/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1106);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1116);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1137)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(1297);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(41);
var core = __webpack_require__(108);
var hide = __webpack_require__(110);
var redefine = __webpack_require__(109);
var ctx = __webpack_require__(137);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * The main AWS namespace
 */
var AWS = { util: __webpack_require__(74) };

/**
 * @api private
 * @!macro [new] nobrowser
 *   @note This feature is not supported in the browser environment of the SDK.
 */
var _hidden = {}; _hidden.toString(); // hack to parse macro

module.exports = AWS;

AWS.util.update(AWS, {

  /**
   * @constant
   */
  VERSION: '2.207.0',

  /**
   * @api private
   */
  Signers: {},

  /**
   * @api private
   */
  Protocol: {
    Json: __webpack_require__(643),
    Query: __webpack_require__(1048),
    Rest: __webpack_require__(439),
    RestJson: __webpack_require__(1050),
    RestXml: __webpack_require__(1051)
  },

  /**
   * @api private
   */
  XML: {
    Builder: __webpack_require__(2660),
    Parser: null // conditionally set based on environment
  },

  /**
   * @api private
   */
  JSON: {
    Builder: __webpack_require__(644),
    Parser: __webpack_require__(645)
  },

  /**
   * @api private
   */
  Model: {
    Api: __webpack_require__(1058),
    Operation: __webpack_require__(1059),
    Shape: __webpack_require__(338),
    Paginator: __webpack_require__(1060),
    ResourceWaiter: __webpack_require__(1061)
  },

  /**
   * @api private
   */
  apiLoader: __webpack_require__(2676)
});

__webpack_require__(2677);
__webpack_require__(2680);

__webpack_require__(1064);
__webpack_require__(1065);
__webpack_require__(2681);
__webpack_require__(2685);
__webpack_require__(2687);
__webpack_require__(2688);
__webpack_require__(2689);
__webpack_require__(2695);

/**
 * @readonly
 * @return [AWS.SequentialExecutor] a collection of global event listeners that
 *   are attached to every sent request.
 * @see AWS.Request AWS.Request for a list of events to listen for
 * @example Logging the time taken to send a request
 *   AWS.events.on('send', function startSend(resp) {
 *     resp.startTime = new Date().getTime();
 *   }).on('complete', function calculateTime(resp) {
 *     var time = (new Date().getTime() - resp.startTime) / 1000;
 *     console.log('Request took ' + time + ' seconds');
 *   });
 *
 *   new AWS.S3().listBuckets(); // prints 'Request took 0.285 seconds'
 */
AWS.events = new AWS.SequentialExecutor();


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Button;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button_css__ = __webpack_require__(1901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Button_css__);
function Button(props){var handleClick=function handleClick(event){event.preventDefault();if(props.onClick!==undefined){props.onClick(event);}};if(props.icon!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn button'+(props.className!==undefined?' '+props.className:''),disabled:props.disabled,onClick:handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:props.icon,alt:'plus'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,props.label));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button'+(props.className!==undefined?' '+props.className:''),disabled:props.disabled,value:props.label,type:'button',onClick:handleClick});}}Button.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};Button.defaultProps={disabled:false,icon:null};

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Accordion__ = __webpack_require__(1150);
/* unused harmony reexport Accordion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Alert__ = __webpack_require__(1170);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Alert__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Badge__ = __webpack_require__(1173);
/* unused harmony reexport Badge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Breadcrumb__ = __webpack_require__(1174);
/* unused harmony reexport Breadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BreadcrumbItem__ = __webpack_require__(697);
/* unused harmony reexport BreadcrumbItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(296);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonGroup__ = __webpack_require__(479);
/* unused harmony reexport ButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonToolbar__ = __webpack_require__(1176);
/* unused harmony reexport ButtonToolbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Carousel__ = __webpack_require__(1177);
/* unused harmony reexport Carousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselItem__ = __webpack_require__(698);
/* unused harmony reexport CarouselItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Checkbox__ = __webpack_require__(1187);
/* unused harmony reexport Checkbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Clearfix__ = __webpack_require__(1188);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_11__Clearfix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CloseButton__ = __webpack_require__(478);
/* unused harmony reexport CloseButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ControlLabel__ = __webpack_require__(1189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__ControlLabel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Col__ = __webpack_require__(1190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_14__Col__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Collapse__ = __webpack_require__(482);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_15__Collapse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Dropdown__ = __webpack_require__(354);
/* unused harmony reexport Dropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DropdownButton__ = __webpack_require__(1208);
/* unused harmony reexport DropdownButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Fade__ = __webpack_require__(357);
/* unused harmony reexport Fade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Form__ = __webpack_require__(1209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_19__Form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__FormControl__ = __webpack_require__(1210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_20__FormControl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FormGroup__ = __webpack_require__(1213);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_21__FormGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Glyphicon__ = __webpack_require__(481);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_22__Glyphicon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Grid__ = __webpack_require__(712);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_23__Grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__HelpBlock__ = __webpack_require__(1214);
/* unused harmony reexport HelpBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Image__ = __webpack_require__(1215);
/* unused harmony reexport Image */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__InputGroup__ = __webpack_require__(1216);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_26__InputGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Jumbotron__ = __webpack_require__(1219);
/* unused harmony reexport Jumbotron */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Label__ = __webpack_require__(1220);
/* unused harmony reexport Label */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ListGroup__ = __webpack_require__(1221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_29__ListGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ListGroupItem__ = __webpack_require__(713);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_30__ListGroupItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Media__ = __webpack_require__(358);
/* unused harmony reexport Media */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__MenuItem__ = __webpack_require__(1228);
/* unused harmony reexport MenuItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Modal__ = __webpack_require__(1229);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_33__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ModalBody__ = __webpack_require__(718);
/* unused harmony reexport ModalBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ModalDialog__ = __webpack_require__(719);
/* unused harmony reexport ModalDialog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ModalFooter__ = __webpack_require__(720);
/* unused harmony reexport ModalFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ModalHeader__ = __webpack_require__(721);
/* unused harmony reexport ModalHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ModalTitle__ = __webpack_require__(722);
/* unused harmony reexport ModalTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Nav__ = __webpack_require__(723);
/* unused harmony reexport Nav */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Navbar__ = __webpack_require__(1245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_40__Navbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__NavbarBrand__ = __webpack_require__(724);
/* unused harmony reexport NavbarBrand */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__NavDropdown__ = __webpack_require__(1249);
/* unused harmony reexport NavDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__NavItem__ = __webpack_require__(725);
/* unused harmony reexport NavItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Overlay__ = __webpack_require__(726);
/* unused harmony reexport Overlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__OverlayTrigger__ = __webpack_require__(1256);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_45__OverlayTrigger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__PageHeader__ = __webpack_require__(1260);
/* unused harmony reexport PageHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__PageItem__ = __webpack_require__(1261);
/* unused harmony reexport PageItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Pager__ = __webpack_require__(1263);
/* unused harmony reexport Pager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Pagination__ = __webpack_require__(1264);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_49__Pagination__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Panel__ = __webpack_require__(1266);
/* unused harmony reexport Panel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__PanelGroup__ = __webpack_require__(692);
/* unused harmony reexport PanelGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Popover__ = __webpack_require__(1272);
/* unused harmony reexport Popover */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ProgressBar__ = __webpack_require__(1273);
/* unused harmony reexport ProgressBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Radio__ = __webpack_require__(1274);
/* unused harmony reexport Radio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__ResponsiveEmbed__ = __webpack_require__(1275);
/* unused harmony reexport ResponsiveEmbed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Row__ = __webpack_require__(1276);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_56__Row__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__SafeAnchor__ = __webpack_require__(138);
/* unused harmony reexport SafeAnchor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__SplitButton__ = __webpack_require__(1277);
/* unused harmony reexport SplitButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Tab__ = __webpack_require__(1279);
/* unused harmony reexport Tab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__TabContainer__ = __webpack_require__(488);
/* unused harmony reexport TabContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__TabContent__ = __webpack_require__(489);
/* unused harmony reexport TabContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Table__ = __webpack_require__(1280);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_62__Table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__TabPane__ = __webpack_require__(733);
/* unused harmony reexport TabPane */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Tabs__ = __webpack_require__(1281);
/* unused harmony reexport Tabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Thumbnail__ = __webpack_require__(1282);
/* unused harmony reexport Thumbnail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__ToggleButton__ = __webpack_require__(734);
/* unused harmony reexport ToggleButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__ToggleButtonGroup__ = __webpack_require__(1283);
/* unused harmony reexport ToggleButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Tooltip__ = __webpack_require__(1284);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_68__Tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Well__ = __webpack_require__(1285);
/* unused harmony reexport Well */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__utils__ = __webpack_require__(1286);
/* unused harmony reexport utils */















































































































































/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_create__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setPrototypeOf_js__ = __webpack_require__(1160);


function _inheritsLoose(subClass, superClass) {
  subClass.prototype = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_create___default()(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_1__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLIENT_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONTRACTOR_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GENERAL_CONTRACTOR_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADMIN_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return usersUtil; });
var _CLIENT_ROLES,_ADMIN_ROLES;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var UsersUtil=function(){function UsersUtil(){_classCallCheck(this,UsersUtil);}_createClass(UsersUtil,[{key:'hasRole',value:function hasRole(user,roleName){console.log(user);return user.roles.filter(function(role){return role.name===roleName;}).length>0;}},{key:'hasType',value:function hasType(user,typeName){return user.accountable_type===typeName;}},{key:'isAdmin',value:function isAdmin(user){return this.hasRole(user,ROLES.SPACKLE_ADMIN)||this.hasRole(user,ROLES.BUSINESS_DEVELOPMENT)||this.hasRole(user,ROLES.FIELD);}},{key:'isSpackleAdmin',value:function isSpackleAdmin(user){return this.hasRole(user,ROLES.SPACKLE_ADMIN);}}]);return UsersUtil;}();var ROLES={OWNER:'owner',SPACKLE_ADMIN:'spackle_admin',BUSINESS_DEVELOPMENT:'business_development',FIELD:'field',CLIENT_BUILDING_MANAGER:'building_manager',CLIENT_WO_CREATOR:'wo_creator',CLIENT_WO_APPROVER:'wo_approver',CLIENT_WO_COMPLETION_APPROVER:'wo_completion_approver',CONTRACTOR_PROJECT_MANAGER:'project_manager',CONTRACTOR_SENIOR_ACCOUNTANT:'senior_accountant',CONTRACTOR_FIELD_PERSONNEL:'field_personnel',CONTRACTOR_TEAM_COORDINATOR:'team_coordinator',CONTRACTOR_FOREMAN:'foreman',GENERAL_CONTRACTOR_CO_FOUNDER:'co_founder',GENERAL_CONTRACTOR_PROJECT_ENGINEER:'project_engineer',GENERAL_CONTRACTOR_PROJECT_MANAGER:'project_manager',GENERAL_CONTRACTOR_SENIOR_PROJECT_MANAGER:'senior_project_manager',GENERAL_CONTRACTOR_SENIOR_PROJECT_ADMIN:'senior_project_administrator',GENERAL_CONTRACTOR_SENIOR_PROJECT_EXECUTIVE:'project_executive',GENERAL_CONTRACTOR_SENIOR_BUSINESS_MANAGER:'business_manager',GENERAL_CONTRACTOR_SUPERINTENDENT:'superintendent',GENERAL_CONTRACTOR_ASSISTANT_SUPERINTENDENT:'assistant_superintendent',GENERAL_CONTRACTOR_SENIOR_SUPERINTENDENT:'senior_superintendent',GENERAL_CONTRACTOR_ASSISTANT_FIELD_OPS_MANAGER:'field_ops_manager',GENERAL_CONTRACTOR_SENIOR_ACCOUNTANT:'senior_accountant',GENERAL_CONTRACTOR_TEAM_COORDINATOR:'team_coordinator'};var TYPES={// resource_types
CLIENT:'Client',CONTRACTOR:'Contractor',GENERAL_CONTRACTOR:'GeneralContractor',ARCHITECT:'Architect',LANDLORD:'Landlord'};var CLIENT_ROLES=(_CLIENT_ROLES={owner:'Administrator'},_defineProperty(_CLIENT_ROLES,ROLES.CLIENT_BUILDING_MANAGER,'Building Manager'),_defineProperty(_CLIENT_ROLES,'wo_approver','May Approve Work Orders'),_defineProperty(_CLIENT_ROLES,'wo_completion_approver','May Approve Completion of Work'),_CLIENT_ROLES);var CONTRACTOR_ROLES={owner:'Administrator',project_manager:'Project Manager',field_personnel:'Field Personnel',senior_accountant:'Senior Accountant',team_coordinator:'Team Coordinator',foreman:'Foreman'};var GENERAL_CONTRACTOR_ROLES={co_founder:'Co-Founder',project_engineer:'Project Engineer',project_manager:'Project Manager',senior_project_manager:'Senior Project Manager',senior_project_administrator:'Senior Project Administrator',project_executive:'Project Executive',business_manager:'Business Manager',superintendent:'Superintendent',assistant_superintendent:'Assistant Superintendent',senior_superintendent:'Senior Superintendent',field_ops_manager:'Field Operations Manager',senior_accountant:'Senior Accountant',team_coordinator:'Team Coordinator',owner:'Administrator',laborer:'Laborer'};var ADMIN_ROLES=(_ADMIN_ROLES={spackle_admin:'Spackle Admin'},_defineProperty(_ADMIN_ROLES,ROLES.BUSINESS_DEVELOPMENT,'Business Development'),_defineProperty(_ADMIN_ROLES,ROLES.FIELD,'Field'),_ADMIN_ROLES);var usersUtil=new UsersUtil();/* unused harmony default export */ var _unused_webpack_default_export = (new UsersUtil());

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign__);

function _extends() {
  _extends = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign___default.a || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCurrentUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isLoggedIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAccessToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAccounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasEnterpriseRedirect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getCurrentUser=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.auth.user;},function(permissions){return permissions;});var isLoggedIn=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.auth.loggedIn;},function(loggedIn){return loggedIn;});var getAccessToken=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.auth.accessToken;},function(accessToken){return accessToken;});var getClient=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.auth.client;},function(client){return client;});var getAccounts=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.auth.accounts;},function(accounts){return accounts;});var hasEnterpriseRedirect=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.auth.enterpriseRedirect;},function(enterpriseRedirect){return enterpriseRedirect;});

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys__);

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};

  var sourceKeys = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys___default()(source);

  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MESSAGES_ERROR_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MESSAGES_ERROR_CLOSE; });
/* harmony export (immutable) */ __webpack_exports__["c"] = closeErrorMessage;
/* harmony export (immutable) */ __webpack_exports__["d"] = showErrorMessage;
var MESSAGES_ERROR_SHOW='MESSAGES_ERROR_SHOW';var MESSAGES_ERROR_CLOSE='MESSAGES_ERROR_CLOSE';function closeErrorMessage(id){return{type:MESSAGES_ERROR_CLOSE,payload:id};}function showErrorMessage(messages){var param=messages;if(typeof messages==='string'){param=[messages];}return{type:MESSAGES_ERROR_SHOW,payload:param};}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = prefix;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bsClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bsStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bsSizes; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getClassSet;
/* harmony export (immutable) */ __webpack_exports__["f"] = splitBsProps;
/* harmony export (immutable) */ __webpack_exports__["g"] = splitBsPropsAndOmit;
/* unused harmony export addStyle */
/* unused harmony export _curry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StyleConfig__ = __webpack_require__(87);


// TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.




function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];

    if (typeof last === 'function') {
      return fn.apply(void 0, args);
    }

    return function (Component) {
      return fn.apply(void 0, args.concat([Component]));
    };
  };
}

function prefix(props, variant) {
  var bsClass = (props.bsClass || '').trim();
  !(bsClass != null) ?  false ? invariant(false, 'A `bsClass` prop is required for this component') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  return bsClass + (variant ? "-" + variant : '');
}
var bsClass = curry(function (defaultClass, Component) {
  var propTypes = Component.propTypes || (Component.propTypes = {});
  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
  propTypes.bsClass = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
  defaultProps.bsClass = defaultClass;
  return Component;
});
var bsStyles = curry(function (styles, defaultStyle, Component) {
  if (typeof defaultStyle !== 'string') {
    Component = defaultStyle;
    defaultStyle = undefined;
  }

  var existing = Component.STYLES || [];
  var propTypes = Component.propTypes || {};
  styles.forEach(function (style) {
    if (existing.indexOf(style) === -1) {
      existing.push(style);
    }
  });
  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(existing); // expose the values on the propType function for documentation

  Component.STYLES = existing;
  propType._values = existing;
  Component.propTypes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, propTypes, {
    bsStyle: propType
  });

  if (defaultStyle !== undefined) {
    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
    defaultProps.bsStyle = defaultStyle;
  }

  return Component;
});
var bsSizes = curry(function (sizes, defaultSize, Component) {
  if (typeof defaultSize !== 'string') {
    Component = defaultSize;
    defaultSize = undefined;
  }

  var existing = Component.SIZES || [];
  var propTypes = Component.propTypes || {};
  sizes.forEach(function (size) {
    if (existing.indexOf(size) === -1) {
      existing.push(size);
    }
  });
  var values = [];
  existing.forEach(function (size) {
    var mappedSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["b" /* SIZE_MAP */][size];

    if (mappedSize && mappedSize !== size) {
      values.push(mappedSize);
    }

    values.push(size);
  });
  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(values);
  propType._values = values; // expose the values on the propType function for documentation

  Component.SIZES = existing;
  Component.propTypes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, propTypes, {
    bsSize: propType
  });

  if (defaultSize !== undefined) {
    if (!Component.defaultProps) {
      Component.defaultProps = {};
    }

    Component.defaultProps.bsSize = defaultSize;
  }

  return Component;
});
function getClassSet(props) {
  var _classes;

  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);

  if (props.bsSize) {
    var bsSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["b" /* SIZE_MAP */][props.bsSize] || props.bsSize;
    classes[prefix(props, bsSize)] = true;
  }

  if (props.bsStyle) {
    classes[prefix(props, props.bsStyle)] = true;
  }

  return classes;
}

function getBsProps(props) {
  return {
    bsClass: props.bsClass,
    bsSize: props.bsSize,
    bsStyle: props.bsStyle,
    bsRole: props.bsRole
  };
}

function isBsProp(propName) {
  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
}

function splitBsProps(props) {
  var elementProps = {};

  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (!isBsProp(propName)) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}
function splitBsPropsAndOmit(props, omittedPropNames) {
  var isOmittedProp = {};
  omittedPropNames.forEach(function (propName) {
    isOmittedProp[propName] = true;
  });
  var elementProps = {};

  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries___default()(props).forEach(function (_ref2) {
    var propName = _ref2[0],
        propValue = _ref2[1];

    if (!isBsProp(propName) && !isOmittedProp[propName]) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}
/**
 * Add a style variant to a Component. Mutates the propTypes of the component
 * in order to validate the new variant.
 */

function addStyle(Component) {
  for (var _len2 = arguments.length, styleVariant = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    styleVariant[_key2 - 1] = arguments[_key2];
  }

  bsStyles(styleVariant, Component);
}
var _curry = curry;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1314);

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_table_BasicTable__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SimpleTable_css__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SimpleTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SimpleTable_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleTable=function(_Component){_inherits(SimpleTable,_Component);function SimpleTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SimpleTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SimpleTable.__proto__||Object.getPrototypeOf(SimpleTable)).call.apply(_ref,[this].concat(args))),_this),_this.buildElement=function(id,element){var onGenerateLink=_this.props.onGenerateLink;if(onGenerateLink){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:onGenerateLink(id)},element);}else{return element;}},_this.handleRowClick=function(id,selectable,event){event.preventDefault();if(selectable){_this.props.onRowSelected(id);}},_this.createRowClassName=function(){var row=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var index=arguments[1];var rows=arguments[2];var className=[];if(_this.props.onRowSelected!==undefined){if(row===null){className.push('selectable');}else if(row.selectable===undefined||row.selectable){className.push('selectable');}}if(index===rows.length-1&&_this.props.showBottomLine){className.push('last-row');}if(_this.props.onGenerateLink){className.push('link-tab');}return className.length===0?null:className.join(' ');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SimpleTable,[{key:'render',value:function render(){var _this2=this;var columnsNumber=0;var _props=this.props,rows=_props.rows,headers=_props.headers;if(headers.length>0){// Get columns from headers
columnsNumber=this.props.headers.length;}else{// If no headers, from row items number
if(rows.length>0){columnsNumber=this.props.rows[0].length;}}var cols=[];if(columnsNumber>0){for(var i=0;i<columnsNumber;i++){cols.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:i+1}));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,!this.props.newView&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["t" /* Table */],{className:'simple-table'+(this.props.className!==undefined?' '+this.props.className:'')},cols.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,cols),this.props.headers.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,this.props.headers.map(function(element,index){if(typeof element==='string'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:index},element);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.props.rows.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'td-empty-table',colSpan:this.props.headers.length},this.props.emptyMessage)):this.props.rows.map(function(row,index,array){if(!Array.isArray(row)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:row.id,className:_this2.createRowClassName(row,index,array),onClick:_this2.handleRowClick.bind(_this2,row.id,_this2.props.onRowSelected!==undefined&&(row.selectable===undefined||row.selectable))},row.data.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:row.className!==undefined?row.className:null,key:index},_this2.buildElement(row.id,element));}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index,className:_this2.createRowClassName(null,index,array),onClick:_this2.handleRowClick.bind(_this2,index,_this2.props.onRowSelected!==undefined)},row.map(function(element,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:i},_this2.buildElement(index,element));}));}}))),this.props.newView&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_table_BasicTable__["a" /* default */],{rowsData:rows,headersData:headers,isSelectable:this.props.onRowSelected!==undefined,handleRowClick:this.handleRowClick.bind(this)}));}}]);return SimpleTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SimpleTable.propTypes={className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,headers:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object])),rows:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any),// simple array with "anything" for each column
__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]).isRequired,// the "id" of the row, will be returned when clicking
className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,// Class to add to each cell for the current row
selectable:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,// if this particular row can be selected (only works if onRowSelected function is passed), default to true
data:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any).isRequired})])),emptyMessage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,showBottomLine:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onRowSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onGenerateLink:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};SimpleTable.defaultProps={headers:[],rows:[],emptyMessage:'No items',showBottomLine:false,newView:false};/* harmony default export */ __webpack_exports__["a"] = (SimpleTable);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var BaseApi=function BaseApi(){_classCallCheck(this,BaseApi);this.baseUrl="https://spackle-v1.fly.dev/";};/* harmony default export */ __webpack_exports__["a"] = (BaseApi);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var util = __webpack_require__(74);

// browser specific modules
util.crypto.lib = __webpack_require__(2700);
util.Buffer = __webpack_require__(339).Buffer;
util.url = __webpack_require__(2708);
util.querystring = __webpack_require__(1070);
util.environment = 'js';

var AWS = __webpack_require__(5);
module.exports = AWS;

__webpack_require__(1062);
__webpack_require__(1063);
__webpack_require__(2713);
__webpack_require__(2717);
__webpack_require__(2718);
__webpack_require__(2722);

// Load the DOMParser XML parser
AWS.XML.Parser = __webpack_require__(2723);

// Load the XHR HttpClient
__webpack_require__(2724);

if (typeof process === 'undefined') {
  process = {
    browser: true
  };
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(254)))

/***/ }),
/* 21 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return WORK_ORDERS_CURRENT_WO_ATTRIBUTE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_170", function() { return WORK_ORDERS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_185", function() { return WORK_ORDERS_WO_SELECT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_184", function() { return WORK_ORDERS_WO_LOAD_TASKS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_181", function() { return WORK_ORDERS_WORK_ORDER_CREATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_182", function() { return WORK_ORDERS_WO_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_171", function() { return WORK_ORDERS_LOAD_TRADES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_169", function() { return WORK_ORDERS_LOAD_SUB_TRADES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_168", function() { return WORK_ORDERS_LOAD_CONTRACTORS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WORK_ORDERS_CONTRACTOR_NEW_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_183", function() { return WORK_ORDERS_WO_ATTRIBUTE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_186", function() { return WORK_ORDERS_WO_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_180", function() { return WORK_ORDERS_UNION_TRADES_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_173", function() { return WORK_ORDERS_SEARCH_TEXT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_174", function() { return WORK_ORDERS_SUMMARY_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_175", function() { return WORK_ORDERS_SUMMARY_TASK_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_176", function() { return WORK_ORDERS_TASK_CHECKLIST_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_177", function() { return WORK_ORDERS_TASK_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_179", function() { return WORK_ORDERS_TASK_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_178", function() { return WORK_ORDERS_TASK_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_172", function() { return WORK_ORDERS_PAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_167", function() { return WORK_ORDERS_INVOICES_TAB_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return WORK_ORDERS_CURRENT_WO_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return WORK_ORDERS_CREATION_CLIENTS_CLIENT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return WORK_ORDERS_CREATION_CLIENTS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return WORK_ORDERS_CREATION_WO_CANCELLATION_MODAL_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return WORK_ORDERS_CREATION_WO_CANCELLATION_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return WORK_ORDERS_CREATION_WO_NEW_PROCESS_STARTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return WORK_ORDERS_CREATION_LOAD_BUILDINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return WORK_ORDERS_CREATION_SELECT_BUILDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return WORK_ORDERS_CREATION_NEW_BUILDING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return WORK_ORDERS_CREATION_NEW_BUILDING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return WORK_ORDERS_CREATION_NEW_BUILDING_CHANGE_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return WORK_ORDERS_CREATION_NEW_BUILDING_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return WORK_ORDERS_CREATION_BUILDING_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return WORK_ORDERS_CREATION_BUILDING_LOCATION_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return WORK_ORDERS_CREATION_BUILDING_DOCUMENTS_UPLOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WORK_ORDERS_CREATION_BUILDING_DOCUMENTS_REMOVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return WORK_ORDERS_CREATION_TASKS_STATE_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return WORK_ORDERS_CREATION_TASKS_TASK_SAVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return WORK_ORDERS_CREATION_TASKS_TASK_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return WORK_ORDERS_CREATION_TASKS_TASK_CHANGE_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return WORK_ORDERS_CREATION_TASKS_TASK_ADD_EMPTY_NEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_NEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return WORK_ORDERS_CREATION_TASKS_TASK_IMAGE_REMOVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return WORK_ORDERS_CREATION_SUB_CONTRACTORS_STATE_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return WORK_ORDERS_CREATION_SUB_CONTRACTORS_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return WORK_ORDERS_CREATION_SUB_CONTRACTORS_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return WORK_ORDERS_CREATION_SUB_CONTRACTORS_QUESTION_ANSWERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return WORK_ORDERS_CREATION_SUB_CONTRACTORS_VALID_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return WORK_ORDERS_CREATION_SUB_CONTRACTORS_INVALID_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return WORK_ORDERS_CREATION_SUB_CONTRACTORS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_VALUE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_VALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_INVALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return WORK_ORDERS_CREATION_SUB_CONTRACTORS_CURRENT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return WORK_ORDERS_CREATION_UNION_TRADES_VALID_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return WORK_ORDERS_CREATION_UNION_TRADES_INVALID_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return WORK_ORDERS_CREATION_WORKING_HOURS_VALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return WORK_ORDERS_CREATION_WORKING_HOURS_INVALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return WORK_ORDERS_CREATION_WORKING_HOURS_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return WORK_ORDERS_CREATION_WORKING_HOURS_OTHER_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return WORK_ORDERS_CREATION_WORKING_HOURS_CURRENT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return WORK_ORDERS_CREATION_UNION_TRADES_CURRENT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return WORK_ORDERS_CREATION_UNION_TRADES_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return WORK_ORDERS_CREATION_SUMMARY_CONFIRMATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return WORK_ORDERS_CREATION_SUMMARY_CONFIRMATION_WITHOUT_PICS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return WORK_ORDERS_CREATION_SUMMARY_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return WORK_ORDERS_DETAILS_ADD_MEMBER_FORM_INVALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return WORK_ORDERS_DETAILS_ADD_MEMBER_FORM_VALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return WORK_ORDERS_DETAILS_ADD_MEMBER_FORM_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return WORK_ORDERS_DETAILS_ADD_MEMBER_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return WORK_ORDERS_DETAILS_ADD_MEMBER_USERS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_INVALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_VALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_MEMBERS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return WORK_ORDERS_DETAILS_BUDGET_BACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return WORK_ORDERS_DETAILS_BUDGET_CURRENT_VIEW_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return WORK_ORDERS_DETAILS_BUDGET_EMAIL_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return WORK_ORDERS_DETAILS_BUDGET_EMAIL_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return WORK_ORDERS_DETAILS_BUDGET_EMAIL_MODAL_SHOW_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return WORK_ORDERS_DETAILS_BUDGET_EMAIL_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return WORK_ORDERS_DETAILS_BUDGET_MESSAGE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_APPROVAL_CONFIRMATION_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_APPROVE_REVIEW_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return WORK_ORDERS_DETAILS_BUDGET_PDF_VIEWER_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return WORK_ORDERS_DETAILS_BUDGET_PRINT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return WORK_ORDERS_DETAILS_BUDGET_NEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return WORK_ORDERS_DETAILS_BUDGET_SUBJECT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return WORK_ORDERS_DETAILS_BUDGET_TASK_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return WORK_ORDERS_DETAILS_BUDGET_USERS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return WORK_ORDERS_DETAILS_BUDGET_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return WORK_ORDERS_DETAILS_BUDGET_VALUES_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return WORK_ORDERS_DETAILS_BUDGET_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return WORK_ORDERS_DETAILS_CONTRACTOR_INVOICE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return WORK_ORDERS_DETAILS_CONTRACTOR_LIEN_RELEASE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return WORK_ORDERS_DETAILS_CONTRACTOR_LIEN_RELEASES_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return WORK_ORDERS_DETAILS_CONTRACTOR_LIEN_RELEASE_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return WORK_ORDERS_DETAILS_CLIENT_STREAM_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return WORK_ORDERS_DETAILS_TASK_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return WORK_ORDERS_DETAILS_TASK_CHANGE_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return WORK_ORDERS_DETAILS_TASK_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return WORK_ORDERS_DETAILS_TASK_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return WORK_ORDERS_DETAILS_TASK_IMAGE_REMOVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_153", function() { return WORK_ORDERS_DETAILS_TASK_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return WORK_ORDERS_DETAILS_STATE_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return WORK_ORDERS_DETAILS_NAV_BAR_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return WORK_ORDERS_DETAILS_NOTE_ADD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return WORK_ORDERS_DETAILS_NOTES_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_150", function() { return WORK_ORDERS_DETAILS_TASK_NOTE_ADD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return WORK_ORDERS_DETAILS_TASK_NOTES_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return WORK_ORDERS_DETAILS_MEMBERS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return WORK_ORDERS_DETAILS_MEMBERS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return WORK_ORDERS_DETAILS_MEMBERS_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return WORK_ORDERS_DETAILS_DOCUMENTS_UPLOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return WORK_ORDERS_DETAILS_DOCUMENT_REMOVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return WORK_ORDERS_DETAILS_OPEN_ITEM_EDIT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return WORK_ORDERS_DETAILS_EDIT_OPEN_ITEM_FORM_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return WORK_ORDERS_DETAILS_OPEN_ITEM_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return WORK_ORDERS_DETAILS_OPEN_ITEMS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return WORK_ORDERS_DETAILS_OPEN_ITEMS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return WORK_ORDERS_DETAILS_OPEN_ITEMS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return WORK_ORDERS_DETAILS_PRE_EXISTING_CONDITIONS_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return WORK_ORDERS_DETAILS_PRE_EXISTING_CONDITIONS_DESCRIPTION_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return WORK_ORDERS_DETAILS_PRE_EXISTING_CONDITIONS_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return WORK_ORDERS_DETAILS_CHANGE_ORDER_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return WORK_ORDERS_DETAILS_MOVED_TO_ACR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return WORK_ORDERS_DETAILS_PROPOSAL_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return WORK_ORDERS_DETAILS_PROPOSAL_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return WORK_ORDERS_DETAILS_PROPOSALS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return WORK_ORDERS_DETAILS_QUOTE_DETAIL_MODAL_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return WORK_ORDERS_DETAILS_QUOTES_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return WORK_ORDERS_DETAILS_QUOTES_REQUEST_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return WORK_ORDERS_DETAILS_QUOTES_REQUEST_MODAL_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return WORK_ORDERS_DETAILS_QUOTES_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return WORK_ORDERS_DETAILS_QUOTES_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return WORK_ORDERS_DETAILS_QUOTES_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return WORK_ORDERS_DETAILS_QUOTES_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return WORK_ORDERS_DETAILS_QUOTES_TABLE_FILTER_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return WORK_ORDERS_DETAILS_QUOTES_TABLE_RADIO_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return WORK_ORDERS_DETAILS_QUOTES_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return WORK_ORDERS_DETAILS_QUOTES_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_154", function() { return WORK_ORDERS_DETAILS_UNREAD_NOTES_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return WORK_ORDERS_DETAILS_SET_CURRENT_WORK_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_157", function() { return WORK_ORDERS_DETAILS_WORK_ORDER_JOB_NUMBER_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_158", function() { return WORK_ORDERS_DETAILS_WORK_ORDER_JOB_NUMBER_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_159", function() { return WORK_ORDERS_DETAILS_WORK_ORDER_JOB_NUMBER_SAVING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_160", function() { return WORK_ORDERS_DETAILS_WORK_ORDER_NAME_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_161", function() { return WORK_ORDERS_DETAILS_WORK_ORDER_NAME_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_162", function() { return WORK_ORDERS_DETAILS_WORK_ORDER_NAME_SAVING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_163", function() { return WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_165", function() { return WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_REMINDER_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_164", function() { return WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_166", function() { return WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_SAVING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return WORK_ORDERS_DETAILS_NEW_TASK_ATTRIBUTE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return WORK_ORDERS_DETAILS_NEW_TASK_FORM_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return WORK_ORDERS_DETAILS_NEW_TASK_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return WORK_ORDERS_DETAILS_NEW_TASK_IMAGE_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return WORK_ORDERS_DETAILS_QUOTES_REQUEST_BID_DUE_DATE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return WORK_ORDERS_DETAILS_QUOTES_REQUEST_PREVIEW_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return WORK_ORDERS_DETAILS_QUOTES_REQUEST_PREVIEW_GO_BACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return WORK_ORDERS_DETAILS_QUOTES_REQUEST_SUBMIT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_INVALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_VALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return WORK_ORDERS_DETAILS_CREATE_QUOTE_STATE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return WORK_ORDERS_DETAILS_CREATE_QUOTE_VALIDATION_MESSAGE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return WORK_ORDERS_DETAILS_REVIEW_QUOTE_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return WORK_ORDERS_DETAILS_CREATE_QUOTES_FORM_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return WORK_ORDERS_DETAILS_CREATE_QUOTES_MODAL_SHOW_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return WORK_ORDERS_DETAILS_CREATE_QUOTES_STATE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return WORK_ORDERS_DETAILS_DENY_QUOTE_MODAL_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return WORK_ORDERS_DETAILS_DENY_QUOTE_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return WORK_ORDERS_DETAILS_DENY_QUOTE_REASON_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return WORK_ORDERS_DETAILS_DENY_QUOTE_QUESTION_ANSWERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return WORK_ORDERS_DETAILS_DECLINE_PROPOSAL_MODAL_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return WORK_ORDERS_DETAILS_DECLINE_PROPOSAL_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return WORK_ORDERS_DETAILS_PROPOSAL_BACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return WORK_ORDERS_DETAILS_PROPOSAL_COMPLETION_DATE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return WORK_ORDERS_DETAILS_PROPOSAL_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_MODAL_SHOW_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return WORK_ORDERS_DETAILS_PROPOSAL_MARKUP_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return WORK_ORDERS_DETAILS_PROPOSAL_MESSAGE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return WORK_ORDERS_DETAILS_PROPOSAL_MODAL_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return WORK_ORDERS_DETAILS_PROPOSAL_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return WORK_ORDERS_DETAILS_PROPOSAL_MODAL_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return WORK_ORDERS_DETAILS_PROPOSAL_NEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return WORK_ORDERS_DETAILS_PROPOSAL_PDF_VIEWER_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return WORK_ORDERS_DETAILS_PROPOSAL_PRINT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return WORK_ORDERS_DETAILS_PROPOSAL_START_DATE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return WORK_ORDERS_DETAILS_PROPOSAL_SUBJECT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return WORK_ORDERS_DETAILS_PROPOSAL_USERS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return WORK_ORDERS_DETAILS_PROPOSAL_DEPOSIT_SELECTED_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return WORK_ORDERS_DETAILS_PROPOSAL_DEPOSIT_COST_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return WORK_ORDERS_DETAILS_PROPOSAL_ADD_BREAKDOWNITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return WORK_ORDERS_DETAILS_PROPOSAL_REMOVE_BREAKDOWNITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return WORK_ORDERS_DETAILS_PROPOSAL_UPDATE_BREAKDOWNITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return WORK_ORDERS_DETAILS_PROPOSAL_APPROVAL_MODAL_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return WORK_ORDERS_DETAILS_PROPOSAL_APPROVAL_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return WORK_ORDERS_DETAILS_PROPOSAL_SUCCESS_MODAL_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return WORK_ORDERS_DETAILS_PROPOSAL_SUCCESS_MODAL_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return WORK_ORDERS_DETAILS_PROPOSAL_QUOTE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return WORK_ORDERS_DETAILS_PURCHASE_ORDER_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return WORK_ORDERS_DETAILS_PURCHASE_ORDER_DOCUMENT_FILE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return WORK_ORDERS_DETAILS_PURCHASE_ORDER_DOCUMENT_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return WORK_ORDERS_DETAILS_PURCHASE_ORDER_EDIT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return WORK_ORDERS_DETAILS_PURCHASE_ORDER_NUMBER_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return WORK_ORDERS_DETAILS_PURCHASE_ORDER_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return WORK_ORDERS_DETAILS_QUALIFICATIONS_ADD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return WORK_ORDERS_DETAILS_QUALIFICATIONS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return WORK_ORDERS_DETAILS_QUALIFICATIONS_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return WORK_ORDERS_DETAILS_QUALIFICATIONS_OPTION_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED_BY_ID_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return WORK_ORDERS_DETAILS_QUALIFICATIONS_TRADES_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_152", function() { return WORK_ORDERS_DETAILS_TASK_SELECT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_151", function() { return WORK_ORDERS_DETAILS_TASK_SELECT_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return WORK_ORDERS_DETAILS_SHOW_WOA_SIGNING_MODAL_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_156", function() { return WORK_ORDERS_DETAILS_WOA_SIGNING_URL_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_155", function() { return WORK_ORDERS_DETAILS_WOAS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WORK_ORDERS_ADD_BUILDING_TO_BEGINNING; });
var WORK_ORDERS_CURRENT_WO_ATTRIBUTE_UPDATE='WORK_ORDERS_CURRENT_WO_ATTRIBUTE_UPDATE';var WORK_ORDERS_LOAD_SUCCESS='WORK_ORDERS_LOAD_SUCCESS';var WORK_ORDERS_WO_SELECT_SUCCESS='WORK_ORDERS_WO_SELECT_SUCCESS';var WORK_ORDERS_WO_LOAD_TASKS_SUCCESS='WORK_ORDERS_WO_LOAD_TASKS_SUCCESS';var WORK_ORDERS_WORK_ORDER_CREATION_SUCCESS='WORK_ORDERS_WORK_ORDER_CREATION_SUCCESS';var WORK_ORDERS_WO_ADD='WORK_ORDERS_WO_ADD';var WORK_ORDERS_LOAD_TRADES_SUCCESS='WORK_ORDERS_LOAD_TRADES_SUCCESS';var WORK_ORDERS_LOAD_SUB_TRADES_SUCCESS='WORK_ORDERS_LOAD_SUB_TRADES_SUCCESS';var WORK_ORDERS_LOAD_CONTRACTORS_SUCCESS='WORK_ORDERS_LOAD_CONTRACTORS_SUCCESS';var WORK_ORDERS_CONTRACTOR_NEW_SUCCESS='WORK_ORDERS_CONTRACTOR_NEW_SUCCESS';var WORK_ORDERS_WO_ATTRIBUTE_UPDATE='WORK_ORDERS_WO_ATTRIBUTE_UPDATE';var WORK_ORDERS_WO_UPDATE='WORK_ORDERS_WO_UPDATE';var WORK_ORDERS_UNION_TRADES_LOAD_SUCCESS='WORK_ORDERS_UNION_TRADES_LOAD_SUCCESS';var WORK_ORDERS_SEARCH_TEXT_CHANGE='WORK_ORDERS_SEARCH_TEXT_CHANGE';var WORK_ORDERS_SUMMARY_LOAD_SUCCESS='WORK_ORDERS_SUMMARY_LOAD_SUCCESS';var WORK_ORDERS_SUMMARY_TASK_REMOVE='WORK_ORDERS_SUMMARY_TASK_REMOVE';var WORK_ORDERS_TASK_CHECKLIST_UPDATE='WORK_ORDERS_TASK_CHECKLIST_UPDATE';var WORK_ORDERS_TASK_REMOVE='WORK_ORDERS_TASK_REMOVE';var WORK_ORDERS_TASK_UPDATE_SUCCESS='WORK_ORDERS_TASK_UPDATE_SUCCESS';var WORK_ORDERS_TASK_UPDATE='WORK_ORDERS_TASK_UPDATE';var WORK_ORDERS_PAGE_CHANGE='WORK_ORDERS_PAGE_CHANGE';var WORK_ORDERS_INVOICES_TAB_CHANGE='WORK_ORDERS_INVOICES_TAB_CHANGE';var WORK_ORDERS_CURRENT_WO_COMPLETE='WORK_ORDERS_CURRENT_WO_COMPLETE';var WORK_ORDERS_CREATION_CLIENTS_CLIENT_SET='WORK_ORDERS_CREATION_CLIENTS_CLIENT_SET';var WORK_ORDERS_CREATION_CLIENTS_LOAD_SUCCESS='WORK_ORDERS_CREATION_CLIENTS_LOAD_SUCCESS';var WORK_ORDERS_CREATION_WO_CANCELLATION_MODAL_CLOSE='WORK_ORDERS_CREATION_WO_CANCELLATION_MODAL_CLOSE';var WORK_ORDERS_CREATION_WO_CANCELLATION_MODAL_SHOW='WORK_ORDERS_CREATION_WO_CANCELLATION_MODAL_SHOW';var WORK_ORDERS_CREATION_WO_NEW_PROCESS_STARTED='WORK_ORDERS_CREATION_WO_NEW_PROCESS_STARTED';var WORK_ORDERS_CREATION_LOAD_BUILDINGS_SUCCESS='WORK_ORDERS_CREATION_LOAD_BUILDINGS_SUCCESS';var WORK_ORDERS_CREATION_SELECT_BUILDING='WORK_ORDERS_CREATION_SELECT_BUILDING';var WORK_ORDERS_CREATION_NEW_BUILDING_REQUEST='WORK_ORDERS_CREATION_NEW_BUILDING_REQUEST';var WORK_ORDERS_CREATION_NEW_BUILDING_SUCCESS='WORK_ORDERS_CREATION_NEW_BUILDING_SUCCESS';var WORK_ORDERS_CREATION_NEW_BUILDING_CHANGE_VALUE='WORK_ORDERS_CREATION_NEW_BUILDING_CHANGE_VALUE';var WORK_ORDERS_CREATION_NEW_BUILDING_EDIT='WORK_ORDERS_CREATION_NEW_BUILDING_EDIT';var WORK_ORDERS_CREATION_BUILDING_UPDATE_SUCCESS='WORK_ORDERS_CREATION_BUILDING_UPDATE_SUCCESS';var WORK_ORDERS_CREATION_BUILDING_LOCATION_UPDATE_SUCCESS='WORK_ORDERS_CREATION_BUILDING_LOCATION_UPDATE_SUCCESS';var WORK_ORDERS_CREATION_BUILDING_DOCUMENTS_UPLOAD_SUCCESS='WORK_ORDERS_CREATION_BUILDING_DOCUMENTS_UPLOAD_SUCCESS';var WORK_ORDERS_CREATION_BUILDING_DOCUMENTS_REMOVE_SUCCESS='WORK_ORDERS_CREATION_BUILDING_DOCUMENTS_REMOVE_SUCCESS';var WORK_ORDERS_CREATION_TASKS_STATE_INIT='WORK_ORDERS_CREATION_TASKS_STATE_INIT';var WORK_ORDERS_CREATION_TASKS_TASK_SAVE_SUCCESS='WORK_ORDERS_CREATION_TASKS_TASK_SAVE_SUCCESS';var WORK_ORDERS_CREATION_TASKS_TASK_EDIT='WORK_ORDERS_CREATION_TASKS_TASK_EDIT';var WORK_ORDERS_CREATION_TASKS_TASK_CHANGE_VALUE='WORK_ORDERS_CREATION_TASKS_TASK_CHANGE_VALUE';var WORK_ORDERS_CREATION_TASKS_TASK_ADD_EMPTY_NEW='WORK_ORDERS_CREATION_TASKS_TASK_ADD_EMPTY_NEW';var WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_NEW='WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_NEW';var WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_SUCCESS='WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_SUCCESS';var WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_SHOW='WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_SHOW';var WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_HIDE='WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_HIDE';var WORK_ORDERS_CREATION_TASKS_TASK_IMAGE_REMOVE_SUCCESS='WORK_ORDERS_CREATION_TASKS_TASK_IMAGE_REMOVE_SUCCESS';var WORK_ORDERS_CREATION_SUB_CONTRACTORS_STATE_INIT='WORK_ORDERS_CREATION_SUB_CONTRACTORS_STATE_INIT';var WORK_ORDERS_CREATION_SUB_CONTRACTORS_SELECT='WORK_ORDERS_CREATION_SUB_CONTRACTORS_SELECT';var WORK_ORDERS_CREATION_SUB_CONTRACTORS_REMOVE='WORK_ORDERS_CREATION_SUB_CONTRACTORS_REMOVE';var WORK_ORDERS_CREATION_SUB_CONTRACTORS_QUESTION_ANSWERED='WORK_ORDERS_CREATION_SUB_CONTRACTORS_QUESTION_ANSWERED';var WORK_ORDERS_CREATION_SUB_CONTRACTORS_VALID_CONFIRMATION='WORK_ORDERS_CREATION_SUB_CONTRACTORS_VALID_CONFIRMATION';var WORK_ORDERS_CREATION_SUB_CONTRACTORS_INVALID_CONFIRMATION='WORK_ORDERS_CREATION_SUB_CONTRACTORS_INVALID_CONFIRMATION';var WORK_ORDERS_CREATION_SUB_CONTRACTORS_ADD='WORK_ORDERS_CREATION_SUB_CONTRACTORS_ADD';var WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_VALUE_CHANGE='WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_VALUE_CHANGE';var WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_CANCEL='WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_CANCEL';var WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_VALID='WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_VALID';var WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_INVALID='WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_INVALID';var WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_SUCCESS='WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_SUCCESS';var WORK_ORDERS_CREATION_SUB_CONTRACTORS_CURRENT_SET='WORK_ORDERS_CREATION_SUB_CONTRACTORS_CURRENT_SET';var WORK_ORDERS_CREATION_UNION_TRADES_VALID_CONFIRMATION='WORK_ORDERS_CREATION_UNION_TRADES_VALID_CONFIRMATION';var WORK_ORDERS_CREATION_UNION_TRADES_INVALID_CONFIRMATION='WORK_ORDERS_CREATION_UNION_TRADES_INVALID_CONFIRMATION';var WORK_ORDERS_CREATION_WORKING_HOURS_VALID='WORK_ORDERS_CREATION_WORKING_HOURS_VALID';var WORK_ORDERS_CREATION_WORKING_HOURS_INVALID='WORK_ORDERS_CREATION_WORKING_HOURS_INVALID';var WORK_ORDERS_CREATION_WORKING_HOURS_SELECT='WORK_ORDERS_CREATION_WORKING_HOURS_SELECT';var WORK_ORDERS_CREATION_WORKING_HOURS_OTHER_CHANGE='WORK_ORDERS_CREATION_WORKING_HOURS_OTHER_CHANGE';var WORK_ORDERS_CREATION_WORKING_HOURS_CURRENT_SET='WORK_ORDERS_CREATION_WORKING_HOURS_CURRENT_SET';var WORK_ORDERS_CREATION_UNION_TRADES_CURRENT_SET='WORK_ORDERS_CREATION_UNION_TRADES_CURRENT_SET';var WORK_ORDERS_CREATION_UNION_TRADES_SELECT='WORK_ORDERS_CREATION_UNION_TRADES_SELECT';var WORK_ORDERS_CREATION_SUMMARY_CONFIRMATION_SUCCESS='WORK_ORDERS_CREATION_SUMMARY_CONFIRMATION_SUCCESS';var WORK_ORDERS_CREATION_SUMMARY_CONFIRMATION_WITHOUT_PICS_SUCCESS='WORK_ORDERS_CREATION_SUMMARY_CONFIRMATION_WITHOUT_PICS_SUCCESS';var WORK_ORDERS_CREATION_SUMMARY_START='WORK_ORDERS_CREATION_SUMMARY_START';var WORK_ORDERS_DETAILS_ADD_MEMBER_FORM_INVALID='WORK_ORDERS_DETAILS_ADD_MEMBER_FORM_INVALID';var WORK_ORDERS_DETAILS_ADD_MEMBER_FORM_VALID='WORK_ORDERS_DETAILS_ADD_MEMBER_FORM_VALID';var WORK_ORDERS_DETAILS_ADD_MEMBER_FORM_VALUE_UPDATE='WORK_ORDERS_DETAILS_ADD_MEMBER_FORM_VALUE_UPDATE';var WORK_ORDERS_DETAILS_ADD_MEMBER_MODAL_SHOW='WORK_ORDERS_DETAILS_ADD_MEMBER_MODAL_SHOW';var WORK_ORDERS_DETAILS_ADD_MEMBER_USERS_LOAD_SUCCESS='WORK_ORDERS_DETAILS_ADD_MEMBER_USERS_LOAD_SUCCESS';var WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_INVALID='WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_INVALID';var WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_VALID='WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_VALID';var WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_VALUE_UPDATE='WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_VALUE_UPDATE';var WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_MEMBERS_LOAD_SUCCESS='WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_MEMBERS_LOAD_SUCCESS';var WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_MODAL_SHOW='WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_MODAL_SHOW';var WORK_ORDERS_DETAILS_BUDGET_BACK='WORK_ORDERS_DETAILS_BUDGET_BACK';var WORK_ORDERS_DETAILS_BUDGET_CURRENT_VIEW_SET='WORK_ORDERS_DETAILS_BUDGET_CURRENT_VIEW_SET';var WORK_ORDERS_DETAILS_BUDGET_EMAIL_ADD='WORK_ORDERS_DETAILS_BUDGET_EMAIL_ADD';var WORK_ORDERS_DETAILS_BUDGET_EMAIL_CLEAR='WORK_ORDERS_DETAILS_BUDGET_EMAIL_CLEAR';var WORK_ORDERS_DETAILS_BUDGET_EMAIL_MODAL_SHOW_SET='WORK_ORDERS_DETAILS_BUDGET_EMAIL_MODAL_SHOW_SET';var WORK_ORDERS_DETAILS_BUDGET_EMAIL_REMOVE='WORK_ORDERS_DETAILS_BUDGET_EMAIL_REMOVE';var WORK_ORDERS_DETAILS_BUDGET_MESSAGE_SET='WORK_ORDERS_DETAILS_BUDGET_MESSAGE_SET';var WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_APPROVAL_CONFIRMATION_SET='WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_APPROVAL_CONFIRMATION_SET';var WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_APPROVE_REVIEW_SET='WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_APPROVE_REVIEW_SET';var WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_SET='WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_SET';var WORK_ORDERS_DETAILS_BUDGET_PDF_VIEWER_CLOSE='WORK_ORDERS_DETAILS_BUDGET_PDF_VIEWER_CLOSE';var WORK_ORDERS_DETAILS_BUDGET_PRINT_SUCCESS='WORK_ORDERS_DETAILS_BUDGET_PRINT_SUCCESS';var WORK_ORDERS_DETAILS_BUDGET_NEXT='WORK_ORDERS_DETAILS_BUDGET_NEXT';var WORK_ORDERS_DETAILS_BUDGET_SUBJECT_SET='WORK_ORDERS_DETAILS_BUDGET_SUBJECT_SET';var WORK_ORDERS_DETAILS_BUDGET_TASK_CHECK='WORK_ORDERS_DETAILS_BUDGET_TASK_CHECK';var WORK_ORDERS_DETAILS_BUDGET_USERS_LOAD_SUCCESS='WORK_ORDERS_DETAILS_BUDGET_USERS_LOAD_SUCCESS';var WORK_ORDERS_DETAILS_BUDGET_VALUE_UPDATE='WORK_ORDERS_DETAILS_BUDGET_VALUE_UPDATE';var WORK_ORDERS_DETAILS_BUDGET_VALUES_INIT='WORK_ORDERS_DETAILS_BUDGET_VALUES_INIT';var WORK_ORDERS_DETAILS_BUDGET_SET='WORK_ORDERS_DETAILS_BUDGET_SET';var WORK_ORDERS_DETAILS_CONTRACTOR_INVOICE_SET='WORK_ORDERS_DETAILS_CONTRACTOR_INVOICE_SET';var WORK_ORDERS_DETAILS_CONTRACTOR_LIEN_RELEASE_SET='WORK_ORDERS_DETAILS_CONTRACTOR_LIEN_RELEASE_SET';var WORK_ORDERS_DETAILS_CONTRACTOR_LIEN_RELEASES_SET='WORK_ORDERS_DETAILS_CONTRACTOR_LIEN_RELEASES_SET';var WORK_ORDERS_DETAILS_CONTRACTOR_LIEN_RELEASE_REMOVE='WORK_ORDERS_DETAILS_CONTRACTOR_LIEN_RELEASE_REMOVE';var WORK_ORDERS_DETAILS_CLIENT_STREAM_MODAL_SHOW='WORK_ORDERS_DETAILS_CLIENT_STREAM_MODAL_SHOW';var WORK_ORDERS_DETAILS_TASK_LOAD_SUCCESS='WORK_ORDERS_DETAILS_TASK_LOAD_SUCCESS';var WORK_ORDERS_DETAILS_TASK_CHANGE_VALUE='WORK_ORDERS_DETAILS_TASK_CHANGE_VALUE';var WORK_ORDERS_DETAILS_TASK_EDIT='WORK_ORDERS_DETAILS_TASK_EDIT';var WORK_ORDERS_DETAILS_TASK_CANCEL='WORK_ORDERS_DETAILS_TASK_CANCEL';var WORK_ORDERS_DETAILS_TASK_IMAGE_REMOVE_SUCCESS='WORK_ORDERS_DETAILS_TASK_IMAGE_REMOVE_SUCCESS';var WORK_ORDERS_DETAILS_TASK_UPDATE='WORK_ORDERS_DETAILS_TASK_UPDATE';var WORK_ORDERS_DETAILS_STATE_INIT='WORK_ORDERS_DETAILS_STATE_INIT';var WORK_ORDERS_DETAILS_NAV_BAR_SELECTION='WORK_ORDERS_DETAILS_NAV_BAR_SELECTION';var WORK_ORDERS_DETAILS_NOTE_ADD_SUCCESS='WORK_ORDERS_DETAILS_NOTE_ADD_SUCCESS';var WORK_ORDERS_DETAILS_NOTES_LOAD_SUCCESS='WORK_ORDERS_DETAILS_NOTES_LOAD_SUCCESS';var WORK_ORDERS_DETAILS_TASK_NOTE_ADD_SUCCESS='WORK_ORDERS_DETAILS_TASK_NOTE_ADD_SUCCESS';var WORK_ORDERS_DETAILS_TASK_NOTES_LOAD_SUCCESS='WORK_ORDERS_DETAILS_TASK_NOTES_LOAD_SUCCESS';var WORK_ORDERS_DETAILS_MEMBERS_ADD='WORK_ORDERS_DETAILS_MEMBERS_ADD';var WORK_ORDERS_DETAILS_MEMBERS_LOAD_SUCCESS='WORK_ORDERS_DETAILS_MEMBERS_LOAD_SUCCESS';var WORK_ORDERS_DETAILS_MEMBERS_REMOVE='WORK_ORDERS_DETAILS_MEMBERS_REMOVE';var WORK_ORDERS_DETAILS_DOCUMENTS_UPLOAD_SUCCESS='WORK_ORDERS_DETAILS_DOCUMENTS_UPLOAD_SUCCESS';var WORK_ORDERS_DETAILS_DOCUMENT_REMOVE_SUCCESS='WORK_ORDERS_DETAILS_DOCUMENT_REMOVE_SUCCESS';var WORK_ORDERS_DETAILS_OPEN_ITEM_EDIT_SET='WORK_ORDERS_DETAILS_OPEN_ITEM_EDIT_SET';var WORK_ORDERS_DETAILS_EDIT_OPEN_ITEM_FORM_VALUE_UPDATE='WORK_ORDERS_DETAILS_EDIT_OPEN_ITEM_FORM_VALUE_UPDATE';var WORK_ORDERS_DETAILS_OPEN_ITEM_SELECTED='WORK_ORDERS_DETAILS_OPEN_ITEM_SELECTED';var WORK_ORDERS_DETAILS_OPEN_ITEMS_ADD='WORK_ORDERS_DETAILS_OPEN_ITEMS_ADD';var WORK_ORDERS_DETAILS_OPEN_ITEMS_UPDATE='WORK_ORDERS_DETAILS_OPEN_ITEMS_UPDATE';var WORK_ORDERS_DETAILS_OPEN_ITEMS_LOAD_SUCCESS='WORK_ORDERS_DETAILS_OPEN_ITEMS_LOAD_SUCCESS';var WORK_ORDERS_DETAILS_PRE_EXISTING_CONDITIONS_CHANGE='WORK_ORDERS_DETAILS_PRE_EXISTING_CONDITIONS_CHANGE';var WORK_ORDERS_DETAILS_PRE_EXISTING_CONDITIONS_DESCRIPTION_CHANGE='WORK_ORDERS_DETAILS_PRE_EXISTING_CONDITIONS_DESCRIPTION_CHANGE';var WORK_ORDERS_DETAILS_PRE_EXISTING_CONDITIONS_RESET='WORK_ORDERS_DETAILS_PRE_EXISTING_CONDITIONS_RESET';var WORK_ORDERS_DETAILS_CHANGE_ORDER_ADD='WORK_ORDERS_DETAILS_CHANGE_ORDER_ADD';var WORK_ORDERS_DETAILS_MOVED_TO_ACR='WORK_ORDERS_DETAILS_MOVED_TO_ACR';var WORK_ORDERS_DETAILS_PROPOSAL_ADD='WORK_ORDERS_DETAILS_PROPOSAL_ADD';var WORK_ORDERS_DETAILS_PROPOSAL_UPDATE='WORK_ORDERS_DETAILS_PROPOSAL_UPDATE';var WORK_ORDERS_DETAILS_PROPOSALS_LOAD_SUCCESS='WORK_ORDERS_DETAILS_PROPOSALS_LOAD_SUCCESS';var WORK_ORDERS_DETAILS_QUOTE_DETAIL_MODAL_CLOSE='WORK_ORDERS_DETAILS_QUOTE_DETAIL_MODAL_CLOSE';var WORK_ORDERS_DETAILS_QUOTES_LOAD_SUCCESS='WORK_ORDERS_DETAILS_QUOTES_LOAD_SUCCESS';var WORK_ORDERS_DETAILS_QUOTES_REQUEST_MODAL_SHOW='WORK_ORDERS_DETAILS_QUOTES_REQUEST_MODAL_SHOW';var WORK_ORDERS_DETAILS_QUOTES_REQUEST_MODAL_CLOSE='WORK_ORDERS_DETAILS_QUOTES_REQUEST_MODAL_CLOSE';var WORK_ORDERS_DETAILS_QUOTES_REMOVE='WORK_ORDERS_DETAILS_QUOTES_REMOVE';var WORK_ORDERS_DETAILS_QUOTES_SELECT='WORK_ORDERS_DETAILS_QUOTES_SELECT';var WORK_ORDERS_DETAILS_QUOTES_UPDATE_SUCCESS='WORK_ORDERS_DETAILS_QUOTES_UPDATE_SUCCESS';var WORK_ORDERS_DETAILS_QUOTES_DELETE_SUCCESS='WORK_ORDERS_DETAILS_QUOTES_DELETE_SUCCESS';var WORK_ORDERS_DETAILS_QUOTES_TABLE_FILTER_CHANGE='WORK_ORDERS_DETAILS_QUOTES_TABLE_FILTER_CHANGE';var WORK_ORDERS_DETAILS_QUOTES_TABLE_RADIO_SELECT='WORK_ORDERS_DETAILS_QUOTES_TABLE_RADIO_SELECT';var WORK_ORDERS_DETAILS_QUOTES_ADD='WORK_ORDERS_DETAILS_QUOTES_ADD';var WORK_ORDERS_DETAILS_QUOTES_UPDATE='WORK_ORDERS_DETAILS_QUOTES_UPDATE';var WORK_ORDERS_DETAILS_UNREAD_NOTES_SET='WORK_ORDERS_DETAILS_UNREAD_NOTES_SET';var WORK_ORDERS_DETAILS_SET_CURRENT_WORK_ORDER='WORK_ORDERS_DETAILS_SET_CURRENT_WORK_ORDER';var WORK_ORDERS_DETAILS_WORK_ORDER_JOB_NUMBER_CHANGE='WORK_ORDERS_DETAILS_WORK_ORDER_JOB_NUMBER_CHANGE';var WORK_ORDERS_DETAILS_WORK_ORDER_JOB_NUMBER_EDIT='WORK_ORDERS_DETAILS_WORK_ORDER_JOB_NUMBER_EDIT';var WORK_ORDERS_DETAILS_WORK_ORDER_JOB_NUMBER_SAVING='WORK_ORDERS_DETAILS_WORK_ORDER_JOB_NUMBER_SAVING';var WORK_ORDERS_DETAILS_WORK_ORDER_NAME_CHANGE='WORK_ORDERS_DETAILS_WORK_ORDER_NAME_CHANGE';var WORK_ORDERS_DETAILS_WORK_ORDER_NAME_EDIT='WORK_ORDERS_DETAILS_WORK_ORDER_NAME_EDIT';var WORK_ORDERS_DETAILS_WORK_ORDER_NAME_SAVING='WORK_ORDERS_DETAILS_WORK_ORDER_NAME_SAVING';var WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_CHANGE='WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_CHANGE';var WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_REMINDER_CHANGE='WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_REMINDER_CHANGE';var WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_EDIT='WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_EDIT';var WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_SAVING='WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_SAVING';var WORK_ORDERS_DETAILS_NEW_TASK_ATTRIBUTE_CHANGE='WORK_ORDERS_DETAILS_NEW_TASK_ATTRIBUTE_CHANGE';var WORK_ORDERS_DETAILS_NEW_TASK_FORM_CLEAR='WORK_ORDERS_DETAILS_NEW_TASK_FORM_CLEAR';var WORK_ORDERS_DETAILS_NEW_TASK_MODAL_SHOW='WORK_ORDERS_DETAILS_NEW_TASK_MODAL_SHOW';var WORK_ORDERS_DETAILS_NEW_TASK_IMAGE_REMOVE='WORK_ORDERS_DETAILS_NEW_TASK_IMAGE_REMOVE';var WORK_ORDERS_DETAILS_QUOTES_REQUEST_BID_DUE_DATE_SET='WORK_ORDERS_DETAILS_QUOTES_REQUEST_BID_DUE_DATE_SET';var WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_SET='WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_SET';var WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_ADD='WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_ADD';var WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_REMOVE='WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_REMOVE';var WORK_ORDERS_DETAILS_QUOTES_REQUEST_PREVIEW_SHOW='WORK_ORDERS_DETAILS_QUOTES_REQUEST_PREVIEW_SHOW';var WORK_ORDERS_DETAILS_QUOTES_REQUEST_PREVIEW_GO_BACK='WORK_ORDERS_DETAILS_QUOTES_REQUEST_PREVIEW_GO_BACK';var WORK_ORDERS_DETAILS_QUOTES_REQUEST_SUBMIT_SUCCESS='WORK_ORDERS_DETAILS_QUOTES_REQUEST_SUBMIT_SUCCESS';var WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_CLOSE='WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_CLOSE';var WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_INVALID='WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_INVALID';var WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_EDIT='WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_EDIT';var WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_VALUE_UPDATE='WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_VALUE_UPDATE';var WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_VALID='WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_VALID';var WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_SHOW='WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_SHOW';var WORK_ORDERS_DETAILS_CREATE_QUOTE_STATE_SET='WORK_ORDERS_DETAILS_CREATE_QUOTE_STATE_SET';var WORK_ORDERS_DETAILS_CREATE_QUOTE_VALIDATION_MESSAGE_SET='WORK_ORDERS_DETAILS_CREATE_QUOTE_VALIDATION_MESSAGE_SET';var WORK_ORDERS_DETAILS_REVIEW_QUOTE_MODAL_SHOW='WORK_ORDERS_DETAILS_REVIEW_QUOTE_MODAL_SHOW';var WORK_ORDERS_DETAILS_CREATE_QUOTES_FORM_SET='WORK_ORDERS_DETAILS_CREATE_QUOTES_FORM_SET';var WORK_ORDERS_DETAILS_CREATE_QUOTES_MODAL_SHOW_SET='WORK_ORDERS_DETAILS_CREATE_QUOTES_MODAL_SHOW_SET';var WORK_ORDERS_DETAILS_CREATE_QUOTES_STATE_SET='WORK_ORDERS_DETAILS_CREATE_QUOTES_STATE_SET';var WORK_ORDERS_DETAILS_DENY_QUOTE_MODAL_CLOSE='WORK_ORDERS_DETAILS_DENY_QUOTE_MODAL_CLOSE';var WORK_ORDERS_DETAILS_DENY_QUOTE_MODAL_SHOW='WORK_ORDERS_DETAILS_DENY_QUOTE_MODAL_SHOW';var WORK_ORDERS_DETAILS_DENY_QUOTE_REASON_CHANGE='WORK_ORDERS_DETAILS_DENY_QUOTE_REASON_CHANGE';var WORK_ORDERS_DETAILS_DENY_QUOTE_QUESTION_ANSWERED='WORK_ORDERS_DETAILS_DENY_QUOTE_QUESTION_ANSWERED';var WORK_ORDERS_DETAILS_DECLINE_PROPOSAL_MODAL_CLOSE='WORK_ORDERS_DETAILS_DECLINE_PROPOSAL_MODAL_CLOSE';var WORK_ORDERS_DETAILS_DECLINE_PROPOSAL_MODAL_SHOW='WORK_ORDERS_DETAILS_DECLINE_PROPOSAL_MODAL_SHOW';var WORK_ORDERS_DETAILS_PROPOSAL_BACK='WORK_ORDERS_DETAILS_PROPOSAL_BACK';var WORK_ORDERS_DETAILS_PROPOSAL_COMPLETION_DATE_UPDATE='WORK_ORDERS_DETAILS_PROPOSAL_COMPLETION_DATE_UPDATE';var WORK_ORDERS_DETAILS_PROPOSAL_CREATE_SUCCESS='WORK_ORDERS_DETAILS_PROPOSAL_CREATE_SUCCESS';var WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_ADD='WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_ADD';var WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_CLEAR='WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_CLEAR';var WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_MODAL_SHOW_SET='WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_MODAL_SHOW_SET';var WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_REMOVE='WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_REMOVE';var WORK_ORDERS_DETAILS_PROPOSAL_MARKUP_UPDATE='WORK_ORDERS_DETAILS_PROPOSAL_MARKUP_UPDATE';var WORK_ORDERS_DETAILS_PROPOSAL_MESSAGE_SET='WORK_ORDERS_DETAILS_PROPOSAL_MESSAGE_SET';var WORK_ORDERS_DETAILS_PROPOSAL_MODAL_CLOSE='WORK_ORDERS_DETAILS_PROPOSAL_MODAL_CLOSE';var WORK_ORDERS_DETAILS_PROPOSAL_MODAL_SHOW='WORK_ORDERS_DETAILS_PROPOSAL_MODAL_SHOW';var WORK_ORDERS_DETAILS_PROPOSAL_MODAL_EDIT='WORK_ORDERS_DETAILS_PROPOSAL_MODAL_EDIT';var WORK_ORDERS_DETAILS_PROPOSAL_NEXT='WORK_ORDERS_DETAILS_PROPOSAL_NEXT';var WORK_ORDERS_DETAILS_PROPOSAL_PDF_VIEWER_CLOSE='WORK_ORDERS_DETAILS_PROPOSAL_PDF_VIEWER_CLOSE';var WORK_ORDERS_DETAILS_PROPOSAL_PRINT_SUCCESS='WORK_ORDERS_DETAILS_PROPOSAL_PRINT_SUCCESS';var WORK_ORDERS_DETAILS_PROPOSAL_START_DATE_UPDATE='WORK_ORDERS_DETAILS_PROPOSAL_START_DATE_UPDATE';var WORK_ORDERS_DETAILS_PROPOSAL_SUBJECT_SET='WORK_ORDERS_DETAILS_PROPOSAL_SUBJECT_SET';var WORK_ORDERS_DETAILS_PROPOSAL_USERS_LOAD_SUCCESS='WORK_ORDERS_DETAILS_PROPOSAL_USERS_LOAD_SUCCESS';var WORK_ORDERS_DETAILS_PROPOSAL_DEPOSIT_SELECTED_CHANGE='WORK_ORDERS_DETAILS_PROPOSAL_DEPOSIT_SELECTED_CHANGE';var WORK_ORDERS_DETAILS_PROPOSAL_DEPOSIT_COST_CHANGE='WORK_ORDERS_DETAILS_PROPOSAL_DEPOSIT_COST_CHANGE';var WORK_ORDERS_DETAILS_PROPOSAL_ADD_BREAKDOWNITEM='WORK_ORDERS_DETAILS_PROPOSAL_ADD_BREAKDOWNITEM';var WORK_ORDERS_DETAILS_PROPOSAL_REMOVE_BREAKDOWNITEM='WORK_ORDERS_DETAILS_PROPOSAL_REMOVE_BREAKDOWNITEM';var WORK_ORDERS_DETAILS_PROPOSAL_UPDATE_BREAKDOWNITEM='WORK_ORDERS_DETAILS_PROPOSAL_UPDATE_BREAKDOWNITEM';var WORK_ORDERS_DETAILS_PROPOSAL_APPROVAL_MODAL_CLOSE='WORK_ORDERS_DETAILS_PROPOSAL_APPROVAL_MODAL_CLOSE';var WORK_ORDERS_DETAILS_PROPOSAL_APPROVAL_SELECT='WORK_ORDERS_DETAILS_PROPOSAL_APPROVAL_SELECT';var WORK_ORDERS_DETAILS_PROPOSAL_SUCCESS_MODAL_OPEN='WORK_ORDERS_DETAILS_PROPOSAL_SUCCESS_MODAL_OPEN';var WORK_ORDERS_DETAILS_PROPOSAL_SUCCESS_MODAL_CLOSE='WORK_ORDERS_DETAILS_PROPOSAL_SUCCESS_MODAL_CLOSE';var WORK_ORDERS_DETAILS_PROPOSAL_QUOTE_UPDATE='WORK_ORDERS_DETAILS_PROPOSAL_QUOTE_UPDATE';var WORK_ORDERS_DETAILS_PURCHASE_ORDER_CANCEL='WORK_ORDERS_DETAILS_PURCHASE_ORDER_CANCEL';var WORK_ORDERS_DETAILS_PURCHASE_ORDER_DOCUMENT_FILE_SET='WORK_ORDERS_DETAILS_PURCHASE_ORDER_DOCUMENT_FILE_SET';var WORK_ORDERS_DETAILS_PURCHASE_ORDER_DOCUMENT_REMOVE='WORK_ORDERS_DETAILS_PURCHASE_ORDER_DOCUMENT_REMOVE';var WORK_ORDERS_DETAILS_PURCHASE_ORDER_EDIT_SET='WORK_ORDERS_DETAILS_PURCHASE_ORDER_EDIT_SET';var WORK_ORDERS_DETAILS_PURCHASE_ORDER_NUMBER_SET='WORK_ORDERS_DETAILS_PURCHASE_ORDER_NUMBER_SET';var WORK_ORDERS_DETAILS_PURCHASE_ORDER_UPDATE='WORK_ORDERS_DETAILS_PURCHASE_ORDER_UPDATE';var WORK_ORDERS_DETAILS_QUALIFICATIONS_ADD_SUCCESS='WORK_ORDERS_DETAILS_QUALIFICATIONS_ADD_SUCCESS';var WORK_ORDERS_DETAILS_QUALIFICATIONS_LOAD_SUCCESS='WORK_ORDERS_DETAILS_QUALIFICATIONS_LOAD_SUCCESS';var WORK_ORDERS_DETAILS_QUALIFICATIONS_MODAL_SHOW='WORK_ORDERS_DETAILS_QUALIFICATIONS_MODAL_SHOW';var WORK_ORDERS_DETAILS_QUALIFICATIONS_OPTION_SELECTED='WORK_ORDERS_DETAILS_QUALIFICATIONS_OPTION_SELECTED';var WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED='WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED';var WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED_BY_ID_SET='WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED_BY_ID_SET';var WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED_CLEAR='WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED_CLEAR';var WORK_ORDERS_DETAILS_QUALIFICATIONS_TRADES_LOAD_SUCCESS='WORK_ORDERS_DETAILS_QUALIFICATIONS_TRADES_LOAD_SUCCESS';var WORK_ORDERS_DETAILS_TASK_SELECT_SET='WORK_ORDERS_DETAILS_TASK_SELECT_SET';var WORK_ORDERS_DETAILS_TASK_SELECT_CLEAR='WORK_ORDERS_DETAILS_TASK_SELECT_CLEAR';var WORK_ORDERS_DETAILS_SHOW_WOA_SIGNING_MODAL_SET='WORK_ORDERS_DETAILS_SHOW_WOA_SIGNING_MODAL_SET';var WORK_ORDERS_DETAILS_WOA_SIGNING_URL_SET='WORK_ORDERS_DETAILS_WOA_SIGNING_URL_SET';var WORK_ORDERS_DETAILS_WOAS_SET='WORK_ORDERS_DETAILS_WOAS_SET';var WORK_ORDERS_ADD_BUILDING_TO_BEGINNING='WORK_ORDERS_ADD_BUILDING_TO_BEGINNING';

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_close_png__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_close_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_close_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_left_arrow_png__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_left_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_left_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormModal_css__ = __webpack_require__(1925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__FormModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormModal=function(_Component){_inherits(FormModal,_Component);function FormModal(){_classCallCheck(this,FormModal);return _possibleConstructorReturn(this,(FormModal.__proto__||Object.getPrototypeOf(FormModal)).apply(this,arguments));}_createClass(FormModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */],{id:this.props.id,className:'form-modal'+(this.props.className!==undefined?' '+this.props.className:''),show:this.props.show},this.props.showHeader&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */].Header,null,this.props.onBack!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'back-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4_images_left_arrow_png___default.a,alt:'back',onClick:this.props.onBack})),this.props.subTitle!==undefined&&this.props.subTitle,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h1'},this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'close-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3_images_close_png___default.a,alt:'close',onClick:this.props.onClose}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */].Body,null,this.props.children));}}]);return FormModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FormModal.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,showHeader:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,subTitle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,onBack:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};FormModal.defaultProps={showHeader:true,onClose:function onClose(){}};/* harmony default export */ __webpack_exports__["a"] = (FormModal);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(368)(module)))

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Date=function(_Component){_inherits(Date,_Component);function Date(){_classCallCheck(this,Date);return _possibleConstructorReturn(this,(Date.__proto__||Object.getPrototypeOf(Date)).apply(this,arguments));}_createClass(Date,[{key:'render',value:function render(){var date=void 0;var dMoment=__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.props.value,__WEBPACK_IMPORTED_MODULE_2_moment___default.a.defaultFormat);if(dMoment.isValid()){date=__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.props.value).format(this.props.format?this.props.format:'L');}else{date='Invalid date';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:this.props.className!==undefined?this.props.className:null},date);}}]);return Date;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Date.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,format:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Date);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReadOnlyInput__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Input_css__ = __webpack_require__(1876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Input_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Input=function(_Component){_inherits(Input,_Component);function Input(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Input);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Input.__proto__||Object.getPrototypeOf(Input)).call.apply(_ref,[this].concat(args))),_this),_this.handleOnBlur=function(event){if(_this.props.onBlur!==undefined){_this.props.onBlur(event.target.value);}},_this.handleOnChange=function(event){if(_this.props.onChange!==undefined){_this.props.onChange(event.target.value);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Input,[{key:'render',value:function render(){return this.props.readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ReadOnlyInput__["a" /* default */],{'class':'input'+(this.props.className!==undefined?' '+this.props.className:''),placeholder:this.props.placeholder,theme:this.props.theme,value:this.props.value}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input'+(this.props.className!==undefined?' '+this.props.className:'')+(!this.props.valid?' invalid':'')+(this.props.required?' required':''),placeholder:this.props.placeholder,required:this.props.required,value:this.props.value,type:this.props.type,onBlur:this.handleOnBlur,onChange:this.handleOnChange});}}]);return Input;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Input.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,required:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,theme:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,valid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onBlur:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};Input.defaultProps={required:false,type:'text',valid:true,value:''};/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getWorkOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentInvoicesTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCurrentWorkOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBuildings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getTrades; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getSubTradesByTradeId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getContractors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getUnionTrades; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getShowNoWorkOrdersOverlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return searchTextSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getWorkOrders=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.data.orders;},function(workOrders){return workOrders;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.ui.currentPage;},function(currentPage){return currentPage;});var getCurrentInvoicesTab=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.ui.currentInvoicesTab;},function(currentInvoicesTab){return currentInvoicesTab;});var getCurrentWorkOrder=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.data.currentWorkOrder;},function(currentWorkOrder){return currentWorkOrder;});var getTasks=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.data.tasks;},function(tasks){return tasks;});var getBuildings=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.data.buildings;},function(buildings){return buildings;});var getTrades=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.data.trades;},function(trades){return trades;});var getSubTradesByTradeId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.data.subTradesByTradeId;},function(subTradesByTradeId){return subTradesByTradeId;});var getContractors=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.data.contractors;},function(contractors){return contractors;});var getUnionTrades=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.data.unionTrades;},function(unionTrades){return unionTrades;});var getSummary=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.data.summary;},function(summary){return summary;});var getShowNoWorkOrdersOverlay=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.ui.showNoWorkOrdersOverlay;},function(showNoWorkOrdersOverlay){return showNoWorkOrdersOverlay;});var searchTextSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.ui.searchText;},function(searchText){return searchText;});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Number;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
function Number(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:props.className!==null?props.className:null},props.format!==null?__WEBPACK_IMPORTED_MODULE_2_numeral___default()(props.value).format(props.format):__WEBPACK_IMPORTED_MODULE_2_numeral___default()(props.value).value().toString());}Number.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,format:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]).isRequired};Number.defaultProps={className:null,format:null};

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toUpperFirstLetter;
/* harmony export (immutable) */ __webpack_exports__["f"] = validateEmail;
/* harmony export (immutable) */ __webpack_exports__["c"] = formatPhoneNumber;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildTaskName;
/* harmony export (immutable) */ __webpack_exports__["d"] = getLastTokenFromUrl;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatNumber;
function toUpperFirstLetter(string){return string.charAt(0).toUpperCase()+string.slice(1);}function validateEmail(email){var emailRegularExpression=/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;return emailRegularExpression.test(email);}/**
 * Format the phone number.
 *
 * @param phoneNumber
 * @return {*}
 */function formatPhoneNumber(){var phoneNumber=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;if(phoneNumber===null){return'';}var pass=/[+][1]\d{10}/.test(phoneNumber);if(pass&&phoneNumber.length===12){return phoneNumber.replace(/\+1(\d{3})(\d{3})(\d{4})/,'($1) $2-$3');}else{return phoneNumber;}}function buildTaskName(trade){return trade;}function getLastTokenFromUrl(url){var defaultValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var result=defaultValue;if(url!==undefined&&url!==null){var tokens=url.split('/');if(tokens.length>0){result=tokens[tokens.length-1];}}return result;}function formatNumber(number){return number&&number<10?'0'+number:number;}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SimplePagination_css__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SimplePagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SimplePagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimplePagination=function(_Component){_inherits(SimplePagination,_Component);function SimplePagination(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SimplePagination);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SimplePagination.__proto__||Object.getPrototypeOf(SimplePagination)).call.apply(_ref,[this].concat(args))),_this),_this.handlePrev=function(disabled){if(!disabled){if(_this.props.onPageChange){_this.props.onPageChange(_this.props.currentPage-1);}}},_this.handleNext=function(disabled){if(!disabled){if(_this.props.onPageChange){_this.props.onPageChange(_this.props.currentPage+1);}}},_this.handlePage=function(pageNumber){if(_this.props.onPageChange&&_this.props.currentPage!==pageNumber){_this.props.onPageChange(pageNumber);}},_this.handleFirst=function(disabled){if(!disabled){_this.props.onPageChange(1);}},_this.handleLast=function(disabled){if(!disabled){_this.props.onPageChange(_this.numberOfPages);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SimplePagination,[{key:'render',value:function render(){var _this2=this;this.numberOfPages=Math.ceil(this.props.total/this.props.pageSize);this.pages=this.createPages();var morePagesThanVisible=this.numberOfPages>this.props.visiblePages;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'simple-pagination'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["r" /* Pagination */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["r" /* Pagination */].First,{className:'pagination-first',disabled:this.numberOfPages<=this.props.visiblePages||this.props.currentPage===1,onClick:this.handleFirst.bind(this,this.numberOfPages<=this.props.visiblePages||this.props.currentPage===1)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["r" /* Pagination */].Prev,{className:'pagination-prev',disabled:this.props.currentPage===1,onClick:this.handlePrev.bind(this,this.props.currentPage===1)}),morePagesThanVisible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["r" /* Pagination */].Ellipsis,{disabled:true}),this.pages.map(function(page,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["r" /* Pagination */].Item,{key:index,active:page.active,className:'pagination-item',onClick:_this2.handlePage.bind(_this2,page.number)},page.number);}),morePagesThanVisible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["r" /* Pagination */].Ellipsis,{disabled:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["r" /* Pagination */].Next,{className:'pagination-next',disabled:this.props.currentPage===this.numberOfPages||this.numberOfPages===0,onClick:this.handleNext.bind(this,this.props.currentPage===this.numberOfPages||this.numberOfPages===0)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["r" /* Pagination */].Last,{className:'pagination-last',disabled:this.numberOfPages<=this.props.visiblePages||this.props.currentPage===this.numberOfPages||this.numberOfPages===0,onClick:this.handleLast.bind(this,this.numberOfPages<=this.props.visiblePages||this.props.currentPage===this.numberOfPages||this.numberOfPages===0)})));}},{key:'createPages',value:function createPages(){var pages=[];for(var i=0;i<this.numberOfPages;i++){pages.push({number:i+1,active:i+1===this.props.currentPage});}if(this.numberOfPages>this.props.visiblePages){// We have to filter values
var pageIndex=this.props.currentPage-1;var leftLimit=Math.floor((this.props.visiblePages-1)/2);var rightLimit=Math.ceil((this.props.visiblePages-1)/2);var limits={firstIndex:pageIndex-leftLimit,lastIndex:pageIndex+rightLimit};limits=this.calculateIndexes(pages.length,limits);pages=pages.filter(function(item,index){return index>=limits.firstIndex&&index<=limits.lastIndex;});}return pages;}},{key:'calculateIndexes',value:function calculateIndexes(total,limits){if(limits.firstIndex>=0){if(limits.lastIndex<total){return limits;}else{limits.firstIndex=limits.firstIndex-1;limits.lastIndex=limits.lastIndex-1;return this.calculateIndexes(total,limits);}}else{limits.firstIndex=limits.firstIndex+1;limits.lastIndex=limits.lastIndex+1;return this.calculateIndexes(total,limits);}}}]);return SimplePagination;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SimplePagination.propTypes={currentPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,pageSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,total:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,visiblePages:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,onPageChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};SimplePagination.defaultProps={currentPage:1,pageSize:25,visiblePages:10};/* harmony default export */ __webpack_exports__["a"] = (SimplePagination);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getNavBarSelectedItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getShowPdfViewer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getCurrentProject=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.data.currentProject;},function(currentProject){return currentProject;});var getNavBarSelectedItem=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.ui.navBarSelectedItem;},function(navBarSelectedItem){return navBarSelectedItem;});var getShowPdfViewer=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.ui.showPdfViewer;},function(showPdfViewer){return showPdfViewer;});

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfirmationModal_css__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfirmationModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ConfirmationModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConfirmationModal=function(_Component){_inherits(ConfirmationModal,_Component);function ConfirmationModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ConfirmationModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ConfirmationModal.__proto__||Object.getPrototypeOf(ConfirmationModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleYes=function(event){event.preventDefault();_this.props.onHide(true);},_this.handleNo=function(event){event.preventDefault();_this.props.onHide(false);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ConfirmationModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */],{className:'confirmation-modal',show:this.props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sub-message'},this.props.subMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'confirmation-modal-no',className:'btn button button-white',type:'button',value:'No',onClick:this.handleNo}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'confirmation-modal-yes',className:'btn button button-orange',type:'button',value:'Yes',onClick:this.handleYes}))));}}]);return ConfirmationModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConfirmationModal.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,message:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onHide:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,subMessage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ConfirmationModal);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export signEasyBasePath */
/* harmony export (immutable) */ __webpack_exports__["a"] = addMember;
/* harmony export (immutable) */ __webpack_exports__["b"] = addOpenItem;
/* harmony export (immutable) */ __webpack_exports__["u"] = detailsAddChangeOrder;
/* harmony export (immutable) */ __webpack_exports__["v"] = detailsMovedToAcr;
/* harmony export (immutable) */ __webpack_exports__["c"] = addProposal;
/* harmony export (immutable) */ __webpack_exports__["e"] = addTaskNoteRequest;
/* unused harmony export addTaskNoteSuccess */
/* harmony export (immutable) */ __webpack_exports__["f"] = addWorkOrderNoteRequest;
/* unused harmony export addWorkOrderNoteSuccess */
/* harmony export (immutable) */ __webpack_exports__["g"] = approveTaskWorkRequest;
/* harmony export (immutable) */ __webpack_exports__["h"] = cancelTask;
/* harmony export (immutable) */ __webpack_exports__["j"] = changeWorkOrderJobNumber;
/* harmony export (immutable) */ __webpack_exports__["k"] = changeWorkOrderName;
/* harmony export (immutable) */ __webpack_exports__["l"] = changeWorkOrderNote;
/* harmony export (immutable) */ __webpack_exports__["m"] = changeWorkOrderNoteReminder;
/* harmony export (immutable) */ __webpack_exports__["i"] = changeQuotesTableFilterSuccess;
/* harmony export (immutable) */ __webpack_exports__["n"] = closeQuoteDetailsModal;
/* harmony export (immutable) */ __webpack_exports__["o"] = completeTask;
/* harmony export (immutable) */ __webpack_exports__["s"] = deleteTaskRequest;
/* harmony export (immutable) */ __webpack_exports__["w"] = editTask;
/* harmony export (immutable) */ __webpack_exports__["x"] = editWorkOrderJobNumber;
/* harmony export (immutable) */ __webpack_exports__["y"] = editWorkOrderName;
/* harmony export (immutable) */ __webpack_exports__["z"] = editWorkOrderNote;
/* harmony export (immutable) */ __webpack_exports__["A"] = goToTask;
/* harmony export (immutable) */ __webpack_exports__["C"] = initializeComponentAppState;
/* unused harmony export loadBudgetRequest */
/* unused harmony export loadContractorInvoiceRequest */
/* unused harmony export loadContractorLienReleaseRequest */
/* unused harmony export loadContractorLienReleasesRequest */
/* harmony export (immutable) */ __webpack_exports__["q"] = deleteContractorLienReleaseRequest;
/* harmony export (immutable) */ __webpack_exports__["D"] = loadMembersRequest;
/* unused harmony export loadMembersSuccess */
/* unused harmony export loadProposalsFromWorkOrderRequest */
/* unused harmony export loadProposalsSucces */
/* harmony export (immutable) */ __webpack_exports__["E"] = loadQuotesRequest;
/* unused harmony export loadQuotesSuccess */
/* harmony export (immutable) */ __webpack_exports__["p"] = counterQuote;
/* harmony export (immutable) */ __webpack_exports__["_15"] = updateQuoteRequest;
/* unused harmony export updateQuoteSuccess */
/* harmony export (immutable) */ __webpack_exports__["r"] = deleteQuote;
/* unused harmony export deleteQuoteSuccess */
/* harmony export (immutable) */ __webpack_exports__["F"] = loadSubTradesRequest;
/* harmony export (immutable) */ __webpack_exports__["H"] = loadTaskNotesRequest;
/* unused harmony export loadTaskNotesSuccess */
/* harmony export (immutable) */ __webpack_exports__["I"] = loadTasksFromWorkOrderRequest;
/* harmony export (immutable) */ __webpack_exports__["G"] = loadTaskForQuoteDetail;
/* harmony export (immutable) */ __webpack_exports__["J"] = loadTradesRequest;
/* harmony export (immutable) */ __webpack_exports__["K"] = loadWorkOrderNotesRequest;
/* unused harmony export loadWorkOrderNotesSuccess */
/* harmony export (immutable) */ __webpack_exports__["L"] = loadWorkOrderRequest;
/* unused harmony export loadOpenItemsRequest */
/* unused harmony export mapWorkOrderOpenItems */
/* unused harmony export loadOpenItemsSuccess */
/* harmony export (immutable) */ __webpack_exports__["M"] = markItemTaskChecklistRequest;
/* harmony export (immutable) */ __webpack_exports__["O"] = removeDocumentRequest;
/* unused harmony export removeDocumentSuccess */
/* harmony export (immutable) */ __webpack_exports__["P"] = removeImageRequest;
/* unused harmony export removeImage */
/* harmony export (immutable) */ __webpack_exports__["N"] = removeCompleteTaskImagesRequest;
/* harmony export (immutable) */ __webpack_exports__["Q"] = removePreExistingConditionsImagesRequest;
/* unused harmony export removeQuotes */
/* harmony export (immutable) */ __webpack_exports__["R"] = savePreExistingConditionsDescriptionRequest;
/* harmony export (immutable) */ __webpack_exports__["S"] = saveWorkOrderJobNumber;
/* harmony export (immutable) */ __webpack_exports__["T"] = saveWorkOrderNameRequest;
/* harmony export (immutable) */ __webpack_exports__["U"] = saveWorkOrderNoteRequest;
/* harmony export (immutable) */ __webpack_exports__["W"] = selectNavigationBar;
/* unused harmony export selectQuote */
/* harmony export (immutable) */ __webpack_exports__["X"] = selectQuotesTableRadio;
/* harmony export (immutable) */ __webpack_exports__["_1"] = setBudget;
/* unused harmony export setContractorInvoice */
/* unused harmony export setContractorLienRelease */
/* unused harmony export setContractorLienReleases */
/* unused harmony export removeContractorLienRelease */
/* harmony export (immutable) */ __webpack_exports__["_2"] = setCurrentWorkOrder;
/* harmony export (immutable) */ __webpack_exports__["Z"] = selectTaskRequest;
/* harmony export (immutable) */ __webpack_exports__["_0"] = selectTaskSuccess;
/* harmony export (immutable) */ __webpack_exports__["_3"] = setSelectedOpenItem;
/* harmony export (immutable) */ __webpack_exports__["_5"] = setShowClientStreamModalRequest;
/* harmony export (immutable) */ __webpack_exports__["_4"] = setShowClientStreamModal;
/* harmony export (immutable) */ __webpack_exports__["_7"] = startTask;
/* harmony export (immutable) */ __webpack_exports__["_8"] = submitEditOpenRequestRequest;
/* unused harmony export taskChange */
/* harmony export (immutable) */ __webpack_exports__["_9"] = taskChangeRequest;
/* harmony export (immutable) */ __webpack_exports__["_12"] = updatePreExistingConditions;
/* harmony export (immutable) */ __webpack_exports__["_13"] = updatePreExistingConditionsDescription;
/* unused harmony export resetPreExistingConditions */
/* harmony export (immutable) */ __webpack_exports__["d"] = addQuote;
/* harmony export (immutable) */ __webpack_exports__["_16"] = updateQuotes;
/* harmony export (immutable) */ __webpack_exports__["_17"] = updateTaskRequest;
/* harmony export (immutable) */ __webpack_exports__["_10"] = taskScheduleUpdate;
/* unused harmony export updateWorkOrderUnreadNotes */
/* harmony export (immutable) */ __webpack_exports__["_22"] = uploadDocumentsRequest;
/* unused harmony export uploadDocumentsSuccess */
/* harmony export (immutable) */ __webpack_exports__["_11"] = updateCurrentTask;
/* unused harmony export updateOpenItem */
/* harmony export (immutable) */ __webpack_exports__["_14"] = updateProposal;
/* harmony export (immutable) */ __webpack_exports__["_19"] = uploadCompleteTaskImagesRequest;
/* harmony export (immutable) */ __webpack_exports__["_20"] = uploadContractorInvoiceRequest;
/* harmony export (immutable) */ __webpack_exports__["_21"] = uploadContractorLienReleaseRequest;
/* harmony export (immutable) */ __webpack_exports__["_23"] = uploadPreExistingConditionsImagesRequest;
/* harmony export (immutable) */ __webpack_exports__["_24"] = withdrawQuoteRequest;
/* harmony export (immutable) */ __webpack_exports__["V"] = selectAllTasks;
/* harmony export (immutable) */ __webpack_exports__["t"] = deselectAllTasks;
/* harmony export (immutable) */ __webpack_exports__["Y"] = selectTask;
/* unused harmony export clearTasksSelection */
/* harmony export (immutable) */ __webpack_exports__["_18"] = updateWorkOrderSchedule;
/* unused harmony export setWoaSigningUrl */
/* harmony export (immutable) */ __webpack_exports__["B"] = hideWoaSigningModal;
/* harmony export (immutable) */ __webpack_exports__["_6"] = showSignWoaModal;
/* unused harmony export setWorkOrderAuthorizations */
/* unused harmony export loadWorkOrderAuthorizations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_utils_tasks_util__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_quotes_api__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_trades_api__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_tasks_api__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_api_contractors_lien_releases_api__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_utils_work_order_status_enum__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_api_tasks_checklist_api__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_domain_task_status_enum__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_work_orders_details_time_store_actions__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_work_orders_details_vendor_invoices_store_actions__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_admin_work_orders_details_receipts_store_actions__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_services_api_work_order_authorizations_api__ = __webpack_require__(1381);
var signEasyBasePath='dl.getsigneasy.com';function addMember(member){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_57" /* WORK_ORDERS_DETAILS_MEMBERS_ADD */],payload:member};}function addOpenItem(openItem){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_68" /* WORK_ORDERS_DETAILS_OPEN_ITEMS_ADD */],payload:{taskId:openItem.task.id,item:openItem}};}function detailsAddChangeOrder(){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_31" /* WORK_ORDERS_DETAILS_CHANGE_ORDER_ADD */]};}function detailsMovedToAcr(){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_60" /* WORK_ORDERS_DETAILS_MOVED_TO_ACR */]};}function addProposal(proposal){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_77" /* WORK_ORDERS_DETAILS_PROPOSAL_ADD */],payload:proposal};}function addTaskNoteRequest(taskId,text){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_tasks_api__["b" /* tasksApi */].addNote(taskId,text).then(function(response){if(response.ok){dispatch(addTaskNoteSuccess(response.note));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function addTaskNoteSuccess(note){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_150" /* WORK_ORDERS_DETAILS_TASK_NOTE_ADD_SUCCESS */],payload:note};}function addWorkOrderNoteRequest(workOrderId,note){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].addNote(workOrderId,note).then(function(response){if(response.ok){dispatch(addWorkOrderNoteSuccess(response.note));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function addWorkOrderNoteSuccess(note){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_67" /* WORK_ORDERS_DETAILS_NOTE_ADD_SUCCESS */],payload:note};}function approveTaskWorkRequest(taskId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_tasks_api__["b" /* tasksApi */].approveWork(taskId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["z" /* updateTask */])(response.task));// to update task on task list on store
}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function cancelTask(workOrderId){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_144" /* WORK_ORDERS_DETAILS_TASK_CANCEL */]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_7__work_orders__["c" /* baseRoutePath */]+'/'+workOrderId));};}function changeWorkOrderJobNumber(value){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_157" /* WORK_ORDERS_DETAILS_WORK_ORDER_JOB_NUMBER_CHANGE */],payload:value};}function changeWorkOrderName(value){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_160" /* WORK_ORDERS_DETAILS_WORK_ORDER_NAME_CHANGE */],payload:value};}function changeWorkOrderNote(value){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_163" /* WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_CHANGE */],payload:value};}function changeWorkOrderNoteReminder(value){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_165" /* WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_REMINDER_CHANGE */],payload:value};}function changeQuotesTableFilterSuccess(filter){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_135" /* WORK_ORDERS_DETAILS_QUOTES_TABLE_FILTER_CHANGE */],payload:filter};}function closeQuoteDetailsModal(){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_139" /* WORK_ORDERS_DETAILS_QUOTE_DETAIL_MODAL_CLOSE */]};}function completeTask(taskId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_tasks_api__["b" /* tasksApi */].complete(taskId).then(function(response){if(response.ok){dispatch(selectTaskSuccess(__WEBPACK_IMPORTED_MODULE_1_services_utils_tasks_util__["a" /* default */].mapTask(response.task)));dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["z" /* updateTask */])(response.task));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function deleteTaskRequest(taskId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_tasks_api__["b" /* tasksApi */].removeTask(taskId).then(function(response){if(response.ok){dispatch(selectTaskSuccess(null));dispatch(removeQuotes(taskId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["t" /* removeTask */])(taskId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function editTask(){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_146" /* WORK_ORDERS_DETAILS_TASK_EDIT */]};}function editWorkOrderJobNumber(value){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_158" /* WORK_ORDERS_DETAILS_WORK_ORDER_JOB_NUMBER_EDIT */],payload:value};}function editWorkOrderName(value){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_161" /* WORK_ORDERS_DETAILS_WORK_ORDER_NAME_EDIT */],payload:value};}function editWorkOrderNote(value){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_164" /* WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_EDIT */],payload:value};}function goToTask(workOrderId,taskId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_7__work_orders__["c" /* baseRoutePath */]+'/'+workOrderId+'/task/'+taskId));};}function initializeComponentAppState(){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_143" /* WORK_ORDERS_DETAILS_STATE_INIT */]};}function loadBudgetRequest(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].getBudget(workOrderId).then(function(response){if(response.ok){dispatch(setBudget(response.budget));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadContractorInvoiceRequest(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].getContractorInvoices(workOrderId).then(function(response){if(response.ok){if(response.invoices.length>0){dispatch(setContractorInvoice(response.invoices[0]));if(response.invoices[0].status==='paid'){dispatch(loadContractorLienReleaseRequest(workOrderId));}}else{dispatch(setContractorInvoice(null));}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadContractorLienReleaseRequest(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].getContractorLienReleases(workOrderId).then(function(response){if(response.ok){if(response.lienReleases.length>0){dispatch(setContractorLienRelease(response.lienReleases[0]));}else{dispatch(setContractorLienRelease(null));}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadContractorLienReleasesRequest(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].getContractorLienReleases(workOrderId).then(function(response){if(response.ok){dispatch(setContractorLienReleases(response.lienReleases));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function deleteContractorLienReleaseRequest(lienReleaseId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5_services_api_contractors_lien_releases_api__["a" /* contractorsLienReleasesApi */].deleteLienRelease(lienReleaseId).then(function(response){if(response.ok){dispatch(removeContractorLienRelease(lienReleaseId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadMembersRequest(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].getMembers(workOrderId).then(function(response){if(response.ok){dispatch(loadMembersSuccess(response.members));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadMembersSuccess(members){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_58" /* WORK_ORDERS_DETAILS_MEMBERS_LOAD_SUCCESS */],payload:members};}function loadProposalsFromWorkOrderRequest(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].getProposals(workOrderId).then(function(response){if(response.ok){dispatch(loadProposalsSucces(response.proposals));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadProposalsSucces(proposals){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_76" /* WORK_ORDERS_DETAILS_PROPOSALS_LOAD_SUCCESS */],payload:proposals};}function loadQuotesRequest(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].getQuotes(workOrderId).then(function(response){if(response.ok){dispatch(loadQuotesSuccess(response.quotes));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadQuotesSuccess(quotes){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_123" /* WORK_ORDERS_DETAILS_QUOTES_LOAD_SUCCESS */],payload:quotes};}function counterQuote(quoteId,counter){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_quotes_api__["a" /* quotesApi */].counterQuote(quoteId,{counter:counter}).then(function(response){if(response.ok){dispatch(updateQuoteSuccess(response.quote));}return response;});};}function updateQuoteRequest(quoteId,estimate,value,contractorId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_quotes_api__["a" /* quotesApi */].updateQuote(quoteId,{estimate:estimate,value:value,contractorId:contractorId}).then(function(response){if(response.ok){dispatch(updateQuoteSuccess(response.quote));}});};}function updateQuoteSuccess(quote){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_138" /* WORK_ORDERS_DETAILS_QUOTES_UPDATE_SUCCESS */],payload:quote};}function deleteQuote(quoteId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_quotes_api__["a" /* quotesApi */].deleteQuote(quoteId).then(function(response){if(response.ok){dispatch(deleteQuoteSuccess(quoteId));}});};}function deleteQuoteSuccess(quoteId){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_122" /* WORK_ORDERS_DETAILS_QUOTES_DELETE_SUCCESS */],payload:quoteId};}function loadSubTradesRequest(tradeId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_trades_api__["b" /* tradesApi */].getSubTrades(tradeId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["l" /* loadSubTradesSuccess */])(tradeId,response.subTrades));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadTaskNotesRequest(taskId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_tasks_api__["b" /* tasksApi */].getNotes(taskId).then(function(response){if(response.ok){dispatch(loadTaskNotesSuccess(response.notes));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadTaskNotesSuccess(notes){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_149" /* WORK_ORDERS_DETAILS_TASK_NOTES_LOAD_SUCCESS */],payload:notes};}function loadTasksFromWorkOrderRequest(workOrderId,userIsContractor){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].getTasks(workOrderId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["m" /* loadTasksFromWorkOrderSuccess */])(response.tasks));dispatch(clearTasksSelection());if(!userIsContractor){dispatch(loadProposalsFromWorkOrderRequest(workOrderId));}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadTaskForQuoteDetail(taskId,quoteId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_tasks_api__["b" /* tasksApi */].getTask(taskId).then(function(response){if(response.ok){dispatch(selectTaskSuccess(__WEBPACK_IMPORTED_MODULE_1_services_utils_tasks_util__["a" /* default */].mapTask(response.task)));dispatch(selectQuote(quoteId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadTradesRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_trades_api__["b" /* tradesApi */].getTrades().then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["n" /* loadTradesSuccess */])(response.trades));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadWorkOrderNotesRequest(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].getNotes(workOrderId).then(function(response){if(response.ok){dispatch(loadWorkOrderNotesSuccess(response.notes));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadWorkOrderNotesSuccess(notes){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_66" /* WORK_ORDERS_DETAILS_NOTES_LOAD_SUCCESS */],payload:notes};}function loadWorkOrderRequest(workOrderId,userIsAdmin,userIsContractor){var contractorUserCanSeeMoney=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["x" /* selectWorkOrderSuccess */])(null));// clean current selected WO (new WOs don't have some info required by WO details)
return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].getWorkOrder(workOrderId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["x" /* selectWorkOrderSuccess */])(response.workOrder));dispatch(loadTasksFromWorkOrderRequest(workOrderId,userIsContractor));// Load WO open items if corresponds
var statusEnum=__WEBPACK_IMPORTED_MODULE_10_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(response.workOrder.status);if((userIsAdmin||userIsContractor)&&(__WEBPACK_IMPORTED_MODULE_10_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].IN_PROGRESS.equals(statusEnum)||__WEBPACK_IMPORTED_MODULE_10_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].COMPLETE.equals(statusEnum)||__WEBPACK_IMPORTED_MODULE_10_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].CLOSED.equals(statusEnum))){dispatch(loadOpenItemsRequest(workOrderId));}if(userIsAdmin&&(__WEBPACK_IMPORTED_MODULE_10_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].COMPLETE.equals(statusEnum)||__WEBPACK_IMPORTED_MODULE_10_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].CLOSED.equals(statusEnum))){dispatch(loadContractorLienReleasesRequest(workOrderId));}if(userIsContractor){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_work_orders_details_receipts_store_actions__["d" /* getReceipts */])(workOrderId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_work_orders_details_time_store_actions__["e" /* getTime */])(workOrderId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_components_admin_work_orders_details_vendor_invoices_store_actions__["c" /* getVendorInvoices */])(workOrderId));if(contractorUserCanSeeMoney&&(__WEBPACK_IMPORTED_MODULE_10_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].IN_PROGRESS.equals(statusEnum)||__WEBPACK_IMPORTED_MODULE_10_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].COMPLETE.equals(statusEnum)||__WEBPACK_IMPORTED_MODULE_10_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].CLOSED.equals(statusEnum))){dispatch(loadContractorInvoiceRequest(workOrderId));}}else{dispatch(loadBudgetRequest(workOrderId));}if(userIsAdmin||contractorUserCanSeeMoney){dispatch(loadWorkOrderAuthorizations(workOrderId));}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadOpenItemsRequest(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].getOpenItems(workOrderId).then(function(response){if(response.ok){var openItemsByTaskId=mapWorkOrderOpenItems(response.openItems);dispatch(loadOpenItemsSuccess(openItemsByTaskId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}/**
 * Map list of open items to a map by task id.
 * @param openItems
 * @return {*}
 */function mapWorkOrderOpenItems(openItems){return openItems.reduce(function(accumulator,currentOpenItem){var items=accumulator[currentOpenItem.task.id];if(accumulator[currentOpenItem.task.id]===undefined){items=[];}items.push(currentOpenItem);accumulator[currentOpenItem.task.id]=items;return accumulator;},{});}function loadOpenItemsSuccess(openItemsByTaskId){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_69" /* WORK_ORDERS_DETAILS_OPEN_ITEMS_LOAD_SUCCESS */],payload:openItemsByTaskId};}function markItemTaskChecklistRequest(taskId,taskChecklistId,itemId,value){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_11_services_api_tasks_checklist_api__["a" /* tasksChecklistApi */].markItemChecklist(taskChecklistId,itemId,value).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["A" /* updateTaskChecklist */])(taskId,response.taskChecklist));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function removeDocumentRequest(workOrderId,documentId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].deleteDocument(workOrderId,documentId).then(function(response){if(response.ok){dispatch(removeDocumentSuccess(documentId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function removeDocumentSuccess(documentId){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_55" /* WORK_ORDERS_DETAILS_DOCUMENT_REMOVE_SUCCESS */],payload:documentId};}function removeImageRequest(currentTask,imageIndex){return function(dispatch){var image=currentTask.images[imageIndex];if(image.id===0){// Image is local
dispatch(removeImage(imageIndex));}else{// Image is stored in the backend, removeUser from there
return __WEBPACK_IMPORTED_MODULE_4_services_api_tasks_api__["a" /* default */].removeImage(currentTask.id,image.id).then(function(response){if(response.ok){dispatch(removeImage(imageIndex));dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["z" /* updateTask */])(response.task));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});}};}function removeImage(imageIndex){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_147" /* WORK_ORDERS_DETAILS_TASK_IMAGE_REMOVE_SUCCESS */],payload:imageIndex};}function removeCompleteTaskImagesRequest(taskChecklistId,imageId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_11_services_api_tasks_checklist_api__["a" /* tasksChecklistApi */].removeCompleteTaskImage(taskChecklistId,imageId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["A" /* updateTaskChecklist */])(response.taskChecklist.task_id,response.taskChecklist));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function removePreExistingConditionsImagesRequest(taskChecklistId,imageId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_11_services_api_tasks_checklist_api__["a" /* tasksChecklistApi */].removePreExistingConditionsImage(taskChecklistId,imageId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["A" /* updateTaskChecklist */])(response.taskChecklist.task_id,response.taskChecklist));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function removeQuotes(taskId){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_124" /* WORK_ORDERS_DETAILS_QUOTES_REMOVE */],payload:taskId};}function savePreExistingConditionsDescriptionRequest(taskChecklistId,description){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_11_services_api_tasks_checklist_api__["a" /* tasksChecklistApi */].savePreExistingConditionsDescription(taskChecklistId,description).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["A" /* updateTaskChecklist */])(response.taskChecklist.task_id,response.taskChecklist));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function saveWorkOrderJobNumber(workOrderId,value){var workOrderJob=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return function(dispatch){dispatch(setWorkOrderJobNumberSaving(true));var promise=void 0;if(workOrderJob===null){promise=__WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].createJobNumber(workOrderId,value);}else{promise=__WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].updateJobNumber(workOrderJob.id,value);}return promise.then(function(response){dispatch(setWorkOrderJobNumberSaving(false));if(response.ok){dispatch(editWorkOrderJobNumber(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_19_actions_admin_work_orders_work_orders__["y" /* updateCurrentWorkOrderAttribute */])('work_order_job',response.workOrderJob));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function saveWorkOrderNameRequest(workOrderId,value){return function(dispatch){dispatch(setWorkOrderNameSaving(true));return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].updateName(workOrderId,value).then(function(response){dispatch(setWorkOrderNameSaving(false));if(response.ok){dispatch(editWorkOrderName(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["D" /* updateWorkOrderAttribute */])(response.workOrder,'name'));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function setWorkOrderJobNumberSaving(value){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_159" /* WORK_ORDERS_DETAILS_WORK_ORDER_JOB_NUMBER_SAVING */],payload:value};}function setWorkOrderNameSaving(value){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_162" /* WORK_ORDERS_DETAILS_WORK_ORDER_NAME_SAVING */],payload:value};}function saveWorkOrderNoteRequest(workOrderId,value,reminderValue){return function(dispatch){dispatch(setWorkOrderNoteSaving(true));return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].updateNote(workOrderId,value,reminderValue).then(function(response){dispatch(setWorkOrderNoteSaving(false));if(response.ok){dispatch(editWorkOrderNote(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["D" /* updateWorkOrderAttribute */])(response.workOrder,'note'));dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["D" /* updateWorkOrderAttribute */])(response.workOrder,'note_reminder_date'));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function setWorkOrderNoteSaving(value){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_166" /* WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_SAVING */],payload:value};}function selectNavigationBar(workOrderId,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_61" /* WORK_ORDERS_DETAILS_NAV_BAR_SELECTION */],payload:value});dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_7__work_orders__["c" /* baseRoutePath */]+'/'+workOrderId));};}function selectQuote(quoteId){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_134" /* WORK_ORDERS_DETAILS_QUOTES_SELECT */],payload:quoteId};}function selectQuotesTableRadio(taskId,quoteId){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_136" /* WORK_ORDERS_DETAILS_QUOTES_TABLE_RADIO_SELECT */],payload:{taskId:taskId,quoteId:quoteId}};}function setBudget(budget){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_25" /* WORK_ORDERS_DETAILS_BUDGET_SET */],payload:budget};}function setContractorInvoice(contractorInvoice){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_33" /* WORK_ORDERS_DETAILS_CONTRACTOR_INVOICE_SET */],payload:contractorInvoice};}function setContractorLienRelease(contractorLienRelease){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_36" /* WORK_ORDERS_DETAILS_CONTRACTOR_LIEN_RELEASE_SET */],payload:contractorLienRelease};}function setContractorLienReleases(contractorLienReleases){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_34" /* WORK_ORDERS_DETAILS_CONTRACTOR_LIEN_RELEASES_SET */],payload:contractorLienReleases};}function removeContractorLienRelease(lienReleaseId){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_35" /* WORK_ORDERS_DETAILS_CONTRACTOR_LIEN_RELEASE_REMOVE */],payload:lienReleaseId};}function setCurrentWorkOrder(workOrder){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_141" /* WORK_ORDERS_DETAILS_SET_CURRENT_WORK_ORDER */],payload:workOrder};}function selectTaskRequest(workOrderId,taskId,currentUser){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_tasks_api__["b" /* tasksApi */].getTask(taskId).then(function(response){if(response.ok){var task=response.task;var tradeId=task.trade.id;dispatch(resetPreExistingConditions());// Task checklist description.
if(task.task_checklist!==null){if(task.task_checklist.pre_existing_desc!==null){dispatch(updatePreExistingConditionsDescription(task.task_checklist.pre_existing_desc));}dispatch(updatePreExistingConditions(task.task_checklist.pre_existing_desc!==null&&task.task_checklist.pre_existing_desc!==''||task.task_checklist.pre_existing_images.length>0?true:null)// at first, no "false", just null
);}// Load quotes only if user is contractor and has at least one role
var loadQuotes=__WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__["f" /* TYPES */].CONTRACTOR)&&currentUser.roles.length>0;if(loadQuotes){return __WEBPACK_IMPORTED_MODULE_2_services_api_quotes_api__["a" /* quotesApi */].getQuotesByTask(taskId).then(function(response){if(response.ok){dispatch(updateQuotes(response.quotes));dispatch(loadSubTradesRequest(tradeId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["z" /* updateTask */])(task));// current task does not contain all task info, update task on the list
dispatch(selectTaskSuccess(__WEBPACK_IMPORTED_MODULE_1_services_utils_tasks_util__["a" /* default */].mapTask(task)));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});}else{dispatch(loadSubTradesRequest(tradeId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["z" /* updateTask */])(task));// current task does not contain all task info, update task on the list
dispatch(selectTaskSuccess(__WEBPACK_IMPORTED_MODULE_1_services_utils_tasks_util__["a" /* default */].mapTask(task)));}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function selectTaskSuccess(task){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_148" /* WORK_ORDERS_DETAILS_TASK_LOAD_SUCCESS */],payload:task};}function setSelectedOpenItem(openItem){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_72" /* WORK_ORDERS_DETAILS_OPEN_ITEM_SELECTED */],payload:openItem};}function setShowClientStreamModalRequest(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].markNotesAsReaded(workOrderId).then(function(response){if(response.ok){dispatch(updateWorkOrderUnreadNotes(false));dispatch(setShowClientStreamModal(true));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function setShowClientStreamModal(open){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_32" /* WORK_ORDERS_DETAILS_CLIENT_STREAM_MODAL_SHOW */],payload:open};}function startTask(taskId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_tasks_api__["b" /* tasksApi */].start(taskId).then(function(response){if(response.ok){dispatch(selectTaskSuccess(__WEBPACK_IMPORTED_MODULE_1_services_utils_tasks_util__["a" /* default */].mapTask(response.task)));dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["z" /* updateTask */])(response.task));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function submitEditOpenRequestRequest(taskId,openItemId,editForm){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_tasks_api__["b" /* tasksApi */].updateOpenItem(taskId,openItemId,editForm).then(function(response){if(response.ok){dispatch(updateOpenItem(response.openItem));dispatch(setSelectedOpenItem(null));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function taskChange(taskId,attribute,value,label){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_145" /* WORK_ORDERS_DETAILS_TASK_CHANGE_VALUE */],payload:{taskId:taskId,attribute:attribute,value:value,label:label}};}function taskChangeRequest(taskId,attribute,value,label){return function(dispatch){if(attribute==='images'){// If new files uploaded, read them first so it's possible to show with a preview
var imageLoaded=[];var imageLoaderPromises=value.map(function(image){return new Promise(function(resolve){var reader=new FileReader();reader.onloadend=function(){imageLoaded.push({id:0,file:{original:image,img:reader.result},preview:null,url:null});resolve();};reader.readAsDataURL(image);});});Promise.all(imageLoaderPromises).then(function(){dispatch(taskChange(taskId,attribute,imageLoaded));});}else{dispatch(taskChange(taskId,attribute,value,label));}};}function updatePreExistingConditions(value){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_73" /* WORK_ORDERS_DETAILS_PRE_EXISTING_CONDITIONS_CHANGE */],payload:value};}function updatePreExistingConditionsDescription(value){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_74" /* WORK_ORDERS_DETAILS_PRE_EXISTING_CONDITIONS_DESCRIPTION_CHANGE */],payload:value};}function resetPreExistingConditions(){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_75" /* WORK_ORDERS_DETAILS_PRE_EXISTING_CONDITIONS_RESET */]};}function addQuote(quote){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_121" /* WORK_ORDERS_DETAILS_QUOTES_ADD */],payload:quote};}function updateQuotes(quotes){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_137" /* WORK_ORDERS_DETAILS_QUOTES_UPDATE */],payload:quotes};}function updateTaskRequest(workOrderId,task){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_tasks_api__["b" /* tasksApi */].updateTask(task).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["B" /* updateTaskSuccess */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["z" /* updateTask */])(response.task));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function taskScheduleUpdate(taskId,start,end){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_tasks_api__["b" /* tasksApi */].updateTaskSchedule(taskId,start,end).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["z" /* updateTask */])(response.task));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function updateWorkOrderUnreadNotes(unread){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_154" /* WORK_ORDERS_DETAILS_UNREAD_NOTES_SET */],payload:unread};}function uploadDocumentsRequest(workOrderId,files){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].uploadDocuments(workOrderId,files).then(function(response){if(response.ok){dispatch(uploadDocumentsSuccess(response.documents));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function uploadDocumentsSuccess(documents){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_54" /* WORK_ORDERS_DETAILS_DOCUMENTS_UPLOAD_SUCCESS */],payload:documents};}function updateCurrentTask(task){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_153" /* WORK_ORDERS_DETAILS_TASK_UPDATE */],payload:__WEBPACK_IMPORTED_MODULE_1_services_utils_tasks_util__["a" /* default */].mapTask(task)};}function updateOpenItem(openItem){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_70" /* WORK_ORDERS_DETAILS_OPEN_ITEMS_UPDATE */],payload:{taskId:openItem.task.id,item:openItem}};}function updateProposal(proposal){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_104" /* WORK_ORDERS_DETAILS_PROPOSAL_UPDATE */],payload:proposal};}function uploadCompleteTaskImagesRequest(taskChecklistId,images){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_11_services_api_tasks_checklist_api__["a" /* tasksChecklistApi */].uploadCompleteTaskImages(taskChecklistId,images).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["A" /* updateTaskChecklist */])(response.taskChecklist.task_id,response.taskChecklist));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function uploadContractorInvoiceRequest(workOrderId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].uploadContractorInvoice(workOrderId,values).then(function(response){if(response.ok){dispatch(setContractorInvoice(response.contractorInvoice));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function uploadContractorLienReleaseRequest(workOrderId,file){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].uploadContractorLienRelease(workOrderId,file).then(function(response){if(response.ok){dispatch(setContractorLienRelease(response.contractorLienRelease));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function uploadPreExistingConditionsImagesRequest(taskChecklistId,images){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_11_services_api_tasks_checklist_api__["a" /* tasksChecklistApi */].uploadPreExistingConditionsImages(taskChecklistId,images).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["A" /* updateTaskChecklist */])(response.taskChecklist.task_id,response.taskChecklist));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function withdrawQuoteRequest(quoteId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_quotes_api__["a" /* quotesApi */].withdrawQuote(quoteId).then(function(response){if(response.ok){dispatch(updateQuotes([response.quote]));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function selectAllTasks(){return function(dispatch,getState){var selectAllChecked=Object(__WEBPACK_IMPORTED_MODULE_13_selectors_admin_work_orders_details_details__["p" /* getSelectAllChecked */])(getState());if(selectAllChecked){dispatch(setTaskSelection({},false));}else{var taskIds={};var tasks=Object(__WEBPACK_IMPORTED_MODULE_14_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(getState());if(tasks!==null&&tasks.length>0){taskIds=extractTaskIds(tasks);}dispatch(setTaskSelection(taskIds,true));}};}function deselectAllTasks(){return function(dispatch){dispatch(setTaskSelection({},false));};}function selectTask(task){return function(dispatch,getState){var selectedTasks=Object(__WEBPACK_IMPORTED_MODULE_13_selectors_admin_work_orders_details_details__["s" /* getSelectedTasks */])(getState());var newSelectedTasks=Object.assign({},selectedTasks);if(selectedTasks[task.id]!==undefined){delete newSelectedTasks[task.id];}else{newSelectedTasks[task.id]=task;}var tasks=Object(__WEBPACK_IMPORTED_MODULE_14_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(getState());var allChecked=false;if(tasks!==null&&tasks.length>0){var taskIds=extractTaskIds(tasks);allChecked=Object.keys(taskIds).length===Object.keys(newSelectedTasks).length;}dispatch(setTaskSelection(newSelectedTasks,allChecked));};}function extractTaskIds(results){return results// For some reports, each item contains a work_order, for other just the work order id
.reduce(function(accumulator,task){if(accumulator[task.id]===undefined&&!__WEBPACK_IMPORTED_MODULE_15_domain_task_status_enum__["a" /* TaskStatusEnum */].CLS.equals(task.status)){accumulator[task.id]=task;}return accumulator;},{});}function setTaskSelection(selectedTasks,allChecked){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_152" /* WORK_ORDERS_DETAILS_TASK_SELECT_SET */],payload:{selectedTasks:selectedTasks,allChecked:allChecked}};}function clearTasksSelection(){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_151" /* WORK_ORDERS_DETAILS_TASK_SELECT_CLEAR */]};}function updateWorkOrderSchedule(workOrderId,start,end){return function(dispatch){var data={schedule_start_date:start,schedule_end_date:end};return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["a" /* default */].updateWorkOrder(workOrderId,data).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["D" /* updateWorkOrderAttribute */])(response.workOrder,'schedule_start_date'));dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__work_orders__["D" /* updateWorkOrderAttribute */])(response.workOrder,'schedule_end_date'));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setWoaSigningUrl(url){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_156" /* WORK_ORDERS_DETAILS_WOA_SIGNING_URL_SET */],payload:url};}function hideWoaSigningModal(){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_142" /* WORK_ORDERS_DETAILS_SHOW_WOA_SIGNING_MODAL_SET */]};}function showSignWoaModal(workOrderAuthorizationId){return function(dispatch){__WEBPACK_IMPORTED_MODULE_20_services_api_work_order_authorizations_api__["a" /* workOrderAuthorizationsApi */].getSigningUrl(workOrderAuthorizationId,'').then(function(response){if(response.ok){var signingUrl=response.data.url.replace(signEasyBasePath,signEasyBasePath+'/#');dispatch(setWoaSigningUrl(signingUrl));}});};}function setWorkOrderAuthorizations(workOrderAuthorizations){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_action_types__["_155" /* WORK_ORDERS_DETAILS_WOAS_SET */],payload:workOrderAuthorizations};}function loadWorkOrderAuthorizations(workOrderId){return function(dispatch){__WEBPACK_IMPORTED_MODULE_20_services_api_work_order_authorizations_api__["a" /* workOrderAuthorizationsApi */].getWorkOrderAuthorizations(workOrderId).then(function(response){if(response.ok){dispatch(setWorkOrderAuthorizations(response.workOrderAuthorizations));}});};}

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return baseRoutePath; });
/* harmony export (immutable) */ __webpack_exports__["b"] = addWorkOrder;
/* harmony export (immutable) */ __webpack_exports__["h"] = goToWorkOrder;
/* harmony export (immutable) */ __webpack_exports__["g"] = goHistoryBack;
/* harmony export (immutable) */ __webpack_exports__["d"] = cancelWorkOrderRequest;
/* unused harmony export changePage */
/* harmony export (immutable) */ __webpack_exports__["e"] = changeInvoicesTab;
/* harmony export (immutable) */ __webpack_exports__["t"] = removeTask;
/* harmony export (immutable) */ __webpack_exports__["u"] = removeTaskFromSummary;
/* harmony export (immutable) */ __webpack_exports__["q"] = loadWorkOrdersRequest;
/* unused harmony export loadWorkOrdersSuccess */
/* harmony export (immutable) */ __webpack_exports__["w"] = selectWorkOrderRequest;
/* harmony export (immutable) */ __webpack_exports__["x"] = selectWorkOrderSuccess;
/* harmony export (immutable) */ __webpack_exports__["m"] = loadTasksFromWorkOrderSuccess;
/* harmony export (immutable) */ __webpack_exports__["i"] = loadBuildingSuccess;
/* harmony export (immutable) */ __webpack_exports__["f"] = createWorkOrderSuccess;
/* harmony export (immutable) */ __webpack_exports__["n"] = loadTradesSuccess;
/* harmony export (immutable) */ __webpack_exports__["k"] = loadSubTradesRequest;
/* harmony export (immutable) */ __webpack_exports__["l"] = loadSubTradesSuccess;
/* harmony export (immutable) */ __webpack_exports__["j"] = loadContractorsSuccess;
/* harmony export (immutable) */ __webpack_exports__["s"] = newContractorSuccess;
/* harmony export (immutable) */ __webpack_exports__["y"] = updateCurrentWorkOrderAttribute;
/* harmony export (immutable) */ __webpack_exports__["C"] = updateWorkOrder;
/* harmony export (immutable) */ __webpack_exports__["D"] = updateWorkOrderAttribute;
/* harmony export (immutable) */ __webpack_exports__["o"] = loadUnionTradesSuccess;
/* harmony export (immutable) */ __webpack_exports__["p"] = loadWorkOrderSummarySuccess;
/* harmony export (immutable) */ __webpack_exports__["v"] = searchTextChange;
/* harmony export (immutable) */ __webpack_exports__["z"] = updateTask;
/* harmony export (immutable) */ __webpack_exports__["A"] = updateTaskChecklist;
/* harmony export (immutable) */ __webpack_exports__["B"] = updateTaskSuccess;
/* harmony export (immutable) */ __webpack_exports__["r"] = markCurrentWorkOrderAsComplete;
/* harmony export (immutable) */ __webpack_exports__["a"] = addBuildingToBeginning;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_trades_api__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__creation_sub_contractors_union_trades__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_action_types__ = __webpack_require__(22);
var baseRoutePath='/admin/work-orders';function addWorkOrder(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_182" /* WORK_ORDERS_WO_ADD */]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__creation_sub_contractors_union_trades__["m" /* setNewWOProcessStarted */])(true));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["d" /* push */])(baseRoutePath+'/new-work-order'));};}// export function getWorkOrdersByJobNumber(value) {
//   return dispatch => {
//     return workOrdersApi.getWorkOrdersByJobNumber(value)
//       .then(response => {
//         if (response.ok) {
//           dispatch(loadWorkOrdersSuccess(response.workOrders));
//           dispatch(searchTextChange(''));
//
//         } else {
//           dispatch(showErrorMessage(response.errors));
//         }
//       });
//   }
// }
function goToWorkOrder(workOrderId,workOrderStatus){return function(dispatch){if(workOrderStatus!==undefined&&__WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].DRAFT.equals(__WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(workOrderStatus))){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["d" /* push */])(baseRoutePath+'/work-order-summary'));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__details_details__["_0" /* selectTaskSuccess */])(null));// unselect task if necessary
dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["d" /* push */])(baseRoutePath+'/'+workOrderId));}};}function goHistoryBack(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["c" /* goBack */])());};}function cancelWorkOrderRequest(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["a" /* default */].deleteWorkOrder(workOrderId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["d" /* push */])(baseRoutePath));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function changePage(newPage){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_172" /* WORK_ORDERS_PAGE_CHANGE */],payload:newPage};}function changeInvoicesTab(newTab){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_167" /* WORK_ORDERS_INVOICES_TAB_CHANGE */],payload:newTab};}function removeTask(id){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_177" /* WORK_ORDERS_TASK_REMOVE */],payload:id};}function removeTaskFromSummary(id){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_175" /* WORK_ORDERS_SUMMARY_TASK_REMOVE */],payload:id};}function loadWorkOrdersRequest(criteria){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["b" /* workOrdersApi */].getWorkOrders(criteria).then(function(response){if(response.ok){dispatch(loadWorkOrdersSuccess(response.workOrders));dispatch(changePage(criteria.page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadWorkOrdersSuccess(workOrders){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_170" /* WORK_ORDERS_LOAD_SUCCESS */],payload:workOrders};}function selectWorkOrderRequest(workOrderId,status){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_work_orders_api__["a" /* default */].getWorkOrder(workOrderId).then(function(response){if(response.ok){dispatch(selectWorkOrderSuccess(response.workOrder));dispatch(goToWorkOrder(workOrderId,status));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function selectWorkOrderSuccess(workOrder){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_185" /* WORK_ORDERS_WO_SELECT_SUCCESS */],payload:workOrder};}function loadTasksFromWorkOrderSuccess(tasks){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_184" /* WORK_ORDERS_WO_LOAD_TASKS_SUCCESS */],payload:tasks};}function loadBuildingSuccess(buildings){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["i" /* WORK_ORDERS_CREATION_LOAD_BUILDINGS_SUCCESS */],payload:buildings};}function createWorkOrderSuccess(newWorkOrder){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_181" /* WORK_ORDERS_WORK_ORDER_CREATION_SUCCESS */],payload:newWorkOrder};}function loadTradesSuccess(trades){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_171" /* WORK_ORDERS_LOAD_TRADES_SUCCESS */],payload:trades};}function loadSubTradesRequest(tradeId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_trades_api__["a" /* default */].getSubTrades(tradeId).then(function(response){if(response.ok){dispatch(loadSubTradesSuccess(tradeId,response.subTrades));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadSubTradesSuccess(tradeId,subTrades){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_169" /* WORK_ORDERS_LOAD_SUB_TRADES_SUCCESS */],payload:{tradeId:tradeId,subTrades:subTrades}};}function loadContractorsSuccess(contractors){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_168" /* WORK_ORDERS_LOAD_CONTRACTORS_SUCCESS */],payload:contractors};}function newContractorSuccess(newContractor){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["b" /* WORK_ORDERS_CONTRACTOR_NEW_SUCCESS */],payload:newContractor};}function updateCurrentWorkOrderAttribute(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_0" /* WORK_ORDERS_CURRENT_WO_ATTRIBUTE_UPDATE */],payload:{attribute:attribute,value:value}};}function updateWorkOrder(workOrder){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_186" /* WORK_ORDERS_WO_UPDATE */],payload:workOrder};}function updateWorkOrderAttribute(workOrder,attribute){return{type:__WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_action_types__["_183" /* WORK_ORDERS_WO_ATTRIBUTE_UPDATE */],payload:{workOrder:workOrder,attribute:attribute}};}function loadUnionTradesSuccess(unionTrades){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_180" /* WORK_ORDERS_UNION_TRADES_LOAD_SUCCESS */],payload:unionTrades};}function loadWorkOrderSummarySuccess(summary){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_174" /* WORK_ORDERS_SUMMARY_LOAD_SUCCESS */],payload:summary};}function searchTextChange(value){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_173" /* WORK_ORDERS_SEARCH_TEXT_CHANGE */],payload:value};}function updateTask(task){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_178" /* WORK_ORDERS_TASK_UPDATE */],payload:task};}function updateTaskChecklist(taskId,taskChecklist){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_176" /* WORK_ORDERS_TASK_CHECKLIST_UPDATE */],payload:{taskId:taskId,taskChecklist:taskChecklist}};}function updateTaskSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_179" /* WORK_ORDERS_TASK_UPDATE_SUCCESS */]};}function markCurrentWorkOrderAsComplete(){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["_1" /* WORK_ORDERS_CURRENT_WO_COMPLETE */],payload:'complete'};}function addBuildingToBeginning(building){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["a" /* WORK_ORDERS_ADD_BUILDING_TO_BEGINNING */],payload:building};}

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBudget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getContractorInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getContractorLienRelease; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getContractorLienReleases; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCurrentTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getEditTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getMembers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getNavigationBarSelectedItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getProposals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getQuotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getQuotesSelectedByTaskId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getQuotesTableSelectedFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getSelectedOpenItemId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getSelectedQuoteId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getTaskNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getOpenItemsByTaskId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getPreExistingConditions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getPreExistingConditionsDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getShowClientStreamModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getWorkOrderJobNumberEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getWorkOrderJobNumberSaving; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getWorkOrderJobNumberValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getWorkOrderNameEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getWorkOrderNameSaving; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getWorkOrderNameValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getWorkOrderNoteEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getWorkOrderNoteSaving; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getWorkOrderNoteValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getWorkOrderNoteReminderValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getWorkOrderNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getSelectedTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getSelectAllChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getWoaSigningUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getShowWoaSigningModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getWorkOrderAuthorizations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getBudget=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.data.budget;},function(budget){return budget;});var getContractorInvoice=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.data.contractorInvoice;},function(contractorInvoice){return contractorInvoice;});var getContractorLienRelease=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.data.contractorLienRelease;},function(contractorLienRelease){return contractorLienRelease;});var getContractorLienReleases=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.data.contractorLienReleases;},function(contractorLienReleases){return contractorLienReleases;});var getCurrentTask=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.data.currentTask;},function(currentTask){return currentTask;});var getEditTask=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.editTask;},function(editTask){return editTask;});var getMembers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.data.members;},function(members){return members;});var getNavigationBarSelectedItem=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.navigationBarSelectedItem;},function(navigationBarSelectedItem){return navigationBarSelectedItem;});var getProposals=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.data.proposals;},function(proposals){return proposals;});var getQuotes=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.data.quotes;},function(quotes){return quotes;});var getQuotesSelectedByTaskId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.data.quotesSelectedByTaskId;},function(quotesSelectedByTaskId){return quotesSelectedByTaskId;});var getQuotesTableSelectedFilter=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.quotesTableSelectedFilter;},function(quotesTableSelectedFilter){return quotesTableSelectedFilter;});var getSelectedOpenItemId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.selectedOpenItemId;},function(selectedOpenItemId){return selectedOpenItemId;});var getSelectedQuoteId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.data.selectedQuoteId;},function(selectedQuoteId){return selectedQuoteId;});var getTaskNotes=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.data.taskNotes;},function(taskNotes){return taskNotes;});var getOpenItemsByTaskId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.data.openItemsByTaskId;},function(openItemsByTaskId){return openItemsByTaskId;});var getPreExistingConditions=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.preExistingConditions;},function(preExistingConditions){return preExistingConditions;});var getPreExistingConditionsDescription=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.preExistingConditionsDescription;},function(preExistingConditionsDescription){return preExistingConditionsDescription;});var getShowClientStreamModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.showClientStreamModal;},function(showClientStreamModal){return showClientStreamModal;});var getWorkOrderJobNumberEdit=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.workOrderJobNumberEdit;},function(workOrderJobNumberEdit){return workOrderJobNumberEdit;});var getWorkOrderJobNumberSaving=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.workOrderJobNumberSaving;},function(workOrderJobNumberSaving){return workOrderJobNumberSaving;});var getWorkOrderJobNumberValue=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.workOrderJobNumberValue;},function(workOrderJobNumberValue){return workOrderJobNumberValue;});var getWorkOrderNameEdit=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.workOrderNameEdit;},function(workOrderNameEdit){return workOrderNameEdit;});var getWorkOrderNameSaving=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.workOrderNameSaving;},function(workOrderNameSaving){return workOrderNameSaving;});var getWorkOrderNameValue=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.workOrderNameValue;},function(workOrderNameValue){return workOrderNameValue;});var getWorkOrderNoteEdit=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.workOrderNoteEdit;},function(workOrderNoteEdit){return workOrderNoteEdit;});var getWorkOrderNoteSaving=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.workOrderNoteSaving;},function(workOrderNoteSaving){return workOrderNoteSaving;});var getWorkOrderNoteValue=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.workOrderNoteValue;},function(workOrderNoteValue){return workOrderNoteValue;});var getWorkOrderNoteReminderValue=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.workOrderNoteReminderValue;},function(workOrderNoteReminderValue){return workOrderNoteReminderValue;});var getWorkOrderNotes=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.data.workOrderNotes;},function(workOrderNotes){return workOrderNotes;});var getSelectedTasks=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.selectedTasks;},function(selectedTasks){return selectedTasks;});var getSelectAllChecked=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.selectAllChecked;},function(selectAllChecked){return selectAllChecked;});var getWoaSigningUrl=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.woaSigningUrl;},function(woaSigningUrl){return woaSigningUrl;});var getShowWoaSigningModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.ui.showWoaSigningModal;},function(showWoaSigningModal){return showWoaSigningModal;});var getWorkOrderAuthorizations=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.data.workOrderAuthorizations;},function(workOrderAuthorizations){return workOrderAuthorizations;});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = simpleScrollTo;
/* harmony export (immutable) */ __webpack_exports__["c"] = simpleScrollToTop;
/* harmony export (immutable) */ __webpack_exports__["a"] = containerScrollToTop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_scroll__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_scroll__);
var containerId='admin-col-item-container';// defined in Admin.js
/**
 * Helper function around react-scroll scrollTo method (with default values related to the app design)
 * @param element
 */function simpleScrollTo(element){__WEBPACK_IMPORTED_MODULE_0_react_scroll__["scroller"].scrollTo(element,{containerId:containerId,delay:50,offset:-70,smooth:true});}function simpleScrollToTop(){containerScrollToTop(containerId);}function containerScrollToTop(id){__WEBPACK_IMPORTED_MODULE_0_react_scroll__["animateScroll"].scrollToTop({containerId:id,delay:0,duration:0});}

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dropdown_css__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select_dist_react_select_css__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__arrow_png__ = __webpack_require__(1867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__input_ReadOnlyInput__ = __webpack_require__(313);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Dropdown=function(_Component){_inherits(Dropdown,_Component);function Dropdown(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Dropdown);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Dropdown.__proto__||Object.getPrototypeOf(Dropdown)).call.apply(_ref,[this].concat(args))),_this),_this.handleOnChange=function(newOption){if(_this.props.onChange!==undefined){_this.props.onChange(newOption);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Dropdown,[{key:'getLabelFromValue',value:function getLabelFromValue(){var _this2=this;var element=this.props.options.find(function(element){return element.value===_this2.props.value;});return element!==undefined?element.label:'';}},{key:'render',value:function render(){return this.props.readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__input_ReadOnlyInput__["a" /* default */],{'class':this.props.className!==undefined?' '+this.props.className:'',placeholder:this.props.placeholder,theme:this.props.theme,value:this.getLabelFromValue()}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown'+(this.props.className!==undefined?' '+this.props.className:'')+(this.props.valid!==undefined&&!this.props.valid?' invalid':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["default"],{arrowRenderer:function arrowRenderer(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__arrow_png___default.a,alt:'arrow'});},clearable:this.props.clearable,disabled:this.props.disabled,options:this.props.options.map(function(element){return{value:element.value,label:element.label};}),placeholder:this.props.placeholder,value:this.props.value,searchable:false,onChange:this.handleOnChange}));}}]);return Dropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Dropdown.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,clearable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})).isRequired,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,theme:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,valid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})]),onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};Dropdown.defaultProps={clearable:false,valid:true};/* harmony default export */ __webpack_exports__["a"] = (Dropdown);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getRange;
/* harmony export (immutable) */ __webpack_exports__["b"] = countdown;
/* harmony export (immutable) */ __webpack_exports__["c"] = getFirstDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = getLastDate;
/* harmony export (immutable) */ __webpack_exports__["k"] = todayValidation;
/* harmony export (immutable) */ __webpack_exports__["i"] = sameOrBeforeDateValidation;
/* harmony export (immutable) */ __webpack_exports__["h"] = sameOrAfterDateValidation;
/* harmony export (immutable) */ __webpack_exports__["a"] = beforeTodayValidation;
/* harmony export (immutable) */ __webpack_exports__["j"] = sameOrBeforeTodayValidation;
/* harmony export (immutable) */ __webpack_exports__["f"] = nextDay;
/* harmony export (immutable) */ __webpack_exports__["g"] = prevDay;
/* harmony export (immutable) */ __webpack_exports__["l"] = utcTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_precise_range_plugin__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_precise_range_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_precise_range_plugin__);
/**
 * Get difference between two dates.
 * Dates should be defined in a ISO 8601 format.
 *
 * @param from - From Date
 * @param to - To Date. Optional, if not specified, today is used.
 * @return {{years : number, months : number, days : number, hours : number, minutes : number}}
 */function getRange(from){var to=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var toMoment=void 0;if(to!==null){toMoment=__WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(to);}else{toMoment=__WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc();}var fromMoment=__WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(from);var result=__WEBPACK_IMPORTED_MODULE_0_moment___default.a.preciseDiff(fromMoment,toMoment,true);delete result.firstDateWasLater;delete result.seconds;return result;}function countdown(from){var to=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var elapsedTime=getRange(from,to);var values=[];var label='';if(elapsedTime.years>0){label=elapsedTime.years>1?'years':'year';values.push(elapsedTime.years+' '+label);}if(elapsedTime.months>0){label=elapsedTime.months>1?'months':'month';values.push(elapsedTime.months+' '+label);}// Only show two attributes from the range value
if(elapsedTime.days>0&&values.length<2){label=elapsedTime.days>1?'days':'day';values.push(elapsedTime.days+' '+label);}if(elapsedTime.hours>0&&values.length<2){label=elapsedTime.hours>1?'hours':'hour';values.push(elapsedTime.hours+' '+label);}if(elapsedTime.minutes>0&&values.length<2){label=elapsedTime.minutes>1?'minutes':'minute';values.push(elapsedTime.minutes+' '+label);}return values.join(', ');}/**
 * Get first date form array of dates. Dates should be defined in a ISO 8601 format.
 * @param arrayOfDates
 * @return {string} Date as YYYY-MM-DD format or null if array is empty
 */function getFirstDate(arrayOfDates){var min=null;if(arrayOfDates===undefined||arrayOfDates===null||arrayOfDates.length===0){return min;}arrayOfDates.forEach(function(date){var dateMoment=__WEBPACK_IMPORTED_MODULE_0_moment___default()(date);if(min===null||min.isAfter(dateMoment)){min=dateMoment;}});return min.format('YYYY-MM-DD');}/**
 * Get last date form array of dates. Dates should be defined in a ISO 8601 format.
 * @param arrayOfDates
 * @return {string} Date as YYYY-MM-DD format or null if array is empty
 */function getLastDate(arrayOfDates){var max=null;if(arrayOfDates===undefined||arrayOfDates===null||arrayOfDates.length===0){return max;}arrayOfDates.forEach(function(date){var dateMoment=__WEBPACK_IMPORTED_MODULE_0_moment___default()(date);if(max===null||max.isBefore(dateMoment)){max=dateMoment;}});return max.format('YYYY-MM-DD');}var yesterday=__WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(1,'day');/**
 * Validate a date against yesterday. To be used to validate dates in DatetimePicker component.
 * @param date
 * @return {*|boolean}
 */function todayValidation(date){return date.isAfter(yesterday);}/**
 * Validates if a date is same or before maxDate. To be used to validate dates in DatetimePicker component.
 * @param date
 * @param maxDate
 * @return {*|boolean}
 */function sameOrBeforeDateValidation(date,maxDate){return maxDate?date.isSameOrBefore(__WEBPACK_IMPORTED_MODULE_0_moment___default()(maxDate)):true;}/**
 * Validates if a date is same or after minDate. To be used to validate dates in DatetimePicker component.
 * @param date
 * @param minDate
 * @return {*|boolean}
 */function sameOrAfterDateValidation(date,minDate){return minDate?date.isSameOrAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default()(minDate)):true;}/**
 * Validate a date is before today. To be used to validate dates in DatetimePicker component.
 * @param date
 * @return {*|boolean}
 */function beforeTodayValidation(date){return date.isBefore(__WEBPACK_IMPORTED_MODULE_0_moment___default()());}function sameOrBeforeTodayValidation(date){return date.isSameOrBefore(__WEBPACK_IMPORTED_MODULE_0_moment___default()());}/**
 * Get the next date of a given day (from 0 to 6). Eg. The next Tuesday is nextDay(2)
 * @param day
 * @return {string} Date as YYYY-MM-DD format or null if array is empty
 */function nextDay(day){var today=__WEBPACK_IMPORTED_MODULE_0_moment___default()().isoWeekday();var nextD=null;if(today<=day){nextD=__WEBPACK_IMPORTED_MODULE_0_moment___default()().isoWeekday(day);}else{nextD=__WEBPACK_IMPORTED_MODULE_0_moment___default()().add(1,'weeks').isoWeekday(day);}return nextD.format('YYYY-MM-DD');}/**
 * Get the previous date of a given day (from 0 to 6). Eg. The previous Tuesday is prevDay(2)
 * @param day
 * @return {string} Date as YYYY-MM-DD format or null if array is empty
 */function prevDay(day){var today=__WEBPACK_IMPORTED_MODULE_0_moment___default()().isoWeekday();var prevD=null;if(today>=day){prevD=__WEBPACK_IMPORTED_MODULE_0_moment___default()().isoWeekday(day);}else{prevD=__WEBPACK_IMPORTED_MODULE_0_moment___default()().add(-1,'weeks').isoWeekday(day);}return prevD.format('YYYY-MM-DD');}function utcTime(datetime){return datetime&&__WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(datetime,'YYYY-MM-DD hh:mm A').format('hh:mm A');}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Enterprise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Enterprise=function(){function Enterprise(){_classCallCheck(this,Enterprise);}_createClass(Enterprise,null,[{key:'showActions',value:function showActions(user){return __WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].isAdmin(user)||__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].hasType(user,__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);}},{key:'showMyProjects',value:function showMyProjects(user){return __WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].hasType(user,__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR)&&!__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].hasRole(user,'field_ops_manager')&&!__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].hasRole(user,'project_executive');}},{key:'spackle',value:function spackle(contribType){return contribType==='Spackle';}},{key:'generalContractor',value:function generalContractor(contribType){return contribType==='GeneralContractor';}},{key:'primary',value:function primary(contribType){return contribType==='Primary';}},{key:'subcontractor',value:function subcontractor(contribType){return contribType==='Subcontractor';}},{key:'spackleOrGc',value:function spackleOrGc(contribType){return contribType==='Spackle'||contribType==='GeneralContractor';}}]);return Enterprise;}();

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__splice__ = __webpack_require__(1982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getIn__ = __webpack_require__(1983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setIn__ = __webpack_require__(2008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deepEqual__ = __webpack_require__(2009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__deleteIn__ = __webpack_require__(2042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keys__ = __webpack_require__(2043);








var structure = {
  allowsArrayErrors: true,
  empty: {},
  emptyList: [],
  getIn: __WEBPACK_IMPORTED_MODULE_1__getIn__["a" /* default */],
  setIn: __WEBPACK_IMPORTED_MODULE_2__setIn__["a" /* default */],
  deepEqual: __WEBPACK_IMPORTED_MODULE_3__deepEqual__["a" /* default */],
  deleteIn: __WEBPACK_IMPORTED_MODULE_4__deleteIn__["a" /* default */],
  forEach: function forEach(items, callback) {
    return items.forEach(callback);
  },
  fromJS: function fromJS(value) {
    return value;
  },
  keys: __WEBPACK_IMPORTED_MODULE_5__keys__["a" /* default */],
  size: function size(array) {
    return array ? array.length : 0;
  },
  some: function some(items, callback) {
    return items.some(callback);
  },
  splice: __WEBPACK_IMPORTED_MODULE_0__splice__["a" /* default */],
  toJS: function toJS(value) {
    return value;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (structure);

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__ = __webpack_require__(1311);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__(1312);
/* unused harmony reexport getLocation */
/* unused harmony reexport createMatchSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(747);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__reducer__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(748);
/* unused harmony reexport CALL_HISTORY_METHOD */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__actions__["c"]; });
/* unused harmony reexport replace */
/* unused harmony reexport go */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__actions__["b"]; });
/* unused harmony reexport goForward */
/* unused harmony reexport routerActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middleware__ = __webpack_require__(1313);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__middleware__["a"]; });









/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RouteTitle_css__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RouteTitle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RouteTitle_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RouteTitle=function(_Component){_inherits(RouteTitle,_Component);function RouteTitle(){_classCallCheck(this,RouteTitle);return _possibleConstructorReturn(this,(RouteTitle.__proto__||Object.getPrototypeOf(RouteTitle)).apply(this,arguments));}_createClass(RouteTitle,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'route-title'},this.props.titles.map(function(label,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:index,className:'subtitle-'+(index+1)},index>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle-slash'},'/'):null,label);}));}}]);return RouteTitle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RouteTitle.propTypes={titles:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired};/* harmony default export */ __webpack_exports__["a"] = (RouteTitle);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DocumentLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocumentLink_css__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocumentLink_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DocumentLink_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_react_fontawesome__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_regular_faFilePdf__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_regular_faFilePdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_regular_faFilePdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome_free_regular_faFileWord__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome_free_regular_faFileWord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome_free_regular_faFileWord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_regular_faFileExcel__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_regular_faFileExcel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_regular_faFileExcel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_regular_faFileImage__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_regular_faFileImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_regular_faFileImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_text_util__ = __webpack_require__(29);
function DocumentLink(props){var getName=function getName(props){var result='Unknown';if(props.url!==null){var name=Object(__WEBPACK_IMPORTED_MODULE_8_services_utils_text_util__["d" /* getLastTokenFromUrl */])(props.url);if(name!==null){result=name;}}else if(props.file!==null){result=props.file.name;}return result;};var getIcon=function getIcon(props){var icon=void 0;var fileName='';if(props.url!==null){var tokens=props.url.split('/');if(tokens.length>0){fileName=tokens[tokens.length-1];}}else if(props.file!==null){fileName=props.file.name;}var fileNameTokes=fileName.split('.');var extension=null;if(fileNameTokes.length>0){extension=fileNameTokes[fileNameTokes.length-1].toLowerCase();}switch(extension){case'pdf':icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__fortawesome_react_fontawesome__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_regular_faFilePdf___default.a,style:{color:'#ff0000'}});break;case'doc':case'docx':icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__fortawesome_react_fontawesome__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome_free_regular_faFileWord___default.a,style:{color:'#0051ff'}});break;case'xls':case'xlsx':icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__fortawesome_react_fontawesome__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_regular_faFileExcel___default.a,style:{color:'#00bd09'}});break;case'jpeg':case'jpg':case'png':case'dwg':icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__fortawesome_react_fontawesome__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_regular_faFileImage___default.a,style:{color:'#eb7d34'}});break;default:icon=null;break;}return icon;};var getUrl=function getUrl(props){if(props.url!==null){return props.url;}else if(props.file!==null&&props.file.hasOwnProperty('preview')){return props.file.preview;}else{return null;}};var handleClick=function handleClick(props,event){event.stopPropagation();// to use inside SimpleTable (which prevents defaults on tr clicks)
props.onClick&&props.onClick(event);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'document-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:!props.showLink?'not-active':null,href:getUrl(props),target:'_blank',onClick:function onClick(event){return handleClick(props,event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,getName(props)))),props.showIcon&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,getIcon(props)));}DocumentLink.propTypes={file:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,showIcon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showLink:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};DocumentLink.defaultProps={file:null,showIcon:true,showLink:true,url:null,onClick:null};

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DatetimePicker_css__ = __webpack_require__(1869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DatetimePicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DatetimePicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_datetime__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datetime_css_react_datetime_css__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datetime_css_react_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_datetime_css_react_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__input_ReadOnlyInput__ = __webpack_require__(313);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DatetimePicker=function(_Component){_inherits(DatetimePicker,_Component);function DatetimePicker(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DatetimePicker);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DatetimePicker.__proto__||Object.getPrototypeOf(DatetimePicker)).call.apply(_ref,[this].concat(args))),_this),_this.handleOnChange=function(valueMoment){_this.props.onChange(valueMoment.format('YYYY-MM-DD'));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DatetimePicker,[{key:'render',value:function render(){var _this2=this;return this.props.readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__input_ReadOnlyInput__["a" /* default */],{'class':this.props.className!==undefined?' '+this.props.className:'',placeholder:this.props.placeholder,theme:this.props.theme,value:this.props.value!==null?__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.props.value).format(this.props.format):''}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'datetime-picker'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_datetime___default.a,{closeOnSelect:true,dateFormat:this.props.format,inputProps:{className:'form-control input'+(this.props.required?' required':'')+(!this.props.valid?' invalid':''),placeholder:this.props.placeholder,readOnly:true},isValidDate:this.props.isValidDate,value:this.props.value!==null?__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.props.value):null,timeFormat:false,onChange:function onChange(value){return _this2.handleOnChange(value);}}));}}]);return DatetimePicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DatetimePicker.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,format:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isValidDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,required:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,theme:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,valid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,// ISO 8601 format, yyyy-mm-dd
onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};DatetimePicker.defaultProps={format:'LL',isValidDate:null,valid:true,value:null};/* harmony default export */ __webpack_exports__["a"] = (DatetimePicker);

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavigationBar_css__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavigationBar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NavigationBar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigationItem__ = __webpack_require__(1384);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationBar=function(_Component){_inherits(NavigationBar,_Component);function NavigationBar(props){_classCallCheck(this,NavigationBar);// The items will not change during the execution, so it's ok to set the state based on props in the constructor
var _this=_possibleConstructorReturn(this,(NavigationBar.__proto__||Object.getPrototypeOf(NavigationBar)).call(this,props));_this.handleItemSelect=function(value){_this.setState({idSelected:value});_this.props.onSelected(value);};_this.state={idSelected:props.selectedValue||(props.items.length>0?props.items[0].id:0)};return _this;}_createClass(NavigationBar,[{key:'UNSAFE_componentWillReceiveProps',value:function UNSAFE_componentWillReceiveProps(newProps){if(newProps.selectedValue&&newProps.selectedValue!==this.state.idSelected){this.setState({idSelected:newProps.selectedValue});}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navigation-bar'},this.props.items.filter(function(element){return element.show===undefined||element.show;}).map(function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__NavigationItem__["a" /* default */],{key:element.id,id:element.id,title:element.title,total:element.total,selected:element.id===_this2.state.idSelected,itemClass:element.class,onSelected:_this2.handleItemSelect});}));}}]);return NavigationBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NavigationBar.propTypes={items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),total:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),class:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})).isRequired,selectedValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,onSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (NavigationBar);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(1136);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(1138);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(673);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(1139);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(1140);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(1142);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(1143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(675);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(465);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(1144);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(1145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(1146);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(1147);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(1148);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIs = __webpack_require__(295);

var _createChainableTypeChecker = __webpack_require__(352);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
  }

  if (!(0, _reactIs.isValidElementType)(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSceneReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(197);
/**
 * Create a reducer for a scene.
 * @param dataReducer
 * @param uiReducer
 * @param scenes
 * @return {Reducer<any>}
 */function createSceneReducer(dataReducer,uiReducer,scenes){var reducers={};if(dataReducer){reducers['data']=dataReducer;}if(uiReducer){reducers['ui']=uiReducer;}if(scenes){reducers['scenes']=scenes;}return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])(reducers);}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(289)('wks');
var uid = __webpack_require__(209);
var Symbol = __webpack_require__(41).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(136);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(43)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(1117);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles__ = __webpack_require__(1657);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint prefer-template: 0 */






var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);

  function Dropzone(props, context) {
    _classCallCheck(this, Dropzone);

    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));

    _this.renderChildren = function (children, isDragActive, isDragAccept, isDragReject) {
      if (typeof children === 'function') {
        return children(_extends({}, _this.state, {
          isDragActive: isDragActive,
          isDragAccept: isDragAccept,
          isDragReject: isDragReject
        }));
      }
      return children;
    };

    _this.composeHandlers = _this.composeHandlers.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDragOver = _this.onDragOver.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
    _this.onInputElementClick = _this.onInputElementClick.bind(_this);

    _this.setRef = _this.setRef.bind(_this);
    _this.setRefs = _this.setRefs.bind(_this);

    _this.isFileDialogActive = false;

    _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };
    return _this;
  }

  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      this.dragTargets = [];

      if (preventDropOnDocument) {
        document.addEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */], false);
        document.addEventListener('drop', this.onDocumentDrop, false);
      }
      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
      window.addEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      if (preventDropOnDocument) {
        document.removeEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */]);
        document.removeEventListener('drop', this.onDocumentDrop);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
      }
      window.removeEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'composeHandlers',
    value: function composeHandlers(handler) {
      if (this.props.disabled) {
        return null;
      }

      return handler;
    }
  }, {
    key: 'onDocumentDrop',
    value: function onDocumentDrop(evt) {
      if (this.node && this.node.contains(evt.target)) {
        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }
      evt.preventDefault();
      this.dragTargets = [];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(evt) {
      if (this.props.onDragStart) {
        this.props.onDragStart.call(this, evt);
      }
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(evt) {
      var _this2 = this;

      evt.preventDefault();

      // Count the dropzone and any children that are entered.
      if (this.dragTargets.indexOf(evt.target) === -1) {
        this.dragTargets.push(evt.target);
      }

      Promise.resolve(this.props.getDataTransferItems(evt)).then(function (draggedFiles) {
        _this2.setState({
          isDragActive: true, // Do not rely on files for the drag state. It doesn't work in Safari.
          draggedFiles: draggedFiles
        });
      });
      if (this.props.onDragEnter) {
        this.props.onDragEnter.call(this, evt);
      }
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(evt) {
      // eslint-disable-line class-methods-use-this
      evt.preventDefault();
      evt.stopPropagation();
      try {
        // The file dialog on Chrome allows users to drag files from the dialog onto
        // the dropzone, causing the browser the crash when the file dialog is closed.
        // A drop effect of 'none' prevents the file from being dropped
        evt.dataTransfer.dropEffect = this.isFileDialogActive ? 'none' : 'copy'; // eslint-disable-line no-param-reassign
      } catch (err) {
        // continue regardless of error
      }

      if (this.props.onDragOver) {
        this.props.onDragOver.call(this, evt);
      }
      return false;
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(evt) {
      var _this3 = this;

      evt.preventDefault();

      // Only deactivate once the dropzone and all children have been left.
      this.dragTargets = this.dragTargets.filter(function (el) {
        return el !== evt.target && _this3.node.contains(el);
      });
      if (this.dragTargets.length > 0) {
        return;
      }

      // Clear dragging files state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (this.props.onDragLeave) {
        this.props.onDragLeave.call(this, evt);
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(evt) {
      var _this4 = this;

      var _props = this.props,
          onDrop = _props.onDrop,
          onDropAccepted = _props.onDropAccepted,
          onDropRejected = _props.onDropRejected,
          multiple = _props.multiple,
          disablePreview = _props.disablePreview,
          accept = _props.accept,
          getDataTransferItems = _props.getDataTransferItems;

      // Stop default browser behavior

      evt.preventDefault();

      // Reset the counter along with the drag on a drop.
      this.dragTargets = [];
      this.isFileDialogActive = false;

      // Clear files value
      this.draggedFiles = null;

      // Reset drag state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      Promise.resolve(getDataTransferItems(evt)).then(function (fileList) {
        var acceptedFiles = [];
        var rejectedFiles = [];

        fileList.forEach(function (file) {
          if (!disablePreview) {
            try {
              file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
            } catch (err) {
              if (false) {
                console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
              }
            }
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* fileAccepted */])(file, accept) && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* fileMatchSize */])(file, _this4.props.maxSize, _this4.props.minSize)) {
            acceptedFiles.push(file);
          } else {
            rejectedFiles.push(file);
          }
        });

        if (!multiple) {
          // if not in multi mode add any extra accepted files to rejected.
          // This will allow end users to easily ignore a multi file drop in "single" mode.
          rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
        }

        if (onDrop) {
          onDrop.call(_this4, acceptedFiles, rejectedFiles, evt);
        }

        if (rejectedFiles.length > 0 && onDropRejected) {
          onDropRejected.call(_this4, rejectedFiles, evt);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted.call(_this4, acceptedFiles, evt);
        }
      });
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      var _props2 = this.props,
          onClick = _props2.onClick,
          disableClick = _props2.disableClick;

      if (!disableClick) {
        evt.stopPropagation();

        if (onClick) {
          onClick.call(this, evt);
        }

        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
        // this is so react can handle state changes in the onClick prop above above
        // see: https://github.com/react-dropzone/react-dropzone/issues/450
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* isIeOrEdge */])()) {
          setTimeout(this.open.bind(this), 0);
        } else {
          this.open();
        }
      }
    }
  }, {
    key: 'onInputElementClick',
    value: function onInputElementClick(evt) {
      evt.stopPropagation();
      if (this.props.inputProps && this.props.inputProps.onClick) {
        this.props.inputProps.onClick();
      }
    }
  }, {
    key: 'onFileDialogCancel',
    value: function onFileDialogCancel() {
      var _this5 = this;

      // timeout will not recognize context of this method
      var onFileDialogCancel = this.props.onFileDialogCancel;
      // execute the timeout only if the FileDialog is opened in the browser

      if (this.isFileDialogActive) {
        setTimeout(function () {
          if (_this5.fileInputEl != null) {
            // Returns an object as FileList
            var files = _this5.fileInputEl.files;


            if (!files.length) {
              _this5.isFileDialogActive = false;
            }
          }

          if (typeof onFileDialogCancel === 'function') {
            onFileDialogCancel();
          }
        }, 300);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.node = ref;
    }
  }, {
    key: 'setRefs',
    value: function setRefs(ref) {
      this.fileInputEl = ref;
    }
    /**
     * Open system file upload dialog.
     *
     * @public
     */

  }, {
    key: 'open',
    value: function open() {
      this.isFileDialogActive = true;
      this.fileInputEl.value = null;
      this.fileInputEl.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          accept = _props3.accept,
          acceptClassName = _props3.acceptClassName,
          activeClassName = _props3.activeClassName,
          children = _props3.children,
          disabled = _props3.disabled,
          disabledClassName = _props3.disabledClassName,
          inputProps = _props3.inputProps,
          multiple = _props3.multiple,
          name = _props3.name,
          rejectClassName = _props3.rejectClassName,
          rest = _objectWithoutProperties(_props3, ['accept', 'acceptClassName', 'activeClassName', 'children', 'disabled', 'disabledClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);

      var acceptStyle = rest.acceptStyle,
          activeStyle = rest.activeStyle,
          _rest$className = rest.className,
          className = _rest$className === undefined ? '' : _rest$className,
          disabledStyle = rest.disabledStyle,
          rejectStyle = rest.rejectStyle,
          style = rest.style,
          props = _objectWithoutProperties(rest, ['acceptStyle', 'activeStyle', 'className', 'disabledStyle', 'rejectStyle', 'style']);

      var _state = this.state,
          isDragActive = _state.isDragActive,
          draggedFiles = _state.draggedFiles;

      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* allFilesAccepted */])(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
      var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;

      if (isDragActive && activeClassName) {
        className += ' ' + activeClassName;
      }
      if (isDragAccept && acceptClassName) {
        className += ' ' + acceptClassName;
      }
      if (isDragReject && rejectClassName) {
        className += ' ' + rejectClassName;
      }
      if (disabled && disabledClassName) {
        className += ' ' + disabledClassName;
      }

      if (noStyles) {
        style = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].default;
        activeStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        acceptStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        rejectStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].rejected;
        disabledStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].disabled;
      }

      var appliedStyle = _extends({ position: 'relative' }, style);
      if (activeStyle && isDragActive) {
        appliedStyle = _extends({}, appliedStyle, activeStyle);
      }
      if (acceptStyle && isDragAccept) {
        appliedStyle = _extends({}, appliedStyle, acceptStyle);
      }
      if (rejectStyle && isDragReject) {
        appliedStyle = _extends({}, appliedStyle, rejectStyle);
      }
      if (disabledStyle && disabled) {
        appliedStyle = _extends({}, appliedStyle, disabledStyle);
      }

      var inputAttributes = {
        accept: accept,
        disabled: disabled,
        type: 'file',
        style: _extends({
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          opacity: 0.00001,
          pointerEvents: 'none'
        }, inputProps.style),
        multiple: __WEBPACK_IMPORTED_MODULE_2__utils__["g" /* supportMultiple */] && multiple,
        ref: this.setRefs,
        onChange: this.onDrop,
        autoComplete: 'off'
      };

      if (name && name.length) {
        inputAttributes.name = name;
      }

      // Destructure custom props away from props used for the div element

      var acceptedFiles = props.acceptedFiles,
          preventDropOnDocument = props.preventDropOnDocument,
          disablePreview = props.disablePreview,
          disableClick = props.disableClick,
          onDropAccepted = props.onDropAccepted,
          onDropRejected = props.onDropRejected,
          onFileDialogCancel = props.onFileDialogCancel,
          maxSize = props.maxSize,
          minSize = props.minSize,
          getDataTransferItems = props.getDataTransferItems,
          divProps = _objectWithoutProperties(props, ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize', 'getDataTransferItems']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: className,
          style: appliedStyle
        }, divProps /* expand user provided props first so event handlers are never overridden */, {
          onClick: this.composeHandlers(this.onClick),
          onDragStart: this.composeHandlers(this.onDragStart),
          onDragEnter: this.composeHandlers(this.onDragEnter),
          onDragOver: this.composeHandlers(this.onDragOver),
          onDragLeave: this.composeHandlers(this.onDragLeave),
          onDrop: this.composeHandlers(this.onDrop),
          ref: this.setRef,
          'aria-disabled': disabled
        }),
        this.renderChildren(children, isDragActive, isDragAccept, isDragReject),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
      );
    }
  }]);

  return Dropzone;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Dropzone);

Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),

  /**
   * Contents of the dropzone
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),

  /**
   * Disallow clicking on the dropzone container to open file dialog
   */
  disableClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable the dropzone entirely
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable preview generation
   */
  disablePreview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */
  inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Allow dropping multiple files
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * `name` attribute for the input tag
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Minimum file size (in bytes)
   */
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * className
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drag is active
   */
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be accepted
   */
  acceptClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be rejected
   */
  rejectClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when dropzone is disabled
   */
  disabledClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS styles to apply
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drag is active
   */
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be accepted
   */
  acceptStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be rejected
   */
  rejectStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when dropzone is disabled
   */
  disabledStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * getDataTransferItems handler
   * @param {Event} event
   * @returns {Array} array of File objects
   */
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDrop callback
   */
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropAccepted callback
   */
  onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropRejected callback
   */
  onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragStart callback
   */
  onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragEnter callback
   */
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragOver callback
   */
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragLeave callback
   */
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  disablePreview: false,
  disableClick: false,
  inputProps: {},
  multiple: true,
  maxSize: Infinity,
  minSize: 0,
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getDataTransferItems */]
};

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReadOnlyInput__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TextArea_css__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TextArea_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TextArea_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextArea=function(_Component){_inherits(TextArea,_Component);function TextArea(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TextArea);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TextArea.__proto__||Object.getPrototypeOf(TextArea)).call.apply(_ref,[this].concat(args))),_this),_this.handleOnBlur=function(event){if(_this.props.onBlur!==undefined){_this.props.onBlur(event.target.value);}},_this.handleOnChange=function(event){if(_this.props.onChange!==undefined){_this.props.onChange(event.target.value);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TextArea,[{key:'render',value:function render(){return this.props.readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ReadOnlyInput__["a" /* default */],{'class':'text-area'+(this.props.className!==null?' '+this.props.className:''),placeholder:this.props.placeholder,theme:this.props.theme,value:this.props.value}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'text-area form-control input-area'+(this.props.className!==null?' '+this.props.className:'')+(this.props.required?' required':'')+(!this.props.valid?' invalid':''),disabled:this.props.disabled,placeholder:this.props.placeholder,required:this.props.required,value:this.props.value,onBlur:this.handleOnBlur,onChange:this.handleOnChange});}}]);return TextArea;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TextArea.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,required:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,theme:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,valid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onBlur:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};TextArea.defaultProps={className:null,required:false,valid:true,value:''};/* harmony default export */ __webpack_exports__["a"] = (TextArea);

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(982)["default"];

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_round_empty_png__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_round_empty_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_round_empty_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_round_full_png__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_round_full_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_round_full_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_round_full_readonly_svg__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_round_full_readonly_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_round_full_readonly_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__checkbox_square_empty_png__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__checkbox_square_empty_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__checkbox_square_empty_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__checkbox_square_full_png__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__checkbox_square_full_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__checkbox_square_full_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_square_full_readonly_svg__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_square_full_readonly_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_square_full_readonly_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CheckBox_css__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CheckBox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__CheckBox_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CheckBox=function(_Component){_inherits(CheckBox,_Component);function CheckBox(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CheckBox);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CheckBox.__proto__||Object.getPrototypeOf(CheckBox)).call.apply(_ref,[this].concat(args))),_this),_this.handleSelectChange=function(event){event.preventDefault();event.stopPropagation();if(!_this.props.readOnly){_this.props.onChange(_this.props.id);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CheckBox,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox-container size-'+this.props.size+(this.props.className!==null?' '+this.props.className:''),onClick:this.handleSelectChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'box-img size-'+this.props.size+(this.props.readOnly?' read-only':'')+(!this.props.checked?' empty':''),src:CheckBox.getImage(this.props.checked,this.props.shape,this.props.readOnly),alt:'plus'}));}}],[{key:'getImage',value:function getImage(checked,shape,readOnly){var image=void 0;if(checked){if(shape==='round'){if(!readOnly){image=__WEBPACK_IMPORTED_MODULE_3__images_round_full_png___default.a;}else{image=__WEBPACK_IMPORTED_MODULE_4__images_round_full_readonly_svg___default.a;}}else{if(!readOnly){image=__WEBPACK_IMPORTED_MODULE_6__checkbox_square_full_png___default.a;}else{image=__WEBPACK_IMPORTED_MODULE_7__images_square_full_readonly_svg___default.a;}}}else{if(shape==='round'){image=__WEBPACK_IMPORTED_MODULE_2__images_round_empty_png___default.a;}else{image=__WEBPACK_IMPORTED_MODULE_5__checkbox_square_empty_png___default.a;}}return image;}}]);return CheckBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CheckBox.propTypes={checked:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,shape:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['round','square']),size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['small','medium']),onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};CheckBox.defaultProps={className:null,readOnly:false,shape:'square',size:'small',onChange:function onChange(){}};/* harmony default export */ __webpack_exports__["a"] = (CheckBox);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ImageUpload_css__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ImageUpload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ImageUpload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_button_SimpleButton__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_plus_icon_png__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_plus_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_plus_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_image_upload_FullScreenImageViewer__ = __webpack_require__(1880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_files_util__ = __webpack_require__(159);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ImageUpload=function(_Component){_inherits(ImageUpload,_Component);function ImageUpload(props){_classCallCheck(this,ImageUpload);var _this=_possibleConstructorReturn(this,(ImageUpload.__proto__||Object.getPrototypeOf(ImageUpload)).call(this,props));_this.handleAddPhotoClick=function(){_this.fileUpload.click();};_this.handleFullScreenOpen=function(url,event){event.preventDefault();_this.setState({fullScreenUrl:url,showFullScreen:true});};_this.handleFullScreenClose=function(){_this.setState({showFullScreen:false});};_this.handleNewImagesUpload=function(files){var newFiles=[];for(var i=0;i<files.length;i++){if(Object(__WEBPACK_IMPORTED_MODULE_8_services_utils_files_util__["b" /* validateFile */])(files.item(i).name,_this.props.extensions)){newFiles.push(files.item(i));}}if(_this.props.max>0){// Remove extra files uploaded
newFiles=newFiles.slice(0,_this.props.max);}// Clear input to allow to upload the same file twice
_this.fileUpload.value='';_this.props.onUpload(newFiles);};_this.handleRemove=function(result){if(result){_this.props.onRemove(_this.state.imageIndexToRemove);}_this.setState({imageIndexToRemove:0,showConfirmation:false});};_this.state={imageIndexToRemove:0,fullScreenUrl:'',showConfirmation:false,showFullScreen:false};return _this;}_createClass(ImageUpload,[{key:'handleRemoveRequest',value:function handleRemoveRequest(index,event){event.preventDefault();this.setState({imageIndexToRemove:index,showConfirmation:true});}},{key:'render',value:function render(){var _this2=this;var buttonLabel=this.props.multiple?'Add Photos':'Add Photo';var minMaxSpan=null;if(this.props.min>0){minMaxSpan='Minimum of '+this.props.min;}if(this.props.max>0){if(this.props.min>0){minMaxSpan+=', maximum of '+this.props.max;}else{minMaxSpan='Maximum of '+this.props.max;}}if(minMaxSpan!==null){minMaxSpan+='.';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-upload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'preview-container'},this.props.images.map(function(image,index){if(image.preview!==undefined&&image.preview!==null){return _this2.getImageDiv(index,image.preview,{show:_this2.props.readOnly&&image.url!==null,url:image.url});}else if(image.url!==undefined&&image.url!==null){return _this2.getImageDiv(index,image.url,{show:_this2.props.readOnly,url:image.url});}else if(image.file!==undefined&&image.file!==null){return _this2.getImageDiv(index,image.file.img);}else{return null;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showConfirmation,message:'Are you sure?',onHide:this.handleRemove})),!this.props.readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-upload-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_SimpleButton__["a" /* default */],{className:'add-photos-button',disabled:this.props.max>0?this.props.images.length>=this.props.max:false,img:__WEBPACK_IMPORTED_MODULE_4_images_plus_icon_png___default.a,label:buttonLabel,onClick:this.handleAddPhotoClick})),(minMaxSpan!==null||this.props.notes!==null)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.props.notes!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.notes)),minMaxSpan!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,minMaxSpan)):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{accept:this.props.extensions.length>0?this.props.extensions:'image/*',multiple:this.props.multiple,ref:function ref(input){_this2.fileUpload=input;},style:{display:'none'},type:'file',onChange:function onChange(event){event.preventDefault();_this2.handleNewImagesUpload(event.target.files);}})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_image_upload_FullScreenImageViewer__["a" /* default */],{show:this.state.showFullScreen,url:this.state.fullScreenUrl,onClose:this.handleFullScreenClose}));}/**
   *
   * @param index
   * @param source
   * @param fullScreenInfo  - { show: boolean, url: string }
   * @return {*}
   */},{key:'getImageDiv',value:function getImageDiv(index,source){var fullScreenInfo=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;if(fullScreenInfo!==null&&fullScreenInfo.show){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-full-screen',src:source,alt:'',onClick:this.handleFullScreenOpen.bind(this,fullScreenInfo.url)}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:source,alt:''}),this.props.onRemove!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'remove-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5_images_remove_png___default.a,alt:'',onClick:this.handleRemoveRequest.bind(this,index)})));}}}]);return ImageUpload;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ImageUpload.propTypes={extensions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),images:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,preview:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,file:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object})),min:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,max:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,notes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUpload:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,multiple:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};ImageUpload.defaultProps={extensions:[],images:[],min:0,max:0,notes:null,multiple:true};/* harmony default export */ __webpack_exports__["a"] = (ImageUpload);

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(982)["default"];

var assertThisInitialized = __webpack_require__(67);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 68 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(2449);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(32);
var IE8_DOM_DEFINE = __webpack_require__(655);
var toPrimitive = __webpack_require__(149);
var dP = Object.defineProperty;

exports.f = __webpack_require__(59) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(150);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export actionTypes */
/* unused harmony export arrayInsert */
/* unused harmony export arrayMove */
/* unused harmony export arrayPop */
/* unused harmony export arrayPush */
/* unused harmony export arrayRemove */
/* unused harmony export arrayRemoveAll */
/* unused harmony export arrayShift */
/* unused harmony export arraySplice */
/* unused harmony export arraySwap */
/* unused harmony export arrayUnshift */
/* unused harmony export autofill */
/* unused harmony export blur */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return change; });
/* unused harmony export clearAsyncError */
/* unused harmony export clearFields */
/* unused harmony export clearSubmitErrors */
/* unused harmony export destroy */
/* unused harmony export focus */
/* unused harmony export initialize */
/* unused harmony export registerField */
/* unused harmony export reset */
/* unused harmony export resetSection */
/* unused harmony export setSubmitFailed */
/* unused harmony export setSubmitSucceeded */
/* unused harmony export startAsyncValidation */
/* unused harmony export startSubmit */
/* unused harmony export stopAsyncValidation */
/* unused harmony export stopSubmit */
/* unused harmony export submit */
/* unused harmony export touch */
/* unused harmony export unregisterField */
/* unused harmony export untouch */
/* unused harmony export updateSyncWarnings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultShouldAsyncValidate__ = __webpack_require__(906);
/* unused harmony reexport defaultShouldAsyncValidate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultShouldValidate__ = __webpack_require__(907);
/* unused harmony reexport defaultShouldValidate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultShouldError__ = __webpack_require__(908);
/* unused harmony reexport defaultShouldError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultShouldWarn__ = __webpack_require__(909);
/* unused harmony reexport defaultShouldWarn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(1972);
/* unused harmony reexport Form */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormName__ = __webpack_require__(1973);
/* unused harmony reexport FormName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormSection__ = __webpack_require__(1974);
/* unused harmony reexport FormSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubmissionError__ = __webpack_require__(910);
/* unused harmony reexport SubmissionError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__propTypes__ = __webpack_require__(1976);
/* unused harmony reexport propTypes */
/* unused harmony reexport fieldInputPropTypes */
/* unused harmony reexport fieldMetaPropTypes */
/* unused harmony reexport fieldPropTypes */
/* unused harmony reexport fieldArrayFieldsPropTypes */
/* unused harmony reexport fieldArrayMetaPropTypes */
/* unused harmony reexport fieldArrayPropTypes */
/* unused harmony reexport formPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Field__ = __webpack_require__(1977);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_11__Field__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Fields__ = __webpack_require__(2044);
/* unused harmony reexport Fields */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FieldArray__ = __webpack_require__(2047);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__FieldArray__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__formValueSelector__ = __webpack_require__(2065);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_14__formValueSelector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__formValues__ = __webpack_require__(2067);
/* unused harmony reexport formValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__getFormError__ = __webpack_require__(2071);
/* unused harmony reexport getFormError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__getFormNames__ = __webpack_require__(2073);
/* unused harmony reexport getFormNames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__getFormValues__ = __webpack_require__(2075);
/* unused harmony reexport getFormValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__getFormInitialValues__ = __webpack_require__(2077);
/* unused harmony reexport getFormInitialValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__getFormSyncErrors__ = __webpack_require__(2079);
/* unused harmony reexport getFormSyncErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__getFormMeta__ = __webpack_require__(2081);
/* unused harmony reexport getFormMeta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__getFormAsyncErrors__ = __webpack_require__(2083);
/* unused harmony reexport getFormAsyncErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__getFormSyncWarnings__ = __webpack_require__(2085);
/* unused harmony reexport getFormSyncWarnings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__getFormSubmitErrors__ = __webpack_require__(2087);
/* unused harmony reexport getFormSubmitErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__isAsyncValidating__ = __webpack_require__(2089);
/* unused harmony reexport isAsyncValidating */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__isDirty__ = __webpack_require__(2091);
/* unused harmony reexport isDirty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__isInvalid__ = __webpack_require__(2093);
/* unused harmony reexport isInvalid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__isPristine__ = __webpack_require__(2096);
/* unused harmony reexport isPristine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__isValid__ = __webpack_require__(2097);
/* unused harmony reexport isValid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__isSubmitting__ = __webpack_require__(2098);
/* unused harmony reexport isSubmitting */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__hasSubmitSucceeded__ = __webpack_require__(2100);
/* unused harmony reexport hasSubmitSucceeded */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__hasSubmitFailed__ = __webpack_require__(2102);
/* unused harmony reexport hasSubmitFailed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__reduxForm__ = __webpack_require__(2104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_33__reduxForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__reducer__ = __webpack_require__(2135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_34__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__values__ = __webpack_require__(2138);
/* unused harmony reexport values */










// alias for propTypes


























var actionTypes = __WEBPACK_IMPORTED_MODULE_1__actionTypes__;
var arrayInsert = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayInsert;
var arrayMove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayMove;
var arrayPop = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPop;
var arrayPush = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPush;
var arrayRemove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemove;
var arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemoveAll;
var arrayShift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayShift;
var arraySplice = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySplice;
var arraySwap = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySwap;
var arrayUnshift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayUnshift;
var autofill = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].autofill;
var blur = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].blur;
var change = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].change;
var clearAsyncError = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearAsyncError;
var clearFields = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearFields;
var clearSubmitErrors = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearSubmitErrors;
var destroy = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].destroy;
var focus = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].focus;
var initialize = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].initialize;
var registerField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].registerField;
var reset = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].reset;
var resetSection = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].resetSection;
var setSubmitFailed = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitFailed;
var setSubmitSucceeded = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitSucceeded;
var startAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startAsyncValidation;
var startSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startSubmit;
var stopAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopAsyncValidation;
var stopSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopSubmit;
var submit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].submit;
var touch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].touch;
var unregisterField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].unregisterField;
var untouch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].untouch;
var updateSyncWarnings = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].updateSyncWarnings;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, setImmediate) {/* eslint guard-for-in:0 */
var AWS;

/**
 * A set of utility methods for use with the AWS SDK.
 *
 * @!attribute abort
 *   Return this value from an iterator function {each} or {arrayEach}
 *   to break out of the iteration.
 *   @example Breaking out of an iterator function
 *     AWS.util.each({a: 1, b: 2, c: 3}, function(key, value) {
 *       if (key == 'b') return AWS.util.abort;
 *     });
 *   @see each
 *   @see arrayEach
 * @api private
 */
var util = {
  environment: 'nodejs',
  engine: function engine() {
    if (util.isBrowser() && typeof navigator !== 'undefined') {
      return navigator.userAgent;
    } else {
      var engine = process.platform + '/' + process.version;
      if (Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://spackle-v1.fly.dev/","REACT_APP_CABLE_WSS_URL":"wss://spackle-v1.fly.dev/cable","REACT_APP_ADVANCED_DOCUMENTS_S3_BUCKET":"360-custom-document","REACT_APP_CLICKUP_FORM_URL":"https://forms.clickup.com/f/86zjg-822/NRB5VVG05QA0QWA5V1","REACT_APP_WEBVIEWER_URL":"https://spackle.s3.amazonaws.com/lib"}).AWS_EXECUTION_ENV) {
        engine += ' exec-env/' + Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://spackle-v1.fly.dev/","REACT_APP_CABLE_WSS_URL":"wss://spackle-v1.fly.dev/cable","REACT_APP_ADVANCED_DOCUMENTS_S3_BUCKET":"360-custom-document","REACT_APP_CLICKUP_FORM_URL":"https://forms.clickup.com/f/86zjg-822/NRB5VVG05QA0QWA5V1","REACT_APP_WEBVIEWER_URL":"https://spackle.s3.amazonaws.com/lib"}).AWS_EXECUTION_ENV;
      }
      return engine;
    }
  },

  userAgent: function userAgent() {
    var name = util.environment;
    var agent = 'aws-sdk-' + name + '/' + __webpack_require__(5).VERSION;
    if (name === 'nodejs') agent += ' ' + util.engine();
    return agent;
  },

  isBrowser: function isBrowser() { return process && process.browser; },
  isNode: function isNode() { return !util.isBrowser(); },
  uriEscape: function uriEscape(string) {
    var output = encodeURIComponent(string);
    output = output.replace(/[^A-Za-z0-9_.~\-%]+/g, escape);

    // AWS percent-encodes some extra non-standard characters in a URI
    output = output.replace(/[*]/g, function(ch) {
      return '%' + ch.charCodeAt(0).toString(16).toUpperCase();
    });

    return output;
  },

  uriEscapePath: function uriEscapePath(string) {
    var parts = [];
    util.arrayEach(string.split('/'), function (part) {
      parts.push(util.uriEscape(part));
    });
    return parts.join('/');
  },

  urlParse: function urlParse(url) {
    return util.url.parse(url);
  },

  urlFormat: function urlFormat(url) {
    return util.url.format(url);
  },

  queryStringParse: function queryStringParse(qs) {
    return util.querystring.parse(qs);
  },

  queryParamsToString: function queryParamsToString(params) {
    var items = [];
    var escape = util.uriEscape;
    var sortedKeys = Object.keys(params).sort();

    util.arrayEach(sortedKeys, function(name) {
      var value = params[name];
      var ename = escape(name);
      var result = ename + '=';
      if (Array.isArray(value)) {
        var vals = [];
        util.arrayEach(value, function(item) { vals.push(escape(item)); });
        result = ename + '=' + vals.sort().join('&' + ename + '=');
      } else if (value !== undefined && value !== null) {
        result = ename + '=' + escape(value);
      }
      items.push(result);
    });

    return items.join('&');
  },

  readFileSync: function readFileSync(path) {
    if (util.isBrowser()) return null;
    return __webpack_require__(647).readFileSync(path, 'utf-8');
  },

  base64: {
    encode: function encode64(string) {
      if (typeof string === 'number') {
        throw util.error(new Error('Cannot base64 encode number ' + string));
      }
      if (string === null || typeof string === 'undefined') {
        return string;
      }
      var buf = (typeof util.Buffer.from === 'function' && util.Buffer.from !== Uint8Array.from) ? util.Buffer.from(string) : new util.Buffer(string);
      return buf.toString('base64');
    },

    decode: function decode64(string) {
      if (typeof string === 'number') {
        throw util.error(new Error('Cannot base64 decode number ' + string));
      }
      if (string === null || typeof string === 'undefined') {
        return string;
      }
      return (typeof util.Buffer.from === 'function' && util.Buffer.from !== Uint8Array.from) ? util.Buffer.from(string, 'base64') : new util.Buffer(string, 'base64');
    }

  },

  buffer: {
    toStream: function toStream(buffer) {
      if (!util.Buffer.isBuffer(buffer)) buffer = new util.Buffer(buffer);

      var readable = new (util.stream.Readable)();
      var pos = 0;
      readable._read = function(size) {
        if (pos >= buffer.length) return readable.push(null);

        var end = pos + size;
        if (end > buffer.length) end = buffer.length;
        readable.push(buffer.slice(pos, end));
        pos = end;
      };

      return readable;
    },

    /**
     * Concatenates a list of Buffer objects.
     */
    concat: function(buffers) {
      var length = 0,
          offset = 0,
          buffer = null, i;

      for (i = 0; i < buffers.length; i++) {
        length += buffers[i].length;
      }

      buffer = new util.Buffer(length);

      for (i = 0; i < buffers.length; i++) {
        buffers[i].copy(buffer, offset);
        offset += buffers[i].length;
      }

      return buffer;
    }
  },

  string: {
    byteLength: function byteLength(string) {
      if (string === null || string === undefined) return 0;
      if (typeof string === 'string') string = new util.Buffer(string);

      if (typeof string.byteLength === 'number') {
        return string.byteLength;
      } else if (typeof string.length === 'number') {
        return string.length;
      } else if (typeof string.size === 'number') {
        return string.size;
      } else if (typeof string.path === 'string') {
        return __webpack_require__(647).lstatSync(string.path).size;
      } else {
        throw util.error(new Error('Cannot determine length of ' + string),
          { object: string });
      }
    },

    upperFirst: function upperFirst(string) {
      return string[0].toUpperCase() + string.substr(1);
    },

    lowerFirst: function lowerFirst(string) {
      return string[0].toLowerCase() + string.substr(1);
    }
  },

  ini: {
    parse: function string(ini) {
      var currentSection, map = {};
      util.arrayEach(ini.split(/\r?\n/), function(line) {
        line = line.split(/(^|\s)[;#]/)[0]; // remove comments
        var section = line.match(/^\s*\[([^\[\]]+)\]\s*$/);
        if (section) {
          currentSection = section[1];
        } else if (currentSection) {
          var item = line.match(/^\s*(.+?)\s*=\s*(.+?)\s*$/);
          if (item) {
            map[currentSection] = map[currentSection] || {};
            map[currentSection][item[1]] = item[2];
          }
        }
      });

      return map;
    }
  },

  fn: {
    noop: function() {},

    /**
     * Turn a synchronous function into as "async" function by making it call
     * a callback. The underlying function is called with all but the last argument,
     * which is treated as the callback. The callback is passed passed a first argument
     * of null on success to mimick standard node callbacks.
     */
    makeAsync: function makeAsync(fn, expectedArgs) {
      if (expectedArgs && expectedArgs <= fn.length) {
        return fn;
      }

      return function() {
        var args = Array.prototype.slice.call(arguments, 0);
        var callback = args.pop();
        var result = fn.apply(null, args);
        callback(result);
      };
    }
  },

  /**
   * Date and time utility functions.
   */
  date: {

    /**
     * @return [Date] the current JavaScript date object. Since all
     *   AWS services rely on this date object, you can override
     *   this function to provide a special time value to AWS service
     *   requests.
     */
    getDate: function getDate() {
      if (!AWS) AWS = __webpack_require__(5);
      if (AWS.config.systemClockOffset) { // use offset when non-zero
        return new Date(new Date().getTime() + AWS.config.systemClockOffset);
      } else {
        return new Date();
      }
    },

    /**
     * @return [String] the date in ISO-8601 format
     */
    iso8601: function iso8601(date) {
      if (date === undefined) { date = util.date.getDate(); }
      return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
    },

    /**
     * @return [String] the date in RFC 822 format
     */
    rfc822: function rfc822(date) {
      if (date === undefined) { date = util.date.getDate(); }
      return date.toUTCString();
    },

    /**
     * @return [Integer] the UNIX timestamp value for the current time
     */
    unixTimestamp: function unixTimestamp(date) {
      if (date === undefined) { date = util.date.getDate(); }
      return date.getTime() / 1000;
    },

    /**
     * @param [String,number,Date] date
     * @return [Date]
     */
    from: function format(date) {
      if (typeof date === 'number') {
        return new Date(date * 1000); // unix timestamp
      } else {
        return new Date(date);
      }
    },

    /**
     * Given a Date or date-like value, this function formats the
     * date into a string of the requested value.
     * @param [String,number,Date] date
     * @param [String] formatter Valid formats are:
     #   * 'iso8601'
     #   * 'rfc822'
     #   * 'unixTimestamp'
     * @return [String]
     */
    format: function format(date, formatter) {
      if (!formatter) formatter = 'iso8601';
      return util.date[formatter](util.date.from(date));
    },

    parseTimestamp: function parseTimestamp(value) {
      if (typeof value === 'number') { // unix timestamp (number)
        return new Date(value * 1000);
      } else if (value.match(/^\d+$/)) { // unix timestamp
        return new Date(value * 1000);
      } else if (value.match(/^\d{4}/)) { // iso8601
        return new Date(value);
      } else if (value.match(/^\w{3},/)) { // rfc822
        return new Date(value);
      } else {
        throw util.error(
          new Error('unhandled timestamp format: ' + value),
          {code: 'TimestampParserError'});
      }
    }

  },

  crypto: {
    crc32Table: [
     0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419,
     0x706AF48F, 0xE963A535, 0x9E6495A3, 0x0EDB8832, 0x79DCB8A4,
     0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07,
     0x90BF1D91, 0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
     0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7, 0x136C9856,
     0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9,
     0xFA0F3D63, 0x8D080DF5, 0x3B6E20C8, 0x4C69105E, 0xD56041E4,
     0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
     0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3,
     0x45DF5C75, 0xDCD60DCF, 0xABD13D59, 0x26D930AC, 0x51DE003A,
     0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599,
     0xB8BDA50F, 0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
     0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D, 0x76DC4190,
     0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F,
     0x9FBFE4A5, 0xE8B8D433, 0x7807C9A2, 0x0F00F934, 0x9609A88E,
     0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
     0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED,
     0x1B01A57B, 0x8208F4C1, 0xF50FC457, 0x65B0D9C6, 0x12B7E950,
     0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3,
     0xFBD44C65, 0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
     0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB, 0x4369E96A,
     0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5,
     0xAA0A4C5F, 0xDD0D7CC9, 0x5005713C, 0x270241AA, 0xBE0B1010,
     0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
     0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17,
     0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD, 0xEDB88320, 0x9ABFB3B6,
     0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615,
     0x73DC1683, 0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
     0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1, 0xF00F9344,
     0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB,
     0x196C3671, 0x6E6B06E7, 0xFED41B76, 0x89D32BE0, 0x10DA7A5A,
     0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
     0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1,
     0xA6BC5767, 0x3FB506DD, 0x48B2364B, 0xD80D2BDA, 0xAF0A1B4C,
     0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF,
     0x4669BE79, 0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
     0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F, 0xC5BA3BBE,
     0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31,
     0x2CD99E8B, 0x5BDEAE1D, 0x9B64C2B0, 0xEC63F226, 0x756AA39C,
     0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
     0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B,
     0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21, 0x86D3D2D4, 0xF1D4E242,
     0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1,
     0x18B74777, 0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
     0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45, 0xA00AE278,
     0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7,
     0x4969474D, 0x3E6E77DB, 0xAED16A4A, 0xD9D65ADC, 0x40DF0B66,
     0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
     0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605,
     0xCDD70693, 0x54DE5729, 0x23D967BF, 0xB3667A2E, 0xC4614AB8,
     0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B,
     0x2D02EF8D],

    crc32: function crc32(data) {
      var tbl = util.crypto.crc32Table;
      var crc = 0 ^ -1;

      if (typeof data === 'string') {
        data = new util.Buffer(data);
      }

      for (var i = 0; i < data.length; i++) {
        var code = data.readUInt8(i);
        crc = (crc >>> 8) ^ tbl[(crc ^ code) & 0xFF];
      }
      return (crc ^ -1) >>> 0;
    },

    hmac: function hmac(key, string, digest, fn) {
      if (!digest) digest = 'binary';
      if (digest === 'buffer') { digest = undefined; }
      if (!fn) fn = 'sha256';
      if (typeof string === 'string') string = new util.Buffer(string);
      return util.crypto.lib.createHmac(fn, key).update(string).digest(digest);
    },

    md5: function md5(data, digest, callback) {
      return util.crypto.hash('md5', data, digest, callback);
    },

    sha256: function sha256(data, digest, callback) {
      return util.crypto.hash('sha256', data, digest, callback);
    },

    hash: function(algorithm, data, digest, callback) {
      var hash = util.crypto.createHash(algorithm);
      if (!digest) { digest = 'binary'; }
      if (digest === 'buffer') { digest = undefined; }
      if (typeof data === 'string') data = new util.Buffer(data);
      var sliceFn = util.arraySliceFn(data);
      var isBuffer = util.Buffer.isBuffer(data);
      //Identifying objects with an ArrayBuffer as buffers
      if (util.isBrowser() && typeof ArrayBuffer !== 'undefined' && data && data.buffer instanceof ArrayBuffer) isBuffer = true;

      if (callback && typeof data === 'object' &&
          typeof data.on === 'function' && !isBuffer) {
        data.on('data', function(chunk) { hash.update(chunk); });
        data.on('error', function(err) { callback(err); });
        data.on('end', function() { callback(null, hash.digest(digest)); });
      } else if (callback && sliceFn && !isBuffer &&
                 typeof FileReader !== 'undefined') {
        // this might be a File/Blob
        var index = 0, size = 1024 * 512;
        var reader = new FileReader();
        reader.onerror = function() {
          callback(new Error('Failed to read data.'));
        };
        reader.onload = function() {
          var buf = new util.Buffer(new Uint8Array(reader.result));
          hash.update(buf);
          index += buf.length;
          reader._continueReading();
        };
        reader._continueReading = function() {
          if (index >= data.size) {
            callback(null, hash.digest(digest));
            return;
          }

          var back = index + size;
          if (back > data.size) back = data.size;
          reader.readAsArrayBuffer(sliceFn.call(data, index, back));
        };

        reader._continueReading();
      } else {
        if (util.isBrowser() && typeof data === 'object' && !isBuffer) {
          data = new util.Buffer(new Uint8Array(data));
        }
        var out = hash.update(data).digest(digest);
        if (callback) callback(null, out);
        return out;
      }
    },

    toHex: function toHex(data) {
      var out = [];
      for (var i = 0; i < data.length; i++) {
        out.push(('0' + data.charCodeAt(i).toString(16)).substr(-2, 2));
      }
      return out.join('');
    },

    createHash: function createHash(algorithm) {
      return util.crypto.lib.createHash(algorithm);
    }

  },

  /** @!ignore */

  /* Abort constant */
  abort: {},

  each: function each(object, iterFunction) {
    for (var key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        var ret = iterFunction.call(this, key, object[key]);
        if (ret === util.abort) break;
      }
    }
  },

  arrayEach: function arrayEach(array, iterFunction) {
    for (var idx in array) {
      if (Object.prototype.hasOwnProperty.call(array, idx)) {
        var ret = iterFunction.call(this, array[idx], parseInt(idx, 10));
        if (ret === util.abort) break;
      }
    }
  },

  update: function update(obj1, obj2) {
    util.each(obj2, function iterator(key, item) {
      obj1[key] = item;
    });
    return obj1;
  },

  merge: function merge(obj1, obj2) {
    return util.update(util.copy(obj1), obj2);
  },

  copy: function copy(object) {
    if (object === null || object === undefined) return object;
    var dupe = {};
    // jshint forin:false
    for (var key in object) {
      dupe[key] = object[key];
    }
    return dupe;
  },

  isEmpty: function isEmpty(obj) {
    for (var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        return false;
      }
    }
    return true;
  },

  arraySliceFn: function arraySliceFn(obj) {
    var fn = obj.slice || obj.webkitSlice || obj.mozSlice;
    return typeof fn === 'function' ? fn : null;
  },

  isType: function isType(obj, type) {
    // handle cross-"frame" objects
    if (typeof type === 'function') type = util.typeName(type);
    return Object.prototype.toString.call(obj) === '[object ' + type + ']';
  },

  typeName: function typeName(type) {
    if (Object.prototype.hasOwnProperty.call(type, 'name')) return type.name;
    var str = type.toString();
    var match = str.match(/^\s*function (.+)\(/);
    return match ? match[1] : str;
  },

  error: function error(err, options) {
    var originalError = null;
    if (typeof err.message === 'string' && err.message !== '') {
      if (typeof options === 'string' || (options && options.message)) {
        originalError = util.copy(err);
        originalError.message = err.message;
      }
    }
    err.message = err.message || null;

    if (typeof options === 'string') {
      err.message = options;
    } else if (typeof options === 'object' && options !== null) {
      util.update(err, options);
      if (options.message)
        err.message = options.message;
      if (options.code || options.name)
        err.code = options.code || options.name;
      if (options.stack)
        err.stack = options.stack;
    }

    if (typeof Object.defineProperty === 'function') {
      Object.defineProperty(err, 'name', {writable: true, enumerable: false});
      Object.defineProperty(err, 'message', {enumerable: true});
    }

    err.name = options && options.name || err.name || err.code || 'Error';
    err.time = new Date();

    if (originalError) err.originalError = originalError;

    return err;
  },

  /**
   * @api private
   */
  inherit: function inherit(klass, features) {
    var newObject = null;
    if (features === undefined) {
      features = klass;
      klass = Object;
      newObject = {};
    } else {
      var ctor = function ConstructorWrapper() {};
      ctor.prototype = klass.prototype;
      newObject = new ctor();
    }

    // constructor not supplied, create pass-through ctor
    if (features.constructor === Object) {
      features.constructor = function() {
        if (klass !== Object) {
          return klass.apply(this, arguments);
        }
      };
    }

    features.constructor.prototype = newObject;
    util.update(features.constructor.prototype, features);
    features.constructor.__super__ = klass;
    return features.constructor;
  },

  /**
   * @api private
   */
  mixin: function mixin() {
    var klass = arguments[0];
    for (var i = 1; i < arguments.length; i++) {
      // jshint forin:false
      for (var prop in arguments[i].prototype) {
        var fn = arguments[i].prototype[prop];
        if (prop !== 'constructor') {
          klass.prototype[prop] = fn;
        }
      }
    }
    return klass;
  },

  /**
   * @api private
   */
  hideProperties: function hideProperties(obj, props) {
    if (typeof Object.defineProperty !== 'function') return;

    util.arrayEach(props, function (key) {
      Object.defineProperty(obj, key, {
        enumerable: false, writable: true, configurable: true });
    });
  },

  /**
   * @api private
   */
  property: function property(obj, name, value, enumerable, isValue) {
    var opts = {
      configurable: true,
      enumerable: enumerable !== undefined ? enumerable : true
    };
    if (typeof value === 'function' && !isValue) {
      opts.get = value;
    }
    else {
      opts.value = value; opts.writable = true;
    }

    Object.defineProperty(obj, name, opts);
  },

  /**
   * @api private
   */
  memoizedProperty: function memoizedProperty(obj, name, get, enumerable) {
    var cachedValue = null;

    // build enumerable attribute for each value with lazy accessor.
    util.property(obj, name, function() {
      if (cachedValue === null) {
        cachedValue = get();
      }
      return cachedValue;
    }, enumerable);
  },

  /**
   * TODO Remove in major version revision
   * This backfill populates response data without the
   * top-level payload name.
   *
   * @api private
   */
  hoistPayloadMember: function hoistPayloadMember(resp) {
    var req = resp.request;
    var operation = req.operation;
    var output = req.service.api.operations[operation].output;
    if (output.payload) {
      var payloadMember = output.members[output.payload];
      var responsePayload = resp.data[output.payload];
      if (payloadMember.type === 'structure') {
        util.each(responsePayload, function(key, value) {
          util.property(resp.data, key, value, false);
        });
      }
    }
  },

  /**
   * Compute SHA-256 checksums of streams
   *
   * @api private
   */
  computeSha256: function computeSha256(body, done) {
    if (util.isNode()) {
      var Stream = util.stream.Stream;
      var fs = __webpack_require__(647);
      if (body instanceof Stream) {
        if (typeof body.path === 'string') { // assume file object
          var settings = {};
          if (typeof body.start === 'number') {
            settings.start = body.start;
          }
          if (typeof body.end === 'number') {
            settings.end = body.end;
          }
          body = fs.createReadStream(body.path, settings);
        } else { // TODO support other stream types
          return done(new Error('Non-file stream objects are ' +
                                'not supported with SigV4'));
        }
      }
    }

    util.crypto.sha256(body, 'hex', function(err, sha) {
      if (err) done(err);
      else done(null, sha);
    });
  },

  /**
   * @api private
   */
  isClockSkewed: function isClockSkewed(serverTime) {
    if (serverTime) {
      util.property(AWS.config, 'isClockSkewed',
        Math.abs(new Date().getTime() - serverTime) >= 300000, false);
      return AWS.config.isClockSkewed;
    }
  },

  applyClockOffset: function applyClockOffset(serverTime) {
    if (serverTime)
      AWS.config.systemClockOffset = serverTime - new Date().getTime();
  },

  /**
   * @api private
   */
  extractRequestId: function extractRequestId(resp) {
    var requestId = resp.httpResponse.headers['x-amz-request-id'] ||
                     resp.httpResponse.headers['x-amzn-requestid'];

    if (!requestId && resp.data && resp.data.ResponseMetadata) {
      requestId = resp.data.ResponseMetadata.RequestId;
    }

    if (requestId) {
      resp.requestId = requestId;
    }

    if (resp.error) {
      resp.error.requestId = requestId;
    }
  },

  /**
   * @api private
   */
  addPromises: function addPromises(constructors, PromiseDependency) {
    if (PromiseDependency === undefined && AWS && AWS.config) {
      PromiseDependency = AWS.config.getPromisesDependency();
    }
    if (PromiseDependency === undefined && typeof Promise !== 'undefined') {
      PromiseDependency = Promise;
    }
    if (typeof PromiseDependency !== 'function') var deletePromises = true;
    if (!Array.isArray(constructors)) constructors = [constructors];

    for (var ind = 0; ind < constructors.length; ind++) {
      var constructor = constructors[ind];
      if (deletePromises) {
        if (constructor.deletePromisesFromClass) {
          constructor.deletePromisesFromClass();
        }
      } else if (constructor.addPromisesToClass) {
        constructor.addPromisesToClass(PromiseDependency);
      }
    }
  },

  /**
   * @api private
   */
  promisifyMethod: function promisifyMethod(methodName, PromiseDependency) {
    return function promise() {
      var self = this;
      return new PromiseDependency(function(resolve, reject) {
        self[methodName](function(err, data) {
          if (err) {
            reject(err);
          } else {
            resolve(data);
          }
        });
      });
    };
  },

  /**
   * @api private
   */
  isDualstackAvailable: function isDualstackAvailable(service) {
    if (!service) return false;
    var metadata = __webpack_require__(2696);
    if (typeof service !== 'string') service = service.serviceIdentifier;
    if (typeof service !== 'string' || !metadata.hasOwnProperty(service)) return false;
    return !!metadata[service].dualstackAvailable;
  },

  /**
   * @api private
   */
  calculateRetryDelay: function calculateRetryDelay(retryCount, retryDelayOptions) {
    if (!retryDelayOptions) retryDelayOptions = {};
    var customBackoff = retryDelayOptions.customBackoff || null;
    if (typeof customBackoff === 'function') {
      return customBackoff(retryCount);
    }
    var base = typeof retryDelayOptions.base === 'number' ? retryDelayOptions.base : 100;
    var delay = Math.random() * (Math.pow(2, retryCount) * base);
    return delay;
  },

  /**
   * @api private
   */
  handleRequestWithRetries: function handleRequestWithRetries(httpRequest, options, cb) {
    if (!options) options = {};
    var http = AWS.HttpClient.getInstance();
    var httpOptions = options.httpOptions || {};
    var retryCount = 0;

    var errCallback = function(err) {
      var maxRetries = options.maxRetries || 0;
      if (err && err.code === 'TimeoutError') err.retryable = true;
      if (err && err.retryable && retryCount < maxRetries) {
        retryCount++;
        var delay = util.calculateRetryDelay(retryCount, options.retryDelayOptions);
        setTimeout(sendRequest, delay + (err.retryAfter || 0));
      } else {
        cb(err);
      }
    };

    var sendRequest = function() {
      var data = '';
      http.handleRequest(httpRequest, httpOptions, function(httpResponse) {
        httpResponse.on('data', function(chunk) { data += chunk.toString(); });
        httpResponse.on('end', function() {
          var statusCode = httpResponse.statusCode;
          if (statusCode < 300) {
            cb(null, data);
          } else {
            var retryAfter = parseInt(httpResponse.headers['retry-after'], 10) * 1000 || 0;
            var err = util.error(new Error(),
              { retryable: statusCode >= 500 || statusCode === 429 }
            );
            if (retryAfter && err.retryable) err.retryAfter = retryAfter;
            errCallback(err);
          }
        });
      }, errCallback);
    };

    AWS.util.defer(sendRequest);
  },

  /**
   * @api private
   */
  uuid: {
    v4: function uuidV4() {
      return __webpack_require__(2697).v4();
    }
  },

  /**
   * @api private
   */
  convertPayloadToString: function convertPayloadToString(resp) {
    var req = resp.request;
    var operation = req.operation;
    var rules = req.service.api.operations[operation].output || {};
    if (rules.payload && resp.data[rules.payload]) {
      resp.data[rules.payload] = resp.data[rules.payload].toString();
    }
  },

  /**
   * @api private
   */
  defer: function defer(callback) {
    if (typeof process === 'object' && typeof process.nextTick === 'function') {
      process.nextTick(callback);
    } else if (typeof setImmediate === 'function') {
      setImmediate(callback);
    } else {
      setTimeout(callback, 0);
    }
  },

  /**
   * @api private
   */
  defaultProfile: 'default',

  /**
   * @api private
   */
  configOptInEnv: 'AWS_SDK_LOAD_CONFIG',

  /**
   * @api private
   */
  sharedCredentialsFileEnv: 'AWS_SHARED_CREDENTIALS_FILE',

  /**
   * @api private
   */
  sharedConfigFileEnv: 'AWS_CONFIG_FILE',

  /**
   * @api private
   */
  imdsDisabledEnv: 'AWS_EC2_METADATA_DISABLED'
};

module.exports = util;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(254), __webpack_require__(2657).setImmediate))

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) {
      return f;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ __webpack_exports__["a"] = (createChainedFunction);

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/upload.297e9245.svg";

/***/ }),
/* 77 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SearchBar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchBar_css__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchBar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SearchBar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(7);
function SearchBar(props){var handleClear=function handleClear(){if(props.onClearText!==null){props.onClearText();}};var handleSearch=function handleSearch(){if(props.onSearch!==null){props.onSearch(props.searchText);}};var handleValueChange=function handleValueChange(event){if(props.onSearchTextChange!==null){props.onSearchTextChange(event.target.value);}};var addButton=props.addButton,children=props.children,searchPlaceHolder=props.searchPlaceHolder,searchText=props.searchText,onSearch=props.onSearch;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'search-bar'},children,(addButton!==null||onSearch!==null)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["p" /* Navbar */].Form,{className:'search-bar-form',pullRight:true},onSearch!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["l" /* InputGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* FormControl */],{className:'search-input',placeholder:searchPlaceHolder,type:'text',value:searchText,onChange:handleValueChange}),searchText!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["l" /* InputGroup */].Addon,{className:'search-buttons remove',onClick:handleClear},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["j" /* Glyphicon */],{glyph:'remove'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["l" /* InputGroup */].Addon,{className:'search-buttons magnifier',onClick:handleSearch},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["j" /* Glyphicon */],{glyph:'search'})))),addButton!==null&&addButton));}SearchBar.propTypes={addButton:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,// Button to show next to search input
searchPlaceHolder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,searchText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onClearText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSearch:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSearchTextChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};SearchBar.defaultProps={addButton:null,searchPlaceHolder:'Search',searchText:'',onClear:null,onSearch:null,onSearchTextChange:null};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1490), __esModule: true };

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(802);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(803);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1509);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1510);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(803);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var TextareaAutosize_1 = __webpack_require__(1947);
exports["default"] = TextareaAutosize_1.TextareaAutosize;


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PdfViewer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_iframe__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PdfViewer_css__ = __webpack_require__(2205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PdfViewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PdfViewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_ImageButton__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_close_svg__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_close_svg__);
function PdfViewer(props){var handleClose=function handleClose(){if(props.onClose){props.onClose();}};var url=null;if(props.content!==null){if(props.content.type==='url'){url=props.content.source;}else if(props.content.type==='blob'){if(navigator.appVersion.toString().indexOf('.NET')>0){window.navigator.msSaveBlob(props.content.source);return null;}else{//Create a Blob from the PDF Stream
var file=new Blob([props.content.source],{type:'application/pdf'});//Build a URL from the file
url=URL.createObjectURL(file);}}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */],{className:'pdf-viewer-modal',show:props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body-bold'},'Pdf Viewer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_ImageButton__["a" /* default */],{alt:'close',src:__WEBPACK_IMPORTED_MODULE_6_images_close_svg___default.a,onClick:handleClose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */].Body,null,url!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_iframe__["a" /* default */],{url:url,className:'pdf-viewer-iframe',width:'100%',height:'100%',display:'initial',position:'relative',allowFullScreen:true})));}PdfViewer.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({source:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['url','blob'])}),onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};PdfViewer.defaultProps={show:false,content:null};

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserModalState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InviteUserModal_css__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InviteUserModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__InviteUserModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_checkbox_CheckBox__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_modal_FormModal__ = __webpack_require__(23);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserModalState={NEW:'new',EDIT:'edit',READ_ONLY:'readOnly'};var InviteUserModal=function(_Component){_inherits(InviteUserModal,_Component);function InviteUserModal(props){_classCallCheck(this,InviteUserModal);var _this=_possibleConstructorReturn(this,(InviteUserModal.__proto__||Object.getPrototypeOf(InviteUserModal)).call(this,props));_this.handleClose=function(){if(_this.props.onClose){_this.props.onClose();}};_this.handleSubmit=function(event){event.preventDefault();if(_this.props.onSubmit){_this.props.onSubmit();}};_this.handleAttributeChange=function(attribute,value){if(_this.props.onAttributeChange){_this.props.onAttributeChange(attribute,value);}};_this.handleMultipleSelected=function(attribute,value){if(_this.props.onAttributeChange){var newValue=void 0;if(_this.props.values[attribute].find(function(element){return element===value;})!==undefined){newValue=_this.props.values[attribute].filter(function(element){return element!==value;});}else{newValue=_this.props.values[attribute].concat([value]);}_this.props.onAttributeChange(attribute,newValue);}};_this.handleEdit=function(){if(_this.props.onEdit){_this.props.onEdit();}};_this.handleDelete=function(){_this.setState({showConfirmation:true});};_this.handleDeleteConfirmation=function(result){_this.setState({showConfirmation:false});if(_this.props.onDeleteConfirmation){_this.props.onDeleteConfirmation(result);}};_this.state={showConfirmation:false};return _this;}_createClass(InviteUserModal,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_modal_FormModal__["a" /* default */],{className:'invite-user-modal'+(this.props.className!==null?' '+this.props.className:''),show:this.props.show,title:this.props.modalState===UserModalState.NEW?'Invite User':'Edit User',onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.handleSubmit},this.props.form.filter(function(item){return item.show===undefined||item.show;}).map(function(item,index){if(typeof item.renderer==='string'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:3},item.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:9},_this2.renderItem(item)));}else if(_typeof(item.renderer)==='object'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],{key:index},item.renderer);}else{return null;}}),this.props.validationMessage!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},this.props.validationMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:12},this.props.modalState!==UserModalState.READ_ONLY?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',value:this.props.modalState===UserModalState.NEW?'Invite':'Update',type:'submit'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{id:'edit-user',label:'Edit',className:'button-orange',onClick:this.handleEdit}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{id:'delete-user',label:'Delete',className:'button-gray',onClick:this.handleDelete})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showConfirmation,message:'Are you sure?',onHide:this.handleDeleteConfirmation}));}},{key:'renderItem',value:function renderItem(item){var _this3=this;if(item.renderer==='input'){var readOnly=this.props.modalState===UserModalState.READ_ONLY;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__["a" /* default */],{id:item.attribute,placeholder:item.label,readOnly:readOnly,theme:'normal',type:item.attribute==='email'?'email':'text',valid:this.props.invalidFields.find(function(element){return element===item.attribute;})===undefined,value:readOnly?item.formatter?item.formatter(this.props.values[item.attribute]):this.props.values[item.attribute]:this.props.values[item.attribute],onChange:this.handleAttributeChange.bind(this,item.attribute)});}else if(item.renderer==='dropdown'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__["a" /* default */],{id:item.attribute,options:item.options,placeholder:item.label,readOnly:this.props.modalState===UserModalState.READ_ONLY,theme:'normal',valid:this.props.invalidFields.find(function(element){return element===item.attribute;})===undefined,value:this.props.values[item.attribute],onChange:function onChange(newOption){return newOption?_this3.handleAttributeChange(item.attribute,newOption.value):'';}});}else if(item.renderer==='multiple'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multiple-container'},item.options.map(function(option){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:option.value},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_checkbox_CheckBox__["a" /* default */],{checked:_this3.props.values[item.attribute].find(function(element){return element===option.value;})!==undefined,id:option.value,readOnly:_this3.props.modalState===UserModalState.READ_ONLY,shape:'square',size:'medium',onChange:_this3.handleMultipleSelected.bind(_this3,item.attribute)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,option.label));}));}else{return null;}}}]);return InviteUserModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);InviteUserModal.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,form:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({attribute:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,formatter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,// renderer: PropTypes.oneOf(['input', 'dropdown', 'multiple']).isRequired,
renderer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['input','dropdown','multiple']),__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,// default to true
options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}))})).isRequired,invalidFields:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,modalState:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.values(UserModalState)).isRequired,show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,validationMessage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,values:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired,onAttributeChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onDeleteConfirmation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};InviteUserModal.defaultProps={className:null,invalidFields:[],rolesInput:'single',validationMessage:''};/* harmony default export */ __webpack_exports__["b"] = (InviteUserModal);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SIZE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEVICE_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return State; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Style; });
var Size = {
  LARGE: 'large',
  SMALL: 'small',
  XSMALL: 'xsmall'
};
var SIZE_MAP = {
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
};
var DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
var State = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};
var Style = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse'
};

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checkbox_square_empty_png__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checkbox_square_empty_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__checkbox_square_empty_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_square_full_readonly_svg__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_square_full_readonly_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_square_full_readonly_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__checkbox_square_full_blue_png__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__checkbox_square_full_blue_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__checkbox_square_full_blue_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CheckBox_css__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CheckBox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CheckBox_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LabeledCheckBox=function(_Component){_inherits(LabeledCheckBox,_Component);function LabeledCheckBox(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LabeledCheckBox);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LabeledCheckBox.__proto__||Object.getPrototypeOf(LabeledCheckBox)).call.apply(_ref,[this].concat(args))),_this),_this.handleSelectChange=function(event){event.preventDefault();event.stopPropagation();if(!_this.props.readOnly){_this.props.onChange(!_this.props.checked);}},_this.getImage=function(){var _this$props=_this.props,checked=_this$props.checked,readOnly=_this$props.readOnly,squareFull=_this$props.squareFull,squareFullReadOnly=_this$props.squareFullReadOnly,squareEmpty=_this$props.squareEmpty;var image=void 0;if(checked){if(!readOnly){image=squareFull||__WEBPACK_IMPORTED_MODULE_4__checkbox_square_full_blue_png___default.a;}else{image=squareFullReadOnly||__WEBPACK_IMPORTED_MODULE_3__images_square_full_readonly_svg___default.a;}}else{image=squareEmpty||__WEBPACK_IMPORTED_MODULE_2__checkbox_square_empty_png___default.a;}return image;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LabeledCheckBox,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'labeled-checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox-container size-'+this.props.size+(this.props.className!==null?' '+this.props.className:''),onClick:this.handleSelectChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'box-img size-'+this.props.size+(this.props.readOnly?' read-only':'')+(!this.props.checked?' empty':''),src:this.getImage(),alt:'plus'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox-label'},this.props.label));}}]);return LabeledCheckBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);LabeledCheckBox.propTypes={checked:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['small','medium']),color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),squareFull:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,squareFullReadOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,squareEmpty:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};LabeledCheckBox.defaultProps={className:null,readOnly:false,size:'small',color:null,label:null,squareFull:null,squareFullReadOnly:null,squareEmpty:null,onChange:function onChange(){}};/* harmony default export */ __webpack_exports__["a"] = (LabeledCheckBox);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return workOrdersApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DEFAULT_GET_WORK_ORDERS_CRITERIA={page:1,perPage:25,status:null,critical:false,withoutContractorInvoice:false,jobNumber:''};var WorkOrdersApi=function(_BaseApi){_inherits(WorkOrdersApi,_BaseApi);function WorkOrdersApi(){_classCallCheck(this,WorkOrdersApi);return _possibleConstructorReturn(this,(WorkOrdersApi.__proto__||Object.getPrototypeOf(WorkOrdersApi)).apply(this,arguments));}_createClass(WorkOrdersApi,[{key:'getWorkOrders',/**
   * Get work orders based on given criteria.
   * @param criteria: { page: number, status: WorkOrderStatusEnum, critical: boolean, jobNumber: string }
   * @return {Promise}
   */value:function getWorkOrders(){var criteria=arguments.length>0&&arguments[0]!==undefined?arguments[0]:DEFAULT_GET_WORK_ORDERS_CRITERIA;// Remove null|undefined values
var filteredCriteria=Object.assign({},criteria);Object.keys(filteredCriteria).forEach(function(key){return(filteredCriteria[key]===null||filteredCriteria[key]===undefined)&&delete filteredCriteria[key];});// Merge default with properly criteria
var finalCriteria=Object.assign({},DEFAULT_GET_WORK_ORDERS_CRITERIA,filteredCriteria);var filter='';if(finalCriteria.status!==null){filter+='&'+finalCriteria.status+'=true';}if(finalCriteria.critical!==null&&finalCriteria.critical){filter+='&critical=true';}if(finalCriteria.jobNumber!==''){filter+='&by_job_number='+finalCriteria.jobNumber;}if(finalCriteria.withoutContractorInvoice!==null&&finalCriteria.withoutContractorInvoice){filter+='&without_contractor_invoice=true';}if(finalCriteria.perPage!==null){filter+='&per_page='+finalCriteria.perPage;}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders?page='+finalCriteria.page+filter).then(function(response){return{ok:true,workOrders:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),totalComplete:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-complete']).value(),totalCritical:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-critical']).value(),totalDraft:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-draft']).value(),totalInProgress:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-in_progress']).value(),totalPending:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-pending']).value(),totalPlm:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-plm']).value(),totalWoa:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-woa']).value(),totalClosed:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-closed']).value(),totalDeclined:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-declined']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getWorkOrder',value:function getWorkOrder(id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders/'+id).then(function(response){return{ok:true,workOrder:Object.assign({},response.data,{unread_notes:response.headers['unread-notes']!==undefined&&response.headers['unread-notes']==='true'})};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createWorkOrder',value:function createWorkOrder(idBuilding,clientId){var data={building_id:idBuilding};if(clientId!==undefined){data['client_id']=clientId;}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/work_orders',data).then(function(response){return{ok:true,newWorkOrder:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateBuilding',value:function updateBuilding(workOrderId,buildingId,files){return this._updateWorkOrder(workOrderId,'building_id',buildingId);}},{key:'updateClient',value:function updateClient(workOrderId,clientId){return this._updateWorkOrder(workOrderId,'client_id',clientId);}},{key:'addSubContractors',value:function addSubContractors(workOrderId,contractorsId){return this._updateWorkOrder(workOrderId,'propietary_sub_contractor_ids',contractorsId);}},{key:'addWorkingHours',value:function addWorkingHours(workOrderId,workingHours){return this._updateWorkOrder(workOrderId,'working_hours',workingHours);}},{key:'addUnionTrades',value:function addUnionTrades(workOrderId,tradesId){return this._updateWorkOrder(workOrderId,'union_ids',tradesId);}},{key:'updateWorkOrder',value:function updateWorkOrder(workOrderId,values){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/work_orders/'+workOrderId,{work_order:values}).then(function(response){return{ok:true,workOrder:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'_updateWorkOrder',value:function _updateWorkOrder(workOrderId,attribute,value){var workOrderData={};workOrderData[attribute]=value;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/work_orders/'+workOrderId,{work_order:workOrderData}).then(function(response){return{ok:true,workOrder:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getSummary',value:function getSummary(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders/'+workOrderId+'/summary').then(function(response){return{ok:true,summary:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'confirmWorkOrder',value:function confirmWorkOrder(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/work_orders/'+workOrderId+'/submit').then(function(response){return{ok:true,workOrder:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'requestSubmit',value:function requestSubmit(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/work_orders/'+workOrderId+'/request_submit').then(function(response){return{ok:true,workOrder:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'deleteWorkOrder',value:function deleteWorkOrder(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/work_orders/'+workOrderId).then(function(){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'uploadDocuments',value:function uploadDocuments(workOrderId,documents){var data=new FormData();documents.forEach(function(document){data.append('documents[][document]',document);});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/work_orders/'+workOrderId+'/documents',data).then(function(response){return{ok:true,documents:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'deleteDocument',value:function deleteDocument(workOrderId,documentId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/work_orders/'+workOrderId+'/documents/'+documentId).then(function(){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getTasks',value:function getTasks(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders/'+workOrderId+'/tasks').then(function(response){return{ok:true,tasks:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getQuotes',value:function getQuotes(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders/'+workOrderId+'/quotes').then(function(response){return{ok:true,quotes:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getProposals',value:function getProposals(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders/'+workOrderId+'/proposals').then(function(response){return{ok:true,proposals:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getNotes',value:function getNotes(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders/'+workOrderId+'/notes').then(function(response){return{ok:true,notes:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'addNote',value:function addNote(workOrderId,content){var headers={headers:{'Content-Type':'multipart/form-data'}};var apiPayload=new FormData();apiPayload.append('note[content]',content.content);var index=0;if(content.images&&content.images.length>0){content.images.filter(function(image){return!image.id;}).forEach(function(image){apiPayload.append('note[images_attributes]['+index+'][image]',image.file,image.file.name);index++;});}index=0;if(content.documents&&content.documents.length>0){content.documents.filter(function(doc){return!doc.id;}).forEach(function(doc){apiPayload.append('note[documents_attributes]['+index+'][document]',doc.file,doc.file.name);index++;});}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/work_orders/'+workOrderId+'/notes',apiPayload,headers).then(function(response){return{ok:true,note:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'markNotesAsReaded',value:function markNotesAsReaded(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/work_orders/'+workOrderId+'/notes/mark_all_read').then(function(){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'addMember',value:function addMember(workOrderId,userId,note){var data={work_order_user:{user_id:userId}};if(note!==''){data['work_order_user']['note']=note;}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/work_orders/'+workOrderId+'/work_order_users',data).then(function(response){return{ok:true,member:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getOpenItems',value:function getOpenItems(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders/'+workOrderId+'/open_items').then(function(response){return{ok:true,openItems:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getMembers',value:function getMembers(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders/'+workOrderId+'/work_order_users').then(function(response){return{ok:true,members:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createJobNumber',value:function createJobNumber(workOrderId,value){var data={work_order_job:{number:value}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/work_orders/'+workOrderId+'/work_order_jobs',data,{loadingDisabled:true}).then(function(response){return{ok:true,workOrderJob:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateJobNumber',value:function updateJobNumber(workOrderJobId,value){var data={work_order_job:{number:value}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/work_order_jobs/'+workOrderJobId,data,{loadingDisabled:true}).then(function(response){return{ok:true,workOrderJob:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateName',value:function updateName(workOrderId,value){var data={work_order:{name:value}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/work_orders/'+workOrderId,data,{loadingDisabled:true}).then(function(response){return{ok:true,workOrder:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateNote',value:function updateNote(workOrderId,value,reminderValue){var data={work_order:{note:value,note_reminder_date:reminderValue}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/work_orders/'+workOrderId,data,{loadingDisabled:true}).then(function(response){return{ok:true,workOrder:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createBudget',value:function createBudget(workOrderId,taskValuesById,qualifications,qualificationsById){var data={budget:{budget_tasks_attributes:Object.keys(taskValuesById).map(function(taskId){return{task_id:taskId,cost:taskValuesById[taskId].cost,fee:taskValuesById[taskId].fee,insurance:taskValuesById[taskId].insurance,markup:taskValuesById[taskId].markup};}),budget_qualifications_attributes:qualifications.filter(function(q){return qualificationsById[q.id];}).map(function(q){var value=qualificationsById[q.id];return{qualification_id:value.id,option:value.option!==null?value.option.label:null};})}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/work_orders/'+workOrderId+'/budget',data).then(function(response){return{ok:true,budget:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateBudget',value:function updateBudget(workOrderId,budgetTasks,budgetQualifications){var data={budget:{budget_tasks_attributes:budgetTasks,budget_qualifications_attributes:budgetQualifications}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/work_orders/'+workOrderId+'/budget',data).then(function(response){return{ok:true,budget:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getBudget',value:function getBudget(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders/'+workOrderId+'/budget').then(function(response){return{ok:true,budget:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'approveBudget',value:function approveBudget(workOrderId,tasksId){var data={budget:{task_ids:tasksId}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/work_orders/'+workOrderId+'/budget/approve',data).then(function(response){return{ok:true,budget:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updatePurchaseOrder',value:function updatePurchaseOrder(workOrderId){var file=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var number=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var formData=new FormData();if(number!==null&&number!==''){formData.append('work_order[purchase_order]',number.toString());}if(file!==null){formData.append('work_order[purchase_order_doc_attributes][document]',file);}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/work_orders/'+workOrderId,formData,{headers:{'Content-Type':'multipart/form-data'}}).then(function(response){return{ok:true,workOrder:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getBudgetAsPdf',value:function getBudgetAsPdf(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders/'+workOrderId+'/budget/print',{responseType:'blob'}).then(function(response){return{ok:true,pdf:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'sendBudgetEmail',value:function sendBudgetEmail(workOrderId,emails,subject,message){var data={budget:{send_to:emails,subject:subject,message:message}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/work_orders/'+workOrderId+'/budget/email',data).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getContractorInvoices',value:function getContractorInvoices(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders/'+workOrderId+'/contractor_invoices').then(function(response){return{ok:true,invoices:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'uploadContractorInvoice',value:function uploadContractorInvoice(workOrderId,values){var data=new FormData();data.append('contractor_invoice[cost]',values.cost);data.append('contractor_invoice[document_attributes][document]',values.document);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/work_orders/'+workOrderId+'/contractor_invoices',data).then(function(response){return{ok:true,contractorInvoice:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getContractorLienReleases',value:function getContractorLienReleases(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders/'+workOrderId+'/contractor_lien_releases').then(function(response){return{ok:true,lienReleases:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'uploadContractorLienRelease',value:function uploadContractorLienRelease(workOrderId,document){var data=new FormData();data.append('contractor_lien_release[document_attributes][document]',document);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/work_orders/'+workOrderId+'/contractor_lien_releases',data).then(function(response){return{ok:true,contractorLienRelease:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getReceipts',value:function getReceipts(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders/'+workOrderId+'/receipts').then(function(response){return{ok:true,receipts:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getTime',value:function getTime(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders/'+workOrderId+'/time_entries').then(function(response){return{ok:true,time:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getVendorInvoices',value:function getVendorInvoices(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders/'+workOrderId+'/vendor_invoices').then(function(response){return{ok:true,invoices:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'declineBudget',value:function declineBudget(workOrderId,values){var apiPayload={budget:{password:values.password,rejected_reason_1:values.reason,rejected_reason_2:values.additionalInfo}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/work_orders/'+workOrderId+'/budget/reject',apiPayload).then(function(response){return{ok:true,budget:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'changeClient',value:function changeClient(workOrderId,clientId){var apiPayload={work_order:{client_id:clientId}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/work_orders/'+workOrderId+'/transfer',apiPayload).then(function(){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'submitQuotes',value:function submitQuotes(workOrderId,contractorId,values){var apiPayload={contractor:{quotes_attributes:values.map(function(item){var result={id:item.quoteId,estimate:item.totalCost,start_date:item.startDate,days_of_duration:item.durationInDays,material_lead_days:item.materialLeadDays,description:item.description};return result;})}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/work_orders/'+workOrderId+'/contractors/'+contractorId+'/submit_quotes',apiPayload).then(function(response){return{ok:true,quotes:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateWorkOrderAcrDocs',value:function updateWorkOrderAcrDocs(workOrderId,docs,docToDestroyId){var docsIndex=0;var workOrderData=new FormData();if(docs&&docs.length>0){docs.forEach(function(doc){workOrderData.append('work_order[acr_documents_attributes]['+docsIndex+'][document]',doc);docsIndex++;});}if(docToDestroyId){workOrderData.append('work_order[acr_documents_attributes]['+docsIndex+'][id]',docToDestroyId);workOrderData.append('work_order[acr_documents_attributes]['+docsIndex+'][_destroy]',true);}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/work_orders/'+workOrderId,workOrderData,{headers:{'Content-Type':'multipart/form-data'}}).then(function(response){return{ok:true,workOrder:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return WorkOrdersApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var workOrdersApi=new WorkOrdersApi();/* harmony default export */ __webpack_exports__["a"] = (WorkOrdersApi=new WorkOrdersApi());

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WorkOrderStatusKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WorkOrderStatusEnum; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var keys={};var WorkOrderStatusKeys={DRAFT:'draft',PENDING:'pending',PLM:'plm',WOA:'woa',IN_PROGRESS:'in_progress',COMPLETE:'complete',CLOSED:'closed',DECLINED:'declined',UNKNOWN:'unknown'};var WorkOrderStatusEnum=function(){function WorkOrderStatusEnum(status,label){_classCallCheck(this,WorkOrderStatusEnum);this.status=status;this.label=label;keys[status]=this;}_createClass(WorkOrderStatusEnum,[{key:'equals',value:function equals(workOrderStatusEnum){return this.status===workOrderStatusEnum.status;}}],[{key:'create',value:function create(status){if(keys[status]){return keys[status];}return WorkOrderStatusEnum.UNKNOWN;}}]);return WorkOrderStatusEnum;}();WorkOrderStatusEnum.DRAFT=new WorkOrderStatusEnum('draft','Draft');WorkOrderStatusEnum.PENDING=new WorkOrderStatusEnum('pending','Pending');WorkOrderStatusEnum.PLM=new WorkOrderStatusEnum('plm','PLM');WorkOrderStatusEnum.WOA=new WorkOrderStatusEnum('woa','WOA');WorkOrderStatusEnum.IN_PROGRESS=new WorkOrderStatusEnum('in_progress','In Progress');WorkOrderStatusEnum.COMPLETE=new WorkOrderStatusEnum('complete','Complete');WorkOrderStatusEnum.CLOSED=new WorkOrderStatusEnum('closed','Closed');WorkOrderStatusEnum.DECLINED=new WorkOrderStatusEnum('declined','Declined');WorkOrderStatusEnum.UNKNOWN=new WorkOrderStatusEnum('unknown','Unknown');

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(802);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
var MAP = (exports.MAP = "__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

// export const SKELETON = `__SECRET_SKELETON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`;

var MARKER = (exports.MARKER =
  "__SECRET_MARKER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var MARKER_WITH_LABEL = (exports.MARKER_WITH_LABEL =
  "__SECRET_MARKER_WITH_LABEL_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var RECTANGLE = (exports.RECTANGLE =
  "__SECRET_RECTANGLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var POLYLINE = (exports.POLYLINE =
  "__SECRET_POLYLINE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var POLYGON = (exports.POLYGON =
  "__SECRET_POLYGON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var CIRCLE = (exports.CIRCLE =
  "__SECRET_CIRCLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var KML_LAYER = (exports.KML_LAYER =
  "__SECRET_KML_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var DIRECTIONS_RENDERER = (exports.DIRECTIONS_RENDERER =
  "__SECRET_DIRECTIONS_RENDERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var HEATMAP_LAYER = (exports.HEATMAP_LAYER =
  "__SECRET_HEATMAP_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var FUSION_TABLES_LAYER = (exports.FUSION_TABLES_LAYER =
  "__SECRET_FUSION_TABLES_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var ANCHOR = (exports.ANCHOR =
  "__SECRET_ANCHOR_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var INFO_WINDOW = (exports.INFO_WINDOW =
  "__SECRET_INFO_WINDOW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var OVERLAY_VIEW = (exports.OVERLAY_VIEW =
  "__SECRET_OVERLAY_VIEW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var GROUND_LAYER = (exports.GROUND_LAYER =
  "__SECRET_GROUND_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var DRAWING_MANAGER = (exports.DRAWING_MANAGER =
  "__SECRET_DRAWING_MANAGER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var SEARCH_BOX = (exports.SEARCH_BOX =
  "__SECRET_SEARCH_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var MARKER_CLUSTERER = (exports.MARKER_CLUSTERER =
  "__SECRET_MARKER_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var INFO_BOX = (exports.INFO_BOX =
  "__SECRET_INFO_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var TRAFFIC_LAYER = (exports.TRAFFIC_LAYER =
  "__SECRET_TRAFFIC_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var STREET_VIEW_PANORAMA = (exports.STREET_VIEW_PANORAMA =
  "__SECRET_STREET_VIEW_PANORAMA_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var BICYCLING_LAYER = (exports.BICYCLING_LAYER =
  "__SECRET_BICYCLING_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_check_circle_png__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_check_circle_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_check_circle_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MessageModal_css__ = __webpack_require__(1944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MessageModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MessageModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MessageModal=function(_Component){_inherits(MessageModal,_Component);function MessageModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MessageModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MessageModal.__proto__||Object.getPrototypeOf(MessageModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleOk=function(){if(_this.props.onHide){_this.props.onHide();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MessageModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */],{show:this.props.show,className:'message-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-modal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.icon,alt:'message-modal-img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h3'},this.props.message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{label:'Ok',className:'button-orange ok-button',onClick:this.handleOk})))));}}]);return MessageModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MessageModal.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,message:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,onHide:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};MessageModal.defaultProps={icon:__WEBPACK_IMPORTED_MODULE_3_images_check_circle_png___default.a};/* harmony default export */ __webpack_exports__["a"] = (MessageModal);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initProjectDetails;
/* unused harmony export loadProjectSuccess */
/* harmony export (immutable) */ __webpack_exports__["b"] = loadProjectRequest;
/* harmony export (immutable) */ __webpack_exports__["c"] = selectNavigationBar;
/* harmony export (immutable) */ __webpack_exports__["d"] = sendProjectResourceEmails;
/* harmony export (immutable) */ __webpack_exports__["e"] = setShowPdfViewer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_projects_api__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_store_action_types__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_project_resource_mailer_api__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_email_modal_store_actions__ = __webpack_require__(148);
function initProjectDetails(){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_store_action_types__["b" /* PROJECT_DETAILS_INIT */]};}function loadProjectSuccess(project){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_store_action_types__["a" /* PROJECT_DETAILS_CURRENT_PROJECT_SET */],payload:project};}function loadProjectRequest(prjectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_projects_api__["a" /* projectsApi */].getProject(prjectId).then(function(response){if(response.ok){dispatch(loadProjectSuccess(response.project));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function selectNavigationBar(value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_store_action_types__["c" /* PROJECT_DETAILS_NAV_BAR_SELECTION */],payload:value});};}function sendProjectResourceEmails(resourceId,resourceType,emailData){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_project_resource_mailer_api__["a" /* projectResourceMailerApi */].postResourceEmails(resourceId,resourceType,emailData).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_email_modal_store_actions__["j" /* setShowEmailModal */])(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setShowPdfViewer(showPdfViewer){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_store_action_types__["d" /* SHOW_PDF_VIEWER_SET */],payload:showPdfViewer};}

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["O"] = setContributors;
/* harmony export (immutable) */ __webpack_exports__["P"] = setCurrentDailyReport;
/* harmony export (immutable) */ __webpack_exports__["_10"] = setShowDailyReportModal;
/* harmony export (immutable) */ __webpack_exports__["_12"] = setShowFieldWorkOrderModal;
/* unused harmony export loadFieldWorkOrderSuccess */
/* unused harmony export loadDailyReportsSuccess */
/* unused harmony export updateDailyReports */
/* unused harmony export addDailyReportSuccess */
/* unused harmony export afterDailyReportSave */
/* harmony export (immutable) */ __webpack_exports__["a"] = addDailyReport;
/* harmony export (immutable) */ __webpack_exports__["j"] = dailyReportFinaleUpdate;
/* harmony export (immutable) */ __webpack_exports__["_15"] = updateDailyReport;
/* harmony export (immutable) */ __webpack_exports__["b"] = addDailyReportEntries;
/* harmony export (immutable) */ __webpack_exports__["E"] = loadFullReportsRequest;
/* harmony export (immutable) */ __webpack_exports__["C"] = loadDailyReportsRequest;
/* harmony export (immutable) */ __webpack_exports__["D"] = loadFieldWorkOrdersRequest;
/* unused harmony export loadFieldWorkOrdersSuccess */
/* unused harmony export setDailyReportsIds */
/* harmony export (immutable) */ __webpack_exports__["J"] = openFieldWorkOrder;
/* harmony export (immutable) */ __webpack_exports__["I"] = openDraftReport;
/* harmony export (immutable) */ __webpack_exports__["G"] = loadPresetTasksSuccess;
/* harmony export (immutable) */ __webpack_exports__["F"] = loadPresetTasksRequest;
/* unused harmony export loadSupervisorTasksSuccess */
/* harmony export (immutable) */ __webpack_exports__["H"] = loadSupervisorTasksRequest;
/* harmony export (immutable) */ __webpack_exports__["d"] = addDailyReportMembers;
/* harmony export (immutable) */ __webpack_exports__["M"] = setActiveContributor;
/* harmony export (immutable) */ __webpack_exports__["N"] = setActiveEntriesId;
/* unused harmony export initializeTradeForm */
/* harmony export (immutable) */ __webpack_exports__["_17"] = updateTradeForm;
/* harmony export (immutable) */ __webpack_exports__["v"] = handleWorkedFrom;
/* harmony export (immutable) */ __webpack_exports__["s"] = handleDateMoreInfo;
/* harmony export (immutable) */ __webpack_exports__["w"] = handleWorkedTo;
/* harmony export (immutable) */ __webpack_exports__["q"] = handleAttributeChangeForSub;
/* harmony export (immutable) */ __webpack_exports__["r"] = handleAttributeChangeForSubMoreAction;
/* harmony export (immutable) */ __webpack_exports__["t"] = handleHoursAmountAction;
/* harmony export (immutable) */ __webpack_exports__["u"] = handleHoursAmountActionMoreAction;
/* harmony export (immutable) */ __webpack_exports__["h"] = changeAmountOfTechnicians;
/* harmony export (immutable) */ __webpack_exports__["g"] = addedDeletedTechnicians;
/* harmony export (immutable) */ __webpack_exports__["p"] = handleAttributeChangeAction;
/* harmony export (immutable) */ __webpack_exports__["_9"] = setReviewFormAction;
/* harmony export (immutable) */ __webpack_exports__["_13"] = setSubmittedReport;
/* harmony export (immutable) */ __webpack_exports__["i"] = clearFormAction;
/* unused harmony export loadDailyReportLogPdfSuccess */
/* harmony export (immutable) */ __webpack_exports__["A"] = loadDailyReportLogPdfRequest;
/* harmony export (immutable) */ __webpack_exports__["R"] = setDailyReportLogPdfViewer;
/* harmony export (immutable) */ __webpack_exports__["V"] = setEditMode;
/* unused harmony export deleteDailyReportSuccess */
/* harmony export (immutable) */ __webpack_exports__["m"] = deleteReportRequest;
/* harmony export (immutable) */ __webpack_exports__["_8"] = setReportPdfViewer;
/* unused harmony export loadReportPdfSuccess */
/* harmony export (immutable) */ __webpack_exports__["B"] = loadDailyReportlPdf;
/* harmony export (immutable) */ __webpack_exports__["L"] = sendDailyReportEmails;
/* harmony export (immutable) */ __webpack_exports__["_3"] = setReportDate;
/* harmony export (immutable) */ __webpack_exports__["_5"] = setReportExtraInputs;
/* harmony export (immutable) */ __webpack_exports__["_4"] = setReportExtraInput;
/* harmony export (immutable) */ __webpack_exports__["_6"] = setReportOpenItem;
/* harmony export (immutable) */ __webpack_exports__["_7"] = setReportOpenItemValue;
/* harmony export (immutable) */ __webpack_exports__["_0"] = setGeneralContractorName;
/* harmony export (immutable) */ __webpack_exports__["_1"] = setMemberForm;
/* harmony export (immutable) */ __webpack_exports__["_2"] = setMembers;
/* harmony export (immutable) */ __webpack_exports__["T"] = setDeletedMembers;
/* unused harmony export setCurrentPage */
/* unused harmony export setReportsTotal */
/* unused harmony export setReportsPageSize */
/* harmony export (immutable) */ __webpack_exports__["Z"] = setGCImagesAction;
/* harmony export (immutable) */ __webpack_exports__["Y"] = setGCDeletedImagesAction;
/* harmony export (immutable) */ __webpack_exports__["U"] = setDelivery;
/* harmony export (immutable) */ __webpack_exports__["e"] = addExtraInput;
/* harmony export (immutable) */ __webpack_exports__["l"] = deleteDelivery;
/* harmony export (immutable) */ __webpack_exports__["K"] = removeDeliveriesExtraInput;
/* harmony export (immutable) */ __webpack_exports__["S"] = setDailyReportTab;
/* unused harmony export subDailyReportsCountSuccess */
/* harmony export (immutable) */ __webpack_exports__["_14"] = subDailyReportsCount;
/* harmony export (immutable) */ __webpack_exports__["y"] = initSubDailyReportsCount;
/* unused harmony export buildFieldWorkOrderForm */
/* harmony export (immutable) */ __webpack_exports__["x"] = initFieldWorkOrderForm;
/* harmony export (immutable) */ __webpack_exports__["X"] = setFieldWorkOrderFormAttribute;
/* harmony export (immutable) */ __webpack_exports__["W"] = setFieldWorkOrderEdit;
/* harmony export (immutable) */ __webpack_exports__["_11"] = setShowFieldWorkOrderError;
/* unused harmony export updateFieldWorkOrderSuccess */
/* harmony export (immutable) */ __webpack_exports__["_16"] = updateFieldWorkOrder;
/* harmony export (immutable) */ __webpack_exports__["Q"] = setDailyReportAddFloor;
/* harmony export (immutable) */ __webpack_exports__["c"] = addDailyReportEntriesFloor;
/* harmony export (immutable) */ __webpack_exports__["k"] = deleteDailyReportEntry;
/* harmony export (immutable) */ __webpack_exports__["f"] = addSubDailyReportEntriesFloor;
/* harmony export (immutable) */ __webpack_exports__["n"] = deleteSubDailyReportEntry;
/* unused harmony export duplicateDailyReportSuccess */
/* harmony export (immutable) */ __webpack_exports__["o"] = duplicateDailyReport;
/* harmony export (immutable) */ __webpack_exports__["z"] = loadDailyReportInBkg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_utils_daily_report_util__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_daily_reports_api__ = __webpack_require__(2515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_sub_daily_reports_api__ = __webpack_require__(2516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_field_work_orders_api__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_api_daily_reports_entries_api__ = __webpack_require__(2517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_api_sub_daily_reports_entries_api__ = __webpack_require__(2518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_api_project_resource_mailer_api__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_api_csi_codes_api__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_selectors__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_email_modal_store_actions__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_utils_date_util__ = __webpack_require__(39);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function prepareResponseForSubDailyReports(response){var resultResponse=Object.assign({},response,{dailyReport:Object.assign({},response.dailyReport,{daily_report_entries:response.dailyReport.sub_daily_report_entries?response.dailyReport.sub_daily_report_entries.map(function(entry){return Object.assign({},entry,{daily_report_id:entry.sub_daily_report_id});}):[],daily_report_id:response.dailyReport.sub_daily_report_id})});return resultResponse;}function setContributors(contributors){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["B" /* SET_CONTRIBUTORS */],payload:contributors};}function setCurrentDailyReport(dailyReport){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["C" /* SET_CURRENT_DAILY_REPORT */],payload:dailyReport};}function setShowDailyReportModal(showEditUserModal){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["_6" /* SHOW_ADD_DAILY_REPORT_SET */],payload:showEditUserModal};}function setShowFieldWorkOrderModal(showFieldWorkOrderModal){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["_3" /* SET_SHOW_FIELD_WORK_ORDER */],payload:showFieldWorkOrderModal};}function loadFieldWorkOrderSuccess(fieldWorkOrder){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["n" /* FIELD_WORK_ORDER_SET */],payload:fieldWorkOrder};}function loadDailyReportsSuccess(dailyReports){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["f" /* DAILY_REPORTS_SET */],payload:dailyReports};}function updateDailyReports(dailyReport){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["g" /* DAILY_REPORTS_UPDATE */],payload:dailyReport};}function addDailyReportSuccess(dailyReport){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["b" /* ADD_DAILY_REPORT_SUCCESS */],payload:dailyReport};}function afterDailyReportSave(response){var editTrades=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var generalContactorName=arguments[2];var isSubDailyReports=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;return function(dispatch,getState){var dailyReport=response.dailyReport;var currentContribForm=Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_selectors__["e" /* getContributorsForm */])(getState());var currentContribFormIds=Object.keys(currentContribForm);if(!editTrades){if(generalContactorName){dispatch(setMemberForm(true));}dispatch(addDailyReportSuccess(dailyReport));if(dailyReport.daily_report_entries.length>0){dispatch(setActiveEntriesId(dailyReport.daily_report_entries[0].id));dispatch(setActiveContributor(1));}}else{dispatch(updateDailyReports(dailyReport));}var setupTradeForm={};var defaultInfo={hoursAmount:'',workedFrom:'',workedTo:'',location:'',customTask:'',workPerformed:'',presetTasks:[]};var defaultTechnician={hoursAmount:'',workedFrom:'',workedTo:''};var defaultTechnicianForSub=Object.assign({},defaultInfo,{tech:{value:1,label:'Technician 1',custom:true},additionalInfo:[]});var defaultTechnicianValue=isSubDailyReports?defaultTechnicianForSub:defaultTechnician;if(dailyReport.daily_report_entries&&dailyReport.daily_report_entries.length>0){dailyReport.daily_report_entries.forEach(function(report){var existingReportId=currentContribFormIds.find(function(id){return report.id===+id;});if(existingReportId){setupTradeForm[report.id]=currentContribForm[existingReportId];}else{setupTradeForm[report.id]={technicians:[defaultTechnicianValue],deletedTechnicians:[],isDelay:false,isFieldWorkOrder:false,floor:'',area:''};}});dispatch(updateTradeForm(setupTradeForm));}};}function addDailyReport(values,reportDate,projectId,generalContactorName){var isSubDailyReports=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;var resultApi=isSubDailyReports?__WEBPACK_IMPORTED_MODULE_3_services_api_sub_daily_reports_api__["a" /* subDailyReportsApi */]:__WEBPACK_IMPORTED_MODULE_2_services_api_daily_reports_api__["a" /* dailyReportsApi */];return function(dispatch){var resultValues=values.map(function(item){return{project_contributor_id:item[0]};});return resultApi.addDailyReport(resultValues,reportDate,projectId,generalContactorName).then(function(response){if(response.ok){var resultResponse=response;if(isSubDailyReports){resultResponse=prepareResponseForSubDailyReports(response);}dispatch(afterDailyReportSave(resultResponse,false,generalContactorName,isSubDailyReports));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function dailyReportFinaleUpdate(projectId,reportId,values,reportStatus,isSubDailyReports){var resultApi=isSubDailyReports?__WEBPACK_IMPORTED_MODULE_3_services_api_sub_daily_reports_api__["a" /* subDailyReportsApi */]:__WEBPACK_IMPORTED_MODULE_2_services_api_daily_reports_api__["a" /* dailyReportsApi */];return function(dispatch){return resultApi.updateDailyReport(values,projectId,reportId).then(function(response){if(response.ok){var resultResponse=response;if(isSubDailyReports){resultResponse=prepareResponseForSubDailyReports(response);}if(reportStatus!=='submitted'){dispatch(setSubmittedReport(true));}dispatch(updateDailyReports(resultResponse.dailyReport));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateDailyReport(values,projectId,dailyReport,editTrades,reportDate,generalContactorName){var isSubDailyReports=arguments.length>6&&arguments[6]!==undefined?arguments[6]:false;var resultApi=isSubDailyReports?__WEBPACK_IMPORTED_MODULE_3_services_api_sub_daily_reports_api__["a" /* subDailyReportsApi */]:__WEBPACK_IMPORTED_MODULE_2_services_api_daily_reports_api__["a" /* dailyReportsApi */];return function(dispatch){var resultValues=[].concat(_toConsumableArray(values.map(function(item){var contrib={project_contributor_id:item[0]};var dailyReportEntry=dailyReport.daily_report_entries.find(function(entry){return entry.project_contributor_id===item[0];});if(dailyReportEntry){contrib.id=dailyReportEntry.id;}return contrib;})),_toConsumableArray(dailyReport.daily_report_entries.map(function(entry){var contrib=values.find(function(item){return entry.project_contributor_id===item[0];});return!contrib&&{id:entry.id,_destroy:true};}))).filter(function(entry){return!!entry;});var results={reportDate:reportDate,gcStaffOnSite:!!generalContactorName,dailyReportEntriesAttributes:resultValues};return resultApi.updateDailyReport(results,projectId,dailyReport.id).then(function(response){if(response.ok){var resultResponse=response;if(isSubDailyReports){resultResponse=prepareResponseForSubDailyReports(response);}dispatch(afterDailyReportSave(resultResponse,editTrades,generalContactorName,isSubDailyReports));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function addDailyReportEntries(values,reportId,imagesFromStore,isLastContributor,editMode,projectId,isSubDailyReports,isChildFloor,isDraft){var resultApi=isSubDailyReports?__WEBPACK_IMPORTED_MODULE_6_services_api_sub_daily_reports_entries_api__["a" /* subDailyReportsEntriesApi */]:__WEBPACK_IMPORTED_MODULE_5_services_api_daily_reports_entries_api__["a" /* dailyReportsEntriesApi */];return function(dispatch){return resultApi.updateDailyReportEntry(values,reportId).then(function(response){if(response.ok){var resultResponse=response;if(isSubDailyReports){resultResponse=prepareResponseForSubDailyReports(response);}var _resultResponse=resultResponse,dailyReport=_resultResponse.dailyReport;var techList=null;if(dailyReport.technicians&&dailyReport.technicians.length){techList=dailyReport.technicians;}if(dailyReport.sub_daily_report_teches&&dailyReport.sub_daily_report_teches.length){techList=dailyReport.sub_daily_report_teches;}var technicians=[];var techId=null;var techRes={};if(techList&&techList.length){var resultTechList=techList;if(isSubDailyReports){var techListTechNumbers=techList.filter(function(tech){return!tech.sub_technician_id&&tech.tech_number;}).sort(function(tech1,tech2){return tech1.tech_number-tech2.tech_number;});var techListSubTechIds=techList.filter(function(tech){return tech.sub_technician_id;}).sort(function(tech1,tech2){return tech1.sub_technician_id-tech2.sub_technician_id;});resultTechList=[].concat(_toConsumableArray(techListTechNumbers),_toConsumableArray(techListSubTechIds));}resultTechList.forEach(function(technician){var resultValue=Object.assign({},technician,{id:technician.id,workPerformed:technician.work_performed,location:technician.location,presetTasks:technician.preset_tasks&&technician.preset_tasks.map(function(task){return[task.id,task.label];}),customTask:technician.preset_task_other});if(technician.sub_technician){resultValue.sub_technician={value:technician.sub_technician.id,label:technician.sub_technician.first_name+' '+(technician.sub_technician.last_name||'')};}resultValue.tech={value:technician.tech_number,label:'Technician '+technician.tech_number,custom:true};if(technician.started_at||technician.ended_at){resultValue.hoursAmount='';resultValue.workedFrom=technician.started_at;resultValue.workedTo=technician.ended_at;}else{resultValue.hoursAmount=''+(technician.hours_worked||'');resultValue.workedFrom='';resultValue.workedTo='';}if(isSubDailyReports){var newTechId=technician.sub_technician_id||technician.tech_number;if(techId!==newTechId){techRes=resultValue;techId=newTechId;technicians.push(techRes);}else{if(techRes.additionalInfo){var isExisting=techRes.additionalInfo.find(function(el){return el.id===technician.id;});if(!isExisting){techRes.additionalInfo.push(resultValue);}}else{techRes.additionalInfo=[resultValue];}}}else{technicians.push(resultValue);}});}if(imagesFromStore&&imagesFromStore.length>0){var newImages=dailyReport.images.map(function(file){return Object.assign({},file,{url:file.image.gallery.url});});dispatch(handleAttributeChangeAction('images',newImages,dailyReport.id));}if(technicians.length){technicians.sort(function(tech1,tech2){return tech1.tech.value-tech2.tech.value;});dispatch(handleAttributeChangeAction('technicians',technicians,dailyReport.id));}dispatch(handleAttributeChangeAction('deletedTechnicians',[],dailyReport.id));dispatch(handleAttributeChangeAction('deletedImages',[],dailyReport.id));dispatch(handleAttributeChangeAction('openItemDeletedImages',[],dailyReport.id));dispatch(handleAttributeChangeAction('openItemDeletedDocuments',[],dailyReport.id));if(!dailyReport.project_open_item){dispatch(handleAttributeChangeAction('openItemId','',dailyReport.id));dispatch(handleAttributeChangeAction('openItemAssigneeId','',dailyReport.id));dispatch(handleAttributeChangeAction('openItemDesc','',dailyReport.id));dispatch(handleAttributeChangeAction('openItemResolveBy','',dailyReport.id));dispatch(handleAttributeChangeAction('openItemCritical',false,dailyReport.id));dispatch(handleAttributeChangeAction('openItemRecipients',[],dailyReport.id));dispatch(handleAttributeChangeAction('openItemImages',[],dailyReport.id));dispatch(handleAttributeChangeAction('openItemDocuments',[],dailyReport.id));}else{dispatch(handleAttributeChangeAction('openItemId',dailyReport.project_open_item.id,dailyReport.id));dispatch(handleAttributeChangeAction('openItemRecipients',dailyReport.project_open_item.recipients.map(function(rcpt){return[rcpt.id];})));dispatch(handleAttributeChangeAction('openItemImages',dailyReport.project_open_item.images.map(function(image){return Object.assign({},image,{url:image.image.gallery.url});}),dailyReport.id));dispatch(handleAttributeChangeAction('openItemDocuments',dailyReport.project_open_item.documents.map(function(doc){return Object.assign({},doc,{url:doc.document.url});}),dailyReport.id));}if(!dailyReport.field_work_order){dispatch(handleAttributeChangeAction('fwoId','',dailyReport.id));dispatch(handleAttributeChangeAction('fwoNumber','',dailyReport.id));dispatch(handleAttributeChangeAction('fwoPresetTasks',[],dailyReport.id));dispatch(handleAttributeChangeAction('fwoCustomTask','',dailyReport.id));dispatch(handleAttributeChangeAction('fwoWorkPerformed','',dailyReport.id));dispatch(handleAttributeChangeAction('fwoComments','',dailyReport.id));dispatch(handleAttributeChangeAction('fwoStartDate','',dailyReport.id));dispatch(handleAttributeChangeAction('fwoCompletionDate','',dailyReport.id));dispatch(handleAttributeChangeAction('fwoLabor','',dailyReport.id));dispatch(handleAttributeChangeAction('fwoMaterials','',dailyReport.id));}else{dispatch(handleAttributeChangeAction('fwoId',dailyReport.field_work_order.id,dailyReport.id));}dispatch(loadFullReportsRequest(projectId,dailyReport.daily_report_id,isSubDailyReports)).then(function(response){if(response.ok&&!isChildFloor&&!isDraft&&(isLastContributor||editMode)){dispatch(setReviewFormAction(true));dispatch(setEditMode(false));dispatch(setActiveContributor(0));dispatch(setActiveEntriesId(null));}});}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadFullReportsRequest(projectId,dailyReportId){var isSubDailyReport=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var newContributors=arguments[3];var resultApi=isSubDailyReport?__WEBPACK_IMPORTED_MODULE_3_services_api_sub_daily_reports_api__["a" /* subDailyReportsApi */]:__WEBPACK_IMPORTED_MODULE_2_services_api_daily_reports_api__["a" /* dailyReportsApi */];return function(dispatch){return resultApi.getDailyReport(projectId,dailyReportId).then(function(response){if(response.ok){var resultResponse=response;if(isSubDailyReport){resultResponse=prepareResponseForSubDailyReports(response);}var _response$dailyReport=response.dailyReport,inspections=_response$dailyReport.inspections,deliveries=_response$dailyReport.deliveries,visitors=_response$dailyReport.visitors,phone_calls=_response$dailyReport.phone_calls,received_submittals=_response$dailyReport.received_submittals,is_safety_accepted=_response$dailyReport.is_safety_accepted,safety=_response$dailyReport.safety;var images=resultResponse.dailyReport.images&&resultResponse.dailyReport.images.length>0?resultResponse.dailyReport.images.map(function(img){return Object.assign({},img,{url:img.image.url});}):[];dispatch(setCurrentDailyReport(resultResponse.dailyReport));dispatch(setGCImagesAction(images));dispatch(setReportExtraInputs({inspections:inspections,deliveries:deliveries,visitors:visitors,phone_calls:phone_calls,is_safety_accepted:is_safety_accepted,safety:safety}));if(received_submittals){dispatch(setDelivery(received_submittals));}if(newContributors&&newContributors.length>0){var setupTradeForm={};newContributors.forEach(function(contrib){var defaultInfo={hoursAmount:'',workedFrom:'',workedTo:'',location:'',customTask:'',workPerformed:'',presetTasks:[]};var defaultTechnicianForSub=Object.assign({},defaultInfo,{tech:{value:1,label:'Technician 1',custom:true},additionalInfo:[]});setupTradeForm[contrib]={technicians:[defaultTechnicianForSub],deletedTechnicians:[],isDelay:false,isFieldWorkOrder:false,floor:'',area:''};});dispatch(initializeTradeForm(setupTradeForm));}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadDailyReportsRequest(projectId,currentPage){var isSubDailyReports=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var resultApi=isSubDailyReports?__WEBPACK_IMPORTED_MODULE_3_services_api_sub_daily_reports_api__["a" /* subDailyReportsApi */]:__WEBPACK_IMPORTED_MODULE_2_services_api_daily_reports_api__["a" /* dailyReportsApi */];return function(dispatch){return resultApi.getDailyReports(projectId,currentPage).then(function(response){if(response.ok){dispatch(setCurrentPage(currentPage));dispatch(setReportsTotal(response.total));dispatch(setReportsPageSize(response.pageSize));dispatch(loadDailyReportsSuccess(response.dailyReports));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadFieldWorkOrdersRequest(projectId,currentPage,spackleOrGc){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_field_work_orders_api__["a" /* fieldWorkOrdersApi */].getFieldWorkOrders(projectId,currentPage,spackleOrGc).then(function(response){if(response.ok){dispatch(setCurrentPage(currentPage));dispatch(setReportsTotal(response.total));dispatch(setReportsPageSize(response.pageSize));dispatch(loadFieldWorkOrdersSuccess(response.fieldWorkOrders));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadFieldWorkOrdersSuccess(fieldWorkOrders){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["k" /* FIELD_WORK_ORDERS_SET */],payload:fieldWorkOrders};}function setDailyReportsIds(ids){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["R" /* SET_REPORTS_IDS */],payload:ids};}function openFieldWorkOrder(projectId,fieldWorkOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_field_work_orders_api__["a" /* fieldWorkOrdersApi */].getFieldWorkOrder(projectId,fieldWorkOrderId).then(function(response){if(response.ok){dispatch(loadFieldWorkOrderSuccess(response.fieldWorkOrder));dispatch(setShowFieldWorkOrderModal(true));}});};}function openDraftReport(projectId,dailyReportId){var isSubDailyReport=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var fromNotification=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;return function(dispatch){dispatch(loadFullReportsRequest(projectId,dailyReportId,isSubDailyReport)).then(function(response){if(response.ok){var resultResponse=response;if(isSubDailyReport){resultResponse=prepareResponseForSubDailyReports(response);if(fromNotification){dispatch(setDailyReportTab(2));dispatch(loadDailyReportsRequest(projectId,1,true));}}dispatch(setReviewFormAction(true));dispatch(setShowDailyReportModal(true));var contributors=[];var currentDailyReportIds=[];var setupTradeForm={};var members=[];if(resultResponse.dailyReport&&resultResponse.dailyReport.daily_report_entries){resultResponse.dailyReport.daily_report_entries.forEach(function(entry){currentDailyReportIds.push(entry.id);if(entry.project_contributor&&!entry.daily_report_entry_id&&!entry.sub_daily_report_entry_id){var label=__WEBPACK_IMPORTED_MODULE_0_services_utils_daily_report_util__["a" /* DailyReportUtil */].tradeLabel(entry.project_contributor);var contributor=[entry.project_contributor.id,label];contributors.push(contributor);}setupTradeForm[entry.id]={};setupTradeForm[entry.id].workPerformed=entry.work_performed;setupTradeForm[entry.id].floor=entry.floor||'';setupTradeForm[entry.id].area=entry.area||'';setupTradeForm[entry.id].comments=entry.comments||'';if(entry.project_open_item){setupTradeForm[entry.id].isDelay=true;setupTradeForm[entry.id].openItemId=entry.project_open_item.id;setupTradeForm[entry.id].openItemAssigneeId=entry.project_open_item.assignee_id;setupTradeForm[entry.id].openItemDesc=entry.project_open_item.description;setupTradeForm[entry.id].openItemResolveBy=entry.project_open_item.resolve_by;setupTradeForm[entry.id].openItemCritical=entry.project_open_item.critical;setupTradeForm[entry.id].openItemRecipients=entry.project_open_item.recipients.map(function(rcpt){return[rcpt.id];});setupTradeForm[entry.id].openItemImages=entry.project_open_item.images.map(function(image){return Object.assign({},image,{url:image.image.gallery.url});});setupTradeForm[entry.id].openItemDocuments=entry.project_open_item.documents.map(function(doc){return Object.assign({},doc,{url:doc.document.url});});}if(entry.field_work_order){setupTradeForm[entry.id].isFieldWorkOrder=true;setupTradeForm[entry.id].fwoId=entry.field_work_order.id;setupTradeForm[entry.id].fwoNumber=entry.field_work_order.number||'';setupTradeForm[entry.id].fwoPresetTasks=entry.field_work_order&&entry.field_work_order.preset_tasks?entry.field_work_order.preset_tasks.map(function(task){return[task.id,task.label];}):[];setupTradeForm[entry.id].fwoCustomTask=entry.field_work_order.preset_task_other||'';setupTradeForm[entry.id].fwoWorkPerformed=entry.field_work_order.work_performed||'';setupTradeForm[entry.id].fwoComments=entry.field_work_order.comments||'';setupTradeForm[entry.id].fwoStartDate=entry.field_work_order.start_date||'';setupTradeForm[entry.id].fwoCompletionDate=entry.field_work_order.completion_date||'';setupTradeForm[entry.id].fwoLabor=entry.field_work_order.labor||'';setupTradeForm[entry.id].fwoMaterials=entry.field_work_order.materials||'';}setupTradeForm[entry.id].presetTasks=entry.preset_tasks&&entry.preset_tasks.length>0?entry.preset_tasks.map(function(task){return[task.id,task.label];}):[];setupTradeForm[entry.id].customTask=entry.preset_task_other||'';setupTradeForm[entry.id].images=entry.images.length>0&&entry.images.map(function(image){return Object.assign({},image,{url:image.image.gallery.url});})||[];if(entry.technicians&&entry.technicians.length>0){setupTradeForm[entry.id].technicians=entry.technicians.map(function(technician){var techValues={id:technician.id,workedFrom:technician.started_at,workedTo:technician.ended_at};if(!technician.started_at&&!technician.workedTo){techValues.hoursAmount=''+(technician.hours_worked||'');}else{techValues.hoursAmount='';}return techValues;});}else{var defaultTechnician={hoursAmount:'',workedFrom:'',workedTo:''};setupTradeForm[entry.id].technicians=[defaultTechnician];}setupTradeForm[entry.id].deletedImages=[];setupTradeForm[entry.id].deletedTechnicians=[];if(isSubDailyReport&&entry.sub_daily_report_teches.length){var techId=0;var subTeches={};var subDailyReportTradesValues=entry.sub_daily_report_teches;subDailyReportTradesValues.forEach(function(tech){techId=tech.sub_technician_id||tech.tech_number;var technicianValue={};if(tech.sub_technician){technicianValue.sub_technician={value:tech.sub_technician.id,label:tech.sub_technician.first_name+' '+(tech.sub_technician.last_name||'')};}technicianValue.tech={value:tech.tech_number,label:'Technician '+tech.tech_number,custom:true};technicianValue.id=tech.id;technicianValue.hoursAmount=tech.hours_worked?tech.hours_worked.toString():'';technicianValue.workedFrom=tech.started_at||'';technicianValue.workedTo=tech.ended_at||'';technicianValue.customTask=tech.preset_task_other||'';technicianValue.location=tech.location||'';technicianValue.workPerformed=tech.work_performed||'';technicianValue.presetTasks=tech.preset_tasks.length?tech.preset_tasks.map(function(task){return[task.id,task.label];}):[];if(!subTeches.hasOwnProperty(techId)){subTeches[techId]=technicianValue;}else{var value={id:tech.id,hoursAmount:tech.hours_worked?tech.hours_worked.toString():'',workedFrom:tech.started_at||'',workedTo:tech.ended_at||'',customTask:tech.preset_task_other||'',location:tech.location,workPerformed:tech.work_performed,presetTasks:tech.preset_tasks.length?tech.preset_tasks.map(function(task){return[task.id,task.label];}):[]};if(subTeches[techId].additionalInfo){subTeches[techId].additionalInfo=[].concat(_toConsumableArray(subTeches[techId].additionalInfo),[value]);}else{subTeches[techId].additionalInfo=[value];}}});setupTradeForm[entry.id].technicians=Object.keys(subTeches).map(function(key){return subTeches[key];}).sort(function(tech1,tech2){return tech1.tech.value-tech2.tech.value;});}else if(isSubDailyReport&&!entry.sub_daily_report_teches.length){var defaultInfo={hoursAmount:'',workedFrom:'',workedTo:'',location:'',customTask:'',workPerformed:'',presetTasks:[]};var defaultTechnicianForSub=Object.assign({},defaultInfo,{tech:{value:1,label:'Technician 1',custom:true},additionalInfo:[]});setupTradeForm[entry.id]={technicians:[defaultTechnicianForSub],deletedTechnicians:[],isDelay:false,isFieldWorkOrder:false,floor:'',area:''};}});}if(resultResponse.dailyReport&&resultResponse.dailyReport.gc_staff_members&&resultResponse.dailyReport.gc_staff_members.length>0){members=[];resultResponse.dailyReport.gc_staff_members.forEach(function(member){var res={};res.user={};res.supervisorTasks=[];res.id=member.id;res.user.value=member.user.id;res.user.label=member.user.first_name+' '+member.user.last_name;if(member.supervisor_tasks&&member.supervisor_tasks.length>0){member.supervisor_tasks.forEach(function(task,index){res.supervisorTasks[index]=[task.id,task.label];});}res.isChildFloor=!!members.find(function(member2){return member2.user.value===member.user_id;});res.floor=member.floor||'';res.area=member.area||'';res.comments=member.comments||'';res.customTask=member.supervisor_task_other||'';res.workedFrom=member.started_at||'';res.workedTo=member.ended_at||'';res.hoursAmount=member.started_at||member.ended_at?'':''+(member.hours_worked||'');members.push(res);});}if(members.length>0){dispatch(setMembers(members));}if(resultResponse.dailyReport&&resultResponse.dailyReport.project_open_item){var project_open_item=resultResponse.dailyReport.project_open_item;dispatch(setReportOpenItem({isDelay:true,openItemId:project_open_item.id,openItemAssigneeId:project_open_item.assignee_id,openItemDesc:project_open_item.description,openItemResolveBy:project_open_item.resolve_by,openItemCritical:project_open_item.critical,openItemRecipients:project_open_item.recipients.map(function(rcpt){return[rcpt.id];}),openItemImages:project_open_item.images.map(function(image){return Object.assign({},image,{url:image.image.gallery.url});}),openItemDocuments:project_open_item.documents.map(function(doc){return Object.assign({},doc,{url:doc.document.url});})}));}if(resultResponse.dailyReport&&resultResponse.dailyReport.report_date){dispatch(setReportDate(resultResponse.dailyReport.report_date));}dispatch(setDailyReportsIds(currentDailyReportIds));dispatch(setContributors(contributors));dispatch(initializeTradeForm(setupTradeForm));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadPresetTasksSuccess(presetTasks){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["x" /* LOAD_PRESET_TASKS */],payload:presetTasks};}function loadPresetTasksRequest(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_8_services_api_csi_codes_api__["a" /* csiCodesApi */].getPresetTasks(projectId).then(function(response){if(response.ok){dispatch(loadPresetTasksSuccess(response.presetTasks));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadSupervisorTasksSuccess(tasks){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["_5" /* SET_SUPERVISOR_TASKS */],payload:tasks};}function loadSupervisorTasksRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_8_services_api_csi_codes_api__["a" /* csiCodesApi */].getSupervisorTasks().then(function(response){if(response.ok){dispatch(loadSupervisorTasksSuccess(response.presetTasks));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function prepareDataForMembers(members,isDeleted){var resultValues=members.map(function(value){var res={};if(value.id){res.id=value.id;}res.user_id=value.user.value;res.floor=value.floor;res.area=value.area;res.supervisor_task_other=value.customTask;res.comments=value.comments;res.hours_worked=value.hoursAmount;res.started_at=Object(__WEBPACK_IMPORTED_MODULE_12_services_utils_date_util__["l" /* utcTime */])(value.workedFrom);res.ended_at=Object(__WEBPACK_IMPORTED_MODULE_12_services_utils_date_util__["l" /* utcTime */])(value.workedTo);if(value.supervisorTasks.length>0){res.supervisor_task_ids=value.supervisorTasks.map(function(task){return task[0];});}else{res.supervisor_task_ids=[];}if(isDeleted){res._destroy=true;}return res;});return resultValues;}function prepareDataForOpenItem(openItem){if(openItem.isDelay){return{id:openItem.openItemId,assignee_id:openItem.openItemAssigneeId||'',recipient_ids:openItem.openItemRecipients&&openItem.openItemRecipients.map(function(rcpt){return rcpt[0];}),description:openItem.openItemDesc||'',resolve_by:openItem.openItemResolveBy||'',critical:!!openItem.openItemCritical,images_attributes:openItem.openItemImages&&openItem.openItemImages.filter(function(img){return!!img.file;}),deleted_images_attributes:openItem.openItemDeletedImages&&openItem.openItemDeletedImages.filter(function(img){return!!img.id;}),documents_attributes:openItem.openItemDocuments&&openItem.openItemDocuments.filter(function(doc){return!!doc.file;}),deleted_documents_attributes:openItem.openItemDeletedDocuments&&openItem.openItemDeletedDocuments.filter(function(doc){return!!doc.id;})};}else if(openItem.openItemId){return{id:openItem.openItemId,_destroy:true};}}function addDailyReportMembers(projectId,reportId,members,deletedMembers,openItem,withSaveDraft,editMode,gcImages,gcDeletedImages){return function(dispatch){var addedValues=prepareDataForMembers(members);var deletedValues=[];if(deletedMembers&&deletedMembers.length>0){deletedValues=prepareDataForMembers(deletedMembers,true);}var resValues={gc_staff_members_attributes:addedValues.concat(deletedValues),project_open_item_attributes:prepareDataForOpenItem(openItem),gcImages:gcImages.filter(function(img){return img.file;}),gcDeletedImages:gcDeletedImages.filter(function(img){return img.id;})};return __WEBPACK_IMPORTED_MODULE_2_services_api_daily_reports_api__["a" /* dailyReportsApi */].addDailyReportMembers(resValues,projectId,reportId).then(function(response){if(response.ok){var dailyReport=response.dailyReport;var updatedValues=[].concat(_toConsumableArray(members));dailyReport.gc_staff_members.forEach(function(member,index){if(updatedValues[index]){updatedValues[index]=Object.assign({},members[index]);updatedValues[index].id=member.id;}});dispatch(setMembers(updatedValues));dispatch(setDeletedMembers([]));var images=response.dailyReport.images.length>0?response.dailyReport.images.map(function(img){return Object.assign({},img,{url:img.image.url});}):[];if(response.dailyReport.daily_report_entries&&response.dailyReport.daily_report_entries.length){response.dailyReport.daily_report_entries.sort(function(entry1,entry2){return entry1.id-entry2.id;});}dispatch(setCurrentDailyReport(response.dailyReport));dispatch(setGCImagesAction(images));dispatch(setGCDeletedImagesAction([]));if(!withSaveDraft&&!editMode){dispatch(setMemberForm(false));if(dailyReport.daily_report_entries.length>0){dispatch(setActiveContributor(1));}else{dispatch(setCurrentDailyReport(dailyReport));dispatch(setReviewFormAction(true));}}if(editMode){dispatch(setCurrentDailyReport(dailyReport));dispatch(setMemberForm(false));dispatch(setReviewFormAction(true));dispatch(setEditMode(false));}if(!dailyReport.project_open_item){dispatch(setReportOpenItem({}));}else{dispatch(setReportOpenItemValue('openItemId',dailyReport.project_open_item.id));dispatch(setReportOpenItemValue('openItemRecipients',dailyReport.project_open_item.recipients.map(function(rcpt){return[rcpt.id];})));dispatch(setReportOpenItemValue('openItemImages',dailyReport.project_open_item.images.map(function(image){return Object.assign({},image,{url:image.image.gallery.url});})));dispatch(setReportOpenItemValue('openItemDocuments',dailyReport.project_open_item.documents.map(function(doc){return Object.assign({},doc,{url:doc.document.url});})));}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setActiveContributor(number){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["z" /* SET_ACTIVE_CONTRIBUTOR */],payload:number};}function setActiveEntriesId(number){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["A" /* SET_ACTIVE_ENTRIES_ID */],payload:number};}function initializeTradeForm(value){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["w" /* INITIALIZE_TRADE_FORM */],payload:value};}function updateTradeForm(value){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["_10" /* UPDATE_TRADE_FORM */],payload:value};}function handleWorkedFrom(value,contribId,techId){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["u" /* HANDLE_WORKED_FORM */],payload:{value:value,contribId:contribId,techId:techId}};}function handleDateMoreInfo(value,contribId,techId,key,infoIndex){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["r" /* HANDLE_DATE_MORE_INFO */],payload:{value:value,contribId:contribId,techId:techId,key:key,infoIndex:infoIndex}};}function handleWorkedTo(value,contribId,techId){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["v" /* HANDLE_WORKED_TO */],payload:{value:value,contribId:contribId,techId:techId}};}function handleAttributeChangeForSub(value,contribId,techId,attribute){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["p" /* HANDLE_ATTRIBUTE_CHANGE_FOR_SUB */],payload:{value:value,contribId:contribId,techId:techId,attribute:attribute}};}function handleAttributeChangeForSubMoreAction(value,contribId,techId,attribute,infoIndex){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["q" /* HANDLE_ATTRIBUTE_CHANGE_FOR_SUB_MORE_ACTION */],payload:{value:value,contribId:contribId,techId:techId,attribute:attribute,infoIndex:infoIndex}};}function handleHoursAmountAction(value,contribId,techId){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["s" /* HANDLE_HOURS_AMOUNT */],payload:{value:value,contribId:contribId,techId:techId}};}function handleHoursAmountActionMoreAction(value,contribId,techId,infoIndex){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["t" /* HANDLE_HOURS_AMOUNT_MORE_INFO */],payload:{value:value,contribId:contribId,techId:techId,infoIndex:infoIndex}};}function changeAmountOfTechnicians(technicians,contribId){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["d" /* CHANGE_AMOUNT_OF_TECHNICIANS */],payload:{technicians:technicians,contribId:contribId}};}function addedDeletedTechnicians(technician,contribId){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["a" /* ADDED_DELETED_TECHNICIANS */],payload:{technician:technician,contribId:contribId}};}function handleAttributeChangeAction(attribute,value,contribId){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["o" /* HANDLE_ATTRIBUTE_CHANGE */],payload:{attribute:attribute,value:value,contribId:contribId}};}function setReviewFormAction(value){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["_2" /* SET_REVIEW_FORM */],payload:value};}function setSubmittedReport(value){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["_1" /* SET_REPORT_SUBMITTED */],payload:value};}function clearFormAction(){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["e" /* CLEAR_FORM */]};}function loadDailyReportLogPdfSuccess(dailyReportLogPdf){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["F" /* SET_DAILY_REPORT_LOG_PDF */],payload:dailyReportLogPdf};}function loadDailyReportLogPdfRequest(projectId){var isSubDailyReports=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var resultApi=isSubDailyReports?__WEBPACK_IMPORTED_MODULE_3_services_api_sub_daily_reports_api__["a" /* subDailyReportsApi */]:__WEBPACK_IMPORTED_MODULE_2_services_api_daily_reports_api__["a" /* dailyReportsApi */];return function(dispatch){return resultApi.getDailyReportLogPdf(projectId).then(function(response){if(response.ok){dispatch(loadDailyReportLogPdfSuccess(response.dailyReportLogPdf));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setDailyReportLogPdfViewer(dailyReportLogPdfViewer){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["G" /* SET_DAILY_REPORT_LOG_PDF_VIEWER */],payload:dailyReportLogPdfViewer};}function setEditMode(value){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["K" /* SET_EDIT_MODE */],payload:value};}function deleteDailyReportSuccess(dailyReportId){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["h" /* DELETE_DAILY_REPORT */],payload:dailyReportId};}function deleteReportRequest(projectId,dailyReportId){var isSubDailyReports=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var resultApi=isSubDailyReports?__WEBPACK_IMPORTED_MODULE_3_services_api_sub_daily_reports_api__["a" /* subDailyReportsApi */]:__WEBPACK_IMPORTED_MODULE_2_services_api_daily_reports_api__["a" /* dailyReportsApi */];return function(dispatch){return resultApi.deleteDailyReport(projectId,dailyReportId).then(function(response){if(response.ok){dispatch(deleteDailyReportSuccess(dailyReportId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setReportPdfViewer(pdfViewer){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["_0" /* SET_REPORT_PDF_VIEWER */],payload:pdfViewer};}function loadReportPdfSuccess(reportPdf){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["Z" /* SET_REPORT_PDF */],payload:reportPdf};}function loadDailyReportlPdf(projectId,dailyReportId){var isSubDailyReports=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var resultApi=isSubDailyReports?__WEBPACK_IMPORTED_MODULE_3_services_api_sub_daily_reports_api__["a" /* subDailyReportsApi */]:__WEBPACK_IMPORTED_MODULE_2_services_api_daily_reports_api__["a" /* dailyReportsApi */];return function(dispatch){return resultApi.getDailyReportPdf(projectId,dailyReportId).then(function(response){if(response.ok){dispatch(loadReportPdfSuccess(response.reportPdf));dispatch(setReportPdfViewer(true));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function sendDailyReportEmails(resourceId,resourceType,emailData){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_7_services_api_project_resource_mailer_api__["a" /* projectResourceMailerApi */].postResourceEmails(resourceId,resourceType,emailData).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_email_modal_store_actions__["j" /* setShowEmailModal */])(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setReportDate(date){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["U" /* SET_REPORT_DATE */],payload:date};}function setReportExtraInputs(value){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["W" /* SET_REPORT_EXTRA_INPUTS */],payload:value};}function setReportExtraInput(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["V" /* SET_REPORT_EXTRA_INPUT */],payload:{attribute:attribute,value:value}};}function setReportOpenItem(openItem){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["X" /* SET_REPORT_OPEN_ITEM */],payload:openItem};}function setReportOpenItemValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["Y" /* SET_REPORT_OPEN_ITEM_VALUE */],payload:{attribute:attribute,value:value}};}function setGeneralContractorName(contrib){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["O" /* SET_GENERAL_CONTACTOR_NAME */],payload:contrib};}function setMemberForm(value){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["Q" /* SET_MEMBER_FORM */],payload:value};}function setMembers(members){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["P" /* SET_MEMBERS */],payload:members};}function setDeletedMembers(members){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["I" /* SET_DELETED_MEMBERS */],payload:members};}function setCurrentPage(currentPage){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["D" /* SET_CURRENT_PAGE */],payload:currentPage};}function setReportsTotal(amount){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["T" /* SET_REPORTS_TOTAL */],payload:amount};}function setReportsPageSize(size){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["S" /* SET_REPORTS_PAGE_SIZE */],payload:size};}function setGCImagesAction(images){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["N" /* SET_GCX_IMAGES */],payload:images};}function setGCDeletedImagesAction(images){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["M" /* SET_GCX_DELETED_IMAGES */],payload:images};}function setDelivery(delivery){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["J" /* SET_DELIVERY */],payload:delivery};}function addExtraInput(value){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["c" /* ADD_EXTRA_INPUT */],payload:value};}function deleteDelivery(delivery){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["i" /* DELETE_DELIVERY */],payload:delivery};}function removeDeliveriesExtraInput(){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["y" /* REMOVE_DELIVERIES_EXTRA_INPUT */]};}function setDailyReportTab(tab){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["H" /* SET_DAILY_REPORT_TAB */],payload:tab};}function subDailyReportsCountSuccess(total){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["_8" /* SUB_DAILY_REPORTS_COUNT_SUCCESS */],payload:total};}function subDailyReportsCount(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_sub_daily_reports_api__["a" /* subDailyReportsApi */].getDailyReportsCount(projectId).then(function(response){if(response.ok){dispatch(subDailyReportsCountSuccess(response.total));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function initSubDailyReportsCount(){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["_7" /* SUB_DAILY_REPORTS_COUNT_INIT */]};}function buildFieldWorkOrderForm(fieldWorkOrder){var status='pending';if(fieldWorkOrder){if(fieldWorkOrder.status==='gc_approved'||fieldWorkOrder.status==='sub_approved'){status='approved';}if(fieldWorkOrder.status==='gc_denied'||fieldWorkOrder.status==='sub_denied'){status='denied';}}var formStatus={value:status,label:status.charAt(0).toUpperCase()+status.slice(1)};return{fwoId:fieldWorkOrder&&fieldWorkOrder.id,fwoNumber:fieldWorkOrder&&fieldWorkOrder.number,fwoStatus:formStatus,fwoDeniedReason:fieldWorkOrder&&(fieldWorkOrder.denied_reason||''),fwoPresetTasks:fieldWorkOrder&&fieldWorkOrder.preset_tasks?fieldWorkOrder.preset_tasks.map(function(task){return[task.id,task.label];}):[],fwoCustomTask:fieldWorkOrder&&(fieldWorkOrder.preset_task_other||''),fwoWorkPerformed:fieldWorkOrder&&(fieldWorkOrder.work_performed||''),fwoComments:fieldWorkOrder&&(fieldWorkOrder.comments||''),fwoStartDate:fieldWorkOrder&&(fieldWorkOrder.start_date||''),fwoCompletionDate:fieldWorkOrder&&(fieldWorkOrder.completion_date||''),fwoCostImpact:fieldWorkOrder&&fieldWorkOrder.cost_impact,fwoCost:fieldWorkOrder&&(fieldWorkOrder.cost||''),fwoDelay:fieldWorkOrder&&fieldWorkOrder.delay,fwoDelayReason:fieldWorkOrder&&(fieldWorkOrder.delay_reason||''),fwoLabor:fieldWorkOrder&&(fieldWorkOrder.labor||''),fwoMaterials:fieldWorkOrder&&(fieldWorkOrder.materials||'')};}function initFieldWorkOrderForm(fieldWorkOrder){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["m" /* FIELD_WORK_ORDER_FORM_INIT */],payload:buildFieldWorkOrderForm(fieldWorkOrder)};}function setFieldWorkOrderFormAttribute(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["l" /* FIELD_WORK_ORDER_FORM_ATTRIBUTE_SET */],payload:{attribute:attribute,value:value}};}function setFieldWorkOrderEdit(value){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["L" /* SET_FIELD_WORK_ORDER_EDIT */],payload:value};}function setShowFieldWorkOrderError(value){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["_4" /* SET_SHOW_FIELD_WORK_ORDER_ERROR */],payload:value};}function updateFieldWorkOrderSuccess(fieldWorkOrder){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["_9" /* UPDATE_FIELD_WORK_ORDER_SUCCESS */],payload:fieldWorkOrder};}function updateFieldWorkOrder(projectId,fieldWorkOrderId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_field_work_orders_api__["a" /* fieldWorkOrdersApi */].updateFieldWorkOrder(projectId,fieldWorkOrderId,values).then(function(response){if(response.ok){dispatch(updateFieldWorkOrderSuccess(response.fieldWorkOrder));dispatch(setFieldWorkOrderEdit(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setDailyReportAddFloor(value){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["E" /* SET_DAILY_REPORT_ADD_FLOOR */],payload:value};}function addDailyReportEntriesFloor(entryId,currentReport){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5_services_api_daily_reports_entries_api__["a" /* dailyReportsEntriesApi */].postDailyReportEntry(entryId).then(function(response){if(response.ok){var newForm={};var defaultTechnician={hoursAmount:'',workedFrom:'',workedTo:''};newForm[response.newEntry.id]=response.newEntry;newForm[response.newEntry.id].technicians=[defaultTechnician];var newReport=Object.assign({},currentReport,{daily_report_entries:[].concat(_toConsumableArray(currentReport.daily_report_entries),[response.newEntry])});dispatch(initializeTradeForm(newForm));dispatch(setActiveEntriesId(response.newEntry.id));dispatch(addDailyReportSuccess(newReport));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function deleteDailyReportEntry(entryId,currentReport){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5_services_api_daily_reports_entries_api__["a" /* dailyReportsEntriesApi */].deleteDailyReportEntry(entryId).then(function(response){if(response.ok){var newEntries=currentReport.daily_report_entries.filter(function(entry){return entry.id!==entryId;});var newReport=Object.assign({},currentReport,{daily_report_entries:newEntries});dispatch(addDailyReportSuccess(newReport));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function addSubDailyReportEntriesFloor(entryId,currentReport){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_6_services_api_sub_daily_reports_entries_api__["a" /* subDailyReportsEntriesApi */].postDailyReportEntry(entryId).then(function(response){if(response.ok){var newForm={};var defaultInfo={hoursAmount:'',workedFrom:'',workedTo:'',location:'',customTask:'',workPerformed:'',presetTasks:[]};var defaultTechnicianForSub=Object.assign({},defaultInfo,{tech:{value:1,label:'Technician 1',custom:true},additionalInfo:[]});newForm[response.newEntry.id]=response.newEntry;newForm[response.newEntry.id].technicians=[defaultTechnicianForSub];var newReport=Object.assign({},currentReport,{sub_daily_report_entries:[].concat(_toConsumableArray(currentReport.sub_daily_report_entries),[response.newEntry])});dispatch(initializeTradeForm(newForm));dispatch(setActiveEntriesId(response.newEntry.id));dispatch(addDailyReportSuccess(newReport));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function deleteSubDailyReportEntry(entryId,currentReport){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_6_services_api_sub_daily_reports_entries_api__["a" /* subDailyReportsEntriesApi */].deleteDailyReportEntry(entryId).then(function(response){if(response.ok){var newEntries=currentReport.sub_daily_report_entries.filter(function(entry){return entry.id!==entryId;});var newReport=Object.assign({},currentReport,{sub_daily_report_entries:newEntries});dispatch(addDailyReportSuccess(newReport));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function duplicateDailyReportSuccess(dailyReport){return{type:__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_action_types__["j" /* DUPLICATE_DAILY_REPORT_SUCCESS */],payload:dailyReport};}function duplicateDailyReport(projectId,dailyReportId,values){var isSubDailyReport=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var resultApi=isSubDailyReport?__WEBPACK_IMPORTED_MODULE_3_services_api_sub_daily_reports_api__["a" /* subDailyReportsApi */]:__WEBPACK_IMPORTED_MODULE_2_services_api_daily_reports_api__["a" /* dailyReportsApi */];return function(dispatch){return resultApi.duplicateDailyReport(values,projectId,dailyReportId).then(function(response){if(response.ok){dispatch(duplicateDailyReportSuccess(response.dailyReport));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadDailyReportInBkg(projectId,dailyReportId){var isSubDailyReport=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var resultApi=isSubDailyReport?__WEBPACK_IMPORTED_MODULE_3_services_api_sub_daily_reports_api__["a" /* subDailyReportsApi */]:__WEBPACK_IMPORTED_MODULE_2_services_api_daily_reports_api__["a" /* dailyReportsApi */];return function(dispatch){return resultApi.getDailyReport(projectId,dailyReportId,true);};}

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDirectory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDirectoryPdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getShowNewContributorModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getShowEditUserModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getServiceProviderUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getShowNewCompanyForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getShowSelectUsersForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getShowInviteUserForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getShowDirectoryPdfViewer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentContributor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getNewContributorType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getContributorSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getUserSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getEditedUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getDirectory=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.directory.data.directory;},function(directory){return directory;});var getDirectoryPdf=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.directory.data.directoryPdf;},function(directoryPdf){return directoryPdf;});var getShowNewContributorModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.directory.ui.showNewContributorModal;},function(showNewContributorModal){return showNewContributorModal;});var getShowEditUserModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.directory.ui.showEditUserModal;},function(showEditUserModal){return showEditUserModal;});var getServiceProviderUsers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.directory.data.serviceProviderUsers;},function(serviceProviderUsers){return serviceProviderUsers;});var getShowNewCompanyForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.directory.ui.showNewCompanyForm;},function(showNewCompanyForm){return showNewCompanyForm;});var getShowSelectUsersForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.directory.ui.showSelectUsersForm;},function(showSelectUsersForm){return showSelectUsersForm;});var getShowInviteUserForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.directory.ui.showInviteUserForm;},function(showInviteUserForm){return showInviteUserForm;});var getShowDirectoryPdfViewer=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.directory.ui.showDirectoryPdfViewer;},function(showPdfViewer){return showPdfViewer;});var getCurrentContributor=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.directory.ui.currentContributor;},function(currentContributor){return currentContributor;});var getNewContributorType=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.directory.ui.newContributorType;},function(newContributorType){return newContributorType;});var getContributorSettings=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.directory.ui.contributorSettings;},function(contributorSettings){return contributorSettings;});var getUserSettings=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.directory.ui.userSettings;},function(userSettings){return userSettings;});var getEditedUser=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.directory.ui.editedUser;},function(editedUser){return editedUser;});

/***/ }),
/* 97 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(299);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chainPropTypes__ = __webpack_require__(507);
/* unused harmony reexport chainPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deepmerge__ = __webpack_require__(1392);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__deepmerge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elementAcceptingRef__ = __webpack_require__(1393);
/* unused harmony reexport elementAcceptingRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elementTypeAcceptingRef__ = __webpack_require__(1394);
/* unused harmony reexport elementTypeAcceptingRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__exactProp__ = __webpack_require__(1395);
/* unused harmony reexport exactProp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatMuiErrorMessage__ = __webpack_require__(1396);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__formatMuiErrorMessage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getDisplayName__ = __webpack_require__(1397);
/* unused harmony reexport getDisplayName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HTMLElementType__ = __webpack_require__(1400);
/* unused harmony reexport HTMLElementType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ponyfillGlobal__ = __webpack_require__(1401);
/* unused harmony reexport ponyfillGlobal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__refType__ = __webpack_require__(1402);
/* unused harmony reexport refType */
/** @license Material-UI v4.11.2
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */











/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _bind2 = __webpack_require__(380)

var _bind3 = _interopRequireDefault(_bind2)

var _isFunction2 = __webpack_require__(260)

var _isFunction3 = _interopRequireDefault(_isFunction2)

var _reduce3 = __webpack_require__(1550)

var _reduce4 = _interopRequireDefault(_reduce3)

var _forEach2 = __webpack_require__(1623)

var _forEach3 = _interopRequireDefault(_forEach2)

var _lowerFirst2 = __webpack_require__(1625)

var _lowerFirst3 = _interopRequireDefault(_lowerFirst2)

var _has2 = __webpack_require__(1632)

var _has3 = _interopRequireDefault(_has2)

exports.construct = construct
exports.componentDidMount = componentDidMount
exports.componentDidUpdate = componentDidUpdate
exports.componentWillUnmount = componentWillUnmount

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
/* eslint-disable no-param-reassign */
function rdcUncontrolledAndControlledProps(acc, value, key) {
  if ((0, _has3.default)(acc.prevProps, key)) {
    var match = key.match(/^default(\S+)/)
    if (match) {
      var unprefixedKey = (0, _lowerFirst3.default)(match[1])
      if (!(0, _has3.default)(acc.nextProps, unprefixedKey)) {
        acc.nextProps[unprefixedKey] = acc.prevProps[key]
      }
    } else {
      acc.nextProps[key] = acc.prevProps[key]
    }
  }
  return acc
}

function applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance) {
  ;(0, _forEach3.default)(updaterMap, function(fn, key) {
    var nextValue = nextProps[key]
    if (nextValue !== prevProps[key]) {
      fn(instance, nextValue)
    }
  })
}

function construct(propTypes, updaterMap, prevProps, instance) {
  var _reduce2 = (0, _reduce4.default)(
      propTypes,
      rdcUncontrolledAndControlledProps,
      {
        nextProps: {},
        prevProps: prevProps,
      }
    ),
    nextProps = _reduce2.nextProps

  applyUpdaterToNextProps(
    updaterMap,
    {
      /* empty prevProps for construct */
    },
    nextProps,
    instance
  )
}

function componentDidMount(component, instance, eventMap) {
  registerEvents(component, instance, eventMap)
}

function componentDidUpdate(
  component,
  instance,
  eventMap,
  updaterMap,
  prevProps
) {
  component.unregisterAllEvents()
  applyUpdaterToNextProps(updaterMap, prevProps, component.props, instance)
  registerEvents(component, instance, eventMap)
}

function componentWillUnmount(component) {
  component.unregisterAllEvents()
}

function registerEvents(component, instance, eventMap) {
  var registeredList = (0, _reduce4.default)(
    eventMap,
    function(acc, googleEventName, onEventName) {
      if ((0, _isFunction3.default)(component.props[onEventName])) {
        acc.push(
          google.maps.event.addListener(
            instance,
            googleEventName,
            component.props[onEventName]
          )
        )
      }
      return acc
    },
    []
  )

  component.unregisterAllEvents = (0, _bind3.default)(
    _forEach3.default,
    null,
    registeredList,
    unregisterEvent
  )
}

function unregisterEvent(registered) {
  google.maps.event.removeListener(registered)
}


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LogoUpload_css__ = __webpack_require__(2366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LogoUpload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LogoUpload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_button_SimpleButton__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_plus_icon_png__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_plus_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_plus_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_upload_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_upload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_logo_upload_FullScreenImageViewer__ = __webpack_require__(2367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dropzone__ = __webpack_require__(61);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LogoUpload=function(_Component){_inherits(LogoUpload,_Component);function LogoUpload(props){_classCallCheck(this,LogoUpload);var _this=_possibleConstructorReturn(this,(LogoUpload.__proto__||Object.getPrototypeOf(LogoUpload)).call(this,props));_this.handleAddPhotoClick=function(){_this.fileUpload.click();};_this.handleFullScreenOpen=function(url,event){event.preventDefault();_this.setState({fullScreenUrl:url,showFullScreen:true});};_this.handleFullScreenClose=function(){_this.setState({showFullScreen:false});};_this.handleNewLogosUpload=function(files){var newFiles=[];for(var i=0;i<files.length;i++){if(_this.validateFile(files.item(i).name)){newFiles.push(files.item(i));}}if(_this.props.max>0){// Remove extra files uploaded
newFiles=newFiles.slice(0,_this.props.max);}// Clear input to allow to upload the same file twice
_this.fileUpload.value='';_this.props.onUpload(newFiles);};_this.handleRemove=function(result){if(result){_this.props.onRemove(_this.state.logoIndexToRemove);}_this.setState({logoIndexToRemove:0,showConfirmation:false});};_this.state={logosIndexToRemove:0,fullScreenUrl:'',showConfirmation:false,showFullScreen:false};return _this;}_createClass(LogoUpload,[{key:'validateFile',value:function validateFile(name){var index=name.lastIndexOf('.');if(index===-1){// The file has no extension, so is not valid
alert('File "'+name+'" could not be uploaded because has no extension.');return false;}else if(this.props.extensions.length>0){var fileExtension=name.substring(index);if(this.props.extensions.find(function(element){return element.toLowerCase()===fileExtension.toLowerCase();})===undefined){alert('File "'+name+'" has an invalid extensions, should be one of ['+this.props.extensions.join(', ')+'].');return false;}}return true;}},{key:'handleRemoveRequest',value:function handleRemoveRequest(index,event){event.preventDefault();this.setState({logoIndexToRemove:index,showConfirmation:true});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-upload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'preview-container'},this.props.logos.map(function(logo,index){if(logo.preview!==undefined&&logo.preview!==null){return _this2.getLogoDiv(index,logo.preview,{show:_this2.props.readOnly&&logo.url!==null,url:logo.url});}else if(logo.url!==undefined&&logo.url!==null){return _this2.getLogoDiv(index,logo.url,{show:_this2.props.readOnly,url:logo.url});}else if(logo.file!==undefined&&logo.file!==null){return _this2.getLogoDiv(index,logo.file.img);}else{return null;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showConfirmation,message:'Are you sure?',onHide:this.handleRemove})),!this.props.readOnly&&this.props.logos.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-upload-button-container'},!this.props.useDropzone?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_SimpleButton__["a" /* default */],{className:'add-photos-button',disabled:this.props.max>0?this.props.logos.length>=this.props.max:false,img:__WEBPACK_IMPORTED_MODULE_4_images_plus_icon_png___default.a,label:this.props.max===1?'Add Logo':'Add Logos',onClick:this.handleAddPhotoClick})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_dropzone__["a" /* default */],{accept:'image/*',className:'files-dropzone dropzone-container',disabled:this.props.max>0?this.props.logos.length>=this.props.max:false,onDrop:function onDrop(files){return _this2.props.onUpload(files);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6_images_upload_svg___default.a,alt:'remove'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'add-message'},this.props.dropzoneLabel)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{accept:this.props.extensions.length>0?this.props.extensions:'image/*',multiple:true,ref:function ref(input){_this2.fileUpload=input;},style:{display:'none'},type:'file',onChange:function onChange(event){event.preventDefault();_this2.handleNewLogosUpload(event.target.files);}})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_logo_upload_FullScreenImageViewer__["a" /* default */],{show:this.state.showFullScreen,url:this.state.fullScreenUrl,onClose:this.handleFullScreenClose}));}/**
   *
   * @param index
   * @param source
   * @param fullScreenInfo  - { show: boolean, url: string }
   * @return {*}
   */},{key:'getLogoDiv',value:function getLogoDiv(index,source){var fullScreenInfo=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;if(fullScreenInfo!==null&&fullScreenInfo.show){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-full-screen',src:source,alt:'',onClick:this.handleFullScreenOpen.bind(this,fullScreenInfo.url)}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:source,alt:''}),this.props.onRemove!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'remove-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5_images_remove_png___default.a,alt:'',onClick:this.handleRemoveRequest.bind(this,index)})));}}}]);return LogoUpload;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);LogoUpload.propTypes={extensions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),logos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,preview:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,file:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object})),min:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,max:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,notes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,dropzoneLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUpload:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};LogoUpload.defaultProps={extensions:[],logos:[],min:0,max:0,notes:null,dropzoneLabel:'Drag logo here'};/* harmony default export */ __webpack_exports__["a"] = (LogoUpload);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
// TODO: This module should be ElementChildren, and should use named exports.

/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid components".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @return {object} Object containing the ordered map of results.
 */

function map(children, func, context) {
  var index = 0;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return child;
    }

    return func.call(context, child, index++);
  });
}
/**
 * Iterates through children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for context.
 */


function forEach(children, func, context) {
  var index = 0;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    func.call(context, child, index++);
  });
}
/**
 * Count the number of "valid components" in the Children container.
 *
 * @param {?*} children Children tree container.
 * @returns {number}
 */


function count(children) {
  var result = 0;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    ++result;
  });
  return result;
}
/**
 * Finds children that are typically specified as `props.children`,
 * but only iterates over children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @returns {array} of children that meet the func return statement
 */


function filter(children, func, context) {
  var index = 0;
  var result = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result.push(child);
    }
  });
  return result;
}

function find(children, func, context) {
  var index = 0;
  var result;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }

    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = child;
    }
  });
  return result;
}

function every(children, func, context) {
  var index = 0;
  var result = true;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!result) {
      return;
    }

    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (!func.call(context, child, index++)) {
      result = false;
    }
  });
  return result;
}

function some(children, func, context) {
  var index = 0;
  var result = false;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }

    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = true;
    }
  });
  return result;
}

function toArray(children) {
  var result = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    result.push(child);
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  map: map,
  forEach: forEach,
  count: count,
  find: find,
  filter: filter,
  every: every,
  some: some,
  toArray: toArray
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);




var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var humps = createCommonjsModule(function (module) {
// =========
// = humps =
// =========
// Underscore-to-camelCase converter (and vice versa)
// for strings and object keys

// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.


(function(global) {

  var _processKeys = function(convert, obj, options) {
    if(!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
      return obj;
    }

    var output,
        i = 0,
        l = 0;

    if(_isArray(obj)) {
      output = [];
      for(l=obj.length; i<l; i++) {
        output.push(_processKeys(convert, obj[i], options));
      }
    }
    else {
      output = {};
      for(var key in obj) {
        if(Object.prototype.hasOwnProperty.call(obj, key)) {
          output[convert(key, options)] = _processKeys(convert, obj[key], options);
        }
      }
    }
    return output;
  };

  // String conversion methods

  var separateWords = function(string, options) {
    options = options || {};
    var separator = options.separator || '_';
    var split = options.split || /(?=[A-Z])/;

    return string.split(split).join(separator);
  };

  var camelize = function(string) {
    if (_isNumerical(string)) {
      return string;
    }
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
      return chr ? chr.toUpperCase() : '';
    });
    // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
  };

  var pascalize = function(string) {
    var camelized = camelize(string);
    // Ensure 1st char is always uppercase
    return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
  };

  var decamelize = function(string, options) {
    return separateWords(string, options).toLowerCase();
  };

  // Utilities
  // Taken from Underscore.js

  var toString = Object.prototype.toString;

  var _isFunction = function(obj) {
    return typeof(obj) === 'function';
  };
  var _isObject = function(obj) {
    return obj === Object(obj);
  };
  var _isArray = function(obj) {
    return toString.call(obj) == '[object Array]';
  };
  var _isDate = function(obj) {
    return toString.call(obj) == '[object Date]';
  };
  var _isRegExp = function(obj) {
    return toString.call(obj) == '[object RegExp]';
  };
  var _isBoolean = function(obj) {
    return toString.call(obj) == '[object Boolean]';
  };

  // Performant way to determine if obj coerces to a number
  var _isNumerical = function(obj) {
    obj = obj - 0;
    return obj === obj;
  };

  // Sets up function which handles processing keys
  // allowing the convert function to be modified by a callback
  var _processor = function(convert, options) {
    var callback = options && 'process' in options ? options.process : options;

    if(typeof(callback) !== 'function') {
      return convert;
    }

    return function(string, options) {
      return callback(string, convert, options);
    }
  };

  var humps = {
    camelize: camelize,
    decamelize: decamelize,
    pascalize: pascalize,
    depascalize: decamelize,
    camelizeKeys: function(object, options) {
      return _processKeys(_processor(camelize, options), object);
    },
    decamelizeKeys: function(object, options) {
      return _processKeys(_processor(decamelize, options), object, options);
    },
    pascalizeKeys: function(object, options) {
      return _processKeys(_processor(pascalize, options), object);
    },
    depascalizeKeys: function () {
      return this.decamelizeKeys.apply(this, arguments);
    }
  };

  if (false) {
    undefined(humps);
  } else if ('object' !== 'undefined' && module.exports) {
    module.exports = humps;
  } else {
    global.humps = humps;
  }

})(commonjsGlobal);
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();













var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};













var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};





















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = humps.camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();

    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;

    return acc;
  }, {});
}

function convert(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var children = (element.children || []).map(convert.bind(null, createElement));

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;
      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;
      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[humps.camelize(key)] = val;
        }
    }

    return acc;
  }, { attrs: {} });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === undefined ? {} : _extraProps$style,
      remaining = objectWithoutProperties(extraProps, ['style']);


  mixins.attrs['style'] = _extends({}, mixins.attrs['style'], existingStyle);

  return createElement.apply(undefined, [element.tag, _extends({}, mixins.attrs, remaining)].concat(toConsumableArray(children)));
}

var PRODUCTION = false;

try {
  PRODUCTION = "production" === 'production';
} catch (e) {}

var log = function () {
  if (!PRODUCTION && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
};

function objectWithKey(key, value) {
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? defineProperty({}, key, value) : {};
}

function classList(props) {
  var _classes;

  var classes = (_classes = {
    'fa-spin': props.spin,
    'fa-pulse': props.pulse,
    'fa-fw': props.fixedWidth,
    'fa-border': props.border,
    'fa-li': props.listItem,
    'fa-flip-horizontal': props.flip === 'horizontal' || props.flip === 'both',
    'fa-flip-vertical': props.flip === 'vertical' || props.flip === 'both'
  }, defineProperty(_classes, 'fa-' + props.size, props.size !== null), defineProperty(_classes, 'fa-rotate-' + props.rotation, props.rotation !== null), defineProperty(_classes, 'fa-pull-' + props.pull, props.pull !== null), _classes);

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

function normalizeIconArgs(icon) {
  if (icon === null) {
    return null;
  }

  if ((typeof icon === 'undefined' ? 'undefined' : _typeof(icon)) === 'object' && icon.prefix && icon.iconName) {
    return icon;
  }

  if (Array.isArray(icon) && icon.length === 2) {
    return { prefix: icon[0], iconName: icon[1] };
  }

  if (typeof icon === 'string') {
    return { prefix: 'fas', iconName: icon };
  }
}

function FontAwesomeIcon$1(props) {
  var iconArgs = props.icon,
      maskArgs = props.mask,
      symbol = props.symbol,
      className = props.className;


  var icon = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(toConsumableArray(classList(props)), toConsumableArray(className.split(' '))));
  var transform = objectWithKey('transform', typeof props.transform === 'string' ? __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome__["a" /* default */].parse.transform(props.transform) : props.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));

  var renderedIcon = __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome__["a" /* default */].icon(icon, _extends({}, classes, transform, mask, {
    symbol: symbol
  }));

  if (!renderedIcon) {
    log('Could not find icon', icon);
    return null;
  }

  var abstract = renderedIcon.abstract;

  var convertCurry = convert.bind(null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement);
  var extraProps = {};

  Object.keys(props).forEach(function (key) {
    if (!FontAwesomeIcon$1.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
  });

  return convertCurry(abstract[0], extraProps);
}

FontAwesomeIcon$1.propTypes = {
  border: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  mask: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  fixedWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['horizontal', 'vertical', 'both']),

  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  listItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  pull: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['right', 'left']),

  pulse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  rotation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([90, 180, 270]),

  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),

  spin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  symbol: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  transform: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object])
};

FontAwesomeIcon$1.defaultProps = {
  border: false,
  className: '',
  mask: null,
  fixedWidth: false,
  flip: null,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  name: '',
  rotation: null,
  size: null,
  spin: false,
  symbol: false,
  transform: null
};

__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome__["a" /* default */].noAuto();

/* harmony default export */ __webpack_exports__["a"] = (FontAwesomeIcon$1);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(97)))

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getReports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getSelectAllChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getReportResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getSelectedWorkOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getStartDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEndDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getExtraFilterValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getSearching; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getReports=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.reports.ui.reports;},function(reports){return reports;});var getSelectAllChecked=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.reports.ui.selectAllChecked;},function(selectAllChecked){return selectAllChecked;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.reports.ui.currentPage;},function(currentPage){return currentPage;});var getReportResults=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.reports.data.results;},function(results){return results;});var getSelectedWorkOrders=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.reports.ui.selectedWorkOrders;},function(selectedWorkOrders){return selectedWorkOrders;});var getStartDate=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.reports.ui.startDate;},function(startDate){return startDate;});var getEndDate=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.reports.ui.endDate;},function(endDate){return endDate;});var getExtraFilterValues=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.reports.ui.extraFilterValues;},function(extraFilterValues){return extraFilterValues;});var getSearching=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.reports.ui.searching;},function(searching){return searching;});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(41);
var hide = __webpack_require__(110);
var has = __webpack_require__(117);
var SRC = __webpack_require__(209)('src');
var $toString = __webpack_require__(1114);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(108).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(70);
var createDesc = __webpack_require__(210);
module.exports = __webpack_require__(59) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(171);
var core = __webpack_require__(77);
var ctx = __webpack_require__(469);
var hide = __webpack_require__(243);
var has = __webpack_require__(220);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(807);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 113 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var fails = __webpack_require__(43);
var defined = __webpack_require__(150);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadDirectorySuccess */
/* harmony export (immutable) */ __webpack_exports__["j"] = loadDirectoryRequest;
/* unused harmony export loadDirectoryPdfSuccess */
/* harmony export (immutable) */ __webpack_exports__["i"] = loadDirectoryPdfRequest;
/* harmony export (immutable) */ __webpack_exports__["m"] = searchDirectory;
/* harmony export (immutable) */ __webpack_exports__["u"] = setShowNewContributorModal;
/* harmony export (immutable) */ __webpack_exports__["r"] = setShowEditUserModal;
/* harmony export (immutable) */ __webpack_exports__["g"] = initNewContributorModal;
/* harmony export (immutable) */ __webpack_exports__["v"] = setShowSelectUsersForm;
/* harmony export (immutable) */ __webpack_exports__["s"] = setShowInviteUserForm;
/* harmony export (immutable) */ __webpack_exports__["q"] = setShowDirectoryPdfViewer;
/* harmony export (immutable) */ __webpack_exports__["o"] = setCurrentContributor;
/* harmony export (immutable) */ __webpack_exports__["f"] = fetchServiceProviders;
/* harmony export (immutable) */ __webpack_exports__["l"] = loadServiceProviderUsersSuccess;
/* harmony export (immutable) */ __webpack_exports__["k"] = loadServiceProviderUsers;
/* harmony export (immutable) */ __webpack_exports__["b"] = createProjectContributor;
/* unused harmony export updateProjectContributorSuccess */
/* harmony export (immutable) */ __webpack_exports__["y"] = updateProjectContributor;
/* harmony export (immutable) */ __webpack_exports__["t"] = setShowNewCompanyForm;
/* harmony export (immutable) */ __webpack_exports__["c"] = createServiceProvider;
/* harmony export (immutable) */ __webpack_exports__["e"] = editUser;
/* unused harmony export updateContributersWithEditUser */
/* harmony export (immutable) */ __webpack_exports__["p"] = setNewContributorType;
/* harmony export (immutable) */ __webpack_exports__["w"] = toggleContributorSettings;
/* harmony export (immutable) */ __webpack_exports__["x"] = toggleUserSettings;
/* unused harmony export projectContributorDeleteSuccess */
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteProjectContributor;
/* harmony export (immutable) */ __webpack_exports__["h"] = inviteUser;
/* harmony export (immutable) */ __webpack_exports__["n"] = sendInvite;
/* harmony export (immutable) */ __webpack_exports__["a"] = activationLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_directories_api__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_project_contributors_api__ = __webpack_require__(2528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_service_providers_api__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_action_types__ = __webpack_require__(630);
function loadDirectorySuccess(directory){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_action_types__["d" /* DIRECTORY_SET */],payload:directory};}function loadDirectoryRequest(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_directories_api__["a" /* directoriesApi */].getDirectory(projectId).then(function(response){if(response.ok){dispatch(loadDirectorySuccess(response.directory));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadDirectoryPdfSuccess(directoryPdf){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_action_types__["c" /* DIRECTORY_PDF_SET */],payload:directoryPdf};}function loadDirectoryPdfRequest(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_directories_api__["a" /* directoriesApi */].getDirectoryPdf(projectId).then(function(response){if(response.ok){dispatch(loadDirectoryPdfSuccess(response.directoryPdf));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function searchDirectory(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_directories_api__["a" /* directoriesApi */].getDirectory(projectId).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setShowNewContributorModal(showNewContributorModal){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_action_types__["o" /* SHOW_NEW_CONTRIBUTOR_MODAL_SET */],payload:showNewContributorModal};}function setShowEditUserModal(showEditUserModal,user){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_action_types__["l" /* SHOW_EDIT_USER_MODAL_SET */],payload:{showEditUserModal:showEditUserModal,user:user}};}function initNewContributorModal(){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_action_types__["e" /* NEW_CONTRIBUTOR_MODAL_INIT */]};}function setShowSelectUsersForm(showSelectUsersForm){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_action_types__["p" /* SHOW_SELECT_USERS_FORM_SET */],payload:showSelectUsersForm};}function setShowInviteUserForm(showInviteUserForm){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_action_types__["m" /* SHOW_INVITE_USER_FORM_SET */],payload:showInviteUserForm};}function setShowDirectoryPdfViewer(showDirectoryPdfViewer){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_action_types__["k" /* SHOW_DIRECTORY_PDF_VIEWER_SET */],payload:showDirectoryPdfViewer};}function setCurrentContributor(contrib){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_action_types__["b" /* CURRENT_CONTRIBUTOR_SET */],payload:contrib};}function fetchServiceProviders(type,byName,page){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_service_providers_api__["a" /* serviceProvidersApi */].getServiceProviders(type,byName,page).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadServiceProviderUsersSuccess(users){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_action_types__["j" /* SERVICE_PROVIDER_USERS_SET */],payload:users};}function loadServiceProviderUsers(type,serviceProviderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_service_providers_api__["a" /* serviceProvidersApi */].getServiceProviderUsers(type,serviceProviderId).then(function(response){if(response.ok){dispatch(loadServiceProviderUsersSuccess(response.users));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function createProjectContributor(projectId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_project_contributors_api__["a" /* projectContributorsApi */].createProjectContributor(projectId,values).then(function(response){if(response.ok){dispatch(loadDirectoryRequest(projectId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateProjectContributorSuccess(projectContributor){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_action_types__["h" /* PROJECT_CONTRIBUTORS_UPDATE */],payload:projectContributor};}function updateProjectContributor(projectId,id,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_project_contributors_api__["a" /* projectContributorsApi */].updateProjectContributor(projectId,id,values).then(function(response){if(response.ok){dispatch(updateProjectContributorSuccess(response.projectContributor));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setShowNewCompanyForm(showNewCompanyForm){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_action_types__["n" /* SHOW_NEW_COMPANY_FORM_SET */],payload:showNewCompanyForm};}function createServiceProvider(type,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_service_providers_api__["a" /* serviceProvidersApi */].createServiceProviderDirectory(type,values).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function editUser(values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_service_providers_api__["a" /* serviceProvidersApi */].editUser(values).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}else{dispatch(setShowEditUserModal(false));dispatch(updateContributersWithEditUser(response.updatedUser));}return response;});};}function updateContributersWithEditUser(user){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_action_types__["i" /* PROJECT_CONTRIBUTORS_UPDATE_WITH_EDIT_USER */],payload:user};}function setNewContributorType(type){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_action_types__["f" /* NEW_CONTRIBUTOR_TYPE_SET */],payload:type};}function toggleContributorSettings(id){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_action_types__["a" /* CONTRIBUTOR_SETTINGS_TOGGLE */],payload:id};}function toggleUserSettings(id){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_action_types__["q" /* USER_SETTINGS_TOGGLE */],payload:id};}function projectContributorDeleteSuccess(id){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_action_types__["g" /* PROJECT_CONTRIBUTORS_DELETE */],payload:id};}function deleteProjectContributor(projectId,id){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_project_contributors_api__["a" /* projectContributorsApi */].destroyProjectContributor(projectId,id).then(function(response){if(response.ok){dispatch(projectContributorDeleteSuccess(id));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function inviteUser(type,id,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_service_providers_api__["a" /* serviceProvidersApi */].inviteUser(type,id,values).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function sendInvite(user){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_service_providers_api__["a" /* serviceProvidersApi */].sendInvite(user).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function activationLink(user){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_service_providers_api__["a" /* serviceProvidersApi */].activationLink(user).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssign = __webpack_require__(2664),
    baseCreate = __webpack_require__(383);

/**
 * Creates an object that inherits from the `prototype` object. If a
 * `properties` object is given, its own enumerable string keyed properties
 * are assigned to the created object.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Object
 * @param {Object} prototype The object to inherit from.
 * @param {Object} [properties] The properties to assign to the object.
 * @returns {Object} Returns the new object.
 * @example
 *
 * function Shape() {
 *   this.x = 0;
 *   this.y = 0;
 * }
 *
 * function Circle() {
 *   Shape.call(this);
 * }
 *
 * Circle.prototype = _.create(Shape.prototype, {
 *   'constructor': Circle
 * });
 *
 * var circle = new Circle;
 * circle instanceof Circle;
 * // => true
 *
 * circle instanceof Shape;
 * // => true
 */
function create(prototype, properties) {
  var result = baseCreate(prototype);
  return properties == null ? result : baseAssign(result, properties);
}

module.exports = create;


/***/ }),
/* 117 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(290);
var defined = __webpack_require__(150);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(117);
var toObject = __webpack_require__(71);
var IE_PROTO = __webpack_require__(450)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(291);
var createDesc = __webpack_require__(210);
var toIObject = __webpack_require__(118);
var toPrimitive = __webpack_require__(149);
var has = __webpack_require__(117);
var IE8_DOM_DEFINE = __webpack_require__(655);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(59) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(749);
var isBuffer = __webpack_require__(1315);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clientsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClientsApi=function(_BaseApi){_inherits(ClientsApi,_BaseApi);function ClientsApi(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientsApi);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientsApi.__proto__||Object.getPrototypeOf(ClientsApi)).call.apply(_ref,[this].concat(args))),_this),_this._makeSimilarClientMsg=function(data,client,criteria){switch(criteria){case'company_name':return'Already exists a client with name '+client.company_name+'.';case'email':return'Client '+client.company_name+' has same email '+data.email+'.';case'phone_number':return'Client '+client.company_name+' has same phone number '+data.phoneNumber+'.';case'company_name_similar':return'A similar client '+client.company_name+' was found.';default:return'';}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientsApi,[{key:'createAccount',/**
   * Create account
   * @param {object} json
   * @return {{ok: boolean, errors: []}}
   */value:function createAccount(json){var data={client:{company_name:json.companyName,contact_attributes:{first_name:json.firstName,last_name:json.lastName,email:json.email,phone_number:json.phoneNumber,password:json.password,password_confirmation:json.passwordConfirmation},location_attributes:{street_address_1:json.address1,street_address_2:json.address2,city:json.city,state:json.state,zip:json.zip},global_po_required:json.globalPurchaseOrderRequired,po_required:json.purchaseOrderRequired},confirm_success_url:json.confirmSuccessUrl};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/clients',data).then(function(response){return{ok:true,errors:[]};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'resendInvitation',value:function resendInvitation(email,confirmSuccessUrl){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/user_confirmations',{email:email,confirm_success_url:confirmSuccessUrl}).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'_makeClientParams',value:function _makeClientParams(data,skipInvitation){var params={client:{company_name:data.companyName,contact_attributes:{first_name:data.firstName,last_name:data.lastName,email:data.email,phone_number:data.phoneNumber}}};if(skipInvitation){params['skip_invitation']=true;}else{params['client']['location_attributes']={street_address_1:data.streetAddress1,city:data.city,state:data.state,zip:data.zip};if(data.streetAddress2!==''){params['client']['location_attributes']['street_address_2']=data.streetAddress2;}}if(data.globalPurchaseOrderRequired!==null){params['client']['global_po_required']=data.globalPurchaseOrderRequired;}if(data.purchaseOrderRequired!==null){params['client']['po_required']=data.purchaseOrderRequired;}return params;}},{key:'findSimilar',value:function findSimilar(data){var _this2=this;var params=this._makeClientParams(data);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/clients/find_similar',params).then(function(response){return response.data&&response.data.client?{ok:true,client:response.data.client,criteria:response.data.criteria,message:_this2._makeSimilarClientMsg(data,response.data.client,response.data.criteria)}:{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'inviteClient',value:function inviteClient(data,skipInvitation){var params=this._makeClientParams(data,skipInvitation);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/clients/invite',params).then(function(response){return{ok:true,client:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'inviteExistent',value:function inviteExistent(clientId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/clients/'+clientId+'/invite_existent',{}).then(function(response){return{ok:true,client:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'inviteUsers',value:function inviteUsers(clientId,invitations){var params={users:invitations.map(function(element){var result={first_name:element.firstName,last_name:element.lastName,email:element.email,role_ids:element.permissions.map(function(element){return element.id;})};if(element.phoneNumber!==''){result['phone_number']=element.phoneNumber;}if(element.title!==''){result['title']=element.title;}if(element.buildingsId!==null){result['building_ids']=element.buildingsId;}return result;})};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/clients/'+clientId+'/invite_users',params).then(function(response){return{ok:true,users:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getClients',value:function getClients(page,label){var filter=page?'page='+page:'';filter+=label?'&by_company_name='+label:'';return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/clients?'+filter).then(function(response){return{ok:true,clients:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getClient',value:function getClient(clientId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/clients/'+clientId).then(function(response){return{ok:true,client:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getWorkOrders',value:function getWorkOrders(clientId,page,workOrderStatus){var filter='';if(workOrderStatus!==undefined){filter='&'+workOrderStatus.status+'=true';}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/clients/'+clientId+'/work_orders?page='+(page!==undefined?page:1)+filter).then(function(response){return{ok:true,workOrders:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),totalComplete:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-complete']).value(),totalDraft:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-draft']).value(),totalInProgress:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-in_progress']).value(),totalPending:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-pending']).value(),totalPlm:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-plm']).value(),totalWoa:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-woa']).value(),totalClosed:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-closed']).value(),totalDeclined:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-declined']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getClientProjects',value:function getClientProjects(clientId,page,status){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/clients/'+clientId+'/projects?page='+(page!==undefined?page:1)+(status?'&'+status+'=true':'')).then(function(response){return{ok:true,projects:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),totalPending:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-pending']).value(),totalInProgress:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-in_progress']).value(),totalComplete:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-complete']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getInvoices',value:function getInvoices(clientId,page,invoiceStatus){var filter='';if(invoiceStatus!==undefined){filter='&'+invoiceStatus+'=true';}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/clients/'+clientId+'/invoices?page='+(page!==undefined?page:1)+filter).then(function(response){return{ok:true,invoices:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateClient',value:function updateClient(id,client){var data=new FormData();data.append('client[company_name]',client.name);data.append('client[contact_attributes][first_name]',client.firstName);data.append('client[contact_attributes][last_name]',client.lastName);data.append('client[contact_attributes][email]',client.email);data.append('client[contact_attributes][phone_number]',client.phoneNumber);data.append('client[location_attributes][street_address_1]',client.streetAddress);data.append('client[location_attributes][street_address_2]',client.unitNumber);data.append('client[location_attributes][city]',client.city);data.append('client[location_attributes][state]',client.state);data.append('client[location_attributes][zip]',client.zipCode);if(client.globalPurchaseOrderRequired!==undefined){data.append('client[global_po_required]',client.globalPurchaseOrderRequired);}if(client.purchaseOrderRequired!==undefined){data.append('client[po_required]',client.purchaseOrderRequired);}var clientLogo=client.clientLogo;var imageLogo=clientLogo&&clientLogo.image;if(imageLogo&&imageLogo.name&&imageLogo.preview){data.append('client[logo_attributes][image]',imageLogo);}else if(clientLogo&&clientLogo.id&&clientLogo.url===''){data.append('client[logo_attributes][id]',client.clientLogo.id);data.append('client[logo_attributes][_destroy]',true);}var headers={headers:{'Content-Type':'multipart/form-data'}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/clients/'+id,data,headers).then(function(response){return{ok:true,client:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getUsers',value:function getUsers(clientId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/clients/'+clientId+'/users').then(function(response){return{ok:true,users:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getPurchaseOrders',value:function getPurchaseOrders(clientId){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/clients/'+clientId+'/purchase_orders?page='+page).then(function(response){return{ok:true,purchaseOrders:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'searchByCompanyName',value:function searchByCompanyName(){var value=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'//clients?by_company_name='+value,{loadingDisabled:true}).then(function(response){return{ok:true,clients:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateNotes',value:function updateNotes(clientId){var text=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var reminder=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var data={client:{note:text,note_reminder_date:reminder}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/clients/'+clientId,data).then(function(response){return{ok:true,client:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return ClientsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var clientsApi=new ClientsApi();/* harmony default export */ __webpack_exports__["b"] = (ClientsApi=new ClientsApi());

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UsersApi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return usersApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_utils_users_util__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UsersApi=function(_BaseApi){_inherits(UsersApi,_BaseApi);function UsersApi(){_classCallCheck(this,UsersApi);return _possibleConstructorReturn(this,(UsersApi.__proto__||Object.getPrototypeOf(UsersApi)).apply(this,arguments));}_createClass(UsersApi,[{key:'removeUser',value:function removeUser(id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/users/'+id).then(function(){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getUsers',value:function getUsers(){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/users').then(function(response){return{ok:true,users:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'addUser',value:function addUser(firstName,lastName,email){var phoneNumber=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var rolesId=arguments[4];var title=arguments.length>5&&arguments[5]!==undefined?arguments[5]:null;var buildingsId=arguments.length>6&&arguments[6]!==undefined?arguments[6]:null;var data=this.createAddEditUserData(firstName,lastName,email,phoneNumber,rolesId,title,buildingsId);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/users',data).then(function(response){return{ok:true,user:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateUser',value:function updateUser(id,firstName,lastName,email){var phoneNumber=arguments.length>4&&arguments[4]!==undefined?arguments[4]:null;var rolesId=arguments[5];var title=arguments.length>6&&arguments[6]!==undefined?arguments[6]:null;var buildingId=arguments.length>7&&arguments[7]!==undefined?arguments[7]:null;var data=this.createAddEditUserData(firstName,lastName,email,phoneNumber,rolesId,title,buildingId);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/users/'+id,data).then(function(response){return{ok:true,user:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createAddEditUserData',value:function createAddEditUserData(firstName,lastName,email){var phoneNumber=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var rolesId=arguments[4];var title=arguments.length>5&&arguments[5]!==undefined?arguments[5]:null;var buildingsId=arguments.length>6&&arguments[6]!==undefined?arguments[6]:null;var data={user:{email:email,first_name:firstName,last_name:lastName,role_ids:rolesId}};if(phoneNumber!==null&&phoneNumber!==''){data.user['phone_number']=phoneNumber;}if(title!==null&&title!==''){data.user['title']=title;}if(buildingsId!==null){data.user['building_ids']=buildingsId;}return data;}},{key:'updateTermsAndConditions',value:function updateTermsAndConditions(isAccepted){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/user/terms_and_conditions',{user:{terms_and_conditions:isAccepted}}).then(function(response){return{ok:true,data:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'resendInvite',value:function resendInvite(userId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/users/'+userId+'/resend_invite',{id:userId}).then(function(response){return{ok:true};}).catch(function(error){return{ok:false};});}},{key:'resendInviteLink',value:function resendInviteLink(currentUser,user){if(user.invitation_accepted_at!==null){return false;}else if(currentUser.accountable_type==null||currentUser.accountable_type===__WEBPACK_IMPORTED_MODULE_2_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR){return true;}else{return currentUser.accountable_type===user.accountable_type;}}}]);return UsersApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var usersApi=new UsersApi();/* harmony default export */ __webpack_exports__["a"] = (UsersApi=new UsersApi());

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = closeWOCancellationModal;
/* harmony export (immutable) */ __webpack_exports__["b"] = goToClientSelection;
/* harmony export (immutable) */ __webpack_exports__["c"] = goToSubContractorsUnionTrades;
/* harmony export (immutable) */ __webpack_exports__["d"] = goToSummary;
/* harmony export (immutable) */ __webpack_exports__["e"] = goToTasks;
/* harmony export (immutable) */ __webpack_exports__["f"] = goToWorkingHours;
/* harmony export (immutable) */ __webpack_exports__["g"] = showWOCancellationModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(45);
function closeWOCancellationModal(){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["X" /* WORK_ORDERS_CREATION_WO_CANCELLATION_MODAL_CLOSE */]};}function goToClientSelection(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_1__work_orders__["c" /* baseRoutePath */]+'/client-selection'));};}function goToSubContractorsUnionTrades(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_1__work_orders__["c" /* baseRoutePath */]+'/sub-contractors-union-trades'));};}function goToSummary(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_1__work_orders__["c" /* baseRoutePath */]+'/work-order-summary'));};}function goToTasks(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_1__work_orders__["c" /* baseRoutePath */]+'/tasks'));};}function goToWorkingHours(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_1__work_orders__["c" /* baseRoutePath */]+'/working-hours'));};}function showWOCancellationModal(){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["Y" /* WORK_ORDERS_CREATION_WO_CANCELLATION_MODAL_SHOW */]};}

/***/ }),
/* 125 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_react_fontawesome__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailsInfoItem_css__ = __webpack_require__(1929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailsInfoItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DetailsInfoItem_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__text_SimpleTruncate__ = __webpack_require__(200);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsInfoItem=function(_Component){_inherits(DetailsInfoItem,_Component);function DetailsInfoItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DetailsInfoItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DetailsInfoItem.__proto__||Object.getPrototypeOf(DetailsInfoItem)).call.apply(_ref,[this].concat(args))),_this),_this.defaultLines=5,_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DetailsInfoItem,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-info-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-bold'},this.props.title,this.props.icon!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__fortawesome_react_fontawesome__["a" /* default */],{icon:this.props.icon}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-regular'},!this.props.truncate?this.props.lines.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},element);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__text_SimpleTruncate__["a" /* default */],{shownLines:this.defaultLines,text:this.props.lines.reduce(function(accumulator,currentValue){return accumulator+currentValue+'\n';},'')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}));}}]);return DetailsInfoItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DetailsInfoItem.propTypes={icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,lines:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object])).isRequired,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,truncate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool// Show lines with a "Show more" if more than 5 lines. WARNING: lines should be plain text
};DetailsInfoItem.defaultProps={truncate:false};/* harmony default export */ __webpack_exports__["a"] = (DetailsInfoItem);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = addEmail;
/* harmony export (immutable) */ __webpack_exports__["c"] = back;
/* unused harmony export clearEmails */
/* harmony export (immutable) */ __webpack_exports__["d"] = closePdfViewer;
/* harmony export (immutable) */ __webpack_exports__["e"] = closeProposalModal;
/* unused harmony export createProposalMessage */
/* unused harmony export createProposalSubject */
/* harmony export (immutable) */ __webpack_exports__["f"] = continueRequest;
/* unused harmony export continueSuccess */
/* harmony export (immutable) */ __webpack_exports__["i"] = initializeEmailValues;
/* unused harmony export loadUsersSuccess */
/* harmony export (immutable) */ __webpack_exports__["j"] = loadEmailProposalDataRequest;
/* harmony export (immutable) */ __webpack_exports__["k"] = next;
/* harmony export (immutable) */ __webpack_exports__["l"] = printProposal;
/* unused harmony export printProposalSuccess */
/* harmony export (immutable) */ __webpack_exports__["n"] = removeEmail;
/* harmony export (immutable) */ __webpack_exports__["p"] = sendEmail;
/* harmony export (immutable) */ __webpack_exports__["r"] = setProposalSubject;
/* harmony export (immutable) */ __webpack_exports__["q"] = setProposalMessage;
/* harmony export (immutable) */ __webpack_exports__["s"] = setShowEmailModal;
/* harmony export (immutable) */ __webpack_exports__["u"] = showProposalModal;
/* harmony export (immutable) */ __webpack_exports__["t"] = showEditProposalModal;
/* harmony export (immutable) */ __webpack_exports__["y"] = updateStartDate;
/* harmony export (immutable) */ __webpack_exports__["w"] = updateCompletionDate;
/* harmony export (immutable) */ __webpack_exports__["x"] = updateProposalValue;
/* harmony export (immutable) */ __webpack_exports__["o"] = saveProposal;
/* harmony export (immutable) */ __webpack_exports__["z"] = updateValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = addBreakdownItem;
/* harmony export (immutable) */ __webpack_exports__["m"] = removeBreakdownItem;
/* harmony export (immutable) */ __webpack_exports__["v"] = updateBreakdownItem;
/* harmony export (immutable) */ __webpack_exports__["A"] = withDrawProposalRequest;
/* harmony export (immutable) */ __webpack_exports__["h"] = depositSelectedChange;
/* harmony export (immutable) */ __webpack_exports__["g"] = depositCostChange;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_proposals_api__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_proposal_util__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_api_clients_api__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal_approval__ = __webpack_require__(323);
function addEmail(email){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_86" /* WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_ADD */],payload:email};}function back(view){var previousActions={review:'form'};return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_81" /* WORK_ORDERS_DETAILS_PROPOSAL_BACK */],payload:previousActions[view]};}function clearEmails(){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_87" /* WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_CLEAR */]};}function closePdfViewer(){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_96" /* WORK_ORDERS_DETAILS_PROPOSAL_PDF_VIEWER_CLOSE */]};}function closeProposalModal(){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_92" /* WORK_ORDERS_DETAILS_PROPOSAL_MODAL_CLOSE */]};}function createProposalMessage(proposalNumber,clientName){var workOrderName=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var buildingLocation=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var woName=workOrderName?' - '+workOrderName:'';var location='';if(buildingLocation!==null){location=' at '+buildingLocation.street_address_1+', '+buildingLocation.city+' '+buildingLocation.state;}return'Please find the attached proposal #'+proposalNumber+' for '+clientName+woName+location+'. If you have any questions, please reach out via chat or email.\n\nThank you';}function createProposalSubject(workOrderNumber,clientName){var workOrderName=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var woName=workOrderName?' - '+workOrderName:'';return'Spackle Proposal for WO #'+workOrderNumber+' '+clientName+woName;}function continueRequest(currentWorkOrderId,startDate,completionDate,valuesByQuoteId,qualifications,selectedQualificationsById,depositCost){return function(dispatch){var quotesMarkup=Object.entries(valuesByQuoteId).map(function(element){var values=element[1];return{quote_id:element[0],fee:values['fee'],insurance:values['insurance'],markup:values['markup'],breakdown_items_attributes:values['breakdownItems']};});var deposit=depositCost!==null?{cost:depositCost}:null;return __WEBPACK_IMPORTED_MODULE_2_services_api_proposals_api__["a" /* proposalsApi */].create(currentWorkOrderId,startDate,completionDate,quotesMarkup,qualifications.filter(function(q){return selectedQualificationsById[q.id];}).map(function(q){var value=selectedQualificationsById[q.id];return{qualification_id:value.id,option:value.option!==null?value.option.label:null};}),deposit).then(function(response){if(response.ok){dispatch(continueSuccess());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_details__["c" /* addProposal */])(response.proposal));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_details__["I" /* loadTasksFromWorkOrderRequest */])(currentWorkOrderId,false));// fetch tasks because state changes after new proposal
}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function continueSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_83" /* WORK_ORDERS_DETAILS_PROPOSAL_CREATE_SUCCESS */]};}function initializeEmailValues(proposalNumber,workOrderNumber,workOrderName,buildingLocation,clientName,users){return function(dispatch){// Create and dispatch generated subject and message
dispatch(setProposalSubject(createProposalSubject(workOrderNumber,clientName,workOrderName)));dispatch(setProposalMessage(createProposalMessage(proposalNumber,clientName,workOrderName,buildingLocation)));// Clear emails
dispatch(clearEmails());// Add client owner by default
var owner=users.find(function(user){return __WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__["g" /* usersUtil */].hasRole(user,__WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__["e" /* ROLES */].OWNER);});if(owner!==undefined){dispatch(addEmail(owner.email));}};}function loadUsersSuccess(users){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_106" /* WORK_ORDERS_DETAILS_PROPOSAL_USERS_LOAD_SUCCESS */],payload:users};}function loadEmailProposalDataRequest(proposalNumber,workOrderNumber,workOrderName,buildingLocation,clientId,clientName){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5_services_api_clients_api__["a" /* clientsApi */].getUsers(clientId).then(function(response){if(response.ok){dispatch(loadUsersSuccess(response.users));dispatch(initializeEmailValues(proposalNumber,workOrderNumber,workOrderName,buildingLocation,clientName,response.users));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function next(view){var nextActions={form:'review',review:'thank-you'};return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_95" /* WORK_ORDERS_DETAILS_PROPOSAL_NEXT */],payload:nextActions[view]};}function printProposal(proposalId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_proposals_api__["a" /* proposalsApi */].getAsPdf(proposalId).then(function(response){if(response.ok){dispatch(printProposalSuccess(response.pdf));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function printProposalSuccess(pdf){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_97" /* WORK_ORDERS_DETAILS_PROPOSAL_PRINT_SUCCESS */],payload:pdf};}function removeEmail(email){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_89" /* WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_REMOVE */],payload:email};}function sendEmail(proposalId,emails,subject,message){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_proposals_api__["a" /* proposalsApi */].sendEmail(proposalId,emails,subject,message).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setProposalSubject(subject){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_101" /* WORK_ORDERS_DETAILS_PROPOSAL_SUBJECT_SET */],payload:subject};}function setProposalMessage(message){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_91" /* WORK_ORDERS_DETAILS_PROPOSAL_MESSAGE_SET */],payload:message};}function setShowEmailModal(value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_88" /* WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_MODAL_SHOW_SET */],payload:value};}function showProposalModal(quoteEstimateByQuoteId,startDate,completionDate){// Calculate markup, fee and insurance for each quote
var valuesByQuoteId={};Object.entries(quoteEstimateByQuoteId).forEach(function(entry){var quoteId=entry[0];var estimate=entry[1];valuesByQuoteId[quoteId]={markup:Math.round(Object(__WEBPACK_IMPORTED_MODULE_4_services_utils_proposal_util__["c" /* calculateMarkup */])(estimate)),fee:Math.round(Object(__WEBPACK_IMPORTED_MODULE_4_services_utils_proposal_util__["a" /* calculateFee */])(estimate)),insurance:Math.round(Object(__WEBPACK_IMPORTED_MODULE_4_services_utils_proposal_util__["b" /* calculateInsurace */])(estimate)),breakdownItems:[]};});return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_94" /* WORK_ORDERS_DETAILS_PROPOSAL_MODAL_SHOW */],payload:{valuesByQuoteId:valuesByQuoteId,startDate:startDate,completionDate:completionDate}};}function showEditProposalModal(selectedProposal){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_93" /* WORK_ORDERS_DETAILS_PROPOSAL_MODAL_EDIT */],payload:selectedProposal};}function updateStartDate(value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_100" /* WORK_ORDERS_DETAILS_PROPOSAL_START_DATE_UPDATE */],payload:value};}function updateCompletionDate(value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_82" /* WORK_ORDERS_DETAILS_PROPOSAL_COMPLETION_DATE_UPDATE */],payload:value};}function updateProposalValue(proposalQuoteId,valueKey,value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_98" /* WORK_ORDERS_DETAILS_PROPOSAL_QUOTE_UPDATE */],payload:{proposalQuoteId:proposalQuoteId,key:valueKey,value:value}};}function saveProposal(proposal){var values={proposal_quotes:proposal.proposal_quotes};return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_proposals_api__["a" /* proposalsApi */].update(proposal.id,values).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_details__["_14" /* updateProposal */])(response.proposal));dispatch(closeProposalModal());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_details__["L" /* loadWorkOrderRequest */])(response.proposal.work_order_id,true,false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_details__["W" /* selectNavigationBar */])(response.proposal.work_order_id,1));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function updateValue(quoteId,valueKey,value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_90" /* WORK_ORDERS_DETAILS_PROPOSAL_MARKUP_UPDATE */],payload:{quoteId:quoteId,key:valueKey,value:value}};}function addBreakdownItem(quoteId,breakdownItem){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_78" /* WORK_ORDERS_DETAILS_PROPOSAL_ADD_BREAKDOWNITEM */],payload:{quoteId:quoteId,breakdownItem:breakdownItem}};}function removeBreakdownItem(quoteId,biIndex){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_99" /* WORK_ORDERS_DETAILS_PROPOSAL_REMOVE_BREAKDOWNITEM */],payload:{quoteId:quoteId,biIndex:biIndex}};}function updateBreakdownItem(quoteId,biIndex,key,value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_105" /* WORK_ORDERS_DETAILS_PROPOSAL_UPDATE_BREAKDOWNITEM */],payload:{quoteId:quoteId,biIndex:biIndex,key:key,value:value}};}function withDrawProposalRequest(proposalId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_proposals_api__["a" /* proposalsApi */].withdraw(proposalId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_details__["_14" /* updateProposal */])(response.proposal));dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal_approval__["b" /* closeProposalApprovalModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_details__["L" /* loadWorkOrderRequest */])(response.proposal.work_order_id,true,false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_details__["W" /* selectNavigationBar */])(response.proposal.work_order_id,1));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function depositSelectedChange(value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_85" /* WORK_ORDERS_DETAILS_PROPOSAL_DEPOSIT_SELECTED_CHANGE */],payload:value};}function depositCostChange(value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_84" /* WORK_ORDERS_DETAILS_PROPOSAL_DEPOSIT_COST_CHANGE */],payload:value};}

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export baseRoutePath */
/* unused harmony export addClient */
/* unused harmony export addUsers */
/* harmony export (immutable) */ __webpack_exports__["b"] = changeFilter;
/* unused harmony export changePage */
/* harmony export (immutable) */ __webpack_exports__["c"] = clearClientForm;
/* unused harmony export loadBuildingsRequest */
/* harmony export (immutable) */ __webpack_exports__["n"] = loadRolesRequest;
/* unused harmony export loadRolesSuccess */
/* unused harmony export invalidForm */
/* harmony export (immutable) */ __webpack_exports__["d"] = goToClient;
/* harmony export (immutable) */ __webpack_exports__["e"] = goToEditClient;
/* harmony export (immutable) */ __webpack_exports__["i"] = loadClientsRequest;
/* harmony export (immutable) */ __webpack_exports__["j"] = loadClientsSuccess;
/* unused harmony export setClientsPaginationData */
/* harmony export (immutable) */ __webpack_exports__["h"] = loadClientRequest;
/* unused harmony export loadClientSuccess */
/* harmony export (immutable) */ __webpack_exports__["k"] = loadInvoicesRequest;
/* unused harmony export loadInvoicesSuccess */
/* harmony export (immutable) */ __webpack_exports__["m"] = loadPurchaseOrdersRequest;
/* unused harmony export loadPurchaseOrdersSuccess */
/* harmony export (immutable) */ __webpack_exports__["o"] = loadSurveysRequest;
/* harmony export (immutable) */ __webpack_exports__["p"] = loadWorkOrdersRequest;
/* harmony export (immutable) */ __webpack_exports__["l"] = loadProjectsRequest;
/* unused harmony export loadWorkOrdersSuccess */
/* unused harmony export loadProjectsSuccess */
/* harmony export (immutable) */ __webpack_exports__["r"] = setShowInviteClientModal;
/* harmony export (immutable) */ __webpack_exports__["s"] = setShowInviteUserClientModal;
/* harmony export (immutable) */ __webpack_exports__["t"] = showContactsModal;
/* harmony export (immutable) */ __webpack_exports__["u"] = showContactsRequest;
/* unused harmony export convertInviteUserFormToApiData */
/* harmony export (immutable) */ __webpack_exports__["q"] = setNoteEditorEdit;
/* harmony export (immutable) */ __webpack_exports__["w"] = submitInviteUserFormRequest;
/* harmony export (immutable) */ __webpack_exports__["v"] = submitFormRequest;
/* harmony export (immutable) */ __webpack_exports__["f"] = inviteClient;
/* harmony export (immutable) */ __webpack_exports__["g"] = inviteExistentClient;
/* harmony export (immutable) */ __webpack_exports__["y"] = updateFormValue;
/* harmony export (immutable) */ __webpack_exports__["B"] = updateNotes;
/* harmony export (immutable) */ __webpack_exports__["z"] = updateNoteEditorReminder;
/* harmony export (immutable) */ __webpack_exports__["A"] = updateNoteEditorText;
/* unused harmony export validForm */
/* harmony export (immutable) */ __webpack_exports__["a"] = addClientToBeginning;
/* harmony export (immutable) */ __webpack_exports__["x"] = updateClientData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_clients_api__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_roles_api__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_api_buildings_api__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_api_surveys_api__ = __webpack_require__(964);
var baseRoutePath='/admin/clients';function addClient(client){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["u" /* CLIENTS_INVITE_CLIENT_ADD */],payload:client};}function addUsers(users){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["q" /* CLIENTS_CLIENT_USERS_ADD */],payload:users};}function changeFilter(filter){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["c" /* CLIENTS_CLIENT_FILTER_CHANGE */],payload:filter};}function changePage(newPage){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["k" /* CLIENTS_CLIENT_PAGE_CHANGE */],payload:newPage};}function clearClientForm(){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["v" /* CLIENTS_INVITE_FORM_CLEAR */]};}function loadBuildingsRequest(clientId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_6_services_api_buildings_api__["a" /* buildingsApi */].getBuildings(clientId).then(function(response){if(response.ok){dispatch(loadBuildingsSuccess(response.buildings));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadBuildingsSuccess(buildings){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["b" /* CLIENTS_CLIENT_BUILDINGS_LOAD_SUCCESS */],payload:buildings};}function loadRolesRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_roles_api__["b" /* rolesApi */].getRoles(__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["f" /* TYPES */].CLIENT).then(function(response){if(response.ok){dispatch(loadRolesSuccess(response.permissions));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadRolesSuccess(roles){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["n" /* CLIENTS_CLIENT_ROLES_LOAD_SUCCESS */],payload:roles};}function invalidForm(invalidFields,message){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["w" /* CLIENTS_INVITE_FORM_INVALID */],payload:{invalidFields:invalidFields,message:message}};}function goToClient(clientId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])(baseRoutePath+'/'+clientId));};}function goToEditClient(clientId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])(baseRoutePath+'/'+clientId+'/edit'));};}function loadClientsRequest(page,label){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_clients_api__["a" /* clientsApi */].getClients(page,label).then(function(response){if(response.ok){dispatch(loadClientsSuccess(response.clients));if(page){dispatch(setClientsPaginationData(page,response.total,response.pageSize));}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadClientsSuccess(clients){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["z" /* CLIENTS_LOAD_SUCCESS */],payload:clients};}function setClientsPaginationData(page,total,pageSize){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["A" /* CLIENTS_SET_PAGINATION_DATA */],payload:{page:page,total:total,pageSize:pageSize}};}function loadClientRequest(clientId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_clients_api__["a" /* clientsApi */].getClient(clientId).then(function(response){if(response.ok){dispatch(loadClientSuccess(response.client));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadClientSuccess(client){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["f" /* CLIENTS_CLIENT_LOAD_SUCCESS */],payload:client};}function loadInvoicesRequest(buildingId,page,invoiceStatus){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_clients_api__["a" /* clientsApi */].getInvoices(buildingId,page,invoiceStatus).then(function(response){if(response.ok){dispatch(loadInvoicesSuccess(response.invoices));dispatch(changePage(page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadInvoicesSuccess(invoices){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["e" /* CLIENTS_CLIENT_INVOICES_LOAD_SUCCESS */],payload:invoices};}function loadPurchaseOrdersRequest(clientId,page){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_clients_api__["a" /* clientsApi */].getPurchaseOrders(clientId,page).then(function(response){if(response.ok){dispatch(loadPurchaseOrdersSuccess(response.purchaseOrders));dispatch(changePage(page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadPurchaseOrdersSuccess(purchaseOrders){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["m" /* CLIENTS_CLIENT_PURCHASE_ORDERS_SUCCESS */],payload:purchaseOrders};}function loadSurveysRequest(clientId){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;return function(dispatch){return __WEBPACK_IMPORTED_MODULE_7_services_api_surveys_api__["a" /* surveysApi */].getClientSurveys(clientId,page).then(function(response){if(response.ok){dispatch(loadSurveysSuccess(response.surveys));dispatch(changePage(page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadSurveysSuccess(surveys){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["p" /* CLIENTS_CLIENT_SURVEYS_LOAD_SUCCESS */],payload:surveys};}function loadWorkOrdersRequest(clientId,page,workOrderStatus){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_clients_api__["a" /* clientsApi */].getWorkOrders(clientId,page,workOrderStatus).then(function(response){if(response.ok){dispatch(loadWorkOrdersSuccess(response.workOrders));dispatch(changePage(page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadProjectsRequest(clientId,page,projectStatus){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_clients_api__["a" /* clientsApi */].getClientProjects(clientId,page,projectStatus).then(function(response){if(response.ok){dispatch(loadProjectsSuccess(response.projects));dispatch(changePage(page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadWorkOrdersSuccess(workOrders){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["r" /* CLIENTS_CLIENT_WORK_ORDERS_LOAD_SUCCESS */],payload:workOrders};}function loadProjectsSuccess(projects){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["l" /* CLIENTS_CLIENT_PROJECTS_LOAD_SUCCESS */],payload:projects};}function setClientUsers(users){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["B" /* CLIENTS_USERS_SET */],payload:users};}function setShowInviteClientModal(value){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["y" /* CLIENTS_INVITE_USER_MODAL_SHOW */],payload:value};}function setShowInviteUserClientModal(value){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["d" /* CLIENTS_CLIENT_INVITE_USER_SHOW */],payload:value};}function showContactsModal(value){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["s" /* CLIENTS_CONTACTS_MODAL_SHOW */],payload:value};}function showContactsRequest(clientId,users,buildings){return function(dispatch){if(users.length===0&&buildings.length===0){var promises=[];promises.push(__WEBPACK_IMPORTED_MODULE_1_services_api_clients_api__["a" /* clientsApi */].getUsers(clientId));promises.push(__WEBPACK_IMPORTED_MODULE_6_services_api_buildings_api__["a" /* buildingsApi */].getBuildings(clientId));return Promise.all(promises).then(function(values){var result={};if(values[0].ok&&values[1].ok){dispatch(setClientUsers(values[0].users));dispatch(loadBuildingsSuccess(values[1].buildings));dispatch(showContactsModal(true));result.ok=true;}else{var errors=[];if(!values[0].ok){errors=errors.concat(values[0].errors);}if(!values[1].ok){errors=errors.concat(values[1].errors);}dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(errors));result.ok=false;}return result;});}else if(users.length===0){return __WEBPACK_IMPORTED_MODULE_1_services_api_clients_api__["a" /* clientsApi */].getUsers(clientId).then(function(response){if(response.ok){dispatch(setClientUsers(response.users));dispatch(showContactsModal(true));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});}else if(buildings.length===0){return __WEBPACK_IMPORTED_MODULE_6_services_api_buildings_api__["a" /* buildingsApi */].getBuildings(clientId).then(function(response){if(response.ok){dispatch(loadBuildingsSuccess(response.buildings));dispatch(showContactsModal(true));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});}else{dispatch(showContactsModal(true));}};}function convertInviteUserFormToApiData(form){var data=Object.assign({},form,{permissions:form.rolesId.map(function(id){return{id:id};})});delete data.rolesId;return[data];}function setCurrentClient(value){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["o" /* CLIENTS_CLIENT_SET */],payload:value};}function setNoteEditorEdit(value){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["g" /* CLIENTS_CLIENT_NOTE_EDITOR_EDIT_SET */],payload:value};}function setNotesEditorSaving(value){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["i" /* CLIENTS_CLIENT_NOTE_EDITOR_SAVING_SET */],payload:value};}function submitInviteUserFormRequest(form,clientId,roles){return function(dispatch){var businessMgrRoleSelected=false;var businessMaganerRole=roles.find(function(role){return role.name===__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["e" /* ROLES */].CLIENT_BUILDING_MANAGER;});if(businessMaganerRole!==null){businessMgrRoleSelected=form.rolesId.find(function(id){return id===businessMaganerRole.id;})!==undefined;}// Validate form
var requiredFields=['firstName','lastName','email','phoneNumber','rolesId'];if(businessMgrRoleSelected){requiredFields.push('buildingsId');}var invalidFields=[];requiredFields.forEach(function(attribute){if(attribute==='rolesId'||attribute==='buildingsId'){if(form[attribute].length===0){invalidFields.push(attribute);}}else{if(form[attribute]===''||form[attribute]===null){invalidFields.push(attribute);}}});if(invalidFields.length>0){dispatch(invalidForm(invalidFields,'The outlined inputs should be added in order to invite a new user.'));return null;}else{dispatch(validForm());return __WEBPACK_IMPORTED_MODULE_1_services_api_clients_api__["a" /* clientsApi */].inviteUsers(clientId,convertInviteUserFormToApiData(form)).then(function(response){if(response.ok){dispatch(addUsers(response.users));dispatch(setShowInviteUserClientModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});}};}function submitFormRequest(form){return function(dispatch){// Validate form
var requiredFields=['companyName','firstName','lastName','email','phoneNumber','streetAddress1','city','state','zip'];var invalidFields=[];requiredFields.forEach(function(attribute){if(form[attribute]===''){invalidFields.push(attribute);}});if(invalidFields.length>0){dispatch(invalidForm(invalidFields,'The outlined inputs should be added in order to invite a client.'));return null;}else{dispatch(validForm());return __WEBPACK_IMPORTED_MODULE_1_services_api_clients_api__["a" /* clientsApi */].findSimilar(form).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});}};}function inviteClient(form){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_clients_api__["a" /* clientsApi */].inviteClient(form).then(function(response){if(response.ok){dispatch(addClient(response.client));dispatch(setShowInviteClientModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function inviteExistentClient(clientId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_clients_api__["a" /* clientsApi */].inviteExistent(clientId).then(function(response){if(response.ok){dispatch(addClient(response.client));dispatch(setShowInviteClientModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateFormValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["t" /* CLIENTS_INVITE_ATTRIBUTE_CHANGE */],payload:{attribute:attribute,value:value}};}function updateNotes(clientId,text,reminder){return function(dispatch){dispatch(setNotesEditorSaving(true));return __WEBPACK_IMPORTED_MODULE_1_services_api_clients_api__["a" /* clientsApi */].updateNotes(clientId,text,reminder).then(function(response){dispatch(setNoteEditorEdit(false));dispatch(setNotesEditorSaving(false));if(response.ok){dispatch(setCurrentClient(response.client));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateNoteEditorReminder(value){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["h" /* CLIENTS_CLIENT_NOTE_EDITOR_REMINDER_CHANGE */],payload:value};}function updateNoteEditorText(value){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["j" /* CLIENTS_CLIENT_NOTE_EDITOR_TEXT_CHANGE */],payload:value};}function validForm(){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["x" /* CLIENTS_INVITE_FORM_VALID */]};}function addClientToBeginning(client){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_clients_action_types__["a" /* CLIENTS_ADD_TO_BEGINNING */],payload:client};}function updateClientData(clientId,clientData){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_clients_api__["a" /* clientsApi */].updateClient(clientId,clientData).then(function(response){if(response.ok){dispatch(setCurrentClient(response.client));dispatch(goToClient(clientId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getDailyReports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCurrentDailyReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getShowAddDailyReportModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getShowReviewForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getDailyReportIsSubmitted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getContributors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getPresetTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return getSupervisorTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getMembers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getDeletedMembers; });
/* unused harmony export getMembersUsers */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getContributorsForm; });
/* unused harmony export getDailyReportEntryIds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getActiveEntryId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getReportDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getReportExtraInputs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getReportOpenItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getGCImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getGCDeletedImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getActiveContributor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getEditMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getDailyReportLogPdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getDailyReportLogPdfViewer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getReportPdfViewer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getReportPdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getGeneralContactorName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getMemberForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getReportsPageSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getReportsTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getDelivery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getExtraInputs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getDailyReportsTabSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getSubDailyReportsCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getFieldWorkOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getShowFieldWorkOrderModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCurrentFieldWorkOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getFieldWorkOrderForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getFieldWorkOrderEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getShowFieldWorkOrderError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAddFloor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getDailyReports=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.dailyReports;},function(dailyReports){return dailyReports;});var getCurrentDailyReport=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.currentDailyReport;},function(currentDailyReport){return currentDailyReport;});var getShowAddDailyReportModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.ui.showAddDailyReportModal;},function(dailyReports){return dailyReports;});var getShowReviewForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.ui.showReviewForm;},function(showReviewForm){return showReviewForm;});var getDailyReportIsSubmitted=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.ui.isSubmitted;},function(isSubmitted){return isSubmitted;});var getContributors=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.contributors;},function(recipients){return recipients;});var getPresetTasks=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.presetTasks;},function(presetTasks){return presetTasks;});var getSupervisorTasks=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.supervisorTasks;},function(supervisorTasks){return supervisorTasks;});var getMembers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.members;},function(members){return members;});var getDeletedMembers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.deletedMembers;},function(deletedMembers){return deletedMembers;});var getMembersUsers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.membersUsers;},function(membersUsers){return membersUsers;});var getContributorsForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.contributorsForm;},function(contributorsForm){return contributorsForm;});var getDailyReportEntryIds=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.currentDailyReportIds;},function(ids){return ids;});var getActiveEntryId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.activeEntryId;},function(id){return id;});var getReportDate=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.reportDate;},function(reportDate){return reportDate;});var getReportExtraInputs=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.reportExtraInputs;},function(reportExtraInputs){return reportExtraInputs;});var getReportOpenItem=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.reportOpenItem;},function(reportOpenItem){return reportOpenItem;});var getGCImages=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.gcImages;},function(gcImages){return gcImages;});var getGCDeletedImages=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.gcDeletedImages;},function(gcDeletedImages){return gcDeletedImages;});var getActiveContributor=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.ui.activeContributor;},function(dailyReports){return dailyReports;});var getEditMode=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.ui.editMode;},function(editMode){return editMode;});var getDailyReportLogPdf=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.dailyReportLogPdf;},function(dailyReportLogPdf){return dailyReportLogPdf;});var getDailyReportLogPdfViewer=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.ui.dailyReportLogPdfViewer;},function(dailyReportLogPdfViewer){return dailyReportLogPdfViewer;});var getReportPdfViewer=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.ui.reportPdfViewer;},function(reportPdfViewer){return reportPdfViewer;});var getReportPdf=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.reportLogPdf;},function(reportLogPdf){return reportLogPdf;});var getGeneralContactorName=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.generalContactor;},function(generalContactor){return generalContactor;});var getMemberForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.ui.memberForm;},function(memberForm){return memberForm;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.ui.currentPage;},function(currentPage){return currentPage;});var getReportsPageSize=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.ui.reportsPageSize;},function(reportsPageSize){return reportsPageSize;});var getReportsTotal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.ui.reportsTotal;},function(reportsTotal){return reportsTotal;});var getDelivery=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.ui.delivery;},function(delivery){return delivery;});var getExtraInputs=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.ui.extraInputs;},function(extraInputs){return extraInputs;});var getDailyReportsTabSelected=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.ui.dailyReportsTabSelected;},function(dailyReportsTabSelected){return dailyReportsTabSelected;});var getSubDailyReportsCount=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.subDailyReportsCount;},function(subDailyReportsCount){return subDailyReportsCount;});var getFieldWorkOrders=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.fieldWorkOrders;},function(fieldWorkOrders){return fieldWorkOrders;});var getShowFieldWorkOrderModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.ui.showFieldWorkOrderModal;},function(showFieldWorkOrderModal){return showFieldWorkOrderModal;});var getCurrentFieldWorkOrder=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.currentFieldWorkOrder;},function(currentFieldWorkOrder){return currentFieldWorkOrder;});var getFieldWorkOrderForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.data.fieldWorkOrderForm;},function(fieldWorkOrderForm){return fieldWorkOrderForm;});var getFieldWorkOrderEdit=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.ui.fieldWorkOrderEdit;},function(fieldWorkOrderEdit){return fieldWorkOrderEdit;});var getShowFieldWorkOrderError=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.ui.showFieldWorkOrderError;},function(showFieldWorkOrderError){return showFieldWorkOrderError;});var getAddFloor=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.dailyReportLog.ui.addFloor;},function(addFloor){return addFloor;});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = initSubmittalLog;
/* harmony export (immutable) */ __webpack_exports__["B"] = setSubmittalTabSelected;
/* unused harmony export loadSubmittalsSuccess */
/* harmony export (immutable) */ __webpack_exports__["m"] = loadSubmittalsRequest;
/* harmony export (immutable) */ __webpack_exports__["y"] = setSubmittalModalShow;
/* harmony export (immutable) */ __webpack_exports__["i"] = initSubmittalModal;
/* harmony export (immutable) */ __webpack_exports__["E"] = updateSubmittalFormValue;
/* harmony export (immutable) */ __webpack_exports__["g"] = deleteSubmittalFile;
/* harmony export (immutable) */ __webpack_exports__["c"] = createSubmittal;
/* harmony export (immutable) */ __webpack_exports__["A"] = setSubmittalReadOnly;
/* harmony export (immutable) */ __webpack_exports__["w"] = setSubmittalLeadTimeReadOnly;
/* harmony export (immutable) */ __webpack_exports__["v"] = setSubmittalGcAcceleration;
/* harmony export (immutable) */ __webpack_exports__["t"] = setShowTransmittalPdf;
/* unused harmony export setTransmittalPdf */
/* harmony export (immutable) */ __webpack_exports__["n"] = loadTransmittalPdf;
/* unused harmony export loadSubmittalSuccess */
/* unused harmony export loadSubmittalRequest */
/* unused harmony export setSubmittalForm */
/* harmony export (immutable) */ __webpack_exports__["u"] = setSubmittalFormErrors;
/* unused harmony export updateSubmittalSuccess */
/* harmony export (immutable) */ __webpack_exports__["C"] = updateSubmittal;
/* harmony export (immutable) */ __webpack_exports__["F"] = updateSubmittalLeadTime;
/* harmony export (immutable) */ __webpack_exports__["q"] = respondSubmittal;
/* unused harmony export respondSubmittalAddlAssigneeSuccess */
/* harmony export (immutable) */ __webpack_exports__["r"] = respondSubmittalAddlAssignee;
/* unused harmony export setSubmittalNotes */
/* harmony export (immutable) */ __webpack_exports__["b"] = clearSubmittalNotes;
/* harmony export (immutable) */ __webpack_exports__["l"] = loadSubmittalNotes;
/* harmony export (immutable) */ __webpack_exports__["o"] = markSubmittalNotesRead;
/* unused harmony export addSubmittalNote */
/* harmony export (immutable) */ __webpack_exports__["d"] = createSubmittalNote;
/* unused harmony export userLabelStr */
/* unused harmony export setCurrentSubmittal */
/* harmony export (immutable) */ __webpack_exports__["p"] = openSubmittal;
/* harmony export (immutable) */ __webpack_exports__["x"] = setSubmittalLogPdfViewer;
/* unused harmony export loadSubmittalLogPdfSuccess */
/* harmony export (immutable) */ __webpack_exports__["k"] = loadSubmittalLogPdfRequest;
/* harmony export (immutable) */ __webpack_exports__["j"] = loadSubmittalLeadTimeLogPdfRequest;
/* harmony export (immutable) */ __webpack_exports__["z"] = setSubmittalPdfViewer;
/* harmony export (immutable) */ __webpack_exports__["s"] = setSetShowSubmittalErrorMessage;
/* harmony export (immutable) */ __webpack_exports__["a"] = addSubmittalAddlAssignee;
/* harmony export (immutable) */ __webpack_exports__["D"] = updateSubmittalAddlAssignee;
/* harmony export (immutable) */ __webpack_exports__["f"] = deleteSubmittalAddlAssignee;
/* unused harmony export deleteSubmittalSuccess */
/* harmony export (immutable) */ __webpack_exports__["e"] = deleteSubmittal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_submittals_api__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_submittal_addl_assignees_api__ = __webpack_require__(2514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domain_submittal__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__ = __webpack_require__(627);
function initSubmittalLog(){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["o" /* SUBMITTAL_LOG_INIT */]};}function setSubmittalTabSelected(submittalTab){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["y" /* SUBMITTAL_TAB_SELECTED_SET */],payload:submittalTab};}function loadSubmittalsSuccess(submittalsData,page,status,dueDateFilter){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["d" /* SUBMITTALS_SET */],payload:Object.assign({},submittalsData,{currentPage:page,currentStatus:status,dueDateFilter:dueDateFilter})};}function loadSubmittalsRequest(projectId,page,status,dueDateFilter){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_submittals_api__["a" /* submittalsApi */].getSubmittals(projectId,page,status,null,dueDateFilter).then(function(response){if(response.ok){dispatch(loadSubmittalsSuccess(response,page,status,dueDateFilter));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setSubmittalModalShow(show){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["s" /* SUBMITTAL_MODAL_SHOW_SET */],payload:show};}function initSubmittalModal(){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["r" /* SUBMITTAL_MODAL_INIT */]};}function updateSubmittalFormValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["l" /* SUBMITTAL_FORM_VALUE_UPDATE */],payload:{attribute:attribute,value:value}};}function deleteSubmittalFile(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["i" /* SUBMITTAL_FILE_DELETE */],payload:{attribute:attribute,value:value}};}function createSubmittal(projectId,values,page,status){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_submittals_api__["a" /* submittalsApi */].createSubmittal(projectId,values).then(function(response){if(response.ok){dispatch(loadSubmittalsRequest(projectId,page,status));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setSubmittalReadOnly(readOnly){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["w" /* SUBMITTAL_READ_ONLY_SET */],payload:readOnly};}function setSubmittalLeadTimeReadOnly(leadTimeReadOnly){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["n" /* SUBMITTAL_LEAD_TIME_READ_ONLY_SET */],payload:leadTimeReadOnly};}function setSubmittalGcAcceleration(gcAcceleration){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["m" /* SUBMITTAL_GC_ACCELERATION_SET */],payload:gcAcceleration};}function setShowTransmittalPdf(showPdf){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["b" /* SHOW_TRANSMITTAL_PDF_SET */],payload:showPdf};}function setTransmittalPdf(pdf){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["A" /* TRANSMITTAL_PDF_SET */],payload:pdf};}function loadTransmittalPdf(projectId,submittalId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_submittals_api__["a" /* submittalsApi */].getTransmittalPdf(projectId,submittalId).then(function(response){if(response.ok){dispatch(setTransmittalPdf(response.transmittalPdf));dispatch(setShowTransmittalPdf(true));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadSubmittalSuccess(submittal){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["a" /* CURRENT_SUBMITTAL_SET */],payload:submittal};}function loadSubmittalRequest(projectId,submittalId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_submittals_api__["a" /* submittalsApi */].getSubmittal(projectId,submittalId).then(function(response){if(response.ok){dispatch(loadSubmittalSuccess(response.submittal));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setSubmittalForm(form){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["k" /* SUBMITTAL_FORM_SET */],payload:form};}function setSubmittalFormErrors(errors){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["j" /* SUBMITTAL_FORM_ERRORS_SET */],payload:errors};}function updateSubmittalSuccess(submittal){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["z" /* SUBMITTAL_UPDATE */],payload:submittal};}function updateSubmittal(projectId,submittalId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_submittals_api__["a" /* submittalsApi */].updateSubmittal(projectId,submittalId,values).then(function(response){if(response.ok){dispatch(updateSubmittalSuccess(response.submittal));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateSubmittalLeadTime(projectId,submittalId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_submittals_api__["a" /* submittalsApi */].updateSubmittalLeadTime(projectId,submittalId,values).then(function(response){if(response.ok){dispatch(updateSubmittalSuccess(response.submittal));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function respondSubmittal(projectId,submittalId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_submittals_api__["a" /* submittalsApi */].respondSubmittal(projectId,submittalId,values).then(function(response){if(response.ok){dispatch(updateSubmittalSuccess(response.submittal));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function respondSubmittalAddlAssigneeSuccess(submittalAddlAssignee){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["h" /* SUBMITTAL_ADDL_ASSIGNEE_RESPONSE */],payload:submittalAddlAssignee};}function respondSubmittalAddlAssignee(id,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_submittal_addl_assignees_api__["a" /* submittalAddlAssigneesApi */].updateSubmittalAddlAssignee(id,values).then(function(response){if(response.ok){dispatch(respondSubmittalAddlAssigneeSuccess(response.submittalAddlAssignee));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setSubmittalNotes(notes){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["u" /* SUBMITTAL_NOTES_SET */],payload:notes};}function clearSubmittalNotes(){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["u" /* SUBMITTAL_NOTES_SET */],payload:[]};}function loadSubmittalNotes(submittalId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_submittals_api__["a" /* submittalsApi */].getNotes(submittalId).then(function(response){if(response.ok){dispatch(setSubmittalNotes(response.notes));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function markSubmittalNotesRead(submittalId,form,userId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_submittals_api__["a" /* submittalsApi */].markNotesRead(submittalId).then(function(response){if(response.ok){var notesReadBy=form.notesReadBy.concat(userId.toString());dispatch(updateSubmittalFormValue('notesReadBy',notesReadBy));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function addSubmittalNote(note){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["t" /* SUBMITTAL_NOTES_ADD */],payload:note};}function createSubmittalNote(submittalId,content){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_submittals_api__["a" /* submittalsApi */].createNote(submittalId,content).then(function(response){if(response.ok){dispatch(addSubmittalNote(response.note));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function userLabelStr(user){var company=user.accountable;return user.first_name+' '+user.last_name+' - '+(company.name||company.company_name);}function setCurrentSubmittal(submittal){return function(dispatch){dispatch(setSubmittalForm(Object.assign({},submittal,{submittedBy:submittal.submitted_by,csiCodeId:submittal.csi_code.id,csiCodeLabel:submittal.csi_code.division+' - '+submittal.csi_code.label,contractorId:submittal.contractor_id||'',physicalCopies:(submittal.physical_copies||0).toString(),assignee:submittal.assignee?[submittal.assignee.id,userLabelStr(submittal.assignee)]:[],recipients:submittal.recipients.map(function(rcpt){return[rcpt.id,userLabelStr(rcpt)];}),requestedDate:submittal.requested_at,dueDate:submittal.due_date,extendedDueDate:submittal.extended_due_date,stampAction:submittal.stamp_action,notesReadBy:submittal.notes_read_by,leadTimeApplies:submittal.lead_time_applies,leadTimeWeeks:submittal.lead_time_weeks!==null?submittal.lead_time_weeks.toString():'',orderDate:submittal.order_date,vendorDelivery:submittal.vendor_delivery,fieldDelivery:submittal.field_delivery,leadTimeReminder:submittal.lead_time_reminder,reqImagesDelete:[],reqDocsDelete:[],resImagesDelete:[],resDocsDelete:[],addlAssignees:submittal.submittal_addl_assignees.map(function(addlAssignee){return{id:addlAssignee.id,assigneeId:addlAssignee.assignee_id,assigneeLabel:userLabelStr(addlAssignee.assignee),dueDate:addlAssignee.due_date,returnedAt:addlAssignee.returned_at,stampAction:addlAssignee.stamp_action,stampTitle:addlAssignee.stamp_title};}),errors:{}})));};}function openSubmittal(projectId,submittalId,user){return function(dispatch){dispatch(initSubmittalModal());dispatch(loadSubmittalRequest(projectId,submittalId)).then(function(response){if(response.ok){var submittal=response.submittal;var readOnly=__WEBPACK_IMPORTED_MODULE_3_domain_submittal__["a" /* Submittal */].readOnly(submittal,user);dispatch(setCurrentSubmittal(submittal));dispatch(setSubmittalReadOnly(readOnly));dispatch(setSubmittalLeadTimeReadOnly(true));dispatch(setSubmittalModalShow(true));}});};}function setSubmittalLogPdfViewer(pdfViewer){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["q" /* SUBMITTAL_LOG_PDF_VIEWER_SET */],payload:pdfViewer};}function loadSubmittalLogPdfSuccess(submittalLogPdf){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["p" /* SUBMITTAL_LOG_PDF_SET */],payload:submittalLogPdf};}function loadSubmittalLogPdfRequest(projectId,status){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_submittals_api__["a" /* submittalsApi */].getSubmittalLogPdf(projectId,status).then(function(response){if(response.ok){dispatch(loadSubmittalLogPdfSuccess(response.submittalLogPdf));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadSubmittalLeadTimeLogPdfRequest(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_submittals_api__["a" /* submittalsApi */].getSubmittalLeadTimeLogPdf(projectId).then(function(response){if(response.ok){dispatch(loadSubmittalLogPdfSuccess(response.submittalLeadTimeLogPdf));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setSubmittalPdfViewer(pdfViewer){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["v" /* SUBMITTAL_PDF_VIEWER_SET */],payload:pdfViewer};}function setSetShowSubmittalErrorMessage(showErrorMessage){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["x" /* SUBMITTAL_SHOW_ERROR_MESSAGE_SET */],payload:showErrorMessage};}function addSubmittalAddlAssignee(addlAssignee){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["e" /* SUBMITTAL_ADDL_ASSIGNEES_ADD */],payload:addlAssignee};}function updateSubmittalAddlAssignee(addlAssignee,index){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["g" /* SUBMITTAL_ADDL_ASSIGNEES_UPDATE */],payload:{addlAssignee:addlAssignee,index:index}};}function deleteSubmittalAddlAssignee(index){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["f" /* SUBMITTAL_ADDL_ASSIGNEES_DELETE */],payload:index};}function deleteSubmittalSuccess(submittalId){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_action_types__["c" /* SUBMITTALS_DELETE */],payload:submittalId};}function deleteSubmittal(projectId,submittalId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_submittals_api__["a" /* submittalsApi */].deleteSubmittal(projectId,submittalId).then(function(response){if(response.ok){dispatch(deleteSubmittalSuccess(submittalId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export showOpenItemsModalSuccess */
/* harmony export (immutable) */ __webpack_exports__["g"] = closeOpenItemsModal;
/* unused harmony export loadOpenItemsSuccess */
/* harmony export (immutable) */ __webpack_exports__["A"] = showOpenItemsModal;
/* harmony export (immutable) */ __webpack_exports__["o"] = loadOpenItems;
/* harmony export (immutable) */ __webpack_exports__["z"] = showOpenItemFormModal;
/* harmony export (immutable) */ __webpack_exports__["f"] = closeOpenItemFormModal;
/* harmony export (immutable) */ __webpack_exports__["v"] = setOpenItemFormAttr;
/* harmony export (immutable) */ __webpack_exports__["w"] = setOpenItemFormErrors;
/* harmony export (immutable) */ __webpack_exports__["d"] = clearOpenItemFormErrorAttr;
/* unused harmony export createOpenItemSuccess */
/* harmony export (immutable) */ __webpack_exports__["x"] = setOpenItemPdfViewer;
/* harmony export (immutable) */ __webpack_exports__["i"] = createProjectOpenItem;
/* harmony export (immutable) */ __webpack_exports__["u"] = setOpenItemForm;
/* harmony export (immutable) */ __webpack_exports__["r"] = resetOpenItemForm;
/* unused harmony export showOpenItemDetailsModal */
/* harmony export (immutable) */ __webpack_exports__["e"] = closeOpenItemDetailsModal;
/* harmony export (immutable) */ __webpack_exports__["k"] = editOpenItemDetailsModal;
/* harmony export (immutable) */ __webpack_exports__["a"] = cancelEditOpenItemDetailsModal;
/* harmony export (immutable) */ __webpack_exports__["s"] = respondOpenItemDetailsModal;
/* harmony export (immutable) */ __webpack_exports__["b"] = cancelRespondOpenItemDetailsModal;
/* unused harmony export loadOpenItemSuccess */
/* unused harmony export updateOpenItemSuccess */
/* harmony export (immutable) */ __webpack_exports__["m"] = loadOpenItem;
/* harmony export (immutable) */ __webpack_exports__["B"] = updateProjectOpenItem;
/* unused harmony export deleteOpenItemSuccess */
/* harmony export (immutable) */ __webpack_exports__["j"] = deleteProjectOpenItem;
/* unused harmony export openItemsCountSuccess */
/* harmony export (immutable) */ __webpack_exports__["q"] = openItemsCount;
/* harmony export (immutable) */ __webpack_exports__["l"] = initOpenItemsCount;
/* harmony export (immutable) */ __webpack_exports__["y"] = setOpenItemsCritical;
/* harmony export (immutable) */ __webpack_exports__["t"] = respondProjectOpenItem;
/* unused harmony export loadOpenItemNotesSuccess */
/* harmony export (immutable) */ __webpack_exports__["c"] = clearItemNotes;
/* harmony export (immutable) */ __webpack_exports__["n"] = loadOpenItemNotes;
/* unused harmony export updateOpenItemValue */
/* harmony export (immutable) */ __webpack_exports__["p"] = markOpenItemNotesRead;
/* unused harmony export createOpenItemNoteSuccess */
/* harmony export (immutable) */ __webpack_exports__["h"] = createOpenItemNote;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_project_open_items_api__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__ = __webpack_require__(629);
function showOpenItemsModalSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["f" /* OPEN_ITEMS_MODAL_SHOW */]};}function closeOpenItemsModal(){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["e" /* OPEN_ITEMS_MODAL_CLOSE */]};}function loadOpenItemsSuccess(openItems,page,critical,status,dueDateFilter){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["d" /* OPEN_ITEMS_LOAD_SUCCESS */],payload:Object.assign({},openItems,{currentPage:page,critical:critical,status:status,dueDateFilter:dueDateFilter})};}function showOpenItemsModal(projectId,page,critical){return function(dispatch){return dispatch(loadOpenItems(projectId,page,critical)).then(function(response){if(response.ok){dispatch(showOpenItemsModalSuccess());}return response;});};}function loadOpenItems(projectId,page,critical,status,dueDateFilter){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_open_items_api__["a" /* projectOpenItemsApi */].getProjectOpenItems(projectId,page,critical,status,dueDateFilter).then(function(response){if(response.ok){dispatch(loadOpenItemsSuccess(response,page,critical,status,dueDateFilter));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function showOpenItemFormModal(){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["s" /* OPEN_ITEM_FORM_MODAL_SHOW */]};}function closeOpenItemFormModal(){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["r" /* OPEN_ITEM_FORM_MODAL_CLOSE */]};}function setOpenItemFormAttr(attr,value){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["o" /* OPEN_ITEM_FORM_ATTR_SET */],payload:{attr:attr,value:value}};}function setOpenItemFormErrors(errors){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["q" /* OPEN_ITEM_FORM_ERRORS_SET */],payload:errors};}function clearOpenItemFormErrorAttr(attr){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["p" /* OPEN_ITEM_FORM_ERRORS_ATTR_CLEAR */],payload:attr};}function createOpenItemSuccess(openItem){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["g" /* OPEN_ITEM_CREATE_SUCCESS */],payload:openItem};}function setOpenItemPdfViewer(pdfViewer){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["z" /* OPEN_ITEM_PDF_VIEWER_SET */],payload:pdfViewer};}function createProjectOpenItem(projectId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_open_items_api__["a" /* projectOpenItemsApi */].createProjectOpenItem(projectId,values).then(function(response){if(response.ok){dispatch(createOpenItemSuccess(response.projectOpenItem));dispatch(closeOpenItemFormModal());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setOpenItemForm(form){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["u" /* OPEN_ITEM_FORM_SET */],payload:form};}function resetOpenItemForm(){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["t" /* OPEN_ITEM_FORM_RESET */]};}function showOpenItemDetailsModal(){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["n" /* OPEN_ITEM_DETAILS_MODAL_SHOW */]};}function closeOpenItemDetailsModal(){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["i" /* OPEN_ITEM_DETAILS_MODAL_CLOSE */]};}function editOpenItemDetailsModal(){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["j" /* OPEN_ITEM_DETAILS_MODAL_EDIT */]};}function cancelEditOpenItemDetailsModal(){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["k" /* OPEN_ITEM_DETAILS_MODAL_EDIT_CANCEL */]};}function respondOpenItemDetailsModal(){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["l" /* OPEN_ITEM_DETAILS_MODAL_RESPOND */]};}function cancelRespondOpenItemDetailsModal(){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["m" /* OPEN_ITEM_DETAILS_MODAL_RESPOND_CANCEL */]};}function loadOpenItemSuccess(openItem){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["v" /* OPEN_ITEM_LOAD_SUCCESS */],payload:openItem};}function updateOpenItemSuccess(openItem){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["A" /* OPEN_ITEM_UPDATE_SUCCESS */],payload:openItem};}function loadOpenItem(projectId,id){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_open_items_api__["a" /* projectOpenItemsApi */].getProjectOpenItem(projectId,id).then(function(response){if(response.ok){dispatch(loadOpenItemSuccess(response.projectOpenItem));dispatch(showOpenItemDetailsModal());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateProjectOpenItem(projectId,id,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_open_items_api__["a" /* projectOpenItemsApi */].updateProjectOpenItem(projectId,id,values).then(function(response){if(response.ok){dispatch(loadOpenItemSuccess(response.projectOpenItem));dispatch(updateOpenItemSuccess(response.projectOpenItem));dispatch(cancelEditOpenItemDetailsModal());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function deleteOpenItemSuccess(openItemId){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["h" /* OPEN_ITEM_DELETE_SUCCESS */],payload:openItemId};}function deleteProjectOpenItem(projectId,id){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_open_items_api__["a" /* projectOpenItemsApi */].deleteProjectOpenItem(projectId,id).then(function(response){if(response.ok){dispatch(deleteOpenItemSuccess(id));dispatch(closeOpenItemDetailsModal());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function openItemsCountSuccess(total,totalCritical){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["b" /* OPEN_ITEMS_COUNT_SUCCESS */],payload:{total:total,totalCritical:totalCritical}};}function openItemsCount(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_open_items_api__["a" /* projectOpenItemsApi */].getProjectOpenItemsCount(projectId).then(function(response){if(response.ok){dispatch(openItemsCountSuccess(response.total,response.totalCritical));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function initOpenItemsCount(){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["a" /* OPEN_ITEMS_COUNT_INIT */]};}function setOpenItemsCritical(critical){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["c" /* OPEN_ITEMS_CRITICAL_SET */],payload:critical};}function respondProjectOpenItem(projectId,id,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_open_items_api__["a" /* projectOpenItemsApi */].respondProjectOpenItem(projectId,id,values).then(function(response){if(response.ok){dispatch(loadOpenItemSuccess(response.projectOpenItem));dispatch(updateOpenItemSuccess(response.projectOpenItem));dispatch(cancelRespondOpenItemDetailsModal());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadOpenItemNotesSuccess(openItemNotes){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["w" /* OPEN_ITEM_NOTES_LOAD_SUCCESS */],payload:openItemNotes};}function clearItemNotes(){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["x" /* OPEN_ITEM_NOTE_CLEAR */]};}function loadOpenItemNotes(id){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_open_items_api__["a" /* projectOpenItemsApi */].getProjectOpenItemNotes(id).then(function(response){if(response.ok){dispatch(loadOpenItemNotesSuccess(response.projectOpenItemNotes));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateOpenItemValue(attr,value){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["B" /* OPEN_ITEM_UPDATE_VALUE */],payload:{attr:attr,value:value}};}function markOpenItemNotesRead(openItem,userId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_open_items_api__["a" /* projectOpenItemsApi */].markProjectOpenItemNotesRead(openItem.id).then(function(response){if(response.ok){var notesReadBy=openItem.notes_read_by.concat(''+userId);dispatch(updateOpenItemValue('notes_read_by',notesReadBy));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function createOpenItemNoteSuccess(openItemNote){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_open_items_store_action_types__["y" /* OPEN_ITEM_NOTE_CREATE_SUCCESS */],payload:openItemNote};}function createOpenItemNote(id,content){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_open_items_api__["a" /* projectOpenItemsApi */].createProjectOpenItemNote(id,content).then(function(response){if(response.ok){dispatch(createOpenItemNoteSuccess(response.projectOpenItemNote));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MultipleDropdown_css__ = __webpack_require__(2531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MultipleDropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MultipleDropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_OutsideAlerter__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MultipleDropdown=function(_Component){_inherits(MultipleDropdown,_Component);function MultipleDropdown(props){_classCallCheck(this,MultipleDropdown);var _this=_possibleConstructorReturn(this,(MultipleDropdown.__proto__||Object.getPrototypeOf(MultipleDropdown)).call(this,props));_this.renderOptionsPopup=function(){var _this$props=_this.props,options=_this$props.options,currentValues=_this$props.currentValues,onChange=_this$props.onChange;var filteredOptions=_this.state.filteredOptions;return(filteredOptions||options).map(function(opt){var selected=!!currentValues.find(function(val){return val[0]===opt.id;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{key:opt.id,type:'button',className:'button-option'+(selected?' selected':''),onClick:function onClick(){if(!selected){onChange(currentValues.concat([[opt.id,opt.label]]));}else{onChange(currentValues.filter(function(val){return val[0]!==opt.id;}));}}},opt.label);});};_this.handleToggleOptions=function(){_this.setState({showOptions:!_this.state.showOptions});};_this.renderLabel=function(value){if(value[1]){return value[1];}else{var options=_this.props.options;var selectedOption=options.find(function(opt){return opt.id===value[0];});return selectedOption&&selectedOption.label;}};_this.selectedLabels=function(){var currentValues=_this.props.currentValues;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label-preview-container'},currentValues.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'remove',onClick:function onClick(){return _this.removeSelection(value);}},'X'),_this.renderLabel(value));}));};_this.removeSelection=function(value){var _this$props2=_this.props,onChange=_this$props2.onChange,currentValues=_this$props2.currentValues;var newValues=currentValues.filter(function(val){return val[0]!==value[0];});onChange(newValues);};_this.allowSearching=function(){var options=_this.props.options;return options.every(function(opt){return typeof opt.label==='string';});};_this.handleSearchChange=function(value){var options=_this.props.options;var filter=new RegExp(value.toLowerCase(),'g');var newFilteredOptions=[].concat(_toConsumableArray(options.filter(function(opt){return filter.test(opt.label.toLowerCase());})));_this.setState({filteredOptions:newFilteredOptions,search:value});};_this.state={showOptions:false,filteredOptions:null,search:''};return _this;}_createClass(MultipleDropdown,[{key:'render',value:function render(){var _props=this.props,options=_props.options,placeholder=_props.placeholder,className=_props.className,dropdownClassName=_props.dropdownClassName,currentValues=_props.currentValues;var _state=this.state,showOptions=_state.showOptions,search=_state.search,filteredOptions=_state.filteredOptions;var allowSearching=this.allowSearching();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multiple-dropdown'+(className?' '+className:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:dropdownClassName?dropdownClassName:'dropdown-control',onClick:this.handleToggleOptions},currentValues.length>0?this.selectedLabels():placeholder||'Select options'),showOptions&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_OutsideAlerter__["a" /* default */],{onClickOutside:this.handleToggleOptions},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'options'},allowSearching&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__["a" /* default */],{placeholder:'Search...',value:search,onChange:this.handleSearchChange}),(filteredOptions||options).length>0?this.renderOptionsPopup():__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no-options'},'No results found'))));}}]);return MultipleDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MultipleDropdown.propTypes={options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element])})).isRequired,currentValues:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (MultipleDropdown);

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 135 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 136 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(98);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__ = __webpack_require__(75);








var propTypes = {
  href: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  tabIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * this is sort of silly but needed for Button
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'a'
};

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
 */


var SafeAnchor =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = SafeAnchor.prototype;

  _proto.handleClick = function handleClick(event) {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        href = _this$props.href,
        onClick = _this$props.onClick;

    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      this.handleClick(event);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        Component = _this$props2.componentClass,
        disabled = _this$props2.disabled,
        onKeyDown = _this$props2.onKeyDown,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["componentClass", "disabled", "onKeyDown"]);

    if (isTrivialHref(props.href)) {
      props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
      // otherwise, the cursor incorrectly styled (except with role='button')

      props.href = props.href || '#';
    }

    if (disabled) {
      props.tabIndex = -1;
      props.style = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
        pointerEvents: 'none'
      }, props.style);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      onClick: this.handleClick,
      onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__["a" /* default */])(this.handleKeyDown, onKeyDown)
    }));
  };

  return SafeAnchor;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

SafeAnchor.propTypes = propTypes;
SafeAnchor.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (SafeAnchor);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return contractorInvoicesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getContractors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCurrentContractor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getInvalidFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getServiceAreas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getSelectedServiceAreasId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getSelectedTradesId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getSelectedUnionsId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getW9Document; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getShowContactsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getTrades; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getUnions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getValidationMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getWorkOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getProjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getMsaSigningUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getShowMsaSigningModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getContractorsCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getContractorsTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getContractorsPageSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getShowInviteContractorUserModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var contractorInvoicesSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.data.contractorInvoices;},function(contractorInvoices){return contractorInvoices;});var getContractors=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.data.contractors;},function(contractors){return contractors;});var getCurrentContractor=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.data.currentContractor;},function(currentContractor){return currentContractor;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.ui.currentPage;},function(currentPage){return currentPage;});var getForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.ui.form;},function(form){return form;});var getInvalidFields=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.ui.invalidFields;},function(invalidFields){return invalidFields;});var getServiceAreas=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.data.serviceAreas;},function(serviceAreas){return serviceAreas;});var getSelectedServiceAreasId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.ui.selectedServiceAreasId;},function(selectedServiceAreasId){return selectedServiceAreasId;});var getSelectedTradesId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.ui.selectedTradesId;},function(selectedTradesId){return selectedTradesId;});var getSelectedUnionsId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.ui.selectedUnionsId;},function(selectedUnionsId){return selectedUnionsId;});var getW9Document=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.ui.w9Document;},function(w9Document){return w9Document;});var getShowContactsModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.ui.showContacts;},function(showContacts){return showContacts;});var getTrades=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.data.trades;},function(trades){return trades;});var getUnions=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.data.unions;},function(unions){return unions;});var getValidationMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.ui.validationMessage;},function(validationMessage){return validationMessage;});var getUsers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.data.users;},function(users){return users;});var getWorkOrders=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.data.workOrders;},function(workOrders){return workOrders;});var getProjects=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.data.projects;},function(projects){return projects;});var getMsaSigningUrl=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.ui.msaSigningUrl;},function(msaSigningUrl){return msaSigningUrl;});var getShowMsaSigningModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.ui.showMsaSigningModal;},function(showMsaSigningModal){return showMsaSigningModal;});var getContractorsCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.ui.contractorsCurrentPage;},function(contractorsCurrentPage){return contractorsCurrentPage;});var getContractorsTotal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.ui.contractorsTotal;},function(contractorsTotal){return contractorsTotal;});var getContractorsPageSize=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.ui.contractorsPageSize;},function(contractorsPageSize){return contractorsPageSize;});var getRoles=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.data.roles;},function(roles){return roles;});var getShowInviteContractorUserModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractors.ui.showInviteContractorUserModal;},function(showInviteContractorUserModal){return showInviteContractorUserModal;});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tasksApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TasksApi=function(_BaseApi){_inherits(TasksApi,_BaseApi);function TasksApi(){_classCallCheck(this,TasksApi);return _possibleConstructorReturn(this,(TasksApi.__proto__||Object.getPrototypeOf(TasksApi)).apply(this,arguments));}_createClass(TasksApi,[{key:'getFormData',value:function getFormData(formData,data,previousKey){var _this2=this;if(data instanceof Object){Object.keys(data).forEach(function(key){var value=data[key];if(value instanceof Object&&!Array.isArray(value)){return _this2.getFormData(formData,value,key);}if(previousKey){key=previousKey+'['+key+']';}if(Array.isArray(value)){value.forEach(function(val){formData.append(key+'[]',val);});}else{formData.append(key,value);}});}}},{key:'createTask',value:function createTask(task,workOrderId){var preTask=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var taskData=new FormData();taskData.append('task[work_order_id]',workOrderId.toString());taskData.append('task[sub_trade_id]',task.subTrade.toString());taskData.append('task[completion_date]',task.completionDate);taskData.append('task[floor]',task.floorNumber);taskData.append('task[room]',task.room);taskData.append('task[name]',task.name);taskData.append('task[description]',task.description);task.images.forEach(function(image){taskData.append('task[images_attributes][][image]',image.file.original,image.file.original.name);});var path=preTask?'/tasks/create_pre':'/tasks';if(preTask){taskData.append('contractor_id',task.contractor?task.contractor.value:'');}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+path,taskData,{headers:{'Content-Type':'multipart/form-data'}}).then(function(response){return{ok:true,newTask:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateTask',value:function updateTask(task){var taskData=new FormData();taskData.append('task[sub_trade_id]',task.subTrade.toString());taskData.append('task[completion_date]',task.completionDate);taskData.append('task[floor]',task.floorNumber);taskData.append('task[room]',task.room);taskData.append('task[name]',task.name);taskData.append('task[description]',task.description);task.images.filter(function(image){return image.id===0;})// Only send new images
.forEach(function(image){taskData.append('task[images_attributes][][image]',image.file.original,image.file.original.name);});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/tasks/'+task.id,taskData,{headers:{'Content-Type':'multipart/form-data'}}).then(function(response){return{ok:true,task:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateTaskSchedule',value:function updateTaskSchedule(taskId,start,end){var taskData=new FormData();taskData.append('task[schedule_start_date]',start);taskData.append('task[schedule_end_date]',end);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/tasks/'+taskId,taskData,{headers:{'Content-Type':'multipart/form-data'}}).then(function(response){return{ok:true,task:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'removeTask',value:function removeTask(id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/tasks/'+id).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getTask',value:function getTask(taskId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/tasks/'+taskId).then(function(response){return{ok:true,task:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getTasks',value:function getTasks(page,contractorId,tradeId,critical,taskStatusEnum){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/tasks?page='+(page!==undefined?page:1)+(contractorId!==undefined?'&by_contractor='+contractorId:'')+(tradeId!==undefined?'&by_trade='+tradeId:'')+(critical!==undefined?'&critical=true':'')+(taskStatusEnum!==undefined?'&'+taskStatusEnum.status+'=true':'')).then(function(response){return{ok:true,tasks:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['total']).value(),totalCritical:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['total-critical']).value(),totalPlm:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['total-plm']).value(),totalAgg:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['total-agg']).value(),totalCmp:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['total-cmp']).value(),totalCls:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['total-cls']).value(),totalDraft:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['total-draft']).value(),totalPre:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['total-pre']).value(),totalRfp:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['total-rfp']).value(),totalWip:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['total-wip']).value(),totalWoa:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['total-woa']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'addQuoteRequest',value:function addQuoteRequest(taskId,contractorsIds,bidDueDate){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/tasks/'+taskId+'/quotes',{task:{bid_due_date:bidDueDate,contractor_ids:contractorsIds}}).then(function(response){return{ok:true,task:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'start',value:function start(taskId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/tasks/'+taskId+'/start').then(function(response){return{ok:true,task:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'complete',value:function complete(taskId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/tasks/'+taskId+'/complete').then(function(response){return{ok:true,task:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'removeImage',value:function removeImage(taskId,imageId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/tasks/'+taskId,{task:{images_attributes:[{id:imageId,_destroy:true}]}}).then(function(response){return{ok:true,task:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'addNote',value:function addNote(taskId,content){var headers={headers:{'Content-Type':'multipart/form-data'}};var apiPayload=new FormData();apiPayload.append('note[content]',content.content);var index=0;if(content.images&&content.images.length>0){content.images.filter(function(image){return!image.id;}).forEach(function(image){apiPayload.append('note[images_attributes]['+index+'][image]',image.file,image.file.name);index++;});}index=0;if(content.documents&&content.documents.length>0){content.documents.filter(function(doc){return!doc.id;}).forEach(function(doc){apiPayload.append('note[documents_attributes]['+index+'][document]',doc.file,doc.file.name);index++;});}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/tasks/'+taskId+'/notes',apiPayload,headers).then(function(response){return{ok:true,note:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getNotes',value:function getNotes(taskId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/tasks/'+taskId+'/notes').then(function(response){return{ok:true,notes:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'addOpenItem',value:function addOpenItem(taskId,userId,description,critical,dueDate){var data={open_item:{description:description,due_date:dueDate,user_id:userId,critical:critical}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/tasks/'+taskId+'/open_items',data).then(function(response){return{ok:true,openItem:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateOpenItem',value:function updateOpenItem(taskId,openItemId,editForm){var data={open_item:{user_id:editForm.userId,description:editForm.description,due_date:editForm.dueDate,resolved:editForm.resolved,resolved_note:editForm.resolvedNote}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/tasks/'+taskId+'/open_items/'+openItemId,data).then(function(response){return{ok:true,openItem:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getMembers',value:function getMembers(taskId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/tasks/'+taskId+'/work_order_users').then(function(response){return{ok:true,members:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'approveWork',value:function approveWork(taskId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/tasks/'+taskId+'/approve_completion').then(function(response){return{ok:true,task:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createReceipt',value:function createReceipt(taskId,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var apiPayload=new FormData();apiPayload.append('receipt[cost]',values.cost);apiPayload.append('receipt[description]',values.description);if(values.image){apiPayload.append('receipt[image_attributes][image]',values.image);}if(values.document){apiPayload.append('receipt[document_attributes][document]',values.document);}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/tasks/'+taskId+'/receipts',apiPayload,headers).then(function(response){return{ok:true,receipt:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createTimeEntry',value:function createTimeEntry(taskId,values){var apiPayload={time_entry:{name_title:values.name,start_date:values.startDate,time_in:values.timeIn,time_out:values.timeOut}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/tasks/'+taskId+'/time_entries',apiPayload).then(function(response){return{ok:true,timeEntry:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createVendorInvoices',value:function createVendorInvoices(taskId,values){var apiPayload=new FormData();apiPayload.append('vendor_invoice[vendor_name]',values.vendorName);apiPayload.append('vendor_invoice[due_date]',values.dueDate);apiPayload.append('vendor_invoice[cost]',values.cost);apiPayload.append('vendor_invoice[document_attributes][document]',values.document);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/tasks/'+taskId+'/vendor_invoices',apiPayload).then(function(response){return{ok:true,invoice:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return TasksApi;}(__WEBPACK_IMPORTED_MODULE_2_services_api_base_api__["a" /* default */]);var tasksApi=new TasksApi();/* harmony default export */ __webpack_exports__["a"] = (TasksApi=new TasksApi());

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfirmationPanel_css__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfirmationPanel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ConfirmationPanel_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConfirmationPanel=function(_Component){_inherits(ConfirmationPanel,_Component);function ConfirmationPanel(){_classCallCheck(this,ConfirmationPanel);return _possibleConstructorReturn(this,(ConfirmationPanel.__proto__||Object.getPrototypeOf(ConfirmationPanel)).apply(this,arguments));}_createClass(ConfirmationPanel,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-panel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.className!==undefined?this.props.className:null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.image,alt:'confirmation-panel-img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'first-line-container'},this.props.firstLine),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lines-container'},this.props.lines.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},element);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},this.props.buttons.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:index},element);}))));}}]);return ConfirmationPanel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConfirmationPanel.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,image:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,firstLine:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,lines:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,buttons:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired};/* harmony default export */ __webpack_exports__["a"] = (ConfirmationPanel);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dropdown_css__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select_dist_react_select_css__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_polyfill__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select_async_paginate__ = __webpack_require__(1865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select_async_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_select_async_paginate__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchableDropDownPaginated=function(_Component){_inherits(SearchableDropDownPaginated,_Component);function SearchableDropDownPaginated(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,SearchableDropDownPaginated);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SearchableDropDownPaginated.__proto__||Object.getPrototypeOf(SearchableDropDownPaginated)).call.apply(_ref,[this].concat(args))),_this),_this.loadOptions=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(input,loadedOptions){var loadedOptionsCount,page,_ref3,options,hasMore;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:loadedOptionsCount=loadedOptions.length;if(_this.props.withCreate){loadedOptionsCount-=1;}page=Math.ceil(loadedOptionsCount/_this.props.pageSize)+1;_context.next=5;return _this.props.loadOptions(input,page);case 5:_ref3=_context.sent;options=_ref3.options;hasMore=_ref3.hasMore;return _context.abrupt('return',{options:options,hasMore:hasMore});case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x,_x2){return _ref2.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SearchableDropDownPaginated,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'searchable-dropdown'+(this.props.className!==undefined?' '+this.props.className:'')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select_async_paginate___default.a,{arrowRenderer:this.props.arrowRenderer,clearable:this.props.clearable,placeholder:this.props.placeholder,value:this.props.value,loadOptions:this.loadOptions,onChange:this.props.onChange}));}}]);return SearchableDropDownPaginated;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);SearchableDropDownPaginated.propTypes={arrowRenderer:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,clearable:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,withCreate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,loadOptions:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,// Return promise (Object with "ok", "options" or "errors", function receives the input from the drop down, should return array of [value, label]
placeholder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,pageSize:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,onChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};SearchableDropDownPaginated.defaultProps={arrowRenderer:null,clearable:false,withCreate:false,pageSize:25,onChange:function onChange(){}};/* harmony default export */ __webpack_exports__["a"] = (SearchableDropDownPaginated);

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(43);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getChangeOrderTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getShowChangeOrderTaskModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getChangeOrderTasks=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrderTasks.data.changeOrderTasks;},function(changeOrderTasks){return changeOrderTasks;});var getShowChangeOrderTaskModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrderTasks.ui.showChangeOrderTaskModal;},function(showChangeOrderTaskModal){return showChangeOrderTaskModal;});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export baseRoutePath */
/* unused harmony export signEasyBasePath */
/* unused harmony export changePage */
/* harmony export (immutable) */ __webpack_exports__["b"] = editContractor;
/* harmony export (immutable) */ __webpack_exports__["c"] = getContractorInvoices;
/* harmony export (immutable) */ __webpack_exports__["d"] = goToContractor;
/* harmony export (immutable) */ __webpack_exports__["e"] = goToContractors;
/* unused harmony export loadContractorSuccess */
/* harmony export (immutable) */ __webpack_exports__["h"] = loadContractorsRequest;
/* unused harmony export loadContractorsSuccess */
/* unused harmony export setContractorsPaginationData */
/* harmony export (immutable) */ __webpack_exports__["g"] = loadContractorRequest;
/* harmony export (immutable) */ __webpack_exports__["i"] = loadNewContractorParametersRequest;
/* unused harmony export loadNewContractorParametersSuccess */
/* harmony export (immutable) */ __webpack_exports__["l"] = loadWorkOrdersRequest;
/* harmony export (immutable) */ __webpack_exports__["j"] = loadProjectsRequest;
/* unused harmony export loadWorkOrdersSuccess */
/* unused harmony export loadProjectsSuccess */
/* harmony export (immutable) */ __webpack_exports__["m"] = newContractor;
/* unused harmony export clearContractorData */
/* harmony export (immutable) */ __webpack_exports__["n"] = selectServiceArea;
/* harmony export (immutable) */ __webpack_exports__["o"] = selectTrade;
/* harmony export (immutable) */ __webpack_exports__["p"] = selectUnion;
/* harmony export (immutable) */ __webpack_exports__["r"] = setW9Document;
/* harmony export (immutable) */ __webpack_exports__["v"] = submitFormRequest;
/* unused harmony export invalidForm */
/* harmony export (immutable) */ __webpack_exports__["s"] = showContactsModal;
/* harmony export (immutable) */ __webpack_exports__["t"] = showContactsRequest;
/* unused harmony export validForm */
/* harmony export (immutable) */ __webpack_exports__["x"] = updateFormFromCurrentContractor;
/* harmony export (immutable) */ __webpack_exports__["y"] = updateFormValue;
/* unused harmony export setMsaSigningUrl */
/* harmony export (immutable) */ __webpack_exports__["f"] = hideMsaSigningModal;
/* harmony export (immutable) */ __webpack_exports__["u"] = showSignMsaModal;
/* harmony export (immutable) */ __webpack_exports__["k"] = loadRolesRequest;
/* unused harmony export loadRolesSuccess */
/* harmony export (immutable) */ __webpack_exports__["q"] = setShowInviteUserContractorModal;
/* harmony export (immutable) */ __webpack_exports__["w"] = submitInviteUserFormRequest;
/* unused harmony export addUser */
/* harmony export (immutable) */ __webpack_exports__["a"] = clearContractorForm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_contractors_api__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_trades_api__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_service_areas_api__ = __webpack_require__(2322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_union_api__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_team_contractor_team__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_pagination_table_store_actions__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_api_roles_api__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__ = __webpack_require__(9);
var baseRoutePath='/admin/contractors';var signEasyBasePath='dl.getsigneasy.com';function changePage(newPage){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["h" /* CONTRACTORS_CONTRACTOR_WORK_ORDERS_PAGE_CHANGE */],payload:newPage};}function editContractor(contractorId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(baseRoutePath+'/'+contractorId+'/edit'));};}function getContractorInvoices(contractorId){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_contractors_api__["a" /* contractorsApi */].getInvoices(contractorId,page).then(function(response){if(response.ok){dispatch(setContractorInvoices(response.contractorInvoices.content));dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_shared_pagination_table_store_actions__["b" /* setCurrentPage */])(page));dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_shared_pagination_table_store_actions__["d" /* setPaginationTotal */])(response.contractorInvoices.total));dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_shared_pagination_table_store_actions__["c" /* setPaginationPageSize */])(response.contractorInvoices.pageSize));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function goToContractor(contractorId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(baseRoutePath+'/'+contractorId));};}function goToContractors(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(''+baseRoutePath));};}function loadContractorSuccess(contractor){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["c" /* CONTRACTORS_CONTRACTOR_LOAD_SUCCESS */],payload:contractor};}function loadContractorsRequest(page,label){var tradesFilter=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_contractors_api__["a" /* contractorsApi */].getContractors([tradesFilter],[],page,label).then(function(response){if(response.ok){dispatch(loadContractorsSuccess(response.contractors));if(page){dispatch(setContractorsPaginationData(page,response.total,response.pageSize));}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadContractorsSuccess(contractors){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["l" /* CONTRACTORS_LOAD_SUCCESS */],payload:contractors};}function setContractorsPaginationData(page,total,pageSize){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["x" /* CONTRACTORS_SET_PAGINATION_DATA */],payload:{page:page,total:total,pageSize:pageSize}};}function loadContractorRequest(contractorId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_contractors_api__["a" /* contractorsApi */].getContractor(contractorId).then(function(response){if(response.ok){dispatch(loadContractorSuccess(response.contractor));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadNewContractorParametersRequest(serviceAreas,trades,unions){return function(dispatch){var promises=[];if(serviceAreas===undefined||serviceAreas.length===0){promises.push(__WEBPACK_IMPORTED_MODULE_3_services_api_service_areas_api__["a" /* serviceAreasApi */].getServiceAreas());}if(trades===undefined||trades.length===0){promises.push(__WEBPACK_IMPORTED_MODULE_2_services_api_trades_api__["b" /* tradesApi */].getTrades());}if(unions===undefined||unions.length===0){promises.push(__WEBPACK_IMPORTED_MODULE_4_services_api_union_api__["b" /* unionsApi */].getUnions());}if(promises.length===0){// All data already loaded
return Promise.resolve([]);}else{return Promise.all(promises).then(function(values){var result={};values.forEach(function(value){if(value.ok){checkParameterResultProperty(value,'serviceAreas',result);checkParameterResultProperty(value,'unions',result);checkParameterResultProperty(value,'trades',result);}});dispatch(loadNewContractorParametersSuccess(result));});}};}function checkParameterResultProperty(value,attribute,result){if(value.hasOwnProperty(attribute)){result[attribute]=value[attribute];}}function loadNewContractorParametersSuccess(result){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["s" /* CONTRACTORS_NEW_PARAMETERS_LOAD_SUCCESS */],payload:result};}function loadWorkOrdersRequest(contractorId,page,workOrderStatus,critical){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_contractors_api__["a" /* contractorsApi */].getWorkOrders(contractorId,page,workOrderStatus,critical).then(function(response){if(response.ok){dispatch(loadWorkOrdersSuccess(response.workOrders));dispatch(changePage(page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadProjectsRequest(contractorId,page,projectStatus){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_contractors_api__["a" /* contractorsApi */].getProjects(contractorId,page,projectStatus).then(function(response){if(response.ok){dispatch(loadProjectsSuccess(response.projects));dispatch(changePage(page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadWorkOrdersSuccess(workOrders){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["g" /* CONTRACTORS_CONTRACTOR_WORK_ORDERS_LOAD_SUCCESS */],payload:workOrders};}function loadProjectsSuccess(projects){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["d" /* CONTRACTORS_CONTRACTOR_PROJECTS_LOAD_SUCCESS */],payload:projects};}function newContractor(){return function(dispatch){dispatch(clearContractorData());dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(baseRoutePath+'/new'));};}function clearContractorData(){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["o" /* CONTRACTORS_NEW_CLEAR_DATA */]};}function selectServiceArea(value){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["t" /* CONTRACTORS_NEW_SERVICE_AREA_SELECT */],payload:value};}function selectTrade(value){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["u" /* CONTRACTORS_NEW_TRADE_SELECT */],payload:value};}function selectUnion(value,unions,selectedUnionsId){var newUnions=[];if(value==='all'){if(unions.length!==selectedUnionsId.length){// Select all (in the other case, just return an empty array)
newUnions=unions.map(function(element){return element.id;});}}else{if(selectedUnionsId.find(function(element){return element===value;})!==undefined){newUnions=selectedUnionsId.filter(function(element){return element!==value;});}else{newUnions=selectedUnionsId.concat(value);}}return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["v" /* CONTRACTORS_NEW_UNIONS_SELECT */],payload:newUnions};}function setW9Document(file){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["w" /* CONTRACTORS_NEW_W9_DOCUMENT_SET */],payload:file};}function setContractorInvoices(contractorInvoices){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["k" /* CONTRACTORS_INVOICES_SET */],payload:contractorInvoices};}function setContractorUsers(users){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["y" /* CONTRACTORS_USERS_SET */],payload:users};}/**
 *
 * @param form
 * @param selectedServiceAreasId
 * @param selectedTradesId
 * @param selectedUnionsId
 * @param sendInvitation
 * @param contractorId - Id of the contractor under edition. If undefined, the it's a new contractor.
 * @return {Function}
 */function submitFormRequest(form,selectedServiceAreasId,selectedTradesId,selectedUnionsId,w9Document,sendInvitation,contractorId,needsConfirmation){return function(dispatch){// Validate form
var requiredFields=['companyName','firstName','lastName','email','phoneNumber','streetAddress','city','state','zipCode'];if(form.confirmed){requiredFields.push('licenseNumber');}var invalidFields=[];requiredFields.forEach(function(attribute){if(form[attribute]===''){invalidFields.push(attribute);}});if(form.confirmed&&w9Document.document===''&&w9Document.url===''){invalidFields.push('w9Document');}if(invalidFields.length>0){dispatch(invalidForm(invalidFields,'The outlined inputs should be added in order to add a contractor.'));return null;}else{dispatch(validForm());var data={name:form.companyName,licenseNumber:form.licenseNumber,contact:{firstName:form.firstName,lastName:form.lastName,email:form.email,phoneNumber:form.phoneNumber},location:{streetAddress:form.streetAddress,unitNumber:form.unitNumber,city:form.city,state:form.state,zipCode:form.zipCode},tradesId:selectedTradesId,serviceAreasId:selectedServiceAreasId,unionsId:selectedUnionsId,w9Document:w9Document,confirmed:form.confirmed};var promise=void 0;if(contractorId!==undefined){promise=__WEBPACK_IMPORTED_MODULE_1_services_api_contractors_api__["a" /* contractorsApi */].updateContractor(contractorId,data,sendInvitation);}else{promise=__WEBPACK_IMPORTED_MODULE_1_services_api_contractors_api__["a" /* contractorsApi */].createContractor(data,sendInvitation);}return promise.then(function(response){if(response.ok){if(contractorId!==undefined){dispatch(loadContractorSuccess(response.contractor));if(needsConfirmation){dispatch(showSignMsaModal(contractorId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_team_contractor_team__["e" /* goToTeam */])());}}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});}};}function invalidForm(invalidFields,message){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["p" /* CONTRACTORS_NEW_FORM_INVALID */],payload:{invalidFields:invalidFields,message:message}};}function showContactsModal(value){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["a" /* CONTRACTORS_CONTACTS_MODAL_SHOW */],payload:value};}function showContactsRequest(contractorId,users){return function(dispatch){if(users.length>0){dispatch(showContactsModal(true));}else{return __WEBPACK_IMPORTED_MODULE_1_services_api_contractors_api__["a" /* contractorsApi */].getUsers(contractorId).then(function(response){if(response.ok){dispatch(setContractorUsers(response.users));dispatch(showContactsModal(true));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});}};}function validForm(){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["q" /* CONTRACTORS_NEW_FORM_VALID */]};}function updateFormFromCurrentContractor(currentContractor){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["i" /* CONTRACTORS_EDIT_FORM_LOAD_FROM_CURRENT */],payload:currentContractor};}function updateFormValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["r" /* CONTRACTORS_NEW_FORM_VALUE_CHANGE */],payload:{attribute:attribute,value:value}};}function setMsaSigningUrl(url){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["n" /* CONTRACTORS_MSA_SIGNING_URL_CHANGE */],payload:url};}function hideMsaSigningModal(){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["m" /* CONTRACTORS_MSA_SIGNING_MODAL_HIDE */]};}function showSignMsaModal(contractorId){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_api_contractors_api__["a" /* contractorsApi */].getMsaSigningUrl(contractorId,'').then(function(response){if(response.ok){var signingUrl=response.data.url.replace(signEasyBasePath,signEasyBasePath+'/#');dispatch(setMsaSigningUrl(signingUrl));}});};}function loadRolesRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_9_services_api_roles_api__["b" /* rolesApi */].getRoles(__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["f" /* TYPES */].CONTRACTOR).then(function(response){if(response.ok){dispatch(loadRolesSuccess(response.permissions));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadRolesSuccess(roles){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["e" /* CONTRACTORS_CONTRACTOR_ROLES_LOAD_SUCCESS */],payload:roles};}function setShowInviteUserContractorModal(value){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["b" /* CONTRACTORS_CONTRACTOR_INVITE_USER_SHOW */],payload:value};}function submitInviteUserFormRequest(form,contractorId,roles){return function(dispatch){var requiredFields=['firstName','lastName','email','phoneNumber','roleId'];var invalidFields=[];requiredFields.forEach(function(attribute){if(form[attribute]===''||form[attribute]===null){invalidFields.push(attribute);}});if(invalidFields.length>0){dispatch(invalidForm(invalidFields,'The outlined inputs should be added in order to invite a new user.'));return null;}else{var role=roles.find(function(role){return role.id===form.roleId;});form.title=__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["c" /* CONTRACTOR_ROLES */][role.name];dispatch(validForm());return __WEBPACK_IMPORTED_MODULE_1_services_api_contractors_api__["a" /* contractorsApi */].inviteUser(contractorId,form).then(function(response){if(response.ok){dispatch(addUser(response.user));dispatch(setShowInviteUserContractorModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});}};}function addUser(user){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["f" /* CONTRACTORS_CONTRACTOR_USER_ADD */],payload:user};}function clearContractorForm(){return{type:__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_action_types__["j" /* CONTRACTORS_INVITE_FORM_CLEAR */]};}

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export baseRoutePath */
/* harmony export (immutable) */ __webpack_exports__["a"] = addGeneralContractor;
/* harmony export (immutable) */ __webpack_exports__["o"] = showGeneralContractorDetails;
/* harmony export (immutable) */ __webpack_exports__["c"] = goToEditGeneralContractor;
/* harmony export (immutable) */ __webpack_exports__["d"] = loadGeneralContractorProjectsRequest;
/* unused harmony export loadGeneralContractorsProjectsSuccess */
/* unused harmony export projectsChangePage */
/* harmony export (immutable) */ __webpack_exports__["g"] = newOnboarding;
/* harmony export (immutable) */ __webpack_exports__["l"] = setStage;
/* harmony export (immutable) */ __webpack_exports__["h"] = nextStage;
/* harmony export (immutable) */ __webpack_exports__["k"] = setLicenceNumberValue;
/* harmony export (immutable) */ __webpack_exports__["i"] = setCompanyLogo;
/* unused harmony export loadGeneralContractorSuccess */
/* harmony export (immutable) */ __webpack_exports__["e"] = loadGeneralContractorRequest;
/* harmony export (immutable) */ __webpack_exports__["f"] = loadGeneralContractorsRequest;
/* unused harmony export loadGeneralContractorsSuccess */
/* unused harmony export changePage */
/* unused harmony export showList */
/* unused harmony export showDashboard */
/* unused harmony export showTeamPage */
/* harmony export (immutable) */ __webpack_exports__["p"] = showOnboarding;
/* unused harmony export showGeneralContractorPage */
/* harmony export (immutable) */ __webpack_exports__["b"] = createGeneralContractor;
/* harmony export (immutable) */ __webpack_exports__["q"] = submitOnboarding;
/* harmony export (immutable) */ __webpack_exports__["r"] = updateGeneralContractorTeam;
/* harmony export (immutable) */ __webpack_exports__["m"] = showContactsModal;
/* harmony export (immutable) */ __webpack_exports__["j"] = setGeneralContractorUsers;
/* harmony export (immutable) */ __webpack_exports__["n"] = showContactsRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_store_action_types__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_general_contractors_api__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(45);
var baseRoutePath='/admin/general-contractors';function addGeneralContractor(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])(baseRoutePath+'/new'));};}function showGeneralContractorDetails(id){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])(baseRoutePath+'/'+id));};}function goToEditGeneralContractor(generalContractorId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])(baseRoutePath+'/'+generalContractorId+'/edit'));};}function loadGeneralContractorProjectsRequest(generalContractorId,page,status){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_general_contractors_api__["a" /* generalContractorsApi */].getGeneralContractorProjects(generalContractorId,page,status).then(function(response){if(response.ok){dispatch(loadGeneralContractorsProjectsSuccess(response.projects));dispatch(projectsChangePage(page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadGeneralContractorsProjectsSuccess(projects){return{type:__WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_store_action_types__["h" /* GENERAL_CONTRACTOR_PROJECTS_LOAD_SUCCESS */],payload:projects};}function projectsChangePage(newPage){return{type:__WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_store_action_types__["i" /* GENERAL_CONTRACTOR_PROJECTS_PAGE_CHANGE */],payload:newPage};}function newOnboarding(){return{type:__WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_store_action_types__["k" /* NEW_ONBOARDING */]};}function setStage(value){return{payload:value,type:__WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_store_action_types__["g" /* GENERAL_CONTRACTOR_ONBOARDING_STAGE_CHANGE */]};}function nextStage(){return{type:__WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_store_action_types__["l" /* NEXT_STAGE */]};}function setLicenceNumberValue(value){return{type:__WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_store_action_types__["j" /* LICENCE_NUMBER_VALUE_CHANGE */],payload:value};}function setCompanyLogo(file){return{type:__WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_store_action_types__["a" /* COMPANY_LOGO_FILE_SET */],payload:file};}function loadGeneralContractorSuccess(generalContractor){return{type:__WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_store_action_types__["f" /* GENERAL_CONTRACTOR_LOAD_SUCCESS */],payload:generalContractor};}function loadGeneralContractorRequest(contractorId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_general_contractors_api__["a" /* generalContractorsApi */].getGeneralContractor(contractorId).then(function(response){if(response.ok){dispatch(loadGeneralContractorSuccess(response.generalContractor));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadGeneralContractorsRequest(page,status){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_general_contractors_api__["a" /* generalContractorsApi */].getGeneralContractors(page,status).then(function(response){if(response.ok){dispatch(loadGeneralContractorsSuccess(response.generalContractors));dispatch(changePage(page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadGeneralContractorsSuccess(generalContractors){return{type:__WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_store_action_types__["c" /* GENERAL_CONTRACTORS_LOAD_SUCCESS */],payload:generalContractors};}function changePage(newPage){return{type:__WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_store_action_types__["d" /* GENERAL_CONTRACTORS_PAGE_CHANGE */],payload:newPage};}function showList(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])(baseRoutePath));};}function showDashboard(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])('/admin/dashboard'));};}function showTeamPage(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])('/admin/team'));};}function showOnboarding(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])(baseRoutePath+'/onboarding'));};}function showGeneralContractorPage(generalContractorId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])('/admin/general-contractors/'+generalContractorId));};}function createGeneralContractor(values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_general_contractors_api__["a" /* generalContractorsApi */].createGeneralContractor(values).then(function(response){if(response.ok){dispatch(showList());// load general contractors list again
}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function submitOnboarding(onboardingData){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_general_contractors_api__["a" /* generalContractorsApi */].updateGeneralContractorOnboardingData(onboardingData).then(function(response){if(response.ok){dispatch(showDashboard());// load dashboard again
}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function updateGeneralContractorTeam(generalContractorData,teamEdit){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_general_contractors_api__["a" /* generalContractorsApi */].updateGeneralContractorTeam(generalContractorData).then(function(response){if(response.ok){if(teamEdit){dispatch(showTeamPage());// load team page again
}else{dispatch(showGeneralContractorPage(generalContractorData.id));}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function showContactsModal(value){return{type:__WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_store_action_types__["b" /* GENERAL_CONTRACTORS_CONTACTS_MODAL_SHOW */],payload:value};}function setGeneralContractorUsers(users){return{type:__WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_store_action_types__["e" /* GENERAL_CONTRACTORS_USERS_SET */],payload:users};}function showContactsRequest(contractorId,users){return function(dispatch){if(users.length>0){dispatch(showContactsModal(true));}else{return __WEBPACK_IMPORTED_MODULE_2_services_api_general_contractors_api__["a" /* generalContractorsApi */].getUsers(contractorId).then(function(response){if(response.ok){dispatch(setGeneralContractorUsers(response.users));dispatch(showContactsModal(true));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});}};}

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = initProjectEmailModal;
/* harmony export (immutable) */ __webpack_exports__["j"] = setShowEmailModal;
/* harmony export (immutable) */ __webpack_exports__["i"] = setShowCustomEmailError;
/* harmony export (immutable) */ __webpack_exports__["k"] = setShowNewCustomEmail;
/* harmony export (immutable) */ __webpack_exports__["f"] = setEmails;
/* harmony export (immutable) */ __webpack_exports__["a"] = addEmail;
/* harmony export (immutable) */ __webpack_exports__["b"] = addRecipient;
/* harmony export (immutable) */ __webpack_exports__["l"] = setSubject;
/* harmony export (immutable) */ __webpack_exports__["g"] = setMessage;
/* harmony export (immutable) */ __webpack_exports__["h"] = setRecipients;
/* harmony export (immutable) */ __webpack_exports__["e"] = setCustomEmail;
/* harmony export (immutable) */ __webpack_exports__["d"] = loadEmailHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_project_resource_mailer_api__ = __webpack_require__(621);
function initProjectEmailModal(payload){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["c" /* INIT_PROJECT_EMAIL_MODAL */],payload:payload};}function setShowEmailModal(value){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["j" /* SET_SHOW_EMAIL_MODAL */],payload:value};}function setShowCustomEmailError(value){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["i" /* SET_SHOW_CUSTOM_EMAIL_ERROR */],payload:value};}function setShowNewCustomEmail(value){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["k" /* SET_SHOW_NEW_CUSTOM_EMAIL */],payload:value};}function setEmails(emails){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["e" /* SET_EMAILS */],payload:emails};}function addEmail(emails){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["a" /* ADD_EMAIL */],payload:emails};}function addRecipient(recipient){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["b" /* ADD_RECIPIENT */],payload:recipient};}function setSubject(subject){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["l" /* SET_SUBJECT */],payload:subject};}function setMessage(message){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["g" /* SET_MESSAGE */],payload:message};}function setRecipients(recipients){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["h" /* SET_RECIPIENTS */],payload:recipients};}function setCustomEmail(email){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["d" /* SET_CUSTOM_EMAIL */],payload:email};}function loadEmailHistorySuccess(history){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["f" /* SET_EMAIL_HISTORY */],payload:history};}function loadEmailHistory(id,type){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_project_resource_mailer_api__["a" /* projectResourceMailerApi */].getEmailHistory(id,type).then(function(response){if(response.ok){dispatch(loadEmailHistorySuccess(response.data));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(48);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 150 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(474)('wks');
var uid = __webpack_require__(351);
var Symbol = __webpack_require__(171).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(739);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TaskStatusKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TaskStatusEnum; });
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var keys={};var TaskStatusKeys={DRAFT:'draft',RFP:'rfp',PLM:'plm',AGG:'agg',WOA:'woa',PRE:'pre',WIP:'wip',CMP:'cmp',CLS:'cls'};var TaskStatusEnum=function(){function TaskStatusEnum(status){_classCallCheck(this,TaskStatusEnum);this.status=status;keys[status]=this;}_createClass(TaskStatusEnum,[{key:'equals',value:function equals(value){if(typeof value==='string'){return this.status===value;}else if((typeof value==='undefined'?'undefined':_typeof(value))==='object'&&value.hasOwnProperty('status')){return this.status===value.status;}else{return false;}}}],[{key:'get',value:function get(status){if(keys[status]){return keys[status];}return null;}}]);return TaskStatusEnum;}();TaskStatusEnum.DRAFT=new TaskStatusEnum(TaskStatusKeys.DRAFT);TaskStatusEnum.RFP=new TaskStatusEnum(TaskStatusKeys.RFP);TaskStatusEnum.PLM=new TaskStatusEnum(TaskStatusKeys.PLM);TaskStatusEnum.AGG=new TaskStatusEnum(TaskStatusKeys.AGG);TaskStatusEnum.WOA=new TaskStatusEnum(TaskStatusKeys.WOA);TaskStatusEnum.PRE=new TaskStatusEnum(TaskStatusKeys.PRE);TaskStatusEnum.WIP=new TaskStatusEnum(TaskStatusKeys.WIP);TaskStatusEnum.CMP=new TaskStatusEnum(TaskStatusKeys.CMP);TaskStatusEnum.CLS=new TaskStatusEnum(TaskStatusKeys.CLS);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__responsivePropType__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breakpoints__ = __webpack_require__(514);




function getPath(obj, path) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  return path.split('.').reduce(function (acc, item) {
    return acc && acc[item] ? acc[item] : null;
  }, obj);
}

function style(options) {
  var prop = options.prop,
      _options$cssProperty = options.cssProperty,
      cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty,
      themeKey = options.themeKey,
      transform = options.transform;

  var fn = function fn(props) {
    if (props[prop] == null) {
      return null;
    }

    var propValue = props[prop];
    var theme = props.theme;
    var themeMapping = getPath(theme, themeKey) || {};

    var styleFromPropValue = function styleFromPropValue(propValueFinal) {
      var value;

      if (typeof themeMapping === 'function') {
        value = themeMapping(propValueFinal);
      } else if (Array.isArray(themeMapping)) {
        value = themeMapping[propValueFinal] || propValueFinal;
      } else {
        value = getPath(themeMapping, propValueFinal) || propValueFinal;

        if (transform) {
          value = transform(value);
        }
      }

      if (cssProperty === false) {
        return value;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, cssProperty, value);
    };

    return Object(__WEBPACK_IMPORTED_MODULE_2__breakpoints__["a" /* handleBreakpoints */])(props, propValue, styleFromPropValue);
  };

  fn.propTypes =  false ? _defineProperty({}, prop, responsivePropType) : {};
  fn.filterProps = [prop];
  return fn;
}

/* harmony default export */ __webpack_exports__["a"] = (style);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleText=function(_Component){_inherits(SimpleText,_Component);function SimpleText(){_classCallCheck(this,SimpleText);return _possibleConstructorReturn(this,(SimpleText.__proto__||Object.getPrototypeOf(SimpleText)).apply(this,arguments));}_createClass(SimpleText,[{key:'render',value:function render(){var _this2=this;return this.props.lines.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,style:_this2.props.style},element);});}}]);return SimpleText;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SimpleText.propTypes={lines:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,style:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};SimpleText.defaultProps={style:{}};/* harmony default export */ __webpack_exports__["a"] = (SimpleText);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseStatus_css__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseStatus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BaseStatus_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BaseStatus=function(_Component){_inherits(BaseStatus,_Component);function BaseStatus(){_classCallCheck(this,BaseStatus);return _possibleConstructorReturn(this,(BaseStatus.__proto__||Object.getPrototypeOf(BaseStatus)).apply(this,arguments));}_createClass(BaseStatus,[{key:'render',value:function render(){var _this2=this;var value=this.props.status;if(this.props.labels!==undefined&&this.props.labels.filter(function(element){return element.id===_this2.props.status;}).length>0){value=this.props.labels.find(function(element){return element.id===_this2.props.status;}).label;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'base-status'},value,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'base-status-color '+this.props.status}));}}]);return BaseStatus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BaseStatus.propTypes={labels:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),status:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (BaseStatus);

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(4);
var core = __webpack_require__(108);
var fails = __webpack_require__(43);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(137);
var IObject = __webpack_require__(290);
var toObject = __webpack_require__(71);
var toLength = __webpack_require__(55);
var asc = __webpack_require__(548);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return imageExtensions; });
/* harmony export (immutable) */ __webpack_exports__["b"] = validateFile;
var imageExtensions=['.jpg','.jpeg','.gif','.png'];function validateFile(name,extensions){var index=name.lastIndexOf('.');if(index===-1){// The file has no extension, so is not valid
alert('File "'+name+'" could not be uploaded because has no extension.');return false;}else if(extensions.length>0){var fileExtension=name.substring(index);if(extensions.find(function(element){return element.toLowerCase()===fileExtension.toLowerCase();})===undefined){alert('File "'+name+'" has an invalid extensions, should be one of ['+extensions.join(', ')+'].');return false;}}return true;}

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_round_empty_png__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_round_empty_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_images_round_empty_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_round_full_png__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_round_full_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_round_full_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_round_full_readonly_svg__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_round_full_readonly_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_round_full_readonly_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RadioButton_css__ = __webpack_require__(1913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RadioButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__RadioButton_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RadioButton=function(_Component){_inherits(RadioButton,_Component);function RadioButton(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RadioButton);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RadioButton.__proto__||Object.getPrototypeOf(RadioButton)).call.apply(_ref,[this].concat(args))),_this),_this.handleChange=function(event,value){event.preventDefault();if(_this.props.onChange&&!_this.props.readOnly){_this.props.onChange(value);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RadioButton,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'radio-button'+(this.props.className!==undefined?' '+this.props.className:'')},this.props.orientation==='table'?this.renderAsTable():this.renderSimple());}},{key:'renderAsTable',value:function renderAsTable(){var _this2=this;var rows=[];var row=[];this.props.options.forEach(function(element,index){if(index%2===0){row=[];row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},_this2.renderItemContent(element)));rows.push(row);}else{row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},_this2.renderItemContent(element)));}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'orientation-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,rows.map(function(row,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row[1]));})));}},{key:'renderSimple',value:function renderSimple(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.options.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'orientation-simple '+_this3.props.orientation},_this3.renderItemContent(element));}));}},{key:'renderItemContent',value:function renderItemContent(element){var _this4=this;var _props=this.props,emptyPng=_props.emptyPng,fullPng=_props.fullPng,fullPngReadOnly=_props.fullPngReadOnly,value=_props.value,readOnly=_props.readOnly;var emptyPngSelected=emptyPng||__WEBPACK_IMPORTED_MODULE_2_images_round_empty_png___default.a;var fullPngSelected=fullPng||__WEBPACK_IMPORTED_MODULE_3_images_round_full_png___default.a;var fullPngReadOnlySelected=fullPngReadOnly||__WEBPACK_IMPORTED_MODULE_4_images_round_full_readonly_svg___default.a;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:readOnly?'read-only':null,src:element.value===value?readOnly?fullPngReadOnlySelected:fullPngSelected:emptyPngSelected,alt:element.selected?'selected':'not-selected',onClick:function onClick(event){return _this4.handleChange(event,element.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element.label));}}]);return RadioButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RadioButton.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element])})).isRequired,emptyPng:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,fullPng:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,fullPngReadOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,orientation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['horizontal','vertical','table']),readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};RadioButton.defaultProps={emptyPng:null,fullPng:null,fullPngReadOnly:null,orientation:'horizontal',readOnly:false};/* harmony default export */ __webpack_exports__["a"] = (RadioButton);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailsHeader_css__ = __webpack_require__(2288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailsHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DetailsHeader_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsHeader=function(_Component){_inherits(DetailsHeader,_Component);function DetailsHeader(){_classCallCheck(this,DetailsHeader);return _possibleConstructorReturn(this,(DetailsHeader.__proto__||Object.getPrototypeOf(DetailsHeader)).apply(this,arguments));}_createClass(DetailsHeader,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left-title'},this.props.leftHeader.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h1'},this.props.leftHeader.value),this.props.leftHeaderExtraComponents!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left-header-extra'},this.props.leftHeaderExtraComponents)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:6,className:'right-container'},this.props.rightHeaders.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'right-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,item.map(function(header,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,header.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h3'},header.value));})));}))));}}]);return DetailsHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DetailsHeader.propTypes={leftHeader:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}).isRequired,leftHeaderExtraComponents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,rightHeaders:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any}).isRequired))};/* harmony default export */ __webpack_exports__["a"] = (DetailsHeader);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export baseRoutePath */
/* harmony export (immutable) */ __webpack_exports__["a"] = addProject;
/* harmony export (immutable) */ __webpack_exports__["i"] = loadProjectsRequest;
/* harmony export (immutable) */ __webpack_exports__["h"] = loadMissingDrsRequest;
/* harmony export (immutable) */ __webpack_exports__["g"] = loadBidsDueRequest;
/* unused harmony export loadProjectsSuccess */
/* unused harmony export loadMissingDrsSuccess */
/* unused harmony export loadBidsDueSuccess */
/* unused harmony export changePage */
/* unused harmony export changeMissingDrsPage */
/* unused harmony export changeBidsDuePage */
/* harmony export (immutable) */ __webpack_exports__["c"] = changeNav;
/* unused harmony export goToProjects */
/* harmony export (immutable) */ __webpack_exports__["f"] = goToProjectDetails;
/* harmony export (immutable) */ __webpack_exports__["e"] = goToEditProject;
/* unused harmony export missingDrsCountSuccess */
/* harmony export (immutable) */ __webpack_exports__["j"] = missingDrsCount;
/* unused harmony export bidsDueCountSuccess */
/* harmony export (immutable) */ __webpack_exports__["b"] = bidsDueCount;
/* harmony export (immutable) */ __webpack_exports__["d"] = dailyReportsReminder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_projects_store_action_types__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_projects_api__ = __webpack_require__(426);
var baseRoutePath='/admin/projects';function addProject(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(baseRoutePath+'/new-project'));};}function loadProjectsRequest(filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_projects_api__["a" /* projectsApi */].getProjects(filters).then(function(response){if(response.ok){dispatch(loadProjectsSuccess(response.projects));dispatch(changePage(filters.page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadMissingDrsRequest(filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_projects_api__["a" /* projectsApi */].getProjects(filters).then(function(response){if(response.ok){dispatch(loadMissingDrsSuccess(response.projects));dispatch(changeMissingDrsPage(filters.page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadBidsDueRequest(filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_projects_api__["a" /* projectsApi */].getProjects(filters).then(function(response){if(response.ok){dispatch(loadBidsDueSuccess(response.projects));dispatch(changeBidsDuePage(filters.page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadProjectsSuccess(projects){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_store_action_types__["d" /* PROJECTS_LOAD_SUCCESS */],payload:projects};}function loadMissingDrsSuccess(projects){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_store_action_types__["f" /* PROJECTS_MISSING_DRS_LOAD_SUCCESS */],payload:projects};}function loadBidsDueSuccess(projects){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_store_action_types__["b" /* PROJECTS_BIDS_DUE_LOAD_SUCCESS */],payload:projects};}function changePage(newPage){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_store_action_types__["i" /* PROJECTS_PAGE_CHANGE */],payload:newPage};}function changeMissingDrsPage(newPage){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_store_action_types__["g" /* PROJECTS_MISSING_DRS_PAGE_CHANGE */],payload:newPage};}function changeBidsDuePage(newPage){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_store_action_types__["c" /* PROJECTS_BIDS_DUE_PAGE_CHANGE */],payload:newPage};}function changeNav(newNav){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_store_action_types__["h" /* PROJECTS_NAV_CHANGE */],payload:newNav};}function goToProjects(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(baseRoutePath));};}function goToProjectDetails(projectId,params){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])({pathname:baseRoutePath+'/'+projectId,state:params}));};}function goToEditProject(projectId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(baseRoutePath+'/edit/'+projectId));};}function missingDrsCountSuccess(count){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_store_action_types__["e" /* PROJECTS_MISSING_DRS_COUNT */],payload:count};}function missingDrsCount(filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_projects_api__["a" /* projectsApi */].getProjectsCount(filters).then(function(response){if(response.ok){dispatch(missingDrsCountSuccess(response.count));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function bidsDueCountSuccess(count){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_store_action_types__["a" /* PROJECTS_BIDS_DUE_COUNT */],payload:count};}function bidsDueCount(filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_projects_api__["a" /* projectsApi */].getProjectsCount(filters).then(function(response){if(response.ok){dispatch(bidsDueCountSuccess(response.count));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function dailyReportsReminder(id){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_projects_api__["a" /* projectsApi */].dailyReportsReminder(id).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBuildings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getClients; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCurrentClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCurrentFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getInvalidFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getInvoices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getPurchaseOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getValidationMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getShowContactsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getShowInviteClientModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getShowInviteClientUserModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getSurveys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getWorkOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getProjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return noteEditorSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getClientsCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getClientsTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getClientsPageSize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getBuildings=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.data.buildings;},function(buildings){return buildings;});var getClients=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.data.clients;},function(clients){return clients;});var getCurrentClient=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.data.currentClient;},function(currentClient){return currentClient;});var getCurrentFilter=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.ui.currentFilter;},function(currentFilter){return currentFilter;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.ui.currentPage;},function(currentPage){return currentPage;});var getForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.ui.form;},function(form){return form;});var getInvalidFields=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.ui.invalidFields;},function(invalidFields){return invalidFields;});var getInvoices=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.data.invoices;},function(invoices){return invoices;});var getPurchaseOrders=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.data.purchaseOrders;},function(purchaseOrders){return purchaseOrders;});var getRoles=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.data.roles;},function(roles){return roles;});var getValidationMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.ui.validationMessage;},function(validationMessage){return validationMessage;});var getShowContactsModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.ui.showContacts;},function(showContacts){return showContacts;});var getShowInviteClientModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.ui.showInviteClientModal;},function(showInviteClientModal){return showInviteClientModal;});var getShowInviteClientUserModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.ui.showInviteClientUserModal;},function(showInviteClientUserModal){return showInviteClientUserModal;});var getSurveys=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.data.surveys;},function(surveys){return surveys;});var getUsers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.data.users;},function(users){return users;});var getWorkOrders=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.data.workOrders;},function(workOrders){return workOrders;});var getProjects=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.data.projects;},function(projects){return projects;});var noteEditorSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.ui.noteEditor;},function(noteEditor){return noteEditor;});var getClientsCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.ui.clientsCurrentPage;},function(clientsCurrentPage){return clientsCurrentPage;});var getClientsTotal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.ui.clientsTotal;},function(clientsTotal){return clientsTotal;});var getClientsPageSize=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.clients.ui.clientsPageSize;},function(clientsPageSize){return clientsPageSize;});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ServiceProviderTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServiceProviderOptions; });
/* unused harmony export ServiceProviderOptionsUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ServiceProviderOptionsUrlToValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ServiceProviderValuesToUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ServiceProviderTitles; });
var ServiceProviderTypes={Architect:'Architect',ConstructionProjectManager:'Construction Project Manager',Consultant:'Consultant',Landlord:'Landlord',PropertyManager:'Property Manager',Contractor:'Subcontractor',Client:'Client',GeneralContractor:'General Contractor'};var ServiceProviderOptions=Object.keys(ServiceProviderTypes).filter(function(type){return type!=='GeneralContractor'&&type!=='Client';}).map(function(type){return{value:type,label:ServiceProviderTypes[type]};});var ServiceProviderOptionsUrl=Object.values(ServiceProviderTypes).map(function(type){return type.toLowerCase().split(' ').join('-');});var ServiceProviderOptionsUrlToValues=new Map(ServiceProviderOptionsUrl.map(function(value,indx){return[value,Object.keys(ServiceProviderTypes)[indx]];}));var ServiceProviderValuesToUrl=new Map(Array.from(ServiceProviderOptionsUrlToValues,function(a){return a.reverse();}));var ServiceProviderTitles={Client:['Administrator'],GeneralContractor:['Co-Founder','Project Executive','Senior Project Manager','Project Manager','Senior Project Administrator','Business Manager','Project Engineer','Senior Superintendent','Superintendent','Assistant Superintendent','Field Operations Manager','Administrator','Laborer'],Architect:['Principal','Designer','Senior Associate','Associate','Studio Director','Project Manager','Administrator'],ConstructionProjectManager:['Executive','Project Manager','Project Engineer','Field Operations','Administrator'],Consultant:['MEP','AV','Structural'],Landlord:['Executive','Associate','Building Manager','Administrator'],PropertyManager:['Property Manager','Assistant Property Manager','Building Engineer','Administrator'],Contractor:['President','Vice President','Executive','Project Manager','Assistant Project Manager','Project Engineer','Estimator','Superintendent','Assistant Superintendent','Foreman','Administrator']};

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentGeneralContractor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getGeneralContractors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getLicenceNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCurrentStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCompanyLogo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getProjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getProjectsCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getShowContactsModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getCurrentGeneralContractor=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.generalContractors.data.currentGeneralContractor;},function(currentGeneralContractor){return currentGeneralContractor;});var getGeneralContractors=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.generalContractors.data.generalContractors;},function(generalContractors){return generalContractors;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.generalContractors.ui.currentPage;},function(currentPage){return currentPage;});var getLicenceNumber=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.generalContractors.ui.licenceNumber;},function(licenceNumber){return licenceNumber;});var getCurrentStage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.generalContractors.ui.currentStage;},function(currentStage){return currentStage;});var getCompanyLogo=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.generalContractors.ui.companyLogo;},function(companyLogo){return companyLogo;});var getProjects=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.generalContractors.data.projects;},function(projects){return projects;});var getProjectsCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.generalContractors.ui.projectsCurrentPage;},function(projectsCurrentPage){return projectsCurrentPage;});var getUsers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.generalContractors.data.users;},function(users){return users;});var getShowContactsModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.generalContractors.ui.showContacts;},function(showContacts){return showContacts;});

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatTime = formatTime;
exports.isVideoChild = isVideoChild;
exports.mergeAndSortChildren = mergeAndSortChildren;
exports.deprecatedWarning = deprecatedWarning;
exports.throttle = throttle;
exports.mediaProperties = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(989));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(206));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(611));

var _react = _interopRequireDefault(__webpack_require__(0));

// NaN is the only value in javascript which is not equal to itself.
// eslint-disable-next-line no-self-compare
var isNaN = Number.isNaN || function (value) {
  return value !== value;
};
/**
 * @file format-time.js
 *
 * Format seconds as a time string, H:MM:SS or M:SS
 * Supplying a guide (in seconds) will force a number of leading zeros
 * to cover the length of the guide
 *
 * @param  {Number} seconds Number of seconds to be turned into a string
 * @param  {Number} guide   Number (in seconds) to model the string after
 * @return {String}         Time formatted as H:MM:SS or M:SS
 * @private
 * @function formatTime
 */


function formatTime() {
  var seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var guide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : seconds;
  var s = Math.floor(seconds % 60);
  var m = Math.floor(seconds / 60 % 60);
  var h = Math.floor(seconds / 3600);
  var gm = Math.floor(guide / 60 % 60);
  var gh = Math.floor(guide / 3600); // handle invalid times

  if (isNaN(seconds) || seconds === Infinity) {
    // '-' is false for all relational operators (e.g. <, >=) so this setting
    // will add the minimum number of fields specified by the guide
    h = '-';
    m = '-';
    s = '-';
  } // Check if we need to show hours


  h = h > 0 || gh > 0 ? "".concat(h, ":") : ''; // If hours are showing, we may need to add a leading zero.
  // Always show at least one digit of minutes.

  m = "".concat((h || gm >= 10) && m < 10 ? "0".concat(m) : m, ":"); // Check if leading zero is need for seconds

  s = s < 10 ? "0".concat(s) : s;
  return h + m + s;
} // Check if the element belongs to a video element
// only accept <source />, <track />,
// <MyComponent isVideoChild />
// elements


function isVideoChild(c) {
  if (c.props && c.props.isVideoChild) {
    return true;
  }

  return c.type === 'source' || c.type === 'track';
}

var find = function find(elements, func) {
  return elements.filter(func)[0];
}; // check if two components are the same type


var isTypeEqual = function isTypeEqual(component1, component2) {
  var type1 = component1.type;
  var type2 = component2.type;

  if (typeof type1 === 'string' || typeof type2 === 'string') {
    return type1 === type2;
  }

  if (typeof type1 === 'function' && typeof type2 === 'function') {
    return type1.displayName === type2.displayName;
  }

  return false;
}; // merge default children
// sort them by `order` property
// filter them by `disabled` property


function mergeAndSortChildren(defaultChildren, _children, _parentProps) {
  var defaultOrder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  var children = _react["default"].Children.toArray(_children);

  var order = _parentProps.order,
      parentProps = (0, _objectWithoutProperties2["default"])(_parentProps, ["order"]); // ignore order from parent

  return children.filter(function (e) {
    return !e.props.disabled;
  }) // filter the disabled components
  .concat(defaultChildren.filter(function (c) {
    return !find(children, function (component) {
      return isTypeEqual(component, c);
    });
  })).map(function (element) {
    var defaultComponent = find(defaultChildren, function (c) {
      return isTypeEqual(c, element);
    });
    var defaultProps = defaultComponent ? defaultComponent.props : {};
    var props = (0, _objectSpread2["default"])({}, parentProps, defaultProps, element.props);

    var e = _react["default"].cloneElement(element, props, element.props.children);

    return e;
  }).sort(function (a, b) {
    return (a.props.order || defaultOrder) - (b.props.order || defaultOrder);
  });
}
/**
 * Temporary utility for generating the warnings
 */


function deprecatedWarning(oldMethodCall, newMethodCall) {
  // eslint-disable-next-line no-console
  console.warn("WARNING: ".concat(oldMethodCall, " will be deprecated soon! Please use ").concat(newMethodCall, " instead."));
}

function throttle(callback, limit) {
  var _arguments = arguments;
  var wait = false;
  return function () {
    if (!wait) {
      // eslint-disable-next-line prefer-rest-params
      callback.apply(void 0, (0, _toConsumableArray2["default"])(_arguments));
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
    }
  };
}

var mediaProperties = ['error', 'src', 'srcObject', 'currentSrc', 'crossOrigin', 'networkState', 'preload', 'buffered', 'readyState', 'seeking', 'currentTime', 'duration', 'paused', 'defaultPlaybackRate', 'playbackRate', 'played', 'seekable', 'ended', 'autoplay', 'loop', 'mediaGroup', 'controller', 'controls', 'volume', 'muted', 'defaultMuted', 'audioTracks', 'videoTracks', 'textTracks', 'width', 'height', 'videoWidth', 'videoHeight', 'poster'];
exports.mediaProperties = mediaProperties;

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCurrentStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getProjectForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getGeneralContractors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getClientForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getShowNewClientModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBuildingForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getShowNewBuildingModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getNewProjectId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.creation.ui.currentPage;},function(currentPage){return currentPage;});var getCurrentStage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.creation.ui.currentStage;},function(currentStage){return currentStage;});var getProjectForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.creation.ui.projectForm;},function(projectForm){return projectForm;});var getGeneralContractors=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.creation.data.generalContractors;},function(generalContractors){return generalContractors;});var getClientForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.creation.ui.clientForm;},function(clientForm){return clientForm;});var getShowNewClientModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.creation.ui.showNewClientModal;},function(showNewClientModal){return showNewClientModal;});var getBuildingForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.creation.ui.buildingForm;},function(buildingForm){return buildingForm;});var getShowNewBuildingModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.creation.ui.showNewBuildingModal;},function(showNewBuildingModal){return showNewBuildingModal;});var getNewProjectId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.creation.data.newProjectId;},function(newProjectId){return newProjectId;});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = newProject;
/* harmony export (immutable) */ __webpack_exports__["f"] = editProject;
/* harmony export (immutable) */ __webpack_exports__["j"] = nextStage;
/* harmony export (immutable) */ __webpack_exports__["n"] = setProjectFormValue;
/* harmony export (immutable) */ __webpack_exports__["o"] = setProjectFormValues;
/* unused harmony export setNewProjectId */
/* harmony export (immutable) */ __webpack_exports__["e"] = createProject;
/* harmony export (immutable) */ __webpack_exports__["r"] = updateProject;
/* harmony export (immutable) */ __webpack_exports__["m"] = setGeneralContractors;
/* unused harmony export changePage */
/* harmony export (immutable) */ __webpack_exports__["h"] = loadGeneralContractorsRequest;
/* harmony export (immutable) */ __webpack_exports__["l"] = setClientFormValue;
/* harmony export (immutable) */ __webpack_exports__["q"] = setShowNewClientModal;
/* harmony export (immutable) */ __webpack_exports__["b"] = cleanClientFormValues;
/* unused harmony export findSimilarClient */
/* harmony export (immutable) */ __webpack_exports__["d"] = createClient;
/* harmony export (immutable) */ __webpack_exports__["g"] = inviteExistentClient;
/* harmony export (immutable) */ __webpack_exports__["k"] = setBuildingFormValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = cleanBuildingFormValues;
/* harmony export (immutable) */ __webpack_exports__["p"] = setShowNewBuildingModal;
/* harmony export (immutable) */ __webpack_exports__["c"] = createBuilding;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_projects_api__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_general_contractors_api__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_clients_api__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_api_buildings_api__ = __webpack_require__(259);
function newProject(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["c" /* NEW_PROJECT */]};}function editProject(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["a" /* EDIT_PROJECT */]};}function nextStage(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["n" /* NEXT_STAGE */]};}function setProjectFormValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["g" /* NEW_PROJECT_FORM_VALUE_CHANGE */],payload:{attribute:attribute,value:value}};}function setProjectFormValues(project){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["b" /* EDIT_PROJECT_FORM_SET_VALUES */],payload:project};}function setNewProjectId(newProjectId){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["i" /* NEW_PROJECT_ID_SET */],payload:newProjectId};}function createProject(values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_projects_api__["a" /* projectsApi */].createProject(values).then(function(response){if(response.ok){dispatch(setNewProjectId(response.project.id));dispatch(nextStage());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function updateProject(id,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_projects_api__["a" /* projectsApi */].updateProject(id,values).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setGeneralContractors(generalContractors){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["h" /* NEW_PROJECT_GC_SET */],payload:generalContractors};}function changePage(page){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["f" /* NEW_PROJECT_CURRENT_PAGE_SET */],payload:page};}function loadGeneralContractorsRequest(page){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_general_contractors_api__["a" /* generalContractorsApi */].getGeneralContractors(page).then(function(response){if(response.ok){dispatch(setGeneralContractors(response.generalContractors));dispatch(changePage(page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setClientFormValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["e" /* NEW_PROJECT_CLIENT_FORM_VALUE_CHANGE */],payload:{attribute:attribute,value:value}};}function setShowNewClientModal(value){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["m" /* NEW_PROJECT_NEW_CLIENT_MODAL_SHOW */],payload:value};}function cleanClientFormValues(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["l" /* NEW_PROJECT_NEW_CLIENT_FORM_CLEAN */]};}function findSimilarClient(values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_clients_api__["a" /* clientsApi */].findSimilar(values).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function createClient(values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_clients_api__["a" /* clientsApi */].inviteClient(values,true).then(function(response){if(response.ok){dispatch(setProjectFormValue('clientId',response.client.id));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function inviteExistentClient(clientId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_clients_api__["a" /* clientsApi */].inviteExistent(clientId).then(function(response){if(response.ok){dispatch(setProjectFormValue('clientId',clientId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setBuildingFormValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["d" /* NEW_PROJECT_BUILDING_FORM_VALUE_CHANGE */],payload:{attribute:attribute,value:value}};}function cleanBuildingFormValues(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["j" /* NEW_PROJECT_NEW_BUILDING_FORM_CLEAN */]};}function setShowNewBuildingModal(value){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["k" /* NEW_PROJECT_NEW_BUILDING_MODAL_SHOW */],payload:value};}function createBuilding(values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5_services_api_buildings_api__["a" /* buildingsApi */].createBuilding(values).then(function(response){if(response.ok){dispatch(setProjectFormValue('buildingId',response.building.id));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = initRfiLog;
/* unused harmony export loadRfisSuccess */
/* harmony export (immutable) */ __webpack_exports__["n"] = loadRfisRequest;
/* harmony export (immutable) */ __webpack_exports__["B"] = setRfiTabSelected;
/* harmony export (immutable) */ __webpack_exports__["x"] = setRfiModalShow;
/* harmony export (immutable) */ __webpack_exports__["k"] = initRfiModal;
/* harmony export (immutable) */ __webpack_exports__["F"] = updateRfiFormValue;
/* harmony export (immutable) */ __webpack_exports__["G"] = updateRfiQuestionValue;
/* harmony export (immutable) */ __webpack_exports__["z"] = setRfiQuestionErrors;
/* harmony export (immutable) */ __webpack_exports__["b"] = addRfiQuestion;
/* harmony export (immutable) */ __webpack_exports__["c"] = attachRfiQuestions;
/* harmony export (immutable) */ __webpack_exports__["i"] = deleteRfiQuestion;
/* unused harmony export createRfiSuccess */
/* harmony export (immutable) */ __webpack_exports__["d"] = createRfi;
/* unused harmony export updateRfiSuccess */
/* harmony export (immutable) */ __webpack_exports__["D"] = updateRfi;
/* harmony export (immutable) */ __webpack_exports__["q"] = respondRfi;
/* harmony export (immutable) */ __webpack_exports__["r"] = respondRfiAddlAssignee;
/* harmony export (immutable) */ __webpack_exports__["s"] = setCurrentRfi;
/* harmony export (immutable) */ __webpack_exports__["A"] = setRfiReadOnly;
/* unused harmony export loadRfiRequest */
/* harmony export (immutable) */ __webpack_exports__["u"] = setRfiFormValues;
/* harmony export (immutable) */ __webpack_exports__["t"] = setRfiFormErrors;
/* harmony export (immutable) */ __webpack_exports__["f"] = deleteQuestionFile;
/* harmony export (immutable) */ __webpack_exports__["m"] = loadRfiQuestionNotes;
/* harmony export (immutable) */ __webpack_exports__["o"] = markRfiQuestionNotesRead;
/* unused harmony export addRfiQuestionNote */
/* harmony export (immutable) */ __webpack_exports__["e"] = createRfiQuestionNote;
/* harmony export (immutable) */ __webpack_exports__["p"] = openRfi;
/* harmony export (immutable) */ __webpack_exports__["v"] = setRfiGcAcceleration;
/* harmony export (immutable) */ __webpack_exports__["w"] = setRfiLogPdfViewer;
/* unused harmony export loadRfiLogPdfSuccess */
/* harmony export (immutable) */ __webpack_exports__["l"] = loadRfiLogPdfRequest;
/* harmony export (immutable) */ __webpack_exports__["y"] = setRfiPdfViewer;
/* unused harmony export deleteRfiSuccess */
/* harmony export (immutable) */ __webpack_exports__["g"] = deleteRfi;
/* harmony export (immutable) */ __webpack_exports__["C"] = setSetShowRfiErrorMessage;
/* harmony export (immutable) */ __webpack_exports__["a"] = addRfiAddlAssignee;
/* harmony export (immutable) */ __webpack_exports__["E"] = updateRfiAddlAssignee;
/* harmony export (immutable) */ __webpack_exports__["h"] = deleteRfiAddlAssignee;
/* unused harmony export respondRfiAddlAssigneeSuccess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_rfis_api__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_rfi_questions_api__ = __webpack_require__(2512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_rfi_addl_assignees_api__ = __webpack_require__(2513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__ = __webpack_require__(625);
function initRfiLog(){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["n" /* RFI_LOG_INIT */]};}function loadRfisSuccess(rfisData,page,status,dueDateFilter){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["d" /* RFIS_SET */],payload:Object.assign({},rfisData,{currentPage:page,currentStatus:status,dueDateFilter:dueDateFilter})};}function loadRfisRequest(projectId,page,status,dueDateFilter){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_rfis_api__["a" /* rfisApi */].getRfis(projectId,page,status,dueDateFilter).then(function(response){if(response.ok){dispatch(loadRfisSuccess(response,page,status,dueDateFilter));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setRfiTabSelected(rfiTab){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["C" /* RFI_TAB_SELECTED_SET */],payload:rfiTab};}function setRfiModalShow(show){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["r" /* RFI_MODAL_SHOW_SET */],payload:show};}function initRfiModal(){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["q" /* RFI_MODAL_INIT */]};}function updateRfiFormValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["l" /* RFI_FORM_VALUE_UPDATE */],payload:{attribute:attribute,value:value}};}function updateRfiQuestionValue(key,attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["z" /* RFI_QUESTION_VALUE_UPDATE */],payload:{key:key,attribute:attribute,value:value}};}function setRfiQuestionErrors(key,errors){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["w" /* RFI_QUESTION_ERRORS_SET */],payload:{key:key,errors:errors}};}function addRfiQuestion(key,item){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["u" /* RFI_QUESTION_ADD */],payload:{key:key,item:item}};}function attachRfiQuestions(questions){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["t" /* RFI_QUESTIONS_ATTACH */],payload:questions};}function deleteRfiQuestion(key){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["v" /* RFI_QUESTION_DELETE */],payload:key};}function createRfiSuccess(rfi){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["b" /* RFIS_ADD */],payload:rfi};}function createRfi(projectId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_rfis_api__["a" /* rfisApi */].createRfi(projectId,values).then(function(response){if(response.ok){dispatch(createRfiSuccess(response.rfi));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateRfiSuccess(rfi){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["e" /* RFIS_UPDATE */],payload:rfi};}function updateRfi(projectId,rfiId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_rfis_api__["a" /* rfisApi */].updateRfi(projectId,rfiId,values).then(function(response){if(response.ok){dispatch(updateRfiSuccess(response.rfi));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function respondRfi(projectId,rfiId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_rfis_api__["a" /* rfisApi */].respondRfi(projectId,rfiId,values).then(function(response){if(response.ok){dispatch(updateRfiSuccess(response.rfi));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function respondRfiAddlAssignee(userId,questions){return function(dispatch){var promises=[];questions.forEach(function(qus){var addlAssignee=qus.addlAssignees.find(function(addlAssignee){return addlAssignee.assigneeId===userId;});var addlAssigneeId=addlAssignee&&addlAssignee.id;if(addlAssigneeId){promises.push(__WEBPACK_IMPORTED_MODULE_3_services_api_rfi_addl_assignees_api__["a" /* rfiAddlAssigneesApi */].updaterfiAddlAssignee(addlAssigneeId,qus));}});return Promise.all(promises).then(function(values){var result={};if(!values.find(function(value){return!value.ok;})){values.forEach(function(value){dispatch(respondRfiAddlAssigneeSuccess(value.rfiAddlAssignee));});result.ok=true;}else{var errors=[];values.forEach(function(value){if(!value.ok){errors.push(value.errors);}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(errors));result.ok=false;}return result;});};}function setCurrentRfi(rfi){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["a" /* CURRENT_RFI_SET */],payload:rfi};}function setRfiReadOnly(readOnly){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["A" /* RFI_READ_ONLY_SET */],payload:readOnly};}function loadRfiRequest(projectId,rfiId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_rfis_api__["a" /* rfisApi */].getRfi(projectId,rfiId).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setRfiFormValues(rfi){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["k" /* RFI_FORM_VALUES_SET */],payload:rfi};}function setRfiFormErrors(errors){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["j" /* RFI_FORM_ERRORS_SET */],payload:errors};}function deleteQuestionFile(key,attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["x" /* RFI_QUESTION_FILE_DELETE */],payload:{key:key,attribute:attribute,value:value}};}function loadRfiQuestionNotes(questionKey,questionId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_rfi_questions_api__["a" /* rfiQuestionsApi */].getNotes(questionId).then(function(response){if(response.ok){dispatch(updateRfiQuestionValue(questionKey,'notes',response.notes));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function markRfiQuestionNotesRead(questionKey,question,userId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_rfi_questions_api__["a" /* rfiQuestionsApi */].markNotesRead(question.id).then(function(response){if(response.ok){var notesReadBy=question.notesReadBy.concat(userId.toString());dispatch(updateRfiQuestionValue(questionKey,'notesReadBy',notesReadBy));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function addRfiQuestionNote(key,note){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["y" /* RFI_QUESTION_NOTE_ADD */],payload:{key:key,note:note}};}function createRfiQuestionNote(questionKey,questionId,content){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_rfi_questions_api__["a" /* rfiQuestionsApi */].createNote(questionId,content).then(function(response){if(response.ok){dispatch(addRfiQuestionNote(questionKey,response.note));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function openRfi(projectId,rfiId){var readOnly=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return function(dispatch){dispatch(loadRfiRequest(projectId,rfiId)).then(function(response){if(response.ok){dispatch(setCurrentRfi(response.rfi));dispatch(setRfiReadOnly(readOnly));dispatch(setRfiModalShow(true));}});};}function setRfiGcAcceleration(gcAcceleration){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["m" /* RFI_GC_ACCELERATION_SET */],payload:gcAcceleration};}function setRfiLogPdfViewer(pdfViewer){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["p" /* RFI_LOG_PDF_VIEWER_SET */],payload:pdfViewer};}function loadRfiLogPdfSuccess(rfiLogPdf){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["o" /* RFI_LOG_PDF_SET */],payload:rfiLogPdf};}function loadRfiLogPdfRequest(projectId){var status=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'not_pre';return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_rfis_api__["a" /* rfisApi */].getRfiLogPdf(projectId,status).then(function(response){if(response.ok){dispatch(loadRfiLogPdfSuccess(response.rfiLogPdf));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setRfiPdfViewer(pdfViewer){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["s" /* RFI_PDF_VIEWER_SET */],payload:pdfViewer};}function deleteRfiSuccess(rfiId){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["c" /* RFIS_DELETE */],payload:rfiId};}function deleteRfi(projectId,rfiId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_rfis_api__["a" /* rfisApi */].deleteRfi(projectId,rfiId).then(function(response){if(response.ok){dispatch(deleteRfiSuccess(rfiId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setSetShowRfiErrorMessage(showErrorMessage){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["B" /* RFI_SHOW_ERROR_MESSAGE_SET */],payload:showErrorMessage};}function addRfiAddlAssignee(key,addlAssignee){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["f" /* RFI_ADDL_ASSIGNEES_ADD */],payload:{key:key,addlAssignee:addlAssignee}};}function updateRfiAddlAssignee(key,addlAssignee,index){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["h" /* RFI_ADDL_ASSIGNEES_UPDATE */],payload:{key:key,addlAssignee:addlAssignee,index:index}};}function deleteRfiAddlAssignee(key,index){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["g" /* RFI_ADDL_ASSIGNEES_DELETE */],payload:{key:key,index:index}};}function respondRfiAddlAssigneeSuccess(addlAssignee){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_rfi_log_store_action_types__["i" /* RFI_ADDL_ASSIGNEE_RESPOND_SUCCESS */],payload:addlAssignee};}

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = initProjectProposal;
/* harmony export (immutable) */ __webpack_exports__["v"] = toggleCreateProposal;
/* harmony export (immutable) */ __webpack_exports__["w"] = toggleCreateProposalSuccess;
/* harmony export (immutable) */ __webpack_exports__["y"] = togglePdfViewer;
/* harmony export (immutable) */ __webpack_exports__["t"] = toggleApproveProposalSuccess;
/* unused harmony export loadProjectProposalSuccess */
/* harmony export (immutable) */ __webpack_exports__["b"] = buildProjectProposalForm;
/* harmony export (immutable) */ __webpack_exports__["i"] = loadProjectProposalRequest;
/* unused harmony export loadProjectProposalPdfSuccess */
/* harmony export (immutable) */ __webpack_exports__["h"] = loadProjectProposalPdfRequest;
/* harmony export (immutable) */ __webpack_exports__["k"] = newItem;
/* unused harmony export addProjectProposalItem */
/* harmony export (immutable) */ __webpack_exports__["E"] = updateProjectProposalItemValue;
/* harmony export (immutable) */ __webpack_exports__["l"] = newSubItem;
/* unused harmony export addProjectProposalSubItem */
/* harmony export (immutable) */ __webpack_exports__["F"] = updateProjectProposalSubItemValue;
/* harmony export (immutable) */ __webpack_exports__["j"] = newAddlItem;
/* unused harmony export addProjectProposalAddlItem */
/* harmony export (immutable) */ __webpack_exports__["B"] = updateProjectProposalAddlItemValue;
/* unused harmony export setProjectProposalItems */
/* harmony export (immutable) */ __webpack_exports__["D"] = updateProjectProposalFormValue;
/* harmony export (immutable) */ __webpack_exports__["c"] = createProjectProposal;
/* harmony export (immutable) */ __webpack_exports__["A"] = updateProjectProposal;
/* harmony export (immutable) */ __webpack_exports__["C"] = updateProjectProposalCostsShown;
/* harmony export (immutable) */ __webpack_exports__["z"] = updateProject;
/* harmony export (immutable) */ __webpack_exports__["a"] = approveProjectProposal;
/* unused harmony export loadCsiCodesSuccess */
/* harmony export (immutable) */ __webpack_exports__["g"] = loadCsiCodes;
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchSubcontractors;
/* harmony export (immutable) */ __webpack_exports__["x"] = toggleItemDelete;
/* harmony export (immutable) */ __webpack_exports__["m"] = resetProjectProposalItems;
/* harmony export (immutable) */ __webpack_exports__["p"] = setReadOnly;
/* harmony export (immutable) */ __webpack_exports__["u"] = toggleAwardRecommendation;
/* harmony export (immutable) */ __webpack_exports__["r"] = setShowLostModal;
/* harmony export (immutable) */ __webpack_exports__["q"] = setShowCancelModal;
/* harmony export (immutable) */ __webpack_exports__["n"] = setDate;
/* harmony export (immutable) */ __webpack_exports__["o"] = setMessage;
/* harmony export (immutable) */ __webpack_exports__["s"] = setTerminationCategory;
/* harmony export (immutable) */ __webpack_exports__["e"] = initProjectLostCancelModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_project_proposals_api__ = __webpack_require__(2534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_projects_api__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_csi_codes_api__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_store_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_api_contractors_api__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_numeral__);
function initProjectProposal(){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["d" /* INIT_PROJECT_PROPOSAL */]};}function toggleCreateProposal(){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["x" /* TOGGLE_CREATE_PROPOSAL */]};}function toggleCreateProposalSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["y" /* TOGGLE_CREATE_PROPOSAL_SUCCESS */]};}function togglePdfViewer(){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["z" /* TOGGLE_PDF_VIEWER_SUCCESS */]};}function toggleApproveProposalSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["w" /* TOGGLE_APPROVE_PROPOSAL_SUCCESS */]};}function loadProjectProposalSuccess(projectProposal){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["o" /* PROJECT_PROPOSAL_SET */],payload:projectProposal};}function buildProjectProposalForm(projectProposal){return function(dispatch){var hasAwardRecommendation=false;var totalTradeCosts=0;var items={};var addlItems={permits:{},generalConditions:{},insurance:{},fee:{},contingency:{}};projectProposal.project_proposal_items.forEach(function(item,index){var subItems={};item.project_proposal_sub_items.forEach(function(subItem,index){subItems[index]=Object.assign({},subItem,{tradeCosts:subItem.trade_costs,awardRecommendationId:subItem.award_recommendation&&subItem.award_recommendation.id,awardRecommendationName:subItem.award_recommendation&&subItem.award_recommendation.name});hasAwardRecommendation=hasAwardRecommendation||!!subItem.award_recommendation;totalTradeCosts+=__WEBPACK_IMPORTED_MODULE_7_numeral___default()(subItem.trade_costs).value();});items[index]={id:item.id,csiCodeId:item.csi_code.id,tradeCosts:item.trade_costs,awardRecommendationId:item.award_recommendation&&item.award_recommendation.id,awardRecommendationName:item.award_recommendation&&item.award_recommendation.name,subItems:subItems};hasAwardRecommendation=hasAwardRecommendation||!!item.award_recommendation;totalTradeCosts+=__WEBPACK_IMPORTED_MODULE_7_numeral___default()(item.trade_costs).value();});[['costsShownToPrimary','costs_shown_to_primary'],['permits'],['generalConditions','general_conditions'],['insurance'],['fee'],['contingency']].forEach(function(attr){if(projectProposal[attr[1]||attr[0]]!==undefined){dispatch(updateProjectProposalFormValue(attr[0],projectProposal[attr[1]||attr[0]]));}if(projectProposal[(attr[1]||attr[0])+'_items']!==undefined){projectProposal[(attr[1]||attr[0])+'_items'].forEach(function(item,index){addlItems[attr[0]][index]=Object.assign({},item);});}});if(!hasAwardRecommendation){dispatch(toggleAwardRecommendation());}dispatch(updateProjectProposalFormValue('insuranceRatio',totalTradeCosts?projectProposal.insurance/totalTradeCosts:1));dispatch(updateProjectProposalFormValue('feeRatio',totalTradeCosts?projectProposal.fee/totalTradeCosts:1));dispatch(setProjectProposalItems(items,addlItems));};}function loadProjectProposalRequest(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_proposals_api__["a" /* projectProposalsApi */].getProjectProposal(projectId).then(function(response){if(response.ok){dispatch(loadProjectProposalSuccess(response.projectProposal));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadProjectProposalPdfSuccess(pdf){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["m" /* PROJECT_PROPOSAL_PDF_SET */],payload:pdf};}function loadProjectProposalPdfRequest(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_proposals_api__["a" /* projectProposalsApi */].getProjectProposalPdf(projectId).then(function(response){if(response.ok){dispatch(loadProjectProposalPdfSuccess(response.pdf));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function newItem(items,csiCodeId){var key=Object.keys(items).length;var item={csiCodeId:csiCodeId||'',newItem:!csiCodeId,tradeCosts:'',subItems:{}};return function(dispatch){dispatch(addProjectProposalItem(key,item));};}function addProjectProposalItem(key,item){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["j" /* PROJECT_PROPOSAL_ITEM_ADD */],payload:{key:key,item:item}};}function updateProjectProposalItemValue(key,attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["l" /* PROJECT_PROPOSAL_ITEM_VALUE_UPDATE */],payload:{key:key,attribute:attribute,value:value}};}function newSubItem(itemKey,item,csiCode){var keys=Object.keys(item.subItems||{});var key=keys.length;var letter=keys.filter(function(key){return!item.subItems[key].delete;}).length;var subItem={division:csiCode.division+'.'+String.fromCharCode(97+letter),label:'',tradeCosts:''};return function(dispatch){dispatch(addProjectProposalSubItem(itemKey,key,subItem));};}function addProjectProposalSubItem(itemKey,key,subItem){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["p" /* PROJECT_PROPOSAL_SUB_ITEM_ADD */],payload:{itemKey:itemKey,key:key,subItem:subItem}};}function updateProjectProposalSubItemValue(itemKey,key,attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["q" /* PROJECT_PROPOSAL_SUB_ITEM_VALUE_UPDATE */],payload:{itemKey:itemKey,key:key,attribute:attribute,value:value}};}function newAddlItem(itemKey,subItems){var key=Object.keys(subItems||{}).length;var item={summary:'',cost:''};return function(dispatch){dispatch(addProjectProposalAddlItem(itemKey,key,item));};}function addProjectProposalAddlItem(type,key,item){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["e" /* PROJECT_PROPOSAL_ADDL_ITEM_ADD */],payload:{type:type,key:key,item:item}};}function updateProjectProposalAddlItemValue(type,key,attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["f" /* PROJECT_PROPOSAL_ADDL_ITEM_VALUE_UPDATE */],payload:{type:type,key:key,attribute:attribute,value:value}};}function setProjectProposalItems(items,addlItems){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["i" /* PROJECT_PROPOSAL_ITEMS_SET */],payload:{items:items,addlItems:addlItems}};}function updateProjectProposalFormValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["g" /* PROJECT_PROPOSAL_FORM_VALUE_UPDATE */],payload:{attribute:attribute,value:value}};}function createProjectProposal(projectId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_proposals_api__["a" /* projectProposalsApi */].createProjectProposal(projectId,values).then(function(response){if(response.ok){dispatch(loadProjectProposalSuccess(response.projectProposal));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateProjectProposal(projectId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_proposals_api__["a" /* projectProposalsApi */].updateProjectProposal(projectId,values).then(function(response){if(response.ok){dispatch(loadProjectProposalSuccess(response.projectProposal));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateProjectProposalCostsShown(projectId,shown){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_proposals_api__["a" /* projectProposalsApi */].updateProjectProposalCostsShown(projectId,shown).then(function(response){if(response.ok){dispatch(loadProjectProposalSuccess(response.projectProposal));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateProject(projectId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_projects_api__["a" /* projectsApi */].updateProject(projectId,values).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_store_actions__["b" /* loadProjectRequest */])(projectId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function approveProjectProposal(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_proposals_api__["a" /* projectProposalsApi */].approveProjectProposal(projectId).then(function(response){if(response.ok){dispatch(loadProjectProposalSuccess(response.projectProposal));dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_store_actions__["b" /* loadProjectRequest */])(projectId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadCsiCodesSuccess(csiCodes){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["b" /* CSI_CODES_SET */],payload:csiCodes};}function loadCsiCodes(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_csi_codes_api__["a" /* csiCodesApi */].getCsiCodes().then(function(response){if(response.ok){dispatch(loadCsiCodesSuccess(response.csiCodes));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function fetchSubcontractors(byName,byCsiCode,page){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_6_services_api_contractors_api__["a" /* contractorsApi */].searchContractors(byName,[],[],byCsiCode,page).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function toggleItemDelete(key){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["k" /* PROJECT_PROPOSAL_ITEM_DELETE_TOGGLE */],payload:key};}function resetProjectProposalItems(){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["h" /* PROJECT_PROPOSAL_ITEMS_RESET */]};}function setReadOnly(readOnly){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["n" /* PROJECT_PROPOSAL_READ_ONLY_SET */],payload:readOnly};}function toggleAwardRecommendation(){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["a" /* AWARD_RECOMMENDATION_TOGGLE */]};}function setShowLostModal(value){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["u" /* SET_SHOW_LOST_MODAL */],payload:value};}function setShowCancelModal(value){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["t" /* SET_SHOW_CANCEL_MODAL */],payload:value};}function setDate(date){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["r" /* SET_DATE_MODAL */],payload:date};}function setMessage(message){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["s" /* SET_MESSAGE */],payload:message};}function setTerminationCategory(value){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["v" /* SET_TERMINATION_CATEGORY */],payload:value};}function initProjectLostCancelModal(payload){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_proposal_store_action_types__["c" /* INIT_PROJECT_LOST_CANCEL_MODAL */],payload:payload};}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(219)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AUTHENTICATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTHENTICATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AUTHENTICATION_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTHENTICATION_ACCOUNTS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CANCEL_ENTERPRISE_REDIRECT; });
/* harmony export (immutable) */ __webpack_exports__["g"] = authenticationRequest;
/* unused harmony export authenticationSuccess */
/* harmony export (immutable) */ __webpack_exports__["m"] = updateUser;
/* unused harmony export authenticationError */
/* harmony export (immutable) */ __webpack_exports__["k"] = logoutRequest;
/* unused harmony export logoutFinish */
/* harmony export (immutable) */ __webpack_exports__["f"] = authRefreshUserAccountable;
/* unused harmony export authenticationSetAccounts */
/* harmony export (immutable) */ __webpack_exports__["l"] = switchAccount;
/* harmony export (immutable) */ __webpack_exports__["i"] = clearCurrentUser;
/* harmony export (immutable) */ __webpack_exports__["j"] = enterpriseRedirect;
/* harmony export (immutable) */ __webpack_exports__["h"] = cancelEnterpriseRedirect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_auth_api__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_authentication_storage__ = __webpack_require__(754);
var AUTHENTICATION_SUCCESS='AUTHENTICATION_SUCCESS';var AUTHENTICATION_FAILURE='AUTHENTICATION_FAILURE';var AUTHENTICATION_LOGOUT='AUTHENTICATION_LOGOUT';var AUTHENTICATION_ACCOUNTS_SET='AUTHENTICATION_ACCOUNTS_SET';var CANCEL_ENTERPRISE_REDIRECT='CANCEL_ENTERPRISE_REDIRECT';function authenticationRequest(email,password){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_auth_api__["b" /* default */].login(email,password).then(function(response){if(response.ok){__WEBPACK_IMPORTED_MODULE_2_services_authentication_storage__["a" /* default */].setCredentials(response.data.accessToken,response.data.client,response.data.user);dispatch(authenticationSuccess(response.data.accessToken,response.data.client,response.data.user));var accounts=__WEBPACK_IMPORTED_MODULE_2_services_authentication_storage__["a" /* default */].setAccounts(response.data.accessToken,response.data.client,response.data.user);dispatch(authenticationSetAccounts(accounts));}else{dispatch(authenticationError(response.errors));}return response;});};}function authenticationSuccess(accessToken,client,user){var serviceWorkApp=Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://spackle-v1.fly.dev/","REACT_APP_CABLE_WSS_URL":"wss://spackle-v1.fly.dev/cable","REACT_APP_ADVANCED_DOCUMENTS_S3_BUCKET":"360-custom-document","REACT_APP_CLICKUP_FORM_URL":"https://forms.clickup.com/f/86zjg-822/NRB5VVG05QA0QWA5V1","REACT_APP_WEBVIEWER_URL":"https://spackle.s3.amazonaws.com/lib"}).REACT_APP_SERVICE_WORK;var enterpriseRedirect=serviceWorkApp==='true'&&!user.service_work;return{type:AUTHENTICATION_SUCCESS,payload:{accessToken:accessToken,client:client,user:user,enterpriseRedirect:enterpriseRedirect}};}function updateUser(user){var creds=__WEBPACK_IMPORTED_MODULE_2_services_authentication_storage__["a" /* default */].getCredentials();var accounts=__WEBPACK_IMPORTED_MODULE_2_services_authentication_storage__["a" /* default */].setAccounts(creds.accessToken,creds.client,user);__WEBPACK_IMPORTED_MODULE_2_services_authentication_storage__["a" /* default */].setCredentials(creds.accessToken,creds.client,user);return function(dispatch){dispatch(authenticationSetAccounts(accounts));};}function authenticationError(errors){return{type:AUTHENTICATION_FAILURE,payload:errors};}/**
 *
 * @param keepCurrentRoute If false, redirect to home (/)
 * @return {function(*): (*|PromiseLike<T>|Promise<T>)}
 */function logoutRequest(keepCurrentRoute){// Clear credentials from local storage
__WEBPACK_IMPORTED_MODULE_2_services_authentication_storage__["a" /* default */].clearCurrentAccount();__WEBPACK_IMPORTED_MODULE_2_services_authentication_storage__["a" /* default */].clearCredentials();return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_auth_api__["b" /* default */].logout().then(function(){// Update state
dispatch(logoutFinish());if(!keepCurrentRoute){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])('/'));}});};}function logoutFinish(){return{type:AUTHENTICATION_LOGOUT};}function authRefreshUserAccountable(accountable){var creds=__WEBPACK_IMPORTED_MODULE_2_services_authentication_storage__["a" /* default */].getCredentials();__WEBPACK_IMPORTED_MODULE_2_services_authentication_storage__["a" /* default */].setCredentials(creds.accessToken,creds.client,Object.assign({},creds.user,{accountable:accountable}));}function authenticationSetAccounts(accounts){return{type:AUTHENTICATION_ACCOUNTS_SET,payload:accounts};}function switchAccount(account){__WEBPACK_IMPORTED_MODULE_2_services_authentication_storage__["a" /* default */].setCredentials(account.accessToken,account.client,account.user);window.location.reload();return function(dispatch){};}function clearCurrentUser(){__WEBPACK_IMPORTED_MODULE_2_services_authentication_storage__["a" /* default */].clearCredentials();window.location.reload();return function(dispatch){};}function enterpriseRedirect(){__WEBPACK_IMPORTED_MODULE_2_services_authentication_storage__["a" /* default */].clearCredentials();var enterpriseDomain=Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://spackle-v1.fly.dev/","REACT_APP_CABLE_WSS_URL":"wss://spackle-v1.fly.dev/cable","REACT_APP_ADVANCED_DOCUMENTS_S3_BUCKET":"360-custom-document","REACT_APP_CLICKUP_FORM_URL":"https://forms.clickup.com/f/86zjg-822/NRB5VVG05QA0QWA5V1","REACT_APP_WEBVIEWER_URL":"https://spackle.s3.amazonaws.com/lib"}).REACT_APP_360PLUS_URL;window.location.href=''+enterpriseDomain+window.location.pathname;return function(dispatch){};}function cancelEnterpriseRedirect(){return{type:CANCEL_ENTERPRISE_REDIRECT};}

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return contractorsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorsApi=function(_BaseApi){_inherits(ContractorsApi,_BaseApi);function ContractorsApi(){_classCallCheck(this,ContractorsApi);return _possibleConstructorReturn(this,(ContractorsApi.__proto__||Object.getPrototypeOf(ContractorsApi)).apply(this,arguments));}_createClass(ContractorsApi,[{key:'getContractors',value:function getContractors(byTrades,unionIds,page,label){var filter='';if(byTrades!==undefined&&(typeof byTrades==='undefined'?'undefined':_typeof(byTrades))==='object'&&byTrades.length>0){// ?by_trades[]=2&by_trades[]=7
filter=byTrades.reduce(function(accumulator,currentValue,currentIndex){return accumulator+(currentIndex===0?'by_trades[]='+currentValue:'&by_trades[]='+currentValue);},'');}if(unionIds!==undefined&&unionIds.length>0){filter=unionIds.reduce(function(accumulator,currentValue){return accumulator+'&by_unions[]='+currentValue;},filter);}filter+=page?'&page='+page:'';filter+=label?'&by_name='+label:'';return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/contractors?'+filter).then(function(response){return{ok:true,contractors:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getContractor',value:function getContractor(contractorId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/contractors/'+contractorId).then(function(response){return{ok:true,contractor:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getWorkOrders',value:function getWorkOrders(contractorId,page,workOrderStatus,critical){var filter='';if(workOrderStatus!==undefined){filter='&'+workOrderStatus.status+'=true';}else if(critical!==undefined&&critical){filter='&critical=true';}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/contractors/'+contractorId+'/work_orders?page='+(page!==undefined?page:1)+filter).then(function(response){return{ok:true,workOrders:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),totalComplete:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-complete']).value(),totalCritical:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-critical']).value(),totalDraft:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-draft']).value(),totalInProgress:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-in_progress']).value(),totalPending:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-pending']).value(),totalPlm:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-plm']).value(),totalWoa:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-woa']).value(),totalClosed:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-closed']).value(),totalDeclined:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-declined']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getProjects',value:function getProjects(contractorId,page,projectStatus){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/contractors/'+contractorId+'/projects?page='+(page!==undefined?page:1)+(projectStatus?'&'+projectStatus+'=true':'')).then(function(response){return{ok:true,projects:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),totalPending:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-pending']).value(),totalInProgress:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-in_progress']).value(),totalComplete:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-complete']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}/**
   * Create a new contractor.
   * @param contractor
   * @param sendInvitation: boolean
   * @return {Promise<{ok: boolean, contractor: any} | {ok: boolean, errors: *}>}
   */},{key:'createContractor',value:function createContractor(contractor,sendInvitation){var contractorData=new FormData();contractorData.append('contractor[name]',contractor.name);contractorData.append('contractor[contact_attributes][first_name]',contractor.contact.firstName);contractorData.append('contractor[contact_attributes][last_name]',contractor.contact.lastName);contractorData.append('contractor[contact_attributes][email]',contractor.contact.email);contractorData.append('contractor[contact_attributes][phone_number]',contractor.contact.phoneNumber);contractorData.append('contractor[contact_attributes][title]',contractor.contact.title);if(contractor.location){contractorData.append('contractor[location_attributes][street_address_1]',contractor.location.streetAddress);contractorData.append('contractor[location_attributes][street_address_2]',contractor.location.unitNumber);contractorData.append('contractor[location_attributes][city]',contractor.location.city);contractorData.append('contractor[location_attributes][state]',contractor.location.state);contractorData.append('contractor[location_attributes][zip]',contractor.location.zipCode);}if(contractor.tradesId!==undefined){contractor.tradesId.forEach(function(id){return contractorData.append('contractor[trade_ids][]',id);});}if(contractor.serviceAreasId!==undefined){contractor.serviceAreasId.forEach(function(id){return contractorData.append('contractor[service_area_ids][]',id);});}if(contractor.unionsId!==undefined){contractor.unionsId.forEach(function(id){return contractorData.append('contractor[union_ids][]',id);});}if(contractor.w9Document&&contractor.w9Document.document!==''){contractorData.append('contractor[w9_document_attributes][document]',contractor.w9Document.document);}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/contractors'+(sendInvitation!==undefined?'?send_invite='+sendInvitation:''),contractorData,{headers:{'Content-Type':'multipart/form-data'}}).then(function(response){return{ok:true,contractor:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateContractor',value:function updateContractor(contractorId,contractor,sendInvitation){var contractorData=new FormData();contractorData.append('contractor[name]',contractor.name);contractorData.append('contractor[license_number]',contractor.licenseNumber);contractorData.append('contractor[contact_attributes][first_name]',contractor.contact.firstName);contractorData.append('contractor[contact_attributes][last_name]',contractor.contact.lastName);contractorData.append('contractor[contact_attributes][email]',contractor.contact.email);contractorData.append('contractor[contact_attributes][phone_number]',contractor.contact.phoneNumber);contractorData.append('contractor[location_attributes][street_address_1]',contractor.location.streetAddress);contractorData.append('contractor[location_attributes][street_address_2]',contractor.location.unitNumber);contractorData.append('contractor[location_attributes][city]',contractor.location.city);contractorData.append('contractor[location_attributes][state]',contractor.location.state);contractorData.append('contractor[location_attributes][zip]',contractor.location.zipCode);contractorData.append('contractor[confirmed]',contractor.confirmed);if(contractor.tradesId!==undefined){contractor.tradesId.forEach(function(id){return contractorData.append('contractor[trade_ids][]',id);});}if(contractor.serviceAreasId!==undefined){contractor.serviceAreasId.forEach(function(id){return contractorData.append('contractor[service_area_ids][]',id);});}if(contractor.unionsId!==undefined){contractor.unionsId.forEach(function(id){return contractorData.append('contractor[union_ids][]',id);});}if(contractor.w9Document.document!==''){contractorData.append('contractor[w9_document_attributes][document]',contractor.w9Document.document);}else if(contractor.w9Document.id&&contractor.w9Document.url===''){contractorData.append('contractor[w9_document_attributes][id]',contractor.w9Document.id);contractorData.append('contractor[w9_document_attributes][_destroy]',true);}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/contractors/'+contractorId+'?send_invite='+(sendInvitation!==undefined?sendInvitation:false),contractorData,{headers:{'Content-Type':'multipart/form-data'}}).then(function(response){return{ok:true,contractor:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'searchContractors',value:function searchContractors(filter,tradeIds,unionIds,csiCodeId,page){var tradeFilter='';if(tradeIds!==undefined&&(typeof tradeIds==='undefined'?'undefined':_typeof(tradeIds))==='object'&&tradeIds.length>0){// ?by_trades[]=2&by_trades[]=7
tradeFilter=tradeIds.reduce(function(accumulator,currentValue,currentIndex){return accumulator+(currentIndex===0?'&by_trades[]='+currentValue:'&by_trades[]='+currentValue);},'');}if(unionIds!==undefined&&unionIds.length>0){tradeFilter=unionIds.reduce(function(accumulator,currentValue){return accumulator+'&by_unions[]='+currentValue;},tradeFilter);}if(csiCodeId){tradeFilter+='&by_csi_code='+csiCodeId;}var pageFilter=page?'&page='+page:'';return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/contractors?by_name='+filter+tradeFilter+pageFilter,{loadingDisabled:true}).then(function(response){return{ok:true,contractors:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getUsers',value:function getUsers(contractorId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/contractors/'+contractorId+'/users').then(function(response){return{ok:true,users:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'addQuoteRequest',value:function addQuoteRequest(workOrderId,taskIds,contractorId,bidDueDate){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/contractors/'+contractorId+'/quotes',{contractor:{bid_due_date:bidDueDate,work_order_id:workOrderId,task_ids:taskIds}}).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getInvoices',value:function getInvoices(contractorId){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/contractors/'+contractorId+'/contractor_invoices?page='+page).then(function(response){return{ok:true,contractorInvoices:{content:response.data,pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value(),total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getMsaSigningUrl',value:function getMsaSigningUrl(contractorId,redirectUrl){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/contractors/'+contractorId+'/msa_signing_url?redirect_url='+redirectUrl).then(function(response){return{ok:true,data:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'inviteUser',value:function inviteUser(contractorId,userInvitation){var user={first_name:userInvitation.firstName,last_name:userInvitation.lastName,email:userInvitation.email,role_ids:[userInvitation.roleId]};if(userInvitation.phoneNumber!==''){user['phone_number']=userInvitation.phoneNumber;}if(userInvitation.title!==''){user['title']=userInvitation.title;}var params={user:user};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/contractors/'+contractorId+'/invite_user',params).then(function(response){return{ok:true,user:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return ContractorsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var contractorsApi=new ContractorsApi();/* harmony default export */ __webpack_exports__["b"] = (ContractorsApi=new ContractorsApi());

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__merge__ = __webpack_require__(374);



function compose() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  var fn = function fn(props) {
    return styles.reduce(function (acc, style) {
      var output = style(props);

      if (output) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__merge__["a" /* default */])(acc, output);
      }

      return acc;
    }, {});
  }; // Alternative approach that doesn't yield any performance gain.
  // const handlers = styles.reduce((acc, style) => {
  //   style.filterProps.forEach(prop => {
  //     acc[prop] = style;
  //   });
  //   return acc;
  // }, {});
  // const fn = props => {
  //   return Object.keys(props).reduce((acc, prop) => {
  //     if (handlers[prop]) {
  //       return merge(acc, handlers[prop](props));
  //     }
  //     return acc;
  //   }, {});
  // };


  fn.propTypes =  false ? styles.reduce(function (acc, style) {
    return _extends(acc, style.propTypes);
  }, {}) : {};
  fn.filterProps = styles.reduce(function (acc, style) {
    return acc.concat(style.filterProps);
  }, []);
  return fn;
}

/* harmony default export */ __webpack_exports__["a"] = (compose);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WorkOrder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_utils_work_order_status_enum__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function getProposalAttribute(workOrder,attribute){var element=workOrder.waiting_proposal||workOrder.approved_proposal;if(element!==null){if(element[attribute]!==null&&element[attribute]!==undefined){return element[attribute];}}return null;}var WorkOrder=function(){function WorkOrder(){_classCallCheck(this,WorkOrder);}_createClass(WorkOrder,null,[{key:'getCompletionDate',value:function getCompletionDate(){var workOrder=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;if(workOrder===null){return null;}var endDate=getProposalAttribute(workOrder,'completion_date');if(endDate!==null){var scheduleEndDate=workOrder.schedule_end_date?__WEBPACK_IMPORTED_MODULE_1_moment___default()(workOrder.schedule_end_date).subtract(1,'day').format('YYYY-MM-DD'):null;endDate=scheduleEndDate||workOrder.completed_at||endDate;}return endDate;}},{key:'getJobNumber',value:function getJobNumber(workOrder){var defaultValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return workOrder.work_order_job!==null&&workOrder.work_order_job!==undefined?workOrder.work_order_job.number:defaultValue;}},{key:'getName',value:function getName(workOrder){var defaultValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return workOrder.name!==null?workOrder.name:defaultValue;}},{key:'getStartDate',value:function getStartDate(){var workOrder=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;if(workOrder===null){return null;}var startDate=getProposalAttribute(workOrder,'start_date');if(startDate!==null){startDate=workOrder.schedule_start_date||workOrder.started_at||startDate;}return startDate;}},{key:'getTotalCost',value:function getTotalCost(workOrder){if(workOrder===null){return null;}return workOrder.cost?workOrder.cost:getProposalAttribute(workOrder,'cost');}/**
   * Returns true if the given work order is currently or has already fulfilled the given status.
   * @param workOrder
   * @param status
   */},{key:'isStatusFulFilled',value:function isStatusFulFilled(workOrder){var status=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';if(__WEBPACK_IMPORTED_MODULE_0_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */][status.toUpperCase()]===undefined){return false;}// Dont take into account DECLINED and UNKNOWN status
var filteredKeys=Object.keys(__WEBPACK_IMPORTED_MODULE_0_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */]).filter(function(key){return __WEBPACK_IMPORTED_MODULE_0_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */][key]!==__WEBPACK_IMPORTED_MODULE_0_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].DECLINED&&__WEBPACK_IMPORTED_MODULE_0_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */][key]!==__WEBPACK_IMPORTED_MODULE_0_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].UNKNOWN;});var woIndex=filteredKeys.indexOf(workOrder.status.toUpperCase());var givenIndex=filteredKeys.indexOf(status.toUpperCase());if(woIndex!==-1&&givenIndex!==-1){return woIndex>=givenIndex;}return false;}},{key:'getVariance',value:function getVariance(workOrder){var defaultValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var variance=void 0;if(workOrder.variance){variance=workOrder.variance+'%';}else{var proposal=workOrder.waiting_proposal||workOrder.approved_proposal||workOrder.budget;variance=proposal!==undefined&&proposal!==null&&proposal.variance!==null?proposal.variance+'%':defaultValue;}return variance;}},{key:'hasPurchaseOrder',value:function hasPurchaseOrder(workOrder){return workOrder.purchase_order!==null&&workOrder.purchase_order_doc!==null;}}]);return WorkOrder;}();

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NOTIFICATIONS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NOTIFICATIONS_CURRENT_PAGE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NOTIFICATIONS_SHOW_LOADER_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NOTIFICATIONS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NOTIFICATIONS_TOTAL_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return NOTIFICATIONS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NOTIFICATIONS_UNREAD_TOTAL_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NOTIFICATIONS_NOTIFICATION_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NOTIFICATIONS_CHAT_UPDATE; });
/* harmony export (immutable) */ __webpack_exports__["j"] = addUnreadMessage;
/* harmony export (immutable) */ __webpack_exports__["k"] = loadNotificationsRequest;
/* harmony export (immutable) */ __webpack_exports__["l"] = markAllAsRead;
/* harmony export (immutable) */ __webpack_exports__["m"] = markAsRead;
/* harmony export (immutable) */ __webpack_exports__["n"] = markAsUnread;
/* harmony export (immutable) */ __webpack_exports__["p"] = setCurrentPage;
/* unused harmony export setNotifications */
/* harmony export (immutable) */ __webpack_exports__["q"] = setShowLoader;
/* unused harmony export updateNotification */
/* unused harmony export updateNotifications */
/* unused harmony export updateUnreadTotal */
/* harmony export (immutable) */ __webpack_exports__["o"] = markNotifiableNotificationsAsRead;
/* unused harmony export updateNotificationsChat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_notifications_api__ = __webpack_require__(800);
var NOTIFICATIONS_ADD='NOTIFICATIONS_ADD';var NOTIFICATIONS_CURRENT_PAGE_SET='NOTIFICATIONS_CURRENT_PAGE_SET';var NOTIFICATIONS_SHOW_LOADER_SET='NOTIFICATIONS_SHOW_LOADER_SET';var NOTIFICATIONS_SET='NOTIFICATIONS_SET';var NOTIFICATIONS_TOTAL_UPDATE='NOTIFICATIONS_TOTAL_UPDATE';var NOTIFICATIONS_UPDATE='NOTIFICATIONS_UPDATE';var NOTIFICATIONS_UNREAD_TOTAL_UPDATE='NOTIFICATIONS_UNREAD_TOTAL_UPDATE';var NOTIFICATIONS_NOTIFICATION_UPDATE='NOTIFICATIONS_NOTIFICATION_UPDATE';var NOTIFICATIONS_CHAT_UPDATE='NOTIFICATIONS_CHAT_UPDATE';function addUnreadMessage(message,total,totalUnread){return function(dispatch){dispatch({type:NOTIFICATIONS_ADD,payload:message});dispatch({type:NOTIFICATIONS_TOTAL_UPDATE,payload:total+1});dispatch(updateUnreadTotal(totalUnread+1));};}function loadNotificationsRequest(page){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__services_api_notifications_api__["a" /* notificationsApi */].getNotifications(page).then(function(response){if(response.ok){dispatch(setNotifications(response.notifications));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function markAllAsRead(workOrderId,notifiableId,notifiableType){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__services_api_notifications_api__["a" /* notificationsApi */].markAllAsRead(workOrderId,notifiableId,notifiableType).then(function(response){if(response.ok){// Mark all returns all notifications
dispatch(setNotifications(response.notifications));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function markAsRead(messageId,totalUnread){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__services_api_notifications_api__["a" /* notificationsApi */].markAsRead(messageId).then(function(response){if(response.ok){dispatch(updateNotification(response.notification));dispatch(updateUnreadTotal(totalUnread-1));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function markAsUnread(messageId,totalUnread){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__services_api_notifications_api__["a" /* notificationsApi */].markAsUnread(messageId).then(function(response){if(response.ok){dispatch(updateNotification(response.notification));dispatch(updateUnreadTotal(totalUnread+1));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setCurrentPage(page){return{type:NOTIFICATIONS_CURRENT_PAGE_SET,payload:page};}function setNotifications(notifications){return{type:NOTIFICATIONS_SET,payload:notifications};}function setShowLoader(value){return{type:NOTIFICATIONS_SHOW_LOADER_SET,payload:value};}function updateNotification(notification){return{type:NOTIFICATIONS_NOTIFICATION_UPDATE,payload:notification};}function updateNotifications(notifications){return{type:NOTIFICATIONS_UPDATE,payload:notifications};}function updateUnreadTotal(value){return{type:NOTIFICATIONS_UNREAD_TOTAL_UPDATE,payload:value};}function markNotifiableNotificationsAsRead(notifiableId,notifiableType){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__services_api_notifications_api__["a" /* notificationsApi */].markAllAsRead(undefined,notifiableId,notifiableType).then(function(response){if(response.ok){// Mark all returns all notifications
dispatch(updateNotifications(response.notifications.content));dispatch(updateNotificationsChat(notifiableId,notifiableType));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateNotificationsChat(id,type){return{type:NOTIFICATIONS_CHAT_UPDATE,payload:{id:id,type:type}};}

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLIENT_TEAM_BUILDINGS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLIENT_TEAM_CLIENT_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLIENT_TEAM_CLIENT_FORM_INVALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLIENT_TEAM_CLIENT_FORM_VALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLIENT_TEAM_CLIENT_FORM_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLIENT_TEAM_EDIT_FORM_LOAD_FROM_CURRENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CLIENT_TEAM_INVITE_USER_FORM_LOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CLIENT_TEAM_INVITE_USER_FORM_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CLIENT_TEAM_INVITE_USER_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CLIENT_TEAM_INVITE_USER_ID_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CLIENT_TEAM_USERS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CLIENT_TEAM_USERS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CLIENT_TEAM_USERS_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CLIENT_TEAM_USERS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CLIENT_TEAM_ROLES_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CONTRACTOR_TEAM_INVITE_USER_FORM_INVALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CONTRACTOR_TEAM_INVITE_USER_FORM_LOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CONTRACTOR_TEAM_INVITE_USER_FORM_VALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CONTRACTOR_TEAM_INVITE_USER_FORM_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CONTRACTOR_TEAM_INVITE_USER_ID_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CONTRACTOR_TEAM_INVITE_USER_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CONTRACTOR_TEAM_ROLES_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CONTRACTOR_TEAM_USERS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CONTRACTOR_TEAM_USERS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CONTRACTOR_TEAM_USERS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CONTRACTOR_TEAM_USERS_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CONTACTOR_TEAM_CURRENT_PAGE_TECHNICIANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CONTACTOR_TEAM_PER_PAGE_TECHNICIANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CONTACTOR_TEAM_TOTAL_TECHNICIANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CONTACTOR_TEAM_SET_ACTIVE_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_INVALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_LOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_VALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return GENERAL_CONTRACTOR_TEAM_INVITE_USER_ID_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return GENERAL_CONTRACTOR_TEAM_INVITE_USER_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return GENERAL_CONTRACTOR_TEAM_ROLES_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return GENERAL_CONTRACTOR_TEAM_USERS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return GENERAL_CONTRACTOR_TEAM_USERS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return GENERAL_CONTRACTOR_TEAM_USERS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return GENERAL_CONTRACTOR_TEAM_USERS_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CONTRACTOR_TEAM_TECHNICIANS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CONTRACTOR_TEAM_TECHNICIANS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CONTRACTOR_TEAM_INVITE_TECHNICIAN_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CONTRACTOR_TEAM_INVITE_TECHNICIAN_ID_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CONTRACTOR_TEAM_TECHNICIANS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CONTRACTOR_TEAM_TECHNICIANS_REMOVE; });
var CLIENT_TEAM_BUILDINGS_LOAD_SUCCESS='CLIENT_TEAM_BUILDINGS_LOAD_SUCCESS';var CLIENT_TEAM_CLIENT_LOAD_SUCCESS='CLIENT_TEAM_CLIENT_LOAD_SUCCESS';var CLIENT_TEAM_CLIENT_FORM_INVALID='CLIENT_TEAM_CLIENT_FORM_INVALID';var CLIENT_TEAM_CLIENT_FORM_VALID='CLIENT_TEAM_CLIENT_FORM_VALID';var CLIENT_TEAM_CLIENT_FORM_VALUE_UPDATE='CLIENT_TEAM_CLIENT_FORM_VALUE_UPDATE';var CLIENT_TEAM_EDIT_FORM_LOAD_FROM_CURRENT='CLIENT_TEAM_EDIT_FORM_LOAD_FROM_CURRENT';var CLIENT_TEAM_INVITE_USER_FORM_LOAD='CLIENT_TEAM_INVITE_USER_FORM_LOAD';var CLIENT_TEAM_INVITE_USER_FORM_VALUE_UPDATE='CLIENT_TEAM_INVITE_USER_FORM_VALUE_UPDATE';var CLIENT_TEAM_INVITE_USER_MODAL_SHOW='CLIENT_TEAM_INVITE_USER_MODAL_SHOW';var CLIENT_TEAM_INVITE_USER_ID_SET='CLIENT_TEAM_INVITE_USER_ID_SET';var CLIENT_TEAM_USERS_ADD='CLIENT_TEAM_USERS_ADD';var CLIENT_TEAM_USERS_EDIT='CLIENT_TEAM_USERS_EDIT';var CLIENT_TEAM_USERS_REMOVE='CLIENT__TEAM_USERS_REMOVE';var CLIENT_TEAM_USERS_LOAD_SUCCESS='CLIENT_TEAM_USERS_LOAD_SUCCESS';var CLIENT_TEAM_ROLES_LOAD_SUCCESS='CLIENT_TEAM_ROLES_LOAD_SUCCESS';var CONTRACTOR_TEAM_INVITE_USER_FORM_INVALID='CONTRACTOR_TEAM_INVITE_USER_FORM_INVALID';var CONTRACTOR_TEAM_INVITE_USER_FORM_LOAD='CONTRACTOR_TEAM_INVITE_USER_FORM_LOAD';var CONTRACTOR_TEAM_INVITE_USER_FORM_VALID='CONTRACTOR_TEAM_INVITE_USER_FORM_VALID';var CONTRACTOR_TEAM_INVITE_USER_FORM_VALUE_UPDATE='CONTRACTOR_TEAM_INVITE_USER_FORM_VALUE_UPDATE';var CONTRACTOR_TEAM_INVITE_USER_ID_SET='CONTRACTOR_TEAM_INVITE_USER_ID_SET';var CONTRACTOR_TEAM_INVITE_USER_MODAL_SHOW='CONTRACTOR_TEAM_INVITE_USER_MODAL_SHOW';var CONTRACTOR_TEAM_ROLES_LOAD_SUCCESS='CONTRACTOR_TEAM_ROLES_LOAD_SUCCESS';var CONTRACTOR_TEAM_USERS_ADD='CONTRACTOR_TEAM_USERS_ADD';var CONTRACTOR_TEAM_USERS_EDIT='CONTRACTOR_TEAM_USERS_EDIT';var CONTRACTOR_TEAM_USERS_LOAD_SUCCESS='CONTRACTOR_TEAM_USERS_LOAD_SUCCESS';var CONTRACTOR_TEAM_USERS_REMOVE='CONTRACTOR_TEAM_USERS_REMOVE';var CONTACTOR_TEAM_CURRENT_PAGE_TECHNICIANS='CONTACTOR_TEAM_CURRENT_PAGE_TECHNICIANS';var CONTACTOR_TEAM_PER_PAGE_TECHNICIANS='CONTACTOR_TEAM_PER_PAGE_TECHNICIANS';var CONTACTOR_TEAM_TOTAL_TECHNICIANS='CONTACTOR_TEAM_TOTAL_TECHNICIANS';var CONTACTOR_TEAM_SET_ACTIVE_TAB='CONTACTOR_TEAM_SET_ACTIVE_TAB';var GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_INVALID='GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_INVALID';var GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_LOAD='GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_LOAD';var GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_VALID='GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_VALID';var GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_VALUE_UPDATE='GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_VALUE_UPDATE';var GENERAL_CONTRACTOR_TEAM_INVITE_USER_ID_SET='GENERAL_CONTRACTOR_TEAM_INVITE_USER_ID_SET';var GENERAL_CONTRACTOR_TEAM_INVITE_USER_MODAL_SHOW='GENERAL_CONTRACTOR_TEAM_INVITE_USER_MODAL_SHOW';var GENERAL_CONTRACTOR_TEAM_ROLES_LOAD_SUCCESS='GENERAL_CONTRACTOR_TEAM_ROLES_LOAD_SUCCESS';var GENERAL_CONTRACTOR_TEAM_USERS_ADD='GENERAL_CONTRACTOR_TEAM_USERS_ADD';var GENERAL_CONTRACTOR_TEAM_USERS_EDIT='GENERAL_CONTRACTOR_TEAM_USERS_EDIT';var GENERAL_CONTRACTOR_TEAM_USERS_LOAD_SUCCESS='GENERAL_CONTRACTOR_TEAM_USERS_LOAD_SUCCESS';var GENERAL_CONTRACTOR_TEAM_USERS_REMOVE='GENERAL_CONTRACTOR_TEAM_USERS_REMOVE';var CONTRACTOR_TEAM_TECHNICIANS_LOAD_SUCCESS='CONTRACTOR_TEAM_TECHNICIANS_LOAD_SUCCESS';var CONTRACTOR_TEAM_TECHNICIANS_ADD='CONTRACTOR_TEAM_TECHNICIANS_ADD';var CONTRACTOR_TEAM_INVITE_TECHNICIAN_MODAL_SHOW='CONTRACTOR_TEAM_INVITE_TECHNICIAN_MODAL_SHOW';var CONTRACTOR_TEAM_INVITE_TECHNICIAN_ID_SET='CONTRACTOR_TEAM_INVITE_TECHNICIAN_ID_SET';var CONTRACTOR_TEAM_TECHNICIANS_EDIT='CONTRACTOR_TEAM_TECHNICIANS_EDIT';var CONTRACTOR_TEAM_TECHNICIANS_REMOVE='CONTRACTOR_TEAM_TECHNICIANS_REMOVE';

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(59)) {
  var LIBRARY = __webpack_require__(192);
  var global = __webpack_require__(41);
  var fails = __webpack_require__(43);
  var $export = __webpack_require__(4);
  var $typed = __webpack_require__(399);
  var $buffer = __webpack_require__(555);
  var ctx = __webpack_require__(137);
  var anInstance = __webpack_require__(215);
  var propertyDesc = __webpack_require__(210);
  var hide = __webpack_require__(110);
  var redefineAll = __webpack_require__(214);
  var toInteger = __webpack_require__(136);
  var toLength = __webpack_require__(55);
  var toIndex = __webpack_require__(871);
  var toAbsoluteIndex = __webpack_require__(213);
  var toPrimitive = __webpack_require__(149);
  var has = __webpack_require__(117);
  var classof = __webpack_require__(238);
  var isObject = __webpack_require__(48);
  var toObject = __webpack_require__(71);
  var isArrayIter = __webpack_require__(456);
  var create = __webpack_require__(211);
  var getPrototypeOf = __webpack_require__(119);
  var gOPN = __webpack_require__(229).f;
  var getIterFn = __webpack_require__(457);
  var uid = __webpack_require__(209);
  var wks = __webpack_require__(54);
  var createArrayMethod = __webpack_require__(158);
  var createArrayIncludes = __webpack_require__(343);
  var speciesConstructor = __webpack_require__(312);
  var ArrayIterators = __webpack_require__(454);
  var Iterators = __webpack_require__(239);
  var $iterDetect = __webpack_require__(345);
  var setSpecies = __webpack_require__(217);
  var arrayFill = __webpack_require__(549);
  var arrayCopyWithin = __webpack_require__(864);
  var $DP = __webpack_require__(70);
  var $GOPD = __webpack_require__(120);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(455);
var $export = __webpack_require__(4);
var shared = __webpack_require__(289)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(869))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PermissionsUtil; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__ = __webpack_require__(9);
function adminUserCanSeeMoney(user){return __WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].hasRole(user,__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].hasRole(user,__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["e" /* ROLES */].BUSINESS_DEVELOPMENT);}function contractorUserCanSeeMoney(user){return __WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].hasType(user,__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["f" /* TYPES */].CONTRACTOR)&&(__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].hasRole(user,__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["e" /* ROLES */].OWNER)||__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].hasRole(user,__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["e" /* ROLES */].CONTRACTOR_PROJECT_MANAGER));}function hasPermissionTeamPage(user){return!!user.accountable_type;}function canCreateBuilding(user){var result=false;if(__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].isAdmin(user)||__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].hasType(user,__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR)){result=true;}else if(__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].hasType(user,__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["f" /* TYPES */].CLIENT)){result=user.roles.filter(function(role){return role.name!==__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["e" /* ROLES */].CLIENT_BUILDING_MANAGER;}).length>0;}return result;}function showPurchaseOrders(user){return __WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].hasType(user,__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["f" /* TYPES */].CLIENT)&&user.accountable&&user.accountable.global_po_required;}function showSurveys(user){return __WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].hasRole(user,__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].hasType(user,__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["f" /* TYPES */].CLIENT)&&__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].hasRole(user,__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["e" /* ROLES */].OWNER)||__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].hasType(user,__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);}var PermissionsUtil={adminUserCanSeeMoney:adminUserCanSeeMoney,contractorUserCanSeeMoney:contractorUserCanSeeMoney,canCreateBuilding:canCreateBuilding,hasPermissionTeamPage:hasPermissionTeamPage,showPurchaseOrders:showPurchaseOrders,showSurveys:showSurveys};

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = loadChangeOrdersRequest;
/* unused harmony export loadChangeOrdersSuccess */
/* harmony export (immutable) */ __webpack_exports__["e"] = closeChangeOrderModal;
/* unused harmony export setShowChangeOrderModal */
/* harmony export (immutable) */ __webpack_exports__["t"] = showChangeOrderModal;
/* unused harmony export addChangeOrder */
/* unused harmony export updateChangeOrder */
/* harmony export (immutable) */ __webpack_exports__["v"] = updateCOStartDate;
/* harmony export (immutable) */ __webpack_exports__["u"] = updateCOCompletionDate;
/* harmony export (immutable) */ __webpack_exports__["w"] = updateCOValue;
/* harmony export (immutable) */ __webpack_exports__["c"] = back;
/* harmony export (immutable) */ __webpack_exports__["h"] = continueRequest;
/* unused harmony export continueSuccess */
/* harmony export (immutable) */ __webpack_exports__["l"] = next;
/* harmony export (immutable) */ __webpack_exports__["d"] = closeChangeOrderApprovalModal;
/* harmony export (immutable) */ __webpack_exports__["o"] = selectChangeOrder;
/* unused harmony export openSuccessModal */
/* harmony export (immutable) */ __webpack_exports__["g"] = closeSuccessModal;
/* harmony export (immutable) */ __webpack_exports__["b"] = approveChangeOrderRequest;
/* harmony export (immutable) */ __webpack_exports__["m"] = printChangeOrder;
/* unused harmony export printChangeOrderSuccess */
/* harmony export (immutable) */ __webpack_exports__["f"] = closePdfViewer;
/* harmony export (immutable) */ __webpack_exports__["s"] = setShowEmailModal;
/* harmony export (immutable) */ __webpack_exports__["k"] = loadEmailChangeOrderDataRequest;
/* unused harmony export loadUsersSuccess */
/* harmony export (immutable) */ __webpack_exports__["i"] = initializeEmailValues;
/* harmony export (immutable) */ __webpack_exports__["r"] = setChangeOrderSubject;
/* harmony export (immutable) */ __webpack_exports__["q"] = setChangeOrderMessage;
/* unused harmony export createChangeOrderSubject */
/* unused harmony export createChangeOrderMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = addEmail;
/* unused harmony export clearEmails */
/* harmony export (immutable) */ __webpack_exports__["n"] = removeEmail;
/* harmony export (immutable) */ __webpack_exports__["p"] = sendEmail;
/* harmony export (immutable) */ __webpack_exports__["x"] = withdrawChangeOrderRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_change_orders_api__ = __webpack_require__(2171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_utils_proposal_util__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_api_clients_api__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_numeral__);
function loadChangeOrdersRequest(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_change_orders_api__["a" /* changeOrdersApi */].getChangeOrders(workOrderId).then(function(response){if(response.ok){dispatch(loadChangeOrdersSuccess(response.changeOrders));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadChangeOrdersSuccess(changeOrders){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["b" /* CHANGE_ORDERS_LOAD_SUCCESS */],payload:changeOrders};}function closeChangeOrderModal(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["n" /* CHANGE_ORDER_MODAL_CLOSE */]};}function setShowChangeOrderModal(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["o" /* CHANGE_ORDER_MODAL_SHOW */]};}function showChangeOrderModal(quotesSelectedByTaskId,changeOrderTasks){return function(dispatch){var startDates=[];var completionDates=[];Object.values(quotesSelectedByTaskId).forEach(function(changeOrderTaskId){var changeOrderTask=changeOrderTasks.find(function(cot){return cot.id===changeOrderTaskId;});var changeOrderQuote=changeOrderTask.change_order_quote;var changeOrderQuoteTotal=__WEBPACK_IMPORTED_MODULE_8_numeral___default()(changeOrderQuote.estimate).value()+__WEBPACK_IMPORTED_MODULE_8_numeral___default()(changeOrderQuote.value).value();var markup=Math.round(Object(__WEBPACK_IMPORTED_MODULE_3_services_utils_proposal_util__["c" /* calculateMarkup */])(changeOrderQuoteTotal));var fee=Math.round(Object(__WEBPACK_IMPORTED_MODULE_3_services_utils_proposal_util__["a" /* calculateFee */])(changeOrderQuoteTotal));var insurance=Math.round(Object(__WEBPACK_IMPORTED_MODULE_3_services_utils_proposal_util__["b" /* calculateInsurace */])(changeOrderQuoteTotal));dispatch(updateCOValue(changeOrderTaskId,'markup',markup));dispatch(updateCOValue(changeOrderTaskId,'fee',fee));dispatch(updateCOValue(changeOrderTaskId,'insurance',insurance));startDates.push(changeOrderQuote.start_date);completionDates.push(changeOrderQuote.end_date);});dispatch(updateCOStartDate(Object(__WEBPACK_IMPORTED_MODULE_4_services_utils_date_util__["c" /* getFirstDate */])(startDates)));dispatch(updateCOCompletionDate(Object(__WEBPACK_IMPORTED_MODULE_4_services_utils_date_util__["d" /* getLastDate */])(completionDates)));dispatch(setShowChangeOrderModal());};}function addChangeOrder(changeOrder){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["a" /* CHANGE_ORDERS_ADD */],payload:changeOrder};}function updateChangeOrder(changeOrder){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["c" /* CHANGE_ORDERS_UPDATE */],payload:changeOrder};}function updateCOStartDate(value){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["s" /* CHANGE_ORDER_START_DATE_UPDATE */],payload:value};}function updateCOCompletionDate(value){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["g" /* CHANGE_ORDER_COMPLETION_DATE_UPDATE */],payload:value};}function updateCOValue(quoteId,valueKey,value){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["x" /* CHANGE_ORDER_VALUES_UPDATE */],payload:{quoteId:quoteId,key:valueKey,value:value}};}function back(view){var previousActions={review:'form'};return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["f" /* CHANGE_ORDER_BACK */],payload:previousActions[view]};}function continueRequest(currentWorkOrderId,startDate,completionDate,valuesByQuoteId,qualifications,selectedQualificationsById){return function(dispatch){var addedValues=Object.entries(valuesByQuoteId).map(function(element){var values=element[1];return{change_order_task_id:element[0],fee:values['fee'],insurance:values['insurance'],markup:values['markup']};});var selectedQualifications=qualifications.filter(function(q){return selectedQualificationsById[q.id];}).map(function(q){var value=selectedQualificationsById[q.id];return{qualification_id:value.id,option:value.option!==null?value.option.label:null};});return __WEBPACK_IMPORTED_MODULE_2_services_api_change_orders_api__["a" /* changeOrdersApi */].createChangeOrder(currentWorkOrderId,startDate,completionDate,addedValues,selectedQualifications).then(function(response){if(response.ok){dispatch(continueSuccess());dispatch(addChangeOrder(response.changeOrder));dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_details__["u" /* detailsAddChangeOrder */])());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function continueSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["h" /* CHANGE_ORDER_CREATE_SUCCESS */]};}function next(view){var nextActions={form:'review',review:'thank-you'};return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["p" /* CHANGE_ORDER_NEXT */],payload:nextActions[view]};}function closeChangeOrderApprovalModal(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["d" /* CHANGE_ORDER_APPROVAL_MODAL_CLOSE */]};}function selectChangeOrder(changeOrder){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["e" /* CHANGE_ORDER_APPROVAL_SELECT */],payload:changeOrder};}function openSuccessModal(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["v" /* CHANGE_ORDER_SUCCESS_MODAL_OPEN */]};}function closeSuccessModal(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["u" /* CHANGE_ORDER_SUCCESS_MODAL_CLOSE */]};}function approveChangeOrderRequest(selectedChangeOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_change_orders_api__["a" /* changeOrdersApi */].approveChangeOrder(selectedChangeOrderId).then(function(response){if(response.ok){dispatch(updateChangeOrder(response.changeOrder));dispatch(openSuccessModal());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function printChangeOrder(changeOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_change_orders_api__["a" /* changeOrdersApi */].getAsPdf(changeOrderId).then(function(response){if(response.ok){dispatch(printChangeOrderSuccess(response.pdf));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function printChangeOrderSuccess(pdf){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["r" /* CHANGE_ORDER_PRINT_SUCCESS */],payload:pdf};}function closePdfViewer(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["q" /* CHANGE_ORDER_PDF_VIEWER_CLOSE */]};}function setShowEmailModal(value){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["k" /* CHANGE_ORDER_EMAIL_MODAL_SHOW_SET */],payload:value};}function loadEmailChangeOrderDataRequest(changeOrderNumber,workOrderNumber,workOrderName,buildingLocation,clientId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_7_services_api_clients_api__["a" /* clientsApi */].getUsers(clientId).then(function(response){if(response.ok){dispatch(loadUsersSuccess(response.users));dispatch(initializeEmailValues(changeOrderNumber,workOrderNumber,workOrderName,buildingLocation,response.users));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadUsersSuccess(users){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["w" /* CHANGE_ORDER_USERS_LOAD_SUCCESS */],payload:users};}function initializeEmailValues(changeOrderNumber,workOrderNumber,workOrderName,buildingLocation,users){return function(dispatch){// Create and dispatch generated subject and message
dispatch(setChangeOrderSubject(createChangeOrderSubject(workOrderNumber,workOrderName)));dispatch(setChangeOrderMessage(createChangeOrderMessage(changeOrderNumber,workOrderNumber,buildingLocation)));// Clear emails
dispatch(clearEmails());// Add client owner by default
var owner=users.find(function(user){return __WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__["g" /* usersUtil */].hasRole(user,__WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__["e" /* ROLES */].OWNER);});if(owner!==undefined){dispatch(addEmail(owner.email));}};}function setChangeOrderSubject(subject){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["t" /* CHANGE_ORDER_SUBJECT_SET */],payload:subject};}function setChangeOrderMessage(message){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["m" /* CHANGE_ORDER_MESSAGE_SET */],payload:message};}function createChangeOrderSubject(workOrderNumber){var workOrderName=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var prefix='Spackle Change Order for WO #'+workOrderNumber;if(workOrderName!==null&&workOrderName!==''){return prefix+' - '+workOrderName;}else{return prefix;}}function createChangeOrderMessage(changeOrderNumber,workOrderNumber){var buildingLocation=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var location='';if(buildingLocation!==null){location=' at '+buildingLocation.street_address_1+', '+buildingLocation.city+' '+buildingLocation.state;}return'Please find the attached change order #'+changeOrderNumber+' for WO #'+workOrderNumber+location+'. If you have any questions, please reach out via chat or email.\n\nThank you';}function addEmail(email){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["i" /* CHANGE_ORDER_EMAIL_ADD */],payload:email};}function clearEmails(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["j" /* CHANGE_ORDER_EMAIL_CLEAR */]};}function removeEmail(email){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["l" /* CHANGE_ORDER_EMAIL_REMOVE */],payload:email};}function sendEmail(changeOrderId,emails,subject,message){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_change_orders_api__["a" /* changeOrdersApi */].sendEmail(changeOrderId,emails,subject,message).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function withdrawChangeOrderRequest(changeOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_change_orders_api__["a" /* changeOrdersApi */].withdrawChangeOrder(changeOrderId).then(function(response){if(response.ok){dispatch(updateChangeOrder(response.changeOrder));dispatch(closeChangeOrderApprovalModal());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContractorStatus_css__ = __webpack_require__(2199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContractorStatus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ContractorStatus_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorStatus=function(_Component){_inherits(ContractorStatus,_Component);function ContractorStatus(){_classCallCheck(this,ContractorStatus);return _possibleConstructorReturn(this,(ContractorStatus.__proto__||Object.getPrototypeOf(ContractorStatus)).apply(this,arguments));}_createClass(ContractorStatus,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_1__services_utils_text_util__["e" /* toUpperFirstLetter */])(this.props.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contractor-status '+this.props.status}));}}]);return ContractorStatus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ContractorStatus.propTypes={status:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ContractorStatus);

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/remove.f13bf232.svg";

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailsInfo_css__ = __webpack_require__(2293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailsInfo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DetailsInfo_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome_free_solid_faAngleDown__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome_free_solid_faAngleDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome_free_solid_faAngleDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faAngleUp__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faAngleUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faAngleUp__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsInfo=function(_Component){_inherits(DetailsInfo,_Component);function DetailsInfo(props){_classCallCheck(this,DetailsInfo);var _this=_possibleConstructorReturn(this,(DetailsInfo.__proto__||Object.getPrototypeOf(DetailsInfo)).call(this,props));_this.handleClickDetails=function(event){event.preventDefault();event.stopPropagation();_this.setState({showDetails:!_this.state.showDetails});};_this.state={showDetails:true};return _this;}_createClass(DetailsInfo,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h4',onClick:this.handleClickDetails},'DETAILS',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome__["a" /* default */],{icon:this.state.showDetails?__WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome_free_solid_faAngleDown___default.a:__WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faAngleUp___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Collapse */],{'in':this.state.showDetails,className:'collapse-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:this.props.itemsContainerSize,className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-info-items'},this.props.itemsLines.map(function(itemLine,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},itemLine.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},item);}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:this.props.rightContainerSize,className:'column'},this.props.rightContainer),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}))));}}]);return DetailsInfo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DetailsInfo.propTypes={itemsLines:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object)).isRequired,itemsContainerSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,rightContainer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,rightContainerSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};DetailsInfo.defaultProps={itemsContainerSize:8,rightContainerSize:4};/* harmony default export */ __webpack_exports__["a"] = (DetailsInfo);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export baseRoutePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContactorTeamTabs; });
/* unused harmony export addUser */
/* unused harmony export addTechnician */
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteTechnicianRequest;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteUserRequest;
/* unused harmony export editUser */
/* unused harmony export editTechnician */
/* harmony export (immutable) */ __webpack_exports__["d"] = goToEditContractor;
/* harmony export (immutable) */ __webpack_exports__["e"] = goToTeam;
/* unused harmony export invalidForm */
/* harmony export (immutable) */ __webpack_exports__["f"] = loadRolesRequest;
/* unused harmony export loadRolesSuccess */
/* harmony export (immutable) */ __webpack_exports__["g"] = loadTechnicianFormRequest;
/* harmony export (immutable) */ __webpack_exports__["i"] = loadUserFormRequest;
/* unused harmony export loadUserForm */
/* harmony export (immutable) */ __webpack_exports__["k"] = setCurrentPageTechnicians;
/* unused harmony export setPerPageTechnicians */
/* unused harmony export setTotalTechnicians */
/* unused harmony export setActiveTab */
/* harmony export (immutable) */ __webpack_exports__["j"] = loadUsersRequest;
/* harmony export (immutable) */ __webpack_exports__["h"] = loadTechnicianRequest;
/* unused harmony export loadUsersSuccess */
/* unused harmony export loadTechniciansSuccess */
/* unused harmony export removeUser */
/* unused harmony export removeTechnician */
/* harmony export (immutable) */ __webpack_exports__["m"] = setCurrentUserId;
/* harmony export (immutable) */ __webpack_exports__["l"] = setCurrentTechnicianId;
/* harmony export (immutable) */ __webpack_exports__["o"] = setShowInviteUserModal;
/* harmony export (immutable) */ __webpack_exports__["n"] = setShowInviteTechnicianModal;
/* harmony export (immutable) */ __webpack_exports__["q"] = submitFormRequestForTechnician;
/* harmony export (immutable) */ __webpack_exports__["p"] = submitFormRequest;
/* harmony export (immutable) */ __webpack_exports__["r"] = updateFormValue;
/* unused harmony export validForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_users_api__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_sub_technicians_api__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_roles_api__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_messages__ = __webpack_require__(14);
var baseRoutePath='/admin/team';var ContactorTeamTabs={Users:{value:1,label:'Users'},Technicians:{value:2,label:'Technicians'}};function addUser(user){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["G" /* CONTRACTOR_TEAM_USERS_ADD */],payload:user};}function addTechnician(technician){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["C" /* CONTRACTOR_TEAM_TECHNICIANS_ADD */],payload:technician};}function deleteTechnicianRequest(technicianId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_sub_technicians_api__["a" /* default */].removeTechnician(technicianId).then(function(response){if(response.ok){dispatch(removeTechnician(technicianId));dispatch(setShowInviteTechnicianModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function deleteUserRequest(userId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_users_api__["b" /* usersApi */].removeUser(userId).then(function(response){if(response.ok){dispatch(removeUser(userId));dispatch(setShowInviteUserModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function editUser(user){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["H" /* CONTRACTOR_TEAM_USERS_EDIT */],payload:user};}function editTechnician(technician){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["D" /* CONTRACTOR_TEAM_TECHNICIANS_EDIT */],payload:technician};}function goToEditContractor(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(baseRoutePath+'/edit'));};}function goToTeam(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(''+baseRoutePath));};}function invalidForm(invalidFields,message){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["v" /* CONTRACTOR_TEAM_INVITE_USER_FORM_INVALID */],payload:{invalidFields:invalidFields,message:message}};}function loadRolesRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_roles_api__["b" /* rolesApi */].getRoles(__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["f" /* TYPES */].CONTRACTOR).then(function(response){if(response.ok){dispatch(loadRolesSuccess(response.permissions));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadRolesSuccess(roles){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["B" /* CONTRACTOR_TEAM_ROLES_LOAD_SUCCESS */],payload:roles};}function loadTechnicianFormRequest(technician){return function(dispatch){var form=void 0;if(technician){form={firstName:technician.first_name,lastName:technician.last_name||'',email:technician.email||'',phoneNumber:technician.phone_number||''};}else{form={firstName:'',lastName:'',email:'',phoneNumber:''};}dispatch(loadUserForm(form));};}function loadUserFormRequest(user){return function(dispatch){var form=void 0;if(user!==null){form={firstName:user.first_name,lastName:user.last_name,email:user.email,phoneNumber:user.phone_number!=null?user.phone_number:'',rolesId:user.roles&&user.roles.length>0?user.roles[0].id:null};}else{form={firstName:'',lastName:'',email:'',phoneNumber:'',rolesId:null};}dispatch(loadUserForm(form));};}function loadUserForm(form){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["w" /* CONTRACTOR_TEAM_INVITE_USER_FORM_LOAD */],payload:form};}function setCurrentPageTechnicians(page){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["p" /* CONTACTOR_TEAM_CURRENT_PAGE_TECHNICIANS */],payload:page};}function setPerPageTechnicians(amount){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["q" /* CONTACTOR_TEAM_PER_PAGE_TECHNICIANS */],payload:amount};}function setTotalTechnicians(amount){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["s" /* CONTACTOR_TEAM_TOTAL_TECHNICIANS */],payload:amount};}function setActiveTab(amount){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["r" /* CONTACTOR_TEAM_SET_ACTIVE_TAB */],payload:amount};}function loadUsersRequest(){var activeTab=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_users_api__["b" /* usersApi */].getUsers().then(function(response){if(response.ok){dispatch(loadUsersSuccess(response.users));dispatch(setActiveTab(activeTab));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadTechnicianRequest(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var activeTab=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_sub_technicians_api__["a" /* default */].getTechnicians(page).then(function(response){if(response.ok){dispatch(loadTechniciansSuccess(response.technicians));dispatch(setActiveTab(activeTab));if(response.perPage){dispatch(setPerPageTechnicians(+response.perPage));}if(response.total){dispatch(setTotalTechnicians(+response.total));}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadUsersSuccess(users){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["I" /* CONTRACTOR_TEAM_USERS_LOAD_SUCCESS */],payload:users};}function loadTechniciansSuccess(technicians){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["E" /* CONTRACTOR_TEAM_TECHNICIANS_LOAD_SUCCESS */],payload:technicians};}function removeUser(userId){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["J" /* CONTRACTOR_TEAM_USERS_REMOVE */],payload:userId};}function removeTechnician(technicianId){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["F" /* CONTRACTOR_TEAM_TECHNICIANS_REMOVE */],payload:technicianId};}function setCurrentUserId(userId){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["z" /* CONTRACTOR_TEAM_INVITE_USER_ID_SET */],payload:userId};}function setCurrentTechnicianId(technicianId){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["t" /* CONTRACTOR_TEAM_INVITE_TECHNICIAN_ID_SET */],payload:technicianId};}function setShowInviteUserModal(open,state){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["A" /* CONTRACTOR_TEAM_INVITE_USER_MODAL_SHOW */],payload:{open:open,state:state?state:undefined}};}function setShowInviteTechnicianModal(open,state){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["u" /* CONTRACTOR_TEAM_INVITE_TECHNICIAN_MODAL_SHOW */],payload:{open:open,state:state?state:undefined}};}function submitFormRequestForTechnician(form,currentTechnicianId){return function(dispatch){var requiredFields=['firstName'];var invalidFields=[];requiredFields.forEach(function(attribute){if(form[attribute]===''||form[attribute]===null){invalidFields.push(attribute);}});if(invalidFields.length>0){dispatch(invalidForm(invalidFields,'The outlined inputs should be added in order to add a technician.'));}else{dispatch(validForm());if(!currentTechnicianId){return __WEBPACK_IMPORTED_MODULE_2_services_api_sub_technicians_api__["a" /* default */].addTechnician(form).then(function(response){if(response.ok){dispatch(addTechnician(response.technician));dispatch(setShowInviteTechnicianModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_messages__["d" /* showErrorMessage */])(response.errors));}});}else{return __WEBPACK_IMPORTED_MODULE_2_services_api_sub_technicians_api__["a" /* default */].updateTechnician(currentTechnicianId,form).then(function(response){if(response.ok){dispatch(editTechnician(response.technician));dispatch(setShowInviteTechnicianModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});}}};}function submitFormRequest(form,currentUserId){return function(dispatch){// Validate form
var requiredFields=['firstName','lastName','email','phoneNumber','rolesId'];var invalidFields=[];requiredFields.forEach(function(attribute){if(form[attribute]===''||form[attribute]===null){invalidFields.push(attribute);}});if(invalidFields.length>0){dispatch(invalidForm(invalidFields,'The outlined inputs should be added in order to invite a user.'));}else{dispatch(validForm());if(currentUserId===0){return __WEBPACK_IMPORTED_MODULE_1_services_api_users_api__["b" /* usersApi */].addUser(form.firstName,form.lastName,form.email,form.phoneNumber,[form.rolesId],form.title).then(function(response){if(response.ok){dispatch(addUser(response.user));dispatch(setShowInviteUserModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});}else{return __WEBPACK_IMPORTED_MODULE_1_services_api_users_api__["b" /* usersApi */].updateUser(currentUserId,form.firstName,form.lastName,form.email,form.phoneNumber,[form.rolesId],form.title).then(function(response){if(response.ok){dispatch(editUser(response.user));dispatch(setShowInviteUserModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});}}};}function updateFormValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["y" /* CONTRACTOR_TEAM_INVITE_USER_FORM_VALUE_UPDATE */],payload:{attribute:attribute,value:value}};}function validForm(){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["x" /* CONTRACTOR_TEAM_INVITE_USER_FORM_VALID */]};}

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getShowOpenItemsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getProjectOpenItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getPageSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCritical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDueDateFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getShowOpenItemFormModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getOpenItemForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getOpenItemFormErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getShowOpenItemDetailsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getEditOpenItemDetailsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getRespondOpenItemDetailsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentProjectOpenItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getProjectOpenItemsCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getProjectOpenItemsCritCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getProjectOpenItemNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getOpenItemPdfViewer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getShowOpenItemsModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.ui.showOpenItemsModal;},function(showOpenItemsModal){return showOpenItemsModal;});var getProjectOpenItems=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.data.projectOpenItems;},function(projectOpenItems){return projectOpenItems;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.data.currentPage;},function(currentPage){return currentPage;});var getTotal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.data.total;},function(currentPage){return currentPage;});var getPageSize=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.data.pageSize;},function(currentPage){return currentPage;});var getCritical=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.data.critical;},function(critical){return critical;});var getStatus=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.data.status;},function(status){return status;});var getDueDateFilter=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.data.dueDateFilter;},function(dueDateFilter){return dueDateFilter;});var getShowOpenItemFormModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.ui.showOpenItemFormModal;},function(showOpenItemFormModal){return showOpenItemFormModal;});var getOpenItemForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.ui.openItemForm;},function(openItemForm){return openItemForm;});var getOpenItemFormErrors=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.ui.openItemFormErrors;},function(openItemFormErrors){return openItemFormErrors;});var getShowOpenItemDetailsModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.ui.showOpenItemDetailsModal;},function(showOpenItemDetailsModal){return showOpenItemDetailsModal;});var getEditOpenItemDetailsModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.ui.editOpenItemDetailsModal;},function(editOpenItemDetailsModal){return editOpenItemDetailsModal;});var getRespondOpenItemDetailsModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.ui.respondOpenItemDetailsModal;},function(respondOpenItemDetailsModal){return respondOpenItemDetailsModal;});var getCurrentProjectOpenItem=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.data.currentProjectOpenItem;},function(currentProjectOpenItem){return currentProjectOpenItem;});var getProjectOpenItemsCount=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.data.projectOpenItemsCount;},function(projectOpenItemsCount){return projectOpenItemsCount;});var getProjectOpenItemsCritCount=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.data.projectOpenItemsCritCount;},function(projectOpenItemsCritCount){return projectOpenItemsCritCount;});var getProjectOpenItemNotes=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.data.projectOpenItemNotes;},function(projectOpenItemNotes){return projectOpenItemNotes;});var getOpenItemPdfViewer=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.openItems.ui.openItemPdfViewer;},function(openItemPdfViewer){return openItemPdfViewer;});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getShowEmailModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getShowCustomEmailError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getShowNewCustomEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEmails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getSubject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getRecipients; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCustomEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getHistory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getShowEmailModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.emailModal.ui.showEmailModal;},function(showEmailModal){return showEmailModal;});var getShowCustomEmailError=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.emailModal.ui.showCustomEmailError;},function(showCustomEmailError){return showCustomEmailError;});var getShowNewCustomEmail=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.emailModal.ui.showNewCustomEmail;},function(showNewCustomEmail){return showNewCustomEmail;});var getEmails=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.emailModal.ui.emails;},function(emails){return emails;});var getSubject=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.emailModal.ui.subject;},function(subject){return subject;});var getMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.emailModal.ui.message;},function(message){return message;});var getRecipients=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.emailModal.ui.recipients;},function(recipients){return recipients;});var getCustomEmail=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.emailModal.ui.customEmail;},function(customEmail){return customEmail;});var getHistory=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.emailModal.data.history;},function(history){return history;});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getSubmittals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDueDateFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPageSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getSubmittalTabSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getSubmittalModalShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getSubmittalForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getSubmittalReadOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getSubmittalLeadTimeReadOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getSubmittalGcAcceleration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getShowTransmittalPdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getTransmittalPdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentSubmittal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getSubmittalNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getSubmittalLogPdfViewer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getSubmittalLogPdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getSubmittalPdfViewer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getSubmittalShowErrorMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getSubmittals=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.data.submittals;},function(submittals){return submittals;});var getTotal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.data.total;},function(total){return total;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.data.currentPage;},function(currentPage){return currentPage;});var getCurrentStatus=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.data.currentStatus;},function(currentStatus){return currentStatus;});var getDueDateFilter=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.data.dueDateFilter;},function(dueDateFilter){return dueDateFilter;});var getPageSize=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.data.pageSize;},function(pageSize){return pageSize;});var getSubmittalTabSelected=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.ui.submittalTabSelected;},function(submittalTabSelected){return submittalTabSelected;});var getSubmittalModalShow=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.ui.submittalModalShow;},function(submittalModalShow){return submittalModalShow;});var getSubmittalForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.ui.submittalForm;},function(submittalForm){return submittalForm;});var getSubmittalReadOnly=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.ui.submittalReadOnly;},function(submittalReadOnly){return submittalReadOnly;});var getSubmittalLeadTimeReadOnly=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.ui.submittalLeadTimeReadOnly;},function(submittalLeadTimeReadOnly){return submittalLeadTimeReadOnly;});var getSubmittalGcAcceleration=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.ui.submittalGcAcceleration;},function(submittalGcAcceleration){return submittalGcAcceleration;});var getShowTransmittalPdf=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.ui.showTransmittalPdf;},function(showTransmittalPdf){return showTransmittalPdf;});var getTransmittalPdf=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.data.transmittalPdf;},function(transmittalPdf){return transmittalPdf;});var getCurrentSubmittal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.data.currentSubmittal;},function(currentSubmittal){return currentSubmittal;});var getSubmittalNotes=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.data.submittalNotes;},function(submittalNotes){return submittalNotes;});var getSubmittalLogPdfViewer=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.ui.submittalLogPdfViewer;},function(submittalLogPdfViewer){return submittalLogPdfViewer;});var getSubmittalLogPdf=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.data.submittalLogPdf;},function(submittalLogPdf){return submittalLogPdf;});var getSubmittalPdfViewer=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.ui.submittalPdfViewer;},function(submittalPdfViewer){return submittalPdfViewer;});var getSubmittalShowErrorMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.submittalLog.ui.submittalShowErrorMessage;},function(submittalShowErrorMessage){return submittalShowErrorMessage;});

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(54)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(110)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(209)('meta');
var isObject = __webpack_require__(48);
var has = __webpack_require__(117);
var setDesc = __webpack_require__(70).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(43)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(244);
var IE8_DOM_DEFINE = __webpack_require__(684);
var toPrimitive = __webpack_require__(470);
var dP = Object.defineProperty;

exports.f = __webpack_require__(172) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(742);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAABOCAYAAACOqiAdAAAAAXNSR0IArs4c6QAAA+BJREFUeAHt3E1u1DAUB/A4RS1HgFnBAoE6qoQ4DL0FEqJix4odKkLiFnAYhFSNBGLBrrDgALSiNX5uPXUzGY8/3oeTTBaTj0ns9//JM2k1kZvGW7TWdxaLn/e8Q9tNIwAmYONjKNhZLPTu+cWPt1rpF43Wd82h01Y1L58ePPnsnzy17a8n355f6uaDyT1rlPqrtPq4u/PozXyuzlvAsGjN5etrNDg0Mxd8+nLy/RXsTHGB7GBgss9sfjOgtDECK9hvYQjakWbf7bxofTxFPJvZZO9o2F2wAjMFn9+zi7NffSctjyl19Ozg8fvl/og3Qmgu9t7O3v12Pn/42xw4dQd71xMZeTFoYAVm9jsObgS9YP7BkeNFojXOysLZu6f5OPpOvdsjxYtFM3fWI/eXhv1zxCGlNDCW77zczLfgADC3IYc/pHVJ1hW4qeCVoIFRL9zY8UrRgnBjxcNA2wg3NjwstCi4seBhokXDDR0PGy0Jbqh4FGjJcEPDo0LLghsKHiVaNlzteNRoRXC14nGgFcPVhseFhgJXCx4nGhqcNB43GiqcFJ4EGjocN54UGgkcF54kGhkcNZ40GikcFV4NaORw2Hi1oLHAYeHVhMYGV4pXGxorXC5ejWjscKl4cL559Kz3qSH7nnsReCho7c+DriaKdfQoiulcAA3KEoGDjlHwhNBE4YrxBNHE4bLxhNGqgEvGqwANarbPx8HGdkkTELs5uDKzbhIVjDpRuCw0Jy6MJwZXhFYBnggcCpowHjtcNJr5KFqb7b9cCf8teN9fKdCcD3SzjbgSgJJr3Scae80ChxEcow1MPHI4zMCYbZUiksJRBKVoMweRDI4yIGXbsYgkcBzBOPoIIaLDcQbi7KuLiAonEUSiT0BEg5MKACEk+kaBkygcwPyFu4ZiOO6CfazuNmctRXCchXaR1u1z1ZQNx1XgOqDQcY7asuA4CgvBxLxHXWMyHHVBMSix51DWmgRHWUgsRup5VDVHw1EVkAqRcz5F7VFwFB3nAJRcg51hIxx2hyXhS6/FzBKEw+yoNDTW9ViZ1sJhdYAVGLMdjGy9cBgNYwalaKs04wpcaYMUIanaLMl6C66kIapw1O3mZl7C5TZAHYyj/ZzsFu569lGYSDO8eL+wh08c3ruxeGbivUOYQ84+WHg9ZWs47YjRILh9fMI9rxKQcFbbyUU7SDEjz04uur//4A9MDty5/mZ35CPtJujV1saRZ6zArFVK/YMZlbsN2P2JoTmDEB5YgZn9joNpqFXTvvNGHkzZfcj52JQrupY1ZAcDU8/VVL8wZbcxAquVGreTxK+Q2AN9k8T/B0Fo78SIrZyfAAAAAElFTkSuQmCC"

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getShowLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getNotifications=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.notifications.data.notifications;},function(notifications){return notifications;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.notifications.ui.currentPage;},function(currentPage){return currentPage;});var getShowLoader=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.notifications.ui.showLoader;},function(showLoader){return showLoader;});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_truncate__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SimpleTruncate_css__ = __webpack_require__(1931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SimpleTruncate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SimpleTruncate_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleTruncate=function(_Component){_inherits(SimpleTruncate,_Component);function SimpleTruncate(props){_classCallCheck(this,SimpleTruncate);var _this=_possibleConstructorReturn(this,(SimpleTruncate.__proto__||Object.getPrototypeOf(SimpleTruncate)).call(this,props));_this.handleShowMore=function(event){event.preventDefault();event.stopPropagation();_this.setState({lines:0});};_this.handleShowLess=function(event){event.preventDefault();event.stopPropagation();_this.setState({lines:_this.props.shownLines});};_this.state={lines:_this.props.shownLines};return _this;}_createClass(SimpleTruncate,[{key:'render',value:function render(){var classNames=['simple-truncate'];if(this.state.lines===0){classNames.push('break-text');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames.join(' ')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_truncate__["a" /* default */],{lines:this.state.lines,ellipsis:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'...',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'show-more-less',onClick:this.handleShowMore},'Show more'))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.text&&this.props.text.split('\n').map(function(line,i,arr){var newLine=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i},line);if(i===arr.length-1){return newLine;}else{return[newLine,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:i+'br'})];}}))),this.state.lines===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'show-more-less',onClick:this.handleShowLess},'Show less')));}}]);return SimpleTruncate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SimpleTruncate.propTypes={shownLines:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};SimpleTruncate.defaultProps={shownLines:3,text:''};/* harmony default export */ __webpack_exports__["a"] = (SimpleTruncate);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SimpleHeader_css__ = __webpack_require__(2160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SimpleHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SimpleHeader_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_react_fontawesome__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_solid_faAngleDown__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_solid_faAngleDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_solid_faAngleDown__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleHeader=function(_Component){_inherits(SimpleHeader,_Component);function SimpleHeader(props){_classCallCheck(this,SimpleHeader);var _this=_possibleConstructorReturn(this,(SimpleHeader.__proto__||Object.getPrototypeOf(SimpleHeader)).call(this,props));_this.handleFilterClick=function(event){event.preventDefault();if(_this.hasFilter){_this.setState({showFilter:true});}};_this.handleOptionClick=function(event,id){event.preventDefault();_this.setState({showFilter:false});if(_this.props.onFilterOptionSelect!==undefined){_this.props.onFilterOptionSelect(id);}};_this.handleOverlayClick=function(event){event.preventDefault();_this.setState({showFilter:false});};_this.state={showFilter:false};_this.hasFilter=_this.props.filter!==undefined&&_this.props.filter.options.length>0;return _this;}_createClass(SimpleHeader,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'simple-header',className:'simple-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.hasFilter?'has-filter':'',onClick:this.handleFilterClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.label),this.hasFilter&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__fortawesome_react_fontawesome__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_solid_faAngleDown___default.a}))),this.hasFilter&&this.state.showFilter&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-container-parent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.props.filter.options.map(function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:element.id,className:element.id===_this2.props.filter.selected?'selected':'',onClick:function onClick(event){return _this2.handleOptionClick(event,element.id);}},element.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-overlay',onClick:this.handleOverlayClick})));}}]);return SimpleHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SimpleHeader.propTypes={filter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})).isRequired,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}),label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onFilterOptionSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (SimpleHeader);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getChangeOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getShowChangeOrderModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getStartDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCompletionDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getValuesByQuoteId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getSelectedChangeOrderId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getSelectedChangeOrderNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getShowSuccessMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getPdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getShowPdfViewer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getShowEmailModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getEmails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getSubject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getChangeOrders=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrders.data.changeOrders;},function(changeOrders){return changeOrders;});var getShowChangeOrderModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrders.ui.showChangeOrderModal;},function(showChangeOrderModal){return showChangeOrderModal;});var getStartDate=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrders.data.startDate;},function(startDate){return startDate;});var getCompletionDate=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrders.data.completionDate;},function(completionDate){return completionDate;});var getValuesByQuoteId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrders.data.valuesByQuoteId;},function(valuesByQuoteId){return valuesByQuoteId;});var getCurrentView=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrders.ui.currentView;},function(currentView){return currentView;});var getSelectedChangeOrderId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrders.data.selectedChangeOrderId;},function(selectedChangeOrderId){return selectedChangeOrderId;});var getSelectedChangeOrderNumber=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrders.data.selectedChangeOrderNumber;},function(selectedChangeOrderNumber){return selectedChangeOrderNumber;});var getShowSuccessMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrders.ui.showSuccessMessage;},function(showSuccessMessage){return showSuccessMessage;});var getPdf=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrders.ui.pdf;},function(pdf){return pdf;});var getShowPdfViewer=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrders.ui.showPdfViewer;},function(showPdfViewer){return showPdfViewer;});var getShowEmailModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrders.ui.showEmailModal;},function(showEmailModal){return showEmailModal;});var getUsers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrders.data.users;},function(users){return users;});var getEmails=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrders.ui.emails;},function(emails){return emails;});var getSubject=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrders.ui.subject;},function(subject){return subject;});var getMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrders.ui.message;},function(message){return message;});

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mail.7283c653.svg";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/print-white.89142ff2.svg";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(610);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Component that alerts if you click outside of it
 */var OutsideAlerter=function(_Component){_inherits(OutsideAlerter,_Component);function OutsideAlerter(props){_classCallCheck(this,OutsideAlerter);var _this=_possibleConstructorReturn(this,(OutsideAlerter.__proto__||Object.getPrototypeOf(OutsideAlerter)).call(this,props));_this.setWrapperRef=_this.setWrapperRef.bind(_this);_this.handleClickOutside=_this.handleClickOutside.bind(_this);return _this;}_createClass(OutsideAlerter,[{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('mousedown',this.handleClickOutside);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('mousedown',this.handleClickOutside);}/**
   * Set the wrapper ref
   */},{key:'setWrapperRef',value:function setWrapperRef(node){this.wrapperRef=node;}/**
   * Alert if clicked on outside of element
   */},{key:'handleClickOutside',value:function handleClickOutside(event){if(this.wrapperRef&&!this.wrapperRef.contains(event.target)){this.props.onClickOutside(event);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:this.setWrapperRef},this.props.children);}}]);return OutsideAlerter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (OutsideAlerter);OutsideAlerter.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired,onClickOutside:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reports_css__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reports_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Reports_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_reports__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReportFilter__ = __webpack_require__(3220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_file_saver__ = __webpack_require__(3222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_checkbox_CheckBox__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BaseReport=function(_Component){_inherits(BaseReport,_Component);function BaseReport(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BaseReport);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BaseReport.__proto__||Object.getPrototypeOf(BaseReport)).call.apply(_ref,[this].concat(args))),_this),_this.handlePageChange=function(newPage){// Should return promise to process results in search
return _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_reports__["f" /* loadReportRequest */])(_this.props.reportName,newPage,_this.props.startDate,_this.props.endDate,_this.props.extraFilterValues));},_this.handleStartDateChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_reports__["c" /* changeStartDate */])(value));},_this.handleEndDateChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_reports__["a" /* changeEndDate */])(value));},_this.handleExport=function(){var _this$props=_this.props,reportName=_this$props.reportName,startDate=_this$props.startDate,endDate=_this$props.endDate,extraFilterValues=_this$props.extraFilterValues,dispatch=_this$props.dispatch;var ids=_this.selectedWorkOrderIds();dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_reports__["e" /* exportReport */])(reportName,ids,startDate,endDate,extraFilterValues)).then(function(content){var file=new File([content.data],content.fileName,{type:content.type});__WEBPACK_IMPORTED_MODULE_9_file_saver___default.a.saveAs(file);});},_this.handleSearch=function(){_this.handlePageChange(1).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_reports__["d" /* clearSelection */])());}});},_this.handleSelectAllCheck=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_reports__["h" /* selectAllWorkOrders */])());},_this.handleWorkOrderSelection=function(workOrderId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_reports__["i" /* selectWorkOrder */])(workOrderId));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BaseReport,[{key:'componentDidMount',value:function componentDidMount(){this.handlePageChange(1);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// If selected items did not change, then scroll top top
if(Object.keys(prevProps.selectedWorkOrders).length===Object.keys(this.props.selectedWorkOrders).length){Object(__WEBPACK_IMPORTED_MODULE_5_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_reports__["g" /* resetReports */])());}},{key:'selectedWorkOrderIds',value:function selectedWorkOrderIds(){var _this2=this;var selectedIds=[];Object.keys(this.props.selectedWorkOrders).forEach(function(page){Object.keys(_this2.props.selectedWorkOrders[page]).forEach(function(woId){selectedIds.push(woId);});});return selectedIds;}},{key:'mapRows',value:function mapRows(){var _this3=this;// Map the info from the parent report to a list of row data (what SimpleTable expects)
// For each item in tableRowsData, add the CheckBox if item is the first one.
return this.props.tableRowsData.map(function(item){if(item.first){var selectedWorkOrders=_this3.props.selectedWorkOrders[_this3.props.currentPage];return Object.assign({},item.rowData,{data:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_checkbox_CheckBox__["a" /* default */],{checked:selectedWorkOrders!==undefined&&selectedWorkOrders[item.workOrderId]!==undefined,onChange:function onChange(){return _this3.handleWorkOrderSelection(item.workOrderId);}})].concat(_toConsumableArray(item.rowData.data))});}else{return Object.assign({},item.rowData,{data:[''].concat(_toConsumableArray(item.rowData.data))});}});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reports'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ReportFilter__["a" /* default */],{startDate:this.props.startDate,endDate:this.props.endDate,exportButtonDisabled:this.selectedWorkOrderIds().length===0,searching:this.props.searching,selectAllChecked:this.props.allChecked,selectAllDisabled:this.props.reportResults===null||this.props.reportResults.total===0,onStartDateChange:this.handleStartDateChange,onEndDateChange:this.handleEndDateChange,onExport:this.handleExport,onSearchClick:this.handleSearch,onSelectAllCheck:this.handleSelectAllCheck,extraFilters:this.props.extraFilters}),this.props.reportResults!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleTable__["a" /* default */],{className:'report-table',headers:this.props.tableHeader,rows:this.mapRows(),emptyMessage:'No Results',onRowSelected:this.props.onRowSelection}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.currentPage,pageSize:this.props.reportResults.pageSize,total:this.props.reportResults.total,onPageChange:this.handlePageChange})))));}}]);return BaseReport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BaseReport.propTypes={reportName:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string.isRequired,tableHeader:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string).isRequired,tableRowsData:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape({first:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool.isRequired,rowData:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape.isRequired,workOrderId:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number.isRequired})),title:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string.isRequired,onRowSelection:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired,extraFilters:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{allChecked:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__["g" /* getSelectAllChecked */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__["a" /* getCurrentPage */])(state),startDate:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__["i" /* getStartDate */])(state),endDate:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__["b" /* getEndDate */])(state),extraFilterValues:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__["c" /* getExtraFilterValues */])(state),searching:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__["f" /* getSearching */])(state),selectedWorkOrders:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__["h" /* getSelectedWorkOrders */])(state),reportResults:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__["d" /* getReportResults */])(state)};})(BaseReport));

/***/ }),
/* 209 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(32);
var dPs = __webpack_require__(656);
var enumBugKeys = __webpack_require__(451);
var IE_PROTO = __webpack_require__(450)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(446)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(452).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(657);
var enumBugKeys = __webpack_require__(451);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(136);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(109);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(137);
var call = __webpack_require__(660);
var isArrayIter = __webpack_require__(456);
var anObject = __webpack_require__(32);
var toLength = __webpack_require__(55);
var getIterFn = __webpack_require__(457);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(41);
var dP = __webpack_require__(70);
var DESCRIPTORS = __webpack_require__(59);
var SPECIES = __webpack_require__(54)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 220 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(687);
var defined = __webpack_require__(349);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = uncontrollable;

var _react = _interopRequireDefault(__webpack_require__(0));

var _invariant = _interopRequireDefault(__webpack_require__(56));

var Utils = _interopRequireWildcard(__webpack_require__(1167));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function uncontrollable(Component, controlledValues, methods) {
  if (methods === void 0) {
    methods = [];
  }

  var displayName = Component.displayName || Component.name || 'Component';
  var isCompositeComponent = Utils.isReactComponent(Component);
  var controlledProps = Object.keys(controlledValues);
  var PROPS_TO_OMIT = controlledProps.map(Utils.defaultKey);
  !(isCompositeComponent || !methods.length) ?  false ? (0, _invariant.default)(false, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', ')) : invariant(false) : void 0;

  var UncontrolledComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(UncontrolledComponent, _React$Component);

    function UncontrolledComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.handlers = Object.create(null);
      controlledProps.forEach(function (propName) {
        var handlerName = controlledValues[propName];

        var handleChange = function handleChange(value) {
          if (_this.props[handlerName]) {
            var _this$props;

            _this._notifying = true;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));

            _this._notifying = false;
          }

          _this._values[propName] = value;
          if (!_this.unmounted) _this.forceUpdate();
        };

        _this.handlers[handlerName] = handleChange;
      });
      if (isCompositeComponent) _this.attachRef = function (ref) {
        _this.inner = ref;
      };
      return _this;
    }

    var _proto = UncontrolledComponent.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
      //let the forceUpdate trigger the update
      return !this._notifying;
    };

    _proto.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var props = this.props;
      this._values = Object.create(null);
      controlledProps.forEach(function (key) {
        _this2._values[key] = props[Utils.defaultKey(key)];
      });
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      var props = this.props;
      controlledProps.forEach(function (key) {
        /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */
        if (!Utils.isProp(nextProps, key) && Utils.isProp(props, key)) {
          _this3._values[key] = nextProps[Utils.defaultKey(key)];
        }
      });
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.unmounted = true;
    };

    _proto.getControlledInstance = function getControlledInstance() {
      return this.inner;
    };

    _proto.render = function render() {
      var _this4 = this;

      var props = _extends({}, this.props);

      PROPS_TO_OMIT.forEach(function (prop) {
        delete props[prop];
      });
      var newProps = {};
      controlledProps.forEach(function (propName) {
        var propValue = _this4.props[propName];
        newProps[propName] = propValue !== undefined ? propValue : _this4._values[propName];
      });
      return _react.default.createElement(Component, _extends({}, props, newProps, this.handlers, {
        ref: this.attachRef
      }));
    };

    return UncontrolledComponent;
  }(_react.default.Component);

  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
  UncontrolledComponent.propTypes = Utils.uncontrolledPropTypes(controlledValues, displayName);
  methods.forEach(function (method) {
    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
      var _inner;

      return (_inner = this.inner)[method].apply(_inner, arguments);
    };
  });
  UncontrolledComponent.ControlledComponent = Component;
  /**
   * useful when wrapping a Component and you want to control
   * everything
   */

  UncontrolledComponent.deferControlTo = function (newComponent, additions, nextMethods) {
    if (additions === void 0) {
      additions = {};
    }

    return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
  };

  return UncontrolledComponent;
}

module.exports = exports["default"];

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAADpJREFUOBFjYCAA3nuY/AdhAsoYmAgpIFZ+1CDCITX4woiRmDRC2GMM1EtHBC0bTdnUC+zBlyCp5iIAnqoMMuV9eOsAAAAASUVORK5CYII="

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rolesApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RolesApi=function(_BaseApi){_inherits(RolesApi,_BaseApi);function RolesApi(){_classCallCheck(this,RolesApi);return _possibleConstructorReturn(this,(RolesApi.__proto__||Object.getPrototypeOf(RolesApi)).apply(this,arguments));}_createClass(RolesApi,[{key:'getRoles',value:function getRoles(type){var filter='';if(type!==undefined){filter='?type='+type;}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/roles'+filter).then(function(response){return{ok:true,permissions:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return RolesApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var rolesApi=new RolesApi();/* harmony default export */ __webpack_exports__["a"] = (RolesApi=new RolesApi());

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports = { prefix: 'fas', iconName: 'angle-down', icon: [320, 512, [], "f107", "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"] };

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RuleList; });
/* unused harmony export SheetsManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SheetsRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return create; });
/* unused harmony export createGenerateId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDynamicStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasCSSTOMSupport; });
/* unused harmony export sheets */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toCssValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_is_in_browser__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiny_warning__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(299);








var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
     false ? warning(false, "[JSS] Unknown rule " + name) : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
var toCssValue = function toCssValue(value, ignoreImportant) {
  if (ignoreImportant === void 0) {
    ignoreImportant = false;
  }

  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;
  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += '\n';
            result += "" + indentStr(prop + ": " + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += '\n';
          result += "" + indentStr(_prop + ": " + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += '\n';
      result += "" + indentStr(_prop2 + ": " + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "\n" + result + "\n";
  return indentStr(selector + " {" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.key = void 0;
    this.isProcessed = false;
    this.style = void 0;
    this.renderer = void 0;
    this.renderable = void 0;
    this.options = void 0;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
       false ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    _this.selectorText = void 0;
    _this.id = void 0;
    _this.renderable = void 0;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(name, style, options) {
    if (name[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(name, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.at = void 0;
    this.key = void 0;
    this.query = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {\n" + children + "\n}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.key = void 0;
    this.name = void 0;
    this.id = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
       false ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "\n" + children + "\n";
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

       false ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var plugin = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _BaseStyleRule.call.apply(_BaseStyleRule, [this].concat(args)) || this;
    _this.renderable = void 0;
    return _this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += '\n';
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.key = void 0;
    this.value = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins = [pluginStyleRule, pluginConditionalRule, plugin, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Get a rule.
   */
  ;

  _proto.get = function get(name) {
    return this.map[name];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe[invalid-tuple-index]

      data = arguments.length <= 1 ? undefined : arguments[1]; // $FlowFixMe[invalid-tuple-index]

      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe[invalid-tuple-index]

      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.map[name], data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var styleRule = rule;
    var style = styleRule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== styleRule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(styleRule.style, styleRule, sheet); // Update and add props.

      for (var prop in styleRule.style) {
        var nextValue = styleRule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          styleRule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = styleRule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          styleRule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += '\n';
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.options = void 0;
    this.deployed = void 0;
    this.attached = void 0;
    this.rules = void 0;
    this.renderer = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.queue = void 0;
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name.
   */
  ;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = void 0;
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      // $FlowFixMe[prop-missing]
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
           false ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["attached"]);

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += '\n';
      css += sheet.toString(options);
    }

    return css;
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var registry = new SheetsRegistry();

/* eslint-disable */

/**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns]++;

var maxRules = 1e10;

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */
var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;
  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
       false ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };
};

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};

/**
 * Set a style property.
 */
var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      cssRule.style.setProperty(prop, cssValue);
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};

/**
 * Remove a style property.
 */
var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
     false ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
  }
};

/**
 * Set the selector.
 */
var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry$1 = registry.registry;

  if (registry$1.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry$1, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry$1, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


     false ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      var c = container;
      c.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        var _c = container;

        _c.appendRule(rule);
      }
  } catch (err) {
     false ? warning(false, "[JSS] " + err.message) : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.element = void 0;
    this.sheet = void 0;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) registry.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules[index] = cssRule;
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   *
   * Only used for some old browsers because they can't set a selector.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.6.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: __WEBPACK_IMPORTED_MODULE_1_is_in_browser__["a" /* default */] ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins.length; i++) {
      this.plugins.use(plugins[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = registry.index === 0 ? 0 : registry.index + 1;
    }

    var sheet = new StyleSheet(styles, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    registry.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      // $FlowFixMe[incompatible-call]
      return this.createRule(undefined, name, style);
    } // $FlowFixMe[incompatible-type]


    var ruleOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager =
/*#__PURE__*/
function () {
  function SheetsManager() {
    this.length = 0;
    this.sheets = new WeakMap();
  }

  var _proto = SheetsManager.prototype;

  _proto.get = function get(key) {
    var entry = this.sheets.get(key);
    return entry && entry.sheet;
  };

  _proto.add = function add(key, sheet) {
    if (this.sheets.has(key)) return;
    this.length++;
    this.sheets.set(key, {
      sheet: sheet,
      refs: 0
    });
  };

  _proto.manage = function manage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs === 0) {
        entry.sheet.attach();
      }

      entry.refs++;
      return entry.sheet;
    }

    Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["default"])(false, "[JSS] SheetsManager: can't find sheet to manage");
    return undefined;
  };

  _proto.unmanage = function unmanage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs > 0) {
        entry.refs--;
        if (entry.refs === 0) entry.sheet.detach();
      }
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["default"])(false, "SheetsManager: can't find sheet to unmanage");
    }
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(SheetsManager, [{
    key: "size",
    get: function get() {
      return this.length;
    }
  }]);

  return SheetsManager;
}();

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */

/**
 * Export a constant indicating if this browser has CSSTOM support.
 * https://developers.google.com/web/updates/2018/03/cssom
 */
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Creates a new instance of Jss.
 */

var create = function create(options) {
  return new Jss(options);
};
/**
 * A global Jss instance.
 */

var jss = create();

/* unused harmony default export */ var _unused_webpack_default_export = (jss);



/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1514),
    getValue = __webpack_require__(1519);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(657);
var hiddenKeys = __webpack_require__(451).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(1989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__(1992);



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/print.1d4e3cbf.svg";

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export baseRoutePath */
/* harmony export (immutable) */ __webpack_exports__["a"] = addFormMiscCost;
/* harmony export (immutable) */ __webpack_exports__["b"] = cancelEdit;
/* unused harmony export changePage */
/* unused harmony export clearFormMiscCost */
/* harmony export (immutable) */ __webpack_exports__["c"] = closePdfViewer;
/* harmony export (immutable) */ __webpack_exports__["d"] = customEmailAdd;
/* harmony export (immutable) */ __webpack_exports__["e"] = customEmailChange;
/* harmony export (immutable) */ __webpack_exports__["f"] = emailRemove;
/* unused harmony export extractDeletedMiscItems */
/* harmony export (immutable) */ __webpack_exports__["h"] = invalid;
/* harmony export (immutable) */ __webpack_exports__["g"] = goToInvoice;
/* harmony export (immutable) */ __webpack_exports__["i"] = loadInvoiceRequest;
/* unused harmony export loadInvoiceSuccess */
/* harmony export (immutable) */ __webpack_exports__["j"] = loadInvoicesRequest;
/* unused harmony export loadInvoicesSuccess */
/* harmony export (immutable) */ __webpack_exports__["k"] = loadUsersRequest;
/* unused harmony export loadUsersSuccess */
/* harmony export (immutable) */ __webpack_exports__["l"] = markAsPaidRequest;
/* harmony export (immutable) */ __webpack_exports__["m"] = printInvoice;
/* unused harmony export printProposalSuccess */
/* harmony export (immutable) */ __webpack_exports__["n"] = removeFormMiscCost;
/* harmony export (immutable) */ __webpack_exports__["p"] = sendInvoiceRequest;
/* harmony export (immutable) */ __webpack_exports__["o"] = sendEmail;
/* unused harmony export setCustomEmailValid */
/* harmony export (immutable) */ __webpack_exports__["q"] = setEdit;
/* harmony export (immutable) */ __webpack_exports__["s"] = setShowEmailModal;
/* harmony export (immutable) */ __webpack_exports__["t"] = setShowSave;
/* harmony export (immutable) */ __webpack_exports__["v"] = updateFormAttributeChange;
/* harmony export (immutable) */ __webpack_exports__["w"] = updateFormItemLineChange;
/* unused harmony export updateCurrentInvoiceAttribute */
/* unused harmony export updateCurrentInvoiceLineItem */
/* harmony export (immutable) */ __webpack_exports__["x"] = updateInvoiceRequest;
/* harmony export (immutable) */ __webpack_exports__["z"] = usersEmailAdd;
/* harmony export (immutable) */ __webpack_exports__["y"] = userSelected;
/* harmony export (immutable) */ __webpack_exports__["A"] = valid;
/* harmony export (immutable) */ __webpack_exports__["u"] = tabSelectionChange;
/* harmony export (immutable) */ __webpack_exports__["r"] = setSelectedStatus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_invoices_api__ = __webpack_require__(2283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_clients_api__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_utils_text_util__ = __webpack_require__(29);
var baseRoutePath='/admin/invoices';function addFormMiscCost(id,description,cost){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["l" /* INVOICES_INVOICE_FORM_MISC_COST_ADD */],payload:{id:id,description:description,cost:cost}};}function cancelEdit(invoice){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["d" /* INVOICES_INVOICE_EDIT_CANCEL */],payload:invoice};}function changePage(newPage){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["w" /* INVOICES_PAGE_CHANGE */],payload:newPage};}function clearFormMiscCost(){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["m" /* INVOICES_INVOICE_FORM_MISC_COST_CLEAR */]};}function closePdfViewer(){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["r" /* INVOICES_INVOICE_PDF_VIEWER_CLOSE */]};}function customEmailAdd(email){return function(dispatch){if(Object(__WEBPACK_IMPORTED_MODULE_5_services_utils_text_util__["f" /* validateEmail */])(email)){dispatch(emailsAdd([{id:0,email:email}]));dispatch(customEmailChange(''));dispatch(setCustomEmailValid(true));}else{dispatch(setCustomEmailValid(false));}};}function customEmailChange(value){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["b" /* INVOICES_INVOICE_CUSTOM_EMAIL_CHANGE */],payload:value};}function emailRemove(id,index){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["f" /* INVOICES_INVOICE_EMAILS_REMOVE */],payload:{id:id,index:index}};}function extractDeletedMiscItems(formMiscItems,originalMiscItems){var idsToDelete=[];originalMiscItems.forEach(function(originalMiscItem){if(formMiscItems.find(function(formMiscItem){return formMiscItem.id===originalMiscItem.id;})===undefined){idsToDelete.push(originalMiscItem.id);}});return idsToDelete;}function invalid(invalidLineItemId,validationMessage){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["j" /* INVOICES_INVOICE_FORM_INVALID */],payload:{invalidLineItemId:invalidLineItemId,validationMessage:validationMessage}};}function goToInvoice(invoiceId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])(baseRoutePath+'/'+invoiceId));};}function loadInvoiceRequest(invoiceId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_invoices_api__["a" /* invoicesApi */].getInvoice(invoiceId).then(function(response){if(response.ok){dispatch(loadInvoiceSuccess(response.invoice));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadInvoiceSuccess(invoice){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["q" /* INVOICES_INVOICE_LOAD_SUCCESS */],payload:invoice};}function loadInvoicesRequest(page,status){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_invoices_api__["a" /* invoicesApi */].getInvoices(page,status).then(function(response){if(response.ok){dispatch(loadInvoicesSuccess(response.invoices));dispatch(changePage(page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadInvoicesSuccess(invoices){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["v" /* INVOICES_LOAD_SUCCESS */],payload:invoices};}function loadUsersRequest(clientId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_clients_api__["a" /* clientsApi */].getUsers(clientId).then(function(response){if(response.ok){dispatch(loadUsersSuccess(clientId,response.users));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadUsersSuccess(clientId,users){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["z" /* INVOICES_USERS_LOAD_SUCCESS */],payload:{clientId:clientId,users:users}};}function markAsPaidRequest(invoiceId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_invoices_api__["a" /* invoicesApi */].markInvoiceAsPaid(invoiceId).then(function(response){if(response.ok){dispatch(updateCurrentInvoiceAttribute('status',response.invoice.status));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function printInvoice(invoiceId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_invoices_api__["a" /* invoicesApi */].getAsPdf(invoiceId).then(function(response){if(response.ok){dispatch(printProposalSuccess(response.pdf));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function printProposalSuccess(pdf){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["s" /* INVOICES_INVOICE_PRINT_SUCCESS */],payload:pdf};}function removeFormMiscCost(index){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["n" /* INVOICES_INVOICE_FORM_MISC_COST_REMOVE */],payload:index};}function sendInvoiceRequest(invoiceId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_invoices_api__["a" /* invoicesApi */].sendInvoice(invoiceId).then(function(response){if(response.ok){dispatch(updateCurrentInvoiceAttribute('sent_at',response.invoice.sent_at));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function sendEmail(invoiceId,emails,subject,message){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_invoices_api__["a" /* invoicesApi */].sendEmail(invoiceId,emails,subject,message).then(function(response){if(response.ok){dispatch(setShowEmailModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setCustomEmailValid(value){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["c" /* INVOICES_INVOICE_CUSTOM_EMAIL_VALIDATION_SET */],payload:value};}function setEdit(value){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["e" /* INVOICES_INVOICE_EDIT_SET */],payload:value};}function setShowEmailModal(value){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["h" /* INVOICES_INVOICE_EMAIL_MODAL_SHOW_SET */],payload:value};}function setShowSave(value){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["t" /* INVOICES_INVOICE_SAVE_SHOW */],payload:value};}function updateFormAttributeChange(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["i" /* INVOICES_INVOICE_FORM_ATTRIBUTE_CHANGE */],payload:{attribute:attribute,value:value}};}function updateFormItemLineChange(itemId,value){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["k" /* INVOICES_INVOICE_FORM_ITEM_LINE_CHANGE */],payload:{itemId:itemId,value:value}};}function updateCurrentInvoiceAttribute(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["a" /* INVOICES_INVOICE_ATTRIBUTE_UPDATE */],payload:{attribute:attribute,value:value}};}function updateCurrentInvoiceLineItem(lineItemId,value){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["p" /* INVOICES_INVOICE_ITEM_LINE_CHANGE */],payload:{lineItemId:lineItemId,value:value}};}function updateInvoiceRequest(invoiceId,form,originalMiscItems){var miscItemsIdToDelete=extractDeletedMiscItems(form.miscCosts,originalMiscItems);return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_invoices_api__["a" /* invoicesApi */].updateInvoice(invoiceId,form,miscItemsIdToDelete).then(function(response){if(response.ok){dispatch(updateCurrentInvoiceAttribute('adjustment',response.invoice.adjustment));dispatch(updateCurrentInvoiceAttribute('due_date',response.invoice.due_date));dispatch(updateCurrentInvoiceAttribute('cost',response.invoice.cost));dispatch(updateCurrentInvoiceAttribute('emails',response.invoice.send_to));dispatch(updateCurrentInvoiceAttribute('total_cost',response.invoice.total_cost));response.invoice.line_items.forEach(function(lineItem){return dispatch(updateCurrentInvoiceLineItem(lineItem.id,lineItem.cost));});dispatch(updateCurrentInvoiceAttribute('misc_items',response.invoice.misc_items));// Update misc costs form values because new id's could be returned from backend
dispatch(clearFormMiscCost());response.invoice.misc_items.forEach(function(miscItem){return dispatch(addFormMiscCost(miscItem.id,miscItem.description,miscItem.cost));});dispatch(setEdit(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function usersEmailAdd(usersIdSelected,users){return function(dispatch){var payload=users.filter(function(user){return usersIdSelected.find(function(id){return id===user.id;})!==undefined;}).map(function(user){return{id:0,// as the email return wihout id, we should use index as key
email:user.email};});dispatch(emailsAdd(payload));};}function emailsAdd(emails){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["g" /* INVOICES_INVOICE_EMAILS_USERS_ADD */],payload:emails};}function userSelected(userId,usersIdSelected){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["u" /* INVOICES_INVOICE_USER_SELECT */],payload:usersIdSelected.find(function(id){return id===userId;})!==undefined?usersIdSelected.filter(function(id){return id!==userId;}):usersIdSelected.concat([userId])};}function valid(){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["o" /* INVOICES_INVOICE_FORM_VALID */]};}function tabSelectionChange(id){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["y" /* INVOICES_TAB_SELECTION_CHANGE */],payload:id};}function setSelectedStatus(status){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_invoices_action_types__["x" /* INVOICES_SELECTED_STATUS_SET */],payload:status};}

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadCloseoutCatsSuccess */
/* harmony export (immutable) */ __webpack_exports__["d"] = loadCloseoutCatsRequest;
/* unused harmony export loadCloseoutSuccess */
/* harmony export (immutable) */ __webpack_exports__["h"] = loadCloseoutRequest;
/* harmony export (immutable) */ __webpack_exports__["k"] = updateCloseout;
/* harmony export (immutable) */ __webpack_exports__["i"] = requestCloseout;
/* unused harmony export loadCloseoutContribsSuccess */
/* harmony export (immutable) */ __webpack_exports__["e"] = loadCloseoutContribsRequest;
/* unused harmony export updateCloseoutContribSuccess */
/* harmony export (immutable) */ __webpack_exports__["l"] = updateCloseoutContrib;
/* unused harmony export closeoutPercentageSuccess */
/* harmony export (immutable) */ __webpack_exports__["a"] = closeoutPercentage;
/* harmony export (immutable) */ __webpack_exports__["j"] = updateBuilding;
/* unused harmony export loadCloseoutManualsSuccess */
/* harmony export (immutable) */ __webpack_exports__["g"] = loadCloseoutManualsRequest;
/* unused harmony export createCloseoutManualSuccess */
/* harmony export (immutable) */ __webpack_exports__["b"] = createCloseoutManual;
/* unused harmony export loadCloseoutManualSuccess */
/* harmony export (immutable) */ __webpack_exports__["f"] = loadCloseoutManual;
/* unused harmony export deleteCloseoutManualSuccess */
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteCloseoutManual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_closeout_cats_api__ = __webpack_require__(2519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_closeout_api__ = __webpack_require__(2520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_closeout_contributors_api__ = __webpack_require__(2521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_closeout_contributor_cats_api__ = __webpack_require__(2522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_api_closeout_manuals_api__ = __webpack_require__(2523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_api_buildings_api__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_closeout_store_action_types__ = __webpack_require__(1024);
function loadCloseoutCatsSuccess(closeoutCats){return{type:__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_closeout_store_action_types__["a" /* CLOSEOUT_CATS_SET */],payload:closeoutCats};}function loadCloseoutCatsRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_closeout_cats_api__["a" /* closeoutCatsApi */].getCloseoutCats().then(function(response){if(response.ok){dispatch(loadCloseoutCatsSuccess(response.closeoutCats));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadCloseoutSuccess(closeout){return{type:__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_closeout_store_action_types__["i" /* CLOSEOUT_SET */],payload:closeout};}function loadCloseoutRequest(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_closeout_api__["a" /* closeoutApi */].getCloseout(projectId).then(function(response){if(response.ok){dispatch(loadCloseoutSuccess(response.closeout));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateCloseout(projectId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_closeout_api__["a" /* closeoutApi */].updateCloseout(projectId,values).then(function(response){if(response.ok){dispatch(loadCloseoutSuccess(response.closeout));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function requestCloseout(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_closeout_api__["a" /* closeoutApi */].requestCloseout(projectId).then(function(response){if(response.ok){dispatch(loadCloseoutSuccess(response.closeout));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadCloseoutContribsSuccess(closeoutContribs,currentPage,total,pageSize){return{type:__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_closeout_store_action_types__["b" /* CLOSEOUT_CONTRIBS_SET */],payload:{closeoutContribs:closeoutContribs,currentPage:currentPage,total:total,pageSize:pageSize}};}function loadCloseoutContribsRequest(projectId,page){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_closeout_contributors_api__["a" /* closeoutContributorsApi */].getCloseoutContributors(projectId,page).then(function(response){if(response.ok){dispatch(loadCloseoutContribsSuccess(response.closeoutContributors,page,response.total,response.pageSize));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateCloseoutContribSuccess(closeoutContrib){return{type:__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_closeout_store_action_types__["c" /* CLOSEOUT_CONTRIB_SET */],payload:closeoutContrib};}function updateCloseoutContrib(projectId,closeoutContrib,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_closeout_contributors_api__["a" /* closeoutContributorsApi */].updateCloseoutContributor(projectId,closeoutContrib,values).then(function(response){if(response.ok){dispatch(updateCloseoutContribSuccess(response.closeoutContributor));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function closeoutPercentageSuccess(percentage){return{type:__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_closeout_store_action_types__["h" /* CLOSEOUT_PERCENTAGE_SET */],payload:percentage};}function closeoutPercentage(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_closeout_contributor_cats_api__["a" /* closeoutContributorCatsApi */].getCompletedPercentage(projectId).then(function(response){if(response.ok){dispatch(closeoutPercentageSuccess(response.completedPercentage));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateBuilding(buildingId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_6_services_api_buildings_api__["a" /* buildingsApi */].updateBuilding(buildingId,values).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadCloseoutManualsSuccess(closeoutManuals,closeoutManualsCurrentPage,closeoutManualsTotal,closeoutManualsPageSize){return{type:__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_closeout_store_action_types__["d" /* CLOSEOUT_MANUALS_SET */],payload:{closeoutManuals:closeoutManuals,closeoutManualsCurrentPage:closeoutManualsCurrentPage,closeoutManualsTotal:closeoutManualsTotal,closeoutManualsPageSize:closeoutManualsPageSize}};}function loadCloseoutManualsRequest(projectId,page){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5_services_api_closeout_manuals_api__["a" /* closeoutManualsApi */].getCloseoutManuals(projectId,page).then(function(response){if(response.ok){dispatch(loadCloseoutManualsSuccess(response.closeoutManuals,page,response.total,response.pageSize));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function createCloseoutManualSuccess(closeoutManual){return{type:__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_closeout_store_action_types__["f" /* CLOSEOUT_MANUAL_SET */],payload:closeoutManual};}function createCloseoutManual(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5_services_api_closeout_manuals_api__["a" /* closeoutManualsApi */].createCloseoutManual(projectId).then(function(response){if(response.ok){dispatch(createCloseoutManualSuccess(response.closeoutManual));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadCloseoutManualSuccess(closeoutManual){return{type:__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_closeout_store_action_types__["g" /* CLOSEOUT_MANUAL_UPDATE */],payload:closeoutManual};}function loadCloseoutManual(projectId,id){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5_services_api_closeout_manuals_api__["a" /* closeoutManualsApi */].getCloseoutManual(projectId,id).then(function(response){if(response.ok){dispatch(loadCloseoutManualSuccess(response.closeoutManual));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function deleteCloseoutManualSuccess(id){return{type:__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_closeout_store_action_types__["e" /* CLOSEOUT_MANUAL_DELETE */],payload:id};}function deleteCloseoutManual(projectId,id){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5_services_api_closeout_manuals_api__["a" /* closeoutManualsApi */].deleteCloseoutManual(projectId,id).then(function(response){if(response.ok){dispatch(deleteCloseoutManualSuccess(id));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_directory_store_selectors__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_email_modal_store_selectors__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_email_modal_EmailHistoryModal__ = __webpack_require__(2529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_dropdown_MultipleDropdown__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_button_ImageButton__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_images_add_svg__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_images_add_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_images_add_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ProjectEmailModal_css__ = __webpack_require__(2532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ProjectEmailModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ProjectEmailModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectEmailModal=function(_Component){_inherits(ProjectEmailModal,_Component);function ProjectEmailModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProjectEmailModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProjectEmailModal.__proto__||Object.getPrototypeOf(ProjectEmailModal)).call.apply(_ref,[this].concat(args))),_this),_this.state={showHistoryModal:false},_this.handleClose=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["j" /* setShowEmailModal */])(false));},_this.handleCustomEmailAdd=function(){if(Object(__WEBPACK_IMPORTED_MODULE_13_services_utils_text_util__["f" /* validateEmail */])(_this.props.customEmail)){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["i" /* setShowCustomEmailError */])(false));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["k" /* setShowNewCustomEmail */])(false));var emailId=Math.max.apply(Math,_toConsumableArray(_this.props.emails.map(function(email){return email.id;})))+1;_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["a" /* addEmail */])({id:emailId,label:_this.props.customEmail}));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["b" /* addRecipient */])([emailId,_this.props.customEmail]));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["e" /* setCustomEmail */])(''));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["i" /* setShowCustomEmailError */])(true));}},_this.handleShowCustomEmailAdd=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["k" /* setShowNewCustomEmail */])(true));},_this.handleSubjectChange=function(subject){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["l" /* setSubject */])(subject));},_this.handleMessageChange=function(message){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["g" /* setMessage */])(message));},_this.handleRecipientsChange=function(recipients){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["h" /* setRecipients */])(recipients));},_this.handleCustomEmailChange=function(customEmail){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["e" /* setCustomEmail */])(customEmail));},_this.handleHistoryClick=function(){var _this$props=_this.props,itemId=_this$props.itemId,itemType=_this$props.itemType,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["d" /* loadEmailHistory */])(itemId,itemType));_this.setState({showHistoryModal:true});},_this.isSendButtonEnabled=function(){return _this.props.recipients.length>0&&_this.props.subject!==''&&_this.props.message!=='';},_this.recipientOptions=function(){return _this.uniqueEmails(_this.props.directory.project_contributors.map(function(pc){return pc.users.map(function(user){return{id:user.id,label:user.email};});}).flat(1));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProjectEmailModal,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;if(!this.props.directory||this.props.directory.project_id!==this.props.projectId){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_actions__["j" /* loadDirectoryRequest */])(this.props.projectId)).then(function(response){if(response.ok){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["f" /* setEmails */])(_this2.recipientOptions()));}});}else{this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["f" /* setEmails */])(this.recipientOptions()));}var initPayload={subject:this.props.initialSubject,message:this.props.initialMessage};this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["c" /* initProjectEmailModal */])(initPayload));}},{key:'uniqueEmails',value:function uniqueEmails(emails){var uniques=[];emails.forEach(function(email){if(!uniques.find(function(unique){return unique.id===email.id;})){uniques.push(email);}});return uniques;}},{key:'render',value:function render(){var _this3=this;var _props=this.props,title=_props.title,showEmailModal=_props.showEmailModal,showCustomEmailError=_props.showCustomEmailError,showNewCustomEmail=_props.showNewCustomEmail,recipients=_props.recipients,emails=_props.emails,customEmail=_props.customEmail,message=_props.message,subject=_props.subject,showHistoryButton=_props.showHistoryButton,history=_props.history;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{className:'project-email-modal',show:showEmailModal,title:title,onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-email-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'body-bold'},'To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'users-email-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_dropdown_MultipleDropdown__["a" /* default */],{className:'to-emails-dropdown',dropdownClassName:'alternate-dropdown-control',options:emails,currentValues:recipients,placeholder:'Select emails...',onChange:function onChange(values){return _this3.handleRecipientsChange(values);}}),!showNewCustomEmail&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_ImageButton__["a" /* default */],{alt:'add',src:__WEBPACK_IMPORTED_MODULE_14_images_add_svg___default.a,onClick:this.handleShowCustomEmailAdd})))),showNewCustomEmail&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-email-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__["a" /* default */],{placeholder:'Custom email',valid:!showCustomEmailError,value:customEmail,onChange:function onChange(value){return _this3.handleCustomEmailChange(value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:customEmail==='',label:'Add',onClick:this.handleCustomEmailAdd})),showCustomEmailError&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'Please verify email address.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'with-border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'body-bold'},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subject-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__["a" /* default */],{placeholder:'Subject',value:subject,onChange:function onChange(value){return _this3.handleSubjectChange(value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'with-border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'body-bold message'},'Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_input_TextArea__["a" /* default */],{placeholder:'Message',value:message,onChange:function onChange(value){return _this3.handleMessageChange(value);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},showHistoryButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:'History',onClick:this.handleHistoryClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:!this.isSendButtonEnabled(),label:'Send',onClick:function onClick(){return _this3.props.handleSendEmail({recipients:recipients.map(function(recipient){return recipient[1];}),subject:subject,message:message});}})),this.state.showHistoryModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_email_modal_EmailHistoryModal__["a" /* default */],{show:this.state.showHistoryModal,title:title,history:history,onClose:function onClose(){_this3.setState({showHistoryModal:false});}})));}}]);return ProjectEmailModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{directory:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_directory_store_selectors__["c" /* getDirectory */])(state),showEmailModal:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_email_modal_store_selectors__["g" /* getShowEmailModal */])(state),showCustomEmailError:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_email_modal_store_selectors__["f" /* getShowCustomEmailError */])(state),showNewCustomEmail:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_email_modal_store_selectors__["h" /* getShowNewCustomEmail */])(state),emails:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_email_modal_store_selectors__["b" /* getEmails */])(state),subject:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_email_modal_store_selectors__["i" /* getSubject */])(state),message:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_email_modal_store_selectors__["d" /* getMessage */])(state),recipients:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_email_modal_store_selectors__["e" /* getRecipients */])(state),customEmail:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_email_modal_store_selectors__["a" /* getCustomEmail */])(state),history:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_email_modal_store_selectors__["c" /* getHistory */])(state)};})(ProjectEmailModal));

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getShowCreateProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getShowCreateProposalSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getShowPdfViewer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getShowApproveProposalSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getProjectProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getProjectProposalPdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getProjectProposalAddlItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getProjectProposalItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getProjectProposalForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCsiCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getItemDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getReadOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getShowAwardRecommendation; });
/* unused harmony export getShowEmailModal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getShowLostOrCancelledModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getIsCancelledModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getTerminationCategory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getShowCreateProposal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.proposal.ui.showCreateProposal;},function(showCreateProposal){return showCreateProposal;});var getShowCreateProposalSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.proposal.ui.showCreateProposalSuccess;},function(showCreateProposalSuccess){return showCreateProposalSuccess;});var getShowPdfViewer=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.proposal.ui.showPdfViewer;},function(showPdfViewer){return showPdfViewer;});var getShowApproveProposalSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.proposal.ui.showApproveProposalSuccess;},function(showApproveProposalSuccess){return showApproveProposalSuccess;});var getProjectProposal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.proposal.data.projectProposal;},function(projectProposal){return projectProposal;});var getProjectProposalPdf=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.proposal.data.projectProposalPdf;},function(projectProposalPdf){return projectProposalPdf;});var getProjectProposalAddlItems=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.proposal.ui.projectProposalAddlItems;},function(projectProposalAddlItems){return projectProposalAddlItems;});var getProjectProposalItems=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.proposal.ui.projectProposalItems;},function(projectProposalItems){return projectProposalItems;});var getProjectProposalForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.proposal.ui.projectProposalForm;},function(projectProposalForm){return projectProposalForm;});var getCsiCodes=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.proposal.data.csiCodes;},function(csiCodes){return csiCodes;});var getItemDelete=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.proposal.ui.itemDelete;},function(itemDelete){return itemDelete;});var getReadOnly=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.proposal.ui.readOnly;},function(readOnly){return readOnly;});var getShowAwardRecommendation=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.proposal.ui.showAwardRecommendation;},function(showAwardRecommendation){return showAwardRecommendation;});var getShowEmailModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.emailModal.data.showEmailModal;},function(showEmailModal){return showEmailModal;});var getShowLostOrCancelledModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.proposal.ui.showLostOrCancelledModal;},function(showLostOrCancelledModal){return showLostOrCancelledModal;});var getIsCancelledModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.proposal.ui.isCancelledModal;},function(isCancelledModal){return isCancelledModal;});var getMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.proposal.ui.cancelledLostModal.message;},function(message){return message;});var getDate=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.proposal.ui.cancelledLostModal.date;},function(date){return date;});var getTerminationCategory=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.proposal.ui.cancelledLostModal.terminationCategory;},function(terminationCategory){return terminationCategory;});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getRfis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDueDateFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPageSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getRfiTabSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getRfiModalShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getRfiForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getRfiQuestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getRfiQuestionsDeleted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentRfi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getRfiReadOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getRfiGcAcceleration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getRfiLogPdfViewer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getRfiLogPdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getRfiPdfViewer; });
/* unused harmony export getRfiChatImages */
/* unused harmony export getRfiChatDocuments */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getRfiShowErrorMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getRfis=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.data.rfis;},function(rfis){return rfis;});var getTotal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.data.total;},function(total){return total;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.data.currentPage;},function(currentPage){return currentPage;});var getCurrentStatus=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.data.currentStatus;},function(currentStatus){return currentStatus;});var getDueDateFilter=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.data.dueDateFilter;},function(dueDateFilter){return dueDateFilter;});var getPageSize=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.data.pageSize;},function(pageSize){return pageSize;});var getRfiTabSelected=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.ui.rfiTabSelected;},function(rfiTabSelected){return rfiTabSelected;});var getRfiModalShow=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.ui.rfiModalShow;},function(rfiModalShow){return rfiModalShow;});var getRfiForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.ui.rfiForm;},function(rfiForm){return rfiForm;});var getRfiQuestions=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.ui.rfiQuestions;},function(rfiQuestions){return rfiQuestions;});var getRfiQuestionsDeleted=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.ui.rfiQuestionsDeleted;},function(rfiQuestionsDeleted){return rfiQuestionsDeleted;});var getCurrentRfi=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.data.currentRfi;},function(currentRfi){return currentRfi;});var getRfiReadOnly=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.ui.rfiReadOnly;},function(rfiReadOnly){return rfiReadOnly;});var getRfiGcAcceleration=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.ui.rfiGcAcceleration;},function(rfiGcAcceleration){return rfiGcAcceleration;});var getRfiLogPdfViewer=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.ui.rfiLogPdfViewer;},function(rfiLogPdfViewer){return rfiLogPdfViewer;});var getRfiLogPdf=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.data.rfiLogPdf;},function(rfiLogPdf){return rfiLogPdf;});var getRfiPdfViewer=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.ui.rfiPdfViewer;},function(rfiPdfViewer){return rfiPdfViewer;});var getRfiChatImages=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.ui.chatImages;},function(chatImages){return chatImages;});var getRfiChatDocuments=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.ui.chatDocuments;},function(chatDocuments){return chatDocuments;});var getRfiShowErrorMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.rfiLog.ui.rfiShowErrorMessage;},function(rfiShowErrorMessage){return rfiShowErrorMessage;});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SubmittalStatusKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SubmittalStatusEnum; });
/* harmony export (immutable) */ __webpack_exports__["c"] = submittalStatusLabel;
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var keys={};var SubmittalStatusKeys={DRAFT:'draft',PENDING:'pending',DRAFT_PENDING:'draft_pending',ASSIGNED:'assigned',DRAFT_ASSIGNED:'draft_assigned',APPROVED:'approved',APPROVED_AS_NOTED:'approved_as_noted',REVISE:'revise',REJECTED:'rejected',NOT_REVIEWED:'not_reviewed',FOR_RECORD:'for_record'};var SubmittalStatusEnum=function(){function SubmittalStatusEnum(status,label){_classCallCheck(this,SubmittalStatusEnum);this.status=status;this.label=label;keys[status]=this;}_createClass(SubmittalStatusEnum,[{key:'equals',value:function equals(submittalStatusEnum){return this.status===submittalStatusEnum.status;}}],[{key:'create',value:function create(status){if(keys[status]){return keys[status];}return SubmittalStatusEnum.UNKNOWN;}}]);return SubmittalStatusEnum;}();SubmittalStatusEnum.DRAFT=new SubmittalStatusEnum('draft','Draft');SubmittalStatusEnum.PENDING=new SubmittalStatusEnum('pending','Pending');SubmittalStatusEnum.DRAFT_PENDING=new SubmittalStatusEnum('draft_pending','Draft - Pending');SubmittalStatusEnum.ASSIGNED=new SubmittalStatusEnum('assigned','Assigned');SubmittalStatusEnum.DRAFT_ASSIGNED=new SubmittalStatusEnum('draft_assigned','Draft - Assigned');SubmittalStatusEnum.APPROVED=new SubmittalStatusEnum('approved','No Exceptions Taken/Approved');SubmittalStatusEnum.APPROVED_AS_NOTED=new SubmittalStatusEnum('approved_as_noted','Corrections Required as Noted');SubmittalStatusEnum.REVISE=new SubmittalStatusEnum('revise','Revise and Resubmit as Noted');SubmittalStatusEnum.REJECTED=new SubmittalStatusEnum('rejected','Rejected');SubmittalStatusEnum.NOT_REVIEWED=new SubmittalStatusEnum('not_reviewed','Not Reviewed');SubmittalStatusEnum.FOR_RECORD=new SubmittalStatusEnum('for_record','For Record Only');function submittalStatusLabel(submittal){var statusEnum=SubmittalStatusEnum.create(submittal.status);var label=submittal.stamp_title||statusEnum.label;if(!SubmittalStatusEnum.DRAFT.equals(statusEnum)&&!SubmittalStatusEnum.DRAFT_PENDING.equals(statusEnum)&&!SubmittalStatusEnum.PENDING.equals(statusEnum)&&!SubmittalStatusEnum.DRAFT_ASSIGNED.equals(statusEnum)){label=(submittal.closed?'Closed':'Pending')+' - '+label;}return label;}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(135);
var TAG = __webpack_require__(54)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(70).f;
var has = __webpack_require__(117);
var TAG = __webpack_require__(54)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(672);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["default"])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(195);
var createDesc = __webpack_require__(293);
module.exports = __webpack_require__(172) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(245);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(686);
var enumBugKeys = __webpack_require__(475);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(349);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1171);

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(196));

var _default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

exports.default = _default;

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);
  return false;
}

module.exports = exports["default"];

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(60);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(249);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 252 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _extends.apply(this, arguments);
}

module.exports = _extends;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(1301);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 254 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports = { prefix: 'fas', iconName: 'angle-up', icon: [320, 512, [], "f106", "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"] };

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tradesApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TradesApi=function(_BaseApi){_inherits(TradesApi,_BaseApi);function TradesApi(){_classCallCheck(this,TradesApi);return _possibleConstructorReturn(this,(TradesApi.__proto__||Object.getPrototypeOf(TradesApi)).apply(this,arguments));}_createClass(TradesApi,[{key:'getTrades',value:function getTrades(){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/trades').then(function(response){return{ok:true,trades:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getSubTrades',value:function getSubTrades(idTrade){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/sub_trades?by_trade='+idTrade).then(function(response){return{ok:true,subTrades:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return TradesApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var tradesApi=new TradesApi();/* harmony default export */ __webpack_exports__["a"] = (TradesApi=new TradesApi());

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
});


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useTheme__ = __webpack_require__(1422);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__useTheme__["a"]; });


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildingsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BuildingsApi=function(_BaseApi){_inherits(BuildingsApi,_BaseApi);function BuildingsApi(){_classCallCheck(this,BuildingsApi);return _possibleConstructorReturn(this,(BuildingsApi.__proto__||Object.getPrototypeOf(BuildingsApi)).apply(this,arguments));}_createClass(BuildingsApi,[{key:'getBuildings',value:function getBuildings(clientId,page){var filter='';if(clientId!==undefined){filter='by_client='+clientId;}filter+=page?'&page='+page:'';return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/buildings?'+filter).then(function(response){return{ok:true,buildings:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getBuilding',value:function getBuilding(buildingId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/buildings/'+buildingId).then(function(response){return{ok:true,building:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getWorkOrders',value:function getWorkOrders(buildingId,page,workOrderStatus,critical){var filter='';if(workOrderStatus!==undefined){filter='&'+workOrderStatus.status+'=true';}else if(critical!==undefined&&critical){filter='&critical=true';}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/buildings/'+buildingId+'/work_orders?page='+(page!==undefined?page:1)+filter).then(function(response){return{ok:true,workOrders:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),totalComplete:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-complete']).value(),totalCritical:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-critical']).value(),totalDraft:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-draft']).value(),totalInProgress:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-in_progress']).value(),totalPending:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-pending']).value(),totalPlm:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-plm']).value(),totalWoa:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-woa']).value(),totalClosed:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-closed']).value(),totalDeclined:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-declined']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getProjects',value:function getProjects(buildingId,page,projectStatus){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/buildings/'+buildingId+'/projects?page='+(page!==undefined?page:1)+(projectStatus?'&'+projectStatus+'=true':'')).then(function(response){return{ok:true,projects:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),totalPending:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-pending']).value(),totalInProgress:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-in_progress']).value(),totalComplete:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-complete']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createBuilding',value:function createBuilding(data){var formData=this.createFormData(data);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/buildings',formData).then(function(response){return{ok:true,building:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateBuilding',value:function updateBuilding(buildingId,data){var formData=this.createFormData(data);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/buildings/'+buildingId,formData).then(function(response){return{ok:true,building:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}/**
   * Generates POST data to send to the API.
   *
   * @param data
   *    {
   *      name: string
   *      parkingOnSite: boolean (optional)
   *      location: {
   *        streetAddress: string
   *        unitNumber: string (optional)
   *        city: string
   *        state: string
   *        zipCode: string
   *      }
   *      manager: {  (optional)
   *        firstName: string
   *        lastName: string
   *        email: string
   *        phoneNumber: string (if defined, should not be empty)
   *      }
   *      engineer: {  (optional)
   *        firstName: string
   *        lastName: string
   *        email: string
   *        phoneNumber: string (if defined, should not be empty)
   *      }
   *      documentsToAdd: array (optional)
   *      documentsIdToRemove: array (optional)
   *      contractorsId: array (optional)
   *      unionsId: array (optional)
   *    }
   * @return {FormData}
   */},{key:'createFormData',value:function createFormData(data){var formData=new FormData();if(data.name!==undefined){formData.append('building[name]',data.name);}if(data.propOwnerName!==undefined&&data.propOwnerName!==null){formData.append('building[property_owner_name]',data.propOwnerName);}if(data.parkingOnSite!==undefined&&data.parkingOnSite!==null){formData.append('building[parking_on_site]',data.parkingOnSite);}if(data.location.id){formData.append('building[location_attributes][id]',data.location.id);}formData.append('building[location_attributes][street_address_1]',data.location.streetAddress);if(data.location.unitNumber!==undefined){formData.append('building[location_attributes][street_address_2]',data.location.unitNumber);}formData.append('building[location_attributes][city]',data.location.city);formData.append('building[location_attributes][state]',data.location.state);formData.append('building[location_attributes][zip]',data.location.zipCode);if(data.propOwnerAddress){if(data.propOwnerAddress.id){formData.append('building[property_owner_address_attributes][id]',data.propOwnerAddress.id);}formData.append('building[property_owner_address_attributes][street_address_1]',data.propOwnerAddress.streetAddress);formData.append('building[property_owner_address_attributes][street_address_2]',data.propOwnerAddress.unitNumber);formData.append('building[property_owner_address_attributes][city]',data.propOwnerAddress.city);formData.append('building[property_owner_address_attributes][state]',data.propOwnerAddress.state);formData.append('building[property_owner_address_attributes][zip]',data.propOwnerAddress.zipCode);}if(data.manager!==undefined){formData.append('building[property_manager_attributes][first_name]',data.manager.firstName);formData.append('building[property_manager_attributes][last_name]',data.manager.lastName);formData.append('building[property_manager_attributes][email]',data.manager.email);if(data.manager.phoneNumber!==''){// Don't send phone number if empty to avoid validation
formData.append('building[property_manager_attributes][phone_number]',data.manager.phoneNumber);}}if(data.engineer!==undefined){formData.append('building[engineer_attributes][first_name]',data.engineer.firstName);formData.append('building[engineer_attributes][last_name]',data.engineer.lastName);formData.append('building[engineer_attributes][email]',data.engineer.email);if(data.engineer.phoneNumber!==''){// Don't send phone number if empty to avoid validation
formData.append('building[engineer_attributes][phone_number]',data.engineer.phoneNumber);}}// Append files added
var documentsIndex=0;if(data.documentsToAdd!==undefined&&data.documentsToAdd.length>0){data.documentsToAdd.forEach(function(file){formData.append('building[documents_attributes]['+documentsIndex+'][document]',file);documentsIndex++;});}if(data.documentsIdToRemove!==undefined&&data.documentsIdToRemove.length>0){data.documentsIdToRemove.forEach(function(id){formData.append('building[documents_attributes]['+documentsIndex+'][id]',id);formData.append('building[documents_attributes]['+documentsIndex+'][_destroy]','true');documentsIndex++;});}if(data.contractorsId!==undefined){if(data.contractorsId.length>0){data.contractorsId.forEach(function(subcontractorId){formData.append('building[propietary_sub_contractor_ids][]',subcontractorId);});}else{formData.append('building[propietary_sub_contractor_ids][]','');}}if(data.unionsId!==undefined){data.unionsId.forEach(function(unionId){formData.append('building[union_ids][]',unionId);});}if(data.clientsId!==undefined&&data.clientsId!==null){if(data.clientsId.length>0){data.clientsId.forEach(function(clientId){formData.append('building[client_ids][]',clientId);});}else{formData.append('building[client_ids][]','');}}return formData;}},{key:'updateBuildingNameAndLocation',value:function updateBuildingNameAndLocation(buildingId,locationId,data){var putData={building:{location_attributes:{id:locationId,street_address_1:data.streetAddress,street_address_2:data.unitNumber,city:data.city,state:data.state,zip:data.zipCode}}};if(data.name!==''){putData['building']['name']=data.name;}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/buildings/'+buildingId,putData).then(function(response){return{ok:true,newBuilding:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'uploadDocuments',value:function uploadDocuments(buildingId,documents){var data=new FormData();documents.forEach(function(document){data.append('building[documents_attributes][][document]',document);});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/buildings/'+buildingId,data).then(function(response){return{ok:true,building:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'deleteDocument',value:function deleteDocument(buildingId,documentId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/buildings/'+buildingId,{building:{documents_attributes:[{id:documentId,_destroy:true}]}}).then(function(response){return{ok:true,building:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return BuildingsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var buildingsApi=new BuildingsApi();/* harmony default export */ __webpack_exports__["b"] = (BuildingsApi=new BuildingsApi());

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(306),
    isObject = __webpack_require__(125);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 261 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var defined = __webpack_require__(150);
var fails = __webpack_require__(43);
var spaces = __webpack_require__(541);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(881);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SimpleButton_css__ = __webpack_require__(1879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SimpleButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SimpleButton_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleButton=function(_Component){_inherits(SimpleButton,_Component);function SimpleButton(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SimpleButton);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SimpleButton.__proto__||Object.getPrototypeOf(SimpleButton)).call.apply(_ref,[this].concat(args))),_this),_this.handleOnClick=function(event){event.preventDefault();_this.props.onClick();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SimpleButton,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'simple-button btn button'+(this.props.className!==null?' '+this.props.className:''),disabled:this.props.disabled,onClick:this.handleOnClick},this.props.img!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.img,alt:'plus'}):null,this.props.label);}}]);return SimpleButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SimpleButton.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,img:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};SimpleButton.defaultProps={img:null};/* harmony default export */ __webpack_exports__["a"] = (SimpleButton);

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FormDropDown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/**
 * Wrapper for Dropdown field used inside redux-form.
 * @param props
 * @return {*}
 * @constructor
 */function FormDropDown(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_dropdown_Dropdown__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(option){return props.input.onChange(option?option.value:'');}},props));}

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = setShowChangeOrderQuoteModal;
/* harmony export (immutable) */ __webpack_exports__["f"] = setShowChangeOrderQuoteRequestConfirmation;
/* harmony export (immutable) */ __webpack_exports__["c"] = requestChangeOrderQuote;
/* harmony export (immutable) */ __webpack_exports__["g"] = submitChangeOrderQuote;
/* harmony export (immutable) */ __webpack_exports__["i"] = withdrawChangeOrderQuote;
/* harmony export (immutable) */ __webpack_exports__["j"] = withdrawChangeOrderQuoteRequest;
/* harmony export (immutable) */ __webpack_exports__["h"] = updateChangeOrderQuote;
/* harmony export (immutable) */ __webpack_exports__["d"] = selectChangeOrderQuote;
/* harmony export (immutable) */ __webpack_exports__["a"] = closeChangeOrderQuoteDetailsModal;
/* harmony export (immutable) */ __webpack_exports__["b"] = moveToAcr;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_quotes_store_action_types__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_change_order_tasks_api__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_order_tasks_store_actions__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_details__ = __webpack_require__(34);
function setShowChangeOrderQuoteModal(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_quotes_store_action_types__["b" /* CHANGE_ORDER_QUOTES_REQUEST_MODAL_SET */]};}function setShowChangeOrderQuoteRequestConfirmation(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_quotes_store_action_types__["a" /* CHANGE_ORDER_QUOTES_REQUEST_CONFIRMATION_SET */]};}function requestChangeOrderQuote(changeOrderTaskId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_change_order_tasks_api__["a" /* changeOrderTasksApi */].requestChangeOrderQuote(changeOrderTaskId,values).then(function(response){if(response.ok){dispatch(setShowChangeOrderQuoteModal());dispatch(setShowChangeOrderQuoteRequestConfirmation());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_order_tasks_store_actions__["f" /* updateChangeOrderTask */])(response.changeOrderTask));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function submitChangeOrderQuote(changeOrderTaskId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_change_order_tasks_api__["a" /* changeOrderTasksApi */].submitChangeOrderQuote(changeOrderTaskId,values).then(function(response){if(response.ok){dispatch(setShowChangeOrderQuoteModal());dispatch(setShowChangeOrderQuoteRequestConfirmation());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_order_tasks_store_actions__["f" /* updateChangeOrderTask */])(response.changeOrderTask));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function withdrawChangeOrderQuote(changeOrderTaskId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_change_order_tasks_api__["a" /* changeOrderTasksApi */].withdrawChangeOrderQuote(changeOrderTaskId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_order_tasks_store_actions__["f" /* updateChangeOrderTask */])(response.changeOrderTask));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function withdrawChangeOrderQuoteRequest(changeOrderTaskId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_change_order_tasks_api__["a" /* changeOrderTasksApi */].withdrawChangeOrderQuoteRequest(changeOrderTaskId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_order_tasks_store_actions__["f" /* updateChangeOrderTask */])(response.changeOrderTask));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateChangeOrderQuote(changeOrderTaskId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_change_order_tasks_api__["a" /* changeOrderTasksApi */].updateChangeOrderQuote(changeOrderTaskId,values).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_order_tasks_store_actions__["f" /* updateChangeOrderTask */])(response.changeOrderTask));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function selectChangeOrderQuote(changeOrderTaskId){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_quotes_store_action_types__["c" /* CHANGE_ORDER_QUOTES_SELECT */],payload:changeOrderTaskId};}function closeChangeOrderQuoteDetailsModal(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_quotes_store_action_types__["d" /* CHANGE_ORDER_QUOTE_DETAILS_MODAL_CLOSE */]};}function moveToAcr(workOrderId,changeOrderTaskIds){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_change_order_tasks_api__["a" /* changeOrderTasksApi */].moveToAcr(workOrderId,changeOrderTaskIds).then(function(response){if(response.ok){response.changeOrderTasks.forEach(function(cot){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_order_tasks_store_actions__["f" /* updateChangeOrderTask */])(cot));});dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_details__["L" /* loadWorkOrderRequest */])(workOrderId,true,false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_details__["W" /* selectNavigationBar */])(workOrderId,1));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_details__["v" /* detailsMovedToAcr */])());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TasksReviewTable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_table_ComplexTable__ = __webpack_require__(2167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TasksReviewTable_css__ = __webpack_require__(2169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TasksReviewTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TasksReviewTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_checkbox_CheckBox__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_numeral__);
function TasksReviewTable(props){var handleSelection=function handleSelection(id){if(props.onSelection){props.onSelection(id);}};var headers=[];if(props.showSelection){headers.push('');}headers.push('TASK');headers.push('DETAILS');headers.push('MATERIAL LEAD TIME');if(props.showContractor){headers.push('CONTRACTOR');}headers.push('COST');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tasks-review-table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_table_ComplexTable__["a" /* default */],{className:'tasks-review-table'+(props.showContractor?' with-contractor':'')+(props.showSelection?' with-selection':''),emptyMessage:'',headers:headers,rows:valueRows(props,handleSelection)}));}function valueRows(props,handleSelection){var rows=[];props.values.forEach(function(item,index){var row=[];if(props.showSelection){row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'with-check-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_checkbox_CheckBox__["a" /* default */],{id:item.id,checked:item.selected,shape:'round',size:'medium',onChange:handleSelection})));}row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold'},'#',item.number));row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold'},item.details));row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold'},item.materialLeadTime));if(props.showContractor){row.push(item.contractor);}row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:item.cost,format:'$0,0.00'})));rows.push(row);if(item.breakdownItems&&item.breakdownItems.length>0){rows.push([__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'breakdownItemsTable '+(props.showSelection?' with-selection':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:3}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:4}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:5}),props.showSelection&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:6})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,props.showSelection&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'DETAILS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'UNITS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'COST')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'EXT')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,item.breakdownItems.map(function(bi,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},props.showSelection&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-regular'},bi.concept)),__WEBPACK_IMPORTED_MODULE_6_numeral___default()(bi.ext).value()>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-regular'},bi.unit_number,'\xA0',bi.unit_type)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-regular'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:bi.cost,format:'$0,0.00'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-regular'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:bi.ext,format:'$0,0.00'})))),__WEBPACK_IMPORTED_MODULE_6_numeral___default()(bi.ext).value()===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-regular'},'Included'))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,props.showSelection&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-regular'},'OH&P')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-regular'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:(item.markup+item.fee)/item.cost,format:'0.00 %'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-regular'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:item.cost,format:'$0,0.00'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-regular'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:item.markup+item.fee,format:'$0,0.00'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,props.showSelection&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-regular'},'Insurance')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-regular'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:item.insurance/item.cost,format:'0.00 %'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-regular'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:item.cost,format:'$0,0.00'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-regular'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:item.insurance,format:'$0,0.00'}))))))]);}});return rows;}TasksReviewTable.propTypes={showContractor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showSelection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,values:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,number:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,details:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,contractor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,cost:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool})),onSelection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};TasksReviewTable.defaultProps={showContractor:false,showSelection:false,values:[]};

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CostsDatesProposal_css__ = __webpack_require__(2170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CostsDatesProposal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CostsDatesProposal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_orders_store_actions__ = __webpack_require__(183);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CostsDatesProposal=function(_Component){_inherits(CostsDatesProposal,_Component);function CostsDatesProposal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CostsDatesProposal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CostsDatesProposal.__proto__||Object.getPrototypeOf(CostsDatesProposal)).call.apply(_ref,[this].concat(args))),_this),_this.handleCompletionDateChange=function(value){if(_this.props.isChangeOrder){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_orders_store_actions__["u" /* updateCOCompletionDate */])(value));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal__["w" /* updateCompletionDate */])(value));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CostsDatesProposal,[{key:'render',value:function render(){var props=this.props;var showTotalBorder=props.startDate!==null||props.completionDate!==null||props.cost!==null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'costs-totals-container'},props.isChangeOrder?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ctc-row'+(showTotalBorder?' with-border':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'CHANGE ORDER AMOUNT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cost-value'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Number__["a" /* default */],{value:props.total,format:'$0,0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ctc-row'+(showTotalBorder?' with-border':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'PREVIOUS CONTRACT AMOUNT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cost-value'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Number__["a" /* default */],{value:props.previousCost,format:'$0,0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ctc-row'+(showTotalBorder?' with-border':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'orange'},'NEW CONTRACT AMOUNT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'total-value'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Number__["a" /* default */],{value:props.previousCost+__WEBPACK_IMPORTED_MODULE_6_numeral___default()(props.total).value(),format:'$0,0'})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ctc-row'+(showTotalBorder?' with-border':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'orange'},'TOTAL'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'total-value'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Number__["a" /* default */],{value:props.total,format:'$0,0'}))),props.startDate!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ctc-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Start Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{format:'M/D/YYYY',placeholder:'',readOnly:true,value:props.startDate,onChange:function onChange(){}}))),props.completionDate!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ctc-row '+(props.completionDate.editable?'without-padding':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:props.completionDate.editable?'orange':null},'Completion Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{format:'M/D/YYYY',placeholder:'',readOnly:!props.completionDate.editable,value:props.completionDate.value,onChange:this.handleCompletionDateChange}))),props.cost!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ctc-row with-border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'COST'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cost-value'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Number__["a" /* default */],{value:props.cost,format:'$0,0'}))));}}]);return CostsDatesProposal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CostsDatesProposal.propTypes={completionDate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({editable:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string}),cost:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,startDate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,total:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,onCompletionDateChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};CostsDatesProposal.defaultProps={completionDate:null,cost:null,startDate:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(CostsDatesProposal));

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_admin_work_orders_details_qualifications__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QualificationsViewer__ = __webpack_require__(2173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_qualifications__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__QualificationsContainer_css__ = __webpack_require__(2175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__QualificationsContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__QualificationsContainer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NewQualificationModal__ = __webpack_require__(2176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_domain_qualification_type_enum__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QualificationsContainer=function(_Component){_inherits(QualificationsContainer,_Component);function QualificationsContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,QualificationsContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=QualificationsContainer.__proto__||Object.getPrototypeOf(QualificationsContainer)).call.apply(_ref,[this].concat(args))),_this),_this.handleAddQualification=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_qualifications__["j" /* setShowNewQualificationModal */])(true));},_this.handleQualificationSelected=function(qualificationId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_qualifications__["h" /* qualificationSelected */])(qualificationId));},_this.handleOptionSelected=function(qualificationId,option){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_qualifications__["g" /* optionSelected */])(qualificationId,option));},_this.mapQualifications=function(qualifications){return qualifications.map(function(qualification){var selectedQualification=_this.props.selectedQualificationsById[qualification.id];return{id:qualification.id,label:qualification.label,options:qualification.options.map(function(option,index){var selected=false;if(selectedQualification!==undefined&&selectedQualification.option!==null){selected=selectedQualification.option.label===option;}return{id:index,label:option,selected:selected};}),selected:selectedQualification!==undefined,trade:qualification.trade!==null&&qualification.trade!==undefined?{value:qualification.trade.value,label:qualification.trade.label}:null,// trade could be undefined
type:__WEBPACK_IMPORTED_MODULE_7_domain_qualification_type_enum__["a" /* QualificationTypeEnum */].get(qualification.q_type)};});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(QualificationsContainer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qualifications-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h3'},'Qualifications'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__QualificationsViewer__["a" /* default */],{qualifications:this.mapQualifications(this.props.qualifications),readOnly:this.props.readOnly,onOptionSelected:this.handleOptionSelected,onQualificationSelected:this.handleQualificationSelected}),!this.props.readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qualifications-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-orange',value:'Add Qualification',onClick:this.handleAddQualification})),this.props.showNewQualificationModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__NewQualificationModal__["a" /* default */],null));}}]);return QualificationsContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);QualificationsContainer.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool};QualificationsContainer.defaultProps={readOnly:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{qualifications:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_work_orders_details_qualifications__["a" /* getQualifications */])(state),// loaded on ProposalModal (defaults) or ProposalApprovalModal
selectedQualificationsById:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_work_orders_details_qualifications__["b" /* getSelectedQualificationsById */])(state),// loaded on ProposalModal (defaults) or ProposalApprovalModal
showNewQualificationModal:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_work_orders_details_qualifications__["c" /* getShowNewQualificationModal */])(state)};})(QualificationsContainer));

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addQualificationRequest;
/* harmony export (immutable) */ __webpack_exports__["b"] = addQualificationSuccess;
/* harmony export (immutable) */ __webpack_exports__["c"] = clearQualificationsSelected;
/* harmony export (immutable) */ __webpack_exports__["d"] = loadDefaultQualificationsRequest;
/* harmony export (immutable) */ __webpack_exports__["e"] = loadQualificationsSuccess;
/* harmony export (immutable) */ __webpack_exports__["f"] = loadTradesRequest;
/* unused harmony export loadTradesSuccess */
/* harmony export (immutable) */ __webpack_exports__["g"] = optionSelected;
/* harmony export (immutable) */ __webpack_exports__["h"] = qualificationSelected;
/* harmony export (immutable) */ __webpack_exports__["i"] = setSelectedQualificationsById;
/* harmony export (immutable) */ __webpack_exports__["j"] = setShowNewQualificationModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_qualifications_api__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_trades_api__ = __webpack_require__(256);
function addQualificationRequest(values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_qualifications_api__["a" /* qualificationsApi */].createQualification(values).then(function(response){if(response.ok){dispatch(setShowNewQualificationModal(false));dispatch(addQualificationSuccess(response.qualification));// Mark added qualification as selected
dispatch(qualificationSelected(response.qualification.id));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function addQualificationSuccess(qualification){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_action_types__["_113" /* WORK_ORDERS_DETAILS_QUALIFICATIONS_ADD_SUCCESS */],payload:qualification};}function clearQualificationsSelected(){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_action_types__["_119" /* WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED_CLEAR */]};}function loadDefaultQualificationsRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_qualifications_api__["a" /* qualificationsApi */].getQualifications(true).then(function(response){if(response.ok){dispatch(loadQualificationsSuccess(response.qualifications));// Select all default qualifications
response.qualifications.forEach(function(qualification){return dispatch(qualificationSelected(qualification.id));});}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadQualificationsSuccess(qualifications){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_action_types__["_114" /* WORK_ORDERS_DETAILS_QUALIFICATIONS_LOAD_SUCCESS */],payload:qualifications};}function loadTradesRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_trades_api__["b" /* tradesApi */].getTrades().then(function(response){if(response.ok){dispatch(loadTradesSuccess(response.trades));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadTradesSuccess(trades){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_action_types__["_120" /* WORK_ORDERS_DETAILS_QUALIFICATIONS_TRADES_LOAD_SUCCESS */],payload:trades};}function optionSelected(qualificationId,option){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_action_types__["_116" /* WORK_ORDERS_DETAILS_QUALIFICATIONS_OPTION_SELECTED */],payload:{qualificationId:qualificationId,option:option}};}function qualificationSelected(qualificationId){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_action_types__["_117" /* WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED */],payload:qualificationId};}function setSelectedQualificationsById(selectedQualificationsById){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_action_types__["_118" /* WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED_BY_ID_SET */],payload:selectedQualificationsById};}function setShowNewQualificationModal(show){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_action_types__["_115" /* WORK_ORDERS_DETAILS_QUALIFICATIONS_MODAL_SHOW */],payload:show};}

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProposalStatus; });
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var byIds={};var ProposalStatus=function(){function ProposalStatus(id){_classCallCheck(this,ProposalStatus);this.id=id;byIds[id]=this;}_createClass(ProposalStatus,[{key:'equals',value:function equals(object){if(typeof object==='string'){return this.id===object;}else if((typeof object==='undefined'?'undefined':_typeof(object))==='object'&&object.hasOwnProperty('id')){return this.id===object.id;}else{return false;}}}],[{key:'getById',value:function getById(id){if(byIds[id]){return byIds[id];}return null;}}]);return ProposalStatus;}();ProposalStatus.WAITING=new ProposalStatus('waiting');ProposalStatus.APPROVED=new ProposalStatus('approved');ProposalStatus.REJECTED=new ProposalStatus('rejected');ProposalStatus.WITHDRAWN=new ProposalStatus('withdrawn');

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sortByAttribute;
/**
 * Sort the array, based on the attribute of the array's objects.
 * Assumes each object contains the attribute.
 * The array is sorted in place.
 *
 * @param array
 * @param attribute
 * @param asc
 * @return {*}
 */function sortByAttribute(array,attribute,asc){var ascOrder=asc!==undefined?asc:true;return array.sort(function(a,b){if(a[attribute]<b[attribute]){return ascOrder?-1:1;}if(a[attribute]>b[attribute]){return ascOrder?1:-1;}return 0;});}

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProjectStatusKeys */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProjectStatusEnum; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var keys={};var ProjectStatusKeys={CANCELLED:'cancelled',PENDING:'pending',IN_PROGRESS:'in_progress',COMPLETE:'complete',LOST:'lost',PRECON:'precon'};var ProjectStatusEnum=function(){function ProjectStatusEnum(status,label){_classCallCheck(this,ProjectStatusEnum);this.status=status;this.label=label;keys[status]=this;}_createClass(ProjectStatusEnum,[{key:'equals',value:function equals(projectStatusEnum){return this.status===projectStatusEnum.status;}}],[{key:'create',value:function create(status){if(keys[status]){return keys[status];}return ProjectStatusEnum.UNKNOWN;}}]);return ProjectStatusEnum;}();ProjectStatusEnum.PENDING=new ProjectStatusEnum('pending','Bid/Budget');ProjectStatusEnum.IN_PROGRESS=new ProjectStatusEnum('in_progress','in progress');ProjectStatusEnum.COMPLETE=new ProjectStatusEnum('complete','complete');ProjectStatusEnum.LOST=new ProjectStatusEnum('lost','lost');ProjectStatusEnum.CANCELLED=new ProjectStatusEnum('cancelled','cancelled');ProjectStatusEnum.PRECON=new ProjectStatusEnum('precon','precon');

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export baseRoutePath */
/* harmony export (immutable) */ __webpack_exports__["a"] = addEngineer;
/* harmony export (immutable) */ __webpack_exports__["b"] = addFiles;
/* unused harmony export changePage */
/* harmony export (immutable) */ __webpack_exports__["c"] = editBuilding;
/* harmony export (immutable) */ __webpack_exports__["d"] = goToBuilding;
/* harmony export (immutable) */ __webpack_exports__["e"] = loadBuildingDetailsRequest;
/* unused harmony export loadBuildingSuccess */
/* harmony export (immutable) */ __webpack_exports__["g"] = loadClientsRequest;
/* unused harmony export loadClientsSuccess */
/* unused harmony export loadWorkOrdersSuccess */
/* unused harmony export loadProjectsSuccess */
/* harmony export (immutable) */ __webpack_exports__["p"] = selectContractor;
/* harmony export (immutable) */ __webpack_exports__["m"] = removeContractor;
/* harmony export (immutable) */ __webpack_exports__["f"] = loadBuildingsRequest;
/* unused harmony export loadBuildingsSuccess */
/* unused harmony export setBuildingsPaginationData */
/* harmony export (immutable) */ __webpack_exports__["j"] = loadWorkOrdersRequest;
/* harmony export (immutable) */ __webpack_exports__["h"] = loadProjectsRequest;
/* harmony export (immutable) */ __webpack_exports__["i"] = loadUnionsRequest;
/* unused harmony export loadUnionsSuccess */
/* harmony export (immutable) */ __webpack_exports__["k"] = newBuilding;
/* unused harmony export clearBuildingData */
/* harmony export (immutable) */ __webpack_exports__["l"] = removeClient;
/* harmony export (immutable) */ __webpack_exports__["n"] = removeFile;
/* harmony export (immutable) */ __webpack_exports__["o"] = selectClient;
/* harmony export (immutable) */ __webpack_exports__["q"] = selectParkingOnSite;
/* harmony export (immutable) */ __webpack_exports__["r"] = selectUnion;
/* harmony export (immutable) */ __webpack_exports__["s"] = submitFormRequest;
/* unused harmony export createBuildingDataObject */
/* unused harmony export invalidForm */
/* unused harmony export validForm */
/* harmony export (immutable) */ __webpack_exports__["t"] = updateFormFromCurrentBuilding;
/* harmony export (immutable) */ __webpack_exports__["u"] = updateFormValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_buildings_api__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_union_api__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_api_clients_api__ = __webpack_require__(122);
var baseRoutePath='/admin/buildings';function addEngineer(){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["m" /* BUILDINGS_NEW_ENGINEER_ADD */]};}function addFiles(files){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["n" /* BUILDINGS_NEW_FILES_ADD */],payload:files};}function changePage(newPage){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["e" /* BUILDINGS_BUILDING_WORK_ORDERS_PAGE_CHANGE */],payload:newPage};}function editBuilding(buildingId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["d" /* push */])(baseRoutePath+'/'+buildingId+'/edit'));};}function goToBuilding(buildingId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["d" /* push */])(baseRoutePath+'/'+buildingId));};}function loadBuildingDetailsRequest(buildingId,loadClients){return function(dispatch){var promises=[];promises.push(__WEBPACK_IMPORTED_MODULE_3_services_api_buildings_api__["a" /* buildingsApi */].getBuilding(buildingId));if(loadClients){promises.push(__WEBPACK_IMPORTED_MODULE_5_services_api_clients_api__["a" /* clientsApi */].getClients());}return Promise.all(promises).then(function(values){var result={};if(values[0].ok&&(!loadClients||values[1].ok)){dispatch(loadBuildingSuccess(values[0].building));if(loadClients){dispatch(loadClientsSuccess(values[1].clients));}dispatch(changePage(1));result.ok=true;}else{var errors=[];if(!values[0].ok){errors=errors.concat(values[0].errors);}if(loadClients&&!values[1].ok){errors=errors.concat(values[1].errors);}dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(errors));result.ok=false;}return result;});};}function loadBuildingSuccess(building){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["b" /* BUILDINGS_BUILDING_LOAD_SUCCESS */],payload:building};}function loadClientsRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5_services_api_clients_api__["a" /* clientsApi */].getClients().then(function(response){var result={};if(response.ok){dispatch(loadClientsSuccess(response.clients));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}return result;});};}function loadClientsSuccess(clients){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["a" /* BUILDINGS_BUILDING_CLIENTS_LOAD_SUCCESS */],payload:clients};}function loadWorkOrdersSuccess(workOrders){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["d" /* BUILDINGS_BUILDING_WORK_ORDERS_LOAD_SUCCESS */],payload:workOrders};}function loadProjectsSuccess(projects){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["c" /* BUILDINGS_BUILDING_PROJECTS_LOAD_SUCCESS */],payload:projects};}function selectContractor(contractor){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["l" /* BUILDINGS_NEW_CONTRACTOR_SELECT */],payload:contractor};}function removeContractor(selectedContractorId){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["k" /* BUILDINGS_NEW_CONTRACTOR_REMOVE */],payload:selectedContractorId};}function loadBuildingsRequest(page){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_buildings_api__["a" /* buildingsApi */].getBuildings(undefined,page).then(function(response){if(response.ok){dispatch(loadBuildingsSuccess(response.buildings));if(page){dispatch(setBuildingsPaginationData(page,response.total,response.pageSize));}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadBuildingsSuccess(buildings){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["g" /* BUILDINGS_LOAD_SUCCESS */],payload:buildings};}function setBuildingsPaginationData(page,total,pageSize){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["v" /* BUILDINGS_SET_PAGINATION_DATA */],payload:{page:page,total:total,pageSize:pageSize}};}function loadWorkOrdersRequest(buildingId,page,workOrderStatus,critical){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_buildings_api__["a" /* buildingsApi */].getWorkOrders(buildingId,page,workOrderStatus,critical).then(function(response){if(response.ok){dispatch(loadWorkOrdersSuccess(response.workOrders));dispatch(changePage(page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadProjectsRequest(buildingId,page){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_buildings_api__["a" /* buildingsApi */].getProjects(buildingId,page).then(function(response){if(response.ok){dispatch(loadProjectsSuccess(response.projects));dispatch(changePage(page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadUnionsRequest(unions){return function(dispatch){if(unions===undefined||unions.length===0){return __WEBPACK_IMPORTED_MODULE_4_services_api_union_api__["b" /* unionsApi */].getUnions().then(function(response){if(response.ok){dispatch(loadUnionsSuccess(response.unions));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}});}else{return Promise.resolve([]);}};}function loadUnionsSuccess(unions){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["t" /* BUILDINGS_NEW_UNIONS_LOAD_SUCCESS */],payload:unions};}function newBuilding(){return function(dispatch){dispatch(clearBuildingData());dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["d" /* push */])(baseRoutePath+'/new'));};}function clearBuildingData(){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["h" /* BUILDINGS_NEW_CLEAR_DATA */]};}function removeClient(clientId){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["i" /* BUILDINGS_NEW_CLIENT_REMOVE */],payload:clientId};}function removeFile(index){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["o" /* BUILDINGS_NEW_FILE_REMOVE */],payload:index};}function selectClient(clientId){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["j" /* BUILDINGS_NEW_CLIENT_SELECT */],payload:clientId};}function selectParkingOnSite(value){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["s" /* BUILDINGS_NEW_PARKING_ON_SITE_SELECT */],payload:value==='true'};}function selectUnion(value,unions,selectedUnionsId){var newUnions=[];if(value==='all'){if(unions.length!==selectedUnionsId.length){// Select all (in the other case, just return an empty array)
newUnions=unions.map(function(element){return element.id;});}}else{if(selectedUnionsId.find(function(element){return element===value;})!==undefined){newUnions=selectedUnionsId.filter(function(element){return element!==value;});}else{newUnions=selectedUnionsId.concat(value);}}return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["u" /* BUILDINGS_NEW_UNIONS_SELECT */],payload:newUnions};}function submitFormRequest(form,selectedUnionsId,selectedContractors,files,parkingOnSite,buildingId,selectedClientsId){return function(dispatch){// Validate form
var requiredFields=['streetAddress','city','state','zipCode'];var invalidFields=[];requiredFields.forEach(function(attribute){if(form[attribute]===''){invalidFields.push(attribute);}});if(invalidFields.length>0){dispatch(invalidForm(invalidFields,'The outlined inputs should be added in order to add a building.'));}else{dispatch(validForm());var data=createBuildingDataObject(form,parkingOnSite,files,selectedContractors,selectedUnionsId,selectedClientsId);var promise=void 0;if(buildingId!==undefined){promise=__WEBPACK_IMPORTED_MODULE_3_services_api_buildings_api__["a" /* buildingsApi */].updateBuilding(buildingId,data);}else{promise=__WEBPACK_IMPORTED_MODULE_3_services_api_buildings_api__["a" /* buildingsApi */].createBuilding(data);}return promise.then(function(response){if(response.ok){if(buildingId!==undefined){dispatch(loadBuildingSuccess(response.building));dispatch(goToBuilding(buildingId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["d" /* push */])(baseRoutePath));}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}});}};}function createBuildingDataObject(form,parkingOnSite,files,selectedContractors,selectedUnionsId,selectedClientsId){var data={name:form.buildingName,propOwnerName:form.propOwnerName,parkingOnSite:parkingOnSite,location:{id:form.locationId,streetAddress:form.streetAddress,city:form.city,state:form.state,zipCode:form.zipCode},// filter all files not removed that are not backend document
documentsToAdd:files.filter(function(element){return!element.removed&&element.file!==null;}).map(function(element){return element.file;}),// filter all files removed that are backend documents
documentsIdToRemove:files.filter(function(element){return element.removed&&element.document!==null;}).map(function(element){return element.document.id;}),clientsId:selectedClientsId!==undefined?selectedClientsId:[],contractorsId:selectedContractors.map(function(element){return element.value;}),unionsId:selectedUnionsId};if(form.propOwnerAddressId||form.propOwnerStreetAddress||form.propOwnerUnitNumber||form.propOwnerCity||form.propOwnerState||form.propOwnerZipCode){data['propOwnerAddress']={id:form.propOwnerAddressId,streetAddress:form.propOwnerStreetAddress,unitNumber:form.propOwnerUnitNumber,city:form.propOwnerCity,state:form.propOwnerState,zipCode:form.propOwnerZipCode};}data['manager']={firstName:form.managerFirstName,lastName:form.managerLastName,email:form.managerEmail,phoneNumber:form.managerPhoneNumber};data['engineer']={firstName:form.engineerFirstName,lastName:form.engineerLastName,email:form.engineerEmail,phoneNumber:form.engineerPhoneNumber};if(form.unitNumber!==''){data['location']['unitNumber']=form.unitNumber;}return data;}function invalidForm(invalidFields,message){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["p" /* BUILDINGS_NEW_FORM_INVALID */],payload:{invalidFields:invalidFields,message:message}};}function validForm(){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["q" /* BUILDINGS_NEW_FORM_VALID */]};}function updateFormFromCurrentBuilding(currentBuilding){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["f" /* BUILDINGS_EDIT_FORM_LOAD_FROM_CURRENT */],payload:currentBuilding};}function updateFormValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_buildings_action_types__["r" /* BUILDINGS_NEW_FORM_VALUE_CHANGE */],payload:{attribute:attribute,value:value}};}

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAASCAYAAABM8m7ZAAAAAXNSR0IArs4c6QAAAYJJREFUSA3V1TFLw0AUB/D3Lo2gKK76CfRrlLq4CFpLB1sRlbbkYzg5uAkVq4NoOlVXxal+A3FSxFHQUShYxZrnveALtab2kmbxlpdeLve7f7hcMVssV8CjbQC8UbaVbxxVnyHhRkS4XKzsAEEJkC7VwlwesyulFwKYZAsB7pSdSieJ++hq+ZA8WJc8llIZxUmlQy9g1vvoNHNrzpT0DVO/kx50owjYHvHse8Wvl5MKkBQeoEQbMjcgvqOlsvX67qM2ATghJ2VUBg3z2vuhSqnF0+O9CzZ8mC+Swk3QH3ASuCn6Cx4Gj4KGwnHwqGhfOAoeB/0TNsEZ1SdfTZ9Imzzeb/qT6d690t1bg13de0N++7u983mlkRnp09/C7RhA5hVgKw7K8wyEeVChUJpuAzZ78JZGJ/i+3wyTBsPlYlANTS4PRUT5MaPEMn94cn0MIiydneyfyziTqv8kzJvr1p5GgdJ6tf7ZrsG3OCiLkRLLEnOOM06tzjxS6rrhVh+k/1/UL7itH0iRJfuaAAAAAElFTkSuQmCC"

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["s"] = setServiceProviderDropdown;
/* unused harmony export setServiceProviderData */
/* unused harmony export setServiceProviderUserData */
/* harmony export (immutable) */ __webpack_exports__["p"] = setCompanyData;
/* unused harmony export setCurrentUserCompany */
/* harmony export (immutable) */ __webpack_exports__["m"] = loadServiceProviders;
/* harmony export (immutable) */ __webpack_exports__["n"] = loadServiceProvidersUser;
/* harmony export (immutable) */ __webpack_exports__["l"] = loadServiceProviderById;
/* unused harmony export loadCurrentUserCompany */
/* unused harmony export updateCurrentUserCompany */
/* harmony export (immutable) */ __webpack_exports__["v"] = updateServiceProvider;
/* harmony export (immutable) */ __webpack_exports__["d"] = createServiceProvider;
/* harmony export (immutable) */ __webpack_exports__["a"] = changePage;
/* unused harmony export setTotal */
/* harmony export (immutable) */ __webpack_exports__["r"] = setNameToSearch;
/* unused harmony export setPageSize */
/* harmony export (immutable) */ __webpack_exports__["o"] = loadUserForm;
/* harmony export (immutable) */ __webpack_exports__["c"] = clearUserData;
/* harmony export (immutable) */ __webpack_exports__["b"] = clearFilters;
/* harmony export (immutable) */ __webpack_exports__["u"] = setShowEditUserModal;
/* harmony export (immutable) */ __webpack_exports__["t"] = setShowConfirmationModal;
/* harmony export (immutable) */ __webpack_exports__["q"] = setCurrentUserId;
/* harmony export (immutable) */ __webpack_exports__["f"] = editUser;
/* harmony export (immutable) */ __webpack_exports__["k"] = inviteUser;
/* harmony export (immutable) */ __webpack_exports__["e"] = deleteUser;
/* harmony export (immutable) */ __webpack_exports__["j"] = goToServiceProviders;
/* harmony export (immutable) */ __webpack_exports__["h"] = goToNewServiceProvider;
/* harmony export (immutable) */ __webpack_exports__["i"] = goToServiceProviderDetails;
/* harmony export (immutable) */ __webpack_exports__["g"] = goToEditServiceProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_service_providers_api__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_service_providers_store_action_types__ = __webpack_require__(968);
var baseRoutePath='/admin/service-providers';var baseRoutePathTeam='/admin/team';function setServiceProviderDropdown(project){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_service_providers_store_action_types__["l" /* SET_SERVICE_PROVIDER_DROPDOWN */],payload:project};}function setServiceProviderData(project){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_service_providers_store_action_types__["k" /* SET_SERVICE_PROVIDER_DATA */],payload:project};}function setServiceProviderUserData(userData){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_service_providers_store_action_types__["m" /* SET_SERVICE_PROVIDER_USER_DATA */],payload:userData};}function setCompanyData(company){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_service_providers_store_action_types__["f" /* SET_COMPANY_DATA */],payload:company};}function setCurrentUserCompany(company){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_service_providers_store_action_types__["h" /* SET_CURRENT_USER_COMPANY */],payload:company};}function loadServiceProviders(type,name,page){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_service_providers_api__["a" /* serviceProvidersApi */].getServiceProviders(type,name,page,false).then(function(response){if(response.ok){dispatch(setServiceProviderData(response.serviceProviders));dispatch(setTotal(response.total));dispatch(setPageSize(response.pageSize));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadServiceProvidersUser(type,serviceProviderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_service_providers_api__["a" /* serviceProvidersApi */].getServiceProviderUsers(type,serviceProviderId,false).then(function(response){if(response.ok){dispatch(setServiceProviderUserData(response.users));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadServiceProviderById(type,serviceProviderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_service_providers_api__["a" /* serviceProvidersApi */].showServiceProviderById(type,serviceProviderId,false).then(function(response){if(response.ok){response.serviceProvider.type=type;dispatch(setCompanyData(response.serviceProvider));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadCurrentUserCompany(type,id){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_service_providers_api__["a" /* serviceProvidersApi */].showServiceProviderById(type,id,false).then(function(response){if(response.ok){dispatch(setCurrentUserCompany(response.serviceProvider));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateCurrentUserCompany(type,id,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_service_providers_api__["a" /* serviceProvidersApi */].updateServiceProvider(type,id,values).then(function(response){if(response.ok){dispatch(setCurrentUserCompany(response.serviceProvider));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateServiceProvider(type,id,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_service_providers_api__["a" /* serviceProvidersApi */].updateServiceProvider(type,id,values).then(function(response){if(response.ok){dispatch(setCompanyData(response.serviceProvider));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function createServiceProvider(type,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_service_providers_api__["a" /* serviceProvidersApi */].createServiceProvider(type,values).then(function(response){if(response.ok){dispatch(setCompanyData(response.serviceProvider));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function changePage(page){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_service_providers_store_action_types__["g" /* SET_CURRENT_PAGE */],payload:page};}function setTotal(total){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_service_providers_store_action_types__["n" /* SET_TOTAL */],payload:total};}function setNameToSearch(name){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_service_providers_store_action_types__["i" /* SET_NAME_TO_SEARCH */],payload:name};}function setPageSize(pageSize){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_service_providers_store_action_types__["j" /* SET_PAGE_SIZE */],payload:pageSize};}function loadUserForm(user){return function(dispatch){var form={id:user.id,accountableId:user.accountable_id,type:user.accountable_type,buildingsId:user.building_ids,firstName:user.first_name,lastName:user.last_name,email:user.email,phoneNumber:user.phone_number?Object(__WEBPACK_IMPORTED_MODULE_3_services_utils_text_util__["c" /* formatPhoneNumber */])(user.phone_number):'',phoneExt:user.phone_ext?user.phone_ext:'',rolesId:user.roles?user.roles.map(function(role){return role.id;}):null,title:user.title?user.title:''};dispatch({type:__WEBPACK_IMPORTED_MODULE_4_components_admin_service_providers_store_action_types__["b" /* SERVICE_PROVIDERS_INVITE_USER_FORM_LOAD */],payload:form});};}function clearUserData(){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_service_providers_store_action_types__["b" /* SERVICE_PROVIDERS_INVITE_USER_FORM_LOAD */]};}function clearFilters(){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_service_providers_store_action_types__["a" /* SERVICE_PROVIDERS_CLEAR_FILTERS */]};}function setShowEditUserModal(open){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_service_providers_store_action_types__["d" /* SERVICE_PROVIDERS_INVITE_USER_MODAL_SHOW */],payload:open};}function setShowConfirmationModal(open){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_service_providers_store_action_types__["e" /* SERVICE_PROVIDERS_SHOW_CONFIRMATION_MODAL */],payload:open};}function setCurrentUserId(userId){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_service_providers_store_action_types__["c" /* SERVICE_PROVIDERS_INVITE_USER_ID_SET */],payload:userId};}function editUser(values,type,serviceProviderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_service_providers_api__["a" /* serviceProvidersApi */].editUser(values).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}else{dispatch(setShowEditUserModal(false));dispatch(loadServiceProvidersUser(type,serviceProviderId));}return response;});};}function inviteUser(values,type,serviceProviderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_service_providers_api__["a" /* serviceProvidersApi */].inviteUser(type,serviceProviderId,values).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}else{dispatch(setShowEditUserModal(false));dispatch(loadServiceProvidersUser(type,serviceProviderId));}return response;});};}function deleteUser(values,type,serviceProviderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_service_providers_api__["a" /* serviceProvidersApi */].deleteUser(values).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}else{dispatch(setShowEditUserModal(false));dispatch(loadServiceProvidersUser(type,serviceProviderId));}return response;});};}function goToServiceProviders(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(baseRoutePath));};}function goToNewServiceProvider(type){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(baseRoutePath+'/'+type+'/new'));};}function goToServiceProviderDetails(type,id){var team=window.location.pathname.includes(baseRoutePathTeam);return function(dispatch){if(team){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(baseRoutePathTeam));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(baseRoutePath+'/'+type+'/'+id));}};}function goToEditServiceProvider(type,id){var team=window.location.pathname.includes(baseRoutePathTeam);return function(dispatch){if(team){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(baseRoutePathTeam+'/edit'));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(baseRoutePath+'/'+type+'/'+id+'/edit'));}};}

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCurrentUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentTechnicianId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentPageTechnicians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPerPageTechnicians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getTotalTechnicians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getActiveTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getTechnicians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getShowInviteUserModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getShowInviteTechnicianModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getInvalidFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getUserModalState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getTechnicianModalState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getValidationMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getCurrentUserId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.contractor.ui.currentUserId;},function(currentUserId){return currentUserId;});var getCurrentTechnicianId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.contractor.ui.currentTechnicianId;},function(currentTechnicianId){return currentTechnicianId;});var getForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.contractor.ui.form;},function(form){return form;});var getCurrentPageTechnicians=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.contractor.ui.currentPageTechnicians;},function(currentPageTechnicians){return currentPageTechnicians;});var getPerPageTechnicians=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.contractor.ui.perPageTechnicians;},function(perPageTechnicians){return perPageTechnicians;});var getTotalTechnicians=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.contractor.ui.totalTechnicians;},function(totalTechnicians){return totalTechnicians;});var getActiveTab=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.contractor.ui.activeTab;},function(activeTab){return activeTab;});var getRoles=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.contractor.data.roles;},function(roles){return roles;});var getUsers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.contractor.data.users;},function(users){return users;});var getTechnicians=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.contractor.data.technicians;},function(technicians){return technicians;});var getShowInviteUserModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.contractor.ui.showInviteUserModal;},function(showInviteUserModal){return showInviteUserModal;});var getShowInviteTechnicianModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.contractor.ui.showInviteTechnicianModal;},function(showInviteTechnicianModal){return showInviteTechnicianModal;});var getInvalidFields=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.contractor.ui.invalidFields;},function(invalidFields){return invalidFields;});var getUserModalState=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.contractor.ui.userModalState;},function(userModalState){return userModalState;});var getTechnicianModalState=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.contractor.ui.technicianModalState;},function(technicianModalState){return technicianModalState;});var getValidationMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.contractor.ui.validationMessage;},function(validationMessage){return validationMessage;});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationTypes; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getNotifiableType;
/* harmony export (immutable) */ __webpack_exports__["b"] = getNotifiable;
/* harmony export (immutable) */ __webpack_exports__["d"] = unreadNotifications;
var NotificationTypes={WORK_ORDER:'WorkOrder',TASK:'Task',INVOICE:'Invoice',CONTRACTOR:'Contractor',PURCHASE_ORDER:'PurchaseOrder',SURVEY:'Survey',CLIENT:'Client',CONTRACTOR_INVOICE:'ContractorInvoice',PROJECT:'Project',MEETING:'Meeting',RFI:'Rfi',SUBMITTAL:'Submittal',PROJECT_OPEN_ITEM:'ProjectOpenItem',NOTE:'Note',ORDER:'Order',PAR:'Par',SUB_DAILY_REPORT:'SubDailyReport',DOCUMENT_NOTIFICATION:'DocumentNotification',COI_EXP:'CoiExp'};function getNotifiableType(notification){return notification.notifiable_type===NotificationTypes.NOTE?notification.notifiable.notifiable_type:notification.notifiable_type;}function getNotifiable(notification){return notification.notifiable_type===NotificationTypes.NOTE?notification.notifiable.notifiable:notification.notifiable;}function unreadNotifications(notifications,type,fallbackAttr){var unreadById={};if(notifications!==null&&notifications.content.length>0){// Look for notifications not read yet, to mark the element
unreadById=notifications.content.filter(function(notification){return notification.read_at===null;}).reduce(function(accumulator,currentNotification){var notifiableType=getNotifiableType(currentNotification);var notifiable=getNotifiable(currentNotification);var id=null;if(notifiableType===type){id=notifiable.id;}else if(notifiable!==null&&fallbackAttr){id=notifiable[fallbackAttr];}if(id!==null){accumulator[id]=true;}return accumulator;},{});}return unreadById;}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCloseoutCats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCloseout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCloseoutContribs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getPageSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getCloseoutPercentage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCloseoutManuals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCloseoutManualsCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCloseoutManualsTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCloseoutManualsPageSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCloseoutManual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getCloseoutCats=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.closeout.data.closeoutCats;},function(closeoutCats){return closeoutCats;});var getCloseout=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.closeout.data.closeout;},function(closeout){return closeout;});var getCloseoutContribs=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.closeout.data.closeoutContribs;},function(closeoutContribs){return closeoutContribs;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.closeout.data.currentPage;},function(currentPage){return currentPage;});var getTotal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.closeout.data.total;},function(total){return total;});var getPageSize=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.closeout.data.pageSize;},function(pageSize){return pageSize;});var getCloseoutPercentage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.closeout.data.closeoutPercentage;},function(closeoutPercentage){return closeoutPercentage;});var getCloseoutManuals=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.closeout.data.closeoutManuals;},function(closeoutManuals){return closeoutManuals;});var getCloseoutManualsCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.closeout.data.closeoutManualsCurrentPage;},function(closeoutManualsCurrentPage){return closeoutManualsCurrentPage;});var getCloseoutManualsTotal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.closeout.data.closeoutManualsTotal;},function(closeoutManualsTotal){return closeoutManualsTotal;});var getCloseoutManualsPageSize=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.closeout.data.closeoutManualsPageSize;},function(closeoutManualsPageSize){return closeoutManualsPageSize;});var getCloseoutManual=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.closeout.data.closeoutManual;},function(closeoutManual){return closeoutManual;});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Submittal; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Submittal=function(){function Submittal(){_classCallCheck(this,Submittal);}_createClass(Submittal,null,[{key:"addlAssignee",value:function addlAssignee(submittal,user){return submittal.submittal_addl_assignees.find(function(addlAssignee){return addlAssignee.assignee_id===user.id;});}},{key:"assignee",value:function assignee(submittal,user){return submittal.assignee_id===user.id||!!this.addlAssignee(submittal,user);}},{key:"responded",value:function responded(submittal,user){var addlAssignee=this.addlAssignee(submittal,user);return submittal.responded_by_id===user.id||!!(addlAssignee&&addlAssignee.stamp_action);}},{key:"readOnly",value:function readOnly(submittal,user){return!this.assignee(submittal,user)||!!submittal.closed||this.responded(submittal,user);}}]);return Submittal;}();

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAATCAYAAABV/rckAAAAAXNSR0IArs4c6QAAADJJREFUCB1jYEACjBNmr2v9/58hj5GRYRILiPGfgYGHAUgzgUQYGRi+gGgkHUQzB5nRAJRyJTMCfUutAAAAAElFTkSuQmCC"

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RfiStatusKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RfiStatusEnum; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var keys={};var RfiStatusKeys={DRAFT:'draft',PENDING:'pending',ASSIGNED:'assigned',RESPONDED:'responded',RESOLVED:'resolved',VOID:'void',FOR_RECORD:'for_record'};var RfiStatusEnum=function(){function RfiStatusEnum(status,label){_classCallCheck(this,RfiStatusEnum);this.status=status;this.label=label;keys[status]=this;}_createClass(RfiStatusEnum,[{key:'equals',value:function equals(rfiStatusEnum){return this.status===rfiStatusEnum.status;}}],[{key:'create',value:function create(status){if(keys[status]){return keys[status];}return RfiStatusEnum.UNKNOWN;}}]);return RfiStatusEnum;}();RfiStatusEnum.DRAFT=new RfiStatusEnum('draft','draft');RfiStatusEnum.PENDING=new RfiStatusEnum('pending','pending');RfiStatusEnum.ASSIGNED=new RfiStatusEnum('assigned','assigned');RfiStatusEnum.RESPONDED=new RfiStatusEnum('responded','responded');RfiStatusEnum.RESOLVED=new RfiStatusEnum('resolved','resolved');RfiStatusEnum.VOID=new RfiStatusEnum('void','void');RfiStatusEnum.FOR_RECORD=new RfiStatusEnum('for_record','For Record Only');

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Project; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_domain_enterprise__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Project=function(){function Project(){_classCallCheck(this,Project);}_createClass(Project,null,[{key:'directoryOrProposal',value:function directoryOrProposal(props){var project=props.project,projectProposal=props.projectProposal,directory=props.directory,currentUser=props.currentUser;var options=[];if(__WEBPACK_IMPORTED_MODULE_0_domain_enterprise__["a" /* Enterprise */].subcontractor(project.contributor_type)){options=directory&&directory.project_contributors.filter(function(contrib){return contrib.company_id===currentUser.accountable_id&&contrib.company_type===currentUser.accountable_type;});}else{var _options;options=projectProposal&&projectProposal.project_proposal_items;options&&directory&&(_options=options).push.apply(_options,_toConsumableArray(directory.project_contributors));}return options||[];}},{key:'csiCodesOptions',value:function csiCodesOptions(props){var csiCodeIds={};return this.directoryOrProposal(props).filter(function(item){return!!item.csi_code;}).map(function(item){var csi_code=item.csi_code;if(csiCodeIds[csi_code.id]){return null;}else{csiCodeIds[csi_code.id]=true;return{value:csi_code.id,label:csi_code.division+' - '+csi_code.label};}}).filter(function(csiCode){return!!csiCode;}).sort(function(csiCode1,csiCode2){return csiCode1.label<csiCode2.label?-1:1;});}},{key:'subcontractorOptions',value:function subcontractorOptions(props,csiCodeId){return(csiCodeId&&props.directory&&props.directory.project_contributors||[]).filter(function(item){return!!item.csi_code&&item.csi_code.id===csiCodeId;}).map(function(item){return{value:item.company_id,label:item.company.name};}).sort(function(sub1,sub2){return sub1.label<sub2.label?-1:1;});}},{key:'projectContributorOptions',value:function projectContributorOptions(props){return(props.directory&&props.directory.project_contributors||[]).filter(function(item){return!!item.csi_code;}).map(function(item){return{value:item.id,label:item.csi_code.division+' '+item.csi_code.label+' - '+(item.company.name||item.company.company_name)};}).sort(function(item1,item2){return item1.label<item2.label?-1:1;});}},{key:'userLabelStr',value:function userLabelStr(user,company){return user.first_name+' '+user.last_name+' - '+(company.name||company.company_name);}},{key:'filterRecipients',value:function filterRecipients(props){var _this=this;var onlyPrimary=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var directory=props.directory;if(!directory){return[];}var users={};var contributors=directory.project_contributors;contributors=onlyPrimary?contributors.filter(function(pc){return pc.primary;}):contributors;return contributors.map(function(pc){return pc.users.filter(function(usr){return!users[usr.id];}).map(function(usr){users[usr.id]=true;var usrLabel=_this.userLabelStr(usr,pc.company);return{id:usr.id,label:usrLabel};});}).reduce(function(acc,val){return acc.concat(val);},[]);}},{key:'recipientOptions',value:function recipientOptions(props){return this.filterRecipients(props);}},{key:'primaryRecipientOptions',value:function primaryRecipientOptions(props){return this.filterRecipients(props,true);}}]);return Project;}();

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLCData, XMLComment, XMLDeclaration, XMLDocType, XMLElement, XMLNode, XMLRaw, XMLText, isEmpty, isFunction, isObject,
    hasProp = {}.hasOwnProperty;

  isObject = __webpack_require__(125);

  isFunction = __webpack_require__(260);

  isEmpty = __webpack_require__(2665);

  XMLElement = null;

  XMLCData = null;

  XMLComment = null;

  XMLDeclaration = null;

  XMLDocType = null;

  XMLRaw = null;

  XMLText = null;

  module.exports = XMLNode = (function() {
    function XMLNode(parent) {
      this.parent = parent;
      this.options = this.parent.options;
      this.stringify = this.parent.stringify;
      if (XMLElement === null) {
        XMLElement = __webpack_require__(1053);
        XMLCData = __webpack_require__(1055);
        XMLComment = __webpack_require__(1056);
        XMLDeclaration = __webpack_require__(1052);
        XMLDocType = __webpack_require__(1057);
        XMLRaw = __webpack_require__(2674);
        XMLText = __webpack_require__(2675);
      }
    }

    XMLNode.prototype.element = function(name, attributes, text) {
      var childNode, item, j, k, key, lastChild, len, len1, ref, val;
      lastChild = null;
      if (attributes == null) {
        attributes = {};
      }
      attributes = attributes.valueOf();
      if (!isObject(attributes)) {
        ref = [attributes, text], text = ref[0], attributes = ref[1];
      }
      if (name != null) {
        name = name.valueOf();
      }
      if (Array.isArray(name)) {
        for (j = 0, len = name.length; j < len; j++) {
          item = name[j];
          lastChild = this.element(item);
        }
      } else if (isFunction(name)) {
        lastChild = this.element(name.apply());
      } else if (isObject(name)) {
        for (key in name) {
          if (!hasProp.call(name, key)) continue;
          val = name[key];
          if (isFunction(val)) {
            val = val.apply();
          }
          if ((isObject(val)) && (isEmpty(val))) {
            val = null;
          }
          if (!this.options.ignoreDecorators && this.stringify.convertAttKey && key.indexOf(this.stringify.convertAttKey) === 0) {
            lastChild = this.attribute(key.substr(this.stringify.convertAttKey.length), val);
          } else if (!this.options.ignoreDecorators && this.stringify.convertPIKey && key.indexOf(this.stringify.convertPIKey) === 0) {
            lastChild = this.instruction(key.substr(this.stringify.convertPIKey.length), val);
          } else if (!this.options.separateArrayItems && Array.isArray(val)) {
            for (k = 0, len1 = val.length; k < len1; k++) {
              item = val[k];
              childNode = {};
              childNode[key] = item;
              lastChild = this.element(childNode);
            }
          } else if (isObject(val)) {
            lastChild = this.element(key);
            lastChild.element(val);
          } else {
            lastChild = this.element(key, val);
          }
        }
      } else {
        if (!this.options.ignoreDecorators && this.stringify.convertTextKey && name.indexOf(this.stringify.convertTextKey) === 0) {
          lastChild = this.text(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertCDataKey && name.indexOf(this.stringify.convertCDataKey) === 0) {
          lastChild = this.cdata(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertCommentKey && name.indexOf(this.stringify.convertCommentKey) === 0) {
          lastChild = this.comment(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertRawKey && name.indexOf(this.stringify.convertRawKey) === 0) {
          lastChild = this.raw(text);
        } else {
          lastChild = this.node(name, attributes, text);
        }
      }
      if (lastChild == null) {
        throw new Error("Could not create any elements with: " + name);
      }
      return lastChild;
    };

    XMLNode.prototype.insertBefore = function(name, attributes, text) {
      var child, i, removed;
      if (this.isRoot) {
        throw new Error("Cannot insert elements at root level");
      }
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i);
      child = this.parent.element(name, attributes, text);
      Array.prototype.push.apply(this.parent.children, removed);
      return child;
    };

    XMLNode.prototype.insertAfter = function(name, attributes, text) {
      var child, i, removed;
      if (this.isRoot) {
        throw new Error("Cannot insert elements at root level");
      }
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i + 1);
      child = this.parent.element(name, attributes, text);
      Array.prototype.push.apply(this.parent.children, removed);
      return child;
    };

    XMLNode.prototype.remove = function() {
      var i, ref;
      if (this.isRoot) {
        throw new Error("Cannot remove the root element");
      }
      i = this.parent.children.indexOf(this);
      [].splice.apply(this.parent.children, [i, i - i + 1].concat(ref = [])), ref;
      return this.parent;
    };

    XMLNode.prototype.node = function(name, attributes, text) {
      var child, ref;
      if (name != null) {
        name = name.valueOf();
      }
      if (attributes == null) {
        attributes = {};
      }
      attributes = attributes.valueOf();
      if (!isObject(attributes)) {
        ref = [attributes, text], text = ref[0], attributes = ref[1];
      }
      child = new XMLElement(this, name, attributes);
      if (text != null) {
        child.text(text);
      }
      this.children.push(child);
      return child;
    };

    XMLNode.prototype.text = function(value) {
      var child;
      child = new XMLText(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.cdata = function(value) {
      var child;
      child = new XMLCData(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.comment = function(value) {
      var child;
      child = new XMLComment(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.raw = function(value) {
      var child;
      child = new XMLRaw(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.declaration = function(version, encoding, standalone) {
      var doc, xmldec;
      doc = this.document();
      xmldec = new XMLDeclaration(doc, version, encoding, standalone);
      doc.xmldec = xmldec;
      return doc.root();
    };

    XMLNode.prototype.doctype = function(pubID, sysID) {
      var doc, doctype;
      doc = this.document();
      doctype = new XMLDocType(doc, pubID, sysID);
      doc.doctype = doctype;
      return doctype;
    };

    XMLNode.prototype.up = function() {
      if (this.isRoot) {
        throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
      }
      return this.parent;
    };

    XMLNode.prototype.root = function() {
      var child;
      if (this.isRoot) {
        return this;
      }
      child = this.parent;
      while (!child.isRoot) {
        child = child.parent;
      }
      return child;
    };

    XMLNode.prototype.document = function() {
      return this.root().documentObject;
    };

    XMLNode.prototype.end = function(options) {
      return this.document().toString(options);
    };

    XMLNode.prototype.prev = function() {
      var i;
      if (this.isRoot) {
        throw new Error("Root node has no siblings");
      }
      i = this.parent.children.indexOf(this);
      if (i < 1) {
        throw new Error("Already at the first node");
      }
      return this.parent.children[i - 1];
    };

    XMLNode.prototype.next = function() {
      var i;
      if (this.isRoot) {
        throw new Error("Root node has no siblings");
      }
      i = this.parent.children.indexOf(this);
      if (i === -1 || i === this.parent.children.length - 1) {
        throw new Error("Already at the last node");
      }
      return this.parent.children[i + 1];
    };

    XMLNode.prototype.importXMLBuilder = function(xmlbuilder) {
      var clonedRoot;
      clonedRoot = xmlbuilder.root().clone();
      clonedRoot.parent = this;
      clonedRoot.isRoot = false;
      this.children.push(clonedRoot);
      return this;
    };

    XMLNode.prototype.ele = function(name, attributes, text) {
      return this.element(name, attributes, text);
    };

    XMLNode.prototype.nod = function(name, attributes, text) {
      return this.node(name, attributes, text);
    };

    XMLNode.prototype.txt = function(value) {
      return this.text(value);
    };

    XMLNode.prototype.dat = function(value) {
      return this.cdata(value);
    };

    XMLNode.prototype.com = function(value) {
      return this.comment(value);
    };

    XMLNode.prototype.doc = function() {
      return this.document();
    };

    XMLNode.prototype.dec = function(version, encoding, standalone) {
      return this.declaration(version, encoding, standalone);
    };

    XMLNode.prototype.dtd = function(pubID, sysID) {
      return this.doctype(pubID, sysID);
    };

    XMLNode.prototype.e = function(name, attributes, text) {
      return this.element(name, attributes, text);
    };

    XMLNode.prototype.n = function(name, attributes, text) {
      return this.node(name, attributes, text);
    };

    XMLNode.prototype.t = function(value) {
      return this.text(value);
    };

    XMLNode.prototype.d = function(value) {
      return this.cdata(value);
    };

    XMLNode.prototype.c = function(value) {
      return this.comment(value);
    };

    XMLNode.prototype.r = function(value) {
      return this.raw(value);
    };

    XMLNode.prototype.u = function() {
      return this.up();
    };

    return XMLNode;

  })();

}).call(this);


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(134);

var ReactCurrentOwner = __webpack_require__(1083);

var warning = __webpack_require__(649);
var canDefineProperty = __webpack_require__(1082);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(1084);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = allRecentActivitySuccess;
/* harmony export (immutable) */ __webpack_exports__["c"] = speRecentActivitySuccess;
/* harmony export (immutable) */ __webpack_exports__["d"] = swRecentActivitySuccess;
/* harmony export (immutable) */ __webpack_exports__["b"] = recentActivityRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_notifications_api__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_recent_activity_store_action_types__ = __webpack_require__(1099);
function allRecentActivitySuccess(recentActivity){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_recent_activity_store_action_types__["a" /* ALL_RECENT_ACTIVITY_LOAD */],payload:recentActivity};}function speRecentActivitySuccess(recentActivity){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_recent_activity_store_action_types__["b" /* SPE_RECENT_ACTIVITY_LOAD */],payload:recentActivity};}function swRecentActivitySuccess(recentActivity){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_recent_activity_store_action_types__["c" /* SW_RECENT_ACTIVITY_LOAD */],payload:recentActivity};}function recentActivityRequest(page,filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_notifications_api__["a" /* notificationsApi */].getNotifications(page,filters).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(108);
var global = __webpack_require__(41);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(192) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(135);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 291 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ __webpack_exports__["default"] = (warning);


/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 294 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1175);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SafeAnchor__ = __webpack_require__(138);











var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  block: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a,
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * Defines HTML button type attribute
   * @defaultValue 'button'
   */
  type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['button', 'reset', 'submit'])
};
var defaultProps = {
  active: false,
  block: false,
  disabled: false
};

var Button =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Button, _React$Component);

  function Button() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Button.prototype;

  _proto.renderAnchor = function renderAnchor(elementProps, className) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, elementProps.disabled && 'disabled')
    }));
  };

  _proto.renderButton = function renderButton(_ref, className) {
    var componentClass = _ref.componentClass,
        elementProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["componentClass"]);

    var Component = componentClass || 'button';
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      type: elementProps.type || 'button',
      className: className
    }));
  };

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        active = _this$props.active,
        block = _this$props.block,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["active", "block", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {
      active: active
    }, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'block')] = block, _extends2));

    var fullClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes);

    if (elementProps.href) {
      return this.renderAnchor(elementProps, fullClassName);
    }

    return this.renderButton(elementProps, fullClassName);
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('btn', Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].XSMALL], Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["d" /* State */]).concat([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].PRIMARY, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].LINK]), __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].DEFAULT, Button))));

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(699));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(1182));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(1184));

var _removeStyle = _interopRequireDefault(__webpack_require__(1185));

var _properties = __webpack_require__(480);

var _isTransform = _interopRequireDefault(__webpack_require__(1186));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getServiceProvidersCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getServiceProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getServiceProvidersDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getServiceProvidersTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getServiceProvidersPageSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getServiceProviderNameToSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCompanyData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getUserList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getUserForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getShowInviteUserModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getShowConfirmationDeleteModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentUserCompany; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getServiceProvidersCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.serviceProviders.ui.currentPage;},function(currentPage){return currentPage;});var getServiceProviders=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.serviceProviders.ui.serviceProviders;},function(serviceProviders){return serviceProviders;});var getServiceProvidersDropdown=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.serviceProviders.ui.serviceProviderDropdown;},function(serviceProviderDropdown){return serviceProviderDropdown;});var getServiceProvidersTotal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.serviceProviders.ui.total;},function(total){return total;});var getServiceProvidersPageSize=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.serviceProviders.ui.pageSize;},function(pageSize){return pageSize;});var getServiceProviderNameToSearch=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.serviceProviders.ui.nameToSearch;},function(nameToSearch){return nameToSearch;});var getCompanyData=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.serviceProviders.ui.companyData;},function(companyData){return companyData;});var getUserList=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.serviceProviders.ui.userList;},function(userList){return userList;});var getUserForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.serviceProviders.ui.userForm;},function(userForm){return userForm;});var getShowInviteUserModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.serviceProviders.ui.showInviteUserModal;},function(showInviteUserModal){return showInviteUserModal;});var getShowConfirmationDeleteModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.serviceProviders.ui.showConfirmationDeleteModal;},function(showConfirmationDeleteModal){return showConfirmationDeleteModal;});var getCurrentUserCompany=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.serviceProviders.ui.currentUserCompany;},function(currentUserCompany){return currentUserCompany;});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__date_util__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var TasksUtil=function(){function TasksUtil(){_classCallCheck(this,TasksUtil);}_createClass(TasksUtil,null,[{key:'mapTask',value:function mapTask(task){return{id:task.id,number:task.number,completionDate:task.completion_date,trade:task.trade.id,tradeLabel:task.trade.label,subTrade:task.sub_trade.id,floorNumber:task.floor,room:task.room,name:task.name,description:task.description,status:task.status,bidDueDate:task.bid_due_date,awardedContractor:task.awarded_contractor,contractorName:task.contractor_name,images:task.images.map(function(newImage){return{id:newImage.id,url:newImage.image.url,preview:newImage.image.preview.url};})};}/**
   * Check if completion date is 5 days or less than 'today'.
   * @param completionDate
   * @param today (optional)
   * @return {boolean} True is valid, false otherwise.
   */},{key:'validateTaskCompletionDate',value:function validateTaskCompletionDate(completionDate,today){var result=false;if(completionDate!==null){var range=Object(__WEBPACK_IMPORTED_MODULE_0__date_util__["e" /* getRange */])(completionDate,today);result=range.years>0||range.months>0||range.days>5||range.days===5&&(range.hours>0||range.minutes>0);}return result;}}]);return TasksUtil;}();/* harmony default export */ __webpack_exports__["a"] = (TasksUtil);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return quotesApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QuotesApi=function(_BaseApi){_inherits(QuotesApi,_BaseApi);function QuotesApi(){_classCallCheck(this,QuotesApi);return _possibleConstructorReturn(this,(QuotesApi.__proto__||Object.getPrototypeOf(QuotesApi)).apply(this,arguments));}_createClass(QuotesApi,[{key:'getQuotes',value:function getQuotes(page,waiting,denied,agg,perPage){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/quotes?page='+(page!==undefined?page:1)+(waiting!==undefined?'&waiting='+waiting:'')+(denied!==undefined?'&denied='+denied:'')+(agg!==undefined?'&agg='+agg:'')+(perPage!==undefined?'&per_page='+perPage:'')).then(function(response){return{ok:true,quotes:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),totalDenied:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-denied']).value(),totalWaiting:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-waiting']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getQuotesCount',value:function getQuotesCount(filters){var query='';Object.keys(filters).forEach(function(filter,index){if(index>0){query+='&';}query+=filter+'='+filters[filter];});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/quotes/count?'+query).then(function(response){return{ok:true,count:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getQuotesByTask',value:function getQuotesByTask(taskId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/quotes?by_task='+taskId).then(function(response){return{ok:true,quotes:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'counterQuote',value:function counterQuote(quoteId,values){var apiPayload={quote:{counter:values['counter']}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/quotes/'+quoteId+'/counter',apiPayload).then(function(response){return{ok:true,quote:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'respondCounterQuote',value:function respondCounterQuote(quoteId,action){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/quotes/'+quoteId+'/'+action+'_counter').then(function(response){return{ok:true,quote:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateQuote',value:function updateQuote(quoteId,values){var apiPayload={quote:{misc_cost:values['miscCost'],contractor_id:values['contractorId'],estimate:values['estimate'],value:values['value']}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/quotes/'+quoteId,apiPayload).then(function(response){return{ok:true,quote:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'deleteQuote',value:function deleteQuote(quoteId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/quotes/'+quoteId).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createQuote',value:function createQuote(values){var apiPayload={quote:{task_id:values['taskId'],start_date:values['startDate'],estimate:values['cost'],days_of_duration:values['duration'],material_lead_days:values['materialLeadDays'],description:values['description']}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/quotes',apiPayload).then(function(response){return{ok:true,quote:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}/**
   *
   * @param quoteId
   * @param values - {startDate: string, cost: number, duration: number, description: string}
   * @return {Promise<{ok: boolean, quotes: any} | {ok: boolean, errors: *}>}
   */},{key:'submitQuote',value:function submitQuote(quoteId,values){var apiPayload={quote:{start_date:values['startDate'],estimate:values['cost'],days_of_duration:values['duration'],material_lead_days:values['materialLeadDays'],description:values['description']}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/quotes/'+quoteId+'/submit',apiPayload).then(function(response){return{ok:true,quote:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'denyQuote',value:function denyQuote(quoteId,reason){var data={};if(reason!==undefined){data['quote']={denied_reason:reason};}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/quotes/'+quoteId+'/deny',data).then(function(response){return{ok:true,quote:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'withdrawQuote',value:function withdrawQuote(quoteId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/quotes/'+quoteId+'/withdraw').then(function(response){return{ok:true,quote:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return QuotesApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var quotesApi=new QuotesApi();

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_styles__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(1431);




function withStyles(stylesOrCreator, options) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_styles__["a" /* withStyles */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    defaultTheme: __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" /* default */]
  }, options));
}

/* harmony default export */ __webpack_exports__["a"] = (withStyles);

/***/ }),
/* 305 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(381),
    getRawTag = __webpack_require__(1515),
    objectToString = __webpack_require__(1516);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1555),
    baseKeys = __webpack_require__(825),
    isArrayLike = __webpack_require__(308);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(260),
    isLength = __webpack_require__(531);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FilesUploadedViewer_css__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FilesUploadedViewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FilesUploadedViewer_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FilesUploadedViewer=function(_Component){_inherits(FilesUploadedViewer,_Component);function FilesUploadedViewer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FilesUploadedViewer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FilesUploadedViewer.__proto__||Object.getPrototypeOf(FilesUploadedViewer)).call.apply(_ref,[this].concat(args))),_this),_this.handleDocumentRemove=function(event,documentId){event.preventDefault();if(_this.props.onDocumentRemove!==undefined){_this.props.onDocumentRemove(documentId);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FilesUploadedViewer,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'files-uploaded-viewer'},this.props.documents.length>0&&this.props.title!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'viewer-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.props.documents.map(function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:element.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__document_DocumentLink__["a" /* default */],{showIcon:false,showLink:_this2.props.showLink,url:element.document.url})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__images_remove_png___default.a,alt:'remove',onClick:function onClick(event){return _this2.handleDocumentRemove(event,element.id);}}))));})));}}]);return FilesUploadedViewer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FilesUploadedViewer.propTypes={documents:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,showLink:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,onDocumentRemove:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};FilesUploadedViewer.defaultProps={showLink:false};/* harmony default export */ __webpack_exports__["a"] = (FilesUploadedViewer);

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(32);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(32);
var aFunction = __webpack_require__(98);
var SPECIES = __webpack_require__(54)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReadOnlyInput_css__ = __webpack_require__(1868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReadOnlyInput_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ReadOnlyInput_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReadOnlyInput=function(_Component){_inherits(ReadOnlyInput,_Component);function ReadOnlyInput(){_classCallCheck(this,ReadOnlyInput);return _possibleConstructorReturn(this,(ReadOnlyInput.__proto__||Object.getPrototypeOf(ReadOnlyInput)).apply(this,arguments));}_createClass(ReadOnlyInput,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'readonly-input form-control input-area '+this.props.theme+(this.props.class!==null?' '+this.props.class:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.placeholder),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.value));}}]);return ReadOnlyInput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ReadOnlyInput.propTypes={class:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,theme:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['bordered','normal','underlined']),value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};ReadOnlyInput.defaultProps={class:null,placeholder:'',theme:'bordered',value:''};/* harmony default export */ __webpack_exports__["a"] = (ReadOnlyInput);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dropdown_css__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select_dist_react_select_css__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_select_dist_react_select_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Searchable drop down. Expects options from a remote location. Delays the options request if the user types fast (delay configurable)
 */var SearchableDropDown=function(_Component){_inherits(SearchableDropDown,_Component);function SearchableDropDown(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SearchableDropDown);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SearchableDropDown.__proto__||Object.getPrototypeOf(SearchableDropDown)).call.apply(_ref,[this].concat(args))),_this),_this.timeOutId=0,_this.handleChange=function(option){_this.props.onChange(option);},_this.handleCreatableKeyDown=function(param){// Only allow to create new when clicking TAB or ENTER
// See: https://app.zenhub.com/workspace/o/spkltarmac/spackle-web/issues/355
return param.keyCode===9||param.keyCode===13;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SearchableDropDown,[{key:'createInputTimeOut',value:function createInputTimeOut(input,callback){var _this2=this;return setTimeout(function(){_this2.timeOutId=0;_this2.props.loadOptions(input).then(function(response){if(response.ok){callback(null,{complete:false,options:response.options});}else{callback(response.errors,{complete:false,options:[]});}});},this.props.keyDelay);}},{key:'getOptions',value:function getOptions(input,callback){if(this.timeOutId>0){clearTimeout(this.timeOutId);this.timeOutId=this.createInputTimeOut(input,callback);}else{this.timeOutId=this.createInputTimeOut(input,callback);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'searchable-dropdown'+(this.props.className!==undefined?' '+this.props.className:'')},!this.props.creatable?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["Async"],{arrowRenderer:this.props.arrowRenderer,autoload:this.props.autoload,cache:this.props.cache,clearable:this.props.clearable,loadOptions:this.getOptions.bind(this),placeholder:this.props.placeholder,searchable:true,value:this.props.value,onChange:this.handleChange}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["AsyncCreatable"],Object.assign({},this.props,{shouldKeyDownEventCreateNewOption:this.handleCreatableKeyDown})));}}]);return SearchableDropDown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SearchableDropDown.propTypes={arrowRenderer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,autoload:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,cache:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,clearable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,creatable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,keyDelay:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,loadOptions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,// Return promise (Object with "ok", "options" or "errors", function receives the input from the drop down, should return array of [value, label]
placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};SearchableDropDown.defaultProps={arrowRenderer:null,autoload:true,clearable:false,creatable:false,keyDelay:500,onChange:function onChange(){}};/* harmony default export */ __webpack_exports__["a"] = (SearchableDropDown);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Chat_css__ = __webpack_require__(1945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Chat_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Chat_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_input_TextareaAutosizeWrapper__ = __webpack_require__(1946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_chat_ChatTitle__ = __webpack_require__(1951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_chat_ChatMessage__ = __webpack_require__(1953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_chat_ChatButtons__ = __webpack_require__(1957);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Chat=function(_Component){_inherits(Chat,_Component);function Chat(props){_classCallCheck(this,Chat);var _this=_possibleConstructorReturn(this,(Chat.__proto__||Object.getPrototypeOf(Chat)).call(this,props));_this.valid=function(){var newNote=_this.state.newNote;return newNote.content||newNote.images&&newNote.images.length>0||newNote.documents&&newNote.documents.length>0;};_this.submit=function(){if(_this.valid()){var handleSubmit=_this.props.handleSubmit;var newNote=_this.state.newNote;handleSubmit(newNote).then(function(){_this.scrollToBottom();_this.setState({newNote:{content:'',images:[],documents:[]}});});}};_this.scrollToBottom=function(){var objDiv=document.getElementById('slide-chat');objDiv.scrollTop=objDiv.scrollHeight;};_this.handleFormChange=function(attr,value){var newNote=_this.state.newNote;_this.setState({newNote:Object.assign({},newNote,_defineProperty({},attr,value))});};_this.state={newNote:{content:'',images:[],documents:[]}};return _this;}_createClass(Chat,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var loadChat=this.props.loadChat;loadChat().then(function(){return _this2.scrollToBottom();});}},{key:'render',value:function render(){var _this3=this;var _props=this.props,notes=_props.notes,name=_props.name;var newNote=this.state.newNote;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat'},name&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_chat_ChatTitle__["a" /* default */],{name:name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'slide-chat',className:'chat-body'},!notes||notes.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no-comments'},'No Comments Yet.'):notes.map(function(note){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_chat_ChatMessage__["a" /* default */],{key:note.id,note:note});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_TextareaAutosizeWrapper__["a" /* default */],{rows:2,placeholder:'Add new comment\u2026',clear:newNote.content==='',onBlur:function onBlur(value){return _this3.handleFormChange('content',value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_chat_ChatButtons__["a" /* default */],{newNote:newNote,handleFormChange:this.handleFormChange,handleSubmit:this.submit}));}}]);return Chat;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Chat.propTypes={name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,notes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape()),loadChat:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,handleSubmit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(Chat));

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuotesStatusKeys; });
var QuotesStatusKeys={WAITING:'waiting',RECEIVED:'received',APPROVED:'approved',DENIED:'denied',WITHDRAWN:'withdrawn',ACR:'acr'};

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var formatName = function formatName(_ref, name) {
  var sectionPrefix = _ref._reduxForm.sectionPrefix;
  return sectionPrefix ? sectionPrefix + '.' + name : name;
};


/* harmony default export */ __webpack_exports__["a"] = (formatName);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["a"] = (eq);


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(407);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (toKey);


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(569);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FormInput;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/**
 * Wrapper for DateTime picker field used inside redux-form.
 * @param props
 * @return {*}
 * @constructor
 */function FormInput(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_datetime_picker_DatetimePicker__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));}

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FormInput;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_input_Input__ = __webpack_require__(26);
/**
 * Wrapper for Input field used inside redux-form.
 * @param props
 * @return {*}
 * @constructor
 */function FormInput(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_input_Input__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));}

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = approveProposalRequest;
/* harmony export (immutable) */ __webpack_exports__["b"] = closeProposalApprovalModal;
/* unused harmony export openSuccessModal */
/* harmony export (immutable) */ __webpack_exports__["c"] = closeSuccessModal;
/* harmony export (immutable) */ __webpack_exports__["d"] = selectProposal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_proposals_api__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__details__ = __webpack_require__(34);
function approveProposalRequest(selectedProposalId,quotesId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_proposals_api__["a" /* proposalsApi */].approve(selectedProposalId,quotesId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__details__["_14" /* updateProposal */])(response.proposal));dispatch(openSuccessModal());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function closeProposalApprovalModal(){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_79" /* WORK_ORDERS_DETAILS_PROPOSAL_APPROVAL_MODAL_CLOSE */]};}function openSuccessModal(){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_103" /* WORK_ORDERS_DETAILS_PROPOSAL_SUCCESS_MODAL_OPEN */]};}function closeSuccessModal(){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_102" /* WORK_ORDERS_DETAILS_PROPOSAL_SUCCESS_MODAL_CLOSE */]};}function selectProposal(proposal){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_80" /* WORK_ORDERS_DETAILS_PROPOSAL_APPROVAL_SELECT */],payload:proposal};}

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCompletionDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getEmails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getValuesByQuoteId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getProposalShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getStartDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getShowEmailModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getShowPdfViewer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getSubject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDepositSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepositCost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getSelectedProposal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getCompletionDate=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.proposal.data.completionDate;},function(completionDate){return completionDate;});var getCurrentView=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.proposal.ui.currentView;},function(review){return review;});var getEmails=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.proposal.ui.emails;},function(emails){return emails;});var getMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.proposal.ui.message;},function(message){return message;});var getPdf=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.proposal.ui.pdf;},function(pdf){return pdf;});var getValuesByQuoteId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.proposal.data.valuesByQuoteId;},function(valuesByQuoteId){return valuesByQuoteId;});var getProposalShow=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.proposal.ui.show;},function(show){return show;});var getStartDate=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.proposal.data.startDate;},function(startDate){return startDate;});var getShowEmailModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.proposal.ui.showEmailModal;},function(showEmailModal){return showEmailModal;});var getShowPdfViewer=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.proposal.ui.showPdfViewer;},function(showPdfViewer){return showPdfViewer;});var getSubject=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.proposal.ui.subject;},function(subject){return subject;});var getUsers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.proposal.data.users;},function(users){return users;});var getDepositSelected=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.proposal.ui.depositSelected;},function(depositSelected){return depositSelected;});var getDepositCost=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.proposal.data.depositCost;},function(depositCost){return depositCost;});var getSelectedProposal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.proposal.data.selectedProposal;},function(selectedProposal){return selectedProposal;});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getQualifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSelectedQualificationsById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getShowNewQualificationModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTrades; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getQualifications=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.qualifications.data.qualifications;},function(qualifications){return qualifications;});var getSelectedQualificationsById=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.qualifications.ui.selectedQualificationsById;},function(selectedQualificationsById){return selectedQualificationsById;});var getShowNewQualificationModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.qualifications.ui.showNewQualificationModal;},function(showNewQualificationModal){return showNewQualificationModal;});var getTrades=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.qualifications.data.trades;},function(trades){return trades;});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QualificationTypeEnum; });
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var keys={};var byIds={};var QualificationTypeEnum=function(){function QualificationTypeEnum(id,value,label){_classCallCheck(this,QualificationTypeEnum);this.id=id;this.value=value;this.label=label;keys[value]=this;byIds[id]=this;}_createClass(QualificationTypeEnum,[{key:'equals',value:function equals(value){if(typeof value==='string'){return this.value===value;}else if((typeof value==='undefined'?'undefined':_typeof(value))==='object'&&value.hasOwnProperty('value')){return this.value===value.value;}else{return false;}}}],[{key:'get',value:function get(value){if(keys[value]){return keys[value];}return null;}},{key:'getById',value:function getById(id){if(byIds[id]){return byIds[id];}return null;}}]);return QualificationTypeEnum;}();QualificationTypeEnum.GENERAL=new QualificationTypeEnum(1,'general','General');QualificationTypeEnum.TRADE=new QualificationTypeEnum(2,'trade','Trade');QualificationTypeEnum.OTHER=new QualificationTypeEnum(3,'other','Other');

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ImageButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ImageButton_css__ = __webpack_require__(2206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ImageButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ImageButton_css__);
function ImageButton(props){var handleClick=function handleClick(event){event.stopPropagation();if(props.onClick&&!props.disabled){props.onClick();}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:props.alt,className:'image-button'+(props.disabled?' disabled':''),src:props.src,onClick:handleClick});}ImageButton.propTypes={alt:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,src:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};ImageButton.defaultProps={disabled:false};

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEmail;
/* harmony export (immutable) */ __webpack_exports__["b"] = approveBudget;
/* harmony export (immutable) */ __webpack_exports__["c"] = back;
/* harmony export (immutable) */ __webpack_exports__["d"] = checkTask;
/* unused harmony export clearEmails */
/* harmony export (immutable) */ __webpack_exports__["e"] = closePdfViewer;
/* harmony export (immutable) */ __webpack_exports__["f"] = createBudgetRequest;
/* unused harmony export createBudgetMessage */
/* unused harmony export createBudgetSubject */
/* harmony export (immutable) */ __webpack_exports__["h"] = initializeEmailValues;
/* unused harmony export initializeValuesByTaskId */
/* harmony export (immutable) */ __webpack_exports__["i"] = loadEmailBudgetDataRequest;
/* unused harmony export loadUsersSuccess */
/* harmony export (immutable) */ __webpack_exports__["j"] = next;
/* harmony export (immutable) */ __webpack_exports__["k"] = openApproveReviewModal;
/* harmony export (immutable) */ __webpack_exports__["l"] = openModal;
/* harmony export (immutable) */ __webpack_exports__["m"] = printBudget;
/* unused harmony export printBudgetSuccess */
/* harmony export (immutable) */ __webpack_exports__["n"] = removeEmail;
/* harmony export (immutable) */ __webpack_exports__["o"] = sendEmail;
/* harmony export (immutable) */ __webpack_exports__["q"] = setBudgetSubject;
/* harmony export (immutable) */ __webpack_exports__["p"] = setBudgetMessage;
/* unused harmony export setCurrentView */
/* harmony export (immutable) */ __webpack_exports__["r"] = setShow;
/* harmony export (immutable) */ __webpack_exports__["s"] = setShowApprovalConfirmation;
/* harmony export (immutable) */ __webpack_exports__["t"] = setShowApproveReviewModal;
/* harmony export (immutable) */ __webpack_exports__["u"] = setShowEmailModal;
/* unused harmony export updateBudgetValues */
/* harmony export (immutable) */ __webpack_exports__["v"] = updateBudgetRequest;
/* unused harmony export createBudgetQualificationAttributes */
/* harmony export (immutable) */ __webpack_exports__["w"] = updateExtraCosts;
/* harmony export (immutable) */ __webpack_exports__["x"] = updateValue;
/* harmony export (immutable) */ __webpack_exports__["g"] = declineBudget;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_admin_work_orders_details_qualifications__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_utils_proposal_util__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_api_work_orders_api__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_api_clients_api__ = __webpack_require__(122);
function addEmail(email){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_14" /* WORK_ORDERS_DETAILS_BUDGET_EMAIL_ADD */],payload:email};}function approveBudget(workOrderId,tasksId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5_services_api_work_orders_api__["b" /* workOrdersApi */].approveBudget(workOrderId,tasksId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["_1" /* setBudget */])(response.budget));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function back(view){var previousActions={review:'form'};return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_12" /* WORK_ORDERS_DETAILS_BUDGET_BACK */],payload:previousActions[view]};}function checkTask(id,value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_27" /* WORK_ORDERS_DETAILS_BUDGET_TASK_CHECK */],payload:{id:id,value:value}};}function clearEmails(){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_15" /* WORK_ORDERS_DETAILS_BUDGET_EMAIL_CLEAR */]};}function closePdfViewer(){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_23" /* WORK_ORDERS_DETAILS_BUDGET_PDF_VIEWER_CLOSE */]};}function createBudgetRequest(workOrderId,valuesByTaskId,qualifications,selectedQualificationsById){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5_services_api_work_orders_api__["b" /* workOrdersApi */].createBudget(workOrderId,valuesByTaskId,qualifications,selectedQualificationsById).then(function(response){if(response.ok){dispatch(next('review'));dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["_1" /* setBudget */])(response.budget));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function createBudgetMessage(workOrderNumber){var buildingLocation=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var location='';if(buildingLocation!==null){location=' at '+buildingLocation.street_address_1+', '+buildingLocation.city+' '+buildingLocation.state;}return'Please find the attached preliminary estimate for WO #'+workOrderNumber+location+'. If you have any questions, please reach out via chat or email.\n\nThank you';}function createBudgetSubject(workOrderNumber){var workOrderName=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var prefix='Spackle Preliminary Estimate for WO #'+workOrderNumber;if(workOrderName!==null&&workOrderName!==''){return prefix+' - '+workOrderName;}else{return prefix;}}function initializeEmailValues(workOrderNumber,workOrderName,buildingLocation,users){return function(dispatch){// Create and dispatch generated subject and message
dispatch(setBudgetSubject(createBudgetSubject(workOrderNumber,workOrderName)));dispatch(setBudgetMessage(createBudgetMessage(workOrderNumber,buildingLocation)));// Clear emails
dispatch(clearEmails());// Add client owner by default
var owner=users.find(function(user){return __WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasRole(user,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["e" /* ROLES */].OWNER);});if(owner!==undefined){dispatch(addEmail(owner.email));}};}function initializeValuesByTaskId(valuesByTaskId){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_29" /* WORK_ORDERS_DETAILS_BUDGET_VALUES_INIT */],payload:valuesByTaskId};}function loadEmailBudgetDataRequest(workOrderNumber,workOrderName,buildingLocation,clientId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_10_services_api_clients_api__["a" /* clientsApi */].getUsers(clientId).then(function(response){if(response.ok){// Process client users response
dispatch(loadUsersSuccess(response.users));dispatch(initializeEmailValues(workOrderNumber,workOrderName,buildingLocation,response.users));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadUsersSuccess(users){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_28" /* WORK_ORDERS_DETAILS_BUDGET_USERS_LOAD_SUCCESS */],payload:users};}function next(view){var nextActions={form:'review',review:'thank-you'};return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_22" /* WORK_ORDERS_DETAILS_BUDGET_NEXT */],payload:nextActions[view]};}function openApproveReviewModal(budget){return function(dispatch,getState){var selectedQualificationsById=budget.budget_qualifications.reduce(function(accumulator,currentValue){accumulator[currentValue.qualification_id]={id:currentValue.qualification_id,option:currentValue.option!==null?{value:0,label:currentValue.option}:null// value=0 because we only need the label
};return accumulator;},{});// Load data in store to use QualificationContainer
dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_admin_work_orders_details_qualifications__["i" /* setSelectedQualificationsById */])(selectedQualificationsById));dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_admin_work_orders_details_qualifications__["e" /* loadQualificationsSuccess */])(budget.qualifications));var currentUser=Object(__WEBPACK_IMPORTED_MODULE_9_selectors_authentication__["d" /* getCurrentUser */])(getState());if(__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["f" /* TYPES */].CLIENT)){// Check all tasks by default
budget.budget_tasks.forEach(function(budgetTask){dispatch(checkTask(budgetTask.task_id,true));});}dispatch(setShowApproveReviewModal(true));};}function openModal(){var budget=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;return function(dispatch,getState){// Clear qualifications data before showing the modal
dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_admin_work_orders_details_qualifications__["c" /* clearQualificationsSelected */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_admin_work_orders_details_qualifications__["d" /* loadDefaultQualificationsRequest */])()).then(function(response){if(response.ok){var tasks=Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(getState());var valuesByTaskId=void 0;if(budget!==null){// Load values for tasks
valuesByTaskId=budget.budget_tasks.reduce(function(accumulator,budgetTask){accumulator[budgetTask.task_id]={cost:__WEBPACK_IMPORTED_MODULE_7_numeral___default()(budgetTask.cost).value(),fee:__WEBPACK_IMPORTED_MODULE_7_numeral___default()(budgetTask.fee).value(),markup:__WEBPACK_IMPORTED_MODULE_7_numeral___default()(budgetTask.markup).value(),insurance:__WEBPACK_IMPORTED_MODULE_7_numeral___default()(budgetTask.insurance).value()};return accumulator;},{});// Check if new tasks
if(budget.budget_tasks.length!==tasks.length){// New tasks, add to values
tasks.forEach(function(task){if(budget.budget_tasks.find(function(budgetTask){return budgetTask.task_id===task.id;})===undefined){// New task, not part of budget tasks
valuesByTaskId[task.id]={cost:null,fee:null,markup:null,insurance:null};}});}// Add not default qualifications that were selected when creating the budget
budget.qualifications.filter(function(qualification){return!qualification.default;}).forEach(function(qualification){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_admin_work_orders_details_qualifications__["b" /* addQualificationSuccess */])(qualification));});// Set selected qualifications
var selectedQualificationsById=budget.budget_qualifications.reduce(function(accumulator,currentValue){accumulator[currentValue.qualification_id]={id:currentValue.qualification_id,option:currentValue.option!==null?{value:0,label:currentValue.option}:null// value=0 because we only need the label
};return accumulator;},{});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_admin_work_orders_details_qualifications__["i" /* setSelectedQualificationsById */])(selectedQualificationsById));}else{valuesByTaskId=tasks.reduce(function(accumulator,task){accumulator[task.id]={cost:null,fee:null,markup:null,insurance:null};return accumulator;},{});}dispatch(initializeValuesByTaskId(valuesByTaskId));// If open an existing budget, open the modal in Review
dispatch(setCurrentView(budget===null?'form':'review'));dispatch(setShow(true));}});};}function printBudget(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5_services_api_work_orders_api__["b" /* workOrdersApi */].getBudgetAsPdf(workOrderId).then(function(response){if(response.ok){dispatch(printBudgetSuccess(response.pdf));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function printBudgetSuccess(pdf){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_24" /* WORK_ORDERS_DETAILS_BUDGET_PRINT_SUCCESS */],payload:pdf};}function removeEmail(email){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_17" /* WORK_ORDERS_DETAILS_BUDGET_EMAIL_REMOVE */],payload:email};}function sendEmail(workOrderId,emails,subject,message){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5_services_api_work_orders_api__["b" /* workOrdersApi */].sendBudgetEmail(workOrderId,emails,subject,message).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setBudgetSubject(subject){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_26" /* WORK_ORDERS_DETAILS_BUDGET_SUBJECT_SET */],payload:subject};}function setBudgetMessage(message){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_18" /* WORK_ORDERS_DETAILS_BUDGET_MESSAGE_SET */],payload:message};}function setCurrentView(view){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_13" /* WORK_ORDERS_DETAILS_BUDGET_CURRENT_VIEW_SET */],payload:view};}function setShow(value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_21" /* WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_SET */],payload:value};}function setShowApprovalConfirmation(value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_19" /* WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_APPROVAL_CONFIRMATION_SET */],payload:value};}function setShowApproveReviewModal(value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_20" /* WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_APPROVE_REVIEW_SET */],payload:value};}function setShowEmailModal(value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_16" /* WORK_ORDERS_DETAILS_BUDGET_EMAIL_MODAL_SHOW_SET */],payload:value};}function updateBudgetValues(valuesByTaskId,budgetTasks){// Take into account if new tasks were added after budget creation
return Object.keys(valuesByTaskId).map(function(taskIdString){var taskId=Number.parseInt(taskIdString,0);var budgetTask=budgetTasks.find(function(budgetTask){return budgetTask.task_id===taskId;});if(budgetTask!==undefined){return{id:budgetTask.id,task_id:budgetTask.task_id,cost:valuesByTaskId[taskId].cost,fee:valuesByTaskId[taskId].fee,insurance:valuesByTaskId[taskId].insurance,markup:valuesByTaskId[taskId].markup};}else{return{task_id:taskId,cost:valuesByTaskId[taskId].cost,fee:valuesByTaskId[taskId].fee,insurance:valuesByTaskId[taskId].insurance,markup:valuesByTaskId[taskId].markup};}});}function updateBudgetRequest(workOrderId,budget,valuesByTaskId,qualifications,selectedQualificationsById){return function(dispatch){var budgetTasks=updateBudgetValues(valuesByTaskId,budget.budget_tasks);// Calculate changes in selected qualifications vs existing qualifications
var budgetQualifications=createBudgetQualificationAttributes(qualifications,selectedQualificationsById,budget.budget_qualifications);return __WEBPACK_IMPORTED_MODULE_5_services_api_work_orders_api__["b" /* workOrdersApi */].updateBudget(workOrderId,budgetTasks,budgetQualifications).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["_1" /* setBudget */])(response.budget));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}/**
 * Create budget qualifications attributes based on the selected ones and existing qualifications.
 * Check if a qualification exists, changes it's value or was unselected.
 *
 * @param selectedQualificationsById
 * @param existingQualifications
 * @return {Array}
 */function createBudgetQualificationAttributes(qualifications,selectedQualificationsById,existingQualifications){var budgetQualifications=[];qualifications.filter(function(q){return selectedQualificationsById[q.id];}).forEach(function(q){var value=selectedQualificationsById[q.id];var qualification=existingQualifications.find(function(qualification){return qualification.qualification_id===value.id;});if(qualification===undefined){// new qualification
budgetQualifications.push({qualification_id:value.id,option:value.option!==null?value.option.label:null});}else{// qualification exists, check if the option changed
if(value.option!==null&&value.option.label!==qualification.option){budgetQualifications.push({id:qualification.id,option:value.option.label});}}});// Remove existing qualifications unselected
existingQualifications.forEach(function(qualification){if(selectedQualificationsById[qualification.qualification_id]===undefined){budgetQualifications.push({id:qualification.id,_destroy:true});}});return budgetQualifications;}function updateExtraCosts(taskId,value){return function(dispatch){dispatch(updateValue(taskId,'markup',Object(__WEBPACK_IMPORTED_MODULE_3_services_utils_proposal_util__["c" /* calculateMarkup */])(value)));dispatch(updateValue(taskId,'fee',Object(__WEBPACK_IMPORTED_MODULE_3_services_utils_proposal_util__["a" /* calculateFee */])(value)));dispatch(updateValue(taskId,'insurance',Object(__WEBPACK_IMPORTED_MODULE_3_services_utils_proposal_util__["b" /* calculateInsurace */])(value)));};}function updateValue(taskId,valueKey,value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_30" /* WORK_ORDERS_DETAILS_BUDGET_VALUE_UPDATE */],payload:{taskId:taskId,valueKey:valueKey,value:value}};}function declineBudget(workOrderId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5_services_api_work_orders_api__["b" /* workOrdersApi */].declineBudget(workOrderId,values).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return receiptsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return receiptToEditSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return showAddMaterialsModalSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var receiptsSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.receipts.data.receipts;},function(receipts){return receipts;});var receiptToEditSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.receipts.ui.receiptToEdit;},function(receiptToEdit){return receiptToEdit;});var showAddMaterialsModalSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.receipts.ui.showAddMaterialsModal;},function(showAddMaterialsModal){return showAddMaterialsModal;});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rateSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return showAddModalSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timeIdRateToEditSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return timeSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return timeToEditSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var rateSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.time.ui.rate;},function(rate){return rate;});var showAddModalSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.time.ui.showAddModal;},function(showAddModal){return showAddModal;});var timeIdRateToEditSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.time.ui.timeIdRateToEdit;},function(timeIdRateToEdit){return timeIdRateToEdit;});var timeSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.time.data.time;},function(time){return time;});var timeToEditSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.time.ui.timeToEdit;},function(timeToEdit){return timeToEdit;});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return showAddInvoiceModalSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return vendorInvoicesSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var showAddInvoiceModalSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.vendorInvoices.ui.showAddInvoiceModal;},function(showAddInvoiceModal){return showAddInvoiceModal;});var vendorInvoicesSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.vendorInvoices.data.invoices;},function(vendorInvoices){return vendorInvoices;});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBuildings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getClients; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCurrentBuilding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getEngineerAdded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getInvalidFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getParkingOnSite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getSelectedClientsId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getSelectedContractors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getSelectedUnionsId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getUnions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getValidationMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getWorkOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getProjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBuildingsCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBuildingsTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBuildingsPageSize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getBuildings=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.data.buildings;},function(buildings){return buildings;});var getClients=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.data.clients;},function(clients){return clients;});var getCurrentBuilding=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.data.currentBuilding;},function(currentBuilding){return currentBuilding;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.ui.currentPage;},function(currentPage){return currentPage;});var getEngineerAdded=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.ui.engineerAdded;},function(engineerAdded){return engineerAdded;});var getFiles=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.ui.files;},function(files){return files;});var getForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.ui.form;},function(form){return form;});var getInvalidFields=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.ui.invalidFields;},function(invalidFields){return invalidFields;});var getParkingOnSite=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.ui.parkingOnSite;},function(parkingOnSite){return parkingOnSite;});var getSelectedClientsId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.ui.selectedClientsId;},function(selectedClientsId){return selectedClientsId;});var getSelectedContractors=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.ui.selectedContractors;},function(selectedContractors){return selectedContractors;});var getSelectedUnionsId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.ui.selectedUnionsId;},function(selectedUnionsId){return selectedUnionsId;});var getUnions=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.data.unions;},function(unions){return unions;});var getValidationMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.ui.validationMessage;},function(validationMessage){return validationMessage;});var getWorkOrders=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.data.workOrders;},function(workOrders){return workOrders;});var getProjects=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.data.projects;},function(projects){return projects;});var getBuildingsCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.ui.buildingsCurrentPage;},function(buildingsCurrentPage){return buildingsCurrentPage;});var getBuildingsTotal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.ui.buildingsTotal;},function(buildingsTotal){return buildingsTotal;});var getBuildingsPageSize=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.buildings.ui.buildingsPageSize;},function(buildingsPageSize){return buildingsPageSize;});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MultipleSelectList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MultipleSelectList_css__ = __webpack_require__(2360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MultipleSelectList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MultipleSelectList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_remove_svg__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_remove_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_remove_svg__);
/**
 * Show list of values, allow to select more than one.
 * It's possible to remove items from the list, for this to work a "onRemove" function should be defined.
 * If an item id es zero (0), then the index is returned when removing an item.
 */function MultipleSelectList(props){var _this=this;var handleSelection=function handleSelection(id,event){event.preventDefault();if(!props.readOnly&&props.onSelect){props.onSelect(id);}};var handleRemove=function handleRemove(id,index,event){event.stopPropagation();if(props.onRemove){props.onRemove(id,index);}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multiple-select-list show-height-'+props.show},props.options.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,props.options.map(function(option,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,className:option.selected?'selected':null,onClick:handleSelection.bind(_this,option.id)},option.value,props.onRemove!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msl-remove-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__images_remove_svg___default.a,alt:'remove',onClick:handleRemove.bind(_this,option.id,index)})));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msl-no-options'},props.noValuesMessage));}MultipleSelectList.propTypes={noValuesMessage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object])})),readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([3,4,5,6]),onRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};MultipleSelectList.defaultProps={noValuesMessage:'No values',options:[],readOnly:false,show:3};

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = changePageRequest;
/* harmony export (immutable) */ __webpack_exports__["c"] = changeSearchText;
/* harmony export (immutable) */ __webpack_exports__["d"] = changeVendorInvoicesPageRequest;
/* harmony export (immutable) */ __webpack_exports__["e"] = deleteContractorInvoiceRequest;
/* harmony export (immutable) */ __webpack_exports__["f"] = getVendorsInvoices;
/* harmony export (immutable) */ __webpack_exports__["g"] = goToContractorInvoices;
/* unused harmony export initializePagination */
/* unused harmony export initializeVendorInvoicesPagination */
/* harmony export (immutable) */ __webpack_exports__["i"] = loadContractorsInvoicesRequest;
/* unused harmony export loadContractorsInvoicesSuccess */
/* harmony export (immutable) */ __webpack_exports__["l"] = updateContractorInvoiceRequest;
/* harmony export (immutable) */ __webpack_exports__["j"] = markAsPaidRequest;
/* harmony export (immutable) */ __webpack_exports__["k"] = markVendorInvoiceAsPaid;
/* unused harmony export removeContractorInvoice */
/* unused harmony export updateInvoice */
/* harmony export (immutable) */ __webpack_exports__["h"] = initSearchFilters;
/* harmony export (immutable) */ __webpack_exports__["b"] = changeSearchFilterValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_contractors_invoices_api__ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_store_action_types__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_vendor_invoices_api__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(45);
var baseRoutePath='/admin/contractors-invoices';function changePage(page){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_store_action_types__["d" /* CONTRACTORS_INVOICES_PAGE_CHANGE */],payload:page};}function changePageRequest(page){var workOrderJobNumber=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_contractors_invoices_api__["a" /* contractorsInvoicesApi */].getInvoices(page,workOrderJobNumber).then(function(response){var result={};if(response.ok){dispatch(loadContractorsInvoicesSuccess(response.invoices.content));dispatch(changePage(page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return result;});};}function changeSearchText(value){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_store_action_types__["h" /* CONTRACTORS_INVOICES_SEARCH_TEXT_CHANGE */],payload:value};}function changeVendorInvoicesPage(page,pageSize,total){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_store_action_types__["j" /* CONTRACTORS_INVOICES_VENDOR_INVOICES_PAGE_CHANGE */],payload:{page:page,pageSize:pageSize,total:total}};}function changeVendorInvoicesPageRequest(page){var workOrderJobNumber=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var searchFilters=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_vendor_invoices_api__["a" /* vendorInvoicesApi */].getVendorInvoices(page,workOrderJobNumber,searchFilters).then(function(response){if(response.ok){dispatch(setVendorsInvoices(response.invoices.content));dispatch(changeVendorInvoicesPage(page,response.invoices.pageSize,response.invoices.total));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function deleteContractorInvoiceRequest(invoiceId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_contractors_invoices_api__["a" /* contractorsInvoicesApi */].deleteInvoice(invoiceId).then(function(response){if(response.ok){dispatch(removeContractorInvoice(invoiceId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function getVendorsInvoices(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_vendor_invoices_api__["a" /* vendorInvoicesApi */].getVendorInvoices().then(function(response){if(response.ok){dispatch(setVendorsInvoices(response.invoices.content));dispatch(initializeVendorInvoicesPagination(response.invoices.pageSize,response.invoices.total));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function goToContractorInvoices(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["d" /* push */])(baseRoutePath));};}function initializePagination(pageSize,total){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_store_action_types__["e" /* CONTRACTORS_INVOICES_PAGINATION_INIT */],payload:{pageSize:pageSize,total:total}};}function initializeVendorInvoicesPagination(pageSize,total){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_store_action_types__["k" /* CONTRACTORS_INVOICES_VENDOR_INVOICES_PAGINATION_INIT */],payload:{pageSize:pageSize,total:total}};}function loadContractorsInvoicesRequest(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var workOrderJobNumber=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_contractors_invoices_api__["a" /* contractorsInvoicesApi */].getInvoices(page,workOrderJobNumber).then(function(response){var result={};if(response.ok){dispatch(loadContractorsInvoicesSuccess(response.invoices.content));dispatch(initializePagination(response.invoices.pageSize,response.invoices.total));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return result;});};}function loadContractorsInvoicesSuccess(invoices){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_store_action_types__["c" /* CONTRACTORS_INVOICES_LOAD_SUCCESS */],payload:invoices};}function updateContractorInvoiceRequest(invoiceId,dueDate){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_contractors_invoices_api__["a" /* contractorsInvoicesApi */].updateInvoice(invoiceId,dueDate).then(function(response){if(response.ok){dispatch(updateInvoice(response.invoice));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function markAsPaidRequest(invoiceId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_contractors_invoices_api__["a" /* contractorsInvoicesApi */].markAsPaid(invoiceId).then(function(response){var result={};if(response.ok){dispatch(updateInvoice(response.invoice));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return result;});};}function markVendorInvoiceAsPaid(invoiceId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_vendor_invoices_api__["a" /* vendorInvoicesApi */].markAsPaid(invoiceId).then(function(response){var result={};if(response.ok){dispatch(updateVendorInvoice(response.invoice));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return result;});};}function removeContractorInvoice(invoiceId){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_store_action_types__["a" /* CONTRACTORS_INVOICES_INVOICE_REMOVE */],payload:invoiceId};}function setVendorsInvoices(invoices){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_store_action_types__["l" /* CONTRACTORS_INVOICES_VENDOR_INVOICES_SET */],payload:invoices};}function updateInvoice(invoice){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_store_action_types__["b" /* CONTRACTORS_INVOICES_INVOICE_UPDATE */],payload:invoice};}function updateVendorInvoice(invoice){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_store_action_types__["i" /* CONTRACTORS_INVOICES_VENDOR_INVOICES_INVOICE_UPDATE */],payload:invoice};}function initSearchFilters(){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_store_action_types__["f" /* CONTRACTORS_INVOICES_SEARCH_FILTERS_INIT */]};}function changeSearchFilterValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_store_action_types__["g" /* CONTRACTORS_INVOICES_SEARCH_FILTER_VALUE_CHANGE */],payload:{attribute:attribute,value:value}};}

/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getSettings=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.settings.data.settings;},function(settings){return settings;});

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var Collection = __webpack_require__(1049);

var util = __webpack_require__(74);

function property(obj, name, value) {
  if (value !== null && value !== undefined) {
    util.property.apply(this, arguments);
  }
}

function memoizedProperty(obj, name) {
  if (!obj.constructor.prototype[name]) {
    util.memoizedProperty.apply(this, arguments);
  }
}

function Shape(shape, options, memberName) {
  options = options || {};

  property(this, 'shape', shape.shape);
  property(this, 'api', options.api, false);
  property(this, 'type', shape.type);
  property(this, 'enum', shape.enum);
  property(this, 'min', shape.min);
  property(this, 'max', shape.max);
  property(this, 'pattern', shape.pattern);
  property(this, 'location', shape.location || this.location || 'body');
  property(this, 'name', this.name || shape.xmlName || shape.queryName ||
    shape.locationName || memberName);
  property(this, 'isStreaming', shape.streaming || this.isStreaming || false);
  property(this, 'isComposite', shape.isComposite || false);
  property(this, 'isShape', true, false);
  property(this, 'isQueryName', Boolean(shape.queryName), false);
  property(this, 'isLocationName', Boolean(shape.locationName), false);
  property(this, 'isIdempotent', shape.idempotencyToken === true);
  property(this, 'isJsonValue', shape.jsonvalue === true);
  property(this, 'isSensitive', shape.sensitive === true || shape.prototype && shape.prototype.sensitive === true);

  if (options.documentation) {
    property(this, 'documentation', shape.documentation);
    property(this, 'documentationUrl', shape.documentationUrl);
  }

  if (shape.xmlAttribute) {
    property(this, 'isXmlAttribute', shape.xmlAttribute || false);
  }

  // type conversion and parsing
  property(this, 'defaultValue', null);
  this.toWireFormat = function(value) {
    if (value === null || value === undefined) return '';
    return value;
  };
  this.toType = function(value) { return value; };
}

/**
 * @api private
 */
Shape.normalizedTypes = {
  character: 'string',
  double: 'float',
  long: 'integer',
  short: 'integer',
  biginteger: 'integer',
  bigdecimal: 'float',
  blob: 'binary'
};

/**
 * @api private
 */
Shape.types = {
  'structure': StructureShape,
  'list': ListShape,
  'map': MapShape,
  'boolean': BooleanShape,
  'timestamp': TimestampShape,
  'float': FloatShape,
  'integer': IntegerShape,
  'string': StringShape,
  'base64': Base64Shape,
  'binary': BinaryShape
};

Shape.resolve = function resolve(shape, options) {
  if (shape.shape) {
    var refShape = options.api.shapes[shape.shape];
    if (!refShape) {
      throw new Error('Cannot find shape reference: ' + shape.shape);
    }

    return refShape;
  } else {
    return null;
  }
};

Shape.create = function create(shape, options, memberName) {
  if (shape.isShape) return shape;

  var refShape = Shape.resolve(shape, options);
  if (refShape) {
    var filteredKeys = Object.keys(shape);
    if (!options.documentation) {
      filteredKeys = filteredKeys.filter(function(name) {
        return !name.match(/documentation/);
      });
    }

    // create an inline shape with extra members
    var InlineShape = function() {
      refShape.constructor.call(this, shape, options, memberName);
    };
    InlineShape.prototype = refShape;
    return new InlineShape();
  } else {
    // set type if not set
    if (!shape.type) {
      if (shape.members) shape.type = 'structure';
      else if (shape.member) shape.type = 'list';
      else if (shape.key) shape.type = 'map';
      else shape.type = 'string';
    }

    // normalize types
    var origType = shape.type;
    if (Shape.normalizedTypes[shape.type]) {
      shape.type = Shape.normalizedTypes[shape.type];
    }

    if (Shape.types[shape.type]) {
      return new Shape.types[shape.type](shape, options, memberName);
    } else {
      throw new Error('Unrecognized shape type: ' + origType);
    }
  }
};

function CompositeShape(shape) {
  Shape.apply(this, arguments);
  property(this, 'isComposite', true);

  if (shape.flattened) {
    property(this, 'flattened', shape.flattened || false);
  }
}

function StructureShape(shape, options) {
  var requiredMap = null, firstInit = !this.isShape;

  CompositeShape.apply(this, arguments);

  if (firstInit) {
    property(this, 'defaultValue', function() { return {}; });
    property(this, 'members', {});
    property(this, 'memberNames', []);
    property(this, 'required', []);
    property(this, 'isRequired', function() { return false; });
  }

  if (shape.members) {
    property(this, 'members', new Collection(shape.members, options, function(name, member) {
      return Shape.create(member, options, name);
    }));
    memoizedProperty(this, 'memberNames', function() {
      return shape.xmlOrder || Object.keys(shape.members);
    });
  }

  if (shape.required) {
    property(this, 'required', shape.required);
    property(this, 'isRequired', function(name) {
      if (!requiredMap) {
        requiredMap = {};
        for (var i = 0; i < shape.required.length; i++) {
          requiredMap[shape.required[i]] = true;
        }
      }

      return requiredMap[name];
    }, false, true);
  }

  property(this, 'resultWrapper', shape.resultWrapper || null);

  if (shape.payload) {
    property(this, 'payload', shape.payload);
  }

  if (typeof shape.xmlNamespace === 'string') {
    property(this, 'xmlNamespaceUri', shape.xmlNamespace);
  } else if (typeof shape.xmlNamespace === 'object') {
    property(this, 'xmlNamespacePrefix', shape.xmlNamespace.prefix);
    property(this, 'xmlNamespaceUri', shape.xmlNamespace.uri);
  }
}

function ListShape(shape, options) {
  var self = this, firstInit = !this.isShape;
  CompositeShape.apply(this, arguments);

  if (firstInit) {
    property(this, 'defaultValue', function() { return []; });
  }

  if (shape.member) {
    memoizedProperty(this, 'member', function() {
      return Shape.create(shape.member, options);
    });
  }

  if (this.flattened) {
    var oldName = this.name;
    memoizedProperty(this, 'name', function() {
      return self.member.name || oldName;
    });
  }
}

function MapShape(shape, options) {
  var firstInit = !this.isShape;
  CompositeShape.apply(this, arguments);

  if (firstInit) {
    property(this, 'defaultValue', function() { return {}; });
    property(this, 'key', Shape.create({type: 'string'}, options));
    property(this, 'value', Shape.create({type: 'string'}, options));
  }

  if (shape.key) {
    memoizedProperty(this, 'key', function() {
      return Shape.create(shape.key, options);
    });
  }
  if (shape.value) {
    memoizedProperty(this, 'value', function() {
      return Shape.create(shape.value, options);
    });
  }
}

function TimestampShape(shape) {
  var self = this;
  Shape.apply(this, arguments);

  if (this.location === 'header') {
    property(this, 'timestampFormat', 'rfc822');
  } else if (shape.timestampFormat) {
    property(this, 'timestampFormat', shape.timestampFormat);
  } else if (!this.timestampFormat && this.api) {
    if (this.api.timestampFormat) {
      property(this, 'timestampFormat', this.api.timestampFormat);
    } else {
      switch (this.api.protocol) {
        case 'json':
        case 'rest-json':
          property(this, 'timestampFormat', 'unixTimestamp');
          break;
        case 'rest-xml':
        case 'query':
        case 'ec2':
          property(this, 'timestampFormat', 'iso8601');
          break;
      }
    }
  }

  this.toType = function(value) {
    if (value === null || value === undefined) return null;
    if (typeof value.toUTCString === 'function') return value;
    return typeof value === 'string' || typeof value === 'number' ?
           util.date.parseTimestamp(value) : null;
  };

  this.toWireFormat = function(value) {
    return util.date.format(value, self.timestampFormat);
  };
}

function StringShape() {
  Shape.apply(this, arguments);

  var nullLessProtocols = ['rest-xml', 'query', 'ec2'];
  this.toType = function(value) {
    value = this.api && nullLessProtocols.indexOf(this.api.protocol) > -1 ?
      value || '' : value;
    if (this.isJsonValue) {
      return JSON.parse(value);
    }

    return value && typeof value.toString === 'function' ?
      value.toString() : value;
  };

  this.toWireFormat = function(value) {
    return this.isJsonValue ? JSON.stringify(value) : value;
  };
}

function FloatShape() {
  Shape.apply(this, arguments);

  this.toType = function(value) {
    if (value === null || value === undefined) return null;
    return parseFloat(value);
  };
  this.toWireFormat = this.toType;
}

function IntegerShape() {
  Shape.apply(this, arguments);

  this.toType = function(value) {
    if (value === null || value === undefined) return null;
    return parseInt(value, 10);
  };
  this.toWireFormat = this.toType;
}

function BinaryShape() {
  Shape.apply(this, arguments);
  this.toType = util.base64.decode;
  this.toWireFormat = util.base64.encode;
}

function Base64Shape() {
  BinaryShape.apply(this, arguments);
}

function BooleanShape() {
  Shape.apply(this, arguments);

  this.toType = function(value) {
    if (typeof value === 'boolean') return value;
    if (value === null || value === undefined) return null;
    return value === 'true';
  };
}

/**
 * @api private
 */
Shape.shapes = {
  StructureShape: StructureShape,
  ListShape: ListShape,
  MapShape: MapShape,
  StringShape: StringShape,
  BooleanShape: BooleanShape,
  Base64Shape: Base64Shape
};

module.exports = Shape;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(2702)
var ieee754 = __webpack_require__(2703)
var isArray = __webpack_require__(2704)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(97)))

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['sts'] = {};
AWS.STS = Service.defineService('sts', ['2011-06-15']);
__webpack_require__(2714);
Object.defineProperty(apiLoader.services['sts'], '2011-06-15', {
  get: function get() {
    var model = __webpack_require__(2715);
    model.paginators = __webpack_require__(2716).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.STS;


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCoiExps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCoiExpsTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCoiExpsCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCoiExpsPageSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCoiExpDocs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getLiabilities; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getCoiExps=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.coiExps.data.coiExps;},function(coiExps){return coiExps;});var getCoiExpsTotal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.coiExps.data.coiExpsTotal;},function(coiExpsTotal){return coiExpsTotal;});var getCoiExpsCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.coiExps.data.coiExpsCurrentPage;},function(coiExpsCurrentPage){return coiExpsCurrentPage;});var getCoiExpsPageSize=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.coiExps.data.coiExpsPageSize;},function(coiExpsPageSize){return coiExpsPageSize;});var getCoiExpDocs=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.coiExps.data.coiExpDocs;},function(coiExpDocs){return coiExpDocs;});var getLiabilities=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.coiExps.data.liabilities;},function(liabilities){return liabilities;});

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(136);
var defined = __webpack_require__(150);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(118);
var toLength = __webpack_require__(55);
var toAbsoluteIndex = __webpack_require__(213);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(41);
var $export = __webpack_require__(4);
var redefine = __webpack_require__(109);
var redefineAll = __webpack_require__(214);
var meta = __webpack_require__(194);
var forOf = __webpack_require__(216);
var anInstance = __webpack_require__(215);
var isObject = __webpack_require__(48);
var fails = __webpack_require__(43);
var $iterDetect = __webpack_require__(345);
var setToStringTag = __webpack_require__(240);
var inheritIfRequired = __webpack_require__(458);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(54)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(1122);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 351 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(352);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_activeElement__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_activeElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_activeElement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_query_contains__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types_extra_lib_all__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_uncontrollable__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ButtonGroup__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DropdownMenu__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DropdownToggle__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_PropTypes__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_ValidComponentChildren__ = __webpack_require__(103);























var TOGGLE_ROLE = __WEBPACK_IMPORTED_MODULE_18__DropdownToggle__["a" /* default */].defaultProps.bsRole;
var MENU_ROLE = __WEBPACK_IMPORTED_MODULE_17__DropdownMenu__["a" /* default */].defaultProps.bsRole;
var propTypes = {
  /**
   * The menu will open above the dropdown button, instead of below it.
   */
  dropup: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,

  /**
   * An html id attribute, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number])),
  componentClass: __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_elementType___default.a,

  /**
   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
   * @type {node}
   */
  children: __WEBPACK_IMPORTED_MODULE_11_prop_types_extra_lib_all___default()(Object(__WEBPACK_IMPORTED_MODULE_21__utils_PropTypes__["c" /* requiredRoles */])(TOGGLE_ROLE, MENU_ROLE), Object(__WEBPACK_IMPORTED_MODULE_21__utils_PropTypes__["a" /* exclusiveRoles */])(MENU_ROLE)),

  /**
   * Whether or not component is disabled.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,

  /**
   * Align the menu to the right side of the Dropdown toggle
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,

  /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */
  open: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  defaultOpen: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,

  /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * ```js
   * function(Boolean isOpen, Object event, { String source }) {}
   * ```
   * @controllable open
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,

  /**
   * A callback fired when a menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,

  /**
   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
   * a menu button.
   */
  role: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,

  /**
   * Which event when fired outside the component will cause it to be closed
   *
   * *Note: For custom dropdown components, you will have to pass the
   * `rootCloseEvent` to `<RootCloseWrapper>` in your custom dropdown menu
   * component ([similarly to how it is implemented in `<Dropdown.Menu>`](https://github.com/react-bootstrap/react-bootstrap/blob/v0.31.5/src/DropdownMenu.js#L115-L119)).*
   */
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOf(['click', 'mousedown']),

  /**
   * @private
   */
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,

  /**
   * @private
   */
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
};
var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_16__ButtonGroup__["a" /* default */]
};

var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Dropdown, _React$Component);

  function Dropdown(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleClose = _this.handleClose.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this._focusInDropdown = false;
    _this.lastOpenEventType = null;
    return _this;
  }

  var _proto = Dropdown.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.focusNextOnOpen();
  };

  _proto.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!nextProps.open && this.props.open) {
      this._focusInDropdown = __WEBPACK_IMPORTED_MODULE_6_dom_helpers_query_contains___default()(__WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.findDOMNode(this.menu), __WEBPACK_IMPORTED_MODULE_5_dom_helpers_activeElement___default()(document));
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var open = this.props.open;
    var prevOpen = prevProps.open;

    if (open && !prevOpen) {
      this.focusNextOnOpen();
    }

    if (!open && prevOpen) {
      // if focus hasn't already moved from the menu let's return it
      // to the toggle
      if (this._focusInDropdown) {
        this._focusInDropdown = false;
        this.focus();
      }
    }
  };

  _proto.focus = function focus() {
    var toggle = __WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.findDOMNode(this.toggle);

    if (toggle && toggle.focus) {
      toggle.focus();
    }
  };

  _proto.focusNextOnOpen = function focusNextOnOpen() {
    var menu = this.menu;

    if (!menu || !menu.focusNext) {
      return;
    }

    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
      menu.focusNext();
    }
  };

  _proto.handleClick = function handleClick(event) {
    if (this.props.disabled) {
      return;
    }

    this.toggleOpen(event, {
      source: 'click'
    });
  };

  _proto.handleClose = function handleClose(event, eventDetails) {
    if (!this.props.open) {
      return;
    }

    this.toggleOpen(event, eventDetails);
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    if (this.props.disabled) {
      return;
    }

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.down:
        if (!this.props.open) {
          this.toggleOpen(event, {
            source: 'keydown'
          });
        } else if (this.menu.focusNext) {
          this.menu.focusNext();
        }

        event.preventDefault();
        break;

      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.tab:
        this.handleClose(event, {
          source: 'keydown'
        });
        break;

      default:
    }
  };

  _proto.toggleOpen = function toggleOpen(event, eventDetails) {
    var open = !this.props.open;

    if (open) {
      this.lastOpenEventType = eventDetails.source;
    }

    if (this.props.onToggle) {
      this.props.onToggle(open, event, eventDetails);
    }
  };

  _proto.renderMenu = function renderMenu(child, _ref) {
    var _this2 = this;

    var id = _ref.id,
        onSelect = _ref.onSelect,
        rootCloseEvent = _ref.rootCloseEvent,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["id", "onSelect", "rootCloseEvent"]);

    var ref = function ref(c) {
      _this2.menu = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_8_react__["cloneElement"])(child, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      ref: ref,
      labelledBy: id,
      bsClass: Object(__WEBPACK_IMPORTED_MODULE_19__utils_bootstrapUtils__["e" /* prefix */])(props, 'menu'),
      onClose: Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.props.onClose, this.handleClose),
      onSelect: Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, function (key, event) {
        return _this2.handleClose(event, {
          source: 'select'
        });
      }),
      rootCloseEvent: rootCloseEvent
    }));
  };

  _proto.renderToggle = function renderToggle(child, props) {
    var _this3 = this;

    var ref = function ref(c) {
      _this3.toggle = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_8_react__["cloneElement"])(child, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      ref: ref,
      bsClass: Object(__WEBPACK_IMPORTED_MODULE_19__utils_bootstrapUtils__["e" /* prefix */])(props, 'toggle'),
      onClick: Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.props.onClick, this.handleClick),
      onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, this.handleKeyDown)
    }));
  };

  _proto.render = function render() {
    var _classes,
        _this4 = this;

    var _this$props = this.props,
        Component = _this$props.componentClass,
        id = _this$props.id,
        dropup = _this$props.dropup,
        disabled = _this$props.disabled,
        pullRight = _this$props.pullRight,
        open = _this$props.open,
        onSelect = _this$props.onSelect,
        role = _this$props.role,
        bsClass = _this$props.bsClass,
        className = _this$props.className,
        rootCloseEvent = _this$props.rootCloseEvent,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "id", "dropup", "disabled", "pullRight", "open", "onSelect", "role", "bsClass", "className", "rootCloseEvent", "children"]);

    delete props.onToggle;
    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);

    if (dropup) {
      classes[bsClass] = false;
      classes.dropup = true;
    } // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.


    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_22__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      switch (child.props.bsRole) {
        case TOGGLE_ROLE:
          return _this4.renderToggle(child, {
            id: id,
            disabled: disabled,
            open: open,
            role: role,
            bsClass: bsClass
          });

        case MENU_ROLE:
          return _this4.renderMenu(child, {
            id: id,
            open: open,
            pullRight: pullRight,
            bsClass: bsClass,
            onSelect: onSelect,
            rootCloseEvent: rootCloseEvent
          });

        default:
          return child;
      }
    }));
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;
Object(__WEBPACK_IMPORTED_MODULE_19__utils_bootstrapUtils__["a" /* bsClass */])('dropdown', Dropdown);
var UncontrolledDropdown = __WEBPACK_IMPORTED_MODULE_14_uncontrollable___default()(Dropdown, {
  open: 'onToggle'
});
UncontrolledDropdown.Toggle = __WEBPACK_IMPORTED_MODULE_18__DropdownToggle__["a" /* default */];
UncontrolledDropdown.Menu = __WEBPACK_IMPORTED_MODULE_17__DropdownMenu__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (UncontrolledDropdown);

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}
module.exports = exports['default'];

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = splitComponentProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries__);

function splitComponentProps(props, Component) {
  var componentPropTypes = Component.propTypes;
  var parentProps = {};
  var childProps = {};

  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (componentPropTypes[propName]) {
      parentProps[propName] = propValue;
    } else {
      childProps[propName] = propValue;
    }
  });

  return [parentProps, childProps];
}

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition__);




var _fadeStyles;





var propTypes = {
  /**
   * Show the component; triggers the fade in or fade out animation
   */
  in: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is faded out
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Run the fade in animation when the component mounts, if it is initially
   * shown
   */
  appear: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Duration of the fade animation in milliseconds, to ensure that finishing
   * callbacks are fired even if the original browser transition end events are
   * canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Callback fired before the component fades in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to fade in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the has component faded in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired before the component fades out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to fade out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the component has faded out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
var fadeStyles = (_fadeStyles = {}, _fadeStyles[__WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition__["ENTERING"]] = 'in', _fadeStyles[__WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition__["ENTERED"]] = 'in', _fadeStyles);

var Fade =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Fade, _React$Component);

  function Fade() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Fade.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition___default.a, props, function (status, innerProps) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, innerProps, {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('fade', className, children.props.className, fadeStyles[status])
      }));
    });
  };

  return Fade;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Fade);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MediaBody__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MediaHeading__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MediaLeft__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MediaList__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MediaListItem__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MediaRight__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(16);













var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var Media =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Media, _React$Component);

  function Media() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Media.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Media;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Media.propTypes = propTypes;
Media.defaultProps = defaultProps;
Media.Heading = __WEBPACK_IMPORTED_MODULE_7__MediaHeading__["a" /* default */];
Media.Body = __WEBPACK_IMPORTED_MODULE_6__MediaBody__["a" /* default */];
Media.Left = __WEBPACK_IMPORTED_MODULE_8__MediaLeft__["a" /* default */];
Media.Right = __WEBPACK_IMPORTED_MODULE_11__MediaRight__["a" /* default */];
Media.List = __WEBPACK_IMPORTED_MODULE_9__MediaList__["a" /* default */];
Media.ListItem = __WEBPACK_IMPORTED_MODULE_10__MediaListItem__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* bsClass */])('media', Media));

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(352);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);
module.exports = exports['default'];

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getContainer;

var _reactDom = __webpack_require__(60);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(1289);
var objectAssign = __webpack_require__(134);
var decodeComponent = __webpack_require__(1290);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SimpleErrorList_css__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SimpleErrorList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SimpleErrorList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleErrorList=function(_Component){_inherits(SimpleErrorList,_Component);function SimpleErrorList(){_classCallCheck(this,SimpleErrorList);return _possibleConstructorReturn(this,(SimpleErrorList.__proto__||Object.getPrototypeOf(SimpleErrorList)).apply(this,arguments));}_createClass(SimpleErrorList,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'simple-error-list'+(this.props.className!==undefined?' '+this.props.className:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["m" /* ListGroup */],null,this.props.errors.map(function(error,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["n" /* ListGroupItem */],{bsStyle:'danger',key:index},error);})));}}]);return SimpleErrorList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SimpleErrorList.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,errors:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired};/* harmony default export */ __webpack_exports__["a"] = (SimpleErrorList);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(152);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AuthApi=function(_BaseApi){_inherits(AuthApi,_BaseApi);function AuthApi(){_classCallCheck(this,AuthApi);return _possibleConstructorReturn(this,(AuthApi.__proto__||Object.getPrototypeOf(AuthApi)).apply(this,arguments));}_createClass(AuthApi,[{key:'login',value:function login(email,password){var data={email:email,password:password};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/auth/sign_in',data).then(function(response){return{ok:true,data:{accessToken:response.headers['access-token'],client:response.headers['client'],user:response.data.data}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'confirmPassword',value:function confirmPassword(token,password,passwordConfirmation,termsAccepted){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/auth/invitation',{invitation_token:token,password:password,password_confirmation:passwordConfirmation,terms_and_conditions:termsAccepted}).then(function(response){return{ok:true,email:response.data.email};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'logout',value:function logout(){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/auth/sign_out').then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'recoverPassword',value:function recoverPassword(email,redirectUrl){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/auth/password',{email:email,redirect_url:redirectUrl}).then(function(response){return{ok:true,message:response.data.message};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'resetPassword',value:function resetPassword(password,passwordConfirmation,clientId,token,uid){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/auth/password',{password:password,password_confirmation:passwordConfirmation},{headers:{'access-token':token,client:clientId,uid:uid}}).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return AuthApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var authApi=new AuthApi();/* harmony default export */ __webpack_exports__["b"] = (AuthApi=new AuthApi());

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectList_css__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SelectList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checkbox_CheckBox__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectList=function(_Component){_inherits(SelectList,_Component);function SelectList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SelectList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SelectList.__proto__||Object.getPrototypeOf(SelectList)).call.apply(_ref,[this].concat(args))),_this),_this.handleChange=function(itemId){_this.props.onSelect(itemId);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SelectList,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select-list'},this.props.showAs==='list'?this.renderAsList():this.renderAsTable());}},{key:'renderAsList',value:function renderAsList(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.props.values.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},_this2.renderElement(element));}));}},{key:'renderAsTable',value:function renderAsTable(){var _this3=this;var rows=[];var row=[];this.props.values.forEach(function(element,index){if(index%2===0){row=[];row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this3.renderElement(element)));rows.push(row);}else{row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this3.renderElement(element)));}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'select-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,rows.map(function(row,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row[1]));})));}},{key:'renderElement',value:function renderElement(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__checkbox_CheckBox__["a" /* default */],{checked:element.selected,id:element.id,shape:'round',size:'medium',onChange:this.handleChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select-list-value'},element.value));}}]);return SelectList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelectList.propTypes={values:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool})),showAs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['list','table']),onSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};SelectList.defaultProps={showAs:'list',values:[]};/* harmony default export */ __webpack_exports__["a"] = (SelectList);

/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createGenerateClassName__ = __webpack_require__(1403);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createGenerateClassName__["a"]; });


/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__makeStyles__ = __webpack_require__(1419);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__makeStyles__["a"]; });


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StylesProvider__ = __webpack_require__(779);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__StylesProvider__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__StylesProvider__["a"]; });



/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(100);


function merge(acc, item) {
  if (!item) {
    return acc;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["a" /* deepmerge */])(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

/* harmony default export */ __webpack_exports__["a"] = (merge);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var Tablelvl2Context = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();

if (false) {
  Tablelvl2Context.displayName = 'Tablelvl2Context';
}

/* harmony default export */ __webpack_exports__["a"] = (Tablelvl2Context);

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(377);

var _utils2 = _interopRequireDefault(_utils);

var _animateScroll = __webpack_require__(797);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollEvents = __webpack_require__(518);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __mapped = {};
var __activeLink = void 0;

exports.default = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    props.absolute = true;

    var horizontal = props.horizontal;
    var scrollOffset = _utils2.default.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](to, target);
      }

      if (containerElement === document) {
        if (props.horizontal) {
          window.scrollTo(scrollOffset, 0);
        } else {
          window.scrollTo(0, scrollOffset);
        }
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2.default.registered['end']) {
        _scrollEvents2.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var updateHash = function updateHash(hash, historyUpdate) {
  var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
  var hashToUpdate = hashVal ? "#" + hashVal : "";
  var curLoc = window && window.location;
  var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
  historyUpdate ? history.pushState(null, "", urlToPush) : history.replaceState(null, "", urlToPush);
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, "");
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var scrollOffset = function scrollOffset(c, t, horizontal) {
  if (horizontal) {
    return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
  } else {
    return c === document ? t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) : getComputedStyle(c).position !== "static" ? t.offsetTop : t.offsetTop - c.offsetTop;
  }
};
exports.default = {
  updateHash: updateHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBuildings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getClientForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCurrentUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getInvalidFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getShowInviteUserModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getUserForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getUserModalState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getValidationMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getBuildings=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.client.data.buildings;},function(buildings){return buildings;});var getClient=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.client.data.client;},function(client){return client;});var getClientForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.client.ui.clientForm;},function(clientForm){return clientForm;});var getCurrentUserId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.client.ui.currentUserId;},function(currentUserId){return currentUserId;});var getInvalidFields=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.client.ui.invalidFields;},function(invalidFields){return invalidFields;});var getRoles=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.client.data.roles;},function(roles){return roles;});var getShowInviteUserModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.client.ui.showInviteUserModal;},function(showInviteUserModal){return showInviteUserModal;});var getUserForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.client.ui.userForm;},function(userForm){return userForm;});var getUserModalState=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.client.ui.userModalState;},function(userModalState){return userModalState;});var getUsers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.client.data.users;},function(users){return users;});var getValidationMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.client.ui.validationMessage;},function(validationMessage){return validationMessage;});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export baseRoutePath */
/* unused harmony export addUser */
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteUserRequest;
/* unused harmony export editUser */
/* unused harmony export invalidForm */
/* harmony export (immutable) */ __webpack_exports__["b"] = goToEditClient;
/* unused harmony export goToTeam */
/* harmony export (immutable) */ __webpack_exports__["c"] = loadBuildingsRequest;
/* harmony export (immutable) */ __webpack_exports__["d"] = loadClientRequest;
/* unused harmony export loadClientSuccess */
/* harmony export (immutable) */ __webpack_exports__["e"] = loadRolesRequest;
/* unused harmony export loadRolesSuccess */
/* harmony export (immutable) */ __webpack_exports__["f"] = loadUserForm;
/* harmony export (immutable) */ __webpack_exports__["g"] = loadUsersRequest;
/* unused harmony export loadUsersSuccess */
/* unused harmony export removeUser */
/* harmony export (immutable) */ __webpack_exports__["h"] = setCurrentUserId;
/* harmony export (immutable) */ __webpack_exports__["i"] = setShowInviteUserModal;
/* harmony export (immutable) */ __webpack_exports__["j"] = submitClientFormRequest;
/* harmony export (immutable) */ __webpack_exports__["k"] = submitUserFormRequest;
/* harmony export (immutable) */ __webpack_exports__["l"] = updateClientFormValue;
/* harmony export (immutable) */ __webpack_exports__["m"] = updateFormFromCurrentClient;
/* harmony export (immutable) */ __webpack_exports__["n"] = updateUserFormValue;
/* unused harmony export validForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_clients_api__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_users_api__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_api_roles_api__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_api_buildings_api__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_authentication__ = __webpack_require__(174);
var baseRoutePath='/admin/team';function addUser(user){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["l" /* CLIENT_TEAM_USERS_ADD */],payload:user};}function deleteUserRequest(userId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_users_api__["b" /* usersApi */].removeUser(userId).then(function(response){if(response.ok){dispatch(removeUser(userId));dispatch(setShowInviteUserModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function editUser(user){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["m" /* CLIENT_TEAM_USERS_EDIT */],payload:user};}function invalidForm(invalidFields,message){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["b" /* CLIENT_TEAM_CLIENT_FORM_INVALID */],payload:{invalidFields:invalidFields,message:message}};}function goToEditClient(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(baseRoutePath+'/edit'));};}function goToTeam(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(''+baseRoutePath));};}function loadBuildingsRequest(clientId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_7_services_api_buildings_api__["a" /* buildingsApi */].getBuildings(clientId).then(function(response){if(response.ok){dispatch(loadBuildingsSuccess(response.buildings));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadBuildingsSuccess(buildings){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["a" /* CLIENT_TEAM_BUILDINGS_LOAD_SUCCESS */],payload:buildings};}function loadClientRequest(clientId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_clients_api__["a" /* clientsApi */].getClient(clientId).then(function(response){if(response.ok){dispatch(loadClientSuccess(response.client));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadClientSuccess(client){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["e" /* CLIENT_TEAM_CLIENT_LOAD_SUCCESS */],payload:client};}function loadRolesRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5_services_api_roles_api__["b" /* rolesApi */].getRoles(__WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__["f" /* TYPES */].CLIENT).then(function(response){if(response.ok){dispatch(loadRolesSuccess(response.permissions));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadRolesSuccess(roles){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["k" /* CLIENT_TEAM_ROLES_LOAD_SUCCESS */],payload:roles};}function loadUserForm(user){return function(dispatch){var form=void 0;if(user!==null){form={buildingsId:user.building_ids,firstName:user.first_name,lastName:user.last_name,email:user.email,phoneNumber:user.phone_number!=null?user.phone_number:'',rolesId:user.roles.map(function(role){return role.id;}),title:user.title!==null?user.title:''};}else{form={buildingsId:[],firstName:'',lastName:'',email:'',phoneNumber:'',rolesId:[],title:''};}dispatch({type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["g" /* CLIENT_TEAM_INVITE_USER_FORM_LOAD */],payload:form});};}function loadUsersRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_users_api__["b" /* usersApi */].getUsers().then(function(response){if(response.ok){dispatch(loadUsersSuccess(response.users));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadUsersSuccess(users){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["n" /* CLIENT_TEAM_USERS_LOAD_SUCCESS */],payload:users};}function removeUser(userId){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["o" /* CLIENT_TEAM_USERS_REMOVE */],payload:userId};}function setCurrentUserId(userId){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["i" /* CLIENT_TEAM_INVITE_USER_ID_SET */],payload:userId};}function setShowInviteUserModal(open,state){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["j" /* CLIENT_TEAM_INVITE_USER_MODAL_SHOW */],payload:{open:open,state:state?state:undefined}};}function submitClientFormRequest(form,clientId){return function(dispatch){// Validate form
var requiredFields=['companyName','firstName','lastName','email','phoneNumber','streetAddress','city','state','zipCode'];var invalidFields=[];requiredFields.forEach(function(attribute){if(form[attribute]===''){invalidFields.push(attribute);}});if(invalidFields.length>0){dispatch(invalidForm(invalidFields,'The outlined inputs are mandatory.'));}else{dispatch(validForm());var data={name:form.companyName,firstName:form.firstName,lastName:form.lastName,email:form.email,phoneNumber:form.phoneNumber,streetAddress:form.streetAddress,unitNumber:form.unitNumber,city:form.city,state:form.state,zipCode:form.zipCode,globalPurchaseOrderRequired:form.globalPurchaseOrderRequired,purchaseOrderRequired:form.purchaseOrderRequired};return __WEBPACK_IMPORTED_MODULE_2_services_api_clients_api__["a" /* clientsApi */].updateClient(clientId,data).then(function(response){if(response.ok){dispatch(loadClientSuccess(response.client));Object(__WEBPACK_IMPORTED_MODULE_8_actions_authentication__["f" /* authRefreshUserAccountable */])(response.client);dispatch(goToTeam());window.location.reload();}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});}};}function submitUserFormRequest(form,userId,roles){return function(dispatch){var businessMgrRoleSelected=false;var businessMaganerRole=roles.find(function(role){return role.name===__WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__["e" /* ROLES */].CLIENT_BUILDING_MANAGER;});if(businessMaganerRole!==null){businessMgrRoleSelected=form.rolesId.find(function(id){return id===businessMaganerRole.id;})!==undefined;}// Validate form
var requiredFields=['firstName','lastName','email','phoneNumber'];var invalidFields=[];requiredFields.forEach(function(attribute){if(form[attribute]===''||form[attribute]===null){invalidFields.push(attribute);}});if(form['rolesId'].length===0){invalidFields.push('rolesId');}if(businessMgrRoleSelected&&form['buildingsId'].length===0){invalidFields.push('buildingsId');}if(invalidFields.length>0){dispatch(invalidForm(invalidFields,'The outlined inputs should be added in order to invite a user.'));}else{dispatch(validForm());if(userId===0){return __WEBPACK_IMPORTED_MODULE_4_services_api_users_api__["b" /* usersApi */].addUser(form.firstName,form.lastName,form.email,form.phoneNumber,form.rolesId,form.title,form.buildingsId).then(function(response){if(response.ok){dispatch(addUser(response.user));dispatch(setShowInviteUserModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});}else{return __WEBPACK_IMPORTED_MODULE_4_services_api_users_api__["b" /* usersApi */].updateUser(userId,form.firstName,form.lastName,form.email,form.phoneNumber,form.rolesId,form.title,form.buildingsId).then(function(response){if(response.ok){dispatch(editUser(response.user));dispatch(setShowInviteUserModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});}}};}function updateClientFormValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["d" /* CLIENT_TEAM_CLIENT_FORM_VALUE_UPDATE */],payload:{attribute:attribute,value:value}};}function updateFormFromCurrentClient(currentClient){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["f" /* CLIENT_TEAM_EDIT_FORM_LOAD_FROM_CURRENT */],payload:currentClient};}function updateUserFormValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["h" /* CLIENT_TEAM_INVITE_USER_FORM_VALUE_UPDATE */],payload:{attribute:attribute,value:value}};}function validForm(){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_action_types__["c" /* CLIENT_TEAM_CLIENT_FORM_VALID */]};}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(522),
    createWrap = __webpack_require__(1520),
    getHolder = __webpack_require__(526),
    replaceHolders = __webpack_require__(385);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and `partials` prepended to the arguments it receives.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * function greet(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * }
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */
var bind = baseRest(function(func, thisArg, partials) {
  var bitmask = WRAP_BIND_FLAG;
  if (partials.length) {
    var holders = replaceHolders(partials, getHolder(bind));
    bitmask |= WRAP_PARTIAL_FLAG;
  }
  return createWrap(func, bitmask, thisArg, partials, holders);
});

// Assign default placeholders.
bind.placeholder = {};

module.exports = bind;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(112);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(383),
    isObject = __webpack_require__(125);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(125);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 384 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 385 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(306),
    isObjectLike = __webpack_require__(261);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1567),
    listCacheDelete = __webpack_require__(1568),
    listCacheGet = __webpack_require__(1569),
    listCacheHas = __webpack_require__(1570),
    listCacheSet = __webpack_require__(1571);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(389);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 389 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(228);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1585);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(386);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(135);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(48);
var cof = __webpack_require__(135);
var MATCH = __webpack_require__(54)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(238);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(865);
var redefine = __webpack_require__(109);
var hide = __webpack_require__(110);
var fails = __webpack_require__(43);
var defined = __webpack_require__(150);
var wks = __webpack_require__(54);
var regexpExec = __webpack_require__(550);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(41);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(41);
var hide = __webpack_require__(110);
var uid = __webpack_require__(209);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(192) || !__webpack_require__(43)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(41)[K];
});


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(4);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(4);
var aFunction = __webpack_require__(98);
var ctx = __webpack_require__(137);
var forOf = __webpack_require__(216);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors_admin_work_orders_creation_creation__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_admin_work_orders_creation_creation__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_modal_ConfirmationModal__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Component to show and manage user decision for WO cancellation.
 */var CancelWorkOrder=function(_Component){_inherits(CancelWorkOrder,_Component);function CancelWorkOrder(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CancelWorkOrder);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CancelWorkOrder.__proto__||Object.getPrototypeOf(CancelWorkOrder)).call.apply(_ref,[this].concat(args))),_this),_this.handleWOCancellationConfirmation=function(result){if(result){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_admin_work_orders_work_orders__["d" /* cancelWorkOrderRequest */])(_this.props.currentWorkOrder.id));}_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_admin_work_orders_creation_creation__["a" /* closeWOCancellationModal */])());},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CancelWorkOrder,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_modal_ConfirmationModal__["a" /* default */],{show:this.props.showWOCancellationConfirmationModal,message:'Are you sure?',onHide:this.handleWOCancellationConfirmation});}}]);return CancelWorkOrder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(state){return{currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_5__selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),showWOCancellationConfirmationModal:Object(__WEBPACK_IMPORTED_MODULE_1__selectors_admin_work_orders_creation_creation__["b" /* getShowWOCancellationConfirmationModal */])(state)};})(CancelWorkOrder));

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNewWOProcessStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getShowWOCancellationConfirmationModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getNewWOProcessStarted=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.ui.newWOProcessStarted;},function(newWOProcessStarted){return newWOProcessStarted;});var getShowWOCancellationConfirmationModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.ui.showWOCancellationConfirmationModal;},function(showWOCancellationConfirmationModal){return showWOCancellationConfirmationModal;});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = continueCreateQuotes;
/* harmony export (immutable) */ __webpack_exports__["c"] = continueWithFormRequest;
/* harmony export (immutable) */ __webpack_exports__["a"] = closeCreateQuoteModal;
/* harmony export (immutable) */ __webpack_exports__["e"] = editForm;
/* unused harmony export invalidForm */
/* harmony export (immutable) */ __webpack_exports__["g"] = setCreateQuotesModalState;
/* unused harmony export setModalState */
/* harmony export (immutable) */ __webpack_exports__["h"] = setShowCreateQuotesModal;
/* unused harmony export setValidationMessage */
/* harmony export (immutable) */ __webpack_exports__["i"] = showCreateQuoteModal;
/* harmony export (immutable) */ __webpack_exports__["j"] = showReviewQuoteModal;
/* harmony export (immutable) */ __webpack_exports__["d"] = createQuoteRequest;
/* harmony export (immutable) */ __webpack_exports__["k"] = submitQuoteRequest;
/* harmony export (immutable) */ __webpack_exports__["l"] = submitQuotes;
/* harmony export (immutable) */ __webpack_exports__["f"] = respondCounterQuoteRequest;
/* harmony export (immutable) */ __webpack_exports__["m"] = updateFormValue;
/* unused harmony export validForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_quotes_api__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_work_orders_api__ = __webpack_require__(89);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function continueCreateQuotes(values){return function(dispatch){dispatch(setCreateQuotesForm(values));dispatch(setCreateQuotesModalState('review'));};}function continueWithFormRequest(form){return function(dispatch){var invalidAttributes=Object.keys(form).filter(function(formKey){return formKey!=='materialLeadDays';}).filter(function(key){return key!=='description'&&(form[key].value===''||form[key].value===null);});// Description is not required
if(invalidAttributes.length>0){dispatch(invalidForm(invalidAttributes));dispatch(setValidationMessage('The outlined inputs should be added'));}else{dispatch(validForm());}};}function closeCreateQuoteModal(){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_40" /* WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_CLOSE */]};}function editForm(){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_41" /* WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_EDIT */]};}function invalidForm(invalidAttributes){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_42" /* WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_INVALID */],payload:invalidAttributes};}function setCreateQuotesForm(values){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_37" /* WORK_ORDERS_DETAILS_CREATE_QUOTES_FORM_SET */],payload:values};}function setCreateQuotesModalState(state){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_39" /* WORK_ORDERS_DETAILS_CREATE_QUOTES_STATE_SET */],payload:state};}function setModalState(state){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_46" /* WORK_ORDERS_DETAILS_CREATE_QUOTE_STATE_SET */],payload:state};}function setShowCreateQuotesModal(value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_38" /* WORK_ORDERS_DETAILS_CREATE_QUOTES_MODAL_SHOW_SET */],payload:value};}function setValidationMessage(value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_47" /* WORK_ORDERS_DETAILS_CREATE_QUOTE_VALIDATION_MESSAGE_SET */],payload:value};}function showCreateQuoteModal(){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_45" /* WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_SHOW */]};}function showReviewQuoteModal(quote){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_140" /* WORK_ORDERS_DETAILS_REVIEW_QUOTE_MODAL_SHOW */],payload:quote};}function createQuoteRequest(form){return function(dispatch){var values={};Object.keys(form).forEach(function(key){values[key]=form[key].value;});return __WEBPACK_IMPORTED_MODULE_1_services_api_quotes_api__["a" /* quotesApi */].createQuote(values).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_details__["d" /* addQuote */])(response.quote));dispatch(setModalState('confirmation'));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function submitQuoteRequest(quoteId,form){return function(dispatch){var values={};Object.keys(form).forEach(function(key){values[key]=form[key].value;});return __WEBPACK_IMPORTED_MODULE_1_services_api_quotes_api__["a" /* quotesApi */].submitQuote(quoteId,values).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_details__["_16" /* updateQuotes */])([response.quote]));dispatch(setModalState('confirmation'));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function submitQuotes(workOrderId,contractorId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_work_orders_api__["b" /* workOrdersApi */].submitQuotes(workOrderId,contractorId,values).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_details__["_16" /* updateQuotes */])(response.quotes.map(function(quote){// Remove work_order property from the new object
var work_order=quote.work_order,newQuote=_objectWithoutProperties(quote,['work_order']);return newQuote;})));dispatch(setCreateQuotesModalState('confirmation'));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function respondCounterQuoteRequest(quoteId,action){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_quotes_api__["a" /* quotesApi */].respondCounterQuote(quoteId,action).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_details__["_16" /* updateQuotes */])([response.quote]));dispatch(setModalState('confirmation'));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function updateFormValue(value,attribute){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_44" /* WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_VALUE_UPDATE */],payload:{value:value,attribute:attribute}};}function validForm(){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_43" /* WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_VALID */]};}

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copyArray_js__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stringToPath_js__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toString_js__ = __webpack_require__(919);








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(value, __WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */]);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toString_js__["a" /* default */])(value)));
}

/* harmony default export */ __webpack_exports__["a"] = (toPath);


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(223);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(230);


/* Built-in method references that are verified to be native. */
var nativeCreate = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'create');

/* harmony default export */ __webpack_exports__["a"] = (nativeCreate);


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__ = __webpack_require__(1997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__ = __webpack_require__(1998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__ = __webpack_require__(1999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__ = __webpack_require__(2000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__ = __webpack_require__(2001);






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__["a" /* default */];
ListCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__["a" /* default */];
ListCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__["a" /* default */];
ListCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__["a" /* default */];
ListCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (ListCache);


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(318);


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (assocIndexOf);


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isKeyable_js__ = __webpack_require__(2003);


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return Object(__WEBPACK_IMPORTED_MODULE_0__isKeyable_js__["a" /* default */])(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ __webpack_exports__["a"] = (getMapData);


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__ = __webpack_require__(2010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(223);



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(other))) {
    return value !== value && other !== other;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__["a" /* default */])(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqual);


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__(2032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(223);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(2033);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(300)(module)))

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__(2034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(2035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(2036);




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(927);


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */]) {
    Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignValue);


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FormTextArea;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_input_TextArea__ = __webpack_require__(62);
/**
 * Wrapper for TextArea field used inside redux-form.
 * @param props
 * @return {*}
 * @constructor
 */function FormTextArea(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_input_TextArea__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));}

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = loadChangeOrderTasksRequest;
/* unused harmony export loadChangeOrderTasksSuccess */
/* harmony export (immutable) */ __webpack_exports__["e"] = setShowChangeOrderTaskModal;
/* harmony export (immutable) */ __webpack_exports__["a"] = createChangeOrderTask;
/* harmony export (immutable) */ __webpack_exports__["c"] = editChangeOrderTask;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteChangeOrderTask;
/* unused harmony export addChangeOrderTask */
/* harmony export (immutable) */ __webpack_exports__["f"] = updateChangeOrderTask;
/* unused harmony export removeChangeOrderTask */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_tasks_store_action_types__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_change_order_tasks_api__ = __webpack_require__(939);
function loadChangeOrderTasksRequest(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_change_order_tasks_api__["a" /* changeOrderTasksApi */].getChangeOrderTasks(workOrderId).then(function(response){if(response.ok){dispatch(loadChangeOrderTasksSuccess(response.changeOrderTasks));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadChangeOrderTasksSuccess(changeOrderTasks){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_tasks_store_action_types__["b" /* CHANGE_ORDER_TASKS_LOAD_SUCCESS */],payload:changeOrderTasks};}function setShowChangeOrderTaskModal(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_tasks_store_action_types__["c" /* CHANGE_ORDER_TASKS_SHOW_MODAL_SET */]};}function createChangeOrderTask(taskId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_change_order_tasks_api__["a" /* changeOrderTasksApi */].createChangeOrderTask(taskId,values).then(function(response){if(response.ok){dispatch(setShowChangeOrderTaskModal());dispatch(addChangeOrderTask(response.changeOrderTask));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function editChangeOrderTask(changeOrderTaskId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_change_order_tasks_api__["a" /* changeOrderTasksApi */].updateChangeOrderTask(changeOrderTaskId,values).then(function(response){if(response.ok){dispatch(setShowChangeOrderTaskModal());dispatch(updateChangeOrderTask(response.changeOrderTask));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function deleteChangeOrderTask(changeOrderTaskId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_change_order_tasks_api__["a" /* changeOrderTasksApi */].deleteChangeOrderTask(changeOrderTaskId).then(function(response){if(response.ok){dispatch(removeChangeOrderTask(changeOrderTaskId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function addChangeOrderTask(changeOrderTask){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_tasks_store_action_types__["a" /* CHANGE_ORDER_TASKS_ADD */],payload:changeOrderTask};}function updateChangeOrderTask(changeOrderTask){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_tasks_store_action_types__["d" /* CHANGE_ORDER_TASKS_UPDATE */],payload:changeOrderTask};}function removeChangeOrderTask(changeOrderTaskId){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_tasks_store_action_types__["e" /* CHANGE_ORDER_TASK_DELETE */],payload:changeOrderTaskId};}

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getShowChangeOrderQuoteModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getShowChangeOrderRequestConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSelectedChangeOrderTaskId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getShowChangeOrderQuoteModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrderQuotes.ui.showChangeOrderQuoteModal;},function(showChangeOrderQuoteModal){return showChangeOrderQuoteModal;});var getShowChangeOrderRequestConfirmation=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrderQuotes.ui.showChangeOrderRequestConfirmation;},function(showChangeOrderRequestConfirmation){return showChangeOrderRequestConfirmation;});var getSelectedChangeOrderTaskId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.changeOrderQuotes.data.selectedChangeOrderTaskId;},function(selectedChangeOrderTaskId){return selectedChangeOrderTaskId;});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return proposalsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProposalsApi=function(_BaseApi){_inherits(ProposalsApi,_BaseApi);function ProposalsApi(){_classCallCheck(this,ProposalsApi);return _possibleConstructorReturn(this,(ProposalsApi.__proto__||Object.getPrototypeOf(ProposalsApi)).apply(this,arguments));}_createClass(ProposalsApi,[{key:'approve',value:function approve(proposalId,quotesId){var data={proposal:{quote_ids:quotesId}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/proposals/'+proposalId+'/approve',data).then(function(response){return{ok:true,proposal:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'create',value:function create(workOrderId,startDate,completionDate,markups,qualifications,deposit){var data={proposal:{work_order_id:workOrderId,start_date:startDate,completion_date:completionDate,proposal_quotes_attributes:markups,proposal_qualifications_attributes:qualifications,deposit_attributes:deposit}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/proposals',data).then(function(response){return{ok:true,proposal:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'reject',value:function reject(proposalId,password,reason1,reason2){var data={proposal:{password:password,rejected_reason_1:reason1,rejected_reason_2:reason2}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/proposals/'+proposalId+'/reject',data).then(function(response){return{ok:true,proposal:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getAsPdf',value:function getAsPdf(proposalId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/proposals/'+proposalId+'/print',{responseType:'blob'}).then(function(response){return{ok:true,pdf:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'sendEmail',value:function sendEmail(proposalId,emails,subject,message){var data={proposal:{send_to:emails,subject:subject,message:message}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/proposals/'+proposalId+'/email',data).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'withdraw',value:function withdraw(proposalId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/proposals/'+proposalId+'/withdraw').then(function(response){return{ok:true,proposal:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'update',value:function update(proposalId,values){var apiPayload={proposal:{cli_additional_cost:values['additionalCost'],cli_additional_cost_desc:values['additionalCostDesc'],proposal_quotes_attributes:values['proposal_quotes']}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/proposals/'+proposalId,apiPayload).then(function(response){return{ok:true,proposal:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return ProposalsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var proposalsApi=new ProposalsApi();

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmailEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmailEditor_css__ = __webpack_require__(2209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmailEditor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EmailEditor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_add_svg__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_add_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_add_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_remove_svg__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_remove_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_remove_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_button_ImageButton__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_utils_text_util__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EmailEditor=function(_Component){_inherits(EmailEditor,_Component);function EmailEditor(props){_classCallCheck(this,EmailEditor);var _this=_possibleConstructorReturn(this,(EmailEditor.__proto__||Object.getPrototypeOf(EmailEditor)).call(this,props));_this.handleToEmailRemove=function(email){if(_this.props.onToEmailRemove){_this.props.onToEmailRemove(email);}};_this.handleCustomEmailChange=function(value){_this.setState({customEmail:value});};_this.handleCustomEmailAdd=function(){if(Object(__WEBPACK_IMPORTED_MODULE_10_services_utils_text_util__["f" /* validateEmail */])(_this.state.customEmail)){if(_this.props.onCustomEmailAdd){_this.props.onCustomEmailAdd(_this.state.customEmail);}_this.setState({customEmail:'',customEmailValid:true});}else{_this.setState({customEmailValid:false});}};_this.handleUserEmailChange=function(option){_this.setState({userEmailOptionSelected:option});};_this.handleUserEmailAdd=function(){if(_this.props.onUserEmailAdd){_this.props.onUserEmailAdd(_this.state.userEmailOptionSelected.label);}_this.setState({userEmailOptionSelected:null});};_this.handleSubjectClick=function(){if(_this.state.customSubjectInputEnable&&_this.props.onSubjectConfirm){_this.props.onSubjectConfirm(_this.state.customSubject);}_this.setState({customSubjectInputEnable:!_this.state.customSubjectInputEnable});};_this.handleSubjectChange=function(value){_this.setState({customSubject:value});};_this.state={customEmail:'',customEmailValid:true,customSubject:props.subject,customSubjectInputEnable:false,userEmailOptionSelected:null};return _this;}_createClass(EmailEditor,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'email-editor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'body-bold'},'To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ee-to-emails-container'},this.props.toEmails.map(function(email,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_button_ImageButton__["a" /* default */],{alt:'remove',src:__WEBPACK_IMPORTED_MODULE_4_images_remove_svg___default.a,onClick:_this2.handleToEmailRemove.bind(_this2,email)})));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ee-custom-email-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_input_Input__["a" /* default */],{placeholder:'Email',valid:this.state.customEmailValid,value:this.state.customEmail,onChange:this.handleCustomEmailChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:this.state.customEmail==='',label:'Add',onClick:this.handleCustomEmailAdd})),!this.state.customEmailValid&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'Please verify email address.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ee-users-email-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_dropdown_Dropdown__["a" /* default */],{options:this.props.usersEmail.filter(function(email){return _this2.props.toEmails.find(function(toEmail){return toEmail===email;})===undefined;}).map(function(email,index){return{value:index,label:email};}),placeholder:'',value:this.state.userEmailOptionSelected!==null?this.state.userEmailOptionSelected.value:null,onChange:this.handleUserEmailChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_button_ImageButton__["a" /* default */],{alt:'add',disabled:this.state.userEmailOptionSelected===null,src:__WEBPACK_IMPORTED_MODULE_3_images_add_svg___default.a,onClick:this.handleUserEmailAdd})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'with-border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'body-bold'},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ee-subject-container'},!this.state.customSubjectInputEnable?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body-bold subject'},this.state.customSubject):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_input_Input__["a" /* default */],{value:this.state.customSubject,onChange:this.handleSubjectChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-gray',disabled:this.state.customSubjectInputEnable&&this.state.customSubject==='',label:this.state.customSubjectInputEnable?'Confirm Subject':'Edit Subject',onClick:this.handleSubjectClick})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'with-border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'body-bold message'},'Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_TextArea__["a" /* default */],{value:this.props.message,onChange:this.props.onMessageChange}))))));}}]);return EmailEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);EmailEditor.propTypes={message:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,subject:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,toEmails:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string),usersEmail:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string),onCustomEmailAdd:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,onMessageChange:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,onSubjectConfirm:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,onToEmailRemove:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,onUserEmailAdd:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func};EmailEditor.defaultProps={toEmails:[],usersEmail:[]};

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TimePicker_css__ = __webpack_require__(2255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TimePicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TimePicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_datetime__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datetime_css_react_datetime_css__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datetime_css_react_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_datetime_css_react_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__input_ReadOnlyInput__ = __webpack_require__(313);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TimePicker=function(_Component){_inherits(TimePicker,_Component);function TimePicker(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TimePicker);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TimePicker.__proto__||Object.getPrototypeOf(TimePicker)).call.apply(_ref,[this].concat(args))),_this),_this.handleOnChange=function(valueMoment){_this.props.onChange(valueMoment.format('YYYY-MM-DD hh:mm A'));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TimePicker,[{key:'render',value:function render(){var _this2=this;return this.props.readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__input_ReadOnlyInput__["a" /* default */],{'class':this.props.className!==undefined?' '+this.props.className:'',placeholder:this.props.placeholder,theme:this.props.theme,value:this.props.value?__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(this.props.value,'YYYY-MM-DD hh:mm A').format(this.props.format):''}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time-picker'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_datetime___default.a,{closeOnSelect:true,inputProps:{className:'form-control input'+(this.props.required?' required':'')+(!this.props.valid?' invalid':'')+' '+this.props.className,placeholder:this.props.placeholder,readOnly:true},value:this.props.value?__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(this.props.value,'YYYY-MM-DD hh:mm A').format(this.props.format):'',dateFormat:false,timeFormat:this.props.format,onChange:function onChange(value){return _this2.handleOnChange(value);}}));}}]);return TimePicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TimePicker.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,format:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,required:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,theme:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,valid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};TimePicker.defaultProps={format:'hh:mm A',valid:true,value:null};/* harmony default export */ __webpack_exports__["a"] = (TimePicker);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_iframe__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_button_ImageButton__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_close_svg__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SigningModal_css__ = __webpack_require__(2315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SigningModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SigningModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SigningModal=function(_Component){_inherits(SigningModal,_Component);function SigningModal(){_classCallCheck(this,SigningModal);return _possibleConstructorReturn(this,(SigningModal.__proto__||Object.getPrototypeOf(SigningModal)).apply(this,arguments));}_createClass(SigningModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */],{className:'signing-modal',show:this.props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body-bold'},this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_ImageButton__["a" /* default */],{alt:'close',src:__WEBPACK_IMPORTED_MODULE_5_images_close_svg___default.a,onClick:this.props.handleClose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */].Body,null,this.props.url&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_iframe__["a" /* default */],{url:this.props.url,className:'signing-iframe',width:'100%',height:'100%',display:'initial',position:'relative',allowFullScreen:true})));}}]);return SigningModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SigningModal.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,handleClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SigningModal);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectStatus_css__ = __webpack_require__(2335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectStatus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProjectStatus_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectStatus=function(_Component){_inherits(ProjectStatus,_Component);function ProjectStatus(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProjectStatus);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProjectStatus.__proto__||Object.getPrototypeOf(ProjectStatus)).call.apply(_ref,[this].concat(args))),_this),_this.configuration={pending:{position:0,total:2},in_progress:{position:1,total:2}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProjectStatus,[{key:'render',value:function render(){var status=this.props.status;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-text '+(status?status.status:'')},status?status.label.toUpperCase():''));}}]);return ProjectStatus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProjectStatus.propTypes={status:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({status:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})};/* harmony default export */ __webpack_exports__["a"] = (ProjectStatus);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return projectsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectsApi=function(_BaseApi){_inherits(ProjectsApi,_BaseApi);function ProjectsApi(){_classCallCheck(this,ProjectsApi);return _possibleConstructorReturn(this,(ProjectsApi.__proto__||Object.getPrototypeOf(ProjectsApi)).apply(this,arguments));}_createClass(ProjectsApi,[{key:'getProjects',value:function getProjects(filters){var query='';Object.keys(filters).filter(function(filter){return filters[filter];}).forEach(function(filter,index){if(index>0){query+='&';}query+=filter+'='+filters[filter];});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects?'+query).then(function(response){return{ok:true,projects:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),totalMyProjects:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-my_projects']).value(),totalPending:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-pending']).value(),totalInProgress:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-in_progress']).value(),totalCancelled:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-cancelled']).value(),totalLost:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-lost']).value(),totalPrecon:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-precon']).value(),totalComplete:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-complete']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getProjectsCount',value:function getProjectsCount(filters){var query='';Object.keys(filters).forEach(function(filter,index){if(index>0){query+='&';}query+=filter+'='+filters[filter];});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/count?'+query).then(function(response){return{ok:true,count:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getProject',value:function getProject(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId).then(function(response){return{ok:true,project:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'dailyReportsReminder',value:function dailyReportsReminder(id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+id+'/daily_reports_reminder').then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createProject',value:function createProject(values){var data=this.projectParams(values);if(values.generalContractorId){data['project']['general_contractor_id']=values.generalContractorId;}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/projects',data).then(function(response){return{ok:true,project:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateProject',value:function updateProject(id,values){var data=this.projectParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+id,data).then(function(response){return{ok:true,project:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'projectParams',value:function projectParams(values){return{project:{number:values.number,name:values.name,sq_footage:values.sqFootage,bid_due_date:values.bidDueDate,client_id:values.clientId,building_id:values.buildingId,status:values.status,termination_date:values.terminationDate,termination_reason:values.terminationReason,termination_category:values.terminationCategory,advanced_document_view:values.advancedDocumentView}};}}]);return ProjectsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var projectsApi=new ProjectsApi();

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = changeAttribute;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSurvey;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSurveys;
/* harmony export (immutable) */ __webpack_exports__["e"] = goToSurveys;
/* harmony export (immutable) */ __webpack_exports__["d"] = goToSurvey;
/* harmony export (immutable) */ __webpack_exports__["f"] = setSurveyForm;
/* harmony export (immutable) */ __webpack_exports__["g"] = submitSurvey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_surveys_api__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_surveys_store_action_types__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_surveys_store_selectors__ = __webpack_require__(599);
var baseRoutePath='/admin/surveys';function changeAttribute(attribute,value){return function(dispatch,getState){dispatch(changeFormAttribute(attribute,value));var surveyForm=Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_surveys_store_selectors__["e" /* surveyFormSelector */])(getState());if(surveyForm.response_time_sat!==null&&surveyForm.work_quality_sat!==null&&surveyForm.recommend_spackle!==null){dispatch(setShowValidationMessage(false));}};}function changeFormAttribute(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_surveys_store_action_types__["d" /* SURVEYS_SURVEY_FORM_ATTRIBUTE_CHANGE */],payload:{attribute:attribute,value:value}};}function changePage(page){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_surveys_store_action_types__["b" /* SURVEYS_PAGINATION_PAGE_CHANGE */],payload:page};}function getSurvey(surveyId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_surveys_api__["a" /* surveysApi */].getSurvey(surveyId).then(function(response){if(response.ok){dispatch(setCurrentSurvey(response.survey));// Load form with survey, in case it's possible to edit it
dispatch(setSurveyForm(response.survey));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function getSurveys(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var pending=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_surveys_api__["a" /* surveysApi */].getSurveys(page,pending).then(function(response){if(response.ok){dispatch(setSurveys(response.surveys.content));dispatch(setPendingTotal(response.surveys.totalPending));if(page===1){dispatch(setPaginationInfo(response.surveys.total,response.surveys.pageSize,page));}else{dispatch(changePage(page));}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function goToSurveys(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])(''+baseRoutePath));};}function goToSurvey(surveyId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])(baseRoutePath+'/'+surveyId));};}function setCurrentSurvey(survey){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_surveys_store_action_types__["g" /* SURVEYS_SURVEY_SET */],payload:survey};}function setPaginationInfo(total,pageSize,page){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_surveys_store_action_types__["a" /* SURVEYS_PAGINATION_INFO_SET */],payload:{total:total,pageSize:pageSize,page:page}};}function setPendingTotal(total){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_surveys_store_action_types__["h" /* SURVEYS_TOTAL_PENDING_SET */],payload:total};}function setShowValidationMessage(value){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_surveys_store_action_types__["f" /* SURVEYS_SURVEY_FORM_VALIDATION_MESSAGE_SET */],payload:value};}function setSurveyForm(survey){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_surveys_store_action_types__["e" /* SURVEYS_SURVEY_FORM_SET */],payload:survey};}function setSurveys(surveys){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_surveys_store_action_types__["c" /* SURVEYS_SET */],payload:surveys};}function submitSurvey(surveyForm){return function(dispatch){if(surveyForm.response_time_sat===null||surveyForm.work_quality_sat===null||surveyForm.recommend_spackle===null){dispatch(setShowValidationMessage(true));}else{return __WEBPACK_IMPORTED_MODULE_1_services_api_surveys_api__["a" /* surveysApi */].updateSurvey(surveyForm.id,surveyForm).then(function(response){if(response.ok){dispatch(setCurrentSurvey(response.survey));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])(''+baseRoutePath));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});}};}

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export changePage */
/* unused harmony export initializeUi */
/* harmony export (immutable) */ __webpack_exports__["a"] = firstLoadTasksRequest;
/* harmony export (immutable) */ __webpack_exports__["b"] = loadTasksRequest;
/* unused harmony export loadTasksSuccess */
/* unused harmony export loadTradesSuccess */
/* harmony export (immutable) */ __webpack_exports__["c"] = openTaskDetails;
/* unused harmony export selectContractor */
/* unused harmony export selectTrade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_tasks_api__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_trades_api__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__work_orders_work_orders__ = __webpack_require__(35);
function changePage(newPage){return{type:__WEBPACK_IMPORTED_MODULE_1__action_types__["c" /* TASKS_PAGE_CHANGE */],payload:newPage};}function initializeUi(){return{type:__WEBPACK_IMPORTED_MODULE_1__action_types__["f" /* TASKS_UI_INITIALIZE */]};}function firstLoadTasksRequest(){return function(dispatch){dispatch(initializeUi());var promises=[];promises.push(__WEBPACK_IMPORTED_MODULE_2__services_api_tasks_api__["b" /* tasksApi */].getTasks(1));promises.push(__WEBPACK_IMPORTED_MODULE_3__services_api_trades_api__["b" /* tradesApi */].getTrades());return Promise.all(promises).then(function(results){if(results[0].ok){dispatch(loadTasksSuccess(results[0].tasks));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(results[0].errors));}if(results[1].ok){dispatch(loadTradesSuccess(results[1].trades));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(results[1].errors));}});};}function loadTasksRequest(page,contractorId,tradeId,critical,taskStatus){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2__services_api_tasks_api__["b" /* tasksApi */].getTasks(page,contractorId===null?undefined:contractorId,tradeId===null?undefined:tradeId,critical,taskStatus).then(function(response){if(response.ok){dispatch(loadTasksSuccess(response.tasks));dispatch(changePage(page));dispatch(selectContractor(contractorId===undefined?null:contractorId));dispatch(selectTrade(tradeId===undefined?null:tradeId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadTasksSuccess(tasks){return{type:__WEBPACK_IMPORTED_MODULE_1__action_types__["b" /* TASKS_LOAD_SUCCESS */],payload:tasks};}function loadTradesSuccess(trades){return{type:__WEBPACK_IMPORTED_MODULE_1__action_types__["e" /* TASKS_TRADES_SUCCESS */],payload:trades};}function openTaskDetails(task){return function(dispatch){if(task.status==='draft'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__work_orders_work_orders__["w" /* selectWorkOrderRequest */])(task.work_order_id,task.work_order.status));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["d" /* push */])('/admin/work-orders/'+task.work_order_id+'/task/'+task.id));}};}function selectContractor(contractorId){return{type:__WEBPACK_IMPORTED_MODULE_1__action_types__["a" /* TASKS_CONTRACTOR_SELECT */],payload:contractorId};}function selectTrade(tradeId){return{type:__WEBPACK_IMPORTED_MODULE_1__action_types__["d" /* TASKS_TRADES_SELECT */],payload:tradeId};}

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getInvoices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCustomEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCustomEmailValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getInvalidFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getPdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getShowEmailModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getShowPdfViewer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getShowSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getUsersByClientId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getUsersIdSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getValidationMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getTabSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getSelectedStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getInvoices=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.invoices.data.invoices;},function(invoices){return invoices;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.invoices.ui.currentPage;},function(currentPage){return currentPage;});var getCustomEmail=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.invoices.ui.customEmail;},function(customEmail){return customEmail;});var getCustomEmailValid=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.invoices.ui.customEmailValid;},function(customEmailValid){return customEmailValid;});var getCurrentInvoice=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.invoices.data.currentInvoice;},function(currentInvoice){return currentInvoice;});var getEdit=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.invoices.ui.edit;},function(edit){return edit;});var getForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.invoices.ui.form;},function(form){return form;});var getInvalidFields=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.invoices.ui.invalidFields;},function(invalidFields){return invalidFields;});var getPdf=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.invoices.ui.pdf;},function(pdf){return pdf;});var getShowEmailModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.invoices.ui.showEmailModal;},function(showEmailModal){return showEmailModal;});var getShowPdfViewer=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.invoices.ui.showPdfViewer;},function(showPdfViewer){return showPdfViewer;});var getShowSave=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.invoices.ui.showSave;},function(showSave){return showSave;});var getUsersByClientId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.invoices.data.usersByClientId;},function(usersByClientId){return usersByClientId;});var getUsersIdSelected=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.invoices.ui.usersIdSelected;},function(usersIdSelected){return usersIdSelected;});var getValidationMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.invoices.ui.validationMessage;},function(validationMessage){return validationMessage;});var getTabSelection=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.invoices.ui.tabSelection;},function(tabSelection){return tabSelection;});var getSelectedStatus=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.invoices.ui.selectedStatus;},function(selectedStatus){return selectedStatus;});

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mail-white.42b58d72.svg";

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseStatus__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserStatus_css__ = __webpack_require__(2422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserStatus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UserStatus_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserStatus=function(_Component){_inherits(UserStatus,_Component);function UserStatus(){_classCallCheck(this,UserStatus);return _possibleConstructorReturn(this,(UserStatus.__proto__||Object.getPrototypeOf(UserStatus)).apply(this,arguments));}_createClass(UserStatus,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BaseStatus__["a" /* default */],{labels:[{id:'active',label:'active'},{id:'inactive',label:'inactive'},{id:'pending_invitation',label:'pending invitation'}],status:this.props.status}));}}]);return UserStatus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UserStatus.propTypes={status:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (UserStatus);

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleFullscreenChange = handleFullscreenChange;
exports.activate = activate;
exports.userActivate = userActivate;
exports.play = play;
exports.pause = pause;
exports.togglePlay = togglePlay;
exports.seek = seek;
exports.forward = forward;
exports.replay = replay;
exports.changeRate = changeRate;
exports.changeVolume = changeVolume;
exports.mute = mute;
exports.toggleFullscreen = toggleFullscreen;
exports.USER_ACTIVATE = exports.PLAYER_ACTIVATE = exports.FULLSCREEN_CHANGE = exports.OPERATE = void 0;

var _fullscreen = _interopRequireDefault(__webpack_require__(984));

var OPERATE = 'video-react/OPERATE';
exports.OPERATE = OPERATE;
var FULLSCREEN_CHANGE = 'video-react/FULLSCREEN_CHANGE';
exports.FULLSCREEN_CHANGE = FULLSCREEN_CHANGE;
var PLAYER_ACTIVATE = 'video-react/PLAYER_ACTIVATE';
exports.PLAYER_ACTIVATE = PLAYER_ACTIVATE;
var USER_ACTIVATE = 'video-react/USER_ACTIVATE';
exports.USER_ACTIVATE = USER_ACTIVATE;

function handleFullscreenChange(isFullscreen) {
  return {
    type: FULLSCREEN_CHANGE,
    isFullscreen: isFullscreen
  };
}

function activate(activity) {
  return {
    type: PLAYER_ACTIVATE,
    activity: activity
  };
}

function userActivate(activity) {
  return {
    type: USER_ACTIVATE,
    activity: activity
  };
}

function play() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    action: 'play',
    source: ''
  };
  this.video.play();
  return {
    type: OPERATE,
    operation: operation
  };
}

function pause() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    action: 'pause',
    source: ''
  };
  this.video.pause();
  return {
    type: OPERATE,
    operation: operation
  };
}

function togglePlay() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    action: 'toggle-play',
    source: ''
  };
  this.video.togglePlay();
  return {
    type: OPERATE,
    operation: operation
  };
} // seek video by time


function seek(time) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'seek',
    source: ''
  };
  this.video.seek(time);
  return {
    type: OPERATE,
    operation: operation
  };
} // jump forward x seconds


function forward(seconds) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: "forward-".concat(seconds),
    source: ''
  };
  this.video.forward(seconds);
  return {
    type: OPERATE,
    operation: operation
  };
} // jump back x seconds


function replay(seconds) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: "replay-".concat(seconds),
    source: ''
  };
  this.video.replay(seconds);
  return {
    type: OPERATE,
    operation: operation
  };
}

function changeRate(rate) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'change-rate',
    source: ''
  };
  this.video.playbackRate = rate;
  return {
    type: OPERATE,
    operation: operation
  };
}

function changeVolume(volume) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'change-volume',
    source: ''
  };
  var v = volume;

  if (volume < 0) {
    v = 0;
  }

  if (volume > 1) {
    v = 1;
  }

  this.video.volume = v;
  return {
    type: OPERATE,
    operation: operation
  };
}

function mute(muted) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: muted ? 'muted' : 'unmuted',
    source: ''
  };
  this.video.muted = muted;
  return {
    type: OPERATE,
    operation: operation
  };
}

function toggleFullscreen(player) {
  if (_fullscreen["default"].enabled) {
    if (_fullscreen["default"].isFullscreen) {
      _fullscreen["default"].exit();
    } else {
      _fullscreen["default"].request(this.rootElement);
    }

    return {
      type: OPERATE,
      operation: {
        action: 'toggle-fullscreen',
        source: ''
      }
    };
  }

  return {
    type: FULLSCREEN_CHANGE,
    isFullscreen: !player.isFullscreen
  };
}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findElPosition = findElPosition;
exports.getPointerPosition = getPointerPosition;
exports.blurNode = blurNode;
exports.focusNode = focusNode;
exports.hasClass = hasClass;

/**
 * Offset Left
 * getBoundingClientRect technique from
 * John Resig http://ejohn.org/blog/getboundingclientrect-is-awesome/
 *
 * @function findElPosition
 * @param {ReactNodeRef} el React Node ref from which to get offset
 * @return {Object}
 */
function findElPosition(el) {
  var box;

  if (el.getBoundingClientRect && el.parentNode) {
    box = el.getBoundingClientRect();
  }

  if (!box) {
    return {
      left: 0,
      top: 0
    };
  }

  var _document = document,
      body = _document.body,
      docEl = _document.documentElement;
  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
  var scrollLeft = window.pageXOffset || body.scrollLeft;
  var left = box.left + scrollLeft - clientLeft;
  var clientTop = docEl.clientTop || body.clientTop || 0;
  var scrollTop = window.pageYOffset || body.scrollTop;
  var top = box.top + scrollTop - clientTop; // Android sometimes returns slightly off decimal values, so need to round

  return {
    left: Math.round(left),
    top: Math.round(top)
  };
}
/**
 * Get pointer position in a React Node ref
 * Returns an object with x and y coordinates.
 * The base on the coordinates are the bottom left of the element.
 *
 * @function getPointerPosition
 * @param {ReactNodeRef} el React Node ref on which to get the pointer position on
 * @param {Event} event Event object
 * @return {Object} This object will have x and y coordinates corresponding to the mouse position
 */


function getPointerPosition(el, event) {
  var position = {};
  var box = findElPosition(el);
  var boxW = el.offsetWidth;
  var boxH = el.offsetHeight;
  var boxY = box.top;
  var boxX = box.left;
  var evtPageY = event.pageY;
  var evtPageX = event.pageX;

  if (event.changedTouches) {
    evtPageX = event.changedTouches[0].pageX;
    evtPageY = event.changedTouches[0].pageY;
  }

  position.y = Math.max(0, Math.min(1, (boxY - evtPageY + boxH) / boxH));
  position.x = Math.max(0, Math.min(1, (evtPageX - boxX) / boxW));
  return position;
} // blur an element


function blurNode(reactNode) {
  if (reactNode && reactNode.blur) {
    reactNode.blur();
  }
} // focus an element


function focusNode(reactNode) {
  if (reactNode && reactNode.focus) {
    reactNode.focus();
  }
} // check if an element has a class name


function hasClass(elm, cls) {
  var classes = elm.className.split(' ');

  for (var i = 0; i < classes.length; i++) {
    if (classes[i].toLowerCase() === cls.toLowerCase()) {
      return true;
    }
  }

  return false;
}

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getInvoices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPaginationInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return searchTextSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return vendorsInvoicesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return vendorsInvoicesPaginationInfoSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return searchFiltersSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getInvoices=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractorsInvoices.data.invoices;},function(invoices){return invoices;});var getPaginationInfo=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractorsInvoices.ui.paginationInfo;},function(paginationInfo){return paginationInfo;});var searchTextSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractorsInvoices.ui.searchText;},function(searchText){return searchText;});var vendorsInvoicesSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractorsInvoices.data.vendorInvoices;},function(vendorInvoices){return vendorInvoices;});var vendorsInvoicesPaginationInfoSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractorsInvoices.ui.vendorInvoicesPaginationInfo;},function(vendorInvoicesPaginationInfo){return vendorInvoicesPaginationInfo;});var searchFiltersSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.contractorsInvoices.ui.searchFilters;},function(searchFilters){return searchFilters;});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getProjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getMissingDrs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBidsDue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getMissingDrsCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBidsDueCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCurrentNav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getMissingDrsCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBidsDueCount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getProjects=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.data.projects;},function(projects){return projects;});var getMissingDrs=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.data.missingDrs;},function(missingDrs){return missingDrs;});var getBidsDue=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.data.bidsDue;},function(bidsDue){return bidsDue;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.ui.currentPage;},function(currentPage){return currentPage;});var getMissingDrsCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.ui.missingDrsCurrentPage;},function(missingDrsCurrentPage){return missingDrsCurrentPage;});var getBidsDueCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.ui.bidsDueCurrentPage;},function(bidsDueCurrentPage){return bidsDueCurrentPage;});var getCurrentNav=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.ui.currentNav;},function(currentNav){return currentNav;});var getMissingDrsCount=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.data.missingDrsCount;},function(missingDrsCount){return missingDrsCount;});var getBidsDueCount=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.data.bidsDueCount;},function(bidsDueCount){return bidsDueCount;});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = initMeetingMinutes;
/* unused harmony export loadMeetingInfoSuccess */
/* harmony export (immutable) */ __webpack_exports__["i"] = loadMeetingInfoRequest;
/* harmony export (immutable) */ __webpack_exports__["q"] = setMeetingInfoEdit;
/* harmony export (immutable) */ __webpack_exports__["d"] = createMeetingInfo;
/* harmony export (immutable) */ __webpack_exports__["y"] = updateMeetingInfo;
/* unused harmony export loadMeetingsSuccess */
/* harmony export (immutable) */ __webpack_exports__["l"] = loadMeetingsRequest;
/* harmony export (immutable) */ __webpack_exports__["v"] = togglePdfViewer;
/* unused harmony export loadMeetingPdfSuccess */
/* harmony export (immutable) */ __webpack_exports__["j"] = loadMeetingPdfRequest;
/* harmony export (immutable) */ __webpack_exports__["s"] = setMeetingModalShow;
/* unused harmony export loadMeetingCategoriesSuccess */
/* harmony export (immutable) */ __webpack_exports__["h"] = loadMeetingCategoriesRequest;
/* harmony export (immutable) */ __webpack_exports__["k"] = loadMeetingRequest;
/* harmony export (immutable) */ __webpack_exports__["g"] = initMeetingModal;
/* harmony export (immutable) */ __webpack_exports__["x"] = updateMeetingFormValue;
/* harmony export (immutable) */ __webpack_exports__["z"] = updateMeetingItemValue;
/* unused harmony export addMeetingItem */
/* unused harmony export removeMeeting */
/* harmony export (immutable) */ __webpack_exports__["a"] = addNewMeetingItem;
/* harmony export (immutable) */ __webpack_exports__["b"] = attachMeetingItems;
/* harmony export (immutable) */ __webpack_exports__["u"] = setShowAttendeesModal;
/* harmony export (immutable) */ __webpack_exports__["t"] = setReviewMeeting;
/* unused harmony export createMeetingSuccess */
/* harmony export (immutable) */ __webpack_exports__["c"] = createMeeting;
/* unused harmony export updateMeetingSuccess */
/* harmony export (immutable) */ __webpack_exports__["w"] = updateMeeting;
/* harmony export (immutable) */ __webpack_exports__["r"] = setMeetingItemSettings;
/* harmony export (immutable) */ __webpack_exports__["p"] = setCurrentMeeting;
/* harmony export (immutable) */ __webpack_exports__["o"] = setConfirmationMsg;
/* harmony export (immutable) */ __webpack_exports__["m"] = openMeeting;
/* harmony export (immutable) */ __webpack_exports__["e"] = deleteMeetingRequest;
/* harmony export (immutable) */ __webpack_exports__["n"] = setConfirmApproval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_meeting_infos_api__ = __webpack_require__(2509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_meetings_api__ = __webpack_require__(2510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_meeting_categories_api__ = __webpack_require__(2511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__ = __webpack_require__(623);
function initMeetingMinutes(){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["p" /* MEETING_MINUTES_INIT */]};}function loadMeetingInfoSuccess(meetingInfo){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["k" /* MEETING_INFO_SET */],payload:meetingInfo};}function loadMeetingInfoRequest(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_meeting_infos_api__["a" /* meetingInfosApi */].getMeetingInfo(projectId).then(function(response){if(response.ok){dispatch(loadMeetingInfoSuccess(response.meetingInfo));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setMeetingInfoEdit(edit){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["j" /* MEETING_INFO_EDIT_SET */],payload:edit};}function createMeetingInfo(projectId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_meeting_infos_api__["a" /* meetingInfosApi */].createMeetingInfo(projectId,values).then(function(response){if(response.ok){dispatch(loadMeetingInfoSuccess(response.meetingInfo));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateMeetingInfo(projectId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_meeting_infos_api__["a" /* meetingInfosApi */].updateMeetingInfo(projectId,values).then(function(response){if(response.ok){dispatch(loadMeetingInfoSuccess(response.meetingInfo));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadMeetingsSuccess(meetings){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["f" /* MEETINGS_SET */],payload:meetings};}function loadMeetingsRequest(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_meetings_api__["a" /* meetingsApi */].getMeetings(projectId).then(function(response){if(response.ok){dispatch(loadMeetingsSuccess(response.meetings));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function togglePdfViewer(){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["v" /* TOGGLE_PDF_VIEWER_SUCCESS */]};}function loadMeetingPdfSuccess(pdf){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["s" /* MEETING_PDF_SET */],payload:pdf};}function loadMeetingPdfRequest(projectId,meetingId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_meetings_api__["a" /* meetingsApi */].getMeetingPdf(projectId,meetingId).then(function(response){if(response.ok){dispatch(loadMeetingPdfSuccess(response.pdf));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setMeetingModalShow(meetingModalShow){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["r" /* MEETING_MODAL_SHOW_SET */],payload:meetingModalShow};}function loadMeetingCategoriesSuccess(meetingCategories){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["h" /* MEETING_CATEGORIES_SET */],payload:meetingCategories};}function loadMeetingCategoriesRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_meeting_categories_api__["a" /* meetingCategoriesApi */].getMeetingCategories().then(function(response){if(response.ok){dispatch(loadMeetingCategoriesSuccess(response.meetingCategories));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadMeetingRequest(projectId,meetingId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_meetings_api__["a" /* meetingsApi */].getMeeting(projectId,meetingId).then(function(response){if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function initMeetingModal(){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["q" /* MEETING_MODAL_INIT */]};}function updateMeetingFormValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["i" /* MEETING_FORM_VALUE_UPDATE */],payload:{attribute:attribute,value:value}};}function updateMeetingItemValue(key,attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["o" /* MEETING_ITEM_VALUE_UPDATE */],payload:{key:key,attribute:attribute,value:value}};}function addMeetingItem(key,item){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["m" /* MEETING_ITEM_ADD */],payload:{key:key,item:item}};}function removeMeeting(projectId,meetingId){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["t" /* MEETING_REMOVE */],payload:{projectId:projectId,meetingId:meetingId}};}function addNewMeetingItem(items,code,meetingCat){var key=Object.keys(items).length+1;var item={code:code,meetingCategoryId:meetingCat.id,newItem:true,info:'',contributorIds:[],meetingCategory:{orderNumber:meetingCat.order_number}};return function(dispatch){dispatch(addMeetingItem(key,item));};}function attachMeetingItems(items){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["l" /* MEETING_ITEMS_ATTACH */],payload:items};}function setShowAttendeesModal(show){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["a" /* ATTENDEES_MODAL_SHOW_SET */],payload:show};}function setReviewMeeting(review){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["u" /* REVIEW_MEETING_SET */],payload:review};}function createMeetingSuccess(meeting){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["e" /* MEETINGS_ADD */],payload:meeting};}function createMeeting(projectId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_meetings_api__["a" /* meetingsApi */].createMeeting(projectId,values).then(function(response){if(response.ok){dispatch(createMeetingSuccess(response.meeting));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateMeetingSuccess(meeting){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["g" /* MEETINGS_UPDATE */],payload:meeting};}function updateMeeting(projectId,meetingId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_meetings_api__["a" /* meetingsApi */].updateMeeting(projectId,meetingId,values).then(function(response){if(response.ok){dispatch(updateMeetingSuccess(response.meeting));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setMeetingItemSettings(key,menu){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["n" /* MEETING_ITEM_SETTINGS_SET */],payload:{key:key,menu:menu}};}function setCurrentMeeting(meeting){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["d" /* CURRENT_MEETING_SET */],payload:meeting};}function setConfirmationMsg(confirmationMsg){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["b" /* CONFIRMATION_MSG_SET */],payload:confirmationMsg};}function openMeeting(projectId,meetingId){return function(dispatch){dispatch(loadMeetingRequest(projectId,meetingId)).then(function(response){if(response.ok){dispatch(setCurrentMeeting(response.meeting));dispatch(setMeetingModalShow(true));}});};}function deleteMeetingRequest(projectId,meetingId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_meetings_api__["a" /* meetingsApi */].deleteMeeting(projectId,meetingId).then(function(response){if(response.ok){dispatch(removeMeeting(projectId,meetingId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setConfirmApproval(confirmApproval){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_meeting_minutes_store_action_types__["c" /* CONFIRM_APPROVAL_SET */],payload:confirmApproval};}

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1027);
var react_1 = tslib_1.__importDefault(__webpack_require__(0));
var react_lifecycles_compat_1 = __webpack_require__(173);
var TransitionGroup_1 = tslib_1.__importDefault(__webpack_require__(2551));
var SlideDownContent = (function (_super) {
    tslib_1.__extends(SlideDownContent, _super);
    function SlideDownContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRef = function (element) {
            _this.element = element;
            _this.callbacks = [];
        };
        _this.handleTransitionEnd = function (evt) {
            if ((evt.target === _this.element) && (evt.propertyName === 'height')) {
                var callback = _this.callbacks.shift();
                callback && callback();
                if (_this.callbacks.length === 0) {
                    _this.element.classList.remove('transitioning');
                    _this.element.style.transitionProperty = 'none';
                    _this.element.style.height = _this.props.closed ? '0px' : 'auto';
                    if (_this.props.closed)
                        _this.element.classList.add('closed');
                }
            }
        };
        return _this;
    }
    SlideDownContent.prototype.componentDidMount = function () {
        if (this.props.closed)
            this.element.classList.add('closed');
    };
    SlideDownContent.prototype.componentWillAppear = function (callback) {
        if (this.props.transitionOnAppear) {
            this.callbacks.push(callback);
            this.startTransition('0px');
        }
        else {
            this.element.style.height = this.props.closed ? '0px' : 'auto';
            callback();
        }
    };
    SlideDownContent.prototype.componentWillEnter = function (callback) {
        this.callbacks.push(callback);
        var prevHeight = this.element.getBoundingClientRect().height + 'px';
        this.startTransition(prevHeight);
    };
    SlideDownContent.prototype.componentWillLeave = function (callback) {
        this.callbacks.push(callback);
        this.element.classList.add('transitioning');
        this.element.style.height = getComputedStyle(this.element).height;
        this.element.offsetHeight;
        this.element.style.transitionProperty = 'height';
        this.element.style.height = '0px';
    };
    SlideDownContent.prototype.getSnapshotBeforeUpdate = function () {
        if (this.callbacks.length === 0) {
            return this.element.getBoundingClientRect().height + 'px';
        }
        else {
            return null;
        }
    };
    SlideDownContent.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var callback = this.callbacks.shift();
        callback && callback();
        if (this.callbacks.length === 0) {
            var prevHeight = snapshot || getComputedStyle(this.element).height;
            this.startTransition(prevHeight);
        }
    };
    SlideDownContent.prototype.startTransition = function (prevHeight) {
        var endHeight = '0px';
        if (!this.props.closed) {
            this.element.classList.remove('closed');
            this.element.style.height = 'auto';
            endHeight = getComputedStyle(this.element).height;
        }
        if (parseFloat(endHeight).toFixed(2) !== parseFloat(prevHeight).toFixed(2)) {
            this.element.classList.add('transitioning');
            this.element.style.height = prevHeight;
            this.element.offsetHeight;
            this.element.style.transitionProperty = 'height';
            this.element.style.height = endHeight;
        }
    };
    SlideDownContent.prototype.render = function () {
        var className = this.props.className ?
            'react-slidedown ' + this.props.className : 'react-slidedown';
        return (react_1.default.createElement("div", { className: className, ref: this.handleRef, onTransitionEnd: this.handleTransitionEnd }, this.props.children));
    };
    SlideDownContent.defaultProps = {
        transitionOnAppear: true,
        closed: false
    };
    return SlideDownContent;
}(react_1.default.Component));
function SlideDownWrapper(props) {
    var childrenArray = react_1.default.Children.toArray(props.children);
    return childrenArray[0] || null;
}
var SlideDownContentCompat = react_lifecycles_compat_1.polyfill(SlideDownContent);
function SlideDown(props) {
    var children = props.children, attrs = tslib_1.__rest(props, ["children"]);
    var hasContent = (children && react_1.default.Children.count(children) !== 0);
    return (react_1.default.createElement(TransitionGroup_1.default, { component: SlideDownWrapper }, hasContent && react_1.default.createElement(SlideDownContentCompat, tslib_1.__assign({ key: 'content' }, attrs), children)));
}
exports.SlideDown = SlideDown;
//# sourceMappingURL=slidedown.js.map

/***/ }),
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(74);

function populateMethod(req) {
  req.httpRequest.method = req.service.api.operations[req.operation].httpMethod;
}

function generateURI(endpointPath, operationPath, input, params) {
  var uri = [endpointPath, operationPath].join('/');
  uri = uri.replace(/\/+/g, '/');

  var queryString = {}, queryStringSet = false;
  util.each(input.members, function (name, member) {
    var paramValue = params[name];
    if (paramValue === null || paramValue === undefined) return;
    if (member.location === 'uri') {
      var regex = new RegExp('\\{' + member.name + '(\\+)?\\}');
      uri = uri.replace(regex, function(_, plus) {
        var fn = plus ? util.uriEscapePath : util.uriEscape;
        return fn(String(paramValue));
      });
    } else if (member.location === 'querystring') {
      queryStringSet = true;

      if (member.type === 'list') {
        queryString[member.name] = paramValue.map(function(val) {
          return util.uriEscape(String(val));
        });
      } else if (member.type === 'map') {
        util.each(paramValue, function(key, value) {
          if (Array.isArray(value)) {
            queryString[key] = value.map(function(val) {
              return util.uriEscape(String(val));
            });
          } else {
            queryString[key] = util.uriEscape(String(value));
          }
        });
      } else {
        queryString[member.name] = util.uriEscape(String(paramValue));
      }
    }
  });

  if (queryStringSet) {
    uri += (uri.indexOf('?') >= 0 ? '&' : '?');
    var parts = [];
    util.arrayEach(Object.keys(queryString).sort(), function(key) {
      if (!Array.isArray(queryString[key])) {
        queryString[key] = [queryString[key]];
      }
      for (var i = 0; i < queryString[key].length; i++) {
        parts.push(util.uriEscape(String(key)) + '=' + queryString[key][i]);
      }
    });
    uri += parts.join('&');
  }

  return uri;
}

function populateURI(req) {
  var operation = req.service.api.operations[req.operation];
  var input = operation.input;

  var uri = generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);
  req.httpRequest.path = uri;
}

function populateHeaders(req) {
  var operation = req.service.api.operations[req.operation];
  util.each(operation.input.members, function (name, member) {
    var value = req.params[name];
    if (value === null || value === undefined) return;

    if (member.location === 'headers' && member.type === 'map') {
      util.each(value, function(key, memberValue) {
        req.httpRequest.headers[member.name + key] = memberValue;
      });
    } else if (member.location === 'header') {
      value = member.toWireFormat(value).toString();
      if (member.isJsonValue) {
        value = util.base64.encode(value);
      }
      req.httpRequest.headers[member.name] = value;
    }
  });
}

function buildRequest(req) {
  populateMethod(req);
  populateURI(req);
  populateHeaders(req);
}

function extractError() {
}

function extractData(resp) {
  var req = resp.request;
  var data = {};
  var r = resp.httpResponse;
  var operation = req.service.api.operations[req.operation];
  var output = operation.output;

  // normalize headers names to lower-cased keys for matching
  var headers = {};
  util.each(r.headers, function (k, v) {
    headers[k.toLowerCase()] = v;
  });

  util.each(output.members, function(name, member) {
    var header = (member.name || name).toLowerCase();
    if (member.location === 'headers' && member.type === 'map') {
      data[name] = {};
      var location = member.isLocationName ? member.name : '';
      var pattern = new RegExp('^' + location + '(.+)', 'i');
      util.each(r.headers, function (k, v) {
        var result = k.match(pattern);
        if (result !== null) {
          data[name][result[1]] = v;
        }
      });
    } else if (member.location === 'header') {
      if (headers[header] !== undefined) {
        var value = member.isJsonValue ?
          util.base64.decode(headers[header]) :
          headers[header];
        data[name] = member.toType(value);
      }
    } else if (member.location === 'statusCode') {
      data[name] = parseInt(r.statusCode, 10);
    }
  });

  resp.data = data;
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData,
  generateURI: generateURI
};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(339).Buffer;

/**
 * This is a polyfill for the static method `isView` of `ArrayBuffer`, which is
 * e.g. missing in IE 10.
 *
 * @api private
 */
if (
    typeof ArrayBuffer !== 'undefined' &&
    typeof ArrayBuffer.isView === 'undefined'
) {
    ArrayBuffer.isView = function(arg) {
        return viewStrings.indexOf(Object.prototype.toString.call(arg)) > -1;
    };
}

/**
 * @api private
 */
var viewStrings = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]',
    '[object DataView]',
];

/**
 * @api private
 */
function isEmptyData(data) {
    if (typeof data === 'string') {
        return data.length === 0;
    }
    return data.byteLength === 0;
}

/**
 * @api private
 */
function convertToBuffer(data) {
    if (typeof data === 'string') {
        data = new Buffer(data, 'utf8');
    }

    if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    }

    return new Uint8Array(data);
}

module.exports = exports = {
    isEmptyData: isEmptyData,
    convertToBuffer: convertToBuffer,
}


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_slidedown__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_slidedown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_slidedown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_slidedown_lib_slidedown_css__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_slidedown_lib_slidedown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_slidedown_lib_slidedown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_open_items_store_selectors__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_email_modal_store_selectors__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_actions__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_open_items_ProjectOpenItemDetails__ = __webpack_require__(2983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_open_items_ProjectOpenItemForm__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_shared_pdf_viewer_PdfViewer__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_email_modal_ProjectEmailModal__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_store_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectOpenItemDetailsModal=function(_Component){_inherits(ProjectOpenItemDetailsModal,_Component);function ProjectOpenItemDetailsModal(props){_classCallCheck(this,ProjectOpenItemDetailsModal);var _this=_possibleConstructorReturn(this,(ProjectOpenItemDetailsModal.__proto__||Object.getPrototypeOf(ProjectOpenItemDetailsModal)).call(this,props));_this.buildEmailModalTitle=function(){var _this$props=_this.props,currentProject=_this$props.currentProject,openItem=_this$props.openItem;return'Open Item '+Object(__WEBPACK_IMPORTED_MODULE_17_services_utils_text_util__["b" /* formatNumber */])(openItem.number)+' (Project #'+currentProject.number+': '+currentProject.name+')';};_this.buildEmailModalSubject=function(){var _this$props2=_this.props,currentProject=_this$props2.currentProject,openItem=_this$props2.openItem;return currentProject.number+', '+currentProject.name+' - Open Item '+Object(__WEBPACK_IMPORTED_MODULE_17_services_utils_text_util__["b" /* formatNumber */])(openItem.number)+' - '+openItem.description;};_this.buildEmailModalMessage=function(){var _this$props3=_this.props,currentProject=_this$props3.currentProject,openItem=_this$props3.openItem;var location='';if(currentProject.building&&currentProject.building.location){var buildingLocation=currentProject.building.location;location=' at '+buildingLocation.street_address_1+', '+buildingLocation.city+' '+buildingLocation.state;}return'Please find the attached Open Item #'+openItem.number+' for Project '+currentProject.name+location+'. If you have any questions, please reach out via chat or email.';};_this.handleSendEmail=function(emailsData){var _this$props4=_this.props,dispatch=_this$props4.dispatch,openItem=_this$props4.openItem;dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_store_actions__["d" /* sendProjectResourceEmails */])(openItem.id,'ProjectOpenItem',emailsData));};_this.handleOpenItemDetailsModalClose=function(){var _this$props5=_this.props,onClose=_this$props5.onClose,dispatch=_this$props5.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_actions__["e" /* closeOpenItemDetailsModal */])());onClose&&onClose();};_this.handleEdit=function(){var _this$props6=_this.props,openItem=_this$props6.openItem,dispatch=_this$props6.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_actions__["u" /* setOpenItemForm */])(Object.assign({},openItem,{projectContributorId:openItem.project_contributor_id||'',assigneeId:openItem.assignee_id,resolveBy:openItem.resolve_by,recipients:openItem.recipients.map(function(rcpt){return[rcpt.id];}),documents:openItem.documents.map(function(doc){return Object.assign({},doc,{url:doc.document.url});}),images:openItem.images.map(function(image){return Object.assign({},image,{url:image.image.gallery.url});})})));dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_actions__["k" /* editOpenItemDetailsModal */])());};_this.handleEditCancel=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_actions__["a" /* cancelEditOpenItemDetailsModal */])());};_this.handleUpdate=function(values){var _this$props7=_this.props,currentProject=_this$props7.currentProject,openItem=_this$props7.openItem,dispatch=_this$props7.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_actions__["B" /* updateProjectOpenItem */])(currentProject.id,openItem.id,values));};_this.handleDeleteConfirmed=function(){var _this$props8=_this.props,currentProject=_this$props8.currentProject,openItem=_this$props8.openItem,dispatch=_this$props8.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_actions__["j" /* deleteProjectOpenItem */])(currentProject.id,openItem.id));};_this.handleDeleteConfirmation=function(confirmed){_this.setState({showDeleteConfirmation:false});confirmed&&_this.handleDeleteConfirmed();};_this.handleDelete=function(){_this.setState({showDeleteConfirmation:true});};_this.handleRfiPdfViewerClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_actions__["x" /* setOpenItemPdfViewer */])(false));};_this.modalTitle=function(){var _this$props9=_this.props,openItem=_this$props9.openItem,critical=_this$props9.critical;var csiCode=openItem&&openItem.csi_code;if(!csiCode){csiCode={};csiCode['division']='00';csiCode['label']='General Contractor';}var title=openItem?'Open Item '+openItem.number:'Open Item';title=critical?'Critical '+title:title;title+=csiCode?' - '+csiCode.division+' '+csiCode.label:'';return title;};_this.state={showDeleteConfirmation:false};return _this;}_createClass(ProjectOpenItemDetailsModal,[{key:'render',value:function render(){var _props=this.props,currentProject=_props.currentProject,openItem=_props.openItem,showOpenItemDetailsModal=_props.showOpenItemDetailsModal,editOpenItemDetailsModal=_props.editOpenItemDetailsModal,openItemPdfViewer=_props.openItemPdfViewer,showEmailModal=_props.showEmailModal;var showDeleteConfirmation=this.state.showDeleteConfirmation;return currentProject&&showOpenItemDetailsModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_modal_FormModal__["a" /* default */],{className:'project-open-item-form-modal',show:showOpenItemDetailsModal,onClose:this.handleOpenItemDetailsModalClose,subTitle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['Projects',currentProject.name]}),title:this.modalTitle()},editOpenItemDetailsModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_slidedown__["SlideDown"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_open_items_ProjectOpenItemForm__["a" /* default */],{onSave:this.handleUpdate,onCancel:this.handleEditCancel})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_open_items_ProjectOpenItemDetails__["a" /* default */],{onDelete:this.handleDelete,onEdit:this.handleEdit}),showDeleteConfirmation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_modal_ConfirmationModal__["a" /* default */],{show:showDeleteConfirmation,message:'Are you sure you want to delete this Open Item?',onHide:this.handleDeleteConfirmation}),openItemPdfViewer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:openItem.pdf_document.document.url+'?time='+__WEBPACK_IMPORTED_MODULE_18_moment___default()().unix(),type:'url'},show:openItemPdfViewer,onClose:this.handleRfiPdfViewerClose}),showEmailModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_email_modal_ProjectEmailModal__["a" /* default */],{title:this.buildEmailModalTitle(),handleSendEmail:this.handleSendEmail,projectId:currentProject.id,initialSubject:this.buildEmailModalSubject(),initialMessage:this.buildEmailModalMessage(),showHistoryButton:true,itemType:'ProjectOpenItem',itemId:openItem.id}));}}]);return ProjectOpenItemDetailsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProjectOpenItemDetailsModal.propTypes={onClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};ProjectOpenItemDetailsModal.defaultProps={onClose:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),openItem:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_open_items_store_selectors__["c" /* getCurrentProjectOpenItem */])(state),showOpenItemDetailsModal:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_open_items_store_selectors__["o" /* getShowOpenItemDetailsModal */])(state),editOpenItemDetailsModal:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_open_items_store_selectors__["e" /* getEditOpenItemDetailsModal */])(state),critical:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_open_items_store_selectors__["a" /* getCritical */])(state),openItemPdfViewer:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_open_items_store_selectors__["h" /* getOpenItemPdfViewer */])(state),showEmailModal:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_email_modal_store_selectors__["g" /* getShowEmailModal */])(state)};})(ProjectOpenItemDetailsModal));

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export changePage */
/* harmony export (immutable) */ __webpack_exports__["d"] = clearSelection;
/* harmony export (immutable) */ __webpack_exports__["e"] = exportReport;
/* harmony export (immutable) */ __webpack_exports__["f"] = loadReportRequest;
/* unused harmony export loadReportSuccess */
/* harmony export (immutable) */ __webpack_exports__["c"] = changeStartDate;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeEndDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = changeExtraFilterValue;
/* unused harmony export changeSearching */
/* harmony export (immutable) */ __webpack_exports__["g"] = resetReports;
/* harmony export (immutable) */ __webpack_exports__["h"] = selectAllWorkOrders;
/* harmony export (immutable) */ __webpack_exports__["i"] = selectWorkOrder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_reports_api__ = __webpack_require__(3219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_admin_reports_reports__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_action_types__ = __webpack_require__(653);
function changePage(newPage){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_action_types__["d" /* REPORT_PAGE_CHANGE */],payload:newPage};}function clearSelection(){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_action_types__["h" /* REPORT_WORK_ORDER_SELECT_CLEAR */]};}function exportReport(report,ids,startDate,endDate,extraFilterValues){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_reports_api__["a" /* reportsApi */].exportReport(report,ids,startDate,endDate,extraFilterValues).then(function(response){if(response.ok){return Object.assign({},response.content,{fileName:report+'.xlsx'});}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));return null;}});};}function loadReportRequest(report,page,startDate,endDate,extraFilterValues){return function(dispatch){dispatch(changeSearching(true));return __WEBPACK_IMPORTED_MODULE_1_services_api_reports_api__["a" /* reportsApi */].getReport(report,page,startDate,endDate,extraFilterValues).then(function(response){if(response.ok){dispatch(loadReportSuccess(response.results));dispatch(changePage(page));dispatch(selectWorkOrder());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}dispatch(changeSearching(false));return response;});};}function loadReportSuccess(results){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_action_types__["e" /* REPORT_RESULTS_LOAD_SUCCESS */],payload:results};}function changeStartDate(value){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_action_types__["g" /* REPORT_START_DATE_CHANGE */],payload:value};}function changeEndDate(value){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_action_types__["b" /* REPORT_END_DATE_CHANGE */],payload:value};}function changeExtraFilterValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_action_types__["c" /* REPORT_EXTRA_FILTER_VALUE_CHANGE */],payload:{attribute:attribute,value:value}};}function changeSearching(value){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_action_types__["f" /* REPORT_SEARCHING_CHANGE */],payload:value};}function resetReports(){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_action_types__["a" /* REPORTS_RESET */]};}function selectAllWorkOrders(){return function(dispatch,getState){var currentPage=Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_reports_reports__["a" /* getCurrentPage */])(getState());var selectAllChecked=Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_reports_reports__["g" /* getSelectAllChecked */])(getState());var currentPageSelection={};if(selectAllChecked){currentPageSelection[currentPage]={};dispatch(setWorkOrderSelection(currentPageSelection,false));}else{var workOrderIds={};var reportResults=Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_reports_reports__["d" /* getReportResults */])(getState());if(reportResults!==null&&reportResults.data.length>0){workOrderIds=extractWorkOrderIds(reportResults.data);}currentPageSelection[currentPage]=workOrderIds;dispatch(setWorkOrderSelection(currentPageSelection,true));}};}function selectWorkOrder(workOrderId){return function(dispatch,getState){var currentPage=Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_reports_reports__["a" /* getCurrentPage */])(getState());var selectedWorkOrders=Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_reports_reports__["h" /* getSelectedWorkOrders */])(getState());var newSelectedWorkOrders=Object.assign({},selectedWorkOrders[currentPage]);var currentPageSelection={};if(selectedWorkOrders[currentPage]!==undefined&&selectedWorkOrders[currentPage][workOrderId]!==undefined){delete newSelectedWorkOrders[workOrderId];}else if(workOrderId!==undefined){newSelectedWorkOrders[workOrderId]=workOrderId;}var reportResults=Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_reports_reports__["d" /* getReportResults */])(getState());var allChecked=false;if(reportResults!==null&&reportResults.data.length>0){var workOrderIds=extractWorkOrderIds(reportResults.data);allChecked=Object.keys(workOrderIds).length===Object.keys(newSelectedWorkOrders).length;}currentPageSelection[currentPage]=newSelectedWorkOrders;dispatch(setWorkOrderSelection(currentPageSelection,allChecked));};}function extractWorkOrderIds(reportResults){return reportResults// For some reports, each item contains a work_order, for other just the work order id
.map(function(result){return result.work_order?result.work_order.id:result.project_id?result.project_id:result.id;}).reduce(function(accumulator,workOrderId){if(accumulator[workOrderId]===undefined){accumulator[workOrderId]=workOrderId;}return accumulator;},{});}function setWorkOrderSelection(selectedWorkOrders,allChecked){return{type:__WEBPACK_IMPORTED_MODULE_3_actions_admin_reports_action_types__["i" /* REPORT_WORK_ORDER_SELECT_SET */],payload:{selectedWorkOrders:selectedWorkOrders,allChecked:allChecked}};}

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(238);
var test = {};
test[__webpack_require__(54)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(109)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48);
var document = __webpack_require__(41).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(342)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(448)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(192);
var $export = __webpack_require__(4);
var redefine = __webpack_require__(109);
var hide = __webpack_require__(110);
var Iterators = __webpack_require__(239);
var $iterCreate = __webpack_require__(449);
var setToStringTag = __webpack_require__(240);
var getPrototypeOf = __webpack_require__(119);
var ITERATOR = __webpack_require__(54)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(211);
var descriptor = __webpack_require__(210);
var setToStringTag = __webpack_require__(240);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(110)(IteratorPrototype, __webpack_require__(54)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(289)('keys');
var uid = __webpack_require__(209);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 451 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(41).document;
module.exports = document && document.documentElement;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(454);
var getKeys = __webpack_require__(212);
var redefine = __webpack_require__(109);
var global = __webpack_require__(41);
var hide = __webpack_require__(110);
var Iterators = __webpack_require__(239);
var wks = __webpack_require__(54);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(193);
var step = __webpack_require__(658);
var Iterators = __webpack_require__(239);
var toIObject = __webpack_require__(118);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(448)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(659);
var validate = __webpack_require__(218);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(344)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(239);
var ITERATOR = __webpack_require__(54)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(238);
var ITERATOR = __webpack_require__(54)('iterator');
var Iterators = __webpack_require__(239);
module.exports = __webpack_require__(108).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48);
var setPrototypeOf = __webpack_require__(459).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(48);
var anObject = __webpack_require__(32);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(137)(Function.call, __webpack_require__(120).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(659);
var validate = __webpack_require__(218);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(344)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(462);
var GetIntrinsic = __webpack_require__(463);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(1124);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(1125)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(462);
var hasOwn = __webpack_require__(464);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(462);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(347);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(348);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(1152);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(245);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 471 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 472 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(474)('keys');
var uid = __webpack_require__(351);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(77);
var global = __webpack_require__(171);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(350) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 475 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 476 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(244);
var dPs = __webpack_require__(1158);
var enumBugKeys = __webpack_require__(475);
var IE_PROTO = __webpack_require__(473)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(685)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1159).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);



var propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
var defaultProps = {
  label: 'Close'
};

var CloseButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(CloseButton, _React$Component);

  function CloseButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CloseButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        onClick = _this$props.onClick;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button", {
      type: "button",
      className: "close",
      onClick: onClick
    }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7"), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      className: "sr-only"
    }, label));
  };

  return CloseButton;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CloseButton);

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_all__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(16);









var propTypes = {
  vertical: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  justified: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Display block buttons; only useful when used with the "vertical" prop.
   * @type {bool}
   */
  block: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, function (_ref) {
    var block = _ref.block,
        vertical = _ref.vertical;
    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
  })
};
var defaultProps = {
  block: false,
  justified: false,
  vertical: false
};

var ButtonGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ButtonGroup, _React$Component);

  function ButtonGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ButtonGroup.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        block = _this$props.block,
        justified = _this$props.justified,
        vertical = _this$props.vertical,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["block", "justified", "vertical", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps)] = !vertical, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'vertical')] = vertical, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'justified')] = justified, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */].defaultProps, 'block')] = block, _extends2));

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('btn-group', ButtonGroup));

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(196));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);







var propTypes = {
  /**
   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
   */
  glyph: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired
};

var Glyphicon =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Glyphicon, _React$Component);

  function Glyphicon() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Glyphicon.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        glyph = _this$props.glyph,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["glyph", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, glyph)] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Glyphicon;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Glyphicon.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('glyphicon', Glyphicon));

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_parse_int__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_style__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(75);





var _collapseStyles;








var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
}; // reading a dimension prop will cause the browser to recalculate,
// which will let our animations work

function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

function getDimensionValue(dimension, elem) {
  var value = elem["offset" + Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(dimension)];
  var margins = MARGINS[dimension];
  return value + __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_parse_int___default()(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_style___default()(elem, margins[0]), 10) + __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_parse_int___default()(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_style___default()(elem, margins[1]), 10);
}

var collapseStyles = (_collapseStyles = {}, _collapseStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["EXITED"]] = 'collapse', _collapseStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["EXITING"]] = 'collapsing', _collapseStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["ENTERING"]] = 'collapsing', _collapseStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["ENTERED"]] = 'collapse in', _collapseStyles);
var propTypes = {
  /**
   * Show the component; triggers the expand or collapse animation
   */
  in: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is collapsed
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Run the expand animation when the component mounts, if it is initially
   * shown
   */
  appear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Duration of the collapse animation in milliseconds, to ensure that
   * finishing callbacks are fired even if the original browser transition end
   * events are canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  /**
   * Callback fired before the component expands
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to expand
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the component has expanded
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired before the component collapses
   */
  onExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the component has collapsed
   */
  onExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * The dimension used when collapsing, or a function that returns the
   * dimension
   *
   * _Note: Bootstrap only partially supports 'width'!
   * You will need to supply your own CSS animation for the `.width` CSS class._
   */
  dimension: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['height', 'width']), __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),

  /**
   * Function that returns the height or width of the animating DOM node
   *
   * Allows for providing some custom logic for how much the Collapse component
   * should animate in its specified dimension. Called with the current
   * dimension prop value and the DOM node.
   */
  getDimensionValue: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * ARIA role of collapsible element
   */
  role: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  dimension: 'height',
  getDimensionValue: getDimensionValue
};

var Collapse =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Collapse, _React$Component);

  function Collapse() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleEnter = function (elem) {
      elem.style[_this.getDimension()] = '0';
    };

    _this.handleEntering = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this._getScrollDimensionValue(elem, dimension);
    };

    _this.handleEntered = function (elem) {
      elem.style[_this.getDimension()] = null;
    };

    _this.handleExit = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this.props.getDimensionValue(dimension, elem) + "px";
      triggerBrowserReflow(elem);
    };

    _this.handleExiting = function (elem) {
      elem.style[_this.getDimension()] = '0';
    };

    return _this;
  }

  var _proto = Collapse.prototype;

  _proto.getDimension = function getDimension() {
    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
  }; // for testing


  _proto._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
    return elem["scroll" + Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(dimension)] + "px";
  };
  /* -- Expanding -- */


  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        onEnter = _this$props.onEnter,
        onEntering = _this$props.onEntering,
        onEntered = _this$props.onEntered,
        onExit = _this$props.onExit,
        onExiting = _this$props.onExiting,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "className", "children"]);

    delete props.dimension;
    delete props.getDimensionValue;
    var handleEnter = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter);
    var handleEntering = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleEntering, onEntering);
    var handleEntered = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleEntered, onEntered);
    var handleExit = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleExit, onExit);
    var handleExiting = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleExiting, onExiting);
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition___default.a, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      "aria-expanded": props.role ? props.in : null,
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: handleEntered,
      onExit: handleExit,
      onExiting: handleExiting
    }), function (state, innerProps) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, innerProps, {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, children.props.className, collapseStyles[state], _this2.getDimension() === 'width' && 'width')
      }));
    });
  };

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Collapse);

/***/ }),
/* 483 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(195).f;
var has = __webpack_require__(220);
var TAG = __webpack_require__(151)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(196));

var on = function on() {};

if (_inDOM.default) {
  on = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

var _default = on;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(196));

var off = function off() {};

if (_inDOM.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

var _default = off;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(1269);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uncontrollable__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uncontrollable__);





var TAB = 'tab';
var PANE = 'pane';
var idPropType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]);
var propTypes = {
  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: function id(props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = idPropType.apply(void 0, [props].concat(args));

      if (!error && !props.id) {
        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
      }
    }

    return error;
  },

  /**
   * A function that takes an `eventKey` and `type` and returns a unique id for
   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
   * function, meaning it should always return the _same_ id for the same set
   * of inputs. The default value requires that an `id` to be set for the
   * `<TabContainer>`.
   *
   * The `type` argument will either be `"tab"` or `"pane"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * A callback fired when a tab is selected.
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * The `eventKey` of the currently active tab.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
};
var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
  })
};

var TabContainer =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(TabContainer, _React$Component);

  function TabContainer() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = TabContainer.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        activeKey = _this$props.activeKey,
        onSelect = _this$props.onSelect,
        generateChildId = _this$props.generateChildId,
        id = _this$props.id;

    var getId = generateChildId || function (key, type) {
      return id ? id + "-" + type + "-" + key : null;
    };

    return {
      $bs_tabContainer: {
        activeKey: activeKey,
        onSelect: onSelect,
        getTabId: function getTabId(key) {
          return getId(key, TAB);
        },
        getPaneId: function getPaneId(key) {
          return getId(key, PANE);
        }
      }
    };
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["children"]);

    delete props.generateChildId;
    delete props.onSelect;
    delete props.activeKey;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children), props);
  };

  return TabContainer;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

TabContainer.propTypes = propTypes;
TabContainer.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_uncontrollable___default()(TabContainer, {
  activeKey: 'onSelect'
}));

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(16);









var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a,

  /**
   * Sets a default animation strategy for all children `<TabPane>`s. Use
   * `false` to disable, `true` to enable the default `<Fade>` animation or
   * a react-transition-group v2 `<Transition/>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when they are no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
var defaultProps = {
  componentClass: 'div',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};
var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
  })
};
var childContextTypes = {
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired
  })
};

var TabContent =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(TabContent, _React$Component);

  function TabContent(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handlePaneEnter = _this.handlePaneEnter.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handlePaneExited = _this.handlePaneExited.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this))); // Active entries in state will be `null` unless `animation` is set. Need
    // to track active child in case keys swap and the active child changes
    // but the active key does not.

    _this.state = {
      activeKey: null,
      activeChild: null
    };
    return _this;
  }

  var _proto = TabContent.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        bsClass = _this$props.bsClass,
        animation = _this$props.animation,
        mountOnEnter = _this$props.mountOnEnter,
        unmountOnExit = _this$props.unmountOnExit;
    var stateActiveKey = this.state.activeKey;
    var containerActiveKey = this.getContainerActiveKey();
    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
    return {
      $bs_tabContent: {
        bsClass: bsClass,
        animation: animation,
        activeKey: activeKey,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        onPaneEnter: this.handlePaneEnter,
        onPaneExited: this.handlePaneExited,
        exiting: exiting
      }
    };
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!nextProps.animation && this.state.activeChild) {
      this.setState({
        activeKey: null,
        activeChild: null
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  _proto.getContainerActiveKey = function getContainerActiveKey() {
    var tabContainer = this.context.$bs_tabContainer;
    return tabContainer && tabContainer.activeKey;
  };

  _proto.handlePaneEnter = function handlePaneEnter(child, childKey) {
    if (!this.props.animation) {
      return false;
    } // It's possible that this child should be transitioning out.


    if (childKey !== this.getContainerActiveKey()) {
      return false;
    }

    this.setState({
      activeKey: childKey,
      activeChild: child
    });
    return true;
  };

  _proto.handlePaneExited = function handlePaneExited(child) {
    // This might happen as everything is unmounting.
    if (this.isUnmounted) {
      return;
    }

    this.setState(function (_ref) {
      var activeChild = _ref.activeChild;

      if (activeChild !== child) {
        return null;
      }

      return {
        activeKey: null,
        activeChild: null
      };
    });
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        Component = _this$props2.componentClass,
        className = _this$props2.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["componentClass", "className"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content'))
    }));
  };

  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TabContent.propTypes = propTypes;
TabContent.defaultProps = defaultProps;
TabContent.contextTypes = contextTypes;
TabContent.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('tab', TabContent));

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(1294);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(223);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(1302);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(97), __webpack_require__(300)(module)))

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(121);
var normalizeHeaderName = __webpack_require__(1317);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(750);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(750);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(254)))

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InvitationPropTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserInvitations_css__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserInvitations_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UserInvitations_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_plus_icon_png__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_plus_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_plus_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AddInvitation__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ShowInvitation__ = __webpack_require__(761);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InvitationPropTypes={firstName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,lastName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,permissions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool})),title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var UserInvitations=function(_Component){_inherits(UserInvitations,_Component);function UserInvitations(){_classCallCheck(this,UserInvitations);var _this=_possibleConstructorReturn(this,(UserInvitations.__proto__||Object.getPrototypeOf(UserInvitations)).call(this));_this.handleInvitationRemove=function(id){_this.props.onRemove(id);};_this.handleAddUser=function(){if(_this.state.addEnable){_this.props.onAdd({firstName:_this.props.currentInvitation.firstName,lastName:_this.props.currentInvitation.lastName,email:_this.props.currentInvitation.email,permissions:_this.props.currentInvitation.permissions,title:_this.props.currentInvitation.title});_this.setState({addEnable:false});}};_this.handleAddInvitationChange=function(newState){var addEnable=newState.firstName!==''&&newState.lastName!==''&&newState.email!==''&&newState.permissions.filter(function(element){return element.selected;}).length>0;_this.setState({addEnable:addEnable});_this.props.onCurrentInvitationChange(newState);};_this.handleSentInvitations=function(){if(_this.props.invitations.length>0){_this.props.onSent();}};_this.state={addEnable:false};return _this;}_createClass(UserInvitations,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-invitations client'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["k" /* Grid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:6,lgOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Invite Users')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:6,lgOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subtitle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Users will be emailed an invite to finish creating their account.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:10,lgOffset:1},this.props.invitations.map(function(invitation){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ShowInvitation__["a" /* default */],{user:invitation,onDelete:_this2.handleInvitationRemove,key:invitation.id});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:10,lgOffset:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AddInvitation__["a" /* default */],{invitation:this.props.currentInvitation,onChange:this.handleAddInvitationChange}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:6,lgOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'add-user',className:'btn btn-select btn-gray'+(this.state.addEnable?'':' disabled'),onClick:this.handleAddUser},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__images_plus_icon_png___default.a,alt:'plus'}),' Add aditional user')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:6,lgOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'invite-users',className:'btn btn-select btn-orange'+(this.props.invitations.length===0?' disabled':''),onClick:this.handleSentInvitations},'Invite Users')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:6,lgOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:'/'},'I\'ll do it later')))))));}}]);return UserInvitations;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UserInvitations.propTypes={invitations:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(InvitationPropTypes)),currentInvitation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(InvitationPropTypes),onAdd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCurrentInvitationChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["b"] = (UserInvitations);

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = selectRoute;
/* unused harmony export routeChange */
/* harmony export (immutable) */ __webpack_exports__["b"] = setHideSideBar;
/* harmony export (immutable) */ __webpack_exports__["c"] = toggleNewServiceWorkModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(45);
function selectRoute(id,route){return function(dispatch){dispatch(routeChange(id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["d" /* push */])(route));};}function routeChange(id){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["b" /* SIDEBAR_SELECT_ROUTE */],payload:id};}function setHideSideBar(value){return{payload:value,type:__WEBPACK_IMPORTED_MODULE_0__action_types__["a" /* HIDE_SIDE_BAR_CHANGE */]};}function toggleNewServiceWorkModal(){return{payload:'',type:__WEBPACK_IMPORTED_MODULE_0__action_types__["c" /* TOGGLE_NEW_SERVICE_WORK */]};}

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = initializeComponentAppState;
/* harmony export (immutable) */ __webpack_exports__["k"] = selectSubContractor;
/* harmony export (immutable) */ __webpack_exports__["a"] = addSubContractor;
/* harmony export (immutable) */ __webpack_exports__["c"] = cancelAddSubContractor;
/* unused harmony export newSubContractorValid */
/* unused harmony export newSubContractorInvalid */
/* harmony export (immutable) */ __webpack_exports__["f"] = formValueChange;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSubContractorRequest;
/* unused harmony export createSubContractorSuccess */
/* harmony export (immutable) */ __webpack_exports__["j"] = removeSubContractor;
/* harmony export (immutable) */ __webpack_exports__["d"] = confirmSubContractorsUnionTradesRequest;
/* harmony export (immutable) */ __webpack_exports__["b"] = answerQuestion;
/* unused harmony export subContractorConfirmationInvalid */
/* unused harmony export subContractorConfirmationValid */
/* unused harmony export unionTradesConfirmationInvalid */
/* unused harmony export unionTradesConfirmationValid */
/* harmony export (immutable) */ __webpack_exports__["h"] = loadContractorsRequest;
/* unused harmony export setCurrentSubContractorsId */
/* harmony export (immutable) */ __webpack_exports__["i"] = loadUnionTradesRequest;
/* unused harmony export setCurrentUnionTradesId */
/* harmony export (immutable) */ __webpack_exports__["l"] = selectUnionTrade;
/* harmony export (immutable) */ __webpack_exports__["m"] = setNewWOProcessStarted;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_contractors_api__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_work_orders_api__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_union_api__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__creation__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_work_orders_creation_UnionTrades__ = __webpack_require__(1373);
function initializeComponentAppState(currentSubContractorsId,dontKnowSubContractor,dontKnowUnions){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["z" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_STATE_INIT */],payload:{dontKnowSubContractor:currentSubContractorsId.length>0?'yes':dontKnowSubContractor?'dont-know':null,dontKnowUnions:dontKnowUnions}};}function selectSubContractor(contractorId){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["y" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_SELECT */],payload:contractorId};}function addSubContractor(){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["o" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_ADD */]};}function cancelAddSubContractor(){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["r" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_CANCEL */]};}function getInvalidFields(newData){return Object.keys(newData).filter(function(key){return key!=='unitNumberFloor'&&newData[key].value==='';}).map(function(key){return key;});}function newSubContractorValid(){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["u" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_VALID */]};}function newSubContractorInvalid(fields,validationMessage){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["s" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_INVALID */],payload:{fields:fields,validationMessage:validationMessage}};}function formValueChange(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["v" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_VALUE_CHANGE */],payload:{attribute:attribute,value:value}};}function createSubContractorRequest(newData){return function(dispatch){var invalidFields=getInvalidFields(newData);if(invalidFields.length===0){dispatch(newSubContractorValid());return __WEBPACK_IMPORTED_MODULE_0__services_api_contractors_api__["b" /* default */].createContractor({name:newData.subContractorName.value,contact:{firstName:newData.contactFirstName.value,lastName:newData.contactLastName.value,email:newData.email.value,phoneNumber:newData.phoneNumber.value},location:{streetAddress:newData.streetAddress.value,unitNumber:newData.unitNumberFloor.value,city:newData.city.value,state:newData.state.value,zipCode:newData.zipCode.value}}).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__work_orders__["s" /* newContractorSuccess */])(response.contractor));dispatch(createSubContractorSuccess(response.contractor));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__messages__["d" /* showErrorMessage */])(response.errors));}});}else{dispatch(newSubContractorInvalid(invalidFields,'The outlined inputs should be added in order to add a contractor.'));}};}function createSubContractorSuccess(newContractor){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["t" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_SUCCESS */],payload:newContractor};}function removeSubContractor(id){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["x" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_REMOVE */],payload:id};}function confirmSubContractorsUnionTradesRequest(workOrderId,contractorsId,subContractorAnswer,selectedUnionTradesId,dontKnowUnions,noUnions,newWOProcessStarted){return function(dispatch){if(subContractorAnswer===null){var msg='Please answer the above question.';if(subContractorAnswer===null){dispatch(subContractorConfirmationInvalid(msg));}return null;}else{dispatch(subContractorConfirmationValid());dispatch(unionTradesConfirmationValid());var data={dont_know_subcons:subContractorAnswer==='dont-know',dont_know_unions:dontKnowUnions,propietary_sub_contractor_ids:contractorsId,union_ids:selectedUnionTradesId};return __WEBPACK_IMPORTED_MODULE_1__services_api_work_orders_api__["a" /* default */].updateWorkOrder(workOrderId,data).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__work_orders__["C" /* updateWorkOrder */])(response.workOrder));if(newWOProcessStarted){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__creation__["f" /* goToWorkingHours */])());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__creation__["d" /* goToSummary */])());}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__messages__["d" /* showErrorMessage */])(response.errors));}return response;});}};}function answerQuestion(value){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["w" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_QUESTION_ANSWERED */],payload:{clearSelected:value!=='yes',value:value}};}function subContractorConfirmationInvalid(message){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["q" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_INVALID_CONFIRMATION */],payload:message};}function subContractorConfirmationValid(){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["A" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_VALID_CONFIRMATION */]};}function unionTradesConfirmationInvalid(message){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["P" /* WORK_ORDERS_CREATION_UNION_TRADES_INVALID_CONFIRMATION */],payload:message};}function unionTradesConfirmationValid(){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["R" /* WORK_ORDERS_CREATION_UNION_TRADES_VALID_CONFIRMATION */]};}function loadContractorsRequest(currentSubContractorsId,tradesId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0__services_api_contractors_api__["b" /* default */].getContractors(tradesId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__work_orders__["j" /* loadContractorsSuccess */])(response.contractors));dispatch(setCurrentSubContractorsId(currentSubContractorsId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__messages__["d" /* showErrorMessage */])(response.errors));}});};}function setCurrentSubContractorsId(currentSubContractorsId){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["p" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_CURRENT_SET */],payload:currentSubContractorsId};}function loadUnionTradesRequest(currentUnionTradesId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2__services_api_union_api__["a" /* default */].getUnions().then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__work_orders__["o" /* loadUnionTradesSuccess */])(response.unions));dispatch(setCurrentUnionTradesId(currentUnionTradesId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__messages__["d" /* showErrorMessage */])(response.errors));}});};}function setCurrentUnionTradesId(currentUnionTradesId){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["O" /* WORK_ORDERS_CREATION_UNION_TRADES_CURRENT_SET */],payload:currentUnionTradesId};}function selectUnionTrade(id,selectedUnionTradesId,unionTrades){var newSelectedUnionTradesId=void 0;var dontKnowUnions=false;var noUnions=false;if(id===__WEBPACK_IMPORTED_MODULE_7__components_admin_work_orders_creation_UnionTrades__["a" /* UnionTradesExtraKeys */].ALL){if(selectedUnionTradesId.length===unionTrades.length){// If all are selected, deselect all
newSelectedUnionTradesId=[];}else{newSelectedUnionTradesId=unionTrades.map(function(element){return element.id;});}}else if(id===__WEBPACK_IMPORTED_MODULE_7__components_admin_work_orders_creation_UnionTrades__["a" /* UnionTradesExtraKeys */].DONT_KNOW){newSelectedUnionTradesId=[];dontKnowUnions=true;noUnions=false;}else if(id===__WEBPACK_IMPORTED_MODULE_7__components_admin_work_orders_creation_UnionTrades__["a" /* UnionTradesExtraKeys */].NO){newSelectedUnionTradesId=[];dontKnowUnions=false;noUnions=true;}else{newSelectedUnionTradesId=selectedUnionTradesId.slice();if(newSelectedUnionTradesId.findIndex(function(element){return element===id;})>-1){// The item is selected, deselect it
newSelectedUnionTradesId=newSelectedUnionTradesId.filter(function(element){return element!==id;});}else{// Add it
newSelectedUnionTradesId.push(id);}}return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["Q" /* WORK_ORDERS_CREATION_UNION_TRADES_SELECT */],payload:{newSelectedUnionTradesId:newSelectedUnionTradesId,dontKnowUnions:dontKnowUnions,noUnions:noUnions}};}function setNewWOProcessStarted(value){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["Z" /* WORK_ORDERS_CREATION_WO_NEW_PROCESS_STARTED */],payload:value};}

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return unionsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UnionsApi=function(_BaseApi){_inherits(UnionsApi,_BaseApi);function UnionsApi(){_classCallCheck(this,UnionsApi);return _possibleConstructorReturn(this,(UnionsApi.__proto__||Object.getPrototypeOf(UnionsApi)).apply(this,arguments));}_createClass(UnionsApi,[{key:'getUnions',value:function getUnions(){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/unions').then(function(response){return{ok:true,unions:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return UnionsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var unionsApi=new UnionsApi();/* harmony default export */ __webpack_exports__["a"] = (UnionsApi=new UnionsApi());

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addTimeEntry;
/* harmony export (immutable) */ __webpack_exports__["b"] = confirmRate;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteTime;
/* harmony export (immutable) */ __webpack_exports__["d"] = editTimeEntry;
/* harmony export (immutable) */ __webpack_exports__["e"] = getTime;
/* harmony export (immutable) */ __webpack_exports__["f"] = setCurrentTimeRateToEdit;
/* harmony export (immutable) */ __webpack_exports__["g"] = setCurrentTimeToEdit;
/* harmony export (immutable) */ __webpack_exports__["h"] = setRate;
/* harmony export (immutable) */ __webpack_exports__["i"] = setShowAddTimeModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_work_orders_api__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_work_orders_details_time_store_action_types__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_tasks_api__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_time_api__ = __webpack_require__(1379);
function addTimeEntry(taskId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_tasks_api__["b" /* tasksApi */].createTimeEntry(taskId,values).then(function(response){if(response.ok){dispatch(addTimeEntrySuccess(response.timeEntry));dispatch(setShowAddTimeModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function addTimeEntrySuccess(timeEntry){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_work_orders_details_time_store_action_types__["a" /* TIME_ADD_ENTRY_SUCCESS */],payload:timeEntry};}function confirmRate(taskId,timeId,newRate){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_time_api__["a" /* timeApi */].updateTimeEntryRate(timeId,newRate).then(function(response){if(response.ok){dispatch(confirmRateSuccess(response.timeEntry));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function confirmRateSuccess(timeEntry){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_work_orders_details_time_store_action_types__["d" /* TIME_RATE_CONFIRM_SUCCESS */],payload:timeEntry};}function deleteTime(timeId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_time_api__["a" /* timeApi */].deleteTimeEntry(timeId).then(function(response){if(response.ok){dispatch(removeTime(timeId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function editTimeEntry(timeId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_time_api__["a" /* timeApi */].editTimeEntry(timeId,values).then(function(response){if(response.ok){dispatch(updateTimeEntry(response.timeEntry));dispatch(setShowAddTimeModal(false));dispatch(setCurrentTimeToEdit(null));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function getTime(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_work_orders_api__["b" /* workOrdersApi */].getTime(workOrderId).then(function(response){if(response.ok){dispatch(setTime(response.time));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function removeTime(timeId){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_work_orders_details_time_store_action_types__["f" /* TIME_REMOVE */],payload:timeId};}function setCurrentTimeRateToEdit(timeId){var rate=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_work_orders_details_time_store_action_types__["c" /* TIME_ID_RATE_TO_EDIT */],payload:{timeId:timeId,rate:rate}};}function setCurrentTimeToEdit(time){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_work_orders_details_time_store_action_types__["h" /* TIME_TO_EDIT */],payload:time};}function setRate(rate){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_work_orders_details_time_store_action_types__["e" /* TIME_RATE_SET */],payload:rate};}function setShowAddTimeModal(value){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_work_orders_details_time_store_action_types__["b" /* TIME_ADD_MODAL_SHOW */],payload:value};}function setTime(time){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_work_orders_details_time_store_action_types__["g" /* TIME_SET */],payload:time};}function updateTimeEntry(timeEntry){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_work_orders_details_time_store_action_types__["i" /* TIME_UPDATE */],payload:timeEntry};}

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TIME_ADD_ENTRY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TIME_ADD_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TIME_ID_RATE_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TIME_RATE_CONFIRM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TIME_RATE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TIME_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TIME_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TIME_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TIME_UPDATE; });
var TIME_ADD_ENTRY_SUCCESS='TIME_ADD_ENTRY_SUCCESS';var TIME_ADD_MODAL_SHOW='TIME_ADD_MODAL_SHOW';var TIME_ID_RATE_TO_EDIT='TIME_ID_RATE_TO_EDIT';var TIME_RATE_CONFIRM_SUCCESS='TIME_RATE_CONFIRM_SUCCESS';var TIME_RATE_SET='TIME_RATE_SET';var TIME_REMOVE='TIME_REMOVE';var TIME_SET='TIME_SET';var TIME_TO_EDIT='TIME_TO_EDIT';var TIME_UPDATE='TIME_UPDATE';

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createVendorInvoice;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteVendorInvoice;
/* harmony export (immutable) */ __webpack_exports__["c"] = getVendorInvoices;
/* harmony export (immutable) */ __webpack_exports__["d"] = setShowAddInvoiceModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_vendor_invoices_store_action_types__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_work_orders_api__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_vendor_invoices_api__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_tasks_api__ = __webpack_require__(140);
function addVendorInvoice(invoice){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_vendor_invoices_store_action_types__["b" /* VENDOR_INVOICES_INVOICE_ADD */],payload:invoice};}function createVendorInvoice(taskId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_tasks_api__["b" /* tasksApi */].createVendorInvoices(taskId,values).then(function(response){if(response.ok){dispatch(addVendorInvoice(response.invoice));dispatch(setShowAddInvoiceModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function deleteVendorInvoice(vendorInvoiceId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_vendor_invoices_api__["a" /* vendorInvoicesApi */].deleteVendorInvoice(vendorInvoiceId).then(function(response){if(response.ok){dispatch(removeVendorInvoice(vendorInvoiceId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function getVendorInvoices(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_work_orders_api__["b" /* workOrdersApi */].getVendorInvoices(workOrderId).then(function(response){if(response.ok){dispatch(setVendorInvoices(response.invoices));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function removeVendorInvoice(invoiceId){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_vendor_invoices_store_action_types__["c" /* VENDOR_INVOICES_INVOICE_REMOVE */],payload:invoiceId};}function setVendorInvoices(invoices){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_vendor_invoices_store_action_types__["d" /* VENDOR_INVOICES_SET */],payload:invoices};}function setShowAddInvoiceModal(value){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_vendor_invoices_store_action_types__["a" /* VENDOR_INVOICES_ADD_INVOICE_MODAL_SHOW */],payload:value};}

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VENDOR_INVOICES_ADD_INVOICE_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VENDOR_INVOICES_INVOICE_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VENDOR_INVOICES_INVOICE_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return VENDOR_INVOICES_SET; });
var VENDOR_INVOICES_ADD_INVOICE_MODAL_SHOW='VENDOR_INVOICES_ADD_INVOICE_MODAL_SHOW';var VENDOR_INVOICES_INVOICE_ADD='VENDOR_INVOICES_INVOICE_ADD';var VENDOR_INVOICES_INVOICE_REMOVE='VENDOR_INVOICES_INVOICE_REMOVE';var VENDOR_INVOICES_SET='VENDOR_INVOICES_SET';

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteReceipt;
/* harmony export (immutable) */ __webpack_exports__["f"] = setShowAddMaterialsModal;
/* harmony export (immutable) */ __webpack_exports__["a"] = createReceipt;
/* harmony export (immutable) */ __webpack_exports__["c"] = editReceipt;
/* harmony export (immutable) */ __webpack_exports__["d"] = getReceipts;
/* harmony export (immutable) */ __webpack_exports__["e"] = setReceiptToEdit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_tasks_api__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_receipts_api__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_work_orders_api__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_receipts_store_action_types__ = __webpack_require__(506);
function addReceipt(receipt){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_receipts_store_action_types__["a" /* RECEIPTS_ADD */],payload:receipt};}function deleteReceipt(receiptId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_receipts_api__["a" /* receiptsApi */].deleteReceipt(receiptId).then(function(response){if(response.ok){dispatch(removeTime(receiptId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function setShowAddMaterialsModal(value){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_receipts_store_action_types__["d" /* RECEIPTS_SHOW_ADD_MODAL_SET */],payload:value};}function createReceipt(taskId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_tasks_api__["b" /* tasksApi */].createReceipt(taskId,values).then(function(response){if(response.ok){dispatch(setShowAddMaterialsModal(false));dispatch(addReceipt(response.receipt));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function editReceipt(receiptId,values){var imageIdToDelete=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var documentIdToDelete=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_receipts_api__["a" /* receiptsApi */].editReceipt(receiptId,values,imageIdToDelete,documentIdToDelete).then(function(response){if(response.ok){dispatch(setShowAddMaterialsModal(false));dispatch(updateReceipt(response.receipt));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function getReceipts(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_work_orders_api__["b" /* workOrdersApi */].getReceipts(workOrderId).then(function(response){if(response.ok){dispatch(setReceipts(response.receipts));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function removeTime(receiptId){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_receipts_store_action_types__["b" /* RECEIPTS_REMOVE */],payload:receiptId};}function setReceipts(receipts){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_receipts_store_action_types__["c" /* RECEIPTS_SET */],payload:receipts};}function setReceiptToEdit(receipt){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_receipts_store_action_types__["e" /* RECEIPTS_TO_EDIT_SET */],payload:receipt};}function updateReceipt(receipt){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_receipts_store_action_types__["f" /* RECEIPTS_UPDATE */],payload:receipt};}

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECEIPTS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECEIPTS_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RECEIPTS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RECEIPTS_SHOW_ADD_MODAL_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RECEIPTS_TO_EDIT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RECEIPTS_UPDATE; });
var RECEIPTS_ADD='RECEIPTS_ADD';var RECEIPTS_REMOVE='RECEIPTS_REMOVE';var RECEIPTS_SET='RECEIPTS_SET';var RECEIPTS_SHOW_ADD_MODAL_SET='RECEIPTS_SHOW_ADD_MODAL_SET';var RECEIPTS_TO_EDIT_SET='RECEIPTS_TO_EDIT_SET';var RECEIPTS_UPDATE='RECEIPTS_UPDATE';

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chainPropTypes;
function chainPropTypes(propType1, propType2) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getThemeProps__ = __webpack_require__(1405);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__getThemeProps__["a"]; });


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jssPreset__ = __webpack_require__(1406);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__jssPreset__["a"]; });


/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__ = __webpack_require__(1417);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__["a" /* default */])();
}

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeClasses__ = __webpack_require__(1420);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__mergeClasses__["a"]; });


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(295);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hexToRgb */
/* unused harmony export rgbToHex */
/* unused harmony export hslToRgb */
/* unused harmony export decomposeColor */
/* unused harmony export recomposeColor */
/* harmony export (immutable) */ __webpack_exports__["c"] = getContrastRatio;
/* unused harmony export getLuminance */
/* unused harmony export emphasize */
/* harmony export (immutable) */ __webpack_exports__["b"] = fade;
/* harmony export (immutable) */ __webpack_exports__["a"] = darken;
/* harmony export (immutable) */ __webpack_exports__["d"] = lighten;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(100);


/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (false) {
    if (value < min || value > max) {
      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    }
  }

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}

function intToHex(int) {
  var hex = int.toString(16);
  return hex.length === 1 ? "0".concat(hex) : hex;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  return "#".concat(values.map(function (n) {
    return intToHex(n);
  }).join(''));
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error( false ? "Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["b" /* formatMuiErrorMessage */])(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleBreakpoints;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__merge__ = __webpack_require__(374);




 // The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.

var values = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};
var defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: function up(key) {
    return "@media (min-width:".concat(values[key], "px)");
  }
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  if (false) {
    if (!props.theme) {
      console.error('Material-UI: You are calling a style function without a theme value.');
    }
  }

  if (Array.isArray(propValue)) {
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    return propValue.reduce(function (acc, item, index) {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__["a" /* default */])(propValue) === 'object') {
    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;

    return Object.keys(propValue).reduce(function (acc, breakpoint) {
      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
      return acc;
    }, {});
  }

  var output = styleFromPropValue(propValue);
  return output;
}

function breakpoints(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var base = styleFunction(props);
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    var extended = themeBreakpoints.keys.reduce(function (acc, key) {
      if (props[key]) {
        acc = acc || {};
        acc[themeBreakpoints.up(key)] = styleFunction(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          theme: props.theme
        }, props[key]));
      }

      return acc;
    }, null);
    return Object(__WEBPACK_IMPORTED_MODULE_4__merge__["a" /* default */])(base, extended);
  };

  newStyleFunction.propTypes =  false ? _extends({}, styleFunction.propTypes, {
    xs: PropTypes.object,
    sm: PropTypes.object,
    md: PropTypes.object,
    lg: PropTypes.object,
    xl: PropTypes.object
  }) : {};
  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl'].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(styleFunction.filterProps));
  return newStyleFunction;
}

/* unused harmony default export */ var _unused_webpack_default_export = (breakpoints);

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollSpy = __webpack_require__(516);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _scroller = __webpack_require__(376);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollHash = __webpack_require__(798);

var _scrollHash2 = _interopRequireDefault(_scrollHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protoTypes = {
  to: _propTypes2.default.string.isRequired,
  containerId: _propTypes2.default.string,
  container: _propTypes2.default.object,
  activeClass: _propTypes2.default.string,
  spy: _propTypes2.default.bool,
  horizontal: _propTypes2.default.bool,
  smooth: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  offset: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  isDynamic: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  absolute: _propTypes2.default.bool,
  onSetActive: _propTypes2.default.func,
  onSetInactive: _propTypes2.default.func,
  ignoreCancelEvents: _propTypes2.default.bool,
  hashSpy: _propTypes2.default.bool,
  saveHashHistory: _propTypes2.default.bool
};

exports.default = function (Component, customScroller) {

  var scroller = customScroller || _scroller2.default;

  var Link = function (_React$PureComponent) {
    _inherits(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck(this, Link);

      var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      return _this;
    }

    _createClass(Link, [{
      key: 'getScrollSpyContainer',
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) {
            _scrollSpy2.default.mount(scrollSpyContainer);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
      }
    }, {
      key: 'render',
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var props = _extends({}, this.props);

        for (var prop in protoTypes) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.onClick = this.handleClick;

        return _react2.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends({}, _this2.state, props));
    };

    this.handleClick = function (event) {

      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (x, y) {
      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var horizontal = _this2.props.horizontal;

      var to = _this2.props.to;
      var element = null;
      var isInside = void 0;
      var isOutside = void 0;

      if (horizontal) {
        var elemLeftBound = 0;
        var elemRightBound = 0;
        var containerLeft = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerLeft = containerCords.left;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemLeftBound = cords.left - containerLeft + x;
          elemRightBound = elemLeftBound + cords.width;
        }

        var offsetX = x - _this2.props.offset;
        isInside = offsetX >= Math.floor(elemLeftBound) && offsetX < Math.floor(elemRightBound);
        isOutside = offsetX < Math.floor(elemLeftBound) || offsetX >= Math.floor(elemRightBound);
      } else {
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var _containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = _containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var _cords = element.getBoundingClientRect();
          elemTopBound = _cords.top - containerTop + y;
          elemBottomBound = elemTopBound + _cords.height;
        }

        var offsetY = y - _this2.props.offset;
        isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      }

      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          var _props$saveHashHistor = _this2.props.saveHashHistory,
              saveHashHistory = _props$saveHashHistor === undefined ? false : _props$saveHashHistor;

          _scrollHash2.default.changeHash("", saveHashHistory);
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        var _props$saveHashHistor2 = _this2.props.saveHashHistory,
            _saveHashHistory = _props$saveHashHistor2 === undefined ? false : _props$saveHashHistor2;

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to, _saveHashHistory);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  ;

  Link.propTypes = protoTypes;

  Link.defaultProps = { offset: 0 };

  return Link;
};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(1474);

var _lodash2 = _interopRequireDefault(_lodash);

var _passiveEventListeners = __webpack_require__(517);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The eventHandler will execute at a rate of 15fps
var eventThrottler = function eventThrottler(eventHandler) {
  return (0, _lodash2.default)(eventHandler, 66);
};

var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy.scrollHandler(scrollSpyContainer);
      });
      scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
    }
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionX: function currentPositionX(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageYOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    } else {
      return scrollSpyContainer.scrollLeft;
    }
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);

    handler(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
  },
  updateStates: function updateStates() {
    scrollSpy.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy.spySetState && scrollSpy.spySetState.length) {
      scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy.scrollHandler);
  },


  update: function update() {
    return scrollSpy.scrollSpyContainers.forEach(function (c) {
      return scrollSpy.scrollHandler(c);
    });
  }
};

exports.default = scrollSpy;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
};

var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

exports.default = Events;

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapProps", function() { return mapProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withProps", function() { return withProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withPropsOnChange", function() { return withPropsOnChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withHandlers", function() { return withHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProp", function() { return renameProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProps", function() { return renameProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flattenProp", function() { return flattenProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withState", function() { return withState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withStateHandlers", function() { return withStateHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withReducer", function() { return withReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "branch", function() { return branch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderComponent", function() { return renderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderNothing", function() { return renderNothing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shouldUpdate", function() { return shouldUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pure", function() { return pure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForKeys", function() { return onlyUpdateForKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForPropTypes", function() { return onlyUpdateForPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withContext", function() { return withContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lifecycle", function() { return lifecycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toClass", function() { return toClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatic", function() { return setStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPropTypes", function() { return setPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayName", function() { return setDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapDisplayName", function() { return wrapDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isClassComponent", function() { return isClassComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSink", function() { return createSink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromProp", function() { return componentFromProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return nest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hoistStatics", function() { return hoistStatics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStream", function() { return componentFromStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStreamWithConfig", function() { return componentFromStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStream", function() { return mapPropsStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStreamWithConfig", function() { return mapPropsStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandler", function() { return createEventHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandlerWithConfig", function() { return createEventHandlerWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setObservableConfig", function() { return configureObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(493);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a; });






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

/* eslint-disable no-console */
var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithStateHandlers = function (_Component) {
      inherits(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithStateHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var propsChanged = nextProps !== this.props;
        // the idea is to skip render if stateUpdater handler return undefined
        // this allows to create no state update handlers with access to state and props
        var stateChanged = !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(nextState, this.state);
        return propsChanged || stateChanged;
      };

      WithStateHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
        return function (mayBeEvent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          // Having that functional form of setState can be called async
          // we need to persist SyntheticEvent
          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
            mayBeEvent.persist();
          }

          _this2.setState(function (state, props) {
            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
          });
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }
    return WithStateHandlers;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"]);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit();

        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(151);


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(171);
var core = __webpack_require__(77);
var LIBRARY = __webpack_require__(350);
var wksExt = __webpack_require__(520);
var defineProperty = __webpack_require__(195).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(305),
    overRest = __webpack_require__(1511),
    setToString = __webpack_require__(805);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 523 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(383),
    baseLodash = __webpack_require__(525);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 525 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 526 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1552),
    createBaseEach = __webpack_require__(1564);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1557),
    isObjectLike = __webpack_require__(261);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(112),
    stubFalse = __webpack_require__(1558);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(368)(module)))

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1559),
    baseUnary = __webpack_require__(1560),
    nodeUtil = __webpack_require__(1561);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 531 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 532 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(228),
    root = __webpack_require__(112);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1577),
    mapCacheDelete = __webpack_require__(1584),
    mapCacheGet = __webpack_require__(1586),
    mapCacheHas = __webpack_require__(1587),
    mapCacheSet = __webpack_require__(1588);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(113),
    isSymbol = __webpack_require__(386);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = loadBuildingsRequest;
/* harmony export (immutable) */ __webpack_exports__["b"] = createWorkOrderRequest;
/* harmony export (immutable) */ __webpack_exports__["h"] = selectBuilding;
/* harmony export (immutable) */ __webpack_exports__["d"] = goToNewBuilding;
/* harmony export (immutable) */ __webpack_exports__["f"] = newBuildingChange;
/* harmony export (immutable) */ __webpack_exports__["c"] = editNewBuilding;
/* harmony export (immutable) */ __webpack_exports__["a"] = createBuildingRequest;
/* unused harmony export createBuildingSuccess */
/* harmony export (immutable) */ __webpack_exports__["i"] = updateBuildingRequest;
/* unused harmony export updateBuildingSuccess */
/* harmony export (immutable) */ __webpack_exports__["j"] = updateLocationRequest;
/* unused harmony export updateLocationRequestSuccess */
/* harmony export (immutable) */ __webpack_exports__["k"] = uploadDocumentsRequest;
/* unused harmony export uploadDocumentsSuccess */
/* harmony export (immutable) */ __webpack_exports__["g"] = removeDocumentRequest;
/* unused harmony export removeDocumentSuccess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_work_orders_api__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_buildings_api__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_locations_api__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__creation__ = __webpack_require__(124);
function loadBuildingsRequest(clientId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2__services_api_buildings_api__["b" /* default */].getBuildings(clientId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__work_orders__["i" /* loadBuildingSuccess */])(response.buildings));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__messages__["d" /* showErrorMessage */])(response.errors));}});};}function createWorkOrderRequest(buildingId,currentWorkOrder,clientId){return function(dispatch){dispatch(selectBuilding(buildingId));if(currentWorkOrder!==null){// Editing the current work order creation
return __WEBPACK_IMPORTED_MODULE_1__services_api_work_orders_api__["a" /* default */].updateBuilding(currentWorkOrder.id,buildingId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__work_orders__["f" /* createWorkOrderSuccess */])(response.workOrder));dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__creation__["e" /* goToTasks */])());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__messages__["d" /* showErrorMessage */])(response.errors));}});}else{return __WEBPACK_IMPORTED_MODULE_1__services_api_work_orders_api__["a" /* default */].createWorkOrder(buildingId,clientId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__work_orders__["f" /* createWorkOrderSuccess */])(response.newWorkOrder));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_0__work_orders__["c" /* baseRoutePath */]+'/work-order-created'));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__messages__["d" /* showErrorMessage */])(response.errors));}});}};}function selectBuilding(buildingId){return{type:__WEBPACK_IMPORTED_MODULE_5__action_types__["n" /* WORK_ORDERS_CREATION_SELECT_BUILDING */],payload:buildingId};}function goToNewBuilding(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__action_types__["l" /* WORK_ORDERS_CREATION_NEW_BUILDING_REQUEST */]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_0__work_orders__["c" /* baseRoutePath */]+'/new-building'));};}function newBuildingChange(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_5__action_types__["j" /* WORK_ORDERS_CREATION_NEW_BUILDING_CHANGE_VALUE */],payload:{attribute:attribute,value:value}};}function editNewBuilding(){return{type:__WEBPACK_IMPORTED_MODULE_5__action_types__["k" /* WORK_ORDERS_CREATION_NEW_BUILDING_EDIT */]};}function createBuildingRequest(newBuilding,clientId){return function(dispatch){var data={location:{streetAddress:newBuilding.streetAddress,city:newBuilding.city,state:newBuilding.state,zipCode:newBuilding.zipCode}};if(newBuilding.name!==''){data['name']=newBuilding.name;}if(newBuilding.unitNumber!==''){data['location']['unitNumber']=newBuilding.unitNumber;}if(clientId!==undefined){data['clientsId']=[clientId];}return __WEBPACK_IMPORTED_MODULE_2__services_api_buildings_api__["b" /* default */].createBuilding(data).then(function(response){if(response.ok){dispatch(createBuildingSuccess(response.building));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__messages__["d" /* showErrorMessage */])(response.errors));}});};}function createBuildingSuccess(newBuilding){return{type:__WEBPACK_IMPORTED_MODULE_5__action_types__["m" /* WORK_ORDERS_CREATION_NEW_BUILDING_SUCCESS */],payload:newBuilding};}function updateBuildingRequest(buildingId,locationId,data,currentWorkOrder,clientId){return function(dispatch){dispatch(selectBuilding(buildingId));return __WEBPACK_IMPORTED_MODULE_2__services_api_buildings_api__["b" /* default */].updateBuildingNameAndLocation(buildingId,locationId,data).then(function(response){if(response.ok){dispatch(updateBuildingSuccess(response.newBuilding));if(currentWorkOrder!==null){// Update current work order with the new building created
return __WEBPACK_IMPORTED_MODULE_1__services_api_work_orders_api__["a" /* default */].updateBuilding(currentWorkOrder.id,buildingId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__work_orders__["f" /* createWorkOrderSuccess */])(response.workOrder));dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__creation__["e" /* goToTasks */])());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__messages__["d" /* showErrorMessage */])(response.errors));}});}else{return __WEBPACK_IMPORTED_MODULE_1__services_api_work_orders_api__["a" /* default */].createWorkOrder(buildingId,clientId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__work_orders__["f" /* createWorkOrderSuccess */])(response.newWorkOrder));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_0__work_orders__["c" /* baseRoutePath */]+'/work-order-created'));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__messages__["d" /* showErrorMessage */])(response.errors));}});}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__messages__["d" /* showErrorMessage */])(response.errors));}});};}function updateBuildingSuccess(building){return{type:__WEBPACK_IMPORTED_MODULE_5__action_types__["f" /* WORK_ORDERS_CREATION_BUILDING_UPDATE_SUCCESS */],payload:building};}function updateLocationRequest(selectedBuildingId,latitude,longitude){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3__services_api_locations_api__["a" /* default */].getLocationByLatLong(latitude,longitude).then(function(response){if(response.ok){dispatch(updateLocationRequestSuccess(selectedBuildingId,latitude,longitude,response.location));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__messages__["d" /* showErrorMessage */])(response.errors));}});};}function updateLocationRequestSuccess(selectedBuildingId,latitude,longitude,location){return{type:__WEBPACK_IMPORTED_MODULE_5__action_types__["e" /* WORK_ORDERS_CREATION_BUILDING_LOCATION_UPDATE_SUCCESS */],payload:{selectedBuildingId:selectedBuildingId,latitude:latitude,longitude:longitude,location:location}};}function uploadDocumentsRequest(buildingId,files){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2__services_api_buildings_api__["b" /* default */].uploadDocuments(buildingId,files).then(function(response){if(response.ok){dispatch(uploadDocumentsSuccess(response.building));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__messages__["d" /* showErrorMessage */])(response.errors));}});};}function uploadDocumentsSuccess(building){return{type:__WEBPACK_IMPORTED_MODULE_5__action_types__["d" /* WORK_ORDERS_CREATION_BUILDING_DOCUMENTS_UPLOAD_SUCCESS */],payload:building};}function removeDocumentRequest(buildingId,documentId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2__services_api_buildings_api__["b" /* default */].deleteDocument(buildingId,documentId).then(function(response){if(response.ok){dispatch(removeDocumentSuccess(response.building));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__messages__["d" /* showErrorMessage */])(response.errors));}});};}function removeDocumentSuccess(building){return{type:__WEBPACK_IMPORTED_MODULE_5__action_types__["c" /* WORK_ORDERS_CREATION_BUILDING_DOCUMENTS_REMOVE_SUCCESS */],payload:building};}

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClients; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSelectedClientId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getClients=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.clients.data.clients;},function(clients){return clients;});var getSelectedClientId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.clients.ui.selectedClientId;},function(selectedClientId){return selectedClientId;});

/***/ }),
/* 538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(41);
var core = __webpack_require__(108);
var LIBRARY = __webpack_require__(192);
var wksExt = __webpack_require__(851);
var defineProperty = __webpack_require__(70).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(136);
var defined = __webpack_require__(150);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 543 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 544 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(395);
var defined = __webpack_require__(150);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(54)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(70);
var createDesc = __webpack_require__(210);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1756);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(71);
var toAbsoluteIndex = __webpack_require__(213);
var toLength = __webpack_require__(55);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(311);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(342)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(137);
var invoke = __webpack_require__(856);
var html = __webpack_require__(452);
var cel = __webpack_require__(446);
var global = __webpack_require__(41);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(135)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(41);
var macrotask = __webpack_require__(552).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(135)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(98);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(41);
var DESCRIPTORS = __webpack_require__(59);
var LIBRARY = __webpack_require__(192);
var $typed = __webpack_require__(399);
var hide = __webpack_require__(110);
var redefineAll = __webpack_require__(214);
var fails = __webpack_require__(43);
var anInstance = __webpack_require__(215);
var toInteger = __webpack_require__(136);
var toLength = __webpack_require__(55);
var toIndex = __webpack_require__(871);
var gOPN = __webpack_require__(229).f;
var dP = __webpack_require__(70).f;
var arrayFill = __webpack_require__(549);
var setToStringTag = __webpack_require__(240);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Async", function() { return Async; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncCreatable", function() { return AsyncCreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Creatable", function() { return CreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Value", function() { return Value; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Option", function() { return Option; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultMenuRenderer", function() { return menuRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultArrowRenderer", function() { return arrowRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultClearRenderer", function() { return clearRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultFilterOptions", function() { return filterOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize__ = __webpack_require__(1866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






var arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var clearRenderer = function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = isValid(value);
		var hasLabel = isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

menuRenderer.propTypes = {
	focusOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	focusedOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
	inputValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onOptionRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	removeValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	selectValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	valueArray: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
			var pref = document.addEventListener ? '' : 'on';

			document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
			document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false,
						focusedOption: null
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen,
					focusedOption: null
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (!this.props.closeOnSelect) {
				return;
			}
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value,
							values: valueArray
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = _extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', _extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						'div',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultChildren = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator,
			    showNewOptionAtTop = _props2.showNewOptionAtTop;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					if (showNewOptionAtTop) {
						filteredOptions.unshift(this._createPlaceholderOption);
					} else {
						filteredOptions.push(this._createPlaceholderOption);
					}
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
	showNewOptionAtTop: true
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Where to show prompt/placeholder option text.
	// true: new option prompt at top of list (default)
	// false: new option prompt at bottom of list
	showNewOptionAtTop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ __webpack_exports__["default"] = (Select$1);


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(1887);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = initializeTasksState;
/* harmony export (immutable) */ __webpack_exports__["h"] = loadTradesRequest;
/* harmony export (immutable) */ __webpack_exports__["j"] = saveTaskRequest;
/* unused harmony export saveTaskSuccess */
/* harmony export (immutable) */ __webpack_exports__["m"] = updateTaskRequest;
/* harmony export (immutable) */ __webpack_exports__["a"] = addEmptyTask;
/* harmony export (immutable) */ __webpack_exports__["f"] = editTask;
/* harmony export (immutable) */ __webpack_exports__["c"] = cancelTaskRequest;
/* unused harmony export cancelNewTask */
/* unused harmony export cancelTaskSuccess */
/* harmony export (immutable) */ __webpack_exports__["d"] = cancelTaskShow;
/* harmony export (immutable) */ __webpack_exports__["b"] = cancelTaskHide;
/* harmony export (immutable) */ __webpack_exports__["e"] = currentTaskChangeRequest;
/* unused harmony export currentTaskChange */
/* harmony export (immutable) */ __webpack_exports__["l"] = taskContinue;
/* harmony export (immutable) */ __webpack_exports__["k"] = taskBack;
/* harmony export (immutable) */ __webpack_exports__["i"] = removeImageRequest;
/* unused harmony export removeImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_api_tasks_api__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_utils_tasks_util__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_api_trades_api__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__creation__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_reducers_admin_work_orders_creation_tasks_data__ = __webpack_require__(888);
function initializeTasksState(editTaskId,tasks,currentTask,companyName){return function(dispatch){// Initialize state based on the current values (it's possible to edit a task from another page)
var localEditTaskId=editTaskId;var localCurrentTask=currentTask;if(editTaskId===-1&&tasks.length===0){localEditTaskId=0;localCurrentTask=Object(__WEBPACK_IMPORTED_MODULE_8_reducers_admin_work_orders_creation_tasks_data__["a" /* createEmptyTask */])();}else if(editTaskId===0){localCurrentTask=Object(__WEBPACK_IMPORTED_MODULE_8_reducers_admin_work_orders_creation_tasks_data__["a" /* createEmptyTask */])();}else if(editTaskId>0&&tasks.filter(function(task){return task.id===editTaskId;}).length===0){localEditTaskId=0;localCurrentTask=Object(__WEBPACK_IMPORTED_MODULE_8_reducers_admin_work_orders_creation_tasks_data__["a" /* createEmptyTask */])();}dispatch({type:__WEBPACK_IMPORTED_MODULE_4__action_types__["E" /* WORK_ORDERS_CREATION_TASKS_STATE_INIT */],payload:{editTaskId:localEditTaskId,currentTask:localCurrentTask,companyName:companyName}});};}function loadTradesRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5_services_api_trades_api__["a" /* default */].getTrades().then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__work_orders__["n" /* loadTradesSuccess */])(response.trades));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function saveTaskRequest(task,workOrderId){var isPreTask=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_tasks_api__["a" /* default */].createTask(task,workOrderId,isPreTask).then(function(response){if(response.ok){dispatch(saveTaskSuccess(response.newTask));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function saveTaskSuccess(newTask){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["N" /* WORK_ORDERS_CREATION_TASKS_TASK_SAVE_SUCCESS */],payload:newTask};}function updateTaskRequest(task){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_tasks_api__["a" /* default */].updateTask(task).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__work_orders__["B" /* updateTaskSuccess */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__work_orders__["z" /* updateTask */])(response.task));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function addEmptyTask(tasks){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["F" /* WORK_ORDERS_CREATION_TASKS_TASK_ADD_EMPTY_NEW */],payload:tasks};}function editTask(taskId,tasks){var task=tasks.find(function(element){return element.id===taskId;});return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__action_types__["L" /* WORK_ORDERS_CREATION_TASKS_TASK_EDIT */],payload:{taskId:taskId,task:__WEBPACK_IMPORTED_MODULE_1_services_utils_tasks_util__["a" /* default */].mapTask(task)}});// Load sub trades in case not loaded yet (could happen when editing tasks)
dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__work_orders__["k" /* loadSubTradesRequest */])(task.trade.id));};}function cancelTaskRequest(id){if(id===0){// Task is not saved yet, don't call backend
return function(dispatch){dispatch(cancelNewTask());};}else{return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_api_tasks_api__["a" /* default */].removeTask(id).then(function(response){if(response.ok){dispatch(cancelTaskSuccess(id));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}}function cancelNewTask(){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["H" /* WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_NEW */]};}function cancelTaskSuccess(id){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["J" /* WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_SUCCESS */],payload:id};}function cancelTaskShow(){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["I" /* WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_SHOW */]};}function cancelTaskHide(){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["G" /* WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_HIDE */]};}function currentTaskChangeRequest(taskId,attribute,value,label){return function(dispatch){if(attribute==='images'){// If new files uploaded, read them first so it's possible to show with a preview
var imageLoaded=[];var imageLoaderPromises=value.map(function(image){return new Promise(function(resolve){var reader=new FileReader();reader.onloadend=function(){imageLoaded.push({id:0,file:{original:image,img:reader.result},url:null});resolve();};reader.readAsDataURL(image);});});Promise.all(imageLoaderPromises).then(function(){dispatch(currentTaskChange(taskId,attribute,imageLoaded));});}else{dispatch(currentTaskChange(taskId,attribute,value,label));}};}function currentTaskChange(taskId,attribute,value,label){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["K" /* WORK_ORDERS_CREATION_TASKS_TASK_CHANGE_VALUE */],payload:{taskId:taskId,attribute:attribute,value:value,label:label}};}function taskContinue(newWOProcessStarted){return function(dispatch){if(newWOProcessStarted){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__creation__["c" /* goToSubContractorsUnionTrades */])());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__creation__["d" /* goToSummary */])());}};}function taskBack(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_3__work_orders__["c" /* baseRoutePath */]+'/new-work-order'));};}function removeImageRequest(currentTask,imageIndex){return function(dispatch){var image=currentTask.images[imageIndex];if(image.id===0){// Image is local
dispatch(removeImage(imageIndex));}else{// Image is stored in the backend, removeUser from there
return __WEBPACK_IMPORTED_MODULE_0_services_api_tasks_api__["a" /* default */].removeImage(currentTask.id,image.id).then(function(response){if(response.ok){dispatch(removeImage(imageIndex));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__work_orders__["z" /* updateTask */])(response.task));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_messages__["d" /* showErrorMessage */])(response.errors));}});}};}function removeImage(imageIndex){return{type:__WEBPACK_IMPORTED_MODULE_4__action_types__["M" /* WORK_ORDERS_CREATION_TASKS_TASK_IMAGE_REMOVE_SUCCESS */],payload:imageIndex};}

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addContractor;
/* harmony export (immutable) */ __webpack_exports__["c"] = goBack;
/* harmony export (immutable) */ __webpack_exports__["d"] = removeContractor;
/* harmony export (immutable) */ __webpack_exports__["e"] = selectContractor;
/* harmony export (immutable) */ __webpack_exports__["f"] = setBidDueDate;
/* harmony export (immutable) */ __webpack_exports__["g"] = showPreview;
/* harmony export (immutable) */ __webpack_exports__["j"] = submitQuotesRequestStart;
/* harmony export (immutable) */ __webpack_exports__["i"] = submitMultipleQuotesRequestStart;
/* unused harmony export submitQuotesRequestSuccess */
/* harmony export (immutable) */ __webpack_exports__["h"] = showQuotesRequestModalRequest;
/* unused harmony export showQuotesRequestModal */
/* harmony export (immutable) */ __webpack_exports__["b"] = closeQuotesRequestModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_tasks_api__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api_contractors_api__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__ = __webpack_require__(34);
function addContractor(selectedContractor){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_126" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_ADD */],payload:selectedContractor};}function goBack(){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_131" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_PREVIEW_GO_BACK */]};}function removeContractor(index){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_127" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_REMOVE */],payload:index};}function selectContractor(option){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_128" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_SET */],payload:option};}function setBidDueDate(date){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_125" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_BID_DUE_DATE_SET */],payload:date};}function showPreview(){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_132" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_PREVIEW_SHOW */]};}function submitQuotesRequestStart(taskId,selectedContractors,bidDueDate){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__services_api_tasks_api__["b" /* tasksApi */].addQuoteRequest(taskId,selectedContractors.map(function(element){return element.value;}),bidDueDate).then(function(response){if(response.ok){dispatch(submitQuotesRequestSuccess());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__work_orders__["B" /* updateTaskSuccess */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__work_orders__["z" /* updateTask */])(response.task));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__details__["_11" /* updateCurrentTask */])(response.task));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__details__["E" /* loadQuotesRequest */])(response.task.work_order_id));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__messages__["d" /* showErrorMessage */])(response.errors));}});};}function submitMultipleQuotesRequestStart(workOrderId,taskIds,contractorId,bidDueDate){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5__services_api_contractors_api__["a" /* contractorsApi */].addQuoteRequest(workOrderId,taskIds,contractorId,bidDueDate).then(function(response){if(response.ok){dispatch(submitQuotesRequestSuccess());dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["I" /* loadTasksFromWorkOrderRequest */])(workOrderId,false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__details__["E" /* loadQuotesRequest */])(workOrderId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__messages__["d" /* showErrorMessage */])(response.errors));}});};}function submitQuotesRequestSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_133" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_SUBMIT_SUCCESS */]};}function showQuotesRequestModalRequest(propietarySubContractors,tradeIds){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5__services_api_contractors_api__["a" /* contractorsApi */].getContractors(tradeIds).then(function(response){if(response.ok){// Form the WO preselected contractors, filter the ones that are not related with the current trade.
var contractorsIdForTrade=response.contractors.map(function(contractor){return contractor.id;});dispatch(showQuotesRequestModal(propietarySubContractors.filter(function(propietary){return contractorsIdForTrade.indexOf(propietary.id)!==-1;})));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__messages__["d" /* showErrorMessage */])(response.errors));}});};}function showQuotesRequestModal(propietarySubContractors){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_130" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_MODAL_SHOW */],payload:propietarySubContractors.map(function(element){return{value:element.id,label:element.name};})};}function closeQuotesRequestModal(){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_129" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_MODAL_CLOSE */]};}

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = changeAssigneeRequest;
/* unused harmony export invalidForm */
/* harmony export (immutable) */ __webpack_exports__["b"] = setEditOpenItem;
/* unused harmony export loadUsersSuccess */
/* harmony export (immutable) */ __webpack_exports__["c"] = setShowAddOpenItemModal;
/* harmony export (immutable) */ __webpack_exports__["d"] = setShowAddOpenItemModalRequest;
/* harmony export (immutable) */ __webpack_exports__["e"] = submitFormRequest;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateFormValue;
/* harmony export (immutable) */ __webpack_exports__["f"] = updateEditFormValue;
/* unused harmony export validForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_tasks_api__ = __webpack_require__(140);
function changeAssigneeRequest(taskId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3__services_api_tasks_api__["b" /* tasksApi */].getMembers(taskId).then(function(response){if(response.ok){dispatch(loadUsersSuccess(response.members));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function invalidForm(invalidFields,message){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_7" /* WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_INVALID */],payload:{invalidFields:invalidFields,message:message}};}function setEditOpenItem(value){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_71" /* WORK_ORDERS_DETAILS_OPEN_ITEM_EDIT_SET */],payload:value};}function loadUsersSuccess(users){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_10" /* WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_MEMBERS_LOAD_SUCCESS */],payload:users};}function setShowAddOpenItemModal(open){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_11" /* WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_MODAL_SHOW */],payload:open};}function setShowAddOpenItemModalRequest(taskId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3__services_api_tasks_api__["b" /* tasksApi */].getMembers(taskId).then(function(response){if(response.ok){dispatch(loadUsersSuccess(response.members));dispatch(setShowAddOpenItemModal(true));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function submitFormRequest(taskId,form){return function(dispatch){// Validate form
var requiredFields=['memberId','description','dueDate'];var invalidFields=[];requiredFields.forEach(function(attribute){if(form[attribute]===''||form[attribute]===null){invalidFields.push(attribute);}});if(invalidFields.length>0){dispatch(invalidForm(invalidFields,'The outlined inputs should be added in order to add an open item.'));}else{dispatch(validForm());return __WEBPACK_IMPORTED_MODULE_3__services_api_tasks_api__["b" /* tasksApi */].addOpenItem(taskId,form.memberId,form.description,form.critical,form.dueDate).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__details__["b" /* addOpenItem */])(response.openItem));dispatch(setShowAddOpenItemModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__messages__["d" /* showErrorMessage */])(response.errors));}});}};}function updateFormValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_9" /* WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_VALUE_UPDATE */],payload:{attribute:attribute,value:value}};}function updateEditFormValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_56" /* WORK_ORDERS_DETAILS_EDIT_OPEN_ITEM_FORM_VALUE_UPDATE */],payload:{attribute:attribute,value:value}};}function validForm(){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_8" /* WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_VALID */]};}

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_checkbox_CheckBox__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_details_open_items__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EditOpenItemModal_css__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EditOpenItemModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__EditOpenItemModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_actions_admin_work_orders_details_open_items__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_shared_text_Date__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditOpenItemModal=function(_Component){_inherits(EditOpenItemModal,_Component);function EditOpenItemModal(props){_classCallCheck(this,EditOpenItemModal);var _this=_possibleConstructorReturn(this,(EditOpenItemModal.__proto__||Object.getPrototypeOf(EditOpenItemModal)).call(this,props));_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_admin_work_orders_details_details__["_3" /* setSelectedOpenItem */])(null));};_this.handleSubmit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_admin_work_orders_details_details__["_8" /* submitEditOpenRequestRequest */])(_this.props.taskId,_this.props.selectedOpenItemId,_this.props.editForm));};_this.handleEditOpenItemClick=function(){if(_this.props.members.length===0){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_actions_admin_work_orders_details_open_items__["a" /* changeAssigneeRequest */])(_this.props.taskId)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_actions_admin_work_orders_details_open_items__["b" /* setEditOpenItem */])(true));}});}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_actions_admin_work_orders_details_open_items__["b" /* setEditOpenItem */])(true));}};_this.handleAttributeChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_actions_admin_work_orders_details_open_items__["f" /* updateEditFormValue */])(attribute,value));};var openItem=props.openItemsByTaskId[props.taskId].find(function(openItem){return openItem.id===props.selectedOpenItemId;});props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_actions_admin_work_orders_details_open_items__["f" /* updateEditFormValue */])('userId',openItem.user.id));props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_actions_admin_work_orders_details_open_items__["f" /* updateEditFormValue */])('description',openItem.description));props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_actions_admin_work_orders_details_open_items__["f" /* updateEditFormValue */])('dueDate',openItem.due_date));props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_actions_admin_work_orders_details_open_items__["f" /* updateEditFormValue */])('resolved',openItem.resolved));props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_actions_admin_work_orders_details_open_items__["f" /* updateEditFormValue */])('resolvedNote',openItem.resolved_note||''));_this.state={openItem:openItem};return _this;}// This modal is called from DetailsTasks and DetailsOpenItems, for the latter no current task is available.
_createClass(EditOpenItemModal,[{key:'render',value:function render(){var _this2=this;var openItem=this.state.openItem;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_modal_FormModal__["a" /* default */],{className:'edit-open-item-modal',show:this.props.selectedOpenItemId!==null,subTitle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_route_title_RouteTitle__["a" /* default */],{titles:[this.props.currentWorkOrder.client.company_name.toUpperCase(),'TASK #'+this.props.currentWorkOrder.number+'-'+__WEBPACK_IMPORTED_MODULE_4_numeral___default()(this.props.taskNumber).format('00')+'-'+openItem.letter]}),title:'Open Item'+(openItem.resolved?' - Resolved':''),onClose:this.handleClose},!this.props.editOpenItem?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2'},''+openItem.letter+(openItem.critical?' (Critical)':'')+': '+openItem.description):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_input_TextArea__["a" /* default */],{className:'h2',placeholder:'Open Item Description...',value:this.props.editForm.description,onChange:this.handleAttributeChange.bind(this,'description')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Assigned To'),!this.props.editOpenItem?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'read-only-user-name'},openItem.user.first_name+' '+openItem.user.last_name):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__shared_dropdown_Dropdown__["a" /* default */],{className:'member-dropdown',options:this.props.members.filter(function(member){return member.user.status==='active';}).map(function(member){return{value:member.user.id,label:member.user.first_name+' '+member.user.last_name};}),placeholder:'Select New Assignee',value:this.props.editForm.userId,onChange:function onChange(newOption){return _this2.handleAttributeChange('userId',newOption.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Due Date'),!this.props.editOpenItem?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'read-only-due-date'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_shared_text_Date__["a" /* default */],{value:openItem.due_date,format:'M/D/YYYY'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{readOnly:!this.props.editOpenItem,placeholder:'Due Date',value:this.props.editForm.dueDate,onChange:this.handleAttributeChange.bind(this,'dueDate')})))))),!openItem.resolved&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mark-resolved-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_checkbox_CheckBox__["a" /* default */],{readOnly:!this.props.editOpenItem,checked:this.props.editForm.resolved,shape:'round',size:'medium',onChange:function onChange(){return _this2.handleAttributeChange('resolved',!_this2.props.editForm.resolved);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Mark as Resolved')),!openItem.resolved?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_input_TextArea__["a" /* default */],{className:'note-textarea',disabled:!this.props.editOpenItem,placeholder:'Note',value:this.props.editForm.resolvedNote,onChange:this.handleAttributeChange.bind(this,'resolvedNote')})):openItem.resolved_note!==null&&openItem.resolved_note!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Note'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'resolved-note'},openItem.resolved_note))))),!openItem.resolved&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},!openItem.resolved&&!this.props.editOpenItem?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_button_Button__["a" /* default */],{className:'button-orange',label:'Edit',onClick:this.handleEditOpenItemClick}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_button_Button__["a" /* default */],{className:'button-orange',label:'Save',onClick:this.handleSubmit})));}}]);return EditOpenItemModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);EditOpenItemModal.propTypes={taskId:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number,taskNumber:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{editOpenItem:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_details_open_items__["b" /* getEditOpenItem */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_7__selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),members:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_details_open_items__["e" /* getMembers */])(state),openItemsByTaskId:Object(__WEBPACK_IMPORTED_MODULE_6__selectors_admin_work_orders_details_details__["i" /* getOpenItemsByTaskId */])(state),editForm:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_details_open_items__["a" /* getEditForm */])(state),selectedOpenItemId:Object(__WEBPACK_IMPORTED_MODULE_6__selectors_admin_work_orders_details_details__["q" /* getSelectedOpenItemId */])(state)};})(EditOpenItemModal));

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prefix", function() { return prefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_INSERT", function() { return ARRAY_INSERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_MOVE", function() { return ARRAY_MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_POP", function() { return ARRAY_POP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_PUSH", function() { return ARRAY_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE", function() { return ARRAY_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE_ALL", function() { return ARRAY_REMOVE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SHIFT", function() { return ARRAY_SHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SPLICE", function() { return ARRAY_SPLICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_UNSHIFT", function() { return ARRAY_UNSHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SWAP", function() { return ARRAY_SWAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTOFILL", function() { return AUTOFILL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLUR", function() { return BLUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE", function() { return CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_FIELDS", function() { return CLEAR_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT", function() { return CLEAR_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT_ERRORS", function() { return CLEAR_SUBMIT_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_ASYNC_ERROR", function() { return CLEAR_ASYNC_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESTROY", function() { return DESTROY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS", function() { return FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INITIALIZE", function() { return INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGISTER_FIELD", function() { return REGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET", function() { return RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_SECTION", function() { return RESET_SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_FAILED", function() { return SET_SUBMIT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_SUCCEEDED", function() { return SET_SUBMIT_SUCCEEDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_ASYNC_VALIDATION", function() { return START_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_SUBMIT", function() { return START_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_ASYNC_VALIDATION", function() { return STOP_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_SUBMIT", function() { return STOP_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBMIT", function() { return SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOUCH", function() { return TOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNREGISTER_FIELD", function() { return UNREGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNTOUCH", function() { return UNTOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_ERRORS", function() { return UPDATE_SYNC_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_WARNINGS", function() { return UPDATE_SYNC_WARNINGS; });
var prefix = '@@redux-form/';

var ARRAY_INSERT = prefix + 'ARRAY_INSERT';
var ARRAY_MOVE = prefix + 'ARRAY_MOVE';
var ARRAY_POP = prefix + 'ARRAY_POP';
var ARRAY_PUSH = prefix + 'ARRAY_PUSH';
var ARRAY_REMOVE = prefix + 'ARRAY_REMOVE';
var ARRAY_REMOVE_ALL = prefix + 'ARRAY_REMOVE_ALL';
var ARRAY_SHIFT = prefix + 'ARRAY_SHIFT';
var ARRAY_SPLICE = prefix + 'ARRAY_SPLICE';
var ARRAY_UNSHIFT = prefix + 'ARRAY_UNSHIFT';
var ARRAY_SWAP = prefix + 'ARRAY_SWAP';
var AUTOFILL = prefix + 'AUTOFILL';
var BLUR = prefix + 'BLUR';
var CHANGE = prefix + 'CHANGE';
var CLEAR_FIELDS = prefix + 'CLEAR_FIELDS';
var CLEAR_SUBMIT = prefix + 'CLEAR_SUBMIT';
var CLEAR_SUBMIT_ERRORS = prefix + 'CLEAR_SUBMIT_ERRORS';
var CLEAR_ASYNC_ERROR = prefix + 'CLEAR_ASYNC_ERROR';
var DESTROY = prefix + 'DESTROY';
var FOCUS = prefix + 'FOCUS';
var INITIALIZE = prefix + 'INITIALIZE';
var REGISTER_FIELD = prefix + 'REGISTER_FIELD';
var RESET = prefix + 'RESET';
var RESET_SECTION = prefix + 'RESET_SECTION';
var SET_SUBMIT_FAILED = prefix + 'SET_SUBMIT_FAILED';
var SET_SUBMIT_SUCCEEDED = prefix + 'SET_SUBMIT_SUCCEEDED';
var START_ASYNC_VALIDATION = prefix + 'START_ASYNC_VALIDATION';
var START_SUBMIT = prefix + 'START_SUBMIT';
var STOP_ASYNC_VALIDATION = prefix + 'STOP_ASYNC_VALIDATION';
var STOP_SUBMIT = prefix + 'STOP_SUBMIT';
var SUBMIT = prefix + 'SUBMIT';
var TOUCH = prefix + 'TOUCH';
var UNREGISTER_FIELD = prefix + 'UNREGISTER_FIELD';
var UNTOUCH = prefix + 'UNTOUCH';
var UPDATE_SYNC_ERRORS = prefix + 'UPDATE_SYNC_ERRORS';
var UPDATE_SYNC_WARNINGS = prefix + 'UPDATE_SYNC_WARNINGS';

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__ = __webpack_require__(1986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__ = __webpack_require__(2002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__ = __webpack_require__(2004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__ = __webpack_require__(2005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__ = __webpack_require__(2006);






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__["a" /* default */];
MapCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__["a" /* default */];
MapCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__["a" /* default */];
MapCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__["a" /* default */];
MapCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (MapCache);


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(201);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(152);



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stackClear_js__ = __webpack_require__(2011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__ = __webpack_require__(2012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stackGet_js__ = __webpack_require__(2013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stackHas_js__ = __webpack_require__(2014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stackSet_js__ = __webpack_require__(2015);







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */](entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = __WEBPACK_IMPORTED_MODULE_1__stackClear_js__["a" /* default */];
Stack.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__["a" /* default */];
Stack.prototype.get = __WEBPACK_IMPORTED_MODULE_3__stackGet_js__["a" /* default */];
Stack.prototype.has = __WEBPACK_IMPORTED_MODULE_4__stackHas_js__["a" /* default */];
Stack.prototype.set = __WEBPACK_IMPORTED_MODULE_5__stackSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Stack);


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(320);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__ = __webpack_require__(2050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(2052);




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 3);

  Object(__WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__["a" /* default */])(object, function(value, key, object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, key, iteratee(value, key, object));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapValues);


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(407);



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ __webpack_exports__["a"] = (isKey);


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasError__ = __webpack_require__(2095);



var createIsValid = function createIsValid(structure) {
  var getIn = structure.getIn,
      keys = structure.keys;

  var hasError = Object(__WEBPACK_IMPORTED_MODULE_0__hasError__["a" /* default */])(structure);
  return function (form, getFormState) {
    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      var syncError = getIn(formState, form + '.syncError');
      if (syncError) {
        return false;
      }
      if (!ignoreSubmitErrors) {
        var error = getIn(formState, form + '.error');
        if (error) {
          return false;
        }
      }
      var syncErrors = getIn(formState, form + '.syncErrors');
      var asyncErrors = getIn(formState, form + '.asyncErrors');
      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + '.submitErrors');
      if (!syncErrors && !asyncErrors && !submitErrors) {
        return true;
      }

      var registeredFields = getIn(formState, form + '.registeredFields');
      if (!registeredFields) {
        return true;
      }

      return !keys(registeredFields).filter(function (name) {
        return getIn(registeredFields, '[\'' + name + '\'].count') > 0;
      }).some(function (name) {
        return hasError(getIn(registeredFields, '[\'' + name + '\']'), syncErrors, asyncErrors, submitErrors);
      });
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsValid);

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports = isPromise;
module.exports.default = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_ORDER_TASKS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_ORDER_TASKS_SHOW_MODAL_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_ORDER_TASKS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_ORDER_TASKS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANGE_ORDER_TASK_DELETE; });
var CHANGE_ORDER_TASKS_LOAD_SUCCESS='CHANGE_ORDER_TASKS_LOAD_SUCCESS';var CHANGE_ORDER_TASKS_SHOW_MODAL_SET='CHANGE_ORDER_TASKS_SHOW_MODAL_SET';var CHANGE_ORDER_TASKS_ADD='CHANGE_ORDER_TASKS_ADD';var CHANGE_ORDER_TASKS_UPDATE='CHANGE_ORDER_TASKS_UPDATE';var CHANGE_ORDER_TASK_DELETE='CHANGE_ORDER_TASK_DELETE';

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_ORDER_QUOTES_REQUEST_MODAL_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_ORDER_QUOTES_REQUEST_CONFIRMATION_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_ORDER_QUOTES_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_ORDER_QUOTE_DETAILS_MODAL_CLOSE; });
var CHANGE_ORDER_QUOTES_REQUEST_MODAL_SET='CHANGE_ORDER_QUOTES_REQUEST_MODAL_SET';var CHANGE_ORDER_QUOTES_REQUEST_CONFIRMATION_SET='CHANGE_ORDER_QUOTES_REQUEST_CONFIRMATION_SET';var CHANGE_ORDER_QUOTES_SELECT='CHANGE_ORDER_QUOTES_SELECT';var CHANGE_ORDER_QUOTE_DETAILS_MODAL_CLOSE='CHANGE_ORDER_QUOTE_DETAILS_MODAL_CLOSE';

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QuoteStatus_css__ = __webpack_require__(2162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QuoteStatus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__QuoteStatus_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QuoteStatus=function(_Component){_inherits(QuoteStatus,_Component);function QuoteStatus(){_classCallCheck(this,QuoteStatus);return _possibleConstructorReturn(this,(QuoteStatus.__proto__||Object.getPrototypeOf(QuoteStatus)).apply(this,arguments));}_createClass(QuoteStatus,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote-status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.status.charAt(0).toUpperCase()+this.props.status.slice(1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status '+this.props.status}));}}]);return QuoteStatus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);QuoteStatus.propTypes={status:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (QuoteStatus);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = calculateMarkup;
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateFee;
/* harmony export (immutable) */ __webpack_exports__["b"] = calculateInsurace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_numeral__);
var MARKUP_PERCENTAGE=15;var FEE_PERCENTAGE=15;var INSURANCE_PERCENTAGE=1.25;function calculateMarkup(estimate){return calculate(estimate,MARKUP_PERCENTAGE);}function calculateFee(estimate){return calculate(estimate,FEE_PERCENTAGE);}function calculateInsurace(estimate){return calculate(estimate,INSURANCE_PERCENTAGE);}function calculate(estimate,percentage){return __WEBPACK_IMPORTED_MODULE_0_numeral___default()((estimate*(percentage/100)).toFixed(2)).value();}

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComplexNumberInput_css__ = __webpack_require__(2166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComplexNumberInput_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ComplexNumberInput_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ComplexNumberInput=function(_Component){_inherits(ComplexNumberInput,_Component);function ComplexNumberInput(props){_classCallCheck(this,ComplexNumberInput);var _this=_possibleConstructorReturn(this,(ComplexNumberInput.__proto__||Object.getPrototypeOf(ComplexNumberInput)).call(this,props));_this.handleAddInputClick=function(){_this.setState({showInput:true});};_this.handleInputBlur=function(event){event.preventDefault();// Firefox issue - check: https://tirdadc.github.io/blog/2015/06/11/react-dot-js-firefox-issue-with-onblur/
if(event.nativeEvent.explicitOriginalTarget&&event.nativeEvent.explicitOriginalTarget===event.nativeEvent.originalTarget){return;}_this.setState({showInput:false});if(_this.props.onValueBlur!==undefined){_this.props.onValueBlur(event.target.value);}};_this.handleInputChange=function(event){if(_this.props.onValueChange!==undefined){_this.props.onValueChange(event.target.value);}};_this.state={showInput:false};_this.inputRef=null;return _this;}_createClass(ComplexNumberInput,[{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.inputRef!==null){this.inputRef.focus();}}},{key:'render',value:function render(){var _this2=this;var component=void 0;if(this.state.showInput){component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'value-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{ref:function ref(input){_this2.inputRef=input;},value:this.props.value!==null?this.props.value:'',type:'number',onBlur:this.handleInputBlur,onChange:this.handleInputChange}));}else if(this.props.value===null){component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{className:this.props.theme==='blue'?'button-blue-grey':'button-orange',label:'Add '+this.props.label+'...',onClick:this.handleAddInputClick});}else{component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'value-readonly '+this.props.theme,onClick:this.handleAddInputClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.label,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Number__["a" /* default */],{value:this.props.value,format:'$0,0.00'})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'complex-number-input'},component);}}]);return ComplexNumberInput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ComplexNumberInput.propTypes={label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,theme:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['blue','tomato']),value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),onValueBlur:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onValueChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};ComplexNumberInput.defaultProps={theme:'tomato',value:null};/* harmony default export */ __webpack_exports__["a"] = (ComplexNumberInput);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_ORDERS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_ORDERS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_ORDERS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CHANGE_ORDER_MODAL_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CHANGE_ORDER_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CHANGE_ORDER_START_DATE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CHANGE_ORDER_COMPLETION_DATE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CHANGE_ORDER_VALUES_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHANGE_ORDER_BACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CHANGE_ORDER_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CHANGE_ORDER_NEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_ORDER_APPROVAL_MODAL_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANGE_ORDER_APPROVAL_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CHANGE_ORDER_SUCCESS_MODAL_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CHANGE_ORDER_SUCCESS_MODAL_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CHANGE_ORDER_PRINT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CHANGE_ORDER_PDF_VIEWER_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CHANGE_ORDER_EMAIL_MODAL_SHOW_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CHANGE_ORDER_USERS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CHANGE_ORDER_SUBJECT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CHANGE_ORDER_MESSAGE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CHANGE_ORDER_EMAIL_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CHANGE_ORDER_EMAIL_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CHANGE_ORDER_EMAIL_REMOVE; });
var CHANGE_ORDERS_LOAD_SUCCESS='CHANGE_ORDERS_LOAD_SUCCESS';var CHANGE_ORDERS_ADD='CHANGE_ORDERS_ADD';var CHANGE_ORDERS_UPDATE='CHANGE_ORDERS_UPDATE';var CHANGE_ORDER_MODAL_CLOSE='CHANGE_ORDER_MODAL_CLOSE';var CHANGE_ORDER_MODAL_SHOW='CHANGE_ORDER_MODAL_SHOW';var CHANGE_ORDER_START_DATE_UPDATE='CHANGE_ORDER_START_DATE_UPDATE';var CHANGE_ORDER_COMPLETION_DATE_UPDATE='CHANGE_ORDER_COMPLETION_DATE_UPDATE';var CHANGE_ORDER_VALUES_UPDATE='CHANGE_ORDER_VALUES_UPDATE';var CHANGE_ORDER_BACK='CHANGE_ORDER_BACK';var CHANGE_ORDER_CREATE_SUCCESS='CHANGE_ORDER_CREATE_SUCCESS';var CHANGE_ORDER_NEXT='CHANGE_ORDER_NEXT';var CHANGE_ORDER_APPROVAL_MODAL_CLOSE='CHANGE_ORDER_APPROVAL_MODAL_CLOSE';var CHANGE_ORDER_APPROVAL_SELECT='CHANGE_ORDER_APPROVAL_SELECT';var CHANGE_ORDER_SUCCESS_MODAL_OPEN='CHANGE_ORDER_SUCCESS_MODAL_OPEN';var CHANGE_ORDER_SUCCESS_MODAL_CLOSE='CHANGE_ORDER_SUCCESS_MODAL_CLOSE';var CHANGE_ORDER_PRINT_SUCCESS='CHANGE_ORDER_PRINT_SUCCESS';var CHANGE_ORDER_PDF_VIEWER_CLOSE='CHANGE_ORDER_PDF_VIEWER_CLOSE';var CHANGE_ORDER_EMAIL_MODAL_SHOW_SET='CHANGE_ORDER_EMAIL_MODAL_SHOW_SET';var CHANGE_ORDER_USERS_LOAD_SUCCESS='CHANGE_ORDER_USERS_LOAD_SUCCESS';var CHANGE_ORDER_SUBJECT_SET='CHANGE_ORDER_SUBJECT_SET';var CHANGE_ORDER_MESSAGE_SET='CHANGE_ORDER_MESSAGE_SET';var CHANGE_ORDER_EMAIL_ADD='CHANGE_ORDER_EMAIL_ADD';var CHANGE_ORDER_EMAIL_CLEAR='CHANGE_ORDER_EMAIL_CLEAR';var CHANGE_ORDER_EMAIL_REMOVE='CHANGE_ORDER_EMAIL_REMOVE';

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteMember;
/* unused harmony export invalidForm */
/* unused harmony export loadUsersRequest */
/* unused harmony export loadUsersSuccess */
/* harmony export (immutable) */ __webpack_exports__["b"] = setShowAddMemberModal;
/* harmony export (immutable) */ __webpack_exports__["c"] = setShowAddMemberModalRequest;
/* harmony export (immutable) */ __webpack_exports__["d"] = submitFormRequest;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateFormValue;
/* unused harmony export validForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_users_api__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_work_orders_api__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_api_work_orders_users_api__ = __webpack_require__(2197);
function deleteMember(memberId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5_services_api_work_orders_users_api__["a" /* workOrdersUsersApi */].deleteMember(memberId).then(function(response){if(response.ok){dispatch(removeMember(memberId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function invalidForm(invalidFields,message){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_2" /* WORK_ORDERS_DETAILS_ADD_MEMBER_FORM_INVALID */],payload:{invalidFields:invalidFields,message:message}};}function loadUsersRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_users_api__["b" /* usersApi */].getUsers().then(function(response){if(response.ok){dispatch(loadUsersSuccess(response.users));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadUsersSuccess(users){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_6" /* WORK_ORDERS_DETAILS_ADD_MEMBER_USERS_LOAD_SUCCESS */],payload:users};}function removeMember(memberId){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_59" /* WORK_ORDERS_DETAILS_MEMBERS_REMOVE */],payload:memberId};}function setShowAddMemberModal(open){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_5" /* WORK_ORDERS_DETAILS_ADD_MEMBER_MODAL_SHOW */],payload:open};}function setShowAddMemberModalRequest(){return function(dispatch){dispatch(loadUsersRequest()).then(function(response){if(response.ok){dispatch(setShowAddMemberModal(true));}});};}function submitFormRequest(workOrderId,form){return function(dispatch){// Validate form
var requiredFields=['userId'];var invalidFields=[];requiredFields.forEach(function(attribute){if(form[attribute]===''||form[attribute]===null){invalidFields.push(attribute);}});if(invalidFields.length>0){dispatch(invalidForm(invalidFields,'The outlined inputs should be added in order to add a member.'));}else{dispatch(validForm());//
return __WEBPACK_IMPORTED_MODULE_2_services_api_work_orders_api__["b" /* workOrdersApi */].addMember(workOrderId,form.userId,form.note).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_details__["a" /* addMember */])(response.member));dispatch(setShowAddMemberModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});}};}function updateFormValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_4" /* WORK_ORDERS_DETAILS_ADD_MEMBER_FORM_VALUE_UPDATE */],payload:{attribute:attribute,value:value}};}function validForm(){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_3" /* WORK_ORDERS_DETAILS_ADD_MEMBER_FORM_VALID */]};}

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSelectedProposalId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSelectedProposalNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getShowSuccessMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getSelectedProposalId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.proposalApproval.data.selectedProposalId;},function(selectedProposalId){return selectedProposalId;});var getSelectedProposalNumber=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.proposalApproval.data.selectedProposalNumber;},function(selectedProposalNumber){return selectedProposalNumber;});var getShowSuccessMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.proposalApproval.ui.showSuccessMessage;},function(showSuccessMessage){return showSuccessMessage;});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_object_assign__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Iframe = function (_a) {
    var url = _a.url, allowFullScreen = _a.allowFullScreen, position = _a.position, display = _a.display, height = _a.height, width = _a.width, overflow = _a.overflow, styles = _a.styles, onLoad = _a.onLoad, onMouseOver = _a.onMouseOver, onMouseOut = _a.onMouseOut, scrolling = _a.scrolling, id = _a.id, frameBorder = _a.frameBorder, ariaHidden = _a.ariaHidden, sandbox = _a.sandbox, allow = _a.allow, className = _a.className, title = _a.title, ariaLabel = _a.ariaLabel, ariaLabelledby = _a.ariaLabelledby, name = _a.name, target = _a.target, loading = _a.loading, importance = _a.importance, referrerpolicy = _a.referrerpolicy, allowpaymentrequest = _a.allowpaymentrequest, src = _a.src;
    var defaultProps = __WEBPACK_IMPORTED_MODULE_1_object_assign___default()({
        src: src || url,
        target: target || null,
        style: {
            position: position || null,
            display: display || "block",
            overflow: overflow || null
        },
        scrolling: scrolling || null,
        allowpaymentrequest: allowpaymentrequest || null,
        importance: importance || null,
        sandbox: sandbox || null,
        loading: loading || null,
        styles: styles || null,
        name: name || null,
        className: className || null,
        referrerpolicy: referrerpolicy || null,
        title: title || null,
        allow: allow || null,
        id: id || null,
        "aria-labelledby": ariaLabelledby || null,
        "aria-hidden": ariaHidden || null,
        "aria-label": ariaLabel || null,
        width: width || null,
        height: height || null,
        onLoad: onLoad || null,
        onMouseOver: onMouseOver || null,
        onMouseOut: onMouseOut || null
    });
    var props = Object.create(null);
    for (var _i = 0, _b = Object.keys(defaultProps); _i < _b.length; _i++) {
        var prop = _b[_i];
        if (defaultProps[prop] != null) {
            props[prop] = defaultProps[prop];
        }
    }
    for (var _c = 0, _d = Object.keys(props.style); _c < _d.length; _c++) {
        var i = _d[_c];
        if (props.style[i] == null) {
            delete props.style[i];
        }
    }
    if (allowFullScreen) {
        if ("allow" in props) {
            var currentAllow = props.allow.replace("fullscreen", "");
            props.allow = ("fullscreen " + currentAllow.trim()).trim();
        }
        else {
            props.allow = "fullscreen";
        }
    }
    if (frameBorder >= 0) {
        if (!props.style.hasOwnProperty("border")) {
            props.style.border = frameBorder;
        }
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", __assign({}, props));
};
/* harmony default export */ __webpack_exports__["a"] = (Iframe);


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close.42d63d0f.svg";

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getApprovedTasksId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getEmails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getShowApprovalConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getShowApproveReviewModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getShowEmailModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getShowPdfViewer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getSubject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getValuesByTaskId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getApprovedTasksId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.budget.ui.approvedTasksId;},function(approvedTasksId){return approvedTasksId;});var getCurrentView=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.budget.ui.currentView;},function(review){return review;});var getEmails=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.budget.ui.emails;},function(emails){return emails;});var getMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.budget.ui.message;},function(message){return message;});var getPdf=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.budget.ui.pdf;},function(pdf){return pdf;});var getShow=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.budget.ui.show;},function(show){return show;});var getShowApprovalConfirmation=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.budget.ui.showApprovalConfirmation;},function(showApprovalConfirmation){return showApprovalConfirmation;});var getShowApproveReviewModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.budget.ui.showApproveReviewModal;},function(showApproveReviewModal){return showApproveReviewModal;});var getShowEmailModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.budget.ui.showEmailModal;},function(showEmailModal){return showEmailModal;});var getShowPdfViewer=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.budget.ui.showPdfViewer;},function(showPdfViewer){return showPdfViewer;});var getSubject=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.budget.ui.subject;},function(subject){return subject;});var getUsers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.budget.data.users;},function(users){return users;});var getValuesByTaskId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.budget.ui.valuesByTaskId;},function(valuesByTaskId){return valuesByTaskId;});

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INVOICES_INVOICE_ATTRIBUTE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INVOICES_INVOICE_CUSTOM_EMAIL_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INVOICES_INVOICE_CUSTOM_EMAIL_VALIDATION_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INVOICES_INVOICE_EDIT_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INVOICES_INVOICE_EDIT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return INVOICES_INVOICE_EMAIL_MODAL_SHOW_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return INVOICES_INVOICE_EMAILS_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return INVOICES_INVOICE_EMAILS_USERS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return INVOICES_INVOICE_FORM_ATTRIBUTE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return INVOICES_INVOICE_FORM_INVALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return INVOICES_INVOICE_FORM_ITEM_LINE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return INVOICES_INVOICE_FORM_MISC_COST_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return INVOICES_INVOICE_FORM_MISC_COST_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return INVOICES_INVOICE_FORM_MISC_COST_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return INVOICES_INVOICE_FORM_VALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return INVOICES_INVOICE_ITEM_LINE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return INVOICES_INVOICE_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return INVOICES_INVOICE_PDF_VIEWER_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return INVOICES_INVOICE_PRINT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return INVOICES_INVOICE_SAVE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return INVOICES_INVOICE_USER_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return INVOICES_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return INVOICES_PAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return INVOICES_USERS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return INVOICES_TAB_SELECTION_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return INVOICES_SELECTED_STATUS_SET; });
var INVOICES_INVOICE_ATTRIBUTE_UPDATE='INVOICES_INVOICE_ATTRIBUTE_UPDATE';var INVOICES_INVOICE_CUSTOM_EMAIL_CHANGE='INVOICES_INVOICE_CUSTOM_EMAIL_CHANGE';var INVOICES_INVOICE_CUSTOM_EMAIL_VALIDATION_SET='INVOICES_INVOICE_CUSTOM_EMAIL_VALIDATION_SET';var INVOICES_INVOICE_EDIT_CANCEL='INVOICES_INVOICE_EDIT_CANCEL';var INVOICES_INVOICE_EDIT_SET='INVOICES_INVOICE_EDIT_SET';var INVOICES_INVOICE_EMAIL_MODAL_SHOW_SET='INVOICES_INVOICE_EMAIL_MODAL_SHOW_SET';var INVOICES_INVOICE_EMAILS_REMOVE='INVOICES_INVOICE_EMAILS_REMOVE';var INVOICES_INVOICE_EMAILS_USERS_ADD='INVOICES_INVOICE_EMAILS_USERS_ADD';var INVOICES_INVOICE_FORM_ATTRIBUTE_CHANGE='INVOICES_INVOICE_FORM_ATTRIBUTE_CHANGE';var INVOICES_INVOICE_FORM_INVALID='INVOICES_INVOICE_FORM_INVALID';var INVOICES_INVOICE_FORM_ITEM_LINE_CHANGE='INVOICES_INVOICE_FORM_ITEM_LINE_CHANGE';var INVOICES_INVOICE_FORM_MISC_COST_ADD='INVOICES_INVOICE_FORM_MISC_COST_ADD';var INVOICES_INVOICE_FORM_MISC_COST_CLEAR='INVOICES_INVOICE_FORM_MISC_COST_CLEAR';var INVOICES_INVOICE_FORM_MISC_COST_REMOVE='INVOICES_INVOICE_FORM_MISC_COST_REMOVE';var INVOICES_INVOICE_FORM_VALID='INVOICES_INVOICE_FORM_VALID';var INVOICES_INVOICE_ITEM_LINE_CHANGE='INVOICES_INVOICE_ITEM_LINE_CHANGE';var INVOICES_INVOICE_LOAD_SUCCESS='INVOICES_INVOICE_LOAD_SUCCESS';var INVOICES_INVOICE_PDF_VIEWER_CLOSE='INVOICES_INVOICE_PDF_VIEWER_CLOSE';var INVOICES_INVOICE_PRINT_SUCCESS='INVOICES_INVOICE_PRINT_SUCCESS';var INVOICES_INVOICE_SAVE_SHOW='INVOICES_INVOICE_SAVE_SHOW';var INVOICES_INVOICE_USER_SELECT='INVOICES_INVOICE_USER_SELECT';var INVOICES_LOAD_SUCCESS='INVOICES_LOAD_SUCCESS';var INVOICES_PAGE_CHANGE='INVOICES_PAGE_CHANGE';var INVOICES_USERS_LOAD_SUCCESS='INVOICES_USERS_LOAD_SUCCESS';var INVOICES_TAB_SELECTION_CHANGE='INVOICES_TAB_SELECTION_CHANGE';var INVOICES_SELECTED_STATUS_SET='INVOICES_SELECTED_STATUS_SET';

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generalContractorsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GeneralContractorsApi=function(_BaseApi){_inherits(GeneralContractorsApi,_BaseApi);function GeneralContractorsApi(){_classCallCheck(this,GeneralContractorsApi);return _possibleConstructorReturn(this,(GeneralContractorsApi.__proto__||Object.getPrototypeOf(GeneralContractorsApi)).apply(this,arguments));}_createClass(GeneralContractorsApi,[{key:'getGeneralContractor',value:function getGeneralContractor(generalContractorId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/general_contractors/'+generalContractorId).then(function(response){return{ok:true,generalContractor:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getGeneralContractors',value:function getGeneralContractors(page,status,name){var query='page='+(page||1);query+=status?'&'+status+'=true':'';query+=name?'&by_name='+name:'';return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/general_contractors?'+query).then(function(response){return{ok:true,generalContractors:{data:response.data,totalActive:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-active']).value(),totalInactive:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-inactive']).value(),total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createGeneralContractor',value:function createGeneralContractor(values){var data={general_contractor:{name:values.name,contact_attributes:{first_name:values.firstName,last_name:values.lastName,email:values.email,phone_number:values.phoneNumber},location_attributes:{street_address_1:values.streetAddress,street_address_2:values.unitNumber,city:values.city,state:values.state,zip:values.zipCode}}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/general_contractors',data).then(function(response){return{ok:true,generalContractor:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateGeneralContractor',value:function updateGeneralContractor(id,generalContractorData){var headers={headers:{'Content-Type':'multipart/form-data'}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/general_contractors/'+id,generalContractorData,headers).then(function(response){return{ok:true,generalContractor:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateGeneralContractorOnboardingData',value:function updateGeneralContractorOnboardingData(onboardingData){var data=new FormData();data.append('general_contractor[license_number]',onboardingData.licenceNumber);data.append('general_contractor[confirmed]',onboardingData.confirmed);data.append('general_contractor[logo_attributes][image]',onboardingData.companyLogo.image);return this.updateGeneralContractor(onboardingData.generalContractor.id,data);}},{key:'updateGeneralContractorTeam',value:function updateGeneralContractorTeam(generalContractor){var data=new FormData();data.append('general_contractor[name]',generalContractor.name);data.append('general_contractor[license_number]',generalContractor.licenceNumber);data.append('general_contractor[contact_attributes][first_name]',generalContractor.firstName);data.append('general_contractor[contact_attributes][last_name]',generalContractor.lastName);data.append('general_contractor[contact_attributes][email]',generalContractor.email);data.append('general_contractor[contact_attributes][phone_number]',generalContractor.phoneNumber);data.append('general_contractor[location_attributes][street_address_1]',generalContractor.streetAddress);data.append('general_contractor[location_attributes][street_address_2]',generalContractor.unitNumber);data.append('general_contractor[location_attributes][city]',generalContractor.city);data.append('general_contractor[location_attributes][state]',generalContractor.state);data.append('general_contractor[location_attributes][zip]',generalContractor.zipCode);data.append('general_contractor[confirmed]',true);var imageLogo=generalContractor.companyLogo.image;if(imageLogo&&imageLogo.name&&imageLogo.preview){data.append('general_contractor[logo_attributes][image]',imageLogo);}return this.updateGeneralContractor(generalContractor.id,data);}},{key:'getGeneralContractorProjects',value:function getGeneralContractorProjects(generalContractorId,page,status){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/general_contractors/'+generalContractorId+'/projects?page='+(page!==undefined?page:1)+(status?'&'+status+'=true':'')).then(function(response){return{ok:true,projects:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),totalPending:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-pending']).value(),totalInProgress:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-in_progress']).value(),totalComplete:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-complete']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getUsers',value:function getUsers(generalContractorId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/general_contractors/'+generalContractorId+'/users').then(function(response){return{ok:true,users:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return GeneralContractorsApi;}(__WEBPACK_IMPORTED_MODULE_1_services_api_base_api__["a" /* default */]);var generalContractorsApi=new GeneralContractorsApi();

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ACR_MISC_COST_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ACR_EDIT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ACR_SAVING_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACR_ADDITIONAL_COST_SET; });
/* unused harmony export ACR_ADDITIONAL_COST_DESC_SET */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACR_ADDITIONAL_COST_EDIT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACR_ADDITIONAL_COST_SAVING_SET; });
var ACR_MISC_COST_SET='ACR_MISC_COST_SET';var ACR_EDIT_SET='ACR_EDIT_SET';var ACR_SAVING_SET='ACR_SAVING_SET';var ACR_ADDITIONAL_COST_SET='ACR_ADDITIONAL_COST_SET';var ACR_ADDITIONAL_COST_DESC_SET='ACR_ADDITIONAL_COST_SET';var ACR_ADDITIONAL_COST_EDIT_SET='ACR_ADDITIONAL_COST_EDIT_SET';var ACR_ADDITIONAL_COST_SAVING_SET='ACR_ADDITIONAL_COST_SAVING_SET';

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConditionRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(51);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/**
 * Conditional routing, based on show argument.
 * @param Component
 * @param show
 * @param fallbackUrl
 * @param rest
 * @return {*}
 * @constructor
 */var ConditionRoute=function ConditionRoute(_ref){var Component=_ref.component,show=_ref.show,_ref$fallbackUrl=_ref.fallbackUrl,fallbackUrl=_ref$fallbackUrl===undefined?null:_ref$fallbackUrl,rest=_objectWithoutProperties(_ref,['component','show','fallbackUrl']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],Object.assign({},rest,{render:function render(props){return show?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,props):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Redirect */],{to:{pathname:fallbackUrl===null?'/':fallbackUrl}});}}));};

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONTRACTORS_CONTACTS_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONTRACTORS_CONTRACTOR_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CONTRACTORS_CONTRACTOR_WORK_ORDERS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CONTRACTORS_CONTRACTOR_WORK_ORDERS_PAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CONTRACTORS_EDIT_FORM_LOAD_FROM_CURRENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CONTRACTORS_INVOICES_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CONTRACTORS_CONTRACTOR_PROJECTS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CONTRACTORS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CONTRACTORS_NEW_CLEAR_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CONTRACTORS_NEW_FORM_INVALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CONTRACTORS_NEW_FORM_VALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CONTRACTORS_NEW_FORM_VALUE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CONTRACTORS_NEW_PARAMETERS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CONTRACTORS_NEW_SERVICE_AREA_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CONTRACTORS_NEW_TRADE_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CONTRACTORS_NEW_UNIONS_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CONTRACTORS_NEW_W9_DOCUMENT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CONTRACTORS_USERS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CONTRACTORS_MSA_SIGNING_URL_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CONTRACTORS_MSA_SIGNING_MODAL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CONTRACTORS_SET_PAGINATION_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CONTRACTORS_CONTRACTOR_ROLES_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONTRACTORS_CONTRACTOR_INVITE_USER_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CONTRACTORS_CONTRACTOR_USER_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CONTRACTORS_INVITE_FORM_CLEAR; });
var CONTRACTORS_CONTACTS_MODAL_SHOW='CONTRACTORS_CONTACTS_MODAL_SHOW';var CONTRACTORS_CONTRACTOR_LOAD_SUCCESS='CONTRACTORS_CONTRACTOR_LOAD_SUCCESS';var CONTRACTORS_CONTRACTOR_WORK_ORDERS_LOAD_SUCCESS='CONTRACTORS_CONTRACTOR_WORK_ORDERS_LOAD_SUCCESS';var CONTRACTORS_CONTRACTOR_WORK_ORDERS_PAGE_CHANGE='CONTRACTORS_CONTRACTOR_WORK_ORDERS_PAGE_CHANGE';var CONTRACTORS_EDIT_FORM_LOAD_FROM_CURRENT='CONTRACTORS_EDIT_FORM_LOAD_FROM_CURRENT';var CONTRACTORS_INVOICES_SET='CONTRACTORS_INVOICES_SET';var CONTRACTORS_CONTRACTOR_PROJECTS_LOAD_SUCCESS='CONTRACTORS_CONTRACTOR_PROJECTS_LOAD_SUCCESS';var CONTRACTORS_LOAD_SUCCESS='CONTRACTORS_LOAD_SUCCESS';var CONTRACTORS_NEW_CLEAR_DATA='CONTRACTORS_NEW_CLEAR_DATA';var CONTRACTORS_NEW_FORM_INVALID='CONTRACTORS_NEW_FORM_INVALID';var CONTRACTORS_NEW_FORM_VALID='CONTRACTORS_NEW_FORM_VALID';var CONTRACTORS_NEW_FORM_VALUE_CHANGE='CONTRACTORS_NEW_FORM_VALUE_CHANGE';var CONTRACTORS_NEW_PARAMETERS_LOAD_SUCCESS='CONTRACTORS_NEW_PARAMETERS_LOAD_SUCCESS';var CONTRACTORS_NEW_SERVICE_AREA_SELECT='CONTRACTORS_NEW_SERVICE_AREA_SELECT';var CONTRACTORS_NEW_TRADE_SELECT='CONTRACTORS_NEW_TRADE_SELECT';var CONTRACTORS_NEW_UNIONS_SELECT='CONTRACTORS_NEW_UNIONS_SELECT';var CONTRACTORS_NEW_W9_DOCUMENT_SET='CONTRACTORS_NEW_W9_DOCUMENT_SET';var CONTRACTORS_USERS_SET='CONTRACTORS_USERS_SET';var CONTRACTORS_MSA_SIGNING_URL_CHANGE='CONTRACTORS_MSA_SIGNING_URL_CHANGE';var CONTRACTORS_MSA_SIGNING_MODAL_HIDE='CONTRACTORS_MSA_SIGNING_MODAL_HIDE';var CONTRACTORS_SET_PAGINATION_DATA='CONTRACTORS_SET_PAGINATION_DATA';var CONTRACTORS_CONTRACTOR_ROLES_LOAD_SUCCESS='CONTRACTORS_CONTRACTOR_ROLES_LOAD_SUCCESS';var CONTRACTORS_CONTRACTOR_INVITE_USER_SHOW='CONTRACTORS_CONTRACTOR_INVITE_USER_SHOW';var CONTRACTORS_CONTRACTOR_USER_ADD='CONTRACTORS_CONTRACTOR_USER_ADD';var CONTRACTORS_INVITE_FORM_CLEAR='CONTRACTORS_INVITE_FORM_CLEAR';

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formatLastLogin */
/* harmony export (immutable) */ __webpack_exports__["a"] = ContactsModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_user_check_svg__ = __webpack_require__(2325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_user_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_user_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_close_png__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_close_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_close_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContactsModal_css__ = __webpack_require__(2326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContactsModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ContactsModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_text_util__ = __webpack_require__(29);
function handleClose(event,props){event.preventDefault();props.onClose();}function mapContacts(users){return users.map(function(user){return[user.primaryContact?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3_images_user_check_svg___default.a,alt:'primary-contact'}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small-bold'},user.name),user.title!==null?user.title:'N/A',user.email!==null?user.email:'N/A',user.phoneNumber!==null?Object(__WEBPACK_IMPORTED_MODULE_8_services_utils_text_util__["c" /* formatPhoneNumber */])(user.phoneNumber):'N/A',formatLastLogin(user.lastSignIn)];});}function formatLastLogin(lastLogin){var today=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var result='N/A';if(lastLogin!==null){var elapsedTime=Object(__WEBPACK_IMPORTED_MODULE_5_services_utils_date_util__["e" /* getRange */])(lastLogin,today);if(elapsedTime.years>0){result=elapsedTime.years+' '+(elapsedTime.years>1?'years':'year')+' ago';}else if(elapsedTime.months>0){result=elapsedTime.months+' '+(elapsedTime.months>1?'months':'month')+' ago';}else if(elapsedTime.days>0){result=elapsedTime.days+' '+(elapsedTime.days>1?'days':'day')+' ago';}else if(elapsedTime.hours>0){result=elapsedTime.hours+' '+(elapsedTime.hours>1?'hours':'hour')+' ago';}else if(elapsedTime.minutes>0){result=elapsedTime.minutes+' '+(elapsedTime.minutes>1?'minutes':'minute')+' ago';}else{result='0 minutes ago';}}return result;}function ContactsModal(props){var headers=['','NAME','TITLE','EMAIL','PHONE','LAST SIGN IN'];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */],{className:'contacts-modal',show:props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cm-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h1'},'Contacts'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6_images_close_png___default.a,alt:'close',onClick:function onClick(event){return handleClose(event,props);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__["a" /* default */],{className:'cm-contacts-table',headers:headers,rows:mapContacts(props.users),emptyMessage:'No Contacts'}))),props.footer!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */].Footer,null,props.footer));}ContactsModal.propTypes={footer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,users:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,lastSignIn:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,phoneNumber:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,primaryContact:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};ContactsModal.defaultProps={footer:null,users:[]};

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResourceWorkOrders_css__ = __webpack_require__(2328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResourceWorkOrders_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ResourceWorkOrders_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_table_WorkOrdersTable__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResourceWorkOrders=function(_Component){_inherits(ResourceWorkOrders,_Component);function ResourceWorkOrders(props){_classCallCheck(this,ResourceWorkOrders);// Keep track of id to avoid showing an "old" resource while loading the current one
var _this=_possibleConstructorReturn(this,(ResourceWorkOrders.__proto__||Object.getPrototypeOf(ResourceWorkOrders)).call(this,props));_this.handleWorkOrderSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_work_orders__["h" /* goToWorkOrder */])(_this.props.workOrders.content[index].id));};_this.handleNavSelect=function(value){_this.currentNav=value;_this.handleChange(1);};_this.handlePageChange=function(newPage){_this.handleChange(newPage);};_this.currentNav=1;return _this;}_createClass(ResourceWorkOrders,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,resource=_props.resource,loadWorkOrdersRequest=_props.loadWorkOrdersRequest;if(resource!==null){this.props.dispatch(loadWorkOrdersRequest(resource.id,1));}}},{key:'handleChange',value:function handleChange(page){var _props2=this.props,dispatch=_props2.dispatch,resource=_props2.resource,loadWorkOrdersRequest=_props2.loadWorkOrdersRequest;switch(this.currentNav){case 1:dispatch(loadWorkOrdersRequest(resource.id,page));break;case 2:dispatch(loadWorkOrdersRequest(resource.id,page,undefined,true));break;case 3:dispatch(loadWorkOrdersRequest(resource.id,page,__WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].DRAFT));break;case 4:dispatch(loadWorkOrdersRequest(resource.id,page,__WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].PENDING));break;case 5:dispatch(loadWorkOrdersRequest(resource.id,page,__WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].PLM));break;case 6:dispatch(loadWorkOrdersRequest(resource.id,page,__WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].WOA));break;case 7:dispatch(loadWorkOrdersRequest(resource.id,page,__WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].IN_PROGRESS));break;case 8:dispatch(loadWorkOrdersRequest(resource.id,page,__WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].COMPLETE));break;case 9:dispatch(loadWorkOrdersRequest(resource.id,page,__WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].CLOSED));break;case 10:dispatch(loadWorkOrdersRequest(resource.id,page,__WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].DECLINED));break;default:}}},{key:'render',value:function render(){var _props3=this.props,resource=_props3.resource,currentPage=_props3.currentPage,workOrders=_props3.workOrders;if(resource!==null&&workOrders!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resource-work-orders'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'All'},{id:2,show:workOrders.totalCritical>0,title:'Critical',total:workOrders.totalCritical},{id:3,show:workOrders.totalDraft>0,title:'Draft',total:workOrders.totalDraft},{id:4,show:workOrders.totalPending>0,title:'Pending',total:workOrders.totalPending},{id:5,show:workOrders.totalPlm>0,title:'PLM',total:workOrders.totalPlm},{id:6,show:workOrders.totalWoa>0,title:'WOA',total:workOrders.totalWoa},{id:7,show:workOrders.totalInProgress>0,title:'In Progress',total:workOrders.totalInProgress},{id:8,show:workOrders.totalComplete>0,title:'Complete',total:workOrders.totalComplete},{id:9,show:workOrders.totalClosed>0,title:'Closed',total:workOrders.totalClosed},{id:10,show:workOrders.totalDeclined>0,title:'Declined',total:workOrders.totalDeclined}],onSelected:this.handleNavSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_table_WorkOrdersTable__["a" /* default */],{currentPage:currentPage,pageSize:workOrders.pageSize,showFilter:false,totals:{all:workOrders.total},total:workOrders.total,workOrders:workOrders.content,onPageChange:this.handlePageChange,onWorkOrderSelection:this.handleWorkOrderSelection}));}return null;}}]);return ResourceWorkOrders;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ResourceWorkOrders.propTypes={resource:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),workOrders:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),currentPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,loadWorkOrdersRequest:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(ResourceWorkOrders));

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResourceProjects_css__ = __webpack_require__(2334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResourceProjects_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ResourceProjects_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_SimpleText__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_project_status_ProjectStatus__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_domain_project_status_enum__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_store_actions__ = __webpack_require__(162);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResourceProjects=function(_Component){_inherits(ResourceProjects,_Component);function ResourceProjects(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ResourceProjects);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ResourceProjects.__proto__||Object.getPrototypeOf(ResourceProjects)).call.apply(_ref,[this].concat(args))),_this),_this.mapProjects=function(projects){return projects.map(function(project){return[project.number,project.name,project.client.company_name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_SimpleText__["a" /* default */],{lines:[project.building.location.street_address_1,project.building.location.city]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_project_status_ProjectStatus__["a" /* default */],{status:__WEBPACK_IMPORTED_MODULE_8_domain_project_status_enum__["a" /* ProjectStatusEnum */].create(project.status)})].filter(function(attr){return attr;});});},_this.handleProjectsRowSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_store_actions__["f" /* goToProjectDetails */])(_this.props.projects.content[index].id));},_this.handleProjectsPageChange=function(newPage){var _this$props=_this.props,resource=_this$props.resource,loadProjectsRequest=_this$props.loadProjectsRequest;_this.props.dispatch(loadProjectsRequest(resource.id,newPage));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ResourceProjects,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,resource=_props.resource,loadProjectsRequest=_props.loadProjectsRequest;if(resource!==null){this.props.dispatch(loadProjectsRequest(resource.id,1));}}},{key:'render',value:function render(){var _props2=this.props,resource=_props2.resource,currentPage=_props2.currentPage,projects=_props2.projects;if(resource!==null&&projects!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resource-projects'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table',headers:['PROJECT #','NAME','CLIENT NAME','LOCATION','STATUS'].filter(function(header){return header;}),rows:this.mapProjects(projects.content),emptyMessage:'No Projects',onRowSelected:this.handleProjectsRowSelection}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPage,pageSize:projects.pageSize,total:projects.total,onPageChange:this.handleProjectsPageChange})));}return null;}}]);return ResourceProjects;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ResourceProjects.propTypes={resource:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),projects:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),currentPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,loadProjectsRequest:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(ResourceProjects));

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PROJECTS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PROJECTS_MISSING_DRS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROJECTS_BIDS_DUE_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PROJECTS_PAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PROJECTS_MISSING_DRS_PAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PROJECTS_BIDS_DUE_PAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PROJECTS_NAV_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PROJECTS_MISSING_DRS_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECTS_BIDS_DUE_COUNT; });
var PROJECTS_LOAD_SUCCESS='PROJECTS_LOAD_SUCCESS';var PROJECTS_MISSING_DRS_LOAD_SUCCESS='PROJECTS_MISSING_DRS_LOAD_SUCCESS';var PROJECTS_BIDS_DUE_LOAD_SUCCESS='PROJECTS_BIDS_DUE_LOAD_SUCCESS';var PROJECTS_PAGE_CHANGE='PROJECTS_PAGE_CHANGE';var PROJECTS_MISSING_DRS_PAGE_CHANGE='PROJECTS_MISSING_DRS_PAGE_CHANGE';var PROJECTS_BIDS_DUE_PAGE_CHANGE='PROJECTS_BIDS_DUE_PAGE_CHANGE';var PROJECTS_NAV_CHANGE='PROJECTS_NAV_CHANGE';var PROJECTS_MISSING_DRS_COUNT='PROJECTS_MISSING_DRS_COUNT';var PROJECTS_BIDS_DUE_COUNT='PROJECTS_BIDS_DUE_COUNT';

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BUILDINGS_BUILDING_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BUILDINGS_BUILDING_WORK_ORDERS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BUILDINGS_BUILDING_WORK_ORDERS_PAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BUILDINGS_BUILDING_PROJECTS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUILDINGS_BUILDING_CLIENTS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BUILDINGS_EDIT_FORM_LOAD_FROM_CURRENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BUILDINGS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BUILDINGS_NEW_CLEAR_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BUILDINGS_NEW_CLIENT_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return BUILDINGS_NEW_CLIENT_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return BUILDINGS_NEW_CONTRACTOR_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return BUILDINGS_NEW_CONTRACTOR_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return BUILDINGS_NEW_ENGINEER_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return BUILDINGS_NEW_FILES_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return BUILDINGS_NEW_FILE_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return BUILDINGS_NEW_FORM_INVALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return BUILDINGS_NEW_FORM_VALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return BUILDINGS_NEW_FORM_VALUE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return BUILDINGS_NEW_UNIONS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return BUILDINGS_NEW_PARKING_ON_SITE_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return BUILDINGS_NEW_UNIONS_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return BUILDINGS_SET_PAGINATION_DATA; });
var BUILDINGS_BUILDING_LOAD_SUCCESS='BUILDINGS_BUILDING_LOAD_SUCCESS';var BUILDINGS_BUILDING_WORK_ORDERS_LOAD_SUCCESS='BUILDINGS_BUILDING_WORK_ORDERS_LOAD_SUCCESS';var BUILDINGS_BUILDING_WORK_ORDERS_PAGE_CHANGE='BUILDINGS_BUILDING_WORK_ORDERS_PAGE_CHANGE';var BUILDINGS_BUILDING_PROJECTS_LOAD_SUCCESS='BUILDINGS_BUILDING_PROJECTS_LOAD_SUCCESS';var BUILDINGS_BUILDING_CLIENTS_LOAD_SUCCESS='BUILDINGS_BUILDING_CLIENTS_LOAD_SUCCESS';var BUILDINGS_EDIT_FORM_LOAD_FROM_CURRENT='BUILDINGS_EDIT_FORM_LOAD_FROM_CURRENT';var BUILDINGS_LOAD_SUCCESS='BUILDINGS_LOAD_SUCCESS';var BUILDINGS_NEW_CLEAR_DATA='BUILDINGS_NEW_CLEAR_DATA';var BUILDINGS_NEW_CLIENT_REMOVE='BUILDINGS_NEW_CLIENT_REMOVE';var BUILDINGS_NEW_CLIENT_SELECT='BUILDINGS_NEW_CLIENT_SELECT';var BUILDINGS_NEW_CONTRACTOR_REMOVE='BUILDINGS_NEW_CONTRACTOR_REMOVE';var BUILDINGS_NEW_CONTRACTOR_SELECT='BUILDINGS_NEW_CONTRACTOR_SELECT';var BUILDINGS_NEW_ENGINEER_ADD='BUILDINGS_NEW_ENGINEER_ADD';var BUILDINGS_NEW_FILES_ADD='BUILDINGS_NEW_FILES_ADD';var BUILDINGS_NEW_FILE_REMOVE='BUILDINGS_NEW_FILE_REMOVE';var BUILDINGS_NEW_FORM_INVALID='BUILDINGS_NEW_FORM_INVALID';var BUILDINGS_NEW_FORM_VALID='BUILDINGS_NEW_FORM_VALID';var BUILDINGS_NEW_FORM_VALUE_CHANGE='BUILDINGS_NEW_FORM_VALUE_CHANGE';var BUILDINGS_NEW_UNIONS_LOAD_SUCCESS='BUILDINGS_NEW_UNIONS_LOAD_SUCCESS';var BUILDINGS_NEW_PARKING_ON_SITE_SELECT='BUILDINGS_NEW_PARKING_ON_SITE_SELECT';var BUILDINGS_NEW_UNIONS_SELECT='BUILDINGS_NEW_UNIONS_SELECT';var BUILDINGS_SET_PAGINATION_DATA='BUILDINGS_SET_PAGINATION_DATA';

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLIENTS_CLIENT_BUILDINGS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLIENTS_CLIENT_FILTER_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLIENTS_CLIENT_INVITE_USER_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLIENTS_CLIENT_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLIENTS_CLIENT_INVOICES_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CLIENTS_CLIENT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CLIENTS_CLIENT_NOTE_EDITOR_EDIT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CLIENTS_CLIENT_NOTE_EDITOR_REMINDER_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CLIENTS_CLIENT_NOTE_EDITOR_SAVING_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CLIENTS_CLIENT_NOTE_EDITOR_TEXT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CLIENTS_CLIENT_PAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CLIENTS_CLIENT_PURCHASE_ORDERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CLIENTS_CLIENT_ROLES_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CLIENTS_CLIENT_SURVEYS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CLIENTS_CLIENT_USERS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CLIENTS_CLIENT_WORK_ORDERS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CLIENTS_CONTACTS_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CLIENTS_INVITE_ATTRIBUTE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CLIENTS_INVITE_CLIENT_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CLIENTS_INVITE_FORM_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CLIENTS_INVITE_FORM_INVALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CLIENTS_INVITE_FORM_VALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CLIENTS_INVITE_USER_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CLIENTS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CLIENTS_USERS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CLIENTS_SET_PAGINATION_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLIENTS_ADD_TO_BEGINNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CLIENTS_CLIENT_PROJECTS_LOAD_SUCCESS; });
var CLIENTS_CLIENT_BUILDINGS_LOAD_SUCCESS='CLIENTS_CLIENT_BUILDINGS_LOAD_SUCCESS';var CLIENTS_CLIENT_FILTER_CHANGE='CLIENTS_CLIENT_FILTER_CHANGE';var CLIENTS_CLIENT_INVITE_USER_SHOW='CLIENTS_CLIENT_INVITE_USER_SHOW';var CLIENTS_CLIENT_LOAD_SUCCESS='CLIENTS_CLIENT_LOAD_SUCCESS';var CLIENTS_CLIENT_INVOICES_LOAD_SUCCESS='CLIENTS_CLIENT_INVOICES_LOAD_SUCCESS';var CLIENTS_CLIENT_SET='CLIENTS_CLIENT_SET';var CLIENTS_CLIENT_NOTE_EDITOR_EDIT_SET='CLIENTS_CLIENT_NOTE_EDITOR_EDIT_SET';var CLIENTS_CLIENT_NOTE_EDITOR_REMINDER_CHANGE='CLIENTS_CLIENT_NOTE_EDITOR_REMINDER_CHANGE';var CLIENTS_CLIENT_NOTE_EDITOR_SAVING_SET='CLIENTS_CLIENT_NOTE_EDITOR_SAVING_SET';var CLIENTS_CLIENT_NOTE_EDITOR_TEXT_CHANGE='CLIENTS_CLIENT_NOTE_EDITOR_TEXT_CHANGE';var CLIENTS_CLIENT_PAGE_CHANGE='CLIENTS_CLIENT_PAGE_CHANGE';var CLIENTS_CLIENT_PURCHASE_ORDERS_SUCCESS='CLIENTS_CLIENT_PURCHASE_ORDERS_SUCCESS';var CLIENTS_CLIENT_ROLES_LOAD_SUCCESS='CLIENTS_CLIENT_ROLES_LOAD_SUCCESS';var CLIENTS_CLIENT_SURVEYS_LOAD_SUCCESS='CLIENTS_CLIENT_SURVEYS_LOAD_SUCCESS';var CLIENTS_CLIENT_USERS_ADD='CLIENTS_CLIENT_USERS_ADD';var CLIENTS_CLIENT_WORK_ORDERS_LOAD_SUCCESS='CLIENTS_CLIENT_WORK_ORDERS_LOAD_SUCCESS';var CLIENTS_CONTACTS_MODAL_SHOW='CLIENTS_CONTACTS_MODAL_SHOW';var CLIENTS_INVITE_ATTRIBUTE_CHANGE='CLIENTS_INVITE_ATTRIBUTE_CHANGE';var CLIENTS_INVITE_CLIENT_ADD='CLIENTS_INVITE_CLIENT_ADD';var CLIENTS_INVITE_FORM_CLEAR='CLIENTS_INVITE_FORM_CLEAR';var CLIENTS_INVITE_FORM_INVALID='CLIENTS_INVITE_FORM_INVALID';var CLIENTS_INVITE_FORM_VALID='CLIENTS_INVITE_FORM_VALID';var CLIENTS_INVITE_USER_MODAL_SHOW='CLIENTS_INVITE_USER_MODAL_SHOW';var CLIENTS_LOAD_SUCCESS='CLIENTS_LOAD_SUCCESS';var CLIENTS_USERS_SET='CLIENTS_USERS_SET';var CLIENTS_SET_PAGINATION_DATA='CLIENTS_SET_PAGINATION_DATA';var CLIENTS_ADD_TO_BEGINNING='CLIENTS_ADD_TO_BEGINNING';var CLIENTS_CLIENT_PROJECTS_LOAD_SUCCESS='CLIENTS_CLIENT_PROJECTS_LOAD_SUCCESS';

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SurveyRating;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SurveyRating_css__ = __webpack_require__(2362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SurveyRating_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SurveyRating_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_star_dark_gray_svg__ = __webpack_require__(2363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_star_dark_gray_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_star_dark_gray_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_star_gray_svg__ = __webpack_require__(2364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_star_gray_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_star_gray_svg__);
function SurveyRating(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'survey-rating'},props.rating===null||props.rating===0?props.showWaiting?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'waiting'},'Waiting'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'N/A'):[1,2,3].map(function(rating){if(rating<=props.rating){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:rating,src:__WEBPACK_IMPORTED_MODULE_3_images_star_dark_gray_svg___default.a,alt:'start-dark-gray'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:rating,src:__WEBPACK_IMPORTED_MODULE_4_images_star_gray_svg___default.a,alt:'start-gray'});}));}SurveyRating.propTypes={rating:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf([0,1,2,3]),showWaiting:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};SurveyRating.defaultProps={rating:0,showWaiting:true};

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SURVEYS_PAGINATION_INFO_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SURVEYS_PAGINATION_PAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SURVEYS_TOTAL_PENDING_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SURVEYS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SURVEYS_SURVEY_FORM_ATTRIBUTE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SURVEYS_SURVEY_FORM_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SURVEYS_SURVEY_FORM_VALIDATION_MESSAGE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SURVEYS_SURVEY_SET; });
var SURVEYS_PAGINATION_INFO_SET='SURVEYS_PAGINATION_INFO_SET';var SURVEYS_PAGINATION_PAGE_CHANGE='SURVEYS_PAGINATION_PAGE_CHANGE';var SURVEYS_TOTAL_PENDING_SET='SURVEYS_TOTAL_PENDING_SET';var SURVEYS_SET='SURVEYS_SET';var SURVEYS_SURVEY_FORM_ATTRIBUTE_CHANGE='SURVEYS_SURVEY_FORM_ATTRIBUTE_CHANGE';var SURVEYS_SURVEY_FORM_SET='SURVEYS_SURVEY_FORM_SET';var SURVEYS_SURVEY_FORM_VALIDATION_MESSAGE_SET='SURVEYS_SURVEY_FORM_VALIDATION_MESSAGE_SET';var SURVEYS_SURVEY_SET='SURVEYS_SURVEY_SET';

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currentSurveySelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return paginationInfoSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pendingTotalSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return showValidationMessageSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return surveyFormSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return surveysSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var currentSurveySelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.surveys.data.currentSurvey;},function(currentSurvey){return currentSurvey;});var paginationInfoSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.surveys.ui.paginationInfo;},function(paginationInfo){return paginationInfo;});var pendingTotalSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.surveys.ui.pendingTotal;},function(pendingTotal){return pendingTotal;});var showValidationMessageSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.surveys.ui.showValidationMessage;},function(showValidationMessage){return showValidationMessage;});var surveyFormSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.surveys.ui.surveyForm;},function(surveyForm){return surveyForm;});var surveysSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.surveys.data.surveys;},function(surveys){return surveys;});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = closeModal;
/* unused harmony export changePage */
/* harmony export (immutable) */ __webpack_exports__["b"] = loadQuotesRequest;
/* unused harmony export loadQuotesSuccess */
/* harmony export (immutable) */ __webpack_exports__["c"] = quotesCount;
/* unused harmony export quotesCountSuccess */
/* harmony export (immutable) */ __webpack_exports__["d"] = selectQuoteRequest;
/* unused harmony export selectQuoteSucess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_quotes_api__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_tasks_api__ = __webpack_require__(140);
function closeModal(){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["c" /* QUOTES_MODAL_CLOSE */]};}function changePage(newPage){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["d" /* QUOTES_PAGE_CHANGE */],payload:newPage};}function loadQuotesRequest(page,waiting,denied,agg,perPage){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__services_api_quotes_api__["a" /* quotesApi */].getQuotes(page,waiting,denied,agg,perPage).then(function(response){if(response.ok){dispatch(loadQuotesSuccess(response.quotes));dispatch(changePage(page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadQuotesSuccess(quotes){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["b" /* QUOTES_LOAD_SUCCESS */],payload:quotes};}function quotesCount(filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__services_api_quotes_api__["a" /* quotesApi */].getQuotesCount(filters).then(function(response){if(response.ok){dispatch(quotesCountSuccess(response.count));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}});};}function quotesCountSuccess(count){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["a" /* QUOTES_COUNT_SUCCESS */],payload:count};}function selectQuoteRequest(quoteIndex,taskId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3__services_api_tasks_api__["b" /* tasksApi */].getTask(taskId).then(function(response){if(response.ok){dispatch(selectQuoteSucess(quoteIndex,response.task.images.map(function(image){return{id:image.id,url:image.image.url,preview:image.image.preview.url};})));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}});};}function selectQuoteSucess(quoteIndex,images){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["e" /* QUOTES_SELECTION_SUCCESS */],payload:{quoteIndex:quoteIndex,images:images}};}

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return QUOTES_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QUOTES_COUNT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return QUOTES_MODAL_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return QUOTES_PAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return QUOTES_SELECTION_SUCCESS; });
var QUOTES_LOAD_SUCCESS='QUOTES_LOAD_SUCCESS';var QUOTES_COUNT_SUCCESS='QUOTES_COUNT_SUCCESS';var QUOTES_MODAL_CLOSE='QUOTES_MODAL_CLOSE';var QUOTES_PAGE_CHANGE='QUOTES_PAGE_CHANGE';var QUOTES_SELECTION_SUCCESS='QUOTES_SELECTION_SUCCESS';

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getQuotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getQuotesCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSelectedQuoteIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getTaskImages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getQuotes=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.quotes.data.quotes;},function(quotes){return quotes;});var getQuotesCount=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.quotes.data.quotesCount;},function(quotesCount){return quotesCount;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.quotes.ui.currentPage;},function(currentPage){return currentPage;});var getSelectedQuoteIndex=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.quotes.ui.selectedQuoteIndex;},function(selectedQuoteIndex){return selectedQuoteIndex;});var getTaskImages=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.quotes.ui.taskImages;},function(taskImages){return taskImages;});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TASKS_CONTRACTOR_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TASKS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TASKS_PAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TASKS_TRADES_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TASKS_TRADES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TASKS_UI_INITIALIZE; });
var TASKS_CONTRACTOR_SELECT='TASKS_CONTRACTOR_SELECT';var TASKS_LOAD_SUCCESS='TASKS_LOAD_SUCCESS';var TASKS_PAGE_CHANGE='TASKS_PAGE_CHANGE';var TASKS_TRADES_SELECT='TASKS_TRADES_SELECT';var TASKS_TRADES_SUCCESS='TASKS_TRADES_SUCCESS';var TASKS_UI_INITIALIZE='TASKS_UI_INITIALIZE';

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DEPOSITS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEPOSITS_DEPOSIT_ATTRIBUTE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DEPOSITS_PAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEPOSITS_DEPOSIT_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DEPOSITS_DEPOSIT_PRINT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DEPOSITS_DEPOSIT_PDF_VIEWER_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DEPOSITS_USERS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEPOSITS_DEPOSIT_EMAIL_MODAL_SHOW_SET; });
var DEPOSITS_LOAD_SUCCESS='DEPOSITS_LOAD_SUCCESS';var DEPOSITS_DEPOSIT_ATTRIBUTE_UPDATE='DEPOSITS_DEPOSIT_ATTRIBUTE_UPDATE';var DEPOSITS_PAGE_CHANGE='DEPOSITS_PAGE_CHANGE';var DEPOSITS_DEPOSIT_LOAD_SUCCESS='DEPOSITS_DEPOSIT_LOAD_SUCCESS';var DEPOSITS_DEPOSIT_PRINT_SUCCESS='DEPOSITS_DEPOSIT_PRINT_SUCCESS';var DEPOSITS_DEPOSIT_PDF_VIEWER_CLOSE='DEPOSITS_DEPOSIT_PDF_VIEWER_CLOSE';var DEPOSITS_USERS_LOAD_SUCCESS='DEPOSITS_USERS_LOAD_SUCCESS';var DEPOSITS_DEPOSIT_EMAIL_MODAL_SHOW_SET='DEPOSITS_DEPOSIT_EMAIL_MODAL_SHOW_SET';

/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GENERAL_CONTRACTORS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GENERAL_CONTRACTORS_PAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NEXT_STAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LICENCE_NUMBER_VALUE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NEW_ONBOARDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPANY_LOGO_FILE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GENERAL_CONTRACTOR_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GENERAL_CONTRACTOR_ONBOARDING_STAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GENERAL_CONTRACTOR_PROJECTS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GENERAL_CONTRACTOR_PROJECTS_PAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GENERAL_CONTRACTORS_CONTACTS_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GENERAL_CONTRACTORS_USERS_SET; });
var GENERAL_CONTRACTORS_LOAD_SUCCESS='GENERAL_CONTRACTORS_LOAD_SUCCESS';var GENERAL_CONTRACTORS_PAGE_CHANGE='GENERAL_CONTRACTORS_PAGE_CHANGE';var NEXT_STAGE='NEXT_STAGE';var LICENCE_NUMBER_VALUE_CHANGE='LICENCE_NUMBER_VALUE_CHANGE';var NEW_ONBOARDING='NEW_ONBOARDING';var COMPANY_LOGO_FILE_SET='COMPANY_LOGO_FILE_SET';var GENERAL_CONTRACTOR_LOAD_SUCCESS='GENERAL_CONTRACTOR_LOAD_SUCCESS';var GENERAL_CONTRACTOR_ONBOARDING_STAGE_CHANGE='GENERAL_CONTRACTOR_ONBOARDING_STAGE_CHANGE';var GENERAL_CONTRACTOR_PROJECTS_LOAD_SUCCESS='GENERAL_CONTRACTOR_PROJECTS_LOAD_SUCCESS';var GENERAL_CONTRACTOR_PROJECTS_PAGE_CHANGE='GENERAL_CONTRACTOR_PROJECTS_PAGE_CHANGE';var GENERAL_CONTRACTORS_CONTACTS_MODAL_SHOW='GENERAL_CONTRACTORS_CONTACTS_MODAL_SHOW';var GENERAL_CONTRACTORS_USERS_SET='GENERAL_CONTRACTORS_USERS_SET';

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_GeneralContractorForm_css__ = __webpack_require__(2437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_GeneralContractorForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_GeneralContractorForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_logo_upload_LogoUpload__ = __webpack_require__(102);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GeneralContractorForm=function(_Component){_inherits(GeneralContractorForm,_Component);function GeneralContractorForm(props){_classCallCheck(this,GeneralContractorForm);var _this=_possibleConstructorReturn(this,(GeneralContractorForm.__proto__||Object.getPrototypeOf(GeneralContractorForm)).call(this,props));_initialiseProps.call(_this);_this.logos=[];var logo=_this.props.initialValues?_this.props.initialValues.companyLogo:null;if(logo&&logo.image!==''){logo.url=logo.image.url;_this.logos=[logo];}return _this;}_createClass(GeneralContractorForm,[{key:'render',value:function render(){var edit=!!this.props.initialValues;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'new-general-contractor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},' ',edit?'Edit':'Invite',' General Contractor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8,lg:8,className:'new-general-contractor-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.props.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2'},'Company Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'name',placeholder:'Company Name',type:'text'})),edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'licenceNumber',placeholder:'Licence Number',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'firstName',placeholder:'Contact First Name',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'lastName',placeholder:'Contact Last Name',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'email',placeholder:'Email',type:'email'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'phoneNumber',placeholder:'Phone Number',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'streetAddress',placeholder:'Street Address',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'unitNumber',placeholder:'Unit number / Floor',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'city',placeholder:'City',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'state',placeholder:'State',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'zipCode',placeholder:'Zip Code',type:'text'}))),this.props.invalid&&this.props.submitFailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'The outlined inputs should be added in order to create a General Contractor.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'submit',value:edit?'Save':'Send Invite'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:12,lg:12,className:'special-note'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'special-note-title'},edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Company Logo')),edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.logoComponent,name:'companyLogo'}))));}}]);return GeneralContractorForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.setLogo=function(props,files){var file=files[0];var logo={url:URL.createObjectURL(file),file:file,image:file};_this2.logos=[logo];props.input.onChange(_this2.logos[0]);};this.removeLogo=function(props,index){_this2.logos=[];props.input.onChange(null);};this.logoComponent=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''+(props.meta.error&&props.meta.submitFailed?'dropzone-with-error':'highlighted')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_logo_upload_LogoUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],logos:_this2.logos,onRemove:function onRemove(index){return _this2.removeLogo(props,index);},onUpload:function onUpload(files){return _this2.setLogo(props,files);},useDropzone:true}));};this.renderInput=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_input_Input__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));};};function validate(values){var errors={};if(!values.name){errors.name='Required';}if(!values.licenceNumber){errors.licenceNumber='Required';}if(!values.firstName){errors.firstName='Required';}if(!values.lastName){errors.lastName='Required';}if(!values.email){errors.email='Required';}if(!values.phoneNumber){errors.phoneNumber='Required';}if(!values.streetAddress){errors.streetAddress='Required';}if(!values.city){errors.city='Required';}if(!values.state){errors.state='Required';}if(!values.zipCode){errors.zipCode='Required';}if(!values.companyLogo){errors.companyLogo='Required';}return errors;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["f" /* reduxForm */])({form:'GeneralContractorForm',validate:validate})(GeneralContractorForm));

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addUser */
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteUserRequest;
/* unused harmony export editUser */
/* unused harmony export invalidForm */
/* harmony export (immutable) */ __webpack_exports__["b"] = loadRolesRequest;
/* unused harmony export loadRolesSuccess */
/* harmony export (immutable) */ __webpack_exports__["c"] = loadUserForm;
/* harmony export (immutable) */ __webpack_exports__["d"] = loadUsersRequest;
/* unused harmony export loadUsersSuccess */
/* unused harmony export removeUser */
/* harmony export (immutable) */ __webpack_exports__["e"] = setCurrentUserId;
/* harmony export (immutable) */ __webpack_exports__["f"] = setShowInviteUserModal;
/* harmony export (immutable) */ __webpack_exports__["g"] = submitFormRequest;
/* harmony export (immutable) */ __webpack_exports__["h"] = updateFormValue;
/* unused harmony export validForm */
/* harmony export (immutable) */ __webpack_exports__["i"] = updateTermsAndConditions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_users_api__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_authentication_js__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api_roles_api__ = __webpack_require__(225);
function addUser(user){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["i" /* USERS_USER_ADD */],payload:user};}function deleteUserRequest(userId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__services_api_users_api__["b" /* usersApi */].removeUser(userId).then(function(response){if(response.ok){dispatch(removeUser(userId));dispatch(setShowInviteUserModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}});};}function editUser(user){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["j" /* USERS_USER_EDIT */],payload:user};}function invalidForm(invalidFields,message){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["a" /* USERS_INVITE_USER_FORM_INVALID */],payload:{invalidFields:invalidFields,message:message}};}function loadRolesRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4__services_api_roles_api__["b" /* rolesApi */].getRoles().then(function(response){if(response.ok){dispatch(loadRolesSuccess(response.permissions));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadRolesSuccess(roles){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["g" /* USERS_INVITE_USER_ROLES_LOAD_SUCCESS */],payload:roles};}function loadUserForm(user){return function(dispatch){var form=void 0;if(user!==null){form={firstName:user.first_name,lastName:user.last_name,email:user.email,phoneNumber:user.phone_number!=null?user.phone_number:'',rolesId:user.roles.length>0?user.roles[0].id:null,// Only one role can be defined
title:user.title!==null?user.title:''};}else{form={firstName:'',lastName:'',email:'',phoneNumber:'',rolesId:null,title:''};}dispatch({type:__WEBPACK_IMPORTED_MODULE_2__action_types__["b" /* USERS_INVITE_USER_FORM_LOAD */],payload:form});};}function loadUsersRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__services_api_users_api__["b" /* usersApi */].getUsers().then(function(response){if(response.ok){dispatch(loadUsersSuccess(response.users));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadUsersSuccess(users){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["h" /* USERS_LOAD_SUCCESS */],payload:users};}function removeUser(userId){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["k" /* USERS_USER_REMOVE */],payload:userId};}function setCurrentUserId(userId){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["e" /* USERS_INVITE_USER_ID_SET */],payload:userId};}function setShowInviteUserModal(open,state){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["f" /* USERS_INVITE_USER_MODAL_SHOW */],payload:{open:open,state:state?state:undefined}};}function submitFormRequest(form,currentUserId){return function(dispatch){// Validate form
var requiredFields=['firstName','lastName','email','phoneNumber','rolesId'];var invalidFields=[];requiredFields.forEach(function(attribute){if(form[attribute]===''||form[attribute]===null){invalidFields.push(attribute);}});if(invalidFields.length>0){dispatch(invalidForm(invalidFields,'The outlined inputs should be added in order to invite a user.'));return null;}else{dispatch(validForm());if(currentUserId===0){return __WEBPACK_IMPORTED_MODULE_1__services_api_users_api__["b" /* usersApi */].addUser(form.firstName,form.lastName,form.email,form.phoneNumber,[form.rolesId],form.title).then(function(response){if(response.ok){dispatch(addUser(response.user));dispatch(setShowInviteUserModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}return response;});}else{return __WEBPACK_IMPORTED_MODULE_1__services_api_users_api__["b" /* usersApi */].updateUser(currentUserId,form.firstName,form.lastName,form.email,form.phoneNumber,[form.rolesId],form.title).then(function(response){if(response.ok){dispatch(editUser(response.user));dispatch(setShowInviteUserModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}return response;});}}};}function updateFormValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["d" /* USERS_INVITE_USER_FORM_VALUE_UPDATE */],payload:{attribute:attribute,value:value}};}function validForm(){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["c" /* USERS_INVITE_USER_FORM_VALID */]};}function updateTermsAndConditions(isAccepted){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__services_api_users_api__["b" /* usersApi */].updateTermsAndConditions(isAccepted).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_authentication_js__["m" /* updateUser */])(response.data));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return USERS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return USERS_INVITE_USER_FORM_INVALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USERS_INVITE_USER_FORM_LOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USERS_INVITE_USER_FORM_VALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return USERS_INVITE_USER_FORM_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return USERS_INVITE_USER_ID_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return USERS_INVITE_USER_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return USERS_INVITE_USER_ROLES_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return USERS_USER_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return USERS_USER_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return USERS_USER_REMOVE; });
var USERS_LOAD_SUCCESS='USERS_LOAD_SUCCESS';var USERS_INVITE_USER_FORM_INVALID='USERS_INVITE_USER_FORM_INVALID';var USERS_INVITE_USER_FORM_LOAD='USERS_INVITE_USER_FORM_LOAD';var USERS_INVITE_USER_FORM_VALID='USERS_INVITE_USER_FORM_VALID';var USERS_INVITE_USER_FORM_VALUE_UPDATE='USERS_INVITE_USER_FORM_VALUE_UPDATE';var USERS_INVITE_USER_ID_SET='USERS_INVITE_USER_ID_SET';var USERS_INVITE_USER_MODAL_SHOW='USERS_INVITE_USER_MODAL_SHOW';var USERS_INVITE_USER_ROLES_LOAD_SUCCESS='USERS_INVITE_USER_ROLES_LOAD_SUCCESS';var USERS_USER_ADD='USERS_USER_ADD';var USERS_USER_EDIT='USERS_USER_EDIT';var USERS_USER_REMOVE='USERS_USER_REMOVE';

/***/ }),
/* 610 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(2448);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleLoadStart = handleLoadStart;
exports.handleCanPlay = handleCanPlay;
exports.handleWaiting = handleWaiting;
exports.handleCanPlayThrough = handleCanPlayThrough;
exports.handlePlaying = handlePlaying;
exports.handlePlay = handlePlay;
exports.handlePause = handlePause;
exports.handleEnd = handleEnd;
exports.handleSeeking = handleSeeking;
exports.handleSeeked = handleSeeked;
exports.handleDurationChange = handleDurationChange;
exports.handleTimeUpdate = handleTimeUpdate;
exports.handleVolumeChange = handleVolumeChange;
exports.handleProgressChange = handleProgressChange;
exports.handleRateChange = handleRateChange;
exports.handleSuspend = handleSuspend;
exports.handleAbort = handleAbort;
exports.handleEmptied = handleEmptied;
exports.handleStalled = handleStalled;
exports.handleLoadedMetaData = handleLoadedMetaData;
exports.handleLoadedData = handleLoadedData;
exports.handleResize = handleResize;
exports.handleError = handleError;
exports.handleSeekingTime = handleSeekingTime;
exports.handleEndSeeking = handleEndSeeking;
exports.activateTextTrack = activateTextTrack;
exports.ACTIVATE_TEXT_TRACK = exports.ERROR = exports.RESIZE = exports.LOADED_DATA = exports.LOADED_META_DATA = exports.STALLED = exports.EMPTIED = exports.ABORT = exports.SUSPEND = exports.RATE_CHANGE = exports.PROGRESS_CHANGE = exports.VOLUME_CHANGE = exports.TIME_UPDATE = exports.DURATION_CHANGE = exports.END_SEEKING = exports.SEEKING_TIME = exports.SEEKED = exports.SEEKING = exports.END = exports.PAUSE = exports.PLAY = exports.PLAYING = exports.CAN_PLAY_THROUGH = exports.WAITING = exports.CAN_PLAY = exports.LOAD_START = void 0;
var LOAD_START = 'video-react/LOAD_START';
exports.LOAD_START = LOAD_START;
var CAN_PLAY = 'video-react/CAN_PLAY';
exports.CAN_PLAY = CAN_PLAY;
var WAITING = 'video-react/WAITING';
exports.WAITING = WAITING;
var CAN_PLAY_THROUGH = 'video-react/CAN_PLAY_THROUGH';
exports.CAN_PLAY_THROUGH = CAN_PLAY_THROUGH;
var PLAYING = 'video-react/PLAYING';
exports.PLAYING = PLAYING;
var PLAY = 'video-react/PLAY';
exports.PLAY = PLAY;
var PAUSE = 'video-react/PAUSE';
exports.PAUSE = PAUSE;
var END = 'video-react/END';
exports.END = END;
var SEEKING = 'video-react/SEEKING';
exports.SEEKING = SEEKING;
var SEEKED = 'video-react/SEEKED';
exports.SEEKED = SEEKED;
var SEEKING_TIME = 'video-react/SEEKING_TIME';
exports.SEEKING_TIME = SEEKING_TIME;
var END_SEEKING = 'video-react/END_SEEKING';
exports.END_SEEKING = END_SEEKING;
var DURATION_CHANGE = 'video-react/DURATION_CHANGE';
exports.DURATION_CHANGE = DURATION_CHANGE;
var TIME_UPDATE = 'video-react/TIME_UPDATE';
exports.TIME_UPDATE = TIME_UPDATE;
var VOLUME_CHANGE = 'video-react/VOLUME_CHANGE';
exports.VOLUME_CHANGE = VOLUME_CHANGE;
var PROGRESS_CHANGE = 'video-react/PROGRESS_CHANGE';
exports.PROGRESS_CHANGE = PROGRESS_CHANGE;
var RATE_CHANGE = 'video-react/RATE_CHANGE';
exports.RATE_CHANGE = RATE_CHANGE;
var SUSPEND = 'video-react/SUSPEND';
exports.SUSPEND = SUSPEND;
var ABORT = 'video-react/ABORT';
exports.ABORT = ABORT;
var EMPTIED = 'video-react/EMPTIED';
exports.EMPTIED = EMPTIED;
var STALLED = 'video-react/STALLED';
exports.STALLED = STALLED;
var LOADED_META_DATA = 'video-react/LOADED_META_DATA';
exports.LOADED_META_DATA = LOADED_META_DATA;
var LOADED_DATA = 'video-react/LOADED_DATA';
exports.LOADED_DATA = LOADED_DATA;
var RESIZE = 'video-react/RESIZE';
exports.RESIZE = RESIZE;
var ERROR = 'video-react/ERROR';
exports.ERROR = ERROR;
var ACTIVATE_TEXT_TRACK = 'video-react/ACTIVATE_TEXT_TRACK';
exports.ACTIVATE_TEXT_TRACK = ACTIVATE_TEXT_TRACK;

function handleLoadStart(videoProps) {
  return {
    type: LOAD_START,
    videoProps: videoProps
  };
}

function handleCanPlay(videoProps) {
  return {
    type: CAN_PLAY,
    videoProps: videoProps
  };
}

function handleWaiting(videoProps) {
  return {
    type: WAITING,
    videoProps: videoProps
  };
}

function handleCanPlayThrough(videoProps) {
  return {
    type: CAN_PLAY_THROUGH,
    videoProps: videoProps
  };
}

function handlePlaying(videoProps) {
  return {
    type: PLAYING,
    videoProps: videoProps
  };
}

function handlePlay(videoProps) {
  return {
    type: PLAY,
    videoProps: videoProps
  };
}

function handlePause(videoProps) {
  return {
    type: PAUSE,
    videoProps: videoProps
  };
}

function handleEnd(videoProps) {
  return {
    type: END,
    videoProps: videoProps
  };
}

function handleSeeking(videoProps) {
  return {
    type: SEEKING,
    videoProps: videoProps
  };
}

function handleSeeked(videoProps) {
  return {
    type: SEEKED,
    videoProps: videoProps
  };
}

function handleDurationChange(videoProps) {
  return {
    type: DURATION_CHANGE,
    videoProps: videoProps
  };
}

function handleTimeUpdate(videoProps) {
  return {
    type: TIME_UPDATE,
    videoProps: videoProps
  };
}

function handleVolumeChange(videoProps) {
  return {
    type: VOLUME_CHANGE,
    videoProps: videoProps
  };
}

function handleProgressChange(videoProps) {
  return {
    type: PROGRESS_CHANGE,
    videoProps: videoProps
  };
}

function handleRateChange(videoProps) {
  return {
    type: RATE_CHANGE,
    videoProps: videoProps
  };
}

function handleSuspend(videoProps) {
  return {
    type: SUSPEND,
    videoProps: videoProps
  };
}

function handleAbort(videoProps) {
  return {
    type: ABORT,
    videoProps: videoProps
  };
}

function handleEmptied(videoProps) {
  return {
    type: EMPTIED,
    videoProps: videoProps
  };
}

function handleStalled(videoProps) {
  return {
    type: STALLED,
    videoProps: videoProps
  };
}

function handleLoadedMetaData(videoProps) {
  return {
    type: LOADED_META_DATA,
    videoProps: videoProps
  };
}

function handleLoadedData(videoProps) {
  return {
    type: LOADED_DATA,
    videoProps: videoProps
  };
}

function handleResize(videoProps) {
  return {
    type: RESIZE,
    videoProps: videoProps
  };
}

function handleError(videoProps) {
  return {
    type: ERROR,
    videoProps: videoProps
  };
}

function handleSeekingTime(time) {
  return {
    type: SEEKING_TIME,
    time: time
  };
}

function handleEndSeeking(time) {
  return {
    type: END_SEEKING,
    time: time
  };
}

function activateTextTrack(textTrack) {
  return {
    type: ACTIVATE_TEXT_TRACK,
    textTrack: textTrack
  };
}

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var Dom = _interopRequireWildcard(__webpack_require__(433));

var propTypes = {
  className: _propTypes["default"].string,
  onMouseDown: _propTypes["default"].func,
  onMouseMove: _propTypes["default"].func,
  stepForward: _propTypes["default"].func,
  stepBack: _propTypes["default"].func,
  sliderActive: _propTypes["default"].func,
  sliderInactive: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  getPercent: _propTypes["default"].func,
  vertical: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  label: _propTypes["default"].string,
  valuenow: _propTypes["default"].string,
  valuetext: _propTypes["default"].string
};

var Slider =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Slider, _Component);

  function Slider(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Slider);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Slider).call(this, props, context));
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
    _this.calculateDistance = _this.calculateDistance.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getProgress = _this.getProgress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      active: false
    };
    return _this;
  }

  (0, _createClass2["default"])(Slider, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousemove', this.handleMouseMove, true);
      document.removeEventListener('mouseup', this.handleMouseUp, true);
      document.removeEventListener('touchmove', this.handleMouseMove, true);
      document.removeEventListener('touchend', this.handleMouseUp, true);
      document.removeEventListener('keydown', this.handleKeyPress, true);
    }
  }, {
    key: "getProgress",
    value: function getProgress() {
      var getPercent = this.props.getPercent;

      if (!getPercent) {
        return 0;
      }

      var progress = getPercent(); // Protect against no duration and other division issues

      if (typeof progress !== 'number' || progress < 0 || progress === Infinity) {
        progress = 0;
      }

      return progress;
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      var onMouseDown = this.props.onMouseDown; // event.preventDefault();
      // event.stopPropagation();

      document.addEventListener('mousemove', this.handleMouseMove, true);
      document.addEventListener('mouseup', this.handleMouseUp, true);
      document.addEventListener('touchmove', this.handleMouseMove, true);
      document.addEventListener('touchend', this.handleMouseUp, true);
      this.setState({
        active: true
      });

      if (this.props.sliderActive) {
        this.props.sliderActive(event);
      }

      this.handleMouseMove(event);

      if (onMouseDown) {
        onMouseDown(event);
      }
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      var onMouseMove = this.props.onMouseMove;

      if (onMouseMove) {
        onMouseMove(event);
      }
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(event) {
      // On iOS safari, a subsequent mouseup event will be fired after touchend.
      // Its weird event positions make the player seek a wrong time.
      // calling preventDefault (at touchend phase) will prevent the mouseup event
      event.preventDefault();
      var onMouseUp = this.props.onMouseUp;
      document.removeEventListener('mousemove', this.handleMouseMove, true);
      document.removeEventListener('mouseup', this.handleMouseUp, true);
      document.removeEventListener('touchmove', this.handleMouseMove, true);
      document.removeEventListener('touchend', this.handleMouseUp, true);
      this.setState({
        active: false
      });

      if (this.props.sliderInactive) {
        this.props.sliderInactive(event);
      }

      if (onMouseUp) {
        onMouseUp(event);
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      document.addEventListener('keydown', this.handleKeyPress, true);

      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      document.removeEventListener('keydown', this.handleKeyPress, true);

      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault(); // event.stopPropagation();

      if (this.props.onClick) {
        this.props.onClick(event);
      }
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event) {
      if (event.which === 37 || event.which === 40) {
        // Left and Down Arrows
        event.preventDefault();
        event.stopPropagation();
        this.stepBack();
      } else if (event.which === 38 || event.which === 39) {
        // Up and Right Arrows
        event.preventDefault();
        event.stopPropagation();
        this.stepForward();
      }
    }
  }, {
    key: "stepForward",
    value: function stepForward() {
      if (this.props.stepForward) {
        this.props.stepForward();
      }
    }
  }, {
    key: "stepBack",
    value: function stepBack() {
      if (this.props.stepBack) {
        this.props.stepBack();
      }
    }
  }, {
    key: "calculateDistance",
    value: function calculateDistance(event) {
      var node = this.slider;
      var position = Dom.getPointerPosition(node, event);

      if (this.props.vertical) {
        return position.y;
      }

      return position.x;
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var progress = this.getProgress();
      var percentage = "".concat((progress * 100).toFixed(2), "%");
      return _react["default"].Children.map(this.props.children, function (child) {
        return _react["default"].cloneElement(child, {
          progress: progress,
          percentage: percentage
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          vertical = _this$props.vertical,
          label = _this$props.label,
          valuenow = _this$props.valuenow,
          valuetext = _this$props.valuetext;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.props.className, {
          'video-react-slider-vertical': vertical,
          'video-react-slider-horizontal': !vertical,
          'video-react-sliding': this.state.active
        }, 'video-react-slider'),
        ref: function ref(c) {
          _this2.slider = c;
        },
        tabIndex: "0",
        role: "slider",
        onMouseDown: this.handleMouseDown,
        onTouchStart: this.handleMouseDown,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleClick,
        "aria-label": label || '',
        "aria-valuenow": valuenow || '',
        "aria-valuetext": valuetext || '',
        "aria-valuemin": 0,
        "aria-valuemax": 100
      }, this.renderChildren());
    }
  }]);
  return Slider;
}(_react.Component);

exports["default"] = Slider;
Slider.propTypes = propTypes;
Slider.displayName = 'Slider';

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _MenuButton = _interopRequireDefault(__webpack_require__(615));

var propTypes = {
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  rates: _propTypes["default"].array,
  className: _propTypes["default"].string
};
var defaultProps = {
  rates: [2, 1.5, 1.25, 1, 0.5, 0.25]
};

var PlaybackRateMenuButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(PlaybackRateMenuButton, _Component);

  function PlaybackRateMenuButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, PlaybackRateMenuButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlaybackRateMenuButton).call(this, props, context));
    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(PlaybackRateMenuButton, [{
    key: "handleSelectItem",
    value: function handleSelectItem(index) {
      var _this$props = this.props,
          rates = _this$props.rates,
          actions = _this$props.actions;

      if (index >= 0 && index < rates.length) {
        actions.changeRate(rates[index]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          rates = _this$props2.rates,
          player = _this$props2.player;
      var items = rates.map(function (rate) {
        return {
          label: "".concat(rate, "x"),
          value: rate
        };
      });
      var selectedIndex = rates.indexOf(player.playbackRate) || 0;
      return _react["default"].createElement(_MenuButton["default"], {
        className: (0, _classnames["default"])('video-react-playback-rate', this.props.className),
        onSelectItem: this.handleSelectItem,
        items: items,
        selectedIndex: selectedIndex
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Playback Rate"), _react["default"].createElement("div", {
        className: "video-react-playback-rate-value"
      }, "".concat(player.playbackRate.toFixed(2), "x")));
    }
  }]);
  return PlaybackRateMenuButton;
}(_react.Component);

PlaybackRateMenuButton.propTypes = propTypes;
PlaybackRateMenuButton.defaultProps = defaultProps;
PlaybackRateMenuButton.displayName = 'PlaybackRateMenuButton';
var _default = PlaybackRateMenuButton;
exports["default"] = _default;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _Menu = _interopRequireDefault(__webpack_require__(2462));

var _MenuItem = _interopRequireDefault(__webpack_require__(2463));

var _ClickableComponent = _interopRequireDefault(__webpack_require__(1009));

var propTypes = {
  inline: _propTypes["default"].bool,
  items: _propTypes["default"].array,
  className: _propTypes["default"].string,
  onSelectItem: _propTypes["default"].func,
  children: _propTypes["default"].any,
  selectedIndex: _propTypes["default"].number
};

var MenuButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(MenuButton, _Component);

  function MenuButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, MenuButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuButton).call(this, props, context));
    _this.state = {
      active: false,
      activateIndex: props.selectedIndex || 0
    };
    _this.commitSelection = _this.commitSelection.bind((0, _assertThisInitialized2["default"])(_this));
    _this.activateMenuItem = _this.activateMenuItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderMenu = _this.renderMenu.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleUpArrow = _this.handleUpArrow.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDownArrow = _this.handleDownArrow.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEscape = _this.handleEscape.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleReturn = _this.handleReturn.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTab = _this.handleTab.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleIndexChange = _this.handleIndexChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(MenuButton, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.selectedIndex !== this.props.selectedIndex) {
        this.activateMenuItem(this.props.selectedIndex);
      }
    }
  }, {
    key: "commitSelection",
    value: function commitSelection(index) {
      this.setState({
        activateIndex: index
      });
      this.handleIndexChange(index);
    }
  }, {
    key: "activateMenuItem",
    value: function activateMenuItem(index) {
      this.setState({
        activateIndex: index
      });
      this.handleIndexChange(index);
    }
  }, {
    key: "handleIndexChange",
    value: function handleIndexChange(index) {
      var onSelectItem = this.props.onSelectItem;
      onSelectItem(index);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.setState(function (prevState) {
        return {
          active: !prevState.active
        };
      });
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      document.addEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.setState({
        active: false
      });
      document.removeEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: "handleUpArrow",
    value: function handleUpArrow(e) {
      var items = this.props.items;

      if (this.state.active) {
        e.preventDefault();
        var newIndex = this.state.activateIndex - 1;

        if (newIndex < 0) {
          newIndex = items.length ? items.length - 1 : 0;
        }

        this.activateMenuItem(newIndex);
      }
    }
  }, {
    key: "handleDownArrow",
    value: function handleDownArrow(e) {
      var items = this.props.items;

      if (this.state.active) {
        e.preventDefault();
        var newIndex = this.state.activateIndex + 1;

        if (newIndex >= items.length) {
          newIndex = 0;
        }

        this.activateMenuItem(newIndex);
      }
    }
  }, {
    key: "handleTab",
    value: function handleTab(e) {
      if (this.state.active) {
        e.preventDefault();
        this.commitSelection(this.state.activateIndex);
      }
    }
  }, {
    key: "handleReturn",
    value: function handleReturn(e) {
      e.preventDefault();

      if (this.state.active) {
        this.commitSelection(this.state.activateIndex);
      } else {
        this.setState({
          active: true
        });
      }
    }
  }, {
    key: "handleEscape",
    value: function handleEscape() {
      this.setState({
        active: false,
        activateIndex: 0
      });
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event) {
      // Escape (27) key
      if (event.which === 27) {
        this.handleEscape(event);
      } else if (event.which === 9) {
        // Tab (9) key
        this.handleTab(event);
      } else if (event.which === 13) {
        // Enter (13) key
        this.handleReturn(event);
      } else if (event.which === 38) {
        // Up (38) key
        this.handleUpArrow(event);
      } else if (event.which === 40) {
        // Down (40) key press
        this.handleDownArrow(event);
      }
    }
  }, {
    key: "handleSelectItem",
    value: function handleSelectItem(i) {
      this.commitSelection(i);
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this2 = this;

      if (!this.state.active) {
        return null;
      }

      var items = this.props.items;
      return _react["default"].createElement(_Menu["default"], null, items.map(function (item, i) {
        return _react["default"].createElement(_MenuItem["default"], {
          item: item,
          index: i,
          onSelectItem: _this2.handleSelectItem,
          activateIndex: _this2.state.activateIndex,
          key: "item-".concat(i++)
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          inline = _this$props.inline,
          className = _this$props.className;
      return _react["default"].createElement(_ClickableComponent["default"], {
        className: (0, _classnames["default"])(className, {
          'video-react-menu-button-inline': !!inline,
          'video-react-menu-button-popup': !inline,
          'video-react-menu-button-active': this.state.active
        }, 'video-react-control video-react-button video-react-menu-button'),
        role: "button",
        tabIndex: "0",
        ref: function ref(c) {
          _this3.menuButton = c;
        },
        onClick: this.handleClick,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, this.props.children, this.renderMenu());
    }
  }]);
  return MenuButton;
}(_react.Component);

exports["default"] = MenuButton;
MenuButton.propTypes = propTypes;
MenuButton.displayName = 'MenuButton';

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONTRACTORS_INVOICES_INVOICE_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONTRACTORS_INVOICES_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONTRACTORS_INVOICES_INVOICE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CONTRACTORS_INVOICES_PAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CONTRACTORS_INVOICES_PAGINATION_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CONTRACTORS_INVOICES_SEARCH_TEXT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CONTRACTORS_INVOICES_VENDOR_INVOICES_INVOICE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CONTRACTORS_INVOICES_VENDOR_INVOICES_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CONTRACTORS_INVOICES_VENDOR_INVOICES_PAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CONTRACTORS_INVOICES_VENDOR_INVOICES_PAGINATION_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CONTRACTORS_INVOICES_SEARCH_FILTERS_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CONTRACTORS_INVOICES_SEARCH_FILTER_VALUE_CHANGE; });
var CONTRACTORS_INVOICES_INVOICE_REMOVE='CONTRACTORS_INVOICES_INVOICE_REMOVE';var CONTRACTORS_INVOICES_LOAD_SUCCESS='CONTRACTORS_INVOICES_LOAD_SUCCESS';var CONTRACTORS_INVOICES_INVOICE_UPDATE='CONTRACTORS_INVOICES_INVOICE_UPDATE';var CONTRACTORS_INVOICES_PAGE_CHANGE='CONTRACTORS_INVOICES_PAGE_CHANGE';var CONTRACTORS_INVOICES_PAGINATION_INIT='CONTRACTORS_INVOICES_PAGINATION_INIT';var CONTRACTORS_INVOICES_SEARCH_TEXT_CHANGE='CONTRACTORS_INVOICES_SEARCH_TEXT_CHANGE';var CONTRACTORS_INVOICES_VENDOR_INVOICES_INVOICE_UPDATE='CONTRACTORS_INVOICES_VENDOR_INVOICES_INVOICE_UPDATE';var CONTRACTORS_INVOICES_VENDOR_INVOICES_SET='CONTRACTORS_INVOICES_VENDOR_INVOICES_SET';var CONTRACTORS_INVOICES_VENDOR_INVOICES_PAGE_CHANGE='CONTRACTORS_INVOICES_VENDOR_INVOICES_PAGE_CHANGE';var CONTRACTORS_INVOICES_VENDOR_INVOICES_PAGINATION_INIT='CONTRACTORS_INVOICES_VENDOR_INVOICES_PAGINATION_INIT';var CONTRACTORS_INVOICES_SEARCH_FILTERS_INIT='CONTRACTORS_INVOICES_SEARCH_FILTERS_INIT';var CONTRACTORS_INVOICES_SEARCH_FILTER_VALUE_CHANGE='CONTRACTORS_INVOICES_SEARCH_FILTER_VALUE_CHANGE';

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export baseRoutePath */
/* harmony export (immutable) */ __webpack_exports__["a"] = changePage;
/* harmony export (immutable) */ __webpack_exports__["b"] = createPurchaseOrder;
/* harmony export (immutable) */ __webpack_exports__["c"] = getPurchaseOrders;
/* harmony export (immutable) */ __webpack_exports__["e"] = setShowCreateModal;
/* harmony export (immutable) */ __webpack_exports__["d"] = goToPurchaseOrders;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_purchase_orders_api__ = __webpack_require__(2481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_purchase_orders_store_action_types__ = __webpack_require__(618);
var baseRoutePath='/admin/purchase-orders';function changePage(newPage){return function(dispatch){return dispatch(getPurchaseOrders(newPage)).then(function(response){if(response.ok){dispatch(setCurrentPage(newPage));}});};}function createPurchaseOrder(values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_purchase_orders_api__["a" /* purchaseOrdersApi */].createPurchaseOrders(values).then(function(response){if(response.ok){dispatch(setShowCreateModal(false));dispatch(changePage(1));// load orders again
}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function getPurchaseOrders(page){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_purchase_orders_api__["a" /* purchaseOrdersApi */].getPurchaseOrders(page).then(function(response){if(response.ok){dispatch(setPurchaseOrders(response.purchaseOrders));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setCurrentPage(page){return{type:__WEBPACK_IMPORTED_MODULE_3_components_admin_purchase_orders_store_action_types__["a" /* PURCHASE_ORDERS_CURRENT_PAGE_SET */],payload:page};}function setPurchaseOrders(purchaseOrders){return{type:__WEBPACK_IMPORTED_MODULE_3_components_admin_purchase_orders_store_action_types__["b" /* PURCHASE_ORDERS_SET */],payload:purchaseOrders};}function setShowCreateModal(value){return{type:__WEBPACK_IMPORTED_MODULE_3_components_admin_purchase_orders_store_action_types__["c" /* PURCHASE_ORDERS_SHOW_MODAL_SET */],payload:value};}function goToPurchaseOrders(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(baseRoutePath));};}

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PURCHASE_ORDERS_CURRENT_PAGE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PURCHASE_ORDERS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PURCHASE_ORDERS_SHOW_MODAL_SET; });
var PURCHASE_ORDERS_CURRENT_PAGE_SET='PURCHASE_ORDERS_CURRENT_PAGE_SET';var PURCHASE_ORDERS_SET='PURCHASE_ORDERS_SET';var PURCHASE_ORDERS_SHOW_MODAL_SET='PURCHASE_ORDERS_SHOW_MODAL_SET';

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NEW_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EDIT_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return NEXT_STAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NEW_PROJECT_FORM_VALUE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NEW_PROJECT_GC_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NEW_PROJECT_CURRENT_PAGE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NEW_PROJECT_CLIENT_FORM_VALUE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NEW_PROJECT_BUILDING_FORM_VALUE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return NEW_PROJECT_NEW_CLIENT_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NEW_PROJECT_NEW_CLIENT_FORM_CLEAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NEW_PROJECT_NEW_BUILDING_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return NEW_PROJECT_NEW_BUILDING_FORM_CLEAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return NEW_PROJECT_ID_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EDIT_PROJECT_FORM_SET_VALUES; });
var NEW_PROJECT='NEW_PROJECT';var EDIT_PROJECT='EDIT_PROJECT';var NEXT_STAGE='NEXT_STAGE';var NEW_PROJECT_FORM_VALUE_CHANGE='NEW_PROJECT_FORM_VALUE_CHANGE';var NEW_PROJECT_GC_SET='NEW_PROJECT_GC_SET';var NEW_PROJECT_CURRENT_PAGE_SET='NEW_PROJECT_CURRENT_PAGE_SET';var NEW_PROJECT_CLIENT_FORM_VALUE_CHANGE='NEW_PROJECT_CLIENT_FORM_VALUE_CHANGE';var NEW_PROJECT_BUILDING_FORM_VALUE_CHANGE='NEW_PROJECT_BUILDING_FORM_VALUE_CHANGE';var NEW_PROJECT_NEW_CLIENT_MODAL_SHOW='NEW_PROJECT_NEW_CLIENT_MODAL_SHOW';var NEW_PROJECT_NEW_CLIENT_FORM_CLEAN='NEW_PROJECT_NEW_CLIENT_FORM_CLEAN';var NEW_PROJECT_NEW_BUILDING_MODAL_SHOW='NEW_PROJECT_NEW_BUILDING_MODAL_SHOW';var NEW_PROJECT_NEW_BUILDING_FORM_CLEAN='NEW_PROJECT_NEW_BUILDING_FORM_CLEAN';var NEW_PROJECT_ID_SET='NEW_PROJECT_ID_SET';var EDIT_PROJECT_FORM_SET_VALUES='EDIT_PROJECT_FORM_SET_VALUES';

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROJECT_DETAILS_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_DETAILS_CURRENT_PROJECT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PROJECT_DETAILS_NAV_BAR_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHOW_PDF_VIEWER_SET; });
var PROJECT_DETAILS_INIT='PROJECT_DETAILS_INIT';var PROJECT_DETAILS_CURRENT_PROJECT_SET='PROJECT_DETAILS_CURRENT_PROJECT_SET';var PROJECT_DETAILS_NAV_BAR_SELECTION='PROJECT_DETAILS_NAV_BAR_SELECTION';var SHOW_PDF_VIEWER_SET='SHOW_PDF_VIEWER_SET';

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return projectResourceMailerApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectResourceMailerApi=function(_BaseApi){_inherits(ProjectResourceMailerApi,_BaseApi);function ProjectResourceMailerApi(){_classCallCheck(this,ProjectResourceMailerApi);return _possibleConstructorReturn(this,(ProjectResourceMailerApi.__proto__||Object.getPrototypeOf(ProjectResourceMailerApi)).apply(this,arguments));}_createClass(ProjectResourceMailerApi,[{key:'postResourceEmails',value:function postResourceEmails(resourceId,resourceType,emailData){var data=this.resourceEmailsParams(resourceId,resourceType,emailData);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/project_resource_mailer',data).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'resourceEmailsParams',value:function resourceEmailsParams(resourceId,resourceType,emailData){return{resource_id:resourceId,resource_type:resourceType,subject:emailData.subject,message:emailData.message,send_to:emailData.recipients};}},{key:'getEmailHistory',value:function getEmailHistory(id,type){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/project_resource_mailer?resource_id='+id+'&resource_type='+type).then(function(response){return{ok:true,data:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return ProjectResourceMailerApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var projectResourceMailerApi=new ProjectResourceMailerApi();

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INIT_PROJECT_EMAIL_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_SHOW_EMAIL_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_SHOW_CUSTOM_EMAIL_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_SHOW_NEW_CUSTOM_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_EMAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_RECIPIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_SUBJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_RECIPIENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_CUSTOM_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_EMAIL_HISTORY; });
var INIT_PROJECT_EMAIL_MODAL='INIT_PROJECT_EMAIL_MODAL';var SET_SHOW_EMAIL_MODAL='SET_SHOW_EMAIL_MODAL';var SET_SHOW_CUSTOM_EMAIL_ERROR='SET_SHOW_CUSTOM_EMAIL_ERROR';var SET_SHOW_NEW_CUSTOM_EMAIL='SET_SHOW_NEW_CUSTOM_EMAIL';var SET_EMAILS='SET_EMAILS';var ADD_EMAIL='ADD_EMAIL';var ADD_RECIPIENT='ADD_RECIPIENT';var SET_SUBJECT='SET_SUBJECT';var SET_MESSAGE='SET_MESSAGE';var SET_RECIPIENTS='SET_RECIPIENTS';var SET_CUSTOM_EMAIL='SET_CUSTOM_EMAIL';var SET_EMAIL_HISTORY='SET_EMAIL_HISTORY';

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return MEETING_MINUTES_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MEETING_INFO_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MEETING_INFO_EDIT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MEETINGS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return MEETING_MODAL_SHOW_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MEETING_CATEGORIES_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return MEETING_MODAL_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MEETING_FORM_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MEETING_ITEM_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MEETING_ITEM_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MEETING_ITEMS_ATTACH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTENDEES_MODAL_SHOW_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return REVIEW_MEETING_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MEETINGS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return MEETING_ITEM_SETTINGS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CURRENT_MEETING_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MEETINGS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return MEETING_PDF_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return TOGGLE_PDF_VIEWER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONFIRMATION_MSG_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONFIRM_APPROVAL_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return MEETING_REMOVE; });
var MEETING_MINUTES_INIT='MEETING_MINUTES_INIT';var MEETING_INFO_SET='MEETING_INFO_SET';var MEETING_INFO_EDIT_SET='MEETING_INFO_EDIT_SET';var MEETINGS_SET='MEETINGS_SET';var MEETING_MODAL_SHOW_SET='MEETING_MODAL_SHOW_SET';var MEETING_CATEGORIES_SET='MEETING_CATEGORIES_SET';var MEETING_MODAL_INIT='MEETING_MODAL_INIT';var MEETING_FORM_VALUE_UPDATE='MEETING_FORM_VALUE_UPDATE';var MEETING_ITEM_VALUE_UPDATE='MEETING_ITEM_VALUE_UPDATE';var MEETING_ITEM_ADD='MEETING_ITEM_ADD';var MEETING_ITEMS_ATTACH='MEETING_ITEMS_ATTACH';var ATTENDEES_MODAL_SHOW_SET='ATTENDEES_MODAL_SHOW_SET';var REVIEW_MEETING_SET='REVIEW_MEETING_SET';var MEETINGS_ADD='MEETINGS_ADD';var MEETING_ITEM_SETTINGS_SET='MEETING_ITEM_SETTINGS_SET';var CURRENT_MEETING_SET='CURRENT_MEETING_SET';var MEETINGS_UPDATE='MEETINGS_UPDATE';var MEETING_PDF_SET='MEETING_PDF_SET';var TOGGLE_PDF_VIEWER_SUCCESS='TOGGLE_PDF_VIEWER_SUCCESS';var CONFIRMATION_MSG_SET='CONFIRMATION_MSG_SET';var CONFIRM_APPROVAL_SET='CONFIRM_APPROVAL_SET';var MEETING_REMOVE='MEETING_REMOVE';

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DueDateFilterUtil; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var DueDateFilterUtil=function(){function DueDateFilterUtil(){_classCallCheck(this,DueDateFilterUtil);}_createClass(DueDateFilterUtil,null,[{key:'getDueDateQuery',value:function getDueDateQuery(dueDateFilter){var todaysDate=__WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD');var dueDateQuery=null;switch(dueDateFilter){case'pending':dueDateQuery='all_before_due='+todaysDate;break;case'overdue':dueDateQuery='all_past_due='+todaysDate;break;case'ascending':dueDateQuery='due_asc=true';break;case'descending':dueDateQuery='due_desc=true';break;default:}return dueDateQuery;}}]);return DueDateFilterUtil;}();

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return RFI_LOG_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RFIS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return RFI_TAB_SELECTED_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RFI_MODAL_SHOW_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RFI_MODAL_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RFI_FORM_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return RFI_QUESTION_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return RFI_QUESTION_ERRORS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return RFI_QUESTION_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return RFI_QUESTIONS_ATTACH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return RFI_QUESTION_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RFIS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RFIS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RFIS_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CURRENT_RFI_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return RFI_READ_ONLY_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RFI_FORM_VALUES_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RFI_FORM_ERRORS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return RFI_QUESTION_FILE_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return RFI_QUESTION_NOTE_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return RFI_GC_ACCELERATION_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return RFI_LOG_PDF_VIEWER_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return RFI_LOG_PDF_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return RFI_PDF_VIEWER_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return RFI_SHOW_ERROR_MESSAGE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RFI_ADDL_ASSIGNEES_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RFI_ADDL_ASSIGNEES_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RFI_ADDL_ASSIGNEES_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RFI_ADDL_ASSIGNEE_RESPOND_SUCCESS; });
var RFI_LOG_INIT='RFI_LOG_INIT';var RFIS_SET='RFIS_SET';var RFI_TAB_SELECTED_SET='RFI_TAB_SELECTED_SET';var RFI_MODAL_SHOW_SET='RFI_MODAL_SHOW_SET';var RFI_MODAL_INIT='RFI_MODAL_INIT';var RFI_FORM_VALUE_UPDATE='RFI_FORM_VALUE_UPDATE';var RFI_QUESTION_VALUE_UPDATE='RFI_QUESTION_VALUE_UPDATE';var RFI_QUESTION_ERRORS_SET='RFI_QUESTION_ERRORS_SET';var RFI_QUESTION_ADD='RFI_QUESTION_ADD';var RFI_QUESTIONS_ATTACH='RFI_QUESTIONS_ATTACH';var RFI_QUESTION_DELETE='RFI_QUESTION_DELETE';var RFIS_ADD='RFIS_ADD';var RFIS_UPDATE='RFIS_UPDATE';var RFIS_DELETE='RFIS_DELETE';var CURRENT_RFI_SET='CURRENT_RFI_SET';var RFI_READ_ONLY_SET='RFI_READ_ONLY_SET';var RFI_FORM_VALUES_SET='RFI_FORM_VALUES_SET';var RFI_FORM_ERRORS_SET='RFI_FORM_ERRORS_SET';var RFI_QUESTION_FILE_DELETE='RFI_QUESTION_FILE_DELETE';var RFI_QUESTION_NOTE_ADD='RFI_QUESTION_NOTE_ADD';var RFI_GC_ACCELERATION_SET='RFI_GC_ACCELERATION_SET';var RFI_LOG_PDF_VIEWER_SET='RFI_LOG_PDF_VIEWER_SET';var RFI_LOG_PDF_SET='RFI_LOG_PDF_SET';var RFI_PDF_VIEWER_SET='RFI_PDF_VIEWER_SET';var RFI_SHOW_ERROR_MESSAGE_SET='RFI_SHOW_ERROR_MESSAGE_SET';var RFI_ADDL_ASSIGNEES_ADD='RFI_ADDL_ASSIGNEES_ADD';var RFI_ADDL_ASSIGNEES_UPDATE='RFI_ADDL_ASSIGNEES_UPDATE';var RFI_ADDL_ASSIGNEES_DELETE='RFI_ADDL_ASSIGNEES_DELETE';var RFI_ADDL_ASSIGNEE_RESPOND_SUCCESS='RFI_ADDL_ASSIGNEE_RESPOND_SUCCESS';

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return submittalsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_utils_due_date_filter_util__ = __webpack_require__(624);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubmittalsApi=function(_BaseApi){_inherits(SubmittalsApi,_BaseApi);function SubmittalsApi(){_classCallCheck(this,SubmittalsApi);return _possibleConstructorReturn(this,(SubmittalsApi.__proto__||Object.getPrototypeOf(SubmittalsApi)).apply(this,arguments));}_createClass(SubmittalsApi,[{key:'getSubmittals',value:function getSubmittals(projectId,page,status,label,dueDateFilter){var dueDateQuery=__WEBPACK_IMPORTED_MODULE_3_services_utils_due_date_filter_util__["a" /* DueDateFilterUtil */].getDueDateQuery(dueDateFilter);var url=this.baseUrl+'/projects/'+projectId+'/submittals?page='+page+'&'+status+'=true'+(dueDateQuery?'&'+dueDateQuery:'');if(label){url+='&by_label='+label;}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function(response){return{ok:true,submittals:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getSubmittalsAll',value:function getSubmittalsAll(page,filters){var query='page='+page;Object.keys(filters).forEach(function(filter){query+='&'+filter+'='+filters[filter];});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/submittals?'+query).then(function(response){return{ok:true,submittals:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getSubmittalsAllCount',value:function getSubmittalsAllCount(filters){var query='';Object.keys(filters).forEach(function(filter,index){if(index>0){query+='&';}query+=filter+'='+filters[filter];});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/submittals/count?'+query).then(function(response){return{ok:true,count:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getSubmittal',value:function getSubmittal(projectId,submittalId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/submittals/'+submittalId).then(function(response){return{ok:true,submittal:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getSubmittalLogPdf',value:function getSubmittalLogPdf(projectId,status){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/submittal_log/print?'+status+'=true',{responseType:'blob'}).then(function(response){return{ok:true,submittalLogPdf:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getSubmittalLeadTimeLogPdf',value:function getSubmittalLeadTimeLogPdf(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/submittal_lead_time_log/print',{responseType:'blob'}).then(function(response){return{ok:true,submittalLeadTimeLogPdf:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createSubmittal',value:function createSubmittal(projectId,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var data=this.submittalParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/projects/'+projectId+'/submittals',data,headers).then(function(response){return{ok:true,submittal:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateSubmittal',value:function updateSubmittal(projectId,submittalId,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var data=this.submittalParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/submittals/'+submittalId,data,headers).then(function(response){return{ok:true,submittal:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateSubmittalLeadTime',value:function updateSubmittalLeadTime(projectId,submittalId,values){var data={submittal:{lead_time_applies:values.leadTimeApplies,lead_time_weeks:values.leadTimeWeeks,order_date:values.orderDate,vendor_delivery:values.vendorDelivery,field_delivery:values.fieldDelivery,lead_time_reminder:values.leadTimeReminder}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/submittals/'+submittalId,data).then(function(response){return{ok:true,submittal:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'respondSubmittal',value:function respondSubmittal(projectId,submittalId,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var data=this.respondParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/submittals/'+submittalId+'/respond',data,headers).then(function(response){return{ok:true,submittal:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getTransmittalPdf',value:function getTransmittalPdf(projectId,submittalId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/submittals/'+submittalId+'/transmittal',{responseType:'blob'}).then(function(response){return{ok:true,transmittalPdf:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getNotes',value:function getNotes(submittalId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/submittals/'+submittalId+'/notes').then(function(response){return{ok:true,notes:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'markNotesRead',value:function markNotesRead(submittalId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/submittals/'+submittalId+'/notes/mark_all_read').then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createNote',value:function createNote(submittalId,content){var headers={headers:{'Content-Type':'multipart/form-data'}};var apiPayload=new FormData();apiPayload.append('note[content]',content.content);var index=0;if(content.images&&content.images.length>0){content.images.filter(function(image){return!image.id;}).forEach(function(image){apiPayload.append('note[images_attributes]['+index+'][image]',image.file,image.file.name);index++;});}index=0;if(content.documents&&content.documents.length>0){content.documents.filter(function(doc){return!doc.id;}).forEach(function(doc){apiPayload.append('note[documents_attributes]['+index+'][document]',doc.file,doc.file.name);index++;});}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/submittals/'+submittalId+'/notes',apiPayload,headers).then(function(response){return{ok:true,note:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'deleteSubmittal',value:function deleteSubmittal(projectId,submittalId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/projects/'+projectId+'/submittals/'+submittalId).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'submittalParams',value:function submittalParams(values){var reqImgsIndex=0;var reqDocsIndex=0;var apiPayload=new FormData();apiPayload.append('submittal[title]',values.title);apiPayload.append('submittal[status]',values.status);apiPayload.append('submittal[csi_code_id]',values.csiCodeId);apiPayload.append('submittal[physical_copies]',values.physicalCopies);apiPayload.append('submittal[assignee_id]',values.assigneeId);apiPayload.append('submittal[requested_at]',values.requestedAt);apiPayload.append('submittal[due_date]',values.dueDate);apiPayload.append('submittal[extended_due_date]',values.extendedDueDate);apiPayload.append('submittal[question]',values.question);apiPayload.append('submittal[closed]',values.closed);if(values.contractorId)apiPayload.append('submittal[contractor_id]',values.contractorId);values.addlAssignees.forEach(function(addlAssignee,index){if(addlAssignee.id){apiPayload.append('submittal[submittal_addl_assignees_attributes]['+index+'][id]',addlAssignee.id);}if(addlAssignee.destroy){apiPayload.append('submittal[submittal_addl_assignees_attributes]['+index+'][_destroy]',true);}else{apiPayload.append('submittal[submittal_addl_assignees_attributes]['+index+'][assignee_id]',addlAssignee.assigneeId);apiPayload.append('submittal[submittal_addl_assignees_attributes]['+index+'][due_date]',addlAssignee.dueDate);}});values.recipientIds.forEach(function(rcptId){apiPayload.append('submittal[recipient_ids][]',rcptId);});values.reqImages.filter(function(img){return img.file;}).forEach(function(img){var file=img.file;apiPayload.append('submittal[request_images_attributes]['+reqImgsIndex+'][image]',file,file.name);reqImgsIndex++;});values.reqDocs.filter(function(doc){return doc.file;}).forEach(function(doc){var file=doc.file;apiPayload.append('submittal[request_documents_attributes]['+reqDocsIndex+'][document]',file,file.name);reqDocsIndex++;});values.reqImagesDelete.filter(function(img){return img.id;}).forEach(function(img){apiPayload.append('submittal[request_images_attributes]['+reqImgsIndex+'][id]',img.id);apiPayload.append('submittal[request_images_attributes]['+reqImgsIndex+'][_destroy]',true);reqImgsIndex++;});values.reqDocsDelete.filter(function(doc){return doc.id;}).forEach(function(doc){apiPayload.append('submittal[request_documents_attributes]['+reqDocsIndex+'][id]',doc.id);apiPayload.append('submittal[request_documents_attributes]['+reqDocsIndex+'][_destroy]',true);reqDocsIndex++;});return apiPayload;}},{key:'respondParams',value:function respondParams(values){var resImgsIndex=0;var resDocsIndex=0;var apiPayload=new FormData();apiPayload.append('submittal[status]',values.status);apiPayload.append('submittal[remarks]',values.remarks);apiPayload.append('submittal[stamp_action]',values.stampAction);values.resImages.filter(function(img){return img.file;}).forEach(function(img){var file=img.file;apiPayload.append('submittal[response_images_attributes]['+resImgsIndex+'][image]',file,file.name);resImgsIndex++;});values.resDocs.filter(function(doc){return doc.file;}).forEach(function(doc){var file=doc.file;apiPayload.append('submittal[response_documents_attributes]['+resDocsIndex+'][document]',file,file.name);resDocsIndex++;});values.resImagesDelete.filter(function(img){return img.id;}).forEach(function(img){apiPayload.append('submittal[response_images_attributes]['+resImgsIndex+'][id]',img.id);apiPayload.append('submittal[response_images_attributes]['+resImgsIndex+'][_destroy]',true);resImgsIndex++;});values.resDocsDelete.filter(function(doc){return doc.id;}).forEach(function(doc){apiPayload.append('submittal[response_documents_attributes]['+resDocsIndex+'][id]',doc.id);apiPayload.append('submittal[response_documents_attributes]['+resDocsIndex+'][_destroy]',true);resDocsIndex++;});return apiPayload;}}]);return SubmittalsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var submittalsApi=new SubmittalsApi();

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SUBMITTAL_LOG_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SUBMITTALS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SUBMITTAL_TAB_SELECTED_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SUBMITTAL_MODAL_SHOW_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SUBMITTAL_MODAL_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SUBMITTAL_FORM_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SUBMITTAL_FILE_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SUBMITTAL_READ_ONLY_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SUBMITTAL_LEAD_TIME_READ_ONLY_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SHOW_TRANSMITTAL_PDF_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return TRANSMITTAL_PDF_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SUBMITTAL_FORM_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SUBMITTAL_FORM_ERRORS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CURRENT_SUBMITTAL_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SUBMITTAL_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SUBMITTAL_NOTES_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SUBMITTAL_NOTES_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SUBMITTAL_GC_ACCELERATION_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SUBMITTAL_LOG_PDF_VIEWER_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SUBMITTAL_LOG_PDF_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SUBMITTAL_PDF_VIEWER_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SUBMITTAL_SHOW_ERROR_MESSAGE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SUBMITTAL_ADDL_ASSIGNEES_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SUBMITTAL_ADDL_ASSIGNEES_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SUBMITTAL_ADDL_ASSIGNEES_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SUBMITTAL_ADDL_ASSIGNEE_RESPONSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SUBMITTALS_DELETE; });
var SUBMITTAL_LOG_INIT='SUBMITTAL_LOG_INIT';var SUBMITTALS_SET='SUBMITTALS_SET';var SUBMITTAL_TAB_SELECTED_SET='SUBMITTAL_TAB_SELECTED_SET';var SUBMITTAL_MODAL_SHOW_SET='SUBMITTAL_MODAL_SHOW_SET';var SUBMITTAL_MODAL_INIT='SUBMITTAL_MODAL_INIT';var SUBMITTAL_FORM_VALUE_UPDATE='SUBMITTAL_FORM_VALUE_UPDATE';var SUBMITTAL_FILE_DELETE='SUBMITTAL_FILE_DELETE';var SUBMITTAL_READ_ONLY_SET='SUBMITTAL_READ_ONLY_SET';var SUBMITTAL_LEAD_TIME_READ_ONLY_SET='SUBMITTAL_LEAD_TIME_READ_ONLY_SET';var SHOW_TRANSMITTAL_PDF_SET='SHOW_TRANSMITTAL_PDF_SET';var TRANSMITTAL_PDF_SET='TRANSMITTAL_PDF_SET';var SUBMITTAL_FORM_SET='SUBMITTAL_FORM_SET';var SUBMITTAL_FORM_ERRORS_SET='SUBMITTAL_FORM_ERRORS_SET';var CURRENT_SUBMITTAL_SET='CURRENT_SUBMITTAL_SET';var SUBMITTAL_UPDATE='SUBMITTAL_UPDATE';var SUBMITTAL_NOTES_SET='SUBMITTAL_NOTES_SET';var SUBMITTAL_NOTES_ADD='SUBMITTAL_NOTES_ADD';var SUBMITTAL_GC_ACCELERATION_SET='SUBMITTAL_GC_ACCELERATION_SET';var SUBMITTAL_LOG_PDF_VIEWER_SET='SUBMITTAL_LOG_PDF_VIEWER_SET';var SUBMITTAL_LOG_PDF_SET='SUBMITTAL_LOG_PDF_SET';var SUBMITTAL_PDF_VIEWER_SET='SUBMITTAL_PDF_VIEWER_SET';var SUBMITTAL_SHOW_ERROR_MESSAGE_SET='SUBMITTAL_SHOW_ERROR_MESSAGE_SET';var SUBMITTAL_ADDL_ASSIGNEES_ADD='SUBMITTAL_ADDL_ASSIGNEES_ADD';var SUBMITTAL_ADDL_ASSIGNEES_UPDATE='SUBMITTAL_ADDL_ASSIGNEES_UPDATE';var SUBMITTAL_ADDL_ASSIGNEES_DELETE='SUBMITTAL_ADDL_ASSIGNEES_DELETE';var SUBMITTAL_ADDL_ASSIGNEE_RESPONSE='SUBMITTAL_ADDL_ASSIGNEE_RESPONSE';var SUBMITTALS_DELETE='SUBMITTALS_DELETE';

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DAILY_REPORTS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DAILY_REPORTS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return SHOW_ADD_DAILY_REPORT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SET_CONTRIBUTORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SET_CURRENT_DAILY_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_DAILY_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SET_ACTIVE_CONTRIBUTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SET_ACTIVE_ENTRIES_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return LOAD_PRESET_TASKS; });
/* unused harmony export SET_PRESET_TASKS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return INITIALIZE_TRADE_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return UPDATE_TRADE_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_AMOUNT_OF_TECHNICIANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return HANDLE_WORKED_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return HANDLE_WORKED_TO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return HANDLE_HOURS_AMOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return HANDLE_ATTRIBUTE_CHANGE; });
/* unused harmony export SET_IMAGES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return SET_REVIEW_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return SET_REPORT_SUBMITTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLEAR_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SET_DAILY_REPORT_LOG_PDF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SET_DAILY_REPORT_LOG_PDF_VIEWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SET_EDIT_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SET_REPORTS_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DELETE_DAILY_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return SET_REPORT_PDF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return SET_REPORT_PDF_VIEWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return SET_REPORT_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return SET_REPORT_EXTRA_INPUTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return SET_REPORT_EXTRA_INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return SET_REPORT_OPEN_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return SET_REPORT_OPEN_ITEM_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SET_GENERAL_CONTACTOR_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return SET_MEMBER_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return SET_SUPERVISOR_TASKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return SET_MEMBERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SET_DELETED_MEMBERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SET_CURRENT_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return SET_REPORTS_TOTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return SET_REPORTS_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return SET_GCX_IMAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return SET_GCX_DELETED_IMAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SET_DELIVERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DELETE_DELIVERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_EXTRA_INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return REMOVE_DELIVERIES_EXTRA_INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SET_DAILY_REPORT_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return SUB_DAILY_REPORTS_COUNT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return SUB_DAILY_REPORTS_COUNT_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return HANDLE_ATTRIBUTE_CHANGE_FOR_SUB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return HANDLE_HOURS_AMOUNT_MORE_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return HANDLE_DATE_MORE_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return HANDLE_ATTRIBUTE_CHANGE_FOR_SUB_MORE_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADDED_DELETED_TECHNICIANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FIELD_WORK_ORDERS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return SET_SHOW_FIELD_WORK_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FIELD_WORK_ORDER_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FIELD_WORK_ORDER_FORM_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FIELD_WORK_ORDER_FORM_ATTRIBUTE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SET_FIELD_WORK_ORDER_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return UPDATE_FIELD_WORK_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return SET_SHOW_FIELD_WORK_ORDER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SET_DAILY_REPORT_ADD_FLOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DUPLICATE_DAILY_REPORT_SUCCESS; });
var DAILY_REPORTS_SET='DAILY_REPORTS_SET';var DAILY_REPORTS_UPDATE='DAILY_REPORTS_UPDATE';var SHOW_ADD_DAILY_REPORT_SET='SHOW_ADD_DAILY_REPORT_SET';var SET_CONTRIBUTORS='SET_CONTRIBUTORS';var SET_CURRENT_DAILY_REPORT='SET_CURRENT_DAILY_REPORT';var ADD_DAILY_REPORT_SUCCESS='ADD_DAILY_REPORT_SUCCESS';var SET_ACTIVE_CONTRIBUTOR='SET_ACTIVE_CONTRIBUTOR';var SET_ACTIVE_ENTRIES_ID='SET_ACTIVE_ENTRIES_ID';var LOAD_PRESET_TASKS='LOAD_PRESET_TASKS';var SET_PRESET_TASKS='SET_PRESET_TASKS';var INITIALIZE_TRADE_FORM='INITIALIZE_TRADE_FORM';var UPDATE_TRADE_FORM='UPDATE_TRADE_FORM';var CHANGE_AMOUNT_OF_TECHNICIANS='CHANGE_AMOUNT_OF_TECHNICIANS';var HANDLE_WORKED_FORM='HANDLE_WORKED_FORM';var HANDLE_WORKED_TO='HANDLE_WORKED_TO';var HANDLE_HOURS_AMOUNT='HANDLE_HOURS_AMOUNT';var HANDLE_ATTRIBUTE_CHANGE='HANDLE_ATTRIBUTE_CHANGE';var SET_IMAGES='SET_IMAGES';var SET_REVIEW_FORM='SET_REVIEW_FORM';var SET_REPORT_SUBMITTED='SET_REPORT_SUBMITTED';var CLEAR_FORM='CLEAR_FORM';var SET_DAILY_REPORT_LOG_PDF='SET_DAILY_REPORT_LOG_PDF';var SET_DAILY_REPORT_LOG_PDF_VIEWER='SET_DAILY_REPORT_LOG_PDF_VIEWER';var SET_EDIT_MODE='SET_EDIT_MODE';var SET_REPORTS_IDS='SET_REPORTS_IDS';var DELETE_DAILY_REPORT='DELETE_DAILY_REPORT';var SET_REPORT_PDF='SET_REPORT_PDF';var SET_REPORT_PDF_VIEWER='SET_REPORT_PDF_VIEWER';var SET_REPORT_DATE='SET_REPORT_DATE';var SET_REPORT_EXTRA_INPUTS='SET_REPORT_EXTRA_INPUTS';var SET_REPORT_EXTRA_INPUT='SET_REPORT_EXTRA_INPUT';var SET_REPORT_OPEN_ITEM='SET_REPORT_OPEN_ITEM';var SET_REPORT_OPEN_ITEM_VALUE='SET_REPORT_OPEN_ITEM_VALUE';var SET_GENERAL_CONTACTOR_NAME='SET_GENERAL_CONTACTOR_NAME';var SET_MEMBER_FORM='SET_MEMBER_FORM';var SET_SUPERVISOR_TASKS='SET_SUPERVISOR_TASKS';var SET_MEMBERS='SET_MEMBERS';var SET_DELETED_MEMBERS='SET_DELETED_MEMBERS';var SET_CURRENT_PAGE='SET_CURRENT_PAGE';var SET_REPORTS_TOTAL='SET_REPORTS_TOTAL';var SET_REPORTS_PAGE_SIZE='SET_REPORTS_PAGE_SIZE';var SET_GCX_IMAGES='SET_GCX_IMAGES';var SET_GCX_DELETED_IMAGES='SET_GCX_DELETED_IMAGES';var SET_DELIVERY='SET_DELIVERY';var DELETE_DELIVERY='DELETE_DELIVERY';var ADD_EXTRA_INPUT='ADD_EXTRA_INPUT';var REMOVE_DELIVERIES_EXTRA_INPUT='REMOVE_DELIVERIES_EXTRA_INPUT';var SET_DAILY_REPORT_TAB='SET_DAILY_REPORT_TAB';var SUB_DAILY_REPORTS_COUNT_SUCCESS='SUB_DAILY_REPORTS_COUNT_SUCCESS';var SUB_DAILY_REPORTS_COUNT_INIT='SUB_DAILY_REPORTS_COUNT_INIT';var HANDLE_ATTRIBUTE_CHANGE_FOR_SUB='HANDLE_ATTRIBUTE_CHANGE_FOR_SUB';var HANDLE_HOURS_AMOUNT_MORE_INFO='HANDLE_HOURS_AMOUNT_MORE_INFO';var HANDLE_DATE_MORE_INFO='HANDLE_DATE_MORE_INFO';var HANDLE_ATTRIBUTE_CHANGE_FOR_SUB_MORE_ACTION='HANDLE_ATTRIBUTE_CHANGE_FOR_SUB_MORE_ACTION';var ADDED_DELETED_TECHNICIANS='ADDED_DELETED_TECHNICIANS';var FIELD_WORK_ORDERS_SET='FIELD_WORK_ORDERS_SET';var SET_SHOW_FIELD_WORK_ORDER='SET_SHOW_FIELD_WORK_ORDER';var FIELD_WORK_ORDER_SET='FIELD_WORK_ORDER_SET';var FIELD_WORK_ORDER_FORM_INIT='FIELD_WORK_ORDER_FORM_INIT';var FIELD_WORK_ORDER_FORM_ATTRIBUTE_SET='FIELD_WORK_ORDER_FORM_ATTRIBUTE_SET';var SET_FIELD_WORK_ORDER_EDIT='SET_FIELD_WORK_ORDER_EDIT';var UPDATE_FIELD_WORK_ORDER_SUCCESS='UPDATE_FIELD_WORK_ORDER_SUCCESS';var SET_SHOW_FIELD_WORK_ORDER_ERROR='SET_SHOW_FIELD_WORK_ORDER_ERROR';var SET_DAILY_REPORT_ADD_FLOOR='SET_DAILY_REPORT_ADD_FLOOR';var DUPLICATE_DAILY_REPORT_SUCCESS='DUPLICATE_DAILY_REPORT_SUCCESS';

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return OPEN_ITEMS_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return OPEN_ITEMS_MODAL_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OPEN_ITEMS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return OPEN_ITEM_FORM_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return OPEN_ITEM_FORM_MODAL_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return OPEN_ITEM_FORM_ATTR_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return OPEN_ITEM_FORM_ERRORS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return OPEN_ITEM_FORM_ERRORS_ATTR_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return OPEN_ITEM_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return OPEN_ITEM_FORM_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return OPEN_ITEM_FORM_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return OPEN_ITEM_DETAILS_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return OPEN_ITEM_DETAILS_MODAL_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return OPEN_ITEM_DETAILS_MODAL_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return OPEN_ITEM_DETAILS_MODAL_EDIT_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return OPEN_ITEM_DETAILS_MODAL_RESPOND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return OPEN_ITEM_DETAILS_MODAL_RESPOND_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return OPEN_ITEM_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return OPEN_ITEM_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return OPEN_ITEM_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OPEN_ITEMS_COUNT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_ITEMS_COUNT_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OPEN_ITEMS_CRITICAL_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return OPEN_ITEM_NOTES_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return OPEN_ITEM_NOTE_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return OPEN_ITEM_NOTE_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return OPEN_ITEM_UPDATE_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return OPEN_ITEM_PDF_VIEWER_SET; });
var OPEN_ITEMS_MODAL_SHOW='OPEN_ITEMS_MODAL_SHOW';var OPEN_ITEMS_MODAL_CLOSE='OPEN_ITEMS_MODAL_CLOSE';var OPEN_ITEMS_LOAD_SUCCESS='OPEN_ITEMS_LOAD_SUCCESS';var OPEN_ITEM_FORM_MODAL_SHOW='OPEN_ITEM_FORM_MODAL_SHOW';var OPEN_ITEM_FORM_MODAL_CLOSE='OPEN_ITEM_FORM_MODAL_CLOSE';var OPEN_ITEM_FORM_ATTR_SET='OPEN_ITEM_FORM_ATTR_SET';var OPEN_ITEM_FORM_ERRORS_SET='OPEN_ITEM_FORM_ERRORS_SET';var OPEN_ITEM_FORM_ERRORS_ATTR_CLEAR='OPEN_ITEM_FORM_ERRORS_ATTR_CLEAR';var OPEN_ITEM_CREATE_SUCCESS='OPEN_ITEM_CREATE_SUCCESS';var OPEN_ITEM_FORM_SET='OPEN_ITEM_FORM_SET';var OPEN_ITEM_FORM_RESET='OPEN_ITEM_FORM_RESET';var OPEN_ITEM_DETAILS_MODAL_SHOW='OPEN_ITEM_DETAILS_MODAL_SHOW';var OPEN_ITEM_DETAILS_MODAL_CLOSE='OPEN_ITEM_DETAILS_MODAL_CLOSE';var OPEN_ITEM_DETAILS_MODAL_EDIT='OPEN_ITEM_DETAILS_MODAL_EDIT';var OPEN_ITEM_DETAILS_MODAL_EDIT_CANCEL='OPEN_ITEM_DETAILS_MODAL_EDIT_CANCEL';var OPEN_ITEM_DETAILS_MODAL_RESPOND='OPEN_ITEM_DETAILS_MODAL_RESPOND';var OPEN_ITEM_DETAILS_MODAL_RESPOND_CANCEL='OPEN_ITEM_DETAILS_MODAL_RESPOND_CANCEL';var OPEN_ITEM_LOAD_SUCCESS='OPEN_ITEM_LOAD_SUCCESS';var OPEN_ITEM_UPDATE_SUCCESS='OPEN_ITEM_UPDATE_SUCCESS';var OPEN_ITEM_DELETE_SUCCESS='OPEN_ITEM_DELETE_SUCCESS';var OPEN_ITEMS_COUNT_SUCCESS='OPEN_ITEMS_COUNT_SUCCESS';var OPEN_ITEMS_COUNT_INIT='OPEN_ITEMS_COUNT_INIT';var OPEN_ITEMS_CRITICAL_SET='OPEN_ITEMS_CRITICAL_SET';var OPEN_ITEM_NOTES_LOAD_SUCCESS='OPEN_ITEM_NOTES_LOAD_SUCCESS';var OPEN_ITEM_NOTE_CREATE_SUCCESS='OPEN_ITEM_NOTE_CREATE_SUCCESS';var OPEN_ITEM_NOTE_CLEAR='OPEN_ITEM_NOTE_CLEAR';var OPEN_ITEM_UPDATE_VALUE='OPEN_ITEM_UPDATE_VALUE';var OPEN_ITEM_PDF_VIEWER_SET='OPEN_ITEM_PDF_VIEWER_SET';

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DIRECTORY_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DIRECTORY_PDF_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SHOW_NEW_CONTRIBUTOR_MODAL_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SHOW_EDIT_USER_MODAL_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NEW_CONTRIBUTOR_MODAL_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SERVICE_PROVIDER_USERS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PROJECT_CONTRIBUTORS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PROJECT_CONTRIBUTORS_UPDATE_WITH_EDIT_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SHOW_NEW_COMPANY_FORM_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SHOW_SELECT_USERS_FORM_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SHOW_INVITE_USER_FORM_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SHOW_DIRECTORY_PDF_VIEWER_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CURRENT_CONTRIBUTOR_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NEW_CONTRIBUTOR_TYPE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONTRIBUTOR_SETTINGS_TOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return USER_SETTINGS_TOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PROJECT_CONTRIBUTORS_DELETE; });
var DIRECTORY_SET='DIRECTORY_SET';var DIRECTORY_PDF_SET='DIRECTORY_PDF_SET';var SHOW_NEW_CONTRIBUTOR_MODAL_SET='SHOW_NEW_CONTRIBUTOR_MODAL_SET';var SHOW_EDIT_USER_MODAL_SET='SHOW_EDIT_USER_MODAL_SET';var NEW_CONTRIBUTOR_MODAL_INIT='NEW_CONTRIBUTOR_MODAL_INIT';var SERVICE_PROVIDER_USERS_SET='SERVICE_PROVIDER_USERS_SET';var PROJECT_CONTRIBUTORS_UPDATE='PROJECT_CONTRIBUTORS_UPDATE';var PROJECT_CONTRIBUTORS_UPDATE_WITH_EDIT_USER='PROJECT_CONTRIBUTORS_UPDATE_WITH_EDIT_USER';var SHOW_NEW_COMPANY_FORM_SET='SHOW_NEW_COMPANY_FORM_SET';var SHOW_SELECT_USERS_FORM_SET='SHOW_SELECT_USERS_FORM_SET';var SHOW_INVITE_USER_FORM_SET='SHOW_INVITE_USER_FORM_SET';var SHOW_DIRECTORY_PDF_VIEWER_SET='SHOW_DIRECTORY_PDF_VIEWER_SET';var CURRENT_CONTRIBUTOR_SET='CURRENT_CONTRIBUTOR_SET';var NEW_CONTRIBUTOR_TYPE_SET='NEW_CONTRIBUTOR_TYPE_SET';var CONTRIBUTOR_SETTINGS_TOGGLE='CONTRIBUTOR_SETTINGS_TOGGLE';var USER_SETTINGS_TOGGLE='USER_SETTINGS_TOGGLE';var PROJECT_CONTRIBUTORS_DELETE='PROJECT_CONTRIBUTORS_DELETE';

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INIT_PROJECT_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TOGGLE_CREATE_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return TOGGLE_CREATE_PROPOSAL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return TOGGLE_PDF_VIEWER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return TOGGLE_APPROVE_PROPOSAL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PROJECT_PROPOSAL_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PROJECT_PROPOSAL_PDF_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PROJECT_PROPOSAL_ITEMS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PROJECT_PROPOSAL_ADDL_ITEM_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PROJECT_PROPOSAL_ADDL_ITEM_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PROJECT_PROPOSAL_ITEM_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PROJECT_PROPOSAL_ITEM_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PROJECT_PROPOSAL_SUB_ITEM_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PROJECT_PROPOSAL_SUB_ITEM_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PROJECT_PROPOSAL_FORM_VALUE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CSI_CODES_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PROJECT_PROPOSAL_ITEM_DELETE_TOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PROJECT_PROPOSAL_ITEMS_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PROJECT_PROPOSAL_READ_ONLY_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AWARD_RECOMMENDATION_TOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_SHOW_CANCEL_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_SHOW_LOST_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_DATE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INIT_PROJECT_LOST_CANCEL_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_TERMINATION_CATEGORY; });
var INIT_PROJECT_PROPOSAL='INIT_PROJECT_PROPOSAL';var TOGGLE_CREATE_PROPOSAL='TOGGLE_CREATE_PROPOSAL';var TOGGLE_CREATE_PROPOSAL_SUCCESS='TOGGLE_CREATE_PROPOSAL_SUCCESS';var TOGGLE_PDF_VIEWER_SUCCESS='TOGGLE_PDF_VIEWER_SUCCESS';var TOGGLE_APPROVE_PROPOSAL_SUCCESS='TOGGLE_APPROVE_PROPOSAL_SUCCESS';var PROJECT_PROPOSAL_SET='PROJECT_PROPOSAL_SET';var PROJECT_PROPOSAL_PDF_SET='PROJECT_PROPOSAL_PDF_SET';var PROJECT_PROPOSAL_ITEMS_SET='PROJECT_PROPOSAL_ADDL_ITEMS_SET';var PROJECT_PROPOSAL_ADDL_ITEM_ADD='PROJECT_PROPOSAL_ADDL_ITEM_ADD';var PROJECT_PROPOSAL_ADDL_ITEM_VALUE_UPDATE='PROJECT_PROPOSAL_ADDL_ITEM_VALUE_UPDATE';var PROJECT_PROPOSAL_ITEM_ADD='PROJECT_PROPOSAL_ITEM_ADD';var PROJECT_PROPOSAL_ITEM_VALUE_UPDATE='PROJECT_PROPOSAL_ITEM_VALUE_UPDATE';var PROJECT_PROPOSAL_SUB_ITEM_ADD='PROJECT_PROPOSAL_SUB_ITEM_ADD';var PROJECT_PROPOSAL_SUB_ITEM_VALUE_UPDATE='PROJECT_PROPOSAL_SUB_ITEM_VALUE_UPDATE';var PROJECT_PROPOSAL_FORM_VALUE_UPDATE='PROJECT_PROPOSAL_FORM_VALUE_UPDATE';var CSI_CODES_SET='CSI_CODES_SET';var PROJECT_PROPOSAL_ITEM_DELETE_TOGGLE='PROJECT_PROPOSAL_ITEM_DELETE_TOGGLE';var PROJECT_PROPOSAL_ITEMS_RESET='PROJECT_PROPOSAL_ITEMS_RESET';var PROJECT_PROPOSAL_READ_ONLY_SET='PROJECT_PROPOSAL_READ_ONLY_SET';var AWARD_RECOMMENDATION_TOGGLE='AWARD_RECOMMENDATION_TOGGLE';var SET_SHOW_CANCEL_MODAL='SET_SHOW_CANCEL_MODAL';var SET_SHOW_LOST_MODAL='SET_SHOW_LOST_MODAL';var SET_DATE_MODAL='SET_DATE_MODAL';var SET_MESSAGE='SET_MESSAGE';var INIT_PROJECT_LOST_CANCEL_MODAL='INIT_PROJECT_LOST_CANCEL_MODAL';var SET_TERMINATION_CATEGORY='SET_TERMINATION_CATEGORY';

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getMeetingInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getMeetingInfoEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getMeetings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getShowPdfViewer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getMeetingPdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getMeetingModalShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getMeetingCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getMeetingForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getMeetingItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getShowAttendeesModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getReviewMeeting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getMeetingItemSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentMeeting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getConfirmationMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getConfirmApproval; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getMeetingInfo=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.meetingMinutes.data.meetingInfo;},function(meetingInfo){return meetingInfo;});var getMeetingInfoEdit=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.meetingMinutes.ui.meetingInfoEdit;},function(meetingInfoEdit){return meetingInfoEdit;});var getMeetings=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.meetingMinutes.data.meetings;},function(meetings){return meetings;});var getShowPdfViewer=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.meetingMinutes.ui.showPdfViewer;},function(showPdfViewer){return showPdfViewer;});var getMeetingPdf=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.meetingMinutes.data.meetingPdf;},function(meetingPdf){return meetingPdf;});var getMeetingModalShow=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.meetingMinutes.ui.meetingModalShow;},function(meetingModalShow){return meetingModalShow;});var getMeetingCategories=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.meetingMinutes.data.meetingCategories;},function(meetingCategories){return meetingCategories;});var getMeetingForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.meetingMinutes.ui.meetingForm;},function(meetingForm){return meetingForm;});var getMeetingItems=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.meetingMinutes.ui.meetingItems;},function(meetingItems){return meetingItems;});var getShowAttendeesModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.meetingMinutes.ui.showAttendeesModal;},function(showAttendeesModal){return showAttendeesModal;});var getReviewMeeting=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.meetingMinutes.ui.reviewMeeting;},function(reviewMeeting){return reviewMeeting;});var getMeetingItemSettings=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.meetingMinutes.ui.meetingItemSettings;},function(meetingItemSettings){return meetingItemSettings;});var getCurrentMeeting=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.meetingMinutes.data.currentMeeting;},function(currentMeeting){return currentMeeting;});var getConfirmationMsg=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.meetingMinutes.ui.confirmationMsg;},function(confirmationMsg){return confirmationMsg;});var getConfirmApproval=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.meetingMinutes.ui.confirmApproval;},function(confirmApproval){return confirmApproval;});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MeetingStatusKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MeetingStatusEnum; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var keys={};var MeetingStatusKeys={DRAFT:'draft',PENDING:'pending',APPROVED:'approved'};var MeetingStatusEnum=function(){function MeetingStatusEnum(status,label){_classCallCheck(this,MeetingStatusEnum);this.status=status;this.label=label;keys[status]=this;}_createClass(MeetingStatusEnum,[{key:'equals',value:function equals(meetingStatusEnum){return this.status===meetingStatusEnum.status;}}],[{key:'create',value:function create(status){if(keys[status]){return keys[status];}return MeetingStatusEnum.UNKNOWN;}}]);return MeetingStatusEnum;}();MeetingStatusEnum.DRAFT=new MeetingStatusEnum('draft','draft');MeetingStatusEnum.PENDING=new MeetingStatusEnum('pending','pending');MeetingStatusEnum.APPROVED=new MeetingStatusEnum('approved','published');

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_pdf_viewer_PdfViewer__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_email_modal_store_selectors__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_rfi_log_store_selectors__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_rfi_log_store_actions__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_email_modal_ProjectEmailModal__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_rfi_log_RfiModal__ = __webpack_require__(2579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RfiModalContainer=function(_Component){_inherits(RfiModalContainer,_Component);function RfiModalContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RfiModalContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RfiModalContainer.__proto__||Object.getPrototypeOf(RfiModalContainer)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseRfiModal=function(){var _this$props=_this.props,onClose=_this$props.onClose,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_rfi_log_store_actions__["x" /* setRfiModalShow */])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_rfi_log_store_actions__["s" /* setCurrentRfi */])(null));dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_rfi_log_store_actions__["A" /* setRfiReadOnly */])(false));onClose&&onClose();},_this.handleRfiPdfViewerClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_rfi_log_store_actions__["y" /* setRfiPdfViewer */])(false));},_this.handleSendEmail=function(emailsData){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_actions__["d" /* sendProjectResourceEmails */])(_this.props.currentRfi.id,'Rfi',emailsData));},_this.buildEmailModalTitle=function(){var _this$props2=_this.props,currentProject=_this$props2.currentProject,currentRfi=_this$props2.currentRfi;return'RFI '+Object(__WEBPACK_IMPORTED_MODULE_4_services_utils_text_util__["b" /* formatNumber */])(currentRfi.number)+' (Project #'+currentProject.number+': '+currentProject.name+')';},_this.buildEmailModalSubject=function(){var _this$props3=_this.props,currentProject=_this$props3.currentProject,currentRfi=_this$props3.currentRfi;return currentProject.number+', '+currentProject.name+' - RFI '+Object(__WEBPACK_IMPORTED_MODULE_4_services_utils_text_util__["b" /* formatNumber */])(currentRfi.number)+' - '+currentRfi.title;},_this.buildEmailModalMessage=function(){var _this$props4=_this.props,currentProject=_this$props4.currentProject,currentRfi=_this$props4.currentRfi;var location='';if(currentProject.building&&currentProject.building.location){var buildingLocation=currentProject.building.location;location=' at '+buildingLocation.street_address_1+', '+buildingLocation.city+' '+buildingLocation.state;}return'Please find the attached RFI '+Object(__WEBPACK_IMPORTED_MODULE_4_services_utils_text_util__["b" /* formatNumber */])(currentRfi.number)+' for Project '+currentProject.name+location+'. If you have any questions, please reach out via chat or email.';},_this.currentOrNextNumber=function(){var _this$props5=_this.props,currentRfi=_this$props5.currentRfi,rfis=_this$props5.rfis;return currentRfi?Object(__WEBPACK_IMPORTED_MODULE_4_services_utils_text_util__["b" /* formatNumber */])(currentRfi.number):Object(__WEBPACK_IMPORTED_MODULE_4_services_utils_text_util__["b" /* formatNumber */])(rfis.length+1);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RfiModalContainer,[{key:'render',value:function render(){var _props=this.props,currentUser=_props.currentUser,currentProject=_props.currentProject,currentRfi=_props.currentRfi,rfiModalShow=_props.rfiModalShow,rfiReadOnly=_props.rfiReadOnly,rfiGcAcceleration=_props.rfiGcAcceleration,rfiPdfViewer=_props.rfiPdfViewer,showEmailModal=_props.showEmailModal;var contribType=currentProject&&currentProject.contributor_type;return currentProject&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,rfiModalShow&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_rfi_log_RfiModal__["a" /* default */],{currentUser:currentUser,contribType:contribType,project:currentProject,number:this.currentOrNextNumber(),show:rfiModalShow,currentRfi:currentRfi,readOnly:rfiReadOnly,gcAcceleration:rfiGcAcceleration,handleClose:this.handleCloseRfiModal}),rfiPdfViewer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:currentRfi.pdf_document.document.url+'?time='+__WEBPACK_IMPORTED_MODULE_13_moment___default()().unix(),type:'url'},show:rfiPdfViewer,onClose:this.handleRfiPdfViewerClose}),showEmailModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_email_modal_ProjectEmailModal__["a" /* default */],{title:this.buildEmailModalTitle(),handleSendEmail:this.handleSendEmail,projectId:currentProject.id,initialSubject:this.buildEmailModalSubject(),initialMessage:this.buildEmailModalMessage(),showHistoryButton:true,itemType:'Rfi',itemId:currentRfi.id}));}}]);return RfiModalContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RfiModalContainer.propTypes={onClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};RfiModalContainer.defaultProps={onClose:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_authentication__["d" /* getCurrentUser */])(state),currentProject:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),rfis:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_rfi_log_store_selectors__["q" /* getRfis */])(state),rfiModalShow:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_rfi_log_store_selectors__["j" /* getRfiModalShow */])(state),currentRfi:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_rfi_log_store_selectors__["b" /* getCurrentRfi */])(state),rfiReadOnly:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_rfi_log_store_selectors__["n" /* getRfiReadOnly */])(state),rfiGcAcceleration:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_rfi_log_store_selectors__["g" /* getRfiGcAcceleration */])(state),rfiPdfViewer:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_rfi_log_store_selectors__["k" /* getRfiPdfViewer */])(state),showEmailModal:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_email_modal_store_selectors__["g" /* getShowEmailModal */])(state)};})(RfiModalContainer));

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bluebeamApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BluebeamApi=function(_BaseApi){_inherits(BluebeamApi,_BaseApi);function BluebeamApi(){_classCallCheck(this,BluebeamApi);return _possibleConstructorReturn(this,(BluebeamApi.__proto__||Object.getPrototypeOf(BluebeamApi)).apply(this,arguments));}_createClass(BluebeamApi,[{key:'isAuthorized',value:function isAuthorized(){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/bluebeam/authorized').then(function(response){return{ok:true,data:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'authorize',value:function authorize(documentId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/bluebeam/authorize?doc_id='+documentId).then(function(response){return{ok:true,url:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'editInBluebeam',value:function editInBluebeam(documentId,documentSrc){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/bluebeam/open_session?doc_id='+documentId+'&src='+documentSrc).then(function(response){return{ok:true,url:response.data.url};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'closeSession',value:function closeSession(sessionId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/bluebeam/close_session?id='+sessionId).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'inviteUsers',value:function inviteUsers(recipients,projectId,documentId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/bluebeam/invite_users',{recipients:recipients,project_id:projectId,document_id:documentId}).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'generateSnapshot',value:function generateSnapshot(documentId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/bluebeam/generate_snapshot',{document_id:documentId}).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return BluebeamApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var bluebeamApi=new BluebeamApi();

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATED_BB_SESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATED_BB_SNAPSHOT; });
/* harmony export (immutable) */ __webpack_exports__["c"] = createdBluebeamSession;
/* harmony export (immutable) */ __webpack_exports__["d"] = createdBluebeamSnapshot;
var CREATED_BB_SESSION='CREATED_BB_SESSION';var CREATED_BB_SNAPSHOT='CREATED_BB_SNAPSHOT';function createdBluebeamSession(){return{type:CREATED_BB_SESSION};}function createdBluebeamSnapshot(){return{type:CREATED_BB_SNAPSHOT};}

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = savedPdfTronSuccess;
/* harmony export (immutable) */ __webpack_exports__["b"] = resetPdfTronMessages;
/* harmony export (immutable) */ __webpack_exports__["a"] = initProjectEmailModal;
/* harmony export (immutable) */ __webpack_exports__["f"] = setShowModal;
/* harmony export (immutable) */ __webpack_exports__["d"] = setEmails;
/* unused harmony export addEmail */
/* unused harmony export addRecipient */
/* harmony export (immutable) */ __webpack_exports__["e"] = setRecipients;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_shared_pdf_viewer_bluebeam_store_action_types__ = __webpack_require__(1032);
function savedPdfTronSuccess(response){return{type:__WEBPACK_IMPORTED_MODULE_0_components_shared_pdf_viewer_bluebeam_store_action_types__["e" /* SAVED_PDFTRON_SUCCESS */],payload:response};}function resetPdfTronMessages(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_shared_pdf_viewer_bluebeam_store_action_types__["d" /* RESET_PDFTRON_MESSAGES */]};}function initProjectEmailModal(payload){return{type:__WEBPACK_IMPORTED_MODULE_0_components_shared_pdf_viewer_bluebeam_store_action_types__["c" /* INIT_PROJECT_EMAIL_MODAL */],payload:payload};}function setShowModal(payload){return{type:__WEBPACK_IMPORTED_MODULE_0_components_shared_pdf_viewer_bluebeam_store_action_types__["h" /* SET_SHOW_MODAL */],payload:payload};}function setEmails(emails){return{type:__WEBPACK_IMPORTED_MODULE_0_components_shared_pdf_viewer_bluebeam_store_action_types__["f" /* SET_EMAILS */],payload:emails};}function addEmail(emails){return{type:__WEBPACK_IMPORTED_MODULE_0_components_shared_pdf_viewer_bluebeam_store_action_types__["a" /* ADD_EMAIL */],payload:emails};}function addRecipient(recipient){return{type:__WEBPACK_IMPORTED_MODULE_0_components_shared_pdf_viewer_bluebeam_store_action_types__["b" /* ADD_RECIPIENT */],payload:recipient};}function setRecipients(recipients){return{type:__WEBPACK_IMPORTED_MODULE_0_components_shared_pdf_viewer_bluebeam_store_action_types__["g" /* SET_RECIPIENTS */],payload:recipients};}

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/done.393162c7.svg";

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_pdf_viewer_PdfViewer__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_domain_submittal_status_enum__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_email_modal_store_selectors__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_submittal_log_store_selectors__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_submittal_log_store_actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_email_modal_ProjectEmailModal__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_submittal_log_SubmittalModal__ = __webpack_require__(2607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubmittalModalContainer=function(_Component){_inherits(SubmittalModalContainer,_Component);function SubmittalModalContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SubmittalModalContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SubmittalModalContainer.__proto__||Object.getPrototypeOf(SubmittalModalContainer)).call.apply(_ref,[this].concat(args))),_this),_this.showLeadTime=function(submittal){var submittalStatus=__WEBPACK_IMPORTED_MODULE_4_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].create(submittal.status);return!!submittal.closed&&(__WEBPACK_IMPORTED_MODULE_4_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].APPROVED.equals(submittalStatus)||__WEBPACK_IMPORTED_MODULE_4_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].APPROVED_AS_NOTED.equals(submittalStatus));},_this.handleCloseSubmittalModal=function(){var _this$props=_this.props,onClose=_this$props.onClose,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_submittal_log_store_actions__["y" /* setSubmittalModalShow */])(false));onClose&&onClose();},_this.handleTransmittalPdfClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_submittal_log_store_actions__["t" /* setShowTransmittalPdf */])(false));},_this.handleSubmittalPdfViewerClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_submittal_log_store_actions__["z" /* setSubmittalPdfViewer */])(false));},_this.handleSendEmail=function(emailsData){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_actions__["d" /* sendProjectResourceEmails */])(_this.props.currentSubmittal.id,'Submittal',emailsData));},_this.buildEmailModalTitle=function(){var _this$props2=_this.props,currentProject=_this$props2.currentProject,currentSubmittal=_this$props2.currentSubmittal;return'Submittal #'+currentSubmittal.csi_code.division+'-'+currentSubmittal.number+' (Project #'+currentProject.number+': '+currentProject.name+')';},_this.buildEmailModalSubject=function(){var _this$props3=_this.props,currentProject=_this$props3.currentProject,currentSubmittal=_this$props3.currentSubmittal;return currentProject.number+', '+currentProject.name+' - Submittal '+currentSubmittal.csi_code.division+'-'+currentSubmittal.number+' - '+currentSubmittal.title;},_this.buildEmailModalMessage=function(){var _this$props4=_this.props,currentProject=_this$props4.currentProject,currentSubmittal=_this$props4.currentSubmittal;var location='';if(currentProject.building&&currentProject.building.location){var buildingLocation=currentProject.building.location;location=' at '+buildingLocation.street_address_1+', '+buildingLocation.city+' '+buildingLocation.state;}return'Please find the attached Submittal #'+currentSubmittal.csi_code.division+'-'+currentSubmittal.number+' for Project '+currentProject.name+location+'. If you have any questions, please reach out via chat or email.';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SubmittalModalContainer,[{key:'render',value:function render(){var _props=this.props,currentUser=_props.currentUser,currentProject=_props.currentProject,currentSubmittal=_props.currentSubmittal,submittalModalShow=_props.submittalModalShow,showTransmittalPdf=_props.showTransmittalPdf,transmittalPdf=_props.transmittalPdf,submittalPdfViewer=_props.submittalPdfViewer,showEmailModal=_props.showEmailModal;return currentProject&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,submittalModalShow&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_submittal_log_SubmittalModal__["a" /* default */],{currentUser:currentUser,project:currentProject,submittal:currentSubmittal,show:submittalModalShow,showLeadTime:!!currentSubmittal&&this.showLeadTime(currentSubmittal),handleClose:this.handleCloseSubmittalModal}),showTransmittalPdf&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:transmittalPdf,type:'blob'},show:showTransmittalPdf,onClose:this.handleTransmittalPdfClose}),submittalPdfViewer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:currentSubmittal.pdf_document.document.url+'?time='+__WEBPACK_IMPORTED_MODULE_13_moment___default()().unix(),type:'url'},show:submittalPdfViewer,onClose:this.handleSubmittalPdfViewerClose}),showEmailModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_email_modal_ProjectEmailModal__["a" /* default */],{title:this.buildEmailModalTitle(),handleSendEmail:this.handleSendEmail,projectId:currentProject.id,initialSubject:this.buildEmailModalSubject(),initialMessage:this.buildEmailModalMessage(),showHistoryButton:true,itemType:'Submittal',itemId:currentSubmittal.id}));}}]);return SubmittalModalContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubmittalModalContainer.propTypes={onClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};SubmittalModalContainer.defaultProps={onClose:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_authentication__["d" /* getCurrentUser */])(state),currentProject:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),currentSubmittal:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_submittal_log_store_selectors__["c" /* getCurrentSubmittal */])(state),submittalModalShow:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_submittal_log_store_selectors__["l" /* getSubmittalModalShow */])(state),showTransmittalPdf:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_submittal_log_store_selectors__["f" /* getShowTransmittalPdf */])(state),transmittalPdf:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_submittal_log_store_selectors__["t" /* getTransmittalPdf */])(state),submittalPdfViewer:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_submittal_log_store_selectors__["n" /* getSubmittalPdfViewer */])(state),showEmailModal:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_email_modal_store_selectors__["g" /* getShowEmailModal */])(state)};})(SubmittalModalContainer));

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SingleTradeForm_css__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SingleTradeForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SingleTradeForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_dropdown_MultipleDropdown__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_checkbox_LabeledCheckBox__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_upload_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_images_upload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_services_utils_files_util__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_domain_project__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_directory_store_selectors__ = __webpack_require__(96);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectOpenItemForm=function(_Component){_inherits(ProjectOpenItemForm,_Component);function ProjectOpenItemForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProjectOpenItemForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProjectOpenItemForm.__proto__||Object.getPrototypeOf(ProjectOpenItemForm)).call.apply(_ref,[this].concat(args))),_this),_this.recipientOptions=function(){return __WEBPACK_IMPORTED_MODULE_17_domain_project__["a" /* Project */].recipientOptions(_this.props);},_this.assigneeOptions=function(){return _this.recipientOptions().map(function(opt){return{value:opt.id,label:opt.label};});},_this.setImages=function(files){var images=[].concat(_toConsumableArray(_this.getImages()));files.forEach(function(val){images.push({url:URL.createObjectURL(val),file:val});});var handleAttributeChange=_this.props.handleAttributeChange;handleAttributeChange('openItemImages',images);},_this.removeImage=function(index){var images=[].concat(_toConsumableArray(_this.getImages()));var deletedImages=[].concat(_toConsumableArray(_this.getDeletedImages()));var deletedImage=images.splice(index,1);deletedImages.push(deletedImage[0]);var handleAttributeChange=_this.props.handleAttributeChange;handleAttributeChange('openItemImages',images);handleAttributeChange('openItemDeletedImages',deletedImages);},_this.getImages=function(){var form=_this.props.form;if(form&&form.openItemImages&&form.openItemImages.length>0){return form.openItemImages;}return[];},_this.getDeletedImages=function(){var form=_this.props.form;if(form&&form.openItemDeletedImages&&form.openItemDeletedImages.length>0){return form.openItemDeletedImages;}return[];},_this.setDocuments=function(files){var docs=[].concat(_toConsumableArray(_this.getDocuments()));files.forEach(function(val){docs.push({file:val,name:val.name});});var handleAttributeChange=_this.props.handleAttributeChange;handleAttributeChange('openItemDocuments',docs);},_this.removeDocument=function(index){var docs=[].concat(_toConsumableArray(_this.getDocuments()));var deletedDocs=[].concat(_toConsumableArray(_this.getDeletedDocuments()));var deletedDoc=docs.splice(index,1);deletedDocs.push(deletedDoc[0]);var handleAttributeChange=_this.props.handleAttributeChange;handleAttributeChange('openItemDocuments',docs);handleAttributeChange('openItemDeletedDocuments',deletedDocs);},_this.getDocuments=function(){var form=_this.props.form;if(form&&form.openItemDocuments&&form.openItemDocuments.length>0){return form.openItemDocuments;}return[];},_this.getDeletedDocuments=function(){var form=_this.props.form;if(form&&form.openItemDeletedDocuments&&form.openItemDeletedDocuments.length>0){return form.openItemDeletedDocuments;}return[];},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProjectOpenItemForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,form=_props.form,errors=_props.errors,handleAttributeChange=_props.handleAttributeChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block assignee-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Assigned To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'single-trade-form-error-field':errors.openItemAssigneeId}),placeholder:'Select Assignee...',onChange:function onChange(option){return handleAttributeChange('openItemAssigneeId',option.value);},value:form.openItemAssigneeId,options:this.assigneeOptions()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block recipients-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'CC Recipient(s)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_dropdown_MultipleDropdown__["a" /* default */],{options:this.recipientOptions(),currentValues:form.openItemRecipients||[],placeholder:'Select Contributors to CC',onChange:function onChange(values){return handleAttributeChange('openItemRecipients',values);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block resolve-by-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Due Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'single-trade-form-error-field':errors.openItemResolveBy})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:__WEBPACK_IMPORTED_MODULE_9_services_utils_date_util__["k" /* todayValidation */],placeholder:'Resolve By',onChange:function onChange(value){return handleAttributeChange('openItemResolveBy',value);},value:form.openItemResolveBy}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea___default.a,{rows:2,className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'text-area':true,'input-area':true,'form-control':true,'single-trade-form-error-field':errors.openItemDesc}),onBlur:function onBlur(e){return handleAttributeChange('openItemDesc',e.target.value);},defaultValue:form.openItemDesc})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Mark as Critical'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{onChange:handleAttributeChange.bind(null,'openItemCritical'),checked:form.openItemCritical})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block single-trade-form-block-docs'},form.openItemDocuments&&form.openItemDocuments.map(function(doc,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'doc-viewer',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'remove-doc-icon',src:__WEBPACK_IMPORTED_MODULE_12_images_remove_png___default.a,alt:'remove',onClick:function onClick(){return _this2.removeDocument(index);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_document_DocumentLink__["a" /* default */],{file:doc,url:doc.url}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx',className:'dropzone-container',onDrop:function onDrop(files){return _this2.setDocuments(files);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Please drag and drop any file into this area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11_images_upload_svg___default.a,alt:'upload'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:__WEBPACK_IMPORTED_MODULE_16_services_utils_files_util__["a" /* imageExtensions */],multiple:true,onUpload:function onUpload(files){return _this2.setImages(files);},onRemove:function onRemove(index){return _this2.removeImage(index);},images:this.getImages()})));}}]);return ProjectOpenItemForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProjectOpenItemForm.propTypes={form:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,errors:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,handleAttributeChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{directory:Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_directory_store_selectors__["c" /* getDirectory */])(state)};})(ProjectOpenItemForm));

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FloorButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FloorButton_css__ = __webpack_require__(2630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FloorButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FloorButton_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_button_SimpleButton__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_plus_icon_png__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_plus_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_plus_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_remove_svg__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_remove_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_remove_svg__);
function FloorButton(props){var handleClick=function handleClick(){if(props.onClick&&!props.disabled){props.onClick();}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_SimpleButton__["a" /* default */],{className:'add-floors-button',disabled:props.disabled,img:props.isForAdd?__WEBPACK_IMPORTED_MODULE_4_images_plus_icon_png___default.a:__WEBPACK_IMPORTED_MODULE_5_images_remove_svg___default.a,label:(props.isForAdd?'Add':'Remove')+' floor',onClick:handleClick});}FloorButton.propTypes={disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isForAdd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};FloorButton.defaultProps={disabled:false,isForAdd:false};

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(74);
var JsonBuilder = __webpack_require__(644);
var JsonParser = __webpack_require__(645);

function buildRequest(req) {
  var httpRequest = req.httpRequest;
  var api = req.service.api;
  var target = api.targetPrefix + '.' + api.operations[req.operation].name;
  var version = api.jsonVersion || '1.0';
  var input = api.operations[req.operation].input;
  var builder = new JsonBuilder();

  if (version === 1) version = '1.0';
  httpRequest.body = builder.build(req.params || {}, input);
  httpRequest.headers['Content-Type'] = 'application/x-amz-json-' + version;
  httpRequest.headers['X-Amz-Target'] = target;
}

function extractError(resp) {
  var error = {};
  var httpResponse = resp.httpResponse;

  error.code = httpResponse.headers['x-amzn-errortype'] || 'UnknownError';
  if (typeof error.code === 'string') {
    error.code = error.code.split(':')[0];
  }

  if (httpResponse.body.length > 0) {
    try {
      var e = JSON.parse(httpResponse.body.toString());
      if (e.__type || e.code) {
        error.code = (e.__type || e.code).split('#').pop();
      }
      if (error.code === 'RequestEntityTooLarge') {
        error.message = 'Request body must be less than 1 MB';
      } else {
        error.message = (e.message || e.Message || null);
      }
    } catch (e) {
      error.statusCode = httpResponse.statusCode;
      error.message = httpResponse.statusMessage;
    }
  } else {
    error.statusCode = httpResponse.statusCode;
    error.message = httpResponse.statusCode.toString();
  }

  resp.error = util.error(new Error(), error);
}

function extractData(resp) {
  var body = resp.httpResponse.body.toString() || '{}';
  if (resp.request.service.config.convertResponseTypes === false) {
    resp.data = JSON.parse(body);
  } else {
    var operation = resp.request.service.api.operations[resp.request.operation];
    var shape = operation.output || {};
    var parser = new JsonParser();
    resp.data = parser.parse(body, shape);
  }
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(74);

function JsonBuilder() { }

JsonBuilder.prototype.build = function(value, shape) {
  return JSON.stringify(translate(value, shape));
};

function translate(value, shape) {
  if (!shape || value === undefined || value === null) return undefined;

  switch (shape.type) {
    case 'structure': return translateStructure(value, shape);
    case 'map': return translateMap(value, shape);
    case 'list': return translateList(value, shape);
    default: return translateScalar(value, shape);
  }
}

function translateStructure(structure, shape) {
  var struct = {};
  util.each(structure, function(name, value) {
    var memberShape = shape.members[name];
    if (memberShape) {
      if (memberShape.location !== 'body') return;
      var locationName = memberShape.isLocationName ? memberShape.name : name;
      var result = translate(value, memberShape);
      if (result !== undefined) struct[locationName] = result;
    }
  });
  return struct;
}

function translateList(list, shape) {
  var out = [];
  util.arrayEach(list, function(value) {
    var result = translate(value, shape.member);
    if (result !== undefined) out.push(result);
  });
  return out;
}

function translateMap(map, shape) {
  var out = {};
  util.each(map, function(key, value) {
    var result = translate(value, shape.value);
    if (result !== undefined) out[key] = result;
  });
  return out;
}

function translateScalar(value, shape) {
  return shape.toWireFormat(value);
}

module.exports = JsonBuilder;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(74);

function JsonParser() { }

JsonParser.prototype.parse = function(value, shape) {
  return translate(JSON.parse(value), shape);
};

function translate(value, shape) {
  if (!shape || value === undefined) return undefined;

  switch (shape.type) {
    case 'structure': return translateStructure(value, shape);
    case 'map': return translateMap(value, shape);
    case 'list': return translateList(value, shape);
    default: return translateScalar(value, shape);
  }
}

function translateStructure(structure, shape) {
  if (structure == null) return undefined;

  var struct = {};
  var shapeMembers = shape.members;
  util.each(shapeMembers, function(name, memberShape) {
    var locationName = memberShape.isLocationName ? memberShape.name : name;
    if (Object.prototype.hasOwnProperty.call(structure, locationName)) {
      var value = structure[locationName];
      var result = translate(value, memberShape);
      if (result !== undefined) struct[name] = result;
    }
  });
  return struct;
}

function translateList(list, shape) {
  if (list == null) return undefined;

  var out = [];
  util.arrayEach(list, function(value) {
    var result = translate(value, shape.member);
    if (result === undefined) out.push(null);
    else out.push(result);
  });
  return out;
}

function translateMap(map, shape) {
  if (map == null) return undefined;

  var out = {};
  util.each(map, function(key, value) {
    var result = translate(value, shape.value);
    if (result === undefined) out[key] = null;
    else out[key] = result;
  });
  return out;
}

function translateScalar(value, shape) {
  return shape.toType(value);
}

module.exports = JsonParser;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

(function(exports) {
  "use strict";

  function isArray(obj) {
    if (obj !== null) {
      return Object.prototype.toString.call(obj) === "[object Array]";
    } else {
      return false;
    }
  }

  function isObject(obj) {
    if (obj !== null) {
      return Object.prototype.toString.call(obj) === "[object Object]";
    } else {
      return false;
    }
  }

  function strictDeepEqual(first, second) {
    // Check the scalar case first.
    if (first === second) {
      return true;
    }

    // Check if they are the same type.
    var firstType = Object.prototype.toString.call(first);
    if (firstType !== Object.prototype.toString.call(second)) {
      return false;
    }
    // We know that first and second have the same type so we can just check the
    // first type from now on.
    if (isArray(first) === true) {
      // Short circuit if they're not the same length;
      if (first.length !== second.length) {
        return false;
      }
      for (var i = 0; i < first.length; i++) {
        if (strictDeepEqual(first[i], second[i]) === false) {
          return false;
        }
      }
      return true;
    }
    if (isObject(first) === true) {
      // An object is equal if it has the same key/value pairs.
      var keysSeen = {};
      for (var key in first) {
        if (hasOwnProperty.call(first, key)) {
          if (strictDeepEqual(first[key], second[key]) === false) {
            return false;
          }
          keysSeen[key] = true;
        }
      }
      // Now check that there aren't any keys in second that weren't
      // in first.
      for (var key2 in second) {
        if (hasOwnProperty.call(second, key2)) {
          if (keysSeen[key2] !== true) {
            return false;
          }
        }
      }
      return true;
    }
    return false;
  }

  function isFalse(obj) {
    // From the spec:
    // A false value corresponds to the following values:
    // Empty list
    // Empty object
    // Empty string
    // False boolean
    // null value

    // First check the scalar values.
    if (obj === "" || obj === false || obj === null) {
        return true;
    } else if (isArray(obj) && obj.length === 0) {
        // Check for an empty array.
        return true;
    } else if (isObject(obj)) {
        // Check for an empty object.
        for (var key in obj) {
            // If there are any keys, then
            // the object is not empty so the object
            // is not false.
            if (obj.hasOwnProperty(key)) {
              return false;
            }
        }
        return true;
    } else {
        return false;
    }
  }

  function objValues(obj) {
    var keys = Object.keys(obj);
    var values = [];
    for (var i = 0; i < keys.length; i++) {
      values.push(obj[keys[i]]);
    }
    return values;
  }

  function merge(a, b) {
      var merged = {};
      for (var key in a) {
          merged[key] = a[key];
      }
      for (var key2 in b) {
          merged[key2] = b[key2];
      }
      return merged;
  }

  var trimLeft;
  if (typeof String.prototype.trimLeft === "function") {
    trimLeft = function(str) {
      return str.trimLeft();
    };
  } else {
    trimLeft = function(str) {
      return str.match(/^\s*(.*)/)[1];
    };
  }

  // Type constants used to define functions.
  var TYPE_NUMBER = 0;
  var TYPE_ANY = 1;
  var TYPE_STRING = 2;
  var TYPE_ARRAY = 3;
  var TYPE_OBJECT = 4;
  var TYPE_BOOLEAN = 5;
  var TYPE_EXPREF = 6;
  var TYPE_NULL = 7;
  var TYPE_ARRAY_NUMBER = 8;
  var TYPE_ARRAY_STRING = 9;

  var TOK_EOF = "EOF";
  var TOK_UNQUOTEDIDENTIFIER = "UnquotedIdentifier";
  var TOK_QUOTEDIDENTIFIER = "QuotedIdentifier";
  var TOK_RBRACKET = "Rbracket";
  var TOK_RPAREN = "Rparen";
  var TOK_COMMA = "Comma";
  var TOK_COLON = "Colon";
  var TOK_RBRACE = "Rbrace";
  var TOK_NUMBER = "Number";
  var TOK_CURRENT = "Current";
  var TOK_EXPREF = "Expref";
  var TOK_PIPE = "Pipe";
  var TOK_OR = "Or";
  var TOK_AND = "And";
  var TOK_EQ = "EQ";
  var TOK_GT = "GT";
  var TOK_LT = "LT";
  var TOK_GTE = "GTE";
  var TOK_LTE = "LTE";
  var TOK_NE = "NE";
  var TOK_FLATTEN = "Flatten";
  var TOK_STAR = "Star";
  var TOK_FILTER = "Filter";
  var TOK_DOT = "Dot";
  var TOK_NOT = "Not";
  var TOK_LBRACE = "Lbrace";
  var TOK_LBRACKET = "Lbracket";
  var TOK_LPAREN= "Lparen";
  var TOK_LITERAL= "Literal";

  // The "&", "[", "<", ">" tokens
  // are not in basicToken because
  // there are two token variants
  // ("&&", "[?", "<=", ">=").  This is specially handled
  // below.

  var basicTokens = {
    ".": TOK_DOT,
    "*": TOK_STAR,
    ",": TOK_COMMA,
    ":": TOK_COLON,
    "{": TOK_LBRACE,
    "}": TOK_RBRACE,
    "]": TOK_RBRACKET,
    "(": TOK_LPAREN,
    ")": TOK_RPAREN,
    "@": TOK_CURRENT
  };

  var operatorStartToken = {
      "<": true,
      ">": true,
      "=": true,
      "!": true
  };

  var skipChars = {
      " ": true,
      "\t": true,
      "\n": true
  };


  function isAlpha(ch) {
      return (ch >= "a" && ch <= "z") ||
             (ch >= "A" && ch <= "Z") ||
             ch === "_";
  }

  function isNum(ch) {
      return (ch >= "0" && ch <= "9") ||
             ch === "-";
  }
  function isAlphaNum(ch) {
      return (ch >= "a" && ch <= "z") ||
             (ch >= "A" && ch <= "Z") ||
             (ch >= "0" && ch <= "9") ||
             ch === "_";
  }

  function Lexer() {
  }
  Lexer.prototype = {
      tokenize: function(stream) {
          var tokens = [];
          this._current = 0;
          var start;
          var identifier;
          var token;
          while (this._current < stream.length) {
              if (isAlpha(stream[this._current])) {
                  start = this._current;
                  identifier = this._consumeUnquotedIdentifier(stream);
                  tokens.push({type: TOK_UNQUOTEDIDENTIFIER,
                               value: identifier,
                               start: start});
              } else if (basicTokens[stream[this._current]] !== undefined) {
                  tokens.push({type: basicTokens[stream[this._current]],
                              value: stream[this._current],
                              start: this._current});
                  this._current++;
              } else if (isNum(stream[this._current])) {
                  token = this._consumeNumber(stream);
                  tokens.push(token);
              } else if (stream[this._current] === "[") {
                  // No need to increment this._current.  This happens
                  // in _consumeLBracket
                  token = this._consumeLBracket(stream);
                  tokens.push(token);
              } else if (stream[this._current] === "\"") {
                  start = this._current;
                  identifier = this._consumeQuotedIdentifier(stream);
                  tokens.push({type: TOK_QUOTEDIDENTIFIER,
                               value: identifier,
                               start: start});
              } else if (stream[this._current] === "'") {
                  start = this._current;
                  identifier = this._consumeRawStringLiteral(stream);
                  tokens.push({type: TOK_LITERAL,
                               value: identifier,
                               start: start});
              } else if (stream[this._current] === "`") {
                  start = this._current;
                  var literal = this._consumeLiteral(stream);
                  tokens.push({type: TOK_LITERAL,
                               value: literal,
                               start: start});
              } else if (operatorStartToken[stream[this._current]] !== undefined) {
                  tokens.push(this._consumeOperator(stream));
              } else if (skipChars[stream[this._current]] !== undefined) {
                  // Ignore whitespace.
                  this._current++;
              } else if (stream[this._current] === "&") {
                  start = this._current;
                  this._current++;
                  if (stream[this._current] === "&") {
                      this._current++;
                      tokens.push({type: TOK_AND, value: "&&", start: start});
                  } else {
                      tokens.push({type: TOK_EXPREF, value: "&", start: start});
                  }
              } else if (stream[this._current] === "|") {
                  start = this._current;
                  this._current++;
                  if (stream[this._current] === "|") {
                      this._current++;
                      tokens.push({type: TOK_OR, value: "||", start: start});
                  } else {
                      tokens.push({type: TOK_PIPE, value: "|", start: start});
                  }
              } else {
                  var error = new Error("Unknown character:" + stream[this._current]);
                  error.name = "LexerError";
                  throw error;
              }
          }
          return tokens;
      },

      _consumeUnquotedIdentifier: function(stream) {
          var start = this._current;
          this._current++;
          while (this._current < stream.length && isAlphaNum(stream[this._current])) {
              this._current++;
          }
          return stream.slice(start, this._current);
      },

      _consumeQuotedIdentifier: function(stream) {
          var start = this._current;
          this._current++;
          var maxLength = stream.length;
          while (stream[this._current] !== "\"" && this._current < maxLength) {
              // You can escape a double quote and you can escape an escape.
              var current = this._current;
              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
                                               stream[current + 1] === "\"")) {
                  current += 2;
              } else {
                  current++;
              }
              this._current = current;
          }
          this._current++;
          return JSON.parse(stream.slice(start, this._current));
      },

      _consumeRawStringLiteral: function(stream) {
          var start = this._current;
          this._current++;
          var maxLength = stream.length;
          while (stream[this._current] !== "'" && this._current < maxLength) {
              // You can escape a single quote and you can escape an escape.
              var current = this._current;
              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
                                               stream[current + 1] === "'")) {
                  current += 2;
              } else {
                  current++;
              }
              this._current = current;
          }
          this._current++;
          var literal = stream.slice(start + 1, this._current - 1);
          return literal.replace("\\'", "'");
      },

      _consumeNumber: function(stream) {
          var start = this._current;
          this._current++;
          var maxLength = stream.length;
          while (isNum(stream[this._current]) && this._current < maxLength) {
              this._current++;
          }
          var value = parseInt(stream.slice(start, this._current));
          return {type: TOK_NUMBER, value: value, start: start};
      },

      _consumeLBracket: function(stream) {
          var start = this._current;
          this._current++;
          if (stream[this._current] === "?") {
              this._current++;
              return {type: TOK_FILTER, value: "[?", start: start};
          } else if (stream[this._current] === "]") {
              this._current++;
              return {type: TOK_FLATTEN, value: "[]", start: start};
          } else {
              return {type: TOK_LBRACKET, value: "[", start: start};
          }
      },

      _consumeOperator: function(stream) {
          var start = this._current;
          var startingChar = stream[start];
          this._current++;
          if (startingChar === "!") {
              if (stream[this._current] === "=") {
                  this._current++;
                  return {type: TOK_NE, value: "!=", start: start};
              } else {
                return {type: TOK_NOT, value: "!", start: start};
              }
          } else if (startingChar === "<") {
              if (stream[this._current] === "=") {
                  this._current++;
                  return {type: TOK_LTE, value: "<=", start: start};
              } else {
                  return {type: TOK_LT, value: "<", start: start};
              }
          } else if (startingChar === ">") {
              if (stream[this._current] === "=") {
                  this._current++;
                  return {type: TOK_GTE, value: ">=", start: start};
              } else {
                  return {type: TOK_GT, value: ">", start: start};
              }
          } else if (startingChar === "=") {
              if (stream[this._current] === "=") {
                  this._current++;
                  return {type: TOK_EQ, value: "==", start: start};
              }
          }
      },

      _consumeLiteral: function(stream) {
          this._current++;
          var start = this._current;
          var maxLength = stream.length;
          var literal;
          while(stream[this._current] !== "`" && this._current < maxLength) {
              // You can escape a literal char or you can escape the escape.
              var current = this._current;
              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
                                               stream[current + 1] === "`")) {
                  current += 2;
              } else {
                  current++;
              }
              this._current = current;
          }
          var literalString = trimLeft(stream.slice(start, this._current));
          literalString = literalString.replace("\\`", "`");
          if (this._looksLikeJSON(literalString)) {
              literal = JSON.parse(literalString);
          } else {
              // Try to JSON parse it as "<literal>"
              literal = JSON.parse("\"" + literalString + "\"");
          }
          // +1 gets us to the ending "`", +1 to move on to the next char.
          this._current++;
          return literal;
      },

      _looksLikeJSON: function(literalString) {
          var startingChars = "[{\"";
          var jsonLiterals = ["true", "false", "null"];
          var numberLooking = "-0123456789";

          if (literalString === "") {
              return false;
          } else if (startingChars.indexOf(literalString[0]) >= 0) {
              return true;
          } else if (jsonLiterals.indexOf(literalString) >= 0) {
              return true;
          } else if (numberLooking.indexOf(literalString[0]) >= 0) {
              try {
                  JSON.parse(literalString);
                  return true;
              } catch (ex) {
                  return false;
              }
          } else {
              return false;
          }
      }
  };

      var bindingPower = {};
      bindingPower[TOK_EOF] = 0;
      bindingPower[TOK_UNQUOTEDIDENTIFIER] = 0;
      bindingPower[TOK_QUOTEDIDENTIFIER] = 0;
      bindingPower[TOK_RBRACKET] = 0;
      bindingPower[TOK_RPAREN] = 0;
      bindingPower[TOK_COMMA] = 0;
      bindingPower[TOK_RBRACE] = 0;
      bindingPower[TOK_NUMBER] = 0;
      bindingPower[TOK_CURRENT] = 0;
      bindingPower[TOK_EXPREF] = 0;
      bindingPower[TOK_PIPE] = 1;
      bindingPower[TOK_OR] = 2;
      bindingPower[TOK_AND] = 3;
      bindingPower[TOK_EQ] = 5;
      bindingPower[TOK_GT] = 5;
      bindingPower[TOK_LT] = 5;
      bindingPower[TOK_GTE] = 5;
      bindingPower[TOK_LTE] = 5;
      bindingPower[TOK_NE] = 5;
      bindingPower[TOK_FLATTEN] = 9;
      bindingPower[TOK_STAR] = 20;
      bindingPower[TOK_FILTER] = 21;
      bindingPower[TOK_DOT] = 40;
      bindingPower[TOK_NOT] = 45;
      bindingPower[TOK_LBRACE] = 50;
      bindingPower[TOK_LBRACKET] = 55;
      bindingPower[TOK_LPAREN] = 60;

  function Parser() {
  }

  Parser.prototype = {
      parse: function(expression) {
          this._loadTokens(expression);
          this.index = 0;
          var ast = this.expression(0);
          if (this._lookahead(0) !== TOK_EOF) {
              var t = this._lookaheadToken(0);
              var error = new Error(
                  "Unexpected token type: " + t.type + ", value: " + t.value);
              error.name = "ParserError";
              throw error;
          }
          return ast;
      },

      _loadTokens: function(expression) {
          var lexer = new Lexer();
          var tokens = lexer.tokenize(expression);
          tokens.push({type: TOK_EOF, value: "", start: expression.length});
          this.tokens = tokens;
      },

      expression: function(rbp) {
          var leftToken = this._lookaheadToken(0);
          this._advance();
          var left = this.nud(leftToken);
          var currentToken = this._lookahead(0);
          while (rbp < bindingPower[currentToken]) {
              this._advance();
              left = this.led(currentToken, left);
              currentToken = this._lookahead(0);
          }
          return left;
      },

      _lookahead: function(number) {
          return this.tokens[this.index + number].type;
      },

      _lookaheadToken: function(number) {
          return this.tokens[this.index + number];
      },

      _advance: function() {
          this.index++;
      },

      nud: function(token) {
        var left;
        var right;
        var expression;
        switch (token.type) {
          case TOK_LITERAL:
            return {type: "Literal", value: token.value};
          case TOK_UNQUOTEDIDENTIFIER:
            return {type: "Field", name: token.value};
          case TOK_QUOTEDIDENTIFIER:
            var node = {type: "Field", name: token.value};
            if (this._lookahead(0) === TOK_LPAREN) {
                throw new Error("Quoted identifier not allowed for function names.");
            } else {
                return node;
            }
            break;
          case TOK_NOT:
            right = this.expression(bindingPower.Not);
            return {type: "NotExpression", children: [right]};
          case TOK_STAR:
            left = {type: "Identity"};
            right = null;
            if (this._lookahead(0) === TOK_RBRACKET) {
                // This can happen in a multiselect,
                // [a, b, *]
                right = {type: "Identity"};
            } else {
                right = this._parseProjectionRHS(bindingPower.Star);
            }
            return {type: "ValueProjection", children: [left, right]};
          case TOK_FILTER:
            return this.led(token.type, {type: "Identity"});
          case TOK_LBRACE:
            return this._parseMultiselectHash();
          case TOK_FLATTEN:
            left = {type: TOK_FLATTEN, children: [{type: "Identity"}]};
            right = this._parseProjectionRHS(bindingPower.Flatten);
            return {type: "Projection", children: [left, right]};
          case TOK_LBRACKET:
            if (this._lookahead(0) === TOK_NUMBER || this._lookahead(0) === TOK_COLON) {
                right = this._parseIndexExpression();
                return this._projectIfSlice({type: "Identity"}, right);
            } else if (this._lookahead(0) === TOK_STAR &&
                       this._lookahead(1) === TOK_RBRACKET) {
                this._advance();
                this._advance();
                right = this._parseProjectionRHS(bindingPower.Star);
                return {type: "Projection",
                        children: [{type: "Identity"}, right]};
            } else {
                return this._parseMultiselectList();
            }
            break;
          case TOK_CURRENT:
            return {type: TOK_CURRENT};
          case TOK_EXPREF:
            expression = this.expression(bindingPower.Expref);
            return {type: "ExpressionReference", children: [expression]};
          case TOK_LPAREN:
            var args = [];
            while (this._lookahead(0) !== TOK_RPAREN) {
              if (this._lookahead(0) === TOK_CURRENT) {
                expression = {type: TOK_CURRENT};
                this._advance();
              } else {
                expression = this.expression(0);
              }
              args.push(expression);
            }
            this._match(TOK_RPAREN);
            return args[0];
          default:
            this._errorToken(token);
        }
      },

      led: function(tokenName, left) {
        var right;
        switch(tokenName) {
          case TOK_DOT:
            var rbp = bindingPower.Dot;
            if (this._lookahead(0) !== TOK_STAR) {
                right = this._parseDotRHS(rbp);
                return {type: "Subexpression", children: [left, right]};
            } else {
                // Creating a projection.
                this._advance();
                right = this._parseProjectionRHS(rbp);
                return {type: "ValueProjection", children: [left, right]};
            }
            break;
          case TOK_PIPE:
            right = this.expression(bindingPower.Pipe);
            return {type: TOK_PIPE, children: [left, right]};
          case TOK_OR:
            right = this.expression(bindingPower.Or);
            return {type: "OrExpression", children: [left, right]};
          case TOK_AND:
            right = this.expression(bindingPower.And);
            return {type: "AndExpression", children: [left, right]};
          case TOK_LPAREN:
            var name = left.name;
            var args = [];
            var expression, node;
            while (this._lookahead(0) !== TOK_RPAREN) {
              if (this._lookahead(0) === TOK_CURRENT) {
                expression = {type: TOK_CURRENT};
                this._advance();
              } else {
                expression = this.expression(0);
              }
              if (this._lookahead(0) === TOK_COMMA) {
                this._match(TOK_COMMA);
              }
              args.push(expression);
            }
            this._match(TOK_RPAREN);
            node = {type: "Function", name: name, children: args};
            return node;
          case TOK_FILTER:
            var condition = this.expression(0);
            this._match(TOK_RBRACKET);
            if (this._lookahead(0) === TOK_FLATTEN) {
              right = {type: "Identity"};
            } else {
              right = this._parseProjectionRHS(bindingPower.Filter);
            }
            return {type: "FilterProjection", children: [left, right, condition]};
          case TOK_FLATTEN:
            var leftNode = {type: TOK_FLATTEN, children: [left]};
            var rightNode = this._parseProjectionRHS(bindingPower.Flatten);
            return {type: "Projection", children: [leftNode, rightNode]};
          case TOK_EQ:
          case TOK_NE:
          case TOK_GT:
          case TOK_GTE:
          case TOK_LT:
          case TOK_LTE:
            return this._parseComparator(left, tokenName);
          case TOK_LBRACKET:
            var token = this._lookaheadToken(0);
            if (token.type === TOK_NUMBER || token.type === TOK_COLON) {
                right = this._parseIndexExpression();
                return this._projectIfSlice(left, right);
            } else {
                this._match(TOK_STAR);
                this._match(TOK_RBRACKET);
                right = this._parseProjectionRHS(bindingPower.Star);
                return {type: "Projection", children: [left, right]};
            }
            break;
          default:
            this._errorToken(this._lookaheadToken(0));
        }
      },

      _match: function(tokenType) {
          if (this._lookahead(0) === tokenType) {
              this._advance();
          } else {
              var t = this._lookaheadToken(0);
              var error = new Error("Expected " + tokenType + ", got: " + t.type);
              error.name = "ParserError";
              throw error;
          }
      },

      _errorToken: function(token) {
          var error = new Error("Invalid token (" +
                                token.type + "): \"" +
                                token.value + "\"");
          error.name = "ParserError";
          throw error;
      },


      _parseIndexExpression: function() {
          if (this._lookahead(0) === TOK_COLON || this._lookahead(1) === TOK_COLON) {
              return this._parseSliceExpression();
          } else {
              var node = {
                  type: "Index",
                  value: this._lookaheadToken(0).value};
              this._advance();
              this._match(TOK_RBRACKET);
              return node;
          }
      },

      _projectIfSlice: function(left, right) {
          var indexExpr = {type: "IndexExpression", children: [left, right]};
          if (right.type === "Slice") {
              return {
                  type: "Projection",
                  children: [indexExpr, this._parseProjectionRHS(bindingPower.Star)]
              };
          } else {
              return indexExpr;
          }
      },

      _parseSliceExpression: function() {
          // [start:end:step] where each part is optional, as well as the last
          // colon.
          var parts = [null, null, null];
          var index = 0;
          var currentToken = this._lookahead(0);
          while (currentToken !== TOK_RBRACKET && index < 3) {
              if (currentToken === TOK_COLON) {
                  index++;
                  this._advance();
              } else if (currentToken === TOK_NUMBER) {
                  parts[index] = this._lookaheadToken(0).value;
                  this._advance();
              } else {
                  var t = this._lookahead(0);
                  var error = new Error("Syntax error, unexpected token: " +
                                        t.value + "(" + t.type + ")");
                  error.name = "Parsererror";
                  throw error;
              }
              currentToken = this._lookahead(0);
          }
          this._match(TOK_RBRACKET);
          return {
              type: "Slice",
              children: parts
          };
      },

      _parseComparator: function(left, comparator) {
        var right = this.expression(bindingPower[comparator]);
        return {type: "Comparator", name: comparator, children: [left, right]};
      },

      _parseDotRHS: function(rbp) {
          var lookahead = this._lookahead(0);
          var exprTokens = [TOK_UNQUOTEDIDENTIFIER, TOK_QUOTEDIDENTIFIER, TOK_STAR];
          if (exprTokens.indexOf(lookahead) >= 0) {
              return this.expression(rbp);
          } else if (lookahead === TOK_LBRACKET) {
              this._match(TOK_LBRACKET);
              return this._parseMultiselectList();
          } else if (lookahead === TOK_LBRACE) {
              this._match(TOK_LBRACE);
              return this._parseMultiselectHash();
          }
      },

      _parseProjectionRHS: function(rbp) {
          var right;
          if (bindingPower[this._lookahead(0)] < 10) {
              right = {type: "Identity"};
          } else if (this._lookahead(0) === TOK_LBRACKET) {
              right = this.expression(rbp);
          } else if (this._lookahead(0) === TOK_FILTER) {
              right = this.expression(rbp);
          } else if (this._lookahead(0) === TOK_DOT) {
              this._match(TOK_DOT);
              right = this._parseDotRHS(rbp);
          } else {
              var t = this._lookaheadToken(0);
              var error = new Error("Sytanx error, unexpected token: " +
                                    t.value + "(" + t.type + ")");
              error.name = "ParserError";
              throw error;
          }
          return right;
      },

      _parseMultiselectList: function() {
          var expressions = [];
          while (this._lookahead(0) !== TOK_RBRACKET) {
              var expression = this.expression(0);
              expressions.push(expression);
              if (this._lookahead(0) === TOK_COMMA) {
                  this._match(TOK_COMMA);
                  if (this._lookahead(0) === TOK_RBRACKET) {
                    throw new Error("Unexpected token Rbracket");
                  }
              }
          }
          this._match(TOK_RBRACKET);
          return {type: "MultiSelectList", children: expressions};
      },

      _parseMultiselectHash: function() {
        var pairs = [];
        var identifierTypes = [TOK_UNQUOTEDIDENTIFIER, TOK_QUOTEDIDENTIFIER];
        var keyToken, keyName, value, node;
        for (;;) {
          keyToken = this._lookaheadToken(0);
          if (identifierTypes.indexOf(keyToken.type) < 0) {
            throw new Error("Expecting an identifier token, got: " +
                            keyToken.type);
          }
          keyName = keyToken.value;
          this._advance();
          this._match(TOK_COLON);
          value = this.expression(0);
          node = {type: "KeyValuePair", name: keyName, value: value};
          pairs.push(node);
          if (this._lookahead(0) === TOK_COMMA) {
            this._match(TOK_COMMA);
          } else if (this._lookahead(0) === TOK_RBRACE) {
            this._match(TOK_RBRACE);
            break;
          }
        }
        return {type: "MultiSelectHash", children: pairs};
      }
  };


  function TreeInterpreter(runtime) {
    this.runtime = runtime;
  }

  TreeInterpreter.prototype = {
      search: function(node, value) {
          return this.visit(node, value);
      },

      visit: function(node, value) {
          var matched, current, result, first, second, field, left, right, collected, i;
          switch (node.type) {
            case "Field":
              if (value === null ) {
                  return null;
              } else if (isObject(value)) {
                  field = value[node.name];
                  if (field === undefined) {
                      return null;
                  } else {
                      return field;
                  }
              } else {
                return null;
              }
              break;
            case "Subexpression":
              result = this.visit(node.children[0], value);
              for (i = 1; i < node.children.length; i++) {
                  result = this.visit(node.children[1], result);
                  if (result === null) {
                      return null;
                  }
              }
              return result;
            case "IndexExpression":
              left = this.visit(node.children[0], value);
              right = this.visit(node.children[1], left);
              return right;
            case "Index":
              if (!isArray(value)) {
                return null;
              }
              var index = node.value;
              if (index < 0) {
                index = value.length + index;
              }
              result = value[index];
              if (result === undefined) {
                result = null;
              }
              return result;
            case "Slice":
              if (!isArray(value)) {
                return null;
              }
              var sliceParams = node.children.slice(0);
              var computed = this.computeSliceParams(value.length, sliceParams);
              var start = computed[0];
              var stop = computed[1];
              var step = computed[2];
              result = [];
              if (step > 0) {
                  for (i = start; i < stop; i += step) {
                      result.push(value[i]);
                  }
              } else {
                  for (i = start; i > stop; i += step) {
                      result.push(value[i]);
                  }
              }
              return result;
            case "Projection":
              // Evaluate left child.
              var base = this.visit(node.children[0], value);
              if (!isArray(base)) {
                return null;
              }
              collected = [];
              for (i = 0; i < base.length; i++) {
                current = this.visit(node.children[1], base[i]);
                if (current !== null) {
                  collected.push(current);
                }
              }
              return collected;
            case "ValueProjection":
              // Evaluate left child.
              base = this.visit(node.children[0], value);
              if (!isObject(base)) {
                return null;
              }
              collected = [];
              var values = objValues(base);
              for (i = 0; i < values.length; i++) {
                current = this.visit(node.children[1], values[i]);
                if (current !== null) {
                  collected.push(current);
                }
              }
              return collected;
            case "FilterProjection":
              base = this.visit(node.children[0], value);
              if (!isArray(base)) {
                return null;
              }
              var filtered = [];
              var finalResults = [];
              for (i = 0; i < base.length; i++) {
                matched = this.visit(node.children[2], base[i]);
                if (!isFalse(matched)) {
                  filtered.push(base[i]);
                }
              }
              for (var j = 0; j < filtered.length; j++) {
                current = this.visit(node.children[1], filtered[j]);
                if (current !== null) {
                  finalResults.push(current);
                }
              }
              return finalResults;
            case "Comparator":
              first = this.visit(node.children[0], value);
              second = this.visit(node.children[1], value);
              switch(node.name) {
                case TOK_EQ:
                  result = strictDeepEqual(first, second);
                  break;
                case TOK_NE:
                  result = !strictDeepEqual(first, second);
                  break;
                case TOK_GT:
                  result = first > second;
                  break;
                case TOK_GTE:
                  result = first >= second;
                  break;
                case TOK_LT:
                  result = first < second;
                  break;
                case TOK_LTE:
                  result = first <= second;
                  break;
                default:
                  throw new Error("Unknown comparator: " + node.name);
              }
              return result;
            case TOK_FLATTEN:
              var original = this.visit(node.children[0], value);
              if (!isArray(original)) {
                return null;
              }
              var merged = [];
              for (i = 0; i < original.length; i++) {
                current = original[i];
                if (isArray(current)) {
                  merged.push.apply(merged, current);
                } else {
                  merged.push(current);
                }
              }
              return merged;
            case "Identity":
              return value;
            case "MultiSelectList":
              if (value === null) {
                return null;
              }
              collected = [];
              for (i = 0; i < node.children.length; i++) {
                  collected.push(this.visit(node.children[i], value));
              }
              return collected;
            case "MultiSelectHash":
              if (value === null) {
                return null;
              }
              collected = {};
              var child;
              for (i = 0; i < node.children.length; i++) {
                child = node.children[i];
                collected[child.name] = this.visit(child.value, value);
              }
              return collected;
            case "OrExpression":
              matched = this.visit(node.children[0], value);
              if (isFalse(matched)) {
                  matched = this.visit(node.children[1], value);
              }
              return matched;
            case "AndExpression":
              first = this.visit(node.children[0], value);

              if (isFalse(first) === true) {
                return first;
              }
              return this.visit(node.children[1], value);
            case "NotExpression":
              first = this.visit(node.children[0], value);
              return isFalse(first);
            case "Literal":
              return node.value;
            case TOK_PIPE:
              left = this.visit(node.children[0], value);
              return this.visit(node.children[1], left);
            case TOK_CURRENT:
              return value;
            case "Function":
              var resolvedArgs = [];
              for (i = 0; i < node.children.length; i++) {
                  resolvedArgs.push(this.visit(node.children[i], value));
              }
              return this.runtime.callFunction(node.name, resolvedArgs);
            case "ExpressionReference":
              var refNode = node.children[0];
              // Tag the node with a specific attribute so the type
              // checker verify the type.
              refNode.jmespathType = TOK_EXPREF;
              return refNode;
            default:
              throw new Error("Unknown node type: " + node.type);
          }
      },

      computeSliceParams: function(arrayLength, sliceParams) {
        var start = sliceParams[0];
        var stop = sliceParams[1];
        var step = sliceParams[2];
        var computed = [null, null, null];
        if (step === null) {
          step = 1;
        } else if (step === 0) {
          var error = new Error("Invalid slice, step cannot be 0");
          error.name = "RuntimeError";
          throw error;
        }
        var stepValueNegative = step < 0 ? true : false;

        if (start === null) {
            start = stepValueNegative ? arrayLength - 1 : 0;
        } else {
            start = this.capSliceRange(arrayLength, start, step);
        }

        if (stop === null) {
            stop = stepValueNegative ? -1 : arrayLength;
        } else {
            stop = this.capSliceRange(arrayLength, stop, step);
        }
        computed[0] = start;
        computed[1] = stop;
        computed[2] = step;
        return computed;
      },

      capSliceRange: function(arrayLength, actualValue, step) {
          if (actualValue < 0) {
              actualValue += arrayLength;
              if (actualValue < 0) {
                  actualValue = step < 0 ? -1 : 0;
              }
          } else if (actualValue >= arrayLength) {
              actualValue = step < 0 ? arrayLength - 1 : arrayLength;
          }
          return actualValue;
      }

  };

  function Runtime(interpreter) {
    this._interpreter = interpreter;
    this.functionTable = {
        // name: [function, <signature>]
        // The <signature> can be:
        //
        // {
        //   args: [[type1, type2], [type1, type2]],
        //   variadic: true|false
        // }
        //
        // Each arg in the arg list is a list of valid types
        // (if the function is overloaded and supports multiple
        // types.  If the type is "any" then no type checking
        // occurs on the argument.  Variadic is optional
        // and if not provided is assumed to be false.
        abs: {_func: this._functionAbs, _signature: [{types: [TYPE_NUMBER]}]},
        avg: {_func: this._functionAvg, _signature: [{types: [TYPE_ARRAY_NUMBER]}]},
        ceil: {_func: this._functionCeil, _signature: [{types: [TYPE_NUMBER]}]},
        contains: {
            _func: this._functionContains,
            _signature: [{types: [TYPE_STRING, TYPE_ARRAY]},
                        {types: [TYPE_ANY]}]},
        "ends_with": {
            _func: this._functionEndsWith,
            _signature: [{types: [TYPE_STRING]}, {types: [TYPE_STRING]}]},
        floor: {_func: this._functionFloor, _signature: [{types: [TYPE_NUMBER]}]},
        length: {
            _func: this._functionLength,
            _signature: [{types: [TYPE_STRING, TYPE_ARRAY, TYPE_OBJECT]}]},
        map: {
            _func: this._functionMap,
            _signature: [{types: [TYPE_EXPREF]}, {types: [TYPE_ARRAY]}]},
        max: {
            _func: this._functionMax,
            _signature: [{types: [TYPE_ARRAY_NUMBER, TYPE_ARRAY_STRING]}]},
        "merge": {
            _func: this._functionMerge,
            _signature: [{types: [TYPE_OBJECT], variadic: true}]
        },
        "max_by": {
          _func: this._functionMaxBy,
          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
        },
        sum: {_func: this._functionSum, _signature: [{types: [TYPE_ARRAY_NUMBER]}]},
        "starts_with": {
            _func: this._functionStartsWith,
            _signature: [{types: [TYPE_STRING]}, {types: [TYPE_STRING]}]},
        min: {
            _func: this._functionMin,
            _signature: [{types: [TYPE_ARRAY_NUMBER, TYPE_ARRAY_STRING]}]},
        "min_by": {
          _func: this._functionMinBy,
          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
        },
        type: {_func: this._functionType, _signature: [{types: [TYPE_ANY]}]},
        keys: {_func: this._functionKeys, _signature: [{types: [TYPE_OBJECT]}]},
        values: {_func: this._functionValues, _signature: [{types: [TYPE_OBJECT]}]},
        sort: {_func: this._functionSort, _signature: [{types: [TYPE_ARRAY_STRING, TYPE_ARRAY_NUMBER]}]},
        "sort_by": {
          _func: this._functionSortBy,
          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
        },
        join: {
            _func: this._functionJoin,
            _signature: [
                {types: [TYPE_STRING]},
                {types: [TYPE_ARRAY_STRING]}
            ]
        },
        reverse: {
            _func: this._functionReverse,
            _signature: [{types: [TYPE_STRING, TYPE_ARRAY]}]},
        "to_array": {_func: this._functionToArray, _signature: [{types: [TYPE_ANY]}]},
        "to_string": {_func: this._functionToString, _signature: [{types: [TYPE_ANY]}]},
        "to_number": {_func: this._functionToNumber, _signature: [{types: [TYPE_ANY]}]},
        "not_null": {
            _func: this._functionNotNull,
            _signature: [{types: [TYPE_ANY], variadic: true}]
        }
    };
  }

  Runtime.prototype = {
    callFunction: function(name, resolvedArgs) {
      var functionEntry = this.functionTable[name];
      if (functionEntry === undefined) {
          throw new Error("Unknown function: " + name + "()");
      }
      this._validateArgs(name, resolvedArgs, functionEntry._signature);
      return functionEntry._func.call(this, resolvedArgs);
    },

    _validateArgs: function(name, args, signature) {
        // Validating the args requires validating
        // the correct arity and the correct type of each arg.
        // If the last argument is declared as variadic, then we need
        // a minimum number of args to be required.  Otherwise it has to
        // be an exact amount.
        var pluralized;
        if (signature[signature.length - 1].variadic) {
            if (args.length < signature.length) {
                pluralized = signature.length === 1 ? " argument" : " arguments";
                throw new Error("ArgumentError: " + name + "() " +
                                "takes at least" + signature.length + pluralized +
                                " but received " + args.length);
            }
        } else if (args.length !== signature.length) {
            pluralized = signature.length === 1 ? " argument" : " arguments";
            throw new Error("ArgumentError: " + name + "() " +
                            "takes " + signature.length + pluralized +
                            " but received " + args.length);
        }
        var currentSpec;
        var actualType;
        var typeMatched;
        for (var i = 0; i < signature.length; i++) {
            typeMatched = false;
            currentSpec = signature[i].types;
            actualType = this._getTypeName(args[i]);
            for (var j = 0; j < currentSpec.length; j++) {
                if (this._typeMatches(actualType, currentSpec[j], args[i])) {
                    typeMatched = true;
                    break;
                }
            }
            if (!typeMatched) {
                throw new Error("TypeError: " + name + "() " +
                                "expected argument " + (i + 1) +
                                " to be type " + currentSpec +
                                " but received type " + actualType +
                                " instead.");
            }
        }
    },

    _typeMatches: function(actual, expected, argValue) {
        if (expected === TYPE_ANY) {
            return true;
        }
        if (expected === TYPE_ARRAY_STRING ||
            expected === TYPE_ARRAY_NUMBER ||
            expected === TYPE_ARRAY) {
            // The expected type can either just be array,
            // or it can require a specific subtype (array of numbers).
            //
            // The simplest case is if "array" with no subtype is specified.
            if (expected === TYPE_ARRAY) {
                return actual === TYPE_ARRAY;
            } else if (actual === TYPE_ARRAY) {
                // Otherwise we need to check subtypes.
                // I think this has potential to be improved.
                var subtype;
                if (expected === TYPE_ARRAY_NUMBER) {
                  subtype = TYPE_NUMBER;
                } else if (expected === TYPE_ARRAY_STRING) {
                  subtype = TYPE_STRING;
                }
                for (var i = 0; i < argValue.length; i++) {
                    if (!this._typeMatches(
                            this._getTypeName(argValue[i]), subtype,
                                             argValue[i])) {
                        return false;
                    }
                }
                return true;
            }
        } else {
            return actual === expected;
        }
    },
    _getTypeName: function(obj) {
        switch (Object.prototype.toString.call(obj)) {
            case "[object String]":
              return TYPE_STRING;
            case "[object Number]":
              return TYPE_NUMBER;
            case "[object Array]":
              return TYPE_ARRAY;
            case "[object Boolean]":
              return TYPE_BOOLEAN;
            case "[object Null]":
              return TYPE_NULL;
            case "[object Object]":
              // Check if it's an expref.  If it has, it's been
              // tagged with a jmespathType attr of 'Expref';
              if (obj.jmespathType === TOK_EXPREF) {
                return TYPE_EXPREF;
              } else {
                return TYPE_OBJECT;
              }
        }
    },

    _functionStartsWith: function(resolvedArgs) {
        return resolvedArgs[0].lastIndexOf(resolvedArgs[1]) === 0;
    },

    _functionEndsWith: function(resolvedArgs) {
        var searchStr = resolvedArgs[0];
        var suffix = resolvedArgs[1];
        return searchStr.indexOf(suffix, searchStr.length - suffix.length) !== -1;
    },

    _functionReverse: function(resolvedArgs) {
        var typeName = this._getTypeName(resolvedArgs[0]);
        if (typeName === TYPE_STRING) {
          var originalStr = resolvedArgs[0];
          var reversedStr = "";
          for (var i = originalStr.length - 1; i >= 0; i--) {
              reversedStr += originalStr[i];
          }
          return reversedStr;
        } else {
          var reversedArray = resolvedArgs[0].slice(0);
          reversedArray.reverse();
          return reversedArray;
        }
    },

    _functionAbs: function(resolvedArgs) {
      return Math.abs(resolvedArgs[0]);
    },

    _functionCeil: function(resolvedArgs) {
        return Math.ceil(resolvedArgs[0]);
    },

    _functionAvg: function(resolvedArgs) {
        var sum = 0;
        var inputArray = resolvedArgs[0];
        for (var i = 0; i < inputArray.length; i++) {
            sum += inputArray[i];
        }
        return sum / inputArray.length;
    },

    _functionContains: function(resolvedArgs) {
        return resolvedArgs[0].indexOf(resolvedArgs[1]) >= 0;
    },

    _functionFloor: function(resolvedArgs) {
        return Math.floor(resolvedArgs[0]);
    },

    _functionLength: function(resolvedArgs) {
       if (!isObject(resolvedArgs[0])) {
         return resolvedArgs[0].length;
       } else {
         // As far as I can tell, there's no way to get the length
         // of an object without O(n) iteration through the object.
         return Object.keys(resolvedArgs[0]).length;
       }
    },

    _functionMap: function(resolvedArgs) {
      var mapped = [];
      var interpreter = this._interpreter;
      var exprefNode = resolvedArgs[0];
      var elements = resolvedArgs[1];
      for (var i = 0; i < elements.length; i++) {
          mapped.push(interpreter.visit(exprefNode, elements[i]));
      }
      return mapped;
    },

    _functionMerge: function(resolvedArgs) {
      var merged = {};
      for (var i = 0; i < resolvedArgs.length; i++) {
        var current = resolvedArgs[i];
        for (var key in current) {
          merged[key] = current[key];
        }
      }
      return merged;
    },

    _functionMax: function(resolvedArgs) {
      if (resolvedArgs[0].length > 0) {
        var typeName = this._getTypeName(resolvedArgs[0][0]);
        if (typeName === TYPE_NUMBER) {
          return Math.max.apply(Math, resolvedArgs[0]);
        } else {
          var elements = resolvedArgs[0];
          var maxElement = elements[0];
          for (var i = 1; i < elements.length; i++) {
              if (maxElement.localeCompare(elements[i]) < 0) {
                  maxElement = elements[i];
              }
          }
          return maxElement;
        }
      } else {
          return null;
      }
    },

    _functionMin: function(resolvedArgs) {
      if (resolvedArgs[0].length > 0) {
        var typeName = this._getTypeName(resolvedArgs[0][0]);
        if (typeName === TYPE_NUMBER) {
          return Math.min.apply(Math, resolvedArgs[0]);
        } else {
          var elements = resolvedArgs[0];
          var minElement = elements[0];
          for (var i = 1; i < elements.length; i++) {
              if (elements[i].localeCompare(minElement) < 0) {
                  minElement = elements[i];
              }
          }
          return minElement;
        }
      } else {
        return null;
      }
    },

    _functionSum: function(resolvedArgs) {
      var sum = 0;
      var listToSum = resolvedArgs[0];
      for (var i = 0; i < listToSum.length; i++) {
        sum += listToSum[i];
      }
      return sum;
    },

    _functionType: function(resolvedArgs) {
        switch (this._getTypeName(resolvedArgs[0])) {
          case TYPE_NUMBER:
            return "number";
          case TYPE_STRING:
            return "string";
          case TYPE_ARRAY:
            return "array";
          case TYPE_OBJECT:
            return "object";
          case TYPE_BOOLEAN:
            return "boolean";
          case TYPE_EXPREF:
            return "expref";
          case TYPE_NULL:
            return "null";
        }
    },

    _functionKeys: function(resolvedArgs) {
        return Object.keys(resolvedArgs[0]);
    },

    _functionValues: function(resolvedArgs) {
        var obj = resolvedArgs[0];
        var keys = Object.keys(obj);
        var values = [];
        for (var i = 0; i < keys.length; i++) {
            values.push(obj[keys[i]]);
        }
        return values;
    },

    _functionJoin: function(resolvedArgs) {
        var joinChar = resolvedArgs[0];
        var listJoin = resolvedArgs[1];
        return listJoin.join(joinChar);
    },

    _functionToArray: function(resolvedArgs) {
        if (this._getTypeName(resolvedArgs[0]) === TYPE_ARRAY) {
            return resolvedArgs[0];
        } else {
            return [resolvedArgs[0]];
        }
    },

    _functionToString: function(resolvedArgs) {
        if (this._getTypeName(resolvedArgs[0]) === TYPE_STRING) {
            return resolvedArgs[0];
        } else {
            return JSON.stringify(resolvedArgs[0]);
        }
    },

    _functionToNumber: function(resolvedArgs) {
        var typeName = this._getTypeName(resolvedArgs[0]);
        var convertedValue;
        if (typeName === TYPE_NUMBER) {
            return resolvedArgs[0];
        } else if (typeName === TYPE_STRING) {
            convertedValue = +resolvedArgs[0];
            if (!isNaN(convertedValue)) {
                return convertedValue;
            }
        }
        return null;
    },

    _functionNotNull: function(resolvedArgs) {
        for (var i = 0; i < resolvedArgs.length; i++) {
            if (this._getTypeName(resolvedArgs[i]) !== TYPE_NULL) {
                return resolvedArgs[i];
            }
        }
        return null;
    },

    _functionSort: function(resolvedArgs) {
        var sortedArray = resolvedArgs[0].slice(0);
        sortedArray.sort();
        return sortedArray;
    },

    _functionSortBy: function(resolvedArgs) {
        var sortedArray = resolvedArgs[0].slice(0);
        if (sortedArray.length === 0) {
            return sortedArray;
        }
        var interpreter = this._interpreter;
        var exprefNode = resolvedArgs[1];
        var requiredType = this._getTypeName(
            interpreter.visit(exprefNode, sortedArray[0]));
        if ([TYPE_NUMBER, TYPE_STRING].indexOf(requiredType) < 0) {
            throw new Error("TypeError");
        }
        var that = this;
        // In order to get a stable sort out of an unstable
        // sort algorithm, we decorate/sort/undecorate (DSU)
        // by creating a new list of [index, element] pairs.
        // In the cmp function, if the evaluated elements are
        // equal, then the index will be used as the tiebreaker.
        // After the decorated list has been sorted, it will be
        // undecorated to extract the original elements.
        var decorated = [];
        for (var i = 0; i < sortedArray.length; i++) {
          decorated.push([i, sortedArray[i]]);
        }
        decorated.sort(function(a, b) {
          var exprA = interpreter.visit(exprefNode, a[1]);
          var exprB = interpreter.visit(exprefNode, b[1]);
          if (that._getTypeName(exprA) !== requiredType) {
              throw new Error(
                  "TypeError: expected " + requiredType + ", received " +
                  that._getTypeName(exprA));
          } else if (that._getTypeName(exprB) !== requiredType) {
              throw new Error(
                  "TypeError: expected " + requiredType + ", received " +
                  that._getTypeName(exprB));
          }
          if (exprA > exprB) {
            return 1;
          } else if (exprA < exprB) {
            return -1;
          } else {
            // If they're equal compare the items by their
            // order to maintain relative order of equal keys
            // (i.e. to get a stable sort).
            return a[0] - b[0];
          }
        });
        // Undecorate: extract out the original list elements.
        for (var j = 0; j < decorated.length; j++) {
          sortedArray[j] = decorated[j][1];
        }
        return sortedArray;
    },

    _functionMaxBy: function(resolvedArgs) {
      var exprefNode = resolvedArgs[1];
      var resolvedArray = resolvedArgs[0];
      var keyFunction = this.createKeyFunction(exprefNode, [TYPE_NUMBER, TYPE_STRING]);
      var maxNumber = -Infinity;
      var maxRecord;
      var current;
      for (var i = 0; i < resolvedArray.length; i++) {
        current = keyFunction(resolvedArray[i]);
        if (current > maxNumber) {
          maxNumber = current;
          maxRecord = resolvedArray[i];
        }
      }
      return maxRecord;
    },

    _functionMinBy: function(resolvedArgs) {
      var exprefNode = resolvedArgs[1];
      var resolvedArray = resolvedArgs[0];
      var keyFunction = this.createKeyFunction(exprefNode, [TYPE_NUMBER, TYPE_STRING]);
      var minNumber = Infinity;
      var minRecord;
      var current;
      for (var i = 0; i < resolvedArray.length; i++) {
        current = keyFunction(resolvedArray[i]);
        if (current < minNumber) {
          minNumber = current;
          minRecord = resolvedArray[i];
        }
      }
      return minRecord;
    },

    createKeyFunction: function(exprefNode, allowedTypes) {
      var that = this;
      var interpreter = this._interpreter;
      var keyFunc = function(x) {
        var current = interpreter.visit(exprefNode, x);
        if (allowedTypes.indexOf(that._getTypeName(current)) < 0) {
          var msg = "TypeError: expected one of " + allowedTypes +
                    ", received " + that._getTypeName(current);
          throw new Error(msg);
        }
        return current;
      };
      return keyFunc;
    }

  };

  function compile(stream) {
    var parser = new Parser();
    var ast = parser.parse(stream);
    return ast;
  }

  function tokenize(stream) {
      var lexer = new Lexer();
      return lexer.tokenize(stream);
  }

  function search(data, expression) {
      var parser = new Parser();
      // This needs to be improved.  Both the interpreter and runtime depend on
      // each other.  The runtime needs the interpreter to support exprefs.
      // There's likely a clean way to avoid the cyclic dependency.
      var runtime = new Runtime();
      var interpreter = new TreeInterpreter(runtime);
      runtime._interpreter = interpreter;
      var node = parser.parse(expression);
      return interpreter.search(node, data);
  }

  exports.tokenize = tokenize;
  exports.compile = compile;
  exports.search = search;
  exports.strictDeepEqual = strictDeepEqual;
})( false ? this.jmespath = {} : exports);


/***/ }),
/* 647 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadCoiExpsSuccess */
/* harmony export (immutable) */ __webpack_exports__["e"] = loadCoiExpsRequest;
/* unused harmony export loadCoiExpSuccess */
/* harmony export (immutable) */ __webpack_exports__["d"] = loadCoiExpRequest;
/* unused harmony export loadCoiExpDocsSuccess */
/* harmony export (immutable) */ __webpack_exports__["c"] = loadCoiExpDocsRequest;
/* unused harmony export loadLiabilitiesSuccess */
/* harmony export (immutable) */ __webpack_exports__["f"] = loadLiabilitiesRequest;
/* unused harmony export createCoiExpDocSuccess */
/* harmony export (immutable) */ __webpack_exports__["a"] = createCoiExpDoc;
/* unused harmony export updateCoiExpDocSuccess */
/* harmony export (immutable) */ __webpack_exports__["g"] = updateCoiExpDoc;
/* unused harmony export destroyCoiExpDocSuccess */
/* harmony export (immutable) */ __webpack_exports__["b"] = destroyCoiExpDoc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_coi_exps_api__ = __webpack_require__(3003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_coi_exp_docs_api__ = __webpack_require__(3004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_liabilities_api__ = __webpack_require__(3005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_coi_exps_store_action_types__ = __webpack_require__(1076);
function loadCoiExpsSuccess(payload){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_coi_exps_store_action_types__["a" /* COI_EXPS_SET */],payload:payload};}function loadCoiExpsRequest(projectId,page){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_coi_exps_api__["a" /* coiExpsApi */].getCoiExps(projectId,page).then(function(response){if(response.ok){dispatch(loadCoiExpsSuccess(Object.assign({},response,{coiExpsCurrentPage:page})));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadCoiExpSuccess(payload){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_coi_exps_store_action_types__["f" /* COI_EXP_SET */],payload:payload};}function loadCoiExpRequest(projectId,coiExpId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_coi_exps_api__["a" /* coiExpsApi */].getCoiExp(projectId,coiExpId).then(function(response){if(response.ok){dispatch(loadCoiExpSuccess(response.coiExp));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadCoiExpDocsSuccess(payload){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_coi_exps_store_action_types__["d" /* COI_EXP_DOCS_SET */],payload:payload};}function loadCoiExpDocsRequest(coiExpId,page){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_coi_exp_docs_api__["a" /* coiExpDocsApi */].getCoiExpDocs(coiExpId,page).then(function(response){if(response.ok){dispatch(loadCoiExpDocsSuccess(Object.assign({},response,{coiExpId:coiExpId,coiExpDocsCurrentPage:page})));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadLiabilitiesSuccess(payload){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_coi_exps_store_action_types__["g" /* LIABILITIES_SET */],payload:payload};}function loadLiabilitiesRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_liabilities_api__["a" /* liabilitiesApi */].getLiabilities().then(function(response){if(response.ok){dispatch(loadLiabilitiesSuccess(response.liabilities));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function createCoiExpDocSuccess(payload){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_coi_exps_store_action_types__["b" /* COI_EXP_DOCS_ADD */],payload:payload};}function createCoiExpDoc(coiExpId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_coi_exp_docs_api__["a" /* coiExpDocsApi */].createCoiExpDoc(coiExpId,values).then(function(response){if(response.ok){var coiExpDoc=response.coiExpDoc;dispatch(createCoiExpDocSuccess({coiExpId:coiExpId,coiExpDoc:coiExpDoc}));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateCoiExpDocSuccess(payload){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_coi_exps_store_action_types__["e" /* COI_EXP_DOCS_UPDATE */],payload:payload};}function updateCoiExpDoc(coiExpId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_coi_exp_docs_api__["a" /* coiExpDocsApi */].updateCoiExpDoc(coiExpId,values).then(function(response){if(response.ok){var coiExpDoc=response.coiExpDoc;dispatch(updateCoiExpDocSuccess({coiExpId:coiExpId,coiExpDoc:coiExpDoc}));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function destroyCoiExpDocSuccess(payload){return{type:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_coi_exps_store_action_types__["c" /* COI_EXP_DOCS_DESTROY */],payload:payload};}function destroyCoiExpDoc(coiExpId,coiExpDoc){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_coi_exp_docs_api__["a" /* coiExpDocsApi */].destroyCoiExpDoc(coiExpId,coiExpDoc.id).then(function(response){if(response.ok){dispatch(destroyCoiExpDocSuccess({coiExpId:coiExpId,coiExpDoc:coiExpDoc}));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(1081);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export projectOpenItemsCountSuccess */
/* harmony export (immutable) */ __webpack_exports__["a"] = projectOpenItemsCount;
/* unused harmony export projectOpenItemsCriticalCountSuccess */
/* harmony export (immutable) */ __webpack_exports__["b"] = projectOpenItemsCriticalCount;
/* unused harmony export projectOpenItemsSuccess */
/* harmony export (immutable) */ __webpack_exports__["c"] = projectOpenItemsRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_project_open_items_api__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_project_open_items_store_action_types__ = __webpack_require__(1093);
function projectOpenItemsCountSuccess(count){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_project_open_items_store_action_types__["a" /* PROJECT_OPEN_ITEMS_COUNT */],payload:count};}function projectOpenItemsCount(filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_open_items_api__["a" /* projectOpenItemsApi */].getProjectOpenItemsAllCount(filters).then(function(response){if(response.ok){dispatch(projectOpenItemsCountSuccess(response.count+response.countCritical));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function projectOpenItemsCriticalCountSuccess(count){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_project_open_items_store_action_types__["b" /* PROJECT_OPEN_ITEMS_CRITICAL_COUNT */],payload:count};}function projectOpenItemsCriticalCount(filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_open_items_api__["a" /* projectOpenItemsApi */].getProjectOpenItemsAllCount(filters).then(function(response){if(response.ok){dispatch(projectOpenItemsCriticalCountSuccess(response.countCritical));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function projectOpenItemsSuccess(projectOpenItems){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_project_open_items_store_action_types__["c" /* PROJECT_OPEN_ITEMS_LOAD */],payload:projectOpenItems};}function projectOpenItemsRequest(page,filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_open_items_api__["a" /* projectOpenItemsApi */].getProjectOpenItemsAll(page,filters).then(function(response){if(response.ok){dispatch(projectOpenItemsSuccess(Object.assign({},response,{currentPage:page})));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllRecentActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSpeRecentActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSwRecentActivity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getAllRecentActivity=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.recentActivity.data.allRecentActivity;},function(allRecentActivity){return allRecentActivity;});var getSpeRecentActivity=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.recentActivity.data.speRecentActivity;},function(speRecentActivity){return speRecentActivity;});var getSwRecentActivity=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.recentActivity.data.swRecentActivity;},function(swRecentActivity){return swRecentActivity;});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RecentActivity_css__ = __webpack_require__(3078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RecentActivity_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RecentActivity_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_header_NotificationsContainer__ = __webpack_require__(1100);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecentActivity=function(_Component){_inherits(RecentActivity,_Component);function RecentActivity(props){_classCallCheck(this,RecentActivity);var _this=_possibleConstructorReturn(this,(RecentActivity.__proto__||Object.getPrototypeOf(RecentActivity)).call(this,props));_this.handlePageChange=function(page){_this.setState({currentPage:page});_this.props.onPageChange(page);};_this.state={currentPage:1};return _this;}_createClass(RecentActivity,[{key:'componentDidMount',value:function componentDidMount(){this.handlePageChange(1);}},{key:'render',value:function render(){var _props=this.props,title=_props.title,recentActivity=_props.recentActivity;var currentPage=this.state.currentPage;return recentActivity&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recent-activity'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recent-activity-title'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_header_NotificationsContainer__["a" /* default */],{recentActivity:true,notifications:recentActivity,currentPage:currentPage,onPageChange:this.handlePageChange}));}}]);return RecentActivity;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RecentActivity.propTypes={title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,recentActivity:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape(),onPageChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};RecentActivity.defaultProps={title:'Recent Activity',recentActivity:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(RecentActivity));

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REPORT_RESULTS_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REPORT_PAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REPORT_START_DATE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REPORT_END_DATE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REPORT_EXTRA_FILTER_VALUE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REPORT_SEARCHING_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REPORT_WORK_ORDER_SELECT_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REPORT_WORK_ORDER_SELECT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REPORTS_RESET; });
var REPORT_RESULTS_LOAD_SUCCESS='REPORT_LOAD_SUCCESS';var REPORT_PAGE_CHANGE='REPORT_PAGE_CHANGE';var REPORT_START_DATE_CHANGE='REPORT_START_DATE_CHANGE';var REPORT_END_DATE_CHANGE='REPORT_END_DATE_CHANGE';var REPORT_EXTRA_FILTER_VALUE_CHANGE='REPORT_EXTRA_FILTER_VALUE_CHANGE';var REPORT_SEARCHING_CHANGE='REPORT_SEARCHING_CHANGE';var REPORT_WORK_ORDER_SELECT_CLEAR='REPORT_WORK_ORDER_SELECT_CLEAR';var REPORT_WORK_ORDER_SELECT_SET='REPORT_WORK_ORDER_SELECT_SET';var REPORTS_RESET='REPORTS_RESET';

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(1109);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(59) && !__webpack_require__(43)(function () {
  return Object.defineProperty(__webpack_require__(446)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(70);
var anObject = __webpack_require__(32);
var getKeys = __webpack_require__(212);

module.exports = __webpack_require__(59) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(117);
var toIObject = __webpack_require__(118);
var arrayIndexOf = __webpack_require__(343)(false);
var IE_PROTO = __webpack_require__(450)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(70).f;
var create = __webpack_require__(211);
var redefineAll = __webpack_require__(214);
var ctx = __webpack_require__(137);
var anInstance = __webpack_require__(215);
var forOf = __webpack_require__(216);
var $iterDefine = __webpack_require__(448);
var step = __webpack_require__(658);
var setSpecies = __webpack_require__(217);
var DESCRIPTORS = __webpack_require__(59);
var fastKey = __webpack_require__(194).fastKey;
var validate = __webpack_require__(218);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(32);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var RequireObjectCoercible = __webpack_require__(663);
var has = __webpack_require__(464);
var callBound = __webpack_require__(664);
var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

module.exports = function entries(O) {
	var obj = RequireObjectCoercible(O);
	var entrys = [];
	for (var key in obj) {
		if (has(obj, key) && $isEnumerable(obj, key)) {
			entrys.push([key, obj[key]]);
		}
	}
	return entrys;
};


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1127);


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(463);

var callBind = __webpack_require__(461);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(662);

module.exports = function getPolyfill() {
	return typeof Object.entries === 'function' ? Object.entries : implementation;
};


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(464);
var RequireObjectCoercible = __webpack_require__(663);
var callBound = __webpack_require__(664);

var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

module.exports = function values(O) {
	var obj = RequireObjectCoercible(O);
	var vals = [];
	for (var key in obj) {
		if (has(obj, key) && $isEnumerable(obj, key)) {
			vals.push(obj[key]);
		}
	}
	return vals;
};


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(666);

module.exports = function getPolyfill() {
	return typeof Object.values === 'function' ? Object.values : implementation;
};


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);


/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

/* harmony default export */ __webpack_exports__["default"] = (invariant);


/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(241);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(347);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(466);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(1141)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(467);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(347);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(348);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(466);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(683);

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1151);
module.exports = __webpack_require__(77).Object.assign;


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(172) && !__webpack_require__(219)(function () {
  return Object.defineProperty(__webpack_require__(685)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(245);
var document = __webpack_require__(171).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(220);
var toIObject = __webpack_require__(221);
var arrayIndexOf = __webpack_require__(1154)(false);
var IE_PROTO = __webpack_require__(473)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(471);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(472);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1157);
var $Object = __webpack_require__(77).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1162);
module.exports = __webpack_require__(77).Object.setPrototypeOf;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(294);
var createDesc = __webpack_require__(293);
var toIObject = __webpack_require__(221);
var toPrimitive = __webpack_require__(470);
var has = __webpack_require__(220);
var IE8_DOM_DEFINE = __webpack_require__(684);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(172) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(696);










var propTypes = {
  accordion: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,

  /**
   * When `accordion` is enabled, `activeKey` controls the which child `Panel` is expanded. `activeKey` should
   * match a child Panel `eventKey` prop exactly.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,

  /**
   * A callback fired when a child Panel collapse state changes. It's called with the next expanded `activeKey`
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,

  /**
   * An HTML role attribute
   */
  role: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,

  /**
   * A function that takes an eventKey and type and returns a
   * unique id for each Panel heading and Panel Collapse. The function _must_ be a pure function,
   * meaning it should always return the _same_ id for the same set of inputs. The default
   * value requires that an `id` to be set for the PanelGroup.
   *
   * The `type` argument will either be `"body"` or `"heading"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,

  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: Object(__WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* generatedId */])('PanelGroup')
};
var defaultProps = {
  accordion: false
};
var childContextTypes = {
  $bs_panelGroup: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    getId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    headerRole: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    panelRole: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    activeKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    onToggle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
  })
};

var PanelGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelGroup, _React$Component);

  function PanelGroup() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleSelect = function (key, expanded, e) {
      if (expanded) {
        _this.props.onSelect(key, e);
      } else if (_this.props.activeKey === key) {
        _this.props.onSelect(null, e);
      }
    };

    return _this;
  }

  var _proto = PanelGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        activeKey = _this$props.activeKey,
        accordion = _this$props.accordion,
        generateChildId = _this$props.generateChildId,
        id = _this$props.id;
    var getId = null;

    if (accordion) {
      getId = generateChildId || function (key, type) {
        return id ? id + "-" + type + "-" + key : null;
      };
    }

    return {
      $bs_panelGroup: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
        getId: getId,
        headerRole: 'tab',
        panelRole: 'tabpanel'
      }, accordion && {
        activeKey: activeKey,
        onToggle: this.handleSelect
      })
    };
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        accordion = _this$props2.accordion,
        className = _this$props2.className,
        children = _this$props2.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["accordion", "className", "children"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['onSelect', 'activeKey']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (accordion) {
      elementProps.role = elementProps.role || 'tablist';
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, {
        bsStyle: child.props.bsStyle || bsProps.bsStyle
      });
    }));
  };

  return PanelGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PanelGroup.propTypes = propTypes;
PanelGroup.defaultProps = defaultProps;
PanelGroup.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_uncontrollable___default()(Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('panel-group', PanelGroup), {
  activeKey: 'onSelect'
}));

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(111);
var core = __webpack_require__(77);
var fails = __webpack_require__(219);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1168);

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(172);
var getKeys = __webpack_require__(246);
var toIObject = __webpack_require__(221);
var isEnum = __webpack_require__(294).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = generatedId;
/* harmony export (immutable) */ __webpack_exports__["c"] = requiredRoles;
/* harmony export (immutable) */ __webpack_exports__["a"] = exclusiveRoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__ = __webpack_require__(103);



var idPropType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number]);
function generatedId(name) {
  return function (props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = idPropType.apply(void 0, [props].concat(args));

      if (!error && !props.id) {
        error = new Error("In order to properly initialize the " + name + " in a way that is accessible to assistive technologies " + ("(such as screen readers) an `id` or a `generateChildId` prop to " + name + " is required"));
      }
    }

    return error;
  };
}
function requiredRoles() {
  for (var _len2 = arguments.length, roles = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    roles[_key2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var missing;
    roles.every(function (role) {
      if (!__WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
        return child.props.bsRole === role;
      })) {
        missing = role;
        return false;
      }

      return true;
    });

    if (missing) {
      return new Error("(children) " + component + " - Missing a required child with bsRole: " + (missing + ". " + component + " must have at least one child of each of ") + ("the following bsRoles: " + roles.join(', ')));
    }

    return null;
  });
}
function exclusiveRoles() {
  for (var _len3 = arguments.length, roles = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    roles[_key3] = arguments[_key3];
  }

  return __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var duplicate;
    roles.every(function (role) {
      var childrenWithRole = __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__["a" /* default */].filter(props.children, function (child) {
        return child.props.bsRole === role;
      });

      if (childrenWithRole.length > 1) {
        duplicate = role;
        return false;
      }

      return true;
    });

    if (duplicate) {
      return new Error("(children) " + component + " - Duplicate children detected of bsRole: " + (duplicate + ". Only one child each allowed with the following ") + ("bsRoles: " + roles.join(', ')));
    }

    return null;
  });
}

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__ = __webpack_require__(138);







var propTypes = {
  /**
   * If set to true, renders `span` instead of `a`
   */
  active: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * `href` attribute for the inner `a` element
   */
  href: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * `title` attribute for the inner `a` element
   */
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,

  /**
   * `target` attribute for the inner `a` element
   */
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};
var defaultProps = {
  active: false
};

var BreadcrumbItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(BreadcrumbItem, _React$Component);

  function BreadcrumbItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = BreadcrumbItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        href = _this$props.href,
        title = _this$props.title,
        target = _this$props.target,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["active", "href", "title", "target", "className"]); // Don't try to render these props on non-active <span>.


    var linkProps = {
      href: href,
      title: title,
      target: target
    };
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, {
        active: active
      })
    }, active ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", props) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, linkProps)));
  };

  return BreadcrumbItem;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

BreadcrumbItem.propTypes = propTypes;
BreadcrumbItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbItem);

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_transition__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_dom_helpers_transition__);









var propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['prev', 'next']),
  onAnimateOutEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  animateIn: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  animateOut: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number
};
var defaultProps = {
  active: false,
  animateIn: false,
  animateOut: false
};

var CarouselItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(CarouselItem, _React$Component);

  function CarouselItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.state = {
      direction: null
    };
    _this.isUnmounted = false;
    return _this;
  }

  var _proto = CarouselItem.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.active !== nextProps.active) {
      this.setState({
        direction: null
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var active = this.props.active;
    var prevActive = prevProps.active;

    if (!active && prevActive) {
      __WEBPACK_IMPORTED_MODULE_8_dom_helpers_transition___default.a.end(__WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this), this.handleAnimateOutEnd);
    }

    if (active !== prevActive) {
      setTimeout(function () {
        return _this2.startAnimation();
      }, 20);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  _proto.handleAnimateOutEnd = function handleAnimateOutEnd() {
    if (this.isUnmounted) {
      return;
    }

    if (this.props.onAnimateOutEnd) {
      this.props.onAnimateOutEnd(this.props.index);
    }
  };

  _proto.startAnimation = function startAnimation() {
    if (this.isUnmounted) {
      return;
    }

    this.setState({
      direction: this.props.direction === 'prev' ? 'right' : 'left'
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        direction = _this$props.direction,
        active = _this$props.active,
        animateIn = _this$props.animateIn,
        animateOut = _this$props.animateOut,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["direction", "active", "animateIn", "animateOut", "className"]);

    delete props.onAnimateOutEnd;
    delete props.index;
    var classes = {
      item: true,
      active: active && !animateIn || animateOut
    };

    if (direction && active && animateIn) {
      classes[direction] = true;
    }

    if (this.state.direction && (animateIn || animateOut)) {
      classes[this.state.direction] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }));
  };

  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

CarouselItem.propTypes = propTypes;
CarouselItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CarouselItem);

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(1181));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(60));

var _reactLifecyclesCompat = __webpack_require__(173);

var _PropTypes = __webpack_require__(1196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = activeElement;

var _ownerDocument = _interopRequireDefault(__webpack_require__(249));

function activeElement(doc) {
  if (doc === void 0) {
    doc = (0, _ownerDocument.default)();
  }

  try {
    return doc.activeElement;
  } catch (e) {
    /* ie throws if no active element */
  }
}

module.exports = exports["default"];

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(705);
__webpack_require__(1201);
module.exports = __webpack_require__(77).Array.from;


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1199)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(706)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(350);
var $export = __webpack_require__(111);
var redefine = __webpack_require__(707);
var hide = __webpack_require__(243);
var Iterators = __webpack_require__(298);
var $iterCreate = __webpack_require__(1200);
var setToStringTag = __webpack_require__(484);
var getPrototypeOf = __webpack_require__(708);
var ITERATOR = __webpack_require__(151)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(243);


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(220);
var toObject = __webpack_require__(247);
var IE_PROTO = __webpack_require__(473)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _contains = __webpack_require__(250);

var _contains2 = _interopRequireDefault(_contains);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(60);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(710);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _ownerDocument = __webpack_require__(251);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var escapeKeyCode = 27;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */

var RootCloseWrapper = function (_React$Component) {
  _inherits(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    _classCallCheck(this, RootCloseWrapper);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.addEventListeners = function () {
      var event = _this.props.event;

      var doc = (0, _ownerDocument2.default)(_this);

      // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.
      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);

      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);

      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
    };

    _this.removeEventListeners = function () {
      if (_this.documentMouseCaptureListener) {
        _this.documentMouseCaptureListener.remove();
      }

      if (_this.documentMouseListener) {
        _this.documentMouseListener.remove();
      }

      if (_this.documentKeyupListener) {
        _this.documentKeyupListener.remove();
      }
    };

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.disabled) {
      this.addEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!this.props.disabled && prevProps.disabled) {
      this.addEventListeners();
    } else if (this.props.disabled && !prevProps.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!this.props.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return RootCloseWrapper;
}(_react2.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';

RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _propTypes2.default.func,
  /**
   * Children to render.
   */
  children: _propTypes2.default.element,
  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Choose which document mouse event to bind to.
   */
  event: _propTypes2.default.oneOf(['click', 'mousedown'])
};

RootCloseWrapper.defaultProps = {
  event: 'click'
};

exports.default = RootCloseWrapper;
module.exports = exports['default'];

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(485);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(486);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Button__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(16);









var propTypes = {
  noCaret: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  open: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  useAnchor: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
var defaultProps = {
  open: false,
  useAnchor: false,
  bsRole: 'toggle'
};

var DropdownToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(DropdownToggle, _React$Component);

  function DropdownToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DropdownToggle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        noCaret = _this$props.noCaret,
        open = _this$props.open,
        useAnchor = _this$props.useAnchor,
        bsClass = _this$props.bsClass,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["noCaret", "open", "useAnchor", "bsClass", "className", "children"]);

    delete props.bsRole;
    var Component = useAnchor ? __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_6__Button__["a" /* default */];
    var useCaret = !noCaret; // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.
    // FIXME: Should this really fall back to `title` as children?

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      role: "button",
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClass),
      "aria-haspopup": true,
      "aria-expanded": open
    }), children || props.title, useCaret && ' ', useCaret && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
      className: "caret"
    }));
  };

  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('dropdown-toggle', DropdownToggle));

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);








var propTypes = {
  /**
   * Turn any fixed-width grid layout into a full-width layout by this property.
   *
   * Adds `container-fluid` class.
   */
  fluid: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * You can use a custom element for this component
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div',
  fluid: false
};

var Grid =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Grid, _React$Component);

  function Grid() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Grid.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        fluid = _this$props.fluid,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["fluid", "componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, fluid && 'fluid');
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('container', Grid));

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(87);









var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  header: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  listItem: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
var defaultProps = {
  listItem: false
};

var ListGroupItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ListGroupItem, _React$Component);

  function ListGroupItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ListGroupItem.prototype;

  _proto.renderHeader = function renderHeader(header, headingClassName) {
    if (__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(header)) {
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(header, {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(header.props.className, headingClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h4", {
      className: headingClassName
    }, header);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        disabled = _this$props.disabled,
        className = _this$props.className,
        header = _this$props.header,
        listItem = _this$props.listItem,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["active", "disabled", "className", "header", "listItem", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      active: active,
      disabled: disabled
    });

    var Component;

    if (elementProps.href) {
      Component = 'a';
    } else if (elementProps.onClick) {
      Component = 'button';
      elementProps.type = elementProps.type || 'button';
    } else if (listItem) {
      Component = 'li';
    } else {
      Component = 'span';
    }

    elementProps.className = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes); // TODO: Deprecate `header` prop.

    if (header) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, elementProps, this.renderHeader(header, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'heading')), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("p", {
        className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'text')
      }, children));
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, elementProps, children);
  };

  return ListGroupItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

ListGroupItem.propTypes = propTypes;
ListGroupItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('list-group-item', Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["d" /* State */]), ListGroupItem)));

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(196));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isOverflowing;

var _isWindow = __webpack_require__(360);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(249);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

function bodyIsOverflowing(node) {
  var doc = (0, _ownerDocument2.default)(node);
  var win = (0, _isWindow2.default)(doc);
  var fullWidth = win.innerWidth;

  // Support: ie8, no innerWidth
  if (!fullWidth) {
    var documentElementRect = doc.documentElement.getBoundingClientRect();
    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
  }

  return doc.body.clientWidth < fullWidth;
}

function isOverflowing(container) {
  var win = (0, _isWindow2.default)(container);

  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}
module.exports = exports['default'];

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(359);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(60);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(361);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(251);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _LegacyPortal = __webpack_require__(1242);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
    }, _this.getMountNode = function () {
      return _this._portalContainerNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this.setContainer();
    this.forceUpdate(this.props.onRendered);
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.container !== this.props.container) {
      this.setContainer(nextProps);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._portalContainerNode = null;
  };

  Portal.prototype.render = function render() {
    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
module.exports = exports['default'];

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var ModalBody =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ModalBody, _React$Component);

  function ModalBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ModalBody;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ModalBody.propTypes = propTypes;
ModalBody.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal-body', ModalBody));

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__ = __webpack_require__(87);








var propTypes = {
  /**
   * A css class to apply to the Modal dialog DOM node.
   */
  dialogClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};

var ModalDialog =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ModalDialog, _React$Component);

  function ModalDialog() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalDialog.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        dialogClassName = _this$props.dialogClassName,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["dialogClassName", "className", "style", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps);

    var modalStyle = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      display: 'block'
    }, style);

    var dialogClasses = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'dialog')] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      tabIndex: "-1",
      role: "dialog",
      style: modalStyle,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsClassName)
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(dialogClassName, dialogClasses)
    }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content'),
      role: "document"
    }, children)));
  };

  return ModalDialog;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ModalDialog.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal', Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["c" /* Size */].SMALL], ModalDialog)));

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var ModalFooter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ModalFooter, _React$Component);

  function ModalFooter() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalFooter.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ModalFooter;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal-footer', ModalFooter));

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CloseButton__ = __webpack_require__(478);








 // TODO: `aria-label` should be `closeLabel`.

var propTypes = {
  /**
   * Provides an accessible label for the close
   * button. It is used for Assistive Technology when the label text is not
   * readable.
   */
  closeLabel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,

  /**
   * Specify whether the Component should contain a close button
   */
  closeButton: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,

  /**
   * A Callback fired when the close button is clicked. If used directly inside
   * a Modal component, the onHide will automatically be propagated up to the
   * parent Modal `onHide`.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};
var defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};
var contextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
  })
};

var ModalHeader =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ModalHeader, _React$Component);

  function ModalHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalHeader.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        closeLabel = _this$props.closeLabel,
        closeButton = _this$props.closeButton,
        onHide = _this$props.onHide,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["closeLabel", "closeButton", "onHide", "className", "children"]);

    var modal = this.context.$bs_modal;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), closeButton && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CloseButton__["a" /* default */], {
      label: closeLabel,
      onClick: Object(__WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__["a" /* default */])(modal && modal.onHide, onHide)
    }), children);
  };

  return ModalHeader;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;
ModalHeader.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal-header', ModalHeader));

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'h4'
};

var ModalTitle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ModalTitle, _React$Component);

  function ModalTitle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalTitle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ModalTitle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ModalTitle.propTypes = propTypes;
ModalTitle.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal-title', ModalTitle));

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_keycode__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__ = __webpack_require__(103);












 // TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
// TODO: This `bsStyle` is very unlike the others. Should we rename it?
// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
// Consider renaming or replacing them.

var propTypes = {
  /**
   * Marks the NavItem with a matching `eventKey` as active. Has a
   * higher precedence over `activeHref`.
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * Marks the child NavItem with a matching `href` prop as active.
   */
  activeHref: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * NavItems are be positioned vertically.
   */
  stacked: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  justified: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, function (_ref) {
    var justified = _ref.justified,
        navbar = _ref.navbar;
    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
  }),

  /**
   * A callback fired when a NavItem is selected.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * ARIA role for the Nav, in the context of a TabContainer, the default will
   * be set to "tablist", but can be overridden by the Nav when set explicitly.
   *
   * When the role is set to "tablist" NavItem focus is managed according to
   * the ARIA authoring practices for tabs:
   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
   */
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * Apply styling an alignment for use in a Navbar. This prop will be set
   * automatically when the Nav is used inside a Navbar.
   */
  navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Float the Nav to the right. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Float the Nav to the left. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullLeft: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
var defaultProps = {
  justified: false,
  pullRight: false,
  pullLeft: false,
  stacked: false
};
var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }),
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
  })
};

var Nav =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Nav, _React$Component);

  function Nav() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Nav.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this = this;

    if (!this._needsRefocus) {
      return;
    }

    this._needsRefocus = false;
    var children = this.props.children;

    var _this$getActiveProps = this.getActiveProps(),
        activeKey = _this$getActiveProps.activeKey,
        activeHref = _this$getActiveProps.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this.isActive(child, activeKey, activeHref);
    });
    var childrenArray = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].toArray(children);
    var activeChildIndex = childrenArray.indexOf(activeChild);
    var childNodes = __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this).children;
    var activeNode = childNodes && childNodes[activeChildIndex];

    if (!activeNode || !activeNode.firstChild) {
      return;
    }

    activeNode.firstChild.focus();
  };

  _proto.getActiveProps = function getActiveProps() {
    var tabContainer = this.context.$bs_tabContainer;

    if (tabContainer) {
       false ? warning(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ("activeKey={" + this.props.activeKey + "} />`.")) : void 0;
      return tabContainer;
    }

    return this.props;
  };

  _proto.getNextActiveChild = function getNextActiveChild(offset) {
    var _this2 = this;

    var children = this.props.children;
    var validChildren = children.filter(function (child) {
      return child.props.eventKey != null && !child.props.disabled;
    });

    var _this$getActiveProps2 = this.getActiveProps(),
        activeKey = _this$getActiveProps2.activeKey,
        activeHref = _this$getActiveProps2.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    }); // This assumes the active child is not disabled.

    var activeChildIndex = validChildren.indexOf(activeChild);

    if (activeChildIndex === -1) {
      // Something has gone wrong. Select the first valid child we can find.
      return validChildren[0];
    }

    var nextIndex = activeChildIndex + offset;
    var numValidChildren = validChildren.length;

    if (nextIndex >= numValidChildren) {
      nextIndex = 0;
    } else if (nextIndex < 0) {
      nextIndex = numValidChildren - 1;
    }

    return validChildren[nextIndex];
  };

  _proto.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
    var _this3 = this;

    if (!tabContainer && navRole !== 'tablist') {
      // No tab props here.
      return null;
    }

    var _child$props = child.props,
        id = _child$props.id,
        controls = _child$props['aria-controls'],
        eventKey = _child$props.eventKey,
        role = _child$props.role,
        onKeyDown = _child$props.onKeyDown,
        tabIndex = _child$props.tabIndex;

    if (tabContainer) {
       false ? warning(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
      id = tabContainer.getTabId(eventKey);
      controls = tabContainer.getPaneId(eventKey);
    }

    if (navRole === 'tablist') {
      role = role || 'tab';
      onKeyDown = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(function (event) {
        return _this3.handleTabKeyDown(onSelect, event);
      }, onKeyDown);
      tabIndex = active ? tabIndex : -1;
    }

    return {
      id: id,
      role: role,
      onKeyDown: onKeyDown,
      'aria-controls': controls,
      tabIndex: tabIndex
    };
  };

  _proto.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
    var nextActiveChild;

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_4_keycode___default.a.codes.left:
      case __WEBPACK_IMPORTED_MODULE_4_keycode___default.a.codes.up:
        nextActiveChild = this.getNextActiveChild(-1);
        break;

      case __WEBPACK_IMPORTED_MODULE_4_keycode___default.a.codes.right:
      case __WEBPACK_IMPORTED_MODULE_4_keycode___default.a.codes.down:
        nextActiveChild = this.getNextActiveChild(1);
        break;

      default:
        // It was a different key; don't handle this keypress.
        return;
    }

    event.preventDefault();

    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
      onSelect(nextActiveChild.props.eventKey);
    }

    this._needsRefocus = true;
  };

  _proto.isActive = function isActive(_ref2, activeKey, activeHref) {
    var props = _ref2.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    return props.active;
  };

  _proto.render = function render() {
    var _extends2,
        _this4 = this;

    var _this$props = this.props,
        stacked = _this$props.stacked,
        justified = _this$props.justified,
        onSelect = _this$props.onSelect,
        propsRole = _this$props.role,
        propsNavbar = _this$props.navbar,
        pullRight = _this$props.pullRight,
        pullLeft = _this$props.pullLeft,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["stacked", "justified", "onSelect", "role", "navbar", "pullRight", "pullLeft", "className", "children"]);

    var tabContainer = this.context.$bs_tabContainer;
    var role = propsRole || (tabContainer ? 'tablist' : null);

    var _this$getActiveProps3 = this.getActiveProps(),
        activeKey = _this$getActiveProps3.activeKey,
        activeHref = _this$getActiveProps3.activeHref;

    delete props.activeKey; // Accessed via this.getActiveProps().

    delete props.activeHref; // Accessed via this.getActiveProps().

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'stacked')] = stacked, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'justified')] = justified, _extends2));

    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
    var pullLeftClassName;
    var pullRightClassName;

    if (navbar) {
      var navbarProps = this.context.$bs_navbar || {
        bsClass: 'navbar'
      };
      classes[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'nav')] = true;
      pullRightClassName = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'right');
      pullLeftClassName = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'left');
    } else {
      pullRightClassName = 'pull-right';
      pullLeftClassName = 'pull-left';
    }

    classes[pullRightClassName] = pullRight;
    classes[pullLeftClassName] = pullLeft;
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: role,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      var active = _this4.isActive(child, activeKey, activeHref);

      var childOnSelect = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, _this4.getTabProps(child, tabContainer, role, active, childOnSelect), {
        active: active,
        activeKey: activeKey,
        activeHref: activeHref,
        onSelect: childOnSelect
      }));
    }));
  };

  return Nav;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;
Nav.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('nav', Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsStyles */])(['tabs', 'pills'], Nav)));

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);







var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
  })
};

var NavbarBrand =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(NavbarBrand, _React$Component);

  function NavbarBrand() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarBrand.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'brand');

    if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(children)) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(children, {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(children.props.className, className, bsClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsClassName)
    }), children);
  };

  return NavbarBrand;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavbarBrand.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (NavbarBrand);

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(75);









var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
var defaultProps = {
  active: false,
  disabled: false
};

var NavItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(NavItem, _React$Component);

  function NavItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = NavItem.prototype;

  _proto.handleClick = function handleClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.onSelect) {
      this.props.onSelect(this.props.eventKey, e);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        disabled = _this$props.disabled,
        onClick = _this$props.onClick,
        className = _this$props.className,
        style = _this$props.style,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["active", "disabled", "onClick", "className", "style"]);

    delete props.onSelect;
    delete props.eventKey; // These are injected down by `<Nav>` for building `<SubNav>`s.

    delete props.activeKey;
    delete props.activeHref;

    if (!props.role) {
      if (props.href === '#') {
        props.role = 'button';
      }
    } else if (props.role === 'tab') {
      props['aria-selected'] = active;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
      role: "presentation",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, {
        active: active,
        disabled: disabled
      }),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      disabled: disabled,
      onClick: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
    })));
  };

  return NavItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (NavItem);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Fade__ = __webpack_require__(357);










var propTypes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay___default.a.propTypes, {
  /**
   * Set the visibility of the Overlay
   */
  show: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
   */
  rootClose: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * A callback invoked by the overlay when it wishes to be hidden. Required if
   * `rootClose` is specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Use animation
   */
  animation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Sets the direction of the Overlay.
   */
  placement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left'])
});

var defaultProps = {
  animation: __WEBPACK_IMPORTED_MODULE_8__Fade__["a" /* default */],
  rootClose: false,
  show: false,
  placement: 'right'
};

var Overlay =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Overlay, _React$Component);

  function Overlay() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Overlay.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        animation = _this$props.animation,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["animation", "children"]);

    var transition = animation === true ? __WEBPACK_IMPORTED_MODULE_8__Fade__["a" /* default */] : animation || null;
    var child;

    if (!transition) {
      child = Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(children, {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(children.props.className, 'in')
      });
    } else {
      child = children;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay___default.a, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      transition: transition
    }), child);
  };

  return Overlay;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = offset;

var _contains = _interopRequireDefault(__webpack_require__(250));

var _isWindow = _interopRequireDefault(__webpack_require__(360));

var _ownerDocument = _interopRequireDefault(__webpack_require__(249));

function offset(node) {
  var doc = (0, _ownerDocument.default)(node),
      win = (0, _isWindow.default)(doc),
      docElem = doc && doc.documentElement,
      box = {
    top: 0,
    left: 0,
    height: 0,
    width: 0
  };
  if (!doc) return; // Make sure it's not a disconnected DOM node

  if (!(0, _contains.default)(docElem, node)) return box;
  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height

  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };
  return box;
}

module.exports = exports["default"];

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(360));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}

module.exports = exports["default"];

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(471);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(75);









var propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  next: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
var defaultProps = {
  disabled: false,
  previous: false,
  next: false
};

var PagerItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PagerItem, _React$Component);

  function PagerItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleSelect = _this.handleSelect.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = PagerItem.prototype;

  _proto.handleSelect = function handleSelect(e) {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        onSelect = _this$props.onSelect,
        eventKey = _this$props.eventKey;

    if (disabled) {
      e.preventDefault();
      return;
    }

    if (onSelect) {
      onSelect(eventKey, e);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        disabled = _this$props2.disabled,
        previous = _this$props2.previous,
        next = _this$props2.next,
        onClick = _this$props2.onClick,
        className = _this$props2.className,
        style = _this$props2.style,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["disabled", "previous", "next", "onClick", "className", "style"]);

    delete props.onSelect;
    delete props.eventKey;
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, {
        disabled: disabled,
        previous: previous,
        next: next
      }),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      disabled: disabled,
      onClick: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(onClick, this.handleSelect)
    })));
  };

  return PagerItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PagerItem.propTypes = propTypes;
PagerItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (PagerItem);

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Collapse__ = __webpack_require__(482);






var propTypes = {
  /**
   * Callback fired before the component expands
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to expand
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired after the component has expanded
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired before the component collapses
   */
  onExit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired after the component has collapsed
   */
  onExited: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    headingId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    bodyId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    bsClass: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  })
};

var PanelCollapse =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelCollapse, _React$Component);

  function PanelCollapse() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelCollapse.prototype;

  _proto.render = function render() {
    var children = this.props.children;

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        bodyId = _ref.bodyId,
        _bsClass = _ref.bsClass,
        expanded = _ref.expanded;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_4__utils_bootstrapUtils__["f" /* splitBsProps */])(this.props),
        bsProps = _splitBsProps[0],
        props = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId && bodyId) {
      props.id = bodyId;
      props.role = props.role || 'tabpanel';
      props['aria-labelledby'] = headingId;
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Collapse__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      in: expanded
    }, props), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_4__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'collapse')
    }, children));
  };

  return PanelCollapse;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

PanelCollapse.propTypes = propTypes;
PanelCollapse.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelCollapse));

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(75);









var propTypes = {
  /**
   * only here to satisfy linting, just the html onClick handler.
   *
   * @private
   */
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * You can use a custom element for this component
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default.a
};
var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__["a" /* default */]
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    bodyId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    onToggle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    expanded: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
  })
};

var PanelToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelToggle, _React$Component);

  function PanelToggle() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.handleToggle = _this.handleToggle.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = PanelToggle.prototype;

  _proto.handleToggle = function handleToggle(event) {
    var _ref = this.context.$bs_panel || {},
        onToggle = _ref.onToggle;

    if (onToggle) {
      onToggle(event);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        onClick = _this$props.onClick,
        className = _this$props.className,
        componentClass = _this$props.componentClass,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["onClick", "className", "componentClass"]);

    var _ref2 = this.context.$bs_panel || {},
        expanded = _ref2.expanded,
        bodyId = _ref2.bodyId;

    var Component = componentClass;
    props.onClick = Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(onClick, this.handleToggle);
    props['aria-expanded'] = expanded;
    props.className = __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, !expanded && 'collapsed');

    if (bodyId) {
      props['aria-controls'] = bodyId;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, props);
  };

  return PanelToggle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

PanelToggle.propTypes = propTypes;
PanelToggle.defaultProps = defaultProps;
PanelToggle.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (PanelToggle);

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Fade__ = __webpack_require__(357);












var propTypes = {
  /**
   * Uniquely identify the `<TabPane>` among its siblings.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
   * `true` to enable the default `<Fade>` animation or
   * a react-transition-group v2 `<Transition/>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),

  /** @private * */
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /** @private * */
  'aria-labelledby': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * If not explicitly specified and rendered in the context of a
   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
   * If otherwise not explicitly specified, `tab-pane`.
   */
  bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * Transition onEnter callback when animation is not `false`
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onEntering callback when animation is not `false`
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onEntered callback when animation is not `false`
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onExit callback when animation is not `false`
   */
  onExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onExiting callback when animation is not `false`
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onExited callback when animation is not `false`
   */
  onExited: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Unmount the tab (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    getTabId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    getPaneId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }),
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired
  })
};
/**
 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
 * conflict with the top level one.
 */

var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf([null])
};

var TabPane =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(TabPane, _React$Component);

  function TabPane(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleEnter = _this.handleEnter.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleExited = _this.handleExited.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.in = false;
    return _this;
  }

  var _proto = TabPane.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      $bs_tabContainer: null
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.shouldBeIn()) {
      // In lieu of the action event firing.
      this.handleEnter();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.in) {
      if (!this.shouldBeIn()) {
        // We shouldn't be active any more. Notify the parent.
        this.handleExited();
      }
    } else if (this.shouldBeIn()) {
      // We are the active child. Notify the parent.
      this.handleEnter();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.in) {
      // In lieu of the action event firing.
      this.handleExited();
    }
  };

  _proto.getAnimation = function getAnimation() {
    if (this.props.animation != null) {
      return this.props.animation;
    }

    var tabContent = this.context.$bs_tabContent;
    return tabContent && tabContent.animation;
  };

  _proto.handleEnter = function handleEnter() {
    var tabContent = this.context.$bs_tabContent;

    if (!tabContent) {
      return;
    }

    this.in = tabContent.onPaneEnter(this, this.props.eventKey);
  };

  _proto.handleExited = function handleExited() {
    var tabContent = this.context.$bs_tabContent;

    if (!tabContent) {
      return;
    }

    tabContent.onPaneExited(this);
    this.in = false;
  };

  _proto.isActive = function isActive() {
    var tabContent = this.context.$bs_tabContent;
    var activeKey = tabContent && tabContent.activeKey;
    return this.props.eventKey === activeKey;
  };

  _proto.shouldBeIn = function shouldBeIn() {
    return this.getAnimation() && this.isActive();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        eventKey = _this$props.eventKey,
        className = _this$props.className,
        onEnter = _this$props.onEnter,
        onEntering = _this$props.onEntering,
        onEntered = _this$props.onEntered,
        onExit = _this$props.onExit,
        onExiting = _this$props.onExiting,
        onExited = _this$props.onExited,
        propsMountOnEnter = _this$props.mountOnEnter,
        propsUnmountOnExit = _this$props.unmountOnExit,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["eventKey", "className", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "mountOnEnter", "unmountOnExit"]);

    var _this$context = this.context,
        tabContent = _this$context.$bs_tabContent,
        tabContainer = _this$context.$bs_tabContainer;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['animation']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var active = this.isActive();
    var animation = this.getAnimation();
    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;

    if (!active && !animation && unmountOnExit) {
      return null;
    }

    var Transition = animation === true ? __WEBPACK_IMPORTED_MODULE_11__Fade__["a" /* default */] : animation || null;

    if (tabContent) {
      bsProps.bsClass = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(tabContent, 'pane');
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      active: active
    });

    if (tabContainer) {
       false ? warning(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
      elementProps.id = tabContainer.getPaneId(eventKey);
      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
    }

    var pane = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "tabpanel",
      "aria-hidden": !active,
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }));

    if (Transition) {
      var exiting = tabContent && tabContent.exiting;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Transition, {
        in: active && !exiting,
        onEnter: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter),
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleExited, onExited),
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit
      }, pane);
    }

    return pane;
  };

  return TabPane;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TabPane.propTypes = propTypes;
TabPane.contextTypes = contextTypes;
TabPane.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('tab-pane', TabPane));

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(296);






var propTypes = {
  /**
   * The `<input>` `type`
   * @type {[type]}
   */
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['checkbox', 'radio']),

  /**
   * The HTML input name, used to group like checkboxes or radio buttons together
   * semantically
   */
  name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

  /**
   * The checked state of the input, managed by `<ToggleButtonGroup>`` automatically
   */
  checked: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * The disabled state of both the label and input
   */
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * [onChange description]
   */
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * The value of the input, and unique identifier in the ToggleButtonGroup
   */
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any.isRequired
};

var ToggleButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ToggleButton, _React$Component);

  function ToggleButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ToggleButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        name = _this$props.name,
        checked = _this$props.checked,
        type = _this$props.type,
        onChange = _this$props.onChange,
        value = _this$props.value,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "name", "checked", "type", "onChange", "value"]);

    var disabled = props.disabled;
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      active: !!checked,
      componentClass: "label"
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", {
      name: name,
      type: type,
      autoComplete: "off",
      value: value,
      checked: !!checked,
      disabled: !!disabled,
      onChange: onChange
    }), children);
  };

  return ToggleButton;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ToggleButton.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (ToggleButton);

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(735);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(493);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(97)))

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(741);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(745);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(491);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(674);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(677);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(678);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(466);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(347);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(679);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(680);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(467);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(348);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(681);
/* unused harmony reexport withRouter */





















/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCATION_CHANGE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = routerReducer;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  location: null

  /**
   * This reducer will update the state with the most recent location history
   * has transitioned to. This may not be in sync with the router, particularly
   * if you have asynchronously-loaded routes, so reading from and relying on
   * this state is discouraged.
   */
};function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { location: payload });
  }

  return state;
}

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALL_HISTORY_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return push; });
/* unused harmony export replace */
/* unused harmony export go */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return goBack; });
/* unused harmony export goForward */
/* unused harmony export routerActions */

/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = updateLocation('push');
var replace = updateLocation('replace');
var go = updateLocation('go');
var goBack = updateLocation('goBack');
var goForward = updateLocation('goForward');

var routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);
var settle = __webpack_require__(1318);
var buildURL = __webpack_require__(1320);
var parseHeaders = __webpack_require__(1321);
var isURLSameOrigin = __webpack_require__(1322);
var createError = __webpack_require__(751);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(1323);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(1319);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var LOCAL_STORAGE_KEY='spkl_accclem';var LOCAL_STORAGE_KEY_ACCOUNTS='spkl_accounts';var AuthenticationStorage=function(){function AuthenticationStorage(){_classCallCheck(this,AuthenticationStorage);}_createClass(AuthenticationStorage,null,[{key:'setCredentials',value:function setCredentials(accessToken,client,user){var localObject={accessToken:accessToken,client:client,user:user};this.setLocalStorageItem(LOCAL_STORAGE_KEY,localObject);}},{key:'setAccounts',value:function setAccounts(accessToken,client,user){var accounts=this.getAccounts();var localObject=[].concat(_toConsumableArray(accounts.filter(function(acc){return acc.user.id!==user.id;})),[{accessToken:accessToken,client:client,user:user}]);this.setLocalStorageItem(LOCAL_STORAGE_KEY_ACCOUNTS,localObject);return localObject;}},{key:'getCredentials',value:function getCredentials(){return this.retrieveLocalStorageItem(LOCAL_STORAGE_KEY);}},{key:'initializeAccounts',value:function initializeAccounts(){var accounts=[this.getCredentials()].filter(function(item){return!!item;});this.setLocalStorageItem(LOCAL_STORAGE_KEY_ACCOUNTS,accounts);return accounts;}},{key:'getAccounts',value:function getAccounts(){var accounts=this.retrieveLocalStorageItem(LOCAL_STORAGE_KEY_ACCOUNTS);return accounts?accounts:this.initializeAccounts();}},{key:'clearCredentials',value:function clearCredentials(){try{window.localStorage.removeItem(LOCAL_STORAGE_KEY);}catch(e){console.log(e);}}},{key:'clearCurrentAccount',value:function clearCurrentAccount(){var creds=this.getCredentials();var newAccounts=this.getAccounts().filter(function(acc){return acc.user.id!==(creds&&creds.user.id);});this.setLocalStorageItem(LOCAL_STORAGE_KEY_ACCOUNTS,newAccounts);}},{key:'setLocalStorageItem',value:function setLocalStorageItem(key,object){try{var json=JSON.stringify(object);var encoded=window.btoa(json);window.localStorage.setItem(key,encoded);}catch(e){console.log(e);}}},{key:'retrieveLocalStorageItem',value:function retrieveLocalStorageItem(key){var result=null;var encoded=window.localStorage.getItem(key);if(encoded!==null){try{var decoded=window.atob(encoded);result=JSON.parse(decoded);}catch(e){console.log(e);}}return result;}}]);return AuthenticationStorage;}();/* harmony default export */ __webpack_exports__["a"] = (AuthenticationStorage);

/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/round-full-readonly.7f722d64.svg";

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACPklEQVRYCe2ZPy8EQRyGZ363S+Q0dKJW+QAanHC5wp8IBY0OnwqdhoKIP8XlXBwaH+AqtehoXMHezdh3128tYRLJOCOZaWZuZjP77HOzs8m8UnxRjqvVGdUOVoWQk5rEsFSy/4vLfqVLk36SStwJoS8paO8tVCrnn28k8x3VamOkFXW2SFIp3/+XbaVVoxgWNiuV0i1zZNAntesJ/fxypCQN8KArNWn1KHt7FufL41dgSqBh+Dnq3DAwiYJWItoOdLjTag02V1ZGn7r1APv7zf5i8WG0LaN1EuGGEp2EEeC9YWEMxpOOw9P6BS8JkvI+0mJtebZU7xbod/c5OGtMh1LsKq2HcA2WytLc9JRMX7qeGjphOBKq7AIweFAScEG1zHjwUqZ0l0gvwJJwCRhU4AFXShjbjnc1wrbGHVjD3Hap/sglJwn7MAPipeO2S3WeC7yU/3B0c5f4iZQ8F3jj5fH/iofu1n/mTXvTBgN+eRjkWB3ypq3qNEzmTRvkWB3ypq3qNEzmTRvkWB3ypq3qNEzmTRvkWB3ypq3qNEzmTRvkWB3ypq3qNEwWn+Xp7MAcB9qGa/9sKM8F3vgsD6FMWnACz22X6jwXeOM1rS8ZEJEBt12qP3LFqRdiLwZExoGTd/7tQg0ecDELeAk5HbIMdCIiQMbhCngSXSBzeQuLwAneALDI6TjdQigTikLt6KzuQLpFG0q/p1t9MSd4k3QLjf+UI2YfFwSLyOl4qeBBXCjgARcHn2DKTOcBXc/GXwHfwwZTfKt7JgAAAABJRU5ErkJggg=="

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAMAAAANxBKoAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABLFBMVEUAAADwSDXwSTXwSDXvSDTxTDfvSTXySzbwSTXvSDTvSjb6w7z1joL5ubH////2nJH4q6L2nZL70MvvTTr0gnT//f382tbwUT7zd2j/+vn95OHwV0XybV3+9vX96+nxXkzxY1L+8O7+8fDyZlXvSTXxXEr96ef+9/byb1/2lov6y8XvTDjwVkP84t7/+/rzemv3pZv5wLnvSTbwUT782NT//v30hXj4s6v4sqrvTDn7zcj1kob6wrv3oJb5ta34r6bwTzz71dH//v76ycP5vLXwVEL839v6yMLvSzfxWkj95+X7087wTjvxYVD+7u383drwU0Dyaln+9PP95uPwWUbzdGX++fj97evxYE70f3H//Pz+9PLyaFj1i3/++PfzcmL2mI3/+/v0fG7yZ1ZbPBp2AAAACXRSTlMAQ5rY8yXAPe5FLo2fAAAAAWJLR0QOb70wTwAAAAd0SU1FB+IDEA4lDoU07YwAAAFHSURBVEjHldXXcsIwEAVQuVAuAYX03kkBUoD0SkJ6770n//8PsS2F4UX27n3aGR9rVnrYFcKPZTsuzHEd2xL/icURnXhM4USSgIFkIjiZhj3un05pQzfjXZCMAUvYDG0Lh6Ed4TK0KxgYiNCppjRDZ6RsJuus9JIl6hYZJJOi6LTCsrWNoNs7FO7sInTS3aNwbx+h7/4BhQeHCG8yPKLw6BhMOlevxicUnpyCSecLRV1Nzyg8OweTLklZrgTV/ILCi0sw6Mqy/33FL1fX9EOvw6CLZQVK3n8bGm/CqAua5LGlqyqMGts7ytR2Nd7LhWjsH8jGHB4hTOP4pAGfniFc4/yiji+vEKVxfaPx7R2iNe4fAvz4BIrG84uHX99A03ivyY9PUDW+vn9A1/gFR4eFOQd5M5Y3v3m7gbd3mDuNty+Zu5ix5/8AwaFZHIB8MhsAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDMtMTZUMTE6Mzc6MjctMDM6MDDMkm1KAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTAzLTE2VDE0OjM3OjE0LTAzOjAwH4d7mwAAAABJRU5ErkJggg=="

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/square-full-readonly.718dc615.svg";

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Invitation_css__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Invitation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Invitation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShowInvitation_css__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShowInvitation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ShowInvitation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserInvitations__ = __webpack_require__(495);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShowInvitation=function(_Component){_inherits(ShowInvitation,_Component);function ShowInvitation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ShowInvitation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ShowInvitation.__proto__||Object.getPrototypeOf(ShowInvitation)).call.apply(_ref,[this].concat(args))),_this),_this.handleRemove=function(){_this.props.onDelete(_this.props.user.id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ShowInvitation,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invitation-container show-invitation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label name'},this.props.user.firstName+' '+this.props.user.lastName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label'},this.props.user.email)),this.props.user.title!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label'},this.props.user.title)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:11},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'permissions-table'},this.props.user.permissions.map(function(permission){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'permissions-table-row',key:permission.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'permissions-table-cell permissions-table-cell-checkbox'},permission.selected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'glyphicon glyphicon-ok selected-icon'}):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'permissions-table-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:permission.selected?'label':'not-selected label'},permission.label)));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'button-remove',onClick:this.handleRemove},'Remove'))))))));}}]);return ShowInvitation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ShowInvitation.propTypes={user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(Object.assign({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number},__WEBPACK_IMPORTED_MODULE_5__UserInvitations__["a" /* InvitationPropTypes */])),onDelete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ShowInvitation);

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return USER_INVITATIONS_REQUEST_PERMISSIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER_INVITATIONS_REQUEST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USER_REMOVE_REQUEST_SUCCESS; });
/* harmony export (immutable) */ __webpack_exports__["e"] = userInvitationsStart;
/* unused harmony export permissionsRequestSuccess */
/* harmony export (immutable) */ __webpack_exports__["d"] = userInvitationsRequest;
/* unused harmony export userInvitationsRequestSuccess */
/* harmony export (immutable) */ __webpack_exports__["f"] = userRemoveRequest;
/* unused harmony export userRemoveSuccess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_clients_api__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_roles_api__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_users_api__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_utils_users_util__ = __webpack_require__(9);
var USER_INVITATIONS_REQUEST_PERMISSIONS_SUCCESS='USER_INVITATIONS_REQUEST_PERMISSIONS_SUCCESS';var USER_INVITATIONS_REQUEST_SUCCESS='USER_INVITATIONS_REQUEST_SUCCESS';var USER_REMOVE_REQUEST_SUCCESS='USER_REMOVE_REQUEST_SUCCESS';function userInvitationsStart(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__services_api_roles_api__["a" /* default */].getRoles('Client').then(function(response){if(response.ok){dispatch(permissionsRequestSuccess(response.permissions.filter(function(element){return element.name!=='owner';}).map(function(element){return{id:element.id,label:__WEBPACK_IMPORTED_MODULE_4__services_utils_users_util__["b" /* CLIENT_ROLES */][element.name]};})));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__messages__["d" /* showErrorMessage */])(response.errors));}});};}function permissionsRequestSuccess(permissions){return{type:USER_INVITATIONS_REQUEST_PERMISSIONS_SUCCESS,payload:permissions};}function userInvitationsRequest(user,invitations){return function(dispatch){__WEBPACK_IMPORTED_MODULE_0__services_api_clients_api__["b" /* default */].inviteUsers(user.accountable_id,invitations).then(function(response){if(response.ok){dispatch(userInvitationsRequestSuccess(response.users));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__messages__["d" /* showErrorMessage */])(response.errors));}});};}function userInvitationsRequestSuccess(users){return{type:USER_INVITATIONS_REQUEST_SUCCESS,payload:users};}function userRemoveRequest(id){return function(dispatch){__WEBPACK_IMPORTED_MODULE_2__services_api_users_api__["a" /* default */].removeUser(id).then(function(response){if(response.ok){dispatch(userRemoveSuccess(id));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__messages__["d" /* showErrorMessage */])(response.errors));}});};}function userRemoveSuccess(id){return{type:USER_REMOVE_REQUEST_SUCCESS,payload:id};}

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_PASSWORD_PASSWORD_UPDATE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = confirmPassword;
/* harmony export (immutable) */ __webpack_exports__["c"] = updatePassword;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_auth_api__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_authentication__ = __webpack_require__(174);
var SET_PASSWORD_PASSWORD_UPDATE='SET_PASSWORD_PASSWORD_UPDATE';function confirmPassword(invitationToken,password,passwordConfirmation,termsAccepted){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_auth_api__["a" /* authApi */].confirmPassword(invitationToken,password,passwordConfirmation,termsAccepted).then(function(response){if(response.ok){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actions_authentication__["g" /* authenticationRequest */])(response.email,password)).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])('/'));}else{dispatch(updatePassword('errors',response.errors));}});}else{dispatch(updatePassword('errors',response.errors));}});};}function updatePassword(attribute,value){return{type:SET_PASSWORD_PASSWORD_UPDATE,payload:{attribute:attribute,value:value}};}

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsModal_css__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TermsModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TermsModalText__ = __webpack_require__(1342);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TermsModal=function(_Component){_inherits(TermsModal,_Component);function TermsModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TermsModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TermsModal.__proto__||Object.getPrototypeOf(TermsModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleYes=function(event){event.preventDefault();_this.props.onHide(true);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TermsModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */],{className:'terms-modal',show:this.props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TermsModalText__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'terms_conditions_buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'confirmation-modal-yes',className:'btn button button-orange',type:'button',value:this.props.invited?'Close':'Accept Terms',onClick:this.handleYes}))));}}]);return TermsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TermsModal.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,invited:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onHide:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TermsModal);

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getActiveRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getHideSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getShowNewServiceWorkModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getActiveRoute=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.sidebar.activeRoute;},function(activeRoute){return activeRoute;});var getHideSidebar=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.sidebar.hideSideBar;},function(hideSideBar){return hideSideBar;});var getShowNewServiceWorkModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.sidebar.showNewServiceWorkModal;},function(showNewServiceWorkModal){return!!showNewServiceWorkModal;});

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SIDEBAR_SELECT_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIDE_SIDE_BAR_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TOGGLE_NEW_SERVICE_WORK; });
var SIDEBAR_SELECT_ROUTE='SIDEBAR_SELECT_ROUTE';var HIDE_SIDE_BAR_CHANGE='HIDE_SIDE_BAR_CHANGE';var TOGGLE_NEW_SERVICE_WORK='TOGGLE_NEW_SERVICE_WORK';

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorkOrders_css__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorkOrders_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__WorkOrders_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__empty_arrow_png__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__empty_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__empty_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_work_order_status_enum__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_navigation_SearchBar__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_table_WorkOrdersTable__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_selectors_notifications__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_actions_notifications__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_work_orders_WorkOrdersTitle__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_selectors_admin_team_client_team__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_actions_admin_team_client_team__ = __webpack_require__(379);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { ROLES, TYPES, usersUtil } from 'services/utils/users-util';
var WorkOrders=function(_Component){_inherits(WorkOrders,_Component);function WorkOrders(props){_classCallCheck(this,WorkOrders);var _this=_possibleConstructorReturn(this,(WorkOrders.__proto__||Object.getPrototypeOf(WorkOrders)).call(this,props));_this.handleAddWorkOrder=function(){// window.location.href = 'https://sw.spackle.co'
_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_work_orders__["b" /* addWorkOrder */])());};_this.showOverlay=function(){return _this.navSelected===1&&_this.props.showNoWorkOrdersOverlay;};_this.handleTableSelection=function(index){// "draft" WO pages expect the currentWO to be loaded, but "not draft" WO loads the info in WO details
var workOrderStatus=_this.props.workOrders.content[index].status;// Mark all notifications for the selected WO as read
_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_actions_notifications__["l" /* markAllAsRead */])(_this.props.workOrders.content[index].id));if(__WEBPACK_IMPORTED_MODULE_6_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].DRAFT.equals(__WEBPACK_IMPORTED_MODULE_6_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(workOrderStatus))){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_work_orders__["w" /* selectWorkOrderRequest */])(_this.props.workOrders.content[index].id,workOrderStatus));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_work_orders__["h" /* goToWorkOrder */])(_this.props.workOrders.content[index].id));}};_this.handleNavSelect=function(value){_this.navSelected=value;_this.handleChange(1);};_this.handlePageChange=function(newPage){_this.handleChange(newPage);};_this.handleClearSearchText=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_work_orders__["v" /* searchTextChange */])(''));};_this.handleContractorSearch=function(){_this.handleChange(1);};_this.handleSearchTextChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_work_orders__["v" /* searchTextChange */])(value));};_this.navSelected=1;_this.userIsContractor=__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);return _this;}_createClass(WorkOrders,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,client=_props.client,currentUser=_props.currentUser,perPage=_props.perPage,dispatch=_props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_work_orders__["q" /* loadWorkOrdersRequest */])({page:1,perPage:perPage}));if(__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["f" /* TYPES */].CLIENT)){var clientId=currentUser.accountable_id;if(client===null||client.id!==clientId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_actions_admin_team_client_team__["d" /* loadClientRequest */])(clientId));}}}},{key:'componentDidUpdate',value:function componentDidUpdate(){Object(__WEBPACK_IMPORTED_MODULE_13_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}},{key:'handleChange',value:function handleChange(page){var criteria={page:page};switch(this.navSelected){case 2:criteria.critical=true;break;case 3:criteria.status=__WEBPACK_IMPORTED_MODULE_6_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].DRAFT;break;case 4:criteria.status=__WEBPACK_IMPORTED_MODULE_6_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].PENDING;break;case 5:criteria.status=__WEBPACK_IMPORTED_MODULE_6_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].PLM;break;case 6:criteria.status=__WEBPACK_IMPORTED_MODULE_6_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].WOA;break;case 7:criteria.status=__WEBPACK_IMPORTED_MODULE_6_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].IN_PROGRESS;break;case 8:criteria.status=__WEBPACK_IMPORTED_MODULE_6_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].COMPLETE;break;case 9:criteria.status=__WEBPACK_IMPORTED_MODULE_6_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].CLOSED;break;case 10:criteria.status=__WEBPACK_IMPORTED_MODULE_6_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].DECLINED;break;default:}if(this.props.searchText!==''){criteria.jobNumber=this.props.searchText;}if(this.props.perPage){criteria.perPage=this.props.perPage;}this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_work_orders__["q" /* loadWorkOrdersRequest */])(criteria));}},{key:'render',value:function render(){var workOrderMarkById={};if(this.props.notifications!==null&&this.props.notifications.content.length>0){// Look for notifications not read yet, to mark the WO
workOrderMarkById=this.props.notifications.content.filter(function(notification){return notification.read_at===null;}).reduce(function(accumulator,currentNotification){var id=null;if(currentNotification.notifiable_type==='WorkOrder'){id=currentNotification.notifiable.id;}else if(currentNotification.notifiable!==null){id=currentNotification.notifiable.work_order_id;}if(id!==null){accumulator[id]=true;}return accumulator;},{});}var clientPurchaseOrder=this.props.client!==null?this.props.client.purchase_order:null;var onContractorSearch=null;if(this.userIsContractor){onContractorSearch=this.handleContractorSearch;}var showTitle=this.props.showTitle;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'work-orders'},showTitle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_admin_work_orders_WorkOrdersTitle__["a" /* default */],{purchaseOrder:clientPurchaseOrder,title:'Work Orders'})),this.props.workOrders!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_navigation_SearchBar__["a" /* default */],{addButton:this.renderAddButton(),searchPlaceHolder:'Search by Job #',searchText:this.props.searchText,onClearText:this.handleClearSearchText,onSearch:onContractorSearch,onSearchTextChange:this.handleSearchTextChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'All'},{id:2,show:this.props.workOrders.totalCritical>0,title:'Critical',total:this.props.workOrders.totalCritical},{id:3,show:this.props.workOrders.totalDraft>0,title:'Draft',total:this.props.workOrders.totalDraft},{id:4,show:this.props.workOrders.totalPending>0,title:'Pending',total:this.props.workOrders.totalPending},{id:5,show:this.props.workOrders.totalPlm>0,title:'PLM',total:this.props.workOrders.totalPlm},{id:6,show:this.props.workOrders.totalWoa>0,title:'WOA',total:this.props.workOrders.totalWoa},{id:7,show:this.props.workOrders.totalInProgress>0,title:'In Progress',total:this.props.workOrders.totalInProgress},{id:8,show:this.props.workOrders.totalComplete>0,title:'Complete',total:this.props.workOrders.totalComplete},{id:9,show:this.props.workOrders.totalClosed>0,title:'Closed',total:this.props.workOrders.totalClosed},{id:10,show:this.props.workOrders.totalDeclined>0,title:'Declined',total:this.props.workOrders.totalDeclined}],onSelected:this.handleNavSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_table_WorkOrdersTable__["a" /* default */],{currentPage:this.props.currentPage,currentUser:this.props.currentUser,pageSize:this.props.workOrders.pageSize,showFilter:false,totals:{all:this.props.workOrders.total},workOrders:this.props.workOrders.content,workOrderMarkById:workOrderMarkById,onPageChange:this.handlePageChange,onWorkOrderSelection:this.handleTableSelection})),!__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["f" /* TYPES */].CONTRACTOR)&&this.showOverlay()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no-work-orders-overlay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Welcome to the Spackle App',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__empty_arrow_png___default.a,alt:'arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Create your first work order')));}},{key:'renderAddButton',value:function renderAddButton(){// const { showControls } = this.props;
// Don't show add WO button if user is a contractor or is business dev or field admin
// const canAdd =
//   showControls &&
//   (usersUtil.hasRole(this.props.currentUser, ROLES.SPACKLE_ADMIN) ||
//     usersUtil.hasType(this.props.currentUser, TYPES.CLIENT) ||
//     usersUtil.hasType(this.props.currentUser, TYPES.GENERAL_CONTRACTOR));
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange button-add-work-order'+(this.showOverlay()?' on-top':''),type:'button',value:'Add Work Order',onClick:this.handleAddWorkOrder}),this.showOverlay()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'empty-button-block'}));}}]);return WorkOrders;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);WorkOrders.propTypes={perPage:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,showTitle:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,showControls:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool};WorkOrders.defaultProps={perPage:25,showTitle:true,showControls:true};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(state){return{client:Object(__WEBPACK_IMPORTED_MODULE_17_selectors_admin_team_client_team__["b" /* getClient */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_work_orders__["d" /* getCurrentPage */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_authentication__["d" /* getCurrentUser */])(state),notifications:Object(__WEBPACK_IMPORTED_MODULE_14_selectors_notifications__["b" /* getNotifications */])(state),showNoWorkOrdersOverlay:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_work_orders__["f" /* getShowNoWorkOrdersOverlay */])(state),searchText:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_work_orders__["m" /* searchTextSelector */])(state),workOrders:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_work_orders__["l" /* getWorkOrders */])(state)};})(WorkOrders));

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return vendorInvoicesApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VendorInvoicesApi=function(_BaseApi){_inherits(VendorInvoicesApi,_BaseApi);function VendorInvoicesApi(){_classCallCheck(this,VendorInvoicesApi);return _possibleConstructorReturn(this,(VendorInvoicesApi.__proto__||Object.getPrototypeOf(VendorInvoicesApi)).apply(this,arguments));}_createClass(VendorInvoicesApi,[{key:'deleteVendorInvoice',value:function deleteVendorInvoice(vendorInvoiceId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/vendor_invoices/'+vendorInvoiceId).then(function(){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getVendorInvoices',value:function getVendorInvoices(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var workOrderJobNumber=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var searchFilters=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var filter='';if(workOrderJobNumber!==null&&workOrderJobNumber!==''){filter+='&by_job_number='+workOrderJobNumber;}if(searchFilters){Object.keys(searchFilters).forEach(function(attr){filter+='&'+attr+'='+searchFilters[attr];});}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/vendor_invoices?page='+page+filter).then(function(response){return{ok:true,invoices:{content:response.data,pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value(),total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'markAsPaid',value:function markAsPaid(invoiceId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/vendor_invoices/'+invoiceId+'/paid').then(function(response){return{ok:true,invoice:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return VendorInvoicesApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var vendorInvoicesApi=new VendorInvoicesApi();

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_utils_work_order_status_enum__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_SimpleText__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WorkOrdersTable_css__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WorkOrdersTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__WorkOrdersTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_text_BaseStatus__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_domain_work_order__ = __webpack_require__(177);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Simple table for work orders with pagination. Shows fixed headers.
 */var WorkOrdersTable=function(_Component){_inherits(WorkOrdersTable,_Component);function WorkOrdersTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,WorkOrdersTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WorkOrdersTable.__proto__||Object.getPrototypeOf(WorkOrdersTable)).call.apply(_ref,[this].concat(args))),_this),_this.handleGenerateLink=function(index){var workOrders=_this.props.workOrders;return'work-orders/'+workOrders[index].id;},_this.handleFilterSelect=function(option){if(_this.props.onFilterChange!==undefined){_this.props.onFilterChange(option);}},_this.buildContractorName=function(wo){var currentUser=_this.props.currentUser;var isContractor=currentUser!==null&&__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);var isGc=currentUser!==null&&__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);var contractorName='';if(isContractor){contractorName=wo.general_contractor_name;}else if(isGc){contractorName=wo.contractor_name;}else{contractorName=wo.general_contractor_name||wo.contractor_name;}return contractorName||'N/A';},_this.mapWorkOrders=function(workOrders,showAmount,showVariance,showJobNumber,showClientName){return workOrders.map(function(element){var showMark=_this.props.workOrderMarkById[element.id]!==undefined;var startDate=__WEBPACK_IMPORTED_MODULE_11_domain_work_order__["a" /* WorkOrder */].getStartDate(element);var completionDate=__WEBPACK_IMPORTED_MODULE_11_domain_work_order__["a" /* WorkOrder */].getCompletionDate(element);var amount=__WEBPACK_IMPORTED_MODULE_11_domain_work_order__["a" /* WorkOrder */].getTotalCost(element);var row=[{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_BaseStatus__["a" /* default */],{labels:[{id:'read',label:''},{id:'unread',label:''}],status:showMark?'unread':'read'}),show:function show(){return true;}},{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:showMark?'small-bold':null},element.number.toString()),show:function show(){return true;}},{content:__WEBPACK_IMPORTED_MODULE_11_domain_work_order__["a" /* WorkOrder */].getJobNumber(element,'N/A'),show:function show(){return showJobNumber;}},{content:__WEBPACK_IMPORTED_MODULE_11_domain_work_order__["a" /* WorkOrder */].getName(element,'N/A'),show:function show(){return true;}},{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'company-name-cell'},element.client.company_name),show:function show(){return showClientName;}},{content:_this.buildContractorName(element),show:function show(){return true;}},{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_SimpleText__["a" /* default */],{lines:[element.building.location.street_address_1,element.building.location.city]}),show:function show(){return true;}},{content:__WEBPACK_IMPORTED_MODULE_2_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(element.status).label,show:function show(){return true;}},{content:startDate!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__["a" /* default */],{value:startDate,format:'ll'}):'TBD',show:function show(){return true;}},{content:completionDate!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__["a" /* default */],{value:completionDate,format:'ll'}):'TBD',show:function show(){return true;}},{content:amount!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:amount,format:'$0,0'}):'TBD',show:function show(){return showAmount;}},{content:element.created_at!=null&&element.created_at!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__["a" /* default */],{value:element.created_at,format:'ll'}):'N/A',show:function show(){return true;}},{content:__WEBPACK_IMPORTED_MODULE_11_domain_work_order__["a" /* WorkOrder */].getVariance(element,'N/A'),show:function show(){return showVariance;}}];row=row.filter(function(item){return item.show();}).map(function(item){return item.content;});return row;});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WorkOrdersTable,[{key:'render',value:function render(){var currentUser=this.props.currentUser;var isContractor=currentUser!==null&&__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);var isClient=currentUser!==null&&__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["f" /* TYPES */].CLIENT);var showAmount=!isContractor;var showVariance=currentUser!==null&&(__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasRole(currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR));var showJobNumber=isContractor;var showClientName=!isClient;var headers=[{title:'',show:function show(){return true;}},{title:'WO #',show:function show(){return true;}},{title:'JOB #',show:function show(){return showJobNumber;}},{title:'NAME',show:function show(){return true;}},{title:'CLIENT NAME',show:function show(){return showClientName;}},{title:isContractor?'GENERAL CONTRACTOR':'CONTRACTOR',show:function show(){return true;}},{title:'LOCATION',show:function show(){return true;}},{title:'STATUS',show:function show(){return true;}},{title:'START DATE',show:function show(){return true;}},{title:'END DATE',show:function show(){return true;}},{title:'WO AMOUNT',show:function show(){return showAmount;}},{title:'CREATED AT',show:function show(){return true;}},{title:'VARIANCE',show:function show(){return showVariance;}}];headers=headers.filter(function(item){return item.show();}).map(function(item){return item.title;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wo-table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__SimpleTable__["a" /* default */],{className:'work-orders-table',headers:headers,rows:this.mapWorkOrders(this.props.workOrders,showAmount,showVariance,showJobNumber,showClientName),emptyMessage:'No Work Orders',onRowSelected:this.props.onWorkOrderSelection,onGenerateLink:this.handleGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.currentPage,pageSize:this.props.pageSize,total:this.props.totals.all,onPageChange:this.props.onPageChange})));}}]);return WorkOrdersTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);WorkOrdersTable.propTypes={currentFilter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,currentPage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,currentUser:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,pageSize:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,showFilter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,totals:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({all:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,draft:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,pending:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,inProgress:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,complete:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,closed:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number}).isRequired,workOrderMarkById:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,// [key: id, value: bool]
workOrders:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any).isRequired,onFilterChange:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onPageChange:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onWorkOrderSelection:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};WorkOrdersTable.defaultProps={currentUser:null,showFilter:true,workOrderMarkById:{}};/* harmony default export */ __webpack_exports__["a"] = (WorkOrdersTable);

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
/* harmony default export */ __webpack_exports__["a"] = (hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__');

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStyles__ = __webpack_require__(1404);
/* unused harmony reexport default */


/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isBrowser */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["a"] = (isBrowser);


/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(776);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ThemeContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);

if (false) {
  ThemeContext.displayName = 'ThemeContext';
}

/* harmony default export */ __webpack_exports__["a"] = (ThemeContext);

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sheetsManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StylesContext; });
/* harmony export (immutable) */ __webpack_exports__["b"] = StylesProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createGenerateClassName__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jss__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jssPreset__ = __webpack_require__(509);







 // Default JSS instance.

var jss = Object(__WEBPACK_IMPORTED_MODULE_6_jss__["c" /* create */])(Object(__WEBPACK_IMPORTED_MODULE_7__jssPreset__["a" /* default */])()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = Object(__WEBPACK_IMPORTED_MODULE_5__createGenerateClassName__["a" /* default */])(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createContext(defaultOptions);

if (false) {
  StylesContext.displayName = 'StylesContext';
}

var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(StylesContext);

  var context = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (false) {
    if (typeof window === 'undefined' && !context.sheetsManager) {
      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
    }
  }

  if (false) {
    if (context.jss.options.insertionPoint && injectFirst) {
      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
    }
  }

  if (false) {
    if (injectFirst && localOptions.jss) {
      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
    }
  }

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = Object(__WEBPACK_IMPORTED_MODULE_6_jss__["c" /* create */])({
      plugins: Object(__WEBPACK_IMPORTED_MODULE_7__jssPreset__["a" /* default */])().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
 false ? StylesProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: PropTypes.bool,

  /**
   * JSS's class name generator.
   */
  generateClassName: PropTypes.func,

  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: PropTypes.bool,

  /**
   * JSS's instance.
   */
  jss: PropTypes.object,

  /**
   * @ignore
   */
  serverGenerateClassName: PropTypes.func,

  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: PropTypes.object,

  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: PropTypes.object,

  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: PropTypes.object
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = exactProp(StylesProvider.propTypes) : void 0;
}

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
/* harmony default export */ __webpack_exports__["a"] = (noopTheme);

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ServerStyleSheets__ = __webpack_require__(1426);
/* unused harmony reexport default */


/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styled__ = __webpack_require__(1428);
/* unused harmony reexport default */


/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThemeProvider__ = __webpack_require__(1429);
/* unused harmony reexport default */


/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withStyles__ = __webpack_require__(1430);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withStyles__["a"]; });


/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withTheme__ = __webpack_require__(786);
/* unused harmony reexport default */
/* unused harmony namespace reexport */



/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export withThemeCreator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useTheme__ = __webpack_require__(258);







function withThemeCreator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultTheme = options.defaultTheme;

  var withTheme = function withTheme(Component) {
    if (false) {
      if (Component === undefined) {
        throw new Error(['You are calling withTheme(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var WithTheme = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function WithTheme(props, ref) {
      var innerRef = props.innerRef,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["innerRef"]);

      var theme = Object(__WEBPACK_IMPORTED_MODULE_6__useTheme__["a" /* default */])() || defaultTheme;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        theme: theme,
        ref: innerRef || ref
      }, other));
    });
     false ? WithTheme.propTypes = {
      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return new Error('Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' + 'Refs are now automatically forwarded to the inner component.');
      })
    } : void 0;

    if (false) {
      WithTheme.displayName = "WithTheme(".concat(getDisplayName(Component), ")");
    }

    __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(WithTheme, Component);

    if (false) {
      // Exposed for test purposes.
      WithTheme.Naked = Component;
    }

    return WithTheme;
  };

  return withTheme;
} // Provide the theme object as a prop to the input component.
// It's an alternative API to useTheme().
// We encourage the usage of useTheme() where possible.

var withTheme = withThemeCreator();
/* unused harmony default export */ var _unused_webpack_default_export = (withTheme);

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export border */
/* unused harmony export borderTop */
/* unused harmony export borderRight */
/* unused harmony export borderBottom */
/* unused harmony export borderLeft */
/* unused harmony export borderColor */
/* unused harmony export borderRadius */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(176);



function getBorder(value) {
  if (typeof value !== 'number') {
    return value;
  }

  return "".concat(value, "px solid");
}

var border = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'border',
  themeKey: 'borders',
  transform: getBorder
});
var borderTop = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderTop',
  themeKey: 'borders',
  transform: getBorder
});
var borderRight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderRight',
  themeKey: 'borders',
  transform: getBorder
});
var borderBottom = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderBottom',
  themeKey: 'borders',
  transform: getBorder
});
var borderLeft = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderLeft',
  themeKey: 'borders',
  transform: getBorder
});
var borderColor = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderColor',
  themeKey: 'palette'
});
var borderRadius = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderRadius',
  themeKey: 'shape'
});
var borders = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderRadius);
/* unused harmony default export */ var _unused_webpack_default_export = (borders);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var responsivePropType =  false ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
/* unused harmony default export */ var _unused_webpack_default_export = (responsivePropType);

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export flexBasis */
/* unused harmony export flexDirection */
/* unused harmony export flexWrap */
/* unused harmony export justifyContent */
/* unused harmony export alignItems */
/* unused harmony export alignContent */
/* unused harmony export order */
/* unused harmony export flex */
/* unused harmony export flexGrow */
/* unused harmony export flexShrink */
/* unused harmony export alignSelf */
/* unused harmony export justifyItems */
/* unused harmony export justifySelf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(176);


var flexBasis = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexBasis'
});
var flexDirection = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexDirection'
});
var flexWrap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexWrap'
});
var justifyContent = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'justifyContent'
});
var alignItems = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'alignItems'
});
var alignContent = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'alignContent'
});
var order = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'order'
});
var flex = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flex'
});
var flexGrow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexGrow'
});
var flexShrink = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexShrink'
});
var alignSelf = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'alignSelf'
});
var justifyItems = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'justifyItems'
});
var justifySelf = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'justifySelf'
});
var flexbox = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
/* unused harmony default export */ var _unused_webpack_default_export = (flexbox);

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gridGap */
/* unused harmony export gridColumnGap */
/* unused harmony export gridRowGap */
/* unused harmony export gridColumn */
/* unused harmony export gridRow */
/* unused harmony export gridAutoFlow */
/* unused harmony export gridAutoColumns */
/* unused harmony export gridAutoRows */
/* unused harmony export gridTemplateColumns */
/* unused harmony export gridTemplateRows */
/* unused harmony export gridTemplateAreas */
/* unused harmony export gridArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(176);


var gridGap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridGap'
});
var gridColumnGap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridColumnGap'
});
var gridRowGap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridRowGap'
});
var gridColumn = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridColumn'
});
var gridRow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridRow'
});
var gridAutoFlow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridAutoFlow'
});
var gridAutoColumns = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridAutoColumns'
});
var gridAutoRows = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridAutoRows'
});
var gridTemplateColumns = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridTemplateColumns'
});
var gridTemplateRows = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridTemplateRows'
});
var gridTemplateAreas = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridTemplateAreas'
});
var gridArea = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridArea'
});
var grid = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(gridGap, gridColumnGap, gridRowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
/* unused harmony default export */ var _unused_webpack_default_export = (grid);

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export color */
/* unused harmony export bgcolor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(176);


var color = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'color',
  themeKey: 'palette'
});
var bgcolor = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette'
});
var palette = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(color, bgcolor);
/* unused harmony default export */ var _unused_webpack_default_export = (palette);

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export position */
/* unused harmony export zIndex */
/* unused harmony export top */
/* unused harmony export right */
/* unused harmony export bottom */
/* unused harmony export left */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(176);


var position = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'position'
});
var zIndex = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'zIndex',
  themeKey: 'zIndex'
});
var top = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'top'
});
var right = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'right'
});
var bottom = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'bottom'
});
var left = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'left'
});
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(position, zIndex, top, right, bottom, left));

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export width */
/* unused harmony export maxWidth */
/* unused harmony export minWidth */
/* unused harmony export height */
/* unused harmony export maxHeight */
/* unused harmony export minHeight */
/* unused harmony export sizeWidth */
/* unused harmony export sizeHeight */
/* unused harmony export boxSizing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(176);



function transform(value) {
  return value <= 1 ? "".concat(value * 100, "%") : value;
}

var width = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'width',
  transform: transform
});
var maxWidth = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'maxWidth',
  transform: transform
});
var minWidth = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'minWidth',
  transform: transform
});
var height = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'height',
  transform: transform
});
var maxHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'maxHeight',
  transform: transform
});
var minHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'minHeight',
  transform: transform
});
var sizeWidth = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'size',
  cssProperty: 'width',
  transform: transform
});
var sizeHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'size',
  cssProperty: 'height',
  transform: transform
});
var boxSizing = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'boxSizing'
});
var sizing = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
/* unused harmony default export */ var _unused_webpack_default_export = (sizing);

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createUnarySpacing;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__responsivePropType__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breakpoints__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__merge__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__memoize__ = __webpack_require__(1456);





var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
var aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec

var getCssProperties = Object(__WEBPACK_IMPORTED_MODULE_4__memoize__["a" /* default */])(function (prop) {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }

  var _prop$split = prop.split(''),
      _prop$split2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_prop$split, 2),
      a = _prop$split2[0],
      b = _prop$split2[1];

  var property = properties[a];
  var direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(function (dir) {
    return property + dir;
  }) : [property + direction];
});
var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (false) {
        if (typeof abs !== 'number') {
          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
        }
      }

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (false) {
        if (abs > themeSpacing.length - 1) {
          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
        }
      }

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (false) {
    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
  }

  return function () {
    return undefined;
  };
}

function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }

  var abs = Math.abs(propValue);
  var transformed = transformer(abs);

  if (propValue >= 0) {
    return transformed;
  }

  if (typeof transformed === 'number') {
    return -transformed;
  }

  return "-".concat(transformed);
}

function getStyleFromPropValue(cssProperties, transformer) {
  return function (propValue) {
    return cssProperties.reduce(function (acc, cssProperty) {
      acc[cssProperty] = getValue(transformer, propValue);
      return acc;
    }, {});
  };
}

function spacing(props) {
  var theme = props.theme;
  var transformer = createUnarySpacing(theme);
  return Object.keys(props).map(function (prop) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (spacingKeys.indexOf(prop) === -1) {
      return null;
    }

    var cssProperties = getCssProperties(prop);
    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    var propValue = props[prop];
    return Object(__WEBPACK_IMPORTED_MODULE_2__breakpoints__["a" /* handleBreakpoints */])(props, propValue, styleFromPropValue);
  }).reduce(__WEBPACK_IMPORTED_MODULE_3__merge__["a" /* default */], {});
}

spacing.propTypes =  false ? spacingKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
spacing.filterProps = spacingKeys;
/* unused harmony default export */ var _unused_webpack_default_export = (spacing);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fontFamily */
/* unused harmony export fontSize */
/* unused harmony export fontStyle */
/* unused harmony export fontWeight */
/* unused harmony export letterSpacing */
/* unused harmony export lineHeight */
/* unused harmony export textAlign */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(176);


var fontFamily = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontFamily',
  themeKey: 'typography'
});
var fontSize = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontSize',
  themeKey: 'typography'
});
var fontStyle = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontStyle',
  themeKey: 'typography'
});
var fontWeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontWeight',
  themeKey: 'typography'
});
var letterSpacing = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'letterSpacing'
});
var lineHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'lineHeight'
});
var textAlign = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'textAlign'
});
var typography = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign);
/* unused harmony default export */ var _unused_webpack_default_export = (typography);

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var TableContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();

if (false) {
  TableContext.displayName = 'TableContext';
}

/* harmony default export */ __webpack_exports__["a"] = (TableContext);

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(377);

var _utils2 = _interopRequireDefault(_utils);

var _smooth = __webpack_require__(1475);

var _smooth2 = _interopRequireDefault(_smooth);

var _cancelEvents = __webpack_require__(1476);

var _cancelEvents2 = _interopRequireDefault(_cancelEvents);

var _scrollEvents = __webpack_require__(518);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPosition: 0,
    startPosition: 0,
    targetPosition: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    delta: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionX = function currentPositionX(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollLeft;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
  }
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerWidth = function scrollContainerWidth(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollWidth - containerElement.offsetWidth;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollHeight - containerElement.offsetHeight;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  };

  data.delta = Math.round(data.targetPosition - data.startPosition);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    if (options.horizontal) {
      data.containerElement.scrollLeft = data.currentPosition;
    } else {
      data.containerElement.scrollTop = data.currentPosition;
    }
  } else {
    if (options.horizontal) {
      window.scrollTo(data.currentPosition, 0);
    } else {
      window.scrollTo(0, data.currentPosition);
    }
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2.default.registered['end']) {
    _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPosition);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  _cancelEvents2.default.subscribe(function () {
    options.data.cancel = true;
  });

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;

  if (options.data.startPosition === options.data.targetPosition) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPosition);
    }
    return;
  }

  options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);

  options.data.duration = functionWrapper(options.duration)(options.data.delta);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
      }
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  if (_scrollEvents2.default.registered['begin']) {
    _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
  }
  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toPosition, options) {
  animateTopScroll(toPosition, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(options.horizontal ? scrollContainerWidth(options) : scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toPosition, options) {
  options = proceedOptions(options);
  setContainer(options);
  var currentPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  animateTopScroll(toPosition + currentPosition, options);
};

exports.default = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__(517);

var _utils = __webpack_require__(377);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHash = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to, saveHashHistory) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.updateHash(to, saveHashHistory);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

exports.default = scrollHash;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(60);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _scroller = __webpack_require__(376);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Component) {
  var Element = function (_React$Component) {
    _inherits(Element, _React$Component);

    function Element(props) {
      _classCallCheck(this, Element);

      var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.registerElems(this.props.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2.default.Component);

  ;

  Element.propTypes = {
    name: _propTypes2.default.string,
    id: _propTypes2.default.string
  };

  return Element;
};

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return notificationsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotificationsApi=function(_BaseApi){_inherits(NotificationsApi,_BaseApi);function NotificationsApi(){_classCallCheck(this,NotificationsApi);return _possibleConstructorReturn(this,(NotificationsApi.__proto__||Object.getPrototypeOf(NotificationsApi)).apply(this,arguments));}_createClass(NotificationsApi,[{key:'getNotifications',value:function getNotifications(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var filters=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var query='page='+page;Object.keys(filters).forEach(function(filter){query+='&'+filter+'='+filters[filter];});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/notifications?'+query,{loadingDisabled:true}).then(function(response){return{ok:true,notifications:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),totalUnread:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-unread']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'markAsRead',value:function markAsRead(id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/notifications/'+id+'/mark_as_read',null,{loadingDisabled:true}).then(function(response){return{ok:true,notification:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'markAsUnread',value:function markAsUnread(id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/notifications/'+id+'/mark_as_unread',null,{loadingDisabled:true}).then(function(response){return{ok:true,notification:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'markAllAsRead',value:function markAllAsRead(workOrderId,notifiableId,notifiableType){var query='';if(workOrderId!==undefined){query='?by_wo='+workOrderId;}else if(notifiableId!==undefined&&notifiableType!==undefined){query='?by_notifiable[id]='+notifiableId+'&by_notifiable[type]='+notifiableType;}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/notifications/mark_all_read'+query,null,{loadingDisabled:true}).then(function(response){return{ok:true,notifications:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),totalUnread:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-unread']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return NotificationsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var notificationsApi=new NotificationsApi();

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1492), __esModule: true };

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1494);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1500);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(686);
var hiddenKeys = __webpack_require__(475).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1512),
    shortOut = __webpack_require__(809);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(228);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(97)))

/***/ }),
/* 808 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 809 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(305),
    metaMap = __webpack_require__(811);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(812);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(228),
    root = __webpack_require__(112);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(814),
    composeArgsRight = __webpack_require__(815),
    countHolders = __webpack_require__(1523),
    createCtor = __webpack_require__(382),
    createRecurry = __webpack_require__(816),
    getHolder = __webpack_require__(526),
    reorder = __webpack_require__(1538),
    replaceHolders = __webpack_require__(385),
    root = __webpack_require__(112);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 814 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 815 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(1524),
    setData = __webpack_require__(820),
    setWrapToString = __webpack_require__(821);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(811),
    noop = __webpack_require__(1525);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(383),
    baseLodash = __webpack_require__(525);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 819 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(810),
    shortOut = __webpack_require__(809);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(1530),
    insertWrapDetails = __webpack_require__(1531),
    setToString = __webpack_require__(805),
    updateWrapDetails = __webpack_require__(1532);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 822 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(1543),
    isObject = __webpack_require__(125),
    isSymbol = __webpack_require__(386);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 824 */
/***/ (function(module, exports) {

var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(532),
    nativeKeys = __webpack_require__(1562);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1565),
    baseMatchesProperty = __webpack_require__(1610),
    identity = __webpack_require__(305),
    isArray = __webpack_require__(113),
    property = __webpack_require__(1619);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(387),
    stackClear = __webpack_require__(1572),
    stackDelete = __webpack_require__(1573),
    stackGet = __webpack_require__(1574),
    stackHas = __webpack_require__(1575),
    stackSet = __webpack_require__(1576);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1589),
    isObjectLike = __webpack_require__(261);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1590),
    arraySome = __webpack_require__(1593),
    cacheHas = __webpack_require__(1594);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1606),
    Map = __webpack_require__(533),
    Promise = __webpack_require__(1607),
    Set = __webpack_require__(1608),
    WeakMap = __webpack_require__(812),
    baseGetTag = __webpack_require__(306),
    toSource = __webpack_require__(808);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(125);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 832 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(834),
    toKey = __webpack_require__(392);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(113),
    isKey = __webpack_require__(535),
    stringToPath = __webpack_require__(1612),
    toString = __webpack_require__(835);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1615);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(834),
    isArguments = __webpack_require__(528),
    isArray = __webpack_require__(113),
    isIndex = __webpack_require__(384),
    isLength = __webpack_require__(531),
    toKey = __webpack_require__(392);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 837 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(839),
    copyObject = __webpack_require__(841),
    createAssigner = __webpack_require__(1645),
    isArrayLike = __webpack_require__(308),
    isPrototype = __webpack_require__(532),
    keys = __webpack_require__(307);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(840),
    eq = __webpack_require__(389);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(806);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(839),
    baseAssignValue = __webpack_require__(840);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(389),
    isArrayLike = __webpack_require__(308),
    isIndex = __webpack_require__(384),
    isObject = __webpack_require__(125);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSelectedBuildingId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNewBuildingForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getReadOnly; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getSelectedBuildingId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.buildings.data.selectedBuildingId;},function(selectedBuildingId){return selectedBuildingId;});var getNewBuildingForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.buildings.data.newBuildingForm;},function(newBuildingForm){return newBuildingForm;});var getReadOnly=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.buildings.ui.readOnly;},function(readOnly){return readOnly;});

/***/ }),
/* 844 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports = { prefix: 'far', iconName: 'file-pdf', icon: [384, 512, [], "f1c1", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"] };

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports = { prefix: 'far', iconName: 'file-word', icon: [384, 512, [], "f1c2", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm220.1-208c-5.7 0-10.6 4-11.7 9.5-20.6 97.7-20.4 95.4-21 103.5-.2-1.2-.4-2.6-.7-4.3-.8-5.1.3.2-23.6-99.5-1.3-5.4-6.1-9.2-11.7-9.2h-13.3c-5.5 0-10.3 3.8-11.7 9.1-24.4 99-24 96.2-24.8 103.7-.1-1.1-.2-2.5-.5-4.2-.7-5.2-14.1-73.3-19.1-99-1.1-5.6-6-9.7-11.8-9.7h-16.8c-7.8 0-13.5 7.3-11.7 14.8 8 32.6 26.7 109.5 33.2 136 1.3 5.4 6.1 9.1 11.7 9.1h25.2c5.5 0 10.3-3.7 11.6-9.1l17.9-71.4c1.5-6.2 2.5-12 3-17.3l2.9 17.3c.1.4 12.6 50.5 17.9 71.4 1.3 5.3 6.1 9.1 11.6 9.1h24.7c5.5 0 10.3-3.7 11.6-9.1 20.8-81.9 30.2-119 34.5-136 1.9-7.6-3.8-14.9-11.6-14.9h-15.8z"] };

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports = { prefix: 'far', iconName: 'file-excel', icon: [384, 512, [], "f1c3", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"] };

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports = { prefix: 'far', iconName: 'file-image', icon: [384, 512, [], "f1c5", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm32-48h224V288l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0L176 352l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0L80 352v64zm48-240c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"] };

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Task_css__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Task_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Task_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_dropdown_SearchableDropDownPaginated__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_tasks_util__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_api_contractors_api__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_utils_date_util__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Task=function(_Component){_inherits(Task,_Component);function Task(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Task);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Task.__proto__||Object.getPrototypeOf(Task)).call.apply(_ref,[this].concat(args))),_this),_this.handleContractorSelect=function(option){_this.handleAttributeChange(option,'contractor',option?option.label:null);},_this.handleSubmit=function(event){event.preventDefault();if(_this.isValid()){_this.props.onSubmit();}},_this.isValid=function(){if(_this.props.task.trade===null){alert('Type of task is required');return false;}else if(_this.props.task.subTrade===null){alert('Sub type of task is required');return false;}else if(_this.props.task.completionDate===null){alert('Completion date is required');return false;}return true;},_this.handleAttributeChange=function(value,attribute,label){_this.props.onChange(_this.props.task.id,attribute,value,label);},_this.handleOnEdit=function(event){event.preventDefault();_this.props.onEdit(_this.props.task.id);},_this.handleOnCancel=function(event){event.preventDefault();_this.props.onCancel(_this.props.task.id);},_this.handleCancelOrder=function(event){event.preventDefault();_this.props.onCancelOrder();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Task,[{key:'render',value:function render(){var _this2=this;var subTrades=this.props.subTradesByTradeId[this.props.task.trade]!==undefined?this.props.subTradesByTradeId[this.props.task.trade]:[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'task',id:this.props.task.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-container'},'Task # ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:this.props.task.number,format:'00'}),this.props.readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-gray',type:'button',value:'Edit',onClick:this.handleOnEdit})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* ControlLabel */],sm:3},'Trade'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__["a" /* default */],{options:this.props.trades.map(function(element){return{value:element.id,label:element.label};}),placeholder:'Type of task',readOnly:this.props.readOnly,value:this.props.task.trade,onChange:function onChange(newOption){return _this2.handleAttributeChange(newOption.value,'trade',newOption.label);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* ControlLabel */],sm:3},'Sub trade'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__["a" /* default */],{disabled:subTrades.length===0,options:this.props.subTradesByTradeId[this.props.task.trade]!==undefined?this.props.subTradesByTradeId[this.props.task.trade].map(function(element){return{value:element.id,label:element.label};}):[],placeholder:'Sub type of task',readOnly:this.props.readOnly,value:this.props.task.subTrade,onChange:function onChange(newOption){return _this2.handleAttributeChange(newOption.value,'subTrade',newOption.label);}}))),this.props.isPreTask&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* ControlLabel */],sm:3},'Contractor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_dropdown_SearchableDropDownPaginated__["a" /* default */],{clearable:true,loadOptions:function loadOptions(input,page){return Task.loadContractors(_this2.props.task.trade,input,page);},value:this.props.task.contractor,onChange:this.handleContractorSelect,placeholder:'Select Subcontractor',autoload:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* ControlLabel */],sm:3},'Target Completion Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:__WEBPACK_IMPORTED_MODULE_13_services_utils_date_util__["k" /* todayValidation */],placeholder:'Completion date',readOnly:this.props.readOnly,value:this.props.task.completionDate,onChange:function onChange(value){return _this2.handleAttributeChange(value,'completionDate');}}),Task.showTaskCompletionDateWarning(this.props.task.completionDate)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["a" /* Alert */],{bsStyle:'warning',className:'completion-date-warning'},'Completion date is 5 days or less from request. Please confirm completion date.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],{className:'inline-controls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* ControlLabel */],sm:3},'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__["a" /* default */],{placeholder:'Floor number',readOnly:this.props.readOnly,required:true,value:this.props.task.floorNumber,onChange:function onChange(value){return _this2.handleAttributeChange(value,'floorNumber');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__["a" /* default */],{placeholder:'Room or Name Number',readOnly:this.props.readOnly,required:true,value:this.props.task.room,onChange:function onChange(value){return _this2.handleAttributeChange(value,'room');}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],{className:'inline-controls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* ControlLabel */],sm:3},'Task Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__["a" /* default */],{placeholder:'Task Name',readOnly:this.props.readOnly,required:true,value:this.props.task.name,onChange:function onChange(value){return _this2.handleAttributeChange(value,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:9,smOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_TextArea__["a" /* default */],{placeholder:'Task Description',readOnly:this.props.readOnly,required:true,value:this.props.task.description,onChange:function onChange(value){return _this2.handleAttributeChange(value,'description');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],images:this.props.task.images,max:this.props.minMaxImages.max,notes:'For faster quotes, provide photos - close-up, distant and one other that may help define your request',readOnly:this.props.readOnly,onRemove:this.props.onImageRemove,onUpload:function onUpload(images){return _this2.handleAttributeChange(images,'images');}}),this.props.readOnly&&this.props.task.images.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["a" /* Alert */],{bsStyle:'warning'},'Images missing for this task, please review.'))),!this.props.readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',value:'Save Task',type:'submit'}),this.props.onCancel!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-gray',value:'Cancel Task',type:'button',onClick:this.handleOnCancel}),this.props.onCancelOrder!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-white',value:'Cancel Order',type:'button',onClick:this.handleCancelOrder}))):null));}}],[{key:'loadContractors',value:function loadContractors(tradeId,input,page){return __WEBPACK_IMPORTED_MODULE_12_services_api_contractors_api__["b" /* default */].searchContractors(input,[tradeId],[],null,page).then(function(response){if(response.ok){return{ok:true,options:response.contractors.map(function(element){return{value:element.id,label:element.name};})};}else{return{ok:false,errors:response.errors};}});}},{key:'showTaskCompletionDateWarning',value:function showTaskCompletionDateWarning(completionDate){return completionDate!==null&&!__WEBPACK_IMPORTED_MODULE_11_services_utils_tasks_util__["a" /* default */].validateTaskCompletionDate(completionDate);}}]);return Task;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Task.propTypes={minMaxImages:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,task:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,number:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,completionDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,trade:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,subTrade:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,floorNumber:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,room:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,images:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,file:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({original:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,img:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})})),contractor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),trades:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,subTradesByTradeId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancelOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onImageRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,isPreTask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};Task.defaultProps={readOnly:false,isPreTask:false};/* harmony default export */ __webpack_exports__["a"] = (Task);

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1665);


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(54);


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(118);
var gOPN = __webpack_require__(229).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(59);
var getKeys = __webpack_require__(212);
var gOPS = __webpack_require__(393);
var pIE = __webpack_require__(291);
var toObject = __webpack_require__(71);
var IObject = __webpack_require__(290);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(43)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 854 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(98);
var isObject = __webpack_require__(48);
var invoke = __webpack_require__(856);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 856 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(41).parseInt;
var $trim = __webpack_require__(262).trim;
var ws = __webpack_require__(541);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(41).parseFloat;
var $trim = __webpack_require__(262).trim;

module.exports = 1 / $parseFloat(__webpack_require__(541) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(135);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(48);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 861 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(543);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(98);
var toObject = __webpack_require__(71);
var IObject = __webpack_require__(290);
var toLength = __webpack_require__(55);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(71);
var toAbsoluteIndex = __webpack_require__(213);
var toLength = __webpack_require__(55);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(550);
__webpack_require__(4)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(59) && /./g.flags != 'g') __webpack_require__(70).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(311)
});


/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(32);
var isObject = __webpack_require__(48);
var newPromiseCapability = __webpack_require__(554);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(41);
var each = __webpack_require__(158)(0);
var redefine = __webpack_require__(109);
var meta = __webpack_require__(194);
var assign = __webpack_require__(853);
var weak = __webpack_require__(870);
var isObject = __webpack_require__(48);
var validate = __webpack_require__(218);
var NATIVE_WEAK_MAP = __webpack_require__(218);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(344)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(214);
var getWeak = __webpack_require__(194).getWeak;
var anObject = __webpack_require__(32);
var isObject = __webpack_require__(48);
var anInstance = __webpack_require__(215);
var forOf = __webpack_require__(216);
var createArrayMethod = __webpack_require__(158);
var $has = __webpack_require__(117);
var validate = __webpack_require__(218);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(136);
var toLength = __webpack_require__(55);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(229);
var gOPS = __webpack_require__(393);
var anObject = __webpack_require__(32);
var Reflect = __webpack_require__(41).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(394);
var isObject = __webpack_require__(48);
var toLength = __webpack_require__(55);
var ctx = __webpack_require__(137);
var IS_CONCAT_SPREADABLE = __webpack_require__(54)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(55);
var repeat = __webpack_require__(542);
var defined = __webpack_require__(150);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(59);
var getKeys = __webpack_require__(212);
var toIObject = __webpack_require__(118);
var isEnum = __webpack_require__(291).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(238);
var from = __webpack_require__(877);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(216);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 878 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assign = __webpack_require__(880),
	PropTypes = __webpack_require__(1),
	createClass = __webpack_require__(263),
	moment = __webpack_require__(24),
	React = __webpack_require__(0),
	CalendarContainer = __webpack_require__(1870),
	onClickOutside = __webpack_require__(1875).default
	;

var viewModes = Object.freeze({
	YEARS: 'years',
	MONTHS: 'months',
	DAYS: 'days',
	TIME: 'time',
});

var TYPES = PropTypes;
var Datetime = createClass({
	displayName: 'DateTime',
	propTypes: {
		// value: TYPES.object | TYPES.string,
		// defaultValue: TYPES.object | TYPES.string,
		// viewDate: TYPES.object | TYPES.string,
		onFocus: TYPES.func,
		onBlur: TYPES.func,
		onChange: TYPES.func,
		onViewModeChange: TYPES.func,
		onNavigateBack: TYPES.func,
		onNavigateForward: TYPES.func,
		locale: TYPES.string,
		utc: TYPES.bool,
		displayTimeZone: TYPES.string,
		input: TYPES.bool,
		// dateFormat: TYPES.string | TYPES.bool,
		// timeFormat: TYPES.string | TYPES.bool,
		inputProps: TYPES.object,
		timeConstraints: TYPES.object,
		viewMode: TYPES.oneOf([viewModes.YEARS, viewModes.MONTHS, viewModes.DAYS, viewModes.TIME]),
		isValidDate: TYPES.func,
		open: TYPES.bool,
		strictParsing: TYPES.bool,
		closeOnSelect: TYPES.bool,
		closeOnTab: TYPES.bool
	},

	getInitialState: function() {
		this.checkTZ( this.props );
		
		var state = this.getStateFromProps( this.props );

		if ( state.open === undefined )
			state.open = !this.props.input;

		state.currentView = this.props.dateFormat ?
			(this.props.viewMode || state.updateOn || viewModes.DAYS) : viewModes.TIME;

		return state;
	},

	parseDate: function (date, formats) {
		var parsedDate;

		if (date && typeof date === 'string')
			parsedDate = this.localMoment(date, formats.datetime);
		else if (date)
			parsedDate = this.localMoment(date);

		if (parsedDate && !parsedDate.isValid())
			parsedDate = null;

		return parsedDate;
	},

	getStateFromProps: function( props ) {
		var formats = this.getFormats( props ),
			date = props.value || props.defaultValue,
			selectedDate, viewDate, updateOn, inputValue
			;

		selectedDate = this.parseDate(date, formats);

		viewDate = this.parseDate(props.viewDate, formats);

		viewDate = selectedDate ?
			selectedDate.clone().startOf('month') :
			viewDate ? viewDate.clone().startOf('month') : this.localMoment().startOf('month');

		updateOn = this.getUpdateOn(formats);

		if ( selectedDate )
			inputValue = selectedDate.format(formats.datetime);
		else if ( date.isValid && !date.isValid() )
			inputValue = '';
		else
			inputValue = date || '';

		return {
			updateOn: updateOn,
			inputFormat: formats.datetime,
			viewDate: viewDate,
			selectedDate: selectedDate,
			inputValue: inputValue,
			open: props.open
		};
	},

	getUpdateOn: function( formats ) {
		if ( formats.date.match(/[lLD]/) ) {
			return viewModes.DAYS;
		} else if ( formats.date.indexOf('M') !== -1 ) {
			return viewModes.MONTHS;
		} else if ( formats.date.indexOf('Y') !== -1 ) {
			return viewModes.YEARS;
		}

		return viewModes.DAYS;
	},

	getFormats: function( props ) {
		var formats = {
				date: props.dateFormat || '',
				time: props.timeFormat || ''
			},
			locale = this.localMoment( props.date, null, props ).localeData()
			;

		if ( formats.date === true ) {
			formats.date = locale.longDateFormat('L');
		}
		else if ( this.getUpdateOn(formats) !== viewModes.DAYS ) {
			formats.time = '';
		}

		if ( formats.time === true ) {
			formats.time = locale.longDateFormat('LT');
		}

		formats.datetime = formats.date && formats.time ?
			formats.date + ' ' + formats.time :
			formats.date || formats.time
		;

		return formats;
	},

	componentWillReceiveProps: function( nextProps ) {
		var formats = this.getFormats( nextProps ),
			updatedState = {}
		;

		if ( nextProps.value !== this.props.value ||
			formats.datetime !== this.getFormats( this.props ).datetime ) {
			updatedState = this.getStateFromProps( nextProps );
		}

		if ( updatedState.open === undefined ) {
			if ( typeof nextProps.open !== 'undefined' ) {
				updatedState.open = nextProps.open;
			} else if ( this.props.closeOnSelect && this.state.currentView !== viewModes.TIME ) {
				updatedState.open = false;
			} else {
				updatedState.open = this.state.open;
			}
		}

		if ( nextProps.viewMode !== this.props.viewMode ) {
			updatedState.currentView = nextProps.viewMode;
		}

		if ( nextProps.locale !== this.props.locale ) {
			if ( this.state.viewDate ) {
				var updatedViewDate = this.state.viewDate.clone().locale( nextProps.locale );
				updatedState.viewDate = updatedViewDate;
			}
			if ( this.state.selectedDate ) {
				var updatedSelectedDate = this.state.selectedDate.clone().locale( nextProps.locale );
				updatedState.selectedDate = updatedSelectedDate;
				updatedState.inputValue = updatedSelectedDate.format( formats.datetime );
			}
		}

		if ( nextProps.utc !== this.props.utc || nextProps.displayTimeZone !== this.props.displayTimeZone ) {
			if ( nextProps.utc ) {
				if ( this.state.viewDate )
					updatedState.viewDate = this.state.viewDate.clone().utc();
				if ( this.state.selectedDate ) {
					updatedState.selectedDate = this.state.selectedDate.clone().utc();
					updatedState.inputValue = updatedState.selectedDate.format( formats.datetime );
				}
			} else if ( nextProps.displayTimeZone ) {
				if ( this.state.viewDate )
					updatedState.viewDate = this.state.viewDate.clone().tz(nextProps.displayTimeZone);
				if ( this.state.selectedDate ) {
					updatedState.selectedDate = this.state.selectedDate.clone().tz(nextProps.displayTimeZone);
					updatedState.inputValue = updatedState.selectedDate.tz(nextProps.displayTimeZone).format( formats.datetime );
				}
			} else {
				if ( this.state.viewDate )
					updatedState.viewDate = this.state.viewDate.clone().local();
				if ( this.state.selectedDate ) {
					updatedState.selectedDate = this.state.selectedDate.clone().local();
					updatedState.inputValue = updatedState.selectedDate.format(formats.datetime);
				}
			}
		}

		if ( nextProps.viewDate !== this.props.viewDate ) {
			updatedState.viewDate = moment(nextProps.viewDate);
		}

		this.checkTZ( nextProps );

		this.setState( updatedState );
	},

	onInputChange: function( e ) {
		var value = e.target === null ? e : e.target.value,
			localMoment = this.localMoment( value, this.state.inputFormat ),
			update = { inputValue: value }
			;

		if ( localMoment.isValid() && !this.props.value ) {
			update.selectedDate = localMoment;
			update.viewDate = localMoment.clone().startOf('month');
		} else {
			update.selectedDate = null;
		}

		return this.setState( update, function() {
			return this.props.onChange( localMoment.isValid() ? localMoment : this.state.inputValue );
		});
	},

	onInputKey: function( e ) {
		if ( e.which === 9 && this.props.closeOnTab ) {
			this.closeCalendar();
		}
	},

	showView: function( view ) {
		var me = this;
		return function() {
			me.state.currentView !== view && me.props.onViewModeChange( view );
			me.setState({ currentView: view });
		};
	},

	setDate: function( type ) {
		var me = this,
			nextViews = {
				month: viewModes.DAYS,
				year: viewModes.MONTHS,
			}
		;
		return function( e ) {
			me.setState({
				viewDate: me.state.viewDate.clone()[ type ]( parseInt(e.target.getAttribute('data-value'), 10) ).startOf( type ),
				currentView: nextViews[ type ]
			});
			me.props.onViewModeChange( nextViews[ type ] );
		};
	},

	subtractTime: function( amount, type, toSelected ) {
		var me = this;
		return function() {
			me.props.onNavigateBack( amount, type );
			me.updateTime( 'subtract', amount, type, toSelected );
		};
	},

	addTime: function( amount, type, toSelected ) {
		var me = this;
		return function() {
			me.props.onNavigateForward( amount, type );
			me.updateTime( 'add', amount, type, toSelected );
		};
	},

	updateTime: function( op, amount, type, toSelected ) {
		var update = {},
			date = toSelected ? 'selectedDate' : 'viewDate';

		update[ date ] = this.state[ date ].clone()[ op ]( amount, type );

		this.setState( update );
	},

	allowedSetTime: ['hours', 'minutes', 'seconds', 'milliseconds'],
	setTime: function( type, value ) {
		var index = this.allowedSetTime.indexOf( type ) + 1,
			state = this.state,
			date = (state.selectedDate || state.viewDate).clone(),
			nextType
			;

		// It is needed to set all the time properties
		// to not to reset the time
		date[ type ]( value );
		for (; index < this.allowedSetTime.length; index++) {
			nextType = this.allowedSetTime[index];
			date[ nextType ]( date[nextType]() );
		}

		if ( !this.props.value ) {
			this.setState({
				selectedDate: date,
				inputValue: date.format( state.inputFormat )
			});
		}
		this.props.onChange( date );
	},

	updateSelectedDate: function( e, close ) {
		var target = e.currentTarget,
			modifier = 0,
			viewDate = this.state.viewDate,
			currentDate = this.state.selectedDate || viewDate,
			date
			;

		if (target.className.indexOf('rdtDay') !== -1) {
			if (target.className.indexOf('rdtNew') !== -1)
				modifier = 1;
			else if (target.className.indexOf('rdtOld') !== -1)
				modifier = -1;

			date = viewDate.clone()
				.month( viewDate.month() + modifier )
				.date( parseInt( target.getAttribute('data-value'), 10 ) );
		} else if (target.className.indexOf('rdtMonth') !== -1) {
			date = viewDate.clone()
				.month( parseInt( target.getAttribute('data-value'), 10 ) )
				.date( currentDate.date() );
		} else if (target.className.indexOf('rdtYear') !== -1) {
			date = viewDate.clone()
				.month( currentDate.month() )
				.date( currentDate.date() )
				.year( parseInt( target.getAttribute('data-value'), 10 ) );
		}

		date.hours( currentDate.hours() )
			.minutes( currentDate.minutes() )
			.seconds( currentDate.seconds() )
			.milliseconds( currentDate.milliseconds() );

		if ( !this.props.value ) {
			var open = !( this.props.closeOnSelect && close );
			if ( !open ) {
				this.props.onBlur( date );
			}

			this.setState({
				selectedDate: date,
				viewDate: date.clone().startOf('month'),
				inputValue: date.format( this.state.inputFormat ),
				open: open
			});
		} else {
			if ( this.props.closeOnSelect && close ) {
				this.closeCalendar();
			}
		}

		this.props.onChange( date );
	},

	openCalendar: function( e ) {
		if ( !this.state.open ) {
			this.setState({ open: true }, function() {
				this.props.onFocus( e );
			});
		}
	},

	closeCalendar: function() {
		this.setState({ open: false }, function () {
			this.props.onBlur( this.state.selectedDate || this.state.inputValue );
		});
	},

	handleClickOutside: function() {
		if ( this.props.input && this.state.open && this.props.open === undefined && !this.props.disableCloseOnClickOutside ) {
			this.setState({ open: false }, function() {
				this.props.onBlur( this.state.selectedDate || this.state.inputValue );
			});
		}
	},

	localMoment: function( date, format, props ) {
		props = props || this.props;
		var m = null;

		if (props.utc) {
			m = moment.utc(date, format, props.strictParsing);
		} else if (props.displayTimeZone) {
			m = moment.tz(date, format, props.displayTimeZone);
		} else {
			m = moment(date, format, props.strictParsing);
		}

		if ( props.locale )
			m.locale( props.locale );
		return m;
	},

	checkTZ: function( props ) {
		var con = console;

		if ( props.displayTimeZone && !this.tzWarning && !moment.tz ) {
			this.tzWarning = true;
			con && con.error('react-datetime: displayTimeZone prop with value "' + props.displayTimeZone +  '" is used but moment.js timezone is not loaded.');
		}
	},

	componentProps: {
		fromProps: ['value', 'isValidDate', 'renderDay', 'renderMonth', 'renderYear', 'timeConstraints'],
		fromState: ['viewDate', 'selectedDate', 'updateOn'],
		fromThis: ['setDate', 'setTime', 'showView', 'addTime', 'subtractTime', 'updateSelectedDate', 'localMoment', 'handleClickOutside']
	},

	getComponentProps: function() {
		var me = this,
			formats = this.getFormats( this.props ),
			props = {dateFormat: formats.date, timeFormat: formats.time}
			;

		this.componentProps.fromProps.forEach( function( name ) {
			props[ name ] = me.props[ name ];
		});
		this.componentProps.fromState.forEach( function( name ) {
			props[ name ] = me.state[ name ];
		});
		this.componentProps.fromThis.forEach( function( name ) {
			props[ name ] = me[ name ];
		});

		return props;
	},

	overrideEvent: function( handler, action ) {
		if ( !this.overridenEvents ) {
			this.overridenEvents = {};
		}

		if ( !this.overridenEvents[handler] ) {
			var me = this;
			this.overridenEvents[handler] = function( e ) {
				var result;
				if ( me.props.inputProps && me.props.inputProps[handler] ) {
					result = me.props.inputProps[handler]( e );
				}
				if ( result !== false ) {
					action( e );
				}
			};
		}

		return this.overridenEvents[handler];
	},

	render: function() {
		// TODO: Make a function or clean up this code,
		// logic right now is really hard to follow
		var className = 'rdt' + (this.props.className ?
									( Array.isArray( this.props.className ) ?
									' ' + this.props.className.join( ' ' ) : ' ' + this.props.className) : ''),
			children = [];

		if ( this.props.input ) {
			var finalInputProps = assign(
				{ type: 'text', className: 'form-control', value: this.state.inputValue },
				this.props.inputProps,
				{
					onClick: this.overrideEvent( 'onClick', this.openCalendar ),
					onFocus: this.overrideEvent( 'onFocus', this.openCalendar ),
					onChange: this.overrideEvent( 'onChange', this.onInputChange ),
					onKeyDown: this.overrideEvent( 'onKeyDown', this.onInputKey ),
				}
			);

			if ( this.props.renderInput ) {
				children = [ React.createElement('div', { key: 'i' }, this.props.renderInput( finalInputProps, this.openCalendar, this.closeCalendar )) ];
			} else {
				children = [ React.createElement('input', assign({ key: 'i' }, finalInputProps ))];
			}
		} else {
			className += ' rdtStatic';
		}

		if ( this.props.open || (this.props.open === undefined && this.state.open ) )
			className += ' rdtOpen';

		return React.createElement( ClickableWrapper, {className: className, onClickOut: this.handleClickOutside}, children.concat(
			React.createElement( 'div',
				{ key: 'dt', className: 'rdtPicker' },
				React.createElement( CalendarContainer, { view: this.state.currentView, viewProps: this.getComponentProps() })
			)
		));
	}
});

var ClickableWrapper = onClickOutside( createClass({
	render: function() {
		return React.createElement( 'div', { className: this.props.className }, this.props.children );
	},
	handleClickOutside: function( e ) {
		this.props.onClickOut( e );
	}
}));

Datetime.defaultProps = {
	className: '',
	defaultValue: '',
	inputProps: {},
	input: true,
	onFocus: function() {},
	onBlur: function() {},
	onChange: function() {},
	onViewModeChange: function() {},
	onNavigateBack: function() {},
	onNavigateForward: function() {},
	timeFormat: true,
	timeConstraints: {},
	dateFormat: true,
	strictParsing: true,
	closeOnSelect: false,
	closeOnTab: true,
	utc: false
};

// Make moment accessible through the Datetime class
Datetime.moment = moment;

module.exports = Datetime;


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function ownEnumerableKeys(obj) {
	var keys = Object.getOwnPropertyNames(obj);

	if (Object.getOwnPropertySymbols) {
		keys = keys.concat(Object.getOwnPropertySymbols(obj));
	}

	return keys.filter(function (key) {
		return propIsEnumerable.call(obj, key);
	});
}

module.exports = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = ownEnumerableKeys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(134);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 882 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(1881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);




function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/**
 * Placeholder for future translate functionality
 */
function translate(str) {
  var replaceStrings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!str) {
    return '';
  }

  var translated = str;

  if (replaceStrings) {
    Object.keys(replaceStrings).forEach(function (placeholder) {
      translated = translated.replace(placeholder, replaceStrings[placeholder]);
    });
  }

  return translated;
}
function getWindowWidth() {
  return typeof global.window !== 'undefined' ? global.window.innerWidth : 0;
}
function getWindowHeight() {
  return typeof global.window !== 'undefined' ? global.window.innerHeight : 0;
} // Get the highest window context that isn't cross-origin
// (When in an iframe)

function getHighestSafeWindowContext() {
  var self = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : global.window.self;
  var referrer = self.document.referrer; // If we reached the top level, return self

  if (self === global.window.top || !referrer) {
    return self;
  }

  var getOrigin = function getOrigin(href) {
    return href.match(/(.*\/\/.*?)(\/|$)/)[1];
  }; // If parent is the same origin, we can move up one context
  // Reference: https://stackoverflow.com/a/21965342/1601953


  if (getOrigin(self.location.href) === getOrigin(referrer)) {
    return getHighestSafeWindowContext(self.parent);
  } // If a different origin, we consider the current level
  // as the top reachable one


  return self;
}

// Min image zoom level
var MIN_ZOOM_LEVEL = 0; // Max image zoom level

var MAX_ZOOM_LEVEL = 300; // Size ratio between previous and next zoom levels

var ZOOM_RATIO = 1.007; // How much to increase/decrease the zoom level when the zoom buttons are clicked

var ZOOM_BUTTON_INCREMENT_SIZE = 100; // Used to judge the amount of horizontal scroll needed to initiate a image move

var WHEEL_MOVE_X_THRESHOLD = 200; // Used to judge the amount of vertical scroll needed to initiate a zoom action

var WHEEL_MOVE_Y_THRESHOLD = 1;
var KEYS = {
  ESC: 27,
  LEFT_ARROW: 37,
  RIGHT_ARROW: 39
}; // Actions

var ACTION_NONE = 0;
var ACTION_MOVE = 1;
var ACTION_SWIPE = 2;
var ACTION_PINCH = 3;

var SOURCE_ANY = 0;
var SOURCE_MOUSE = 1;
var SOURCE_TOUCH = 2;
var SOURCE_POINTER = 3; // Minimal swipe distance

var MIN_SWIPE_DISTANCE = 200;

var ReactImageLightbox =
/*#__PURE__*/
function (_Component) {
  _inherits(ReactImageLightbox, _Component);

  _createClass(ReactImageLightbox, null, [{
    key: "isTargetMatchImage",
    value: function isTargetMatchImage(target) {
      return target && /ril-image-current/.test(target.className);
    }
  }, {
    key: "parseMouseEvent",
    value: function parseMouseEvent(mouseEvent) {
      return {
        id: 'mouse',
        source: SOURCE_MOUSE,
        x: parseInt(mouseEvent.clientX, 10),
        y: parseInt(mouseEvent.clientY, 10)
      };
    }
  }, {
    key: "parseTouchPointer",
    value: function parseTouchPointer(touchPointer) {
      return {
        id: touchPointer.identifier,
        source: SOURCE_TOUCH,
        x: parseInt(touchPointer.clientX, 10),
        y: parseInt(touchPointer.clientY, 10)
      };
    }
  }, {
    key: "parsePointerEvent",
    value: function parsePointerEvent(pointerEvent) {
      return {
        id: pointerEvent.pointerId,
        source: SOURCE_POINTER,
        x: parseInt(pointerEvent.clientX, 10),
        y: parseInt(pointerEvent.clientY, 10)
      };
    } // Request to transition to the previous image

  }, {
    key: "getTransform",
    value: function getTransform(_ref) {
      var _ref$x = _ref.x,
          x = _ref$x === void 0 ? 0 : _ref$x,
          _ref$y = _ref.y,
          y = _ref$y === void 0 ? 0 : _ref$y,
          _ref$zoom = _ref.zoom,
          zoom = _ref$zoom === void 0 ? 1 : _ref$zoom,
          width = _ref.width,
          targetWidth = _ref.targetWidth;
      var nextX = x;
      var windowWidth = getWindowWidth();

      if (width > windowWidth) {
        nextX += (windowWidth - width) / 2;
      }

      var scaleFactor = zoom * (targetWidth / width);
      return {
        transform: "translate3d(".concat(nextX, "px,").concat(y, "px,0) scale3d(").concat(scaleFactor, ",").concat(scaleFactor, ",1)")
      };
    }
  }]);

  function ReactImageLightbox(props) {
    var _this;

    _classCallCheck(this, ReactImageLightbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactImageLightbox).call(this, props));
    _this.state = {
      //-----------------------------
      // Animation
      //-----------------------------
      // Lightbox is closing
      // When Lightbox is mounted, if animation is enabled it will open with the reverse of the closing animation
      isClosing: !props.animationDisabled,
      // Component parts should animate (e.g., when images are moving, or image is being zoomed)
      shouldAnimate: false,
      //-----------------------------
      // Zoom settings
      //-----------------------------
      // Zoom level of image
      zoomLevel: MIN_ZOOM_LEVEL,
      //-----------------------------
      // Image position settings
      //-----------------------------
      // Horizontal offset from center
      offsetX: 0,
      // Vertical offset from center
      offsetY: 0,
      // image load error for srcType
      loadErrorStatus: {}
    }; // Refs

    _this.outerEl = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this.zoomInBtn = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this.zoomOutBtn = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this.caption = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this.closeIfClickInner = _this.closeIfClickInner.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleImageDoubleClick = _this.handleImageDoubleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleImageMouseWheel = _this.handleImageMouseWheel.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleKeyInput = _this.handleKeyInput.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleMouseMove = _this.handleMouseMove.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleOuterMousewheel = _this.handleOuterMousewheel.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleTouchStart = _this.handleTouchStart.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleTouchMove = _this.handleTouchMove.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleTouchEnd = _this.handleTouchEnd.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handlePointerEvent = _this.handlePointerEvent.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleCaptionMousewheel = _this.handleCaptionMousewheel.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleWindowResize = _this.handleWindowResize.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleZoomInButtonClick = _this.handleZoomInButtonClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleZoomOutButtonClick = _this.handleZoomOutButtonClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.requestClose = _this.requestClose.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.requestMoveNext = _this.requestMoveNext.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.requestMovePrev = _this.requestMovePrev.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(ReactImageLightbox, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // Timeouts - always clear it before umount
      this.timeouts = []; // Current action

      this.currentAction = ACTION_NONE; // Events source

      this.eventsSource = SOURCE_ANY; // Empty pointers list

      this.pointerList = []; // Prevent inner close

      this.preventInnerClose = false;
      this.preventInnerCloseTimeout = null; // Used to disable animation when changing props.mainSrc|nextSrc|prevSrc

      this.keyPressed = false; // Used to store load state / dimensions of images

      this.imageCache = {}; // Time the last keydown event was called (used in keyboard action rate limiting)

      this.lastKeyDownTime = 0; // Used for debouncing window resize event

      this.resizeTimeout = null; // Used to determine when actions are triggered by the scroll wheel

      this.wheelActionTimeout = null;
      this.resetScrollTimeout = null;
      this.scrollX = 0;
      this.scrollY = 0; // Used in panning zoomed images

      this.moveStartX = 0;
      this.moveStartY = 0;
      this.moveStartOffsetX = 0;
      this.moveStartOffsetY = 0; // Used to swipe

      this.swipeStartX = 0;
      this.swipeStartY = 0;
      this.swipeEndX = 0;
      this.swipeEndY = 0; // Used to pinch

      this.pinchTouchList = null;
      this.pinchDistance = 0; // Used to differentiate between images with identical src

      this.keyCounter = 0; // Used to detect a move when all src's remain unchanged (four or more of the same image in a row)

      this.moveRequested = false;

      if (!this.props.animationDisabled) {
        // Make opening animation play
        this.setState({
          isClosing: false
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Prevents cross-origin errors when using a cross-origin iframe
      this.windowContext = getHighestSafeWindowContext();
      this.listeners = {
        resize: this.handleWindowResize,
        mouseup: this.handleMouseUp,
        touchend: this.handleTouchEnd,
        touchcancel: this.handleTouchEnd,
        pointerdown: this.handlePointerEvent,
        pointermove: this.handlePointerEvent,
        pointerup: this.handlePointerEvent,
        pointercancel: this.handlePointerEvent
      };
      Object.keys(this.listeners).forEach(function (type) {
        _this2.windowContext.addEventListener(type, _this2.listeners[type]);
      });
      this.loadAllImages();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      // Iterate through the source types for prevProps and nextProps to
      //  determine if any of the sources changed
      var sourcesChanged = false;
      var prevSrcDict = {};
      var nextSrcDict = {};
      this.getSrcTypes().forEach(function (srcType) {
        if (_this3.props[srcType.name] !== nextProps[srcType.name]) {
          sourcesChanged = true;
          prevSrcDict[_this3.props[srcType.name]] = true;
          nextSrcDict[nextProps[srcType.name]] = true;
        }
      });

      if (sourcesChanged || this.moveRequested) {
        // Reset the loaded state for images not rendered next
        Object.keys(prevSrcDict).forEach(function (prevSrc) {
          if (!(prevSrc in nextSrcDict) && prevSrc in _this3.imageCache) {
            _this3.imageCache[prevSrc].loaded = false;
          }
        });
        this.moveRequested = false; // Load any new images

        this.loadAllImages(nextProps);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      // Wait for move...
      return !this.moveRequested;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this4 = this;

      this.didUnmount = true;
      Object.keys(this.listeners).forEach(function (type) {
        _this4.windowContext.removeEventListener(type, _this4.listeners[type]);
      });
      this.timeouts.forEach(function (tid) {
        return clearTimeout(tid);
      });
    }
  }, {
    key: "setTimeout",
    value: function (_setTimeout) {
      function setTimeout(_x, _x2) {
        return _setTimeout.apply(this, arguments);
      }

      setTimeout.toString = function () {
        return _setTimeout.toString();
      };

      return setTimeout;
    }(function (func, time) {
      var _this5 = this;

      var id = setTimeout(function () {
        _this5.timeouts = _this5.timeouts.filter(function (tid) {
          return tid !== id;
        });
        func();
      }, time);
      this.timeouts.push(id);
      return id;
    })
  }, {
    key: "setPreventInnerClose",
    value: function setPreventInnerClose() {
      var _this6 = this;

      if (this.preventInnerCloseTimeout) {
        this.clearTimeout(this.preventInnerCloseTimeout);
      }

      this.preventInnerClose = true;
      this.preventInnerCloseTimeout = this.setTimeout(function () {
        _this6.preventInnerClose = false;
        _this6.preventInnerCloseTimeout = null;
      }, 100);
    } // Get info for the best suited image to display with the given srcType

  }, {
    key: "getBestImageForType",
    value: function getBestImageForType(srcType) {
      var imageSrc = this.props[srcType];
      var fitSizes = {};

      if (this.isImageLoaded(imageSrc)) {
        // Use full-size image if available
        fitSizes = this.getFitSizes(this.imageCache[imageSrc].width, this.imageCache[imageSrc].height);
      } else if (this.isImageLoaded(this.props["".concat(srcType, "Thumbnail")])) {
        // Fall back to using thumbnail if the image has not been loaded
        imageSrc = this.props["".concat(srcType, "Thumbnail")];
        fitSizes = this.getFitSizes(this.imageCache[imageSrc].width, this.imageCache[imageSrc].height, true);
      } else {
        return null;
      }

      return {
        src: imageSrc,
        height: this.imageCache[imageSrc].height,
        width: this.imageCache[imageSrc].width,
        targetHeight: fitSizes.height,
        targetWidth: fitSizes.width
      };
    } // Get sizing for when an image is larger than the window

  }, {
    key: "getFitSizes",
    value: function getFitSizes(width, height, stretch) {
      var boxSize = this.getLightboxRect();
      var maxHeight = boxSize.height - this.props.imagePadding * 2;
      var maxWidth = boxSize.width - this.props.imagePadding * 2;

      if (!stretch) {
        maxHeight = Math.min(maxHeight, height);
        maxWidth = Math.min(maxWidth, width);
      }

      var maxRatio = maxWidth / maxHeight;
      var srcRatio = width / height;

      if (maxRatio > srcRatio) {
        // height is the constraining dimension of the photo
        return {
          width: width * maxHeight / height,
          height: maxHeight
        };
      }

      return {
        width: maxWidth,
        height: height * maxWidth / width
      };
    }
  }, {
    key: "getMaxOffsets",
    value: function getMaxOffsets() {
      var zoomLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.zoomLevel;
      var currentImageInfo = this.getBestImageForType('mainSrc');

      if (currentImageInfo === null) {
        return {
          maxX: 0,
          minX: 0,
          maxY: 0,
          minY: 0
        };
      }

      var boxSize = this.getLightboxRect();
      var zoomMultiplier = this.getZoomMultiplier(zoomLevel);
      var maxX = 0;

      if (zoomMultiplier * currentImageInfo.width - boxSize.width < 0) {
        // if there is still blank space in the X dimension, don't limit except to the opposite edge
        maxX = (boxSize.width - zoomMultiplier * currentImageInfo.width) / 2;
      } else {
        maxX = (zoomMultiplier * currentImageInfo.width - boxSize.width) / 2;
      }

      var maxY = 0;

      if (zoomMultiplier * currentImageInfo.height - boxSize.height < 0) {
        // if there is still blank space in the Y dimension, don't limit except to the opposite edge
        maxY = (boxSize.height - zoomMultiplier * currentImageInfo.height) / 2;
      } else {
        maxY = (zoomMultiplier * currentImageInfo.height - boxSize.height) / 2;
      }

      return {
        maxX: maxX,
        maxY: maxY,
        minX: -1 * maxX,
        minY: -1 * maxY
      };
    } // Get image src types

  }, {
    key: "getSrcTypes",
    value: function getSrcTypes() {
      return [{
        name: 'mainSrc',
        keyEnding: "i".concat(this.keyCounter)
      }, {
        name: 'mainSrcThumbnail',
        keyEnding: "t".concat(this.keyCounter)
      }, {
        name: 'nextSrc',
        keyEnding: "i".concat(this.keyCounter + 1)
      }, {
        name: 'nextSrcThumbnail',
        keyEnding: "t".concat(this.keyCounter + 1)
      }, {
        name: 'prevSrc',
        keyEnding: "i".concat(this.keyCounter - 1)
      }, {
        name: 'prevSrcThumbnail',
        keyEnding: "t".concat(this.keyCounter - 1)
      }];
    }
    /**
     * Get sizing when the image is scaled
     */

  }, {
    key: "getZoomMultiplier",
    value: function getZoomMultiplier() {
      var zoomLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.zoomLevel;
      return Math.pow(ZOOM_RATIO, zoomLevel);
    }
    /**
     * Get the size of the lightbox in pixels
     */

  }, {
    key: "getLightboxRect",
    value: function getLightboxRect() {
      if (this.outerEl.current) {
        return this.outerEl.current.getBoundingClientRect();
      }

      return {
        width: getWindowWidth(),
        height: getWindowHeight(),
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      };
    }
  }, {
    key: "clearTimeout",
    value: function (_clearTimeout) {
      function clearTimeout(_x3) {
        return _clearTimeout.apply(this, arguments);
      }

      clearTimeout.toString = function () {
        return _clearTimeout.toString();
      };

      return clearTimeout;
    }(function (id) {
      this.timeouts = this.timeouts.filter(function (tid) {
        return tid !== id;
      });
      clearTimeout(id);
    }) // Change zoom level

  }, {
    key: "changeZoom",
    value: function changeZoom(zoomLevel, clientX, clientY) {
      // Ignore if zoom disabled
      if (!this.props.enableZoom) {
        return;
      } // Constrain zoom level to the set bounds


      var nextZoomLevel = Math.max(MIN_ZOOM_LEVEL, Math.min(MAX_ZOOM_LEVEL, zoomLevel)); // Ignore requests that don't change the zoom level

      if (nextZoomLevel === this.state.zoomLevel) {
        return;
      }

      if (nextZoomLevel === MIN_ZOOM_LEVEL) {
        // Snap back to center if zoomed all the way out
        this.setState({
          zoomLevel: nextZoomLevel,
          offsetX: 0,
          offsetY: 0
        });
        return;
      }

      var imageBaseSize = this.getBestImageForType('mainSrc');

      if (imageBaseSize === null) {
        return;
      }

      var currentZoomMultiplier = this.getZoomMultiplier();
      var nextZoomMultiplier = this.getZoomMultiplier(nextZoomLevel); // Default to the center of the image to zoom when no mouse position specified

      var boxRect = this.getLightboxRect();
      var pointerX = typeof clientX !== 'undefined' ? clientX - boxRect.left : boxRect.width / 2;
      var pointerY = typeof clientY !== 'undefined' ? clientY - boxRect.top : boxRect.height / 2;
      var currentImageOffsetX = (boxRect.width - imageBaseSize.width * currentZoomMultiplier) / 2;
      var currentImageOffsetY = (boxRect.height - imageBaseSize.height * currentZoomMultiplier) / 2;
      var currentImageRealOffsetX = currentImageOffsetX - this.state.offsetX;
      var currentImageRealOffsetY = currentImageOffsetY - this.state.offsetY;
      var currentPointerXRelativeToImage = (pointerX - currentImageRealOffsetX) / currentZoomMultiplier;
      var currentPointerYRelativeToImage = (pointerY - currentImageRealOffsetY) / currentZoomMultiplier;
      var nextImageRealOffsetX = pointerX - currentPointerXRelativeToImage * nextZoomMultiplier;
      var nextImageRealOffsetY = pointerY - currentPointerYRelativeToImage * nextZoomMultiplier;
      var nextImageOffsetX = (boxRect.width - imageBaseSize.width * nextZoomMultiplier) / 2;
      var nextImageOffsetY = (boxRect.height - imageBaseSize.height * nextZoomMultiplier) / 2;
      var nextOffsetX = nextImageOffsetX - nextImageRealOffsetX;
      var nextOffsetY = nextImageOffsetY - nextImageRealOffsetY; // When zooming out, limit the offset so things don't get left askew

      if (this.currentAction !== ACTION_PINCH) {
        var maxOffsets = this.getMaxOffsets();

        if (this.state.zoomLevel > nextZoomLevel) {
          nextOffsetX = Math.max(maxOffsets.minX, Math.min(maxOffsets.maxX, nextOffsetX));
          nextOffsetY = Math.max(maxOffsets.minY, Math.min(maxOffsets.maxY, nextOffsetY));
        }
      }

      this.setState({
        zoomLevel: nextZoomLevel,
        offsetX: nextOffsetX,
        offsetY: nextOffsetY
      });
    }
  }, {
    key: "closeIfClickInner",
    value: function closeIfClickInner(event) {
      if (!this.preventInnerClose && event.target.className.search(/\bril-inner\b/) > -1) {
        this.requestClose(event);
      }
    }
    /**
     * Handle user keyboard actions
     */

  }, {
    key: "handleKeyInput",
    value: function handleKeyInput(event) {
      event.stopPropagation(); // Ignore key input during animations

      if (this.isAnimating()) {
        return;
      } // Allow slightly faster navigation through the images when user presses keys repeatedly


      if (event.type === 'keyup') {
        this.lastKeyDownTime -= this.props.keyRepeatKeyupBonus;
        return;
      }

      var keyCode = event.which || event.keyCode; // Ignore key presses that happen too close to each other (when rapid fire key pressing or holding down the key)
      // But allow it if it's a lightbox closing action

      var currentTime = new Date();

      if (currentTime.getTime() - this.lastKeyDownTime < this.props.keyRepeatLimit && keyCode !== KEYS.ESC) {
        return;
      }

      this.lastKeyDownTime = currentTime.getTime();

      switch (keyCode) {
        // ESC key closes the lightbox
        case KEYS.ESC:
          event.preventDefault();
          this.requestClose(event);
          break;
        // Left arrow key moves to previous image

        case KEYS.LEFT_ARROW:
          if (!this.props.prevSrc) {
            return;
          }

          event.preventDefault();
          this.keyPressed = true;
          this.requestMovePrev(event);
          break;
        // Right arrow key moves to next image

        case KEYS.RIGHT_ARROW:
          if (!this.props.nextSrc) {
            return;
          }

          event.preventDefault();
          this.keyPressed = true;
          this.requestMoveNext(event);
          break;
      }
    }
    /**
     * Handle a mouse wheel event over the lightbox container
     */

  }, {
    key: "handleOuterMousewheel",
    value: function handleOuterMousewheel(event) {
      var _this7 = this;

      // Prevent scrolling of the background
      event.stopPropagation();
      var xThreshold = WHEEL_MOVE_X_THRESHOLD;
      var actionDelay = 0;
      var imageMoveDelay = 500;
      this.clearTimeout(this.resetScrollTimeout);
      this.resetScrollTimeout = this.setTimeout(function () {
        _this7.scrollX = 0;
        _this7.scrollY = 0;
      }, 300); // Prevent rapid-fire zoom behavior

      if (this.wheelActionTimeout !== null || this.isAnimating()) {
        return;
      }

      if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) {
        // handle horizontal scrolls with image moves
        this.scrollY = 0;
        this.scrollX += event.deltaX;
        var bigLeapX = xThreshold / 2; // If the scroll amount has accumulated sufficiently, or a large leap was taken

        if (this.scrollX >= xThreshold || event.deltaX >= bigLeapX) {
          // Scroll right moves to next
          this.requestMoveNext(event);
          actionDelay = imageMoveDelay;
          this.scrollX = 0;
        } else if (this.scrollX <= -1 * xThreshold || event.deltaX <= -1 * bigLeapX) {
          // Scroll left moves to previous
          this.requestMovePrev(event);
          actionDelay = imageMoveDelay;
          this.scrollX = 0;
        }
      } // Allow successive actions after the set delay


      if (actionDelay !== 0) {
        this.wheelActionTimeout = this.setTimeout(function () {
          _this7.wheelActionTimeout = null;
        }, actionDelay);
      }
    }
  }, {
    key: "handleImageMouseWheel",
    value: function handleImageMouseWheel(event) {
      var yThreshold = WHEEL_MOVE_Y_THRESHOLD;

      if (Math.abs(event.deltaY) >= Math.abs(event.deltaX)) {
        event.stopPropagation(); // If the vertical scroll amount was large enough, perform a zoom

        if (Math.abs(event.deltaY) < yThreshold) {
          return;
        }

        this.scrollX = 0;
        this.scrollY += event.deltaY;
        this.changeZoom(this.state.zoomLevel - event.deltaY, event.clientX, event.clientY);
      }
    }
    /**
     * Handle a double click on the current image
     */

  }, {
    key: "handleImageDoubleClick",
    value: function handleImageDoubleClick(event) {
      if (this.state.zoomLevel > MIN_ZOOM_LEVEL) {
        // A double click when zoomed in zooms all the way out
        this.changeZoom(MIN_ZOOM_LEVEL, event.clientX, event.clientY);
      } else {
        // A double click when zoomed all the way out zooms in
        this.changeZoom(this.state.zoomLevel + ZOOM_BUTTON_INCREMENT_SIZE, event.clientX, event.clientY);
      }
    }
  }, {
    key: "shouldHandleEvent",
    value: function shouldHandleEvent(source) {
      if (this.eventsSource === source) {
        return true;
      }

      if (this.eventsSource === SOURCE_ANY) {
        this.eventsSource = source;
        return true;
      }

      switch (source) {
        case SOURCE_MOUSE:
          return false;

        case SOURCE_TOUCH:
          this.eventsSource = SOURCE_TOUCH;
          this.filterPointersBySource();
          return true;

        case SOURCE_POINTER:
          if (this.eventsSource === SOURCE_MOUSE) {
            this.eventsSource = SOURCE_POINTER;
            this.filterPointersBySource();
            return true;
          }

          return false;

        default:
          return false;
      }
    }
  }, {
    key: "addPointer",
    value: function addPointer(pointer) {
      this.pointerList.push(pointer);
    }
  }, {
    key: "removePointer",
    value: function removePointer(pointer) {
      this.pointerList = this.pointerList.filter(function (_ref2) {
        var id = _ref2.id;
        return id !== pointer.id;
      });
    }
  }, {
    key: "filterPointersBySource",
    value: function filterPointersBySource() {
      var _this8 = this;

      this.pointerList = this.pointerList.filter(function (_ref3) {
        var source = _ref3.source;
        return source === _this8.eventsSource;
      });
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      if (this.shouldHandleEvent(SOURCE_MOUSE) && ReactImageLightbox.isTargetMatchImage(event.target)) {
        this.addPointer(ReactImageLightbox.parseMouseEvent(event));
        this.multiPointerStart(event);
      }
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      if (this.shouldHandleEvent(SOURCE_MOUSE)) {
        this.multiPointerMove(event, [ReactImageLightbox.parseMouseEvent(event)]);
      }
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(event) {
      if (this.shouldHandleEvent(SOURCE_MOUSE)) {
        this.removePointer(ReactImageLightbox.parseMouseEvent(event));
        this.multiPointerEnd(event);
      }
    }
  }, {
    key: "handlePointerEvent",
    value: function handlePointerEvent(event) {
      if (this.shouldHandleEvent(SOURCE_POINTER)) {
        switch (event.type) {
          case 'pointerdown':
            if (ReactImageLightbox.isTargetMatchImage(event.target)) {
              this.addPointer(ReactImageLightbox.parsePointerEvent(event));
              this.multiPointerStart(event);
            }

            break;

          case 'pointermove':
            this.multiPointerMove(event, [ReactImageLightbox.parsePointerEvent(event)]);
            break;

          case 'pointerup':
          case 'pointercancel':
            this.removePointer(ReactImageLightbox.parsePointerEvent(event));
            this.multiPointerEnd(event);
            break;
        }
      }
    }
  }, {
    key: "handleTouchStart",
    value: function handleTouchStart(event) {
      var _this9 = this;

      if (this.shouldHandleEvent(SOURCE_TOUCH) && ReactImageLightbox.isTargetMatchImage(event.target)) {
        [].forEach.call(event.changedTouches, function (eventTouch) {
          return _this9.addPointer(ReactImageLightbox.parseTouchPointer(eventTouch));
        });
        this.multiPointerStart(event);
      }
    }
  }, {
    key: "handleTouchMove",
    value: function handleTouchMove(event) {
      if (this.shouldHandleEvent(SOURCE_TOUCH)) {
        this.multiPointerMove(event, [].map.call(event.changedTouches, function (eventTouch) {
          return ReactImageLightbox.parseTouchPointer(eventTouch);
        }));
      }
    }
  }, {
    key: "handleTouchEnd",
    value: function handleTouchEnd(event) {
      var _this10 = this;

      if (this.shouldHandleEvent(SOURCE_TOUCH)) {
        [].map.call(event.changedTouches, function (touch) {
          return _this10.removePointer(ReactImageLightbox.parseTouchPointer(touch));
        });
        this.multiPointerEnd(event);
      }
    }
  }, {
    key: "decideMoveOrSwipe",
    value: function decideMoveOrSwipe(pointer) {
      if (this.state.zoomLevel <= MIN_ZOOM_LEVEL) {
        this.handleSwipeStart(pointer);
      } else {
        this.handleMoveStart(pointer);
      }
    }
  }, {
    key: "multiPointerStart",
    value: function multiPointerStart(event) {
      this.handleEnd(null);

      switch (this.pointerList.length) {
        case 1:
          {
            event.preventDefault();
            this.decideMoveOrSwipe(this.pointerList[0]);
            break;
          }

        case 2:
          {
            event.preventDefault();
            this.handlePinchStart(this.pointerList);
            break;
          }
      }
    }
  }, {
    key: "multiPointerMove",
    value: function multiPointerMove(event, pointerList) {
      switch (this.currentAction) {
        case ACTION_MOVE:
          {
            event.preventDefault();
            this.handleMove(pointerList[0]);
            break;
          }

        case ACTION_SWIPE:
          {
            event.preventDefault();
            this.handleSwipe(pointerList[0]);
            break;
          }

        case ACTION_PINCH:
          {
            event.preventDefault();
            this.handlePinch(pointerList);
            break;
          }
      }
    }
  }, {
    key: "multiPointerEnd",
    value: function multiPointerEnd(event) {
      if (this.currentAction !== ACTION_NONE) {
        this.setPreventInnerClose();
        this.handleEnd(event);
      }

      switch (this.pointerList.length) {
        case 0:
          {
            this.eventsSource = SOURCE_ANY;
            break;
          }

        case 1:
          {
            event.preventDefault();
            this.decideMoveOrSwipe(this.pointerList[0]);
            break;
          }

        case 2:
          {
            event.preventDefault();
            this.handlePinchStart(this.pointerList);
            break;
          }
      }
    }
  }, {
    key: "handleEnd",
    value: function handleEnd(event) {
      switch (this.currentAction) {
        case ACTION_MOVE:
          this.handleMoveEnd(event);
          break;

        case ACTION_SWIPE:
          this.handleSwipeEnd(event);
          break;

        case ACTION_PINCH:
          this.handlePinchEnd(event);
          break;
      }
    } // Handle move start over the lightbox container
    // This happens:
    // - On a mouseDown event
    // - On a touchstart event

  }, {
    key: "handleMoveStart",
    value: function handleMoveStart(_ref4) {
      var clientX = _ref4.x,
          clientY = _ref4.y;

      if (!this.props.enableZoom) {
        return;
      }

      this.currentAction = ACTION_MOVE;
      this.moveStartX = clientX;
      this.moveStartY = clientY;
      this.moveStartOffsetX = this.state.offsetX;
      this.moveStartOffsetY = this.state.offsetY;
    } // Handle dragging over the lightbox container
    // This happens:
    // - After a mouseDown and before a mouseUp event
    // - After a touchstart and before a touchend event

  }, {
    key: "handleMove",
    value: function handleMove(_ref5) {
      var clientX = _ref5.x,
          clientY = _ref5.y;
      var newOffsetX = this.moveStartX - clientX + this.moveStartOffsetX;
      var newOffsetY = this.moveStartY - clientY + this.moveStartOffsetY;

      if (this.state.offsetX !== newOffsetX || this.state.offsetY !== newOffsetY) {
        this.setState({
          offsetX: newOffsetX,
          offsetY: newOffsetY
        });
      }
    }
  }, {
    key: "handleMoveEnd",
    value: function handleMoveEnd() {
      var _this11 = this;

      this.currentAction = ACTION_NONE;
      this.moveStartX = 0;
      this.moveStartY = 0;
      this.moveStartOffsetX = 0;
      this.moveStartOffsetY = 0; // Snap image back into frame if outside max offset range

      var maxOffsets = this.getMaxOffsets();
      var nextOffsetX = Math.max(maxOffsets.minX, Math.min(maxOffsets.maxX, this.state.offsetX));
      var nextOffsetY = Math.max(maxOffsets.minY, Math.min(maxOffsets.maxY, this.state.offsetY));

      if (nextOffsetX !== this.state.offsetX || nextOffsetY !== this.state.offsetY) {
        this.setState({
          offsetX: nextOffsetX,
          offsetY: nextOffsetY,
          shouldAnimate: true
        });
        this.setTimeout(function () {
          _this11.setState({
            shouldAnimate: false
          });
        }, this.props.animationDuration);
      }
    }
  }, {
    key: "handleSwipeStart",
    value: function handleSwipeStart(_ref6) {
      var clientX = _ref6.x,
          clientY = _ref6.y;
      this.currentAction = ACTION_SWIPE;
      this.swipeStartX = clientX;
      this.swipeStartY = clientY;
      this.swipeEndX = clientX;
      this.swipeEndY = clientY;
    }
  }, {
    key: "handleSwipe",
    value: function handleSwipe(_ref7) {
      var clientX = _ref7.x,
          clientY = _ref7.y;
      this.swipeEndX = clientX;
      this.swipeEndY = clientY;
    }
  }, {
    key: "handleSwipeEnd",
    value: function handleSwipeEnd(event) {
      var xDiff = this.swipeEndX - this.swipeStartX;
      var xDiffAbs = Math.abs(xDiff);
      var yDiffAbs = Math.abs(this.swipeEndY - this.swipeStartY);
      this.currentAction = ACTION_NONE;
      this.swipeStartX = 0;
      this.swipeStartY = 0;
      this.swipeEndX = 0;
      this.swipeEndY = 0;

      if (!event || this.isAnimating() || xDiffAbs < yDiffAbs * 1.5) {
        return;
      }

      if (xDiffAbs < MIN_SWIPE_DISTANCE) {
        var boxRect = this.getLightboxRect();

        if (xDiffAbs < boxRect.width / 4) {
          return;
        }
      }

      if (xDiff > 0 && this.props.prevSrc) {
        event.preventDefault();
        this.requestMovePrev();
      } else if (xDiff < 0 && this.props.nextSrc) {
        event.preventDefault();
        this.requestMoveNext();
      }
    }
  }, {
    key: "calculatePinchDistance",
    value: function calculatePinchDistance() {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pinchTouchList,
          _ref9 = _slicedToArray(_ref8, 2),
          a = _ref9[0],
          b = _ref9[1];

      return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
    }
  }, {
    key: "calculatePinchCenter",
    value: function calculatePinchCenter() {
      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pinchTouchList,
          _ref11 = _slicedToArray(_ref10, 2),
          a = _ref11[0],
          b = _ref11[1];

      return {
        x: a.x - (a.x - b.x) / 2,
        y: a.y - (a.y - b.y) / 2
      };
    }
  }, {
    key: "handlePinchStart",
    value: function handlePinchStart(pointerList) {
      if (!this.props.enableZoom) {
        return;
      }

      this.currentAction = ACTION_PINCH;
      this.pinchTouchList = pointerList.map(function (_ref12) {
        var id = _ref12.id,
            x = _ref12.x,
            y = _ref12.y;
        return {
          id: id,
          x: x,
          y: y
        };
      });
      this.pinchDistance = this.calculatePinchDistance();
    }
  }, {
    key: "handlePinch",
    value: function handlePinch(pointerList) {
      this.pinchTouchList = this.pinchTouchList.map(function (oldPointer) {
        for (var i = 0; i < pointerList.length; i += 1) {
          if (pointerList[i].id === oldPointer.id) {
            return pointerList[i];
          }
        }

        return oldPointer;
      });
      var newDistance = this.calculatePinchDistance();
      var zoomLevel = this.state.zoomLevel + newDistance - this.pinchDistance;
      this.pinchDistance = newDistance;

      var _this$calculatePinchC = this.calculatePinchCenter(this.pinchTouchList),
          clientX = _this$calculatePinchC.x,
          clientY = _this$calculatePinchC.y;

      this.changeZoom(zoomLevel, clientX, clientY);
    }
  }, {
    key: "handlePinchEnd",
    value: function handlePinchEnd() {
      this.currentAction = ACTION_NONE;
      this.pinchTouchList = null;
      this.pinchDistance = 0;
    } // Handle the window resize event

  }, {
    key: "handleWindowResize",
    value: function handleWindowResize() {
      this.clearTimeout(this.resizeTimeout);
      this.resizeTimeout = this.setTimeout(this.forceUpdate.bind(this), 100);
    }
  }, {
    key: "handleZoomInButtonClick",
    value: function handleZoomInButtonClick() {
      var nextZoomLevel = this.state.zoomLevel + ZOOM_BUTTON_INCREMENT_SIZE;
      this.changeZoom(nextZoomLevel);

      if (nextZoomLevel === MAX_ZOOM_LEVEL) {
        this.zoomOutBtn.current.focus();
      }
    }
  }, {
    key: "handleZoomOutButtonClick",
    value: function handleZoomOutButtonClick() {
      var nextZoomLevel = this.state.zoomLevel - ZOOM_BUTTON_INCREMENT_SIZE;
      this.changeZoom(nextZoomLevel);

      if (nextZoomLevel === MIN_ZOOM_LEVEL) {
        this.zoomInBtn.current.focus();
      }
    }
  }, {
    key: "handleCaptionMousewheel",
    value: function handleCaptionMousewheel(event) {
      event.stopPropagation();

      if (!this.caption.current) {
        return;
      }

      var _this$caption$current = this.caption.current.getBoundingClientRect(),
          height = _this$caption$current.height;

      var _this$caption$current2 = this.caption.current,
          scrollHeight = _this$caption$current2.scrollHeight,
          scrollTop = _this$caption$current2.scrollTop;

      if (event.deltaY > 0 && height + scrollTop >= scrollHeight || event.deltaY < 0 && scrollTop <= 0) {
        event.preventDefault();
      }
    } // Detach key and mouse input events

  }, {
    key: "isAnimating",
    value: function isAnimating() {
      return this.state.shouldAnimate || this.state.isClosing;
    } // Check if image is loaded

  }, {
    key: "isImageLoaded",
    value: function isImageLoaded(imageSrc) {
      return imageSrc && imageSrc in this.imageCache && this.imageCache[imageSrc].loaded;
    } // Load image from src and call callback with image width and height on load

  }, {
    key: "loadImage",
    value: function loadImage(srcType, imageSrc, done) {
      var _this12 = this;

      // Return the image info if it is already cached
      if (this.isImageLoaded(imageSrc)) {
        this.setTimeout(function () {
          done();
        }, 1);
        return;
      }

      var inMemoryImage = new global.Image();

      if (this.props.imageCrossOrigin) {
        inMemoryImage.crossOrigin = this.props.imageCrossOrigin;
      }

      inMemoryImage.onerror = function (errorEvent) {
        _this12.props.onImageLoadError(imageSrc, srcType, errorEvent); // failed to load so set the state loadErrorStatus


        _this12.setState(function (prevState) {
          return {
            loadErrorStatus: _objectSpread({}, prevState.loadErrorStatus, _defineProperty({}, srcType, true))
          };
        });

        done(errorEvent);
      };

      inMemoryImage.onload = function () {
        _this12.props.onImageLoad(imageSrc, srcType, inMemoryImage);

        _this12.imageCache[imageSrc] = {
          loaded: true,
          width: inMemoryImage.width,
          height: inMemoryImage.height
        };
        done();
      };

      inMemoryImage.src = imageSrc;
    } // Load all images and their thumbnails

  }, {
    key: "loadAllImages",
    value: function loadAllImages() {
      var _this13 = this;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      var generateLoadDoneCallback = function generateLoadDoneCallback(srcType, imageSrc) {
        return function (err) {
          // Give up showing image on error
          if (err) {
            return;
          } // Don't rerender if the src is not the same as when the load started
          // or if the component has unmounted


          if (_this13.props[srcType] !== imageSrc || _this13.didUnmount) {
            return;
          } // Force rerender with the new image


          _this13.forceUpdate();
        };
      }; // Load the images


      this.getSrcTypes().forEach(function (srcType) {
        var type = srcType.name; // there is no error when we try to load it initially

        if (props[type] && _this13.state.loadErrorStatus[type]) {
          _this13.setState(function (prevState) {
            return {
              loadErrorStatus: _objectSpread({}, prevState.loadErrorStatus, _defineProperty({}, type, false))
            };
          });
        } // Load unloaded images


        if (props[type] && !_this13.isImageLoaded(props[type])) {
          _this13.loadImage(type, props[type], generateLoadDoneCallback(type, props[type]));
        }
      });
    } // Request that the lightbox be closed

  }, {
    key: "requestClose",
    value: function requestClose(event) {
      var _this14 = this;

      // Call the parent close request
      var closeLightbox = function closeLightbox() {
        return _this14.props.onCloseRequest(event);
      };

      if (this.props.animationDisabled || event.type === 'keydown' && !this.props.animationOnKeyInput) {
        // No animation
        closeLightbox();
        return;
      } // With animation
      // Start closing animation


      this.setState({
        isClosing: true
      }); // Perform the actual closing at the end of the animation

      this.setTimeout(closeLightbox, this.props.animationDuration);
    }
  }, {
    key: "requestMove",
    value: function requestMove(direction, event) {
      var _this15 = this;

      // Reset the zoom level on image move
      var nextState = {
        zoomLevel: MIN_ZOOM_LEVEL,
        offsetX: 0,
        offsetY: 0
      }; // Enable animated states

      if (!this.props.animationDisabled && (!this.keyPressed || this.props.animationOnKeyInput)) {
        nextState.shouldAnimate = true;
        this.setTimeout(function () {
          return _this15.setState({
            shouldAnimate: false
          });
        }, this.props.animationDuration);
      }

      this.keyPressed = false;
      this.moveRequested = true;

      if (direction === 'prev') {
        this.keyCounter -= 1;
        this.setState(nextState);
        this.props.onMovePrevRequest(event);
      } else {
        this.keyCounter += 1;
        this.setState(nextState);
        this.props.onMoveNextRequest(event);
      }
    } // Request to transition to the next image

  }, {
    key: "requestMoveNext",
    value: function requestMoveNext(event) {
      this.requestMove('next', event);
    } // Request to transition to the previous image

  }, {
    key: "requestMovePrev",
    value: function requestMovePrev(event) {
      this.requestMove('prev', event);
    }
  }, {
    key: "render",
    value: function render() {
      var _this16 = this;

      var _this$props = this.props,
          animationDisabled = _this$props.animationDisabled,
          animationDuration = _this$props.animationDuration,
          clickOutsideToClose = _this$props.clickOutsideToClose,
          discourageDownloads = _this$props.discourageDownloads,
          enableZoom = _this$props.enableZoom,
          imageTitle = _this$props.imageTitle,
          nextSrc = _this$props.nextSrc,
          prevSrc = _this$props.prevSrc,
          toolbarButtons = _this$props.toolbarButtons,
          reactModalStyle = _this$props.reactModalStyle,
          _onAfterOpen = _this$props.onAfterOpen,
          imageCrossOrigin = _this$props.imageCrossOrigin,
          reactModalProps = _this$props.reactModalProps;
      var _this$state = this.state,
          zoomLevel = _this$state.zoomLevel,
          offsetX = _this$state.offsetX,
          offsetY = _this$state.offsetY,
          isClosing = _this$state.isClosing,
          loadErrorStatus = _this$state.loadErrorStatus;
      var boxSize = this.getLightboxRect();
      var transitionStyle = {}; // Transition settings for sliding animations

      if (!animationDisabled && this.isAnimating()) {
        transitionStyle = _objectSpread({}, transitionStyle, {
          transition: "transform ".concat(animationDuration, "ms")
        });
      } // Key endings to differentiate between images with the same src


      var keyEndings = {};
      this.getSrcTypes().forEach(function (_ref13) {
        var name = _ref13.name,
            keyEnding = _ref13.keyEnding;
        keyEndings[name] = keyEnding;
      }); // Images to be displayed

      var images = [];

      var addImage = function addImage(srcType, imageClass, transforms) {
        // Ignore types that have no source defined for their full size image
        if (!_this16.props[srcType]) {
          return;
        }

        var bestImageInfo = _this16.getBestImageForType(srcType);

        var imageStyle = _objectSpread({}, transitionStyle, ReactImageLightbox.getTransform(_objectSpread({}, transforms, bestImageInfo)));

        if (zoomLevel > MIN_ZOOM_LEVEL) {
          imageStyle.cursor = 'move';
        } // support IE 9 and 11


        var hasTrueValue = function hasTrueValue(object) {
          return Object.keys(object).some(function (key) {
            return object[key];
          });
        }; // when error on one of the loads then push custom error stuff


        if (bestImageInfo === null && hasTrueValue(loadErrorStatus)) {
          images.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "".concat(imageClass, " ril__image ril-errored"),
            style: imageStyle,
            key: _this16.props[srcType] + keyEndings[srcType]
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "ril__errorContainer"
          }, _this16.props.imageLoadErrorMessage)));
          return;
        }

        if (bestImageInfo === null) {
          var loadingIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "ril-loading-circle ril__loadingCircle ril__loadingContainer__icon"
          }, _toConsumableArray(new Array(12)).map(function (_, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
              // eslint-disable-next-line react/no-array-index-key
              key: index,
              className: "ril-loading-circle-point ril__loadingCirclePoint"
            });
          })); // Fall back to loading icon if the thumbnail has not been loaded

          images.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "".concat(imageClass, " ril__image ril-not-loaded"),
            style: imageStyle,
            key: _this16.props[srcType] + keyEndings[srcType]
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "ril__loadingContainer"
          }, loadingIcon)));
          return;
        }

        var imageSrc = bestImageInfo.src;

        if (discourageDownloads) {
          imageStyle.backgroundImage = "url('".concat(imageSrc, "')");
          images.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "".concat(imageClass, " ril__image ril__imageDiscourager"),
            onDoubleClick: _this16.handleImageDoubleClick,
            onWheel: _this16.handleImageMouseWheel,
            style: imageStyle,
            key: imageSrc + keyEndings[srcType]
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "ril-download-blocker ril__downloadBlocker"
          })));
        } else {
          images.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", _extends({}, imageCrossOrigin ? {
            crossOrigin: imageCrossOrigin
          } : {}, {
            className: "".concat(imageClass, " ril__image"),
            onDoubleClick: _this16.handleImageDoubleClick,
            onWheel: _this16.handleImageMouseWheel,
            onDragStart: function onDragStart(e) {
              return e.preventDefault();
            },
            style: imageStyle,
            src: imageSrc,
            key: imageSrc + keyEndings[srcType],
            alt: typeof imageTitle === 'string' ? imageTitle : translate('Image'),
            draggable: false
          })));
        }
      };

      var zoomMultiplier = this.getZoomMultiplier(); // Next Image (displayed on the right)

      addImage('nextSrc', 'ril-image-next ril__imageNext', {
        x: boxSize.width
      }); // Main Image

      addImage('mainSrc', 'ril-image-current', {
        x: -1 * offsetX,
        y: -1 * offsetY,
        zoom: zoomMultiplier
      }); // Previous Image (displayed on the left)

      addImage('prevSrc', 'ril-image-prev ril__imagePrev', {
        x: -1 * boxSize.width
      });
      var modalStyle = {
        overlay: _objectSpread({
          zIndex: 1000,
          backgroundColor: 'transparent'
        }, reactModalStyle.overlay),
        content: _objectSpread({
          backgroundColor: 'transparent',
          overflow: 'hidden',
          // Needed, otherwise keyboard shortcuts scroll the page
          border: 'none',
          borderRadius: 0,
          padding: 0,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        }, reactModalStyle.content)
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a, _extends({
        isOpen: true,
        onRequestClose: clickOutsideToClose ? this.requestClose : undefined,
        onAfterOpen: function onAfterOpen() {
          // Focus on the div with key handlers
          if (_this16.outerEl.current) {
            _this16.outerEl.current.focus();
          }

          _onAfterOpen();
        },
        style: modalStyle,
        contentLabel: translate('Lightbox'),
        appElement: typeof global.window !== 'undefined' ? global.window.document.body : undefined
      }, reactModalProps), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        // eslint-disable-line jsx-a11y/no-static-element-interactions
        // Floating modal with closing animations
        className: "ril-outer ril__outer ril__outerAnimating ".concat(this.props.wrapperClassName, " ").concat(isClosing ? 'ril-closing ril__outerClosing' : ''),
        style: {
          transition: "opacity ".concat(animationDuration, "ms"),
          animationDuration: "".concat(animationDuration, "ms"),
          animationDirection: isClosing ? 'normal' : 'reverse'
        },
        ref: this.outerEl,
        onWheel: this.handleOuterMousewheel,
        onMouseMove: this.handleMouseMove,
        onMouseDown: this.handleMouseDown,
        onTouchStart: this.handleTouchStart,
        onTouchMove: this.handleTouchMove,
        tabIndex: "-1" // Enables key handlers on div
        ,
        onKeyDown: this.handleKeyInput,
        onKeyUp: this.handleKeyInput
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        // eslint-disable-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        // Image holder
        className: "ril-inner ril__inner",
        onClick: clickOutsideToClose ? this.closeIfClickInner : undefined
      }, images), prevSrc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        // Move to previous image button
        type: "button",
        className: "ril-prev-button ril__navButtons ril__navButtonPrev",
        key: "prev",
        "aria-label": this.props.prevLabel,
        onClick: !this.isAnimating() ? this.requestMovePrev : undefined // Ignore clicks during animation

      }), nextSrc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        // Move to next image button
        type: "button",
        className: "ril-next-button ril__navButtons ril__navButtonNext",
        key: "next",
        "aria-label": this.props.nextLabel,
        onClick: !this.isAnimating() ? this.requestMoveNext : undefined // Ignore clicks during animation

      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        // Lightbox toolbar
        className: "ril-toolbar ril__toolbar"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "ril-toolbar-left ril__toolbarSide ril__toolbarLeftSide"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "ril-toolbar__item ril__toolbarItem"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "ril-toolbar__item__child ril__toolbarItemChild"
      }, imageTitle))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "ril-toolbar-right ril__toolbarSide ril__toolbarRightSide"
      }, toolbarButtons && toolbarButtons.map(function (button, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          key: "button_".concat(i + 1),
          className: "ril-toolbar__item ril__toolbarItem"
        }, button);
      }), enableZoom && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "ril-toolbar__item ril__toolbarItem"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        // Lightbox zoom in button
        type: "button",
        key: "zoom-in",
        "aria-label": this.props.zoomInLabel,
        className: ['ril-zoom-in', 'ril__toolbarItemChild', 'ril__builtinButton', 'ril__zoomInButton'].concat(_toConsumableArray(zoomLevel === MAX_ZOOM_LEVEL ? ['ril__builtinButtonDisabled'] : [])).join(' '),
        ref: this.zoomInBtn,
        disabled: this.isAnimating() || zoomLevel === MAX_ZOOM_LEVEL,
        onClick: !this.isAnimating() && zoomLevel !== MAX_ZOOM_LEVEL ? this.handleZoomInButtonClick : undefined
      })), enableZoom && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "ril-toolbar__item ril__toolbarItem"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        // Lightbox zoom out button
        type: "button",
        key: "zoom-out",
        "aria-label": this.props.zoomOutLabel,
        className: ['ril-zoom-out', 'ril__toolbarItemChild', 'ril__builtinButton', 'ril__zoomOutButton'].concat(_toConsumableArray(zoomLevel === MIN_ZOOM_LEVEL ? ['ril__builtinButtonDisabled'] : [])).join(' '),
        ref: this.zoomOutBtn,
        disabled: this.isAnimating() || zoomLevel === MIN_ZOOM_LEVEL,
        onClick: !this.isAnimating() && zoomLevel !== MIN_ZOOM_LEVEL ? this.handleZoomOutButtonClick : undefined
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "ril-toolbar__item ril__toolbarItem"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        // Lightbox close button
        type: "button",
        key: "close",
        "aria-label": this.props.closeLabel,
        className: "ril-close ril-toolbar__item__child ril__toolbarItemChild ril__builtinButton ril__closeButton",
        onClick: !this.isAnimating() ? this.requestClose : undefined // Ignore clicks during animation

      })))), this.props.imageCaption && // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        // Image caption
        onWheel: this.handleCaptionMousewheel,
        onMouseDown: function onMouseDown(event) {
          return event.stopPropagation();
        },
        className: "ril-caption ril__caption",
        ref: this.caption
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "ril-caption-content ril__captionContent"
      }, this.props.imageCaption))));
    }
  }]);

  return ReactImageLightbox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ReactImageLightbox.propTypes = {
  //-----------------------------
  // Image sources
  //-----------------------------
  // Main display image url
  mainSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  // eslint-disable-line react/no-unused-prop-types
  // Previous display image url (displayed to the left)
  // If left undefined, movePrev actions will not be performed, and the button not displayed
  prevSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // Next display image url (displayed to the right)
  // If left undefined, moveNext actions will not be performed, and the button not displayed
  nextSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  //-----------------------------
  // Image thumbnail sources
  //-----------------------------
  // Thumbnail image url corresponding to props.mainSrc
  mainSrcThumbnail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // eslint-disable-line react/no-unused-prop-types
  // Thumbnail image url corresponding to props.prevSrc
  prevSrcThumbnail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // eslint-disable-line react/no-unused-prop-types
  // Thumbnail image url corresponding to props.nextSrc
  nextSrcThumbnail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // eslint-disable-line react/no-unused-prop-types
  //-----------------------------
  // Event Handlers
  //-----------------------------
  // Close window event
  // Should change the parent state such that the lightbox is not rendered
  onCloseRequest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // Move to previous image event
  // Should change the parent state such that props.prevSrc becomes props.mainSrc,
  //  props.mainSrc becomes props.nextSrc, etc.
  onMovePrevRequest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // Move to next image event
  // Should change the parent state such that props.nextSrc becomes props.mainSrc,
  //  props.mainSrc becomes props.prevSrc, etc.
  onMoveNextRequest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // Called when an image fails to load
  // (imageSrc: string, srcType: string, errorEvent: object): void
  onImageLoadError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // Called when image successfully loads
  onImageLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // Open window event
  onAfterOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  //-----------------------------
  // Download discouragement settings
  //-----------------------------
  // Enable download discouragement (prevents [right-click -> Save Image As...])
  discourageDownloads: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  //-----------------------------
  // Animation settings
  //-----------------------------
  // Disable all animation
  animationDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // Disable animation on actions performed with keyboard shortcuts
  animationOnKeyInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // Animation duration (ms)
  animationDuration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  //-----------------------------
  // Keyboard shortcut settings
  //-----------------------------
  // Required interval of time (ms) between key actions
  // (prevents excessively fast navigation of images)
  keyRepeatLimit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // Amount of time (ms) restored after each keyup
  // (makes rapid key presses slightly faster than holding down the key to navigate images)
  keyRepeatKeyupBonus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  //-----------------------------
  // Image info
  //-----------------------------
  // Image title
  imageTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  // Image caption
  imageCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  // Optional crossOrigin attribute
  imageCrossOrigin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  //-----------------------------
  // Lightbox style
  //-----------------------------
  // Set z-index style, etc., for the parent react-modal (format: https://github.com/reactjs/react-modal#styles )
  reactModalStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  // Padding (px) between the edge of the window and the lightbox
  imagePadding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  wrapperClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  //-----------------------------
  // Other
  //-----------------------------
  // Array of custom toolbar buttons
  toolbarButtons: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  // When true, clicks outside of the image close the lightbox
  clickOutsideToClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // Set to false to disable zoom functionality and hide zoom buttons
  enableZoom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // Override props set on react-modal (https://github.com/reactjs/react-modal)
  reactModalProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  // Aria-labels
  nextLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prevLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  zoomInLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  zoomOutLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  imageLoadErrorMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
ReactImageLightbox.defaultProps = {
  imageTitle: null,
  imageCaption: null,
  toolbarButtons: null,
  reactModalProps: {},
  animationDisabled: false,
  animationDuration: 300,
  animationOnKeyInput: false,
  clickOutsideToClose: true,
  closeLabel: 'Close lightbox',
  discourageDownloads: false,
  enableZoom: true,
  imagePadding: 10,
  imageCrossOrigin: null,
  keyRepeatKeyupBonus: 40,
  keyRepeatLimit: 180,
  mainSrcThumbnail: null,
  nextLabel: 'Next image',
  nextSrc: null,
  nextSrcThumbnail: null,
  onAfterOpen: function onAfterOpen() {},
  onImageLoadError: function onImageLoadError() {},
  onImageLoad: function onImageLoad() {},
  onMoveNextRequest: function onMoveNextRequest() {},
  onMovePrevRequest: function onMovePrevRequest() {},
  prevLabel: 'Previous image',
  prevSrc: null,
  prevSrcThumbnail: null,
  reactModalStyle: {},
  wrapperClassName: '',
  zoomInLabel: 'Zoom in',
  zoomOutLabel: 'Zoom out',
  imageLoadErrorMessage: 'This image failed to load'
};

/* harmony default export */ __webpack_exports__["a"] = (ReactImageLightbox);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(97)))

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(1886);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(557);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (false) {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Cannot register modal instance that's already open");
      }
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (false) {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
      }
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

exports.default = portalOpenInstances;
module.exports = exports["default"];

/***/ }),
/* 887 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createEmptyTask;
/* harmony export (immutable) */ __webpack_exports__["b"] = tasksDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_utils_text_util__ = __webpack_require__(29);
var initialState={currentTask:createEmptyTask([]),editTaskId:0,// If 0, a new task is being edited, if -1 no task is under edition, otherwise contains a task id under edition
companyName:''};function createEmptyTask(tasks){var number=1;if(tasks!==undefined&&tasks.length>0){number=tasks[tasks.length-1].number+1;}return{id:0,number:number,completionDate:null,trade:0,subTrade:0,tradeLabel:'',floorNumber:'',room:'',name:'',description:'',images:[]};}function tasksDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var newTask=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["E" /* WORK_ORDERS_CREATION_TASKS_STATE_INIT */]:return Object.assign({},state,{currentTask:action.payload.currentTask,editTaskId:action.payload.editTaskId,companyName:action.payload.companyName});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["K" /* WORK_ORDERS_CREATION_TASKS_TASK_CHANGE_VALUE */]:newTask=Object.assign({},state.currentTask);if(action.payload.attribute==='images'){newTask['images']=newTask['images'].concat(action.payload.value);}else{newTask[action.payload.attribute]=action.payload.value;}// If trades are updated, removeUser value for subTrade
if(action.payload.attribute==='trade'){newTask['tradeLabel']=action.payload.label;newTask['subTrade']=0;}if(action.payload.attribute==='trade'&&newTask['tradeLabel']!==''){newTask['name']=Object(__WEBPACK_IMPORTED_MODULE_1_services_utils_text_util__["a" /* buildTaskName */])(newTask['tradeLabel']);}return Object.assign({},state,{currentTask:newTask});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["N" /* WORK_ORDERS_CREATION_TASKS_TASK_SAVE_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_179" /* WORK_ORDERS_TASK_UPDATE_SUCCESS */]:return Object.assign({},state,{editTaskId:-1});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["F" /* WORK_ORDERS_CREATION_TASKS_TASK_ADD_EMPTY_NEW */]:return Object.assign({},state,{currentTask:createEmptyTask(action.payload),editTaskId:0});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["L" /* WORK_ORDERS_CREATION_TASKS_TASK_EDIT */]:return Object.assign({},state,{currentTask:action.payload.task,editTaskId:action.payload.taskId});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["H" /* WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_NEW */]:case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["J" /* WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_SUCCESS */]:return Object.assign({},state,{editTaskId:-1});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["M" /* WORK_ORDERS_CREATION_TASKS_TASK_IMAGE_REMOVE_SUCCESS */]:return Object.assign({},state,{currentTask:Object.assign({},state.currentTask,{images:state.currentTask.images.filter(function(element,index){return index!==action.payload;})})});default:return state;}}

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function insertRule(e){try{return sheet.insertRule(e,sheet.cssRules.length)}catch(e){console.warn("react-reveal - animation failed")}}function cascade(e,n,t,o,r){var s=Math.log(o),i=Math.log(r),a=(i-s)/(t-n);return Math.exp(s+a*(e-n))}function animation(e){if(!sheet)return"";var n="@keyframes "+(name+counter)+"{"+e+"}",t=effectMap[e];return t?""+name+t:(sheet.insertRule(n,sheet.cssRules.length),effectMap[e]=counter,""+name+counter++)}function hideAll(){globalHide||(exports.globalHide=globalHide=!0,window.removeEventListener("scroll",hideAll,!0),insertRule("."+namespace+" { opacity: 0; }"),window.removeEventListener("orientationchange",hideAll,!0),window.document.removeEventListener("visibilitychange",hideAll))}function config(e){var n=e.ssrFadeout;exports.fadeOutEnabled=fadeOutEnabled=n}Object.defineProperty(exports,"__esModule",{value:!0}),exports.insertRule=insertRule,exports.cascade=cascade,exports.animation=animation,exports.hideAll=hideAll,exports.default=config;var namespace=exports.namespace="react-reveal",defaults=exports.defaults={duration:1e3,delay:0,count:1},ssr=exports.ssr=!0,observerMode=exports.observerMode=!1,raf=exports.raf=function(e){return window.setTimeout(e,66)},disableSsr=exports.disableSsr=function(){return exports.ssr=ssr=!1},fadeOutEnabled=exports.fadeOutEnabled=!1,ssrFadeout=exports.ssrFadeout=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return exports.fadeOutEnabled=fadeOutEnabled=e},globalHide=exports.globalHide=!1,ie10=exports.ie10=!1,collapseend=exports.collapseend=void 0,counter=1,effectMap={},sheet=!1,name=namespace+"-"+Math.floor(1e15*Math.random())+"-";if("undefined"!=typeof window&&"nodejs"!==window.name&&window.document&&"undefined"!=typeof navigator){exports.observerMode=observerMode="IntersectionObserver"in window&&"IntersectionObserverEntry"in window&&"intersectionRatio"in window.IntersectionObserverEntry.prototype&&/\{\s*\[native code\]\s*\}/.test(""+IntersectionObserver),exports.raf=raf=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||raf,exports.ssr=ssr=window.document.querySelectorAll("div[data-reactroot]").length>0,-1!==navigator.appVersion.indexOf("MSIE 10")&&(exports.ie10=ie10=!0),ssr&&"performance"in window&&"timing"in window.performance&&"domContentLoadedEventEnd"in window.performance.timing&&window.performance.timing.domLoading&&Date.now()-window.performance.timing.domLoading<300&&(exports.ssr=ssr=!1),ssr&&window.setTimeout(disableSsr,1500),observerMode||(exports.collapseend=collapseend=document.createEvent("Event"),collapseend.initEvent("collapseend",!0,!0));var element=document.createElement("style");document.head.appendChild(element),element.sheet&&element.sheet.cssRules&&element.sheet.insertRule&&(sheet=element.sheet,window.addEventListener("scroll",hideAll,!0),window.addEventListener("orientationchange",hideAll,!0),window.document.addEventListener("visibilitychange",hideAll))}

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsFilesContainer_css__ = __webpack_require__(1906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsFilesContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DetailsFilesContainer_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsFilesContainer=function(_Component){_inherits(DetailsFilesContainer,_Component);function DetailsFilesContainer(){_classCallCheck(this,DetailsFilesContainer);return _possibleConstructorReturn(this,(DetailsFilesContainer.__proto__||Object.getPrototypeOf(DetailsFilesContainer)).apply(this,arguments));}_createClass(DetailsFilesContainer,[{key:'render',value:function render(){return this.props.show?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-files-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.header),this.props.children):null;}}]);return DetailsFilesContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DetailsFilesContainer.propTypes={header:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};DetailsFilesContainer.defaultProps={show:true};/* harmony default export */ __webpack_exports__["a"] = (DetailsFilesContainer);

/***/ }),
/* 891 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_details_create_quote__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_create_quote__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CreateQuoteModal_css__ = __webpack_require__(1926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CreateQuoteModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__CreateQuoteModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_shared_confirmation_ConfirmationPanel__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_images_check_circle_png__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_images_check_circle_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_images_check_circle_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_services_utils_users_util__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Create quote (for contractor)
 */var CreateQuoteModal=function(_Component){_inherits(CreateQuoteModal,_Component);function CreateQuoteModal(props){_classCallCheck(this,CreateQuoteModal);var _this=_possibleConstructorReturn(this,(CreateQuoteModal.__proto__||Object.getPrototypeOf(CreateQuoteModal)).call(this,props));_this.handleClose=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_create_quote__["a" /* closeCreateQuoteModal */])());};_this.handleAttributeChange=function(value,attribute){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_create_quote__["m" /* updateFormValue */])(value,attribute));};_this.handleContinue=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_create_quote__["c" /* continueWithFormRequest */])(_this.props.form,_this.props.currentTask.completionDate));};_this.handleQuoteEdit=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_create_quote__["e" /* editForm */])());};_this.handleQuoteSubmit=function(event){event.preventDefault();var taskQuote=_this.props.quotes.find(function(quote){return quote.task.id===_this.props.currentTask.id&&(!_this.userIsAdmin||!quote.contractor_id);});if(taskQuote!==undefined){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_create_quote__["k" /* submitQuoteRequest */])(taskQuote.id,_this.props.form));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_create_quote__["d" /* createQuoteRequest */])(Object.assign({},_this.props.form,{taskId:{value:_this.props.currentTask.id}})));}};_this.handleQuoteRespondCounter=function(action){var confirmed=window.confirm('Are you sure?');if(confirmed){var taskQuote=_this.props.quotes.find(function(quote){return quote.task.id===_this.props.currentTask.id;});if(taskQuote!==undefined){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_create_quote__["f" /* respondCounterQuoteRequest */])(taskQuote.id,action));}}};_this.handleQuoteAcceptCounter=function(event){event.preventDefault();_this.handleQuoteRespondCounter('accept');_this.setState({successMessage:'Counter offer acceptance has been submitted.'});};_this.handleQuoteRejectCounter=function(event){event.preventDefault();_this.handleQuoteRespondCounter('reject');_this.setState({successMessage:'Counter offer rejection has been submitted.'});};_this.handleQuoteRequestEnd=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_create_quote__["a" /* closeCreateQuoteModal */])());_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_19_actions_admin_work_orders_work_orders__["h" /* goToWorkOrder */])(_this.props.currentWorkOrder.id));};_this.userIsAdmin=__WEBPACK_IMPORTED_MODULE_21_services_utils_users_util__["g" /* usersUtil */].isAdmin(props.currentUser)||__WEBPACK_IMPORTED_MODULE_21_services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_21_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);_this.state={successMessage:'Quote has been submitted.'};return _this;}_createClass(CreateQuoteModal,[{key:'render',value:function render(){return this.props.show?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_modal_FormModal__["a" /* default */],{className:'create-quote-modal',show:this.props.show,showHeader:this.props.state!=='confirmation',title:this.props.state==='edit'?'Create Quote':'Review Quote',subTitle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold'},'Target Completion Date: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_text_Date__["a" /* default */],{value:this.props.currentTask.completionDate,format:'M/D/YYYY'}))),onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,{edit:this.getEditForm(),review:this.getReadOnlyForm(),confirmation:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_shared_confirmation_ConfirmationPanel__["a" /* default */],{image:__WEBPACK_IMPORTED_MODULE_18_images_check_circle_png___default.a,firstLine:'Success!',lines:[this.state.successMessage],buttons:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Continue',onClick:this.handleQuoteRequestEnd})]})}[this.props.state])):null;}},{key:'showDurationMessage',value:function showDurationMessage(){// Add duration-1 because the start day counts as a working day
var quoteCompletionDate=__WEBPACK_IMPORTED_MODULE_16_moment___default()(this.props.form.startDate.value).add(this.props.form.duration.value>=1?this.props.form.duration.value-1:0,'days').add(this.props.form.materialLeadDays.value,'days');return quoteCompletionDate.isAfter(__WEBPACK_IMPORTED_MODULE_16_moment___default()(this.props.currentTask.completionDate));}},{key:'renderDurationMessage',value:function renderDurationMessage(){if(this.showDurationMessage()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'duration-warning'},'Your date/duration does not meet the client\'s target completion date. Are you sure you would still like to submit?');}else{return null;}}},{key:'getReadOnlyForm',value:function getReadOnlyForm(){var _this2=this;var task=this.props.tasks.find(function(element){return element.id===_this2.props.currentTask.id;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'create-quote-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2'},task.trade.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Target Completion Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_text_Date__["a" /* default */],{value:task.completion_date,format:'M/D/YYYY'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Duration in days'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.props.form.duration.value)),this.props.form.materialLeadDays.value!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Material Lead Time in days'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:this.props.form.materialLeadDays.value,format:'0.[0]'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Cost'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:this.props.form.cost.value,format:'$0,0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Start Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_text_Date__["a" /* default */],{value:this.props.form.startDate.value,format:'M/D/YYYY'}))),this.props.form.description.value!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Description/Qualifications'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.props.form.description.value)),this.showDurationMessage()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2,className:'duration-warning-container'},this.renderDurationMessage())),this.props.validationMessage!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2,className:'invalid-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},this.props.validationMessage))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.props.showCounter?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',value:'Accept Counter',type:'button',onClick:this.handleQuoteAcceptCounter}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',value:'Submit Quote',type:'button',onClick:this.handleQuoteSubmit}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-gray',value:'Edit Quote',type:'button',onClick:this.handleQuoteEdit}),this.props.showCounter&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-white',value:'Reject Counter',type:'button',onClick:this.handleQuoteRejectCounter}))))));}},{key:'getEditForm',value:function getEditForm(){var _this3=this;var completionDateMoment=__WEBPACK_IMPORTED_MODULE_16_moment___default()(this.props.currentTask.completionDate);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'create-quote-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'When can you get started?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:function isValidDate(date){return Object(__WEBPACK_IMPORTED_MODULE_20_services_utils_date_util__["k" /* todayValidation */])(date)&&date.isSameOrBefore(completionDateMoment);},placeholder:'Start date',valid:this.props.form.startDate.valid,value:this.props.form.startDate.value,onChange:function onChange(value){return _this3.handleAttributeChange(value,'startDate');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'How long will it take?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_dropdown_Dropdown__["a" /* default */],{options:CreateQuoteModal.createDurationOptions(),placeholder:'Duration in days',valid:this.props.form.duration.valid,value:this.props.form.duration.value,onChange:function onChange(option){return _this3.handleAttributeChange(option.value,'duration');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Material Lead Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_dropdown_Dropdown__["a" /* default */],{options:CreateQuoteModal.createMaterialLeadDaysOptions(),clearable:true,placeholder:'Material Lead Time in days',valid:this.props.form.materialLeadDays.valid,value:this.props.form.materialLeadDays.value,onChange:function onChange(option){return _this3.handleAttributeChange(option?option.value:'','materialLeadDays');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Total Cost'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{placeholder:'Total Cost',type:'number',valid:this.props.form.cost.valid,value:this.props.form.cost.value,onChange:function onChange(value){return _this3.handleAttributeChange(value,'cost');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Description/Qualifications'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_TextArea__["a" /* default */],{placeholder:'Is there anything the Spackle team should know regarding your quote, process or experience? (Please be sure to include any exclusions).',value:this.props.form.description.value,onChange:function onChange(value){return _this3.handleAttributeChange(value,'description');}}))))),this.props.validationMessage!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},this.props.validationMessage),this.showDurationMessage()&&this.renderDurationMessage(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Continue',onClick:this.handleContinue}));}}],[{key:'createDurationOptions',value:function createDurationOptions(){var result=[];for(var i=0.5;i<=15;i=i+0.5){result.push({label:i+(i<1.5?' day':' days'),value:i});}return result;}},{key:'createMaterialLeadDaysOptions',value:function createMaterialLeadDaysOptions(){var result=[];for(var i=1;i<=100;i=i+1){result.push({label:i+(i<2?' day':' days'),value:i});}return result;}}]);return CreateQuoteModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),currentTask:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_details_details__["e" /* getCurrentTask */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_details_create_quote__["c" /* getCreateQuoteForm */])(state),quotes:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_details_details__["m" /* getQuotes */])(state),show:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_details_create_quote__["d" /* getCreateQuoteShow */])(state),state:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_details_create_quote__["e" /* getCreateQuoteState */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state),validationMessage:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_details_create_quote__["g" /* getValidationMessage */])(state),showCounter:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_details_create_quote__["f" /* getShowCounter */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_13_selectors_authentication__["d" /* getCurrentUser */])(state)};})(CreateQuoteModal));

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createQuotesFormSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createQuotesModalStateSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCreateQuoteForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCreateQuoteShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCreateQuoteState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getValidationMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getShowCounter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return showCreateQuotesModalSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var createQuotesFormSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.createQuote.ui.createQuotesForm;},function(createQuotesForm){return createQuotesForm;});var createQuotesModalStateSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.createQuote.ui.createQuotesModalState;},function(createQuotesModalState){return createQuotesModalState;});var getCreateQuoteForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.createQuote.data.form;},function(form){return form;});var getCreateQuoteShow=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.createQuote.ui.show;},function(show){return show;});var getCreateQuoteState=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.createQuote.ui.state;},function(edit){return edit;});var getValidationMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.createQuote.ui.validationMessage;},function(validationMessage){return validationMessage;});var getShowCounter=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.createQuote.ui.showCounter;},function(showCounter){return showCounter;});var showCreateQuotesModalSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.createQuote.ui.showCreateQuotesModal;},function(showCreateQuotesModal){return showCreateQuotesModal;});

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QuotesRequestModal_css__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QuotesRequestModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__QuotesRequestModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_add_png__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_add_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_add_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_left_arrow_png__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_left_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_left_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_check_circle_png__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_check_circle_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_check_circle_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectors_admin_work_orders_details_quotes_request__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_admin_work_orders_details_quotes_request__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_dropdown_SearchableDropDown__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_api_contractors_api__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_details_DetailsInfoItem__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_confirmation_ConfirmationPanel__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__actions_admin_work_orders_work_orders__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Modal for requesting bids from a task (by the admin)
 */var QuotesRequestModal=function(_Component){_inherits(QuotesRequestModal,_Component);function QuotesRequestModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,QuotesRequestModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=QuotesRequestModal.__proto__||Object.getPrototypeOf(QuotesRequestModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_admin_work_orders_details_quotes_request__["b" /* closeQuotesRequestModal */])());},_this.handleBidDueDateChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_admin_work_orders_details_quotes_request__["f" /* setBidDueDate */])(value));},_this.handleContractorSelect=function(option){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_admin_work_orders_details_quotes_request__["e" /* selectContractor */])(option));},_this.handleAddClick=function(event){event.preventDefault();if(_this.props.selectedContractor!==null&&_this.canSelectContractor()){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_admin_work_orders_details_quotes_request__["a" /* addContractor */])(_this.props.selectedContractor));}},_this.handleRemoveClick=function(event,index){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_admin_work_orders_details_quotes_request__["d" /* removeContractor */])(index));},_this.handleNext=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_admin_work_orders_details_quotes_request__["g" /* showPreview */])());},_this.handleSubmit=function(event){event.preventDefault();if(_this.props.currentTask){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_admin_work_orders_details_quotes_request__["j" /* submitQuotesRequestStart */])(_this.props.currentTask.id,_this.props.selectedContractors,_this.props.bidDueDate));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_admin_work_orders_details_quotes_request__["i" /* submitMultipleQuotesRequestStart */])(_this.props.currentWorkOrder.id,Object.keys(_this.props.selectedTasks),_this.props.selectedContractors[0].value,_this.props.bidDueDate));}},_this.handleBackArrow=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_admin_work_orders_details_quotes_request__["c" /* goBack */])());},_this.handleContinueClick=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_admin_work_orders_details_quotes_request__["b" /* closeQuotesRequestModal */])());_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_admin_work_orders_work_orders__["h" /* goToWorkOrder */])(_this.props.currentWorkOrder.id));},_this.completionDate=function(currentTask){if(currentTask){return currentTask.completion_date;}else if(_this.props.tasks.length>0&&Object.keys(_this.props.selectedTasks).length>0){var selectedTasks=_this.props.selectedTasks;return _this.props.tasks.reduce(function(previousTask,task){if(selectedTasks[task.id]!==undefined){return __WEBPACK_IMPORTED_MODULE_23_moment___default()(previousTask.completion_date)<__WEBPACK_IMPORTED_MODULE_23_moment___default()(task.completion_date)?previousTask:task;}else{return previousTask;}}).completion_date;}return null;},_this.trades=function(currentTask){if(currentTask){return[currentTask.trade.id];}else if(_this.props.tasks.length>0&&Object.keys(_this.props.selectedTasks).length>0){var selectedTasks=_this.props.selectedTasks;return _this.props.tasks.map(function(task){return selectedTasks[task.id]!==undefined?task.trade.id:null;}).filter(function(obj){return obj;});}return[];},_this.canSelectContractor=function(){return _this.props.currentTask||_this.props.selectedContractors.length===0;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(QuotesRequestModal,[{key:'render',value:function render(){// Find current task entity (this.props.currentTask is actually the form values)
var currentTaskId=this.props.currentTask!==null?this.props.currentTask.id:0;var currentTask=this.props.tasks.find(function(element){return element.id===currentTaskId;});var selectedTasks=this.props.selectedTasks;var completionDate=this.completionDate(currentTask);var trades=this.trades(currentTask);var showHeader=false;var title=void 0;if(this.props.currentView!=='message'){if(currentTask){title='Task #'+__WEBPACK_IMPORTED_MODULE_19_numeral___default()(currentTask.number).format('00')+': '+currentTask.trade.label;}else{title=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'selected-tasks-list'},this.props.tasks.map(function(task){return selectedTasks[task.id]!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:task.id},'Task #',__WEBPACK_IMPORTED_MODULE_19_numeral___default()(task.number).format('00'),':',' ',task.trade.label);}));}showHeader=true;}return this.props.show?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__shared_modal_FormModal__["a" /* default */],{className:'quotes-request-modal',show:this.props.show,showHeader:showHeader,title:title,onClose:this.handleClose},this.props.currentView==='form'&&this.getFormPage(completionDate,trades),this.props.currentView==='preview'&&this.getPreviewPage(completionDate),this.props.currentView==='message'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_confirmation_ConfirmationPanel__["a" /* default */],{image:__WEBPACK_IMPORTED_MODULE_7__images_check_circle_png___default.a,firstLine:'Thank you!',lines:['Your request for bid has been sent.'],buttons:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-orange',value:'Continue',onClick:this.handleContinueClick})]})):null;}},{key:'getPreviewPage',value:function getPreviewPage(completionDate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'preview-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__images_left_arrow_png___default.a,alt:'left-arrow',onClick:this.handleBackArrow})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2'},'Request Quotes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'task-details-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__shared_details_DetailsInfoItem__["a" /* default */],{lines:[this.props.currentWorkOrder.building.location.street_address_1,this.props.currentWorkOrder.building.location.city+', '+this.props.currentWorkOrder.building.location.state+' '+this.props.currentWorkOrder.building.location.zip,this.props.currentWorkOrder.building.name!==''&&this.props.currentWorkOrder.building.name!==null?this.props.currentWorkOrder.building.name:''],title:'BUILDING'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__shared_details_DetailsInfoItem__["a" /* default */],{lines:this.props.currentWorkOrder.working_hours,title:'AVAILABLE WORKING HOURS'}))),this.props.currentTask&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__shared_details_DetailsInfoItem__["a" /* default */],{lines:[this.props.currentTask.description],title:'DESCRIPTION'}))),this.props.currentTask&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'images-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_image_upload_ImageUpload__["a" /* default */],{images:this.props.currentTask.images,readOnly:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contractors-clients-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.props.selectedContractors.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:element.value},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element.label));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'completion-date-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold'},'Target Completion Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_text_Date__["a" /* default */],{format:'LL',value:completionDate}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bid-due-date-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-regular'},'Bid due Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_text_Date__["a" /* default */],{value:this.props.bidDueDate})))),this.showDatesWarning(completionDate)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_bootstrap__["a" /* Alert */],{bsStyle:'warning'},'Bid due date is 5 days or less from Task completion date. Please confirm.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'button',value:'Submit',onClick:this.handleSubmit})));}},{key:'getFormPage',value:function getFormPage(completionDate,trades){var _this2=this;this.completionDateMoment=__WEBPACK_IMPORTED_MODULE_23_moment___default()(completionDate);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2'},'Request Bids'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contractors-clients-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.props.selectedContractors.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:element.value},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__images_remove_png___default.a,alt:'remove',onClick:function onClick(event){return _this2.handleRemoveClick(event,index);}}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'drop-down-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_dropdown_SearchableDropDown__["a" /* default */],{autoload:false,loadOptions:QuotesRequestModal.loadContractors.bind(this,trades),placeholder:'Sub-Contractor Name',value:this.props.selectedContractor!==null?this.props.selectedContractor.value:null,onChange:this.handleContractorSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:this.props.selectedContractor===null||!this.canSelectContractor()?'disabled':'',src:__WEBPACK_IMPORTED_MODULE_4__images_add_png___default.a,alt:'add',onClick:this.handleAddClick}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'completion-date-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold'},'Target Completion Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_text_Date__["a" /* default */],{format:'LL',value:completionDate}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bid-due-date-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-regular'},'Bid due Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:this.validateBidDueDate.bind(this),placeholder:'',value:this.props.bidDueDate,onChange:this.handleBidDueDateChange}))),this.showDatesWarning(completionDate)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_bootstrap__["a" /* Alert */],{bsStyle:'warning'},'Bid due date is 5 days or less from Task completion date. Please confirm.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',disabled:this.props.selectedContractors.length===0||this.props.bidDueDate===null,type:'button',value:'Next',onClick:this.handleNext})));}},{key:'validateBidDueDate',value:function validateBidDueDate(date){return Object(__WEBPACK_IMPORTED_MODULE_22__services_utils_date_util__["k" /* todayValidation */])(date)&&date.isSameOrBefore(this.completionDateMoment);}},{key:'showDatesWarning',value:function showDatesWarning(targetCompletionDate){var result=false;if(targetCompletionDate!==null&&this.props.bidDueDate!==null){var range=Object(__WEBPACK_IMPORTED_MODULE_22__services_utils_date_util__["e" /* getRange */])(this.props.bidDueDate,targetCompletionDate);result=range.years===0&&range.months===0&&range.days<=5;}return result;}}],[{key:'loadContractors',value:function loadContractors(tradeIds,input){return __WEBPACK_IMPORTED_MODULE_14__services_api_contractors_api__["b" /* default */].searchContractors(input,tradeIds).then(function(response){if(response.ok){return{ok:true,options:response.contractors.map(function(element){return{value:element.id,label:element.name};})};}else{return{ok:false,errors:response.errors};}});}}]);return QuotesRequestModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{bidDueDate:Object(__WEBPACK_IMPORTED_MODULE_10__selectors_admin_work_orders_details_quotes_request__["a" /* getBidDueDate */])(state),currentTask:Object(__WEBPACK_IMPORTED_MODULE_2__selectors_admin_work_orders_details_details__["e" /* getCurrentTask */])(state),currentView:Object(__WEBPACK_IMPORTED_MODULE_10__selectors_admin_work_orders_details_quotes_request__["b" /* getCurrentView */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_20__selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),selectedContractor:Object(__WEBPACK_IMPORTED_MODULE_10__selectors_admin_work_orders_details_quotes_request__["c" /* getSelectedContractor */])(state),selectedContractors:Object(__WEBPACK_IMPORTED_MODULE_10__selectors_admin_work_orders_details_quotes_request__["d" /* getSelectedContractors */])(state),show:Object(__WEBPACK_IMPORTED_MODULE_10__selectors_admin_work_orders_details_quotes_request__["e" /* getShowQuotesRequestModal */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_20__selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state),selectedTasks:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_admin_work_orders_details_details__["s" /* getSelectedTasks */])(state)};})(QuotesRequestModal));

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = closeDenyQuoteModal;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeReason;
/* harmony export (immutable) */ __webpack_exports__["c"] = denyQuoteRequest;
/* harmony export (immutable) */ __webpack_exports__["d"] = selectAnswer;
/* harmony export (immutable) */ __webpack_exports__["e"] = showDenyQuoteModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_quotes_api__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__work_orders__ = __webpack_require__(35);
function closeDenyQuoteModal(){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_50" /* WORK_ORDERS_DETAILS_DENY_QUOTE_MODAL_CLOSE */]};}function changeReason(value){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_53" /* WORK_ORDERS_DETAILS_DENY_QUOTE_REASON_CHANGE */],payload:value};}function denyQuoteRequest(quoteId,reason){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__services_api_quotes_api__["a" /* quotesApi */].denyQuote(quoteId,reason!==''?reason:undefined).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__details__["_16" /* updateQuotes */])([response.quote]));dispatch(closeDenyQuoteModal());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_5__work_orders__["c" /* baseRoutePath */]));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__messages__["d" /* showErrorMessage */])(response.errors));}});};}function selectAnswer(value){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_52" /* WORK_ORDERS_DETAILS_DENY_QUOTE_QUESTION_ANSWERED */],payload:value==='yes'};}function showDenyQuoteModal(){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_51" /* WORK_ORDERS_DETAILS_DENY_QUOTE_MODAL_SHOW */]};}

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEditOpenItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getMembers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getShowAddOpenItemModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getInvalidFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEditForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getValidationMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getEditOpenItem=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.openItems.ui.editOpenItem;},function(editOpenItem){return editOpenItem;});var getForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.openItems.ui.form;},function(form){return form;});var getMembers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.openItems.data.members;},function(members){return members;});var getShowAddOpenItemModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.openItems.ui.showAddOpenItemModal;},function(showAddOpenItemModal){return showAddOpenItemModal;});var getInvalidFields=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.openItems.ui.invalidFields;},function(invalidFields){return invalidFields;});var getEditForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.openItems.ui.editForm;},function(editForm){return editForm;});var getValidationMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.openItems.ui.validationMessage;},function(validationMessage){return validationMessage;});

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA5CAYAAAB9E9gIAAAAAXNSR0IArs4c6QAABExJREFUaAXtmluITVEYxx3MMIzk1sSgJJFLcilMLg9u5ZKZFPLikpCI8CDiwQNKSnmQxiVJJDLy4AUZt3LLbSb3JCmX8eB+nRm//5mzz9lnzTqnc6acs/Zpvvqftb7L3uv7r7X32muvs1u08El9ff1YcBq8A3XAdaklwTfgGBjqo9JQxdgG7AIKDKr8JvFNoGWUIIpI5YqsFbEQbEoor4AYU3mCKz9JfajIrAcmqbPYtoAHIGjSloRXacTeUinyZV8RCoXKpOMrpHgKuksPkNzVSHU0Er7m6RD8Sv2+pweo7CRiL42EyxipPNkoe1GMMfxBUN+K2HUjU00mVZA6QXkPmCNqhDupXtQ9NoDUqoE5gTiZcQpJfSBmkMhoctiQwgFBCVnB3PBBxE6CPWAd+A6CKu9IvBRS4hN+QNdTPgJrwBOwBGjC6AZcvzxryVGELoN9kKqhDIvuMRHz5BmVM+A5eA/qgCk1nCD6SDCdzugilqZccCb5JIm4fqklST25q5lY8v5xz9s8Yu6NSfKMcnbEWifnbffyeOiJZ4jdm1HrZ1p7qiWU2WqTiHGSqWC/ebIs6dpNO0/byyEYfQXLhUtRHKaABxCc63VuImKvCTgHvniBASi1jXEQcv2Uq43Ybez9GdZplMOBtgeCIu1ItFzJiph/ESzbCUj9UIVSi2FzwWtbGCs8k6J9mElgMnhoNDyBUeujyUNLfb2ieDLSqxBQQH2gp0fK6KuBYc+kuoBOD28ykeNCGr5jND5YxG6C6T7HHIL1niP7PKANHb/I3s5vyEL9o69Nf90z52snagpIVT4RWAR2pHrAf4o7ynkLIjhuaWNYmCGOcovTZlqpA3BU2pwZtv2kvV+WNl9hC3nEClGOWIL8pvCGD4Zi4PK/MovCpPw/JKzN0uvgL5C8ByfBCC+O+gHgquwlsXzQxcs3rsTRCnSIM6Jgmw5c/EOwhrzmgi7gAhjXcC2aDCw6wXmYN4L2Fne2TFoZPQaaqcvAZtAZjE+ZGMFZETp0Bg3PTNB4J+y9gW4V/4J+vF9JcGzWzVowLE03C9taMd1zOBnfTMzJYUmSVKN7jJs1n/jBwIW9e9s6MAmdmCtKLDKd6w/11aDRMyx2SEZrlbR2qSktholBSiv4s6Dx1y1NOasDx7SElJ5lh3KJlPpVs+JiMFFKLomILcwlQh4X3WNDPCVApT662Qu6gmVAM3mciFgjY1xEdpVEWxCT2fOoUmrMES8odptp6lKUw1UpJrE/RnLfPFIR+w3DL/WPiFVYHK6YepDILyOZ9ozSLJ9tvq/uVd9oKBX4Argq2yyJ6Q3/HLhl8em7lQbBOQ58tQS5YNL2REUaicwWK12K2vHVh5hadVyV7phozfoXVKeQ13G4nFJc3Bs0vSJ9NCgBLiyCSSMqWvLtBKOillillup2sBVi4ckmjlgszs1apOM1cZSCvkATy0NwGEL3KJslsD3wD5SLwdUN3EG1AAAAAElFTkSuQmCC"

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TasksChecklist_css__ = __webpack_require__(1961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TasksChecklist_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TasksChecklist_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_checkbox_CheckBox__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var values={arrived_onsite:{id:'arrived_onsite',labelForContractor:'I have arrived onsite.',labelForRest:'Contractor has arrived onsite.',order:1},checked_security:{id:'checked_security',labelForContractor:'I have checked with security.',labelForRest:'Contractor has checked with security.',order:2},checked_in:{id:'checked_in',labelForContractor:'I have made contact/checked in with the client/contact person.',labelForRest:'Contractor has made contact/checked in with the client/contact person.',order:3},verified_work:{id:'verified_work',labelForContractor:'I have verified I can complete work.',labelForRest:'Contractor has verified it can complete work.',order:4},protected_work:{id:'protected_work',labelForContractor:'I have protected work that is to remain.',labelForRest:'Contractor has protected work that is to remain.',order:5}};var TasksChecklist=function(_Component){_inherits(TasksChecklist,_Component);function TasksChecklist(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TasksChecklist);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TasksChecklist.__proto__||Object.getPrototypeOf(TasksChecklist)).call.apply(_ref,[this].concat(args))),_this),_this.handleChange=function(id){if(_this.props.onSelect!==undefined){_this.props.onSelect(id);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TasksChecklist,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tasks-checklist'},Object.entries(values).map(function(entry){var found=_this2.props.selectedStatus.find(function(status){return status===entry[1].id;});if(found===undefined){return _this2.renderItem(entry[1].order,entry[1].id,_this2.props.showForContractor?entry[1].labelForContractor:entry[1].labelForRest,_this2.props.readOnly,false);}else{return _this2.renderItem(entry[1].order,entry[1].id,_this2.props.showForContractor?entry[1].labelForContractor:entry[1].labelForRest,_this2.props.readOnly,true);}}));}},{key:'renderItem',value:function renderItem(key,id,label,readOnly,checked){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key,className:'tasks-checklist-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_checkbox_CheckBox__["a" /* default */],{id:id,readOnly:readOnly,checked:checked,size:'medium',shape:'square',onChange:this.handleChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,label));}}]);return TasksChecklist;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TasksChecklist.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,selectedStatus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.keys(values).concat(null))),showForContractor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,onSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};TasksChecklist.defaultProps={selectedStatus:[]};TasksChecklist.keys=Object.keys(values);/* harmony default export */ __webpack_exports__["a"] = (TasksChecklist);

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = showDetailsTaskButtons;
/* harmony export (immutable) */ __webpack_exports__["a"] = isTaskChecklistComplete;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_quotes_status_enum__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_work_orders_details_TasksChecklist__ = __webpack_require__(900);
/**
 * Calculates which button should be visible for a given user and task. Also the quote and task preCondition are important.
 * @param user
 * @param task
 * @param quote
 * @param hasPrecondition
 * @return {{requestBids: boolean, editTask: boolean, createQuote: boolean, askQuestion: boolean,
 * noThanks: boolean, withdrawQuote: boolean, resubmitQuote: boolean, startTask: {enable: boolean, show: boolean},
 * markAsCompleted: {enable: boolean, show: boolean}, approveWork: boolean, showCompleted: boolean}}
 */function showDetailsTaskButtons(user,task){var quote=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var hasPrecondition=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var result={requestBids:false,editTask:false,deleteTask:false,createQuote:false,askQuestion:false,noThanks:false,withdrawQuote:false,viewCounterQuote:false,resubmitQuote:false,addMaterials:false,addTime:false,startTask:{enable:false,show:false},markAsCompleted:{enable:false,show:false},approveWork:false,showCompleted:false};var gcType=__WEBPACK_IMPORTED_MODULE_0__users_util__["g" /* usersUtil */].hasType(user,__WEBPACK_IMPORTED_MODULE_0__users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);if(__WEBPACK_IMPORTED_MODULE_0__users_util__["g" /* usersUtil */].isAdmin(user)||gcType){if(__WEBPACK_IMPORTED_MODULE_0__users_util__["g" /* usersUtil */].hasRole(user,__WEBPACK_IMPORTED_MODULE_0__users_util__["e" /* ROLES */].SPACKLE_ADMIN)||gcType){result.requestBids=task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].RFP||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].PLM||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].AGG;result.editTask=task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].RFP||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].PLM||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].AGG||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].WOA;result.deleteTask=task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].RFP||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].PLM||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].AGG||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].WOA;}if(__WEBPACK_IMPORTED_MODULE_0__users_util__["g" /* usersUtil */].hasRole(user,__WEBPACK_IMPORTED_MODULE_0__users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_0__users_util__["g" /* usersUtil */].hasRole(user,__WEBPACK_IMPORTED_MODULE_0__users_util__["e" /* ROLES */].FIELD)||gcType){result.approveWork=task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].CMP&&!task.cmp_approved;}result.showCompleted=(task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].CMP||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].CLS)&&task.cmp_approved;if(!task.awardedContractor){result.createQuote=(task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].RFP||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].AGG||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].PLM)&&!quote;result.withdrawQuote=(task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].RFP||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].AGG||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].PLM||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].WOA)&&quote&&quote.status===__WEBPACK_IMPORTED_MODULE_2__domain_quotes_status_enum__["a" /* QuotesStatusKeys */].RECEIVED;result.resubmitQuote=(task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].RFP||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].AGG||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].PLM||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].WOA)&&quote&&quote.status===__WEBPACK_IMPORTED_MODULE_2__domain_quotes_status_enum__["a" /* QuotesStatusKeys */].WITHDRAWN;result.startTask.show=task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].PRE;result.startTask.enable=result.startTask.show&&startTaskConditionsMet(false,task,hasPrecondition);result.markAsCompleted.show=task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].WIP;result.markAsCompleted.enable=result.markAsCompleted.show&&task.task_checklist.completed_images.length>0;}}else if(__WEBPACK_IMPORTED_MODULE_0__users_util__["g" /* usersUtil */].hasType(user,__WEBPACK_IMPORTED_MODULE_0__users_util__["f" /* TYPES */].CONTRACTOR)){if(quote!==null){result.createQuote=(task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].RFP||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].PLM)&&quote.status===__WEBPACK_IMPORTED_MODULE_2__domain_quotes_status_enum__["a" /* QuotesStatusKeys */].WAITING;result.askQuestion=result.createQuote;result.noThanks=result.createQuote;result.withdrawQuote=(task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].RFP||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].PLM||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].WOA)&&quote.status===__WEBPACK_IMPORTED_MODULE_2__domain_quotes_status_enum__["a" /* QuotesStatusKeys */].RECEIVED;result.viewCounterQuote=result.withdrawQuote&&quote.counter_status==='negotiating';result.resubmitQuote=(task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].RFP||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].PLM||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].WOA)&&quote.status===__WEBPACK_IMPORTED_MODULE_2__domain_quotes_status_enum__["a" /* QuotesStatusKeys */].WITHDRAWN;}result.addMaterials=task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].PRE||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].WIP||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].CMP||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].CLS;result.addTime=task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].CMP||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].CLS;result.startTask.show=task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].PRE;result.startTask.enable=result.startTask.show&&startTaskConditionsMet(false,task,hasPrecondition);result.markAsCompleted.show=task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].WIP;result.markAsCompleted.enable=result.markAsCompleted.show&&task.task_checklist.completed_images.length>0;result.showCompleted=(task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].CMP||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].CLS)&&task.cmp_approved;}else if(__WEBPACK_IMPORTED_MODULE_0__users_util__["g" /* usersUtil */].hasType(user,__WEBPACK_IMPORTED_MODULE_0__users_util__["f" /* TYPES */].CLIENT)){result.approveWork=task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].CMP&&!task.cmp_approved;result.showCompleted=(task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].CMP||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].CLS)&&task.cmp_approved;result.editTask=task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].RFP||task.status===__WEBPACK_IMPORTED_MODULE_1__domain_task_status_enum__["b" /* TaskStatusKeys */].AGG;result.deleteTask=result.editTask;}return result;}/**
 * Check if the task checklist is complete.
 * @param task
 * @return {boolean}
 */function isTaskChecklistComplete(){var task=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;if(task!==null&&task.task_checklist!==undefined&&task.task_checklist!==null){// All keys should be true
return __WEBPACK_IMPORTED_MODULE_3__components_admin_work_orders_details_TasksChecklist__["a" /* default */].keys.filter(function(key){return!task.task_checklist[key];}).length===0;}return false;}function startTaskConditionsMet(isAdmin,task,hasPrecondition){if(isAdmin&&isTaskChecklistComplete(task)){return true;}else if(!isAdmin&&isTaskChecklistComplete(task)&&hasPrecondition!==null){// precondition has to be defined
return!hasPrecondition||hasPrecondition&&task.task_checklist.pre_existing_images.length>0&&task.task_checklist.pre_existing_desc!==null&&task.task_checklist.pre_existing_desc!=='';}else{return false;}}

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getShowModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.newTask.ui.form;},function(form){return form;});var getShowModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.newTask.ui.showModal;},function(showModal){return showModal;});

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = attributeChange;
/* unused harmony export clearForm */
/* harmony export (immutable) */ __webpack_exports__["b"] = openModal;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeImage;
/* harmony export (immutable) */ __webpack_exports__["d"] = setShowModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_admin_work_orders_details_new_task__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_images_util__ = __webpack_require__(1968);
function attributeChange(attribute,value,label){return function(dispatch,getState){var form=Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_work_orders_details_new_task__["a" /* getForm */])(getState());if(attribute==='images'){Object(__WEBPACK_IMPORTED_MODULE_4_services_utils_images_util__["a" /* getFilesFromDataImages */])(value).then(function(imageFiles){var currentImages=form.images;dispatch(attributeChangeAction(attribute,currentImages.concat(imageFiles)));});}else{dispatch(attributeChangeAction(attribute,value));// Check if 'name' attribute should be updated
if(attribute==='trade'){updateName(dispatch,label);}}};}function attributeChangeAction(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_62" /* WORK_ORDERS_DETAILS_NEW_TASK_ATTRIBUTE_CHANGE */],payload:{attribute:attribute,value:value}};}function clearForm(){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_63" /* WORK_ORDERS_DETAILS_NEW_TASK_FORM_CLEAR */]};}function openModal(loadTrades,lastTaskNumber){return function(dispatch){var newTaskNumber=lastTaskNumber+1;if(loadTrades){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_admin_work_orders_details_details__["J" /* loadTradesRequest */])()).then(function(response){if(response.ok){openModalConfirm(dispatch,newTaskNumber);}});}else{openModalConfirm(dispatch,newTaskNumber);}};}function openModalConfirm(dispatch,newTaskNumber){dispatch(clearForm());dispatch(attributeChange('number',newTaskNumber));dispatch(setShowModal(true));}function removeImage(index){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_64" /* WORK_ORDERS_DETAILS_NEW_TASK_IMAGE_REMOVE */],payload:index};}function setShowModal(show){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_65" /* WORK_ORDERS_DETAILS_NEW_TASK_MODAL_SHOW */],payload:show};}function updateName(dispatch,trade){dispatch(attributeChangeAction('name',Object(__WEBPACK_IMPORTED_MODULE_3_services_utils_text_util__["a" /* buildTaskName */])(trade)));}

/***/ }),
/* 904 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(562);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var arrayInsert = function arrayInsert(form, field, index, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"],
    meta: { form: form, field: field, index: index },
    payload: value
  };
};

var arrayMove = function arrayMove(form, field, from, to) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"],
    meta: { form: form, field: field, from: from, to: to }
  };
};

var arrayPop = function arrayPop(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"],
    meta: { form: form, field: field }
  };
};

var arrayPush = function arrayPush(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"],
    meta: { form: form, field: field },
    payload: value
  };
};

var arrayRemove = function arrayRemove(form, field, index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"],
    meta: { form: form, field: field, index: index }
  };
};

var arrayRemoveAll = function arrayRemoveAll(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"],
    meta: { form: form, field: field }
  };
};

var arrayShift = function arrayShift(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"],
    meta: { form: form, field: field }
  };
};

var arraySplice = function arraySplice(form, field, index, removeNum, value) {
  var action = {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"],
    meta: { form: form, field: field, index: index, removeNum: removeNum }
  };
  if (value !== undefined) {
    action.payload = value;
  }
  return action;
};

var arraySwap = function arraySwap(form, field, indexA, indexB) {
  if (indexA === indexB) {
    throw new Error('Swap indices cannot be equal');
  }
  if (indexA < 0 || indexB < 0) {
    throw new Error('Swap indices cannot be negative');
  }
  return { type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
};

var arrayUnshift = function arrayUnshift(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"],
    meta: { form: form, field: field },
    payload: value
  };
};

var autofill = function autofill(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"],
    meta: { form: form, field: field },
    payload: value
  };
};

var blur = function blur(form, field, value, touch) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"],
    meta: { form: form, field: field, touch: touch },
    payload: value
  };
};

var change = function change(form, field, value, touch, persistentSubmitErrors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"],
    meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors },
    payload: value
  };
};

var clearSubmit = function clearSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"],
    meta: { form: form }
  };
};

var clearSubmitErrors = function clearSubmitErrors(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"],
    meta: { form: form }
  };
};

var clearAsyncError = function clearAsyncError(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"],
    meta: { form: form, field: field }
  };
};

var clearFields = function clearFields(form, keepTouched, persistentSubmitErrors) {
  for (var _len = arguments.length, fields = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    fields[_key - 3] = arguments[_key];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_FIELDS"],
    meta: { form: form, keepTouched: keepTouched, persistentSubmitErrors: persistentSubmitErrors, fields: fields }
  };
};

var destroy = function destroy() {
  for (var _len2 = arguments.length, form = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    form[_key2] = arguments[_key2];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"],
    meta: { form: form }
  };
};

var focus = function focus(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"],
    meta: { form: form, field: field }
  };
};

var initialize = function initialize(form, values, keepDirty) {
  var otherMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (keepDirty instanceof Object) {
    otherMeta = keepDirty;
    keepDirty = false;
  }
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"],
    meta: _extends({ form: form, keepDirty: keepDirty }, otherMeta),
    payload: values
  };
};

var registerField = function registerField(form, name, type) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, type: type }
  };
};

var reset = function reset(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"],
    meta: { form: form }
  };
};

var resetSection = function resetSection(form) {
  for (var _len3 = arguments.length, sections = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    sections[_key3 - 1] = arguments[_key3];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET_SECTION"],
    meta: { form: form, sections: sections }
  };
};

var startAsyncValidation = function startAsyncValidation(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"],
    meta: { form: form, field: field }
  };
};

var startSubmit = function startSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"],
    meta: { form: form }
  };
};

var stopAsyncValidation = function stopAsyncValidation(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var stopSubmit = function stopSubmit(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var submit = function submit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"],
    meta: { form: form }
  };
};

var setSubmitFailed = function setSubmitFailed(form) {
  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    fields[_key4 - 1] = arguments[_key4];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"],
    meta: { form: form, fields: fields },
    error: true
  };
};

var setSubmitSucceeded = function setSubmitSucceeded(form) {
  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    fields[_key5 - 1] = arguments[_key5];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"],
    meta: { form: form, fields: fields },
    error: false
  };
};

var touch = function touch(form) {
  for (var _len6 = arguments.length, fields = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    fields[_key6 - 1] = arguments[_key6];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"],
    meta: { form: form, fields: fields }
  };
};

var unregisterField = function unregisterField(form, name) {
  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, destroyOnUnmount: destroyOnUnmount }
  };
};

var untouch = function untouch(form) {
  for (var _len7 = arguments.length, fields = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    fields[_key7 - 1] = arguments[_key7];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"],
    meta: { form: form, fields: fields }
  };
};

var updateSyncErrors = function updateSyncErrors(form) {
  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var error = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"],
    meta: { form: form },
    payload: { syncErrors: syncErrors, error: error }
  };
};

var updateSyncWarnings = function updateSyncWarnings(form) {
  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var warning = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"],
    meta: { form: form },
    payload: { syncWarnings: syncWarnings, warning: warning }
  };
};

var actions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift,
  autofill: autofill,
  blur: blur,
  change: change,
  clearFields: clearFields,
  clearSubmit: clearSubmit,
  clearSubmitErrors: clearSubmitErrors,
  clearAsyncError: clearAsyncError,
  destroy: destroy,
  focus: focus,
  initialize: initialize,
  registerField: registerField,
  reset: reset,
  resetSection: resetSection,
  startAsyncValidation: startAsyncValidation,
  startSubmit: startSubmit,
  stopAsyncValidation: stopAsyncValidation,
  stopSubmit: stopSubmit,
  submit: submit,
  setSubmitFailed: setSubmitFailed,
  setSubmitSucceeded: setSubmitSucceeded,
  touch: touch,
  unregisterField: unregisterField,
  untouch: untouch,
  updateSyncErrors: updateSyncErrors,
  updateSyncWarnings: updateSyncWarnings
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
  var initialized = _ref.initialized,
      trigger = _ref.trigger,
      pristine = _ref.pristine,
      syncValidationPasses = _ref.syncValidationPasses;

  if (!syncValidationPasses) {
    return false;
  }
  switch (trigger) {
    case 'blur':
    case 'change':
      // blurring
      return true;
    case 'submit':
      // submitting, so only async validate if form is dirty or was never initialized
      // conversely, DON'T async validate if the form is pristine just as it was initialized
      return !pristine || !initialized;
    default:
      return false;
  }
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldAsyncValidate);

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldValidate = function defaultShouldValidate(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldValidate);

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldError = function defaultShouldError(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldError);

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldWarn = function defaultShouldWarn(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldWarn);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_error__ = __webpack_require__(1975);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var SubmissionError = function (_ExtendableError) {
  _inherits(SubmissionError, _ExtendableError);

  function SubmissionError(errors) {
    _classCallCheck(this, SubmissionError);

    var _this = _possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));

    _this.errors = errors;
    return _this;
  }

  return SubmissionError;
}(__WEBPACK_IMPORTED_MODULE_0_es6_error__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SubmissionError);

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var processProps = function processProps(type, props, _value, deepEqual) {
  var value = props.value;

  if (type === 'checkbox') {
    return _extends({}, props, {
      checked: !!value
    });
  }
  if (type === 'radio') {
    return _extends({}, props, {
      checked: deepEqual(value, _value),
      value: _value
    });
  }
  if (type === 'select-multiple') {
    return _extends({}, props, {
      value: value || []
    });
  }
  if (type === 'file') {
    return _extends({}, props, {
      value: value || undefined
    });
  }
  return props;
};

var createFieldProps = function createFieldProps(_ref2, name, _ref) {
  var getIn = _ref2.getIn,
      toJS = _ref2.toJS,
      deepEqual = _ref2.deepEqual;

  var asyncError = _ref.asyncError,
      asyncValidating = _ref.asyncValidating,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onDrop = _ref.onDrop,
      onDragStart = _ref.onDragStart,
      dirty = _ref.dirty,
      dispatch = _ref.dispatch,
      onFocus = _ref.onFocus,
      form = _ref.form,
      format = _ref.format,
      initial = _ref.initial,
      parse = _ref.parse,
      pristine = _ref.pristine,
      props = _ref.props,
      state = _ref.state,
      submitError = _ref.submitError,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      validate = _ref.validate,
      value = _ref.value,
      _value = _ref._value,
      warn = _ref.warn,
      custom = _objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'onBlur', 'onChange', 'onDrop', 'onDragStart', 'dirty', 'dispatch', 'onFocus', 'form', 'format', 'initial', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'validate', 'value', '_value', 'warn']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;

  var formatFieldValue = function formatFieldValue(value, format) {
    if (format === null) {
      return value;
    }
    var defaultFormattedValue = value == null ? '' : value;
    return format ? format(value, name) : defaultFormattedValue;
  };

  var formattedFieldValue = formatFieldValue(value, format);

  return {
    input: processProps(custom.type, {
      name: name,
      onBlur: onBlur,
      onChange: onChange,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onFocus: onFocus,
      value: formattedFieldValue
    }, _value, deepEqual),
    meta: _extends({}, toJS(state), {
      active: !!(state && getIn(state, 'active')),
      asyncValidating: asyncValidating,
      autofilled: !!(state && getIn(state, 'autofilled')),
      dirty: dirty,
      dispatch: dispatch,
      error: error,
      form: form,
      initial: initial,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: !!submitting,
      submitFailed: !!submitFailed,
      touched: !!(state && getIn(state, 'touched')),
      valid: !error,
      visited: !!(state && getIn(state, 'visited'))
    }),
    custom: _extends({}, custom, props)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldProps);

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getValue__ = __webpack_require__(1980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isReactNative__ = __webpack_require__(914);




var onChangeValue = function onChangeValue(event, _ref) {
  var name = _ref.name,
      parse = _ref.parse,
      normalize = _ref.normalize;

  // read value from input
  var value = Object(__WEBPACK_IMPORTED_MODULE_0__getValue__["a" /* default */])(event, __WEBPACK_IMPORTED_MODULE_1__isReactNative__["a" /* default */]);

  // parse value if we have a parser
  if (parse) {
    value = parse(value, name);
  }

  // normalize value
  if (normalize) {
    value = normalize(name, value);
  }

  return value;
};

/* harmony default export */ __webpack_exports__["a"] = (onChangeValue);

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

/* harmony default export */ __webpack_exports__["a"] = (isEvent);

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

/* harmony default export */ __webpack_exports__["a"] = (isReactNative);

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (copyArray);


/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__ = __webpack_require__(1984);


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = Object(__WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__["a" /* default */])(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (stringToPath);


/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(2007);


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(412);


/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other, undefined, customizer) : !!result;
}

/* harmony default export */ __webpack_exports__["a"] = (isEqualWith);


/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(2016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arraySome_js__ = __webpack_require__(2019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cacheHas_js__ = __webpack_require__(2020);




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */] : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__arraySome_js__["a" /* default */])(other, function(othValue, othIndex) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__cacheHas_js__["a" /* default */])(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalArrays);


/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(152);


/** Built-in value references. */
var Uint8Array = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Uint8Array;

/* harmony default export */ __webpack_exports__["a"] = (Uint8Array);


/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(2031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__(415);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && Object(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? Object(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__(2037);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__(2038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__(2039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__(2040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__(2041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__(918);








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(920);



var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
  // https://lodash.com/docs/4.17.4#isEqualWith
  if (stack) {
    // Shallow compares
    // For 1st level, stack === undefined.
    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
    // For 2nd level and up, stack !== undefined.
    //   -> Compare by === operator
    return objectValue === otherValue;
  }
};

var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
  var propsEqual = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.props, nextProps, customizer);
  var stateEqual = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.state, nextState, customizer);

  return !propsEqual || !stateEqual;
};

/* harmony default export */ __webpack_exports__["a"] = (shallowCompare);

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(230);


var defineProperty = (function() {
  try {
    var func = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (defineProperty);


/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__ = __webpack_require__(2051);


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = Object(__WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (baseFor);


/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(201);


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isStrictComparable);


/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (matchesStrictComparable);


/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toKey_js__ = __webpack_require__(319);



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[Object(__WEBPACK_IMPORTED_MODULE_1__toKey_js__["a" /* default */])(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (baseGet);


/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isKey_js__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToPath_js__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(919);





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return value;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__isKey_js__["a" /* default */])(value, object) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_2__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (castPath);


/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsPristine = function createIsPristine(_ref) {
  var deepEqual = _ref.deepEqual,
      empty = _ref.empty,
      getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      if (fields && fields.length) {
        return fields.every(function (field) {
          var fieldInitial = getIn(formState, form + '.initial.' + field);
          var fieldValue = getIn(formState, form + '.values.' + field);
          return deepEqual(fieldInitial, fieldValue);
        });
      }
      var initial = getIn(formState, form + '.initial') || empty;
      var values = getIn(formState, form + '.values') || initial;
      return deepEqual(initial, values);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsPristine);

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(318);



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(object[key], value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignMergeValue);


/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (safeGet);


/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__ = __webpack_require__(2118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(320);




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object, true) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keysIn);


/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(913);


var silenceEvent = function silenceEvent(event) {
  var is = Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event);
  if (is) {
    event.preventDefault();
  }
  return is;
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvent);

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SimpleTaskStatus_css__ = __webpack_require__(2141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SimpleTaskStatus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SimpleTaskStatus_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleTaskStatus=function(_Component){_inherits(SimpleTaskStatus,_Component);function SimpleTaskStatus(){_classCallCheck(this,SimpleTaskStatus);return _possibleConstructorReturn(this,(SimpleTaskStatus.__proto__||Object.getPrototypeOf(SimpleTaskStatus)).apply(this,arguments));}_createClass(SimpleTaskStatus,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'simple-task-status box '+this.props.status},this.props.status);}}]);return SimpleTaskStatus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SimpleTaskStatus.propTypes={status:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (SimpleTaskStatus);

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeOrderTasksApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeOrderTasksApi=function(_BaseApi){_inherits(ChangeOrderTasksApi,_BaseApi);function ChangeOrderTasksApi(){_classCallCheck(this,ChangeOrderTasksApi);return _possibleConstructorReturn(this,(ChangeOrderTasksApi.__proto__||Object.getPrototypeOf(ChangeOrderTasksApi)).apply(this,arguments));}_createClass(ChangeOrderTasksApi,[{key:'getChangeOrderTasks',value:function getChangeOrderTasks(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders/'+workOrderId+'/change_order_tasks').then(function(response){return{ok:true,changeOrderTasks:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createChangeOrderTask',value:function createChangeOrderTask(taskId,values){var changeOrderTaskData=new FormData();changeOrderTaskData.append('change_order_task[completion_date]',values.completionDate);changeOrderTaskData.append('change_order_task[description]',values.description);if(values.images&&values.images.length>0){values.images.forEach(function(image){var file=image.file;changeOrderTaskData.append('change_order_task[images_attributes][][image]',file,file.name);});}if(values.changeOrderQuote){changeOrderTaskData.append('change_order_task[change_order_quote_attributes][create]',true);}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/tasks/'+taskId+'/change_order_tasks',changeOrderTaskData,{headers:{'Content-Type':'multipart/form-data'}}).then(function(response){return{ok:true,changeOrderTask:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'deleteChangeOrderTask',value:function deleteChangeOrderTask(changeOrderTaskId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/change_order_tasks/'+changeOrderTaskId).then(function(response){return{ok:true,changeOrderTasks:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateChangeOrderTask',value:function updateChangeOrderTask(changeOrderTaskId,values){var imagesIndex=0;var changeOrderTaskData=new FormData();changeOrderTaskData.append('change_order_task[completion_date]',values.completionDate);changeOrderTaskData.append('change_order_task[description]',values.description);if(values.images&&values.images.length>0){values.images.filter(function(image){return image.file;}).forEach(function(image){var file=image.file;changeOrderTaskData.append('change_order_task[images_attributes]['+imagesIndex+'][image]',file,file.name);imagesIndex++;});}if(values.imagesToDestroy&&values.imagesToDestroy.length>0){values.imagesToDestroy.forEach(function(image){changeOrderTaskData.append('change_order_task[images_attributes]['+imagesIndex+'][id]',image.id);changeOrderTaskData.append('change_order_task[images_attributes]['+imagesIndex+'][_destroy]',true);imagesIndex++;});}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/change_order_tasks/'+changeOrderTaskId,changeOrderTaskData,{headers:{'Content-Type':'multipart/form-data'}}).then(function(response){return{ok:true,changeOrderTask:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateChangeOrderQuote',value:function updateChangeOrderQuote(changeOrderTaskId,values){var apiPayload={change_order_task:{change_order_quote_attributes:{id:values.id,estimate:values.estimate,value:values.value}}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/change_order_tasks/'+changeOrderTaskId,apiPayload).then(function(response){return{ok:true,changeOrderTask:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'requestChangeOrderQuote',value:function requestChangeOrderQuote(changeOrderTaskId,values){var apiPayload={change_order_task:{bid_due_date:values.bidDueDate}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/change_order_tasks/'+changeOrderTaskId+'/request_quote',apiPayload).then(function(response){return{ok:true,changeOrderTask:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'submitChangeOrderQuote',value:function submitChangeOrderQuote(changeOrderTaskId,values){var apiPayload={change_order_task:{change_order_quote_attributes:{id:values.id,start_date:values.startDate,days_of_duration:values.daysOfDuration,material_lead_days:values.materialLeadDays,estimate:values.estimate,description:values.description}}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/change_order_tasks/'+changeOrderTaskId+'/submit_quote',apiPayload).then(function(response){return{ok:true,changeOrderTask:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'withdrawChangeOrderQuote',value:function withdrawChangeOrderQuote(changeOrderTaskId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/change_order_tasks/'+changeOrderTaskId+'/withdraw_quote').then(function(response){return{ok:true,changeOrderTask:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'withdrawChangeOrderQuoteRequest',value:function withdrawChangeOrderQuoteRequest(changeOrderTaskId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/change_order_tasks/'+changeOrderTaskId+'/delete_quote').then(function(response){return{ok:true,changeOrderTask:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'moveToAcr',value:function moveToAcr(workOrderId,changeOrderTaskIds){var apiPayload={change_order_task_ids:changeOrderTaskIds};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/work_orders/'+workOrderId+'/change_order_tasks/move_to_acr',apiPayload).then(function(response){return{ok:true,changeOrderTasks:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return ChangeOrderTasksApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var changeOrderTasksApi=new ChangeOrderTasksApi();

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangeOrderTaskModal_css__ = __webpack_require__(2155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangeOrderTaskModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ChangeOrderTaskModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_change_order_tasks_store_selectors__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_change_order_tasks_store_actions__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_change_order_tasks_ChangeOrderTaskForm__ = __webpack_require__(2156);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeOrderTaskModal=function(_Component){_inherits(ChangeOrderTaskModal,_Component);function ChangeOrderTaskModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChangeOrderTaskModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChangeOrderTaskModal.__proto__||Object.getPrototypeOf(ChangeOrderTaskModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_change_order_tasks_store_actions__["e" /* setShowChangeOrderTaskModal */])());},_this.setImagesToDestroy=function(values){values.imagesToDestroy=_this.changeOrderTask.images.map(function(img){var prevImg=values.images.find(function(i){return i.id===img.id;});return!prevImg&&img;}).filter(function(img){return img;});},_this.handleOnSubmit=function(values){if(_this.edit){_this.setImagesToDestroy(values);_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_change_order_tasks_store_actions__["c" /* editChangeOrderTask */])(_this.changeOrderTask.id,values));}else{if(!_this.props.currentTask.awardedContractor){values.changeOrderQuote=true;}_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_change_order_tasks_store_actions__["a" /* createChangeOrderTask */])(_this.props.currentTask.id,values));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChangeOrderTaskModal,[{key:'render',value:function render(){var _this2=this;this.changeOrderTask=this.props.changeOrderTasks.find(function(cot){return cot.task_id===_this2.props.currentTask.id&&cot.status==='pending';});this.edit=!!this.changeOrderTask;if(this.edit){this.initialValues={completionDate:this.changeOrderTask.completion_date,description:this.changeOrderTask.description,images:this.changeOrderTask.images.map(function(i){return{id:i.id,url:i.image.preview.url};})};}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{className:'change-order-task-modal',show:this.props.show,title:this.edit?'Edit Change Order':'Create Change Order',onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_change_order_tasks_ChangeOrderTaskForm__["a" /* default */],{initialValues:this.initialValues,onSubmit:this.handleOnSubmit})));}}]);return ChangeOrderTaskModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentTask:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_details_details__["e" /* getCurrentTask */])(state),show:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_change_order_tasks_store_selectors__["b" /* getShowChangeOrderTaskModal */])(state),changeOrderTasks:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_change_order_tasks_store_selectors__["a" /* getChangeOrderTasks */])(state)};})(ChangeOrderTaskModal));

/***/ }),
/* 941 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DepositContainer_css__ = __webpack_require__(2172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DepositContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DepositContainer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_proposal__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_checkbox_CheckBox__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_details_proposal__ = __webpack_require__(128);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DepositContainer=function(_Component){_inherits(DepositContainer,_Component);function DepositContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DepositContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DepositContainer.__proto__||Object.getPrototypeOf(DepositContainer)).call.apply(_ref,[this].concat(args))),_this),_this.handleDepositSelectedChange=function(){if(_this.props.depositSelected){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_details_proposal__["g" /* depositCostChange */])(null));}_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_details_proposal__["h" /* depositSelectedChange */])(!_this.props.depositSelected));},_this.handleDepositCostChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_details_proposal__["g" /* depositCostChange */])(value===''?null:value));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DepositContainer,[{key:'render',value:function render(){return(!this.props.readOnly||this.props.depositCost!==null)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deposit-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h3'},'Deposit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deposit-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_checkbox_CheckBox__["a" /* default */],{checked:this.props.depositSelected,readOnly:this.props.readOnly,onChange:this.handleDepositSelectedChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deposit-label'},'A deposit of',this.props.readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Number__["a" /* default */],{className:'deposit-cost-read-only',value:this.props.depositCost,format:'$0,0'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__["a" /* default */],{type:'number',value:this.props.depositCost||'',readOnly:!this.props.depositSelected,onChange:this.handleDepositCostChange}),'is required prior to the start of work'))));}}]);return DepositContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DepositContainer.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};DepositContainer.defaultProps={readOnly:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{depositSelected:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_proposal__["d" /* getDepositSelected */])(state),depositCost:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_proposal__["c" /* getDepositCost */])(state)};})(DepositContainer));

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return qualificationsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_qualification_type_enum__ = __webpack_require__(326);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QualificationsApi=function(_BaseApi){_inherits(QualificationsApi,_BaseApi);function QualificationsApi(){_classCallCheck(this,QualificationsApi);return _possibleConstructorReturn(this,(QualificationsApi.__proto__||Object.getPrototypeOf(QualificationsApi)).apply(this,arguments));}_createClass(QualificationsApi,[{key:'getQualifications',/**
   * Get qualifications
   * @param defaults: boolean (optional)
   * @return {Promise<{ok: boolean, proposal: any} | {ok: boolean, errors: *}>}
   */value:function getQualifications(defaults){var defaultFilter='';if(defaults!==undefined&&defaults){defaultFilter='?default=true';}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/qualifications'+defaultFilter).then(function(response){return{ok:true,qualifications:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}/**
   *
   * @param type: QualificationTypeEnum
   * @param trade
   * @param label
   * @return {Promise<{ok: boolean, qualifications: any} | {ok: boolean, errors: *}>}
   */},{key:'searchQualifications',value:function searchQualifications(type,trade,label){if(type===undefined){throw new Error('Qualification type is required');}if(label===undefined){throw new Error('Qualification label is required');}if(type===__WEBPACK_IMPORTED_MODULE_2__domain_qualification_type_enum__["a" /* QualificationTypeEnum */].TRADE&&trade===undefined){throw new Error('Qualification trade is required');}var filter='';switch(type){case __WEBPACK_IMPORTED_MODULE_2__domain_qualification_type_enum__["a" /* QualificationTypeEnum */].GENERAL:filter=filter+'?general=true&by_label='+label;break;case __WEBPACK_IMPORTED_MODULE_2__domain_qualification_type_enum__["a" /* QualificationTypeEnum */].TRADE:filter=filter+'?by_trade='+trade+'&by_label='+label;break;case __WEBPACK_IMPORTED_MODULE_2__domain_qualification_type_enum__["a" /* QualificationTypeEnum */].OTHER:filter=filter+'?other=true&by_label='+label;break;default:}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/qualifications'+filter,{loadingDisabled:true}).then(function(response){return{ok:true,qualifications:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}/**
   *
   * @param values: object {"type": string,"trade": number | undefined, "label": string, "options":[string]}"
   * @return {Promise<{ok: boolean, proposal: any} | {ok: boolean, errors: *}>}
   */},{key:'createQualification',value:function createQualification(values){var data={qualification:{q_type:values.type,trade_id:values.trade,default:false,label:values.label,options:values.options}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/qualifications',data).then(function(response){return{ok:true,qualification:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return QualificationsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var qualificationsApi=new QualificationsApi();

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewProposalForm_css__ = __webpack_require__(2179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewProposalForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NewProposalForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_proposals_ProposalQuote__ = __webpack_require__(2180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_admin_work_orders_details_proposal__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_work_orders_details_change_orders_store_actions__ = __webpack_require__(183);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewProposalForm=function(_Component){_inherits(NewProposalForm,_Component);function NewProposalForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewProposalForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewProposalForm.__proto__||Object.getPrototypeOf(NewProposalForm)).call.apply(_ref,[this].concat(args))),_this),_this.handleCompletionDateChange=function(date){if(_this.props.isChangeOrder){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_work_orders_details_change_orders_store_actions__["u" /* updateCOCompletionDate */])(date));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_work_orders_details_proposal__["w" /* updateCompletionDate */])(date));}},_this.handleStartDateChange=function(date){if(_this.props.isChangeOrder){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_work_orders_details_change_orders_store_actions__["v" /* updateCOStartDate */])(date));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_work_orders_details_proposal__["y" /* updateStartDate */])(date));}},_this.validateCompletionDate=function(date){if(_this.props.startDate!==undefined&&_this.props.startDate!==null){return date.isAfter(__WEBPACK_IMPORTED_MODULE_8_moment___default()(_this.props.startDate));}else{return Object(__WEBPACK_IMPORTED_MODULE_5_services_utils_date_util__["k" /* todayValidation */])(date);}},_this.renderTotal=function(className,label,total){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,total>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Number__["a" /* default */],{value:total,format:'$0,0'}):'TBD'))));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewProposalForm,[{key:'render',value:function render(){var total=0;var props=this.props;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'new-proposal-form'},props.items.map(function(item){total+=__WEBPACK_IMPORTED_MODULE_7_numeral___default()(item.amount).value()+__WEBPACK_IMPORTED_MODULE_7_numeral___default()(item.value).value();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:item.id,className:'npf-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_proposals_ProposalQuote__["a" /* default */],{itemId:item.id,amount:item.amount,value:item.value,contractor:item.contractorName,showValues:true,taskNumber:item.task.number,taskTrade:item.task.name!==null?item.task.name:item.task.trade.label,values:item.values,isChangeOrder:props.isChangeOrder}));}),props.isChangeOrder?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'npf-total'},this.renderTotal('cost','CHANGE ORDER AMOUNT',0),this.renderTotal('cost','PREVIOUS CONTRACT AMOUNT',this.props.previousCost),this.renderTotal('total','NEW CONTRACT AMOUNT',0)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'npf-total'},this.renderTotal('cost','COST',total),this.renderTotal('total','TOTAL',0)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'npf-date-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Start Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{format:'M/D/YYYY',isValidDate:__WEBPACK_IMPORTED_MODULE_5_services_utils_date_util__["k" /* todayValidation */],placeholder:'',readOnly:false,value:props.startDate,onChange:this.handleStartDateChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'npf-date-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Completion Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{format:'M/D/YYYY',isValidDate:this.validateCompletionDate,placeholder:'',readOnly:false,value:props.completionDate,onChange:this.handleCompletionDateChange})));}}]);return NewProposalForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NewProposalForm.propTypes={completionDate:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,items:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,amount:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number]).isRequired,value:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number]),contractorName:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,task:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape.isRequired,values:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape({fee:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number]),insurance:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number]),markup:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number])})})),startDate:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired};NewProposalForm.defaultProps={items:[]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(NewProposalForm));

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__QuoteDetailsModal_css__ = __webpack_require__(2187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__QuoteDetailsModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__QuoteDetailsModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_dropdown_SearchableDropDownPaginated__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_api_contractors_api__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_details_DetailsInfoItem__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_modal_MessageModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QuoteDetailsModal=function(_Component){_inherits(QuoteDetailsModal,_Component);function QuoteDetailsModal(props){_classCallCheck(this,QuoteDetailsModal);var _this=_possibleConstructorReturn(this,(QuoteDetailsModal.__proto__||Object.getPrototypeOf(QuoteDetailsModal)).call(this,props));_initialiseProps.call(_this);_this.state=_this.initializeState(props);return _this;}_createClass(QuoteDetailsModal,[{key:'render',value:function render(){var _this2=this;var _state=this.state,readOnly=_state.readOnly,negotiate=_state.negotiate,negotiateSuccess=_state.negotiateSuccess,estimate=_state.estimate,counter=_state.counter,value=_state.value;var readOnlyButtons=readOnly&&!negotiate;var workOrderTitle='WO #'+this.props.workOrder.number;if(this.props.workOrder.name!==null){workOrderTitle+=': '+this.props.workOrder.name;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_modal_FormModal__["a" /* default */],{className:'quote-details-modal',show:this.props.show,title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title-task'},'Task # ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__["a" /* default */],{value:this.props.quote.task.number,format:'00'}),': ',this.props.quote.task.trade.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title-wo'},'(',workOrderTitle,')')),onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'task-wo-details-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[this.props.quote.contractor_name],title:'CONTRACTOR'})),!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[],title:'CONTRACTOR'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'drop-down-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_dropdown_SearchableDropDownPaginated__["a" /* default */],{clearable:true,loadOptions:function loadOptions(input,page){return QuoteDetailsModal.loadContractors(_this2.props.quote.task.trade.id,input,page);},value:this.state.contractor,onChange:this.handleContractorSelect,placeholder:'Select Subcontractor',autoload:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[this.props.workOrder.building.location.street_address_1,this.props.workOrder.building.location.city+', '+this.props.workOrder.building.location.state+' '+this.props.workOrder.building.location.zip,this.props.workOrder.building.name!==''&&this.props.workOrder.building.name!==null?this.props.workOrder.building.name:''],title:'BUILDING'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:this.props.workOrder.working_hours,title:'AVAILABLE WORKING HOURS'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[this.props.quote.task.description],title:'DESCRIPTION'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'images-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_image_upload_ImageUpload__["a" /* default */],{images:this.props.taskImages,readOnly:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quotes-details-container'},this.props.quote.start_date!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote start-date'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Start Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Date__["a" /* default */],{value:this.props.quote.start_date,format:'M/D/YYYY'}))),this.props.quote.days_of_duration!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Duration'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_15_numeral___default()(this.props.quote.days_of_duration).format('0.[0]')+' '+(this.props.quote.days_of_duration>1?'days':'day'))),this.props.quote.material_lead_days!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Material Lead Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_15_numeral___default()(this.props.quote.material_lead_days).format('0.[0]')+' '+(this.props.quote.material_lead_days>1?'days':'day'))),this.props.quote.task.completion_date!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Task Completion Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Date__["a" /* default */],{value:this.props.quote.task.completion_date,format:'M/D/YYYY'}))),this.props.quote.end_date!==null&&this.props.quote.task.completion_date!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Contractor Completion Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.getJobCompletionDiff()!==0?''+(this.getJobCompletionDiff()>0?'+':'')+this.getJobCompletionDiff()+' days from task completion date':'Same as task completion date')),readOnly&&this.props.quote.estimate!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote cost'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Cost'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__["a" /* default */],{value:estimate,format:'$ 0'}))),!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote cost'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Cost'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_input_Input__["a" /* default */],{id:'quote-estimate',onChange:this.handleEstimateChange,value:estimate,theme:'normal'}))),!negotiate&&this.props.quote.counter&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote cost'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Counter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__["a" /* default */],{value:counter,format:'$ 0'}))),negotiate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote cost'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Counter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_input_Input__["a" /* default */],{id:'quote-counter',onChange:this.handleCounterChange,value:counter,theme:'normal'}))),readOnly&&this.props.quote.estimate!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote cost'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__["a" /* default */],{value:value,format:'$ 0'}))),!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote cost'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_input_Input__["a" /* default */],{id:'quote-value',onChange:this.handleValueChange,value:value,theme:'normal'}))),this.props.quote.estimate!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote cost'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.quote.status==='received'&&this.props.quote.counter_status==='negotiating'||negotiate?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__["a" /* default */],{value:__WEBPACK_IMPORTED_MODULE_15_numeral___default()(counter).value()+__WEBPACK_IMPORTED_MODULE_15_numeral___default()(value).value(),format:'$ 0'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__["a" /* default */],{value:__WEBPACK_IMPORTED_MODULE_15_numeral___default()(estimate).value()+__WEBPACK_IMPORTED_MODULE_15_numeral___default()(value).value(),format:'$ 0'}))),this.props.quote.description!==null&&this.props.quote.description!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.quote.description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.quote.status.charAt(0).toUpperCase()+this.props.quote.status.slice(1))),this.props.quote.denied_reason!==null&&this.props.quote.denied_reason!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote denied-reason'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Denied Reason'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.quote.denied_reason)),this.props.quote.submitted_on!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote submitted-date'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Quoted Submitted on',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Date__["a" /* default */],{value:this.props.quote.submitted_on,format:'M/D/YYYY'})))),this.props.onNegotiate&&this.props.onEdit&&this.props.onDelete&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},readOnlyButtons&&this.props.quote.status==='received'&&this.props.quote.contractor_id&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:'Negotiate',onClick:this.handleNegotiate}),readOnlyButtons&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Edit',onClick:this.handleEdit}),readOnlyButtons&&this.props.quote.status==='waiting'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{className:'btn button button-white',label:'Delete',onClick:this.onQuoteDeleteClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showDeleteConfirmation,message:'Are you sure you want to delete this quote?',onHide:this.handleDelete})),!readOnlyButtons&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{className:'btn button button-white',label:'Cancel',onClick:this.handleCancel}),negotiate?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{disabled:!counter,className:'btn button button-orange',label:'Submit',onClick:this.handleNegotiateSubmit}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{className:'btn button button-orange',label:'Save',onClick:this.handleSave}))),negotiateSuccess&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_modal_MessageModal__["a" /* default */],{show:this.state.negotiateSuccess,message:'Thank you. The counter offer was submitted to the Subcontractor.',onHide:this.handleNegotiateSuccessHide}));}},{key:'getJobCompletionDiff',value:function getJobCompletionDiff(){return __WEBPACK_IMPORTED_MODULE_14_moment___default()(this.props.quote.end_date).diff(__WEBPACK_IMPORTED_MODULE_14_moment___default()(this.props.quote.task.completion_date),'days');}}],[{key:'loadContractors',value:function loadContractors(tradeId,input,page){return __WEBPACK_IMPORTED_MODULE_5_services_api_contractors_api__["b" /* default */].searchContractors(input,[tradeId],[],null,page).then(function(response){if(response.ok){return{ok:true,options:response.contractors.map(function(element){return{value:element.id,label:element.name};})};}else{return{ok:false,errors:response.errors};}});}}]);return QuoteDetailsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);QuoteDetailsModal.propTypes={quote:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,show:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,taskImages:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,workOrder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,onNegotiate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onEdit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onDelete:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};QuoteDetailsModal.defaultProps={show:false};var _initialiseProps=function _initialiseProps(){var _this3=this;this.initializeState=function(props){var quote=props.quote;return{readOnly:true,negotiate:false,negotiateSuccess:false,estimate:quote.estimate||'',counter:quote.counter||'',value:quote.value||'',contractor:quote.contractor_id?{value:quote.contractor_id,label:quote.contractor_name}:null,showDeleteConfirmation:false};};this.handleClose=function(event){event.preventDefault();_this3.props.onClose();};this.handleCancel=function(){_this3.setState(_this3.initializeState(_this3.props));};this.handleNegotiate=function(){_this3.setState({negotiate:true});};this.handleNegotiateSubmit=function(){_this3.setState({negotiate:false});_this3.props.onNegotiate(_this3.state.counter,_this3.handleNegotiateCallback);};this.handleNegotiateCallback=function(response){if(response.ok){_this3.setState({negotiateSuccess:true});}};this.handleNegotiateSuccessHide=function(){_this3.setState({negotiateSuccess:false});_this3.props.onClose();};this.handleSave=function(){var _state2=_this3.state,estimate=_state2.estimate,value=_state2.value,contractor=_state2.contractor;var contractorId=contractor?contractor.value:'';_this3.setState({readOnly:true});_this3.props.onEdit(estimate,value,contractorId);};this.handleEdit=function(event){_this3.setState({readOnly:false});};this.handleDelete=function(result){if(result){_this3.props.onDelete&&_this3.props.onDelete();_this3.props.onClose();}_this3.setState({showDeleteConfirmation:false});};this.onQuoteDeleteClick=function(){_this3.setState({showDeleteConfirmation:true});};this.handleEstimateChange=function(value){_this3.setState({estimate:value});};this.handleCounterChange=function(value){_this3.setState({counter:value});};this.handleValueChange=function(value){_this3.setState({value:value});};this.handleContractorSelect=function(option){_this3.setState({contractor:option});};};/* harmony default export */ __webpack_exports__["a"] = (QuoteDetailsModal);

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/add.cfa03ffc.svg";

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DeclineModal_css__ = __webpack_require__(2210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DeclineModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DeclineModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_modal_DeclineForm__ = __webpack_require__(2211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeclineModal=function(_Component){_inherits(DeclineModal,_Component);function DeclineModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DeclineModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeclineModal.__proto__||Object.getPrototypeOf(DeclineModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleOnSubmit=function(values){_this.props.onSubmit(Object.assign({},values,{reason:__WEBPACK_IMPORTED_MODULE_3_components_shared_modal_DeclineForm__["a" /* REASON_OPTIONS */][__WEBPACK_IMPORTED_MODULE_5_numeral___default()(values.reason).value()]}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DeclineModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["o" /* Modal */],{className:'decline-modal',show:this.props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["o" /* Modal */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_modal_DeclineForm__["b" /* default */],{onSubmit:this.handleOnSubmit})));}}]);return DeclineModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DeclineModal.propTypes={show:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,onSubmit:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired};DeclineModal.defaultProps={show:false};/* harmony default export */ __webpack_exports__["a"] = (DeclineModal);

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BudgetEmailModal_css__ = __webpack_require__(2222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BudgetEmailModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BudgetEmailModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_domain_work_order__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_email_EmailEditor__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_selectors_admin_work_orders_details_budget__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_budget__ = __webpack_require__(328);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BudgetEmailModal=function(_Component){_inherits(BudgetEmailModal,_Component);function BudgetEmailModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BudgetEmailModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BudgetEmailModal.__proto__||Object.getPrototypeOf(BudgetEmailModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_budget__["u" /* setShowEmailModal */])(false));},_this.handleAddCustomEmail=function(email){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_budget__["a" /* addEmail */])(email));},_this.handleToEmailRemove=function(email){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_budget__["n" /* removeEmail */])(email));},_this.handleAddUserEmail=function(email){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_budget__["a" /* addEmail */])(email));},_this.handleSend=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_budget__["o" /* sendEmail */])(_this.props.currentWorkOrder.id,_this.props.emails,_this.props.subject,_this.props.message)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_budget__["u" /* setShowEmailModal */])(false));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_budget__["h" /* initializeEmailValues */])(_this.props.currentWorkOrder.number,_this.props.currentWorkOrder.name,_this.props.currentWorkOrder.building.location,_this.props.users));}});},_this.handleSubjectConfirm=function(subject){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_budget__["q" /* setBudgetSubject */])(subject));},_this.handleMessageChange=function(message){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_budget__["p" /* setBudgetMessage */])(message));},_this.isSendButtonEnabled=function(){return _this.props.emails.length>0&&_this.props.subject!==''&&_this.props.message!=='';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BudgetEmailModal,[{key:'render',value:function render(){var woName=__WEBPACK_IMPORTED_MODULE_6_domain_work_order__["a" /* WorkOrder */].getName(this.props.currentWorkOrder);var title='Preliminary Estimate (WO #'+this.props.currentWorkOrder.number+(woName!==null?': '+woName:'')+')';return this.props.showEmailModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_modal_FormModal__["a" /* default */],{className:'budget-email-modal',show:this.props.showEmailModal,title:title,onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'budget-email-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_email_EmailEditor__["a" /* EmailEditor */],{toEmails:this.props.emails,message:this.props.message,subject:this.props.subject,usersEmail:this.props.users.map(function(user){return user.email;}),onCustomEmailAdd:this.handleAddCustomEmail,onMessageChange:this.handleMessageChange,onSubjectConfirm:this.handleSubjectConfirm,onToEmailRemove:this.handleToEmailRemove,onUserEmailAdd:this.handleAddUserEmail}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:!this.isSendButtonEnabled(),label:'Send',onClick:this.handleSend})))):null;}}]);return BudgetEmailModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),emails:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_work_orders_details_budget__["c" /* getEmails */])(state),message:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_work_orders_details_budget__["d" /* getMessage */])(state),showEmailModal:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_work_orders_details_budget__["i" /* getShowEmailModal */])(state),subject:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_work_orders_details_budget__["k" /* getSubject */])(state),users:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_work_orders_details_budget__["l" /* getUsers */])(state)};})(BudgetEmailModal));

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BudgetStatusKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BudgetTaskStatusKeys; });
var BudgetStatusKeys={WAITING:'waiting',APPROVED:'approved'};var BudgetTaskStatusKeys={APPROVED:'approved',DECLINED:'declined'};

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Contractor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_domain_quotes_status_enum__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Contractor=function(){function Contractor(){_classCallCheck(this,Contractor);}_createClass(Contractor,null,[{key:'getExtraCost',value:function getExtraCost(){var materials=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var time=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var vendorInvoices=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];// Add materials costs
var extraCost=materials.reduce(function(total,material){return total+__WEBPACK_IMPORTED_MODULE_1_numeral___default()(material.cost).value();},0);// Add time costs
extraCost=time.reduce(function(total,time){return total+(time.cost!==null?__WEBPACK_IMPORTED_MODULE_1_numeral___default()(time.cost).value():0);},extraCost);// Add vendor invoices costs
extraCost=vendorInvoices.reduce(function(total,invoice){return total+__WEBPACK_IMPORTED_MODULE_1_numeral___default()(invoice.cost).value();},extraCost);return extraCost;}},{key:'getNetCost',value:function getNetCost(){var quotes=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var changeOrderTasks=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var materials=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var time=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];var vendorInvoices=arguments.length>4&&arguments[4]!==undefined?arguments[4]:[];var totalCost=Contractor.getTotalCost(quotes,changeOrderTasks,true);var extraCost=Contractor.getExtraCost(materials,time,vendorInvoices);return totalCost-extraCost;}/**
   * Get total costs of Contractor, given if the quotes should be approved or not.
   * @param quotes
   * @param approved
   * @return {*}
   */},{key:'getTotalCost',value:function getTotalCost(){var quotes=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var changeOrderTasks=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var approved=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var totalCost=quotes.filter(function(quote){var status=quote.status!==__WEBPACK_IMPORTED_MODULE_0_domain_quotes_status_enum__["a" /* QuotesStatusKeys */].WITHDRAWN&&quote.status!==__WEBPACK_IMPORTED_MODULE_0_domain_quotes_status_enum__["a" /* QuotesStatusKeys */].WAITING;if(status&&approved){status=status&&quote.status===__WEBPACK_IMPORTED_MODULE_0_domain_quotes_status_enum__["a" /* QuotesStatusKeys */].APPROVED;}return status;}).reduce(function(total,quote){return total+Math.round(quote.estimate);},0);totalCost+=changeOrderTasks.filter(function(cot){return cot.status===__WEBPACK_IMPORTED_MODULE_0_domain_quotes_status_enum__["a" /* QuotesStatusKeys */].APPROVED||cot.status===__WEBPACK_IMPORTED_MODULE_0_domain_quotes_status_enum__["a" /* QuotesStatusKeys */].ACR;}).reduce(function(total,cot){return total+Math.round(cot.change_order_quote.estimate);},0);return totalCost;}},{key:'getVariancePercentage',value:function getVariancePercentage(){var quotes=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var changeOrderTasks=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var materials=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var time=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];var vendorInvoices=arguments.length>4&&arguments[4]!==undefined?arguments[4]:[];var totalCost=Contractor.getTotalCost(quotes,changeOrderTasks,true);var extraCost=Contractor.getExtraCost(materials,time,vendorInvoices);return(totalCost-extraCost)/totalCost;}}]);return Contractor;}();

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FormInput;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_time_picker_TimePicker__ = __webpack_require__(423);
/**
 * Wrapper for DateTime picker field used inside redux-form.
 * @param props
 * @return {*}
 * @constructor
 */function FormInput(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_time_picker_TimePicker__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));}

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Time=function(_Component){_inherits(Time,_Component);function Time(){_classCallCheck(this,Time);return _possibleConstructorReturn(this,(Time.__proto__||Object.getPrototypeOf(Time)).apply(this,arguments));}_createClass(Time,[{key:'render',value:function render(){var time=void 0;var tMoment=__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.props.value);if(tMoment.isValid()){time=__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(this.props.value).format(this.props.format?this.props.format:'hh:mm A');}else{time='Invalid time';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:this.props.className!==undefined?this.props.className:null},time);}}]);return Time;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Time.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,format:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Time);

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = module.exports = {};

/**
 * Loops through the collection and calls the callback for each element. if the callback returns truthy, the loop is broken and returns the same value.
 * @public
 * @param {*} collection The collection to loop through. Needs to have a length property set and have indices set from 0 to length - 1.
 * @param {function} callback The callback to be called for each element. The element will be given as a parameter to the callback. If this callback returns truthy, the loop is broken and the same value is returned.
 * @returns {*} The value that a callback has returned (if truthy). Otherwise nothing.
 */
utils.forEach = function(collection, callback) {
    for(var i = 0; i < collection.length; i++) {
        var result = callback(collection[i]);
        if(result) {
            return result;
        }
    }
};


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var detector = module.exports = {};

detector.isIE = function(version) {
    function isAnyIeVersion() {
        var agent = navigator.userAgent.toLowerCase();
        return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
    }

    if(!isAnyIeVersion()) {
        return false;
    }

    if(!version) {
        return true;
    }

    //Shamelessly stolen from https://gist.github.com/padolsey/527683
    var ieVersion = (function(){
        var undef,
            v = 3,
            div = document.createElement("div"),
            all = div.getElementsByTagName("i");

        do {
            div.innerHTML = "<!--[if gt IE " + (++v) + "]><i></i><![endif]-->";
        }
        while (all[0]);

        return v > 4 ? v : undef;
    }());

    return version === ieVersion;
};

detector.isLegacyOpera = function() {
    return !!window.opera;
};


/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_react_fontawesome__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_free_solid_faExclamationTriangle__ = __webpack_require__(2291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_free_solid_faExclamationTriangle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_free_solid_faExclamationTriangle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuildingDocumentsViewer_css__ = __webpack_require__(2292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuildingDocumentsViewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BuildingDocumentsViewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DocumentLink__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BuildingDocumentsViewer=function(_Component){_inherits(BuildingDocumentsViewer,_Component);function BuildingDocumentsViewer(){_classCallCheck(this,BuildingDocumentsViewer);return _possibleConstructorReturn(this,(BuildingDocumentsViewer.__proto__||Object.getPrototypeOf(BuildingDocumentsViewer)).apply(this,arguments));}_createClass(BuildingDocumentsViewer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'building-documents-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'INSURANCE & BUILDING REGULATIONS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__fortawesome_react_fontawesome__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_free_solid_faExclamationTriangle___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.props.documents.map(function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:element.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DocumentLink__["a" /* default */],{url:element.document.url}));})));}}]);return BuildingDocumentsViewer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BuildingDocumentsViewer.propTypes={documents:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any).isRequired};/* harmony default export */ __webpack_exports__["a"] = (BuildingDocumentsViewer);

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NoteEditor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NoteEditor_css__ = __webpack_require__(2294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NoteEditor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NoteEditor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_text_SimpleTruncate__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_text_Date__ = __webpack_require__(25);
function NoteEditor(props){var handleClick=function handleClick(){if(props.edit){if(props.onSave){props.onSave();}}else{if(props.onEdit){props.onEdit();}}};var handleChange=function handleChange(value){if(props.onValueChange){props.onValueChange(value);}};var handleReminderValueChange=function handleReminderValueChange(value){if(props.onReminderValueChange){props.onReminderValueChange(value);}};var buttonLabel=void 0;if(props.edit){if(props.saving){buttonLabel='Saving...';}else{buttonLabel='Save';}}else{buttonLabel=props.editButtonLabel;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'note-editor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-bold ne-label'},props.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ne-row'},props.edit&&!props.saving?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_TextArea__["a" /* default */],{readOnly:props.saving,value:props.value,onChange:handleChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reminder-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-bold ne-label'},props.reminderLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{placeholder:'Reminder Date',value:props.reminderValue,isValidDate:__WEBPACK_IMPORTED_MODULE_7_services_utils_date_util__["k" /* todayValidation */],onChange:function onChange(value){return handleReminderValueChange(value);}}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-regular'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_SimpleTruncate__["a" /* default */],{shownLines:props.lines,text:props.value})),props.reminderOriginalValue&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reminder-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-bold ne-label'},props.reminderLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Date__["a" /* default */],{format:'LL',value:props.reminderOriginalValue}))),props.canEdit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:props.saving,label:buttonLabel,onClick:handleClick}))));}NoteEditor.propTypes={editButtonLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,canEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,edit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,lines:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,reminderLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,reminderOriginalValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,reminderValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,saving:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onReminderValueChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSave:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onValueChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};NoteEditor.defaultProps={editButtonLabel:'Edit',canEdit:true,edit:false,lines:3,reminderLabel:'',saving:false};

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRANSFER_WORK_ORDER_CLIENT_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRANSFER_WORK_ORDER_MESSAGE_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRANSFER_WORK_ORDER_MODAL_SHOW; });
var TRANSFER_WORK_ORDER_CLIENT_SELECT='TRANSFER_WORK_ORDER_CLIENT_SELECT';var TRANSFER_WORK_ORDER_MESSAGE_MODAL_SHOW='TRANSFER_WORK_ORDER_MESSAGE_MODAL_SHOW';var TRANSFER_WORK_ORDER_MODAL_SHOW='TRANSFER_WORK_ORDER_MODAL_SHOW';

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SubTechniciansApi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubTechniciansApi=function(_BaseApi){_inherits(SubTechniciansApi,_BaseApi);function SubTechniciansApi(){_classCallCheck(this,SubTechniciansApi);return _possibleConstructorReturn(this,(SubTechniciansApi.__proto__||Object.getPrototypeOf(SubTechniciansApi)).apply(this,arguments));}_createClass(SubTechniciansApi,[{key:'getTechnicians',value:function getTechnicians(page,name){var address=name?this.baseUrl+'/sub_technicians?page='+page+'&by_name='+name:this.baseUrl+'/sub_technicians?page='+page;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(address).then(function(response){return{ok:true,technicians:response.data,perPage:response.headers['per-page'],total:response.headers.total};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'addTechnician',value:function addTechnician(data){var resultData=this.createAddEditTechnicianData(data);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/sub_technicians',resultData).then(function(response){return{ok:true,technician:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateTechnician',value:function updateTechnician(id,data){var resultData=this.createAddEditTechnicianData(data);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/sub_technicians/'+id,resultData).then(function(response){return{ok:true,technician:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'removeTechnician',value:function removeTechnician(id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/sub_technicians/'+id).then(function(){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createAddEditTechnicianData',value:function createAddEditTechnicianData(data){var resultData={sub_technician:{first_name:data.firstName,last_name:data.lastName||'',email:data.email||'',phone_number:data.phoneNumber||''}};return resultData;}}]);return SubTechniciansApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (SubTechniciansApi=new SubTechniciansApi());

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initPagination;
/* harmony export (immutable) */ __webpack_exports__["b"] = setCurrentPage;
/* harmony export (immutable) */ __webpack_exports__["c"] = setPaginationPageSize;
/* harmony export (immutable) */ __webpack_exports__["d"] = setPaginationTotal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_shared_pagination_table_store_action_types__ = __webpack_require__(960);
function initPagination(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_shared_pagination_table_store_action_types__["b" /* PAGINATION_TABLE_INIT */]};}function setCurrentPage(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return{type:__WEBPACK_IMPORTED_MODULE_0_components_shared_pagination_table_store_action_types__["a" /* PAGINATION_TABLE_CURRENT_PAGE_SET */],payload:page};}function setPaginationPageSize(pageSize){return{type:__WEBPACK_IMPORTED_MODULE_0_components_shared_pagination_table_store_action_types__["c" /* PAGINATION_TABLE_PAGE_SIZE_SET */],payload:pageSize};}function setPaginationTotal(total){return{type:__WEBPACK_IMPORTED_MODULE_0_components_shared_pagination_table_store_action_types__["d" /* PAGINATION_TABLE_TOTAL_SET */],payload:total};}

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PAGINATION_TABLE_CURRENT_PAGE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PAGINATION_TABLE_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PAGINATION_TABLE_PAGE_SIZE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAGINATION_TABLE_TOTAL_SET; });
var PAGINATION_TABLE_CURRENT_PAGE_SET='PAGINATION_TABLE_CURRENT_PAGE_SET';var PAGINATION_TABLE_INIT='PAGINATION_TABLE_INIT';var PAGINATION_TABLE_PAGE_SIZE_SET='PAGINATION_TABLE_PAGE_SIZE_SET';var PAGINATION_TABLE_TOTAL_SET='PAGINATION_TABLE_TOTAL_SET';

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContractorDocumentsViewer_css__ = __webpack_require__(2336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContractorDocumentsViewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ContractorDocumentsViewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_document_DocumentLink__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorDocumentsViewer=function(_Component){_inherits(ContractorDocumentsViewer,_Component);function ContractorDocumentsViewer(){_classCallCheck(this,ContractorDocumentsViewer);return _possibleConstructorReturn(this,(ContractorDocumentsViewer.__proto__||Object.getPrototypeOf(ContractorDocumentsViewer)).apply(this,arguments));}_createClass(ContractorDocumentsViewer,[{key:'render',value:function render(){var contractor=this.props.contractor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contractor-documents-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'document-title'},'W9 DOCUMENT'),contractor.w9_document&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'document-links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_document_DocumentLink__["a" /* default */],{url:contractor.w9_document.document.url}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'document-title'},'MSA DOCUMENT'),contractor.msa_document&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'document-links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_document_DocumentLink__["a" /* default */],{url:contractor.msa_document.document.url}))));}}]);return ContractorDocumentsViewer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ContractorDocumentsViewer.propTypes={contractor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (ContractorDocumentsViewer);

/***/ }),
/* 962 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_select_SelectList__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContractorForm_css__ = __webpack_require__(2339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContractorForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ContractorForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_upload_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_upload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_remove_svg__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_remove_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_images_remove_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorForm=function(_Component){_inherits(ContractorForm,_Component);function ContractorForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ContractorForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ContractorForm.__proto__||Object.getPrototypeOf(ContractorForm)).call.apply(_ref,[this].concat(args))),_this),_this.title=function(){if(_this.props.needsConfirmation){return'Confirm your Information';}return _this.props.edit?'Edit Contractor':'Add a Contractor';},_this.filterState=function(){return _this.props.form.state!==null?_this.props.form.state:'';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ContractorForm,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contractor-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},this.title()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contractor-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left-side'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2'},'Company Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'details-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.props.edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Company Name','companyName')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('License Number','licenseNumber',this.props.needsConfirmation))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Company Name','companyName')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'details-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Contact First Name','firstName')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2},this.renderField('Contact Last Name','lastName'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Email','email')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2},this.renderField('Phone Number','phoneNumber'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Street Address','streetAddress')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2},this.renderField('Unit number / Floor','unitNumber'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('City','city')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('State','state')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Zip Code','zipCode')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2 radios-container'},'Specialities (Trades)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{tabIndex:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_select_SelectList__["a" /* default */],{showAs:'table',values:this.props.trades.map(function(element){return{id:element.id,value:element.label,selected:_this2.props.selectedTradesId.find(function(selected){return selected===element.id;})!==undefined};}),onSelect:this.props.onTradesSelection})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2 radios-container'},'Areas of Service'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{tabIndex:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_select_SelectList__["a" /* default */],{showAs:'table',values:this.props.serviceAreas.filter(function(element){return element.state===_this2.filterState();}).map(function(element){return{id:element.id,value:element.name,selected:_this2.props.selectedServiceAreasId.find(function(selected){return selected===element.id;})!==undefined};}),onSelect:this.props.onServiceAreaSelection})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2 radios-container'},'Which unions do you belong to?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{tabIndex:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_select_SelectList__["a" /* default */],{showAs:'table',values:this.props.unions.map(function(element){return{id:element.id,value:element.label,selected:_this2.props.selectedUnionsId.find(function(selected){return selected===element.id;})!==undefined};}).concat({id:'all',value:'All',selected:this.props.selectedUnionsId.length===this.props.unions.length}),onSelect:this.props.onUnionSelection})),this.props.validationMessage!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},this.props.validationMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-gray',type:'button',value:this.props.edit?'Save':'Only Add',onClick:this.props.onSubmit.bind(this,false)}),this.props.withInvitation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'button',value:this.props.edit?'Save and Send Invite':'Send Invite',onClick:this.props.onSubmit.bind(this,true)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-side'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2'},'W9 Document'),this.props.w9Document.document===''&&this.props.w9Document.url===''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body-bold files-title'},'Please drag and drop any file into this area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropzone-container'+(this.props.needsConfirmation&&!this.props.invalidFields.find(function(el){return el==='w9Document';})?' highlighted':'')+(this.props.invalidFields.find(function(el){return el==='w9Document';})?' dropzone-with-error':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx',className:'files-dropzone',multiple:false,onDrop:function onDrop(files){return _this2.props.onW9DocumentChange(files[0]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5_images_upload_svg___default.a,alt:'remove'})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'file-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_document_DocumentLink__["a" /* default */],{file:this.props.w9Document.document,url:this.props.w9Document.document===''?this.props.w9Document.url:null,showIcon:false,showLink:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8_images_remove_svg___default.a,alt:'remove',onClick:function onClick(){return _this2.props.onW9DocumentChange('');}})))));}},{key:'renderField',value:function renderField(placeholder,attribute){var highlighted=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var valid=this.props.invalidFields.find(function(element){return element===attribute;})===undefined;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_input_Input__["a" /* default */],{placeholder:placeholder,valid:valid,value:this.props.form[attribute],className:highlighted&&valid?'highlighted':'',onChange:this.props.onFormChange.bind(this,attribute)});}}]);return ContractorForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ContractorForm.propTypes={edit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,needsConfirmation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,form:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,invalidFields:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,serviceAreas:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,selectedServiceAreasId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,selectedTradesId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,selectedUnionsId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,w9Document:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,trades:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,unions:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,validationMessage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,withInvitation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,onFormChange:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onServiceAreaSelection:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onTradesSelection:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onUnionSelection:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onW9DocumentChange:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};ContractorForm.defaultProps={edit:false,needsConfirmation:false,form:{},invalidFields:[],selectedServiceAreasId:[],selectedTradesId:[],selectedUnionsId:[],serviceAreas:[],trades:[],unions:[],validationMessage:'',withInvitation:true};/* harmony default export */ __webpack_exports__["a"] = (ContractorForm);

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return surveysApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SurveysApi=function(_BaseApi){_inherits(SurveysApi,_BaseApi);function SurveysApi(){_classCallCheck(this,SurveysApi);return _possibleConstructorReturn(this,(SurveysApi.__proto__||Object.getPrototypeOf(SurveysApi)).apply(this,arguments));}_createClass(SurveysApi,[{key:'getSurvey',value:function getSurvey(surveyId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/surveys/'+surveyId).then(function(response){return{ok:true,survey:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getSurveys',value:function getSurveys(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var pending=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var url=this.baseUrl+'/surveys?page='+page;if(pending!==null){url+='&pending='+pending;}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function(response){return{ok:true,surveys:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),totalPending:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-pending']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getClientSurveys',value:function getClientSurveys(clientId){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/clients/'+clientId+'/surveys?page='+page).then(function(response){return{ok:true,surveys:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateSurvey',value:function updateSurvey(surveyId,values){var apiPayload={survey:{response_time_sat:values.response_time_sat,work_quality_sat:values.work_quality_sat,recommend_spackle:values.recommend_spackle}};if(values.note!==null){apiPayload.survey.note=values.note;}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/surveys/'+surveyId,apiPayload).then(function(response){return{ok:true,survey:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return SurveysApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var surveysApi=new SurveysApi();

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Building; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Building=function(){function Building(){_classCallCheck(this,Building);}_createClass(Building,null,[{key:'getPrettyName',value:function getPrettyName(building){var withName=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return building.location.street_address_1+', '+building.location.city+', '+building.location.state+'       '+building.location.zip+(withName&&building.name!==null&&building.name!==''?' - '+building.name:'');}}]);return Building;}();

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SurveysTable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SurveysTable_css__ = __webpack_require__(2361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SurveysTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SurveysTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_text_SimpleText__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_surveys_SurveyRating__ = __webpack_require__(597);
function mapSurveys(surveys,showClient){return surveys.map(function(survey){return[survey.work_order.number,showClient?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'client-name'},survey.work_order.client.company_name):undefined,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_SimpleText__["a" /* default */],{lines:[survey.work_order.building.location.street_address_1,survey.work_order.building.location.city]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_surveys_SurveyRating__["a" /* default */],{rating:survey.rating}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__["a" /* default */],{value:survey.work_order.started_at,format:'ll'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__["a" /* default */],{value:survey.work_order.completed_at,format:'ll'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Number__["a" /* default */],{value:survey.work_order.approved_proposal.cost,format:'$0,0'}),survey.work_order.approved_proposal.variance!==null?survey.work_order.approved_proposal.variance+'%':'N/A'].filter(function(notNull){return notNull;});});}function SurveysTable(props){var classNames=['surveys-table'];var headers=['WO #'];if(props.showClient){classNames.push('with-client');headers.push('CLIENT NAME');}headers=headers.concat(['LOCATION','STATUS','START DATE','END DATE','WO AMOUNT','VARIANCE']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__["a" /* default */],{className:classNames.join(' '),headers:headers,emptyMessage:'No Surveys yet!',rows:mapSurveys(props.surveys,props.showClient),onRowSelected:props.onRowSelected,onGenerateLink:props.onGenerateLink});}SurveysTable.propTypes={showClient:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,surveys:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),onRowSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onGenerateLink:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};SurveysTable.defaultProps={surveys:[]};

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serviceProvidersApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ServiceProvidersApi=function(_BaseApi){_inherits(ServiceProvidersApi,_BaseApi);function ServiceProvidersApi(){_classCallCheck(this,ServiceProvidersApi);return _possibleConstructorReturn(this,(ServiceProvidersApi.__proto__||Object.getPrototypeOf(ServiceProvidersApi)).apply(this,arguments));}_createClass(ServiceProvidersApi,[{key:'getServiceProviders',value:function getServiceProviders(type,byName,page){var loadingDisabled=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;var queryString='type='+type+'&page='+(page||1);if(byName){queryString+='&by_name='+byName;}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/service_providers?'+queryString,{loadingDisabled:loadingDisabled}).then(function(response){return{ok:true,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value(),serviceProviders:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'showServiceProviderById',value:function showServiceProviderById(type,id){var loadingDisabled=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var queryString='type='+type;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/service_providers/'+id+'?'+queryString,{loadingDisabled:loadingDisabled}).then(function(response){return{ok:true,serviceProvider:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getServiceProviderUsers',value:function getServiceProviderUsers(type,serviceProviderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/service_providers/'+serviceProviderId+'/users?type='+type).then(function(response){return{ok:true,users:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createServiceProvider',value:function createServiceProvider(type,values){var data=this.serviceProviderParams(values);var headers={headers:{'Content-Type':'multipart/form-data'}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/service_providers?type='+type,data,headers).then(function(response){return{ok:true,serviceProvider:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateServiceProvider',value:function updateServiceProvider(type,id,values){var data=this.serviceProviderParams(values);var headers={headers:{'Content-Type':'multipart/form-data'}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/service_providers/'+id+'?type='+type,data,headers).then(function(response){return{ok:true,serviceProvider:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'editUser',value:function editUser(values){var data=this.userParams(values.type,values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/service_providers/'+values.accountableId+'/users/'+values.id,data).then(function(response){return{ok:true,updatedUser:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'deleteUser',value:function deleteUser(values){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/service_providers/'+values.accountableId+'/users/'+values.id+'?type='+values.type).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createServiceProviderDirectory',value:function createServiceProviderDirectory(type,values){var data=new FormData();data.append('type',type);data.append('service_provider[name]',values.name);data.append('service_provider[contact_attributes][first_name]',values.contact.firstName);data.append('service_provider[contact_attributes][last_name]',values.contact.lastName);data.append('service_provider[contact_attributes][email]',values.contact.email);data.append('service_provider[contact_attributes][phone_number]',values.contact.phoneNumber);data.append('service_provider[contact_attributes][phone_ext]',values.contact.phoneExt);data.append('service_provider[contact_attributes][title]',values.contact.title);if(values.image&&values.image.name&&values.image.preview){data.append('service_provider[logo_attributes][image]',values.image);}var headers={headers:{'Content-Type':'multipart/form-data'}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/service_providers',data,headers).then(function(response){return{ok:true,serviceProvider:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'inviteUser',value:function inviteUser(type,serviceProviderId,values){var data=this.userParams(type,values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/service_providers/'+serviceProviderId+'/invite_user',data).then(function(response){return{ok:true,user:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'sendInvite',value:function sendInvite(user){var id=user.id,accountable_id=user.accountable_id,accountable_type=user.accountable_type;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/service_providers/'+accountable_id+'/users/'+id+'/send_invite?type='+accountable_type).then(function(response){return{ok:true,user:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'activationLink',value:function activationLink(user){var id=user.id,accountable_id=user.accountable_id,accountable_type=user.accountable_type;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/service_providers/'+accountable_id+'/users/'+id+'/accept_invitation_url?type='+accountable_type).then(function(response){return{ok:true,instructions:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'serviceProviderParams',value:function serviceProviderParams(values){var data=new FormData();if(values.name!==undefined){data.append('service_provider[name]',values.name);if(values.contactId){data.append('service_provider[contact_attributes][id]',values.contactId);}data.append('service_provider[contact_attributes][first_name]',values.firstName);data.append('service_provider[contact_attributes][last_name]',values.lastName);data.append('service_provider[contact_attributes][email]',values.email);data.append('service_provider[contact_attributes][phone_number]',values.phoneNumber);if(values.locationId){data.append('service_provider[location_attributes][id]',values.locationId);}data.append('service_provider[location_attributes][street_address_1]',values.streetAddress);data.append('service_provider[location_attributes][street_address_2]',values.unitNumber||'');data.append('service_provider[location_attributes][city]',values.city);data.append('service_provider[location_attributes][state]',values.state);data.append('service_provider[location_attributes][zip]',values.zipCode);}if(values.logo){if(values.logo.id){data.append('service_provider[logo_attributes][id]',values.logo.id);}if(values.logo.destroy){data.append('service_provider[logo_attributes][_destroy]',true);}else if(values.logo.file){var file=values.logo.file;data.append('service_provider[logo_attributes][image]',file,file.name);}}if(values.stamp){var stamp=values.stamp;if(stamp.id){data.append('service_provider[stamp_attributes][id]',stamp.id);}if(stamp.destroy){data.append('service_provider[stamp_attributes][_destroy]',true);}else{data.append('service_provider[stamp_attributes][legal]',stamp.legal);stamp.stampActions&&stamp.stampActions.forEach(function(stampAction,index){if(stampAction.id){data.append('service_provider[stamp_attributes][stamp_actions_attributes]['+index+'][id]',stampAction.id);}if(stampAction.destroy){data.append('service_provider[stamp_attributes][stamp_actions_attributes]['+index+'][_destroy]',stampAction.destroy);}else{data.append('service_provider[stamp_attributes][stamp_actions_attributes]['+index+'][action]',stampAction.action);data.append('service_provider[stamp_attributes][stamp_actions_attributes]['+index+'][title]',stampAction.title);data.append('service_provider[stamp_attributes][stamp_actions_attributes]['+index+'][subtitle]',stampAction.subtitle||'');}});}}return data;}},{key:'userParams',value:function userParams(type,values){return{type:type,user:{first_name:values.firstName,last_name:values.lastName,email:values.email,phone_number:values.phoneNumber,phone_ext:values.phoneExt,title:values.title}};}}]);return ServiceProvidersApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var serviceProvidersApi=new ServiceProvidersApi();

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_SERVICE_PROVIDER_DROPDOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_CURRENT_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_SERVICE_PROVIDER_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_TOTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_NAME_TO_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_SERVICE_PROVIDER_USER_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_COMPANY_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_CURRENT_USER_COMPANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SERVICE_PROVIDERS_INVITE_USER_FORM_LOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SERVICE_PROVIDERS_INVITE_USER_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SERVICE_PROVIDERS_INVITE_USER_ID_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SERVICE_PROVIDERS_SHOW_CONFIRMATION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SERVICE_PROVIDERS_CLEAR_FILTERS; });
var SET_SERVICE_PROVIDER_DROPDOWN='SET_SERVICE_PROVIDER_DROPDOWN';var SET_CURRENT_PAGE='SET_CURRENT_PAGE';var SET_SERVICE_PROVIDER_DATA='SET_SERVICE_PROVIDER_DATA';var SET_TOTAL='SET_TOTAL';var SET_PAGE_SIZE='SET_PAGE_SIZE';var SET_NAME_TO_SEARCH='SET_NAME_TO_SEARCH';var SET_SERVICE_PROVIDER_USER_DATA='SET_SERVICE_PROVIDER_USER_DATA';var SET_COMPANY_DATA='SET_COMPANY_DATA';var SET_CURRENT_USER_COMPANY='SET_CURRENT_USER_COMPANY';var SERVICE_PROVIDERS_INVITE_USER_FORM_LOAD='SERVICE_PROVIDERS_INVITE_USER_FORM_LOAD';var SERVICE_PROVIDERS_INVITE_USER_MODAL_SHOW='SERVICE_PROVIDERS_INVITE_USER_MODAL_SHOW';var SERVICE_PROVIDERS_INVITE_USER_ID_SET='SERVICE_PROVIDERS_INVITE_USER_ID_SET';var SERVICE_PROVIDERS_SHOW_CONFIRMATION_MODAL='SERVICE_PROVIDERS_SHOW_CONFIRMATION_MODAL';var SERVICE_PROVIDERS_CLEAR_FILTERS='SERVICE_PROVIDERS_CLEAR_FILTERS';

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_service_providers_ServiceProvidersDetails_css__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_service_providers_ServiceProvidersDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_admin_service_providers_ServiceProvidersDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_details_DetailsHeader__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_contractors_ContractorStatus__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_details_DetailsInfo__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_details_DetailsInfoItem__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_service_providers_store_selectors__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_logo_upload_LogoUpload__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_service_providers_store_actions__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_domain_service_provider_type_enum__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_service_providers_UserTable__ = __webpack_require__(2376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_shared_stamp_StampDetails__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__fortawesome_react_fontawesome__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__fortawesome_fontawesome_free_solid_faAngleDown__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__fortawesome_fontawesome_free_solid_faAngleDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__fortawesome_fontawesome_free_solid_faAngleDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__fortawesome_fontawesome_free_solid_faAngleUp__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__fortawesome_fontawesome_free_solid_faAngleUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__fortawesome_fontawesome_free_solid_faAngleUp__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ServiceProvidersDetails=function(_Component){_inherits(ServiceProvidersDetails,_Component);function ServiceProvidersDetails(props){_classCallCheck(this,ServiceProvidersDetails);var _this=_possibleConstructorReturn(this,(ServiceProvidersDetails.__proto__||Object.getPrototypeOf(ServiceProvidersDetails)).call(this,props));_this.handleEdit=function(){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_service_providers_store_actions__["g" /* goToEditServiceProvider */])(_this.typeUrl,_this.serviceProviderId));};_this.handleUserSelection=function(index){var _this$props=_this.props,dispatch=_this$props.dispatch,users=_this$props.users;dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_service_providers_store_actions__["q" /* setCurrentUserId */])(users[index].id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_service_providers_store_actions__["o" /* loadUserForm */])(users[index]));dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_service_providers_store_actions__["u" /* setShowEditUserModal */])(true));};_this.handleShowStamp=function(){_this.setState({showStamp:!_this.state.showStamp});};_this.handleCloseEditUserModal=function(){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_service_providers_store_actions__["u" /* setShowEditUserModal */])(false));};_this.handleInviteClient=function(){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_service_providers_store_actions__["c" /* clearUserData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_service_providers_store_actions__["u" /* setShowEditUserModal */])(true));};_this.handleEditUserOnSubmit=function(values){var _this$props2=_this.props,dispatch=_this$props2.dispatch,companyData=_this$props2.companyData,user=_this$props2.user;if(user){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_service_providers_store_actions__["f" /* editUser */])(values,companyData.type,companyData.id));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_service_providers_store_actions__["k" /* inviteUser */])(values,companyData.type,companyData.id));}};_this.handleDeleteEditUserModal=function(response){var _this$props3=_this.props,user=_this$props3.user,dispatch=_this$props3.dispatch,companyData=_this$props3.companyData;if(response){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_service_providers_store_actions__["e" /* deleteUser */])(user,companyData.type,companyData.id));}dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_service_providers_store_actions__["t" /* setShowConfirmationModal */])(false));};_this.handleShowConfirmationDelete=function(){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_service_providers_store_actions__["t" /* setShowConfirmationModal */])(true));};_this.mapServiceProviders=function(serviceProviders){return serviceProviders.map(function(serviceProvider){return[serviceProvider.first_name!==null?serviceProvider.first_name+' '+serviceProvider.last_name:'N/A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},serviceProvider.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_contractors_ContractorStatus__["a" /* default */],{status:serviceProvider.status}),serviceProvider.email!==null?serviceProvider.email:'N/A',''+Object(__WEBPACK_IMPORTED_MODULE_10_services_utils_text_util__["c" /* formatPhoneNumber */])(serviceProvider.phone_number)+(serviceProvider.phone_ext?' ext '+serviceProvider.phone_ext:'')];});};var match=_this.props.match;_this.type=match?__WEBPACK_IMPORTED_MODULE_14_domain_service_provider_type_enum__["b" /* ServiceProviderOptionsUrlToValues */].get(match.params.type):props.type;_this.typeUrl=match?match.params.type:props.type;_this.serviceProviderId=match?match.params.id:props.id;_this.state={showStamp:false};return _this;}_createClass(ServiceProvidersDetails,[{key:'componentDidUpdate',value:function componentDidUpdate(){Object(__WEBPACK_IMPORTED_MODULE_12_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}},{key:'componentDidMount',value:function componentDidMount(){var dispatch=this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_service_providers_store_actions__["l" /* loadServiceProviderById */])(this.type,this.serviceProviderId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_service_providers_store_actions__["n" /* loadServiceProvidersUser */])(this.type,this.serviceProviderId));}},{key:'render',value:function render(){var detailsInfoItems=[];var _props=this.props,companyData=_props.companyData,users=_props.users;if(companyData){if(companyData.location){detailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[companyData.location.street_address_1,companyData.location.city+', '+companyData.location.state+' '+companyData.location.zip],title:'ADDRESS'}));}detailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'general-contractor-name'},companyData.contact.first_name+' '+companyData.contact.last_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'general-contractor-email',href:'mailto:'+companyData.contact.email},companyData.contact.email),Object(__WEBPACK_IMPORTED_MODULE_10_services_utils_text_util__["c" /* formatPhoneNumber */])(companyData.contact.phone_number)],title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'PRIMARY CONTACT'))}));var showStamp=this.state.showStamp;detailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Collapse */],{'in':showStamp,className:'collapse-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_shared_stamp_StampDetails__["a" /* default */],{companyName:companyData.name,companyLogo:companyData.logo,stamp:companyData.stamp,value:'approved'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'})))],title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-info-item-stamp',onClick:this.handleShowStamp},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'STAMP'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__fortawesome_react_fontawesome__["a" /* default */],{icon:showStamp?__WEBPACK_IMPORTED_MODULE_19__fortawesome_fontawesome_free_solid_faAngleUp___default.a:__WEBPACK_IMPORTED_MODULE_18__fortawesome_fontawesome_free_solid_faAngleDown___default.a})))}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'service-provider-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['COMPANY',companyData.name.toUpperCase()]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_details_DetailsHeader__["a" /* default */],{leftHeader:{title:'COMPANY',value:companyData.name},leftHeaderExtraComponents:companyData.logo&&companyData.logo.image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-preview-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_logo_upload_LogoUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],logos:[{preview:companyData.logo.image.url,url:companyData.logo.image.url}],readOnly:true})),rightHeaders:[[{title:'STATUS',value:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_contractors_ContractorStatus__["a" /* default */],{status:companyData.status})}]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-info-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_details_DetailsInfo__["a" /* default */],{itemsContainerSize:12,itemsLines:[detailsInfoItems]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edit-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-gray',value:'Edit',onClick:this.handleEdit}))),users&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_admin_service_providers_UserTable__["a" /* default */],{type:this.type}));}}]);return ServiceProvidersDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{companyData:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_service_providers_store_selectors__["a" /* getCompanyData */])(state),users:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_service_providers_store_selectors__["l" /* getUserList */])(state),user:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_service_providers_store_selectors__["k" /* getUserForm */])(state),showInviteUserModal:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_service_providers_store_selectors__["j" /* getShowInviteUserModal */])(state),showConfirmationDeleteModal:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_service_providers_store_selectors__["i" /* getShowConfirmationDeleteModal */])(state)};})(ServiceProvidersDetails));

/***/ }),
/* 970 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StampDetails_css__ = __webpack_require__(2380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StampDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__StampDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_domain_stamp_options__ = __webpack_require__(2381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_radio_button_RadioButton__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_logo_upload_LogoUpload__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_square_empty_svg__ = __webpack_require__(2382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_square_empty_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_images_square_empty_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_square_full_svg__ = __webpack_require__(2383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_square_full_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_images_square_full_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StampDetails=function(_Component){_inherits(StampDetails,_Component);function StampDetails(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StampDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StampDetails.__proto__||Object.getPrototypeOf(StampDetails)).call.apply(_ref,[this].concat(args))),_this),_this.stampOptions=function(){var stamp=_this.props.stamp;return stamp?stamp.stamp_actions.map(function(stampAction){return{value:stampAction.action,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,stampAction.title),stampAction.subtitle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,stampAction.subtitle))};}):__WEBPACK_IMPORTED_MODULE_4_domain_stamp_options__["a" /* default */];},_this.handleChange=function(value){var onChange=_this.props.onChange;onChange&&onChange(value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StampDetails,[{key:'render',value:function render(){var _props=this.props,companyName=_props.companyName,companyLogo=_props.companyLogo,stamp=_props.stamp,value=_props.value,error=_props.error,readOnly=_props.readOnly;var logoExists=companyLogo&&companyLogo.image&&companyLogo.image.url;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stamp-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stamp-details-block stamp-details-header'},logoExists?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-preview-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_logo_upload_LogoUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],logos:[{preview:companyLogo.image.url,url:companyLogo.image.url}],readOnly:true})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stamp-details-company-name'},companyName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stamp-details-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SUBMITTAL REVIEW'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stamp-details-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_radio_button_RadioButton__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'stamp-details-action':true,'stamp-details-action-error':error}),orientation:'vertical',options:this.stampOptions(),value:value,readOnly:readOnly,emptyPng:__WEBPACK_IMPORTED_MODULE_7_images_square_empty_svg___default.a,fullPng:__WEBPACK_IMPORTED_MODULE_8_images_square_full_svg___default.a,fullPngReadOnly:__WEBPACK_IMPORTED_MODULE_8_images_square_full_svg___default.a,onChange:this.handleChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stamp-details-block stamp-details-legal'},stamp?stamp.legal:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,companyName||'General Contractor',' has reviewed this Submittal, but only for the purpose of checking for conformance with the design intent expressed in the Contract Documents.',' ',companyName||'General Contractor','\u2019s action on a specific',' ','item does not indicate approval of an assembly of which the item is a component, nor of an item as delivered and installed if it does not conform to the Contract Documents.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Contractor is responsible for checking for deviations between this Submittal and differing information or conditions in the Contract Documents and field conditions; for determining or substantiating the accuracy and completeness of other details such as dimensions and quantities; for substantiating instructions for installation or performance of equipment or systems designed by Contractor; for construction means, methods, techniques, schedules, sequences, procedures, and fabrication processes; for errors and omissions in Submittals; for coordination of the Work of the trades, safety precautions and performing the Work in a safe and satisfactory manner and in conformance with the Contract Documents.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If more than one submittal review stamp appears on this Submittal, the most stringent action and notations thereon apply. ',companyName||'General Contractor',' nor Spackle and its',' ','consultants, employees, contractors or agents have not reviewed work not within their respective professional discipline or scope of services.'))));}}]);return StampDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StampDetails.propTypes={companyName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,companyLogo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),stamp:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};StampDetails.defaultProps={companyName:'',companyLogo:null,stamp:null,value:'',error:false,readOnly:true,onChange:null};/* harmony default export */ __webpack_exports__["a"] = (StampDetails);

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_service_providers_store_selectors__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_service_providers_store_actions__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_domain_service_provider_type_enum__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_service_providers_ServiceProvidersEditForm__ = __webpack_require__(2384);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ServiceProvidersEdit=function(_Component){_inherits(ServiceProvidersEdit,_Component);function ServiceProvidersEdit(props){_classCallCheck(this,ServiceProvidersEdit);var _this=_possibleConstructorReturn(this,(ServiceProvidersEdit.__proto__||Object.getPrototypeOf(ServiceProvidersEdit)).call(this,props));_this.buildLogo=function(logo){if(logo&&logo.image&&logo.image.url){logo.url=logo.image.url;}return logo;};_this.buildLegal=function(companyName){return companyName+' has reviewed this Submittal,'+' but only for the purpose of checking for'+' conformance with the design intent expressed in the Contract Documents.'+(' '+companyName+'\u2019s action on a specific')+' item does not indicate approval of an assembly of'+' which the item is a component, nor of an item as delivered and installed if it does'+' not conform to the Contract Documents.'+'\n\n'+'Contractor is responsible for checking for deviations between this Submittal and'+' differing information or conditions in the Contract Documents and field conditions;'+' for determining or substantiating the accuracy and completeness of other details such'+' as dimensions and quantities; for substantiating instructions for installation or'+' performance of equipment or systems designed by Contractor; for construction means,'+' methods, techniques, schedules, sequences, procedures, and fabrication processes; for'+' errors and omissions in Submittals; for coordination of the Work of the trades, safety'+' precautions and performing the Work in a safe and satisfactory manner and in conformance'+' with the Contract Documents.'+'\n\n'+'If more than one submittal review stamp appears on this Submittal, the most stringent action'+' and notations thereon apply.'+(' '+companyName+' nor Spackle and its')+' consultants, employees, contractors or agents have not reviewed work not within their'+' respective professional discipline or scope of services.';};_this.buildStamp=function(stamp,companyName){var initialStamp={destroy:!stamp};if(stamp){initialStamp.id=stamp.id;initialStamp.legal=stamp.legal;initialStamp.stampActions=stamp.stamp_actions;}initialStamp.legal=initialStamp.legal||_this.buildLegal(companyName);return initialStamp;};_this.initialValues=function(){var companyData=_this.props.companyData;var initialValues={};if(companyData&&companyData.id){initialValues.id=companyData.id;initialValues.name=companyData.name;initialValues.logo=_this.buildLogo(companyData.logo);initialValues.stamp=_this.buildStamp(companyData.stamp,companyData.name);if(companyData.contact){var contact=companyData.contact;initialValues.contactId=contact.id;initialValues.firstName=contact.first_name;initialValues.lastName=contact.last_name;initialValues.email=contact.email;initialValues.phoneNumber=Object(__WEBPACK_IMPORTED_MODULE_4_services_utils_text_util__["c" /* formatPhoneNumber */])(contact.phone_number);}if(companyData.location){var location=companyData.location;initialValues.locationId=location.id;initialValues.streetAddress=location.street_address_1;initialValues.unitNumber=location.street_address_2;initialValues.city=location.city;initialValues.state=location.state;initialValues.zipCode=location.zip;}}return initialValues;};_this.handleSubmit=function(values){var dispatch=_this.props.dispatch;var promise=null;if(_this.serviceProviderId){promise=dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_service_providers_store_actions__["v" /* updateServiceProvider */])(_this.type,_this.serviceProviderId,values));}else{promise=dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_service_providers_store_actions__["d" /* createServiceProvider */])(_this.type,values));}promise.then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_service_providers_store_actions__["i" /* goToServiceProviderDetails */])(_this.typeUrl,response.serviceProvider.id));}});};_this.handleCancel=function(){var dispatch=_this.props.dispatch;if(_this.serviceProviderId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_service_providers_store_actions__["i" /* goToServiceProviderDetails */])(_this.typeUrl,_this.serviceProviderId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_service_providers_store_actions__["j" /* goToServiceProviders */])());}};var match=_this.props.match;_this.type=match?__WEBPACK_IMPORTED_MODULE_6_domain_service_provider_type_enum__["b" /* ServiceProviderOptionsUrlToValues */].get(match.params.type):props.type;_this.typeUrl=match?match.params.type:props.type;_this.serviceProviderId=match?match.params.id:props.id;return _this;}_createClass(ServiceProvidersEdit,[{key:'componentDidUpdate',value:function componentDidUpdate(){Object(__WEBPACK_IMPORTED_MODULE_3_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}},{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,companyData=_props.companyData,dispatch=_props.dispatch;if(this.serviceProviderId&&(!companyData||!companyData.id)){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_service_providers_store_actions__["l" /* loadServiceProviderById */])(this.type,this.serviceProviderId));}}},{key:'render',value:function render(){var initialValues=this.initialValues();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_service_providers_ServiceProvidersEditForm__["a" /* default */],{initialValues:initialValues.id?initialValues:null,onSubmit:this.handleSubmit,onCancel:this.handleCancel});}}]);return ServiceProvidersEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{companyData:Object(__WEBPACK_IMPORTED_MODULE_2_components_admin_service_providers_store_selectors__["a" /* getCompanyData */])(state)};})(ServiceProvidersEdit));

/***/ }),
/* 973 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDeposits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentDeposit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getShowPdfViewer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getUsersByClientId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getShowEmailModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getDeposits=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.deposits.data.deposits;},function(deposits){return deposits;});var getCurrentDeposit=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.deposits.data.currentDeposit;},function(currentDeposit){return currentDeposit;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.deposits.ui.currentPage;},function(currentPage){return currentPage;});var getPdf=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.deposits.ui.pdf;},function(pdf){return pdf;});var getShowPdfViewer=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.deposits.ui.showPdfViewer;},function(showPdfViewer){return showPdfViewer;});var getUsersByClientId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.deposits.data.usersByClientId;},function(usersByClientId){return usersByClientId;});var getShowEmailModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.deposits.ui.showEmailModal;},function(showEmailModal){return showEmailModal;});

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export baseRoutePath */
/* unused harmony export changePage */
/* harmony export (immutable) */ __webpack_exports__["d"] = loadDepositsRequest;
/* unused harmony export loadDepositsSuccess */
/* harmony export (immutable) */ __webpack_exports__["b"] = goToDeposit;
/* harmony export (immutable) */ __webpack_exports__["c"] = loadDepositRequest;
/* unused harmony export loadDepositSuccess */
/* harmony export (immutable) */ __webpack_exports__["f"] = markAsPaidRequest;
/* unused harmony export updateCurrentDepositAttribute */
/* harmony export (immutable) */ __webpack_exports__["g"] = printDeposit;
/* unused harmony export printDepositSuccess */
/* harmony export (immutable) */ __webpack_exports__["a"] = closePdfViewer;
/* harmony export (immutable) */ __webpack_exports__["e"] = loadUsersRequest;
/* unused harmony export loadUsersSuccess */
/* harmony export (immutable) */ __webpack_exports__["h"] = sendEmail;
/* harmony export (immutable) */ __webpack_exports__["i"] = setShowEmailModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_admin_deposits_action_types__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_deposits_api__ = __webpack_require__(2403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_clients_api__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(45);
var baseRoutePath='/admin/invoices/deposit';function changePage(newPage){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_deposits_action_types__["g" /* DEPOSITS_PAGE_CHANGE */],payload:newPage};}function loadDepositsRequest(page){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_deposits_api__["a" /* depositsApi */].getDeposits(page).then(function(response){if(response.ok){dispatch(loadDepositsSuccess(response.deposits));dispatch(changePage(page));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadDepositsSuccess(deposits){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_deposits_action_types__["f" /* DEPOSITS_LOAD_SUCCESS */],payload:deposits};}function goToDeposit(depositId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["d" /* push */])(baseRoutePath+'/'+depositId));};}function loadDepositRequest(depositId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_deposits_api__["a" /* depositsApi */].getDeposit(depositId).then(function(response){if(response.ok){dispatch(loadDepositSuccess(response.deposit));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadDepositSuccess(deposit){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_deposits_action_types__["c" /* DEPOSITS_DEPOSIT_LOAD_SUCCESS */],payload:deposit};}function markAsPaidRequest(depositId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_deposits_api__["a" /* depositsApi */].markDepositAsPaid(depositId).then(function(response){if(response.ok){dispatch(updateCurrentDepositAttribute('status',response.deposit.status));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function updateCurrentDepositAttribute(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_deposits_action_types__["a" /* DEPOSITS_DEPOSIT_ATTRIBUTE_UPDATE */],payload:{attribute:attribute,value:value}};}function printDeposit(depositId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_deposits_api__["a" /* depositsApi */].getAsPdf(depositId).then(function(response){if(response.ok){dispatch(printDepositSuccess(response.pdf));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function printDepositSuccess(pdf){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_deposits_action_types__["e" /* DEPOSITS_DEPOSIT_PRINT_SUCCESS */],payload:pdf};}function closePdfViewer(){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_deposits_action_types__["d" /* DEPOSITS_DEPOSIT_PDF_VIEWER_CLOSE */]};}function loadUsersRequest(clientId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_clients_api__["a" /* clientsApi */].getUsers(clientId).then(function(response){if(response.ok){dispatch(loadUsersSuccess(clientId,response.users));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadUsersSuccess(clientId,users){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_deposits_action_types__["h" /* DEPOSITS_USERS_LOAD_SUCCESS */],payload:{clientId:clientId,users:users}};}function sendEmail(depositId,emails,subject,message){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_deposits_api__["a" /* depositsApi */].sendEmail(depositId,emails,subject,message).then(function(response){if(response.ok){dispatch(setShowEmailModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setShowEmailModal(value){return{type:__WEBPACK_IMPORTED_MODULE_1_actions_admin_deposits_action_types__["b" /* DEPOSITS_DEPOSIT_EMAIL_MODAL_SHOW_SET */],payload:value};}

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAA8CAYAAADSfGxZAAAAAXNSR0IArs4c6QAAA+JJREFUaAXtm89P1EAUx2fKKjEQFxIPGi9cjH8BcEJN9GCDiWCC3owX/wbxgpGT/A1eCDdD4o9Esx40UTnB/gleuBg8mMCaJQYNHd93aEnLTsvsbqed2bRJ09nXtzPv++HNtPRtOVNse7cnbzLOHjDBrgkmLpPLqMKtaNMO53ytPjqxxNfX//Y6uFhYONva335O2h7JPjhbrY9MPOPxDlt3pq8Eh8FLJsT1uN2mNsFYGWs0F3uJSfj+cIv9eiOE8OPf5x5/4UWG37NTM+Iw2LQZAmIlEQ+jmLs5pkGQfVB2SBAyEwLxjgYZ76ZzV3wzIYQiajiG08EJCFgnuvkD6ECg9XDV25udvGX7dAiFY7FcwWKpC0IHAvXZwGJZYwG7r+qYc0Yrs7d05tzw2sjrjR2VTzm2ptaw2hDYhXlchWq4RKp79pbGGlsr6nN2W7uC0GgcQI0X3id0KEMmdBgdMPQCAbJw1VDeLNk1HfT+Ar1CiEDojWK5Vz8QBgZEvxAGAkQeEJwHkRcEp0HkCcFZEHlDcBKECQjOgTAFwSkQJiE4A8I0BCdAFAHBehBFQbAaRJEQrAVRNASAkM8s0eh3S60XdFmDKAMCtMun2P1CwPdRNBGBWKQn4RflTu1We/sthOn2XxYExJcbiOPKUUw1AfFlQUUDRpkQEHJuUyOmP9GUMDhVl3x/nofPBxMO9MEEBDlV29vLNL4sCKEMkFUuzC8jqDZwUmD0OSszTEDAuDQtAeEJNS9hRxs2nFNtuYGQhVSqEagGgU0FwxSEcLyO0iDF0GGL4s0NBGoDddQINGGYhBCKQyac3FQ26ZMbCPSGNUAXhqoqHY9aVqAANmVdifvm0c4VBALShYGpkiagaAiII3cQ6FQHBvxUWxkQEIcREOi4FxhlQTAKolsYZUIwDkIXRtkQCgFxGgwbIBQG4hjG6MQcfrhF4n/Kndp02ztX1CUScaRtxv/XiA8c/izwKdmwh5veDz8ib1NHY1cNUwGb6rcCEZKtQFQgkpOsyogqI6qMSBKoMiLJo1ojqoyoMiJJIJYRbdWZ/XszqQ86Vf422TJiV2pF7B5n/IdKxL8/B6mPvlX+NtnSYk/Tithr9NLGNyrXXe0UEizv+VPMvtcUOiONLMiEIwjBcmRLHKE1ZeN4o49+of8p5fxAmSkjbo19bH5WiZJv+e36k18ceYtHpUHPxvnX8UbzRpqzvI/whrzH9MRoN83JdTu0QWOWDgmi/n7zu+fxu4MIQ0IgbdB4Kgg4nP+wtcGHvGlGKZT1BafOkRZogrbT4k68CRw5W/pKdBRe1rEtL5FHV8JXaQujqoP/N2GPHdrNouMAAAAASUVORK5CYII="

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmailModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EmailModal_css__ = __webpack_require__(2408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EmailModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EmailModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_email_EmailEditor__ = __webpack_require__(422);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EmailModal=function(_Component){_inherits(EmailModal,_Component);function EmailModal(props){_classCallCheck(this,EmailModal);var _this=_possibleConstructorReturn(this,(EmailModal.__proto__||Object.getPrototypeOf(EmailModal)).call(this,props));_this.handleAddCustomEmail=function(email){_this.setState({toEmails:_this.state.toEmails.concat([email])});};_this.handleAddUserEmail=function(email){_this.setState({toEmails:_this.state.toEmails.concat([email])});};_this.handleClose=function(event){event.preventDefault();if(_this.props.onClose){_this.props.onClose();}};_this.handleMessageChange=function(message){_this.setState({message:message});};_this.handleSend=function(){if(_this.props.onSend){_this.props.onSend(_this.state.toEmails,_this.state.subject,_this.state.message);}};_this.handleSubjectConfirm=function(subject){_this.setState({subject:subject});};_this.handleToEmailRemove=function(email){_this.setState({toEmails:_this.state.toEmails.filter(function(toEmail){return toEmail!==email;})});};_this.isSendButtonEnabled=function(){return _this.state.toEmails.length>0&&_this.state.subject!==''&&_this.state.message!=='';};_this.state={message:props.defaultMessage,subject:props.defaultSubject,toEmails:props.defaultEmails};return _this;}_createClass(EmailModal,[{key:'UNSAFE_componentWillReceiveProps',value:function UNSAFE_componentWillReceiveProps(nextProps){if(nextProps.defaultSubject!==this.state.subject){this.setState({subject:nextProps.defaultSubject});}if(nextProps.defaultMessage!==this.state.message){this.setState({message:nextProps.defaultMessage});}this.setState({toEmails:nextProps.defaultEmails});}},{key:'render',value:function render(){return this.props.show?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_modal_FormModal__["a" /* default */],{className:'email-modal',show:this.props.show,title:this.props.title,onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'email-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_email_EmailEditor__["a" /* EmailEditor */],{toEmails:this.state.toEmails,message:this.state.message,subject:this.state.subject,usersEmail:this.props.emails,onCustomEmailAdd:this.handleAddCustomEmail,onMessageChange:this.handleMessageChange,onSubjectConfirm:this.handleSubjectConfirm,onToEmailRemove:this.handleToEmailRemove,onUserEmailAdd:this.handleAddUserEmail}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:!this.isSendButtonEnabled(),label:'Send',onClick:this.handleSend})))):null;}}]);return EmailModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);EmailModal.propTypes={defaultEmails:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),defaultMessage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,defaultSubject:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,emails:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSend:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};EmailModal.defaultProps={defaultEmails:[],defaultMessage:'',defaultSubject:'',emails:[],show:false};

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export baseRoutePath */
/* unused harmony export addUser */
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteUserRequest;
/* unused harmony export editUser */
/* harmony export (immutable) */ __webpack_exports__["b"] = goToEditGeneralContractorTeam;
/* unused harmony export goToTeam */
/* unused harmony export invalidForm */
/* harmony export (immutable) */ __webpack_exports__["d"] = loadUserFormRequest;
/* unused harmony export loadUserForm */
/* harmony export (immutable) */ __webpack_exports__["e"] = loadUsersRequest;
/* unused harmony export loadUsersSuccess */
/* unused harmony export removeUser */
/* harmony export (immutable) */ __webpack_exports__["f"] = setCurrentUserId;
/* harmony export (immutable) */ __webpack_exports__["c"] = loadRolesRequest;
/* unused harmony export loadRolesSuccess */
/* harmony export (immutable) */ __webpack_exports__["g"] = setShowInviteUserModal;
/* harmony export (immutable) */ __webpack_exports__["h"] = submitFormRequest;
/* harmony export (immutable) */ __webpack_exports__["i"] = updateFormValue;
/* unused harmony export validForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_users_api__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_admin_team_action_types__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_roles_api__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__ = __webpack_require__(9);
var baseRoutePath='/admin/team';function addUser(user){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_team_action_types__["R" /* GENERAL_CONTRACTOR_TEAM_USERS_ADD */],payload:user};}function deleteUserRequest(userId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_users_api__["b" /* usersApi */].removeUser(userId).then(function(response){if(response.ok){dispatch(removeUser(userId));dispatch(setShowInviteUserModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function editUser(user){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_team_action_types__["S" /* GENERAL_CONTRACTOR_TEAM_USERS_EDIT */],payload:user};}function goToEditGeneralContractorTeam(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(baseRoutePath+'/edit'));};}function goToTeam(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(''+baseRoutePath));};}function invalidForm(invalidFields,message){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_team_action_types__["K" /* GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_INVALID */],payload:{invalidFields:invalidFields,message:message}};}function loadUserFormRequest(user){return function(dispatch){var form=void 0;if(user!==null){form={firstName:user.first_name,lastName:user.last_name,email:user.email,phoneNumber:user.phone_number!=null?user.phone_number:'',rolesId:user.roles.length>0?user.roles[0].id:null};}else{form={firstName:'',lastName:'',email:'',phoneNumber:'',rolesId:null};}dispatch(loadUserForm(form));};}function loadUserForm(form){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_team_action_types__["L" /* GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_LOAD */],payload:form};}function loadUsersRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_users_api__["b" /* usersApi */].getUsers().then(function(response){if(response.ok){dispatch(loadUsersSuccess(response.users));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadUsersSuccess(users){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_team_action_types__["T" /* GENERAL_CONTRACTOR_TEAM_USERS_LOAD_SUCCESS */],payload:users};}function removeUser(userId){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_team_action_types__["U" /* GENERAL_CONTRACTOR_TEAM_USERS_REMOVE */],payload:userId};}function setCurrentUserId(userId){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_team_action_types__["O" /* GENERAL_CONTRACTOR_TEAM_INVITE_USER_ID_SET */],payload:userId};}function loadRolesRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_3_services_api_roles_api__["b" /* rolesApi */].getRoles(__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR).then(function(response){if(response.ok){dispatch(loadRolesSuccess(response.permissions));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadRolesSuccess(roles){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_team_action_types__["Q" /* GENERAL_CONTRACTOR_TEAM_ROLES_LOAD_SUCCESS */],payload:roles};}function setShowInviteUserModal(open,state){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_team_action_types__["P" /* GENERAL_CONTRACTOR_TEAM_INVITE_USER_MODAL_SHOW */],payload:{open:open,state:state?state:undefined}};}function submitFormRequest(form,currentUserId){var roles=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];return function(dispatch){// Validate form
var requiredFields=['firstName','lastName','email','phoneNumber','rolesId'];var invalidFields=[];requiredFields.forEach(function(attribute){if(form[attribute]===''||form[attribute]===null){invalidFields.push(attribute);}});if(invalidFields.length>0){dispatch(invalidForm(invalidFields,'The outlined inputs should be added in order to invite a user.'));}else{dispatch(validForm());var selectedRole=roles.find(function(role){return role.id===form.rolesId;});var title=selectedRole?__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["d" /* GENERAL_CONTRACTOR_ROLES */][selectedRole.name]:null;if(currentUserId===0){return __WEBPACK_IMPORTED_MODULE_1_services_api_users_api__["b" /* usersApi */].addUser(form.firstName,form.lastName,form.email,form.phoneNumber,[form.rolesId],title).then(function(response){if(response.ok){dispatch(addUser(response.user));dispatch(setShowInviteUserModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});}else{return __WEBPACK_IMPORTED_MODULE_1_services_api_users_api__["b" /* usersApi */].updateUser(currentUserId,form.firstName,form.lastName,form.email,form.phoneNumber,[form.rolesId],title).then(function(response){if(response.ok){dispatch(editUser(response.user));dispatch(setShowInviteUserModal(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});}}};}function updateFormValue(attribute,value){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_team_action_types__["N" /* GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_VALUE_UPDATE */],payload:{attribute:attribute,value:value}};}function validForm(){return{type:__WEBPACK_IMPORTED_MODULE_2_actions_admin_team_action_types__["M" /* GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_VALID */]};}

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getShowInviteUserModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getInvalidFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getUserModalState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getValidationMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getCurrentUserId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.generalContractor.ui.currentUserId;},function(currentUserId){return currentUserId;});var getForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.generalContractor.ui.form;},function(form){return form;});var getRoles=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.generalContractor.data.roles;},function(roles){return roles;});var getUsers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.generalContractor.data.users;},function(users){return users;});var getShowInviteUserModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.generalContractor.ui.showInviteUserModal;},function(showInviteUserModal){return showInviteUserModal;});var getInvalidFields=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.generalContractor.ui.invalidFields;},function(invalidFields){return invalidFields;});var getUserModalState=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.generalContractor.ui.userModalState;},function(userModalState){return userModalState;});var getValidationMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.team.scenes.generalContractor.ui.validationMessage;},function(validationMessage){return validationMessage;});

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getShowInviteUserModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getInvalidFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getUserModalState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getValidationMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getCurrentUserId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.users.ui.currentUserId;},function(currentUserId){return currentUserId;});var getForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.users.ui.form;},function(form){return form;});var getRoles=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.users.data.roles;},function(roles){return roles;});var getUsers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.users.data.users;},function(users){return users;});var getShowInviteUserModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.users.ui.showInviteUserModal;},function(showInviteUserModal){return showInviteUserModal;});var getInvalidFields=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.users.ui.invalidFields;},function(invalidFields){return invalidFields;});var getUserModalState=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.users.ui.userModalState;},function(userModalState){return userModalState;});var getValidationMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.users.ui.validationMessage;},function(validationMessage){return validationMessage;});

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_close_png__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_close_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_close_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VideoReact_css__ = __webpack_require__(2444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VideoReact_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__VideoReact_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VideoModal_css__ = __webpack_require__(2445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VideoModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__VideoModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_video_react__ = __webpack_require__(2446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_video_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_video_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VideoModal=function(_Component){_inherits(VideoModal,_Component);function VideoModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,VideoModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VideoModal.__proto__||Object.getPrototypeOf(VideoModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){if(_this.props.onHide){_this.props.onHide();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VideoModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-modal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */],{show:this.props.show,className:'video-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'close-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3_images_close_png___default.a,alt:'close',onClick:this.handleClose}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Modal */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_video_react__["Player"],{playsInline:true,autoPlay:this.props.autoPlay,src:this.props.videoSrc}))));}}]);return VideoModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);VideoModal.propTypes={autoPlay:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,onHide:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};VideoModal.defaultProps={autoPlay:false};/* harmony default export */ __webpack_exports__["a"] = (VideoModal);

/***/ }),
/* 982 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.operationReducer = exports.playerReducer = void 0;

var _player = _interopRequireDefault(__webpack_require__(2452));

var _operation = _interopRequireDefault(__webpack_require__(2453));

function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return {
    player: (0, _player["default"])(state.player, action),
    operation: (0, _operation["default"])(state.operation, action)
  };
}

var playerReducer = _player["default"];
exports.playerReducer = playerReducer;
var operationReducer = _operation["default"];
exports.operationReducer = operationReducer;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var Fullscreen =
/*#__PURE__*/
function () {
  function Fullscreen() {
    (0, _classCallCheck2["default"])(this, Fullscreen);
  }

  (0, _createClass2["default"])(Fullscreen, [{
    key: "request",
    value: function request(elm) {
      if (elm.requestFullscreen) {
        elm.requestFullscreen();
      } else if (elm.webkitRequestFullscreen) {
        elm.webkitRequestFullscreen();
      } else if (elm.mozRequestFullScreen) {
        elm.mozRequestFullScreen();
      } else if (elm.msRequestFullscreen) {
        elm.msRequestFullscreen();
      }
    }
  }, {
    key: "exit",
    value: function exit() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(handler) {
      document.addEventListener('fullscreenchange', handler);
      document.addEventListener('webkitfullscreenchange', handler);
      document.addEventListener('mozfullscreenchange', handler);
      document.addEventListener('MSFullscreenChange', handler);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(handler) {
      document.removeEventListener('fullscreenchange', handler);
      document.removeEventListener('webkitfullscreenchange', handler);
      document.removeEventListener('mozfullscreenchange', handler);
      document.removeEventListener('MSFullscreenChange', handler);
    }
  }, {
    key: "isFullscreen",
    get: function get() {
      return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
    }
  }, {
    key: "enabled",
    get: function get() {
      return document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
    }
  }]);
  return Fullscreen;
}();

var _default = new Fullscreen();

exports["default"] = _default;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  position: _propTypes["default"].string,
  className: _propTypes["default"].string
};
var defaultProps = {
  position: 'left'
};

var BigPlayButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(BigPlayButton, _Component);

  function BigPlayButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, BigPlayButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(BigPlayButton).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(BigPlayButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "handleClick",
    value: function handleClick() {
      var actions = this.props.actions;
      actions.play();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          player = _this$props.player,
          position = _this$props.position;
      return _react["default"].createElement("button", {
        className: (0, _classnames["default"])('video-react-big-play-button', "video-react-big-play-button-".concat(position), this.props.className, {
          'big-play-button-hide': player.hasStarted || !player.currentSrc
        }),
        type: "button",
        "aria-live": "polite",
        tabIndex: "0",
        onClick: this.handleClick
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Play Video"));
    }
  }]);
  return BigPlayButton;
}(_react.Component);

exports["default"] = BigPlayButton;
BigPlayButton.propTypes = propTypes;
BigPlayButton.defaultProps = defaultProps;
BigPlayButton.displayName = 'BigPlayButton';

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LoadingSpinner;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function LoadingSpinner(_ref) {
  var player = _ref.player,
      className = _ref.className;

  if (player.error) {
    return null;
  }

  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-loading-spinner', className)
  });
}

LoadingSpinner.propTypes = propTypes;
LoadingSpinner.displayName = 'LoadingSpinner';

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var propTypes = {
  poster: _propTypes["default"].string,
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function PosterImage(_ref) {
  var poster = _ref.poster,
      player = _ref.player,
      actions = _ref.actions,
      className = _ref.className;

  if (!poster || player.hasStarted) {
    return null;
  }

  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-poster', className),
    style: {
      backgroundImage: "url(\"".concat(poster, "\")")
    },
    onClick: function onClick() {
      if (player.paused) {
        actions.play();
      }
    }
  });
}

PosterImage.propTypes = propTypes;
PosterImage.displayName = 'PosterImage';
var _default = PosterImage;
exports["default"] = _default;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(206));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(166);

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  children: _propTypes["default"].any,
  startTime: _propTypes["default"].number,
  loop: _propTypes["default"].bool,
  muted: _propTypes["default"].bool,
  autoPlay: _propTypes["default"].bool,
  playsInline: _propTypes["default"].bool,
  src: _propTypes["default"].string,
  poster: _propTypes["default"].string,
  className: _propTypes["default"].string,
  preload: _propTypes["default"].oneOf(['auto', 'metadata', 'none']),
  crossOrigin: _propTypes["default"].string,
  onLoadStart: _propTypes["default"].func,
  onWaiting: _propTypes["default"].func,
  onCanPlay: _propTypes["default"].func,
  onCanPlayThrough: _propTypes["default"].func,
  onPlaying: _propTypes["default"].func,
  onEnded: _propTypes["default"].func,
  onSeeking: _propTypes["default"].func,
  onSeeked: _propTypes["default"].func,
  onPlay: _propTypes["default"].func,
  onPause: _propTypes["default"].func,
  onProgress: _propTypes["default"].func,
  onDurationChange: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onSuspend: _propTypes["default"].func,
  onAbort: _propTypes["default"].func,
  onEmptied: _propTypes["default"].func,
  onStalled: _propTypes["default"].func,
  onLoadedMetadata: _propTypes["default"].func,
  onLoadedData: _propTypes["default"].func,
  onTimeUpdate: _propTypes["default"].func,
  onRateChange: _propTypes["default"].func,
  onVolumeChange: _propTypes["default"].func,
  onResize: _propTypes["default"].func
};

var Video =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Video, _Component);

  function Video(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Video);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Video).call(this, props));
    _this.video = null; // the html5 video

    _this.play = _this.play.bind((0, _assertThisInitialized2["default"])(_this));
    _this.pause = _this.pause.bind((0, _assertThisInitialized2["default"])(_this));
    _this.seek = _this.seek.bind((0, _assertThisInitialized2["default"])(_this));
    _this.forward = _this.forward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.replay = _this.replay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.toggleFullscreen = _this.toggleFullscreen.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getProperties = _this.getProperties.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleLoadStart = _this.handleLoadStart.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleCanPlay = _this.handleCanPlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleCanPlayThrough = _this.handleCanPlayThrough.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePlay = _this.handlePlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePlaying = _this.handlePlaying.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePause = _this.handlePause.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEnded = _this.handleEnded.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleWaiting = _this.handleWaiting.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSeeking = _this.handleSeeking.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSeeked = _this.handleSeeked.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFullscreenChange = _this.handleFullscreenChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleError = _this.handleError.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSuspend = _this.handleSuspend.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleAbort = _this.handleAbort.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEmptied = _this.handleEmptied.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleStalled = _this.handleStalled.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleLoadedMetaData = _this.handleLoadedMetaData.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleLoadedData = _this.handleLoadedData.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTimeUpdate = _this.handleTimeUpdate.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleRateChange = _this.handleRateChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleVolumeChange = _this.handleVolumeChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDurationChange = _this.handleDurationChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleProgress = (0, _utils.throttle)(_this.handleProgress.bind((0, _assertThisInitialized2["default"])(_this)), 250);
    _this.handleKeypress = _this.handleKeypress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTextTrackChange = _this.handleTextTrackChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Video, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.forceUpdate(); // make sure the children can get the video property

      if (this.video && this.video.textTracks) {
        this.video.textTracks.onaddtrack = this.handleTextTrackChange;
        this.video.textTracks.onremovetrack = this.handleTextTrackChange;
      }
    } // get all video properties

  }, {
    key: "getProperties",
    value: function getProperties() {
      var _this2 = this;

      if (!this.video) {
        return null;
      }

      return _utils.mediaProperties.reduce(function (properties, key) {
        properties[key] = _this2.video[key];
        return properties;
      }, {});
    } // get playback rate

  }, {
    key: "handleTextTrackChange",
    value: function handleTextTrackChange() {
      var _this$props = this.props,
          actions = _this$props.actions,
          player = _this$props.player;

      if (this.video && this.video.textTracks) {
        var activeTextTrack = Array.from(this.video.textTracks).find(function (textTrack) {
          return textTrack.mode === 'showing';
        });

        if (activeTextTrack !== player.activeTextTrack) {
          actions.activateTextTrack(activeTextTrack);
        }
      }
    } // play the video

  }, {
    key: "play",
    value: function play() {
      var promise = this.video.play();

      if (promise !== undefined) {
        promise["catch"](function () {}).then(function () {});
      }
    } // pause the video

  }, {
    key: "pause",
    value: function pause() {
      var promise = this.video.pause();

      if (promise !== undefined) {
        promise["catch"](function () {}).then(function () {});
      }
    } // Change the video source and re-load the video:

  }, {
    key: "load",
    value: function load() {
      this.video.load();
    } // Add a new text track to the video

  }, {
    key: "addTextTrack",
    value: function addTextTrack() {
      var _this$video;

      (_this$video = this.video).addTextTrack.apply(_this$video, arguments);
    } // Check if your browser can play different types of video:

  }, {
    key: "canPlayType",
    value: function canPlayType() {
      var _this$video2;

      (_this$video2 = this.video).canPlayType.apply(_this$video2, arguments);
    } // toggle play

  }, {
    key: "togglePlay",
    value: function togglePlay() {
      if (this.video.paused) {
        this.play();
      } else {
        this.pause();
      }
    } // seek video by time

  }, {
    key: "seek",
    value: function seek(time) {
      try {
        this.video.currentTime = time;
      } catch (e) {// console.log(e, 'Video is not ready.')
      }
    } // jump forward x seconds

  }, {
    key: "forward",
    value: function forward(seconds) {
      this.seek(this.video.currentTime + seconds);
    } // jump back x seconds

  }, {
    key: "replay",
    value: function replay(seconds) {
      this.forward(-seconds);
    } // enter or exist full screen

  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen() {
      var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions;
      actions.toggleFullscreen(player);
    } // Fired when the user agent
    // begins looking for media data

  }, {
    key: "handleLoadStart",
    value: function handleLoadStart() {
      var _this$props3 = this.props,
          actions = _this$props3.actions,
          onLoadStart = _this$props3.onLoadStart;
      actions.handleLoadStart(this.getProperties());

      if (onLoadStart) {
        onLoadStart.apply(void 0, arguments);
      }
    } // A handler for events that
    // signal that waiting has ended

  }, {
    key: "handleCanPlay",
    value: function handleCanPlay() {
      var _this$props4 = this.props,
          actions = _this$props4.actions,
          onCanPlay = _this$props4.onCanPlay;
      actions.handleCanPlay(this.getProperties());

      if (onCanPlay) {
        onCanPlay.apply(void 0, arguments);
      }
    } // A handler for events that
    // signal that waiting has ended

  }, {
    key: "handleCanPlayThrough",
    value: function handleCanPlayThrough() {
      var _this$props5 = this.props,
          actions = _this$props5.actions,
          onCanPlayThrough = _this$props5.onCanPlayThrough;
      actions.handleCanPlayThrough(this.getProperties());

      if (onCanPlayThrough) {
        onCanPlayThrough.apply(void 0, arguments);
      }
    } // A handler for events that
    // signal that waiting has ended

  }, {
    key: "handlePlaying",
    value: function handlePlaying() {
      var _this$props6 = this.props,
          actions = _this$props6.actions,
          onPlaying = _this$props6.onPlaying;
      actions.handlePlaying(this.getProperties());

      if (onPlaying) {
        onPlaying.apply(void 0, arguments);
      }
    } // Fired whenever the media has been started

  }, {
    key: "handlePlay",
    value: function handlePlay() {
      var _this$props7 = this.props,
          actions = _this$props7.actions,
          onPlay = _this$props7.onPlay;
      actions.handlePlay(this.getProperties());

      if (onPlay) {
        onPlay.apply(void 0, arguments);
      }
    } // Fired whenever the media has been paused

  }, {
    key: "handlePause",
    value: function handlePause() {
      var _this$props8 = this.props,
          actions = _this$props8.actions,
          onPause = _this$props8.onPause;
      actions.handlePause(this.getProperties());

      if (onPause) {
        onPause.apply(void 0, arguments);
      }
    } // Fired when the duration of
    // the media resource is first known or changed

  }, {
    key: "handleDurationChange",
    value: function handleDurationChange() {
      var _this$props9 = this.props,
          actions = _this$props9.actions,
          onDurationChange = _this$props9.onDurationChange;
      actions.handleDurationChange(this.getProperties());

      if (onDurationChange) {
        onDurationChange.apply(void 0, arguments);
      }
    } // Fired while the user agent
    // is downloading media data

  }, {
    key: "handleProgress",
    value: function handleProgress() {
      var _this$props10 = this.props,
          actions = _this$props10.actions,
          onProgress = _this$props10.onProgress;

      if (this.video) {
        actions.handleProgressChange(this.getProperties());
      }

      if (onProgress) {
        onProgress.apply(void 0, arguments);
      }
    } // Fired when the end of the media resource
    // is reached (currentTime == duration)

  }, {
    key: "handleEnded",
    value: function handleEnded() {
      var _this$props11 = this.props,
          loop = _this$props11.loop,
          player = _this$props11.player,
          actions = _this$props11.actions,
          onEnded = _this$props11.onEnded;

      if (loop) {
        this.seek(0);
        this.play();
      } else if (!player.paused) {
        this.pause();
      }

      actions.handleEnd(this.getProperties());

      if (onEnded) {
        onEnded.apply(void 0, arguments);
      }
    } // Fired whenever the media begins waiting

  }, {
    key: "handleWaiting",
    value: function handleWaiting() {
      var _this$props12 = this.props,
          actions = _this$props12.actions,
          onWaiting = _this$props12.onWaiting;
      actions.handleWaiting(this.getProperties());

      if (onWaiting) {
        onWaiting.apply(void 0, arguments);
      }
    } // Fired whenever the player
    // is jumping to a new time

  }, {
    key: "handleSeeking",
    value: function handleSeeking() {
      var _this$props13 = this.props,
          actions = _this$props13.actions,
          onSeeking = _this$props13.onSeeking;
      actions.handleSeeking(this.getProperties());

      if (onSeeking) {
        onSeeking.apply(void 0, arguments);
      }
    } // Fired when the player has
    // finished jumping to a new time

  }, {
    key: "handleSeeked",
    value: function handleSeeked() {
      var _this$props14 = this.props,
          actions = _this$props14.actions,
          onSeeked = _this$props14.onSeeked;
      actions.handleSeeked(this.getProperties());

      if (onSeeked) {
        onSeeked.apply(void 0, arguments);
      }
    } // Handle Fullscreen Change

  }, {
    key: "handleFullscreenChange",
    value: function handleFullscreenChange() {} // Fires when the browser is
    // intentionally not getting media data

  }, {
    key: "handleSuspend",
    value: function handleSuspend() {
      var _this$props15 = this.props,
          actions = _this$props15.actions,
          onSuspend = _this$props15.onSuspend;
      actions.handleSuspend(this.getProperties());

      if (onSuspend) {
        onSuspend.apply(void 0, arguments);
      }
    } // Fires when the loading of an audio/video is aborted

  }, {
    key: "handleAbort",
    value: function handleAbort() {
      var _this$props16 = this.props,
          actions = _this$props16.actions,
          onAbort = _this$props16.onAbort;
      actions.handleAbort(this.getProperties());

      if (onAbort) {
        onAbort.apply(void 0, arguments);
      }
    } // Fires when the current playlist is empty

  }, {
    key: "handleEmptied",
    value: function handleEmptied() {
      var _this$props17 = this.props,
          actions = _this$props17.actions,
          onEmptied = _this$props17.onEmptied;
      actions.handleEmptied(this.getProperties());

      if (onEmptied) {
        onEmptied.apply(void 0, arguments);
      }
    } // Fires when the browser is trying to
    // get media data, but data is not available

  }, {
    key: "handleStalled",
    value: function handleStalled() {
      var _this$props18 = this.props,
          actions = _this$props18.actions,
          onStalled = _this$props18.onStalled;
      actions.handleStalled(this.getProperties());

      if (onStalled) {
        onStalled.apply(void 0, arguments);
      }
    } // Fires when the browser has loaded
    // meta data for the audio/video

  }, {
    key: "handleLoadedMetaData",
    value: function handleLoadedMetaData() {
      var _this$props19 = this.props,
          actions = _this$props19.actions,
          onLoadedMetadata = _this$props19.onLoadedMetadata,
          startTime = _this$props19.startTime;

      if (startTime && startTime > 0) {
        this.video.currentTime = startTime;
      }

      actions.handleLoadedMetaData(this.getProperties());

      if (onLoadedMetadata) {
        onLoadedMetadata.apply(void 0, arguments);
      }
    } // Fires when the browser has loaded
    // the current frame of the audio/video

  }, {
    key: "handleLoadedData",
    value: function handleLoadedData() {
      var _this$props20 = this.props,
          actions = _this$props20.actions,
          onLoadedData = _this$props20.onLoadedData;
      actions.handleLoadedData(this.getProperties());

      if (onLoadedData) {
        onLoadedData.apply(void 0, arguments);
      }
    } // Fires when the current
    // playback position has changed

  }, {
    key: "handleTimeUpdate",
    value: function handleTimeUpdate() {
      var _this$props21 = this.props,
          actions = _this$props21.actions,
          onTimeUpdate = _this$props21.onTimeUpdate;
      actions.handleTimeUpdate(this.getProperties());

      if (onTimeUpdate) {
        onTimeUpdate.apply(void 0, arguments);
      }
    }
    /**
     * Fires when the playing speed of the audio/video is changed
     */

  }, {
    key: "handleRateChange",
    value: function handleRateChange() {
      var _this$props22 = this.props,
          actions = _this$props22.actions,
          onRateChange = _this$props22.onRateChange;
      actions.handleRateChange(this.getProperties());

      if (onRateChange) {
        onRateChange.apply(void 0, arguments);
      }
    } // Fires when the volume has been changed

  }, {
    key: "handleVolumeChange",
    value: function handleVolumeChange() {
      var _this$props23 = this.props,
          actions = _this$props23.actions,
          onVolumeChange = _this$props23.onVolumeChange;
      actions.handleVolumeChange(this.getProperties());

      if (onVolumeChange) {
        onVolumeChange.apply(void 0, arguments);
      }
    } // Fires when an error occurred
    // during the loading of an audio/video

  }, {
    key: "handleError",
    value: function handleError() {
      var _this$props24 = this.props,
          actions = _this$props24.actions,
          onError = _this$props24.onError;
      actions.handleError(this.getProperties());

      if (onError) {
        onError.apply(void 0, arguments);
      }
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var _this$props25 = this.props,
          actions = _this$props25.actions,
          onResize = _this$props25.onResize;
      actions.handleResize(this.getProperties());

      if (onResize) {
        onResize.apply(void 0, arguments);
      }
    }
  }, {
    key: "handleKeypress",
    value: function handleKeypress() {}
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this3 = this;

      var props = (0, _objectSpread2["default"])({}, this.props, {
        video: this.video
      }); // to make sure the children can get video property

      if (!this.video) {
        return null;
      } // only keep <source />, <track />, <MyComponent isVideoChild /> elements


      return _react["default"].Children.toArray(this.props.children).filter(_utils.isVideoChild).map(function (c) {
        var cprops;

        if (typeof c.type === 'string') {
          // add onError to <source />
          if (c.type === 'source') {
            cprops = (0, _objectSpread2["default"])({}, c.props);
            var preOnError = cprops.onError;

            cprops.onError = function () {
              if (preOnError) {
                preOnError.apply(void 0, arguments);
              }

              _this3.handleError.apply(_this3, arguments);
            };
          }
        } else {
          cprops = props;
        }

        return _react["default"].cloneElement(c, cprops);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props26 = this.props,
          loop = _this$props26.loop,
          poster = _this$props26.poster,
          preload = _this$props26.preload,
          src = _this$props26.src,
          autoPlay = _this$props26.autoPlay,
          playsInline = _this$props26.playsInline,
          muted = _this$props26.muted,
          crossOrigin = _this$props26.crossOrigin,
          videoId = _this$props26.videoId;
      return _react["default"].createElement("video", {
        className: (0, _classnames["default"])('video-react-video', this.props.className),
        id: videoId,
        crossOrigin: crossOrigin,
        ref: function ref(c) {
          _this4.video = c;
        },
        muted: muted,
        preload: preload,
        loop: loop,
        playsInline: playsInline,
        autoPlay: autoPlay,
        poster: poster,
        src: src,
        onLoadStart: this.handleLoadStart,
        onWaiting: this.handleWaiting,
        onCanPlay: this.handleCanPlay,
        onCanPlayThrough: this.handleCanPlayThrough,
        onPlaying: this.handlePlaying,
        onEnded: this.handleEnded,
        onSeeking: this.handleSeeking,
        onSeeked: this.handleSeeked,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onProgress: this.handleProgress,
        onDurationChange: this.handleDurationChange,
        onError: this.handleError,
        onSuspend: this.handleSuspend,
        onAbort: this.handleAbort,
        onEmptied: this.handleEmptied,
        onStalled: this.handleStalled,
        onLoadedMetadata: this.handleLoadedMetaData,
        onLoadedData: this.handleLoadedData,
        onTimeUpdate: this.handleTimeUpdate,
        onRateChange: this.handleRateChange,
        onVolumeChange: this.handleVolumeChange,
        tabIndex: "-1"
      }, this.renderChildren());
    }
  }, {
    key: "playbackRate",
    get: function get() {
      return this.video.playbackRate;
    } // set playback rate
    // speed of video
    ,
    set: function set(rate) {
      this.video.playbackRate = rate;
    }
  }, {
    key: "muted",
    get: function get() {
      return this.video.muted;
    },
    set: function set(val) {
      this.video.muted = val;
    }
  }, {
    key: "volume",
    get: function get() {
      return this.video.volume;
    },
    set: function set(val) {
      if (val > 1) {
        val = 1;
      }

      if (val < 0) {
        val = 0;
      }

      this.video.volume = val;
    } // video width

  }, {
    key: "videoWidth",
    get: function get() {
      return this.video.videoWidth;
    } // video height

  }, {
    key: "videoHeight",
    get: function get() {
      return this.video.videoHeight;
    }
  }]);
  return Video;
}(_react.Component);

exports["default"] = Video;
Video.propTypes = propTypes;
Video.displayName = 'Video';

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(2454);

var iterableToArray = __webpack_require__(2455);

var unsupportedIterableToArray = __webpack_require__(2456);

var nonIterableSpread = __webpack_require__(2457);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 990 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var propTypes = {
  manager: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var Bezel =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Bezel, _Component);

  function Bezel(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Bezel);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Bezel).call(this, props, context));
    _this.timer = null;
    props.manager.subscribeToOperationStateChange(_this.handleStateChange.bind((0, _assertThisInitialized2["default"])(_this)));
    _this.state = {
      hidden: true,
      operation: {}
    };
    return _this;
  }

  (0, _createClass2["default"])(Bezel, [{
    key: "handleStateChange",
    value: function handleStateChange(state, prevState) {
      var _this2 = this;

      if (state.count !== prevState.count && state.operation.source === 'shortcut') {
        if (this.timer) {
          // previous animation is not finished
          clearTimeout(this.timer); // cancel it

          this.timer = null;
        } // show it
        // update operation


        this.setState({
          hidden: false,
          count: state.count,
          operation: state.operation
        }); // hide it after 0.5s

        this.timer = setTimeout(function () {
          _this2.setState({
            hidden: true
          });

          _this2.timer = null;
        }, 500);
      }
    }
  }, {
    key: "render",
    value: function render() {
      // only displays for shortcut so far
      if (this.state.operation.source !== 'shortcut') {
        return null;
      }

      var style = this.state.hidden ? {
        display: 'none'
      } : null;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])({
          'video-react-bezel': true,
          'video-react-bezel-animation': this.state.count % 2 === 0,
          'video-react-bezel-animation-alt': this.state.count % 2 === 1
        }, this.props.className),
        style: style,
        role: "status",
        "aria-label": this.state.operation.action
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])('video-react-bezel-icon', "video-react-bezel-icon-".concat(this.state.operation.action))
      }));
    }
  }]);
  return Bezel;
}(_react.Component);

exports["default"] = Bezel;
Bezel.propTypes = propTypes;
Bezel.displayName = 'Bezel';

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(610));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(989));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _react = __webpack_require__(0);

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _dom = __webpack_require__(433);

var propTypes = {
  clickable: _propTypes["default"].bool,
  dblclickable: _propTypes["default"].bool,
  manager: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  shortcuts: _propTypes["default"].array
};
var defaultProps = {
  clickable: true,
  dblclickable: true
};

var Shortcut =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Shortcut, _Component);

  function Shortcut(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Shortcut);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Shortcut).call(this, props, context));
    _this.defaultShortcuts = [{
      keyCode: 32,
      // spacebar
      handle: _this.togglePlay
    }, {
      keyCode: 75,
      // k
      handle: _this.togglePlay
    }, {
      keyCode: 70,
      // f
      handle: _this.toggleFullscreen
    }, {
      keyCode: 37,
      // Left arrow
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.replay(5, {
          action: 'replay-5',
          source: 'shortcut'
        }); // Go back 5 seconds
      }
    }, {
      keyCode: 74,
      // j
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.replay(10, {
          action: 'replay-10',
          source: 'shortcut'
        }); // Go back 10 seconds
      }
    }, {
      keyCode: 39,
      // Right arrow
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.forward(5, {
          action: 'forward-5',
          source: 'shortcut'
        }); // Go forward 5 seconds
      }
    }, {
      keyCode: 76,
      // l
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.forward(10, {
          action: 'forward-10',
          source: 'shortcut'
        }); // Go forward 10 seconds
      }
    }, {
      keyCode: 36,
      // Home
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.seek(0); // Go to beginning of video
      }
    }, {
      keyCode: 35,
      // End
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        } // Go to end of video


        actions.seek(player.duration);
      }
    }, {
      keyCode: 38,
      // Up arrow
      handle: function handle(player, actions) {
        // Increase volume 5%
        var v = player.volume + 0.05;

        if (v > 1) {
          v = 1;
        }

        actions.changeVolume(v, {
          action: 'volume-up',
          source: 'shortcut'
        });
      }
    }, {
      keyCode: 40,
      // Down arrow
      handle: function handle(player, actions) {
        // Decrease volume 5%
        var v = player.volume - 0.05;

        if (v < 0) {
          v = 0;
        }

        var action = v > 0 ? 'volume-down' : 'volume-off';
        actions.changeVolume(v, {
          action: action,
          source: 'shortcut'
        });
      }
    }, {
      keyCode: 190,
      // Shift + >
      shift: true,
      handle: function handle(player, actions) {
        // Increase speed
        var playbackRate = player.playbackRate;

        if (playbackRate >= 1.5) {
          playbackRate = 2;
        } else if (playbackRate >= 1.25) {
          playbackRate = 1.5;
        } else if (playbackRate >= 1.0) {
          playbackRate = 1.25;
        } else if (playbackRate >= 0.5) {
          playbackRate = 1.0;
        } else if (playbackRate >= 0.25) {
          playbackRate = 0.5;
        } else if (playbackRate >= 0) {
          playbackRate = 0.25;
        }

        actions.changeRate(playbackRate, {
          action: 'fast-forward',
          source: 'shortcut'
        });
      }
    }, {
      keyCode: 188,
      // Shift + <
      shift: true,
      handle: function handle(player, actions) {
        // Decrease speed
        var playbackRate = player.playbackRate;

        if (playbackRate <= 0.5) {
          playbackRate = 0.25;
        } else if (playbackRate <= 1.0) {
          playbackRate = 0.5;
        } else if (playbackRate <= 1.25) {
          playbackRate = 1.0;
        } else if (playbackRate <= 1.5) {
          playbackRate = 1.25;
        } else if (playbackRate <= 2) {
          playbackRate = 1.5;
        }

        actions.changeRate(playbackRate, {
          action: 'fast-rewind',
          source: 'shortcut'
        });
      }
    }];
    _this.shortcuts = (0, _toConsumableArray2["default"])(_this.defaultShortcuts);
    _this.mergeShortcuts = _this.mergeShortcuts.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDoubleClick = _this.handleDoubleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Shortcut, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mergeShortcuts();
      document.addEventListener('keydown', this.handleKeyPress);
      document.addEventListener('click', this.handleClick);
      document.addEventListener('dblclick', this.handleDoubleClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.shortcuts !== this.props.shortcuts) {
        this.mergeShortcuts();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyPress);
      document.removeEventListener('click', this.handleClick);
      document.removeEventListener('dblclick', this.handleDoubleClick);
    } // merge the shortcuts from props

  }, {
    key: "mergeShortcuts",
    value: function mergeShortcuts() {
      var getShortcutKey = function getShortcutKey(_ref) {
        var _ref$keyCode = _ref.keyCode,
            keyCode = _ref$keyCode === void 0 ? 0 : _ref$keyCode,
            _ref$ctrl = _ref.ctrl,
            ctrl = _ref$ctrl === void 0 ? false : _ref$ctrl,
            _ref$shift = _ref.shift,
            shift = _ref$shift === void 0 ? false : _ref$shift,
            _ref$alt = _ref.alt,
            alt = _ref$alt === void 0 ? false : _ref$alt;
        return "".concat(keyCode, ":").concat(ctrl, ":").concat(shift, ":").concat(alt);
      };

      var defaultShortcuts = this.defaultShortcuts.reduce(function (shortcuts, shortcut) {
        return Object.assign(shortcuts, (0, _defineProperty2["default"])({}, getShortcutKey(shortcut), shortcut));
      }, {});
      var mergedShortcuts = (this.props.shortcuts || []).reduce(function (shortcuts, shortcut) {
        var keyCode = shortcut.keyCode,
            handle = shortcut.handle;

        if (keyCode && typeof handle === 'function') {
          return Object.assign(shortcuts, (0, _defineProperty2["default"])({}, getShortcutKey(shortcut), shortcut));
        }

        return shortcuts;
      }, defaultShortcuts);

      var gradeShortcut = function gradeShortcut(s) {
        var score = 0;
        var ps = ['ctrl', 'shift', 'alt'];
        ps.forEach(function (key) {
          if (s[key]) {
            score++;
          }
        });
        return score;
      };

      this.shortcuts = Object.keys(mergedShortcuts).map(function (key) {
        return mergedShortcuts[key];
      }).sort(function (a, b) {
        return gradeShortcut(b) - gradeShortcut(a);
      });
    }
  }, {
    key: "togglePlay",
    value: function togglePlay(player, actions) {
      if (player.paused) {
        actions.play({
          action: 'play',
          source: 'shortcut'
        });
      } else {
        actions.pause({
          action: 'pause',
          source: 'shortcut'
        });
      }
    }
  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen(player, actions) {
      actions.toggleFullscreen(player);
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(e) {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;

      if (!player.isActive) {
        return;
      }

      if (document.activeElement && ((0, _dom.hasClass)(document.activeElement, 'video-react-control') || (0, _dom.hasClass)(document.activeElement, 'video-react-menu-button-active') // || hasClass(document.activeElement, 'video-react-slider')
      || (0, _dom.hasClass)(document.activeElement, 'video-react-big-play-button'))) {
        return;
      }

      var keyCode = e.keyCode || e.which;
      var ctrl = e.ctrlKey || e.metaKey;
      var shift = e.shiftKey;
      var alt = e.altKey;
      var shortcut = this.shortcuts.filter(function (s) {
        if (!s.keyCode || s.keyCode - keyCode !== 0) {
          return false;
        }

        if (s.ctrl !== undefined && s.ctrl !== ctrl || s.shift !== undefined && s.shift !== shift || s.alt !== undefined && s.alt !== alt) {
          return false;
        }

        return true;
      })[0];

      if (shortcut) {
        shortcut.handle(player, actions);
        e.preventDefault();
      }
    } // only if player is active and player is ready

  }, {
    key: "canBeClicked",
    value: function canBeClicked(player, e) {
      if (!player.isActive || e.target.nodeName !== 'VIDEO' || player.readyState !== 4) {
        return false;
      }

      return true;
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions,
          clickable = _this$props2.clickable;

      if (!this.canBeClicked(player, e) || !clickable) {
        return;
      }

      this.togglePlay(player, actions); // e.preventDefault();
    }
  }, {
    key: "handleDoubleClick",
    value: function handleDoubleClick(e) {
      var _this$props3 = this.props,
          player = _this$props3.player,
          actions = _this$props3.actions,
          dblclickable = _this$props3.dblclickable;

      if (!this.canBeClicked(player, e) || !dblclickable) {
        return;
      }

      this.toggleFullscreen(player, actions); // e.preventDefault();
    } // this component dose not render anything
    // it's just for the key down event

  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return Shortcut;
}(_react.Component);

exports["default"] = Shortcut;
Shortcut.propTypes = propTypes;
Shortcut.defaultProps = defaultProps;
Shortcut.displayName = 'Shortcut';

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(611));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _ProgressControl = _interopRequireDefault(__webpack_require__(994));

var _PlayToggle = _interopRequireDefault(__webpack_require__(999));

var _ForwardControl = _interopRequireDefault(__webpack_require__(1000));

var _ReplayControl = _interopRequireDefault(__webpack_require__(1002));

var _FullscreenToggle = _interopRequireDefault(__webpack_require__(1003));

var _RemainingTimeDisplay = _interopRequireDefault(__webpack_require__(1004));

var _CurrentTimeDisplay = _interopRequireDefault(__webpack_require__(1005));

var _DurationDisplay = _interopRequireDefault(__webpack_require__(1006));

var _TimeDivider = _interopRequireDefault(__webpack_require__(1007));

var _VolumeMenuButton = _interopRequireDefault(__webpack_require__(1008));

var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(614));

var _utils = __webpack_require__(166);

var propTypes = {
  children: _propTypes["default"].any,
  autoHide: _propTypes["default"].bool,
  autoHideTime: _propTypes["default"].number,
  // used in Player
  disableDefaultControls: _propTypes["default"].bool,
  disableCompletely: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var defaultProps = {
  autoHide: true,
  disableCompletely: false
};

var ControlBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ControlBar, _Component);

  function ControlBar(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ControlBar);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ControlBar).call(this, props));
    _this.getDefaultChildren = _this.getDefaultChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getFullChildren = _this.getFullChildren.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ControlBar, [{
    key: "getDefaultChildren",
    value: function getDefaultChildren() {
      return [_react["default"].createElement(_PlayToggle["default"], {
        key: "play-toggle",
        order: 1
      }), _react["default"].createElement(_VolumeMenuButton["default"], {
        key: "volume-menu-button",
        order: 4
      }), _react["default"].createElement(_CurrentTimeDisplay["default"], {
        key: "current-time-display",
        order: 5.1
      }), _react["default"].createElement(_TimeDivider["default"], {
        key: "time-divider",
        order: 5.2
      }), _react["default"].createElement(_DurationDisplay["default"], {
        key: "duration-display",
        order: 5.3
      }), _react["default"].createElement(_ProgressControl["default"], {
        key: "progress-control",
        order: 6
      }), _react["default"].createElement(_FullscreenToggle["default"], {
        key: "fullscreen-toggle",
        order: 8
      })];
    }
  }, {
    key: "getFullChildren",
    value: function getFullChildren() {
      return [_react["default"].createElement(_PlayToggle["default"], {
        key: "play-toggle",
        order: 1
      }), _react["default"].createElement(_ReplayControl["default"], {
        key: "replay-control",
        order: 2
      }), _react["default"].createElement(_ForwardControl["default"], {
        key: "forward-control",
        order: 3
      }), _react["default"].createElement(_VolumeMenuButton["default"], {
        key: "volume-menu-button",
        order: 4
      }), _react["default"].createElement(_CurrentTimeDisplay["default"], {
        key: "current-time-display",
        order: 5
      }), _react["default"].createElement(_TimeDivider["default"], {
        key: "time-divider",
        order: 6
      }), _react["default"].createElement(_DurationDisplay["default"], {
        key: "duration-display",
        order: 7
      }), _react["default"].createElement(_ProgressControl["default"], {
        key: "progress-control",
        order: 8
      }), _react["default"].createElement(_RemainingTimeDisplay["default"], {
        key: "remaining-time-display",
        order: 9
      }), _react["default"].createElement(_PlaybackRateMenuButton["default"], {
        rates: [1, 1.25, 1.5, 2],
        key: "playback-rate",
        order: 10
      }), _react["default"].createElement(_FullscreenToggle["default"], {
        key: "fullscreen-toggle",
        order: 11
      })];
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var children = _react["default"].Children.toArray(this.props.children);

      var defaultChildren = this.props.disableDefaultControls ? [] : this.getDefaultChildren();
      var _this$props = this.props,
          className = _this$props.className,
          parentProps = (0, _objectWithoutProperties2["default"])(_this$props, ["className"]); // remove className

      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, parentProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          autoHide = _this$props2.autoHide,
          className = _this$props2.className,
          disableCompletely = _this$props2.disableCompletely;
      var children = this.getChildren();
      return disableCompletely ? null : _react["default"].createElement("div", {
        className: (0, _classnames["default"])('video-react-control-bar', {
          'video-react-control-bar-auto-hide': autoHide
        }, className)
      }, children);
    }
  }]);
  return ControlBar;
}(_react.Component);

exports["default"] = ControlBar;
ControlBar.propTypes = propTypes;
ControlBar.defaultProps = defaultProps;
ControlBar.displayName = 'ControlBar';

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(252));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var Dom = _interopRequireWildcard(__webpack_require__(433));

var _SeekBar = _interopRequireDefault(__webpack_require__(995));

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var ProgressControl =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ProgressControl, _Component);

  function ProgressControl(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, ProgressControl);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ProgressControl).call(this, props, context));
    _this.state = {
      mouseTime: {
        time: null,
        position: 0
      }
    };
    _this.handleMouseMoveThrottle = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ProgressControl, [{
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      if (!event.pageX) {
        return;
      }

      var duration = this.props.player.duration;
      var node = this.seekBar;
      var newTime = Dom.getPointerPosition(node, event).x * duration;
      var position = event.pageX - Dom.findElPosition(node).left;
      this.setState({
        mouseTime: {
          time: newTime,
          position: position
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = this.props.className;
      return _react["default"].createElement("div", {
        onMouseMove: this.handleMouseMoveThrottle,
        className: (0, _classnames["default"])('video-react-progress-control video-react-control', className)
      }, _react["default"].createElement(_SeekBar["default"], (0, _extends2["default"])({
        mouseTime: this.state.mouseTime,
        ref: function ref(c) {
          _this2.seekBar = c;
        }
      }, this.props)));
    }
  }]);
  return ProgressControl;
}(_react.Component);

exports["default"] = ProgressControl;
ProgressControl.propTypes = propTypes;
ProgressControl.displayName = 'ProgressControl';

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _Slider = _interopRequireDefault(__webpack_require__(613));

var _PlayProgressBar = _interopRequireDefault(__webpack_require__(996));

var _LoadProgressBar = _interopRequireDefault(__webpack_require__(997));

var _MouseTimeDisplay = _interopRequireDefault(__webpack_require__(998));

var _utils = __webpack_require__(166);

var propTypes = {
  player: _propTypes["default"].object,
  mouseTime: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var SeekBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(SeekBar, _Component);

  function SeekBar(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, SeekBar);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SeekBar).call(this, props, context));
    _this.getPercent = _this.getPercent.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getNewTime = _this.getNewTime.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(SeekBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
    /**
     * Get percentage of video played
     *
     * @return {Number} Percentage played
     * @method getPercent
     */

  }, {
    key: "getPercent",
    value: function getPercent() {
      var _this$props$player = this.props.player,
          currentTime = _this$props$player.currentTime,
          seekingTime = _this$props$player.seekingTime,
          duration = _this$props$player.duration;
      var time = seekingTime || currentTime;
      var percent = time / duration;
      return percent >= 1 ? 1 : percent;
    }
  }, {
    key: "getNewTime",
    value: function getNewTime(event) {
      var duration = this.props.player.duration;
      var distance = this.slider.calculateDistance(event);
      var newTime = distance * duration; // Don't let video end while scrubbing.

      return newTime === duration ? newTime - 0.1 : newTime;
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown() {}
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(event) {
      var actions = this.props.actions;
      var newTime = this.getNewTime(event); // Set new time (tell video to seek to new time)

      actions.seek(newTime);
      actions.handleEndSeeking(newTime);
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      var actions = this.props.actions;
      var newTime = this.getNewTime(event);
      actions.handleSeekingTime(newTime);
    }
  }, {
    key: "stepForward",
    value: function stepForward() {
      var actions = this.props.actions;
      actions.forward(5);
    }
  }, {
    key: "stepBack",
    value: function stepBack() {
      var actions = this.props.actions;
      actions.replay(5);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$player2 = _this$props.player,
          currentTime = _this$props$player2.currentTime,
          seekingTime = _this$props$player2.seekingTime,
          duration = _this$props$player2.duration,
          buffered = _this$props$player2.buffered,
          mouseTime = _this$props.mouseTime;
      var time = seekingTime || currentTime;
      return _react["default"].createElement(_Slider["default"], {
        ref: function ref(input) {
          _this2.slider = input;
        },
        label: "video progress bar",
        className: (0, _classnames["default"])('video-react-progress-holder', this.props.className),
        valuenow: (this.getPercent() * 100).toFixed(2),
        valuetext: (0, _utils.formatTime)(time, duration),
        onMouseDown: this.handleMouseDown,
        onMouseMove: this.handleMouseMove,
        onMouseUp: this.handleMouseUp,
        getPercent: this.getPercent,
        stepForward: this.stepForward,
        stepBack: this.stepBack
      }, _react["default"].createElement(_LoadProgressBar["default"], {
        buffered: buffered,
        currentTime: time,
        duration: duration
      }), _react["default"].createElement(_MouseTimeDisplay["default"], {
        duration: duration,
        mouseTime: mouseTime
      }), _react["default"].createElement(_PlayProgressBar["default"], {
        currentTime: time,
        duration: duration
      }));
    }
  }]);
  return SeekBar;
}(_react.Component);

exports["default"] = SeekBar;
SeekBar.propTypes = propTypes;
SeekBar.displayName = 'SeekBar';

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PlayProgressBar;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(166);

var propTypes = {
  currentTime: _propTypes["default"].number,
  duration: _propTypes["default"].number,
  percentage: _propTypes["default"].string,
  className: _propTypes["default"].string
}; // Shows play progress

function PlayProgressBar(_ref) {
  var currentTime = _ref.currentTime,
      duration = _ref.duration,
      percentage = _ref.percentage,
      className = _ref.className;
  return _react["default"].createElement("div", {
    "data-current-time": (0, _utils.formatTime)(currentTime, duration),
    className: (0, _classnames["default"])('video-react-play-progress video-react-slider-bar', className),
    style: {
      width: percentage
    }
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Progress: ".concat(percentage)));
}

PlayProgressBar.propTypes = propTypes;
PlayProgressBar.displayName = 'PlayProgressBar';

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LoadProgressBar;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var propTypes = {
  duration: _propTypes["default"].number,
  buffered: _propTypes["default"].object,
  className: _propTypes["default"].string
}; // Shows load progress

function LoadProgressBar(_ref) {
  var buffered = _ref.buffered,
      duration = _ref.duration,
      className = _ref.className;

  if (!buffered || !buffered.length) {
    return null;
  }

  var bufferedEnd = buffered.end(buffered.length - 1);
  var style = {};

  if (bufferedEnd > duration) {
    bufferedEnd = duration;
  } // get the percent width of a time compared to the total end


  function percentify(time, end) {
    var percent = time / end || 0; // no NaN

    return "".concat((percent >= 1 ? 1 : percent) * 100, "%");
  } // the width of the progress bar


  style.width = percentify(bufferedEnd, duration);
  var parts = []; // add child elements to represent the individual buffered time ranges

  for (var i = 0; i < buffered.length; i++) {
    var start = buffered.start(i);
    var end = buffered.end(i); // set the percent based on the width of the progress bar (bufferedEnd)

    var part = _react["default"].createElement("div", {
      style: {
        left: percentify(start, bufferedEnd),
        width: percentify(end - start, bufferedEnd)
      },
      key: "part-".concat(i)
    });

    parts.push(part);
  }

  if (parts.length === 0) {
    parts = null;
  }

  return _react["default"].createElement("div", {
    style: style,
    className: (0, _classnames["default"])('video-react-load-progress', className)
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Loaded: 0%"), parts);
}

LoadProgressBar.propTypes = propTypes;
LoadProgressBar.displayName = 'LoadProgressBar';

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(166);

function MouseTimeDisplay(_ref) {
  var duration = _ref.duration,
      mouseTime = _ref.mouseTime,
      className = _ref.className,
      text = _ref.text;

  if (!mouseTime.time) {
    return null;
  }

  var time = text || (0, _utils.formatTime)(mouseTime.time, duration);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-mouse-display', className),
    style: {
      left: "".concat(mouseTime.position, "px")
    },
    "data-current-time": time
  });
}

MouseTimeDisplay.propTypes = {
  duration: _propTypes["default"].number,
  mouseTime: _propTypes["default"].object,
  className: _propTypes["default"].string
};
MouseTimeDisplay.displayName = 'MouseTimeDisplay';
var _default = MouseTimeDisplay;
exports["default"] = _default;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var PlayToggle =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(PlayToggle, _Component);

  function PlayToggle(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, PlayToggle);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlayToggle).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(PlayToggle, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          actions = _this$props.actions,
          player = _this$props.player;

      if (player.paused) {
        actions.play();
      } else {
        actions.pause();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          player = _this$props2.player,
          className = _this$props2.className;
      var controlText = player.paused ? 'Play' : 'Pause';
      return _react["default"].createElement("button", {
        ref: function ref(c) {
          _this2.button = c;
        },
        className: (0, _classnames["default"])(className, {
          'video-react-play-control': true,
          'video-react-control': true,
          'video-react-button': true,
          'video-react-paused': player.paused,
          'video-react-playing': !player.paused
        }),
        type: "button",
        tabIndex: "0",
        onClick: this.handleClick
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, controlText));
    }
  }]);
  return PlayToggle;
}(_react.Component);

exports["default"] = PlayToggle;
PlayToggle.propTypes = propTypes;
PlayToggle.displayName = 'PlayToggle';

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ForwardReplayControl = _interopRequireDefault(__webpack_require__(1001));

// Pass mode into parent function
var ForwardControl = (0, _ForwardReplayControl["default"])('forward');
ForwardControl.displayName = 'ForwardControl';
var _default = ForwardControl;
exports["default"] = _default;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var propTypes = {
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string,
  seconds: _propTypes["default"].oneOf([5, 10, 30])
};
var defaultProps = {
  seconds: 10
};

var _default = function _default(mode) {
  var ForwardReplayControl =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2["default"])(ForwardReplayControl, _Component);

    function ForwardReplayControl(props, context) {
      var _this;

      (0, _classCallCheck2["default"])(this, ForwardReplayControl);
      _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ForwardReplayControl).call(this, props, context));
      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
      return _this;
    }

    (0, _createClass2["default"])(ForwardReplayControl, [{
      key: "handleClick",
      value: function handleClick() {
        var _this$props = this.props,
            actions = _this$props.actions,
            seconds = _this$props.seconds; // Depends mode to implement different actions

        if (mode === 'forward') {
          actions.forward(seconds);
        } else {
          actions.replay(seconds);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            seconds = _this$props2.seconds,
            className = _this$props2.className;
        var classNames = ['video-react-control', 'video-react-button', 'video-react-icon'];
        classNames.push("video-react-icon-".concat(mode, "-").concat(seconds), "video-react-".concat(mode, "-control"));

        if (className) {
          classNames.push(className);
        }

        return _react["default"].createElement("button", {
          ref: function ref(c) {
            _this2.button = c;
          },
          className: classNames.join(' '),
          type: "button",
          onClick: this.handleClick
        }, _react["default"].createElement("span", {
          className: "video-react-control-text"
        }, "".concat(mode, " ").concat(seconds, " seconds")));
      }
    }]);
    return ForwardReplayControl;
  }(_react.Component);

  ForwardReplayControl.propTypes = propTypes;
  ForwardReplayControl.defaultProps = defaultProps;
  return ForwardReplayControl;
};

exports["default"] = _default;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ForwardReplayControl = _interopRequireDefault(__webpack_require__(1001));

// Pass mode into parent function
var ReplayControl = (0, _ForwardReplayControl["default"])('replay');
ReplayControl.displayName = 'ReplayControl';
var _default = ReplayControl;
exports["default"] = _default;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var FullscreenToggle =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(FullscreenToggle, _Component);

  function FullscreenToggle(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, FullscreenToggle);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(FullscreenToggle).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(FullscreenToggle, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;
      actions.toggleFullscreen(player);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          player = _this$props2.player,
          className = _this$props2.className;
      return _react["default"].createElement("button", {
        className: (0, _classnames["default"])(className, {
          'video-react-icon-fullscreen-exit': player.isFullscreen,
          'video-react-icon-fullscreen': !player.isFullscreen
        }, 'video-react-fullscreen-control video-react-control video-react-button video-react-icon'),
        ref: function ref(c) {
          _this2.button = c;
        },
        type: "button",
        tabIndex: "0",
        onClick: this.handleClick
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Non-Fullscreen"));
    }
  }]);
  return FullscreenToggle;
}(_react.Component);

exports["default"] = FullscreenToggle;
FullscreenToggle.propTypes = propTypes;
FullscreenToggle.displayName = 'FullscreenToggle';

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(166);

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function RemainingTimeDisplay(_ref) {
  var _ref$player = _ref.player,
      currentTime = _ref$player.currentTime,
      duration = _ref$player.duration,
      className = _ref.className;
  var remainingTime = duration - currentTime;
  var formattedTime = (0, _utils.formatTime)(remainingTime);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-remaining-time video-react-time-control video-react-control', className)
  }, _react["default"].createElement("div", {
    className: "video-react-remaining-time-display",
    "aria-live": "off"
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Remaining Time "), "-".concat(formattedTime)));
}

RemainingTimeDisplay.propTypes = propTypes;
RemainingTimeDisplay.displayName = 'RemainingTimeDisplay';
var _default = RemainingTimeDisplay;
exports["default"] = _default;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(166);

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function CurrentTimeDisplay(_ref) {
  var _ref$player = _ref.player,
      currentTime = _ref$player.currentTime,
      duration = _ref$player.duration,
      className = _ref.className;
  var formattedTime = (0, _utils.formatTime)(currentTime, duration);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-current-time video-react-time-control video-react-control', className)
  }, _react["default"].createElement("div", {
    className: "video-react-current-time-display",
    "aria-live": "off"
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Current Time "), formattedTime));
}

CurrentTimeDisplay.propTypes = propTypes;
CurrentTimeDisplay.displayName = 'CurrentTimeDisplay';
var _default = CurrentTimeDisplay;
exports["default"] = _default;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(166);

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function DurationDisplay(_ref) {
  var duration = _ref.player.duration,
      className = _ref.className;
  var formattedTime = (0, _utils.formatTime)(duration);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, 'video-react-duration video-react-time-control video-react-control')
  }, _react["default"].createElement("div", {
    className: "video-react-duration-display",
    "aria-live": "off"
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Duration Time "), formattedTime));
}

DurationDisplay.propTypes = propTypes;
DurationDisplay.displayName = 'DurationDisplay';
var _default = DurationDisplay;
exports["default"] = _default;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TimeDivider;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var propTypes = {
  separator: _propTypes["default"].string,
  className: _propTypes["default"].string
};

function TimeDivider(_ref) {
  var separator = _ref.separator,
      className = _ref.className;
  var separatorText = separator || '/';
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-time-control video-react-time-divider', className),
    dir: "ltr"
  }, _react["default"].createElement("div", null, _react["default"].createElement("span", null, separatorText)));
}

TimeDivider.propTypes = propTypes;
TimeDivider.displayName = 'TimeDivider';

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(252));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _PopupButton = _interopRequireDefault(__webpack_require__(2458));

var _VolumeBar = _interopRequireDefault(__webpack_require__(2460));

var propTypes = {
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  vertical: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  alwaysShowVolume: _propTypes["default"].bool
};
var defaultProps = {
  vertical: false
};

var VolumeMenuButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(VolumeMenuButton, _Component);

  function VolumeMenuButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, VolumeMenuButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VolumeMenuButton).call(this, props, context));
    _this.state = {
      active: false
    };
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(VolumeMenuButton, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;
      actions.mute(!player.muted);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      this.setState({
        active: true
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.setState({
        active: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          vertical = _this$props2.vertical,
          player = _this$props2.player,
          className = _this$props2.className;
      var inline = !vertical;
      var level = this.volumeLevel;
      return _react["default"].createElement(_PopupButton["default"], {
        className: (0, _classnames["default"])(className, {
          'video-react-volume-menu-button-vertical': vertical,
          'video-react-volume-menu-button-horizontal': !vertical,
          'video-react-vol-muted': player.muted,
          'video-react-vol-0': level === 0 && !player.muted,
          'video-react-vol-1': level === 1,
          'video-react-vol-2': level === 2,
          'video-react-vol-3': level === 3,
          'video-react-slider-active': this.props.alwaysShowVolume || this.state.active,
          'video-react-lock-showing': this.props.alwaysShowVolume || this.state.active
        }, 'video-react-volume-menu-button'),
        onClick: this.handleClick,
        inline: inline
      }, _react["default"].createElement(_VolumeBar["default"], (0, _extends2["default"])({
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, this.props)));
    }
  }, {
    key: "volumeLevel",
    get: function get() {
      var _this$props$player = this.props.player,
          volume = _this$props$player.volume,
          muted = _this$props$player.muted;
      var level = 3;

      if (volume === 0 || muted) {
        level = 0;
      } else if (volume < 0.33) {
        level = 1;
      } else if (volume < 0.67) {
        level = 2;
      }

      return level;
    }
  }]);
  return VolumeMenuButton;
}(_react.Component);

VolumeMenuButton.propTypes = propTypes;
VolumeMenuButton.defaultProps = defaultProps;
VolumeMenuButton.displayName = 'VolumeMenuButton';
var _default = VolumeMenuButton;
exports["default"] = _default;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(252));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(206));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var propTypes = {
  tagName: _propTypes["default"].string,
  onClick: _propTypes["default"].func.isRequired,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  className: _propTypes["default"].string
};
var defaultProps = {
  tagName: 'div'
};

var ClickableComponent =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ClickableComponent, _Component);

  function ClickableComponent(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, ClickableComponent);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ClickableComponent).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeypress = _this.handleKeypress.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ClickableComponent, [{
    key: "handleKeypress",
    value: function handleKeypress(event) {
      // Support Space (32) or Enter (13) key operation to fire a click event
      if (event.which === 32 || event.which === 13) {
        event.preventDefault();
        this.handleClick(event);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var onClick = this.props.onClick;
      onClick(event);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      document.addEventListener('keydown', this.handleKeypress);

      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      document.removeEventListener('keydown', this.handleKeypress);

      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var Tag = this.props.tagName;
      var props = (0, _objectSpread2["default"])({}, this.props);
      delete props.tagName;
      delete props.className;
      return _react["default"].createElement(Tag, (0, _extends2["default"])({
        className: (0, _classnames["default"])(this.props.className),
        role: "button",
        tabIndex: "0",
        onClick: this.handleClick,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, props));
    }
  }]);
  return ClickableComponent;
}(_react.Component);

exports["default"] = ClickableComponent;
ClickableComponent.propTypes = propTypes;
ClickableComponent.defaultProps = defaultProps;
ClickableComponent.displayName = 'ClickableComponent';

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TUTORIALS_LOAD_SUCCESS; });
var TUTORIALS_LOAD_SUCCESS='TUTORIALS_LOAD_SUCCESS';

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContractorsInvoicesTable_css__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContractorsInvoicesTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ContractorsInvoicesTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_domain_invoice__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_contractors_invoices_store_actions__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_contractors_invoices_store_selectors__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_shared_text_Number__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorsInvoicesTable=function(_Component){_inherits(ContractorsInvoicesTable,_Component);function ContractorsInvoicesTable(props){_classCallCheck(this,ContractorsInvoicesTable);var _this=_possibleConstructorReturn(this,(ContractorsInvoicesTable.__proto__||Object.getPrototypeOf(ContractorsInvoicesTable)).call(this,props));_this.handleDelete=function(invoiceId){_this.setState({invoiceIdToDelete:invoiceId,showDeleteConfirmation:true});};_this.handleDeleteConfirmation=function(response){var invoiceIdToDelete=_this.state.invoiceIdToDelete;_this.setState({invoiceIdToDelete:null,showDeleteConfirmation:false});if(response){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_contractors_invoices_store_actions__["e" /* deleteContractorInvoiceRequest */])(invoiceIdToDelete));}};_this.renderDueDate=function(invoice){var showMarkAsPaid=__WEBPACK_IMPORTED_MODULE_16_services_utils_users_util__["g" /* usersUtil */].isAdmin(_this.props.currentUser)||__WEBPACK_IMPORTED_MODULE_16_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_16_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);if(showMarkAsPaid&&invoice.status!==__WEBPACK_IMPORTED_MODULE_9_domain_invoice__["a" /* InvoiceStatusKeys */].PAID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:__WEBPACK_IMPORTED_MODULE_6_services_utils_date_util__["k" /* todayValidation */],placeholder:'Invoice due date',value:invoice.due_date,onChange:function onChange(value){return _this.handleDueDateChange(invoice.id,value);}});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Date__["a" /* default */],{value:invoice.due_date,format:'LL'});}};_this.handleDueDateChange=function(invoiceId,dueDate){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_contractors_invoices_store_actions__["l" /* updateContractorInvoiceRequest */])(invoiceId,dueDate));};_this.handleMarkAsPaid=function(invoiceId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_contractors_invoices_store_actions__["j" /* markAsPaidRequest */])(invoiceId));};_this.handlePageChange=function(page){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_contractors_invoices_store_actions__["a" /* changePageRequest */])(page,_this.props.searchText));};_this.mapInvoices=function(invoices){var showDelete=_this.userIsContractor;var showMarkAsPaid=__WEBPACK_IMPORTED_MODULE_16_services_utils_users_util__["g" /* usersUtil */].isAdmin(_this.props.currentUser)||__WEBPACK_IMPORTED_MODULE_16_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_16_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);return invoices.map(function(invoice){var buttonComponent=[];if(showDelete&&invoice.status!==__WEBPACK_IMPORTED_MODULE_9_domain_invoice__["a" /* InvoiceStatusKeys */].PAID){buttonComponent.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{key:1,className:'button-blue-grey delete',label:'Delete',onClick:function onClick(){return _this.handleDelete(invoice.id);}}));}if(showMarkAsPaid&&invoice.status!==__WEBPACK_IMPORTED_MODULE_9_domain_invoice__["a" /* InvoiceStatusKeys */].PAID){buttonComponent.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{key:2,className:'button-blue-grey mark-as-paid',label:'Mark as Paid',onClick:function onClick(){return _this.handleMarkAsPaid(invoice.id);}}));}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small-bold'},invoice.work_order_number),_this.userIsContractor?invoice.work_order_job!==null?invoice.work_order_job:'N/A':null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small-bold'},invoice.client_name),invoice.contractor_name,Object(__WEBPACK_IMPORTED_MODULE_3_services_utils_text_util__["e" /* toUpperFirstLetter */])(invoice.status),_this.renderDueDate(invoice),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_shared_text_Number__["a" /* default */],{value:invoice.cost,format:'$0,0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_document_DocumentLink__["a" /* default */],{showIcon:false,url:invoice.document.document.url}),buttonComponent].filter(function(invoice){return invoice;});// filter null
});};_this.state={invoiceIdToDelete:null,showDeleteConfirmation:false};_this.userIsContractor=__WEBPACK_IMPORTED_MODULE_16_services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_16_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);return _this;}_createClass(ContractorsInvoicesTable,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_contractors_invoices_store_actions__["i" /* loadContractorsInvoicesRequest */])());}},{key:'componentDidUpdate',value:function componentDidUpdate(){Object(__WEBPACK_IMPORTED_MODULE_13_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}},{key:'render',value:function render(){var _this2=this;var headers=['WO #',this.userIsContractor?'JOB #':null,'CLIENT NAME','CONTRACTOR NAME','STATUS','DUE DATE','AMOUNT','DOC LINK',''].filter(function(invoice){return invoice!==null;});// filter null
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contractors-invoices-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_table_SimpleTable__["a" /* default */],{className:this.userIsContractor?'for-contractor':'',headers:headers,rows:this.mapInvoices(this.props.invoices),emptyMessage:'No Invoices for Contractor'}),this.props.paginationInfo!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.paginationInfo.currentPage,pageSize:this.props.paginationInfo.pageSize,total:this.props.paginationInfo.total,onPageChange:function onPageChange(page){return _this2.handlePageChange(page);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showDeleteConfirmation,message:'Are you sure?',onHide:this.handleDeleteConfirmation}));}}]);return ContractorsInvoicesTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_15_selectors_authentication__["d" /* getCurrentUser */])(state),invoices:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_contractors_invoices_store_selectors__["a" /* getInvoices */])(state),paginationInfo:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_contractors_invoices_store_selectors__["b" /* getPaginationInfo */])(state),searchText:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_contractors_invoices_store_selectors__["d" /* searchTextSelector */])(state)};})(ContractorsInvoicesTable));

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InvoiceStatusKeys; });
var InvoiceStatusKeys={PENDING:'pending',PAID:'paid'};

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return currentPageSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createFormSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return purchaseOrdersSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return showCreateModalSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var currentPageSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.purchaseOrders.ui.currentPage;},function(currentPage){return currentPage;});var createFormSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.purchaseOrders.ui.createForm;},function(createForm){return createForm;});var purchaseOrdersSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.purchaseOrders.data.purchaseOrders;},function(purchaseOrders){return purchaseOrders;});var showCreateModalSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.purchaseOrders.ui.showCreateModal;},function(showCreateModal){return showCreateModal;});

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Projects_css__ = __webpack_require__(2497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Projects_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Projects_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_SearchBar__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_notifications__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_domain_notification__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_store_selectors__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_store_actions__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_shared_text_SimpleText__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_shared_text_BaseStatus__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_shared_project_status_ProjectStatus__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_domain_project_status_enum__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_header_logo_png__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_header_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_components_header_logo_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Projects=function(_Component){_inherits(Projects,_Component);function Projects(props){_classCallCheck(this,Projects);var _this=_possibleConstructorReturn(this,(Projects.__proto__||Object.getPrototypeOf(Projects)).call(this,props));_this.handleGenerateLink=function(index){var content=_this.props.projects.content;return'projects/'+content[index].id;};_this.handleNavSelect=function(id){_this.loadProjects(id,1);_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_store_actions__["c" /* changeNav */])(id));};_this.handlePageChange=function(newPage){_this.loadProjects(_this.props.currentNav,newPage);};_this.handleAddProject=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_store_actions__["a" /* addProject */])());};_this.handleRowSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_store_actions__["f" /* goToProjectDetails */])(_this.props.projects.content[index].id));};_this.handleSearchTextChange=function(value){var dispatch=_this.props.dispatch;_this.setState({nameToSearch:value},function(){return _this.loadProjects(1,1);});dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_store_actions__["c" /* changeNav */])(1));};_this.handleSearchTextClear=function(){_this.handleSearchTextChange('');};_this.mapProjects=function(projects){var unreadById=Object(__WEBPACK_IMPORTED_MODULE_11_domain_notification__["d" /* unreadNotifications */])(_this.props.notifications,'Project','project_id');return projects.map(function(project){var unread=unreadById&&!!unreadById[project.id];return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,unread&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_shared_text_BaseStatus__["a" /* default */],{labels:[{id:'unread',label:''}],status:'unread'}),project.number),project.name,!_this.userIsGC&&project.general_contractor&&project.general_contractor.name,!_this.userIsClient&&project.client.company_name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_text_SimpleText__["a" /* default */],{lines:[project.building.location.street_address_1,project.building.location.city]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_shared_project_status_ProjectStatus__["a" /* default */],{status:__WEBPACK_IMPORTED_MODULE_19_domain_project_status_enum__["a" /* ProjectStatusEnum */].create(project.status)})].filter(function(attr){return attr;});});};_this.userIsGC=__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);_this.userIsClient=__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["f" /* TYPES */].CLIENT);_this.showActions=__WEBPACK_IMPORTED_MODULE_9_domain_enterprise__["a" /* Enterprise */].showActions(props.currentUser);_this.showMyProjects=__WEBPACK_IMPORTED_MODULE_9_domain_enterprise__["a" /* Enterprise */].showMyProjects(props.currentUser);_this.initialTabSelection=_this.showMyProjects?8:4;_this.state={nameToSearch:''};return _this;}_createClass(Projects,[{key:'componentDidMount',value:function componentDidMount(){this.handleNavSelect(this.initialTabSelection);}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.props.showControls&&Object(__WEBPACK_IMPORTED_MODULE_16_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}},{key:'loadProjects',value:function loadProjects(tabSelection,newPage){var _props=this.props,perPage=_props.perPage,dispatch=_props.dispatch;var nameToSearch=this.state.nameToSearch;var filters={page:newPage,per_page:perPage,by_name:nameToSearch};switch(tabSelection){case 1:dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_store_actions__["i" /* loadProjectsRequest */])(filters));break;case 2:dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_store_actions__["i" /* loadProjectsRequest */])(Object.assign({},filters,{pending:true})));break;case 3:dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_store_actions__["i" /* loadProjectsRequest */])(Object.assign({},filters,{precon:true})));break;case 4:dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_store_actions__["i" /* loadProjectsRequest */])(Object.assign({},filters,{in_progress:true})));break;case 5:dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_store_actions__["i" /* loadProjectsRequest */])(Object.assign({},filters,{cancelled:true})));break;case 6:dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_store_actions__["i" /* loadProjectsRequest */])(Object.assign({},filters,{lost:true})));break;case 7:dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_store_actions__["i" /* loadProjectsRequest */])(Object.assign({},filters,{complete:true})));break;case 8:dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_store_actions__["i" /* loadProjectsRequest */])(Object.assign({},filters,{my_projects:true})));break;default:}}},{key:'render',value:function render(){var nameToSearch=this.state.nameToSearch;var _props2=this.props,showTitle=_props2.showTitle,showControls=_props2.showControls,showNav=_props2.showNav;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'projects'},showTitle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Projects'),this.props.projects!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},showNav&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_SearchBar__["a" /* default */],{addButton:this.showActions&&showControls&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'button',value:'Add Project',onClick:this.handleAddProject}),searchPlaceHolder:'Search by Name',searchText:nameToSearch,onSearchTextChange:this.handleSearchTextChange,onClearText:this.handleSearchTextClear,onSearch:showControls?this.handleSearchTextChange:null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'All'},this.showMyProjects&&{id:8,title:'My Projects',total:this.props.projects.totalMyProjects},{id:2,show:this.props.projects.totalPending>0,title:'Bid/Budget',total:this.props.projects.totalPending},{id:3,show:this.props.projects.totalPrecon>0,title:'Precon',total:this.props.projects.totalPrecon},{id:4,title:'In Progress',total:this.props.projects.totalInProgress},{id:7,show:this.props.projects.totalComplete>0,title:'Complete',total:this.props.projects.totalComplete},{id:5,show:this.props.projects.totalCancelled>0,title:'Cancelled',total:this.props.projects.totalCancelled},{id:6,show:this.props.projects.totalLost>0,title:'Lost',total:this.props.projects.totalLost}].filter(function(item){return item;}),selectedValue:this.props.currentNav,onSelected:this.handleNavSelect})),this.props.projects.total>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table',headers:['PROJECT #','NAME',!this.userIsGC&&'GC NAME',!this.userIsClient&&'CLIENT NAME','LOCATION','STATUS'].filter(function(header){return!!header;}),rows:this.mapProjects(this.props.projects.content),emptyMessage:'No Projects',onRowSelected:this.handleRowSelection,onGenerateLink:this.handleGenerateLink,newView:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.currentPage,pageSize:this.props.projects.pageSize,total:this.props.projects.total,onPageChange:this.handlePageChange})))),this.props.projects!==null&&this.props.projects.total===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'zero-state'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'zero-state-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_20_components_header_logo_png___default.a,className:'logo',alt:'Spackle Logo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'We\u2019re excited to have you join the Spackle Enterprise Platform.'),this.showActions&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Click button below to create your first project!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'button',value:'Create Project',onClick:this.handleAddProject})))));}}]);return Projects;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Projects.propTypes={perPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,showTitle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,showControls:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,showNav:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};Projects.defaultProps={perPage:25,showTitle:true,showControls:true,showNav:true};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_authentication__["d" /* getCurrentUser */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_store_selectors__["e" /* getCurrentPage */])(state),projects:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_store_selectors__["i" /* getProjects */])(state),notifications:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_notifications__["b" /* getNotifications */])(state),currentNav:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_store_selectors__["d" /* getCurrentNav */])(state)};})(Projects));

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewProject_css__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewProject_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NewProject_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_checkbox_CheckBox__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_checkbox_LabeledCheckBox__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_admin_clients_clients__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_admin_clients_clients__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_creation_store_selectors__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_creation_store_actions__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_creation_NewClientModal__ = __webpack_require__(2500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClientSelection=function(_Component){_inherits(ClientSelection,_Component);function ClientSelection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientSelection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientSelection.__proto__||Object.getPrototypeOf(ClientSelection)).call.apply(_ref,[this].concat(args))),_this),_this.handleProjectFormChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_creation_store_actions__["n" /* setProjectFormValue */])(attribute,value));},_this.handleClientSelection=function(value){if(value!==_this.props.projectForm.clientId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_creation_store_actions__["n" /* setProjectFormValue */])('clientId',value));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_creation_store_actions__["n" /* setProjectFormValue */])('buildingId',null));}},_this.handleContinue=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_creation_store_actions__["j" /* nextStage */])());},_this.showAddNewClientModal=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_creation_store_actions__["q" /* setShowNewClientModal */])(true));},_this.handleClientsPageChange=function(newPage){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_clients_clients__["j" /* loadClientsSuccess */])([]));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_clients_clients__["i" /* loadClientsRequest */])(newPage));},_this.advancedDocumentCheckbox=function(){var currentProject=_this.props.currentProject;if(currentProject&&currentProject.documents_count===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{checked:_this.props.projectForm.advancedDocumentView,size:'medium',label:'Enable Advanced Document View',onChange:function onChange(value){return _this.handleProjectFormChange('advancedDocumentView',value);}})));}},_this.mapClients=function(clients){return clients.map(function(client){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_checkbox_CheckBox__["a" /* default */],{id:client.id,checked:client.id===_this.props.projectForm.clientId,shape:'round',size:'medium',onChange:_this.handleClientSelection.bind(_this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},client.company_name),client.contact.first_name+' '+client.contact.last_name];});},_this.canContinue=function(){return!!_this.props.projectForm.number&&!!_this.props.projectForm.name&&!!_this.props.projectForm.sqFootage&&!!_this.props.projectForm.clientId&&!!_this.props.projectForm.bidDueDate;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientSelection,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_clients_clients__["i" /* loadClientsRequest */])(1));}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'selection-title'},'Project Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__["a" /* default */],{placeholder:'Project Number',value:this.props.projectForm.number,onChange:this.handleProjectFormChange.bind(this,'number')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__["a" /* default */],{placeholder:'Project Name',value:this.props.projectForm.name,onChange:this.handleProjectFormChange.bind(this,'name')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__["a" /* default */],{placeholder:'Approx. Square Feet',value:this.props.projectForm.sqFootage?__WEBPACK_IMPORTED_MODULE_14_numeral___default()(this.props.projectForm.sqFootage).format('0,0'):'',onChange:function onChange(value){return _this2.handleProjectFormChange('sqFootage',__WEBPACK_IMPORTED_MODULE_14_numeral___default()(value).value());}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{format:'MM/DD/YY',isValidDate:__WEBPACK_IMPORTED_MODULE_16_services_utils_date_util__["k" /* todayValidation */],placeholder:'Bid Due Date',value:this.props.projectForm.bidDueDate,onChange:function onChange(value){return _this2.handleProjectFormChange('bidDueDate',value);}}))),this.advancedDocumentCheckbox()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'selection-title'},'Which client is the Project for?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange add-new-client-button',type:'button',value:'Add New Client',onClick:this.showAddNewClientModal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selection-table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__["a" /* default */],{headers:['','COMPANY NAME','CONTACT'],rows:this.mapClients(this.props.clients),emptyMessage:'No Clients'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.clientsCurrentPage,pageSize:this.props.clientsPageSize,total:this.props.clientsTotal,onPageChange:this.handleClientsPageChange})),this.props.showNewClientModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_creation_NewClientModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-continue '+(this.canContinue()?'button-orange':'button-disabled'),type:'button',value:'Continue',onClick:this.handleContinue,disabled:!this.canContinue()}));}}]);return ClientSelection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{clients:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_clients_clients__["b" /* getClients */])(state),clientsCurrentPage:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_clients_clients__["c" /* getClientsCurrentPage */])(state),clientsPageSize:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_clients_clients__["d" /* getClientsPageSize */])(state),clientsTotal:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_clients_clients__["e" /* getClientsTotal */])(state),projectForm:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_creation_store_selectors__["g" /* getProjectForm */])(state),showNewClientModal:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_creation_store_selectors__["i" /* getShowNewClientModal */])(state),currentProject:Object(__WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state)};})(ClientSelection));

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewProject_css__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewProject_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NewProject_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_checkbox_CheckBox__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_creation_buildings__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_creation_store_selectors__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_creation_store_actions__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_creation_NewBuildingModal__ = __webpack_require__(2502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BuildingSelection=function(_Component){_inherits(BuildingSelection,_Component);function BuildingSelection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BuildingSelection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BuildingSelection.__proto__||Object.getPrototypeOf(BuildingSelection)).call.apply(_ref,[this].concat(args))),_this),_this.handleProjectFormChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_creation_store_actions__["n" /* setProjectFormValue */])(attribute,value));},_this.showAddNewBuildingModal=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_creation_store_actions__["p" /* setShowNewBuildingModal */])(true));},_this.mapBuildings=function(buildings){return buildings.map(function(building){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_checkbox_CheckBox__["a" /* default */],{id:building.id,checked:building.id===_this.props.projectForm.buildingId,shape:'round',size:'medium',onChange:_this.handleProjectFormChange.bind(_this,'buildingId')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},building.location.street_address_1+', '+building.location.city+', '+building.location.state+' '+building.location.zip),building.name||'N/A'];});},_this.mapBuildingData=function(){var buildingForm=_this.props.buildingForm;return{name:buildingForm.name,location:{streetAddress:buildingForm.streetAddress1,unitNumber:buildingForm.streetAddress2,city:buildingForm.city,state:buildingForm.state,zip:buildingForm.zip},clientsId:[_this.props.projectForm.clientId]};},_this.canContinue=function(){return!!_this.props.projectForm.buildingId;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BuildingSelection,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_creation_buildings__["e" /* loadBuildingsRequest */])(this.props.projectForm.clientId));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'selection-title'},'What property is the Project for?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange add-new-building-button',type:'button',value:'Add New Building',onClick:this.showAddNewBuildingModal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selection-table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__["a" /* default */],{headers:['','ADDRESS','BUILDING NAME'],rows:this.mapBuildings(this.props.buildings),emptyMessage:'No Buildings'})),this.props.showNewProjectModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_creation_NewBuildingModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-continue '+(this.canContinue()?'button-orange':'button-disabled'),type:'button',value:this.props.submitButtonLabel,onClick:this.props.submitFunction,disabled:!this.canContinue()}));}}]);return BuildingSelection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BuildingSelection.propTypes={submitButtonLabel:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string.isRequired,submitFunction:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{buildings:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_work_orders__["a" /* getBuildings */])(state),projectForm:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_creation_store_selectors__["g" /* getProjectForm */])(state),showNewProjectModal:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_creation_store_selectors__["h" /* getShowNewBuildingModal */])(state)};})(BuildingSelection));

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rfisApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_utils_due_date_filter_util__ = __webpack_require__(624);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable default-case */var RfisApi=function(_BaseApi){_inherits(RfisApi,_BaseApi);function RfisApi(){_classCallCheck(this,RfisApi);return _possibleConstructorReturn(this,(RfisApi.__proto__||Object.getPrototypeOf(RfisApi)).apply(this,arguments));}_createClass(RfisApi,[{key:'getRfis',value:function getRfis(projectId,page,status,dueDateFilter){var dueDateQuery=__WEBPACK_IMPORTED_MODULE_3_services_utils_due_date_filter_util__["a" /* DueDateFilterUtil */].getDueDateQuery(dueDateFilter);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/rfis?page='+page+'&'+status+'=true'+(dueDateQuery?'&'+dueDateQuery:'')).then(function(response){return{ok:true,rfis:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getRfisAll',value:function getRfisAll(page,filters){var query='page='+page;Object.keys(filters).forEach(function(filter){query+='&'+filter+'='+filters[filter];});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/rfis?'+query).then(function(response){return{ok:true,rfis:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getRfisAllCount',value:function getRfisAllCount(filters){var query='';Object.keys(filters).forEach(function(filter,index){if(index>0){query+='&';}query+=filter+'='+filters[filter];});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/rfis/count?'+query).then(function(response){return{ok:true,count:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getRfi',value:function getRfi(projectId,rfiId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/rfis/'+rfiId).then(function(response){return{ok:true,rfi:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getRfiLogPdf',value:function getRfiLogPdf(projectId,status){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/rfi_log/print?'+status+'=true',{responseType:'blob'}).then(function(response){return{ok:true,rfiLogPdf:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createRfi',value:function createRfi(projectId,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var data=this.rfiParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/projects/'+projectId+'/rfis',data,headers).then(function(response){return{ok:true,rfi:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateRfi',value:function updateRfi(projectId,rfiId,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var data=this.rfiParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/rfis/'+rfiId,data,headers).then(function(response){return{ok:true,rfi:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'respondRfi',value:function respondRfi(projectId,rfiId,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var data=this.respondRfiParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/rfis/'+rfiId+'/respond',data,headers).then(function(response){return{ok:true,rfi:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'deleteRfi',value:function deleteRfi(projectId,rfiId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/projects/'+projectId+'/rfis/'+rfiId).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'rfiParams',value:function rfiParams(values){var questionsIndex=0;var apiPayload=new FormData();apiPayload.append('rfi[csi_code_id]',values.csiCodeId);apiPayload.append('rfi[due_date]',values.dueDate);apiPayload.append('rfi[extended_due_date]',values.extendedDueDate);apiPayload.append('rfi[status]',values.status);apiPayload.append('rfi[title]',values.title);if(values.contractorId){apiPayload.append('rfi[contractor_id]',values.contractorId);}values.relCsiCodeIds.forEach(function(csiCodeId){apiPayload.append('rfi[rel_csi_code_ids][]',csiCodeId);});values.recipientIds.forEach(function(rcptId){apiPayload.append('rfi[recipient_ids][]',rcptId);});values.questions.forEach(function(qus){var reqImgsIndex=0;var reqDocsIndex=0;apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][number]',qus.number);apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][assignee_id]',qus.assigneeId);apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][action]',qus.action);apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][question]',qus.question);apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][resolved]',qus.resolved);if(qus.id){apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][id]',qus.id);}qus.addlAssignees.forEach(function(addlAssignee,index){if(addlAssignee.id){apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][rfi_addl_assignees_attributes]['+index+'][id]',addlAssignee.id);}if(addlAssignee.destroy){apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][rfi_addl_assignees_attributes]['+index+'][_destroy]',true);}else{apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][rfi_addl_assignees_attributes]['+index+'][assignee_id]',addlAssignee.assigneeId);apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][rfi_addl_assignees_attributes]['+index+'][due_date]',addlAssignee.dueDate);}});qus.reqImages.filter(function(img){return img.file;}).forEach(function(img){var file=img.file;apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][request_images_attributes]['+reqImgsIndex+'][image]',file,file.name);reqImgsIndex++;});qus.reqDocs.filter(function(doc){return doc.file;}).forEach(function(doc){var file=doc.file;apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][request_documents_attributes]['+reqDocsIndex+'][document]',file,file.name);reqDocsIndex++;});qus.reqImagesDelete.filter(function(img){return img.id;}).forEach(function(img){apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][request_images_attributes]['+reqImgsIndex+'][id]',img.id);apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][request_images_attributes]['+reqImgsIndex+'][_destroy]',true);reqImgsIndex++;});qus.reqDocsDelete.filter(function(doc){return doc.id;}).forEach(function(doc){apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][request_documents_attributes]['+reqDocsIndex+'][id]',doc.id);apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][request_documents_attributes]['+reqDocsIndex+'][_destroy]',true);reqDocsIndex++;});questionsIndex++;});values.questionsDeleted&&values.questionsDeleted.filter(function(qus){return qus.id;}).forEach(function(qus){apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][id]',qus.id);apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][_destroy]',true);questionsIndex++;});return apiPayload;}},{key:'respondRfiParams',value:function respondRfiParams(values){var questionsIndex=0;var apiPayload=new FormData();apiPayload.append('draft',values.draft);values.questions.filter(function(qus){return qus.id;}).forEach(function(qus){var resImgsIndex=0;var resDocsIndex=0;apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][id]',qus.id);apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][response]',qus.response||'');apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][draft_response]',qus.draftResponse);qus.resImages.filter(function(img){return img.file;}).forEach(function(img){var file=img.file;apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][response_images_attributes]['+resImgsIndex+'][image]',file,file.name);resImgsIndex++;});qus.resDocs.filter(function(doc){return doc.file;}).forEach(function(doc){var file=doc.file;apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][response_documents_attributes]['+resDocsIndex+'][document]',file,file.name);resDocsIndex++;});qus.resImagesDelete.filter(function(img){return img.id;}).forEach(function(img){apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][response_images_attributes]['+resImgsIndex+'][id]',img.id);apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][response_images_attributes]['+resImgsIndex+'][_destroy]',true);resImgsIndex++;});qus.resDocsDelete.filter(function(doc){return doc.id;}).forEach(function(doc){apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][response_documents_attributes]['+resDocsIndex+'][id]',doc.id);apiPayload.append('rfi[rfi_questions_attributes]['+questionsIndex+'][response_documents_attributes]['+resDocsIndex+'][_destroy]',true);resDocsIndex++;});questionsIndex++;});return apiPayload;}}]);return RfisApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var rfisApi=new RfisApi();

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DailyReportUtil; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var DailyReportUtil=function(){function DailyReportUtil(){_classCallCheck(this,DailyReportUtil);}_createClass(DailyReportUtil,null,[{key:'gcLabel',value:function gcLabel(generalContractor){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'00 - General Contractor - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,generalContractor.name));}},{key:'tradeLabel',value:function tradeLabel(projectContributor){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,projectContributor.csi_code.division,' -',' ',projectContributor.csi_code.label,' -',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,projectContributor.company.name));}}]);return DailyReportUtil;}();

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fieldWorkOrdersApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FieldWorkOrdersApi=function(_BaseApi){_inherits(FieldWorkOrdersApi,_BaseApi);function FieldWorkOrdersApi(){_classCallCheck(this,FieldWorkOrdersApi);return _possibleConstructorReturn(this,(FieldWorkOrdersApi.__proto__||Object.getPrototypeOf(FieldWorkOrdersApi)).apply(this,arguments));}_createClass(FieldWorkOrdersApi,[{key:'getFieldWorkOrders',value:function getFieldWorkOrders(projectId,currentPage,spackleOrGc){var gcFilters=spackleOrGc?'&gc_stage=true':'';return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/field_work_orders?page='+currentPage+gcFilters).then(function(response){return{ok:true,fieldWorkOrders:response.data,total:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['per-page']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getFieldWorkOrdersAll',value:function getFieldWorkOrdersAll(page,filters){var query='page='+page;Object.keys(filters).forEach(function(filter){query+='&'+filter+'='+filters[filter];});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/field_work_orders?'+query).then(function(response){return{ok:true,fieldWorkOrders:response.data,total:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['per-page']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getFieldWorkOrdersAllCount',value:function getFieldWorkOrdersAllCount(filters){var query='';Object.keys(filters).forEach(function(filter,index){if(index>0){query+='&';}query+=filter+'='+filters[filter];});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/field_work_orders/count?'+query).then(function(response){return{ok:true,count:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['total']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getFieldWorkOrder',value:function getFieldWorkOrder(projectId,id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/field_work_orders/'+id).then(function(response){return{ok:true,fieldWorkOrder:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateFieldWorkOrder',value:function updateFieldWorkOrder(projectId,fieldWorkOrderId,fieldWorkOrderData){var data=this.fieldWorkOrderParams(fieldWorkOrderData);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/field_work_orders/'+fieldWorkOrderId,data).then(function(response){return{ok:true,fieldWorkOrder:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'fieldWorkOrderParams',value:function fieldWorkOrderParams(fieldWorkOrderData){var status=fieldWorkOrderData.fwoStatus.value;var data={field_work_order:{number:fieldWorkOrderData.fwoNumber,preset_task_ids:fieldWorkOrderData.fwoPresetTasks.length>0?fieldWorkOrderData.fwoPresetTasks.map(function(task){return task[0];}):[],preset_task_other:fieldWorkOrderData.fwoCustomTask,work_performed:fieldWorkOrderData.fwoWorkPerformed,comments:fieldWorkOrderData.fwoComments,start_date:fieldWorkOrderData.fwoStartDate,completion_date:fieldWorkOrderData.fwoCompletionDate,labor:fieldWorkOrderData.fwoLabor,materials:fieldWorkOrderData.fwoMaterials,cost_impact:fieldWorkOrderData.fwoCostImpact,cost:fieldWorkOrderData.fwoCostImpact?fieldWorkOrderData.fwoCost:'',delay:fieldWorkOrderData.fwoDelay,delay_reason:fieldWorkOrderData.fwoDelay?fieldWorkOrderData.fwoDelayReason:'',denied_reason:''}};if(status==='approved'){data={field_work_order:Object.assign({},data.field_work_order,{approved:true})};}if(status==='denied'){data={field_work_order:Object.assign({},data.field_work_order,{denied:true,denied_reason:fieldWorkOrderData.fwoDeniedReason})};}return data;}}]);return FieldWorkOrdersApi;}(__WEBPACK_IMPORTED_MODULE_2__base_api__["a" /* default */]);var fieldWorkOrdersApi=new FieldWorkOrdersApi();

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return csiCodesApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CsiCodesApi=function(_BaseApi){_inherits(CsiCodesApi,_BaseApi);function CsiCodesApi(){_classCallCheck(this,CsiCodesApi);return _possibleConstructorReturn(this,(CsiCodesApi.__proto__||Object.getPrototypeOf(CsiCodesApi)).apply(this,arguments));}_createClass(CsiCodesApi,[{key:'getCsiCodes',value:function getCsiCodes(){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/csi_codes').then(function(response){return{ok:true,csiCodes:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getPresetTasks',value:function getPresetTasks(id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/csi_codes/'+id+'/preset_tasks').then(function(response){return{ok:true,presetTasks:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getSupervisorTasks',value:function getSupervisorTasks(){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/supervisor_tasks').then(function(response){return{ok:true,presetTasks:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return CsiCodesApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var csiCodesApi=new CsiCodesApi();

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return projectOpenItemsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_due_date_filter_util__ = __webpack_require__(624);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectOpenItemsApi=function(_BaseApi){_inherits(ProjectOpenItemsApi,_BaseApi);function ProjectOpenItemsApi(){_classCallCheck(this,ProjectOpenItemsApi);return _possibleConstructorReturn(this,(ProjectOpenItemsApi.__proto__||Object.getPrototypeOf(ProjectOpenItemsApi)).apply(this,arguments));}_createClass(ProjectOpenItemsApi,[{key:'getProjectOpenItems',value:function getProjectOpenItems(projectId,page,critical,status,dueDateFilter){var dueDateQuery=__WEBPACK_IMPORTED_MODULE_4_services_utils_due_date_filter_util__["a" /* DueDateFilterUtil */].getDueDateQuery(dueDateFilter);var filters='page='+page;if(critical!==undefined){filters+=critical?'&critical=true':'&non_critical=true';}if(status!==undefined){filters+=status==='past_due'?'&'+status+'='+__WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD'):'&'+status+'=true';}filters+=dueDateQuery?'&'+dueDateQuery:'';return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/project_open_items?'+filters).then(function(response){return{ok:true,projectOpenItems:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getProjectOpenItemsAll',value:function getProjectOpenItemsAll(page,filters){var query='page='+page;Object.keys(filters).forEach(function(filter){query+='&'+filter+'='+filters[filter];});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/project_open_items?'+query).then(function(response){return{ok:true,projectOpenItems:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getProjectOpenItem',value:function getProjectOpenItem(projectId,id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/project_open_items/'+id).then(function(response){return{ok:true,projectOpenItem:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getProjectOpenItemsAllCount',value:function getProjectOpenItemsAllCount(filters){var query='';Object.keys(filters).forEach(function(filter,index){if(index>0){query+='&';}query+=filter+'='+filters[filter];});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/project_open_items/count?'+query).then(function(response){return{ok:true,count:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),countCritical:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-critical']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getProjectOpenItemsCount',value:function getProjectOpenItemsCount(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/project_open_items/count').then(function(response){return{ok:true,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),totalCritical:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total-critical']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getProjectOpenItemNotes',value:function getProjectOpenItemNotes(id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/project_open_items/'+id+'/notes').then(function(response){return{ok:true,projectOpenItemNotes:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'markProjectOpenItemNotesRead',value:function markProjectOpenItemNotesRead(id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/project_open_items/'+id+'/notes/mark_all_read').then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createProjectOpenItemNote',value:function createProjectOpenItemNote(id,content){var headers={headers:{'Content-Type':'multipart/form-data'}};var apiPayload=new FormData();apiPayload.append('note[content]',content.content);var index=0;if(content.images&&content.images.length>0){content.images.filter(function(image){return!image.id;}).forEach(function(image){apiPayload.append('note[images_attributes]['+index+'][image]',image.file,image.file.name);index++;});}index=0;if(content.documents&&content.documents.length>0){content.documents.filter(function(doc){return!doc.id;}).forEach(function(doc){apiPayload.append('note[documents_attributes]['+index+'][document]',doc.file,doc.file.name);index++;});}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/project_open_items/'+id+'/notes',apiPayload,headers).then(function(response){return{ok:true,projectOpenItemNote:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createProjectOpenItem',value:function createProjectOpenItem(projectId,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var data=this.projectOpenItemParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/projects/'+projectId+'/project_open_items',data,headers).then(function(response){return{ok:true,projectOpenItem:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateProjectOpenItem',value:function updateProjectOpenItem(projectId,id,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var data=this.projectOpenItemParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/project_open_items/'+id,data,headers).then(function(response){return{ok:true,projectOpenItem:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'respondProjectOpenItem',value:function respondProjectOpenItem(projectId,id,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var data=this.respondProjectOpenItemParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/project_open_items/'+id+'/respond',data,headers).then(function(response){return{ok:true,projectOpenItem:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'deleteProjectOpenItem',value:function deleteProjectOpenItem(projectId,id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/projects/'+projectId+'/project_open_items/'+id).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'projectOpenItemParams',value:function projectOpenItemParams(values){var apiPayload=new FormData();apiPayload.append('project_open_item[project_contributor_id]',values.projectContributorId||'');apiPayload.append('project_open_item[assignee_id]',values.assigneeId||'');apiPayload.append('project_open_item[resolve_by]',values.resolveBy||'');apiPayload.append('project_open_item[description]',values.description||'');apiPayload.append('project_open_item[critical]',values.critical||false);apiPayload.append('project_open_item[resolved]',values.resolved||false);apiPayload.append('project_open_item[draft]',values.draft||false);if(values.recipientIds&&values.recipientIds.length>0){values.recipientIds.forEach(function(rcptId){apiPayload.append('project_open_item[recipient_ids][]',rcptId);});}else{apiPayload.append('project_open_item[recipient_ids][]',[]);}var index=0;if(values.images&&values.images.length>0){values.images.filter(function(image){return!image.id;}).forEach(function(image){apiPayload.append('project_open_item[images_attributes]['+index+'][image]',image.file,image.file.name);index++;});}if(values.deletedImages&&values.deletedImages.length>0){values.deletedImages.filter(function(image){return image.id;}).forEach(function(image){apiPayload.append('project_open_item[images_attributes]['+index+'][id]',image.id);apiPayload.append('project_open_item[images_attributes]['+index+'][_destroy]',true);index++;});}index=0;if(values.documents&&values.documents.length>0){values.documents.filter(function(doc){return!doc.id;}).forEach(function(doc){apiPayload.append('project_open_item[documents_attributes]['+index+'][document]',doc.file,doc.file.name);index++;});}if(values.deletedDocuments&&values.deletedDocuments.length>0){values.deletedDocuments.filter(function(doc){return doc.id;}).forEach(function(doc){apiPayload.append('project_open_item[documents_attributes]['+index+'][id]',doc.id);apiPayload.append('project_open_item[documents_attributes]['+index+'][_destroy]',true);index++;});}return apiPayload;}},{key:'respondProjectOpenItemParams',value:function respondProjectOpenItemParams(values){var apiPayload=new FormData();apiPayload.append('project_open_item[response]',values.response||'');apiPayload.append('project_open_item[draft_response]',values.draftResponse||false);var index=0;if(values.images&&values.images.length>0){values.images.filter(function(image){return!image.id;}).forEach(function(image){apiPayload.append('project_open_item[response_images_attributes]['+index+'][image]',image.file,image.file.name);index++;});}if(values.deletedImages&&values.deletedImages.length>0){values.deletedImages.filter(function(image){return image.id;}).forEach(function(image){apiPayload.append('project_open_item[response_images_attributes]['+index+'][id]',image.id);apiPayload.append('project_open_item[response_images_attributes]['+index+'][_destroy]',true);index++;});}index=0;if(values.documents&&values.documents.length>0){values.documents.filter(function(doc){return!doc.id;}).forEach(function(doc){apiPayload.append('project_open_item[response_documents_attributes]['+index+'][document]',doc.file,doc.file.name);index++;});}if(values.deletedDocuments&&values.deletedDocuments.length>0){values.deletedDocuments.filter(function(doc){return doc.id;}).forEach(function(doc){apiPayload.append('project_open_item[response_documents_attributes]['+index+'][id]',doc.id);apiPayload.append('project_open_item[response_documents_attributes]['+index+'][_destroy]',true);index++;});}return apiPayload;}}]);return ProjectOpenItemsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var projectOpenItemsApi=new ProjectOpenItemsApi();

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSEOUT_CATS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CLOSEOUT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLOSEOUT_CONTRIBS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLOSEOUT_CONTRIB_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CLOSEOUT_PERCENTAGE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLOSEOUT_MANUALS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLOSEOUT_MANUAL_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CLOSEOUT_MANUAL_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLOSEOUT_MANUAL_DELETE; });
var CLOSEOUT_CATS_SET='CLOSEOUT_CATS_SET';var CLOSEOUT_SET='CLOSEOUT_SET';var CLOSEOUT_CONTRIBS_SET='CLOSEOUT_CONTRIBS_SET';var CLOSEOUT_CONTRIB_SET='CLOSEOUT_CONTRIB_SET';var CLOSEOUT_PERCENTAGE_SET='CLOSEOUT_PERCENTAGE_SET';var CLOSEOUT_MANUALS_SET='CLOSEOUT_MANUALS_SET';var CLOSEOUT_MANUAL_SET='CLOSEOUT_MANUAL_SET';var CLOSEOUT_MANUAL_UPDATE='CLOSEOUT_MANUAL_UPDATE';var CLOSEOUT_MANUAL_DELETE='CLOSEOUT_MANUAL_DELETE';

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return directoriesApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DirectoriesApi=function(_BaseApi){_inherits(DirectoriesApi,_BaseApi);function DirectoriesApi(){_classCallCheck(this,DirectoriesApi);return _possibleConstructorReturn(this,(DirectoriesApi.__proto__||Object.getPrototypeOf(DirectoriesApi)).apply(this,arguments));}_createClass(DirectoriesApi,[{key:'getDirectory',value:function getDirectory(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/directory').then(function(response){return{ok:true,directory:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getDirectoryPdf',value:function getDirectoryPdf(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/directory/print',{responseType:'blob'}).then(function(response){return{ok:true,directoryPdf:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return DirectoriesApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var directoriesApi=new DirectoriesApi();

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__createBinding"] = __createBinding;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__spreadArrays"] = __spreadArrays;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/* harmony export (immutable) */ __webpack_exports__["__classPrivateFieldGet"] = __classPrivateFieldGet;
/* harmony export (immutable) */ __webpack_exports__["__classPrivateFieldSet"] = __classPrivateFieldSet;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAPCAYAAAAyPTUwAAAAAXNSR0IArs4c6QAAASpJREFUKBVjZICChoYGpo2H7xf++88Qz/CfQYGRgeESExNjy7m9C3bA1DDDGB+Y5Of9//+/lJGRYS8DI+NGBob/ykB+lYSy/t2X9y9eAqkDGsDAoO8UZwY07SQDE0PGxb2LZoLEgAoZDZ0TVgJpF0F7JbEDDQ1/mEASTIxMNkDTfgraKs0F8UGAkZHxP1BiGpAp+PHgI22QGFjxf4b/IkD2B5BukCAMsDAxvwGzWf6C5BlYQMT/fwzcQINYjNyTVf79+wt2Gkj8z++/ciCa4S+DGIhi1HeKXw50YASIgxcwMq5gAioMx6sIJglUB3Iz3FqYOA6aEexBHJIYwoNFMTAtXMRwHBYBRgbGCyycrKxO3/789mL6x8QGU/OP8f9/GBtEAw38xcPBtQ0AdENa0PdzT0sAAAAASUVORK5CYII="

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RfiDocuments_css__ = __webpack_require__(2587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RfiDocuments_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RfiDocuments_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_upload_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_upload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_document_DocumentLinkBluebeam__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RfiDocuments=function(_Component){_inherits(RfiDocuments,_Component);function RfiDocuments(props){_classCallCheck(this,RfiDocuments);var _this=_possibleConstructorReturn(this,(RfiDocuments.__proto__||Object.getPrototypeOf(RfiDocuments)).call(this,props));_initialiseProps.call(_this);switch(props.fileType){case'req':_this.imgsAttr='reqImages';_this.docsAttr='reqDocs';_this.imgsDelAttr='reqImagesDelete';_this.docsDelAttr='reqDocsDelete';_this.rfiImgsAttr='request_images';_this.rfiDocsAttr='request_documents';break;case'res':_this.imgsAttr='resImages';_this.docsAttr='resDocs';_this.imgsDelAttr='resImagesDelete';_this.docsDelAttr='resDocsDelete';_this.rfiImgsAttr='response_images';_this.rfiDocsAttr='response_documents';break;default:}if(props.question.id){_this.initFiles(props);}return _this;}_createClass(RfiDocuments,[{key:'render',value:function render(){var _this2=this;var _props=this.props,questionAddlAssignee=_props.questionAddlAssignee,question=_props.question,fileType=_props.fileType,readOnly=_props.readOnly;var filteredAddlAssignees=question&&fileType==='res'&&this.filteredAddlAssignees();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["s" /* Row */],{className:'rfi-documents'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{sm:12},(!readOnly||this.filesPresent(this.rfiDocsAttr))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* ControlLabel */],sm:1},'Documents'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{sm:8},filteredAddlAssignees&&filteredAddlAssignees.map(function(addlAssignee){return _this2.mapFiles(addlAssignee[_this2.rfiDocsAttr],'document').map(function(doc,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'doc-viewer doc-viewer-read-only',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_document_DocumentLinkBluebeam__["a" /* default */],{file:doc}),_this2.renderUploaderName(addlAssignee.assignee));});}),questionAddlAssignee&&question[this.rfiDocsAttr]&&this.mapFiles(question[this.rfiDocsAttr],'document').map(function(doc,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'doc-viewer doc-viewer-read-only',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_document_DocumentLinkBluebeam__["a" /* default */],{file:doc}),_this2.renderUploaderName(question.responded_by));}),question[this.docsAttr]&&question[this.docsAttr].map(function(doc,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'doc-viewer'+(readOnly?' doc-viewer-read-only':''),key:index},!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'remove-doc-icon',src:__WEBPACK_IMPORTED_MODULE_6_images_remove_png___default.a,alt:'remove',onClick:function onClick(){return _this2.removeRfiDocument(index);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_document_DocumentLinkBluebeam__["a" /* default */],{file:doc}),readOnly&&fileType==='res'&&_this2.renderUploaderName(questionAddlAssignee?questionAddlAssignee.assignee:question.responded_by));}),!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx',className:'dropzone-container',onDrop:this.dropRfiDocuments},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Please drag and drop any file into this area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5_images_upload_svg___default.a,alt:'upload'})))),(!readOnly||this.filesPresent(this.rfiImgsAttr))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* ControlLabel */],sm:1},'Photos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{sm:8},filteredAddlAssignees&&filteredAddlAssignees.filter(function(addlAssignee){return addlAssignee[_this2.rfiImgsAttr].length>0;}).map(function(addlAssignee,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'img-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],images:_this2.mapFiles(addlAssignee[_this2.rfiImgsAttr],'image'),readOnly:true}),_this2.renderUploaderName(addlAssignee.assignee));}),questionAddlAssignee&&question[this.rfiImgsAttr]&&question[this.rfiImgsAttr].length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],images:this.mapFiles(question[this.rfiImgsAttr],'image'),readOnly:true}),this.renderUploaderName(question.responded_by)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-viewer'+(!question[this.imgsAttr]||question[this.imgsAttr].length===0?' img-viewer-empty':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],images:question[this.imgsAttr],readOnly:readOnly,onRemove:function onRemove(index){return _this2.removeRfiImage(index);},onUpload:function onUpload(files){return _this2.setRfiImages(files);}}),readOnly&&fileType==='res'&&question[this.imgsAttr]&&question[this.imgsAttr].length>0&&this.renderUploaderName(questionAddlAssignee?questionAddlAssignee.assignee:question.responded_by))))));}}]);return RfiDocuments;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RfiDocuments.propTypes={questionKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,question:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,questionAddlAssignee:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,fileType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['req','res']).isRequired,handleQuestionChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleQuestionDeleteFile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};RfiDocuments.defaultProps={questionAddlAssignee:null};var _initialiseProps=function _initialiseProps(){var _this3=this;this.filesPresent=function(attr){var _props2=_this3.props,question=_props2.question,fileType=_props2.fileType;var rfiFilesPresent=question&&question[attr]&&question[attr].length>0;var addlAssigneesFilesPresent=question&&fileType==='res'&&question.rfi_addl_assignees.find(function(addlAssignee){return addlAssignee[attr].length>0;});return!!(rfiFilesPresent||addlAssigneesFilesPresent);};this.mapFiles=function(files,type){return(files||[]).map(function(file){return{id:file.id,url:file[type].url,preview:file[type].gallery&&file[type].gallery.url};});};this.initFiles=function(props){var questionAddlAssignee=props.questionAddlAssignee,question=props.question,fileType=props.fileType;if(questionAddlAssignee&&fileType==='res'){_this3.handleFormChange(_this3.imgsAttr,_this3.mapFiles(questionAddlAssignee[_this3.rfiImgsAttr],'image'));_this3.handleFormChange(_this3.docsAttr,_this3.mapFiles(questionAddlAssignee[_this3.rfiDocsAttr],'document'));}else{_this3.handleFormChange(_this3.imgsAttr,_this3.mapFiles(question[_this3.rfiImgsAttr],'image'));_this3.handleFormChange(_this3.docsAttr,_this3.mapFiles(question[_this3.rfiDocsAttr],'document'));}};this.setImages=function(files,imagesRef){var images=imagesRef.slice();files.forEach(function(val){images.push({url:URL.createObjectURL(val),file:val});});return images;};this.setRfiImages=function(files){var images=_this3.setImages(files,_this3.props.question[_this3.imgsAttr]);_this3.handleFormChange(_this3.imgsAttr,images);};this.removeRfiImage=function(index){var img=_this3.props.question[_this3.imgsAttr][index];_this3.props.question[_this3.imgsAttr].splice(index,1);_this3.handleFormDeleteFile(_this3.imgsDelAttr,img);_this3.handleFormChange(_this3.imgsAttr,_this3.props.question[_this3.imgsAttr]);};this.dropDocuments=function(files,docsRef){var docs=docsRef.slice();files.forEach(function(val){docs.push({file:val,name:val.name});});return docs;};this.dropRfiDocuments=function(files){var docs=_this3.dropDocuments(files,_this3.props.question[_this3.docsAttr]);_this3.handleFormChange(_this3.docsAttr,docs);};this.removeRfiDocument=function(index){var doc=_this3.props.question[_this3.docsAttr][index];_this3.props.question[_this3.docsAttr].splice(index,1);_this3.handleFormDeleteFile(_this3.docsDelAttr,doc);_this3.handleFormChange(_this3.docsAttr,_this3.props.question[_this3.docsAttr]);};this.filteredAddlAssignees=function(){var _props3=_this3.props,question=_props3.question,questionAddlAssignee=_props3.questionAddlAssignee;return question.rfi_addl_assignees.filter(function(addlAssignee){return!questionAddlAssignee||questionAddlAssignee.assignee_id!==addlAssignee.assignee_id;});};this.renderUploaderName=function(uploadedBy){return uploadedBy&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,uploadedBy.first_name,' ',uploadedBy.last_name);};this.handleFormChange=function(attribute,value){var _props4=_this3.props,questionKey=_props4.questionKey,handleQuestionChange=_props4.handleQuestionChange;handleQuestionChange(questionKey,attribute,value);};this.handleFormDeleteFile=function(attribute,value){var _props5=_this3.props,questionKey=_props5.questionKey,handleQuestionDeleteFile=_props5.handleQuestionDeleteFile;handleQuestionDeleteFile(questionKey,attribute,value);};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(RfiDocuments));

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DocumentLink_css__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DocumentLink_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DocumentLink_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_react_fontawesome__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_regular_faFilePdf__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_regular_faFilePdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_regular_faFilePdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_regular_faFileWord__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_regular_faFileWord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_regular_faFileWord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_free_regular_faFileExcel__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_free_regular_faFileExcel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_free_regular_faFileExcel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_free_regular_faFileImage__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_free_regular_faFileImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_free_regular_faFileImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_pdf_viewer_bluebeam_PdfViewerBluebeam__ = __webpack_require__(2588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_api_bluebeam_api__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_selectors_pdfViewerBluebeam__ = __webpack_require__(2592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_actions_pdfViewerBluebeam__ = __webpack_require__(636);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DocumentLinkBluebeam=function(_Component){_inherits(DocumentLinkBluebeam,_Component);function DocumentLinkBluebeam(props){_classCallCheck(this,DocumentLinkBluebeam);var _this=_possibleConstructorReturn(this,(DocumentLinkBluebeam.__proto__||Object.getPrototypeOf(DocumentLinkBluebeam)).call(this,props));_initialiseProps.call(_this);_this.state={showDocumentPdfViewer:false,pdfUrl:null};return _this;}_createClass(DocumentLinkBluebeam,[{key:'render',value:function render(){var props=this.props;var fileName=this.getName(props);var extension=this.getExtension(fileName);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'document-link'},(!props.file.id||extension!=='pdf')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:!props.showLink?'not-active':null,href:this.getUrl(props),target:'_blank',onClick:function onClick(event){return event.stopPropagation();}// to use inside SimpleTable (which prevents defaults on tr clicks)
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.getName(props)))),props.file.id&&extension==='pdf'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{label:fileName,onClick:this.showPdf}),props.showIcon&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.getIcon(props))),props.showInModal&&props.file.id&&extension==='pdf'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_pdf_viewer_bluebeam_PdfViewerBluebeam__["a" /* default */],{content:{source:this.state.pdfUrl,type:'url'},show:this.state.showDocumentPdfViewer,onClose:this.handleDocumentPdfViewerClose,documentId:props.file.id,fileName:fileName,pdftronIntegration:true,bbIntegration:true,blueBeamLink:null})));}}]);return DocumentLinkBluebeam;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DocumentLinkBluebeam.propTypes={file:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,showIcon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,showLink:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,createdBluebeamSession:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,showInModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};DocumentLinkBluebeam.defaultProps={file:null,showIcon:true,showLink:true,createdBluebeamSession:false,showInModal:true};var _initialiseProps=function _initialiseProps(){var _this2=this;this.getName=function(props){var result='Unknown';if(props.file.url){var name=Object(__WEBPACK_IMPORTED_MODULE_10_services_utils_text_util__["d" /* getLastTokenFromUrl */])(props.file.url);if(name){result=name;}}else if(props.file){result=props.file.name;}return result;};this.getIcon=function(props){var icon=void 0;var fileName='';if(props.file.url){var tokens=props.file.url.split('/');if(tokens.length>0){fileName=tokens[tokens.length-1];}}else if(props.file!==null){fileName=props.file.name;}var extension=_this2.getExtension(fileName);switch(extension){case'pdf':icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__fortawesome_react_fontawesome__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_regular_faFilePdf___default.a,style:{color:'#ff0000'}});break;case'doc':case'docx':icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__fortawesome_react_fontawesome__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_regular_faFileWord___default.a,style:{color:'#0051ff'}});break;case'xls':case'xlsx':icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__fortawesome_react_fontawesome__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_free_regular_faFileExcel___default.a,style:{color:'#00bd09'}});break;case'jpeg':case'jpg':case'png':icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__fortawesome_react_fontawesome__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_free_regular_faFileImage___default.a,style:{color:'#eb7d34'}});break;default:icon=null;break;}return icon;};this.getExtension=function(fileName){var fileNameTokes=fileName.split('.');if(fileNameTokes.length>0){return fileNameTokes[fileNameTokes.length-1].toLowerCase();}};this.getUrl=function(){if(_this2.props.file.url!==null){return _this2.props.file.url+'?time='+__WEBPACK_IMPORTED_MODULE_4_moment___default()().unix();}else if(_this2.props.file!==null&&_this2.props.file.hasOwnProperty('preview')){return _this2.props.file.preview;}else{return null;}};this.showPdf=function(){_this2.setState({pdfUrl:_this2.getUrl(_this2.props),showDocumentPdfViewer:true});};this.handleDocumentPdfViewerClose=function(){_this2.setState({pdfUrl:null,showDocumentPdfViewer:false});if(_this2.props.createdBluebeamSession){__WEBPACK_IMPORTED_MODULE_13_services_api_bluebeam_api__["a" /* bluebeamApi */].generateSnapshot(_this2.props.file.id);_this2.props.onCreatedBluebeamSnapshot();}};};var mapStateToProps=function mapStateToProps(state){return{createdBluebeamSession:Object(__WEBPACK_IMPORTED_MODULE_14_selectors_pdfViewerBluebeam__["a" /* getCreatedBluebeamSession */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCreatedBluebeamSnapshot:function onCreatedBluebeamSnapshot(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_actions_pdfViewerBluebeam__["d" /* createdBluebeamSnapshot */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(DocumentLinkBluebeam));

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INIT_PROJECT_EMAIL_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_EMAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_RECIPIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_RECIPIENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_SHOW_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVED_PDFTRON_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESET_PDFTRON_MESSAGES; });
var INIT_PROJECT_EMAIL_MODAL='INIT_PROJECT_EMAIL_MODAL';var SET_EMAILS='SET_EMAILS';var ADD_EMAIL='ADD_EMAIL';var ADD_RECIPIENT='ADD_RECIPIENT';var SET_RECIPIENTS='SET_RECIPIENTS';var SET_SHOW_MODAL='SET_SHOW_MODAL';var SAVED_PDFTRON_SUCCESS='SAVED_PDFTRON_SUCCESS';var RESET_PDFTRON_MESSAGES='RESET_PDFTRON_MESSAGES';

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getShowEmailModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDocumentId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEmails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRecipients; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPdfTronSuccess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getShowEmailModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.pdfViewer.data.showModal;},function(showModal){return showModal;});var getDocumentId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.pdfViewer.data.documentId;},function(documentId){return documentId;});var getEmails=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.pdfViewer.data.emails;},function(emails){return emails;});var getRecipients=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.pdfViewer.data.recipients;},function(recipients){return recipients;});var getPdfTronSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.pdfViewer.data.pdfTronSuccess;},function(pdfTronSuccess){return pdfTronSuccess;});

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddlAssigneeForm_css__ = __webpack_require__(2598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddlAssigneeForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AddlAssigneeForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_directory_store_selectors__ = __webpack_require__(96);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddlAssigneeForm=function(_Component){_inherits(AddlAssigneeForm,_Component);function AddlAssigneeForm(props){_classCallCheck(this,AddlAssigneeForm);var _this=_possibleConstructorReturn(this,(AddlAssigneeForm.__proto__||Object.getPrototypeOf(AddlAssigneeForm)).call(this,props));_this.userLabelStr=function(user,company){return user.first_name+' '+user.last_name+' - '+(company.name||company.company_name);};_this.filterRecipients=function(){var _this$props=_this.props,addlAssignees=_this$props.addlAssignees,addlAssignee=_this$props.addlAssignee,directory=_this$props.directory;if(!directory){return[];}var users={};var contributors=directory.project_contributors;contributors=contributors.filter(function(pc){return pc.primary&&pc.company_type!=='GeneralContractor';}).map(function(pc){return pc.users.filter(function(usr){return!users[usr.id]&&!addlAssignees.find(function(addlAssignee){return!addlAssignee.destroy&&addlAssignee.assigneeId===usr.id;});}).map(function(usr){users[usr.id]=true;var usrLabel=_this.userLabelStr(usr,pc.company);return{value:usr.id,label:usrLabel};});}).reduce(function(acc,val){return acc.concat(val);},[]);if(addlAssignee.assigneeId){contributors.unshift({value:addlAssignee.assigneeId,label:addlAssignee.assigneeLabel});}return contributors;};_this.handleChange=function(attribute,value){_this.setState(_defineProperty({},attribute,value));};_this.handleAssigneeChange=function(option){_this.handleChange('assigneeId',option.value);_this.handleChange('assigneeLabel',option.label);};_this.handleSubmit=function(){var _this$state=_this.state,assigneeId=_this$state.assigneeId,assigneeLabel=_this$state.assigneeLabel,dueDate=_this$state.dueDate;_this.props.onSubmit({assigneeId:assigneeId,assigneeLabel:assigneeLabel,dueDate:dueDate});};_this.validDueDate=function(date){var maxDueDate=_this.props.maxDueDate;return Object(__WEBPACK_IMPORTED_MODULE_8_services_utils_date_util__["k" /* todayValidation */])(date)&&(!maxDueDate||date.isSameOrBefore(maxDueDate));};_this.state={assigneeId:props.addlAssignee.assigneeId||'',assigneeLabel:props.addlAssignee.assigneeLabel||'',dueDate:props.addlAssignee.dueDate||props.maxDueDate||''};return _this;}_createClass(AddlAssigneeForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,showModal=_props.showModal,onClose=_props.onClose;var _state=this.state,assigneeId=_state.assigneeId,dueDate=_state.dueDate;return showModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__["a" /* default */],{show:showModal,onClose:onClose,title:'Additional Assignee'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-label'},'Assignee'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__["a" /* default */],{options:this.filterRecipients(),placeholder:'Contributors...',value:assigneeId,onChange:this.handleAssigneeChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-label'},'Due Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:this.validDueDate,placeholder:'Chose Date...',value:dueDate,onChange:function onChange(value){return _this2.handleChange('dueDate',value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{disabled:!assigneeId||!dueDate,className:'button-orange',label:'Done',onClick:this.handleSubmit}))));}}]);return AddlAssigneeForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AddlAssigneeForm.propTypes={showModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,maxDueDate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,addlAssignees:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,addlAssignee:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),onSubmit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};AddlAssigneeForm.defaultProps={maxDueDate:null,addlAssignee:{}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{directory:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_directory_store_selectors__["c" /* getDirectory */])(state)};})(AddlAssigneeForm));

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadSettingsSuccess */
/* harmony export (immutable) */ __webpack_exports__["a"] = loadSettings;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateSettings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_project_settings_api__ = __webpack_require__(2623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_settings_store_action_types__ = __webpack_require__(1038);
function loadSettingsSuccess(settings){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_settings_store_action_types__["a" /* SETTINGS_SET */],payload:settings};}function loadSettings(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_settings_api__["a" /* projectSettingsApi */].show(projectId).then(function(response){if(response.ok){dispatch(loadSettingsSuccess(response.projectSettings));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateSettings(projectId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_settings_api__["a" /* projectSettingsApi */].update(projectId,values).then(function(response){if(response.ok){dispatch(loadSettingsSuccess(response.projectSettings));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SETTINGS_SET; });
var SETTINGS_SET='SETTINGS_SET';

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_close_png__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_close_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_close_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_daily_report_log_store_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_daily_report_log_store_selectors__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_checkbox_LabeledCheckBox__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_dropdown_MultipleDropdown__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_utils_field_work_order_util__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FieldWorkOrderForm_css__ = __webpack_require__(2632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FieldWorkOrderForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__FieldWorkOrderForm_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FieldWorkOrderForm=function(_Component){_inherits(FieldWorkOrderForm,_Component);function FieldWorkOrderForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FieldWorkOrderForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FieldWorkOrderForm.__proto__||Object.getPrototypeOf(FieldWorkOrderForm)).call.apply(_ref,[this].concat(args))),_this),_this.loadPresetTasks=function(){var _this$props=_this.props,dispatch=_this$props.dispatch,currentFieldWorkOrder=_this$props.currentFieldWorkOrder;dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_daily_report_log_store_actions__["F" /* loadPresetTasksRequest */])(currentFieldWorkOrder.csi_code.id));},_this.invalidTasks=function(field){var _this$props2=_this.props,fieldWorkOrderForm=_this$props2.fieldWorkOrderForm,showErrorMessage=_this$props2.showErrorMessage,formErrors=_this$props2.formErrors;return(!fieldWorkOrderForm.fwoPresetTasks||!fieldWorkOrderForm.fwoPresetTasks.length)&&!fieldWorkOrderForm.fwoCustomTask&&showErrorMessage||formErrors&&formErrors[field];},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FieldWorkOrderForm,[{key:'missingField',value:function missingField(value,field){var _props=this.props,showErrorMessage=_props.showErrorMessage,formErrors=_props.formErrors;return!value&&showErrorMessage||formErrors&&formErrors[field];}},{key:'componentDidMount',value:function componentDidMount(){if(!this.props.fwoForSubForm){this.loadPresetTasks();}}},{key:'render',value:function render(){var _props2=this.props,presetTasks=_props2.presetTasks,fieldWorkOrderForm=_props2.fieldWorkOrderForm,currentFieldWorkOrder=_props2.currentFieldWorkOrder,fwoForSubForm=_props2.fwoForSubForm,handleAttributeChange=_props2.handleAttributeChange;var presetTaskList=[];if(presetTasks&&presetTasks.length>0){presetTaskList=presetTasks.map(function(task){return{id:task.id,label:task.label};});}var statusList=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_12_services_utils_field_work_order_util__["a" /* fwoStatusList */]));var currentStatus=currentFieldWorkOrder?currentFieldWorkOrder.status:'pending';if(currentStatus!=='pending'){statusList=statusList.filter(function(s){return s.value!=='pending';});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,fieldWorkOrderForm&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'field-work-order-form-wrapper':true,'field-work-order-form-for-sub':fwoForSubForm})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-order-block number-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'field-work-order-form-label'},'FWO #'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'field-work-order-form-error-field':this.missingField(fieldWorkOrderForm.fwoNumber,'fwoNumber')}),onChange:handleAttributeChange.bind(null,'fwoNumber'),value:fieldWorkOrderForm.fwoNumber})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-order-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'field-work-order-form-label'},'Preset tasks'),presetTasks&&presetTasks.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'field-work-order-dropdown':true,'field-work-order-multiselect':!this.invalidTasks('fwoPresetTasks'),'field-work-order-form-error-field':this.invalidTasks('fwoPresetTasks')})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_dropdown_MultipleDropdown__["a" /* default */],{dropdownClassName:'alternate-dropdown-control',options:presetTaskList,currentValues:fieldWorkOrderForm.fwoPresetTasks||[],placeholder:'Select tasks...',onChange:function onChange(values){return handleAttributeChange('fwoPresetTasks',values);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-order-block custom-task-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'field-work-order-form-label'},'Custom task'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'field-work-order-form-error-field':this.invalidTasks('fwoPresetTasks')}),onChange:handleAttributeChange.bind(null,'fwoCustomTask'),value:fieldWorkOrderForm.fwoCustomTask})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-order-block-text-area'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'field-work-order-form-label'},'Work to be performed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_TextArea__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'text-area-input':true,'field-work-order-form-error-field':this.missingField(fieldWorkOrderForm.fwoWorkPerformed,'fwoWorkPerformed')}),onChange:handleAttributeChange.bind(null,'fwoWorkPerformed'),value:fieldWorkOrderForm.fwoWorkPerformed||''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-order-block-text-area'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'field-work-order-form-label'},'Comments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_TextArea__["a" /* default */],{className:'text-area-input',onChange:handleAttributeChange.bind(null,'fwoComments'),value:fieldWorkOrderForm.fwoComments||''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-order-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'field-work-order-form-label'},'Start date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-date-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-date-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:function isValidDate(date){return Object(__WEBPACK_IMPORTED_MODULE_13_services_utils_date_util__["i" /* sameOrBeforeDateValidation */])(date,fieldWorkOrderForm.fwoCompletionDate);},placeholder:'Start date',onChange:function onChange(value){return handleAttributeChange('fwoStartDate',value);},value:fieldWorkOrderForm.fwoStartDate})),!!fieldWorkOrderForm.fwoStartDate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'remove',className:'remove-image',src:__WEBPACK_IMPORTED_MODULE_3_images_close_png___default.a,onClick:function onClick(value){return handleAttributeChange('fwoStartDate','');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-order-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'field-work-order-form-label'},'Completion date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-date-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-date-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:function isValidDate(date){return Object(__WEBPACK_IMPORTED_MODULE_13_services_utils_date_util__["h" /* sameOrAfterDateValidation */])(date,fieldWorkOrderForm.fwoStartDate);},placeholder:'Completion date',onChange:function onChange(value){return handleAttributeChange('fwoCompletionDate',value);},value:fieldWorkOrderForm.fwoCompletionDate})),!!fieldWorkOrderForm.fwoCompletionDate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'remove',className:'remove-image',src:__WEBPACK_IMPORTED_MODULE_3_images_close_png___default.a,onClick:function onClick(value){return handleAttributeChange('fwoCompletionDate','');}}))),!fwoForSubForm&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-order-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'field-work-order-form-label'},'Cost Impact'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{onChange:handleAttributeChange.bind(null,'fwoCostImpact'),checked:fieldWorkOrderForm.fwoCostImpact})),fieldWorkOrderForm.fwoCostImpact&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-order-block number-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'field-work-order-form-label'},'Cost'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{onChange:handleAttributeChange.bind(null,'fwoCost'),value:fieldWorkOrderForm.fwoCost,type:'number'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-order-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'field-work-order-form-label'},'Delay'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{onChange:handleAttributeChange.bind(null,'fwoDelay'),checked:fieldWorkOrderForm.fwoDelay})),fieldWorkOrderForm.fwoDelay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-order-block-text-area'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'field-work-order-form-label'},'Delay reason'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_TextArea__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'delay-reason-input':true,'field-work-order-form-error-field':this.missingField(fieldWorkOrderForm.fwoDelayReason,'fwoDelayReason')}),onChange:handleAttributeChange.bind(null,'fwoDelayReason'),value:fieldWorkOrderForm.fwoDelayReason||''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-order-block-text-area'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'field-work-order-form-label'},'Labor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_TextArea__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'text-area-input':true,'field-work-order-form-error-field':this.missingField(fieldWorkOrderForm.fwoLabor,'fwoLabor')}),onChange:handleAttributeChange.bind(null,'fwoLabor'),value:fieldWorkOrderForm.fwoLabor||''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-order-block-text-area'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'field-work-order-form-label'},'Materials'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_TextArea__["a" /* default */],{className:'text-area-input',onChange:handleAttributeChange.bind(null,'fwoMaterials'),value:fieldWorkOrderForm.fwoMaterials||''})),!fwoForSubForm&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-order-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'field-work-order-form-label'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'field-work-order-dropdown':true,'field-work-order-form-error-field':this.missingField(fieldWorkOrderForm.fwoStatus,'fwoStatus')})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_dropdown_Dropdown__["a" /* default */],{options:statusList,placeholder:'Select status',value:fieldWorkOrderForm.fwoStatus,onChange:function onChange(value){return handleAttributeChange('fwoStatus',value);}}))),fieldWorkOrderForm.fwoStatus&&fieldWorkOrderForm.fwoStatus.value==='denied'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-order-block-text-area'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'field-work-order-form-label'},'Denied reason'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_TextArea__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'text-area-input':true,'field-work-order-form-error-field':this.missingField(fieldWorkOrderForm.fwoDeniedReason,'fwoDeniedReason')}),onChange:handleAttributeChange.bind(null,'fwoDeniedReason'),value:fieldWorkOrderForm.fwoDeniedReason||''})))));}}]);return FieldWorkOrderForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{presetTasks:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_daily_report_log_store_selectors__["z" /* getPresetTasks */])(state),currentFieldWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_daily_report_log_store_selectors__["g" /* getCurrentFieldWorkOrder */])(state)};})(FieldWorkOrderForm));

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fwoStatusList; });
var fwoStatusList=[{value:'pending',label:'Pending'},{value:'approved',label:'Approved'},{value:'denied',label:'Denied'}];

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReviewForm_css__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReviewForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ReviewForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_logo_upload_LogoUpload__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectOpenItemReview=function(_Component){_inherits(ProjectOpenItemReview,_Component);function ProjectOpenItemReview(){_classCallCheck(this,ProjectOpenItemReview);return _possibleConstructorReturn(this,(ProjectOpenItemReview.__proto__||Object.getPrototypeOf(ProjectOpenItemReview)).apply(this,arguments));}_createClass(ProjectOpenItemReview,[{key:'render',value:function render(){var openItem=this.props.openItem;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block review-form-project-open-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-title-bloc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title review-form-block-title-open-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'OPEN ITEM',!!openItem.critical&&' - CRITICAL')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title review-form-block-title-open-item review-form-block-assignee-due-date'},!!openItem.assignee_label&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Assigned To: ',openItem.assignee_label),!!openItem.resolve_by&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Due Date: ',__WEBPACK_IMPORTED_MODULE_5_moment___default()(openItem.resolve_by).format('MM/DD/YYYY'))),openItem.recipients&&openItem.recipients.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title'},'CC Recipient(s):',' ',openItem.recipients.map(function(rcpt){return rcpt.first_name+' '+rcpt.last_name;}).join(', '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-text-block'},openItem.description)),openItem.documents&&openItem.documents.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},openItem.documents.map(function(doc,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'doc-viewer',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_document_DocumentLink__["a" /* default */],{url:doc.document.url}));})),openItem.images&&openItem.images.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-block-images-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_logo_upload_LogoUpload__["a" /* default */],{readOnly:true,logos:openItem.images.map(function(image){return{preview:image.image.gallery.url,url:image.image.url};})}))));}}]);return ProjectOpenItemReview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProjectOpenItemReview.propTypes={openItem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (ProjectOpenItemReview);

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_FieldWorkOrderActions__ = __webpack_require__(2641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_daily_report_log_FieldWorkOrderDetails__ = __webpack_require__(2643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_daily_report_log_FieldWorkOrderForm__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_selectors__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FieldWorkOrderModal=function(_Component){_inherits(FieldWorkOrderModal,_Component);function FieldWorkOrderModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FieldWorkOrderModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FieldWorkOrderModal.__proto__||Object.getPrototypeOf(FieldWorkOrderModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleAttributeChange=function(attribute,value){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_actions__["X" /* setFieldWorkOrderFormAttribute */])(attribute,value));},_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_actions__["_12" /* setShowFieldWorkOrderModal */])(false));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_actions__["W" /* setFieldWorkOrderEdit */])(false));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_actions__["_11" /* setShowFieldWorkOrderError */])(false));_this.props.onClose&&_this.props.onClose();},_this.handleEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_actions__["W" /* setFieldWorkOrderEdit */])(true));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_actions__["x" /* initFieldWorkOrderForm */])(_this.props.currentFieldWorkOrder));},_this.handleCancel=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_actions__["W" /* setFieldWorkOrderEdit */])(false));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_actions__["_11" /* setShowFieldWorkOrderError */])(false));},_this.handleSave=function(){var _this$props=_this.props,dispatch=_this$props.dispatch,currentFieldWorkOrder=_this$props.currentFieldWorkOrder,fieldWorkOrderForm=_this$props.fieldWorkOrderForm,currentProject=_this$props.currentProject;if(_this.incompleteForm()){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_actions__["_11" /* setShowFieldWorkOrderError */])(true));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_actions__["_16" /* updateFieldWorkOrder */])(currentProject.id,currentFieldWorkOrder.id,fieldWorkOrderForm));dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_actions__["_11" /* setShowFieldWorkOrderError */])(false));}},_this.incompleteForm=function(){var fieldWorkOrderForm=_this.props.fieldWorkOrderForm;return!fieldWorkOrderForm.fwoNumber||!fieldWorkOrderForm.fwoWorkPerformed||!fieldWorkOrderForm.fwoStatus||(!fieldWorkOrderForm.fwoPresetTasks||!fieldWorkOrderForm.fwoPresetTasks.length)&&!fieldWorkOrderForm.fwoCustomTask||fieldWorkOrderForm.fwoStatus.value==='denied'&&!fieldWorkOrderForm.fwoDeniedReason||fieldWorkOrderForm.fwoDelay&&!fieldWorkOrderForm.fwoDelayReason||!fieldWorkOrderForm.fwoLabor;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FieldWorkOrderModal,[{key:'render',value:function render(){var _this2=this;var _props=this.props,currentFieldWorkOrder=_props.currentFieldWorkOrder,showFieldWorkOrderModal=_props.showFieldWorkOrderModal,fieldWorkOrderEdit=_props.fieldWorkOrderEdit,showErrorMessage=_props.showErrorMessage,fieldWorkOrderForm=_props.fieldWorkOrderForm,currentProject=_props.currentProject;var isSubcontractor=currentProject&&__WEBPACK_IMPORTED_MODULE_3_domain_enterprise__["a" /* Enterprise */].subcontractor(currentProject.contributor_type);return currentProject&&showFieldWorkOrderModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__["a" /* default */],{className:'field-work-order-modal',onClose:this.handleClose,show:true,subTitle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['Projects',currentProject.name,'Field Work Order '+currentFieldWorkOrder.number]})},fieldWorkOrderEdit&&isSubcontractor?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_daily_report_log_FieldWorkOrderForm__["a" /* default */],{fieldWorkOrderForm:fieldWorkOrderForm,handleAttributeChange:this.handleAttributeChange,fieldWorkOrder:currentFieldWorkOrder,showErrorMessage:showErrorMessage}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_daily_report_log_FieldWorkOrderDetails__["a" /* default */],{fieldWorkOrder:currentFieldWorkOrder,fieldWorkOrderForm:fieldWorkOrderForm,handleAttributeChange:this.handleAttributeChange,fieldWorkOrderEdit:fieldWorkOrderEdit,showErrorMessage:showErrorMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_FieldWorkOrderActions__["a" /* default */],{handleClose:this.handleClose,handleEdit:this.handleEdit,handleCancel:this.handleCancel,handleSave:function handleSave(){return _this2.handleSave();},fieldWorkOrderEdit:fieldWorkOrderEdit,showErrorMessage:showErrorMessage,fieldWorkOrder:currentFieldWorkOrder}));}}]);return FieldWorkOrderModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FieldWorkOrderModal.propTypes={onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};FieldWorkOrderModal.defaultProps={onClose:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{currentFieldWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_selectors__["g" /* getCurrentFieldWorkOrder */])(state),showFieldWorkOrderModal:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_selectors__["J" /* getShowFieldWorkOrderModal */])(state),fieldWorkOrderEdit:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_selectors__["r" /* getFieldWorkOrderEdit */])(state),currentProject:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),fieldWorkOrderForm:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_selectors__["s" /* getFieldWorkOrderForm */])(state),showErrorMessage:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_selectors__["I" /* getShowFieldWorkOrderError */])(state)};})(FieldWorkOrderModal));

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadDocumentationSuccess */
/* unused harmony export loadDocumentationCountSuccess */
/* harmony export (immutable) */ __webpack_exports__["h"] = resetDocumentation;
/* harmony export (immutable) */ __webpack_exports__["e"] = loadDocumentationRequest;
/* harmony export (immutable) */ __webpack_exports__["d"] = loadDocumentationCountRequest;
/* harmony export (immutable) */ __webpack_exports__["i"] = updateDocumentationRequest;
/* harmony export (immutable) */ __webpack_exports__["a"] = createAdvancedDocumentsFolderRequest;
/* harmony export (immutable) */ __webpack_exports__["g"] = renameAdvancedDocumentsFolderRequest;
/* harmony export (immutable) */ __webpack_exports__["j"] = uploadAdvancedDocumentsRequest;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteAdvancedDocumentsRequest;
/* harmony export (immutable) */ __webpack_exports__["c"] = downloadAdvancedDocumentsFolderRequest;
/* harmony export (immutable) */ __webpack_exports__["f"] = moveAdvancedDocumentsFolderRequest;
/* unused harmony export loadDirectorySuccess */
/* unused harmony export loadDirectoryRequest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_project_documentations_api__ = __webpack_require__(2648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_project_advanced_documents_api__ = __webpack_require__(2649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_documentation_store_action_types__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_directories_api__ = __webpack_require__(1025);
function loadDocumentationSuccess(documentation,category){return{type:__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_documentation_store_action_types__["d" /* DOCUMENTATION_SET */],payload:{documentation:documentation,category:category}};}function loadDocumentationCountSuccess(documentationCount){return{type:__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_documentation_store_action_types__["b" /* DOCUMENTATION_COUNT_SET */],payload:documentationCount};}function resetDocumentation(){return{type:__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_documentation_store_action_types__["c" /* DOCUMENTATION_RESET */]};}function loadDocumentationRequest(projectId,filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_documentations_api__["a" /* projectDocumentationsApi */].getProjectDocumentation(projectId,filters).then(function(response){if(response.ok){dispatch(loadDocumentationSuccess(response.projectDocumentation,filters.category));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadDocumentationCountRequest(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_documentations_api__["a" /* projectDocumentationsApi */].getProjectDocumentationCount(projectId).then(function(response){if(response.ok){dispatch(loadDocumentationCountSuccess(response.projectDocumentationCount));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function updateDocumentationRequest(projectId,values,filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_project_documentations_api__["a" /* projectDocumentationsApi */].updateProjectDocumentation(projectId,values,filters).then(function(response){if(response.ok){dispatch(loadDocumentationSuccess(response.projectDocumentation,filters.category));dispatch(loadDocumentationCountRequest(projectId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function createAdvancedDocumentsFolderRequest(projectId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_project_advanced_documents_api__["a" /* projectAdvancedDocumentsApi */].createAdvancedDocumentsFolder(projectId,values).then(function(response){if(response.ok){}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function renameAdvancedDocumentsFolderRequest(projectId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_project_advanced_documents_api__["a" /* projectAdvancedDocumentsApi */].renameAdvancedDocumentsFolder(projectId,values).then(function(response){if(response.ok){}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function uploadAdvancedDocumentsRequest(projectId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_project_advanced_documents_api__["a" /* projectAdvancedDocumentsApi */].uploadAdvancedDocuments(projectId,values).then(function(response){if(response.ok){}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function deleteAdvancedDocumentsRequest(projectId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_project_advanced_documents_api__["a" /* projectAdvancedDocumentsApi */].deleteAdvancedDocuments(projectId,values).then(function(response){if(response.ok){}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function downloadAdvancedDocumentsFolderRequest(values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_project_advanced_documents_api__["a" /* projectAdvancedDocumentsApi */].downloadAdvancedDocumentsFolder(values).then(function(response){if(response.ok){}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function moveAdvancedDocumentsFolderRequest(projectId,values){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_project_advanced_documents_api__["a" /* projectAdvancedDocumentsApi */].moveAdvancedDocumentsFolder(projectId,values).then(function(response){if(response.ok){}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadDirectorySuccess(directory){return{type:__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_documentation_store_action_types__["a" /* DIRECTORY_SET */],payload:directory};}function loadDirectoryRequest(projectId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_directories_api__["a" /* directoriesApi */].getDirectory(projectId).then(function(response){if(response.ok){dispatch(loadDirectorySuccess(response.directory));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DOCUMENTATION_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DOCUMENTATION_COUNT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DOCUMENTATION_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DIRECTORY_SET; });
var DOCUMENTATION_SET='DOCUMENTATION_SET';var DOCUMENTATION_COUNT_SET='DOCUMENTATION_COUNT_SET';var DOCUMENTATION_RESET='DOCUMENTATION_RESET';var DIRECTORY_SET='DIRECTORY_SET';

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);

var AWS = __webpack_require__(5);

if (typeof window !== 'undefined') window.AWS = AWS;
if (true) module.exports = AWS;
if (typeof self !== 'undefined') self.AWS = AWS;

/**
 * @private
 * DO NOT REMOVE
 * browser builder will strip out this line if services are supplied on the command line.
 */
__webpack_require__(2726);

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var util = __webpack_require__(74);
var QueryParamSerializer = __webpack_require__(2659);
var Shape = __webpack_require__(338);

function buildRequest(req) {
  var operation = req.service.api.operations[req.operation];
  var httpRequest = req.httpRequest;
  httpRequest.headers['Content-Type'] =
    'application/x-www-form-urlencoded; charset=utf-8';
  httpRequest.params = {
    Version: req.service.api.apiVersion,
    Action: operation.name
  };

  // convert the request parameters into a list of query params,
  // e.g. Deeply.NestedParam.0.Name=value
  var builder = new QueryParamSerializer();
  builder.serialize(req.params, operation.input, function(name, value) {
    httpRequest.params[name] = value;
  });
  httpRequest.body = util.queryParamsToString(httpRequest.params);
}

function extractError(resp) {
  var data, body = resp.httpResponse.body.toString();
  if (body.match('<UnknownOperationException')) {
    data = {
      Code: 'UnknownOperation',
      Message: 'Unknown operation ' + resp.request.operation
    };
  } else {
    try {
      data = new AWS.XML.Parser().parse(body);
    } catch (e) {
      data = {
        Code: resp.httpResponse.statusCode,
        Message: resp.httpResponse.statusMessage
      };
    }
  }

  if (data.requestId && !resp.requestId) resp.requestId = data.requestId;
  if (data.Errors) data = data.Errors;
  if (data.Error) data = data.Error;
  if (data.Code) {
    resp.error = util.error(new Error(), {
      code: data.Code,
      message: data.Message
    });
  } else {
    resp.error = util.error(new Error(), {
      code: resp.httpResponse.statusCode,
      message: null
    });
  }
}

function extractData(resp) {
  var req = resp.request;
  var operation = req.service.api.operations[req.operation];
  var shape = operation.output || {};
  var origRules = shape;

  if (origRules.resultWrapper) {
    var tmp = Shape.create({type: 'structure'});
    tmp.members[origRules.resultWrapper] = shape;
    tmp.memberNames = [origRules.resultWrapper];
    util.property(shape, 'name', shape.resultWrapper);
    shape = tmp;
  }

  var parser = new AWS.XML.Parser();

  // TODO: Refactor XML Parser to parse RequestId from response.
  if (shape && shape.members && !shape.members._XAMZRequestId) {
    var requestIdShape = Shape.create(
      { type: 'string' },
      { api: { protocol: 'query' } },
      'requestId'
    );
    shape.members._XAMZRequestId = requestIdShape;
  }

  var data = parser.parse(resp.httpResponse.body.toString(), shape);
  resp.requestId = data._XAMZRequestId || data.requestId;

  if (data._XAMZRequestId) delete data._XAMZRequestId;

  if (origRules.resultWrapper) {
    if (data[origRules.resultWrapper]) {
      util.update(data, data[origRules.resultWrapper]);
      delete data[origRules.resultWrapper];
    }
  }

  resp.data = data;
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

var memoizedProperty = __webpack_require__(74).memoizedProperty;

function memoize(name, value, fn, nameTr) {
  memoizedProperty(this, nameTr(name), function() {
    return fn(name, value);
  });
}

function Collection(iterable, options, fn, nameTr) {
  nameTr = nameTr || String;
  var self = this;

  for (var id in iterable) {
    if (Object.prototype.hasOwnProperty.call(iterable, id)) {
      memoize.call(self, id, iterable[id], fn, nameTr);
    }
  }
}

module.exports = Collection;


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(74);
var Rest = __webpack_require__(439);
var Json = __webpack_require__(643);
var JsonBuilder = __webpack_require__(644);
var JsonParser = __webpack_require__(645);

function populateBody(req) {
  var builder = new JsonBuilder();
  var input = req.service.api.operations[req.operation].input;

  if (input.payload) {
    var params = {};
    var payloadShape = input.members[input.payload];
    params = req.params[input.payload];
    if (params === undefined) return;

    if (payloadShape.type === 'structure') {
      req.httpRequest.body = builder.build(params, payloadShape);
      applyContentTypeHeader(req);
    } else { // non-JSON payload
      req.httpRequest.body = params;
      if (payloadShape.type === 'binary' || payloadShape.isStreaming) {
        applyContentTypeHeader(req, true);
      }
    }
  } else {
    req.httpRequest.body = builder.build(req.params, input);
    applyContentTypeHeader(req);
  }
}

function applyContentTypeHeader(req, isBinary) {
  var operation = req.service.api.operations[req.operation];
  var input = operation.input;

  if (!req.httpRequest.headers['Content-Type']) {
    var type = isBinary ? 'binary/octet-stream' : 'application/json';
    req.httpRequest.headers['Content-Type'] = type;
  }
}

function buildRequest(req) {
  Rest.buildRequest(req);

  // never send body payload on GET/HEAD/DELETE
  if (['GET', 'HEAD', 'DELETE'].indexOf(req.httpRequest.method) < 0) {
    populateBody(req);
  }
}

function extractError(resp) {
  Json.extractError(resp);
}

function extractData(resp) {
  Rest.extractData(resp);

  var req = resp.request;
  var rules = req.service.api.operations[req.operation].output || {};
  if (rules.payload) {
    var payloadMember = rules.members[rules.payload];
    var body = resp.httpResponse.body;
    if (payloadMember.type === 'structure' || payloadMember.type === 'list') {
      var parser = new JsonParser();
      resp.data[rules.payload] = parser.parse(body, payloadMember);
    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
      resp.data[rules.payload] = body;
    } else {
      resp.data[rules.payload] = payloadMember.toType(body);
    }
  } else {
    var data = resp.data;
    Json.extractData(resp);
    resp.data = util.merge(data, resp.data);
  }
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var util = __webpack_require__(74);
var Rest = __webpack_require__(439);

function populateBody(req) {
  var input = req.service.api.operations[req.operation].input;
  var builder = new AWS.XML.Builder();
  var params = req.params;

  var payload = input.payload;
  if (payload) {
    var payloadMember = input.members[payload];
    params = params[payload];
    if (params === undefined) return;

    if (payloadMember.type === 'structure') {
      var rootElement = payloadMember.name;
      req.httpRequest.body = builder.toXML(params, payloadMember, rootElement, true);
    } else { // non-xml payload
      req.httpRequest.body = params;
    }
  } else {
    req.httpRequest.body = builder.toXML(params, input, input.name ||
      input.shape || util.string.upperFirst(req.operation) + 'Request');
  }
}

function buildRequest(req) {
  Rest.buildRequest(req);

  // never send body payload on GET/HEAD
  if (['GET', 'HEAD'].indexOf(req.httpRequest.method) < 0) {
    populateBody(req);
  }
}

function extractError(resp) {
  Rest.extractError(resp);

  var data;
  try {
    data = new AWS.XML.Parser().parse(resp.httpResponse.body.toString());
  } catch (e) {
    data = {
      Code: resp.httpResponse.statusCode,
      Message: resp.httpResponse.statusMessage
    };
  }

  if (data.Errors) data = data.Errors;
  if (data.Error) data = data.Error;
  if (data.Code) {
    resp.error = util.error(new Error(), {
      code: data.Code,
      message: data.Message
    });
  } else {
    resp.error = util.error(new Error(), {
      code: resp.httpResponse.statusCode,
      message: null
    });
  }
}

function extractData(resp) {
  Rest.extractData(resp);

  var parser;
  var req = resp.request;
  var body = resp.httpResponse.body;
  var operation = req.service.api.operations[req.operation];
  var output = operation.output;

  var payload = output.payload;
  if (payload) {
    var payloadMember = output.members[payload];
    if (payloadMember.type === 'structure') {
      parser = new AWS.XML.Parser();
      resp.data[payload] = parser.parse(body.toString(), payloadMember);
    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
      resp.data[payload] = body;
    } else {
      resp.data[payload] = payloadMember.toType(body);
    }
  } else if (body.length > 0) {
    parser = new AWS.XML.Parser();
    var data = parser.parse(body.toString(), output);
    util.update(resp.data, data);
  }
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLDeclaration, XMLNode, create, isObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  create = __webpack_require__(116);

  isObject = __webpack_require__(125);

  XMLNode = __webpack_require__(286);

  module.exports = XMLDeclaration = (function(superClass) {
    extend(XMLDeclaration, superClass);

    function XMLDeclaration(parent, version, encoding, standalone) {
      var ref;
      XMLDeclaration.__super__.constructor.call(this, parent);
      if (isObject(version)) {
        ref = version, version = ref.version, encoding = ref.encoding, standalone = ref.standalone;
      }
      if (!version) {
        version = '1.0';
      }
      this.version = this.stringify.xmlVersion(version);
      if (encoding != null) {
        this.encoding = this.stringify.xmlEncoding(encoding);
      }
      if (standalone != null) {
        this.standalone = this.stringify.xmlStandalone(standalone);
      }
    }

    XMLDeclaration.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<?xml';
      r += ' version="' + this.version + '"';
      if (this.encoding != null) {
        r += ' encoding="' + this.encoding + '"';
      }
      if (this.standalone != null) {
        r += ' standalone="' + this.standalone + '"';
      }
      r += '?>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLDeclaration;

  })(XMLNode);

}).call(this);


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLAttribute, XMLElement, XMLNode, XMLProcessingInstruction, create, every, isFunction, isObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  create = __webpack_require__(116);

  isObject = __webpack_require__(125);

  isFunction = __webpack_require__(260);

  every = __webpack_require__(2666);

  XMLNode = __webpack_require__(286);

  XMLAttribute = __webpack_require__(2669);

  XMLProcessingInstruction = __webpack_require__(1054);

  module.exports = XMLElement = (function(superClass) {
    extend(XMLElement, superClass);

    function XMLElement(parent, name, attributes) {
      XMLElement.__super__.constructor.call(this, parent);
      if (name == null) {
        throw new Error("Missing element name");
      }
      this.name = this.stringify.eleName(name);
      this.children = [];
      this.instructions = [];
      this.attributes = {};
      if (attributes != null) {
        this.attribute(attributes);
      }
    }

    XMLElement.prototype.clone = function() {
      var att, attName, clonedSelf, i, len, pi, ref, ref1;
      clonedSelf = create(XMLElement.prototype, this);
      if (clonedSelf.isRoot) {
        clonedSelf.documentObject = null;
      }
      clonedSelf.attributes = {};
      ref = this.attributes;
      for (attName in ref) {
        if (!hasProp.call(ref, attName)) continue;
        att = ref[attName];
        clonedSelf.attributes[attName] = att.clone();
      }
      clonedSelf.instructions = [];
      ref1 = this.instructions;
      for (i = 0, len = ref1.length; i < len; i++) {
        pi = ref1[i];
        clonedSelf.instructions.push(pi.clone());
      }
      clonedSelf.children = [];
      this.children.forEach(function(child) {
        var clonedChild;
        clonedChild = child.clone();
        clonedChild.parent = clonedSelf;
        return clonedSelf.children.push(clonedChild);
      });
      return clonedSelf;
    };

    XMLElement.prototype.attribute = function(name, value) {
      var attName, attValue;
      if (name != null) {
        name = name.valueOf();
      }
      if (isObject(name)) {
        for (attName in name) {
          if (!hasProp.call(name, attName)) continue;
          attValue = name[attName];
          this.attribute(attName, attValue);
        }
      } else {
        if (isFunction(value)) {
          value = value.apply();
        }
        if (!this.options.skipNullAttributes || (value != null)) {
          this.attributes[name] = new XMLAttribute(this, name, value);
        }
      }
      return this;
    };

    XMLElement.prototype.removeAttribute = function(name) {
      var attName, i, len;
      if (name == null) {
        throw new Error("Missing attribute name");
      }
      name = name.valueOf();
      if (Array.isArray(name)) {
        for (i = 0, len = name.length; i < len; i++) {
          attName = name[i];
          delete this.attributes[attName];
        }
      } else {
        delete this.attributes[name];
      }
      return this;
    };

    XMLElement.prototype.instruction = function(target, value) {
      var i, insTarget, insValue, instruction, len;
      if (target != null) {
        target = target.valueOf();
      }
      if (value != null) {
        value = value.valueOf();
      }
      if (Array.isArray(target)) {
        for (i = 0, len = target.length; i < len; i++) {
          insTarget = target[i];
          this.instruction(insTarget);
        }
      } else if (isObject(target)) {
        for (insTarget in target) {
          if (!hasProp.call(target, insTarget)) continue;
          insValue = target[insTarget];
          this.instruction(insTarget, insValue);
        }
      } else {
        if (isFunction(value)) {
          value = value.apply();
        }
        instruction = new XMLProcessingInstruction(this, target, value);
        this.instructions.push(instruction);
      }
      return this;
    };

    XMLElement.prototype.toString = function(options, level) {
      var att, child, i, indent, instruction, j, len, len1, name, newline, offset, pretty, r, ref, ref1, ref2, ref3, ref4, ref5, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      ref3 = this.instructions;
      for (i = 0, len = ref3.length; i < len; i++) {
        instruction = ref3[i];
        r += instruction.toString(options, level);
      }
      if (pretty) {
        r += space;
      }
      r += '<' + this.name;
      ref4 = this.attributes;
      for (name in ref4) {
        if (!hasProp.call(ref4, name)) continue;
        att = ref4[name];
        r += att.toString(options);
      }
      if (this.children.length === 0 || every(this.children, function(e) {
        return e.value === '';
      })) {
        r += '/>';
        if (pretty) {
          r += newline;
        }
      } else if (pretty && this.children.length === 1 && (this.children[0].value != null)) {
        r += '>';
        r += this.children[0].value;
        r += '</' + this.name + '>';
        r += newline;
      } else {
        r += '>';
        if (pretty) {
          r += newline;
        }
        ref5 = this.children;
        for (j = 0, len1 = ref5.length; j < len1; j++) {
          child = ref5[j];
          r += child.toString(options, level + 1);
        }
        if (pretty) {
          r += space;
        }
        r += '</' + this.name + '>';
        if (pretty) {
          r += newline;
        }
      }
      return r;
    };

    XMLElement.prototype.att = function(name, value) {
      return this.attribute(name, value);
    };

    XMLElement.prototype.ins = function(target, value) {
      return this.instruction(target, value);
    };

    XMLElement.prototype.a = function(name, value) {
      return this.attribute(name, value);
    };

    XMLElement.prototype.i = function(target, value) {
      return this.instruction(target, value);
    };

    return XMLElement;

  })(XMLNode);

}).call(this);


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLProcessingInstruction, create;

  create = __webpack_require__(116);

  module.exports = XMLProcessingInstruction = (function() {
    function XMLProcessingInstruction(parent, target, value) {
      this.stringify = parent.stringify;
      if (target == null) {
        throw new Error("Missing instruction target");
      }
      this.target = this.stringify.insTarget(target);
      if (value) {
        this.value = this.stringify.insValue(value);
      }
    }

    XMLProcessingInstruction.prototype.clone = function() {
      return create(XMLProcessingInstruction.prototype, this);
    };

    XMLProcessingInstruction.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<?';
      r += this.target;
      if (this.value) {
        r += ' ' + this.value;
      }
      r += '?>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLProcessingInstruction;

  })();

}).call(this);


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLCData, XMLNode, create,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  create = __webpack_require__(116);

  XMLNode = __webpack_require__(286);

  module.exports = XMLCData = (function(superClass) {
    extend(XMLCData, superClass);

    function XMLCData(parent, text) {
      XMLCData.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing CDATA text");
      }
      this.text = this.stringify.cdata(text);
    }

    XMLCData.prototype.clone = function() {
      return create(XMLCData.prototype, this);
    };

    XMLCData.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<![CDATA[' + this.text + ']]>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLCData;

  })(XMLNode);

}).call(this);


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLComment, XMLNode, create,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  create = __webpack_require__(116);

  XMLNode = __webpack_require__(286);

  module.exports = XMLComment = (function(superClass) {
    extend(XMLComment, superClass);

    function XMLComment(parent, text) {
      XMLComment.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing comment text");
      }
      this.text = this.stringify.comment(text);
    }

    XMLComment.prototype.clone = function() {
      return create(XMLComment.prototype, this);
    };

    XMLComment.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<!-- ' + this.text + ' -->';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLComment;

  })(XMLNode);

}).call(this);


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDocType, XMLProcessingInstruction, create, isObject;

  create = __webpack_require__(116);

  isObject = __webpack_require__(125);

  XMLCData = __webpack_require__(1055);

  XMLComment = __webpack_require__(1056);

  XMLDTDAttList = __webpack_require__(2670);

  XMLDTDEntity = __webpack_require__(2671);

  XMLDTDElement = __webpack_require__(2672);

  XMLDTDNotation = __webpack_require__(2673);

  XMLProcessingInstruction = __webpack_require__(1054);

  module.exports = XMLDocType = (function() {
    function XMLDocType(parent, pubID, sysID) {
      var ref, ref1;
      this.documentObject = parent;
      this.stringify = this.documentObject.stringify;
      this.children = [];
      if (isObject(pubID)) {
        ref = pubID, pubID = ref.pubID, sysID = ref.sysID;
      }
      if (sysID == null) {
        ref1 = [pubID, sysID], sysID = ref1[0], pubID = ref1[1];
      }
      if (pubID != null) {
        this.pubID = this.stringify.dtdPubID(pubID);
      }
      if (sysID != null) {
        this.sysID = this.stringify.dtdSysID(sysID);
      }
    }

    XMLDocType.prototype.element = function(name, value) {
      var child;
      child = new XMLDTDElement(this, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      var child;
      child = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.entity = function(name, value) {
      var child;
      child = new XMLDTDEntity(this, false, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.pEntity = function(name, value) {
      var child;
      child = new XMLDTDEntity(this, true, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.notation = function(name, value) {
      var child;
      child = new XMLDTDNotation(this, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.cdata = function(value) {
      var child;
      child = new XMLCData(this, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.comment = function(value) {
      var child;
      child = new XMLComment(this, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.instruction = function(target, value) {
      var child;
      child = new XMLProcessingInstruction(this, target, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.root = function() {
      return this.documentObject.root();
    };

    XMLDocType.prototype.document = function() {
      return this.documentObject;
    };

    XMLDocType.prototype.toString = function(options, level) {
      var child, i, indent, len, newline, offset, pretty, r, ref, ref1, ref2, ref3, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<!DOCTYPE ' + this.root().name;
      if (this.pubID && this.sysID) {
        r += ' PUBLIC "' + this.pubID + '" "' + this.sysID + '"';
      } else if (this.sysID) {
        r += ' SYSTEM "' + this.sysID + '"';
      }
      if (this.children.length > 0) {
        r += ' [';
        if (pretty) {
          r += newline;
        }
        ref3 = this.children;
        for (i = 0, len = ref3.length; i < len; i++) {
          child = ref3[i];
          r += child.toString(options, level + 1);
        }
        r += ']';
      }
      r += '>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    XMLDocType.prototype.ele = function(name, value) {
      return this.element(name, value);
    };

    XMLDocType.prototype.att = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      return this.attList(elementName, attributeName, attributeType, defaultValueType, defaultValue);
    };

    XMLDocType.prototype.ent = function(name, value) {
      return this.entity(name, value);
    };

    XMLDocType.prototype.pent = function(name, value) {
      return this.pEntity(name, value);
    };

    XMLDocType.prototype.not = function(name, value) {
      return this.notation(name, value);
    };

    XMLDocType.prototype.dat = function(value) {
      return this.cdata(value);
    };

    XMLDocType.prototype.com = function(value) {
      return this.comment(value);
    };

    XMLDocType.prototype.ins = function(target, value) {
      return this.instruction(target, value);
    };

    XMLDocType.prototype.up = function() {
      return this.root();
    };

    XMLDocType.prototype.doc = function() {
      return this.document();
    };

    return XMLDocType;

  })();

}).call(this);


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

var Collection = __webpack_require__(1049);
var Operation = __webpack_require__(1059);
var Shape = __webpack_require__(338);
var Paginator = __webpack_require__(1060);
var ResourceWaiter = __webpack_require__(1061);

var util = __webpack_require__(74);
var property = util.property;
var memoizedProperty = util.memoizedProperty;

function Api(api, options) {
  api = api || {};
  options = options || {};
  options.api = this;

  api.metadata = api.metadata || {};

  property(this, 'isApi', true, false);
  property(this, 'apiVersion', api.metadata.apiVersion);
  property(this, 'endpointPrefix', api.metadata.endpointPrefix);
  property(this, 'signingName', api.metadata.signingName);
  property(this, 'globalEndpoint', api.metadata.globalEndpoint);
  property(this, 'signatureVersion', api.metadata.signatureVersion);
  property(this, 'jsonVersion', api.metadata.jsonVersion);
  property(this, 'targetPrefix', api.metadata.targetPrefix);
  property(this, 'protocol', api.metadata.protocol);
  property(this, 'timestampFormat', api.metadata.timestampFormat);
  property(this, 'xmlNamespaceUri', api.metadata.xmlNamespace);
  property(this, 'abbreviation', api.metadata.serviceAbbreviation);
  property(this, 'fullName', api.metadata.serviceFullName);

  memoizedProperty(this, 'className', function() {
    var name = api.metadata.serviceAbbreviation || api.metadata.serviceFullName;
    if (!name) return null;

    name = name.replace(/^Amazon|AWS\s*|\(.*|\s+|\W+/g, '');
    if (name === 'ElasticLoadBalancing') name = 'ELB';
    return name;
  });

  property(this, 'operations', new Collection(api.operations, options, function(name, operation) {
    return new Operation(name, operation, options);
  }, util.string.lowerFirst));

  property(this, 'shapes', new Collection(api.shapes, options, function(name, shape) {
    return Shape.create(shape, options);
  }));

  property(this, 'paginators', new Collection(api.paginators, options, function(name, paginator) {
    return new Paginator(name, paginator, options);
  }));

  property(this, 'waiters', new Collection(api.waiters, options, function(name, waiter) {
    return new ResourceWaiter(name, waiter, options);
  }, util.string.lowerFirst));

  if (options.documentation) {
    property(this, 'documentation', api.documentation);
    property(this, 'documentationUrl', api.documentationUrl);
  }
}

module.exports = Api;


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

var Shape = __webpack_require__(338);

var util = __webpack_require__(74);
var property = util.property;
var memoizedProperty = util.memoizedProperty;

function Operation(name, operation, options) {
  var self = this;
  options = options || {};

  property(this, 'name', operation.name || name);
  property(this, 'api', options.api, false);

  operation.http = operation.http || {};
  property(this, 'httpMethod', operation.http.method || 'POST');
  property(this, 'httpPath', operation.http.requestUri || '/');
  property(this, 'authtype', operation.authtype || '');

  memoizedProperty(this, 'input', function() {
    if (!operation.input) {
      return new Shape.create({type: 'structure'}, options);
    }
    return Shape.create(operation.input, options);
  });

  memoizedProperty(this, 'output', function() {
    if (!operation.output) {
      return new Shape.create({type: 'structure'}, options);
    }
    return Shape.create(operation.output, options);
  });

  memoizedProperty(this, 'errors', function() {
    var list = [];
    if (!operation.errors) return null;

    for (var i = 0; i < operation.errors.length; i++) {
      list.push(Shape.create(operation.errors[i], options));
    }

    return list;
  });

  memoizedProperty(this, 'paginator', function() {
    return options.api.paginators[name];
  });

  if (options.documentation) {
    property(this, 'documentation', operation.documentation);
    property(this, 'documentationUrl', operation.documentationUrl);
  }

  // idempotentMembers only tracks top-level input shapes
  memoizedProperty(this, 'idempotentMembers', function() {
    var idempotentMembers = [];
    var input = self.input;
    var members = input.members;
    if (!input.members) {
      return idempotentMembers;
    }
    for (var name in members) {
      if (!members.hasOwnProperty(name)) {
        continue;
      }
      if (members[name].isIdempotent === true) {
        idempotentMembers.push(name);
      }
    }
    return idempotentMembers;
  });

}

module.exports = Operation;


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

var property = __webpack_require__(74).property;

function Paginator(name, paginator) {
  property(this, 'inputToken', paginator.input_token);
  property(this, 'limitKey', paginator.limit_key);
  property(this, 'moreResults', paginator.more_results);
  property(this, 'outputToken', paginator.output_token);
  property(this, 'resultKey', paginator.result_key);
}

module.exports = Paginator;


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(74);
var property = util.property;

function ResourceWaiter(name, waiter, options) {
  options = options || {};
  property(this, 'name', name);
  property(this, 'api', options.api, false);

  if (waiter.operation) {
    property(this, 'operation', util.string.lowerFirst(waiter.operation));
  }

  var self = this;
  var keys = [
    'type',
    'description',
    'delay',
    'maxAttempts',
    'acceptors'
  ];

  keys.forEach(function(key) {
    var value = waiter[key];
    if (value) {
      property(self, key, value);
    }
  });
}

module.exports = ResourceWaiter;


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);

/**
 * Represents your AWS security credentials, specifically the
 * {accessKeyId}, {secretAccessKey}, and optional {sessionToken}.
 * Creating a `Credentials` object allows you to pass around your
 * security information to configuration and service objects.
 *
 * Note that this class typically does not need to be constructed manually,
 * as the {AWS.Config} and {AWS.Service} classes both accept simple
 * options hashes with the three keys. These structures will be converted
 * into Credentials objects automatically.
 *
 * ## Expiring and Refreshing Credentials
 *
 * Occasionally credentials can expire in the middle of a long-running
 * application. In this case, the SDK will automatically attempt to
 * refresh the credentials from the storage location if the Credentials
 * class implements the {refresh} method.
 *
 * If you are implementing a credential storage location, you
 * will want to create a subclass of the `Credentials` class and
 * override the {refresh} method. This method allows credentials to be
 * retrieved from the backing store, be it a file system, database, or
 * some network storage. The method should reset the credential attributes
 * on the object.
 *
 * @!attribute expired
 *   @return [Boolean] whether the credentials have been expired and
 *     require a refresh. Used in conjunction with {expireTime}.
 * @!attribute expireTime
 *   @return [Date] a time when credentials should be considered expired. Used
 *     in conjunction with {expired}.
 * @!attribute accessKeyId
 *   @return [String] the AWS access key ID
 * @!attribute secretAccessKey
 *   @return [String] the AWS secret access key
 * @!attribute sessionToken
 *   @return [String] an optional AWS session token
 */
AWS.Credentials = AWS.util.inherit({
  /**
   * A credentials object can be created using positional arguments or an options
   * hash.
   *
   * @overload AWS.Credentials(accessKeyId, secretAccessKey, sessionToken=null)
   *   Creates a Credentials object with a given set of credential information
   *   as positional arguments.
   *   @param accessKeyId [String] the AWS access key ID
   *   @param secretAccessKey [String] the AWS secret access key
   *   @param sessionToken [String] the optional AWS session token
   *   @example Create a credentials object with AWS credentials
   *     var creds = new AWS.Credentials('akid', 'secret', 'session');
   * @overload AWS.Credentials(options)
   *   Creates a Credentials object with a given set of credential information
   *   as an options hash.
   *   @option options accessKeyId [String] the AWS access key ID
   *   @option options secretAccessKey [String] the AWS secret access key
   *   @option options sessionToken [String] the optional AWS session token
   *   @example Create a credentials object with AWS credentials
   *     var creds = new AWS.Credentials({
   *       accessKeyId: 'akid', secretAccessKey: 'secret', sessionToken: 'session'
   *     });
   */
  constructor: function Credentials() {
    // hide secretAccessKey from being displayed with util.inspect
    AWS.util.hideProperties(this, ['secretAccessKey']);

    this.expired = false;
    this.expireTime = null;
    if (arguments.length === 1 && typeof arguments[0] === 'object') {
      var creds = arguments[0].credentials || arguments[0];
      this.accessKeyId = creds.accessKeyId;
      this.secretAccessKey = creds.secretAccessKey;
      this.sessionToken = creds.sessionToken;
    } else {
      this.accessKeyId = arguments[0];
      this.secretAccessKey = arguments[1];
      this.sessionToken = arguments[2];
    }
  },

  /**
   * @return [Integer] the number of seconds before {expireTime} during which
   *   the credentials will be considered expired.
   */
  expiryWindow: 15,

  /**
   * @return [Boolean] whether the credentials object should call {refresh}
   * @note Subclasses should override this method to provide custom refresh
   *   logic.
   */
  needsRefresh: function needsRefresh() {
    var currentTime = AWS.util.date.getDate().getTime();
    var adjustedTime = new Date(currentTime + this.expiryWindow * 1000);

    if (this.expireTime && adjustedTime > this.expireTime) {
      return true;
    } else {
      return this.expired || !this.accessKeyId || !this.secretAccessKey;
    }
  },

  /**
   * Gets the existing credentials, refreshing them if they are not yet loaded
   * or have expired. Users should call this method before using {refresh},
   * as this will not attempt to reload credentials when they are already
   * loaded into the object.
   *
   * @callback callback function(err)
   *   When this callback is called with no error, it means either credentials
   *   do not need to be refreshed or refreshed credentials information has
   *   been loaded into the object (as the `accessKeyId`, `secretAccessKey`,
   *   and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   */
  get: function get(callback) {
    var self = this;
    if (this.needsRefresh()) {
      this.refresh(function(err) {
        if (!err) self.expired = false; // reset expired flag
        if (callback) callback(err);
      });
    } else if (callback) {
      callback();
    }
  },

  /**
   * @!method  getPromise()
   *   Returns a 'thenable' promise.
   *   Gets the existing credentials, refreshing them if they are not yet loaded
   *   or have expired. Users should call this method before using {refresh},
   *   as this will not attempt to reload credentials when they are already
   *   loaded into the object.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function()
   *     Called if the promise is fulfilled. When this callback is called, it
   *     means either credentials do not need to be refreshed or refreshed
   *     credentials information has been loaded into the object (as the
   *     `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @callback rejectedCallback function(err)
   *     Called if the promise is rejected.
   *     @param err [Error] if an error occurred, this value will be filled
   *   @return [Promise] A promise that represents the state of the `get` call.
   *   @example Calling the `getPromise` method.
   *     var promise = credProvider.getPromise();
   *     promise.then(function() { ... }, function(err) { ... });
   */

  /**
   * @!method  refreshPromise()
   *   Returns a 'thenable' promise.
   *   Refreshes the credentials. Users should call {get} before attempting
   *   to forcibly refresh credentials.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function()
   *     Called if the promise is fulfilled. When this callback is called, it
   *     means refreshed credentials information has been loaded into the object
   *     (as the `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @callback rejectedCallback function(err)
   *     Called if the promise is rejected.
   *     @param err [Error] if an error occurred, this value will be filled
   *   @return [Promise] A promise that represents the state of the `refresh` call.
   *   @example Calling the `refreshPromise` method.
   *     var promise = credProvider.refreshPromise();
   *     promise.then(function() { ... }, function(err) { ... });
   */

  /**
   * Refreshes the credentials. Users should call {get} before attempting
   * to forcibly refresh credentials.
   *
   * @callback callback function(err)
   *   When this callback is called with no error, it means refreshed
   *   credentials information has been loaded into the object (as the
   *   `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @note Subclasses should override this class to reset the
   *   {accessKeyId}, {secretAccessKey} and optional {sessionToken}
   *   on the credentials object and then call the callback with
   *   any error information.
   * @see get
   */
  refresh: function refresh(callback) {
    this.expired = false;
    callback();
  }
});

/**
 * @api private
 */
AWS.Credentials.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
  this.prototype.getPromise = AWS.util.promisifyMethod('get', PromiseDependency);
  this.prototype.refreshPromise = AWS.util.promisifyMethod('refresh', PromiseDependency);
};

/**
 * @api private
 */
AWS.Credentials.deletePromisesFromClass = function deletePromisesFromClass() {
  delete this.prototype.getPromise;
  delete this.prototype.refreshPromise;
};

AWS.util.addPromises(AWS.Credentials);


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);

/**
 * Creates a credential provider chain that searches for AWS credentials
 * in a list of credential providers specified by the {providers} property.
 *
 * By default, the chain will use the {defaultProviders} to resolve credentials.
 * These providers will look in the environment using the
 * {AWS.EnvironmentCredentials} class with the 'AWS' and 'AMAZON' prefixes.
 *
 * ## Setting Providers
 *
 * Each provider in the {providers} list should be a function that returns
 * a {AWS.Credentials} object, or a hardcoded credentials object. The function
 * form allows for delayed execution of the credential construction.
 *
 * ## Resolving Credentials from a Chain
 *
 * Call {resolve} to return the first valid credential object that can be
 * loaded by the provider chain.
 *
 * For example, to resolve a chain with a custom provider that checks a file
 * on disk after the set of {defaultProviders}:
 *
 * ```javascript
 * var diskProvider = new AWS.FileSystemCredentials('./creds.json');
 * var chain = new AWS.CredentialProviderChain();
 * chain.providers.push(diskProvider);
 * chain.resolve();
 * ```
 *
 * The above code will return the `diskProvider` object if the
 * file contains credentials and the `defaultProviders` do not contain
 * any credential settings.
 *
 * @!attribute providers
 *   @return [Array<AWS.Credentials, Function>]
 *     a list of credentials objects or functions that return credentials
 *     objects. If the provider is a function, the function will be
 *     executed lazily when the provider needs to be checked for valid
 *     credentials. By default, this object will be set to the
 *     {defaultProviders}.
 *   @see defaultProviders
 */
AWS.CredentialProviderChain = AWS.util.inherit(AWS.Credentials, {

  /**
   * Creates a new CredentialProviderChain with a default set of providers
   * specified by {defaultProviders}.
   */
  constructor: function CredentialProviderChain(providers) {
    if (providers) {
      this.providers = providers;
    } else {
      this.providers = AWS.CredentialProviderChain.defaultProviders.slice(0);
    }
  },

  /**
   * @!method  resolvePromise()
   *   Returns a 'thenable' promise.
   *   Resolves the provider chain by searching for the first set of
   *   credentials in {providers}.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function(credentials)
   *     Called if the promise is fulfilled and the provider resolves the chain
   *     to a credentials object
   *     @param credentials [AWS.Credentials] the credentials object resolved
   *       by the provider chain.
   *   @callback rejectedCallback function(error)
   *     Called if the promise is rejected.
   *     @param err [Error] the error object returned if no credentials are found.
   *   @return [Promise] A promise that represents the state of the `resolve` method call.
   *   @example Calling the `resolvePromise` method.
   *     var promise = chain.resolvePromise();
   *     promise.then(function(credentials) { ... }, function(err) { ... });
   */

  /**
   * Resolves the provider chain by searching for the first set of
   * credentials in {providers}.
   *
   * @callback callback function(err, credentials)
   *   Called when the provider resolves the chain to a credentials object
   *   or null if no credentials can be found.
   *
   *   @param err [Error] the error object returned if no credentials are
   *     found.
   *   @param credentials [AWS.Credentials] the credentials object resolved
   *     by the provider chain.
   * @return [AWS.CredentialProviderChain] the provider, for chaining.
   */
  resolve: function resolve(callback) {
    if (this.providers.length === 0) {
      callback(new Error('No providers'));
      return this;
    }

    var index = 0;
    var providers = this.providers.slice(0);

    function resolveNext(err, creds) {
      if ((!err && creds) || index === providers.length) {
        callback(err, creds);
        return;
      }

      var provider = providers[index++];
      if (typeof provider === 'function') {
        creds = provider.call();
      } else {
        creds = provider;
      }

      if (creds.get) {
        creds.get(function(getErr) {
          resolveNext(getErr, getErr ? null : creds);
        });
      } else {
        resolveNext(null, creds);
      }
    }

    resolveNext();
    return this;
  }
});

/**
 * The default set of providers used by a vanilla CredentialProviderChain.
 *
 * In the browser:
 *
 * ```javascript
 * AWS.CredentialProviderChain.defaultProviders = []
 * ```
 *
 * In Node.js:
 *
 * ```javascript
 * AWS.CredentialProviderChain.defaultProviders = [
 *   function () { return new AWS.EnvironmentCredentials('AWS'); },
 *   function () { return new AWS.EnvironmentCredentials('AMAZON'); },
 *   function () { return new AWS.SharedIniFileCredentials(); },
 *   function () {
 *     // if AWS_CONTAINER_CREDENTIALS_RELATIVE_URI is set
 *       return new AWS.ECSCredentials();
 *     // else
 *       return new AWS.EC2MetadataCredentials();
 *   }
 * ]
 * ```
 */
AWS.CredentialProviderChain.defaultProviders = [];

/**
 * @api private
 */
AWS.CredentialProviderChain.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
  this.prototype.resolvePromise = AWS.util.promisifyMethod('resolve', PromiseDependency);
};

/**
 * @api private
 */
AWS.CredentialProviderChain.deletePromisesFromClass = function deletePromisesFromClass() {
  delete this.prototype.resolvePromise;
};

AWS.util.addPromises(AWS.CredentialProviderChain);


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var inherit = AWS.util.inherit;

/**
 * The endpoint that a service will talk to, for example,
 * `'https://ec2.ap-southeast-1.amazonaws.com'`. If
 * you need to override an endpoint for a service, you can
 * set the endpoint on a service by passing the endpoint
 * object with the `endpoint` option key:
 *
 * ```javascript
 * var ep = new AWS.Endpoint('awsproxy.example.com');
 * var s3 = new AWS.S3({endpoint: ep});
 * s3.service.endpoint.hostname == 'awsproxy.example.com'
 * ```
 *
 * Note that if you do not specify a protocol, the protocol will
 * be selected based on your current {AWS.config} configuration.
 *
 * @!attribute protocol
 *   @return [String] the protocol (http or https) of the endpoint
 *     URL
 * @!attribute hostname
 *   @return [String] the host portion of the endpoint, e.g.,
 *     example.com
 * @!attribute host
 *   @return [String] the host portion of the endpoint including
 *     the port, e.g., example.com:80
 * @!attribute port
 *   @return [Integer] the port of the endpoint
 * @!attribute href
 *   @return [String] the full URL of the endpoint
 */
AWS.Endpoint = inherit({

  /**
   * @overload Endpoint(endpoint)
   *   Constructs a new endpoint given an endpoint URL. If the
   *   URL omits a protocol (http or https), the default protocol
   *   set in the global {AWS.config} will be used.
   *   @param endpoint [String] the URL to construct an endpoint from
   */
  constructor: function Endpoint(endpoint, config) {
    AWS.util.hideProperties(this, ['slashes', 'auth', 'hash', 'search', 'query']);

    if (typeof endpoint === 'undefined' || endpoint === null) {
      throw new Error('Invalid endpoint: ' + endpoint);
    } else if (typeof endpoint !== 'string') {
      return AWS.util.copy(endpoint);
    }

    if (!endpoint.match(/^http/)) {
      var useSSL = config && config.sslEnabled !== undefined ?
        config.sslEnabled : AWS.config.sslEnabled;
      endpoint = (useSSL ? 'https' : 'http') + '://' + endpoint;
    }

    AWS.util.update(this, AWS.util.urlParse(endpoint));

    // Ensure the port property is set as an integer
    if (this.port) {
      this.port = parseInt(this.port, 10);
    } else {
      this.port = this.protocol === 'https:' ? 443 : 80;
    }
  }

});

/**
 * The low level HTTP request object, encapsulating all HTTP header
 * and body data sent by a service request.
 *
 * @!attribute method
 *   @return [String] the HTTP method of the request
 * @!attribute path
 *   @return [String] the path portion of the URI, e.g.,
 *     "/list/?start=5&num=10"
 * @!attribute headers
 *   @return [map<String,String>]
 *     a map of header keys and their respective values
 * @!attribute body
 *   @return [String] the request body payload
 * @!attribute endpoint
 *   @return [AWS.Endpoint] the endpoint for the request
 * @!attribute region
 *   @api private
 *   @return [String] the region, for signing purposes only.
 */
AWS.HttpRequest = inherit({

  /**
   * @api private
   */
  constructor: function HttpRequest(endpoint, region) {
    endpoint = new AWS.Endpoint(endpoint);
    this.method = 'POST';
    this.path = endpoint.path || '/';
    this.headers = {};
    this.body = '';
    this.endpoint = endpoint;
    this.region = region;
    this._userAgent = '';
    this.setUserAgent();
  },

  /**
   * @api private
   */
  setUserAgent: function setUserAgent() {
    this._userAgent = this.headers[this.getUserAgentHeaderName()] = AWS.util.userAgent();
  },

  getUserAgentHeaderName: function getUserAgentHeaderName() {
    var prefix = AWS.util.isBrowser() ? 'X-Amz-' : '';
    return prefix + 'User-Agent';
  },

  /**
   * @api private
   */
  appendToUserAgent: function appendToUserAgent(agentPartial) {
    if (typeof agentPartial === 'string' && agentPartial) {
      this._userAgent += ' ' + agentPartial;
    }
    this.headers[this.getUserAgentHeaderName()] = this._userAgent;
  },

  /**
   * @api private
   */
  getUserAgent: function getUserAgent() {
    return this._userAgent;
  },

  /**
   * @return [String] the part of the {path} excluding the
   *   query string
   */
  pathname: function pathname() {
    return this.path.split('?', 1)[0];
  },

  /**
   * @return [String] the query string portion of the {path}
   */
  search: function search() {
    var query = this.path.split('?', 2)[1];
    if (query) {
      query = AWS.util.queryStringParse(query);
      return AWS.util.queryParamsToString(query);
    }
    return '';
  }

});

/**
 * The low level HTTP response object, encapsulating all HTTP header
 * and body data returned from the request.
 *
 * @!attribute statusCode
 *   @return [Integer] the HTTP status code of the response (e.g., 200, 404)
 * @!attribute headers
 *   @return [map<String,String>]
 *      a map of response header keys and their respective values
 * @!attribute body
 *   @return [String] the response body payload
 * @!attribute [r] streaming
 *   @return [Boolean] whether this response is being streamed at a low-level.
 *     Defaults to `false` (buffered reads). Do not modify this manually, use
 *     {createUnbufferedStream} to convert the stream to unbuffered mode
 *     instead.
 */
AWS.HttpResponse = inherit({

  /**
   * @api private
   */
  constructor: function HttpResponse() {
    this.statusCode = undefined;
    this.headers = {};
    this.body = undefined;
    this.streaming = false;
    this.stream = null;
  },

  /**
   * Disables buffering on the HTTP response and returns the stream for reading.
   * @return [Stream, XMLHttpRequest, null] the underlying stream object.
   *   Use this object to directly read data off of the stream.
   * @note This object is only available after the {AWS.Request~httpHeaders}
   *   event has fired. This method must be called prior to
   *   {AWS.Request~httpData}.
   * @example Taking control of a stream
   *   request.on('httpHeaders', function(statusCode, headers) {
   *     if (statusCode < 300) {
   *       if (headers.etag === 'xyz') {
   *         // pipe the stream, disabling buffering
   *         var stream = this.response.httpResponse.createUnbufferedStream();
   *         stream.pipe(process.stdout);
   *       } else { // abort this request and set a better error message
   *         this.abort();
   *         this.response.error = new Error('Invalid ETag');
   *       }
   *     }
   *   }).send(console.log);
   */
  createUnbufferedStream: function createUnbufferedStream() {
    this.streaming = true;
    return this.stream;
  }
});


AWS.HttpClient = inherit({});

/**
 * @api private
 */
AWS.HttpClient.getInstance = function getInstance() {
  if (this.singleton === undefined) {
    this.singleton = new this();
  }
  return this.singleton;
};


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);

/**
 * @api private
 * @!method on(eventName, callback)
 *   Registers an event listener callback for the event given by `eventName`.
 *   Parameters passed to the callback function depend on the individual event
 *   being triggered. See the event documentation for those parameters.
 *
 *   @param eventName [String] the event name to register the listener for
 *   @param callback [Function] the listener callback function
 *   @return [AWS.SequentialExecutor] the same object for chaining
 */
AWS.SequentialExecutor = AWS.util.inherit({

  constructor: function SequentialExecutor() {
    this._events = {};
  },

  /**
   * @api private
   */
  listeners: function listeners(eventName) {
    return this._events[eventName] ? this._events[eventName].slice(0) : [];
  },

  on: function on(eventName, listener) {
    if (this._events[eventName]) {
      this._events[eventName].push(listener);
    } else {
      this._events[eventName] = [listener];
    }
    return this;
  },

  /**
   * @api private
   */
  onAsync: function onAsync(eventName, listener) {
    listener._isAsync = true;
    return this.on(eventName, listener);
  },

  removeListener: function removeListener(eventName, listener) {
    var listeners = this._events[eventName];
    if (listeners) {
      var length = listeners.length;
      var position = -1;
      for (var i = 0; i < length; ++i) {
        if (listeners[i] === listener) {
          position = i;
        }
      }
      if (position > -1) {
        listeners.splice(position, 1);
      }
    }
    return this;
  },

  removeAllListeners: function removeAllListeners(eventName) {
    if (eventName) {
      delete this._events[eventName];
    } else {
      this._events = {};
    }
    return this;
  },

  /**
   * @api private
   */
  emit: function emit(eventName, eventArgs, doneCallback) {
    if (!doneCallback) doneCallback = function() { };
    var listeners = this.listeners(eventName);
    var count = listeners.length;
    this.callListeners(listeners, eventArgs, doneCallback);
    return count > 0;
  },

  /**
   * @api private
   */
  callListeners: function callListeners(listeners, args, doneCallback, prevError) {
    var self = this;
    var error = prevError || null;

    function callNextListener(err) {
      if (err) {
        error = AWS.util.error(error || new Error(), err);
        if (self._haltHandlersOnError) {
          return doneCallback.call(self, error);
        }
      }
      self.callListeners(listeners, args, doneCallback, error);
    }

    while (listeners.length > 0) {
      var listener = listeners.shift();
      if (listener._isAsync) { // asynchronous listener
        listener.apply(self, args.concat([callNextListener]));
        return; // stop here, callNextListener will continue
      } else { // synchronous listener
        try {
          listener.apply(self, args);
        } catch (err) {
          error = AWS.util.error(error || new Error(), err);
        }
        if (error && self._haltHandlersOnError) {
          doneCallback.call(self, error);
          return;
        }
      }
    }
    doneCallback.call(self, error);
  },

  /**
   * Adds or copies a set of listeners from another list of
   * listeners or SequentialExecutor object.
   *
   * @param listeners [map<String,Array<Function>>, AWS.SequentialExecutor]
   *   a list of events and callbacks, or an event emitter object
   *   containing listeners to add to this emitter object.
   * @return [AWS.SequentialExecutor] the emitter object, for chaining.
   * @example Adding listeners from a map of listeners
   *   emitter.addListeners({
   *     event1: [function() { ... }, function() { ... }],
   *     event2: [function() { ... }]
   *   });
   *   emitter.emit('event1'); // emitter has event1
   *   emitter.emit('event2'); // emitter has event2
   * @example Adding listeners from another emitter object
   *   var emitter1 = new AWS.SequentialExecutor();
   *   emitter1.on('event1', function() { ... });
   *   emitter1.on('event2', function() { ... });
   *   var emitter2 = new AWS.SequentialExecutor();
   *   emitter2.addListeners(emitter1);
   *   emitter2.emit('event1'); // emitter2 has event1
   *   emitter2.emit('event2'); // emitter2 has event2
   */
  addListeners: function addListeners(listeners) {
    var self = this;

    // extract listeners if parameter is an SequentialExecutor object
    if (listeners._events) listeners = listeners._events;

    AWS.util.each(listeners, function(event, callbacks) {
      if (typeof callbacks === 'function') callbacks = [callbacks];
      AWS.util.arrayEach(callbacks, function(callback) {
        self.on(event, callback);
      });
    });

    return self;
  },

  /**
   * Registers an event with {on} and saves the callback handle function
   * as a property on the emitter object using a given `name`.
   *
   * @param name [String] the property name to set on this object containing
   *   the callback function handle so that the listener can be removed in
   *   the future.
   * @param (see on)
   * @return (see on)
   * @example Adding a named listener DATA_CALLBACK
   *   var listener = function() { doSomething(); };
   *   emitter.addNamedListener('DATA_CALLBACK', 'data', listener);
   *
   *   // the following prints: true
   *   console.log(emitter.DATA_CALLBACK == listener);
   */
  addNamedListener: function addNamedListener(name, eventName, callback) {
    this[name] = callback;
    this.addListener(eventName, callback);
    return this;
  },

  /**
   * @api private
   */
  addNamedAsyncListener: function addNamedAsyncListener(name, eventName, callback) {
    callback._isAsync = true;
    return this.addNamedListener(name, eventName, callback);
  },

  /**
   * Helper method to add a set of named listeners using
   * {addNamedListener}. The callback contains a parameter
   * with a handle to the `addNamedListener` method.
   *
   * @callback callback function(add)
   *   The callback function is called immediately in order to provide
   *   the `add` function to the block. This simplifies the addition of
   *   a large group of named listeners.
   *   @param add [Function] the {addNamedListener} function to call
   *     when registering listeners.
   * @example Adding a set of named listeners
   *   emitter.addNamedListeners(function(add) {
   *     add('DATA_CALLBACK', 'data', function() { ... });
   *     add('OTHER', 'otherEvent', function() { ... });
   *     add('LAST', 'lastEvent', function() { ... });
   *   });
   *
   *   // these properties are now set:
   *   emitter.DATA_CALLBACK;
   *   emitter.OTHER;
   *   emitter.LAST;
   */
  addNamedListeners: function addNamedListeners(callback) {
    var self = this;
    callback(
      function() {
        self.addNamedListener.apply(self, arguments);
      },
      function() {
        self.addNamedAsyncListener.apply(self, arguments);
      }
    );
    return this;
  }
});

/**
 * {on} is the prefered method.
 * @api private
 */
AWS.SequentialExecutor.prototype.addListener = AWS.SequentialExecutor.prototype.on;

module.exports = AWS.SequentialExecutor;


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.V3 = inherit(AWS.Signers.RequestSigner, {
  addAuthorization: function addAuthorization(credentials, date) {

    var datetime = AWS.util.date.rfc822(date);

    this.request.headers['X-Amz-Date'] = datetime;

    if (credentials.sessionToken) {
      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
    }

    this.request.headers['X-Amzn-Authorization'] =
      this.authorization(credentials, datetime);

  },

  authorization: function authorization(credentials) {
    return 'AWS3 ' +
      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
      'Algorithm=HmacSHA256,' +
      'SignedHeaders=' + this.signedHeaders() + ',' +
      'Signature=' + this.signature(credentials);
  },

  signedHeaders: function signedHeaders() {
    var headers = [];
    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
      headers.push(h.toLowerCase());
    });
    return headers.sort().join(';');
  },

  canonicalHeaders: function canonicalHeaders() {
    var headers = this.request.headers;
    var parts = [];
    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
      parts.push(h.toLowerCase().trim() + ':' + String(headers[h]).trim());
    });
    return parts.sort().join('\n') + '\n';
  },

  headersToSign: function headersToSign() {
    var headers = [];
    AWS.util.each(this.request.headers, function iterator(k) {
      if (k === 'Host' || k === 'Content-Encoding' || k.match(/^X-Amz/i)) {
        headers.push(k);
      }
    });
    return headers;
  },

  signature: function signature(credentials) {
    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
  },

  stringToSign: function stringToSign() {
    var parts = [];
    parts.push(this.request.method);
    parts.push('/');
    parts.push('');
    parts.push(this.canonicalHeaders());
    parts.push(this.request.body);
    return AWS.util.crypto.sha256(parts.join('\n'));
  }

});

module.exports = AWS.Signers.V3;


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);

/**
 * @api private
 */
var cachedSecret = {};

/**
 * @api private
 */
var cacheQueue = [];

/**
 * @api private
 */
var maxCacheEntries = 50;

/**
 * @api private
 */
var v4Identifier = 'aws4_request';

module.exports = {
  /**
   * @api private
   *
   * @param date [String]
   * @param region [String]
   * @param serviceName [String]
   * @return [String]
   */
  createScope: function createScope(date, region, serviceName) {
    return [
      date.substr(0, 8),
      region,
      serviceName,
      v4Identifier
    ].join('/');
  },

  /**
   * @api private
   *
   * @param credentials [Credentials]
   * @param date [String]
   * @param region [String]
   * @param service [String]
   * @param shouldCache [Boolean]
   * @return [String]
   */
  getSigningKey: function getSigningKey(
    credentials,
    date,
    region,
    service,
    shouldCache
  ) {
    var credsIdentifier = AWS.util.crypto
      .hmac(credentials.secretAccessKey, credentials.accessKeyId, 'base64');
    var cacheKey = [credsIdentifier, date, region, service].join('_');
    shouldCache = shouldCache !== false;
    if (shouldCache && (cacheKey in cachedSecret)) {
      return cachedSecret[cacheKey];
    }

    var kDate = AWS.util.crypto.hmac(
      'AWS4' + credentials.secretAccessKey,
      date,
      'buffer'
    );
    var kRegion = AWS.util.crypto.hmac(kDate, region, 'buffer');
    var kService = AWS.util.crypto.hmac(kRegion, service, 'buffer');

    var signingKey = AWS.util.crypto.hmac(kService, v4Identifier, 'buffer');
    if (shouldCache) {
      cachedSecret[cacheKey] = signingKey;
      cacheQueue.push(cacheKey);
      if (cacheQueue.length > maxCacheEntries) {
        // remove the oldest entry (not the least recently used)
        delete cachedSecret[cacheQueue.shift()];
      }
    }

    return signingKey;
  },

  /**
   * @api private
   *
   * Empties the derived signing key cache. Made available for testing purposes
   * only.
   */
  emptyCache: function emptyCache() {
    cachedSecret = {};
    cacheQueue = [];
  }
};


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
  rng = function whatwgRNG() {
    crypto.getRandomValues(rnds8);
    return rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

module.exports = rng;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(97)))

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(2711);
exports.encode = exports.stringify = __webpack_require__(2712);


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cognitoidentity'] = {};
AWS.CognitoIdentity = Service.defineService('cognitoidentity', ['2014-06-30']);
__webpack_require__(2719);
Object.defineProperty(apiLoader.services['cognitoidentity'], '2014-06-30', {
  get: function get() {
    var model = __webpack_require__(2720);
    model.paginators = __webpack_require__(2721).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CognitoIdentity;


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(5).util;

function typeOf(data) {
  if (data === null && typeof data === 'object') {
    return 'null';
  } else if (data !== undefined && isBinary(data)) {
    return 'Binary';
  } else if (data !== undefined && data.constructor) {
    return util.typeName(data.constructor);
  } else if (data !== undefined && typeof data === 'object') {
    // this object is the result of Object.create(null), hence the absence of a
    // defined constructor
    return 'Object';
  } else {
    return 'undefined';
  }
}

function isBinary(data) {
  var types = [
    'Buffer', 'File', 'Blob', 'ArrayBuffer', 'DataView',
    'Int8Array', 'Uint8Array', 'Uint8ClampedArray',
    'Int16Array', 'Uint16Array', 'Int32Array', 'Uint32Array',
    'Float32Array', 'Float64Array'
  ];
  if (util.isNode()) {
    var Stream = util.stream.Stream;
    if (util.Buffer.isBuffer(data) || data instanceof Stream) {
      return true;
    }
  }

  for (var i = 0; i < types.length; i++) {
    if (data !== undefined && data.constructor) {
      if (util.isType(data, types[i])) return true;
      if (util.typeName(data.constructor) === types[i]) return true;
    }
  }

  return false;
}

module.exports = {
  typeOf: typeOf,
  isBinary: isBinary
};


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(5).util;
var typeOf = __webpack_require__(1072).typeOf;

/**
 * @api private
 */
var memberTypeToSetType = {
  'String': 'String',
  'Number': 'Number',
  'NumberValue': 'Number',
  'Binary': 'Binary'
};

/**
 * @api private
 */
var DynamoDBSet = util.inherit({

  constructor: function Set(list, options) {
    options = options || {};
    this.initialize(list, options.validate);
  },

  initialize: function(list, validate) {
    var self = this;
    self.values = [].concat(list);
    self.detectType();
    if (validate) {
      self.validate();
    }
  },

  detectType: function() {
    this.type = memberTypeToSetType[typeOf(this.values[0])];
    if (!this.type) {
      throw util.error(new Error(), {
        code: 'InvalidSetType',
        message: 'Sets can contain string, number, or binary values'
      });
    }
  },

  validate: function() {
    var self = this;
    var length = self.values.length;
    var values = self.values;
    for (var i = 0; i < length; i++) {
      if (memberTypeToSetType[typeOf(values[i])] !== self.type) {
        throw util.error(new Error(), {
          code: 'InvalidType',
          message: self.type + ' Set contains ' + typeOf(values[i]) + ' value'
        });
      }
    }
  }

});

module.exports = DynamoDBSet;


/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports = { prefix: 'fas', iconName: 'folder', icon: [512, 512, [], "f07b", "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"] };

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProjectOpenItemForm_css__ = __webpack_require__(2981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProjectOpenItemForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ProjectOpenItemForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_dropdown_MultipleDropdown__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_upload_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_images_upload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_services_utils_files_util__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_shared_checkbox_LabeledCheckBox__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_domain_project__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_admin_projects_details_project_directory_store_selectors__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_open_items_store_selectors__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_admin_projects_details_project_directory_store_actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_admin_projects_details_project_open_items_store_actions__ = __webpack_require__(132);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectOpenItemForm=function(_Component){_inherits(ProjectOpenItemForm,_Component);function ProjectOpenItemForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProjectOpenItemForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProjectOpenItemForm.__proto__||Object.getPrototypeOf(ProjectOpenItemForm)).call.apply(_ref,[this].concat(args))),_this),_this.loadDirectory=function(){var _this$props=_this.props,currentProject=_this$props.currentProject,directory=_this$props.directory,dispatch=_this$props.dispatch;if(!directory||directory.project_id!==currentProject.id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_23_components_admin_projects_details_project_directory_store_actions__["j" /* loadDirectoryRequest */])(currentProject.id));}},_this.handleAttributeChange=function(attr,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_24_components_admin_projects_details_project_open_items_store_actions__["v" /* setOpenItemFormAttr */])(attr,value));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_24_components_admin_projects_details_project_open_items_store_actions__["d" /* clearOpenItemFormErrorAttr */])(attr));},_this.mapRecipientIds=function(){var form=_this.props.form;return form.recipients&&form.recipients.map(function(rcpt){return rcpt[0];});},_this.handleSaveDraft=function(){var _this$props2=_this.props,form=_this$props2.form,critical=_this$props2.critical,onSave=_this$props2.onSave;var recipientIds=_this.mapRecipientIds();var values=Object.assign({},form,{recipientIds:recipientIds,critical:critical,draft:true});onSave(values);},_this.handleSave=function(){var _this$props3=_this.props,form=_this$props3.form,critical=_this$props3.critical,onSave=_this$props3.onSave,dispatch=_this$props3.dispatch;var errors={};if(form.projectContributorId===null||form.projectContributorId===undefined){errors.projectContributorId=true;}if(!form.assigneeId){errors.assigneeId=true;}if(!form.resolveBy){errors.resolveBy=true;}if(!form.description){errors.description=true;}if(Object.keys(errors).length>0){dispatch(Object(__WEBPACK_IMPORTED_MODULE_24_components_admin_projects_details_project_open_items_store_actions__["w" /* setOpenItemFormErrors */])(errors));}else{var recipientIds=_this.mapRecipientIds();var values=Object.assign({},form,{recipientIds:recipientIds,critical:critical,draft:false});onSave(values);}},_this.projectContributorOptions=function(){var options=__WEBPACK_IMPORTED_MODULE_19_domain_project__["a" /* Project */].projectContributorOptions(_this.props);options.unshift({value:'',label:'00 General Contractor'});return options;},_this.recipientOptions=function(){var currentProject=_this.props.currentProject;return __WEBPACK_IMPORTED_MODULE_18_domain_enterprise__["a" /* Enterprise */].spackleOrGc(currentProject.contributor_type)?__WEBPACK_IMPORTED_MODULE_19_domain_project__["a" /* Project */].recipientOptions(_this.props):__WEBPACK_IMPORTED_MODULE_19_domain_project__["a" /* Project */].primaryRecipientOptions(_this.props);},_this.assigneeOptions=function(){return _this.recipientOptions().map(function(opt){return{value:opt.id,label:opt.label};});},_this.getArrayAttribute=function(attr){var form=_this.props.form;if(form&&form[attr]&&form[attr].length>0){return form[attr];}return[];},_this.setImages=function(files){var images=[].concat(_toConsumableArray(_this.getArrayAttribute('images')));files.forEach(function(val){images.push({url:URL.createObjectURL(val),file:val});});_this.handleAttributeChange('images',images);},_this.removeImage=function(index){var images=[].concat(_toConsumableArray(_this.getArrayAttribute('images')));var deletedImages=[].concat(_toConsumableArray(_this.getArrayAttribute('deletedImages')));var deletedImage=images.splice(index,1);deletedImages.push(deletedImage[0]);_this.handleAttributeChange('images',images);_this.handleAttributeChange('deletedImages',deletedImages);},_this.setDocuments=function(files){var docs=[].concat(_toConsumableArray(_this.getArrayAttribute('documents')));files.forEach(function(val){docs.push({file:val,name:val.name});});_this.handleAttributeChange('documents',docs);},_this.removeDocument=function(index){var docs=[].concat(_toConsumableArray(_this.getArrayAttribute('documents')));var deletedDocs=[].concat(_toConsumableArray(_this.getArrayAttribute('deletedDocuments')));var deletedDoc=docs.splice(index,1);deletedDocs.push(deletedDoc[0]);_this.handleAttributeChange('documents',docs);_this.handleAttributeChange('deletedDocuments',deletedDocs);},_this.showSaveDraftBtn=function(){var form=_this.props.form;return!form.id||form.draft;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProjectOpenItemForm,[{key:'componentDidMount',value:function componentDidMount(){this.loadDirectory();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_24_components_admin_projects_details_project_open_items_store_actions__["r" /* resetOpenItemForm */])());}},{key:'render',value:function render(){var _this2=this;var _props=this.props,form=_props.form,errors=_props.errors,onCancel=_props.onCancel;var showSaveDraftBtn=this.showSaveDraftBtn();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-form'},form.id&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'project-open-item-form-label project-open-item-resolved-label'},'Mark as Resolved'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{onChange:this.handleAttributeChange.bind(null,'resolved'),checked:form.resolved})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-form-block csi-code-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'project-open-item-form-label'},'CSI Code'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'project-open-item-form-error-field':errors.projectContributorId}),placeholder:'Select CSI Code...',onChange:function onChange(option){return _this2.handleAttributeChange('projectContributorId',option&&option.value);},value:form.projectContributorId,options:this.projectContributorOptions()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-form-block assignee-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'project-open-item-form-label'},'Assigned To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'project-open-item-form-error-field':errors.assigneeId}),placeholder:'Select Assignee...',onChange:function onChange(option){return _this2.handleAttributeChange('assigneeId',option.value);},value:form.assigneeId,options:this.assigneeOptions()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-form-block recipients-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'project-open-item-form-label'},'CC Recipient(s)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_dropdown_MultipleDropdown__["a" /* default */],{options:this.recipientOptions(),currentValues:form.recipients||[],placeholder:'Select Contributors to CC',onChange:function onChange(values){return _this2.handleAttributeChange('recipients',values);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-form-block resolve-by-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'project-open-item-form-label'},'Due Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'project-open-item-form-error-field':errors.resolveBy})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:__WEBPACK_IMPORTED_MODULE_9_services_utils_date_util__["k" /* todayValidation */],placeholder:'Resolve By',onChange:function onChange(value){return _this2.handleAttributeChange('resolveBy',value);},value:form.resolveBy}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'project-open-item-form-label'},'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea___default.a,{rows:2,className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'text-area':true,'input-area':true,'form-control':true,'project-open-item-form-error-field':errors.description}),placeholder:'Enter Text Here...',onBlur:function onBlur(e){return _this2.handleAttributeChange('description',e.target.value);},defaultValue:form.description})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-form-block project-open-item-form-block-docs'},form.documents&&form.documents.map(function(doc,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'doc-viewer',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'remove-doc-icon',src:__WEBPACK_IMPORTED_MODULE_11_images_remove_png___default.a,alt:'remove',onClick:function onClick(){return _this2.removeDocument(index);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_document_DocumentLink__["a" /* default */],{file:doc,url:doc.url}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx',className:'dropzone-container',onDrop:function onDrop(files){return _this2.setDocuments(files);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Please drag and drop any file into this area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10_images_upload_svg___default.a,alt:'upload'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:__WEBPACK_IMPORTED_MODULE_15_services_utils_files_util__["a" /* imageExtensions */],multiple:true,onUpload:function onUpload(files){return _this2.setImages(files);},onRemove:function onRemove(index){return _this2.removeImage(index);},images:form.images})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},showSaveDraftBtn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_shared_button_Button__["a" /* default */],{label:'Save Draft',className:'button-white',onClick:this.handleSaveDraft}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_shared_button_Button__["a" /* default */],{label:showSaveDraftBtn?'Submit':'Save',className:'button-orange',onClick:this.handleSave}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_shared_button_Button__["a" /* default */],{label:'Cancel',className:'button-gray',onClick:onCancel})));}}]);return ProjectOpenItemForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProjectOpenItemForm.propTypes={onSave:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),directory:Object(__WEBPACK_IMPORTED_MODULE_21_components_admin_projects_details_project_directory_store_selectors__["c" /* getDirectory */])(state),critical:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_open_items_store_selectors__["a" /* getCritical */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_open_items_store_selectors__["f" /* getOpenItemForm */])(state),errors:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_open_items_store_selectors__["g" /* getOpenItemFormErrors */])(state)};})(ProjectOpenItemForm));

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COI_EXPS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COI_EXP_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COI_EXP_DOCS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LIABILITIES_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COI_EXP_DOCS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COI_EXP_DOCS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COI_EXP_DOCS_DESTROY; });
var COI_EXPS_SET='COI_EXPS_SET';var COI_EXP_SET='COI_EXP_SET';var COI_EXP_DOCS_SET='COI_EXP_DOCS_SET';var LIABILITIES_SET='LIABILITIES_SET';var COI_EXP_DOCS_ADD='COI_EXP_DOCS_ADD';var COI_EXP_DOCS_UPDATE='COI_EXP_DOCS_UPDATE';var COI_EXP_DOCS_DESTROY='COI_EXP_DOCS_DESTROY';

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_stepper_horizontal__ = __webpack_require__(3024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_stepper_horizontal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_stepper_horizontal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_general_contractors_store_actions__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_selectors__ = __webpack_require__(165);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OnboardingStatus=function(_Component){_inherits(OnboardingStatus,_Component);function OnboardingStatus(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OnboardingStatus);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OnboardingStatus.__proto__||Object.getPrototypeOf(OnboardingStatus)).call.apply(_ref,[this].concat(args))),_this),_this.handleStageChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_components_admin_general_contractors_store_actions__["l" /* setStage */])(value));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OnboardingStatus,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_stepper_horizontal___default.a,{steps:[{title:'Contractor License',href:null,onClick:function onClick(){_this2.handleStageChange('licence-input');}},{title:'Company Logo ',href:null,onClick:function onClick(){_this2.handleStageChange('logo-upload');}}],size:16,lineMarginOffset:0,activeStep:this.props.activeStep,activeColor:'#ef4b3d',completeColor:'#ef4b3d',defaultColor:'#cecece',circleFontSize:0,completeBarColor:'#3c4249',defaultBarColor:'#cecece'});}}]);return OnboardingStatus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(state){return{currentStage:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_selectors__["d" /* getCurrentStage */])(state)};})(OnboardingStatus));

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(3026);


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(442),
    _assign = __webpack_require__(134);

var ReactNoopUpdateQueue = __webpack_require__(1080);

var canDefineProperty = __webpack_require__(1082);
var emptyObject = __webpack_require__(3027);
var invariant = __webpack_require__(443);
var lowPriorityWarning = __webpack_require__(3028);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(649);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getRfisCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRfis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPageSize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getRfisCount=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.rfis.data.rfisCount;},function(rfisCount){return rfisCount;});var getRfis=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.rfis.data.rfis;},function(rfis){return rfis;});var getCurrentStatus=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.rfis.data.currentStatus;},function(currentStatus){return currentStatus;});var getTotal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.rfis.data.total;},function(total){return total;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.rfis.data.currentPage;},function(currentPage){return currentPage;});var getPageSize=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.rfis.data.pageSize;},function(pageSize){return pageSize;});

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSubmittalsCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSubmittals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPageSize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getSubmittalsCount=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.submittals.data.submittalsCount;},function(submittalsCount){return submittalsCount;});var getSubmittals=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.submittals.data.submittals;},function(submittals){return submittals;});var getCurrentStatus=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.submittals.data.currentStatus;},function(currentStatus){return currentStatus;});var getTotal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.submittals.data.total;},function(total){return total;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.submittals.data.currentPage;},function(currentPage){return currentPage;});var getPageSize=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.submittals.data.pageSize;},function(pageSize){return pageSize;});

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getProjectOpenItemsCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getProjectOpenItemsCritCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProjectOpenItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPageSize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getProjectOpenItemsCount=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projectOpenItems.data.projectOpenItemsCount;},function(projectOpenItemsCount){return projectOpenItemsCount;});var getProjectOpenItemsCritCount=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projectOpenItems.data.projectOpenItemsCritCount;},function(projectOpenItemsCritCount){return projectOpenItemsCritCount;});var getProjectOpenItems=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projectOpenItems.data.projectOpenItems;},function(projectOpenItems){return projectOpenItems;});var getCurrentStatus=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projectOpenItems.data.currentStatus;},function(currentStatus){return currentStatus;});var getTotal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projectOpenItems.data.total;},function(total){return total;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projectOpenItems.data.currentPage;},function(currentPage){return currentPage;});var getPageSize=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projectOpenItems.data.pageSize;},function(pageSize){return pageSize;});

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFieldWorkOrdersCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFieldWorkOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPageSize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getFieldWorkOrdersCount=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.fieldWorkOrders.data.fieldWorkOrdersCount;},function(fieldWorkOrdersCount){return fieldWorkOrdersCount;});var getFieldWorkOrders=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.fieldWorkOrders.data.fieldWorkOrders;},function(fieldWorkOrders){return fieldWorkOrders;});var getTotal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.fieldWorkOrders.data.total;},function(total){return total;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.fieldWorkOrders.data.currentPage;},function(currentPage){return currentPage;});var getPageSize=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.fieldWorkOrders.data.pageSize;},function(pageSize){return pageSize;});

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rfisCountSuccess */
/* harmony export (immutable) */ __webpack_exports__["a"] = rfisCount;
/* unused harmony export rfisSuccess */
/* harmony export (immutable) */ __webpack_exports__["b"] = rfisRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_rfis_api__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_rfis_store_action_types__ = __webpack_require__(1090);
function rfisCountSuccess(count){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_rfis_store_action_types__["a" /* RFIS_COUNT */],payload:count};}function rfisCount(filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_rfis_api__["a" /* rfisApi */].getRfisAllCount(filters).then(function(response){if(response.ok){dispatch(rfisCountSuccess(response.count));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function rfisSuccess(rfis){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_rfis_store_action_types__["b" /* RFIS_LOAD */],payload:rfis};}function rfisRequest(page,status,filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_rfis_api__["a" /* rfisApi */].getRfisAll(page,filters).then(function(response){if(response.ok){dispatch(rfisSuccess(Object.assign({},response,{currentPage:page,currentStatus:status})));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RFIS_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RFIS_LOAD; });
var RFIS_COUNT='RFIS_COUNT';var RFIS_LOAD='RFIS_LOAD';

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export submittalsCountSuccess */
/* harmony export (immutable) */ __webpack_exports__["a"] = submittalsCount;
/* unused harmony export submittalsSuccess */
/* harmony export (immutable) */ __webpack_exports__["b"] = submittalsRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_submittals_api__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_submittals_store_action_types__ = __webpack_require__(1092);
function submittalsCountSuccess(count){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_submittals_store_action_types__["a" /* SUBMITTALS_COUNT */],payload:count};}function submittalsCount(filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_submittals_api__["a" /* submittalsApi */].getSubmittalsAllCount(filters).then(function(response){if(response.ok){dispatch(submittalsCountSuccess(response.count));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function submittalsSuccess(submittals){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_submittals_store_action_types__["b" /* SUBMITTALS_LOAD */],payload:submittals};}function submittalsRequest(page,status,filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_submittals_api__["a" /* submittalsApi */].getSubmittalsAll(page,filters).then(function(response){if(response.ok){dispatch(submittalsSuccess(Object.assign({},response,{currentPage:page,currentStatus:status})));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SUBMITTALS_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SUBMITTALS_LOAD; });
var SUBMITTALS_COUNT='SUBMITTALS_COUNT';var SUBMITTALS_LOAD='SUBMITTALS_LOAD';

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_OPEN_ITEMS_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROJECT_OPEN_ITEMS_CRITICAL_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PROJECT_OPEN_ITEMS_LOAD; });
var PROJECT_OPEN_ITEMS_COUNT='PROJECT_OPEN_ITEMS_COUNT';var PROJECT_OPEN_ITEMS_CRITICAL_COUNT='PROJECT_OPEN_ITEMS_CRITICAL_COUNT';var PROJECT_OPEN_ITEMS_LOAD='PROJECT_OPEN_ITEMS_LOAD';

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fieldWorkOrdersCountSuccess */
/* harmony export (immutable) */ __webpack_exports__["a"] = fieldWorkOrdersCount;
/* unused harmony export fieldWorkOrdersSuccess */
/* harmony export (immutable) */ __webpack_exports__["b"] = fieldWorkOrdersRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_field_work_orders_api__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_field_work_orders_store_action_types__ = __webpack_require__(1095);
function fieldWorkOrdersCountSuccess(count){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_field_work_orders_store_action_types__["a" /* FIELD_WORK_ORDERS_COUNT */],payload:count};}function fieldWorkOrdersCount(filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_field_work_orders_api__["a" /* fieldWorkOrdersApi */].getFieldWorkOrdersAllCount(filters).then(function(response){if(response.ok){dispatch(fieldWorkOrdersCountSuccess(response.count));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function fieldWorkOrdersSuccess(fieldWorkOrders){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_field_work_orders_store_action_types__["b" /* FIELD_WORK_ORDERS_LOAD */],payload:fieldWorkOrders};}function fieldWorkOrdersRequest(page,filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_field_work_orders_api__["a" /* fieldWorkOrdersApi */].getFieldWorkOrdersAll(page,filters).then(function(response){if(response.ok){dispatch(fieldWorkOrdersSuccess(Object.assign({},response,{currentPage:page})));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FIELD_WORK_ORDERS_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIELD_WORK_ORDERS_LOAD; });
var FIELD_WORK_ORDERS_COUNT='FIELD_WORK_ORDERS_COUNT';var FIELD_WORK_ORDERS_LOAD='FIELD_WORK_ORDERS_LOAD';

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_project_open_items_store_actions__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_project_open_items_ProjectOpenItemsTable__ = __webpack_require__(1097);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectOpenItems=function(_Component){_inherits(ProjectOpenItems,_Component);function ProjectOpenItems(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProjectOpenItems);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProjectOpenItems.__proto__||Object.getPrototypeOf(ProjectOpenItems)).call.apply(_ref,[this].concat(args))),_this),_this.handlePageChange=function(page){var _this$props=_this.props,filters=_this$props.filters,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_project_open_items_store_actions__["c" /* projectOpenItemsRequest */])(page,filters));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProjectOpenItems,[{key:'componentDidMount',value:function componentDidMount(){this.handlePageChange(1);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-items'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_project_open_items_ProjectOpenItemsTable__["a" /* default */],{onPageChange:this.handlePageChange}));}}]);return ProjectOpenItems;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProjectOpenItems.propTypes={filters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape()};ProjectOpenItems.defaultProps={filters:{}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{};})(ProjectOpenItems));

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectOpenItemsTable_css__ = __webpack_require__(3067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectOpenItemsTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ProjectOpenItemsTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_open_items_ProjectOpenItemDetailsModal__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_project_open_items_store_selectors__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_store_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_actions__ = __webpack_require__(132);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectOpenItemsTable=function(_Component){_inherits(ProjectOpenItemsTable,_Component);function ProjectOpenItemsTable(props){_classCallCheck(this,ProjectOpenItemsTable);var _this=_possibleConstructorReturn(this,(ProjectOpenItemsTable.__proto__||Object.getPrototypeOf(ProjectOpenItemsTable)).call(this,props));_this.handleGenerateLink=function(id){var projectOpenItems=_this.props.projectOpenItems;var poi=projectOpenItems.find(function(projectOpenItem){return projectOpenItem.id===id;});var projId=poi.project_id;var query='projectOpenItemId='+id;if(poi.critical){query+='&projectOpenItemCritical='+poi.critical;}return'projects/'+projId+'?'+query;};_this.open=function(id){var _this$props=_this.props,projectOpenItems=_this$props.projectOpenItems,dispatch=_this$props.dispatch;var projectOpenItem=projectOpenItems.find(function(projectOpenItem){return projectOpenItem.id===id;});_this.setState({showModal:true});dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_store_actions__["b" /* loadProjectRequest */])(projectOpenItem.project_id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_actions__["y" /* setOpenItemsCritical */])(projectOpenItem.critical));dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_actions__["m" /* loadOpenItem */])(projectOpenItem.project_id,projectOpenItem.id));};_this.close=function(){var _this$props2=_this.props,currentPage=_this$props2.currentPage,currentStatus=_this$props2.currentStatus,onPageChange=_this$props2.onPageChange;_this.setState({showModal:false});onPageChange(currentPage,currentStatus);};_this.mapProjectOpenItems=function(){return _this.props.projectOpenItems.map(function(projectOpenItem){return{id:projectOpenItem.id,data:[projectOpenItem.project_number,projectOpenItem.project_name,Object(__WEBPACK_IMPORTED_MODULE_8_services_utils_text_util__["b" /* formatNumber */])(projectOpenItem.number),projectOpenItem.csi_code&&projectOpenItem.csi_code.division||'00',projectOpenItem.description||'-',projectOpenItem.resolve_by?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__["a" /* default */],{className:'due-date',value:projectOpenItem.resolve_by,format:'MM/DD/YYYY'}):'-']};});};_this.state={showModal:false};return _this;}_createClass(ProjectOpenItemsTable,[{key:'render',value:function render(){var _props=this.props,currentStatus=_props.currentStatus,total=_props.total,currentPage=_props.currentPage,pageSize=_props.pageSize,_onPageChange=_props.onPageChange;var showModal=this.state.showModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-items-all-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table',headers:['PROJECT #','NAME','#','CSI CODE','DESCRIPTION','DUE'],rows:this.mapProjectOpenItems(),emptyMessage:'No Project Open Item\'s added yet.',onRowSelected:this.open,onGenerateLink:this.handleGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPage,pageSize:pageSize,total:total,onPageChange:function onPageChange(page){return _onPageChange(page,currentStatus);}})),showModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_open_items_ProjectOpenItemDetailsModal__["a" /* default */],{onClose:this.close}));}}]);return ProjectOpenItemsTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProjectOpenItemsTable.propTypes={onPageChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{projectOpenItems:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_project_open_items_store_selectors__["d" /* getProjectOpenItems */])(state),currentStatus:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_project_open_items_store_selectors__["b" /* getCurrentStatus */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_project_open_items_store_selectors__["g" /* getTotal */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_project_open_items_store_selectors__["a" /* getCurrentPage */])(state),pageSize:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_project_open_items_store_selectors__["c" /* getPageSize */])(state)};})(ProjectOpenItemsTable));

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_project_open_items_store_actions__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_project_open_items_ProjectOpenItemsTable__ = __webpack_require__(1097);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectOpenItemsCritical=function(_Component){_inherits(ProjectOpenItemsCritical,_Component);function ProjectOpenItemsCritical(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProjectOpenItemsCritical);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProjectOpenItemsCritical.__proto__||Object.getPrototypeOf(ProjectOpenItemsCritical)).call.apply(_ref,[this].concat(args))),_this),_this.handlePageChange=function(page){var _this$props=_this.props,filters=_this$props.filters,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_project_open_items_store_actions__["c" /* projectOpenItemsRequest */])(page,Object.assign({},filters,{unresolved:true,critical:true})));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProjectOpenItemsCritical,[{key:'componentDidMount',value:function componentDidMount(){this.handlePageChange(1);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-items'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_project_open_items_ProjectOpenItemsTable__["a" /* default */],{onPageChange:this.handlePageChange}));}}]);return ProjectOpenItemsCritical;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProjectOpenItemsCritical.propTypes={filters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape()};ProjectOpenItemsCritical.defaultProps={filters:{}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{};})(ProjectOpenItemsCritical));

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_RECENT_ACTIVITY_LOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SPE_RECENT_ACTIVITY_LOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SW_RECENT_ACTIVITY_LOAD; });
var ALL_RECENT_ACTIVITY_LOAD='ALL_RECENT_ACTIVITY_LOAD';var SPE_RECENT_ACTIVITY_LOAD='SPE_RECENT_ACTIVITY_LOAD';var SW_RECENT_ACTIVITY_LOAD='SW_RECENT_ACTIVITY_LOAD';

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_notifications__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_admin_invoices_invoices__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_contractors_contractors__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_purchase_orders_store_actions__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_domain_notification__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_surveys_store_actions__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_header_NotificationViewer__ = __webpack_require__(3079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_notifications_socket__ = __webpack_require__(3084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_selectors_notifications__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_services_utils_work_order_status_enum__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_actions_admin_clients_clients__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_contractors_invoices_store_actions__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_admin_projects_store_actions__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotificationsContainer=function(_Component){_inherits(NotificationsContainer,_Component);function NotificationsContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NotificationsContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NotificationsContainer.__proto__||Object.getPrototypeOf(NotificationsContainer)).call.apply(_ref,[this].concat(args))),_this),_this.handleOnUpdate=function(data){if(data!==undefined&&data.notification!==undefined){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_notifications__["j" /* addUnreadMessage */])(data.notification,_this.props.notifications.total,_this.props.notifications.totalUnread));}},_this.handleMessageOpen=function(id){var message=_this.props.notifications.content.find(function(message){return message.id===id;});if(message!==undefined){if(message.read_at===null){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_notifications__["m" /* markAsRead */])(message.id,_this.props.notifications.totalUnread));}_this.goToMessageTarget(message);}},_this.handleMessageRead=function(id){var message=_this.props.notifications.content.find(function(message){return message.id===id;});if(message!==undefined){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_notifications__["m" /* markAsRead */])(message.id,_this.props.notifications.totalUnread));}},_this.handleMessageUnread=function(id){var message=_this.props.notifications.content.find(function(message){return message.id===id;});if(message!==undefined){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_notifications__["n" /* markAsUnread */])(message.id,_this.props.notifications.totalUnread));}},_this.handleMarkAllAsRead=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_notifications__["l" /* markAllAsRead */])());},_this.handleShowNewer=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_notifications__["q" /* setShowLoader */])(true));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_notifications__["k" /* loadNotificationsRequest */])(_this.props.currentPage-1)).then(function(response){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_notifications__["q" /* setShowLoader */])(false));if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_notifications__["p" /* setCurrentPage */])(_this.props.currentPage-1));}});},_this.handleShowOlder=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_notifications__["q" /* setShowLoader */])(true));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_notifications__["k" /* loadNotificationsRequest */])(_this.props.currentPage+1)).then(function(response){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_notifications__["q" /* setShowLoader */])(false));if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_notifications__["p" /* setCurrentPage */])(_this.props.currentPage+1));}});},_this.goToMessageTarget=function(message){var notifiableType=Object(__WEBPACK_IMPORTED_MODULE_7_domain_notification__["c" /* getNotifiableType */])(message);var notifiable=Object(__WEBPACK_IMPORTED_MODULE_7_domain_notification__["b" /* getNotifiable */])(message);if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].WORK_ORDER){if(__WEBPACK_IMPORTED_MODULE_15_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].DRAFT.equals(__WEBPACK_IMPORTED_MODULE_15_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(notifiable.status))){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_work_orders__["w" /* selectWorkOrderRequest */])(notifiable.id,notifiable.status));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_work_orders__["h" /* goToWorkOrder */])(notifiable.id));}}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].TASK){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_actions_admin_work_orders_details_details__["A" /* goToTask */])(notifiable.work_order_id,notifiable.id));}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].INVOICE){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_invoices_invoices__["g" /* goToInvoice */])(notifiable.id));}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].CONTRACTOR){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_contractors_contractors__["d" /* goToContractor */])(notifiable.id));}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].PURCHASE_ORDER){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_purchase_orders_store_actions__["d" /* goToPurchaseOrders */])());}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].SURVEY){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_surveys_store_actions__["d" /* goToSurvey */])(notifiable.id));}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].CLIENT){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_actions_admin_clients_clients__["d" /* goToClient */])(notifiable.id));}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].CONTRACTOR_INVOICE){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_components_admin_contractors_invoices_store_actions__["g" /* goToContractorInvoices */])());}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].PROJECT){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_store_actions__["f" /* goToProjectDetails */])(notifiable.id));}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].MEETING){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_store_actions__["f" /* goToProjectDetails */])(notifiable.project_id,{meetingId:notifiable.id}));}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].RFI){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_store_actions__["f" /* goToProjectDetails */])(notifiable.project_id,{rfiId:notifiable.id}));}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].SUBMITTAL){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_store_actions__["f" /* goToProjectDetails */])(notifiable.project_id,{submittalId:notifiable.id}));}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].PROJECT_OPEN_ITEM){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_store_actions__["f" /* goToProjectDetails */])(notifiable.project_id,{projectOpenItemId:notifiable.id,projectOpenItemCritical:notifiable.critical}));}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].SUB_DAILY_REPORT){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_store_actions__["f" /* goToProjectDetails */])(notifiable.project_id,{dailyReportId:notifiable.id,subDailyReport:true}));}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].DOCUMENT_NOTIFICATION){window.open(notifiable.document_url,'_blank');}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].COI_EXP){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_store_actions__["f" /* goToProjectDetails */])(notifiable.project_id,{documentation:true}));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NotificationsContainer,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;// Do not load notifications on recent activity.
if(this.props.recentActivity){return null;}this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_notifications__["k" /* loadNotificationsRequest */])()).then(function(response){if(response.ok){_this2.notificationsSocket=new __WEBPACK_IMPORTED_MODULE_11_services_notifications_socket__["a" /* default */](_this2.props.currentUser.uid,_this2.props.accessToken,_this2.props.client,_this2.handleOnUpdate);_this2.notificationsSocket.subscribe({channel:'NotificationsChannel'});}});}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.notificationsSocket){this.notificationsSocket.disconnect();}}},{key:'render',value:function render(){var pageSize=0;var total=0;var totalUnread=0;var messages=[];if(this.props.notifications!==null){pageSize=this.props.notifications.pageSize;total=this.props.notifications.total;totalUnread=this.props.notifications.totalUnread;messages=this.props.notifications.content.map(function(message){return NotificationsContainer.mapMessage(message);});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_header_NotificationViewer__["a" /* default */],{recentActivity:this.props.recentActivity,currentPage:this.props.currentPage,pageSize:pageSize,messages:messages,showLoader:this.props.showLoader,total:total,totalUnread:totalUnread,onMessageOpen:this.handleMessageOpen,onMessageRead:this.handleMessageRead,onMessageUnread:this.handleMessageUnread,onMarkAllAsRead:this.handleMarkAllAsRead,onShowNewer:this.handleShowNewer,onShowOlder:this.handleShowOlder,onPageChange:this.props.onPageChange});}}],[{key:'mapMessage',value:function mapMessage(message){var notifiableType=Object(__WEBPACK_IMPORTED_MODULE_7_domain_notification__["c" /* getNotifiableType */])(message);var notifiable=Object(__WEBPACK_IMPORTED_MODULE_7_domain_notification__["b" /* getNotifiable */])(message);var user=message.user;var data={id:message.id,message:message.action,unread:message.read_at===null,content:message.content};if(user){data['user']=NotificationsContainer.buildMessageUser(user);}if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].WORK_ORDER){data['target']='WO #'+notifiable.number;}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].TASK){data['target']='Task #'+notifiable.number+' WO #'+notifiable.wo_number;}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].INVOICE){data['target']='Invoice WO #'+notifiable.wo_number;}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].CONTRACTOR){data['target']=''+notifiable.name;}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].PURCHASE_ORDER){data['target']='PO #'+notifiable.number;}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].SURVEY){data['target']='Survey WO #'+notifiable.wo_number;}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].CLIENT){data['target']=''+notifiable.company_name;}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].CONTRACTOR_INVOICE){data['target']='WO #'+notifiable.work_order_number;}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].PROJECT){data['target']='Project '+notifiable.name;}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].MEETING){data['target']='Meeting '+__WEBPACK_IMPORTED_MODULE_19_moment___default()(notifiable.meeting_date).format('L')+' - '+notifiable.project_name;}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].RFI){data['target']='RFI #'+notifiable.number+' - '+notifiable.project_name+' - '+notifiable.title;}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].SUBMITTAL){data['target']='Submittal '+notifiable.division+'-'+notifiable.number+' - '+notifiable.project_name+' - '+notifiable.title;}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].PROJECT_OPEN_ITEM){data['target']='Open Item #'+notifiable.number+' - '+notifiable.project_name;}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].ORDER){data['target']='Order #'+notifiable.reference_number+' - '+notifiable.project_name;data['message']=data['message']+'. Check your mobile app.';data['webAvailable']=false;}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].PAR){data['target']='PAR '+__WEBPACK_IMPORTED_MODULE_19_moment___default()(notifiable.created_at).format('L')+' - '+notifiable.project_name;data['message']=data['message']+'. Check your mobile app.';data['webAvailable']=false;}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].SUB_DAILY_REPORT){data['target']='Sub Daily Report '+__WEBPACK_IMPORTED_MODULE_19_moment___default()(notifiable.report_date).format('L')+' - '+notifiable.project_name;}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].DOCUMENT_NOTIFICATION){data['target']=notifiable.name;}else if(notifiableType===__WEBPACK_IMPORTED_MODULE_7_domain_notification__["a" /* NotificationTypes */].COI_EXP){data['target']='Project '+notifiable.project_name;}else{data['target']='unknown';}return data;}}]);return NotificationsContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NotificationsContainer.propTypes={recentActivity:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,notifications:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape(),currentPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,onPageChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};NotificationsContainer.defaultProps={recentActivity:false,notifications:null,currentPage:null,onPageChange:null};NotificationsContainer.buildMessageUser=function(user){var accountable=user.accountable;var companyName=accountable?accountable.name||accountable.company_name:'Spackle';return user.first_name+' '+user.last_name+' - '+companyName;};var mapStateToProps=function mapStateToProps(state,ownProps){return{accessToken:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_authentication__["a" /* getAccessToken */])(state),client:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_authentication__["c" /* getClient */])(state),currentPage:ownProps.currentPage||Object(__WEBPACK_IMPORTED_MODULE_12_selectors_notifications__["a" /* getCurrentPage */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_authentication__["d" /* getCurrentUser */])(state),notifications:ownProps.notifications||Object(__WEBPACK_IMPORTED_MODULE_12_selectors_notifications__["b" /* getNotifications */])(state),showLoader:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_notifications__["c" /* getShowLoader */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(NotificationsContainer));

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory(__webpack_require__(3082)) :
	typeof define === 'function' && define.amd ? define(['react'], factory) :
	(global = global || self, global.ReactAwesomePopover = factory(global.React));
}(this, function (React) { 'use strict';

	React = React && React.hasOwnProperty('default') ? React['default'] : React;

	function _defineProperty(obj, key, value) {
	    if (key in obj) {
	        Object.defineProperty(obj, key, {
	            value: value,
	            enumerable: true,
	            configurable: true,
	            writable: true
	        });
	    } else {
	        obj[key] = value;
	    }
	    return obj;
	}
	function _extends() {
	    _extends = Object.assign || function(target) {
	        for(var i = 1; i < arguments.length; i++){
	            var source = arguments[i];
	            for(var key in source){
	                if (Object.prototype.hasOwnProperty.call(source, key)) {
	                    target[key] = source[key];
	                }
	            }
	        }
	        return target;
	    };
	    return _extends.apply(this, arguments);
	}
	function _objectSpread(target) {
	    for(var i = 1; i < arguments.length; i++){
	        var source = arguments[i] != null ? arguments[i] : {
	        };
	        var ownKeys = Object.keys(source);
	        if (typeof Object.getOwnPropertySymbols === 'function') {
	            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
	                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	            }));
	        }
	        ownKeys.forEach(function(key) {
	            _defineProperty(target, key, source[key]);
	        });
	    }
	    return target;
	}
	function _throw(e) {
	    throw e;
	}
	var Target = function(param) {
	    var ref1 = param ? param : _throw(new TypeError("Cannot destructure 'undefined' or 'null'")), open = ref1.open, zIndex = ref1.zIndex, children = ref1.children, action = ref1.action, targetRef = ref1.targetRef, setOpen = ref1.setOpen, preventDefault = ref1.preventDefault, stopPropagation = ref1.stopPropagation;
	    var onClick = function(e) {
	        if (preventDefault) e.preventDefault();
	        if (stopPropagation) e.stopPropagation();
	        setOpen();
	    };
	    var onMouseOut = function(param1) {
	        var ref1 = param1 ? param1 : _throw(new TypeError("Cannot destructure 'undefined' or 'null'")), relatedTarget = ref1.relatedTarget;
	        if (relatedTarget.id === 'overlay') {
	            setOpen();
	        }
	    };
	    var defaultStyle = {
	        display: 'inline-block',
	        position: 'relative'
	    };
	    var zIndexStyle = open ? {
	        zIndex: zIndex + 10
	    } : {
	    };
	    var actions = action === 'click' ? {
	        onClick: onClick,
	        onTouchEnd: onClick
	    } : action === 'hover' ? {
	        onMouseOver: setOpen,
	        onMouseOut: onMouseOut
	    } : {
	    };
	    return React.createElement('div', _extends({
	        style: _objectSpread({
	        }, defaultStyle, zIndexStyle),
	        ref: targetRef
	    }, actions), children);
	};

	var DEFAULT_ZINDEX = 1000;

	function _assertThisInitialized(self) {
	    if (self === void 0) {
	        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	    return self;
	}
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	function _defineProperties(target, props) {
	    for(var i = 0; i < props.length; i++){
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ('value' in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	    }
	}
	function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	}
	function _defineProperty$1(obj, key, value) {
	    if (key in obj) {
	        Object.defineProperty(obj, key, {
	            value: value,
	            enumerable: true,
	            configurable: true,
	            writable: true
	        });
	    } else {
	        obj[key] = value;
	    }
	    return obj;
	}
	function _extends$1() {
	    _extends$1 = Object.assign || function(target) {
	        for(var i = 1; i < arguments.length; i++){
	            var source = arguments[i];
	            for(var key in source){
	                if (Object.prototype.hasOwnProperty.call(source, key)) {
	                    target[key] = source[key];
	                }
	            }
	        }
	        return target;
	    };
	    return _extends$1.apply(this, arguments);
	}
	function _getPrototypeOf(o) {
	    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	        return o.__proto__ || Object.getPrototypeOf(o);
	    };
	    return _getPrototypeOf(o);
	}
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function');
	    }
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	        constructor: {
	            value: subClass,
	            writable: true,
	            configurable: true
	        }
	    });
	    if (superClass) _setPrototypeOf(subClass, superClass);
	}
	function _objectSpread$1(target) {
	    for(var i = 1; i < arguments.length; i++){
	        var source = arguments[i] != null ? arguments[i] : {
	        };
	        var ownKeys = Object.keys(source);
	        if (typeof Object.getOwnPropertySymbols === 'function') {
	            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
	                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	            }));
	        }
	        ownKeys.forEach(function(key) {
	            _defineProperty$1(target, key, source[key]);
	        });
	    }
	    return target;
	}
	function _objectWithoutProperties(source, excluded) {
	    if (source == null) return {
	    };
	    var target = _objectWithoutPropertiesLoose(source, excluded);
	    var key, i;
	    if (Object.getOwnPropertySymbols) {
	        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	        for(i = 0; i < sourceSymbolKeys.length; i++){
	            key = sourceSymbolKeys[i];
	            if (excluded.indexOf(key) >= 0) continue;
	            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	            target[key] = source[key];
	        }
	    }
	    return target;
	}
	function _objectWithoutPropertiesLoose(source, excluded) {
	    if (source == null) return {
	    };
	    var target = {
	    };
	    var sourceKeys = Object.keys(source);
	    var key, i;
	    for(i = 0; i < sourceKeys.length; i++){
	        key = sourceKeys[i];
	        if (excluded.indexOf(key) >= 0) continue;
	        target[key] = source[key];
	    }
	    return target;
	}
	function _possibleConstructorReturn(self, call) {
	    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
	        return call;
	    }
	    return _assertThisInitialized(self);
	}
	function _setPrototypeOf(o, p) {
	    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	        o.__proto__ = p;
	        return o;
	    };
	    return _setPrototypeOf(o, p);
	}
	function _throw$1(e) {
	    throw e;
	}
	var _typeof = function(obj) {
	    return obj && obj.constructor === Symbol ? 'symbol' : typeof obj;
	};
	var _Math;
	var Content = function(_Component) {
	    _inherits(Content, _Component);
	    function Content() {
	        var _this;
	        _classCallCheck(this, Content);
	        _this = _possibleConstructorReturn(this, _getPrototypeOf(Content).apply(this, arguments));
	        _defineProperty$1(_assertThisInitialized(_this), 'state', {
	            position: null
	        });
	        _defineProperty$1(_assertThisInitialized(_this), 'contentRef', React.createRef());
	        _defineProperty$1(_assertThisInitialized(_this), 'arrowRef', React.createRef());
	        return _this;
	    }
	    _createClass(Content, [{
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                var ref = this, ref1 = ref ? ref : _throw$1(new TypeError("Cannot destructure 'undefined' or 'null'")), contentRef = ref1.contentRef, arrowRef = ref1.arrowRef;
	                var ref2 = this.props, ref3 = ref2 ? ref2 : _throw$1(new TypeError("Cannot destructure 'undefined' or 'null'")), targetRef = ref3.targetRef, arrow = ref3.arrow, onOpen = ref3.onOpen, placement = ref3.placement;
	                if (onOpen) onOpen();
	                var targetBound = targetRef.current.getBoundingClientRect();
	                var contentBound = contentRef.current.getBoundingClientRect();
	                var arrowBound = {
	                    width: 0,
	                    height: 0
	                };
	                if (arrow) {
	                    arrowBound = arrowRef.current.getBoundingClientRect();
	                }
	                var ref4 = window ? window : _throw$1(new TypeError("Cannot destructure 'undefined' or 'null'")), innerWidth = ref4.innerWidth, innerHeight = ref4.innerHeight;
	                var calcCoverLeft = contentBound.x - contentBound.width;
	                var coverLeft = calcCoverLeft < 0 ? calcCoverLeft : 0;
	                var calcCoverRight = contentBound.x + targetBound.width + contentBound.width;
	                var coverRight = calcCoverRight > innerWidth ? innerWidth - calcCoverRight : 0;
	                var calcCoverTop = contentBound.y - contentBound.height;
	                var coverTop = calcCoverTop < 0 ? calcCoverTop : 0;
	                var calcCoverBottom = targetBound.bottom + contentBound.height;
	                var coverBottom = calcCoverBottom > innerHeight ? innerHeight - calcCoverBottom : 0;
	                var calcXCenterLeft = contentBound.x + targetBound.width / 2 - contentBound.width / 2;
	                var calcXCenterRight = contentBound.x + targetBound.width / 2 - contentBound.width / 2 + contentBound.width;
	                var coverXCenterLeft = calcXCenterLeft < 0 ? calcXCenterLeft : 0;
	                var coverXCenterRight = calcXCenterRight > innerWidth ? innerWidth - calcXCenterRight : 0;
	                var calcYCenterTop = contentBound.y + targetBound.height / 2 - contentBound.height / 2;
	                var coverYCenterTop = calcYCenterTop < 0 ? calcYCenterTop : 0;
	                var calcYCenterBottom = contentBound.y + targetBound.height / 2 - contentBound.height / 2 + contentBound.height;
	                var coverYCenterBottom = calcYCenterBottom > innerHeight ? calcYCenterBottom : 0;
	                var calcTopStart = contentBound.x + contentBound.width;
	                var coverTopStart = calcTopStart > innerWidth ? innerWidth - calcTopStart : 0;
	                var calcTopEnd = contentBound.x - contentBound.width - targetBound.width;
	                var coverTopEnd = calcTopEnd < 0 ? calcTopEnd : 0;
	                var calcLeftEndTop = contentBound.y - contentBound.height - targetBound.height;
	                var coverLeftEndTop = calcLeftEndTop < 0 ? calcLeftEndTop : 0;
	                var coverRightEndTop = coverLeftEndTop;
	                var calcLefStartBottom = contentBound.y + contentBound.height;
	                var coverLeftStartBottom = calcLefStartBottom > innerHeight ? innerHeight - calcLefStartBottom : 0;
	                var coverRightStartBottom = coverLeftStartBottom;
	                var coverBottomStartRight = coverTopStart;
	                var coverBottomEndLeft = coverTopEnd;
	                var xCenterStyle = targetBound.height / 2 - contentBound.height / 2;
	                var rightLeftEnd = -(contentBound.height - targetBound.height);
	                var topBottomEnd = -(contentBound.width - targetBound.width);
	                var topBottomCenter = targetBound.width / 2 - contentBound.width / 2;
	                var computeArrowW = arrowBound.width / 2;
	                var computearrowH = arrowBound.height / 2;
	                var leftLeftStyle = -(contentBound.width + computeArrowW);
	                var topTopStyle = -(contentBound.height + arrowBound.height / 2);
	                var rightLeftStyle = targetBound.width + computeArrowW;
	                var bottomTopStyle = targetBound.height + computearrowH;
	                var styles = {
	                    topStart: {
	                        top: topTopStyle
	                    },
	                    topCenter: {
	                        top: topTopStyle,
	                        left: topBottomCenter
	                    },
	                    topEnd: {
	                        top: topTopStyle,
	                        left: topBottomEnd
	                    },
	                    leftStart: {
	                        left: leftLeftStyle
	                    },
	                    leftCenter: {
	                        left: leftLeftStyle,
	                        top: xCenterStyle
	                    },
	                    leftEnd: {
	                        top: rightLeftEnd,
	                        left: leftLeftStyle
	                    },
	                    rightStart: {
	                        left: rightLeftStyle
	                    },
	                    rightCenter: {
	                        left: rightLeftStyle,
	                        top: xCenterStyle
	                    },
	                    rightEnd: {
	                        left: rightLeftStyle,
	                        top: rightLeftEnd
	                    },
	                    bottomStart: {
	                        top: bottomTopStyle
	                    },
	                    bottomCenter: {
	                        top: bottomTopStyle,
	                        left: topBottomCenter
	                    },
	                    bottomEnd: {
	                        top: bottomTopStyle,
	                        left: topBottomEnd
	                    }
	                };
	                var transform = {
	                    bottom: {
	                        transform: 'rotate(-45deg)'
	                    },
	                    top: {
	                        transform: 'rotate(135deg)'
	                    },
	                    left: {
	                        transform: 'rotate(45deg)'
	                    },
	                    right: {
	                        transform: 'rotate(45deg)'
	                    }
	                };
	                var arrowBottomTop = Math.ceil(-arrowBound.height / 2);
	                var arrowBottomTopCenter = contentBound.width / 2 - arrowBound.width / 2;
	                var arrowTop = contentBound.height - arrowBound.height / 2;
	                var arrowTopBottomEnd = targetBound.width / 2 - arrowBound.width / 2;
	                var arrowLeftRightEnd = contentBound.height - arrowBound.height / 2 - targetBound.height / 2;
	                var arrowLeftRightCenter = contentBound.height / 2 - Math.ceil(arrowBound.height / 2);
	                var arrowTopBottomStartLeft = targetBound.width / 2 - arrowBound.width / 2;
	                var arrowLeftLeft = Math.ceil(contentBound.width - arrowBound.width / 2);
	                var arrowLeftRightTop = targetBound.height / 2 - arrowBound.height / 2;
	                var arrowStyle = {
	                    topStart: _objectSpread$1({
	                    }, transform.top, {
	                        top: arrowTop,
	                        left: arrowTopBottomStartLeft
	                    }),
	                    topCenter: _objectSpread$1({
	                    }, transform.top, {
	                        top: arrowTop,
	                        left: arrowBottomTopCenter
	                    }),
	                    topEnd: _objectSpread$1({
	                    }, transform.top, {
	                        top: arrowTop,
	                        right: arrowTopBottomEnd
	                    }),
	                    leftStart: _objectSpread$1({
	                    }, transform.left, {
	                        left: arrowLeftLeft,
	                        top: arrowLeftRightTop
	                    }),
	                    leftCenter: _objectSpread$1({
	                    }, transform.left, {
	                        left: arrowLeftLeft,
	                        top: arrowLeftRightCenter
	                    }),
	                    leftEnd: _objectSpread$1({
	                    }, transform.left, {
	                        left: arrowLeftLeft,
	                        top: arrowLeftRightEnd
	                    }),
	                    rightStart: _objectSpread$1({
	                    }, transform.right, {
	                        left: -arrowBound.width,
	                        top: arrowLeftRightTop
	                    }),
	                    rightCenter: _objectSpread$1({
	                    }, transform.right, {
	                        left: -arrowBound.width,
	                        top: arrowLeftRightCenter
	                    }),
	                    rightEnd: _objectSpread$1({
	                    }, transform.right, {
	                        left: -arrowBound.width,
	                        top: arrowLeftRightEnd
	                    }),
	                    bottomStart: _objectSpread$1({
	                    }, transform.bottom, {
	                        top: arrowBottomTop,
	                        left: arrowTopBottomStartLeft
	                    }),
	                    bottomCenter: _objectSpread$1({
	                    }, transform.bottom, {
	                        top: arrowBottomTop,
	                        left: arrowBottomTopCenter
	                    }),
	                    bottomEnd: _objectSpread$1({
	                    }, transform.bottom, {
	                        top: arrowBottomTop,
	                        right: arrowTopBottomEnd
	                    })
	                };
	                var pos = [
	                    {
	                        at: 'top-start',
	                        cover: [coverTop, coverTopStart, 0],
	                        style: styles.topStart,
	                        arrow: arrowStyle.topStart
	                    },
	                    {
	                        at: 'top-center',
	                        cover: [coverTop, coverXCenterLeft, coverXCenterRight],
	                        style: styles.topCenter,
	                        arrow: arrowStyle.topCenter
	                    },
	                    {
	                        at: 'top-end',
	                        cover: [coverTop, coverTopEnd, 0],
	                        style: styles.topEnd,
	                        arrow: arrowStyle.topEnd
	                    },
	                    {
	                        at: 'left-start',
	                        cover: [coverLeft, coverLeftStartBottom, 0],
	                        style: styles.leftStart,
	                        arrow: arrowStyle.leftStart
	                    },
	                    {
	                        at: 'left-center',
	                        cover: [coverLeft, coverYCenterTop, coverYCenterBottom],
	                        style: styles.leftCenter,
	                        arrow: arrowStyle.leftCenter
	                    },
	                    {
	                        at: 'left-end',
	                        cover: [coverLeft, coverLeftEndTop, 0],
	                        style: styles.leftEnd,
	                        arrow: arrowStyle.leftEnd
	                    },
	                    {
	                        at: 'right-start',
	                        cover: [coverRight, coverRightStartBottom, 0],
	                        style: styles.rightStart,
	                        arrow: arrowStyle.rightStart
	                    },
	                    {
	                        at: 'right-center',
	                        cover: [coverRight, coverYCenterTop, coverYCenterBottom],
	                        style: styles.rightCenter,
	                        arrow: arrowStyle.rightCenter
	                    },
	                    {
	                        at: 'right-end',
	                        cover: [coverRight, coverRightEndTop, 0],
	                        style: styles.rightEnd,
	                        arrow: arrowStyle.rightEnd
	                    },
	                    {
	                        at: 'bottom-start',
	                        cover: [coverBottom, coverBottomStartRight, 0],
	                        style: styles.bottomStart,
	                        arrow: arrowStyle.bottomStart
	                    },
	                    {
	                        at: 'bottom-center',
	                        cover: [coverBottom, coverXCenterLeft, coverXCenterRight],
	                        style: styles.bottomCenter,
	                        arrow: arrowStyle.bottomCenter
	                    },
	                    {
	                        at: 'bottom-end',
	                        cover: [coverBottom, coverBottomEndLeft, 0],
	                        style: styles.bottomEnd,
	                        arrow: arrowStyle.bottomEnd
	                    }, 
	                ];
	                var get;
	                if (placement === 'auto') {
	                    var reducer = function(accumulator, currentValue) {
	                        return accumulator + currentValue;
	                    };
	                    var compute = pos.map(function(param) {
	                        var ref5 = param ? param : _throw$1(new TypeError("Cannot destructure 'undefined' or 'null'")), cover = ref5.cover;
	                        return cover.reduce(reducer);
	                    });
	                    var findIndex = compute.indexOf((_Math = Math).max.apply(_Math, compute));
	                    var result = pos[findIndex];
	                    get = result;
	                } else {
	                    get = pos.filter(function(val) {
	                        return val.at === placement;
	                    })[0];
	                }
	                this.setState({
	                    position: get
	                });
	            }
	        }, {
	            key: 'componentWillUnmount',
	            value: function componentWillUnmount() {
	                var ref = this.props, ref1 = ref ? ref : _throw$1(new TypeError("Cannot destructure 'undefined' or 'null'")), onClose = ref1.onClose;
	                if (onClose) onClose();
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var ref5 = this.state, ref1 = ref5 ? ref5 : _throw$1(new TypeError("Cannot destructure 'undefined' or 'null'")), position = ref1.position;
	                var defaultStyle = {
	                    display: 'inline-block',
	                    position: 'absolute',
	                    left: 0,
	                    top: 0,
	                    zIndex: DEFAULT_ZINDEX + 10
	                };
	                var positionStyle = position ? position.style : {
	                };
	                var arrowStyle = position ? position.arrow : {
	                };
	                var ref2 = this.props, ref3 = ref2 ? ref2 : _throw$1(new TypeError("Cannot destructure 'undefined' or 'null'")), content = ref3.content, arrow = ref3.arrow, _ref$arrowProps = ref3.arrowProps, arrowProps = _ref$arrowProps === void 0 ? {
	                } : _ref$arrowProps;
	                var ref4 = arrowProps ? arrowProps : _throw$1(new TypeError("Cannot destructure 'undefined' or 'null'")), _ref$style = ref4.style, style = _ref$style === void 0 ? {
	                } : _ref$style, arrowRest = _objectWithoutProperties(arrowProps, [
	                    'style'
	                ]);
	                return React.createElement('div', {
	                    style: _objectSpread$1({
	                    }, defaultStyle, positionStyle),
	                    ref: this.contentRef
	                }, arrow ? React.createElement('div', _extends$1({
	                    ref: this.arrowRef,
	                    style: _objectSpread$1({
	                    }, _objectSpread$1({
	                        position: 'absolute',
	                        top: 0
	                    }, arrowStyle), style)
	                }, arrowRest), '◥') : null, content);
	            }
	        }]);
	    return Content;
	}(React.Component);

	function _extends$2() {
	    _extends$2 = Object.assign || function(target) {
	        for(var i = 1; i < arguments.length; i++){
	            var source = arguments[i];
	            for(var key in source){
	                if (Object.prototype.hasOwnProperty.call(source, key)) {
	                    target[key] = source[key];
	                }
	            }
	        }
	        return target;
	    };
	    return _extends$2.apply(this, arguments);
	}
	function _throw$2(e) {
	    throw e;
	}
	var Overlay = function(param) {
	    var ref = param ? param : _throw$2(new TypeError("Cannot destructure 'undefined' or 'null'")), onClose = ref.onClose, _ref$overlayColor = ref.overlayColor, overlayColor = _ref$overlayColor === void 0 ? 'rgba(0,0,0,0.5)' : _ref$overlayColor, zIndex = ref.zIndex, action = ref.action, setOpen = ref.setOpen, preventDefault = ref.preventDefault, stopPropagation = ref.stopPropagation;
	    var onClick = function(e) {
	        if (preventDefault) e.preventDefault();
	        if (stopPropagation) e.stopPropagation();
	        onClose();
	    };
	    var actions = action === 'click' ? {
	        onClick: onClick,
	        onTouchEnd: onClick
	    } : action === 'hover' ? {
	        onMouseEnter: setOpen
	    } : {
	    };
	    return React.createElement('div', _extends$2({
	        style: {
	            backgroundColor: overlayColor,
	            position: 'fixed',
	            width: '100%',
	            height: '100%',
	            top: 0,
	            left: 0,
	            cursor: 'pointer',
	            zIndex: zIndex
	        }
	    }, actions));
	};

	function _assertThisInitialized$1(self) {
	    if (self === void 0) {
	        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	    return self;
	}
	function _classCallCheck$1(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	function _defineProperties$1(target, props) {
	    for(var i = 0; i < props.length; i++){
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ('value' in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	    }
	}
	function _createClass$1(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties$1(Constructor, staticProps);
	    return Constructor;
	}
	function _defineProperty$2(obj, key, value) {
	    if (key in obj) {
	        Object.defineProperty(obj, key, {
	            value: value,
	            enumerable: true,
	            configurable: true,
	            writable: true
	        });
	    } else {
	        obj[key] = value;
	    }
	    return obj;
	}
	function _extends$3() {
	    _extends$3 = Object.assign || function(target) {
	        for(var i = 1; i < arguments.length; i++){
	            var source = arguments[i];
	            for(var key in source){
	                if (Object.prototype.hasOwnProperty.call(source, key)) {
	                    target[key] = source[key];
	                }
	            }
	        }
	        return target;
	    };
	    return _extends$3.apply(this, arguments);
	}
	function _getPrototypeOf$1(o) {
	    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	        return o.__proto__ || Object.getPrototypeOf(o);
	    };
	    return _getPrototypeOf$1(o);
	}
	function _inherits$1(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function');
	    }
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	        constructor: {
	            value: subClass,
	            writable: true,
	            configurable: true
	        }
	    });
	    if (superClass) _setPrototypeOf$1(subClass, superClass);
	}
	function _objectSpread$2(target) {
	    for(var i = 1; i < arguments.length; i++){
	        var source = arguments[i] != null ? arguments[i] : {
	        };
	        var ownKeys = Object.keys(source);
	        if (typeof Object.getOwnPropertySymbols === 'function') {
	            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
	                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	            }));
	        }
	        ownKeys.forEach(function(key) {
	            _defineProperty$2(target, key, source[key]);
	        });
	    }
	    return target;
	}
	function _objectWithoutProperties$1(source, excluded) {
	    if (source == null) return {
	    };
	    var target = _objectWithoutPropertiesLoose$1(source, excluded);
	    var key, i;
	    if (Object.getOwnPropertySymbols) {
	        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	        for(i = 0; i < sourceSymbolKeys.length; i++){
	            key = sourceSymbolKeys[i];
	            if (excluded.indexOf(key) >= 0) continue;
	            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	            target[key] = source[key];
	        }
	    }
	    return target;
	}
	function _objectWithoutPropertiesLoose$1(source, excluded) {
	    if (source == null) return {
	    };
	    var target = {
	    };
	    var sourceKeys = Object.keys(source);
	    var key, i;
	    for(i = 0; i < sourceKeys.length; i++){
	        key = sourceKeys[i];
	        if (excluded.indexOf(key) >= 0) continue;
	        target[key] = source[key];
	    }
	    return target;
	}
	function _possibleConstructorReturn$1(self, call) {
	    if (call && (_typeof$1(call) === 'object' || typeof call === 'function')) {
	        return call;
	    }
	    return _assertThisInitialized$1(self);
	}
	function _setPrototypeOf$1(o, p) {
	    _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	        o.__proto__ = p;
	        return o;
	    };
	    return _setPrototypeOf$1(o, p);
	}
	function _throw$3(e) {
	    throw e;
	}
	var _typeof$1 = function(obj) {
	    return obj && obj.constructor === Symbol ? 'symbol' : typeof obj;
	};
	var Popover = function(_Component) {
	    _inherits$1(Popover, _Component);
	    function Popover() {
	        var _this;
	        _classCallCheck$1(this, Popover);
	        _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(Popover).apply(this, arguments));
	        _defineProperty$2(_assertThisInitialized$1(_this), 'state', {
	            open: _this.props.open || false
	        });
	        _defineProperty$2(_assertThisInitialized$1(_this), 'target', React.createRef());
	        _defineProperty$2(_assertThisInitialized$1(_this), 'setOpen', function() {
	            _this.setState({
	                open: !_this.state.open
	            });
	        });
	        return _this;
	    }
	    _createClass$1(Popover, [{
	            key: 'componentDidUpdate',
	            value: function componentDidUpdate(prevProps) {
	                if (prevProps.open !== this.props.open) {
	                    this.setState({
	                        open: this.props.open
	                    });
	                }
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var ref = this, ref1 = ref ? ref : _throw$3(new TypeError("Cannot destructure 'undefined' or 'null'")), props = ref1.props;
	                var ref2 = props ? props : _throw$3(new TypeError("Cannot destructure 'undefined' or 'null'")), _ref$placement = ref2.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$arrow = ref2.arrow, arrow = _ref$arrow === void 0 ? true : _ref$arrow, _ref$action = ref2.action, action = _ref$action === void 0 ? 'click' : _ref$action, _ref$zIndex = ref2.zIndex, zIndex = _ref$zIndex === void 0 ? DEFAULT_ZINDEX : _ref$zIndex, preventDefault = ref2.preventDefault, stopPropagation = ref2.stopPropagation, onOpen = ref2.onOpen, onClose = ref2.onClose, children = ref2.children, style = ref2.style, overlayColor = ref2.overlayColor, arrowProps = ref2.arrowProps, rest = _objectWithoutProperties$1(props, [
	                    'placement',
	                    'arrow',
	                    'action',
	                    'zIndex',
	                    'preventDefault',
	                    'stopPropagation',
	                    'onOpen',
	                    'onClose',
	                    'children',
	                    'style',
	                    'overlayColor',
	                    'arrowProps'
	                ]);
	                var target = children[0], content = children[1];
	                return React.createElement('div', _extends$3({
	                    style: _objectSpread$2({
	                    }, {
	                        position: 'relative'
	                    }, style)
	                }, rest), React.createElement(Target, {
	                    preventDefault: preventDefault,
	                    stopPropagation: stopPropagation,
	                    targetRef: this.target,
	                    open: this.state.open,
	                    zIndex: zIndex,
	                    action: action,
	                    setOpen: this.setOpen
	                }, target), this.state.open && React.createElement(React.Fragment, null, React.createElement(Content, {
	                    arrowProps: arrowProps,
	                    zIndex: zIndex,
	                    arrow: arrow,
	                    placement: placement,
	                    targetRef: this.target,
	                    content: content,
	                    onClose: onClose,
	                    onOpen: onOpen
	                }), React.createElement(Overlay, {
	                    preventDefault: preventDefault,
	                    stopPropagation: stopPropagation,
	                    overlayColor: overlayColor,
	                    onClose: this.setOpen,
	                    zIndex: zIndex,
	                    action: action,
	                    setOpen: this.setOpen
	                })));
	            }
	        }]);
	    return Popover;
	}(React.Component);

	return Popover;

}));


/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHAT_ACTIVITY_LOAD; });
var CHAT_ACTIVITY_LOAD='CHAT_ACTIVITY_LOAD';

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOADER_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOADER_END; });
/* harmony export (immutable) */ __webpack_exports__["d"] = loaderStart;
/* harmony export (immutable) */ __webpack_exports__["c"] = loaderEnd;
var LOADER_START='LOADER_START';var LOADER_END='LOADER_END';function loaderStart(){return{type:LOADER_START};}function loaderEnd(){return{type:LOADER_END};}

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module route/nodes */


/**
 * Create a node for use with the parser, giving it a constructor that takes
 * props, children, and returns an object with props, children, and a
 * displayName.
 * @param  {String} displayName The display name for the node
 * @return {{displayName: string, props: Object, children: Array}}
 */
function createNode(displayName) {
  return function(props, children) {
    return {
      displayName: displayName,
      props: props,
      children: children || []
    };
  };
}

module.exports = {
  Root: createNode('Root'),
  Concat: createNode('Concat'),
  Literal: createNode('Literal'),
  Splat: createNode('Splat'),
  Param: createNode('Param'),
  Optional: createNode('Optional')
};


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module route/visitors/create_visitor
 */

var nodeTypes = Object.keys(__webpack_require__(1104));

/**
 * Helper for creating visitors. Take an object of node name to handler
 * mappings, returns an object with a "visit" method that can be called
 * @param  {Object.<string,function(node,context)>} handlers A mapping of node
 * type to visitor functions
 * @return {{visit: function(node,context)}}  A visitor object with a "visit"
 * method that can be called on a node with a context
 */
function createVisitor(handlers) {
  nodeTypes.forEach(function(nodeType) {
    if( typeof handlers[nodeType] === 'undefined') {
      throw new Error('No handler defined for ' + nodeType.displayName);
    }

  });

  return {
    /**
     * Call the given handler for this node type
     * @param  {Object} node    the AST node
     * @param  {Object} context context to pass through to handlers
     * @return {Object}
     */
    visit: function(node, context) {
      return this.handlers[node.displayName].call(this,node, context);
    },
    handlers: handlers
  };
}

module.exports = createVisitor;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1107);
module.exports = __webpack_require__(1112);


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(1108).enable();
  window.Promise = __webpack_require__(1110);
}

// fetch() polyfill for making API calls.
__webpack_require__(1111);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(134);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(654);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(97)))

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(654);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 1111 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_map__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_set__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__polyfill__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__serviceWorker__ = __webpack_require__(3110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_thunk__ = __webpack_require__(3111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reducers_reducers__ = __webpack_require__(3112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_history_createBrowserHistory__ = __webpack_require__(3287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_api_api_configuration__ = __webpack_require__(3291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_authentication_storage__ = __webpack_require__(754);
// Import bootstrap styles first to avoid conflict with our styles
var history=__WEBPACK_IMPORTED_MODULE_12_history_createBrowserHistory___default()();// Build the middleware for intercepting and dispatching navigation actions
var middleware=Object(__WEBPACK_IMPORTED_MODULE_13_react_router_redux__["e" /* routerMiddleware */])(history);var reducers=Object(__WEBPACK_IMPORTED_MODULE_11__reducers_reducers__["a" /* getReducers */])();var initialState={};// Check user information in the local storage
var credentials=__WEBPACK_IMPORTED_MODULE_15__services_authentication_storage__["a" /* default */].getCredentials();var accounts=__WEBPACK_IMPORTED_MODULE_15__services_authentication_storage__["a" /* default */].getAccounts();if(credentials!==null){initialState['auth']=credentials;initialState['auth'].errors=[];initialState['auth'].loggedIn=true;initialState['auth'].accounts=accounts;}// To debug redux store in Chrome DevTools
var composeEnhancers=window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||__WEBPACK_IMPORTED_MODULE_8_redux__["d" /* compose */];var store=Object(__WEBPACK_IMPORTED_MODULE_8_redux__["e" /* createStore */])(Object(__WEBPACK_IMPORTED_MODULE_8_redux__["c" /* combineReducers */])(Object.assign({},reducers,{router:__WEBPACK_IMPORTED_MODULE_13_react_router_redux__["f" /* routerReducer */]})),initialState,composeEnhancers(Object(__WEBPACK_IMPORTED_MODULE_8_redux__["a" /* applyMiddleware */])(middleware,__WEBPACK_IMPORTED_MODULE_9_redux_thunk__["a" /* default */])));// Configure API layer
Object(__WEBPACK_IMPORTED_MODULE_14__services_api_api_configuration__["a" /* configureApi */])(store.dispatch,store.getState);__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_router_redux__["a" /* ConnectedRouter */],{history:history},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */],null))),document.getElementById('root'));// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/2vJdu84
__WEBPACK_IMPORTED_MODULE_7__serviceWorker__["a" /* unregister */]();

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(445);
__webpack_require__(447);
__webpack_require__(453);
__webpack_require__(455);
module.exports = __webpack_require__(108).Map;


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(289)('native-function-to-string', Function.toString);


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(445);
__webpack_require__(447);
__webpack_require__(453);
__webpack_require__(460);
module.exports = __webpack_require__(108).Set;


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l=__webpack_require__(134),n=60103,p=60106;exports.Fragment=60107;exports.StrictMode=60108;exports.Profiler=60114;var q=60109,r=60110,t=60112;exports.Suspense=60113;var u=60115,v=60116;
if("function"===typeof Symbol&&Symbol.for){var w=Symbol.for;n=w("react.element");p=w("react.portal");exports.Fragment=w("react.fragment");exports.StrictMode=w("react.strict_mode");exports.Profiler=w("react.profiler");q=w("react.provider");r=w("react.context");t=w("react.forward_ref");exports.Suspense=w("react.suspense");u=w("react.memo");v=w("react.lazy")}var x="function"===typeof Symbol&&Symbol.iterator;
function y(a){if(null===a||"object"!==typeof a)return null;a=x&&a[x]||a["@@iterator"];return"function"===typeof a?a:null}function z(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var A={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},B={};function C(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A}C.prototype.isReactComponent={};C.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(z(85));this.updater.enqueueSetState(this,a,b,"setState")};C.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function D(){}D.prototype=C.prototype;function E(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A}var F=E.prototype=new D;F.constructor=E;l(F,C.prototype);F.isPureReactComponent=!0;var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,c){var e,d={},k=null,h=null;if(null!=b)for(e in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(k=""+b.key),b)H.call(b,e)&&!I.hasOwnProperty(e)&&(d[e]=b[e]);var g=arguments.length-2;if(1===g)d.children=c;else if(1<g){for(var f=Array(g),m=0;m<g;m++)f[m]=arguments[m+2];d.children=f}if(a&&a.defaultProps)for(e in g=a.defaultProps,g)void 0===d[e]&&(d[e]=g[e]);return{$$typeof:n,type:a,key:k,ref:h,props:d,_owner:G.current}}
function K(a,b){return{$$typeof:n,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function L(a){return"object"===typeof a&&null!==a&&a.$$typeof===n}function escape(a){var b={"=":"=0",":":"=2"};return"$"+a.replace(/[=:]/g,function(a){return b[a]})}var M=/\/+/g;function N(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(""+a.key):b.toString(36)}
function O(a,b,c,e,d){var k=typeof a;if("undefined"===k||"boolean"===k)a=null;var h=!1;if(null===a)h=!0;else switch(k){case "string":case "number":h=!0;break;case "object":switch(a.$$typeof){case n:case p:h=!0}}if(h)return h=a,d=d(h),a=""===e?"."+N(h,0):e,Array.isArray(d)?(c="",null!=a&&(c=a.replace(M,"$&/")+"/"),O(d,b,c,"",function(a){return a})):null!=d&&(L(d)&&(d=K(d,c+(!d.key||h&&h.key===d.key?"":(""+d.key).replace(M,"$&/")+"/")+a)),b.push(d)),1;h=0;e=""===e?".":e+":";if(Array.isArray(a))for(var g=
0;g<a.length;g++){k=a[g];var f=e+N(k,g);h+=O(k,b,c,f,d)}else if(f=y(a),"function"===typeof f)for(a=f.call(a),g=0;!(k=a.next()).done;)k=k.value,f=e+N(k,g++),h+=O(k,b,c,f,d);else if("object"===k)throw b=""+a,Error(z(31,"[object Object]"===b?"object with keys {"+Object.keys(a).join(", ")+"}":b));return h}function P(a,b,c){if(null==a)return a;var e=[],d=0;O(a,e,"","",function(a){return b.call(c,a,d++)});return e}
function Q(a){if(-1===a._status){var b=a._result;b=b();a._status=0;a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}if(1===a._status)return a._result;throw a._result;}var R={current:null};function S(){var a=R.current;if(null===a)throw Error(z(321));return a}var T={ReactCurrentDispatcher:R,ReactCurrentBatchConfig:{transition:0},ReactCurrentOwner:G,IsSomeRendererActing:{current:!1},assign:l};
exports.Children={map:P,forEach:function(a,b,c){P(a,function(){b.apply(this,arguments)},c)},count:function(a){var b=0;P(a,function(){b++});return b},toArray:function(a){return P(a,function(a){return a})||[]},only:function(a){if(!L(a))throw Error(z(143));return a}};exports.Component=C;exports.PureComponent=E;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=T;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(z(267,a));var e=l({},a.props),d=a.key,k=a.ref,h=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,h=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var g=a.type.defaultProps;for(f in b)H.call(b,f)&&!I.hasOwnProperty(f)&&(e[f]=void 0===b[f]&&void 0!==g?g[f]:b[f])}var f=arguments.length-2;if(1===f)e.children=c;else if(1<f){g=Array(f);for(var m=0;m<f;m++)g[m]=arguments[m+2];e.children=g}return{$$typeof:n,type:a.type,
key:d,ref:k,props:e,_owner:h}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:r,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:q,_context:a};return a.Consumer=a};exports.createElement=J;exports.createFactory=function(a){var b=J.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:t,render:a}};exports.isValidElement=L;
exports.lazy=function(a){return{$$typeof:v,_payload:{_status:-1,_result:a},_init:Q}};exports.memo=function(a,b){return{$$typeof:u,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return S().useCallback(a,b)};exports.useContext=function(a,b){return S().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return S().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return S().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return S().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return S().useMemo(a,b)};exports.useReducer=function(a,b,c){return S().useReducer(a,b,c)};exports.useRef=function(a){return S().useRef(a)};exports.useState=function(a){return S().useState(a)};exports.version="17.0.2";


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),m=__webpack_require__(134),r=__webpack_require__(1118);function y(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(y(227));var ba=new Set,ca={};function da(a,b){ea(a,b);ea(a+"Capture",b)}
function ea(a,b){ca[a]=b;for(a=0;a<b.length;a++)ba.add(b[a])}
var fa=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),ha=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ia=Object.prototype.hasOwnProperty,
ja={},ka={};function la(a){if(ia.call(ka,a))return!0;if(ia.call(ja,a))return!1;if(ha.test(a))return ka[a]=!0;ja[a]=!0;return!1}function ma(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function na(a,b,c,d){if(null===b||"undefined"===typeof b||ma(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f;this.removeEmptyString=g}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1,!1)});var oa=/[\-:]([a-z])/g;function pa(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(oa,
pa);D[b]=new B(b,1,!1,a,null,!1,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(oa,pa);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(oa,pa);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0,!0)});
function qa(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(na(b,c,e,d)&&(c=null),d||null===e?la(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var ra=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,sa=60103,ta=60106,ua=60107,wa=60108,xa=60114,ya=60109,za=60110,Aa=60112,Ba=60113,Ca=60120,Da=60115,Ea=60116,Fa=60121,Ga=60128,Ha=60129,Ia=60130,Ja=60131;
if("function"===typeof Symbol&&Symbol.for){var E=Symbol.for;sa=E("react.element");ta=E("react.portal");ua=E("react.fragment");wa=E("react.strict_mode");xa=E("react.profiler");ya=E("react.provider");za=E("react.context");Aa=E("react.forward_ref");Ba=E("react.suspense");Ca=E("react.suspense_list");Da=E("react.memo");Ea=E("react.lazy");Fa=E("react.block");E("react.scope");Ga=E("react.opaque.id");Ha=E("react.debug_trace_mode");Ia=E("react.offscreen");Ja=E("react.legacy_hidden")}
var Ka="function"===typeof Symbol&&Symbol.iterator;function La(a){if(null===a||"object"!==typeof a)return null;a=Ka&&a[Ka]||a["@@iterator"];return"function"===typeof a?a:null}var Ma;function Na(a){if(void 0===Ma)try{throw Error();}catch(c){var b=c.stack.trim().match(/\n( *(at )?)/);Ma=b&&b[1]||""}return"\n"+Ma+a}var Oa=!1;
function Pa(a,b){if(!a||Oa)return"";Oa=!0;var c=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(b)if(b=function(){throw Error();},Object.defineProperty(b.prototype,"props",{set:function(){throw Error();}}),"object"===typeof Reflect&&Reflect.construct){try{Reflect.construct(b,[])}catch(k){var d=k}Reflect.construct(a,[],b)}else{try{b.call()}catch(k){d=k}a.call(b.prototype)}else{try{throw Error();}catch(k){d=k}a()}}catch(k){if(k&&d&&"string"===typeof k.stack){for(var e=k.stack.split("\n"),
f=d.stack.split("\n"),g=e.length-1,h=f.length-1;1<=g&&0<=h&&e[g]!==f[h];)h--;for(;1<=g&&0<=h;g--,h--)if(e[g]!==f[h]){if(1!==g||1!==h){do if(g--,h--,0>h||e[g]!==f[h])return"\n"+e[g].replace(" at new "," at ");while(1<=g&&0<=h)}break}}}finally{Oa=!1,Error.prepareStackTrace=c}return(a=a?a.displayName||a.name:"")?Na(a):""}
function Qa(a){switch(a.tag){case 5:return Na(a.type);case 16:return Na("Lazy");case 13:return Na("Suspense");case 19:return Na("SuspenseList");case 0:case 2:case 15:return a=Pa(a.type,!1),a;case 11:return a=Pa(a.type.render,!1),a;case 22:return a=Pa(a.type._render,!1),a;case 1:return a=Pa(a.type,!0),a;default:return""}}
function Ra(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ua:return"Fragment";case ta:return"Portal";case xa:return"Profiler";case wa:return"StrictMode";case Ba:return"Suspense";case Ca:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case za:return(a.displayName||"Context")+".Consumer";case ya:return(a._context.displayName||"Context")+".Provider";case Aa:var b=a.render;b=b.displayName||b.name||"";
return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");case Da:return Ra(a.type);case Fa:return Ra(a._render);case Ea:b=a._payload;a=a._init;try{return Ra(a(b))}catch(c){}}return null}function Sa(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Ta(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ua(a){var b=Ta(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Va(a){a._valueTracker||(a._valueTracker=Ua(a))}function Wa(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Ta(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Xa(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}
function Ya(a,b){var c=b.checked;return m({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Za(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Sa(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function $a(a,b){b=b.checked;null!=b&&qa(a,"checked",b,!1)}
function ab(a,b){$a(a,b);var c=Sa(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?bb(a,b.type,c):b.hasOwnProperty("defaultValue")&&bb(a,b.type,Sa(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function cb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function bb(a,b,c){if("number"!==b||Xa(a.ownerDocument)!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function db(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function eb(a,b){a=m({children:void 0},b);if(b=db(b.children))a.children=b;return a}
function fb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Sa(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function gb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(y(91));return m({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function hb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(y(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(y(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:Sa(c)}}
function ib(a,b){var c=Sa(b.value),d=Sa(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function jb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var kb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function lb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function mb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?lb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var nb,ob=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==kb.svg||"innerHTML"in a)a.innerHTML=b;else{nb=nb||document.createElement("div");nb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=nb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function pb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var qb={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},rb=["Webkit","ms","Moz","O"];Object.keys(qb).forEach(function(a){rb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);qb[b]=qb[a]})});function sb(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||qb.hasOwnProperty(a)&&qb[a]?(""+b).trim():b+"px"}
function tb(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=sb(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var ub=m({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function vb(a,b){if(b){if(ub[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(y(137,a));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(y(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(y(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(y(62));}}
function wb(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function xb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var yb=null,zb=null,Ab=null;
function Bb(a){if(a=Cb(a)){if("function"!==typeof yb)throw Error(y(280));var b=a.stateNode;b&&(b=Db(b),yb(a.stateNode,a.type,b))}}function Eb(a){zb?Ab?Ab.push(a):Ab=[a]:zb=a}function Fb(){if(zb){var a=zb,b=Ab;Ab=zb=null;Bb(a);if(b)for(a=0;a<b.length;a++)Bb(b[a])}}function Gb(a,b){return a(b)}function Hb(a,b,c,d,e){return a(b,c,d,e)}function Ib(){}var Jb=Gb,Kb=!1,Lb=!1;function Mb(){if(null!==zb||null!==Ab)Ib(),Fb()}
function Nb(a,b,c){if(Lb)return a(b,c);Lb=!0;try{return Jb(a,b,c)}finally{Lb=!1,Mb()}}
function Ob(a,b){var c=a.stateNode;if(null===c)return null;var d=Db(c);if(null===d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==
typeof c)throw Error(y(231,b,typeof c));return c}var Pb=!1;if(fa)try{var Qb={};Object.defineProperty(Qb,"passive",{get:function(){Pb=!0}});window.addEventListener("test",Qb,Qb);window.removeEventListener("test",Qb,Qb)}catch(a){Pb=!1}function Rb(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(n){this.onError(n)}}var Sb=!1,Tb=null,Ub=!1,Vb=null,Wb={onError:function(a){Sb=!0;Tb=a}};function Xb(a,b,c,d,e,f,g,h,k){Sb=!1;Tb=null;Rb.apply(Wb,arguments)}
function Yb(a,b,c,d,e,f,g,h,k){Xb.apply(this,arguments);if(Sb){if(Sb){var l=Tb;Sb=!1;Tb=null}else throw Error(y(198));Ub||(Ub=!0,Vb=l)}}function Zb(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.flags&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function $b(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function ac(a){if(Zb(a)!==a)throw Error(y(188));}
function bc(a){var b=a.alternate;if(!b){b=Zb(a);if(null===b)throw Error(y(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return ac(e),a;if(f===d)return ac(e),b;f=f.sibling}throw Error(y(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(y(189));}}if(c.alternate!==d)throw Error(y(190));}if(3!==c.tag)throw Error(y(188));return c.stateNode.current===c?a:b}function cc(a){a=bc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function dc(a,b){for(var c=a.alternate;null!==b;){if(b===a||b===c)return!0;b=b.return}return!1}var ec,fc,gc,hc,ic=!1,jc=[],kc=null,lc=null,mc=null,nc=new Map,oc=new Map,pc=[],qc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a,b,c,d,e){return{blockedOn:a,domEventName:b,eventSystemFlags:c|16,nativeEvent:e,targetContainers:[d]}}function sc(a,b){switch(a){case "focusin":case "focusout":kc=null;break;case "dragenter":case "dragleave":lc=null;break;case "mouseover":case "mouseout":mc=null;break;case "pointerover":case "pointerout":nc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":oc.delete(b.pointerId)}}
function tc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=rc(b,c,d,e,f),null!==b&&(b=Cb(b),null!==b&&fc(b)),a;a.eventSystemFlags|=d;b=a.targetContainers;null!==e&&-1===b.indexOf(e)&&b.push(e);return a}
function uc(a,b,c,d,e){switch(b){case "focusin":return kc=tc(kc,a,b,c,d,e),!0;case "dragenter":return lc=tc(lc,a,b,c,d,e),!0;case "mouseover":return mc=tc(mc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;nc.set(f,tc(nc.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,oc.set(f,tc(oc.get(f)||null,a,b,c,d,e)),!0}return!1}
function vc(a){var b=wc(a.target);if(null!==b){var c=Zb(b);if(null!==c)if(b=c.tag,13===b){if(b=$b(c),null!==b){a.blockedOn=b;hc(a.lanePriority,function(){r.unstable_runWithPriority(a.priority,function(){gc(c)})});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}
function xc(a){if(null!==a.blockedOn)return!1;for(var b=a.targetContainers;0<b.length;){var c=yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c)return b=Cb(c),null!==b&&fc(b),a.blockedOn=c,!1;b.shift()}return!0}function zc(a,b,c){xc(a)&&c.delete(b)}
function Ac(){for(ic=!1;0<jc.length;){var a=jc[0];if(null!==a.blockedOn){a=Cb(a.blockedOn);null!==a&&ec(a);break}for(var b=a.targetContainers;0<b.length;){var c=yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c){a.blockedOn=c;break}b.shift()}null===a.blockedOn&&jc.shift()}null!==kc&&xc(kc)&&(kc=null);null!==lc&&xc(lc)&&(lc=null);null!==mc&&xc(mc)&&(mc=null);nc.forEach(zc);oc.forEach(zc)}
function Bc(a,b){a.blockedOn===b&&(a.blockedOn=null,ic||(ic=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Ac)))}
function Cc(a){function b(b){return Bc(b,a)}if(0<jc.length){Bc(jc[0],a);for(var c=1;c<jc.length;c++){var d=jc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==kc&&Bc(kc,a);null!==lc&&Bc(lc,a);null!==mc&&Bc(mc,a);nc.forEach(b);oc.forEach(b);for(c=0;c<pc.length;c++)d=pc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<pc.length&&(c=pc[0],null===c.blockedOn);)vc(c),null===c.blockedOn&&pc.shift()}
function Dc(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ec={animationend:Dc("Animation","AnimationEnd"),animationiteration:Dc("Animation","AnimationIteration"),animationstart:Dc("Animation","AnimationStart"),transitionend:Dc("Transition","TransitionEnd")},Fc={},Gc={};
fa&&(Gc=document.createElement("div").style,"AnimationEvent"in window||(delete Ec.animationend.animation,delete Ec.animationiteration.animation,delete Ec.animationstart.animation),"TransitionEvent"in window||delete Ec.transitionend.transition);function Hc(a){if(Fc[a])return Fc[a];if(!Ec[a])return a;var b=Ec[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Gc)return Fc[a]=b[c];return a}
var Ic=Hc("animationend"),Jc=Hc("animationiteration"),Kc=Hc("animationstart"),Lc=Hc("transitionend"),Mc=new Map,Nc=new Map,Oc=["abort","abort",Ic,"animationEnd",Jc,"animationIteration",Kc,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart",
"lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking","seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",Lc,"transitionEnd","waiting","waiting"];function Pc(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1];e="on"+(e[0].toUpperCase()+e.slice(1));Nc.set(d,b);Mc.set(d,e);da(e,[d])}}var Qc=r.unstable_now;Qc();var F=8;
function Rc(a){if(0!==(1&a))return F=15,1;if(0!==(2&a))return F=14,2;if(0!==(4&a))return F=13,4;var b=24&a;if(0!==b)return F=12,b;if(0!==(a&32))return F=11,32;b=192&a;if(0!==b)return F=10,b;if(0!==(a&256))return F=9,256;b=3584&a;if(0!==b)return F=8,b;if(0!==(a&4096))return F=7,4096;b=4186112&a;if(0!==b)return F=6,b;b=62914560&a;if(0!==b)return F=5,b;if(a&67108864)return F=4,67108864;if(0!==(a&134217728))return F=3,134217728;b=805306368&a;if(0!==b)return F=2,b;if(0!==(1073741824&a))return F=1,1073741824;
F=8;return a}function Sc(a){switch(a){case 99:return 15;case 98:return 10;case 97:case 96:return 8;case 95:return 2;default:return 0}}function Tc(a){switch(a){case 15:case 14:return 99;case 13:case 12:case 11:case 10:return 98;case 9:case 8:case 7:case 6:case 4:case 5:return 97;case 3:case 2:case 1:return 95;case 0:return 90;default:throw Error(y(358,a));}}
function Uc(a,b){var c=a.pendingLanes;if(0===c)return F=0;var d=0,e=0,f=a.expiredLanes,g=a.suspendedLanes,h=a.pingedLanes;if(0!==f)d=f,e=F=15;else if(f=c&134217727,0!==f){var k=f&~g;0!==k?(d=Rc(k),e=F):(h&=f,0!==h&&(d=Rc(h),e=F))}else f=c&~g,0!==f?(d=Rc(f),e=F):0!==h&&(d=Rc(h),e=F);if(0===d)return 0;d=31-Vc(d);d=c&((0>d?0:1<<d)<<1)-1;if(0!==b&&b!==d&&0===(b&g)){Rc(b);if(e<=F)return b;F=e}b=a.entangledLanes;if(0!==b)for(a=a.entanglements,b&=d;0<b;)c=31-Vc(b),e=1<<c,d|=a[c],b&=~e;return d}
function Wc(a){a=a.pendingLanes&-1073741825;return 0!==a?a:a&1073741824?1073741824:0}function Xc(a,b){switch(a){case 15:return 1;case 14:return 2;case 12:return a=Yc(24&~b),0===a?Xc(10,b):a;case 10:return a=Yc(192&~b),0===a?Xc(8,b):a;case 8:return a=Yc(3584&~b),0===a&&(a=Yc(4186112&~b),0===a&&(a=512)),a;case 2:return b=Yc(805306368&~b),0===b&&(b=268435456),b}throw Error(y(358,a));}function Yc(a){return a&-a}function Zc(a){for(var b=[],c=0;31>c;c++)b.push(a);return b}
function $c(a,b,c){a.pendingLanes|=b;var d=b-1;a.suspendedLanes&=d;a.pingedLanes&=d;a=a.eventTimes;b=31-Vc(b);a[b]=c}var Vc=Math.clz32?Math.clz32:ad,bd=Math.log,cd=Math.LN2;function ad(a){return 0===a?32:31-(bd(a)/cd|0)|0}var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function gd(a,b,c,d){Kb||Ib();var e=hd,f=Kb;Kb=!0;try{Hb(e,a,b,c,d)}finally{(Kb=f)||Mb()}}function id(a,b,c,d){ed(dd,hd.bind(null,a,b,c,d))}
function hd(a,b,c,d){if(fd){var e;if((e=0===(b&4))&&0<jc.length&&-1<qc.indexOf(a))a=rc(null,a,b,c,d),jc.push(a);else{var f=yc(a,b,c,d);if(null===f)e&&sc(a,d);else{if(e){if(-1<qc.indexOf(a)){a=rc(f,a,b,c,d);jc.push(a);return}if(uc(f,a,b,c,d))return;sc(a,d)}jd(a,b,d,null,c)}}}}
function yc(a,b,c,d){var e=xb(d);e=wc(e);if(null!==e){var f=Zb(e);if(null===f)e=null;else{var g=f.tag;if(13===g){e=$b(f);if(null!==e)return e;e=null}else if(3===g){if(f.stateNode.hydrate)return 3===f.tag?f.stateNode.containerInfo:null;e=null}else f!==e&&(e=null)}}jd(a,b,d,e,c);return null}var kd=null,ld=null,md=null;
function nd(){if(md)return md;var a,b=ld,c=b.length,d,e="value"in kd?kd.value:kd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return md=e.slice(a,1<d?1-d:void 0)}function od(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}function pd(){return!0}function qd(){return!1}
function rd(a){function b(b,d,e,f,g){this._reactName=b;this._targetInst=e;this.type=d;this.nativeEvent=f;this.target=g;this.currentTarget=null;for(var c in a)a.hasOwnProperty(c)&&(b=a[c],this[c]=b?b(f):f[c]);this.isDefaultPrevented=(null!=f.defaultPrevented?f.defaultPrevented:!1===f.returnValue)?pd:qd;this.isPropagationStopped=qd;return this}m(b.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&
(a.returnValue=!1),this.isDefaultPrevented=pd)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=pd)},persist:function(){},isPersistent:pd});return b}
var sd={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},td=rd(sd),ud=m({},sd,{view:0,detail:0}),vd=rd(ud),wd,xd,yd,Ad=m({},ud,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:zd,button:0,buttons:0,relatedTarget:function(a){return void 0===a.relatedTarget?a.fromElement===a.srcElement?a.toElement:a.fromElement:a.relatedTarget},movementX:function(a){if("movementX"in
a)return a.movementX;a!==yd&&(yd&&"mousemove"===a.type?(wd=a.screenX-yd.screenX,xd=a.screenY-yd.screenY):xd=wd=0,yd=a);return wd},movementY:function(a){return"movementY"in a?a.movementY:xd}}),Bd=rd(Ad),Cd=m({},Ad,{dataTransfer:0}),Dd=rd(Cd),Ed=m({},ud,{relatedTarget:0}),Fd=rd(Ed),Gd=m({},sd,{animationName:0,elapsedTime:0,pseudoElement:0}),Hd=rd(Gd),Id=m({},sd,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Jd=rd(Id),Kd=m({},sd,{data:0}),Ld=rd(Kd),Md={Esc:"Escape",
Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",
119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Od={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Od[a])?!!b[a]:!1}function zd(){return Pd}
var Qd=m({},ud,{key:function(a){if(a.key){var b=Md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=od(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Nd[a.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:zd,charCode:function(a){return"keypress"===a.type?od(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?od(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Rd=rd(Qd),Sd=m({},Ad,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0}),Td=rd(Sd),Ud=m({},ud,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:zd}),Vd=rd(Ud),Wd=m({},sd,{propertyName:0,elapsedTime:0,pseudoElement:0}),Xd=rd(Wd),Yd=m({},Ad,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},
deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:0,deltaMode:0}),Zd=rd(Yd),$d=[9,13,27,32],ae=fa&&"CompositionEvent"in window,be=null;fa&&"documentMode"in document&&(be=document.documentMode);var ce=fa&&"TextEvent"in window&&!be,de=fa&&(!ae||be&&8<be&&11>=be),ee=String.fromCharCode(32),fe=!1;
function ge(a,b){switch(a){case "keyup":return-1!==$d.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "focusout":return!0;default:return!1}}function he(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var ie=!1;function je(a,b){switch(a){case "compositionend":return he(b);case "keypress":if(32!==b.which)return null;fe=!0;return ee;case "textInput":return a=b.data,a===ee&&fe?null:a;default:return null}}
function ke(a,b){if(ie)return"compositionend"===a||!ae&&ge(a,b)?(a=nd(),md=ld=kd=null,ie=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return de&&"ko"!==b.locale?null:b.data;default:return null}}
var le={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function me(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!le[a.type]:"textarea"===b?!0:!1}function ne(a,b,c,d){Eb(d);b=oe(b,"onChange");0<b.length&&(c=new td("onChange","change",null,c,d),a.push({event:c,listeners:b}))}var pe=null,qe=null;function re(a){se(a,0)}function te(a){var b=ue(a);if(Wa(b))return a}
function ve(a,b){if("change"===a)return b}var we=!1;if(fa){var xe;if(fa){var ye="oninput"in document;if(!ye){var ze=document.createElement("div");ze.setAttribute("oninput","return;");ye="function"===typeof ze.oninput}xe=ye}else xe=!1;we=xe&&(!document.documentMode||9<document.documentMode)}function Ae(){pe&&(pe.detachEvent("onpropertychange",Be),qe=pe=null)}function Be(a){if("value"===a.propertyName&&te(qe)){var b=[];ne(b,qe,a,xb(a));a=re;if(Kb)a(b);else{Kb=!0;try{Gb(a,b)}finally{Kb=!1,Mb()}}}}
function Ce(a,b,c){"focusin"===a?(Ae(),pe=b,qe=c,pe.attachEvent("onpropertychange",Be)):"focusout"===a&&Ae()}function De(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return te(qe)}function Ee(a,b){if("click"===a)return te(b)}function Fe(a,b){if("input"===a||"change"===a)return te(b)}function Ge(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var He="function"===typeof Object.is?Object.is:Ge,Ie=Object.prototype.hasOwnProperty;
function Je(a,b){if(He(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!Ie.call(b,c[d])||!He(a[c[d]],b[c[d]]))return!1;return!0}function Ke(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Le(a,b){var c=Ke(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Ke(c)}}function Me(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Me(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Ne(){for(var a=window,b=Xa();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Xa(a.document)}return b}function Oe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Pe=fa&&"documentMode"in document&&11>=document.documentMode,Qe=null,Re=null,Se=null,Te=!1;
function Ue(a,b,c){var d=c.window===c?c.document:9===c.nodeType?c:c.ownerDocument;Te||null==Qe||Qe!==Xa(d)||(d=Qe,"selectionStart"in d&&Oe(d)?d={start:d.selectionStart,end:d.selectionEnd}:(d=(d.ownerDocument&&d.ownerDocument.defaultView||window).getSelection(),d={anchorNode:d.anchorNode,anchorOffset:d.anchorOffset,focusNode:d.focusNode,focusOffset:d.focusOffset}),Se&&Je(Se,d)||(Se=d,d=oe(Re,"onSelect"),0<d.length&&(b=new td("onSelect","select",null,b,c),a.push({event:b,listeners:d}),b.target=Qe)))}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),
0);Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);Pc(Oc,2);for(var Ve="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),We=0;We<Ve.length;We++)Nc.set(Ve[We],0);ea("onMouseEnter",["mouseout","mouseover"]);
ea("onMouseLeave",["mouseout","mouseover"]);ea("onPointerEnter",["pointerout","pointerover"]);ea("onPointerLeave",["pointerout","pointerover"]);da("onChange","change click focusin focusout input keydown keyup selectionchange".split(" "));da("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));da("onBeforeInput",["compositionend","keypress","textInput","paste"]);da("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" "));da("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var Xe="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),Ye=new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a,b,c){var d=a.type||"unknown-event";a.currentTarget=c;Yb(d,b,void 0,a);a.currentTarget=null}
function se(a,b){b=0!==(b&4);for(var c=0;c<a.length;c++){var d=a[c],e=d.event;d=d.listeners;a:{var f=void 0;if(b)for(var g=d.length-1;0<=g;g--){var h=d[g],k=h.instance,l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;Ze(e,h,l);f=k}else for(g=0;g<d.length;g++){h=d[g];k=h.instance;l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;Ze(e,h,l);f=k}}}if(Ub)throw a=Vb,Ub=!1,Vb=null,a;}
function G(a,b){var c=$e(b),d=a+"__bubble";c.has(d)||(af(b,a,2,!1),c.add(d))}var bf="_reactListening"+Math.random().toString(36).slice(2);function cf(a){a[bf]||(a[bf]=!0,ba.forEach(function(b){Ye.has(b)||df(b,!1,a,null);df(b,!0,a,null)}))}
function df(a,b,c,d){var e=4<arguments.length&&void 0!==arguments[4]?arguments[4]:0,f=c;"selectionchange"===a&&9!==c.nodeType&&(f=c.ownerDocument);if(null!==d&&!b&&Ye.has(a)){if("scroll"!==a)return;e|=2;f=d}var g=$e(f),h=a+"__"+(b?"capture":"bubble");g.has(h)||(b&&(e|=4),af(f,a,e,b),g.add(h))}
function af(a,b,c,d){var e=Nc.get(b);switch(void 0===e?2:e){case 0:e=gd;break;case 1:e=id;break;default:e=hd}c=e.bind(null,b,c,a);e=void 0;!Pb||"touchstart"!==b&&"touchmove"!==b&&"wheel"!==b||(e=!0);d?void 0!==e?a.addEventListener(b,c,{capture:!0,passive:e}):a.addEventListener(b,c,!0):void 0!==e?a.addEventListener(b,c,{passive:e}):a.addEventListener(b,c,!1)}
function jd(a,b,c,d,e){var f=d;if(0===(b&1)&&0===(b&2)&&null!==d)a:for(;;){if(null===d)return;var g=d.tag;if(3===g||4===g){var h=d.stateNode.containerInfo;if(h===e||8===h.nodeType&&h.parentNode===e)break;if(4===g)for(g=d.return;null!==g;){var k=g.tag;if(3===k||4===k)if(k=g.stateNode.containerInfo,k===e||8===k.nodeType&&k.parentNode===e)return;g=g.return}for(;null!==h;){g=wc(h);if(null===g)return;k=g.tag;if(5===k||6===k){d=f=g;continue a}h=h.parentNode}}d=d.return}Nb(function(){var d=f,e=xb(c),g=[];
a:{var h=Mc.get(a);if(void 0!==h){var k=td,x=a;switch(a){case "keypress":if(0===od(c))break a;case "keydown":case "keyup":k=Rd;break;case "focusin":x="focus";k=Fd;break;case "focusout":x="blur";k=Fd;break;case "beforeblur":case "afterblur":k=Fd;break;case "click":if(2===c.button)break a;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":k=Bd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":k=
Dd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":k=Vd;break;case Ic:case Jc:case Kc:k=Hd;break;case Lc:k=Xd;break;case "scroll":k=vd;break;case "wheel":k=Zd;break;case "copy":case "cut":case "paste":k=Jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":k=Td}var w=0!==(b&4),z=!w&&"scroll"===a,u=w?null!==h?h+"Capture":null:h;w=[];for(var t=d,q;null!==
t;){q=t;var v=q.stateNode;5===q.tag&&null!==v&&(q=v,null!==u&&(v=Ob(t,u),null!=v&&w.push(ef(t,v,q))));if(z)break;t=t.return}0<w.length&&(h=new k(h,x,null,c,e),g.push({event:h,listeners:w}))}}if(0===(b&7)){a:{h="mouseover"===a||"pointerover"===a;k="mouseout"===a||"pointerout"===a;if(h&&0===(b&16)&&(x=c.relatedTarget||c.fromElement)&&(wc(x)||x[ff]))break a;if(k||h){h=e.window===e?e:(h=e.ownerDocument)?h.defaultView||h.parentWindow:window;if(k){if(x=c.relatedTarget||c.toElement,k=d,x=x?wc(x):null,null!==
x&&(z=Zb(x),x!==z||5!==x.tag&&6!==x.tag))x=null}else k=null,x=d;if(k!==x){w=Bd;v="onMouseLeave";u="onMouseEnter";t="mouse";if("pointerout"===a||"pointerover"===a)w=Td,v="onPointerLeave",u="onPointerEnter",t="pointer";z=null==k?h:ue(k);q=null==x?h:ue(x);h=new w(v,t+"leave",k,c,e);h.target=z;h.relatedTarget=q;v=null;wc(e)===d&&(w=new w(u,t+"enter",x,c,e),w.target=q,w.relatedTarget=z,v=w);z=v;if(k&&x)b:{w=k;u=x;t=0;for(q=w;q;q=gf(q))t++;q=0;for(v=u;v;v=gf(v))q++;for(;0<t-q;)w=gf(w),t--;for(;0<q-t;)u=
gf(u),q--;for(;t--;){if(w===u||null!==u&&w===u.alternate)break b;w=gf(w);u=gf(u)}w=null}else w=null;null!==k&&hf(g,h,k,w,!1);null!==x&&null!==z&&hf(g,z,x,w,!0)}}}a:{h=d?ue(d):window;k=h.nodeName&&h.nodeName.toLowerCase();if("select"===k||"input"===k&&"file"===h.type)var J=ve;else if(me(h))if(we)J=Fe;else{J=De;var K=Ce}else(k=h.nodeName)&&"input"===k.toLowerCase()&&("checkbox"===h.type||"radio"===h.type)&&(J=Ee);if(J&&(J=J(a,d))){ne(g,J,c,e);break a}K&&K(a,h,d);"focusout"===a&&(K=h._wrapperState)&&
K.controlled&&"number"===h.type&&bb(h,"number",h.value)}K=d?ue(d):window;switch(a){case "focusin":if(me(K)||"true"===K.contentEditable)Qe=K,Re=d,Se=null;break;case "focusout":Se=Re=Qe=null;break;case "mousedown":Te=!0;break;case "contextmenu":case "mouseup":case "dragend":Te=!1;Ue(g,c,e);break;case "selectionchange":if(Pe)break;case "keydown":case "keyup":Ue(g,c,e)}var Q;if(ae)b:{switch(a){case "compositionstart":var L="onCompositionStart";break b;case "compositionend":L="onCompositionEnd";break b;
case "compositionupdate":L="onCompositionUpdate";break b}L=void 0}else ie?ge(a,c)&&(L="onCompositionEnd"):"keydown"===a&&229===c.keyCode&&(L="onCompositionStart");L&&(de&&"ko"!==c.locale&&(ie||"onCompositionStart"!==L?"onCompositionEnd"===L&&ie&&(Q=nd()):(kd=e,ld="value"in kd?kd.value:kd.textContent,ie=!0)),K=oe(d,L),0<K.length&&(L=new Ld(L,a,null,c,e),g.push({event:L,listeners:K}),Q?L.data=Q:(Q=he(c),null!==Q&&(L.data=Q))));if(Q=ce?je(a,c):ke(a,c))d=oe(d,"onBeforeInput"),0<d.length&&(e=new Ld("onBeforeInput",
"beforeinput",null,c,e),g.push({event:e,listeners:d}),e.data=Q)}se(g,b)})}function ef(a,b,c){return{instance:a,listener:b,currentTarget:c}}function oe(a,b){for(var c=b+"Capture",d=[];null!==a;){var e=a,f=e.stateNode;5===e.tag&&null!==f&&(e=f,f=Ob(a,c),null!=f&&d.unshift(ef(a,f,e)),f=Ob(a,b),null!=f&&d.push(ef(a,f,e)));a=a.return}return d}function gf(a){if(null===a)return null;do a=a.return;while(a&&5!==a.tag);return a?a:null}
function hf(a,b,c,d,e){for(var f=b._reactName,g=[];null!==c&&c!==d;){var h=c,k=h.alternate,l=h.stateNode;if(null!==k&&k===d)break;5===h.tag&&null!==l&&(h=l,e?(k=Ob(c,f),null!=k&&g.unshift(ef(c,k,h))):e||(k=Ob(c,f),null!=k&&g.push(ef(c,k,h))));c=c.return}0!==g.length&&a.push({event:b,listeners:g})}function jf(){}var kf=null,lf=null;function mf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function nf(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var of="function"===typeof setTimeout?setTimeout:void 0,pf="function"===typeof clearTimeout?clearTimeout:void 0;function qf(a){1===a.nodeType?a.textContent="":9===a.nodeType&&(a=a.body,null!=a&&(a.textContent=""))}
function rf(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}function sf(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if("$"===c||"$!"===c||"$?"===c){if(0===b)return a;b--}else"/$"===c&&b++}a=a.previousSibling}return null}var tf=0;function uf(a){return{$$typeof:Ga,toString:a,valueOf:a}}var vf=Math.random().toString(36).slice(2),wf="__reactFiber$"+vf,xf="__reactProps$"+vf,ff="__reactContainer$"+vf,yf="__reactEvents$"+vf;
function wc(a){var b=a[wf];if(b)return b;for(var c=a.parentNode;c;){if(b=c[ff]||c[wf]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=sf(a);null!==a;){if(c=a[wf])return c;a=sf(a)}return b}a=c;c=a.parentNode}return null}function Cb(a){a=a[wf]||a[ff];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function ue(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(y(33));}function Db(a){return a[xf]||null}
function $e(a){var b=a[yf];void 0===b&&(b=a[yf]=new Set);return b}var zf=[],Af=-1;function Bf(a){return{current:a}}function H(a){0>Af||(a.current=zf[Af],zf[Af]=null,Af--)}function I(a,b){Af++;zf[Af]=a.current;a.current=b}var Cf={},M=Bf(Cf),N=Bf(!1),Df=Cf;
function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function Ff(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Gf(){H(N);H(M)}function Hf(a,b,c){if(M.current!==Cf)throw Error(y(168));I(M,b);I(N,c)}
function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(y(108,Ra(b)||"Unknown",e));return m({},c,d)}function Jf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Cf;Df=M.current;I(M,a);I(N,N.current);return!0}function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(y(169));c?(a=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=a,H(N),H(M),I(M,a)):H(N);I(N,c)}
var Lf=null,Mf=null,Nf=r.unstable_runWithPriority,Of=r.unstable_scheduleCallback,Pf=r.unstable_cancelCallback,Qf=r.unstable_shouldYield,Rf=r.unstable_requestPaint,Sf=r.unstable_now,Tf=r.unstable_getCurrentPriorityLevel,Uf=r.unstable_ImmediatePriority,Vf=r.unstable_UserBlockingPriority,Wf=r.unstable_NormalPriority,Xf=r.unstable_LowPriority,Yf=r.unstable_IdlePriority,Zf={},$f=void 0!==Rf?Rf:function(){},ag=null,bg=null,cg=!1,dg=Sf(),O=1E4>dg?Sf:function(){return Sf()-dg};
function eg(){switch(Tf()){case Uf:return 99;case Vf:return 98;case Wf:return 97;case Xf:return 96;case Yf:return 95;default:throw Error(y(332));}}function fg(a){switch(a){case 99:return Uf;case 98:return Vf;case 97:return Wf;case 96:return Xf;case 95:return Yf;default:throw Error(y(332));}}function gg(a,b){a=fg(a);return Nf(a,b)}function hg(a,b,c){a=fg(a);return Of(a,b,c)}function ig(){if(null!==bg){var a=bg;bg=null;Pf(a)}jg()}
function jg(){if(!cg&&null!==ag){cg=!0;var a=0;try{var b=ag;gg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});ag=null}catch(c){throw null!==ag&&(ag=ag.slice(a+1)),Of(Uf,ig),c;}finally{cg=!1}}}var kg=ra.ReactCurrentBatchConfig;function lg(a,b){if(a&&a.defaultProps){b=m({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c]);return b}return b}var mg=Bf(null),ng=null,og=null,pg=null;function qg(){pg=og=ng=null}
function rg(a){var b=mg.current;H(mg);a.type._context._currentValue=b}function sg(a,b){for(;null!==a;){var c=a.alternate;if((a.childLanes&b)===b)if(null===c||(c.childLanes&b)===b)break;else c.childLanes|=b;else a.childLanes|=b,null!==c&&(c.childLanes|=b);a=a.return}}function tg(a,b){ng=a;pg=og=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(0!==(a.lanes&b)&&(ug=!0),a.firstContext=null)}
function vg(a,b){if(pg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)pg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===og){if(null===ng)throw Error(y(308));og=b;ng.dependencies={lanes:0,firstContext:b,responders:null}}else og=og.next=b}return a._currentValue}var wg=!1;function xg(a){a.updateQueue={baseState:a.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null},effects:null}}
function yg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,firstBaseUpdate:a.firstBaseUpdate,lastBaseUpdate:a.lastBaseUpdate,shared:a.shared,effects:a.effects})}function zg(a,b){return{eventTime:a,lane:b,tag:0,payload:null,callback:null,next:null}}function Ag(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function Bg(a,b){var c=a.updateQueue,d=a.alternate;if(null!==d&&(d=d.updateQueue,c===d)){var e=null,f=null;c=c.firstBaseUpdate;if(null!==c){do{var g={eventTime:c.eventTime,lane:c.lane,tag:c.tag,payload:c.payload,callback:c.callback,next:null};null===f?e=f=g:f=f.next=g;c=c.next}while(null!==c);null===f?e=f=b:f=f.next=b}else e=f=b;c={baseState:d.baseState,firstBaseUpdate:e,lastBaseUpdate:f,shared:d.shared,effects:d.effects};a.updateQueue=c;return}a=c.lastBaseUpdate;null===a?c.firstBaseUpdate=b:a.next=
b;c.lastBaseUpdate=b}
function Cg(a,b,c,d){var e=a.updateQueue;wg=!1;var f=e.firstBaseUpdate,g=e.lastBaseUpdate,h=e.shared.pending;if(null!==h){e.shared.pending=null;var k=h,l=k.next;k.next=null;null===g?f=l:g.next=l;g=k;var n=a.alternate;if(null!==n){n=n.updateQueue;var A=n.lastBaseUpdate;A!==g&&(null===A?n.firstBaseUpdate=l:A.next=l,n.lastBaseUpdate=k)}}if(null!==f){A=e.baseState;g=0;n=l=k=null;do{h=f.lane;var p=f.eventTime;if((d&h)===h){null!==n&&(n=n.next={eventTime:p,lane:0,tag:f.tag,payload:f.payload,callback:f.callback,
next:null});a:{var C=a,x=f;h=b;p=c;switch(x.tag){case 1:C=x.payload;if("function"===typeof C){A=C.call(p,A,h);break a}A=C;break a;case 3:C.flags=C.flags&-4097|64;case 0:C=x.payload;h="function"===typeof C?C.call(p,A,h):C;if(null===h||void 0===h)break a;A=m({},A,h);break a;case 2:wg=!0}}null!==f.callback&&(a.flags|=32,h=e.effects,null===h?e.effects=[f]:h.push(f))}else p={eventTime:p,lane:h,tag:f.tag,payload:f.payload,callback:f.callback,next:null},null===n?(l=n=p,k=A):n=n.next=p,g|=h;f=f.next;if(null===
f)if(h=e.shared.pending,null===h)break;else f=h.next,h.next=null,e.lastBaseUpdate=h,e.shared.pending=null}while(1);null===n&&(k=A);e.baseState=k;e.firstBaseUpdate=l;e.lastBaseUpdate=n;Dg|=g;a.lanes=g;a.memoizedState=A}}function Eg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=c;if("function"!==typeof e)throw Error(y(191,e));e.call(d)}}}var Fg=(new aa.Component).refs;
function Gg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:m({},b,c);a.memoizedState=c;0===a.lanes&&(a.updateQueue.baseState=c)}
var Kg={isMounted:function(a){return(a=a._reactInternals)?Zb(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternals;var d=Hg(),e=Ig(a),f=zg(d,e);f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Ag(a,f);Jg(a,e,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternals;var d=Hg(),e=Ig(a),f=zg(d,e);f.tag=1;f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Ag(a,f);Jg(a,e,d)},enqueueForceUpdate:function(a,b){a=a._reactInternals;var c=Hg(),d=Ig(a),e=zg(c,d);e.tag=2;void 0!==b&&null!==b&&(e.callback=
b);Ag(a,e);Jg(a,d,c)}};function Lg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!Je(c,d)||!Je(e,f):!0}
function Mg(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=vg(f):(e=Ff(b)?Df:M.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Kg;a.stateNode=b;b._reactInternals=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Ng(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Kg.enqueueReplaceState(b,b.state,null)}
function Og(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Fg;xg(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=vg(f):(f=Ff(b)?Df:M.current,e.context=Ef(a,f));Cg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Gg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Kg.enqueueReplaceState(e,e.state,null),Cg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.flags|=4)}var Pg=Array.isArray;
function Qg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(y(309));var d=c.stateNode}if(!d)throw Error(y(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Fg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(y(284));if(!c._owner)throw Error(y(290,a));}return a}
function Rg(a,b){if("textarea"!==a.type)throw Error(y(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b));}
function Sg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.flags=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Tg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.flags=2,
c):d;b.flags=2;return c}function g(b){a&&null===b.alternate&&(b.flags=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Ug(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Qg(a,b,c),d.return=a,d;d=Vg(c.type,c.key,c.props,null,a.mode,d);d.ref=Qg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Wg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function n(a,b,c,d,f){if(null===b||7!==b.tag)return b=Xg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function A(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ug(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case sa:return c=Vg(b.type,b.key,b.props,null,a.mode,c),c.ref=Qg(a,null,b),c.return=a,c;case ta:return b=Wg(b,a.mode,c),b.return=a,b}if(Pg(b)||La(b))return b=Xg(b,
a.mode,c,null),b.return=a,b;Rg(a,b)}return null}function p(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case sa:return c.key===e?c.type===ua?n(a,b,c.props.children,d,e):k(a,b,c,d):null;case ta:return c.key===e?l(a,b,c,d):null}if(Pg(c)||La(c))return null!==e?null:n(a,b,c,d,null);Rg(a,c)}return null}function C(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case sa:return a=a.get(null===d.key?c:d.key)||null,d.type===ua?n(b,a,d.props.children,e,d.key):k(b,a,d,e);case ta:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Pg(d)||La(d))return a=a.get(c)||null,n(b,a,d,e,null);Rg(b,d)}return null}function x(e,g,h,k){for(var l=null,t=null,u=g,z=g=0,q=null;null!==u&&z<h.length;z++){u.index>z?(q=u,u=null):q=u.sibling;var n=p(e,u,h[z],k);if(null===n){null===u&&(u=q);break}a&&u&&null===
n.alternate&&b(e,u);g=f(n,g,z);null===t?l=n:t.sibling=n;t=n;u=q}if(z===h.length)return c(e,u),l;if(null===u){for(;z<h.length;z++)u=A(e,h[z],k),null!==u&&(g=f(u,g,z),null===t?l=u:t.sibling=u,t=u);return l}for(u=d(e,u);z<h.length;z++)q=C(u,e,z,h[z],k),null!==q&&(a&&null!==q.alternate&&u.delete(null===q.key?z:q.key),g=f(q,g,z),null===t?l=q:t.sibling=q,t=q);a&&u.forEach(function(a){return b(e,a)});return l}function w(e,g,h,k){var l=La(h);if("function"!==typeof l)throw Error(y(150));h=l.call(h);if(null==
h)throw Error(y(151));for(var t=l=null,u=g,z=g=0,q=null,n=h.next();null!==u&&!n.done;z++,n=h.next()){u.index>z?(q=u,u=null):q=u.sibling;var w=p(e,u,n.value,k);if(null===w){null===u&&(u=q);break}a&&u&&null===w.alternate&&b(e,u);g=f(w,g,z);null===t?l=w:t.sibling=w;t=w;u=q}if(n.done)return c(e,u),l;if(null===u){for(;!n.done;z++,n=h.next())n=A(e,n.value,k),null!==n&&(g=f(n,g,z),null===t?l=n:t.sibling=n,t=n);return l}for(u=d(e,u);!n.done;z++,n=h.next())n=C(u,e,z,n.value,k),null!==n&&(a&&null!==n.alternate&&
u.delete(null===n.key?z:n.key),g=f(n,g,z),null===t?l=n:t.sibling=n,t=n);a&&u.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ua&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case sa:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ua){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,k.sibling);
d=e(k,f.props);d.ref=Qg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ua?(d=Xg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Vg(f.type,f.key,f.props,null,a.mode,h),h.ref=Qg(a,d,f),h.return=a,a=h)}return g(a);case ta:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=
Wg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Ug(f,a.mode,h),d.return=a,a=d),g(a);if(Pg(f))return x(a,d,f,h);if(La(f))return w(a,d,f,h);l&&Rg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 22:case 0:case 11:case 15:throw Error(y(152,Ra(a.type)||"Component"));}return c(a,d)}}var Yg=Sg(!0),Zg=Sg(!1),$g={},ah=Bf($g),bh=Bf($g),ch=Bf($g);
function dh(a){if(a===$g)throw Error(y(174));return a}function eh(a,b){I(ch,b);I(bh,a);I(ah,$g);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:mb(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=mb(b,a)}H(ah);I(ah,b)}function fh(){H(ah);H(bh);H(ch)}function gh(a){dh(ch.current);var b=dh(ah.current);var c=mb(b,a.type);b!==c&&(I(bh,a),I(ah,c))}function hh(a){bh.current===a&&(H(ah),H(bh))}var P=Bf(0);
function ih(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||"$?"===c.data||"$!"===c.data))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.flags&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}var jh=null,kh=null,lh=!1;
function mh(a,b){var c=nh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.flags=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function oh(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ph(a){if(lh){var b=kh;if(b){var c=b;if(!oh(a,b)){b=rf(c.nextSibling);if(!b||!oh(a,b)){a.flags=a.flags&-1025|2;lh=!1;jh=a;return}mh(jh,c)}jh=a;kh=rf(b.firstChild)}else a.flags=a.flags&-1025|2,lh=!1,jh=a}}function qh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;jh=a}
function rh(a){if(a!==jh)return!1;if(!lh)return qh(a),lh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!nf(b,a.memoizedProps))for(b=kh;b;)mh(a,b),b=rf(b.nextSibling);qh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(y(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if("/$"===c){if(0===b){kh=rf(a.nextSibling);break a}b--}else"$"!==c&&"$!"!==c&&"$?"!==c||b++}a=a.nextSibling}kh=null}}else kh=jh?rf(a.stateNode.nextSibling):null;return!0}
function sh(){kh=jh=null;lh=!1}var th=[];function uh(){for(var a=0;a<th.length;a++)th[a]._workInProgressVersionPrimary=null;th.length=0}var vh=ra.ReactCurrentDispatcher,wh=ra.ReactCurrentBatchConfig,xh=0,R=null,S=null,T=null,yh=!1,zh=!1;function Ah(){throw Error(y(321));}function Bh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!He(a[c],b[c]))return!1;return!0}
function Ch(a,b,c,d,e,f){xh=f;R=b;b.memoizedState=null;b.updateQueue=null;b.lanes=0;vh.current=null===a||null===a.memoizedState?Dh:Eh;a=c(d,e);if(zh){f=0;do{zh=!1;if(!(25>f))throw Error(y(301));f+=1;T=S=null;b.updateQueue=null;vh.current=Fh;a=c(d,e)}while(zh)}vh.current=Gh;b=null!==S&&null!==S.next;xh=0;T=S=R=null;yh=!1;if(b)throw Error(y(300));return a}function Hh(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===T?R.memoizedState=T=a:T=T.next=a;return T}
function Ih(){if(null===S){var a=R.alternate;a=null!==a?a.memoizedState:null}else a=S.next;var b=null===T?R.memoizedState:T.next;if(null!==b)T=b,S=a;else{if(null===a)throw Error(y(310));S=a;a={memoizedState:S.memoizedState,baseState:S.baseState,baseQueue:S.baseQueue,queue:S.queue,next:null};null===T?R.memoizedState=T=a:T=T.next=a}return T}function Jh(a,b){return"function"===typeof b?b(a):b}
function Kh(a){var b=Ih(),c=b.queue;if(null===c)throw Error(y(311));c.lastRenderedReducer=a;var d=S,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.lane;if((xh&l)===l)null!==h&&(h=h.next={lane:0,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),d=k.eagerReducer===a?k.eagerState:a(d,k.action);else{var n={lane:l,action:k.action,eagerReducer:k.eagerReducer,
eagerState:k.eagerState,next:null};null===h?(g=h=n,f=d):h=h.next=n;R.lanes|=l;Dg|=l}k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;He(d,b.memoizedState)||(ug=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function Lh(a){var b=Ih(),c=b.queue;if(null===c)throw Error(y(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);He(f,b.memoizedState)||(ug=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function Mh(a,b,c){var d=b._getVersion;d=d(b._source);var e=b._workInProgressVersionPrimary;if(null!==e)a=e===d;else if(a=a.mutableReadLanes,a=(xh&a)===a)b._workInProgressVersionPrimary=d,th.push(b);if(a)return c(b._source);th.push(b);throw Error(y(350));}
function Nh(a,b,c,d){var e=U;if(null===e)throw Error(y(349));var f=b._getVersion,g=f(b._source),h=vh.current,k=h.useState(function(){return Mh(e,b,c)}),l=k[1],n=k[0];k=T;var A=a.memoizedState,p=A.refs,C=p.getSnapshot,x=A.source;A=A.subscribe;var w=R;a.memoizedState={refs:p,source:b,subscribe:d};h.useEffect(function(){p.getSnapshot=c;p.setSnapshot=l;var a=f(b._source);if(!He(g,a)){a=c(b._source);He(n,a)||(l(a),a=Ig(w),e.mutableReadLanes|=a&e.pendingLanes);a=e.mutableReadLanes;e.entangledLanes|=a;for(var d=
e.entanglements,h=a;0<h;){var k=31-Vc(h),v=1<<k;d[k]|=a;h&=~v}}},[c,b,d]);h.useEffect(function(){return d(b._source,function(){var a=p.getSnapshot,c=p.setSnapshot;try{c(a(b._source));var d=Ig(w);e.mutableReadLanes|=d&e.pendingLanes}catch(q){c(function(){throw q;})}})},[b,d]);He(C,c)&&He(x,b)&&He(A,d)||(a={pending:null,dispatch:null,lastRenderedReducer:Jh,lastRenderedState:n},a.dispatch=l=Oh.bind(null,R,a),k.queue=a,k.baseQueue=null,n=Mh(e,b,c),k.memoizedState=k.baseState=n);return n}
function Ph(a,b,c){var d=Ih();return Nh(d,a,b,c)}function Qh(a){var b=Hh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:Jh,lastRenderedState:a};a=a.dispatch=Oh.bind(null,R,a);return[b.memoizedState,a]}
function Rh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=R.updateQueue;null===b?(b={lastEffect:null},R.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}function Sh(a){var b=Hh();a={current:a};return b.memoizedState=a}function Th(){return Ih().memoizedState}function Uh(a,b,c,d){var e=Hh();R.flags|=a;e.memoizedState=Rh(1|b,c,void 0,void 0===d?null:d)}
function Vh(a,b,c,d){var e=Ih();d=void 0===d?null:d;var f=void 0;if(null!==S){var g=S.memoizedState;f=g.destroy;if(null!==d&&Bh(d,g.deps)){Rh(b,c,f,d);return}}R.flags|=a;e.memoizedState=Rh(1|b,c,f,d)}function Wh(a,b){return Uh(516,4,a,b)}function Xh(a,b){return Vh(516,4,a,b)}function Yh(a,b){return Vh(4,2,a,b)}function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}
function $h(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,2,Zh.bind(null,b,a),c)}function ai(){}function bi(a,b){var c=Ih();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Bh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}function ci(a,b){var c=Ih();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Bh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}
function di(a,b){var c=eg();gg(98>c?98:c,function(){a(!0)});gg(97<c?97:c,function(){var c=wh.transition;wh.transition=1;try{a(!1),b()}finally{wh.transition=c}})}
function Oh(a,b,c){var d=Hg(),e=Ig(a),f={lane:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.pending;null===g?f.next=f:(f.next=g.next,g.next=f);b.pending=f;g=a.alternate;if(a===R||null!==g&&g===R)zh=yh=!0;else{if(0===a.lanes&&(null===g||0===g.lanes)&&(g=b.lastRenderedReducer,null!==g))try{var h=b.lastRenderedState,k=g(h,c);f.eagerReducer=g;f.eagerState=k;if(He(k,h))return}catch(l){}finally{}Jg(a,e,d)}}
var Gh={readContext:vg,useCallback:Ah,useContext:Ah,useEffect:Ah,useImperativeHandle:Ah,useLayoutEffect:Ah,useMemo:Ah,useReducer:Ah,useRef:Ah,useState:Ah,useDebugValue:Ah,useDeferredValue:Ah,useTransition:Ah,useMutableSource:Ah,useOpaqueIdentifier:Ah,unstable_isNewReconciler:!1},Dh={readContext:vg,useCallback:function(a,b){Hh().memoizedState=[a,void 0===b?null:b];return a},useContext:vg,useEffect:Wh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Uh(4,2,Zh.bind(null,
b,a),c)},useLayoutEffect:function(a,b){return Uh(4,2,a,b)},useMemo:function(a,b){var c=Hh();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=Hh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Oh.bind(null,R,a);return[d.memoizedState,a]},useRef:Sh,useState:Qh,useDebugValue:ai,useDeferredValue:function(a){var b=Qh(a),c=b[0],d=b[1];Wh(function(){var b=wh.transition;
wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Qh(!1),b=a[0];a=di.bind(null,a[1]);Sh(a);return[a,b]},useMutableSource:function(a,b,c){var d=Hh();d.memoizedState={refs:{getSnapshot:b,setSnapshot:null},source:a,subscribe:c};return Nh(d,a,b,c)},useOpaqueIdentifier:function(){if(lh){var a=!1,b=uf(function(){a||(a=!0,c("r:"+(tf++).toString(36)));throw Error(y(355));}),c=Qh(b)[1];0===(R.mode&2)&&(R.flags|=516,Rh(5,function(){c("r:"+(tf++).toString(36))},
void 0,null));return b}b="r:"+(tf++).toString(36);Qh(b);return b},unstable_isNewReconciler:!1},Eh={readContext:vg,useCallback:bi,useContext:vg,useEffect:Xh,useImperativeHandle:$h,useLayoutEffect:Yh,useMemo:ci,useReducer:Kh,useRef:Th,useState:function(){return Kh(Jh)},useDebugValue:ai,useDeferredValue:function(a){var b=Kh(Jh),c=b[0],d=b[1];Xh(function(){var b=wh.transition;wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Kh(Jh)[0];return[Th().current,
a]},useMutableSource:Ph,useOpaqueIdentifier:function(){return Kh(Jh)[0]},unstable_isNewReconciler:!1},Fh={readContext:vg,useCallback:bi,useContext:vg,useEffect:Xh,useImperativeHandle:$h,useLayoutEffect:Yh,useMemo:ci,useReducer:Lh,useRef:Th,useState:function(){return Lh(Jh)},useDebugValue:ai,useDeferredValue:function(a){var b=Lh(Jh),c=b[0],d=b[1];Xh(function(){var b=wh.transition;wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Lh(Jh)[0];return[Th().current,
a]},useMutableSource:Ph,useOpaqueIdentifier:function(){return Lh(Jh)[0]},unstable_isNewReconciler:!1},ei=ra.ReactCurrentOwner,ug=!1;function fi(a,b,c,d){b.child=null===a?Zg(b,null,c,d):Yg(b,a.child,c,d)}function gi(a,b,c,d,e){c=c.render;var f=b.ref;tg(b,e);d=Ch(a,b,c,d,f,e);if(null!==a&&!ug)return b.updateQueue=a.updateQueue,b.flags&=-517,a.lanes&=~e,hi(a,b,e);b.flags|=1;fi(a,b,d,e);return b.child}
function ii(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!ji(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ki(a,b,g,d,e,f);a=Vg(c.type,null,d,b,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(0===(e&f)&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:Je,c(e,d)&&a.ref===b.ref))return hi(a,b,f);b.flags|=1;a=Tg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ki(a,b,c,d,e,f){if(null!==a&&Je(a.memoizedProps,d)&&a.ref===b.ref)if(ug=!1,0!==(f&e))0!==(a.flags&16384)&&(ug=!0);else return b.lanes=a.lanes,hi(a,b,f);return li(a,b,c,d,f)}
function mi(a,b,c){var d=b.pendingProps,e=d.children,f=null!==a?a.memoizedState:null;if("hidden"===d.mode||"unstable-defer-without-hiding"===d.mode)if(0===(b.mode&4))b.memoizedState={baseLanes:0},ni(b,c);else if(0!==(c&1073741824))b.memoizedState={baseLanes:0},ni(b,null!==f?f.baseLanes:c);else return a=null!==f?f.baseLanes|c:c,b.lanes=b.childLanes=1073741824,b.memoizedState={baseLanes:a},ni(b,a),null;else null!==f?(d=f.baseLanes|c,b.memoizedState=null):d=c,ni(b,d);fi(a,b,e,c);return b.child}
function oi(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.flags|=128}function li(a,b,c,d,e){var f=Ff(c)?Df:M.current;f=Ef(b,f);tg(b,e);c=Ch(a,b,c,d,f,e);if(null!==a&&!ug)return b.updateQueue=a.updateQueue,b.flags&=-517,a.lanes&=~e,hi(a,b,e);b.flags|=1;fi(a,b,c,e);return b.child}
function pi(a,b,c,d,e){if(Ff(c)){var f=!0;Jf(b)}else f=!1;tg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),Mg(b,c,d),Og(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=vg(l):(l=Ff(c)?Df:M.current,l=Ef(b,l));var n=c.getDerivedStateFromProps,A="function"===typeof n||"function"===typeof g.getSnapshotBeforeUpdate;A||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Ng(b,g,d,l);wg=!1;var p=b.memoizedState;g.state=p;Cg(b,d,g,e);k=b.memoizedState;h!==d||p!==k||N.current||wg?("function"===typeof n&&(Gg(b,c,n,d),k=b.memoizedState),(h=wg||Lg(b,c,h,d,p,k,l))?(A||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.flags|=4)):("function"===typeof g.componentDidMount&&(b.flags|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.flags|=4),d=!1)}else{g=b.stateNode;yg(a,b);h=b.memoizedProps;l=b.type===b.elementType?h:lg(b.type,h);g.props=l;A=b.pendingProps;p=g.context;k=c.contextType;"object"===typeof k&&null!==k?k=vg(k):(k=Ff(c)?Df:M.current,k=Ef(b,k));var C=c.getDerivedStateFromProps;(n="function"===typeof C||
"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==A||p!==k)&&Ng(b,g,d,k);wg=!1;p=b.memoizedState;g.state=p;Cg(b,d,g,e);var x=b.memoizedState;h!==A||p!==x||N.current||wg?("function"===typeof C&&(Gg(b,c,C,d),x=b.memoizedState),(l=wg||Lg(b,c,l,d,p,x,k))?(n||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,k)),"function"===typeof g.componentDidUpdate&&(b.flags|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.flags|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=k,d=l):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&p===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=256),d=!1)}return qi(a,b,c,d,f,e)}
function qi(a,b,c,d,e,f){oi(a,b);var g=0!==(b.flags&64);if(!d&&!g)return e&&Kf(b,c,!1),hi(a,b,f);d=b.stateNode;ei.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.flags|=1;null!==a&&g?(b.child=Yg(b,a.child,null,f),b.child=Yg(b,null,h,f)):fi(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function ri(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);eh(a,b.containerInfo)}
var si={dehydrated:null,retryLane:0};
function ti(a,b,c){var d=b.pendingProps,e=P.current,f=!1,g;(g=0!==(b.flags&64))||(g=null!==a&&null===a.memoizedState?!1:0!==(e&2));g?(f=!0,b.flags&=-65):null!==a&&null===a.memoizedState||void 0===d.fallback||!0===d.unstable_avoidThisFallback||(e|=1);I(P,e&1);if(null===a){void 0!==d.fallback&&ph(b);a=d.children;e=d.fallback;if(f)return a=ui(b,a,e,c),b.child.memoizedState={baseLanes:c},b.memoizedState=si,a;if("number"===typeof d.unstable_expectedLoadTime)return a=ui(b,a,e,c),b.child.memoizedState={baseLanes:c},
b.memoizedState=si,b.lanes=33554432,a;c=vi({mode:"visible",children:a},b.mode,c,null);c.return=b;return b.child=c}if(null!==a.memoizedState){if(f)return d=wi(a,b,d.children,d.fallback,c),f=b.child,e=a.child.memoizedState,f.memoizedState=null===e?{baseLanes:c}:{baseLanes:e.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=si,d;c=xi(a,b,d.children,c);b.memoizedState=null;return c}if(f)return d=wi(a,b,d.children,d.fallback,c),f=b.child,e=a.child.memoizedState,f.memoizedState=null===e?{baseLanes:c}:
{baseLanes:e.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=si,d;c=xi(a,b,d.children,c);b.memoizedState=null;return c}function ui(a,b,c,d){var e=a.mode,f=a.child;b={mode:"hidden",children:b};0===(e&2)&&null!==f?(f.childLanes=0,f.pendingProps=b):f=vi(b,e,0,null);c=Xg(c,e,d,null);f.return=a;c.return=a;f.sibling=c;a.child=f;return c}
function xi(a,b,c,d){var e=a.child;a=e.sibling;c=Tg(e,{mode:"visible",children:c});0===(b.mode&2)&&(c.lanes=d);c.return=b;c.sibling=null;null!==a&&(a.nextEffect=null,a.flags=8,b.firstEffect=b.lastEffect=a);return b.child=c}
function wi(a,b,c,d,e){var f=b.mode,g=a.child;a=g.sibling;var h={mode:"hidden",children:c};0===(f&2)&&b.child!==g?(c=b.child,c.childLanes=0,c.pendingProps=h,g=c.lastEffect,null!==g?(b.firstEffect=c.firstEffect,b.lastEffect=g,g.nextEffect=null):b.firstEffect=b.lastEffect=null):c=Tg(g,h);null!==a?d=Tg(a,d):(d=Xg(d,f,e,null),d.flags|=2);d.return=b;c.return=b;c.sibling=d;b.child=c;return d}function yi(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);sg(a.return,b)}
function zi(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailMode=e,g.lastEffect=f)}
function Ai(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;fi(a,b,d.children,c);d=P.current;if(0!==(d&2))d=d&1|2,b.flags|=64;else{if(null!==a&&0!==(a.flags&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&yi(a,c);else if(19===a.tag)yi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(P,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===ih(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);zi(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===ih(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}zi(b,!0,c,null,f,b.lastEffect);break;case "together":zi(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function hi(a,b,c){null!==a&&(b.dependencies=a.dependencies);Dg|=b.lanes;if(0!==(c&b.childLanes)){if(null!==a&&b.child!==a.child)throw Error(y(153));if(null!==b.child){a=b.child;c=Tg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Tg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}return null}var Bi,Ci,Di,Ei;
Bi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ci=function(){};
Di=function(a,b,c,d){var e=a.memoizedProps;if(e!==d){a=b.stateNode;dh(ah.current);var f=null;switch(c){case "input":e=Ya(a,e);d=Ya(a,d);f=[];break;case "option":e=eb(a,e);d=eb(a,d);f=[];break;case "select":e=m({},e,{value:void 0});d=m({},d,{value:void 0});f=[];break;case "textarea":e=gb(a,e);d=gb(a,d);f=[];break;default:"function"!==typeof e.onClick&&"function"===typeof d.onClick&&(a.onclick=jf)}vb(c,d);var g;c=null;for(l in e)if(!d.hasOwnProperty(l)&&e.hasOwnProperty(l)&&null!=e[l])if("style"===
l){var h=e[l];for(g in h)h.hasOwnProperty(g)&&(c||(c={}),c[g]="")}else"dangerouslySetInnerHTML"!==l&&"children"!==l&&"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ca.hasOwnProperty(l)?f||(f=[]):(f=f||[]).push(l,null));for(l in d){var k=d[l];h=null!=e?e[l]:void 0;if(d.hasOwnProperty(l)&&k!==h&&(null!=k||null!=h))if("style"===l)if(h){for(g in h)!h.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(c||(c={}),c[g]="");for(g in k)k.hasOwnProperty(g)&&h[g]!==k[g]&&(c||
(c={}),c[g]=k[g])}else c||(f||(f=[]),f.push(l,c)),c=k;else"dangerouslySetInnerHTML"===l?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(l,k)):"children"===l?"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(l,""+k):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&(ca.hasOwnProperty(l)?(null!=k&&"onScroll"===l&&G("scroll",a),f||h===k||(f=[])):"object"===typeof k&&null!==k&&k.$$typeof===Ga?k.toString():(f=f||[]).push(l,k))}c&&(f=f||[]).push("style",
c);var l=f;if(b.updateQueue=l)b.flags|=4}};Ei=function(a,b,c,d){c!==d&&(b.flags|=4)};function Fi(a,b){if(!lh)switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Gi(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return Ff(b.type)&&Gf(),null;case 3:fh();H(N);H(M);uh();d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)rh(b)?b.flags|=4:d.hydrate||(b.flags|=256);Ci(b);return null;case 5:hh(b);var e=dh(ch.current);c=b.type;if(null!==a&&null!=b.stateNode)Di(a,b,c,d,e),a.ref!==b.ref&&(b.flags|=128);else{if(!d){if(null===
b.stateNode)throw Error(y(166));return null}a=dh(ah.current);if(rh(b)){d=b.stateNode;c=b.type;var f=b.memoizedProps;d[wf]=b;d[xf]=f;switch(c){case "dialog":G("cancel",d);G("close",d);break;case "iframe":case "object":case "embed":G("load",d);break;case "video":case "audio":for(a=0;a<Xe.length;a++)G(Xe[a],d);break;case "source":G("error",d);break;case "img":case "image":case "link":G("error",d);G("load",d);break;case "details":G("toggle",d);break;case "input":Za(d,f);G("invalid",d);break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};G("invalid",d);break;case "textarea":hb(d,f),G("invalid",d)}vb(c,f);a=null;for(var g in f)f.hasOwnProperty(g)&&(e=f[g],"children"===g?"string"===typeof e?d.textContent!==e&&(a=["children",e]):"number"===typeof e&&d.textContent!==""+e&&(a=["children",""+e]):ca.hasOwnProperty(g)&&null!=e&&"onScroll"===g&&G("scroll",d));switch(c){case "input":Va(d);cb(d,f,!0);break;case "textarea":Va(d);jb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&(d.onclick=
jf)}d=a;b.updateQueue=d;null!==d&&(b.flags|=4)}else{g=9===e.nodeType?e:e.ownerDocument;a===kb.html&&(a=lb(c));a===kb.html?"script"===c?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(c,{is:d.is}):(a=g.createElement(c),"select"===c&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,c);a[wf]=b;a[xf]=d;Bi(a,b,!1,!1);b.stateNode=a;g=wb(c,d);switch(c){case "dialog":G("cancel",a);G("close",a);
e=d;break;case "iframe":case "object":case "embed":G("load",a);e=d;break;case "video":case "audio":for(e=0;e<Xe.length;e++)G(Xe[e],a);e=d;break;case "source":G("error",a);e=d;break;case "img":case "image":case "link":G("error",a);G("load",a);e=d;break;case "details":G("toggle",a);e=d;break;case "input":Za(a,d);e=Ya(a,d);G("invalid",a);break;case "option":e=eb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};e=m({},d,{value:void 0});G("invalid",a);break;case "textarea":hb(a,d);e=
gb(a,d);G("invalid",a);break;default:e=d}vb(c,e);var h=e;for(f in h)if(h.hasOwnProperty(f)){var k=h[f];"style"===f?tb(a,k):"dangerouslySetInnerHTML"===f?(k=k?k.__html:void 0,null!=k&&ob(a,k)):"children"===f?"string"===typeof k?("textarea"!==c||""!==k)&&pb(a,k):"number"===typeof k&&pb(a,""+k):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(ca.hasOwnProperty(f)?null!=k&&"onScroll"===f&&G("scroll",a):null!=k&&qa(a,f,k,g))}switch(c){case "input":Va(a);cb(a,d,!1);
break;case "textarea":Va(a);jb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+Sa(d.value));break;case "select":a.multiple=!!d.multiple;f=d.value;null!=f?fb(a,!!d.multiple,f,!1):null!=d.defaultValue&&fb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof e.onClick&&(a.onclick=jf)}mf(c,d)&&(b.flags|=4)}null!==b.ref&&(b.flags|=128)}return null;case 6:if(a&&null!=b.stateNode)Ei(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(y(166));
c=dh(ch.current);dh(ah.current);rh(b)?(d=b.stateNode,c=b.memoizedProps,d[wf]=b,d.nodeValue!==c&&(b.flags|=4)):(d=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),d[wf]=b,b.stateNode=d)}return null;case 13:H(P);d=b.memoizedState;if(0!==(b.flags&64))return b.lanes=c,b;d=null!==d;c=!1;null===a?void 0!==b.memoizedProps.fallback&&rh(b):c=null!==a.memoizedState;if(d&&!c&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(P.current&1))0===V&&(V=3);else{if(0===V||3===V)V=
4;null===U||0===(Dg&134217727)&&0===(Hi&134217727)||Ii(U,W)}if(d||c)b.flags|=4;return null;case 4:return fh(),Ci(b),null===a&&cf(b.stateNode.containerInfo),null;case 10:return rg(b),null;case 17:return Ff(b.type)&&Gf(),null;case 19:H(P);d=b.memoizedState;if(null===d)return null;f=0!==(b.flags&64);g=d.rendering;if(null===g)if(f)Fi(d,!1);else{if(0!==V||null!==a&&0!==(a.flags&64))for(a=b.child;null!==a;){g=ih(a);if(null!==g){b.flags|=64;Fi(d,!1);f=g.updateQueue;null!==f&&(b.updateQueue=f,b.flags|=4);
null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;d=c;for(c=b.child;null!==c;)f=c,a=d,f.flags&=2,f.nextEffect=null,f.firstEffect=null,f.lastEffect=null,g=f.alternate,null===g?(f.childLanes=0,f.lanes=a,f.child=null,f.memoizedProps=null,f.memoizedState=null,f.updateQueue=null,f.dependencies=null,f.stateNode=null):(f.childLanes=g.childLanes,f.lanes=g.lanes,f.child=g.child,f.memoizedProps=g.memoizedProps,f.memoizedState=g.memoizedState,f.updateQueue=g.updateQueue,f.type=g.type,a=g.dependencies,
f.dependencies=null===a?null:{lanes:a.lanes,firstContext:a.firstContext}),c=c.sibling;I(P,P.current&1|2);return b.child}a=a.sibling}null!==d.tail&&O()>Ji&&(b.flags|=64,f=!0,Fi(d,!1),b.lanes=33554432)}else{if(!f)if(a=ih(g),null!==a){if(b.flags|=64,f=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.flags|=4),Fi(d,!0),null===d.tail&&"hidden"===d.tailMode&&!g.alternate&&!lh)return b=b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*O()-d.renderingStartTime>Ji&&1073741824!==c&&(b.flags|=
64,f=!0,Fi(d,!1),b.lanes=33554432);d.isBackwards?(g.sibling=b.child,b.child=g):(c=d.last,null!==c?c.sibling=g:b.child=g,d.last=g)}return null!==d.tail?(c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=O(),c.sibling=null,b=P.current,I(P,f?b&1|2:b&1),c):null;case 23:case 24:return Ki(),null!==a&&null!==a.memoizedState!==(null!==b.memoizedState)&&"unstable-defer-without-hiding"!==d.mode&&(b.flags|=4),null}throw Error(y(156,b.tag));}
function Li(a){switch(a.tag){case 1:Ff(a.type)&&Gf();var b=a.flags;return b&4096?(a.flags=b&-4097|64,a):null;case 3:fh();H(N);H(M);uh();b=a.flags;if(0!==(b&64))throw Error(y(285));a.flags=b&-4097|64;return a;case 5:return hh(a),null;case 13:return H(P),b=a.flags,b&4096?(a.flags=b&-4097|64,a):null;case 19:return H(P),null;case 4:return fh(),null;case 10:return rg(a),null;case 23:case 24:return Ki(),null;default:return null}}
function Mi(a,b){try{var c="",d=b;do c+=Qa(d),d=d.return;while(d);var e=c}catch(f){e="\nError generating stack: "+f.message+"\n"+f.stack}return{value:a,source:b,stack:e}}function Ni(a,b){try{console.error(b.value)}catch(c){setTimeout(function(){throw c;})}}var Oi="function"===typeof WeakMap?WeakMap:Map;function Pi(a,b,c){c=zg(-1,c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Qi||(Qi=!0,Ri=d);Ni(a,b)};return c}
function Si(a,b,c){c=zg(-1,c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ni(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Ti?Ti=new Set([this]):Ti.add(this),Ni(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}var Ui="function"===typeof WeakSet?WeakSet:Set;
function Vi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Wi(a,c)}else b.current=null}function Xi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.flags&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:lg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:b.flags&256&&qf(b.stateNode.containerInfo);return;case 5:case 6:case 4:case 17:return}throw Error(y(163));}
function Yi(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{if(3===(a.tag&3)){var d=a.create;a.destroy=d()}a=a.next}while(a!==b)}b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{var e=a;d=e.next;e=e.tag;0!==(e&4)&&0!==(e&1)&&(Zi(c,a),$i(c,a));a=d}while(a!==b)}return;case 1:a=c.stateNode;c.flags&4&&(null===b?a.componentDidMount():(d=c.elementType===c.type?b.memoizedProps:lg(c.type,b.memoizedProps),a.componentDidUpdate(d,
b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)));b=c.updateQueue;null!==b&&Eg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Eg(c,b,a)}return;case 5:a=c.stateNode;null===b&&c.flags&4&&mf(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Cc(c))));
return;case 19:case 17:case 20:case 21:case 23:case 24:return}throw Error(y(163));}
function aj(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d=d.style,"function"===typeof d.setProperty?d.setProperty("display","none","important"):d.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=sb("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if((23!==c.tag&&24!==c.tag||null===c.memoizedState||c===a)&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===
a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function bj(a,b){if(Mf&&"function"===typeof Mf.onCommitFiberUnmount)try{Mf.onCommitFiberUnmount(Lf,b)}catch(f){}switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var c=a=a.next;do{var d=c,e=d.destroy;d=d.tag;if(void 0!==e)if(0!==(d&4))Zi(b,c);else{d=b;try{e()}catch(f){Wi(d,f)}}c=c.next}while(c!==a)}break;case 1:Vi(b);a=b.stateNode;if("function"===typeof a.componentWillUnmount)try{a.props=b.memoizedProps,a.state=b.memoizedState,a.componentWillUnmount()}catch(f){Wi(b,
f)}break;case 5:Vi(b);break;case 4:cj(a,b)}}function dj(a){a.alternate=null;a.child=null;a.dependencies=null;a.firstEffect=null;a.lastEffect=null;a.memoizedProps=null;a.memoizedState=null;a.pendingProps=null;a.return=null;a.updateQueue=null}function ej(a){return 5===a.tag||3===a.tag||4===a.tag}
function fj(a){a:{for(var b=a.return;null!==b;){if(ej(b))break a;b=b.return}throw Error(y(160));}var c=b;b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(y(161));}c.flags&16&&(pb(b,""),c.flags&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||ej(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.flags&2)continue b;if(null===
c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.flags&2)){c=c.stateNode;break a}}d?gj(a,c,b):hj(a,c,b)}
function gj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=jf));else if(4!==d&&(a=a.child,null!==a))for(gj(a,b,c),a=a.sibling;null!==a;)gj(a,b,c),a=a.sibling}
function hj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(hj(a,b,c),a=a.sibling;null!==a;)hj(a,b,c),a=a.sibling}
function cj(a,b){for(var c=b,d=!1,e,f;;){if(!d){d=c.return;a:for(;;){if(null===d)throw Error(y(160));e=d.stateNode;switch(d.tag){case 5:f=!1;break a;case 3:e=e.containerInfo;f=!0;break a;case 4:e=e.containerInfo;f=!0;break a}d=d.return}d=!0}if(5===c.tag||6===c.tag){a:for(var g=a,h=c,k=h;;)if(bj(g,k),null!==k.child&&4!==k.tag)k.child.return=k,k=k.child;else{if(k===h)break a;for(;null===k.sibling;){if(null===k.return||k.return===h)break a;k=k.return}k.sibling.return=k.return;k=k.sibling}f?(g=e,h=c.stateNode,
8===g.nodeType?g.parentNode.removeChild(h):g.removeChild(h)):e.removeChild(c.stateNode)}else if(4===c.tag){if(null!==c.child){e=c.stateNode.containerInfo;f=!0;c.child.return=c;c=c.child;continue}}else if(bj(a,c),null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return;4===c.tag&&(d=!1)}c.sibling.return=c.return;c=c.sibling}}
function ij(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:var c=b.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do 3===(d.tag&3)&&(a=d.destroy,d.destroy=void 0,void 0!==a&&a()),d=d.next;while(d!==c)}return;case 1:return;case 5:c=b.stateNode;if(null!=c){d=b.memoizedProps;var e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[xf]=d;"input"===a&&"radio"===d.type&&null!=d.name&&$a(c,d);wb(a,e);b=wb(a,d);for(e=0;e<f.length;e+=
2){var g=f[e],h=f[e+1];"style"===g?tb(c,h):"dangerouslySetInnerHTML"===g?ob(c,h):"children"===g?pb(c,h):qa(c,g,h,b)}switch(a){case "input":ab(c,d);break;case "textarea":ib(c,d);break;case "select":a=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,f=d.value,null!=f?fb(c,!!d.multiple,f,!1):a!==!!d.multiple&&(null!=d.defaultValue?fb(c,!!d.multiple,d.defaultValue,!0):fb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(y(162));b.stateNode.nodeValue=
b.memoizedProps;return;case 3:c=b.stateNode;c.hydrate&&(c.hydrate=!1,Cc(c.containerInfo));return;case 12:return;case 13:null!==b.memoizedState&&(jj=O(),aj(b.child,!0));kj(b);return;case 19:kj(b);return;case 17:return;case 23:case 24:aj(b,null!==b.memoizedState);return}throw Error(y(163));}function kj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Ui);b.forEach(function(b){var d=lj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
function mj(a,b){return null!==a&&(a=a.memoizedState,null===a||null!==a.dehydrated)?(b=b.memoizedState,null!==b&&null===b.dehydrated):!1}var nj=Math.ceil,oj=ra.ReactCurrentDispatcher,pj=ra.ReactCurrentOwner,X=0,U=null,Y=null,W=0,qj=0,rj=Bf(0),V=0,sj=null,tj=0,Dg=0,Hi=0,uj=0,vj=null,jj=0,Ji=Infinity;function wj(){Ji=O()+500}var Z=null,Qi=!1,Ri=null,Ti=null,xj=!1,yj=null,zj=90,Aj=[],Bj=[],Cj=null,Dj=0,Ej=null,Fj=-1,Gj=0,Hj=0,Ij=null,Jj=!1;function Hg(){return 0!==(X&48)?O():-1!==Fj?Fj:Fj=O()}
function Ig(a){a=a.mode;if(0===(a&2))return 1;if(0===(a&4))return 99===eg()?1:2;0===Gj&&(Gj=tj);if(0!==kg.transition){0!==Hj&&(Hj=null!==vj?vj.pendingLanes:0);a=Gj;var b=4186112&~Hj;b&=-b;0===b&&(a=4186112&~a,b=a&-a,0===b&&(b=8192));return b}a=eg();0!==(X&4)&&98===a?a=Xc(12,Gj):(a=Sc(a),a=Xc(a,Gj));return a}
function Jg(a,b,c){if(50<Dj)throw Dj=0,Ej=null,Error(y(185));a=Kj(a,b);if(null===a)return null;$c(a,b,c);a===U&&(Hi|=b,4===V&&Ii(a,W));var d=eg();1===b?0!==(X&8)&&0===(X&48)?Lj(a):(Mj(a,c),0===X&&(wj(),ig())):(0===(X&4)||98!==d&&99!==d||(null===Cj?Cj=new Set([a]):Cj.add(a)),Mj(a,c));vj=a}function Kj(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);c=a;for(a=a.return;null!==a;)a.childLanes|=b,c=a.alternate,null!==c&&(c.childLanes|=b),c=a,a=a.return;return 3===c.tag?c.stateNode:null}
function Mj(a,b){for(var c=a.callbackNode,d=a.suspendedLanes,e=a.pingedLanes,f=a.expirationTimes,g=a.pendingLanes;0<g;){var h=31-Vc(g),k=1<<h,l=f[h];if(-1===l){if(0===(k&d)||0!==(k&e)){l=b;Rc(k);var n=F;f[h]=10<=n?l+250:6<=n?l+5E3:-1}}else l<=b&&(a.expiredLanes|=k);g&=~k}d=Uc(a,a===U?W:0);b=F;if(0===d)null!==c&&(c!==Zf&&Pf(c),a.callbackNode=null,a.callbackPriority=0);else{if(null!==c){if(a.callbackPriority===b)return;c!==Zf&&Pf(c)}15===b?(c=Lj.bind(null,a),null===ag?(ag=[c],bg=Of(Uf,jg)):ag.push(c),
c=Zf):14===b?c=hg(99,Lj.bind(null,a)):(c=Tc(b),c=hg(c,Nj.bind(null,a)));a.callbackPriority=b;a.callbackNode=c}}
function Nj(a){Fj=-1;Hj=Gj=0;if(0!==(X&48))throw Error(y(327));var b=a.callbackNode;if(Oj()&&a.callbackNode!==b)return null;var c=Uc(a,a===U?W:0);if(0===c)return null;var d=c;var e=X;X|=16;var f=Pj();if(U!==a||W!==d)wj(),Qj(a,d);do try{Rj();break}catch(h){Sj(a,h)}while(1);qg();oj.current=f;X=e;null!==Y?d=0:(U=null,W=0,d=V);if(0!==(tj&Hi))Qj(a,0);else if(0!==d){2===d&&(X|=64,a.hydrate&&(a.hydrate=!1,qf(a.containerInfo)),c=Wc(a),0!==c&&(d=Tj(a,c)));if(1===d)throw b=sj,Qj(a,0),Ii(a,c),Mj(a,O()),b;a.finishedWork=
a.current.alternate;a.finishedLanes=c;switch(d){case 0:case 1:throw Error(y(345));case 2:Uj(a);break;case 3:Ii(a,c);if((c&62914560)===c&&(d=jj+500-O(),10<d)){if(0!==Uc(a,0))break;e=a.suspendedLanes;if((e&c)!==c){Hg();a.pingedLanes|=a.suspendedLanes&e;break}a.timeoutHandle=of(Uj.bind(null,a),d);break}Uj(a);break;case 4:Ii(a,c);if((c&4186112)===c)break;d=a.eventTimes;for(e=-1;0<c;){var g=31-Vc(c);f=1<<g;g=d[g];g>e&&(e=g);c&=~f}c=e;c=O()-c;c=(120>c?120:480>c?480:1080>c?1080:1920>c?1920:3E3>c?3E3:4320>
c?4320:1960*nj(c/1960))-c;if(10<c){a.timeoutHandle=of(Uj.bind(null,a),c);break}Uj(a);break;case 5:Uj(a);break;default:throw Error(y(329));}}Mj(a,O());return a.callbackNode===b?Nj.bind(null,a):null}function Ii(a,b){b&=~uj;b&=~Hi;a.suspendedLanes|=b;a.pingedLanes&=~b;for(a=a.expirationTimes;0<b;){var c=31-Vc(b),d=1<<c;a[c]=-1;b&=~d}}
function Lj(a){if(0!==(X&48))throw Error(y(327));Oj();if(a===U&&0!==(a.expiredLanes&W)){var b=W;var c=Tj(a,b);0!==(tj&Hi)&&(b=Uc(a,b),c=Tj(a,b))}else b=Uc(a,0),c=Tj(a,b);0!==a.tag&&2===c&&(X|=64,a.hydrate&&(a.hydrate=!1,qf(a.containerInfo)),b=Wc(a),0!==b&&(c=Tj(a,b)));if(1===c)throw c=sj,Qj(a,0),Ii(a,b),Mj(a,O()),c;a.finishedWork=a.current.alternate;a.finishedLanes=b;Uj(a);Mj(a,O());return null}
function Vj(){if(null!==Cj){var a=Cj;Cj=null;a.forEach(function(a){a.expiredLanes|=24&a.pendingLanes;Mj(a,O())})}ig()}function Wj(a,b){var c=X;X|=1;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}}function Xj(a,b){var c=X;X&=-2;X|=8;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}}function ni(a,b){I(rj,qj);qj|=b;tj|=b}function Ki(){qj=rj.current;H(rj)}
function Qj(a,b){a.finishedWork=null;a.finishedLanes=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,pf(c));if(null!==Y)for(c=Y.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Gf();break;case 3:fh();H(N);H(M);uh();break;case 5:hh(d);break;case 4:fh();break;case 13:H(P);break;case 19:H(P);break;case 10:rg(d);break;case 23:case 24:Ki()}c=c.return}U=a;Y=Tg(a.current,null);W=qj=tj=b;V=0;sj=null;uj=Hi=Dg=0}
function Sj(a,b){do{var c=Y;try{qg();vh.current=Gh;if(yh){for(var d=R.memoizedState;null!==d;){var e=d.queue;null!==e&&(e.pending=null);d=d.next}yh=!1}xh=0;T=S=R=null;zh=!1;pj.current=null;if(null===c||null===c.return){V=1;sj=b;Y=null;break}a:{var f=a,g=c.return,h=c,k=b;b=W;h.flags|=2048;h.firstEffect=h.lastEffect=null;if(null!==k&&"object"===typeof k&&"function"===typeof k.then){var l=k;if(0===(h.mode&2)){var n=h.alternate;n?(h.updateQueue=n.updateQueue,h.memoizedState=n.memoizedState,h.lanes=n.lanes):
(h.updateQueue=null,h.memoizedState=null)}var A=0!==(P.current&1),p=g;do{var C;if(C=13===p.tag){var x=p.memoizedState;if(null!==x)C=null!==x.dehydrated?!0:!1;else{var w=p.memoizedProps;C=void 0===w.fallback?!1:!0!==w.unstable_avoidThisFallback?!0:A?!1:!0}}if(C){var z=p.updateQueue;if(null===z){var u=new Set;u.add(l);p.updateQueue=u}else z.add(l);if(0===(p.mode&2)){p.flags|=64;h.flags|=16384;h.flags&=-2981;if(1===h.tag)if(null===h.alternate)h.tag=17;else{var t=zg(-1,1);t.tag=2;Ag(h,t)}h.lanes|=1;break a}k=
void 0;h=b;var q=f.pingCache;null===q?(q=f.pingCache=new Oi,k=new Set,q.set(l,k)):(k=q.get(l),void 0===k&&(k=new Set,q.set(l,k)));if(!k.has(h)){k.add(h);var v=Yj.bind(null,f,l,h);l.then(v,v)}p.flags|=4096;p.lanes=b;break a}p=p.return}while(null!==p);k=Error((Ra(h.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.")}5!==V&&(V=2);k=Mi(k,h);p=
g;do{switch(p.tag){case 3:f=k;p.flags|=4096;b&=-b;p.lanes|=b;var J=Pi(p,f,b);Bg(p,J);break a;case 1:f=k;var K=p.type,Q=p.stateNode;if(0===(p.flags&64)&&("function"===typeof K.getDerivedStateFromError||null!==Q&&"function"===typeof Q.componentDidCatch&&(null===Ti||!Ti.has(Q)))){p.flags|=4096;b&=-b;p.lanes|=b;var L=Si(p,f,b);Bg(p,L);break a}}p=p.return}while(null!==p)}Zj(c)}catch(va){b=va;Y===c&&null!==c&&(Y=c=c.return);continue}break}while(1)}
function Pj(){var a=oj.current;oj.current=Gh;return null===a?Gh:a}function Tj(a,b){var c=X;X|=16;var d=Pj();U===a&&W===b||Qj(a,b);do try{ak();break}catch(e){Sj(a,e)}while(1);qg();X=c;oj.current=d;if(null!==Y)throw Error(y(261));U=null;W=0;return V}function ak(){for(;null!==Y;)bk(Y)}function Rj(){for(;null!==Y&&!Qf();)bk(Y)}function bk(a){var b=ck(a.alternate,a,qj);a.memoizedProps=a.pendingProps;null===b?Zj(a):Y=b;pj.current=null}
function Zj(a){var b=a;do{var c=b.alternate;a=b.return;if(0===(b.flags&2048)){c=Gi(c,b,qj);if(null!==c){Y=c;return}c=b;if(24!==c.tag&&23!==c.tag||null===c.memoizedState||0!==(qj&1073741824)||0===(c.mode&4)){for(var d=0,e=c.child;null!==e;)d|=e.lanes|e.childLanes,e=e.sibling;c.childLanes=d}null!==a&&0===(a.flags&2048)&&(null===a.firstEffect&&(a.firstEffect=b.firstEffect),null!==b.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=b.firstEffect),a.lastEffect=b.lastEffect),1<b.flags&&(null!==
a.lastEffect?a.lastEffect.nextEffect=b:a.firstEffect=b,a.lastEffect=b))}else{c=Li(b);if(null!==c){c.flags&=2047;Y=c;return}null!==a&&(a.firstEffect=a.lastEffect=null,a.flags|=2048)}b=b.sibling;if(null!==b){Y=b;return}Y=b=a}while(null!==b);0===V&&(V=5)}function Uj(a){var b=eg();gg(99,dk.bind(null,a,b));return null}
function dk(a,b){do Oj();while(null!==yj);if(0!==(X&48))throw Error(y(327));var c=a.finishedWork;if(null===c)return null;a.finishedWork=null;a.finishedLanes=0;if(c===a.current)throw Error(y(177));a.callbackNode=null;var d=c.lanes|c.childLanes,e=d,f=a.pendingLanes&~e;a.pendingLanes=e;a.suspendedLanes=0;a.pingedLanes=0;a.expiredLanes&=e;a.mutableReadLanes&=e;a.entangledLanes&=e;e=a.entanglements;for(var g=a.eventTimes,h=a.expirationTimes;0<f;){var k=31-Vc(f),l=1<<k;e[k]=0;g[k]=-1;h[k]=-1;f&=~l}null!==
Cj&&0===(d&24)&&Cj.has(a)&&Cj.delete(a);a===U&&(Y=U=null,W=0);1<c.flags?null!==c.lastEffect?(c.lastEffect.nextEffect=c,d=c.firstEffect):d=c:d=c.firstEffect;if(null!==d){e=X;X|=32;pj.current=null;kf=fd;g=Ne();if(Oe(g)){if("selectionStart"in g)h={start:g.selectionStart,end:g.selectionEnd};else a:if(h=(h=g.ownerDocument)&&h.defaultView||window,(l=h.getSelection&&h.getSelection())&&0!==l.rangeCount){h=l.anchorNode;f=l.anchorOffset;k=l.focusNode;l=l.focusOffset;try{h.nodeType,k.nodeType}catch(va){h=null;
break a}var n=0,A=-1,p=-1,C=0,x=0,w=g,z=null;b:for(;;){for(var u;;){w!==h||0!==f&&3!==w.nodeType||(A=n+f);w!==k||0!==l&&3!==w.nodeType||(p=n+l);3===w.nodeType&&(n+=w.nodeValue.length);if(null===(u=w.firstChild))break;z=w;w=u}for(;;){if(w===g)break b;z===h&&++C===f&&(A=n);z===k&&++x===l&&(p=n);if(null!==(u=w.nextSibling))break;w=z;z=w.parentNode}w=u}h=-1===A||-1===p?null:{start:A,end:p}}else h=null;h=h||{start:0,end:0}}else h=null;lf={focusedElem:g,selectionRange:h};fd=!1;Ij=null;Jj=!1;Z=d;do try{ek()}catch(va){if(null===
Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);Ij=null;Z=d;do try{for(g=a;null!==Z;){var t=Z.flags;t&16&&pb(Z.stateNode,"");if(t&128){var q=Z.alternate;if(null!==q){var v=q.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(t&1038){case 2:fj(Z);Z.flags&=-3;break;case 6:fj(Z);Z.flags&=-3;ij(Z.alternate,Z);break;case 1024:Z.flags&=-1025;break;case 1028:Z.flags&=-1025;ij(Z.alternate,Z);break;case 4:ij(Z.alternate,Z);break;case 8:h=Z;cj(g,h);var J=h.alternate;dj(h);null!==
J&&dj(J)}Z=Z.nextEffect}}catch(va){if(null===Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);v=lf;q=Ne();t=v.focusedElem;g=v.selectionRange;if(q!==t&&t&&t.ownerDocument&&Me(t.ownerDocument.documentElement,t)){null!==g&&Oe(t)&&(q=g.start,v=g.end,void 0===v&&(v=q),"selectionStart"in t?(t.selectionStart=q,t.selectionEnd=Math.min(v,t.value.length)):(v=(q=t.ownerDocument||document)&&q.defaultView||window,v.getSelection&&(v=v.getSelection(),h=t.textContent.length,J=Math.min(g.start,h),g=void 0===
g.end?J:Math.min(g.end,h),!v.extend&&J>g&&(h=g,g=J,J=h),h=Le(t,J),f=Le(t,g),h&&f&&(1!==v.rangeCount||v.anchorNode!==h.node||v.anchorOffset!==h.offset||v.focusNode!==f.node||v.focusOffset!==f.offset)&&(q=q.createRange(),q.setStart(h.node,h.offset),v.removeAllRanges(),J>g?(v.addRange(q),v.extend(f.node,f.offset)):(q.setEnd(f.node,f.offset),v.addRange(q))))));q=[];for(v=t;v=v.parentNode;)1===v.nodeType&&q.push({element:v,left:v.scrollLeft,top:v.scrollTop});"function"===typeof t.focus&&t.focus();for(t=
0;t<q.length;t++)v=q[t],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}fd=!!kf;lf=kf=null;a.current=c;Z=d;do try{for(t=a;null!==Z;){var K=Z.flags;K&36&&Yi(t,Z.alternate,Z);if(K&128){q=void 0;var Q=Z.ref;if(null!==Q){var L=Z.stateNode;switch(Z.tag){case 5:q=L;break;default:q=L}"function"===typeof Q?Q(q):Q.current=q}}Z=Z.nextEffect}}catch(va){if(null===Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);Z=null;$f();X=e}else a.current=c;if(xj)xj=!1,yj=a,zj=b;else for(Z=d;null!==Z;)b=
Z.nextEffect,Z.nextEffect=null,Z.flags&8&&(K=Z,K.sibling=null,K.stateNode=null),Z=b;d=a.pendingLanes;0===d&&(Ti=null);1===d?a===Ej?Dj++:(Dj=0,Ej=a):Dj=0;c=c.stateNode;if(Mf&&"function"===typeof Mf.onCommitFiberRoot)try{Mf.onCommitFiberRoot(Lf,c,void 0,64===(c.current.flags&64))}catch(va){}Mj(a,O());if(Qi)throw Qi=!1,a=Ri,Ri=null,a;if(0!==(X&8))return null;ig();return null}
function ek(){for(;null!==Z;){var a=Z.alternate;Jj||null===Ij||(0!==(Z.flags&8)?dc(Z,Ij)&&(Jj=!0):13===Z.tag&&mj(a,Z)&&dc(Z,Ij)&&(Jj=!0));var b=Z.flags;0!==(b&256)&&Xi(a,Z);0===(b&512)||xj||(xj=!0,hg(97,function(){Oj();return null}));Z=Z.nextEffect}}function Oj(){if(90!==zj){var a=97<zj?97:zj;zj=90;return gg(a,fk)}return!1}function $i(a,b){Aj.push(b,a);xj||(xj=!0,hg(97,function(){Oj();return null}))}function Zi(a,b){Bj.push(b,a);xj||(xj=!0,hg(97,function(){Oj();return null}))}
function fk(){if(null===yj)return!1;var a=yj;yj=null;if(0!==(X&48))throw Error(y(331));var b=X;X|=32;var c=Bj;Bj=[];for(var d=0;d<c.length;d+=2){var e=c[d],f=c[d+1],g=e.destroy;e.destroy=void 0;if("function"===typeof g)try{g()}catch(k){if(null===f)throw Error(y(330));Wi(f,k)}}c=Aj;Aj=[];for(d=0;d<c.length;d+=2){e=c[d];f=c[d+1];try{var h=e.create;e.destroy=h()}catch(k){if(null===f)throw Error(y(330));Wi(f,k)}}for(h=a.current.firstEffect;null!==h;)a=h.nextEffect,h.nextEffect=null,h.flags&8&&(h.sibling=
null,h.stateNode=null),h=a;X=b;ig();return!0}function gk(a,b,c){b=Mi(c,b);b=Pi(a,b,1);Ag(a,b);b=Hg();a=Kj(a,1);null!==a&&($c(a,1,b),Mj(a,b))}
function Wi(a,b){if(3===a.tag)gk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){gk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Ti||!Ti.has(d))){a=Mi(b,a);var e=Si(c,a,1);Ag(c,e);e=Hg();c=Kj(c,1);if(null!==c)$c(c,1,e),Mj(c,e);else if("function"===typeof d.componentDidCatch&&(null===Ti||!Ti.has(d)))try{d.componentDidCatch(b,a)}catch(f){}break}}c=c.return}}
function Yj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);b=Hg();a.pingedLanes|=a.suspendedLanes&c;U===a&&(W&c)===c&&(4===V||3===V&&(W&62914560)===W&&500>O()-jj?Qj(a,0):uj|=c);Mj(a,b)}function lj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=a.mode,0===(b&2)?b=1:0===(b&4)?b=99===eg()?1:2:(0===Gj&&(Gj=tj),b=Yc(62914560&~Gj),0===b&&(b=4194304)));c=Hg();a=Kj(a,b);null!==a&&($c(a,b,c),Mj(a,c))}var ck;
ck=function(a,b,c){var d=b.lanes;if(null!==a)if(a.memoizedProps!==b.pendingProps||N.current)ug=!0;else if(0!==(c&d))ug=0!==(a.flags&16384)?!0:!1;else{ug=!1;switch(b.tag){case 3:ri(b);sh();break;case 5:gh(b);break;case 1:Ff(b.type)&&Jf(b);break;case 4:eh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;var e=b.type._context;I(mg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){if(0!==(c&b.child.childLanes))return ti(a,b,c);I(P,P.current&1);b=hi(a,b,c);return null!==
b?b.sibling:null}I(P,P.current&1);break;case 19:d=0!==(c&b.childLanes);if(0!==(a.flags&64)){if(d)return Ai(a,b,c);b.flags|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null,e.lastEffect=null);I(P,P.current);if(d)break;else return null;case 23:case 24:return b.lanes=0,mi(a,b,c)}return hi(a,b,c)}else ug=!1;b.lanes=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);a=b.pendingProps;e=Ef(b,M.current);tg(b,c);e=Ch(null,b,d,a,e,c);b.flags|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(Ff(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;xg(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Gg(b,d,g,a);e.updater=Kg;b.stateNode=e;e._reactInternals=b;Og(b,d,a,c);b=qi(null,b,d,!0,f,c)}else b.tag=0,fi(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;a:{null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);
a=b.pendingProps;f=e._init;e=f(e._payload);b.type=e;f=b.tag=hk(e);a=lg(e,a);switch(f){case 0:b=li(null,b,e,a,c);break a;case 1:b=pi(null,b,e,a,c);break a;case 11:b=gi(null,b,e,a,c);break a;case 14:b=ii(null,b,e,lg(e.type,a),d,c);break a}throw Error(y(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),li(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),pi(a,b,d,e,c);case 3:ri(b);d=b.updateQueue;if(null===a||null===d)throw Error(y(282));
d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;yg(a,b);Cg(b,d,null,c);d=b.memoizedState.element;if(d===e)sh(),b=hi(a,b,c);else{e=b.stateNode;if(f=e.hydrate)kh=rf(b.stateNode.containerInfo.firstChild),jh=b,f=lh=!0;if(f){a=e.mutableSourceEagerHydrationData;if(null!=a)for(e=0;e<a.length;e+=2)f=a[e],f._workInProgressVersionPrimary=a[e+1],th.push(f);c=Zg(b,null,d,c);for(b.child=c;c;)c.flags=c.flags&-3|1024,c=c.sibling}else fi(a,b,d,c),sh();b=b.child}return b;case 5:return gh(b),null===a&&
ph(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,nf(d,e)?g=null:null!==f&&nf(d,f)&&(b.flags|=16),oi(a,b),fi(a,b,g,c),b.child;case 6:return null===a&&ph(b),null;case 13:return ti(a,b,c);case 4:return eh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Yg(b,null,d,c):fi(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),gi(a,b,d,e,c);case 7:return fi(a,b,b.pendingProps,c),b.child;case 8:return fi(a,b,b.pendingProps.children,
c),b.child;case 12:return fi(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(mg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=He(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!N.current){b=hi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=
k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=zg(-1,c&-c),l.tag=2,Ag(h,l));h.lanes|=c;l=h.alternate;null!==l&&(l.lanes|=c);sg(h.return,c);k.lanes|=c;break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}fi(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,tg(b,c),e=vg(e,
f.unstable_observedBits),d=d(e),b.flags|=1,fi(a,b,d,c),b.child;case 14:return e=b.type,f=lg(e,b.pendingProps),f=lg(e.type,f),ii(a,b,e,f,d,c);case 15:return ki(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),b.tag=1,Ff(d)?(a=!0,Jf(b)):a=!1,tg(b,c),Mg(b,d,e),Og(b,d,e,c),qi(null,b,d,!0,a,c);case 19:return Ai(a,b,c);case 23:return mi(a,b,c);case 24:return mi(a,b,c)}throw Error(y(156,b.tag));
};function ik(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.flags=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childLanes=this.lanes=0;this.alternate=null}function nh(a,b,c,d){return new ik(a,b,c,d)}function ji(a){a=a.prototype;return!(!a||!a.isReactComponent)}
function hk(a){if("function"===typeof a)return ji(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Aa)return 11;if(a===Da)return 14}return 2}
function Tg(a,b){var c=a.alternate;null===c?(c=nh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.type=a.type,c.flags=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childLanes=a.childLanes;c.lanes=a.lanes;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{lanes:b.lanes,firstContext:b.firstContext};
c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Vg(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)ji(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ua:return Xg(c.children,e,f,b);case Ha:g=8;e|=16;break;case wa:g=8;e|=1;break;case xa:return a=nh(12,c,b,e|8),a.elementType=xa,a.type=xa,a.lanes=f,a;case Ba:return a=nh(13,c,b,e),a.type=Ba,a.elementType=Ba,a.lanes=f,a;case Ca:return a=nh(19,c,b,e),a.elementType=Ca,a.lanes=f,a;case Ia:return vi(c,e,f,b);case Ja:return a=nh(24,c,b,e),a.elementType=Ja,a.lanes=f,a;default:if("object"===
typeof a&&null!==a)switch(a.$$typeof){case ya:g=10;break a;case za:g=9;break a;case Aa:g=11;break a;case Da:g=14;break a;case Ea:g=16;d=null;break a;case Fa:g=22;break a}throw Error(y(130,null==a?a:typeof a,""));}b=nh(g,c,b,e);b.elementType=a;b.type=d;b.lanes=f;return b}function Xg(a,b,c,d){a=nh(7,a,d,b);a.lanes=c;return a}function vi(a,b,c,d){a=nh(23,a,d,b);a.elementType=Ia;a.lanes=c;return a}function Ug(a,b,c){a=nh(6,a,null,b);a.lanes=c;return a}
function Wg(a,b,c){b=nh(4,null!==a.children?a.children:[],a.key,b);b.lanes=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function jk(a,b,c){this.tag=b;this.containerInfo=a;this.finishedWork=this.pingCache=this.current=this.pendingChildren=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=0;this.eventTimes=Zc(0);this.expirationTimes=Zc(-1);this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0;this.entanglements=Zc(0);this.mutableSourceEagerHydrationData=null}
function kk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:ta,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
function lk(a,b,c,d){var e=b.current,f=Hg(),g=Ig(e);a:if(c){c=c._reactInternals;b:{if(Zb(c)!==c||1!==c.tag)throw Error(y(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(Ff(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(y(171));}if(1===c.tag){var k=c.type;if(Ff(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=zg(f,g);b.payload={element:a};d=void 0===d?null:d;null!==
d&&(b.callback=d);Ag(e,b);Jg(e,g,f);return g}function mk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function nk(a,b){a=a.memoizedState;if(null!==a&&null!==a.dehydrated){var c=a.retryLane;a.retryLane=0!==c&&c<b?c:b}}function ok(a,b){nk(a,b);(a=a.alternate)&&nk(a,b)}function pk(){return null}
function qk(a,b,c){var d=null!=c&&null!=c.hydrationOptions&&c.hydrationOptions.mutableSources||null;c=new jk(a,b,null!=c&&!0===c.hydrate);b=nh(3,null,null,2===b?7:1===b?3:0);c.current=b;b.stateNode=c;xg(b);a[ff]=c.current;cf(8===a.nodeType?a.parentNode:a);if(d)for(a=0;a<d.length;a++){b=d[a];var e=b._getVersion;e=e(b._source);null==c.mutableSourceEagerHydrationData?c.mutableSourceEagerHydrationData=[b,e]:c.mutableSourceEagerHydrationData.push(b,e)}this._internalRoot=c}
qk.prototype.render=function(a){lk(a,this._internalRoot,null,null)};qk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;lk(null,a,null,function(){b[ff]=null})};function rk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function sk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new qk(a,0,b?{hydrate:!0}:void 0)}
function tk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=mk(g);h.call(a)}}lk(b,g,a,e)}else{f=c._reactRootContainer=sk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=mk(g);k.call(a)}}Xj(function(){lk(b,g,a,e)})}return mk(g)}ec=function(a){if(13===a.tag){var b=Hg();Jg(a,4,b);ok(a,4)}};fc=function(a){if(13===a.tag){var b=Hg();Jg(a,67108864,b);ok(a,67108864)}};
gc=function(a){if(13===a.tag){var b=Hg(),c=Ig(a);Jg(a,c,b);ok(a,c)}};hc=function(a,b){return b()};
yb=function(a,b,c){switch(b){case "input":ab(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Db(d);if(!e)throw Error(y(90));Wa(d);ab(d,e)}}}break;case "textarea":ib(a,c);break;case "select":b=c.value,null!=b&&fb(a,!!c.multiple,b,!1)}};Gb=Wj;
Hb=function(a,b,c,d,e){var f=X;X|=4;try{return gg(98,a.bind(null,b,c,d,e))}finally{X=f,0===X&&(wj(),ig())}};Ib=function(){0===(X&49)&&(Vj(),Oj())};Jb=function(a,b){var c=X;X|=2;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}};function uk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!rk(b))throw Error(y(200));return kk(a,b,null,c)}var vk={Events:[Cb,ue,Db,Eb,Fb,Oj,{current:!1}]},wk={findFiberByHostInstance:wc,bundleType:0,version:"17.0.2",rendererPackageName:"react-dom"};
var xk={bundleType:wk.bundleType,version:wk.version,rendererPackageName:wk.rendererPackageName,rendererConfig:wk.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:ra.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=cc(a);return null===a?null:a.stateNode},findFiberByHostInstance:wk.findFiberByHostInstance||
pk,findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null};if("undefined"!==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__){var yk=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!yk.isDisabled&&yk.supportsFiber)try{Lf=yk.inject(xk),Mf=yk}catch(a){}}exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=vk;exports.createPortal=uk;
exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternals;if(void 0===b){if("function"===typeof a.render)throw Error(y(188));throw Error(y(268,Object.keys(a)));}a=cc(b);a=null===a?null:a.stateNode;return a};exports.flushSync=function(a,b){var c=X;if(0!==(c&48))return a(b);X|=1;try{if(a)return gg(99,a.bind(null,b))}finally{X=c,ig()}};exports.hydrate=function(a,b,c){if(!rk(b))throw Error(y(200));return tk(null,a,b,!0,c)};
exports.render=function(a,b,c){if(!rk(b))throw Error(y(200));return tk(null,a,b,!1,c)};exports.unmountComponentAtNode=function(a){if(!rk(a))throw Error(y(40));return a._reactRootContainer?(Xj(function(){tk(null,null,a,!1,function(){a._reactRootContainer=null;a[ff]=null})}),!0):!1};exports.unstable_batchedUpdates=Wj;exports.unstable_createPortal=function(a,b){return uk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!rk(c))throw Error(y(200));if(null==a||void 0===a._reactInternals)throw Error(y(38));return tk(a,b,c,!1,d)};exports.version="17.0.2";


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1119);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f,g,h,k;if("object"===typeof performance&&"function"===typeof performance.now){var l=performance;exports.unstable_now=function(){return l.now()}}else{var p=Date,q=p.now();exports.unstable_now=function(){return p.now()-q}}
if("undefined"===typeof window||"function"!==typeof MessageChannel){var t=null,u=null,w=function(){if(null!==t)try{var a=exports.unstable_now();t(!0,a);t=null}catch(b){throw setTimeout(w,0),b;}};f=function(a){null!==t?setTimeout(f,0,a):(t=a,setTimeout(w,0))};g=function(a,b){u=setTimeout(a,b)};h=function(){clearTimeout(u)};exports.unstable_shouldYield=function(){return!1};k=exports.unstable_forceFrameRate=function(){}}else{var x=window.setTimeout,y=window.clearTimeout;if("undefined"!==typeof console){var z=
window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");"function"!==typeof z&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills")}var A=!1,B=null,C=-1,D=5,E=0;exports.unstable_shouldYield=function(){return exports.unstable_now()>=
E};k=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):D=0<a?Math.floor(1E3/a):5};var F=new MessageChannel,G=F.port2;F.port1.onmessage=function(){if(null!==B){var a=exports.unstable_now();E=a+D;try{B(!0,a)?G.postMessage(null):(A=!1,B=null)}catch(b){throw G.postMessage(null),b;}}else A=!1};f=function(a){B=a;A||(A=!0,G.postMessage(null))};g=function(a,b){C=
x(function(){a(exports.unstable_now())},b)};h=function(){y(C);C=-1}}function H(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<I(e,b))a[d]=b,a[c]=e,c=d;else break a}}function J(a){a=a[0];return void 0===a?null:a}
function K(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>I(n,c))void 0!==r&&0>I(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>I(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function I(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var L=[],M=[],N=1,O=null,P=3,Q=!1,R=!1,S=!1;
function T(a){for(var b=J(M);null!==b;){if(null===b.callback)K(M);else if(b.startTime<=a)K(M),b.sortIndex=b.expirationTime,H(L,b);else break;b=J(M)}}function U(a){S=!1;T(a);if(!R)if(null!==J(L))R=!0,f(V);else{var b=J(M);null!==b&&g(U,b.startTime-a)}}
function V(a,b){R=!1;S&&(S=!1,h());Q=!0;var c=P;try{T(b);for(O=J(L);null!==O&&(!(O.expirationTime>b)||a&&!exports.unstable_shouldYield());){var d=O.callback;if("function"===typeof d){O.callback=null;P=O.priorityLevel;var e=d(O.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?O.callback=e:O===J(L)&&K(L);T(b)}else K(L);O=J(L)}if(null!==O)var m=!0;else{var n=J(M);null!==n&&g(U,n.startTime-b);m=!1}return m}finally{O=null,P=c,Q=!1}}var W=k;exports.unstable_IdlePriority=5;
exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){R||Q||(R=!0,f(V))};exports.unstable_getCurrentPriorityLevel=function(){return P};exports.unstable_getFirstCallbackNode=function(){return J(L)};
exports.unstable_next=function(a){switch(P){case 1:case 2:case 3:var b=3;break;default:b=P}var c=P;P=b;try{return a()}finally{P=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=W;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=P;P=a;try{return b()}finally{P=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();"object"===typeof c&&null!==c?(c=c.delay,c="number"===typeof c&&0<c?d+c:d):c=d;switch(a){case 1:var e=-1;break;case 2:e=250;break;case 5:e=1073741823;break;case 4:e=1E4;break;default:e=5E3}e=c+e;a={id:N++,callback:b,priorityLevel:a,startTime:c,expirationTime:e,sortIndex:-1};c>d?(a.sortIndex=c,H(M,a),null===J(L)&&a===J(M)&&(S?h():S=!0,g(U,c-d))):(a.sortIndex=e,H(L,a),R||Q||(R=!0,f(V)));return a};
exports.unstable_wrapCallback=function(a){var b=P;return function(){var c=P;P=b;try{return a.apply(this,arguments)}finally{P=c}}};


/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_entries__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_values__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_object_values__);
/* eslint no-extend-native: "off" */// to avoid warning at console
// Add polyfill for Object.entries
if(!Object.entries){__WEBPACK_IMPORTED_MODULE_0_object_entries___default.a.shim();}// Add polyfill for Object.values
if(!Object.values){__WEBPACK_IMPORTED_MODULE_1_object_values___default.a.shim();}// https://tc39.github.io/ecma262/#sec-array.prototype.find
if(!Array.prototype.find){Object.defineProperty(Array.prototype,'find',{value:function value(predicate){// 1. Let O be ? ToObject(this value).
if(this==null){throw new TypeError('"this" is null or not defined');}var o=Object(this);// 2. Let len be ? ToLength(? Get(O, "length")).
var len=o.length>>>0;// 3. If IsCallable(predicate) is false, throw a TypeError exception.
if(typeof predicate!=='function'){throw new TypeError('predicate must be a function');}// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
var thisArg=arguments[1];// 5. Let k be 0.
var k=0;// 6. Repeat, while k < len
while(k<len){// a. Let Pk be ! ToString(k).
// b. Let kValue be ? Get(O, Pk).
// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
// d. If testResult is true, return kValue.
var kValue=o[k];if(predicate.call(thisArg,kValue,k,o)){return kValue;}// e. Increase k by 1.
k++;}// 7. Return undefined.
return undefined;},configurable:true,writable:true});}// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
if(!Array.prototype.findIndex){Object.defineProperty(Array.prototype,'findIndex',{value:function value(predicate){// 1. Let O be ? ToObject(this value).
if(this==null){throw new TypeError('"this" is null or not defined');}var o=Object(this);// 2. Let len be ? ToLength(? Get(O, "length")).
var len=o.length>>>0;// 3. If IsCallable(predicate) is false, throw a TypeError exception.
if(typeof predicate!=='function'){throw new TypeError('predicate must be a function');}// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
var thisArg=arguments[1];// 5. Let k be 0.
var k=0;// 6. Repeat, while k < len
while(k<len){// a. Let Pk be ! ToString(k).
// b. Let kValue be ? Get(O, Pk).
// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
// d. If testResult is true, return k.
var kValue=o[k];if(predicate.call(thisArg,kValue,k,o)){return k;}// e. Increase k by 1.
k++;}// 7. Return -1.
return-1;},configurable:true,writable:true});}Math.trunc=Math.trunc||function(x){return x<0?Math.ceil(x):Math.floor(x);};// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: http://es5.github.com/#x15.4.4.18
if(!Array.prototype.forEach){Array.prototype.forEach=function forEach(callback,thisArg){var T,k;if(this==null){throw new TypeError('this is null or not defined');}var kValue,// 1. Let O be the result of calling ToObject passing the |this| value as the argument.
O=Object(this),// 2. Let lenValue be the result of calling the Get internal method of O with the argument "length".
// 3. Let len be ToUint32(lenValue).
len=O.length>>>0;// Hack to convert O.length to a UInt32
// 4. If IsCallable(callback) is false, throw a TypeError exception.
// See: http://es5.github.com/#x9.11
if({}.toString.call(callback)!=='[object Function]'){throw new TypeError(callback+' is not a function');}// 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
if(arguments.length>=2){T=thisArg;}// 6. Let k be 0
k=0;// 7. Repeat, while k < len
while(k<len){// a. Let Pk be ToString(k).
//   This is implicit for LHS operands of the in operator
// b. Let kPresent be the result of calling the HasProperty internal method of O with argument Pk.
//   This step can be combined with c
// c. If kPresent is true, then
if(k in O){// i. Let kValue be the result of calling the Get internal method of O with argument Pk.
kValue=O[k];// ii. Call the Call internal method of callback with T as the this value and
// argument list containing kValue, k, and O.
callback.call(T,kValue,k,O);}// d. Increase k by 1.
k++;}// 8. return undefined
};}if(!Array.prototype.flat){Array.prototype.flat=function(depth){var flattend=[];(function flat(array,depth){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=array[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var el=_step.value;if(Array.isArray(el)&&depth>0){flat(el,depth-1);}else{flattend.push(el);}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}})(this,Math.floor(depth)||1);return flattend;};}

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(346);
var callBind = __webpack_require__(461);

var implementation = __webpack_require__(662);
var getPolyfill = __webpack_require__(665);
var shim = __webpack_require__(1128);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(661);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1123);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(661); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(1126);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(463);

var $TypeError = GetIntrinsic('%TypeError%');

// http://262.ecma-international.org/5.1/#sec-9.10

module.exports = function CheckObjectCoercible(value, optMessage) {
	if (value == null) {
		throw new $TypeError(optMessage || ('Cannot call method on ' + value));
	}
	return value;
};


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(665);
var define = __webpack_require__(346);

module.exports = function shimEntries() {
	var polyfill = getPolyfill();
	define(Object, { entries: polyfill }, {
		entries: function testEntries() {
			return Object.entries !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(346);
var callBind = __webpack_require__(461);

var implementation = __webpack_require__(666);
var getPolyfill = __webpack_require__(667);
var shim = __webpack_require__(1130);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(667);
var define = __webpack_require__(346);

module.exports = function shimValues() {
	var polyfill = getPolyfill();
	define(Object, { values: polyfill }, {
		values: function testValues() {
			return Object.values !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 1131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_Main__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_header_Header__ = __webpack_require__(3097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_loader_Loader__ = __webpack_require__(3104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_messages_Messages__ = __webpack_require__(3107);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_header_Header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_main_Main__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_shared_loader_Loader__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_shared_messages_Messages__["a" /* default */],null));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_css__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__client_login_Login__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_PrivateRoute__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__client_user_invitations_UserInvitationsContainer__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__client_user_invitations_SetPassword__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__admin_Admin__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__client_recover_RecoverPassword__ = __webpack_require__(3093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__client_recover_ResetPassword__ = __webpack_require__(3095);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Main=function(_Component){_inherits(Main,_Component);function Main(){_classCallCheck(this,Main);return _possibleConstructorReturn(this,(Main.__proto__||Object.getPrototypeOf(Main)).apply(this,arguments));}_createClass(Main,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Route */],{path:'/login',component:__WEBPACK_IMPORTED_MODULE_3__client_login_Login__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Route */],{path:'/set-password',component:__WEBPACK_IMPORTED_MODULE_6__client_user_invitations_SetPassword__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Route */],{path:'/recover-password',component:__WEBPACK_IMPORTED_MODULE_8__client_recover_RecoverPassword__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Route */],{path:'/reset-password',component:__WEBPACK_IMPORTED_MODULE_9__client_recover_ResetPassword__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_PrivateRoute__["a" /* PrivateRoute */],{path:'/admin',component:__WEBPACK_IMPORTED_MODULE_7__admin_Admin__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_PrivateRoute__["a" /* PrivateRoute */],{path:'/user-invitations',component:__WEBPACK_IMPORTED_MODULE_5__client_user_invitations_UserInvitationsContainer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Redirect */],{from:'/',to:'/admin'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Redirect */],{from:'/index.html',to:'/admin'})));}}]);return Main;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Main);

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(465);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(669);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(465);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(674);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(673);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(677);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(678);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(679);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(680);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(467);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(348);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(681);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Login */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Client_css__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Client_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Client_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Login_css__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Login_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Login_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__account_verified_png__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__account_verified_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__account_verified_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_errors_SimpleErrorList__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_authentication__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Login=function(_Component){_inherits(Login,_Component);function Login(){_classCallCheck(this,Login);var _this=_possibleConstructorReturn(this,(Login.__proto__||Object.getPrototypeOf(Login)).call(this));_this.handleEmailChange=function(event){_this.setState({email:event.target.value});};_this.handlePasswordChange=function(event){_this.setState({password:event.target.value});};_this.handleSubmit=function(event){event.preventDefault();_this.props.onSubmit(_this.state.email,_this.state.password);};_this.state={email:'',password:''};return _this;}_createClass(Login,[{key:'UNSAFE_componentWillReceiveProps',value:function UNSAFE_componentWillReceiveProps(nextProps){if(nextProps.errors.length>0){this.setState({password:''});}}},{key:'render',value:function render(){var params=__WEBPACK_IMPORTED_MODULE_5_query_string___default.a.parse(this.props.location.search);var onboarding=params.onboarding;var currentView=void 0;if(this.props.loggedIn){if(onboarding){currentView=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Redirect */],{to:{pathname:'/user-invitations'}});}else{var newLocation='/';if(this.props.location.state!==undefined&&this.props.location.state.hasOwnProperty('referrer')){// If a referrer location is defined un state, go to it
newLocation=this.props.location.state.referrer;}currentView=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Redirect */],{to:{pathname:newLocation}});}}else{currentView=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login client'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["k" /* Grid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:6,mdOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Log in to your account')))),onboarding?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:6,mdOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subtitle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__account_verified_png___default.a,alt:'Account verified'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Account Verified')))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:6,mdOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormControl */],{type:'email',className:'input',value:this.state.email,placeholder:'Email',onChange:this.handleEmailChange,required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormControl */],{type:'password',className:'input',value:this.state.password,placeholder:'Password',onChange:this.handlePasswordChange,required:true}))),this.props.errors.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_errors_SimpleErrorList__["a" /* default */],{errors:this.props.errors})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',className:'btn-select btn-orange',value:'Log in'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:6,mdOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom-title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{to:'/recover-password'},'Forgot your password?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{target:'_blank',to:{pathname:"https://forms.clickup.com/f/86zjg-822/NRB5VVG05QA0QWA5V1"}},'Support')))))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,currentView);}}]);return Login;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Login.propTypes={loggedIn:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,errors:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string),onSubmit:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(function(state){return{loggedIn:state.auth.loggedIn,errors:state.auth.errors};},function(dispatch){return{onSubmit:function onSubmit(email,password){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_authentication__["g" /* authenticationRequest */])(email,password));}};})(Login));

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelGroup__ = __webpack_require__(692);





var Accordion =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Accordion, _React$Component);

  function Accordion() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Accordion.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PanelGroup__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, this.props, {
      accordion: true
    }), this.props.children);
  };

  return Accordion;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Accordion);

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(111);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1153) });


/***/ }),
/* 1152 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(172);
var getKeys = __webpack_require__(246);
var gOPS = __webpack_require__(476);
var pIE = __webpack_require__(294);
var toObject = __webpack_require__(247);
var IObject = __webpack_require__(687);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(219)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(221);
var toLength = __webpack_require__(688);
var toAbsoluteIndex = __webpack_require__(1155);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(472);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(689);

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(111);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(477) });


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(195);
var anObject = __webpack_require__(244);
var getKeys = __webpack_require__(246);

module.exports = __webpack_require__(172) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(171).document;
module.exports = document && document.documentElement;


/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_set_prototype_of__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_set_prototype_of__);

function _setPrototypeOf(o, p) {
  _setPrototypeOf = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_set_prototype_of___default.a || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(690);

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(111);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1163).set });


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(245);
var anObject = __webpack_require__(244);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(469)(Function.call, __webpack_require__(691).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1165);

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1166);
module.exports = __webpack_require__(77).Object.keys;


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(247);
var $keys = __webpack_require__(246);

__webpack_require__(693)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.uncontrolledPropTypes = uncontrolledPropTypes;
exports.isProp = isProp;
exports.defaultKey = defaultKey;
exports.isReactComponent = isReactComponent;

var _invariant = _interopRequireDefault(__webpack_require__(56));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, displayName) {
  var propTypes = {};
  Object.keys(controlledValues).forEach(function (prop) {
    // add default propTypes for folks that use runtime checks
    propTypes[defaultKey(prop)] = noop;

    if (false) {
      var handler = controlledValues[prop];
      !(typeof handler === 'string' && handler.trim().length) ? process.env.NODE_ENV !== "production" ? (0, _invariant.default)(false, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop) : invariant(false) : void 0;
      propTypes[prop] = readOnlyPropType(handler, displayName);
    }
  });
  return propTypes;
}

function isProp(props, prop) {
  return props[prop] !== undefined;
}

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */


function isReactComponent(component) {
  return !!(component && component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1169);
module.exports = __webpack_require__(77).Object.entries;


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(111);
var $entries = __webpack_require__(695)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CloseButton__ = __webpack_require__(478);










var propTypes = {
  onDismiss: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  closeLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
var defaultProps = {
  closeLabel: 'Close alert'
};

var Alert =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Alert, _React$Component);

  function Alert() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Alert.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        onDismiss = _this$props.onDismiss,
        closeLabel = _this$props.closeLabel,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["onDismiss", "closeLabel", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var dismissable = !!onDismiss;

    var classes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'dismissable')] = dismissable, _extends2));

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "alert",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }), dismissable && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CloseButton__["a" /* default */], {
      onClick: onDismiss,
      label: closeLabel
    }), children);
  };

  return Alert;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["d" /* State */]), __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["d" /* State */].INFO, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('alert', Alert)));

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1172);
module.exports = __webpack_require__(77).Object.values;


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(111);
var $values = __webpack_require__(695)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);






 // TODO: `pullRight` doesn't belong here. There's no special handling here.

var propTypes = {
  pullRight: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  pullRight: false
};

var Badge =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Badge, _React$Component);

  function Badge() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Badge.prototype;

  _proto.hasContent = function hasContent(children) {
    var result = false;
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });
    return result;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        pullRight = _this$props.pullRight,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["pullRight", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      'pull-right': pullRight,
      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), children);
  };

  return Badge;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Badge.propTypes = propTypes;
Badge.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('badge', Badge));

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BreadcrumbItem__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);








var Breadcrumb =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Breadcrumb, _React$Component);

  function Breadcrumb() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Breadcrumb.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ol", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "navigation",
      "aria-label": "breadcrumbs",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Breadcrumb;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Breadcrumb.Item = __WEBPACK_IMPORTED_MODULE_5__BreadcrumbItem__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('breadcrumb', Breadcrumb));

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(16);







var ButtonToolbar =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ButtonToolbar, _React$Component);

  function ButtonToolbar() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ButtonToolbar.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "toolbar",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ButtonToolbar;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('btn-toolbar', ButtonToolbar));

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CarouselCaption__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CarouselItem__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Glyphicon__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SafeAnchor__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__ = __webpack_require__(103);












 // TODO: `slide` should be `animate`.
// TODO: Use uncontrollable.

var propTypes = {
  slide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  indicators: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * The amount of time to delay between automatically cycling an item.
   * If `null`, carousel will not automatically cycle.
   */
  interval: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  controls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  pauseOnHover: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  wrap: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Callback fired when the active item changes.
   *
   * ```js
   * (eventKey: any, ?event: Object) => any
   * ```
   *
   * If this callback takes two or more arguments, the second argument will
   * be a persisted event object with `direction` set to the direction of the
   * transition.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSlideEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  activeIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  defaultActiveIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  direction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['prev', 'next']),
  prevIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,

  /**
   * Label shown to screen readers only, can be used to show the previous element
   * in the carousel.
   * Set to null to deactivate.
   */
  prevLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  nextIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,

  /**
   * Label shown to screen readers only, can be used to show the next element
   * in the carousel.
   * Set to null to deactivate.
   */
  nextLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
var defaultProps = {
  slide: true,
  interval: 5000,
  pauseOnHover: true,
  wrap: true,
  indicators: true,
  controls: true,
  prevIcon: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Glyphicon__["a" /* default */], {
    glyph: "chevron-left"
  }),
  prevLabel: 'Previous',
  nextIcon: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Glyphicon__["a" /* default */], {
    glyph: "chevron-right"
  }),
  nextLabel: 'Next'
};

var Carousel =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Carousel, _React$Component);

  function Carousel(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleMouseOver = _this.handleMouseOver.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleMouseOut = _this.handleMouseOut.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handlePrev = _this.handlePrev.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleNext = _this.handleNext.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    var defaultActiveIndex = props.defaultActiveIndex;
    _this.state = {
      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
      previousActiveIndex: null,
      direction: null
    };
    _this.isUnmounted = false;
    return _this;
  }

  var _proto = Carousel.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.waitForNext();
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var activeIndex = this.getActiveIndex();

    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
      clearTimeout(this.timeout);
      this.setState({
        previousActiveIndex: activeIndex,
        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
      });
    }

    if (nextProps.activeIndex == null && this.state.activeIndex >= nextProps.children.length) {
      this.setState({
        activeIndex: 0,
        previousActiveIndex: null,
        direction: null
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeout);
    this.isUnmounted = true;
  };

  _proto.getActiveIndex = function getActiveIndex() {
    var activeIndexProp = this.props.activeIndex;
    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
  };

  _proto.getDirection = function getDirection(prevIndex, index) {
    if (prevIndex === index) {
      return null;
    }

    return prevIndex > index ? 'prev' : 'next';
  };

  _proto.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
    var _this2 = this;

    this.setState({
      previousActiveIndex: null,
      direction: null
    }, function () {
      _this2.waitForNext();

      if (_this2.props.onSlideEnd) {
        _this2.props.onSlideEnd();
      }
    });
  };

  _proto.handleMouseOut = function handleMouseOut() {
    if (this.isPaused) {
      this.play();
    }
  };

  _proto.handleMouseOver = function handleMouseOver() {
    if (this.props.pauseOnHover) {
      this.pause();
    }
  };

  _proto.handleNext = function handleNext(e) {
    var index = this.getActiveIndex() + 1;
    var count = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].count(this.props.children);

    if (index > count - 1) {
      if (!this.props.wrap) {
        return;
      }

      index = 0;
    }

    this.select(index, e, 'next');
  };

  _proto.handlePrev = function handlePrev(e) {
    var index = this.getActiveIndex() - 1;

    if (index < 0) {
      if (!this.props.wrap) {
        return;
      }

      index = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].count(this.props.children) - 1;
    }

    this.select(index, e, 'prev');
  }; // This might be a public API.


  _proto.pause = function pause() {
    this.isPaused = true;
    clearTimeout(this.timeout);
  }; // This might be a public API.


  _proto.play = function play() {
    this.isPaused = false;
    this.waitForNext();
  };

  _proto.select = function select(index, e, direction) {
    clearTimeout(this.timeout); // TODO: Is this necessary? Seems like the only risk is if the component
    // unmounts while handleItemAnimateOutEnd fires.

    if (this.isUnmounted) {
      return;
    }

    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
    direction = direction || this.getDirection(previousActiveIndex, index);
    var onSelect = this.props.onSelect;

    if (onSelect) {
      if (onSelect.length > 1) {
        // React SyntheticEvents are pooled, so we need to remove this event
        // from the pool to add a custom property. To avoid unnecessarily
        // removing objects from the pool, only do this when the listener
        // actually wants the event.
        if (e) {
          e.persist();
          e.direction = direction;
        } else {
          e = {
            direction: direction
          };
        }

        onSelect(index, e);
      } else {
        onSelect(index);
      }
    }

    if (this.props.activeIndex == null && index !== previousActiveIndex) {
      if (this.state.previousActiveIndex != null) {
        // If currently animating don't activate the new index.
        // TODO: look into queueing this canceled call and
        // animating after the current animation has ended.
        return;
      }

      this.setState({
        activeIndex: index,
        previousActiveIndex: previousActiveIndex,
        direction: direction
      });
    }
  };

  _proto.waitForNext = function waitForNext() {
    var _this$props = this.props,
        slide = _this$props.slide,
        interval = _this$props.interval,
        activeIndexProp = _this$props.activeIndex;

    if (!this.isPaused && slide && interval && activeIndexProp == null) {
      this.timeout = setTimeout(this.handleNext, interval);
    }
  };

  _proto.renderControls = function renderControls(properties) {
    var wrap = properties.wrap,
        children = properties.children,
        activeIndex = properties.activeIndex,
        prevIcon = properties.prevIcon,
        nextIcon = properties.nextIcon,
        bsProps = properties.bsProps,
        prevLabel = properties.prevLabel,
        nextLabel = properties.nextLabel;
    var controlClassName = Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'control');
    var count = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].count(children);
    return [(wrap || activeIndex !== 0) && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SafeAnchor__["a" /* default */], {
      key: "prev",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(controlClassName, 'left'),
      onClick: this.handlePrev
    }, prevIcon, prevLabel && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
      className: "sr-only"
    }, prevLabel)), (wrap || activeIndex !== count - 1) && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SafeAnchor__["a" /* default */], {
      key: "next",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(controlClassName, 'right'),
      onClick: this.handleNext
    }, nextIcon, nextLabel && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
      className: "sr-only"
    }, nextLabel))];
  };

  _proto.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
    var _this3 = this;

    var indicators = [];
    __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child, index) {
      indicators.push(__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
        key: index,
        className: index === activeIndex ? 'active' : null,
        onClick: function onClick(e) {
          return _this3.select(index, e);
        }
      }), // Force whitespace between indicator elements. Bootstrap requires
      // this for correct spacing of elements.
      ' ');
    });
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("ol", {
      className: Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'indicators')
    }, indicators);
  };

  _proto.render = function render() {
    var _this4 = this;

    var _this$props2 = this.props,
        slide = _this$props2.slide,
        indicators = _this$props2.indicators,
        controls = _this$props2.controls,
        wrap = _this$props2.wrap,
        prevIcon = _this$props2.prevIcon,
        prevLabel = _this$props2.prevLabel,
        nextIcon = _this$props2.nextIcon,
        nextLabel = _this$props2.nextLabel,
        className = _this$props2.className,
        children = _this$props2.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["slide", "indicators", "controls", "wrap", "prevIcon", "prevLabel", "nextIcon", "nextLabel", "className", "children"]);

    var _this$state = this.state,
        previousActiveIndex = _this$state.previousActiveIndex,
        direction = _this$state.direction;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
    'defaultActiveIndex', 'direction']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var activeIndex = this.getActiveIndex();

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      slide: slide
    });

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes),
      onMouseOver: this.handleMouseOver,
      onMouseOut: this.handleMouseOut
    }), indicators && this.renderIndicators(children, activeIndex, bsProps), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inner')
    }, __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].map(children, function (child, index) {
      var active = index === activeIndex;
      var previousActive = slide && index === previousActiveIndex;
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, {
        active: active,
        index: index,
        animateOut: previousActive,
        animateIn: active && previousActiveIndex != null && slide,
        direction: direction,
        onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
      });
    })), controls && this.renderControls({
      wrap: wrap,
      children: children,
      activeIndex: activeIndex,
      prevIcon: prevIcon,
      prevLabel: prevLabel,
      nextIcon: nextIcon,
      nextLabel: nextLabel,
      bsProps: bsProps
    }));
  };

  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;
Carousel.Caption = __WEBPACK_IMPORTED_MODULE_7__CarouselCaption__["a" /* default */];
Carousel.Item = __WEBPACK_IMPORTED_MODULE_8__CarouselItem__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["a" /* bsClass */])('carousel', Carousel));

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var CarouselCaption =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(CarouselCaption, _React$Component);

  function CarouselCaption() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CarouselCaption.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return CarouselCaption;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

CarouselCaption.propTypes = propTypes;
CarouselCaption.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('carousel-caption', CarouselCaption));

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = void 0;

var _end = _interopRequireDefault(__webpack_require__(1180));

exports.end = _end.default;

var _properties = _interopRequireDefault(__webpack_require__(480));

exports.properties = _properties.default;
var _default = {
  end: _end.default,
  properties: _properties.default
};
exports.default = _default;

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = void 0;

var _properties = _interopRequireDefault(__webpack_require__(480));

var _style = _interopRequireDefault(__webpack_require__(297));

function onEnd(node, handler, duration) {
  var fakeEvent = {
    target: node,
    currentTarget: node
  },
      backup;
  if (!_properties.default.end) duration = 0;else if (duration == null) duration = parseDuration(node) || 0;

  if (_properties.default.end) {
    node.addEventListener(_properties.default.end, done, false);
    backup = setTimeout(function () {
      return done(fakeEvent);
    }, (duration || 100) * 1.5);
  } else setTimeout(done.bind(null, fakeEvent), 0);

  function done(event) {
    if (event.target !== event.currentTarget) return;
    clearTimeout(backup);
    event.target.removeEventListener(_properties.default.end, done);
    handler.call(this);
  }
}

onEnd._parseDuration = parseDuration;
var _default = onEnd;
exports.default = _default;

function parseDuration(node) {
  var str = (0, _style.default)(node, _properties.default.duration),
      mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

module.exports = exports["default"];

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(1183));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(699));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);




/* eslint-disable jsx-a11y/label-has-for */





var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Checkbox inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Checkbox, _React$Component);

  function Checkbox() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Checkbox.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        inline = _this$props.inline,
        disabled = _this$props.disabled,
        validationState = _this$props.validationState,
        inputRef = _this$props.inputRef,
        className = _this$props.className,
        style = _this$props.style,
        title = _this$props.title,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["inline", "disabled", "validationState", "inputRef", "className", "style", "title", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      ref: inputRef,
      type: "checkbox",
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2); // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.


       false ? warning(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, _classes),
        style: style,
        title: title
      }, input, children);
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      disabled: disabled
    });

    if (validationState) {
      classes["has-" + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", {
      title: title
    }, input, children));
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('checkbox', Checkbox));

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(87);










var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a,

  /**
   * Apply clearfix
   *
   * on Extra small devices Phones
   *
   * adds class `visible-xs-block`
   */
  visibleXsBlock: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Apply clearfix
   *
   * on Small devices Tablets
   *
   * adds class `visible-sm-block`
   */
  visibleSmBlock: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Apply clearfix
   *
   * on Medium devices Desktops
   *
   * adds class `visible-md-block`
   */
  visibleMdBlock: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Apply clearfix
   *
   * on Large devices Desktops
   *
   * adds class `visible-lg-block`
   */
  visibleLgBlock: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  componentClass: 'div'
};

var Clearfix =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Clearfix, _React$Component);

  function Clearfix() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Clearfix.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["a" /* DEVICE_SIZES */].forEach(function (size) {
      var propName = "visible" + Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size) + "Block";

      if (elementProps[propName]) {
        classes["visible-" + size + "-block"] = true;
      }

      delete elementProps[propName];
    });
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Clearfix;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Clearfix.propTypes = propTypes;
Clearfix.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('clearfix', Clearfix));

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);








var propTypes = {
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  htmlFor: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  srOnly: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  srOnly: false
};
var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};

var ControlLabel =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ControlLabel, _React$Component);

  function ControlLabel() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ControlLabel.prototype;

  _proto.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _this$props = this.props,
        _this$props$htmlFor = _this$props.htmlFor,
        htmlFor = _this$props$htmlFor === void 0 ? controlId : _this$props$htmlFor,
        srOnly = _this$props.srOnly,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["htmlFor", "srOnly", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      'sr-only': srOnly
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      htmlFor: htmlFor,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ControlLabel;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ControlLabel.propTypes = propTypes;
ControlLabel.defaultProps = defaultProps;
ControlLabel.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('control-label', ControlLabel));

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(87);









var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a,

  /**
   * The number of columns you wish to span
   *
   * for Extra small devices Phones (<768px)
   *
   * class-prefix `col-xs-`
   */
  xs: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * The number of columns you wish to span
   *
   * for Small devices Tablets (≥768px)
   *
   * class-prefix `col-sm-`
   */
  sm: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * The number of columns you wish to span
   *
   * for Medium devices Desktops (≥992px)
   *
   * class-prefix `col-md-`
   */
  md: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * The number of columns you wish to span
   *
   * for Large devices Desktops (≥1200px)
   *
   * class-prefix `col-lg-`
   */
  lg: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Hide column
   *
   * on Extra small devices Phones
   *
   * adds class `hidden-xs`
   */
  xsHidden: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Hide column
   *
   * on Small devices Tablets
   *
   * adds class `hidden-sm`
   */
  smHidden: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Hide column
   *
   * on Medium devices Desktops
   *
   * adds class `hidden-md`
   */
  mdHidden: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Hide column
   *
   * on Large devices Desktops
   *
   * adds class `hidden-lg`
   */
  lgHidden: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Move columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-offset-`
   */
  xsOffset: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Move columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-offset-`
   */
  smOffset: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Move columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-offset-`
   */
  mdOffset: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Move columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-offset-`
   */
  lgOffset: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-push-`
   */
  xsPush: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-push-`
   */
  smPush: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-push-`
   */
  mdPush: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-push-`
   */
  lgPush: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-pull-`
   */
  xsPull: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-pull-`
   */
  smPull: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-pull-`
   */
  mdPull: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-pull-`
   */
  lgPull: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
};
var defaultProps = {
  componentClass: 'div'
};

var Col =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Col, _React$Component);

  function Col() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Col.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];
    __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["a" /* DEVICE_SIZES */].forEach(function (size) {
      function popProp(propSuffix, modifier) {
        var propName = "" + size + propSuffix;
        var propValue = elementProps[propName];

        if (propValue != null) {
          classes.push(Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, "" + size + modifier + "-" + propValue));
        }

        delete elementProps[propName];
      }

      popProp('', '');
      popProp('Offset', '-offset');
      popProp('Push', '-push');
      popProp('Pull', '-pull');
      var hiddenPropName = size + "Hidden";

      if (elementProps[hiddenPropName]) {
        classes.push("hidden-" + size);
      }

      delete elementProps[hiddenPropName];
    });
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Col;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Col.propTypes = propTypes;
Col.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('col', Col));

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1192);

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1193);
module.exports = __webpack_require__(77).parseInt;


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(111);
var $parseInt = __webpack_require__(1194);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(171).parseInt;
var $trim = __webpack_require__(1195).trim;
var ws = __webpack_require__(701);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(111);
var defined = __webpack_require__(349);
var fails = __webpack_require__(219);
var spaces = __webpack_require__(701);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_array_from__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_overlays_lib_RootCloseWrapper__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_overlays_lib_RootCloseWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_overlays_lib_RootCloseWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_createChainedFunction__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__ = __webpack_require__(103);














var propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  pullRight: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onClose: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  labelledBy: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['click', 'mousedown'])
};
var defaultProps = {
  bsRole: 'menu',
  pullRight: false
};

var DropdownMenu =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.handleRootClose = _this.handleRootClose.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = DropdownMenu.prototype;

  _proto.getFocusableMenuItems = function getFocusableMenuItems() {
    var node = __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(this);

    if (!node) {
      return [];
    }

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_array_from___default()(node.querySelectorAll('[tabIndex="-1"]'));
  };

  _proto.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
    var items = this.getFocusableMenuItems();
    var activeIndex = items.indexOf(document.activeElement);
    return {
      items: items,
      activeIndex: activeIndex
    };
  };

  _proto.focusNext = function focusNext() {
    var _this$getItemsAndActi = this.getItemsAndActiveIndex(),
        items = _this$getItemsAndActi.items,
        activeIndex = _this$getItemsAndActi.activeIndex;

    if (items.length === 0) {
      return;
    }

    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    items[nextIndex].focus();
  };

  _proto.focusPrevious = function focusPrevious() {
    var _this$getItemsAndActi2 = this.getItemsAndActiveIndex(),
        items = _this$getItemsAndActi2.items,
        activeIndex = _this$getItemsAndActi2.activeIndex;

    if (items.length === 0) {
      return;
    }

    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    items[prevIndex].focus();
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.down:
        this.focusNext();
        event.preventDefault();
        break;

      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.up:
        this.focusPrevious();
        event.preventDefault();
        break;

      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.tab:
        this.props.onClose(event, {
          source: 'keydown'
        });
        break;

      default:
    }
  };

  _proto.handleRootClose = function handleRootClose(event) {
    this.props.onClose(event, {
      source: 'rootClose'
    });
  };

  _proto.render = function render() {
    var _extends2,
        _this2 = this;

    var _this$props = this.props,
        open = _this$props.open,
        pullRight = _this$props.pullRight,
        labelledBy = _this$props.labelledBy,
        onSelect = _this$props.onSelect,
        className = _this$props.className,
        rootCloseEvent = _this$props.rootCloseEvent,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["open", "pullRight", "labelledBy", "onSelect", "className", "rootCloseEvent", "children"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['onClose']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'right')] = pullRight, _extends2));

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_overlays_lib_RootCloseWrapper___default.a, {
      disabled: !open,
      onRootClose: this.handleRootClose,
      event: rootCloseEvent
    }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "menu",
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
      "aria-labelledby": labelledBy
    }), __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(child, {
        onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_12__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, _this2.handleKeyDown),
        onSelect: Object(__WEBPACK_IMPORTED_MODULE_12__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
      });
    })));
  };

  return DropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["a" /* bsClass */])('dropdown-menu', DropdownMenu));

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(704);

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(472);
var defined = __webpack_require__(349);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(477);
var descriptor = __webpack_require__(293);
var setToStringTag = __webpack_require__(484);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(243)(IteratorPrototype, __webpack_require__(151)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(469);
var $export = __webpack_require__(111);
var toObject = __webpack_require__(247);
var call = __webpack_require__(1202);
var isArrayIter = __webpack_require__(1203);
var toLength = __webpack_require__(688);
var createProperty = __webpack_require__(1204);
var getIterFn = __webpack_require__(1205);

$export($export.S + $export.F * !__webpack_require__(1207)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(244);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(298);
var ITERATOR = __webpack_require__(151)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(195);
var createDesc = __webpack_require__(293);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(1206);
var ITERATOR = __webpack_require__(151)('iterator');
var Iterators = __webpack_require__(298);
module.exports = __webpack_require__(77).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(471);
var TAG = __webpack_require__(151)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(151)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Dropdown__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_splitComponentProps__ = __webpack_require__(356);








var propTypes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */].propTypes, {
  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  // Override generated docs from <Dropdown>.

  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node
});

var DropdownButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(DropdownButton, _React$Component);

  function DropdownButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DropdownButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        bsSize = _this$props.bsSize,
        bsStyle = _this$props.bsStyle,
        title = _this$props.title,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["bsSize", "bsStyle", "title", "children"]);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, dropdownProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */].Toggle, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, toggleProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), title), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */].Menu, null, children));
  };

  return DropdownButton;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DropdownButton.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (DropdownButton);

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);








var propTypes = {
  horizontal: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  horizontal: false,
  inline: false,
  componentClass: 'form'
};

var Form =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Form, _React$Component);

  function Form() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Form.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        horizontal = _this$props.horizontal,
        inline = _this$props.inline,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["horizontal", "inline", "componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];

    if (horizontal) {
      classes.push(Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'horizontal'));
    }

    if (inline) {
      classes.push(Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline'));
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Form;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('form', Form));

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormControlFeedback__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FormControlStatic__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(87);












var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a,

  /**
   * Only relevant if `componentClass` is `'input'`.
   */
  type: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  id: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <FormControl inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var defaultProps = {
  componentClass: 'input'
};
var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};

var FormControl =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(FormControl, _React$Component);

  function FormControl() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControl.prototype;

  _proto.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _this$props = this.props,
        Component = _this$props.componentClass,
        type = _this$props.type,
        _this$props$id = _this$props.id,
        id = _this$props$id === void 0 ? controlId : _this$props$id,
        inputRef = _this$props.inputRef,
        className = _this$props.className,
        bsSize = _this$props.bsSize,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "type", "id", "inputRef", "className", "bsSize"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0; // input[type="file"] should not have .form-control.

    var classes;

    if (type !== 'file') {
      classes = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    } // If user provides a size, make sure to append it to classes as input-
    // e.g. if bsSize is small, it will append input-sm


    if (bsSize) {
      var size = __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["b" /* SIZE_MAP */][bsSize] || bsSize;
      classes[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])({
        bsClass: 'input'
      }, size)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      type: type,
      id: id,
      ref: inputRef,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return FormControl;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

FormControl.propTypes = propTypes;
FormControl.defaultProps = defaultProps;
FormControl.contextTypes = contextTypes;
FormControl.Feedback = __WEBPACK_IMPORTED_MODULE_8__FormControlFeedback__["a" /* default */];
FormControl.Static = __WEBPACK_IMPORTED_MODULE_9__FormControlStatic__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('form-control', Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* Size */].LARGE], FormControl)));

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Glyphicon__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);








var defaultProps = {
  bsRole: 'feedback'
};
var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};

var FormControlFeedback =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(FormControlFeedback, _React$Component);

  function FormControlFeedback() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControlFeedback.prototype;

  _proto.getGlyph = function getGlyph(validationState) {
    switch (validationState) {
      case 'success':
        return 'ok';

      case 'warning':
        return 'warning-sign';

      case 'error':
        return 'remove';

      default:
        return null;
    }
  };

  _proto.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
    var glyph = this.getGlyph(formGroup && formGroup.validationState);

    if (!glyph) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Glyphicon__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      glyph: glyph,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (!children) {
      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
    }

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(child.props.className, className, classes)
    }));
  };

  return FormControlFeedback;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

FormControlFeedback.defaultProps = defaultProps;
FormControlFeedback.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('form-control-feedback', FormControlFeedback));

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'p'
};

var FormControlStatic =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(FormControlStatic, _React$Component);

  function FormControlStatic() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControlStatic.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return FormControlStatic;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

FormControlStatic.propTypes = propTypes;
FormControlStatic.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('form-control-static', FormControlStatic));

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(103);









var propTypes = {
  /**
   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
   */
  controlId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  validationState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['success', 'warning', 'error', null])
};
var childContextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};

var FormGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(FormGroup, _React$Component);

  function FormGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        controlId = _this$props.controlId,
        validationState = _this$props.validationState;
    return {
      $bs_formGroup: {
        controlId: controlId,
        validationState: validationState
      }
    };
  };

  _proto.hasFeedback = function hasFeedback(children) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
      return child.props.bsRole === 'feedback' || child.props.children && _this.hasFeedback(child.props.children);
    });
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        validationState = _this$props2.validationState,
        className = _this$props2.className,
        children = _this$props2.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["validationState", "className", "children"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['controlId']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      'has-feedback': this.hasFeedback(children)
    });

    if (validationState) {
      classes["has-" + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), children);
  };

  return FormGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

FormGroup.propTypes = propTypes;
FormGroup.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('form-group', Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["c" /* Size */].SMALL], FormGroup)));

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(16);







var HelpBlock =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(HelpBlock, _React$Component);

  function HelpBlock() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = HelpBlock.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return HelpBlock;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('help-block', HelpBlock));

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);







var propTypes = {
  /**
   * Sets image as responsive image
   */
  responsive: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Sets image shape as rounded
   */
  rounded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Sets image shape as circle
   */
  circle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Sets image shape as thumbnail
   */
  thumbnail: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  responsive: false,
  rounded: false,
  circle: false,
  thumbnail: false
};

var Image =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Image, _React$Component);

  function Image() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Image.prototype;

  _proto.render = function render() {
    var _classes;

    var _this$props = this.props,
        responsive = _this$props.responsive,
        rounded = _this$props.rounded,
        circle = _this$props.circle,
        thumbnail = _this$props.thumbnail,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["responsive", "rounded", "circle", "thumbnail", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (_classes = {}, _classes[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'responsive')] = responsive, _classes[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'rounded')] = rounded, _classes[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'circle')] = circle, _classes[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'thumbnail')] = thumbnail, _classes);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Image;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('img', Image));

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InputGroupAddon__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputGroupButton__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(87);










var InputGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(InputGroup, _React$Component);

  function InputGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return InputGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

InputGroup.Addon = __WEBPACK_IMPORTED_MODULE_5__InputGroupAddon__["a" /* default */];
InputGroup.Button = __WEBPACK_IMPORTED_MODULE_6__InputGroupButton__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('input-group', Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["c" /* Size */].SMALL], InputGroup)));

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(16);







var InputGroupAddon =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(InputGroupAddon, _React$Component);

  function InputGroupAddon() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroupAddon.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return InputGroupAddon;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('input-group-addon', InputGroupAddon));

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(16);







var InputGroupButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(InputGroupButton, _React$Component);

  function InputGroupButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroupButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return InputGroupButton;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('input-group-btn', InputGroupButton));

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var Jumbotron =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Jumbotron, _React$Component);

  function Jumbotron() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Jumbotron.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }));
  };

  return Jumbotron;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Jumbotron.propTypes = propTypes;
Jumbotron.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('jumbotron', Jumbotron));

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__ = __webpack_require__(87);









var Label =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Label, _React$Component);

  function Label() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Label.prototype;

  _proto.hasContent = function hasContent(children) {
    var result = false;
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });
    return result;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }), children);
  };

  return Label;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('label', Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["d" /* State */]).concat([__WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["e" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["e" /* Style */].DEFAULT, Label)));

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListGroupItem__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(103);









var propTypes = {
  /**
   * You can use a custom element type for this component.
   *
   * If not specified, it will be treated as `'li'` if every child is a
   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};

function getDefaultComponent(children) {
  if (!children) {
    // FIXME: This is the old behavior. Is this right?
    return 'div';
  }

  if (__WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
    return child.type !== __WEBPACK_IMPORTED_MODULE_6__ListGroupItem__["a" /* default */] || child.props.href || child.props.onClick;
  })) {
    return 'div';
  }

  return 'ul';
}

var ListGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ListGroup, _React$Component);

  function ListGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ListGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        _this$props$component = _this$props.componentClass,
        Component = _this$props$component === void 0 ? getDefaultComponent(children) : _this$props$component,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    var useListItem = Component === 'ul' && __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].every(children, function (child) {
      return child.type === __WEBPACK_IMPORTED_MODULE_6__ListGroupItem__["a" /* default */];
    });
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), useListItem ? __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(child, {
        listItem: true
      });
    }) : children);
  };

  return ListGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ListGroup.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('list-group', ListGroup));

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Media__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(16);









var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'middle', 'bottom']),
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var MediaBody =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MediaBody, _React$Component);

  function MediaBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        align = _this$props.align,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "align", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_7__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaBody;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MediaBody.propTypes = propTypes;
MediaBody.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('media-body', MediaBody));

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'h4'
};

var MediaHeading =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MediaHeading, _React$Component);

  function MediaHeading() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaHeading.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaHeading;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MediaHeading.propTypes = propTypes;
MediaHeading.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('media-heading', MediaHeading));

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Media__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);








var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaLeft =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MediaLeft, _React$Component);

  function MediaLeft() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaLeft.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        align = _this$props.align,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["align", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_6__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaLeft;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MediaLeft.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('media-left', MediaLeft));

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(16);







var MediaList =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MediaList, _React$Component);

  function MediaList() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaList.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaList;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('media-list', MediaList));

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(16);







var MediaListItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MediaListItem, _React$Component);

  function MediaListItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaListItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaListItem;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('media', MediaListItem));

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Media__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);








var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaRight =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MediaRight, _React$Component);

  function MediaRight() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaRight.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        align = _this$props.align,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["align", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-right-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_6__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaRight;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MediaRight.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('media-right', MediaRight));

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_all__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(75);











var propTypes = {
  /**
   * Highlight the menu item as active.
   */
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Disable the menu item, making it unselectable.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Styles the menu item as a horizontal rule, providing visual separation between
   * groups of menu items.
   */
  divider: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, function (_ref) {
    var divider = _ref.divider,
        children = _ref.children;
    return divider && children ? new Error('Children will not be rendered for dividers') : null;
  }),

  /**
   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * Styles the menu item as a header label, useful for describing a group of menu items.
   */
  header: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * HTML `href` attribute corresponding to `a.href`.
   */
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * Callback fired when the menu item is clicked.
   */
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Callback fired when the menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
var defaultProps = {
  divider: false,
  disabled: false,
  header: false
};

var MenuItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MenuItem, _React$Component);

  function MenuItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = MenuItem.prototype;

  _proto.handleClick = function handleClick(event) {
    var _this$props = this.props,
        href = _this$props.href,
        disabled = _this$props.disabled,
        onSelect = _this$props.onSelect,
        eventKey = _this$props.eventKey;

    if (!href || disabled) {
      event.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, event);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        active = _this$props2.active,
        disabled = _this$props2.disabled,
        divider = _this$props2.divider,
        header = _this$props2.header,
        onClick = _this$props2.onClick,
        className = _this$props2.className,
        style = _this$props2.style,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["active", "disabled", "divider", "header", "onClick", "className", "style"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['eventKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (divider) {
      // Forcibly blank out the children; separators shouldn't render any.
      elementProps.children = undefined;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
        role: "separator",
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'divider'),
        style: style
      }));
    }

    if (header) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
        role: "heading",
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'header')),
        style: style
      }));
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
      role: "presentation",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, {
        active: active,
        disabled: disabled
      }),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "menuitem",
      tabIndex: "-1",
      onClick: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
    })));
  };

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('dropdown', MenuItem));

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_events__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_ownerDocument__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_ownerDocument___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_ownerDocument__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_inDOM__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_inDOM___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_inDOM__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_utils_isOverflowing__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_utils_isOverflowing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_utils_isOverflowing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Fade__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ModalBody__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ModalDialog__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ModalFooter__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ModalHeader__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ModalTitle__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_createChainedFunction__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_splitComponentProps__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_StyleConfig__ = __webpack_require__(87);


























var propTypes = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a.propTypes, __WEBPACK_IMPORTED_MODULE_17__ModalDialog__["a" /* default */].propTypes, {
  /**
   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
   * trigger an "onHide" when clicked.
   */
  backdrop: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOf(['static', true, false]),

  /**
   * Add an optional extra class name to .modal-backdrop
   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
   */
  backdropClassName: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * Open and close the Modal with a slide and fade animation.
   */
  animation: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * A Component type that provides the modal content Markup. This is a useful
   * prop when you want to use your own styles and markup to create a custom
   * modal component.
   */
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_elementType___default.a,

  /**
   * When `true` The modal will automatically shift focus to itself when it
   * opens, and replace it to the last focused element when it closes.
   * Generally this should never be set to false as it makes the Modal less
   * accessible to assistive technologies, like screen-readers.
   */
  autoFocus: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while
   * open. Consider leaving the default value here, as it is necessary to make
   * the Modal work well with assistive technologies, such as screen readers.
   */
  enforceFocus: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * When `true` The modal will show itself.
   */
  show: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * A callback fired when the header closeButton or non-static backdrop is
   * clicked. Required if either are specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * @private
   */
  container: __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a.propTypes.container
});

var defaultProps = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a.defaultProps, {
  animation: true,
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_17__ModalDialog__["a" /* default */]
});

var childContextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func
  })
};
/* eslint-disable no-use-before-define, react/no-multi-comp */

function DialogTransition(props) {
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Fade__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
    timeout: Modal.TRANSITION_DURATION
  }));
}

function BackdropTransition(props) {
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Fade__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
    timeout: Modal.BACKDROP_TRANSITION_DURATION
  }));
}
/* eslint-enable no-use-before-define */


var Modal =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Modal, _React$Component);

  function Modal(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleEntering = _this.handleEntering.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleExited = _this.handleExited.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleWindowResize = _this.handleWindowResize.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleDialogClick = _this.handleDialogClick.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.setModalRef = _this.setModalRef.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.state = {
      style: {}
    };
    return _this;
  }

  var _proto = Modal.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      $bs_modal: {
        onHide: this.props.onHide
      }
    };
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    // Clean up the listener if we need to.
    this.handleExited();
  };

  _proto.setModalRef = function setModalRef(ref) {
    this._modal = ref;
  };

  _proto.handleDialogClick = function handleDialogClick(e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    this.props.onHide();
  };

  _proto.handleEntering = function handleEntering() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_5_dom_helpers_events___default.a.on(window, 'resize', this.handleWindowResize);
    this.updateStyle();
  };

  _proto.handleExited = function handleExited() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_5_dom_helpers_events___default.a.off(window, 'resize', this.handleWindowResize);
  };

  _proto.handleWindowResize = function handleWindowResize() {
    this.updateStyle();
  };

  _proto.updateStyle = function updateStyle() {
    if (!__WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_inDOM___default.a) {
      return;
    }

    var dialogNode = this._modal.getDialogElement();

    var dialogHeight = dialogNode.scrollHeight;
    var document = __WEBPACK_IMPORTED_MODULE_6_dom_helpers_ownerDocument___default()(dialogNode);
    var bodyIsOverflowing = __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_utils_isOverflowing___default()(__WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this.props.container || document.body));
    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
    this.setState({
      style: {
        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize___default()() : undefined,
        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize___default()() : undefined
      }
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        backdrop = _this$props.backdrop,
        backdropClassName = _this$props.backdropClassName,
        animation = _this$props.animation,
        show = _this$props.show,
        Dialog = _this$props.dialogComponentClass,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        onEntering = _this$props.onEntering,
        onExited = _this$props.onExited,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["backdrop", "backdropClassName", "animation", "show", "dialogComponentClass", "className", "style", "children", "onEntering", "onExited"]);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_23__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a),
        baseModalProps = _splitComponentProps[0],
        dialogProps = _splitComponentProps[1];

    var inClassName = show && !animation && 'in';
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, baseModalProps, {
      ref: this.setModalRef,
      show: show,
      containerClassName: Object(__WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__["e" /* prefix */])(props, 'open'),
      transition: animation ? DialogTransition : undefined,
      backdrop: backdrop,
      backdropTransition: animation ? BackdropTransition : undefined,
      backdropClassName: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__["e" /* prefix */])(props, 'backdrop'), backdropClassName, inClassName),
      onEntering: Object(__WEBPACK_IMPORTED_MODULE_22__utils_createChainedFunction__["a" /* default */])(onEntering, this.handleEntering),
      onExited: Object(__WEBPACK_IMPORTED_MODULE_22__utils_createChainedFunction__["a" /* default */])(onExited, this.handleExited)
    }), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Dialog, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, dialogProps, {
      style: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, this.state.style, style),
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, inClassName),
      onClick: backdrop === true ? this.handleDialogClick : null
    }), children));
  };

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.childContextTypes = childContextTypes;
Modal.Body = __WEBPACK_IMPORTED_MODULE_16__ModalBody__["a" /* default */];
Modal.Header = __WEBPACK_IMPORTED_MODULE_19__ModalHeader__["a" /* default */];
Modal.Title = __WEBPACK_IMPORTED_MODULE_20__ModalTitle__["a" /* default */];
Modal.Footer = __WEBPACK_IMPORTED_MODULE_18__ModalFooter__["a" /* default */];
Modal.Dialog = __WEBPACK_IMPORTED_MODULE_17__ModalDialog__["a" /* default */];
Modal.TRANSITION_DURATION = 300;
Modal.BACKDROP_TRANSITION_DURATION = 150;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__["a" /* bsClass */])('modal', Object(__WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_24__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_24__utils_StyleConfig__["c" /* Size */].SMALL], Modal)));

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = void 0;

var _on = _interopRequireDefault(__webpack_require__(485));

exports.on = _on.default;

var _off = _interopRequireDefault(__webpack_require__(486));

exports.off = _off.default;

var _filter = _interopRequireDefault(__webpack_require__(1231));

exports.filter = _filter.default;

var _listen = _interopRequireDefault(__webpack_require__(1233));

exports.listen = _listen.default;
var _default = {
  on: _on.default,
  off: _off.default,
  filter: _filter.default,
  listen: _listen.default
};
exports.default = _default;

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = filterEvents;

var _contains = _interopRequireDefault(__webpack_require__(250));

var _querySelectorAll = _interopRequireDefault(__webpack_require__(1232));

function filterEvents(selector, handler) {
  return function filterHandler(e) {
    var top = e.currentTarget,
        target = e.target,
        matches = (0, _querySelectorAll.default)(top, selector);
    if (matches.some(function (match) {
      return (0, _contains.default)(match, target);
    })) handler.call(this, e);
  };
}

module.exports = exports["default"];

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);

function qsa(element, selector) {
  var maybeID = selector[0] === '#',
      maybeClass = selector[0] === '.',
      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
      isSimple = simpleSelectorRE.test(nameOnly),
      found;

  if (isSimple) {
    if (maybeID) {
      element = element.getElementById ? element : document;
      return (found = element.getElementById(nameOnly)) ? [found] : [];
    }

    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
    return toArray(element.getElementsByTagName(selector));
  }

  return toArray(element.querySelectorAll(selector));
}

module.exports = exports["default"];

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(196));

var _on = _interopRequireDefault(__webpack_require__(485));

var _off = _interopRequireDefault(__webpack_require__(486));

var listen = function listen() {};

if (_inDOM.default) {
  listen = function listen(node, eventName, handler, capture) {
    (0, _on.default)(node, eventName, handler, capture);
    return function () {
      (0, _off.default)(node, eventName, handler, capture);
    };
  };
}

var _default = listen;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _activeElement = __webpack_require__(703);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _contains = __webpack_require__(250);

var _contains2 = _interopRequireDefault(_contains);

var _inDOM = __webpack_require__(196);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(359);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _deprecated = __webpack_require__(1235);

var _deprecated2 = _interopRequireDefault(_deprecated);

var _elementType = __webpack_require__(52);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(60);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _warning = __webpack_require__(105);

var _warning2 = _interopRequireDefault(_warning);

var _ModalManager = __webpack_require__(1237);

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _Portal = __webpack_require__(717);

var _Portal2 = _interopRequireDefault(_Portal);

var _RefHolder = __webpack_require__(1243);

var _RefHolder2 = _interopRequireDefault(_RefHolder);

var _addEventListener = __webpack_require__(710);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _addFocusListener = __webpack_require__(1244);

var _addFocusListener2 = _interopRequireDefault(_addFocusListener);

var _getContainer = __webpack_require__(361);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(251);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */

var modalManager = new _ModalManager2.default();

/**
 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
 * The Modal component renders its `children` node in front of a backdrop component.
 *
 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
 *
 * - Manages dialog stacking when one-at-a-time just isn't enough.
 * - Creates a backdrop, for disabling interaction below the modal.
 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
 * - It disables scrolling of the page content while open.
 * - Adds the appropriate ARIA roles are automatically.
 * - Easily pluggable animations via a `<Transition/>` component.
 *
 * Note that, in the same way the backdrop element prevents users from clicking or interacting
 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
 * interact with page content while the Modal is open. To do this, we use a common technique of applying
 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
 * React hierarchy (such as the default: document.body).
 */

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Modal.prototype.omitProps = function omitProps(props, propTypes) {

    var keys = Object.keys(props);
    var newProps = {};
    keys.map(function (prop) {
      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
        newProps[prop] = props[prop];
      }
    });

    return newProps;
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        show = _props.show,
        container = _props.container,
        children = _props.children,
        Transition = _props.transition,
        backdrop = _props.backdrop,
        className = _props.className,
        style = _props.style,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered;


    var dialog = _react2.default.Children.only(children);
    var filteredProps = this.omitProps(this.props, Modal.propTypes);

    var mountModal = show || Transition && !this.state.exited;
    if (!mountModal) {
      return null;
    }

    var _dialog$props = dialog.props,
        role = _dialog$props.role,
        tabIndex = _dialog$props.tabIndex;


    if (role === undefined || tabIndex === undefined) {
      dialog = (0, _react.cloneElement)(dialog, {
        role: role === undefined ? 'document' : role,
        tabIndex: tabIndex == null ? '-1' : tabIndex
      });
    }

    if (Transition) {
      dialog = _react2.default.createElement(
        Transition,
        {
          appear: true,
          unmountOnExit: true,
          'in': show,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.handleHidden,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        dialog
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      {
        ref: this.setMountNode,
        container: container,
        onRendered: this.onPortalRendered
      },
      _react2.default.createElement(
        'div',
        _extends({
          ref: this.setModalNodeRef,
          role: role || 'dialog'
        }, filteredProps, {
          style: style,
          className: className
        }),
        backdrop && this.renderBackdrop(),
        _react2.default.createElement(
          _RefHolder2.default,
          { ref: this.setDialogRef },
          dialog
        )
      )
    );
  };

  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!this.props.show && nextProps.show) {
      this.checkForFocus();
    }
  };

  Modal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    if (this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var transition = this.props.transition;


    if (prevProps.show && !this.props.show && !transition) {
      // Otherwise handleHidden will call this.
      this.onHide();
    } else if (!prevProps.show && this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        show = _props2.show,
        transition = _props2.transition;


    this._isMounted = false;

    if (show || transition && !this.state.exited) {
      this.onHide();
    }
  };

  Modal.prototype.autoFocus = function autoFocus() {
    if (!this.props.autoFocus) {
      return;
    }

    var dialogElement = this.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      this.lastFocus = currentActiveElement;

      if (!dialogElement.hasAttribute('tabIndex')) {
        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');

        dialogElement.setAttribute('tabIndex', -1);
      }

      dialogElement.focus();
    }
  };

  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
    if (this.lastFocus && this.lastFocus.focus) {
      this.lastFocus.focus();
      this.lastFocus = null;
    }
  };

  Modal.prototype.getDialogElement = function getDialogElement() {
    return _reactDom2.default.findDOMNode(this.dialog);
  };

  Modal.prototype.isTopModal = function isTopModal() {
    return this.props.manager.isTopModal(this);
  };

  return Modal;
}(_react2.default.Component);

Modal.propTypes = _extends({}, _Portal2.default.propTypes, {

  /**
   * Set the visibility of the Modal
   */
  show: _propTypes2.default.bool,

  /**
   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
   *
   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
   * page content can be placed behind a virtual backdrop as well as a visual one.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * A callback fired when the Modal is opening.
   */
  onShow: _propTypes2.default.func,

  /**
   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
   *
   * The `onHide` callback only signals intent from the Modal,
   * you must actually set the `show` prop to `false` for the Modal to close.
   */
  onHide: _propTypes2.default.func,

  /**
   * Include a backdrop component.
   */
  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),

  /**
   * A function that returns a backdrop component. Useful for custom
   * backdrop rendering.
   *
   * ```js
   *  renderBackdrop={props => <MyBackdrop {...props} />}
   * ```
   */
  renderBackdrop: _propTypes2.default.func,

  /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   */
  onEscapeKeyDown: _propTypes2.default.func,

  /**
   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   * @deprecated
   */
  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),

  /**
   * A callback fired when the backdrop, if specified, is clicked.
   */
  onBackdropClick: _propTypes2.default.func,

  /**
   * A style object for the backdrop component.
   */
  backdropStyle: _propTypes2.default.object,

  /**
   * A css class or classes for the backdrop component.
   */
  backdropClassName: _propTypes2.default.string,

  /**
   * A css class or set of classes applied to the modal container when the modal is open,
   * and removed when it is closed.
   */
  containerClassName: _propTypes2.default.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: _propTypes2.default.bool,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the dialog component.
   */
  transition: _elementType2.default,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the backdrop components.
   */
  backdropTransition: _elementType2.default,

  /**
   * When `true` The modal will automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes. This also
   * works correctly with any Modal children that have the `autoFocus` prop.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  autoFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  enforceFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: _propTypes2.default.bool,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: _propTypes2.default.func,

  /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */
  manager: _propTypes2.default.object.isRequired
});
Modal.defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  onHide: function onHide() {},
  manager: modalManager,
  renderBackdrop: function renderBackdrop(props) {
    return _react2.default.createElement('div', props);
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = { exited: !this.props.show };

  this.renderBackdrop = function () {
    var _props3 = _this2.props,
        backdropStyle = _props3.backdropStyle,
        backdropClassName = _props3.backdropClassName,
        renderBackdrop = _props3.renderBackdrop,
        Transition = _props3.backdropTransition;


    var backdropRef = function backdropRef(ref) {
      return _this2.backdrop = ref;
    };

    var backdrop = renderBackdrop({
      ref: backdropRef,
      style: backdropStyle,
      className: backdropClassName,
      onClick: _this2.handleBackdropClick
    });

    if (Transition) {
      backdrop = _react2.default.createElement(
        Transition,
        {
          appear: true,
          'in': _this2.props.show
        },
        backdrop
      );
    }

    return backdrop;
  };

  this.onPortalRendered = function () {
    _this2.autoFocus();

    if (_this2.props.onShow) {
      _this2.props.onShow();
    }
  };

  this.onShow = function () {
    var doc = (0, _ownerDocument2.default)(_this2);
    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);

    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);

    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);

    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);

    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
  };

  this.onHide = function () {
    _this2.props.manager.remove(_this2);

    _this2._onDocumentKeydownListener.remove();

    _this2._onDocumentKeyupListener.remove();

    _this2._onFocusinListener.remove();

    if (_this2.props.restoreFocus) {
      _this2.restoreLastFocus();
    }
  };

  this.setMountNode = function (ref) {
    _this2.mountNode = ref ? ref.getMountNode() : ref;
  };

  this.setModalNodeRef = function (ref) {
    _this2.modalNode = ref;
  };

  this.setDialogRef = function (ref) {
    _this2.dialog = ref;
  };

  this.handleHidden = function () {
    _this2.setState({ exited: true });
    _this2.onHide();

    if (_this2.props.onExited) {
      var _props4;

      (_props4 = _this2.props).onExited.apply(_props4, arguments);
    }
  };

  this.handleBackdropClick = function (e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    if (_this2.props.onBackdropClick) {
      _this2.props.onBackdropClick(e);
    }

    if (_this2.props.backdrop === true) {
      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyDown = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyDown) {
        _this2.props.onEscapeKeyDown(e);
      }

      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyUp = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyUp) {
        _this2.props.onEscapeKeyUp(e);
      }
    }
  };

  this.checkForFocus = function () {
    if (_inDOM2.default) {
      _this2.lastFocus = (0, _activeElement2.default)();
    }
  };

  this.enforceFocus = function () {
    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
      return;
    }

    var dialogElement = _this2.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      dialogElement.focus();
    }
  };
};

Modal.Manager = _ModalManager2.default;

exports.default = Modal;
module.exports = exports['default'];

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deprecated;

var _warning = __webpack_require__(1236);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function deprecated(validator, reason) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] != null) {
      var messageKey = componentName + '.' + propName;

      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));

      warned[messageKey] = true;
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}

/* eslint-disable no-underscore-dangle */
function _resetWarned() {
  warned = {};
}

deprecated._resetWarned = _resetWarned;
/* eslint-enable no-underscore-dangle */

module.exports = exports['default'];

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class = __webpack_require__(1238);

var _class2 = _interopRequireDefault(_class);

var _style = __webpack_require__(297);

var _style2 = _interopRequireDefault(_style);

var _scrollbarSize = __webpack_require__(714);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _isOverflowing = __webpack_require__(716);

var _isOverflowing2 = _interopRequireDefault(_isOverflowing);

var _manageAriaHidden = __webpack_require__(1241);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function findIndexOf(arr, cb) {
  var idx = -1;
  arr.some(function (d, i) {
    if (cb(d, i)) {
      idx = i;
      return true;
    }
  });
  return idx;
}

function findContainer(data, modal) {
  return findIndexOf(data, function (d) {
    return d.modals.indexOf(modal) !== -1;
  });
}

function setContainerStyle(state, container) {
  var style = { overflow: 'hidden' };

  // we are only interested in the actual `style` here
  // becasue we will override it
  state.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (state.overflowing) {
    // use computed style, here to get the real padding
    // to add our scrollbar width
    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
  }

  (0, _style2.default)(container, style);
}

function removeContainerStyle(_ref, container) {
  var style = _ref.style;


  Object.keys(style).forEach(function (key) {
    return container.style[key] = style[key];
  });
}
/**
 * Proper state managment for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */

var ModalManager = function ModalManager() {
  var _this = this;

  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
      _ref2$handleContainer = _ref2.handleContainerOverflow,
      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;

  _classCallCheck(this, ModalManager);

  this.add = function (modal, container, className) {
    var modalIdx = _this.modals.indexOf(modal);
    var containerIdx = _this.containers.indexOf(container);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = _this.modals.length;
    _this.modals.push(modal);

    if (_this.hideSiblingNodes) {
      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
    }

    if (containerIdx !== -1) {
      _this.data[containerIdx].modals.push(modal);
      return modalIdx;
    }

    var data = {
      modals: [modal],
      //right now only the first modal of a container will have its classes applied
      classes: className ? className.split(/\s+/) : [],

      overflowing: (0, _isOverflowing2.default)(container)
    };

    if (_this.handleContainerOverflow) {
      setContainerStyle(data, container);
    }

    data.classes.forEach(_class2.default.addClass.bind(null, container));

    _this.containers.push(container);
    _this.data.push(data);

    return modalIdx;
  };

  this.remove = function (modal) {
    var modalIdx = _this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return;
    }

    var containerIdx = findContainer(_this.data, modal);
    var data = _this.data[containerIdx];
    var container = _this.containers[containerIdx];

    data.modals.splice(data.modals.indexOf(modal), 1);

    _this.modals.splice(modalIdx, 1);

    // if that was the last modal in a container,
    // clean up the container
    if (data.modals.length === 0) {
      data.classes.forEach(_class2.default.removeClass.bind(null, container));

      if (_this.handleContainerOverflow) {
        removeContainerStyle(data, container);
      }

      if (_this.hideSiblingNodes) {
        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
      }
      _this.containers.splice(containerIdx, 1);
      _this.data.splice(containerIdx, 1);
    } else if (_this.hideSiblingNodes) {
      //otherwise make sure the next top modal is visible to a SR
      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
    }
  };

  this.isTopModal = function (modal) {
    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
  };

  this.hideSiblingNodes = hideSiblingNodes;
  this.handleContainerOverflow = handleContainerOverflow;
  this.modals = [];
  this.containers = [];
  this.data = [];
};

exports.default = ModalManager;
module.exports = exports['default'];

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = void 0;

var _addClass = _interopRequireDefault(__webpack_require__(1239));

exports.addClass = _addClass.default;

var _removeClass = _interopRequireDefault(__webpack_require__(1240));

exports.removeClass = _removeClass.default;

var _hasClass = _interopRequireDefault(__webpack_require__(715));

exports.hasClass = _hasClass.default;
var _default = {
  addClass: _addClass.default,
  removeClass: _removeClass.default,
  hasClass: _hasClass.default
};
exports.default = _default;

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(715));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;

var BLACKLIST = ['template', 'script', 'style'];

var isHidable = function isHidable(_ref) {
  var nodeType = _ref.nodeType,
      tagName = _ref.tagName;
  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};

var siblings = function siblings(container, mount, cb) {
  mount = [].concat(mount);

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      cb(node);
    }
  });
};

function ariaHidden(show, node) {
  if (!node) {
    return;
  }
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(359);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(60);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(361);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(251);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {
      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();

        var initialRender = !_this._overlayInstance;

        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
          if (initialRender && _this.props.onRendered) {
            _this.props.onRendered();
          }
        });
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._renderOverlay();
  };

  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
    this._renderOverlay();
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this._overlayTarget && nextProps.container !== this.props.container) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this._unrenderOverlay();
    this._unmountOverlayTarget();
  };

  Portal.prototype.render = function render() {
    return null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  children: _propTypes2.default.node
};

/**
 * Internal helper component to allow attaching a non-conflicting ref to a
 * child element that may not accept refs.
 */

var RefHolder = function (_React$Component) {
  _inherits(RefHolder, _React$Component);

  function RefHolder() {
    _classCallCheck(this, RefHolder);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  RefHolder.prototype.render = function render() {
    return this.props.children;
  };

  return RefHolder;
}(_react2.default.Component);

RefHolder.propTypes = propTypes;

exports.default = RefHolder;
module.exports = exports['default'];

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = addFocusListener;
/**
 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
 *
 * We only allow one Listener at a time to avoid stack overflows
 */
function addFocusListener(handler) {
  var useFocusin = !document.addEventListener;
  var remove = void 0;

  if (useFocusin) {
    document.attachEvent('onfocusin', handler);
    remove = function remove() {
      return document.detachEvent('onfocusin', handler);
    };
  } else {
    document.addEventListener('focus', handler, true);
    remove = function remove() {
      return document.removeEventListener('focus', handler, true);
    };
  }

  return { remove: remove };
}
module.exports = exports['default'];

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Grid__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavbarBrand__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NavbarCollapse__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NavbarHeader__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NavbarToggle__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_createChainedFunction__ = __webpack_require__(75);




// TODO: Remove this pragma once we upgrade eslint-config-airbnb.

/* eslint-disable react/no-multi-comp */













var propTypes = {
  /**
   * Create a fixed navbar along the top of the screen, that scrolls with the
   * page
   */
  fixedTop: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Create a fixed navbar along the bottom of the screen, that scrolls with
   * the page
   */
  fixedBottom: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Create a full-width navbar that scrolls away with the page
   */
  staticTop: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * An alternative dark visual style for the Navbar
   */
  inverse: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Allow the Navbar to fluidly adjust to the page or container width, instead
   * of at the predefined screen breakpoints
   */
  fluid: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Set a custom element for this component.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a,

  /**
   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
   * a `<Navbar.Toggle>` is clicked and called with the new `expanded`
   * boolean value.
   *
   * @controllable expanded
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * A callback fired when a descendant of a child `<Nav>` is selected. Should
   * be used to execute complex closing or other miscellaneous actions desired
   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
   * descendants exist. The callback is called with an eventKey, which is a
   * prop from the selected `<Nav>` descendant, and an event.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   *
   * For basic closing behavior after all `<Nav>` descendant onSelect events in
   * mobile viewports, try using collapseOnSelect.
   *
   * Note: If you are manually closing the navbar using this `OnSelect` prop,
   * ensure that you are setting `expanded` to false and not *toggling* between
   * true and false.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Sets `expanded` to `false` after the onSelect event of a descendant of a
   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
   *
   * The onSelect callback should be used instead for more complex operations
   * that need to be executed after the `select` event of `<Nav>` descendants.
   */
  collapseOnSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Explicitly set the visiblity of the navbar body
   *
   * @controllable onToggle
   */
  expanded: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
var defaultProps = {
  componentClass: 'nav',
  fixedTop: false,
  fixedBottom: false,
  staticTop: false,
  inverse: false,
  fluid: false,
  collapseOnSelect: false
};
var childContextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  })
};

var Navbar =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Navbar, _React$Component);

  function Navbar(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleToggle = _this.handleToggle.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleCollapse = _this.handleCollapse.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = Navbar.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        bsClass = _this$props.bsClass,
        expanded = _this$props.expanded,
        onSelect = _this$props.onSelect,
        collapseOnSelect = _this$props.collapseOnSelect;
    return {
      $bs_navbar: {
        bsClass: bsClass,
        expanded: expanded,
        onToggle: this.handleToggle,
        onSelect: Object(__WEBPACK_IMPORTED_MODULE_16__utils_createChainedFunction__["a" /* default */])(onSelect, collapseOnSelect ? this.handleCollapse : null)
      }
    };
  };

  _proto.handleCollapse = function handleCollapse() {
    var _this$props2 = this.props,
        onToggle = _this$props2.onToggle,
        expanded = _this$props2.expanded;

    if (expanded) {
      onToggle(false);
    }
  };

  _proto.handleToggle = function handleToggle() {
    var _this$props3 = this.props,
        onToggle = _this$props3.onToggle,
        expanded = _this$props3.expanded;
    onToggle(!expanded);
  };

  _proto.render = function render() {
    var _extends2;

    var _this$props4 = this.props,
        Component = _this$props4.componentClass,
        fixedTop = _this$props4.fixedTop,
        fixedBottom = _this$props4.fixedBottom,
        staticTop = _this$props4.staticTop,
        inverse = _this$props4.inverse,
        fluid = _this$props4.fluid,
        className = _this$props4.className,
        children = _this$props4.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props4, ["componentClass", "fixedTop", "fixedBottom", "staticTop", "inverse", "fluid", "className", "children"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1]; // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one


    if (elementProps.role === undefined && Component !== 'nav') {
      elementProps.role = 'navigation';
    }

    if (inverse) {
      bsProps.bsStyle = __WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__["e" /* Style */].INVERSE;
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'fixed-top')] = fixedTop, _extends2[Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'static-top')] = staticTop, _extends2));

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Grid__["a" /* default */], {
      fluid: fluid
    }, children));
  };

  return Navbar;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;
Navbar.childContextTypes = childContextTypes;
Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["a" /* bsClass */])('navbar', Navbar);
var UncontrollableNavbar = __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default()(Navbar, {
  expanded: 'onToggle'
});

function createSimpleWrapper(tag, suffix, displayName) {
  var Wrapper = function Wrapper(_ref, _ref2) {
    var Component = _ref.componentClass,
        className = _ref.className,
        pullRight = _ref.pullRight,
        pullLeft = _ref.pullLeft,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["componentClass", "className", "pullRight", "pullLeft"]);

    var _ref2$$bs_navbar = _ref2.$bs_navbar,
        navbarProps = _ref2$$bs_navbar === void 0 ? {
      bsClass: 'navbar'
    } : _ref2$$bs_navbar;
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, suffix), pullRight && Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'right'), pullLeft && Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'left'))
    }));
  };

  Wrapper.displayName = displayName;
  Wrapper.propTypes = {
    componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a,
    pullRight: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    pullLeft: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
  };
  Wrapper.defaultProps = {
    componentClass: tag,
    pullRight: false,
    pullLeft: false
  };
  Wrapper.contextTypes = {
    $bs_navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
      bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
    })
  };
  return Wrapper;
}

UncontrollableNavbar.Brand = __WEBPACK_IMPORTED_MODULE_10__NavbarBrand__["a" /* default */];
UncontrollableNavbar.Header = __WEBPACK_IMPORTED_MODULE_12__NavbarHeader__["a" /* default */];
UncontrollableNavbar.Toggle = __WEBPACK_IMPORTED_MODULE_13__NavbarToggle__["a" /* default */];
UncontrollableNavbar.Collapse = __WEBPACK_IMPORTED_MODULE_11__NavbarCollapse__["a" /* default */];
UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink'); // Set bsStyles here so they can be overridden.

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["c" /* bsStyles */])([__WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__["e" /* Style */].INVERSE], __WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__["e" /* Style */].DEFAULT, UncontrollableNavbar));

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Collapse__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);







var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
  })
};

var NavbarCollapse =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(NavbarCollapse, _React$Component);

  function NavbarCollapse() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarCollapse.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'collapse');
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Collapse__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      in: navbarProps.expanded
    }, props), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
      className: bsClassName
    }, children));
  };

  return NavbarCollapse;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

NavbarCollapse.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (NavbarCollapse);

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);







var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
  })
};

var NavbarHeader =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(NavbarHeader, _React$Component);

  function NavbarHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarHeader.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'header');
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsClassName)
    }));
  };

  return NavbarHeader;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavbarHeader.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (NavbarHeader);

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__ = __webpack_require__(75);








var propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * The toggle content, if left empty it will render the default toggle (seen above).
   */
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node
};
var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
  })
};

var NavbarToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(NavbarToggle, _React$Component);

  function NavbarToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarToggle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        onClick = _this$props.onClick,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["onClick", "className", "children"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };

    var buttonProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      type: 'button'
    }, props, {
      onClick: Object(__WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__["a" /* default */])(onClick, navbarProps.onToggle),
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
    });

    if (children) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("button", buttonProps, children);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("button", buttonProps, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "sr-only"
    }, "Toggle navigation"), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "icon-bar"
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "icon-bar"
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "icon-bar"
    }));
  };

  return NavbarToggle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavbarToggle.propTypes = propTypes;
NavbarToggle.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (NavbarToggle);

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Dropdown__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_splitComponentProps__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(103);










var propTypes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].propTypes, {
  // Toggle props.
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  activeHref: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  // Override generated docs from <Dropdown>.

  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node
});

var NavDropdown =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(NavDropdown, _React$Component);

  function NavDropdown() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavDropdown.prototype;

  _proto.isActive = function isActive(_ref, activeKey, activeHref) {
    var _this = this;

    var props = _ref.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    if (__WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
      return _this.isActive(child, activeKey, activeHref);
    })) {
      return true;
    }

    return props.active;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        title = _this$props.title,
        activeKey = _this$props.activeKey,
        activeHref = _this$props.activeHref,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["title", "activeKey", "activeHref", "className", "style", "children"]);

    var active = this.isActive(this, activeKey, activeHref);
    delete props.active; // Accessed via this.isActive().

    delete props.eventKey; // Accessed via this.isActive().

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1]; // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
    // rather than the `<Dropdown.Toggle>`.


    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, dropdownProps, {
      componentClass: "li",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, {
        active: active
      }),
      style: style
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].Toggle, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, toggleProps, {
      useAnchor: true
    }), title), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].Menu, null, __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, {
        active: _this2.isActive(child, activeKey, activeHref)
      });
    })));
  };

  return NavDropdown;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavDropdown.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (NavDropdown);

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(52);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Portal = __webpack_require__(717);

var _Portal2 = _interopRequireDefault(_Portal);

var _Position = __webpack_require__(1251);

var _Position2 = _interopRequireDefault(_Position);

var _RootCloseWrapper = __webpack_require__(709);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props, context) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleHidden = function () {
      _this.setState({ exited: true });

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.state = { exited: !props.show };
    _this.onHiddenListener = _this.handleHidden.bind(_this);
    return _this;
  }

  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Overlay.prototype.render = function render() {
    var _props = this.props,
        container = _props.container,
        containerPadding = _props.containerPadding,
        target = _props.target,
        placement = _props.placement,
        shouldUpdatePosition = _props.shouldUpdatePosition,
        rootClose = _props.rootClose,
        children = _props.children,
        Transition = _props.transition,
        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

    // Don't un-render the overlay while it's transitioning out.


    var mountOverlay = props.show || Transition && !this.state.exited;
    if (!mountOverlay) {
      // Don't bother showing anything if we don't have to.
      return null;
    }

    var child = children;

    // Position is be inner-most because it adds inline styles into the child,
    // which the other wrappers don't forward correctly.
    child = _react2.default.createElement(
      _Position2.default,
      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
      child
    );

    if (Transition) {
      var onExit = props.onExit,
          onExiting = props.onExiting,
          onEnter = props.onEnter,
          onEntering = props.onEntering,
          onEntered = props.onEntered;

      // This animates the child node by injecting props, so it must precede
      // anything that adds a wrapping div.

      child = _react2.default.createElement(
        Transition,
        {
          'in': props.show,
          appear: true,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.onHiddenListener,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        child
      );
    }

    // This goes after everything else because it adds a wrapping div.
    if (rootClose) {
      child = _react2.default.createElement(
        _RootCloseWrapper2.default,
        { onRootClose: props.onHide },
        child
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      { container: container },
      child
    );
  };

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes2.default.bool,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _propTypes2.default.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _propTypes2.default.func;
    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(undefined, [props].concat(args));
  },


  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */
  transition: _elementType2.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes2.default.func
});

exports.default = Overlay;
module.exports = exports['default'];

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(359);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(60);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _calculatePosition = __webpack_require__(1252);

var _calculatePosition2 = _interopRequireDefault(_calculatePosition);

var _getContainer = __webpack_require__(361);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(251);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.getTarget = function () {
      var target = _this.props.target;

      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
    };

    _this.maybeUpdatePosition = function (placementChanged) {
      var target = _this.getTarget();

      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
        return;
      }

      _this.updatePosition(target);
    };

    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null
    };

    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  Position.prototype.componentDidMount = function componentDidMount() {
    this.updatePosition(this.getTarget());
  };

  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needsFlush = true;
  };

  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this._needsFlush) {
      this._needsFlush = false;
      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
    }
  };

  Position.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['children', 'className']);

    var _state = this.state,
        positionLeft = _state.positionLeft,
        positionTop = _state.positionTop,
        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

    // These should not be forwarded to the child.


    delete props.target;
    delete props.container;
    delete props.containerPadding;
    delete props.shouldUpdatePosition;

    var child = _react2.default.Children.only(children);
    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
      // and `props.style`.
      positionLeft: positionLeft,
      positionTop: positionTop,
      className: (0, _classnames2.default)(className, child.props.className),
      style: _extends({}, child.props.style, {
        left: positionLeft,
        top: positionTop
      })
    }));
  };

  Position.prototype.updatePosition = function updatePosition(target) {
    this._lastTarget = target;

    if (!target) {
      this.setState({
        positionLeft: 0,
        positionTop: 0,
        arrowOffsetLeft: null,
        arrowOffsetTop: null
      });

      return;
    }

    var overlay = _reactDom2.default.findDOMNode(this);
    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);

    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
  };

  return Position;
}(_react2.default.Component);

Position.propTypes = {
  /**
   * A node, element, or function that returns either. The child will be
   * be positioned next to the `target` specified.
   */
  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * "offsetParent" of the component
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Minimum spacing in pixels between container border and component border
   */
  containerPadding: _propTypes2.default.number,
  /**
   * How to position the component relative to the target
   */
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether the position should be changed on each update
   */
  shouldUpdatePosition: _propTypes2.default.bool
};

Position.displayName = 'Position';

Position.defaultProps = {
  containerPadding: 0,
  placement: 'right',
  shouldUpdatePosition: false
};

exports.default = Position;
module.exports = exports['default'];

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = calculatePosition;

var _offset = __webpack_require__(727);

var _offset2 = _interopRequireDefault(_offset);

var _position = __webpack_require__(1253);

var _position2 = _interopRequireDefault(_position);

var _scrollTop = __webpack_require__(728);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _ownerDocument = __webpack_require__(251);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainerDimensions(containerNode) {
  var width = void 0,
      height = void 0,
      scroll = void 0;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;

    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
  } else {
    var _getOffset = (0, _offset2.default)(containerNode);

    width = _getOffset.width;
    height = _getOffset.height;

    scroll = (0, _scrollTop2.default)(containerNode);
  }

  return { width: width, height: height, scroll: scroll };
}

function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;

  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}

function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;

  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;

  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }

  return 0;
}

function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

  var _getOffset2 = (0, _offset2.default)(overlayNode),
      overlayHeight = _getOffset2.height,
      overlayWidth = _getOffset2.width;

  var positionLeft = void 0,
      positionTop = void 0,
      arrowOffsetLeft = void 0,
      arrowOffsetTop = void 0;

  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }

    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

    positionTop += topDelta;
    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }

    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);

    positionLeft += leftDelta;
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
  }

  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
}
module.exports = exports['default'];

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = position;

var _extends2 = _interopRequireDefault(__webpack_require__(252));

var _offset = _interopRequireDefault(__webpack_require__(727));

var _offsetParent = _interopRequireDefault(__webpack_require__(1254));

var _scrollTop = _interopRequireDefault(__webpack_require__(728));

var _scrollLeft = _interopRequireDefault(__webpack_require__(1255));

var _style = _interopRequireDefault(__webpack_require__(297));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = {
    top: 0,
    left: 0
  },
      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent

  if ((0, _style.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent.default)(node);
    offset = (0, _offset.default)(node);
    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
  } // Subtract parent offsets and node margins


  return (0, _extends2.default)({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
  });
}

module.exports = exports["default"];

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = offsetParent;

var _ownerDocument = _interopRequireDefault(__webpack_require__(249));

var _style = _interopRequireDefault(__webpack_require__(297));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}

module.exports = exports["default"];

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(360));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}

module.exports = exports["default"];

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_array_is_array__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_array_is_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_array_is_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Overlay__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(75);












/**
 * Check if value one is inside or equal to the of value
 *
 * @param {string} one
 * @param {string|array} of
 * @returns {boolean}
 */

function isOneOf(one, of) {
  if (__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_array_is_array___default()(of)) {
    return of.indexOf(one) >= 0;
  }

  return one === of;
}

var triggerType = __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['click', 'hover', 'focus']);

var propTypes = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */].propTypes, {
  /**
   * Specify which action or actions trigger Overlay visibility
   */
  trigger: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([triggerType, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(triggerType)]),

  /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */
  delay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  /**
   * A millisecond delay amount before showing the Overlay once triggered.
   */
  delayShow: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  /**
   * A millisecond delay amount before hiding the Overlay once triggered.
   */
  delayHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  // FIXME: This should be `defaultShow`.

  /**
   * The initial visibility state of the Overlay. For more nuanced visibility
   * control, consider using the Overlay component directly.
   */
  defaultOverlayShown: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * An element or text to overlay next to the target.
   */
  overlay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,

  /**
   * @private
   */
  onBlur: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * @private
   */
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * @private
   */
  onFocus: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * @private
   */
  onMouseOut: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * @private
   */
  onMouseOver: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  // Overridden props from `<Overlay>`.

  /**
   * @private
   */
  target: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null]),

  /**
   * @private
   */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null]),

  /**
   * @private
   */
  show: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null])
});

var defaultProps = {
  defaultOverlayShown: false,
  trigger: ['hover', 'focus']
};

var OverlayTrigger =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(OverlayTrigger, _React$Component);

  function OverlayTrigger(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleToggle = _this.handleToggle.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleDelayedShow = _this.handleDelayedShow.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleDelayedHide = _this.handleDelayedHide.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleHide = _this.handleHide.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));

    _this.handleMouseOver = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedShow, e, 'fromElement');
    };

    _this.handleMouseOut = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedHide, e, 'toElement');
    };

    _this._mountNode = null;
    _this.state = {
      show: props.defaultOverlayShown
    };
    return _this;
  }

  var _proto = OverlayTrigger.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._mountNode = document.createElement('div');
    this.renderOverlay();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.renderOverlay();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unmountComponentAtNode(this._mountNode);
    this._mountNode = null;
    clearTimeout(this._hoverShowDelay);
    clearTimeout(this._hoverHideDelay);
  };

  _proto.handleDelayedHide = function handleDelayedHide() {
    var _this2 = this;

    if (this._hoverShowDelay != null) {
      clearTimeout(this._hoverShowDelay);
      this._hoverShowDelay = null;
      return;
    }

    if (!this.state.show || this._hoverHideDelay != null) {
      return;
    }

    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;

    if (!delay) {
      this.hide();
      return;
    }

    this._hoverHideDelay = setTimeout(function () {
      _this2._hoverHideDelay = null;

      _this2.hide();
    }, delay);
  };

  _proto.handleDelayedShow = function handleDelayedShow() {
    var _this3 = this;

    if (this._hoverHideDelay != null) {
      clearTimeout(this._hoverHideDelay);
      this._hoverHideDelay = null;
      return;
    }

    if (this.state.show || this._hoverShowDelay != null) {
      return;
    }

    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;

    if (!delay) {
      this.show();
      return;
    }

    this._hoverShowDelay = setTimeout(function () {
      _this3._hoverShowDelay = null;

      _this3.show();
    }, delay);
  };

  _proto.handleHide = function handleHide() {
    this.hide();
  }; // Simple implementation of mouseEnter and mouseLeave.
  // React's built version is broken: https://github.com/facebook/react/issues/4251
  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
  // moving from one child element to another.


  _proto.handleMouseOverOut = function handleMouseOverOut(handler, e, relatedNative) {
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent[relatedNative];

    if ((!related || related !== target) && !__WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains___default()(target, related)) {
      handler(e);
    }
  };

  _proto.handleToggle = function handleToggle() {
    if (this.state.show) {
      this.hide();
    } else {
      this.show();
    }
  };

  _proto.hide = function hide() {
    this.setState({
      show: false
    });
  };

  _proto.makeOverlay = function makeOverlay(overlay, props) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      show: this.state.show,
      onHide: this.handleHide,
      target: this
    }), overlay);
  };

  _proto.show = function show() {
    this.setState({
      show: true
    });
  };

  _proto.renderOverlay = function renderOverlay() {
    __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        trigger = _this$props.trigger,
        overlay = _this$props.overlay,
        children = _this$props.children,
        onBlur = _this$props.onBlur,
        onClick = _this$props.onClick,
        onFocus = _this$props.onFocus,
        onMouseOut = _this$props.onMouseOut,
        onMouseOver = _this$props.onMouseOver,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["trigger", "overlay", "children", "onBlur", "onClick", "onFocus", "onMouseOut", "onMouseOver"]);

    delete props.delay;
    delete props.delayShow;
    delete props.delayHide;
    delete props.defaultOverlayShown;
    var child = __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.only(children);
    var childProps = child.props;
    var triggerProps = {};

    if (this.state.show) {
      triggerProps['aria-describedby'] = overlay.props.id;
    } // FIXME: The logic here for passing through handlers on this component is
    // inconsistent. We shouldn't be passing any of these props through.


    triggerProps.onClick = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onClick, onClick);

    if (isOneOf('click', trigger)) {
      triggerProps.onClick = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(triggerProps.onClick, this.handleToggle);
    }

    if (isOneOf('hover', trigger)) {
       false ? warning(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
      triggerProps.onMouseOver = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
      triggerProps.onMouseOut = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
    }

    if (isOneOf('focus', trigger)) {
      triggerProps.onFocus = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onFocus, onFocus, this.handleDelayedShow);
      triggerProps.onBlur = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onBlur, onBlur, this.handleDelayedHide);
    }

    this._overlay = this.makeOverlay(overlay, props);
    return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, triggerProps);
  };

  return OverlayTrigger;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

OverlayTrigger.propTypes = propTypes;
OverlayTrigger.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (OverlayTrigger);

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1258);

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1259);
module.exports = __webpack_require__(77).Array.isArray;


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(111);

$export($export.S, 'Array', { isArray: __webpack_require__(729) });


/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(16);







var PageHeader =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PageHeader, _React$Component);

  function PageHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PageHeader.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h1", null, children));
  };

  return PageHeader;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('page-header', PageHeader));

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PagerItem__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__ = __webpack_require__(1262);


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__["a" /* default */].wrapper(__WEBPACK_IMPORTED_MODULE_0__PagerItem__["a" /* default */], '`<PageItem>`', '`<Pager.Item>`'));

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_warning__);


var warned = {};

function deprecationWarning(oldname, newname, link) {
  var message;

  if (typeof oldname === 'object') {
    message = oldname.message;
  } else {
    message = oldname + " is deprecated. Use " + newname + " instead.";

    if (link) {
      message += "\nYou can read more about it at " + link;
    }
  }

  if (warned[message]) {
    return;
  }

   false ? warning(false, message) : void 0;
  warned[message] = true;
}

deprecationWarning.wrapper = function (Component) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return (
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(DeprecatedComponent, _Component);

      function DeprecatedComponent() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = DeprecatedComponent.prototype;

      _proto.componentWillMount = function componentWillMount() {
        deprecationWarning.apply(void 0, args);

        if (_Component.prototype.componentWillMount) {
          var _Component$prototype$;

          for (var _len2 = arguments.length, methodArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            methodArgs[_key2] = arguments[_key2];
          }

          (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
        }
      };

      return DeprecatedComponent;
    }(Component)
  );
};

/* harmony default export */ __webpack_exports__["a"] = (deprecationWarning);
function _resetWarned() {
  warned = {};
}

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PagerItem__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ValidComponentChildren__ = __webpack_require__(103);










var propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

var Pager =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Pager, _React$Component);

  function Pager() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Pager.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        onSelect = _this$props.onSelect,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["onSelect", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_9__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(child, {
        onSelect: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
      });
    }));
  };

  return Pager;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Pager.propTypes = propTypes;
Pager.Item = __WEBPACK_IMPORTED_MODULE_6__PagerItem__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('pager', Pager));

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaginationItem__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);








var Pagination =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Pagination, _React$Component);

  function Pagination() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Pagination.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), children);
  };

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('pagination', Pagination);
Pagination.First = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["b" /* First */];
Pagination.Prev = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["e" /* Prev */];
Pagination.Ellipsis = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["a" /* Ellipsis */];
Pagination.Item = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["f" /* default */];
Pagination.Next = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["d" /* Next */];
Pagination.Last = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["c" /* Last */];
/* harmony default export */ __webpack_exports__["a"] = (Pagination);

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = PaginationItem;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return First; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Prev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ellipsis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Next; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Last; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__ = __webpack_require__(138);




/* eslint-disable react/no-multi-comp */




var propTypes = {
  eventKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  activeLabel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired
};
var defaultProps = {
  active: false,
  disabled: false,
  activeLabel: '(current)'
};
function PaginationItem(_ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      className = _ref.className,
      style = _ref.style,
      activeLabel = _ref.activeLabel,
      children = _ref.children,
      props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["active", "disabled", "className", "style", "activeLabel", "children"]);

  var Component = active || disabled ? 'span' : __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__["a" /* default */];
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
    style: style,
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, {
      active: active,
      disabled: disabled
    })
  }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
    disabled: disabled
  }, props), children, active && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
    className: "sr-only"
  }, activeLabel)));
}
PaginationItem.propTypes = propTypes;
PaginationItem.defaultProps = defaultProps;

function createButton(name, defaultValue, label) {
  var _class, _temp;

  if (label === void 0) {
    label = name;
  }

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(_class, _React$Component);

    function _class() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = _class.prototype;

    _proto.render = function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          children = _this$props.children,
          className = _this$props.className,
          props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["disabled", "children", "className"]);

      var Component = disabled ? 'span' : __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__["a" /* default */];
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
        "aria-label": label,
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, {
          disabled: disabled
        })
      }, props), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, null, children || defaultValue));
    };

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component), _class.displayName = name, _class.propTypes = {
    disabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
  }, _temp;
}

var First = createButton('First', "\xAB");
var Prev = createButton('Prev', "\u2039");
var Ellipsis = createButton('Ellipsis', "\u2026", 'More');
var Next = createButton('Next', "\u203A");
var Last = createButton('Last', "\xBB");

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uncontrollable__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PanelBody__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PanelHeading__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PanelTitle__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PanelFooter__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PanelToggle__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PanelCollapse__ = __webpack_require__(731);

















var has = Object.prototype.hasOwnProperty;

var defaultGetId = function defaultGetId(id, type) {
  return id ? id + "--" + type : null;
};

var propTypes = {
  /**
   * Controls the collapsed/expanded state ofthe Panel. Requires
   * a `Panel.Collapse` or `<Panel.Body collapsible>` child component
   * in order to actually animate out or in.
   *
   * @controllable onToggle
   */
  expanded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * A callback fired when the collapse state changes.
   *
   * @controllable expanded
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,

  /**
   * An HTML `id` attribute uniquely identifying the Panel component.
   */
  id: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};
var contextTypes = {
  $bs_panelGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    getId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
    onToggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};
var childContextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    headingId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    bodyId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    bsClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    onToggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    expanded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
  })
};

var Panel =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Panel, _React$Component);

  function Panel() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleToggle = function (e) {
      var panelGroup = _this.context.$bs_panelGroup;
      var expanded = !_this.getExpanded();

      if (panelGroup && panelGroup.onToggle) {
        panelGroup.onToggle(_this.props.eventKey, expanded, e);
      } else {
        _this.props.onToggle(expanded, e);
      }
    };

    return _this;
  }

  var _proto = Panel.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        eventKey = _this$props.eventKey,
        id = _this$props.id;
    var idKey = eventKey == null ? id : eventKey;
    var ids;

    if (idKey !== null) {
      var panelGroup = this.context.$bs_panelGroup;
      var getId = panelGroup && panelGroup.getId || defaultGetId;
      ids = {
        headingId: getId(idKey, 'heading'),
        bodyId: getId(idKey, 'body')
      };
    }

    return {
      $bs_panel: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, ids, {
        bsClass: this.props.bsClass,
        expanded: this.getExpanded(),
        onToggle: this.handleToggle
      })
    };
  };

  _proto.getExpanded = function getExpanded() {
    var panelGroup = this.context.$bs_panelGroup;

    if (panelGroup && has.call(panelGroup, 'activeKey')) {
       false ? warning(this.props.expanded == null, 'Specifying `<Panel>` `expanded` in the context of an accordion ' + '`<PanelGroup>` is not supported. Set `activeKey` on the ' + '`<PanelGroup>` instead.') : void 0;
      return panelGroup.activeKey === this.props.eventKey;
    }

    return !!this.props.expanded;
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        className = _this$props2.className,
        children = _this$props2.children;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(this.props, ['onToggle', 'eventKey', 'expanded']),
        bsProps = _splitBsPropsAndOmit[0],
        props = _splitBsPropsAndOmit[1];

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps))
    }), children);
  };

  return Panel;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Panel.propTypes = propTypes;
Panel.contextTypes = contextTypes;
Panel.childContextTypes = childContextTypes;
var UncontrolledPanel = __WEBPACK_IMPORTED_MODULE_7_uncontrollable___default()(Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('panel', Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["d" /* State */]).concat([__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["e" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["e" /* Style */].DEFAULT, Panel)), {
  expanded: 'onToggle'
});

__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign___default()(UncontrolledPanel, {
  Heading: __WEBPACK_IMPORTED_MODULE_12__PanelHeading__["a" /* default */],
  Title: __WEBPACK_IMPORTED_MODULE_13__PanelTitle__["a" /* default */],
  Body: __WEBPACK_IMPORTED_MODULE_11__PanelBody__["a" /* default */],
  Footer: __WEBPACK_IMPORTED_MODULE_14__PanelFooter__["a" /* default */],
  Toggle: __WEBPACK_IMPORTED_MODULE_15__PanelToggle__["a" /* default */],
  Collapse: __WEBPACK_IMPORTED_MODULE_16__PanelCollapse__["a" /* default */]
});

/* unused harmony default export */ var _unused_webpack_default_export = (UncontrolledPanel);

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PanelCollapse__ = __webpack_require__(731);







var propTypes = {
  /**
   * A convenience prop that renders a Collapse component around the Body for
   * situations when the parent Panel only contains a single Panel.Body child.
   *
   * renders:
   * ```jsx
   * <Panel.Collapse>
   *  <Panel.Body />
   * </Panel.Collapse>
   * ```
   */
  collapsible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};
var defaultProps = {
  collapsible: false
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  })
};

var PanelBody =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelBody, _React$Component);

  function PanelBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        collapsible = _this$props.collapsible;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(this.props, ['collapsible']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;
    var body = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'body'))
    }), children);

    if (collapsible) {
      body = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PanelCollapse__["a" /* default */], null, body);
    }

    return body;
  };

  return PanelBody;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

PanelBody.propTypes = propTypes;
PanelBody.defaultProps = defaultProps;
PanelBody.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelBody));

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);








var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    headingId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    bsClass: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
  })
};

var PanelHeading =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelHeading, _React$Component);

  function PanelHeading() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelHeading.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        Component = _this$props.componentClass,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "className", "componentClass"]);

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        _bsClass = _ref.bsClass;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId) {
      elementProps.role = elementProps.role || 'tab';
      elementProps.id = headingId;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'heading'))
    }), children);
  };

  return PanelHeading;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

PanelHeading.propTypes = propTypes;
PanelHeading.defaultProps = defaultProps;
PanelHeading.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelHeading));

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PanelToggle__ = __webpack_require__(732);









var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default.a,

  /**
   * A convenience prop that renders the Panel.Title as a panel collapse toggle component
   * for the common use-case.
   */
  toggle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
  })
};
var defaultProps = {
  componentClass: 'div'
};

var PanelTitle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelTitle, _React$Component);

  function PanelTitle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelTitle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        toggle = _this$props.toggle,
        Component = _this$props.componentClass,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "className", "toggle", "componentClass"]);

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (toggle) {
      children = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PanelToggle__["a" /* default */], null, children);
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'title'))
    }), children);
  };

  return PanelTitle;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PanelTitle.propTypes = propTypes;
PanelTitle.defaultProps = defaultProps;
PanelTitle.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelTitle));

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(16);






var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  })
};

var PanelFooter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelFooter, _React$Component);

  function PanelFooter() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelFooter.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(this.props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'footer'))
    }), children);
  };

  return PanelFooter;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

PanelFooter.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelFooter));

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);








var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number])),

  /**
   * Sets the direction the Popover is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Popover.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "left" position value for the Popover.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "top" position value for the Popover arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "left" position value for the Popover arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * Title content
   */
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node
};
var defaultProps = {
  placement: 'right'
};

var Popover =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Popover, _React$Component);

  function Popover() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Popover.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        placement = _this$props.placement,
        positionTop = _this$props.positionTop,
        positionLeft = _this$props.positionLeft,
        arrowOffsetTop = _this$props.arrowOffsetTop,
        arrowOffsetLeft = _this$props.arrowOffsetLeft,
        title = _this$props.title,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["placement", "positionTop", "positionLeft", "arrowOffsetTop", "arrowOffsetLeft", "title", "className", "style", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      display: 'block',
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "tooltip",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes),
      style: outerStyle
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: "arrow",
      style: arrowStyle
    }), title && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h3", {
      className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'title')
    }, title), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content')
    }, children));
  };

  return Popover;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('popover', Popover));

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ValidComponentChildren__ = __webpack_require__(103);










var ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `<ProgressBar>`.
 */

function onlyProgressBar(props, propName, componentName) {
  var children = props[propName];

  if (!children) {
    return null;
  }

  var error = null;
  __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (child) {
    if (error) {
      return;
    }
    /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */


    var element = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ProgressBar, null);
    if (child.type === element.type) return;
    var childIdentifier = __WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
    error = new Error("Children of " + componentName + " can contain only ProgressBar " + ("components. Found " + childIdentifier + "."));
  });
  return error;
}

var propTypes = {
  min: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  now: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  label: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  srOnly: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: onlyProgressBar,

  /**
   * @private
   */
  isChild: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
var defaultProps = {
  min: 0,
  max: 100,
  active: false,
  isChild: false,
  srOnly: false,
  striped: false
};

function getPercentage(now, min, max) {
  var percentage = (now - min) / (max - min) * 100;
  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

var ProgressBar =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ProgressBar, _React$Component);

  function ProgressBar() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ProgressBar.prototype;

  _proto.renderProgressBar = function renderProgressBar(_ref) {
    var _extends2;

    var min = _ref.min,
        now = _ref.now,
        max = _ref.max,
        label = _ref.label,
        srOnly = _ref.srOnly,
        striped = _ref.striped,
        active = _ref.active,
        className = _ref.className,
        style = _ref.style,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["min", "now", "max", "label", "srOnly", "striped", "active", "className", "style"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {
      active: active
    }, _extends2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'striped')] = active || striped, _extends2));

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "progressbar",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes),
      style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
        width: getPercentage(now, min, max) + "%"
      }, style),
      "aria-valuenow": now,
      "aria-valuemin": min,
      "aria-valuemax": max
    }), srOnly ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
      className: "sr-only"
    }, label) : label);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        isChild = _this$props.isChild,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["isChild"]);

    if (isChild) {
      return this.renderProgressBar(props);
    }

    var min = props.min,
        now = props.now,
        max = props.max,
        label = props.label,
        srOnly = props.srOnly,
        striped = props.striped,
        active = props.active,
        bsClass = props.bsClass,
        bsStyle = props.bsStyle,
        className = props.className,
        children = props.children,
        wrapperProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["min", "now", "max", "label", "srOnly", "striped", "active", "bsClass", "bsStyle", "className", "children"]);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, wrapperProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'progress')
    }), children ? __WEBPACK_IMPORTED_MODULE_9__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, {
        isChild: true
      });
    }) : this.renderProgressBar({
      min: min,
      now: now,
      max: max,
      label: label,
      srOnly: srOnly,
      striped: striped,
      active: active,
      bsClass: bsClass,
      bsStyle: bsStyle
    }));
  };

  return ProgressBar;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

ProgressBar.propTypes = propTypes;
ProgressBar.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('progress-bar', Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["d" /* State */]), ProgressBar)));

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);




/* eslint-disable jsx-a11y/label-has-for */





var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Radio inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Radio =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Radio, _React$Component);

  function Radio() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Radio.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        inline = _this$props.inline,
        disabled = _this$props.disabled,
        validationState = _this$props.validationState,
        inputRef = _this$props.inputRef,
        className = _this$props.className,
        style = _this$props.style,
        title = _this$props.title,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["inline", "disabled", "validationState", "inputRef", "className", "style", "title", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      ref: inputRef,
      type: "radio",
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2); // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.


       false ? warning(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, _classes),
        style: style,
        title: title
      }, input, children);
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      disabled: disabled
    });

    if (validationState) {
      classes["has-" + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", {
      title: title
    }, input, children));
  };

  return Radio;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('radio', Radio));

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);







 // TODO: This should probably take a single `aspectRatio` prop.

var propTypes = {
  /**
   * This component requires a single child element
   */
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element.isRequired,

  /**
   * 16by9 aspect ratio
   */
  a16by9: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * 4by3 aspect ratio
   */
  a4by3: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  a16by9: false,
  a4by3: false
};

var ResponsiveEmbed =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ResponsiveEmbed, _React$Component);

  function ResponsiveEmbed() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ResponsiveEmbed.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        a16by9 = _this$props.a16by9,
        a4by3 = _this$props.a4by3,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["a16by9", "a4by3", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
     false ? warning(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '16by9')] = a16by9, _extends2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '4by3')] = a4by3, _extends2));

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(classes)
    }, Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'item'))
    })));
  };

  return ResponsiveEmbed;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ResponsiveEmbed.propTypes = propTypes;
ResponsiveEmbed.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('embed-responsive', ResponsiveEmbed));

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var Row =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Row, _React$Component);

  function Row() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Row.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Row;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('row', Row));

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Dropdown__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SplitToggle__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__ = __webpack_require__(356);










var propTypes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].propTypes, {
  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,

  /**
   * The content of the split button.
   */
  title: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node.isRequired,

  /**
   * Accessible label for the toggle; the value of `title` if not specified.
   */
  toggleLabel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  // Override generated docs from <Dropdown>.

  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node
});

var SplitButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(SplitButton, _React$Component);

  function SplitButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SplitButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        bsSize = _this$props.bsSize,
        bsStyle = _this$props.bsStyle,
        title = _this$props.title,
        toggleLabel = _this$props.toggleLabel,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["bsSize", "bsStyle", "title", "toggleLabel", "children"]);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        buttonProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, dropdownProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, buttonProps, {
      disabled: props.disabled,
      bsSize: bsSize,
      bsStyle: bsStyle
    }), title), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SplitToggle__["a" /* default */], {
      "aria-label": toggleLabel || title,
      bsSize: bsSize,
      bsStyle: bsStyle
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].Menu, null, children));
  };

  return SplitButton;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

SplitButton.propTypes = propTypes;
SplitButton.Toggle = __WEBPACK_IMPORTED_MODULE_7__SplitToggle__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (SplitButton);

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DropdownToggle__ = __webpack_require__(711);





var SplitToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(SplitToggle, _React$Component);

  function SplitToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SplitToggle.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DropdownToggle__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, this.props, {
      useAnchor: false,
      noCaret: false
    }));
  };

  return SplitToggle;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

SplitToggle.defaultProps = __WEBPACK_IMPORTED_MODULE_3__DropdownToggle__["a" /* default */].defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (SplitToggle);

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TabContainer__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TabContent__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TabPane__ = __webpack_require__(733);








var propTypes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6__TabPane__["a" /* default */].propTypes, {
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,

  /**
   * tabClassName is used as className for the associated NavItem
   */
  tabClassName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
});

var Tab =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Tab, _React$Component);

  function Tab() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tab.prototype;

  _proto.render = function render() {
    var props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, this.props); // These props are for the parent `<Tabs>` rather than the `<TabPane>`.


    delete props.title;
    delete props.disabled;
    delete props.tabClassName;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TabPane__["a" /* default */], props);
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Tab.propTypes = propTypes;
Tab.Container = __WEBPACK_IMPORTED_MODULE_4__TabContainer__["a" /* default */];
Tab.Content = __WEBPACK_IMPORTED_MODULE_5__TabContent__["a" /* default */];
Tab.Pane = __WEBPACK_IMPORTED_MODULE_6__TabPane__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Tab);

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(16);







var propTypes = {
  striped: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  bordered: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  condensed: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  bordered: false,
  condensed: false,
  hover: false,
  responsive: false,
  striped: false
};

var Table =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Table, _React$Component);

  function Table() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Table.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        striped = _this$props.striped,
        bordered = _this$props.bordered,
        condensed = _this$props.condensed,
        hover = _this$props.hover,
        responsive = _this$props.responsive,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["striped", "bordered", "condensed", "hover", "responsive", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'striped')] = striped, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'bordered')] = bordered, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'condensed')] = condensed, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'hover')] = hover, _extends2));

    var table = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("table", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));

    if (responsive) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
        className: Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'responsive')
      }, table);
    }

    return table;
  };

  return Table;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('table', Table));

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Nav__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NavItem__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TabContainer__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TabContent__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__ = __webpack_require__(103);














var TabContainer = __WEBPACK_IMPORTED_MODULE_10__TabContainer__["a" /* default */].ControlledComponent;
var propTypes = {
  /**
   * Mark the Tab with a matching `eventKey` as active.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,

  /**
   * Navigation style
   */
  bsStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['tabs', 'pills']),

  /**
   * Sets a default animation strategy. Use `false` to disable, `true`
   * to enable the default `<Fade>` animation, or a react-transition-group
   * v2 `<Transition/>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),
  id: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number])),

  /**
   * Callback fired when a Tab is selected.
   *
   * ```js
   * function (
   *   Any eventKey,
   *   SyntheticEvent event?
   * )
   * ```
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
var defaultProps = {
  bsStyle: 'tabs',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  var defaultActiveKey;
  __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });
  return defaultActiveKey;
}

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Tabs, _React$Component);

  function Tabs() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tabs.prototype;

  _proto.renderTab = function renderTab(child) {
    var _child$props = child.props,
        title = _child$props.title,
        eventKey = _child$props.eventKey,
        disabled = _child$props.disabled,
        tabClassName = _child$props.tabClassName;

    if (title == null) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__NavItem__["a" /* default */], {
      eventKey: eventKey,
      disabled: disabled,
      className: tabClassName
    }, title);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        id = _this$props.id,
        onSelect = _this$props.onSelect,
        animation = _this$props.animation,
        mountOnEnter = _this$props.mountOnEnter,
        unmountOnExit = _this$props.unmountOnExit,
        bsClass = _this$props.bsClass,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        _this$props$activeKey = _this$props.activeKey,
        activeKey = _this$props$activeKey === void 0 ? getDefaultActiveKey(children) : _this$props$activeKey,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["id", "onSelect", "animation", "mountOnEnter", "unmountOnExit", "bsClass", "className", "style", "children", "activeKey"]);

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(TabContainer, {
      id: id,
      activeKey: activeKey,
      onSelect: onSelect,
      className: className,
      style: style
    }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Nav__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      role: "tablist"
    }), __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].map(children, this.renderTab)), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__TabContent__["a" /* default */], {
      bsClass: bsClass,
      animation: animation,
      mountOnEnter: mountOnEnter,
      unmountOnExit: unmountOnExit
    }, children)));
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;
Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* bsClass */])('tab', Tabs);
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_6_uncontrollable___default()(Tabs, {
  activeKey: 'onSelect'
}));

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);




/* eslint-disable jsx-a11y/alt-text */





var propTypes = {
  /**
   * src property that is passed down to the image inside this component
   */
  src: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * alt property that is passed down to the image inside this component
   */
  alt: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * href property that is passed down to the image inside this component
   */
  href: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * onError callback that is passed down to the image inside this component
   */
  onError: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * onLoad callback that is passed down to the image inside this component
   */
  onLoad: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

var Thumbnail =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Thumbnail, _React$Component);

  function Thumbnail() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Thumbnail.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        src = _this$props.src,
        alt = _this$props.alt,
        onError = _this$props.onError,
        onLoad = _this$props.onLoad,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["src", "alt", "onError", "onLoad", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var Component = elementProps.href ? __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__["a" /* default */] : 'div';
    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", {
      src: src,
      alt: alt,
      onError: onError,
      onLoad: onLoad
    }), children && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: "caption"
    }, children));
  };

  return Thumbnail;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Thumbnail.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('thumbnail', Thumbnail));

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonGroup__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ToggleButton__ = __webpack_require__(734);











var propTypes = {
  /**
   * An HTML `<input>` name for each child button.
   *
   * __Required if `type` is set to `'radio'`__
   */
  name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

  /**
   * The value, or array of values, of the active (pressed) buttons
   *
   * @controllable onChange
   */
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,

  /**
   * Callback fired when a button is pressed, depending on whether the `type`
   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
   * array of active values
   *
   * @controllable values
   */
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * The input `type` of the rendered buttons, determines the toggle behavior
   * of the buttons
   */
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['checkbox', 'radio']).isRequired
};
var defaultProps = {
  type: 'radio'
};

var ToggleButtonGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ToggleButtonGroup, _React$Component);

  function ToggleButtonGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ToggleButtonGroup.prototype;

  _proto.getValues = function getValues() {
    var value = this.props.value;
    return value == null ? [] : [].concat(value);
  };

  _proto.handleToggle = function handleToggle(value) {
    var _this$props = this.props,
        type = _this$props.type,
        onChange = _this$props.onChange;
    var values = this.getValues();
    var isActive = values.indexOf(value) !== -1;

    if (type === 'radio') {
      if (!isActive) {
        onChange(value);
      }

      return;
    }

    if (isActive) {
      onChange(values.filter(function (n) {
        return n !== value;
      }));
    } else {
      onChange(values.concat([value]));
    }
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        type = _this$props2.type,
        name = _this$props2.name,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["children", "type", "name"]);

    var values = this.getValues();
    !(type !== 'radio' || !!name) ?  false ? invariant(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : __WEBPACK_IMPORTED_MODULE_5_invariant___default()(false) : void 0;
    delete props.onChange;
    delete props.value; // the data attribute is required b/c twbs css uses it in the selector

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ButtonGroup__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      "data-toggle": "buttons"
    }), __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      var _child$props = child.props,
          value = _child$props.value,
          onChange = _child$props.onChange;

      var handler = function handler() {
        return _this.handleToggle(value);
      };

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, {
        type: type,
        name: child.name || name,
        checked: values.indexOf(value) !== -1,
        onChange: Object(__WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__["a" /* default */])(onChange, handler)
      });
    }));
  };

  return ToggleButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ToggleButtonGroup.propTypes = propTypes;
ToggleButtonGroup.defaultProps = defaultProps;
var UncontrolledToggleButtonGroup = __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default()(ToggleButtonGroup, {
  value: 'onChange'
});
UncontrolledToggleButtonGroup.Button = __WEBPACK_IMPORTED_MODULE_10__ToggleButton__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (UncontrolledToggleButtonGroup);

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(16);








var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number])),

  /**
   * Sets the direction the Tooltip is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Tooltip.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "left" position value for the Tooltip.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "top" position value for the Tooltip arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "left" position value for the Tooltip arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string])
};
var defaultProps = {
  placement: 'right'
};

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Tooltip, _React$Component);

  function Tooltip() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tooltip.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        placement = _this$props.placement,
        positionTop = _this$props.positionTop,
        positionLeft = _this$props.positionLeft,
        arrowOffsetTop = _this$props.arrowOffsetTop,
        arrowOffsetLeft = _this$props.arrowOffsetLeft,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["placement", "positionTop", "positionLeft", "arrowOffsetTop", "arrowOffsetLeft", "className", "style", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "tooltip",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes),
      style: outerStyle
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'arrow'),
      style: arrowStyle
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inner')
    }, children));
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('tooltip', Tooltip));

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_StyleConfig__ = __webpack_require__(87);








var Well =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Well, _React$Component);

  function Well() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Well.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Well;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('well', Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_6__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_6__utils_StyleConfig__["c" /* Size */].SMALL], Well)));

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bootstrapUtils__ = __webpack_require__(16);
/* unused harmony reexport bootstrapUtils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createChainedFunction__ = __webpack_require__(75);
/* unused harmony reexport createChainedFunction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__ = __webpack_require__(103);
/* unused harmony reexport ValidComponentChildren */







/***/ }),
/* 1287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 1291 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(491);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(295);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(1309);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(744);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(364);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(742);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(743);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(744);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(745);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(1310);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(491);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(747);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ConnectedRouter = function (_Component) {
  _inherits(ConnectedRouter, _Component);

  function ConnectedRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, ConnectedRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleLocationChange = function (location) {
      _this.store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* LOCATION_CHANGE */],
        payload: location
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        propsStore = _props.store,
        history = _props.history,
        isSSR = _props.isSSR;

    this.store = propsStore || this.context.store;
    this.handleLocationChange(history.location);

    if (!isSSR) this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
  };

  ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
  };

  ConnectedRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Router */], this.props);
  };

  return ConnectedRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ConnectedRouter.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  isSSR: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
ConnectedRouter.contextTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (ConnectedRouter);

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getLocation */
/* unused harmony export createMatchSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(746);


var getLocation = function getLocation(state) {
  return state.router.location;
};

var createMatchSelector = function createMatchSelector(path) {
  var lastPathname = null;
  var lastMatch = null;
  return function (state) {
    var _ref = getLocation(state) || {},
        pathname = _ref.pathname;

    if (pathname === lastPathname) {
      return lastMatch;
    }
    lastPathname = pathname;
    var match = Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["b" /* matchPath */])(pathname, path);
    if (!match || !lastMatch || match.url !== lastMatch.url) {
      lastMatch = match;
    }
    return lastMatch;
  };
};

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = routerMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(748);


/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* CALL_HISTORY_METHOD */]) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, args);
      };
    };
  };
}

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);
var bind = __webpack_require__(749);
var Axios = __webpack_require__(1316);
var defaults = __webpack_require__(494);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(753);
axios.CancelToken = __webpack_require__(1329);
axios.isCancel = __webpack_require__(752);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(1330);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 1315 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(494);
var utils = __webpack_require__(121);
var InterceptorManager = __webpack_require__(1324);
var dispatchRequest = __webpack_require__(1325);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(751);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);
var transformData = __webpack_require__(1326);
var isCancel = __webpack_require__(752);
var defaults = __webpack_require__(494);
var isAbsoluteURL = __webpack_require__(1327);
var combineURLs = __webpack_require__(1328);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(753);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PrivateRouteLocal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrivateRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors_authentication__ = __webpack_require__(11);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var PrivateRouteLocal=function PrivateRouteLocal(_ref){var Component=_ref.component,rest=_objectWithoutProperties(_ref,['component']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],Object.assign({},rest,{render:function render(props){return rest.isLoggedIn?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,props):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Redirect */],{to:{pathname:'/login',state:{referrer:rest.location.pathname}// keep track of previous route to go after login
}});}}));};var PrivateRoute=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{isLoggedIn:Object(__WEBPACK_IMPORTED_MODULE_3__selectors_authentication__["f" /* isLoggedIn */])(state)};})(PrivateRouteLocal);

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserInvitationsContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserInvitations__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserInvitationsSent__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_client_user_invitations__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors_client_user_invitations__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectors_authentication__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserInvitationsContainer=function(_Component){_inherits(UserInvitationsContainer,_Component);function UserInvitationsContainer(){_classCallCheck(this,UserInvitationsContainer);var _this=_possibleConstructorReturn(this,(UserInvitationsContainer.__proto__||Object.getPrototypeOf(UserInvitationsContainer)).call(this));_this.userIndexToRemove=null;_this.userIdToRemove=null;_this.handleCurrentInvitationChange=function(invitation){_this.setState({currentInvitation:invitation});};_this.handleAddInvitation=function(newInvitation){var newInvitations=_this.state.invitations.slice();newInvitations.push(newInvitation);_this.setState({currentInvitation:{firstName:'',lastName:'',email:'',permissions:UserInvitationsContainer._initPermissions(_this.props.permissions),title:''},invitations:newInvitations});};_this.handleSentInvitation=function(){var params=_this.state.invitations.map(function(element){return Object.assign({},element,{permissions:element.permissions.filter(function(element){return element.selected;}).map(function(element){return{id:element.id};})});});_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_client_user_invitations__["d" /* userInvitationsRequest */])(_this.props.currentUser,params));};_this.handleRemoveInvitation=function(id){_this.userIndexToRemove=id;_this.setState({showRemoveConfirmation:true});};_this.handleRemoveUser=function(userId){_this.userIdToRemove=userId;_this.setState({showRemoveConfirmation:true});};_this.handleConfirmationModalHide=function(confirmation){if(confirmation){if(_this.userIndexToRemove!==null){_this.setState({invitations:_this.state.invitations.filter(function(element,index){return index!==_this.userIndexToRemove;})});_this.userIndexToRemove=null;}else if(_this.userIdToRemove!==null){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_client_user_invitations__["f" /* userRemoveRequest */])(_this.userIdToRemove));_this.userIdToRemove=null;}}_this.setState({showRemoveConfirmation:false});};_this.state={invitationsSent:false,invitations:[],currentInvitation:{firstName:'',lastName:'',email:'',permissions:[],title:''},usersInvited:[],showRemoveConfirmation:false};return _this;}_createClass(UserInvitationsContainer,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_client_user_invitations__["e" /* userInvitationsStart */])());}},{key:'UNSAFE_componentWillReceiveProps',value:function UNSAFE_componentWillReceiveProps(nextProps){var _this2=this;// When permissions are loaded, initialize current invitation
if(nextProps.permissions.length>0){this.setState({currentInvitation:{firstName:'',lastName:'',email:'',permissions:UserInvitationsContainer._initPermissions(nextProps.permissions),title:''}});}if(nextProps.users.length!==this.props.users.length){// Populate users list with new users
var users=nextProps.users.map(function(user){var newElement={firstName:user.first_name,lastName:user.last_name,email:user.email,id:user.id,permissions:UserInvitationsContainer._initPermissions(_this2.props.permissions),title:user.title};// For every role in the user, mark permissions selected
newElement.permissions.forEach(function(permission){if(user.roles.find(function(element){return element.id===permission.id;})!==undefined){permission.selected=true;}});return newElement;});this.setState({usersInvited:users});if(this.props.users.length===0){this.setState({invitationsSent:true});}}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,!this.state.invitationsSent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UserInvitations__["b" /* default */],{invitations:this.state.invitations.map(function(element,index){element.id=index;return element;}),currentInvitation:this.state.currentInvitation,onAdd:this.handleAddInvitation,onSent:this.handleSentInvitation,onRemove:this.handleRemoveInvitation,onCurrentInvitationChange:this.handleCurrentInvitationChange}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UserInvitationsSent__["a" /* default */],{invitations:this.state.usersInvited,onRemove:this.handleRemoveUser}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showRemoveConfirmation,message:'Are you sure you want to remove this item?',onHide:this.handleConfirmationModalHide}));}}],[{key:'_initPermissions',value:function _initPermissions(permissions){return permissions.map(function(element){return{id:element.id,label:element.label,selected:false};});}}]);return UserInvitationsContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_7__selectors_authentication__["d" /* getCurrentUser */])(state),permissions:Object(__WEBPACK_IMPORTED_MODULE_6__selectors_client_user_invitations__["a" /* getUserInvitationsPermissions */])(state),users:Object(__WEBPACK_IMPORTED_MODULE_6__selectors_client_user_invitations__["b" /* getUserInvitationsUsers */])(state)};})(UserInvitationsContainer));

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Invitation_css__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Invitation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Invitation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddInvitation_css__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddInvitation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AddInvitation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_checkbox_CheckBox__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserInvitations__ = __webpack_require__(495);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddInvitation=function(_Component){_inherits(AddInvitation,_Component);function AddInvitation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddInvitation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddInvitation.__proto__||Object.getPrototypeOf(AddInvitation)).call.apply(_ref,[this].concat(args))),_this),_this.handleSelectChange=function(id){_this.props.onChange(Object.assign({},_this.props.invitation,{permissions:_this.props.invitation.permissions.map(function(element,index){if(index===id){element.selected=!element.selected;}return element;})}));},_this.handleFirstNameChange=function(event){_this.props.onChange(Object.assign({},_this.props.invitation,{firstName:event.target.value}));},_this.handleLastNameChange=function(event){_this.props.onChange(Object.assign({},_this.props.invitation,{lastName:event.target.value}));},_this.handleEmailChange=function(event){_this.props.onChange(Object.assign({},_this.props.invitation,{email:event.target.value}));},_this.handleTitleChange=function(event){_this.props.onChange(Object.assign({},_this.props.invitation,{title:event.target.value}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddInvitation,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invitation-container add-invitation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:6,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'header'},'User Details'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["h" /* FormControl */],{id:'first-name',type:'text',className:'input',value:this.props.invitation.firstName,placeholder:'First Name',onChange:this.handleFirstNameChange,required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["h" /* FormControl */],{type:'text',className:'input',value:this.props.invitation.lastName,placeholder:'Last Name',onChange:this.handleLastNameChange,required:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["h" /* FormControl */],{type:'email',className:'input',value:this.props.invitation.email,placeholder:'Email',onChange:this.handleEmailChange,required:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["h" /* FormControl */],{className:'input',value:this.props.invitation.title,placeholder:'Title',onChange:this.handleTitleChange})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:6,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'header'},'Account Permissions'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],{className:'add-invitation-permissions-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:6,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label'},'You may change these in the Dashboard after creation.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'permissions-table'},this.props.invitation.permissions.map(function(permission,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'permissions-table-row',key:permission.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'permissions-table-cell permissions-table-cell-checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_checkbox_CheckBox__["a" /* default */],{id:index,checked:permission.selected,onChange:_this2.handleSelectChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'permissions-table-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'permission-label label'},permission.label)));})))))));}}]);return AddInvitation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AddInvitation.propTypes={invitation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_6__UserInvitations__["a" /* InvitationPropTypes */]),onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (AddInvitation);

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserInvitations_css__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserInvitations_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UserInvitations_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShowInvitation__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(51);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserInvitationsSent=function(_Component){_inherits(UserInvitationsSent,_Component);function UserInvitationsSent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserInvitationsSent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserInvitationsSent.__proto__||Object.getPrototypeOf(UserInvitationsSent)).call.apply(_ref,[this].concat(args))),_this),_this.handleInvitationRemove=function(id){_this.props.onRemove(id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserInvitationsSent,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-invitations client'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["k" /* Grid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:6,lgOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Invites Sent')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:6,lgOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subtitle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'You will be notified when the user accepts your invite.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:10,lgOffset:1},this.props.invitations.map(function(invitation){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ShowInvitation__["a" /* default */],{user:invitation,onDelete:_this2.handleInvitationRemove,key:invitation.id});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{lg:6,lgOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */],{to:'/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-select btn-orange'},'Go to Dashboard')))))));}}]);return UserInvitationsSent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UserInvitationsSent.propTypes={invitations:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,firstName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,lastName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,permissions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}))})),onRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (UserInvitationsSent);

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUserInvitationsPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUserInvitationsUsers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getUserInvitationsPermissions=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.userInvitations.data.permissions;},function(permissions){return permissions;});var getUserInvitationsUsers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.userInvitations.data.users;},function(users){return users;});

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_errors_SimpleErrorList__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_client_set_password__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_client_set_password__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_modal_TermsModal__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_checkbox_LabeledCheckBox__ = __webpack_require__(88);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SetPassword=function(_Component){_inherits(SetPassword,_Component);function SetPassword(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SetPassword);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SetPassword.__proto__||Object.getPrototypeOf(SetPassword)).call.apply(_ref,[this].concat(args))),_this),_this.state={showTerms:false,termsAccepted:false},_this.handleChange=function(attribute,event){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_client_set_password__["c" /* updatePassword */])(attribute,event.target.value));},_this.handleSubmit=function(event){event.preventDefault();var params=__WEBPACK_IMPORTED_MODULE_3_query_string___default.a.parse(_this.props.location.search);_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_client_set_password__["b" /* confirmPassword */])(params.invitation_token,_this.props.password,_this.props.passwordConfirmation,_this.state.termsAccepted));},_this.toggleShowTerms=function(){_this.setState(function(state){return{showTerms:!state.showTerms};});},_this.toggleTermsAccept=function(){_this.setState(function(state){return{termsAccepted:!state.termsAccepted};});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SetPassword,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'client'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_modal_TermsModal__["a" /* default */],{show:this.state.showTerms,onHide:this.toggleShowTerms,invited:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["k" /* Grid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:6,mdOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Create your password')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:6,mdOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["h" /* FormControl */],{type:'password',className:'input',value:this.props.password,placeholder:'Password',onChange:this.handleChange.bind(this,'password'),required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["h" /* FormControl */],{type:'password',className:'input',value:this.props.passwordConfirmation,placeholder:'Password confirmation',onChange:this.handleChange.bind(this,'passwordConfirmation'),required:true}))),this.props.errors.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_errors_SimpleErrorList__["a" /* default */],{errors:this.props.errors})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'row',marginBottom:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{checked:this.state.termsAccepted,onChange:this.toggleTermsAccept,id:'terms-and-conditions-checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'I accept the',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{cursor:'pointer'},onClick:this.toggleShowTerms},' ','Terms and conditions')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',className:'btn-select btn-'+(this.state.termsAccepted?'orange':'gray'),value:'Confirm',disabled:!this.state.termsAccepted})))))))));}}]);return SetPassword;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{errors:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_client_set_password__["a" /* getErrors */])(state),password:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_client_set_password__["b" /* getPassword */])(state),passwordConfirmation:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_client_set_password__["c" /* getPasswordConfirmation */])(state)};})(SetPassword));

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPasswordConfirmation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getErrors=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.setPassword.ui.errors;},function(errors){return errors;});var getPassword=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.setPassword.ui.password;},function(password){return password;});var getPasswordConfirmation=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.setPassword.ui.passwordConfirmation;},function(passwordConfirmation){return passwordConfirmation;});

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var textStyle={fontSize:'14px',height:'500px',overflowX:'hidden',textAlign:'left'};var TermsModalText=function TermsModalText(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:textStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'TERMS OF USE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Spackle, Inc. ("Spackle" or "We") provides an interactive software product ("App") via online services such as the Apple iTunes App Store and Google Play Store. We own and operate',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.spackle.co',target:'_blank',rel:'noopener noreferrer'},'www.spackle.co'),' ','(our "Site") to provide access to information about Spackle and the App(s) (our "Content"). Please read the following terms and conditions ("Terms of Use") carefully. These Terms of Use govern your access to and use of our App, Site and Content (defined below) and set forth the legally binding terms for your use of the App and Content.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Our App, Site and Content are available for individuals aged 13 years or older. BY ACCESSING OR USING OUR SITE OR BY PURCHASING, DOWNLOADING AND/OR INSTALLING OUR APP, YOU REPRESENT THAT YOU ARE AT LEAST 13 YEARS OLD AND THAT YOU HAVE READ AND UNDERSTAND AND ACCEPT THESE TERMS OF USE AND YOU AGREE AND UNDERSTAND THAT YOU ARE BOUND BY THESE TERMS OF USE AND ALL TERMS, POLICIES AND GUIDELINES INCORPORATED IN THESE TERMS OF USE, INCLUDING WITHOUT LIMITATION OUR PRIVACY POLICY LOCATED AT',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.spackle.co/privacy/',target:'_blank',rel:'noopener noreferrer'},'www.spackle.co/privacy'),'. IF YOU DO NOT AGREE TO THESE TERMS OF USE, THEN YOU HAVE NO RIGHT TO ACCESS OR USE OUR SITE, APPS OR CONTENT.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'We reserve the right to amend these Terms of Use in any and all respects at any time. IF YOU ARE NOT AT LEAST 13 YEARS OLD AND/OR YOU DO NOT AGREE TO THE TERMS OF THIS AGREEMENT, YOU MUST IMMEDIATELY (1) REFRAIN FROM USING THE SOFTWARE AND ANY OTHER MATERIALS ASSOCIATED WITH THE SOFTWARE, (2) COMPLETELY DELETE ALL COPIES OF THE SOFTWARE AND ALL RELATED FILES FROM YOUR DEVICE.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'IN ADDITION TO THE FOREGOING, IF YOU ARE PURCHASING, DOWNLOADING AND/OR INSTALLING OUR APP FROM AN ONLINE SERVICE SUCH AS APPLE ITUNES APP STORE OR GOOGLE PLAY STORE, YOU REPRESENT THAT YOU ARE NOT LOCATED IN A COUNTRY EMBARGOED BY THE UNITED STATES AND/OR ON THE U.S. TREASURY DEPARTMENT\u2019S LIST OF SPECIALLY-DESIGNATED NATIONALS. IF YOU DO NOT MEET THIS REQUIREMENT, YOU MUST IMMEDIATELY (1) REFRAIN FROM USING THE SOFTWARE AND ANY OTHER MATERIALS ASSOCIATED WITH THE SOFTWARE, (2) COMPLETELY DELETE ALL COPIES OF THE SOFTWARE AND ALL RELATED FILES FROM YOUR DEVICE.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We reserve the right to modify or discontinue the Site, App or Content in any and all respects. You agree to check',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.spackle.co/terms',target:'_blank',rel:'noopener noreferrer'},'www.spackle.co/terms'),' ','periodically for new information and terms that govern your use of our services. Revisions to terms affecting existing services shall be effective thirty (30) days after posting at spackle.co/terms. Terms for new services are effective immediately upon posting at',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.spackle.co/terms',target:'_blank',rel:'noopener noreferrer'},'www.spackle.co/terms'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Table of Contents'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Certain Definitions Intellectual Property Rights'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Contributing Third Party Content'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Takedown Procedure under the U.S. Digital Millennium Copyright Act'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Contributing User Content; License Grant to Us'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Third Party Services'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Privacy'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Rules of Conduct'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Termination'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'NO WARRANTY'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'LIMITATION OF LIABILITY'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Indemnity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Injunctive Relief'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Controlling Law and Jurisdiction'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Entire Agreement; Severability; Waiver'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Notices')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Certain Definitions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Certain types of content are made available through the Site and/or App. "Content" includes, but is not limited to, the software, data, technology, text, forum posts, chat posts, profiles, widgets, messages, links, e-mails, music, sound, graphics, pictures, images, illustrations, forms, video, code, and all audio visual or other material appearing on or emanating to and/or from the Site or App, including their look and feel attributes, as well as the design and appearance of the Site, the Spackle trademarks and logos and other content made available through the Site and App. "User Content" means any text, data, graphics, images, photos, video or audiovisual content, hypertext links and any other content uploaded, transmitted or submitted by individual users to the Site or App, including through use of any widget.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Intellectual Property Rights'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The Site, App and Content are owned by Spackle or Spackle\u2019s third-party licensors and are protected by U.S. copyright laws, trade dress, patent, and trademark laws, international conventions, and other laws protecting intellectual property and related proprietary rights. You may not copy or download any Content unless you are expressly authorized to do so. You do not acquire any ownership rights in our Site, App or Content by using the Site, App or Content.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You agree not to remove, obscure, or alter copyright, patent, trademark, or other proprietary rights notices affixed to Content or App. You may not sell, license, distribute, copy, modify, publicly perform or display, transmit, publish, edit, adapt, create derivative works from, or otherwise make unauthorized use of App or Content. We reserve all rights in our Site, App and Content that are not expressly granted to you in these Terms of Use. Making unauthorized copies of App and/or Content found on the Site will result in the termination of your rights to use the Site and App and further legal action. We or our licensors and exclusive licensees may take criminal or civil action against you for unauthorized use of intellectual property. You agree to indemnify and hold us and our employees, representatives, agents, licensees and providers of Third-Party Services to our Site and App harmless from any unauthorized or illegal conduct by you, or through the use of the Site or App.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We welcome and encourage you to provide feedback, comments and suggestions for improvements to the Site, products and Content ("Feedback"). You may submit Feedback by emailing us at support@spackle.co. You acknowledge and agree that all Feedback will be our sole and exclusive property and you hereby irrevocably assign to Spackle and its licensees and successors and assigns, and agree to irrevocably assign to Spackle and its licensees and successors and assigns all of your right, title, and interest in and to all Feedback, including without limitation all worldwide patent rights, copyright rights, trade secret rights, and other proprietary or intellectual property rights therein. At our request and expense, you will execute documents and take such further acts as we may reasonably request to assist us to acquire, perfect, and maintain its intellectual property rights and other legal protections for the Feedback.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Contributing Third Party Content'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We respect the intellectual property rights of others. You must have the legal right to upload User Content to the Site or App. You may not upload or post any User Content that is protected by copyright, trademark or other intellectual property rights unless (i) you are the owner of all of those rights or (ii) you have the prior written consent of the owner(s) of those rights to make such use of that User Content. We may, without prior notice to you and in our sole judgment, remove User Content that may infringe the intellectual property rights of a third party. If you are an infringer of our or a third party\u2019s intellectual property rights, we may terminate your right to access the Site or App without notice to you. If your access is terminated to the Site or App as a result of any infringement of intellectual property rights, you are not entitled to a refund for any fees you have paid.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Takedown Procedure under the U.S. Digital Millennium Copyright Act'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We have adopted and implemented a policy respecting the U.S. copyright law that provides for the removal of User Content that infringes the rights of third parties and, in appropriate circumstances, disabling access to the Site and/or App and/or Content of users who are infringers of intellectual property rights, including copyrights under U.S. law. If you believe that one of our users is, through the use of one of our App or Site, unlawfully infringing the copyright(s) in a work, and wish to have the allegedly infringing material removed from our Site or App(s), the following information in the form of a written notification (pursuant to 17 U.S.C. - 512(c)) must be provided to our designated Copyright Agent:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Identification of the copyrighted work(s) that you claim to have been infringed;'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Identification of where the infringing material is located on our Site or products;'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'A statement that you have a good faith belief that use of the objectionable material is not authorized by the copyright owner, its agent, or under the law;'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'A statement that the information in the notification is accurate, and that under penalty of perjury, you are either the owner of the copyright that has allegedly been infringed or that you are authorized to act on behalf of the copyright owner;'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Your address, telephone number, and e-mail address; and'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Your physical or electronic signature.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Please note that pursuant to 17 U.S.C. - 512(f), any misrepresentation of material fact (falsities) in a written notification automatically subjects the complaining party to liability for any damages, costs and attorney\u2019s fees incurred by Spackle in connection with the written notification and allegation of copyright infringement.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Contributing User Content; License Grant to Spackle'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'When you contribute User Content to the Site or a App, you expressly grant to us and our licensees, successors and assigns, a non-exclusive, perpetual, worldwide, complete, irrevocable, fully-paid and royalty-free right to quote, re-post, use, reproduce, modify, create derivative works from, syndicate, license, print, sublicense, distribute, transmit, broadcast, and otherwise communicate, and publicly display and perform the User Content, or any portion thereof, in any manner or form and in any medium or forum, whether now known or hereafter devised, without notice, payment or attribution of any kind to you or any third party. You grant us all licenses, consents and clearances to enable us to use such User Content for such purposes. You waive and agree not to assert any moral or similar rights you may have in such User Content.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Third Party Services'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The Site and App may contain or link to third-party websites or resources, such as Apple iTunes App Store, Google Play Store, Amazon Appstore for Android, Samsung Appstore, and websites owned and operated by publishing and distribution partners ("Third Party Services") where you can access the content, products, or services on or available from such websites or resources ("Third Party Materials"). Third Party Services, Third Party Materials and links to other websites are provided solely as a convenience to you, and links to such Third Party Services do not imply any endorsement by us of such Third Party Services or Third Party Materials available from such websites or resources nor do such links imply an endorsement by the providers of such Third Party Services or Third Party Materials of us, or the App or Content. You acknowledge and agree that (i) we are not responsible or liable for examining or evaluating the content, the availability or accuracy, completeness, timeliness, validity, copyright compliance, legality, decency, quality, maintenance or support, or any other aspect of such Third Party Services or Third Party Materials, and (ii) the providers of such Third Party Services or Third Party Materials are not responsible or liable for examining or evaluating the content, the availability or accuracy, completeness, timeliness, validity, copyright compliance, legality, decency, quality, maintenance or support, or any other aspect of our Site, App and Content. We encourage you to review the terms of use or terms of service of any other Third Party Services provider from whom you request services, because by visiting a Third Party Service that is linked to the Site or App, you will be governed by such party\u2019s terms of use or terms of service and privacy policy and you should consult that site\u2019s terms of use or terms of service, and that site\u2019s privacy policy before entering and using that site and before providing any personal information.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Privacy'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Personal information gathered in connection with your use of the Site or App or submitted with User Content shall be held by Spackle in compliance with Spackle\u2019s Privacy Policy, which is incorporated herein by reference. See our Privacy Policy at',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.spackle.co/privacy',target:'_blank',rel:'noopener noreferrer'},'www.spackle.co/privacy'),' ','or information and notices concerning our collection and use of your personal information. If you have any questions about our Privacy Policy, please contact us at pa@spackle.co. Because we cannot control the activities of third parties (including the providers of such Third-Party Services or Third-Party Materials), we cannot accept responsibility for any use of your personal information by such third parties, and we cannot guarantee that they will adhere to the same privacy and security practices as we do. We encourage you to review the privacy policies of any other Third Party Services provider from whom you request services, because by visiting a Third Party Service that is linked to the Site or App, you will be governed by such party\u2019s terms of use or terms of service and privacy policy and you should consult that site\u2019s terms of use or terms of service and that site\u2019s privacy policy before entering and using that site and before providing any personal information.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Rules of Conduct'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'By agreeing to these Terms of Use you acknowledge that you may not:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Post, transmit, promote, or distribute User Content that is illegal.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Impersonate another person (including celebrities); indicate falsely that you are our employee or our representative, or attempt to mislead users by indicating that you represent us or any of our partners or affiliates.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Engage in any commercial activities, including but not limited to any attempts to raise money for anyone or advertise or promote a product, service, website, pyramid scheme or multi-tiered marketing scheme.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Attempt to get a password, account information, or other private information from any user.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Upload any software or User Content that you do not own or have permission to freely distribute.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Promote or encourage any illegal activity including hacking, cracking or distribution of counterfeit software.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Upload files that contain a virus or corrupted data.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Post messages for any purpose other than personal communication, including advertising or promotional messaging, chain letters, pyramid schemes, or other commercial activities.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Use or distribute "auto" software programs, "macro" software programs or other "cheat utility" software program or applications.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Modify any part of the Site, App or Content that we do not specifically authorize you to modify.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Attempt to interfere with, hack into or decipher any transmissions to or from our servers.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Attempt to use App on or through any service that is not controlled or authorized by us.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Interfere with the ability of others to enjoy playing a App or take actions that interfere with or materially increase the cost to provide App for the enjoyment of all its users.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Specific Third Party Services may also post additional rules that apply to your conduct on those services. You must also obey all applicable laws, regulations and rules that apply to your activities when you use the Site or App.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you encounter another user who is violating any of the Rules of Conduct, please report this activity to Spackle at support@spackle.co.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Termination'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We reserve the right to terminate your access and to prevent your use of any and all of our Site or App if you engage in illegal activity or violate these Terms of Use. We will have the right to investigate and prosecute violations of any of the above, including intellectual property rights infringement and Site and App security issues, to the fullest extent of the law. We may involve and cooperate with law enforcement authorities in prosecuting users who violate these Terms of Use. You acknowledge that we have no obligation to monitor your access to or use of the Site, App or Content or to review or edit any User Content, but has the right to do so for the purpose of operating the Site and App, to ensure your compliance with these Terms of Use, or to comply with applicable law or the order or requirement of a court, administrative agency or other governmental body. In addition, if as a result of our monitoring your access to or use of the Site, App or Content, we find that you have not accessed or used the Site or App for a period of twelve (12) months or more, we reserve the right to terminate your account. We reserve the right, at any time and without prior notice, to remove or disable access to any Content or other content, including any User Content, that we, in our sole discretion, considers to be in violation of these Terms of Use or otherwise harmful to the Site or App.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'NO WARRANTY'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT USE OF THE SITE, APPS AND CONTENT, AS WELL AS THE THIRD-PARTY SERVICES LINKED TO OUR SITE AND APPS, AND THE THIRD-PARTY MATERIALS OFFERED THROUGH SUCH LINKS IS AT YOUR SOLE RISK AND THAT THE ENTIRE RISK AS TO SATISFACTORY QUALITY, PERFORMANCE, ACCURACY AND EFFORT IS WITH YOU. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE SITE, APPS AND CONTENT AND ANY THIRD PARTY SERVICES OR THIRD PARTY MATERIALS PERFORMED OR PROVIDED BY THE SITE OR PRODUCTS ARE PROVIDED "AS IS" AND "AS AVAILABLE", WITH ALL FAULTS AND WITHOUT WARRANTY OF ANY KIND, AND WE AND THE PROVIDERS OF THE THIRD PARTY SERVICES LINKED TO OUR SITE AND APPS, AND THE THIRD PARTY MATERIALS OFFERED THROUGH SUCH LINKS, HEREBY DISCLAIM ALL WARRANTIES AND CONDITIONS WITH RESPECT TO THE SITE, APPS AND CONTENT AND ANY THIRD PARTY SERVICES AND THIRD PARTY MATERIALS, WHETHER EXPRESS, IMPLIED OR STATUTORY, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY, OF SATISFACTORY QUALITY, OF FITNESS FOR A PARTICULAR PURPOSE, OF ACCURACY, OF QUIET ENJOYMENT, AND OF NON-INFRINGEMENT OF THIRD PARTY RIGHTS. WE DO NOT WARRANT AGAINST INTERFERENCE WITH YOUR ENJOYMENT OF THE SITE, APPS AND CONTENT, THAT THE FUNCTIONS CONTAINED IN, OR SERVICES PERFORMED OR PROVIDED BY, THE SITE, APPS AND CONTENT WILL MEET YOUR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'REQUIREMENTS OR THAT ANY ERRORS IN THE OPERATION OF THE SITE, APPS OR THIRD-PARTY SERVICES OR THIRD- PARTY MATERIALS WILL BE CORRECTED. NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY US OR OUR AUTHORIZED REPRESENTATIVES OR BY THIRD PARTY SERVICES LINKED TO OUR SITE AND APPS SHALL CREATE A WARRANTY. SHOULD THE SITE, APPS, CONTENT, THIRD PARTY SERVICES OR THIRD-PARTY MATERIALS PROVE DEFECTIVE, YOU ASSUME THE ENTIRE COST OF ALL NECESSARY SERVICING, REPAIR OR CORRECTION INCURRED BY YOU AS A RESULT OF YOUR USE OF THE SITE, APPS, CONTENT, THIRD PARTY SERVICES OR THIRD PARTY MATERIALS. FOR THE AVOIDANCE OF DOUBT, WE ARE NOT AUTHORIZED TO MAKE AND DO NOT MAKE ANY WARRANTIES ON BEHALF OF THE PROVIDERS OF THE THIRD PARTY SERVICES LINKED TO OUR SITE AND APPS, AND THE THIRD PARTY MATERIALS OFFERED THROUGH SUCH LINKS, AND OUR LICENSEES AND THE PROVIDERS OF THE THIRD PARTY SERVICES LINKED TO OUR SITE AND APPS, AND THE THIRD PARTY MATERIALS OFFERED THROUGH SUCH LINKS ARE NOT AUTHORIZED TO MAKE AND DO NOT MAKE ANY WARRANTIES ON BEHALF OF OUR SITE, APPS OR CONTENT. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES OR LIMITATIONS ON APPLICABLE STATUTORY RIGHTS OF A CONSUMER, SO THE ABOVE EXCLUSION AND LIMITATIONS MAY NOT APPLY TO YOU.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'LIMITATION OF LIABILITY'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TO THE EXTENT NOT PROHIBITED BY LAW, IN NO EVENT SHALL WE OR ANY OF OUR EMPLOYEES, REPRESENTATIVES, AGENTS OR LICENSEES BE LIABLE FOR PERSONAL INURY OR ANY INCIDENTAL, SPECIAL, INDIRECT, OR CONSEQUENTIAL DAMAGES WHATSOEVER, INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF PROFITS, LOSS OF DATA, BUSINESS INTERRUPTION OR ANY OTHER COMMERCIAL DAMAGES OR LOSSES, ARISING OUT OF OR RELATED TO YOUR USE OR INABILITY TO USE THE SITE, PRODUCTS, CONTENT, THIRD PARTY SERVICES OR THIRD PARTY MATERIALS, HOWEVER CAUSED, REGARDLESS OF THE THEORY OF LIABILITY (CONTRACT, TORT OR OTHERWISE) AND EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. SOME JURISDICTIONS DO NOT ALLOW THE LIMITATION OF LIABILITY FOR PERSONAL INJURY OR OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THIS LIMITATION MAY NOT APPLY TO YOU. IN NO EVENT SHALL OUR TOTAL LIABILITY TO YOU FOR ALL DAMAGES (OTHER THAN AS MAY BE REQUIRED BY APPLICABLE LAW IN CASES INVOLVING PERSONAL INJURY) EXCEED THE AMOUNT OF FIVE DOLLARS (US$5). THE FOREGOING LIMITATIONS WILL APPLY EVEN IF THE ABOVE STATED REMEDY FAILS OF ITS ESSENTIAL PURPOSE.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Indemnity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You agree to defend, indemnify, and hold us and our employees, representatives, agents, licensees and providers of Third Party Services linked to our Site and App harmless from and against any claims, liabilities, damages, losses, and expenses, including, without limitation, reasonable legal and accounting fees, arising out of or in any way connected with User Content you submit to us, your access to or use of our Site, App or Content, or your violation of these Terms of Use.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Injunctive Relief'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You agree that a breach of these Terms of Use will cause irreparable injury to us for which monetary damages would not be an adequate remedy and we shall be entitled to seek equitable relief in addition to any remedies we may have hereunder or at law without a bond, other security or proof of damages.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Controlling Law and Jurisdiction'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'These Terms of Use and any action related thereto will be governed by the laws of the State of California (USA) without regard to its conflict of laws provisions. Any legal suit, action or proceeding arising out of, or related to, these Terms of Use, the App or the Site shall be instituted exclusively in the federal courts of the United States or the courts of the State of California in each case located in Los Angeles County, California; although we retain the right to bring any suit, action or proceeding against you for breach of these Terms of Use in your state or country of residence or any other relevant state or country if different from the State of California and the United States. You waive any and all objections to the exercise of jurisdiction over you by such courts and to venue in such courts.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Entire Agreement; Severability; Waiver'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'These Terms of Use constitute the entire and exclusive understanding and agreement between Spackle and you regarding the Site, App and Content, and these Terms of Use supersede and replace any and all prior oral or written understandings or agreements between Spackle and you regarding the Site, App and Content. You agree that these Terms of Use are not intended to confer and do not confer any rights or remedies upon any person other than the parties to these Terms of'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Use. You also understand and agree that these Terms of Use and our Privacy Policy',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.spackle.co/privacy/',target:'_blank',rel:'noopener noreferrer'},'https://www.spackle.co/privacy/'),' ','incorporated by reference into these Terms of Use, including our enforcement of those policies, are not intended to confer, and do not confer, any rights or remedies upon any third party. If any part of these Terms of Use is held invalid or unenforceable, that portion shall be interpreted in a manner consistent with applicable law to reflect, as nearly as possible, our original intentions, and the remaining portions shall remain in full force and effect. Our failure to enforce any right or provision of these Terms of Use will not constitute a waiver of future enforcement of that right or provision.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Notices'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You consent to the use of (i) electronic means to complete these Terms of Use and to deliver any notices or other communications permitted or required hereunder and (ii) electronic records to store information related to these Terms of Use or your use of the Site, App or Content. Any notices or other communications permitted to required hereunder, including those regarding modifications to these Terms of Use, will be in writing and given (x) by us via email (in each case to the address that you provide) or (y) by posting to the Site or App. For notices made by e-mail, the date of receipt will be deemed the date on which such notice is transmitted.'));};/* harmony default export */ __webpack_exports__["a"] = (TermsModalText);

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAAAXNSR0IArs4c6QAABFJJREFUWAntmWtMVEcUx/93AQXBR6pFUBGNSPDFQ43VNk3TXaM1JnzQaKw1WhWpG4moIL6ioJbaikLUluIDicaoH0zkQ9vEVGgMSooWrdpNisEHvkAMiLyksOw6Z+Pe7Fx2L3cfZe8mTrJ75/xn7pnfnj13ZnJHwLtiNpuFBN3KJLPZtJpJk9gnxNrmxWsrG9sgCJrCWyVFJwRBMBOLQF/T5iaHG7s6zsAMLdmqLAJK/QMCl1VeOlaroQirHpiiyAJKnMQrxGu/XsNS4pgqo2sHiqVKMou0JYftNKtTIl4NQ6OHzpfKJIJWwyzhTNBCCNrnynvovvrLVBPpyIgwxb9ZFdCffZyAi0X7kLJ6IdhS3Su816EjRoTi263J0Gg0SPoqEfk/pGPwoGBZcK9CB/bvh7y9qRgYMkCEnDV9MnZvThJtexWvQmemr0LU2FEcV3NLG3Lyz3Ka1PAa9NIFczBPN4vjYZshbP+uAM9qX3K61PAKdPzk8dikXyJlQcGpYlytuNNDlwp9Dj3sg8HIyUyBv58fx1L2520cPV3MaY6MPoUmUAL+cOgQjufp83pLWnCijNGn0JQSCVOiOZyO/zqxKfMwWlrbOV3OcBqaJv+VS+YjeECgnN8ebfN0M0EPn7TszS3CvftPpLKs7RQ0/b37dqxFavJiHM7eiH4BAbLOrY00re1KW2U1xev54sv49fdy0VZaUQxNC8Gh7A34QjvT4ntaXAzLz3XwYyuZXAkJDkLunvUICuzPdbttqMaBn+TnY+4GG0N+RJuOc7Uf4ZMZsTYKQHuG3Rnyq1f2tm8weuRw7r6GxtdIzzoCY3c3pys1/MLGxmUp6VxV/RiDBgZjyoRxXPfocaMty3D5jbucTsaaZYlYlKjldAJN3ZGH6kfPON0ZQzE0Ob12/S5GhYeCQG1L7MQodJtMuHmnSpRpD0HLtHTXlltwHpf+qBD7uVJxCpoGuFJ+CzFRkRgTEc6NNyNhIhpfNcNQ9RDhw4fi5/0ZCAri85hgCdrd4jQ07Q9KyyoxNTYaI8KGceNTztfVNyJN/yUiRoZybfdZOqxnaWE0upbHts6EuM+XW96P2YpK6jRPF+ZtR8z4yF67t7W/wVJ9Fmqe1PXaV0kHxbOH1Flbewf0W3JQ87R3kJ3fH/cYMHG4DE03v2pqwdrN+/HiZSOZdsvJc7+g9Gql3TZXRbegadDaFw3QZ+Sg6TW9leVLxU0Dfiy8wIsesNyGJoYHNc+Rsu0g2t90iEh19Q3YsicfJpNLj4zox17FI9Dk+J9/H2DjzkPo6jKis7MLaZlH0NTcM/r2IJzVXJ49HA2k+3S6ZeW8+NsVR13c1v3d9iBxUFL2l0TxvOmx9PA8mmOP76Edx8azLRTp/+cR9yynrbdWgjbYKj5QN2joYNEHQEVE4hXoXC5et+Kyqg8+rcjsAPTvklOzWaQFM52EsrPbUmubKq/vTmyJV3yDTRH3lbPxt8iLRkuAInBGAAAAAElFTkSuQmCC"

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_sidebar_EnterpriseSidebar__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__work_orders_WorkOrdersContainer__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contractors_ContractorsContainer__ = __webpack_require__(2319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__buildings_BuildingsContainer__ = __webpack_require__(2340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Admin_css__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Admin_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Admin_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__clients_ClientsContainer__ = __webpack_require__(2350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_service_providers_ServiceProvidersContainer__ = __webpack_require__(2373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__quotes_Quotes__ = __webpack_require__(2392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__tasks_TasksContainer__ = __webpack_require__(2394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_selectors_admin_sidebar_sidebar__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_actions_admin_sidebar_sidebar__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__invoices_InvoicesContainer__ = __webpack_require__(2398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__team_TeamContainer__ = __webpack_require__(2415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__users_Users__ = __webpack_require__(2439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__tutorials_Tutorials__ = __webpack_require__(2442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_services_utils_permissions_util__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_admin_contractors_invoices_ContractorsInvoices__ = __webpack_require__(2470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_admin_reports_ReportsContainer__ = __webpack_require__(2476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_admin_purchase_orders_PurchaseOrdersContainer__ = __webpack_require__(2478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_admin_surveys_SurveysContainer__ = __webpack_require__(2486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_actions_admin_contractors_contractors__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_selectors_admin_contractors_contractors__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_actions_admin_team_contractor_team__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_components_admin_projects_ProjectsContainer__ = __webpack_require__(2496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_admin_general_contractors_GeneralContractorsContainer__ = __webpack_require__(3016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_components_admin_dashboard_DashboardContainer__ = __webpack_require__(3047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_components_admin_general_contractors_store_selectors__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_components_admin_general_contractors_store_actions__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_components_shared_modal_TermsModal__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_actions_admin_users_users__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_actions_authentication__ = __webpack_require__(174);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Admin=function(_Component){_inherits(Admin,_Component);function Admin(props){_classCallCheck(this,Admin);var _this=_possibleConstructorReturn(this,(Admin.__proto__||Object.getPrototypeOf(Admin)).call(this,props));_this.redirectToTeamEditPage=function(){if(_this.props.contractor&&!_this.props.contractor.confirmed){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_29_actions_admin_team_contractor_team__["d" /* goToEditContractor */])());}};_this.redirectToGeneralContractorOnboarding=function(){if(_this.props.generalContractor&&!_this.props.generalContractor.confirmed){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_actions_admin_sidebar_sidebar__["b" /* setHideSideBar */])(true));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_34_components_admin_general_contractors_store_actions__["p" /* showOnboarding */])());}};_this.handleItemSelected=function(id){Object(__WEBPACK_IMPORTED_MODULE_25_services_utils_scroller_util__["c" /* simpleScrollToTop */])();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_actions_admin_sidebar_sidebar__["a" /* selectRoute */])(id,_this.props.match.url+_this.sidebarItems.find(function(element){return element.icon===id;}).route));};_this.handleGenerateLink=function(id){return _this.props.match.url+'/'+id;};_this.onTermsAccept=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_37_actions_admin_users_users__["i" /* updateTermsAndConditions */])(true)).then(function(response){if(response.ok){_this.setState(function(state){return{showTerms:!state.showTerms};});}});};_this.handleEnterpriseRedirect=function(redirect){_this.props.dispatch(redirect?Object(__WEBPACK_IMPORTED_MODULE_39_actions_authentication__["j" /* enterpriseRedirect */])():Object(__WEBPACK_IMPORTED_MODULE_39_actions_authentication__["h" /* cancelEnterpriseRedirect */])());};props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_actions_admin_sidebar_sidebar__["b" /* setHideSideBar */])(false));_this.userIsSpackleAdmin=false;//usersUtil.isSpackleAdmin(props.currentUser);
_this.userIsAdmin=__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["g" /* usersUtil */].isAdmin(props.currentUser);_this.adminUserCanSeeMoney=__WEBPACK_IMPORTED_MODULE_21_services_utils_permissions_util__["a" /* PermissionsUtil */].adminUserCanSeeMoney(props.currentUser);_this.userIsGC=__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);_this.userIsClient=__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["f" /* TYPES */].CLIENT);_this.userIsContractor=__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["f" /* TYPES */].CONTRACTOR);_this.defaultRoute='/dashboard';_this.showEnterpriseActions=__WEBPACK_IMPORTED_MODULE_35_domain_enterprise__["a" /* Enterprise */].showActions(props.currentUser);_this.sidebarItems=[{label:'Work Orders',route:'/work-orders',icon:'work-orders',show:_this.userIsAdmin||_this.userIsClient||_this.userIsContractor||_this.userIsGC,type:'service-work'},{label:'Tasks',route:'/tasks',icon:'tasks',show:_this.userIsAdmin||_this.userIsGC,type:'service-work'},{label:'Clients',route:'/clients',icon:'clients',show:_this.showEnterpriseActions,type:'shared-bottom'},{label:'Service Providers',route:'/service-providers',icon:'service-providers',show:_this.showEnterpriseActions,type:'shared-bottom'},{label:'Sub Contractors',route:'/contractors',icon:'contractors',show:_this.userIsAdmin||_this.userIsGC,type:'shared-bottom'},{label:'Buildings',route:'/buildings',icon:'buildings',show:_this.userIsAdmin||_this.userIsClient||_this.userIsGC,type:'shared-bottom'},{label:'Purchase Orders',route:'/purchase-orders',icon:'purchase-orders',show:__WEBPACK_IMPORTED_MODULE_21_services_utils_permissions_util__["a" /* PermissionsUtil */].showPurchaseOrders(props.currentUser),type:'service-work'},{label:'Quotes',route:'/quotes',icon:'quotes',show:_this.adminUserCanSeeMoney||_this.userIsGC,type:'service-work'},{label:'Surveys',route:'/surveys',icon:'surveys',show:__WEBPACK_IMPORTED_MODULE_21_services_utils_permissions_util__["a" /* PermissionsUtil */].showSurveys(props.currentUser),type:'service-work'},{label:'Invoices',route:'/invoices',icon:'invoices',show:_this.adminUserCanSeeMoney||_this.userIsClient||_this.userIsGC,type:'service-work'},{label:_this.userIsAdmin||_this.userIsGC?'Contractors Invoices':'Invoices',route:'/contractors-invoices',icon:'contractors-invoices',show:_this.userIsAdmin||_this.userIsContractor||_this.userIsGC,type:'service-work'},{label:'Reports',route:'/reports',icon:'reports',show:__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["g" /* usersUtil */].hasRole(props.currentUser,__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["g" /* usersUtil */].hasRole(props.currentUser,__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["e" /* ROLES */].BUSINESS_DEVELOPMENT)||_this.userIsContractor||_this.userIsGC,type:'service-work'},{label:'Team',route:'/team',icon:'team',show:__WEBPACK_IMPORTED_MODULE_21_services_utils_permissions_util__["a" /* PermissionsUtil */].hasPermissionTeamPage(props.currentUser),type:'shared-bottom'},{label:'Users',route:'/users',icon:'users',show:__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["g" /* usersUtil */].hasRole(props.currentUser,__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN),type:'shared-bottom'},{label:'Projects',route:'/projects',icon:'projects',show:true,type:'enterprise'},{label:'General Contractors',route:'/general-contractors',icon:'general-contractors',show:_this.userIsAdmin,type:'enterprise'},{label:'Reports',route:'/spe-reports',icon:'spe-reports',show:_this.showEnterpriseActions,type:'enterprise'},{label:'Tutorials',route:'/tutorials',icon:'tutorials',show:true,type:'shared-bottom'},{label:'Dashboard',route:'/dashboard',icon:'dashboard',show:true,type:'shared-top'}];return _this;}_createClass(Admin,[{key:'UNSAFE_componentWillMount',value:function UNSAFE_componentWillMount(){var _this2=this;var user=this.props.currentUser;if(!user.terms_of_service){this.setState({showTerms:true});}if(this.userIsContractor&&user.accountable&&!user.accountable.confirmed){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_27_actions_admin_contractors_contractors__["g" /* loadContractorRequest */])(user.accountable_id)).then(function(){return _this2.redirectToTeamEditPage();});}else if(this.userIsGC&&user.accountable&&!user.accountable.confirmed){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_34_components_admin_general_contractors_store_actions__["e" /* loadGeneralContractorRequest */])(user.accountable_id)).then(function(){return _this2.redirectToGeneralContractorOnboarding();});}}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'admin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'admin-col sidebar-container '+(this.props.hideSideBar?'hidden':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_admin_sidebar_EnterpriseSidebar__["a" /* default */],{sharedItemsTop:this.sidebarItems.filter(function(item){return item.type==='shared-top';}).map(function(item){return Object.assign({},item,{selected:item.icon===_this3.props.activeRoute});}),serviceWorkItems:this.sidebarItems.filter(function(item){return item.type==='service-work';}).map(function(item){return Object.assign({},item,{selected:item.icon===_this3.props.activeRoute});}),enterpriseItems:this.sidebarItems.filter(function(item){return item.type==='enterprise';}).map(function(item){return Object.assign({},item,{selected:item.icon===_this3.props.activeRoute});}),sharedItemsBottom:this.sidebarItems.filter(function(item){return item.type==='shared-bottom';}).map(function(item){return Object.assign({},item,{selected:item.icon===_this3.props.activeRoute});}),onItemSelected:this.handleItemSelected,onGenerateLink:this.handleGenerateLink})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'admin-col-item-container',className:'admin-col item-container'},!this.props.currentUser.terms_and_conditions&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36_components_shared_modal_TermsModal__["a" /* default */],{show:this.state.showTerms,onHide:this.onTermsAccept}),this.props.hasEnterpriseRedirect&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.props.hasEnterpriseRedirect,message:'Spackle Enterprise for construction project management, is now called 360Plus. Would you like to be directed there?',onHide:this.handleEnterpriseRedirect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */],{path:this.props.match.url+'/work-orders',component:__WEBPACK_IMPORTED_MODULE_4__work_orders_WorkOrdersContainer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__["a" /* ConditionRoute */],{path:this.props.match.url+'/contractors',component:__WEBPACK_IMPORTED_MODULE_5__contractors_ContractorsContainer__["a" /* default */],show:this.userIsAdmin||this.userIsGC}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__["a" /* ConditionRoute */],{path:this.props.match.url+'/buildings',component:__WEBPACK_IMPORTED_MODULE_6__buildings_BuildingsContainer__["a" /* default */],show:this.userIsAdmin||__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["f" /* TYPES */].CLIENT)||this.userIsGC}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__["a" /* ConditionRoute */],{path:this.props.match.url+'/clients',component:__WEBPACK_IMPORTED_MODULE_10__clients_ClientsContainer__["a" /* default */],show:this.showEnterpriseActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__["a" /* ConditionRoute */],{path:this.props.match.url+'/service-providers',component:__WEBPACK_IMPORTED_MODULE_11_components_admin_service_providers_ServiceProvidersContainer__["a" /* default */],show:this.showEnterpriseActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__["a" /* ConditionRoute */],{path:this.props.match.url+'/quotes',component:__WEBPACK_IMPORTED_MODULE_13__quotes_Quotes__["a" /* default */],show:this.userIsAdmin||this.userIsGC}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__["a" /* ConditionRoute */],{path:this.props.match.url+'/tasks',component:__WEBPACK_IMPORTED_MODULE_14__tasks_TasksContainer__["a" /* default */],show:this.userIsAdmin||this.userIsGC}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__["a" /* ConditionRoute */],{path:this.props.match.url+'/purchase-orders',component:__WEBPACK_IMPORTED_MODULE_24_components_admin_purchase_orders_PurchaseOrdersContainer__["a" /* default */],show:__WEBPACK_IMPORTED_MODULE_21_services_utils_permissions_util__["a" /* PermissionsUtil */].showPurchaseOrders(this.props.currentUser)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__["a" /* ConditionRoute */],{path:this.props.match.url+'/invoices',component:__WEBPACK_IMPORTED_MODULE_17__invoices_InvoicesContainer__["a" /* default */],show:this.adminUserCanSeeMoney||__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["f" /* TYPES */].CLIENT)||this.userIsGC}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__["a" /* ConditionRoute */],{path:this.props.match.url+'/team',component:__WEBPACK_IMPORTED_MODULE_18__team_TeamContainer__["a" /* default */],show:__WEBPACK_IMPORTED_MODULE_21_services_utils_permissions_util__["a" /* PermissionsUtil */].hasPermissionTeamPage(this.props.currentUser)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__["a" /* ConditionRoute */],{path:this.props.match.url+'/users',component:__WEBPACK_IMPORTED_MODULE_19__users_Users__["a" /* default */],show:__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["g" /* usersUtil */].hasRole(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__["a" /* ConditionRoute */],{path:this.props.match.url+'/contractors-invoices',component:__WEBPACK_IMPORTED_MODULE_22_components_admin_contractors_invoices_ContractorsInvoices__["a" /* default */],show:this.userIsAdmin||__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["f" /* TYPES */].CONTRACTOR)||this.userIsGC}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__["a" /* ConditionRoute */],{path:this.props.match.url+'/reports',component:__WEBPACK_IMPORTED_MODULE_23_components_admin_reports_ReportsContainer__["a" /* default */],show:__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["g" /* usersUtil */].hasRole(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["g" /* usersUtil */].hasRole(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["e" /* ROLES */].BUSINESS_DEVELOPMENT)||__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_8__services_utils_users_util__["f" /* TYPES */].CONTRACTOR)||this.userIsGC}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__["a" /* ConditionRoute */],{path:this.props.match.url+'/surveys',component:__WEBPACK_IMPORTED_MODULE_26_components_admin_surveys_SurveysContainer__["a" /* default */],show:__WEBPACK_IMPORTED_MODULE_21_services_utils_permissions_util__["a" /* PermissionsUtil */].showSurveys(this.props.currentUser)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__["a" /* ConditionRoute */],{path:this.props.match.url+'/projects',component:__WEBPACK_IMPORTED_MODULE_30_components_admin_projects_ProjectsContainer__["a" /* default */],show:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__["a" /* ConditionRoute */],{path:this.props.match.url+'/general-contractors',component:__WEBPACK_IMPORTED_MODULE_31_components_admin_general_contractors_GeneralContractorsContainer__["a" /* default */],show:this.userIsAdmin||this.userIsGC}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__["a" /* ConditionRoute */],{path:this.props.match.url+'/spe-reports',component:__WEBPACK_IMPORTED_MODULE_23_components_admin_reports_ReportsContainer__["a" /* default */],show:this.showEnterpriseActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__["a" /* ConditionRoute */],{path:this.props.match.url+'/tutorials',component:__WEBPACK_IMPORTED_MODULE_20__tutorials_Tutorials__["a" /* default */],show:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_ConditionRoute__["a" /* ConditionRoute */],{path:this.props.match.url+'/dashboard',component:__WEBPACK_IMPORTED_MODULE_32_components_admin_dashboard_DashboardContainer__["a" /* default */],show:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Redirect */],{to:this.props.match.url+this.defaultRoute}))));}}]);return Admin;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activeRoute:Object(__WEBPACK_IMPORTED_MODULE_15_selectors_admin_sidebar_sidebar__["a" /* getActiveRoute */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_7__selectors_authentication__["d" /* getCurrentUser */])(state),contractor:Object(__WEBPACK_IMPORTED_MODULE_28_selectors_admin_contractors_contractors__["f" /* getCurrentContractor */])(state),generalContractor:Object(__WEBPACK_IMPORTED_MODULE_33_components_admin_general_contractors_store_selectors__["b" /* getCurrentGeneralContractor */])(state),hideSideBar:Object(__WEBPACK_IMPORTED_MODULE_15_selectors_admin_sidebar_sidebar__["b" /* getHideSidebar */])(state),hasEnterpriseRedirect:Object(__WEBPACK_IMPORTED_MODULE_7__selectors_authentication__["e" /* hasEnterpriseRedirect */])(state)};})(Admin));

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EnterpriseSidebar_css__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EnterpriseSidebar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EnterpriseSidebar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EnterpriseSidebarMenu__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarItem__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_dashboard_selected_png__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_dashboard_selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_dashboard_selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_dashboard_not_selected_png__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_dashboard_not_selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_dashboard_not_selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_enterprise_selected_png__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_enterprise_selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_enterprise_selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_enterprise_not_selected_png__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_enterprise_not_selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_enterprise_not_selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_service_work_selected_png__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_service_work_selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_service_work_selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_service_work_not_selected_png__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_service_work_not_selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_service_work_not_selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_buildings_selected_png__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_buildings_selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_buildings_selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_buildings_not_selected_png__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_buildings_not_selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_buildings_not_selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_clients_selected_png__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_clients_selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_clients_selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_clients_not_selected_png__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_clients_not_selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_clients_not_selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_contractors_selected_png__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_contractors_selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_contractors_selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_contractors_not_selected_png__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_contractors_not_selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_contractors_not_selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_team_selected_png__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_team_selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_team_selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_team_not_selected_png__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_team_not_selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__images_team_not_selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_tutorials_selected_png__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_tutorials_selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__images_tutorials_selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_tutorials_not_selected_png__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_tutorials_not_selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__images_tutorials_not_selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__shared_modal_NewServiceWorkSignupModal__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_admin_service_providers_store_selectors_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__selectors_admin_contractors_contractors_js__ = __webpack_require__(139);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var itemProps=__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({icon:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,route:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,selected:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,show:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,customAction:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,customClass:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string});var EnterpriseSidebar=function(_Component){_inherits(EnterpriseSidebar,_Component);function EnterpriseSidebar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EnterpriseSidebar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EnterpriseSidebar.__proto__||Object.getPrototypeOf(EnterpriseSidebar)).call.apply(_ref,[this].concat(args))),_this),_this.enterpriseSelected=function(){return!!_this.props.enterpriseItems.find(function(item){return item.selected;});},_this.serviceWorkSelected=function(){return!!_this.props.serviceWorkItems.find(function(item){return item.selected;});},_this.serviceWorkItemsWithBetaLink=function(){var company=_this.props.currentCompany;if(company&&company.enrolled_in_new_service_work)return _this.props.serviceWorkItems;var betaLink={icon:'',label:'Service Work',route:'/new_thing',selected:false,show:true,customAction:function customAction(){window.open('https://sw.spackle.co','_blank').focus();},customClass:'bold-item'};return[betaLink].concat(_toConsumableArray(_this.props.serviceWorkItems));},_this.renderSharedItems=function(items){var _this$props=_this.props,onItemSelected=_this$props.onItemSelected,onGenerateLink=_this$props.onGenerateLink;return items.filter(function(element){return element.show;}).map(function(element,index){var icon=void 0;switch(element.icon){case'dashboard':icon=element.selected?__WEBPACK_IMPORTED_MODULE_7__images_dashboard_selected_png___default.a:__WEBPACK_IMPORTED_MODULE_8__images_dashboard_not_selected_png___default.a;break;case'buildings':icon=element.selected?__WEBPACK_IMPORTED_MODULE_13__images_buildings_selected_png___default.a:__WEBPACK_IMPORTED_MODULE_14__images_buildings_not_selected_png___default.a;break;case'clients':icon=element.selected?__WEBPACK_IMPORTED_MODULE_15__images_clients_selected_png___default.a:__WEBPACK_IMPORTED_MODULE_16__images_clients_not_selected_png___default.a;break;case'service-providers':icon=element.selected?__WEBPACK_IMPORTED_MODULE_17__images_contractors_selected_png___default.a:__WEBPACK_IMPORTED_MODULE_18__images_contractors_not_selected_png___default.a;break;case'contractors':icon=element.selected?__WEBPACK_IMPORTED_MODULE_17__images_contractors_selected_png___default.a:__WEBPACK_IMPORTED_MODULE_18__images_contractors_not_selected_png___default.a;break;case'users':icon=element.selected?__WEBPACK_IMPORTED_MODULE_19__images_team_selected_png___default.a:__WEBPACK_IMPORTED_MODULE_20__images_team_not_selected_png___default.a;// Share icon with team
break;case'team':icon=element.selected?__WEBPACK_IMPORTED_MODULE_19__images_team_selected_png___default.a:__WEBPACK_IMPORTED_MODULE_20__images_team_not_selected_png___default.a;break;case'tutorials':icon=element.selected?__WEBPACK_IMPORTED_MODULE_21__images_tutorials_selected_png___default.a:__WEBPACK_IMPORTED_MODULE_22__images_tutorials_not_selected_png___default.a;break;default:icon=null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SidebarItem__["a" /* default */],{key:index,id:element.icon,image:icon,label:element.label,selected:element.selected,onSelected:onItemSelected,onGenerateLink:onGenerateLink});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EnterpriseSidebar,[{key:'render',value:function render(){var _props=this.props,sharedItemsTop=_props.sharedItemsTop,sharedItemsBottom=_props.sharedItemsBottom,onItemSelected=_props.onItemSelected,onGenerateLink=_props.onGenerateLink;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'enterprise-sidebar-admin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sidebar-admin-table'},this.renderSharedItems(sharedItemsTop)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EnterpriseSidebarMenu__["a" /* default */],{menu:{icon:this.enterpriseSelected()?__WEBPACK_IMPORTED_MODULE_9__images_enterprise_selected_png___default.a:__WEBPACK_IMPORTED_MODULE_10__images_enterprise_not_selected_png___default.a,label:'Enterprise',selected:this.enterpriseSelected()},items:this.props.enterpriseItems,onItemSelected:onItemSelected,onGenerateLink:onGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EnterpriseSidebarMenu__["a" /* default */],{menu:{icon:this.serviceWorkSelected()?__WEBPACK_IMPORTED_MODULE_11__images_service_work_selected_png___default.a:__WEBPACK_IMPORTED_MODULE_12__images_service_work_not_selected_png___default.a,label:'Service Work',selected:this.serviceWorkSelected()},items:this.serviceWorkItemsWithBetaLink(),onItemSelected:onItemSelected,onGenerateLink:onGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sidebar-admin-table'},this.renderSharedItems(sharedItemsBottom)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_modal_NewServiceWorkSignupModal__["a" /* default */],{currentCompany:this.props.currentCompany}));}}]);return EnterpriseSidebar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);EnterpriseSidebar.propTypes={sharedItemsTop:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(itemProps),enterpriseItems:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(itemProps),serviceWorkItems:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(itemProps),sharedItemsBottom:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(itemProps),onItemSelected:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,onGenerateLink:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,currentCompany:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentCompany:Object(__WEBPACK_IMPORTED_MODULE_24_components_admin_service_providers_store_selectors_js__["b" /* getCurrentUserCompany */])(state)||Object(__WEBPACK_IMPORTED_MODULE_25__selectors_admin_contractors_contractors_js__["f" /* getCurrentContractor */])(state)};})(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(EnterpriseSidebar)));

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnterpriseSidebarMenu_css__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnterpriseSidebarMenu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EnterpriseSidebarMenu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EnterpriseSidebarItem__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_react_fontawesome__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faAngleDown__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faAngleDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faAngleDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_solid_faAngleUp__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_solid_faAngleUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_solid_faAngleUp__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EnterpriseSidebarMenu=function(_Component){_inherits(EnterpriseSidebarMenu,_Component);function EnterpriseSidebarMenu(props){_classCallCheck(this,EnterpriseSidebarMenu);var _this=_possibleConstructorReturn(this,(EnterpriseSidebarMenu.__proto__||Object.getPrototypeOf(EnterpriseSidebarMenu)).call(this,props));_this.handleClickMenu=function(event){event.preventDefault();event.stopPropagation();_this.setState({showMenu:!_this.state.showMenu});};_this.state={showMenu:true};return _this;}_createClass(EnterpriseSidebarMenu,[{key:'render',value:function render(){var _props=this.props,onItemSelected=_props.onItemSelected,onGenerateLink=_props.onGenerateLink;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'enterprise-menu '+(this.props.menu.selected?'selected':'')+' '+(this.state.showMenu?'toggled':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sidebar-menu-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sidebar-menu-cell',onClick:this.handleClickMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.menu.icon,alt:'icon'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.menu.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'toggle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__fortawesome_react_fontawesome__["a" /* default */],{icon:this.state.showMenu?__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_solid_faAngleUp___default.a:__WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faAngleDown___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Collapse */],{'in':this.state.showMenu,className:'collapse-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.items.filter(function(element){return element.show;}).map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__EnterpriseSidebarItem__["a" /* default */],{key:index,id:element.icon,label:element.label,selected:element.selected,onSelected:element.customAction||onItemSelected,onGenerateLink:onGenerateLink,customClass:element.customClass});}))));}}]);return EnterpriseSidebarMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);EnterpriseSidebarMenu.propTypes={menu:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({icon:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,selected:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool}),items:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({icon:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,route:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,selected:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,show:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,customAction:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,customClass:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string})),onItemSelected:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onGenerateLink:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (EnterpriseSidebarMenu);

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnterpriseSidebarItem_css__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnterpriseSidebarItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EnterpriseSidebarItem_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EnterpriseSidebarItem=function(_Component){_inherits(EnterpriseSidebarItem,_Component);function EnterpriseSidebarItem(props){_classCallCheck(this,EnterpriseSidebarItem);var _this=_possibleConstructorReturn(this,(EnterpriseSidebarItem.__proto__||Object.getPrototypeOf(EnterpriseSidebarItem)).call(this,props));_this.handleClick=function(event){event.preventDefault();_this.props.onSelected(_this.props.id);};_this.handleGenerateLink=function(){var _this$props=_this.props,id=_this$props.id,onGenerateLink=_this$props.onGenerateLink;return onGenerateLink&&onGenerateLink(id);};_this.class=props.customClass||'enterprise-sidebar-item-row';return _this;}_createClass(EnterpriseSidebarItem,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.class},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.handleGenerateLink(),className:'sidebar-item-cell'+(this.props.selected?' selected':''),onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'},this.props.image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.image,alt:'icon'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:this.props.selected?'selected':''},this.props.label)));}}]);return EnterpriseSidebarItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);EnterpriseSidebarItem.propTypes={label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]).isRequired,image:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,selected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onGenerateLink:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,customClass:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (EnterpriseSidebarItem);

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export config */
/* unused harmony export icon */
/* unused harmony export noAuto */
/* unused harmony export layer */
/* unused harmony export text */
/* unused harmony export library */
/* unused harmony export dom */
/* unused harmony export parse */
/* unused harmony export findIconDefinition */
/*!
 * Font Awesome Free 5.0.13 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER$1 = null;
var _PERFORMANCE = { mark: noop, measure: noop };

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER$1 = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {};
var _ref$userAgent = _ref.userAgent;
var userAgent = _ref$userAgent === undefined ? '' : _ref$userAgent;

var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER$1;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var UNITS_IN_GRID = 16;
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';

var PRODUCTION = function () {
  try {
    return "production" === 'production';
  } catch (e) {
    return false;
  }
}();

var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);

var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];

var RESERVED_CLASSES = ['xs', 'sm', 'lg', 'fw', 'ul', 'li', 'border', 'pull-left', 'pull-right', 'spin', 'pulse', 'rotate-90', 'rotate-180', 'rotate-270', 'flip-horizontal', 'flip-vertical', 'stack', 'stack-1x', 'stack-2x', 'inverse', 'layers', 'layers-text', 'layers-counter'].concat(oneToTen.map(function (n) {
  return n + 'x';
})).concat(oneToTwenty.map(function (n) {
  return 'w-' + n;
}));

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();



var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var initial = WINDOW.FontAwesomeConfig || {};
var initialKeys = Object.keys(initial);

var _default = _extends({
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
}, initial);

if (!_default.autoReplaceSvg) _default.observeMutations = false;

var config$1 = _extends({}, _default);

WINDOW.FontAwesomeConfig = config$1;

function update(newConfig) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$asNewDefault = params.asNewDefault,
      asNewDefault = _params$asNewDefault === undefined ? false : _params$asNewDefault;

  var validKeys = Object.keys(config$1);
  var ok = asNewDefault ? function (k) {
    return ~validKeys.indexOf(k) && !~initialKeys.indexOf(k);
  } : function (k) {
    return ~validKeys.indexOf(k);
  };

  Object.keys(newConfig).forEach(function (configKey) {
    if (ok(configKey)) config$1[configKey] = newConfig[configKey];
  });
}

function auto(value) {
  update({
    autoReplaceSvg: value,
    observeMutations: value
  });
}

var w = WINDOW || {};

if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];

var namespace = w[NAMESPACE_IDENTIFIER];

var functions = [];
var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);

  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

var domready = function (fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
};

var d = UNITS_IN_GRID;

var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};

function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}

function bunker(fn) {
  try {
    fn();
  } catch (e) {
    if (!PRODUCTION) {
      throw e;
    }
  }
}

function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;

  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();
    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);

  return css;
}

var _uniqueId = 0;

function nextUniqueId() {
  _uniqueId++;

  return _uniqueId;
}

function toArray(obj) {
  var array = [];

  for (var i = (obj || []).length >>> 0; i--;) {
    array[i] = obj[i];
  }

  return array;
}

function classArray(node) {
  if (node.classList) {
    return toArray(node.classList);
  } else {
    return (node.getAttribute('class') || '').split(' ').filter(function (i) {
      return i;
    });
  }
}

function getIconName(familyPrefix, cls) {
  var parts = cls.split('-');
  var prefix = parts[0];
  var iconName = parts.slice(1).join('-');

  if (prefix === familyPrefix && iconName !== '' && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}

function htmlEscape(str) {
  return ('' + str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + (attributeName + '="' + htmlEscape(attributes[attributeName]) + '" ');
  }, '').trim();
}

function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + (styleName + ': ' + styles[styleName] + ';');
  }, '');
}

function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}

function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;

  var outer = {
    transform: 'translate(' + containerWidth / 2 + ' 256)'
  };
  var innerTranslate = 'translate(' + transform.x * 32 + ', ' + transform.y * 32 + ') ';
  var innerScale = 'scale(' + transform.size / 16 * (transform.flipX ? -1 : 1) + ', ' + transform.size / 16 * (transform.flipY ? -1 : 1) + ') ';
  var innerRotate = 'rotate(' + transform.rotate + ' 0 0)';
  var inner = {
    transform: innerTranslate + ' ' + innerScale + ' ' + innerRotate
  };
  var path = {
    transform: 'translate(' + iconWidth / 2 * -1 + ' -256)'
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}

function transformForCss(_ref2) {
  var transform = _ref2.transform,
      _ref2$width = _ref2.width,
      width = _ref2$width === undefined ? UNITS_IN_GRID : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === undefined ? UNITS_IN_GRID : _ref2$height,
      _ref2$startCentered = _ref2.startCentered,
      startCentered = _ref2$startCentered === undefined ? false : _ref2$startCentered;

  var val = '';

  if (startCentered && IS_IE) {
    val += 'translate(' + (transform.x / d - width / 2) + 'em, ' + (transform.y / d - height / 2) + 'em) ';
  } else if (startCentered) {
    val += 'translate(calc(-50% + ' + transform.x / d + 'em), calc(-50% + ' + transform.y / d + 'em)) ';
  } else {
    val += 'translate(' + transform.x / d + 'em, ' + transform.y / d + 'em) ';
  }

  val += 'scale(' + transform.size / d * (transform.flipX ? -1 : 1) + ', ' + transform.size / d * (transform.flipY ? -1 : 1) + ') ';
  val += 'rotate(' + transform.rotate + 'deg) ';

  return val;
}

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

var makeIconMasking = function (_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      mask = _ref.mask,
      transform = _ref.transform;
  var mainWidth = main.width,
      mainPath = main.icon;
  var maskWidth = mask.width,
      maskPath = mask.icon;


  var trans = transformForSvg({ transform: transform, containerWidth: maskWidth, iconWidth: mainWidth });

  var maskRect = {
    tag: 'rect',
    attributes: _extends({}, ALL_SPACE, {
      fill: 'white'
    })
  };
  var maskInnerGroup = {
    tag: 'g',
    attributes: _extends({}, trans.inner),
    children: [{ tag: 'path', attributes: _extends({}, mainPath.attributes, trans.path, { fill: 'black' }) }]
  };
  var maskOuterGroup = {
    tag: 'g',
    attributes: _extends({}, trans.outer),
    children: [maskInnerGroup]
  };
  var maskId = 'mask-' + nextUniqueId();
  var clipId = 'clip-' + nextUniqueId();
  var maskTag = {
    tag: 'mask',
    attributes: _extends({}, ALL_SPACE, {
      id: maskId,
      maskUnits: 'userSpaceOnUse',
      maskContentUnits: 'userSpaceOnUse'
    }),
    children: [maskRect, maskOuterGroup]
  };
  var defs = {
    tag: 'defs',
    children: [{ tag: 'clipPath', attributes: { id: clipId }, children: [maskPath] }, maskTag]
  };

  children.push(defs, { tag: 'rect', attributes: _extends({ fill: 'currentColor', 'clip-path': 'url(#' + clipId + ')', mask: 'url(#' + maskId + ')' }, ALL_SPACE) });

  return {
    children: children,
    attributes: attributes
  };
};

var makeIconStandard = function (_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      transform = _ref.transform,
      styles = _ref.styles;

  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  if (transformIsMeaningful(transform)) {
    var trans = transformForSvg({ transform: transform, containerWidth: main.width, iconWidth: main.width });
    children.push({
      tag: 'g',
      attributes: _extends({}, trans.outer),
      children: [{
        tag: 'g',
        attributes: _extends({}, trans.inner),
        children: [{
          tag: main.icon.tag,
          children: main.icon.children,
          attributes: _extends({}, main.icon.attributes, trans.path)
        }]
      }]
    });
  } else {
    children.push(main.icon);
  }

  return {
    children: children,
    attributes: attributes
  };
};

var asIcon = function (_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;

    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_extends({}, styles, {
      'transform-origin': offset.x + transform.x / 16 + 'em ' + (offset.y + transform.y / 16) + 'em'
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
};

var asSymbol = function (_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;

  var id = symbol === true ? prefix + '-' + config$1.familyPrefix + '-' + iconName : symbol;

  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _extends({}, attributes, { id: id }),
      children: children
    }]
  }];
};

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === undefined ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var widthClass = 'fa-w-' + Math.ceil(width / height * 16);
  var attrClass = [config$1.replacementClass, iconName ? config$1.familyPrefix + '-' + iconName : '', widthClass].concat(extra.classes).join(' ');

  var content = {
    children: [],
    attributes: _extends({}, extra.attributes, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': '0 0 ' + width + ' ' + height
    })
  };

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) content.children.push({ tag: 'title', attributes: { id: content.attributes['aria-labelledby'] || 'title-' + nextUniqueId() }, children: [title] });

  var args = _extends({}, content, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    transform: transform,
    symbol: symbol,
    styles: extra.styles
  });

  var _ref2 = mask.found && main.found ? makeIconMasking(args) : makeIconStandard(args),
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}

function makeLayersTextAbstract(params) {
  var content = params.content,
      width = params.width,
      height = params.height,
      transform = params.transform,
      title = params.title,
      extra = params.extra,
      _params$watchable2 = params.watchable,
      watchable = _params$watchable2 === undefined ? false : _params$watchable2;


  var attributes = _extends({}, extra.attributes, title ? { 'title': title } : {}, {
    'class': extra.classes.join(' ')
  });

  if (watchable) {
    attributes[DATA_FA_I2SVG] = '';
  }

  var styles = _extends({}, extra.styles);

  if (transformIsMeaningful(transform)) {
    styles['transform'] = transformForCss({ transform: transform, startCentered: true, width: width, height: height });
    styles['-webkit-transform'] = styles['transform'];
  }

  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];

  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({ tag: 'span', attributes: { class: 'sr-only' }, children: [title] });
  }

  return val;
}

var noop$2 = function noop() {};
var p = config$1.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : { mark: noop$2, measure: noop$2 };
var preamble = 'FA "5.0.13"';

var begin = function begin(name) {
  p.mark(preamble + ' ' + name + ' begins');
  return function () {
    return end(name);
  };
};

var end = function end(name) {
  p.mark(preamble + ' ' + name + ' ends');
  p.measure(preamble + ' ' + name, preamble + ' ' + name + ' begins', preamble + ' ' + name + ' ends');
};

var perf = { begin: begin, end: end };

'use strict';

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */
var bindInternal4 = function bindInternal4 (func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

'use strict';



/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */
var reduce = function fastReduceObject (subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i, key, result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  }
  else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

var styles$2 = namespace.styles;
var shims = namespace.shims;


var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};

var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles$2, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    acc[icon[3]] = iconName;

    return acc;
  });

  _byLigature = lookup(function (acc, icon, iconName) {
    var ligatures = icon[2];

    acc[iconName] = iconName;

    ligatures.forEach(function (ligature) {
      acc[ligature] = iconName;
    });

    return acc;
  });

  var hasRegular = 'far' in styles$2;

  _byOldName = reduce(shims, function (acc, shim) {
    var oldName = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    acc[oldName] = { prefix: prefix, iconName: iconName };

    return acc;
  }, {});
};

build();

function byUnicode(prefix, unicode) {
  return _byUnicode[prefix][unicode];
}

function byLigature(prefix, ligature) {
  return _byLigature[prefix][ligature];
}

function byOldName(name) {
  return _byOldName[name] || { prefix: null, iconName: null };
}

var styles$1 = namespace.styles;


var emptyCanonicalIcon = function emptyCanonicalIcon() {
  return { prefix: null, iconName: null, rest: [] };
};

function getCanonicalIcon(values) {
  return values.reduce(function (acc, cls) {
    var iconName = getIconName(config$1.familyPrefix, cls);

    if (styles$1[cls]) {
      acc.prefix = cls;
    } else if (iconName) {
      var shim = acc.prefix === 'fa' ? byOldName(iconName) : {};

      acc.iconName = shim.iconName || iconName;
      acc.prefix = shim.prefix || acc.prefix;
    } else if (cls !== config$1.replacementClass && cls.indexOf('fa-w-') !== 0) {
      acc.rest.push(cls);
    }

    return acc;
  }, emptyCanonicalIcon());
}

function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === undefined ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === undefined ? [] : _abstractNodes$childr;


  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return '<' + tag + ' ' + joinAttributes(attributes) + '>' + children.map(toHtml).join('') + '</' + tag + '>';
  }
}

var noop$1 = function noop() {};

function isWatched(node) {
  var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;

  return typeof i2svg === 'string';
}

function getMutator() {
  if (config$1.autoReplaceSvg === true) {
    return mutators.replace;
  }

  var mutator = mutators[config$1.autoReplaceSvg];

  return mutator || mutators.replace;
}

var mutators = {
  replace: function replace(mutation) {
    var node = mutation[0];
    var abstract = mutation[1];
    var newOuterHTML = abstract.map(function (a) {
      return toHtml(a);
    }).join('\n');

    if (node.parentNode && node.outerHTML) {
      node.outerHTML = newOuterHTML + (config$1.keepOriginalSource && node.tagName.toLowerCase() !== 'svg' ? '<!-- ' + node.outerHTML + ' -->' : '');
    } else if (node.parentNode) {
      var newNode = document.createElement('span');
      node.parentNode.replaceChild(newNode, node);
      newNode.outerHTML = newOuterHTML;
    }
  },
  nest: function nest(mutation) {
    var node = mutation[0];
    var abstract = mutation[1];

    // If we already have a replaced node we do not want to continue nesting within it.
    // Short-circuit to the standard replacement
    if (~classArray(node).indexOf(config$1.replacementClass)) {
      return mutators.replace(mutation);
    }

    var forSvg = new RegExp(config$1.familyPrefix + '-.*');

    delete abstract[0].attributes.style;

    var splitClasses = abstract[0].attributes.class.split(' ').reduce(function (acc, cls) {
      if (cls === config$1.replacementClass || cls.match(forSvg)) {
        acc.toSvg.push(cls);
      } else {
        acc.toNode.push(cls);
      }

      return acc;
    }, { toNode: [], toSvg: [] });

    abstract[0].attributes.class = splitClasses.toSvg.join(' ');

    var newInnerHTML = abstract.map(function (a) {
      return toHtml(a);
    }).join('\n');
    node.setAttribute('class', splitClasses.toNode.join(' '));
    node.setAttribute(DATA_FA_I2SVG, '');
    node.innerHTML = newInnerHTML;
  }
};

function perform(mutations, callback) {
  var callbackFunction = typeof callback === 'function' ? callback : noop$1;

  if (mutations.length === 0) {
    callbackFunction();
  } else {
    var frame = WINDOW.requestAnimationFrame || function (op) {
      return op();
    };

    frame(function () {
      var mutator = getMutator();
      var mark = perf.begin('mutate');

      mutations.map(mutator);

      mark();

      callbackFunction();
    });
  }
}

var disabled = false;

function disableObservation(operation) {
  disabled = true;
  operation();
  disabled = false;
}

var mo = null;

function observe(options) {
  if (!MUTATION_OBSERVER) return;

  var treeCallback = options.treeCallback,
      nodeCallback = options.nodeCallback,
      pseudoElementsCallback = options.pseudoElementsCallback;


  mo = new MUTATION_OBSERVER(function (objects) {
    if (disabled) return;

    toArray(objects).forEach(function (mutationRecord) {
      if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config$1.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }

        treeCallback(mutationRecord.target);
      }

      if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config$1.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }

      if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === 'class') {
          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
              prefix = _getCanonicalIcon.prefix,
              iconName = _getCanonicalIcon.iconName;

          if (prefix) mutationRecord.target.setAttribute('data-prefix', prefix);
          if (iconName) mutationRecord.target.setAttribute('data-icon', iconName);
        } else {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });

  if (!IS_DOM) return;

  mo.observe(DOCUMENT.getElementsByTagName('body')[0], {
    childList: true, attributes: true, characterData: true, subtree: true
  });
}

function disconnect() {
  if (!mo) return;

  mo.disconnect();
}

var styleParser = function (node) {
  var style = node.getAttribute('style');

  var val = [];

  if (style) {
    val = style.split(';').reduce(function (acc, style) {
      var styles = style.split(':');
      var prop = styles[0];
      var value = styles.slice(1);

      if (prop && value.length > 0) {
        acc[prop] = value.join(':').trim();
      }

      return acc;
    }, {});
  }

  return val;
};

function toHex(unicode) {
  var result = '';

  for (var i = 0; i < unicode.length; i++) {
    var hex = unicode.charCodeAt(i).toString(16);
    result += ('000' + hex).slice(-4);
  }

  return result;
}

var classParser = function (node) {
  var existingPrefix = node.getAttribute('data-prefix');
  var existingIconName = node.getAttribute('data-icon');
  var innerText = node.innerText !== undefined ? node.innerText.trim() : '';

  var val = getCanonicalIcon(classArray(node));

  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }

  if (val.prefix && innerText.length > 1) {
    val.iconName = byLigature(val.prefix, node.innerText);
  } else if (val.prefix && innerText.length === 1) {
    val.iconName = byUnicode(val.prefix, toHex(node.innerText));
  }

  return val;
};

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };

  if (!transformString) {
    return transform;
  } else {
    return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
      var parts = n.toLowerCase().split('-');
      var first = parts[0];
      var rest = parts.slice(1).join('-');

      if (first && rest === 'h') {
        acc.flipX = true;
        return acc;
      }

      if (first && rest === 'v') {
        acc.flipY = true;
        return acc;
      }

      rest = parseFloat(rest);

      if (isNaN(rest)) {
        return acc;
      }

      switch (first) {
        case 'grow':
          acc.size = acc.size + rest;
          break;
        case 'shrink':
          acc.size = acc.size - rest;
          break;
        case 'left':
          acc.x = acc.x - rest;
          break;
        case 'right':
          acc.x = acc.x + rest;
          break;
        case 'up':
          acc.y = acc.y - rest;
          break;
        case 'down':
          acc.y = acc.y + rest;
          break;
        case 'rotate':
          acc.rotate = acc.rotate + rest;
          break;
      }

      return acc;
    }, transform);
  }
};

var transformParser = function (node) {
  return parseTransformString(node.getAttribute('data-fa-transform'));
};

var symbolParser = function (node) {
  var symbol = node.getAttribute('data-fa-symbol');

  return symbol === null ? false : symbol === '' ? true : symbol;
};

var attributesParser = function (node) {
  var extraAttributes = toArray(node.attributes).reduce(function (acc, attr) {
    if (acc.name !== 'class' && acc.name !== 'style') {
      acc[attr.name] = attr.value;
    }
    return acc;
  }, {});

  var title = node.getAttribute('title');

  if (config$1.autoA11y) {
    if (title) {
      extraAttributes['aria-labelledby'] = config$1.replacementClass + '-title-' + nextUniqueId();
    } else {
      extraAttributes['aria-hidden'] = 'true';
    }
  }

  return extraAttributes;
};

var maskParser = function (node) {
  var mask = node.getAttribute('data-fa-mask');

  if (!mask) {
    return emptyCanonicalIcon();
  } else {
    return getCanonicalIcon(mask.split(' ').map(function (i) {
      return i.trim();
    }));
  }
};

function parseMeta(node) {
  var _classParser = classParser(node),
      iconName = _classParser.iconName,
      prefix = _classParser.prefix,
      extraClasses = _classParser.rest;

  var extraStyles = styleParser(node);
  var transform = transformParser(node);
  var symbol = symbolParser(node);
  var extraAttributes = attributesParser(node);
  var mask = maskParser(node);

  return {
    iconName: iconName,
    title: node.getAttribute('title'),
    prefix: prefix,
    transform: transform,
    symbol: symbol,
    mask: mask,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  };
}

function MissingIcon(error) {
  this.name = 'MissingIcon';
  this.message = error || 'Icon unavailable';
  this.stack = new Error().stack;
}

MissingIcon.prototype = Object.create(Error.prototype);
MissingIcon.prototype.constructor = MissingIcon;

var FILL = { fill: 'currentColor' };
var ANIMATION_BASE = {
  attributeType: 'XML',
  repeatCount: 'indefinite',
  dur: '2s'
};
var RING = {
  tag: 'path',
  attributes: _extends({}, FILL, {
    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
  })
};
var OPACITY_ANIMATE = _extends({}, ANIMATION_BASE, {
  attributeName: 'opacity'
});
var DOT = {
  tag: 'circle',
  attributes: _extends({}, FILL, {
    cx: '256',
    cy: '364',
    r: '28'
  }),
  children: [{ tag: 'animate', attributes: _extends({}, ANIMATION_BASE, { attributeName: 'r', values: '28;14;28;28;14;28;' }) }, { tag: 'animate', attributes: _extends({}, OPACITY_ANIMATE, { values: '1;0;1;1;0;1;' }) }]
};
var QUESTION = {
  tag: 'path',
  attributes: _extends({}, FILL, {
    opacity: '1',
    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
  }),
  children: [{ tag: 'animate', attributes: _extends({}, OPACITY_ANIMATE, { values: '1;0;0;0;0;1;' }) }]
};
var EXCLAMATION = {
  tag: 'path',
  attributes: _extends({}, FILL, {
    opacity: '0',
    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
  }),
  children: [{ tag: 'animate', attributes: _extends({}, OPACITY_ANIMATE, { values: '0;0;1;1;0;0;' }) }]
};

var missing = { tag: 'g', children: [RING, DOT, QUESTION, EXCLAMATION] };

var styles = namespace.styles;

var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var FONT_FAMILY_PATTERN = /Font Awesome 5 (Solid|Regular|Light|Brands)/;
var STYLE_TO_PREFIX = {
  'Solid': 'fas',
  'Regular': 'far',
  'Light': 'fal',
  'Brands': 'fab'
};

function findIcon(iconName, prefix) {
  var val = {
    found: false,
    width: 512,
    height: 512,
    icon: missing
  };

  if (iconName && prefix && styles[prefix] && styles[prefix][iconName]) {
    var icon = styles[prefix][iconName];
    var width = icon[0];
    var height = icon[1];
    var vectorData = icon.slice(4);

    val = {
      found: true,
      width: width,
      height: height,
      icon: { tag: 'path', attributes: { fill: 'currentColor', d: vectorData[0] } }
    };
  } else if (iconName && prefix && !config$1.showMissingIcons) {
    throw new MissingIcon('Icon is missing for prefix ' + prefix + ' with icon name ' + iconName);
  }

  return val;
}

function generateSvgReplacementMutation(node, nodeMeta) {
  var iconName = nodeMeta.iconName,
      title = nodeMeta.title,
      prefix = nodeMeta.prefix,
      transform = nodeMeta.transform,
      symbol = nodeMeta.symbol,
      mask = nodeMeta.mask,
      extra = nodeMeta.extra;


  return [node, makeInlineSvgAbstract({
    icons: {
      main: findIcon(iconName, prefix),
      mask: findIcon(mask.iconName, mask.prefix)
    },
    prefix: prefix,
    iconName: iconName,
    transform: transform,
    symbol: symbol,
    mask: mask,
    title: title,
    extra: extra,
    watchable: true
  })];
}

function generateLayersText(node, nodeMeta) {
  var title = nodeMeta.title,
      transform = nodeMeta.transform,
      extra = nodeMeta.extra;


  var width = null;
  var height = null;

  if (IS_IE) {
    var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
    var boundingClientRect = node.getBoundingClientRect();
    width = boundingClientRect.width / computedFontSize;
    height = boundingClientRect.height / computedFontSize;
  }

  if (config$1.autoA11y && !title) {
    extra.attributes['aria-hidden'] = 'true';
  }

  return [node, makeLayersTextAbstract({
    content: node.innerHTML,
    width: width,
    height: height,
    transform: transform,
    title: title,
    extra: extra,
    watchable: true
  })];
}

function generateMutation(node) {
  var nodeMeta = parseMeta(node);

  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return generateLayersText(node, nodeMeta);
  } else {
    return generateSvgReplacementMutation(node, nodeMeta);
  }
}

function remove(node) {
  if (typeof node.remove === 'function') {
    node.remove();
  } else if (node && node.parentNode) {
    node.parentNode.removeChild(node);
  }
}

function searchPseudoElements(root) {
  if (!IS_DOM) return;

  var end = perf.begin('searchPseudoElements');

  disableObservation(function () {
    toArray(root.querySelectorAll('*')).forEach(function (node) {
      [':before', ':after'].forEach(function (pos) {
        var styles = WINDOW.getComputedStyle(node, pos);
        var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
        var children = toArray(node.children);
        var pseudoElement = children.filter(function (c) {
          return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === pos;
        })[0];

        if (pseudoElement) {
          if (pseudoElement.nextSibling && pseudoElement.nextSibling.textContent.indexOf(DATA_FA_PSEUDO_ELEMENT) > -1) {
            remove(pseudoElement.nextSibling);
          }
          remove(pseudoElement);
          pseudoElement = null;
        }

        if (fontFamily && !pseudoElement) {
          var content = styles.getPropertyValue('content');
          var i = DOCUMENT.createElement('i');
          i.setAttribute('class', '' + STYLE_TO_PREFIX[fontFamily[1]]);
          i.setAttribute(DATA_FA_PSEUDO_ELEMENT, pos);
          i.innerText = content.length === 3 ? content.substr(1, 1) : content;
          if (pos === ':before') {
            node.insertBefore(i, node.firstChild);
          } else {
            node.appendChild(i);
          }
        }
      });
    });
  });

  end();
}

function onTree(root) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!IS_DOM) return;

  var htmlClassList = DOCUMENT.documentElement.classList;
  var hclAdd = function hclAdd(suffix) {
    return htmlClassList.add(HTML_CLASS_I2SVG_BASE_CLASS + '-' + suffix);
  };
  var hclRemove = function hclRemove(suffix) {
    return htmlClassList.remove(HTML_CLASS_I2SVG_BASE_CLASS + '-' + suffix);
  };
  var prefixes = Object.keys(styles);
  var prefixesDomQuery = ['.' + LAYERS_TEXT_CLASSNAME + ':not([' + DATA_FA_I2SVG + '])'].concat(prefixes.map(function (p) {
    return '.' + p + ':not([' + DATA_FA_I2SVG + '])';
  })).join(', ');

  if (prefixesDomQuery.length === 0) {
    return;
  }

  var candidates = toArray(root.querySelectorAll(prefixesDomQuery));

  if (candidates.length > 0) {
    hclAdd('pending');
    hclRemove('complete');
  } else {
    return;
  }

  var mark = perf.begin('onTree');

  var mutations = candidates.reduce(function (acc, node) {
    try {
      var mutation = generateMutation(node);

      if (mutation) {
        acc.push(mutation);
      }
    } catch (e) {
      if (!PRODUCTION) {
        if (e instanceof MissingIcon) {
          console.error(e);
        }
      }
    }

    return acc;
  }, []);

  mark();

  perform(mutations, function () {
    hclAdd('active');
    hclAdd('complete');
    hclRemove('pending');

    if (typeof callback === 'function') callback();
  });
}

function onNode(node) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var mutation = generateMutation(node);

  if (mutation) {
    perform([mutation], callback);
  }
}

var baseStyles = "svg:not(:root).svg-inline--fa {\n  overflow: visible; }\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -.125em; }\n  .svg-inline--fa.fa-lg {\n    vertical-align: -.225em; }\n  .svg-inline--fa.fa-w-1 {\n    width: 0.0625em; }\n  .svg-inline--fa.fa-w-2 {\n    width: 0.125em; }\n  .svg-inline--fa.fa-w-3 {\n    width: 0.1875em; }\n  .svg-inline--fa.fa-w-4 {\n    width: 0.25em; }\n  .svg-inline--fa.fa-w-5 {\n    width: 0.3125em; }\n  .svg-inline--fa.fa-w-6 {\n    width: 0.375em; }\n  .svg-inline--fa.fa-w-7 {\n    width: 0.4375em; }\n  .svg-inline--fa.fa-w-8 {\n    width: 0.5em; }\n  .svg-inline--fa.fa-w-9 {\n    width: 0.5625em; }\n  .svg-inline--fa.fa-w-10 {\n    width: 0.625em; }\n  .svg-inline--fa.fa-w-11 {\n    width: 0.6875em; }\n  .svg-inline--fa.fa-w-12 {\n    width: 0.75em; }\n  .svg-inline--fa.fa-w-13 {\n    width: 0.8125em; }\n  .svg-inline--fa.fa-w-14 {\n    width: 0.875em; }\n  .svg-inline--fa.fa-w-15 {\n    width: 0.9375em; }\n  .svg-inline--fa.fa-w-16 {\n    width: 1em; }\n  .svg-inline--fa.fa-w-17 {\n    width: 1.0625em; }\n  .svg-inline--fa.fa-w-18 {\n    width: 1.125em; }\n  .svg-inline--fa.fa-w-19 {\n    width: 1.1875em; }\n  .svg-inline--fa.fa-w-20 {\n    width: 1.25em; }\n  .svg-inline--fa.fa-pull-left {\n    margin-right: .3em;\n    width: auto; }\n  .svg-inline--fa.fa-pull-right {\n    margin-left: .3em;\n    width: auto; }\n  .svg-inline--fa.fa-border {\n    height: 1.5em; }\n  .svg-inline--fa.fa-li {\n    width: 2em; }\n  .svg-inline--fa.fa-fw {\n    width: 1.25em; }\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0; }\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -.125em;\n  width: 1em; }\n  .fa-layers svg.svg-inline--fa {\n    -webkit-transform-origin: center center;\n            transform-origin: center center; }\n\n.fa-layers-text, .fa-layers-counter {\n  display: inline-block;\n  position: absolute;\n  text-align: center; }\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center; }\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: .25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right; }\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right; }\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left; }\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right; }\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left; }\n\n.fa-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -.0667em; }\n\n.fa-xs {\n  font-size: .75em; }\n\n.fa-sm {\n  font-size: .875em; }\n\n.fa-1x {\n  font-size: 1em; }\n\n.fa-2x {\n  font-size: 2em; }\n\n.fa-3x {\n  font-size: 3em; }\n\n.fa-4x {\n  font-size: 4em; }\n\n.fa-5x {\n  font-size: 5em; }\n\n.fa-6x {\n  font-size: 6em; }\n\n.fa-7x {\n  font-size: 7em; }\n\n.fa-8x {\n  font-size: 8em; }\n\n.fa-9x {\n  font-size: 9em; }\n\n.fa-10x {\n  font-size: 10em; }\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em; }\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0; }\n  .fa-ul > li {\n    position: relative; }\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit; }\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: .1em;\n  padding: .2em .25em .15em; }\n\n.fa-pull-left {\n  float: left; }\n\n.fa-pull-right {\n  float: right; }\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: .3em; }\n\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: .3em; }\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear; }\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8); }\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg); }\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg); }\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg); }\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1); }\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1); }\n\n.fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1); }\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical {\n  -webkit-filter: none;\n          filter: none; }\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2em; }\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0; }\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1em; }\n\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2em; }\n\n.fa-inverse {\n  color: #fff; }\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto; }\n";

var css = function () {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config$1.familyPrefix;
  var rc = config$1.replacementClass;
  var s = baseStyles;

  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp('\\.' + dfp + '\\-', 'g');
    var rPatt = new RegExp('\\.' + drc, 'g');

    s = s.replace(dPatt, '.' + fp + '-').replace(rPatt, '.' + rc);
  }

  return s;
};

function define(prefix, icons) {
  var normalized = Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }
    return acc;
  }, {});

  if (typeof namespace.hooks.addPack === 'function') {
    namespace.hooks.addPack(prefix, normalized);
  } else {
    namespace.styles[prefix] = _extends({}, namespace.styles[prefix] || {}, normalized);
  }

  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll easy the upgrade process for our users by automatically defining
   * this as well.
   */
  if (prefix === 'fas') {
    define('fa', icons);
  }
}

var Library = function () {
  function Library() {
    classCallCheck(this, Library);

    this.definitions = {};
  }

  createClass(Library, [{
    key: 'add',
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});

      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _extends({}, _this.definitions[key] || {}, additions[key]);
        define(key, additions[key]);
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: '_pullDefinitions',
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? { 0: definition } : definition;

      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;


        if (!additions[prefix]) additions[prefix] = {};

        additions[prefix][iconName] = icon;
      });

      return additions;
    }
  }]);
  return Library;
}();

function prepIcon(icon) {
  var width = icon[0];
  var height = icon[1];
  var vectorData = icon.slice(4);

  return {
    found: true,
    width: width,
    height: height,
    icon: { tag: 'path', attributes: { fill: 'currentColor', d: vectorData[0] } }
  };
}

var _cssInserted = false;

function ensureCss() {
  if (!config$1.autoAddCss) {
    return;
  }

  if (!_cssInserted) {
    insertCss(css());
  }

  _cssInserted = true;
}

function apiObject(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });

  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });

  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;

      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });

  return val;
}

function findIconDefinition(params) {
  var _params$prefix = params.prefix,
      prefix = _params$prefix === undefined ? 'fa' : _params$prefix,
      iconName = params.iconName;


  if (!iconName) return;

  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});

    var mask = params.mask;


    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _extends({}, params, { mask: mask }));
  };
}

var library = new Library();

var noAuto = function noAuto() {
  auto(false);
  disconnect();
};

var dom = {
  i2svg: function i2svg() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (IS_DOM) {
      ensureCss();

      var _params$node = params.node,
          node = _params$node === undefined ? DOCUMENT : _params$node,
          _params$callback = params.callback,
          callback = _params$callback === undefined ? function () {} : _params$callback;


      if (config$1.searchPseudoElements) {
        searchPseudoElements(node);
      }

      onTree(node, callback);
    }
  },

  css: css,

  insertCss: function insertCss$$1() {
    insertCss(css());
  }
};

var parse = {
  transform: function transform(transformString) {
    return parseTransformString(transformString);
  }
};

var icon = resolveIcons(function (iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === undefined ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === undefined ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === undefined ? null : _params$mask,
      _params$title = params.title,
      title = _params$title === undefined ? null : _params$title,
      _params$classes = params.classes,
      classes = _params$classes === undefined ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === undefined ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === undefined ? {} : _params$styles;


  if (!iconDefinition) return;

  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;


  return apiObject(_extends({ type: 'icon' }, iconDefinition), function () {
    ensureCss();

    if (config$1.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = config$1.replacementClass + '-title-' + nextUniqueId();
      } else {
        attributes['aria-hidden'] = 'true';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: prepIcon(icon),
        mask: mask ? prepIcon(mask.icon) : { found: false, width: null, height: null, icon: {} }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _extends({}, meaninglessTransform, transform),
      symbol: symbol,
      title: title,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
});

var text = function text(content) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform2 = params.transform,
      transform = _params$transform2 === undefined ? meaninglessTransform : _params$transform2,
      _params$title2 = params.title,
      title = _params$title2 === undefined ? null : _params$title2,
      _params$classes2 = params.classes,
      classes = _params$classes2 === undefined ? [] : _params$classes2,
      _params$attributes2 = params.attributes,
      attributes = _params$attributes2 === undefined ? {} : _params$attributes2,
      _params$styles2 = params.styles,
      styles = _params$styles2 === undefined ? {} : _params$styles2;


  return apiObject({ type: 'text', content: content }, function () {
    ensureCss();

    return makeLayersTextAbstract({
      content: content,
      transform: _extends({}, meaninglessTransform, transform),
      title: title,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: [config$1.familyPrefix + '-layers-text'].concat(toConsumableArray(classes))
      }
    });
  });
};

var layer = function layer(assembler) {
  return apiObject({ type: 'layer' }, function () {
    ensureCss();

    var children = [];

    assembler(function (args) {
      Array.isArray(args) ? args.map(function (a) {
        children = children.concat(a.abstract);
      }) : children = children.concat(args.abstract);
    });

    return [{
      tag: 'span',
      attributes: { class: config$1.familyPrefix + '-layers' },
      children: children
    }];
  });
};

var api$1 = {
  noAuto: noAuto,
  dom: dom,
  library: library,
  parse: parse,
  findIconDefinition: findIconDefinition,
  icon: icon,
  text: text,
  layer: layer
};

var autoReplace = function autoReplace() {
  if (IS_DOM && config$1.autoReplaceSvg) api$1.dom.i2svg({ node: DOCUMENT });
};

function bootstrap() {
  if (IS_BROWSER) {
    if (!WINDOW.FontAwesome) {
      WINDOW.FontAwesome = api$1;
    }

    domready(function () {
      if (Object.keys(namespace.styles).length > 0) {
        autoReplace();
      }

      if (config$1.observeMutations && typeof MutationObserver === 'function') {
        observe({
          treeCallback: onTree,
          nodeCallback: onNode,
          pseudoElementsCallback: searchPseudoElements
        });
      }
    });
  }

  namespace.hooks = _extends({}, namespace.hooks, {

    addPack: function addPack(prefix, icons) {
      namespace.styles[prefix] = _extends({}, namespace.styles[prefix] || {}, icons);

      build();
      autoReplace();
    },

    addShims: function addShims(shims) {
      var _namespace$shims;

      (_namespace$shims = namespace.shims).push.apply(_namespace$shims, toConsumableArray(shims));

      build();
      autoReplace();
    }
  });
}

Object.defineProperty(api$1, 'config', {
  get: function get() {
    return config$1;
  },

  set: function set(newConfig) {
    update(newConfig);
  }
});

if (IS_DOM) bunker(bootstrap);

var config = api$1.config;


/* harmony default export */ __webpack_exports__["a"] = (api$1);


/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarItem_css__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SidebarItem_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SidebarItem=function(_Component){_inherits(SidebarItem,_Component);function SidebarItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SidebarItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SidebarItem.__proto__||Object.getPrototypeOf(SidebarItem)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(event){event.preventDefault();_this.props.onSelected(_this.props.id);},_this.handleGenerateLink=function(){var _this$props=_this.props,id=_this$props.id,onGenerateLink=_this$props.onGenerateLink;return onGenerateLink&&onGenerateLink(id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SidebarItem,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sidebar-item-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.handleGenerateLink(),className:'sidebar-item-cell'+(this.props.selected?' selected':''),onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.image,alt:'icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:this.props.selected?'selected':''},this.props.label)));}}]);return SidebarItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SidebarItem.propTypes={label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]).isRequired,image:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,selected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onGenerateLink:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (SidebarItem);

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAxZJREFUOBG1Vc9LVFEUPufN02epzVhQoYuI0IWrFpoUWRNWMBY4LsJtBP4BraL+gKI2/QG1aCst1CgHKmHKKEwXbRIiIlooFJRvUmueM/NO57tv3us5/igoL8x7d+79znfP+c655zFtMtxzx1tEvAEWGSDiThFpBZSZF4hkTpjHmZ3x1KMXixtRcO2iXEw3FL6sXBZfruhesna/5n+BLb6Z3Nt4m+/li/G9NcQ/zh9tW62Ux9S7LoDUu0l9jVh18rzZaZrH2pK33OaX+IROhxTXhzXFzdYn7OzOh68MxqzhgQFSr1KeJpE2Bb5PEA0352aeBbsbP5cy3ScrRHf0gHZln3cSdk9IbsEE4cNTkOr5U2Q5PX8ihZ3BKNbYqK2JVrmwZ4iNpho+POWEM7BZQmAQDiTXzRw7BCxsYAsJwQUMm+xXih91nrSZ01t5Wq2ULAtd0OhOq41NXN+eyr38AFnKInldK3Ci4aCNkgKpnji5EeliNp2i1ZVBQ1YpgqxO9IGhmS+RZX3DHLZupnsSCQWnjTqtAkcAiA9D6i2/IaEDwDBxmVme6Eydk4wm7GmNbODoA6dqzJ0gQ0nhvWaopyA12lvWsLWD96dys2c13TZwwnQ/jv/NwZ0qRXCjwjqNAxG+iYb5Vmri9V3sfR88ssf/KaeYpETsjMXx4HBXl1V+aTVVEd8M50gUEoTwLYdGw3Xfo0GBx+tlIPJK0YXTQuAFPaEDN0qN34UEmoCszuug6a7Rma/GUyUl38dVXycD1pbIi/qJaiVzutZRvaYRcSSDZt7NdD1G+MZTMDB9ovrGKAosYQQcRry3FrpUsExD1TeFMuC/CPXr7wxmGl2OLL5ETtPhlrG8G+Jjb8OhSX2gUjjjQsWCytGHIje17Pu7FWybOlUtTfY1UTWlFeNTGYILgqZUAKcR2+3vvqpt8jrKCn0CBLiuKP6tyEJmE6HvTatz7dpGr6UmZm4YYtODP69M6Ya2S576234BYnPNK57KKb3q2GxyX2MvenNUHv+7bUbEOH1bGj2IMbbl0xRQB0+j3T98TH8BNqnR1sViNnYAAAAASUVORK5CYII="

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAA0ZJREFUOBG1Vc9LVFEUPufNezOTUk61CV1IhC5atQhcWUkWFMU4A9GihSm6KEKYVdQfUNSiAYlaKJmLFhE4TgVBJf1wJbRokxAh0cJ26YyiOfPezOl89/mm54gSgXfx5r5zzv3eud/5zhmmLdaDJy/3llbcpLqTwnSYRZoRKsw/WWhWt/lYo5O/euncIuz1i+sNY2Pv4oVKISNVua6+pnp/3XuRLb6TiCSyfX1da2HfBuCH4y9a1srepIgcNUHMU5bIU4pEPjq798zD5i4vtVClcqzKfJFETsLGzJ/iUbvnSu95E2NseGAB9HfJndFti37tW8SmwaH+9Afj3OIx/GjieMWjESFq05D5XTGnIwA3GZvre4VpZKpfn441OMmtuKv/hqnFqpvXs53IPGEnOkGLhUDDKUA1038FBeDw49whJIAzOIvEgAVMRsDaSvm77ptsm05sd33EuqteT1XkguqjW8m1Iw61DV1OzYEWz6P3ilOMN0YP2uuSatKgqaH+1CZOs2O5hOVxCmCllXK38unoYbNUgq7tRBfwgoTujeSmUFBg2mqDVslUH5vQAqh48rki0uqb2WOWNypmT0jO6IXfhmsBjCoRlJK0IH5zSCUVwjRbZEpCreCPLWswGpMDmcH0aWJBQmQxP9twZh0DmDY6Sq9HgU7DgT6XQLDuZgZ6RuG7Pz6xv1ziLiZxnQZ7MhwPjFJhUb8rzUYVYWewR6FMgYg9x6nmArvrWim1a8YbaYA/vrykl/OXjd5XwttNRxF9DRyoPgoFTq/1pn8hU4CqpNDqm2lQ2zJRbZ4oFTSrAO1oU/XVgAMahNjNjky8xvWJqoZbYvpRtaV2C3zILB9Dt/IFVORhNL2Pja6/NOiLyFkROqWcak34VYStfrb5SKYvVTDBoUeAwcLPbYw+bZAi9AeRQ4+e6+6D+KFTcInqo1BhaYXwzNZvEDOUisA0ZGdHczd0TN6CrGKN0Q4AoF1tx1nYDiwAxw21eWaU0jYdozczA6nbhjPM04IU0uj1kg4UDcQQmgsObvdrQDGEAIohpFiIN3LDNMI81fd5TCl8HVfbDhA+xJhM9QzOAiMY+DXdIXBHBj2AsXbkr8mH9p9+Qf7/z/QP69vbi80fpAEAAAAASUVORK5CYII="

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAABLCAYAAAAs2+QLAAAAAXNSR0IArs4c6QAAChdJREFUeAHtWwlsXEcZnpm3PuJr7cRK3IiKHoRWSXqqVdS0PkrihuKuk1CZpKBwSCFVVBUoICRArqIUqKgjIRAVNApSpaCE1mpS27GgbYjXthoqOZFpGwgQqAK0SWibeNf39d7w/Wvv25nn59337LWzK2Wk9Zv5j5n/m/Ofw5xlQJB79ojoqY4XJLO2wZy383KNxwqOhN9fCNPEQmTqN8/I6XC9lNZOJlkxfg+Mj1mNfvPwKp8RgAWT12sGc6anNeb8Enx+6jO1pZQ8Gqr6LjibJOO5MyVmUriUKyVjN8c5MKpPcn4mnk76lUxC/ozIzXm65OgfLyeVBTOQSsAvvz9UvUNK9tyUHmB4CE4ppMuYlJUeVGMikK+yJiaWIbE9lU7au7TF2E2pCl0gvqdy0w44z2C/AaB/LxAo12w546MYPs+6Mh3EtI9hyl82NOQOjV25dZKZnsYwM61tGIo07qcDP8kN8c14KunX5OjRBe+Vtrf3JZWbZqZ9DFO+vLl5HJ93pstI+YmGqu+TVmIkc86ipa3hUykV5yCQ9i49BxsWVeWqA44+UrUKTsdtKmp072IZChWotHTFF2QMpzIOXfhegNwNr2pLbAlyUcBENMY4e1NyebA0v+LQ9DBxkfRHWlTAsdZkcj/W6RpfZnJ2AeB/WNbW/aIvPRfhRQMMsE9YTDahVZe42OGRxFs4K/6a1xnZLdNFARytq2yEQ7LXzQDM6RfRej3g/YczOYwKuZ5xfgtc1Lvd5DnnvSInp9aLG+mq70acC20g9OAay5K3MW6WW4yXI49y1GYZvstg/CZnnuAdx29fSUHFcYxP08mP1td8SprYQXH5FIaAtp5D7x+olF6nTtK0ZOeFEPugO7cg6+uLI7LvUWaxDZhgNmJmrfCWEx/iQn6rtK37gBd5qkhTmgdRaXd5kU8mg/U97BuwbKgpio6YT6IrfgdGkMPuOaDAcbRMqLSt63XPShCUDRuD0eHxMCr1Tj96TlmUb/kCHAlVPY4x9iMApS7rK9AyIw32xbLWriO+FKeFB+s3rJiwxl9H+bfPRT+u4wmw3LUrJ3rh7PMYS1+PKzq/mExoLxrG7xwmocvYFl9Ga/YZFka2Ic0Ay+8tbH3jglPPT1p+tSZ/8DJfJy0z6EXPEuw6uKy/VmVTAu7fumGZOTH+Cmq2WlWkOJRpo/6LHGYcLWw78Q5AJxxip/BVSNPEZ5nmObXopJsHatnIB39rhcJ6VQktN4gl5CdBUfZL3to6EONhgGRDSAo4evHszwFCA4uxeD5gsPqilu53swGg08ZZNw/Ruprt0mK7VQV02R6sZfcWtXRlJVjC4gqYJgeLW9PnUlOQAfZ/OSJvS0lb+GO1ErIt7go4+rH8Bg7R7KNSWr8Mbmyb7yybCZUzAzAdz2Cp/55qHM6LDhe3dXSqtGyNz5i0oqOXQlhvbQ8Kk9QkF2JPtgJ02j2zhSX/iibEWUuwNfxPjZbFCa2F5ZMP50XfG6rVvAcuD/vFN1Rfu3JCjt7HmVhjSZlj63N+xWD8oN+JD64sbjMefBSnH7djbvG84GO3tdQuezqiKffXVVeazOqyhTgbKS03lvIXw6M2LUkkdgt4+sS3sYN6Bo5+vpsoJsAPpRDby1o7O9z4Tlq0YdNSOTLyW4B+2MmbS1rr0liKHnBkctorWNKL9Jx4Cr5r02xgSQbzw3JuyTcidVUvjHz+M58kmlugyTNSV73bGhl+N11gaQOjd2nJVquFc8nfUtPJ4n1bam5gk+Ze+NwpAwAYENo1Nj6xM1JX2QOnvJNz8QEcnVGsgCuwKtwZGb60ETIlXvJLWeC0AIbEyxpg9O9Vmr1C/t1rZnzCegK6ytEqjwrOfobz9UHKA/uKW2D8TsjYwwitTT1sHejrcIoZK2qqfM2KGJ3+wPnphfYhiLoL2JIzIzh0OB/Mr3hVA4ydz0rqc3awjPN2PEUEtVermgGAPw4e625S1bCf/h32UwfQwjeq9FTx2F6as6bgylv38v37J1LJJ+NrYxgGa7OaNKyU962UOZ2CAIi2MRciQLssLeCk40TwHvFpIfiX0FpvkQenCTgTOJ5FV382UCBuKDvW1ThfsJS91sJolSVqAxtGzpDTBrd0/xirQL+wuyrAmMV55a5rN98TnkQeh+g3NQOPVqPcm3GtvRyTXR5a4CMsPBeNADtZfLTrrFt586FpgGEz7Fa69KSp94DZSpKSTiftgC475HYSaQtMR4LNr11B9KiTvpBpDRBqeEwtTHADfnXqIC3h6JqZdfKhItAAqwxfcTGpdAtfmosunB7Ai2723At0jGE9o0lrvAceUerW8+Hf6iUsfiopYMzYtDdObZUHkdSZLI6E1qWxrvw3LcXyNOWTFmP0TDTABg88DtD/0kX8pbAGnzO40A7//OVwTfpaDVyrAR81YPu/bjr9m6vWW5PyIPGEEfhySWvHm25y2USbFXB/qKbcktYZ+MUrCBAdzRhLitYWN//+o2wC6LRVm6VVJm45cT06BZboWJOXm8NDz6sy2Rh3beH+UOVm02KvugISxtaytrA7z1Uhs4gzANNmPjJi/RVNal+16Cbz90uN0tX2NanOzPjUjC6N9xuNGlgc1WJrP5JAIj8RtaKNiXR2xbQWjj0Vssy/TPnQU0BQI0/TCRwO1J+JQ8MENs6FsSYbbyS0FsZJ/U9VsOQmltxU9FzJjYVNFI8DJhmSjaez6Wu3cCRUeTeO1E5h42PTUBufDbZ3v0aA8JpuE441/qCC4yxwT2l7x2mVlunxRAtLjuuRBFigPh4HSyAoTjQNEMfBe5aFGOCBzRtWY839nGo7rkh/oKZjccP4vkojHdJVaZkejwE2zQm8rEsEHHwfCbZ10oNPLdCzfOKpRKeuysvEuKCX55iEdqjGCc73qWk17uSR7kK9XlfLTVdcDLBILRzHwniGaME/lxzr/FM87fwSj2QSdFkYYQMPJdKZHRO47Nqsm8h/paddUoLpz/mkWe8ilZEkjGF+h2pZoIDPuBNS+RQP5IsWnabnofMyK4V/7Ezc5KGrXipqDl9KZSLJkKwtp+Rh0zI0InBxlXiaAE/Cs52KLPLI86x3lQVpWbI39FhXy+lGL5VNsVs//c101rzOwyU93jcrgY+M3q8kXaNOGWcerkoZQhTYCXWotph4FowHJfQGwzUQj2Q0piMPjZdhCfgR4iXtJl7Ktf3DHx6QOx6y1+a4zUQjHia6tXEa6VIe8XSmf9Eb8dyoruol3A1/QTWWtoMY04dxXNkbo1vmXaA9BtoqTY7xl0vbu7aptEyOxwAPNtRUTI6Yb8NNXO7HWDrJDCwx7vCylPnJdyFlY5sHMlgYfCvQ93ktjGRJJ5vAErYYYIqUtHSdNHL5/ei2s/rRJEeBZEiWdKYo2fM31qWd5kbrK+ssyRvwUmM9DgWuIz4EL8LBOCm4bA62drc7dbIl/X/0sodRov+ApQAAAABJRU5ErkJggg=="

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABFCAYAAADpc6CZAAAAAXNSR0IArs4c6QAABZZJREFUeAHtm39sE1UcwN+7lskkG2jEiCH6ByIJmPiHiRImf+CvLWZQS8L+I5GtzPiDsJJoIP7nn4BurYkJ7brhJERKpK1NFtE/SlSMJmJijPxhFP4QY5zBrUy3Du7e8/uuuyaj17t3745b73qXdN3ufX9+7t37PYwcvkZGz+0hBGUdNstlTpJQ31Bs91kuYU4hiVOuZcUCQCaPPgAUADIhYFIc1KAAkAkBk+KwSbnlYomGf6dY5u9qKe6miHbqOcII30CYntcr07vHfOvdt3MP21F2Qve9VO5nhOhmfVv48qHB6Bb9MnfuBm2QCecAkAkgx9sgE3/LXvx+pvCgrKAdGNH1FNN2g4AuxPdHL7QMoORYfrMik6MyIS9Cp4ApI6P+0EeEsdo8twagRCofVWR6CnjcjagBFR1Wvq9Bw6OFLoUqH0NtadPJ3/SWrxvpUqkURpRkROEwer4G9OOVmQildJNpNTEQ8DUgStBOg9y5inwNCLqpR7goGAg51khnszT0Rzm/HWH0JCKIVeuH4NMBc6lVlOKGDwI60w2N+hVWVp2KGGRgVETRBsO+3Eh3scwWoImJ86uuL/zXDbYi18q5XmgM760bW6jZN0JgHD6MV+4C2w3maebZNfZqrqtJCAEaHy+tLMvTB65X5o5AEPdoxvz4bQkQ9AjScCa3d+bWzDsABl4hJ55Rc2PlBpQcm1w7ks6fg3Sehqrf3Fk5GB0XoGSm+LisVArg92EHfXvCVMPeRYuezWNkIl+EStNycBgDwxo0ki48T5ByFuCENGCt9t2wBiXGixspJWdg8tuycFhl0AV0IvvFaiLLRWiMfd2F87wNuq/YXHk2DTXH1iSPx7kXZOpqUDL96VaAs8cLwbsRYx0gBSlH3XDsFR9LAI1kCrtgtLzdK8G7EecSQJSQw2449ZKPWiM9/NFn61BlfqtTwcOuwCWwdYliNAVbCIpTdq3YgV74FRjDPWBF53bZGiC8UNlFYOHmdgGrfwOYbBuW3n49FvnVqq7T8sOpXBdAcgYQJTRiM0ACcF6FzbaUTTtOqv8Axp6zY1Btg9j6Dhh5xpYhjA43GRyYSIXP2MmJ6aqAyvKNR6EqstU7oYu1Nwdj0eNCyndQKd6/E2oQ/sSOi2ovhhVbo2Y4x3MMIDXlIlGn1D4I8f0mCqkKCElrRQ3AFrbSIeFJUf07rReL9fyD2tvZZsK3Ir6qgAjsPoheFE0NDERmRdXd0Ivv7fkzHot2QYPyMjzQi+CT8PpVu3k467BSdBWVIjzN62w55aAJYFA+ZB/WKf0rz66jIWJw/KXtbxavNg6yPf5hxrxy7du3owKxXuWJd7EN4hFtTZkAkMlzDwAFgEwImBQHNcgEkNqLQRc4Bcusl01kdYvhtOiyz9p1A3PrZvLUZGcinXvCLX/N5sfwFWNwlLmFz2G1q5QYy29rtuDdiKfhAFGDA7P8p9RAMJ4NhXDPwf6XvnEjsGbxoQuoDo4WbQtCqgPUEE6LQloCyBROC0KqNdLsEKYyv5CttTkaDL1vSjsUhRSTJ3NwSNLfVw0QnFA9AJuG3dzpwoFN+Saa4Jb3qKAKiB3ZBzhHrOdAtyVGc89a1/OOhgrop6vTXRDy/SJhw15aVETPKzoqIEWRHhMNGPYahXVFfbqppwKC0/C6/3XMFQhG4rpcDpZXqAoI0b/Ew7CjK+7VLU0V0AqCvhZ1KFHMdgl8e6mA3hjc/Qtsrn1nPUss0/CK09b1vKOx+IrBBq0kvQVhc+8XqSli+kG8v/eKd9K1HmkN0FAs8qWEMYPEdcEi21frV296k0vYw0I1QCyHof3Rd9nuI4JZu1FOWMIn14TXvNDXt+WmkZwfypZMVrWETpwu3jc/d+s1+JfGXoC1EeZncDwGX4PfS/BJHRqIfK/J+v37f1EEsPUUcuwaAAAAAElFTkSuQmCC"

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABLCAYAAADEW1EgAAAAAXNSR0IArs4c6QAABUFJREFUeAHtXF+IVUUYn+9414119Rr4kERgFCb6oNCaLKEkvayh9bQUQtmDifjQqz0V9bZPQQ+h1oPWS7H0YIktVCCKLOVCrWBUCAkSBknubde1de/er29u58g938449/PMzO7dPQeWe7//v/mdOXNn7t4ZUOya3tv/6Ey9flgBvqRQPU7mXuYSQ5xSoH5XCKe7K5VjPWdG/whdFFoL1Ab6XmkodYx01Vb9Ar+vJUodro6MfRYSxz0iai/0vYoNdQoV3YtFdhEghEQdqJ4d+zQUtGaj/9nXv6lRnx1HVCtDFSqaF0DdTSpdW9d8NfpL0VymeOp1ShEJHyxmEjRGjU/j1O9DXDC5Z8fmOs5dCZE8RM4KrNiy+uvvf/adu1JXjZeNSQEmE1TPV0cuXTLaAyprA9u3N0B9R91gNS+T4n2H64vKCSDuNCWhwePDhSBBY9F1dX0jLgtek69ElyDARlMAKvzcpI+ls9W34S2KKwGF60xJ1nZ1XzXpY+ls9W14i+JKaDTuNiWBLy9OmvSxdLb6NrxFcTU/PosmWQrxFWkjcHBwZW3q2nuI+BrFrm+JvwEAn1R7N7wNw8N3M73UP4uL/SomIiXhqAHoeiLnKNm16a3MLvXP4mK/ih+NtCdYcXI7l3mgy879Q8liIkIBWei8YiL0OHA/0NzOZR7rsnP/ULKYiOZgCDBEgG4wUHqwHNL2Vr3UvzU25nu4NdBHX0HMvx4eGWsu0edb4mliYhP3iHg0xK1UEpHyLZ5HxL1P5mq2R8bsndfqb7pQwVVQcKr62Lb34cSJWe2x7HpE85s4xM2IjaGJ6z9+i68/99CyJCLXPxB3Tfx5W38CKvGjIV07SP1zQGMIgAdrg/3viomQrh2k/jHanquBqgen5t4QjxGutQG3czkHggSXnfuHkRu7xD0iDBBZ1q5Ksq33zA/jsiilpvY+s3W23viJx9GnyAZxj3CtDbidyxyEy879tbxqXc+vJr1LZ49DORHStYPU39UYbYeT5/5tx4/7WONonFh2aw3bZEz8aHCWl4pcEpHeyZKIkoj8Q132iJQP8YRKunaQ+ufvk1vylV9MhHTtIPV3Nz3v4Su/+NFwrQ24ncv5ZhRfa/jKLyaCN2SpyGIiXGsDbucyJ85l5/5cdsW77Fk+MRHStYPUPwPW7quv/OVaI2Vc3CPavVOd5lcSUfaIfJ8te0TZI/I9QjzFls7tpf55eG7JV34xEdK5vdTf3fS8h6/84jFCOreX+ueb6ZZ85RcT4YbWmR5iIlxzd27nMqfJZef+XHbFu+xZPjER0rm91D8D1u6rr/zlWiNlXNwj2r1TneZXEpHeMfE8wnanfU1sbPlD670R4WtiE7rBtvzeHg1fExsb0NB6b0QQ0Na9GybcLrspJprOJxHRQIcoVBKRsloSURKRf8AS+m3yTF71v4QvPjtvO7LJL5QO9+xYEyq3KS9t/4abJsPE7MyTJn0s3YSaeyJWLV1H7w3/zVSQfr1u3jxvcg6gu1/97Ifk0rLWOFDTFdprfYF+/rqbJ6VtPUdo1/4XPjfK46FDXbyOSb5zffzpGYVH6H/lJrOa/uvOFsp12Wg0KY8fr9P3Enj75vRTJjP9YPFax50fYW5IMS2Nk2cTfSgFvfmmWKpOj07ON+cRdHbLm3pnS6c354Hw0/gAvSs+ahKhD7AhIg7Stj7zQ/lAFTokCOHj6vDo3/dmlvpoIyJiP8GvdUgTisMEOL/2kVXNfe7z9nYuhpPJ6LAM2nqlD8QCOh9M6T990ZwH6eAPshY4K0sPAabNbf8BfIDP8VTkQlwAAAAASUVORK5CYII="

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABLCAYAAADEW1EgAAAAAXNSR0IArs4c6QAABW1JREFUeAHtXF9oHEUYn9nbq7WmlYIvUgRFsdI8tJD6aKH44kuMvlQRtMScWgtGfdInRd/yYjWCVr0Yoj5owT8xUAQVoT5a0AqVKgVFKIKIpU1ak97ejt9s9663X2dv8uvN7PXSXUhuv//f/HZmdr5LZqRg19tzC1v+a0T7RCzGpFC3KSGGmIp3UgqxpIT8XQRi/vpqePDpvaOnfAelmJeuN+rzDzfj5kHi3HiJ2/e7M5Wgsu/Z2tjHPjNpA3Gg/vmjQok5pVSb5zMw4ltKSR1E7H2+9uCHiB2imzT6zdmFuxpR4xgBsQ4xLlRXigvVsLr9mfHREz7iBtppFDWmr2oQdJL0kJI89b2HS06//8W2KIqPe/DtxWUYBsOTjz/wi2vnYRSJh4xOpVwMwsq9z43f/4NR7pH5+uyXd8dR81uh1EYeJs33Zc7vlaahEd9jckLz01v9AEHnouPq+Ka88vI1666eq+eIO03qFVH5xMQvitclvjHfXvMKpJA3mZzcIMVJE78oXl78vHx7zStQQl1ncjIxMbZo4hfFy4ufl2+veSWvz16drAX7EG3EoUPH1506++urVIs8RnXIzS17Wpn9RbXBB1s2bX1pz57hCy0+qt+yK/oTBkKDoGLxAk80AYX4JNeiF1tyVL9lV/QnPjSoJ3RNkss5zY1tcq7vicaB8JRIv93iQNA80DVpLuc0N7bJub4nGgZCT4YyEFPJ5NiRlKY1X8s72ALV77Qt8h6eLNM3gp4M2xNit4RR/W6+fMrgHuEzmX76LoFI0YeHRj+fWiv2a+9+RsuWK7zomy6h5Emaz+Y27LjlwFM7dza0p2uvRyRfR6ptKlZT53/885vZ2e/WX5tAdHQkpcSu09HpKc2ChwZaO6D6HXkWciuVrNXrX70CA4HWDqh+Ia3vCEJl/YalePkJfI6w1QZczumOJJJbm5zre6BjqXbBPcJDHrDLsFLdMTkxegw1nJ5Z2B41Gz9dZqfErXiPsNUGXM5pnoVNzvWJ3hgMJbW+QdSVlWdH5QEOBFo7oPpdW5IKx8d3L69Gj+vk2el5Ah4aaO2A6vPki6LxoVFUZgXHKYFIAS+BKIHIjr2yR6R4wG8NtHZA9bPPyU658g8DgdYOqL696VkNV/7xoWGrDbic09l20F/5LX8n4fqcttnb5Kk/HAieyBqhcSBstQGXc5oDZ5NzfU7b7G3y1B8MBFo7oPq8nTbalX94skRrB1Tf1nAud+Uf7hE8kbVCl0CkT7IEogQiO6jLHpHiAb810LU9qp99TnbKlX8YCHRtj+rbm57VcOUfHxq2tTuXczrbjrLW4Hj0m8Z7hG3tzuWc5i22ybk+p232NnnqDwYCXduj+rydNtqVf3iyRNf2qL6t4Vzuyj/cI3gia4UugUifJDw08nqAq4VNnn/ffGdAuFrY+G5wnn93Q8P3wimvBY74zoDo3Lthys0mN9kUyXMGRJFJ+4hVApGiWgJRApEdYHrf50qWdZGamZm/bDuySc8Xb/qjw5t8+Tb51fs+/zEJzilxh4lfGG+5cXthsSiQniN+MwVsiqZ587xJ2QOvW/zWP5KjYfPsaFScp5Vl8D19TbSbO6WDRfbTrv1PXW6Uf+fo0SqPY6JXTvw9Ei2v7NeHRpius/LcMPn62SQz8Z4cGYn0qSSL8dJWk5yi/DFw50eYGtIzT8rDgT6UQkrxdc/OBthBoOSRZB0RhtVJOsymvY15gNsEp67nh6Fg/XsJEPoAGxpDteR0H9jVYBsoqeq12n3/tleW+mijQAaPULPODHbTVp89TQlHNoebk33u9I/p2evqOJmMzp26+MaIKTv9oy/90OiHzkuj3WkJ50p+5Wxu+x8oRHVGq4ZcDwAAAABJRU5ErkJggg=="

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAoCAYAAACFFRgXAAAAAXNSR0IArs4c6QAAAgtJREFUWAntWT1PAkEQ3dkEFYMRSxP/gbHjo7IxFEBpYmcnwl9Sgp2/AYwSSyPE1l4TezHiJ8mtM3hzbOJ5kWMXr9hrZm529+27d7NzyRwI/1JKwVO1UBNCHSglNjGc4bEoCwLuBMhGttM7j5pnagwI6GV3e3309n6KpHdiAQM8L0FqK92+uo+1fopFkpSdiSxtptTKhzdqTbFv7KmS0iC2stq2SqjSoFpoaCErLgwquWvM2SKjA0BnQcj6cqf3wLHf7KCcvyCiwfgcUgNTYnzAgj3/SpYWLMpUTSDJYPEcUgMeyzkVbIjO2tnN+CDqsSif0kB53lHUnJhjQwBxKwScrLb7LXzzY54yJliwLNvuH2Np6wYBc06GUhXPVxPPWZcqGUHPTJhAfqQGBQ1eVBT8SgZGCFP9lRL2xh8Rg0R1KCJNFW3mHNZBTfqvleLGp/CaSLTCuJjTPSMKM6BJS2WVKpaOSRUtsYSJaMi3IJNowrq67DvCrIQt6xS2pSzjOoVZCVvWKWxLWcZ1CrMStqxT2JayjOsUZiVsWaewLWUZ1ynMStiyTmFbyjIuKTzkG7LUD9Dv/9MP4TKU3w23CS1qXoRMnEyYk8eNFH074or94fwhNdz0gaT62MGsA5KlnzFd6l0llSjxQrKX2HYtYUqASqWX9imQVMLEzeeogua1r/TUv70sPmRoQ/sLdXrCQeq54J4AAAAASUVORK5CYII="

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAA8CAYAAADSfGxZAAAAAXNSR0IArs4c6QAAA0VJREFUaAXtW79rFEEUfm9uExNIYyliKWnsrTSFoiKIlzQ2Koh3qdRcoq0KYmEKTxNIk0QEY2PjRQRRUfC08m+wEUQsBRESTG7H+SZ34WZvLprc7Y9wbyDczsvu+/Ht92bewhsmz5hZrByrEZ9jrY+S1vs10ZDntv8SMfFXYloqFfK3mdmoyubgZrdmHr88WFtbXyDSI83yblwz09xkcexKN3TFoWMTiPLC8hHDgBea9N44DFmdOT45dXn0bWz6O1BsgQATwrX1z7GCACeZvwWDew5dO3/6Vwc+x/KoglakQ+wgwJDWB2orq/dxmbXBdmEM9btEHctgigTYHcyrasWB6Y/S6pYeHHgyeeHUj9YbtpaUH1VOUE2/8d4V0uLs01eZShFlt0iPtwChNJ6f3gkIUGcXRaXMDuQZGUwRhTrB4yqBCT75dmTBQP8NLJC+Z7SmgmWN758pyLg8/9yTF+aNjo9tbq2d+LVlinSieBvPmkB+mxfyXTN/zJF+NlEYfR993O4aUWE350gRU0wtdlPndnWZNz2ktR6mMCzWzMZQnq98QMnQrCd2IGAsNzhwvV2KNDuT3LUeQd2EIrJhMxEgbAGlqNAwmoVf1E2opBvMSAQIBF5PkbksgNDwAWBsfFsRJQYEjJcKo1dJ8V37RdrwJvVfPYKiMkjSj/pn+E1jE3+JjQdLr/fxyurFkMM7pnbsjxpGUZkoEFEHkprXi8Lph/PLFFJ4L2oXRWWiqRF1IOl52yLRFJU9BUS7zwXUGT0FxFYMFCDq6AgQAoSbKMIIYYQwwkVAGOHiIWuEMEIY4SIgjHDxkDVCGCGMcBEQRrh4yBohjBBGuAgII1w8ZI0QRggjXASEES4eskYII4QRLgLCCBcPWSOEEcIIFwFhhIuHsl2prszO0HfkEe9qUbuYgIFCa64vOjRf+eS7WdY2JoNBgP5k05g+HA0QHWhovtrpMYWovjTnka66FleAQToHV1pcSVeQU3xcbXSqczVdV9K0zlVgYAuqXF9QNN2wP9N0Jw3biBmxw7YFYuLSmS8mT872EhiIFTEj9k0gcDFVzH9SfcFhcyaxB9KEq4gVMSN2DLOFto5uHolu1Z68BHXCv07w/AU7MBTpHxY5kgAAAABJRU5ErkJggg=="

/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NewServiceWorkSignupModal_css__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NewServiceWorkSignupModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__NewServiceWorkSignupModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors_admin_sidebar_sidebar__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_admin_sidebar_sidebar_js__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_close_png__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_close_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_images_close_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_selectors_authentication__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewServiceWorkSignupModal=function(_Component){_inherits(NewServiceWorkSignupModal,_Component);function NewServiceWorkSignupModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewServiceWorkSignupModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewServiceWorkSignupModal.__proto__||Object.getPrototypeOf(NewServiceWorkSignupModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_admin_sidebar_sidebar_js__["c" /* toggleNewServiceWorkModal */])());},_this.buildParams=function(){var user=_this.props.currentUser;var company=_this.props.currentCompany||{name:'',id:''};var fields=['569ni='+company.id,'825b7='+company.name,'8vn45='+user.accountable_type,'3751f='+user.first_name,'11g0m='+user.last_name,'6v740='+user.email,'7bi7q='+user.phone_number];return fields.join('&');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewServiceWorkSignupModal,[{key:'render',value:function render(){var script=document.createElement('script');script.src='https://paperform.co/__embed';document.body.appendChild(script);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["o" /* Modal */],{className:'new-service-work-modal',show:this.props.show,title:'New Service Work Coming Soon!',onClose:function onClose(){}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'close-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7_images_close_png___default.a,alt:'close',onClick:this.handleClose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'modal-underline'},'Join'),' SPACKLE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-body'},'Make your life exponentially easier',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'modal-emphasis'},'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'SPACKLE is a marketplace designed for building owners, facility managers and occupiers to connect with qualified contractors, automating the entire process of searching and hiring for small construction projects and service work.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-cta'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'modal-emphasis'},'Sign-up here to join the network and get to work!')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-paperform','data-prefill':this.buildParams(),'data-paperform-id':'iaiercyx'}));}}]);return NewServiceWorkSignupModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NewServiceWorkSignupModal.propTypes={show:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,currentUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,currentCompany:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{show:Object(__WEBPACK_IMPORTED_MODULE_5__selectors_admin_sidebar_sidebar__["c" /* getShowNewServiceWorkModal */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_authentication__["d" /* getCurrentUser */])(state)};})(NewServiceWorkSignupModal));

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorkOrders__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__creation_NewBuilding__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__creation_WorkOrderCreated__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__creation_Tasks__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__creation_WorkingHours__ = __webpack_require__(1892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__creation_WorkOrderSummary__ = __webpack_require__(1896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__creation_BuildingSelection__ = __webpack_require__(1907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__creation_SubContractorsUnionTrades__ = __webpack_require__(1909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__details_WorkOrderDetails__ = __webpack_require__(1917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NewWorkOrderRouteGuard__ = __webpack_require__(2316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__creation_ClientSelection__ = __webpack_require__(2317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_messages__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Parent container for all work orders components/routes. Also catch render errors and redirects to /
 */var WorkOrdersContainer=function(_Component){_inherits(WorkOrdersContainer,_Component);function WorkOrdersContainer(props){_classCallCheck(this,WorkOrdersContainer);var _this=_possibleConstructorReturn(this,(WorkOrdersContainer.__proto__||Object.getPrototypeOf(WorkOrdersContainer)).call(this,props));_this.state={hasError:false};return _this;}_createClass(WorkOrdersContainer,[{key:'componentDidCatch',value:function componentDidCatch(error,info){this.setState({hasError:true});this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_messages__["d" /* showErrorMessage */])('Something went wrong with the request, please try again later.'));}},{key:'render',value:function render(){var _this2=this;if(this.state.hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Redirect */],{to:'/'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/',component:__WEBPACK_IMPORTED_MODULE_1__WorkOrders__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/new-work-order',render:function render(){return(// Only show client selection if user is admin and no WO is created yet
(__WEBPACK_IMPORTED_MODULE_14__services_utils_users_util__["g" /* usersUtil */].hasRole(_this2.props.currentUser,__WEBPACK_IMPORTED_MODULE_14__services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_14__services_utils_users_util__["g" /* usersUtil */].hasType(_this2.props.currentUser,__WEBPACK_IMPORTED_MODULE_14__services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR))&&_this2.props.currentWorkOrder===null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Redirect */],{to:_this2.props.match.url+'/client-selection'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Redirect */],{to:_this2.props.match.url+'/building-selection'}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/client-selection',component:__WEBPACK_IMPORTED_MODULE_15__creation_ClientSelection__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/building-selection',component:__WEBPACK_IMPORTED_MODULE_8__creation_BuildingSelection__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/new-building',component:__WEBPACK_IMPORTED_MODULE_2__creation_NewBuilding__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__NewWorkOrderRouteGuard__["a" /* default */],{exact:true,path:this.props.match.url+'/work-order-created',component:__WEBPACK_IMPORTED_MODULE_3__creation_WorkOrderCreated__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__NewWorkOrderRouteGuard__["a" /* default */],{exact:true,path:this.props.match.url+'/tasks',component:__WEBPACK_IMPORTED_MODULE_4__creation_Tasks__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__NewWorkOrderRouteGuard__["a" /* default */],{exact:true,path:this.props.match.url+'/sub-contractors-union-trades',component:__WEBPACK_IMPORTED_MODULE_9__creation_SubContractorsUnionTrades__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__NewWorkOrderRouteGuard__["a" /* default */],{exact:true,path:this.props.match.url+'/working-hours',component:__WEBPACK_IMPORTED_MODULE_5__creation_WorkingHours__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__NewWorkOrderRouteGuard__["a" /* default */],{exact:true,path:this.props.match.url+'/work-order-summary',component:__WEBPACK_IMPORTED_MODULE_6__creation_WorkOrderSummary__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/:woId',component:__WEBPACK_IMPORTED_MODULE_10__details_WorkOrderDetails__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/:woId/task/:taskId',component:__WEBPACK_IMPORTED_MODULE_10__details_WorkOrderDetails__["a" /* default */]})));}}}]);return WorkOrdersContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_13__selectors_authentication__["d" /* getCurrentUser */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_16__selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state)};})(WorkOrdersContainer));

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAA8CAYAAAAuaUeTAAAAAXNSR0IArs4c6QAAAx1JREFUeAHt3L1v00AUAPD3XGDowoKQEDNCDlJa0XYnLF0RQYCgWUNVIbGxFApNYUBMSAipXklASKQwwkhZGJolFQQJ8Q8gWLvQ+ngv0VXEShwnsc9355xk2fch5+6nl8s5doKgeSqWlheF8DdQoAsIPwBEpV713qfR7ak0XjTqa7ahfP8DtT9N2zHaTtF2PZefF63dxic6Vpq0xnLz51+TBkMFUyENMCfYC53y7bdenw4JEOtXlsr3+1QnUqw1VmeO6j9uX0BFJZjeWDSZ96fq1KgE03rOajUb38/NzJEHFMLQuF7FHKY1FgN9aza2o4BR0wK34/ZhsOPUaY/Fg4sKxhGWJJgRWBLMnZ0/AAEXw6IjybekMVgMRHPYdhQwaprIHGYUVtpgxmGlCWYkVlpgxmKlAWY0lmow47FUglmBpQrMGiwVYFZhDQvmzszxQjfyN67WYUmwXH5hn76vD700orYXhgGzEqsNtrvzOW4wa7GSALMaK24w67HiBMsEVlxgmcGKAwzL5fL0nz14IgCvghAn+aST1BFAhLv0qMBT6eH83oNnQsDtCZQk6do/vlZacWWJQwc3ZGay7xagIDp64O8vylLGmqSIAoz1KmLbzDWjOevvlHPkoxy4c2Ia7lDhc0D8JQsn+0OB1TcvX7RkDuVBVvbFm8urAvxHA8eL8HCr6q3/3y5TWONAMVpmsMaFygxWHFCZwIoLynqsOKEYy9oL6culW/foEm6kTz2G6ZWsnODbUL7Y6DXgrrIey4Ou+kDGusiKCoWAD7ZqXiXgEZq1KrKGgarXNoeCYkVrsJKGsgZLBZQVWKqgjMdSCWU0lmooY7HSgDISKy0oxjJqUcq/AKObCANX5rzgHGUdxSBhyZh1FkPxL8DCBsN1SUHxuY2IrKhQDsJaveYNjDwe+ChJ+8gaBuptNTkoxtUaq7hUvkRz1LtBUcARlTQU94HvG2qccG1Q51RBcT/0xhJwJgxLJZT2WALF4Q3OIJpqKO2xEJ2ef0WQBhRjab10aDV3fuZmF77QI9pnaf10HBG/0qMGK/TMlBeMNBX5fwU44vc5os+MAAAAAElFTkSuQmCC"

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UnionTradesExtraKeys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UnionTrades_css__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UnionTrades_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__UnionTrades_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_select_SelectList__ = __webpack_require__(367);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UnionTradesExtraKeys={ALL:'all',DONT_KNOW:'dont-know',NO:'no'};var UnionTrades=function(_Component){_inherits(UnionTrades,_Component);function UnionTrades(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UnionTrades);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UnionTrades.__proto__||Object.getPrototypeOf(UnionTrades)).call.apply(_ref,[this].concat(args))),_this),_this.handleUnionTradeSelection=function(id){_this.props.onItemSelected(id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UnionTrades,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'union-trades'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Requirements'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Do you or your Building require Union Trades for any of the following?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'union-trades-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_select_SelectList__["a" /* default */],{values:this.props.unionTrades.map(function(element){return{id:element.id,value:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'trade-value'},element.label,element.detail!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'trade-detail'},'(',element.detail,')'):null),selected:_this2.props.selectedUnionTradesId.findIndex(function(selected){return selected===element.id;})>-1};}).concat({id:UnionTradesExtraKeys.ALL,value:'All Union Trades',selected:this.props.selectedUnionTradesId.length>0&&this.props.unionTrades.length===this.props.selectedUnionTradesId.length}).concat({id:UnionTradesExtraKeys.DONT_KNOW,value:"I don't know",selected:this.props.dontKnowUnions}).concat({id:UnionTradesExtraKeys.NO,value:'No',selected:this.props.noUnions}),onSelect:this.handleUnionTradeSelection})),this.props.unionTradesValidationError!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},this.props.unionTradesValidationError));}}]);return UnionTrades;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UnionTrades.propTypes={dontKnowUnions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,noUnions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,unionTradesValidationError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,selectedUnionTradesId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),unionTrades:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,detail:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),onItemSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* unused harmony default export */ var _unused_webpack_default_export = (UnionTrades);

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

if (typeof moment === "undefined" && "function" === 'function') {
    var moment = __webpack_require__(24);
}

(function(moment) {
    var STRINGS = {
        nodiff: '',
        year: 'year',
        years: 'years',
        month: 'month',
        months: 'months',
        day: 'day',
        days: 'days',
        hour: 'hour',
        hours: 'hours',
        minute: 'minute',
        minutes: 'minutes',
        second: 'second',
        seconds: 'seconds',
        delimiter: ' '
    };

    function pluralize(num, word) {
        return num + ' ' + STRINGS[word + (num === 1 ? '' : 's')];
    }

    function buildStringFromValues(yDiff, mDiff, dDiff, hourDiff, minDiff, secDiff){
        var result = [];

        if (yDiff) {
            result.push(pluralize(yDiff, 'year'));
        }
        if (mDiff) {
            result.push(pluralize(mDiff, 'month'));
        }
        if (dDiff) {
            result.push(pluralize(dDiff, 'day'));
        }
        if (hourDiff) {
            result.push(pluralize(hourDiff, 'hour'));
        }
        if (minDiff) {
            result.push(pluralize(minDiff, 'minute'));
        }
        if (secDiff) {
            result.push(pluralize(secDiff, 'second'));
        }

        return result.join(STRINGS.delimiter);
    }

    function buildValueObject(yDiff, mDiff, dDiff, hourDiff, minDiff, secDiff, firstDateWasLater) {
        return {
            "years"   : yDiff,
            "months"  : mDiff,
            "days"    : dDiff,
            "hours"   : hourDiff,
            "minutes" : minDiff,
            "seconds" : secDiff,
            "firstDateWasLater" : firstDateWasLater
        }
    }
    moment.fn.preciseDiff = function(d2, returnValueObject) {
        return moment.preciseDiff(this, d2, returnValueObject);
    };

    moment.preciseDiff = function(d1, d2, returnValueObject) {
        var m1 = moment(d1), m2 = moment(d2), firstDateWasLater;
        
        m1.add(m2.utcOffset() - m1.utcOffset(), 'minutes'); // shift timezone of m1 to m2
        
        if (m1.isSame(m2)) {
            if (returnValueObject) {
                return buildValueObject(0, 0, 0, 0, 0, 0, false);
            } else {
                return STRINGS.nodiff;
            }
        }
        if (m1.isAfter(m2)) {
            var tmp = m1;
            m1 = m2;
            m2 = tmp;
            firstDateWasLater = true;
        } else {
            firstDateWasLater = false;
        }

        var yDiff = m2.year() - m1.year();
        var mDiff = m2.month() - m1.month();
        var dDiff = m2.date() - m1.date();
        var hourDiff = m2.hour() - m1.hour();
        var minDiff = m2.minute() - m1.minute();
        var secDiff = m2.second() - m1.second();

        if (secDiff < 0) {
            secDiff = 60 + secDiff;
            minDiff--;
        }
        if (minDiff < 0) {
            minDiff = 60 + minDiff;
            hourDiff--;
        }
        if (hourDiff < 0) {
            hourDiff = 24 + hourDiff;
            dDiff--;
        }
        if (dDiff < 0) {
            var daysInLastFullMonth = moment(m2.year() + '-' + (m2.month() + 1), "YYYY-MM").subtract(1, 'M').daysInMonth();
            if (daysInLastFullMonth < m1.date()) { // 31/01 -> 2/03
                dDiff = daysInLastFullMonth + dDiff + (m1.date() - daysInLastFullMonth);
            } else {
                dDiff = daysInLastFullMonth + dDiff;
            }
            mDiff--;
        }
        if (mDiff < 0) {
            mDiff = 12 + mDiff;
            yDiff--;
        }

        if (returnValueObject) {
            return buildValueObject(yDiff, mDiff, dDiff, hourDiff, minDiff, secDiff, firstDateWasLater);
        } else {
            return buildStringFromValues(yDiff, mDiff, dDiff, hourDiff, minDiff, secDiff);
        }


    };
}(moment));


/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return contractorsLienReleasesApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorsLienReleasesApi=function(_BaseApi){_inherits(ContractorsLienReleasesApi,_BaseApi);function ContractorsLienReleasesApi(){_classCallCheck(this,ContractorsLienReleasesApi);return _possibleConstructorReturn(this,(ContractorsLienReleasesApi.__proto__||Object.getPrototypeOf(ContractorsLienReleasesApi)).apply(this,arguments));}_createClass(ContractorsLienReleasesApi,[{key:'deleteLienRelease',value:function deleteLienRelease(lienReleaseId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/contractor_lien_releases/'+lienReleaseId).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return ContractorsLienReleasesApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var contractorsLienReleasesApi=new ContractorsLienReleasesApi();

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tasksChecklistApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TasksChecklistApi=function(_BaseApi){_inherits(TasksChecklistApi,_BaseApi);function TasksChecklistApi(){_classCallCheck(this,TasksChecklistApi);return _possibleConstructorReturn(this,(TasksChecklistApi.__proto__||Object.getPrototypeOf(TasksChecklistApi)).apply(this,arguments));}_createClass(TasksChecklistApi,[{key:'markItemChecklist',value:function markItemChecklist(taskChecklistId,itemId,value){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/task_checklists/'+taskChecklistId,{task_checklist:_defineProperty({},itemId,value)}).then(function(response){return{ok:true,taskChecklist:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'uploadPreExistingConditionsImages',value:function uploadPreExistingConditionsImages(taskChecklistId,images){return this._uploadImages(taskChecklistId,'pre_existing_images_attributes',images);}},{key:'uploadCompleteTaskImages',value:function uploadCompleteTaskImages(taskChecklistId,images){return this._uploadImages(taskChecklistId,'completed_images_attributes',images);}},{key:'_uploadImages',value:function _uploadImages(taskChecklistId,attribute,images){var formData=new FormData();images.forEach(function(image){formData.append('task_checklist['+attribute+'][][image]',image);});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/task_checklists/'+taskChecklistId,formData).then(function(response){return{ok:true,taskChecklist:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'removePreExistingConditionsImage',value:function removePreExistingConditionsImage(taskChecklistId,imageId){return this._removeImage(taskChecklistId,'pre_existing_images_attributes',imageId);}},{key:'removeCompleteTaskImage',value:function removeCompleteTaskImage(taskChecklistId,imageId){return this._removeImage(taskChecklistId,'completed_images_attributes',imageId);}},{key:'_removeImage',value:function _removeImage(taskChecklistId,attribute,imageId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/task_checklists/'+taskChecklistId,{task_checklist:_defineProperty({},attribute,[{id:imageId,_destroy:true}])}).then(function(response){return{ok:true,taskChecklist:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'savePreExistingConditionsDescription',value:function savePreExistingConditionsDescription(taskChecklistId,description){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/task_checklists/'+taskChecklistId,{task_checklist:{pre_existing_desc:description}}).then(function(response){return{ok:true,taskChecklist:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return TasksChecklistApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var tasksChecklistApi=new TasksChecklistApi();

/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timeApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TimeApi=function(_BaseApi){_inherits(TimeApi,_BaseApi);function TimeApi(){_classCallCheck(this,TimeApi);return _possibleConstructorReturn(this,(TimeApi.__proto__||Object.getPrototypeOf(TimeApi)).apply(this,arguments));}_createClass(TimeApi,[{key:'deleteTimeEntry',value:function deleteTimeEntry(timeId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/time_entries/'+timeId).then(function(){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'editTimeEntry',value:function editTimeEntry(timeId,values){var apiPayload={time_entry:{name_title:values.name,start_date:values.startDate,time_in:values.timeIn,time_out:values.timeOut}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/time_entries/'+timeId,apiPayload).then(function(response){return{ok:true,timeEntry:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateTimeEntryRate',value:function updateTimeEntryRate(timeId,rate){var apiPayload={time_entry:{rate:rate}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/time_entries/'+timeId,apiPayload).then(function(response){return{ok:true,timeEntry:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return TimeApi;}(__WEBPACK_IMPORTED_MODULE_1_services_api_base_api__["a" /* default */]);var timeApi=new TimeApi();

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return receiptsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReceiptsApi=function(_BaseApi){_inherits(ReceiptsApi,_BaseApi);function ReceiptsApi(){_classCallCheck(this,ReceiptsApi);return _possibleConstructorReturn(this,(ReceiptsApi.__proto__||Object.getPrototypeOf(ReceiptsApi)).apply(this,arguments));}_createClass(ReceiptsApi,[{key:'deleteReceipt',value:function deleteReceipt(receiptId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/receipts/'+receiptId).then(function(){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'editReceipt',value:function editReceipt(receiptId,values){var imageIdToDelete=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var documentIdToDelete=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var headers={headers:{'Content-Type':'multipart/form-data'}};var apiPayload=new FormData();apiPayload.append('receipt[cost]',values.cost);apiPayload.append('receipt[description]',values.description);if(imageIdToDelete!==null){apiPayload.append('receipt[image_attributes][id]',imageIdToDelete);apiPayload.append('receipt[image_attributes][_destroy]','true');}else if(values.image&&values.image.type!==undefined){// It's a file object
apiPayload.append('receipt[image_attributes][image]',values.image);}if(documentIdToDelete!==null){apiPayload.append('receipt[document_attributes][id]',documentIdToDelete);apiPayload.append('receipt[document_attributes][_destroy]','true');}else if(values.document&&values.document.type!==undefined){// It's a file object
apiPayload.append('receipt[document_attributes][document]',values.document);}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/receipts/'+receiptId,apiPayload,headers).then(function(response){return{ok:true,receipt:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return ReceiptsApi;}(__WEBPACK_IMPORTED_MODULE_1_services_api_base_api__["a" /* default */]);var receiptsApi=new ReceiptsApi();

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return workOrderAuthorizationsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WorkOrderAuthorizationsApi=function(_BaseApi){_inherits(WorkOrderAuthorizationsApi,_BaseApi);function WorkOrderAuthorizationsApi(){_classCallCheck(this,WorkOrderAuthorizationsApi);return _possibleConstructorReturn(this,(WorkOrderAuthorizationsApi.__proto__||Object.getPrototypeOf(WorkOrderAuthorizationsApi)).apply(this,arguments));}_createClass(WorkOrderAuthorizationsApi,[{key:'getWorkOrderAuthorizations',value:function getWorkOrderAuthorizations(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders/'+workOrderId+'/work_order_authorizations').then(function(response){return{ok:true,workOrderAuthorizations:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getSigningUrl',value:function getSigningUrl(workOrderAuthorizationId,redirectUrl){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_order_authorizations/'+workOrderAuthorizationId+'/signing_url?redirect_url='+redirectUrl).then(function(response){return{ok:true,data:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return WorkOrderAuthorizationsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var workOrderAuthorizationsApi=new WorkOrderAuthorizationsApi();/* unused harmony default export */ var _unused_webpack_default_export = (workOrderAuthorizationsApi=new WorkOrderAuthorizationsApi());

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NavigationItem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavigationItem_css__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavigationItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NavigationItem_css__);
function NavigationItem(props){var handleOnSelected=function handleOnSelected(event){event.preventDefault();event.stopPropagation();props.onSelected(props.id);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navigation-item'+(props.selected?' selected':'')+(props.itemClass?' '+props.itemClass:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:handleOnSelected},props.title),props.total!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,props.total));}NavigationItem.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]).isRequired,total:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),onSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};NavigationItem.defaultProps={selected:false,total:null};

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_table__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Table__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TableBody__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_TableCell__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableHead__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableRow__ = __webpack_require__(1466);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var cellStyle={padding:'15px 8px',fontSize:'14px',boxSizing:'border-box',fontFamily:'Lato',textOverflow:'ellipsis',overflow:'hidden'};var leftPadding='40px';function BasicTable(props){var rowsData=props.rowsData,headersData=props.headersData,handleRowClick=props.handleRowClick;var readyHeaders=headersData.map(function(el,i){return{header:el,accessor:'col'+i};});var readyRows=rowsData.map(function(row,i){if(Array.isArray(row)){return row.reduce(function(acc,current,i){acc['col'+i]=current;return acc;},{});}else if((typeof row==='undefined'?'undefined':_typeof(row))==='object'&&row!==null){return{col0:row.data[0]};}return row;});var data=__WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function(){return readyRows;},[rowsData]);var columns=__WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function(){return readyHeaders;},[headersData]);var getCellWidth=function getCellWidth(i,arrLength){if(i===0){return'8%';}else if(i===arrLength-1){return'6%';}return 86/arrLength-2+'%';};var _useTable=Object(__WEBPACK_IMPORTED_MODULE_1_react_table__["useTable"])({columns:columns,data:data}),getTableProps=_useTable.getTableProps,getTableBodyProps=_useTable.getTableBodyProps,headerGroups=_useTable.headerGroups,rows=_useTable.rows,prepareRow=_useTable.prepareRow;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Table__["a" /* default */],Object.assign({},getTableProps(),{style:{width:'100%',tableLayout:'fixed'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableHead__["a" /* default */],null,headerGroups.map(function(headerGroup){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableRow__["a" /* default */],headerGroup.getHeaderGroupProps(),headerGroup.headers.map(function(column,i,arr){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_TableCell__["a" /* default */],column.getHeaderProps({style:Object.assign({},cellStyle,{fontWeight:'bold',width:getCellWidth(i,arr.length),paddingLeft:i?'0':leftPadding})}),column.render('header'));}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TableBody__["a" /* default */],getTableBodyProps(),rows.map(function(row){prepareRow(row);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableRow__["a" /* default */],Object.assign({},row.getRowProps(),{style:{cursor:'pointer'},onClick:function onClick(e){handleRowClick(row.id,props.isSelectable,e);}}),row.cells.map(function(cell,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_TableCell__["a" /* default */],cell.getCellProps({style:Object.assign({},cellStyle,{paddingLeft:i?'0':leftPadding})}),cell.value);}));})));}/* harmony default export */ __webpack_exports__["a"] = (BasicTable);

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

if (true) {
  module.exports = __webpack_require__(1388)
} else {
  module.exports = require('./dist/react-table.development.js')
}


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?t(exports,__webpack_require__(0)):"function"==typeof define&&define.amd?define(["exports","react"],t):t((e=e||self).ReactTable={},e.React)}(this,(function(e,t){"use strict";function n(e,t,n,o,r,i,u){try{var l=e[i](u),s=l.value}catch(e){return void n(e)}l.done?t(s):Promise.resolve(s).then(o,r)}function o(e){return function(){var t=this,o=arguments;return new Promise((function(r,i){var u=e.apply(t,o);function l(e){n(u,r,i,l,s,"next",e)}function s(e){n(u,r,i,l,s,"throw",e)}l(void 0)}))}}function r(){return(r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e}).apply(this,arguments)}function i(e,t){if(null==e)return{};var n,o,r={},i=Object.keys(e);for(o=0;o<i.length;o++)n=i[o],t.indexOf(n)>=0||(r[n]=e[n]);return r}function u(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var o=n.call(e,t||"default");if("object"!=typeof o)return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}t=t&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t;var l={init:"init"},s=function(e){var t=e.value;return void 0===t?"":t},a=function(){return t.createElement(t.Fragment,null," ")},c={Cell:s,width:150,minWidth:0,maxWidth:Number.MAX_SAFE_INTEGER};function d(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return t.reduce((function(e,t){var n=t.style,o=t.className;return e=r({},e,{},i(t,["style","className"])),n&&(e.style=e.style?r({},e.style||{},{},n||{}):n),o&&(e.className=e.className?e.className+" "+o:o),""===e.className&&delete e.className,e}),{})}var f=function(e,t){return void 0===t&&(t={}),function(n){return void 0===n&&(n={}),[].concat(e,[n]).reduce((function(e,o){return function e(t,n,o){return"function"==typeof n?e({},n(t,o)):Array.isArray(n)?d.apply(void 0,[t].concat(n)):d(t,n)}(e,o,r({},t,{userProps:n}))}),{})}},p=function(e,t,n,o){return void 0===n&&(n={}),e.reduce((function(e,t){return t(e,n)}),t)},g=function(e,t,n){return void 0===n&&(n={}),e.forEach((function(e){e(t,n)}))};function v(e,t,n,o){e.findIndex((function(e){return e.pluginName===n}));t.forEach((function(t){e.findIndex((function(e){return e.pluginName===t}))}))}function m(e,t){return"function"==typeof e?e(t):e}function h(e){var n=t.useRef();return n.current=e,t.useCallback((function(){return n.current}),[])}var y="undefined"!=typeof document?t.useLayoutEffect:t.useEffect;function w(e,n){var o=t.useRef(!1);y((function(){o.current&&e(),o.current=!0}),n)}function R(e,t,n){return void 0===n&&(n={}),function(o,i){void 0===i&&(i={});var u="string"==typeof o?t[o]:o;if(void 0===u)throw console.info(t),new Error("Renderer Error ☝️");return b(u,r({},e,{column:t},n,{},i))}}function b(e,n){return function(e){return"function"==typeof e&&((t=Object.getPrototypeOf(e)).prototype&&t.prototype.isReactComponent);var t}(o=e)||"function"==typeof o||function(e){return"object"==typeof e&&"symbol"==typeof e.$$typeof&&["react.memo","react.forward_ref"].includes(e.$$typeof.description)}(o)?t.createElement(e,n):e;var o}function S(e,t,n){return void 0===n&&(n=0),e.map((function(e){return x(e=r({},e,{parent:t,depth:n})),e.columns&&(e.columns=S(e.columns,e,n+1)),e}))}function C(e){return G(e,"columns")}function x(e){var t=e.id,n=e.accessor,o=e.Header;if("string"==typeof n){t=t||n;var r=n.split(".");n=function(e){return function(e,t,n){if(!t)return e;var o,r="function"==typeof t?t:JSON.stringify(t),i=E.get(r)||function(){var e=function(e){return function e(t,n){void 0===n&&(n=[]);if(Array.isArray(t))for(var o=0;o<t.length;o+=1)e(t[o],n);else n.push(t);return n}(e).map((function(e){return String(e).replace(".","_")})).join(".").replace(W,".").replace(O,"").split(".")}(t);return E.set(r,e),e}();try{o=i.reduce((function(e,t){return e[t]}),e)}catch(e){}return void 0!==o?o:n}(e,r)}}if(!t&&"string"==typeof o&&o&&(t=o),!t&&e.columns)throw console.error(e),new Error('A column ID (or unique "Header" value) is required!');if(!t)throw console.error(e),new Error("A column ID (or string accessor) is required!");return Object.assign(e,{id:t,accessor:n}),e}function P(e,t){if(!t)throw new Error;return Object.assign(e,r({Header:a,Footer:a},c,{},t,{},e)),Object.assign(e,{originalWidth:e.width}),e}function B(e,t,n){void 0===n&&(n=function(){return{}});for(var o=[],i=e,u=0,l=function(){return u++},s=function(){var e={headers:[]},u=[],s=i.some((function(e){return e.parent}));i.forEach((function(o){var i,a=[].concat(u).reverse()[0];if(s){if(o.parent)i=r({},o.parent,{originalId:o.parent.id,id:o.parent.id+"_"+l(),headers:[o]},n(o));else i=P(r({originalId:o.id+"_placeholder",id:o.id+"_placeholder_"+l(),placeholderOf:o,headers:[o]},n(o)),t);a&&a.originalId===i.originalId?a.headers.push(o):u.push(i)}e.headers.push(o)})),o.push(e),i=u};i.length;)s();return o.reverse()}var E=new Map;function I(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];for(var o=0;o<t.length;o+=1)if(void 0!==t[o])return t[o]}function F(e){if("function"==typeof e)return e}function G(e,t){var n=[];return function e(o){o.forEach((function(o){o[t]?e(o[t]):n.push(o)}))}(e),n}function A(e,t){var n=t.manualExpandedKey,o=t.expanded,r=t.expandSubRows,i=void 0===r||r,u=[];return e.forEach((function(e){return function e(t,r){void 0===r&&(r=!0),t.isExpanded=t.original&&t.original[n]||o[t.id],t.canExpand=t.subRows&&!!t.subRows.length,r&&u.push(t),t.subRows&&t.subRows.length&&t.isExpanded&&t.subRows.forEach((function(t){return e(t,i)}))}(e)})),u}function k(e,t,n){return F(e)||t[e]||n[e]||n.text}function H(e,t,n){return e?e(t,n):void 0===t}function T(){throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.")}var z=null;var W=/\[/g,O=/\]/g;var M=function(e){return r({role:"table"},e)},j=function(e){return r({role:"rowgroup"},e)},N=function(e,t){var n=t.column;return r({key:"header_"+n.id,colSpan:n.totalVisibleHeaderCount,role:"columnheader"},e)},D=function(e,t){var n=t.column;return r({key:"footer_"+n.id,colSpan:n.totalVisibleHeaderCount},e)},L=function(e,t){return r({key:"headerGroup_"+t.index,role:"row"},e)},V=function(e,t){return r({key:"footerGroup_"+t.index},e)},_=function(e,t){return r({key:"row_"+t.row.id,role:"row"},e)},X=function(e,t){var n=t.cell;return r({key:"cell_"+n.row.id+"_"+n.column.id,role:"cell"},e)};function q(){return{useOptions:[],stateReducers:[],useControlledState:[],columns:[],columnsDeps:[],allColumns:[],allColumnsDeps:[],accessValue:[],materializedColumns:[],materializedColumnsDeps:[],useInstanceAfterData:[],visibleColumns:[],visibleColumnsDeps:[],headerGroups:[],headerGroupsDeps:[],useInstanceBeforeDimensions:[],useInstance:[],prepareRow:[],getTableProps:[M],getTableBodyProps:[j],getHeaderGroupProps:[L],getFooterGroupProps:[V],getHeaderProps:[N],getFooterProps:[D],getRowProps:[_],getCellProps:[X],useFinalInstance:[]}}l.resetHiddenColumns="resetHiddenColumns",l.toggleHideColumn="toggleHideColumn",l.setHiddenColumns="setHiddenColumns",l.toggleHideAllColumns="toggleHideAllColumns";var K=function(e){e.getToggleHiddenProps=[U],e.getToggleHideAllColumnsProps=[$],e.stateReducers.push(J),e.useInstanceBeforeDimensions.push(Y),e.headerGroupsDeps.push((function(e,t){var n=t.instance;return[].concat(e,[n.state.hiddenColumns])})),e.useInstance.push(Q)};K.pluginName="useColumnVisibility";var U=function(e,t){var n=t.column;return[e,{onChange:function(e){n.toggleHidden(!e.target.checked)},style:{cursor:"pointer"},checked:n.isVisible,title:"Toggle Column Visible"}]},$=function(e,t){var n=t.instance;return[e,{onChange:function(e){n.toggleHideAllColumns(!e.target.checked)},style:{cursor:"pointer"},checked:!n.allColumnsHidden&&!n.state.hiddenColumns.length,title:"Toggle All Columns Hidden",indeterminate:!n.allColumnsHidden&&n.state.hiddenColumns.length}]};function J(e,t,n,o){if(t.type===l.init)return r({hiddenColumns:[]},e);if(t.type===l.resetHiddenColumns)return r({},e,{hiddenColumns:o.initialState.hiddenColumns||[]});if(t.type===l.toggleHideColumn){var i=(void 0!==t.value?t.value:!e.hiddenColumns.includes(t.columnId))?[].concat(e.hiddenColumns,[t.columnId]):e.hiddenColumns.filter((function(e){return e!==t.columnId}));return r({},e,{hiddenColumns:i})}return t.type===l.setHiddenColumns?r({},e,{hiddenColumns:m(t.value,e.hiddenColumns)}):t.type===l.toggleHideAllColumns?r({},e,{hiddenColumns:(void 0!==t.value?t.value:!e.hiddenColumns.length)?o.allColumns.map((function(e){return e.id})):[]}):void 0}function Y(e){var n=e.headers,o=e.state.hiddenColumns;t.useRef(!1).current;var r=0;n.forEach((function(e){return r+=function e(t,n){t.isVisible=n&&!o.includes(t.id);var r=0;return t.headers&&t.headers.length?t.headers.forEach((function(n){return r+=e(n,t.isVisible)})):r=t.isVisible?1:0,t.totalVisibleHeaderCount=r,r}(e,!0)}))}function Q(e){var n=e.columns,o=e.flatHeaders,r=e.dispatch,i=e.allColumns,u=e.getHooks,s=e.state.hiddenColumns,a=e.autoResetHiddenColumns,c=void 0===a||a,d=h(e),p=i.length===s.length,g=t.useCallback((function(e,t){return r({type:l.toggleHideColumn,columnId:e,value:t})}),[r]),v=t.useCallback((function(e){return r({type:l.setHiddenColumns,value:e})}),[r]),m=t.useCallback((function(e){return r({type:l.toggleHideAllColumns,value:e})}),[r]),y=f(u().getToggleHideAllColumnsProps,{instance:d()});o.forEach((function(e){e.toggleHidden=function(t){r({type:l.toggleHideColumn,columnId:e.id,value:t})},e.getToggleHiddenProps=f(u().getToggleHiddenProps,{instance:d(),column:e})}));var R=h(c);w((function(){R()&&r({type:l.resetHiddenColumns})}),[r,n]),Object.assign(e,{allColumnsHidden:p,toggleHideColumn:g,setHiddenColumns:v,toggleHideAllColumns:m,getToggleHideAllColumnsProps:y})}var Z={},ee={},te=function(e,t,n){return e},ne=function(e,t){return e.subRows||[]},oe=function(e,t,n){return""+(n?[n.id,t].join("."):t)},re=function(e){return e};function ie(e){var t=e.initialState,n=void 0===t?Z:t,o=e.defaultColumn,u=void 0===o?ee:o,l=e.getSubRows,s=void 0===l?ne:l,a=e.getRowId,c=void 0===a?oe:a,d=e.stateReducer,f=void 0===d?te:d,p=e.useControlledState,g=void 0===p?re:p;return r({},i(e,["initialState","defaultColumn","getSubRows","getRowId","stateReducer","useControlledState"]),{initialState:n,defaultColumn:u,getSubRows:s,getRowId:c,stateReducer:f,useControlledState:g})}function ue(e,t){void 0===t&&(t=0);var n=0,o=0,r=0,i=0;return e.forEach((function(e){var u=e.headers;if(e.totalLeft=t,u&&u.length){var l=ue(u,t),s=l[0],a=l[1],c=l[2],d=l[3];e.totalMinWidth=s,e.totalWidth=a,e.totalMaxWidth=c,e.totalFlexWidth=d}else e.totalMinWidth=e.minWidth,e.totalWidth=Math.min(Math.max(e.minWidth,e.width),e.maxWidth),e.totalMaxWidth=e.maxWidth,e.totalFlexWidth=e.canResize?e.totalWidth:0;e.isVisible&&(t+=e.totalWidth,n+=e.totalMinWidth,o+=e.totalWidth,r+=e.totalMaxWidth,i+=e.totalFlexWidth)})),[n,o,r,i]}function le(e){var t=e.data,n=e.rows,o=e.flatRows,r=e.rowsById,i=e.column,u=e.getRowId,l=e.getSubRows,s=e.accessValueHooks,a=e.getInstance;t.forEach((function(e,c){return function e(n,c,d,f,g){void 0===d&&(d=0);var v=n,m=u(n,c,f),h=r[m];if(h)h.subRows&&h.originalSubRows.forEach((function(t,n){return e(t,n,d+1,h)}));else if((h={id:m,original:v,index:c,depth:d,cells:[{}]}).cells.map=T,h.cells.filter=T,h.cells.forEach=T,h.cells[0].getCellProps=T,h.values={},g.push(h),o.push(h),r[m]=h,h.originalSubRows=l(n,c),h.originalSubRows){var y=[];h.originalSubRows.forEach((function(t,n){return e(t,n,d+1,h,y)})),h.subRows=y}i.accessor&&(h.values[i.id]=i.accessor(n,c,h,g,t)),h.values[i.id]=p(s,h.values[i.id],{row:h,column:i,instance:a()})}(e,c,0,void 0,n)}))}l.resetExpanded="resetExpanded",l.toggleRowExpanded="toggleRowExpanded",l.toggleAllRowsExpanded="toggleAllRowsExpanded";var se=function(e){e.getToggleAllRowsExpandedProps=[ae],e.getToggleRowExpandedProps=[ce],e.stateReducers.push(de),e.useInstance.push(fe),e.prepareRow.push(pe)};se.pluginName="useExpanded";var ae=function(e,t){var n=t.instance;return[e,{onClick:function(e){n.toggleAllRowsExpanded()},style:{cursor:"pointer"},title:"Toggle All Rows Expanded"}]},ce=function(e,t){var n=t.row;return[e,{onClick:function(){n.toggleRowExpanded()},style:{cursor:"pointer"},title:"Toggle Row Expanded"}]};function de(e,t,n,o){if(t.type===l.init)return r({expanded:{}},e);if(t.type===l.resetExpanded)return r({},e,{expanded:o.initialState.expanded||{}});if(t.type===l.toggleAllRowsExpanded){var s=t.value,a=o.isAllRowsExpanded,c=o.rowsById;if(void 0!==s?s:!a){var d={};return Object.keys(c).forEach((function(e){d[e]=!0})),r({},e,{expanded:d})}return r({},e,{expanded:{}})}if(t.type===l.toggleRowExpanded){var f,p=t.id,g=t.value,v=e.expanded[p],m=void 0!==g?g:!v;if(!v&&m)return r({},e,{expanded:r({},e.expanded,(f={},f[p]=!0,f))});if(v&&!m){var h=e.expanded;h[p];return r({},e,{expanded:i(h,[p].map(u))})}return e}}function fe(e){var n=e.data,o=e.rows,r=e.rowsById,i=e.manualExpandedKey,u=void 0===i?"expanded":i,s=e.paginateExpandedRows,a=void 0===s||s,c=e.expandSubRows,d=void 0===c||c,p=e.autoResetExpanded,g=void 0===p||p,m=e.getHooks,y=e.plugins,R=e.state.expanded,b=e.dispatch;v(y,["useSortBy","useGroupBy","usePivotColumns","useGlobalFilter"],"useExpanded");var S=h(g),C=Boolean(Object.keys(r).length&&Object.keys(R).length);C&&Object.keys(r).some((function(e){return!R[e]}))&&(C=!1),w((function(){S()&&b({type:l.resetExpanded})}),[b,n]);var x=t.useCallback((function(e,t){b({type:l.toggleRowExpanded,id:e,value:t})}),[b]),P=t.useCallback((function(e){return b({type:l.toggleAllRowsExpanded,value:e})}),[b]),B=t.useMemo((function(){return a?A(o,{manualExpandedKey:u,expanded:R,expandSubRows:d}):o}),[a,o,u,R,d]),E=t.useMemo((function(){return function(e){var t=0;return Object.keys(e).forEach((function(e){var n=e.split(".");t=Math.max(t,n.length)})),t}(R)}),[R]),I=h(e),F=f(m().getToggleAllRowsExpandedProps,{instance:I()});Object.assign(e,{preExpandedRows:o,expandedRows:B,rows:B,expandedDepth:E,isAllRowsExpanded:C,toggleRowExpanded:x,toggleAllRowsExpanded:P,getToggleAllRowsExpandedProps:F})}function pe(e,t){var n=t.instance.getHooks,o=t.instance;e.toggleRowExpanded=function(t){return o.toggleRowExpanded(e.id,t)},e.getToggleRowExpandedProps=f(n().getToggleRowExpandedProps,{instance:o,row:e})}var ge=function(e,t,n){return e=e.filter((function(e){return t.some((function(t){var o=e.values[t];return String(o).toLowerCase().includes(String(n).toLowerCase())}))}))};ge.autoRemove=function(e){return!e};var ve=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return void 0===o||String(o).toLowerCase()===String(n).toLowerCase()}))}))};ve.autoRemove=function(e){return!e};var me=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return void 0===o||String(o)===String(n)}))}))};me.autoRemove=function(e){return!e};var he=function(e,t,n){return e.filter((function(e){return t.some((function(t){return e.values[t].includes(n)}))}))};he.autoRemove=function(e){return!e||!e.length};var ye=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return o&&o.length&&n.every((function(e){return o.includes(e)}))}))}))};ye.autoRemove=function(e){return!e||!e.length};var we=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return o&&o.length&&n.some((function(e){return o.includes(e)}))}))}))};we.autoRemove=function(e){return!e||!e.length};var Re=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return n.includes(o)}))}))};Re.autoRemove=function(e){return!e||!e.length};var be=function(e,t,n){return e.filter((function(e){return t.some((function(t){return e.values[t]===n}))}))};be.autoRemove=function(e){return void 0===e};var Se=function(e,t,n){return e.filter((function(e){return t.some((function(t){return e.values[t]==n}))}))};Se.autoRemove=function(e){return null==e};var Ce=function(e,t,n){var o=n||[],r=o[0],i=o[1];if((r="number"==typeof r?r:-1/0)>(i="number"==typeof i?i:1/0)){var u=r;r=i,i=u}return e.filter((function(e){return t.some((function(t){var n=e.values[t];return n>=r&&n<=i}))}))};Ce.autoRemove=function(e){return!e||"number"!=typeof e[0]&&"number"!=typeof e[1]};var xe=Object.freeze({__proto__:null,text:ge,exactText:ve,exactTextCase:me,includes:he,includesAll:ye,includesSome:we,includesValue:Re,exact:be,equals:Se,between:Ce});l.resetFilters="resetFilters",l.setFilter="setFilter",l.setAllFilters="setAllFilters";var Pe=function(e){e.stateReducers.push(Be),e.useInstance.push(Ee)};function Be(e,t,n,o){if(t.type===l.init)return r({filters:[]},e);if(t.type===l.resetFilters)return r({},e,{filters:o.initialState.filters||[]});if(t.type===l.setFilter){var i=t.columnId,u=t.filterValue,s=o.allColumns,a=o.filterTypes,c=s.find((function(e){return e.id===i}));if(!c)throw new Error("React-Table: Could not find a column with id: "+i);var d=k(c.filter,a||{},xe),f=e.filters.find((function(e){return e.id===i})),p=m(u,f&&f.value);return H(d.autoRemove,p,c)?r({},e,{filters:e.filters.filter((function(e){return e.id!==i}))}):r({},e,f?{filters:e.filters.map((function(e){return e.id===i?{id:i,value:p}:e}))}:{filters:[].concat(e.filters,[{id:i,value:p}])})}if(t.type===l.setAllFilters){var g=t.filters,v=o.allColumns,h=o.filterTypes;return r({},e,{filters:m(g,e.filters).filter((function(e){var t=v.find((function(t){return t.id===e.id}));return!H(k(t.filter,h||{},xe).autoRemove,e.value,t)}))})}}function Ee(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.rowsById,u=e.allColumns,s=e.filterTypes,a=e.manualFilters,c=e.defaultCanFilter,d=void 0!==c&&c,f=e.disableFilters,p=e.state.filters,g=e.dispatch,v=e.autoResetFilters,m=void 0===v||v,y=t.useCallback((function(e,t){g({type:l.setFilter,columnId:e,filterValue:t})}),[g]),R=t.useCallback((function(e){g({type:l.setAllFilters,filters:e})}),[g]);u.forEach((function(e){var t=e.id,n=e.accessor,o=e.defaultCanFilter,r=e.disableFilters;e.canFilter=n?I(!0!==r&&void 0,!0!==f&&void 0,!0):I(o,d,!1),e.setFilter=function(t){return y(e.id,t)};var i=p.find((function(e){return e.id===t}));e.filterValue=i&&i.value}));var b=t.useMemo((function(){if(a||!p.length)return[o,r,i];var e=[],t={};return[function n(o,r){void 0===r&&(r=0);var i=o;return(i=p.reduce((function(e,t){var n=t.id,o=t.value,i=u.find((function(e){return e.id===n}));if(!i)return e;0===r&&(i.preFilteredRows=e);var l=k(i.filter,s||{},xe);return l?(i.filteredRows=l(e,[n],o),i.filteredRows):(console.warn("Could not find a valid 'column.filter' for column with the ID: "+i.id+"."),e)}),o)).forEach((function(o){e.push(o),t[o.id]=o,o.subRows&&(o.subRows=o.subRows&&o.subRows.length>0?n(o.subRows,r+1):o.subRows)})),i}(o),e,t]}),[a,p,o,r,i,u,s]),S=b[0],C=b[1],x=b[2];t.useMemo((function(){u.filter((function(e){return!p.find((function(t){return t.id===e.id}))})).forEach((function(e){e.preFilteredRows=S,e.filteredRows=S}))}),[S,p,u]);var P=h(m);w((function(){P()&&g({type:l.resetFilters})}),[g,a?null:n]),Object.assign(e,{preFilteredRows:o,preFilteredFlatRows:r,preFilteredRowsById:i,filteredRows:S,filteredFlatRows:C,filteredRowsById:x,rows:S,flatRows:C,rowsById:x,setFilter:y,setAllFilters:R})}Pe.pluginName="useFilters",l.resetGlobalFilter="resetGlobalFilter",l.setGlobalFilter="setGlobalFilter";var Ie=function(e){e.stateReducers.push(Fe),e.useInstance.push(Ge)};function Fe(e,t,n,o){if(t.type===l.resetGlobalFilter)return r({},e,{globalFilter:o.initialState.globalFilter||void 0});if(t.type===l.setGlobalFilter){var u=t.filterValue,s=o.userFilterTypes,a=k(o.globalFilter,s||{},xe),c=m(u,e.globalFilter);if(H(a.autoRemove,c)){e.globalFilter;return i(e,["globalFilter"])}return r({},e,{globalFilter:c})}}function Ge(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.rowsById,u=e.allColumns,s=e.filterTypes,a=e.globalFilter,c=e.manualGlobalFilter,d=e.state.globalFilter,f=e.dispatch,p=e.autoResetGlobalFilter,g=void 0===p||p,v=e.disableGlobalFilter,m=t.useCallback((function(e){f({type:l.setGlobalFilter,filterValue:e})}),[f]),y=t.useMemo((function(){if(c||void 0===d)return[o,r,i];var e=[],t={},n=k(a,s||{},xe);if(!n)return console.warn("Could not find a valid 'globalFilter' option."),o;u.forEach((function(e){var t=e.disableGlobalFilter;e.canFilter=I(!0!==t&&void 0,!0!==v&&void 0,!0)}));var l=u.filter((function(e){return!0===e.canFilter}));return[function o(r){return(r=n(r,l.map((function(e){return e.id})),d)).forEach((function(n){e.push(n),t[n.id]=n,n.subRows=n.subRows&&n.subRows.length?o(n.subRows):n.subRows})),r}(o),e,t]}),[c,d,a,s,u,o,r,i,v]),R=y[0],b=y[1],S=y[2],C=h(g);w((function(){C()&&f({type:l.resetGlobalFilter})}),[f,c?null:n]),Object.assign(e,{preGlobalFilteredRows:o,preGlobalFilteredFlatRows:r,preGlobalFilteredRowsById:i,globalFilteredRows:R,globalFilteredFlatRows:b,globalFilteredRowsById:S,rows:R,flatRows:b,rowsById:S,setGlobalFilter:m,disableGlobalFilter:v})}function Ae(e,t){return t.reduce((function(e,t){return e+("number"==typeof t?t:0)}),0)}Ie.pluginName="useGlobalFilter";var ke=Object.freeze({__proto__:null,sum:Ae,min:function(e){var t=e[0]||0;return e.forEach((function(e){"number"==typeof e&&(t=Math.min(t,e))})),t},max:function(e){var t=e[0]||0;return e.forEach((function(e){"number"==typeof e&&(t=Math.max(t,e))})),t},minMax:function(e){var t=e[0]||0,n=e[0]||0;return e.forEach((function(e){"number"==typeof e&&(t=Math.min(t,e),n=Math.max(n,e))})),t+".."+n},average:function(e){return Ae(0,e)/e.length},median:function(e){if(!e.length)return null;var t=Math.floor(e.length/2),n=[].concat(e).sort((function(e,t){return e-t}));return e.length%2!=0?n[t]:(n[t-1]+n[t])/2},unique:function(e){return Array.from(new Set(e).values())},uniqueCount:function(e){return new Set(e).size},count:function(e){return e.length}}),He=[],Te={};l.resetGroupBy="resetGroupBy",l.setGroupBy="setGroupBy",l.toggleGroupBy="toggleGroupBy";var ze=function(e){e.getGroupByToggleProps=[We],e.stateReducers.push(Oe),e.visibleColumnsDeps.push((function(e,t){var n=t.instance;return[].concat(e,[n.state.groupBy])})),e.visibleColumns.push(Me),e.useInstance.push(Ne),e.prepareRow.push(De)};ze.pluginName="useGroupBy";var We=function(e,t){var n=t.header;return[e,{onClick:n.canGroupBy?function(e){e.persist(),n.toggleGroupBy()}:void 0,style:{cursor:n.canGroupBy?"pointer":void 0},title:"Toggle GroupBy"}]};function Oe(e,t,n,o){if(t.type===l.init)return r({groupBy:[]},e);if(t.type===l.resetGroupBy)return r({},e,{groupBy:o.initialState.groupBy||[]});if(t.type===l.setGroupBy)return r({},e,{groupBy:t.value});if(t.type===l.toggleGroupBy){var i=t.columnId,u=t.value,s=void 0!==u?u:!e.groupBy.includes(i);return r({},e,s?{groupBy:[].concat(e.groupBy,[i])}:{groupBy:e.groupBy.filter((function(e){return e!==i}))})}}function Me(e,t){var n=t.instance.state.groupBy,o=n.map((function(t){return e.find((function(e){return e.id===t}))})).filter(Boolean),r=e.filter((function(e){return!n.includes(e.id)}));return(e=[].concat(o,r)).forEach((function(e){e.isGrouped=n.includes(e.id),e.groupedIndex=n.indexOf(e.id)})),e}var je={};function Ne(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.rowsById,u=e.allColumns,s=e.flatHeaders,a=e.groupByFn,c=void 0===a?Le:a,d=e.manualGroupBy,p=e.aggregations,g=void 0===p?je:p,m=e.plugins,y=e.state.groupBy,R=e.dispatch,b=e.autoResetGroupBy,S=void 0===b||b,C=e.disableGroupBy,x=e.defaultCanGroupBy,P=e.getHooks;v(m,["useColumnOrder","useFilters"],"useGroupBy");var B=h(e);u.forEach((function(t){var n=t.accessor,o=t.defaultGroupBy,r=t.disableGroupBy;t.canGroupBy=n?I(t.canGroupBy,!0!==r&&void 0,!0!==C&&void 0,!0):I(t.canGroupBy,o,x,!1),t.canGroupBy&&(t.toggleGroupBy=function(){return e.toggleGroupBy(t.id)}),t.Aggregated=t.Aggregated||t.Cell}));var E=t.useCallback((function(e,t){R({type:l.toggleGroupBy,columnId:e,value:t})}),[R]),F=t.useCallback((function(e){R({type:l.setGroupBy,value:e})}),[R]);s.forEach((function(e){e.getGroupByToggleProps=f(P().getGroupByToggleProps,{instance:B(),header:e})}));var A=t.useMemo((function(){if(d||!y.length)return[o,r,i,He,Te,r,i];var e=y.filter((function(e){return u.find((function(t){return t.id===e}))})),t=[],n={},l=[],s={},a=[],f={},p=function o(r,i,d){if(void 0===i&&(i=0),i===e.length)return r;var p=e[i],v=c(r,p);return Object.entries(v).map((function(r,c){var v=r[0],m=r[1],h=p+":"+v,y=o(m,i+1,h=d?d+">"+h:h),w=i?G(m,"leafRows"):m,R=function(t,n,o){var r={};return u.forEach((function(i){if(e.includes(i.id))r[i.id]=n[0]?n[0].values[i.id]:null;else{var u="function"==typeof i.aggregate?i.aggregate:g[i.aggregate]||ke[i.aggregate];if(u){var l=n.map((function(e){return e.values[i.id]})),s=t.map((function(e){var t=e.values[i.id];if(!o&&i.aggregateValue){var n="function"==typeof i.aggregateValue?i.aggregateValue:g[i.aggregateValue]||ke[i.aggregateValue];if(!n)throw console.info({column:i}),new Error("React Table: Invalid column.aggregateValue option for column listed above");t=n(t,e,i)}return t}));r[i.id]=u(s,l)}else{if(i.aggregate)throw console.info({column:i}),new Error("React Table: Invalid column.aggregate option for column listed above");r[i.id]=null}}})),r}(w,m,i),b={id:h,isGrouped:!0,groupByID:p,groupByVal:v,values:R,subRows:y,leafRows:w,depth:i,index:c};return y.forEach((function(e){t.push(e),n[e.id]=e,e.isGrouped?(l.push(e),s[e.id]=e):(a.push(e),f[e.id]=e)})),b}))}(o);return p.forEach((function(e){t.push(e),n[e.id]=e,e.isGrouped?(l.push(e),s[e.id]=e):(a.push(e),f[e.id]=e)})),[p,t,n,l,s,a,f]}),[d,y,o,r,i,u,g,c]),k=A[0],H=A[1],T=A[2],z=A[3],W=A[4],O=A[5],M=A[6],j=h(S);w((function(){j()&&R({type:l.resetGroupBy})}),[R,d?null:n]),Object.assign(e,{preGroupedRows:o,preGroupedFlatRow:r,preGroupedRowsById:i,groupedRows:k,groupedFlatRows:H,groupedRowsById:T,onlyGroupedFlatRows:z,onlyGroupedRowsById:W,nonGroupedFlatRows:O,nonGroupedRowsById:M,rows:k,flatRows:H,rowsById:T,toggleGroupBy:E,setGroupBy:F})}function De(e){e.allCells.forEach((function(t){var n;t.isGrouped=t.column.isGrouped&&t.column.id===e.groupByID,t.isPlaceholder=!t.isGrouped&&t.column.isGrouped,t.isAggregated=!t.isGrouped&&!t.isPlaceholder&&(null==(n=e.subRows)?void 0:n.length)}))}function Le(e,t){return e.reduce((function(e,n,o){var r=""+n.values[t];return e[r]=Array.isArray(e[r])?e[r]:[],e[r].push(n),e}),{})}var Ve=/([0-9]+)/gm;function _e(e,t){return e===t?0:e>t?1:-1}function Xe(e,t){return e.values[t]}function qe(e){return"number"==typeof e?isNaN(e)||e===1/0||e===-1/0?"":String(e):"string"==typeof e?e:""}var Ke=Object.freeze({__proto__:null,alphanumeric:function(e,t,n){var o=Xe(e,n),r=Xe(t,n);for(o=qe(o),r=qe(r),o=o.split(Ve).filter(Boolean),r=r.split(Ve).filter(Boolean);o.length&&r.length;){var i=o.shift(),u=r.shift(),l=parseInt(i,10),s=parseInt(u,10),a=[l,s].sort();if(isNaN(a[0])){if(i>u)return 1;if(u>i)return-1}else{if(isNaN(a[1]))return isNaN(l)?-1:1;if(l>s)return 1;if(s>l)return-1}}return o.length-r.length},datetime:function(e,t,n){var o=Xe(e,n),r=Xe(t,n);return _e(o=o.getTime(),r=r.getTime())},basic:function(e,t,n){return _e(Xe(e,n),Xe(t,n))}});l.resetSortBy="resetSortBy",l.setSortBy="setSortBy",l.toggleSortBy="toggleSortBy",l.clearSortBy="clearSortBy",c.sortType="alphanumeric",c.sortDescFirst=!1;var Ue=function(e){e.getSortByToggleProps=[$e],e.stateReducers.push(Je),e.useInstance.push(Ye)};Ue.pluginName="useSortBy";var $e=function(e,t){var n=t.instance,o=t.column,r=n.isMultiSortEvent,i=void 0===r?function(e){return e.shiftKey}:r;return[e,{onClick:o.canSort?function(e){e.persist(),o.toggleSortBy(void 0,!n.disableMultiSort&&i(e))}:void 0,style:{cursor:o.canSort?"pointer":void 0},title:o.canSort?"Toggle SortBy":void 0}]};function Je(e,t,n,o){if(t.type===l.init)return r({sortBy:[]},e);if(t.type===l.resetSortBy)return r({},e,{sortBy:o.initialState.sortBy||[]});if(t.type===l.clearSortBy)return r({},e,{sortBy:e.sortBy.filter((function(e){return e.id!==t.columnId}))});if(t.type===l.setSortBy)return r({},e,{sortBy:t.sortBy});if(t.type===l.toggleSortBy){var i,u=t.columnId,s=t.desc,a=t.multi,c=o.allColumns,d=o.disableMultiSort,f=o.disableSortRemove,p=o.disableMultiRemove,g=o.maxMultiSortColCount,v=void 0===g?Number.MAX_SAFE_INTEGER:g,m=e.sortBy,h=c.find((function(e){return e.id===u})).sortDescFirst,y=m.find((function(e){return e.id===u})),w=m.findIndex((function(e){return e.id===u})),R=null!=s,b=[];return"toggle"!==(i=!d&&a?y?"toggle":"add":w!==m.length-1||1!==m.length?"replace":y?"toggle":"replace")||f||R||a&&p||!(y&&y.desc&&!h||!y.desc&&h)||(i="remove"),"replace"===i?b=[{id:u,desc:R?s:h}]:"add"===i?(b=[].concat(m,[{id:u,desc:R?s:h}])).splice(0,b.length-v):"toggle"===i?b=m.map((function(e){return e.id===u?r({},e,{desc:R?s:!y.desc}):e})):"remove"===i&&(b=m.filter((function(e){return e.id!==u}))),r({},e,{sortBy:b})}}function Ye(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.allColumns,u=e.orderByFn,s=void 0===u?Qe:u,a=e.sortTypes,c=e.manualSortBy,d=e.defaultCanSort,p=e.disableSortBy,g=e.flatHeaders,m=e.state.sortBy,y=e.dispatch,R=e.plugins,b=e.getHooks,S=e.autoResetSortBy,C=void 0===S||S;v(R,["useFilters","useGlobalFilter","useGroupBy","usePivotColumns"],"useSortBy");var x=t.useCallback((function(e){y({type:l.setSortBy,sortBy:e})}),[y]),P=t.useCallback((function(e,t,n){y({type:l.toggleSortBy,columnId:e,desc:t,multi:n})}),[y]),B=h(e);g.forEach((function(e){var t=e.accessor,n=e.canSort,o=e.disableSortBy,r=e.id,i=t?I(!0!==o&&void 0,!0!==p&&void 0,!0):I(d,n,!1);e.canSort=i,e.canSort&&(e.toggleSortBy=function(t,n){return P(e.id,t,n)},e.clearSortBy=function(){y({type:l.clearSortBy,columnId:e.id})}),e.getSortByToggleProps=f(b().getSortByToggleProps,{instance:B(),column:e});var u=m.find((function(e){return e.id===r}));e.isSorted=!!u,e.sortedIndex=m.findIndex((function(e){return e.id===r})),e.isSortedDesc=e.isSorted?u.desc:void 0}));var E=t.useMemo((function(){if(c||!m.length)return[o,r];var e=[],t=m.filter((function(e){return i.find((function(t){return t.id===e.id}))}));return[function n(o){var r=s(o,t.map((function(e){var t=i.find((function(t){return t.id===e.id}));if(!t)throw new Error("React-Table: Could not find a column with id: "+e.id+" while sorting");var n=t.sortType,o=F(n)||(a||{})[n]||Ke[n];if(!o)throw new Error("React-Table: Could not find a valid sortType of '"+n+"' for column '"+e.id+"'.");return function(t,n){return o(t,n,e.id,e.desc)}})),t.map((function(e){var t=i.find((function(t){return t.id===e.id}));return t&&t.sortInverted?e.desc:!e.desc})));return r.forEach((function(t){e.push(t),t.subRows&&0!==t.subRows.length&&(t.subRows=n(t.subRows))})),r}(o),e]}),[c,m,o,r,i,s,a]),G=E[0],A=E[1],k=h(C);w((function(){k()&&y({type:l.resetSortBy})}),[c?null:n]),Object.assign(e,{preSortedRows:o,preSortedFlatRows:r,sortedRows:G,sortedFlatRows:A,rows:G,flatRows:A,setSortBy:x,toggleSortBy:P})}function Qe(e,t,n){return[].concat(e).sort((function(e,o){for(var r=0;r<t.length;r+=1){var i=t[r],u=!1===n[r]||"desc"===n[r],l=i(e,o);if(0!==l)return u?-l:l}return n[0]?e.index-o.index:o.index-e.index}))}l.resetPage="resetPage",l.gotoPage="gotoPage",l.setPageSize="setPageSize";var Ze=function(e){e.stateReducers.push(et),e.useInstance.push(tt)};function et(e,t,n,o){if(t.type===l.init)return r({pageSize:10,pageIndex:0},e);if(t.type===l.resetPage)return r({},e,{pageIndex:o.initialState.pageIndex||0});if(t.type===l.gotoPage){var i=o.pageCount,u=o.page,s=m(t.pageIndex,e.pageIndex),a=!1;return s>e.pageIndex?a=-1===i?u.length>=e.pageSize:s<i:s<e.pageIndex&&(a=s>-1),a?r({},e,{pageIndex:s}):e}if(t.type===l.setPageSize){var c=t.pageSize,d=e.pageSize*e.pageIndex;return r({},e,{pageIndex:Math.floor(d/c),pageSize:c})}}function tt(e){var n=e.rows,o=e.autoResetPage,r=void 0===o||o,i=e.manualExpandedKey,u=void 0===i?"expanded":i,s=e.plugins,a=e.pageCount,c=e.paginateExpandedRows,d=void 0===c||c,f=e.expandSubRows,p=void 0===f||f,g=e.state,m=g.pageSize,y=g.pageIndex,R=g.expanded,b=g.globalFilter,S=g.filters,C=g.groupBy,x=g.sortBy,P=e.dispatch,B=e.data,E=e.manualPagination;v(s,["useGlobalFilter","useFilters","useGroupBy","useSortBy","useExpanded"],"usePagination");var I=h(r);w((function(){I()&&P({type:l.resetPage})}),[P,E?null:B,b,S,C,x]);var F=E?a:Math.ceil(n.length/m),G=t.useMemo((function(){return F>0?[].concat(new Array(F)).fill(null).map((function(e,t){return t})):[]}),[F]),k=t.useMemo((function(){var e;if(E)e=n;else{var t=m*y,o=t+m;e=n.slice(t,o)}return d?e:A(e,{manualExpandedKey:u,expanded:R,expandSubRows:p})}),[p,R,u,E,y,m,d,n]),H=y>0,T=-1===F?k.length>=m:y<F-1,z=t.useCallback((function(e){P({type:l.gotoPage,pageIndex:e})}),[P]),W=t.useCallback((function(){return z((function(e){return e-1}))}),[z]),O=t.useCallback((function(){return z((function(e){return e+1}))}),[z]),M=t.useCallback((function(e){P({type:l.setPageSize,pageSize:e})}),[P]);Object.assign(e,{pageOptions:G,pageCount:F,page:k,canPreviousPage:H,canNextPage:T,gotoPage:z,previousPage:W,nextPage:O,setPageSize:M})}Ze.pluginName="usePagination",l.resetPivot="resetPivot",l.togglePivot="togglePivot";var nt=function(e){e.getPivotToggleProps=[rt],e.stateReducers.push(it),e.useInstanceAfterData.push(ut),e.allColumns.push(lt),e.accessValue.push(st),e.materializedColumns.push(at),e.materializedColumnsDeps.push(ct),e.visibleColumns.push(dt),e.visibleColumnsDeps.push(ft),e.useInstance.push(pt),e.prepareRow.push(gt)};nt.pluginName="usePivotColumns";var ot=[],rt=function(e,t){var n=t.header;return[e,{onClick:n.canPivot?function(e){e.persist(),n.togglePivot()}:void 0,style:{cursor:n.canPivot?"pointer":void 0},title:"Toggle Pivot"}]};function it(e,t,n,o){if(t.type===l.init)return r({pivotColumns:ot},e);if(t.type===l.resetPivot)return r({},e,{pivotColumns:o.initialState.pivotColumns||ot});if(t.type===l.togglePivot){var i=t.columnId,u=t.value,s=void 0!==u?u:!e.pivotColumns.includes(i);return r({},e,s?{pivotColumns:[].concat(e.pivotColumns,[i])}:{pivotColumns:e.pivotColumns.filter((function(e){return e!==i}))})}}function ut(e){e.allColumns.forEach((function(t){t.isPivotSource=e.state.pivotColumns.includes(t.id)}))}function lt(e,t){var n=t.instance;return e.forEach((function(e){e.isPivotSource=n.state.pivotColumns.includes(e.id),e.uniqueValues=new Set})),e}function st(e,t){var n=t.column;return n.uniqueValues&&void 0!==e&&n.uniqueValues.add(e),e}function at(e,t){var n=t.instance,o=n.allColumns,i=n.state;if(!i.pivotColumns.length||!i.groupBy||!i.groupBy.length)return e;var u=i.pivotColumns.map((function(e){return o.find((function(t){return t.id===e}))})).filter(Boolean),l=o.filter((function(e){return!e.isPivotSource&&!i.groupBy.includes(e.id)&&!i.pivotColumns.includes(e.id)})),s=C(function e(t,n,o){void 0===t&&(t=0),void 0===o&&(o=[]);var i=u[t];return i?Array.from(i.uniqueValues).sort().map((function(u){var l=r({},i,{Header:i.PivotHeader||"string"==typeof i.header?i.Header+": "+u:u,isPivotGroup:!0,parent:n,depth:t,id:n?n.id+"."+i.id+"."+u:i.id+"."+u,pivotValue:u});return l.columns=e(t+1,l,[].concat(o,[function(e){return e.values[i.id]===u}])),l})):l.map((function(e){return r({},e,{canPivot:!1,isPivoted:!0,parent:n,depth:t,id:""+(n?n.id+"."+e.id:e.id),accessor:function(t,n,r){if(o.every((function(e){return e(r)})))return r.values[e.id]}})}))}());return[].concat(e,s)}function ct(e,t){var n=t.instance.state,o=n.pivotColumns,r=n.groupBy;return[].concat(e,[o,r])}function dt(e,t){var n=t.instance.state;return e=e.filter((function(e){return!e.isPivotSource})),n.pivotColumns.length&&n.groupBy&&n.groupBy.length&&(e=e.filter((function(e){return e.isGrouped||e.isPivoted}))),e}function ft(e,t){var n=t.instance;return[].concat(e,[n.state.pivotColumns,n.state.groupBy])}function pt(e){var t=e.columns,n=e.allColumns,o=e.flatHeaders,r=e.getHooks,i=e.plugins,u=e.dispatch,s=e.autoResetPivot,a=void 0===s||s,c=e.manaulPivot,d=e.disablePivot,p=e.defaultCanPivot;v(i,["useGroupBy"],"usePivotColumns");var g=h(e);n.forEach((function(t){var n=t.accessor,o=t.defaultPivot,r=t.disablePivot;t.canPivot=n?I(t.canPivot,!0!==r&&void 0,!0!==d&&void 0,!0):I(t.canPivot,o,p,!1),t.canPivot&&(t.togglePivot=function(){return e.togglePivot(t.id)}),t.Aggregated=t.Aggregated||t.Cell}));o.forEach((function(e){e.getPivotToggleProps=f(r().getPivotToggleProps,{instance:g(),header:e})}));var m=h(a);w((function(){m()&&u({type:l.resetPivot})}),[u,c?null:t]),Object.assign(e,{togglePivot:function(e,t){u({type:l.togglePivot,columnId:e,value:t})}})}function gt(e){e.allCells.forEach((function(e){e.isPivoted=e.column.isPivoted}))}l.resetSelectedRows="resetSelectedRows",l.toggleAllRowsSelected="toggleAllRowsSelected",l.toggleRowSelected="toggleRowSelected",l.toggleAllPageRowsSelected="toggleAllPageRowsSelected";var vt=function(e){e.getToggleRowSelectedProps=[mt],e.getToggleAllRowsSelectedProps=[ht],e.getToggleAllPageRowsSelectedProps=[yt],e.stateReducers.push(wt),e.useInstance.push(Rt),e.prepareRow.push(bt)};vt.pluginName="useRowSelect";var mt=function(e,t){var n=t.instance,o=t.row,r=n.manualRowSelectedKey,i=void 0===r?"isSelected":r;return[e,{onChange:function(e){o.toggleRowSelected(e.target.checked)},style:{cursor:"pointer"},checked:!(!o.original||!o.original[i])||o.isSelected,title:"Toggle Row Selected",indeterminate:o.isSomeSelected}]},ht=function(e,t){var n=t.instance;return[e,{onChange:function(e){n.toggleAllRowsSelected(e.target.checked)},style:{cursor:"pointer"},checked:n.isAllRowsSelected,title:"Toggle All Rows Selected",indeterminate:Boolean(!n.isAllRowsSelected&&Object.keys(n.state.selectedRowIds).length)}]},yt=function(e,t){var n=t.instance;return[e,{onChange:function(e){n.toggleAllPageRowsSelected(e.target.checked)},style:{cursor:"pointer"},checked:n.isAllPageRowsSelected,title:"Toggle All Current Page Rows Selected",indeterminate:Boolean(!n.isAllPageRowsSelected&&n.page.some((function(e){var t=e.id;return n.state.selectedRowIds[t]})))}]};function wt(e,t,n,o){if(t.type===l.init)return r({selectedRowIds:{}},e);if(t.type===l.resetSelectedRows)return r({},e,{selectedRowIds:o.initialState.selectedRowIds||{}});if(t.type===l.toggleAllRowsSelected){var i=t.value,u=o.isAllRowsSelected,s=o.rowsById,a=o.nonGroupedRowsById,c=void 0===a?s:a,d=void 0!==i?i:!u,f=Object.assign({},e.selectedRowIds);return d?Object.keys(c).forEach((function(e){f[e]=!0})):Object.keys(c).forEach((function(e){delete f[e]})),r({},e,{selectedRowIds:f})}if(t.type===l.toggleRowSelected){var p=t.id,g=t.value,v=o.rowsById,m=o.selectSubRows,h=void 0===m||m,y=o.getSubRows,w=e.selectedRowIds[p],R=void 0!==g?g:!w;if(w===R)return e;var b=r({},e.selectedRowIds);return function e(t){var n=v[t];if(n.isGrouped||(R?b[t]=!0:delete b[t]),h&&y(n))return y(n).forEach((function(t){return e(t.id)}))}(p),r({},e,{selectedRowIds:b})}if(t.type===l.toggleAllPageRowsSelected){var S=t.value,C=o.page,x=o.rowsById,P=o.selectSubRows,B=void 0===P||P,E=o.isAllPageRowsSelected,I=o.getSubRows,F=void 0!==S?S:!E,G=r({},e.selectedRowIds);return C.forEach((function(e){return function e(t){var n=x[t];if(n.isGrouped||(F?G[t]=!0:delete G[t]),B&&I(n))return I(n).forEach((function(t){return e(t.id)}))}(e.id)})),r({},e,{selectedRowIds:G})}return e}function Rt(e){var n=e.data,o=e.rows,r=e.getHooks,i=e.plugins,u=e.rowsById,s=e.nonGroupedRowsById,a=void 0===s?u:s,c=e.autoResetSelectedRows,d=void 0===c||c,p=e.state.selectedRowIds,g=e.selectSubRows,m=void 0===g||g,y=e.dispatch,R=e.page,b=e.getSubRows;v(i,["useFilters","useGroupBy","useSortBy","useExpanded","usePagination"],"useRowSelect");var S=t.useMemo((function(){var e=[];return o.forEach((function(t){var n=m?function e(t,n,o){if(n[t.id])return!0;var r=o(t);if(r&&r.length){var i=!0,u=!1;return r.forEach((function(t){u&&!i||(e(t,n,o)?u=!0:i=!1)})),!!i||!!u&&null}return!1}(t,p,b):!!p[t.id];t.isSelected=!!n,t.isSomeSelected=null===n,n&&e.push(t)})),e}),[o,m,p,b]),C=Boolean(Object.keys(a).length&&Object.keys(p).length),x=C;C&&Object.keys(a).some((function(e){return!p[e]}))&&(C=!1),C||R&&R.length&&R.some((function(e){var t=e.id;return!p[t]}))&&(x=!1);var P=h(d);w((function(){P()&&y({type:l.resetSelectedRows})}),[y,n]);var B=t.useCallback((function(e){return y({type:l.toggleAllRowsSelected,value:e})}),[y]),E=t.useCallback((function(e){return y({type:l.toggleAllPageRowsSelected,value:e})}),[y]),I=t.useCallback((function(e,t){return y({type:l.toggleRowSelected,id:e,value:t})}),[y]),F=h(e),G=f(r().getToggleAllRowsSelectedProps,{instance:F()}),A=f(r().getToggleAllPageRowsSelectedProps,{instance:F()});Object.assign(e,{selectedFlatRows:S,isAllRowsSelected:C,isAllPageRowsSelected:x,toggleRowSelected:I,toggleAllRowsSelected:B,getToggleAllRowsSelectedProps:G,getToggleAllPageRowsSelectedProps:A,toggleAllPageRowsSelected:E})}function bt(e,t){var n=t.instance;e.toggleRowSelected=function(t){return n.toggleRowSelected(e.id,t)},e.getToggleRowSelectedProps=f(n.getHooks().getToggleRowSelectedProps,{instance:n,row:e})}var St=function(e){return{}},Ct=function(e){return{}};l.setRowState="setRowState",l.setCellState="setCellState",l.resetRowState="resetRowState";var xt=function(e){e.stateReducers.push(Pt),e.useInstance.push(Bt),e.prepareRow.push(Et)};function Pt(e,t,n,o){var i=o.initialRowStateAccessor,u=void 0===i?St:i,s=o.initialCellStateAccessor,a=void 0===s?Ct:s,c=o.rowsById;if(t.type===l.init)return r({rowState:{}},e);if(t.type===l.resetRowState)return r({},e,{rowState:o.initialState.rowState||{}});if(t.type===l.setRowState){var d,f=t.rowId,p=t.value,g=void 0!==e.rowState[f]?e.rowState[f]:u(c[f]);return r({},e,{rowState:r({},e.rowState,(d={},d[f]=m(p,g),d))})}if(t.type===l.setCellState){var v,h,y,w,R,b=t.rowId,S=t.columnId,C=t.value,x=void 0!==e.rowState[b]?e.rowState[b]:u(c[b]),P=void 0!==(null==x?void 0:null==(v=x.cellState)?void 0:v[S])?x.cellState[S]:a(null==(h=c[b])?void 0:null==(y=h.cells)?void 0:y.find((function(e){return e.column.id===S})));return r({},e,{rowState:r({},e.rowState,(R={},R[b]=r({},x,{cellState:r({},x.cellState||{},(w={},w[S]=m(C,P),w))}),R))})}}function Bt(e){var n=e.autoResetRowState,o=void 0===n||n,r=e.data,i=e.dispatch,u=t.useCallback((function(e,t){return i({type:l.setRowState,rowId:e,value:t})}),[i]),s=t.useCallback((function(e,t,n){return i({type:l.setCellState,rowId:e,columnId:t,value:n})}),[i]),a=h(o);w((function(){a()&&i({type:l.resetRowState})}),[r]),Object.assign(e,{setRowState:u,setCellState:s})}function Et(e,t){var n=t.instance,o=n.initialRowStateAccessor,r=void 0===o?St:o,i=n.initialCellStateAccessor,u=void 0===i?Ct:i,l=n.state.rowState;e&&(e.state=void 0!==l[e.id]?l[e.id]:r(e),e.setState=function(t){return n.setRowState(e.id,t)},e.cells.forEach((function(t){e.state.cellState||(e.state.cellState={}),t.state=void 0!==e.state.cellState[t.column.id]?e.state.cellState[t.column.id]:u(t),t.setState=function(o){return n.setCellState(e.id,t.column.id,o)}})))}xt.pluginName="useRowState",l.resetColumnOrder="resetColumnOrder",l.setColumnOrder="setColumnOrder";var It=function(e){e.stateReducers.push(Ft),e.visibleColumnsDeps.push((function(e,t){var n=t.instance;return[].concat(e,[n.state.columnOrder])})),e.visibleColumns.push(Gt),e.useInstance.push(At)};function Ft(e,t,n,o){return t.type===l.init?r({columnOrder:[]},e):t.type===l.resetColumnOrder?r({},e,{columnOrder:o.initialState.columnOrder||[]}):t.type===l.setColumnOrder?r({},e,{columnOrder:m(t.columnOrder,e.columnOrder)}):void 0}function Gt(e,t){var n=t.instance.state.columnOrder;if(!n||!n.length)return e;for(var o=[].concat(n),r=[].concat(e),i=[],u=function(){var e=o.shift(),t=r.findIndex((function(t){return t.id===e}));t>-1&&i.push(r.splice(t,1)[0])};r.length&&o.length;)u();return[].concat(i,r)}function At(e){var n=e.dispatch;e.setColumnOrder=t.useCallback((function(e){return n({type:l.setColumnOrder,columnOrder:e})}),[n])}It.pluginName="useColumnOrder",c.canResize=!0,l.columnStartResizing="columnStartResizing",l.columnResizing="columnResizing",l.columnDoneResizing="columnDoneResizing",l.resetResize="resetResize";var kt=function(e){e.getResizerProps=[Ht],e.getHeaderProps.push({style:{position:"relative"}}),e.stateReducers.push(Tt),e.useInstance.push(Wt),e.useInstanceBeforeDimensions.push(zt)},Ht=function(e,t){var n=t.instance,o=t.header,r=n.dispatch,i=function(e,t){var n=!1;if("touchstart"===e.type){if(e.touches&&e.touches.length>1)return;n=!0}var o=function(e){var t=[];return function e(n){n.columns&&n.columns.length&&n.columns.map(e);t.push(n)}(e),t}(t).map((function(e){return[e.id,e.totalWidth]})),i=n?Math.round(e.touches[0].clientX):e.clientX,u=function(e){r({type:l.columnResizing,clientX:e})},s=function(){return r({type:l.columnDoneResizing})},a={mouse:{moveEvent:"mousemove",moveHandler:function(e){return u(e.clientX)},upEvent:"mouseup",upHandler:function(e){document.removeEventListener("mousemove",a.mouse.moveHandler),document.removeEventListener("mouseup",a.mouse.upHandler),s()}},touch:{moveEvent:"touchmove",moveHandler:function(e){return e.cancelable&&(e.preventDefault(),e.stopPropagation()),u(e.touches[0].clientX),!1},upEvent:"touchend",upHandler:function(e){document.removeEventListener(a.touch.moveEvent,a.touch.moveHandler),document.removeEventListener(a.touch.upEvent,a.touch.moveHandler),s()}}},c=n?a.touch:a.mouse,d=!!function(){if("boolean"==typeof z)return z;var e=!1;try{var t={get passive(){return e=!0,!1}};window.addEventListener("test",null,t),window.removeEventListener("test",null,t)}catch(t){e=!1}return z=e}()&&{passive:!1};document.addEventListener(c.moveEvent,c.moveHandler,d),document.addEventListener(c.upEvent,c.upHandler,d),r({type:l.columnStartResizing,columnId:t.id,columnWidth:t.totalWidth,headerIdWidths:o,clientX:i})};return[e,{onMouseDown:function(e){return e.persist()||i(e,o)},onTouchStart:function(e){return e.persist()||i(e,o)},style:{cursor:"col-resize"},draggable:!1,role:"separator"}]};function Tt(e,t){if(t.type===l.init)return r({columnResizing:{columnWidths:{}}},e);if(t.type===l.resetResize)return r({},e,{columnResizing:{columnWidths:{}}});if(t.type===l.columnStartResizing){var n=t.clientX,o=t.columnId,i=t.columnWidth,u=t.headerIdWidths;return r({},e,{columnResizing:r({},e.columnResizing,{startX:n,headerIdWidths:u,columnWidth:i,isResizingColumn:o})})}if(t.type===l.columnResizing){var s=t.clientX,a=e.columnResizing,c=a.startX,d=a.columnWidth,f=a.headerIdWidths,p=(s-c)/d,g={};return(void 0===f?[]:f).forEach((function(e){var t=e[0],n=e[1];g[t]=Math.max(n+n*p,0)})),r({},e,{columnResizing:r({},e.columnResizing,{columnWidths:r({},e.columnResizing.columnWidths,{},g)})})}return t.type===l.columnDoneResizing?r({},e,{columnResizing:r({},e.columnResizing,{startX:null,isResizingColumn:null})}):void 0}kt.pluginName="useResizeColumns";var zt=function(e){var t=e.flatHeaders,n=e.disableResizing,o=e.getHooks,r=e.state.columnResizing,i=h(e);t.forEach((function(e){var t=I(!0!==e.disableResizing&&void 0,!0!==n&&void 0,!0);e.canResize=t,e.width=r.columnWidths[e.id]||e.originalWidth||e.width,e.isResizing=r.isResizingColumn===e.id,t&&(e.getResizerProps=f(o().getResizerProps,{instance:i(),header:e}))}))};function Wt(e){var n=e.plugins,o=e.dispatch,r=e.autoResetResize,i=void 0===r||r,u=e.columns;v(n,["useAbsoluteLayout"],"useResizeColumns");var s=h(i);w((function(){s()&&o({type:l.resetResize})}),[u]);var a=t.useCallback((function(){return o({type:l.resetResize})}),[o]);Object.assign(e,{resetResizing:a})}var Ot={position:"absolute",top:0},Mt=function(e){e.getTableBodyProps.push(jt),e.getRowProps.push(jt),e.getHeaderGroupProps.push(jt),e.getFooterGroupProps.push(jt),e.getHeaderProps.push((function(e,t){var n=t.column;return[e,{style:r({},Ot,{left:n.totalLeft+"px",width:n.totalWidth+"px"})}]})),e.getCellProps.push((function(e,t){var n=t.cell;return[e,{style:r({},Ot,{left:n.column.totalLeft+"px",width:n.column.totalWidth+"px"})}]})),e.getFooterProps.push((function(e,t){var n=t.column;return[e,{style:r({},Ot,{left:n.totalLeft+"px",width:n.totalWidth+"px"})}]}))};Mt.pluginName="useAbsoluteLayout";var jt=function(e,t){return[e,{style:{position:"relative",width:t.instance.totalColumnsWidth+"px"}}]},Nt={display:"inline-block",boxSizing:"border-box"},Dt=function(e,t){return[e,{style:{display:"flex",width:t.instance.totalColumnsWidth+"px"}}]},Lt=function(e){e.getRowProps.push(Dt),e.getHeaderGroupProps.push(Dt),e.getFooterGroupProps.push(Dt),e.getHeaderProps.push((function(e,t){var n=t.column;return[e,{style:r({},Nt,{width:n.totalWidth+"px"})}]})),e.getCellProps.push((function(e,t){var n=t.cell;return[e,{style:r({},Nt,{width:n.column.totalWidth+"px"})}]})),e.getFooterProps.push((function(e,t){var n=t.column;return[e,{style:r({},Nt,{width:n.totalWidth+"px"})}]}))};function Vt(e){e.getTableProps.push(_t),e.getRowProps.push(Xt),e.getHeaderGroupProps.push(Xt),e.getFooterGroupProps.push(Xt),e.getHeaderProps.push(qt),e.getCellProps.push(Kt),e.getFooterProps.push(Ut)}Lt.pluginName="useBlockLayout",Vt.pluginName="useFlexLayout";var _t=function(e,t){return[e,{style:{minWidth:t.instance.totalColumnsMinWidth+"px"}}]},Xt=function(e,t){return[e,{style:{display:"flex",flex:"1 0 auto",minWidth:t.instance.totalColumnsMinWidth+"px"}}]},qt=function(e,t){var n=t.column;return[e,{style:{boxSizing:"border-box",flex:n.totalFlexWidth?n.totalFlexWidth+" 0 auto":void 0,minWidth:n.totalMinWidth+"px",width:n.totalWidth+"px"}}]},Kt=function(e,t){var n=t.cell;return[e,{style:{boxSizing:"border-box",flex:n.column.totalFlexWidth+" 0 auto",minWidth:n.column.totalMinWidth+"px",width:n.column.totalWidth+"px"}}]},Ut=function(e,t){var n=t.column;return[e,{style:{boxSizing:"border-box",flex:n.totalFlexWidth?n.totalFlexWidth+" 0 auto":void 0,minWidth:n.totalMinWidth+"px",width:n.totalWidth+"px"}}]};function $t(e){e.stateReducers.push(Qt),e.getTableProps.push(Jt),e.getHeaderProps.push(Yt)}$t.pluginName="useGridLayout";var Jt=function(e,t){return[e,{style:{display:"grid",gridTemplateColumns:t.instance.state.gridLayout.columnWidths.map((function(e){return e})).join(" ")}}]},Yt=function(e,t){return[e,{id:"header-cell-"+t.column.id,style:{position:"sticky"}}]};function Qt(e,t,n,o){if("init"===t.type)return r({gridLayout:{columnWidths:o.columns.map((function(){return"auto"}))}},e);if("columnStartResizing"===t.type){var i=t.columnId,u=o.visibleColumns.findIndex((function(e){return e.id===i})),l=function(e){var t,n=null==(t=document.getElementById("header-cell-"+e))?void 0:t.offsetWidth;if(void 0!==n)return n}(i);return void 0!==l?r({},e,{gridLayout:r({},e.gridLayout,{columnId:i,columnIndex:u,startingWidth:l})}):e}if("columnResizing"===t.type){var s=e.gridLayout,a=s.columnIndex,c=s.startingWidth,d=s.columnWidths,f=c-(e.columnResizing.startX-t.clientX),p=[].concat(d);return p[a]=f+"px",r({},e,{gridLayout:r({},e.gridLayout,{columnWidths:p})})}}e._UNSTABLE_usePivotColumns=nt,e.actions=l,e.defaultColumn=c,e.defaultGroupByFn=Le,e.defaultOrderByFn=Qe,e.defaultRenderer=s,e.emptyRenderer=a,e.ensurePluginOrder=v,e.flexRender=b,e.functionalUpdate=m,e.loopHooks=g,e.makePropGetter=f,e.makeRenderer=R,e.reduceHooks=p,e.safeUseLayoutEffect=y,e.useAbsoluteLayout=Mt,e.useAsyncDebounce=function(e,n){void 0===n&&(n=0);var r=t.useRef({}),i=h(e),u=h(n);return t.useCallback(function(){var e=o(regeneratorRuntime.mark((function e(){var t,n,l,s=arguments;return regeneratorRuntime.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:for(t=s.length,n=new Array(t),l=0;l<t;l++)n[l]=s[l];return r.current.promise||(r.current.promise=new Promise((function(e,t){r.current.resolve=e,r.current.reject=t}))),r.current.timeout&&clearTimeout(r.current.timeout),r.current.timeout=setTimeout(o(regeneratorRuntime.mark((function e(){return regeneratorRuntime.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return delete r.current.timeout,e.prev=1,e.t0=r.current,e.next=5,i().apply(void 0,n);case 5:e.t1=e.sent,e.t0.resolve.call(e.t0,e.t1),e.next=12;break;case 9:e.prev=9,e.t2=e.catch(1),r.current.reject(e.t2);case 12:return e.prev=12,delete r.current.promise,e.finish(12);case 15:case"end":return e.stop()}}),e,null,[[1,9,12,15]])}))),u()),e.abrupt("return",r.current.promise);case 5:case"end":return e.stop()}}),e)})));return function(){return e.apply(this,arguments)}}(),[i,u])},e.useBlockLayout=Lt,e.useColumnOrder=It,e.useExpanded=se,e.useFilters=Pe,e.useFlexLayout=Vt,e.useGetLatest=h,e.useGlobalFilter=Ie,e.useGridLayout=$t,e.useGroupBy=ze,e.useMountedLayoutEffect=w,e.usePagination=Ze,e.useResizeColumns=kt,e.useRowSelect=vt,e.useRowState=xt,e.useSortBy=Ue,e.useTable=function(e){for(var n=arguments.length,o=new Array(n>1?n-1:0),i=1;i<n;i++)o[i-1]=arguments[i];e=ie(e),o=[K].concat(o);var u=t.useRef({}),s=h(u.current);Object.assign(s(),r({},e,{plugins:o,hooks:q()})),o.filter(Boolean).forEach((function(e){e(s().hooks)}));var a=h(s().hooks);s().getHooks=a,delete s().hooks,Object.assign(s(),p(a().useOptions,ie(e)));var c=s(),d=c.data,v=c.columns,m=c.initialState,y=c.defaultColumn,w=c.getSubRows,b=c.getRowId,E=c.stateReducer,I=c.useControlledState,F=h(E),G=t.useCallback((function(e,t){if(!t.type)throw console.info({action:t}),new Error("Unknown Action 👆");return[].concat(a().stateReducers,Array.isArray(F())?F():[F()]).reduce((function(n,o){return o(n,t,e,s())||n}),e)}),[a,F,s]),A=t.useReducer(G,void 0,(function(){return G(m,{type:l.init})})),k=A[0],H=A[1],T=p([].concat(a().useControlledState,[I]),k,{instance:s()});Object.assign(s(),{state:T,dispatch:H});var z=t.useMemo((function(){return S(p(a().columns,v,{instance:s()}))}),[a,s,v].concat(p(a().columnsDeps,[],{instance:s()})));s().columns=z;var W=t.useMemo((function(){return p(a().allColumns,C(z),{instance:s()}).map(x)}),[z,a,s].concat(p(a().allColumnsDeps,[],{instance:s()})));s().allColumns=W;var O=t.useMemo((function(){for(var e=[],t=[],n={},o=[].concat(W);o.length;){var r=o.shift();le({data:d,rows:e,flatRows:t,rowsById:n,column:r,getRowId:b,getSubRows:w,accessValueHooks:a().accessValue,getInstance:s})}return[e,t,n]}),[W,d,b,w,a,s]),M=O[0],j=O[1],N=O[2];Object.assign(s(),{rows:M,initialRows:[].concat(M),flatRows:j,rowsById:N}),g(a().useInstanceAfterData,s());var D=t.useMemo((function(){return p(a().visibleColumns,W,{instance:s()}).map((function(e){return P(e,y)}))}),[a,W,s,y].concat(p(a().visibleColumnsDeps,[],{instance:s()})));W=t.useMemo((function(){var e=[].concat(D);return W.forEach((function(t){e.find((function(e){return e.id===t.id}))||e.push(t)})),e}),[W,D]),s().allColumns=W;var L=t.useMemo((function(){return p(a().headerGroups,B(D,y),s())}),[a,D,y,s].concat(p(a().headerGroupsDeps,[],{instance:s()})));s().headerGroups=L;var V=t.useMemo((function(){return L.length?L[0].headers:[]}),[L]);s().headers=V,s().flatHeaders=L.reduce((function(e,t){return[].concat(e,t.headers)}),[]),g(a().useInstanceBeforeDimensions,s());var _=D.filter((function(e){return e.isVisible})).map((function(e){return e.id})).sort().join("_");D=t.useMemo((function(){return D.filter((function(e){return e.isVisible}))}),[D,_]),s().visibleColumns=D;var X=ue(V),U=X[0],$=X[1],J=X[2];return s().totalColumnsMinWidth=U,s().totalColumnsWidth=$,s().totalColumnsMaxWidth=J,g(a().useInstance,s()),[].concat(s().flatHeaders,s().allColumns).forEach((function(e){e.render=R(s(),e),e.getHeaderProps=f(a().getHeaderProps,{instance:s(),column:e}),e.getFooterProps=f(a().getFooterProps,{instance:s(),column:e})})),s().headerGroups=t.useMemo((function(){return L.filter((function(e,t){return e.headers=e.headers.filter((function(e){return e.headers?function e(t){return t.filter((function(t){return t.headers?e(t.headers):t.isVisible})).length}(e.headers):e.isVisible})),!!e.headers.length&&(e.getHeaderGroupProps=f(a().getHeaderGroupProps,{instance:s(),headerGroup:e,index:t}),e.getFooterGroupProps=f(a().getFooterGroupProps,{instance:s(),headerGroup:e,index:t}),!0)}))}),[L,s,a]),s().footerGroups=[].concat(s().headerGroups).reverse(),s().prepareRow=t.useCallback((function(e){e.getRowProps=f(a().getRowProps,{instance:s(),row:e}),e.allCells=W.map((function(t){var n=e.values[t.id],o={column:t,row:e,value:n};return o.getCellProps=f(a().getCellProps,{instance:s(),cell:o}),o.render=R(s(),t,{row:e,cell:o,value:n}),o})),e.cells=D.map((function(t){return e.allCells.find((function(e){return e.column.id===t.id}))})),g(a().prepareRow,e,{instance:s()})}),[a,s,W,D]),s().getTableProps=f(a().getTableProps,{instance:s()}),s().getTableBodyProps=f(a().getTableBodyProps,{instance:s()}),g(a().useFinalInstance,s()),s()},Object.defineProperty(e,"__esModule",{value:!0})}));
//# sourceMappingURL=react-table.production.min.js.map


/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table__ = __webpack_require__(1390);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Table__["a"]; });


/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TableContext__ = __webpack_require__(796);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'table',
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      '& caption': Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        textAlign: 'left',
        captionSide: 'bottom'
      })
    },

    /* Styles applied to the root element if `stickyHeader={true}`. */
    stickyHeader: {
      borderCollapse: 'separate'
    }
  };
};
var defaultComponent = 'table';
var Table = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Table(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      _props$padding = props.padding,
      padding = _props$padding === void 0 ? 'default' : _props$padding,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$stickyHeader = props.stickyHeader,
      stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "padding", "size", "stickyHeader"]);

  var table = __WEBPACK_IMPORTED_MODULE_2_react__["useMemo"](function () {
    return {
      padding: padding,
      size: size,
      stickyHeader: stickyHeader
    };
  }, [padding, size, stickyHeader]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__TableContext__["a" /* default */].Provider, {
    value: table
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: Component === defaultComponent ? null : 'table',
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, stickyHeader && classes.stickyHeader)
  }, other)));
});
 false ? Table.propTypes = {
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Allows TableCells to inherit padding of the Table.
   */
  padding: PropTypes.oneOf(['default', 'checkbox', 'none']),

  /**
   * Allows TableCells to inherit size of the Table.
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE 11.
   */
  stickyHeader: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTable'
})(Table));

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createGenerateClassName__ = __webpack_require__(371);
/* unused harmony reexport createGenerateClassName */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createStyles__ = __webpack_require__(773);
/* unused harmony reexport createStyles */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getThemeProps__ = __webpack_require__(508);
/* unused harmony reexport getThemeProps */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jssPreset__ = __webpack_require__(509);
/* unused harmony reexport jssPreset */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__makeStyles__ = __webpack_require__(372);
/* unused harmony reexport makeStyles */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeClasses__ = __webpack_require__(511);
/* unused harmony reexport mergeClasses */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ServerStyleSheets__ = __webpack_require__(781);
/* unused harmony reexport ServerStyleSheets */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled__ = __webpack_require__(782);
/* unused harmony reexport styled */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StylesProvider__ = __webpack_require__(373);
/* unused harmony reexport StylesProvider */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ThemeProvider__ = __webpack_require__(783);
/* unused harmony reexport ThemeProvider */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__useTheme__ = __webpack_require__(258);
/* unused harmony reexport useTheme */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withStyles__ = __webpack_require__(784);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_12__withStyles__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withTheme__ = __webpack_require__(785);
/* unused harmony reexport withTheme */
/* unused harmony namespace reexport */
/** @license Material-UI v4.11.3
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/* eslint-disable import/export */

/* Warning if there are several instances of @material-ui/styles */

if (false) {
  ponyfillGlobal['__@material-ui/styles-init__'] = ponyfillGlobal['__@material-ui/styles-init__'] || 0;

  if (ponyfillGlobal['__@material-ui/styles-init__'] === 1) {
    console.warn(['It looks like there are several instances of `@material-ui/styles` initialized in this application.', 'This may cause theme propagation issues, broken class names, ' + 'specificity issues, and makes your application bigger without a good reason.', '', 'See https://material-ui.com/r/styles-instance-warning for more info.'].join('\n'));
  }

  ponyfillGlobal['__@material-ui/styles-init__'] += 1;
}




























/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isPlainObject */
/* harmony export (immutable) */ __webpack_exports__["a"] = deepmerge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(369);


function isPlainObject(item) {
  return item && Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__["a" /* default */])(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes__ = __webpack_require__(507);



function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function acceptingRef(props, propName, componentName, location, propFullName) {
  var element = props[propName];
  var safePropName = propFullName || propName;

  if (element == null) {
    return null;
  }

  var warningHint;
  var elementType = element.type;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof elementType === 'function' && !isClassComponent(elementType)) {
    warningHint = 'Did you accidentally use a plain function component for an element instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
  }

  return null;
}

var elementAcceptingRef = Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, acceptingRef);
elementAcceptingRef.isRequired = Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element.isRequired, acceptingRef);
/* unused harmony default export */ var _unused_webpack_default_export = (elementAcceptingRef);

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes__ = __webpack_require__(507);



function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  var warningHint;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
    warningHint = 'Did you accidentally provide a plain function component instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
  }

  return null;
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["elementType"], elementTypeAcceptingRef));

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export specialProperty */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);


// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (true) {
    return propTypes;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, propTypes, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  var url = 'https://material-ui.com/production-error/?code=' + code;

  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getFunctionName */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_is__);

 // Simplified polyfill for IE 11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */

function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE 11 support
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */


function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(Component) === 'object') {
    switch (Component.$$typeof) {
      case __WEBPACK_IMPORTED_MODULE_1_react_is__["ForwardRef"]:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      case __WEBPACK_IMPORTED_MODULE_1_react_is__["Memo"]:
        return getWrappedName(Component, Component.type, 'memo');

      default:
        return undefined;
    }
  }

  return undefined;
}

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1399);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;exports.ContextConsumer=h;exports.ContextProvider=z;exports.Element=A;exports.ForwardRef=B;exports.Fragment=C;exports.Lazy=D;exports.Memo=E;exports.Portal=F;exports.Profiler=G;exports.StrictMode=H;
exports.Suspense=I;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};exports.isContextProvider=function(a){return y(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return y(a)===k};exports.isFragment=function(a){return y(a)===d};exports.isLazy=function(a){return y(a)===p};exports.isMemo=function(a){return y(a)===n};
exports.isPortal=function(a){return y(a)===c};exports.isProfiler=function(a){return y(a)===f};exports.isStrictMode=function(a){return y(a)===e};exports.isSuspense=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
exports.typeOf=y;


/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function HTMLElementType(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }

  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  if (propValue && propValue.nodeType !== 1) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an HTMLElement.");
  }

  return null;
}

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
/* unused harmony default export */ var _unused_webpack_default_export = (typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')());

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var refType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object]);
/* unused harmony default export */ var _unused_webpack_default_export = (refType);

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createGenerateClassName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThemeProvider_nested__ = __webpack_require__(772);

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    if (false) {
      if (ruleCounter >= 1e10) {
        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
      }
    }

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[__WEBPACK_IMPORTED_MODULE_0__ThemeProvider_nested__["a" /* default */]] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    if (true) {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }

    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function createStyles(styles) {
  return styles;
}

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getThemeProps;
/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = jssPreset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jss_plugin_rule_value_function__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss_plugin_global__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jss_plugin_nested__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jss_plugin_camel_case__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jss_plugin_default_unit__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jss_plugin_vendor_prefixer__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jss_plugin_props_sort__ = __webpack_require__(1418);






 // Subset of jss-preset-default with only the plugins the Material-UI components are using.

function jssPreset() {
  return {
    plugins: [Object(__WEBPACK_IMPORTED_MODULE_0_jss_plugin_rule_value_function__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_1_jss_plugin_global__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_2_jss_plugin_nested__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_3_jss_plugin_camel_case__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_4_jss_plugin_default_unit__["a" /* default */])(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : Object(__WEBPACK_IMPORTED_MODULE_5_jss_plugin_vendor_prefixer__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_6_jss_plugin_props_sort__["a" /* default */])()]
  };
}

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiny_warning__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(227);



var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = Object(__WEBPACK_IMPORTED_MODULE_1_jss__["d" /* createRule */])(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      } // $FlowFixMe[prop-missing]


      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule; // $FlowFixMe[prop-missing]

      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (false) {
          for (var prop in styleRule.style) {
            if (typeof styleRule.style[prop] === 'function') {
              process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Function values inside function rules are not supported.') : void 0;
              break;
            }
          }
        }
      } // $FlowFixMe[prop-missing]


      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (functionPlugin);


/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(227);



var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.rules = void 0;
    this.options = void 0;
    this.key = void 0;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new __WEBPACK_IMPORTED_MODULE_1_jss__["a" /* RuleList */](Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString() {
    return this.rules.toString();
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.options = void 0;
    this.rule = void 0;
    this.isProcessed = false;
    this.key = void 0;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssGlobal);


/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tiny_warning__ = __webpack_require__(292);



var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        rule = rule;
        return rule.selector;
      }

       false ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, prevOptions, {
      index: prevOptions.index + 1 // $FlowFixMe[prop-missing]

    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        container.addRule(selector, style[prop], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
          selector: selector
        }));
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options) // Flow expects more options but they aren't required
        // And flow doesn't know this will always be a StyleRule which has the addRule method
        // $FlowFixMe[incompatible-use]
        // $FlowFixMe[prop-missing]
        .addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssNested);


/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__ = __webpack_require__(1411);


/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__["a" /* default */])(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__["a" /* default */])(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (camelCase);


/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["a"] = (hyphenateStyleName);


/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jss__ = __webpack_require__(227);


var px = __WEBPACK_IMPORTED_MODULE_0_jss__["f" /* hasCSSTOMSupport */] && CSS ? CSS.px : 'px';
var ms = __WEBPACK_IMPORTED_MODULE_0_jss__["f" /* hasCSSTOMSupport */] && CSS ? CSS.ms : 'ms';
var percent = __WEBPACK_IMPORTED_MODULE_0_jss__["f" /* hasCSSTOMSupport */] && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 *
 * @type object
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var _key in obj) {
    newObj[_key] = obj[_key];
    newObj[_key.replace(regExp, replace)] = obj[_key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals

  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (defaultUnit);


/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_vendor__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(227);



/**
 * Add vendor prefix to a property name when needed.
 *
 * @api public
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["a" /* supportedKeyframes */])(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["b" /* supportedProperty */])(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["c" /* supportedValue */])(supportedProp, Object(__WEBPACK_IMPORTED_MODULE_1_jss__["g" /* toCssValue */])(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["c" /* supportedValue */])(prop, Object(__WEBPACK_IMPORTED_MODULE_1_jss__["g" /* toCssValue */])(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssVendorPrefixer);


/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export prefix */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return supportedKeyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return supportedProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return supportedValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_in_browser__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(510);



// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = __WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */] && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */]) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(p.noPrefill));
  return a;
}, []);

var el;
var cache = {};

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */]) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if ("production" !== 'benchmark' && cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */]) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if ("production" !== 'benchmark' && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}




/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(776);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(arr);
}

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssPropsSort);


/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jss__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeClasses__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useTheme__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StylesProvider__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__indexCounter__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getStylesCreator__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__getStylesCreator_noopTheme__ = __webpack_require__(780);












function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = Object(__WEBPACK_IMPORTED_MODULE_4__mergeClasses__["a" /* default */])({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = Object(__WEBPACK_IMPORTED_MODULE_3_jss__["e" /* getDynamicStyles */])(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = Object(__WEBPACK_IMPORTED_MODULE_4__mergeClasses__["a" /* default */])({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? __WEBPACK_IMPORTED_MODULE_10__getStylesCreator_noopTheme__["a" /* default */] : _options$defaultTheme,
      stylesOptions2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = Object(__WEBPACK_IMPORTED_MODULE_9__getStylesCreator__["a" /* default */])(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: Object(__WEBPACK_IMPORTED_MODULE_8__indexCounter__["a" /* increment */])(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = Object(__WEBPACK_IMPORTED_MODULE_6__useTheme__["a" /* default */])() || defaultTheme;

    var stylesOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_7__StylesProvider__["a" /* StylesContext */]), stylesOptions2);

    var instance = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
    var shouldUpdate = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    if (false) {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React.useDebugValue(classes);
    }

    return classes;
  };

  return useStyles;
}

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeClasses;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_utils__ = __webpack_require__(100);


function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, baseClasses);

  if (false) {
    if (typeof newClasses === 'string') {
      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat(getDisplayName(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
      return baseClasses;
    }
  }

  Object.keys(newClasses).forEach(function (key) {
    if (false) {
      if (!baseClasses[key] && newClasses[key]) {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat(getDisplayName(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
      }

      if (newClasses[key] && typeof newClasses[key] !== 'string') {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat(getDisplayName(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
      }
    }

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (multiKeyStore);

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ThemeContext__ = __webpack_require__(778);


function useTheme() {
  var theme = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_1__ThemeContext__["a" /* default */]);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(theme);
  }

  return theme;
}

/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = increment;
/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (false) {
    if (indexCounter >= 0) {
      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
    }
  }

  return indexCounter;
}

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getStylesCreator__ = __webpack_require__(1425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__getStylesCreator__["a"]; });


/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStylesCreator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__noopTheme__ = __webpack_require__(780);




function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (false) {
    if (_typeof(stylesOrCreator) !== 'object' && !themingEnabled) {
      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
    }
  }

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (false) {
          if (themingEnabled === true && theme === noopTheme) {
            // TODO: prepend error message/name instead
            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
          }
        }

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (false) {
          if (!stylesWithOverrides[key]) {
            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
          }
        }

        stylesWithOverrides[key] = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jss__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StylesProvider__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createGenerateClassName__ = __webpack_require__(371);








var ServerStyleSheets = /*#__PURE__*/function () {
  function ServerStyleSheets() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ServerStyleSheets);

    this.options = options;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(ServerStyleSheets, [{
    key: "collect",
    value: function collect(children) {
      // This is needed in order to deduplicate the injection of CSS in the page.
      var sheetsManager = new Map(); // This is needed in order to inject the critical CSS.

      this.sheetsRegistry = new __WEBPACK_IMPORTED_MODULE_4_jss__["b" /* SheetsRegistry */](); // A new class name generator

      var generateClassName = Object(__WEBPACK_IMPORTED_MODULE_6__createGenerateClassName__["a" /* default */])();
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StylesProvider__["b" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        sheetsManager: sheetsManager,
        serverGenerateClassName: generateClassName,
        sheetsRegistry: this.sheetsRegistry
      }, this.options), children);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.sheetsRegistry ? this.sheetsRegistry.toString() : '';
    }
  }, {
    key: "getStyleElement",
    value: function getStyleElement(props) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('style', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        id: 'jss-server-side',
        key: 'jss-server-side',
        dangerouslySetInnerHTML: {
          __html: this.toString()
        }
      }, props));
    }
  }]);

  return ServerStyleSheets;
}();



/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__makeStyles__ = __webpack_require__(372);









function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
} // styled-components's API removes the mapping between components and styles.
// Using components as a low-level styling construct can be simpler.


function styled(Component) {
  var componentCreator = function componentCreator(style) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var name = options.name,
        stylesOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["name"]);

    if (false) {
      throw new Error(['You are calling styled(Component)(style) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
    }

    var classNamePrefix = name;

    if (false) {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var stylesOrCreator = typeof style === 'function' ? function (theme) {
      return {
        root: function root(props) {
          return style(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
            theme: theme
          }, props));
        }
      };
    } : {
      root: style
    };
    var useStyles = Object(__WEBPACK_IMPORTED_MODULE_7__makeStyles__["a" /* default */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var filterProps;
    var propTypes = {};

    if (style.filterProps) {
      filterProps = style.filterProps;
      delete style.filterProps;
    }
    /* eslint-disable react/forbid-foreign-prop-types */


    if (style.propTypes) {
      propTypes = style.propTypes;
      delete style.propTypes;
    }
    /* eslint-enable react/forbid-foreign-prop-types */


    var StyledComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function StyledComponent(props, ref) {
      var children = props.children,
          classNameProp = props.className,
          clone = props.clone,
          ComponentProp = props.component,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "className", "clone", "component"]);

      var classes = useStyles(props);
      var className = Object(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])(classes.root, classNameProp);
      var spread = other;

      if (filterProps) {
        spread = omit(spread, filterProps);
      }

      if (clone) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          className: Object(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])(children.props.className, className)
        }, spread));
      }

      if (typeof children === 'function') {
        return children(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          className: className
        }, spread));
      }

      var FinalComponent = ComponentProp || Component;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(FinalComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: ref,
        className: className
      }, spread), children);
    });
     false ? StyledComponent.propTypes = _extends({
      /**
       * A render function or node.
       */
      children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

      /**
       * @ignore
       */
      className: PropTypes.string,

      /**
       * If `true`, the component will recycle it's children HTML element.
       * It's using `React.cloneElement` internally.
       *
       * This prop will be deprecated and removed in v5
       */
      clone: chainPropTypes(PropTypes.bool, function (props) {
        if (props.clone && props.component) {
          return new Error('You can not use the clone and component prop at the same time.');
        }

        return null;
      }),

      /**
       * The component used for the root node.
       * Either a string to use a HTML element or a component.
       */
      component: PropTypes
      /* @typescript-to-proptypes-ignore */
      .elementType
    }, propTypes) : void 0;

    if (false) {
      StyledComponent.displayName = "Styled(".concat(classNamePrefix, ")");
    }

    __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default()(StyledComponent, Component);
    return StyledComponent;
  };

  return componentCreator;
}

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_utils__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useTheme_ThemeContext__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__useTheme__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nested__ = __webpack_require__(772);






 // To support composition of theme.

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    var mergedTheme = localTheme(outerTheme);

    if (false) {
      if (!mergedTheme) {
        console.error(['Material-UI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
      }
    }

    return mergedTheme;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */


function ThemeProvider(props) {
  var children = props.children,
      localTheme = props.theme;
  var outerTheme = Object(__WEBPACK_IMPORTED_MODULE_5__useTheme__["a" /* default */])();

  if (false) {
    if (outerTheme === null && typeof localTheme === 'function') {
      console.error(['Material-UI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }

  var theme = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useMemo(function () {
    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);

    if (output != null) {
      output[__WEBPACK_IMPORTED_MODULE_6__nested__["a" /* default */]] = outerTheme !== null;
    }

    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__useTheme_ThemeContext__["a" /* default */].Provider, {
    value: theme
  }, children);
}

 false ? ThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = exactProp(ThemeProvider.propTypes) : void 0;
}

/* unused harmony default export */ var _unused_webpack_default_export = (ThemeProvider);

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__makeStyles__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getThemeProps__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__useTheme__ = __webpack_require__(258);








 // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["defaultTheme", "withTheme", "name"]);

    if (false) {
      if (Component === undefined) {
        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var classNamePrefix = name;

    if (false) {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var useStyles = Object(__WEBPACK_IMPORTED_MODULE_6__makeStyles__["a" /* default */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function WithStyles(props, ref) {
      var classesProp = props.classes,
          innerRef = props.innerRef,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, Component.defaultProps, props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = Object(__WEBPACK_IMPORTED_MODULE_8__useTheme__["a" /* default */])() || defaultTheme;

        if (name) {
          more = Object(__WEBPACK_IMPORTED_MODULE_7__getThemeProps__["a" /* default */])({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
     false ? WithStyles.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: PropTypes.object,

      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return null; // return new Error(
        //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
        //     'Refs are now automatically forwarded to the inner component.',
        // );
      })
    } : void 0;

    if (false) {
      WithStyles.displayName = "WithStyles(".concat(getDisplayName(Component), ")");
    }

    __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
      WithStyles.useStyles = useStyles;
    }

    return WithStyles;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (withStyles);

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createMuiTheme__ = __webpack_require__(1432);

var defaultTheme = Object(__WEBPACK_IMPORTED_MODULE_0__createMuiTheme__["a" /* default */])();
/* harmony default export */ __webpack_exports__["a"] = (defaultTheme);

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createBreakpoints__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createMixins__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createPalette__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createTypography__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shadows__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__createSpacing__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__transitions__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zIndex__ = __webpack_require__(1458);













function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = Object(__WEBPACK_IMPORTED_MODULE_5__createPalette__["a" /* default */])(paletteInput);
  var breakpoints = Object(__WEBPACK_IMPORTED_MODULE_3__createBreakpoints__["a" /* default */])(breakpointsInput);
  var spacing = Object(__WEBPACK_IMPORTED_MODULE_9__createSpacing__["a" /* default */])(spacingInput);
  var muiTheme = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: Object(__WEBPACK_IMPORTED_MODULE_4__createMixins__["a" /* default */])(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: __WEBPACK_IMPORTED_MODULE_7__shadows__["a" /* default */],
    typography: Object(__WEBPACK_IMPORTED_MODULE_6__createTypography__["a" /* default */])(palette, typographyInput),
    spacing: spacing,
    shape: __WEBPACK_IMPORTED_MODULE_8__shape__["a" /* default */],
    transitions: __WEBPACK_IMPORTED_MODULE_10__transitions__["a" /* default */],
    zIndex: __WEBPACK_IMPORTED_MODULE_11__zIndex__["a" /* default */]
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(acc, argument);
  }, muiTheme);

  if (false) {
    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
              root: _defineProperty({}, "&$".concat(key), child)
            }, null, 2), '', 'https://material-ui.com/r/pseudo-classes-guide'].join('\n'));
          } // Remove the style to prevent global conflicts.


          node[key] = {};
        }
      }
    };

    traverse(muiTheme.overrides);
  }

  return muiTheme;
}

/* harmony default export */ __webpack_exports__["a"] = (createMuiTheme);

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export keys */
/* harmony export (immutable) */ __webpack_exports__["a"] = createBreakpoints;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(99);


// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end);

    if (endIndex === keys.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMixins;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);


function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // To deprecate in v4.1
      //       warning(
      //         false,
      //         [
      //           'Material-UI: Theme.mixins.gutters() is deprecated.',
      //           'You can use the source of the mixin directly:',
      //           `
      // paddingLeft: theme.spacing(2),
      // paddingRight: theme.spacing(2),
      // [theme.breakpoints.up('sm')]: {
      //   paddingLeft: theme.spacing(3),
      //   paddingRight: theme.spacing(3),
      // },
      // `,
      //         ].join('\n'),
      //       );
      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export light */
/* unused harmony export dark */
/* harmony export (immutable) */ __webpack_exports__["a"] = createPalette;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__colors_common__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colors_grey__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__colors_indigo__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__colors_pink__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__colors_red__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__colors_orange__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__colors_blue__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colors_green__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__colorManipulator__ = __webpack_require__(513);













var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */].white,
    default: __WEBPACK_IMPORTED_MODULE_4__colors_grey__["a" /* default */][50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */].white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: __WEBPACK_IMPORTED_MODULE_4__colors_grey__["a" /* default */][800],
    default: '#303030'
  },
  action: {
    active: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */].white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = Object(__WEBPACK_IMPORTED_MODULE_11__colorManipulator__["d" /* lighten */])(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = Object(__WEBPACK_IMPORTED_MODULE_11__colorManipulator__["a" /* darken */])(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_5__colors_indigo__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_5__colors_indigo__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_5__colors_indigo__["a" /* default */][700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_6__colors_pink__["a" /* default */].A200,
    main: __WEBPACK_IMPORTED_MODULE_6__colors_pink__["a" /* default */].A400,
    dark: __WEBPACK_IMPORTED_MODULE_6__colors_pink__["a" /* default */].A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_7__colors_red__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_7__colors_red__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_7__colors_red__["a" /* default */][700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_8__colors_orange__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_8__colors_orange__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_8__colors_orange__["a" /* default */][700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_9__colors_blue__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_9__colors_blue__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_9__colors_blue__["a" /* default */][700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_10__colors_green__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_10__colors_green__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_10__colors_green__["a" /* default */][700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = Object(__WEBPACK_IMPORTED_MODULE_11__colorManipulator__["c" /* getContrastRatio */])(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = getContrastRatio(background, contrastText);

      if (contrast < 3) {
        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error( false ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property.") : Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["b" /* formatMuiErrorMessage */])(4, mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error( false ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from \"@material-ui/core/colors\";\n\nconst theme1 = createMuiTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createMuiTheme({ palette: {\n  primary: { main: green[500] },\n} });") : Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["b" /* formatMuiErrorMessage */])(5, JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  if (false) {
    if (!types[type]) {
      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
    }
  }

  var paletteOutput = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    // A collection of common colors.
    common: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */],
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: __WEBPACK_IMPORTED_MODULE_4__colors_grey__["a" /* default */],
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var common = {
  black: '#000',
  white: '#fff'
};
/* harmony default export */ __webpack_exports__["a"] = (common);

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
/* harmony default export */ __webpack_exports__["a"] = (grey);

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
/* harmony default export */ __webpack_exports__["a"] = (indigo);

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
/* harmony default export */ __webpack_exports__["a"] = (pink);

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
/* harmony default export */ __webpack_exports__["a"] = (red);

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
/* harmony default export */ __webpack_exports__["a"] = (orange);

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
/* harmony default export */ __webpack_exports__["a"] = (blue);

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
/* harmony default export */ __webpack_exports__["a"] = (green);

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTypography;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(100);




function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  if (false) {
    if (typeof fontSize !== 'number') {
      console.error('Material-UI: `fontSize` is required to be a number.');
    }

    if (typeof htmlFontSize !== 'number') {
      console.error('Material-UI: `htmlFontSize` is required to be a number.');
    }
  }

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: round,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
/* harmony default export */ __webpack_exports__["a"] = (shadows);

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var shape = {
  borderRadius: 4
};
/* harmony default export */ __webpack_exports__["a"] = (shape);

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSpacing;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_system__ = __webpack_require__(1448);

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_system__["a" /* createUnarySpacing */])({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (false) {
      if (!(args.length <= 4)) {
        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
      }
    }

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (false) {
        if (!warnOnce || process.env.NODE_ENV === 'test') {
          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
        }

        warnOnce = true;
      }

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__borders__ = __webpack_require__(787);
/* unused harmony reexport borders */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breakpoints__ = __webpack_require__(514);
/* unused harmony reexport breakpoints */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compose__ = __webpack_require__(176);
/* unused harmony reexport compose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css__ = __webpack_require__(1449);
/* unused harmony reexport css */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__display__ = __webpack_require__(1450);
/* unused harmony reexport display */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flexbox__ = __webpack_require__(789);
/* unused harmony reexport flexbox */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__grid__ = __webpack_require__(790);
/* unused harmony reexport grid */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__palette__ = __webpack_require__(791);
/* unused harmony reexport palette */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__positions__ = __webpack_require__(792);
/* unused harmony reexport positions */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shadows__ = __webpack_require__(1451);
/* unused harmony reexport shadows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sizing__ = __webpack_require__(793);
/* unused harmony reexport sizing */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__spacing__ = __webpack_require__(794);
/* unused harmony reexport spacing */
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_11__spacing__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style__ = __webpack_require__(154);
/* unused harmony reexport style */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__typography__ = __webpack_require__(795);
/* unused harmony reexport typography */
/* unused harmony namespace reexport */
/** @license Material-UI v4.11.3
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */























/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__merge__ = __webpack_require__(374);





function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
}

function css(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var output = styleFunction(props);

    if (props.css) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_3__merge__["a" /* default */])(output, styleFunction(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        theme: props.theme
      }, props.css))), omit(props.css, [styleFunction.filterProps]));
    }

    return output;
  };

  newStyleFunction.propTypes =  false ? _extends({}, styleFunction.propTypes, {
    css: PropTypes.object
  }) : {};
  newStyleFunction.filterProps = ['css'].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(styleFunction.filterProps));
  return newStyleFunction;
}

/* unused harmony default export */ var _unused_webpack_default_export = (css);

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export displayPrint */
/* unused harmony export displayRaw */
/* unused harmony export overflow */
/* unused harmony export textOverflow */
/* unused harmony export visibility */
/* unused harmony export whiteSpace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(176);


var displayPrint = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'displayPrint',
  cssProperty: false,
  transform: function transform(value) {
    return {
      '@media print': {
        display: value
      }
    };
  }
});
var displayRaw = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'display'
});
var overflow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'overflow'
});
var textOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'textOverflow'
});
var visibility = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'visibility'
});
var whiteSpace = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'whiteSpace'
});
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace));

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(154);

var boxShadow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'boxShadow',
  themeKey: 'shadows'
});
/* unused harmony default export */ var _unused_webpack_default_export = (boxShadow);

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(1455);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = memoize;
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export easing */
/* unused harmony export duration */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(99);

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


/* harmony default export */ __webpack_exports__["a"] = ({
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["duration", "easing", "delay"]);

    if (false) {
      var isString = function isString(value) {
        return typeof value === 'string';
      };

      var isNumber = function isNumber(value) {
        return !isNaN(parseFloat(value));
      };

      if (!isString(props) && !Array.isArray(props)) {
        console.error('Material-UI: Argument "props" must be a string or Array.');
      }

      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
      }

      if (!isString(easingOption)) {
        console.error('Material-UI: Argument "easing" must be a string.');
      }

      if (!isNumber(delay) && !isString(delay)) {
        console.error('Material-UI: Argument "delay" must be a number or a string.');
      }

      if (Object.keys(other).length !== 0) {
        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
      }
    }

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
});

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
/* harmony default export */ __webpack_exports__["a"] = (zIndex);

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableBody__ = __webpack_require__(1460);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TableBody__["a"]; });


/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(375);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-row-group'
  }
};
var tablelvl2 = {
  variant: 'body'
};
var defaultComponent = 'tbody';
var TableBody = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableBody(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */].Provider, {
    value: tablelvl2
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref,
    role: Component === defaultComponent ? null : 'rowgroup'
  }, other)));
});
 false ? TableBody.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableBody'
})(TableBody));

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableCell__ = __webpack_require__(1462);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TableCell__["a"]; });


/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Table_TableContext__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table_Tablelvl2Context__ = __webpack_require__(375);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, {
      display: 'table-cell',
      verticalAlign: 'inherit',
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["d" /* lighten */])(Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["b" /* fade */])(theme.palette.divider, 1), 0.88) : Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* darken */])(Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["b" /* fade */])(theme.palette.divider, 1), 0.68)),
      textAlign: 'left',
      padding: 16
    }),

    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
    head: {
      color: theme.palette.text.primary,
      lineHeight: theme.typography.pxToRem(24),
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
    body: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
    footer: {
      color: theme.palette.text.secondary,
      lineHeight: theme.typography.pxToRem(21),
      fontSize: theme.typography.pxToRem(12)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: '6px 24px 6px 16px',
      '&:last-child': {
        paddingRight: 16
      },
      '&$paddingCheckbox': {
        width: 24,
        // prevent the checkbox column from growing
        padding: '0 12px 0 16px',
        '&:last-child': {
          paddingLeft: 12,
          paddingRight: 16
        },
        '& > *': {
          padding: 0
        }
      }
    },

    /* Styles applied to the root element if `padding="checkbox"`. */
    paddingCheckbox: {
      width: 48,
      // prevent the checkbox column from growing
      padding: '0 0 0 4px',
      '&:last-child': {
        paddingLeft: 0,
        paddingRight: 4
      }
    },

    /* Styles applied to the root element if `padding="none"`. */
    paddingNone: {
      padding: 0,
      '&:last-child': {
        padding: 0
      }
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right',
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `context.table.stickyHeader={true}`. */
    stickyHeader: {
      position: 'sticky',
      top: 0,
      left: 0,
      zIndex: 2,
      backgroundColor: theme.palette.background.default
    }
  };
};
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */

var TableCell = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableCell(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      component = props.component,
      paddingProp = props.padding,
      scopeProp = props.scope,
      sizeProp = props.size,
      sortDirection = props.sortDirection,
      variantProp = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["align", "classes", "className", "component", "padding", "scope", "size", "sortDirection", "variant"]);

  var table = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_8__Table_TableContext__["a" /* default */]);
  var tablelvl2 = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_9__Table_Tablelvl2Context__["a" /* default */]);
  var isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
  var role;
  var Component;

  if (component) {
    Component = component;
    role = isHeadCell ? 'columnheader' : 'cell';
  } else {
    Component = isHeadCell ? 'th' : 'td';
  }

  var scope = scopeProp;

  if (!scope && isHeadCell) {
    scope = 'col';
  }

  var padding = paddingProp || (table && table.padding ? table.padding : 'default');
  var size = sizeProp || (table && table.size ? table.size : 'medium');
  var variant = variantProp || tablelvl2 && tablelvl2.variant;
  var ariaSort = null;

  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[variant], className, align !== 'inherit' && classes["align".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(align))], padding !== 'default' && classes["padding".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(padding))], size !== 'medium' && classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(size))], variant === 'head' && table && table.stickyHeader && classes.stickyHeader),
    "aria-sort": ariaSort,
    role: role,
    scope: scope
  }, other));
});
 false ? TableCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   */
  align: PropTypes.oneOf(['center', 'inherit', 'justify', 'left', 'right']),

  /**
   * The table cell contents.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Sets the padding applied to the cell.
   * By default, the Table parent component set the value (`default`).
   */
  padding: PropTypes.oneOf(['checkbox', 'default', 'none']),

  /**
   * Set scope attribute.
   */
  scope: PropTypes.string,

  /**
   * Specify the size of the cell.
   * By default, the Table parent component set the value (`medium`).
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * Set aria-sort direction.
   */
  sortDirection: PropTypes.oneOf(['asc', 'desc', false]),

  /**
   * Specify the cell type.
   * By default, the TableHead, TableBody or TableFooter parent component set the value.
   */
  variant: PropTypes.oneOf(['body', 'footer', 'head'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableCell'
})(TableCell));

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(100);

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error( false ? "Material-UI: capitalize(string) expects a string argument." : Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["b" /* formatMuiErrorMessage */])(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableHead__ = __webpack_require__(1465);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TableHead__["a"]; });


/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(375);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-header-group'
  }
};
var tablelvl2 = {
  variant: 'head'
};
var defaultComponent = 'thead';
var TableHead = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableHead(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */].Provider, {
    value: tablelvl2
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref,
    role: Component === defaultComponent ? null : 'rowgroup'
  }, other)));
});
 false ? TableHead.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableHead'
})(TableHead));

/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableRow__ = __webpack_require__(1467);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TableRow__["a"]; });


/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(513);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: 'inherit',
      display: 'table-row',
      verticalAlign: 'middle',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      '&$hover:hover': {
        backgroundColor: theme.palette.action.hover
      },
      '&$selected, &$selected:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["b" /* fade */])(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
      }
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {},

    /* Pseudo-class applied to the root element if `hover={true}`. */
    hover: {},

    /* Styles applied to the root element if table variant="head". */
    head: {},

    /* Styles applied to the root element if table variant="footer". */
    footer: {}
  };
};
var defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */

var TableRow = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableRow(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      _props$hover = props.hover,
      hover = _props$hover === void 0 ? false : _props$hover,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "hover", "selected"]);

  var tablelvl2 = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, tablelvl2 && {
      'head': classes.head,
      'footer': classes.footer
    }[tablelvl2.variant], hover && classes.hover, selected && classes.selected),
    role: Component === defaultComponent ? null : 'row'
  }, other));
});
 false ? TableRow.propTypes = {
  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the table row will shade on hover.
   */
  hover: PropTypes.bool,

  /**
   * If `true`, the table row will have the selected shading.
   */
  selected: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableRow'
})(TableRow));

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Helpers = exports.ScrollElement = exports.ScrollLink = exports.animateScroll = exports.scrollSpy = exports.Events = exports.scroller = exports.Element = exports.Button = exports.Link = undefined;

var _Link = __webpack_require__(1473);

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__(1477);

var _Button2 = _interopRequireDefault(_Button);

var _Element = __webpack_require__(1478);

var _Element2 = _interopRequireDefault(_Element);

var _scroller = __webpack_require__(376);

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollEvents = __webpack_require__(518);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _scrollSpy = __webpack_require__(516);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _animateScroll = __webpack_require__(797);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollLink = __webpack_require__(515);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

var _scrollElement = __webpack_require__(799);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _Helpers = __webpack_require__(1479);

var _Helpers2 = _interopRequireDefault(_Helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Link = _Link2.default;
exports.Button = _Button2.default;
exports.Element = _Element2.default;
exports.scroller = _scroller2.default;
exports.Events = _scrollEvents2.default;
exports.scrollSpy = _scrollSpy2.default;
exports.animateScroll = _animateScroll2.default;
exports.ScrollLink = _scrollLink2.default;
exports.ScrollElement = _scrollElement2.default;
exports.Helpers = _Helpers2.default;
exports.default = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(515);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkElement = function (_React$Component) {
  _inherits(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2.default.createElement(
        'a',
        _this.props,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LinkElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(LinkElement);

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(97)))

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__(517);

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

exports.default = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(515);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonElement = function (_React$Component) {
  _inherits(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck(this, ButtonElement);

    return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'input',
        this.props,
        this.props.children
      );
    }
  }]);

  return ButtonElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(ButtonElement);

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollElement = __webpack_require__(799);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ElementWrapper = function (_React$Component) {
  _inherits(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck(this, ElementWrapper);

    return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` from props
      var newProps = _extends({}, this.props);
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

;

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

exports.default = (0, _scrollElement2.default)(ElementWrapper);

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* DEPRECATED */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(60);

var utils = __webpack_require__(377);
var scrollSpy = __webpack_require__(516);
var defaultScroller = __webpack_require__(376);
var PropTypes = __webpack_require__(1);
var scrollHash = __webpack_require__(798);

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck(this, Scroll);

        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    ;

    Scroll.propTypes = protoTypes;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits(Element, _React$Component2);

      function Element(props) {
        _classCallCheck(this, Element);

        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.name !== prevProps.name) {
            this.registerElems(this.props.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    ;

    Element.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };

    return Element;
  }
};

module.exports = Helpers;

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = WorkOrdersTitle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorkOrdersTitle_css__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorkOrdersTitle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__WorkOrdersTitle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
function WorkOrdersTitle(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'work-orders-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,props.title),props.purchaseOrder!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wot-title'},'CURRENT PO #'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h3'},props.purchaseOrder.number)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wot-title'},'AMOUNT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h3'},__WEBPACK_IMPORTED_MODULE_3_numeral___default()(props.purchaseOrder.amount).format('$0,0'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wot-title'},'BALANCE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h3'},__WEBPACK_IMPORTED_MODULE_3_numeral___default()(props.purchaseOrder.balance).format('$0,0')))));}WorkOrdersTitle.propTypes={purchaseOrder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({amount:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,balance:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,number:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired}),title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired};WorkOrdersTitle.defaultProps={purchaseOrder:null};

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NewBuilding_css__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NewBuilding_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__NewBuilding_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_map_Map__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors_admin_work_orders_creation_buildings__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_admin_work_orders_creation_buildings__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_upload_png__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_upload_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_upload_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_files_FilesUploadedViewer__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selectors_admin_work_orders_creation_clients__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_admin_work_orders_creation_creation__ = __webpack_require__(124);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Shows both steps of a new building. The first "page" shows a form and submitting this creates a new building on the
 * backend. The second "page" allows to select the building from the map, change the form values and upload files.
 */var NewBuilding=function(_Component){_inherits(NewBuilding,_Component);function NewBuilding(props){_classCallCheck(this,NewBuilding);// If user is admin, check if a client is selected, otherwise route to client selection
var _this=_possibleConstructorReturn(this,(NewBuilding.__proto__||Object.getPrototypeOf(NewBuilding)).call(this,props));_this.handleChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_admin_work_orders_creation_buildings__["f" /* newBuildingChange */])(attribute,value));};_this.handleEditDetails=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_admin_work_orders_creation_buildings__["c" /* editNewBuilding */])());};_this.handleMapMarkerChange=function(newPosition){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_admin_work_orders_creation_buildings__["j" /* updateLocationRequest */])(_this.props.selectedBuildingId,newPosition.latitude,newPosition.longitude));};_this.handleOnDrop=function(files){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_admin_work_orders_creation_buildings__["k" /* uploadDocumentsRequest */])(_this.props.selectedBuildingId,files));};_this.handleDocumentRemove=function(documentId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_admin_work_orders_creation_buildings__["g" /* removeDocumentRequest */])(_this.props.selectedBuildingId,documentId));};_this.handleSubmit=function(event){event.preventDefault();if(_this.props.selectedBuildingId===0){// When creating building with Admin user, send selectedClientId to create building
_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_admin_work_orders_creation_buildings__["a" /* createBuildingRequest */])(_this.props.newBuildingForm,_this.props.selectedClientId!==null?_this.props.selectedClientId:undefined));}else{var newBuilding=_this.props.buildings.find(function(element){return element.id===_this.props.selectedBuildingId;});_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_admin_work_orders_creation_buildings__["i" /* updateBuildingRequest */])(newBuilding.id,newBuilding.location.id,_this.props.newBuildingForm,_this.props.currentWorkOrder,_this.props.selectedClientId!==null?_this.props.selectedClientId:undefined));}};if((__WEBPACK_IMPORTED_MODULE_14__services_utils_users_util__["g" /* usersUtil */].hasRole(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_14__services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_14__services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_14__services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR))&&_this.props.selectedClientId===null){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_admin_work_orders_creation_creation__["b" /* goToClientSelection */])());}return _this;}_createClass(NewBuilding,[{key:'render',value:function render(){var _this2=this;var newBuilding=this.props.buildings.find(function(element){return element.id===_this2.props.selectedBuildingId;});var routeTitle=['work orders'];if(this.props.selectedClientId!==null){var client=this.props.clients.find(function(client){return client.id===_this2.props.selectedClientId;});if(client!==undefined){routeTitle.push(client.company_name);}}routeTitle.push('add building');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'new-building'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_route_title_RouteTitle__["a" /* default */],{titles:routeTitle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},newBuilding===undefined?'Add a Building':'Property Details'),newBuilding!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_map_Map__["a" /* Map */],{latitude:newBuilding.location.latitude,longitude:newBuilding.location.longitude,onMarkerChanged:this.handleMapMarkerChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'building-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'building-form'+(newBuilding!==undefined?' new':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Building Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.handleSubmit},newBuilding===undefined?this.getNewFormTable():this.getEditFormTable(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-building-btn-container'},newBuilding===undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',className:'btn button button-orange',value:'Add Building'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',className:'btn button button-gray',value:'Edit Details',onClick:this.handleEditDetails}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',className:'btn button button-orange',value:'Confirm Details'}))))),newBuilding!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'building-files'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Insurance Requirements & Building Rules and Regulations'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Please drag and drop any file into this area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx',className:'building-files-dropzone',onDrop:this.handleOnDrop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__images_upload_png___default.a,alt:'remove'})),newBuilding.documents!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_files_FilesUploadedViewer__["a" /* default */],{documents:newBuilding.documents,title:'Files uploaded:',onDocumentRemove:this.handleDocumentRemove})))));}},{key:'getNewFormTable',value:function getNewFormTable(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["t" /* Table */],{responsive:true,className:'new-form-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{width:'21%'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{width:'21%'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{width:'21%'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{width:'6%'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{width:'6%'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.getStreetAddressFormControl(false)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.getFloorFormControl(false)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.getCityFormControl(false)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.getStateFormControl(false)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.getZipCodeFormControl(false))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.getNameFormControl(false)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null))));}},{key:'getEditFormTable',value:function getEditFormTable(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["t" /* Table */],{responsive:true,className:'edit-form-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{width:'50%'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{width:'16%'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{width:'16%'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{width:'18%'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.getStreetAddressFormControl(this.props.readOnly)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},this.getFloorFormControl(this.props.readOnly))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.getCityFormControl(this.props.readOnly)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.getStateFormControl(this.props.readOnly)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.getZipCodeFormControl(this.props.readOnly))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.getNameFormControl(this.props.readOnly)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null))));}},{key:'getNameFormControl',value:function getNameFormControl(readOnly){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["h" /* FormControl */],{type:'text',className:'input',placeholder:'Building Name',value:this.props.newBuildingForm.name,onChange:function onChange(event){return _this3.handleChange('name',event.target.value);},readOnly:readOnly});}},{key:'getStreetAddressFormControl',value:function getStreetAddressFormControl(readOnly){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["h" /* FormControl */],{type:'text',className:'input',placeholder:'Street Address Name',value:this.props.newBuildingForm.streetAddress,onChange:function onChange(event){return _this4.handleChange('streetAddress',event.target.value);},required:true,readOnly:readOnly});}},{key:'getFloorFormControl',value:function getFloorFormControl(readOnly){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["h" /* FormControl */],{type:'text',className:'input',placeholder:'Unit number / floor',value:this.props.newBuildingForm.unitNumber,onChange:function onChange(event){return _this5.handleChange('unitNumber',event.target.value);},readOnly:readOnly});}},{key:'getCityFormControl',value:function getCityFormControl(readOnly){var _this6=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["h" /* FormControl */],{type:'text',className:'input',placeholder:'City',value:this.props.newBuildingForm.city,onChange:function onChange(event){return _this6.handleChange('city',event.target.value);},required:true,readOnly:readOnly});}},{key:'getStateFormControl',value:function getStateFormControl(readOnly){var _this7=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["h" /* FormControl */],{type:'text',className:'input',placeholder:'State',value:this.props.newBuildingForm.state,onChange:function onChange(event){return _this7.handleChange('state',event.target.value);},required:true,readOnly:readOnly});}},{key:'getZipCodeFormControl',value:function getZipCodeFormControl(readOnly){var _this8=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["h" /* FormControl */],{type:'text',className:'input',placeholder:'Zip code',value:this.props.newBuildingForm.zipCode,onChange:function onChange(event){return _this8.handleChange('zipCode',event.target.value);},required:true,readOnly:readOnly});}}]);return NewBuilding;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(state){return{buildings:Object(__WEBPACK_IMPORTED_MODULE_11__selectors_admin_work_orders_work_orders__["a" /* getBuildings */])(state),clients:Object(__WEBPACK_IMPORTED_MODULE_12__selectors_admin_work_orders_creation_clients__["a" /* getClients */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_13__selectors_authentication__["d" /* getCurrentUser */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_11__selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),newBuildingForm:Object(__WEBPACK_IMPORTED_MODULE_6__selectors_admin_work_orders_creation_buildings__["a" /* getNewBuildingForm */])(state),readOnly:Object(__WEBPACK_IMPORTED_MODULE_6__selectors_admin_work_orders_creation_buildings__["b" /* getReadOnly */])(state),selectedBuildingId:Object(__WEBPACK_IMPORTED_MODULE_6__selectors_admin_work_orders_creation_buildings__["c" /* getSelectedBuildingId */])(state),selectedClientId:Object(__WEBPACK_IMPORTED_MODULE_12__selectors_admin_work_orders_creation_clients__["b" /* getSelectedClientId */])(state)};})(NewBuilding));

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Map; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_google_maps__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
function handleDragEnd(props,event){props.onMarkerChanged({latitude:event.latLng.lat(),longitude:event.latLng.lng()});}var Map=Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["withProps"])({googleMapURL:'https://maps.googleapis.com/maps/api/js?key='+Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://spackle-v1.fly.dev/","REACT_APP_CABLE_WSS_URL":"wss://spackle-v1.fly.dev/cable","REACT_APP_ADVANCED_DOCUMENTS_S3_BUCKET":"360-custom-document","REACT_APP_CLICKUP_FORM_URL":"https://forms.clickup.com/f/86zjg-822/NRB5VVG05QA0QWA5V1","REACT_APP_WEBVIEWER_URL":"https://spackle.s3.amazonaws.com/lib"}).REACT_APP_GOOGLE_MAPS_KEY+'&v=3.exp&libraries=geometry,drawing,places',loadingElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'440px',width:'100%',position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'fixed',top:'50%',left:'50%',transform:'translate(-50%, -50%)'}},'Loading...')),containerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'440px'}}),mapElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'100%'}})}),__WEBPACK_IMPORTED_MODULE_2_react_google_maps__["withScriptjs"],__WEBPACK_IMPORTED_MODULE_2_react_google_maps__["withGoogleMap"])(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_google_maps__["GoogleMap"],{defaultZoom:17,defaultCenter:{lat:props.latitude,lng:props.longitude}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_google_maps__["Marker"],{draggable:true,position:{lat:props.latitude,lng:props.longitude},onDragEnd:function onDragEnd(event){return handleDragEnd(props,event);}}));});Map.propTypes={latitude:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,longitude:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,onMarkerChanged:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _withScriptjs = __webpack_require__(1489)

Object.defineProperty(exports, "withScriptjs", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withScriptjs).default
  },
})

var _withGoogleMap = __webpack_require__(1546)

Object.defineProperty(exports, "withGoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withGoogleMap).default
  },
})

var _GoogleMap = __webpack_require__(1547)

Object.defineProperty(exports, "GoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GoogleMap).default
  },
})

var _Circle = __webpack_require__(1634)

Object.defineProperty(exports, "Circle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default
  },
})

var _Marker = __webpack_require__(1635)

Object.defineProperty(exports, "Marker", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Marker).default
  },
})

var _Polyline = __webpack_require__(1636)

Object.defineProperty(exports, "Polyline", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polyline).default
  },
})

var _Polygon = __webpack_require__(1637)

Object.defineProperty(exports, "Polygon", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polygon).default
  },
})

var _Rectangle = __webpack_require__(1638)

Object.defineProperty(exports, "Rectangle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Rectangle).default
  },
})

var _InfoWindow = __webpack_require__(1639)

Object.defineProperty(exports, "InfoWindow", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InfoWindow).default
  },
})

var _OverlayView = __webpack_require__(1640)

Object.defineProperty(exports, "OverlayView", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OverlayView).default
  },
})

var _GroundOverlay = __webpack_require__(1647)

Object.defineProperty(exports, "GroundOverlay", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GroundOverlay).default
  },
})

var _DirectionsRenderer = __webpack_require__(1648)

Object.defineProperty(exports, "DirectionsRenderer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DirectionsRenderer).default
  },
})

var _FusionTablesLayer = __webpack_require__(1649)

Object.defineProperty(exports, "FusionTablesLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FusionTablesLayer).default
  },
})

var _KmlLayer = __webpack_require__(1650)

Object.defineProperty(exports, "KmlLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_KmlLayer).default
  },
})

var _TrafficLayer = __webpack_require__(1651)

Object.defineProperty(exports, "TrafficLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TrafficLayer).default
  },
})

var _StreetViewPanorama = __webpack_require__(1652)

Object.defineProperty(exports, "StreetViewPanorama", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StreetViewPanorama).default
  },
})

var _BicyclingLayer = __webpack_require__(1653)

Object.defineProperty(exports, "BicyclingLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BicyclingLayer).default
  },
})

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _objectWithoutProperties2 = __webpack_require__(801)

var _objectWithoutProperties3 = _interopRequireDefault(
  _objectWithoutProperties2
)

var _getPrototypeOf = __webpack_require__(79)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(80)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(81)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(82)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(83)

var _inherits3 = _interopRequireDefault(_inherits2)

var _bind2 = __webpack_require__(380)

var _bind3 = _interopRequireDefault(_bind2)

exports.withScriptjs = withScriptjs

var _invariant = __webpack_require__(56)

var _invariant2 = _interopRequireDefault(_invariant)

var _canUseDom = __webpack_require__(824)

var _canUseDom2 = _interopRequireDefault(_canUseDom)

var _recompose = __webpack_require__(519)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

var LOADING_STATE_NONE = "NONE"
var LOADING_STATE_BEGIN = "BEGIN"
var LOADING_STATE_LOADED = "LOADED"

function withScriptjs(BaseComponent) {
  var factory = _react2.default.createFactory(BaseComponent)

  var Container = (function(_React$PureComponent) {
    ;(0, _inherits3.default)(Container, _React$PureComponent)

    function Container() {
      var _ref

      var _temp, _this, _ret

      ;(0, _classCallCheck3.default)(this, Container)

      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key]
      }

      return (
        (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
          this,
          (_ref =
            Container.__proto__ ||
            (0, _getPrototypeOf2.default)(Container)).call.apply(
            _ref,
            [this].concat(args)
          )
        )),
        _this)),
        (_this.state = {
          loadingState: LOADING_STATE_NONE,
        }),
        (_this.isUnmounted = false),
        (_this.handleLoaded = (0, _bind3.default)(_this.handleLoaded, _this)),
        _temp)),
        (0, _possibleConstructorReturn3.default)(_this, _ret)
      )
    }

    ;(0, _createClass3.default)(Container, [
      {
        key: "handleLoaded",
        value: function handleLoaded() {
          if (this.isUnmounted) {
            return
          }
          this.setState({
            loadingState: LOADING_STATE_LOADED,
          })
        },
      },
      {
        key: "componentWillMount",
        value: function componentWillMount() {
          var _props = this.props,
            loadingElement = _props.loadingElement,
            googleMapURL = _props.googleMapURL

          ;(0, _invariant2.default)(
            !!loadingElement && !!googleMapURL,
            "Required props loadingElement or googleMapURL is missing. You need to provide both of them."
          )
        },
      },
      {
        key: "componentDidMount",
        value: function componentDidMount() {
          var loadingState = this.state.loadingState

          if (loadingState !== LOADING_STATE_NONE || !_canUseDom2.default) {
            return
          }
          this.setState({
            loadingState: LOADING_STATE_BEGIN,
          })
          // Don't load scriptjs as a dependency since we do not want this module be used on server side.
          // eslint-disable-next-line global-require
          var scriptjs = __webpack_require__(1545)
          var googleMapURL = this.props.googleMapURL

          scriptjs(googleMapURL, this.handleLoaded)
        },
      },
      {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.isUnmounted = true
        },
      },
      {
        key: "render",
        value: function render() {
          var _props2 = this.props,
            loadingElement = _props2.loadingElement,
            googleMapURL = _props2.googleMapURL,
            restProps = (0, _objectWithoutProperties3.default)(_props2, [
              "loadingElement",
              "googleMapURL",
            ])
          var loadingState = this.state.loadingState

          if (loadingState === LOADING_STATE_LOADED) {
            return factory(restProps)
          } else {
            return loadingElement
          }
        },
      },
    ])
    return Container
  })(_react2.default.PureComponent)

  Container.displayName =
    "withScriptjs(" + (0, _recompose.getDisplayName)(BaseComponent) + ")"
  Container.propTypes = {
    loadingElement: _propTypes2.default.node.isRequired,
    googleMapURL: _propTypes2.default.string.isRequired,
  }

  return Container
}

exports.default = withScriptjs


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1491);
module.exports = __webpack_require__(77).Object.getPrototypeOf;


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(247);
var $getPrototypeOf = __webpack_require__(708);

__webpack_require__(693)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1493);
var $Object = __webpack_require__(77).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(111);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(172), 'Object', { defineProperty: __webpack_require__(195).f });


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1495), __esModule: true };

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(705);
__webpack_require__(1496);
module.exports = __webpack_require__(520).f('iterator');


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1497);
var global = __webpack_require__(171);
var hide = __webpack_require__(243);
var Iterators = __webpack_require__(298);
var TO_STRING_TAG = __webpack_require__(151)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1498);
var step = __webpack_require__(1499);
var Iterators = __webpack_require__(298);
var toIObject = __webpack_require__(221);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(706)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1498 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 1499 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1501), __esModule: true };

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1502);
__webpack_require__(1506);
__webpack_require__(1507);
__webpack_require__(1508);
module.exports = __webpack_require__(77).Symbol;


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(171);
var has = __webpack_require__(220);
var DESCRIPTORS = __webpack_require__(172);
var $export = __webpack_require__(111);
var redefine = __webpack_require__(707);
var META = __webpack_require__(1503).KEY;
var $fails = __webpack_require__(219);
var shared = __webpack_require__(474);
var setToStringTag = __webpack_require__(484);
var uid = __webpack_require__(351);
var wks = __webpack_require__(151);
var wksExt = __webpack_require__(520);
var wksDefine = __webpack_require__(521);
var enumKeys = __webpack_require__(1504);
var isArray = __webpack_require__(729);
var anObject = __webpack_require__(244);
var isObject = __webpack_require__(245);
var toObject = __webpack_require__(247);
var toIObject = __webpack_require__(221);
var toPrimitive = __webpack_require__(470);
var createDesc = __webpack_require__(293);
var _create = __webpack_require__(477);
var gOPNExt = __webpack_require__(1505);
var $GOPD = __webpack_require__(691);
var $GOPS = __webpack_require__(476);
var $DP = __webpack_require__(195);
var $keys = __webpack_require__(246);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(804).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(294).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(350)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(243)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(351)('meta');
var isObject = __webpack_require__(245);
var has = __webpack_require__(220);
var setDesc = __webpack_require__(195).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(219)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(246);
var gOPS = __webpack_require__(476);
var pIE = __webpack_require__(294);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(221);
var gOPN = __webpack_require__(804).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1506 */
/***/ (function(module, exports) {



/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(521)('asyncIterator');


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(521)('observable');


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(690), __esModule: true };

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(689), __esModule: true };

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(523);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1513),
    defineProperty = __webpack_require__(806),
    identity = __webpack_require__(305);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1513 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(260),
    isMasked = __webpack_require__(1517),
    isObject = __webpack_require__(125),
    toSource = __webpack_require__(808);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(381);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1516 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1518);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(112);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1519 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(810),
    createBind = __webpack_require__(1521),
    createCurry = __webpack_require__(1522),
    createHybrid = __webpack_require__(813),
    createPartial = __webpack_require__(1539),
    getData = __webpack_require__(817),
    mergeData = __webpack_require__(1540),
    setData = __webpack_require__(820),
    setWrapToString = __webpack_require__(821),
    toInteger = __webpack_require__(1541);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(382),
    root = __webpack_require__(112);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(523),
    createCtor = __webpack_require__(382),
    createHybrid = __webpack_require__(813),
    createRecurry = __webpack_require__(816),
    getHolder = __webpack_require__(526),
    replaceHolders = __webpack_require__(385),
    root = __webpack_require__(112);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 1523 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(524),
    getData = __webpack_require__(817),
    getFuncName = __webpack_require__(1526),
    lodash = __webpack_require__(1528);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 1525 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(1527);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 1527 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(524),
    LodashWrapper = __webpack_require__(818),
    baseLodash = __webpack_require__(525),
    isArray = __webpack_require__(113),
    isObjectLike = __webpack_require__(261),
    wrapperClone = __webpack_require__(1529);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(524),
    LodashWrapper = __webpack_require__(818),
    copyArray = __webpack_require__(819);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 1530 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 1531 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(822),
    arrayIncludes = __webpack_require__(1533);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(1534);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1535),
    baseIsNaN = __webpack_require__(1536),
    strictIndexOf = __webpack_require__(1537);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 1535 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 1536 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1537 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(819),
    isIndex = __webpack_require__(384);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(523),
    createCtor = __webpack_require__(382),
    root = __webpack_require__(112);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(814),
    composeArgsRight = __webpack_require__(815),
    replaceHolders = __webpack_require__(385);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(1542);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(823);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(1544);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 1544 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _objectWithoutProperties2 = __webpack_require__(801)

var _objectWithoutProperties3 = _interopRequireDefault(
  _objectWithoutProperties2
)

var _defineProperty2 = __webpack_require__(91)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(79)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(80)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(81)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(82)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(83)

var _inherits3 = _interopRequireDefault(_inherits2)

var _bind2 = __webpack_require__(380)

var _bind3 = _interopRequireDefault(_bind2)

exports.withGoogleMap = withGoogleMap

var _warning = __webpack_require__(105)

var _warning2 = _interopRequireDefault(_warning)

var _invariant = __webpack_require__(56)

var _invariant2 = _interopRequireDefault(_invariant)

var _recompose = __webpack_require__(519)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _constants = __webpack_require__(92)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
function withGoogleMap(BaseComponent) {
  var factory = _react2.default.createFactory(BaseComponent)

  var Container = (function(_React$PureComponent) {
    ;(0, _inherits3.default)(Container, _React$PureComponent)

    function Container() {
      var _ref

      var _temp, _this, _ret

      ;(0, _classCallCheck3.default)(this, Container)

      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key]
      }

      return (
        (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
          this,
          (_ref =
            Container.__proto__ ||
            (0, _getPrototypeOf2.default)(Container)).call.apply(
            _ref,
            [this].concat(args)
          )
        )),
        _this)),
        (_this.state = {
          map: null,
        }),
        (_this.handleComponentMount = (0, _bind3.default)(
          _this.handleComponentMount,
          _this
        )),
        _temp)),
        (0, _possibleConstructorReturn3.default)(_this, _ret)
      )
    }

    ;(0, _createClass3.default)(Container, [
      {
        key: "getChildContext",
        value: function getChildContext() {
          return (0, _defineProperty3.default)(
            {},
            _constants.MAP,
            this.state.map
          )
        },
      },
      {
        key: "componentWillMount",
        value: function componentWillMount() {
          var _props = this.props,
            containerElement = _props.containerElement,
            mapElement = _props.mapElement

          ;(0, _invariant2.default)(
            !!containerElement && !!mapElement,
            "Required props containerElement or mapElement is missing. You need to provide both of them.\n The `google.maps.Map` instance will be initialized on mapElement and it's wrapped by containerElement.\nYou need to provide both of them since Google Map requires the DOM to have height when initialized."
          )
        },
      },
      {
        key: "handleComponentMount",
        value: function handleComponentMount(node) {
          if (this.state.map || node === null) {
            return
          }
          ;(0, _warning2.default)(
            "undefined" !== typeof google,
            "Make sure you've put a <script> tag in your <head> element to load Google Maps JavaScript API v3.\n If you're looking for built-in support to load it for you, use the \"async/ScriptjsLoader\" instead.\n See https://github.com/tomchentw/react-google-maps/pull/168"
          )
          // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
          var map = new google.maps.Map(node)
          this.setState({ map: map })
        },
      },
      {
        key: "render",
        value: function render() {
          var _props2 = this.props,
            containerElement = _props2.containerElement,
            mapElement = _props2.mapElement,
            restProps = (0, _objectWithoutProperties3.default)(_props2, [
              "containerElement",
              "mapElement",
            ])
          var map = this.state.map

          if (map) {
            return _react2.default.cloneElement(
              containerElement,
              {},
              _react2.default.cloneElement(mapElement, {
                ref: this.handleComponentMount,
              }),
              _react2.default.createElement("div", null, factory(restProps))
            )
          } else {
            return _react2.default.cloneElement(
              containerElement,
              {},
              _react2.default.cloneElement(mapElement, {
                ref: this.handleComponentMount,
              }),
              _react2.default.createElement("div", null)
            )
          }
        },
      },
    ])
    return Container
  })(_react2.default.PureComponent)

  Container.displayName =
    "withGoogleMap(" + (0, _recompose.getDisplayName)(BaseComponent) + ")"
  Container.propTypes = {
    containerElement: _propTypes2.default.node.isRequired,
    mapElement: _propTypes2.default.node.isRequired,
  }
  Container.childContextTypes = (0, _defineProperty3.default)(
    {},
    _constants.MAP,
    _propTypes2.default.object
  )

  return Container
}

exports.default = withGoogleMap


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.GoogleMap = exports.Map = undefined

var _defineProperty2 = __webpack_require__(91)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _toConsumableArray2 = __webpack_require__(1548)

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2)

var _getPrototypeOf = __webpack_require__(79)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(80)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _possibleConstructorReturn2 = __webpack_require__(82)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _createClass2 = __webpack_require__(81)

var _createClass3 = _interopRequireDefault(_createClass2)

var _inherits2 = __webpack_require__(83)

var _inherits3 = _interopRequireDefault(_inherits2)

var _invariant = __webpack_require__(56)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(101)

var _constants = __webpack_require__(92)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Map`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
 */
var Map = (exports.Map = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Map, _React$PureComponent)
  ;(0, _createClass3.default)(Map, [
    {
      key: "fitBounds",

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
      value: function fitBounds() {
        var _context$MAP

        return (_context$MAP = this.context[_constants.MAP]).fitBounds.apply(
          _context$MAP,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panBy",
      value: function panBy() {
        var _context$MAP2

        return (_context$MAP2 = this.context[_constants.MAP]).panBy.apply(
          _context$MAP2,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panTo",
      value: function panTo() {
        var _context$MAP3

        return (_context$MAP3 = this.context[_constants.MAP]).panTo.apply(
          _context$MAP3,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panToBounds",
      value: function panToBounds() {
        var _context$MAP4

        return (_context$MAP4 = this.context[_constants.MAP]).panToBounds.apply(
          _context$MAP4,
          arguments
        )
      },

      /*
     * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
     */
    },
  ])

  function Map(props, context) {
    ;(0, _classCallCheck3.default)(this, Map)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Map.__proto__ || (0, _getPrototypeOf2.default)(Map)).call(
        this,
        props,
        context
      )
    )

    ;(0, _invariant2.default)(
      !!_this.context[_constants.MAP],
      "Did you wrap <GoogleMap> component with withGoogleMap() HOC?"
    )
    ;(0, _MapChildHelper.construct)(
      GoogleMap.propTypes,
      updaterMap,
      _this.props,
      _this.context[_constants.MAP]
    )
    return _this
  }

  ;(0, _createClass3.default)(Map, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.context[_constants.MAP],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.context[_constants.MAP],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       * Returns the lat/lng bounds of the current viewport. If more than one copy of the world is visible, the bounds range in longitude from -180 to 180 degrees inclusive. If the map is not yet initialized (i.e. the mapType is still null), or center and zoom have not been set then the result is `null` or `undefined`.
       * @type LatLngBoundsnullundefined
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.context[_constants.MAP].getBounds()
      },

      /**
       * Returns the position displayed at the center of the map. Note that this `LatLng` object is _not_ wrapped. See `[LatLng](#LatLng)` for more information.
       * @type LatLngLatLngLatLng
       * @public
       */
    },
    {
      key: "getCenter",
      value: function getCenter() {
        return this.context[_constants.MAP].getCenter()
      },

      /**
       * Returns the clickability of the map icons. A map icon represents a point of interest, also known as a POI. If the returned value is true, then the icons are clickable on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getClickableIcons",
      value: function getClickableIcons() {
        return this.context[_constants.MAP].getClickableIcons()
      },

      /**
       *
       * @type Element
       * @public
       */
    },
    {
      key: "getDiv",
      value: function getDiv() {
        return this.context[_constants.MAP].getDiv()
      },

      /**
       * Returns the compass heading of aerial imagery. The heading value is measured in degrees (clockwise) from cardinal direction North.
       * @type number
       * @public
       */
    },
    {
      key: "getHeading",
      value: function getHeading() {
        return this.context[_constants.MAP].getHeading()
      },

      /**
       *
       * @type MapTypeId|string
       * @public
       */
    },
    {
      key: "getMapTypeId",
      value: function getMapTypeId() {
        return this.context[_constants.MAP].getMapTypeId()
      },

      /**
       * Returns the current `Projection`. If the map is not yet initialized (i.e. the mapType is still null) then the result is null. Listen to `projection_changed` and check its value to ensure it is not null.
       * @type ProjectionProjectionprojection_changed
       * @public
       */
    },
    {
      key: "getProjection",
      value: function getProjection() {
        return this.context[_constants.MAP].getProjection()
      },

      /**
       * Returns the default `StreetViewPanorama` bound to the map, which may be a default panorama embedded within the map, or the panorama set using `setStreetView()`. Changes to the map's `streetViewControl` will be reflected in the display of such a bound panorama.
       * @type StreetViewPanoramaStreetViewPanoramasetStreetView()streetViewControl
       * @public
       */
    },
    {
      key: "getStreetView",
      value: function getStreetView() {
        return this.context[_constants.MAP].getStreetView()
      },

      /**
       * Returns the current angle of incidence of the map, in degrees from the viewport plane to the map plane. The result will be `0` for imagery taken directly overhead or `45` for 45° imagery. 45° imagery is only available for `satellite` and `hybrid` map types, within some locations, and at some zoom levels. **Note:** This method does not return the value set by `setTilt`. See `setTilt` for details.
       * @type number045satellitehybridsetTiltsetTilt
       * @public
       */
    },
    {
      key: "getTilt",
      value: function getTilt() {
        return this.context[_constants.MAP].getTilt()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZoom",
      value: function getZoom() {
        return this.context[_constants.MAP].getZoom()
      },
    },
  ])
  return Map
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */

Map.displayName = "GoogleMap"
Map.propTypes = {
  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapTypeRegistry
   * @type Array<[id:string, mapType:MapType|*]>
   */
  defaultExtraMapTypes: _propTypes2.default.arrayOf(
    _propTypes2.default.arrayOf(_propTypes2.default.any)
  ),

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultCenter: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultClickableIcons: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultHeading: _propTypes2.default.number,

  /**
   * @type MapTypeId|string
   */
  defaultMapTypeId: _propTypes2.default.any,

  /**
   * @type MapOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type StreetViewPanorama
   */
  defaultStreetView: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultTilt: _propTypes2.default.number,

  /**
   * @type number
   */
  defaultZoom: _propTypes2.default.number,

  /**
   * @type LatLng|LatLngLiteral
   */
  center: _propTypes2.default.any,

  /**
   * @type boolean
   */
  clickableIcons: _propTypes2.default.bool,

  /**
   * @type number
   */
  heading: _propTypes2.default.number,

  /**
   * @type MapTypeId|string
   */
  mapTypeId: _propTypes2.default.any,

  /**
   * @type MapOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type StreetViewPanorama
   */
  streetView: _propTypes2.default.any,

  /**
   * @type number
   */
  tilt: _propTypes2.default.number,

  /**
   * @type number
   */
  zoom: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMapTypeIdChanged: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onTilesLoaded: _propTypes2.default.func,

  /**
   * function
   */
  onBoundsChanged: _propTypes2.default.func,

  /**
   * function
   */
  onCenterChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onHeadingChanged: _propTypes2.default.func,

  /**
   * function
   */
  onIdle: _propTypes2.default.func,

  /**
   * function
   */
  onProjectionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onResize: _propTypes2.default.func,

  /**
   * function
   */
  onTiltChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZoomChanged: _propTypes2.default.func,
}
Map.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
var GoogleMap = (exports.GoogleMap = Map)

exports.default = Map

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMapTypeIdChanged: "maptypeid_changed",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onRightClick: "rightclick",
  onTilesLoaded: "tilesloaded",
  onBoundsChanged: "bounds_changed",
  onCenterChanged: "center_changed",
  onClick: "click",
  onDrag: "drag",
  onHeadingChanged: "heading_changed",
  onIdle: "idle",
  onProjectionChanged: "projection_changed",
  onResize: "resize",
  onTiltChanged: "tilt_changed",
  onZoomChanged: "zoom_changed",
}

var updaterMap = {
  extraMapTypes: function extraMapTypes(instance, extra) {
    extra.forEach(function(it) {
      var _instance$mapTypes

      return (_instance$mapTypes = instance.mapTypes).set.apply(
        _instance$mapTypes,
        (0, _toConsumableArray3.default)(it)
      )
    })
  },
  center: function center(instance, _center) {
    instance.setCenter(_center)
  },
  clickableIcons: function clickableIcons(instance, _clickableIcons) {
    instance.setClickableIcons(_clickableIcons)
  },
  heading: function heading(instance, _heading) {
    instance.setHeading(_heading)
  },
  mapTypeId: function mapTypeId(instance, _mapTypeId) {
    instance.setMapTypeId(_mapTypeId)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  streetView: function streetView(instance, _streetView) {
    instance.setStreetView(_streetView)
  },
  tilt: function tilt(instance, _tilt) {
    instance.setTilt(_tilt)
  },
  zoom: function zoom(instance, _zoom) {
    instance.setZoom(_zoom)
  },
}


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1549);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(704), __esModule: true };

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(1551),
    baseEach = __webpack_require__(527),
    baseIteratee = __webpack_require__(826),
    baseReduce = __webpack_require__(1622),
    isArray = __webpack_require__(113);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 1551 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1553),
    keys = __webpack_require__(307);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1554);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1554 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1556),
    isArguments = __webpack_require__(528),
    isArray = __webpack_require__(113),
    isBuffer = __webpack_require__(529),
    isIndex = __webpack_require__(384),
    isTypedArray = __webpack_require__(530);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 1556 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(306),
    isObjectLike = __webpack_require__(261);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1558 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(306),
    isLength = __webpack_require__(531),
    isObjectLike = __webpack_require__(261);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1560 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(807);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(368)(module)))

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1563);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1563 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(308);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1566),
    getMatchData = __webpack_require__(1609),
    matchesStrictComparable = __webpack_require__(832);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(827),
    baseIsEqual = __webpack_require__(828);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1567 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(388);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(388);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(388);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(388);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(387);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1573 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1574 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1575 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(387),
    Map = __webpack_require__(533),
    MapCache = __webpack_require__(534);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1578),
    ListCache = __webpack_require__(387),
    Map = __webpack_require__(533);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1579),
    hashDelete = __webpack_require__(1580),
    hashGet = __webpack_require__(1581),
    hashHas = __webpack_require__(1582),
    hashSet = __webpack_require__(1583);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(390);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1580 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(390);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(390);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(390);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(391);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1585 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(391);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(391);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(391);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(827),
    equalArrays = __webpack_require__(829),
    equalByTag = __webpack_require__(1595),
    equalObjects = __webpack_require__(1599),
    getTag = __webpack_require__(830),
    isArray = __webpack_require__(113),
    isBuffer = __webpack_require__(529),
    isTypedArray = __webpack_require__(530);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(534),
    setCacheAdd = __webpack_require__(1591),
    setCacheHas = __webpack_require__(1592);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 1591 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1592 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1593 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1594 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(381),
    Uint8Array = __webpack_require__(1596),
    eq = __webpack_require__(389),
    equalArrays = __webpack_require__(829),
    mapToArray = __webpack_require__(1597),
    setToArray = __webpack_require__(1598);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(112);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 1597 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1598 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1600);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1601),
    getSymbols = __webpack_require__(1603),
    keys = __webpack_require__(307);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1602),
    isArray = __webpack_require__(113);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 1602 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1604),
    stubArray = __webpack_require__(1605);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 1604 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1605 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(228),
    root = __webpack_require__(112);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(228),
    root = __webpack_require__(112);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(228),
    root = __webpack_require__(112);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(831),
    keys = __webpack_require__(307);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(828),
    get = __webpack_require__(1611),
    hasIn = __webpack_require__(1617),
    isKey = __webpack_require__(535),
    isStrictComparable = __webpack_require__(831),
    matchesStrictComparable = __webpack_require__(832),
    toKey = __webpack_require__(392);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(833);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1613);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1614);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(534);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(381),
    arrayMap = __webpack_require__(1616),
    isArray = __webpack_require__(113),
    isSymbol = __webpack_require__(386);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1616 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1618),
    hasPath = __webpack_require__(836);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1618 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1620),
    basePropertyDeep = __webpack_require__(1621),
    isKey = __webpack_require__(535),
    toKey = __webpack_require__(392);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1620 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(833);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1622 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(822),
    baseEach = __webpack_require__(527),
    castFunction = __webpack_require__(1624),
    isArray = __webpack_require__(113);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(305);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(1626);

/**
 * Converts the first character of `string` to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.lowerFirst('Fred');
 * // => 'fred'
 *
 * _.lowerFirst('FRED');
 * // => 'fRED'
 */
var lowerFirst = createCaseFirst('toLowerCase');

module.exports = lowerFirst;


/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(1627),
    hasUnicode = __webpack_require__(837),
    stringToArray = __webpack_require__(1629),
    toString = __webpack_require__(835);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(1628);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 1628 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(1630),
    hasUnicode = __webpack_require__(837),
    unicodeToArray = __webpack_require__(1631);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 1630 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 1631 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(1633),
    hasPath = __webpack_require__(836);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 1633 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Circle = undefined

var _defineProperty2 = __webpack_require__(91)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(79)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(80)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(81)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(82)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(83)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(101)

var _constants = __webpack_require__(92)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Circle`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Circle = (exports.Circle = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Circle, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
   */
  function Circle(props, context) {
    ;(0, _classCallCheck3.default)(this, Circle)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Circle.__proto__ || (0, _getPrototypeOf2.default)(Circle)).call(
        this,
        props,
        context
      )
    )

    var circle = new google.maps.Circle()
    ;(0, _MapChildHelper.construct)(
      Circle.propTypes,
      updaterMap,
      _this.props,
      circle
    )
    circle.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)({}, _constants.CIRCLE, circle)
    return _this
  }

  ;(0, _createClass3.default)(Circle, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.CIRCLE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.CIRCLE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var circle = this.state[_constants.CIRCLE]
        if (circle) {
          circle.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Gets the `LatLngBounds` of this Circle.
       * @type LatLngBoundsLatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.CIRCLE].getBounds()
      },

      /**
       * Returns the center of this circle.
       * @type LatLng
       * @public
       */
    },
    {
      key: "getCenter",
      value: function getCenter() {
        return this.state[_constants.CIRCLE].getCenter()
      },

      /**
       * Returns whether this circle can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.CIRCLE].getDraggable()
      },

      /**
       * Returns whether this circle can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.CIRCLE].getEditable()
      },

      /**
       * Returns the radius of this circle (in meters).
       * @type number
       * @public
       */
    },
    {
      key: "getRadius",
      value: function getRadius() {
        return this.state[_constants.CIRCLE].getRadius()
      },

      /**
       * Returns whether this circle is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.CIRCLE].getVisible()
      },
    },
  ])
  return Circle
})(_react2.default.PureComponent))

Circle.propTypes = {
  /**
   * @type LatLng|LatLngLiteral
   */
  defaultCenter: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type CircleOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultRadius: _propTypes2.default.number,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type LatLng|LatLngLiteral
   */
  center: _propTypes2.default.any,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type CircleOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type number
   */
  radius: _propTypes2.default.number,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onCenterChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onRadiusChanged: _propTypes2.default.func,
}
Circle.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Circle

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onCenterChanged: "center_changed",
  onClick: "click",
  onDrag: "drag",
  onRadiusChanged: "radius_changed",
}

var updaterMap = {
  center: function center(instance, _center) {
    instance.setCenter(_center)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  radius: function radius(instance, _radius) {
    instance.setRadius(_radius)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Marker = undefined

var _defineProperty2 = __webpack_require__(91)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(79)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(80)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(81)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(82)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(83)

var _inherits3 = _interopRequireDefault(_inherits2)

var _Marker$contextTypes /*
                           * -----------------------------------------------------------------------------
                           * This file is auto-generated from the corresponding file at `src/macros/`.
                           * Please **DO NOT** edit this file directly when creating PRs.
                           * -----------------------------------------------------------------------------
                           */
/* global google */

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(101)

var _constants = __webpack_require__(92)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Marker`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
 */
var Marker = (exports.Marker = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Marker, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
   */
  function Marker(props, context) {
    ;(0, _classCallCheck3.default)(this, Marker)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Marker.__proto__ || (0, _getPrototypeOf2.default)(Marker)).call(
        this,
        props,
        context
      )
    )

    var marker = new google.maps.Marker()
    ;(0, _MapChildHelper.construct)(
      Marker.propTypes,
      updaterMap,
      _this.props,
      marker
    )
    var markerClusterer = _this.context[_constants.MARKER_CLUSTERER]
    if (markerClusterer) {
      markerClusterer.addMarker(marker, !!_this.props.noRedraw)
    } else {
      marker.setMap(_this.context[_constants.MAP])
    }
    _this.state = (0, _defineProperty3.default)({}, _constants.MARKER, marker)
    return _this
  }

  ;(0, _createClass3.default)(Marker, [
    {
      key: "getChildContext",
      value: function getChildContext() {
        return (0, _defineProperty3.default)(
          {},
          _constants.ANCHOR,
          this.context[_constants.ANCHOR] || this.state[_constants.MARKER]
        )
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.MARKER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.MARKER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var marker = this.state[_constants.MARKER]
        if (marker) {
          var markerClusterer = this.context[_constants.MARKER_CLUSTERER]
          if (markerClusterer) {
            markerClusterer.removeMarker(marker, !!this.props.noRedraw)
          }
          marker.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       *
       * @type Animation
       * @public
       */
    },
    {
      key: "getAnimation",
      value: function getAnimation() {
        return this.state[_constants.MARKER].getAnimation()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getClickable",
      value: function getClickable() {
        return this.state[_constants.MARKER].getClickable()
      },

      /**
       *
       * @type string
       * @public
       */
    },
    {
      key: "getCursor",
      value: function getCursor() {
        return this.state[_constants.MARKER].getCursor()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.MARKER].getDraggable()
      },

      /**
       *
       * @type string|Icon|Symbol
       * @public
       */
    },
    {
      key: "getIcon",
      value: function getIcon() {
        return this.state[_constants.MARKER].getIcon()
      },

      /**
       *
       * @type MarkerLabel
       * @public
       */
    },
    {
      key: "getLabel",
      value: function getLabel() {
        return this.state[_constants.MARKER].getLabel()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getOpacity",
      value: function getOpacity() {
        return this.state[_constants.MARKER].getOpacity()
      },

      /**
       *
       * @type MarkerPlace
       * @public
       */
    },
    {
      key: "getPlace",
      value: function getPlace() {
        return this.state[_constants.MARKER].getPlace()
      },

      /**
       *
       * @type LatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.state[_constants.MARKER].getPosition()
      },

      /**
       *
       * @type MarkerShape
       * @public
       */
    },
    {
      key: "getShape",
      value: function getShape() {
        return this.state[_constants.MARKER].getShape()
      },

      /**
       *
       * @type string
       * @public
       */
    },
    {
      key: "getTitle",
      value: function getTitle() {
        return this.state[_constants.MARKER].getTitle()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.MARKER].getVisible()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.MARKER].getZIndex()
      },
    },
  ])
  return Marker
})(_react2.default.PureComponent))

Marker.propTypes = {
  /**
   * For the 2nd argument of `MarkerCluster#addMarker`
   * @see https://github.com/mikesaidani/marker-clusterer-plus
   */
  noRedraw: _propTypes2.default.bool,

  /**
   * @type Animation
   */
  defaultAnimation: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultClickable: _propTypes2.default.bool,

  /**
   * @type string
   */
  defaultCursor: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type string|Icon|Symbol
   */
  defaultIcon: _propTypes2.default.any,

  /**
   * @type string|MarkerLabel
   */
  defaultLabel: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultOpacity: _propTypes2.default.number,

  /**
   * @type MarkerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MarkerPlace
   */
  defaultPlace: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type MarkerShape
   */
  defaultShape: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultTitle: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type Animation
   */
  animation: _propTypes2.default.any,

  /**
   * @type boolean
   */
  clickable: _propTypes2.default.bool,

  /**
   * @type string
   */
  cursor: _propTypes2.default.string,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type string|Icon|Symbol
   */
  icon: _propTypes2.default.any,

  /**
   * @type string|MarkerLabel
   */
  label: _propTypes2.default.any,

  /**
   * @type number
   */
  opacity: _propTypes2.default.number,

  /**
   * @type MarkerOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MarkerPlace
   */
  place: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type MarkerShape
   */
  shape: _propTypes2.default.any,

  /**
   * @type string
   */
  title: _propTypes2.default.string,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onAnimationChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onClickableChanged: _propTypes2.default.func,

  /**
   * function
   */
  onCursorChanged: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onDraggableChanged: _propTypes2.default.func,

  /**
   * function
   */
  onFlatChanged: _propTypes2.default.func,

  /**
   * function
   */
  onIconChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onShapeChanged: _propTypes2.default.func,

  /**
   * function
   */
  onTitleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onVisibleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZindexChanged: _propTypes2.default.func,
}
Marker.contextTypes = ((_Marker$contextTypes = {}),
(0, _defineProperty3.default)(
  _Marker$contextTypes,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _Marker$contextTypes,
  _constants.MARKER_CLUSTERER,
  _propTypes2.default.object
),
_Marker$contextTypes)
Marker.childContextTypes = (0, _defineProperty3.default)(
  {},
  _constants.ANCHOR,
  _propTypes2.default.object
)
exports.default = Marker

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onAnimationChanged: "animation_changed",
  onClick: "click",
  onClickableChanged: "clickable_changed",
  onCursorChanged: "cursor_changed",
  onDrag: "drag",
  onDraggableChanged: "draggable_changed",
  onFlatChanged: "flat_changed",
  onIconChanged: "icon_changed",
  onPositionChanged: "position_changed",
  onShapeChanged: "shape_changed",
  onTitleChanged: "title_changed",
  onVisibleChanged: "visible_changed",
  onZindexChanged: "zindex_changed",
}

var updaterMap = {
  animation: function animation(instance, _animation) {
    instance.setAnimation(_animation)
  },
  clickable: function clickable(instance, _clickable) {
    instance.setClickable(_clickable)
  },
  cursor: function cursor(instance, _cursor) {
    instance.setCursor(_cursor)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  icon: function icon(instance, _icon) {
    instance.setIcon(_icon)
  },
  label: function label(instance, _label) {
    instance.setLabel(_label)
  },
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  place: function place(instance, _place) {
    instance.setPlace(_place)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  shape: function shape(instance, _shape) {
    instance.setShape(_shape)
  },
  title: function title(instance, _title) {
    instance.setTitle(_title)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Polyline = undefined

var _defineProperty2 = __webpack_require__(91)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(79)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(80)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(81)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(82)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(83)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(101)

var _constants = __webpack_require__(92)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Polyline`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Polyline = (exports.Polyline = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Polyline, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
   */
  function Polyline(props, context) {
    ;(0, _classCallCheck3.default)(this, Polyline)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Polyline.__proto__ || (0, _getPrototypeOf2.default)(Polyline)).call(
        this,
        props,
        context
      )
    )

    var polyline = new google.maps.Polyline()
    ;(0, _MapChildHelper.construct)(
      Polyline.propTypes,
      updaterMap,
      _this.props,
      polyline
    )
    polyline.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.POLYLINE,
      polyline
    )
    return _this
  }

  ;(0, _createClass3.default)(Polyline, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.POLYLINE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.POLYLINE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var polyline = this.state[_constants.POLYLINE]
        if (polyline) {
          polyline.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns whether this shape can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.POLYLINE].getDraggable()
      },

      /**
       * Returns whether this shape can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.POLYLINE].getEditable()
      },

      /**
       * Retrieves the path.
       * @type MVCArray<LatLng>
       * @public
       */
    },
    {
      key: "getPath",
      value: function getPath() {
        return this.state[_constants.POLYLINE].getPath()
      },

      /**
       * Returns whether this poly is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.POLYLINE].getVisible()
      },
    },
  ])
  return Polyline
})(_react2.default.PureComponent))

Polyline.propTypes = {
  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type PolylineOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  defaultPath: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type PolylineOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  path: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Polyline.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Polyline

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  path: function path(instance, _path) {
    instance.setPath(_path)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Polygon = undefined

var _defineProperty2 = __webpack_require__(91)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(79)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(80)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(81)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(82)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(83)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(101)

var _constants = __webpack_require__(92)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Polygon`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Polygon = (exports.Polygon = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Polygon, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
   */
  function Polygon(props, context) {
    ;(0, _classCallCheck3.default)(this, Polygon)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Polygon.__proto__ || (0, _getPrototypeOf2.default)(Polygon)).call(
        this,
        props,
        context
      )
    )

    var polygon = new google.maps.Polygon()
    ;(0, _MapChildHelper.construct)(
      Polygon.propTypes,
      updaterMap,
      _this.props,
      polygon
    )
    polygon.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)({}, _constants.POLYGON, polygon)
    return _this
  }

  ;(0, _createClass3.default)(Polygon, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.POLYGON],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.POLYGON],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var polygon = this.state[_constants.POLYGON]
        if (polygon) {
          polygon.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns whether this shape can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.POLYGON].getDraggable()
      },

      /**
       * Returns whether this shape can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.POLYGON].getEditable()
      },

      /**
       * Retrieves the first path.
       * @type MVCArray<LatLng>
       * @public
       */
    },
    {
      key: "getPath",
      value: function getPath() {
        return this.state[_constants.POLYGON].getPath()
      },

      /**
       * Retrieves the paths for this polygon.
       * @type MVCArray<MVCArray<LatLng>>
       * @public
       */
    },
    {
      key: "getPaths",
      value: function getPaths() {
        return this.state[_constants.POLYGON].getPaths()
      },

      /**
       * Returns whether this poly is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.POLYGON].getVisible()
      },
    },
  ])
  return Polygon
})(_react2.default.PureComponent))

Polygon.propTypes = {
  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type PolygonOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  defaultPath: _propTypes2.default.any,

  /**
   * @type MVCArray<MVCArray<LatLng>>|MVCArray<LatLng>|Array<Array<LatLng|LatLngLiteral>>|Array<LatLng|LatLngLiteral>
   */
  defaultPaths: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type PolygonOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  path: _propTypes2.default.any,

  /**
   * @type MVCArray<MVCArray<LatLng>>|MVCArray<LatLng>|Array<Array<LatLng|LatLngLiteral>>|Array<LatLng|LatLngLiteral>
   */
  paths: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Polygon.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Polygon

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  path: function path(instance, _path) {
    instance.setPath(_path)
  },
  paths: function paths(instance, _paths) {
    instance.setPaths(_paths)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Rectangle = undefined

var _defineProperty2 = __webpack_require__(91)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(79)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(80)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(81)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(82)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(83)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(101)

var _constants = __webpack_require__(92)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Rectangle`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Rectangle = (exports.Rectangle = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Rectangle, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
   */
  function Rectangle(props, context) {
    ;(0, _classCallCheck3.default)(this, Rectangle)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Rectangle.__proto__ || (0, _getPrototypeOf2.default)(Rectangle)).call(
        this,
        props,
        context
      )
    )

    var rectangle = new google.maps.Rectangle()
    ;(0, _MapChildHelper.construct)(
      Rectangle.propTypes,
      updaterMap,
      _this.props,
      rectangle
    )
    rectangle.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.RECTANGLE,
      rectangle
    )
    return _this
  }

  ;(0, _createClass3.default)(Rectangle, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.RECTANGLE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.RECTANGLE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var rectangle = this.state[_constants.RECTANGLE]
        if (rectangle) {
          rectangle.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the bounds of this rectangle.
       * @type LatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.RECTANGLE].getBounds()
      },

      /**
       * Returns whether this rectangle can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.RECTANGLE].getDraggable()
      },

      /**
       * Returns whether this rectangle can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.RECTANGLE].getEditable()
      },

      /**
       * Returns whether this rectangle is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.RECTANGLE].getVisible()
      },
    },
  ])
  return Rectangle
})(_react2.default.PureComponent))

Rectangle.propTypes = {
  /**
   * @type LatLngBounds|LatLngBoundsLiteral
   */
  defaultBounds: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type RectangleOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type LatLngBounds|LatLngBoundsLiteral
   */
  bounds: _propTypes2.default.any,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type RectangleOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onBoundsChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Rectangle.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Rectangle

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onBoundsChanged: "bounds_changed",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  bounds: function bounds(instance, _bounds) {
    instance.setBounds(_bounds)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.InfoWindow = undefined

var _defineProperty2 = __webpack_require__(91)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(79)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(80)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(81)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(82)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(83)

var _inherits3 = _interopRequireDefault(_inherits2)

var _InfoWindow$contextTy /*
                            * -----------------------------------------------------------------------------
                            * This file is auto-generated from the corresponding file at `src/macros/`.
                            * Please **DO NOT** edit this file directly when creating PRs.
                            * -----------------------------------------------------------------------------
                            */
/* global google */

var _invariant = __webpack_require__(56)

var _invariant2 = _interopRequireDefault(_invariant)

var _canUseDom = __webpack_require__(824)

var _canUseDom2 = _interopRequireDefault(_canUseDom)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _reactDom = __webpack_require__(60)

var _reactDom2 = _interopRequireDefault(_reactDom)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(101)

var _constants = __webpack_require__(92)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.InfoWindow`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
 */
var InfoWindow = (exports.InfoWindow = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(InfoWindow, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
   */
  function InfoWindow(props, context) {
    ;(0, _classCallCheck3.default)(this, InfoWindow)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (InfoWindow.__proto__ || (0, _getPrototypeOf2.default)(InfoWindow)).call(
        this,
        props,
        context
      )
    )

    var infoWindow = new google.maps.InfoWindow()
    ;(0, _MapChildHelper.construct)(
      InfoWindow.propTypes,
      updaterMap,
      _this.props,
      infoWindow
    )
    infoWindow.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.INFO_WINDOW,
      infoWindow
    )
    return _this
  }

  ;(0, _createClass3.default)(InfoWindow, [
    {
      key: "componentWillMount",
      value: function componentWillMount() {
        if (!_canUseDom2.default || this.containerElement) {
          return
        }
        if (_react2.default.version.match(/^16/)) {
          this.containerElement = document.createElement("div")
        }
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.INFO_WINDOW],
          eventMap
        )
        if (_react2.default.version.match(/^16/)) {
          this.state[_constants.INFO_WINDOW].setContent(this.containerElement)
          open(
            this.state[_constants.INFO_WINDOW],
            this.context[_constants.ANCHOR]
          )
          return
        }
        var content = document.createElement("div")
        _reactDom2.default.unstable_renderSubtreeIntoContainer(
          this,
          _react2.default.Children.only(this.props.children),
          content
        )
        this.state[_constants.INFO_WINDOW].setContent(content)
        open(
          this.state[_constants.INFO_WINDOW],
          this.context[_constants.ANCHOR]
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.INFO_WINDOW],
          eventMap,
          updaterMap,
          prevProps
        )
        if (_react2.default.version.match(/^16/)) {
          return
        }
        if (this.props.children !== prevProps.children) {
          _reactDom2.default.unstable_renderSubtreeIntoContainer(
            this,
            _react2.default.Children.only(this.props.children),
            this.state[_constants.INFO_WINDOW].getContent()
          )
        }
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var infoWindow = this.state[_constants.INFO_WINDOW]
        if (infoWindow) {
          if (
            !_react2.default.version.match(/^16/) &&
            infoWindow.getContent()
          ) {
            _reactDom2.default.unmountComponentAtNode(infoWindow.getContent())
          }
          infoWindow.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        if (_react2.default.version.match(/^16/)) {
          return _reactDom2.default.createPortal(
            _react2.default.Children.only(this.props.children),
            this.containerElement
          )
        }
        return false
      },

      /**
       *
       * @type LatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.state[_constants.INFO_WINDOW].getPosition()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.INFO_WINDOW].getZIndex()
      },
    },
  ])
  return InfoWindow
})(_react2.default.PureComponent))

InfoWindow.propTypes = {
  /**
   * @type InfoWindowOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type InfoWindowOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onCloseClick: _propTypes2.default.func,

  /**
   * function
   */
  onDomReady: _propTypes2.default.func,

  /**
   * function
   */
  onContentChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZindexChanged: _propTypes2.default.func,
}
InfoWindow.contextTypes = ((_InfoWindow$contextTy = {}),
(0, _defineProperty3.default)(
  _InfoWindow$contextTy,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _InfoWindow$contextTy,
  _constants.ANCHOR,
  _propTypes2.default.object
),
_InfoWindow$contextTy)
exports.default = InfoWindow

var open = function open(infoWindow, anchor) {
  if (anchor) {
    infoWindow.open(infoWindow.getMap(), anchor)
  } else if (infoWindow.getPosition()) {
    infoWindow.open(infoWindow.getMap())
  } else {
    ;(0, _invariant2.default)(
      false,
      "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>."
    )
  }
}

var eventMap = {
  onCloseClick: "closeclick",
  onDomReady: "domready",
  onContentChanged: "content_changed",
  onPositionChanged: "position_changed",
  onZindexChanged: "zindex_changed",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.OverlayView = undefined

var _extends2 = __webpack_require__(1641)

var _extends3 = _interopRequireDefault(_extends2)

var _defineProperty2 = __webpack_require__(91)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(79)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(80)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(81)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(82)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(83)

var _inherits3 = _interopRequireDefault(_inherits2)

var _delay2 = __webpack_require__(1643)

var _delay3 = _interopRequireDefault(_delay2)

var _assign2 = __webpack_require__(838)

var _assign3 = _interopRequireDefault(_assign2)

var _bind2 = __webpack_require__(380)

var _bind3 = _interopRequireDefault(_bind2)

var _OverlayView$contextT /*
                            * -----------------------------------------------------------------------------
                            * This file is auto-generated from the corresponding file at `src/macros/`.
                            * Please **DO NOT** edit this file directly when creating PRs.
                            * -----------------------------------------------------------------------------
                            */
/* global google */

var _invariant = __webpack_require__(56)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _reactDom = __webpack_require__(60)

var _reactDom2 = _interopRequireDefault(_reactDom)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(101)

var _OverlayViewHelper = __webpack_require__(1646)

var _constants = __webpack_require__(92)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.OverlayView`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
 */
var OverlayView = (exports.OverlayView = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(OverlayView, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  function OverlayView(props, context) {
    ;(0, _classCallCheck3.default)(this, OverlayView)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        OverlayView.__proto__ || (0, _getPrototypeOf2.default)(OverlayView)
      ).call(this, props, context)
    )

    var overlayView = new google.maps.OverlayView()
    // You must implement three methods: onAdd(), draw(), and onRemove().
    overlayView.onAdd = (0, _bind3.default)(_this.onAdd, _this)
    overlayView.draw = (0, _bind3.default)(_this.draw, _this)
    overlayView.onRemove = (0, _bind3.default)(_this.onRemove, _this)
    _this.onPositionElement = (0, _bind3.default)(
      _this.onPositionElement,
      _this
    )
    // You must call setMap() with a valid Map object to trigger the call to
    // the onAdd() method and setMap(null) in order to trigger the onRemove() method.
    overlayView.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.OVERLAY_VIEW,
      overlayView
    )
    return _this
  }

  ;(0, _createClass3.default)(OverlayView, [
    {
      key: "onAdd",
      value: function onAdd() {
        this.containerElement = document.createElement("div")
        this.containerElement.style.position = "absolute"
      },
    },
    {
      key: "draw",
      value: function draw() {
        var mapPaneName = this.props.mapPaneName

        ;(0, _invariant2.default)(
          !!mapPaneName,
          "OverlayView requires either props.mapPaneName or props.defaultMapPaneName but got %s",
          mapPaneName
        )
        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
        var mapPanes = this.state[_constants.OVERLAY_VIEW].getPanes()
        mapPanes[mapPaneName].appendChild(this.containerElement)

        _reactDom2.default.unstable_renderSubtreeIntoContainer(
          this,
          _react2.default.Children.only(this.props.children),
          this.containerElement,
          this.onPositionElement
        )
      },
    },
    {
      key: "onPositionElement",
      value: function onPositionElement() {
        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapCanvasProjection
        var mapCanvasProjection = this.state[
          _constants.OVERLAY_VIEW
        ].getProjection()

        var offset = (0, _extends3.default)(
          {
            x: 0,
            y: 0,
          },
          (0, _OverlayViewHelper.getOffsetOverride)(
            this.containerElement,
            this.props
          )
        )
        var layoutStyles = (0, _OverlayViewHelper.getLayoutStyles)(
          mapCanvasProjection,
          offset,
          this.props
        )
        ;(0, _assign3.default)(this.containerElement.style, layoutStyles)
      },
    },
    {
      key: "onRemove",
      value: function onRemove() {
        this.containerElement.parentNode.removeChild(this.containerElement)
        _reactDom2.default.unmountComponentAtNode(this.containerElement)
        this.containerElement = null
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.OVERLAY_VIEW],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.OVERLAY_VIEW],
          eventMap,
          updaterMap,
          prevProps
        )
        ;(0, _delay3.default)(this.state[_constants.OVERLAY_VIEW].draw)
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var overlayView = this.state[_constants.OVERLAY_VIEW]
        if (overlayView) {
          overlayView.setMap(null)
          // You must implement three methods: onAdd(), draw(), and onRemove().
          overlayView.onAdd = null
          overlayView.draw = null
          overlayView.onRemove = null
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the panes in which this OverlayView can be rendered. The panes are not initialized until `onAdd` is called by the API.
       * @type MapPanesonAdd
       * @public
       */
    },
    {
      key: "getPanes",
      value: function getPanes() {
        return this.state[_constants.OVERLAY_VIEW].getPanes()
      },

      /**
       * Returns the `MapCanvasProjection` object associated with this `OverlayView`. The projection is not initialized until `onAdd` is called by the API.
       * @type MapCanvasProjectionMapCanvasProjectionOverlayViewonAdd
       * @public
       */
    },
    {
      key: "getProjection",
      value: function getProjection() {
        return this.state[_constants.OVERLAY_VIEW].getProjection()
      },
    },
  ])
  return OverlayView
})(_react2.default.PureComponent))

OverlayView.FLOAT_PANE = "floatPane"
OverlayView.MAP_PANE = "mapPane"
OverlayView.MARKER_LAYER = "markerLayer"
OverlayView.OVERLAY_LAYER = "overlayLayer"
OverlayView.OVERLAY_MOUSE_TARGET = "overlayMouseTarget"
OverlayView.propTypes = {
  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  mapPaneName: _propTypes2.default.string,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  position: _propTypes2.default.object,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  bounds: _propTypes2.default.object,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  children: _propTypes2.default.node.isRequired,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  getPixelPositionOffset: _propTypes2.default.func,
}
OverlayView.contextTypes = ((_OverlayView$contextT = {}),
(0, _defineProperty3.default)(
  _OverlayView$contextT,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _OverlayView$contextT,
  _constants.ANCHOR,
  _propTypes2.default.object
),
_OverlayView$contextT)
exports.default = OverlayView

var eventMap = {}

var updaterMap = {}


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1642);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(683), __esModule: true };

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

var baseDelay = __webpack_require__(1644),
    baseRest = __webpack_require__(522),
    toNumber = __webpack_require__(823);

/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = baseRest(function(func, wait, args) {
  return baseDelay(func, toNumber(wait) || 0, args);
});

module.exports = delay;


/***/ }),
/* 1644 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

module.exports = baseDelay;


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(522),
    isIterateeCall = __webpack_require__(842);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _isFunction2 = __webpack_require__(260)

var _isFunction3 = _interopRequireDefault(_isFunction2)

exports.getOffsetOverride = getOffsetOverride
exports.getLayoutStyles = getLayoutStyles

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
function getOffsetOverride(containerElement, props) {
  var getPixelPositionOffset = props.getPixelPositionOffset
  //
  // Allows the component to control the visual position of the OverlayView
  // relative to the LatLng pixel position.
  //

  if ((0, _isFunction3.default)(getPixelPositionOffset)) {
    return getPixelPositionOffset(
      containerElement.offsetWidth,
      containerElement.offsetHeight
    )
  } else {
    return {}
  }
}

function createLatLng(inst, Type) {
  return new Type(inst.lat, inst.lng)
}

function createLatLngBounds(inst, Type) {
  return new Type(
    new google.maps.LatLng(inst.ne.lat, inst.ne.lng),
    new google.maps.LatLng(inst.sw.lat, inst.sw.lng)
  )
}

function ensureOfType(inst, type, factory) {
  if (inst instanceof type) {
    return inst
  } else {
    return factory(inst, type)
  }
}

function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
  var ne = mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast())
  var sw = mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest())
  if (ne && sw) {
    return {
      left: sw.x + offset.x + "px",
      top: ne.y + offset.y + "px",
      width: ne.x - sw.x - offset.x + "px",
      height: sw.y - ne.y - offset.y + "px",
    }
  }
  return {
    left: "-9999px",
    top: "-9999px",
  }
}

function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
  var point = mapCanvasProjection.fromLatLngToDivPixel(position)
  if (point) {
    var x = point.x,
      y = point.y

    return {
      left: x + offset.x + "px",
      top: y + offset.y + "px",
    }
  }
  return {
    left: "-9999px",
    top: "-9999px",
  }
}

function getLayoutStyles(mapCanvasProjection, offset, props) {
  if (props.bounds) {
    var bounds = ensureOfType(
      props.bounds,
      google.maps.LatLngBounds,
      createLatLngBounds
    )
    return getLayoutStylesByBounds(mapCanvasProjection, offset, bounds)
  } else {
    var position = ensureOfType(
      props.position,
      google.maps.LatLng,
      createLatLng
    )
    return getLayoutStylesByPosition(mapCanvasProjection, offset, position)
  }
}


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.GroundOverlay = undefined

var _defineProperty2 = __webpack_require__(91)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(79)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(80)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(81)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(82)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(83)

var _inherits3 = _interopRequireDefault(_inherits2)

var _warning = __webpack_require__(105)

var _warning2 = _interopRequireDefault(_warning)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(101)

var _constants = __webpack_require__(92)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.GroundOverlay`
 *
 * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
 */
var GroundOverlay = (exports.GroundOverlay = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(GroundOverlay, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#GroundOverlay
   */
  function GroundOverlay(props, context) {
    ;(0, _classCallCheck3.default)(this, GroundOverlay)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        GroundOverlay.__proto__ || (0, _getPrototypeOf2.default)(GroundOverlay)
      ).call(this, props, context)
    )

    ;(0, _warning2.default)(
      !props.url || !props.bounds,
      "\nFor GroundOveray, url and bounds are passed in to constructor and are immutable\n after iinstantiated. This is the behavior of Google Maps JavaScript API v3 (\n See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay)\n Hence, use the corresponding two props provided by `react-google-maps`.\n They're prefixed with _default_ (defaultUrl, defaultBounds).\n\n In some cases, you'll need the GroundOverlay component to reflect the changes\n of url and bounds. You can leverage the React's key property to remount the\n component. Typically, just `key={url}` would serve your need.\n See https://github.com/tomchentw/react-google-maps/issues/655\n"
    )
    var groundOverlay = new google.maps.GroundOverlay(
      props.defaultUrl || props.url,
      props.defaultBounds || props.bounds
    )
    ;(0, _MapChildHelper.construct)(
      GroundOverlay.propTypes,
      updaterMap,
      _this.props,
      groundOverlay
    )
    groundOverlay.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.GROUND_LAYER,
      groundOverlay
    )
    return _this
  }

  ;(0, _createClass3.default)(GroundOverlay, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.GROUND_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.GROUND_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var GroundOverlay = this.state[_constants.GROUND_LAYER]
        if (GroundOverlay) {
          GroundOverlay.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Gets the `LatLngBounds` of this overlay.
       * @type LatLngBoundsLatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.GROUND_LAYER].getBounds()
      },

      /**
       * Returns the opacity of this ground overlay.
       * @type number
       * @public
       */
    },
    {
      key: "getOpacity",
      value: function getOpacity() {
        return this.state[_constants.GROUND_LAYER].getOpacity()
      },

      /**
       * Gets the url of the projected image.
       * @type string
       * @public
       */
    },
    {
      key: "getUrl",
      value: function getUrl() {
        return this.state[_constants.GROUND_LAYER].getUrl()
      },
    },
  ])
  return GroundOverlay
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */
/* global google */

GroundOverlay.propTypes = {
  /**
   * @type string
   */
  defaultUrl: _propTypes2.default.string /* v10.0.0 .isRequired */ /**
   * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
   */,

  defaultBounds: _propTypes2.default.object /* v10.0.0 .isRequired */ /**
   * @type string
   * @deprecated use `defaultUrl` instead. It will be removed in v10.0.0
   */,

  url: _propTypes2.default.string,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
   * @deprecated use `defaultBounds` instead. It will be removed in v10.0.0
   */
  bounds: _propTypes2.default.object,

  /**
   * @type number
   */
  defaultOpacity: _propTypes2.default.number,

  /**
   * @type number
   */
  opacity: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,
}
GroundOverlay.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = GroundOverlay

var eventMap = {
  onDblClick: "dblclick",
  onClick: "click",
}

var updaterMap = {
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity)
  },
}


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.DirectionsRenderer = undefined

var _defineProperty2 = __webpack_require__(91)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(79)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(80)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(81)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(82)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(83)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(101)

var _constants = __webpack_require__(92)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.DirectionsRenderer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var DirectionsRenderer = (exports.DirectionsRenderer = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(DirectionsRenderer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
   */
  function DirectionsRenderer(props, context) {
    ;(0, _classCallCheck3.default)(this, DirectionsRenderer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        DirectionsRenderer.__proto__ ||
        (0, _getPrototypeOf2.default)(DirectionsRenderer)
      ).call(this, props, context)
    )

    var directionsRenderer = new google.maps.DirectionsRenderer()
    ;(0, _MapChildHelper.construct)(
      DirectionsRenderer.propTypes,
      updaterMap,
      _this.props,
      directionsRenderer
    )
    directionsRenderer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.DIRECTIONS_RENDERER,
      directionsRenderer
    )
    return _this
  }

  ;(0, _createClass3.default)(DirectionsRenderer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.DIRECTIONS_RENDERER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.DIRECTIONS_RENDERER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var directionsRenderer = this.state[_constants.DIRECTIONS_RENDERER]
        if (directionsRenderer) {
          directionsRenderer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the renderer's current set of directions.
       * @type DirectionsResult
       * @public
       */
    },
    {
      key: "getDirections",
      value: function getDirections() {
        return this.state[_constants.DIRECTIONS_RENDERER].getDirections()
      },

      /**
       * Returns the panel `<div>` in which the `DirectionsResult` is rendered.
       * @type Node<div>DirectionsResult
       * @public
       */
    },
    {
      key: "getPanel",
      value: function getPanel() {
        return this.state[_constants.DIRECTIONS_RENDERER].getPanel()
      },

      /**
       * Returns the current (zero-based) route index in use by this `DirectionsRenderer` object.
       * @type numberDirectionsRenderer
       * @public
       */
    },
    {
      key: "getRouteIndex",
      value: function getRouteIndex() {
        return this.state[_constants.DIRECTIONS_RENDERER].getRouteIndex()
      },
    },
  ])
  return DirectionsRenderer
})(_react2.default.PureComponent))

DirectionsRenderer.propTypes = {
  /**
   * @type DirectionsResult
   */
  defaultDirections: _propTypes2.default.any,

  /**
   * @type DirectionsRendererOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type Node
   */
  defaultPanel: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultRouteIndex: _propTypes2.default.number,

  /**
   * @type DirectionsResult
   */
  directions: _propTypes2.default.any,

  /**
   * @type DirectionsRendererOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type Node
   */
  panel: _propTypes2.default.any,

  /**
   * @type number
   */
  routeIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDirectionsChanged: _propTypes2.default.func,
}
DirectionsRenderer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = DirectionsRenderer

var eventMap = {
  onDirectionsChanged: "directions_changed",
}

var updaterMap = {
  directions: function directions(instance, _directions) {
    instance.setDirections(_directions)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  panel: function panel(instance, _panel) {
    instance.setPanel(_panel)
  },
  routeIndex: function routeIndex(instance, _routeIndex) {
    instance.setRouteIndex(_routeIndex)
  },
}


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.FusionTablesLayer = undefined

var _defineProperty2 = __webpack_require__(91)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(79)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(80)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(81)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(82)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(83)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(101)

var _constants = __webpack_require__(92)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.FusionTablesLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var FusionTablesLayer = (exports.FusionTablesLayer = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(FusionTablesLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
   */
  function FusionTablesLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, FusionTablesLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        FusionTablesLayer.__proto__ ||
        (0, _getPrototypeOf2.default)(FusionTablesLayer)
      ).call(this, props, context)
    )

    var fusionTablesLayer = new google.maps.FusionTablesLayer()
    ;(0, _MapChildHelper.construct)(
      FusionTablesLayer.propTypes,
      updaterMap,
      _this.props,
      fusionTablesLayer
    )
    fusionTablesLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.FUSION_TABLES_LAYER,
      fusionTablesLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(FusionTablesLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.FUSION_TABLES_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.FUSION_TABLES_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var fusionTablesLayer = this.state[_constants.FUSION_TABLES_LAYER]
        if (fusionTablesLayer) {
          fusionTablesLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return FusionTablesLayer
})(_react2.default.PureComponent))

FusionTablesLayer.propTypes = {
  /**
   * @type FusionTablesLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type FusionTablesLayerOptions
   */
  options: _propTypes2.default.any,

  /**
   * function
   */
  onClick: _propTypes2.default.func,
}
FusionTablesLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = FusionTablesLayer

var eventMap = {
  onClick: "click",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
}


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.KmlLayer = undefined

var _defineProperty2 = __webpack_require__(91)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(79)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(80)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(81)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(82)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(83)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(101)

var _constants = __webpack_require__(92)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.KmlLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var KmlLayer = (exports.KmlLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(KmlLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
   */
  function KmlLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, KmlLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (KmlLayer.__proto__ || (0, _getPrototypeOf2.default)(KmlLayer)).call(
        this,
        props,
        context
      )
    )

    var kmlLayer = new google.maps.KmlLayer()
    ;(0, _MapChildHelper.construct)(
      KmlLayer.propTypes,
      updaterMap,
      _this.props,
      kmlLayer
    )
    kmlLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.KML_LAYER,
      kmlLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(KmlLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.KML_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.KML_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var kmlLayer = this.state[_constants.KML_LAYER]
        if (kmlLayer) {
          kmlLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Get the default viewport for the layer being displayed.
       * @type LatLngBounds
       * @public
       */
    },
    {
      key: "getDefaultViewport",
      value: function getDefaultViewport() {
        return this.state[_constants.KML_LAYER].getDefaultViewport()
      },

      /**
       * Get the metadata associated with this layer, as specified in the layer markup.
       * @type KmlLayerMetadata
       * @public
       */
    },
    {
      key: "getMetadata",
      value: function getMetadata() {
        return this.state[_constants.KML_LAYER].getMetadata()
      },

      /**
       * Get the status of the layer, set once the requested document has loaded.
       * @type KmlLayerStatus
       * @public
       */
    },
    {
      key: "getStatus",
      value: function getStatus() {
        return this.state[_constants.KML_LAYER].getStatus()
      },

      /**
       * Gets the URL of the KML file being displayed.
       * @type string
       * @public
       */
    },
    {
      key: "getUrl",
      value: function getUrl() {
        return this.state[_constants.KML_LAYER].getUrl()
      },

      /**
       * Gets the z-index of the KML Layer.
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.KML_LAYER].getZIndex()
      },
    },
  ])
  return KmlLayer
})(_react2.default.PureComponent))

KmlLayer.propTypes = {
  /**
   * @type KmlLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultUrl: _propTypes2.default.string,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type KmlLayerOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type string
   */
  url: _propTypes2.default.string,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDefaultViewportChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onStatusChanged: _propTypes2.default.func,
}
KmlLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = KmlLayer

var eventMap = {
  onDefaultViewportChanged: "defaultviewport_changed",
  onClick: "click",
  onStatusChanged: "status_changed",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  url: function url(instance, _url) {
    instance.setUrl(_url)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.TrafficLayer = undefined

var _defineProperty2 = __webpack_require__(91)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(79)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(80)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(81)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(82)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(83)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(101)

var _constants = __webpack_require__(92)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.TrafficLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var TrafficLayer = (exports.TrafficLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(TrafficLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
   */
  function TrafficLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, TrafficLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        TrafficLayer.__proto__ || (0, _getPrototypeOf2.default)(TrafficLayer)
      ).call(this, props, context)
    )

    var trafficLayer = new google.maps.TrafficLayer()
    ;(0, _MapChildHelper.construct)(
      TrafficLayer.propTypes,
      updaterMap,
      _this.props,
      trafficLayer
    )
    trafficLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.TRAFFIC_LAYER,
      trafficLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(TrafficLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.TRAFFIC_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.TRAFFIC_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var trafficLayer = this.state[_constants.TRAFFIC_LAYER]
        if (trafficLayer) {
          trafficLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return TrafficLayer
})(_react2.default.PureComponent))

TrafficLayer.propTypes = {
  /**
   * @type TrafficLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type TrafficLayerOptions
   */
  options: _propTypes2.default.any,
}
TrafficLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = TrafficLayer

var eventMap = {}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
}


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.StreetViewPanorama = undefined

var _defineProperty2 = __webpack_require__(91)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(79)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(80)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(81)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(82)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(83)

var _inherits3 = _interopRequireDefault(_inherits2)

var _invariant = __webpack_require__(56)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(101)

var _constants = __webpack_require__(92)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.StreetViewPanorama`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
 */
var StreetViewPanorama = (exports.StreetViewPanorama = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(StreetViewPanorama, _React$PureComponent)

  function StreetViewPanorama(props, context) {
    ;(0, _classCallCheck3.default)(this, StreetViewPanorama)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        StreetViewPanorama.__proto__ ||
        (0, _getPrototypeOf2.default)(StreetViewPanorama)
      ).call(this, props, context)
    )

    ;(0, _invariant2.default)(
      !!_this.context[_constants.MAP],
      "Did you render <StreetViewPanorama> as a child of <GoogleMap> with withGoogleMap() HOC?"
    )
    ;(0, _MapChildHelper.construct)(
      StreetViewPanorama.propTypes,
      updaterMap,
      _this.props,
      _this.context[_constants.MAP].getStreetView()
    )
    return _this
  }

  ;(0, _createClass3.default)(StreetViewPanorama, [
    {
      key: "getChildContext",
      value: function getChildContext() {
        return (0, _defineProperty3.default)(
          {},
          _constants.MAP,
          this.context[_constants.MAP].getStreetView()
        )
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.context[_constants.MAP].getStreetView(),
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.context[_constants.MAP].getStreetView(),
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var streetViewPanorama = this.context[_constants.MAP].getStreetView()
        if (streetViewPanorama) {
          streetViewPanorama.setVisible(false)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       * Returns the set of navigation links for the Street View panorama.
       * @type Array<StreetViewLink>
       * @public
       */
    },
    {
      key: "getLinks",
      value: function getLinks() {
        return this.context[_constants.MAP].getLinks()
      },

      /**
       * Returns the StreetViewLocation of the current panorama.
       * @type StreetViewLocation
       * @public
       */
    },
    {
      key: "getLocation",
      value: function getLocation() {
        return this.context[_constants.MAP].getLocation()
      },

      /**
       * Returns the state of motion tracker. If true when the user physically moves the device and the browser supports it, the Street View Panorama tracks the physical movements.
       * @type boolean
       * @public
       */
    },
    {
      key: "getMotionTracking",
      value: function getMotionTracking() {
        return this.context[_constants.MAP].getMotionTracking()
      },

      /**
       * Returns the current panorama ID for the Street View panorama. This id is stable within the browser's current session only.
       * @type string
       * @public
       */
    },
    {
      key: "getPano",
      value: function getPano() {
        return this.context[_constants.MAP].getPano()
      },

      /**
       * Returns the heading and pitch of the photographer when this panorama was taken. For Street View panoramas on the road, this also reveals in which direction the car was travelling. This data is available after the `pano_changed` event.
       * @type StreetViewPovpano_changed
       * @public
       */
    },
    {
      key: "getPhotographerPov",
      value: function getPhotographerPov() {
        return this.context[_constants.MAP].getPhotographerPov()
      },

      /**
       * Returns the current `LatLng` position for the Street View panorama.
       * @type LatLngLatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.context[_constants.MAP].getPosition()
      },

      /**
       * Returns the current point of view for the Street View panorama.
       * @type StreetViewPov
       * @public
       */
    },
    {
      key: "getPov",
      value: function getPov() {
        return this.context[_constants.MAP].getPov()
      },

      /**
       * Returns the status of the panorama on completion of the `setPosition()` or `setPano()` request.
       * @type StreetViewStatussetPosition()setPano()
       * @public
       */
    },
    {
      key: "getStatus",
      value: function getStatus() {
        return this.context[_constants.MAP].getStatus()
      },

      /**
       * Returns `true` if the panorama is visible. It does not specify whether Street View imagery is available at the specified position.
       * @type booleantrue
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.context[_constants.MAP].getVisible()
      },

      /**
       * Returns the zoom level of the panorama. Fully zoomed-out is level 0, where the field of view is 180 degrees. Zooming in increases the zoom level.
       * @type number
       * @public
       */
    },
    {
      key: "getZoom",
      value: function getZoom() {
        return this.context[_constants.MAP].getZoom()
      },
    },
  ])
  return StreetViewPanorama
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */

StreetViewPanorama.propTypes = {
  /**
   * @type Array<StreetViewLink>
   */
  defaultLinks: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultMotionTracking: _propTypes2.default.bool,

  /**
   * @type StreetViewPanoramaOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultPano: _propTypes2.default.string,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type StreetViewPov
   */
  defaultPov: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultZoom: _propTypes2.default.number,

  /**
   * @type Array<StreetViewLink>
   */
  links: _propTypes2.default.any,

  /**
   * @type boolean
   */
  motionTracking: _propTypes2.default.bool,

  /**
   * @type StreetViewPanoramaOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type string
   */
  pano: _propTypes2.default.string,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type StreetViewPov
   */
  pov: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * @type number
   */
  zoom: _propTypes2.default.number,

  /**
   * function
   */
  onCloseClick: _propTypes2.default.func,

  /**
   * function
   */
  onPanoChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPovChanged: _propTypes2.default.func,

  /**
   * function
   */
  onResize: _propTypes2.default.func,

  /**
   * function
   */
  onStatusChanged: _propTypes2.default.func,

  /**
   * function
   */
  onVisibleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZoomChanged: _propTypes2.default.func,
}
StreetViewPanorama.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
StreetViewPanorama.childContextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = StreetViewPanorama

var eventMap = {
  onCloseClick: "closeclick",
  onPanoChanged: "pano_changed",
  onPositionChanged: "position_changed",
  onPovChanged: "pov_changed",
  onResize: "resize",
  onStatusChanged: "status_changed",
  onVisibleChanged: "visible_changed",
  onZoomChanged: "zoom_changed",
}

var updaterMap = {
  links: function links(instance, _links) {
    instance.setLinks(_links)
  },
  motionTracking: function motionTracking(instance, _motionTracking) {
    instance.setMotionTracking(_motionTracking)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  pano: function pano(instance, _pano) {
    instance.setPano(_pano)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  pov: function pov(instance, _pov) {
    instance.setPov(_pov)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
  zoom: function zoom(instance, _zoom) {
    instance.setZoom(_zoom)
  },
}


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.BicyclingLayer = undefined

var _defineProperty2 = __webpack_require__(91)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(79)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(80)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(81)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(82)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(83)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(101)

var _constants = __webpack_require__(92)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.BicyclingLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var BicyclingLayer = (exports.BicyclingLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(BicyclingLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
   */
  function BicyclingLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, BicyclingLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        BicyclingLayer.__proto__ ||
        (0, _getPrototypeOf2.default)(BicyclingLayer)
      ).call(this, props, context)
    )

    var bicyclingLayer = new google.maps.BicyclingLayer()
    ;(0, _MapChildHelper.construct)(
      BicyclingLayer.propTypes,
      updaterMap,
      _this.props,
      bicyclingLayer
    )
    bicyclingLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.BICYCLING_LAYER,
      bicyclingLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(BicyclingLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.BICYCLING_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.BICYCLING_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var bicyclingLayer = this.state[_constants.BICYCLING_LAYER]
        if (bicyclingLayer) {
          bicyclingLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return BicyclingLayer
})(_react2.default.PureComponent))

BicyclingLayer.propTypes = {}
BicyclingLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = BicyclingLayer

var eventMap = {}

var updaterMap = {}


/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LocationsApi=function(_BaseApi){_inherits(LocationsApi,_BaseApi);function LocationsApi(){_classCallCheck(this,LocationsApi);return _possibleConstructorReturn(this,(LocationsApi.__proto__||Object.getPrototypeOf(LocationsApi)).apply(this,arguments));}_createClass(LocationsApi,[{key:'getLocationByLatLong',value:function getLocationByLatLong(latitude,longitude){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/locations/reverse_geocode?lat='+latitude+'&lon='+longitude).then(function(response){return{ok:true,location:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return LocationsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (LocationsApi=new LocationsApi());

/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportMultiple; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getDataTransferItems;
/* harmony export (immutable) */ __webpack_exports__["b"] = fileAccepted;
/* harmony export (immutable) */ __webpack_exports__["c"] = fileMatchSize;
/* harmony export (immutable) */ __webpack_exports__["a"] = allFilesAccepted;
/* harmony export (immutable) */ __webpack_exports__["f"] = onDocumentDragOver;
/* harmony export (immutable) */ __webpack_exports__["e"] = isIeOrEdge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);


var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

function getDataTransferItems(event) {
  var dataTransferItemsList = [];
  if (event.dataTransfer) {
    var dt = event.dataTransfer;

    if (dt.files && dt.files.length) {
      dataTransferItemsList = dt.files;
    } else if (dt.items && dt.items.length) {
      // During the drag even the dataTransfer.files is null
      // but Chrome implements some drag store, which is accesible via dataTransfer.items
      dataTransferItemsList = dt.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }

  // Convert from DataTransferItemsList to the native Array
  return Array.prototype.slice.call(dataTransferItemsList);
}

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default()(file, accept);
}

function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}

function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
}

// allow the entire document to be a drag target
function onDocumentDragOver(evt) {
  evt.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

  return isIe(userAgent) || isEdge(userAgent);
}

/***/ }),
/* 1656 */
/***/ (function(module, exports) {

module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={i:e,l:!1,exports:{}};return t[e].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var r={};return n.m=t,n.c=r,n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=13)}([function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n){var r=t.exports={version:"2.5.0"};"number"==typeof __e&&(__e=r)},function(t,n,r){t.exports=!r(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(32)("wks"),o=r(9),i=r(0).Symbol,u="function"==typeof i;(t.exports=function(t){return e[t]||(e[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=e},function(t,n,r){var e=r(0),o=r(2),i=r(8),u=r(22),c=r(10),f=function(t,n,r){var a,s,p,l,v=t&f.F,y=t&f.G,h=t&f.S,d=t&f.P,x=t&f.B,g=y?e:h?e[n]||(e[n]={}):(e[n]||{}).prototype,m=y?o:o[n]||(o[n]={}),b=m.prototype||(m.prototype={});y&&(r=n);for(a in r)s=!v&&g&&void 0!==g[a],p=(s?g:r)[a],l=x&&s?c(p,e):d&&"function"==typeof p?c(Function.call,p):p,g&&u(g,a,p,t&f.U),m[a]!=p&&i(m,a,l),d&&b[a]!=p&&(b[a]=p)};e.core=o,f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f},function(t,n,r){var e=r(16),o=r(21);t.exports=r(3)?function(t,n,r){return e.f(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(24);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){var e=r(28),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";n.__esModule=!0,n.default=function(t,n){if(t&&n){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):n.endsWith("/*")?i===n.replace(/\/.*$/,""):o===n})}return!0},r(14),r(34)},function(t,n,r){r(15),t.exports=r(2).Array.some},function(t,n,r){"use strict";var e=r(7),o=r(25)(3);e(e.P+e.F*!r(33)([].some,!0),"Array",{some:function(t){return o(this,t,arguments[1])}})},function(t,n,r){var e=r(17),o=r(18),i=r(20),u=Object.defineProperty;n.f=r(3)?Object.defineProperty:function(t,n,r){if(e(t),n=i(n,!0),e(r),o)try{return u(t,n,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(t[n]=r.value),t}},function(t,n,r){var e=r(1);t.exports=function(t){if(!e(t))throw TypeError(t+" is not an object!");return t}},function(t,n,r){t.exports=!r(3)&&!r(4)(function(){return 7!=Object.defineProperty(r(19)("div"),"a",{get:function(){return 7}}).a})},function(t,n,r){var e=r(1),o=r(0).document,i=e(o)&&e(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,n,r){var e=r(1);t.exports=function(t,n){if(!e(t))return t;var r,o;if(n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;if("function"==typeof(r=t.valueOf)&&!e(o=r.call(t)))return o;if(!n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(0),o=r(8),i=r(23),u=r(9)("src"),c=Function.toString,f=(""+c).split("toString");r(2).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,c){var a="function"==typeof r;a&&(i(r,"name")||o(r,"name",n)),t[n]!==r&&(a&&(i(r,u)||o(r,u,t[n]?""+t[n]:f.join(String(n)))),t===e?t[n]=r:c?t[n]?t[n]=r:o(t,n,r):(delete t[n],o(t,n,r)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[u]||c.call(this)})},function(t,n){var r={}.hasOwnProperty;t.exports=function(t,n){return r.call(t,n)}},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n,r){var e=r(10),o=r(26),i=r(27),u=r(12),c=r(29);t.exports=function(t,n){var r=1==t,f=2==t,a=3==t,s=4==t,p=6==t,l=5==t||p,v=n||c;return function(n,c,y){for(var h,d,x=i(n),g=o(x),m=e(c,y,3),b=u(g.length),_=0,w=r?v(n,b):f?v(n,0):void 0;b>_;_++)if((l||_ in g)&&(h=g[_],d=m(h,_,x),t))if(r)w[_]=d;else if(d)switch(t){case 3:return!0;case 5:return h;case 6:return _;case 2:w.push(h)}else if(s)return!1;return p?-1:a||s?s:w}}},function(t,n,r){var e=r(5);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==e(t)?t.split(""):Object(t)}},function(t,n,r){var e=r(11);t.exports=function(t){return Object(e(t))}},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(30);t.exports=function(t,n){return new(e(t))(n)}},function(t,n,r){var e=r(1),o=r(31),i=r(6)("species");t.exports=function(t){var n;return o(t)&&(n=t.constructor,"function"!=typeof n||n!==Array&&!o(n.prototype)||(n=void 0),e(n)&&null===(n=n[i])&&(n=void 0)),void 0===n?Array:n}},function(t,n,r){var e=r(5);t.exports=Array.isArray||function(t){return"Array"==e(t)}},function(t,n,r){var e=r(0),o=e["__core-js_shared__"]||(e["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,n,r){"use strict";var e=r(4);t.exports=function(t,n){return!!t&&e(function(){n?t.call(null,function(){},1):t.call(null)})}},function(t,n,r){r(35),t.exports=r(2).String.endsWith},function(t,n,r){"use strict";var e=r(7),o=r(12),i=r(36),u="".endsWith;e(e.P+e.F*r(38)("endsWith"),"String",{endsWith:function(t){var n=i(this,t,"endsWith"),r=arguments.length>1?arguments[1]:void 0,e=o(n.length),c=void 0===r?e:Math.min(o(r),e),f=String(t);return u?u.call(n,f,c):n.slice(c-f.length,c)===f}})},function(t,n,r){var e=r(37),o=r(11);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){var e=r(1),o=r(5),i=r(6)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n,r){var e=r(6)("match");t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(r){try{return n[e]=!1,!"/./"[t](n)}catch(t){}}return!0}}]);

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  rejected: {
    borderStyle: 'solid',
    borderColor: '#c66',
    backgroundColor: '#eee'
  },
  disabled: {
    opacity: 0.5
  },
  active: {
    borderStyle: 'solid',
    borderColor: '#6c6',
    backgroundColor: '#eee'
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5
  }
});

/***/ }),
/* 1658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkOrderCreated_css__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkOrderCreated_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__WorkOrderCreated_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_check_circle_png__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_check_circle_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_check_circle_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_confirmation_ConfirmationPanel__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_admin_work_orders_creation_creation__ = __webpack_require__(124);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WorkOrderCreated=function(_Component){_inherits(WorkOrderCreated,_Component);function WorkOrderCreated(){var _ref;var _temp,_this,_ret;_classCallCheck(this,WorkOrderCreated);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WorkOrderCreated.__proto__||Object.getPrototypeOf(WorkOrderCreated)).call.apply(_ref,[this].concat(args))),_this),_this.handleAddTask=function(event){event.preventDefault();_this.props.onGoToTasks();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WorkOrderCreated,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'work-order-created'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_route_title_RouteTitle__["a" /* default */],{titles:['WORK ORDERS','WO #'+this.props.newWorkOrder.number]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Work Order #',this.props.newWorkOrder.number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_confirmation_ConfirmationPanel__["a" /* default */],{image:__WEBPACK_IMPORTED_MODULE_4__images_check_circle_png___default.a,firstLine:'Work Order Created',lines:['Add one or more Task for this Work Order.'],buttons:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-orange',value:'Add Task',onClick:this.handleAddTask})]})));}}]);return WorkOrderCreated;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);WorkOrderCreated.propTypes={newWorkOrder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,onGoToTasks:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(function(state){return{newWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_7__selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state)};},function(dispatch){return{onGoToTasks:function onGoToTasks(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_admin_work_orders_creation_creation__["e" /* goToTasks */])());}};})(WorkOrderCreated));

/***/ }),
/* 1660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tasks_css__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tasks_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Tasks_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Task__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_left_arrow_png__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_left_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_left_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_confirmation_ConfirmationPanel__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_confirmation_alert_triangle_png__ = __webpack_require__(1890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_confirmation_alert_triangle_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__shared_confirmation_alert_triangle_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_tasks__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selectors_admin_work_orders_creation_tasks__ = __webpack_require__(1891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_utils_tasks_util__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_admin_work_orders_creation_creation__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CancelWorkOrder__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__selectors_admin_work_orders_creation_creation__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_utils_scroller_util__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tasks=function(_Component){_inherits(Tasks,_Component);function Tasks(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Tasks);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Tasks.__proto__||Object.getPrototypeOf(Tasks)).call.apply(_ref,[this].concat(args))),_this),_this.minMaxImages={min:3,max:6},_this.handleTaskChange=function(taskId,attribute,value,label){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_tasks__["e" /* currentTaskChangeRequest */])(taskId,attribute,value,label));if(attribute==='trade'){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_admin_work_orders_work_orders__["k" /* loadSubTradesRequest */])(value));}},_this.handleTaskSubmit=function(){if(_this.props.currentTask.id===0){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_tasks__["j" /* saveTaskRequest */])(_this.props.currentTask,_this.props.currentWorkOrder.id));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_tasks__["m" /* updateTaskRequest */])(_this.props.currentTask));}},_this.handleTaskEdit=function(taskId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_tasks__["f" /* editTask */])(taskId,_this.props.tasks));},_this.handleAddAdditionalTask=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_tasks__["a" /* addEmptyTask */])(_this.props.tasks));},_this.handleTaskCancel=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_tasks__["d" /* cancelTaskShow */])());},_this.handleTaskCancelYes=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_tasks__["c" /* cancelTaskRequest */])(_this.props.currentTask.id));},_this.handleTaskCancelNo=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_tasks__["b" /* cancelTaskHide */])());},_this.handleBackArrow=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_tasks__["k" /* taskBack */])());},_this.handleTaskContinue=function(event){event.preventDefault();Object(__WEBPACK_IMPORTED_MODULE_18__services_utils_scroller_util__["c" /* simpleScrollToTop */])();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_tasks__["l" /* taskContinue */])(_this.props.newWOProcessStarted));},_this.handleCancelOrder=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_admin_work_orders_creation_creation__["g" /* showWOCancellationModal */])());},_this.handleTaskCancelOrder=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_admin_work_orders_creation_creation__["g" /* showWOCancellationModal */])());},_this.handleImageRemove=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_tasks__["i" /* removeImageRequest */])(_this.props.currentTask,index));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Tasks,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_tasks__["h" /* loadTradesRequest */])());this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_tasks__["g" /* initializeTasksState */])(this.props.editTaskId,this.props.tasks,this.props.currentTask,this.props.currentWorkOrder.client.company_name));if(this.props.editTaskId>0){Object(__WEBPACK_IMPORTED_MODULE_18__services_utils_scroller_util__["b" /* simpleScrollTo */])(this.props.editTaskId.toString());}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tasks-creation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_route_title_RouteTitle__["a" /* default */],{titles:['WORK ORDERS','WO #'+this.props.currentWorkOrder.number]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title light'},'Work Order #',this.props.currentWorkOrder.number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{md:8,className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},!this.props.showCancel?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,/* Only show back button if WO is under creation */this.props.newWOProcessStarted&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-back-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__images_left_arrow_png___default.a,alt:'left-arrow',onClick:this.handleBackArrow})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tasks'},// Iterate over existing tasks
this.props.tasks.slice()// copy task for sorting
.sort(Tasks.sortTasks).map(function(task){var readOnly=task.id!==_this2.props.editTaskId;var localSubTradesByTradeId=_this2.props.subTradesByTradeId;if(readOnly){localSubTradesByTradeId={};// If read only, simulate the sub trades with the value of the task
localSubTradesByTradeId[task.trade.id]=[task.sub_trade];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Task__["a" /* default */],{key:task.id,minMaxImages:_this2.minMaxImages,readOnly:readOnly,task:readOnly?__WEBPACK_IMPORTED_MODULE_13__services_utils_tasks_util__["a" /* default */].mapTask(task):_this2.props.currentTask,trades:_this2.props.trades,subTradesByTradeId:localSubTradesByTradeId,onCancel:_this2.handleTaskCancel,onCancelOrder:_this2.handleTaskCancelOrder,onChange:_this2.handleTaskChange,onEdit:_this2.handleTaskEdit,onImageRemove:readOnly?undefined:_this2.handleImageRemove,onSubmit:_this2.handleTaskSubmit});}),this.props.editTaskId===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Task__["a" /* default */],{key:0,minMaxImages:this.minMaxImages,readOnly:false,task:this.props.currentTask,trades:this.props.trades,subTradesByTradeId:this.props.subTradesByTradeId,onCancel:this.handleTaskCancel,onCancelOrder:this.handleTaskCancelOrder,onChange:this.handleTaskChange,onEdit:this.handleTaskEdit,onImageRemove:this.handleImageRemove,onSubmit:this.handleTaskSubmit}):this.props.tasks.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no-tasks'},'No Tasks')),this.props.editTaskId===-1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',value:'Add Additional Task',type:'button',onClick:this.handleAddAdditionalTask}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-gray'+(this.props.tasks.length===0?' hidden':''),value:'Continue',type:'button',onClick:this.handleTaskContinue}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-white',value:'Cancel Order',type:'button',onClick:this.handleCancelOrder}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-panel-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_confirmation_ConfirmationPanel__["a" /* default */],{buttons:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',value:'No',type:'button',onClick:this.handleTaskCancelNo}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-gray',value:'Yes',type:'button',onClick:this.handleTaskCancelYes})],firstLine:'Cancelling Task #'+__WEBPACK_IMPORTED_MODULE_9_numeral___default()(this.props.currentTask.number).format('00'),image:__WEBPACK_IMPORTED_MODULE_8__shared_confirmation_alert_triangle_png___default.a,lines:['Are you sure you would like to cancel Task #'+__WEBPACK_IMPORTED_MODULE_9_numeral___default()(this.props.currentTask.number).format('00')+'?']})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__CancelWorkOrder__["a" /* default */],null));}}],[{key:'sortTasks',value:function sortTasks(taskA,taskB){if(taskA.number<taskB.number){return-1;}if(taskA.number>taskB.number){return 1;}return 0;}}]);return Tasks;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{currentTask:Object(__WEBPACK_IMPORTED_MODULE_12__selectors_admin_work_orders_creation_tasks__["a" /* getCurrentTask */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_14__selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),editTaskId:Object(__WEBPACK_IMPORTED_MODULE_12__selectors_admin_work_orders_creation_tasks__["b" /* getEditTaskId */])(state),newWOProcessStarted:Object(__WEBPACK_IMPORTED_MODULE_17__selectors_admin_work_orders_creation_creation__["a" /* getNewWOProcessStarted */])(state),showCancel:Object(__WEBPACK_IMPORTED_MODULE_12__selectors_admin_work_orders_creation_tasks__["c" /* getShowCancel */])(state),subTradesByTradeId:Object(__WEBPACK_IMPORTED_MODULE_14__selectors_admin_work_orders_work_orders__["g" /* getSubTradesByTradeId */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_14__selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state),trades:Object(__WEBPACK_IMPORTED_MODULE_14__selectors_admin_work_orders_work_orders__["j" /* getTrades */])(state)};})(Tasks));

/***/ }),
/* 1663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(1666);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 1666 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(1668);

__webpack_require__(1861);

__webpack_require__(1862);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(97)))

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1669);
__webpack_require__(1671);
__webpack_require__(1672);
__webpack_require__(1673);
__webpack_require__(1674);
__webpack_require__(1675);
__webpack_require__(1676);
__webpack_require__(1677);
__webpack_require__(1678);
__webpack_require__(1679);
__webpack_require__(1680);
__webpack_require__(1681);
__webpack_require__(1682);
__webpack_require__(1683);
__webpack_require__(1684);
__webpack_require__(1685);
__webpack_require__(1686);
__webpack_require__(445);
__webpack_require__(1687);
__webpack_require__(1688);
__webpack_require__(1689);
__webpack_require__(1690);
__webpack_require__(1691);
__webpack_require__(1692);
__webpack_require__(1693);
__webpack_require__(1694);
__webpack_require__(1695);
__webpack_require__(1696);
__webpack_require__(1697);
__webpack_require__(1698);
__webpack_require__(1699);
__webpack_require__(1700);
__webpack_require__(1701);
__webpack_require__(1702);
__webpack_require__(1703);
__webpack_require__(1704);
__webpack_require__(1705);
__webpack_require__(1706);
__webpack_require__(1707);
__webpack_require__(1708);
__webpack_require__(1709);
__webpack_require__(1710);
__webpack_require__(1711);
__webpack_require__(1712);
__webpack_require__(1713);
__webpack_require__(1714);
__webpack_require__(1715);
__webpack_require__(1716);
__webpack_require__(1717);
__webpack_require__(1718);
__webpack_require__(1719);
__webpack_require__(1720);
__webpack_require__(1721);
__webpack_require__(1722);
__webpack_require__(1723);
__webpack_require__(447);
__webpack_require__(1724);
__webpack_require__(1725);
__webpack_require__(1726);
__webpack_require__(1727);
__webpack_require__(1728);
__webpack_require__(1729);
__webpack_require__(1730);
__webpack_require__(1731);
__webpack_require__(1732);
__webpack_require__(1733);
__webpack_require__(1734);
__webpack_require__(1735);
__webpack_require__(1736);
__webpack_require__(1737);
__webpack_require__(1738);
__webpack_require__(1739);
__webpack_require__(1740);
__webpack_require__(1741);
__webpack_require__(1742);
__webpack_require__(1743);
__webpack_require__(1744);
__webpack_require__(1746);
__webpack_require__(1747);
__webpack_require__(1749);
__webpack_require__(1750);
__webpack_require__(1751);
__webpack_require__(1752);
__webpack_require__(1753);
__webpack_require__(1754);
__webpack_require__(1755);
__webpack_require__(1757);
__webpack_require__(1758);
__webpack_require__(1759);
__webpack_require__(1760);
__webpack_require__(1761);
__webpack_require__(1762);
__webpack_require__(1763);
__webpack_require__(1764);
__webpack_require__(1765);
__webpack_require__(1766);
__webpack_require__(1767);
__webpack_require__(1768);
__webpack_require__(1769);
__webpack_require__(454);
__webpack_require__(1770);
__webpack_require__(865);
__webpack_require__(1771);
__webpack_require__(866);
__webpack_require__(1772);
__webpack_require__(1773);
__webpack_require__(1774);
__webpack_require__(1775);
__webpack_require__(1776);
__webpack_require__(455);
__webpack_require__(460);
__webpack_require__(869);
__webpack_require__(1777);
__webpack_require__(1778);
__webpack_require__(1779);
__webpack_require__(1780);
__webpack_require__(1781);
__webpack_require__(1782);
__webpack_require__(1783);
__webpack_require__(1784);
__webpack_require__(1785);
__webpack_require__(1786);
__webpack_require__(1787);
__webpack_require__(1788);
__webpack_require__(1789);
__webpack_require__(1790);
__webpack_require__(1791);
__webpack_require__(1792);
__webpack_require__(1793);
__webpack_require__(1794);
__webpack_require__(1795);
__webpack_require__(1796);
__webpack_require__(1797);
__webpack_require__(1798);
__webpack_require__(1799);
__webpack_require__(1800);
__webpack_require__(1801);
__webpack_require__(1802);
__webpack_require__(1803);
__webpack_require__(1804);
__webpack_require__(1805);
__webpack_require__(1806);
__webpack_require__(1807);
__webpack_require__(1808);
__webpack_require__(1809);
__webpack_require__(1810);
__webpack_require__(1811);
__webpack_require__(1812);
__webpack_require__(1813);
__webpack_require__(1814);
__webpack_require__(1815);
__webpack_require__(1816);
__webpack_require__(1817);
__webpack_require__(1818);
__webpack_require__(1819);
__webpack_require__(1820);
__webpack_require__(1821);
__webpack_require__(1822);
__webpack_require__(1823);
__webpack_require__(1824);
__webpack_require__(1825);
__webpack_require__(1826);
__webpack_require__(1827);
__webpack_require__(1828);
__webpack_require__(1829);
__webpack_require__(1830);
__webpack_require__(1831);
__webpack_require__(1832);
__webpack_require__(1833);
__webpack_require__(1834);
__webpack_require__(1835);
__webpack_require__(1836);
__webpack_require__(1837);
__webpack_require__(1838);
__webpack_require__(1839);
__webpack_require__(1840);
__webpack_require__(1841);
__webpack_require__(1842);
__webpack_require__(1843);
__webpack_require__(1844);
__webpack_require__(1845);
__webpack_require__(1846);
__webpack_require__(1847);
__webpack_require__(1848);
__webpack_require__(1849);
__webpack_require__(1850);
__webpack_require__(1851);
__webpack_require__(1852);
__webpack_require__(1853);
__webpack_require__(1854);
__webpack_require__(1855);
__webpack_require__(1856);
__webpack_require__(1857);
__webpack_require__(1858);
__webpack_require__(1859);
__webpack_require__(1860);
__webpack_require__(453);
module.exports = __webpack_require__(108);


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(41);
var has = __webpack_require__(117);
var DESCRIPTORS = __webpack_require__(59);
var $export = __webpack_require__(4);
var redefine = __webpack_require__(109);
var META = __webpack_require__(194).KEY;
var $fails = __webpack_require__(43);
var shared = __webpack_require__(289);
var setToStringTag = __webpack_require__(240);
var uid = __webpack_require__(209);
var wks = __webpack_require__(54);
var wksExt = __webpack_require__(851);
var wksDefine = __webpack_require__(540);
var enumKeys = __webpack_require__(1670);
var isArray = __webpack_require__(394);
var anObject = __webpack_require__(32);
var isObject = __webpack_require__(48);
var toObject = __webpack_require__(71);
var toIObject = __webpack_require__(118);
var toPrimitive = __webpack_require__(149);
var createDesc = __webpack_require__(210);
var _create = __webpack_require__(211);
var gOPNExt = __webpack_require__(852);
var $GOPD = __webpack_require__(120);
var $GOPS = __webpack_require__(393);
var $DP = __webpack_require__(70);
var $keys = __webpack_require__(212);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(229).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(291).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(192)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(110)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(212);
var gOPS = __webpack_require__(393);
var pIE = __webpack_require__(291);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(211) });


/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(59), 'Object', { defineProperty: __webpack_require__(70).f });


/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(59), 'Object', { defineProperties: __webpack_require__(656) });


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(118);
var $getOwnPropertyDescriptor = __webpack_require__(120).f;

__webpack_require__(157)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(71);
var $getPrototypeOf = __webpack_require__(119);

__webpack_require__(157)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(71);
var $keys = __webpack_require__(212);

__webpack_require__(157)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(157)('getOwnPropertyNames', function () {
  return __webpack_require__(852).f;
});


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(48);
var meta = __webpack_require__(194).onFreeze;

__webpack_require__(157)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(48);
var meta = __webpack_require__(194).onFreeze;

__webpack_require__(157)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(48);
var meta = __webpack_require__(194).onFreeze;

__webpack_require__(157)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(48);

__webpack_require__(157)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(48);

__webpack_require__(157)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(48);

__webpack_require__(157)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(4);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(853) });


/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(4);
$export($export.S, 'Object', { is: __webpack_require__(854) });


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(4);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(459).set });


/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(4);

$export($export.P, 'Function', { bind: __webpack_require__(855) });


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(70).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(59) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(48);
var getPrototypeOf = __webpack_require__(119);
var HAS_INSTANCE = __webpack_require__(54)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(70).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $parseInt = __webpack_require__(857);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $parseFloat = __webpack_require__(858);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(41);
var has = __webpack_require__(117);
var cof = __webpack_require__(135);
var inheritIfRequired = __webpack_require__(458);
var toPrimitive = __webpack_require__(149);
var fails = __webpack_require__(43);
var gOPN = __webpack_require__(229).f;
var gOPD = __webpack_require__(120).f;
var dP = __webpack_require__(70).f;
var $trim = __webpack_require__(262).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(211)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(59) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(109)(global, NUMBER, $Number);
}


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toInteger = __webpack_require__(136);
var aNumberValue = __webpack_require__(859);
var repeat = __webpack_require__(542);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(43)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $fails = __webpack_require__(43);
var aNumberValue = __webpack_require__(859);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(4);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(4);
var _isFinite = __webpack_require__(41).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(4);

$export($export.S, 'Number', { isInteger: __webpack_require__(860) });


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(4);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(4);
var isInteger = __webpack_require__(860);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(4);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(4);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $parseFloat = __webpack_require__(858);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $parseInt = __webpack_require__(857);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(4);
var log1p = __webpack_require__(861);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(4);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(4);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(4);
var sign = __webpack_require__(543);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(4);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(4);
var $expm1 = __webpack_require__(544);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', { fround: __webpack_require__(862) });


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(4);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(4);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(43)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', { log1p: __webpack_require__(861) });


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', { sign: __webpack_require__(543) });


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(4);
var expm1 = __webpack_require__(544);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(43)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(4);
var expm1 = __webpack_require__(544);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var toAbsoluteIndex = __webpack_require__(213);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var toIObject = __webpack_require__(118);
var toLength = __webpack_require__(55);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(262)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $at = __webpack_require__(342)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(4);
var toLength = __webpack_require__(55);
var context = __webpack_require__(545);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(546)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(4);
var context = __webpack_require__(545);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(546)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(542)
});


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(4);
var toLength = __webpack_require__(55);
var context = __webpack_require__(545);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(546)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(114)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(114)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(114)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(114)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(114)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(114)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(114)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(114)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(114)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(114)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(114)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(114)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(114)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(4);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(71);
var toPrimitive = __webpack_require__(149);

$export($export.P + $export.F * __webpack_require__(43)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(4);
var toISOString = __webpack_require__(1745);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(43);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(109)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(54)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(110)(proto, TO_PRIMITIVE, __webpack_require__(1748));


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(32);
var toPrimitive = __webpack_require__(149);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(4);

$export($export.S, 'Array', { isArray: __webpack_require__(394) });


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(137);
var $export = __webpack_require__(4);
var toObject = __webpack_require__(71);
var call = __webpack_require__(660);
var isArrayIter = __webpack_require__(456);
var toLength = __webpack_require__(55);
var createProperty = __webpack_require__(547);
var getIterFn = __webpack_require__(457);

$export($export.S + $export.F * !__webpack_require__(345)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var createProperty = __webpack_require__(547);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(43)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(4);
var toIObject = __webpack_require__(118);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(290) != Object || !__webpack_require__(143)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var html = __webpack_require__(452);
var cof = __webpack_require__(135);
var toAbsoluteIndex = __webpack_require__(213);
var toLength = __webpack_require__(55);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(43)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var aFunction = __webpack_require__(98);
var toObject = __webpack_require__(71);
var fails = __webpack_require__(43);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(143)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $forEach = __webpack_require__(158)(0);
var STRICT = __webpack_require__(143)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48);
var isArray = __webpack_require__(394);
var SPECIES = __webpack_require__(54)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $map = __webpack_require__(158)(1);

$export($export.P + $export.F * !__webpack_require__(143)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $filter = __webpack_require__(158)(2);

$export($export.P + $export.F * !__webpack_require__(143)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $some = __webpack_require__(158)(3);

$export($export.P + $export.F * !__webpack_require__(143)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $every = __webpack_require__(158)(4);

$export($export.P + $export.F * !__webpack_require__(143)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $reduce = __webpack_require__(863);

$export($export.P + $export.F * !__webpack_require__(143)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $reduce = __webpack_require__(863);

$export($export.P + $export.F * !__webpack_require__(143)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $indexOf = __webpack_require__(343)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(143)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toIObject = __webpack_require__(118);
var toInteger = __webpack_require__(136);
var toLength = __webpack_require__(55);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(143)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(4);

$export($export.P, 'Array', { copyWithin: __webpack_require__(864) });

__webpack_require__(193)('copyWithin');


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(4);

$export($export.P, 'Array', { fill: __webpack_require__(549) });

__webpack_require__(193)('fill');


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(4);
var $find = __webpack_require__(158)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(193)(KEY);


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(4);
var $find = __webpack_require__(158)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(193)(KEY);


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(217)('Array');


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(41);
var inheritIfRequired = __webpack_require__(458);
var dP = __webpack_require__(70).f;
var gOPN = __webpack_require__(229).f;
var isRegExp = __webpack_require__(395);
var $flags = __webpack_require__(311);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(59) && (!CORRECT_NEW || __webpack_require__(43)(function () {
  re2[__webpack_require__(54)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(109)(global, 'RegExp', $RegExp);
}

__webpack_require__(217)('RegExp');


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(866);
var anObject = __webpack_require__(32);
var $flags = __webpack_require__(311);
var DESCRIPTORS = __webpack_require__(59);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(109)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(43)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(32);
var toLength = __webpack_require__(55);
var advanceStringIndex = __webpack_require__(551);
var regExpExec = __webpack_require__(396);

// @@match logic
__webpack_require__(397)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(32);
var toObject = __webpack_require__(71);
var toLength = __webpack_require__(55);
var toInteger = __webpack_require__(136);
var advanceStringIndex = __webpack_require__(551);
var regExpExec = __webpack_require__(396);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(397)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(32);
var sameValue = __webpack_require__(854);
var regExpExec = __webpack_require__(396);

// @@search logic
__webpack_require__(397)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(395);
var anObject = __webpack_require__(32);
var speciesConstructor = __webpack_require__(312);
var advanceStringIndex = __webpack_require__(551);
var toLength = __webpack_require__(55);
var callRegExpExec = __webpack_require__(396);
var regexpExec = __webpack_require__(550);
var fails = __webpack_require__(43);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(397)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(192);
var global = __webpack_require__(41);
var ctx = __webpack_require__(137);
var classof = __webpack_require__(238);
var $export = __webpack_require__(4);
var isObject = __webpack_require__(48);
var aFunction = __webpack_require__(98);
var anInstance = __webpack_require__(215);
var forOf = __webpack_require__(216);
var speciesConstructor = __webpack_require__(312);
var task = __webpack_require__(552).set;
var microtask = __webpack_require__(553)();
var newPromiseCapabilityModule = __webpack_require__(554);
var perform = __webpack_require__(867);
var userAgent = __webpack_require__(398);
var promiseResolve = __webpack_require__(868);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(54)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(214)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(240)($Promise, PROMISE);
__webpack_require__(217)(PROMISE);
Wrapper = __webpack_require__(108)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(345)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(870);
var validate = __webpack_require__(218);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(344)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $typed = __webpack_require__(399);
var buffer = __webpack_require__(555);
var anObject = __webpack_require__(32);
var toAbsoluteIndex = __webpack_require__(213);
var toLength = __webpack_require__(55);
var isObject = __webpack_require__(48);
var ArrayBuffer = __webpack_require__(41).ArrayBuffer;
var speciesConstructor = __webpack_require__(312);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(43)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(217)(ARRAY_BUFFER);


/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
$export($export.G + $export.W + $export.F * !__webpack_require__(399).ABV, {
  DataView: __webpack_require__(555).DataView
});


/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(4);
var aFunction = __webpack_require__(98);
var anObject = __webpack_require__(32);
var rApply = (__webpack_require__(41).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(43)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(4);
var create = __webpack_require__(211);
var aFunction = __webpack_require__(98);
var anObject = __webpack_require__(32);
var isObject = __webpack_require__(48);
var fails = __webpack_require__(43);
var bind = __webpack_require__(855);
var rConstruct = (__webpack_require__(41).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(70);
var $export = __webpack_require__(4);
var anObject = __webpack_require__(32);
var toPrimitive = __webpack_require__(149);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(43)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(4);
var gOPD = __webpack_require__(120).f;
var anObject = __webpack_require__(32);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(4);
var anObject = __webpack_require__(32);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(449)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(120);
var getPrototypeOf = __webpack_require__(119);
var has = __webpack_require__(117);
var $export = __webpack_require__(4);
var isObject = __webpack_require__(48);
var anObject = __webpack_require__(32);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(120);
var $export = __webpack_require__(4);
var anObject = __webpack_require__(32);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(4);
var getProto = __webpack_require__(119);
var anObject = __webpack_require__(32);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(4);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(4);
var anObject = __webpack_require__(32);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(4);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(872) });


/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(4);
var anObject = __webpack_require__(32);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(70);
var gOPD = __webpack_require__(120);
var getPrototypeOf = __webpack_require__(119);
var has = __webpack_require__(117);
var $export = __webpack_require__(4);
var createDesc = __webpack_require__(210);
var anObject = __webpack_require__(32);
var isObject = __webpack_require__(48);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(4);
var setProto = __webpack_require__(459);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(4);
var $includes = __webpack_require__(343)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(193)('includes');


/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(4);
var flattenIntoArray = __webpack_require__(873);
var toObject = __webpack_require__(71);
var toLength = __webpack_require__(55);
var aFunction = __webpack_require__(98);
var arraySpeciesCreate = __webpack_require__(548);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(193)('flatMap');


/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(4);
var flattenIntoArray = __webpack_require__(873);
var toObject = __webpack_require__(71);
var toLength = __webpack_require__(55);
var toInteger = __webpack_require__(136);
var arraySpeciesCreate = __webpack_require__(548);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(193)('flatten');


/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(4);
var $at = __webpack_require__(342)(true);
var $fails = __webpack_require__(43);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(4);
var $pad = __webpack_require__(874);
var userAgent = __webpack_require__(398);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(4);
var $pad = __webpack_require__(874);
var userAgent = __webpack_require__(398);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(262)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(262)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(4);
var defined = __webpack_require__(150);
var toLength = __webpack_require__(55);
var isRegExp = __webpack_require__(395);
var getFlags = __webpack_require__(311);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(449)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(540)('asyncIterator');


/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(540)('observable');


/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(4);
var ownKeys = __webpack_require__(872);
var toIObject = __webpack_require__(118);
var gOPD = __webpack_require__(120);
var createProperty = __webpack_require__(547);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(4);
var $values = __webpack_require__(875)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(4);
var $entries = __webpack_require__(875)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(71);
var aFunction = __webpack_require__(98);
var $defineProperty = __webpack_require__(70);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(59) && $export($export.P + __webpack_require__(400), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(71);
var aFunction = __webpack_require__(98);
var $defineProperty = __webpack_require__(70);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(59) && $export($export.P + __webpack_require__(400), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(71);
var toPrimitive = __webpack_require__(149);
var getPrototypeOf = __webpack_require__(119);
var getOwnPropertyDescriptor = __webpack_require__(120).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(59) && $export($export.P + __webpack_require__(400), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(71);
var toPrimitive = __webpack_require__(149);
var getPrototypeOf = __webpack_require__(119);
var getOwnPropertyDescriptor = __webpack_require__(120).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(59) && $export($export.P + __webpack_require__(400), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(4);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(876)('Map') });


/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(4);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(876)('Set') });


/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(401)('Map');


/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(401)('Set');


/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(401)('WeakMap');


/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(401)('WeakSet');


/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(402)('Map');


/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(402)('Set');


/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(402)('WeakMap');


/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(402)('WeakSet');


/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(4);

$export($export.G, { global: __webpack_require__(41) });


/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(4);

$export($export.S, 'System', { global: __webpack_require__(41) });


/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(4);
var cof = __webpack_require__(135);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);
var scale = __webpack_require__(878);
var fround = __webpack_require__(862);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);

$export($export.S, 'Math', { scale: __webpack_require__(878) });


/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(4);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(4);
var core = __webpack_require__(108);
var global = __webpack_require__(41);
var speciesConstructor = __webpack_require__(312);
var promiseResolve = __webpack_require__(868);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(4);
var newPromiseCapability = __webpack_require__(554);
var perform = __webpack_require__(867);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(181);
var anObject = __webpack_require__(32);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(181);
var anObject = __webpack_require__(32);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(181);
var anObject = __webpack_require__(32);
var getPrototypeOf = __webpack_require__(119);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(460);
var from = __webpack_require__(877);
var metadata = __webpack_require__(181);
var anObject = __webpack_require__(32);
var getPrototypeOf = __webpack_require__(119);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(181);
var anObject = __webpack_require__(32);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(181);
var anObject = __webpack_require__(32);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(181);
var anObject = __webpack_require__(32);
var getPrototypeOf = __webpack_require__(119);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(181);
var anObject = __webpack_require__(32);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(181);
var anObject = __webpack_require__(32);
var aFunction = __webpack_require__(98);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(4);
var microtask = __webpack_require__(553)();
var process = __webpack_require__(41).process;
var isNode = __webpack_require__(135)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(4);
var global = __webpack_require__(41);
var core = __webpack_require__(108);
var microtask = __webpack_require__(553)();
var OBSERVABLE = __webpack_require__(54)('observable');
var aFunction = __webpack_require__(98);
var anObject = __webpack_require__(32);
var anInstance = __webpack_require__(215);
var redefineAll = __webpack_require__(214);
var hide = __webpack_require__(110);
var forOf = __webpack_require__(216);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(217)('Observable');


/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(41);
var $export = __webpack_require__(4);
var userAgent = __webpack_require__(398);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $task = __webpack_require__(552);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(97)))

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1863);
module.exports = __webpack_require__(108).RegExp.escape;


/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(4);
var $re = __webpack_require__(1864)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1864 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = __webpack_require__(556);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var initialCache = {
  options: [],
  hasMore: true,
  isLoading: false
};

var AsyncPaginate = function (_Component) {
  _inherits(AsyncPaginate, _Component);

  function AsyncPaginate(props) {
    var _this2 = this;

    _classCallCheck(this, AsyncPaginate);

    var _this = _possibleConstructorReturn(this, (AsyncPaginate.__proto__ || Object.getPrototypeOf(AsyncPaginate)).call(this, props));

    _this.onClose = function () {
      _this.setState({
        search: ''
      });
    };

    _this.onOpen = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.state.optionsCache['']) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return _this.loadOptions();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.onInputChange = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(search) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.setState({
                  search: search
                });

              case 2:
                if (_this.state.optionsCache[search]) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 5;
                return _this.loadOptions();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.onMenuScrollToBottom = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _this$state, search, optionsCache, currentOptions;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$state = _this.state, search = _this$state.search, optionsCache = _this$state.optionsCache;
              currentOptions = optionsCache[search];

              if (!currentOptions) {
                _context3.next = 5;
                break;
              }

              _context3.next = 5;
              return _this.loadOptions();

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));


    var initialOptionsCache = props.options ? {
      '': {
        isLoading: false,
        options: props.options,
        hasMore: true
      }
    } : {};

    _this.state = {
      search: '',
      optionsCache: initialOptionsCache
    };
    return _this;
  }

  _createClass(AsyncPaginate, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_ref4) {
      var cacheUniq = _ref4.cacheUniq;

      if (cacheUniq !== this.props.cacheUniq) {
        this.setState({
          optionsCache: {}
        });
      }
    }
  }, {
    key: 'loadOptions',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _state, search, optionsCache, currentOptions, _ref6, options, hasMore;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _state = this.state, search = _state.search, optionsCache = _state.optionsCache;
                currentOptions = optionsCache[search] || initialCache;

                if (!(currentOptions.isLoading || !currentOptions.hasMore)) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt('return');

              case 4:
                _context4.next = 6;
                return this.setState({
                  search: search,
                  optionsCache: _extends({}, this.state.optionsCache, _defineProperty({}, search, _extends({}, currentOptions, {
                    isLoading: true
                  })))
                });

              case 6:
                _context4.prev = 6;
                _context4.next = 9;
                return this.props.loadOptions(search, currentOptions.options);

              case 9:
                _ref6 = _context4.sent;
                options = _ref6.options;
                hasMore = _ref6.hasMore;
                _context4.next = 14;
                return this.setState({
                  optionsCache: _extends({}, this.state.optionsCache, _defineProperty({}, search, _extends({}, currentOptions, {
                    options: currentOptions.options.concat(options),
                    hasMore: !!hasMore,
                    isLoading: false
                  })))
                });

              case 14:
                _context4.next = 20;
                break;

              case 16:
                _context4.prev = 16;
                _context4.t0 = _context4['catch'](6);
                _context4.next = 20;
                return this.setState({
                  optionsCache: _extends({}, this.state.optionsCache, _defineProperty({}, search, _extends({}, currentOptions, {
                    isLoading: false
                  })))
                });

              case 20:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[6, 16]]);
      }));

      function loadOptions() {
        return _ref5.apply(this, arguments);
      }

      return loadOptions;
    }()
  }, {
    key: 'render',
    value: function render() {
      var selectRef = this.props.selectRef;
      var _state2 = this.state,
          search = _state2.search,
          optionsCache = _state2.optionsCache;


      var currentOptions = optionsCache[search] || initialCache;

      return _react2.default.createElement(_reactSelect2.default, _extends({}, this.props, {
        onClose: this.onClose,
        onOpen: this.onOpen,
        onInputChange: this.onInputChange,
        onMenuScrollToBottom: this.onMenuScrollToBottom,
        isLoading: currentOptions.isLoading,
        options: currentOptions.options,
        ref: selectRef
      }));
    }
  }]);

  return AsyncPaginate;
}(_react.Component);

AsyncPaginate.propTypes = {
  loadOptions: _propTypes2.default.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  cacheUniq: _propTypes2.default.any,
  selectRef: _propTypes2.default.func,
  options: _propTypes2.default.arrayOf(_propTypes2.default.object)
};
AsyncPaginate.defaultProps = {
  cacheUniq: null,
  selectRef: function selectRef() {},
  options: null
};
exports.default = AsyncPaginate;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 1867 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAASCAYAAABM8m7ZAAAAAXNSR0IArs4c6QAAAYJJREFUSA3V1TFLw0AUB/D3Lo2gKK76CfRrlLq4CFpLB1sRlbbkYzg5uAkVq4NoOlVXxal+A3FSxFHQUShYxZrnveALtab2kmbxlpdeLve7f7hcMVssV8CjbQC8UbaVbxxVnyHhRkS4XKzsAEEJkC7VwlwesyulFwKYZAsB7pSdSieJ++hq+ZA8WJc8llIZxUmlQy9g1vvoNHNrzpT0DVO/kx50owjYHvHse8Wvl5MKkBQeoEQbMjcgvqOlsvX67qM2ATghJ2VUBg3z2vuhSqnF0+O9CzZ8mC+Swk3QH3ASuCn6Cx4Gj4KGwnHwqGhfOAoeB/0TNsEZ1SdfTZ9Imzzeb/qT6d690t1bg13de0N++7u983mlkRnp09/C7RhA5hVgKw7K8wyEeVChUJpuAzZ78JZGJ/i+3wyTBsPlYlANTS4PRUT5MaPEMn94cn0MIiydneyfyziTqv8kzJvr1p5GgdJ6tf7ZrsG3OCiLkRLLEnOOM06tzjxS6rrhVh+k/1/UL7itH0iRJfuaAAAAAElFTkSuQmCC"

/***/ }),
/* 1868 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1869 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(263),
	DaysView = __webpack_require__(1871),
	MonthsView = __webpack_require__(1872),
	YearsView = __webpack_require__(1873),
	TimeView = __webpack_require__(1874)
	;

var CalendarContainer = createClass({
	viewComponents: {
		days: DaysView,
		months: MonthsView,
		years: YearsView,
		time: TimeView
	},

	render: function() {
		return React.createElement( this.viewComponents[ this.props.view ], this.props.viewProps );
	}
});

module.exports = CalendarContainer;


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(263),
	moment = __webpack_require__(24)
	;

var DateTimePickerDays = createClass({
	render: function() {
		var footer = this.renderFooter(),
			date = this.props.viewDate,
			locale = date.localeData(),
			tableChildren
			;

		tableChildren = [
			React.createElement('thead', { key: 'th' }, [
				React.createElement('tr', { key: 'h' }, [
					React.createElement('th', { key: 'p', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'months' )}, React.createElement('span', {}, '‹' )),
					React.createElement('th', { key: 's', className: 'rdtSwitch', onClick: this.props.showView( 'months' ), colSpan: 5, 'data-value': this.props.viewDate.month() }, locale.months( date ) + ' ' + date.year() ),
					React.createElement('th', { key: 'n', className: 'rdtNext', onClick: this.props.addTime( 1, 'months' )}, React.createElement('span', {}, '›' ))
				]),
				React.createElement('tr', { key: 'd'}, this.getDaysOfWeek( locale ).map( function( day, index ) { return React.createElement('th', { key: day + index, className: 'dow'}, day ); }) )
			]),
			React.createElement('tbody', { key: 'tb' }, this.renderDays())
		];

		if ( footer )
			tableChildren.push( footer );

		return React.createElement('div', { className: 'rdtDays' },
			React.createElement('table', {}, tableChildren )
		);
	},

	/**
	 * Get a list of the days of the week
	 * depending on the current locale
	 * @return {array} A list with the shortname of the days
	 */
	getDaysOfWeek: function( locale ) {
		var days = locale._weekdaysMin,
			first = locale.firstDayOfWeek(),
			dow = [],
			i = 0
			;

		days.forEach( function( day ) {
			dow[ (7 + ( i++ ) - first) % 7 ] = day;
		});

		return dow;
	},

	renderDays: function() {
		var date = this.props.viewDate,
			selected = this.props.selectedDate && this.props.selectedDate.clone(),
			prevMonth = date.clone().subtract( 1, 'months' ),
			currentYear = date.year(),
			currentMonth = date.month(),
			weeks = [],
			days = [],
			renderer = this.props.renderDay || this.renderDay,
			isValid = this.props.isValidDate || this.alwaysValidDate,
			classes, isDisabled, dayProps, currentDate
			;

		// Go to the last week of the previous month
		prevMonth.date( prevMonth.daysInMonth() ).startOf( 'week' );
		var lastDay = prevMonth.clone().add( 42, 'd' );

		while ( prevMonth.isBefore( lastDay ) ) {
			classes = 'rdtDay';
			currentDate = prevMonth.clone();

			if ( ( prevMonth.year() === currentYear && prevMonth.month() < currentMonth ) || ( prevMonth.year() < currentYear ) )
				classes += ' rdtOld';
			else if ( ( prevMonth.year() === currentYear && prevMonth.month() > currentMonth ) || ( prevMonth.year() > currentYear ) )
				classes += ' rdtNew';

			if ( selected && prevMonth.isSame( selected, 'day' ) )
				classes += ' rdtActive';

			if ( prevMonth.isSame( moment(), 'day' ) )
				classes += ' rdtToday';

			isDisabled = !isValid( currentDate, selected );
			if ( isDisabled )
				classes += ' rdtDisabled';

			dayProps = {
				key: prevMonth.format( 'M_D' ),
				'data-value': prevMonth.date(),
				className: classes
			};

			if ( !isDisabled )
				dayProps.onClick = this.updateSelectedDate;

			days.push( renderer( dayProps, currentDate, selected ) );

			if ( days.length === 7 ) {
				weeks.push( React.createElement('tr', { key: prevMonth.format( 'M_D' )}, days ) );
				days = [];
			}

			prevMonth.add( 1, 'd' );
		}

		return weeks;
	},

	updateSelectedDate: function( event ) {
		this.props.updateSelectedDate( event, true );
	},

	renderDay: function( props, currentDate ) {
		return React.createElement('td',  props, currentDate.date() );
	},

	renderFooter: function() {
		if ( !this.props.timeFormat )
			return '';

		var date = this.props.selectedDate || this.props.viewDate;

		return React.createElement('tfoot', { key: 'tf'},
			React.createElement('tr', {},
				React.createElement('td', { onClick: this.props.showView( 'time' ), colSpan: 7, className: 'rdtTimeToggle' }, date.format( this.props.timeFormat ))
			)
		);
	},

	alwaysValidDate: function() {
		return 1;
	}
});

module.exports = DateTimePickerDays;


/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(263)
;

var DateTimePickerMonths = createClass({
	render: function() {
		return React.createElement('div', { className: 'rdtMonths' }, [
			React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
				React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'years' )}, React.createElement('span', {}, '‹' )),
				React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2, 'data-value': this.props.viewDate.year() }, this.props.viewDate.year() ),
				React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 1, 'years' )}, React.createElement('span', {}, '›' ))
			]))),
			React.createElement('table', { key: 'months' }, React.createElement('tbody', { key: 'b' }, this.renderMonths()))
		]);
	},

	renderMonths: function() {
		var date = this.props.selectedDate,
			month = this.props.viewDate.month(),
			year = this.props.viewDate.year(),
			rows = [],
			i = 0,
			months = [],
			renderer = this.props.renderMonth || this.renderMonth,
			isValid = this.props.isValidDate || this.alwaysValidDate,
			classes, props, currentMonth, isDisabled, noOfDaysInMonth, daysInMonth, validDay,
			// Date is irrelevant because we're only interested in month
			irrelevantDate = 1
			;

		while (i < 12) {
			classes = 'rdtMonth';
			currentMonth =
				this.props.viewDate.clone().set({ year: year, month: i, date: irrelevantDate });

			noOfDaysInMonth = currentMonth.endOf( 'month' ).format( 'D' );
			daysInMonth = Array.from({ length: noOfDaysInMonth }, function( e, i ) {
				return i + 1;
			});

			validDay = daysInMonth.find(function( d ) {
				var day = currentMonth.clone().set( 'date', d );
				return isValid( day );
			});

			isDisabled = ( validDay === undefined );

			if ( isDisabled )
				classes += ' rdtDisabled';

			if ( date && i === date.month() && year === date.year() )
				classes += ' rdtActive';

			props = {
				key: i,
				'data-value': i,
				className: classes
			};

			if ( !isDisabled )
				props.onClick = ( this.props.updateOn === 'months' ?
					this.updateSelectedMonth : this.props.setDate( 'month' ) );

			months.push( renderer( props, i, year, date && date.clone() ) );

			if ( months.length === 4 ) {
				rows.push( React.createElement('tr', { key: month + '_' + rows.length }, months ) );
				months = [];
			}

			i++;
		}

		return rows;
	},

	updateSelectedMonth: function( event ) {
		this.props.updateSelectedDate( event );
	},

	renderMonth: function( props, month ) {
		var localMoment = this.props.viewDate;
		var monthStr = localMoment.localeData().monthsShort( localMoment.month( month ) );
		var strLength = 3;
		// Because some months are up to 5 characters long, we want to
		// use a fixed string length for consistency
		var monthStrFixedLength = monthStr.substring( 0, strLength );
		return React.createElement('td', props, capitalize( monthStrFixedLength ) );
	},

	alwaysValidDate: function() {
		return 1;
	},
});

function capitalize( str ) {
	return str.charAt( 0 ).toUpperCase() + str.slice( 1 );
}

module.exports = DateTimePickerMonths;


/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(263)
;

var DateTimePickerYears = createClass({
	render: function() {
		var year = parseInt( this.props.viewDate.year() / 10, 10 ) * 10;

		return React.createElement('div', { className: 'rdtYears' }, [
			React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
				React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 10, 'years' )}, React.createElement('span', {}, '‹' )),
				React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2 }, year + '-' + ( year + 9 ) ),
				React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 10, 'years' )}, React.createElement('span', {}, '›' ))
			]))),
			React.createElement('table', { key: 'years' }, React.createElement('tbody',  {}, this.renderYears( year )))
		]);
	},

	renderYears: function( year ) {
		var years = [],
			i = -1,
			rows = [],
			renderer = this.props.renderYear || this.renderYear,
			selectedDate = this.props.selectedDate,
			isValid = this.props.isValidDate || this.alwaysValidDate,
			classes, props, currentYear, isDisabled, noOfDaysInYear, daysInYear, validDay,
			// Month and date are irrelevant here because
			// we're only interested in the year
			irrelevantMonth = 0,
			irrelevantDate = 1
			;

		year--;
		while (i < 11) {
			classes = 'rdtYear';
			currentYear = this.props.viewDate.clone().set(
				{ year: year, month: irrelevantMonth, date: irrelevantDate } );

			// Not sure what 'rdtOld' is for, commenting out for now as it's not working properly
			// if ( i === -1 | i === 10 )
				// classes += ' rdtOld';

			noOfDaysInYear = currentYear.endOf( 'year' ).format( 'DDD' );
			daysInYear = Array.from({ length: noOfDaysInYear }, function( e, i ) {
				return i + 1;
			});

			validDay = daysInYear.find(function( d ) {
				var day = currentYear.clone().dayOfYear( d );
				return isValid( day );
			});

			isDisabled = ( validDay === undefined );

			if ( isDisabled )
				classes += ' rdtDisabled';

			if ( selectedDate && selectedDate.year() === year )
				classes += ' rdtActive';

			props = {
				key: year,
				'data-value': year,
				className: classes
			};

			if ( !isDisabled )
				props.onClick = ( this.props.updateOn === 'years' ?
					this.updateSelectedYear : this.props.setDate('year') );

			years.push( renderer( props, year, selectedDate && selectedDate.clone() ));

			if ( years.length === 4 ) {
				rows.push( React.createElement('tr', { key: i }, years ) );
				years = [];
			}

			year++;
			i++;
		}

		return rows;
	},

	updateSelectedYear: function( event ) {
		this.props.updateSelectedDate( event );
	},

	renderYear: function( props, year ) {
		return React.createElement('td',  props, year );
	},

	alwaysValidDate: function() {
		return 1;
	},
});

module.exports = DateTimePickerYears;


/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(263),
	assign = __webpack_require__(880)
	;

var DateTimePickerTime = createClass({
	getInitialState: function() {
		return this.calculateState( this.props );
	},

	calculateState: function( props ) {
		var date = props.selectedDate || props.viewDate,
			format = props.timeFormat,
			counters = []
			;

		if ( format.toLowerCase().indexOf('h') !== -1 ) {
			counters.push('hours');
			if ( format.indexOf('m') !== -1 ) {
				counters.push('minutes');
				if ( format.indexOf('s') !== -1 ) {
					counters.push('seconds');
				}
			}
		}

		var hours = date.format( 'H' );

		var daypart = false;
		if ( this.state !== null && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
			if ( this.props.timeFormat.indexOf( ' A' ) !== -1 ) {
				daypart = ( hours >= 12 ) ? 'PM' : 'AM';
			} else {
				daypart = ( hours >= 12 ) ? 'pm' : 'am';
			}
		}

		return {
			hours: hours,
			minutes: date.format( 'mm' ),
			seconds: date.format( 'ss' ),
			milliseconds: date.format( 'SSS' ),
			daypart: daypart,
			counters: counters
		};
	},

	renderCounter: function( type ) {
		if ( type !== 'daypart' ) {
			var value = this.state[ type ];
			if ( type === 'hours' && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
				value = ( value - 1 ) % 12 + 1;

				if ( value === 0 ) {
					value = 12;
				}
			}
			return React.createElement('div', { key: type, className: 'rdtCounter' }, [
				React.createElement('span', { key: 'up', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'increase', type ), onContextMenu: this.disableContextMenu }, '▲' ),
				React.createElement('div', { key: 'c', className: 'rdtCount' }, value ),
				React.createElement('span', { key: 'do', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'decrease', type ), onContextMenu: this.disableContextMenu }, '▼' )
			]);
		}
		return '';
	},

	renderDayPart: function() {
		return React.createElement('div', { key: 'dayPart', className: 'rdtCounter' }, [
			React.createElement('span', { key: 'up', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▲' ),
			React.createElement('div', { key: this.state.daypart, className: 'rdtCount' }, this.state.daypart ),
			React.createElement('span', { key: 'do', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▼' )
		]);
	},

	render: function() {
		var me = this,
			counters = []
		;

		this.state.counters.forEach( function( c ) {
			if ( counters.length )
				counters.push( React.createElement('div', { key: 'sep' + counters.length, className: 'rdtCounterSeparator' }, ':' ) );
			counters.push( me.renderCounter( c ) );
		});

		if ( this.state.daypart !== false ) {
			counters.push( me.renderDayPart() );
		}

		if ( this.state.counters.length === 3 && this.props.timeFormat.indexOf( 'S' ) !== -1 ) {
			counters.push( React.createElement('div', { className: 'rdtCounterSeparator', key: 'sep5' }, ':' ) );
			counters.push(
				React.createElement('div', { className: 'rdtCounter rdtMilli', key: 'm' },
					React.createElement('input', { value: this.state.milliseconds, type: 'text', onChange: this.updateMilli } )
					)
				);
		}

		return React.createElement('div', { className: 'rdtTime' },
			React.createElement('table', {}, [
				this.renderHeader(),
				React.createElement('tbody', { key: 'b'}, React.createElement('tr', {}, React.createElement('td', {},
					React.createElement('div', { className: 'rdtCounters' }, counters )
				)))
			])
		);
	},

	componentWillMount: function() {
		var me = this;
		me.timeConstraints = {
			hours: {
				min: 0,
				max: 23,
				step: 1
			},
			minutes: {
				min: 0,
				max: 59,
				step: 1
			},
			seconds: {
				min: 0,
				max: 59,
				step: 1
			},
			milliseconds: {
				min: 0,
				max: 999,
				step: 1
			}
		};
		['hours', 'minutes', 'seconds', 'milliseconds'].forEach( function( type ) {
			assign(me.timeConstraints[ type ], me.props.timeConstraints[ type ]);
		});
		this.setState( this.calculateState( this.props ) );
	},

	componentWillReceiveProps: function( nextProps ) {
		this.setState( this.calculateState( nextProps ) );
	},

	updateMilli: function( e ) {
		var milli = parseInt( e.target.value, 10 );
		if ( milli === e.target.value && milli >= 0 && milli < 1000 ) {
			this.props.setTime( 'milliseconds', milli );
			this.setState( { milliseconds: milli } );
		}
	},

	renderHeader: function() {
		if ( !this.props.dateFormat )
			return null;

		var date = this.props.selectedDate || this.props.viewDate;
		return React.createElement('thead', { key: 'h' }, React.createElement('tr', {},
			React.createElement('th', { className: 'rdtSwitch', colSpan: 4, onClick: this.props.showView( 'days' ) }, date.format( this.props.dateFormat ) )
		));
	},

	onStartClicking: function( action, type ) {
		var me = this;

		return function() {
			var update = {};
			update[ type ] = me[ action ]( type );
			me.setState( update );

			me.timer = setTimeout( function() {
				me.increaseTimer = setInterval( function() {
					update[ type ] = me[ action ]( type );
					me.setState( update );
				}, 70);
			}, 500);

			me.mouseUpListener = function() {
				clearTimeout( me.timer );
				clearInterval( me.increaseTimer );
				me.props.setTime( type, me.state[ type ] );
				document.body.removeEventListener( 'mouseup', me.mouseUpListener );
				document.body.removeEventListener( 'touchend', me.mouseUpListener );
			};

			document.body.addEventListener( 'mouseup', me.mouseUpListener );
			document.body.addEventListener( 'touchend', me.mouseUpListener );
		};
	},

	disableContextMenu: function( event ) {
		event.preventDefault();
		return false;
	},

	padValues: {
		hours: 1,
		minutes: 2,
		seconds: 2,
		milliseconds: 3
	},

	toggleDayPart: function( type ) { // type is always 'hours'
		var value = parseInt( this.state[ type ], 10) + 12;
		if ( value > this.timeConstraints[ type ].max )
			value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
		return this.pad( type, value );
	},

	increase: function( type ) {
		var value = parseInt( this.state[ type ], 10) + this.timeConstraints[ type ].step;
		if ( value > this.timeConstraints[ type ].max )
			value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
		return this.pad( type, value );
	},

	decrease: function( type ) {
		var value = parseInt( this.state[ type ], 10) - this.timeConstraints[ type ].step;
		if ( value < this.timeConstraints[ type ].min )
			value = this.timeConstraints[ type ].max + 1 - ( this.timeConstraints[ type ].min - value );
		return this.pad( type, value );
	},

	pad: function( type, value ) {
		var str = value + '';
		while ( str.length < this.padValues[ type ] )
			str = '0' + str;
		return str;
	},
});

module.exports = DateTimePickerTime;


/***/ }),
/* 1875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IGNORE_CLASS_NAME", function() { return IGNORE_CLASS_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);


/***/ }),
/* 1876 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1877 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1878 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1879 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_image_lightbox__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_lightbox_style_css__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_lightbox_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_image_lightbox_style_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FullScreenImageViewer=function(_Component){_inherits(FullScreenImageViewer,_Component);function FullScreenImageViewer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FullScreenImageViewer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FullScreenImageViewer.__proto__||Object.getPrototypeOf(FullScreenImageViewer)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(event){if(_this.props.onClose){_this.props.onClose();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FullScreenImageViewer,[{key:'render',value:function render(){if(this.props.show){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_image_lightbox__["a" /* default */],{mainSrc:this.props.url,reactModalStyle:{overlay:{zIndex:2000}},onCloseRequest:this.handleClose});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}}]);return FullScreenImageViewer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FullScreenImageViewer.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};FullScreenImageViewer.defaultProps={show:false};/* harmony default export */ __webpack_exports__["a"] = (FullScreenImageViewer);

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(1882);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(60);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(1883);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(885);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(557);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(173);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(1884);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(1885);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(885);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(1888);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(557);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(886);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(1889);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus(_this.props.preventScroll);
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen({
              overlayEl: _this.overlay,
              contentEl: _this.content
            });
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(884);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(884);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _portalOpenInstances = __webpack_require__(886);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

function focusContent() {
  if (instances.length === 0) {
    if (false) {
      // eslint-disable-next-line no-console
      console.warn("React-Modal: Open instances > 0 expected");
    }
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before || !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),
/* 1890 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getShowCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEditTaskId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getCurrentTask=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.tasks.data.currentTask;},function(currentTask){return currentTask;});var getShowCancel=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.tasks.ui.showCancel;},function(showCancel){return showCancel;});var getEditTaskId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.tasks.data.editTaskId;},function(editTaskId){return editTaskId;});

/***/ }),
/* 1892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WorkingHours_css__ = __webpack_require__(1893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WorkingHours_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__WorkingHours_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_select_SelectList__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_admin_work_orders_creation_working_hours__ = __webpack_require__(1894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_left_arrow_png__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_left_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_left_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectors_admin_work_orders_creation_working_hours__ = __webpack_require__(1895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_admin_work_orders_creation_creation__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CancelWorkOrder__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__selectors_admin_work_orders_creation_creation__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_utils_scroller_util__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WorkingHours=function(_Component){_inherits(WorkingHours,_Component);function WorkingHours(){var _ref;var _temp,_this,_ret;_classCallCheck(this,WorkingHours);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WorkingHours.__proto__||Object.getPrototypeOf(WorkingHours)).call.apply(_ref,[this].concat(args))),_this),_this.handleWorkingHourSelection=function(id){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_admin_work_orders_creation_working_hours__["c" /* selectWorkingHour */])(id));},_this.handleDescribeOnChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_admin_work_orders_creation_working_hours__["b" /* changeOtherWorkingHour */])(value));},_this.handleContinue=function(event){event.preventDefault();var promise=_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_admin_work_orders_creation_working_hours__["a" /* addWorkingHoursRequest */])(_this.props.currentWorkOrder.id,_this.props.workingHours,_this.props.otherWorkingHour));if(promise!==null){promise.then(function(response){if(response.ok){Object(__WEBPACK_IMPORTED_MODULE_15__services_utils_scroller_util__["c" /* simpleScrollToTop */])();}});}},_this.handleBackArrow=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_admin_work_orders_work_orders__["g" /* goHistoryBack */])());},_this.handleCancelOrder=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_admin_work_orders_creation_creation__["g" /* showWOCancellationModal */])());},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WorkingHours,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_admin_work_orders_creation_working_hours__["d" /* setCurrentWorkingHours */])(this.props.currentWorkOrder!==null?this.props.currentWorkOrder.working_hours:[]));}},{key:'isValid',value:function isValid(){return this.props.validationError==='';}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'working-hours'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_route_title_RouteTitle__["a" /* default */],{titles:['WORK ORDERS','WO #'+this.props.currentWorkOrder.number]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title light'},'Work Order #',this.props.currentWorkOrder.number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:8,className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},/* Only show back button if WO is under creation */this.props.newWOProcessStarted&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-back-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__images_left_arrow_png___default.a,alt:'left-arrow',onClick:this.handleBackArrow})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sub-titles-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Available Working Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Click all the apply:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'working-hours-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_select_SelectList__["a" /* default */],{values:this.props.workingHours,onSelect:this.handleWorkingHourSelection}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-area-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_input_TextArea__["a" /* default */],{className:'text-area-describe',placeholder:'Describe...',value:this.props.otherWorkingHour,onChange:this.handleDescribeOnChange}))),!this.isValid()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},this.props.validationError):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',value:'Continue',type:'button',onClick:this.handleContinue}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-white',value:'Cancel Order',type:'button',onClick:this.handleCancelOrder})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__CancelWorkOrder__["a" /* default */],null));}}]);return WorkingHours;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(state){return{currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_11__selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),newWOProcessStarted:Object(__WEBPACK_IMPORTED_MODULE_14__selectors_admin_work_orders_creation_creation__["a" /* getNewWOProcessStarted */])(state),otherWorkingHour:Object(__WEBPACK_IMPORTED_MODULE_10__selectors_admin_work_orders_creation_working_hours__["a" /* getOtherWorkingHour */])(state),validationError:Object(__WEBPACK_IMPORTED_MODULE_10__selectors_admin_work_orders_creation_working_hours__["b" /* getValidationError */])(state),workingHours:Object(__WEBPACK_IMPORTED_MODULE_10__selectors_admin_work_orders_creation_working_hours__["c" /* getWorkingHours */])(state)};})(WorkingHours));

/***/ }),
/* 1893 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addWorkingHoursRequest;
/* unused harmony export validWorkingHour */
/* unused harmony export invalidWorkingHour */
/* harmony export (immutable) */ __webpack_exports__["c"] = selectWorkingHour;
/* harmony export (immutable) */ __webpack_exports__["b"] = changeOtherWorkingHour;
/* harmony export (immutable) */ __webpack_exports__["d"] = setCurrentWorkingHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_work_orders_api__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__creation__ = __webpack_require__(124);
function validate(workingHours,other){if(workingHours.filter(function(element){return element.selected;}).length===0){return'Please select at least one element from the list.';}return null;}function addWorkingHoursRequest(workOrderId,workingHours,other){return function(dispatch){var validation=validate(workingHours,other);if(validation!==null){dispatch(invalidWorkingHour(validation));return null;}else{var newWorkingHours=workingHours.filter(function(element){return element.selected;}).map(function(element){return element.value;});if(other!==''){newWorkingHours.push(other);}dispatch(validWorkingHour());return __WEBPACK_IMPORTED_MODULE_0__services_api_work_orders_api__["a" /* default */].addWorkingHours(workOrderId,newWorkingHours).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__work_orders__["C" /* updateWorkOrder */])(response.workOrder));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__creation__["d" /* goToSummary */])());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__messages__["d" /* showErrorMessage */])(response.errors));}return response;});}};}function validWorkingHour(){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["W" /* WORK_ORDERS_CREATION_WORKING_HOURS_VALID */]};}function invalidWorkingHour(validation){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["T" /* WORK_ORDERS_CREATION_WORKING_HOURS_INVALID */],payload:validation};}function selectWorkingHour(id){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["V" /* WORK_ORDERS_CREATION_WORKING_HOURS_SELECT */],payload:id};}function changeOtherWorkingHour(value){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["U" /* WORK_ORDERS_CREATION_WORKING_HOURS_OTHER_CHANGE */],payload:value};}function setCurrentWorkingHours(currentWorkingHours){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["S" /* WORK_ORDERS_CREATION_WORKING_HOURS_CURRENT_SET */],payload:currentWorkingHours};}

/***/ }),
/* 1895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getOtherWorkingHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getValidationError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getWorkingHours; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getOtherWorkingHour=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.workingHours.data.otherWorkingHour;},function(otherWorkingHour){return otherWorkingHour;});var getValidationError=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.workingHours.ui.validationError;},function(validationError){return validationError;});var getWorkingHours=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.workingHours.data.workingHours;},function(workingHours){return workingHours;});

/***/ }),
/* 1896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WorkOrderSummary_css__ = __webpack_require__(1897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WorkOrderSummary_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__WorkOrderSummary_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_creation_work_order_summary__ = __webpack_require__(1898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TaskSummary__ = __webpack_require__(1899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_check_circle_png__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_check_circle_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_images_check_circle_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_confirmation_ConfirmationPanel__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_creation_work_order_summary__ = __webpack_require__(1902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_actions_admin_work_orders_creation_creation__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CancelWorkOrder__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_actions_admin_work_orders_creation_sub_contractors_union_trades__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_actions_admin_work_orders_creation_tasks__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_reveal_Flash__ = __webpack_require__(1903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_reveal_Flash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_reveal_Flash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_shared_details_DetailsFilesContainer__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_images_upload_png__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_images_upload_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_images_upload_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_shared_files_FilesUploadedViewer__ = __webpack_require__(310);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WorkOrderSummary=function(_Component){_inherits(WorkOrderSummary,_Component);function WorkOrderSummary(props){_classCallCheck(this,WorkOrderSummary);var _this=_possibleConstructorReturn(this,(WorkOrderSummary.__proto__||Object.getPrototypeOf(WorkOrderSummary)).call(this,props));_this.submitAvailable=function(){// Submit is available if at least one task is defined, one working hour is defined
return _this.props.summary.tasks.length>0&&_this.props.summary.working_hours.length>0;};_this.partialSubmitAvailable=function(){// Partial submit is available if at least one task is defined, one working hour is defined and if the user is a client,
// at least one task has no images
var userIsClient=__WEBPACK_IMPORTED_MODULE_19_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.user,__WEBPACK_IMPORTED_MODULE_19_services_utils_users_util__["f" /* TYPES */].CLIENT);return _this.props.summary.tasks.length>0&&_this.props.summary.working_hours.length>0&&userIsClient&&_this.props.summary.tasks.filter(function(task){return task.images.length===0;}).length>0;};_this.handleSubmit=function(event){event.preventDefault();if(_this.partialSubmitAvailable()){_this.setState({showPartialSubmitAnimation:true});}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_creation_work_order_summary__["d" /* workOrderConfirmationRequest */])(_this.props.currentWorkOrder.id));}};_this.handleSubmitWithoutPictures=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_creation_work_order_summary__["e" /* workOrderConfirmationWithoutPicturesRequest */])(_this.props.currentWorkOrder.id));};_this.handleSubmitRequestContinue=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_creation_work_order_summary__["b" /* finishWorkOrderCreation */])());};_this.handleWorkOrderConfirmationContinue=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_creation_work_order_summary__["b" /* finishWorkOrderCreation */])());};_this.handleCancelOrder=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_actions_admin_work_orders_creation_creation__["g" /* showWOCancellationModal */])());};_this.handleTaskDelete=function(id,taskNumber){_this.setState({showTaskConfirmation:true,taskId:id,taskNumber:taskNumber});};_this.handleTaskEdit=function(taskId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions_admin_work_orders_creation_tasks__["f" /* editTask */])(taskId,_this.props.tasks));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_actions_admin_work_orders_creation_creation__["e" /* goToTasks */])());};_this.handleTasksEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_actions_admin_work_orders_creation_creation__["e" /* goToTasks */])());};_this.handleTaskDeleteConfirmation=function(response){if(response){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_creation_work_order_summary__["a" /* deleteTaskRequest */])(_this.state.taskId));}_this.setState({showTaskConfirmation:false,taskId:0,taskNumber:0});};_this.handleSubContractorsUnionTradesEdit=function(){Object(__WEBPACK_IMPORTED_MODULE_18_services_utils_scroller_util__["c" /* simpleScrollToTop */])();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_actions_admin_work_orders_creation_creation__["c" /* goToSubContractorsUnionTrades */])());};_this.handleWorkingHoursEdit=function(){Object(__WEBPACK_IMPORTED_MODULE_18_services_utils_scroller_util__["c" /* simpleScrollToTop */])();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_actions_admin_work_orders_creation_creation__["f" /* goToWorkingHours */])());};_this.handleDocumentsDrop=function(documents){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_actions_admin_work_orders_details_details__["_22" /* uploadDocumentsRequest */])(_this.props.currentWorkOrder.id,documents));};_this.handleDocumentRemove=function(documentId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_actions_admin_work_orders_details_details__["O" /* removeDocumentRequest */])(_this.props.currentWorkOrder.id,documentId));};_this.state={showPartialSubmitAnimation:false,showTaskConfirmation:false,taskId:0,taskNumber:0};return _this;}_createClass(WorkOrderSummary,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_actions_admin_work_orders_creation_sub_contractors_union_trades__["m" /* setNewWOProcessStarted */])(false));// set process started to false
this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_creation_work_order_summary__["c" /* loadWorkOrderSummaryRequest */])(this.props.currentWorkOrder.id));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'work-order-summary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['WORK ORDERS','WO #'+this.props.currentWorkOrder.number,'Summary - Draft status']}),this.showContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__CancelWorkOrder__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showTaskConfirmation,message:'Are you sure you would like to delete Task #'+__WEBPACK_IMPORTED_MODULE_15_numeral___default()(this.state.taskNumber).format('00')+'?',onHide:this.handleTaskDeleteConfirmation}));}},{key:'getContent',value:function getContent(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:8,className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-title'},'Building Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-line'},this.props.summary.building.location.street_address_1,this.props.summary.building.location.street_address_2!==null&&this.props.summary.building.location.street_address_2!==''?', '+this.props.summary.building.location.street_address_2:null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-line'},this.props.summary.building.location.city+', ',this.props.summary.building.location.state+' ',this.props.summary.building.location.zip),this.props.summary.building.name!==''&&this.props.summary.building.name!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-line'},this.props.summary.building.name)),this.props.summary.tasks.length>0?this.props.summary.tasks.slice()// copy task for sorting
.sort(WorkOrderSummary.sortTasks).map(function(task,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'item-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TaskSummary__["a" /* default */],{key:index,task:WorkOrderSummary.convertTask(task),onTaskDelete:_this2.handleTaskDelete,onTaskEdit:_this2.handleTaskEdit}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-title'},'Tasks'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-edit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_button_Button__["a" /* default */],{label:'Edit',className:'button-gray summary-edit-button',onClick:this.handleTasksEdit}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-title'},'Available Working Hours'),this.props.summary.working_hours.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'item-line'},element);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-edit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_button_Button__["a" /* default */],{label:'Edit',className:'button-gray summary-edit-button',onClick:this.handleWorkingHoursEdit}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-title'},'Preferred or Propietary Subcontractors'),this.props.summary.propietary_sub_contractors.length>0?this.props.summary.propietary_sub_contractors.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'item-line'},element.name);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-line'},'None'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-edit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_button_Button__["a" /* default */],{label:'Edit',className:'button-gray summary-edit-button',onClick:this.handleSubContractorsUnionTradesEdit}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-title'},'Union Requirements'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-line'},this.props.summary.unions.length>0?this.props.summary.unions.map(function(element,index,array){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:index},element.label),index<array.length-1?', ':null);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'None')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-edit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_button_Button__["a" /* default */],{label:'Edit',className:'button-gray summary-edit-button',onClick:this.handleSubContractorsUnionTradesEdit}))),this.partialSubmitAvailable()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_reveal_Flash___default.a,{count:2,spy:this.state.showPartialSubmitAnimation,onReveal:function onReveal(){return _this2.setState({showPartialSubmitAnimation:false});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["a" /* Alert */],{bsStyle:'warning',className:'submit-alert'},'If a photo for this WO does not apply, please click',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:this.handleSubmitWithoutPictures},'here')),' ','for it to be submitted as is.')),this.props.currentWorkOrder.documents.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["a" /* Alert */],{bsStyle:'warning',className:'submit-alert'},'Documents missing for this Work Order, please review.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',disabled:!this.submitAvailable(),value:'Submit',type:'button',onClick:this.handleSubmit}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-white',value:'Cancel Order',type:'button',onClick:this.handleCancelOrder})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:4,className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_shared_details_DetailsFilesContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2'},'Documents'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body-bold files-title'},'Please drag and drop any file into this area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropzone-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx',className:'files-dropzone',onDrop:this.handleDocumentsDrop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_24_images_upload_png___default.a,alt:'remove'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'files-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_components_shared_files_FilesUploadedViewer__["a" /* default */],{documents:this.props.currentWorkOrder.documents,showLink:true,onDocumentRemove:this.handleDocumentRemove})))));}},{key:'getSubmitRequestConfirmation',value:function getSubmitRequestConfirmation(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:8,className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_confirmation_ConfirmationPanel__["a" /* default */],{className:'summary-confirmation-panel',image:__WEBPACK_IMPORTED_MODULE_7_images_check_circle_png___default.a,firstLine:'Request submitted',lines:['A request was sent to the admin to submit the WO as is.'],buttons:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-orange',value:'Continue',onClick:this.handleSubmitRequestContinue})]})));}},{key:'getWorkOrderConfirmation',value:function getWorkOrderConfirmation(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:8,className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_confirmation_ConfirmationPanel__["a" /* default */],{className:'summary-confirmation-panel',image:__WEBPACK_IMPORTED_MODULE_7_images_check_circle_png___default.a,firstLine:'Success!',lines:['Work Order '+this.props.currentWorkOrder.number+' was created.','A member of the Spackle team will reach out for any additional information or documents.'],buttons:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-orange',value:'Continue',onClick:this.handleWorkOrderConfirmationContinue})]})));}},{key:'showContent',value:function showContent(){if(this.props.showSubmitRequestConfirmation){return this.getSubmitRequestConfirmation();}else if(this.props.showWorkOrderCreatedConfirmation){return this.getWorkOrderConfirmation();}else if(this.props.summary!==null){return this.getContent();}else{return null;}}}],[{key:'sortTasks',value:function sortTasks(taskA,taskB){if(taskA.number<taskB.number){return-1;}if(taskA.number>taskB.number){return 1;}return 0;}},{key:'convertTask',value:function convertTask(task){return{id:task.id,description:task.description,dueDate:task.completion_date,floor:task.floor,images:task.images.map(function(element){return{preview:element.image.preview.url,url:element.image.url};}),number:task.number,room:task.room,trade:task.trade.label,name:task.name};}}]);return WorkOrderSummary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(state){return{currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),summary:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_work_orders__["h" /* getSummary */])(state),showSubmitRequestConfirmation:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_creation_work_order_summary__["a" /* getShowSubmitRequestConfirmation */])(state),showWorkOrderCreatedConfirmation:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_creation_work_order_summary__["b" /* getShowWorkOrderCreatedConfirmation */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state),user:state.auth.user};})(WorkOrderSummary));

/***/ }),
/* 1897 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteTaskRequest;
/* harmony export (immutable) */ __webpack_exports__["c"] = loadWorkOrderSummaryRequest;
/* unused harmony export workOrderSummaryStart */
/* harmony export (immutable) */ __webpack_exports__["d"] = workOrderConfirmationRequest;
/* unused harmony export workOrderConfirmationSuccess */
/* harmony export (immutable) */ __webpack_exports__["e"] = workOrderConfirmationWithoutPicturesRequest;
/* unused harmony export workOrderConfirmationWithoutPicturesSuccess */
/* harmony export (immutable) */ __webpack_exports__["b"] = finishWorkOrderCreation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_work_orders_api__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api_tasks_api__ = __webpack_require__(140);
function deleteTaskRequest(id){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_5__services_api_tasks_api__["b" /* tasksApi */].removeTask(id).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__work_orders__["t" /* removeTask */])(id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__work_orders__["u" /* removeTaskFromSummary */])(id));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function loadWorkOrderSummaryRequest(workOrderId){return function(dispatch){dispatch(workOrderSummaryStart());return __WEBPACK_IMPORTED_MODULE_1__services_api_work_orders_api__["a" /* default */].getSummary(workOrderId).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__work_orders__["p" /* loadWorkOrderSummarySuccess */])(response.summary));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__messages__["d" /* showErrorMessage */])(response.errors));}});};}function workOrderSummaryStart(){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["D" /* WORK_ORDERS_CREATION_SUMMARY_START */]};}function workOrderConfirmationRequest(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__services_api_work_orders_api__["a" /* default */].confirmWorkOrder(workOrderId).then(function(response){if(response.ok){dispatch(workOrderConfirmationSuccess());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__work_orders__["C" /* updateWorkOrder */])(response.workOrder));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__messages__["d" /* showErrorMessage */])(response.errors));}});};}function workOrderConfirmationSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["B" /* WORK_ORDERS_CREATION_SUMMARY_CONFIRMATION_SUCCESS */]};}function workOrderConfirmationWithoutPicturesRequest(workOrderId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__services_api_work_orders_api__["a" /* default */].requestSubmit(workOrderId).then(function(response){if(response.ok){dispatch(workOrderConfirmationWithoutPicturesSuccess());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__work_orders__["C" /* updateWorkOrder */])(response.workOrder));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__messages__["d" /* showErrorMessage */])(response.errors));}});};}function workOrderConfirmationWithoutPicturesSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_3__action_types__["C" /* WORK_ORDERS_CREATION_SUMMARY_CONFIRMATION_WITHOUT_PICS_SUCCESS */]};}function finishWorkOrderCreation(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_2__work_orders__["c" /* baseRoutePath */]));};}

/***/ }),
/* 1899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TaskSummary_css__ = __webpack_require__(1900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TaskSummary_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TaskSummary_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_utils_tasks_util__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TaskSummary=function(_Component){_inherits(TaskSummary,_Component);function TaskSummary(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TaskSummary);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TaskSummary.__proto__||Object.getPrototypeOf(TaskSummary)).call.apply(_ref,[this].concat(args))),_this),_this.handleTaskEdit=function(){if(_this.props.onTaskEdit!==undefined){_this.props.onTaskEdit(_this.props.task.id);}},_this.handleTaskDelete=function(){if(_this.props.onTaskDelete!==undefined){_this.props.onTaskDelete(_this.props.task.id,_this.props.task.number);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TaskSummary,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'task-summary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-title'},this.props.task.trade),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-title'},'Task',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'#',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:this.props.task.number,format:'00'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edit-delete-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{label:'Edit',className:'button-gray summary-edit-button',onClick:this.handleTaskEdit}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{label:'Delete',className:'button-gray summary-edit-button',onClick:this.handleTaskDelete}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Completion Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__["a" /* default */],{value:this.props.task.dueDate,format:'M/D/YYYY'}))),!__WEBPACK_IMPORTED_MODULE_7_services_utils_tasks_util__["a" /* default */].validateTaskCompletionDate(this.props.task.dueDate)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["a" /* Alert */],{bsStyle:'warning',className:'completion-date-warning'},'Completion date is 5 days or less from request. Please confirm completion date.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Floor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.props.task.floor)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Room'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.props.task.room)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Task Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.props.task.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.props.task.description)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'images-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_image_upload_ImageUpload__["a" /* default */],{images:this.props.task.images//.map(image => { return { url: image.url, preview: image.preview }})}
,readOnly:true})));}}]);return TaskSummary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TaskSummary.propTypes={task:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,dueDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,floor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,images:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({preview:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),number:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,room:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,trade:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}).isRequired,onTaskDelete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onTaskEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (TaskSummary);

/***/ }),
/* 1900 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1901 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getShowSubmitRequestConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getShowWorkOrderCreatedConfirmation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getShowSubmitRequestConfirmation=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.summary.ui.showSubmitRequestConfirmation;},function(showSubmitRequestConfirmation){return showSubmitRequestConfirmation;});var getShowWorkOrderCreatedConfirmation=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.summary.ui.showWorkOrderCreatedConfirmation;},function(showWorkOrderCreatedConfirmation){return showWorkOrderCreatedConfirmation;});

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function _objectWithoutProperties(e,o){var r={};for(var t in e)o.indexOf(t)>=0||Object.prototype.hasOwnProperty.call(e,t)&&(r[t]=e[t]);return r}function make(){return name||(name=(0,_globals.animation)(rule))}function Flash(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:_globals.defaults,o=e.children,r=(e.out,e.timeout),t=e.duration,a=void 0===t?_globals.defaults.duration:t,u=e.delay,n=void 0===u?_globals.defaults.delay:u,p=e.count,l=void 0===p?_globals.defaults.count:p,i=e.forever,s=_objectWithoutProperties(e,["children","out","timeout","duration","delay","count","forever"]),d={make:make,duration:void 0===r?a:r,delay:n,forever:i,count:l,style:{animationFillMode:"both"}};return(0,_wrap2.default)(s,d,!1,o,!0)}Object.defineProperty(exports,"__esModule",{value:!0});var _propTypes=__webpack_require__(1),_wrap=__webpack_require__(1904),_wrap2=_interopRequireDefault(_wrap),_globals=__webpack_require__(889),propTypes={duration:_propTypes.number,timeout:_propTypes.number,delay:_propTypes.number,count:_propTypes.number,forever:_propTypes.bool},rule="\nfrom, 50%, to {\n    opacity: 1;\n  }\n\n  25%, 75% {\n    opacity: 0;\n}\n",name=!1;Flash.propTypes=propTypes,exports.default=Flash,module.exports=exports.default;

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function wrap(e,t,a,r){return"in"in e&&(e.when=e.in),_react2.default.Children.count(r)<2?_react2.default.createElement(_RevealBase2.default,_extends({},e,{inEffect:t,outEffect:a,children:r})):(r=_react2.default.Children.map(r,function(r){return _react2.default.createElement(_RevealBase2.default,_extends({},e,{inEffect:t,outEffect:a,children:r}))}),"Fragment"in _react2.default?_react2.default.createElement(_react2.default.Fragment,null,r):_react2.default.createElement("span",null,r))}Object.defineProperty(exports,"__esModule",{value:!0});var _extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var a=arguments[t];for(var r in a)Object.prototype.hasOwnProperty.call(a,r)&&(e[r]=a[r])}return e};exports.default=wrap;var _react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_RevealBase=__webpack_require__(1905),_RevealBase2=_interopRequireDefault(_RevealBase);module.exports=exports.default;

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function _defineProperty(e,t,i){return t in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(exports,"__esModule",{value:!0});var _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},_slicedToArray=function(){function e(e,t){var i=[],s=!0,o=!1,n=void 0;try{for(var r,a=e[Symbol.iterator]();!(s=(r=a.next()).done)&&(i.push(r.value),!t||i.length!==t);s=!0);}catch(e){o=!0,n=e}finally{try{!s&&a.return&&a.return()}finally{if(o)throw n}}return i}return function(t,i){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,i);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var i=arguments[t];for(var s in i)Object.prototype.hasOwnProperty.call(i,s)&&(e[s]=i[s])}return e},_createClass=function(){function e(e,t){for(var i=0;i<t.length;i++){var s=t[i];s.enumerable=s.enumerable||!1,s.configurable=!0,"value"in s&&(s.writable=!0),Object.defineProperty(e,s.key,s)}}return function(t,i,s){return i&&e(t.prototype,i),s&&e(t,s),t}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_globals=__webpack_require__(889),inOut=(0,_propTypes.shape)({make:_propTypes.func,duration:_propTypes.number.isRequired,delay:_propTypes.number.isRequired,forever:_propTypes.bool,count:_propTypes.number.isRequired,style:_propTypes.object.isRequired,reverse:_propTypes.bool}),propTypes={collapse:_propTypes.bool,collapseEl:_propTypes.element,cascade:_propTypes.bool,wait:_propTypes.number,force:_propTypes.bool,disabled:_propTypes.bool,appear:_propTypes.bool,enter:_propTypes.bool,exit:_propTypes.bool,fraction:_propTypes.number,refProp:_propTypes.string,innerRef:_propTypes.func,onReveal:_propTypes.func,unmountOnExit:_propTypes.bool,mountOnEnter:_propTypes.bool,inEffect:inOut.isRequired,outEffect:(0,_propTypes.oneOfType)([inOut,(0,_propTypes.oneOf)([!1])]).isRequired,ssrReveal:_propTypes.bool,collapseOnly:_propTypes.bool,ssrFadeout:_propTypes.bool},defaultProps={fraction:.2,refProp:"ref"},contextTypes={transitionGroup:_propTypes.object},RevealBase=function(e){function t(e,i){_classCallCheck(this,t);var s=_possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e,i));return s.isOn=void 0===e.when||!!e.when,s.state={collapse:e.collapse?t.getInitialCollapseStyle(e):void 0,style:{opacity:s.isOn&&!e.ssrReveal||!e.outEffect?void 0:0}},s.savedChild=!1,s.isShown=!1,_globals.observerMode?s.handleObserve=s.handleObserve.bind(s):(s.revealHandler=s.makeHandler(s.reveal),s.resizeHandler=s.makeHandler(s.resize)),s.saveRef=s.saveRef.bind(s),s}return _inherits(t,e),_createClass(t,[{key:"saveRef",value:function(e){this.childRef&&this.childRef(e),this.props.innerRef&&this.props.innerRef(e),this.el!==e&&(this.el=e&&"offsetHeight"in e?e:void 0,this.observe(this.props,!0))}},{key:"invisible",value:function(){this&&this.el&&(this.savedChild=!1,this.isShown||(this.setState({hasExited:!0,collapse:this.props.collapse?_extends({},this.state.collapse,{visibility:"hidden"}):null,style:{opacity:0}}),!_globals.observerMode&&this.props.collapse&&window.document.dispatchEvent(_globals.collapseend)))}},{key:"animationEnd",value:function(e,t,i){var s=this,o=i.forever,n=i.count,r=i.delay,a=i.duration;if(!o){var l=function(){s&&s.el&&(s.animationEndTimeout=void 0,e.call(s))};this.animationEndTimeout=window.setTimeout(l,r+(a+(t?a:0)*n))}}},{key:"getDimensionValue",value:function(){return this.el.offsetHeight+parseInt(window.getComputedStyle(this.el,null).getPropertyValue("margin-top"),10)+parseInt(window.getComputedStyle(this.el,null).getPropertyValue("margin-bottom"),10)}},{key:"collapse",value:function(e,t,i){var s=i.duration+(t.cascade?i.duration:0),o=this.isOn?this.getDimensionValue():0,n=void 0,r=void 0;if(t.collapseOnly)n=i.duration/3,r=i.delay;else{var a=s>>2,l=a>>1;n=a,r=i.delay+(this.isOn?0:s-a-l),e.style.animationDuration=s-a+(this.isOn?l:-l)+"ms",e.style.animationDelay=i.delay+(this.isOn?a-l:0)+"ms"}return e.collapse={height:o,transition:"height "+n+"ms ease "+r+"ms",overflow:t.collapseOnly?"hidden":void 0},e}},{key:"animate",value:function(e){if(this&&this.el&&(this.unlisten(),this.isShown!==this.isOn)){this.isShown=this.isOn;var t=!this.isOn&&e.outEffect,i=e[t?"outEffect":"inEffect"],s="style"in i&&i.style.animationName||void 0,o=void 0;e.collapseOnly?o={hasAppeared:!0,hasExited:!1,style:{opacity:1}}:((e.outEffect||this.isOn)&&i.make&&(s=i.make),o={hasAppeared:!0,hasExited:!1,collapse:void 0,style:_extends({},i.style,{animationDuration:i.duration+"ms",animationDelay:i.delay+"ms",animationIterationCount:i.forever?"infinite":i.count,opacity:1,animationName:s}),className:i.className}),this.setState(e.collapse?this.collapse(o,e,i):o),t?(this.savedChild=_react2.default.cloneElement(this.getChild()),this.animationEnd(this.invisible,e.cascade,i)):this.savedChild=!1,this.onReveal(e)}}},{key:"onReveal",value:function(e){e.onReveal&&this.isOn&&(this.onRevealTimeout&&(this.onRevealTimeout=window.clearTimeout(this.onRevealTimeout)),e.wait?this.onRevealTimeout=window.setTimeout(e.onReveal,e.wait):e.onReveal())}},{key:"componentWillUnmount",value:function(){this.unlisten(),_globals.ssr&&(0,_globals.disableSsr)()}},{key:"handleObserve",value:function(e,t){_slicedToArray(e,1)[0].intersectionRatio>0&&(t.disconnect(),this.observer=null,this.reveal(this.props,!0))}},{key:"observe",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(this.el&&_globals.observerMode){if(this.observer){if(!t)return;this.observer.disconnect()}else if(t)return;this.observer=new IntersectionObserver(this.handleObserve,{threshold:e.fraction}),this.observer.observe(this.el)}}},{key:"reveal",value:function(e){var t=this,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1];_globals.globalHide||(0,_globals.hideAll)(),this&&this.el&&(e||(e=this.props),_globals.ssr&&(0,_globals.disableSsr)(),this.isOn&&this.isShown&&void 0!==e.spy?(this.isShown=!1,this.setState({style:{}}),window.setTimeout(function(){return t.reveal(e)},200)):i||this.inViewport(e)||e.force?this.animate(e):_globals.observerMode?this.observe(e):this.listen())}},{key:"componentDidMount",value:function(){var e=this;if(this.el&&!this.props.disabled){this.props.collapseOnly||("make"in this.props.inEffect&&this.props.inEffect.make(!1,this.props),void 0!==this.props.when&&this.props.outEffect&&"make"in this.props.outEffect&&this.props.outEffect.make(!0,this.props));var i=this.context.transitionGroup,s=i&&!i.isMounting?!("enter"in this.props&&!1===this.props.enter):this.props.appear;return this.isOn&&((void 0!==this.props.when||void 0!==this.props.spy)&&!s||_globals.ssr&&!_globals.fadeOutEnabled&&!this.props.ssrFadeout&&this.props.outEffect&&!this.props.ssrReveal&&t.getTop(this.el)<window.pageYOffset+window.innerHeight)?(this.isShown=!0,this.setState({hasAppeared:!0,collapse:this.props.collapse?{height:this.getDimensionValue()}:this.state.collapse,style:{opacity:1}}),void this.onReveal(this.props)):_globals.ssr&&(_globals.fadeOutEnabled||this.props.ssrFadeout)&&this.props.outEffect&&t.getTop(this.el)<window.pageYOffset+window.innerHeight?(this.setState({style:{opacity:0,transition:"opacity 1000ms 1000ms"}}),void window.setTimeout(function(){return e.reveal(e.props,!0)},2e3)):void(this.isOn&&(this.props.force?this.animate(this.props):this.reveal(this.props)))}}},{key:"cascade",value:function(e){var t=this,i=void 0;i="string"==typeof e?e.split("").map(function(e,t){return _react2.default.createElement("span",{key:t,style:{display:"inline-block",whiteSpace:"pre"}},e)}):_react2.default.Children.toArray(e);var s=this.props[this.isOn||!this.props.outEffect?"inEffect":"outEffect"],o=s.duration,n=s.reverse,r=i.length,a=2*o;this.props.collapse&&(a=parseInt(this.state.style.animationDuration,10),o=a/2);var l=n?r:0;return i=i.map(function(e){return"object"===(void 0===e?"undefined":_typeof(e))&&e?_react2.default.cloneElement(e,{style:_extends({},e.props.style,t.state.style,{animationDuration:Math.round((0,_globals.cascade)(n?l--:l++,0,r,o,a))+"ms"})}):e})}},{key:"componentWillReceiveProps",value:function(e){if(void 0!==e.when&&(this.isOn=!!e.when),e.fraction!==this.props.fraction&&this.observe(e,!0),!this.isOn&&e.onExited&&"exit"in e&&!1===e.exit)return void e.onExited();e.disabled||(e.collapse&&!this.props.collapse&&(this.setState({style:{},collapse:t.getInitialCollapseStyle(e)}),this.isShown=!1),e.when===this.props.when&&e.spy===this.props.spy||this.reveal(e),this.onRevealTimeout&&!this.isOn&&(this.onRevealTimeout=window.clearTimeout(this.onRevealTimeout)))}},{key:"getChild",value:function(){if(this.savedChild&&!this.props.disabled)return this.savedChild;if("object"===_typeof(this.props.children)){var e=_react2.default.Children.only(this.props.children);return"type"in e&&"string"==typeof e.type||"ref"!==this.props.refProp?e:_react2.default.createElement("div",null,e)}return _react2.default.createElement("div",null,this.props.children)}},{key:"render",value:function(){var e=void 0;e=this.state.hasAppeared?!this.props.unmountOnExit||!this.state.hasExited||this.isOn:!this.props.mountOnEnter||this.isOn;var t=this.getChild();"function"==typeof t.ref&&(this.childRef=t.ref);var i=!1,s=t.props,o=s.style,n=s.className,r=s.children,a=this.props.disabled?n:(this.props.outEffect?_globals.namespace:"")+(this.state.className?" "+this.state.className:"")+(n?" "+n:"")||void 0,l=void 0;"function"==typeof this.state.style.animationName&&(this.state.style.animationName=this.state.style.animationName(!this.isOn,this.props)),this.props.cascade&&!this.props.disabled&&r&&this.state.style.animationName?(i=this.cascade(r),l=_extends({},o,{opacity:1})):l=this.props.disabled?o:_extends({},o,this.state.style);var p=_extends({},this.props.props,_defineProperty({className:a,style:l},this.props.refProp,this.saveRef)),h=_react2.default.cloneElement(t,p,e?i||r:void 0);return void 0!==this.props.collapse?this.props.collapseEl?_react2.default.cloneElement(this.props.collapseEl,{style:_extends({},this.props.collapseEl.style,this.props.disabled?void 0:this.state.collapse),children:h}):_react2.default.createElement("div",{style:this.props.disabled?void 0:this.state.collapse,children:h}):h}},{key:"makeHandler",value:function(e){var t=this,i=function(){e.call(t,t.props),t.ticking=!1};return function(){t.ticking||((0,_globals.raf)(i),t.ticking=!0)}}},{key:"inViewport",value:function(e){if(!this.el||window.document.hidden)return!1;var i=this.el.offsetHeight,s=window.pageYOffset-t.getTop(this.el),o=Math.min(i,window.innerHeight)*(_globals.globalHide?e.fraction:0);return s>o-window.innerHeight&&s<i-o}},{key:"resize",value:function(e){this&&this.el&&this.isOn&&this.inViewport(e)&&(this.unlisten(),this.isShown=this.isOn,this.setState({hasExited:!this.isOn,hasAppeared:!0,collapse:void 0,style:{opacity:this.isOn||!e.outEffect?1:0}}),this.onReveal(e))}},{key:"listen",value:function(){_globals.observerMode||this.isListener||(this.isListener=!0,window.addEventListener("scroll",this.revealHandler,{passive:!0}),window.addEventListener("orientationchange",this.revealHandler,{passive:!0}),window.document.addEventListener("visibilitychange",this.revealHandler,{passive:!0}),window.document.addEventListener("collapseend",this.revealHandler,{passive:!0}),window.addEventListener("resize",this.resizeHandler,{passive:!0}))}},{key:"unlisten",value:function(){!_globals.observerMode&&this.isListener&&(window.removeEventListener("scroll",this.revealHandler,{passive:!0}),window.removeEventListener("orientationchange",this.revealHandler,{passive:!0}),window.document.removeEventListener("visibilitychange",this.revealHandler,{passive:!0}),window.document.removeEventListener("collapseend",this.revealHandler,{passive:!0}),window.removeEventListener("resize",this.resizeHandler,{passive:!0}),this.isListener=!1),this.onRevealTimeout&&(this.onRevealTimeout=window.clearTimeout(this.onRevealTimeout)),this.animationEndTimeout&&(this.animationEndTimeout=window.clearTimeout(this.animationEndTimeout))}}],[{key:"getInitialCollapseStyle",value:function(e){return{height:0,visibility:e.when?void 0:"hidden"}}},{key:"getTop",value:function(e){for(;void 0===e.offsetTop;)e=e.parentNode;for(var t=e.offsetTop;e.offsetParent;t+=e.offsetTop)e=e.offsetParent;return t}}]),t}(_react2.default.Component);RevealBase.propTypes=propTypes,RevealBase.defaultProps=defaultProps,RevealBase.contextTypes=contextTypes,RevealBase.displayName="RevealBase",exports.default=RevealBase,module.exports=exports.default;

/***/ }),
/* 1906 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_Admin_css__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_Admin_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_admin_Admin_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuildingSelection_css__ = __webpack_require__(1908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuildingSelection_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BuildingSelection_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_checkbox_CheckBox__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_creation_buildings__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_creation_buildings__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_navigation_SearchBar__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_selectors_admin_work_orders_creation_clients__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_creation_creation__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_services_utils_permissions_util__ = __webpack_require__(182);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BuildingSelection=function(_Component){_inherits(BuildingSelection,_Component);function BuildingSelection(props){_classCallCheck(this,BuildingSelection);// If user is admin, check if a client is selected, otherwise route to client selection
var _this=_possibleConstructorReturn(this,(BuildingSelection.__proto__||Object.getPrototypeOf(BuildingSelection)).call(this,props));_this.handleCheckboxChange=function(buildingId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_creation_buildings__["b" /* createWorkOrderRequest */])(buildingId,_this.props.currentWorkOrder,_this.props.selectedClientId!==null?_this.props.selectedClientId:undefined));};_this.handleAddBuilding=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_creation_buildings__["d" /* goToNewBuilding */])());};_this.mapBuildings=function(buildings){return buildings.map(function(element){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_checkbox_CheckBox__["a" /* default */],{id:element.id,checked:element.id===_this.props.selectedBuildingId,shape:'round',size:'medium',onChange:_this.handleCheckboxChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},element.location.street_address_1+', '+element.location.city+', '+element.location.state+' '+element.location.zip),element.name!==''&&element.name!==null?element.name:'N/A'];});};if((__WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__["g" /* usersUtil */].hasRole(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR))&&_this.props.selectedClientId===null){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_creation_creation__["b" /* goToClientSelection */])());}return _this;}_createClass(BuildingSelection,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.currentWorkOrder!==null){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_creation_buildings__["h" /* selectBuilding */])(this.props.currentWorkOrder.building.id));}this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_creation_buildings__["e" /* loadBuildingsRequest */])(this.props.selectedClientId!==null?this.props.selectedClientId:undefined));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'building-selection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['WORK ORDERS',this.props.currentWorkOrder===null?'CREATE NEW':'WO #'+this.props.currentWorkOrder.number]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_navigation_SearchBar__["a" /* default */],{addButton:__WEBPACK_IMPORTED_MODULE_15_services_utils_permissions_util__["a" /* PermissionsUtil */].canCreateBuilding(this.props.currentUser)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange button-add-work-order',type:'button',value:'Add Building',onClick:this.handleAddBuilding}):null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'navbar-text'},'Which Property is the Work Order for?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__["a" /* default */],{headers:['','ADDRESS','BUILDING NAME'],rows:this.mapBuildings(this.props.buildings),emptyMessage:'No Buildings'})));}}]);return BuildingSelection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_14_selectors_authentication__["d" /* getCurrentUser */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),buildings:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_work_orders__["a" /* getBuildings */])(state),selectedBuildingId:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_creation_buildings__["c" /* getSelectedBuildingId */])(state),selectedClientId:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_admin_work_orders_creation_clients__["b" /* getSelectedClientId */])(state)};})(BuildingSelection));

/***/ }),
/* 1908 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubContractorsUnionTrades_css__ = __webpack_require__(1910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubContractorsUnionTrades_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SubContractorsUnionTrades_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubContractorsList__ = __webpack_require__(1911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubContractorsForm__ = __webpack_require__(1914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_left_arrow_png__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_left_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_left_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectors_admin_work_orders_creation_sub_contractors_union_trades__ = __webpack_require__(1916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_sub_contractors_union_trades__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_admin_work_orders_creation_creation__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CancelWorkOrder__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__selectors_admin_work_orders_creation_creation__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_utils_scroller_util__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubContractorsUnionTrades=function(_Component){_inherits(SubContractorsUnionTrades,_Component);function SubContractorsUnionTrades(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SubContractorsUnionTrades);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SubContractorsUnionTrades.__proto__||Object.getPrototypeOf(SubContractorsUnionTrades)).call.apply(_ref,[this].concat(args))),_this),_this.handleSubContractorSelection=function(contractorId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_sub_contractors_union_trades__["k" /* selectSubContractor */])(contractorId));},_this.handleAddSubContractor=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_sub_contractors_union_trades__["a" /* addSubContractor */])());},_this.handleRemoveSubContractor=function(id){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_sub_contractors_union_trades__["j" /* removeSubContractor */])(id));},_this.handleQuestionResponse=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_sub_contractors_union_trades__["b" /* answerQuestion */])(value));},_this.handleFormCancel=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_sub_contractors_union_trades__["c" /* cancelAddSubContractor */])());},_this.handleFormChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_sub_contractors_union_trades__["f" /* formValueChange */])(attribute,value));},_this.handleFormSubmit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_sub_contractors_union_trades__["e" /* createSubContractorRequest */])(_this.props.newSubContractor));},_this.handleContinue=function(){var promise=_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_sub_contractors_union_trades__["d" /* confirmSubContractorsUnionTradesRequest */])(_this.props.currentWorkOrder.id,_this.props.selectedSubContractorsId.map(function(element){return element;}),_this.props.subContractorAnswer,_this.props.selectedUnionTradesId,_this.props.dontKnowUnions,_this.props.noUnions,_this.props.newWOProcessStarted));if(promise!==null){promise.then(function(response){if(response.ok){Object(__WEBPACK_IMPORTED_MODULE_15__services_utils_scroller_util__["c" /* simpleScrollToTop */])();}});}},_this.handleBackArrow=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_admin_work_orders_work_orders__["g" /* goHistoryBack */])());},_this.handleCancelOrder=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_admin_work_orders_creation_creation__["g" /* showWOCancellationModal */])());},_this.handleUnionTradesSelection=function(unionTradeId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_sub_contractors_union_trades__["l" /* selectUnionTrade */])(unionTradeId,_this.props.selectedUnionTradesId,_this.props.unionTrades));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SubContractorsUnionTrades,[{key:'componentDidMount',value:function componentDidMount(){var currentSubContractorsId=[];var currentUnionTradesId=[];var dontKnowSubContractor=false;var dontKnowUnions=false;if(this.props.currentWorkOrder!==null){currentSubContractorsId=this.props.currentWorkOrder.propietary_sub_contractors.map(function(element){return element.id;});currentUnionTradesId=this.props.currentWorkOrder.unions.map(function(element){return element.id;});dontKnowSubContractor=this.props.currentWorkOrder.dont_know_subcons;dontKnowUnions=this.props.currentWorkOrder.dont_know_unions;}this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_sub_contractors_union_trades__["g" /* initializeComponentAppState */])(currentSubContractorsId,dontKnowSubContractor,dontKnowUnions));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_sub_contractors_union_trades__["h" /* loadContractorsRequest */])(currentSubContractorsId,this.props.tasks.map(function(task){return task.trade.id;})));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_admin_work_orders_creation_sub_contractors_union_trades__["i" /* loadUnionTradesRequest */])(currentUnionTradesId));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sub-contractors'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_route_title_RouteTitle__["a" /* default */],{titles:['WORK ORDERS','WO #'+this.props.currentWorkOrder.number]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Work Order #',this.props.currentWorkOrder.number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{md:8,className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},!this.props.showNewContractor?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contractors-union-trades'},/* Only show back button if WO is under creation */this.props.newWOProcessStarted&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-back-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__images_left_arrow_png___default.a,alt:'left-arrow',onClick:this.handleBackArrow})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SubContractorsList__["a" /* default */],{subContractorAnswer:this.props.subContractorAnswer,subContractors:this.props.subContractors,selectedSubContractorsId:this.props.selectedSubContractorsId,validationError:this.props.validationError,onAddSubContractor:this.handleAddSubContractor,onQuestionResponse:this.handleQuestionResponse,onRemoveSubContractor:this.handleRemoveSubContractor,onSubContractorSelection:this.handleSubContractorSelection}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',value:'Continue',type:'button',onClick:this.handleContinue}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-white',value:'Cancel Order',type:'button',onClick:this.handleCancelOrder}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SubContractorsForm__["a" /* default */],{data:this.props.newSubContractor,validationError:this.props.validationError,onCancel:this.handleFormCancel,onFormChange:this.handleFormChange,onFormSubmit:this.handleFormSubmit}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__CancelWorkOrder__["a" /* default */],null));}}]);return SubContractorsUnionTrades;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_11__selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),dontKnowUnions:Object(__WEBPACK_IMPORTED_MODULE_9__selectors_admin_work_orders_creation_sub_contractors_union_trades__["a" /* getDontKnowUnions */])(state),noUnions:Object(__WEBPACK_IMPORTED_MODULE_9__selectors_admin_work_orders_creation_sub_contractors_union_trades__["c" /* getNoUnions */])(state),newSubContractor:Object(__WEBPACK_IMPORTED_MODULE_9__selectors_admin_work_orders_creation_sub_contractors_union_trades__["b" /* getNewSubContractor */])(state),newWOProcessStarted:Object(__WEBPACK_IMPORTED_MODULE_14__selectors_admin_work_orders_creation_creation__["a" /* getNewWOProcessStarted */])(state),subContractorAnswer:Object(__WEBPACK_IMPORTED_MODULE_9__selectors_admin_work_orders_creation_sub_contractors_union_trades__["g" /* getSubContractorAnswer */])(state),subContractors:Object(__WEBPACK_IMPORTED_MODULE_11__selectors_admin_work_orders_work_orders__["b" /* getContractors */])(state),selectedSubContractorsId:Object(__WEBPACK_IMPORTED_MODULE_9__selectors_admin_work_orders_creation_sub_contractors_union_trades__["d" /* getSelectedSubContractorsId */])(state),selectedUnionTradesId:Object(__WEBPACK_IMPORTED_MODULE_9__selectors_admin_work_orders_creation_sub_contractors_union_trades__["e" /* getSelectedUnionTradesId */])(state),showNewContractor:Object(__WEBPACK_IMPORTED_MODULE_9__selectors_admin_work_orders_creation_sub_contractors_union_trades__["f" /* getShowNewContractor */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_11__selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state),unionTrades:Object(__WEBPACK_IMPORTED_MODULE_11__selectors_admin_work_orders_work_orders__["k" /* getUnionTrades */])(state),validationError:Object(__WEBPACK_IMPORTED_MODULE_9__selectors_admin_work_orders_creation_sub_contractors_union_trades__["i" /* getValidationError */])(state),unionTradesValidationError:Object(__WEBPACK_IMPORTED_MODULE_9__selectors_admin_work_orders_creation_sub_contractors_union_trades__["h" /* getUnionTradesValidationError */])(state)};})(SubContractorsUnionTrades));

/***/ }),
/* 1910 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_plus_icon_png__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_plus_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_plus_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubContractorsList_css__ = __webpack_require__(1912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubContractorsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SubContractorsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_button_SimpleButton__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_radio_button_RadioButton__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubContractorsList=function(_Component){_inherits(SubContractorsList,_Component);function SubContractorsList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SubContractorsList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SubContractorsList.__proto__||Object.getPrototypeOf(SubContractorsList)).call.apply(_ref,[this].concat(args))),_this),_this.handleSubContractorSelection=function(newOption){_this.props.onSubContractorSelection(newOption.value);},_this.handleAddSubContractor=function(){_this.props.onAddSubContractor();},_this.handleRemove=function(event,id){event.preventDefault();_this.props.onRemoveSubContractor(id);},_this.handleQuestion=function(value){_this.props.onQuestionResponse(value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SubContractorsList,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sub-contractors-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Subcontractors'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Do you or your building require any proprietary subcontractors?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_radio_button_RadioButton__["a" /* default */],{options:[{value:'yes',label:'Yes'},{value:'no',label:'No'},{value:'dont-know',label:"I don't know"}],orientation:'vertical',value:this.props.subContractorAnswer,onChange:this.handleQuestion}),this.props.validationError!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},this.props.validationError)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selection-container'},this.props.subContractorAnswer==='yes'&&this.getContent())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["c" /* Clearfix */],null));}},{key:'getContent',value:function getContent(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.selectedSubContractorsId.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.props.subContractors.filter(function(element){// Return contractors selected
var index=_this2.props.selectedSubContractorsId.find(function(selected){return selected===element.id;});return index>-1;}).sort(function(a,b){if(a.name>b.name){return 1;}if(a.name<b.name){return-1;}return 0;}).map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__images_remove_png___default.a,alt:'remove',onClick:function onClick(event){return _this2.handleRemove(event,element.id);}}));})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_dropdown_Dropdown__["a" /* default */],{className:'sub-contractors-dropdown',options:this.props.subContractors.filter(function(element){// Show elements not selected
var index=_this2.props.selectedSubContractorsId.findIndex(function(selected){return selected===element.id;});return index===-1;}).sort(function(a,b){if(a.name>b.name){return 1;}if(a.name<b.name){return-1;}return 0;}).map(function(element){return{value:element.id,label:element.name};}),placeholder:'Select from list',onChange:this.handleSubContractorSelection}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'OR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_button_SimpleButton__["a" /* default */],{className:'sub-contractor-button',img:__WEBPACK_IMPORTED_MODULE_2__images_plus_icon_png___default.a,label:'Add Additional Subcontractor',onClick:this.handleAddSubContractor}));}}]);return SubContractorsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubContractorsList.propTypes={subContractorAnswer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,subContractors:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,selectedSubContractorsId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number).isRequired,validationError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onAddSubContractor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onQuestionResponse:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onRemoveSubContractor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSubContractorSelection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (SubContractorsList);

/***/ }),
/* 1912 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1913 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubContractorsForm_css__ = __webpack_require__(1915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubContractorsForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SubContractorsForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_left_arrow_png__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_left_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_left_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_input_Input__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubContractorsForm=function(_Component){_inherits(SubContractorsForm,_Component);function SubContractorsForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SubContractorsForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SubContractorsForm.__proto__||Object.getPrototypeOf(SubContractorsForm)).call.apply(_ref,[this].concat(args))),_this),_this.handleBackArrow=function(){_this.props.onCancel();},_this.handleCancel=function(){_this.props.onCancel();},_this.handleChange=function(attribute,value){_this.props.onFormChange(attribute,value);},_this.handleSubmit=function(event){event.preventDefault();_this.props.onFormSubmit();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SubContractorsForm,[{key:'isValid',value:function isValid(){var _this2=this;return Object.keys(this.props.data).map(function(key){return _this2.props.data[key].valid;}).reduce(function(lastValue,currentValue){return lastValue&&currentValue;},false);}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sub-contractors-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__images_left_arrow_png___default.a,alt:'left-arrow',onClick:this.handleBackArrow})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Add Subcontractor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_input_Input__["a" /* default */],{placeholder:'Sub-Contractor Name',valid:this.props.data.subContractorName.valid,value:this.props.data.subContractorName.value,onChange:function onChange(value){return _this3.handleChange('subContractorName',value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_input_Input__["a" /* default */],{placeholder:'Phone Number',valid:this.props.data.phoneNumber.valid,value:this.props.data.phoneNumber.value,onChange:function onChange(value){return _this3.handleChange('phoneNumber',value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_input_Input__["a" /* default */],{placeholder:'Street Address',valid:this.props.data.streetAddress.valid,value:this.props.data.streetAddress.value,onChange:function onChange(value){return _this3.handleChange('streetAddress',value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_input_Input__["a" /* default */],{placeholder:'Unit number / Floor',valid:this.props.data.unitNumberFloor.valid,value:this.props.data.unitNumberFloor.value,onChange:function onChange(value){return _this3.handleChange('unitNumberFloor',value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_input_Input__["a" /* default */],{placeholder:'City',valid:this.props.data.city.valid,value:this.props.data.city.value,onChange:function onChange(value){return _this3.handleChange('city',value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{md:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_input_Input__["a" /* default */],{className:'state-input',placeholder:'State',valid:this.props.data.state.valid,value:this.props.data.state.value,onChange:function onChange(value){return _this3.handleChange('state',value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_input_Input__["a" /* default */],{placeholder:'Zip Code',valid:this.props.data.zipCode.valid,value:this.props.data.zipCode.value,onChange:function onChange(value){return _this3.handleChange('zipCode',value);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_input_Input__["a" /* default */],{placeholder:'Contact First Name',valid:this.props.data.contactFirstName.valid,value:this.props.data.contactFirstName.value,onChange:function onChange(value){return _this3.handleChange('contactFirstName',value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_input_Input__["a" /* default */],{placeholder:'Contact Last Name',valid:this.props.data.contactLastName.valid,value:this.props.data.contactLastName.value,onChange:function onChange(value){return _this3.handleChange('contactLastName',value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_input_Input__["a" /* default */],{placeholder:'Email',valid:this.props.data.email.valid,value:this.props.data.email.value,onChange:function onChange(value){return _this3.handleChange('email',value);}}))),!this.isValid()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},this.props.validationError):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',value:'Submit Request',type:'submit'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-white',value:'Cancel',type:'button',onClick:this.handleCancel}))));}}]);return SubContractorsForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubContractorsForm.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({subContractorName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,valid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}),phoneNumber:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,valid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}),streetAddress:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,valid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}),unitNumberFloor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,valid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}),city:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,valid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}),state:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,valid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}),zipCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,valid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}),contactFirstName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,valid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}),contactLastName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,valid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}),email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,valid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool})}),validationError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onFormChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onFormSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (SubContractorsForm);

/***/ }),
/* 1915 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getNewSubContractor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getSubContractorAnswer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSelectedSubContractorsId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getShowNewContractor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getValidationError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSelectedUnionTradesId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDontKnowUnions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getNoUnions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getUnionTradesValidationError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getNewSubContractor=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.subContractorsUnionTrades.data.newSubContractor;},function(newSubContractor){return newSubContractor;});var getSubContractorAnswer=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.subContractorsUnionTrades.ui.subContractorAnswer;},function(subContractorAnswer){return subContractorAnswer;});var getSelectedSubContractorsId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.subContractorsUnionTrades.data.selectedSubContractorsId;},function(selectedSubContractorsId){return selectedSubContractorsId;});var getShowNewContractor=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.subContractorsUnionTrades.ui.showNewContractor;},function(showNewContractor){return showNewContractor;});var getValidationError=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.subContractorsUnionTrades.ui.validationError;},function(validationError){return validationError;});var getSelectedUnionTradesId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.subContractorsUnionTrades.data.selectedUnionTradesId;},function(selectedUnionTradesId){return selectedUnionTradesId;});var getDontKnowUnions=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.subContractorsUnionTrades.ui.dontKnowUnions;},function(dontKnowUnions){return dontKnowUnions;});var getNoUnions=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.subContractorsUnionTrades.ui.noUnions;},function(noUnions){return noUnions;});var getUnionTradesValidationError=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.creation.scenes.subContractorsUnionTrades.ui.unionTradesValidationError;},function(unionTradesValidationError){return unionTradesValidationError;});

/***/ }),
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkOrderDetails_css__ = __webpack_require__(1918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkOrderDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__WorkOrderDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DetailsTasks__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DetailsQuotes__ = __webpack_require__(2158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DetailsMembers__ = __webpack_require__(2193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_actions_admin_work_orders_details_members__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DetailsOpenItems__ = __webpack_require__(2200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_selectors_admin_work_orders_details_proposal_approval__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__proposals_ProposalApprovalModal__ = __webpack_require__(2202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_admin_work_orders_details_WorkOrderValueEditor__ = __webpack_require__(2214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_domain_work_order__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_admin_work_orders_details_budget_DetailsBudget__ = __webpack_require__(2216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_services_utils_permissions_util__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_domain_proposal_status_enum__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_admin_work_orders_details_purchase_order_DetailsPurchaseOrder__ = __webpack_require__(2225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_admin_work_orders_details_budget_BudgetApproveReviewModal__ = __webpack_require__(2231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_admin_work_orders_details_contractors_invoices_DetailsContractorsInvoices__ = __webpack_require__(2233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_admin_work_orders_details_contractors_lien_releases_DetailsContractorsLienReleases__ = __webpack_require__(2237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_admin_work_orders_details_contractors_lien_releases_DetailsContractorsLienReleasesTable__ = __webpack_require__(2241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_components_admin_work_orders_details_receipts_ReceiptsTable__ = __webpack_require__(2243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_admin_work_orders_details_time_TimeTable__ = __webpack_require__(2250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_components_admin_work_orders_details_schedule_DetailsSchedule__ = __webpack_require__(2256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_components_admin_work_orders_details_time_store_selectors__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_components_admin_work_orders_details_vendor_invoices_store_selectors__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_components_admin_work_orders_details_vendor_invoices_VendorInvoicesDetails__ = __webpack_require__(2275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_components_admin_work_orders_details_WorkOrderDetailsHeader__ = __webpack_require__(2280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_components_admin_work_orders_details_WorkOrderDetailsInfo__ = __webpack_require__(2289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_components_admin_work_orders_details_transfer_TransferWorkOrder__ = __webpack_require__(2295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_components_admin_work_orders_details_receipts_store_selectors__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_components_admin_work_orders_details_anticipated_cost_report_AnticipatedCostReport__ = __webpack_require__(2303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_components_admin_work_orders_details_change_order_tasks_store_actions__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_components_admin_work_orders_details_change_orders_store_actions__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_components_admin_work_orders_details_change_orders_ChangeOrderApprovalModal__ = __webpack_require__(2309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_components_admin_work_orders_details_change_orders_store_selectors__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_components_admin_work_orders_details_work_order_authorizations_WorkOrderAuthorizations__ = __webpack_require__(2313);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WorkOrderDetails=function(_Component){_inherits(WorkOrderDetails,_Component);function WorkOrderDetails(props){_classCallCheck(this,WorkOrderDetails);var _this=_possibleConstructorReturn(this,(WorkOrderDetails.__proto__||Object.getPrototypeOf(WorkOrderDetails)).call(this,props));_this.handleNavigationItemSelect=function(value){Object(__WEBPACK_IMPORTED_MODULE_17_services_utils_scroller_util__["c" /* simpleScrollToTop */])();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["W" /* selectNavigationBar */])(_this.props.currentWorkOrder.id,value));};_this.handleAddMember=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_actions_admin_work_orders_details_members__["c" /* setShowAddMemberModalRequest */])());};_this.handleWorkOrderJobNumberChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["j" /* changeWorkOrderJobNumber */])(value));};_this.handleWorkOrderJobNumberEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["x" /* editWorkOrderJobNumber */])(true));};_this.handleWorkOrderJobNumberSave=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["S" /* saveWorkOrderJobNumber */])(_this.props.currentWorkOrder.id,_this.props.workOrderJobNumberValue,_this.props.currentWorkOrder.work_order_job));};_this.handleWorkOrderNameChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["k" /* changeWorkOrderName */])(value));};_this.handleWorkOrderNameEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["y" /* editWorkOrderName */])(true));};_this.handleWorkOrderNameSave=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["T" /* saveWorkOrderNameRequest */])(_this.props.currentWorkOrder.id,_this.props.workOrderNameValue));};_this.userIsAdmin=__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["g" /* usersUtil */].isAdmin(_this.props.user)||__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.user,__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);_this.userIsSpackleAdmin=__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["g" /* usersUtil */].hasRole(_this.props.user,__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.user,__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);_this.userIsContractor=__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.user,__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);_this.userIsClient=__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.user,__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["f" /* TYPES */].CLIENT);_this.userIsGc=__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.user,__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);_this.contractorUserCanSeeMoney=__WEBPACK_IMPORTED_MODULE_23_services_utils_permissions_util__["a" /* PermissionsUtil */].contractorUserCanSeeMoney(_this.props.user);_this.adminUserCanSeeMoney=__WEBPACK_IMPORTED_MODULE_23_services_utils_permissions_util__["a" /* PermissionsUtil */].adminUserCanSeeMoney(_this.props.user)||__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.user,__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);return _this;}_createClass(WorkOrderDetails,[{key:'initializeComponent',value:function initializeComponent(){var _this2=this;this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["C" /* initializeComponentAppState */])());this.workOrderId=__WEBPACK_IMPORTED_MODULE_13_numeral___default()(this.props.match.params.woId).value();this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["L" /* loadWorkOrderRequest */])(this.workOrderId,this.userIsAdmin,this.userIsContractor,this.contractorUserCanSeeMoney)).then(function(response){if(response.ok){// If work order is loaded, load task and members (if possible)
_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["_2" /* setCurrentWorkOrder */])(_this2.props.currentWorkOrder));// Load task
if(_this2.props.match.params.hasOwnProperty('taskId')){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["J" /* loadTradesRequest */])());_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["Z" /* selectTaskRequest */])(_this2.workOrderId,_this2.props.match.params.taskId,_this2.props.user));}// Load members
if(WorkOrderDetails.showMembers(response.workOrder.status,_this2.props.user)){// At this point current user is a contractor
_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["D" /* loadMembersRequest */])(response.workOrder.id));}}});this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["E" /* loadQuotesRequest */])(this.workOrderId));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_41_components_admin_work_orders_details_change_order_tasks_store_actions__["d" /* loadChangeOrderTasksRequest */])(this.workOrderId));if(this.userIsAdmin||this.userIsClient){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_42_components_admin_work_orders_details_change_orders_store_actions__["j" /* loadChangeOrdersRequest */])(this.workOrderId));}}},{key:'componentDidMount',value:function componentDidMount(){this.initializeComponent();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.match.params.woId!==this.props.match.params.woId){// This happens if on one WO, another one is opened (so, we should refresh everything)
this.initializeComponent();}}},{key:'render',value:function render(){// Only render if the current loaded WO is the one specified in the route
var showContent=this.props.currentWorkOrder!==null&&this.props.currentWorkOrder.id===this.workOrderId;var workOrderTitle='';if(showContent){workOrderTitle='WO #'+this.props.currentWorkOrder.number;if(this.props.currentWorkOrder.name!==null){workOrderTitle+=': '+this.props.currentWorkOrder.name;}}return showContent&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'work-order-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['WORK ORDERS',workOrderTitle]}),this.showTransfer()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38_components_admin_work_orders_details_transfer_TransferWorkOrder__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36_components_admin_work_orders_details_WorkOrderDetailsHeader__["a" /* default */],null),this.userIsAdmin&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'work-order-value-editor-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_admin_work_orders_details_WorkOrderValueEditor__["a" /* default */],{canEdit:this.userIsSpackleAdmin,edit:this.props.workOrderNameEdit,label:'name',saving:this.props.workOrderNameSaving,value:this.props.workOrderNameValue,onEdit:this.handleWorkOrderNameEdit,onSave:this.handleWorkOrderNameSave,onValueChange:this.handleWorkOrderNameChange}))),this.showJobNumber(this.props.currentWorkOrder)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'work-order-value-editor-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_admin_work_orders_details_WorkOrderValueEditor__["a" /* default */],{edit:this.props.workOrderJobNumberEdit,label:'job reference',saving:this.props.workOrderJobNumberSaving,value:this.props.workOrderJobNumberValue,onEdit:this.handleWorkOrderJobNumberEdit,onSave:this.handleWorkOrderJobNumberSave,onValueChange:this.handleWorkOrderJobNumberChange}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37_components_admin_work_orders_details_WorkOrderDetailsInfo__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'Tasks',total:this.props.tasks.length},{id:5,show:this.showBudgetTab(),title:'Preliminary Estimate',total:this.props.budget!==null?1:0},{id:2,show:__WEBPACK_IMPORTED_MODULE_23_services_utils_permissions_util__["a" /* PermissionsUtil */].adminUserCanSeeMoney(this.props.user)||this.userIsClient||this.userIsGc,title:'Quotes',total:this.userIsClient?this.props.proposals.length:this.props.quotes.length},{id:14,show:this.showAcrTab(),title:'ACR',total:1},{id:6,show:this.showPurchaseOrderTab(),title:'Purchase Order',total:__WEBPACK_IMPORTED_MODULE_21_domain_work_order__["a" /* WorkOrder */].hasPurchaseOrder(this.props.currentWorkOrder)?1:0},{id:3,show:WorkOrderDetails.showMembers(this.props.currentWorkOrder.status,this.props.user),title:'Members',total:this.props.members.length},{id:4,show:this.showOpenItems(),title:'Open Items',total:this.props.openItemsByTaskId!==null?Object.values(this.props.openItemsByTaskId).reduce(function(accumulator,currentValue){return accumulator.concat(currentValue);},[]).filter(function(openItem){return!openItem.resolved;}).length:0},{id:13,show:this.showScheduleTab(),title:'Schedule',total:1},{id:8,show:this.showContractorLienRelease(this.props.contractorInvoice),title:'Unconditional Lien Release',total:this.props.contractorLienRelease!==null?1:0},{id:9,show:this.showContractorLienReleasesTable(this.props.currentWorkOrder),title:'Unconditional Lien Releases',total:this.props.contractorLienReleases.length},{id:10,show:this.showReceiptsTable(),title:'Materials',total:this.props.receipts.length},{id:11,show:this.showTimeTable(),title:'Time',total:this.props.time.length},{id:12,show:this.showVendorInvoices(),title:'Vendors',total:this.props.vendorInvoices.length},{id:15,show:this.props.workOrderAuthorizations.length>0,title:'WOAs',total:this.props.workOrderAuthorizations.length},{id:7,show:this.showContractorInvoice(),title:'Spackle Invoice',total:this.props.contractorInvoice!==null?1:0}],onSelected:this.handleNavigationItemSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'})),this.props.navigationBarSelectedItem===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__DetailsTasks__["a" /* default */],null),this.props.navigationBarSelectedItem===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__DetailsQuotes__["a" /* default */],null),this.props.navigationBarSelectedItem===3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__DetailsMembers__["a" /* default */],null),this.props.navigationBarSelectedItem===4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__DetailsOpenItems__["a" /* default */],null),this.props.navigationBarSelectedItem===5&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_admin_work_orders_details_budget_DetailsBudget__["a" /* default */],null),this.props.navigationBarSelectedItem===6&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_components_admin_work_orders_details_purchase_order_DetailsPurchaseOrder__["a" /* default */],null),this.props.navigationBarSelectedItem===7&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_components_admin_work_orders_details_contractors_invoices_DetailsContractorsInvoices__["a" /* default */],null),this.props.navigationBarSelectedItem===8&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_components_admin_work_orders_details_contractors_lien_releases_DetailsContractorsLienReleases__["a" /* default */],null),this.props.navigationBarSelectedItem===9&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_components_admin_work_orders_details_contractors_lien_releases_DetailsContractorsLienReleasesTable__["a" /* default */],null),this.props.navigationBarSelectedItem===10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_components_admin_work_orders_details_receipts_ReceiptsTable__["a" /* default */],null),this.props.navigationBarSelectedItem===11&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_components_admin_work_orders_details_time_TimeTable__["a" /* default */],null),this.props.navigationBarSelectedItem===12&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35_components_admin_work_orders_details_vendor_invoices_VendorInvoicesDetails__["a" /* default */],null),this.props.navigationBarSelectedItem===13&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32_components_admin_work_orders_details_schedule_DetailsSchedule__["a" /* default */],null),this.props.navigationBarSelectedItem===14&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_components_admin_work_orders_details_anticipated_cost_report_AnticipatedCostReport__["a" /* default */],null),this.props.navigationBarSelectedItem===15&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45_components_admin_work_orders_details_work_order_authorizations_WorkOrderAuthorizations__["a" /* default */],null),this.props.navigationBarSelectedItem===3&&!__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].COMPLETE.equals(__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(this.props.currentWorkOrder.status))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange btn-add-member',type:'button',value:'Add Member',onClick:this.handleAddMember}))),this.props.selectedProposalId!==null&&this.props.proposals.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__proposals_ProposalApprovalModal__["a" /* default */],null),this.props.selectedChangeOrderId!==null&&this.props.changeOrders.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43_components_admin_work_orders_details_change_orders_ChangeOrderApprovalModal__["a" /* default */],null),this.props.budget!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_admin_work_orders_details_budget_BudgetApproveReviewModal__["a" /* default */],null));}},{key:'showContractorInvoice',value:function showContractorInvoice(){var statusEnum=__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(this.props.currentWorkOrder.status);return this.contractorUserCanSeeMoney&&(__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].IN_PROGRESS.equals(statusEnum)||__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].COMPLETE.equals(statusEnum)||__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].CLOSED.equals(statusEnum));}},{key:'showContractorLienRelease',value:function showContractorLienRelease(contractorInvoice){// Contractor invoice is paid
return this.contractorUserCanSeeMoney&&contractorInvoice!==null&&contractorInvoice.status==='paid';}},{key:'showContractorLienReleasesTable',value:function showContractorLienReleasesTable(workOrder){var statusEnum=__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(workOrder.status);return this.userIsAdmin&&(__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].COMPLETE.equals(statusEnum)||__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].CLOSED.equals(statusEnum));}},{key:'showJobNumber',value:function showJobNumber(workOrder){return this.userIsContractor&&__WEBPACK_IMPORTED_MODULE_21_domain_work_order__["a" /* WorkOrder */].isStatusFulFilled(workOrder,__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].IN_PROGRESS);}},{key:'showOpenItems',value:function showOpenItems(){var statusEnum=__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(this.props.currentWorkOrder.status);return(__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].IN_PROGRESS.equals(statusEnum)||__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].COMPLETE.equals(statusEnum)||__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].CLOSED.equals(statusEnum))&&(this.userIsAdmin||this.userIsContractor);}},{key:'showScheduleTab',value:function showScheduleTab(){var statusEnum=__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(this.props.currentWorkOrder.status);return(__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].IN_PROGRESS.equals(statusEnum)||__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].COMPLETE.equals(statusEnum))&&this.userIsAdmin;}},{key:'showAcrTab',value:function showAcrTab(){var statusEnum=__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(this.props.currentWorkOrder.status);return(__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].IN_PROGRESS.equals(statusEnum)||__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].COMPLETE.equals(statusEnum))&&this.userIsAdmin&&this.adminUserCanSeeMoney;}},{key:'showPurchaseOrderTab',value:function showPurchaseOrderTab(){var result=false;if(this.props.proposals.length>0&&this.props.currentWorkOrder.client.po_required){// Show if last proposal is approved and current user is admin or client
result=__WEBPACK_IMPORTED_MODULE_24_domain_proposal_status_enum__["a" /* ProposalStatus */].APPROVED.equals(this.props.proposals[this.props.proposals.length-1].status)&&(this.userIsAdmin||this.userIsClient);}return result;}},{key:'showBudgetTab',value:function showBudgetTab(){var statusEnum=__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(this.props.currentWorkOrder.status);return(__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].PENDING.equals(statusEnum)||__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].PLM.equals(statusEnum))&&(__WEBPACK_IMPORTED_MODULE_23_services_utils_permissions_util__["a" /* PermissionsUtil */].adminUserCanSeeMoney(this.props.user)||this.userIsClient||this.userIsGc);}},{key:'showReceiptsTable',value:function showReceiptsTable(){return this.userIsContractor;}},{key:'showTimeTable',value:function showTimeTable(){return this.userIsContractor;}},{key:'showTransfer',value:function showTransfer(){return this.userIsAdmin&&!__WEBPACK_IMPORTED_MODULE_21_domain_work_order__["a" /* WorkOrder */].isStatusFulFilled(this.props.currentWorkOrder,__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].IN_PROGRESS)&&!this.userIsGc;}},{key:'showVendorInvoices',value:function showVendorInvoices(){return this.userIsContractor;}}],[{key:'showMembers',value:function showMembers(status,user){if(__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["g" /* usersUtil */].hasType(user,__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["f" /* TYPES */].CONTRACTOR)){return __WEBPACK_IMPORTED_MODULE_21_domain_work_order__["a" /* WorkOrder */].isStatusFulFilled({status:status},__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].PENDING)&&status!==__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].COMPLETE;}if(__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["g" /* usersUtil */].isAdmin(user)||__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["g" /* usersUtil */].hasType(user,__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR)){return status===__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].IN_PROGRESS||status===__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].COMPLETE;}}}]);return WorkOrderDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{budget:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["a" /* getBudget */])(state),contractorInvoice:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["b" /* getContractorInvoice */])(state),contractorLienRelease:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["c" /* getContractorLienRelease */])(state),contractorLienReleases:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["d" /* getContractorLienReleases */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),members:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["g" /* getMembers */])(state),navigationBarSelectedItem:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["h" /* getNavigationBarSelectedItem */])(state),openItemsByTaskId:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["i" /* getOpenItemsByTaskId */])(state),proposals:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["l" /* getProposals */])(state),quotes:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["m" /* getQuotes */])(state),receipts:Object(__WEBPACK_IMPORTED_MODULE_39_components_admin_work_orders_details_receipts_store_selectors__["b" /* receiptsSelector */])(state),selectedProposalId:Object(__WEBPACK_IMPORTED_MODULE_18_selectors_admin_work_orders_details_proposal_approval__["a" /* getSelectedProposalId */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state),time:Object(__WEBPACK_IMPORTED_MODULE_33_components_admin_work_orders_details_time_store_selectors__["d" /* timeSelector */])(state),user:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_authentication__["d" /* getCurrentUser */])(state),vendorInvoices:Object(__WEBPACK_IMPORTED_MODULE_34_components_admin_work_orders_details_vendor_invoices_store_selectors__["b" /* vendorInvoicesSelector */])(state),workOrderNameEdit:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["B" /* getWorkOrderNameEdit */])(state),workOrderNameSaving:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["C" /* getWorkOrderNameSaving */])(state),workOrderNameValue:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["D" /* getWorkOrderNameValue */])(state),workOrderJobNumberEdit:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["y" /* getWorkOrderJobNumberEdit */])(state),workOrderJobNumberSaving:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["z" /* getWorkOrderJobNumberSaving */])(state),workOrderJobNumberValue:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["A" /* getWorkOrderJobNumberValue */])(state),changeOrders:Object(__WEBPACK_IMPORTED_MODULE_44_components_admin_work_orders_details_change_orders_store_selectors__["a" /* getChangeOrders */])(state),selectedChangeOrderId:Object(__WEBPACK_IMPORTED_MODULE_44_components_admin_work_orders_details_change_orders_store_selectors__["g" /* getSelectedChangeOrderId */])(state),workOrderAuthorizations:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["x" /* getWorkOrderAuthorizations */])(state)};})(WorkOrderDetails));

/***/ }),
/* 1918 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TaskDetails__ = __webpack_require__(1920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_task_status_TaskStatus__ = __webpack_require__(1922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_utils_permissions_util__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__quotes_CreateQuoteModal__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__quotes_QuotesRequestModal__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_quotes_request__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_actions_admin_work_orders_details_create_quote__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__quotes_DenyQuoteModal__ = __webpack_require__(1932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_actions_admin_work_orders_details_deny_quote__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DetailsTasks_css__ = __webpack_require__(1935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DetailsTasks_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__DetailsTasks_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__OpenItemsViewer__ = __webpack_require__(1936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_actions_admin_work_orders_details_open_items__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__open_items_AddOpenItemModal__ = __webpack_require__(1941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__open_items_EditOpenItemModal__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_services_utils_work_order_status_enum__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_shared_modal_MessageModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_shared_chat_Chat__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__fortawesome_fontawesome_free_solid_faArrowDown__ = __webpack_require__(1960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__fortawesome_fontawesome_free_solid_faArrowDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__fortawesome_fontawesome_free_solid_faArrowDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__fortawesome_react_fontawesome__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__TasksChecklist__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__tasks_DetailsTaskButtons__ = __webpack_require__(1962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_services_utils_details_task_util__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_components_admin_work_orders_details_tasks_TasksTable__ = __webpack_require__(1964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_components_admin_work_orders_details_tasks_DetailsTaskPreExistingConditions__ = __webpack_require__(2142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_components_admin_work_orders_details_change_order_tasks_store_actions__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_components_admin_work_orders_details_change_order_tasks_store_selectors__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_components_admin_work_orders_details_change_order_tasks_ChangeOrderTask__ = __webpack_require__(2145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_components_admin_work_orders_details_change_order_tasks_ChangeOrderTaskModal__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_components_admin_work_orders_details_change_order_quotes_store_actions__ = __webpack_require__(267);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsTasks=function(_Component){_inherits(DetailsTasks,_Component);function DetailsTasks(props){_classCallCheck(this,DetailsTasks);var _this=_possibleConstructorReturn(this,(DetailsTasks.__proto__||Object.getPrototypeOf(DetailsTasks)).call(this,props));_this.userIsContractor=function(){var _this$props=_this.props,user=_this$props.user,currentTask=_this$props.currentTask;return __WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__["g" /* usersUtil */].hasType(user,__WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__["f" /* TYPES */].CONTRACTOR)||_this.userIsAdmin&&currentTask&&!currentTask.awardedContractor;};_this.handleCloseCompleteModal=function(){_this.setState({showCompleteModal:false});_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_19_actions_admin_work_orders_work_orders__["h" /* goToWorkOrder */])(_this.props.currentWorkOrder.id));};_this.handleTaskChange=function(taskId,attribute,value,label){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_details__["_9" /* taskChangeRequest */])(taskId,attribute,value,label));if(attribute==='trade'){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_details__["F" /* loadSubTradesRequest */])(value));}};_this.handleTaskEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_details__["w" /* editTask */])());};_this.handleTaskDelete=function(){_this.setState({showDeleteConfirmation:true});};_this.handleTaskCancel=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_details__["h" /* cancelTask */])(_this.props.currentWorkOrder.id));};_this.handleTaskSubmit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_details__["_17" /* updateTaskRequest */])(_this.props.currentWorkOrder.id,_this.props.currentTask));};_this.handleBidsRequest=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_quotes_request__["h" /* showQuotesRequestModalRequest */])(_this.props.currentWorkOrder.propietary_sub_contractors,[_this.props.currentTask.trade]));};_this.handleCreateQuote=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_actions_admin_work_orders_details_create_quote__["i" /* showCreateQuoteModal */])());};_this.handleDenyQuote=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_actions_admin_work_orders_details_deny_quote__["e" /* showDenyQuoteModal */])());};_this.handleStartTask=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_details__["_7" /* startTask */])(_this.props.currentTask.id));};_this.handleCompleteTask=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_details__["o" /* completeTask */])(_this.props.currentTask.id)).then(function(result){if(result.ok){// Show confirmation modal
_this.setState({showCompleteModal:true});// Check if all tasks are "cmp", and if true, mark WO as "complete" (locally)
if(_this.props.tasks.filter(function(task){return task.status!=='cmp';}).length===0){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_19_actions_admin_work_orders_work_orders__["r" /* markCurrentWorkOrderAsComplete */])());}}});};_this.handleApproveWork=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_details__["g" /* approveTaskWorkRequest */])(_this.props.currentTask.id)).then(function(response){if(response.ok){_this.setState({showApprovedModal:true});}});};_this.handleCloseApprovedModal=function(){_this.setState({showApprovedModal:false});_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_19_actions_admin_work_orders_work_orders__["h" /* goToWorkOrder */])(_this.props.currentWorkOrder.id));};_this.handleViewCounterQuote=function(){_this.handleResubmitQuote();};_this.handleResubmitQuote=function(){var taskQuote=_this.findQuoteForCurrentTask();if(taskQuote!==null){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_actions_admin_work_orders_details_create_quote__["j" /* showReviewQuoteModal */])(taskQuote));}};_this.handleTaskImageRemove=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_details__["P" /* removeImageRequest */])(_this.props.currentTask,index));};_this.handleLoadNotes=function(){return _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_details__["H" /* loadTaskNotesRequest */])(_this.props.currentTask.id));};_this.handleAddNote=function(text){return _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_details__["e" /* addTaskNoteRequest */])(_this.props.currentTask.id,text));};_this.handleNotesClick=function(){Object(__WEBPACK_IMPORTED_MODULE_28_services_utils_scroller_util__["b" /* simpleScrollTo */])('task-notes-container');};_this.handleAddOpenItem=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_22_actions_admin_work_orders_details_open_items__["d" /* setShowAddOpenItemModalRequest */])(_this.props.currentTask.id));};_this.handleSelectOpenItem=function(openItemId){var openItem=_this.props.openItemsByTaskId[_this.props.currentTask.id].find(function(openItem){return openItem.id===openItemId;});_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_details__["_3" /* setSelectedOpenItem */])(openItem));};_this.handleDeleteCo=function(){_this.setState({showDeleteCoConfirmation:true});};_this.handleWithdrawQuote=function(){_this.setState({showWithdrawConfirmation:true});};_this.handleWithdrawCoQuote=function(){_this.setState({showWithdrawCoQuoteConfirmation:true});};_this.handleWithdrawCoQuoteRequest=function(){_this.setState({showWithdrawCoQuoteRequestConfirmation:true});};_this.handleDeleteCoConfirmation=function(result){if(result){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_39_components_admin_work_orders_details_change_order_tasks_store_actions__["b" /* deleteChangeOrderTask */])(_this.changeOrderTask.id));}_this.setState({showDeleteCoConfirmation:false});};_this.handleWithdrawConfirmation=function(result){if(result){var taskQuote=_this.findQuoteForCurrentTask();if(taskQuote!==null){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_details__["_24" /* withdrawQuoteRequest */])(taskQuote.id));// only one quote for current task
}}_this.setState({showWithdrawConfirmation:false});};_this.handleWithdrawCoQuoteConfirmation=function(result){if(result){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_43_components_admin_work_orders_details_change_order_quotes_store_actions__["i" /* withdrawChangeOrderQuote */])(_this.changeOrderTask.id));}_this.setState({showWithdrawCoQuoteConfirmation:false});};_this.handleWithdrawCoQuoteRequestConfirmation=function(result){if(result){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_43_components_admin_work_orders_details_change_order_quotes_store_actions__["j" /* withdrawChangeOrderQuoteRequest */])(_this.changeOrderTask.id));}_this.setState({showWithdrawCoQuoteRequestConfirmation:false});};_this.handleDeleteConfirmation=function(result){if(result){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_details__["s" /* deleteTaskRequest */])(_this.props.currentTask.id)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_19_actions_admin_work_orders_work_orders__["h" /* goToWorkOrder */])(_this.props.currentWorkOrder.id));}});}_this.setState({showDeleteConfirmation:false});};_this.handleTaskChecklistSelect=function(itemId){var task=_this.props.tasks.find(function(task){return task.id===_this.props.currentTask.id;});if(task!==undefined){var value=!task.task_checklist[itemId];_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_details__["M" /* markItemTaskChecklistRequest */])(_this.props.currentTask.id,task.task_checklist.id,itemId,value));}};_this.handleCompleteTaskImageUpload=function(taskChecklistId,images){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_details__["_19" /* uploadCompleteTaskImagesRequest */])(taskChecklistId,images));};_this.handleCompleteTaskImageRemove=function(images,taskChecklistId,imageIndex){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_details_details__["N" /* removeCompleteTaskImagesRequest */])(taskChecklistId,images[imageIndex].id));};_this.userIsAdmin=__WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__["g" /* usersUtil */].isAdmin(_this.props.user)||__WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.user,__WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);_this.contractorUserCanSeeMoney=__WEBPACK_IMPORTED_MODULE_7_services_utils_permissions_util__["a" /* PermissionsUtil */].contractorUserCanSeeMoney(_this.props.user);_this.state={showApprovedModal:false,showCompleteModal:false,showDeleteConfirmation:false,showDeleteCoConfirmation:false,showWithdrawConfirmation:false,showWithdrawCoQuoteConfirmation:false,showWithdrawCoQuoteRequestConfirmation:false};return _this;}_createClass(DetailsTasks,[{key:'render',value:function render(){var _this2=this;var contractorUserCanSeeMoney=this.contractorUserCanSeeMoney;this.currentTask=null;if(this.props.currentTask!==null&&this.props.tasks.length>0){// This variable contains the current task with the backend data (this.props.currentTask has fewer data)
this.currentTask=this.props.tasks.find(function(task){return task.id===_this2.props.currentTask.id;});this.changeOrderTask=this.props.changeOrderTasks.find(function(cot){return cot.task_id===_this2.currentTask.id&&cot.status==='pending';});}return this.props.currentWorkOrder!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-tasks'},this.props.currentTask!==null&&this.currentTask!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'task-details-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{md:8},this.showBidDueDate()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'due-date-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-regular'},'Bid due date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold-orange'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Date__["a" /* default */],{value:this.props.currentTask.bidDueDate}))),this.showNotes()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notes-count-container',onClick:this.handleNotesClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Task Chat (',this.props.taskNotes.length,') '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__fortawesome_react_fontawesome__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_29__fortawesome_fontawesome_free_solid_faArrowDown___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TaskDetails__["a" /* default */],{minMaxImages:{min:3,max:6},readOnly:!this.props.editTask,subTradesByTradeId:this.props.subTradesByTradeId,task:this.props.currentTask,trades:this.props.trades,onChange:this.handleTaskChange,onCancel:this.handleTaskCancel,onNotesClick:this.handleNotesClick,onSubmit:this.handleTaskSubmit,onTaskImageRemove:this.props.editTask?this.handleTaskImageRemove:undefined}),this.props.changeOrderTasks.filter(function(cot){return cot.task_id===_this2.currentTask.id&&(cot.status==='approved'||cot.status==='acr');}).sort(function(cot1,cot2){return cot1.number-cot2.number;}).map(function(cot){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41_components_admin_work_orders_details_change_order_tasks_ChangeOrderTask__["a" /* default */],{key:cot.id,changeOrderTask:cot,showEstimateInTitle:contractorUserCanSeeMoney});}),this.showChangeOrderTask(this.changeOrderTask)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41_components_admin_work_orders_details_change_order_tasks_ChangeOrderTask__["a" /* default */],{changeOrderTask:this.changeOrderTask,showEstimateInTitle:contractorUserCanSeeMoney,showRequestQuoteBtn:this.userIsAdmin&&!this.changeOrderTask.change_order_quote,showSubmitQuoteBtn:this.showSubmitCoQuoteBtn(this.changeOrderTask),showDeleteCoBtn:this.userIsAdmin&&!this.changeOrderTask.change_order_quote,showWithdrawQuoteBtn:this.showWithdrawCoQuoteBtn(this.changeOrderTask),showWithdrawCoQuoteRequestBtn:this.showWithdrawCoQuoteRequestBtn(this.changeOrderTask),onDeleteCoClick:this.handleDeleteCo,onQuoteActionClick:function onQuoteActionClick(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_43_components_admin_work_orders_details_change_order_quotes_store_actions__["e" /* setShowChangeOrderQuoteModal */])());},onWithdrawQuoteClick:function onWithdrawQuoteClick(){return _this2.handleWithdrawCoQuote();},onWithdrawCoQuoteRequestClick:function onWithdrawCoQuoteRequestClick(){return _this2.handleWithdrawCoQuoteRequest();},onEditActionClick:function onEditActionClick(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_39_components_admin_work_orders_details_change_order_tasks_store_actions__["e" /* setShowChangeOrderTaskModal */])());}}):this.showCreateChangeOrder()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38_components_shared_button_Button__["a" /* default */],{className:'button-orange create-change-order-btn',label:'Create Change Order',onClick:function onClick(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_39_components_admin_work_orders_details_change_order_tasks_store_actions__["e" /* setShowChangeOrderTaskModal */])());}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42_components_admin_work_orders_details_change_order_tasks_ChangeOrderTaskModal__["a" /* default */],null)),/*** Task Checklist ************/(this.props.currentTask.status===__WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__["b" /* TaskStatusKeys */].PRE||this.props.currentTask.status===__WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__["b" /* TaskStatusKeys */].WIP||this.props.currentTask.status===__WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__["b" /* TaskStatusKeys */].CMP||this.props.currentTask.status===__WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__["b" /* TaskStatusKeys */].CLS)&&this.renderTaskChecklist(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37_components_admin_work_orders_details_tasks_DetailsTaskPreExistingConditions__["a" /* default */],null),/*** Completed work - Contractor in task WIP ************/this.userIsContractor()&&this.props.currentTask.status===__WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__["b" /* TaskStatusKeys */].WIP&&this.currentTask.task_checklist!==undefined&&this.currentTask.task_checklist!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'completed-work-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h3'},'Completed work images'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],images:this.currentTask.task_checklist.completed_images.map(function(image){return{preview:image.image.preview.url};}),notes:'Provide photos of the completed work',onRemove:this.handleCompleteTaskImageRemove.bind(this,this.currentTask.task_checklist.completed_images,this.currentTask.task_checklist.id),onUpload:this.handleCompleteTaskImageUpload.bind(this,this.currentTask.task_checklist.id)})),/*** Completed work - Contractor in task CMP and Admin WIP and afterwards ************/this.currentTask.task_checklist!==undefined&&this.currentTask.task_checklist!==null&&this.currentTask.task_checklist.completed_images.length>0&&(!this.userIsContractor()&&this.props.currentTask.status===__WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__["b" /* TaskStatusKeys */].WIP||this.props.currentTask.status===__WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__["b" /* TaskStatusKeys */].CMP||this.props.currentTask.status===__WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__["b" /* TaskStatusKeys */].CLS)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'completed-work-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h3'},'Completed work images'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],images:this.currentTask.task_checklist.completed_images.map(function(image){return{preview:image.image.preview.url,url:image.image.url};}),readOnly:true})),!this.props.editTask&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dt-bottom-button-container'},this.renderTasksButtons(),this.showBidDueDate()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'due-date-container due-date-bottom-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-regular'},'Bid due date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold-orange'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Date__["a" /* default */],{value:this.props.currentTask.bidDueDate})))),this.showNotes()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'task-notes-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Task Chat'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_components_shared_chat_Chat__["a" /* default */],{notes:this.props.taskNotes,loadChat:this.handleLoadNotes,handleSubmit:this.handleAddNote}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_task_status_TaskStatus__["a" /* default */],{status:this.props.currentTask.status}),this.showOpenItems()&&this.props.openItemsByTaskId!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'open-items-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__OpenItemsViewer__["a" /* default */],{items:this.props.openItemsByTaskId[this.props.currentTask.id]!==undefined?this.props.openItemsByTaskId[this.props.currentTask.id].map(function(openItem){return{id:openItem.id,critical:openItem.critical,description:openItem.description,dueDate:openItem.due_date,letter:openItem.letter,resolvedNote:openItem.resolved_note,status:openItem.resolved?'complete':'incomplete',updatedAt:openItem.updated_at};}):[],onAddOpenItem:this.handleAddOpenItem,onSelectOpenItem:this.handleSelectOpenItem}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["c" /* Clearfix */],null),this.showOpenItems()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__open_items_AddOpenItemModal__["a" /* default */],null),this.showOpenItems()&&this.props.selectedOpenItemId!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__open_items_EditOpenItemModal__["a" /* default */],{taskId:this.props.currentTask.id,taskNumber:this.props.currentTask.number}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__quotes_QuotesRequestModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__quotes_CreateQuoteModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__quotes_DenyQuoteModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_shared_modal_MessageModal__["a" /* default */],{show:this.state.showCompleteModal,message:'Thank you for completing the task. You will be able to upload your invoice once all of your tasks are complete.',onHide:this.handleCloseCompleteModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_shared_modal_MessageModal__["a" /* default */],{show:this.state.showApprovedModal,message:'Thank you. Task #'+__WEBPACK_IMPORTED_MODULE_2_numeral___default()(this.props.currentTask.number).format('00')+' is now approved.',onHide:this.handleCloseApprovedModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showDeleteCoConfirmation,message:'Are you sure you want to delete the change order?',onHide:this.handleDeleteCoConfirmation}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showWithdrawConfirmation,message:'Are you sure you want to withdraw the quote?',onHide:this.handleWithdrawConfirmation}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showWithdrawCoQuoteConfirmation,message:'Are you sure you want to withdraw the change order pricing?',onHide:this.handleWithdrawCoQuoteConfirmation}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showWithdrawCoQuoteRequestConfirmation,message:'Are you sure you want to withdraw the change order quote request?',onHide:this.handleWithdrawCoQuoteRequestConfirmation}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showDeleteConfirmation,message:'Are you sure you want to delete the task?',onHide:this.handleDeleteConfirmation})),this.props.currentTask===null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36_components_admin_work_orders_details_tasks_TasksTable__["a" /* default */],null));}},{key:'renderTasksButtons',value:function renderTasksButtons(){var buttonsActive=Object(__WEBPACK_IMPORTED_MODULE_35_services_utils_details_task_util__["b" /* showDetailsTaskButtons */])(this.props.user,this.currentTask,this.findQuoteForCurrentTask(),this.props.preExistingConditions);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__tasks_DetailsTaskButtons__["a" /* default */],Object.assign({},buttonsActive,{onRequestBids:this.handleBidsRequest,onTaskEdit:this.handleTaskEdit,onTaskDelete:this.handleTaskDelete,onCreateQuote:this.handleCreateQuote,onDenyQuote:this.handleDenyQuote,onWithdrawQuote:this.handleWithdrawQuote,onViewCounterQuote:this.handleViewCounterQuote,onResubmitQuote:this.handleResubmitQuote,onStartTask:this.handleStartTask,onMarkAsComplete:this.handleCompleteTask,onApproveWork:this.handleApproveWork,task:{number:this.currentTask.number,name:this.currentTask.name},workOrder:{name:this.props.currentWorkOrder.name,number:this.props.currentWorkOrder.number}}));}},{key:'showBidDueDate',value:function showBidDueDate(){return this.props.currentTask!==null&&this.props.currentTask.bidDueDate!==null&&(__WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__["a" /* TaskStatusEnum */].RFP.equals(this.props.currentTask.status)||__WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__["a" /* TaskStatusEnum */].AGG.equals(this.props.currentTask.status));}},{key:'showChangeOrderTask',value:function showChangeOrderTask(changeOrderTask){return changeOrderTask&&(this.userIsAdmin||changeOrderTask.change_order_quote);}},{key:'showSubmitCoQuoteBtn',value:function showSubmitCoQuoteBtn(changeOrderTask){var coQuote=changeOrderTask.change_order_quote;return this.userIsContractor()&&coQuote&&(coQuote.status==='waiting'||coQuote.status==='withdrawn');}},{key:'showWithdrawCoQuoteBtn',value:function showWithdrawCoQuoteBtn(changeOrderTask){var coQuote=changeOrderTask.change_order_quote;return this.userIsContractor()&&coQuote&&coQuote.status==='received';}},{key:'showWithdrawCoQuoteRequestBtn',value:function showWithdrawCoQuoteRequestBtn(changeOrderTask){var coQuote=changeOrderTask.change_order_quote;return this.userIsAdmin&&!!changeOrderTask.change_order_quote&&coQuote.status!=='approved'&&coQuote.status!=='received';}},{key:'showCreateChangeOrder',value:function showCreateChangeOrder(){return(__WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__["a" /* TaskStatusEnum */].PRE.equals(this.props.currentTask.status)||__WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__["a" /* TaskStatusEnum */].WIP.equals(this.props.currentTask.status)||__WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__["a" /* TaskStatusEnum */].CMP.equals(this.props.currentTask.status))&&this.userIsAdmin;}},{key:'showNotes',value:function showNotes(){return(__WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__["a" /* TaskStatusEnum */].PRE.equals(this.props.currentTask.status)||__WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__["a" /* TaskStatusEnum */].WIP.equals(this.props.currentTask.status)||__WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__["a" /* TaskStatusEnum */].CMP.equals(this.props.currentTask.status))&&(this.userIsAdmin||this.userIsContractor());}},{key:'showOpenItems',value:function showOpenItems(){var statusEnum=__WEBPACK_IMPORTED_MODULE_25_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(this.props.currentWorkOrder.status);return(__WEBPACK_IMPORTED_MODULE_25_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].IN_PROGRESS.equals(statusEnum)||__WEBPACK_IMPORTED_MODULE_25_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].COMPLETE.equals(statusEnum)||__WEBPACK_IMPORTED_MODULE_25_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].CLOSED.equals(statusEnum))&&(this.userIsAdmin||this.userIsContractor());}},{key:'renderTaskChecklist',value:function renderTaskChecklist(){var _this3=this;var task=this.props.tasks.find(function(task){return task.id===_this3.props.currentTask.id;});var selectedStatus=[];if(task!==undefined){__WEBPACK_IMPORTED_MODULE_32__TasksChecklist__["a" /* default */].keys.forEach(function(key){if(task.task_checklist!==undefined&&task.task_checklist!==null&&task.task_checklist[key]){selectedStatus.push(key);}});}if(this.props.currentTask.status===__WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__["b" /* TaskStatusKeys */].PRE){if(this.userIsContractor()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'task-checklist-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h3'},'Checklist'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__TasksChecklist__["a" /* default */],{readOnly:false,selectedStatus:selectedStatus,showForContractor:this.userIsContractor(),onSelect:this.handleTaskChecklistSelect}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'task-checklist-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h3'},'Checklist'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__TasksChecklist__["a" /* default */],{readOnly:true,selectedStatus:selectedStatus,showForContractor:this.userIsContractor()}));}}else if(this.props.currentTask.status===__WEBPACK_IMPORTED_MODULE_21_domain_task_status_enum__["b" /* TaskStatusKeys */].WIP){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'task-checklist-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h3'},'Checklist'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__TasksChecklist__["a" /* default */],{readOnly:true,selectedStatus:selectedStatus,showForContractor:this.userIsContractor()}));}else{return null;}}},{key:'findQuoteForCurrentTask',value:function findQuoteForCurrentTask(){var _this4=this;if(this.props.currentTask!==null){var taskQuote=this.props.quotes.find(function(quote){return quote.task.id===_this4.props.currentTask.id&&(!_this4.userIsAdmin||!quote.contractor_id);});if(taskQuote!==undefined){return taskQuote;}}return null;}}]);return DetailsTasks;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_18_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),currentTask:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_details_details__["e" /* getCurrentTask */])(state),editTask:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_details_details__["f" /* getEditTask */])(state),openItemsByTaskId:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_details_details__["i" /* getOpenItemsByTaskId */])(state),preExistingConditions:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_details_details__["j" /* getPreExistingConditions */])(state),proposals:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_details_details__["l" /* getProposals */])(state),quotes:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_details_details__["m" /* getQuotes */])(state),quotesSelectedByTaskId:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_details_details__["n" /* getQuotesSelectedByTaskId */])(state),selectedOpenItemId:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_details_details__["q" /* getSelectedOpenItemId */])(state),subTradesByTradeId:Object(__WEBPACK_IMPORTED_MODULE_18_selectors_admin_work_orders_work_orders__["g" /* getSubTradesByTradeId */])(state),taskNotes:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_details_details__["v" /* getTaskNotes */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_18_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state),trades:Object(__WEBPACK_IMPORTED_MODULE_18_selectors_admin_work_orders_work_orders__["j" /* getTrades */])(state),user:state.auth.user,changeOrderTasks:Object(__WEBPACK_IMPORTED_MODULE_40_components_admin_work_orders_details_change_order_tasks_store_selectors__["a" /* getChangeOrderTasks */])(state)};})(DetailsTasks));

/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TaskDetails_css__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TaskDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__TaskDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_utils_date_util__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TaskDetails=function(_Component){_inherits(TaskDetails,_Component);function TaskDetails(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TaskDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TaskDetails.__proto__||Object.getPrototypeOf(TaskDetails)).call.apply(_ref,[this].concat(args))),_this),_this.handleSubmit=function(event){event.preventDefault();if(_this.isValid()){_this.props.onSubmit();}},_this.isValid=function(){if(_this.props.task.trade===null){alert('Type of task is required');return false;}else if(_this.props.task.subTrade===null){alert('Sub type of task is required');return false;}else if(_this.props.task.completionDate===null){alert('Completion date is required');return false;}return true;},_this.handleAttributeChange=function(value,attribute,label){_this.props.onChange(_this.props.task.id,attribute,value,label);},_this.handleOnCancel=function(event){event.preventDefault();_this.props.onCancel();},_this.handleNotesClick=function(event){event.preventDefault();if(_this.props.onNotesClick!==undefined){_this.props.onNotesClick();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TaskDetails,[{key:'render',value:function render(){var _this2=this;var subTrades=this.props.subTradesByTradeId[this.props.task.trade]!==undefined?this.props.subTradesByTradeId[this.props.task.trade]:[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'task-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Task # ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__["a" /* default */],{value:this.props.task.number,format:'00'}),':',' ',this.props.task.name!==undefined?this.props.task.name:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-item-label'},'Trade'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_dropdown_Dropdown__["a" /* default */],{options:this.props.trades.map(function(element){return{value:element.id,label:element.label};}),placeholder:'Trade',readOnly:this.props.readOnly,theme:'underlined',value:this.props.task.trade,onChange:function onChange(newOption){return _this2.handleAttributeChange(newOption.value,'trade',newOption.label);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-item-label'},'Sub Trades'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_dropdown_Dropdown__["a" /* default */],{disabled:subTrades.length===0,options:this.props.subTradesByTradeId[this.props.task.trade]!==undefined?this.props.subTradesByTradeId[this.props.task.trade].map(function(element){return{value:element.id,label:element.label};}):[],placeholder:'Sub Trade',readOnly:this.props.readOnly,theme:'underlined',value:this.props.task.subTrade,onChange:function onChange(newOption){return _this2.handleAttributeChange(newOption.value,'subTrade',newOption.label);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-item-label'},'Floor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_input_Input__["a" /* default */],{placeholder:'Floor',readOnly:this.props.readOnly,required:true,theme:'underlined',value:this.props.task.floorNumber,onChange:function onChange(value){return _this2.handleAttributeChange(value,'floorNumber');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-item-label'},'Room'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_input_Input__["a" /* default */],{placeholder:'Room',readOnly:this.props.readOnly,required:true,theme:'underlined',value:this.props.task.room,onChange:function onChange(value){return _this2.handleAttributeChange(value,'room');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-item-label'},'Task Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_input_Input__["a" /* default */],{placeholder:'Task Name',readOnly:this.props.readOnly,required:true,theme:'underlined',value:this.props.task.name||'',onChange:function onChange(value){return _this2.handleAttributeChange(value,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-item-label'},'Target Completion Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{className:'completion-date',isValidDate:__WEBPACK_IMPORTED_MODULE_10_services_utils_date_util__["k" /* todayValidation */],placeholder:'Target Completion date',readOnly:this.props.readOnly,value:this.props.task.completionDate,theme:'underlined',onChange:function onChange(value){return _this2.handleAttributeChange(value,'completionDate');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-item-label'},'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_TextArea__["a" /* default */],{className:'description',placeholder:'Description',readOnly:this.props.readOnly,required:true,value:this.props.task.description,theme:'underlined',onChange:function onChange(value){return _this2.handleAttributeChange(value,'description');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],images:this.props.task.images,max:this.props.minMaxImages.max,notes:'For faster quotes, provide photos - close-up, distant and one other that may help define your request',readOnly:this.props.readOnly,onRemove:this.props.onTaskImageRemove,onUpload:function onUpload(images){return _this2.handleAttributeChange(images,'images');}}))),!this.props.readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',value:'Save Task',type:'submit'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-gray',value:'Cancel Task',type:'button',onClick:this.handleOnCancel}))));}}]);return TaskDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TaskDetails.propTypes={minMaxImages:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,task:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,number:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,completionDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,trade:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,subTrade:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,floorNumber:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,room:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,status:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,images:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,file:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({original:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,img:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}))}),trades:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,subTradesByTradeId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onNotesClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onTaskImageRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};TaskDetails.defaultProps={notesCount:0,readOnly:false,showBidDueDate:false};/* harmony default export */ __webpack_exports__["a"] = (TaskDetails);

/***/ }),
/* 1921 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TaskStatus_css__ = __webpack_require__(1923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TaskStatus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TaskStatus_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checked_png__ = __webpack_require__(1924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checked_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__checked_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TaskStatus=function(_Component){_inherits(TaskStatus,_Component);function TaskStatus(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TaskStatus);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TaskStatus.__proto__||Object.getPrototypeOf(TaskStatus)).call.apply(_ref,[this].concat(args))),_this),_this.configuration={rfp:{position:0,total:7},plm:{position:1,total:7},agg:{position:2,total:8},woa:{position:2,total:7},pre:{position:3,total:7},wip:{position:4,total:7},cmp:{position:5,total:7},cls:{position:6,total:7}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TaskStatus,[{key:'render',value:function render(){var total=this.configuration[this.props.status].total;var position=this.configuration[this.props.status].position;var elements=[];var key=0;for(var i=0;i<total;i++){if(i===position){elements.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key,className:'selected-circle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'circle '+this.props.status})));}else if(i<position){elements.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:key,src:__WEBPACK_IMPORTED_MODULE_3__checked_png___default.a,alt:'checked'}));}else{elements.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key,className:'circle'}));}key++;if(i<total-1){elements.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{key:key}));}key++;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'task-status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-text '+this.props.status},this.props.status.toUpperCase()),elements);}}]);return TaskStatus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TaskStatus.propTypes={status:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TaskStatus);

/***/ }),
/* 1923 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1924 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1926 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBidDueDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSelectedContractor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSelectedContractors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getShowQuotesRequestModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getBidDueDate=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.quotesRequest.data.bidDueDate;},function(bidDueDate){return bidDueDate;});var getCurrentView=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.quotesRequest.ui.currentView;},function(currentView){return currentView;});var getSelectedContractor=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.quotesRequest.data.selectedContractor;},function(selectedContractor){return selectedContractor;});var getSelectedContractors=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.quotesRequest.data.selectedContractors;},function(selectedContractors){return selectedContractors;});var getShowQuotesRequestModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.quotesRequest.ui.showQuotesRequestModal;},function(showQuotesRequestModal){return showQuotesRequestModal;});

/***/ }),
/* 1929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Truncate = function (_Component) {
    _inherits(Truncate, _Component);

    function Truncate() {
        var _ref;

        _classCallCheck(this, Truncate);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = Truncate.__proto__ || Object.getPrototypeOf(Truncate)).call.apply(_ref, [this].concat(args)));

        _this.state = {};
        _this.styles = {
            ellipsis: {
                position: 'fixed',
                visibility: 'hidden',
                top: 0,
                left: 0
            }
        };


        _this.elements = {};

        _this.onResize = _this.onResize.bind(_this);
        _this.onTruncate = _this.onTruncate.bind(_this);
        _this.calcTargetWidth = _this.calcTargetWidth.bind(_this);
        _this.measureWidth = _this.measureWidth.bind(_this);
        _this.getLines = _this.getLines.bind(_this);
        _this.renderLine = _this.renderLine.bind(_this);
        return _this;
    }

    _createClass(Truncate, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var text = this.elements.text,
                calcTargetWidth = this.calcTargetWidth,
                onResize = this.onResize;


            var canvas = document.createElement('canvas');
            this.canvasContext = canvas.getContext('2d');

            calcTargetWidth(function () {
                // Node not needed in document tree to read its content
                if (text) {
                    text.parentNode.removeChild(text);
                }
            });

            window.addEventListener('resize', onResize);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            // Render was based on outdated refs and needs to be rerun
            if (this.props.children !== prevProps.children) {
                this.forceUpdate();
            }

            // If the width prop has changed, recalculate size of contents
            if (this.props.width !== prevProps.width) {
                this.calcTargetWidth();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var ellipsis = this.elements.ellipsis,
                onResize = this.onResize,
                timeout = this.timeout;


            ellipsis.parentNode.removeChild(ellipsis);

            window.removeEventListener('resize', onResize);

            window.cancelAnimationFrame(timeout);
        }

        // Shim innerText to consistently break lines at <br/> but not at \n

    }, {
        key: 'innerText',
        value: function innerText(node) {
            var div = document.createElement('div');
            var contentKey = 'innerText' in window.HTMLElement.prototype ? 'innerText' : 'textContent';

            div.innerHTML = node.innerHTML.replace(/\r\n|\r|\n/g, ' ');

            var text = div[contentKey];

            var test = document.createElement('div');
            test.innerHTML = 'foo<br/>bar';

            if (test[contentKey].replace(/\r\n|\r/g, '\n') !== 'foo\nbar') {
                div.innerHTML = div.innerHTML.replace(/<br.*?[\/]?>/gi, '\n');
                text = div[contentKey];
            }

            return text;
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            this.calcTargetWidth();
        }
    }, {
        key: 'onTruncate',
        value: function onTruncate(didTruncate) {
            var onTruncate = this.props.onTruncate;


            if (typeof onTruncate === 'function') {
                this.timeout = window.requestAnimationFrame(function () {
                    onTruncate(didTruncate);
                });
            }
        }
    }, {
        key: 'calcTargetWidth',
        value: function calcTargetWidth(callback) {
            var target = this.elements.target,
                calcTargetWidth = this.calcTargetWidth,
                canvasContext = this.canvasContext,
                width = this.props.width;

            // Calculation is no longer relevant, since node has been removed

            if (!target) {
                return;
            }

            var targetWidth = width ||
            // Floor the result to deal with browser subpixel precision
            Math.floor(target.parentNode.getBoundingClientRect().width);

            // Delay calculation until parent node is inserted to the document
            // Mounting order in React is ChildComponent, ParentComponent
            if (!targetWidth) {
                return window.requestAnimationFrame(function () {
                    return calcTargetWidth(callback);
                });
            }

            var style = window.getComputedStyle(target);

            var font = [style['font-weight'], style['font-style'], style['font-size'], style['font-family']].join(' ');

            canvasContext.font = font;

            this.setState({
                targetWidth: targetWidth
            }, callback);
        }
    }, {
        key: 'measureWidth',
        value: function measureWidth(text) {
            return this.canvasContext.measureText(text).width;
        }
    }, {
        key: 'ellipsisWidth',
        value: function ellipsisWidth(node) {
            return node.offsetWidth;
        }
    }, {
        key: 'trimRight',
        value: function trimRight(text) {
            return text.replace(/\s+$/, '');
        }
    }, {
        key: 'getLines',
        value: function getLines() {
            var elements = this.elements,
                _props = this.props,
                numLines = _props.lines,
                ellipsis = _props.ellipsis,
                trimWhitespace = _props.trimWhitespace,
                targetWidth = this.state.targetWidth,
                innerText = this.innerText,
                measureWidth = this.measureWidth,
                onTruncate = this.onTruncate,
                trimRight = this.trimRight;


            var lines = [];
            var text = innerText(elements.text);
            var textLines = text.split('\n').map(function (line) {
                return line.split(' ');
            });
            var didTruncate = true;
            var ellipsisWidth = this.ellipsisWidth(this.elements.ellipsis);

            for (var line = 1; line <= numLines; line++) {
                var textWords = textLines[0];

                // Handle newline
                if (textWords.length === 0) {
                    lines.push();
                    textLines.shift();
                    line--;
                    continue;
                }

                var resultLine = textWords.join(' ');

                if (measureWidth(resultLine) <= targetWidth) {
                    if (textLines.length === 1) {
                        // Line is end of text and fits without truncating
                        didTruncate = false;

                        lines.push(resultLine);
                        break;
                    }
                }

                if (line === numLines) {
                    // Binary search determining the longest possible line inluding truncate string
                    var textRest = textWords.join(' ');

                    var lower = 0;
                    var upper = textRest.length - 1;

                    while (lower <= upper) {
                        var middle = Math.floor((lower + upper) / 2);

                        var testLine = textRest.slice(0, middle + 1);

                        if (measureWidth(testLine) + ellipsisWidth <= targetWidth) {
                            lower = middle + 1;
                        } else {
                            upper = middle - 1;
                        }
                    }

                    var lastLineText = textRest.slice(0, lower);

                    if (trimWhitespace) {
                        lastLineText = trimRight(lastLineText);

                        // Remove blank lines from the end of text
                        while (!lastLineText.length && lines.length) {
                            var prevLine = lines.pop();

                            lastLineText = trimRight(prevLine);
                        }
                    }

                    resultLine = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        lastLineText,
                        ellipsis
                    );
                } else {
                    // Binary search determining when the line breaks
                    var _lower = 0;
                    var _upper = textWords.length - 1;

                    while (_lower <= _upper) {
                        var _middle = Math.floor((_lower + _upper) / 2);

                        var _testLine = textWords.slice(0, _middle + 1).join(' ');

                        if (measureWidth(_testLine) <= targetWidth) {
                            _lower = _middle + 1;
                        } else {
                            _upper = _middle - 1;
                        }
                    }

                    // The first word of this line is too long to fit it
                    if (_lower === 0) {
                        // Jump to processing of last line
                        line = numLines - 1;
                        continue;
                    }

                    resultLine = textWords.slice(0, _lower).join(' ');
                    textLines[0].splice(0, _lower);
                }

                lines.push(resultLine);
            }

            onTruncate(didTruncate);

            return lines;
        }
    }, {
        key: 'renderLine',
        value: function renderLine(line, i, arr) {
            if (i === arr.length - 1) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { key: i },
                    line
                );
            } else {
                var br = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', { key: i + 'br' });

                if (line) {
                    return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { key: i },
                        line
                    ), br];
                } else {
                    return br;
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var target = this.elements.target,
                _props2 = this.props,
                children = _props2.children,
                ellipsis = _props2.ellipsis,
                lines = _props2.lines,
                spanProps = _objectWithoutProperties(_props2, ['children', 'ellipsis', 'lines']),
                targetWidth = this.state.targetWidth,
                getLines = this.getLines,
                renderLine = this.renderLine,
                onTruncate = this.onTruncate;

            var text = void 0;

            var mounted = !!(target && targetWidth);

            if (typeof window !== 'undefined' && mounted) {
                if (lines > 0) {
                    text = getLines().map(renderLine);
                } else {
                    text = children;

                    onTruncate(false);
                }
            }

            delete spanProps.onTruncate;
            delete spanProps.trimWhitespace;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                _extends({}, spanProps, { ref: function ref(targetEl) {
                        _this2.elements.target = targetEl;
                    } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    text
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { ref: function ref(textEl) {
                            _this2.elements.text = textEl;
                        } },
                    children
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { ref: function ref(ellipsisEl) {
                            _this2.elements.ellipsis = ellipsisEl;
                        }, style: this.styles.ellipsis },
                    ellipsis
                )
            );
        }
    }]);

    return Truncate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Truncate.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    ellipsis: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    lines: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([false]), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
    trimWhitespace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    onTruncate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
Truncate.defaultProps = {
    children: '',
    ellipsis: '…',
    lines: 1,
    trimWhitespace: false,
    width: 0
};
/* harmony default export */ __webpack_exports__["a"] = (Truncate);
;


/***/ }),
/* 1931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors_admin_work_orders_details_deny_quote__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DenyQuoteModal_css__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DenyQuoteModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DenyQuoteModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_radio_button_RadioButton__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_admin_work_orders_details_deny_quote__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__selectors_admin_work_orders_details_details__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DenyQuoteModal=function(_Component){_inherits(DenyQuoteModal,_Component);function DenyQuoteModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DenyQuoteModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DenyQuoteModal.__proto__||Object.getPrototypeOf(DenyQuoteModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleQuestionAnswer=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_admin_work_orders_details_deny_quote__["d" /* selectAnswer */])(value));},_this.handleReasonChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_admin_work_orders_details_deny_quote__["a" /* changeReason */])(value));},_this.handleContinue=function(event){event.preventDefault();if(_this.props.sure){var taskQuote=_this.props.quotes.find(function(quote){return quote.task.id===_this.props.currentTask.id;});if(taskQuote!==undefined){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_admin_work_orders_details_deny_quote__["c" /* denyQuoteRequest */])(taskQuote.id,_this.props.reason));}}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_admin_work_orders_details_deny_quote__["b" /* closeDenyQuoteModal */])());}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DenyQuoteModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["o" /* Modal */],{className:'deny-quote-modal',show:this.props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["o" /* Modal */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2'},'Are you sure?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_radio_button_RadioButton__["a" /* default */],{options:[{value:'yes',label:'Yes'},{value:'no',label:'No'}],value:this.props.sure===null?null:this.props.sure?'yes':'no',onChange:this.handleQuestionAnswer})),this.props.sure&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reason-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_input_TextArea__["a" /* default */],{placeholder:'Please enter a reason (optional)',value:this.props.reason,onChange:this.handleReasonChange})),this.props.sure!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'continue-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',value:'Continue',type:'button',onClick:this.handleContinue}))));}}]);return DenyQuoteModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentTask:Object(__WEBPACK_IMPORTED_MODULE_8__selectors_admin_work_orders_details_details__["e" /* getCurrentTask */])(state),quotes:Object(__WEBPACK_IMPORTED_MODULE_8__selectors_admin_work_orders_details_details__["m" /* getQuotes */])(state),reason:Object(__WEBPACK_IMPORTED_MODULE_2__selectors_admin_work_orders_details_deny_quote__["a" /* getDenyQuoteReason */])(state),show:Object(__WEBPACK_IMPORTED_MODULE_2__selectors_admin_work_orders_details_deny_quote__["b" /* getDenyQuoteShow */])(state),sure:Object(__WEBPACK_IMPORTED_MODULE_2__selectors_admin_work_orders_details_deny_quote__["c" /* getDenyQuoteSure */])(state)};})(DenyQuoteModal));

/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDenyQuoteReason; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDenyQuoteShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDenyQuoteSure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getDenyQuoteReason=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.denyQuote.ui.reason;},function(reason){return reason;});var getDenyQuoteShow=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.denyQuote.ui.show;},function(show){return show;});var getDenyQuoteSure=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.denyQuote.ui.sure;},function(sure){return sure;});

/***/ }),
/* 1934 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1935 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OpenItemsViewer_css__ = __webpack_require__(1937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OpenItemsViewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__OpenItemsViewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_clipboard_png__ = __webpack_require__(1938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_clipboard_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_clipboard_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OpenItem__ = __webpack_require__(1939);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OpenItemsViewer=function(_Component){_inherits(OpenItemsViewer,_Component);function OpenItemsViewer(props){_classCallCheck(this,OpenItemsViewer);var _this=_possibleConstructorReturn(this,(OpenItemsViewer.__proto__||Object.getPrototypeOf(OpenItemsViewer)).call(this,props));_this.handleNavClick=function(value,event){event.preventDefault();_this.setState({currentNav:value});};_this.handleAddButtonClick=function(event){event.preventDefault();if(_this.props.onAddOpenItem!==undefined){_this.props.onAddOpenItem();}};_this.handleClick=function(openItemId){if(_this.props.onSelectOpenItem!==undefined){_this.props.onSelectOpenItem(openItemId);}};_this.handleShowMore=function(event){event.preventDefault();_this.setState({lines:0});};_this.handleShowLess=function(event){event.preventDefault();_this.setState({lines:3});};_this.state={currentNav:1,lines:3};return _this;}_createClass(OpenItemsViewer,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'open-items-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'items-navs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav '+(this.state.currentNav===1?'active':''),onClick:this.handleNavClick.bind(this,1)},'Open Items'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav '+(this.state.currentNav===2?'active':''),onClick:this.handleNavClick.bind(this,2)},'Completed')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'items-container'},this.props.items.filter(function(item){return _this2.state.currentNav===1?item.status==='incomplete':item.status==='complete';}).map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__OpenItem__["a" /* default */],{key:item.id,item:item,onClick:_this2.handleClick});}),this.props.items.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no-items-msg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__images_clipboard_png___default.a,alt:'no-items'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'There are no open item yet.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'button',value:'Add Open Item',onClick:this.handleAddButtonClick}))));}}]);return OpenItemsViewer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);OpenItemsViewer.propTypes={items:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_4__OpenItem__["a" /* default */].openItemPropType)),onAddOpenItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onSelectOpenItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};OpenItemsViewer.defaultProps={items:[]};/* harmony default export */ __webpack_exports__["a"] = (OpenItemsViewer);

/***/ }),
/* 1937 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1938 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OpenItem_css__ = __webpack_require__(1940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OpenItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__OpenItem_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_text_SimpleTruncate__ = __webpack_require__(200);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OpenItem=function(_Component){_inherits(OpenItem,_Component);function OpenItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OpenItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OpenItem.__proto__||Object.getPrototypeOf(OpenItem)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(event){event.preventDefault();if(_this.props.onClick!==undefined){_this.props.onClick(_this.props.item.id);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OpenItem,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'open-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selection',onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,''+this.props.item.letter+(this.props.item.critical?' (Critical)':'')+': '+this.props.item.description),this.props.item.status==='incomplete'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_text_Date__["a" /* default */],{className:this.props.item.status,value:this.props.item.dueDate,format:'LL'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:this.props.item.status},this.props.item.status)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selection',onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_text_Date__["a" /* default */],{value:this.props.item.updatedAt,format:'hh:mm LL'}),this.props.item.status==='incomplete'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'button',value:'Respond'}))),this.props.item.status==='complete'&&this.props.item.resolvedNote!==undefined&&this.props.item.resolvedNote!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_text_SimpleTruncate__["a" /* default */],{text:this.props.item.resolvedNote})));}}]);return OpenItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);OpenItem.openItemPropType={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,critical:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,dueDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,letter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,resolvedNote:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,status:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['incomplete','complete']).isRequired,updatedAt:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};OpenItem.propTypes={item:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(OpenItem.openItemPropType).isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};OpenItem.defaultProps={critical:false};/* harmony default export */ __webpack_exports__["a"] = (OpenItem);

/***/ }),
/* 1940 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_admin_work_orders_details_open_items__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectors_admin_work_orders_details_open_items__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AddOpenItemModal_css__ = __webpack_require__(1942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AddOpenItemModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__AddOpenItemModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_checkbox_CheckBox__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_utils_date_util__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddOpenItemModal=function(_Component){_inherits(AddOpenItemModal,_Component);function AddOpenItemModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddOpenItemModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddOpenItemModal.__proto__||Object.getPrototypeOf(AddOpenItemModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_admin_work_orders_details_open_items__["c" /* setShowAddOpenItemModal */])(false));},_this.handleSubmit=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_admin_work_orders_details_open_items__["e" /* submitFormRequest */])(_this.props.currentTask.id,_this.props.form));},_this.handleAttributeChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_admin_work_orders_details_open_items__["g" /* updateFormValue */])(attribute,value));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddOpenItemModal,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_modal_FormModal__["a" /* default */],{className:'add-open-item-modal',show:this.props.showAddOpenItemModal,subTitle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_route_title_RouteTitle__["a" /* default */],{titles:[this.props.currentWorkOrder.client.company_name.toUpperCase(),'TASK #'+this.props.currentWorkOrder.number+'-'+__WEBPACK_IMPORTED_MODULE_9_numeral___default()(this.props.currentTask.number).format('00')+'-'+this.getNextLetter()]}),title:'New Open Item',onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_dropdown_Dropdown__["a" /* default */],{className:'assigned-member-dropdown',disabled:this.props.members.length===0,options:this.props.members// Show only active users who has not the role OWNER
.filter(function(member){return member.user.status==='active';}).map(function(member){return{value:member.user.id,label:member.user.first_name+' '+member.user.last_name};}),placeholder:'Assigned To',valid:this.props.invalidFields.find(function(element){return element==='memberId';})===undefined,value:this.props.form.memberId,onChange:function onChange(newOption){return _this2.handleAttributeChange('memberId',newOption.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:__WEBPACK_IMPORTED_MODULE_14__services_utils_date_util__["k" /* todayValidation */],placeholder:'Due Date',valid:this.props.invalidFields.find(function(element){return element==='dueDate';})===undefined,value:this.props.form.dueDate,onChange:this.handleAttributeChange.bind(this,'dueDate')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_input_TextArea__["a" /* default */],{placeholder:'Open Item Description...',valid:this.props.invalidFields.find(function(element){return element==='description';})===undefined,value:this.props.form.description,onChange:this.handleAttributeChange.bind(this,'description')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_checkbox_CheckBox__["a" /* default */],{checked:this.props.form.critical,shape:'round',size:'medium',onChange:this.handleAttributeChange.bind(this,'critical',!this.props.form.critical)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Mark as Critical')),this.props.validationMessage!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},this.props.validationMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-orange',value:'Create Open Item',onClick:this.handleSubmit})));}},{key:'getNextLetter',value:function getNextLetter(){var openItems=this.props.openItemsByTaskId!==null?this.props.openItemsByTaskId[this.props.currentTask.id]:undefined;if(openItems===undefined){return'A';}else{return String.fromCharCode(65+openItems.length);// 65 unicode for 'A' (upper case)
}}}]);return AddOpenItemModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentTask:Object(__WEBPACK_IMPORTED_MODULE_10__selectors_admin_work_orders_details_details__["e" /* getCurrentTask */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_5__selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_7__selectors_admin_work_orders_details_open_items__["c" /* getForm */])(state),invalidFields:Object(__WEBPACK_IMPORTED_MODULE_7__selectors_admin_work_orders_details_open_items__["d" /* getInvalidFields */])(state),members:Object(__WEBPACK_IMPORTED_MODULE_7__selectors_admin_work_orders_details_open_items__["e" /* getMembers */])(state),openItemsByTaskId:Object(__WEBPACK_IMPORTED_MODULE_10__selectors_admin_work_orders_details_details__["i" /* getOpenItemsByTaskId */])(state),showAddOpenItemModal:Object(__WEBPACK_IMPORTED_MODULE_7__selectors_admin_work_orders_details_open_items__["f" /* getShowAddOpenItemModal */])(state),validationMessage:Object(__WEBPACK_IMPORTED_MODULE_7__selectors_admin_work_orders_details_open_items__["g" /* getValidationMessage */])(state)};})(AddOpenItemModal));

/***/ }),
/* 1942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1944 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1945 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_autosize_textarea__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_autosize_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_autosize_textarea__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextareaAutosizeWrapper=function(_Component){_inherits(TextareaAutosizeWrapper,_Component);function TextareaAutosizeWrapper(props){_classCallCheck(this,TextareaAutosizeWrapper);var _this=_possibleConstructorReturn(this,(TextareaAutosizeWrapper.__proto__||Object.getPrototypeOf(TextareaAutosizeWrapper)).call(this,props));_this.handleOnBlur=function(e){var onBlur=_this.props.onBlur;if(onBlur){onBlur(e.target.value);}};_this.handleOnChange=function(e){_this.setState({value:e.target.value});};_this.state={value:props.initialValue||''};return _this;}_createClass(TextareaAutosizeWrapper,[{key:'UNSAFE_componentWillReceiveProps',value:function UNSAFE_componentWillReceiveProps(nextProps){if(!this.props.clear&&nextProps.clear){this.setState({value:nextProps.initialValue||''});}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,rows=_props.rows,placeholder=_props.placeholder,disabled=_props.disabled,required=_props.required;var value=this.state.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_autosize_textarea___default.a,{rows:rows,placeholder:placeholder,disabled:disabled,required:required,value:value,onChange:function onChange(e){return _this2.handleOnChange(e);},onBlur:function onBlur(e){return _this2.handleOnBlur(e);}});}}]);return TextareaAutosizeWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TextareaAutosizeWrapper.propTypes={rows:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,initialValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,required:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,clear:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onBlur:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (TextareaAutosizeWrapper);

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
exports.__esModule = true;
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var autosize = __webpack_require__(1948);
var _getLineHeight = __webpack_require__(1949);
var getLineHeight = _getLineHeight;
var UPDATE = 'autosize:update';
var DESTROY = 'autosize:destroy';
var RESIZED = 'autosize:resized';
/**
 * A light replacement for built-in textarea component
 * which automaticaly adjusts its height to match the content
 */
var TextareaAutosize = /** @class */ (function (_super) {
    __extends(TextareaAutosize, _super);
    function TextareaAutosize() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            lineHeight: null
        };
        _this.dispatchEvent = function (EVENT_TYPE) {
            switch (EVENT_TYPE) {
                case UPDATE:
                    autosize.update(_this.textarea);
                    break;
                case DESTROY:
                    autosize.destroy(_this.textarea);
                    break;
                case RESIZED:
                    var event_1 = document.createEvent('Event');
                    event_1.initEvent(RESIZED, true, false);
                    _this.textarea.dispatchEvent(event_1);
                default:
                    break;
            }
        };
        _this.updateLineHeight = function () {
            _this.setState({
                lineHeight: getLineHeight(_this.textarea)
            });
        };
        _this.onChange = function (e) {
            var onChange = _this.props.onChange;
            _this.currentValue = e.currentTarget.value;
            onChange && onChange(e);
        };
        _this.saveDOMNodeRef = function (ref) {
            var innerRef = _this.props.innerRef;
            if (innerRef) {
                innerRef(ref);
            }
            _this.textarea = ref;
        };
        _this.getLocals = function () {
            var _a = _this, _b = _a.props, onResize = _b.onResize, maxRows = _b.maxRows, onChange = _b.onChange, style = _b.style, innerRef = _b.innerRef, props = __rest(_b, ["onResize", "maxRows", "onChange", "style", "innerRef"]), lineHeight = _a.state.lineHeight, saveDOMNodeRef = _a.saveDOMNodeRef;
            var maxHeight = maxRows && lineHeight ? lineHeight * maxRows : null;
            return __assign({}, props, { saveDOMNodeRef: saveDOMNodeRef, style: maxHeight ? __assign({}, style, { maxHeight: maxHeight }) : style, onChange: _this.onChange });
        };
        return _this;
    }
    TextareaAutosize.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, onResize = _a.onResize, maxRows = _a.maxRows, async = _a.async;
        if (typeof maxRows === 'number') {
            this.updateLineHeight();
        }
        if (typeof maxRows === "number" || async) {
            /*
              the defer is needed to:
                - force "autosize" to activate the scrollbar when this.props.maxRows is passed
                - support StyledComponents (see #71)
            */
            setTimeout(function () { return autosize(_this.textarea); });
        }
        else {
            autosize(this.textarea);
        }
        if (onResize) {
            this.textarea.addEventListener(RESIZED, onResize);
        }
    };
    TextareaAutosize.prototype.componentWillUnmount = function () {
        var onResize = this.props.onResize;
        if (onResize) {
            this.textarea.removeEventListener(RESIZED, onResize);
        }
        this.dispatchEvent(DESTROY);
    };
    TextareaAutosize.prototype.render = function () {
        var _a = this.getLocals(), children = _a.children, saveDOMNodeRef = _a.saveDOMNodeRef, locals = __rest(_a, ["children", "saveDOMNodeRef"]);
        return (React.createElement("textarea", __assign({}, locals, { ref: saveDOMNodeRef }), children));
    };
    TextareaAutosize.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.value !== this.currentValue || this.props.rows !== prevProps.rows) {
            this.dispatchEvent(UPDATE);
        }
    };
    TextareaAutosize.defaultProps = {
        rows: 1,
        async: false
    };
    TextareaAutosize.propTypes = {
        rows: PropTypes.number,
        maxRows: PropTypes.number,
        onResize: PropTypes.func,
        innerRef: PropTypes.func,
        async: PropTypes.bool
    };
    return TextareaAutosize;
}(React.Component));
exports.TextareaAutosize = TextareaAutosize;


/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	autosize 4.0.2
	license: MIT
	http://www.jacklmoore.com/autosize
*/
(function (global, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports !== "undefined") {
		factory(module, exports);
	} else {
		var mod = {
			exports: {}
		};
		factory(mod, mod.exports);
		global.autosize = mod.exports;
	}
})(this, function (module, exports) {
	'use strict';

	var map = typeof Map === "function" ? new Map() : function () {
		var keys = [];
		var values = [];

		return {
			has: function has(key) {
				return keys.indexOf(key) > -1;
			},
			get: function get(key) {
				return values[keys.indexOf(key)];
			},
			set: function set(key, value) {
				if (keys.indexOf(key) === -1) {
					keys.push(key);
					values.push(value);
				}
			},
			delete: function _delete(key) {
				var index = keys.indexOf(key);
				if (index > -1) {
					keys.splice(index, 1);
					values.splice(index, 1);
				}
			}
		};
	}();

	var createEvent = function createEvent(name) {
		return new Event(name, { bubbles: true });
	};
	try {
		new Event('test');
	} catch (e) {
		// IE does not support `new Event()`
		createEvent = function createEvent(name) {
			var evt = document.createEvent('Event');
			evt.initEvent(name, true, false);
			return evt;
		};
	}

	function assign(ta) {
		if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;

		var heightOffset = null;
		var clientWidth = null;
		var cachedHeight = null;

		function init() {
			var style = window.getComputedStyle(ta, null);

			if (style.resize === 'vertical') {
				ta.style.resize = 'none';
			} else if (style.resize === 'both') {
				ta.style.resize = 'horizontal';
			}

			if (style.boxSizing === 'content-box') {
				heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
			} else {
				heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
			}
			// Fix when a textarea is not on document body and heightOffset is Not a Number
			if (isNaN(heightOffset)) {
				heightOffset = 0;
			}

			update();
		}

		function changeOverflow(value) {
			{
				// Chrome/Safari-specific fix:
				// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
				// made available by removing the scrollbar. The following forces the necessary text reflow.
				var width = ta.style.width;
				ta.style.width = '0px';
				// Force reflow:
				/* jshint ignore:start */
				ta.offsetWidth;
				/* jshint ignore:end */
				ta.style.width = width;
			}

			ta.style.overflowY = value;
		}

		function getParentOverflows(el) {
			var arr = [];

			while (el && el.parentNode && el.parentNode instanceof Element) {
				if (el.parentNode.scrollTop) {
					arr.push({
						node: el.parentNode,
						scrollTop: el.parentNode.scrollTop
					});
				}
				el = el.parentNode;
			}

			return arr;
		}

		function resize() {
			if (ta.scrollHeight === 0) {
				// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
				return;
			}

			var overflows = getParentOverflows(ta);
			var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)

			ta.style.height = '';
			ta.style.height = ta.scrollHeight + heightOffset + 'px';

			// used to check if an update is actually necessary on window.resize
			clientWidth = ta.clientWidth;

			// prevents scroll-position jumping
			overflows.forEach(function (el) {
				el.node.scrollTop = el.scrollTop;
			});

			if (docTop) {
				document.documentElement.scrollTop = docTop;
			}
		}

		function update() {
			resize();

			var styleHeight = Math.round(parseFloat(ta.style.height));
			var computed = window.getComputedStyle(ta, null);

			// Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
			var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;

			// The actual height not matching the style height (set via the resize method) indicates that 
			// the max-height has been exceeded, in which case the overflow should be allowed.
			if (actualHeight < styleHeight) {
				if (computed.overflowY === 'hidden') {
					changeOverflow('scroll');
					resize();
					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
				}
			} else {
				// Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
				if (computed.overflowY !== 'hidden') {
					changeOverflow('hidden');
					resize();
					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
				}
			}

			if (cachedHeight !== actualHeight) {
				cachedHeight = actualHeight;
				var evt = createEvent('autosize:resized');
				try {
					ta.dispatchEvent(evt);
				} catch (err) {
					// Firefox will throw an error on dispatchEvent for a detached element
					// https://bugzilla.mozilla.org/show_bug.cgi?id=889376
				}
			}
		}

		var pageResize = function pageResize() {
			if (ta.clientWidth !== clientWidth) {
				update();
			}
		};

		var destroy = function (style) {
			window.removeEventListener('resize', pageResize, false);
			ta.removeEventListener('input', update, false);
			ta.removeEventListener('keyup', update, false);
			ta.removeEventListener('autosize:destroy', destroy, false);
			ta.removeEventListener('autosize:update', update, false);

			Object.keys(style).forEach(function (key) {
				ta.style[key] = style[key];
			});

			map.delete(ta);
		}.bind(ta, {
			height: ta.style.height,
			resize: ta.style.resize,
			overflowY: ta.style.overflowY,
			overflowX: ta.style.overflowX,
			wordWrap: ta.style.wordWrap
		});

		ta.addEventListener('autosize:destroy', destroy, false);

		// IE9 does not fire onpropertychange or oninput for deletions,
		// so binding to onkeyup to catch most of those events.
		// There is no way that I know of to detect something like 'cut' in IE9.
		if ('onpropertychange' in ta && 'oninput' in ta) {
			ta.addEventListener('keyup', update, false);
		}

		window.addEventListener('resize', pageResize, false);
		ta.addEventListener('input', update, false);
		ta.addEventListener('autosize:update', update, false);
		ta.style.overflowX = 'hidden';
		ta.style.wordWrap = 'break-word';

		map.set(ta, {
			destroy: destroy,
			update: update
		});

		init();
	}

	function destroy(ta) {
		var methods = map.get(ta);
		if (methods) {
			methods.destroy();
		}
	}

	function update(ta) {
		var methods = map.get(ta);
		if (methods) {
			methods.update();
		}
	}

	var autosize = null;

	// Do nothing in Node.js environment and IE8 (or lower)
	if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
		autosize = function autosize(el) {
			return el;
		};
		autosize.destroy = function (el) {
			return el;
		};
		autosize.update = function (el) {
			return el;
		};
	} else {
		autosize = function autosize(el, options) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], function (x) {
					return assign(x, options);
				});
			}
			return el;
		};
		autosize.destroy = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], destroy);
			}
			return el;
		};
		autosize.update = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], update);
			}
			return el;
		};
	}

	exports.default = autosize;
	module.exports = exports['default'];
});

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

// Load in dependencies
var computedStyle = __webpack_require__(1950);

/**
 * Calculate the `line-height` of a given node
 * @param {HTMLElement} node Element to calculate line height of. Must be in the DOM.
 * @returns {Number} `line-height` of the element in pixels
 */
function lineHeight(node) {
  // Grab the line-height via style
  var lnHeightStr = computedStyle(node, 'line-height');
  var lnHeight = parseFloat(lnHeightStr, 10);

  // If the lineHeight did not contain a unit (i.e. it was numeric), convert it to ems (e.g. '2.3' === '2.3em')
  if (lnHeightStr === lnHeight + '') {
    // Save the old lineHeight style and update the em unit to the element
    var _lnHeightStyle = node.style.lineHeight;
    node.style.lineHeight = lnHeightStr + 'em';

    // Calculate the em based height
    lnHeightStr = computedStyle(node, 'line-height');
    lnHeight = parseFloat(lnHeightStr, 10);

    // Revert the lineHeight style
    if (_lnHeightStyle) {
      node.style.lineHeight = _lnHeightStyle;
    } else {
      delete node.style.lineHeight;
    }
  }

  // If the lineHeight is in `pt`, convert it to pixels (4px for 3pt)
  // DEV: `em` units are converted to `pt` in IE6
  // Conversion ratio from https://developer.mozilla.org/en-US/docs/Web/CSS/length
  if (lnHeightStr.indexOf('pt') !== -1) {
    lnHeight *= 4;
    lnHeight /= 3;
  // Otherwise, if the lineHeight is in `mm`, convert it to pixels (96px for 25.4mm)
  } else if (lnHeightStr.indexOf('mm') !== -1) {
    lnHeight *= 96;
    lnHeight /= 25.4;
  // Otherwise, if the lineHeight is in `cm`, convert it to pixels (96px for 2.54cm)
  } else if (lnHeightStr.indexOf('cm') !== -1) {
    lnHeight *= 96;
    lnHeight /= 2.54;
  // Otherwise, if the lineHeight is in `in`, convert it to pixels (96px for 1in)
  } else if (lnHeightStr.indexOf('in') !== -1) {
    lnHeight *= 96;
  // Otherwise, if the lineHeight is in `pc`, convert it to pixels (12pt for 1pc)
  } else if (lnHeightStr.indexOf('pc') !== -1) {
    lnHeight *= 16;
  }

  // Continue our computation
  lnHeight = Math.round(lnHeight);

  // If the line-height is "normal", calculate by font-size
  if (lnHeightStr === 'normal') {
    // Create a temporary node
    var nodeName = node.nodeName;
    var _node = document.createElement(nodeName);
    _node.innerHTML = '&nbsp;';

    // If we have a text area, reset it to only 1 row
    // https://github.com/twolfson/line-height/issues/4
    if (nodeName.toUpperCase() === 'TEXTAREA') {
      _node.setAttribute('rows', '1');
    }

    // Set the font-size of the element
    var fontSizeStr = computedStyle(node, 'font-size');
    _node.style.fontSize = fontSizeStr;

    // Remove default padding/border which can affect offset height
    // https://github.com/twolfson/line-height/issues/4
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetHeight
    _node.style.padding = '0px';
    _node.style.border = '0px';

    // Append it to the body
    var body = document.body;
    body.appendChild(_node);

    // Assume the line height of the element is the height
    var height = _node.offsetHeight;
    lnHeight = height;

    // Remove our child from the DOM
    body.removeChild(_node);
  }

  // Return the calculated height
  return lnHeight;
}

// Export lineHeight
module.exports = lineHeight;


/***/ }),
/* 1950 */
/***/ (function(module, exports) {

// This code has been refactored for 140 bytes
// You can see the original here: https://github.com/twolfson/computedStyle/blob/04cd1da2e30fa45844f95f5cb1ac898e9b9ef050/lib/computedStyle.js
var computedStyle = function (el, prop, getComputedStyle) {
  getComputedStyle = window.getComputedStyle;

  // In one fell swoop
  return (
    // If we have getComputedStyle
    getComputedStyle ?
      // Query it
      // TODO: From CSS-Query notes, we might need (node, null) for FF
      getComputedStyle(el) :

    // Otherwise, we are in IE and use currentStyle
      el.currentStyle
  )[
    // Switch to camelCase for CSSOM
    // DEV: Grabbed from jQuery
    // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
    // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
    prop.replace(/-(\w)/gi, function (word, letter) {
      return letter.toUpperCase();
    })
  ];
};

module.exports = computedStyle;


/***/ }),
/* 1951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ChatTitle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChatTitle_css__ = __webpack_require__(1952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChatTitle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ChatTitle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_chat_bubbles_png__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_chat_bubbles_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_chat_bubbles_png__);
function ChatTitle(props){var name=props.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Chat',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'chat-bubbles',src:__WEBPACK_IMPORTED_MODULE_3_images_chat_bubbles_png___default.a,alt:'chat-bubbles'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'This chat is just for clarification.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Any official response must be entered in the ',name,'.'));}ChatTitle.propTypes={name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};

/***/ }),
/* 1952 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChatMessage_css__ = __webpack_require__(1954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChatMessage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ChatMessage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_spackle_icon_png__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_spackle_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_spackle_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__text_SimpleTruncate__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_chat_ChatAttachments__ = __webpack_require__(1955);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChatMessage=function(_Component){_inherits(ChatMessage,_Component);function ChatMessage(){_classCallCheck(this,ChatMessage);return _possibleConstructorReturn(this,(ChatMessage.__proto__||Object.getPrototypeOf(ChatMessage)).apply(this,arguments));}_createClass(ChatMessage,[{key:'render',value:function render(){var _props=this.props,note=_props.note,elapsedTime=_props.elapsedTime,linesShown=_props.linesShown;var spackle=!note.user.accountable_id&&!note.user.accountable_type;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'note-icon-container'},spackle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon with-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__images_spackle_icon_png___default.a,alt:'user-icon'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon no-icon'},note.user.first_name.charAt(0),note.user.last_name.charAt(0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'note-content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-date'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,note.user.first_name,' ',note.user.last_name),elapsedTime?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.renderCreatedAt()):note.created_at&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__["a" /* default */],{value:note.created_at,format:'MM/DD/YY hh:mm A'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__text_SimpleTruncate__["a" /* default */],{shownLines:linesShown,text:note.content}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_chat_ChatAttachments__["a" /* default */],{note:note}))));}},{key:'renderCreatedAt',value:function renderCreatedAt(){var elapsedTime=this.props.elapsedTime;var values=[];if(elapsedTime.years>0){values.push(elapsedTime.years+'y');}if(elapsedTime.months>0){values.push(elapsedTime.months+'mo');}// Only show two attributes from the range value
if(elapsedTime.days>0&&values.length<2){values.push(elapsedTime.days+'d');}if(elapsedTime.hours>0&&values.length<2){values.push(elapsedTime.hours+'h');}if(elapsedTime.minutes>0&&values.length<2){values.push(elapsedTime.minutes+'m');}return values.join(' ');}}]);return ChatMessage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ChatMessage.propTypes={note:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,created_at:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,documents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),images:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({accountable_id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,accountable_type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,first_name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,last_name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}).isRequired,elapsedTime:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({years:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,months:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,days:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,hours:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,minutes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}),linesShown:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};ChatMessage.defaultProps={note:{content:'',created_at:'',documents:[],images:[],user:{accountable_id:null,accountable_type:'',first_name:'',last_name:''}},elapsedTime:null,linesShown:4};/* harmony default export */ __webpack_exports__["a"] = (ChatMessage);

/***/ }),
/* 1954 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ChatAttachments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChatAttachments_css__ = __webpack_require__(1956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChatAttachments_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ChatAttachments_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_document_DocumentLink__ = __webpack_require__(47);
function ChatAttachments(props){var note=props.note;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat-attachments'},note.documents&&note.documents.map(function(doc,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_document_DocumentLink__["a" /* default */],{key:index,file:doc.document,url:doc.document.url});}),note.images&&note.images.map(function(img,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'image-preview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_image_upload_ImageUpload__["a" /* default */],{images:[{id:img.id,url:img.image.url,preview:img.image.preview.url}],readOnly:true}));}));}ChatAttachments.propTypes={note:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape()};

/***/ }),
/* 1956 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ChatButtons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChatButtons_css__ = __webpack_require__(1958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChatButtons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ChatButtons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_upload_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_images_upload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_utils_files_util__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_attachments_util__ = __webpack_require__(1959);
function ChatButtons(props){var newNote=props.newNote,handleFormChange=props.handleFormChange,handleSubmit=props.handleSubmit;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],{className:'notes-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:6,className:'doc-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx',className:'dropzone-container',onDrop:function onDrop(files){return Object(__WEBPACK_IMPORTED_MODULE_11_services_utils_attachments_util__["d" /* setDocuments */])(files,newNote,handleFormChange);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Please drag and drop any file into this area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8_images_upload_svg___default.a,alt:'upload'})),newNote.documents&&newNote.documents.map(function(doc,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'doc-viewer',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'remove-doc-icon',src:__WEBPACK_IMPORTED_MODULE_9_images_remove_png___default.a,alt:'remove',onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_11_services_utils_attachments_util__["b" /* removeDocument */])(index,newNote,handleFormChange);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_document_DocumentLink__["a" /* default */],{file:doc,url:doc.url}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:__WEBPACK_IMPORTED_MODULE_10_services_utils_files_util__["a" /* imageExtensions */],multiple:true,onUpload:function onUpload(files){return Object(__WEBPACK_IMPORTED_MODULE_11_services_utils_attachments_util__["e" /* setImages */])(files,newNote,handleFormChange);},onRemove:function onRemove(index){return Object(__WEBPACK_IMPORTED_MODULE_11_services_utils_attachments_util__["c" /* removeImage */])(index,newNote,handleFormChange);},images:Object(__WEBPACK_IMPORTED_MODULE_11_services_utils_attachments_util__["a" /* getImages */])(newNote)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Send',onClick:handleSubmit}));}ChatButtons.propTypes={newNote:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(),handleFormChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};

/***/ }),
/* 1958 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = setImages;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeImage;
/* harmony export (immutable) */ __webpack_exports__["a"] = getImages;
/* harmony export (immutable) */ __webpack_exports__["d"] = setDocuments;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeDocument;
/* unused harmony export getDocuments */
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function setImages(files,form,handleFormChange){var images=[].concat(_toConsumableArray(getImages(form)));files.forEach(function(val){images.push({url:URL.createObjectURL(val),file:val});});handleFormChange('images',images);}function removeImage(index,form,handleFormChange){var images=[].concat(_toConsumableArray(getImages(form)));var deletedImages=[];var deletedImage=images.splice(index,1);deletedImages.push(deletedImage[0]);handleFormChange('images',images,'deletedImages',deletedImages);}function getImages(form){if(form.images){return form.images;}return[];}function setDocuments(files,form,handleFormChange){var docs=[].concat(_toConsumableArray(getDocuments(form)));files.forEach(function(val){docs.push({file:val,name:val.name});});handleFormChange('documents',docs);}function removeDocument(index,form,handleFormChange){var docs=[].concat(_toConsumableArray(getDocuments(form)));var deletedDocs=[];var deletedDoc=docs.splice(index,1);deletedDocs.push(deletedDoc[0]);handleFormChange('documents',docs,'deletedDocs',deletedDocs);}function getDocuments(form){if(form.documents){return form.documents;}return[];}

/***/ }),
/* 1960 */
/***/ (function(module, exports) {

module.exports = { prefix: 'fas', iconName: 'arrow-down', icon: [448, 512, [], "f063", "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"] };

/***/ }),
/* 1961 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsTaskButtons_css__ = __webpack_require__(1963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsTaskButtons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DetailsTaskButtons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsTaskButtons=function(_Component){_inherits(DetailsTaskButtons,_Component);function DetailsTaskButtons(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DetailsTaskButtons);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DetailsTaskButtons.__proto__||Object.getPrototypeOf(DetailsTaskButtons)).call.apply(_ref,[this].concat(args))),_this),_this.handleBidsRequest=function(){if(_this.props.onRequestBids){_this.props.onRequestBids();}},_this.handleTaskEdit=function(){if(_this.props.onTaskEdit){_this.props.onTaskEdit();}},_this.handleDeleteTask=function(){if(_this.props.onTaskDelete){_this.props.onTaskDelete();}},_this.handleCreateQuote=function(){if(_this.props.onCreateQuote){_this.props.onCreateQuote();}},_this.handleDenyQuote=function(){if(_this.props.onDenyQuote){_this.props.onDenyQuote();}},_this.handleWithdrawQuote=function(){if(_this.props.onWithdrawQuote){_this.props.onWithdrawQuote();}},_this.handleViewCounterQuote=function(){if(_this.props.onViewCounterQuote){_this.props.onViewCounterQuote();}},_this.handleResubmitQuote=function(){if(_this.props.onResubmitQuote){_this.props.onResubmitQuote();}},_this.handleStartTask=function(){if(_this.props.onStartTask){_this.props.onStartTask();}},_this.handleMarkAsCompleteTask=function(){if(_this.props.onMarkAsComplete){_this.props.onMarkAsComplete();}},_this.handleApproveWork=function(){if(_this.props.onApproveWork){_this.props.onApproveWork();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DetailsTaskButtons,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-task-button-container'},this.props.requestBids&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{id:'request-bids-button',className:'button-orange',label:'Request Bids',onClick:this.handleBidsRequest}),this.props.editTask&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{id:'edit-task-button',className:'button-gray',label:'Edit Task',onClick:this.handleTaskEdit}),this.props.deleteTask&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{id:'delete-task-button',className:'button-white',label:'Delete Task',onClick:this.handleDeleteTask}),this.props.createQuote&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{id:'create-quote-button',className:'button-orange',label:'Create Quote',onClick:this.handleCreateQuote}),this.props.askQuestion&&this.renderAskQuestionButton(),this.props.noThanks&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{id:'no-thanks-button',className:'button-white',label:'No, Thanks',onClick:this.handleDenyQuote}),this.props.withdrawQuote&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{id:'withdraw-quote-button',className:'button-orange withdraw',label:'Withdraw Quote',onClick:this.handleWithdrawQuote}),this.props.viewCounterQuote&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{id:'view-counter-quote-button',className:'button-gray',label:'View Counter',onClick:this.handleViewCounterQuote}),this.props.resubmitQuote&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{id:'resubmit-quote-button',className:'button-orange withdraw',label:'Resubmit Quote',onClick:this.handleResubmitQuote}),this.props.startTask.show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{id:'start-task-button',className:'button-white-orange',disabled:!this.props.startTask.enable,label:'Start Task',onClick:this.handleStartTask}),this.props.markAsCompleted.show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{id:'mark-as-complete-button',className:'button-orange wip',disabled:!this.props.markAsCompleted.enable,label:'Mark as Complete',onClick:this.handleMarkAsCompleteTask}),this.props.approveWork&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{id:'approve-work-button',className:'button-orange',label:'Approve Work',onClick:this.handleApproveWork}),this.props.showCompleted&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'show-completed-button',className:'btn button button-blue cmp'},'Completed'));}},{key:'renderAskQuestionButton',value:function renderAskQuestionButton(){var mailSubject='mailto:admin@spackle.co?subject='+('WO #'+this.props.workOrder.number+DetailsTaskButtons.getWorkOrderName(this.props.workOrder)+'-')+(__WEBPACK_IMPORTED_MODULE_4_numeral___default()(this.props.task.number).format('00')+': ')+(''+this.props.task.name);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'ask-question-button',className:'btn button button-gray mail-link',href:mailSubject},'Ask a question');}}],[{key:'getWorkOrderName',value:function getWorkOrderName(workOrder){return workOrder.name!==undefined&&workOrder.name!==null?':'+workOrder.name:'';}}]);return DetailsTaskButtons;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DetailsTaskButtons.propTypes={requestBids:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,editTask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,deleteTask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,createQuote:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,askQuestion:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,noThanks:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,withdrawQuote:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,viewCounterQuote:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,resubmitQuote:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,startTask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({enable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}),markAsCompleted:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({enable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}),approveWork:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showCompleted:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,task:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({number:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}).isRequired,workOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,number:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired}).isRequired,onRequestBids:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onTaskEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onTaskDelete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCreateQuote:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onDenyQuote:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onWithdrawQuote:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onViewCounterQuote:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onResubmitQuote:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onStartTask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onMarkAsComplete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onApproveWork:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};DetailsTaskButtons.defaultProps={addTime:false,requestBids:false,editTask:false,deleteTask:false,createQuote:false,askQuestion:false,noThanks:false,withdrawQuote:false,startTask:{enable:false,show:false},markAsCompleted:{enable:false,show:false},approveWork:false,showCompleted:false};/* harmony default export */ __webpack_exports__["a"] = (DetailsTaskButtons);

/***/ }),
/* 1963 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TasksTable_css__ = __webpack_require__(1965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TasksTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TasksTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_quotes_QuotesRequestModal__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_tasks_NewTaskModal__ = __webpack_require__(1966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_utils_work_order_status_enum__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_work_orders_details_change_order_tasks_store_selectors__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_domain_quotes_status_enum__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_actions_admin_work_orders_details_new_task__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_actions_admin_work_orders_details_quotes_request__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_actions_admin_work_orders_details_create_quote__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_admin_work_orders_details_quotes_CreateQuotesModal__ = __webpack_require__(1969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_admin_work_orders_details_tasks_TasksSimpleTable__ = __webpack_require__(2140);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TasksTable=function(_Component){_inherits(TasksTable,_Component);function TasksTable(props){_classCallCheck(this,TasksTable);var _this=_possibleConstructorReturn(this,(TasksTable.__proto__||Object.getPrototypeOf(TasksTable)).call(this,props));_initialiseProps.call(_this);var currentUser=_this.props.currentUser;_this.userIsClient=__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["f" /* TYPES */].CLIENT);_this.userIsContractor=__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);_this.userIsAdmin=__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].isAdmin(currentUser)||__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);_this.userIsSpackleAdmin=__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasRole(currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);return _this;}_createClass(TasksTable,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tasks-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_admin_work_orders_details_tasks_TasksSimpleTable__["a" /* default */],{currentUser:this.props.currentUser,currentWorkOrder:this.props.currentWorkOrder,quotes:this.props.quotes,selectAllChecked:this.props.selectAllChecked,selectedTasks:this.props.selectedTasks,tasks:this.props.tasks,trades:this.props.trades,changeOrderTasks:this.props.changeOrderTasks,onDeselectAllTasks:this.props.onDeselectAllTasks,onGoToTask:this.props.onGoToTask,onLoadTrades:this.props.onLoadTrades,onSelectAllTasks:this.props.onSelectAllTasks,onSelectTask:this.props.onSelectTask,onSelectTaskRequest:this.props.onSelectTaskRequest}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},this.showAddTask()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Add Task',onClick:this.handleAddTask}),this.showRequestBid()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:'Request Bids',disabled:Object.keys(this.props.selectedTasks).length===0,onClick:this.handleBidsRequest}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_quotes_QuotesRequestModal__["a" /* default */],null))),this.showCreateQuotes()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:Object.keys(this.props.selectedTasks).length===0,label:'Create Quotes',onClick:this.handleCreateQuotes})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_tasks_NewTaskModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_admin_work_orders_details_quotes_CreateQuotesModal__["a" /* default */],null));}},{key:'mapTrades',value:function mapTrades(){var _props=this.props,tasks=_props.tasks,selectedTasks=_props.selectedTasks;return tasks.map(function(task){return selectedTasks[task.id]!==undefined?task.trade.id:null;}).filter(function(obj){return obj;});}},{key:'showAddTask',value:function showAddTask(){var statusEnum=__WEBPACK_IMPORTED_MODULE_9_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(this.props.currentWorkOrder.status);return(__WEBPACK_IMPORTED_MODULE_9_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].PENDING.equals(statusEnum)||__WEBPACK_IMPORTED_MODULE_9_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].PLM.equals(statusEnum)||__WEBPACK_IMPORTED_MODULE_9_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].IN_PROGRESS.equals(statusEnum))&&this.userIsSpackleAdmin||__WEBPACK_IMPORTED_MODULE_9_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].PENDING.equals(statusEnum)&&this.userIsClient;}},{key:'showRequestBid',value:function showRequestBid(){var statusEnum=__WEBPACK_IMPORTED_MODULE_9_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(this.props.currentWorkOrder.status);return(__WEBPACK_IMPORTED_MODULE_9_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].PENDING.equals(statusEnum)||__WEBPACK_IMPORTED_MODULE_9_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].PLM.equals(statusEnum))&&this.userIsSpackleAdmin;}},{key:'showCreateQuotes',value:function showCreateQuotes(){var _props2=this.props,currentWorkOrder=_props2.currentWorkOrder,quotes=_props2.quotes;var correctWOStatus=currentWorkOrder.status===__WEBPACK_IMPORTED_MODULE_9_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].PENDING||currentWorkOrder.status===__WEBPACK_IMPORTED_MODULE_9_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].PLM||currentWorkOrder.status===__WEBPACK_IMPORTED_MODULE_9_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].WOA;var correctQuotesStatus=quotes.filter(function(quote){return quote.status===__WEBPACK_IMPORTED_MODULE_12_domain_quotes_status_enum__["a" /* QuotesStatusKeys */].WAITING||quote.status===__WEBPACK_IMPORTED_MODULE_12_domain_quotes_status_enum__["a" /* QuotesStatusKeys */].WITHDRAWN;}).length>0;return this.userIsContractor&&correctWOStatus&&correctQuotesStatus;}}]);return TasksTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TasksTable.propTypes={currentUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,currentWorkOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,quotes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,selectAllChecked:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,selectedTasks:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,tasks:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,trades:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,onDeselectAllTasks:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGoToTask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onLoadTrades:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onOpenNewTaskModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSelectAllTasks:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSelectTask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSelectTaskRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onShowCreateQuotesModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onShowQuotesRequestModalRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};var _initialiseProps=function _initialiseProps(){var _this2=this;this.handleAddTask=function(){var _props3=_this2.props,tasks=_props3.tasks,trades=_props3.trades,onOpenNewTaskModal=_props3.onOpenNewTaskModal;var lastTaskNumber=0;if(tasks.length>0){lastTaskNumber=tasks[tasks.length-1].number;}onOpenNewTaskModal(trades.length===0,lastTaskNumber);};this.handleBidsRequest=function(){_this2.props.onShowQuotesRequestModalRequest([],_this2.mapTrades());};this.handleCreateQuotes=function(){_this2.props.onShowCreateQuotesModal(true);};this.handleSelectAllCheck=function(){_this2.props.onSelectAllTasks();};this.handleTaskCheckSelection=function(taskId){_this2.props.onSelectTask(taskId);};this.handleTaskSelection=function(index){Object(__WEBPACK_IMPORTED_MODULE_13_services_utils_scroller_util__["c" /* simpleScrollToTop */])();var _props4=_this2.props,currentUser=_props4.currentUser,currentWorkOrder=_props4.currentWorkOrder,tasks=_props4.tasks,trades=_props4.trades,onDeselectAllTasks=_props4.onDeselectAllTasks,onGoToTask=_props4.onGoToTask,onLoadTrades=_props4.onLoadTrades,onSelectTaskRequest=_props4.onSelectTaskRequest;var taskId=tasks[index].id;if(trades.length===0){onLoadTrades();}onSelectTaskRequest(currentWorkOrder.id,taskId,currentUser).then(function(response){if(response.ok){onDeselectAllTasks();onGoToTask(_this2.props.currentWorkOrder.id,taskId);}});};};function mapStateToProps(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_16_selectors_authentication__["d" /* getCurrentUser */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),quotes:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["m" /* getQuotes */])(state),selectAllChecked:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["p" /* getSelectAllChecked */])(state),selectedTasks:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["s" /* getSelectedTasks */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state),trades:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_work_orders__["j" /* getTrades */])(state),changeOrderTasks:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_work_orders_details_change_order_tasks_store_selectors__["a" /* getChangeOrderTasks */])(state)};}var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onDeselectAllTasks:function onDeselectAllTasks(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_actions_admin_work_orders_details_details__["t" /* deselectAllTasks */])());},onGoToTask:function onGoToTask(workOrderId,taskId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_actions_admin_work_orders_details_details__["A" /* goToTask */])(workOrderId,taskId));},onLoadTrades:function onLoadTrades(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_actions_admin_work_orders_details_details__["J" /* loadTradesRequest */])());},onOpenNewTaskModal:function onOpenNewTaskModal(loadTrades,lastTaskNumber){dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_actions_admin_work_orders_details_new_task__["b" /* openModal */])(loadTrades,lastTaskNumber));},onSelectAllTasks:function onSelectAllTasks(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_actions_admin_work_orders_details_details__["V" /* selectAllTasks */])());},onSelectTask:function onSelectTask(taskId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_actions_admin_work_orders_details_details__["Y" /* selectTask */])(taskId));},onSelectTaskRequest:function onSelectTaskRequest(workOrderId,taskId,currentUser){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_actions_admin_work_orders_details_details__["Z" /* selectTaskRequest */])(workOrderId,taskId,currentUser));},onShowCreateQuotesModal:function onShowCreateQuotesModal(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_actions_admin_work_orders_details_create_quote__["h" /* setShowCreateQuotesModal */])(value));},onShowQuotesRequestModalRequest:function onShowQuotesRequestModalRequest(subContractors,trades){dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions_admin_work_orders_details_quotes_request__["h" /* showQuotesRequestModalRequest */])(subContractors,trades));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TasksTable));

/***/ }),
/* 1965 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_work_orders_creation_Task__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NewTaskModal_css__ = __webpack_require__(1967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NewTaskModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__NewTaskModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_new_task__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_new_task__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_creation_tasks__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_utils_work_order_status_enum__ = __webpack_require__(90);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewTaskModal=function(_Component){_inherits(NewTaskModal,_Component);function NewTaskModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewTaskModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewTaskModal.__proto__||Object.getPrototypeOf(NewTaskModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleCancel=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_new_task__["d" /* setShowModal */])(false));},_this.handleChange=function(taskId,attribute,value,label){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_new_task__["a" /* attributeChange */])(attribute,value,label));if(attribute==='trade'){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_work_orders_work_orders__["k" /* loadSubTradesRequest */])(value));}},_this.handleImageRemove=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_new_task__["c" /* removeImage */])(index));},_this.handleSubmit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_creation_tasks__["j" /* saveTaskRequest */])(_this.props.form,_this.props.currentWorkOrder.id,_this.isPreTask())).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_new_task__["d" /* setShowModal */])(false));}});},_this.isPreTask=function(){var statusEnum=__WEBPACK_IMPORTED_MODULE_10_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(_this.props.currentWorkOrder.status);return __WEBPACK_IMPORTED_MODULE_10_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].IN_PROGRESS.equals(statusEnum);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewTaskModal,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.trades.length===0){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_creation_tasks__["h" /* loadTradesRequest */])());}}},{key:'render',value:function render(){var minMaxImages={min:3,max:6};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["o" /* Modal */],{className:'new-task-modal',show:this.props.showModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["o" /* Modal */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_admin_work_orders_creation_Task__["a" /* default */],{key:0,minMaxImages:minMaxImages,task:this.props.form,trades:this.props.trades,subTradesByTradeId:this.props.subTradesByTradeId,onCancel:this.handleCancel,onChange:this.handleChange,onImageRemove:this.handleImageRemove,onSubmit:this.handleSubmit,isPreTask:this.isPreTask()})));}}]);return NewTaskModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_new_task__["a" /* getForm */])(state),showModal:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_new_task__["b" /* getShowModal */])(state),subTradesByTradeId:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_work_orders__["g" /* getSubTradesByTradeId */])(state),trades:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_work_orders__["j" /* getTrades */])(state)};})(NewTaskModal));

/***/ }),
/* 1967 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFilesFromDataImages;
/**
 * Create File for all data images passed. The function returns a Promise that will resolve when all
 * images are processed.
 * @param images
 * @return {Promise<any[]>}
 */function getFilesFromDataImages(images){var imagesLoaded=[];var imageLoaderPromises=images.map(function(image){return new Promise(function(resolve){var reader=new FileReader();reader.onloadend=function(){imagesLoaded.push({id:0,file:{original:image,img:reader.result},url:null});resolve();};reader.readAsDataURL(image);});});return new Promise(function(resolve){Promise.all(imageLoaderPromises).then(function(){resolve(imagesLoaded);});});}

/***/ }),
/* 1969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreateQuotesModal_css__ = __webpack_require__(1970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreateQuotesModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CreateQuotesModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CreateQuotesForm_css__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CreateQuotesForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CreateQuotesForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_create_quote__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_create_quote__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_quotes_CreateQuotesForm__ = __webpack_require__(1971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_images_check_circle_png__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_images_check_circle_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_images_check_circle_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_shared_confirmation_ConfirmationPanel__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_domain_quotes_status_enum__ = __webpack_require__(316);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateQuotesModal=function(_Component){_inherits(CreateQuotesModal,_Component);function CreateQuotesModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CreateQuotesModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CreateQuotesModal.__proto__||Object.getPrototypeOf(CreateQuotesModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleContinue=function(values){_this.props.onContinue(values);},_this.handleEnd=function(){_this.props.onDeselectAllTasks();_this.props.onShowCreateQuotesModal(false);},_this.handleSubmit=function(){var _this$props=_this.props,createQuotesForm=_this$props.createQuotesForm,currentUser=_this$props.currentUser,currentWorkOrder=_this$props.currentWorkOrder,quotes=_this$props.quotes;var values=createQuotesForm.fields.map(function(field){var quote=quotes.find(function(quote){return quote.task.id===field.taskId;});return{quoteId:quote.id,startDate:field.startDate,durationInDays:field.durationInDays,totalCost:__WEBPACK_IMPORTED_MODULE_11_numeral___default()(field.totalCost).value(),materialLeadDays:field.materialLeadDays,description:field.description};});_this.props.onQuotesSubmit(currentWorkOrder.id,currentUser.accountable_id,values);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CreateQuotesModal,[{key:'render',value:function render(){var _props=this.props,createQuotesModalState=_props.createQuotesModalState,showCreateQuotesModal=_props.showCreateQuotesModal,onShowCreateQuotesModal=_props.onShowCreateQuotesModal;if(showCreateQuotesModal){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_modal_FormModal__["a" /* default */],{className:'create-quotes-modal',show:showCreateQuotesModal,showHeader:createQuotesModalState!=='confirmation',title:createQuotesModalState==='edit'?'Create Quotes':'Edit Quotes',onClose:function onClose(){return onShowCreateQuotesModal(false);}},createQuotesModalState==='edit'&&this.renderForm(),createQuotesModalState==='review'&&this.renderReviewForm(),createQuotesModalState==='confirmation'&&this.renderConfirmation());}return null;}},{key:'renderConfirmation',value:function renderConfirmation(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_confirmation_ConfirmationPanel__["a" /* default */],{image:__WEBPACK_IMPORTED_MODULE_13_images_check_circle_png___default.a,firstLine:'Success!',lines:['Quotes have been submitted.'],buttons:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Continue',onClick:this.handleEnd})]});}},{key:'renderForm',value:function renderForm(){var _props2=this.props,createQuotesForm=_props2.createQuotesForm,quotes=_props2.quotes,selectedTasks=_props2.selectedTasks;var initialValues=void 0;if(createQuotesForm!==null){initialValues={fields:createQuotesForm.fields};}else{initialValues={fields:Object.keys(selectedTasks).filter(function(key){var quote=quotes.find(function(quote){return quote.task.id===selectedTasks[key].id;});if(quote!==undefined){return quote.status===__WEBPACK_IMPORTED_MODULE_18_domain_quotes_status_enum__["a" /* QuotesStatusKeys */].WAITING||quote.status===__WEBPACK_IMPORTED_MODULE_18_domain_quotes_status_enum__["a" /* QuotesStatusKeys */].WITHDRAWN;}return false;}).map(function(key){return{taskId:__WEBPACK_IMPORTED_MODULE_11_numeral___default()(key).value(),taskNumber:selectedTasks[key].number,taskType:selectedTasks[key].trade.label,taskCompletionDate:selectedTasks[key].completion_date,startDate:'',durationInDays:null,totalCost:'',materialLeadDays:'',description:''};})};}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_quotes_CreateQuotesForm__["a" /* default */],{initialValues:initialValues,onSubmit:this.handleContinue});}},{key:'renderReviewForm',value:function renderReviewForm(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'create-quotes-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'create-quotes-form-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'TASK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'TYPE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'TARGET COMPLETION DATE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'START DATE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'DURATION IN DAYS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'MATERIAL LEAD TIME IN DAYS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'TOTAL COST'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'DESCRIPTION'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.props.createQuotesForm.fields.map(function(field,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,field.taskNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,field.taskType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'completion-date-readonly'},__WEBPACK_IMPORTED_MODULE_10_moment___default()(field.taskCompletionDate).format('M/D/YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_10_moment___default()(field.startDate).format('M/D/YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,field.durationInDays),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,field.materialLeadDays),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'total-cost-readonly'},__WEBPACK_IMPORTED_MODULE_11_numeral___default()(field.totalCost).format('$0,0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,field.description));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Submit Quotes',onClick:this.handleSubmit}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:'Edit Quotes',onClick:function onClick(){return _this2.props.onSetCreateQuotesModalState('edit');}})));}}]);return CreateQuotesModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CreateQuotesModal.propTypes={createQuotesForm:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),createQuotesModalState:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,currentUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,currentWorkOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,quotes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,showCreateQuotesModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,onContinue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onDeselectAllTasks:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onQuotesSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSetCreateQuotesModalState:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onShowCreateQuotesModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};CreateQuotesModal.defaultProps={createQuotesForm:null};function mapStateToProps(state){return{createQuotesForm:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_create_quote__["a" /* createQuotesFormSelector */])(state),createQuotesModalState:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_create_quote__["b" /* createQuotesModalStateSelector */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_17_selectors_authentication__["d" /* getCurrentUser */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_15_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),quotes:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_details_details__["m" /* getQuotes */])(state),selectedTasks:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_details_details__["s" /* getSelectedTasks */])(state),showCreateQuotesModal:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_create_quote__["h" /* showCreateQuotesModalSelector */])(state)};}var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onContinue:function onContinue(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_create_quote__["b" /* continueCreateQuotes */])(values));},onDeselectAllTasks:function onDeselectAllTasks(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_actions_admin_work_orders_details_details__["t" /* deselectAllTasks */])());},onQuotesSubmit:function onQuotesSubmit(workOrderId,contractorId,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_create_quote__["l" /* submitQuotes */])(workOrderId,contractorId,values));},onSetCreateQuotesModalState:function onSetCreateQuotesModalState(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_create_quote__["g" /* setCreateQuotesModalState */])(value));},onShowCreateQuotesModal:function onShowCreateQuotesModal(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_create_quote__["h" /* setShowCreateQuotesModal */])(value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CreateQuotesModal));

/***/ }),
/* 1970 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateQuotesForm_css__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateQuotesForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CreateQuotesForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_form_FormDateTimePicker__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_form_FormDropDown__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_quotes_CreateQuoteModal__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_form_FormInput__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_form_FormTextArea__ = __webpack_require__(418);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateQuotesForm=function(_Component){_inherits(CreateQuotesForm,_Component);function CreateQuotesForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CreateQuotesForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CreateQuotesForm.__proto__||Object.getPrototypeOf(CreateQuotesForm)).call.apply(_ref,[this].concat(args))),_this),_this.renderFields=function(_ref2){var fields=_ref2.fields;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,fields.map(function(item,index){var field=fields.get(index);var taskNumber=field.taskNumber;var completionDateMoment=__WEBPACK_IMPORTED_MODULE_5_moment___default()(field.taskCompletionDate);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,taskNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,field.taskType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,completionDateMoment.format('M/D/YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_3_components_shared_form_FormDateTimePicker__["a" /* default */],isValidDate:function isValidDate(date){return Object(__WEBPACK_IMPORTED_MODULE_4_services_utils_date_util__["k" /* todayValidation */])(date)&&date.isSameOrBefore(completionDateMoment);},name:item+'.startDate',placeholder:'Start date',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_shared_form_FormDropDown__["a" /* default */],name:item+'.durationInDays',options:__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_quotes_CreateQuoteModal__["a" /* default */].createDurationOptions(),placeholder:'Duration'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_shared_form_FormDropDown__["a" /* default */],clearable:true,name:item+'.materialLeadDays',options:__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_quotes_CreateQuoteModal__["a" /* default */].createMaterialLeadDaysOptions(),placeholder:'Lead Time'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_8_components_shared_form_FormInput__["a" /* default */],name:item+'.totalCost',placeholder:'Total Cost',type:'number'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_9_components_shared_form_FormTextArea__["a" /* default */],name:item+'.description',placeholder:'Is there anything the Spackle team should know regarding your quote, process or experience? (Please be sure to include any exclusions).'})));}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CreateQuotesForm,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'create-quotes-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.props.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'create-quotes-form-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'TASK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'TYPE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'TARGET COMPLETION DATE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'START DATE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'DURATION IN DAYS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'MATERIAL LEAD TIME IN DAYS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'TOTAL COST'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'DESCRIPTION/QUALIFICATIONS'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["b" /* FieldArray */],{component:this.renderFields,name:'fields'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'submit',value:'Continue'})));}}]);return CreateQuotesForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(values){var fieldsArrayErrors=[];values.fields.forEach(function(item,index){var fieldErrors={};if(!item||!item.startDate){fieldErrors.startDate='Required';fieldsArrayErrors[index]=fieldErrors;}if(!item||!item.durationInDays){fieldErrors.durationInDays='Required';fieldsArrayErrors[index]=fieldErrors;}if(!item||!item.totalCost){fieldErrors.totalCost='Required';fieldsArrayErrors[index]=fieldErrors;}});var errors={};if(fieldsArrayErrors.length>0){errors.fields=fieldsArrayErrors;}return errors;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["f" /* reduxForm */])({form:'CreateQuotesForm',validate:validate})(CreateQuotesForm));

/***/ }),
/* 1972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form(props, context) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('Form must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(Form, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', this.props);
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
Form.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};

Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Form);
/* unused harmony default export */ var _unused_webpack_default_export = (Form);

/***/ }),
/* 1973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);




var FormName = function FormName(_ref, _ref2) {
  var children = _ref.children;
  var _reduxForm = _ref2._reduxForm;
  return children({ form: _reduxForm && _reduxForm.form });
};
FormName.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    form: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (FormName);

/***/ }),
/* 1974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_prefixName__ = __webpack_require__(317);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FormSection = function (_Component) {
  _inherits(FormSection, _Component);

  function FormSection(props, context) {
    _classCallCheck(this, FormSection);

    var _this = _possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('FormSection must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(FormSection, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var context = this.context,
          name = this.props.name;

      return {
        _reduxForm: _extends({}, context._reduxForm, {
          sectionPrefix: Object(__WEBPACK_IMPORTED_MODULE_2__util_prefixName__["a" /* default */])(context, name)
        })
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          name = _props.name,
          component = _props.component,
          rest = _objectWithoutProperties(_props, ['children', 'name', 'component']);

      if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(children)) {
        return children;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, rest, {
        children: children
      }));
    }
  }]);

  return FormSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FormSection.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
};

FormSection.defaultProps = {
  component: 'div'
};

FormSection.childContextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

FormSection.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (FormSection);

/***/ }),
/* 1975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var ExtendableError = function (_extendableBuiltin2) {
  _inherits(ExtendableError, _extendableBuiltin2);

  function ExtendableError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, ExtendableError);

    // extending Error is weird and does not propagate `message`
    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    Object.defineProperty(_this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    });

    Object.defineProperty(_this, 'name', {
      configurable: true,
      enumerable: false,
      value: _this.constructor.name,
      writable: true
    });

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(_this, _this.constructor);
      return _possibleConstructorReturn(_this);
    }

    Object.defineProperty(_this, 'stack', {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true
    });
    return _this;
  }

  return ExtendableError;
}(_extendableBuiltin(Error));

/* harmony default export */ __webpack_exports__["a"] = (ExtendableError);


/***/ }),
/* 1976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formPropTypes */
/* unused harmony export fieldInputPropTypes */
/* unused harmony export fieldMetaPropTypes */
/* unused harmony export fieldArrayMetaPropTypes */
/* unused harmony export fieldArrayFieldsPropTypes */
/* unused harmony export fieldPropTypes */
/* unused harmony export fieldArrayPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var any = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
    bool = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    func = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    shape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape,
    string = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    oneOfType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType,
    object = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    number = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number;


var formPropTypes = {
  // State:
  anyTouched: bool.isRequired, // true if any of the fields have been marked as touched
  asyncValidating: oneOfType([bool, string]).isRequired, // true if async validation is running, a string if a field triggered async validation
  dirty: bool.isRequired, // true if any values are different from initialValues
  error: any, // form-wide error from '_error' key in validation result
  form: string.isRequired, // the name of the form
  invalid: bool.isRequired, // true if there are any validation errors
  initialized: bool.isRequired, // true if the form has been initialized
  initialValues: object, // the initialValues object passed to reduxForm
  pristine: bool.isRequired, // true if the values are the same as initialValues
  pure: bool.isRequired, // if true, implements shouldComponentUpdate
  submitting: bool.isRequired, // true if the form is in the process of being submitted
  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
  valid: bool.isRequired, // true if there are no validation errors
  warning: any, // form-wide warning from '_warning' key in validation result
  // Actions:
  array: shape({
    insert: func.isRequired, // function to insert a value into an array field
    move: func.isRequired, // function to move a value within an array field
    pop: func.isRequired, // function to pop a value off of an array field
    push: func.isRequired, // function to push a value onto an array field
    remove: func.isRequired, // function to remove a value from an array field
    removeAll: func.isRequired, // function to remove all the values from an array field
    shift: func.isRequired, // function to shift a value out of an array field
    splice: func.isRequired, // function to splice a value into an array field
    swap: func.isRequired, // function to swap values in an array field
    unshift: func.isRequired // function to unshift a value into an array field
  }),
  asyncValidate: func.isRequired, // function to trigger async validation
  autofill: func.isRequired, // action to set a value of a field and mark it as autofilled
  blur: func.isRequired, // action to mark a field as blurred
  change: func.isRequired, // action to change the value of a field
  clearAsyncError: func.isRequired, // action to clear the async error of a field
  clearFields: func.isRequired, // action to clean fields values for all fields
  clearSubmitErrors: func.isRequired, // action to remove submitErrors and error
  destroy: func.isRequired, // action to destroy the form's data in Redux
  dispatch: func.isRequired, // the Redux dispatch action
  handleSubmit: func.isRequired, // function to submit the form
  initialize: func.isRequired, // action to initialize form data
  reset: func.isRequired, // action to reset the form data to previously initialized values
  resetSection: func.isRequired, // action to reset the form sections data to previously initialized values
  touch: func.isRequired, // action to mark fields as touched
  submit: func.isRequired, // action to trigger a submission of the specified form
  untouch: func.isRequired, // action to mark fields as untouched

  // triggerSubmit
  triggerSubmit: bool, // if true, submits the form on componentWillReceiveProps
  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
};

var fieldInputPropTypes = {
  checked: bool,
  name: string.isRequired,
  onBlur: func.isRequired,
  onChange: func.isRequired,
  onDragStart: func.isRequired,
  onDrop: func.isRequired,
  onFocus: func.isRequired,
  value: any
};

var fieldMetaPropTypes = {
  active: bool.isRequired,
  asyncValidating: bool.isRequired,
  autofilled: bool.isRequired,
  dirty: bool.isRequired,
  dispatch: func.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitting: bool.isRequired,
  submitFailed: bool.isRequired,
  touched: bool.isRequired,
  valid: bool.isRequired,
  visited: bool.isRequired,
  warning: string
};

var fieldArrayMetaPropTypes = {
  dirty: bool.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitFailed: bool,
  submitting: bool,
  valid: bool.isRequired,
  warning: string
};

var fieldArrayFieldsPropTypes = {
  name: string.isRequired,
  forEach: func.isRequired,
  get: func.isRequired,
  getAll: func.isRequired,
  insert: func.isRequired,
  length: number.isRequired,
  map: func.isRequired,
  move: func.isRequired,
  pop: func.isRequired,
  push: func.isRequired,
  reduce: func.isRequired,
  remove: func.isRequired,
  removeAll: func.isRequired,
  shift: func.isRequired,
  swap: func.isRequired,
  unshift: func.isRequired
};

var fieldPropTypes = {
  input: shape(fieldInputPropTypes).isRequired,
  meta: shape(fieldMetaPropTypes).isRequired
};

var fieldArrayPropTypes = {
  fields: shape(fieldArrayFieldsPropTypes).isRequired,
  meta: shape(fieldArrayMetaPropTypes).isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (formPropTypes);

/***/ }),
/* 1977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createField__ = __webpack_require__(1978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createField__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedField__ = __webpack_require__(1979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_prefixName__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__structure_plain__ = __webpack_require__(42);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var createField = function createField(structure) {
  var ConnectedField = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedField__["a" /* default */])(structure);

  var setIn = structure.setIn;

  var Field = function (_Component) {
    _inherits(Field, _Component);

    function Field(props, context) {
      _classCallCheck(this, Field);

      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));

      _this.saveRef = function (ref) {
        return _this.ref = ref;
      };

      _this.normalize = function (name, value) {
        var normalize = _this.props.normalize;

        if (!normalize) {
          return value;
        }
        var previousValues = _this.context._reduxForm.getValues();
        var previousValue = _this.value;
        var nextValues = setIn(previousValues, name, value);
        return normalize(value, previousValue, nextValues, previousValues);
      };

      if (!context._reduxForm) {
        throw new Error('Field must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(Field, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'Field', function () {
          return _this2.props.validate;
        }, function () {
          return _this2.props.warn;
        });
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__["a" /* default */])(this, nextProps, nextState);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(this.context, this.props.name);
        var newName = Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(nextContext, nextProps.name);

        if (oldName !== newName ||
        // use deepEqual here because they could be a function or an array of functions
        !__WEBPACK_IMPORTED_MODULE_7__structure_plain__["a" /* default */].deepEqual(this.props.validate, nextProps.validate) || !__WEBPACK_IMPORTED_MODULE_7__structure_plain__["a" /* default */].deepEqual(this.props.warn, nextProps.warn)) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'Field', function () {
            return nextProps.validate;
          }, function () {
            return nextProps.warn;
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
        return this.ref ? this.ref.getWrappedInstance().getRenderedComponent() : undefined;
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedField, _extends({}, this.props, {
          name: this.name,
          normalize: this.normalize,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.pristine;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().isPristine());
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref && this.ref.getWrappedInstance().getValue();
      }
    }]);

    return Field;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Field.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    normalize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onDragStart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onDrop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    immutableProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string)
  };
  Field.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Field);
  return Field;
};

/* harmony default export */ __webpack_exports__["a"] = (createField);

/***/ }),
/* 1979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__ = __webpack_require__(1981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isReactNative__ = __webpack_require__(914);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var propsToNotUpdateFor = ['_reduxForm'];

var isObject = function isObject(entity) {
  return entity && (typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) === 'object';
};

var isFunction = function isFunction(entity) {
  return entity && typeof entity === 'function';
};

var eventPreventDefault = function eventPreventDefault(event) {
  if (isObject(event) && isFunction(event.preventDefault)) {
    event.preventDefault();
  }
};

var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
    return event.dataTransfer.getData(key);
  }
};

var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
    event.dataTransfer.setData(key, value);
  }
};

var createConnectedField = function createConnectedField(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn;

  var getSyncError = function getSyncError(syncErrors, name) {
    var error = __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name);
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return error && error._error ? error._error : error;
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedField = function (_Component) {
    _inherits(ConnectedField, _Component);

    function ConnectedField() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedField);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        return _this.ref = ref;
      }, _this.isPristine = function () {
        return _this.props.pristine;
      }, _this.getValue = function () {
        return _this.props.value;
      }, _this.handleChange = function (event) {
        var _this$props = _this.props,
            name = _this$props.name,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            normalize = _this$props.normalize,
            onChange = _this$props.onChange,
            _reduxForm = _this$props._reduxForm,
            previousValue = _this$props.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        var defaultPrevented = false;
        if (onChange) {
          // Can't seem to find a way to extend Event in React Native,
          // thus I simply avoid adding preventDefault() in a RN environment
          // to prevent the following error:
          // `One of the sources for assign has an enumerable key on the prototype chain`
          // Reference: https://github.com/facebook/react-native/issues/5507
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onChange(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onChange(event, newValue, previousValue, name);
          }
        }
        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));

          // call post-change callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'change');
          }
        }
      }, _this.handleFocus = function (event) {
        var _this$props2 = _this.props,
            name = _this$props2.name,
            dispatch = _this$props2.dispatch,
            onFocus = _this$props2.onFocus,
            _reduxForm = _this$props2._reduxForm;


        var defaultPrevented = false;
        if (onFocus) {
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onFocus(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), name);
          } else {
            onFocus(event, name);
          }
        }

        if (!defaultPrevented) {
          dispatch(_reduxForm.focus(name));
        }
      }, _this.handleBlur = function (event) {
        var _this$props3 = _this.props,
            name = _this$props3.name,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            normalize = _this$props3.normalize,
            onBlur = _this$props3.onBlur,
            _reduxForm = _this$props3._reduxForm,
            _value = _this$props3._value,
            previousValue = _this$props3.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        // for checkbox and radio, if the value property of checkbox or radio equals
        // the value passed by blur event, then fire blur action with previousValue.
        if (newValue === _value && _value !== undefined) {
          newValue = previousValue;
        }

        var defaultPrevented = false;
        if (onBlur) {
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onBlur(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onBlur(event, newValue, previousValue, name);
          }
        }

        if (!defaultPrevented) {
          // dispatch blur action
          dispatch(_reduxForm.blur(name, newValue));

          // call post-blur callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'blur');
          }
        }
      }, _this.handleDragStart = function (event) {
        var _this$props4 = _this.props,
            name = _this$props4.name,
            onDragStart = _this$props4.onDragStart,
            value = _this$props4.value;

        eventDataTransferSetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */], value == null ? '' : value);

        if (onDragStart) {
          onDragStart(event, name);
        }
      }, _this.handleDrop = function (event) {
        var _this$props5 = _this.props,
            name = _this$props5.name,
            dispatch = _this$props5.dispatch,
            onDrop = _this$props5.onDrop,
            _reduxForm = _this$props5._reduxForm,
            previousValue = _this$props5.value;

        var newValue = eventDataTransferGetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */]);

        var defaultPrevented = false;
        if (onDrop) {
          onDrop(_extends({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }), newValue, previousValue, name);
        }

        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));
          eventPreventDefault(event);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedField, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          if (~(nextProps.immutableProps || []).indexOf(prop)) {
            return _this2.props[prop] !== nextProps[prop];
          }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            normalize = _props.normalize,
            onBlur = _props.onBlur,
            onChange = _props.onChange,
            onFocus = _props.onFocus,
            onDragStart = _props.onDragStart,
            onDrop = _props.onDrop,
            immutableProps = _props.immutableProps,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'normalize', 'onBlur', 'onChange', 'onFocus', 'onDragStart', 'onDrop', 'immutableProps']);

        var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, rest, {
          form: _reduxForm.form,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onDrop: this.handleDrop,
          onDragStart: this.handleDragStart,
          onFocus: this.handleFocus
        })),
            custom = _createFieldProps.custom,
            props = _objectWithoutProperties(_createFieldProps, ['custom']);

        if (withRef) {
          custom.ref = this.saveRef;
        }
        if (typeof component === 'string') {
          var input = props.input,
              meta = props.meta; // eslint-disable-line no-unused-vars
          // flatten input into other props

          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, input, custom));
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, props, custom));
        }
      }
    }]);

    return ConnectedField;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedField.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initialState = getIn(formState, 'initial.' + name);
    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name),
      asyncValidating: getIn(formState, 'asyncValidating') === name,
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      initial: initial,
      value: value,
      _value: ownProps.value // save value passed in (for checkboxes)
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedField);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedField);

/***/ }),
/* 1980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(913);



var getSelectedValues = function getSelectedValues(options) {
  var result = [];
  if (options) {
    for (var index = 0; index < options.length; index++) {
      var option = options[index];
      if (option.selected) {
        result.push(option.value);
      }
    }
  }
  return result;
};

var getValue = function getValue(event, isReactNative) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event)) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
      return event.nativeEvent.text;
    }
    if (isReactNative && event.nativeEvent !== undefined) {
      return event.nativeEvent.text;
    }
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target,
        type = _detypedEvent$target.type,
        value = _detypedEvent$target.value,
        checked = _detypedEvent$target.checked,
        files = _detypedEvent$target.files,
        dataTransfer = detypedEvent.dataTransfer;

    if (type === 'checkbox') {
      return !!checked;
    }
    if (type === 'file') {
      return files || dataTransfer && dataTransfer.files;
    }
    if (type === 'select-multiple') {
      return getSelectedValues(event.target.options);
    }
    return value;
  }
  return event;
};

/* harmony default export */ __webpack_exports__["a"] = (getValue);

/***/ }),
/* 1981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataKey; });
var dataKey = 'text';

/***/ }),
/* 1982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var splice = function splice(array, index, removeNum, value) {
  array = array || [];

  if (index < array.length) {
    if (value === undefined && !removeNum) {
      // inserting undefined
      var _copy2 = [].concat(_toConsumableArray(array));
      _copy2.splice(index, 0, true); // temporary placeholder
      _copy2[index] = undefined; // set to undefined
      return _copy2;
    }
    if (value != null) {
      var _copy3 = [].concat(_toConsumableArray(array));
      _copy3.splice(index, removeNum, value); // removing and adding
      return _copy3;
    }
    var _copy = [].concat(_toConsumableArray(array));
    _copy.splice(index, removeNum); // removing
    return _copy;
  }
  if (removeNum) {
    // trying to remove non-existant item: return original array
    return array;
  }
  // trying to add outside of range: just set value
  var copy = [].concat(_toConsumableArray(array));
  copy[index] = value;
  return copy;
};

/* harmony default export */ __webpack_exports__["a"] = (splice);

/***/ }),
/* 1983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(406);



var getIn = function getIn(state, field) {
  if (!state) {
    return state;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field);
  var length = path.length;
  if (!length) {
    return undefined;
  }

  var result = state;
  for (var i = 0; i < length && result; ++i) {
    result = result[path[i]];
  }

  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getIn);

/***/ }),
/* 1984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoize_js__ = __webpack_require__(1985);


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__memoize_js__["a" /* default */])(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeCapped);


/***/ }),
/* 1985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(563);


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */]);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 1986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hash_js__ = __webpack_require__(1987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListCache_js__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_js__ = __webpack_require__(565);




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */],
    'map': new (__WEBPACK_IMPORTED_MODULE_2__Map_js__["a" /* default */] || __WEBPACK_IMPORTED_MODULE_1__ListCache_js__["a" /* default */]),
    'string': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheClear);


/***/ }),
/* 1987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hashClear_js__ = __webpack_require__(1988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__ = __webpack_require__(1993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hashGet_js__ = __webpack_require__(1994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashHas_js__ = __webpack_require__(1995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hashSet_js__ = __webpack_require__(1996);






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__hashClear_js__["a" /* default */];
Hash.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__["a" /* default */];
Hash.prototype.get = __WEBPACK_IMPORTED_MODULE_2__hashGet_js__["a" /* default */];
Hash.prototype.has = __WEBPACK_IMPORTED_MODULE_3__hashHas_js__["a" /* default */];
Hash.prototype.set = __WEBPACK_IMPORTED_MODULE_4__hashSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Hash);


/***/ }),
/* 1988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(408);


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? Object(__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */])(null) : {};
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (hashClear);


/***/ }),
/* 1989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__(1990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__(918);





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),
/* 1990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(1991);


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),
/* 1991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(152);


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),
/* 1992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),
/* 1993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (hashDelete);


/***/ }),
/* 1994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(408);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */]) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (hashGet);


/***/ }),
/* 1995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(408);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/* harmony default export */ __webpack_exports__["a"] = (hashHas);


/***/ }),
/* 1996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(408);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (hashSet);


/***/ }),
/* 1997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheClear);


/***/ }),
/* 1998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(410);


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheDelete);


/***/ }),
/* 1999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(410);


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheGet);


/***/ }),
/* 2000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(410);


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(this.__data__, key) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheHas);


/***/ }),
/* 2001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(410);


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheSet);


/***/ }),
/* 2002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(411);


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheDelete);


/***/ }),
/* 2003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ __webpack_exports__["a"] = (isKeyable);


/***/ }),
/* 2004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(411);


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheGet);


/***/ }),
/* 2005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(411);


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheHas);


/***/ }),
/* 2006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(411);


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheSet);


/***/ }),
/* 2007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(407);





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),
/* 2008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(406);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
  if (pathIndex >= path.length) {
    return value;
  }

  var first = path[pathIndex];
  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
  var next = setInWithPath(firstState, value, path, pathIndex + 1);

  if (!state) {
    if (isNaN(first)) {
      return _defineProperty({}, first, next);
    }
    var initialized = [];
    initialized[parseInt(first, 10)] = next;
    return initialized;
  }

  if (Array.isArray(state)) {
    var copy = [].concat(state);
    copy[parseInt(first, 10)] = next;
    return copy;
  }

  return _extends({}, state, _defineProperty({}, first, next));
};

var setIn = function setIn(state, field, value) {
  return setInWithPath(state, value, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field), 0);
};

/* harmony default export */ __webpack_exports__["a"] = (setIn);

/***/ }),
/* 2009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);




var customizer = function customizer(obj, other) {
  if (obj === other) return true;

  if (!obj && !other) {
    var objIsEmpty = obj === null || obj === undefined || obj === '';
    var otherIsEmpty = other === null || other === undefined || other === '';
    return objIsEmpty === otherIsEmpty;
  }

  if (obj && other && obj._error !== other._error) return false;
  if (obj && other && obj._warning !== other._warning) return false;
  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(obj) || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(other)) return false;
};

var deepEqual = function deepEqual(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(a, b, customizer);
};

/* harmony default export */ __webpack_exports__["a"] = (deepEqual);

/***/ }),
/* 2010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equalArrays_js__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equalByTag_js__ = __webpack_require__(2021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalObjects_js__ = __webpack_require__(2024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getTag_js__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArray_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isBuffer_js__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(415);









/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(object),
      othIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(other),
      objTag = objIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(object),
      othTag = othIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(object)) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    return (objIsArr || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(object))
      ? Object(__WEBPACK_IMPORTED_MODULE_1__equalArrays_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack)
      : Object(__WEBPACK_IMPORTED_MODULE_2__equalByTag_js__["a" /* default */])(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  return Object(__WEBPACK_IMPORTED_MODULE_3__equalObjects_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqualDeep);


/***/ }),
/* 2011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(409);


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (stackClear);


/***/ }),
/* 2012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (stackDelete);


/***/ }),
/* 2013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackGet);


/***/ }),
/* 2014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackHas);


/***/ }),
/* 2015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapCache_js__ = __webpack_require__(563);




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */]) {
    var pairs = data.__data__;
    if (!__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_2__MapCache_js__["a" /* default */](pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (stackSet);


/***/ }),
/* 2016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__ = __webpack_require__(2018);




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__["a" /* default */];
SetCache.prototype.has = __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (SetCache);


/***/ }),
/* 2017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheAdd);


/***/ }),
/* 2018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheHas);


/***/ }),
/* 2019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (arraySome);


/***/ }),
/* 2020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (cacheHas);


/***/ }),
/* 2021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eq_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalArrays_js__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__ = __webpack_require__(2022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setToArray_js__ = __webpack_require__(2023);







/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](object), new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return Object(__WEBPACK_IMPORTED_MODULE_2__eq_js__["a" /* default */])(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__["a" /* default */];

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = __WEBPACK_IMPORTED_MODULE_5__setToArray_js__["a" /* default */]);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = Object(__WEBPACK_IMPORTED_MODULE_3__equalArrays_js__["a" /* default */])(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (equalByTag);


/***/ }),
/* 2022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapToArray);


/***/ }),
/* 2023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (setToArray);


/***/ }),
/* 2024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__ = __webpack_require__(2025);


/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(object),
      objLength = objProps.length,
      othProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalObjects);


/***/ }),
/* 2025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(2026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(2028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(567);




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeys);


/***/ }),
/* 2026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(2027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(145);



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(object) ? result : Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, symbolsFunc(object));
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetAllKeys);


/***/ }),
/* 2027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayPush);


/***/ }),
/* 2028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(2029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubArray_js__ = __webpack_require__(2030);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_1__stubArray_js__["a" /* default */] : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbols);


/***/ }),
/* 2029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayFilter);


/***/ }),
/* 2030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (stubArray);


/***/ }),
/* 2031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),
/* 2032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(223);



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),
/* 2033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 2034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(223);




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 2036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(739);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(300)(module)))

/***/ }),
/* 2037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(741);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),
/* 2038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(152);



/* Built-in method references that are verified to be native. */
var DataView = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),
/* 2039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(152);



/* Built-in method references that are verified to be native. */
var Promise = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),
/* 2040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(152);



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 2041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(152);



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 2042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(406);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function deleteInWithPath(state, first) {
  if (state === undefined || state === null || first === undefined || first === null) {
    return state;
  }

  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  if (rest.length) {
    if (Array.isArray(state)) {
      if (isNaN(first)) {
        throw new Error('Must access array elements with a number, not "' + String(first) + '".');
      }
      var firstIndex = Number(first);
      if (firstIndex < state.length) {
        var result = deleteInWithPath.apply(undefined, [state && state[firstIndex]].concat(_toConsumableArray(rest)));
        if (result !== state[firstIndex]) {
          var copy = [].concat(_toConsumableArray(state));
          copy[firstIndex] = result;
          return copy;
        }
      }
      return state;
    }
    if (first in state) {
      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(_toConsumableArray(rest)));
      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
    }
    return state;
  }
  if (Array.isArray(state)) {
    if (isNaN(first)) {
      throw new Error('Cannot delete non-numerical index from an array. Given: "' + String(first));
    }
    var _firstIndex = Number(first);
    if (_firstIndex < state.length) {
      var _copy = [].concat(_toConsumableArray(state));
      _copy.splice(_firstIndex, 1);
      return _copy;
    }
    return state;
  }
  if (first in state) {
    var _copy2 = _extends({}, state);
    delete _copy2[first];
    return _copy2;
  }
  return state;
}

var deleteIn = function deleteIn(state, field) {
  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field))));
};

/* harmony default export */ __webpack_exports__["a"] = (deleteIn);

/***/ }),
/* 2043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function keys(value) {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.map(function (i) {
      return i.name;
    });
  }

  return Object.keys(value);
}


/* harmony default export */ __webpack_exports__["a"] = (keys);

/***/ }),
/* 2044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFields__ = __webpack_require__(2045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFields__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedFields__ = __webpack_require__(2046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_prefixName__ = __webpack_require__(317);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var validateNameProp = function validateNameProp(prop) {
  if (!prop) {
    return new Error('No "names" prop was specified <Fields/>');
  }
  if (!Array.isArray(prop) && !prop._isFieldArray) {
    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
  }
};

var createFields = function createFields(structure) {
  var ConnectedFields = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedFields__["a" /* default */])(structure);

  var Fields = function (_Component) {
    _inherits(Fields, _Component);

    function Fields(props, context) {
      _classCallCheck(this, Fields);

      var _this = _possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));

      if (!context._reduxForm) {
        throw new Error('Fields must be inside a component decorated with reduxForm()');
      }
      var error = validateNameProp(props.names);
      if (error) {
        throw error;
      }
      return _this;
    }

    _createClass(Fields, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__["a" /* default */])(this, nextProps);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var context = this.context;
        var register = context._reduxForm.register;

        this.names.forEach(function (name) {
          return register(name, 'Field');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!__WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].deepEqual(this.props.names, nextProps.names)) {
          var context = this.context;
          var _context$_reduxForm = context._reduxForm,
              register = _context$_reduxForm.register,
              unregister = _context$_reduxForm.unregister;
          // unregister old name

          this.props.names.forEach(function (name) {
            return unregister(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name));
          });
          // register new name
          nextProps.names.forEach(function (name) {
            return register(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name), 'Field');
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var context = this.context;
        var unregister = context._reduxForm.unregister;

        this.props.names.forEach(function (name) {
          return unregister(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name));
        });
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
        return this.refs.connected.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        var context = this.context;

        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFields, _extends({}, this.props, {
          names: this.props.names.map(function (name) {
            return Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name);
          }),
          _reduxForm: this.context._reduxForm,
          ref: 'connected'
        }));
      }
    }, {
      key: 'names',
      get: function get() {
        var context = this.context;

        return this.props.names.map(function (name) {
          return Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name);
        });
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.refs.connected.getWrappedInstance().isDirty();
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !this.dirty;
      }
    }, {
      key: 'values',
      get: function get() {
        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
      }
    }]);

    return Fields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Fields.propTypes = {
    names: function names(props, propName) {
      return validateNameProp(props[propName]);
    },
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };
  Fields.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Fields);
  return Fields;
};

/* harmony default export */ __webpack_exports__["a"] = (createFields);

/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__structure_plain__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__ = __webpack_require__(912);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var propsToNotUpdateFor = ['_reduxForm'];

var createConnectedFields = function createConnectedFields(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;


  var getSyncError = function getSyncError(syncErrors, name) {
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error') || __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name);
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedFields = function (_React$Component) {
    _inherits(ConnectedFields, _React$Component);

    function ConnectedFields(props) {
      _classCallCheck(this, ConnectedFields);

      var _this = _possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).call(this, props));

      _this.onChangeFns = {};
      _this.onFocusFns = {};
      _this.onBlurFns = {};

      _this.prepareEventHandlers = function (_ref) {
        var names = _ref.names;
        return names.forEach(function (name) {
          _this.onChangeFns[name] = function (event) {
            return _this.handleChange(name, event);
          };
          _this.onFocusFns[name] = function () {
            return _this.handleFocus(name);
          };
          _this.onBlurFns[name] = function (event) {
            return _this.handleBlur(name, event);
          };
        });
      };

      _this.handleChange = function (name, event) {
        var _this$props = _this.props,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            _reduxForm = _this$props._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        dispatch(_reduxForm.change(name, value));

        // call post-change callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value, 'change');
        }
      };

      _this.handleFocus = function (name) {
        var _this$props2 = _this.props,
            dispatch = _this$props2.dispatch,
            _reduxForm = _this$props2._reduxForm;

        dispatch(_reduxForm.focus(name));
      };

      _this.handleBlur = function (name, event) {
        var _this$props3 = _this.props,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            _reduxForm = _this$props3._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        // dispatch blur action
        dispatch(_reduxForm.blur(name, value));

        // call post-blur callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value, 'blur');
        }
      };

      _this.saveRef = function (ref) {
        _this.ref = ref;
      };

      _this.prepareEventHandlers(props);
      return _this;
    }

    _createClass(ConnectedFields, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
          return !_this2.props._fields[nextName];
        }))) {
          // names has changed. The cached event handlers need to be updated
          this.prepareEventHandlers(nextProps);
        }
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this3 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'isDirty',
      value: function isDirty() {
        var _fields = this.props._fields;

        return Object.keys(_fields).some(function (name) {
          return _fields[name].dirty;
        });
      }
    }, {
      key: 'getValues',
      value: function getValues() {
        var _fields = this.props._fields;

        return Object.keys(_fields).reduce(function (accumulator, name) {
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, name, _fields[name].value);
        }, {});
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            _fields = _props._fields,
            _reduxForm = _props._reduxForm,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', '_fields', '_reduxForm']);

        var sectionPrefix = _reduxForm.sectionPrefix,
            form = _reduxForm.form;

        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
          var connectedProps = _fields[name];

          var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, connectedProps, rest, {
            form: form,
            onBlur: _this4.onBlurFns[name],
            onChange: _this4.onChangeFns[name],
            onFocus: _this4.onFocusFns[name]
          })),
              custom = _createFieldProps.custom,
              fieldProps = _objectWithoutProperties(_createFieldProps, ['custom']);

          accumulator.custom = custom;
          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, fieldName, fieldProps);
        }, {}),
            custom = _Object$keys$reduce.custom,
            props = _objectWithoutProperties(_Object$keys$reduce, ['custom']);

        if (withRef) {
          props.ref = this.saveRef;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](component, _extends({}, props, custom));
      }
    }]);

    return ConnectedFields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedFields.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,
    _fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var names = ownProps.names,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    return {
      _fields: names.reduce(function (accumulator, name) {
        var initialState = getIn(formState, 'initial.' + name);
        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
        var value = getIn(formState, 'values.' + name);
        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
        var submitting = getIn(formState, 'submitting');
        var pristine = value === initial;
        accumulator[name] = {
          asyncError: getIn(formState, 'asyncErrors.' + name),
          asyncValidating: getIn(formState, 'asyncValidating') === name,
          dirty: !pristine,
          initial: initial,
          pristine: pristine,
          state: getIn(formState, 'fields.' + name),
          submitError: getIn(formState, 'submitErrors.' + name),
          submitFailed: getIn(formState, 'submitFailed'),
          submitting: submitting,
          syncError: syncError,
          syncWarning: syncWarning,
          value: value,
          _value: ownProps.value // save value passed in (for checkboxes)
        };
        return accumulator;
      }, {})
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedFields);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFields);

/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFieldArray__ = __webpack_require__(2048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFieldArray__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedFieldArray__ = __webpack_require__(2049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_prefixName__ = __webpack_require__(317);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var wrapError = function wrapError(fn, key) {
  return fn && function () {
    var validators = toArray(fn);
    for (var i = 0; i < validators.length; i++) {
      var result = validators[i].apply(validators, arguments);
      if (result) {
        return _defineProperty({}, key, result);
      }
    }
  };
};

var createFieldArray = function createFieldArray(structure) {
  var ConnectedFieldArray = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedFieldArray__["a" /* default */])(structure);

  var FieldArray = function (_Component) {
    _inherits(FieldArray, _Component);

    function FieldArray(props, context) {
      _classCallCheck(this, FieldArray);

      var _this = _possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));

      _this.saveRef = function (ref) {
        _this.ref = ref;
      };

      if (!context._reduxForm) {
        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(FieldArray, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'FieldArray', function () {
          return wrapError(_this2.props.validate, '_error');
        }, function () {
          return wrapError(_this2.props.warn, '_warning');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
        var newName = Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(nextContext, nextProps.name);

        if (oldName !== newName) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'FieldArray');
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
        return this.ref && this.ref.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFieldArray, _extends({}, this.props, {
          name: this.name,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.ref || this.ref.getWrappedInstance().dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().pristine);
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref ? this.ref.getWrappedInstance().value : undefined;
      }
    }]);

    return FieldArray;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  FieldArray.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };
  FieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(FieldArray);
  return FieldArray;
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldArray);

/***/ }),
/* 2049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__ = __webpack_require__(2064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(42);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var propsToNotUpdateFor = ['_reduxForm', 'value'];

var createConnectedFieldArray = function createConnectedFieldArray(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;

  var getSyncError = function getSyncError(syncErrors, name) {
    // For an array, the error can _ONLY_ be under _error.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error');
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    // For an array, the warning can _ONLY_ be under _warning.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return getIn(syncWarnings, name + '._warning');
  };

  var ConnectedFieldArray = function (_React$Component) {
    _inherits(ConnectedFieldArray, _React$Component);

    function ConnectedFieldArray() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedFieldArray);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        _this.ref = ref;
      }, _this.getValue = function (index) {
        return _this.props.value && getIn(_this.props.value, String(index));
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedFieldArray, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        // Update if the elements of the value array was updated.
        var thisValue = this.props.value;
        var nextValue = nextProps.value;

        if (thisValue && nextValue) {
          var nextValueItemsSame = nextValue.every(function (val) {
            return ~thisValue.indexOf(val);
          });
          var nextValueItemsOrderChanged = nextValue.some(function (val, index) {
            return val !== thisValue[index];
          });
          if (thisValue.length !== nextValue.length || nextValueItemsSame && nextValueItemsOrderChanged || nextProps.rerenderOnEveryChange && thisValue.some(function (val, index) {
            return !deepEqual(val, nextValue[index]);
          })) {
            return true;
          }
        }

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          // useful to debug rerenders
          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
          // }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            validate = _props.validate,
            warn = _props.warn,
            rerenderOnEveryChange = _props.rerenderOnEveryChange,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'validate', 'warn', 'rerenderOnEveryChange']);

        var props = Object(__WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__["a" /* default */])(structure, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
        if (withRef) {
          props.ref = this.saveRef;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](component, props);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.props.dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return this.props.pristine;
      }
    }, {
      key: 'value',
      get: function get() {
        return this.props.value;
      }
    }]);

    return ConnectedFieldArray;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  ConnectedFieldArray.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    rerenderOnEveryChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };

  ConnectedFieldArray.defaultProps = {
    rerenderOnEveryChange: false
  };

  ConnectedFieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      value: value,
      length: size(value)
    };
  }, function (dispatch, ownProps) {
    var name = ownProps.name,
        _reduxForm = ownProps._reduxForm;
    var arrayInsert = _reduxForm.arrayInsert,
        arrayMove = _reduxForm.arrayMove,
        arrayPop = _reduxForm.arrayPop,
        arrayPush = _reduxForm.arrayPush,
        arrayRemove = _reduxForm.arrayRemove,
        arrayRemoveAll = _reduxForm.arrayRemoveAll,
        arrayShift = _reduxForm.arrayShift,
        arraySplice = _reduxForm.arraySplice,
        arraySwap = _reduxForm.arraySwap,
        arrayUnshift = _reduxForm.arrayUnshift;

    return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__["a" /* default */])({
      arrayInsert: arrayInsert,
      arrayMove: arrayMove,
      arrayPop: arrayPop,
      arrayPush: arrayPush,
      arrayRemove: arrayRemove,
      arrayRemoveAll: arrayRemoveAll,
      arrayShift: arrayShift,
      arraySplice: arraySplice,
      arraySwap: arraySwap,
      arrayUnshift: arrayUnshift
    }, function (actionCreator) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(actionCreator.bind(null, name), dispatch);
    });
  }, undefined, { withRef: true });
  return connector(ConnectedFieldArray);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFieldArray);

/***/ }),
/* 2050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFor_js__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(567);



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__baseFor_js__["a" /* default */])(object, iteratee, __WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseForOwn);


/***/ }),
/* 2051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createBaseFor);


/***/ }),
/* 2052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMatches_js__ = __webpack_require__(2053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__ = __webpack_require__(2056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__property_js__ = __webpack_require__(2061);






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */];
  }
  if (typeof value == 'object') {
    return Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value)
      ? Object(__WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__["a" /* default */])(value[0], value[1])
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseMatches_js__["a" /* default */])(value);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_4__property_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIteratee);


/***/ }),
/* 2053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__ = __webpack_require__(2054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getMatchData_js__ = __webpack_require__(2055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__ = __webpack_require__(930);




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = Object(__WEBPACK_IMPORTED_MODULE_1__getMatchData_js__["a" /* default */])(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__["a" /* default */])(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || Object(__WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__["a" /* default */])(object, source, matchData);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatches);


/***/ }),
/* 2054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__ = __webpack_require__(412);



/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */];
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? Object(__WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMatch);


/***/ }),
/* 2055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(567);



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, Object(__WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__["a" /* default */])(value)];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getMatchData);


/***/ }),
/* 2056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_js__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasIn_js__ = __webpack_require__(2058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isKey_js__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toKey_js__ = __webpack_require__(319);








/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isKey_js__["a" /* default */])(path) && Object(__WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__["a" /* default */])(srcValue)) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toKey_js__["a" /* default */])(path), srcValue);
  }
  return function(object) {
    var objValue = Object(__WEBPACK_IMPORTED_MODULE_1__get_js__["a" /* default */])(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? Object(__WEBPACK_IMPORTED_MODULE_2__hasIn_js__["a" /* default */])(object, path)
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatchesProperty);


/***/ }),
/* 2057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(931);


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ __webpack_exports__["a"] = (get);


/***/ }),
/* 2058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__ = __webpack_require__(2059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__(2060);



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && Object(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (hasIn);


/***/ }),
/* 2059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHasIn);


/***/ }),
/* 2060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIndex_js__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isLength_js__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(319);







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = Object(__WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */])(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && Object(__WEBPACK_IMPORTED_MODULE_4__isLength_js__["a" /* default */])(length) && Object(__WEBPACK_IMPORTED_MODULE_3__isIndex_js__["a" /* default */])(key, length) &&
    (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(object) || Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (hasPath);


/***/ }),
/* 2061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseProperty_js__ = __webpack_require__(2062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__ = __webpack_require__(2063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isKey_js__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toKey_js__ = __webpack_require__(319);





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isKey_js__["a" /* default */])(path) ? Object(__WEBPACK_IMPORTED_MODULE_0__baseProperty_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toKey_js__["a" /* default */])(path)) : Object(__WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__["a" /* default */])(path);
}

/* harmony default export */ __webpack_exports__["a"] = (property);


/***/ }),
/* 2062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseProperty);


/***/ }),
/* 2063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(931);


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (basePropertyDeep);


/***/ }),
/* 2064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createFieldArrayProps = function createFieldArrayProps(_ref2, name, form, sectionPrefix, getValue, _ref) {
  var getIn = _ref2.getIn;

  var arrayInsert = _ref.arrayInsert,
      arrayMove = _ref.arrayMove,
      arrayPop = _ref.arrayPop,
      arrayPush = _ref.arrayPush,
      arrayRemove = _ref.arrayRemove,
      arrayRemoveAll = _ref.arrayRemoveAll,
      arrayShift = _ref.arrayShift,
      arraySplice = _ref.arraySplice,
      arraySwap = _ref.arraySwap,
      arrayUnshift = _ref.arrayUnshift,
      asyncError = _ref.asyncError,
      dirty = _ref.dirty,
      length = _ref.length,
      pristine = _ref.pristine,
      submitError = _ref.submitError,
      state = _ref.state,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      value = _ref.value,
      props = _ref.props,
      rest = _objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;
  var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
  var finalProps = _extends({
    fields: {
      _isFieldArray: true,
      forEach: function forEach(callback) {
        return (value || []).forEach(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      get: getValue,
      getAll: function getAll() {
        return value;
      },
      insert: arrayInsert,
      length: length,
      map: function map(callback) {
        return (value || []).map(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      move: arrayMove,
      name: name,
      pop: function pop() {
        arrayPop();
        return getIn(value, String(length - 1));
      },
      push: arrayPush,
      reduce: function reduce(callback, initial) {
        return (value || []).reduce(function (accumulator, item, index) {
          return callback(accumulator, fieldName + '[' + index + ']', index, finalProps.fields);
        }, initial);
      },
      remove: arrayRemove,
      removeAll: arrayRemoveAll,
      shift: function shift() {
        arrayShift();
        return getIn(value, '0');
      },
      splice: arraySplice,
      swap: arraySwap,
      unshift: arrayUnshift
    },
    meta: {
      dirty: dirty,
      error: error,
      form: form,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: submitting,
      submitFailed: submitFailed,
      valid: !error
    }
  }, props, rest);
  return finalProps;
};


/* harmony default export */ __webpack_exports__["a"] = (createFieldArrayProps);

/***/ }),
/* 2065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__ = __webpack_require__(2066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);




var createFormValueSelector = function createFormValueSelector(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(form, 'Form value must be specified');
    var nonNullGetFormState = getFormState || function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      __WEBPACK_IMPORTED_MODULE_0_invariant___default()(fields.length, 'No fields specified');
      return fields.length === 1 ? // only selecting one field, so return its value
      getIn(nonNullGetFormState(state), form + '.values.' + fields[0]) : // selecting many fields, so return an object of field values
      fields.reduce(function (accumulator, field) {
        var value = getIn(nonNullGetFormState(state), form + '.values.' + field);
        return value === undefined ? accumulator : __WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */].setIn(accumulator, field, value);
      }, {});
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFormValueSelector);

/***/ }),
/* 2067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValues__ = __webpack_require__(2068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isEqual__ = __webpack_require__(2069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__ = __webpack_require__(2070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_prefixName__ = __webpack_require__(317);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (firstArg) {
    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    // create a class that reads current form name and creates a selector
    // return
    return function (Component) {
      var FormValues = function (_React$Component) {
        _inherits(FormValues, _React$Component);

        function FormValues(props, context) {
          _classCallCheck(this, FormValues);

          var _this = _possibleConstructorReturn(this, (FormValues.__proto__ || Object.getPrototypeOf(FormValues)).call(this, props, context));

          if (!context._reduxForm) {
            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
          }
          _this.updateComponent(props);
          return _this;
        }

        _createClass(FormValues, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(props) {
            if (typeof firstArg === 'function') {
              this.updateComponent(props);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var Component = this.Component;

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component
            // so that the connected component updates props when sectionPrefix has changed
            , _extends({ sectionPrefix: this.context._reduxForm.sectionPrefix
            }, this.props));
          }
        }, {
          key: 'updateComponent',
          value: function updateComponent(props) {
            var valuesMap = void 0;
            var resolvedFirstArg = typeof firstArg === 'function' ? firstArg(props) : firstArg;
            if (typeof resolvedFirstArg === 'string') {
              valuesMap = rest.reduce(function (result, k) {
                result[k] = k;
                return result;
              }, _defineProperty({}, resolvedFirstArg, resolvedFirstArg));
            } else {
              valuesMap = resolvedFirstArg;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__["a" /* default */])(valuesMap)) {
              // maybe that empty valuesMap is ok if firstArg is a function?
              // if this is the case, we probably should set this.Component = Component
              throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...}) or formValues((props) => name) or formValues((props) => ({propName1: propPath1, ...}))');
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isEqual__["a" /* default */])(valuesMap, this._valuesMap)) {
              // no change in valuesMap
              return;
            }
            this._valuesMap = valuesMap;
            this.setComponent();
          }
        }, {
          key: 'setComponent',
          value: function setComponent() {
            var _this2 = this;

            var formValuesSelector = function formValuesSelector(_, _ref2) {
              var sectionPrefix = _ref2.sectionPrefix;

              // Yes, we're only using connect() for listening to updates.
              // The second argument needs to be there so that connect calls
              // the selector when props change
              var getValues = _this2.context._reduxForm.getValues;

              var values = getValues();
              return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__["a" /* default */])(_this2._valuesMap, function (path) {
                return getIn(values, Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(_this2.context, path));
              });
            };
            this.Component = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(formValuesSelector, function () {
              return {};
            } // ignore dispatch
            )(function (_ref3) {
              var sectionPrefix = _ref3.sectionPrefix,
                  otherProps = _objectWithoutProperties(_ref3, ['sectionPrefix']);

              return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, otherProps);
            });
          }
        }]);

        return FormValues;
      }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

      FormValues.contextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
      };
      return FormValues;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 2069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(412);


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other);
}

/* harmony default export */ __webpack_exports__["a"] = (isEqual);


/***/ }),
/* 2070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseKeys_js__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTag_js__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArguments_js__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBuffer_js__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isPrototype_js__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(415);









/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__["a" /* default */])(value) &&
      (Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        Object(__WEBPACK_IMPORTED_MODULE_5__isBuffer_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_2__isArguments_js__["a" /* default */])(value))) {
    return !value.length;
  }
  var tag = Object(__WEBPACK_IMPORTED_MODULE_1__getTag_js__["a" /* default */])(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_6__isPrototype_js__["a" /* default */])(value)) {
    return !Object(__WEBPACK_IMPORTED_MODULE_0__baseKeys_js__["a" /* default */])(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (isEmpty);


/***/ }),
/* 2071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormError__ = __webpack_require__(2072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormError__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormError = function createGetFormError(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.error');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormError);

/***/ }),
/* 2073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__ = __webpack_require__(2074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createGetFormNames(_ref) {
  var getIn = _ref.getIn,
      keys = _ref.keys;

  return function (getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return keys(nonNullGetFormState(state));
    };
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createGetFormNames);

/***/ }),
/* 2075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__ = __webpack_require__(2076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormValues = function createGetFormValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.values');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormValues);

/***/ }),
/* 2077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__ = __webpack_require__(2078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.initial');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormInitialValues);

/***/ }),
/* 2079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__ = __webpack_require__(2080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncErrors') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncErrors);

/***/ }),
/* 2081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__ = __webpack_require__(2082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormMeta = function createGetFormMeta(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.fields') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormMeta);

/***/ }),
/* 2083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__ = __webpack_require__(2084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.asyncErrors');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormAsyncErrors);

/***/ }),
/* 2085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__ = __webpack_require__(2086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncWarnings') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncWarnings);

/***/ }),
/* 2087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__ = __webpack_require__(2088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.submitErrors') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSubmitErrors);

/***/ }),
/* 2089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isAsyncValidating__ = __webpack_require__(2090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isAsyncValidating__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsAsyncValidating = function createIsAsyncValidating(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.asyncValidating');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsAsyncValidating);

/***/ }),
/* 2091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__ = __webpack_require__(2092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPristine__ = __webpack_require__(933);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var createIsDirty = function createIsDirty(structure) {
  return function (form, getFormState) {
    var isPristine = Object(__WEBPACK_IMPORTED_MODULE_0__isPristine__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      return !isPristine.apply(undefined, [state].concat(_toConsumableArray(fields)));
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsDirty);

/***/ }),
/* 2093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__ = __webpack_require__(2094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isValid__ = __webpack_require__(573);



var createIsInvalid = function createIsInvalid(structure) {
  return function (form, getFormState) {
    var isValid = Object(__WEBPACK_IMPORTED_MODULE_0__isValid__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      return !isValid(state);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsInvalid);

/***/ }),
/* 2095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getErrorKeys = function getErrorKeys(name, type) {
  switch (type) {
    case 'Field':
      return [name, name + '._error'];
    case 'FieldArray':
      return [name + '._error'];
    default:
      throw new Error('Unknown field type');
  }
};


var createHasError = function createHasError(_ref) {
  var getIn = _ref.getIn;

  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
    if (!syncErrors && !asyncErrors && !submitErrors) {
      return false;
    }

    var name = getIn(field, 'name');
    var type = getIn(field, 'type');
    return getErrorKeys(name, type).some(function (key) {
      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
    });
  };
  return hasError;
};

/* harmony default export */ __webpack_exports__["a"] = (createHasError);

/***/ }),
/* 2096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isValid__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isValid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__ = __webpack_require__(2099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsSubmitting = function createIsSubmitting(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitting');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsSubmitting);

/***/ }),
/* 2100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__ = __webpack_require__(2101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitSucceeded');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitSucceeded);

/***/ }),
/* 2102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__ = __webpack_require__(2103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitFailed');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitFailed);

/***/ }),
/* 2104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReduxForm__ = __webpack_require__(2105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReduxForm__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__ = __webpack_require__(2106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_is_promise__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__asyncValidation__ = __webpack_require__(2129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultShouldAsyncValidate__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__events_silenceEvent__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__events_silenceEvents__ = __webpack_require__(2130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__generateValidator__ = __webpack_require__(2131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__handleSubmit__ = __webpack_require__(2132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__selectors_isValid__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__structure_plain__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_getDisplayName__ = __webpack_require__(2133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__ = __webpack_require__(2134);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



























var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
};

// extract field-specific actions

var arrayInsert = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayInsert,
    arrayMove = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayMove,
    arrayPop = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayPop,
    arrayPush = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayPush,
    arrayRemove = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayRemove,
    arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayRemoveAll,
    arrayShift = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayShift,
    arraySplice = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arraySplice,
    arraySwap = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arraySwap,
    arrayUnshift = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayUnshift,
    blur = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].blur,
    change = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].change,
    focus = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].focus,
    formActions = _objectWithoutProperties(__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */], ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);

var arrayActions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift
};

var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */])), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);

var checkSubmit = function checkSubmit(submit) {
  if (!submit || typeof submit !== 'function') {
    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
  }
  return submit;
};

/**
 * The decorator that is the main API to redux-form
 */
var createReduxForm = function createReduxForm(structure) {
  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      setIn = structure.setIn,
      keys = structure.keys,
      fromJS = structure.fromJS;

  var isValid = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_isValid__["a" /* default */])(structure);
  return function (initialConfig) {
    var config = _extends({
      touchOnBlur: true,
      touchOnChange: false,
      persistentSubmitErrors: false,
      destroyOnUnmount: true,
      shouldAsyncValidate: __WEBPACK_IMPORTED_MODULE_12__defaultShouldAsyncValidate__["a" /* default */],
      shouldValidate: __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */],
      shouldError: __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__["a" /* default */],
      shouldWarn: __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__["a" /* default */],
      enableReinitialize: false,
      keepDirtyOnReinitialize: false,
      updateUnregisteredFields: false,
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      },
      pure: true,
      forceUnregisterOnUnmount: false
    }, initialConfig);

    return function (WrappedComponent) {
      var Form = function (_Component) {
        _inherits(Form, _Component);

        function Form() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, Form);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.destroyed = false, _this.fieldCounts = {}, _this.fieldValidators = {}, _this.lastFieldValidatorKeys = [], _this.fieldWarners = {}, _this.lastFieldWarnerKeys = [], _this.innerOnSubmit = undefined, _this.submitPromise = undefined, _this.getValues = function () {
            return _this.props.values;
          }, _this.isValid = function () {
            return _this.props.valid;
          }, _this.isPristine = function () {
            return _this.props.pristine;
          }, _this.register = function (name, type, getValidator, getWarner) {
            var lastCount = _this.fieldCounts[name];
            var nextCount = (lastCount || 0) + 1;
            _this.fieldCounts[name] = nextCount;
            _this.props.registerField(name, type);
            if (getValidator) {
              _this.fieldValidators[name] = getValidator;
            }
            if (getWarner) {
              _this.fieldWarners[name] = getWarner;
            }
          }, _this.unregister = function (name) {
            var lastCount = _this.fieldCounts[name];
            if (lastCount === 1) delete _this.fieldCounts[name];else if (lastCount != null) _this.fieldCounts[name] = lastCount - 1;

            if (!_this.destroyed) {
              var _this$props = _this.props,
                  _destroyOnUnmount = _this$props.destroyOnUnmount,
                  _forceUnregisterOnUnmount = _this$props.forceUnregisterOnUnmount,
                  _unregisterField = _this$props.unregisterField;

              if (_destroyOnUnmount || _forceUnregisterOnUnmount) {
                _unregisterField(name, _destroyOnUnmount);
                if (!_this.fieldCounts[name]) {
                  delete _this.fieldValidators[name];
                  delete _this.fieldWarners[name];
                  _this.lastFieldValidatorKeys = _this.lastFieldValidatorKeys.filter(function (key) {
                    return key !== name;
                  });
                }
              } else {
                _unregisterField(name, false);
              }
            }
          }, _this.getFieldList = function (options) {
            var registeredFields = _this.props.registeredFields;
            var list = [];
            if (!registeredFields) {
              return list;
            }
            var keySeq = keys(registeredFields);
            if (options && options.excludeFieldArray) {
              keySeq = keySeq.filter(function (name) {
                return getIn(registeredFields, '[\'' + name + '\'].type') !== 'FieldArray';
              });
            }
            return fromJS(keySeq.reduce(function (acc, key) {
              acc.push(key);
              return acc;
            }, list));
          }, _this.getValidators = function () {
            var validators = {};
            Object.keys(_this.fieldValidators).forEach(function (name) {
              var validator = _this.fieldValidators[name]();
              if (validator) {
                validators[name] = validator;
              }
            });
            return validators;
          }, _this.generateValidator = function () {
            var validators = _this.getValidators();
            return Object.keys(validators).length ? Object(__WEBPACK_IMPORTED_MODULE_18__generateValidator__["a" /* default */])(validators, structure) : undefined;
          }, _this.getWarners = function () {
            var warners = {};
            Object.keys(_this.fieldWarners).forEach(function (name) {
              var warner = _this.fieldWarners[name]();
              if (warner) {
                warners[name] = warner;
              }
            });
            return warners;
          }, _this.generateWarner = function () {
            var warners = _this.getWarners();
            return Object.keys(warners).length ? Object(__WEBPACK_IMPORTED_MODULE_18__generateValidator__["a" /* default */])(warners, structure) : undefined;
          }, _this.asyncValidate = function (name, value, trigger) {
            var _this$props2 = _this.props,
                asyncBlurFields = _this$props2.asyncBlurFields,
                asyncChangeFields = _this$props2.asyncChangeFields,
                asyncErrors = _this$props2.asyncErrors,
                asyncValidate = _this$props2.asyncValidate,
                dispatch = _this$props2.dispatch,
                initialized = _this$props2.initialized,
                pristine = _this$props2.pristine,
                shouldAsyncValidate = _this$props2.shouldAsyncValidate,
                startAsyncValidation = _this$props2.startAsyncValidation,
                stopAsyncValidation = _this$props2.stopAsyncValidation,
                syncErrors = _this$props2.syncErrors,
                values = _this$props2.values;

            var submitting = !name;

            var fieldNeedsValidation = function fieldNeedsValidation() {
              var fieldNeedsValidationForBlur = asyncBlurFields && name && ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var fieldNeedsValidationForChange = asyncChangeFields && name && ~asyncChangeFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var asyncValidateByDefault = !(asyncBlurFields || asyncChangeFields);

              return submitting || asyncValidateByDefault || (trigger === 'blur' ? fieldNeedsValidationForBlur : fieldNeedsValidationForChange);
            };

            if (asyncValidate) {
              var valuesToValidate = submitting ? values : setIn(values, name, value);
              var syncValidationPasses = submitting || !getIn(syncErrors, name);
              if (fieldNeedsValidation() && shouldAsyncValidate({
                asyncErrors: asyncErrors,
                initialized: initialized,
                trigger: submitting ? 'submit' : trigger,
                blurredField: name,
                pristine: pristine,
                syncValidationPasses: syncValidationPasses
              })) {
                return Object(__WEBPACK_IMPORTED_MODULE_11__asyncValidation__["a" /* default */])(function () {
                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
                }, startAsyncValidation, stopAsyncValidation, name);
              }
            }
          }, _this.submitCompleted = function (result) {
            delete _this.submitPromise;
            return result;
          }, _this.submitFailed = function (error) {
            delete _this.submitPromise;
            throw error;
          }, _this.listenToSubmit = function (promise) {
            if (!__WEBPACK_IMPORTED_MODULE_6_is_promise___default()(promise)) {
              return promise;
            }
            _this.submitPromise = promise;
            return promise.then(_this.submitCompleted, _this.submitFailed);
          }, _this.submit = function (submitOrEvent) {
            var _this$props3 = _this.props,
                onSubmit = _this$props3.onSubmit,
                blur = _this$props3.blur,
                change = _this$props3.change,
                dispatch = _this$props3.dispatch;


            if (!submitOrEvent || Object(__WEBPACK_IMPORTED_MODULE_16__events_silenceEvent__["a" /* default */])(submitOrEvent)) {
              // submitOrEvent is an event: fire submit if not already submitting
              if (!_this.submitPromise) {
                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
                  // will call "submitOrEvent is the submit function" block below
                  return _this.innerOnSubmit();
                } else {
                  return _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_19__handleSubmit__["a" /* default */])(checkSubmit(onSubmit), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
                }
              }
            } else {
              // submitOrEvent is the submit function: return deferred submit thunk
              return Object(__WEBPACK_IMPORTED_MODULE_17__events_silenceEvents__["a" /* default */])(function () {
                return !_this.submitPromise && _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_19__handleSubmit__["a" /* default */])(checkSubmit(submitOrEvent), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
              });
            }
          }, _this.reset = function () {
            return _this.props.reset();
          }, _this.saveRef = function (ref) {
            _this.wrapped = ref;
          }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(Form, [{
          key: 'getChildContext',
          value: function getChildContext() {
            var _this2 = this;

            return {
              _reduxForm: _extends({}, this.props, {
                getFormState: function getFormState(state) {
                  return getIn(_this2.props.getFormState(state), _this2.props.form);
                },
                asyncValidate: this.asyncValidate,
                getValues: this.getValues,
                sectionPrefix: undefined,
                register: this.register,
                unregister: this.unregister,
                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
                  return _this2.innerOnSubmit = innerOnSubmit;
                }
              })
            };
          }
        }, {
          key: 'initIfNeeded',
          value: function initIfNeeded(nextProps) {
            var enableReinitialize = this.props.enableReinitialize;

            if (nextProps) {
              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
                var _keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
                this.props.initialize(nextProps.initialValues, _keepDirty, {
                  keepValues: nextProps.keepValues,
                  lastInitialValues: this.props.initialValues,
                  updateUnregisteredFields: nextProps.updateUnregisteredFields
                });
              }
            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize, {
                keepValues: this.props.keepValues,
                updateUnregisteredFields: this.props.updateUnregisteredFields
              });
            }
          }
        }, {
          key: 'updateSyncErrorsIfNeeded',
          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
            var _props = this.props,
                error = _props.error,
                updateSyncErrors = _props.updateSyncErrors;

            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
            if (!(noErrors && nextNoErrors) && (!__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(lastSyncErrors, nextSyncErrors) || !__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(error, nextError))) {
              updateSyncErrors(nextSyncErrors, nextError);
            }
          }
        }, {
          key: 'clearSubmitPromiseIfNeeded',
          value: function clearSubmitPromiseIfNeeded(nextProps) {
            var submitting = this.props.submitting;

            if (this.submitPromise && submitting && !nextProps.submitting) {
              delete this.submitPromise;
            }
          }
        }, {
          key: 'submitIfNeeded',
          value: function submitIfNeeded(nextProps) {
            var _props2 = this.props,
                clearSubmit = _props2.clearSubmit,
                triggerSubmit = _props2.triggerSubmit;

            if (!triggerSubmit && nextProps.triggerSubmit) {
              clearSubmit();
              this.submit();
            }
          }
        }, {
          key: 'shouldErrorFunction',
          value: function shouldErrorFunction() {
            var _props3 = this.props,
                shouldValidate = _props3.shouldValidate,
                shouldError = _props3.shouldError;

            var shouldValidateOverridden = shouldValidate !== __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */];
            var shouldErrorOverridden = shouldError !== __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__["a" /* default */];

            return shouldValidateOverridden && !shouldErrorOverridden ? shouldValidate : shouldError;
          }
        }, {
          key: 'validateIfNeeded',
          value: function validateIfNeeded(nextProps) {
            var _props4 = this.props,
                validate = _props4.validate,
                values = _props4.values;

            var shouldError = this.shouldErrorFunction();
            var fieldLevelValidate = this.generateValidator();
            if (validate || fieldLevelValidate) {
              var initialRender = nextProps === undefined;
              var fieldValidatorKeys = Object.keys(this.getValidators());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
                fieldValidatorKeys: fieldValidatorKeys,
                structure: structure
              };

              if (shouldError(validateParams)) {
                var propsToValidate = initialRender || !nextProps ? this.props : nextProps;

                var _merge2 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
                    _error = _merge2._error,
                    nextSyncErrors = _objectWithoutProperties(_merge2, ['_error']);

                this.lastFieldValidatorKeys = fieldValidatorKeys;
                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
              }
            } else {
              this.lastFieldValidatorKeys = [];
            }
          }
        }, {
          key: 'updateSyncWarningsIfNeeded',
          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
            var _props5 = this.props,
                warning = _props5.warning,
                syncWarnings = _props5.syncWarnings,
                updateSyncWarnings = _props5.updateSyncWarnings;

            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
            if (!(noWarnings && nextNoWarnings) && (!__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(lastSyncWarnings, nextSyncWarnings) || !__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(warning, nextWarning))) {
              updateSyncWarnings(nextSyncWarnings, nextWarning);
            }
          }
        }, {
          key: 'shouldWarnFunction',
          value: function shouldWarnFunction() {
            var _props6 = this.props,
                shouldValidate = _props6.shouldValidate,
                shouldWarn = _props6.shouldWarn;

            var shouldValidateOverridden = shouldValidate !== __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */];
            var shouldWarnOverridden = shouldWarn !== __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__["a" /* default */];

            return shouldValidateOverridden && !shouldWarnOverridden ? shouldValidate : shouldWarn;
          }
        }, {
          key: 'warnIfNeeded',
          value: function warnIfNeeded(nextProps) {
            var _props7 = this.props,
                warn = _props7.warn,
                values = _props7.values;

            var shouldWarn = this.shouldWarnFunction();
            var fieldLevelWarn = this.generateWarner();
            if (warn || fieldLevelWarn) {
              var initialRender = nextProps === undefined;
              var fieldWarnerKeys = Object.keys(this.getWarners());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
                fieldValidatorKeys: fieldWarnerKeys,
                structure: structure
              };

              if (shouldWarn(validateParams)) {
                var propsToWarn = initialRender || !nextProps ? this.props : nextProps;

                var _merge3 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
                    _warning = _merge3._warning,
                    nextSyncWarnings = _objectWithoutProperties(_merge3, ['_warning']);

                this.lastFieldWarnerKeys = fieldWarnerKeys;
                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
              }
            }
          }
        }, {
          key: 'componentWillMount',
          value: function componentWillMount() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.initIfNeeded();
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            __WEBPACK_IMPORTED_MODULE_5_invariant___default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            this.initIfNeeded(nextProps);
            this.validateIfNeeded(nextProps);
            this.warnIfNeeded(nextProps);
            this.clearSubmitPromiseIfNeeded(nextProps);
            this.submitIfNeeded(nextProps);
            var onChange = nextProps.onChange,
                values = nextProps.values,
                dispatch = nextProps.dispatch;

            if (onChange && !deepEqual(values, this.props.values)) {
              onChange(values, dispatch, nextProps, this.props.values);
            }
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps) {
            var _this3 = this;

            if (!this.props.pure) return true;
            var _config$immutableProp = config.immutableProps,
                immutableProps = _config$immutableProp === undefined ? [] : _config$immutableProp;
            // if we have children, we MUST update in React 16
            // https://twitter.com/erikras/status/915866544558788608

            return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function (prop) {
              // useful to debug rerenders
              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
              // }
              if (~immutableProps.indexOf(prop)) {
                return _this3.props[prop] !== nextProps[prop];
              }
              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
            }));
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.initIfNeeded(this.props);
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            __WEBPACK_IMPORTED_MODULE_5_invariant___default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            var _props8 = this.props,
                destroyOnUnmount = _props8.destroyOnUnmount,
                destroy = _props8.destroy;

            if (destroyOnUnmount && !Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.destroyed = true;
              destroy();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            // remove some redux-form config-only props
            /* eslint-disable no-unused-vars */
            var _props9 = this.props,
                anyTouched = _props9.anyTouched,
                array = _props9.array,
                arrayInsert = _props9.arrayInsert,
                arrayMove = _props9.arrayMove,
                arrayPop = _props9.arrayPop,
                arrayPush = _props9.arrayPush,
                arrayRemove = _props9.arrayRemove,
                arrayRemoveAll = _props9.arrayRemoveAll,
                arrayShift = _props9.arrayShift,
                arraySplice = _props9.arraySplice,
                arraySwap = _props9.arraySwap,
                arrayUnshift = _props9.arrayUnshift,
                asyncErrors = _props9.asyncErrors,
                asyncValidate = _props9.asyncValidate,
                asyncValidating = _props9.asyncValidating,
                blur = _props9.blur,
                change = _props9.change,
                clearSubmit = _props9.clearSubmit,
                destroy = _props9.destroy,
                destroyOnUnmount = _props9.destroyOnUnmount,
                forceUnregisterOnUnmount = _props9.forceUnregisterOnUnmount,
                dirty = _props9.dirty,
                dispatch = _props9.dispatch,
                enableReinitialize = _props9.enableReinitialize,
                error = _props9.error,
                focus = _props9.focus,
                form = _props9.form,
                getFormState = _props9.getFormState,
                immutableProps = _props9.immutableProps,
                initialize = _props9.initialize,
                initialized = _props9.initialized,
                initialValues = _props9.initialValues,
                invalid = _props9.invalid,
                keepDirtyOnReinitialize = _props9.keepDirtyOnReinitialize,
                keepValues = _props9.keepValues,
                updateUnregisteredFields = _props9.updateUnregisteredFields,
                pristine = _props9.pristine,
                propNamespace = _props9.propNamespace,
                registeredFields = _props9.registeredFields,
                registerField = _props9.registerField,
                reset = _props9.reset,
                resetSection = _props9.resetSection,
                setSubmitFailed = _props9.setSubmitFailed,
                setSubmitSucceeded = _props9.setSubmitSucceeded,
                shouldAsyncValidate = _props9.shouldAsyncValidate,
                shouldValidate = _props9.shouldValidate,
                shouldError = _props9.shouldError,
                shouldWarn = _props9.shouldWarn,
                startAsyncValidation = _props9.startAsyncValidation,
                startSubmit = _props9.startSubmit,
                stopAsyncValidation = _props9.stopAsyncValidation,
                stopSubmit = _props9.stopSubmit,
                submitting = _props9.submitting,
                submitFailed = _props9.submitFailed,
                submitSucceeded = _props9.submitSucceeded,
                touch = _props9.touch,
                touchOnBlur = _props9.touchOnBlur,
                touchOnChange = _props9.touchOnChange,
                persistentSubmitErrors = _props9.persistentSubmitErrors,
                syncErrors = _props9.syncErrors,
                syncWarnings = _props9.syncWarnings,
                unregisterField = _props9.unregisterField,
                untouch = _props9.untouch,
                updateSyncErrors = _props9.updateSyncErrors,
                updateSyncWarnings = _props9.updateSyncWarnings,
                valid = _props9.valid,
                validExceptSubmit = _props9.validExceptSubmit,
                values = _props9.values,
                warning = _props9.warning,
                rest = _objectWithoutProperties(_props9, ['anyTouched', 'array', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'clearSubmit', 'destroy', 'destroyOnUnmount', 'forceUnregisterOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'immutableProps', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'keepValues', 'updateUnregisteredFields', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'resetSection', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'shouldError', 'shouldWarn', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'validExceptSubmit', 'values', 'warning']);
            /* eslint-enable no-unused-vars */


            var reduxFormProps = _extends({
              array: array,
              anyTouched: anyTouched,
              asyncValidate: this.asyncValidate,
              asyncValidating: asyncValidating
            }, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({ blur: blur, change: change }, dispatch), {
              clearSubmit: clearSubmit,
              destroy: destroy,
              dirty: dirty,
              dispatch: dispatch,
              error: error,
              form: form,
              handleSubmit: this.submit,
              initialize: initialize,
              initialized: initialized,
              initialValues: initialValues,
              invalid: invalid,
              pristine: pristine,
              reset: reset,
              resetSection: resetSection,
              submitting: submitting,
              submitFailed: submitFailed,
              submitSucceeded: submitSucceeded,
              touch: touch,
              untouch: untouch,
              valid: valid,
              warning: warning
            });
            var propsToPass = _extends({}, propNamespace ? _defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
            if (isClassComponent(WrappedComponent)) {
              ;propsToPass.ref = this.saveRef;
            }
            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, propsToPass);
          }
        }]);

        return Form;
      }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

      Form.displayName = 'Form(' + Object(__WEBPACK_IMPORTED_MODULE_22__util_getDisplayName__["a" /* default */])(WrappedComponent) + ')';
      Form.WrappedComponent = WrappedComponent;
      Form.childContextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
      };
      Form.propTypes = {
        destroyOnUnmount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        forceUnregisterOnUnmount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        form: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
        immutableProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string),
        initialValues: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
        getFormState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        onSubmitFail: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        onSubmitSuccess: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        propNamespace: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
        validate: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        warn: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        touchOnBlur: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        touchOnChange: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        triggerSubmit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        persistentSubmitErrors: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        registeredFields: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
      };

      var connector = Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(function (state, props) {
        var form = props.form,
            getFormState = props.getFormState,
            initialValues = props.initialValues,
            enableReinitialize = props.enableReinitialize,
            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;

        var formState = getIn(getFormState(state) || empty, form) || empty;
        var stateInitial = getIn(formState, 'initial');
        var initialized = !!stateInitial;

        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;

        var initial = initialValues || stateInitial || empty;

        if (shouldUpdateInitialValues) {
          initial = stateInitial || empty;
        }

        var values = getIn(formState, 'values') || initial;

        if (shouldResetValues) {
          values = initial;
        }

        var pristine = shouldResetValues || deepEqual(initial, values);
        var asyncErrors = getIn(formState, 'asyncErrors');
        var syncErrors = getIn(formState, 'syncErrors') || __WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].empty;
        var syncWarnings = getIn(formState, 'syncWarnings') || __WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].empty;
        var registeredFields = getIn(formState, 'registeredFields');
        var valid = isValid(form, getFormState, false)(state);
        var validExceptSubmit = isValid(form, getFormState, true)(state);
        var anyTouched = !!getIn(formState, 'anyTouched');
        var submitting = !!getIn(formState, 'submitting');
        var submitFailed = !!getIn(formState, 'submitFailed');
        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
        var error = getIn(formState, 'error');
        var warning = getIn(formState, 'warning');
        var triggerSubmit = getIn(formState, 'triggerSubmit');
        return {
          anyTouched: anyTouched,
          asyncErrors: asyncErrors,
          asyncValidating: getIn(formState, 'asyncValidating') || false,
          dirty: !pristine,
          error: error,
          initialized: initialized,
          invalid: !valid,
          pristine: pristine,
          registeredFields: registeredFields,
          submitting: submitting,
          submitFailed: submitFailed,
          submitSucceeded: submitSucceeded,
          syncErrors: syncErrors,
          syncWarnings: syncWarnings,
          triggerSubmit: triggerSubmit,
          values: values,
          valid: valid,
          validExceptSubmit: validExceptSubmit,
          warning: warning
        };
      }, function (dispatch, initialProps) {
        var bindForm = function bindForm(actionCreator) {
          return actionCreator.bind(null, initialProps.form);
        };

        // Bind the first parameter on `props.form`
        var boundFormACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(formActions, bindForm);
        var boundArrayACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(arrayActions, bindForm);
        var boundBlur = function boundBlur(field, value) {
          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
        };
        var boundChange = function boundChange(field, value) {
          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
        };
        var boundFocus = bindForm(focus);

        // Wrap action creators with `dispatch`
        var connectedFormACs = Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundFormACs, dispatch);
        var connectedArrayACs = {
          insert: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayInsert, dispatch),
          move: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayMove, dispatch),
          pop: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayPop, dispatch),
          push: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayPush, dispatch),
          remove: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayRemove, dispatch),
          removeAll: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayRemoveAll, dispatch),
          shift: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayShift, dispatch),
          splice: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arraySplice, dispatch),
          swap: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arraySwap, dispatch),
          unshift: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayUnshift, dispatch)
        };

        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
          blur: boundBlur,
          change: boundChange,
          array: connectedArrayACs,
          focus: boundFocus,
          dispatch: dispatch
        });

        return function () {
          return computedActions;
        };
      }, undefined, { withRef: true });
      var ConnectedForm = __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(connector(Form), WrappedComponent);
      ConnectedForm.defaultProps = config;

      // build outer component to expose instance api

      var ReduxForm = function (_Component2) {
        _inherits(ReduxForm, _Component2);

        function ReduxForm() {
          _classCallCheck(this, ReduxForm);

          return _possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
        }

        _createClass(ReduxForm, [{
          key: 'submit',
          value: function submit() {
            return this.ref && this.ref.getWrappedInstance().submit();
          }
        }, {
          key: 'reset',
          value: function reset() {
            if (this.ref) {
              this.ref.getWrappedInstance().reset();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _this5 = this;

            var _props10 = this.props,
                initialValues = _props10.initialValues,
                rest = _objectWithoutProperties(_props10, ['initialValues']);

            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ConnectedForm, _extends({}, rest, {
              ref: function ref(_ref3) {
                _this5.ref = _ref3;
              },
              // convert initialValues if need to
              initialValues: fromJS(initialValues)
            }));
          }
        }, {
          key: 'valid',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isValid());
          }
        }, {
          key: 'invalid',
          get: function get() {
            return !this.valid;
          }
        }, {
          key: 'pristine',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isPristine());
          }
        }, {
          key: 'dirty',
          get: function get() {
            return !this.pristine;
          }
        }, {
          key: 'values',
          get: function get() {
            return this.ref ? this.ref.getWrappedInstance().getValues() : empty;
          }
        }, {
          key: 'fieldList',
          get: function get() {
            // mainly provided for testing
            return this.ref ? this.ref.getWrappedInstance().getFieldList() : [];
          }
        }, {
          key: 'wrappedInstance',
          get: function get() {
            // for testing
            return this.ref && this.ref.getWrappedInstance().wrapped;
          }
        }]);

        return ReduxForm;
      }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

      Object(__WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__["polyfill"])(ReduxForm);
      return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(ReduxForm, WrappedComponent);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createReduxForm);

/***/ }),
/* 2106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMerge_js__ = __webpack_require__(2107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAssigner_js__ = __webpack_require__(2120);



/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = Object(__WEBPACK_IMPORTED_MODULE_1__createAssigner_js__["a" /* default */])(function(object, source, srcIndex) {
  Object(__WEBPACK_IMPORTED_MODULE_0__baseMerge_js__["a" /* default */])(object, source, srcIndex);
});

/* harmony default export */ __webpack_exports__["a"] = (merge);


/***/ }),
/* 2107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseFor_js__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__ = __webpack_require__(2108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isObject_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keysIn_js__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__safeGet_js__ = __webpack_require__(935);








/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  Object(__WEBPACK_IMPORTED_MODULE_2__baseFor_js__["a" /* default */])(source, function(srcValue, key) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    if (Object(__WEBPACK_IMPORTED_MODULE_4__isObject_js__["a" /* default */])(srcValue)) {
      Object(__WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__["a" /* default */])(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(Object(__WEBPACK_IMPORTED_MODULE_6__safeGet_js__["a" /* default */])(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__["a" /* default */])(object, key, newValue);
    }
  }, __WEBPACK_IMPORTED_MODULE_5__keysIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMerge);


/***/ }),
/* 2108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__ = __webpack_require__(2109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__ = __webpack_require__(2110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__copyArray_js__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__ = __webpack_require__(2112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArguments_js__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isArray_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__ = __webpack_require__(2114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isBuffer_js__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isFunction_js__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isObject_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__safeGet_js__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__ = __webpack_require__(2115);
















/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(object, key),
      srcValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(srcValue),
        isBuff = !isArr && Object(__WEBPACK_IMPORTED_MODULE_8__isBuffer_js__["a" /* default */])(srcValue),
        isTyped = !isArr && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__["a" /* default */])(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(objValue)) {
        newValue = objValue;
      }
      else if (Object(__WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_3__copyArray_js__["a" /* default */])(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__["a" /* default */])(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__["a" /* default */])(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__["a" /* default */])(srcValue) || Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(srcValue)) {
      newValue = objValue;
      if (Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__["a" /* default */])(objValue);
      }
      else if (!Object(__WEBPACK_IMPORTED_MODULE_10__isObject_js__["a" /* default */])(objValue) || Object(__WEBPACK_IMPORTED_MODULE_9__isFunction_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__["a" /* default */])(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, newValue);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMergeDeep);


/***/ }),
/* 2109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(152);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(300)(module)))

/***/ }),
/* 2110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(2111);


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneTypedArray);


/***/ }),
/* 2111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__ = __webpack_require__(922);


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](result).set(new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](arrayBuffer));
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneArrayBuffer);


/***/ }),
/* 2112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(2113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isPrototype_js__ = __webpack_require__(416);




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !Object(__WEBPACK_IMPORTED_MODULE_2__isPrototype_js__["a" /* default */])(object))
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object))
    : {};
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneObject);


/***/ }),
/* 2113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(201);


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (baseCreate);


/***/ }),
/* 2114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(223);



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLikeObject);


/***/ }),
/* 2115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(2116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(936);



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(value, Object(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (toPlainObject);


/***/ }),
/* 2116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(2117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__ = __webpack_require__(417);



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      Object(__WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__["a" /* default */])(object, key, newValue);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (copyObject);


/***/ }),
/* 2117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(318);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(objValue, value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignValue);


/***/ }),
/* 2118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPrototype_js__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__ = __webpack_require__(2119);




/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__["a" /* default */])(object);
  }
  var isProto = Object(__WEBPACK_IMPORTED_MODULE_1__isPrototype_js__["a" /* default */])(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeysIn);


/***/ }),
/* 2119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (nativeKeysIn);


/***/ }),
/* 2120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(2121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(2128);



/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && Object(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/* harmony default export */ __webpack_exports__["a"] = (createAssigner);


/***/ }),
/* 2121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overRest_js__ = __webpack_require__(2122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(2124);




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__overRest_js__["a" /* default */])(func, start, __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */]), func + '');
}

/* harmony default export */ __webpack_exports__["a"] = (baseRest);


/***/ }),
/* 2122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(2123);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, this, otherArgs);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overRest);


/***/ }),
/* 2123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ __webpack_exports__["a"] = (apply);


/***/ }),
/* 2124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__ = __webpack_require__(2125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortOut_js__ = __webpack_require__(2127);



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = Object(__WEBPACK_IMPORTED_MODULE_1__shortOut_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (setToString);


/***/ }),
/* 2125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(2126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defineProperty_js__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(572);




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */] : function(func, string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */])(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(string),
    'writable': true
  });
};

/* harmony default export */ __webpack_exports__["a"] = (baseSetToString);


/***/ }),
/* 2126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (constant);


/***/ }),
/* 2127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (shortOut);


/***/ }),
/* 2128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIndex_js__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(201);





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(object) && Object(__WEBPACK_IMPORTED_MODULE_2__isIndex_js__["a" /* default */])(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(object[index], value);
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (isIterateeCall);


/***/ }),
/* 2129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);


var asyncValidation = function asyncValidation(fn, start, stop, field) {
  start(field);
  var promise = fn();
  if (!__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(promise)) {
    throw new Error('asyncValidate function passed to reduxForm must return a promise');
  }
  var handleErrors = function handleErrors(rejected) {
    return function (errors) {
      if (rejected) {
        if (errors && Object.keys(errors).length) {
          stop(errors);
          return errors;
        } else {
          stop();
          throw new Error('Asynchronous validation promise was rejected without errors.');
        }
      }
      stop();
      return Promise.resolve();
    };
  };
  return promise.then(handleErrors(false), handleErrors(true));
};

/* harmony default export */ __webpack_exports__["a"] = (asyncValidation);

/***/ }),
/* 2130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__silenceEvent__ = __webpack_require__(937);


var silenceEvents = function silenceEvents(fn) {
  return function (event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__silenceEvent__["a" /* default */])(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
  };
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvents);

/***/ }),
/* 2131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__structure_plain__ = __webpack_require__(42);



var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var getError = function getError(value, values, props, validators, name) {
  var array = toArray(validators);
  for (var i = 0; i < array.length; i++) {
    var error = array[i](value, values, props, name);
    if (error) {
      return error;
    }
  }
};

var generateValidator = function generateValidator(validators, _ref) {
  var getIn = _ref.getIn;
  return function (values, props) {
    var errors = {};
    Object.keys(validators).forEach(function (name) {
      var value = getIn(values, name);
      var error = getError(value, values, props, validators[name], name);
      if (error) {
        errors = __WEBPACK_IMPORTED_MODULE_0__structure_plain__["a" /* default */].setIn(errors, name, error);
      }
    });
    return errors;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (generateValidator);

/***/ }),
/* 2132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubmissionError__ = __webpack_require__(910);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
  var dispatch = props.dispatch,
      onSubmitFail = props.onSubmitFail,
      onSubmitSuccess = props.onSubmitSuccess,
      startSubmit = props.startSubmit,
      stopSubmit = props.stopSubmit,
      setSubmitFailed = props.setSubmitFailed,
      setSubmitSucceeded = props.setSubmitSucceeded,
      syncErrors = props.syncErrors,
      asyncErrors = props.asyncErrors,
      touch = props.touch,
      values = props.values,
      persistentSubmitErrors = props.persistentSubmitErrors;


  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched

  if (valid || persistentSubmitErrors) {
    var doSubmit = function doSubmit() {
      var result = void 0;
      try {
        result = submit(values, dispatch, props);
      } catch (submitError) {
        var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
        stopSubmit(error);
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(error, dispatch, submitError, props);
        }
        if (error || onSubmitFail) {
          // if you've provided an onSubmitFail callback, don't re-throw the error
          return error;
        } else {
          throw submitError;
        }
      }
      if (__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(result)) {
        startSubmit();
        return result.then(function (submitResult) {
          stopSubmit();
          setSubmitSucceeded();
          if (onSubmitSuccess) {
            onSubmitSuccess(submitResult, dispatch, props);
          }
          return submitResult;
        }, function (submitError) {
          var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
          stopSubmit(error);
          setSubmitFailed.apply(undefined, _toConsumableArray(fields));
          if (onSubmitFail) {
            onSubmitFail(error, dispatch, submitError, props);
          }
          if (error || onSubmitFail) {
            // if you've provided an onSubmitFail callback, don't re-throw the error
            return error;
          } else {
            throw submitError;
          }
        });
      } else {
        setSubmitSucceeded();
        if (onSubmitSuccess) {
          onSubmitSuccess(result, dispatch, props);
        }
      }
      return result;
    };

    var asyncValidateResult = asyncValidate && asyncValidate();
    if (asyncValidateResult) {
      return asyncValidateResult.then(function (asyncErrors) {
        if (asyncErrors) {
          throw asyncErrors;
        }
        return doSubmit();
      }).catch(function (asyncErrors) {
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(asyncErrors, dispatch, null, props);
        }
        return Promise.reject(asyncErrors);
      });
    } else {
      return doSubmit();
    }
  } else {
    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
    var errors = _extends({}, asyncErrors, syncErrors);
    if (onSubmitFail) {
      onSubmitFail(errors, dispatch, null, props);
    }
    return errors;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (handleSubmit);

/***/ }),
/* 2133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};


/* harmony default export */ __webpack_exports__["a"] = (getDisplayName);

/***/ }),
/* 2134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var isHotReloading = function isHotReloading() {
  return !!(typeof module !== 'undefined' && module.hot && typeof module.hot.status === 'function' && module.hot.status() === 'apply');
};

/* harmony default export */ __webpack_exports__["a"] = (isHotReloading);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(300)(module)))

/***/ }),
/* 2135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReducer__ = __webpack_require__(2136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__ = __webpack_require__(2137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__structure_plain__ = __webpack_require__(42);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var shouldDelete = function shouldDelete(_ref) {
  var getIn = _ref.getIn;
  return function (state, path) {
    var initialValuesPath = null;

    if (path.startsWith('values')) {
      initialValuesPath = path.replace('values', 'initial');
    }

    var initialValueComparison = initialValuesPath ? getIn(state, initialValuesPath) === undefined : true;

    return getIn(state, path) !== undefined && initialValueComparison;
  };
};

var isReduxFormAction = function isReduxFormAction(action) {
  return action && action.type && action.type.length > __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length && action.type.substring(0, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length) === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"];
};

function createReducer(structure) {
  var _behaviors;

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      forEach = structure.forEach,
      getIn = structure.getIn,
      setIn = structure.setIn,
      deleteIn = structure.deleteIn,
      fromJS = structure.fromJS,
      keys = structure.keys,
      size = structure.size,
      some = structure.some,
      splice = structure.splice;

  var deleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(structure)(shouldDelete);
  var plainDeleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */])(shouldDelete);
  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
    var existing = getIn(state, key + '.' + field);
    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
  };
  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
    var slice = getIn(state, key);
    var existing = __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].getIn(slice, field);
    return existing || force ? setIn(state, key, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].setIn(slice, field, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].splice(existing, index, removeNum, value))) : state;
  };
  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
    var result = state;
    var nonValuesValue = value != null ? empty : undefined;
    result = doSplice(result, 'values', field, index, removeNum, value, true);
    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
    return result;
  };

  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"], function (state, _ref2) {
    var _ref2$meta = _ref2.meta,
        field = _ref2$meta.field,
        index = _ref2$meta.index,
        payload = _ref2.payload;

    return arraySplice(state, field, index, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"], function (state, _ref3) {
    var _ref3$meta = _ref3.meta,
        field = _ref3$meta.field,
        from = _ref3$meta.from,
        to = _ref3$meta.to;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    var result = state;
    if (length) {
      rootKeys.forEach(function (key) {
        var path = key + '.' + field;
        if (getIn(result, path)) {
          var value = getIn(result, path + '[' + from + ']');
          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
        }
      });
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"], function (state, _ref4) {
    var field = _ref4.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, length - 1, 1) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"], function (state, _ref5) {
    var field = _ref5.meta.field,
        payload = _ref5.payload;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return arraySplice(state, field, length, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"], function (state, _ref6) {
    var _ref6$meta = _ref6.meta,
        field = _ref6$meta.field,
        index = _ref6$meta.index;

    return arraySplice(state, field, index, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"], function (state, _ref7) {
    var field = _ref7.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, 0, length) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"], function (state, _ref8) {
    var field = _ref8.meta.field;

    return arraySplice(state, field, 0, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"], function (state, _ref9) {
    var _ref9$meta = _ref9.meta,
        field = _ref9$meta.field,
        index = _ref9$meta.index,
        removeNum = _ref9$meta.removeNum,
        payload = _ref9.payload;

    return arraySplice(state, field, index, removeNum, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], function (state, _ref10) {
    var _ref10$meta = _ref10.meta,
        field = _ref10$meta.field,
        indexA = _ref10$meta.indexA,
        indexB = _ref10$meta.indexB;

    var result = state;
    rootKeys.forEach(function (key) {
      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
      if (valueA !== undefined || valueB !== undefined) {
        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
      }
    });
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"], function (state, _ref11) {
    var field = _ref11.meta.field,
        payload = _ref11.payload;

    return arraySplice(state, field, 0, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"], function (state, _ref12) {
    var field = _ref12.meta.field,
        payload = _ref12.payload;

    var result = state;
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    result = setIn(result, 'fields.' + field + '.autofilled', true);
    result = setIn(result, 'values.' + field, payload);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"], function (state, _ref13) {
    var _ref13$meta = _ref13.meta,
        field = _ref13$meta.field,
        touch = _ref13$meta.touch,
        payload = _ref13.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    if (field === getIn(result, 'active')) {
      result = deleteIn(result, 'active');
    }
    result = deleteIn(result, 'fields.' + field + '.active');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"], function (state, _ref14) {
    var _ref14$meta = _ref14.meta,
        field = _ref14$meta.field,
        touch = _ref14$meta.touch,
        persistentSubmitErrors = _ref14$meta.persistentSubmitErrors,
        payload = _ref14.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    if (!persistentSubmitErrors) {
      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    }
    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"], function (state) {
    return deleteIn(state, 'triggerSubmit');
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"], function (state) {
    var result = state;
    result = deleteInWithCleanUp(result, 'submitErrors');
    result = deleteIn(result, 'error');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"], function (state, _ref15) {
    var field = _ref15.meta.field;

    return deleteIn(state, 'asyncErrors.' + field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_FIELDS"], function (state, _ref16) {
    var _ref16$meta = _ref16.meta,
        keepTouched = _ref16$meta.keepTouched,
        persistentSubmitErrors = _ref16$meta.persistentSubmitErrors,
        fields = _ref16$meta.fields;

    var result = state;
    fields.forEach(function (field) {
      result = deleteInWithCleanUp(result, 'values.' + field);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
      if (!persistentSubmitErrors) {
        result = deleteInWithCleanUp(result, 'submitErrors.' + field);
      }
      result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
      if (!keepTouched) {
        result = deleteIn(result, 'fields.' + field + '.touched');
      }
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"], function (state, _ref17) {
    var field = _ref17.meta.field;

    var result = state;
    var previouslyActive = getIn(state, 'active');
    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
    result = setIn(result, 'fields.' + field + '.visited', true);
    result = setIn(result, 'fields.' + field + '.active', true);
    result = setIn(result, 'active', field);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"], function (state, _ref18) {
    var payload = _ref18.payload,
        _ref18$meta = _ref18.meta,
        keepDirty = _ref18$meta.keepDirty,
        keepSubmitSucceeded = _ref18$meta.keepSubmitSucceeded,
        updateUnregisteredFields = _ref18$meta.updateUnregisteredFields,
        keepValues = _ref18$meta.keepValues;

    var mapData = fromJS(payload);
    var result = empty; // clean all field state

    // persist old warnings, they will get recalculated if the new form values are different from the old values
    var warning = getIn(state, 'warning');
    if (warning) {
      result = setIn(result, 'warning', warning);
    }
    var syncWarnings = getIn(state, 'syncWarnings');
    if (syncWarnings) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    }

    // persist old errors, they will get recalculated if the new form values are different from the old values
    var error = getIn(state, 'error');
    if (error) {
      result = setIn(result, 'error', error);
    }
    var syncErrors = getIn(state, 'syncErrors');
    if (syncErrors) {
      result = setIn(result, 'syncErrors', syncErrors);
    }

    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }

    var previousValues = getIn(state, 'values');
    var previousInitialValues = getIn(state, 'initial');

    var newInitialValues = mapData;
    var newValues = previousValues;

    if (keepDirty && registeredFields) {
      if (!deepEqual(newInitialValues, previousInitialValues)) {
        //
        // Keep the value of dirty fields while updating the value of
        // pristine fields. This way, apps can reinitialize forms while
        // avoiding stomping on user edits.
        //
        // Note 1: The initialize action replaces all initial values
        // regardless of keepDirty.
        //
        // Note 2: When a field is dirty, keepDirty is enabled, and the field
        // value is the same as the new initial value for the field, the
        // initialize action causes the field to become pristine. That effect
        // is what we want.
        //
        var overwritePristineValue = function overwritePristineValue(name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          var previousValue = getIn(previousValues, name);

          if (deepEqual(previousValue, previousInitialValue)) {
            // Overwrite the old pristine value with the new pristine value
            var newInitialValue = getIn(newInitialValues, name);

            // This check prevents any 'setIn' call that would create useless
            // nested objects, since the path to the new field value would
            // evaluate to the same (especially for undefined values)
            if (getIn(newValues, name) !== newInitialValue) {
              newValues = setIn(newValues, name, newInitialValue);
            }
          }
        };

        if (!updateUnregisteredFields) {
          forEach(keys(registeredFields), function (name) {
            return overwritePristineValue(name);
          });
        }

        forEach(keys(newInitialValues), function (name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          if (typeof previousInitialValue === 'undefined') {
            // Add new values at the root level.
            var newInitialValue = getIn(newInitialValues, name);
            newValues = setIn(newValues, name, newInitialValue);
          }

          if (updateUnregisteredFields) {
            overwritePristineValue(name);
          }
        });
      }
    } else {
      newValues = newInitialValues;
    }

    if (keepValues) {
      forEach(keys(previousValues), function (name) {
        var previousValue = getIn(previousValues, name);

        newValues = setIn(newValues, name, previousValue);
      });

      forEach(keys(previousInitialValues), function (name) {
        var previousInitialValue = getIn(previousInitialValues, name);

        newInitialValues = setIn(newInitialValues, name, previousInitialValue);
      });
    }

    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
      result = setIn(result, 'submitSucceeded', true);
    }
    result = setIn(result, 'values', newValues);
    result = setIn(result, 'initial', newInitialValues);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"], function (state, _ref19) {
    var _ref19$payload = _ref19.payload,
        name = _ref19$payload.name,
        type = _ref19$payload.type;

    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(state, key);
    if (field) {
      var count = getIn(field, 'count') + 1;
      field = setIn(field, 'count', count);
    } else {
      field = fromJS({ name: name, type: type, count: 1 });
    }
    return setIn(state, key, field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"], function (state) {
    var result = empty;
    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }
    var values = getIn(state, 'initial');
    if (values) {
      result = setIn(result, 'values', values);
      result = setIn(result, 'initial', values);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET_SECTION"], function (state, _ref20) {
    var sections = _ref20.meta.sections;

    var result = state;

    sections.forEach(function (section) {
      result = deleteInWithCleanUp(result, 'asyncErrors.' + section);
      result = deleteInWithCleanUp(result, 'submitErrors.' + section);
      result = deleteInWithCleanUp(result, 'fields.' + section);

      var values = getIn(state, 'initial.' + section);
      result = values ? setIn(result, 'values.' + section, values) : deleteInWithCleanUp(result, 'values.' + section);
    });

    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');

    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"], function (state) {
    return setIn(state, 'triggerSubmit', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"], function (state, _ref21) {
    var field = _ref21.meta.field;

    return setIn(state, 'asyncValidating', field || true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"], function (state) {
    return setIn(state, 'submitting', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"], function (state, _ref22) {
    var payload = _ref22.payload;

    var result = state;
    result = deleteIn(result, 'asyncValidating');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
      }
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'asyncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"], function (state, _ref23) {
    var payload = _ref23.payload;

    var result = state;
    result = deleteIn(result, 'submitting');
    result = deleteIn(result, 'submitFailed');
    result = deleteIn(result, 'submitSucceeded');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      } else {
        result = deleteIn(result, 'error');
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
      } else {
        result = deleteIn(result, 'submitErrors');
      }
      result = setIn(result, 'submitFailed', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'submitErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"], function (state, _ref24) {
    var fields = _ref24.meta.fields;

    var result = state;
    result = setIn(result, 'submitFailed', true);
    result = deleteIn(result, 'submitSucceeded');
    result = deleteIn(result, 'submitting');
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    if (fields.length) {
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"], function (state) {
    var result = state;
    result = deleteIn(result, 'submitFailed');
    result = setIn(result, 'submitSucceeded', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"], function (state, _ref25) {
    var fields = _ref25.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    result = setIn(result, 'anyTouched', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"], function (state, _ref26) {
    var _ref26$payload = _ref26.payload,
        name = _ref26$payload.name,
        destroyOnUnmount = _ref26$payload.destroyOnUnmount;

    var result = state;
    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(result, key);
    if (!field) {
      return result;
    }

    var count = getIn(field, 'count') - 1;
    if (count <= 0 && destroyOnUnmount) {
      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
      result = deleteIn(result, key);
      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
        result = deleteIn(result, 'registeredFields');
      }
      var syncErrors = getIn(result, 'syncErrors');
      if (syncErrors) {
        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncErrors, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncErrors');
        } else {
          result = setIn(result, 'syncErrors', syncErrors);
        }
      }
      var syncWarnings = getIn(result, 'syncWarnings');
      if (syncWarnings) {
        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncWarnings, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncWarnings');
        } else {
          result = setIn(result, 'syncWarnings', syncWarnings);
        }
      }
      result = deleteInWithCleanUp(result, 'submitErrors.' + name);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + name);
    } else {
      field = setIn(field, 'count', count);
      result = setIn(result, key, field);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"], function (state, _ref27) {
    var fields = _ref27.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = deleteIn(result, 'fields.' + field + '.touched');
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"], function (state, _ref28) {
    var _ref28$payload = _ref28.payload,
        syncErrors = _ref28$payload.syncErrors,
        error = _ref28$payload.error;

    var result = state;
    if (error) {
      result = setIn(result, 'error', error);
      result = setIn(result, 'syncError', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'syncError');
    }
    if (Object.keys(syncErrors).length) {
      result = setIn(result, 'syncErrors', syncErrors);
    } else {
      result = deleteIn(result, 'syncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"], function (state, _ref29) {
    var _ref29$payload = _ref29.payload,
        syncWarnings = _ref29$payload.syncWarnings,
        warning = _ref29$payload.warning;

    var result = state;
    if (warning) {
      result = setIn(result, 'warning', warning);
    } else {
      result = deleteIn(result, 'warning');
    }
    if (Object.keys(syncWarnings).length) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    } else {
      result = deleteIn(result, 'syncWarnings');
    }
    return result;
  }), _behaviors);

  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
    var action = arguments[1];

    var behavior = behaviors[action.type];
    return behavior ? behavior(state, action) : state;
  };

  var byForm = function byForm(reducer) {
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

      var form = action && action.meta && action.meta.form;
      if (!form || !isReduxFormAction(action)) {
        return state;
      }
      if (action.type === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"] && action.meta && action.meta.form) {
        return action.meta.form.reduce(function (result, form) {
          return deleteInWithCleanUp(result, form);
        }, state);
      }
      var formState = getIn(state, form);
      var result = reducer(formState, action);
      return result === formState ? state : setIn(state, form, result);
    };
  };

  /**
   * Adds additional functionality to the reducer
   */
  function decorate(target) {
    target.plugin = function (reducers) {
      var _this = this;

      // use 'function' keyword to enable 'this'
      return decorate(function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

        var callPlugin = function callPlugin(processed, key) {
          var previousState = getIn(processed, key);
          var nextState = reducers[key](previousState, action, getIn(state, key));
          return nextState !== previousState ? setIn(processed, key, nextState) : processed;
        };

        var processed = _this(state, action); // run through redux-form reducer
        var form = action && action.meta && action.meta.form;

        if (form) {
          // this is an action aimed at forms, so only give it to the specified form's plugin
          return reducers[form] ? callPlugin(processed, form) : processed;
        } else {
          // this is not a form-specific action, so send it to all the plugins
          return Object.keys(reducers).reduce(callPlugin, processed);
        }
      });
    };

    return target;
  }

  return decorate(byForm(reducer));
}

/* harmony default export */ __webpack_exports__["a"] = (createReducer);

/***/ }),
/* 2137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(406);



function createDeleteInWithCleanUp(structure) {
  var shouldDeleteDefault = function shouldDeleteDefault(structure) {
    return function (state, path) {
      return structure.getIn(state, path) !== undefined;
    };
  };

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      deleteIn = structure.deleteIn,
      setIn = structure.setIn;


  return function () {
    var shouldDelete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : shouldDeleteDefault;

    var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
      if (path[path.length - 1] === ']') {
        // array path
        var pathTokens = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(path);
        pathTokens.pop();
        var parent = getIn(state, pathTokens.join('.'));
        return parent ? setIn(state, path) : state;
      }

      var result = state;

      if (shouldDelete(structure)(state, path)) {
        result = deleteIn(state, path);
      }

      var dotIndex = path.lastIndexOf('.');
      if (dotIndex > 0) {
        var parentPath = path.substring(0, dotIndex);
        if (parentPath[parentPath.length - 1] !== ']') {
          var _parent = getIn(result, parentPath);
          if (deepEqual(_parent, empty)) {
            return deleteInWithCleanUp(result, parentPath);
          }
        }
      }
      return result;
    };

    return deleteInWithCleanUp;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createDeleteInWithCleanUp);

/***/ }),
/* 2138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createValues__ = __webpack_require__(2139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 2139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (config) {
    var _prop$getFormState$co = _extends({
      prop: 'values',
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      }
    }, config),
        form = _prop$getFormState$co.form,
        prop = _prop$getFormState$co.prop,
        getFormState = _prop$getFormState$co.getFormState;

    return Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
    }
    // ignore dispatch
    );
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 2140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_checkbox_CheckBox__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_domain_quotes_status_enum__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_domain_task_status_enum__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_table_cell_addons_SimpleTaskStatus__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_utils_scroller_util__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TasksSimpleTable=function(_Component){_inherits(TasksSimpleTable,_Component);function TasksSimpleTable(props){_classCallCheck(this,TasksSimpleTable);var _this=_possibleConstructorReturn(this,(TasksSimpleTable.__proto__||Object.getPrototypeOf(TasksSimpleTable)).call(this,props));_initialiseProps.call(_this);var currentUser=_this.props.currentUser;_this.userIsContractor=__WEBPACK_IMPORTED_MODULE_3_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_3_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);_this.userIsAdmin=__WEBPACK_IMPORTED_MODULE_3_services_utils_users_util__["g" /* usersUtil */].isAdmin(currentUser)||__WEBPACK_IMPORTED_MODULE_3_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_3_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);_this.userIsSpackleAdmin=__WEBPACK_IMPORTED_MODULE_3_services_utils_users_util__["g" /* usersUtil */].hasRole(currentUser,__WEBPACK_IMPORTED_MODULE_3_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_3_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_3_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);return _this;}_createClass(TasksSimpleTable,[{key:'render',value:function render(){// Table Headers
var headers=[];if(this.showSelectTask()){headers.push(this.renderSelectAllTasks());}headers=headers.concat(['TASK #','TASK NAME','SUBTASK TYPE','FLOOR','ROOM']);if(this.userIsAdmin){headers.push('CONTRACTOR');}if(this.userIsContractor){headers.push('TASK AMOUNT');}headers.push('STATUS');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_table_SimpleTable__["a" /* default */],{headers:headers,rows:this.mapTasks(),emptyMessage:'No Tasks',onRowSelected:this.handleTaskSelection,onGenerateLink:this.handleGenerateLink});}},{key:'mapTasks',value:function mapTasks(){var _this2=this;var _props=this.props,quotes=_props.quotes,tasks=_props.tasks,changeOrderTasks=_props.changeOrderTasks;if(tasks!==undefined){return tasks.map(function(element){var taskAmount=null;var quote=null;try{quote=quotes.find(function(quote){return quote.task.id===element.id;});if(quote!==undefined&&quote.status!==__WEBPACK_IMPORTED_MODULE_6_domain_quotes_status_enum__["a" /* QuotesStatusKeys */].WITHDRAWN){var changeOrderAmount=changeOrderTasks.filter(function(cot){return cot.task_id===element.id&&(cot.status===__WEBPACK_IMPORTED_MODULE_6_domain_quotes_status_enum__["a" /* QuotesStatusKeys */].APPROVED||cot.status===__WEBPACK_IMPORTED_MODULE_6_domain_quotes_status_enum__["a" /* QuotesStatusKeys */].ACR);}).reduce(function(total,cot){return total+Math.round(cot.change_order_quote.estimate);},0);taskAmount=Math.round(quote.estimate)+changeOrderAmount;}}catch(e){console.log(e);}return[_this2.showSelectTask()?_this2.renderSelectTask(element,quote):null,element.number,element.name||'TBD',element.sub_trade.label,element.floor,element.room,_this2.userIsAdmin?element.contractor_name!==undefined&&element.contractor_name!==null?element.contractor_name:'TBD':null,_this2.userIsContractor?taskAmount!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__["a" /* default */],{value:taskAmount,format:'$0,0'}):'TBD':null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_table_cell_addons_SimpleTaskStatus__["a" /* default */],{status:element.status})].filter(function(obj){return obj;});// to remove null elements
});}else{return[];}}},{key:'renderSelectAllTasks',value:function renderSelectAllTasks(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_checkbox_CheckBox__["a" /* default */],{checked:this.props.selectAllChecked,className:'check-select-all',onChange:this.handleSelectAllCheck});}},{key:'renderSelectTask',value:function renderSelectTask(task,quote){var _this3=this;var result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);if(this.userIsSpackleAdmin&&task.status!==__WEBPACK_IMPORTED_MODULE_7_domain_task_status_enum__["b" /* TaskStatusKeys */].CLS||this.showCreateQuotes()&&quote!==null&&(quote.status===__WEBPACK_IMPORTED_MODULE_6_domain_quotes_status_enum__["a" /* QuotesStatusKeys */].WAITING||quote.status===__WEBPACK_IMPORTED_MODULE_6_domain_quotes_status_enum__["a" /* QuotesStatusKeys */].WITHDRAWN)){result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_checkbox_CheckBox__["a" /* default */],{className:'select-task',checked:this.props.selectedTasks[task.id]!==undefined,onChange:function onChange(){return _this3.handleTaskCheckSelection(task);}});}return result;}},{key:'showCreateQuotes',value:function showCreateQuotes(){var _props2=this.props,currentWorkOrder=_props2.currentWorkOrder,quotes=_props2.quotes;var correctWOStatus=currentWorkOrder.status===__WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].PENDING||currentWorkOrder.status===__WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].PLM||currentWorkOrder.status===__WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].WOA;var correctQuotesStatus=quotes.filter(function(quote){return quote.status===__WEBPACK_IMPORTED_MODULE_6_domain_quotes_status_enum__["a" /* QuotesStatusKeys */].WAITING||quote.status===__WEBPACK_IMPORTED_MODULE_6_domain_quotes_status_enum__["a" /* QuotesStatusKeys */].WITHDRAWN;}).length>0;return this.userIsContractor&&correctWOStatus&&correctQuotesStatus;}},{key:'showSelectTask',value:function showSelectTask(){var currentWorkOrder=this.props.currentWorkOrder;if(this.userIsContractor){// To decide if the task can be selected, dont check quote status
return currentWorkOrder.status===__WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].PENDING||currentWorkOrder.status===__WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].PLM||currentWorkOrder.status===__WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].WOA;}if(this.userIsSpackleAdmin){return currentWorkOrder.status===__WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].PENDING||currentWorkOrder.status===__WEBPACK_IMPORTED_MODULE_4_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].PLM;}}}]);return TasksSimpleTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TasksSimpleTable.propTypes={currentUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,currentWorkOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,quotes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,selectAllChecked:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,selectedTasks:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,tasks:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,trades:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,changeOrderTasks:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,onDeselectAllTasks:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGoToTask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onLoadTrades:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSelectAllTasks:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSelectTask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSelectTaskRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};var _initialiseProps=function _initialiseProps(){var _this4=this;this.handleGenerateLink=function(id){var tasks=_this4.props.tasks;var task=tasks[id];return task.work_order_id+'/task/'+task.id;};this.handleSelectAllCheck=function(){_this4.props.onSelectAllTasks();};this.handleTaskCheckSelection=function(taskId){_this4.props.onSelectTask(taskId);};this.handleTaskSelection=function(index){Object(__WEBPACK_IMPORTED_MODULE_10_services_utils_scroller_util__["c" /* simpleScrollToTop */])();var _props3=_this4.props,currentUser=_props3.currentUser,currentWorkOrder=_props3.currentWorkOrder,tasks=_props3.tasks,trades=_props3.trades,onDeselectAllTasks=_props3.onDeselectAllTasks,onGoToTask=_props3.onGoToTask,onLoadTrades=_props3.onLoadTrades,onSelectTaskRequest=_props3.onSelectTaskRequest;var taskId=tasks[index].id;if(trades.length===0){onLoadTrades();}onSelectTaskRequest(currentWorkOrder.id,taskId,currentUser).then(function(response){if(response.ok){onDeselectAllTasks();onGoToTask(_this4.props.currentWorkOrder.id,taskId);}});};};/* harmony default export */ __webpack_exports__["a"] = (TasksSimpleTable);

/***/ }),
/* 2141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailsTaskPreExistingConditions_css__ = __webpack_require__(2143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailsTaskPreExistingConditions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DetailsTaskPreExistingConditions_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_domain_task_status_enum__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_details_task_util__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_domain_task__ = __webpack_require__(2144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_shared_radio_button_RadioButton__ = __webpack_require__(160);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsTaskPreExistingConditions=function(_Component){_inherits(DetailsTaskPreExistingConditions,_Component);function DetailsTaskPreExistingConditions(props){_classCallCheck(this,DetailsTaskPreExistingConditions);var _this=_possibleConstructorReturn(this,(DetailsTaskPreExistingConditions.__proto__||Object.getPrototypeOf(DetailsTaskPreExistingConditions)).call(this,props));_this.handlePreExistingConditionsChange=function(value){_this.props.onPreExistingConditionsChange(value==='yes');};_this.handlePreExistingConditionsDescriptionChange=function(value){_this.props.onPreExistingConditionsDescriptionChange(value);};_this.handlePreExistingConditionsImageUpload=function(taskChecklistId,images){_this.props.onPreExistingConditionsImageUpload(taskChecklistId,images);};_this.handleRemovePreConditionsImage=function(images,taskChecklistId,imageIndex){_this.props.onPreExistingConditionsImagesRemove(taskChecklistId,images[imageIndex].id);};_this.handleSavePreExistingConditionsDescription=function(taskChecklistId){_this.props.onPreExistingConditionsSave(taskChecklistId,_this.props.preExistingConditionsDescription);};_this.userIsAdmin=__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["g" /* usersUtil */].isAdmin(props.currentUser)||__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);_this.userIsContractor=__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["f" /* TYPES */].CONTRACTOR)||_this.userIsAdmin&&!props.currentTask.awardedContractor;return _this;}_createClass(DetailsTaskPreExistingConditions,[{key:'render',value:function render(){var _props=this.props,currentTask=_props.currentTask,tasks=_props.tasks;this.task=tasks.find(function(task){return task.id===currentTask.id;});if(__WEBPACK_IMPORTED_MODULE_14_domain_task__["a" /* Task */].isStatusFulFilled(currentTask,__WEBPACK_IMPORTED_MODULE_7_domain_task_status_enum__["b" /* TaskStatusKeys */].PRE)&&Object(__WEBPACK_IMPORTED_MODULE_8_services_utils_details_task_util__["a" /* isTaskChecklistComplete */])(this.task)){if(this.userIsContractor&&currentTask.status===__WEBPACK_IMPORTED_MODULE_7_domain_task_status_enum__["b" /* TaskStatusKeys */].PRE){return this.renderEdit();}else{return this.renderReadOnly();}}return null;}},{key:'renderEdit',value:function renderEdit(){var _props2=this.props,preExistingConditions=_props2.preExistingConditions,preExistingConditionsDescription=_props2.preExistingConditionsDescription;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'task-pre-conditions-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h3'},'Pre-existing conditions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Are there any pre-existing conditions?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_radio_button_RadioButton__["a" /* default */],{options:[{value:'yes',label:'Yes'},{value:'no',label:'No'}],readOnly:this.task.task_checklist.pre_existing_images.length>0||preExistingConditionsDescription!==null&&preExistingConditionsDescription!=='',value:preExistingConditions?'yes':preExistingConditions!==null?'no':null,onChange:this.handlePreExistingConditionsChange}),preExistingConditions&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pre-existing-conditions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],images:this.task.task_checklist.pre_existing_images.map(function(image){return{preview:image.image.preview.url};}),notes:'Provide photos - close-up, distant',onRemove:this.handleRemovePreConditionsImage.bind(this,this.task.task_checklist.pre_existing_images,this.task.task_checklist.id),onUpload:this.handlePreExistingConditionsImageUpload.bind(this,this.task.task_checklist.id)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pre-existing-conditions-description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_input_TextArea__["a" /* default */],{placeholder:'Enter a description',value:preExistingConditionsDescription,onChange:this.handlePreExistingConditionsDescriptionChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Save Description',onClick:this.handleSavePreExistingConditionsDescription.bind(this,this.task.task_checklist.id)}))));}},{key:'renderReadOnly',value:function renderReadOnly(){if(this.task.task_checklist.pre_existing_images.length>0||this.task.task_checklist.pre_existing_desc!==null&&this.task.task_checklist.pre_existing_desc!==''){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'task-pre-conditions-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h3'},'Pre-existing conditions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pre-existing-conditions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_image_upload_ImageUpload__["a" /* default */],{images:this.task.task_checklist.pre_existing_images.map(function(image){return{preview:image.image.preview.url,url:image.image.url};}),readOnly:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pre-existing-conditions-description read-only'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h4'},'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.task.task_checklist.pre_existing_desc))));}return null;}}]);return DetailsTaskPreExistingConditions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DetailsTaskPreExistingConditions.propTypes={currentTask:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,currentUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,preExistingConditions:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,preExistingConditionsDescription:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,tasks:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})).isRequired,onPreExistingConditionsChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onPreExistingConditionsImageUpload:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onPreExistingConditionsImagesRemove:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onPreExistingConditionsDescriptionChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onPreExistingConditionsSave:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};DetailsTaskPreExistingConditions.defaultProps={preExistingConditions:null,preExistingConditionsDescription:''};var mapStateToProps=function mapStateToProps(state){return{currentTask:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_details__["e" /* getCurrentTask */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_authentication__["d" /* getCurrentUser */])(state),preExistingConditions:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_details__["j" /* getPreExistingConditions */])(state),preExistingConditionsDescription:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_details__["k" /* getPreExistingConditionsDescription */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onPreExistingConditionsChange:function onPreExistingConditionsChange(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_details__["_12" /* updatePreExistingConditions */])(value));},onPreExistingConditionsDescriptionChange:function onPreExistingConditionsDescriptionChange(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_details__["_13" /* updatePreExistingConditionsDescription */])(value));},onPreExistingConditionsImageUpload:function onPreExistingConditionsImageUpload(taskChecklistId,images){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_details__["_23" /* uploadPreExistingConditionsImagesRequest */])(taskChecklistId,images));},onPreExistingConditionsImagesRemove:function onPreExistingConditionsImagesRemove(taskChecklistId,imageId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_details__["Q" /* removePreExistingConditionsImagesRequest */])(taskChecklistId,imageId));},onPreExistingConditionsSave:function onPreExistingConditionsSave(taskChecklistId,description){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_details__["R" /* savePreExistingConditionsDescriptionRequest */])(taskChecklistId,description));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(DetailsTaskPreExistingConditions));

/***/ }),
/* 2143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Task; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_domain_task_status_enum__ = __webpack_require__(153);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Task=function(){function Task(){_classCallCheck(this,Task);}_createClass(Task,null,[{key:'isStatusFulFilled',/**
   * Returns true if the given task is currently or has already fulfilled the given status.
   * @param task
   * @param status
   */value:function isStatusFulFilled(task){var status=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';if(__WEBPACK_IMPORTED_MODULE_0_domain_task_status_enum__["b" /* TaskStatusKeys */][status.toUpperCase()]===undefined){return false;}// Dont take into account DECLINED and UNKNOWN status
var filteredKeys=Object.keys(__WEBPACK_IMPORTED_MODULE_0_domain_task_status_enum__["b" /* TaskStatusKeys */]);var taskIndex=filteredKeys.indexOf(task.status.toUpperCase());var givenIndex=filteredKeys.indexOf(status.toUpperCase());if(taskIndex!==-1&&givenIndex!==-1){return taskIndex>=givenIndex;}return false;}}]);return Task;}();

/***/ }),
/* 2145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChangeOrderTask_css__ = __webpack_require__(2146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChangeOrderTask_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ChangeOrderTask_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_order_quotes_ChangeOrderQuoteRequestModal__ = __webpack_require__(2147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_change_order_quotes_ChangeOrderQuoteConfirmationModal__ = __webpack_require__(2151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_work_orders_details_change_order_quotes_ChangeOrderQuoteSubmitModal__ = __webpack_require__(2152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_work_orders_details_change_order_tasks_ChangeOrderTaskModal__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_text_Number__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeOrderTask=function(_Component){_inherits(ChangeOrderTask,_Component);function ChangeOrderTask(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChangeOrderTask);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChangeOrderTask.__proto__||Object.getPrototypeOf(ChangeOrderTask)).call.apply(_ref,[this].concat(args))),_this),_this.renderImages=function(){var images=_this.props.changeOrderTask.images.map(function(img){return{id:img.id,url:img.image.url,preview:img.image.preview.url};});return images;},_this.confirmationMsg=function(){if(_this.props.showRequestQuoteBtn){return'Your change order pricing request has been sent.';}else{return'Your change order pricing has been submitted.';}},_this.renderTitle=function(){var coQuote=_this.props.changeOrderTask.change_order_quote;var title='Change Order #'+_this.props.changeOrderTask.number;if(_this.props.showEstimateInTitle&&coQuote&&coQuote.estimate){title=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,title,' - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_text_Number__["a" /* default */],{value:coQuote.estimate,format:'$0'}));}return title;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChangeOrderTask,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'change-order-task'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h3 title'},this.renderTitle()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Form */],{horizontal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-item-label'},'Target Completion Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{className:'completion-date',placeholder:'Target Completion date',readOnly:true,value:this.props.changeOrderTask.completion_date,theme:'underlined',onChange:function onChange(){}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-item-label'},'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_input_TextArea__["a" /* default */],{className:'description',placeholder:'Description',readOnly:true,value:this.props.changeOrderTask.description,theme:'underlined',onChange:function onChange(){}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_image_upload_ImageUpload__["a" /* default */],{images:this.renderImages(),readOnly:true})))),(this.props.showRequestQuoteBtn||this.props.showSubmitQuoteBtn)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-orange change-order-pricing-btn',label:'Change Order Pricing',onClick:this.props.onQuoteActionClick}),this.props.showRequestQuoteBtn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-gray change-order-pricing-btn',label:'Edit Change Order',onClick:this.props.onEditActionClick}),this.props.showDeleteCoBtn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-white change-order-pricing-btn',label:'Delete Change Order',onClick:this.props.onDeleteCoClick}),this.props.showRequestQuoteBtn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_admin_work_orders_details_change_order_tasks_ChangeOrderTaskModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_order_quotes_ChangeOrderQuoteRequestModal__["a" /* default */],{changeOrderTask:this.props.changeOrderTask})),this.props.showSubmitQuoteBtn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_admin_work_orders_details_change_order_quotes_ChangeOrderQuoteSubmitModal__["a" /* default */],{changeOrderTask:this.props.changeOrderTask})),this.props.showWithdrawQuoteBtn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-orange change-order-pricing-btn',label:'Withdraw Change Order Pricing',onClick:this.props.onWithdrawQuoteClick}),this.props.showWithdrawCoQuoteRequestBtn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-orange change-order-pricing-btn',label:'Withdraw Change Order Pricing request',onClick:this.props.onWithdrawCoQuoteRequestClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_change_order_quotes_ChangeOrderQuoteConfirmationModal__["a" /* default */],{message:this.confirmationMsg()}));}}]);return ChangeOrderTask;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ChangeOrderTask.propTypes={changeOrderTask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,showEstimateInTitle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showRequestQuoteBtn:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showSubmitQuoteBtn:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showDeleteCoBtn:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showWithdrawQuoteBtn:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showWithdrawCoQuoteRequestBtn:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onDeleteCoClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onQuoteActionClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onWithdrawQuoteClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onWithdrawCoQuoteRequestClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onEditActionClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ChangeOrderTask);

/***/ }),
/* 2146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangeOrderQuoteRequestModal_css__ = __webpack_require__(2148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangeOrderQuoteRequestModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ChangeOrderQuoteRequestModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_change_order_quotes_store_selectors__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_change_order_quotes_store_actions__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_change_order_quotes_ChangeOrderQuoteRequestForm__ = __webpack_require__(2149);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeOrderQuoteRequestModal=function(_Component){_inherits(ChangeOrderQuoteRequestModal,_Component);function ChangeOrderQuoteRequestModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChangeOrderQuoteRequestModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChangeOrderQuoteRequestModal.__proto__||Object.getPrototypeOf(ChangeOrderQuoteRequestModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_change_order_quotes_store_actions__["e" /* setShowChangeOrderQuoteModal */])());},_this.handleOnSubmit=function(values){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_change_order_quotes_store_actions__["c" /* requestChangeOrderQuote */])(_this.props.changeOrderTask.id,values));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChangeOrderQuoteRequestModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{className:'change-order-quote-request-modal',show:this.props.show,title:'Change Order Pricing',onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_change_order_quotes_ChangeOrderQuoteRequestForm__["a" /* default */],{currentTask:this.props.currentTask,changeOrderTask:this.props.changeOrderTask,onSubmit:this.handleOnSubmit})));}}]);return ChangeOrderQuoteRequestModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentTask:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_details_details__["e" /* getCurrentTask */])(state),show:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_change_order_quotes_store_selectors__["b" /* getShowChangeOrderQuoteModal */])(state)};})(ChangeOrderQuoteRequestModal));

/***/ }),
/* 2148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangeOrderQuoteRequestForm_css__ = __webpack_require__(2150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangeOrderQuoteRequestForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ChangeOrderQuoteRequestForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_form_FormDateTimePicker__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_date_util__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeOrderQuoteRequestForm=function(_Component){_inherits(ChangeOrderQuoteRequestForm,_Component);function ChangeOrderQuoteRequestForm(){_classCallCheck(this,ChangeOrderQuoteRequestForm);return _possibleConstructorReturn(this,(ChangeOrderQuoteRequestForm.__proto__||Object.getPrototypeOf(ChangeOrderQuoteRequestForm)).apply(this,arguments));}_createClass(ChangeOrderQuoteRequestForm,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'change-order-quote-request-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.props.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:4},'Contractor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold'},this.props.currentTask.contractorName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:4},'Target Completion Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Date__["a" /* default */],{format:'LL',value:this.props.changeOrderTask.completion_date})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:4},'Pricing Due Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_shared_form_FormDateTimePicker__["a" /* default */],isValidDate:__WEBPACK_IMPORTED_MODULE_6_services_utils_date_util__["k" /* todayValidation */],name:'bidDueDate',placeholder:'Pricing Due Date'}))),this.props.invalid&&this.props.submitFailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'The outlined inputs should be added in order to request change order pricing.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'submit',value:'Submit'})))));}}]);return ChangeOrderQuoteRequestForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(values){var errors={};if(!values.bidDueDate){errors.bidDueDate='Required';}return errors;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["f" /* reduxForm */])({form:'ChangeOrderQuoteRequestForm',validate:validate})(ChangeOrderQuoteRequestForm));

/***/ }),
/* 2150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_check_circle_png__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_check_circle_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_check_circle_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_change_order_quotes_store_selectors__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_change_order_quotes_store_actions__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_confirmation_ConfirmationPanel__ = __webpack_require__(141);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeOrderQuoteConfirmationModal=function(_Component){_inherits(ChangeOrderQuoteConfirmationModal,_Component);function ChangeOrderQuoteConfirmationModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChangeOrderQuoteConfirmationModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChangeOrderQuoteConfirmationModal.__proto__||Object.getPrototypeOf(ChangeOrderQuoteConfirmationModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleConfirmation=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_change_order_quotes_store_actions__["f" /* setShowChangeOrderQuoteRequestConfirmation */])());},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChangeOrderQuoteConfirmationModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{show:this.props.showConfirmation,showHeader:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_confirmation_ConfirmationPanel__["a" /* default */],{image:__WEBPACK_IMPORTED_MODULE_3_images_check_circle_png___default.a,firstLine:'Thank you!',lines:[this.props.message],buttons:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-orange',value:'Continue',onClick:this.handleConfirmation})]})));}}]);return ChangeOrderQuoteConfirmationModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{showConfirmation:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_change_order_quotes_store_selectors__["c" /* getShowChangeOrderRequestConfirmation */])(state)};})(ChangeOrderQuoteConfirmationModal));

/***/ }),
/* 2152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_order_quotes_store_selectors__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_change_order_quotes_store_actions__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_change_order_quotes_ChangeOrderQuoteSubmitForm__ = __webpack_require__(2153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeOrderQuoteSubmitModal=function(_Component){_inherits(ChangeOrderQuoteSubmitModal,_Component);function ChangeOrderQuoteSubmitModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChangeOrderQuoteSubmitModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChangeOrderQuoteSubmitModal.__proto__||Object.getPrototypeOf(ChangeOrderQuoteSubmitModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_change_order_quotes_store_actions__["e" /* setShowChangeOrderQuoteModal */])());},_this.handleOnSubmit=function(values){values.id=_this.props.changeOrderTask.change_order_quote.id;_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_change_order_quotes_store_actions__["g" /* submitChangeOrderQuote */])(_this.props.changeOrderTask.id,values));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChangeOrderQuoteSubmitModal,[{key:'render',value:function render(){var coQuote=this.props.changeOrderTask.change_order_quote;if(coQuote.status==='withdrawn'){this.initialValues={startDate:coQuote.start_date,daysOfDuration:__WEBPACK_IMPORTED_MODULE_6_numeral___default()(coQuote.days_of_duration).value(),materialLeadDays:__WEBPACK_IMPORTED_MODULE_6_numeral___default()(coQuote.material_lead_days).value(),estimate:coQuote.estimate,description:coQuote.description};}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{className:'change-order-quote-request-modal',show:this.props.show,title:'Change Order Pricing',onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_change_order_quotes_ChangeOrderQuoteSubmitForm__["a" /* default */],{changeOrderTask:this.props.changeOrderTask,initialValues:this.initialValues,onSubmit:this.handleOnSubmit})));}}]);return ChangeOrderQuoteSubmitModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{show:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_order_quotes_store_selectors__["b" /* getShowChangeOrderQuoteModal */])(state)};})(ChangeOrderQuoteSubmitModal));

/***/ }),
/* 2153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangeOrderQuoteSubmitForm_css__ = __webpack_require__(2154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangeOrderQuoteSubmitForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ChangeOrderQuoteSubmitForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_form_FormDateTimePicker__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_form_FormDropDown__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_form_FormInput__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_form_FormTextArea__ = __webpack_require__(418);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeOrderQuoteSubmitForm=function(_Component){_inherits(ChangeOrderQuoteSubmitForm,_Component);function ChangeOrderQuoteSubmitForm(){_classCallCheck(this,ChangeOrderQuoteSubmitForm);return _possibleConstructorReturn(this,(ChangeOrderQuoteSubmitForm.__proto__||Object.getPrototypeOf(ChangeOrderQuoteSubmitForm)).apply(this,arguments));}_createClass(ChangeOrderQuoteSubmitForm,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'change-order-quote-request-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.props.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:4},'Target Completion Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Date__["a" /* default */],{format:'LL',value:this.props.changeOrderTask.completion_date})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:4},'When can you get started?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_shared_form_FormDateTimePicker__["a" /* default */],isValidDate:__WEBPACK_IMPORTED_MODULE_6_services_utils_date_util__["k" /* todayValidation */],name:'startDate',placeholder:'Start Date'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:4},'How long will it take?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_7_components_shared_form_FormDropDown__["a" /* default */],options:ChangeOrderQuoteSubmitForm.createDurationOptions(),name:'daysOfDuration',placeholder:'Duration'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:4},'Material Lead Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_7_components_shared_form_FormDropDown__["a" /* default */],options:ChangeOrderQuoteSubmitForm.createMaterialLeadDaysOptions(),clearable:true,name:'materialLeadDays',placeholder:'Material Lead Time'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:4},'Total Cost'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_8_components_shared_form_FormInput__["a" /* default */],type:'number',name:'estimate',placeholder:'Total Cost'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:4},'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_9_components_shared_form_FormTextArea__["a" /* default */],name:'description',placeholder:'Is there anything the Spackle team should know, process or experience? (Please be sure to include any exclusions).'}))),this.props.invalid&&this.props.submitFailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'The outlined inputs should be added in order to submit change order pricing.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'submit',value:'Submit'})))));}}],[{key:'createDurationOptions',value:function createDurationOptions(){var result=[];for(var i=0.5;i<=15;i=i+0.5){result.push({label:i+(i<1.5?' day':' days'),value:i});}return result;}},{key:'createMaterialLeadDaysOptions',value:function createMaterialLeadDaysOptions(){var result=[];for(var i=1;i<=100;i=i+1){result.push({label:i+(i<2?' day':' days'),value:i});}return result;}}]);return ChangeOrderQuoteSubmitForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(values){var errors={};if(!values.startDate){errors.startDate='Required';}if(!values.daysOfDuration){errors.daysOfDuration='Required';}if(!values.estimate){errors.estimate='Required';}return errors;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["f" /* reduxForm */])({form:'ChangeOrderQuoteSubmitForm',validate:validate})(ChangeOrderQuoteSubmitForm));

/***/ }),
/* 2154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangeOrderTaskForm_css__ = __webpack_require__(2157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangeOrderTaskForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ChangeOrderTaskForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_form_FormTextArea__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_form_FormDateTimePicker__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_utils_date_util__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeOrderTaskForm=function(_Component){_inherits(ChangeOrderTaskForm,_Component);function ChangeOrderTaskForm(props){_classCallCheck(this,ChangeOrderTaskForm);var _this=_possibleConstructorReturn(this,(ChangeOrderTaskForm.__proto__||Object.getPrototypeOf(ChangeOrderTaskForm)).call(this,props));_initialiseProps.call(_this);_this.images=_this.props.initialValues?_this.props.initialValues.images:[];return _this;}_createClass(ChangeOrderTaskForm,[{key:'render',value:function render(){var edit=!!this.props.initialValues;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'change-order-task-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.props.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:4},'Target Completion Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_shared_form_FormDateTimePicker__["a" /* default */],isValidDate:__WEBPACK_IMPORTED_MODULE_7_services_utils_date_util__["k" /* todayValidation */],name:'completionDate',placeholder:'Target Completion Date'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:4},'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_4_components_shared_form_FormTextArea__["a" /* default */],name:'description',placeholder:'Description'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:this.imagesComponent,name:'images'}))),this.props.invalid&&this.props.submitFailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'The outlined inputs should be added in order to create a change order.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'submit',value:edit?'Update':'Create'})))));}}]);return ChangeOrderTaskForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.setImages=function(props,files){var images=_this2.images.slice();_this2.images=[];files.forEach(function(val){images.push({url:URL.createObjectURL(val),file:val});});_this2.images=images;props.input.onChange(_this2.images);};this.removeImage=function(props,index){_this2.images.splice(index,1);props.input.onChange(_this2.images);};this.imagesComponent=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],images:_this2.images,onRemove:function onRemove(index){return _this2.removeImage(props,index);},onUpload:function onUpload(files){return _this2.setImages(props,files);}});};};function validate(values){var errors={};if(!values.completionDate){errors.completionDate='Required';}if(!values.description){errors.description='Required';}return errors;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["f" /* reduxForm */])({form:'ChangeOrderTaskForm',validate:validate})(ChangeOrderTaskForm));

/***/ }),
/* 2157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__quotes_QuotesTable__ = __webpack_require__(2159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__proposals_ProposalModal__ = __webpack_require__(2163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__proposals_ProposalsTable__ = __webpack_require__(2183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_actions_admin_work_orders_details_proposal_approval__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DetailsQuotes_css__ = __webpack_require__(2185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DetailsQuotes_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__DetailsQuotes_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__quotes_QuoteDetailsModalContainer__ = __webpack_require__(2186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_selectors_admin_work_orders_details_proposal__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_actions_admin_work_orders_details_qualifications__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_domain_proposal_status_enum__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_domain_task_status_enum__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_services_utils_permissions_util__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_admin_work_orders_details_change_order_tasks_store_selectors__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_admin_work_orders_details_change_orders_store_actions__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_admin_work_orders_details_change_orders_ChangeOrderModal__ = __webpack_require__(2188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_admin_work_orders_details_change_orders_store_selectors__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_admin_work_orders_details_change_order_quotes_ChangeOrderQuoteDetailsModalContainer__ = __webpack_require__(2190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_admin_work_orders_details_change_order_quotes_store_actions__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsQuotes=function(_Component){_inherits(DetailsQuotes,_Component);function DetailsQuotes(props){_classCallCheck(this,DetailsQuotes);var _this=_possibleConstructorReturn(this,(DetailsQuotes.__proto__||Object.getPrototypeOf(DetailsQuotes)).call(this,props));_this.handleQuotesFilter=function(filter){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_details__["i" /* changeQuotesTableFilterSuccess */])(filter));};_this.handleQuotesTableRadioSelect=function(taskId,quoteId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_details__["X" /* selectQuotesTableRadio */])(taskId,quoteId));};_this.handleCreateProposalClick=function(event){event.preventDefault();var quoteEstimateByQuoteId={};var startDates=[];var completionDates=[];Object.values(_this.props.quotesSelectedByTaskId).forEach(function(quoteId){var quote=_this.props.quotes.find(function(element){return element.id===quoteId;});startDates.push(quote.start_date);completionDates.push(quote.end_date);quoteEstimateByQuoteId[quoteId]=__WEBPACK_IMPORTED_MODULE_11_numeral___default()(quote.estimate).value()+__WEBPACK_IMPORTED_MODULE_11_numeral___default()(quote.value).value();});// Clear qualifications data before showing the proposal modal
_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions_admin_work_orders_details_qualifications__["c" /* clearQualificationsSelected */])());_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions_admin_work_orders_details_qualifications__["d" /* loadDefaultQualificationsRequest */])()).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal__["u" /* showProposalModal */])(quoteEstimateByQuoteId,Object(__WEBPACK_IMPORTED_MODULE_18_services_utils_date_util__["c" /* getFirstDate */])(startDates),Object(__WEBPACK_IMPORTED_MODULE_18_services_utils_date_util__["d" /* getLastDate */])(completionDates)));}});};_this.handleProposalSelection=function(proposalId){var proposal=_this.props.proposals.find(function(prop){return prop.id===proposalId;});_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal__["j" /* loadEmailProposalDataRequest */])(proposal.number,_this.props.currentWorkOrder.number,_this.props.currentWorkOrder.name,_this.props.currentWorkOrder.building.location,_this.props.currentWorkOrder.client.id,_this.props.currentWorkOrder.client.company_name)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_actions_admin_work_orders_details_proposal_approval__["d" /* selectProposal */])(proposal));}});};_this.handleChangeOrderSelection=function(coId){var changeOrder=_this.props.changeOrders.find(function(co){return co.id.toString()===coId;});_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_24_components_admin_work_orders_details_change_orders_store_actions__["k" /* loadEmailChangeOrderDataRequest */])(changeOrder.number,_this.props.currentWorkOrder.number,_this.props.currentWorkOrder.name,_this.props.currentWorkOrder.building.location,_this.props.currentWorkOrder.client.id)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_24_components_admin_work_orders_details_change_orders_store_actions__["o" /* selectChangeOrder */])(changeOrder));}});};_this.handleCreateChangeOrderClick=function(event){event.preventDefault();// Clear qualifications data before showing the change order modal
_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions_admin_work_orders_details_qualifications__["c" /* clearQualificationsSelected */])());_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions_admin_work_orders_details_qualifications__["d" /* loadDefaultQualificationsRequest */])()).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_24_components_admin_work_orders_details_change_orders_store_actions__["t" /* showChangeOrderModal */])(_this.props.quotesSelectedByTaskId,_this.props.changeOrderTasks));}});};_this.handleRowSelect=function(quoteId){var quote=_this.props.quotes.find(function(element){return element.id===quoteId;});_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_details__["G" /* loadTaskForQuoteDetail */])(quote.task.id,quoteId));};_this.handleChangeOrderRowSelect=function(changeOrderTaskId){var changeOrderTask=_this.props.changeOrderTasks.find(function(cot){return cot.id.toString()===changeOrderTaskId;});_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_28_components_admin_work_orders_details_change_order_quotes_store_actions__["d" /* selectChangeOrderQuote */])(changeOrderTask.id));};_this.handleMoveToAcrClick=function(){_this.setState({showMoveToAcrConfirmation:true});};_this.handleMoveToAcrConfirmation=function(response){_this.setState({showMoveToAcrConfirmation:false});if(response){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_28_components_admin_work_orders_details_change_order_quotes_store_actions__["b" /* moveToAcr */])(_this.props.currentWorkOrder.id,Object.values(_this.props.quotesSelectedByTaskId)));}};_this.userIsClient=__WEBPACK_IMPORTED_MODULE_2_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_2_services_utils_users_util__["f" /* TYPES */].CLIENT);_this.state={showMoveToAcrConfirmation:false};return _this;}_createClass(DetailsQuotes,[{key:'render',value:function render(){var _this2=this;var proposalOnWaiting=this.props.proposals.filter(function(proposal){return __WEBPACK_IMPORTED_MODULE_19_domain_proposal_status_enum__["a" /* ProposalStatus */].WAITING.equals(proposal.status);}).length>0;var proposalOnApproved=this.props.proposals.filter(function(proposal){return __WEBPACK_IMPORTED_MODULE_19_domain_proposal_status_enum__["a" /* ProposalStatus */].APPROVED.equals(proposal.status);}).length>0;var changeOrderOnWaiting=this.props.changeOrders.filter(function(co){return co.status==='waiting';}).length>0;var budgetTasksByTaskId={};if(this.props.budget!==null){budgetTasksByTaskId=this.props.budget.budget_tasks.reduce(function(accumulator,currentBudgetTask){accumulator[currentBudgetTask.task_id]=currentBudgetTask;return accumulator;},{});}return this.props.currentWorkOrder!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-quotes'},(__WEBPACK_IMPORTED_MODULE_22_services_utils_permissions_util__["a" /* PermissionsUtil */].adminUserCanSeeMoney(this.props.currentUser)||__WEBPACK_IMPORTED_MODULE_2_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_2_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,!proposalOnWaiting&&this.showCreateProposalButton()&&!this.showCreateChangeOrderButton()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quotes-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'button',value:'Create Proposal',onClick:this.handleCreateProposalClick})),this.showCreateChangeOrderButton()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quotes-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange button-create-co',type:'button',value:'Create Change Order',onClick:this.handleCreateChangeOrderClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-gray',type:'button',value:'Move to ACR',onClick:this.handleMoveToAcrClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showMoveToAcrConfirmation,message:'Are you sure you want to move these change orders to the ACR?',onHide:this.handleMoveToAcrConfirmation})),this.props.proposals.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'proposals-admin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__proposals_ProposalsTable__["a" /* default */],{showHeader:false,proposals:this.props.proposals,proposalRenderer:function proposalRenderer(number){return'Proposal '+number;},onRowSelected:this.handleProposalSelection,changeOrders:this.props.changeOrders,approvedProposal:this.props.currentWorkOrder.approved_proposal,changeOrderRenderer:function changeOrderRenderer(number){return'Change Order '+number;},onChangeOrderRowSelected:this.handleChangeOrderSelection})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__quotes_QuotesTable__["a" /* default */],{budgetTasksByTaskId:budgetTasksByTaskId,quoteTableRadios:this.props.quotesSelectedByTaskId,quotes:this.props.quotes.filter(function(element){if(_this2.props.quotesTableSelectedFilter==='all'){return element;}else{return element.status===_this2.props.quotesTableSelectedFilter;}}),changeOrderTasks:this.props.changeOrderTasks,proposalSelectable:!proposalOnWaiting&&!proposalOnApproved,changeOrderSelectable:!changeOrderOnWaiting,selectedFilter:this.props.quotesTableSelectedFilter,onFilterSelect:this.handleQuotesFilter,onRadioSelect:this.handleQuotesTableRadioSelect,onRowSelected:this.handleRowSelect,onChangeOrderRowSelected:this.handleChangeOrderRowSelect})),this.userIsClient&&this.props.proposals.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'proposal-completion-date-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-regular'},'Target Completion Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Date__["a" /* default */],{value:this.props.proposals[this.props.proposals.length-1].completion_date,format:'M/D/YYYY'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'proposals-client'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__proposals_ProposalsTable__["a" /* default */],{showHeader:true,proposals:this.props.proposals,proposalRenderer:function proposalRenderer(number){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:number,format:'00'});},onRowSelected:this.handleProposalSelection,changeOrders:this.props.changeOrders,approvedProposal:this.props.currentWorkOrder.approved_proposal,changeOrderRenderer:function changeOrderRenderer(number){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Change Order ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:number,format:'00'}));},onChangeOrderRowSelected:this.handleChangeOrderSelection}))),this.props.showProposalShow&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__proposals_ProposalModal__["a" /* default */],null),this.props.showChangeOrderModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_components_admin_work_orders_details_change_orders_ChangeOrderModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__quotes_QuoteDetailsModalContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_components_admin_work_orders_details_change_order_quotes_ChangeOrderQuoteDetailsModalContainer__["a" /* default */],null));}},{key:'showCreateProposalButton',value:function showCreateProposalButton(){// Check that all tasks has one of the (received) quotes selected
var openTasks=this.props.tasks.filter(function(task){return task.status!==__WEBPACK_IMPORTED_MODULE_20_domain_task_status_enum__["b" /* TaskStatusKeys */].CLS;});return openTasks.length===Object.keys(this.props.quotesSelectedByTaskId).length;}},{key:'showCreateChangeOrderButton',value:function showCreateChangeOrderButton(){return this.props.proposals.filter(function(proposal){return __WEBPACK_IMPORTED_MODULE_19_domain_proposal_status_enum__["a" /* ProposalStatus */].APPROVED.equals(proposal.status);}).length>0&&Object.keys(this.props.quotesSelectedByTaskId).length>0;}}]);return DetailsQuotes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{budget:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_details__["a" /* getBudget */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_21_selectors_authentication__["d" /* getCurrentUser */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_14_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),proposals:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_details__["l" /* getProposals */])(state),quotes:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_details__["m" /* getQuotes */])(state),quotesSelectedByTaskId:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_details__["n" /* getQuotesSelectedByTaskId */])(state),quotesTableSelectedFilter:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_details__["o" /* getQuotesTableSelectedFilter */])(state),showProposalShow:Object(__WEBPACK_IMPORTED_MODULE_16_selectors_admin_work_orders_details_proposal__["h" /* getProposalShow */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_14_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state),changeOrderTasks:Object(__WEBPACK_IMPORTED_MODULE_23_components_admin_work_orders_details_change_order_tasks_store_selectors__["a" /* getChangeOrderTasks */])(state),showChangeOrderModal:Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_work_orders_details_change_orders_store_selectors__["i" /* getShowChangeOrderModal */])(state),changeOrders:Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_work_orders_details_change_orders_store_selectors__["a" /* getChangeOrders */])(state)};})(DetailsQuotes));

/***/ }),
/* 2159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapQuotes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_table_SimpleHeader__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__QuotesTable_css__ = __webpack_require__(2161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__QuotesTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__QuotesTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_round_empty_png__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_round_empty_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_round_empty_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_round_full_png__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_round_full_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_images_round_full_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_table_cell_addons_QuoteStatus__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Map quotes from the same task to a single task object with an array of these quotes.
 * @param quotes
 * @param budgetTasksByTaskId
 */function mapQuotes(quotes){var budgetTasksByTaskId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var result={};quotes.forEach(function(quote){var task=result[quote.task.id];if(task===undefined){task={id:quote.task.id,number:quote.task.number,trade:{id:quote.task.trade.id,value:quote.task.trade.value,label:quote.task.trade.label},quotes:[]};result[task.id]=task;}var data={id:quote.id,status:quote.status,counterStatus:quote.counter_status,estimate:quote.estimate,counter:quote.counter,value:quote.value,contractor:{id:quote.contractor_id,name:quote.contractor_name}};if(budgetTasksByTaskId!==null&&budgetTasksByTaskId[quote.task.id]!==undefined){var budgetTask=budgetTasksByTaskId[quote.task.id];var totalCost=__WEBPACK_IMPORTED_MODULE_9_numeral___default()(budgetTask.cost).value()+__WEBPACK_IMPORTED_MODULE_9_numeral___default()(budgetTask.fee).value()+__WEBPACK_IMPORTED_MODULE_9_numeral___default()(budgetTask.markup).value()+__WEBPACK_IMPORTED_MODULE_9_numeral___default()(budgetTask.insurance).value();data=Object.assign({},data,{budget:totalCost});}task.quotes.push(data);});return result;}var QuotesTable=function(_Component){_inherits(QuotesTable,_Component);function QuotesTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,QuotesTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=QuotesTable.__proto__||Object.getPrototypeOf(QuotesTable)).call.apply(_ref,[this].concat(args))),_this),_this.handleRadioSelect=function(taskId,quoteId,event){event.preventDefault();event.stopPropagation();// To prevent to trigger row click event
_this.props.onRadioSelect(taskId,quoteId);},_this.handleFilterSelect=function(newFilter){if(_this.props.selectedFilter!==newFilter){_this.props.onFilterSelect(newFilter);}},_this.handleRowSelect=function(quoteId){if(quoteId[0]==='_'){_this.props.onChangeOrderRowSelected(quoteId.substr(1));}else{_this.props.onRowSelected(quoteId);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(QuotesTable,[{key:'render',value:function render(){var showBudgetTaskCost=Object.keys(this.props.budgetTasksByTaskId).length>0;if(showBudgetTaskCost){this.rows=this.createRows(mapQuotes(this.props.quotes,this.props.budgetTasksByTaskId),showBudgetTaskCost);}else{this.rows=this.createRows(mapQuotes(this.props.quotes));}var headers=['TASK #','TRADE','CO #',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_table_SimpleHeader__["a" /* default */],{label:'STATUS',filter:{options:[{id:'all',label:'All'},{id:'waiting',label:'Waiting'},{id:'received',label:'Received'},{id:'denied',label:'Denied'}],selected:this.props.selectedFilter},onFilterOptionSelect:this.handleFilterSelect})];if(showBudgetTaskCost){headers.push('ESTIMATE COST');headers.push('CONTRACTOR ESTIMATE');}else{headers.push('ESTIMATE');}headers.push('');// SELECT radio button
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quotes-table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_table_SimpleTable__["a" /* default */],{className:'quotes-table'+(showBudgetTaskCost?' budget':''),headers:headers,rows:this.rows,emptyMessage:'No Quotes',onRowSelected:this.handleRowSelect}));}},{key:'createRows',value:function createRows(tasksWithQuotes){var _this2=this;var showBudgetTaskCost=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var rows=[];Object.keys(tasksWithQuotes).forEach(function(key){var task=tasksWithQuotes[key];var changeOrderTasks=_this2.props.changeOrderTasks.filter(function(cot){return cot.task_id===task.id&&cot.change_order_quote;});var awardedContractor=null;// If current task has a selected quote
var selectedQuote=_this2.props.quoteTableRadios[task.id];rows.push({id:'t'+task.id,// prefix with t to avoid same id with quote
selectable:false,data:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h2'},'Task # ',task.number),'','','','',''].concat(showBudgetTaskCost?['']:null)});task.quotes.forEach(function(quote){if(quote.status==='approved'){awardedContractor=quote.contractor;}var data=[quote.contractor.name,task.trade.label,'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_table_cell_addons_QuoteStatus__["a" /* default */],{status:quote.status==='received'&&quote.counterStatus!=='none'?quote.counterStatus:quote.status})];if(quote.hasOwnProperty('budget')){data.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Number__["a" /* default */],{value:quote.budget,format:'$0,0'}));}else if(showBudgetTaskCost){data.push('');}data=data.concat([quote.estimate!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Number__["a" /* default */],{value:quote.status==='received'&&quote.counterStatus==='negotiating'?__WEBPACK_IMPORTED_MODULE_9_numeral___default()(quote.counter).value()+__WEBPACK_IMPORTED_MODULE_9_numeral___default()(quote.value).value():__WEBPACK_IMPORTED_MODULE_9_numeral___default()(quote.estimate).value()+__WEBPACK_IMPORTED_MODULE_9_numeral___default()(quote.value).value(),format:'$0,0'}):'N/A',quote.status==='received'&&_this2.props.proposalSelectable&&_this2.props.onRadioSelect!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:selectedQuote===quote.id?__WEBPACK_IMPORTED_MODULE_7_images_round_full_png___default.a:__WEBPACK_IMPORTED_MODULE_6_images_round_empty_png___default.a,alt:selectedQuote===quote.id?'selected':'not-selected',onClick:_this2.handleRadioSelect.bind(_this2,task.id,quote.id)}):'']);rows.push({id:quote.id,data:data});});var self=_this2;changeOrderTasks.sort(function(cot1,cot2){return cot1.number-cot2.number;}).forEach(function(changeOrderTask){var changeOrderQuote=changeOrderTask.change_order_quote;var data=[awardedContractor.name,task.trade.label,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Number__["a" /* default */],{value:changeOrderTask.number,format:'00'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_table_cell_addons_QuoteStatus__["a" /* default */],{status:changeOrderQuote.status})];data=data.concat([changeOrderQuote.estimate!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Number__["a" /* default */],{value:__WEBPACK_IMPORTED_MODULE_9_numeral___default()(changeOrderQuote.estimate).value()+__WEBPACK_IMPORTED_MODULE_9_numeral___default()(changeOrderQuote.value).value(),format:'$0,0'}):'N/A',changeOrderQuote.status==='received'&&self.props.changeOrderSelectable&&self.props.onRadioSelect!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:selectedQuote===changeOrderTask.id?__WEBPACK_IMPORTED_MODULE_7_images_round_full_png___default.a:__WEBPACK_IMPORTED_MODULE_6_images_round_empty_png___default.a,alt:selectedQuote===changeOrderTask.id?'selected':'not-selected',onClick:self.handleRadioSelect.bind(self,task.id,changeOrderTask.id)}):'']);rows.push({id:'_'+changeOrderTask.id,data:data});});});return rows;}}]);return QuotesTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);QuotesTable.propTypes={budgetTasksByTaskId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,quoteTableRadios:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,quotes:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,changeOrderTasks:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,proposalSelectable:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,changeOrderSelectable:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,selectedFilter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,onFilterSelect:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onRadioSelect:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onRowSelected:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func// returns quote id
};QuotesTable.defaultProps={budgetTasksByTaskId:{}};/* harmony default export */ __webpack_exports__["a"] = (QuotesTable);

/***/ }),
/* 2160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProposalModal_css__ = __webpack_require__(2164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProposalModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ProposalModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_proposal__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_confirmation_ConfirmationPanel__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_check_circle_png__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_check_circle_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_images_check_circle_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_selectors_admin_work_orders_details_qualifications__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_work_orders_details_proposals_EditProposalQuote__ = __webpack_require__(2165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_work_orders_details_proposals_TasksReviewTable__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_work_orders_details_proposals_CostsDatesProposal__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_work_orders_details_deposit_DepositContainer__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_work_orders_details_qualifications_QualificationsContainer__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_admin_work_orders_details_proposals_NewProposalForm__ = __webpack_require__(944);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProposalModal=function(_Component){_inherits(ProposalModal,_Component);function ProposalModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProposalModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProposalModal.__proto__||Object.getPrototypeOf(ProposalModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleBack=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal__["c" /* back */])(_this.props.currentView));},_this.handleButton=function(){if(_this.props.currentView==='review'){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal__["f" /* continueRequest */])(_this.props.currentWorkOrder.id,_this.props.startDate,_this.props.completionDate,_this.props.valuesByQuoteId,_this.props.qualifications,_this.props.selectedQualificationsById,_this.props.depositCost));}else if(_this.props.currentView==='edit'){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal__["o" /* saveProposal */])(_this.props.selectedProposal));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal__["k" /* next */])(_this.props.currentView));}},_this.handleClose=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal__["e" /* closeProposalModal */])());},_this.handleThankYou=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal__["e" /* closeProposalModal */])());},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProposalModal,[{key:'render',value:function render(){var couldGoBack=this.props.currentView==='review';var title=void 0;var postTitle='Proposal (WO #'+this.props.currentWorkOrder.number+ProposalModal.getWorkOrderName(this.props.currentWorkOrder)+')';var mainComponent=void 0;switch(this.props.currentView){case'edit':mainComponent=this.renderEdit();title=postTitle;break;case'form':mainComponent=this.renderForm();title=postTitle;break;case'review':mainComponent=this.renderReview();title=postTitle;break;case'thank-you':mainComponent=this.renderThankYou();break;default:mainComponent=null;}return this.props.show?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__["a" /* default */],{className:'proposal-modal',show:this.props.show,showHeader:this.props.currentView!=='thank-you',title:title,onBack:couldGoBack?this.handleBack:undefined,onClose:this.handleClose},mainComponent):null;}},{key:'renderEdit',value:function renderEdit(){var _this2=this;var total=0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edit-proposal-container'},this.props.selectedProposal.proposal_quotes.map(function(item){var values={markup:item.markup,fee:item.fee,insurance:item.insurance};var quote=_this2.props.quotes.find(function(quote){return quote.id===item.quote_id;});total+=__WEBPACK_IMPORTED_MODULE_2_numeral___default()(item.markup).value()+__WEBPACK_IMPORTED_MODULE_2_numeral___default()(item.fee).value()+__WEBPACK_IMPORTED_MODULE_2_numeral___default()(item.insurance).value()+__WEBPACK_IMPORTED_MODULE_2_numeral___default()(quote.estimate).value()+__WEBPACK_IMPORTED_MODULE_2_numeral___default()(quote.value).value();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:item.id,className:'pq-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_admin_work_orders_details_proposals_EditProposalQuote__["a" /* default */],{itemId:item.id,amount:quote.estimate,value:quote.value,contractor:quote.contractor_name,taskNumber:quote.task.number,taskTrade:quote.task.trade.label,showValues:true,values:values}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'costs-dates-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_admin_work_orders_details_proposals_CostsDatesProposal__["a" /* default */],{total:total})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Save',onClick:this.handleButton})));}},{key:'renderForm',value:function renderForm(){var _this3=this;var quotesTotal=0;var items=[];Object.values(this.props.quotesSelectedByTaskId).forEach(function(quoteId){var quote=_this3.props.quotes.find(function(element){return element.id===quoteId;});if(quote!==undefined){quotesTotal=quotesTotal+__WEBPACK_IMPORTED_MODULE_2_numeral___default()(quote.estimate).value()+__WEBPACK_IMPORTED_MODULE_2_numeral___default()(quote.value).value();items.push({id:quoteId,amount:quote.estimate,value:quote.value,contractorName:quote.contractor_name,task:quote.task,values:_this3.props.valuesByQuoteId[quoteId]});}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quotes-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_admin_work_orders_details_proposals_NewProposalForm__["a" /* default */],{completionDate:this.props.completionDate,items:items,startDate:this.props.startDate}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_admin_work_orders_details_deposit_DepositContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_admin_work_orders_details_qualifications_QualificationsContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h3',style:{margin:'10px 0 10px 0'}},'Proposal is good for 30 days'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:!this.isReviewButtonEnable(),label:'Review',onClick:this.handleButton})));}},{key:'getMaterialLeadTime',value:function getMaterialLeadTime(mDays){if(mDays){return __WEBPACK_IMPORTED_MODULE_2_numeral___default()(mDays).value()+' '+(mDays>1?'days':'day');}return'N/A';}},{key:'renderReview',value:function renderReview(){var _this4=this;var quotesTotal=0;var valuesTotal=Object.values(this.props.valuesByQuoteId).reduce(function(accumulator,currentValue){return accumulator+currentValue['markup']+currentValue['fee']+currentValue['insurance'];},0);var values=[];Object.values(this.props.quotesSelectedByTaskId).forEach(function(quoteId){var quote=_this4.props.quotes.find(function(element){return element.id===quoteId;});if(quote!==undefined){quotesTotal=quotesTotal+__WEBPACK_IMPORTED_MODULE_2_numeral___default()(quote.estimate).value()+__WEBPACK_IMPORTED_MODULE_2_numeral___default()(quote.value).value();var quoteValues=_this4.props.valuesByQuoteId[quoteId];var quoteTotal=__WEBPACK_IMPORTED_MODULE_2_numeral___default()(quote.estimate).value()+__WEBPACK_IMPORTED_MODULE_2_numeral___default()(quote.value).value()+__WEBPACK_IMPORTED_MODULE_2_numeral___default()(quoteValues['markup']).value()+__WEBPACK_IMPORTED_MODULE_2_numeral___default()(quoteValues['fee']).value()+__WEBPACK_IMPORTED_MODULE_2_numeral___default()(quoteValues['insurance']).value();values.push({id:quote.task.id,number:quote.task.number,details:quote.task.name!==null?quote.task.name:quote.task.trade.label,materialLeadTime:_this4.getMaterialLeadTime(quote.material_lead_days),contractor:quote.contractor_name,cost:quoteTotal,fee:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(quoteValues['fee']).value(),insurance:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(quoteValues['insurance']).value(),markup:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(quoteValues['markup']).value(),breakdownItems:quoteValues['breakdownItems']});}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quotes-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_admin_work_orders_details_proposals_TasksReviewTable__["a" /* default */],{showContractor:true,values:values}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'costs-dates-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_admin_work_orders_details_proposals_CostsDatesProposal__["a" /* default */],{completionDate:{editable:true,value:this.props.completionDate},startDate:this.props.startDate,total:quotesTotal+valuesTotal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_admin_work_orders_details_deposit_DepositContainer__["a" /* default */],{readOnly:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_admin_work_orders_details_qualifications_QualificationsContainer__["a" /* default */],{readOnly:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h3',style:{margin:'10px 0 10px 0'}},'Proposal is good for 30 days'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Send',onClick:this.handleButton})));}},{key:'renderThankYou',value:function renderThankYou(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_confirmation_ConfirmationPanel__["a" /* default */],{image:__WEBPACK_IMPORTED_MODULE_10_images_check_circle_png___default.a,firstLine:'Thank you!',lines:['Proposal for WO #'+this.props.currentWorkOrder.number+' has been sent to '+this.props.currentWorkOrder.client.company_name+'.'],buttons:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-orange',value:'Continue',onClick:this.handleThankYou})]});}},{key:'isReviewButtonEnable',value:function isReviewButtonEnable(){var _this5=this;var undefinedConceptForBreakdownItem=false;var matchingCosts=true;this.props.quotes.filter(function(quote){return _this5.props.valuesByQuoteId[quote.id];}).forEach(function(quote){undefinedConceptForBreakdownItem=undefinedConceptForBreakdownItem||!!_this5.props.valuesByQuoteId[quote.id].breakdownItems.find(function(bi){return bi.concept==='';});var quoteBreakdownItemsTotal=_this5.props.valuesByQuoteId[quote.id].breakdownItems.reduce(function(breakdownCost,bi){return breakdownCost+__WEBPACK_IMPORTED_MODULE_2_numeral___default()(bi.ext).value();},0);var quoteTotal=__WEBPACK_IMPORTED_MODULE_2_numeral___default()(quote.estimate).value()+__WEBPACK_IMPORTED_MODULE_2_numeral___default()(quote.value).value();matchingCosts=matchingCosts&&(quoteBreakdownItemsTotal===quoteTotal||quoteBreakdownItemsTotal===0);});var optionUndefinedForQualification=false;Object.keys(this.props.selectedQualificationsById).forEach(function(key){var qualification=_this5.props.qualifications.find(function(qualification){return qualification.id===__WEBPACK_IMPORTED_MODULE_2_numeral___default()(key).value();});// object.keys returns string
if(qualification!==undefined&&qualification.options.length>0){optionUndefinedForQualification=optionUndefinedForQualification||_this5.props.selectedQualificationsById[key].option===null;}});return this.props.startDate!==null&&this.props.completionDate!==null&&!optionUndefinedForQualification&&matchingCosts&&(!this.props.depositSelected||this.props.depositCost!==null)&&!undefinedConceptForBreakdownItem;}}],[{key:'getWorkOrderName',value:function getWorkOrderName(workOrder){return workOrder.name!==null?': '+workOrder.name:'';}}]);return ProposalModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{completionDate:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_proposal__["a" /* getCompletionDate */])(state),currentView:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_proposal__["b" /* getCurrentView */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),qualifications:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_admin_work_orders_details_qualifications__["a" /* getQualifications */])(state),quotes:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_details__["m" /* getQuotes */])(state),quotesSelectedByTaskId:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_details__["n" /* getQuotesSelectedByTaskId */])(state),selectedQualificationsById:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_admin_work_orders_details_qualifications__["b" /* getSelectedQualificationsById */])(state),show:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_proposal__["h" /* getProposalShow */])(state),startDate:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_proposal__["l" /* getStartDate */])(state),valuesByQuoteId:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_proposal__["o" /* getValuesByQuoteId */])(state),depositSelected:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_proposal__["d" /* getDepositSelected */])(state),depositCost:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_proposal__["c" /* getDepositCost */])(state),selectedProposal:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_proposal__["i" /* getSelectedProposal */])(state)};})(ProposalModal));

/***/ }),
/* 2164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProposalQuote_css__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProposalQuote_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ProposalQuote_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_input_ComplexNumberInput__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_proposal__ = __webpack_require__(128);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProposalQuote=function(_Component){_inherits(ProposalQuote,_Component);function ProposalQuote(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProposalQuote);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProposalQuote.__proto__||Object.getPrototypeOf(ProposalQuote)).call.apply(_ref,[this].concat(args))),_this),_this.handleInputBlur=function(valueKey,value){// Round value
_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_proposal__["x" /* updateProposalValue */])(_this.props.itemId,valueKey,Math.round(value)));},_this.handleInputChange=function(valueKey,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_proposal__["x" /* updateProposalValue */])(_this.props.itemId,valueKey,value));},_this.variance=function(){var variance=(parseFloat(_this.props.values['fee'])+parseFloat(_this.props.values['insurance'])+parseFloat(_this.props.values['markup'])+parseFloat(_this.props.value||0))/parseFloat(_this.props.amount)*100;return variance;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProposalQuote,[{key:'render',value:function render(){var showCheck=this.props.withCheck!==undefined;var props=this.props;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'proposal-quote'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'proposal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:showCheck?'with-check-text':''},'Task # '+props.taskNumber))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:showCheck?'with-check-text':''},props.taskTrade)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,props.contractor),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:props.amount,format:'$0,0.00'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,props.value&&'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,props.value&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:props.value||'',format:'$0,0.00'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_input_ComplexNumberInput__["a" /* default */],{label:'Markup',value:props.values['markup'],onValueBlur:this.handleInputBlur.bind(this,'markup'),onValueChange:this.handleInputChange.bind(this,'markup')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_input_ComplexNumberInput__["a" /* default */],{label:'Fee',value:props.values['fee'],onValueBlur:this.handleInputBlur.bind(this,'fee'),onValueChange:this.handleInputChange.bind(this,'fee')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_input_ComplexNumberInput__["a" /* default */],{label:'Insurance',value:props.values['insurance'],onValueBlur:this.handleInputBlur.bind(this,'insurance'),onValueChange:this.handleInputChange.bind(this,'insurance')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:5},this.variance()<15&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'variance-warning'},'Warning: Variance is lower than 15%, please adjust markup, fee and insurance'))))));}}]);return ProposalQuote;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProposalQuote.propTypes={itemId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,amount:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]).isRequired,value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),contractor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,taskNumber:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,taskTrade:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,values:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({fee:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),insurance:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),markup:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number])})};ProposalQuote.defaultProps={values:{fee:null,insurance:null,markup:null}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(ProposalQuote));

/***/ }),
/* 2166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ComplexTable_css__ = __webpack_require__(2168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ComplexTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ComplexTable_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ComplexTable=function(_Component){_inherits(ComplexTable,_Component);function ComplexTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ComplexTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ComplexTable.__proto__||Object.getPrototypeOf(ComplexTable)).call.apply(_ref,[this].concat(args))),_this),_this.handleRowClick=function(id,selectable,event){event.preventDefault();if(selectable){_this.props.onRowSelected(id);}},_this.createRowClassName=function(){var row=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var index=arguments[1];var rows=arguments[2];var className=[];if(_this.props.onRowSelected!==undefined){if(row===null){className.push('selectable');}else if(row.selectable===undefined||row.selectable){className.push('selectable');}}if(index===rows.length-1&&_this.props.showBottomLine){className.push('last-row');}return className.length===0?null:className.join(' ');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ComplexTable,[{key:'render',value:function render(){var _this2=this;var columnsNumber=0;if(this.props.headers.length>0){// Get columns from headers
columnsNumber=this.props.headers.length;}else{// If no headers, from row items number
if(this.props.rows.length>0){columnsNumber=this.props.rows[0].length;}}var cols=[];if(columnsNumber>0){for(var i=0;i<columnsNumber;i++){cols.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:i+1}));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["t" /* Table */],{className:'complex-table'+(this.props.className!==undefined?' '+this.props.className:'')},cols.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,cols),this.props.headers.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,this.props.headers.map(function(element,index){if(typeof element==='string'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:index},element);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.props.rows.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'td-empty-table',colSpan:this.props.headers.length},this.props.emptyMessage)):this.props.rows.map(function(row,index,array){if(!Array.isArray(row)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:row.id,className:_this2.createRowClassName(row,index,array),onClick:_this2.handleRowClick.bind(_this2,row.id,_this2.props.onRowSelected!==undefined&&(row.selectable===undefined||row.selectable))},row.data.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:row.className!==undefined?row.className:null,key:index},element);}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index,className:_this2.createRowClassName(null,index,array),onClick:_this2.handleRowClick.bind(_this2,index,_this2.props.onRowSelected!==undefined)},row.map(function(element,index){if(element.type==='table'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:index,className:'subTable',colSpan:columnsNumber},element);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:index},element);}}));}})));}}]);return ComplexTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ComplexTable.propTypes={className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,headers:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object])),rows:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any),// simple array with "anything" for each column
__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]).isRequired,// the "id" of the row, will be returned when clicking
className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,// Class to add to each cell for the current row
selectable:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,// if this particular row can be selected (only works if onRowSelected function is passed), default to true
data:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any).isRequired})])),emptyMessage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,showBottomLine:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onRowSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};ComplexTable.defaultProps={headers:[],rows:[],emptyMessage:'No items',showBottomLine:false};/* harmony default export */ __webpack_exports__["a"] = (ComplexTable);

/***/ }),
/* 2168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeOrdersApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeOrdersApi=function(_BaseApi){_inherits(ChangeOrdersApi,_BaseApi);function ChangeOrdersApi(){_classCallCheck(this,ChangeOrdersApi);return _possibleConstructorReturn(this,(ChangeOrdersApi.__proto__||Object.getPrototypeOf(ChangeOrdersApi)).apply(this,arguments));}_createClass(ChangeOrdersApi,[{key:'getChangeOrders',value:function getChangeOrders(workOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/work_orders/'+workOrderId+'/change_orders').then(function(response){return{ok:true,changeOrders:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createChangeOrder',value:function createChangeOrder(workOrderId,startDate,completionDate,addedValues,qualifications){var apiPayload={change_order:{start_date:startDate,completion_date:completionDate,change_order_proposal_tasks_attributes:addedValues,change_order_qualifications_attributes:qualifications}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/work_orders/'+workOrderId+'/change_orders',apiPayload).then(function(response){return{ok:true,changeOrder:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'approveChangeOrder',value:function approveChangeOrder(changeOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/change_orders/'+changeOrderId+'/approve').then(function(response){return{ok:true,changeOrder:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'withdrawChangeOrder',value:function withdrawChangeOrder(changeOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/change_orders/'+changeOrderId+'/withdraw').then(function(response){return{ok:true,changeOrder:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getAsPdf',value:function getAsPdf(changeOrderId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/change_orders/'+changeOrderId+'/print',{responseType:'blob'}).then(function(response){return{ok:true,pdf:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'sendEmail',value:function sendEmail(changeOrderId,emails,subject,message){var data={change_order:{send_to:emails,subject:subject,message:message}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/change_orders/'+changeOrderId+'/email',data).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return ChangeOrdersApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var changeOrdersApi=new ChangeOrdersApi();

/***/ }),
/* 2172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QualificationsViewer_css__ = __webpack_require__(2174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QualificationsViewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__QualificationsViewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_checkbox_CheckBox__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_domain_qualification_type_enum__ = __webpack_require__(326);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QualificationsViewer=function(_Component){_inherits(QualificationsViewer,_Component);function QualificationsViewer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,QualificationsViewer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=QualificationsViewer.__proto__||Object.getPrototypeOf(QualificationsViewer)).call.apply(_ref,[this].concat(args))),_this),_this.handleOptionChange=function(qualificationId,option){if(_this.props.onOptionSelected!==undefined){_this.props.onOptionSelected(qualificationId,option);}},_this.handleQualificationChange=function(qualificationId){if(_this.props.onQualificationSelected!==undefined){_this.props.onQualificationSelected(qualificationId);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(QualificationsViewer,[{key:'render',value:function render(){var _this2=this;var generalSection=[];var otherSection=[];var tradeSection=null;// trade: string, { label: string, lines: [] }
this.props.qualifications.forEach(function(qualification){switch(qualification.type){case __WEBPACK_IMPORTED_MODULE_5_domain_qualification_type_enum__["a" /* QualificationTypeEnum */].GENERAL:if(!_this2.props.readOnly||_this2.props.readOnly&&qualification.selected){generalSection.push(_this2.createLine(qualification));}break;case __WEBPACK_IMPORTED_MODULE_5_domain_qualification_type_enum__["a" /* QualificationTypeEnum */].OTHER:if(!_this2.props.readOnly||_this2.props.readOnly&&qualification.selected){otherSection.push(_this2.createLine(qualification));}break;case __WEBPACK_IMPORTED_MODULE_5_domain_qualification_type_enum__["a" /* QualificationTypeEnum */].TRADE:if(!_this2.props.readOnly||_this2.props.readOnly&&qualification.selected){if(qualification.trade!==null&&qualification.trade!==undefined){if(tradeSection===null){tradeSection={};}var tradeContainer=tradeSection[qualification.trade.value];if(tradeContainer===undefined){tradeContainer={label:qualification.trade.label,lines:[]};}tradeContainer.lines.push(_this2.createLine(qualification));tradeSection[qualification.trade.value]=tradeContainer;}}break;default:}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qualifications-viewer'},generalSection.length>0&&QualificationsViewer.createSection(__WEBPACK_IMPORTED_MODULE_5_domain_qualification_type_enum__["a" /* QualificationTypeEnum */].GENERAL.label,generalSection),tradeSection!==null&&Object.keys(tradeSection).sort().map(function(key,index){return QualificationsViewer.createSection(tradeSection[key].label,tradeSection[key].lines,index);}),otherSection.length>0&&QualificationsViewer.createSection(__WEBPACK_IMPORTED_MODULE_5_domain_qualification_type_enum__["a" /* QualificationTypeEnum */].OTHER.label,otherSection),generalSection.length===0&&tradeSection===null&&otherSection.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body-regular text-center',style:{width:'100%'}},'No qualifications'));}},{key:'createLine',value:function createLine(qualification){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:qualification.id,className:'line'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_checkbox_CheckBox__["a" /* default */],{checked:qualification.selected,readOnly:this.props.readOnly,onChange:this.handleQualificationChange.bind(this,qualification.id)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qualification-label'},qualification.label),qualification.options!==undefined&&qualification.options.length>0&&qualification.selected&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,qualification.options.filter(function(option){return option.selected;}).reduce(function(accumulator,currentOption){return currentOption.label;},null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_dropdown_Dropdown__["a" /* default */],{className:'options-dropdown',options:qualification.options.map(function(option){return{value:option.id,label:option.label};}),value:qualification.options.filter(function(option){return option.selected;}).reduce(function(accumulator,currentOption){return currentOption.id;},null),placeholder:'Select option',onChange:this.handleOptionChange.bind(this,qualification.id)})));}}],[{key:'createSection',value:function createSection(label,section,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body-regular'},label),section);}}]);return QualificationsViewer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);QualificationsViewer.propTypes={qualifications:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool})),selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,trade:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}),type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_5_domain_qualification_type_enum__["a" /* QualificationTypeEnum */]).isRequired})),readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onOptionSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onQualificationSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};QualificationsViewer.defaultProps={qualifications:[],readOnly:false};/* harmony default export */ __webpack_exports__["a"] = (QualificationsViewer);

/***/ }),
/* 2174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_qualifications__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NewQualificationForm__ = __webpack_require__(2177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_qualifications__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_api_qualifications_api__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_domain_qualification_type_enum__ = __webpack_require__(326);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewQualificationModal=function(_Component){_inherits(NewQualificationModal,_Component);function NewQualificationModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewQualificationModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewQualificationModal.__proto__||Object.getPrototypeOf(NewQualificationModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_qualifications__["j" /* setShowNewQualificationModal */])(false));},_this.handleLoadLabelOptions=function(input,type,trade){return __WEBPACK_IMPORTED_MODULE_6_services_api_qualifications_api__["a" /* qualificationsApi */].searchQualifications(__WEBPACK_IMPORTED_MODULE_7_domain_qualification_type_enum__["a" /* QualificationTypeEnum */].getById(type),trade,input).then(function(response){if(response.ok){return{ok:true,options:response.qualifications.filter(function(qualification){return _this.props.qualifications.find(function(element){return element.id===qualification.id;})===undefined;}).map(function(element){return{value:element.id,label:element.label,qualification:element// add object to use it if the user select an existing label
};})};}else{return{ok:false,errors:response.errors};}});},_this.handleQualificationCreated=function(values){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_qualifications__["a" /* addQualificationRequest */])(values));},_this.handleQualificationSelected=function(qualification){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_qualifications__["b" /* addQualificationSuccess */])(qualification));// Mark added qualification as selected
_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_qualifications__["h" /* qualificationSelected */])(qualification.id));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_qualifications__["j" /* setShowNewQualificationModal */])(false));// close modal
},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewQualificationModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{show:true,title:'Add Qualification',onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NewQualificationForm__["a" /* default */],{loadLabelOptions:this.handleLoadLabelOptions,trades:this.props.trades,onQualificationCreated:this.handleQualificationCreated,onQualificationSelected:this.handleQualificationSelected}));}},{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_qualifications__["f" /* loadTradesRequest */])());}}]);return NewQualificationModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{qualifications:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_qualifications__["a" /* getQualifications */])(state),trades:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_qualifications__["d" /* getTrades */])(state)};})(NewQualificationModal));

/***/ }),
/* 2177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domain_qualification_type_enum__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_dropdown_SearchableDropDown__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NewQualificationForm_css__ = __webpack_require__(2178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NewQualificationForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__NewQualificationForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_add_png__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_add_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_images_add_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewQualificationForm=function(_Component){_inherits(NewQualificationForm,_Component);function NewQualificationForm(props){_classCallCheck(this,NewQualificationForm);var _this=_possibleConstructorReturn(this,(NewQualificationForm.__proto__||Object.getPrototypeOf(NewQualificationForm)).call(this,props));_this.handleTypeChange=function(option){_this.setState({selectedTrade:null,// update in case type is changed
selectedType:option.value});};_this.handleTradeChange=function(option){_this.setState({selectedTrade:option.value});};_this.handleLoadLabelOptions=function(input){return _this.props.loadLabelOptions(input,_this.state.selectedType,_this.state.selectedTrade);};_this.handleLabelChange=function(option){_this.setState({selectedLabel:option,showConfirmation:option!==null&&option.value!==0});};_this.handleConfirmation=function(result){_this.setState({showConfirmation:false});if(result){if(_this.props.onQualificationSelected!==undefined){// Send object
_this.props.onQualificationSelected(_this.state.selectedLabel.qualification);}}else{_this.setState({selectedLabel:null});}};_this.handleNewOptionChange=function(value){_this.setState({newOption:value});};_this.handleOptionAdd=function(event){event.preventDefault();_this.setState({newOption:'',options:_this.state.options.concat([_this.state.newOption])});};_this.handleOptionRemove=function(optionIndex,event){event.preventDefault();_this.setState({options:_this.state.options.filter(function(option,index){return index!==optionIndex;})});};_this.enableAddButton=function(){var result=_this.state.selectedType!==null;if(_this.state.selectedType===2){// Trade
result=result&&_this.state.selectedTrade!==null;}result=result&&_this.state.selectedLabel!==null;return result;};_this.handleAdd=function(event){event.preventDefault();if(_this.props.onQualificationCreated){_this.props.onQualificationCreated({type:__WEBPACK_IMPORTED_MODULE_3_domain_qualification_type_enum__["a" /* QualificationTypeEnum */].getById(_this.state.selectedType).value,// send value, selectedType is array index
trade:_this.state.selectedTrade,label:_this.state.selectedLabel.label,options:_this.state.options});}};_this.state={newOption:'',options:[],selectedLabel:null,// option type { value, label }
selectedTrade:null,selectedType:null,showConfirmation:false};return _this;}_createClass(NewQualificationForm,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'new-qualification-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_dropdown_Dropdown__["a" /* default */],{className:'new-qualification-dropdown',options:this.props.types.map(function(type){return{value:type.id,label:type.label};}),placeholder:'Select type',value:this.state.selectedType,onChange:this.handleTypeChange}))),this.state.selectedType!==null&&this.state.selectedType===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Trade'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_dropdown_Dropdown__["a" /* default */],{className:'new-qualification-dropdown',options:this.props.trades.map(function(trade){return{value:trade.id,label:trade.label};}),placeholder:'Select trade',value:this.state.selectedTrade,onChange:this.handleTradeChange}))),this.state.selectedType!==null&&(this.state.selectedType!==__WEBPACK_IMPORTED_MODULE_3_domain_qualification_type_enum__["a" /* QualificationTypeEnum */].TRADE.id||this.state.selectedType===__WEBPACK_IMPORTED_MODULE_3_domain_qualification_type_enum__["a" /* QualificationTypeEnum */].TRADE.id&&this.state.selectedTrade!==null)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Label'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_dropdown_SearchableDropDown__["a" /* default */],{autoload:false,cache:false,className:'new-qualification-dropdown',clearable:true,creatable:true,loadOptions:this.handleLoadLabelOptions.bind(this),newOptionCreator:function newOptionCreator(option){return{value:0,label:option.label};},placeholder:'Enter label',promptTextCreator:function promptTextCreator(label){return'Create label '+label;},value:this.state.selectedLabel,onChange:this.handleLabelChange}))),this.state.selectedLabel!==null&&this.state.selectedLabel.value===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Options'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'options-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__["a" /* default */],{placeholder:'Enter new option',value:this.state.newOption,onChange:this.handleNewOptionChange}),this.state.newOption!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7_images_add_png___default.a,alt:'add',onClick:this.handleOptionAdd})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.state.options.map(function(option,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,option),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8_images_remove_png___default.a,alt:'remove',onClick:_this2.handleOptionRemove.bind(_this2,index)}));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-orange',value:'Create',disabled:!this.enableAddButton(),onClick:this.handleAdd}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showConfirmation,message:'Do you want to use this qualification?',onHide:this.handleConfirmation}));}}]);return NewQualificationForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NewQualificationForm.propTypes={trades:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,types:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_domain_qualification_type_enum__["a" /* QualificationTypeEnum */])),loadLabelOptions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onQualificationCreated:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onQualificationSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};NewQualificationForm.defaultProps={labelOptions:[],trades:[],types:[__WEBPACK_IMPORTED_MODULE_3_domain_qualification_type_enum__["a" /* QualificationTypeEnum */].GENERAL,__WEBPACK_IMPORTED_MODULE_3_domain_qualification_type_enum__["a" /* QualificationTypeEnum */].TRADE,__WEBPACK_IMPORTED_MODULE_3_domain_qualification_type_enum__["a" /* QualificationTypeEnum */].OTHER]};/* harmony default export */ __webpack_exports__["a"] = (NewQualificationForm);

/***/ }),
/* 2178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProposalQuote_css__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProposalQuote_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ProposalQuote_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_checkbox_CheckBox__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_input_ComplexNumberInput__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_proposals_BreakdownItem__ = __webpack_require__(2181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_change_orders_store_actions__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_admin_work_orders_details_proposal__ = __webpack_require__(128);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProposalQuote=function(_Component){_inherits(ProposalQuote,_Component);function ProposalQuote(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProposalQuote);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProposalQuote.__proto__||Object.getPrototypeOf(ProposalQuote)).call.apply(_ref,[this].concat(args))),_this),_this.handleInputBlur=function(valueKey,value){// Round value
if(_this.props.isChangeOrder){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_change_orders_store_actions__["w" /* updateCOValue */])(_this.props.itemId,valueKey,Math.round(value)));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_work_orders_details_proposal__["z" /* updateValue */])(_this.props.itemId,valueKey,Math.round(value)));}},_this.handleInputChange=function(valueKey,value){if(_this.props.isChangeOrder){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_change_orders_store_actions__["w" /* updateCOValue */])(_this.props.itemId,valueKey,value));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_work_orders_details_proposal__["z" /* updateValue */])(_this.props.itemId,valueKey,value));}},_this.handleAddBreakdownItemClick=function(){var defaultBreakdownItem={concept:'',unit_number:'',unit_type:'',cost:'',ext:'0'};_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_work_orders_details_proposal__["a" /* addBreakdownItem */])(_this.props.itemId,defaultBreakdownItem));},_this.proposalTotal=function(){return parseFloat(_this.props.amount)+parseFloat(_this.props.value||0)+parseFloat(_this.props.values['fee'])+parseFloat(_this.props.values['insurance'])+parseFloat(_this.props.values['markup']);},_this.breakdownItemsSubtotal=function(){return-parseFloat(_this.props.amount)-parseFloat(_this.props.value||0)+_this.props.values.breakdownItems.reduce(function(acc,bi){return acc+parseFloat(bi.ext);},0);},_this.variance=function(){var variance=(parseFloat(_this.props.values['fee'])+parseFloat(_this.props.values['insurance'])+parseFloat(_this.props.values['markup'])+parseFloat(_this.props.value||0))/parseFloat(_this.props.amount)*100;return variance;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProposalQuote,[{key:'render',value:function render(){var _this2=this;var showCheck=this.props.withCheck!==undefined;var props=this.props;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'proposal-quote'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'proposal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,showCheck&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'with-check-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_checkbox_CheckBox__["a" /* default */],{id:props.withCheck.id,checked:props.withCheck.checked,shape:'round',size:'medium',onChange:props.withCheck.onCheck})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:showCheck?'with-check-text':''},'Task # '+props.taskNumber))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:showCheck?'with-check-text':''},props.taskTrade)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,props.contractor),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:props.amount,format:'$0,0.00'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,props.value&&'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,props.value&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:props.value||'',format:'$0,0.00'}))),props.showValues&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_ComplexNumberInput__["a" /* default */],{label:'Markup',value:props.values['markup'],onValueBlur:this.handleInputBlur.bind(this,'markup'),onValueChange:this.handleInputChange.bind(this,'markup')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_ComplexNumberInput__["a" /* default */],{label:'Fee',value:props.values['fee'],onValueBlur:this.handleInputBlur.bind(this,'fee'),onValueChange:this.handleInputChange.bind(this,'fee')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_ComplexNumberInput__["a" /* default */],{label:'Insurance',value:props.values['insurance'],onValueBlur:this.handleInputBlur.bind(this,'insurance'),onValueChange:this.handleInputChange.bind(this,'insurance')}))),props.values.breakdownItems!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3,className:'breakdown-items'},props.values.breakdownItems.map(function(breakdownItem,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:index,className:'breakdown-item-inputs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_proposals_BreakdownItem__["a" /* default */],{itemId:_this2.props.itemId,breakdownItem:breakdownItem,itemIndex:index}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:5,className:'breakdown-items-subtotals'},props.values.breakdownItems.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Total:\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:this.proposalTotal(),format:'$0,0.00'})),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtotals'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:this.breakdownItemsSubtotal(),format:'$0,0.00'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:5},this.variance()<15&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'variance-warning'},'Warning: Variance is lower than 15%, please adjust markup, fee and insurance'))))),props.values.breakdownItems!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'bi-link',label:'+ Add breakdown item',onClick:this.handleAddBreakdownItemClick}));}}]);return ProposalQuote;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProposalQuote.propTypes={itemId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,amount:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]).isRequired,value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),contractor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,showValues:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,taskNumber:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,taskTrade:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,values:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({fee:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),insurance:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),markup:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number])}),withCheck:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,checked:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,onCheck:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired})};ProposalQuote.defaultProps={showValues:true,values:{fee:null,insurance:null,markup:null,breakdownItems:[]}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(ProposalQuote));

/***/ }),
/* 2181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BreakdownItem_css__ = __webpack_require__(2182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BreakdownItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BreakdownItem_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_details_proposal__ = __webpack_require__(128);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BreakdownItem=function(_Component){_inherits(BreakdownItem,_Component);function BreakdownItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BreakdownItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BreakdownItem.__proto__||Object.getPrototypeOf(BreakdownItem)).call.apply(_ref,[this].concat(args))),_this),_this.handleRemoveBreakdownItemClick=function(biIndex){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_details_proposal__["m" /* removeBreakdownItem */])(_this.props.itemId,biIndex));},_this.handleBreakDownItemChange=function(biIndex,key,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_details_proposal__["v" /* updateBreakdownItem */])(_this.props.itemId,biIndex,key,value));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BreakdownItem,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var item=this.props.breakdownItem;// if the change is on the unit_number or the cost
if(item.unit_number!==prevProps.breakdownItem.unit_number||item.cost!==prevProps.breakdownItem.cost){// if the change is not on the 'ext' property
if(prevProps.breakdownItem.ext===item.ext){var ext=parseFloat(item.unit_number||0)*parseFloat(item.cost||0);this.handleBreakDownItemChange(this.props.itemIndex,'ext',''+ext);}}}},{key:'render',value:function render(){var _this2=this;var breakdownItem=this.props.breakdownItem;var index=this.props.itemIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea___default.a,{rows:1,id:'breakdown-item-'+index+'-concept',value:breakdownItem.concept,onChange:function onChange(e){return _this2.handleBreakDownItemChange(index,'concept',e.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__["a" /* default */],{id:'breakdown-item-'+index+'-unit_number',placeholder:'units',type:'number',value:breakdownItem.unit_number,theme:'normal',className:'small',onChange:this.handleBreakDownItemChange.bind(this,index,'unit_number')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__["a" /* default */],{id:'breakdown-item-'+index+'-unit_type',placeholder:'type',value:breakdownItem.unit_type,theme:'normal',className:'small',onChange:this.handleBreakDownItemChange.bind(this,index,'unit_type')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__["a" /* default */],{id:'breakdown-item-'+index+'-cost',placeholder:'cost',type:'number',value:breakdownItem.cost,theme:'normal',onChange:this.handleBreakDownItemChange.bind(this,index,'cost')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__["a" /* default */],{id:'breakdown-item-'+index+'-ext',placeholder:'ext',type:'number',value:breakdownItem.ext,theme:'normal',onChange:this.handleBreakDownItemChange.bind(this,index,'ext')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'remove-bi-'+index,src:__WEBPACK_IMPORTED_MODULE_6_images_remove_png___default.a,className:'bi-remove',alt:'remove',onClick:this.handleRemoveBreakdownItemClick.bind(this,index)}));}}]);return BreakdownItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BreakdownItem.propTypes={concept:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,unit_number:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),unit_type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,cost:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),ext:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(BreakdownItem));

/***/ }),
/* 2182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProposalsTable_css__ = __webpack_require__(2184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProposalsTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProposalsTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_domain_proposal_status_enum__ = __webpack_require__(272);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProposalsTable=function(_Component){_inherits(ProposalsTable,_Component);function ProposalsTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProposalsTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProposalsTable.__proto__||Object.getPrototypeOf(ProposalsTable)).call.apply(_ref,[this].concat(args))),_this),_this.handleRowSelect=function(proposalId){if(proposalId[0]==='_'){_this.props.onChangeOrderRowSelected(proposalId.substr(1));}else{_this.props.onRowSelected(proposalId);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProposalsTable,[{key:'render',value:function render(){var headers=[];if(this.props.showHeader){headers=['PROPOSAL #','STATUS','DATE RECEIVED','AMOUNT'];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'proposals-table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_table_SimpleTable__["a" /* default */],{className:'proposals-table',headers:headers,rows:this.createRows(this.props.proposals).concat(this.createChangeOrderRows(this.props.changeOrders)),onRowSelected:this.handleRowSelect}));}},{key:'createRows',value:function createRows(proposals){var _this2=this;var rows=[];proposals.forEach(function(proposal){rows.push({id:proposal.id,data:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'proposal-number'},_this2.props.proposalRenderer(proposal.number)),ProposalsTable.createStatusElement(proposal.status,proposal.rejected_reason_1,proposal.rejected_reason_2),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_text_Date__["a" /* default */],{value:proposal.created_at,format:'M/D/YYYY'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_text_Number__["a" /* default */],{value:proposal.cost,format:'$0,0'})]});});return rows;}},{key:'createChangeOrderRows',value:function createChangeOrderRows(changeOrders){var _this3=this;var rows=[];if(changeOrders.length>0){var cost=__WEBPACK_IMPORTED_MODULE_6_numeral___default()(this.props.approvedProposal.cost).value();changeOrders.forEach(function(co){rows.push({id:'_'+co.id,data:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'proposal-number'},_this3.props.changeOrderRenderer(co.number)),ProposalsTable.createStatusElement(co.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_text_Date__["a" /* default */],{value:co.created_at,format:'M/D/YYYY'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_text_Number__["a" /* default */],{value:cost+__WEBPACK_IMPORTED_MODULE_6_numeral___default()(co.cost).value(),format:'$0,0'})]});if(__WEBPACK_IMPORTED_MODULE_7_domain_proposal_status_enum__["a" /* ProposalStatus */].APPROVED.equals(co.status)){cost+=__WEBPACK_IMPORTED_MODULE_6_numeral___default()(co.cost).value();}});}return rows;}}],[{key:'createStatusElement',value:function createStatusElement(status,rejectedReason1,rejectedReason2){var reason='';if(rejectedReason1){reason='('+rejectedReason1+(rejectedReason2?': '+rejectedReason2+')':')');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,status.charAt(0).toUpperCase()+status.slice(1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status '+status}),reason&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,reason));}}]);return ProposalsTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProposalsTable.propTypes={proposalRenderer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,proposals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,changeOrders:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,approvedProposal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,changeOrderRenderer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,showHeader:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onRowSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};ProposalsTable.defaultProps={proposalRenderer:function proposalRenderer(proposalNumber){return proposalNumber;},showHeader:true};/* harmony default export */ __webpack_exports__["a"] = (ProposalsTable);

/***/ }),
/* 2184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__quotes_QuoteDetailsModal__ = __webpack_require__(945);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QuoteDetailsModalContainer=function(_Component){_inherits(QuoteDetailsModalContainer,_Component);function QuoteDetailsModalContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,QuoteDetailsModalContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=QuoteDetailsModalContainer.__proto__||Object.getPrototypeOf(QuoteDetailsModalContainer)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_admin_work_orders_details_details__["n" /* closeQuoteDetailsModal */])());},_this.handleNegotiate=function(counter,callback){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_admin_work_orders_details_details__["p" /* counterQuote */])(_this.props.selectedQuoteId,counter)).then(function(response){return callback(response);});},_this.handleEdit=function(estimate,value,contractorId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_admin_work_orders_details_details__["_15" /* updateQuoteRequest */])(_this.props.selectedQuoteId,estimate,value,contractorId));},_this.handleDelete=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_admin_work_orders_details_details__["r" /* deleteQuote */])(_this.props.selectedQuoteId));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(QuoteDetailsModalContainer,[{key:'render',value:function render(){var _this2=this;var quote=this.props.quotes.find(function(element){return element.id===_this2.props.selectedQuoteId;});return quote!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__quotes_QuoteDetailsModal__["a" /* default */],{quote:quote,show:this.props.selectedQuoteId!==null,taskImages:this.props.currentTask.images,workOrder:this.props.currentWorkOrder,onNegotiate:this.handleNegotiate,onEdit:this.handleEdit,onClose:this.handleClose,onDelete:this.handleDelete});}}]);return QuoteDetailsModalContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentTask:Object(__WEBPACK_IMPORTED_MODULE_2__selectors_admin_work_orders_details_details__["e" /* getCurrentTask */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_4__selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),quotes:Object(__WEBPACK_IMPORTED_MODULE_2__selectors_admin_work_orders_details_details__["m" /* getQuotes */])(state),selectedQuoteId:Object(__WEBPACK_IMPORTED_MODULE_2__selectors_admin_work_orders_details_details__["r" /* getSelectedQuoteId */])(state)};})(QuoteDetailsModalContainer));

/***/ }),
/* 2187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangeOrderModal_css__ = __webpack_require__(2189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangeOrderModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ChangeOrderModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_change_order_tasks_store_selectors__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_orders_store_selectors__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_change_orders_store_actions__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_work_orders_details_proposals_NewProposalForm__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_domain_proposal_status_enum__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_work_orders_details_proposals_TasksReviewTable__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_work_orders_details_proposals_CostsDatesProposal__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_shared_confirmation_ConfirmationPanel__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_images_check_circle_png__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_images_check_circle_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_images_check_circle_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_selectors_admin_work_orders_details_qualifications__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_admin_work_orders_details_qualifications_QualificationsContainer__ = __webpack_require__(270);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeOrderModal=function(_Component){_inherits(ChangeOrderModal,_Component);function ChangeOrderModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChangeOrderModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChangeOrderModal.__proto__||Object.getPrototypeOf(ChangeOrderModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_change_orders_store_actions__["e" /* closeChangeOrderModal */])());},_this.handleBack=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_change_orders_store_actions__["c" /* back */])(_this.props.currentView));},_this.handleButton=function(){if(_this.props.currentView==='review'){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_change_orders_store_actions__["h" /* continueRequest */])(_this.props.currentWorkOrder.id,_this.props.startDate,_this.props.completionDate,_this.props.valuesByQuoteId,_this.props.qualifications,_this.props.selectedQualificationsById));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_change_orders_store_actions__["l" /* next */])(_this.props.currentView));}},_this.createItems=function(){var items=[];Object.values(_this.props.quotesSelectedByTaskId).forEach(function(changeOrderTaskId){var changeOrderTask=_this.props.changeOrderTasks.find(function(cot){return cot.id===changeOrderTaskId;});var task=_this.props.tasks.find(function(t){return t.id===changeOrderTask.task_id;});var changeOrderQuote=changeOrderTask.change_order_quote;items.push({id:changeOrderTaskId,amount:changeOrderQuote.estimate,value:changeOrderQuote.value,contractorName:task.contractor_name,task:task,values:_this.props.valuesByQuoteId[changeOrderTaskId]});});return items;},_this.handleThankYou=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_change_orders_store_actions__["e" /* closeChangeOrderModal */])());},_this.previousCost=function(){var prevCost=__WEBPACK_IMPORTED_MODULE_4_numeral___default()(_this.props.currentWorkOrder.approved_proposal.cost).value();_this.props.changeOrders.filter(function(co){return __WEBPACK_IMPORTED_MODULE_12_domain_proposal_status_enum__["a" /* ProposalStatus */].APPROVED.equals(co.status);}).forEach(function(co){prevCost+=__WEBPACK_IMPORTED_MODULE_4_numeral___default()(co.cost).value();});return prevCost;},_this.renderForm=function(){var items=_this.createItems();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quotes-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_admin_work_orders_details_proposals_NewProposalForm__["a" /* default */],{startDate:_this.props.startDate,completionDate:_this.props.completionDate,items:items,isChangeOrder:true,previousCost:_this.previousCost()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_admin_work_orders_details_qualifications_QualificationsContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:!_this.isReviewButtonEnable(),label:'Review',onClick:_this.handleButton})));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChangeOrderModal,[{key:'render',value:function render(){var couldGoBack=this.props.currentView==='review';var title=void 0;var postTitle='Change Order (WO #'+this.props.currentWorkOrder.number+ChangeOrderModal.getWorkOrderName(this.props.currentWorkOrder)+')';var mainComponent=void 0;switch(this.props.currentView){case'form':mainComponent=this.renderForm();title=postTitle;break;case'review':mainComponent=this.renderReview();title=postTitle;break;case'thank-you':mainComponent=this.renderThankYou();break;default:mainComponent=null;}return this.props.show?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{className:'change-order-modal',show:this.props.show,showHeader:this.props.currentView!=='thank-you',title:title,onBack:couldGoBack?this.handleBack:undefined,onClose:this.handleClose},mainComponent):null;}},{key:'renderReview',value:function renderReview(){var _this2=this;var quotesTotal=0;var valuesTotal=Object.values(this.props.valuesByQuoteId).reduce(function(accumulator,currentValue){return accumulator+currentValue['markup']+currentValue['fee']+currentValue['insurance'];},0);var values=[];Object.values(this.props.quotesSelectedByTaskId).forEach(function(changeOrderTaskId){var changeOrderTask=_this2.props.changeOrderTasks.find(function(cot){return cot.id===changeOrderTaskId;});var task=_this2.props.tasks.find(function(t){return t.id===changeOrderTask.task_id;});var changeOrderQuote=changeOrderTask.change_order_quote;quotesTotal=quotesTotal+__WEBPACK_IMPORTED_MODULE_4_numeral___default()(changeOrderQuote.estimate).value()+__WEBPACK_IMPORTED_MODULE_4_numeral___default()(changeOrderQuote.value).value();var quoteValues=_this2.props.valuesByQuoteId[changeOrderTaskId];var quoteTotal=__WEBPACK_IMPORTED_MODULE_4_numeral___default()(changeOrderQuote.estimate).value()+__WEBPACK_IMPORTED_MODULE_4_numeral___default()(changeOrderQuote.value).value()+__WEBPACK_IMPORTED_MODULE_4_numeral___default()(quoteValues['markup']).value()+__WEBPACK_IMPORTED_MODULE_4_numeral___default()(quoteValues['fee']).value()+__WEBPACK_IMPORTED_MODULE_4_numeral___default()(quoteValues['insurance']).value();values.push({id:task.id,number:task.number,details:task.name!==null?task.name:task.trade.label,materialLeadTime:_this2.getMaterialLeadTime(changeOrderQuote.material_lead_days),contractor:task.contractor_name,cost:quoteTotal});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quotes-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_admin_work_orders_details_proposals_TasksReviewTable__["a" /* default */],{showContractor:true,values:values}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'costs-dates-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_admin_work_orders_details_proposals_CostsDatesProposal__["a" /* default */],{completionDate:{editable:true,value:this.props.completionDate},startDate:this.props.startDate,total:quotesTotal+valuesTotal,isChangeOrder:true,previousCost:this.previousCost()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_admin_work_orders_details_qualifications_QualificationsContainer__["a" /* default */],{readOnly:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Send',onClick:this.handleButton})));}},{key:'renderThankYou',value:function renderThankYou(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_confirmation_ConfirmationPanel__["a" /* default */],{image:__WEBPACK_IMPORTED_MODULE_16_images_check_circle_png___default.a,firstLine:'Thank you!',lines:['Change Order for WO #'+this.props.currentWorkOrder.number+' has been sent to '+this.props.currentWorkOrder.client.company_name+'.'],buttons:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-orange',value:'Continue',onClick:this.handleThankYou})]});}},{key:'getMaterialLeadTime',value:function getMaterialLeadTime(mDays){if(mDays){return __WEBPACK_IMPORTED_MODULE_4_numeral___default()(mDays).value()+' '+(mDays>1?'days':'day');}return'N/A';}},{key:'isReviewButtonEnable',value:function isReviewButtonEnable(){var _this3=this;var optionUndefinedForQualification=false;Object.keys(this.props.selectedQualificationsById).forEach(function(key){var qualification=_this3.props.qualifications.find(function(qualification){return qualification.id===__WEBPACK_IMPORTED_MODULE_4_numeral___default()(key).value();});// object.keys returns string
if(qualification!==undefined&&qualification.options.length>0){optionUndefinedForQualification=optionUndefinedForQualification||_this3.props.selectedQualificationsById[key].option===null;}});return this.props.startDate!==null&&this.props.completionDate!==null&&!optionUndefinedForQualification;}}],[{key:'getWorkOrderName',value:function getWorkOrderName(workOrder){return workOrder.name!==null?': '+workOrder.name:'';}}]);return ChangeOrderModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{show:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_orders_store_selectors__["i" /* getShowChangeOrderModal */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state),qualifications:Object(__WEBPACK_IMPORTED_MODULE_17_selectors_admin_work_orders_details_qualifications__["a" /* getQualifications */])(state),changeOrders:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_orders_store_selectors__["a" /* getChangeOrders */])(state),changeOrderTasks:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_change_order_tasks_store_selectors__["a" /* getChangeOrderTasks */])(state),quotesSelectedByTaskId:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["n" /* getQuotesSelectedByTaskId */])(state),selectedQualificationsById:Object(__WEBPACK_IMPORTED_MODULE_17_selectors_admin_work_orders_details_qualifications__["b" /* getSelectedQualificationsById */])(state),startDate:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_orders_store_selectors__["m" /* getStartDate */])(state),completionDate:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_orders_store_selectors__["b" /* getCompletionDate */])(state),valuesByQuoteId:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_orders_store_selectors__["p" /* getValuesByQuoteId */])(state),currentView:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_orders_store_selectors__["c" /* getCurrentView */])(state)};})(ChangeOrderModal));

/***/ }),
/* 2189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_order_tasks_store_selectors__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_change_order_quotes_store_selectors__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_change_order_quotes_store_actions__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_change_order_quotes_ChangeOrderQuoteDetailsModal__ = __webpack_require__(2191);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeOrderQuoteDetailsModalContainer=function(_Component){_inherits(ChangeOrderQuoteDetailsModalContainer,_Component);function ChangeOrderQuoteDetailsModalContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChangeOrderQuoteDetailsModalContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChangeOrderQuoteDetailsModalContainer.__proto__||Object.getPrototypeOf(ChangeOrderQuoteDetailsModalContainer)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_change_order_quotes_store_actions__["a" /* closeChangeOrderQuoteDetailsModal */])());},_this.handleSave=function(values){var _this$props=_this.props,changeOrderTasks=_this$props.changeOrderTasks,selectedChangeOrderTaskId=_this$props.selectedChangeOrderTaskId,dispatch=_this$props.dispatch;var changeOrderTask=changeOrderTasks.find(function(element){return element.id===selectedChangeOrderTaskId;});dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_change_order_quotes_store_actions__["h" /* updateChangeOrderQuote */])(changeOrderTask.id,values));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChangeOrderQuoteDetailsModalContainer,[{key:'render',value:function render(){var _this2=this;var changeOrderTask=this.props.changeOrderTasks.find(function(element){return element.id===_this2.props.selectedChangeOrderTaskId;});var task=void 0;if(changeOrderTask){task=this.props.tasks.find(function(element){return element.id===changeOrderTask.task_id;});}return!!changeOrderTask&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_change_order_quotes_ChangeOrderQuoteDetailsModal__["a" /* default */],{show:!!changeOrderTask,changeOrderTask:changeOrderTask,task:task,workOrder:this.props.currentWorkOrder,onClose:this.handleClose,onSave:this.handleSave});}}]);return ChangeOrderQuoteDetailsModalContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state),changeOrderTasks:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_order_tasks_store_selectors__["a" /* getChangeOrderTasks */])(state),selectedChangeOrderTaskId:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_change_order_quotes_store_selectors__["a" /* getSelectedChangeOrderTaskId */])(state)};})(ChangeOrderQuoteDetailsModalContainer));

/***/ }),
/* 2191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChangeOrderQuoteDetailsModal_css__ = __webpack_require__(2192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChangeOrderQuoteDetailsModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ChangeOrderQuoteDetailsModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_details_DetailsInfoItem__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeOrderQuoteDetailsModal=function(_Component){_inherits(ChangeOrderQuoteDetailsModal,_Component);function ChangeOrderQuoteDetailsModal(props){_classCallCheck(this,ChangeOrderQuoteDetailsModal);var _this=_possibleConstructorReturn(this,(ChangeOrderQuoteDetailsModal.__proto__||Object.getPrototypeOf(ChangeOrderQuoteDetailsModal)).call(this,props));_this.handleEstimateChange=function(estimate){_this.setState({estimate:estimate});};_this.handleValueChange=function(value){_this.setState({value:value});};_this.handleClose=function(event){event.preventDefault();_this.props.onClose();};_this.handleEdit=function(){_this.setState({readOnly:false});};_this.handleCancel=function(){_this.setState({readOnly:true});};_this.handleSave=function(){var _this$state=_this.state,id=_this$state.id,estimate=_this$state.estimate,value=_this$state.value;var onSave=_this.props.onSave;_this.setState({readOnly:true});onSave({id:id,estimate:estimate,value:value});};var changeOrderQuote=props.changeOrderTask.change_order_quote;_this.state={readOnly:true,id:changeOrderQuote.id,estimate:changeOrderQuote.estimate||'',value:changeOrderQuote.value||''};return _this;}_createClass(ChangeOrderQuoteDetailsModal,[{key:'render',value:function render(){var _state=this.state,readOnly=_state.readOnly,estimate=_state.estimate,value=_state.value;var changeOrderQuote=this.props.changeOrderTask.change_order_quote;var workOrderTitle='WO #'+this.props.workOrder.number;if(this.props.workOrder.name!==null){workOrderTitle+=': '+this.props.workOrder.name;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_modal_FormModal__["a" /* default */],{className:'change-order-quote-details-modal',show:this.props.show,title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title-task'},'Task # ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Number__["a" /* default */],{value:this.props.task.number,format:'00'}),':',' ',this.props.task.name,' (CO #',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Number__["a" /* default */],{value:this.props.changeOrderTask.number,format:'00'}),')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title-wo'},'(',workOrderTitle,')')),onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'task-wo-details-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[this.props.task.contractor_name],title:'CONTRACTOR'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[this.props.workOrder.building.location.street_address_1,this.props.workOrder.building.location.city+', '+this.props.workOrder.building.location.state+' '+this.props.workOrder.building.location.zip,this.props.workOrder.building.name!==''&&this.props.workOrder.building.name!==null?this.props.workOrder.building.name:''],title:'BUILDING'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:this.props.workOrder.working_hours,title:'AVAILABLE WORKING HOURS'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[this.props.changeOrderTask.description],title:'DESCRIPTION'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'images-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_image_upload_ImageUpload__["a" /* default */],{images:this.props.changeOrderTask.images.map(function(img){return{url:img.image.url,preview:img.image.preview.url};}),readOnly:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'change-order-quote-details-container'},changeOrderQuote.start_date!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote start-date'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Start Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__["a" /* default */],{value:changeOrderQuote.start_date,format:'M/D/YYYY'}))),changeOrderQuote.days_of_duration!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Duration'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_9_numeral___default()(changeOrderQuote.days_of_duration).format('0.[0]')+' '+(changeOrderQuote.days_of_duration>1?'days':'day'))),changeOrderQuote.material_lead_days!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Material Lead Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_9_numeral___default()(changeOrderQuote.material_lead_days).format('0.[0]')+' '+(changeOrderQuote.material_lead_days>1?'days':'day'))),this.props.changeOrderTask.completion_date!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Task Completion Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__["a" /* default */],{value:this.props.changeOrderTask.completion_date,format:'M/D/YYYY'}))),this.props.changeOrderTask.change_order_quote.end_date!==null&&this.props.changeOrderTask.completion_date!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Contractor Completion Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.getJobCompletionDiff()!==0?''+(this.getJobCompletionDiff()>0?'+':'')+this.getJobCompletionDiff()+' days from task completion date':'Same as task completion date')),readOnly&&changeOrderQuote.estimate!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote cost'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Cost'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Number__["a" /* default */],{value:changeOrderQuote.estimate,format:'$ 0'}))),readOnly&&changeOrderQuote.estimate!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote cost'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Number__["a" /* default */],{value:changeOrderQuote.value||'',format:'$ 0'}))),!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote cost'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Cost'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_input_Input__["a" /* default */],{id:'quote-estimate',onChange:this.handleEstimateChange,value:estimate,theme:'normal'}))),!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote cost'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_input_Input__["a" /* default */],{id:'quote-value',onChange:this.handleValueChange,value:value,theme:'normal'}))),changeOrderQuote.estimate!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote cost'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Number__["a" /* default */],{value:__WEBPACK_IMPORTED_MODULE_9_numeral___default()(estimate).value()+__WEBPACK_IMPORTED_MODULE_9_numeral___default()(value).value(),format:'$ 0'}))),changeOrderQuote.description!==null&&changeOrderQuote.description!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,changeOrderQuote.description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,changeOrderQuote.status.charAt(0).toUpperCase()+changeOrderQuote.status.slice(1))),changeOrderQuote.submitted_at!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote submitted-date'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Quoted Submitted on',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__["a" /* default */],{value:changeOrderQuote.submitted_at,format:'M/D/YYYY'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},readOnly&&changeOrderQuote.status!=='approved'&&changeOrderQuote.status!=='acr'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Edit',onClick:this.handleEdit}),!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{className:'btn button button-white',label:'Cancel',onClick:this.handleCancel}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{className:'btn button button-orange',label:'Save',onClick:this.handleSave}))));}},{key:'getJobCompletionDiff',value:function getJobCompletionDiff(){return __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.props.changeOrderTask.change_order_quote.end_date).diff(__WEBPACK_IMPORTED_MODULE_8_moment___default()(this.props.changeOrderTask.completion_date),'days');}}]);return ChangeOrderQuoteDetailsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ChangeOrderQuoteDetailsModal.propTypes={changeOrderTask:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,task:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,show:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,workOrder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onSave:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};ChangeOrderQuoteDetailsModal.defaultProps={show:false};/* harmony default export */ __webpack_exports__["a"] = (ChangeOrderQuoteDetailsModal);

/***/ }),
/* 2192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailsMembers_css__ = __webpack_require__(2194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailsMembers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DetailsMembers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_members_AddMemberModal__ = __webpack_require__(2195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_contractors_ContractorStatus__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_members__ = __webpack_require__(581);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsMembers=function(_Component){_inherits(DetailsMembers,_Component);function DetailsMembers(props){_classCallCheck(this,DetailsMembers);var _this=_possibleConstructorReturn(this,(DetailsMembers.__proto__||Object.getPrototypeOf(DetailsMembers)).call(this,props));_this.handleDeleteConfirmation=function(response){if(response){_this.props.onMemberDelete(_this.state.memberIdToDelete);}_this.setState({memberIdToDelete:null,showDeleteConfirmation:false});};var currentUser=props.currentUser;_this.showDelete=__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["f" /* TYPES */].CONTRACTOR)&&(__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["g" /* usersUtil */].hasRole(currentUser,__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["e" /* ROLES */].OWNER)||__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["g" /* usersUtil */].hasRole(currentUser,__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["e" /* ROLES */].CONTRACTOR_PROJECT_MANAGER));_this.state={memberIdToDelete:null,showDeleteConfirmation:false};return _this;}_createClass(DetailsMembers,[{key:'render',value:function render(){var members=this.props.members;var classNames=['members-table'];var headers=['NAME','EMAIL','PHONE NUMBER','STATUS'];if(this.showDelete){classNames.push('for-contractor');headers.push('');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-members'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleTable__["a" /* default */],{className:classNames.join(' '),headers:headers,rows:this.mapMembers(members),emptyMessage:'No Members'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_members_AddMemberModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showDeleteConfirmation,message:'Are you sure you want to delete the member?',onHide:this.handleDeleteConfirmation}));}},{key:'mapMembers',value:function mapMembers(members){var _this2=this;return members.map(function(member){var rows=[member.user.first_name+' '+member.user.last_name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mailto'},member.user.email),member.user.phone_number!==null?Object(__WEBPACK_IMPORTED_MODULE_5_services_utils_text_util__["c" /* formatPhoneNumber */])(member.user.phone_number):'N/A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_admin_contractors_ContractorStatus__["a" /* default */],{status:member.user.status})];if(_this2.showDelete){if(__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["g" /* usersUtil */].hasType(member.user,__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["f" /* TYPES */].CONTRACTOR)){rows.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{className:'button-blue-grey',label:'Delete',onClick:function onClick(){return _this2.setState({memberIdToDelete:member.id,showDeleteConfirmation:true});}}));}else{rows.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null));}}return rows;});}}]);return DetailsMembers;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DetailsMembers.propTypes={currentUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,members:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})).isRequired,onMemberDelete:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};var mapStateToProps=function mapStateToProps(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_authentication__["d" /* getCurrentUser */])(state),members:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_details_details__["g" /* getMembers */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMemberDelete:function onMemberDelete(memberId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_members__["a" /* deleteMember */])(memberId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(DetailsMembers));

/***/ }),
/* 2194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddMemberModal_css__ = __webpack_require__(2196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddMemberModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AddMemberModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_members__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_selectors_admin_work_orders_details_members__ = __webpack_require__(2198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddMemberModal=function(_Component){_inherits(AddMemberModal,_Component);function AddMemberModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddMemberModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddMemberModal.__proto__||Object.getPrototypeOf(AddMemberModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_members__["b" /* setShowAddMemberModal */])(false));},_this.handleSubmit=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_members__["d" /* submitFormRequest */])(_this.props.currentWorkOrder.id,_this.props.form));},_this.handleAttributeChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_members__["e" /* updateFormValue */])(attribute,value));},_this.handleUserChange=function(option){var _this$props=_this.props,currentUser=_this$props.currentUser,currentWorkOrder=_this$props.currentWorkOrder,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_members__["e" /* updateFormValue */])('userId',option.value));if(__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["f" /* TYPES */].CONTRACTOR)){// If user is contractor, create a suggested note for the selected new member.
var suggestedNote=option.label+', you are being added to this Work Order for notifications associated with '+currentWorkOrder.client.company_name+', WO #'+currentWorkOrder.number+(currentWorkOrder.name!==null&&currentWorkOrder.name!==''?', '+currentWorkOrder.name:'')+'.';dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_details_members__["e" /* updateFormValue */])('note',suggestedNote));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddMemberModal,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__["a" /* default */],{className:'add-member-modal',show:this.props.showAddMemberModal,title:'Add Member',onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__["a" /* default */],{disabled:this.props.users.length===0,options:this.props.users.filter(function(user){return _this2.filterUser(user);}).map(function(user){return{value:user.id,label:user.first_name+' '+user.last_name};}),placeholder:'Which Member would you like to add?',valid:this.props.invalidFields.find(function(element){return element==='userId';})===undefined,value:this.props.form.userId,onChange:this.handleUserChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_TextArea__["a" /* default */],{placeholder:'Note',value:this.props.form.note,onChange:this.handleAttributeChange.bind(this,'note')})),this.props.validationMessage!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},this.props.validationMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-orange',value:'Continue',onClick:this.handleSubmit})));}},{key:'filterUser',value:function filterUser(user){var result=false;if(user.status==='active'){// If user is already a member, don't show it
result=this.props.members.filter(function(member){return member.user.id===user.id;}).length===0;}return result;}}]);return AddMemberModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_authentication__["d" /* getCurrentUser */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_work_orders_details_members__["a" /* getForm */])(state),invalidFields:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_work_orders_details_members__["b" /* getInvalidFields */])(state),members:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_details_details__["g" /* getMembers */])(state),showAddMemberModal:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_work_orders_details_members__["c" /* getShowAddMemberModal */])(state),users:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_work_orders_details_members__["d" /* getUsers */])(state),validationMessage:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_work_orders_details_members__["e" /* getValidationMessage */])(state)};})(AddMemberModal));

/***/ }),
/* 2196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return workOrdersUsersApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WorkOrdersUsersApi=function(_BaseApi){_inherits(WorkOrdersUsersApi,_BaseApi);function WorkOrdersUsersApi(){_classCallCheck(this,WorkOrdersUsersApi);return _possibleConstructorReturn(this,(WorkOrdersUsersApi.__proto__||Object.getPrototypeOf(WorkOrdersUsersApi)).apply(this,arguments));}_createClass(WorkOrdersUsersApi,[{key:'deleteMember',value:function deleteMember(memberId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/work_order_users/'+memberId).then(function(){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return WorkOrdersUsersApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var workOrdersUsersApi=new WorkOrdersUsersApi();

/***/ }),
/* 2198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getShowAddMemberModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getInvalidFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getValidationMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getForm=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.members.ui.form;},function(form){return form;});var getUsers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.members.data.users;},function(users){return users;});var getShowAddMemberModal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.members.ui.showAddMemberModal;},function(showAddMemberModal){return showAddMemberModal;});var getInvalidFields=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.members.ui.invalidFields;},function(invalidFields){return invalidFields;});var getValidationMessage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.members.ui.validationMessage;},function(validationMessage){return validationMessage;});

/***/ }),
/* 2199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DetailsOpenItems_css__ = __webpack_require__(2201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DetailsOpenItems_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__DetailsOpenItems_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__open_items_EditOpenItemModal__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_text_SimpleTruncate__ = __webpack_require__(200);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsOpenItems=function(_Component){_inherits(DetailsOpenItems,_Component);function DetailsOpenItems(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DetailsOpenItems);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DetailsOpenItems.__proto__||Object.getPrototypeOf(DetailsOpenItems)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenItemSelection=function(openItemId){var openItems=Object.values(_this.props.openItemsByTaskId).reduce(function(accumulator,currentValue){return accumulator.concat(currentValue);},[]);var openItem=openItems.find(function(openItem){return openItem.id===openItemId;});_this.taskId=openItem.task.id;_this.taskNumber=openItem.task.number;_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_admin_work_orders_details_details__["_3" /* setSelectedOpenItem */])(openItem));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DetailsOpenItems,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-open-items'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_table_SimpleTable__["a" /* default */],{className:'open-items-table',headers:['TASK #','ASSIGNED TO','STATUS','DESCRIPTION','NOTE','UPDATED AT','CRITICAL'],rows:DetailsOpenItems.mapOpenItems(this.props.openItemsByTaskId),emptyMessage:'No Open Items',onRowSelected:this.handleOpenItemSelection}),this.props.selectedOpenItemId!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__open_items_EditOpenItemModal__["a" /* default */],{taskId:this.taskId,taskNumber:this.taskNumber}));}}],[{key:'mapOpenItems',value:function mapOpenItems(openItemsByTaskId){var openItems=Object.values(openItemsByTaskId).reduce(function(accumulator,currentValue){return accumulator.concat(currentValue);},[]);return openItems.map(function(openItem){return{id:openItem.id,selectable:true,data:[__WEBPACK_IMPORTED_MODULE_5_numeral___default()(openItem.task.number).format('00')+'-'+openItem.letter,openItem.user.first_name+' '+openItem.user.last_name,DetailsOpenItems.createStatusElement(openItem.resolved),openItem.description,openItem.resolved_note!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_text_SimpleTruncate__["a" /* default */],{text:openItem.resolved_note}):'N/A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_text_Date__["a" /* default */],{value:openItem.updated_at,format:'LL'}),openItem.critical?'Yes':'No']};});}},{key:'createStatusElement',value:function createStatusElement(resolved){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,resolved?'Complete':'Incomplete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status '+(resolved?'complete':'incomplete')}));}}]);return DetailsOpenItems;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{openItemsByTaskId:Object(__WEBPACK_IMPORTED_MODULE_2__selectors_admin_work_orders_details_details__["i" /* getOpenItemsByTaskId */])(state),selectedOpenItemId:Object(__WEBPACK_IMPORTED_MODULE_2__selectors_admin_work_orders_details_details__["q" /* getSelectedOpenItemId */])(state)};})(DetailsOpenItems));

/***/ }),
/* 2201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProposalApprovalModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_proposal_approval__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_decline_proposal__ = __webpack_require__(2203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal_approval__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ProposalApprovalModal_css__ = __webpack_require__(2204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ProposalApprovalModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ProposalApprovalModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_modal_MessageModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_actions_admin_work_orders_details_qualifications__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_domain_proposal_status_enum__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_services_utils_permissions_util__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_admin_work_orders_details_proposals_TasksReviewTable__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_admin_work_orders_details_proposals_CostsDatesProposal__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_shared_pdf_viewer_PdfViewer__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_images_print_svg__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_images_print_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_images_print_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_images_mail_svg__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_images_mail_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_images_mail_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_selectors_admin_work_orders_details_proposal__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_admin_work_orders_details_proposals_ProposalEmailModal__ = __webpack_require__(2207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_admin_work_orders_details_deposit_DepositContainer__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_admin_work_orders_details_qualifications_QualificationsContainer__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_shared_modal_DeclineModal__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_selectors_admin_work_orders_details_decline_proposal__ = __webpack_require__(2213);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * This component is used in DetailsQuotes, and show if a proposal is selected
 */var ProposalApprovalModal=function(_Component){_inherits(ProposalApprovalModal,_Component);function ProposalApprovalModal(props){_classCallCheck(this,ProposalApprovalModal);var _this=_possibleConstructorReturn(this,(ProposalApprovalModal.__proto__||Object.getPrototypeOf(ProposalApprovalModal)).call(this,props));_this.handleApprove=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal_approval__["a" /* approveProposalRequest */])(_this.props.selectedProposalId,Object.values(_this.state.quotes).filter(function(element){return element.selected;}).map(function(element){return element.quote.id;})));};_this.handleDecline=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_decline_proposal__["c" /* showDeclineProposalModal */])());};_this.handleDeclineSubmit=function(values){if(values.sure==='yes'){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_decline_proposal__["b" /* declineProposalRequest */])(_this.props.currentWorkOrder.id,_this.props.selectedProposalId,values.password,values.reason,_this.props.additionalInfo));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_decline_proposal__["a" /* closeDeclineProposalModal */])());}};_this.handleClose=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal_approval__["b" /* closeProposalApprovalModal */])());};_this.handleEdit=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal_approval__["b" /* closeProposalApprovalModal */])());var selectedProposal=_this.props.proposals.find(function(element){return element.id===_this.props.selectedProposalId;});_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__["t" /* showEditProposalModal */])(selectedProposal));};_this.handleQuoteCheck=function(quoteId){_this.setState({quotes:Object.assign({},_this.state.quotes,_defineProperty({},quoteId,Object.assign({},_this.state.quotes[quoteId],{selected:!_this.state.quotes[quoteId].selected})))});};_this.handleCloseSuccessModal=function(){var userIsAdmin=__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["g" /* usersUtil */].hasRole(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);var userIsContractor=__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);var contractorUserCanSeeMoney=__WEBPACK_IMPORTED_MODULE_16_services_utils_permissions_util__["a" /* PermissionsUtil */].contractorUserCanSeeMoney(_this.props.currentUser);_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal_approval__["c" /* closeSuccessModal */])());_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal_approval__["b" /* closeProposalApprovalModal */])());_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions_admin_work_orders_details_details__["L" /* loadWorkOrderRequest */])(_this.props.currentWorkOrder.id,userIsAdmin,userIsContractor,contractorUserCanSeeMoney));};_this.handleProposalPrint=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__["l" /* printProposal */])(_this.selectedProposal.id));};_this.handlePdfViewerClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__["d" /* closePdfViewer */])());};_this.handleProposalEmail=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__["s" /* setShowEmailModal */])(true));};_this.handleWithdraw=function(){_this.setState({showWithdrawConfirmation:true});};_this.handleWithdrawConfirmation=function(response){_this.setState({showWithdrawConfirmation:false});if(response){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__["A" /* withDrawProposalRequest */])(_this.selectedProposal.id));}};var quotes={};_this.selectedProposal=props.proposals.find(function(element){return element.id===props.selectedProposalId;});_this.selectedProposal.proposal_quotes.forEach(function(proposalQuote){var quoteId=proposalQuote.quote_id;var quoteTotal=void 0;var quote=props.quotes.find(function(element){return element.id===quoteId;});if(quote!==undefined){// Update quote estimate and value with proposal values (fee, insurance and markup)
// DON'T UPDATE STATE OBJECT!!!
quoteTotal=__WEBPACK_IMPORTED_MODULE_8_numeral___default()(quote.estimate).value()+__WEBPACK_IMPORTED_MODULE_8_numeral___default()(quote.value).value()+__WEBPACK_IMPORTED_MODULE_8_numeral___default()(proposalQuote.fee).value()+__WEBPACK_IMPORTED_MODULE_8_numeral___default()(proposalQuote.insurance).value()+__WEBPACK_IMPORTED_MODULE_8_numeral___default()(proposalQuote.markup).value();quotes[quote.id]={quote:quote,total:quoteTotal,selected:true};}});_this.state={showWithdrawConfirmation:false,quotes:quotes};return _this;}_createClass(ProposalApprovalModal,[{key:'componentDidMount',value:function componentDidMount(){if(this.selectedProposal.qualifications.length>0&&this.selectedProposal.proposal_qualifications.length>0){var selectedQualificationsById=this.selectedProposal.proposal_qualifications.reduce(function(accumulator,currentValue){accumulator[currentValue.qualification_id]={id:currentValue.qualification_id,// value=0 because we only need the label
option:currentValue.option!==null?{value:0,label:currentValue.option}:null};return accumulator;},{});this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_actions_admin_work_orders_details_qualifications__["i" /* setSelectedQualificationsById */])(selectedQualificationsById));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_actions_admin_work_orders_details_qualifications__["e" /* loadQualificationsSuccess */])(this.selectedProposal.qualifications));}else{this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_actions_admin_work_orders_details_qualifications__["i" /* setSelectedQualificationsById */])({}));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_actions_admin_work_orders_details_qualifications__["e" /* loadQualificationsSuccess */])([]));}var deposit=this.selectedProposal.deposit;if(deposit!==undefined&&deposit!==null){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__["h" /* depositSelectedChange */])(true));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__["g" /* depositCostChange */])(deposit.cost));}else{this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__["g" /* depositCostChange */])(null));}}},{key:'getMaterialLeadTime',value:function getMaterialLeadTime(mDays){if(mDays){return __WEBPACK_IMPORTED_MODULE_8_numeral___default()(mDays).value()+' '+(mDays>1?'days':'day');}return'N/A';}},{key:'render',value:function render(){var _this2=this;var canSelectTask=__WEBPACK_IMPORTED_MODULE_13_domain_proposal_status_enum__["a" /* ProposalStatus */].WAITING.equals(this.selectedProposal.status)&&__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["f" /* TYPES */].CLIENT);var values=[];Object.values(this.state.quotes).sort(function(e1,e2){return e1.quote&&e2.quote?e1.quote.task.number-e2.quote.task.number:-1;}).forEach(function(element){if(element.quote!==undefined){var proposal_quote=_this2.selectedProposal.proposal_quotes.find(function(pq){return pq.quote_id===element.quote.id;});var value={id:element.quote.id,number:element.quote.task.number,details:element.quote.task.name!==null?element.quote.task.name:element.quote.task.trade.label,materialLeadTime:_this2.getMaterialLeadTime(element.quote.material_lead_days),cost:__WEBPACK_IMPORTED_MODULE_8_numeral___default()(element.total).value(),markup:__WEBPACK_IMPORTED_MODULE_8_numeral___default()(proposal_quote.markup).value(),fee:__WEBPACK_IMPORTED_MODULE_8_numeral___default()(proposal_quote.fee).value(),insurance:__WEBPACK_IMPORTED_MODULE_8_numeral___default()(proposal_quote.insurance).value(),breakdownItems:proposal_quote.breakdown_items};// If proposal is waiting for approval (and user is not client), show checks to select tasks
if(canSelectTask){value['selected']=element.selected;}values.push(value);}});// Only take into account selected quotes for total
var total=Object.values(this.state.quotes).reduce(function(accumulator,currentValue){if(currentValue.selected){return accumulator+currentValue.total;}else{return accumulator;}},0);var successMessage='Thank you. The Proposal approval was submitted to Spackle';if(this.props.currentWorkOrder.client.po_required&&!this.props.currentWorkOrder.client.global_po_required){successMessage+=', please upload the Purchase Order document.';}else{successMessage+='.';}var titlePostfix=void 0;if(__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["f" /* TYPES */].CLIENT)){titlePostfix=__WEBPACK_IMPORTED_MODULE_29_moment___default()(this.selectedProposal.created_at).format('LL');}else{var reason='';if(this.selectedProposal.rejected_reason_1){var reason1=this.selectedProposal.rejected_reason_1;var reason2=this.selectedProposal.rejected_reason_2;reason=' ('+reason1+(reason2?': '+reason2+')':')');}titlePostfix=Object(__WEBPACK_IMPORTED_MODULE_18_services_utils_text_util__["e" /* toUpperFirstLetter */])(this.selectedProposal.status)+reason;}var title='Proposal (WO #'+this.props.currentWorkOrder.number+' '+ProposalApprovalModal.getWorkOrderName(this.props.currentWorkOrder)+') - '+titlePostfix;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_modal_FormModal__["a" /* default */],{className:'proposal-modal proposal-approval-modal',show:this.props.selectedProposalId!==null,title:title,subTitle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2'},'Spackle is pleased to submit proposal #',this.selectedProposal.number,' for:'),onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'proposal-approval-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_admin_work_orders_details_proposals_TasksReviewTable__["a" /* default */],{showSelection:canSelectTask,values:values,onSelection:this.handleQuoteCheck}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'costs-dates-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_shared_button_Button__["a" /* default */],{className:'button-white',icon:__WEBPACK_IMPORTED_MODULE_24_images_mail_svg___default.a,label:'Email',onClick:this.handleProposalEmail}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_shared_button_Button__["a" /* default */],{className:'button-white print-button',icon:__WEBPACK_IMPORTED_MODULE_23_images_print_svg___default.a,label:'Print',onClick:this.handleProposalPrint})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_admin_work_orders_details_proposals_CostsDatesProposal__["a" /* default */],{completionDate:{value:this.selectedProposal.completion_date},startDate:this.selectedProposal.start_date,total:total})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_components_admin_work_orders_details_deposit_DepositContainer__["a" /* default */],{readOnly:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_components_admin_work_orders_details_qualifications_QualificationsContainer__["a" /* default */],{readOnly:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'proposal-days-sign'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body-bold'},'Proposal is good for 30 days'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-regular'},'4130 Cahuenga Blvd, Suite 206'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-regular'},'Los Angeles, CA 91602'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-regular'},'Phone: (310) 848-3078')),__WEBPACK_IMPORTED_MODULE_13_domain_proposal_status_enum__["a" /* ProposalStatus */].WAITING.equals(this.selectedProposal.status)&&__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["f" /* TYPES */].CLIENT)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:Object.values(this.state.quotes).filter(function(element){return element.selected;}).length===0,label:'Approve',onClick:this.handleApprove})),__WEBPACK_IMPORTED_MODULE_13_domain_proposal_status_enum__["a" /* ProposalStatus */].WAITING.equals(this.selectedProposal.status)&&(__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["g" /* usersUtil */].hasRole(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_shared_button_Button__["a" /* default */],{className:'button-white',label:'Decline',onClick:this.handleDecline}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:'Withdraw',onClick:this.handleWithdraw}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:Object.values(this.state.quotes).filter(function(element){return element.selected;}).length===0,label:'Approve',onClick:this.handleApprove})),__WEBPACK_IMPORTED_MODULE_13_domain_proposal_status_enum__["a" /* ProposalStatus */].APPROVED.equals(this.selectedProposal.status)&&(__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["g" /* usersUtil */].hasRole(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Edit',onClick:this.handleEdit})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_components_shared_modal_DeclineModal__["a" /* default */],{show:this.props.showDeclineModal,onSubmit:this.handleDeclineSubmit}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_modal_MessageModal__["a" /* default */],{show:this.props.showSuccessMessage,message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,successMessage),onHide:this.handleCloseSuccessModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:this.props.pdf,type:'blob'},show:this.props.showPdfViewer,onClose:this.handlePdfViewerClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_admin_work_orders_details_proposals_ProposalEmailModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showWithdrawConfirmation,message:'Are you sure',onHide:this.handleWithdrawConfirmation}));}}],[{key:'getWorkOrderName',value:function getWorkOrderName(workOrder){return workOrder.name!==null?': '+workOrder.name:'';}},{key:'renderTotal',value:function renderTotal(label,value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,value))));}}]);return ProposalApprovalModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_14_selectors_authentication__["d" /* getCurrentUser */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),pdf:Object(__WEBPACK_IMPORTED_MODULE_25_selectors_admin_work_orders_details_proposal__["g" /* getPdf */])(state),proposals:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_details_details__["l" /* getProposals */])(state),quotes:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_details_details__["m" /* getQuotes */])(state),selectedProposalId:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_proposal_approval__["a" /* getSelectedProposalId */])(state),showDeclineModal:Object(__WEBPACK_IMPORTED_MODULE_32_selectors_admin_work_orders_details_decline_proposal__["a" /* getDeclineProposalShow */])(state),showPdfViewer:Object(__WEBPACK_IMPORTED_MODULE_25_selectors_admin_work_orders_details_proposal__["k" /* getShowPdfViewer */])(state),showSuccessMessage:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_proposal_approval__["c" /* getShowSuccessMessage */])(state),users:Object(__WEBPACK_IMPORTED_MODULE_25_selectors_admin_work_orders_details_proposal__["n" /* getUsers */])(state)};})(ProposalApprovalModal));

/***/ }),
/* 2203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = closeDeclineProposalModal;
/* harmony export (immutable) */ __webpack_exports__["b"] = declineProposalRequest;
/* harmony export (immutable) */ __webpack_exports__["c"] = showDeclineProposalModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_admin_work_orders_details_proposal_approval__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_proposals_api__ = __webpack_require__(421);
function closeDeclineProposalModal(){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_48" /* WORK_ORDERS_DETAILS_DECLINE_PROPOSAL_MODAL_CLOSE */]};}function declineProposalRequest(currentWorkOrderId,proposalId,password,reason1,reason2){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_proposals_api__["a" /* proposalsApi */].reject(proposalId,password,reason1,reason2).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_details_details__["_14" /* updateProposal */])(response.proposal));dispatch(closeDeclineProposalModal());dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_admin_work_orders_details_proposal_approval__["b" /* closeProposalApprovalModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_details_details__["L" /* loadWorkOrderRequest */])(currentWorkOrderId,true,false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_details_details__["W" /* selectNavigationBar */])(currentWorkOrderId,1));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function showDeclineProposalModal(){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types__["_49" /* WORK_ORDERS_DETAILS_DECLINE_PROPOSAL_MODAL_SHOW */]};}

/***/ }),
/* 2204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_details_proposal__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_domain_work_order__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProposalEmailModal_css__ = __webpack_require__(2208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProposalEmailModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ProposalEmailModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_details_proposal_approval__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_email_EmailEditor__ = __webpack_require__(422);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProposalEmailModal=function(_Component){_inherits(ProposalEmailModal,_Component);function ProposalEmailModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProposalEmailModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProposalEmailModal.__proto__||Object.getPrototypeOf(ProposalEmailModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleSend=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__["p" /* sendEmail */])(_this.props.selectedProposalId,_this.props.emails,_this.props.subject,_this.props.message)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__["s" /* setShowEmailModal */])(false));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__["i" /* initializeEmailValues */])(_this.props.selectedProposalNumber,_this.props.currentWorkOrder.number,_this.props.currentWorkOrder.name,_this.props.currentWorkOrder.building.location,_this.props.currentWorkOrder.client.company_name,_this.props.users));}});},_this.handleClose=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__["s" /* setShowEmailModal */])(false));},_this.handleAddCustomEmail=function(email){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__["b" /* addEmail */])(email));},_this.handleToEmailRemove=function(email){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__["n" /* removeEmail */])(email));},_this.handleAddUserEmail=function(email){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__["b" /* addEmail */])(email));},_this.handleSubjectConfirm=function(subject){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__["r" /* setProposalSubject */])(subject));},_this.handleMessageChange=function(message){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_work_orders_details_proposal__["q" /* setProposalMessage */])(message));},_this.isSendButtonEnabled=function(){return _this.props.emails.length>0&&_this.props.subject!==''&&_this.props.message!=='';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProposalEmailModal,[{key:'render',value:function render(){var woName=__WEBPACK_IMPORTED_MODULE_7_domain_work_order__["a" /* WorkOrder */].getName(this.props.currentWorkOrder);var title='Proposal (WO #'+this.props.currentWorkOrder.number+(woName!==null?': '+woName:'')+')';return this.props.showEmailModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{className:'proposal-email-modal',show:this.props.showEmailModal,title:title,onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'proposal-email-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_email_EmailEditor__["a" /* EmailEditor */],{toEmails:this.props.emails,message:this.props.message,subject:this.props.subject,usersEmail:this.props.users.map(function(user){return user.email;}),onCustomEmailAdd:this.handleAddCustomEmail,onMessageChange:this.handleMessageChange,onSubjectConfirm:this.handleSubjectConfirm,onToEmailRemove:this.handleToEmailRemove,onUserEmailAdd:this.handleAddUserEmail}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:!this.isSendButtonEnabled(),label:'Send',onClick:this.handleSend})))):null;}}]);return ProposalEmailModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),emails:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_details_proposal__["e" /* getEmails */])(state),message:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_details_proposal__["f" /* getMessage */])(state),selectedProposalId:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_details_proposal_approval__["a" /* getSelectedProposalId */])(state),selectedProposalNumber:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_details_proposal_approval__["b" /* getSelectedProposalNumber */])(state),showEmailModal:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_details_proposal__["j" /* getShowEmailModal */])(state),subject:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_details_proposal__["m" /* getSubject */])(state),users:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_details_proposal__["n" /* getUsers */])(state)};})(ProposalEmailModal));

/***/ }),
/* 2208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REASON_OPTIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_radio_button_RadioButton__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DeclineForm_css__ = __webpack_require__(2212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DeclineForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DeclineForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_input_TextArea__ = __webpack_require__(62);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var REASON_OPTIONS={1:'Pricing',2:'Schedule',3:'Using Preferred Contractor'};var DeclineFormClass=function(_Component){_inherits(DeclineFormClass,_Component);function DeclineFormClass(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DeclineFormClass);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeclineFormClass.__proto__||Object.getPrototypeOf(DeclineFormClass)).call.apply(_ref,[this].concat(args))),_this),_this.renderDropDown=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_dropdown_Dropdown__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(option){return props.input.onChange(option.value);}},props));},_this.renderInput=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_input_Input__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));},_this.renderRadioButton=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_radio_button_RadioButton__["a" /* default */],Object.assign({value:props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));},_this.renderTextArea=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_TextArea__["a" /* default */],Object.assign({value:props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DeclineFormClass,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'decline-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.props.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2'},'Are you sure?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'question-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */],{component:this.renderRadioButton,options:[{value:'yes',label:'Yes'},{value:'no',label:'No'}],name:'sure'})),this.props.isSure&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reason-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */],{component:this.renderInput,name:'password',placeholder:'Enter the password',type:'password'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */],{component:this.renderDropDown,name:'reason',options:Object.keys(REASON_OPTIONS).map(function(key){return{value:key,label:REASON_OPTIONS[key]};}),placeholder:'Select the reason'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */],{component:this.renderTextArea,name:'additionalInfo',placeholder:'Enter additional info (optional)'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'continue-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'submit',value:'Continue'}))));}}]);return DeclineFormClass;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(values){var errors={};if(!values.password){errors.password='Required';}if(!values.reason){errors.reason='Required';}return errors;}var DeclineForm=Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["f" /* reduxForm */])({form:'DeclineForm',validate:validate})(DeclineFormClass);var selector=Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["d" /* formValueSelector */])('DeclineForm');DeclineForm=Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(state){var isSure=selector(state,'sure')==='yes';return{isSure:isSure};})(DeclineForm);/* harmony default export */ __webpack_exports__["b"] = (DeclineForm);

/***/ }),
/* 2212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDeclineProposalShow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getDeclineProposalShow=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.declineProposal.ui.show;},function(show){return show;});

/***/ }),
/* 2214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = WorkOrderValueEditor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkOrderValueEditor_css__ = __webpack_require__(2215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkOrderValueEditor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__WorkOrderValueEditor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__ = __webpack_require__(26);
function WorkOrderValueEditor(props){var handleClick=function handleClick(){if(props.edit){if(props.onSave){props.onSave();}}else{if(props.onEdit){props.onEdit();}}};var handleChange=function handleChange(value){if(props.onValueChange){props.onValueChange(value);}};var buttonLabel=void 0;if(props.edit){if(props.saving){buttonLabel='Saving...';}else{buttonLabel='Save';}}else{buttonLabel='Edit';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'work-order-value-editor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-bold wove-label'},props.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wove-row'},props.edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__["a" /* default */],{readOnly:props.saving,value:props.value,onChange:handleChange}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-regular'},props.value),props.canEdit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:props.saving,label:buttonLabel,onClick:handleClick}))));}WorkOrderValueEditor.propTypes={canEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,edit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,saving:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onValueChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSave:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};WorkOrderValueEditor.defaultProps={canEdit:true,edit:false,saving:false};

/***/ }),
/* 2215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsBudget_css__ = __webpack_require__(2217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsBudget_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DetailsBudget_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_budget_NewBudgetModal__ = __webpack_require__(2218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_budget__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_text_BudgetStatus__ = __webpack_require__(2223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_domain_budget__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsBudget=function(_Component){_inherits(DetailsBudget,_Component);function DetailsBudget(props){_classCallCheck(this,DetailsBudget);var _this=_possibleConstructorReturn(this,(DetailsBudget.__proto__||Object.getPrototypeOf(DetailsBudget)).call(this,props));_this.handleBudgetSelection=function(){if(_this.userIsClient||_this.userIsAdmin&&_this.props.budget.status===__WEBPACK_IMPORTED_MODULE_13_domain_budget__["a" /* BudgetStatusKeys */].APPROVED){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_budget__["i" /* loadEmailBudgetDataRequest */])(_this.props.currentWorkOrder.number,_this.props.currentWorkOrder.name,_this.props.currentWorkOrder.building.location,_this.props.currentWorkOrder.client.id)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_budget__["k" /* openApproveReviewModal */])(_this.props.budget));}});}else{// open budget to be edited
_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_budget__["i" /* loadEmailBudgetDataRequest */])(_this.props.currentWorkOrder.number,_this.props.currentWorkOrder.name,_this.props.currentWorkOrder.building.location,_this.props.currentWorkOrder.client.id)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_budget__["l" /* openModal */])(_this.props.budget));}});}};_this.handleCreateBudget=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_budget__["l" /* openModal */])());};_this.userIsAdmin=__WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__["g" /* usersUtil */].isAdmin(_this.props.currentUser)||__WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);_this.userIsClient=__WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__["f" /* TYPES */].CLIENT);return _this;}_createClass(DetailsBudget,[{key:'render',value:function render(){var component=null;if(this.props.budget===null){if(this.userIsAdmin){component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-orange create-button',label:'Create Estimate',onClick:this.handleCreateBudget});}else{component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no-budget-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold'},'No preliminary estimate yet'));}}else{component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_table_SimpleTable__["a" /* default */],{className:'budget-table'+(this.userIsAdmin?' variance':''),rows:this.mapBudget(this.props.budget),onRowSelected:this.handleBudgetSelection});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-budget'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'budget-container'},component),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_budget_NewBudgetModal__["a" /* default */],null));}},{key:'mapBudget',value:function mapBudget(budget){var row=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold'},'Preliminary Estimate #'+budget.version_number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_BudgetStatus__["a" /* default */],{status:budget.status}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Date__["a" /* default */],{value:budget.updated_at,format:'M/D/YYYY'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__["a" /* default */],{value:budget.cost,format:'$0,0'}))];if(this.userIsAdmin){row.push(budget.variance+'%');}return[row];}}]);return DetailsBudget;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{budget:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_details__["a" /* getBudget */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_14_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_authentication__["d" /* getCurrentUser */])(state)};})(DetailsBudget));

/***/ }),
/* 2217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewBudgetModal_css__ = __webpack_require__(2219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewBudgetModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NewBudgetModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_confirmation_ConfirmationPanel__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_check_circle_png__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_check_circle_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_check_circle_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_proposals_TasksReviewTable__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_qualifications_QualificationsContainer__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_selectors_admin_work_orders_details_budget__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_selectors_admin_work_orders_details_qualifications__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_budget__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_work_orders_details_budget_TaskBudget__ = __webpack_require__(2220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_work_orders_details_proposals_CostsDatesProposal__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_shared_modal_DeclineModal__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_images_mail_svg__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_images_mail_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_images_mail_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_images_print_svg__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_images_print_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_images_print_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_shared_pdf_viewer_PdfViewer__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_admin_work_orders_details_budget_BudgetEmailModal__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_shared_modal_MessageModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_images_invalid_png__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_images_invalid_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_images_invalid_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewBudgetModal=function(_Component){_inherits(NewBudgetModal,_Component);function NewBudgetModal(props){_classCallCheck(this,NewBudgetModal);var _this=_possibleConstructorReturn(this,(NewBudgetModal.__proto__||Object.getPrototypeOf(NewBudgetModal)).call(this,props));_this.handleBack=function(event){if(event){event.preventDefault();}_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_budget__["c" /* back */])(_this.props.currentView));};_this.handleButton=function(){if(_this.props.currentView==='review'){if(_this.props.budget===null){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_budget__["f" /* createBudgetRequest */])(_this.props.currentWorkOrder.id,_this.props.valuesByTaskId,_this.props.qualifications,_this.props.selectedQualificationsById));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_budget__["v" /* updateBudgetRequest */])(_this.props.currentWorkOrder.id,_this.props.budget,_this.props.valuesByTaskId,_this.props.qualifications,_this.props.selectedQualificationsById));}}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_budget__["j" /* next */])(_this.props.currentView));}};_this.handleClose=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_budget__["r" /* setShow */])(false));};_this.handleDecline=function(){_this.setState({showDeclineModal:true});};_this.handleDeclineSubmit=function(values){if(values.sure==='yes'){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_budget__["g" /* declineBudget */])(_this.props.currentWorkOrder.id,values)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_19_actions_admin_work_orders_work_orders__["c" /* baseRoutePath */]));}});}else{_this.setState({showDeclineModal:false});}};_this.handleEmail=function(){var _this$props=_this.props,budget=_this$props.budget,selectedQualificationsById=_this$props.selectedQualificationsById,valuesByTaskId=_this$props.valuesByTaskId;if(NewBudgetModal.hasDataChange(budget,valuesByTaskId,selectedQualificationsById)){_this.setState({showHasChangeMessageModal:true});}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_budget__["u" /* setShowEmailModal */])(true));}};_this.handlePdfViewerClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_budget__["e" /* closePdfViewer */])());};_this.handlePrint=function(){var _this$props2=_this.props,budget=_this$props2.budget,selectedQualificationsById=_this$props2.selectedQualificationsById,valuesByTaskId=_this$props2.valuesByTaskId;if(NewBudgetModal.hasDataChange(budget,valuesByTaskId,selectedQualificationsById)){_this.setState({showHasChangeMessageModal:true});}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_budget__["m" /* printBudget */])(_this.props.currentWorkOrder.id));}};_this.handleValueBlur=function(taskId,valueKey,value){// Round value
_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_budget__["x" /* updateValue */])(taskId,valueKey,Math.round(value)));if(valueKey==='cost'){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_budget__["w" /* updateExtraCosts */])(taskId,Math.round(value)));}};_this.handleValueChange=function(taskId,valueKey,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_budget__["x" /* updateValue */])(taskId,valueKey,value));};_this.handleThankYou=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_budget__["r" /* setShow */])(false));};_this.handleApprove=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_budget__["k" /* openApproveReviewModal */])(_this.props.budget));};_this.state={showDeclineModal:false,showHasChangeMessageModal:false};return _this;}_createClass(NewBudgetModal,[{key:'render',value:function render(){var couldGoBack=this.props.currentView==='review';var title=void 0;var version=this.props.budget!==null?'#'+this.props.budget.version_number+' ':'';var postTitle='Preliminary Estimate '+version+'(WO #'+this.props.currentWorkOrder.number+NewBudgetModal.getWorkOrderName(this.props.currentWorkOrder)+')';var mainComponent=void 0;switch(this.props.currentView){case'form':mainComponent=this.renderForm();title=postTitle;break;case'review':mainComponent=this.renderReview();title=postTitle;break;case'thank-you':mainComponent=this.renderThankYou();break;default:mainComponent=null;}return this.props.show?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__["a" /* default */],{className:'new-budget-modal',show:this.props.show,showHeader:this.props.currentView!=='thank-you',title:title,onBack:couldGoBack?this.handleBack:undefined,onClose:this.handleClose},mainComponent):null;}},{key:'renderForm',value:function renderForm(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'items-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'task-budget-items'},this.props.tasks.map(function(task){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:task.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_admin_work_orders_details_budget_TaskBudget__["a" /* default */],{taskNumber:task.number,taskTrade:task.trade.label,values:_this2.props.valuesByTaskId[task.id],onValueBlur:function onValueBlur(valueKey,value){return _this2.handleValueBlur(task.id,valueKey,value);},onValueChange:function onValueChange(valueKey,value){return _this2.handleValueChange(task.id,valueKey,value);}}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_qualifications_QualificationsContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:!this.isReviewButtonEnable(),label:'Review',onClick:this.handleButton})));}},{key:'renderReview',value:function renderReview(){var _this3=this;var _props=this.props,budget=_props.budget,tasks=_props.tasks,valuesByTaskId=_props.valuesByTaskId;var total=0;var values=tasks.map(function(task){var taskValues=valuesByTaskId[task.id];var taskTotal=0;if(taskValues){taskTotal=taskValues.cost+taskValues.fee+taskValues.markup+taskValues.insurance;}total+=taskTotal;return{id:task.id,number:task.number,details:task.name!==null?task.name:task.trade.label,cost:taskTotal};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'items-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_proposals_TasksReviewTable__["a" /* default */],{values:values}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'total-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-white',icon:__WEBPACK_IMPORTED_MODULE_20_images_mail_svg___default.a,label:'Email',onClick:this.handleEmail}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-white print-button',icon:__WEBPACK_IMPORTED_MODULE_21_images_print_svg___default.a,label:'Print',onClick:this.handlePrint})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_admin_work_orders_details_proposals_CostsDatesProposal__["a" /* default */],{total:total})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_qualifications_QualificationsContainer__["a" /* default */],{readOnly:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},budget!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-white',label:'Decline',onClick:this.handleDecline}),budget!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:'Edit',onClick:this.handleBack}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:budget===null?'Submit':'Update',onClick:this.handleButton}),budget!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Approve',onClick:this.handleApprove})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_shared_modal_DeclineModal__["a" /* default */],{show:this.state.showDeclineModal,onSubmit:this.handleDeclineSubmit}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:this.props.pdf,type:'blob'},show:this.props.showPdfViewer,onClose:this.handlePdfViewerClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_components_admin_work_orders_details_budget_BudgetEmailModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_components_shared_modal_MessageModal__["a" /* default */],{show:this.state.showHasChangeMessageModal,icon:__WEBPACK_IMPORTED_MODULE_25_images_invalid_png___default.a,message:'Please update first to see the updated printed view.',onHide:function onHide(){return _this3.setState({showHasChangeMessageModal:false});}}));}},{key:'renderThankYou',value:function renderThankYou(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_confirmation_ConfirmationPanel__["a" /* default */],{image:__WEBPACK_IMPORTED_MODULE_6_images_check_circle_png___default.a,firstLine:'Thank you!',lines:['Preliminary Estimate for WO #'+this.props.currentWorkOrder.number+' has been sent\n            to '+this.props.currentWorkOrder.client.company_name+'.'],buttons:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-orange',value:'Continue',onClick:this.handleThankYou})]});}},{key:'isReviewButtonEnable',value:function isReviewButtonEnable(){var _this4=this;var optionUndefinedForQualification=false;Object.keys(this.props.selectedQualificationsById).forEach(function(key){var qualification=_this4.props.qualifications.find(function(qualification){return qualification.id===__WEBPACK_IMPORTED_MODULE_2_numeral___default()(key).value();});// object.keys returns string
if(qualification!==undefined&&qualification.options.length>0){optionUndefinedForQualification=optionUndefinedForQualification||_this4.props.selectedQualificationsById[key].option===null;}});// If no tasks, then default to false, otherwise will be true and checks that ALL costs are not null
var allCostsWithValue=this.props.tasks.length>0;Object.values(this.props.valuesByTaskId).forEach(function(value){allCostsWithValue=allCostsWithValue&&value.cost!==null&&value.cost!==''&&value.cost>0;});return!optionUndefinedForQualification&&allCostsWithValue;}}],[{key:'getWorkOrderName',value:function getWorkOrderName(workOrder){return workOrder.name!==null&&workOrder.name!==''?': '+workOrder.name:'';}},{key:'hasDataChange',value:function hasDataChange(budget,valuesByTaskId,selectedQualificationsById){// Check tasks values
var taskValuesChanged=Object.keys(valuesByTaskId).some(function(taskId){var budgetTask=budget.budget_tasks.find(function(budgetTask){return budgetTask.task_id===__WEBPACK_IMPORTED_MODULE_2_numeral___default()(taskId).value();});if(budgetTask===undefined){return true;}else{if(__WEBPACK_IMPORTED_MODULE_2_numeral___default()(budgetTask.cost).value()!==valuesByTaskId[taskId].cost){return true;}else if(__WEBPACK_IMPORTED_MODULE_2_numeral___default()(budgetTask.fee).value()!==valuesByTaskId[taskId].fee){return true;}else if(__WEBPACK_IMPORTED_MODULE_2_numeral___default()(budgetTask.insurance).value()!==valuesByTaskId[taskId].insurance){return true;}else if(__WEBPACK_IMPORTED_MODULE_2_numeral___default()(budgetTask.markup).value()!==valuesByTaskId[taskId].markup){return true;}}return false;});// Check qualifications
var qualificationsChanged=budget.budget_qualifications.length!==Object.keys(selectedQualificationsById).length;// Check if some qualification changed
if(!qualificationsChanged){qualificationsChanged=budget.budget_qualifications.some(function(budgetQualification){return selectedQualificationsById[budgetQualification.qualification_id]===undefined;});}//Check if some of the option values has changed
if(!qualificationsChanged){qualificationsChanged=budget.budget_qualifications.some(function(budgetQualification){if(selectedQualificationsById[budgetQualification.qualification_id].option!==null&&budgetQualification.option!==null){return selectedQualificationsById[budgetQualification.qualification_id].option.label!==budgetQualification.option;}else{return false;}});}return taskValuesChanged||qualificationsChanged;}}]);return NewBudgetModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{budget:Object(__WEBPACK_IMPORTED_MODULE_16_selectors_admin_work_orders_details_details__["a" /* getBudget */])(state),currentView:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_admin_work_orders_details_budget__["b" /* getCurrentView */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),pdf:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_admin_work_orders_details_budget__["e" /* getPdf */])(state),qualifications:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_admin_work_orders_details_qualifications__["a" /* getQualifications */])(state),selectedQualificationsById:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_admin_work_orders_details_qualifications__["b" /* getSelectedQualificationsById */])(state),show:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_admin_work_orders_details_budget__["f" /* getShow */])(state),showPdfViewer:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_admin_work_orders_details_budget__["j" /* getShowPdfViewer */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state),valuesByTaskId:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_admin_work_orders_details_budget__["m" /* getValuesByTaskId */])(state)};})(NewBudgetModal));

/***/ }),
/* 2219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TaskBudget;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TaskBudget_css__ = __webpack_require__(2221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TaskBudget_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TaskBudget_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_checkbox_CheckBox__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_input_ComplexNumberInput__ = __webpack_require__(579);
function TaskBudget(props){var handleInputBlur=function handleInputBlur(valueKey,value){if(props.onValueBlur!==undefined){props.onValueBlur(valueKey,value);}};var handleInputChange=function handleInputChange(valueKey,value){if(props.onValueChange!==undefined){props.onValueChange(valueKey,value);}};var showCheck=props.withCheck!==undefined;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'task-budget'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,showCheck&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'with-check-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_checkbox_CheckBox__["a" /* default */],{id:props.withCheck.id,checked:props.withCheck.checked,shape:'round',size:'medium',onChange:props.withCheck.onCheck})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:showCheck?'with-check-text':''},'Task # '+props.taskNumber))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:showCheck?'with-check-text':''},props.taskTrade)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_ComplexNumberInput__["a" /* default */],{label:'Cost',theme:'blue',value:props.values['cost'],onValueBlur:function onValueBlur(value){return handleInputBlur('cost',value);},onValueChange:function onValueChange(value){return handleInputChange('cost',value);}}))),props.showValues&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_ComplexNumberInput__["a" /* default */],{label:'Markup',value:props.values['markup'],onValueBlur:function onValueBlur(value){return handleInputBlur('markup',value);},onValueChange:function onValueChange(value){return handleInputChange('markup',value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_ComplexNumberInput__["a" /* default */],{label:'Fee',value:props.values['fee'],onValueBlur:function onValueBlur(value){return handleInputBlur('fee',value);},onValueChange:function onValueChange(value){return handleInputChange('fee',value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_ComplexNumberInput__["a" /* default */],{label:'Insurance',value:props.values['insurance'],onValueBlur:function onValueBlur(value){return handleInputBlur('insurance',value);},onValueChange:function onValueChange(value){return handleInputChange('insurance',value);}}))))));}TaskBudget.propTypes={showValues:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,taskNumber:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,taskTrade:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,values:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({cost:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),fee:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),insurance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),markup:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])}),withCheck:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,checked:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,onCheck:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}),onValueBlur:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onValueChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};TaskBudget.defaultProps={showValues:true,values:{cost:null,fee:null,insurance:null,markup:null}};

/***/ }),
/* 2221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BudgetStatus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseStatus__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BudgetStatus_css__ = __webpack_require__(2224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BudgetStatus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BudgetStatus_css__);
function BudgetStatus(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'budget-status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BaseStatus__["a" /* default */],{labels:[{id:'approved',label:'approved'},{id:'rejected',label:'rejected'},{id:'waiting',label:'waiting'}],status:props.status}));}BudgetStatus.propTypes={status:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};

/***/ }),
/* 2224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsPurchaseOrder_css__ = __webpack_require__(2226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsPurchaseOrder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DetailsPurchaseOrder_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_purchase_order_PurchaseOrderEditor__ = __webpack_require__(2227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_details_purchase_order__ = __webpack_require__(2229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_purchase_order__ = __webpack_require__(2230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsPurchaseOrder=function(_Component){_inherits(DetailsPurchaseOrder,_Component);function DetailsPurchaseOrder(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DetailsPurchaseOrder);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DetailsPurchaseOrder.__proto__||Object.getPrototypeOf(DetailsPurchaseOrder)).call.apply(_ref,[this].concat(args))),_this),_this.handleCancel=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_purchase_order__["a" /* cancelValues */])(_this.props.currentWorkOrder));},_this.handleDocumentDrop=function(file){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_purchase_order__["d" /* setDocumentFile */])(file));},_this.handleDocumentRemove=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_purchase_order__["b" /* removeDocument */])());},_this.handleEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_purchase_order__["e" /* setEdit */])(!_this.props.edit));},_this.handleNumberChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_purchase_order__["f" /* setNumber */])(value));},_this.handleSave=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_purchase_order__["c" /* saveValuesRequest */])(_this.props.currentWorkOrder.id,_this.props.documentFile,_this.props.number));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DetailsPurchaseOrder,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-purchase-order'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_purchase_order_PurchaseOrderEditor__["a" /* default */],{documentFile:this.props.documentFile,documentUrl:this.props.documentUrl,edit:this.props.edit,number:this.props.number,onCancel:this.handleCancel,onDocumentDrop:this.handleDocumentDrop,onDocumentRemove:this.handleDocumentRemove,onEdit:this.handleEdit,onNumberChange:this.handleNumberChange,onSave:this.handleSave}));}}]);return DetailsPurchaseOrder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),documentFile:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_details_purchase_order__["a" /* getDocumentFile */])(state),documentUrl:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_details_purchase_order__["b" /* getDocumentUrl */])(state),edit:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_details_purchase_order__["c" /* getEdit */])(state),number:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_details_purchase_order__["d" /* getNumber */])(state)};})(DetailsPurchaseOrder));

/***/ }),
/* 2226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PurchaseOrderEditor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PurchaseOrderEditor_css__ = __webpack_require__(2228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PurchaseOrderEditor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PurchaseOrderEditor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_upload_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_upload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_files_FilesUploadedViewer__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_remove_svg__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_remove_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_images_remove_svg__);
function PurchaseOrderEditor(props){var handleCancel=function handleCancel(){if(props.onCancel){props.onCancel();}};var handleDocumentDrop=function handleDocumentDrop(files){if(props.onDocumentDrop&&files.length>0){props.onDocumentDrop(files[0]);}};var handleDocumentRemove=function handleDocumentRemove(){if(props.onDocumentRemove){props.onDocumentRemove();}};var handleEdit=function handleEdit(){if(props.onEdit){props.onEdit();}};var handleNumberChange=function handleNumberChange(value){if(props.onNumberChange){props.onNumberChange(value);}};var handleSave=function handleSave(){if(props.onSave){props.onSave();}};var renderButton=function renderButton(props){if(props.edit){var saveDisabled=props.documentUrl===null&&props.documentFile===null||props.number==='';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:saveDisabled,label:'Save',onClick:handleSave}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_button_Button__["a" /* default */],{className:'button-white',label:'Cancel',onClick:handleCancel}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_button_Button__["a" /* default */],{id:'edit-button',className:'button-orange',label:'Edit',onClick:handleEdit});}};var renderDocument=function renderDocument(props){if(props.edit){if(props.documentUrl!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_files_FilesUploadedViewer__["a" /* default */],{documents:[{id:1,document:{url:props.documentUrl}}],showLink:true,onDocumentRemove:handleDocumentRemove});}else if(props.documentFile!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'file-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_document_DocumentLink__["a" /* default */],{file:props.documentFile,showIcon:false,showLink:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9_images_remove_svg___default.a,alt:'remove',onClick:handleDocumentRemove}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx',className:'dropzone-container',multiple:false,onDrop:handleDocumentDrop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Please drag and drop any file into this area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6_images_upload_svg___default.a,alt:'upload'}));}}else if(props.documentUrl!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_document_DocumentLink__["a" /* default */],{showIcon:false,showLink:true,url:props.documentUrl});}else if(props.documentFile!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_document_DocumentLink__["a" /* default */],{file:props.documentFile,showIcon:false,showLink:true});}};var renderNumber=function renderNumber(props){if(props.edit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__["a" /* default */],{value:props.number,onChange:handleNumberChange});}else{return props.number;}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'purchase-order-editor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Document'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,renderDocument(props))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,renderNumber(props))),!props.readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'button-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2},renderButton(props))))));}PurchaseOrderEditor.propTypes={documentFile:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,documentUrl:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,// url
edit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,number:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,readOnly:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,onCancel:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onDocumentDrop:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onDocumentRemove:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onEdit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onNumberChange:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onSave:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};PurchaseOrderEditor.defaultProps={documentFile:null,documentUrl:null,edit:false,number:'',readOnly:false};

/***/ }),
/* 2228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDocumentFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDocumentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getNumber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getDocumentFile=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.purchaseOrder.ui.documentFile;},function(documentFile){return documentFile;});var getDocumentUrl=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.purchaseOrder.ui.documentUrl;},function(documentUrl){return documentUrl;});var getEdit=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.purchaseOrder.ui.edit;},function(edit){return edit;});var getNumber=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.purchaseOrder.ui.number;},function(number){return number;});

/***/ }),
/* 2230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cancelValues;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeDocument;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveValuesRequest;
/* harmony export (immutable) */ __webpack_exports__["d"] = setDocumentFile;
/* harmony export (immutable) */ __webpack_exports__["e"] = setEdit;
/* harmony export (immutable) */ __webpack_exports__["f"] = setNumber;
/* unused harmony export updateValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_work_orders_api__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
function cancelValues(workOrder){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_107" /* WORK_ORDERS_DETAILS_PURCHASE_ORDER_CANCEL */],payload:workOrder};}function removeDocument(){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_109" /* WORK_ORDERS_DETAILS_PURCHASE_ORDER_DOCUMENT_REMOVE */]};}function saveValuesRequest(workOrderId,file,number){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_api_work_orders_api__["b" /* workOrdersApi */].updatePurchaseOrder(workOrderId,file,number).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_work_orders__["D" /* updateWorkOrderAttribute */])(response.workOrder,'purchase_order_doc'));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_work_orders__["D" /* updateWorkOrderAttribute */])(response.workOrder,'purchase_order'));dispatch(updateValues(response.workOrder));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}function setDocumentFile(file){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_108" /* WORK_ORDERS_DETAILS_PURCHASE_ORDER_DOCUMENT_FILE_SET */],payload:file};}function setEdit(value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_110" /* WORK_ORDERS_DETAILS_PURCHASE_ORDER_EDIT_SET */],payload:value};}function setNumber(value){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_111" /* WORK_ORDERS_DETAILS_PURCHASE_ORDER_NUMBER_SET */],payload:value};}function updateValues(workOrder){return{type:__WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_112" /* WORK_ORDERS_DETAILS_PURCHASE_ORDER_UPDATE */],payload:workOrder};}

/***/ }),
/* 2231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BudgetApproveReviewModal_css__ = __webpack_require__(2232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BudgetApproveReviewModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BudgetApproveReviewModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_proposals_TasksReviewTable__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_proposals_CostsDatesProposal__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_selectors_admin_work_orders_details_budget__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_work_orders_details_qualifications_QualificationsContainer__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_actions_admin_work_orders_details_budget__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_domain_budget__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_shared_modal_MessageModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_images_mail_svg__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_images_mail_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_images_mail_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_images_print_svg__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_images_print_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_images_print_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_shared_pdf_viewer_PdfViewer__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_admin_work_orders_details_budget_BudgetEmailModal__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_services_utils_work_order_status_enum__ = __webpack_require__(90);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function BudgetApproveReview(props){var handleApprove=function handleApprove(){if(props.onApprove){props.onApprove();}};var handleEmail=function handleEmail(){if(props.onEmail){props.onEmail();}};var handlePrint=function handlePrint(){if(props.onPrint){props.onPrint();}};var handleTaskSelection=function handleTaskSelection(id){if(props.onTaskSelection){props.onTaskSelection(id);}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'budget-approve-review'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_proposals_TasksReviewTable__["a" /* default */],{showSelection:props.canApprove,values:props.values,onSelection:handleTaskSelection}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'total-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-white',icon:__WEBPACK_IMPORTED_MODULE_19_images_mail_svg___default.a,label:'Email',onClick:handleEmail}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-white print-button',icon:__WEBPACK_IMPORTED_MODULE_20_images_print_svg___default.a,label:'Print',onClick:handlePrint})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_proposals_CostsDatesProposal__["a" /* default */],{total:props.total})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_admin_work_orders_details_qualifications_QualificationsContainer__["a" /* default */],{readOnly:true}),props.canApprove&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:props.values.filter(function(value){return value.selected;}).length===0,label:'Approve',onClick:handleApprove})));}BudgetApproveReview.propTypes={canApprove:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,total:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,values:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,number:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,details:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,cost:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,selected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool})),onApprove:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onEmail:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onPrint:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onTaskSelection:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};BudgetApproveReview.defaultProps={canApprove:false,total:0,values:[]};var BudgetApproveReviewModal=function(_Component){_inherits(BudgetApproveReviewModal,_Component);function BudgetApproveReviewModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BudgetApproveReviewModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BudgetApproveReviewModal.__proto__||Object.getPrototypeOf(BudgetApproveReviewModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleApprove=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_actions_admin_work_orders_details_budget__["b" /* approveBudget */])(_this.props.currentWorkOrder.id,_this.props.approvedTasksId)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_actions_admin_work_orders_details_budget__["s" /* setShowApprovalConfirmation */])(true));}});},_this.handleApprovalConfirmationClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_actions_admin_work_orders_details_budget__["s" /* setShowApprovalConfirmation */])(false));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_actions_admin_work_orders_details_budget__["t" /* setShowApproveReviewModal */])(false));},_this.handleClose=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_actions_admin_work_orders_details_budget__["t" /* setShowApproveReviewModal */])(false));},_this.handleEmail=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_actions_admin_work_orders_details_budget__["u" /* setShowEmailModal */])(true));},_this.handlePdfViewerClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_actions_admin_work_orders_details_budget__["e" /* closePdfViewer */])());},_this.handlePrint=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_actions_admin_work_orders_details_budget__["m" /* printBudget */])(_this.props.currentWorkOrder.id));},_this.handleTaskSelection=function(id){var found=_this.props.approvedTasksId.find(function(taskId){return taskId===id;})!==undefined;_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_actions_admin_work_orders_details_budget__["d" /* checkTask */])(id,!found));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BudgetApproveReviewModal,[{key:'render',value:function render(){var _this2=this;if(this.props.showApproveReviewModal){var userIsClient=__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["f" /* TYPES */].CLIENT);var userIsAdmin=__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasRole(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);var woStatusEnum=__WEBPACK_IMPORTED_MODULE_24_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(this.props.currentWorkOrder.status);var woPlm=__WEBPACK_IMPORTED_MODULE_24_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].PLM.equals(woStatusEnum);var canApprove=this.props.budget.status===__WEBPACK_IMPORTED_MODULE_16_domain_budget__["a" /* BudgetStatusKeys */].WAITING&&(userIsClient||userIsAdmin)&&woPlm;var values=this.props.budget.budget_tasks.filter(function(budgetTask){return budgetTask.status!==__WEBPACK_IMPORTED_MODULE_16_domain_budget__["b" /* BudgetTaskStatusKeys */].DECLINED;}).map(function(budgetTask){var totalCost=__WEBPACK_IMPORTED_MODULE_13_numeral___default()(budgetTask.cost).value()+__WEBPACK_IMPORTED_MODULE_13_numeral___default()(budgetTask.fee).value()+__WEBPACK_IMPORTED_MODULE_13_numeral___default()(budgetTask.markup).value()+__WEBPACK_IMPORTED_MODULE_13_numeral___default()(budgetTask.insurance).value();var task=_this2.props.tasks.find(function(task){return task.id===budgetTask.task_id;});return{id:budgetTask.task_id,number:task.number,details:task.name!==null?task.name:task.trade.label,cost:totalCost,selected:_this2.props.approvedTasksId.filter(function(id){return id===budgetTask.task_id;}).length>0};});var titlePostfix=void 0;if(__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["f" /* TYPES */].CLIENT)){titlePostfix=__WEBPACK_IMPORTED_MODULE_23_moment___default()(this.props.budget.updated_at).format('LL');}else{titlePostfix=Object(__WEBPACK_IMPORTED_MODULE_17_services_utils_text_util__["e" /* toUpperFirstLetter */])(this.props.budget.status);}var version=this.props.budget!==null?'#'+this.props.budget.version_number+' ':'';var title='Preliminary Estimate '+version+'(WO #'+this.props.currentWorkOrder.number+BudgetApproveReviewModal.getWorkOrderName(this.props.currentWorkOrder)+')       - '+titlePostfix;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__["a" /* default */],{className:'budget-approve-review-modal',show:this.props.showApproveReviewModal,showHeader:this.props.currentView!=='thank-you',title:title,onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BudgetApproveReview,{canApprove:canApprove,values:values,total:__WEBPACK_IMPORTED_MODULE_13_numeral___default()(this.props.budget.cost).value(),onApprove:this.handleApprove,onEmail:this.handleEmail,onPrint:this.handlePrint,onTaskSelection:this.handleTaskSelection})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_shared_modal_MessageModal__["a" /* default */],{show:this.props.showApprovalConfirmation,message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Thank you. The Preliminary Estimate approval was submitted to Spackle.'),onHide:this.handleApprovalConfirmationClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:this.props.pdf,type:'blob'},show:this.props.showPdfViewer,onClose:this.handlePdfViewerClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_admin_work_orders_details_budget_BudgetEmailModal__["a" /* default */],null));}else{return null;}}}],[{key:'getWorkOrderName',value:function getWorkOrderName(workOrder){return workOrder.name!==null?': '+workOrder.name:'';}}]);return BudgetApproveReviewModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{approvedTasksId:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_admin_work_orders_details_budget__["a" /* getApprovedTasksId */])(state),budget:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_details_details__["a" /* getBudget */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_authentication__["d" /* getCurrentUser */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),pdf:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_admin_work_orders_details_budget__["e" /* getPdf */])(state),showApprovalConfirmation:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_admin_work_orders_details_budget__["g" /* getShowApprovalConfirmation */])(state),showApproveReviewModal:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_admin_work_orders_details_budget__["h" /* getShowApproveReviewModal */])(state),showPdfViewer:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_admin_work_orders_details_budget__["j" /* getShowPdfViewer */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state)};})(BudgetApproveReviewModal));

/***/ }),
/* 2232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsContractorsInvoices_css__ = __webpack_require__(2234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsContractorsInvoices_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DetailsContractorsInvoices_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_contractors_invoices_AddInvoiceForm__ = __webpack_require__(2235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_change_order_tasks_store_selectors__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsContractorsInvoices=function(_Component){_inherits(DetailsContractorsInvoices,_Component);function DetailsContractorsInvoices(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DetailsContractorsInvoices);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DetailsContractorsInvoices.__proto__||Object.getPrototypeOf(DetailsContractorsInvoices)).call.apply(_ref,[this].concat(args))),_this),_this.handleSubmit=function(values){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_details__["_20" /* uploadContractorInvoiceRequest */])(_this.props.currentWorkOrder.id,values));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DetailsContractorsInvoices,[{key:'render',value:function render(){var _props=this.props,contractorInvoice=_props.contractorInvoice,quotes=_props.quotes,changeOrderTasks=_props.changeOrderTasks,tasks=_props.tasks;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-contractors-invoices'},contractorInvoice===null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_contractors_invoices_AddInvoiceForm__["a" /* default */],{quotes:quotes,changeOrderTasks:changeOrderTasks,tasks:tasks,onSubmit:this.handleSubmit}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-form-readonly'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["g" /* Form */],{horizontal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["f" /* ControlLabel */],sm:3},'Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:contractorInvoice.cost,format:'$0,0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["f" /* ControlLabel */],sm:3},'Document'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_document_DocumentLink__["a" /* default */],{showIcon:false,url:contractorInvoice.document.document.url}))))));}}]);return DetailsContractorsInvoices;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{contractorInvoice:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_details__["b" /* getContractorInvoice */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),quotes:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_details__["m" /* getQuotes */])(state),changeOrderTasks:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_change_order_tasks_store_selectors__["a" /* getChangeOrderTasks */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state)};})(DetailsContractorsInvoices));

/***/ }),
/* 2234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddInvoiceForm_css__ = __webpack_require__(2236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddInvoiceForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AddInvoiceForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_upload_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_upload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_domain_contractor__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_modal_MessageModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_invalid_png__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_invalid_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_images_invalid_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_domain_task_status_enum__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddInvoiceForm=function(_Component){_inherits(AddInvoiceForm,_Component);function AddInvoiceForm(props){_classCallCheck(this,AddInvoiceForm);var _this=_possibleConstructorReturn(this,(AddInvoiceForm.__proto__||Object.getPrototypeOf(AddInvoiceForm)).call(this,props));_this.handleConfirmation=function(response){if(response){_this.props.onSubmit({cost:_this.cost,document:_this.state.file});}_this.setState({file:null,showConfirmation:false});};_this.handleFiles=function(files){_this.validInvoiceUpload()?_this.setState({file:files[0],showConfirmation:true}):_this.showInvalidUploadMsg();};_this.validateInvoiceUpload=function(e){if(!_this.validInvoiceUpload()){_this.showInvalidUploadMsg();e.stopPropagation();}};_this.validInvoiceUpload=function(){var tasks=_this.props.tasks;return tasks.filter(function(task){return __WEBPACK_IMPORTED_MODULE_10_domain_task_status_enum__["a" /* TaskStatusEnum */].CMP.equals(task.status)||__WEBPACK_IMPORTED_MODULE_10_domain_task_status_enum__["a" /* TaskStatusEnum */].CLS.equals(task.status);}).length===tasks.length;};_this.showInvalidUploadMsg=function(){_this.setState({showInvalidUploadMsg:true});};_this.hideInvalidUploadMsg=function(){_this.setState({showInvalidUploadMsg:false});};_this.state={file:null,showConfirmation:false};_this.cost=__WEBPACK_IMPORTED_MODULE_6_domain_contractor__["a" /* Contractor */].getTotalCost(props.quotes,props.changeOrderTasks,true);return _this;}_createClass(AddInvoiceForm,[{key:'render',value:function render(){var showInvalidUploadMsg=this.state.showInvalidUploadMsg;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-invoice-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["g" /* Form */],{horizontal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:3},'Document'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx',className:'dropzone-container',multiple:false,onDrop:this.handleFiles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.validateInvoiceUpload},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Please drag and drop any file into this area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3_images_upload_svg___default.a,alt:'upload'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showConfirmation,message:'Please confirm that the invoice amount is for '+__WEBPACK_IMPORTED_MODULE_11_numeral___default()(this.cost).format('$0,0'),onHide:this.handleConfirmation}),showInvalidUploadMsg&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_modal_MessageModal__["a" /* default */],{show:showInvalidUploadMsg,message:'Please complete task checklist and submit a completed photo before submitting your invoice',icon:__WEBPACK_IMPORTED_MODULE_9_images_invalid_png___default.a,onHide:this.hideInvalidUploadMsg}));}}]);return AddInvoiceForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AddInvoiceForm.propTypes={quotes:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({})),changeOrderTasks:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({})),onSubmit:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired};AddInvoiceForm.defaultProps={tasks:[]};/* harmony default export */ __webpack_exports__["a"] = (AddInvoiceForm);

/***/ }),
/* 2236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsContractorsLienReleases_css__ = __webpack_require__(2238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsContractorsLienReleases_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DetailsContractorsLienReleases_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_contractors_lien_releases_AddLienReleaseForm__ = __webpack_require__(2239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsContractorsLienReleases=function(_Component){_inherits(DetailsContractorsLienReleases,_Component);function DetailsContractorsLienReleases(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DetailsContractorsLienReleases);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DetailsContractorsLienReleases.__proto__||Object.getPrototypeOf(DetailsContractorsLienReleases)).call.apply(_ref,[this].concat(args))),_this),_this.handleDocumentDrop=function(file){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_details__["_21" /* uploadContractorLienReleaseRequest */])(_this.props.currentWorkOrder.id,file));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DetailsContractorsLienReleases,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-contractors-lien-releases'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_contractors_lien_releases_AddLienReleaseForm__["a" /* default */],{fileUrl:this.props.contractorLienRelease!==null?this.props.contractorLienRelease.document.document.url:null,onDocumentDrop:this.handleDocumentDrop}));}}]);return DetailsContractorsLienReleases;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{contractorLienRelease:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_details_details__["c" /* getContractorLienRelease */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state)};})(DetailsContractorsLienReleases));

/***/ }),
/* 2238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AddLienReleaseForm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddLienReleaseForm_css__ = __webpack_require__(2240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddLienReleaseForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AddLienReleaseForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_upload_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_upload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_document_DocumentLink__ = __webpack_require__(47);
function AddLienReleaseForm(props){var handleDocumentDrop=function handleDocumentDrop(files){if(props.onDocumentDrop){props.onDocumentDrop(files[0]);}};var fileComponent=null;if(props.fileUrl===null){fileComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx',className:'dropzone-container',multiple:false,onDrop:handleDocumentDrop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Please drag and drop any file into this area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3_images_upload_svg___default.a,alt:'upload'}));}else{fileComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'file-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_document_DocumentLink__["a" /* default */],{showIcon:false,showLink:true,url:props.fileUrl}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-lien-release-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Document'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,fileComponent)))));}AddLienReleaseForm.propTypes={fileUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onDocumentDrop:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};AddLienReleaseForm.defaultProps={fileUrl:null};

/***/ }),
/* 2240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsContractorsLienReleasesTable_css__ = __webpack_require__(2242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsContractorsLienReleasesTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DetailsContractorsLienReleasesTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsContractorsLienReleasesTable=function(_Component){_inherits(DetailsContractorsLienReleasesTable,_Component);function DetailsContractorsLienReleasesTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DetailsContractorsLienReleasesTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DetailsContractorsLienReleasesTable.__proto__||Object.getPrototypeOf(DetailsContractorsLienReleasesTable)).call.apply(_ref,[this].concat(args))),_this),_this.mapContractorLienReleases=function(contractorLienReleases){return contractorLienReleases.map(function(contractorLienRelease){return[contractorLienRelease.contractor_name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'file-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_document_DocumentLink__["a" /* default */],{showIcon:false,showLink:true,url:contractorLienRelease.document.document.url})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{key:1,className:'button-blue-grey delete',label:'Delete',onClick:function onClick(){return _this.handleDelete(contractorLienRelease.id);}})];});},_this.handleDelete=function(contractorLienReleaseId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["q" /* deleteContractorLienReleaseRequest */])(contractorLienReleaseId));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DetailsContractorsLienReleasesTable,[{key:'render',value:function render(){var headers=['CONTRACTOR','DOCUMENT'];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-contractor-lien-releases'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__["a" /* default */],{headers:headers,rows:this.mapContractorLienReleases(this.props.contractorLienReleases),emptyMessage:'No Final Unconditional Lien Releases'}));}}]);return DetailsContractorsLienReleasesTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{contractorLienReleases:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["d" /* getContractorLienReleases */])(state)};})(DetailsContractorsLienReleasesTable));

/***/ }),
/* 2242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReceiptsTable_css__ = __webpack_require__(2244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReceiptsTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ReceiptsTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_receipts_store_actions__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_receipts_AddMaterialsModal__ = __webpack_require__(2245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_work_orders_details_receipts_store_selectors__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_document_DocumentLink__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReceiptsTable=function(_Component){_inherits(ReceiptsTable,_Component);function ReceiptsTable(props){_classCallCheck(this,ReceiptsTable);var _this=_possibleConstructorReturn(this,(ReceiptsTable.__proto__||Object.getPrototypeOf(ReceiptsTable)).call(this,props));_this.handleDeleteConfirmation=function(response){if(response){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_receipts_store_actions__["b" /* deleteReceipt */])(_this.state.receiptIdToDelete));}_this.setState({receiptIdToDelete:null,showDeleteConfirmation:false});};_this.mapReceipts=function(receipts){return receipts.map(function(receipt){return[receipt.task_number,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:receipt.cost,format:'$0,0.[00]'}),receipt.description,receipt.image!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_image_upload_ImageUpload__["a" /* default */],{images:[{id:receipt.image.id,url:receipt.image.image.url,preview:receipt.image.image.preview.url}],readOnly:true}):'',receipt.document!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_document_DocumentLink__["a" /* default */],{url:receipt.document.document.url}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edit-delete-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button-blue-grey',label:'Edit',onClick:function onClick(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_receipts_store_actions__["e" /* setReceiptToEdit */])(receipt));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_receipts_store_actions__["f" /* setShowAddMaterialsModal */])(true));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button-blue-grey',label:'Delete',onClick:function onClick(){return _this.setState({receiptIdToDelete:receipt.id,showDeleteConfirmation:true});}}))];});};_this.state={receiptIdToDelete:null,showDeleteConfirmation:false};return _this;}_createClass(ReceiptsTable,[{key:'render',value:function render(){var _this2=this;var headers=['TASK #','AMOUNT','DESCRIPTION','PHOTO','DOCUMENT',''];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'receipts-table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__["a" /* default */],{className:'receipts-table',headers:headers,rows:this.mapReceipts(this.props.receipts),emptyMessage:'No Materials'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button-orange add-materials-button',label:'Add Materials',onClick:function onClick(){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_receipts_store_actions__["e" /* setReceiptToEdit */])(null));_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_receipts_store_actions__["f" /* setShowAddMaterialsModal */])(true));}}),this.props.showMaterialsModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_receipts_AddMaterialsModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showDeleteConfirmation,message:'Are you sure you want to delete the item?',onHide:this.handleDeleteConfirmation}));}}]);return ReceiptsTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{receipts:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_work_orders_details_receipts_store_selectors__["b" /* receiptsSelector */])(state),showMaterialsModal:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_work_orders_details_receipts_store_selectors__["c" /* showAddMaterialsModalSelector */])(state)};})(ReceiptsTable));

/***/ }),
/* 2244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_receipts_store_actions__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_receipts_store_selectors__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_receipts_AddMaterialsForm__ = __webpack_require__(2246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddMaterialsModal=function(_Component){_inherits(AddMaterialsModal,_Component);function AddMaterialsModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddMaterialsModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddMaterialsModal.__proto__||Object.getPrototypeOf(AddMaterialsModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_receipts_store_actions__["f" /* setShowAddMaterialsModal */])(false));},_this.handleOnSubmit=function(values){var receiptToEdit=_this.props.receiptToEdit;var edit=receiptToEdit!==null;if(edit){var imageIdToDelete=null;if(receiptToEdit.image!==null&&values.image===''){imageIdToDelete=receiptToEdit.image.id;}var documentIdToDelete=null;if(receiptToEdit.document!==null&&values.document===''){documentIdToDelete=receiptToEdit.document.id;}_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_receipts_store_actions__["c" /* editReceipt */])(receiptToEdit.id,values,imageIdToDelete,documentIdToDelete));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_receipts_store_actions__["a" /* createReceipt */])(values.taskId,values));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddMaterialsModal,[{key:'render',value:function render(){var _props=this.props,receiptToEdit=_props.receiptToEdit,tasks=_props.tasks;var initialValues=null;if(receiptToEdit!==null){initialValues={taskId:tasks.find(function(task){return task.number===receiptToEdit.task_number;}).id,cost:__WEBPACK_IMPORTED_MODULE_6_numeral___default()(receiptToEdit.cost).value().toString(),description:receiptToEdit.description};if(receiptToEdit.image!==null){initialValues.image=receiptToEdit.image.image;}if(receiptToEdit.document!==null){initialValues.document=receiptToEdit.document.document;}}var edit=receiptToEdit!==null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_modal_FormModal__["a" /* default */],{className:'add-materials-modal',show:this.props.show,title:edit?'Edit Materials':'Add Materials',onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_receipts_AddMaterialsForm__["a" /* default */],{initialValues:initialValues,tasks:this.props.tasks,onSubmit:this.handleOnSubmit})));}}]);return AddMaterialsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{receiptToEdit:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_receipts_store_selectors__["a" /* receiptToEditSelector */])(state),show:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_receipts_store_selectors__["c" /* showAddMaterialsModalSelector */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state)};})(AddMaterialsModal));

/***/ }),
/* 2246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddMaterialsForm_css__ = __webpack_require__(2247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddMaterialsForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AddMaterialsForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_form_FormInput__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_form_FormTextArea__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_form_FormDropDown__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_form_FormDocument__ = __webpack_require__(2248);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddMaterialsForm=function(_Component){_inherits(AddMaterialsForm,_Component);function AddMaterialsForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddMaterialsForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddMaterialsForm.__proto__||Object.getPrototypeOf(AddMaterialsForm)).call.apply(_ref,[this].concat(args))),_this),_this.renderImage=function(props){var images=[];if(props.input.value){if(_typeof(props.input.value)==='object'){if(props.input.value.hasOwnProperty('url')){images.push({url:props.input.value.url,preview:props.input.value.preview.url});}else{images.push({url:URL.createObjectURL(props.input.value)});}}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],images:images,readOnly:false,onRemove:function onRemove(){return props.input.onChange('');},onUpload:function onUpload(files){return props.input.onChange(files[0]);}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddMaterialsForm,[{key:'render',value:function render(){var edit=this.props.initialValues!==null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-materials-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.props.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Task'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_7_components_shared_form_FormDropDown__["a" /* default */],disabled:edit,name:'taskId',options:this.props.tasks.map(function(task){return{value:task.id,label:task.number+' - '+task.name};}),placeholder:'Task'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'files-comment'},'Please upload at least one image and/or one document.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Photo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderImage,name:'image',placeholder:'Photo'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Document'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_8_components_shared_form_FormDocument__["a" /* default */],name:'document',placeholder:'Document'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_shared_form_FormInput__["a" /* default */],name:'cost',placeholder:'Amount',type:'number'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_shared_form_FormTextArea__["a" /* default */],name:'description',placeholder:'Description'}))),this.props.invalid&&this.props.submitFailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'The outlined inputs should be added in order to add materials.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'submit',value:edit?'Update':'Create'})))));}}]);return AddMaterialsForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(values){var errors={};if(!values.taskId){errors.taskId='Required';}if(!values.cost){errors.cost='Required';}if(!values.description){errors.description='Required';}if(!values.image&&!values.document){errors.image='Required';errors.document='Required';}return errors;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["f" /* reduxForm */])({form:'AddMaterialsForm',validate:validate})(AddMaterialsForm));

/***/ }),
/* 2247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FormDocument;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormDocument_css__ = __webpack_require__(2249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormDocument_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FormDocument_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_upload_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_upload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_remove_svg__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_remove_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_remove_svg__);
/**
 * Wrapper for Document piciker field used inside redux-form.
 * @param props
 * @return {*}
 * @constructor
 */function FormDocument(props){if(props.input.value===''){var isValid=!props.meta.error||!props.meta.submitFailed;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-document'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx',className:'dropzone-container'+(!isValid?' with-error':''),multiple:false,onDrop:function onDrop(files){return props.input.onChange(files[0]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Please drag and drop any file into this area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3_images_upload_svg___default.a,alt:'upload'})));}var documentLinkProps={};if(props.input.value.hasOwnProperty('url')){documentLinkProps.url=props.input.value.url;}else{documentLinkProps.file=props.input.value;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-document'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'file-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_document_DocumentLink__["a" /* default */],Object.assign({showIcon:false},documentLinkProps)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5_images_remove_svg___default.a,alt:'remove',onClick:function onClick(){return props.input.onChange('');}})));}

/***/ }),
/* 2249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TimeTable_css__ = __webpack_require__(2251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TimeTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TimeTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_time_store_selectors__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_time_store_actions__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_work_orders_details_time_AddTimeModal__ = __webpack_require__(2252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_shared_text_Time__ = __webpack_require__(952);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TimeTable=function(_Component){_inherits(TimeTable,_Component);function TimeTable(props){_classCallCheck(this,TimeTable);var _this=_possibleConstructorReturn(this,(TimeTable.__proto__||Object.getPrototypeOf(TimeTable)).call(this,props));_this.handleDeleteConfirmation=function(result){if(result){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_time_store_actions__["c" /* deleteTime */])(_this.state.timeToDelete));}_this.setState({showDeleteConfirmation:false,timeToDelete:null});};_this.mapTime=function(timeEntries,ratesAvailable){var _this$props=_this.props,dispatch=_this$props.dispatch,rate=_this$props.rate,timeIdRateToEdit=_this$props.timeIdRateToEdit;return timeEntries.map(function(time){var row=[time.task_number,time.name_title,time.start_date?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_text_Date__["a" /* default */],{value:time.start_date,format:'ll'}):'N/A',time.time_in?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_text_Time__["a" /* default */],{value:time.time_in}):'N/A',time.time_out?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_text_Time__["a" /* default */],{value:time.time_out}):'N/A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Number__["a" /* default */],{value:time.hours_worked||0,format:'0.[00]'}),' hours')];if(ratesAvailable){if(timeIdRateToEdit!==null&&timeIdRateToEdit===time.id){row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_input_Input__["a" /* default */],{className:'rate-input',type:'number',value:rate,onChange:function onChange(value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_time_store_actions__["h" /* setRate */])(value));}}));row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-orange time-button',label:'Confirm',onClick:function onClick(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_time_store_actions__["b" /* confirmRate */])(time.task_id,time.id,rate));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-white time-button',label:'Cancel',onClick:function onClick(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_time_store_actions__["f" /* setCurrentTimeRateToEdit */])(null));}})));}else{row.push(time.rate!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Number__["a" /* default */],{format:'$0',value:time.rate}):'N/A');row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-orange time-button',label:'Edit rate',onClick:function onClick(){return _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_time_store_actions__["f" /* setCurrentTimeRateToEdit */])(time.id,time.rate));}}));}row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Number__["a" /* default */],{value:time.cost!==null?time.cost:0,format:'$0,0.[00]'}));row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edit-delete-buttons-container',style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-blue-grey',label:'Edit',onClick:function onClick(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_time_store_actions__["g" /* setCurrentTimeToEdit */])(time));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_time_store_actions__["i" /* setShowAddTimeModal */])(true));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-blue-grey',label:'Delete',onClick:function onClick(){return _this.setState({showDeleteConfirmation:true,timeToDelete:time.id});}})));}else{row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edit-delete-buttons-container',style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-blue-grey',label:'Delete',onClick:function onClick(){return _this.setState({showDeleteConfirmation:true,timeToDelete:time.id});}})));}return row;});};_this.state={showDeleteConfirmation:false,timeToDelete:null};return _this;}_createClass(TimeTable,[{key:'render',value:function render(){var _this2=this;var currentUser=this.props.currentUser;var ratesAvailable=__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["g" /* usersUtil */].hasRole(currentUser,__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["e" /* ROLES */].OWNER)||__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["g" /* usersUtil */].hasRole(currentUser,__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["e" /* ROLES */].CONTRACTOR_PROJECT_MANAGER)||__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);var headers=['TASK #','NAME/TITLE','START DATE','TIME IN','TIME OUT','HOURS'];if(ratesAvailable){headers=headers.concat(['RATE','','TOTAL']);}// Buttons column
headers.push('');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__["a" /* default */],{className:'time-table'+(ratesAvailable?' editable':''),headers:headers,rows:this.mapTime(this.props.time,ratesAvailable),emptyMessage:'No Time Entries'}),ratesAvailable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-orange add-time-button',label:'Add Time',onClick:function onClick(){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_time_store_actions__["g" /* setCurrentTimeToEdit */])(null));_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_time_store_actions__["i" /* setShowAddTimeModal */])(true));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_admin_work_orders_details_time_AddTimeModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showDeleteConfirmation,message:'Are you sure you want to delete this item?',onHide:this.handleDeleteConfirmation}));}}]);return TimeTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_authentication__["d" /* getCurrentUser */])(state),rate:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_time_store_selectors__["a" /* rateSelector */])(state),time:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_time_store_selectors__["d" /* timeSelector */])(state),timeIdRateToEdit:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_time_store_selectors__["c" /* timeIdRateToEditSelector */])(state)};})(TimeTable));

/***/ }),
/* 2251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_time_AddTimeForm__ = __webpack_require__(2253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_time_store_selectors__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_time_store_actions__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddTimeModal=function(_Component){_inherits(AddTimeModal,_Component);function AddTimeModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddTimeModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddTimeModal.__proto__||Object.getPrototypeOf(AddTimeModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_time_store_actions__["i" /* setShowAddTimeModal */])(false));},_this.handleOnSubmit=function(values){var edit=_this.props.timeToEdit!==null;if(edit){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_time_store_actions__["d" /* editTimeEntry */])(_this.props.timeToEdit.id,values));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_time_store_actions__["a" /* addTimeEntry */])(values.taskId,values));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddTimeModal,[{key:'render',value:function render(){var _props=this.props,showAddModal=_props.showAddModal,tasks=_props.tasks,timeToEdit=_props.timeToEdit;var initialValues=null;if(timeToEdit!==null){initialValues={taskId:timeToEdit.task_id,name:timeToEdit.name_title,startDate:timeToEdit.start_date,timeIn:timeToEdit.time_in,timeOut:timeToEdit.time_out};}var edit=timeToEdit!==null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{className:'add-time-modal',show:showAddModal,title:edit?'Edit Time':'Add Time',onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_time_AddTimeForm__["a" /* default */],{initialValues:initialValues,tasks:tasks,onSubmit:this.handleOnSubmit})));}}]);return AddTimeModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{showAddModal:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_time_store_selectors__["b" /* showAddModalSelector */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state),timeToEdit:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_time_store_selectors__["e" /* timeToEditSelector */])(state)};})(AddTimeModal));

/***/ }),
/* 2253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddTimeForm_css__ = __webpack_require__(2254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddTimeForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AddTimeForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_form_FormInput__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_form_FormDropDown__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_form_FormDateTimePicker__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_form_FormTimePicker__ = __webpack_require__(951);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddTimeForm=function(_Component){_inherits(AddTimeForm,_Component);function AddTimeForm(){_classCallCheck(this,AddTimeForm);return _possibleConstructorReturn(this,(AddTimeForm.__proto__||Object.getPrototypeOf(AddTimeForm)).apply(this,arguments));}_createClass(AddTimeForm,[{key:'render',value:function render(){var edit=this.props.initialValues!==null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-time-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.props.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Task'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_shared_form_FormDropDown__["a" /* default */],disabled:edit,name:'taskId',options:this.props.tasks.map(function(task){return{value:task.id,label:task.number+' - '+task.name};}),placeholder:'Task'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Name/Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_4_components_shared_form_FormInput__["a" /* default */],name:'name',placeholder:'Name/Title'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Start Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_shared_form_FormDateTimePicker__["a" /* default */],name:'startDate',placeholder:'Start Date'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Time In'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_7_components_shared_form_FormTimePicker__["a" /* default */],name:'timeIn',placeholder:'Time In'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Time Out'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_7_components_shared_form_FormTimePicker__["a" /* default */],name:'timeOut',placeholder:'Time Out'}))),this.props.invalid&&this.props.submitFailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'The outlined inputs should be added in order to add a time.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'submit',value:edit?'Update':'Create'})))));}}]);return AddTimeForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(values){var errors={};if(!values.taskId){errors.taskId='Required';}if(!values.name){errors.name='Required';}if(!values.startDate){errors.startDate='Required';}if(!values.timeIn){errors.timeIn='Required';}if(!values.timeOut){errors.timeOut='Required';}return errors;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["f" /* reduxForm */])({form:'AddTimeForm',validate:validate})(AddTimeForm));

/***/ }),
/* 2254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsSchedule_css__ = __webpack_require__(2257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsSchedule_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DetailsSchedule_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_open_items_EditOpenItemModal__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Gantt__ = __webpack_require__(2258);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsSchedule=function(_Component){_inherits(DetailsSchedule,_Component);function DetailsSchedule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DetailsSchedule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DetailsSchedule.__proto__||Object.getPrototypeOf(DetailsSchedule)).call.apply(_ref,[this].concat(args))),_this),_this.handleScheduleUpdateWorkOrder=function(workOrderId,start,end){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_details__["_18" /* updateWorkOrderSchedule */])(workOrderId,start,end));},_this.handleScheduleUpdateTask=function(taskId,start,end){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_details__["_10" /* taskScheduleUpdate */])(taskId,start,end));},_this.mapOpenItems=function(){var openItems=Object.values(_this.props.openItems).reduce(function(accumulator,currentValue){return accumulator.concat(currentValue);},[]);return openItems;},_this.handleOpenItemSelection=function(openItemId){var openItem=_this.mapOpenItems().find(function(openItem){return openItem.id===openItemId;});_this.taskId=openItem.task.id;_this.taskNumber=openItem.task.number;_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_details__["_3" /* setSelectedOpenItem */])(openItem));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DetailsSchedule,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-schedule'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Gantt__["a" /* default */],{workOrder:this.props.workOrder,tasks:this.props.tasks,quotes:this.props.quotes,openItems:this.mapOpenItems(),onWorkOrderUpdate:this.handleScheduleUpdateWorkOrder,onTaskUpdate:this.handleScheduleUpdateTask,onOpenItemClick:this.handleOpenItemSelection}),this.props.selectedOpenItemId!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_open_items_EditOpenItemModal__["a" /* default */],{taskId:this.taskId,taskNumber:this.taskNumber}));}}]);return DetailsSchedule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{workOrder:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state),quotes:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_details_details__["m" /* getQuotes */])(state),openItems:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_details_details__["i" /* getOpenItemsByTaskId */])(state),selectedOpenItemId:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_details_details__["q" /* getSelectedOpenItemId */])(state)};})(DetailsSchedule));

/***/ }),
/* 2257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Gantt_css__ = __webpack_require__(2259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Gantt_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Gantt_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_gantt_timeline__ = __webpack_require__(2260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_gantt_timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_gantt_timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var config={header:{top:{style:{backgroundColor:'#3c4249'}},middle:{style:{backgroundColor:'#ef4834'}},bottom:{style:{background:'#8e9aae'}}},dataViewPort:{task:{showLabel:true,style:{borderRadius:4,cursor:'pointer'}}}};var itemheight=40;var colors={pre:'#da2b48',wip:'#c63992',cmp:'#1279be'};var Gantt=function(_Component){_inherits(Gantt,_Component);function Gantt(props){_classCallCheck(this,Gantt);var _this=_possibleConstructorReturn(this,(Gantt.__proto__||Object.getPrototypeOf(Gantt)).call(this,props));_initialiseProps.call(_this);_this.state=_this.parseTasks(_this.props);return _this;}_createClass(Gantt,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps!==this.props){this.updateOpenItems(this.props);}}},{key:'render',value:function render(){var buttonLabel=this.state.editing?'Save':'Edit';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gantt'},this.state.editing&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-gray button-cancel',label:'Cancel',onClick:this.handleCancelClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-orange button-edit',label:buttonLabel,onClick:this.handleEditClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_gantt_timeline___default.a,{data:this.state.data,onUpdateTask:this.onUpdateTask,onSelectItem:this.onSelectItem,config:config,itemheight:itemheight}));}}]);return Gantt;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.handleEditClick=function(){if(_this2.state.editing){_this2.saveSchedule();}_this2.setState({editing:!_this2.state.editing});};this.saveSchedule=function(){var onWorkOrderUpdate=_this2.props.onWorkOrderUpdate;var onTaskUpdate=_this2.props.onTaskUpdate;_this2.state.data.forEach(function(item){if(item.type==='WORKORDER'&&onWorkOrderUpdate){onWorkOrderUpdate(item.id,item.start,item.end);}else if(item.type==='TASK'&&onTaskUpdate){onTaskUpdate(item.id,item.start,item.end);}});};this.handleCancelClick=function(){_this2.setState(_this2.parseTasks(_this2.props));_this2.setState({editing:!_this2.state.editing});};this.parseTasks=function(props){var woStart=__WEBPACK_IMPORTED_MODULE_4_moment___default()(props.workOrder.schedule_start_date||props.workOrder.approved_proposal.start_date);var woEnd=props.workOrder.schedule_end_date?__WEBPACK_IMPORTED_MODULE_4_moment___default()(props.workOrder.schedule_end_date):__WEBPACK_IMPORTED_MODULE_4_moment___default()(props.workOrder.approved_proposal.completion_date).add(1,'day');var tasks=[].concat({id:props.workOrder.id,start:woStart,end:woEnd,name:'Client Start and Completion Dates',color:'#ef4834',type:'WORKORDER'});props.quotes.filter(function(quote){return quote.status==='approved'&&quote.task.status!=='cls';}).sort(function(quote1,quote2){return __WEBPACK_IMPORTED_MODULE_4_moment___default()(quote1.task.schedule_start_date||quote1.start_date)-__WEBPACK_IMPORTED_MODULE_4_moment___default()(quote2.task.schedule_start_date||quote2.start_date);}).forEach(function(quote){var task=props.tasks.find(function(t){return t.id===quote.task.id;});var start=__WEBPACK_IMPORTED_MODULE_4_moment___default()(task.schedule_start_date||quote.start_date);var end=task.schedule_end_date?__WEBPACK_IMPORTED_MODULE_4_moment___default()(task.schedule_end_date):__WEBPACK_IMPORTED_MODULE_4_moment___default()(quote.end_date).add(1,'day');var color=colors[task.status];var taskSchedule={id:task.id,start:start,end:end,name:'Task '+task.number+' ('+task.status.toUpperCase()+') - '+task.name,color:color,type:'TASK',mltId:'MLT-'+task.id};var materialLeadTime=[];if(quote.material_lead_days){materialLeadTime={id:'MLT-'+task.id,start:start,end:__WEBPACK_IMPORTED_MODULE_4_moment___default()(start).add(quote.material_lead_days,'days'),name:'Task '+task.number+' - Material Lead Time',color:color,leadDays:quote.material_lead_days};}var openItems=props.openItems.filter(function(oi){return oi.task.id===task.id&&!oi.resolved;}).map(function(oi){return{id:oi.id,start:__WEBPACK_IMPORTED_MODULE_4_moment___default()(oi.created_at),end:__WEBPACK_IMPORTED_MODULE_4_moment___default()(oi.due_date).add(1,'day'),name:'Open Item '+oi.task.number+'-'+oi.letter+' - '+oi.description,color:'#fab73d',type:'OPENITEM'};});tasks=tasks.concat(taskSchedule,materialLeadTime,openItems);});return{data:tasks};};this.onUpdateTask=function(item,props){if(!_this2.state.editing){return;}if(item.type!=='WORKORDER'&&item.type!=='TASK'){return;}props.start=__WEBPACK_IMPORTED_MODULE_4_moment___default()(props.start).format('YYYY-MM-DD');props.end=__WEBPACK_IMPORTED_MODULE_4_moment___default()(props.end).format('YYYY-MM-DD');var sameStart=__WEBPACK_IMPORTED_MODULE_4_moment___default()(item.start).format('YYYY-MM-DD')===props.start;if(!sameStart){if(item.type==='TASK'){_this2.state.data.filter(function(i){return i.id===item.mltId;}).forEach(function(i){i.start=props.start;i.end=__WEBPACK_IMPORTED_MODULE_4_moment___default()(props.start).add(i.leadDays,'days');});}else if(item.type==='WORKORDER'){var diffDays=__WEBPACK_IMPORTED_MODULE_4_moment___default()(props.start).diff(__WEBPACK_IMPORTED_MODULE_4_moment___default()(item.start),'days');var onUpdate=_this2.onUpdateTask;_this2.state.data.filter(function(i){return i.type==='TASK';}).forEach(function(i){var start=__WEBPACK_IMPORTED_MODULE_4_moment___default()(i.start).add(diffDays,'days');var end=__WEBPACK_IMPORTED_MODULE_4_moment___default()(i.end).add(diffDays,'days');onUpdate(i,{start:start,end:end});});}}item.start=__WEBPACK_IMPORTED_MODULE_4_moment___default()(props.start);item.end=__WEBPACK_IMPORTED_MODULE_4_moment___default()(props.end);_this2.setState({data:[].concat(_toConsumableArray(_this2.state.data))});};this.onSelectItem=function(item){if(item.type==='OPENITEM'&&_this2.props.onOpenItemClick){_this2.props.onOpenItemClick(item.id);}};this.updateOpenItems=function(props){_this2.state.data.filter(function(i){return i.type==='OPENITEM';}).forEach(function(item){var oi=props.openItems.find(function(oi){return oi.id===item.id;});item.end=__WEBPACK_IMPORTED_MODULE_4_moment___default()(oi.due_date).add(1,'day');});};};/* harmony default export */ __webpack_exports__["a"] = (Gantt);Gantt.propTypes={workOrder:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,tasks:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,quotes:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,openItems:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,onWorkOrderUpdate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onTaskUpdate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onOpenItemClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};

/***/ }),
/* 2259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e(__webpack_require__(0),__webpack_require__(24),__webpack_require__(2261)):"function"==typeof define&&define.amd?define("react-gantt-timeline",["React","moment","ReactDOM"],e):"object"==typeof exports?exports["react-gantt-timeline"]=e(require("react"),require("moment"),require("react-sizeme")):t["react-gantt-timeline"]=e(t.React,t.moment,t.ReactDOM)}(window,function(t,e,n){return function(t){var e={};function n(o){if(e[o])return e[o].exports;var r=e[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=t,n.c=e,n.d=function(t,e,o){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:o})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)n.d(o,r,function(e){return t[e]}.bind(null,r));return o},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=13)}([function(e,n){e.exports=t},function(t,n){t.exports=e},function(t,e,n){t.exports=n(6)()},function(t,e,n){"use strict";t.exports=function(t){var e=[];return e.toString=function(){return this.map(function(e){var n=function(t,e){var n=t[1]||"",o=t[3];if(!o)return n;if(e&&"function"==typeof btoa){var r=(a=o,s=btoa(unescape(encodeURIComponent(JSON.stringify(a)))),c="sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(s),"/*# ".concat(c," */")),i=o.sources.map(function(t){return"/*# sourceURL=".concat(o.sourceRoot||"").concat(t," */")});return[n].concat(i).concat([r]).join("\n")}var a,s,c;return[n].join("\n")}(e,t);return e[2]?"@media ".concat(e[2]," {").concat(n,"}"):n}).join("")},e.i=function(t,n,o){"string"==typeof t&&(t=[[null,t,""]]);var r={};if(o)for(var i=0;i<this.length;i++){var a=this[i][0];null!=a&&(r[a]=!0)}for(var s=0;s<t.length;s++){var c=[].concat(t[s]);o&&r[c[0]]||(n&&(c[2]?c[2]="".concat(n," and ").concat(c[2]):c[2]=n),e.push(c))}},e}},function(t,e,n){var o,r,i={},a=(o=function(){return window&&document&&document.all&&!window.atob},function(){return void 0===r&&(r=o.apply(this,arguments)),r}),s=function(t){var e={};return function(t){if("function"==typeof t)return t();if(void 0===e[t]){var n=function(t){return document.querySelector(t)}.call(this,t);if(window.HTMLIFrameElement&&n instanceof window.HTMLIFrameElement)try{n=n.contentDocument.head}catch(t){n=null}e[t]=n}return e[t]}}(),c=null,l=0,u=[],p=n(10);function d(t,e){for(var n=0;n<t.length;n++){var o=t[n],r=i[o.id];if(r){r.refs++;for(var a=0;a<r.parts.length;a++)r.parts[a](o.parts[a]);for(;a<o.parts.length;a++)r.parts.push(g(o.parts[a],e))}else{var s=[];for(a=0;a<o.parts.length;a++)s.push(g(o.parts[a],e));i[o.id]={id:o.id,refs:1,parts:s}}}}function f(t,e){for(var n=[],o={},r=0;r<t.length;r++){var i=t[r],a=e.base?i[0]+e.base:i[0],s={css:i[1],media:i[2],sourceMap:i[3]};o[a]?o[a].parts.push(s):n.push(o[a]={id:a,parts:[s]})}return n}function h(t,e){var n=s(t.insertInto);if(!n)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var o=u[u.length-1];if("top"===t.insertAt)o?o.nextSibling?n.insertBefore(e,o.nextSibling):n.appendChild(e):n.insertBefore(e,n.firstChild),u.push(e);else if("bottom"===t.insertAt)n.appendChild(e);else{if("object"!=typeof t.insertAt||!t.insertAt.before)throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");var r=s(t.insertInto+" "+t.insertAt.before);n.insertBefore(e,r)}}function y(t){if(null===t.parentNode)return!1;t.parentNode.removeChild(t);var e=u.indexOf(t);e>=0&&u.splice(e,1)}function m(t){var e=document.createElement("style");return void 0===t.attrs.type&&(t.attrs.type="text/css"),b(e,t.attrs),h(t,e),e}function b(t,e){Object.keys(e).forEach(function(n){t.setAttribute(n,e[n])})}function g(t,e){var n,o,r,i;if(e.transform&&t.css){if(!(i=e.transform(t.css)))return function(){};t.css=i}if(e.singleton){var a=l++;n=c||(c=m(e)),o=k.bind(null,n,a,!1),r=k.bind(null,n,a,!0)}else t.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=function(t){var e=document.createElement("link");return void 0===t.attrs.type&&(t.attrs.type="text/css"),t.attrs.rel="stylesheet",b(e,t.attrs),h(t,e),e}(e),o=function(t,e,n){var o=n.css,r=n.sourceMap,i=void 0===e.convertToAbsoluteUrls&&r;(e.convertToAbsoluteUrls||i)&&(o=p(o));r&&(o+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");var a=new Blob([o],{type:"text/css"}),s=t.href;t.href=URL.createObjectURL(a),s&&URL.revokeObjectURL(s)}.bind(null,n,e),r=function(){y(n),n.href&&URL.revokeObjectURL(n.href)}):(n=m(e),o=function(t,e){var n=e.css,o=e.media;o&&t.setAttribute("media",o);if(t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}.bind(null,n),r=function(){y(n)});return o(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;o(t=e)}else r()}}t.exports=function(t,e){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");(e=e||{}).attrs="object"==typeof e.attrs?e.attrs:{},e.singleton||"boolean"==typeof e.singleton||(e.singleton=a()),e.insertInto||(e.insertInto="head"),e.insertAt||(e.insertAt="bottom");var n=f(t,e);return d(n,e),function(t){for(var o=[],r=0;r<n.length;r++){var a=n[r];(s=i[a.id]).refs--,o.push(s)}t&&d(f(t,e),e);for(r=0;r<o.length;r++){var s;if(0===(s=o[r]).refs){for(var c=0;c<s.parts.length;c++)s.parts[c]();delete i[s.id]}}}};var v,w=(v=[],function(t,e){return v[t]=e,v.filter(Boolean).join("\n")});function k(t,e,n,o){var r=n?"":o.css;if(t.styleSheet)t.styleSheet.cssText=w(e,r);else{var i=document.createTextNode(r),a=t.childNodes;a[e]&&t.removeChild(a[e]),a.length?t.insertBefore(i,a[e]):t.appendChild(i)}}},function(t,e){t.exports=n},function(t,e,n){"use strict";var o=n(7);function r(){}function i(){}i.resetWarningCache=r,t.exports=function(){function t(t,e,n,r,i,a){if(a!==o){var s=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw s.name="Invariant Violation",s}}function e(){return t}t.isRequired=t;var n={array:t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:e,element:t,elementType:t,instanceOf:e,node:t,objectOf:e,oneOf:e,oneOfType:e,shape:e,exact:e,checkPropTypes:i,resetWarningCache:r};return n.PropTypes=n,n}},function(t,e,n){"use strict";t.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(t,e,n){var o=n(9);"string"==typeof o&&(o=[[t.i,o,""]]);var r={hmr:!0,transform:void 0,insertInto:void 0};n(4)(o,r);o.locals&&(t.exports=o.locals)},function(t,e,n){(e=n(3)(!1)).push([t.i,".header-top {\n  height: 20px;\n\n  border-bottom: solid 0.5px silver;\n}\n\n.header-middle {\n  height: 20px;\n  background-color: chocolate;\n  color: white;\n  font-size: 10px;\n  border-bottom: solid 0.5px silver;\n}\n.header-bottom {\n  height: 20px;\n  font-size: 10px;\n  border-bottom: solid 0.5px silver;\n}\n",""]),t.exports=e},function(t,e){t.exports=function(t){var e="undefined"!=typeof window&&window.location;if(!e)throw new Error("fixUrls requires window.location");if(!t||"string"!=typeof t)return t;var n=e.protocol+"//"+e.host,o=n+e.pathname.replace(/\/[^\/]*$/,"/");return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(t,e){var r,i=e.trim().replace(/^"(.*)"$/,function(t,e){return e}).replace(/^'(.*)'$/,function(t,e){return e});return/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(i)?t:(r=0===i.indexOf("//")?i:0===i.indexOf("/")?n+i:o+i.replace(/^\.\//,""),"url("+JSON.stringify(r)+")")})}},function(t,e,n){var o=n(12);"string"==typeof o&&(o=[[t.i,o,""]]);var r={hmr:!0,transform:void 0,insertInto:void 0};n(4)(o,r);o.locals&&(t.exports=o.locals)},function(t,e,n){(e=n(3)(!1)).push([t.i,".timeLine {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: 100%;\n  border: solid 1px rgb(207, 207, 205);\n  font-size: 12px;\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n}\n\n/* Main Area */\n\n.timeLine-main {\n  flex: 1 1 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow-y: hidden;\n}\n/* Main Area Header*/\n\n.timeLine-main-header-viewPort {\n  flex: 0 0 60px;\n  position: relative;\n  height: 60px;\n  width: 100%;\n  background-color: rgb(112, 112, 112);\n  overflow: hidden;\n}\n\n.timeLine-main-header-container {\n  flex: 0 0 60px;\n  position: relative;\n  top: 0;\n  left: 0;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: #333333;\n  overflow: hidden;\n  user-select: none;\n}\n\n.timeLine-main-header-day-item {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background-color: rgb(112, 112, 112);\n  font-size: 10px;\n  text-align: center;\n  border-right: solid 1px;\n  border-top: solid 1px;\n  border-bottom: solid 1px;\n  top: 20px;\n  height: 40px;\n  color: white;\n  text-align: center;\n}\n\n.timeLine-main-header-top-item {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-right: solid 1px white;\n  height: 20px;\n  z-index: 91;\n}\n\n.timeLine-main-header-day-week {\n  flex: 0 0 12px;\n  padding: 4px;\n  z-index: 90;\n}\n\n.timeLine-main-header-day-month {\n  top: 0px;\n  position: sticky;\n  flex: 0 0 15px;\n  padding: 5px;\n  z-index: 90;\n}\n\n.timeLine-main-header-time {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  height: 22px;\n  justify-content: stretch;\n}\n\n.timeLine-main-header-time-item {\n  border-left: solid 1px silver;\n  border-bottom: solid 1px silver;\n  border-top: solid 1px silver;\n  text-align: center;\n  padding-top: 5px;\n}\n/* Main Area Data*/\n\n.timeLine-main-data-viewPort {\n  flex: 1 1 auto;\n  position: relative;\n  overflow: hidden;\n  background-color: #fbf9f9;\n}\n.timeLine-main-data-container {\n  position: relative;\n  top: 0;\n  left: 0;\n  height: 100%;\n  background-color: rgb(255, 255, 255);\n}\n\n.timeLine-main-data-row {\n  position: absolute;\n  width: 100%;\n  height: 50px;\n}\n\n.timeLine-main-data-task {\n  position: absolute;\n  background-color: darkorchid;\n  border-radius: 14px;\n  color: white;\n  text-align: center;\n}\n\n.timeLine-main-data-task-side {\n  position: absolute;\n  width: 10px;\n  cursor: col-resize;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.timeLine-main-data-task-side-linker {\n  width: 8px;\n  height: 8px;\n  border-radius: 4px;\n  cursor: default;\n  z-index: 100;\n}\n.timeLine-main-data-task-side-linker:hover {\n  background-color: black;\n  border: solid 0.5px grey;\n}\n/* .timeLine-main-data-task:hover {\n    background-color:chocolate;\n    border:solid 2px darkorchid;\n    cursor: move;\n} */\n\n.timeLine-main-data-verticalLine {\n  flex: 1 1 auto;\n  height: 100%;\n  width: 24px;\n  background-color: white;\n  border-left-width: 0.5px;\n  border-left-color: rgb(207, 207, 205);\n  border-left-style: dashed;\n}\n\n/* Side Area */\n\n.timeLine-side-main {\n  flex: 0 0 auto;\n  width: 108px;\n  min-width: 108px;\n  display: flex;\n  flex-direction: row;\n}\n\n.timeLine-side {\n  flex: 1 0 100px;\n  display: flex;\n  flex-direction: column;\n  border-right: solid 1px rgb(207, 207, 205);\n}\n\n.verticalResizer {\n  flex: 0 0 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: col-resize;\n  border-right: solid 1px rgb(207, 207, 205);\n  height: 100%;\n}\n.squareGrip {\n  flex: 0 0 auto;\n\n  border-radius: 50%;\n  height: 5px;\n  width: 5px;\n  margin: 3px 0;\n}\n\n.timeLine-side-title {\n  flex: 0 0 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.timeLine-side-task-viewPort {\n  position: relative;\n  flex: 1 1 auto;\n  height: 100%;\n  background-color: #fbf9f9;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.timeLine-side-task-container {\n  position: relative;\n  overflow-x: hidden;\n  overflow-y: hidden;\n}\n\n.timeLine-side-task-row {\n  position: absolute;\n  width: 100%;\n  background-color: rgb(112, 112, 112);\n  border-bottom-width: 0.5px;\n  border-bottom-color: rgb(207, 207, 205);\n  border-bottom-style: solid;\n  height: 30px;\n  color: grey;\n  text-align: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  outline: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n",""]),t.exports=e},function(t,e,n){"use strict";n.r(e);var o=n(0),r=n.n(o),i=n(2),a=n.n(i);function s(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}var c={header:{top:{style:{backgroundColor:"#333333",fontSize:10,color:"white",textAlign:"center"}},middle:{style:{backgroundColor:"chocolate"},selectedStyle:{backgroundColor:"#b13525",fontWeight:"bold"}},bottom:{style:{background:"grey",color:"white",fontSize:9},selectedStyle:{backgroundColor:"#b13525",fontWeight:"bold"}}},taskList:{title:{label:"Projects",style:{backgroundColor:"#333333",borderBottom:"solid 1px silver",color:"white",textAlign:"center"}},task:{style:{backgroundColor:"#fbf9f9"}},verticalSeparator:{style:{backgroundColor:"#333333"},grip:{style:{backgroundColor:"#cfcfcd"}}}},dataViewPort:{rows:{style:{backgroundColor:"#fbf9f9",borderBottom:"solid 0.5px #cfcfcd"}},task:{showLabel:!1,style:{position:"absolute",borderRadius:14,color:"white",textAlign:"center",backgroundColor:"grey"},selectedStyle:{position:"absolute",borderRadius:14,border:"solid 1px #ff00fa",color:"white",textAlign:"center",backgroundColor:"grey"}}},links:{color:"black",selectedColor:"#ff00fa"}},l=new(function(){function t(){var e,n,o,r=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),o=function(t){r.data={},t?r.populate(t,c,r.data):r.data=c},(n="load")in(e=this)?Object.defineProperty(e,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[n]=o,this.data=c}var e,n,o;return e=t,(n=[{key:"populate",value:function(t,e,n){if(this.isObject(e))for(var o in e)t[o]?(n[o]=t[o],this.populate(t[o],e[o],n[o])):n[o]=e[o]}},{key:"isObject",value:function(t){return"string"!=typeof t&&"boolean"!=typeof t&&"number"!=typeof t}},{key:"values",get:function(){return this.data}}])&&s(e.prototype,n),o&&s(e,o),t}());function u(t){"@babel/helpers - typeof";return(u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function p(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function d(t){return(d=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function f(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function h(t,e){return(h=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var y=function(t){function e(t){var n,o,r;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),o=this,(n=!(r=d(e).call(this,t))||"object"!==u(r)&&"function"!=typeof r?f(o):r).doMouseMove=n.doMouseMove.bind(f(n)),n.doMouseDown=n.doMouseDown.bind(f(n)),n.doMouseUp=n.doMouseUp.bind(f(n)),n.state={dragging:!1},n}var n,i,a;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&h(t,e)}(e,o["Component"]),n=e,(i=[{key:"doMouseDown",value:function(t){0===t.button&&(this.draggingPosition=t.clientX,this.setState({dragging:!0}))}},{key:"componentDidUpdate",value:function(t,e){this.state.dragging&&!e.dragging?(document.addEventListener("mousemove",this.doMouseMove),document.addEventListener("mouseup",this.doMouseUp)):!this.state.dragging&&e.dragging&&(document.removeEventListener("mousemove",this.doMouseMove),document.removeEventListener("mouseup",this.doMouseUp))}},{key:"doMouseMove",value:function(t){if(this.state.dragging){t.stopPropagation();var e=this.draggingPosition-t.clientX;this.draggingPosition=t.clientX,this.props.onTaskListSizing(e)}}},{key:"doMouseUp",value:function(t){this.setState({dragging:!1})}},{key:"render",value:function(){return r.a.createElement("div",{className:"verticalResizer",style:l.values.taskList.verticalSeparator.style,onMouseDown:this.doMouseDown},r.a.createElement("div",{className:"squareGrip",style:l.values.taskList.verticalSeparator.grip.style}),r.a.createElement("div",{className:"squareGrip",style:l.values.taskList.verticalSeparator.grip.style}),r.a.createElement("div",{className:"squareGrip",style:l.values.taskList.verticalSeparator.grip.style}),r.a.createElement("div",{className:"squareGrip",style:l.values.taskList.verticalSeparator.grip.style}))}}])&&p(n.prototype,i),a&&p(n,a),e}(),m=n(1),b=n.n(m),g=0,v=30,w=5e3,k="day",x="week",O="month",S="year";function T(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function j(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var P=new(function(){function t(){var e=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),j(this,"dayToPosition",function(t,e,n){return t*n+e}),j(this,"daysInYear",function(t){return e.isLeapYear(t)?366:365})}var e,n,o;return e=t,(n=[{key:"dateToPixel",value:function(t,e,n){var o=this.getToday(),r=new Date(t),i=60*(r.getTimezoneOffset()-o.getTimezoneOffset())*1e3;return(r.getTime()-o.getTime()-i)/36e5*(n/24)+e}},{key:"pixelToDate",value:function(t,e,n){var o=24/n,r=t-e,i=this.getToday(),a=i.getTime()+r*o*36e5,s=new Date(a),c=60*(s.getTimezoneOffset()-i.getTimezoneOffset())*1e3;return s.setTime(s.getTime()+c),s}},{key:"getToday",value:function(){var t=new Date;return t.setHours(0,0,0,0),t}},{key:"monthDiff",value:function(t,e){return Math.abs(e.getMonth()-t.getMonth()+12*(e.getFullYear()-t.getFullYear()))}},{key:"daysInMonth",value:function(t,e){return new Date(e,t,0).getDate()}},{key:"isLeapYear",value:function(t){return t%400==0||t%100!=0&&t%4==0}}])&&T(e.prototype,n),o&&T(e,o),t}());n(8);function E(t){"@babel/helpers - typeof";return(E="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function L(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);e&&(o=o.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),n.push.apply(n,o)}return n}function C(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?L(Object(n),!0).forEach(function(e){M(t,e,n[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):L(Object(n)).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))})}return t}function M(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function D(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function _(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function R(t,e,n){return e&&_(t.prototype,e),n&&_(t,n),t}function I(t,e){return!e||"object"!==E(e)&&"function"!=typeof e?U(t):e}function U(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function z(t){return(z=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function N(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&W(t,e)}function W(t,e){return(W=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var V=function(t){function e(t){return D(this,e),I(this,z(e).call(this,t))}return N(e,o["PureComponent"]),R(e,[{key:"render",value:function(){return r.a.createElement("div",{style:{display:"flex",justifyContent:"center",alignItems:"center",borderLeft:"solid 1px white",position:"absolute",height:20,left:this.props.left,width:this.props.width}},r.a.createElement("div",null,this.props.label))}}]),e}(),F=function(t){function e(t){var n;return D(this,e),M(U(n=I(this,z(e).call(this,t))),"getStartDate",function(t,e){var n=null;switch(e){case"year":return n=t.year(),b()([n,0,1]);case"month":n=t.year();var o=t.month();return b()([n,o,1]);case"week":return t.subtract(t.day(),"days");default:return t}}),M(U(n),"renderTime",function(t,e,n,o){for(var i=[],a=e/24,s=0,c=0;c<24;c++)i.push(r.a.createElement(V,{key:c,left:s,width:a,label:"shorttime"==n?c:"".concat(c,":00")})),s+=a;return r.a.createElement("div",{key:o,style:{position:"absolute",height:20,left:t,width:e}}," ",i)}),M(U(n),"renderHeaderRows",function(t,e,o){for(var i={top:[],middle:[],bottom:[]},a={},s="",c="",u="",p=null,d=null,f=n.props.currentday,h=n.props.currentday+n.props.numVisibleDays,y=f-v;y<h+v;y++)s!=(p=b()().add(y,"days")).format(n.getFormat(t,"top"))&&(s=p.format(n.getFormat(t,"top")),d=n.getBox(p,t,a.top),a.top=d.left+d.width,i.top.push(r.a.createElement(V,{key:y,left:d.left,width:d.width,label:s}))),c!=p.format(n.getFormat(e))&&(c=p.format(n.getFormat(e)),d=n.getBox(p,e,a.middle),a.middle=d.left+d.width,i.middle.push(r.a.createElement(V,{key:y,left:d.left,width:d.width,label:c}))),u!=p.format(n.getFormat(o))&&(u=p.format(n.getFormat(o)),d=n.getBox(p,o,a.bottom),a.bottom=d.left+d.width,"shorttime"==o||"fulltime"==o?i.bottom.push(n.renderTime(d.left,d.width,o,y)):i.bottom.push(r.a.createElement(V,{key:y,left:d.left,width:d.width,label:u})));return r.a.createElement("div",{className:"timeLine-main-header-container",style:{width:w,maxWidth:w}},r.a.createElement("div",{className:"header-top",style:C({},l.values.header.top.style)},i.top),r.a.createElement("div",{className:"header-middle",style:C({},l.values.header.middle.style)},i.middle),r.a.createElement("div",{className:"header-bottom",style:C({},l.values.header.bottom.style)},i.bottom))}),M(U(n),"renderHeader",function(){switch(n.props.mode){case k:return n.renderHeaderRows("week","dayweek","fulltime");case x:return n.renderHeaderRows("week","dayweek","shorttime");case O:return n.renderHeaderRows("month","dayweek","daymonth");case S:return n.renderHeaderRows("year","month","week")}}),M(U(n),"setBoundaries",function(){n.start=n.props.currentday-v,n.end=n.props.currentday+n.props.numVisibleDays+v}),M(U(n),"needToRender",function(){return n.props.currentday<n.start||n.props.currentday+n.props.numVisibleDays>n.end}),n.setBoundaries(),n}return N(e,o["PureComponent"]),R(e,[{key:"getFormat",value:function(t,e){switch(t){case"year":return"YYYY";case"month":return"top"==e?"MMMM YYYY":"MMMM";case"week":return"top"==e?"ww MMMM YYYY":"ww";case"dayweek":return"dd";case"daymonth":return"D"}}},{key:"getModeIncrement",value:function(t,e){switch(e){case"year":return P.daysInYear(t.year());case"month":return t.daysInMonth();case"week":return 7;default:return 1}}},{key:"getBox",value:function(t,e,n){var o=this.getModeIncrement(t,e)*this.props.dayWidth;if(!n){var r=this.getStartDate(t,e);r=r.startOf("day");var i=b()().startOf("day"),a=r.diff(i,"days");n=P.dayToPosition(a,this.props.nowposition,this.props.dayWidth)}return{left:n,width:o}}},{key:"render",value:function(){return this.refs.Header&&(this.refs.Header.scrollLeft=this.props.scrollLeft),r.a.createElement("div",{id:"timeline-header",ref:"Header",className:"timeLine-main-header-viewPort"},this.renderHeader())}}]),e}();function A(t){"@babel/helpers - typeof";return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function H(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);e&&(o=o.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),n.push.apply(n,o)}return n}function Y(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?H(Object(n),!0).forEach(function(e){$(t,e,n[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):H(Object(n)).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))})}return t}function B(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function X(t){return(X=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function q(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function G(t,e){return(G=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function $(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var J=function(t){function e(t){var n,o,r;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),o=this,r=X(e).call(this,t),$(q(n=!r||"object"!==A(r)&&"function"!=typeof r?q(o):r),"onCreateLinkMouseDown",function(t,e){0===t.button&&(t.stopPropagation(),n.props.onStartCreateLink(n.props.item,e))}),$(q(n),"onCreateLinkMouseUp",function(t,e){t.stopPropagation(),n.props.onFinishCreateLink(n.props.item,e)}),$(q(n),"onCreateLinkTouchStart",function(t,e){t.stopPropagation(),n.props.onStartCreateLink(n.props.item,e)}),$(q(n),"onCreateLinkTouchEnd",function(t,e){t.stopPropagation(),n.props.onFinishCreateLink(n.props.item,e)}),$(q(n),"doMouseDown",function(t,e){n.props.onUpdateTask&&0===t.button&&(t.stopPropagation(),n.dragStart(t.clientX,e))}),$(q(n),"doMouseMove",function(t){n.state.dragging&&(t.stopPropagation(),n.dragProcess(t.clientX))}),$(q(n),"doMouseUp",function(){n.dragEnd()}),$(q(n),"doTouchStart",function(t,e){n.props.onUpdateTask&&(t.stopPropagation(),n.dragStart(t.touches[0].clientX,e))}),$(q(n),"doTouchMove",function(t){n.state.dragging&&(t.stopPropagation(),n.dragProcess(t.changedTouches[0].clientX))}),$(q(n),"doTouchEnd",function(t){n.dragEnd()}),n.calculateStyle=n.calculateStyle.bind(q(n)),n.state={dragging:!1,left:n.props.left,width:n.props.width,mode:g},n}var n,i,a;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&G(t,e)}(e,o["Component"]),n=e,(i=[{key:"componentDidUpdate",value:function(t,e){this.state.dragging&&!e.dragging?(document.addEventListener("mousemove",this.doMouseMove),document.addEventListener("mouseup",this.doMouseUp),document.addEventListener("touchmove",this.doTouchMove),document.addEventListener("touchend",this.doTouchEnd)):!this.state.dragging&&e.dragging&&(document.removeEventListener("mousemove",this.doMouseMove),document.removeEventListener("mouseup",this.doMouseUp),document.removeEventListener("touchmove",this.doTouchMove),document.removeEventListener("touchend",this.doTouchEnd))}},{key:"dragStart",value:function(t,e){this.props.onChildDrag(!0),this.draggingPosition=t,this.setState({dragging:!0,mode:e,left:this.props.left,width:this.props.width})}},{key:"dragProcess",value:function(t){var e=this.draggingPosition-t,n=this.state.left,o=this.state.width;switch(this.state.mode){case 1:n=this.state.left-e;break;case 2:n=this.state.left-e,o=this.state.width+e;break;case 3:o=this.state.width-e}var r={item:this.props.item,position:{start:n-this.props.nowposition,end:n+o-this.props.nowposition}};this.props.onTaskChanging(r),this.setState({left:n,width:o}),this.draggingPosition=t}},{key:"dragEnd",value:function(){this.props.onChildDrag(!1);var t=P.pixelToDate(this.state.left,this.props.nowposition,this.props.dayWidth),e=P.pixelToDate(this.state.left+this.state.width,this.props.nowposition,this.props.dayWidth);this.props.onUpdateTask(this.props.item,{start:t,end:e}),this.setState({dragging:!1,mode:g})}},{key:"calculateStyle",value:function(){var t=this.props.isSelected?l.values.dataViewPort.task.selectedStyle:l.values.dataViewPort.task.style,e=this.props.color?this.props.color:t.backgroundColor;return this.state.dragging?Y({},t,{backgroundColor:e,left:this.state.left,width:this.state.width,height:this.props.height-5,top:2}):Y({},t,{backgroundColor:e,left:this.props.left,width:this.props.width,height:this.props.height-5,top:2})}},{key:"render",value:function(){var t=this,e=this.calculateStyle();return r.a.createElement("div",{onMouseDown:function(e){return t.doMouseDown(e,1)},onTouchStart:function(e){return t.doTouchStart(e,1)},onClick:function(e){t.props.onSelectItem(t.props.item)},style:e},r.a.createElement("div",{className:"timeLine-main-data-task-side",style:{top:0,left:-4,height:e.height},onMouseDown:function(e){return t.doMouseDown(e,2)},onTouchStart:function(e){return t.doTouchStart(e,2)}},r.a.createElement("div",{className:"timeLine-main-data-task-side-linker",onMouseUp:function(e){return t.onCreateLinkMouseUp(e,void 0)},onTouchEnd:function(e){return t.onCreateLinkTouchEnd(e,void 0)}})),r.a.createElement("div",{style:{overflow:"hidden"}},l.values.dataViewPort.task.showLabel?this.props.item.name:""),r.a.createElement("div",{className:"timeLine-main-data-task-side",style:{top:0,left:e.width-3,height:e.height},onMouseDown:function(e){return t.doMouseDown(e,3)},onTouchStart:function(e){return t.doTouchStart(e,3)}},r.a.createElement("div",{className:"timeLine-main-data-task-side-linker",onMouseDown:function(e){return t.onCreateLinkMouseDown(e,void 0)},onTouchStart:function(e){return t.onCreateLinkTouchStart(e,void 0)}})))}}])&&B(n.prototype,i),a&&B(n,a),e}(),K=n(5),Q=n.n(K);function Z(t){"@babel/helpers - typeof";return(Z="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function tt(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);e&&(o=o.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),n.push.apply(n,o)}return n}function et(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function nt(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function ot(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function rt(t,e,n){return e&&ot(t.prototype,e),n&&ot(t,n),t}function it(t,e){return!e||"object"!==Z(e)&&"function"!=typeof e?at(t):e}function at(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function st(t){return(st=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function ct(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&lt(t,e)}function lt(t,e){return(lt=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var ut=function(t){function e(t){return nt(this,e),it(this,st(e).call(this,t))}return ct(e,o["Component"]),rt(e,[{key:"render",value:function(){return r.a.createElement("div",{className:"timeLine-main-data-row",style:function(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?tt(Object(n),!0).forEach(function(e){et(t,e,n[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):tt(Object(n)).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))})}return t}({},l.values.dataViewPort.rows.style,{top:this.props.top,height:this.props.itemheight})},this.props.children)}}]),e}(),pt=function(t){function e(t){var n;return nt(this,e),et(at(n=it(this,st(e).call(this,t))),"onChildDrag",function(t){n.childDragging=t}),et(at(n),"renderRows",function(){for(var t=[],e=n.props.startRow;e<n.props.endRow+1;e++){var o=n.props.data[e];if(!o)break;var i=P.dateToPixel(o.start,n.props.nowposition,n.props.dayWidth),a=P.dateToPixel(o.end,n.props.nowposition,n.props.dayWidth)-i;t.push(r.a.createElement(ut,{key:e,label:o.name,top:e*n.props.itemheight,left:20,itemheight:n.props.itemheight},r.a.createElement(J,{item:o,label:o.name,nowposition:n.props.nowposition,dayWidth:n.props.dayWidth,color:o.color,left:i,width:a,height:n.props.itemheight,onChildDrag:n.onChildDrag,isSelected:n.props.selectedItem==o,onSelectItem:n.props.onSelectItem,onStartCreateLink:n.props.onStartCreateLink,onFinishCreateLink:n.props.onFinishCreateLink,onTaskChanging:n.props.onTaskChanging,onUpdateTask:n.props.onUpdateTask}," ")))}return t}),et(at(n),"doMouseDown",function(t){0!==t.button||n.childDragging||n.props.onMouseDown(t)}),et(at(n),"doMouseMove",function(t){n.props.onMouseMove(t,n.refs.dataViewPort)}),et(at(n),"doTouchStart",function(t){n.childDragging||n.props.onTouchStart(t)}),et(at(n),"doTouchMove",function(t){n.props.onTouchMove(t,n.refs.dataViewPort)}),n.childDragging=!1,n}return ct(e,o["Component"]),rt(e,[{key:"getContainerHeight",value:function(t){return t>0?t*this.props.itemheight:10}},{key:"componentDidMount",value:function(){this.refs.dataViewPort.scrollLeft=0}},{key:"render",value:function(){this.refs.dataViewPort&&(this.refs.dataViewPort.scrollLeft=this.props.scrollLeft,this.refs.dataViewPort.scrollTop=this.props.scrollTop);var t=this.getContainerHeight(this.props.data.length);return r.a.createElement("div",{ref:"dataViewPort",id:"timeLinedataViewPort",className:"timeLine-main-data-viewPort",onMouseDown:this.doMouseDown,onMouseMove:this.doMouseMove,onMouseUp:this.props.onMouseUp,onMouseLeave:this.props.onMouseLeave,onTouchStart:this.doTouchStart,onTouchMove:this.doTouchMove,onTouchEnd:this.props.onTouchEnd,onTouchCancel:this.props.onTouchCancel},r.a.createElement("div",{className:"timeLine-main-data-container",style:{height:t,width:w,maxWidth:w}},this.renderRows()))}}]),e}(),dt=Q()({monitorWidth:!0,monitorHeight:!0})(pt);function ft(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}var ht=new(function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.data={},this.link={}}var e,n,o;return e=t,(n=[{key:"registerData",value:function(t){if(t){this.data={};for(var e=0;e<t.length;e++)this.data[t[e].id]={item:t[e],index:e}}}},{key:"registerLinks",value:function(t){if(t){this.link={};for(var e=0,n=0,o=0;o<t.length;o++){e=t[o].start,n=t[o].end;var r={link:t[o],index:o};this.createAddTo(e,this.link,r,o),this.createAddTo(n,this.link,r,o)}}}},{key:"createAddTo",value:function(t,e,n,o){e[t]||(e[t]=[]),-1==e[t].indexOf(n)&&e[t].push(n)}},{key:"getTask",value:function(t){return this.data[t]}},{key:"getLinks",value:function(t){return this.link[t]}}])&&ft(e.prototype,n),o&&ft(e,o),t}());function yt(t){"@babel/helpers - typeof";return(yt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function mt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function bt(t){return(bt=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function gt(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function vt(t,e){return(vt=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function wt(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var kt=20,xt=function(t){function e(t){var n,o,r;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),o=this,r=bt(e).call(this,t),wt(gt(n=!r||"object"!==yt(r)&&"function"!=typeof r?gt(o):r),"calcNormCoordinates",function(){var t;return{cpt1:{x:t=n.props.start.x+(n.props.end.x-n.props.start.x)/2,y:n.props.start.y},cpt2:{x:t,y:n.props.end.y}}}),wt(gt(n),"calcSCoordinates",function(){var t={x:n.props.start.x+kt,y:n.props.start.y},e=(n.props.end.y-n.props.start.y)/2,o={x:t.x,y:t.y+e},r={x:n.props.end.x-kt,y:o.y};return{cpt1:t,cpt2:o,cpt3:r,cpt4:{x:r.x,y:r.y+e}}}),wt(gt(n),"getPath",function(){var t=null;return n.props.start.x>n.props.end.x?(t=n.calcSCoordinates(),"M".concat(n.props.start.x," ").concat(n.props.start.y,"  ").concat(t.cpt1.x," ").concat(t.cpt1.y," ").concat(t.cpt2.x," ").concat(t.cpt2.y," ").concat(t.cpt3.x," ").concat(t.cpt3.y," ").concat(t.cpt4.x," ").concat(t.cpt4.y," ").concat(n.props.end.x," ").concat(n.props.end.y)):(t=n.calcNormCoordinates(),"M".concat(n.props.start.x," ").concat(n.props.start.y,"  ").concat(t.cpt1.x," ").concat(t.cpt1.y," ").concat(t.cpt2.x," ").concat(t.cpt2.y," ").concat(n.props.end.x," ").concat(n.props.end.y))}),wt(gt(n),"onSelect",function(t){n.props.onSelectItem&&n.props.onSelectItem(n.props.item)}),n}var n,i,a;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&vt(t,e)}(e,o["Component"]),n=e,(i=[{key:"render",value:function(){var t=this.props.isSelected?l.values.links.selectedColor:l.values.links.color;return r.a.createElement("g",{className:"timeline-link"},r.a.createElement("path",{pointerEvents:"stroke",onMouseDown:this.onSelect,stroke:"white",d:this.getPath(),strokeLinejoin:"round",fill:"transparent",strokeWidth:"4",cursor:"pointer"}),r.a.createElement("path",{pointerEvents:"stroke",onMouseDown:this.onSelect,stroke:t,d:this.getPath(),strokeLinejoin:"round",fill:"transparent",strokeWidth:"1",cursor:"pointer",markerEnd:"url(#arrow)"}))}}])&&mt(n.prototype,i),a&&mt(n,a),e}();function Ot(t){"@babel/helpers - typeof";return(Ot="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function St(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Tt(t){return(Tt=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function jt(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function Pt(t,e){return(Pt=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function Et(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var Lt=function(t){function e(t){var n,o,r;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),o=this,r=Tt(e).call(this,t),Et(jt(n=!r||"object"!==Ot(r)&&"function"!=typeof r?jt(o):r),"doMouseMove",function(t){n.init||(n.lastX=t.clientX,n.lastY=t.clientY,n.init=!0);var e=n.state.x+(t.clientX-n.lastX),o=n.state.y+(t.clientY-n.lastY);n.lastX=t.clientX,n.lastY=t.clientY,n.setState({x:e,y:o})}),Et(jt(n),"doMouseUp",function(t){n.props.onFinishCreateLink()}),n.state={x:n.props.start.x,y:n.props.start.y},n.init=!1,n.lastX=-1,n.lastY=-1,n}var n,i,a;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Pt(t,e)}(e,o["Component"]),n=e,(i=[{key:"componentDidMount",value:function(){document.addEventListener("mousemove",this.doMouseMove),document.addEventListener("mouseup",this.doMouseUp)}},{key:"componentWillUnmount",value:function(){document.removeEventListener("mousemove",this.doMouseMove),document.removeEventListener("mouseup",this.doMouseUp)}},{key:"render",value:function(){return r.a.createElement(xt,{key:-1,start:{x:this.props.start.x,y:this.props.start.y},end:{x:this.state.x,y:this.state.y}})}}])&&St(n.prototype,i),a&&St(n,a),e}();function Ct(t){"@babel/helpers - typeof";return(Ct="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Mt(t){return function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++)n[e]=t[e];return n}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function Dt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function _t(t){return(_t=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Rt(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function It(t,e){return(It=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function Ut(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var zt=function(t){function e(t){var n,o,i;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),o=this,i=_t(e).call(this,t),Ut(Rt(n=!i||"object"!==Ct(i)&&"function"!=typeof i?Rt(o):i),"getItemPosition",function(t,e){return{x:P.dateToPixel(e,0,n.props.dayWidth),y:t*n.props.itemheight+n.props.itemheight/2}}),Ut(Rt(n),"renderCreateLink",function(){if(n.props.interactiveMode){var t=ht.getTask(n.props.taskToCreate.task.id),e=n.getItemPosition(t.index,t.item.end);return r.a.createElement(Lt,{start:e,onFinishCreateLink:n.props.onFinishCreateLink})}}),Ut(Rt(n),"renderChangingTaskLinks",function(){if(n.props.changingTask!=n.state.changingTask){n.state.changingTask=n.props.changingTask;var t=ht.getLinks(n.state.changingTask.item.id);if(!t)return;for(var e=null,o=null,i=null,a={},s={},c=0;c<t.length;c++)e=t[c],(o=ht.getTask(e.link.start))&&(i=ht.getTask(e.link.end))&&(a=n.getItemPosition(o.index,o.item.end),n.state.changingTask.item.id==e.link.start&&(a.x=n.state.changingTask.position.end),s=n.getItemPosition(i.index,i.item.start),n.state.changingTask.item.id==e.link.end&&(s.x=n.state.changingTask.position.start),n.cache[e.index]=r.a.createElement(xt,{key:-c-1,item:e,start:{x:a.x,y:a.y},end:{x:s.x,y:s.y},isSelected:n.props.selectedItem==e,onSelectItem:n.props.onSelectItem}),n.cache=Mt(n.cache))}}),n.cache=[],n.state={links:[],data:[],selectedItem:null},n}var n,i,a;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&It(t,e)}(e,o["Component"]),n=e,(i=[{key:"renderLink",value:function(t,e,n,o){var i=this.getItemPosition(t.index,t.item.end),a=this.getItemPosition(e.index,e.item.start);return r.a.createElement(xt,{key:o,item:n,start:{x:i.x,y:i.y},end:{x:a.x,y:a.y},isSelected:this.props.selectedItem==n,onSelectItem:this.props.onSelectItem})}},{key:"renderLinks",value:function(){this.cache=[];var t,e={},n={};if(0!=this.state.data.length)for(var o=0;o<this.state.links.length;o++){var r=this.state.links[o];!r&&e[r.id]||((t=ht.getTask(r.start))&&(n=ht.getTask(r.end))?(this.cache.push(this.renderLink(t,n,r,o)),e[r.id]=""):this.cache.push(null))}}},{key:"refreshData",value:function(){this.props.links==this.state.links&&this.props.data==this.state.data&&this.props.dayWidth==this.state.dayWidth&&this.props.selectedItem==this.state.selectedItem||(this.state.selectedItem=this.props.selectedItem,this.state.dayWidth=this.props.dayWidth,this.state.links=this.props.links,this.state.data=this.props.data,this.state.links&&this.state.data&&this.renderLinks())}},{key:"render",value:function(){return this.refreshData(),this.renderChangingTaskLinks(),r.a.createElement("svg",{x:0,y:0,width:"100%",pointerEvents:"none",style:{position:"absolute",top:60,userSelect:"none",height:"100%"}},r.a.createElement("defs",null,r.a.createElement("marker",{id:"arrow",viewBox:"0 0 10 10",refX:"5",refY:"5",markerWidth:"9",markerHeight:"9",orient:"auto-start-reverse"},r.a.createElement("path",{d:"M 0 0 L 10 5 L 0 10 z",strokeLinejoin:"round"}))),r.a.createElement("g",{transform:"matrix(1,0,0,1,".concat(-(this.props.scrollLeft-this.props.nowposition),",").concat(-this.props.scrollTop,")")},this.cache,this.renderCreateLink()))}}])&&Dt(n.prototype,i),a&&Dt(n,a),e}();function Nt(t){"@babel/helpers - typeof";return(Nt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Wt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Vt(t){return(Vt=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Ft(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function At(t,e){return(At=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function Ht(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var Yt=function(t){function e(t){var n,o,i;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),o=this,i=Vt(e).call(this,t),Ht(Ft(n=!i||"object"!==Nt(i)&&"function"!=typeof i?Ft(o):i),"onFocus",function(){n.setState({editing:!0})}),Ht(Ft(n),"onBlur",function(){n.finishEditing()}),Ht(Ft(n),"handleKey",function(t){13===(t.keyCode||t.which)&&n.finishEditing()}),Ht(Ft(n),"finishEditing",function(){n.isFocus=!1,n.setState({editing:!1}),n.props.onChange&&n.props.onChange(n.state.value)}),Ht(Ft(n),"handleChange",function(t){n.setState({value:t.target.value})}),Ht(Ft(n),"renderDiv",function(){return r.a.createElement("div",{tabIndex:n.props.index,onClick:n.onFocus,onFocus:n.onFocus,style:{width:"100%"}}," ",n.state.value)}),Ht(Ft(n),"renderEditor",function(){return r.a.createElement("input",{ref:"textInput",onBlur:n.onBlur,style:{width:"100%",outlineColor:"black",outlineStyle:"oinset"},type:"text",name:"name",value:n.state.value,onKeyUp:n.handleKey,onChange:n.handleChange})}),n.isFocus=!1,n.state={editing:!1,value:n.props.value},n}var n,i,a;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&At(t,e)}(e,o["Component"]),n=e,(i=[{key:"componentDidUpdate",value:function(t,e){this.refs.textInput&&!this.isFocus&&(this.refs.textInput.focus(),this.isFocus=!0)}},{key:"shouldComponentUpdate",value:function(t,e){return t.value!=this.props.value&&(this.state.value=t.value),!0}},{key:"render",value:function(){return this.state.editing?this.renderEditor():this.renderDiv()}}])&&Wt(n.prototype,i),a&&Wt(n,a),e}();function Bt(t){"@babel/helpers - typeof";return(Bt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Xt(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);e&&(o=o.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),n.push.apply(n,o)}return n}function qt(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function Gt(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function $t(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Jt(t,e,n){return e&&$t(t.prototype,e),n&&$t(t,n),t}function Kt(t,e){return!e||"object"!==Bt(e)&&"function"!=typeof e?Qt(t):e}function Qt(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function Zt(t){return(Zt=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function te(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&ee(t,e)}function ee(t,e){return(ee=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var ne=function(t){function e(t){var n;return Gt(this,e),qt(Qt(n=Kt(this,Zt(e).call(this,t))),"onChange",function(t){n.props.onUpdateTask&&n.props.onUpdateTask(n.props.item,{name:t})}),n}return te(e,o["Component"]),Jt(e,[{key:"render",value:function(){var t=this;return r.a.createElement("div",{className:"timeLine-side-task-row",style:function(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Xt(Object(n),!0).forEach(function(e){qt(t,e,n[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Xt(Object(n)).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))})}return t}({},l.values.taskList.task.style,{top:this.props.top,height:this.props.itemheight}),onClick:function(e){return t.props.onSelectItem(t.props.item)}},this.props.nonEditable?r.a.createElement("div",{tabIndex:this.props.index,style:{width:"100%"}},this.props.label):r.a.createElement(Yt,{value:this.props.label,index:this.props.index,onChange:this.onChange}))}}]),e}(),oe=function(t){function e(t){var n;return Gt(this,e),qt(Qt(n=Kt(this,Zt(e).call(this,t))),"doScroll",function(){n.props.onScroll(n.refs.taskViewPort.scrollTop)}),n}return te(e,o["Component"]),Jt(e,[{key:"getContainerStyle",value:function(t){return{height:t>0?t*this.props.itemheight:10}}},{key:"renderTaskRow",value:function(t){for(var e=[],n=this.props.startRow;n<this.props.endRow+1;n++){var o=t[n];if(!o)break;e.push(r.a.createElement(ne,{key:n,index:n,item:o,label:o.name,top:n*this.props.itemheight,itemheight:this.props.itemheight,isSelected:this.props.selectedItem==o,onUpdateTask:this.props.onUpdateTask,onSelectItem:this.props.onSelectItem,nonEditable:this.props.nonEditable}))}return e}},{key:"render",value:function(){var t=this.props.data?this.props.data:[];return this.containerStyle=this.getContainerStyle(t.length),r.a.createElement("div",{className:"timeLine-side"},r.a.createElement("div",{className:"timeLine-side-title",style:l.values.taskList.title.style},r.a.createElement("div",null,l.values.taskList.title.label)),r.a.createElement("div",{ref:"taskViewPort",className:"timeLine-side-task-viewPort",onScroll:this.doScroll},r.a.createElement("div",{className:"timeLine-side-task-container",style:this.containerStyle},this.renderTaskRow(t))))}}]),e}();function re(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var ie=function t(){var e=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),re(this,"initialise",function(t,n,o,r){e.nowposition=o,e.daywidth=r,e.setLimits(t,n,o,r),e.loadDataHorizon()}),re(this,"setStartEnd",function(t,n,o,r){e.nowposition=o,e.daywidth=r,e.needData(t,n)&&(e.setLimits(t,n),e.loadDataHorizon())}),re(this,"needData",function(t,n){return t<e.lower_data_limit||n>e.upper_data_limit}),re(this,"setLimits",function(t,n){e.lower_limit=t-1e3,e.lower_data_limit=t-750,e.upper_limit=n+1e3,e.upper_data_limit=n+750}),re(this,"loadDataHorizon",function(){var t=P.pixelToDate(e.lower_limit,e.nowposition,e.daywidth),n=P.pixelToDate(e.upper_limit,e.nowposition,e.daywidth);e.onHorizonChange(t,n)}),this.lower_limit=0,this.upper_limit=0,this._dataToRender=[]};n(11);function ae(t){"@babel/helpers - typeof";return(ae="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function se(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);e&&(o=o.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),n.push.apply(n,o)}return n}function ce(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function le(t){return(le=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function ue(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function pe(t,e){return(pe=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function de(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var fe=function(t){function e(t){var n,o,r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),o=this,r=le(e).call(this,t),de(ue(n=!r||"object"!==ae(r)&&"function"!=typeof r?ue(o):r),"onSize",function(t){n.calculateVerticalScrollVariables(t),n.initialise||(n.dc.initialise(n.state.scrollLeft+n.state.nowposition,n.state.scrollLeft+n.state.nowposition+t.width,n.state.nowposition,n.state.dayWidth),n.initialise=!0),n.setStartEnd();var e=Math.ceil(t.height/n.props.itemheight),o=n.calcNumVisibleDays(t),r=n.calculateStartEndRows(e,n.props.data,n.state.scrollTop);n.setState({numVisibleRows:e,numVisibleDays:o,startRow:r.start,endRow:r.end,size:t})}),de(ue(n),"verticalChange",function(t){if(t!=n.state.scrollTop){var e=n.calculateStartEndRows(n.state.numVisibleRows,n.props.data,t);e.start!==n.state.start&&n.setState({scrollTop:t,startRow:e.start,endRow:e.end})}}),de(ue(n),"calculateStartEndRows",function(t,e,o){var r=Math.trunc(o/n.props.itemheight);return{start:r,end:r+t>=e.length?e.length:r+t}}),de(ue(n),"setStartEnd",function(){n.dc.setStartEnd(n.state.scrollLeft,n.state.scrollLeft+n.state.size.width,n.state.nowposition,n.state.dayWidth)}),de(ue(n),"horizontalChange",function(t){var e=n.state.nowposition,o=-1,r=n.state.headerData,i=n.state.startRow,a=n.state.endRow;t>n.pxToScroll?(e=n.state.nowposition-n.pxToScroll,o=0):t<=0?(e=n.state.nowposition+n.pxToScroll,o=n.pxToScroll):o=t;var s=Math.trunc((t-n.state.nowposition)/n.state.dayWidth);a=(i=Math.trunc(n.state.scrollTop/n.props.itemheight))+n.state.numVisibleRows>=n.props.data.length?n.props.data.length-1:i+n.state.numVisibleRows,n.setStartEnd(),n.setState({currentday:s,nowposition:e,headerData:r,scrollLeft:o,startRow:i,endRow:a})}),de(ue(n),"calculateVerticalScrollVariables",function(t){n.pxToScroll=(1-t.width/w)*w-1}),de(ue(n),"onHorizonChange",function(t,e){n.props.onHorizonChange&&n.props.onHorizonChange(t,e)}),de(ue(n),"doMouseDown",function(t){n.dragging=!0,n.draggingPosition=t.clientX}),de(ue(n),"doMouseMove",function(t){if(n.dragging){var e=n.draggingPosition-t.clientX;0!==e&&(n.draggingPosition=t.clientX,n.horizontalChange(n.state.scrollLeft+e))}}),de(ue(n),"doMouseUp",function(t){n.dragging=!1}),de(ue(n),"doMouseLeave",function(t){n.dragging=!1}),de(ue(n),"doTouchStart",function(t){n.dragging=!0,n.draggingPosition=t.touches[0].clientX}),de(ue(n),"doTouchEnd",function(t){n.dragging=!1}),de(ue(n),"doTouchMove",function(t){if(n.dragging){var e=n.draggingPosition-t.touches[0].clientX;0!==e&&(n.draggingPosition=t.touches[0].clientX,n.horizontalChange(n.state.scrollLeft+e))}}),de(ue(n),"doTouchCancel",function(t){n.dragging=!1}),de(ue(n),"doMouseLeave",function(t){n.dragging=!1}),de(ue(n),"onTaskListSizing",function(t){n.setState(function(e){var n=function(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?se(Object(n),!0).forEach(function(e){de(t,e,n[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):se(Object(n)).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))})}return t}({},e);return n.sideStyle={width:n.sideStyle.width-t},n})}),de(ue(n),"onSelectItem",function(t){n.props.onSelectItem&&t!=n.props.selectedItem&&n.props.onSelectItem(t)}),de(ue(n),"onStartCreateLink",function(t,e){n.setState({interactiveMode:!0,taskToCreate:{task:t,position:e}})}),de(ue(n),"onFinishCreateLink",function(t,e){n.props.onCreateLink&&t&&n.state.taskToCreate&&n.state.taskToCreate.task.id!=t.id&&n.props.onCreateLink({start:n.state.taskToCreate,end:{task:t,position:e}}),n.setState({interactiveMode:!1,taskToCreate:null})}),de(ue(n),"onTaskChanging",function(t){n.setState({changingTask:t})}),de(ue(n),"calcNumVisibleDays",function(t){return Math.ceil(t.width/n.state.dayWidth)+v}),de(ue(n),"checkNeeeData",function(){if(n.props.data!=n.state.data){n.state.data=n.props.data;var t=n.calculateStartEndRows(n.state.numVisibleRows,n.props.data,n.state.scrollTop);n.state.startRow=t.start,n.state.endRow=t.end,ht.registerData(n.state.data)}n.props.links!=n.state.links&&(n.state.links=n.props.links,ht.registerLinks(n.props.links))}),n.dragging=!1,n.draggingPosition=0,n.dc=new ie,n.dc.onHorizonChange=n.onHorizonChange,n.initialise=!1,n.pxToScroll=1900;var i=n.getDayWidth(n.props.mode);return l.load(n.props.config),n.state={currentday:0,nowposition:0,startRow:0,endRow:10,sideStyle:{width:200},scrollLeft:0,scrollTop:0,numVisibleRows:40,numVisibleDays:60,dayWidth:i,interactiveMode:!1,taskToCreate:null,links:[],mode:n.props.mode?n.props.mode:O,size:{width:1,height:1},changingTask:null},n}var n,i,a;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&pe(t,e)}(e,o["Component"]),n=e,(i=[{key:"getDayWidth",value:function(t){switch(t){case k:return 1440;case x:return 480;case O:return 24;case S:return 4;default:return 24}}},{key:"checkMode",value:function(){if(this.props.mode!=this.state.mode&&this.props.mode){this.state.mode=this.props.mode;var t=this.getDayWidth(this.state.mode);this.state.dayWidth=t,this.state.numVisibleDays=this.calcNumVisibleDays(this.state.size);var e=Math.ceil(-this.state.currentday*this.state.dayWidth/this.pxToScroll);this.state.nowposition=e*this.pxToScroll;var n=(this.state.currentday*this.state.dayWidth+this.state.nowposition)%this.pxToScroll;this.state.scrollLeft=n}}},{key:"render",value:function(){var t;return this.checkMode(),this.checkNeeeData(),this.state.size,r.a.createElement("div",{className:"timeLine"},r.a.createElement("div",{className:"timeLine-side-main",style:this.state.sideStyle},r.a.createElement(oe,{ref:"taskViewPort",itemheight:this.props.itemheight,startRow:this.state.startRow,endRow:this.state.endRow,data:this.props.data,selectedItem:this.props.selectedItem,onSelectItem:this.onSelectItem,onUpdateTask:this.props.onUpdateTask,onScroll:this.verticalChange,nonEditable:this.props.nonEditableName}),r.a.createElement(y,{onTaskListSizing:this.onTaskListSizing})),r.a.createElement("div",{className:"timeLine-main"},r.a.createElement(F,{headerData:this.state.headerData,numVisibleDays:this.state.numVisibleDays,currentday:this.state.currentday,nowposition:this.state.nowposition,dayWidth:this.state.dayWidth,mode:this.state.mode,scrollLeft:this.state.scrollLeft}),r.a.createElement(dt,{ref:"dataViewPort",scrollLeft:this.state.scrollLeft,scrollTop:this.state.scrollTop,itemheight:this.props.itemheight,nowposition:this.state.nowposition,startRow:this.state.startRow,endRow:this.state.endRow,data:this.props.data,selectedItem:this.props.selectedItem,dayWidth:this.state.dayWidth,onScroll:this.scrollData,onMouseDown:this.doMouseDown,onMouseMove:this.doMouseMove,onMouseUp:this.doMouseUp,onMouseLeave:this.doMouseLeave,onTouchStart:this.doTouchStart,onTouchMove:this.doTouchMove,onTouchEnd:this.doTouchEnd,onTouchCancel:this.doTouchCancel,onSelectItem:this.onSelectItem,onUpdateTask:this.props.onUpdateTask,onTaskChanging:this.onTaskChanging,onStartCreateLink:this.onStartCreateLink,onFinishCreateLink:this.onFinishCreateLink,boundaries:{lower:this.state.scrollLeft,upper:this.state.scrollLeft+this.state.size.width},onSize:this.onSize}),r.a.createElement(zt,(de(t={scrollLeft:this.state.scrollLeft,scrollTop:this.state.scrollTop,startRow:this.state.startRow,endRow:this.state.endRow,data:this.props.data,nowposition:this.state.nowposition,dayWidth:this.state.dayWidth,interactiveMode:this.state.interactiveMode,taskToCreate:this.state.taskToCreate,onFinishCreateLink:this.onFinishCreateLink,changingTask:this.state.changingTask,selectedItem:this.props.selectedItem,onSelectItem:this.onSelectItem,itemheight:this.props.itemheight},"onSelectItem",this.onSelectItem),de(t,"links",this.props.links),t))))}}])&&ce(n.prototype,i),a&&ce(n,a),e}();fe.propTypes={itemheight:a.a.number.isRequired,dayWidth:a.a.number.isRequired,nonEditableName:a.a.bool},fe.defaultProps={itemheight:20,dayWidth:24,nonEditableName:!1};e.default=fe}])});

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var ReactDOM = _interopDefault(__webpack_require__(60));
var invariant = _interopDefault(__webpack_require__(56));
var throttleDebounce = __webpack_require__(2262);
var createResizeDetector = _interopDefault(__webpack_require__(2263));
var isShallowEqual = _interopDefault(__webpack_require__(2274));

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var instances = {}; // Lazily require to not cause bug
// https://github.com/ctrlplusb/react-sizeme/issues/6

function resizeDetector() {
  var strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'scroll';

  if (!instances[strategy]) {
    instances[strategy] = createResizeDetector({
      strategy: strategy
    });
  }

  return instances[strategy];
}

var errMsg = 'react-sizeme: an error occurred whilst stopping to listen to node size changes';
var defaultConfig = {
  monitorWidth: true,
  monitorHeight: false,
  monitorPosition: false,
  refreshRate: 16,
  refreshMode: 'throttle',
  noPlaceholder: false,
  resizeDetectorStrategy: 'scroll'
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
/**
 * This is a utility wrapper component that will allow our higher order
 * component to get a ref handle on our wrapped components html.
 * @see https://gist.github.com/jimfb/32b587ee6177665fb4cf
 */


var ReferenceWrapper =
/*#__PURE__*/
function (_Component) {
  _inherits(ReferenceWrapper, _Component);

  function ReferenceWrapper() {
    _classCallCheck(this, ReferenceWrapper);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceWrapper).apply(this, arguments));
  }

  _createClass(ReferenceWrapper, [{
    key: "render",
    value: function render() {
      return React.Children.only(this.props.children);
    }
  }]);

  return ReferenceWrapper;
}(React.Component);

_defineProperty(ReferenceWrapper, "displayName", 'SizeMeReferenceWrapper');

function Placeholder(_ref) {
  var className = _ref.className,
      style = _ref.style;
  // Lets create the props for the temp element.
  var phProps = {}; // We will use any provided className/style or else make the temp
  // container take the full available space.

  if (!className && !style) {
    phProps.style = {
      width: '100%',
      height: '100%'
    };
  } else {
    if (className) {
      phProps.className = className;
    }

    if (style) {
      phProps.style = style;
    }
  }

  return React__default.createElement("div", phProps);
}

Placeholder.displayName = 'SizeMePlaceholder';
/**
 * As we need to maintain a ref on the root node that is rendered within our
 * SizeMe component we need to wrap our entire render in a sub component.
 * Without this, we lose the DOM ref after the placeholder is removed from
 * the render and the actual component is rendered.
 * It took me forever to figure this out, so tread extra careful on this one!
 */

var renderWrapper = function renderWrapper(WrappedComponent) {
  function SizeMeRenderer(props) {
    var explicitRef = props.explicitRef,
        className = props.className,
        style = props.style,
        size = props.size,
        disablePlaceholder = props.disablePlaceholder,
        onSize = props.onSize,
        restProps = _objectWithoutProperties(props, ["explicitRef", "className", "style", "size", "disablePlaceholder", "onSize"]);

    var noSizeData = size == null || size.width == null && size.height == null && size.position == null;
    var renderPlaceholder = noSizeData && !disablePlaceholder;
    var renderProps = {
      className: className,
      style: style
    };

    if (size != null) {
      renderProps.size = size;
    }

    var toRender = renderPlaceholder ? React__default.createElement(Placeholder, {
      className: className,
      style: style
    }) : React__default.createElement(WrappedComponent, _extends({}, renderProps, restProps));
    return React__default.createElement(ReferenceWrapper, {
      ref: explicitRef
    }, toRender);
  }

  SizeMeRenderer.displayName = "SizeMeRenderer(".concat(getDisplayName(WrappedComponent), ")");
  return SizeMeRenderer;
};
/**
 * :: config -> Component -> WrappedComponent
 *
 * Higher order component that allows the wrapped component to become aware
 * of it's size, by receiving it as an object within it's props.
 *
 * @param  monitorWidth
 *   Default true, whether changes in the element's width should be monitored,
 *   causing a size property to be broadcast.
 * @param  monitorHeight
 *   Default false, whether changes in the element's height should be monitored,
 *   causing a size property to be broadcast.
 *
 * @return The wrapped component.
 */


function withSize() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultConfig;
  var _config$monitorWidth = config.monitorWidth,
      monitorWidth = _config$monitorWidth === void 0 ? defaultConfig.monitorWidth : _config$monitorWidth,
      _config$monitorHeight = config.monitorHeight,
      monitorHeight = _config$monitorHeight === void 0 ? defaultConfig.monitorHeight : _config$monitorHeight,
      _config$monitorPositi = config.monitorPosition,
      monitorPosition = _config$monitorPositi === void 0 ? defaultConfig.monitorPosition : _config$monitorPositi,
      _config$refreshRate = config.refreshRate,
      refreshRate = _config$refreshRate === void 0 ? defaultConfig.refreshRate : _config$refreshRate,
      _config$refreshMode = config.refreshMode,
      refreshMode = _config$refreshMode === void 0 ? defaultConfig.refreshMode : _config$refreshMode,
      _config$noPlaceholder = config.noPlaceholder,
      noPlaceholder = _config$noPlaceholder === void 0 ? defaultConfig.noPlaceholder : _config$noPlaceholder,
      _config$resizeDetecto = config.resizeDetectorStrategy,
      resizeDetectorStrategy = _config$resizeDetecto === void 0 ? defaultConfig.resizeDetectorStrategy : _config$resizeDetecto;
  invariant(monitorWidth || monitorHeight || monitorPosition, 'You have to monitor at least one of the width, height, or position when using "sizeMe"');
  invariant(refreshRate >= 16, "It is highly recommended that you don't put your refreshRate lower than " + '16 as this may cause layout thrashing.');
  invariant(refreshMode === 'throttle' || refreshMode === 'debounce', 'The refreshMode should have a value of "throttle" or "debounce"');
  var refreshDelayStrategy = refreshMode === 'throttle' ? throttleDebounce.throttle : throttleDebounce.debounce;
  return function WrapComponent(WrappedComponent) {
    var SizeMeRenderWrapper = renderWrapper(WrappedComponent);

    var SizeAwareComponent =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(SizeAwareComponent, _React$Component);

      function SizeAwareComponent() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, SizeAwareComponent);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SizeAwareComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_this), "domEl", null);

        _defineProperty(_assertThisInitialized(_this), "state", {
          width: undefined,
          height: undefined,
          position: undefined
        });

        _defineProperty(_assertThisInitialized(_this), "uninstall", function () {
          if (_this.domEl) {
            try {
              _this.detector.uninstall(_this.domEl);
            } catch (err) {
              // eslint-disable-next-line no-console
              console.warn(errMsg);
            }

            _this.domEl = null;
          }
        });

        _defineProperty(_assertThisInitialized(_this), "determineStrategy", function (props) {
          if (props.onSize) {
            if (!_this.callbackState) {
              _this.callbackState = _objectSpread2({}, _this.state);
            }

            _this.strategy = 'callback';
          } else {
            _this.strategy = 'render';
          }
        });

        _defineProperty(_assertThisInitialized(_this), "strategisedSetState", function (state) {
          if (_this.strategy === 'callback') {
            _this.callbackState = state;

            _this.props.onSize(state);
          }

          _this.setState(state);
        });

        _defineProperty(_assertThisInitialized(_this), "strategisedGetState", function () {
          return _this.strategy === 'callback' ? _this.callbackState : _this.state;
        });

        _defineProperty(_assertThisInitialized(_this), "refCallback", function (element) {
          _this.element = element;
        });

        _defineProperty(_assertThisInitialized(_this), "hasSizeChanged", function (current, next) {
          var c = current;
          var n = next;
          var cp = c.position || {};
          var np = n.position || {};
          return monitorWidth && c.width !== n.width || monitorHeight && c.height !== n.height || monitorPosition && (cp.top !== np.top || cp.left !== np.left || cp.bottom !== np.bottom || cp.right !== np.right);
        });

        _defineProperty(_assertThisInitialized(_this), "checkIfSizeChanged", refreshDelayStrategy(refreshRate, function (el) {
          var _el$getBoundingClient = el.getBoundingClientRect(),
              width = _el$getBoundingClient.width,
              height = _el$getBoundingClient.height,
              right = _el$getBoundingClient.right,
              left = _el$getBoundingClient.left,
              top = _el$getBoundingClient.top,
              bottom = _el$getBoundingClient.bottom;

          var next = {
            width: monitorWidth ? width : null,
            height: monitorHeight ? height : null,
            position: monitorPosition ? {
              right: right,
              left: left,
              top: top,
              bottom: bottom
            } : null
          };

          if (_this.hasSizeChanged(_this.strategisedGetState(), next)) {
            _this.strategisedSetState(next);
          }
        }));

        return _this;
      }

      _createClass(SizeAwareComponent, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.detector = resizeDetector(resizeDetectorStrategy);
          this.determineStrategy(this.props);
          this.handleDOMNode();
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          this.determineStrategy(this.props);
          this.handleDOMNode();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          // Change our size checker to a noop just in case we have some
          // late running events.
          this.hasSizeChanged = function () {
            return undefined;
          };

          this.checkIfSizeChanged = function () {
            return undefined;
          };

          this.uninstall();
        }
      }, {
        key: "handleDOMNode",
        value: function handleDOMNode() {
          var found = this.element && ReactDOM.findDOMNode(this.element);

          if (!found) {
            // If we previously had a dom node then we need to ensure that
            // we remove any existing listeners to avoid memory leaks.
            this.uninstall();
            return;
          }

          if (!this.domEl) {
            this.domEl = found;
            this.detector.listenTo(this.domEl, this.checkIfSizeChanged);
          } else if (this.domEl.isSameNode && !this.domEl.isSameNode(found) || this.domEl !== found) {
            this.uninstall();
            this.domEl = found;
            this.detector.listenTo(this.domEl, this.checkIfSizeChanged);
          }
        }
      }, {
        key: "render",
        value: function render() {
          var disablePlaceholder = withSize.enableSSRBehaviour || withSize.noPlaceholders || noPlaceholder || this.strategy === 'callback';

          var size = _objectSpread2({}, this.state);

          return React__default.createElement(SizeMeRenderWrapper, _extends({
            explicitRef: this.refCallback,
            size: this.strategy === 'callback' ? null : size,
            disablePlaceholder: disablePlaceholder
          }, this.props));
        }
      }]);

      return SizeAwareComponent;
    }(React__default.Component);

    _defineProperty(SizeAwareComponent, "displayName", "SizeMe(".concat(getDisplayName(WrappedComponent), ")"));

    SizeAwareComponent.WrappedComponent = WrappedComponent;
    return SizeAwareComponent;
  };
}
/**
 * Allow SizeMe to run within SSR environments.  This is a "global" behaviour
 * flag that should be set within the initialisation phase of your application.
 *
 * Warning: don't set this flag unless you need to as using it may cause
 * extra render cycles to happen within your components depending on the logic
 * contained within them around the usage of the `size` data.
 *
 * DEPRECATED: Please use the global noPlaceholders
 */


withSize.enableSSRBehaviour = false;
/**
 * Global configuration allowing to disable placeholder rendering for all
 * sizeMe components.
 */

withSize.noPlaceholders = false;

var SizeMe =
/*#__PURE__*/
function (_Component) {
  _inherits(SizeMe, _Component);

  function SizeMe(props) {
    var _this;

    _classCallCheck(this, SizeMe);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SizeMe).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "createComponent", function (config) {
      _this.SizeAware = withSize(config)(function (_ref) {
        var children = _ref.children;
        return children;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSize", function (size) {
      return _this.setState({
        size: size
      });
    });

    var _children = props.children,
        render = props.render,
        sizeMeConfig = _objectWithoutProperties(props, ["children", "render"]);

    _this.createComponent(sizeMeConfig);

    _this.state = {
      size: {
        width: undefined,
        height: undefined
      }
    };
    return _this;
  }

  _createClass(SizeMe, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          prevChildren = _this$props.children,
          prevRender = _this$props.render,
          currentSizeMeConfig = _objectWithoutProperties(_this$props, ["children", "render"]);

      var nextChildren = prevProps.children,
          nextRender = prevProps.render,
          prevSizeMeConfig = _objectWithoutProperties(prevProps, ["children", "render"]);

      if (!isShallowEqual(currentSizeMeConfig, prevSizeMeConfig)) {
        this.createComponent(currentSizeMeConfig);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var SizeAware = this.SizeAware;
      var render = this.props.children || this.props.render;
      return React__default.createElement(SizeAware, {
        onSize: this.onSize
      }, render({
        size: this.state.size
      }));
    }
  }]);

  return SizeMe;
}(React.Component);

_defineProperty(SizeMe, "defaultProps", {
  children: undefined,
  render: undefined
});

withSize.SizeMe = SizeMe;
withSize.withSize = withSize;

module.exports = withSize;
//# sourceMappingURL=react-sizeme.js.map


/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.throttleDebounce = {}));
}(this, (function (exports) { 'use strict';

	/* eslint-disable no-undefined,no-param-reassign,no-shadow */

	/**
	 * Throttle execution of a function. Especially useful for rate limiting
	 * execution of handlers on events like resize and scroll.
	 *
	 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
	 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
	 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
	 *                                    the internal counter is reset).
	 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                    to `callback` when the throttled-function is executed.
	 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
	 *                                    schedule `callback` to execute after `delay` ms.
	 *
	 * @returns {Function}  A new, throttled, function.
	 */
	function throttle (delay, noTrailing, callback, debounceMode) {
	  /*
	   * After wrapper has stopped being called, this timeout ensures that
	   * `callback` is executed at the proper times in `throttle` and `end`
	   * debounce modes.
	   */
	  var timeoutID;
	  var cancelled = false; // Keep track of the last time `callback` was executed.

	  var lastExec = 0; // Function to clear existing timeout

	  function clearExistingTimeout() {
	    if (timeoutID) {
	      clearTimeout(timeoutID);
	    }
	  } // Function to cancel next exec


	  function cancel() {
	    clearExistingTimeout();
	    cancelled = true;
	  } // `noTrailing` defaults to falsy.


	  if (typeof noTrailing !== 'boolean') {
	    debounceMode = callback;
	    callback = noTrailing;
	    noTrailing = undefined;
	  }
	  /*
	   * The `wrapper` function encapsulates all of the throttling / debouncing
	   * functionality and when executed will limit the rate at which `callback`
	   * is executed.
	   */


	  function wrapper() {
	    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
	      arguments_[_key] = arguments[_key];
	    }

	    var self = this;
	    var elapsed = Date.now() - lastExec;

	    if (cancelled) {
	      return;
	    } // Execute `callback` and update the `lastExec` timestamp.


	    function exec() {
	      lastExec = Date.now();
	      callback.apply(self, arguments_);
	    }
	    /*
	     * If `debounceMode` is true (at begin) this is used to clear the flag
	     * to allow future `callback` executions.
	     */


	    function clear() {
	      timeoutID = undefined;
	    }

	    if (debounceMode && !timeoutID) {
	      /*
	       * Since `wrapper` is being called for the first time and
	       * `debounceMode` is true (at begin), execute `callback`.
	       */
	      exec();
	    }

	    clearExistingTimeout();

	    if (debounceMode === undefined && elapsed > delay) {
	      /*
	       * In throttle mode, if `delay` time has been exceeded, execute
	       * `callback`.
	       */
	      exec();
	    } else if (noTrailing !== true) {
	      /*
	       * In trailing throttle mode, since `delay` time has not been
	       * exceeded, schedule `callback` to execute `delay` ms after most
	       * recent execution.
	       *
	       * If `debounceMode` is true (at begin), schedule `clear` to execute
	       * after `delay` ms.
	       *
	       * If `debounceMode` is false (at end), schedule `callback` to
	       * execute after `delay` ms.
	       */
	      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
	    }
	  }

	  wrapper.cancel = cancel; // Return the wrapper function.

	  return wrapper;
	}

	/* eslint-disable no-undefined */
	/**
	 * Debounce execution of a function. Debouncing, unlike throttling,
	 * guarantees that a function is only executed a single time, either at the
	 * very beginning of a series of calls, or at the very end.
	 *
	 * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
	 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
	 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
	 * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                  to `callback` when the debounced-function is executed.
	 *
	 * @returns {Function} A new, debounced function.
	 */

	function debounce (delay, atBegin, callback) {
	  return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
	}

	exports.debounce = debounce;
	exports.throttle = throttle;

	Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.umd.js.map


/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var forEach                 = __webpack_require__(953).forEach;
var elementUtilsMaker       = __webpack_require__(2264);
var listenerHandlerMaker    = __webpack_require__(2265);
var idGeneratorMaker        = __webpack_require__(2266);
var idHandlerMaker          = __webpack_require__(2267);
var reporterMaker           = __webpack_require__(2268);
var browserDetector         = __webpack_require__(954);
var batchProcessorMaker     = __webpack_require__(2269);
var stateHandler            = __webpack_require__(2271);

//Detection strategies.
var objectStrategyMaker     = __webpack_require__(2272);
var scrollStrategyMaker     = __webpack_require__(2273);

function isCollection(obj) {
    return Array.isArray(obj) || obj.length !== undefined;
}

function toArray(collection) {
    if (!Array.isArray(collection)) {
        var array = [];
        forEach(collection, function (obj) {
            array.push(obj);
        });
        return array;
    } else {
        return collection;
    }
}

function isElement(obj) {
    return obj && obj.nodeType === 1;
}

/**
 * @typedef idHandler
 * @type {object}
 * @property {function} get Gets the resize detector id of the element.
 * @property {function} set Generate and sets the resize detector id of the element.
 */

/**
 * @typedef Options
 * @type {object}
 * @property {boolean} callOnAdd    Determines if listeners should be called when they are getting added.
                                    Default is true. If true, the listener is guaranteed to be called when it has been added.
                                    If false, the listener will not be guarenteed to be called when it has been added (does not prevent it from being called).
 * @property {idHandler} idHandler  A custom id handler that is responsible for generating, setting and retrieving id's for elements.
                                    If not provided, a default id handler will be used.
 * @property {reporter} reporter    A custom reporter that handles reporting logs, warnings and errors.
                                    If not provided, a default id handler will be used.
                                    If set to false, then nothing will be reported.
 * @property {boolean} debug        If set to true, the the system will report debug messages as default for the listenTo method.
 */

/**
 * Creates an element resize detector instance.
 * @public
 * @param {Options?} options Optional global options object that will decide how this instance will work.
 */
module.exports = function(options) {
    options = options || {};

    //idHandler is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var idHandler;

    if (options.idHandler) {
        // To maintain compatability with idHandler.get(element, readonly), make sure to wrap the given idHandler
        // so that readonly flag always is true when it's used here. This may be removed next major version bump.
        idHandler = {
            get: function (element) { return options.idHandler.get(element, true); },
            set: options.idHandler.set
        };
    } else {
        var idGenerator = idGeneratorMaker();
        var defaultIdHandler = idHandlerMaker({
            idGenerator: idGenerator,
            stateHandler: stateHandler
        });
        idHandler = defaultIdHandler;
    }

    //reporter is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var reporter = options.reporter;

    if(!reporter) {
        //If options.reporter is false, then the reporter should be quiet.
        var quiet = reporter === false;
        reporter = reporterMaker(quiet);
    }

    //batchProcessor is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var batchProcessor = getOption(options, "batchProcessor", batchProcessorMaker({ reporter: reporter }));

    //Options to be used as default for the listenTo function.
    var globalOptions = {};
    globalOptions.callOnAdd     = !!getOption(options, "callOnAdd", true);
    globalOptions.debug         = !!getOption(options, "debug", false);

    var eventListenerHandler    = listenerHandlerMaker(idHandler);
    var elementUtils            = elementUtilsMaker({
        stateHandler: stateHandler
    });

    //The detection strategy to be used.
    var detectionStrategy;
    var desiredStrategy = getOption(options, "strategy", "object");
    var importantCssRules = getOption(options, "important", false);
    var strategyOptions = {
        reporter: reporter,
        batchProcessor: batchProcessor,
        stateHandler: stateHandler,
        idHandler: idHandler,
        important: importantCssRules
    };

    if(desiredStrategy === "scroll") {
        if (browserDetector.isLegacyOpera()) {
            reporter.warn("Scroll strategy is not supported on legacy Opera. Changing to object strategy.");
            desiredStrategy = "object";
        } else if (browserDetector.isIE(9)) {
            reporter.warn("Scroll strategy is not supported on IE9. Changing to object strategy.");
            desiredStrategy = "object";
        }
    }

    if(desiredStrategy === "scroll") {
        detectionStrategy = scrollStrategyMaker(strategyOptions);
    } else if(desiredStrategy === "object") {
        detectionStrategy = objectStrategyMaker(strategyOptions);
    } else {
        throw new Error("Invalid strategy name: " + desiredStrategy);
    }

    //Calls can be made to listenTo with elements that are still being installed.
    //Also, same elements can occur in the elements list in the listenTo function.
    //With this map, the ready callbacks can be synchronized between the calls
    //so that the ready callback can always be called when an element is ready - even if
    //it wasn't installed from the function itself.
    var onReadyCallbacks = {};

    /**
     * Makes the given elements resize-detectable and starts listening to resize events on the elements. Calls the event callback for each event for each element.
     * @public
     * @param {Options?} options Optional options object. These options will override the global options. Some options may not be overriden, such as idHandler.
     * @param {element[]|element} elements The given array of elements to detect resize events of. Single element is also valid.
     * @param {function} listener The callback to be executed for each resize event for each element.
     */
    function listenTo(options, elements, listener) {
        function onResizeCallback(element) {
            var listeners = eventListenerHandler.get(element);
            forEach(listeners, function callListenerProxy(listener) {
                listener(element);
            });
        }

        function addListener(callOnAdd, element, listener) {
            eventListenerHandler.add(element, listener);

            if(callOnAdd) {
                listener(element);
            }
        }

        //Options object may be omitted.
        if(!listener) {
            listener = elements;
            elements = options;
            options = {};
        }

        if(!elements) {
            throw new Error("At least one element required.");
        }

        if(!listener) {
            throw new Error("Listener required.");
        }

        if (isElement(elements)) {
            // A single element has been passed in.
            elements = [elements];
        } else if (isCollection(elements)) {
            // Convert collection to array for plugins.
            // TODO: May want to check so that all the elements in the collection are valid elements.
            elements = toArray(elements);
        } else {
            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        }

        var elementsReady = 0;

        var callOnAdd = getOption(options, "callOnAdd", globalOptions.callOnAdd);
        var onReadyCallback = getOption(options, "onReady", function noop() {});
        var debug = getOption(options, "debug", globalOptions.debug);

        forEach(elements, function attachListenerToElement(element) {
            if (!stateHandler.getState(element)) {
                stateHandler.initState(element);
                idHandler.set(element);
            }

            var id = idHandler.get(element);

            debug && reporter.log("Attaching listener to element", id, element);

            if(!elementUtils.isDetectable(element)) {
                debug && reporter.log(id, "Not detectable.");
                if(elementUtils.isBusy(element)) {
                    debug && reporter.log(id, "System busy making it detectable");

                    //The element is being prepared to be detectable. Do not make it detectable.
                    //Just add the listener, because the element will soon be detectable.
                    addListener(callOnAdd, element, listener);
                    onReadyCallbacks[id] = onReadyCallbacks[id] || [];
                    onReadyCallbacks[id].push(function onReady() {
                        elementsReady++;

                        if(elementsReady === elements.length) {
                            onReadyCallback();
                        }
                    });
                    return;
                }

                debug && reporter.log(id, "Making detectable...");
                //The element is not prepared to be detectable, so do prepare it and add a listener to it.
                elementUtils.markBusy(element, true);
                return detectionStrategy.makeDetectable({ debug: debug, important: importantCssRules }, element, function onElementDetectable(element) {
                    debug && reporter.log(id, "onElementDetectable");

                    if (stateHandler.getState(element)) {
                        elementUtils.markAsDetectable(element);
                        elementUtils.markBusy(element, false);
                        detectionStrategy.addListener(element, onResizeCallback);
                        addListener(callOnAdd, element, listener);

                        // Since the element size might have changed since the call to "listenTo", we need to check for this change,
                        // so that a resize event may be emitted.
                        // Having the startSize object is optional (since it does not make sense in some cases such as unrendered elements), so check for its existance before.
                        // Also, check the state existance before since the element may have been uninstalled in the installation process.
                        var state = stateHandler.getState(element);
                        if (state && state.startSize) {
                            var width = element.offsetWidth;
                            var height = element.offsetHeight;
                            if (state.startSize.width !== width || state.startSize.height !== height) {
                                onResizeCallback(element);
                            }
                        }

                        if(onReadyCallbacks[id]) {
                            forEach(onReadyCallbacks[id], function(callback) {
                                callback();
                            });
                        }
                    } else {
                        // The element has been unisntalled before being detectable.
                        debug && reporter.log(id, "Element uninstalled before being detectable.");
                    }

                    delete onReadyCallbacks[id];

                    elementsReady++;
                    if(elementsReady === elements.length) {
                        onReadyCallback();
                    }
                });
            }

            debug && reporter.log(id, "Already detecable, adding listener.");

            //The element has been prepared to be detectable and is ready to be listened to.
            addListener(callOnAdd, element, listener);
            elementsReady++;
        });

        if(elementsReady === elements.length) {
            onReadyCallback();
        }
    }

    function uninstall(elements) {
        if(!elements) {
            return reporter.error("At least one element is required.");
        }

        if (isElement(elements)) {
            // A single element has been passed in.
            elements = [elements];
        } else if (isCollection(elements)) {
            // Convert collection to array for plugins.
            // TODO: May want to check so that all the elements in the collection are valid elements.
            elements = toArray(elements);
        } else {
            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        }

        forEach(elements, function (element) {
            eventListenerHandler.removeAllListeners(element);
            detectionStrategy.uninstall(element);
            stateHandler.cleanState(element);
        });
    }

    function initDocument(targetDocument) {
        detectionStrategy.initDocument && detectionStrategy.initDocument(targetDocument);
    }

    return {
        listenTo: listenTo,
        removeListener: eventListenerHandler.removeListener,
        removeAllListeners: eventListenerHandler.removeAllListeners,
        uninstall: uninstall,
        initDocument: initDocument
    };
};

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}


/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(options) {
    var getState = options.stateHandler.getState;

    /**
     * Tells if the element has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is detectable or not.
     */
    function isDetectable(element) {
        var state = getState(element);
        return state && !!state.isDetectable;
    }

    /**
     * Marks the element that it has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to mark.
     */
    function markAsDetectable(element) {
        getState(element).isDetectable = true;
    }

    /**
     * Tells if the element is busy or not.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is busy or not.
     */
    function isBusy(element) {
        return !!getState(element).busy;
    }

    /**
     * Marks the object is busy and should not be made detectable.
     * @public
     * @param {element} element The element to mark.
     * @param {boolean} busy If the element is busy or not.
     */
    function markBusy(element, busy) {
        getState(element).busy = !!busy;
    }

    return {
        isDetectable: isDetectable,
        markAsDetectable: markAsDetectable,
        isBusy: isBusy,
        markBusy: markBusy
    };
};


/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(idHandler) {
    var eventListeners = {};

    /**
     * Gets all listeners for the given element.
     * @public
     * @param {element} element The element to get all listeners for.
     * @returns All listeners for the given element.
     */
    function getListeners(element) {
        var id = idHandler.get(element);

        if (id === undefined) {
            return [];
        }

        return eventListeners[id] || [];
    }

    /**
     * Stores the given listener for the given element. Will not actually add the listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The callback that the element has added.
     */
    function addListener(element, listener) {
        var id = idHandler.get(element);

        if(!eventListeners[id]) {
            eventListeners[id] = [];
        }

        eventListeners[id].push(listener);
    }

    function removeListener(element, listener) {
        var listeners = getListeners(element);
        for (var i = 0, len = listeners.length; i < len; ++i) {
            if (listeners[i] === listener) {
              listeners.splice(i, 1);
              break;
            }
        }
    }

    function removeAllListeners(element) {
      var listeners = getListeners(element);
      if (!listeners) { return; }
      listeners.length = 0;
    }

    return {
        get: getListeners,
        add: addListener,
        removeListener: removeListener,
        removeAllListeners: removeAllListeners
    };
};


/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function() {
    var idCount = 1;

    /**
     * Generates a new unique id in the context.
     * @public
     * @returns {number} A unique id in the context.
     */
    function generate() {
        return idCount++;
    }

    return {
        generate: generate
    };
};


/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(options) {
    var idGenerator     = options.idGenerator;
    var getState        = options.stateHandler.getState;

    /**
     * Gets the resize detector id of the element.
     * @public
     * @param {element} element The target element to get the id of.
     * @returns {string|number|null} The id of the element. Null if it has no id.
     */
    function getId(element) {
        var state = getState(element);

        if (state && state.id !== undefined) {
            return state.id;
        }

        return null;
    }

    /**
     * Sets the resize detector id of the element. Requires the element to have a resize detector state initialized.
     * @public
     * @param {element} element The target element to set the id of.
     * @returns {string|number|null} The id of the element.
     */
    function setId(element) {
        var state = getState(element);

        if (!state) {
            throw new Error("setId required the element to have a resize detection state.");
        }

        var id = idGenerator.generate();

        state.id = id;

        return id;
    }

    return {
        get: getId,
        set: setId
    };
};


/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global console: false */

/**
 * Reporter that handles the reporting of logs, warnings and errors.
 * @public
 * @param {boolean} quiet Tells if the reporter should be quiet or not.
 */
module.exports = function(quiet) {
    function noop() {
        //Does nothing.
    }

    var reporter = {
        log: noop,
        warn: noop,
        error: noop
    };

    if(!quiet && window.console) {
        var attachFunction = function(reporter, name) {
            //The proxy is needed to be able to call the method with the console context,
            //since we cannot use bind.
            reporter[name] = function reporterProxy() {
                var f = console[name];
                if (f.apply) { //IE9 does not support console.log.apply :)
                    f.apply(console, arguments);
                } else {
                    for (var i = 0; i < arguments.length; i++) {
                        f(arguments[i]);
                    }
                }
            };
        };

        attachFunction(reporter, "log");
        attachFunction(reporter, "warn");
        attachFunction(reporter, "error");
    }

    return reporter;
};

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2270);

module.exports = function batchProcessorMaker(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var asyncProcess    = utils.getOption(options, "async", true);
    var autoProcess     = utils.getOption(options, "auto", true);

    if(autoProcess && !asyncProcess) {
        reporter && reporter.warn("Invalid options combination. auto=true and async=false is invalid. Setting async=true.");
        asyncProcess = true;
    }

    var batch = Batch();
    var asyncFrameHandler;
    var isProcessing = false;

    function addFunction(level, fn) {
        if(!isProcessing && autoProcess && asyncProcess && batch.size() === 0) {
            // Since this is async, it is guaranteed to be executed after that the fn is added to the batch.
            // This needs to be done before, since we're checking the size of the batch to be 0.
            processBatchAsync();
        }

        batch.add(level, fn);
    }

    function processBatch() {
        // Save the current batch, and create a new batch so that incoming functions are not added into the currently processing batch.
        // Continue processing until the top-level batch is empty (functions may be added to the new batch while processing, and so on).
        isProcessing = true;
        while (batch.size()) {
            var processingBatch = batch;
            batch = Batch();
            processingBatch.process();
        }
        isProcessing = false;
    }

    function forceProcessBatch(localAsyncProcess) {
        if (isProcessing) {
            return;
        }

        if(localAsyncProcess === undefined) {
            localAsyncProcess = asyncProcess;
        }

        if(asyncFrameHandler) {
            cancelFrame(asyncFrameHandler);
            asyncFrameHandler = null;
        }

        if(localAsyncProcess) {
            processBatchAsync();
        } else {
            processBatch();
        }
    }

    function processBatchAsync() {
        asyncFrameHandler = requestFrame(processBatch);
    }

    function clearBatch() {
        batch           = {};
        batchSize       = 0;
        topLevel        = 0;
        bottomLevel     = 0;
    }

    function cancelFrame(listener) {
        // var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
        var cancel = clearTimeout;
        return cancel(listener);
    }

    function requestFrame(callback) {
        // var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) { return window.setTimeout(fn, 20); };
        var raf = function(fn) { return setTimeout(fn, 0); };
        return raf(callback);
    }

    return {
        add: addFunction,
        force: forceProcessBatch
    };
};

function Batch() {
    var batch       = {};
    var size        = 0;
    var topLevel    = 0;
    var bottomLevel = 0;

    function add(level, fn) {
        if(!fn) {
            fn = level;
            level = 0;
        }

        if(level > topLevel) {
            topLevel = level;
        } else if(level < bottomLevel) {
            bottomLevel = level;
        }

        if(!batch[level]) {
            batch[level] = [];
        }

        batch[level].push(fn);
        size++;
    }

    function process() {
        for(var level = bottomLevel; level <= topLevel; level++) {
            var fns = batch[level];

            for(var i = 0; i < fns.length; i++) {
                var fn = fns[i];
                fn();
            }
        }
    }

    function getSize() {
        return size;
    }

    return {
        add: add,
        process: process,
        size: getSize
    };
}


/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = module.exports = {};

utils.getOption = getOption;

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}


/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var prop = "_erd";

function initState(element) {
    element[prop] = {};
    return getState(element);
}

function getState(element) {
    return element[prop];
}

function cleanState(element) {
    delete element[prop];
}

module.exports = {
    initState: initState,
    getState: getState,
    cleanState: cleanState
};


/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Resize detection strategy that injects objects to elements in order to detect resize events.
 * Heavily inspired by: http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/
 */



var browserDetector = __webpack_require__(954);

module.exports = function(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var batchProcessor  = options.batchProcessor;
    var getState        = options.stateHandler.getState;

    if(!reporter) {
        throw new Error("Missing required dependency: reporter.");
    }

    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */
    function addListener(element, listener) {
        function listenerProxy() {
            listener(element);
        }

        if(browserDetector.isIE(8)) {
            //IE 8 does not support object, but supports the resize event directly on elements.
            getState(element).object = {
                proxy: listenerProxy
            };
            element.attachEvent("onresize", listenerProxy);
        } else {
            var object = getObject(element);

            if(!object) {
                throw new Error("Element is not detectable by this strategy.");
            }

            object.contentDocument.defaultView.addEventListener("resize", listenerProxy);
        }
    }

    function buildCssTextString(rules) {
        var seperator = options.important ? " !important; " : "; ";

        return (rules.join(seperator) + seperator).trim();
    }

    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */
    function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }

        options = options || {};
        var debug = options.debug;

        function injectObject(element, callback) {
            var OBJECT_STYLE = buildCssTextString(["display: block", "position: absolute", "top: 0", "left: 0", "width: 100%", "height: 100%", "border: none", "padding: 0", "margin: 0", "opacity: 0", "z-index: -1000", "pointer-events: none", "visibility: hidden"]);

            //The target element needs to be positioned (everything except static) so the absolute positioned object will be positioned relative to the target element.

            // Position altering may be performed directly or on object load, depending on if style resolution is possible directly or not.
            var positionCheckPerformed = false;

            // The element may not yet be attached to the DOM, and therefore the style object may be empty in some browsers.
            // Since the style object is a reference, it will be updated as soon as the element is attached to the DOM.
            var style = window.getComputedStyle(element);
            var width = element.offsetWidth;
            var height = element.offsetHeight;

            getState(element).startSize = {
                width: width,
                height: height
            };

            function mutateDom() {
                function alterPositionStyles() {
                    if(style.position === "static") {
                        element.style.setProperty("position", "relative", options.important ? "important" : "");

                        var removeRelativeStyles = function(reporter, element, style, property) {
                            function getNumericalValue(value) {
                                return value.replace(/[^-\d\.]/g, "");
                            }

                            var value = style[property];

                            if(value !== "auto" && getNumericalValue(value) !== "0") {
                                reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                                element.style.setProperty(property, "0", options.important ? "important" : "");
                            }
                        };

                        //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                        //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                        removeRelativeStyles(reporter, element, style, "top");
                        removeRelativeStyles(reporter, element, style, "right");
                        removeRelativeStyles(reporter, element, style, "bottom");
                        removeRelativeStyles(reporter, element, style, "left");
                    }
                }

                function onObjectLoad() {
                    // The object has been loaded, which means that the element now is guaranteed to be attached to the DOM.
                    if (!positionCheckPerformed) {
                        alterPositionStyles();
                    }

                    /*jshint validthis: true */

                    function getDocument(element, callback) {
                        //Opera 12 seem to call the object.onload before the actual document has been created.
                        //So if it is not present, poll it with an timeout until it is present.
                        //TODO: Could maybe be handled better with object.onreadystatechange or similar.
                        if(!element.contentDocument) {
                            var state = getState(element);
                            if (state.checkForObjectDocumentTimeoutId) {
                                window.clearTimeout(state.checkForObjectDocumentTimeoutId);
                            }
                            state.checkForObjectDocumentTimeoutId = setTimeout(function checkForObjectDocument() {
                                state.checkForObjectDocumentTimeoutId = 0;
                                getDocument(element, callback);
                            }, 100);

                            return;
                        }

                        callback(element.contentDocument);
                    }

                    //Mutating the object element here seems to fire another load event.
                    //Mutating the inner document of the object element is fine though.
                    var objectElement = this;

                    //Create the style element to be added to the object.
                    getDocument(objectElement, function onObjectDocumentReady(objectDocument) {
                        //Notify that the element is ready to be listened to.
                        callback(element);
                    });
                }

                // The element may be detached from the DOM, and some browsers does not support style resolving of detached elements.
                // The alterPositionStyles needs to be delayed until we know the element has been attached to the DOM (which we are sure of when the onObjectLoad has been fired), if style resolution is not possible.
                if (style.position !== "") {
                    alterPositionStyles(style);
                    positionCheckPerformed = true;
                }

                //Add an object element as a child to the target element that will be listened to for resize events.
                var object = document.createElement("object");
                object.style.cssText = OBJECT_STYLE;
                object.tabIndex = -1;
                object.type = "text/html";
                object.setAttribute("aria-hidden", "true");
                object.onload = onObjectLoad;

                //Safari: This must occur before adding the object to the DOM.
                //IE: Does not like that this happens before, even if it is also added after.
                if(!browserDetector.isIE()) {
                    object.data = "about:blank";
                }

                if (!getState(element)) {
                    // The element has been uninstalled before the actual loading happened.
                    return;
                }

                element.appendChild(object);
                getState(element).object = object;

                //IE: This must occur after adding the object to the DOM.
                if(browserDetector.isIE()) {
                    object.data = "about:blank";
                }
            }

            if(batchProcessor) {
                batchProcessor.add(mutateDom);
            } else {
                mutateDom();
            }
        }

        if(browserDetector.isIE(8)) {
            //IE 8 does not support objects properly. Luckily they do support the resize event.
            //So do not inject the object and notify that the element is already ready to be listened to.
            //The event handler for the resize event is attached in the utils.addListener instead.
            callback(element);
        } else {
            injectObject(element, callback);
        }
    }

    /**
     * Returns the child object of the target element.
     * @private
     * @param {element} element The target element.
     * @returns The object element of the target.
     */
    function getObject(element) {
        return getState(element).object;
    }

    function uninstall(element) {
        if (!getState(element)) {
            return;
        }

        var object = getObject(element);

        if (!object) {
            return;
        }

        if (browserDetector.isIE(8)) {
            element.detachEvent("onresize", object.proxy);
        } else {
            element.removeChild(object);
        }

        if (getState(element).checkForObjectDocumentTimeoutId) {
            window.clearTimeout(getState(element).checkForObjectDocumentTimeoutId);
        }

        delete getState(element).object;
    }

    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall
    };
};


/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Resize detection strategy that injects divs to elements in order to detect resize events on scroll events.
 * Heavily inspired by: https://github.com/marcj/css-element-queries/blob/master/src/ResizeSensor.js
 */



var forEach = __webpack_require__(953).forEach;

module.exports = function(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var batchProcessor  = options.batchProcessor;
    var getState        = options.stateHandler.getState;
    var hasState        = options.stateHandler.hasState;
    var idHandler       = options.idHandler;

    if (!batchProcessor) {
        throw new Error("Missing required dependency: batchProcessor");
    }

    if (!reporter) {
        throw new Error("Missing required dependency: reporter.");
    }

    //TODO: Could this perhaps be done at installation time?
    var scrollbarSizes = getScrollbarSizes();

    var styleId = "erd_scroll_detection_scrollbar_style";
    var detectionContainerClass = "erd_scroll_detection_container";

    function initDocument(targetDocument) {
        // Inject the scrollbar styling that prevents them from appearing sometimes in Chrome.
        // The injected container needs to have a class, so that it may be styled with CSS (pseudo elements).
        injectScrollStyle(targetDocument, styleId, detectionContainerClass);
    }

    initDocument(window.document);

    function buildCssTextString(rules) {
        var seperator = options.important ? " !important; " : "; ";

        return (rules.join(seperator) + seperator).trim();
    }

    function getScrollbarSizes() {
        var width = 500;
        var height = 500;

        var child = document.createElement("div");
        child.style.cssText = buildCssTextString(["position: absolute", "width: " + width*2 + "px", "height: " + height*2 + "px", "visibility: hidden", "margin: 0", "padding: 0"]);

        var container = document.createElement("div");
        container.style.cssText = buildCssTextString(["position: absolute", "width: " + width + "px", "height: " + height + "px", "overflow: scroll", "visibility: none", "top: " + -width*3 + "px", "left: " + -height*3 + "px", "visibility: hidden", "margin: 0", "padding: 0"]);

        container.appendChild(child);

        document.body.insertBefore(container, document.body.firstChild);

        var widthSize = width - container.clientWidth;
        var heightSize = height - container.clientHeight;

        document.body.removeChild(container);

        return {
            width: widthSize,
            height: heightSize
        };
    }

    function injectScrollStyle(targetDocument, styleId, containerClass) {
        function injectStyle(style, method) {
            method = method || function (element) {
                targetDocument.head.appendChild(element);
            };

            var styleElement = targetDocument.createElement("style");
            styleElement.innerHTML = style;
            styleElement.id = styleId;
            method(styleElement);
            return styleElement;
        }

        if (!targetDocument.getElementById(styleId)) {
            var containerAnimationClass = containerClass + "_animation";
            var containerAnimationActiveClass = containerClass + "_animation_active";
            var style = "/* Created by the element-resize-detector library. */\n";
            style += "." + containerClass + " > div::-webkit-scrollbar { " + buildCssTextString(["display: none"]) + " }\n\n";
            style += "." + containerAnimationActiveClass + " { " + buildCssTextString(["-webkit-animation-duration: 0.1s", "animation-duration: 0.1s", "-webkit-animation-name: " + containerAnimationClass, "animation-name: " + containerAnimationClass]) + " }\n";
            style += "@-webkit-keyframes " + containerAnimationClass +  " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }\n";
            style += "@keyframes " + containerAnimationClass +          " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }";
            injectStyle(style);
        }
    }

    function addAnimationClass(element) {
        element.className += " " + detectionContainerClass + "_animation_active";
    }

    function addEvent(el, name, cb) {
        if (el.addEventListener) {
            el.addEventListener(name, cb);
        } else if(el.attachEvent) {
            el.attachEvent("on" + name, cb);
        } else {
            return reporter.error("[scroll] Don't know how to add event listeners.");
        }
    }

    function removeEvent(el, name, cb) {
        if (el.removeEventListener) {
            el.removeEventListener(name, cb);
        } else if(el.detachEvent) {
            el.detachEvent("on" + name, cb);
        } else {
            return reporter.error("[scroll] Don't know how to remove event listeners.");
        }
    }

    function getExpandElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[0];
    }

    function getShrinkElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[1];
    }

    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */
    function addListener(element, listener) {
        var listeners = getState(element).listeners;

        if (!listeners.push) {
            throw new Error("Cannot add listener to an element that is not detectable.");
        }

        getState(element).listeners.push(listener);
    }

    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */
    function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }

        options = options || {};

        function debug() {
            if (options.debug) {
                var args = Array.prototype.slice.call(arguments);
                args.unshift(idHandler.get(element), "Scroll: ");
                if (reporter.log.apply) {
                    reporter.log.apply(null, args);
                } else {
                    for (var i = 0; i < args.length; i++) {
                        reporter.log(args[i]);
                    }
                }
            }
        }

        function isDetached(element) {
            function isInDocument(element) {
                var isInShadowRoot = element.getRootNode && element.getRootNode().contains(element);
                return element === element.ownerDocument.body || element.ownerDocument.body.contains(element) || isInShadowRoot;
            }

            if (!isInDocument(element)) {
                return true;
            }

            // FireFox returns null style in hidden iframes. See https://github.com/wnr/element-resize-detector/issues/68 and https://bugzilla.mozilla.org/show_bug.cgi?id=795520
            if (window.getComputedStyle(element) === null) {
                return true;
            }

            return false;
        }

        function isUnrendered(element) {
            // Check the absolute positioned container since the top level container is display: inline.
            var container = getState(element).container.childNodes[0];
            var style = window.getComputedStyle(container);
            return !style.width || style.width.indexOf("px") === -1; //Can only compute pixel value when rendered.
        }

        function getStyle() {
            // Some browsers only force layouts when actually reading the style properties of the style object, so make sure that they are all read here,
            // so that the user of the function can be sure that it will perform the layout here, instead of later (important for batching).
            var elementStyle            = window.getComputedStyle(element);
            var style                   = {};
            style.position              = elementStyle.position;
            style.width                 = element.offsetWidth;
            style.height                = element.offsetHeight;
            style.top                   = elementStyle.top;
            style.right                 = elementStyle.right;
            style.bottom                = elementStyle.bottom;
            style.left                  = elementStyle.left;
            style.widthCSS              = elementStyle.width;
            style.heightCSS             = elementStyle.height;
            return style;
        }

        function storeStartSize() {
            var style = getStyle();
            getState(element).startSize = {
                width: style.width,
                height: style.height
            };
            debug("Element start size", getState(element).startSize);
        }

        function initListeners() {
            getState(element).listeners = [];
        }

        function storeStyle() {
            debug("storeStyle invoked.");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            var style = getStyle();
            getState(element).style = style;
        }

        function storeCurrentSize(element, width, height) {
            getState(element).lastWidth = width;
            getState(element).lastHeight  = height;
        }

        function getExpandChildElement(element) {
            return getExpandElement(element).childNodes[0];
        }

        function getWidthOffset() {
            return 2 * scrollbarSizes.width + 1;
        }

        function getHeightOffset() {
            return 2 * scrollbarSizes.height + 1;
        }

        function getExpandWidth(width) {
            return width + 10 + getWidthOffset();
        }

        function getExpandHeight(height) {
            return height + 10 + getHeightOffset();
        }

        function getShrinkWidth(width) {
            return width * 2 + getWidthOffset();
        }

        function getShrinkHeight(height) {
            return height * 2 + getHeightOffset();
        }

        function positionScrollbars(element, width, height) {
            var expand          = getExpandElement(element);
            var shrink          = getShrinkElement(element);
            var expandWidth     = getExpandWidth(width);
            var expandHeight    = getExpandHeight(height);
            var shrinkWidth     = getShrinkWidth(width);
            var shrinkHeight    = getShrinkHeight(height);
            expand.scrollLeft   = expandWidth;
            expand.scrollTop    = expandHeight;
            shrink.scrollLeft   = shrinkWidth;
            shrink.scrollTop    = shrinkHeight;
        }

        function injectContainerElement() {
            var container = getState(element).container;

            if (!container) {
                container                   = document.createElement("div");
                container.className         = detectionContainerClass;
                container.style.cssText     = buildCssTextString(["visibility: hidden", "display: inline", "width: 0px", "height: 0px", "z-index: -1", "overflow: hidden", "margin: 0", "padding: 0"]);
                getState(element).container = container;
                addAnimationClass(container);
                element.appendChild(container);

                var onAnimationStart = function () {
                    getState(element).onRendered && getState(element).onRendered();
                };

                addEvent(container, "animationstart", onAnimationStart);

                // Store the event handler here so that they may be removed when uninstall is called.
                // See uninstall function for an explanation why it is needed.
                getState(element).onAnimationStart = onAnimationStart;
            }

            return container;
        }

        function injectScrollElements() {
            function alterPositionStyles() {
                var style = getState(element).style;

                if(style.position === "static") {
                    element.style.setProperty("position", "relative",options.important ? "important" : "");

                    var removeRelativeStyles = function(reporter, element, style, property) {
                        function getNumericalValue(value) {
                            return value.replace(/[^-\d\.]/g, "");
                        }

                        var value = style[property];

                        if(value !== "auto" && getNumericalValue(value) !== "0") {
                            reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                            element.style[property] = 0;
                        }
                    };

                    //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                    //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                    removeRelativeStyles(reporter, element, style, "top");
                    removeRelativeStyles(reporter, element, style, "right");
                    removeRelativeStyles(reporter, element, style, "bottom");
                    removeRelativeStyles(reporter, element, style, "left");
                }
            }

            function getLeftTopBottomRightCssText(left, top, bottom, right) {
                left = (!left ? "0" : (left + "px"));
                top = (!top ? "0" : (top + "px"));
                bottom = (!bottom ? "0" : (bottom + "px"));
                right = (!right ? "0" : (right + "px"));

                return ["left: " + left, "top: " + top, "right: " + right, "bottom: " + bottom];
            }

            debug("Injecting elements");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            alterPositionStyles();

            var rootContainer = getState(element).container;

            if (!rootContainer) {
                rootContainer = injectContainerElement();
            }

            // Due to this WebKit bug https://bugs.webkit.org/show_bug.cgi?id=80808 (currently fixed in Blink, but still present in WebKit browsers such as Safari),
            // we need to inject two containers, one that is width/height 100% and another that is left/top -1px so that the final container always is 1x1 pixels bigger than
            // the targeted element.
            // When the bug is resolved, "containerContainer" may be removed.

            // The outer container can occasionally be less wide than the targeted when inside inline elements element in WebKit (see https://bugs.webkit.org/show_bug.cgi?id=152980).
            // This should be no problem since the inner container either way makes sure the injected scroll elements are at least 1x1 px.

            var scrollbarWidth          = scrollbarSizes.width;
            var scrollbarHeight         = scrollbarSizes.height;
            var containerContainerStyle = buildCssTextString(["position: absolute", "flex: none", "overflow: hidden", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%", "left: 0px", "top: 0px"]);
            var containerStyle          = buildCssTextString(["position: absolute", "flex: none", "overflow: hidden", "z-index: -1", "visibility: hidden"].concat(getLeftTopBottomRightCssText(-(1 + scrollbarWidth), -(1 + scrollbarHeight), -scrollbarHeight, -scrollbarWidth)));
            var expandStyle             = buildCssTextString(["position: absolute", "flex: none", "overflow: scroll", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%"]);
            var shrinkStyle             = buildCssTextString(["position: absolute", "flex: none", "overflow: scroll", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%"]);
            var expandChildStyle        = buildCssTextString(["position: absolute", "left: 0", "top: 0"]);
            var shrinkChildStyle        = buildCssTextString(["position: absolute", "width: 200%", "height: 200%"]);

            var containerContainer      = document.createElement("div");
            var container               = document.createElement("div");
            var expand                  = document.createElement("div");
            var expandChild             = document.createElement("div");
            var shrink                  = document.createElement("div");
            var shrinkChild             = document.createElement("div");

            // Some browsers choke on the resize system being rtl, so force it to ltr. https://github.com/wnr/element-resize-detector/issues/56
            // However, dir should not be set on the top level container as it alters the dimensions of the target element in some browsers.
            containerContainer.dir              = "ltr";

            containerContainer.style.cssText    = containerContainerStyle;
            containerContainer.className        = detectionContainerClass;
            container.className                 = detectionContainerClass;
            container.style.cssText             = containerStyle;
            expand.style.cssText                = expandStyle;
            expandChild.style.cssText           = expandChildStyle;
            shrink.style.cssText                = shrinkStyle;
            shrinkChild.style.cssText           = shrinkChildStyle;

            expand.appendChild(expandChild);
            shrink.appendChild(shrinkChild);
            container.appendChild(expand);
            container.appendChild(shrink);
            containerContainer.appendChild(container);
            rootContainer.appendChild(containerContainer);

            function onExpandScroll() {
                getState(element).onExpand && getState(element).onExpand();
            }

            function onShrinkScroll() {
                getState(element).onShrink && getState(element).onShrink();
            }

            addEvent(expand, "scroll", onExpandScroll);
            addEvent(shrink, "scroll", onShrinkScroll);

            // Store the event handlers here so that they may be removed when uninstall is called.
            // See uninstall function for an explanation why it is needed.
            getState(element).onExpandScroll = onExpandScroll;
            getState(element).onShrinkScroll = onShrinkScroll;
        }

        function registerListenersAndPositionElements() {
            function updateChildSizes(element, width, height) {
                var expandChild             = getExpandChildElement(element);
                var expandWidth             = getExpandWidth(width);
                var expandHeight            = getExpandHeight(height);
                expandChild.style.setProperty("width", expandWidth + "px", options.important ? "important" : "");
                expandChild.style.setProperty("height", expandHeight + "px", options.important ? "important" : "");
            }

            function updateDetectorElements(done) {
                var width           = element.offsetWidth;
                var height          = element.offsetHeight;

                // Check whether the size has actually changed since last time the algorithm ran. If not, some steps may be skipped.
                var sizeChanged = width !== getState(element).lastWidth || height !== getState(element).lastHeight;

                debug("Storing current size", width, height);

                // Store the size of the element sync here, so that multiple scroll events may be ignored in the event listeners.
                // Otherwise the if-check in handleScroll is useless.
                storeCurrentSize(element, width, height);

                // Since we delay the processing of the batch, there is a risk that uninstall has been called before the batch gets to execute.
                // Since there is no way to cancel the fn executions, we need to add an uninstall guard to all fns of the batch.

                batchProcessor.add(0, function performUpdateChildSizes() {
                    if (!sizeChanged) {
                        return;
                    }

                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }

                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }

                    if (options.debug) {
                        var w = element.offsetWidth;
                        var h = element.offsetHeight;

                        if (w !== width || h !== height) {
                            reporter.warn(idHandler.get(element), "Scroll: Size changed before updating detector elements.");
                        }
                    }

                    updateChildSizes(element, width, height);
                });

                batchProcessor.add(1, function updateScrollbars() {
                    // This function needs to be invoked event though the size is unchanged. The element could have been resized very quickly and then
                    // been restored to the original size, which will have changed the scrollbar positions.

                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }

                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }

                    positionScrollbars(element, width, height);
                });

                if (sizeChanged && done) {
                    batchProcessor.add(2, function () {
                        if (!getState(element)) {
                            debug("Aborting because element has been uninstalled");
                            return;
                        }

                        if (!areElementsInjected()) {
                          debug("Aborting because element container has not been initialized");
                          return;
                        }

                        done();
                    });
                }
            }

            function areElementsInjected() {
                return !!getState(element).container;
            }

            function notifyListenersIfNeeded() {
                function isFirstNotify() {
                    return getState(element).lastNotifiedWidth === undefined;
                }

                debug("notifyListenersIfNeeded invoked");

                var state = getState(element);

                // Don't notify if the current size is the start size, and this is the first notification.
                if (isFirstNotify() && state.lastWidth === state.startSize.width && state.lastHeight === state.startSize.height) {
                    return debug("Not notifying: Size is the same as the start size, and there has been no notification yet.");
                }

                // Don't notify if the size already has been notified.
                if (state.lastWidth === state.lastNotifiedWidth && state.lastHeight === state.lastNotifiedHeight) {
                    return debug("Not notifying: Size already notified");
                }


                debug("Current size not notified, notifying...");
                state.lastNotifiedWidth = state.lastWidth;
                state.lastNotifiedHeight = state.lastHeight;
                forEach(getState(element).listeners, function (listener) {
                    listener(element);
                });
            }

            function handleRender() {
                debug("startanimation triggered.");

                if (isUnrendered(element)) {
                    debug("Ignoring since element is still unrendered...");
                    return;
                }

                debug("Element rendered.");
                var expand = getExpandElement(element);
                var shrink = getShrinkElement(element);
                if (expand.scrollLeft === 0 || expand.scrollTop === 0 || shrink.scrollLeft === 0 || shrink.scrollTop === 0) {
                    debug("Scrollbars out of sync. Updating detector elements...");
                    updateDetectorElements(notifyListenersIfNeeded);
                }
            }

            function handleScroll() {
                debug("Scroll detected.");

                if (isUnrendered(element)) {
                    // Element is still unrendered. Skip this scroll event.
                    debug("Scroll event fired while unrendered. Ignoring...");
                    return;
                }

                updateDetectorElements(notifyListenersIfNeeded);
            }

            debug("registerListenersAndPositionElements invoked.");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            getState(element).onRendered = handleRender;
            getState(element).onExpand = handleScroll;
            getState(element).onShrink = handleScroll;

            var style = getState(element).style;
            updateChildSizes(element, style.width, style.height);
        }

        function finalizeDomMutation() {
            debug("finalizeDomMutation invoked.");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            var style = getState(element).style;
            storeCurrentSize(element, style.width, style.height);
            positionScrollbars(element, style.width, style.height);
        }

        function ready() {
            callback(element);
        }

        function install() {
            debug("Installing...");
            initListeners();
            storeStartSize();

            batchProcessor.add(0, storeStyle);
            batchProcessor.add(1, injectScrollElements);
            batchProcessor.add(2, registerListenersAndPositionElements);
            batchProcessor.add(3, finalizeDomMutation);
            batchProcessor.add(4, ready);
        }

        debug("Making detectable...");

        if (isDetached(element)) {
            debug("Element is detached");

            injectContainerElement();

            debug("Waiting until element is attached...");

            getState(element).onRendered = function () {
                debug("Element is now attached");
                install();
            };
        } else {
            install();
        }
    }

    function uninstall(element) {
        var state = getState(element);

        if (!state) {
            // Uninstall has been called on a non-erd element.
            return;
        }

        // Uninstall may have been called in the following scenarios:
        // (1) Right between the sync code and async batch (here state.busy = true, but nothing have been registered or injected).
        // (2) In the ready callback of the last level of the batch by another element (here, state.busy = true, but all the stuff has been injected).
        // (3) After the installation process (here, state.busy = false and all the stuff has been injected).
        // So to be on the safe side, let's check for each thing before removing.

        // We need to remove the event listeners, because otherwise the event might fire on an uninstall element which results in an error when trying to get the state of the element.
        state.onExpandScroll && removeEvent(getExpandElement(element), "scroll", state.onExpandScroll);
        state.onShrinkScroll && removeEvent(getShrinkElement(element), "scroll", state.onShrinkScroll);
        state.onAnimationStart && removeEvent(state.container, "animationstart", state.onAnimationStart);

        state.container && element.removeChild(state.container);
    }

    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall,
        initDocument: initDocument
    };
};


/***/ }),
/* 2274 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 2275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VendorInvoicesDetails_css__ = __webpack_require__(2276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VendorInvoicesDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__VendorInvoicesDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_vendor_invoices_store_selectors__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_vendor_invoices_AddVendorInvoiceModal__ = __webpack_require__(2277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_vendor_invoices_store_actions__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VendorInvoicesDetails=function(_Component){_inherits(VendorInvoicesDetails,_Component);function VendorInvoicesDetails(props){_classCallCheck(this,VendorInvoicesDetails);var _this=_possibleConstructorReturn(this,(VendorInvoicesDetails.__proto__||Object.getPrototypeOf(VendorInvoicesDetails)).call(this,props));_this.handleDeleteConfirmation=function(result){if(result){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_vendor_invoices_store_actions__["b" /* deleteVendorInvoice */])(_this.state.vendorInvoiceIdToDelete));}_this.setState({showDeleteConfirmation:false,vendorInvoiceIdToDelete:null});};_this.mapInvoices=function(invoices){return invoices.map(function(invoice){return[invoice.task_number,invoice.vendor_name,Object(__WEBPACK_IMPORTED_MODULE_8_services_utils_text_util__["e" /* toUpperFirstLetter */])(invoice.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Date__["a" /* default */],{value:invoice.due_date,format:'LL'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:invoice.cost,format:'$0,0.[00]'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_document_DocumentLink__["a" /* default */],{showIcon:false,url:invoice.document.document.url}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button-blue-grey',label:'Delete',onClick:function onClick(){return _this.setState({showDeleteConfirmation:true,vendorInvoiceIdToDelete:invoice.id});}})];});};_this.state={showDeleteConfirmation:false,vendorInvoiceIdToDelete:null};return _this;}_createClass(VendorInvoicesDetails,[{key:'render',value:function render(){var _this2=this;var headers=['TASK #','VENDOR NAME','STATUS','DUE DATE','AMOUNT','DOC LINK',''];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vendor-invoices-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_table_SimpleTable__["a" /* default */],{className:'vendor-invoice-table',headers:headers,rows:this.mapInvoices(this.props.vendorInvoices),emptyMessage:'No Vendor Invoices'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button-orange buttons-container',label:'Add Invoice',onClick:function onClick(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_vendor_invoices_store_actions__["d" /* setShowAddInvoiceModal */])(true));}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_vendor_invoices_AddVendorInvoiceModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showDeleteConfirmation,message:'Are you sure you want to delete the invoice?',onHide:this.handleDeleteConfirmation}));}}]);return VendorInvoicesDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{vendorInvoices:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_vendor_invoices_store_selectors__["b" /* vendorInvoicesSelector */])(state)};})(VendorInvoicesDetails));

/***/ }),
/* 2276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_work_orders_details_vendor_invoices_store_selectors__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_vendor_invoices_store_actions__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_vendor_invoices_AddVendorInvoiceForm__ = __webpack_require__(2278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddVendorInvoiceModal=function(_Component){_inherits(AddVendorInvoiceModal,_Component);function AddVendorInvoiceModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddVendorInvoiceModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddVendorInvoiceModal.__proto__||Object.getPrototypeOf(AddVendorInvoiceModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleSubmit=function(values){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_vendor_invoices_store_actions__["a" /* createVendorInvoice */])(values.taskId,values));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddVendorInvoiceModal,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_modal_FormModal__["a" /* default */],{title:'Add Invoice',show:this.props.showAddInvoiceModal,onClose:function onClose(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_vendor_invoices_store_actions__["d" /* setShowAddInvoiceModal */])(false));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_vendor_invoices_AddVendorInvoiceForm__["a" /* default */],{tasks:this.props.tasks,onSubmit:this.handleSubmit}));}}]);return AddVendorInvoiceModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(state){return{showAddInvoiceModal:Object(__WEBPACK_IMPORTED_MODULE_2_components_admin_work_orders_details_vendor_invoices_store_selectors__["a" /* showAddInvoiceModalSelector */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state)};})(AddVendorInvoiceModal));

/***/ }),
/* 2278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddVendorInvoiceForm_css__ = __webpack_require__(2279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddVendorInvoiceForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AddVendorInvoiceForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_upload_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_upload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_remove_svg__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_remove_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_images_remove_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_form_FormDropDown__ = __webpack_require__(266);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddVendorInvoiceForm=function(_Component){_inherits(AddVendorInvoiceForm,_Component);function AddVendorInvoiceForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddVendorInvoiceForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddVendorInvoiceForm.__proto__||Object.getPrototypeOf(AddVendorInvoiceForm)).call.apply(_ref,[this].concat(args))),_this),_this.renderDatePicker=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_datetime_picker_DatetimePicker__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));},_this.renderDocument=function(props){if(props.input.value===''){var isValid=!props.meta.error||!props.meta.submitFailed;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx',className:'dropzone-container'+(!isValid?' dropzone-with-error':''),multiple:false,onDrop:function onDrop(files){return props.input.onChange(files[0]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Please drag and drop any file into this area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5_images_upload_svg___default.a,alt:'upload'}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'file-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_document_DocumentLink__["a" /* default */],{file:props.input.value,showIcon:false,showLink:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8_images_remove_svg___default.a,alt:'remove',onClick:function onClick(){return props.input.onChange('');}}));},_this.renderInput=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_input_Input__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddVendorInvoiceForm,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-vendor-invoice-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.props.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Task'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_11_components_shared_form_FormDropDown__["a" /* default */],name:'taskId',options:this.props.tasks.map(function(task){return{value:task.id,label:task.number+' - '+task.name};}),placeholder:'Task'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Vendor Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'vendorName',placeholder:'Vendor Name'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Due Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderDatePicker,isValidDate:__WEBPACK_IMPORTED_MODULE_10_services_utils_date_util__["k" /* todayValidation */],name:'dueDate',placeholder:'Due Date'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'cost',placeholder:'Amount',type:'number'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Document'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderDocument,name:'document',placeholder:'Document'}))),this.props.invalid&&this.props.submitFailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'The outlined inputs should be added in order to add an Invoice.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'submit',value:'Create'})))));}}]);return AddVendorInvoiceForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(values){var errors={};if(!values.taskId){errors.taskId='Required';}if(!values.vendorName){errors.vendorName='Required';}if(!values.dueDate){errors.dueDate='Required';}if(!values.cost){errors.cost='Required';}if(!values.document){errors.document='Required';}return errors;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["f" /* reduxForm */])({form:'AddVendorInvoiceForm',validate:validate})(AddVendorInvoiceForm));

/***/ }),
/* 2279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkOrderDetailsHeader_css__ = __webpack_require__(2281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkOrderDetailsHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__WorkOrderDetailsHeader_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_ClientLinkButtonsContainer__ = __webpack_require__(2282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_chat_bubbles_png__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_chat_bubbles_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_chat_bubbles_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_chat_bubbles_indicator_png__ = __webpack_require__(2285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_chat_bubbles_indicator_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_chat_bubbles_indicator_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_ClientStreamModal__ = __webpack_require__(2286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_work_order_status_enum__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_permissions_util__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_domain_work_order__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_details_DetailsHeader__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_domain_contractor__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_admin_work_orders_details_time_store_selectors__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_admin_work_orders_details_vendor_invoices_store_selectors__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_admin_work_orders_details_receipts_store_selectors__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_admin_work_orders_details_change_order_tasks_store_selectors__ = __webpack_require__(144);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WorkOrderDetailsHeader=function(_Component){_inherits(WorkOrderDetailsHeader,_Component);function WorkOrderDetailsHeader(props){_classCallCheck(this,WorkOrderDetailsHeader);var _this=_possibleConstructorReturn(this,(WorkOrderDetailsHeader.__proto__||Object.getPrototypeOf(WorkOrderDetailsHeader)).call(this,props));_initialiseProps.call(_this);var currentUser=_this.props.currentUser;_this.userIsAdmin=__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["g" /* usersUtil */].isAdmin(currentUser)||__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);_this.userIsContractor=__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);_this.userIsClient=__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["f" /* TYPES */].CLIENT);return _this;}_createClass(WorkOrderDetailsHeader,[{key:'render',value:function render(){var currentWorkOrder=this.props.currentWorkOrder;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'work-order-details-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_details_DetailsHeader__["a" /* default */],{leftHeader:{title:'CLIENT',value:currentWorkOrder.client.company_name},leftHeaderExtraComponents:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_ClientLinkButtonsContainer__["a" /* default */],null),(this.userIsAdmin||this.userIsClient)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'client-stream-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'chat-bubbles',src:__WEBPACK_IMPORTED_MODULE_5_images_chat_bubbles_png___default.a,alt:'chat-bubbles',onClick:this.handleOpenClientStream}),currentWorkOrder.unread_notes&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'chat-bubbles-indicator',src:__WEBPACK_IMPORTED_MODULE_6_images_chat_bubbles_indicator_png___default.a,alt:'chat-bubbles-indicator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_ClientStreamModal__["a" /* default */],null))),rightHeaders:this.getRightHeaders()}));}}]);return WorkOrderDetailsHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);WorkOrderDetailsHeader.propTypes={budget:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),currentUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,currentWorkOrder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,materials:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,quotes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,time:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,vendorInvoices:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,onChatClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};WorkOrderDetailsHeader.defaultProps={budget:null};var _initialiseProps=function _initialiseProps(){var _this2=this;this.handleOpenClientStream=function(event){event.preventDefault();_this2.props.onChatClick(_this2.props.currentWorkOrder.id);};this.completeHeaderForAdmin=function(defaultHeaders,totalCost){var _props=_this2.props,budget=_props.budget,currentUser=_props.currentUser,currentWorkOrder=_props.currentWorkOrder;var result=defaultHeaders.slice();result[0].push({title:'TOTAL COST',value:totalCost!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:totalCost,format:'$0,0'}):'TBD'});if(__WEBPACK_IMPORTED_MODULE_11_services_utils_permissions_util__["a" /* PermissionsUtil */].adminUserCanSeeMoney(currentUser)||__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_15_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR)){result[0].push({title:'VARIANCE',value:__WEBPACK_IMPORTED_MODULE_12_domain_work_order__["a" /* WorkOrder */].getVariance(Object.assign({},currentWorkOrder,{budget:budget}),'N/A')});}return result;};this.completeHeaderForClient=function(defaultHeaders,totalCost){var result=defaultHeaders.slice();result[0].push({title:'TOTAL COST',value:totalCost!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:totalCost,format:'$0,0'}):'TBD'});return result;};this.completeHeaderForContractor=function(defaultHeaders){var _props2=_this2.props,currentWorkOrder=_props2.currentWorkOrder,quotes=_props2.quotes,materials=_props2.materials,time=_props2.time,vendorInvoices=_props2.vendorInvoices,changeOrderTasks=_props2.changeOrderTasks;var result=defaultHeaders.slice();if(__WEBPACK_IMPORTED_MODULE_12_domain_work_order__["a" /* WorkOrder */].isStatusFulFilled(currentWorkOrder,__WEBPACK_IMPORTED_MODULE_8_services_utils_work_order_status_enum__["b" /* WorkOrderStatusKeys */].IN_PROGRESS)){// Create new line of header
result.push([{title:'QUOTES COST',value:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:__WEBPACK_IMPORTED_MODULE_19_domain_contractor__["a" /* Contractor */].getTotalCost(quotes,changeOrderTasks,true),format:'$0,0'})},{title:'PROFIT',value:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:__WEBPACK_IMPORTED_MODULE_19_domain_contractor__["a" /* Contractor */].getNetCost(quotes,changeOrderTasks,materials,time,vendorInvoices),format:'$0,0'})},{title:'VARIANCE PERCENTAGE',value:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:__WEBPACK_IMPORTED_MODULE_19_domain_contractor__["a" /* Contractor */].getVariancePercentage(quotes,changeOrderTasks,materials,time,vendorInvoices),format:'0%'})}]);}else{result[0].push({title:'TOTAL COST',value:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:__WEBPACK_IMPORTED_MODULE_19_domain_contractor__["a" /* Contractor */].getTotalCost(quotes),format:'$0,0'})});}return result;};this.getRightHeaders=function(){var currentWorkOrder=_this2.props.currentWorkOrder;var startDate=__WEBPACK_IMPORTED_MODULE_12_domain_work_order__["a" /* WorkOrder */].getStartDate(currentWorkOrder);var completionDate=__WEBPACK_IMPORTED_MODULE_12_domain_work_order__["a" /* WorkOrder */].getCompletionDate(currentWorkOrder);var totalCost=__WEBPACK_IMPORTED_MODULE_12_domain_work_order__["a" /* WorkOrder */].getTotalCost(currentWorkOrder);var defaultHeaders=[[{title:'STATUS',value:__WEBPACK_IMPORTED_MODULE_8_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(currentWorkOrder.status).label},{title:'START',value:startDate!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Date__["a" /* default */],{value:startDate,format:'M/D/YYYY'}):'TBD'},{title:'COMPLETION',value:completionDate!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Date__["a" /* default */],{value:completionDate,format:'M/D/YYYY'}):'TBD'}]];// Complete headers for different users
var headers=void 0;if(_this2.userIsAdmin){headers=_this2.completeHeaderForAdmin(defaultHeaders,totalCost);}else if(_this2.userIsClient){headers=_this2.completeHeaderForClient(defaultHeaders,totalCost);}else{headers=_this2.completeHeaderForContractor(defaultHeaders);}return headers;};};var mapStateToProps=function mapStateToProps(state){return{budget:Object(__WEBPACK_IMPORTED_MODULE_17_selectors_admin_work_orders_details_details__["a" /* getBudget */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_16_selectors_authentication__["d" /* getCurrentUser */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_14_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),materials:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_work_orders_details_receipts_store_selectors__["b" /* receiptsSelector */])(state),quotes:Object(__WEBPACK_IMPORTED_MODULE_17_selectors_admin_work_orders_details_details__["m" /* getQuotes */])(state),time:Object(__WEBPACK_IMPORTED_MODULE_20_components_admin_work_orders_details_time_store_selectors__["d" /* timeSelector */])(state),vendorInvoices:Object(__WEBPACK_IMPORTED_MODULE_21_components_admin_work_orders_details_vendor_invoices_store_selectors__["b" /* vendorInvoicesSelector */])(state),changeOrderTasks:Object(__WEBPACK_IMPORTED_MODULE_23_components_admin_work_orders_details_change_order_tasks_store_selectors__["a" /* getChangeOrderTasks */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChatClick:function onChatClick(workOrderId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_actions_admin_work_orders_details_details__["_5" /* setShowClientStreamModalRequest */])(workOrderId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(WorkOrderDetailsHeader));

/***/ }),
/* 2281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_proposal_approval__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_sort_util__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_details_budget__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_admin_invoices_invoices__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_work_orders_details_ClientLinkButtons__ = __webpack_require__(2284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_work_orders_details_change_orders_store_actions__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_work_orders_details_change_orders_store_selectors__ = __webpack_require__(203);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClientLinkButtonsContainer=function(_Component){_inherits(ClientLinkButtonsContainer,_Component);function ClientLinkButtonsContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientLinkButtonsContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientLinkButtonsContainer.__proto__||Object.getPrototypeOf(ClientLinkButtonsContainer)).call.apply(_ref,[this].concat(args))),_this),_this.handleViewBudget=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_details_budget__["i" /* loadEmailBudgetDataRequest */])(_this.props.currentWorkOrder.number,_this.props.currentWorkOrder.name,_this.props.currentWorkOrder.building.location,_this.props.currentWorkOrder.client.id)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_details_budget__["k" /* openApproveReviewModal */])(_this.props.budget));}});},_this.handleViewInvoice=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_invoices_invoices__["g" /* goToInvoice */])(_this.props.currentWorkOrder.invoice.id));},_this.handleViewQuote=function(){if(_this.props.changeOrders.length===0){var sortedProposals=_this.props.proposals.slice();// copy slice before sorting
Object(__WEBPACK_IMPORTED_MODULE_6_services_utils_sort_util__["a" /* sortByAttribute */])(sortedProposals,'number',false);var lastProposal=sortedProposals.shift();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_work_orders_details_proposal__["j" /* loadEmailProposalDataRequest */])(lastProposal.number,_this.props.currentWorkOrder.number,_this.props.currentWorkOrder.name,_this.props.currentWorkOrder.building.location,_this.props.currentWorkOrder.client.id,_this.props.currentWorkOrder.client.company_name)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_details_proposal_approval__["d" /* selectProposal */])(lastProposal));}});}else{var changeOrder=_this.props.changeOrders[_this.props.changeOrders.length-1];_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_work_orders_details_change_orders_store_actions__["k" /* loadEmailChangeOrderDataRequest */])(changeOrder.number,_this.props.currentWorkOrder.number,_this.props.currentWorkOrder.name,_this.props.currentWorkOrder.building.location,_this.props.currentWorkOrder.client.id)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_work_orders_details_change_orders_store_actions__["o" /* selectChangeOrder */])(changeOrder));}});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientLinkButtonsContainer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_admin_work_orders_details_ClientLinkButtons__["a" /* ClientLinkButtons */],{budget:this.props.budget,proposals:this.props.proposals,user:this.props.currentUser,workOrder:this.props.currentWorkOrder,onBudgetClick:this.handleViewBudget,onInvoiceClick:this.handleViewInvoice,onQuoteClick:this.handleViewQuote});}}]);return ClientLinkButtonsContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{budget:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_work_orders_details_details__["a" /* getBudget */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_authentication__["d" /* getCurrentUser */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),proposals:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_work_orders_details_details__["l" /* getProposals */])(state),changeOrders:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_work_orders_details_change_orders_store_selectors__["a" /* getChangeOrders */])(state)};})(ClientLinkButtonsContainer));

/***/ }),
/* 2283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invoicesApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InvoicesApi=function(_BaseApi){_inherits(InvoicesApi,_BaseApi);function InvoicesApi(){_classCallCheck(this,InvoicesApi);return _possibleConstructorReturn(this,(InvoicesApi.__proto__||Object.getPrototypeOf(InvoicesApi)).apply(this,arguments));}_createClass(InvoicesApi,[{key:'getInvoices',value:function getInvoices(page,status){var filter='';if(status){filter+='&'+status+'=true';}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/invoices?page='+(page!==undefined?page:1)+filter).then(function(response){return{ok:true,invoices:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getInvoice',value:function getInvoice(invoiceId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/invoices/'+invoiceId).then(function(response){return{ok:true,invoice:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'deleteInvoice',value:function deleteInvoice(invoiceId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/invoices/'+invoiceId).then(function(){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'sendInvoice',value:function sendInvoice(invoiceId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/invoices/'+invoiceId+'/send_to_client').then(function(response){return{ok:true,invoice:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'markInvoiceAsPaid',value:function markInvoiceAsPaid(invoiceId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/invoices/'+invoiceId+'/paid').then(function(response){return{ok:true,invoice:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createInvoiceData',value:function createInvoiceData(form){var miscItemsIdToDelete=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var data={invoice:{adjustment:form.adjustment,adjustment_desc:form.adjustmentDesc,due_date:form.dueDate,send_to:form.emails.map(function(value){return value.email;}),line_items_attributes:Object.keys(form.amountsByLineItemId).map(function(key){return{id:key,cost:form.amountsByLineItemId[key]};})}};if(form.miscCosts.length>0||miscItemsIdToDelete.length>0){var attributes=[];form.miscCosts.forEach(function(misc){var data={cost:misc.cost,description:misc.description};if(misc.id>0){data['id']=misc.id;}attributes.push(data);});miscItemsIdToDelete.forEach(function(idToDelete){attributes.push({id:idToDelete,_destroy:true});});data['invoice']['misc_items_attributes']=attributes;}return data;}},{key:'updateInvoice',value:function updateInvoice(invoiceId,form,miscItemsIdToDelete){var data=this.createInvoiceData(form,miscItemsIdToDelete);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/invoices/'+invoiceId,data).then(function(response){return{ok:true,invoice:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getAsPdf',value:function getAsPdf(invoiceId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/invoices/'+invoiceId+'/print',{responseType:'blob'}).then(function(response){return{ok:true,pdf:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'sendEmail',value:function sendEmail(invoiceId,emails,subject,message){var data={invoice:{send_to:emails,subject:subject,message:message}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/invoices/'+invoiceId+'/email',data).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return InvoicesApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var invoicesApi=new InvoicesApi();

/***/ }),
/* 2284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ClientLinkButtons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
function ClientLinkButtons(props){var handleViewBudget=function handleViewBudget(props){if(props.onBudgetClick){props.onBudgetClick();}};var handleViewInvoice=function handleViewInvoice(props){if(props.onInvoiceClick){props.onInvoiceClick();}};var handleViewQuote=function handleViewQuote(props){if(props.onQuoteClick){props.onQuoteClick();}};var content=null;if(__WEBPACK_IMPORTED_MODULE_1_services_utils_users_util__["g" /* usersUtil */].hasType(props.user,__WEBPACK_IMPORTED_MODULE_1_services_utils_users_util__["f" /* TYPES */].CLIENT)){if(props.workOrder.invoice!==null){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'View Invoice',onClick:function onClick(){return handleViewInvoice(props);}});}else if(props.proposals.length>0){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'View Quote',onClick:function onClick(){return handleViewQuote(props);}});}else if(props.budget!==null){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'View Estimate',onClick:function onClick(){return handleViewBudget(props);}});}}return content;}ClientLinkButtons.propTypes={budget:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape(),proposals:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,user:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape().isRequired,workOrder:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape().isRequired,onBudgetClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onInvoiceClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onQuoteClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};ClientLinkButtons.defaultProps={budget:null,proposals:[]};

/***/ }),
/* 2285 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAS1JREFUOBGlVD1OgkEQnRl6hdraIwAVQoKFRhNLT+CpPAGliUYLSPipkCNYW6P27DBvklmI+qEsW3w7Ozvv7X4z85bpl/Fx0ewT0y0pnSnpCUKY+N0+U/MN6i+L0XcYbzs+r9unaZXuSbW77f9hM0+kJnfHj/O32MtEX1etTkr6oKqN2Nw1M/NShG+Onl5niHMi3ERXaf5fkjgAZFyTNm4mcOJ39iUBDhhPhdmMxFpCh9goHVaIc/HqlDIEziosKHGsi2fjkOiTYhIDgsOTfQhJYMU7NlaFMziQ7GkhfgMzDiR7sPEUWsbhnb28bI7/1FfVGaa7xvOi58mGANHuVbFVftebYbHvRK4VE+A+ZE5imHgBcvmhYgiQ7KpVN8h+i0FsKB/+/IzkIDNKHrY132BwyOIRa3cAAAAASUVORK5CYII="

/***/ }),
/* 2286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ClientStreamModal_css__ = __webpack_require__(2287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ClientStreamModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ClientStreamModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_chat_Chat__ = __webpack_require__(315);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClientStreamModal=function(_Component){_inherits(ClientStreamModal,_Component);function ClientStreamModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientStreamModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientStreamModal.__proto__||Object.getPrototypeOf(ClientStreamModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleLoadNotes=function(){return _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["K" /* loadWorkOrderNotesRequest */])(_this.props.currentWorkOrder.id));},_this.handleAddNote=function(note){return _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["f" /* addWorkOrderNoteRequest */])(_this.props.currentWorkOrder.id,note));},_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["_4" /* setShowClientStreamModal */])(false));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientStreamModal,[{key:'render',value:function render(){return this.props.showClientStreamModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{className:'client-stream-modal',show:this.props.showClientStreamModal,title:'Stream / WO #'+this.props.currentWorkOrder.number+ClientStreamModal.getWorkOrderName(this.props.currentWorkOrder),onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_chat_Chat__["a" /* default */],{notes:this.props.workOrderNotes,loadChat:this.handleLoadNotes,handleSubmit:this.handleAddNote}))):null;}}],[{key:'getWorkOrderName',value:function getWorkOrderName(workOrder){return workOrder.name!==null?': '+workOrder.name:'';}}]);return ClientStreamModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),showClientStreamModal:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_details__["t" /* getShowClientStreamModal */])(state),workOrderNotes:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_details__["I" /* getWorkOrderNotes */])(state)};})(ClientStreamModal));

/***/ }),
/* 2287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkOrderDetailsInfo_css__ = __webpack_require__(2290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkOrderDetailsInfo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__WorkOrderDetailsInfo_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_details_DetailsInfoItem__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_document_BuildingDocumentsViewer__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_details_DetailsFilesContainer__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_upload_png__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_upload_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_images_upload_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_files_FilesUploadedViewer__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_details_DetailsInfo__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_admin_work_orders_details_time_store_selectors__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_admin_work_orders_details_vendor_invoices_store_selectors__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_admin_work_orders_details_receipts_store_selectors__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_shared_NoteEditor__ = __webpack_require__(956);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WorkOrderDetailsInfo=function(_Component){_inherits(WorkOrderDetailsInfo,_Component);function WorkOrderDetailsInfo(props){_classCallCheck(this,WorkOrderDetailsInfo);var _this=_possibleConstructorReturn(this,(WorkOrderDetailsInfo.__proto__||Object.getPrototypeOf(WorkOrderDetailsInfo)).call(this,props));_this.handleDocumentsDrop=function(documents){_this.props.onDocumentsDrop(_this.props.currentWorkOrder.id,documents);};_this.handleDocumentRemove=function(documentId){_this.props.onDocumentRemove(_this.props.currentWorkOrder.id,documentId);};_this.handleWorkOrderNoteChange=function(value){_this.props.onNoteChange(value);};_this.handleWorkOrderNoteEdit=function(){_this.props.onNoteEdit(true);};_this.handleWorkOrderNoteReminderChange=function(value){_this.props.onNoteReminderChange(value);};_this.handleWorkOrderNoteSave=function(){_this.props.onNoteSave(_this.props.currentWorkOrder.id,_this.props.workOrderNoteValue,_this.props.workOrderNoteReminderValue);};_this.renderCostsSummary=function(){var _this$props=_this.props,materials=_this$props.materials,time=_this$props.time,vendorInvoices=_this$props.vendorInvoices;var show=materials.length>0||time.length>0||vendorInvoices.length>0;if(show){var materialsTotal=materials.reduce(function(total,material){return total+__WEBPACK_IMPORTED_MODULE_17_numeral___default()(material.cost).value();},0);var timeTotal=time.reduce(function(total,entry){return total+(entry.cost!==null?__WEBPACK_IMPORTED_MODULE_17_numeral___default()(entry.cost).value():0);},0);var vendorInvoicesTotal=vendorInvoices.reduce(function(total,vendorInvoice){return total+__WEBPACK_IMPORTED_MODULE_17_numeral___default()(vendorInvoice.cost).value();},0);var lines=[];var total=0;if(materialsTotal>0){lines.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'costs-summary-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Materials:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_shared_text_Number__["a" /* default */],{value:materialsTotal,format:'$0,0.[00]'}))));total+=materialsTotal;}if(timeTotal>0){lines.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'costs-summary-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Labor:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_shared_text_Number__["a" /* default */],{value:timeTotal,format:'$0,0.[00]'}))));total+=timeTotal;}if(vendorInvoicesTotal>0){lines.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'costs-summary-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Vendor:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_shared_text_Number__["a" /* default */],{value:vendorInvoicesTotal,format:'$0,0.[00]'}))));total+=vendorInvoicesTotal;}if(total>0){lines.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'costs-summary-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'costs-summary-total'},'Total:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_shared_text_Number__["a" /* default */],{value:total,format:'$0,0.[00]'}))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:lines,title:'COSTS SUMMARY'});}return null;};var currentUser=_this.props.currentUser;_this.userIsAdmin=__WEBPACK_IMPORTED_MODULE_13_services_utils_users_util__["g" /* usersUtil */].isAdmin(currentUser)||__WEBPACK_IMPORTED_MODULE_13_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_13_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);_this.userIsContractor=__WEBPACK_IMPORTED_MODULE_13_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_13_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);return _this;}_createClass(WorkOrderDetailsInfo,[{key:'render',value:function render(){var _props=this.props,currentWorkOrder=_props.currentWorkOrder,general_contractor=_props.currentWorkOrder.general_contractor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'work-order-details-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_details_DetailsInfo__["a" /* default */],{itemsLines:[[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[currentWorkOrder.building.location.street_address_1,currentWorkOrder.building.location.city+', '+currentWorkOrder.building.location.state+' '+currentWorkOrder.building.location.zip,currentWorkOrder.building.name!==''&&currentWorkOrder.building.name!==null?currentWorkOrder.building.name:''],title:'BUILDING'}),general_contractor&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[general_contractor.name],title:'GENERAL CONTRACTOR'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:currentWorkOrder.working_hours,title:'AVAILABLE WORKING HOURS'})].concat(// Show subcontractors only if available in WO
currentWorkOrder.propietary_sub_contractors!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:currentWorkOrder.propietary_sub_contractors.length>0?currentWorkOrder.propietary_sub_contractors.map(function(element){return element.name;}):[currentWorkOrder.dont_know_subcons?"Don't know":'No'],title:'PROPRIETARY SUBCONTRACTORS'}):[]).concat(this.userIsAdmin?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'work-order-note-editor-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_shared_NoteEditor__["a" /* default */],{canEdit:this.userIsAdmin,edit:this.props.workOrderNoteEdit,label:'notes',reminderLabel:'reminder date',saving:this.props.workOrderNoteSaving,value:this.props.workOrderNoteValue,reminderValue:this.props.workOrderNoteReminderValue,reminderOriginalValue:currentWorkOrder.note_reminder_date,onEdit:this.handleWorkOrderNoteEdit,onSave:this.handleWorkOrderNoteSave,onValueChange:this.handleWorkOrderNoteChange,onReminderValueChange:this.handleWorkOrderNoteReminderChange}))):[]).concat(this.userIsContractor?this.renderCostsSummary():[])],rightContainer:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'requirements-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_document_BuildingDocumentsViewer__["a" /* default */],{documents:currentWorkOrder.building.documents}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_details_DetailsFilesContainer__["a" /* default */],{header:'My Documents'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropzone-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx',className:'building-files-dropzone',onDrop:this.handleDocumentsDrop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Please drag and drop any file into this area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8_images_upload_png___default.a,alt:'remove'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'files-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_files_FilesUploadedViewer__["a" /* default */],{documents:currentWorkOrder.documents,showLink:true,onDocumentRemove:this.handleDocumentRemove}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_details_DetailsFilesContainer__["a" /* default */],{header:'Other Documents',show:currentWorkOrder.other_documents.length>0},currentWorkOrder.other_documents.map(function(document,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_document_DocumentLink__["a" /* default */],{key:index,url:document.document.url});})))}));}}]);return WorkOrderDetailsInfo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);WorkOrderDetailsInfo.propTypes={currentWorkOrder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,materials:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,time:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,vendorInvoices:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,workOrderNoteEdit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,workOrderNoteSaving:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,workOrderNoteValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,workOrderNoteReminderValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,onDocumentsDrop:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onDocumentRemove:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onNoteChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onNoteEdit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onNoteReminderChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onNoteSave:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};WorkOrderDetailsInfo.defaultProps={workOrderNoteReminderValue:null};var mapStateToProps=function mapStateToProps(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_14_selectors_authentication__["d" /* getCurrentUser */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),materials:Object(__WEBPACK_IMPORTED_MODULE_21_components_admin_work_orders_details_receipts_store_selectors__["b" /* receiptsSelector */])(state),time:Object(__WEBPACK_IMPORTED_MODULE_19_components_admin_work_orders_details_time_store_selectors__["d" /* timeSelector */])(state),vendorInvoices:Object(__WEBPACK_IMPORTED_MODULE_20_components_admin_work_orders_details_vendor_invoices_store_selectors__["b" /* vendorInvoicesSelector */])(state),workOrderNoteEdit:Object(__WEBPACK_IMPORTED_MODULE_15_selectors_admin_work_orders_details_details__["E" /* getWorkOrderNoteEdit */])(state),workOrderNoteSaving:Object(__WEBPACK_IMPORTED_MODULE_15_selectors_admin_work_orders_details_details__["G" /* getWorkOrderNoteSaving */])(state),workOrderNoteValue:Object(__WEBPACK_IMPORTED_MODULE_15_selectors_admin_work_orders_details_details__["H" /* getWorkOrderNoteValue */])(state),workOrderNoteReminderValue:Object(__WEBPACK_IMPORTED_MODULE_15_selectors_admin_work_orders_details_details__["F" /* getWorkOrderNoteReminderValue */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onDocumentsDrop:function onDocumentsDrop(workOrderId,documents){dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_actions_admin_work_orders_details_details__["_22" /* uploadDocumentsRequest */])(workOrderId,documents));},onDocumentRemove:function onDocumentRemove(workOrderId,documentId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_actions_admin_work_orders_details_details__["O" /* removeDocumentRequest */])(workOrderId,documentId));},onNoteChange:function onNoteChange(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_actions_admin_work_orders_details_details__["l" /* changeWorkOrderNote */])(value));},onNoteEdit:function onNoteEdit(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_actions_admin_work_orders_details_details__["z" /* editWorkOrderNote */])(value));},onNoteReminderChange:function onNoteReminderChange(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_actions_admin_work_orders_details_details__["m" /* changeWorkOrderNoteReminder */])(value));},onNoteSave:function onNoteSave(workOrderId,noteValue,noteReminerValue){dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_actions_admin_work_orders_details_details__["U" /* saveWorkOrderNoteRequest */])(workOrderId,noteValue,noteReminerValue));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(WorkOrderDetailsInfo));

/***/ }),
/* 2290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2291 */
/***/ (function(module, exports) {

module.exports = { prefix: 'fas', iconName: 'exclamation-triangle', icon: [576, 512, [], "f071", "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"] };

/***/ }),
/* 2292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransferWorkOrder_css__ = __webpack_require__(2296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransferWorkOrder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TransferWorkOrder_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_transfer_store_actions__ = __webpack_require__(2297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_transfer_AssignModal__ = __webpack_require__(2298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_transfer_SelectClientModal__ = __webpack_require__(2300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_transfer_store_selectors__ = __webpack_require__(2302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_modal_MessageModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_api_clients_api__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TransferWorkOrder=function(_Component){_inherits(TransferWorkOrder,_Component);function TransferWorkOrder(props){_classCallCheck(this,TransferWorkOrder);var _this=_possibleConstructorReturn(this,(TransferWorkOrder.__proto__||Object.getPrototypeOf(TransferWorkOrder)).call(this,props));_this.handleAssign=function(){var showAssignModal=_this.state.showAssignModal;_this.setState({showAssignModal:!showAssignModal});};_this.handleAssignConfirm=function(gcId){var _this$props=_this.props,currentWorkOrder=_this$props.currentWorkOrder,onAssignConfirm=_this$props.onAssignConfirm;_this.setState({showAssignModal:false});onAssignConfirm(currentWorkOrder.id,gcId);};_this.handleConfirm=function(){_this.props.onClientConfirm(_this.props.currentWorkOrder.id,_this.props.selectedClient.value);};_this.handleMessageModalHide=function(){_this.props.onFinish();};_this.handleDelete=function(){_this.setState({showDeleteConfirmation:true});};_this.handleDeleteConfirmationModalHide=function(confirmation){if(confirmation){_this.props.onDeleteConfirm(_this.props.currentWorkOrder.id);}_this.setState({showDeleteConfirmation:false});};_this.state={showAssignModal:false,showDeleteConfirmation:false};return _this;}_createClass(TransferWorkOrder,[{key:'render',value:function render(){var _props=this.props,currentWorkOrder=_props.currentWorkOrder,general_contractor=_props.currentWorkOrder.general_contractor,selectedClient=_props.selectedClient,showModal=_props.showModal,onClientSelect=_props.onClientSelect,onTransferClick=_props.onTransferClick;var showAssignModal=this.state.showAssignModal;var message='';if(selectedClient!==null){message='Work Order #'+currentWorkOrder.number+' has been transferred to '+selectedClient.label;}var assignInitialValues={selectedGc:general_contractor&&{value:general_contractor.id,label:general_contractor.name}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transfer-work-order'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-white',label:'Assign',onClick:this.handleAssign}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Transfer',onClick:function onClick(){return onTransferClick(true);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:'Delete',onClick:this.handleDelete}),showAssignModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_transfer_AssignModal__["a" /* default */],{initialValues:assignInitialValues,show:showAssignModal,onClose:this.handleAssign,onConfirm:this.handleAssignConfirm}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_transfer_SelectClientModal__["a" /* default */],{loadOptions:function loadOptions(value){return TransferWorkOrder.loadClients(value,currentWorkOrder.client.id);},selectedClient:selectedClient,show:showModal,onClientSelect:onClientSelect,onClose:function onClose(){return onTransferClick(false);},onConfirm:this.handleConfirm}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_modal_MessageModal__["a" /* default */],{show:this.props.showMessageModal,message:message,onHide:this.handleMessageModalHide}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showDeleteConfirmation,message:'Are you sure you want to delete this Work Order?',onHide:this.handleDeleteConfirmationModalHide}));}}],[{key:'loadClients',value:function loadClients(value,currentClientId){return __WEBPACK_IMPORTED_MODULE_11_services_api_clients_api__["a" /* clientsApi */].searchByCompanyName(value).then(function(response){if(response.ok){return{ok:true,options:response.clients.filter(function(client){return client.id!==currentClientId;}).map(function(element){return{value:element.id,label:element.company_name};})};}else{return{ok:false,errors:response.errors};}});}}]);return TransferWorkOrder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TransferWorkOrder.propTypes={currentWorkOrder:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({}).isRequired,selectedClient:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({}),showMessageModal:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired,showModal:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired,onClientConfirm:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,onClientSelect:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,onFinish:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,onAssignConfirm:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,onTransferClick:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,onDeleteConfirm:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired};TransferWorkOrder.defaultProps={selectedClient:null};function mapStateToProps(state){return{currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),selectedClient:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_transfer_store_selectors__["a" /* selectedClientSelector */])(state),showMessageModal:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_transfer_store_selectors__["b" /* showMessageModalSelector */])(state),showModal:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_transfer_store_selectors__["c" /* showModalSelector */])(state)};}var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAssignConfirm:function onAssignConfirm(workOrderId,gcId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_transfer_store_actions__["e" /* updateGc */])(workOrderId,gcId));},onClientConfirm:function onClientConfirm(workOrderId,clientId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_transfer_store_actions__["a" /* changeWorkOrderClient */])(workOrderId,clientId));},onClientSelect:function onClientSelect(client){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_transfer_store_actions__["c" /* selectClient */])(client));},onFinish:function onFinish(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_transfer_store_actions__["b" /* finishTransfer */])());},onTransferClick:function onTransferClick(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_work_orders_details_transfer_store_actions__["d" /* setShowModal */])(value));},onDeleteConfirm:function onDeleteConfirm(workOrderId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_work_orders__["d" /* cancelWorkOrderRequest */])(workOrderId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TransferWorkOrder));

/***/ }),
/* 2296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = updateGc;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeWorkOrderClient;
/* harmony export (immutable) */ __webpack_exports__["b"] = finishTransfer;
/* harmony export (immutable) */ __webpack_exports__["c"] = selectClient;
/* harmony export (immutable) */ __webpack_exports__["d"] = setShowModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_transfer_store_action_types__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_work_orders_api__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(45);
function updateGc(workOrderId,gcId){return function(dispatch){var values={general_contractor_id:gcId};return __WEBPACK_IMPORTED_MODULE_1_services_api_work_orders_api__["b" /* workOrdersApi */].updateWorkOrder(workOrderId,values).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_work_orders__["D" /* updateWorkOrderAttribute */])(response.workOrder,'general_contractor'));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function changeWorkOrderClient(workOrderId,clientId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_work_orders_api__["b" /* workOrdersApi */].changeClient(workOrderId,clientId).then(function(response){if(response.ok){dispatch(setShowModal(false));// hide client selection modal
dispatch(setShowMessageModal(true));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function finishTransfer(){return function(dispatch){dispatch(setShowMessageModal(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_work_orders__["c" /* baseRoutePath */]));};}function selectClient(client){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_transfer_store_action_types__["a" /* TRANSFER_WORK_ORDER_CLIENT_SELECT */],payload:client};}function setShowMessageModal(value){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_transfer_store_action_types__["b" /* TRANSFER_WORK_ORDER_MESSAGE_MODAL_SHOW */],payload:value};}function setShowModal(value){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_transfer_store_action_types__["c" /* TRANSFER_WORK_ORDER_MODAL_SHOW */],payload:value};}

/***/ }),
/* 2298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AssignModal_css__ = __webpack_require__(2299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AssignModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AssignModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_dropdown_SearchableDropDownPaginated__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_api_general_contractors_api__ = __webpack_require__(587);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AssignModal=function(_Component){_inherits(AssignModal,_Component);function AssignModal(props){_classCallCheck(this,AssignModal);var _this=_possibleConstructorReturn(this,(AssignModal.__proto__||Object.getPrototypeOf(AssignModal)).call(this,props));_this.loadGcs=function(input,page){return __WEBPACK_IMPORTED_MODULE_7_services_api_general_contractors_api__["a" /* generalContractorsApi */].getGeneralContractors(page,null,input).then(function(response){return{ok:true,options:response.generalContractors.data.map(function(gc){return{value:gc.id,label:gc.name};}),hasMore:true};});};_this.handleSelect=function(gc){_this.setState({selectedGc:gc});};_this.handleConfirmation=function(confirmation){if(confirmation){var onConfirm=_this.props.onConfirm;var selectedGc=_this.state.selectedGc;onConfirm(selectedGc?selectedGc.value:'');}_this.setState({showConfirmationModal:false});};_this.state={selectedGc:props.initialValues.selectedGc,showConfirmationModal:false};return _this;}_createClass(AssignModal,[{key:'render',value:function render(){var _this2=this;var _props=this.props,show=_props.show,onClose=_props.onClose;var _state=this.state,selectedGc=_state.selectedGc,showConfirmationModal=_state.showConfirmationModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_modal_FormModal__["a" /* default */],{className:'assign-select-gc-modal',show:show,title:'Select General Contractor',onClose:onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'drop-down-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_dropdown_SearchableDropDownPaginated__["a" /* default */],{clearable:true,value:selectedGc,loadOptions:function loadOptions(input,page){return _this2.loadGcs(input,page);},onChange:this.handleSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Confirm',onClick:function onClick(){return _this2.setState({showConfirmationModal:true});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_modal_ConfirmationModal__["a" /* default */],{show:showConfirmationModal,message:'Are you sure?',onHide:this.handleConfirmation}));}}]);return AssignModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AssignModal.propTypes={initialValues:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),show:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onConfirm:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};AssignModal.defaultProps={initialValues:{}};/* harmony default export */ __webpack_exports__["a"] = (AssignModal);

/***/ }),
/* 2299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectClientModal_css__ = __webpack_require__(2301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectClientModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SelectClientModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_dropdown_SearchableDropDown__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectClientModal=function(_Component){_inherits(SelectClientModal,_Component);function SelectClientModal(props){_classCallCheck(this,SelectClientModal);var _this=_possibleConstructorReturn(this,(SelectClientModal.__proto__||Object.getPrototypeOf(SelectClientModal)).call(this,props));_this.handleConfirmation=function(result){if(result){_this.props.onConfirm();}_this.setState({showConfirmationModal:false});};_this.handleSelect=function(client){_this.props.onClientSelect(client);};_this.state={showConfirmationModal:false};return _this;}_createClass(SelectClientModal,[{key:'render',value:function render(){var _this2=this;var _props=this.props,_loadOptions=_props.loadOptions,selectedClient=_props.selectedClient,show=_props.show,_onClose=_props.onClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_modal_FormModal__["a" /* default */],{className:'transfer-select-client-modal',show:show,title:'Select Client',onClose:function onClose(){return _onClose();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'drop-down-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_dropdown_SearchableDropDown__["a" /* default */],{autoload:false,className:'searchable-container',loadOptions:function loadOptions(value){return _loadOptions(value);},placeholder:'Search a new Client',value:selectedClient!==null?selectedClient.value:null,onChange:this.handleSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:selectedClient===null,label:'Confirm',onClick:function onClick(){return _this2.setState({showConfirmationModal:true});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showConfirmationModal,message:'Are you sure?',onHide:this.handleConfirmation}));}}]);return SelectClientModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelectClientModal.propTypes={loadOptions:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,selectedClient:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),show:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onClientSelect:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onConfirm:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};SelectClientModal.defaultProps={selectedClient:null,show:false};/* harmony default export */ __webpack_exports__["a"] = (SelectClientModal);

/***/ }),
/* 2301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectedClientSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return showMessageModalSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return showModalSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var selectedClientSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.transfer.ui.selectedClient;},function(selectedClient){return selectedClient;});var showMessageModalSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.transfer.ui.showMessageModal;},function(showMessageModal){return showMessageModal;});var showModalSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.transfer.ui.showModal;},function(showModal){return showModal;});

/***/ }),
/* 2303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnticipatedCostReport_css__ = __webpack_require__(2304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnticipatedCostReport_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AnticipatedCostReport_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnticipatedCostReportTable__ = __webpack_require__(2305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_anticipated_cost_report_store_selectors__ = __webpack_require__(2307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_anticipated_cost_report_store_actions__ = __webpack_require__(2308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_upload_png__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_upload_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_images_upload_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_files_FilesUploadedViewer__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_work_orders_details_change_orders_store_selectors__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_work_orders_details_change_order_tasks_store_selectors__ = __webpack_require__(144);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AnticipatedCostReport=function(_Component){_inherits(AnticipatedCostReport,_Component);function AnticipatedCostReport(props){_classCallCheck(this,AnticipatedCostReport);var _this=_possibleConstructorReturn(this,(AnticipatedCostReport.__proto__||Object.getPrototypeOf(AnticipatedCostReport)).call(this,props));_this.handleDocumentsDrop=function(documents){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_anticipated_cost_report_store_actions__["g" /* updateWorkOrderAcrDocs */])(_this.props.workOrder.id,documents));};_this.handleDocumentRemove=function(documentId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_anticipated_cost_report_store_actions__["g" /* updateWorkOrderAcrDocs */])(_this.props.workOrder.id,null,documentId));};_this.onValueChange=function(quoteId,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_anticipated_cost_report_store_actions__["f" /* setMiscCost */])(quoteId,value));};_this.onEdit=function(quoteId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_anticipated_cost_report_store_actions__["e" /* setEdit */])(quoteId));};_this.onSave=function(quoteId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_anticipated_cost_report_store_actions__["b" /* saveQuote */])(quoteId,{miscCost:_this.props.miscCosts[quoteId]}));};_this.onAdditionalCostValueChange=function(value,attr){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_anticipated_cost_report_store_actions__["c" /* setAdditionalCost */])(value,attr));};_this.onAdditionalCostEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_anticipated_cost_report_store_actions__["d" /* setAdditionalCostEdit */])());};_this.onAdditionalCostSave=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_anticipated_cost_report_store_actions__["a" /* saveProposal */])(_this.props.workOrder.approved_proposal.id,_this.props.proposal));};props.quotes.forEach(function(quote){if(!props.miscCosts[quote.id]){props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_anticipated_cost_report_store_actions__["f" /* setMiscCost */])(quote.id,quote.misc_cost||''));}});if(!props.proposal.additionalCost){props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_anticipated_cost_report_store_actions__["c" /* setAdditionalCost */])(props.workOrder.approved_proposal.cli_additional_cost||'','additionalCost'));}if(!props.proposal.additionalCostDesc){props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_anticipated_cost_report_store_actions__["c" /* setAdditionalCost */])(props.workOrder.approved_proposal.cli_additional_cost_desc||'','additionalCostDesc'));}return _this;}_createClass(AnticipatedCostReport,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'anticipated-cost-report'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acr-documents-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropzone-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx',className:'building-files-dropzone',onDrop:this.handleDocumentsDrop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Please drag and drop any file into this area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9_images_upload_png___default.a,alt:'remove'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'files-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_files_FilesUploadedViewer__["a" /* default */],{documents:this.props.workOrder.acr_documents,showLink:true,onDocumentRemove:this.handleDocumentRemove}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AnticipatedCostReportTable__["a" /* default */],{workOrder:this.props.workOrder,proposals:this.props.proposals,quotes:this.props.quotes,changeOrders:this.props.changeOrders,changeOrderTasks:this.props.changeOrderTasks,miscCosts:this.props.miscCosts,edit:this.props.edit,saving:this.props.saving,onValueChange:this.onValueChange,onEdit:this.onEdit,onSave:this.onSave,proposal:this.props.proposal,additionalCostEdit:this.props.additionalCostEdit,additionalCostSaving:this.props.additionalCostSaving,onAdditionalCostValueChange:this.onAdditionalCostValueChange,onAdditionalCostEdit:this.onAdditionalCostEdit,onAdditionalCostSave:this.onAdditionalCostSave}));}}]);return AnticipatedCostReport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{workOrder:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),quotes:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_details__["m" /* getQuotes */])(state),proposals:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_details_details__["l" /* getProposals */])(state),changeOrders:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_work_orders_details_change_orders_store_selectors__["a" /* getChangeOrders */])(state),changeOrderTasks:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_work_orders_details_change_order_tasks_store_selectors__["a" /* getChangeOrderTasks */])(state),miscCosts:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_anticipated_cost_report_store_selectors__["d" /* getMiscCosts */])(state),edit:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_anticipated_cost_report_store_selectors__["c" /* getEdit */])(state),saving:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_anticipated_cost_report_store_selectors__["f" /* getSaving */])(state),proposal:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_anticipated_cost_report_store_selectors__["e" /* getProposal */])(state),additionalCostEdit:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_anticipated_cost_report_store_selectors__["a" /* getAdditionalCostEdit */])(state),additionalCostSaving:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_anticipated_cost_report_store_selectors__["b" /* getAdditionalCostSaving */])(state)};})(AnticipatedCostReport));

/***/ }),
/* 2304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnticipatedCostReportTable_css__ = __webpack_require__(2306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnticipatedCostReportTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AnticipatedCostReportTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_input_TextArea__ = __webpack_require__(62);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AnticipatedCostReportTable=function(_Component){_inherits(AnticipatedCostReportTable,_Component);function AnticipatedCostReportTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AnticipatedCostReportTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AnticipatedCostReportTable.__proto__||Object.getPrototypeOf(AnticipatedCostReportTable)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(quoteId){if(_this.props.edit[quoteId]){if(_this.props.onSave){_this.props.onSave(quoteId);}}else{if(_this.props.onEdit){_this.props.onEdit(quoteId);}}},_this.handleChange=function(quoteId,value){if(_this.props.onValueChange){_this.props.onValueChange(quoteId,value);}},_this.handleAdditionalCostChange=function(value,attr){if(_this.props.onAdditionalCostValueChange){_this.props.onAdditionalCostValueChange(value,attr);}},_this.handleAdditionalCostClick=function(){if(_this.props.additionalCostEdit){if(_this.props.onAdditionalCostSave){_this.props.onAdditionalCostSave();}}else{if(_this.props.onAdditionalCostEdit){_this.props.onAdditionalCostEdit();}}},_this.getCoOriginalCosts=function(taskId){var coOriginalCosts=0;var changeOrders=_this.props.changeOrders;_this.props.changeOrderTasks.filter(function(cot){return cot.status==='approved'&&cot.task_id===taskId;}).forEach(function(cot){coOriginalCosts+=__WEBPACK_IMPORTED_MODULE_5_numeral___default()(cot.change_order_quote.estimate).value()+__WEBPACK_IMPORTED_MODULE_5_numeral___default()(cot.change_order_quote.value).value();changeOrders.filter(function(co){return co.status==='approved';}).forEach(function(co){co.change_order_proposal_tasks.filter(function(copt){return copt.change_order_task_id===cot.id;}).forEach(function(copt){coOriginalCosts+=__WEBPACK_IMPORTED_MODULE_5_numeral___default()(copt.markup).value()+__WEBPACK_IMPORTED_MODULE_5_numeral___default()(copt.fee).value()+__WEBPACK_IMPORTED_MODULE_5_numeral___default()(copt.insurance).value();});});});return coOriginalCosts;},_this.getCoCommittedCosts=function(taskId){return _this.props.changeOrderTasks.filter(function(cot){return cot.task_id===taskId&&(cot.status==='approved'||cot.status==='acr');}).reduce(function(total,cot){total+=__WEBPACK_IMPORTED_MODULE_5_numeral___default()(cot.change_order_quote.estimate).value();return total;},0);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AnticipatedCostReportTable,[{key:'render',value:function render(){this.rows=this.createRows();var headers=['TASK #','TRADE','ORIGINAL','CHANGE ORDER','COMMITTED','PENDING','VARIANCE ($)','VARIANCE (%)',''];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'anticipated-cost-report-table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_table_SimpleTable__["a" /* default */],{className:'anticipated-cost-report-table',headers:headers,rows:this.rows,emptyMessage:'No Quotes'}));}},{key:'createRows',value:function createRows(){var _this2=this;var rows=[];var totalOriginal=0;var totalChangeOrder=0;var totalClientCost=0;var totalCommitted=0;var totalPending=0;var totalVariance=0;this.props.quotes.filter(function(q){return q.status==='approved';}).sort(function(quote1,quote2){return quote1.task.number-quote2.task.number;}).forEach(function(quote){var task=quote.task;rows.push({id:'t'+task.id,// prefix with t to avoid same id with quote
data:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h2'},'Task # ',task.number),'','','','','','']});var proposal=_this2.props.proposals.find(function(p){return p.id===_this2.props.workOrder.approved_proposal.id;});var proposalQuote=proposal.proposal_quotes.find(function(pq){return pq.quote_id===quote.id;});var clientCost=__WEBPACK_IMPORTED_MODULE_5_numeral___default()(quote.estimate).value()+__WEBPACK_IMPORTED_MODULE_5_numeral___default()(quote.value).value()+__WEBPACK_IMPORTED_MODULE_5_numeral___default()(proposalQuote.fee).value()+__WEBPACK_IMPORTED_MODULE_5_numeral___default()(proposalQuote.insurance).value()+__WEBPACK_IMPORTED_MODULE_5_numeral___default()(proposalQuote.markup).value();var changeOrderCost=_this2.getCoOriginalCosts(task.id);var clientTotalCost=clientCost+changeOrderCost;var committedCost=__WEBPACK_IMPORTED_MODULE_5_numeral___default()(quote.estimate).value()+_this2.getCoCommittedCosts(task.id);var miscCost=_this2.props.miscCosts[quote.id]||0;var varianceCost=clientTotalCost-committedCost-miscCost;var variance=varianceCost*100/clientTotalCost;var buttonLabel=void 0;if(_this2.props.edit[quote.id]){if(_this2.props.saving[quote.id]){buttonLabel='Saving...';}else{buttonLabel='Save';}}else{buttonLabel='Edit';}totalOriginal+=__WEBPACK_IMPORTED_MODULE_5_numeral___default()(clientCost).value();totalChangeOrder+=changeOrderCost;totalClientCost=totalOriginal+totalChangeOrder;totalCommitted+=__WEBPACK_IMPORTED_MODULE_5_numeral___default()(committedCost).value();totalPending+=__WEBPACK_IMPORTED_MODULE_5_numeral___default()(miscCost).value();totalVariance=totalClientCost-totalCommitted-totalPending;var data=[quote.contractor_name,task.trade.label,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:clientCost,format:'$0,0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:changeOrderCost,format:'$0,0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:committedCost,format:'$0,0'}),_this2.props.edit[quote.id]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__["a" /* default */],{type:'number',readOnly:_this2.props.saving[quote.id],value:_this2.props.miscCosts[quote.id],onChange:function onChange(value){return _this2.handleChange(quote.id,value);}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:miscCost,format:'$0,0.00'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:varianceCost,format:'$0,0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:variance,format:'0,0'}),'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:_this2.props.saving[quote.id],label:buttonLabel,onClick:function onClick(){return _this2.handleClick(quote.id);}})];rows.push({id:quote.id,data:data});});var buttonLabel=void 0;if(this.props.additionalCostEdit){if(this.props.additionalCostSaving){buttonLabel='Saving...';}else{buttonLabel='Save';}}else{buttonLabel='Edit';}rows.push({id:'Totals',className:'totals',data:['','',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h2'},'Totals'),'','','','','','']});rows.push({id:'TotalsValues',className:'totals',data:['','',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:totalOriginal,format:'$0,0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:totalChangeOrder,format:'$0,0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:totalCommitted,format:'$0,0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:totalPending,format:'$0,0.00'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:totalVariance,format:'$0,0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:totalVariance*100/totalClientCost,format:'0,0'}),'%'),'']});rows.push({id:'AdditionalCost',data:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h2'},'Additional Costs'),'','','','','','','','']});rows.push({id:'AdditionalCostValues',data:[this.props.additionalCostEdit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_TextArea__["a" /* default */],{readOnly:this.props.additionalCostSaving,placeholder:'Description',value:this.props.proposal.additionalCostDesc,onChange:function onChange(value){return _this2.handleAdditionalCostChange(value,'additionalCostDesc');}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.proposal.additionalCostDesc||'TBD'),this.props.additionalCostEdit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__["a" /* default */],{type:'number',readOnly:this.props.additionalCostSaving,value:this.props.proposal.additionalCost,onChange:function onChange(value){return _this2.handleAdditionalCostChange(value,'additionalCost');}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:this.props.proposal.additionalCost,format:'$0,0.00'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:this.props.additionalCostSaving,label:buttonLabel,onClick:this.handleAdditionalCostClick}),'','','','','','','']});return rows;}}]);return AnticipatedCostReportTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AnticipatedCostReportTable.propTypes={workOrder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,proposals:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,quotes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,changeOrderTasks:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,changeOrders:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,miscCosts:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,edit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,saving:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,onValueChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onEdit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onSave:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,proposal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,additionalCostEdit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,additionalCostSaving:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onAdditionalCostValueChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onAdditionalCostEdit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onAdditionalCostSave:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (AnticipatedCostReportTable);

/***/ }),
/* 2306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getMiscCosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getSaving; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAdditionalCostEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAdditionalCostSaving; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getMiscCosts=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.anticipatedCostReport.data.miscCosts;},function(miscCosts){return miscCosts;});var getEdit=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.anticipatedCostReport.ui.edit;},function(edit){return edit;});var getSaving=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.anticipatedCostReport.ui.saving;},function(saving){return saving;});var getProposal=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.anticipatedCostReport.data.proposal;},function(proposal){return proposal;});var getAdditionalCostEdit=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.anticipatedCostReport.ui.additionalCostEdit;},function(additionalCostEdit){return additionalCostEdit;});var getAdditionalCostSaving=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.workOrders.scenes.details.scenes.anticipatedCostReport.ui.additionalCostSaving;},function(additionalCostSaving){return additionalCostSaving;});

/***/ }),
/* 2308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = setMiscCost;
/* unused harmony export miscCostSet */
/* harmony export (immutable) */ __webpack_exports__["e"] = setEdit;
/* unused harmony export editSet */
/* unused harmony export savingSet */
/* harmony export (immutable) */ __webpack_exports__["b"] = saveQuote;
/* harmony export (immutable) */ __webpack_exports__["c"] = setAdditionalCost;
/* unused harmony export additionalCostSet */
/* harmony export (immutable) */ __webpack_exports__["d"] = setAdditionalCostEdit;
/* unused harmony export editAdditionalCostSet */
/* unused harmony export additionalCostSavingSet */
/* harmony export (immutable) */ __webpack_exports__["a"] = saveProposal;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateWorkOrderAcrDocs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_anticipated_cost_report_store_action_types__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_quotes_api__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_proposals_api__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_work_orders_api__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
function setMiscCost(quoteId,value){return function(dispatch){dispatch(miscCostSet(quoteId,value));};}function miscCostSet(quoteId,value){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_anticipated_cost_report_store_action_types__["e" /* ACR_MISC_COST_SET */],payload:{quoteId:quoteId,value:value}};}function setEdit(quoteId){return function(dispatch){dispatch(editSet(quoteId));};}function editSet(quoteId){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_anticipated_cost_report_store_action_types__["d" /* ACR_EDIT_SET */],payload:quoteId};}function savingSet(quoteId){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_anticipated_cost_report_store_action_types__["f" /* ACR_SAVING_SET */],payload:quoteId};}function saveQuote(quoteId,values){return function(dispatch){dispatch(savingSet(quoteId));return __WEBPACK_IMPORTED_MODULE_2_services_api_quotes_api__["a" /* quotesApi */].updateQuote(quoteId,values).then(function(response){dispatch(editSet(quoteId));dispatch(savingSet(quoteId));if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function setAdditionalCost(value,attr){return function(dispatch){dispatch(additionalCostSet(value,attr));};}function additionalCostSet(value,attr){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_anticipated_cost_report_store_action_types__["c" /* ACR_ADDITIONAL_COST_SET */],payload:{value:value,attr:attr}};}function setAdditionalCostEdit(){return function(dispatch){dispatch(editAdditionalCostSet());};}function editAdditionalCostSet(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_anticipated_cost_report_store_action_types__["a" /* ACR_ADDITIONAL_COST_EDIT_SET */]};}function additionalCostSavingSet(){return{type:__WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_anticipated_cost_report_store_action_types__["b" /* ACR_ADDITIONAL_COST_SAVING_SET */]};}function saveProposal(proposalId,values){return function(dispatch){dispatch(additionalCostSavingSet());return __WEBPACK_IMPORTED_MODULE_3_services_api_proposals_api__["a" /* proposalsApi */].update(proposalId,values).then(function(response){dispatch(editAdditionalCostSet());dispatch(additionalCostSavingSet());if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function updateWorkOrderAcrDocs(workOrderId,docs,docToDestroyId){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_api_work_orders_api__["b" /* workOrdersApi */].updateWorkOrderAcrDocs(workOrderId,docs,docToDestroyId).then(function(response){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_work_orders__["D" /* updateWorkOrderAttribute */])(response.workOrder,'acr_documents'));if(!response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}

/***/ }),
/* 2309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ChangeOrderApprovalModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangeOrderApprovalModal_css__ = __webpack_require__(2310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangeOrderApprovalModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ChangeOrderApprovalModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_change_orders_store_selectors__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_change_order_tasks_store_selectors__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_orders_store_actions__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_proposals_TasksReviewTable__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_work_orders_details_proposals_CostsDatesProposal__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_utils_permissions_util__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_domain_proposal_status_enum__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_actions_admin_work_orders_details_qualifications__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_work_orders_details_qualifications_QualificationsContainer__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_admin_work_orders_details_change_orders_ChangeOrderEmailModal__ = __webpack_require__(2311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_shared_modal_MessageModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_shared_pdf_viewer_PdfViewer__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_images_print_svg__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_images_print_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_images_print_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_images_mail_svg__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_images_mail_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_images_mail_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeOrderApprovalModal=function(_Component){_inherits(ChangeOrderApprovalModal,_Component);function ChangeOrderApprovalModal(props){_classCallCheck(this,ChangeOrderApprovalModal);var _this=_possibleConstructorReturn(this,(ChangeOrderApprovalModal.__proto__||Object.getPrototypeOf(ChangeOrderApprovalModal)).call(this,props));_this.handleClose=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_orders_store_actions__["d" /* closeChangeOrderApprovalModal */])());};_this.handleApprove=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_orders_store_actions__["b" /* approveChangeOrderRequest */])(_this.props.selectedChangeOrderId));};_this.handleCloseSuccessModal=function(){var userIsAdmin=__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasRole(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);var userIsContractor=__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);var contractorUserCanSeeMoney=__WEBPACK_IMPORTED_MODULE_12_services_utils_permissions_util__["a" /* PermissionsUtil */].contractorUserCanSeeMoney(_this.props.currentUser);_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_orders_store_actions__["g" /* closeSuccessModal */])());_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_orders_store_actions__["d" /* closeChangeOrderApprovalModal */])());_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_details__["L" /* loadWorkOrderRequest */])(_this.props.currentWorkOrder.id,userIsAdmin,userIsContractor,contractorUserCanSeeMoney));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_details__["W" /* selectNavigationBar */])(_this.props.currentWorkOrder.id,1));};_this.handleChangeOrderPrint=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_orders_store_actions__["m" /* printChangeOrder */])(_this.props.selectedChangeOrderId));};_this.handlePdfViewerClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_orders_store_actions__["f" /* closePdfViewer */])());};_this.handleChangeOrderEmail=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_orders_store_actions__["s" /* setShowEmailModal */])(true));};_this.handleWithdraw=function(){_this.setState({showWithdrawConfirmation:true});};_this.handleWithdrawConfirmation=function(response){_this.setState({showWithdrawConfirmation:false});if(response){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_work_orders_details_change_orders_store_actions__["x" /* withdrawChangeOrderRequest */])(_this.props.selectedChangeOrderId));}};_this.previousCost=function(){var prevCost=__WEBPACK_IMPORTED_MODULE_26_numeral___default()(_this.props.currentWorkOrder.approved_proposal.cost).value();var coId=_this.props.selectedChangeOrderId;_this.props.changeOrders.filter(function(co){return __WEBPACK_IMPORTED_MODULE_15_domain_proposal_status_enum__["a" /* ProposalStatus */].APPROVED.equals(co.status);}).forEach(function(co){if(co.id!==coId&&co.id<coId){prevCost+=__WEBPACK_IMPORTED_MODULE_26_numeral___default()(co.cost).value();}});return prevCost;};_this.selectedChangeOrder=props.changeOrders.find(function(element){return element.id===props.selectedChangeOrderId;});_this.state={showWithdrawConfirmation:false};return _this;}_createClass(ChangeOrderApprovalModal,[{key:'componentDidMount',value:function componentDidMount(){if(this.selectedChangeOrder.qualifications.length>0&&this.selectedChangeOrder.change_order_qualifications.length>0){var selectedQualificationsById=this.selectedChangeOrder.change_order_qualifications.reduce(function(accumulator,currentValue){accumulator[currentValue.qualification_id]={id:currentValue.qualification_id,// value=0 because we only need the label
option:currentValue.option!==null?{value:0,label:currentValue.option}:null};return accumulator;},{});this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_actions_admin_work_orders_details_qualifications__["i" /* setSelectedQualificationsById */])(selectedQualificationsById));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_actions_admin_work_orders_details_qualifications__["e" /* loadQualificationsSuccess */])(this.selectedChangeOrder.qualifications));}else{this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_actions_admin_work_orders_details_qualifications__["i" /* setSelectedQualificationsById */])({}));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_actions_admin_work_orders_details_qualifications__["e" /* loadQualificationsSuccess */])([]));}}},{key:'getMaterialLeadTime',value:function getMaterialLeadTime(mDays){if(mDays){return __WEBPACK_IMPORTED_MODULE_26_numeral___default()(mDays).value()+' '+(mDays>1?'days':'day');}return'N/A';}},{key:'getCost',value:function getCost(quote,proposalTask){return __WEBPACK_IMPORTED_MODULE_26_numeral___default()(quote.estimate).value()+__WEBPACK_IMPORTED_MODULE_26_numeral___default()(quote.value).value()+__WEBPACK_IMPORTED_MODULE_26_numeral___default()(proposalTask.markup).value()+__WEBPACK_IMPORTED_MODULE_26_numeral___default()(proposalTask.fee).value()+__WEBPACK_IMPORTED_MODULE_26_numeral___default()(proposalTask.insurance).value();}},{key:'render',value:function render(){var _this2=this;var successMessage='Thank you. The Change Order approval was submitted to Spackle.';var titlePostfix=void 0;if(__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["f" /* TYPES */].CLIENT)){titlePostfix=__WEBPACK_IMPORTED_MODULE_25_moment___default()(this.selectedChangeOrder.created_at).format('LL');}else{titlePostfix=Object(__WEBPACK_IMPORTED_MODULE_14_services_utils_text_util__["e" /* toUpperFirstLetter */])(this.selectedChangeOrder.status);}var title='Change Order (WO #'+this.props.currentWorkOrder.number+' '+ChangeOrderApprovalModal.getWorkOrderName(this.props.currentWorkOrder)+') - '+titlePostfix;var values=[];this.props.changeOrderTasks.sort(function(cot1,cot2){return cot1.task_id-cot2.task_id;}).forEach(function(changeOrderTask){var changeOrderProposalTask=_this2.selectedChangeOrder.change_order_proposal_tasks.find(function(copt){return copt.change_order_task_id===changeOrderTask.id;});if(changeOrderProposalTask){var changeOrderQuote=changeOrderTask.change_order_quote;var task=_this2.props.tasks.find(function(t){return t.id===changeOrderTask.task_id;});var value={id:changeOrderTask.id,number:task.number,details:task.name!==null?task.name:task.trade.label,materialLeadTime:_this2.getMaterialLeadTime(changeOrderQuote.material_lead_days),cost:_this2.getCost(changeOrderQuote,changeOrderProposalTask)};values.push(value);}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_modal_FormModal__["a" /* default */],{className:'change-order-modal change-order-approval-modal',show:this.props.selectedChangeOrderId!==null,title:title,subTitle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2'},'Spackle is pleased to submit change order #',this.props.selectedChangeOrderNumber,' for:'),onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'change-order-approval-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_admin_work_orders_details_proposals_TasksReviewTable__["a" /* default */],{values:values}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'costs-dates-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_shared_button_Button__["a" /* default */],{className:'button-white',icon:__WEBPACK_IMPORTED_MODULE_24_images_mail_svg___default.a,label:'Email',onClick:this.handleChangeOrderEmail}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_shared_button_Button__["a" /* default */],{className:'button-white print-button',icon:__WEBPACK_IMPORTED_MODULE_23_images_print_svg___default.a,label:'Print',onClick:this.handleChangeOrderPrint})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_admin_work_orders_details_proposals_CostsDatesProposal__["a" /* default */],{completionDate:{value:this.selectedChangeOrder.completion_date},startDate:this.selectedChangeOrder.start_date,isChangeOrder:true,previousCost:this.previousCost(),total:__WEBPACK_IMPORTED_MODULE_26_numeral___default()(this.selectedChangeOrder.cost).value()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_admin_work_orders_details_qualifications_QualificationsContainer__["a" /* default */],{readOnly:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'change-order-days-sign'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-regular'},'4130 Cahuenga Blvd, Suite 206'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-regular'},'Los Angeles, CA 91602'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-regular'},'Phone: (310) 848-3078')),__WEBPACK_IMPORTED_MODULE_15_domain_proposal_status_enum__["a" /* ProposalStatus */].WAITING.equals(this.selectedChangeOrder.status)&&__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["f" /* TYPES */].CLIENT)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Approve',onClick:this.handleApprove})),__WEBPACK_IMPORTED_MODULE_15_domain_proposal_status_enum__["a" /* ProposalStatus */].WAITING.equals(this.selectedChangeOrder.status)&&(__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasRole(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:'Withdraw',onClick:this.handleWithdraw}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Approve',onClick:this.handleApprove})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_shared_modal_MessageModal__["a" /* default */],{show:this.props.showSuccessMessage,message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,successMessage),onHide:this.handleCloseSuccessModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:this.props.pdf,type:'blob'},show:this.props.showPdfViewer,onClose:this.handlePdfViewerClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_admin_work_orders_details_change_orders_ChangeOrderEmailModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showWithdrawConfirmation,message:'Are you sure',onHide:this.handleWithdrawConfirmation}));}}],[{key:'getWorkOrderName',value:function getWorkOrderName(workOrder){return workOrder.name!==null?': '+workOrder.name:'';}}]);return ChangeOrderApprovalModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_authentication__["d" /* getCurrentUser */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_work_orders__["i" /* getTasks */])(state),changeOrders:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_change_orders_store_selectors__["a" /* getChangeOrders */])(state),changeOrderTasks:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_work_orders_details_change_order_tasks_store_selectors__["a" /* getChangeOrderTasks */])(state),selectedChangeOrderId:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_change_orders_store_selectors__["g" /* getSelectedChangeOrderId */])(state),selectedChangeOrderNumber:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_change_orders_store_selectors__["h" /* getSelectedChangeOrderNumber */])(state),showSuccessMessage:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_change_orders_store_selectors__["l" /* getShowSuccessMessage */])(state),pdf:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_change_orders_store_selectors__["f" /* getPdf */])(state),showPdfViewer:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_details_change_orders_store_selectors__["k" /* getShowPdfViewer */])(state)};})(ChangeOrderApprovalModal));

/***/ }),
/* 2310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_orders_store_selectors__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_change_orders_store_actions__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_domain_work_order__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChangeOrderEmailModal_css__ = __webpack_require__(2312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChangeOrderEmailModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ChangeOrderEmailModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_email_EmailEditor__ = __webpack_require__(422);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeOrderEmailModal=function(_Component){_inherits(ChangeOrderEmailModal,_Component);function ChangeOrderEmailModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChangeOrderEmailModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChangeOrderEmailModal.__proto__||Object.getPrototypeOf(ChangeOrderEmailModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleSend=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_change_orders_store_actions__["p" /* sendEmail */])(_this.props.selectedChangeOrderId,_this.props.emails,_this.props.subject,_this.props.message)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_change_orders_store_actions__["s" /* setShowEmailModal */])(false));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_change_orders_store_actions__["i" /* initializeEmailValues */])(_this.props.selectedChangeOrderNumber,_this.props.currentWorkOrder.number,_this.props.currentWorkOrder.name,_this.props.currentWorkOrder.building.location,_this.props.users));}});},_this.handleClose=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_change_orders_store_actions__["s" /* setShowEmailModal */])(false));},_this.handleAddCustomEmail=function(email){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_change_orders_store_actions__["a" /* addEmail */])(email));},_this.handleToEmailRemove=function(email){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_change_orders_store_actions__["n" /* removeEmail */])(email));},_this.handleAddUserEmail=function(email){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_change_orders_store_actions__["a" /* addEmail */])(email));},_this.handleSubjectConfirm=function(subject){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_change_orders_store_actions__["r" /* setChangeOrderSubject */])(subject));},_this.handleMessageChange=function(message){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_work_orders_details_change_orders_store_actions__["q" /* setChangeOrderMessage */])(message));},_this.isSendButtonEnabled=function(){return _this.props.emails.length>0&&_this.props.subject!==''&&_this.props.message!=='';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChangeOrderEmailModal,[{key:'render',value:function render(){var woName=__WEBPACK_IMPORTED_MODULE_7_domain_work_order__["a" /* WorkOrder */].getName(this.props.currentWorkOrder);var title='ChangeOrder (WO #'+this.props.currentWorkOrder.number+(woName!==null?': '+woName:'')+')';return this.props.showEmailModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{className:'change-order-email-modal',show:this.props.showEmailModal,title:title,onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'change-order-email-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_email_EmailEditor__["a" /* EmailEditor */],{toEmails:this.props.emails,message:this.props.message,subject:this.props.subject,usersEmail:this.props.users.map(function(user){return user.email;}),onCustomEmailAdd:this.handleAddCustomEmail,onMessageChange:this.handleMessageChange,onSubjectConfirm:this.handleSubjectConfirm,onToEmailRemove:this.handleToEmailRemove,onUserEmailAdd:this.handleAddUserEmail}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:!this.isSendButtonEnabled(),label:'Send',onClick:this.handleSend})))):null;}}]);return ChangeOrderEmailModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),emails:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_orders_store_selectors__["d" /* getEmails */])(state),message:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_orders_store_selectors__["e" /* getMessage */])(state),selectedChangeOrderId:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_orders_store_selectors__["g" /* getSelectedChangeOrderId */])(state),selectedChangeOrderNumber:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_orders_store_selectors__["h" /* getSelectedChangeOrderNumber */])(state),showEmailModal:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_orders_store_selectors__["j" /* getShowEmailModal */])(state),subject:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_orders_store_selectors__["n" /* getSubject */])(state),users:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_work_orders_details_change_orders_store_selectors__["o" /* getUsers */])(state)};})(ChangeOrderEmailModal));

/***/ }),
/* 2312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkOrderAuthorizations_css__ = __webpack_require__(2314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkOrderAuthorizations_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__WorkOrderAuthorizations_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_modal_SigningModal__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_utils_users_util__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WorkOrderAuthorizations=function(_Component){_inherits(WorkOrderAuthorizations,_Component);function WorkOrderAuthorizations(props){_classCallCheck(this,WorkOrderAuthorizations);var _this=_possibleConstructorReturn(this,(WorkOrderAuthorizations.__proto__||Object.getPrototypeOf(WorkOrderAuthorizations)).call(this,props));_this.mapWoas=function(woas){return woas.map(function(woa){return[woa.number,!_this.userIsContractor&&woa.contractor.name,woa.document?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_document_DocumentLink__["a" /* default */],{url:woa.document.document.url}):'N/A',!woa.document&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-orange',value:'Sign WOA',onClick:function onClick(){return _this.handleSignWoa(woa.id);}})].filter(function(item){return!!item;});});};_this.handleSignWoa=function(woaId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["_6" /* showSignWoaModal */])(woaId));};_this.handleWoaSigningModalClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["B" /* hideWoaSigningModal */])());};_this.userIsContractor=__WEBPACK_IMPORTED_MODULE_9_services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_9_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);return _this;}_createClass(WorkOrderAuthorizations,[{key:'render',value:function render(){var headers=['NUMBER',!this.userIsContractor&&'CONTRACOTR','DOC LINK',' '].filter(function(item){return!!item;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'work-order-authorizations'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_table_SimpleTable__["a" /* default */],{className:'work-order-authorizations-table '+(this.userIsContractor&&'for-contractor'),headers:headers,rows:this.mapWoas(this.props.workOrderAuthorizations),emptyMessage:'No Work Order Authorizations'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_modal_SigningModal__["a" /* default */],{show:this.props.showWoaSigningModal,url:this.props.woaSigningUrl,title:'Sign WOA',handleClose:this.handleWoaSigningModalClose}));}}]);return WorkOrderAuthorizations;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{woaSigningUrl:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["w" /* getWoaSigningUrl */])(state),showWoaSigningModal:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["u" /* getShowWoaSigningModal */])(state),workOrderAuthorizations:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_details_details__["x" /* getWorkOrderAuthorizations */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_authentication__["d" /* getCurrentUser */])(state)};})(WorkOrderAuthorizations));

/***/ }),
/* 2314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NewWorkOrderRouteGuard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/**
 * Call the route only if the currentWorkOrder is not null, otherwise redirects to /
 */var NewWorkOrderRouteGuard=function NewWorkOrderRouteGuard(_ref){var Component=_ref.component,rest=_objectWithoutProperties(_ref,['component']);if(rest.currentWorkOrder===null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Redirect */],{to:'/'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],Object.assign({},rest,{component:Component}));}};function mapStateToProps(state){return{currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_3__selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(NewWorkOrderRouteGuard));

/***/ }),
/* 2317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_checkbox_CheckBox__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_navigation_SearchBar__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectors_admin_work_orders_creation_clients__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_admin_work_orders_creation_clients__ = __webpack_require__(2318);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClientSelection=function(_Component){_inherits(ClientSelection,_Component);function ClientSelection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientSelection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientSelection.__proto__||Object.getPrototypeOf(ClientSelection)).call.apply(_ref,[this].concat(args))),_this),_this.handleCheckboxChange=function(clientId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_admin_work_orders_creation_clients__["c" /* setClient */])(clientId));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_admin_work_orders_creation_clients__["a" /* goToBuildingSelection */])());},_this.mapClients=function(clients){return clients.map(function(client){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_checkbox_CheckBox__["a" /* default */],{id:client.id,checked:client.id===_this.props.selectedClientId,shape:'round',size:'medium',onChange:_this.handleCheckboxChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},client.company_name),client.contact.first_name+' '+client.contact.last_name];});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientSelection,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.currentWorkOrder!==null){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_admin_work_orders_creation_clients__["c" /* setClient */])(this.props.currentWorkOrder.client.id));}this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_admin_work_orders_creation_clients__["b" /* loadClientsRequest */])());}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'building-selection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_route_title_RouteTitle__["a" /* default */],{titles:['WORK ORDERS',this.props.currentWorkOrder===null?'CREATE NEW':'WO #'+this.props.currentWorkOrder.number]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_navigation_SearchBar__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'navbar-text'},'Which Client is the Work Order for?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_table_SimpleTable__["a" /* default */],{headers:['','COMPANY NAME','CONTACT'],rows:this.mapClients(this.props.clients),emptyMessage:'No Clients'})));}}]);return ClientSelection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(state){return{clients:Object(__WEBPACK_IMPORTED_MODULE_7__selectors_admin_work_orders_creation_clients__["a" /* getClients */])(state),currentWorkOrder:Object(__WEBPACK_IMPORTED_MODULE_5__selectors_admin_work_orders_work_orders__["e" /* getCurrentWorkOrder */])(state),selectedClientId:Object(__WEBPACK_IMPORTED_MODULE_7__selectors_admin_work_orders_creation_clients__["b" /* getSelectedClientId */])(state)};})(ClientSelection));

/***/ }),
/* 2318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = goToBuildingSelection;
/* harmony export (immutable) */ __webpack_exports__["b"] = loadClientsRequest;
/* unused harmony export loadClientsSuccess */
/* harmony export (immutable) */ __webpack_exports__["c"] = setClient;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_clients_api__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__work_orders__ = __webpack_require__(35);
function goToBuildingSelection(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_4__work_orders__["c" /* baseRoutePath */]+'/building-selection'));};}function loadClientsRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0__services_api_clients_api__["a" /* clientsApi */].getClients().then(function(response){if(response.ok){dispatch(loadClientsSuccess(response.clients));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadClientsSuccess(clients){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["h" /* WORK_ORDERS_CREATION_CLIENTS_LOAD_SUCCESS */],payload:clients};}function setClient(clientId){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["g" /* WORK_ORDERS_CREATION_CLIENTS_CLIENT_SET */],payload:clientId};}

/***/ }),
/* 2319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_ConditionRoute__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_contractors_Contractors__ = __webpack_require__(2320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_contractors_ContractorDetails__ = __webpack_require__(2323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_contractors_NewContractor__ = __webpack_require__(2338);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorsContainer=function(_Component){_inherits(ContractorsContainer,_Component);function ContractorsContainer(props){_classCallCheck(this,ContractorsContainer);var _this=_possibleConstructorReturn(this,(ContractorsContainer.__proto__||Object.getPrototypeOf(ContractorsContainer)).call(this,props));_this.state={hasError:false};return _this;}_createClass(ContractorsContainer,[{key:'componentDidCatch',value:function componentDidCatch(error,info){this.setState({hasError:true});this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_messages__["d" /* showErrorMessage */])('Something went wrong with the request, please try again later.'));}},{key:'render',value:function render(){if(this.state.hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Redirect */],{to:'/'});}else{var currentUser=this.props.currentUser;var adminOrGc=__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["g" /* usersUtil */].isAdmin(currentUser)||__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/',component:__WEBPACK_IMPORTED_MODULE_7_components_admin_contractors_Contractors__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_ConditionRoute__["a" /* ConditionRoute */],{fallbackUrl:this.props.match.url+'/',path:this.props.match.url+'/new',component:__WEBPACK_IMPORTED_MODULE_9_components_admin_contractors_NewContractor__["a" /* default */],show:adminOrGc}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/:id',component:__WEBPACK_IMPORTED_MODULE_8_components_admin_contractors_ContractorDetails__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_ConditionRoute__["a" /* ConditionRoute */],{fallbackUrl:this.props.match.url+'/',path:this.props.match.url+'/:id/edit',component:__WEBPACK_IMPORTED_MODULE_9_components_admin_contractors_NewContractor__["a" /* default */],show:adminOrGc})));}}}]);return ContractorsContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_authentication__["d" /* getCurrentUser */])(state)};})(ContractorsContainer));

/***/ }),
/* 2320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Contractors_css__ = __webpack_require__(2321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Contractors_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Contractors_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_navigation_SearchBar__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_admin_contractors_contractors__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_admin_contractors_contractors__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_table_SimpleHeader__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ContractorStatus__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_shared_text_SimpleTruncate__ = __webpack_require__(200);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Contractors=function(_Component){_inherits(Contractors,_Component);function Contractors(props){_classCallCheck(this,Contractors);var _this=_possibleConstructorReturn(this,(Contractors.__proto__||Object.getPrototypeOf(Contractors)).call(this,props));_this.handleAddContractor=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_contractors_contractors__["m" /* newContractor */])());};_this.handleContractorSelection=function(index){Object(__WEBPACK_IMPORTED_MODULE_12_services_utils_scroller_util__["c" /* simpleScrollToTop */])();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_contractors_contractors__["d" /* goToContractor */])(_this.props.contractors[index].id));};_this.handleTradesFilterSelect=function(filter){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_contractors_contractors__["h" /* loadContractorsRequest */])(1,_this.state.nameToSearch,filter)).then(function(response){if(response.ok){_this.setState({tradesFilter:filter});}});};_this.handleGenerateLink=function(index){var contractors=_this.props.contractors;return'contractors/'+contractors[index].id;};_this.mapContractors=function(contractors){return contractors.map(function(contractor){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},contractor.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_text_SimpleTruncate__["a" /* default */],{text:contractor.trades.map(function(trade){return trade.label;}).join('\n')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ContractorStatus__["a" /* default */],{status:contractor.status}),contractor.wo_in_progress_count,contractor.wo_complete_count,contractor.contact.first_name+' '+contractor.contact.last_name,contractor.total_earned!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_text_Number__["a" /* default */],{value:contractor.total_earned,format:'$0,0'}):'N/A'];});};_this.handleContractorsPageChange=function(newPage){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_contractors_contractors__["h" /* loadContractorsRequest */])(newPage));};_this.handleSearchTextChange=function(value){_this.setState({nameToSearch:value});_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_contractors_contractors__["h" /* loadContractorsRequest */])(1,value));};_this.handleSearchTextClear=function(){_this.handleSearchTextChange('');};_this.state={nameToSearch:'',tradesFilter:''};return _this;}_createClass(Contractors,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_contractors_contractors__["h" /* loadContractorsRequest */])(1));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_work_orders_details_details__["J" /* loadTradesRequest */])());}},{key:'componentDidUpdate',value:function componentDidUpdate(){Object(__WEBPACK_IMPORTED_MODULE_12_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}},{key:'render',value:function render(){var nameToSearch=this.state.nameToSearch;var _props=this.props,trades=_props.trades,contractors=_props.contractors,contractorsCurrentPage=_props.contractorsCurrentPage,contractorsPageSize=_props.contractorsPageSize,contractorsTotal=_props.contractorsTotal;var tradesHeaders=trades.map(function(trade){return{id:''+trade.id,label:trade.label};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contractors'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Contractors'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_navigation_SearchBar__["a" /* default */],{addButton:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'button',value:'Add Contractor',onClick:this.handleAddContractor}),searchPlaceHolder:'Search by Name',searchText:nameToSearch,onSearchTextChange:this.handleSearchTextChange,onClearText:this.handleSearchTextClear,onSearch:this.handleSearchTextChange},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_table_SimpleTable__["a" /* default */],{className:'contractors-table',headers:['COMPANY NAME',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_table_SimpleHeader__["a" /* default */],{label:'TRADES',filter:{options:[{id:'',label:'All'}].concat(_toConsumableArray(tradesHeaders)),selected:this.state.tradesFilter},onFilterOptionSelect:this.handleTradesFilterSelect}),'STATUS','IN PROGRESS','COMPLETED','POC','EARNINGS'],rows:this.mapContractors(contractors),emptyMessage:'No Contractors',onRowSelected:this.handleContractorSelection,onGenerateLink:this.handleGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:contractorsCurrentPage,pageSize:contractorsPageSize,total:contractorsTotal,onPageChange:this.handleContractorsPageChange}))));}}]);return Contractors;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{contractors:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_contractors_contractors__["b" /* getContractors */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_13_selectors_authentication__["d" /* getCurrentUser */])(state),contractorsCurrentPage:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_contractors_contractors__["c" /* getContractorsCurrentPage */])(state),contractorsTotal:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_contractors_contractors__["e" /* getContractorsTotal */])(state),contractorsPageSize:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_contractors_contractors__["d" /* getContractorsPageSize */])(state),trades:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_work_orders_work_orders__["j" /* getTrades */])(state)};})(Contractors));

/***/ }),
/* 2321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serviceAreasApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ServiceAreasApi=function(_BaseApi){_inherits(ServiceAreasApi,_BaseApi);function ServiceAreasApi(){_classCallCheck(this,ServiceAreasApi);return _possibleConstructorReturn(this,(ServiceAreasApi.__proto__||Object.getPrototypeOf(ServiceAreasApi)).apply(this,arguments));}_createClass(ServiceAreasApi,[{key:'getServiceAreas',value:function getServiceAreas(){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/service_areas').then(function(response){return{ok:true,serviceAreas:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return ServiceAreasApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var serviceAreasApi=new ServiceAreasApi();

/***/ }),
/* 2323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_admin_contractors_contractors__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_contractors_contractors__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_details_DetailsHeader__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContractorStatus__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_details_DetailsInfo__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfoItem__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ContractorDetails_css__ = __webpack_require__(2324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ContractorDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ContractorDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_modal_ContactsModal__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_admin_contractors_ContractorDetailsWorkOrders__ = __webpack_require__(2327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_admin_contractors_ContractorDetailsInvoices__ = __webpack_require__(2329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_admin_contractors_ContractorDetailsProjects__ = __webpack_require__(2333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_admin_contractors_ContractorDocumentsViewer__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_shared_modal_SigningModal__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_admin_contractors_ContractorInviteUserModal_js__ = __webpack_require__(2337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_shared_button_Button__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorDetails=function(_Component){_inherits(ContractorDetails,_Component);function ContractorDetails(props){_classCallCheck(this,ContractorDetails);// Keep track of id to avoid showing an "old" contractor while loading the current one
var _this=_possibleConstructorReturn(this,(ContractorDetails.__proto__||Object.getPrototypeOf(ContractorDetails)).call(this,props));_this.handleContactsModalClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_contractors_contractors__["s" /* showContactsModal */])(false));};_this.handleEdit=function(){Object(__WEBPACK_IMPORTED_MODULE_17_services_utils_scroller_util__["c" /* simpleScrollToTop */])();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_contractors_contractors__["b" /* editContractor */])(_this.props.currentContractor.id));};_this.handleNavSelect=function(value){_this.setState({currentNav:value});};_this.handleViewAll=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_contractors_contractors__["t" /* showContactsRequest */])(_this.props.currentContractor.id,_this.props.users));};_this.mapUsers=function(users){return users.map(function(user){return{email:user.email,lastSignIn:user.current_sign_in_at,name:user.first_name+' '+user.last_name,phoneNumber:user.phone_number,primaryContact:user.account_creator,title:_this.mapTitle(user.roles)};});};_this.handleSignMsa=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_contractors_contractors__["u" /* showSignMsaModal */])(_this.props.currentContractor.id));};_this.handleMsaSigningModalClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_contractors_contractors__["f" /* hideMsaSigningModal */])());};_this.handleInviteUserClick=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_contractors_contractors__["a" /* clearContractorForm */])());_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_contractors_contractors__["q" /* setShowInviteUserContractorModal */])(true));};_this.contractorId=__WEBPACK_IMPORTED_MODULE_4_numeral___default()(_this.props.match.params.id).value();_this.userIsSpackleAdmin=__WEBPACK_IMPORTED_MODULE_16_services_utils_users_util__["g" /* usersUtil */].hasRole(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_16_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN);_this.userIsAdmin=__WEBPACK_IMPORTED_MODULE_16_services_utils_users_util__["g" /* usersUtil */].isAdmin(props.currentUser);_this.state={currentNav:_this.userIsAdmin?1:3};return _this;}_createClass(ContractorDetails,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_contractors_contractors__["g" /* loadContractorRequest */])(this.contractorId));}},{key:'mapTitle',value:function mapTitle(roles){var titles=roles.filter(function(role){return role.resource_type===__WEBPACK_IMPORTED_MODULE_16_services_utils_users_util__["f" /* TYPES */].CONTRACTOR;}).map(function(role){return __WEBPACK_IMPORTED_MODULE_16_services_utils_users_util__["c" /* CONTRACTOR_ROLES */][role.name];});if(titles.length>1){return titles.join(' / ');}else if(titles.length===1){return titles[0];}else{return'N/A';}}},{key:'render',value:function render(){var currentContractor=this.props.currentContractor;var firstRowDetailsInfoItems=[];var secondRowDetailsInfoItems=[];if(currentContractor){if(currentContractor.location){firstRowDetailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[currentContractor.location.street_address_1,currentContractor.location.city+', '+currentContractor.location.state+' '+currentContractor.location.zip],title:'ADDRESS'}));}firstRowDetailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'contractor-name'},currentContractor.contact.first_name+' '+currentContractor.contact.last_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'contractor-email',href:'mailto:'+currentContractor.contact.email},currentContractor.contact.email),Object(__WEBPACK_IMPORTED_MODULE_14_services_utils_text_util__["c" /* formatPhoneNumber */])(currentContractor.contact.phone_number)],title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'PRIMARY CONTACT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'view-all',onClick:this.handleViewAll},'View All'))}));firstRowDetailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[currentContractor.license_number],title:'LICENSE NUMBER'}));secondRowDetailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:currentContractor.service_areas.map(function(element){return element.name;}),title:'AREAS OF SERVICE'}));secondRowDetailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:currentContractor.unions.map(function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element.label,element.detail!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'union-detail'},'(',element.detail,')'));}),title:'UNIONS'}));secondRowDetailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:currentContractor.trades.map(function(element){return element.label;}),title:'SPECIALITIES',truncate:true}));}var rightHeaders=[];if(currentContractor){rightHeaders.push({title:'STATUS',value:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ContractorStatus__["a" /* default */],{status:currentContractor.status})});if(this.userIsAdmin){rightHeaders.push({title:'IN PROGRESS',value:currentContractor.wo_in_progress_count},{title:'COMPLETED',value:currentContractor.wo_complete_count},{title:'TOTAL EARNED',value:currentContractor.total_earned!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_text_Number__["a" /* default */],{value:currentContractor.total_earned,format:'$0,0'}):'N/A'});}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contractor-details'},currentContractor!==null&&currentContractor.id===this.contractorId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['CONTRACTORS',currentContractor.name.toUpperCase()]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_details_DetailsHeader__["a" /* default */],{leftHeader:{title:'CONTRACTOR',value:currentContractor.name},rightHeaders:[rightHeaders]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-info-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_details_DetailsInfo__["a" /* default */],{itemsContainerSize:10,itemsLines:[firstRowDetailsInfoItems,secondRowDetailsInfoItems],rightContainerSize:2,rightContainer:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contractors-documents-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_admin_contractors_ContractorDocumentsViewer__["a" /* default */],{contractor:currentContractor}))}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edit-button-container'},this.userIsAdmin&&currentContractor.confirmed&&!currentContractor.msa_document&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-orange',value:'Sign MSA',onClick:this.handleSignMsa}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-gray',value:'Edit',onClick:this.handleEdit}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'Work Orders',show:this.userIsAdmin},{id:2,title:'Invoices',show:this.userIsAdmin},{id:3,title:'Projects',class:this.state.currentNav===3?'selected':''}],onSelected:this.handleNavSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navigation-content'},this.state.currentNav===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_admin_contractors_ContractorDetailsWorkOrders__["a" /* default */],null),this.state.currentNav===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_admin_contractors_ContractorDetailsInvoices__["a" /* default */],null),this.state.currentNav===3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_admin_contractors_ContractorDetailsProjects__["a" /* default */],null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_modal_ContactsModal__["a" /* default */],{footer:this.userIsSpackleAdmin?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contacts-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_components_shared_button_Button__["a" /* default */],{label:'Invite User',className:'button-orange',onClick:this.handleInviteUserClick})):null,show:this.props.showContactsModal,users:this.mapUsers(this.props.users),onClose:this.handleContactsModalClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_shared_modal_SigningModal__["a" /* default */],{show:this.props.showMsaSigningModal,url:this.props.msaSigningUrl,title:'Sign MSA',handleClose:this.handleMsaSigningModalClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_components_admin_contractors_ContractorInviteUserModal_js__["a" /* default */],null));}}]);return ContractorDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentContractor:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_contractors_contractors__["f" /* getCurrentContractor */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_15_selectors_authentication__["d" /* getCurrentUser */])(state),showContactsModal:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_contractors_contractors__["q" /* getShowContactsModal */])(state),users:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_contractors_contractors__["v" /* getUsers */])(state),workOrders:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_contractors_contractors__["y" /* getWorkOrders */])(state),msaSigningUrl:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_contractors_contractors__["j" /* getMsaSigningUrl */])(state),showMsaSigningModal:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_contractors_contractors__["s" /* getShowMsaSigningModal */])(state),projects:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_contractors_contractors__["k" /* getProjects */])(state)};})(ContractorDetails));

/***/ }),
/* 2324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/user-check.ff43f039.svg";

/***/ }),
/* 2326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_admin_contractors_contractors__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_contractors_contractors__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_work_orders_ResourceWorkOrders__ = __webpack_require__(592);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorDetailsWorkOrders=function(_Component){_inherits(ContractorDetailsWorkOrders,_Component);function ContractorDetailsWorkOrders(){_classCallCheck(this,ContractorDetailsWorkOrders);return _possibleConstructorReturn(this,(ContractorDetailsWorkOrders.__proto__||Object.getPrototypeOf(ContractorDetailsWorkOrders)).apply(this,arguments));}_createClass(ContractorDetailsWorkOrders,[{key:'render',value:function render(){var _props=this.props,currentContractor=_props.currentContractor,currentPage=_props.currentPage,workOrders=_props.workOrders;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_work_orders_ResourceWorkOrders__["a" /* default */],{resource:currentContractor,workOrders:workOrders,currentPage:currentPage,loadWorkOrdersRequest:__WEBPACK_IMPORTED_MODULE_3_actions_admin_contractors_contractors__["l" /* loadWorkOrdersRequest */]});}}]);return ContractorDetailsWorkOrders;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentContractor:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_contractors_contractors__["f" /* getCurrentContractor */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_contractors_contractors__["g" /* getCurrentPage */])(state),workOrders:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_contractors_contractors__["y" /* getWorkOrders */])(state)};})(ContractorDetailsWorkOrders));

/***/ }),
/* 2328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectors_admin_contractors_contractors__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_pagination_table_PaginationTable__ = __webpack_require__(2330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_contractors_contractors__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_table_SimpleTable__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorDetailsInvoices=function(_Component){_inherits(ContractorDetailsInvoices,_Component);function ContractorDetailsInvoices(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ContractorDetailsInvoices);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ContractorDetailsInvoices.__proto__||Object.getPrototypeOf(ContractorDetailsInvoices)).call.apply(_ref,[this].concat(args))),_this),_this.handlePageChange=function(page){var _this$props=_this.props,currentContractor=_this$props.currentContractor,onContractorInvoicesGet=_this$props.onContractorInvoicesGet;onContractorInvoicesGet(currentContractor.id,page);},_this.mapInvoices=function(invoices){return invoices.map(function(invoice){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small-bold'},invoice.work_order_number),Object(__WEBPACK_IMPORTED_MODULE_6_services_utils_text_util__["e" /* toUpperFirstLetter */])(invoice.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__["a" /* default */],{value:invoice.due_date,format:'LL'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__["a" /* default */],{value:invoice.cost,format:'$0,0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_document_DocumentLink__["a" /* default */],{showIcon:false,url:invoice.document.document.url})];});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ContractorDetailsInvoices,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,currentContractor=_props.currentContractor,onContractorInvoicesGet=_props.onContractorInvoicesGet;if(currentContractor!==null){onContractorInvoicesGet(currentContractor.id);}}},{key:'render',value:function render(){var contractorInvoices=this.props.contractorInvoices;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contractor-details-invoices'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_pagination_table_PaginationTable__["a" /* default */],{onCurrentPageChange:this.handlePageChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_table_SimpleTable__["a" /* default */],{headers:['WO #','STATUS','DUE DATE','AMOUNT','DOC LINK'],rows:this.mapInvoices(contractorInvoices),emptyMessage:'No Invoices'})));}}]);return ContractorDetailsInvoices;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ContractorDetailsInvoices.propTypes={contractorInvoices:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})).isRequired,currentContractor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),onContractorInvoicesGet:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};ContractorDetailsInvoices.defaultProps={currentContractor:null};var mapStateToProps=function mapStateToProps(state){return{contractorInvoices:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_contractors_contractors__["a" /* contractorInvoicesSelector */])(state),currentContractor:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_contractors_contractors__["f" /* getCurrentContractor */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onContractorInvoicesGet:function onContractorInvoicesGet(contractorId,page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_contractors_contractors__["c" /* getContractorInvoices */])(contractorId,page));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ContractorDetailsInvoices));

/***/ }),
/* 2330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaginationTable_css__ = __webpack_require__(2331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaginationTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PaginationTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_pagination_table_store_actions__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_pagination_table_store_selectors__ = __webpack_require__(2332);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaginationTable=function(_Component){_inherits(PaginationTable,_Component);function PaginationTable(){_classCallCheck(this,PaginationTable);return _possibleConstructorReturn(this,(PaginationTable.__proto__||Object.getPrototypeOf(PaginationTable)).apply(this,arguments));}_createClass(PaginationTable,[{key:'componentDidMount',value:function componentDidMount(){this.props.onInit();}},{key:'render',value:function render(){var _props=this.props,children=_props.children,currentPage=_props.currentPage,pageSize=_props.pageSize,total=_props.total,onCurrentPageChange=_props.onCurrentPageChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-table'},children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPage,pageSize:pageSize,total:total,onPageChange:onCurrentPageChange})));}}]);return PaginationTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PaginationTable.propTypes={currentPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,pageSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,total:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,onCurrentPageChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};var mapStateToProps=function mapStateToProps(state){return{currentPage:Object(__WEBPACK_IMPORTED_MODULE_6_components_shared_pagination_table_store_selectors__["a" /* currentPageSelector */])(state),pageSize:Object(__WEBPACK_IMPORTED_MODULE_6_components_shared_pagination_table_store_selectors__["b" /* paginationPageSizeSelector */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_6_components_shared_pagination_table_store_selectors__["c" /* paginationTotalSelector */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onInit:function onInit(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_shared_pagination_table_store_actions__["a" /* initPagination */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(PaginationTable));

/***/ }),
/* 2331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currentPageSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return paginationPageSizeSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return paginationTotalSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var currentPageSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.paginationTable.currentPage;},function(currentPage){return currentPage;});var paginationPageSizeSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.paginationTable.pageSize;},function(pageSize){return pageSize;});var paginationTotalSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.paginationTable.total;},function(total){return total;});

/***/ }),
/* 2333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_admin_contractors_contractors__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_contractors_contractors__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_projects_ResourceProjects__ = __webpack_require__(593);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorDetailsProjects=function(_Component){_inherits(ContractorDetailsProjects,_Component);function ContractorDetailsProjects(){_classCallCheck(this,ContractorDetailsProjects);return _possibleConstructorReturn(this,(ContractorDetailsProjects.__proto__||Object.getPrototypeOf(ContractorDetailsProjects)).apply(this,arguments));}_createClass(ContractorDetailsProjects,[{key:'render',value:function render(){var _props=this.props,currentContractor=_props.currentContractor,currentPage=_props.currentPage,projects=_props.projects;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_projects_ResourceProjects__["a" /* default */],{resource:currentContractor,projects:projects,currentPage:currentPage,loadProjectsRequest:__WEBPACK_IMPORTED_MODULE_3_actions_admin_contractors_contractors__["j" /* loadProjectsRequest */]});}}]);return ContractorDetailsProjects;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentContractor:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_contractors_contractors__["f" /* getCurrentContractor */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_contractors_contractors__["g" /* getCurrentPage */])(state),projects:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_contractors_contractors__["k" /* getProjects */])(state)};})(ContractorDetailsProjects));

/***/ }),
/* 2334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_modal_InviteUserModal__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_admin_contractors_contractors_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_contractors__ = __webpack_require__(146);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorInviteUserModal=function(_Component){_inherits(ContractorInviteUserModal,_Component);function ContractorInviteUserModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ContractorInviteUserModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ContractorInviteUserModal.__proto__||Object.getPrototypeOf(ContractorInviteUserModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_contractors__["q" /* setShowInviteUserContractorModal */])(false));},_this.handleSubmit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_contractors__["w" /* submitInviteUserFormRequest */])(_this.props.form,_this.props.currentContractor.id,_this.props.roles));},_this.handleAttributeChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_contractors__["y" /* updateFormValue */])(attribute,value));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ContractorInviteUserModal,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.roles.length===0){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_contractors_contractors__["k" /* loadRolesRequest */])());}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_modal_InviteUserModal__["b" /* default */],{className:'contractor-invite-user-modal',form:[{attribute:'firstName',label:'First Name',renderer:'input'},{attribute:'lastName',label:'Last Name',renderer:'input'},{attribute:'email',label:'Email',renderer:'input'},{attribute:'phoneNumber',formatter:__WEBPACK_IMPORTED_MODULE_4_services_utils_text_util__["c" /* formatPhoneNumber */],label:'Phone Number',renderer:'input'},{attribute:'roleId',label:'Title',renderer:'dropdown',options:this.props.roles.map(function(role){return{value:role.id,label:__WEBPACK_IMPORTED_MODULE_2_services_utils_users_util__["c" /* CONTRACTOR_ROLES */][role.name]};})}],invalidFields:this.props.invalidFields,modalState:__WEBPACK_IMPORTED_MODULE_3_components_shared_modal_InviteUserModal__["a" /* UserModalState */].NEW,show:this.props.showInviteContractorUserModal,values:this.props.form,validationMessage:this.props.validationMessage,onAttributeChange:this.handleAttributeChange,onClose:this.handleClose,onSubmit:this.handleSubmit}));}}]);return ContractorInviteUserModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentContractor:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_contractors_contractors_js__["f" /* getCurrentContractor */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_contractors_contractors_js__["h" /* getForm */])(state),invalidFields:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_contractors_contractors_js__["i" /* getInvalidFields */])(state),roles:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_contractors_contractors_js__["l" /* getRoles */])(state),showInviteContractorUserModal:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_contractors_contractors_js__["r" /* getShowInviteContractorUserModal */])(state),validationMessage:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_contractors_contractors_js__["w" /* getValidationMessage */])(state)};})(ContractorInviteUserModal));

/***/ }),
/* 2338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_admin_contractors_contractors__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors_admin_contractors_contractors__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContractorForm__ = __webpack_require__(963);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewContractor=function(_Component){_inherits(NewContractor,_Component);function NewContractor(props){_classCallCheck(this,NewContractor);var _this=_possibleConstructorReturn(this,(NewContractor.__proto__||Object.getPrototypeOf(NewContractor)).call(this,props));_this.handleServiceAreaSelection=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_admin_contractors_contractors__["n" /* selectServiceArea */])(value));};_this.handleTradesSelection=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_admin_contractors_contractors__["o" /* selectTrade */])(value));};_this.handleUnionSelection=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_admin_contractors_contractors__["p" /* selectUnion */])(value,_this.props.unions,_this.props.selectedUnionsId));};_this.handleW9DocumentChange=function(file){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_admin_contractors_contractors__["r" /* setW9Document */])(file));};_this.handleFormChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_admin_contractors_contractors__["y" /* updateFormValue */])(attribute,value));};_this.handleSubmit=function(sendInvitation){var promise=_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_admin_contractors_contractors__["v" /* submitFormRequest */])(_this.props.form,_this.props.selectedServiceAreasId,_this.props.selectedTradesId,_this.props.selectedUnionsId,_this.props.w9Document,sendInvitation,_this.editContractor?_this.props.currentContractor.id:undefined));if(promise!==null){promise.then(function(response){if(response.ok){if(_this.editContractor){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_admin_contractors_contractors__["d" /* goToContractor */])(_this.props.currentContractor.id));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_admin_contractors_contractors__["e" /* goToContractors */])());}}});}};_this.editContractor=false;return _this;}_createClass(NewContractor,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_admin_contractors_contractors__["i" /* loadNewContractorParametersRequest */])(this.props.serviceAreas,this.props.trades,this.props.unions)).then(function(){if(_this2.props.match.params.hasOwnProperty('id')){// Editing a contractor
_this2.editContractor=true;if(_this2.props.currentContractor===null){// If contractor not loaded, load it
_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_admin_contractors_contractors__["g" /* loadContractorRequest */])(_this2.props.match.params.id)).then(function(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_admin_contractors_contractors__["x" /* updateFormFromCurrentContractor */])(_this2.props.currentContractor));});}else{_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_admin_contractors_contractors__["x" /* updateFormFromCurrentContractor */])(_this2.props.currentContractor));}}});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ContractorForm__["a" /* default */],{edit:this.editContractor,form:this.props.form,invalidFields:this.props.invalidFields,selectedServiceAreasId:this.props.selectedServiceAreasId,selectedTradesId:this.props.selectedTradesId,selectedUnionsId:this.props.selectedUnionsId,w9Document:this.props.w9Document,serviceAreas:this.props.serviceAreas,trades:this.props.trades,unions:this.props.unions,validationMessage:this.props.validationMessage,onFormChange:this.handleFormChange,onServiceAreaSelection:this.handleServiceAreaSelection,onSubmit:this.handleSubmit,onTradesSelection:this.handleTradesSelection,onUnionSelection:this.handleUnionSelection,onW9DocumentChange:this.handleW9DocumentChange});}}]);return NewContractor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentContractor:Object(__WEBPACK_IMPORTED_MODULE_3__selectors_admin_contractors_contractors__["f" /* getCurrentContractor */])(state),invalidFields:Object(__WEBPACK_IMPORTED_MODULE_3__selectors_admin_contractors_contractors__["i" /* getInvalidFields */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_3__selectors_admin_contractors_contractors__["h" /* getForm */])(state),serviceAreas:Object(__WEBPACK_IMPORTED_MODULE_3__selectors_admin_contractors_contractors__["p" /* getServiceAreas */])(state),selectedServiceAreasId:Object(__WEBPACK_IMPORTED_MODULE_3__selectors_admin_contractors_contractors__["m" /* getSelectedServiceAreasId */])(state),selectedTradesId:Object(__WEBPACK_IMPORTED_MODULE_3__selectors_admin_contractors_contractors__["n" /* getSelectedTradesId */])(state),selectedUnionsId:Object(__WEBPACK_IMPORTED_MODULE_3__selectors_admin_contractors_contractors__["o" /* getSelectedUnionsId */])(state),w9Document:Object(__WEBPACK_IMPORTED_MODULE_3__selectors_admin_contractors_contractors__["x" /* getW9Document */])(state),trades:Object(__WEBPACK_IMPORTED_MODULE_3__selectors_admin_contractors_contractors__["t" /* getTrades */])(state),unions:Object(__WEBPACK_IMPORTED_MODULE_3__selectors_admin_contractors_contractors__["u" /* getUnions */])(state),validationMessage:Object(__WEBPACK_IMPORTED_MODULE_3__selectors_admin_contractors_contractors__["w" /* getValidationMessage */])(state)};})(NewContractor));

/***/ }),
/* 2339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Buildings__ = __webpack_require__(2341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NewBuilding__ = __webpack_require__(2343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BuildingDetails__ = __webpack_require__(2345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_ConditionRoute__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_authentication__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BuildingsContainer=function(_Component){_inherits(BuildingsContainer,_Component);function BuildingsContainer(props){_classCallCheck(this,BuildingsContainer);var _this=_possibleConstructorReturn(this,(BuildingsContainer.__proto__||Object.getPrototypeOf(BuildingsContainer)).call(this,props));_this.showConditionRoutes=function(){var currentUser=_this.props.currentUser;return __WEBPACK_IMPORTED_MODULE_7_services_utils_users_util__["g" /* usersUtil */].hasRole(currentUser,__WEBPACK_IMPORTED_MODULE_7_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_7_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_7_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR)||__WEBPACK_IMPORTED_MODULE_7_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_7_services_utils_users_util__["f" /* TYPES */].CLIENT);};_this.state={hasError:false};return _this;}_createClass(BuildingsContainer,[{key:'componentDidCatch',value:function componentDidCatch(error,info){this.setState({hasError:true});this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_messages__["d" /* showErrorMessage */])('Something went wrong with the request, please try again later.'));}},{key:'render',value:function render(){if(this.state.hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Redirect */],{to:'/'});}else{var showRoutes=this.showConditionRoutes();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/',component:__WEBPACK_IMPORTED_MODULE_3__Buildings__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_ConditionRoute__["a" /* ConditionRoute */],{fallbackUrl:''+this.props.match.url,path:this.props.match.url+'/new',component:__WEBPACK_IMPORTED_MODULE_4__NewBuilding__["a" /* default */],show:showRoutes}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/:id',component:__WEBPACK_IMPORTED_MODULE_5__BuildingDetails__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_ConditionRoute__["a" /* ConditionRoute */],{fallbackUrl:''+this.props.match.url,path:this.props.match.url+'/:id/edit',component:__WEBPACK_IMPORTED_MODULE_4__NewBuilding__["a" /* default */],show:showRoutes})));}}}]);return BuildingsContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_authentication__["d" /* getCurrentUser */])(state)};})(BuildingsContainer));

/***/ }),
/* 2341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Buildings_css__ = __webpack_require__(2342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Buildings_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Buildings_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_navigation_SearchBar__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_buildings_buildings__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_SimpleText__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_admin_buildings_buildings__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Buildings=function(_Component){_inherits(Buildings,_Component);function Buildings(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Buildings);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Buildings.__proto__||Object.getPrototypeOf(Buildings)).call.apply(_ref,[this].concat(args))),_this),_this.handleAddBuilding=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_buildings_buildings__["k" /* newBuilding */])());},_this.handleGenerateLink=function(index){var buildings=_this.props.buildings;return'buildings/'+buildings[index].id;},_this.mapBuildings=function(buildings){return buildings.map(function(building){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_SimpleText__["a" /* default */],{lines:[building.location.street_address_1,building.location.city],style:{fontWeight:600}}),building.name!==''&&building.name!==null?building.name:'N/A',building.property_owner_name||'N/A',Buildings.renderContactName(building.property_manager),Buildings.renderContactName(building.engineer)];});},_this.handleBuildingSelection=function(index){var loadClients=__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["g" /* usersUtil */].hasRole(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_buildings_buildings__["e" /* loadBuildingDetailsRequest */])(_this.props.buildings[index].id,loadClients)).then(function(response){// When building is loaded successfully, go to building page
if(response.ok){Object(__WEBPACK_IMPORTED_MODULE_8_services_utils_scroller_util__["c" /* simpleScrollToTop */])();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_buildings_buildings__["d" /* goToBuilding */])(_this.props.buildings[index].id));}});},_this.handleBuildingsPageChange=function(newPage){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_buildings_buildings__["f" /* loadBuildingsRequest */])(newPage));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Buildings,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_buildings_buildings__["f" /* loadBuildingsRequest */])(1));}},{key:'componentDidUpdate',value:function componentDidUpdate(){Object(__WEBPACK_IMPORTED_MODULE_8_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buildings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Buildings'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_navigation_SearchBar__["a" /* default */],{addButton:__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["g" /* usersUtil */].hasRole(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR)||__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["f" /* TYPES */].CLIENT)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'button',value:'Add Building',onClick:this.handleAddBuilding}):null},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__["a" /* default */],{className:'buildings-table',headers:['ADDRESS','BUILDING NAME','PROPERTY OWNER','PROPERTY MANAGER','BUILDING ENGINEER'],rows:this.mapBuildings(this.props.buildings),emptyMessage:'No Buildings',onRowSelected:this.handleBuildingSelection,onGenerateLink:this.handleGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.buildingsCurrentPage,pageSize:this.props.buildingsPageSize,total:this.props.buildingsTotal,onPageChange:this.handleBuildingsPageChange}))));}}],[{key:'renderContactName',value:function renderContactName(contact){var result='N/A';if(contact!==null&&(contact.first_name!==''||contact.last_name!=='')){result=contact.first_name+' '+contact.last_name;}return result;}}]);return Buildings;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{buildings:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_buildings_buildings__["a" /* getBuildings */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_authentication__["d" /* getCurrentUser */])(state),buildingsCurrentPage:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_buildings_buildings__["b" /* getBuildingsCurrentPage */])(state),buildingsTotal:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_buildings_buildings__["d" /* getBuildingsTotal */])(state),buildingsPageSize:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_buildings_buildings__["c" /* getBuildingsPageSize */])(state)};})(Buildings));

/***/ }),
/* 2342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewBuilding_css__ = __webpack_require__(2344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewBuilding_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NewBuilding_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_select_SelectList__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_admin_buildings_buildings__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_admin_buildings_buildings__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_plus_icon_png__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_plus_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_images_plus_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_close_png__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_close_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_images_close_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_dropdown_arrow_png__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_dropdown_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_images_dropdown_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_upload_png__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_upload_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_images_upload_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_radio_button_RadioButton__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_shared_button_SimpleButton__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_shared_dropdown_SearchableDropDown__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_services_api_contractors_api__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_services_utils_users_util__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewBuilding=function(_Component){_inherits(NewBuilding,_Component);function NewBuilding(props){_classCallCheck(this,NewBuilding);var _this=_possibleConstructorReturn(this,(NewBuilding.__proto__||Object.getPrototypeOf(NewBuilding)).call(this,props));_this.showClients=function(){var currentUser=_this.props.currentUser;return __WEBPACK_IMPORTED_MODULE_20_services_utils_users_util__["g" /* usersUtil */].hasRole(currentUser,__WEBPACK_IMPORTED_MODULE_20_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_20_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_20_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);};_this.handleUnionSelection=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_buildings_buildings__["r" /* selectUnion */])(value,_this.props.unions,_this.props.selectedUnionsId));};_this.handleFormChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_buildings_buildings__["u" /* updateFormValue */])(attribute,value));};_this.handleSubmit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_buildings_buildings__["s" /* submitFormRequest */])(_this.props.form,_this.props.selectedUnionsId,_this.props.selectedContractors,_this.props.files,_this.props.parkingOnSite,_this.editBuilding?_this.props.currentBuilding.id:undefined,_this.props.selectedClientsId));};_this.handleAddEngineer=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_buildings_buildings__["a" /* addEngineer */])());};_this.handleParkingOnSiteSelection=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_buildings_buildings__["q" /* selectParkingOnSite */])(value));};_this.handleContractorSelect=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_buildings_buildings__["p" /* selectContractor */])(value));};_this.handleContractorRemove=function(selectedContractorId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_buildings_buildings__["m" /* removeContractor */])(selectedContractorId));};_this.handleFileDrop=function(files){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_buildings_buildings__["b" /* addFiles */])(files));};_this.handleFileRemove=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_buildings_buildings__["n" /* removeFile */])(index));};_this.handleClientSelection=function(option){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_buildings_buildings__["o" /* selectClient */])(option.value));};_this.handleClientRemove=function(clientId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_buildings_buildings__["l" /* removeClient */])(clientId));};_this.editBuilding=false;return _this;}_createClass(NewBuilding,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var showClients=this.showClients();this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_buildings_buildings__["i" /* loadUnionsRequest */])(this.props.unions)).then(function(){if(_this2.props.match.params.hasOwnProperty('id')){// Editing the building
_this2.editBuilding=true;if(_this2.props.currentBuilding===null){// If building not loaded, load it
_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_buildings_buildings__["e" /* loadBuildingDetailsRequest */])(_this2.props.match.params.id,showClients)).then(function(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_buildings_buildings__["t" /* updateFormFromCurrentBuilding */])(_this2.props.currentBuilding));});}else{_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_buildings_buildings__["t" /* updateFormFromCurrentBuilding */])(_this2.props.currentBuilding));}}else if(showClients){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_buildings_buildings__["g" /* loadClientsRequest */])());}});}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'new-building'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},this.editBuilding?'Edit Building':'Add a Building'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'new-building-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left-side'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2'},'Building Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'details-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Street Address','streetAddress')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2},this.renderField('Unit number / Floor','unitNumber'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('City','city')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('State','state')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Zip Code','zipCode'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Building Name','buildingName')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'details-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Property Owner','propOwnerName')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Street Address','propOwnerStreetAddress')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2},this.renderField('Unit number / Floor','propOwnerUnitNumber'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('City','propOwnerCity')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('State','propOwnerState')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Zip Code','propOwnerZipCode'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'contact-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Manager First Name','managerFirstName')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Manager Last Name','managerLastName'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Email','managerEmail')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Phone Number','managerPhoneNumber'))))),this.props.engineerAdded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'contact-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Engineer First Name','engineerFirstName')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Engineer Last Name','engineerLastName'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Email','engineerEmail')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Phone Number','engineerPhoneNumber')))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'contact-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_button_SimpleButton__["a" /* default */],{className:'add-engineer-button',img:__WEBPACK_IMPORTED_MODULE_8_images_plus_icon_png___default.a,label:'Add Building Engineer',onClick:this.handleAddEngineer})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2 extra-info-container'},'Parking On Site'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{tabIndex:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_radio_button_RadioButton__["a" /* default */],{options:[{value:'true',label:'Yes'},{value:'false',label:'No'}],orientation:'vertical',value:this.props.parkingOnSite!==null?this.props.parkingOnSite.toString():null,onChange:this.handleParkingOnSiteSelection})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2 extra-info-container'},'Union Requirements'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{tabIndex:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_select_SelectList__["a" /* default */],{showAs:'table',values:this.props.unions.map(function(element){return{id:element.id,value:element.label,selected:_this3.props.selectedUnionsId.find(function(selected){return selected===element.id;})!==undefined};}).concat({id:'all',value:'All',selected:this.props.selectedUnionsId.length===this.props.unions.length}),onSelect:this.handleUnionSelection})),this.showClients()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2 extra-info-container'},'Add preferred subcontractors here if any'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contractors-clients-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'drop-down-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_dropdown_SearchableDropDown__["a" /* default */],{arrowRenderer:function arrowRenderer(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'drop-down-image',src:__WEBPACK_IMPORTED_MODULE_10_images_dropdown_arrow_png___default.a,alt:'down-arrow'});},autoload:false,loadOptions:NewBuilding.loadContractors,placeholder:'Select',onChange:this.handleContractorSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contractors-clients-selected-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.props.selectedContractors.map(function(selectedContractor){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:selectedContractor.value},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,selectedContractor.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9_images_close_png___default.a,alt:'remove',onClick:_this3.handleContractorRemove.bind(_this3,selectedContractor.value)})));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2 extra-info-container'},'Add Clients'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contractors-clients-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'drop-down-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_shared_dropdown_Dropdown__["a" /* default */],{options:this.props.clients.filter(function(client){return _this3.props.selectedClientsId.find(function(id){return id===client.id;})===undefined;}).map(function(client){return{value:client.id,label:client.company_name};}),placeholder:'Select',onChange:this.handleClientSelection})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contractors-clients-selected-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.props.selectedClientsId.map(function(clientId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:clientId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this3.props.clients.find(function(client){return client.id===clientId;}).company_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9_images_close_png___default.a,alt:'remove',onClick:_this3.handleClientRemove.bind(_this3,clientId)})));}))))),this.props.validationMessage!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},this.props.validationMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'button',value:this.editBuilding?'Save Building':'Add Building',onClick:this.handleSubmit}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-side'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2'},'Insurance Requirements & Building Rules and Regulations'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body-bold files-title'},'Please drag and drop any file into this area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropzone-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx',className:'files-dropzone',onDrop:this.handleFileDrop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12_images_upload_png___default.a,alt:'remove'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'files-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.props.files.map(function(data,index){return!data.removed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,data.file!==null?data.file.name:Object(__WEBPACK_IMPORTED_MODULE_18_services_utils_text_util__["d" /* getLastTokenFromUrl */])(data.document.document.url,'unknown')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11_images_remove_png___default.a,alt:'remove',onClick:_this3.handleFileRemove.bind(_this3,index)})));}))))));}},{key:'renderField',value:function renderField(placeholder,attribute){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__["a" /* default */],{placeholder:placeholder,valid:this.props.invalidFields.find(function(element){return element===attribute;})===undefined,value:this.props.form[attribute],onChange:this.handleFormChange.bind(this,attribute)});}}],[{key:'loadContractors',value:function loadContractors(input){return __WEBPACK_IMPORTED_MODULE_16_services_api_contractors_api__["a" /* contractorsApi */].searchContractors(input).then(function(response){if(response.ok){return{ok:true,options:response.contractors.map(function(element){return{value:element.id,label:element.name};})};}else{return{ok:false,errors:response.errors};}});}}]);return NewBuilding;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{clients:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_buildings_buildings__["e" /* getClients */])(state),currentBuilding:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_buildings_buildings__["f" /* getCurrentBuilding */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_19_selectors_authentication__["d" /* getCurrentUser */])(state),engineerAdded:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_buildings_buildings__["h" /* getEngineerAdded */])(state),files:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_buildings_buildings__["i" /* getFiles */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_buildings_buildings__["j" /* getForm */])(state),invalidFields:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_buildings_buildings__["k" /* getInvalidFields */])(state),parkingOnSite:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_buildings_buildings__["l" /* getParkingOnSite */])(state),selectedClientsId:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_buildings_buildings__["n" /* getSelectedClientsId */])(state),selectedContractors:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_buildings_buildings__["o" /* getSelectedContractors */])(state),selectedUnionsId:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_buildings_buildings__["p" /* getSelectedUnionsId */])(state),unions:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_buildings_buildings__["q" /* getUnions */])(state),validationMessage:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_buildings_buildings__["r" /* getValidationMessage */])(state)};})(NewBuilding));

/***/ }),
/* 2344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuildingDetails_css__ = __webpack_require__(2346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuildingDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BuildingDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_buildings_buildings__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_buildings_buildings__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_details_DetailsHeader__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_details_DetailsInfo__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfoItem__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_free_solid_faInfoCircle__ = __webpack_require__(2347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_free_solid_faInfoCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_free_solid_faInfoCircle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_document_BuildingDocumentsViewer__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_admin_buildings_BuildingDetailsWorkOrders__ = __webpack_require__(2348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_admin_buildings_BuildingDetailsProjects__ = __webpack_require__(2349);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BuildingDetails=function(_Component){_inherits(BuildingDetails,_Component);function BuildingDetails(props){_classCallCheck(this,BuildingDetails);// Keep track of id to avoid showing an "old" building while loading the current one
var _this=_possibleConstructorReturn(this,(BuildingDetails.__proto__||Object.getPrototypeOf(BuildingDetails)).call(this,props));_this.handleWorkOrderSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_work_orders__["h" /* goToWorkOrder */])(_this.props.workOrders.content[index].id,_this.props.workOrders.content[index].status));};_this.handleEdit=function(){Object(__WEBPACK_IMPORTED_MODULE_15_services_utils_scroller_util__["c" /* simpleScrollToTop */])();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_buildings_buildings__["c" /* editBuilding */])(_this.props.currentBuilding.id));};_this.handleNavSelect=function(value){_this.currentNav=value;_this.handleChange(1);};_this.handlePageChange=function(newPage){_this.handleChange(newPage);};_this.buildingId=__WEBPACK_IMPORTED_MODULE_2_numeral___default()(_this.props.match.params.id).value();_this.userIsAdmin=__WEBPACK_IMPORTED_MODULE_17_services_utils_users_util__["g" /* usersUtil */].hasRole(props.currentUser,__WEBPACK_IMPORTED_MODULE_17_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN);_this.userIsGC=__WEBPACK_IMPORTED_MODULE_17_services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_17_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);_this.currentNav=_this.userIsGC?2:1;return _this;}_createClass(BuildingDetails,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.currentBuilding===null||this.props.currentBuilding.id!==this.buildingId){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_buildings_buildings__["e" /* loadBuildingDetailsRequest */])(this.buildingId,this.userIsAdmin||this.userIsGC));}}},{key:'handleChange',value:function handleChange(page){switch(this.currentNav){case 1:this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_buildings_buildings__["j" /* loadWorkOrdersRequest */])(this.props.currentBuilding.id,page));break;case 2:this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_buildings_buildings__["h" /* loadProjectsRequest */])(this.props.currentBuilding.id,page));break;default:}}},{key:'render',value:function render(){var _this2=this;var currentBuilding=this.props.currentBuilding;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'building-details'},currentBuilding!==null&&currentBuilding.id===this.buildingId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['BUILDINGS'].concat(currentBuilding.name!==null&&currentBuilding.name!==''?currentBuilding.name.toUpperCase():[])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_details_DetailsHeader__["a" /* default */],{leftHeader:{title:'BUILDING',value:currentBuilding.name!==null&&currentBuilding.name!==''?currentBuilding.name:currentBuilding.location.street_address_1},rightHeaders:[[{title:'IN PROGRESS',value:currentBuilding.wo_in_progress_count},{title:'COMPLETED',value:currentBuilding.wo_complete_count},{title:'TOTAL SPENT',value:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_text_Number__["a" /* default */],{value:currentBuilding.total_spent,format:'$0,0'})}]].filter(function(header){return!_this2.userIsGC;})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-info-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_details_DetailsInfo__["a" /* default */],{itemsContainerSize:9,itemsLines:[[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[currentBuilding.location.street_address_1,currentBuilding.location.city+', '+currentBuilding.location.state+' '+currentBuilding.location.zip],title:'ADDRESS'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[currentBuilding.property_owner_name,currentBuilding.property_owner_address&&currentBuilding.property_owner_address.street_address_1,currentBuilding.property_owner_address&&currentBuilding.property_owner_address.street_address_2,currentBuilding.property_owner_address&&''+currentBuilding.property_owner_address.city+(', '+currentBuilding.property_owner_address.state)+(', '+currentBuilding.property_owner_address.zip)],title:'PROPERTY OWNER'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:currentBuilding.property_manager!==null?[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,currentBuilding.property_manager.first_name+' '+currentBuilding.property_manager.last_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,currentBuilding.property_manager.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_16_services_utils_text_util__["c" /* formatPhoneNumber */])(currentBuilding.property_manager.phone_number))]:[],title:'PROPERTY MANAGER'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:currentBuilding.engineer!==null?[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,currentBuilding.engineer.first_name+' '+currentBuilding.engineer.last_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,currentBuilding.engineer.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_16_services_utils_text_util__["c" /* formatPhoneNumber */])(currentBuilding.engineer.phone_number))]:[],title:'BUILDING ENGINEER'})],[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:currentBuilding.unions.map(function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element.label);}),title:'UNION REQUIREMENTS'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfoItem__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_free_solid_faInfoCircle___default.a,lines:[currentBuilding.parking_on_site?'Yes (Validated)':'No'],title:'PARKING ON SITE'})]],rightContainerSize:3,rightContainer:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buildings-documents-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_document_BuildingDocumentsViewer__["a" /* default */],{documents:currentBuilding.documents}))}),(this.userIsAdmin||this.userIsGC||__WEBPACK_IMPORTED_MODULE_17_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_17_services_utils_users_util__["f" /* TYPES */].CLIENT))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edit-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-gray',value:'Edit',onClick:this.handleEdit}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'Work Orders',show:!this.userIsGC},{id:2,title:'Projects'}],selectedValue:this.currentNav,onSelected:this.handleNavSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navigation-content'},this.currentNav===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_admin_buildings_BuildingDetailsWorkOrders__["a" /* default */],null),this.currentNav===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_admin_buildings_BuildingDetailsProjects__["a" /* default */],null))))));}}]);return BuildingDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentBuilding:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_buildings_buildings__["f" /* getCurrentBuilding */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_buildings_buildings__["g" /* getCurrentPage */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_18_selectors_authentication__["d" /* getCurrentUser */])(state),workOrders:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_buildings_buildings__["s" /* getWorkOrders */])(state),prjects:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_buildings_buildings__["m" /* getProjects */])(state)};})(BuildingDetails));

/***/ }),
/* 2346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2347 */
/***/ (function(module, exports) {

module.exports = { prefix: 'fas', iconName: 'info-circle', icon: [512, 512, [], "f05a", "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"] };

/***/ }),
/* 2348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_admin_buildings_buildings__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_buildings_buildings__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_work_orders_ResourceWorkOrders__ = __webpack_require__(592);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BuildingDetailsWorkOrders=function(_Component){_inherits(BuildingDetailsWorkOrders,_Component);function BuildingDetailsWorkOrders(){_classCallCheck(this,BuildingDetailsWorkOrders);return _possibleConstructorReturn(this,(BuildingDetailsWorkOrders.__proto__||Object.getPrototypeOf(BuildingDetailsWorkOrders)).apply(this,arguments));}_createClass(BuildingDetailsWorkOrders,[{key:'render',value:function render(){var _props=this.props,currentBuilding=_props.currentBuilding,currentPage=_props.currentPage,workOrders=_props.workOrders;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_work_orders_ResourceWorkOrders__["a" /* default */],{resource:currentBuilding,workOrders:workOrders,currentPage:currentPage,loadWorkOrdersRequest:__WEBPACK_IMPORTED_MODULE_3_actions_admin_buildings_buildings__["j" /* loadWorkOrdersRequest */]});}}]);return BuildingDetailsWorkOrders;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentBuilding:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_buildings_buildings__["f" /* getCurrentBuilding */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_buildings_buildings__["g" /* getCurrentPage */])(state),workOrders:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_buildings_buildings__["s" /* getWorkOrders */])(state)};})(BuildingDetailsWorkOrders));

/***/ }),
/* 2349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_admin_buildings_buildings__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_buildings_buildings__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_projects_ResourceProjects__ = __webpack_require__(593);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BuildingDetailsProjects=function(_Component){_inherits(BuildingDetailsProjects,_Component);function BuildingDetailsProjects(){_classCallCheck(this,BuildingDetailsProjects);return _possibleConstructorReturn(this,(BuildingDetailsProjects.__proto__||Object.getPrototypeOf(BuildingDetailsProjects)).apply(this,arguments));}_createClass(BuildingDetailsProjects,[{key:'render',value:function render(){var _props=this.props,currentBuilding=_props.currentBuilding,currentPage=_props.currentPage,projects=_props.projects;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_projects_ResourceProjects__["a" /* default */],{resource:currentBuilding,projects:projects,currentPage:currentPage,loadProjectsRequest:__WEBPACK_IMPORTED_MODULE_3_actions_admin_buildings_buildings__["h" /* loadProjectsRequest */]});}}]);return BuildingDetailsProjects;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentBuilding:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_buildings_buildings__["f" /* getCurrentBuilding */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_buildings_buildings__["g" /* getCurrentPage */])(state),projects:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_buildings_buildings__["m" /* getProjects */])(state)};})(BuildingDetailsProjects));

/***/ }),
/* 2350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Clients__ = __webpack_require__(2351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ClientDetails__ = __webpack_require__(2355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_clients_EditClient__ = __webpack_require__(2370);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClientsContainer=function(_Component){_inherits(ClientsContainer,_Component);function ClientsContainer(props){_classCallCheck(this,ClientsContainer);var _this=_possibleConstructorReturn(this,(ClientsContainer.__proto__||Object.getPrototypeOf(ClientsContainer)).call(this,props));_this.state={hasError:false};return _this;}_createClass(ClientsContainer,[{key:'componentDidCatch',value:function componentDidCatch(error,info){this.setState({hasError:true});this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_messages__["d" /* showErrorMessage */])('Something went wrong with the request, please try again later.'));}},{key:'render',value:function render(){if(this.state.hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Redirect */],{to:'/'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/',component:__WEBPACK_IMPORTED_MODULE_3__Clients__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/:id',component:__WEBPACK_IMPORTED_MODULE_4__ClientDetails__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/:id/edit',component:__WEBPACK_IMPORTED_MODULE_6_components_admin_clients_EditClient__["a" /* default */]})));}}}]);return ClientsContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])()(ClientsContainer));

/***/ }),
/* 2351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Clients_css__ = __webpack_require__(2352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Clients_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Clients_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_navigation_SearchBar__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_text_SimpleText__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_admin_clients_clients__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_selectors_admin_clients_clients__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ClientInviteModal__ = __webpack_require__(2353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Clients=function(_Component){_inherits(Clients,_Component);function Clients(props){_classCallCheck(this,Clients);var _this=_possibleConstructorReturn(this,(Clients.__proto__||Object.getPrototypeOf(Clients)).call(this,props));_this.handleClientSelection=function(index){Object(__WEBPACK_IMPORTED_MODULE_9_services_utils_scroller_util__["c" /* simpleScrollToTop */])();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_clients_clients__["d" /* goToClient */])(_this.props.clients[index].id));};_this.handleClientsPageChange=function(newPage){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_clients_clients__["i" /* loadClientsRequest */])(newPage));};_this.handleSearchTextChange=function(value){_this.setState({nameToSearch:value});_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_clients_clients__["i" /* loadClientsRequest */])(1,value));};_this.handleSearchTextClear=function(){_this.handleSearchTextChange('');};_this.handleGenerateLink=function(index){var clients=_this.props.clients;return'clients/'+clients[index].id;};_this.handleInviteClient=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_clients_clients__["c" /* clearClientForm */])());_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_clients_clients__["r" /* setShowInviteClientModal */])(true));};_this.mapClients=function(clients){return clients.map(function(client){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},client.company_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_SimpleText__["a" /* default */],{lines:client.location!==null?[client.location.street_address_1,client.location.city]:['N/A']}),client.contact!==null?client.contact.first_name+' '+client.contact.last_name:'N/A',client.wo_in_progress_count,client.wo_complete_count,client.balance_due!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Number__["a" /* default */],{value:client.balance_due,format:'$0,0'}):'N/A'];});};_this.state={nameToSearch:''};return _this;}_createClass(Clients,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_clients_clients__["i" /* loadClientsRequest */])(1));}},{key:'componentDidUpdate',value:function componentDidUpdate(){Object(__WEBPACK_IMPORTED_MODULE_9_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}},{key:'render',value:function render(){var nameToSearch=this.state.nameToSearch;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clients'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Clients'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_navigation_SearchBar__["a" /* default */],{addButton:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_button_Button__["a" /* default */],{id:'invite-client',className:'button-orange',label:'Invite Client',onClick:this.handleInviteClient}),searchPlaceHolder:'Search by Name',searchText:nameToSearch,onSearchTextChange:this.handleSearchTextChange,onClearText:this.handleSearchTextClear,onSearch:this.handleSearchTextChange},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__["a" /* default */],{className:'clients-table',headers:['COMPANY NAME','ADDRESS','POC','IN PROGRESS','COMPLETED','BALANCE DUE'],rows:this.mapClients(this.props.clients),emptyMessage:'No Clients',onRowSelected:this.handleClientSelection,onGenerateLink:this.handleGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.clientsCurrentPage,pageSize:this.props.clientsPageSize,total:this.props.clientsTotal,onPageChange:this.handleClientsPageChange}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ClientInviteModal__["a" /* default */],null));}}]);return Clients;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{clients:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_clients_clients__["b" /* getClients */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_authentication__["d" /* getCurrentUser */])(state),clientsCurrentPage:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_clients_clients__["c" /* getClientsCurrentPage */])(state),clientsTotal:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_clients_clients__["e" /* getClientsTotal */])(state),clientsPageSize:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_clients_clients__["d" /* getClientsPageSize */])(state)};})(Clients));

/***/ }),
/* 2352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ClientInviteModal_css__ = __webpack_require__(2354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ClientInviteModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ClientInviteModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_MessageModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_clients_clients__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_selectors_admin_clients_clients__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_radio_button_RadioButton__ = __webpack_require__(160);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClientInviteModal=function(_Component){_inherits(ClientInviteModal,_Component);function ClientInviteModal(props){_classCallCheck(this,ClientInviteModal);var _this=_possibleConstructorReturn(this,(ClientInviteModal.__proto__||Object.getPrototypeOf(ClientInviteModal)).call(this,props));_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_clients_clients__["r" /* setShowInviteClientModal */])(false));};_this.handleCreateClient=function(existentClientId){if(existentClientId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_clients_clients__["g" /* inviteExistentClient */])(existentClientId));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_clients_clients__["f" /* inviteClient */])(_this.props.form)).then(function(response){if(response.ok){_this.setState({showConfirmationMessage:true});}});}};_this.handleSimilarClient=function(client,similarMsg){var message=similarMsg+' Do you want to use it?';_this.setState({confirmSimilarClient:{clientId:client.id,message:message}});};_this.similarClientConfirmed=function(confirmed){var clientId=_this.state.confirmSimilarClient.clientId;_this.setState({confirmSimilarClient:null});_this.handleCreateClient(confirmed?clientId:null);};_this.handleSubmit=function(event){event.preventDefault();var promise=_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_clients_clients__["v" /* submitFormRequest */])(_this.props.form));if(promise!==null){promise.then(function(response){if(response.ok){if(response.client){_this.handleSimilarClient(response.client,response.message);}else{_this.handleCreateClient();}}});}};_this.handleAttributeChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_clients_clients__["y" /* updateFormValue */])(attribute,value));};_this.handleCloseConfirmationModal=function(){_this.setState({showConfirmationMessage:false});};_this.state={showConfirmationMessage:false,confirmSimilarClient:null};return _this;}_createClass(ClientInviteModal,[{key:'isFieldValid',value:function isFieldValid(fieldName){return this.props.invalidFields.find(function(element){return element===fieldName;})===undefined;}},{key:'render',value:function render(){var _this2=this;var _state=this.state,showConfirmationMessage=_state.showConfirmationMessage,confirmSimilarClient=_state.confirmSimilarClient;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'invite-client-form-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_modal_FormModal__["a" /* default */],{className:'invite-client-modal',show:this.props.showInviteClientModal,title:'Invite Client',onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'Company Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__["a" /* default */],{id:'company-name',placeholder:'Company Name',valid:this.isFieldValid('companyName'),value:this.props.form.companyName,theme:'normal',onChange:this.handleAttributeChange.bind(this,'companyName')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'First Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__["a" /* default */],{id:'first-name',placeholder:'First Name',valid:this.isFieldValid('firstName'),value:this.props.form.firstName,theme:'normal',onChange:this.handleAttributeChange.bind(this,'firstName')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'Last Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__["a" /* default */],{id:'last-name',placeholder:'Last Name',theme:'normal',valid:this.isFieldValid('lastName'),value:this.props.form.lastName,onChange:this.handleAttributeChange.bind(this,'lastName')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__["a" /* default */],{id:'email',placeholder:'Email',theme:'normal',type:'email',valid:this.isFieldValid('email'),value:this.props.form.email,onChange:this.handleAttributeChange.bind(this,'email')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'Phone Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__["a" /* default */],{id:'phone-number',placeholder:'Phone Number',theme:'normal',valid:this.isFieldValid('phoneNumber'),value:this.props.form.phoneNumber,onChange:this.handleAttributeChange.bind(this,'phoneNumber')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'Street Address 1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__["a" /* default */],{id:'street-address-1',placeholder:'Street Address 1',theme:'normal',valid:this.isFieldValid('streetAddress1'),value:this.props.form.streetAddress1,onChange:this.handleAttributeChange.bind(this,'streetAddress1')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'Street Address 2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__["a" /* default */],{placeholder:'Street Address 2',theme:'normal',valid:this.isFieldValid('streetAddress2'),value:this.props.form.streetAddress2,onChange:this.handleAttributeChange.bind(this,'streetAddress2')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'City / State'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__["a" /* default */],{id:'city',placeholder:'City',theme:'normal',valid:this.isFieldValid('city'),value:this.props.form.city,onChange:this.handleAttributeChange.bind(this,'city')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__["a" /* default */],{id:'state',placeholder:'State',theme:'normal',valid:this.isFieldValid('state'),value:this.props.form.state,onChange:this.handleAttributeChange.bind(this,'state')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'Zip'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__["a" /* default */],{id:'zip',placeholder:'Zip',theme:'normal',valid:this.isFieldValid('zip'),value:this.props.form.zip,onChange:this.handleAttributeChange.bind(this,'zip')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'Global PO with running balance?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_radio_button_RadioButton__["a" /* default */],{options:[{value:1,label:'Yes'},{value:0,label:'No'}],value:this.props.form.globalPurchaseOrderRequired!==null?this.props.form.globalPurchaseOrderRequired?1:0:null,onChange:function onChange(value){return _this2.handleAttributeChange('globalPurchaseOrderRequired',value===1);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'PO for each work order?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_radio_button_RadioButton__["a" /* default */],{options:[{value:1,label:'Yes'},{value:0,label:'No'}],value:this.props.form.purchaseOrderRequired!==null?this.props.form.purchaseOrderRequired?1:0:null,onChange:function onChange(value){return _this2.handleAttributeChange('purchaseOrderRequired',value===1);}}))),this.props.validationMessage!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},this.props.validationMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'send-invite',className:'btn button button-orange',value:'Send Invite',type:'submit'}))))),confirmSimilarClient&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_modal_ConfirmationModal__["a" /* default */],{show:confirmSimilarClient?true:false,message:confirmSimilarClient.message,onHide:this.similarClientConfirmed}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_MessageModal__["a" /* default */],{show:showConfirmationMessage,message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'An invite has been sent to ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.form.email),' to join Spackle as Client.'),onHide:this.handleCloseConfirmationModal}));}}]);return ClientInviteModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{form:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_clients_clients__["i" /* getForm */])(state),invalidFields:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_clients_clients__["j" /* getInvalidFields */])(state),showInviteClientModal:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_clients_clients__["p" /* getShowInviteClientModal */])(state),validationMessage:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_admin_clients_clients__["t" /* getValidationMessage */])(state)};})(ClientInviteModal));

/***/ }),
/* 2354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_details_DetailsHeader__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClientDetails_css__ = __webpack_require__(2356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClientDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ClientDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_details_DetailsInfo__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_details_DetailsInfoItem__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_admin_clients_clients__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_services_utils_work_order_status_enum__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_actions_admin_invoices_invoices__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_shared_table_SimpleHeader__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_shared_modal_ContactsModal__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_domain_client__ = __webpack_require__(2357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_admin_clients_ClientInviteUserModal__ = __webpack_require__(2358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_services_utils_permissions_util__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_admin_surveys_SurveysTable__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_admin_surveys_SurveyRating__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_admin_surveys_store_actions__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_components_admin_clients_ClientDetailsNoteEditor__ = __webpack_require__(2365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_shared_logo_upload_LogoUpload__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_components_admin_clients_ClientDetailsWorkOrders__ = __webpack_require__(2368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_components_admin_clients_ClientDetailsProjects__ = __webpack_require__(2369);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClientDetails=function(_Component){_inherits(ClientDetails,_Component);function ClientDetails(props){_classCallCheck(this,ClientDetails);// Keep track of id to avoid showing an "old" client while loading the current one
var _this=_possibleConstructorReturn(this,(ClientDetails.__proto__||Object.getPrototypeOf(ClientDetails)).call(this,props));_this.handleInvoiceSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions_admin_invoices_invoices__["g" /* goToInvoice */])(_this.props.invoices.content[index].id));};_this.handleNavSelect=function(value){var _this$props=_this.props,currentClient=_this$props.currentClient,dispatch=_this$props.dispatch;_this.currentNav=value;switch(value){case 1:dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["p" /* loadWorkOrdersRequest */])(currentClient.id,1)).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["b" /* changeFilter */])('all'));}});break;case 2:dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["k" /* loadInvoicesRequest */])(currentClient.id,1)).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["b" /* changeFilter */])('all'));}});break;case 3:dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["m" /* loadPurchaseOrdersRequest */])(currentClient.id,1));break;case 4:dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["o" /* loadSurveysRequest */])(currentClient.id,1));break;case 5:dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["l" /* loadProjectsRequest */])(currentClient.id,1));break;default:}};_this.handlePageChange=function(newPage){// Take into account if the "pending" section is selected
var _this$props2=_this.props,currentFilter=_this$props2.currentFilter,currentClient=_this$props2.currentClient,dispatch=_this$props2.dispatch;switch(_this.currentNav){case 2:dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["k" /* loadInvoicesRequest */])(currentClient.id,newPage,currentFilter));break;case 3:dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["m" /* loadPurchaseOrdersRequest */])(currentClient.id,newPage));break;case 4:dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["o" /* loadSurveysRequest */])(currentClient.id,newPage));break;default:}};_this.handleFilterSelect=function(filter){var status=__WEBPACK_IMPORTED_MODULE_14_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(filter);if(!__WEBPACK_IMPORTED_MODULE_14_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].UNKNOWN.equals(status)){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["p" /* loadWorkOrdersRequest */])(_this.props.currentClient.id,1,status)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["b" /* changeFilter */])(filter));}});}else{// If status is unknow is because filter is "all"
_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["p" /* loadWorkOrdersRequest */])(_this.props.currentClient.id,1)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["b" /* changeFilter */])(filter));}});}};_this.handleInvoicesFilterSelect=function(filter){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["k" /* loadInvoicesRequest */])(_this.props.currentClient.id,1,filter)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["b" /* changeFilter */])(filter));}});};_this.handleViewAll=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["u" /* showContactsRequest */])(_this.props.currentClient.id,_this.props.users,_this.props.buildings));};_this.handleContactsModalClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["t" /* showContactsModal */])(false));};_this.handleInviteUserClick=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["c" /* clearClientForm */])());_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["s" /* setShowInviteUserClientModal */])(true));};_this.handleEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["e" /* goToEditClient */])(_this.props.currentClient.id));};_this.mapInvoices=function(invoices){return invoices.map(function(invoice){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},invoice.work_order.number),Object(__WEBPACK_IMPORTED_MODULE_16_services_utils_text_util__["e" /* toUpperFirstLetter */])(invoice.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_text_Date__["a" /* default */],{value:invoice.due_date,format:'LL'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_text_Number__["a" /* default */],{value:invoice.cost,format:'$0,0'})];});};_this.mapPurchaseOrders=function(purchaseOrders){return purchaseOrders.map(function(purchaseOrder){return[purchaseOrder.number,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_text_Number__["a" /* default */],{value:purchaseOrder.amount,format:'$0,0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_text_Number__["a" /* default */],{value:purchaseOrder.balance,format:'$0,0'}),purchaseOrder.document!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_shared_document_DocumentLink__["a" /* default */],{showIcon:false,showLink:true,url:purchaseOrder.document.document.url}):'N/A'];});};_this.mapUsers=function(users){return users.map(function(user){return{email:user.email,lastSignIn:user.current_sign_in_at,name:user.first_name+' '+user.last_name,phoneNumber:user.phone_number,primaryContact:user.account_creator,title:user.title};});};_this.clientId=__WEBPACK_IMPORTED_MODULE_2_numeral___default()(props.match.params.id).value();_this.canSeeMoney=__WEBPACK_IMPORTED_MODULE_24_services_utils_permissions_util__["a" /* PermissionsUtil */].adminUserCanSeeMoney(props.currentUser);_this.userIsSpackleAdmin=__WEBPACK_IMPORTED_MODULE_25_services_utils_users_util__["g" /* usersUtil */].hasRole(props.currentUser,__WEBPACK_IMPORTED_MODULE_25_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN);_this.userIsAdmin=__WEBPACK_IMPORTED_MODULE_25_services_utils_users_util__["g" /* usersUtil */].isAdmin(props.currentUser);_this.currentNav=_this.userIsAdmin?1:5;return _this;}_createClass(ClientDetails,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["h" /* loadClientRequest */])(this.clientId));if(this.currentNav===1){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["p" /* loadWorkOrdersRequest */])(this.clientId,1));}else{this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["l" /* loadProjectsRequest */])(this.clientId,1));}}},{key:'render',value:function render(){var _this2=this;var currentClient=this.props.currentClient;var rightHeaders=[];if(currentClient!==null&&this.userIsAdmin){rightHeaders=[[{title:'WO COMPLETED',value:currentClient.wo_complete_count},{title:'AVERAGE RATING',value:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_components_admin_surveys_SurveyRating__["a" /* default */],{rating:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(currentClient.avg_rating).value(),showWaiting:false})},{title:'TOTAL SPENT',value:currentClient.total_spent!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_text_Number__["a" /* default */],{value:currentClient.total_spent,format:'$0,0'}):'N/A'},{title:'AVG VARIANCE',value:__WEBPACK_IMPORTED_MODULE_20_domain_client__["a" /* Client */].getVariance(currentClient,'N/A')}]];if(currentClient.purchase_order!==null&&currentClient.purchase_order!==undefined){rightHeaders.push([{title:'CURRENT PO #',value:currentClient.purchase_order.number},{title:'AMOUNT',value:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_text_Number__["a" /* default */],{value:currentClient.purchase_order.amount,format:'$0,0'})},{title:'BALANCE',value:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_text_Number__["a" /* default */],{value:currentClient.purchase_order.balance,format:'$0,0'})},{title:'',value:''}]);}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'client-details'},currentClient!==null&&currentClient.id===this.clientId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['CLIENTS',currentClient.company_name.toUpperCase()]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_details_DetailsHeader__["a" /* default */],{leftHeader:{title:'CLIENT',value:currentClient.company_name},leftHeaderExtraComponents:currentClient.logo&&currentClient.logo.image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-preview-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_components_shared_logo_upload_LogoUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],logos:[{preview:currentClient.logo.image.url,url:currentClient.logo.image.url}],readOnly:true})),rightHeaders:rightHeaders}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-info-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edit-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-gray',value:'Edit',onClick:this.handleEdit})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_details_DetailsInfo__["a" /* default */],{itemsContainerSize:8,itemsLines:[[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:currentClient.location!==null?[currentClient.location.street_address_1,currentClient.location.city+', '+currentClient.location.state+' '+currentClient.location.zip]:['N/A'],title:'ADDRESS'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'name'},currentClient.contact.first_name+' '+currentClient.contact.last_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'email'},currentClient.contact.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_16_services_utils_text_util__["c" /* formatPhoneNumber */])(currentClient.contact.phone_number))],title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'PRIMARY CONTACT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'view-all',onClick:this.handleViewAll},'View All'))}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:currentClient.propietary_sub_contractors.map(function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'contractor'},element.name);}),title:'PROPRIETARY SUBCONTRACTORS'})]],rightContainer:this.userIsAdmin&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'note-editor-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_components_admin_clients_ClientDetailsNoteEditor__["a" /* default */],null)),rightContainerSize:2})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'Work Orders',show:this.userIsAdmin},{id:2,title:'Invoices',show:this.userIsAdmin&&this.canSeeMoney},{id:3,title:'Purchase Orders',show:this.userIsAdmin},{id:4,title:'Surveys',show:this.userIsAdmin},{id:5,title:'Projects',class:this.currentNav===5?'selected':''}],onSelected:this.handleNavSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navigation-content'},this.currentNav===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32_components_admin_clients_ClientDetailsWorkOrders__["a" /* default */],null),this.currentNav===2&&this.props.invoices!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_table_SimpleTable__["a" /* default */],{className:'invoices-table',headers:['WO #',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_shared_table_SimpleHeader__["a" /* default */],{label:'STATUS',filter:{options:[{id:'all',label:'All'},{id:'paid',label:'Paid'},{id:'overdue',label:'Overdue'}],selected:this.props.currentFilter},onFilterOptionSelect:this.handleInvoicesFilterSelect}),'DUE DATE','AMOUNT DUE'],rows:this.mapInvoices(this.props.invoices.content),emptyMessage:'No Invoices',onRowSelected:this.handleInvoiceSelection}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.currentPage,pageSize:this.props.invoices.pageSize,total:this.props.invoices.total,onPageChange:this.handlePageChange}))),this.currentNav===3&&this.props.purchaseOrders!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_table_SimpleTable__["a" /* default */],{className:'purchase-orders-table',headers:['PO #','AMOUNT','BALANCE','DOCUMENT'],rows:this.mapPurchaseOrders(this.props.purchaseOrders.content),emptyMessage:'No Purchase Orders'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.currentPage,pageSize:this.props.purchaseOrders.pageSize,total:this.props.purchaseOrders.total,onPageChange:this.handlePageChange}))),this.currentNav===4&&this.props.surveys!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'surveys-table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_components_admin_surveys_SurveysTable__["a" /* default */],{showClient:false,surveys:this.props.surveys.content,onRowSelected:function onRowSelected(index){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_29_components_admin_surveys_store_actions__["d" /* goToSurvey */])(_this2.props.surveys.content[index].id));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.currentPage,pageSize:this.props.surveys.pageSize,total:this.props.surveys.total,onPageChange:this.handlePageChange}))),this.currentNav===5&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_components_admin_clients_ClientDetailsProjects__["a" /* default */],null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_shared_modal_ContactsModal__["a" /* default */],{footer:this.userIsSpackleAdmin?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contacts-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_shared_button_Button__["a" /* default */],{label:'Invite User',className:'button-orange',onClick:this.handleInviteUserClick})):null,show:this.props.showContactsModal,users:this.mapUsers(this.props.users),onClose:this.handleContactsModalClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_admin_clients_ClientInviteUserModal__["a" /* default */],null));}}]);return ClientDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{buildings:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_clients_clients__["a" /* getBuildings */])(state),currentClient:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_clients_clients__["f" /* getCurrentClient */])(state),currentFilter:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_clients_clients__["g" /* getCurrentFilter */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_23_selectors_authentication__["d" /* getCurrentUser */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_clients_clients__["h" /* getCurrentPage */])(state),invoices:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_clients_clients__["k" /* getInvoices */])(state),purchaseOrders:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_clients_clients__["m" /* getPurchaseOrders */])(state),showContactsModal:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_clients_clients__["o" /* getShowContactsModal */])(state),surveys:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_clients_clients__["r" /* getSurveys */])(state),users:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_clients_clients__["s" /* getUsers */])(state),workOrders:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_clients_clients__["u" /* getWorkOrders */])(state),projects:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_clients_clients__["l" /* getProjects */])(state)};})(ClientDetails));

/***/ }),
/* 2356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Client; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Client=function(){function Client(){_classCallCheck(this,Client);}_createClass(Client,null,[{key:"getVariance",value:function getVariance(client){var defaultValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return client.avg_variance!==null?client.avg_variance+"%":defaultValue;}}]);return Client;}();

/***/ }),
/* 2358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientInviteUserModal_css__ = __webpack_require__(2359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientInviteUserModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ClientInviteUserModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_InviteUserModal__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_admin_clients_clients__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_admin_clients_clients__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_domain_building__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_select_MultipleSelectList__ = __webpack_require__(334);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClientInviteUserModal=function(_Component){_inherits(ClientInviteUserModal,_Component);function ClientInviteUserModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientInviteUserModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientInviteUserModal.__proto__||Object.getPrototypeOf(ClientInviteUserModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_clients_clients__["s" /* setShowInviteUserClientModal */])(false));},_this.handleSubmit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_clients_clients__["w" /* submitInviteUserFormRequest */])(_this.props.form,_this.props.currentClient.id,_this.props.roles));},_this.handleAttributeChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_clients_clients__["y" /* updateFormValue */])(attribute,value));},_this.handleBuildingSelect=function(buildingId){if(_this.props.form.buildingsId.find(function(id){return id===buildingId;})!==undefined){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_clients_clients__["y" /* updateFormValue */])('buildingsId',_this.props.form.buildingsId.filter(function(id){return id!==buildingId;})));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_clients_clients__["y" /* updateFormValue */])('buildingsId',_this.props.form.buildingsId.concat([buildingId])));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientInviteUserModal,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.roles.length===0){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_clients_clients__["n" /* loadRolesRequest */])());}}},{key:'render',value:function render(){var _this2=this;var showBuildings=false;var businessMaganerRole=this.props.roles.find(function(role){return role.name===__WEBPACK_IMPORTED_MODULE_3_services_utils_users_util__["e" /* ROLES */].CLIENT_BUILDING_MANAGER;});if(businessMaganerRole!==null){showBuildings=this.props.form.rolesId.find(function(id){return id===businessMaganerRole.id;})!==undefined;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_InviteUserModal__["b" /* default */],{className:'client-invite-user-modal',form:[{attribute:'firstName',label:'First Name',renderer:'input'},{attribute:'lastName',label:'Last Name',renderer:'input'},{attribute:'title',label:'Title',renderer:'input'},{attribute:'email',label:'Email',renderer:'input'},{attribute:'phoneNumber',formatter:__WEBPACK_IMPORTED_MODULE_5_services_utils_text_util__["c" /* formatPhoneNumber */],label:'Phone Number',renderer:'input'},{attribute:'rolesId',label:'Work Order Permissions',renderer:'multiple',options:this.props.roles.filter(function(role){return role.name!==__WEBPACK_IMPORTED_MODULE_3_services_utils_users_util__["e" /* ROLES */].OWNER;}).map(function(role){return{value:role.id,label:__WEBPACK_IMPORTED_MODULE_3_services_utils_users_util__["b" /* CLIENT_ROLES */][role.name]};})},{attribute:'buildingsId',label:'Building',renderer:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-12 building-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body-bold'},'Please assign buildings to this user'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_select_MultipleSelectList__["a" /* default */],{options:this.props.buildings.map(function(building){return{id:building.id,selected:_this2.props.form['buildingsId'].find(function(id){return id===building.id;})!==undefined,value:__WEBPACK_IMPORTED_MODULE_8_domain_building__["a" /* Building */].getPrettyName(building,true)};}),show:5,onSelect:this.handleBuildingSelect})),show:showBuildings}],invalidFields:this.props.invalidFields,modalState:__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_InviteUserModal__["a" /* UserModalState */].NEW,show:this.props.showInviteClientUserModal,values:this.props.form,validationMessage:this.props.validationMessage,onAttributeChange:this.handleAttributeChange,onClose:this.handleClose,onSubmit:this.handleSubmit}));}}]);return ClientInviteUserModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{buildings:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_clients_clients__["a" /* getBuildings */])(state),currentClient:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_clients_clients__["f" /* getCurrentClient */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_clients_clients__["i" /* getForm */])(state),invalidFields:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_clients_clients__["j" /* getInvalidFields */])(state),roles:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_clients_clients__["n" /* getRoles */])(state),showInviteClientUserModal:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_clients_clients__["q" /* getShowInviteClientUserModal */])(state),validationMessage:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_clients_clients__["t" /* getValidationMessage */])(state)};})(ClientInviteUserModal));

/***/ }),
/* 2359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/star_dark_gray.2752d354.svg";

/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/star_gray.50b52586.svg";

/***/ }),
/* 2365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_NoteEditor__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_clients_clients__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_clients_clients__ = __webpack_require__(129);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClientDetailsNoteEditor=function(_Component){_inherits(ClientDetailsNoteEditor,_Component);function ClientDetailsNoteEditor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientDetailsNoteEditor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientDetailsNoteEditor.__proto__||Object.getPrototypeOf(ClientDetailsNoteEditor)).call.apply(_ref,[this].concat(args))),_this),_this.handleSave=function(){var _this$props=_this.props,currentClient=_this$props.currentClient,noteEditor=_this$props.noteEditor,onSave=_this$props.onSave;onSave(currentClient.id,noteEditor.text,noteEditor.reminder);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientDetailsNoteEditor,[{key:'render',value:function render(){var _props=this.props,currentClient=_props.currentClient,noteEditor=_props.noteEditor,onEdit=_props.onEdit,onNoteReminderChange=_props.onNoteReminderChange,onNoteTextChange=_props.onNoteTextChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_NoteEditor__["a" /* default */],{editButtonLabel:'Edit Note',edit:noteEditor.edit,label:'notes',lines:4,reminderLabel:'reminder date',reminderValue:noteEditor.reminder,reminderOriginalValue:currentClient.note_reminder_date,saving:noteEditor.saving,value:noteEditor.text,onEdit:onEdit,onReminderValueChange:onNoteReminderChange,onSave:this.handleSave,onValueChange:onNoteTextChange});}}]);return ClientDetailsNoteEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ClientDetailsNoteEditor.propTypes={currentClient:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,noteEditor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({edit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,reminder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,saving:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,text:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired}).isRequired,onEdit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onNoteReminderChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onNoteTextChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onSave:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};var mapStateToProps=function mapStateToProps(state){return{currentClient:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_clients_clients__["f" /* getCurrentClient */])(state),noteEditor:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_clients_clients__["v" /* noteEditorSelector */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onEdit:function onEdit(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_clients_clients__["q" /* setNoteEditorEdit */])(true));dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_clients_clients__["z" /* updateNoteEditorReminder */])(null));},onNoteReminderChange:function onNoteReminderChange(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_clients_clients__["z" /* updateNoteEditorReminder */])(value));},onNoteTextChange:function onNoteTextChange(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_clients_clients__["A" /* updateNoteEditorText */])(value));},onSave:function onSave(clientId,text,reminder){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_clients_clients__["B" /* updateNotes */])(clientId,text,reminder));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ClientDetailsNoteEditor));

/***/ }),
/* 2366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_image_lightbox__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_lightbox_style_css__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_lightbox_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_image_lightbox_style_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FullScreenImageViewer=function(_Component){_inherits(FullScreenImageViewer,_Component);function FullScreenImageViewer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FullScreenImageViewer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FullScreenImageViewer.__proto__||Object.getPrototypeOf(FullScreenImageViewer)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(event){if(_this.props.onClose){_this.props.onClose();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FullScreenImageViewer,[{key:'render',value:function render(){if(this.props.show){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_image_lightbox__["a" /* default */],{mainSrc:this.props.url,reactModalStyle:{overlay:{zIndex:2000}},onCloseRequest:this.handleClose});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}}]);return FullScreenImageViewer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FullScreenImageViewer.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};FullScreenImageViewer.defaultProps={show:false};/* harmony default export */ __webpack_exports__["a"] = (FullScreenImageViewer);

/***/ }),
/* 2368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_admin_clients_clients__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_clients_clients__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_work_orders_ResourceWorkOrders__ = __webpack_require__(592);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClientDetailsWorkOrders=function(_Component){_inherits(ClientDetailsWorkOrders,_Component);function ClientDetailsWorkOrders(){_classCallCheck(this,ClientDetailsWorkOrders);return _possibleConstructorReturn(this,(ClientDetailsWorkOrders.__proto__||Object.getPrototypeOf(ClientDetailsWorkOrders)).apply(this,arguments));}_createClass(ClientDetailsWorkOrders,[{key:'render',value:function render(){var _props=this.props,currentClient=_props.currentClient,currentPage=_props.currentPage,workOrders=_props.workOrders;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_work_orders_ResourceWorkOrders__["a" /* default */],{resource:currentClient,workOrders:workOrders,currentPage:currentPage,loadWorkOrdersRequest:__WEBPACK_IMPORTED_MODULE_3_actions_admin_clients_clients__["p" /* loadWorkOrdersRequest */]});}}]);return ClientDetailsWorkOrders;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentClient:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_clients_clients__["f" /* getCurrentClient */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_clients_clients__["h" /* getCurrentPage */])(state),workOrders:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_clients_clients__["u" /* getWorkOrders */])(state)};})(ClientDetailsWorkOrders));

/***/ }),
/* 2369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_admin_clients_clients__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_clients_clients__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_projects_ResourceProjects__ = __webpack_require__(593);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClientDetailsProjects=function(_Component){_inherits(ClientDetailsProjects,_Component);function ClientDetailsProjects(){_classCallCheck(this,ClientDetailsProjects);return _possibleConstructorReturn(this,(ClientDetailsProjects.__proto__||Object.getPrototypeOf(ClientDetailsProjects)).apply(this,arguments));}_createClass(ClientDetailsProjects,[{key:'render',value:function render(){var _props=this.props,currentClient=_props.currentClient,currentPage=_props.currentPage,projects=_props.projects;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_projects_ResourceProjects__["a" /* default */],{resource:currentClient,projects:projects,currentPage:currentPage,loadProjectsRequest:__WEBPACK_IMPORTED_MODULE_3_actions_admin_clients_clients__["l" /* loadProjectsRequest */]});}}]);return ClientDetailsProjects;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentClient:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_clients_clients__["f" /* getCurrentClient */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_clients_clients__["h" /* getCurrentPage */])(state),projects:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_clients_clients__["l" /* getProjects */])(state)};})(ClientDetailsProjects));

/***/ }),
/* 2370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_clients_ClientForm__ = __webpack_require__(2371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_clients_clients__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_clients_clients__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditClient=function(_Component){_inherits(EditClient,_Component);function EditClient(props){_classCallCheck(this,EditClient);var _this=_possibleConstructorReturn(this,(EditClient.__proto__||Object.getPrototypeOf(EditClient)).call(this,props));_this.handleOnSubmit=function(values){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_clients_clients__["x" /* updateClientData */])(_this.clientId,values));};_this.clientId=__WEBPACK_IMPORTED_MODULE_5_numeral___default()(props.match.params.id).value();return _this;}_createClass(EditClient,[{key:'UNSAFE_componentWillMount',value:function UNSAFE_componentWillMount(){if(this.props.client===null||this.props.client.id!==this.clientId){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_clients_clients__["h" /* loadClientRequest */])(this.clientId));}}},{key:'render',value:function render(){var client=this.props.client;if(client){this.initialValues={id:client.id,name:client.company_name,firstName:client.contact.first_name,lastName:client.contact.last_name,email:client.contact.email,phoneNumber:client.contact.phone_number,clientLogo:client.logo};if(client.location){this.initialValues['streetAddress']=client.location.street_address_1;this.initialValues['unitNumber']=client.location.street_address_2;this.initialValues['city']=client.location.city;this.initialValues['state']=client.location.state;this.initialValues['zipCode']=client.location.zip;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,client&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_admin_clients_ClientForm__["a" /* default */],{initialValues:this.initialValues,onSubmit:this.handleOnSubmit}));}}]);return EditClient;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{client:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_clients_clients__["f" /* getCurrentClient */])(state)};})(EditClient));

/***/ }),
/* 2371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_clients_ClientForm_css__ = __webpack_require__(2372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_clients_ClientForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_admin_clients_ClientForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_logo_upload_LogoUpload__ = __webpack_require__(102);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClientForm=function(_Component){_inherits(ClientForm,_Component);function ClientForm(props){_classCallCheck(this,ClientForm);var _this=_possibleConstructorReturn(this,(ClientForm.__proto__||Object.getPrototypeOf(ClientForm)).call(this,props));_initialiseProps.call(_this);_this.logo={};var logo=props.initialValues?props.initialValues.clientLogo:null;if(logo&&logo.image&&logo.image.url){logo.url=logo.image.url;_this.logo=logo;}return _this;}_createClass(ClientForm,[{key:'hasLogoImage',value:function hasLogoImage(logo){return logo&&logo.image&&logo.url!=='';}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edit-client'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Edit Client'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8,lg:8,className:'edit-client-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.props.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2'},'Client Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'name',placeholder:'Client Name',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'firstName',placeholder:'Contact First Name',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'lastName',placeholder:'Contact Last Name',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'email',placeholder:'Email',type:'email'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'phoneNumber',placeholder:'Phone Number',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'streetAddress',placeholder:'Street Address',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'unitNumber',placeholder:'Unit number / Floor',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'city',placeholder:'City',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'state',placeholder:'State',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'zipCode',placeholder:'Zip Code',type:'text'}))),this.props.invalid&&this.props.submitFailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'The outlined inputs should be added in order to create a Client.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'submit',value:'Save'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:12,lg:12,className:'special-note'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'special-note-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Client Logo')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.logoComponent,name:'clientLogo'}))));}}]);return ClientForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.setLogo=function(props,files){var file=files[0];var logo={url:URL.createObjectURL(file),file:file,image:file};_this2.logo=logo;props.input.onChange(logo);};this.removeLogo=function(props,index){var logo={id:_this2.logo.id,url:''};_this2.logo=logo;props.input.onChange(logo);};this.logoComponent=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_logo_upload_LogoUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],logos:_this2.hasLogoImage(_this2.logo)?[_this2.logo]:[],onRemove:function onRemove(index){return _this2.removeLogo(props,index);},onUpload:function onUpload(files){return _this2.setLogo(props,files);},useDropzone:true});};this.renderInput=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_input_Input__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));};};function validate(values){var errors={};if(!values.name){errors.name='Required';}if(!values.firstName){errors.firstName='Required';}if(!values.lastName){errors.lastName='Required';}if(!values.email){errors.email='Required';}if(!values.phoneNumber){errors.phoneNumber='Required';}if(!values.streetAddress){errors.streetAddress='Required';}if(!values.city){errors.city='Required';}if(!values.state){errors.state='Required';}if(!values.zipCode){errors.zipCode='Required';}return errors;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["f" /* reduxForm */])({form:'ClientForm',validate:validate})(ClientForm));

/***/ }),
/* 2372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_service_providers_ServiceProviders__ = __webpack_require__(2374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_service_providers_ServiceProvidersDetails__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_service_providers_ServiceProvidersEdit__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_messages__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ServiceProvidersContainer=function(_Component){_inherits(ServiceProvidersContainer,_Component);function ServiceProvidersContainer(props){_classCallCheck(this,ServiceProvidersContainer);var _this=_possibleConstructorReturn(this,(ServiceProvidersContainer.__proto__||Object.getPrototypeOf(ServiceProvidersContainer)).call(this,props));_this.state={hasError:false};return _this;}_createClass(ServiceProvidersContainer,[{key:'componentDidCatch',value:function componentDidCatch(error,info){this.setState({hasError:true});this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_messages__["d" /* showErrorMessage */])('Something went wrong with the request, please try again later.'));}},{key:'render',value:function render(){if(this.state.hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Redirect */],{to:'/'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/',component:__WEBPACK_IMPORTED_MODULE_3_components_admin_service_providers_ServiceProviders__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/:type/new',component:__WEBPACK_IMPORTED_MODULE_5_components_admin_service_providers_ServiceProvidersEdit__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/:type/:id',component:__WEBPACK_IMPORTED_MODULE_4_components_admin_service_providers_ServiceProvidersDetails__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/:type/:id/edit',component:__WEBPACK_IMPORTED_MODULE_5_components_admin_service_providers_ServiceProvidersEdit__["a" /* default */]})));}}}]);return ServiceProvidersContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])()(ServiceProvidersContainer));

/***/ }),
/* 2374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ServiceProviders_css__ = __webpack_require__(2375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ServiceProviders_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ServiceProviders_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_contractors_ContractorStatus__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_service_providers_store_selectors__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_domain_service_provider_type_enum__ = __webpack_require__(164);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ServiceProviders=function(_Component){_inherits(ServiceProviders,_Component);function ServiceProviders(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ServiceProviders);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ServiceProviders.__proto__||Object.getPrototypeOf(ServiceProviders)).call.apply(_ref,[this].concat(args))),_this),_this.handleServiceProviderDropdownChange=function(option){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["s" /* setServiceProviderDropdown */])(option.value));dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["m" /* loadServiceProviders */])(option.value));},_this.inviteServiceProviderButtonLabel=function(){var serviceProvidersDropdown=_this.props.serviceProvidersDropdown;return'Invite '+(__WEBPACK_IMPORTED_MODULE_13_domain_service_provider_type_enum__["d" /* ServiceProviderTypes */][serviceProvidersDropdown]||'Service Provider');},_this.handleServiceProviderSelection=function(index){Object(__WEBPACK_IMPORTED_MODULE_10_services_utils_scroller_util__["c" /* simpleScrollToTop */])();var _this$props=_this.props,history=_this$props.history,serviceProvidersDropdown=_this$props.serviceProvidersDropdown,serviceProviders=_this$props.serviceProviders;var serviceProviderId=serviceProviders[index].id;var serviceProviderValue=__WEBPACK_IMPORTED_MODULE_13_domain_service_provider_type_enum__["e" /* ServiceProviderValuesToUrl */].get(serviceProvidersDropdown);history.push('/admin/service-providers/'+serviceProviderValue+'/'+serviceProviderId);},_this.handleServiceProvidersPageChange=function(newPage){var _this$props2=_this.props,serviceProvidersDropdown=_this$props2.serviceProvidersDropdown,serviceProviderNameToSearch=_this$props2.serviceProviderNameToSearch,dispatch=_this$props2.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["a" /* changePage */])(newPage));dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["m" /* loadServiceProviders */])(serviceProvidersDropdown,serviceProviderNameToSearch,newPage));},_this.handleInputNameChange=function(value){var _this$props3=_this.props,dispatch=_this$props3.dispatch,serviceProvidersDropdown=_this$props3.serviceProvidersDropdown;dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["r" /* setNameToSearch */])(value));dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["m" /* loadServiceProviders */])(serviceProvidersDropdown,value));},_this.handleInviteServiceProvider=function(){var _this$props4=_this.props,serviceProvidersDropdown=_this$props4.serviceProvidersDropdown,dispatch=_this$props4.dispatch;var serviceProviderValue=__WEBPACK_IMPORTED_MODULE_13_domain_service_provider_type_enum__["e" /* ServiceProviderValuesToUrl */].get(serviceProvidersDropdown);dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["p" /* setCompanyData */])({}));dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["h" /* goToNewServiceProvider */])(serviceProviderValue));},_this.handleGenerateLink=function(index){var _this$props5=_this.props,serviceProvidersDropdown=_this$props5.serviceProvidersDropdown,serviceProviders=_this$props5.serviceProviders;var serviceProviderId=serviceProviders[index].id;var serviceProviderValue=__WEBPACK_IMPORTED_MODULE_13_domain_service_provider_type_enum__["e" /* ServiceProviderValuesToUrl */].get(serviceProvidersDropdown);return'service-providers/'+serviceProviderValue+'/'+serviceProviderId;},_this.mapServiceProviders=function(serviceProviders){return serviceProviders.map(function(serviceProvider){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},serviceProvider.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_contractors_ContractorStatus__["a" /* default */],{status:serviceProvider.status}),serviceProvider.contact!==null?serviceProvider.contact.first_name+' '+serviceProvider.contact.last_name:'N/A',serviceProvider.contact!==null?serviceProvider.contact.email:'N/A'];});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ServiceProviders,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["m" /* loadServiceProviders */])(this.props.serviceProvidersDropdown));}},{key:'componentWillUnmount',value:function componentWillUnmount(){var dispatch=this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["b" /* clearFilters */])());}},{key:'componentDidUpdate',value:function componentDidUpdate(){Object(__WEBPACK_IMPORTED_MODULE_10_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'service-providers'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Service Providers'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["s" /* Row */],{className:'filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_dropdown_Dropdown__["a" /* default */],{className:'positive-negative-drop-down',options:__WEBPACK_IMPORTED_MODULE_13_domain_service_provider_type_enum__["a" /* ServiceProviderOptions */].filter(function(spType){return spType.label!=='Client'&&spType.label!=='Subcontractor';}),placeholder:'Service Provider Options',value:this.props.serviceProvidersDropdown,onChange:this.handleServiceProviderDropdownChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__["a" /* default */],{className:'input-name',onChange:this.handleInputNameChange,value:this.props.serviceProviderNameToSearch,theme:'normal',placeholder:'Search by Name'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:this.inviteServiceProviderButtonLabel(),onClick:this.handleInviteServiceProvider})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__["a" /* default */],{className:'service-providers-table',headers:['COMPANY NAME','STATUS','POC','EMAIL'],rows:this.mapServiceProviders(this.props.serviceProviders),emptyMessage:'No Companies',onRowSelected:this.handleServiceProviderSelection,onGenerateLink:this.handleGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.serviceProvidersCurrentPage,pageSize:this.props.serviceProvidersPageSize,total:this.props.serviceProvidersTotal,onPageChange:this.handleServiceProvidersPageChange}))));}}]);return ServiceProviders;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{serviceProviders:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_service_providers_store_selectors__["d" /* getServiceProviders */])(state),serviceProvidersCurrentPage:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_service_providers_store_selectors__["e" /* getServiceProvidersCurrentPage */])(state),serviceProvidersPageSize:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_service_providers_store_selectors__["g" /* getServiceProvidersPageSize */])(state),serviceProvidersDropdown:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_service_providers_store_selectors__["f" /* getServiceProvidersDropdown */])(state),serviceProvidersTotal:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_service_providers_store_selectors__["h" /* getServiceProvidersTotal */])(state),serviceProviderNameToSearch:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_service_providers_store_selectors__["c" /* getServiceProviderNameToSearch */])(state)};})(ServiceProviders));

/***/ }),
/* 2375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_service_providers_ServiceProvidersDetails_css__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_service_providers_ServiceProvidersDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_admin_service_providers_ServiceProvidersDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_contractors_ContractorStatus__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_service_providers_store_selectors__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_service_providers_UserModal__ = __webpack_require__(2377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_navigation_SearchBar__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_api_users_api__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_selectors_authentication__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserTable=function(_Component){_inherits(UserTable,_Component);function UserTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserTable.__proto__||Object.getPrototypeOf(UserTable)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseEditUserModal=function(){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["u" /* setShowEditUserModal */])(false));},_this.handleInviteClient=function(){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["c" /* clearUserData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["u" /* setShowEditUserModal */])(true));},_this.handleEditUserOnSubmit=function(values){var _this$props=_this.props,dispatch=_this$props.dispatch,companyData=_this$props.companyData,user=_this$props.user;if(user){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["f" /* editUser */])(values,companyData.type,companyData.id));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["k" /* inviteUser */])(values,companyData.type,companyData.id));}},_this.handleDeleteEditUserModal=function(response){var _this$props2=_this.props,user=_this$props2.user,dispatch=_this$props2.dispatch,companyData=_this$props2.companyData;if(response){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["e" /* deleteUser */])(user,companyData.type,companyData.id));}dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["t" /* setShowConfirmationModal */])(false));},_this.handleShowConfirmationDelete=function(){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["t" /* setShowConfirmationModal */])(true));},_this.handleUserSelection=function(user){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["q" /* setCurrentUserId */])(user.id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["o" /* loadUserForm */])(user));dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_service_providers_store_actions__["u" /* setShowEditUserModal */])(true));},_this.handleResendInvite=function(id){__WEBPACK_IMPORTED_MODULE_12_services_api_users_api__["b" /* usersApi */].resendInvite(id);},_this.mapServiceProviders=function(serviceProviders){var currentUser=_this.props.currentUser;return serviceProviders.map(function(serviceProvider){return[serviceProvider.first_name!==null?serviceProvider.first_name+' '+serviceProvider.last_name:'N/A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},serviceProvider.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_admin_contractors_ContractorStatus__["a" /* default */],{status:serviceProvider.status}),serviceProvider.email!==null?serviceProvider.email:'N/A',''+Object(__WEBPACK_IMPORTED_MODULE_7_services_utils_text_util__["c" /* formatPhoneNumber */])(serviceProvider.phone_number)+(serviceProvider.phone_ext?' ext '+serviceProvider.phone_ext:''),_this.actionBtns(currentUser,serviceProvider)];});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserTable,[{key:'actionBtns',value:function actionBtns(currentUser,user){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'action-btns-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'linkable action-btn',onClick:function onClick(){return _this2.handleUserSelection(user);}},'Edit'),__WEBPACK_IMPORTED_MODULE_12_services_api_users_api__["b" /* usersApi */].resendInviteLink(currentUser,user)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'linkable action-btn',onClick:function onClick(){return _this2.handleResendInvite(user.id);}},'Resend Invite'):'');}},{key:'render',value:function render(){var _props=this.props,users=_props.users,showInviteUserModal=_props.showInviteUserModal,showConfirmationDeleteModal=_props.showConfirmationDeleteModal,type=_props.type;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,users&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_navigation_SearchBar__["a" /* default */],{addButton:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{id:'invite-user',className:'button-orange',label:'Invite User',onClick:this.handleInviteClient})},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleTable__["a" /* default */],{className:'service-providers-table',headers:['NAME','TITLE','STATUS','EMAIL','PHONE','ACTIONS'],rows:this.mapServiceProviders(users),emptyMessage:'No Users'})),showInviteUserModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_admin_service_providers_UserModal__["a" /* default */],{show:true,companyType:type,handleSubmit:this.handleEditUserOnSubmit,handleClose:this.handleCloseEditUserModal,handleDelete:this.handleShowConfirmationDelete,initialValues:this.props.user}),showConfirmationDeleteModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_ConfirmationModal__["a" /* default */],{show:showConfirmationDeleteModal,message:'Are you sure you want to delete this user?',onHide:this.handleDeleteEditUserModal}));}}]);return UserTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{companyData:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_service_providers_store_selectors__["a" /* getCompanyData */])(state),users:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_service_providers_store_selectors__["l" /* getUserList */])(state),user:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_service_providers_store_selectors__["k" /* getUserForm */])(state),showInviteUserModal:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_service_providers_store_selectors__["j" /* getShowInviteUserModal */])(state),showConfirmationDeleteModal:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_service_providers_store_selectors__["i" /* getShowConfirmationDeleteModal */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_13_selectors_authentication__["d" /* getCurrentUser */])(state)};})(UserTable));

/***/ }),
/* 2377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_service_providers_UserForm__ = __webpack_require__(2378);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserModal=function(_Component){_inherits(UserModal,_Component);function UserModal(){_classCallCheck(this,UserModal);return _possibleConstructorReturn(this,(UserModal.__proto__||Object.getPrototypeOf(UserModal)).apply(this,arguments));}_createClass(UserModal,[{key:'render',value:function render(){var _props=this.props,show=_props.show,companyType=_props.companyType,handleSubmit=_props.handleSubmit,handleClose=_props.handleClose,handleDelete=_props.handleDelete,initialValues=_props.initialValues;var title=initialValues?'Edit User':'Invite User';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{show:show,title:title,onClose:handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_admin_service_providers_UserForm__["a" /* default */],{companyType:companyType,onSubmit:handleSubmit,onClose:handleClose,onDelete:handleDelete,initialValues:initialValues}));}}]);return UserModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UserModal.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,companyType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,handleSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleDelete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,initialValues:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,firstName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,lastName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,phoneNumber:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,accountableId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number})};/* harmony default export */ __webpack_exports__["a"] = (UserModal);

/***/ }),
/* 2378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_service_providers_UserForm_css__ = __webpack_require__(2379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_service_providers_UserForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_admin_service_providers_UserForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_domain_service_provider_type_enum__ = __webpack_require__(164);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InviteUserForm=function(_Component){_inherits(InviteUserForm,_Component);function InviteUserForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InviteUserForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InviteUserForm.__proto__||Object.getPrototypeOf(InviteUserForm)).call.apply(_ref,[this].concat(args))),_this),_this.renderInput=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_input_Input__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));},_this.onChangeDropDown=function(option,props){var value=option&&option.value?option.value:'';props.input.onChange(value);},_this.renderDropDown=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_dropdown_Dropdown__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(option){return _this.onChangeDropDown(option,props);}},props));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InviteUserForm,[{key:'render',value:function render(){var _props=this.props,companyType=_props.companyType,onClose=_props.onClose,onDelete=_props.onDelete,initialValues=_props.initialValues;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invite-edit-user-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.props.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* ControlLabel */],sm:3},'First Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderInput,name:'firstName',placeholder:'First Name'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* ControlLabel */],sm:3},'Last Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderInput,name:'lastName',placeholder:'Last Name'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* ControlLabel */],sm:3},'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderInput,name:'email',placeholder:'Email'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* ControlLabel */],sm:3},'Phone Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderInput,name:'phoneNumber',placeholder:'Phone Number'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderInput,name:'phoneExt',placeholder:'ext'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* ControlLabel */],sm:3},'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderDropDown,name:'title',placeholder:'Select Title',options:__WEBPACK_IMPORTED_MODULE_7_domain_service_provider_type_enum__["c" /* ServiceProviderTitles */][companyType].map(function(title){return{value:title,label:title};})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderInput,name:'title',placeholder:'Or Type in'}))),this.props.invalid&&this.props.submitFailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'The outlined inputs should be added in order to Invite a User.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:3}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange button-submit',type:'submit',value:'Save',disabled:this.props.invalid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-gray',type:'button',value:'Cancel',onClick:onClose}),initialValues&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-white button-submit',type:'button',value:'Delete',onClick:onDelete})))));}}]);return InviteUserForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);InviteUserForm.propTypes={companyType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onDelete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,initialValues:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,firstName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,lastName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,phoneNumber:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,accountableId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number})};function validate(values){var errors={};if(!values.firstName){errors.firstName='Required';}if(!values.lastName){errors.lastName='Required';}if(!values.email){errors.email='Required';}if(!values.phoneNumber){errors.phoneNumber='Required';}if(!values.title){errors.title='Required';}return errors;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["f" /* reduxForm */])({form:'InviteUserForm',validate:validate})(InviteUserForm));

/***/ }),
/* 2379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var StampOptions=[{value:'approved',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'No Exceptions Taken/Approved')},{value:'approved_as_noted',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Corrections Required as Noted'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Resubmittal only required if Contractor cannot comply with corrections.'))},{value:'revise',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Revise and Resubmit as Noted')},{value:'rejected',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Rejected'))},{value:'not_reviewed',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Not Reviewed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Submittal not required.'))},{value:'for_record',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'For Record Only'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Submittal not reviewed.'))}];/* harmony default export */ __webpack_exports__["a"] = (StampOptions);

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/square-empty.72faf9f8.svg";

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/square-full.e4aab9b8.svg";

/***/ }),
/* 2384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_logo_upload_LogoUpload__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_stamp_StampForm__ = __webpack_require__(2385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_service_providers_ServiceProvidersEditForm_css__ = __webpack_require__(2391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_service_providers_ServiceProvidersEditForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_admin_service_providers_ServiceProvidersEditForm_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ServiceProvidersEditForm=function(_Component){_inherits(ServiceProvidersEditForm,_Component);function ServiceProvidersEditForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ServiceProvidersEditForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ServiceProvidersEditForm.__proto__||Object.getPrototypeOf(ServiceProvidersEditForm)).call.apply(_ref,[this].concat(args))),_this),_this.setLogo=function(props,files){var file=files[0];var logo={url:URL.createObjectURL(file),file:file};props.input.onChange(logo);},_this.removeLogo=function(props){props.input.onChange(Object.assign({},props.input.value,{destroy:true}));},_this.logoComponent=function(props,logo){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_logo_upload_LogoUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],logos:[props.input.value].filter(function(logo){return!!logo&&!logo.destroy;}),onRemove:function onRemove(){return _this.removeLogo(props);},onUpload:function onUpload(files){return _this.setLogo(props,files);},useDropzone:true});},_this.handleStampFormChange=function(props,attr,value){props.input.onChange(Object.assign({},props.input.value,_defineProperty({},attr,value)));},_this.stampFormComponent=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_stamp_StampForm__["a" /* default */],{stamp:props.input.value||undefined,error:props.meta.error&&props.meta.submitFailed,onChange:function onChange(attr,value){return _this.handleStampFormChange(props,attr,value);}});},_this.renderInput=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_input_Input__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ServiceProvidersEditForm,[{key:'render',value:function render(){var _props=this.props,initialValues=_props.initialValues,handleSubmit=_props.handleSubmit,invalid=_props.invalid,submitFailed=_props.submitFailed,onCancel=_props.onCancel;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edit-service-provider'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},initialValues?'Edit':'New',' Company'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8,lg:8,className:'edit-service-provider-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2'},'Company Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'name',placeholder:'Company Name',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'firstName',placeholder:'Contact First Name',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'lastName',placeholder:'Contact Last Name',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'email',placeholder:'Email',type:'email'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'phoneNumber',placeholder:'Phone Number',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'streetAddress',placeholder:'Street Address',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'unitNumber',placeholder:'Unit number / Floor',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'city',placeholder:'City',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'state',placeholder:'State',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'zipCode',placeholder:'Zip Code',type:'text'}))),invalid&&submitFailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'The outlined inputs should be added in order to submit the form.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'submit',value:'Save'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-gray',type:'button',value:'Cancel',onClick:onCancel}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:12,lg:12,className:'special-note'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'special-note-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Company Logo & Stamp')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.logoComponent,name:'logo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.stampFormComponent,name:'stamp'}))));}}]);return ServiceProvidersEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(values){var errors={};if(!values.name){errors.name='Required';}if(!values.firstName){errors.firstName='Required';}if(!values.lastName){errors.lastName='Required';}if(!values.email){errors.email='Required';}if(!values.phoneNumber){errors.phoneNumber='Required';}if(!values.streetAddress){errors.streetAddress='Required';}if(!values.city){errors.city='Required';}if(!values.state){errors.state='Required';}if(!values.zipCode){errors.zipCode='Required';}if(values.stamp&&!values.stamp.destroy){var stamp=values.stamp;errors.stamp=!stamp.legal||!stamp.stampActions||!stamp.stampActions.find(function(stampAction){return!stampAction.destroy;})||!!stamp.stampActions.find(function(stampAction){return!stampAction.destroy&&!stampAction.title;});}return errors;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["f" /* reduxForm */])({form:'ServiceProvidersEditForm',validate:validate})(ServiceProvidersEditForm));

/***/ }),
/* 2385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StampForm_css__ = __webpack_require__(2386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StampForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__StampForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_square_full_red_svg__ = __webpack_require__(2387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_square_full_red_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_square_full_red_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_square_empty_red_svg__ = __webpack_require__(2388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_square_empty_red_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_square_empty_red_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_edit_pencil_svg__ = __webpack_require__(2389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_edit_pencil_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_edit_pencil_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_domain_stamp_actions__ = __webpack_require__(2390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_checkbox_LabeledCheckBox__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_autosize_textarea__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_autosize_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_autosize_textarea__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={stamp:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};var defaultProps={stamp:{destroy:true},error:false};var StampForm=function(_Component){_inherits(StampForm,_Component);function StampForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StampForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StampForm.__proto__||Object.getPrototypeOf(StampForm)).call.apply(_ref,[this].concat(args))),_this),_this.buildLabel=function(action,stampAction){var stamp=_this.props.stamp;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stamp-action-label'},!stampAction||stampAction.destroy||!stampAction.edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stamp-action-attr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'stamp-action-title'},stampAction&&stampAction.title||action.title),stampAction&&!stampAction.destroy&&!stampAction.edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'stamp-action-edit':true,'stamp-action-edit-read-only':!!stamp.destroy}),src:__WEBPACK_IMPORTED_MODULE_6_images_edit_pencil_svg___default.a,alt:'edit',onClick:function onClick(){return!stamp.destroy&&_this.handleStampActionChange(stampAction,'edit',true);}})),(stampAction&&stampAction.subtitle||(!stampAction||!stampAction.title)&&action.subtitle)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stamp-action-attr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,stampAction&&stampAction.subtitle||action.subtitle),stampAction&&!stampAction.destroy&&!stampAction.edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'stamp-action-edit':true,'stamp-action-edit-read-only':!!stamp.destroy}),src:__WEBPACK_IMPORTED_MODULE_6_images_edit_pencil_svg___default.a,alt:'edit',onClick:function onClick(){return!stamp.destroy&&_this.handleStampActionChange(stampAction,'edit',true);}})),stampAction&&stampAction.title&&stampAction.title!==action.title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stamp-action-original-label'},'Original Label: ',action.title)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'stamp-action-input':true,'stamp-action-title-input':true,'stamp-invalid':stampAction.saveFailed&&!stampAction.title}),placeholder:!stamp.destroy?action.title:'Title',value:stampAction.title,readOnly:!!stamp.destroy,onChange:function onChange(value){return _this.handleStampActionChange(stampAction,'title',value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'stamp-action-save':true,'stamp-action-save-read-only':!!stamp.destroy}),onClick:function onClick(){if(!stamp.destroy){if(stampAction.title){_this.handleStampActionChange(stampAction,'edit',false);}else{_this.handleStampActionChange(stampAction,'saveFailed',true);}}}},'Save'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__["a" /* default */],{className:'stamp-action-input stamp-action-subtitle-input',placeholder:!stamp.destroy?action.subtitle:'Subtitle',value:stampAction.subtitle,readOnly:!!stamp.destroy,onChange:function onChange(value){return _this.handleStampActionChange(stampAction,'subtitle',value);}})));},_this.findStampAction=function(action){var stamp=_this.props.stamp;return stamp.stampActions&&stamp.stampActions.find(function(stampAction){return stampAction.action===action;});},_this.handleStampActionSelect=function(action,value){var stamp=_this.props.stamp;var stampAction=_this.findStampAction(action.action);var stampActions=stamp.stampActions||[];if(stampAction){stampActions=[].concat(_toConsumableArray(stampActions.filter(function(stampAct){return stampAct.action!==action.action;})),[Object.assign({},stampAction,{destroy:!value,edit:false})]);}else{stampActions=[].concat(_toConsumableArray(stampActions),[Object.assign({},action)]);}_this.handleFormChange('stampActions',stampActions);},_this.handleStampActionChange=function(stampAction,attr,value){var stamp=_this.props.stamp;var stampActions=[].concat(_toConsumableArray(stamp.stampActions.filter(function(prevStampAction){return prevStampAction.action!==stampAction.action;})),[Object.assign({},stampAction,_defineProperty({},attr,value))]);_this.handleFormChange('stampActions',stampActions);},_this.handleFormChange=function(attr,value){_this.props.onChange(attr,value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StampForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,stamp=_props.stamp,error=_props.error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stamp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stamp-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{checked:!stamp.destroy,label:'Create a Custom Stamp',squareFull:__WEBPACK_IMPORTED_MODULE_4_images_square_full_red_svg___default.a,squareFullReadOnly:__WEBPACK_IMPORTED_MODULE_4_images_square_full_red_svg___default.a,squareEmpty:__WEBPACK_IMPORTED_MODULE_5_images_square_empty_red_svg___default.a,size:'medium',onChange:function onChange(value){return _this2.handleFormChange('destroy',!value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'stamp-read-only':!!stamp.destroy})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stamp-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'stamp-label':true,'stamp-label-invalid':error&&(!stamp.stampActions||!stamp.stampActions.find(function(stampAction){return!stampAction.destroy;}))})},'Select and edit the call to actions you want to use.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Please be advised that the action must remain the same as the verbiage is the only thing that can be edited.'),__WEBPACK_IMPORTED_MODULE_7_domain_stamp_actions__["a" /* default */].map(function(action,index){var stampAction=_this2.findStampAction(action.action);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'stamp-action'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{checked:!!stampAction&&!stampAction.destroy,label:_this2.buildLabel(action,stampAction),readOnly:!!stamp.destroy,squareFull:__WEBPACK_IMPORTED_MODULE_4_images_square_full_red_svg___default.a,squareFullReadOnly:__WEBPACK_IMPORTED_MODULE_4_images_square_full_red_svg___default.a,squareEmpty:__WEBPACK_IMPORTED_MODULE_5_images_square_empty_red_svg___default.a,size:'medium',onChange:function onChange(value){return _this2.handleStampActionSelect(action,value);}}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stamp-block stamp-legal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'stamp-label'},'Legal Information.'),stamp.legal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_autosize_textarea___default.a,{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'stamp-invalid':error&&!stamp.legal}),placeholder:'Legal',rows:5,defaultValue:stamp.legal,readOnly:!!stamp.destroy,onBlur:function onBlur(e){return _this2.handleFormChange('legal',e.target.value);}}),!stamp.legal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_autosize_textarea___default.a,{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'stamp-invalid':error&&!stamp.legal}),placeholder:'Legal',rows:5,defaultValue:'',readOnly:!!stamp.destroy,onBlur:function onBlur(e){return _this2.handleFormChange('legal',e.target.value);}}))));}}]);return StampForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StampForm.propTypes=propTypes;StampForm.defaultProps=defaultProps;/* harmony default export */ __webpack_exports__["a"] = (StampForm);

/***/ }),
/* 2386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/square-full-red.9ed423ad.svg";

/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/square-empty-red.8263ef5e.svg";

/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/edit-pencil.f7965126.svg";

/***/ }),
/* 2390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var StampActions=[{action:'approved',title:'No Exceptions Taken/Approved'},{action:'approved_as_noted',title:'Corrections Required as Noted',subtitle:'Resubmittal only required if Contractor cannot comply with corrections.'},{action:'revise',title:'Revise and Resubmit as Noted'},{action:'rejected',title:'Rejected'},{action:'not_reviewed',title:'Not Reviewed',subtitle:'Submittal not required.'},{action:'for_record',title:'For Record Only',subtitle:'Submittal not reviewed.'}];/* harmony default export */ __webpack_exports__["a"] = (StampActions);

/***/ }),
/* 2391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Quotes_css__ = __webpack_require__(2393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Quotes_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Quotes_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_navigation_SearchBar__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_quotes_quotes__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_admin_quotes_quotes__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_text_SimpleText__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_table_cell_addons_QuoteStatus__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__QuoteDetailsModal__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_services_utils_scroller_util__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Quotes=function(_Component){_inherits(Quotes,_Component);function Quotes(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Quotes);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Quotes.__proto__||Object.getPrototypeOf(Quotes)).call.apply(_ref,[this].concat(args))),_this),_this.tabSelection=1,_this.handleNavSelect=function(id){_this.tabSelection=id;_this.loadQuotes(id,1);},_this.handlePageChange=function(newPage){_this.loadQuotes(_this.tabSelection,newPage);},_this.handleRowSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_quotes_quotes__["d" /* selectQuoteRequest */])(index,_this.props.quotes.content[index].task.id));},_this.handleCloseModal=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_quotes_quotes__["a" /* closeModal */])());},_this.mapQuotes=function(quotes){return quotes.map(function(quote){return[quote.work_order.number+'-'+__WEBPACK_IMPORTED_MODULE_10_numeral___default()(quote.task.number).format('00'),quote.work_order.name!==null?quote.work_order.name:'N/A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},quote.work_order.client.company_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_SimpleText__["a" /* default */],{lines:[quote.work_order.building.location.street_address_1,quote.work_order.building.location.city]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},quote.contractor_name),quote.task.trade.label,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_table_cell_addons_QuoteStatus__["a" /* default */],{status:quote.status}),quote.estimate!=null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__["a" /* default */],{value:quote.estimate,format:'$0,0'}):'TBD'];});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Quotes,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_quotes_quotes__["b" /* loadQuotesRequest */])(1,undefined,undefined,true));}},{key:'componentDidUpdate',value:function componentDidUpdate(){Object(__WEBPACK_IMPORTED_MODULE_14_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}},{key:'loadQuotes',value:function loadQuotes(tabSelection,newPage){switch(tabSelection){case 1:this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_quotes_quotes__["b" /* loadQuotesRequest */])(newPage));break;case 2:this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_quotes_quotes__["b" /* loadQuotesRequest */])(newPage,true,undefined,true));break;case 3:this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_quotes_quotes__["b" /* loadQuotesRequest */])(newPage,undefined,true,true));break;default:}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quotes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Quotes'),this.props.quotes!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_navigation_SearchBar__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'All'},{id:2,show:this.props.quotes.totalWaiting>0,title:'Waiting',total:this.props.quotes.totalWaiting},{id:3,show:this.props.quotes.totalDenied>0,title:'Denied',total:this.props.quotes.totalDenied}],onSelected:this.handleNavSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__["a" /* default */],{className:'quotes-table',headers:['WO #','NAME','CLIENT NAME','LOCATION','CONTRACTOR','TRADE','STATUS','AMOUNT'],rows:this.mapQuotes(this.props.quotes.content),emptyMessage:'No Quotes',onRowSelected:this.handleRowSelection}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.currentPage,pageSize:this.props.quotes.pageSize,total:this.props.quotes.total,onPageChange:this.handlePageChange}))),this.props.selectedQuoteIndex!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__QuoteDetailsModal__["a" /* default */],{quote:this.props.quotes.content[this.props.selectedQuoteIndex],show:this.props.selectedQuoteIndex!==null,taskImages:this.props.taskImages,workOrder:this.props.quotes.content[this.props.selectedQuoteIndex].work_order,onClose:this.handleCloseModal}));}}]);return Quotes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentPage:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_quotes_quotes__["a" /* getCurrentPage */])(state),quotes:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_quotes_quotes__["b" /* getQuotes */])(state),selectedQuoteIndex:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_quotes_quotes__["d" /* getSelectedQuoteIndex */])(state),taskImages:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_admin_quotes_quotes__["e" /* getTaskImages */])(state)};})(Quotes));

/***/ }),
/* 2393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tasks__ = __webpack_require__(2395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_messages__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TasksContainer=function(_Component){_inherits(TasksContainer,_Component);function TasksContainer(props){_classCallCheck(this,TasksContainer);var _this=_possibleConstructorReturn(this,(TasksContainer.__proto__||Object.getPrototypeOf(TasksContainer)).call(this,props));_this.state={hasError:false};return _this;}_createClass(TasksContainer,[{key:'componentDidCatch',value:function componentDidCatch(error,info){this.setState({hasError:true});this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_messages__["d" /* showErrorMessage */])('Something went wrong with the request, please try again later.'));}},{key:'render',value:function render(){if(this.state.hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Redirect */],{to:'/'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/',component:__WEBPACK_IMPORTED_MODULE_2__Tasks__["a" /* default */]})));}}}]);return TasksContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TasksContainer);

/***/ }),
/* 2395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tasks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tasks_css__ = __webpack_require__(2396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tasks_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Tasks_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_SearchBar__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_text_SimpleText__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_admin_tasks_tasks__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_admin_tasks_tasks__ = __webpack_require__(2397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_table_cell_addons_SimpleTaskStatus__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_dropdown_SearchableDropDown__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_images_dropdown_arrow_png__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_images_dropdown_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_images_dropdown_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_services_api_contractors_api__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_domain_task_status_enum__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_services_utils_users_util__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tasks=function(_Component){_inherits(Tasks,_Component);function Tasks(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Tasks);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Tasks.__proto__||Object.getPrototypeOf(Tasks)).call.apply(_ref,[this].concat(args))),_this),_this.tabSelection=1,_this.handleRowSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_tasks_tasks__["c" /* openTaskDetails */])(_this.props.tasks.content[index]));},_this.handleGenerateLink=function(id){var content=_this.props.tasks.content;var task=content[id];return'work-orders/'+task.work_order_id+'/task/'+task.id;},_this.handleTradeChange=function(trade){_this.handleChange(1,_this.props.selectedContractorId,trade!==null?trade.value:trade);},_this.handleContractorChange=function(contractor){_this.handleChange(1,contractor!==null?contractor.value:contractor,_this.props.selectedTradeId);},_this.handleNavSelect=function(id){_this.tabSelection=id;_this.handleChange(1,_this.props.selectedContractorId,_this.props.selectedTradeId);},_this.handlePageChange=function(newPage){_this.handleChange(newPage,_this.props.selectedContractorId,_this.props.selectedTradeId);},_this.handleChange=function(page,contractorId,tradeId){switch(_this.tabSelection){case 1:_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_tasks_tasks__["b" /* loadTasksRequest */])(page,contractorId,tradeId));break;case 2:_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_tasks_tasks__["b" /* loadTasksRequest */])(page,contractorId,tradeId,true));break;case 3:_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_tasks_tasks__["b" /* loadTasksRequest */])(page,contractorId,tradeId,undefined,__WEBPACK_IMPORTED_MODULE_16_domain_task_status_enum__["a" /* TaskStatusEnum */].DRAFT));break;case 4:_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_tasks_tasks__["b" /* loadTasksRequest */])(page,contractorId,tradeId,undefined,__WEBPACK_IMPORTED_MODULE_16_domain_task_status_enum__["a" /* TaskStatusEnum */].RFP));break;case 5:_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_tasks_tasks__["b" /* loadTasksRequest */])(page,contractorId,tradeId,undefined,__WEBPACK_IMPORTED_MODULE_16_domain_task_status_enum__["a" /* TaskStatusEnum */].PLM));break;case 6:_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_tasks_tasks__["b" /* loadTasksRequest */])(page,contractorId,tradeId,undefined,__WEBPACK_IMPORTED_MODULE_16_domain_task_status_enum__["a" /* TaskStatusEnum */].AGG));break;case 7:_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_tasks_tasks__["b" /* loadTasksRequest */])(page,contractorId,tradeId,undefined,__WEBPACK_IMPORTED_MODULE_16_domain_task_status_enum__["a" /* TaskStatusEnum */].WOA));break;case 8:_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_tasks_tasks__["b" /* loadTasksRequest */])(page,contractorId,tradeId,undefined,__WEBPACK_IMPORTED_MODULE_16_domain_task_status_enum__["a" /* TaskStatusEnum */].PRE));break;case 9:_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_tasks_tasks__["b" /* loadTasksRequest */])(page,contractorId,tradeId,undefined,__WEBPACK_IMPORTED_MODULE_16_domain_task_status_enum__["a" /* TaskStatusEnum */].WIP));break;case 10:_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_tasks_tasks__["b" /* loadTasksRequest */])(page,contractorId,tradeId,undefined,__WEBPACK_IMPORTED_MODULE_16_domain_task_status_enum__["a" /* TaskStatusEnum */].CMP));break;case 11:_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_tasks_tasks__["b" /* loadTasksRequest */])(page,contractorId,tradeId,undefined,__WEBPACK_IMPORTED_MODULE_16_domain_task_status_enum__["a" /* TaskStatusEnum */].CLS));break;default:}},_this.mapTasks=function(tasks){return tasks.map(function(task,index){// Add special class to hide top border if current task belongs to the same WO of the previous task
var addClass=false;if(index>0){var previousTask=tasks[index-1];addClass=previousTask.work_order.id===task.work_order.id;}var rowData={id:index,selectable:true,data:[task.work_order.number+'-'+__WEBPACK_IMPORTED_MODULE_3_numeral___default()(task.number).format('00'),task.work_order.name!==null?task.work_order.name:'N/A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},task.name||'TBD'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_SimpleText__["a" /* default */],{lines:[task.work_order.building.location.street_address_1,task.work_order.building.location.city]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_table_cell_addons_SimpleTaskStatus__["a" /* default */],{status:task.status}),task.trade.label,task.contractor_name!==null?task.contractor_name:'TBD']};if(addClass){rowData['className']='no-top-border';}return rowData;});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Tasks,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_admin_tasks_tasks__["a" /* firstLoadTasksRequest */])());}},{key:'componentDidUpdate',value:function componentDidUpdate(){Object(__WEBPACK_IMPORTED_MODULE_17_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tasks'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Tasks'),this.props.tasks!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_SearchBar__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'All'},{id:2,show:this.props.tasks.totalCritical>0,title:'Critical',total:this.props.tasks.totalCritical},{id:3,show:this.props.tasks.totalDraft>0,title:'Draft',total:this.props.tasks.totalDraft},{id:4,show:this.props.tasks.totalRfp>0,title:'RFP',total:this.props.tasks.totalRfp},{id:5,show:this.props.tasks.totalPlm>0,title:'PLM',total:this.props.tasks.totalPlm},{id:6,show:this.props.tasks.totalAgg>0&&(__WEBPACK_IMPORTED_MODULE_19_services_utils_users_util__["g" /* usersUtil */].isAdmin(this.props.currentUser)||__WEBPACK_IMPORTED_MODULE_19_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_19_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR)),title:'AGG',total:this.props.tasks.totalAgg},{id:7,show:this.props.tasks.totalWoa>0,title:'WOA',total:this.props.tasks.totalWoa},{id:8,show:this.props.tasks.totalPre>0,title:'PRE',total:this.props.tasks.totalPre},{id:9,show:this.props.tasks.totalWip>0,title:'WIP',total:this.props.tasks.totalWip},{id:10,show:this.props.tasks.totalCmp>0,title:'CMP',total:this.props.tasks.totalCmp},{id:11,show:this.props.tasks.totalCls>0,title:'CLS',total:this.props.tasks.totalCls}],onSelected:this.handleNavSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tasks-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_dropdown_Dropdown__["a" /* default */],{className:'trade-dropdown',clearable:true,options:this.props.trades.map(function(trade){return{value:trade.id,label:trade.label};}),placeholder:'Filter Trade',value:this.props.selectedTradeId,onChange:this.handleTradeChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_dropdown_SearchableDropDown__["a" /* default */],{arrowRenderer:function arrowRenderer(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_14_images_dropdown_arrow_png___default.a,alt:'arrow'});},autoload:false,className:'contractor-dropdown',clearable:true,loadOptions:Tasks.loadContractors,placeholder:'Filter Contractor',value:this.props.selectedContractorId,onChange:this.handleContractorChange}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__["a" /* default */],{className:'tasks-table',headers:['WO #','NAME','TASK NAME','LOCATION','STATUS','TRADE','CONTRACTOR'],rows:this.mapTasks(this.props.tasks.content),emptyMessage:'No Tasks',onRowSelected:this.handleRowSelection,onGenerateLink:this.handleGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.currentPage,pageSize:this.props.tasks.pageSize,total:this.props.tasks.total,onPageChange:this.handlePageChange}))));}}],[{key:'loadContractors',value:function loadContractors(input){return __WEBPACK_IMPORTED_MODULE_15_services_api_contractors_api__["b" /* default */].searchContractors(input).then(function(response){if(response.ok){return{ok:true,options:response.contractors.map(function(element){return{value:element.id,label:element.name};})};}else{return{ok:false,errors:response.errors};}});}}]);return Tasks;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentPage:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_tasks_tasks__["a" /* getCurrentPage */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_18_selectors_authentication__["d" /* getCurrentUser */])(state),selectedContractorId:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_tasks_tasks__["b" /* getSelectedContractorId */])(state),selectedTradeId:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_tasks_tasks__["c" /* getSelectedTradeId */])(state),tasks:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_tasks_tasks__["d" /* getTasks */])(state),trades:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_admin_tasks_tasks__["e" /* getTrades */])(state)};})(Tasks));

/***/ }),
/* 2396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getTrades; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSelectedTradeId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSelectedContractorId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getTasks=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.tasks.data.tasks;},function(quotes){return quotes;});var getTrades=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.tasks.data.trades;},function(trades){return trades;});var getCurrentPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.tasks.ui.currentPage;},function(currentPage){return currentPage;});var getSelectedTradeId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.tasks.ui.selectedTradeId;},function(selectedTradeId){return selectedTradeId;});var getSelectedContractorId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.tasks.ui.selectedContractorId;},function(selectedContractorId){return selectedContractorId;});

/***/ }),
/* 2398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Invoices__ = __webpack_require__(2399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InvoiceDetails__ = __webpack_require__(2404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DepositDetails__ = __webpack_require__(2413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InvoicesContainer=function(_Component){_inherits(InvoicesContainer,_Component);function InvoicesContainer(props){_classCallCheck(this,InvoicesContainer);var _this=_possibleConstructorReturn(this,(InvoicesContainer.__proto__||Object.getPrototypeOf(InvoicesContainer)).call(this,props));_this.state={hasError:false};return _this;}_createClass(InvoicesContainer,[{key:'componentDidCatch',value:function componentDidCatch(error,info){this.setState({hasError:true});this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_messages__["d" /* showErrorMessage */])('Something went wrong with the request, please try again later.'));}},{key:'render',value:function render(){if(this.state.hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Redirect */],{to:'/'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/',component:__WEBPACK_IMPORTED_MODULE_2__Invoices__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/:id',component:__WEBPACK_IMPORTED_MODULE_3__InvoiceDetails__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/deposit/:id',component:__WEBPACK_IMPORTED_MODULE_4__DepositDetails__["a" /* default */]})));}}}]);return InvoicesContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])()(InvoicesContainer));

/***/ }),
/* 2399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Invoices_css__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Invoices_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Invoices_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_SearchBar__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_admin_invoices_invoices__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_invoices_invoices__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InvoicesTable__ = __webpack_require__(2400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DepositsTable__ = __webpack_require__(2401);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Invoices=function(_Component){_inherits(Invoices,_Component);function Invoices(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Invoices);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Invoices.__proto__||Object.getPrototypeOf(Invoices)).call.apply(_ref,[this].concat(args))),_this),_this.handleNavSelect=function(id){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_invoices_invoices__["u" /* tabSelectionChange */])(id));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Invoices,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoices'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Invoices / Deposits'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_SearchBar__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'Invoices'},{id:2,title:'Deposits'}],onSelected:this.handleNavSelect})),this.props.tabSelection===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__InvoicesTable__["a" /* default */],null),this.props.tabSelection===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__DepositsTable__["a" /* default */],null)));}},{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_invoices_invoices__["u" /* tabSelectionChange */])(1));}}]);return Invoices;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{tabSelection:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_invoices_invoices__["n" /* getTabSelection */])(state)};})(Invoices));

/***/ }),
/* 2400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Invoices_css__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Invoices_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Invoices_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleHeader__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_admin_invoices_invoices__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_invoices_invoices__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_utils_scroller_util__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InvoicesTable=function(_Component){_inherits(InvoicesTable,_Component);function InvoicesTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InvoicesTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InvoicesTable.__proto__||Object.getPrototypeOf(InvoicesTable)).call.apply(_ref,[this].concat(args))),_this),_this.handlePageChange=function(newPage){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_invoices_invoices__["j" /* loadInvoicesRequest */])(newPage,_this.props.selectedStatus));},_this.handleStatusSelection=function(status){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_invoices_invoices__["j" /* loadInvoicesRequest */])(1,status)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_invoices_invoices__["r" /* setSelectedStatus */])(status));}});},_this.handleInvoiceSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_invoices_invoices__["i" /* loadInvoiceRequest */])(_this.props.invoices.content[index].id)).then(function(response){Object(__WEBPACK_IMPORTED_MODULE_13_services_utils_scroller_util__["c" /* simpleScrollToTop */])();// When invoice is loaded successfully, go to invoice page
if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_invoices_invoices__["t" /* setShowSave */])(false));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_invoices_invoices__["g" /* goToInvoice */])(_this.props.invoices.content[index].id));if(_this.props.usersByClientId[response.invoice.client.id]===undefined){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_invoices_invoices__["k" /* loadUsersRequest */])(response.invoice.client.id));}}});},_this.handleGenerateLink=function(index){var content=_this.props.invoices.content;return'invoices/'+content[index].id;},_this.mapInvoices=function(invoices){return invoices.map(function(invoice){if(__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["f" /* TYPES */].CLIENT)){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},invoice.work_order.number),invoice.work_order.name!==null?invoice.work_order.name:'N/A',Object(__WEBPACK_IMPORTED_MODULE_7_services_utils_text_util__["e" /* toUpperFirstLetter */])(invoice.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Date__["a" /* default */],{value:invoice.due_date,format:'LL'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__["a" /* default */],{value:invoice.total_cost,format:'$0,0'})];}else{return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},invoice.work_order.number),invoice.work_order.name!==null?invoice.work_order.name:'N/A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},invoice.client.company_name),Object(__WEBPACK_IMPORTED_MODULE_7_services_utils_text_util__["e" /* toUpperFirstLetter */])(invoice.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Date__["a" /* default */],{value:invoice.due_date,format:'LL'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__["a" /* default */],{value:invoice.total_cost,format:'$0,0'})];}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InvoicesTable,[{key:'render',value:function render(){var tableHeaders=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleHeader__["a" /* default */],{label:'STATUS',filter:{options:[{id:'all',label:'All'},{id:'paid',label:'Paid'},{id:'overdue',label:'Overdue'}],selected:this.props.selectedStatus},onFilterOptionSelect:this.handleStatusSelection}),'DUE DATE','AMOUNT DUE'];if(__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["f" /* TYPES */].CLIENT)){tableHeaders=['WO #','NAME'].concat(_toConsumableArray(tableHeaders));}else{tableHeaders=['WO #','NAME','CLIENT NAME'].concat(_toConsumableArray(tableHeaders));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.invoices!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__["a" /* default */],{className:'invoices-table',headers:tableHeaders,rows:this.mapInvoices(this.props.invoices.content),emptyMessage:'No Invoices',onRowSelected:this.handleInvoiceSelection,onGenerateLink:this.handleGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.currentPage,pageSize:this.props.invoices.pageSize,total:this.props.invoices.total,onPageChange:this.handlePageChange}))));}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_invoices_invoices__["j" /* loadInvoicesRequest */])(1)).then(function(response){if(response.ok){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_invoices_invoices__["r" /* setSelectedStatus */])('all'));}});}},{key:'componentDidUpdate',value:function componentDidUpdate(){Object(__WEBPACK_IMPORTED_MODULE_13_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}}]);return InvoicesTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentPage:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_invoices_invoices__["b" /* getCurrentPage */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_authentication__["d" /* getCurrentUser */])(state),invoices:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_invoices_invoices__["h" /* getInvoices */])(state),usersByClientId:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_invoices_invoices__["o" /* getUsersByClientId */])(state),selectedStatus:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_invoices_invoices__["j" /* getSelectedStatus */])(state)};})(InvoicesTable));

/***/ }),
/* 2401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DepositsTable_css__ = __webpack_require__(2402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DepositsTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DepositsTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_admin_deposits_deposits__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_admin_deposits_deposits__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_utils_text_util__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DepositsTable=function(_Component){_inherits(DepositsTable,_Component);function DepositsTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DepositsTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DepositsTable.__proto__||Object.getPrototypeOf(DepositsTable)).call.apply(_ref,[this].concat(args))),_this),_this.handlePageChange=function(newPage){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_deposits_deposits__["d" /* loadDepositsRequest */])(newPage));},_this.handleDepositSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_deposits_deposits__["c" /* loadDepositRequest */])(_this.props.deposits.content[index].id)).then(function(response){Object(__WEBPACK_IMPORTED_MODULE_11_services_utils_scroller_util__["c" /* simpleScrollToTop */])();// When deposit is loaded successfully, go to deposit page
if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_deposits_deposits__["b" /* goToDeposit */])(_this.props.deposits.content[index].id));if(_this.props.usersByClientId[response.deposit.client.id]===undefined){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_deposits_deposits__["e" /* loadUsersRequest */])(response.deposit.client.id));}}});},_this.mapDeposits=function(deposits){return deposits.map(function(deposit){if(__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["f" /* TYPES */].CLIENT)){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},deposit.work_order.number,'-D'),deposit.work_order.name!==null?deposit.work_order.name:'N/A',Object(__WEBPACK_IMPORTED_MODULE_12_services_utils_text_util__["e" /* toUpperFirstLetter */])(deposit.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Date__["a" /* default */],{value:deposit.created_at,format:'LL'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__["a" /* default */],{value:deposit.cost,format:'$0,0'})];}else{return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},deposit.work_order.number,'-D'),deposit.work_order.name!==null?deposit.work_order.name:'N/A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},deposit.client.company_name),Object(__WEBPACK_IMPORTED_MODULE_12_services_utils_text_util__["e" /* toUpperFirstLetter */])(deposit.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Date__["a" /* default */],{value:deposit.created_at,format:'LL'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__["a" /* default */],{value:deposit.cost,format:'$0,0'})];}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DepositsTable,[{key:'render',value:function render(){var tableHeaders=void 0;if(__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["f" /* TYPES */].CLIENT)){tableHeaders=['WO #','NAME','STATUS','CREATED DATE','AMOUNT'];}else{tableHeaders=['WO #','NAME','CLIENT NAME','STATUS','CREATED DATE','AMOUNT'];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.deposits!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__["a" /* default */],{className:'deposits-table',headers:tableHeaders,rows:this.mapDeposits(this.props.deposits.content),emptyMessage:'No Deposits',onRowSelected:this.handleDepositSelection}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.currentPage,pageSize:this.props.deposits.pageSize,total:this.props.deposits.total,onPageChange:this.handlePageChange}))));}},{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_admin_deposits_deposits__["d" /* loadDepositsRequest */])(1));}},{key:'componentDidUpdate',value:function componentDidUpdate(){Object(__WEBPACK_IMPORTED_MODULE_11_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}}]);return DepositsTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_authentication__["d" /* getCurrentUser */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_deposits_deposits__["b" /* getCurrentPage */])(state),deposits:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_deposits_deposits__["c" /* getDeposits */])(state),usersByClientId:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_deposits_deposits__["g" /* getUsersByClientId */])(state)};})(DepositsTable));

/***/ }),
/* 2402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return depositsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DepositsApi=function(_BaseApi){_inherits(DepositsApi,_BaseApi);function DepositsApi(){_classCallCheck(this,DepositsApi);return _possibleConstructorReturn(this,(DepositsApi.__proto__||Object.getPrototypeOf(DepositsApi)).apply(this,arguments));}_createClass(DepositsApi,[{key:'getDeposits',value:function getDeposits(page){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/deposits?page='+(page!==undefined?page:1)).then(function(response){return{ok:true,deposits:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getDeposit',value:function getDeposit(depositId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/deposits/'+depositId).then(function(response){return{ok:true,deposit:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'markDepositAsPaid',value:function markDepositAsPaid(depositId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/deposits/'+depositId+'/paid').then(function(response){return{ok:true,deposit:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getAsPdf',value:function getAsPdf(depositId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/deposits/'+depositId+'/print',{responseType:'blob'}).then(function(response){return{ok:true,pdf:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'sendEmail',value:function sendEmail(depositId,emails,subject,message){var data={deposit:{send_to:emails,subject:subject,message:message}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/deposits/'+depositId+'/email',data).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return DepositsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var depositsApi=new DepositsApi();

/***/ }),
/* 2404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InvoiceDetails_css__ = __webpack_require__(2405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InvoiceDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__InvoiceDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_check_square_png__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_check_square_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_images_check_square_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_invoices_InvoiceData__ = __webpack_require__(2406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_mail_white_svg__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_mail_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_images_mail_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_images_print_white_svg__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_images_print_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_images_print_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_shared_pdf_viewer_PdfViewer__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_shared_email_EmailModal__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_domain_work_order__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_invoices_TotalTables__ = __webpack_require__(2409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_services_utils_scroller_util__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InvoiceDetails=function(_Component){_inherits(InvoiceDetails,_Component);function InvoiceDetails(props){_classCallCheck(this,InvoiceDetails);// Keep track of id to avoid showing an "old" invoice while loading the current one
var _this=_possibleConstructorReturn(this,(InvoiceDetails.__proto__||Object.getPrototypeOf(InvoiceDetails)).call(this,props));_this.getEmailMessage=function(){var location='';if(_this.props.currentInvoice.building!==null){var building=_this.props.currentInvoice.building;location=' at '+building.location.street_address_1+', '+building.location.city+' '+building.location.state;}return'Please find the attached invoice for WO #'+_this.props.currentInvoice.work_order.number+location+'. If you have any questions, please reach out via chat or email.\n\nThank you';};_this.getEmailSubject=function(){var name='';if(__WEBPACK_IMPORTED_MODULE_16_domain_work_order__["a" /* WorkOrder */].getName(_this.props.currentInvoice.work_order)!==null){name=' - '+__WEBPACK_IMPORTED_MODULE_16_domain_work_order__["a" /* WorkOrder */].getName(_this.props.currentInvoice.work_order);}return'Spackle Invoice for WO #'+_this.props.currentInvoice.work_order.number+name;};_this.getEmailTitle=function(){return'Invoice for WO #'+_this.props.currentInvoice.work_order.number;};_this.handleCancel=function(){Object(__WEBPACK_IMPORTED_MODULE_18_services_utils_scroller_util__["c" /* simpleScrollToTop */])();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["b" /* cancelEdit */])(_this.props.currentInvoice));};_this.handleCustomEmailAdd=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["d" /* customEmailAdd */])(_this.props.customEmail));};_this.handleCustomEmailChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["e" /* customEmailChange */])(value));};_this.handleEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["q" /* setEdit */])(true));};_this.handleEmail=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["s" /* setShowEmailModal */])(true));};_this.handleEmailModalClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["s" /* setShowEmailModal */])(false));};_this.handleEmailRemove=function(id,index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["f" /* emailRemove */])(id,index));};_this.handleEmailSend=function(emails,subject,message){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["o" /* sendEmail */])(_this.props.currentInvoice.id,emails,subject,message));};_this.handleFormAttributeChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["v" /* updateFormAttributeChange */])(attribute,value));};_this.handleMarkAsPaid=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["l" /* markAsPaidRequest */])(_this.props.currentInvoice.id));};_this.handlePdfViewerClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["c" /* closePdfViewer */])());};_this.handlePrint=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["m" /* printInvoice */])(_this.invoiceId));};_this.handleSend=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["p" /* sendInvoiceRequest */])(_this.props.currentInvoice.id));};_this.handleUpdate=function(){var invalidLineItemId=Object.keys(_this.props.form.amountsByLineItemId).filter(function(key){return _this.props.form.amountsByLineItemId[key]==='';});if(invalidLineItemId.length>0){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["h" /* invalid */])(invalidLineItemId,'The outlined costs are required.'));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["A" /* valid */])());_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["x" /* updateInvoiceRequest */])(_this.props.currentInvoice.id,_this.props.form,_this.props.currentInvoice.misc_items));}};_this.handleUsersAdd=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["z" /* usersEmailAdd */])(_this.props.usersIdSelected,_this.props.usersByClientId[_this.props.currentInvoice.client.id]));};_this.handleUserSelected=function(userId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["y" /* userSelected */])(userId,_this.props.usersIdSelected));};_this.invoiceId=__WEBPACK_IMPORTED_MODULE_2_numeral___default()(_this.props.match.params.id).value();_this.isClient=__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["f" /* TYPES */].CLIENT);return _this;}_createClass(InvoiceDetails,[{key:'render',value:function render(){var _this2=this;if(this.props.currentInvoice!==null&&this.props.currentInvoice.id===this.invoiceId){var isPaid=this.props.currentInvoice.status==='paid';var isSent=this.props.currentInvoice.sent_at!==null;var isSpackleAdmin=__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasRole(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);var clientUsers=[];if(this.props.usersByClientId[this.props.currentInvoice.client.id]!==undefined){clientUsers=this.props.usersByClientId[this.props.currentInvoice.client.id];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['INVOICES','INVOICE WO #'+this.props.currentInvoice.work_order.number]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Invoice (WO ',this.props.currentInvoice.work_order.number,')'),this.isClient&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'print-email-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_button_Button__["a" /* default */],{className:'button-gray',icon:__WEBPACK_IMPORTED_MODULE_12_images_mail_white_svg___default.a,label:'Email',onClick:this.handleEmail}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_button_Button__["a" /* default */],{className:'button-gray',icon:__WEBPACK_IMPORTED_MODULE_13_images_print_white_svg___default.a,label:'Print',onClick:this.handlePrint}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-data-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_admin_invoices_InvoiceData__["a" /* default */],{to:this.props.currentInvoice.client.company_name,completionDate:this.props.currentInvoice.completion_date,customEmail:this.props.customEmail,customEmailValid:this.props.customEmailValid,dueDate:this.props.form.dueDate,cost:this.props.currentInvoice.total_cost,edit:this.props.edit,emails:this.props.form.emails,purchaseOrder:this.props.currentInvoice.work_order.purchase_order,showSendTo:isSpackleAdmin,users:this.props.usersByClientId[this.props.currentInvoice.client.id]!==undefined?this.props.usersByClientId[this.props.currentInvoice.client.id].filter(function(user){return _this2.props.form.emails.find(function(userEmail){return userEmail.email===user.email;})===undefined;}).map(function(user){return{id:user.id,email:user.email,name:user.first_name+' '+user.last_name,selected:_this2.props.usersIdSelected.find(function(id){return id===user.id;})!==undefined};}):[],onAttributeChange:this.handleFormAttributeChange,onEmailRemove:this.handleEmailRemove,onCustomEmailAdd:this.handleCustomEmailAdd,onCustomEmailChange:this.handleCustomEmailChange,onUsersAdd:this.handleUsersAdd,onUserSelected:this.handleUserSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inv-buttons-container'},isSpackleAdmin&&!isPaid&&!this.props.edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_button_Button__["a" /* default */],{label:'Mark as Paid',className:'button-orange',onClick:this.handleMarkAsPaid}),isPaid&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'not-paid-indicator'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9_images_check_square_png___default.a,alt:'yes'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button button-white-orange'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Paid'))),isSpackleAdmin&&!isPaid&&!this.props.edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_button_Button__["a" /* default */],{label:isSent?'Send Again':'Send',className:'button-blue-grey',onClick:this.handleSend}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_button_Button__["a" /* default */],{label:'Edit',className:'button-gray',onClick:this.handleEdit})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_admin_invoices_TotalTables__["a" /* default */],null),isSpackleAdmin&&this.props.edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extra-save-cancel-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_button_Button__["a" /* default */],{label:'Save',className:'button-gray',onClick:this.handleUpdate}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_button_Button__["a" /* default */],{label:'Cancel',className:'button-white',onClick:this.handleCancel}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Send Payment to:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Spackle, Inc.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'4130 Cahuenga Blvd, Suite 206'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Los Angeles, CA 91602')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'Please note')),', our banking has changed. To pay via ACH please contact us at',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:accounts@spackle.co',className:'mailto'},'accounts@spackle.co'),'.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:this.props.pdf,type:'blob'},show:this.props.showPdfViewer,onClose:this.handlePdfViewerClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_email_EmailModal__["a" /* EmailModal */],{defaultEmails:clientUsers.filter(function(user){return user.account_creator;}).map(function(user){return user.email;}),defaultMessage:this.getEmailMessage(),defaultSubject:this.getEmailSubject(),emails:clientUsers.map(function(user){return user.email;}),title:this.getEmailTitle(),show:this.props.showEmailModal,onClose:this.handleEmailModalClose,onSend:this.handleEmailSend}));}else{return null;}}},{key:'componentDidMount',value:function componentDidMount(){var _this3=this;if(this.props.currentInvoice===null||this.props.currentInvoice.id!==this.invoiceId){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["i" /* loadInvoiceRequest */])(this.invoiceId)).then(function(response){if(response.ok){if(_this3.props.usersByClientId[response.invoice.client.id]===undefined){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["k" /* loadUsersRequest */])(response.invoice.client.id));}}});}}}]);return InvoiceDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentInvoice:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__["a" /* getCurrentInvoice */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_authentication__["d" /* getCurrentUser */])(state),customEmail:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__["c" /* getCustomEmail */])(state),customEmailValid:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__["d" /* getCustomEmailValid */])(state),edit:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__["e" /* getEdit */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__["f" /* getForm */])(state),// invalidFields: getInvalidFields(state),
invoices:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__["h" /* getInvoices */])(state),pdf:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__["i" /* getPdf */])(state),showEmailModal:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__["k" /* getShowEmailModal */])(state),showPdfViewer:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__["l" /* getShowPdfViewer */])(state),showSave:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__["m" /* getShowSave */])(state),usersByClientId:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__["o" /* getUsersByClientId */])(state),usersIdSelected:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__["p" /* getUsersIdSelected */])(state)// validationMessage: getValidationMessage(state)
};})(InvoiceDetails));

/***/ }),
/* 2405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InvoiceData_css__ = __webpack_require__(2407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InvoiceData_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__InvoiceData_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_select_MultipleSelectList__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_button_Button__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InvoiceData=function(_Component){_inherits(InvoiceData,_Component);function InvoiceData(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InvoiceData);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InvoiceData.__proto__||Object.getPrototypeOf(InvoiceData)).call.apply(_ref,[this].concat(args))),_this),_this.handleAttributeChange=function(attribute,value){if(_this.props.onAttributeChange){_this.props.onAttributeChange(attribute,value);}},_this.handleCustomEmailAdd=function(){if(_this.props.onCustomEmailAdd){_this.props.onCustomEmailAdd();}},_this.handleUsersAdd=function(){if(_this.props.onUsersAdd){_this.props.onUsersAdd();}},_this.handleUserSelected=function(id){if(_this.props.onUserSelected){_this.props.onUserSelected(id);}},_this.handleCustomEmailChange=function(value){if(_this.props.onCustomEmailChange){_this.props.onCustomEmailChange(value);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InvoiceData,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-data-label'},'To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.to)),this.props.purchaseOrder!==''&&this.props.purchaseOrder!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-data-label'},'Purchase Order'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.purchaseOrder)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-data-label'},'Completion Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-data-bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Date__["a" /* default */],{value:this.props.completionDate,format:'M/D/YYYY'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-data-label'},'Due Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-data-bold'},this.props.edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:__WEBPACK_IMPORTED_MODULE_7_services_utils_date_util__["k" /* todayValidation */],placeholder:'',value:this.props.dueDate,onChange:this.handleAttributeChange.bind(this,'dueDate')}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Date__["a" /* default */],{value:this.props.dueDate,format:'M/D/YYYY'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-data-label'},'Invoice Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-data-bold orange'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Number__["a" /* default */],{value:this.props.cost,format:'$ 0,0'}))),this.props.showSendTo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-data-label emails'},'Send to'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-emails-container'},this.props.edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_select_MultipleSelectList__["a" /* default */],{options:this.props.users.map(function(user){return{id:user.id,selected:user.selected,value:user.name+' <'+user.email+'>'};}),show:5,onSelect:this.handleUserSelected})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:this.props.users.filter(function(user){return user.selected;}).length===0,label:'Add',onClick:this.handleUsersAdd}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_input_Input__["a" /* default */],{className:'email-input',valid:this.props.customEmailValid,value:this.props.customEmail,onChange:this.handleCustomEmailChange}),!this.props.customEmailValid&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'Invalid email, please verify.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:this.props.customEmail==='',label:'Add',onClick:this.handleCustomEmailAdd}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_select_MultipleSelectList__["a" /* default */],{noValuesMessage:'No emails',options:this.props.emails.map(function(value){return{id:value.id,value:value.email};}),readOnly:true,onRemove:this.props.onEmailRemove})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_select_MultipleSelectList__["a" /* default */],{noValuesMessage:'No emails',options:this.props.emails.map(function(value){return{id:value.id,value:value.email};}),readOnly:true}))))))));}}]);return InvoiceData;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);InvoiceData.propTypes={completionDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,cost:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,customEmail:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,customEmailValid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,dueDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,edit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,emails:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),purchaseOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,showSendTo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,to:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,users:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.name,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool})),onAttributeChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCustomEmailAdd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCustomEmailChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onEmailRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUsersAdd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUserSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};InvoiceData.defaultProps={customEmail:'',customEmailValid:true,edit:false,emails:[],purchaseOrder:'',showSendTo:true,users:[]};/* harmony default export */ __webpack_exports__["a"] = (InvoiceData);

/***/ }),
/* 2407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TotalTables_css__ = __webpack_require__(2410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TotalTables_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TotalTables_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_invoices_AdditionalCostsEditor__ = __webpack_require__(2411);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TotalTables=function(_Component){_inherits(TotalTables,_Component);function TotalTables(props){_classCallCheck(this,TotalTables);var _this=_possibleConstructorReturn(this,(TotalTables.__proto__||Object.getPrototypeOf(TotalTables)).call(this,props));_this.mapLineItems=function(lineItems){return lineItems.sort(function(li1,li2){return li1.task.number-li2.task.number;}).map(function(item){return[].concat(item.type==='LineItemTask'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Number__["a" /* default */],{value:item.task.number,format:'00'}):[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Number__["a" /* default */],{value:item.task.number,format:'00'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Number__["a" /* default */],{value:item.change_order_task.number,format:'00'})],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},item.type==='LineItemTask'?item.task.name||'N/A':item.change_order_task.description),_this.isClient?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Number__["a" /* default */],{value:Math.round(_this.props.form.amountsByLineItemId[item.id])+Math.round(_this.props.form.additionalCostsByLineItemId[item.id]),format:'$0,0'}):[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},item.contractor_name),_this.props.edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_input_Input__["a" /* default */],{valid:_this.props.invalidFields.find(function(element){return __WEBPACK_IMPORTED_MODULE_2_numeral___default()(element).value()===item.id;})===undefined,value:_this.props.form.amountsByLineItemId[item.id],onChange:_this.handleItemLineChange.bind(_this,item.id)}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Number__["a" /* default */],{value:_this.props.form.amountsByLineItemId[item.id],format:'$0,0'})]);});};_this.handleAdjustmentDescChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["v" /* updateFormAttributeChange */])('adjustmentDesc',value));};_this.handleAdjustmentChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["v" /* updateFormAttributeChange */])('adjustment',value));};_this.handleAdjustmentSignChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["v" /* updateFormAttributeChange */])('adjustmentSign',value));// Update value with the new sign
var newAdjustmentValue=Math.abs(_this.props.form.adjustment)*value;_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["v" /* updateFormAttributeChange */])('adjustment',newAdjustmentValue.toString()));};_this.handleFormAttributeChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["v" /* updateFormAttributeChange */])(attribute,value));};_this.handleItemLineChange=function(itemId,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["w" /* updateFormItemLineChange */])(itemId,value));};_this.handleMiscAdd=function(description,cost){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["a" /* addFormMiscCost */])(0,description,cost));};_this.handleMiscDelete=function(id,index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_invoices_invoices__["n" /* removeFormMiscCost */])(index));};_this.isClient=__WEBPACK_IMPORTED_MODULE_9_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_9_services_utils_users_util__["f" /* TYPES */].CLIENT);return _this;}_createClass(TotalTables,[{key:'render',value:function render(){var lineItemTasks=this.props.currentInvoice.line_items.filter(function(li){return li.type==='LineItemTask';});var lineItemChangeOrders=this.props.currentInvoice.line_items.filter(function(li){return li.type==='LineItemChangeOrder';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleTable__["a" /* default */],{className:'tasks-table'+(this.isClient?'':' with-contractor'),headers:[].concat('TASK #','TASK NAME',this.isClient?'COST':['CONTRACTOR','COST']),rows:this.mapLineItems(lineItemTasks),emptyMessage:'No Items',showBottomLine:true}),lineItemChangeOrders.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h4 change-orders-table-title'},'CHANGE ORDERS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleTable__["a" /* default */],{className:'change-orders-table'+(this.isClient?'':' with-contractor'),headers:[].concat('TASK #','CO #','DETAILS',this.isClient?'COST':['CONTRACTOR','COST']),rows:this.mapLineItems(lineItemChangeOrders),emptyMessage:'No Items',showBottomLine:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleTable__["a" /* default */],{className:'total-table'+(this.isClient?'':' with-contractor'),rows:[].concat([['',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},'SUB TOTAL'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Number__["a" /* default */],{className:'h4',value:this.calculateSubTotal(this.isClient),format:'$0,0'})]],[this.props.currentInvoice.deposit!==null&&this.props.currentInvoice.deposit!==undefined?['',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},'PAID DEPOSIT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Number__["a" /* default */],{className:'h4',value:-this.props.currentInvoice.deposit.cost,format:'$0,0'})]:[]])}),this.renderAdditionalCostsTable(),this.props.edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'additional-costs-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-uppercase h4'},'additional costs'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_admin_invoices_AdditionalCostsEditor__["a" /* default */],{adjustmentDesc:this.props.form.adjustmentDesc,adjustment:this.props.form.adjustment,miscItems:this.props.form.miscCosts,sign:this.props.form.adjustmentSign,onAdjustmentDescChange:this.handleAdjustmentDescChange,onAdjustmentChange:this.handleAdjustmentChange,onAdjustmentSignChange:this.handleAdjustmentSignChange,onMiscAdd:this.handleMiscAdd,onMiscDelete:this.handleMiscDelete})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleTable__["a" /* default */],{className:'total-table'+(this.isClient?'':' with-contractor'),rows:[['',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total'},'TOTAL'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Number__["a" /* default */],{className:'h3',value:this.calculateTotal(),format:'$0,0'})]]}),this.props.validationMessage!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},this.props.validationMessage));}},{key:'renderAdditionalCostsTable',value:function renderAdditionalCostsTable(){var rows=[];this.props.currentInvoice.misc_items.forEach(function(miscItem){rows.push([__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},miscItem.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Number__["a" /* default */],{value:miscItem.cost,format:'$0,0'})]);});var adjustmentValue=__WEBPACK_IMPORTED_MODULE_2_numeral___default()(this.props.currentInvoice.adjustment).value();if(adjustmentValue!==0){rows.push([__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},this.props.form.adjustmentDesc||'Adjustment'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Number__["a" /* default */],{value:adjustmentValue,format:'$0,0'})]);}return this.showAdditionalCostsTable()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleTable__["a" /* default */],{className:'additional-costs-table'+(this.isClient?'':' with-contractor'),headers:['ADDITIONAL COSTS','COST'],rows:rows,showBottomLine:true});}},{key:'calculateSubTotal',value:function calculateSubTotal(addAdditionalCosts){var _this2=this;return this.props.currentInvoice.line_items.reduce(function(accumulator,currentItem){var value=0;if(addAdditionalCosts){value=Math.round(_this2.props.form.amountsByLineItemId[currentItem.id])+Math.round(_this2.props.form.additionalCostsByLineItemId[currentItem.id]);}else{value=__WEBPACK_IMPORTED_MODULE_2_numeral___default()(_this2.props.form.amountsByLineItemId[currentItem.id]).value();}return accumulator+value;},0);}},{key:'calculateTotal',value:function calculateTotal(){if(!this.props.edit){return this.props.currentInvoice.total_cost;}else{var miscItemsTotal=this.props.form.miscCosts.reduce(function(accumulator,currentMisc){return accumulator+__WEBPACK_IMPORTED_MODULE_2_numeral___default()(currentMisc.cost).value();},0);return this.calculateSubTotal(true)+__WEBPACK_IMPORTED_MODULE_2_numeral___default()(this.props.form.adjustment).value()+miscItemsTotal;}}},{key:'showAdditionalCostsTable',value:function showAdditionalCostsTable(){return!this.props.edit&&(__WEBPACK_IMPORTED_MODULE_2_numeral___default()(this.props.currentInvoice.adjustment).value()!==0||this.props.currentInvoice.misc_items.length>0);}}]);return TotalTables;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentInvoice:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__["a" /* getCurrentInvoice */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_authentication__["d" /* getCurrentUser */])(state),edit:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__["e" /* getEdit */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__["f" /* getForm */])(state),invalidFields:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__["g" /* getInvalidFields */])(state),validationMessage:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_invoices_invoices__["q" /* getValidationMessage */])(state)};})(TotalTables));

/***/ }),
/* 2410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AdditionalCostsEditor_css__ = __webpack_require__(2412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AdditionalCostsEditor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AdditionalCostsEditor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AdditionalCostsEditor=function(_Component){_inherits(AdditionalCostsEditor,_Component);function AdditionalCostsEditor(props){_classCallCheck(this,AdditionalCostsEditor);var _this=_possibleConstructorReturn(this,(AdditionalCostsEditor.__proto__||Object.getPrototypeOf(AdditionalCostsEditor)).call(this,props));_this.handleAdd=function(){_this.setState({showNewLine:true});};_this.handleAdjustmentDescChange=function(value){if(_this.props.onAdjustmentDescChange){_this.props.onAdjustmentDescChange(value);}};_this.handleAdjustmentChange=function(value){if(_this.props.onAdjustmentChange){var newValue=__WEBPACK_IMPORTED_MODULE_3_numeral___default()(value).value();if(newValue===null){_this.props.onAdjustmentChange('');}else{if(_this.props.sign===-1){newValue=newValue*-1;}_this.props.onAdjustmentChange(newValue.toString());}}};_this.handleAdjustmentSignChange=function(option){if(_this.props.onAdjustmentSignChange){_this.props.onAdjustmentSignChange(option.value);}};_this.handleConfirmationModalHide=function(confirmation){if(confirmation&&_this.props.onMiscDelete){_this.props.onMiscDelete(_this.deleteInfo.id,_this.deleteInfo.index);}_this.setState({showDeleteConfirmation:false});};_this.handleDelete=function(itemId,index){_this.deleteInfo={id:itemId,index:index};_this.setState({showDeleteConfirmation:true});};_this.handleNewCancel=function(){_this.setState({newCost:'',newDescription:'',showNewLine:false});};_this.handleNewConfirm=function(){if(_this.props.onMiscAdd){_this.props.onMiscAdd(_this.state.newDescription,_this.state.newCost);}_this.setState({newCost:'',newDescription:'',showNewLine:false});};_this.handleNewCostChange=function(value){_this.setState({newCost:value});};_this.handleNewDescriptionChange=function(value){_this.setState({newDescription:value});};_this.state={newCost:'',newDescription:'',showDeleteConfirmation:false,showNewLine:false};_this.deleteInfo=null;// { id: number, index: number }
return _this;}_createClass(AdditionalCostsEditor,[{key:'render',value:function render(){var _this2=this;var adjustmentValue=null;if(__WEBPACK_IMPORTED_MODULE_3_numeral___default()(this.props.adjustment).value()!==null){adjustmentValue=Math.abs(__WEBPACK_IMPORTED_MODULE_3_numeral___default()(this.props.adjustment).value());}var adjustmentInputClassName=null;if(adjustmentValue!==0){adjustmentInputClassName=this.props.sign===1?'positive':'negative';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'additional-costs-editor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-uppercase'},'description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-uppercase'},'cost'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.props.miscItems.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'h4'},item.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'body-regular'},__WEBPACK_IMPORTED_MODULE_3_numeral___default()(item.cost).format('$0,0.00')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{className:'button-blue-grey',label:'Delete',onClick:function onClick(){return _this2.handleDelete(item.id,index);}})));}),this.state.showNewLine&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{className:'new-line-description',value:this.state.newDescription,onChange:this.handleNewDescriptionChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{type:'number',value:this.state.newCost,onChange:this.handleNewCostChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'new-line-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{className:'button-gray',disabled:this.state.newCost===''||this.state.newDescription==='',label:'Confirm',onClick:this.handleNewConfirm}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{className:'button-white',label:'Cancel',onClick:this.handleNewCancel}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Add',onClick:this.handleAdd})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'adjustment-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-uppercase'},'adjustment'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{className:'new-line-description',value:this.props.adjustmentDesc,onChange:this.handleAdjustmentDescChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__["a" /* default */],{className:'positive-negative-drop-down',options:[{value:1,label:'+'},{value:-1,label:'-'}],placeholder:'',value:this.props.sign,onChange:this.handleAdjustmentSignChange})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{className:'adjustment-input '+adjustmentInputClassName,type:'number',value:adjustmentValue!==null?adjustmentValue.toString():'',onChange:this.handleAdjustmentChange}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showDeleteConfirmation,message:'Are you sure you want to delete this item?',onHide:this.handleConfirmationModalHide}));}}]);return AdditionalCostsEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AdditionalCostsEditor.propTypes={adjustmentDesc:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,adjustment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,miscItems:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,cost:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),sign:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([1,-1]),onAdjustmentDescChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onAdjustmentChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onAdjustmentSignChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onMiscAdd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onMiscDelete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};AdditionalCostsEditor.defaultProps={adjustmentDesc:'',adjustment:'',miscItems:[],sign:1};/* harmony default export */ __webpack_exports__["a"] = (AdditionalCostsEditor);

/***/ }),
/* 2412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DepositDetails_css__ = __webpack_require__(2414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DepositDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DepositDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_deposits_deposits__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_deposits_deposits__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_domain_task_status_enum__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_check_square_png__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_check_square_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_images_check_square_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_images_mail_white_svg__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_images_mail_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_images_mail_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_images_print_white_svg__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_images_print_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_images_print_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_shared_pdf_viewer_PdfViewer__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_shared_email_EmailModal__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_domain_work_order__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_services_utils_users_util__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DepositDetails=function(_Component){_inherits(DepositDetails,_Component);function DepositDetails(props){_classCallCheck(this,DepositDetails);// Keep track of id to avoid showing an "old" deposit while loading the current one
var _this=_possibleConstructorReturn(this,(DepositDetails.__proto__||Object.getPrototypeOf(DepositDetails)).call(this,props));_this.mapTasks=function(tasks){return tasks.filter(function(task){return task.status!==__WEBPACK_IMPORTED_MODULE_10_domain_task_status_enum__["b" /* TaskStatusKeys */].CLS;}).map(function(task){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__["a" /* default */],{value:task.number,format:'00'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},task.name||'N/A'),''];});};_this.handleMarkAsPaid=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_deposits_deposits__["f" /* markAsPaidRequest */])(_this.depositId));};_this.handlePrint=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_deposits_deposits__["g" /* printDeposit */])(_this.depositId));};_this.handlePdfViewerClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_deposits_deposits__["a" /* closePdfViewer */])());};_this.handleEmail=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_deposits_deposits__["i" /* setShowEmailModal */])(true));};_this.getEmailMessage=function(){var location='';if(_this.props.currentDeposit.building!==null){var building=_this.props.currentDeposit.building;location=' at '+building.location.street_address_1+', '+building.location.city+' '+building.location.state;}return'Please find the attached deposit invoice for WO #'+_this.props.currentDeposit.work_order.number+location+'. If you have any questions, please reach out via chat or email.\n\nThank you';};_this.getEmailSubject=function(){var name='';if(__WEBPACK_IMPORTED_MODULE_17_domain_work_order__["a" /* WorkOrder */].getName(_this.props.currentDeposit.work_order)!==null){name=' - '+__WEBPACK_IMPORTED_MODULE_17_domain_work_order__["a" /* WorkOrder */].getName(_this.props.currentDeposit.work_order);}return'Spackle Deposit Invoice for WO #'+_this.props.currentDeposit.work_order.number+'-D'+name;};_this.getEmailTitle=function(){return'Deposit Invoice for WO #'+_this.props.currentDeposit.work_order.number+'-D';};_this.handleEmailModalClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_deposits_deposits__["i" /* setShowEmailModal */])(false));};_this.handleEmailSend=function(emails,subject,message){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_deposits_deposits__["h" /* sendEmail */])(_this.props.currentDeposit.id,emails,subject,message));};_this.depositId=__WEBPACK_IMPORTED_MODULE_3_numeral___default()(_this.props.match.params.id).value();return _this;}_createClass(DepositDetails,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;if(this.props.currentDeposit===null||this.props.currentDeposit.id!==this.depositId){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_deposits_deposits__["c" /* loadDepositRequest */])(this.depositId)).then(function(response){if(response.ok){if(_this2.props.usersByClientId[response.deposit.client.id]===undefined){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_deposits_deposits__["e" /* loadUsersRequest */])(response.deposit.client.id));}}});}}},{key:'render',value:function render(){if(this.props.currentDeposit!==null&&this.props.currentDeposit.id===this.depositId){var isPaid=this.props.currentDeposit.status==='paid';var isSpackleAdmin=__WEBPACK_IMPORTED_MODULE_19_services_utils_users_util__["g" /* usersUtil */].hasRole(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_19_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN)||__WEBPACK_IMPORTED_MODULE_19_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_19_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);var clientUsers=[];if(this.props.usersByClientId[this.props.currentDeposit.client.id]!==undefined){clientUsers=this.props.usersByClientId[this.props.currentDeposit.client.id];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deposit-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['DEPOSITS','DEPOSIT INVOICE WO #'+this.props.currentDeposit.work_order.number+'-D']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Deposit Invoice (WO ',this.props.currentDeposit.work_order.number,'-D)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'print-email-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__["a" /* default */],{className:'button-gray',icon:__WEBPACK_IMPORTED_MODULE_13_images_mail_white_svg___default.a,label:'Email',onClick:this.handleEmail}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__["a" /* default */],{className:'button-gray',icon:__WEBPACK_IMPORTED_MODULE_14_images_print_white_svg___default.a,label:'Print',onClick:this.handlePrint}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-data-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-data-label'},'To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.currentDeposit.client.company_name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-data-label'},'Created Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-data-bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__["a" /* default */],{value:this.props.currentDeposit.created_at,format:'M/D/YYYY'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-data-label'},'Deposit Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoice-data-bold orange'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__["a" /* default */],{value:this.props.currentDeposit.cost,format:'$ 0,0'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inv-buttons-container'},isSpackleAdmin&&!isPaid&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__["a" /* default */],{label:'Mark as Paid',className:'button-orange',onClick:this.handleMarkAsPaid}),isPaid&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'not-paid-indicator'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11_images_check_square_png___default.a,alt:'yes'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button button-white-orange'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Paid'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_table_SimpleTable__["a" /* default */],{className:'tasks-table',headers:['TASK #','TASK NAME',''],rows:this.mapTasks(this.props.currentDeposit.work_order.tasks),emptyMessage:'No Tasks',showBottomLine:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_table_SimpleTable__["a" /* default */],{className:'total-table',rows:[['',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total'},'DEPOSIT INVOICE TOTAL'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__["a" /* default */],{className:'h3',value:this.props.currentDeposit.cost,format:'$0,0'})]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Send Payment to:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Spackle, Inc.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'4130 Cahuenga Blvd, Suite 206'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Los Angeles, CA 91602')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Please note, our banking has changed. To pay via ACH please contact us at',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:accounts@spackle.co',className:'mailto'},'accounts@spackle.co'),'.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'To pay by credit card or for wiring instructions, please contact us at',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:admin@spackle.co',className:'mailto'},'admin@spackle.co'),'.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:this.props.pdf,type:'blob'},show:this.props.showPdfViewer,onClose:this.handlePdfViewerClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_shared_email_EmailModal__["a" /* EmailModal */],{defaultEmails:clientUsers.filter(function(user){return user.account_creator;}).map(function(user){return user.email;}),defaultMessage:this.getEmailMessage(),defaultSubject:this.getEmailSubject(),emails:clientUsers.map(function(user){return user.email;}),title:this.getEmailTitle(),show:this.props.showEmailModal,onClose:this.handleEmailModalClose,onSend:this.handleEmailSend}));}else{return null;}}}]);return DepositDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_18_selectors_authentication__["d" /* getCurrentUser */])(state),currentDeposit:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_deposits_deposits__["a" /* getCurrentDeposit */])(state),pdf:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_deposits_deposits__["d" /* getPdf */])(state),showPdfViewer:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_deposits_deposits__["f" /* getShowPdfViewer */])(state),usersByClientId:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_deposits_deposits__["g" /* getUsersByClientId */])(state),showEmailModal:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_deposits_deposits__["e" /* getShowEmailModal */])(state)};})(DepositDetails));

/***/ }),
/* 2414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Team__ = __webpack_require__(2416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TeamEdit__ = __webpack_require__(2432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TeamContainer=function(_Component){_inherits(TeamContainer,_Component);function TeamContainer(props){_classCallCheck(this,TeamContainer);var _this=_possibleConstructorReturn(this,(TeamContainer.__proto__||Object.getPrototypeOf(TeamContainer)).call(this,props));_this.state={hasError:false};return _this;}_createClass(TeamContainer,[{key:'componentDidCatch',value:function componentDidCatch(error,info){this.setState({hasError:true});this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_messages__["d" /* showErrorMessage */])('Something went wrong with the request, please try again later.'));}},{key:'render',value:function render(){if(this.state.hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Redirect */],{to:'/'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/',component:__WEBPACK_IMPORTED_MODULE_2__Team__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/edit',component:__WEBPACK_IMPORTED_MODULE_3__TeamEdit__["a" /* default */]})));}}}]);return TeamContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])()(TeamContainer));

/***/ }),
/* 2416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContractorTeam__ = __webpack_require__(2417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClientTeam__ = __webpack_require__(2424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_team_GeneralContractorTeam_js__ = __webpack_require__(2428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_team_ServiceProviderTeam_js__ = __webpack_require__(2431);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Team=function(_Component){_inherits(Team,_Component);function Team(){_classCallCheck(this,Team);return _possibleConstructorReturn(this,(Team.__proto__||Object.getPrototypeOf(Team)).apply(this,arguments));}_createClass(Team,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3__services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_3__services_utils_users_util__["f" /* TYPES */].CONTRACTOR)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ContractorTeam__["a" /* default */],null);}else if(__WEBPACK_IMPORTED_MODULE_3__services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_3__services_utils_users_util__["f" /* TYPES */].CLIENT)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ClientTeam__["a" /* default */],null);}else if(__WEBPACK_IMPORTED_MODULE_3__services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_3__services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_team_GeneralContractorTeam_js__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_team_ServiceProviderTeam_js__["a" /* default */],null);}}}]);return Team;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_2__selectors_authentication__["d" /* getCurrentUser */])(state)};})(Team));

/***/ }),
/* 2417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContractorTeam_css__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContractorTeam_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ContractorTeam_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_admin_contractors_contractors__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_modal_InviteUserModal__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_details_DetailsHeader__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_contractors_ContractorStatus__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfo__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_details_DetailsInfoItem__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_selectors_admin_contractors_contractors__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_selectors_admin_team_contractor_team__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_team_ContractorTeamUserModalContainer__ = __webpack_require__(2418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_team_ContractorTeamTechnicianModalContainer__ = __webpack_require__(2419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_contractors_ContractorDocumentsViewer__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_shared_modal_SigningModal__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_admin_team_UsersTable__ = __webpack_require__(2421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_admin_team_TechniciansTable__ = __webpack_require__(2423);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorTeam=function(_Component){_inherits(ContractorTeam,_Component);function ContractorTeam(props){_classCallCheck(this,ContractorTeam);var _this=_possibleConstructorReturn(this,(ContractorTeam.__proto__||Object.getPrototypeOf(ContractorTeam)).call(this,props));_this.handleEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["d" /* goToEditContractor */])());};_this.handleInviteUser=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["m" /* setCurrentUserId */])(0));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["i" /* loadUserFormRequest */])(null));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["o" /* setShowInviteUserModal */])(true,__WEBPACK_IMPORTED_MODULE_5_components_shared_modal_InviteUserModal__["a" /* UserModalState */].NEW));};_this.handleInviteTechnician=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["l" /* setCurrentTechnicianId */])(0));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["g" /* loadTechnicianFormRequest */])(null));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["n" /* setShowInviteTechnicianModal */])(true,__WEBPACK_IMPORTED_MODULE_5_components_shared_modal_InviteUserModal__["a" /* UserModalState */].NEW));};_this.handleSignMsa=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_contractors_contractors__["u" /* showSignMsaModal */])(_this.contractorId));};_this.handleMsaSigningModalClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_contractors_contractors__["f" /* hideMsaSigningModal */])());};_this.onSelectTab=function(id){var dispatch=_this.props.dispatch;if(id===__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["a" /* ContactorTeamTabs */].Users.value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["j" /* loadUsersRequest */])(id));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["h" /* loadTechnicianRequest */])(1,id));}};_this.contractorId=_this.props.currentUser.accountable_id;return _this;}_createClass(ContractorTeam,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_contractors_contractors__["g" /* loadContractorRequest */])(this.contractorId)).then(function(response){if(response.ok){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["j" /* loadUsersRequest */])());}});}},{key:'render',value:function render(){var firstRowDetailsInfoItems=[];var secondRowDetailsInfoItems=[];var activeTab=this.props.activeTab;if(this.props.contractor){if(this.props.contractor.location){firstRowDetailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[this.props.contractor.location.street_address_1,this.props.contractor.location.city+', '+this.props.contractor.location.state+' '+this.props.contractor.location.zip],title:'ADDRESS'}));}firstRowDetailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'contractor-name'},this.props.contractor.contact.first_name+' '+this.props.contractor.contact.last_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'contractor-email',href:'mailto:'+this.props.contractor.contact.email},this.props.contractor.contact.email),Object(__WEBPACK_IMPORTED_MODULE_16_services_utils_text_util__["c" /* formatPhoneNumber */])(this.props.contractor.contact.phone_number)],title:'PRIMARY CONTACT'}));firstRowDetailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[this.props.contractor.license_number],title:'LICENSE NUMBER'}));secondRowDetailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:this.props.contractor.service_areas.map(function(element){return element.name;}),title:'AREAS OF SERVICE'}));secondRowDetailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:this.props.contractor.unions.map(function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element.label,element.detail!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'union-detail'},'(',element.detail,')'));}),title:'UNIONS'}));secondRowDetailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:this.props.contractor.trades.map(function(element){return element.label;}),title:'SPECIALITIES',truncate:true}));}return this.props.contractor!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['COMPANY',this.props.contractor.name.toUpperCase()]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_details_DetailsHeader__["a" /* default */],{leftHeader:{title:'COMPANY',value:this.props.contractor.name},rightHeaders:[[{title:'STATUS',value:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_admin_contractors_ContractorStatus__["a" /* default */],{status:this.props.contractor.status})},{title:'IN PROGRESS',value:this.props.contractor.wo_in_progress_count},{title:'COMPLETED',value:this.props.contractor.wo_complete_count}]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-info-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfo__["a" /* default */],{itemsContainerSize:10,itemsLines:[firstRowDetailsInfoItems,secondRowDetailsInfoItems],rightContainerSize:2,rightContainer:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contractors-documents-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_admin_contractors_ContractorDocumentsViewer__["a" /* default */],{contractor:this.props.contractor}))}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edit-button-container'},this.props.contractor.confirmed&&!this.props.contractor.msa_document&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-orange',value:'Sign MSA',onClick:this.handleSignMsa}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-gray',value:'Edit',onClick:this.handleEdit}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invite-container-space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["a" /* ContactorTeamTabs */].Users.value,title:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["a" /* ContactorTeamTabs */].Users.label},{id:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["a" /* ContactorTeamTabs */].Technicians.value,title:__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["a" /* ContactorTeamTabs */].Technicians.label}],onSelected:this.onSelectTab}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,activeTab===__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["a" /* ContactorTeamTabs */].Technicians.value&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-orange',value:'Add technician',onClick:this.handleInviteTechnician}),activeTab===__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["a" /* ContactorTeamTabs */].Users.value&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-orange',value:'Invite',onClick:this.handleInviteUser}))),activeTab===__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["a" /* ContactorTeamTabs */].Users.value?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_admin_team_UsersTable__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_admin_team_TechniciansTable__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_admin_team_ContractorTeamUserModalContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_admin_team_ContractorTeamTechnicianModalContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_shared_modal_SigningModal__["a" /* default */],{show:this.props.showMsaSigningModal,url:this.props.msaSigningUrl,title:'Sign MSA',handleClose:this.handleMsaSigningModalClose}));}}]);return ContractorTeam;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{contractor:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_admin_contractors_contractors__["f" /* getCurrentContractor */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_authentication__["d" /* getCurrentUser */])(state),users:Object(__WEBPACK_IMPORTED_MODULE_13_selectors_admin_team_contractor_team__["o" /* getUsers */])(state),msaSigningUrl:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_admin_contractors_contractors__["j" /* getMsaSigningUrl */])(state),showMsaSigningModal:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_admin_contractors_contractors__["s" /* getShowMsaSigningModal */])(state),activeTab:Object(__WEBPACK_IMPORTED_MODULE_13_selectors_admin_team_contractor_team__["a" /* getActiveTab */])(state)};})(ContractorTeam));

/***/ }),
/* 2418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_modal_InviteUserModal__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_text_util__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorTeamUserModalContainer=function(_Component){_inherits(ContractorTeamUserModalContainer,_Component);function ContractorTeamUserModalContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ContractorTeamUserModalContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ContractorTeamUserModalContainer.__proto__||Object.getPrototypeOf(ContractorTeamUserModalContainer)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["o" /* setShowInviteUserModal */])(false));},_this.handleSubmit=function(){var role=_this.props.roles.find(function(role){return role.id===_this.props.form.rolesId;});_this.props.form.title=role?__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["c" /* CONTRACTOR_ROLES */][role.name]:'';_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["p" /* submitFormRequest */])(_this.props.form,_this.props.currentUserId));},_this.handleAttributeChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["r" /* updateFormValue */])(attribute,value));},_this.handleEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["o" /* setShowInviteUserModal */])(true,__WEBPACK_IMPORTED_MODULE_5_components_shared_modal_InviteUserModal__["a" /* UserModalState */].EDIT));},_this.handleDeleteConfirmation=function(result){if(result){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["c" /* deleteUserRequest */])(_this.props.currentUserId));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ContractorTeamUserModalContainer,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.roles.length===0){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["f" /* loadRolesRequest */])());}}},{key:'render',value:function render(){var userFormFields=[{attribute:'firstName',label:'First Name',renderer:'input'},{attribute:'lastName',label:'Last Name',renderer:'input'},{attribute:'email',label:'Email',renderer:'input'},{attribute:'phoneNumber',formatter:__WEBPACK_IMPORTED_MODULE_6_services_utils_text_util__["c" /* formatPhoneNumber */],label:'Phone Number',renderer:'input'},{attribute:'rolesId',label:'Title',renderer:'dropdown',options:this.props.roles.map(function(role){return{value:role.id,label:__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["c" /* CONTRACTOR_ROLES */][role.name]};})}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_modal_InviteUserModal__["b" /* default */],{form:userFormFields,invalidFields:this.props.invalidFields,modalState:this.props.userModalState,show:this.props.showInviteUserModal,values:this.props.form,validationMessage:this.props.validationMessage,onAttributeChange:this.handleAttributeChange,onClose:this.handleClose,onDeleteConfirmation:this.handleDeleteConfirmation,onEdit:this.handleEdit,onSubmit:this.handleSubmit}));}}]);return ContractorTeamUserModalContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUserId:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["d" /* getCurrentUserId */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["e" /* getForm */])(state),invalidFields:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["f" /* getInvalidFields */])(state),roles:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["h" /* getRoles */])(state),showInviteUserModal:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["j" /* getShowInviteUserModal */])(state),userModalState:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["n" /* getUserModalState */])(state),validationMessage:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["p" /* getValidationMessage */])(state)};})(ContractorTeamUserModalContainer));

/***/ }),
/* 2419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_InviteTechnicianModal__ = __webpack_require__(2420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_utils_text_util__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorTeamTechnicianModalContainer=function(_Component){_inherits(ContractorTeamTechnicianModalContainer,_Component);function ContractorTeamTechnicianModalContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ContractorTeamTechnicianModalContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ContractorTeamTechnicianModalContainer.__proto__||Object.getPrototypeOf(ContractorTeamTechnicianModalContainer)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["n" /* setShowInviteTechnicianModal */])(false));},_this.handleSubmit=function(){var _this$props=_this.props,form=_this$props.form,dispatch=_this$props.dispatch,currentTechnicianId=_this$props.currentTechnicianId;dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["q" /* submitFormRequestForTechnician */])(form,currentTechnicianId));},_this.handleAttributeChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["r" /* updateFormValue */])(attribute,value));},_this.handleEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["n" /* setShowInviteTechnicianModal */])(true,__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_InviteTechnicianModal__["a" /* TechnicianModalState */].EDIT));},_this.handleDeleteConfirmation=function(result){if(result){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["b" /* deleteTechnicianRequest */])(_this.props.currentTechnicianId));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ContractorTeamTechnicianModalContainer,[{key:'render',value:function render(){var technicianFormField=[{attribute:'firstName',label:'First Name*',renderer:'input'},{attribute:'lastName',label:'Last Name',renderer:'input'},{attribute:'email',label:'Email',renderer:'input'},{attribute:'phoneNumber',formatter:__WEBPACK_IMPORTED_MODULE_5_services_utils_text_util__["c" /* formatPhoneNumber */],label:'Phone Number',renderer:'input'}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_InviteTechnicianModal__["b" /* default */],{form:technicianFormField,invalidFields:this.props.invalidFields,modalState:this.props.technicianModalState,show:this.props.showInviteTechnicianModal,values:this.props.form,validationMessage:this.props.validationMessage,onAttributeChange:this.handleAttributeChange,onClose:this.handleClose,onDeleteConfirmation:this.handleDeleteConfirmation,onEdit:this.handleEdit,onSubmit:this.handleSubmit}));}}]);return ContractorTeamTechnicianModalContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentTechnicianId:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["c" /* getCurrentTechnicianId */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["e" /* getForm */])(state),invalidFields:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["f" /* getInvalidFields */])(state),showInviteTechnicianModal:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["i" /* getShowInviteTechnicianModal */])(state),technicianModalState:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["k" /* getTechnicianModalState */])(state),validationMessage:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["p" /* getValidationMessage */])(state)};})(ContractorTeamTechnicianModalContainer));

/***/ }),
/* 2420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TechnicianModalState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InviteUserModal_css__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InviteUserModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__InviteUserModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_modal_FormModal__ = __webpack_require__(23);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TechnicianModalState={NEW:'new',EDIT:'edit',READ_ONLY:'readOnly'};var InviteTechnicianModal=function(_Component){_inherits(InviteTechnicianModal,_Component);function InviteTechnicianModal(props){_classCallCheck(this,InviteTechnicianModal);var _this=_possibleConstructorReturn(this,(InviteTechnicianModal.__proto__||Object.getPrototypeOf(InviteTechnicianModal)).call(this,props));_this.handleClose=function(){if(_this.props.onClose){_this.props.onClose();}};_this.handleSubmit=function(event){event.preventDefault();if(_this.props.onSubmit){_this.props.onSubmit();}};_this.handleAttributeChange=function(attribute,value){if(_this.props.onAttributeChange){_this.props.onAttributeChange(attribute,value);}};_this.handleMultipleSelected=function(attribute,value){if(_this.props.onAttributeChange){var newValue=void 0;if(_this.props.values[attribute].find(function(element){return element===value;})!==undefined){newValue=_this.props.values[attribute].filter(function(element){return element!==value;});}else{newValue=_this.props.values[attribute].concat([value]);}_this.props.onAttributeChange(attribute,newValue);}};_this.handleEdit=function(){if(_this.props.onEdit){_this.props.onEdit();}};_this.handleDelete=function(){_this.setState({showConfirmation:true});};_this.handleDeleteConfirmation=function(result){_this.setState({showConfirmation:false});if(_this.props.onDeleteConfirmation){_this.props.onDeleteConfirmation(result);}};_this.state={showConfirmation:false};return _this;}_createClass(InviteTechnicianModal,[{key:'render',value:function render(){var _this2=this;var title=this.props.modalState===TechnicianModalState.NEW?'Add Technician':'Edit Technician';var buttonText=this.props.modalState===TechnicianModalState.NEW?'Add':'Update';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_modal_FormModal__["a" /* default */],{className:'invite-user-modal'+(this.props.className!==null?' '+this.props.className:''),show:this.props.show,title:title,onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.handleSubmit},this.props.form.filter(function(item){return item.show===undefined||item.show;}).map(function(item,index){if(typeof item.renderer==='string'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:3},item.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:9},_this2.renderItem(item)));}else if(_typeof(item.renderer)==='object'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],{key:index},item.renderer);}else{return null;}}),this.props.validationMessage!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},this.props.validationMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:12},this.props.modalState!==TechnicianModalState.READ_ONLY?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',value:buttonText,type:'submit'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{id:'edit-technician',label:'Edit',className:'button-orange',onClick:this.handleEdit}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{id:'delete-technician',label:'Delete',className:'button-gray',onClick:this.handleDelete})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showConfirmation,message:'Are you sure?',onHide:this.handleDeleteConfirmation}));}},{key:'renderItem',value:function renderItem(item){if(item.renderer==='input'){var readOnly=this.props.modalState===TechnicianModalState.READ_ONLY;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_Input__["a" /* default */],{id:item.attribute,placeholder:item.label,readOnly:readOnly,theme:'normal',type:item.attribute==='email'?'email':'text',valid:this.props.invalidFields.find(function(element){return element===item.attribute;})===undefined,value:readOnly?item.formatter?item.formatter(this.props.values[item.attribute]):this.props.values[item.attribute]:this.props.values[item.attribute],onChange:this.handleAttributeChange.bind(this,item.attribute)});}else{return null;}}}]);return InviteTechnicianModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);InviteTechnicianModal.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,form:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({attribute:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,formatter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,renderer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['input']),__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}))})).isRequired,invalidFields:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,modalState:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.values(TechnicianModalState)).isRequired,show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,validationMessage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,values:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired,onAttributeChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onDeleteConfirmation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};InviteTechnicianModal.defaultProps={className:null,invalidFields:[],rolesInput:'single',validationMessage:''};/* harmony default export */ __webpack_exports__["b"] = (InviteTechnicianModal);

/***/ }),
/* 2421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_text_UserStatus__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_modal_InviteUserModal__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ContractorTeam_css__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ContractorTeam_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ContractorTeam_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_api_users_api__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_selectors_authentication__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UsersTableHeaders=['NAME','TITLE','STATUS','WORK ORDERS','PHONE NUMBER','EMAIL','ACTIONS'];var UsersTable=function(_Component){_inherits(UsersTable,_Component);function UsersTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UsersTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UsersTable.__proto__||Object.getPrototypeOf(UsersTable)).call.apply(_ref,[this].concat(args))),_this),_this.handleSelectUser=function(user){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["m" /* setCurrentUserId */])(user.id));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["i" /* loadUserFormRequest */])(user));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["o" /* setShowInviteUserModal */])(true,__WEBPACK_IMPORTED_MODULE_8_components_shared_modal_InviteUserModal__["a" /* UserModalState */].READ_ONLY));},_this.handleResendInvite=function(id){__WEBPACK_IMPORTED_MODULE_10_services_api_users_api__["b" /* usersApi */].resendInvite(id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UsersTable,[{key:'render',value:function render(){var users=this.props.users;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__["a" /* default */],{headers:UsersTableHeaders,rows:this.mapUsers(users),emptyMessage:'No Users'});}},{key:'actionBtns',value:function actionBtns(currentUser,user){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'action-btns-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'linkable action-btn',onClick:function onClick(){return _this2.handleSelectUser(user);}},'Edit'),__WEBPACK_IMPORTED_MODULE_10_services_api_users_api__["b" /* usersApi */].resendInviteLink(currentUser,user)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'linkable action-btn',onClick:function onClick(){return _this2.handleResendInvite(user.id);}},'Resend Invite'):'');}},{key:'mapUsers',value:function mapUsers(users){var _this3=this;var currentUser=this.props.currentUser;return users.map(function(user){var status=void 0;if(user.invitation_sent_at===null||user.invitation_accepted_at!==null){status=user.status;}else if(user.invitation_accepted_at===null){status='pending_invitation';}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},user.first_name+' '+user.last_name),user.roles&&_this3.mapTitle(user.roles),status&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_UserStatus__["a" /* default */],{status:status}),user.work_order_users_count,user.phone_number!==null?Object(__WEBPACK_IMPORTED_MODULE_6_services_utils_text_util__["c" /* formatPhoneNumber */])(user.phone_number):'N/A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:'+user.email,className:'mailto'},user.email),_this3.actionBtns(currentUser,user)];});}},{key:'mapTitle',value:function mapTitle(roles){var titles=roles.filter(function(role){return role.resource_type===__WEBPACK_IMPORTED_MODULE_7_services_utils_users_util__["f" /* TYPES */].CONTRACTOR;}).map(function(role){return __WEBPACK_IMPORTED_MODULE_7_services_utils_users_util__["c" /* CONTRACTOR_ROLES */][role.name];});if(titles.length>1){return titles.join(' / ');}else if(titles.length===1){return titles[0];}else{return'N/A';}}}]);return UsersTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{users:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["o" /* getUsers */])(state),activeTab:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["a" /* getActiveTab */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_authentication__["d" /* getCurrentUser */])(state)};})(UsersTable));

/***/ }),
/* 2422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_modal_InviteUserModal__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ContractorTeam_css__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ContractorTeam_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ContractorTeam_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_api_users_api__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_authentication__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TechniciansTableHeaders=['NAME','EMAIL','PHONE NUMBER','ACTIONS'];var TechniciansTable=function(_Component){_inherits(TechniciansTable,_Component);function TechniciansTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TechniciansTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TechniciansTable.__proto__||Object.getPrototypeOf(TechniciansTable)).call.apply(_ref,[this].concat(args))),_this),_this.handlePageChange=function(newPage){var _this$props=_this.props,dispatch=_this$props.dispatch,activeTab=_this$props.activeTab;dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["h" /* loadTechnicianRequest */])(newPage,activeTab));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["k" /* setCurrentPageTechnicians */])(newPage));},_this.handleSelectUser=function(user){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["l" /* setCurrentTechnicianId */])(user.id));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["g" /* loadTechnicianFormRequest */])(user));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_contractor_team__["n" /* setShowInviteTechnicianModal */])(true,__WEBPACK_IMPORTED_MODULE_6_components_shared_modal_InviteUserModal__["a" /* UserModalState */].READ_ONLY));},_this.handleResendInvite=function(id){__WEBPACK_IMPORTED_MODULE_9_services_api_users_api__["b" /* usersApi */].resendInvite(id);},_this.mapTechnicians=function(technicians){var currentUser=_this.props.currentUser;return technicians.map(function(technician){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},technician.first_name,' ',technician.last_name),technician.email||'N/A',technician.phone_number?Object(__WEBPACK_IMPORTED_MODULE_5_services_utils_text_util__["c" /* formatPhoneNumber */])(technician.phone_number):'N/A',_this.actionBtns(currentUser,technician)];});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TechniciansTable,[{key:'render',value:function render(){var _props=this.props,technicians=_props.technicians,currentPageTechnicians=_props.currentPageTechnicians,perPageTechnicians=_props.perPageTechnicians,totalTechnicians=_props.totalTechnicians;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__["a" /* default */],{headers:TechniciansTableHeaders,rows:this.mapTechnicians(technicians),emptyMessage:'No Technicians'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPageTechnicians,pageSize:perPageTechnicians,total:totalTechnicians,onPageChange:this.handlePageChange})));}},{key:'actionBtns',value:function actionBtns(currentUser,user){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'action-btns-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'linkable action-btn',onClick:function onClick(){return _this2.handleSelectUser(user);}},'Edit'),__WEBPACK_IMPORTED_MODULE_9_services_api_users_api__["b" /* usersApi */].resendInviteLink(currentUser,user)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'linkable action-btn',onClick:function onClick(){return _this2.handleResendInvite(user.id);}},'Resend Invite'):'');}}]);return TechniciansTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{technicians:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["l" /* getTechnicians */])(state),currentPageTechnicians:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["b" /* getCurrentPageTechnicians */])(state),perPageTechnicians:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["g" /* getPerPageTechnicians */])(state),totalTechnicians:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["m" /* getTotalTechnicians */])(state),activeTab:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_contractor_team__["a" /* getActiveTab */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_authentication__["d" /* getCurrentUser */])(state)};})(TechniciansTable));

/***/ }),
/* 2424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientTeam_css__ = __webpack_require__(2425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientTeam_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ClientTeam_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_details_DetailsHeader__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_details_DetailsInfo__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_details_DetailsInfoItem__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_admin_team_client_team__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_selectors_admin_team_client_team__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_modal_InviteUserModal__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ClientTeamUserModalContainer__ = __webpack_require__(2426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_shared_text_UserStatus__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_shared_logo_upload_LogoUpload__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_services_api_users_api__ = __webpack_require__(123);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClientTeam=function(_Component){_inherits(ClientTeam,_Component);function ClientTeam(props){_classCallCheck(this,ClientTeam);var _this=_possibleConstructorReturn(this,(ClientTeam.__proto__||Object.getPrototypeOf(ClientTeam)).call(this,props));_this.handleEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_team_client_team__["b" /* goToEditClient */])());};_this.handleInviteUser=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_team_client_team__["h" /* setCurrentUserId */])(0));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_team_client_team__["f" /* loadUserForm */])(null));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_team_client_team__["i" /* setShowInviteUserModal */])(true,__WEBPACK_IMPORTED_MODULE_13_components_shared_modal_InviteUserModal__["a" /* UserModalState */].NEW));};_this.handleSelectUser=function(user){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_team_client_team__["h" /* setCurrentUserId */])(user.id));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_team_client_team__["f" /* loadUserForm */])(user));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_team_client_team__["i" /* setShowInviteUserModal */])(true,__WEBPACK_IMPORTED_MODULE_13_components_shared_modal_InviteUserModal__["a" /* UserModalState */].READ_ONLY));};_this.handleResendInvite=function(id){__WEBPACK_IMPORTED_MODULE_19_services_api_users_api__["b" /* usersApi */].resendInvite(id);};_this.clientId=_this.props.currentUser.accountable_id;return _this;}_createClass(ClientTeam,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_team_client_team__["d" /* loadClientRequest */])(this.clientId)).then(function(response){if(response.ok){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_team_client_team__["g" /* loadUsersRequest */])());_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_team_client_team__["c" /* loadBuildingsRequest */])(_this2.clientId));}});}},{key:'actionBtns',value:function actionBtns(currentUser,user){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'action-btns-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'linkable action-btn',onClick:function onClick(){return _this3.handleSelectUser(user);}},'Edit'),__WEBPACK_IMPORTED_MODULE_19_services_api_users_api__["b" /* usersApi */].resendInviteLink(currentUser,user)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'linkable action-btn',onClick:function onClick(){return _this3.handleResendInvite(user.id);}},'Resend Invite'):'');}},{key:'render',value:function render(){return this.props.client!==null&&this.props.client.id===this.clientId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'client-team'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['client',this.props.client.company_name]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_details_DetailsHeader__["a" /* default */],{leftHeader:{title:'CLIENT',value:this.props.client.company_name},leftHeaderExtraComponents:this.props.client.logo&&this.props.client.logo.image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-preview-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_shared_logo_upload_LogoUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],logos:[{preview:this.props.client.logo.image.url,url:this.props.client.logo.image.url}],readOnly:true})),rightHeaders:[[{title:'WO COMPLETED',value:this.props.client.wo_complete_count},{title:'TOTAL SPENT',value:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__["a" /* default */],{value:this.props.client.total_spent,format:'$0,0'})}]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-info-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_details_DetailsInfo__["a" /* default */],{itemsContainerSize:12,itemsLines:[[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:this.props.client.location?[this.props.client.location.street_address_1,this.props.client.location.city+', '+this.props.client.location.state+' '+this.props.client.location.zip]:['N/A'],title:'ADDRESS'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'name'},this.props.client.contact.first_name+' '+this.props.client.contact.last_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'email'},this.props.client.contact.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_17_services_utils_text_util__["c" /* formatPhoneNumber */])(this.props.client.contact.phone_number))],title:'PRIMARY CONTACT'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:this.props.client.propietary_sub_contractors.map(function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'contractor'},element.name);}),title:'PROPRIETARY SUBCONTRACTORS'})]],rightContainerSize:0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edit-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-gray',value:'Edit',onClick:this.handleEdit}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invite-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Invite',onClick:this.handleInviteUser})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_table_SimpleTable__["a" /* default */],{className:'users-table',headers:['NAME','WO ROLES/PERMISSIONS','TITLE','STATUS','WORK ORDERS','PHONE NUMBER','EMAIL','ACTIONS'],rows:this.mapUsers(this.props.users),emptyMessage:'No Users',onRowSelected:this.handleSelectUser})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ClientTeamUserModalContainer__["a" /* default */],null));}},{key:'mapUsers',value:function mapUsers(users){var _this4=this;var currentUser=this.props.currentUser;return users.map(function(user){var status=void 0;if(user.invitation_sent_at===null||user.invitation_accepted_at!==null){status=user.status;}else if(user.invitation_accepted_at===null){status='pending_invitation';}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},user.first_name+' '+user.last_name),_this4.mapTitle(user.roles),user.title!==null?user.title:'N/A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_text_UserStatus__["a" /* default */],{status:status}),user.work_order_users_count,user.phone_number!==null?Object(__WEBPACK_IMPORTED_MODULE_17_services_utils_text_util__["c" /* formatPhoneNumber */])(user.phone_number):'N/A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:'+user.email,className:'mailto'},user.email),_this4.actionBtns(currentUser,user)];});}},{key:'mapTitle',value:function mapTitle(roles){var titles=roles.map(function(role){return __WEBPACK_IMPORTED_MODULE_16_services_utils_users_util__["b" /* CLIENT_ROLES */][role.name];});if(titles.length>1){return titles.join(' / ');}else if(titles.length===1){return titles[0];}else{return'N/A';}}}]);return ClientTeam;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{client:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_admin_team_client_team__["b" /* getClient */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_authentication__["d" /* getCurrentUser */])(state),users:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_admin_team_client_team__["j" /* getUsers */])(state)};})(ClientTeam));

/***/ }),
/* 2425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientTeamUserModalContainer_css__ = __webpack_require__(2427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientTeamUserModalContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ClientTeamUserModalContainer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_InviteUserModal__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_admin_team_client_team__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_team_client_team__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_domain_building__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_select_MultipleSelectList__ = __webpack_require__(334);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClientTeamUserModalContainer=function(_Component){_inherits(ClientTeamUserModalContainer,_Component);function ClientTeamUserModalContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientTeamUserModalContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientTeamUserModalContainer.__proto__||Object.getPrototypeOf(ClientTeamUserModalContainer)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_team_client_team__["i" /* setShowInviteUserModal */])(false));},_this.handleSubmit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_team_client_team__["k" /* submitUserFormRequest */])(_this.props.userForm,_this.props.currentUserId,_this.props.roles));},_this.handleAttributeChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_team_client_team__["n" /* updateUserFormValue */])(attribute,value));},_this.handleBuildingSelect=function(buildingId){if(_this.props.userForm.buildingsId.find(function(id){return id===buildingId;})!==undefined){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_team_client_team__["n" /* updateUserFormValue */])('buildingsId',_this.props.userForm.buildingsId.filter(function(id){return id!==buildingId;})));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_team_client_team__["n" /* updateUserFormValue */])('buildingsId',_this.props.userForm.buildingsId.concat([buildingId])));}},_this.handleEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_team_client_team__["i" /* setShowInviteUserModal */])(true,__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_InviteUserModal__["a" /* UserModalState */].EDIT));},_this.handleDeleteConfirmation=function(result){if(result){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_team_client_team__["a" /* deleteUserRequest */])(_this.props.currentUserId));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientTeamUserModalContainer,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.roles.length===0){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_team_client_team__["e" /* loadRolesRequest */])());}}},{key:'render',value:function render(){var _this2=this;var showBuildings=false;var businessMaganerRole=this.props.roles.find(function(role){return role.name===__WEBPACK_IMPORTED_MODULE_3_services_utils_users_util__["e" /* ROLES */].CLIENT_BUILDING_MANAGER;});if(businessMaganerRole!==null){showBuildings=this.props.userForm.rolesId.find(function(id){return id===businessMaganerRole.id;})!==undefined;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_InviteUserModal__["b" /* default */],{className:'client-team-user-modal-container',form:[{attribute:'firstName',label:'First Name',renderer:'input'},{attribute:'lastName',label:'Last Name',renderer:'input'},{attribute:'title',label:'Title',renderer:'input'},{attribute:'email',label:'Email',renderer:'input'},{attribute:'phoneNumber',formatter:__WEBPACK_IMPORTED_MODULE_7_services_utils_text_util__["c" /* formatPhoneNumber */],label:'Phone Number',renderer:'input'},{attribute:'rolesId',label:'Work Order Permissions',renderer:'multiple',options:this.props.roles.filter(function(role){return role.name!==__WEBPACK_IMPORTED_MODULE_3_services_utils_users_util__["e" /* ROLES */].OWNER;}).map(function(role){return{value:role.id,label:__WEBPACK_IMPORTED_MODULE_3_services_utils_users_util__["b" /* CLIENT_ROLES */][role.name]};})},{attribute:'buildingsId',label:'Buildings',options:this.props.buildings.map(function(building){return{value:building.id,label:__WEBPACK_IMPORTED_MODULE_8_domain_building__["a" /* Building */].getPrettyName(building,true)};}),renderer:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-12 building-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body-bold'},this.props.userModalState===__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_InviteUserModal__["a" /* UserModalState */].READ_ONLY?'Buildings assigned':'Please assign buildings to this user'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_select_MultipleSelectList__["a" /* default */],{options:this.props.buildings.map(function(building){return{id:building.id,selected:_this2.props.userForm['buildingsId'].find(function(id){return id===building.id;})!==undefined,value:__WEBPACK_IMPORTED_MODULE_8_domain_building__["a" /* Building */].getPrettyName(building,true)};}),readOnly:this.props.userModalState===__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_InviteUserModal__["a" /* UserModalState */].READ_ONLY,show:5,onSelect:this.handleBuildingSelect})),show:showBuildings}],invalidFields:this.props.invalidFields,modalState:this.props.userModalState,show:this.props.showInviteUserModal,values:this.props.userForm,validationMessage:this.props.validationMessage,onAttributeChange:this.handleAttributeChange,onClose:this.handleClose,onDeleteConfirmation:this.handleDeleteConfirmation,onEdit:this.handleEdit,onSubmit:this.handleSubmit});}}]);return ClientTeamUserModalContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{buildings:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_team_client_team__["a" /* getBuildings */])(state),currentUserId:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_team_client_team__["d" /* getCurrentUserId */])(state),userForm:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_team_client_team__["h" /* getUserForm */])(state),invalidFields:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_team_client_team__["e" /* getInvalidFields */])(state),roles:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_team_client_team__["f" /* getRoles */])(state),showInviteUserModal:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_team_client_team__["g" /* getShowInviteUserModal */])(state),userModalState:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_team_client_team__["i" /* getUserModalState */])(state),validationMessage:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_team_client_team__["k" /* getValidationMessage */])(state)};})(ClientTeamUserModalContainer));

/***/ }),
/* 2427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GeneralContractorTeam_css__ = __webpack_require__(2429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GeneralContractorTeam_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__GeneralContractorTeam_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_team_general_contractor_team__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_actions_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_modal_InviteUserModal__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_details_DetailsHeader__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_contractors_ContractorStatus__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfo__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_details_DetailsInfoItem__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_text_UserStatus__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_general_contractors_store_selectors__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_selectors_admin_team_general_contractor_team__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_team_GeneralContractorTeamUserModalContainer__ = __webpack_require__(2430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_shared_logo_upload_LogoUpload__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_services_api_users_api__ = __webpack_require__(123);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GeneralContractorTeam=function(_Component){_inherits(GeneralContractorTeam,_Component);function GeneralContractorTeam(props){_classCallCheck(this,GeneralContractorTeam);var _this=_possibleConstructorReturn(this,(GeneralContractorTeam.__proto__||Object.getPrototypeOf(GeneralContractorTeam)).call(this,props));_this.handleInviteUser=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_general_contractor_team__["f" /* setCurrentUserId */])(0));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_general_contractor_team__["d" /* loadUserFormRequest */])(null));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_general_contractor_team__["g" /* setShowInviteUserModal */])(true,__WEBPACK_IMPORTED_MODULE_5_components_shared_modal_InviteUserModal__["a" /* UserModalState */].NEW));};_this.handleSelectUser=function(user){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_general_contractor_team__["f" /* setCurrentUserId */])(user.id));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_general_contractor_team__["d" /* loadUserFormRequest */])(user));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_general_contractor_team__["g" /* setShowInviteUserModal */])(true,__WEBPACK_IMPORTED_MODULE_5_components_shared_modal_InviteUserModal__["a" /* UserModalState */].READ_ONLY));};_this.handleEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_general_contractor_team__["b" /* goToEditGeneralContractorTeam */])());};_this.handleResendInvite=function(id){__WEBPACK_IMPORTED_MODULE_20_services_api_users_api__["b" /* usersApi */].resendInvite(id);};_this.generalContractorId=_this.props.currentUser.accountable_id;return _this;}_createClass(GeneralContractorTeam,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_actions_js__["e" /* loadGeneralContractorRequest */])(this.generalContractorId)).then(function(response){if(response.ok){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_general_contractor_team__["e" /* loadUsersRequest */])());}});}},{key:'actionBtns',value:function actionBtns(currentUser,user){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'action-btns-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'linkable action-btn',onClick:function onClick(){return _this3.handleSelectUser(user);}},'Edit'),__WEBPACK_IMPORTED_MODULE_20_services_api_users_api__["b" /* usersApi */].resendInviteLink(currentUser,user)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'linkable action-btn',onClick:function onClick(){return _this3.handleResendInvite(user.id);}},'Resend Invite'):'');}},{key:'render',value:function render(){var detailsInfoItems=[];if(this.props.generalContractor){if(this.props.generalContractor.location){detailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[this.props.generalContractor.location.street_address_1,this.props.generalContractor.location.city+', '+this.props.generalContractor.location.state+' '+this.props.generalContractor.location.zip],title:'ADDRESS'}));}detailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'general-contractor-name'},this.props.generalContractor.contact.first_name+' '+this.props.generalContractor.contact.last_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'general-contractor-email',href:'mailto:'+this.props.generalContractor.contact.email},this.props.generalContractor.contact.email),Object(__WEBPACK_IMPORTED_MODULE_18_services_utils_text_util__["c" /* formatPhoneNumber */])(this.props.generalContractor.contact.phone_number)],title:'PRIMARY CONTACT'}));detailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[this.props.generalContractor.license_number],title:'LICENSE NUMBER'}));}return this.props.generalContractor!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['COMPANY',this.props.generalContractor.name.toUpperCase()]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_details_DetailsHeader__["a" /* default */],{leftHeader:{title:'COMPANY',value:this.props.generalContractor.name},leftHeaderExtraComponents:this.props.generalContractor.logo&&this.props.generalContractor.logo.image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-preview-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_shared_logo_upload_LogoUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],logos:[{preview:this.props.generalContractor.logo.image.url,url:this.props.generalContractor.logo.image.url}],readOnly:true})),rightHeaders:[[{title:'STATUS',value:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_admin_contractors_ContractorStatus__["a" /* default */],{status:this.props.generalContractor.status})}]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-info-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfo__["a" /* default */],{itemsContainerSize:12,itemsLines:[detailsInfoItems]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edit-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-gray',value:'Edit',onClick:this.handleEdit}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invite-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-orange',value:'Invite',onClick:this.handleInviteUser})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_shared_table_SimpleTable__["a" /* default */],{className:'users-table',headers:['NAME','TITLE','STATUS','PHONE NUMBER','EMAIL','ACTIONS'],rows:this.mapUsers(this.props.users),emptyMessage:'No Users'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_admin_team_GeneralContractorTeamUserModalContainer__["a" /* default */],null));}},{key:'mapUsers',value:function mapUsers(users){var _this4=this;var currentUser=this.props.currentUser;return users.map(function(user){var status=void 0;if(user.invitation_sent_at===null||user.invitation_accepted_at!==null){status=user.status;}else if(user.invitation_accepted_at===null){status='pending_invitation';}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},user.first_name+' '+user.last_name),_this4.mapTitle(user.roles),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_text_UserStatus__["a" /* default */],{status:status}),user.phone_number!==null?Object(__WEBPACK_IMPORTED_MODULE_18_services_utils_text_util__["c" /* formatPhoneNumber */])(user.phone_number):'N/A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:'+user.email,className:'mailto'},user.email),_this4.actionBtns(currentUser,user)];});}},{key:'mapTitle',value:function mapTitle(roles){var titles=roles.filter(function(role){return role.resource_type===__WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR;}).map(function(role){return __WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__["d" /* GENERAL_CONTRACTOR_ROLES */][role.name];});if(titles.length>1){return titles.join(' / ');}else if(titles.length===1){return titles[0];}else{return'N/A';}}}]);return GeneralContractorTeam;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{generalContractor:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_general_contractors_store_selectors__["b" /* getCurrentGeneralContractor */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_14_selectors_authentication__["d" /* getCurrentUser */])(state),users:Object(__WEBPACK_IMPORTED_MODULE_15_selectors_admin_team_general_contractor_team__["g" /* getUsers */])(state)};})(GeneralContractorTeam));

/***/ }),
/* 2429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_general_contractor_team__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_team_general_contractor_team__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_modal_InviteUserModal__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_text_util__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GeneralContractorTeamUserModalContainer=function(_Component){_inherits(GeneralContractorTeamUserModalContainer,_Component);function GeneralContractorTeamUserModalContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GeneralContractorTeamUserModalContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GeneralContractorTeamUserModalContainer.__proto__||Object.getPrototypeOf(GeneralContractorTeamUserModalContainer)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_general_contractor_team__["g" /* setShowInviteUserModal */])(false));},_this.handleSubmit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_general_contractor_team__["h" /* submitFormRequest */])(_this.props.form,_this.props.currentUserId,_this.props.roles));},_this.handleAttributeChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_general_contractor_team__["i" /* updateFormValue */])(attribute,value));},_this.handleEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_general_contractor_team__["g" /* setShowInviteUserModal */])(true,__WEBPACK_IMPORTED_MODULE_5_components_shared_modal_InviteUserModal__["a" /* UserModalState */].EDIT));},_this.handleDeleteConfirmation=function(result){if(result){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_general_contractor_team__["a" /* deleteUserRequest */])(_this.props.currentUserId));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GeneralContractorTeamUserModalContainer,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.roles.length===0){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_team_general_contractor_team__["c" /* loadRolesRequest */])());}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_modal_InviteUserModal__["b" /* default */],{form:[{attribute:'firstName',label:'First Name',renderer:'input'},{attribute:'lastName',label:'Last Name',renderer:'input'},{attribute:'email',label:'Email',renderer:'input'},{attribute:'phoneNumber',formatter:__WEBPACK_IMPORTED_MODULE_6_services_utils_text_util__["c" /* formatPhoneNumber */],label:'Phone Number',renderer:'input'},{attribute:'rolesId',label:'Title',renderer:'dropdown',options:this.props.roles.map(function(role){return{value:role.id,label:__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["d" /* GENERAL_CONTRACTOR_ROLES */][role.name]};})}],invalidFields:this.props.invalidFields,modalState:this.props.userModalState,show:this.props.showInviteUserModal,values:this.props.form,validationMessage:this.props.validationMessage,onAttributeChange:this.handleAttributeChange,onClose:this.handleClose,onDeleteConfirmation:this.handleDeleteConfirmation,onEdit:this.handleEdit,onSubmit:this.handleSubmit}));}}]);return GeneralContractorTeamUserModalContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUserId:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_general_contractor_team__["a" /* getCurrentUserId */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_general_contractor_team__["b" /* getForm */])(state),invalidFields:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_general_contractor_team__["c" /* getInvalidFields */])(state),roles:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_general_contractor_team__["d" /* getRoles */])(state),showInviteUserModal:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_general_contractor_team__["e" /* getShowInviteUserModal */])(state),userModalState:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_general_contractor_team__["f" /* getUserModalState */])(state),validationMessage:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_admin_team_general_contractor_team__["h" /* getValidationMessage */])(state)};})(GeneralContractorTeamUserModalContainer));

/***/ }),
/* 2431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_service_providers_ServiceProvidersDetails_js__ = __webpack_require__(969);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ServiceProviderTeam=function(_Component){_inherits(ServiceProviderTeam,_Component);function ServiceProviderTeam(){_classCallCheck(this,ServiceProviderTeam);return _possibleConstructorReturn(this,(ServiceProviderTeam.__proto__||Object.getPrototypeOf(ServiceProviderTeam)).apply(this,arguments));}_createClass(ServiceProviderTeam,[{key:'render',value:function render(){var currentUser=this.props.currentUser;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_admin_service_providers_ServiceProvidersDetails_js__["a" /* default */],{id:currentUser.accountable_id,type:currentUser.accountable_type});}}]);return ServiceProviderTeam;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_authentication__["d" /* getCurrentUser */])(state)};})(ServiceProviderTeam));

/***/ }),
/* 2432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContractorTeamEdit__ = __webpack_require__(2433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClientTeamEdit__ = __webpack_require__(2434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_team_GeneralContractorTeamEdit__ = __webpack_require__(2436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_team_ServiceProvidersTeamEdit__ = __webpack_require__(2438);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TeamEdit=function(_Component){_inherits(TeamEdit,_Component);function TeamEdit(){_classCallCheck(this,TeamEdit);return _possibleConstructorReturn(this,(TeamEdit.__proto__||Object.getPrototypeOf(TeamEdit)).apply(this,arguments));}_createClass(TeamEdit,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3__services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_3__services_utils_users_util__["f" /* TYPES */].CONTRACTOR)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ContractorTeamEdit__["a" /* default */],null);}else if(__WEBPACK_IMPORTED_MODULE_3__services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_3__services_utils_users_util__["f" /* TYPES */].CLIENT)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ClientTeamEdit__["a" /* default */],null);}else if(__WEBPACK_IMPORTED_MODULE_3__services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_3__services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_team_GeneralContractorTeamEdit__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_team_ServiceProvidersTeamEdit__["a" /* default */],null);}}}]);return TeamEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_2__selectors_authentication__["d" /* getCurrentUser */])(state)};})(TeamEdit));

/***/ }),
/* 2433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contractors_ContractorForm__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_admin_contractors_contractors__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors_admin_contractors_contractors__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_team_contractor_team__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_modal_SigningModal__ = __webpack_require__(424);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorTeamEdit=function(_Component){_inherits(ContractorTeamEdit,_Component);function ContractorTeamEdit(props){_classCallCheck(this,ContractorTeamEdit);var _this=_possibleConstructorReturn(this,(ContractorTeamEdit.__proto__||Object.getPrototypeOf(ContractorTeamEdit)).call(this,props));_this.setConfirmed=function(){if(_this.props.currentUser.accountable_type===__WEBPACK_IMPORTED_MODULE_7_services_utils_users_util__["f" /* TYPES */].CONTRACTOR){_this.handleFormChange('confirmed',true);}};_this.needsConfirmation=function(){return _this.props.currentUser.accountable_type===__WEBPACK_IMPORTED_MODULE_7_services_utils_users_util__["f" /* TYPES */].CONTRACTOR&&!_this.props.contractor.confirmed;};_this.handleServiceAreaSelection=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_admin_contractors_contractors__["n" /* selectServiceArea */])(value));};_this.handleTradesSelection=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_admin_contractors_contractors__["o" /* selectTrade */])(value));};_this.handleUnionSelection=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_admin_contractors_contractors__["p" /* selectUnion */])(value,_this.props.unions,_this.props.selectedUnionsId));};_this.handleW9DocumentChange=function(file){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_admin_contractors_contractors__["r" /* setW9Document */])(file));};_this.handleFormChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_admin_contractors_contractors__["y" /* updateFormValue */])(attribute,value));};_this.handleSubmit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_admin_contractors_contractors__["v" /* submitFormRequest */])(_this.props.form,_this.props.selectedServiceAreasId,_this.props.selectedTradesId,_this.props.selectedUnionsId,_this.props.w9Document,false,_this.contractorId,_this.needsConfirmation()));};_this.handleMsaSigningModalClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_team_contractor_team__["e" /* goToTeam */])());_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_admin_contractors_contractors__["f" /* hideMsaSigningModal */])());};_this.contractorId=_this.props.currentUser.accountable_id;return _this;}_createClass(ContractorTeamEdit,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_admin_contractors_contractors__["i" /* loadNewContractorParametersRequest */])(this.props.serviceAreas,this.props.trades,this.props.unions)).then(function(){if(_this2.props.contractor===null){// If contractor not loaded, load it
_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_admin_contractors_contractors__["g" /* loadContractorRequest */])(_this2.contractorId)).then(function(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_admin_contractors_contractors__["x" /* updateFormFromCurrentContractor */])(_this2.props.contractor));}).then(function(){return _this2.setConfirmed();});}else{_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_admin_contractors_contractors__["x" /* updateFormFromCurrentContractor */])(_this2.props.contractor));_this2.setConfirmed();}});}},{key:'render',value:function render(){return this.props.contractor&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__contractors_ContractorForm__["a" /* default */],{edit:true,needsConfirmation:this.needsConfirmation(),form:this.props.form,invalidFields:this.props.invalidFields,selectedServiceAreasId:this.props.selectedServiceAreasId,selectedTradesId:this.props.selectedTradesId,selectedUnionsId:this.props.selectedUnionsId,w9Document:this.props.w9Document,serviceAreas:this.props.serviceAreas,trades:this.props.trades,unions:this.props.unions,validationMessage:this.props.validationMessage,withInvitation:false,onFormChange:this.handleFormChange,onServiceAreaSelection:this.handleServiceAreaSelection,onSubmit:this.handleSubmit,onTradesSelection:this.handleTradesSelection,onUnionSelection:this.handleUnionSelection,onW9DocumentChange:this.handleW9DocumentChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_modal_SigningModal__["a" /* default */],{show:this.props.showMsaSigningModal,url:this.props.msaSigningUrl,title:'Sign MSA',handleClose:this.handleMsaSigningModalClose}));}}]);return ContractorTeamEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{contractor:Object(__WEBPACK_IMPORTED_MODULE_5__selectors_admin_contractors_contractors__["f" /* getCurrentContractor */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_3__selectors_authentication__["d" /* getCurrentUser */])(state),invalidFields:Object(__WEBPACK_IMPORTED_MODULE_5__selectors_admin_contractors_contractors__["i" /* getInvalidFields */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_5__selectors_admin_contractors_contractors__["h" /* getForm */])(state),serviceAreas:Object(__WEBPACK_IMPORTED_MODULE_5__selectors_admin_contractors_contractors__["p" /* getServiceAreas */])(state),selectedServiceAreasId:Object(__WEBPACK_IMPORTED_MODULE_5__selectors_admin_contractors_contractors__["m" /* getSelectedServiceAreasId */])(state),selectedTradesId:Object(__WEBPACK_IMPORTED_MODULE_5__selectors_admin_contractors_contractors__["n" /* getSelectedTradesId */])(state),selectedUnionsId:Object(__WEBPACK_IMPORTED_MODULE_5__selectors_admin_contractors_contractors__["o" /* getSelectedUnionsId */])(state),w9Document:Object(__WEBPACK_IMPORTED_MODULE_5__selectors_admin_contractors_contractors__["x" /* getW9Document */])(state),trades:Object(__WEBPACK_IMPORTED_MODULE_5__selectors_admin_contractors_contractors__["t" /* getTrades */])(state),unions:Object(__WEBPACK_IMPORTED_MODULE_5__selectors_admin_contractors_contractors__["u" /* getUnions */])(state),validationMessage:Object(__WEBPACK_IMPORTED_MODULE_5__selectors_admin_contractors_contractors__["w" /* getValidationMessage */])(state),msaSigningUrl:Object(__WEBPACK_IMPORTED_MODULE_5__selectors_admin_contractors_contractors__["j" /* getMsaSigningUrl */])(state),showMsaSigningModal:Object(__WEBPACK_IMPORTED_MODULE_5__selectors_admin_contractors_contractors__["s" /* getShowMsaSigningModal */])(state)};})(ContractorTeamEdit));

/***/ }),
/* 2434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientTeamEdit_css__ = __webpack_require__(2435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientTeamEdit_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ClientTeamEdit_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectors_admin_team_client_team__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_team_client_team__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_radio_button_RadioButton__ = __webpack_require__(160);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClientTeamEdit=function(_Component){_inherits(ClientTeamEdit,_Component);function ClientTeamEdit(props){_classCallCheck(this,ClientTeamEdit);var _this=_possibleConstructorReturn(this,(ClientTeamEdit.__proto__||Object.getPrototypeOf(ClientTeamEdit)).call(this,props));_this.handleFormChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_team_client_team__["l" /* updateClientFormValue */])(attribute,value));};_this.handleGlobalPurchaseOrderChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_team_client_team__["l" /* updateClientFormValue */])('globalPurchaseOrderRequired',value===1));};_this.handlePurchaseOrderChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_team_client_team__["l" /* updateClientFormValue */])('purchaseOrderRequired',value===1));};_this.handleSubmit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_team_client_team__["j" /* submitClientFormRequest */])(_this.props.clientForm,_this.clientId));};_this.clientId=_this.props.currentUser.accountable_id;return _this;}_createClass(ClientTeamEdit,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;if(this.props.client===null){// If client not loaded, load it
this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_team_client_team__["d" /* loadClientRequest */])(this.clientId)).then(function(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_team_client_team__["m" /* updateFormFromCurrentClient */])(_this2.props.client));});}else{this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_team_client_team__["m" /* updateFormFromCurrentClient */])(this.props.client));}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'client-team-edit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Edit Client'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'client-team-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left-side'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h2'},'Client Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'details-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Company Name','companyName')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'details-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Contact First Name','firstName')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2},this.renderField('Contact Last Name','lastName'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Email','email')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2},this.renderField('Phone Number','phoneNumber'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Street Address','streetAddress')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2},this.renderField('Unit number / Floor','unitNumber'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('City','city')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('State','state')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.renderField('Zip Code','zipCode'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'purchase-order-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Global PO with running balance?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_radio_button_RadioButton__["a" /* default */],{className:'purchase-order-radio',options:[{value:1,label:'Yes'},{value:0,label:'No'}],value:this.props.clientForm.globalPurchaseOrderRequired?1:0,onChange:this.handleGlobalPurchaseOrderChange})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'purchase-order-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'PO for each work order?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_radio_button_RadioButton__["a" /* default */],{className:'purchase-order-radio',options:[{value:1,label:'Yes'},{value:0,label:'No'}],value:this.props.clientForm.purchaseOrderRequired?1:0,onChange:this.handlePurchaseOrderChange}))))))),this.props.validationMessage!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},this.props.validationMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Save',onClick:this.handleSubmit})))));}},{key:'renderField',value:function renderField(placeholder,attribute){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__["a" /* default */],{placeholder:placeholder,valid:this.props.invalidFields.find(function(element){return element===attribute;})===undefined,value:this.props.clientForm[attribute],onChange:this.handleFormChange.bind(this,attribute)});}}]);return ClientTeamEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{client:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_team_client_team__["b" /* getClient */])(state),clientForm:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_team_client_team__["c" /* getClientForm */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_authentication__["d" /* getCurrentUser */])(state),invalidFields:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_team_client_team__["e" /* getInvalidFields */])(state),validationMessage:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_team_client_team__["k" /* getValidationMessage */])(state)};})(ClientTeamEdit));

/***/ }),
/* 2435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_GeneralContractorForm__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_general_contractors_store_actions__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_selectors__ = __webpack_require__(165);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GeneralContractorTeamEdit=function(_Component){_inherits(GeneralContractorTeamEdit,_Component);function GeneralContractorTeamEdit(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GeneralContractorTeamEdit);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GeneralContractorTeamEdit.__proto__||Object.getPrototypeOf(GeneralContractorTeamEdit)).call.apply(_ref,[this].concat(args))),_this),_this.handleOnSubmit=function(values){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_general_contractors_store_actions__["r" /* updateGeneralContractorTeam */])(values,true));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GeneralContractorTeamEdit,[{key:'render',value:function render(){var generalContractor=this.props.generalContractor;if(generalContractor){this.initialValues={id:generalContractor.id,name:generalContractor.name,licenceNumber:generalContractor.license_number,firstName:generalContractor.contact.first_name,lastName:generalContractor.contact.last_name,email:generalContractor.contact.email,phoneNumber:generalContractor.contact.phone_number,companyLogo:generalContractor.logo};if(generalContractor.location){this.initialValues['streetAddress']=generalContractor.location.street_address_1;this.initialValues['unitNumber']=generalContractor.location.street_address_2;this.initialValues['city']=generalContractor.location.city;this.initialValues['state']=generalContractor.location.state;this.initialValues['zipCode']=generalContractor.location.zip;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_GeneralContractorForm__["a" /* default */],{initialValues:this.initialValues,onSubmit:this.handleOnSubmit});}}]);return GeneralContractorTeamEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{generalContractor:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_selectors__["b" /* getCurrentGeneralContractor */])(state)};})(GeneralContractorTeamEdit));

/***/ }),
/* 2437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_service_providers_ServiceProvidersEdit_js__ = __webpack_require__(972);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ServiceProviderTeamEdit=function(_Component){_inherits(ServiceProviderTeamEdit,_Component);function ServiceProviderTeamEdit(){_classCallCheck(this,ServiceProviderTeamEdit);return _possibleConstructorReturn(this,(ServiceProviderTeamEdit.__proto__||Object.getPrototypeOf(ServiceProviderTeamEdit)).apply(this,arguments));}_createClass(ServiceProviderTeamEdit,[{key:'render',value:function render(){var currentUser=this.props.currentUser;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_admin_service_providers_ServiceProvidersEdit_js__["a" /* default */],{id:currentUser.accountable_id,type:currentUser.accountable_type});}}]);return ServiceProviderTeamEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_authentication__["d" /* getCurrentUser */])(state)};})(ServiceProviderTeamEdit));

/***/ }),
/* 2439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_css__ = __webpack_require__(2440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors_admin_users_users__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_navigation_SearchBar__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_admin_users_users__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_modal_InviteUserModal__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UsersInviteUserModalContainer__ = __webpack_require__(2441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_text_UserStatus__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_text_util__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Users=function(_Component){_inherits(Users,_Component);function Users(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Users);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Users.__proto__||Object.getPrototypeOf(Users)).call.apply(_ref,[this].concat(args))),_this),_this.handleInviteUser=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_admin_users_users__["e" /* setCurrentUserId */])(0));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_admin_users_users__["c" /* loadUserForm */])(null));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_admin_users_users__["f" /* setShowInviteUserModal */])(true,__WEBPACK_IMPORTED_MODULE_7__shared_modal_InviteUserModal__["a" /* UserModalState */].NEW));},_this.handleUserSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_admin_users_users__["e" /* setCurrentUserId */])(_this.props.users[index].id));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_admin_users_users__["c" /* loadUserForm */])(_this.props.users[index]));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_admin_users_users__["f" /* setShowInviteUserModal */])(true,__WEBPACK_IMPORTED_MODULE_7__shared_modal_InviteUserModal__["a" /* UserModalState */].READ_ONLY));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Users,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_admin_users_users__["d" /* loadUsersRequest */])());}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'users'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Users'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_navigation_SearchBar__["a" /* default */],{addButton:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'button',value:'Invite User',onClick:this.handleInviteUser})},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_table_SimpleTable__["a" /* default */],{className:'users-table',headers:['NAME','ROLES/PERMISSIONS','TITLE','STATUS','WORK ORDERS','PHONE NUMBER','EMAIL'],rows:this.mapUsers(this.props.users),emptyMessage:'No Users',onRowSelected:this.handleUserSelection})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__UsersInviteUserModalContainer__["a" /* default */],null));}},{key:'mapUsers',value:function mapUsers(users){var _this2=this;return users.map(function(user){var status=void 0;if(user.invitation_sent_at===null||user.invitation_accepted_at!==null){status=user.status;}else if(user.invitation_accepted_at===null){status='pending_invitation';}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},user.first_name+' '+user.last_name),_this2.mapTitle(user.roles),user.title!==null?user.title:'N/A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_text_UserStatus__["a" /* default */],{status:status}),user.work_order_users_count,user.phone_number!==null?Object(__WEBPACK_IMPORTED_MODULE_11_services_utils_text_util__["c" /* formatPhoneNumber */])(user.phone_number):'N/A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:'+user.email,className:'mailto'},user.email)];});}},{key:'mapTitle',value:function mapTitle(roles){var titles=roles.map(function(role){return __WEBPACK_IMPORTED_MODULE_10__services_utils_users_util__["a" /* ADMIN_ROLES */][role.name];});if(titles.length>1){return titles.join(' / ');}else if(titles.length===1){return titles[0];}else{return'N/A';}}}]);return Users;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{users:Object(__WEBPACK_IMPORTED_MODULE_4__selectors_admin_users_users__["g" /* getUsers */])(state)};})(Users));

/***/ }),
/* 2440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_InviteUserModal__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectors_admin_users_users__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_admin_users_users__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_modal_MessageModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_utils_text_util__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UsersInviteUserModalContainer=function(_Component){_inherits(UsersInviteUserModalContainer,_Component);function UsersInviteUserModalContainer(props){_classCallCheck(this,UsersInviteUserModalContainer);var _this=_possibleConstructorReturn(this,(UsersInviteUserModalContainer.__proto__||Object.getPrototypeOf(UsersInviteUserModalContainer)).call(this,props));_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_users_users__["f" /* setShowInviteUserModal */])(false));};_this.handleSubmit=function(){var promise=_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_users_users__["g" /* submitFormRequest */])(_this.props.form,_this.props.currentUserId));if(promise!==null&&_this.props.userModalState===__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_InviteUserModal__["a" /* UserModalState */].NEW){promise.then(function(response){if(response.ok){_this.setState({showConfirmationMessage:true});}});}};_this.handleAttributeChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_users_users__["h" /* updateFormValue */])(attribute,value));};_this.handleEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_users_users__["f" /* setShowInviteUserModal */])(true,__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_InviteUserModal__["a" /* UserModalState */].EDIT));};_this.handleDeleteConfirmation=function(result){if(result){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_users_users__["a" /* deleteUserRequest */])(_this.props.currentUserId));}};_this.handleCloseConfirmationModal=function(){_this.setState({showConfirmationMessage:false});};_this.state={showConfirmationMessage:false};return _this;}_createClass(UsersInviteUserModalContainer,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.roles.length===0){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_admin_users_users__["b" /* loadRolesRequest */])());}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_InviteUserModal__["b" /* default */],{form:[{attribute:'firstName',label:'First Name',renderer:'input'},{attribute:'lastName',label:'Last Name',renderer:'input'},{attribute:'title',label:'Title',renderer:'input'},{attribute:'email',label:'Email',renderer:'input'},{attribute:'phoneNumber',formatter:__WEBPACK_IMPORTED_MODULE_7_services_utils_text_util__["c" /* formatPhoneNumber */],label:'Phone Number',renderer:'input'},{attribute:'rolesId',label:'Title',renderer:'dropdown',options:this.props.roles.map(function(role){return{value:role.id,label:__WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__["a" /* ADMIN_ROLES */][role.name]};})}],invalidFields:this.props.invalidFields,modalState:this.props.userModalState,show:this.props.showInviteUserModal,values:this.props.form,validationMessage:this.props.validationMessage,onAttributeChange:this.handleAttributeChange,onClose:this.handleClose,onDeleteConfirmation:this.handleDeleteConfirmation,onEdit:this.handleEdit,onSubmit:this.handleSubmit}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_modal_MessageModal__["a" /* default */],{show:this.state.showConfirmationMessage,message:'Invite has been sent',onHide:this.handleCloseConfirmationModal}));}}]);return UsersInviteUserModalContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUserId:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_users_users__["a" /* getCurrentUserId */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_users_users__["b" /* getForm */])(state),invalidFields:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_users_users__["c" /* getInvalidFields */])(state),roles:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_users_users__["d" /* getRoles */])(state),showInviteUserModal:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_users_users__["e" /* getShowInviteUserModal */])(state),userModalState:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_users_users__["f" /* getUserModalState */])(state),validationMessage:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_users_users__["h" /* getValidationMessage */])(state)};})(UsersInviteUserModalContainer));

/***/ }),
/* 2442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tutorials_css__ = __webpack_require__(2443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tutorials_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Tutorials_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_VideoModal__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_selectors__ = __webpack_require__(2467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actions__ = __webpack_require__(2468);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tutorials=function(_Component){_inherits(Tutorials,_Component);function Tutorials(props){_classCallCheck(this,Tutorials);var _this=_possibleConstructorReturn(this,(Tutorials.__proto__||Object.getPrototypeOf(Tutorials)).call(this,props));_this.handleTutorialClick=function(index){_this.setState({showVideoModal:true,videoSrc:_this.props.tutorials[index].link});};_this.handleCloseModal=function(){_this.setState({showVideoModal:false,videoSrc:null});};_this.state={showVideoModal:false,videoSrc:null};return _this;}_createClass(Tutorials,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions__["a" /* loadTutorialsRequest */])());}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'users'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Tutorials'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__["a" /* default */],{className:'users-table',headers:['NAME'],rows:this.mapTutorials(this.props.tutorials),emptyMessage:'No Tutorials',onRowSelected:this.handleTutorialClick})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_VideoModal__["a" /* default */],{show:this.state.showVideoModal,videoSrc:this.state.videoSrc,onHide:this.handleCloseModal}));}},{key:'mapTutorials',value:function mapTutorials(tutorials){return tutorials.map(function(tutorial){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h3'},tutorial.title)];});}}]);return Tutorials;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{tutorials:Object(__WEBPACK_IMPORTED_MODULE_5__store_selectors__["a" /* getTutorials */])(state)};})(Tutorials));

/***/ }),
/* 2443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Player", {
  enumerable: true,
  get: function get() {
    return _Player["default"];
  }
});
Object.defineProperty(exports, "Video", {
  enumerable: true,
  get: function get() {
    return _Video["default"];
  }
});
Object.defineProperty(exports, "BigPlayButton", {
  enumerable: true,
  get: function get() {
    return _BigPlayButton["default"];
  }
});
Object.defineProperty(exports, "LoadingSpinner", {
  enumerable: true,
  get: function get() {
    return _LoadingSpinner["default"];
  }
});
Object.defineProperty(exports, "PosterImage", {
  enumerable: true,
  get: function get() {
    return _PosterImage["default"];
  }
});
Object.defineProperty(exports, "Slider", {
  enumerable: true,
  get: function get() {
    return _Slider["default"];
  }
});
Object.defineProperty(exports, "Bezel", {
  enumerable: true,
  get: function get() {
    return _Bezel["default"];
  }
});
Object.defineProperty(exports, "Shortcut", {
  enumerable: true,
  get: function get() {
    return _Shortcut["default"];
  }
});
Object.defineProperty(exports, "ControlBar", {
  enumerable: true,
  get: function get() {
    return _ControlBar["default"];
  }
});
Object.defineProperty(exports, "PlayToggle", {
  enumerable: true,
  get: function get() {
    return _PlayToggle["default"];
  }
});
Object.defineProperty(exports, "ForwardControl", {
  enumerable: true,
  get: function get() {
    return _ForwardControl["default"];
  }
});
Object.defineProperty(exports, "ReplayControl", {
  enumerable: true,
  get: function get() {
    return _ReplayControl["default"];
  }
});
Object.defineProperty(exports, "FullscreenToggle", {
  enumerable: true,
  get: function get() {
    return _FullscreenToggle["default"];
  }
});
Object.defineProperty(exports, "ProgressControl", {
  enumerable: true,
  get: function get() {
    return _ProgressControl["default"];
  }
});
Object.defineProperty(exports, "SeekBar", {
  enumerable: true,
  get: function get() {
    return _SeekBar["default"];
  }
});
Object.defineProperty(exports, "PlayProgressBar", {
  enumerable: true,
  get: function get() {
    return _PlayProgressBar["default"];
  }
});
Object.defineProperty(exports, "LoadProgressBar", {
  enumerable: true,
  get: function get() {
    return _LoadProgressBar["default"];
  }
});
Object.defineProperty(exports, "MouseTimeDisplay", {
  enumerable: true,
  get: function get() {
    return _MouseTimeDisplay["default"];
  }
});
Object.defineProperty(exports, "VolumeMenuButton", {
  enumerable: true,
  get: function get() {
    return _VolumeMenuButton["default"];
  }
});
Object.defineProperty(exports, "PlaybackRateMenuButton", {
  enumerable: true,
  get: function get() {
    return _PlaybackRateMenuButton["default"];
  }
});
Object.defineProperty(exports, "PlaybackRate", {
  enumerable: true,
  get: function get() {
    return _PlaybackRate["default"];
  }
});
Object.defineProperty(exports, "ClosedCaptionButton", {
  enumerable: true,
  get: function get() {
    return _ClosedCaptionButton["default"];
  }
});
Object.defineProperty(exports, "RemainingTimeDisplay", {
  enumerable: true,
  get: function get() {
    return _RemainingTimeDisplay["default"];
  }
});
Object.defineProperty(exports, "CurrentTimeDisplay", {
  enumerable: true,
  get: function get() {
    return _CurrentTimeDisplay["default"];
  }
});
Object.defineProperty(exports, "DurationDisplay", {
  enumerable: true,
  get: function get() {
    return _DurationDisplay["default"];
  }
});
Object.defineProperty(exports, "TimeDivider", {
  enumerable: true,
  get: function get() {
    return _TimeDivider["default"];
  }
});
Object.defineProperty(exports, "MenuButton", {
  enumerable: true,
  get: function get() {
    return _MenuButton["default"];
  }
});
Object.defineProperty(exports, "playerReducer", {
  enumerable: true,
  get: function get() {
    return _reducers.playerReducer;
  }
});
Object.defineProperty(exports, "operationReducer", {
  enumerable: true,
  get: function get() {
    return _reducers.operationReducer;
  }
});
exports.videoActions = exports.playerActions = void 0;

var _Player = _interopRequireDefault(__webpack_require__(2447));

var _Video = _interopRequireDefault(__webpack_require__(988));

var _BigPlayButton = _interopRequireDefault(__webpack_require__(985));

var _LoadingSpinner = _interopRequireDefault(__webpack_require__(986));

var _PosterImage = _interopRequireDefault(__webpack_require__(987));

var _Slider = _interopRequireDefault(__webpack_require__(613));

var _Bezel = _interopRequireDefault(__webpack_require__(991));

var _Shortcut = _interopRequireDefault(__webpack_require__(992));

var _ControlBar = _interopRequireDefault(__webpack_require__(993));

var _PlayToggle = _interopRequireDefault(__webpack_require__(999));

var _ForwardControl = _interopRequireDefault(__webpack_require__(1000));

var _ReplayControl = _interopRequireDefault(__webpack_require__(1002));

var _FullscreenToggle = _interopRequireDefault(__webpack_require__(1003));

var _ProgressControl = _interopRequireDefault(__webpack_require__(994));

var _SeekBar = _interopRequireDefault(__webpack_require__(995));

var _PlayProgressBar = _interopRequireDefault(__webpack_require__(996));

var _LoadProgressBar = _interopRequireDefault(__webpack_require__(997));

var _MouseTimeDisplay = _interopRequireDefault(__webpack_require__(998));

var _VolumeMenuButton = _interopRequireDefault(__webpack_require__(1008));

var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(614));

var _PlaybackRate = _interopRequireDefault(__webpack_require__(2465));

var _ClosedCaptionButton = _interopRequireDefault(__webpack_require__(2466));

var _RemainingTimeDisplay = _interopRequireDefault(__webpack_require__(1004));

var _CurrentTimeDisplay = _interopRequireDefault(__webpack_require__(1005));

var _DurationDisplay = _interopRequireDefault(__webpack_require__(1006));

var _TimeDivider = _interopRequireDefault(__webpack_require__(1007));

var _MenuButton = _interopRequireDefault(__webpack_require__(615));

var playerActions = _interopRequireWildcard(__webpack_require__(432));

exports.playerActions = playerActions;

var videoActions = _interopRequireWildcard(__webpack_require__(612));

exports.videoActions = videoActions;

var _reducers = __webpack_require__(983);

/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(206));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(610));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(611));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _Manager = _interopRequireDefault(__webpack_require__(2450));

var _BigPlayButton = _interopRequireDefault(__webpack_require__(985));

var _LoadingSpinner = _interopRequireDefault(__webpack_require__(986));

var _PosterImage = _interopRequireDefault(__webpack_require__(987));

var _Video = _interopRequireDefault(__webpack_require__(988));

var _Bezel = _interopRequireDefault(__webpack_require__(991));

var _Shortcut = _interopRequireDefault(__webpack_require__(992));

var _ControlBar = _interopRequireDefault(__webpack_require__(993));

var browser = _interopRequireWildcard(__webpack_require__(2464));

var _dom = __webpack_require__(433);

var _utils = __webpack_require__(166);

var _fullscreen = _interopRequireDefault(__webpack_require__(984));

var propTypes = {
  children: _propTypes["default"].any,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  fluid: _propTypes["default"].bool,
  muted: _propTypes["default"].bool,
  playsInline: _propTypes["default"].bool,
  aspectRatio: _propTypes["default"].string,
  className: _propTypes["default"].string,
  videoId: _propTypes["default"].string,
  startTime: _propTypes["default"].number,
  loop: _propTypes["default"].bool,
  autoPlay: _propTypes["default"].bool,
  src: _propTypes["default"].string,
  poster: _propTypes["default"].string,
  preload: _propTypes["default"].oneOf(['auto', 'metadata', 'none']),
  onLoadStart: _propTypes["default"].func,
  onWaiting: _propTypes["default"].func,
  onCanPlay: _propTypes["default"].func,
  onCanPlayThrough: _propTypes["default"].func,
  onPlaying: _propTypes["default"].func,
  onEnded: _propTypes["default"].func,
  onSeeking: _propTypes["default"].func,
  onSeeked: _propTypes["default"].func,
  onPlay: _propTypes["default"].func,
  onPause: _propTypes["default"].func,
  onProgress: _propTypes["default"].func,
  onDurationChange: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onSuspend: _propTypes["default"].func,
  onAbort: _propTypes["default"].func,
  onEmptied: _propTypes["default"].func,
  onStalled: _propTypes["default"].func,
  onLoadedMetadata: _propTypes["default"].func,
  onLoadedData: _propTypes["default"].func,
  onTimeUpdate: _propTypes["default"].func,
  onRateChange: _propTypes["default"].func,
  onVolumeChange: _propTypes["default"].func,
  store: _propTypes["default"].object
};
var defaultProps = {
  fluid: true,
  muted: false,
  playsInline: false,
  preload: 'auto',
  aspectRatio: 'auto'
};

var Player =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Player, _Component);

  function Player(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Player);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Player).call(this, props));
    _this.controlsHideTimer = null;
    _this.video = null; // the Video component

    _this.manager = new _Manager["default"](props.store);
    _this.actions = _this.manager.getActions();

    _this.manager.subscribeToPlayerStateChange(_this.handleStateChange.bind((0, _assertThisInitialized2["default"])(_this)));

    _this.getStyle = _this.getStyle.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleResize = _this.handleResize.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getChildren = _this.getChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseMove = (0, _utils.throttle)(_this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this)), 250);
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.startControlsTimer = _this.startControlsTimer.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFullScreenChange = _this.handleFullScreenChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);

      _fullscreen["default"].addEventListener(this.handleFullScreenChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event listener
      window.removeEventListener('resize', this.handleResize);

      _fullscreen["default"].removeEventListener(this.handleFullScreenChange);

      if (this.controlsHideTimer) {
        window.clearTimeout(this.controlsHideTimer);
      }
    }
  }, {
    key: "getDefaultChildren",
    value: function getDefaultChildren(originalChildren) {
      var _this2 = this;

      return [_react["default"].createElement(_Video["default"], {
        ref: function ref(c) {
          _this2.video = c;
          _this2.manager.video = _this2.video;
        },
        key: "video",
        order: 0.0
      }, originalChildren), _react["default"].createElement(_PosterImage["default"], {
        key: "poster-image",
        order: 1.0
      }), _react["default"].createElement(_LoadingSpinner["default"], {
        key: "loading-spinner",
        order: 2.0
      }), _react["default"].createElement(_Bezel["default"], {
        key: "bezel",
        order: 3.0
      }), _react["default"].createElement(_BigPlayButton["default"], {
        key: "big-play-button",
        order: 4.0
      }), _react["default"].createElement(_ControlBar["default"], {
        key: "control-bar",
        order: 5.0
      }), _react["default"].createElement(_Shortcut["default"], {
        key: "shortcut",
        order: 99.0
      })];
    }
  }, {
    key: "getChildren",
    value: function getChildren(props) {
      var _ = props.className,
          originalChildren = props.children,
          propsWithoutChildren = (0, _objectWithoutProperties2["default"])(props, ["className", "children"]);

      var children = _react["default"].Children.toArray(this.props.children).filter(function (e) {
        return !(0, _utils.isVideoChild)(e);
      });

      var defaultChildren = this.getDefaultChildren(originalChildren);
      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, propsWithoutChildren);
    }
  }, {
    key: "setWidthOrHeight",
    value: function setWidthOrHeight(style, name, value) {
      var styleVal;

      if (typeof value === 'string') {
        if (value === 'auto') {
          styleVal = 'auto';
        } else if (value.match(/\d+%/)) {
          styleVal = value;
        }
      } else if (typeof value === 'number') {
        styleVal = "".concat(value, "px");
      }

      Object.assign(style, (0, _defineProperty2["default"])({}, name, styleVal));
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var _this$props = this.props,
          fluid = _this$props.fluid,
          propsAspectRatio = _this$props.aspectRatio,
          propsHeight = _this$props.height,
          propsWidth = _this$props.width;

      var _this$manager$getStat = this.manager.getState(),
          player = _this$manager$getStat.player;

      var style = {};
      var width;
      var height;
      var aspectRatio; // The aspect ratio is either used directly or to calculate width and height.

      if (propsAspectRatio !== undefined && propsAspectRatio !== 'auto') {
        // Use any aspectRatio that's been specifically set
        aspectRatio = propsAspectRatio;
      } else if (player.videoWidth) {
        // Otherwise try to get the aspect ratio from the video metadata
        aspectRatio = "".concat(player.videoWidth, ":").concat(player.videoHeight);
      } else {
        // Or use a default. The video element's is 2:1, but 16:9 is more common.
        aspectRatio = '16:9';
      } // Get the ratio as a decimal we can use to calculate dimensions


      var ratioParts = aspectRatio.split(':');
      var ratioMultiplier = ratioParts[1] / ratioParts[0];

      if (propsWidth !== undefined) {
        // Use any width that's been specifically set
        width = propsWidth;
      } else if (propsHeight !== undefined) {
        // Or calulate the width from the aspect ratio if a height has been set
        width = propsHeight / ratioMultiplier;
      } else {
        // Or use the video's metadata, or use the video el's default of 300
        width = player.videoWidth || 400;
      }

      if (propsHeight !== undefined) {
        // Use any height that's been specifically set
        height = propsHeight;
      } else {
        // Otherwise calculate the height from the ratio and the width
        height = width * ratioMultiplier;
      }

      if (fluid) {
        style.paddingTop = "".concat(ratioMultiplier * 100, "%");
      } else {
        // If Width contains "auto", set "auto" in style
        this.setWidthOrHeight(style, 'width', width);
        this.setWidthOrHeight(style, 'height', height);
      }

      return style;
    } // get redux state
    // { player, operation }

  }, {
    key: "getState",
    value: function getState() {
      return this.manager.getState();
    } // get playback rate

  }, {
    key: "play",
    // play the video
    value: function play() {
      this.video.play();
    } // pause the video

  }, {
    key: "pause",
    value: function pause() {
      this.video.pause();
    } // Change the video source and re-load the video:

  }, {
    key: "load",
    value: function load() {
      this.video.load();
    } // Add a new text track to the video

  }, {
    key: "addTextTrack",
    value: function addTextTrack() {
      var _this$video;

      (_this$video = this.video).addTextTrack.apply(_this$video, arguments);
    } // Check if your browser can play different types of video:

  }, {
    key: "canPlayType",
    value: function canPlayType() {
      var _this$video2;

      (_this$video2 = this.video).canPlayType.apply(_this$video2, arguments);
    } // seek video by time

  }, {
    key: "seek",
    value: function seek(time) {
      this.video.seek(time);
    } // jump forward x seconds

  }, {
    key: "forward",
    value: function forward(seconds) {
      this.video.forward(seconds);
    } // jump back x seconds

  }, {
    key: "replay",
    value: function replay(seconds) {
      this.video.replay(seconds);
    } // enter or exist full screen

  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen() {
      this.video.toggleFullscreen();
    } // subscribe to player state change

  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener) {
      return this.manager.subscribeToPlayerStateChange(listener);
    } // player resize

  }, {
    key: "handleResize",
    value: function handleResize() {}
  }, {
    key: "handleFullScreenChange",
    value: function handleFullScreenChange(event) {
      if (event.target === this.manager.rootElement) {
        this.actions.handleFullscreenChange(_fullscreen["default"].isFullscreen);
      }
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown() {
      this.startControlsTimer();
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove() {
      this.startControlsTimer();
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown() {
      this.startControlsTimer();
    }
  }, {
    key: "startControlsTimer",
    value: function startControlsTimer() {
      var _this3 = this;

      var controlBarActiveTime = 3000;

      _react["default"].Children.forEach(this.props.children, function (element) {
        if (!_react["default"].isValidElement(element) || element.type !== _ControlBar["default"]) {
          return;
        }

        var autoHideTime = element.props.autoHideTime;

        if (typeof autoHideTime === 'number') {
          controlBarActiveTime = autoHideTime;
        }
      });

      this.actions.userActivate(true);
      clearTimeout(this.controlsHideTimer);
      this.controlsHideTimer = setTimeout(function () {
        _this3.actions.userActivate(false);
      }, controlBarActiveTime);
    }
  }, {
    key: "handleStateChange",
    value: function handleStateChange(state, prevState) {
      if (state.isFullscreen !== prevState.isFullscreen) {
        this.handleResize(); // focus root when switching fullscreen mode to avoid confusion #276

        (0, _dom.focusNode)(this.manager.rootElement);
      }

      this.forceUpdate(); // re-render
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      this.actions.activate(true);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.actions.activate(false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var fluid = this.props.fluid;

      var _this$manager$getStat2 = this.manager.getState(),
          player = _this$manager$getStat2.player;

      var paused = player.paused,
          hasStarted = player.hasStarted,
          waiting = player.waiting,
          seeking = player.seeking,
          isFullscreen = player.isFullscreen,
          userActivity = player.userActivity;
      var props = (0, _objectSpread2["default"])({}, this.props, {
        player: player,
        actions: this.actions,
        manager: this.manager,
        store: this.manager.store,
        video: this.video ? this.video.video : null
      });
      var children = this.getChildren(props);
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])({
          'video-react-controls-enabled': true,
          'video-react-has-started': hasStarted,
          'video-react-paused': paused,
          'video-react-playing': !paused,
          'video-react-waiting': waiting,
          'video-react-seeking': seeking,
          'video-react-fluid': fluid,
          'video-react-fullscreen': isFullscreen,
          'video-react-user-inactive': !userActivity,
          'video-react-user-active': userActivity,
          'video-react-workinghover': !browser.IS_IOS
        }, 'video-react', this.props.className),
        style: this.getStyle(),
        ref: function ref(c) {
          _this4.manager.rootElement = c;
        },
        role: "region",
        onTouchStart: this.handleMouseDown,
        onMouseDown: this.handleMouseDown,
        onTouchMove: this.handleMouseMove,
        onMouseMove: this.handleMouseMove,
        onKeyDown: this.handleKeyDown,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        tabIndex: "-1"
      }, children);
    }
  }, {
    key: "playbackRate",
    get: function get() {
      return this.video.playbackRate;
    } // set playback rate
    // speed of video
    ,
    set: function set(rate) {
      this.video.playbackRate = rate;
    }
  }, {
    key: "muted",
    get: function get() {
      return this.video.muted;
    },
    set: function set(val) {
      this.video.muted = val;
    }
  }, {
    key: "volume",
    get: function get() {
      return this.video.volume;
    },
    set: function set(val) {
      this.video.volume = val;
    } // video width

  }, {
    key: "videoWidth",
    get: function get() {
      return this.video.videoWidth;
    } // video height

  }, {
    key: "videoHeight",
    get: function get() {
      return this.video.videoHeight;
    }
  }]);
  return Player;
}(_react.Component);

exports["default"] = Player;
Player.contextTypes = {
  store: _propTypes["default"].object
};
Player.propTypes = propTypes;
Player.defaultProps = defaultProps;
Player.displayName = 'Player';

/***/ }),
/* 2448 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 2449 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(206));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _redux = __webpack_require__(2451);

var _reducers = _interopRequireDefault(__webpack_require__(983));

var playerActions = _interopRequireWildcard(__webpack_require__(432));

var videoActions = _interopRequireWildcard(__webpack_require__(612));

var Manager =
/*#__PURE__*/
function () {
  function Manager(store) {
    (0, _classCallCheck2["default"])(this, Manager);
    this.store = store || (0, _redux.createStore)(_reducers["default"]);
    this.video = null;
    this.rootElement = null;
  }

  (0, _createClass2["default"])(Manager, [{
    key: "getActions",
    value: function getActions() {
      var manager = this;
      var dispatch = this.store.dispatch;
      var actions = (0, _objectSpread2["default"])({}, playerActions, videoActions);

      function bindActionCreator(actionCreator) {
        return function bindAction() {
          // eslint-disable-next-line prefer-rest-params
          var action = actionCreator.apply(manager, arguments);

          if (typeof action !== 'undefined') {
            dispatch(action);
          }
        };
      }

      return Object.keys(actions).filter(function (key) {
        return typeof actions[key] === 'function';
      }).reduce(function (boundActions, key) {
        boundActions[key] = bindActionCreator(actions[key]);
        return boundActions;
      }, {});
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.store.getState();
    } // subscribe state change

  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener, getState) {
      if (!getState) {
        getState = this.getState.bind(this);
      }

      var prevState = getState();

      var handleChange = function handleChange() {
        var state = getState();

        if (state === prevState) {
          return;
        }

        var prevStateCopy = prevState;
        prevState = state;
        listener(state, prevStateCopy);
      };

      return this.store.subscribe(handleChange);
    } // subscribe to operation state change

  }, {
    key: "subscribeToOperationStateChange",
    value: function subscribeToOperationStateChange(listener) {
      var _this = this;

      return this.subscribeToStateChange(listener, function () {
        return _this.getState().operation;
      });
    } // subscribe to player state change

  }, {
    key: "subscribeToPlayerStateChange",
    value: function subscribeToPlayerStateChange(listener) {
      var _this2 = this;

      return this.subscribeToStateChange(listener, function () {
        return _this2.getState().player;
      });
    }
  }]);
  return Manager;
}();

exports["default"] = Manager;

/***/ }),
/* 2451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE__ActionTypes", function() { return ActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(493);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = player;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(206));

var _video = __webpack_require__(612);

var _player = __webpack_require__(432);

var initialState = {
  currentSrc: null,
  duration: 0,
  currentTime: 0,
  seekingTime: 0,
  buffered: null,
  waiting: false,
  seeking: false,
  paused: true,
  autoPaused: false,
  ended: false,
  playbackRate: 1,
  muted: false,
  volume: 1,
  readyState: 0,
  networkState: 0,
  videoWidth: 0,
  videoHeight: 0,
  hasStarted: false,
  userActivity: true,
  isActive: false,
  isFullscreen: false,
  activeTextTrack: null
};

function player() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _player.USER_ACTIVATE:
      return (0, _objectSpread2["default"])({}, state, {
        userActivity: action.activity
      });

    case _player.PLAYER_ACTIVATE:
      return (0, _objectSpread2["default"])({}, state, {
        isActive: action.activity
      });

    case _player.FULLSCREEN_CHANGE:
      return (0, _objectSpread2["default"])({}, state, {
        isFullscreen: !!action.isFullscreen
      });

    case _video.SEEKING_TIME:
      return (0, _objectSpread2["default"])({}, state, {
        seekingTime: action.time
      });

    case _video.END_SEEKING:
      return (0, _objectSpread2["default"])({}, state, {
        seekingTime: 0
      });

    case _video.LOAD_START:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        hasStarted: false,
        ended: false
      });

    case _video.CAN_PLAY:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        waiting: false
      });

    case _video.WAITING:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        waiting: true
      });

    case _video.CAN_PLAY_THROUGH:
    case _video.PLAYING:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        waiting: false
      });

    case _video.PLAY:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        ended: false,
        paused: false,
        autoPaused: false,
        waiting: false,
        hasStarted: true
      });

    case _video.PAUSE:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        paused: true
      });

    case _video.END:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        ended: true
      });

    case _video.SEEKING:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        seeking: true
      });

    case _video.SEEKED:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        seeking: false
      });

    case _video.ERROR:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        error: 'UNKNOWN ERROR',
        ended: true
      });

    case _video.DURATION_CHANGE:
    case _video.TIME_UPDATE:
    case _video.VOLUME_CHANGE:
    case _video.PROGRESS_CHANGE:
    case _video.RATE_CHANGE:
    case _video.SUSPEND:
    case _video.ABORT:
    case _video.EMPTIED:
    case _video.STALLED:
    case _video.LOADED_META_DATA:
    case _video.LOADED_DATA:
    case _video.RESIZE:
      return (0, _objectSpread2["default"])({}, state, action.videoProps);

    case _video.ACTIVATE_TEXT_TRACK:
      return (0, _objectSpread2["default"])({}, state, {
        activeTextTrack: action.textTrack
      });

    default:
      return state;
  }
}

/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = operation;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(206));

var _player = __webpack_require__(432);

var initialState = {
  count: 0,
  operation: {
    action: '',
    source: ''
  }
};

function operation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _player.OPERATE:
      return (0, _objectSpread2["default"])({}, state, {
        count: state.count + 1,
        operation: (0, _objectSpread2["default"])({}, state.operation, action.operation)
      });

    default:
      return state;
  }
}

/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(990);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 2455 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(990);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 2457 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PopupButton;

var _extends2 = _interopRequireDefault(__webpack_require__(252));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(206));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _ClickableComponent = _interopRequireDefault(__webpack_require__(1009));

var _Popup = _interopRequireDefault(__webpack_require__(2459));

var propTypes = {
  inline: _propTypes["default"].bool,
  onClick: _propTypes["default"].func.isRequired,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  className: _propTypes["default"].string
};
var defaultProps = {
  inline: true
};

function PopupButton(props) {
  var inline = props.inline,
      className = props.className;
  var ps = (0, _objectSpread2["default"])({}, props);
  delete ps.children;
  delete ps.inline;
  delete ps.className;
  return _react["default"].createElement(_ClickableComponent["default"], (0, _extends2["default"])({
    className: (0, _classnames["default"])(className, {
      'video-react-menu-button-inline': !!inline,
      'video-react-menu-button-popup': !inline
    }, 'video-react-control video-react-button video-react-menu-button')
  }, ps), _react["default"].createElement(_Popup["default"], props));
}

PopupButton.propTypes = propTypes;
PopupButton.defaultProps = defaultProps;
PopupButton.displayName = 'PopupButton';

/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var propTypes = {
  player: _propTypes["default"].object,
  children: _propTypes["default"].any
};

var Popup =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Popup, _Component);

  function Popup(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Popup);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Popup).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Popup, [{
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault(); // event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return _react["default"].createElement("div", {
        className: "video-react-menu",
        onClick: this.handleClick
      }, _react["default"].createElement("div", {
        className: "video-react-menu-content"
      }, children));
    }
  }]);
  return Popup;
}(_react.Component);

exports["default"] = Popup;
Popup.propTypes = propTypes;
Popup.displayName = 'Popup';

/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(252));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _Slider = _interopRequireDefault(__webpack_require__(613));

var _VolumeLevel = _interopRequireDefault(__webpack_require__(2461));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  className: _propTypes["default"].string,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func
};

var VolumeBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(VolumeBar, _Component);

  function VolumeBar(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, VolumeBar);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VolumeBar).call(this, props, context));
    _this.state = {
      percentage: '0%'
    };
    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePercentageChange = _this.handlePercentageChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.checkMuted = _this.checkMuted.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getPercent = _this.getPercent.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(VolumeBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "getPercent",
    value: function getPercent() {
      var player = this.props.player;

      if (player.muted) {
        return 0;
      }

      return player.volume;
    }
  }, {
    key: "checkMuted",
    value: function checkMuted() {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;

      if (player.muted) {
        actions.mute(false);
      }
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      var actions = this.props.actions;
      this.checkMuted();
      var distance = this.slider.calculateDistance(event);
      actions.changeVolume(distance);
    }
  }, {
    key: "stepForward",
    value: function stepForward() {
      var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions;
      this.checkMuted();
      actions.changeVolume(player.volume + 0.1);
    }
  }, {
    key: "stepBack",
    value: function stepBack() {
      var _this$props3 = this.props,
          player = _this$props3.player,
          actions = _this$props3.actions;
      this.checkMuted();
      actions.changeVolume(player.volume - 0.1);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: "handlePercentageChange",
    value: function handlePercentageChange(percentage) {
      if (percentage !== this.state.percentage) {
        this.setState({
          percentage: percentage
        });
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          player = _this$props4.player,
          className = _this$props4.className;
      var volume = (player.volume * 100).toFixed(2);
      return _react["default"].createElement(_Slider["default"], (0, _extends2["default"])({
        ref: function ref(c) {
          _this2.slider = c;
        },
        label: "volume level",
        valuenow: volume,
        valuetext: "".concat(volume, "%"),
        onMouseMove: this.handleMouseMove,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleClick,
        sliderActive: this.handleFocus,
        sliderInactive: this.handleBlur,
        getPercent: this.getPercent,
        onPercentageChange: this.handlePercentageChange,
        stepForward: this.stepForward,
        stepBack: this.stepBack
      }, this.props, {
        className: (0, _classnames["default"])(className, 'video-react-volume-bar video-react-slider-bar')
      }), _react["default"].createElement(_VolumeLevel["default"], this.props));
    }
  }]);
  return VolumeBar;
}(_react.Component);

VolumeBar.propTypes = propTypes;
VolumeBar.displayName = 'VolumeBar';
var _default = VolumeBar;
exports["default"] = _default;

/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var propTypes = {
  percentage: _propTypes["default"].string,
  vertical: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var defaultProps = {
  percentage: '100%',
  vertical: false
};

function VolumeLevel(_ref) {
  var percentage = _ref.percentage,
      vertical = _ref.vertical,
      className = _ref.className;
  var style = {};

  if (vertical) {
    style.height = percentage;
  } else {
    style.width = percentage;
  }

  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, 'video-react-volume-level'),
    style: style
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }));
}

VolumeLevel.propTypes = propTypes;
VolumeLevel.defaultProps = defaultProps;
VolumeLevel.displayName = 'VolumeLevel';
var _default = VolumeLevel;
exports["default"] = _default;

/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var propTypes = {
  children: _propTypes["default"].any
};

var Menu =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Menu, _Component);

  function Menu(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Menu);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Menu).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Menu, [{
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault(); // event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        className: "video-react-menu video-react-lock-showing",
        role: "presentation",
        onClick: this.handleClick
      }, _react["default"].createElement("ul", {
        className: "video-react-menu-content"
      }, this.props.children));
    }
  }]);
  return Menu;
}(_react.Component);

exports["default"] = Menu;
Menu.propTypes = propTypes;
Menu.displayName = 'Menu';

/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var propTypes = {
  item: _propTypes["default"].object,
  index: _propTypes["default"].number,
  activateIndex: _propTypes["default"].number,
  onSelectItem: _propTypes["default"].func
};

var MenuItem =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(MenuItem, _Component);

  function MenuItem(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, MenuItem);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuItem).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(MenuItem, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          index = _this$props.index,
          onSelectItem = _this$props.onSelectItem;
      onSelectItem(index);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          item = _this$props2.item,
          index = _this$props2.index,
          activateIndex = _this$props2.activateIndex;
      return _react["default"].createElement("li", {
        className: (0, _classnames["default"])({
          'video-react-menu-item': true,
          'video-react-selected': index === activateIndex
        }),
        role: "menuitem",
        onClick: this.handleClick
      }, item.label, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }));
    }
  }]);
  return MenuItem;
}(_react.Component);

exports["default"] = MenuItem;
MenuItem.propTypes = propTypes;
MenuItem.displayName = 'MenuItem';

/***/ }),
/* 2464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IS_IOS = exports.IS_IPOD = exports.IS_IPHONE = exports.IS_IPAD = void 0;
var USER_AGENT = typeof window !== 'undefined' && window.navigator ? window.navigator.userAgent : ''; // const webkitVersionMap = (/AppleWebKit\/([\d.]+)/i).exec(USER_AGENT);
// const appleWebkitVersion = webkitVersionMap ? parseFloat(webkitVersionMap.pop()) : null;

/*
 * Device is an iPhone
 *
 * @type {Boolean}
 * @constant
 * @private
 */

var IS_IPAD = /iPad/i.test(USER_AGENT); // The Facebook app's UIWebView identifies as both an iPhone and iPad, so
// to identify iPhones, we need to exclude iPads.
// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/

exports.IS_IPAD = IS_IPAD;
var IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
exports.IS_IPHONE = IS_IPHONE;
var IS_IPOD = /iPod/i.test(USER_AGENT);
exports.IS_IPOD = IS_IPOD;
var IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;
exports.IS_IOS = IS_IOS;

/***/ }),
/* 2465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(614));

var _utils = __webpack_require__(166);

var PlaybackRate =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(PlaybackRate, _Component);

  function PlaybackRate(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, PlaybackRate);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlaybackRate).call(this, props, context));
    (0, _utils.deprecatedWarning)('PlaybackRate', 'PlaybackRateMenuButton');
    return _this;
  }

  (0, _createClass2["default"])(PlaybackRate, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(_PlaybackRateMenuButton["default"], this.props);
    }
  }]);
  return PlaybackRate;
}(_react.Component);

exports["default"] = PlaybackRate;
PlaybackRate.displayName = 'PlaybackRate';

/***/ }),
/* 2466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(63);

var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(57));

var _createClass2 = _interopRequireDefault(__webpack_require__(58));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(66));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(68));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(67));

var _inherits2 = _interopRequireDefault(__webpack_require__(69));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _MenuButton = _interopRequireDefault(__webpack_require__(615));

var propTypes = {
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string,
  offMenuText: _propTypes["default"].string,
  showOffMenu: _propTypes["default"].bool,
  kinds: _propTypes["default"].array
};
var defaultProps = {
  offMenuText: 'Off',
  showOffMenu: true,
  kinds: ['captions', 'subtitles'] // `kind`s of TextTrack to look for to associate it with this menu.

};

var ClosedCaptionButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ClosedCaptionButton, _Component);

  function ClosedCaptionButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, ClosedCaptionButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ClosedCaptionButton).call(this, props, context));
    _this.getTextTrackItems = _this.getTextTrackItems.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateState = _this.updateState.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = _this.getTextTrackItems();
    return _this;
  }

  (0, _createClass2["default"])(ClosedCaptionButton, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateState();
    }
  }, {
    key: "getTextTrackItems",
    value: function getTextTrackItems() {
      var _this$props = this.props,
          kinds = _this$props.kinds,
          player = _this$props.player,
          offMenuText = _this$props.offMenuText,
          showOffMenu = _this$props.showOffMenu;
      var textTracks = player.textTracks,
          activeTextTrack = player.activeTextTrack;
      var textTrackItems = {
        items: [],
        selectedIndex: 0
      };
      var tracks = Array.from(textTracks || []);

      if (tracks.length === 0) {
        return textTrackItems;
      }

      if (showOffMenu) {
        textTrackItems.items.push({
          label: offMenuText || 'Off',
          value: null
        });
      }

      tracks.forEach(function (textTrack) {
        // ignore invalid text track kind
        if (kinds.length && !kinds.includes(textTrack.kind)) {
          return;
        }

        textTrackItems.items.push({
          label: textTrack.label,
          value: textTrack.language
        });
      });
      textTrackItems.selectedIndex = textTrackItems.items.findIndex(function (item) {
        return activeTextTrack && activeTextTrack.language === item.value;
      });

      if (textTrackItems.selectedIndex === -1) {
        textTrackItems.selectedIndex = 0;
      }

      return textTrackItems;
    }
  }, {
    key: "updateState",
    value: function updateState() {
      var textTrackItems = this.getTextTrackItems();

      if (textTrackItems.selectedIndex !== this.state.selectedIndex || !this.textTrackItemsAreEqual(textTrackItems.items, this.state.items)) {
        this.setState(textTrackItems);
      }
    }
  }, {
    key: "textTrackItemsAreEqual",
    value: function textTrackItemsAreEqual(items1, items2) {
      if (items1.length !== items2.length) {
        return false;
      }

      for (var i = 0; i < items1.length; i++) {
        if (!items2[i] || items1[i].label !== items2[i].label || items1[i].value !== items2[i].value) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "handleSelectItem",
    value: function handleSelectItem(index) {
      var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions,
          showOffMenu = _this$props2.showOffMenu;
      var textTracks = player.textTracks; // For the 'subtitles-off' button, the first condition will never match
      // so all subtitles will be turned off

      Array.from(textTracks).forEach(function (textTrack, i) {
        // if it shows the `Off` menu, the first item is `Off`
        if (index === (showOffMenu ? i + 1 : i)) {
          textTrack.mode = 'showing';
          actions.activateTextTrack(textTrack);
        } else {
          textTrack.mode = 'hidden';
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          items = _this$state.items,
          selectedIndex = _this$state.selectedIndex;
      return _react["default"].createElement(_MenuButton["default"], {
        className: (0, _classnames["default"])('video-react-closed-caption', this.props.className),
        onSelectItem: this.handleSelectItem,
        items: items,
        selectedIndex: selectedIndex
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Closed Caption"));
    }
  }]);
  return ClosedCaptionButton;
}(_react.Component);

ClosedCaptionButton.propTypes = propTypes;
ClosedCaptionButton.defaultProps = defaultProps;
ClosedCaptionButton.displayName = 'ClosedCaptionButton';
var _default = ClosedCaptionButton;
exports["default"] = _default;

/***/ }),
/* 2467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTutorials; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getTutorials=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.tutorials.data.tutorials;},function(tutorials){return tutorials;});

/***/ }),
/* 2468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadTutorialsRequest;
/* unused harmony export loadTutorialsSuccess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_tutorials_api__ = __webpack_require__(2469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types__ = __webpack_require__(1010);
function loadTutorialsRequest(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_tutorials_api__["a" /* tutorialsApi */].getTutorials().then(function(response){if(response.ok){dispatch(loadTutorialsSuccess(response.tutorials));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}});};}function loadTutorialsSuccess(tutorials){return{type:__WEBPACK_IMPORTED_MODULE_2__action_types__["a" /* TUTORIALS_LOAD_SUCCESS */],payload:tutorials};}

/***/ }),
/* 2469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TutorialsApi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tutorialsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TutorialsApi=function(_BaseApi){_inherits(TutorialsApi,_BaseApi);function TutorialsApi(){_classCallCheck(this,TutorialsApi);return _possibleConstructorReturn(this,(TutorialsApi.__proto__||Object.getPrototypeOf(TutorialsApi)).apply(this,arguments));}_createClass(TutorialsApi,[{key:'getTutorials',value:function getTutorials(){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/tutorials?platform=web').then(function(response){return{ok:true,tutorials:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return TutorialsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var tutorialsApi=new TutorialsApi();

/***/ }),
/* 2470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_navigation_SearchBar__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_ContractorsInvoicesTable__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_contractors_invoices_ContractorsInvoicesTabs__ = __webpack_require__(2472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_contractors_invoices_VendorsInvoicesTable__ = __webpack_require__(2474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_contractors_invoices_store_selectors__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_contractors_invoices_store_actions__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorsInvoices=function(_Component){_inherits(ContractorsInvoices,_Component);function ContractorsInvoices(props){_classCallCheck(this,ContractorsInvoices);var _this=_possibleConstructorReturn(this,(ContractorsInvoices.__proto__||Object.getPrototypeOf(ContractorsInvoices)).call(this,props));_this.handleSearch=function(text){if(_this.state.currentTab===1){if(_this.props.currentInvoicesTab===1){_this.props.onContractorInvoicesSearch(text);}else{_this.props.onWorkOrdersWithoutInvocesSearch({page:1,withoutContractorInvoice:true,jobNumber:text});}}else{_this.props.onVendorInvoicesSearch(text);}};_this.handleSearchTextChange=function(text){_this.props.onSearchTextChange(text);};_this.handleSearchTextClear=function(){_this.props.onSearchTextChange('');};_this.handleTabChange=function(value){// Clear search text input
_this.props.onSearchTextChange('');_this.props.onInitSearchFilters();_this.setState({currentTab:value});};_this.renderForAdmin=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_navigation_SearchBar__["a" /* default */],null,'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_ContractorsInvoicesTable__["a" /* default */],null));};_this.renderForContractor=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_navigation_SearchBar__["a" /* default */],{searchPlaceHolder:'Search by Job #',searchText:_this.props.searchText,onClearText:_this.handleSearchTextClear,onSearch:_this.handleSearch,onSearchTextChange:_this.handleSearchTextChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'Spackle Invoices'},{id:2,title:'Vendors'}],onSelected:_this.handleTabChange})),_this.state.currentTab===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_admin_contractors_invoices_ContractorsInvoicesTabs__["a" /* default */],null),_this.state.currentTab===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_contractors_invoices_VendorsInvoicesTable__["a" /* default */],null));};_this.state={currentTab:1};return _this;}_createClass(ContractorsInvoices,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invoices'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Contractors Invoices'),__WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__["g" /* usersUtil */].isAdmin(this.props.currentUser)||__WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR)?this.renderForAdmin():this.renderForContractor());}}]);return ContractorsInvoices;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_authentication__["d" /* getCurrentUser */])(state),searchText:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_contractors_invoices_store_selectors__["d" /* searchTextSelector */])(state),currentInvoicesTab:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_admin_work_orders_work_orders__["c" /* getCurrentInvoicesTab */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onContractorInvoicesSearch:function onContractorInvoicesSearch(text){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_contractors_invoices_store_actions__["a" /* changePageRequest */])(1,text));},onSearchTextChange:function onSearchTextChange(text){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_contractors_invoices_store_actions__["c" /* changeSearchText */])(text));},onInitSearchFilters:function onInitSearchFilters(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_contractors_invoices_store_actions__["h" /* initSearchFilters */])());},onVendorInvoicesSearch:function onVendorInvoicesSearch(text){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_contractors_invoices_store_actions__["d" /* changeVendorInvoicesPageRequest */])(1,text));},onWorkOrdersWithoutInvocesSearch:function onWorkOrdersWithoutInvocesSearch(criteria){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_actions_admin_work_orders_work_orders__["q" /* loadWorkOrdersRequest */])(criteria));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ContractorsInvoices));

/***/ }),
/* 2471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return contractorsInvoicesApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorsInvoicesApi=function(_BaseApi){_inherits(ContractorsInvoicesApi,_BaseApi);function ContractorsInvoicesApi(){_classCallCheck(this,ContractorsInvoicesApi);return _possibleConstructorReturn(this,(ContractorsInvoicesApi.__proto__||Object.getPrototypeOf(ContractorsInvoicesApi)).apply(this,arguments));}_createClass(ContractorsInvoicesApi,[{key:'getInvoices',value:function getInvoices(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var workOrderJobNumber=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var filter='';if(workOrderJobNumber!==null&&workOrderJobNumber!==''){filter+='&by_job_number='+workOrderJobNumber;}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/contractor_invoices?page='+page+filter).then(function(response){return{ok:true,invoices:{content:response.data,pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value(),total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateInvoice',value:function updateInvoice(invoiceId,dueDate){var data={contractor_invoice:{due_date:dueDate}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/contractor_invoices/'+invoiceId,data).then(function(response){return{ok:true,invoice:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'deleteInvoice',value:function deleteInvoice(invoiceId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/contractor_invoices/'+invoiceId).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'markAsPaid',value:function markAsPaid(invoiceId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/contractor_invoices/'+invoiceId+'/paid').then(function(response){return{ok:true,invoice:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return ContractorsInvoicesApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var contractorsInvoicesApi=new ContractorsInvoicesApi();

/***/ }),
/* 2472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_ContractorsInvoicesTable__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_contractors_invoices_ContractorsWorkOrdersWithoutInvoices__ = __webpack_require__(2473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_contractors_invoices_store_actions__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorsInvoicesTabs=function(_Component){_inherits(ContractorsInvoicesTabs,_Component);function ContractorsInvoicesTabs(props){_classCallCheck(this,ContractorsInvoicesTabs);var _this=_possibleConstructorReturn(this,(ContractorsInvoicesTabs.__proto__||Object.getPrototypeOf(ContractorsInvoicesTabs)).call(this,props));_this.handleTabChange=function(value){// Clear search text input
_this.props.onSearchTextChange('');_this.props.onInitSearchFilters();_this.setState({currentTab:value});_this.props.onInvoicesTabChange(value);};_this.state={currentTab:1};return _this;}_createClass(ContractorsInvoicesTabs,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contractors-invoices-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'Uploaded'},{id:2,title:'Not Uploaded'}],onSelected:this.handleTabChange}),this.state.currentTab===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_ContractorsInvoicesTable__["a" /* default */],null),this.state.currentTab===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_admin_contractors_invoices_ContractorsWorkOrdersWithoutInvoices__["a" /* default */],null));}}]);return ContractorsInvoicesTabs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSearchTextChange:function onSearchTextChange(text){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_contractors_invoices_store_actions__["c" /* changeSearchText */])(text));},onInitSearchFilters:function onInitSearchFilters(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_contractors_invoices_store_actions__["h" /* initSearchFilters */])());},onInvoicesTabChange:function onInvoicesTabChange(newTab){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_work_orders_work_orders__["e" /* changeInvoicesTab */])(newTab));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(null,mapDispatchToProps)(ContractorsInvoicesTabs));

/***/ }),
/* 2473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContractorsInvoicesTable_css__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContractorsInvoicesTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ContractorsInvoicesTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_contractors_invoices_store_selectors__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_work_orders__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_domain_work_order__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_text_SimpleText__ = __webpack_require__(155);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorsWorkOrdersWithoutInvoices=function(_Component){_inherits(ContractorsWorkOrdersWithoutInvoices,_Component);function ContractorsWorkOrdersWithoutInvoices(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ContractorsWorkOrdersWithoutInvoices);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ContractorsWorkOrdersWithoutInvoices.__proto__||Object.getPrototypeOf(ContractorsWorkOrdersWithoutInvoices)).call.apply(_ref,[this].concat(args))),_this),_this.handlePageChange=function(page){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_work_orders__["q" /* loadWorkOrdersRequest */])({page:page,withoutContractorInvoice:true}));},_this.handleTableSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_work_orders__["h" /* goToWorkOrder */])(_this.props.workOrders.content[index].id));},_this.mapWorkOrders=function(workOrders){return workOrders.content.map(function(element){var startDate=__WEBPACK_IMPORTED_MODULE_10_domain_work_order__["a" /* WorkOrder */].getStartDate(element);var completionDate=__WEBPACK_IMPORTED_MODULE_10_domain_work_order__["a" /* WorkOrder */].getCompletionDate(element);return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,element.number.toString()),__WEBPACK_IMPORTED_MODULE_10_domain_work_order__["a" /* WorkOrder */].getJobNumber(element,'N/A'),__WEBPACK_IMPORTED_MODULE_10_domain_work_order__["a" /* WorkOrder */].getName(element,'N/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'company-name-cell'},element.client.company_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_text_SimpleText__["a" /* default */],{lines:[element.building.location.street_address_1,element.building.location.city]}),__WEBPACK_IMPORTED_MODULE_11_services_utils_work_order_status_enum__["a" /* WorkOrderStatusEnum */].create(element.status).label,startDate!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_text_Date__["a" /* default */],{value:startDate,format:'ll'}):'TBD',completionDate!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_text_Date__["a" /* default */],{value:completionDate,format:'ll'}):'TBD'];});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ContractorsWorkOrdersWithoutInvoices,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_work_orders__["q" /* loadWorkOrdersRequest */])({page:1,withoutContractorInvoice:true}));}},{key:'componentDidUpdate',value:function componentDidUpdate(){Object(__WEBPACK_IMPORTED_MODULE_5_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}},{key:'render',value:function render(){var headers=['WO #','JOB #','NAME','CLIENT NAME','LOCATION','STATUS','START DATE','END DATE'];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wo-without-invoices-container'},this.props.workOrders!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wo-table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_table_SimpleTable__["a" /* default */],{className:'work-orders-table',headers:headers,rows:this.mapWorkOrders(this.props.workOrders),emptyMessage:'No Work Order for Contractor',onRowSelected:this.handleTableSelection}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.currentPage,pageSize:this.props.workOrders.pageSize,total:this.props.workOrders.total,onPageChange:this.handlePageChange}))));}}]);return ContractorsWorkOrdersWithoutInvoices;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_authentication__["d" /* getCurrentUser */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_work_orders__["d" /* getCurrentPage */])(state),workOrders:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_work_orders_work_orders__["l" /* getWorkOrders */])(state),paginationInfo:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_contractors_invoices_store_selectors__["b" /* getPaginationInfo */])(state),searchText:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_contractors_invoices_store_selectors__["d" /* searchTextSelector */])(state)};})(ContractorsWorkOrdersWithoutInvoices));

/***/ }),
/* 2474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VendorsInvoicesTable_css__ = __webpack_require__(2475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VendorsInvoicesTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__VendorsInvoicesTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_contractors_invoices_store_selectors__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_contractors_invoices_store_actions__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_domain_invoice__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_shared_input_Input__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VendorsInvoicesTable=function(_Component){_inherits(VendorsInvoicesTable,_Component);function VendorsInvoicesTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,VendorsInvoicesTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VendorsInvoicesTable.__proto__||Object.getPrototypeOf(VendorsInvoicesTable)).call.apply(_ref,[this].concat(args))),_this),_this.handleMarkAsPaid=function(invoiceId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_contractors_invoices_store_actions__["k" /* markVendorInvoiceAsPaid */])(invoiceId));},_this.handlePageChange=function(page){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_contractors_invoices_store_actions__["d" /* changeVendorInvoicesPageRequest */])(page,_this.props.searchText,_this.props.searchFilters));},_this.mapInvoices=function(invoices){return invoices.map(function(invoice){return[invoice.work_order_number,invoice.task_number,invoice.work_order_job!==null?invoice.work_order_job:'N/A',invoice.client_name,invoice.vendor_name,Object(__WEBPACK_IMPORTED_MODULE_3_services_utils_text_util__["e" /* toUpperFirstLetter */])(invoice.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_text_Date__["a" /* default */],{value:invoice.due_date,format:'LL'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_text_Number__["a" /* default */],{value:invoice.cost,format:'$0,0.[00]'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_document_DocumentLink__["a" /* default */],{showIcon:false,url:invoice.document.document.url}),invoice.status!==__WEBPACK_IMPORTED_MODULE_14_domain_invoice__["a" /* InvoiceStatusKeys */].PAID?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-blue-grey',label:'Mark as Paid',onClick:function onClick(){return _this.handleMarkAsPaid(invoice.id);}}):''];});},_this.handleSearchFiltersValueChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_contractors_invoices_store_actions__["b" /* changeSearchFilterValue */])(attribute,value));},_this.handleClearFilters=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_contractors_invoices_store_actions__["h" /* initSearchFilters */])());_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_contractors_invoices_store_actions__["d" /* changeVendorInvoicesPageRequest */])(1,_this.props.searchText));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VendorsInvoicesTable,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_contractors_invoices_store_actions__["f" /* getVendorsInvoices */])());}},{key:'componentDidUpdate',value:function componentDidUpdate(){Object(__WEBPACK_IMPORTED_MODULE_8_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}},{key:'render',value:function render(){var _this2=this;var headers=['WO #','TASK #','JOB #','CLIENT NAME','VENDOR NAME','STATUS','DUE DATE','AMOUNT','DOC LINK',''];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vendors-invoices-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'search-filters'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_input_Input__["a" /* default */],{type:'number',placeholder:'WO #',value:this.props.searchFilters['by_wo_number'],onChange:function onChange(value){return _this2.handleSearchFiltersValueChange('by_wo_number',value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_input_Input__["a" /* default */],{placeholder:'Vendor Name',value:this.props.searchFilters['by_vendor_name'],onChange:function onChange(value){return _this2.handleSearchFiltersValueChange('by_vendor_name',value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_input_Input__["a" /* default */],{type:'number',placeholder:'Min. Amount',value:this.props.searchFilters['by_min_cost'],onChange:function onChange(value){return _this2.handleSearchFiltersValueChange('by_min_cost',value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_input_Input__["a" /* default */],{type:'number',placeholder:'Max. Amount',value:this.props.searchFilters['by_max_cost'],onChange:function onChange(value){return _this2.handleSearchFiltersValueChange('by_max_cost',value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Filter',onClick:function onClick(){return _this2.handlePageChange(1);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:'Clear',onClick:this.handleClearFilters})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_table_SimpleTable__["a" /* default */],{headers:headers,rows:this.mapInvoices(this.props.vendorInvoices),emptyMessage:'No Vendor Invoices'}),this.props.vendorInvoicesPaginationInfo!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.vendorInvoicesPaginationInfo.currentPage,pageSize:this.props.vendorInvoicesPaginationInfo.pageSize,total:this.props.vendorInvoicesPaginationInfo.total,onPageChange:function onPageChange(page){return _this2.handlePageChange(page);}})));}}]);return VendorsInvoicesTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_authentication__["d" /* getCurrentUser */])(state),searchText:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_contractors_invoices_store_selectors__["d" /* searchTextSelector */])(state),vendorInvoices:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_contractors_invoices_store_selectors__["f" /* vendorsInvoicesSelector */])(state),vendorInvoicesPaginationInfo:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_contractors_invoices_store_selectors__["e" /* vendorsInvoicesPaginationInfoSelector */])(state),searchFilters:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_contractors_invoices_store_selectors__["c" /* searchFiltersSelector */])(state)};})(VendorsInvoicesTable));

/***/ }),
/* 2475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_reports_Reports__ = __webpack_require__(2477);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportsContainer=function(_Component){_inherits(ReportsContainer,_Component);function ReportsContainer(props){_classCallCheck(this,ReportsContainer);var _this=_possibleConstructorReturn(this,(ReportsContainer.__proto__||Object.getPrototypeOf(ReportsContainer)).call(this,props));_this.reportRoutes=function(reports){return reports.map(function(report,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Route */],{exact:true,key:i,path:_this.props.match.url+'/'+report.route,component:report.component});});};_this.state={hasError:false};return _this;}_createClass(ReportsContainer,[{key:'componentDidCatch',value:function componentDidCatch(error,info){this.setState({hasError:true});this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_messages__["d" /* showErrorMessage */])('Something went wrong with the request, please try again later.'));}},{key:'render',value:function render(){if(this.state.hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Redirect */],{to:'/'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/',component:__WEBPACK_IMPORTED_MODULE_5_components_admin_reports_Reports__["a" /* default */]}),this.reportRoutes(this.props.reports)));}}}]);return ReportsContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{reports:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__["e" /* getReports */])(state)};})(ReportsContainer));

/***/ }),
/* 2477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectors_admin_reports_reports__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_authentication__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Reports=function(_Component){_inherits(Reports,_Component);function Reports(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Reports);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Reports.__proto__||Object.getPrototypeOf(Reports)).call.apply(_ref,[this].concat(args))),_this),_this.state={toReport:false,selectedReportRoute:'',userIsSpackleAdmin:__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["g" /* usersUtil */].hasRole(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["e" /* ROLES */].SPACKLE_ADMIN),userIsSpackleBd:__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["g" /* usersUtil */].hasRole(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["e" /* ROLES */].BUSINESS_DEVELOPMENT),userIsContractor:__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["f" /* TYPES */].CONTRACTOR),userIsGc:__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["g" /* usersUtil */].hasType(_this.props.currentUser,__WEBPACK_IMPORTED_MODULE_5_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR)},_this.handleRowSelection=function(index){var route=_this.props.match.url+'/'+_this.props.reports[index].route;_this.setState(function(){return{toReport:true,selectedReportRoute:route};});},_this.handleGenerateLink=function(index){var _this$props=_this.props,url=_this$props.match.url,reports=_this$props.reports;return url+'/'+reports[index].route;},_this.mapReports=function(reports){return reports.map(function(report){if(_this.props.match.url.includes('spe-reports')){if(report.generalContractor){return[report.name,report.description];}else{return[];}}else{if(report.admin&&(_this.state.userIsSpackleAdmin||_this.state.userIsSpackleBd||_this.state.userIsGc)||report.contractor&&_this.state.userIsContractor){return[report.name,report.description];}else{return[];}}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Reports,[{key:'render',value:function render(){if(this.state.toReport===true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Redirect */],{push:true,to:this.state.selectedReportRoute});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reports'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Reports'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_table_SimpleTable__["a" /* default */],{className:'quotes-table',headers:['NAME','DESCRIPTION'],rows:this.mapReports(this.props.reports),emptyMessage:'No Reports',onRowSelected:this.handleRowSelection,onGenerateLink:this.handleGenerateLink})));}}]);return Reports;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{reports:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_reports_reports__["e" /* getReports */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_authentication__["d" /* getCurrentUser */])(state)};})(Reports));

/***/ }),
/* 2478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_purchase_orders_PurchaseOrders__ = __webpack_require__(2479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_BaseMenuContainer__ = __webpack_require__(2485);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PurchaseOrdersContainer=function(_Component){_inherits(PurchaseOrdersContainer,_Component);function PurchaseOrdersContainer(){_classCallCheck(this,PurchaseOrdersContainer);return _possibleConstructorReturn(this,(PurchaseOrdersContainer.__proto__||Object.getPrototypeOf(PurchaseOrdersContainer)).apply(this,arguments));}_createClass(PurchaseOrdersContainer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_BaseMenuContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/',component:__WEBPACK_IMPORTED_MODULE_2_components_admin_purchase_orders_PurchaseOrders__["a" /* default */]})));}}]);return PurchaseOrdersContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PurchaseOrdersContainer);

/***/ }),
/* 2479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_navigation_SearchBar__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_css__ = __webpack_require__(2480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_purchase_orders_store_actions__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_purchase_orders_store_selectors__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_purchase_orders_NewPurchaseOrderModal__ = __webpack_require__(2482);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PurchaseOrders=function(_Component){_inherits(PurchaseOrders,_Component);function PurchaseOrders(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PurchaseOrders);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PurchaseOrders.__proto__||Object.getPrototypeOf(PurchaseOrders)).call.apply(_ref,[this].concat(args))),_this),_this.handleAddPurchaseOrder=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_purchase_orders_store_actions__["e" /* setShowCreateModal */])(true));},_this.handlePageChange=function(newPage){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_purchase_orders_store_actions__["a" /* changePage */])(newPage));},_this.mapPurchaseOrders=function(purchaseOrders){return purchaseOrders.map(function(purchaseOrder){return[purchaseOrder.number,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__["a" /* default */],{value:purchaseOrder.amount,format:'$0,0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__["a" /* default */],{value:purchaseOrder.balance,format:'$0,0'}),purchaseOrder.document!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_document_DocumentLink__["a" /* default */],{showIcon:false,showLink:true,url:purchaseOrder.document.document.url}):'N/A'];});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PurchaseOrders,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_purchase_orders_store_actions__["c" /* getPurchaseOrders */])());}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'purchase-orders'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Purchase Orders'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_navigation_SearchBar__["a" /* default */],{addButton:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'button',value:'Add Purchase Order',onClick:this.handleAddPurchaseOrder})},'\xA0'),this.props.purchaseOrders!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__["a" /* default */],{className:'purchase-orders-table',headers:['PO #','AMOUNT','BALANCE','DOCUMENT'],rows:this.mapPurchaseOrders(this.props.purchaseOrders.content),emptyMessage:'No Purchase Orders'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.currentPage,pageSize:this.props.purchaseOrders.pageSize,total:this.props.purchaseOrders.total,onPageChange:this.handlePageChange})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_admin_purchase_orders_NewPurchaseOrderModal__["a" /* default */],null));}}]);return PurchaseOrders;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentPage:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_purchase_orders_store_selectors__["b" /* currentPageSelector */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_authentication__["d" /* getCurrentUser */])(state),purchaseOrders:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_purchase_orders_store_selectors__["c" /* purchaseOrdersSelector */])(state)};})(PurchaseOrders));

/***/ }),
/* 2480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return purchaseOrdersApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PurchaseOrdersApi=function(_BaseApi){_inherits(PurchaseOrdersApi,_BaseApi);function PurchaseOrdersApi(){_classCallCheck(this,PurchaseOrdersApi);return _possibleConstructorReturn(this,(PurchaseOrdersApi.__proto__||Object.getPrototypeOf(PurchaseOrdersApi)).apply(this,arguments));}_createClass(PurchaseOrdersApi,[{key:'createPurchaseOrders',value:function createPurchaseOrders(values){var headers={headers:{'Content-Type':'multipart/form-data'}};var apiPayload=new FormData();apiPayload.append('purchase_order[number]',values.number);apiPayload.append('purchase_order[amount]',values.amount);if(values.document){apiPayload.append('purchase_order[document_attributes][document]',values.document);}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/purchase_orders',apiPayload,headers).then(function(response){return{ok:true,purchaseOrder:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getPurchaseOrders',value:function getPurchaseOrders(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/purchase_orders?page='+page).then(function(response){return{ok:true,purchaseOrders:{content:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return PurchaseOrdersApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var purchaseOrdersApi=new PurchaseOrdersApi();

/***/ }),
/* 2482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_purchase_orders_store_selectors__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_purchase_orders_store_actions__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_purchase_orders_NewPurchaseOrderForm__ = __webpack_require__(2483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewPurchaseOrderModal=function(_Component){_inherits(NewPurchaseOrderModal,_Component);function NewPurchaseOrderModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewPurchaseOrderModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewPurchaseOrderModal.__proto__||Object.getPrototypeOf(NewPurchaseOrderModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_purchase_orders_store_actions__["e" /* setShowCreateModal */])(false));},_this.handleOnSubmit=function(values){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_purchase_orders_store_actions__["b" /* createPurchaseOrder */])(values));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewPurchaseOrderModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_modal_FormModal__["a" /* default */],{className:'create-purchase-order-modal',show:this.props.show,title:'Create Purchase Order',onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_purchase_orders_NewPurchaseOrderForm__["a" /* default */],{onSubmit:this.handleOnSubmit})));}}]);return NewPurchaseOrderModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(function(state){return{form:Object(__WEBPACK_IMPORTED_MODULE_2_components_admin_purchase_orders_store_selectors__["a" /* createFormSelector */])(state),show:Object(__WEBPACK_IMPORTED_MODULE_2_components_admin_purchase_orders_store_selectors__["d" /* showCreateModalSelector */])(state)};})(NewPurchaseOrderModal));

/***/ }),
/* 2483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NewPurchaseOrderForm_css__ = __webpack_require__(2484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NewPurchaseOrderForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__NewPurchaseOrderForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_upload_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_upload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_remove_svg__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_remove_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_images_remove_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewPurchaseOrderForm=function(_Component){_inherits(NewPurchaseOrderForm,_Component);function NewPurchaseOrderForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewPurchaseOrderForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewPurchaseOrderForm.__proto__||Object.getPrototypeOf(NewPurchaseOrderForm)).call.apply(_ref,[this].concat(args))),_this),_this.renderDocument=function(props){if(props.input.value===''){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx',className:'dropzone-container',multiple:false,onDrop:function onDrop(files){return props.input.onChange(files[0]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Please drag and drop any file into this area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5_images_upload_svg___default.a,alt:'upload'}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'file-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_document_DocumentLink__["a" /* default */],{file:props.input.value,showIcon:false,showLink:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8_images_remove_svg___default.a,alt:'remove',onClick:function onClick(){return props.input.onChange('');}}));},_this.renderInput=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_input_Input__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewPurchaseOrderForm,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'new-purchase-order-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.props.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'number',placeholder:'Number'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'amount',placeholder:'Amount',type:'number'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Document'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderDocument,name:'document',placeholder:'Document'}))),this.props.invalid&&this.props.submitFailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'The outlined inputs should be added in order to create a Purchase Order.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'submit',value:'Create'})))));}}]);return NewPurchaseOrderForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(values){var errors={};if(!values.number){errors.number='Required';}if(!values.amount){errors.amount='Required';}if(!values.document){errors.document='Required';}return errors;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["f" /* reduxForm */])({form:'NewPurchaseOrderForm',validate:validate})(NewPurchaseOrderForm));

/***/ }),
/* 2484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_authentication__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BaseMenuContainer=function(_Component){_inherits(BaseMenuContainer,_Component);function BaseMenuContainer(props){_classCallCheck(this,BaseMenuContainer);var _this=_possibleConstructorReturn(this,(BaseMenuContainer.__proto__||Object.getPrototypeOf(BaseMenuContainer)).call(this,props));_this.state={hasError:false};return _this;}_createClass(BaseMenuContainer,[{key:'componentDidCatch',value:function componentDidCatch(error,info){this.setState({hasError:true});this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_messages__["d" /* showErrorMessage */])('Something went wrong with the request, please try again later.'));}},{key:'render',value:function render(){if(this.state.hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Redirect */],{to:'/'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.children);}}}]);return BaseMenuContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_authentication__["d" /* getCurrentUser */])(state)};})(BaseMenuContainer));

/***/ }),
/* 2486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_surveys_Surveys__ = __webpack_require__(2487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_surveys_SurveyDetails__ = __webpack_require__(2489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SurveysContainer=function(_Component){_inherits(SurveysContainer,_Component);function SurveysContainer(props){_classCallCheck(this,SurveysContainer);var _this=_possibleConstructorReturn(this,(SurveysContainer.__proto__||Object.getPrototypeOf(SurveysContainer)).call(this,props));_this.state={hasError:false};return _this;}_createClass(SurveysContainer,[{key:'componentDidCatch',value:function componentDidCatch(error,info){this.setState({hasError:true});this.props.onErrorShow('Something went wrong with the request, please try again later.');}},{key:'render',value:function render(){if(this.state.hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Redirect */],{to:'/'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/',component:__WEBPACK_IMPORTED_MODULE_3_components_admin_surveys_Surveys__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/:id',component:__WEBPACK_IMPORTED_MODULE_4_components_admin_surveys_SurveyDetails__["a" /* default */]})));}}}]);return SurveysContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onErrorShow:function onErrorShow(message){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actions_messages__["d" /* showErrorMessage */])(message));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(null,mapDispatchToProps)(SurveysContainer));

/***/ }),
/* 2487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Surveys_css__ = __webpack_require__(2488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Surveys_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Surveys_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_surveys_store_selectors__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_surveys_store_actions__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_surveys_SurveysTable__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_navigation_SearchBar__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Surveys=function(_Component){_inherits(Surveys,_Component);function Surveys(props){_classCallCheck(this,Surveys);var _this=_possibleConstructorReturn(this,(Surveys.__proto__||Object.getPrototypeOf(Surveys)).call(this,props));_this.handlePageChange=function(page){if(_this.selectedNavigator===1){_this.props.onSurveysGet(page);}else{_this.props.onSurveysGet(page,true);}};_this.handleNavSelection=function(value){_this.selectedNavigator=value;_this.handlePageChange(1);};_this.handleGenerateLink=function(index){var surveys=_this.props.surveys;return'surveys/'+surveys[index].id;};_this.selectedNavigator=1;return _this;}_createClass(Surveys,[{key:'componentDidMount',value:function componentDidMount(){this.props.onSurveysGet();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,currentUser=_props.currentUser,paginationInfo=_props.paginationInfo,pendingTotal=_props.pendingTotal,surveys=_props.surveys,onSurveyClick=_props.onSurveyClick;var isClient=__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["f" /* TYPES */].CLIENT);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'surveys'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Surveys'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_navigation_SearchBar__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'All'},{id:2,show:pendingTotal>0,title:'Pending',total:pendingTotal}],onSelected:this.handleNavSelection})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_surveys_SurveysTable__["a" /* default */],{showClient:!isClient,surveys:surveys,onRowSelected:function onRowSelected(index){return onSurveyClick(surveys[index].id);},onGenerateLink:this.handleGenerateLink}),paginationInfo!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:paginationInfo.currentPage,pageSize:paginationInfo.pageSize,total:paginationInfo.total,onPageChange:function onPageChange(page){return _this2.handlePageChange(page);}}))));}}]);return Surveys;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Surveys.propTypes={paginationInfo:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({}),pendingTotal:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired,surveys:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({})).isRequired,onSurveyClick:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,onSurveysGet:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired};Surveys.defaultProps={paginationInfo:null};var mapStateToProps=function mapStateToProps(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_authentication__["d" /* getCurrentUser */])(state),paginationInfo:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_surveys_store_selectors__["b" /* paginationInfoSelector */])(state),pendingTotal:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_surveys_store_selectors__["c" /* pendingTotalSelector */])(state),surveys:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_surveys_store_selectors__["f" /* surveysSelector */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSurveyClick:function onSurveyClick(surveyId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_surveys_store_actions__["d" /* goToSurvey */])(surveyId));},onSurveysGet:function onSurveysGet(page,pending){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_surveys_store_actions__["c" /* getSurveys */])(page,pending));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Surveys));

/***/ }),
/* 2488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_surveys_store_selectors__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_surveys_store_actions__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_surveys_SurveyForm__ = __webpack_require__(2490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_domain_survey__ = __webpack_require__(2495);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SurveyDetails=function(_Component){_inherits(SurveyDetails,_Component);function SurveyDetails(props){_classCallCheck(this,SurveyDetails);var _this=_possibleConstructorReturn(this,(SurveyDetails.__proto__||Object.getPrototypeOf(SurveyDetails)).call(this,props));_this.handleAttributeChange=function(attribute,value){_this.props.onSurveyFormAttributeChange(attribute,value);};_this.surveyId=__WEBPACK_IMPORTED_MODULE_1_numeral___default()(props.match.params.id).value();return _this;}_createClass(SurveyDetails,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,currentSurvey=_props.currentSurvey,onSurveyFormSet=_props.onSurveyFormSet,onSurveyGet=_props.onSurveyGet;if(currentSurvey===null||currentSurvey.id!==this.surveyId){onSurveyGet(this.surveyId);}else{// If already loaded, update the form with the survey
onSurveyFormSet(currentSurvey);}}},{key:'render',value:function render(){var _props2=this.props,currentSurvey=_props2.currentSurvey,currentUser=_props2.currentUser,showValidationMessage=_props2.showValidationMessage,surveyForm=_props2.surveyForm,onSurveyEditCancel=_props2.onSurveyEditCancel,onSurveyEditSubmit=_props2.onSurveyEditSubmit;var isClient=__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["f" /* TYPES */].CLIENT);if(currentSurvey!==null&&currentSurvey.id===this.surveyId){if(isClient&&__WEBPACK_IMPORTED_MODULE_9_domain_survey__["a" /* Survey */].isEditable(currentSurvey)){// If editable, make sure the form is loaded
if(surveyForm!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_surveys_SurveyForm__["a" /* default */],{edit:true,showValidationMessage:showValidationMessage,survey:surveyForm,onAttributeChange:this.handleAttributeChange,onCancel:function onCancel(){return onSurveyEditCancel();},onSubmit:function onSubmit(){return onSurveyEditSubmit(surveyForm);}});}return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_surveys_SurveyForm__["a" /* default */],{edit:false,survey:currentSurvey});}return null;}}]);return SurveyDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SurveyDetails.propTypes={currentSurvey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),match:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,// from router
showValidationMessage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,surveyForm:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),onSurveyEditSubmit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onSurveyFormAttributeChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onSurveyFormSet:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onSurveyGet:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};SurveyDetails.defaultProps={currentSurvey:null,surveyForm:null};var mapStateToProps=function mapStateToProps(state){return{currentSurvey:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_surveys_store_selectors__["a" /* currentSurveySelector */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_authentication__["d" /* getCurrentUser */])(state),showValidationMessage:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_surveys_store_selectors__["d" /* showValidationMessageSelector */])(state),surveyForm:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_surveys_store_selectors__["e" /* surveyFormSelector */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSurveyFormAttributeChange:function onSurveyFormAttributeChange(attribute,value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_surveys_store_actions__["a" /* changeAttribute */])(attribute,value));},onSurveyEditCancel:function onSurveyEditCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_surveys_store_actions__["e" /* goToSurveys */])());},onSurveyEditSubmit:function onSurveyEditSubmit(surveyForm){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_surveys_store_actions__["g" /* submitSurvey */])(surveyForm));},onSurveyFormSet:function onSurveyFormSet(survey){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_surveys_store_actions__["f" /* setSurveyForm */])(survey));},onSurveyGet:function onSurveyGet(surveyId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_surveys_store_actions__["b" /* getSurvey */])(surveyId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SurveyDetails));

/***/ }),
/* 2490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SurveyForm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SurveyForm_css__ = __webpack_require__(2491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SurveyForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SurveyForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_surveys_SurveyRating__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_surveys_SurveyQuestion__ = __webpack_require__(2492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_input_TextArea__ = __webpack_require__(62);
function SurveyForm(props){var edit=props.edit,showValidationMessage=props.showValidationMessage,survey=props.survey,onAttributeChange=props.onAttributeChange,onCancel=props.onCancel,onSubmit=props.onSubmit;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'survey-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['WORK ORDERS',survey.wo_number.toString()]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'work-order-title-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'work-order-title'},'Survey Work Order #'+survey.wo_number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_surveys_SurveyRating__["a" /* default */],{rating:survey.rating}))),survey.rating!==null&&survey.rating>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submitted-container'},'Survey Submitted on',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__["a" /* default */],{value:survey.updated_at,format:'M/D/YYYY'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'survey-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_surveys_SurveyQuestion__["a" /* default */],{edit:edit,title:'1. Was the response time satisfactory?',value:survey.response_time_sat,onChange:function onChange(value){return onAttributeChange('response_time_sat',value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'question-separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_surveys_SurveyQuestion__["a" /* default */],{edit:edit,title:'2. Was the quality of work satisfactory?',value:survey.work_quality_sat,onChange:function onChange(value){return onAttributeChange('work_quality_sat',value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'question-separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_surveys_SurveyQuestion__["a" /* default */],{edit:edit,title:'3. Would you recommend Spackle?',value:survey.recommend_spackle,onChange:function onChange(value){return onAttributeChange('recommend_spackle',value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'note-container'},edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_TextArea__["a" /* default */],{value:survey.note!==null?survey.note:'',onChange:function onChange(value){return onAttributeChange('note',value);}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'note-readonly'},survey.note)),edit&&showValidationMessage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-form-message'},'Please answer all questions before submitting.'),edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Submit',onClick:function onClick(){return onSubmit();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:'Cancel',onClick:function onClick(){return onCancel();}}))));}SurveyForm.propTypes={edit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showValidationMessage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,survey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,onAttributeChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};SurveyForm.defaultProps={edit:false,showValidationMessage:false,onAttributeChange:function onAttributeChange(){},onCancel:function onCancel(){}};

/***/ }),
/* 2491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SurveyQuestion;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SurveyQuestion_css__ = __webpack_require__(2493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SurveyQuestion_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SurveyQuestion_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_radio_button_RadioButton__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_round_full_png__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_round_full_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_round_full_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_close_blue_svg__ = __webpack_require__(2494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_close_blue_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_close_blue_svg__);
function SurveyQuestion(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'survey-question'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'question-title'},props.title),props.edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_radio_button_RadioButton__["a" /* default */],{className:'question-radio',options:[{value:1,label:'Yes'},{value:0,label:'No'}],value:props.value!==null?props.value?1:0:null,onChange:function onChange(value){return props.onChange(value===1);}}):props.value===null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'N/A')):props.value?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4_images_round_full_png___default.a,alt:'with-value'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Yes')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5_images_close_blue_svg___default.a,alt:'with-value'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'No')));}SurveyQuestion.propTypes={edit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};SurveyQuestion.defaultProps={edit:false,value:null};

/***/ }),
/* 2493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close-blue.c6b17bb9.svg";

/***/ }),
/* 2495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Survey; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Survey=function(){function Survey(){_classCallCheck(this,Survey);}_createClass(Survey,null,[{key:"isEditable",value:function isEditable(){var survey=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;return survey!==null&&survey.rating===null&&survey.response_time_sat===null&&survey.work_quality_sat===null&&survey.recommend_spackle===null;}}]);return Survey;}();

/***/ }),
/* 2496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_projects_Projects__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_creation_NewProject__ = __webpack_require__(2498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_ProjectDetails__ = __webpack_require__(2505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_creation_EditProject__ = __webpack_require__(3015);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Parent container for all projects components/routes. Also catch render errors and redirects to /
 */var ProjectsContainer=function(_Component){_inherits(ProjectsContainer,_Component);function ProjectsContainer(props){_classCallCheck(this,ProjectsContainer);var _this=_possibleConstructorReturn(this,(ProjectsContainer.__proto__||Object.getPrototypeOf(ProjectsContainer)).call(this,props));_this.state={hasError:false};return _this;}_createClass(ProjectsContainer,[{key:'componentDidCatch',value:function componentDidCatch(error,info){this.setState({hasError:true});this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actions_messages__["d" /* showErrorMessage */])('Something went wrong with the request, please try again later.'));}},{key:'render',value:function render(){if(this.state.hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Redirect */],{to:'/'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url,component:__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_Projects__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/new-project',component:__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_creation_NewProject__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/edit/:projectId',component:__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_creation_EditProject__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/:projectId',component:__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_ProjectDetails__["a" /* default */]})));}}}]);return ProjectsContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProjectsContainer);

/***/ }),
/* 2497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewProject_css__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewProject_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NewProject_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_projects_creation_store_selectors__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_creation_store_actions__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_creation_GeneralContractorSelection__ = __webpack_require__(2499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_creation_ClientSelection__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_creation_BuildingSelection__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_creation_Success__ = __webpack_require__(2504);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewProject=function(_Component){_inherits(NewProject,_Component);function NewProject(props){_classCallCheck(this,NewProject);var _this=_possibleConstructorReturn(this,(NewProject.__proto__||Object.getPrototypeOf(NewProject)).call(this,props));_this.handleCreateProject=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_creation_store_actions__["e" /* createProject */])(_this.props.projectForm));};_this.renderCurrentStage=function(){var stage=void 0;switch(_this.props.currentStage){case'gc-selection':stage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_creation_GeneralContractorSelection__["a" /* default */],null);break;case'client-selection':stage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_creation_ClientSelection__["a" /* default */],null);break;case'building-selection':stage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_creation_BuildingSelection__["a" /* default */],{submitButtonLabel:'Create Project',submitFunction:_this.handleCreateProject});break;case'success':stage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_creation_Success__["a" /* default */],null);break;default:stage=null;}return stage;};props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_creation_store_actions__["i" /* newProject */])());return _this;}_createClass(NewProject,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'new-project'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Create Project'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},this.renderCurrentStage()));}}]);return NewProject;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentStage:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_creation_store_selectors__["d" /* getCurrentStage */])(state),projectForm:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_creation_store_selectors__["g" /* getProjectForm */])(state)};})(NewProject));

/***/ }),
/* 2499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewProject_css__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewProject_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NewProject_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_checkbox_CheckBox__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_creation_store_selectors__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_creation_store_actions__ = __webpack_require__(168);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GeneralContractorSelection=function(_Component){_inherits(GeneralContractorSelection,_Component);function GeneralContractorSelection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GeneralContractorSelection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GeneralContractorSelection.__proto__||Object.getPrototypeOf(GeneralContractorSelection)).call.apply(_ref,[this].concat(args))),_this),_this.handleProjectFormChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_creation_store_actions__["n" /* setProjectFormValue */])(attribute,value));},_this.handleContinue=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_creation_store_actions__["j" /* nextStage */])());},_this.handlePageChange=function(newPage){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_creation_store_actions__["m" /* setGeneralContractors */])([]));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_creation_store_actions__["h" /* loadGeneralContractorsRequest */])(newPage));},_this.mapGeneralContractors=function(generalContractors){return generalContractors.map(function(generalContractor){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_checkbox_CheckBox__["a" /* default */],{id:generalContractor.id,checked:generalContractor.id===_this.props.projectForm.generalContractorId,shape:'round',size:'medium',onChange:_this.handleProjectFormChange.bind(_this,'generalContractorId')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'h4'},generalContractor.name),generalContractor.contact.first_name+' '+generalContractor.contact.last_name];});},_this.canContinue=function(){return!!_this.props.projectForm.generalContractorId;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GeneralContractorSelection,[{key:'componentDidMount',value:function componentDidMount(){if(__WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__["g" /* usersUtil */].hasType(this.props.currentUser,__WEBPACK_IMPORTED_MODULE_6_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR)){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_creation_store_actions__["j" /* nextStage */])());}else{this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_creation_store_actions__["h" /* loadGeneralContractorsRequest */])(1));}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.generalContractors!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'selection-title'},'Which general contractor is the Project for?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selection-table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_table_SimpleTable__["a" /* default */],{headers:['','COMPANY NAME','CONTACT'],rows:this.mapGeneralContractors(this.props.generalContractors.data),emptyMessage:'No General Contractors'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.currentPage,pageSize:this.props.generalContractors.pageSize,total:this.props.generalContractors.total,onPageChange:this.handlePageChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-continue '+(this.canContinue()?'button-orange':'button-disabled'),type:'button',value:'Continue',onClick:this.handleContinue,disabled:!this.canContinue()})));}}]);return GeneralContractorSelection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_authentication__["d" /* getCurrentUser */])(state),generalContractors:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_creation_store_selectors__["e" /* getGeneralContractors */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_creation_store_selectors__["c" /* getCurrentPage */])(state),projectForm:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_creation_store_selectors__["g" /* getProjectForm */])(state)};})(GeneralContractorSelection));

/***/ }),
/* 2500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewClientModal_css__ = __webpack_require__(2501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewClientModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NewClientModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_creation_store_selectors__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_creation_store_actions__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_admin_clients_clients__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__ = __webpack_require__(129);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewClientModal=function(_Component){_inherits(NewClientModal,_Component);function NewClientModal(props){_classCallCheck(this,NewClientModal);var _this=_possibleConstructorReturn(this,(NewClientModal.__proto__||Object.getPrototypeOf(NewClientModal)).call(this,props));_this.handleClientFormChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_creation_store_actions__["l" /* setClientFormValue */])(attribute,value));};_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_creation_store_actions__["q" /* setShowNewClientModal */])(false));};_this.handleCreateClient=function(existentClientId){_this.props.dispatch(existentClientId?Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_creation_store_actions__["g" /* inviteExistentClient */])(existentClientId):Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_creation_store_actions__["d" /* createClient */])(_this.props.form)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_admin_clients_clients__["a" /* addClientToBeginning */])(response.client));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_creation_store_actions__["q" /* setShowNewClientModal */])(false));}});};_this.handleSimilarClient=function(client,similarMsg){var message=similarMsg+' Do you want to use it?';_this.setState({confirmSimilarClient:{clientId:client.id,message:message}});};_this.similarClientConfirmed=function(confirmed){var clientId=_this.state.confirmSimilarClient.clientId;_this.setState({confirmSimilarClient:null});_this.handleCreateClient(confirmed?clientId:null);};_this.handleSubmit=function(event){event.preventDefault();_this.handleCreateClient();// this.props.dispatch(findSimilarClient(this.props.form)).then((response) => {
//   if (response.ok) {
//     if (response.client) {
//       this.handleSimilarClient(response.client, response.message);
//     } else {
//       this.handleCreateClient();
//     }
//   }
// });
};_this.clientFormValid=function(){var clientForm=_this.props.form;return!!clientForm.companyName&&!!clientForm.firstName&&!!clientForm.lastName&&!!clientForm.email&&!!clientForm.phoneNumber;};props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_creation_store_actions__["b" /* cleanClientFormValues */])());_this.state={confirmSimilarClient:null};return _this;}_createClass(NewClientModal,[{key:'render',value:function render(){var confirmSimilarClient=this.state.confirmSimilarClient;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'new-client-form-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__["a" /* default */],{className:'new-client-modal',show:this.props.showNewClientModal,title:'New Client Information',onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'Company Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__["a" /* default */],{id:'company-name',placeholder:'Company Name',value:this.props.form.companyName,theme:'normal',onChange:this.handleClientFormChange.bind(this,'companyName')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'First Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__["a" /* default */],{id:'first-name',placeholder:'First Name',value:this.props.form.firstName,theme:'normal',onChange:this.handleClientFormChange.bind(this,'firstName')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'Last Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__["a" /* default */],{id:'last-name',placeholder:'Last Name',theme:'normal',value:this.props.form.lastName,onChange:this.handleClientFormChange.bind(this,'lastName')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__["a" /* default */],{id:'email',placeholder:'Email',theme:'normal',type:'email',value:this.props.form.email,onChange:this.handleClientFormChange.bind(this,'email')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'Phone Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__["a" /* default */],{id:'phone-number',placeholder:'Phone Number',theme:'normal',value:this.props.form.phoneNumber,onChange:this.handleClientFormChange.bind(this,'phoneNumber')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-continue '+(this.clientFormValid()?'button-orange':'button-disabled'),type:'submit',value:'Add',disabled:!this.clientFormValid()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'cancel-add-client',className:'btn button button-gray',value:'Cancel',onClick:this.handleClose,readOnly:true})))),confirmSimilarClient&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_modal_ConfirmationModal__["a" /* default */],{show:confirmSimilarClient?true:false,message:confirmSimilarClient.message,onHide:this.similarClientConfirmed})));}}]);return NewClientModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{form:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_creation_store_selectors__["b" /* getClientForm */])(state),showNewClientModal:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_creation_store_selectors__["i" /* getShowNewClientModal */])(state),clients:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_admin_clients_clients__["b" /* getClients */])(state)};})(NewClientModal));

/***/ }),
/* 2501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewBuildingModal_css__ = __webpack_require__(2503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewBuildingModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NewBuildingModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_creation_store_selectors__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_creation_store_actions__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_work_orders_js__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewBuildingModal=function(_Component){_inherits(NewBuildingModal,_Component);function NewBuildingModal(props){_classCallCheck(this,NewBuildingModal);var _this=_possibleConstructorReturn(this,(NewBuildingModal.__proto__||Object.getPrototypeOf(NewBuildingModal)).call(this,props));_this.handleBuildingFormChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_creation_store_actions__["k" /* setBuildingFormValue */])(attribute,value));};_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_creation_store_actions__["p" /* setShowNewBuildingModal */])(false));};_this.handleSubmit=function(event){event.preventDefault();var dispatch=_this.props.dispatch;var buildingData=_this.mapBuildingData();dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_creation_store_actions__["c" /* createBuilding */])(buildingData)).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_work_orders_work_orders_js__["a" /* addBuildingToBeginning */])(response.building));dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_creation_store_actions__["p" /* setShowNewBuildingModal */])(false));}});};_this.buildingFormValid=function(){var buildingForm=_this.props.form;return!!buildingForm.streetAddress1&&!!buildingForm.city&&!!buildingForm.state&&!!buildingForm.zip;};_this.mapBuildingData=function(){var buildingForm=_this.props.form;return{name:buildingForm.name,location:{streetAddress:buildingForm.streetAddress1,unitNumber:buildingForm.streetAddress2,city:buildingForm.city,state:buildingForm.state,zipCode:buildingForm.zip},clientsId:[_this.props.projectForm.clientId]};};props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_creation_store_actions__["a" /* cleanBuildingFormValues */])());return _this;}_createClass(NewBuildingModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'new-building-form-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__["a" /* default */],{className:'new-building-modal',show:this.props.showNewBuildingModal,title:'New Building Information',onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'Building Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{id:'name',placeholder:'Building Name',value:this.props.form.name,theme:'normal',onChange:this.handleBuildingFormChange.bind(this,'name')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'Address Line 1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{id:'street-address-1',placeholder:'Street Address',value:this.props.form.streetAddress1,theme:'normal',onChange:this.handleBuildingFormChange.bind(this,'streetAddress1')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'Address Line 2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{id:'street-address-2',placeholder:'Unit number / Floor',value:this.props.form.streetAddress2,theme:'normal',onChange:this.handleBuildingFormChange.bind(this,'streetAddress2')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'City'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{id:'city',placeholder:'City',theme:'normal',value:this.props.form.city,onChange:this.handleBuildingFormChange.bind(this,'city')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'State / Zip'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{id:'state',placeholder:'State',value:this.props.form.state,theme:'normal',onChange:this.handleBuildingFormChange.bind(this,'state')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{id:'zip',placeholder:'Zip',value:this.props.form.zip,theme:'normal',onChange:this.handleBuildingFormChange.bind(this,'zip')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-continue '+(this.buildingFormValid()?'button-orange':'button-disabled'),type:'submit',value:'Add',disabled:!this.buildingFormValid()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'cancel-add-building',className:'btn button button-gray',value:'Cancel',onClick:this.handleClose,readOnly:true}))))));}}]);return NewBuildingModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{form:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_creation_store_selectors__["a" /* getBuildingForm */])(state),projectForm:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_creation_store_selectors__["g" /* getProjectForm */])(state),showNewBuildingModal:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_creation_store_selectors__["h" /* getShowNewBuildingModal */])(state)};})(NewBuildingModal));

/***/ }),
/* 2503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewProject_css__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewProject_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NewProject_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_check_circle_png__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_check_circle_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_check_circle_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_creation_store_selectors__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_store_actions__ = __webpack_require__(162);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Success=function(_Component){_inherits(Success,_Component);function Success(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Success);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Success.__proto__||Object.getPrototypeOf(Success)).call.apply(_ref,[this].concat(args))),_this),_this.handleContinue=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_store_actions__["f" /* goToProjectDetails */])(_this.props.newProjectId));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Success,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-success-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3_images_check_circle_png___default.a,className:'success-check',alt:'Success'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Project Created'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'success-message'},'Begin adding all other details to create your proposal.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-continue button-orange',type:'button',value:'Continue',onClick:this.handleContinue})));}}]);return Success;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{newProjectId:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_creation_store_selectors__["f" /* getNewProjectId */])(state)};})(Success));

/***/ }),
/* 2505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectDetails_css__ = __webpack_require__(2506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProjectDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_details_DetailsHeader__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_video_Video__ = __webpack_require__(2507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_logo_upload_LogoUpload__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_open_items_store_selectors__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_closeout_store_selectors__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_daily_report_log_store_selectors__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_rfi_log_store_actions__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_submittal_log_store_actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_daily_report_log_store_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_open_items_store_actions__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_project_closeout_store_actions__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_shared_details_DetailsInfoCard__ = __webpack_require__(2524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_proposal_ProjectProposal__ = __webpack_require__(2526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_admin_projects_details_project_directory_ProjectDirectory__ = __webpack_require__(2542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_admin_projects_details_project_meeting_minutes_ProjectMeetingMinutes__ = __webpack_require__(2563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_admin_projects_details_project_rfi_log_ProjectRfiLog__ = __webpack_require__(2575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_submittal_log_ProjectSubmittalLog__ = __webpack_require__(2603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_admin_projects_details_project_daily_report_log_ProjectDailyReportLog__ = __webpack_require__(2621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_admin_projects_details_project_documentation_ProjectDocumentation__ = __webpack_require__(2645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_admin_projects_details_project_open_items_ProjectOpenItemsModal__ = __webpack_require__(2976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_components_admin_projects_details_project_closeout_ProjectCloseout__ = __webpack_require__(2988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_admin_projects_details_project_coi_exps_CoiExps__ = __webpack_require__(3001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_domain_project_status_enum__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_images_group_png__ = __webpack_require__(3013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_images_group_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_images_group_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_images_group_selected_png__ = __webpack_require__(3014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_images_group_selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_images_group_selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_components_admin_projects_store_actions__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_query_string__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_components_admin_projects_details_project_proposal_store_actions__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_components_shared_pdf_viewer_PdfViewer__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectDetails=function(_Component){_inherits(ProjectDetails,_Component);function ProjectDetails(props){_classCallCheck(this,ProjectDetails);var _this=_possibleConstructorReturn(this,(ProjectDetails.__proto__||Object.getPrototypeOf(ProjectDetails)).call(this,props));_initialiseProps.call(_this);props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_actions__["a" /* initProjectDetails */])());props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_open_items_store_actions__["l" /* initOpenItemsCount */])());props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_daily_report_log_store_actions__["y" /* initSubDailyReportsCount */])());_this.showActions=__WEBPACK_IMPORTED_MODULE_36_domain_enterprise__["a" /* Enterprise */].showActions(props.currentUser);_this.subcontractor=__WEBPACK_IMPORTED_MODULE_44_services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_44_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);return _this;}_createClass(ProjectDetails,[{key:'componentDidMount',value:function componentDidMount(){this.loadProjectDetails(this.props);this.displayEmailPdf();}},{key:'UNSAFE_componentWillReceiveProps',value:function UNSAFE_componentWillReceiveProps(newProps){var newProjectId=__WEBPACK_IMPORTED_MODULE_3_numeral___default()(newProps.match.params.projectId).value();if(this.projectId!==newProjectId||this.props.location!==newProps.location){this.loadProjectDetails(newProps);}}},{key:'render',value:function render(){var _props=this.props,currentProject=_props.currentProject,closeoutPercentage=_props.closeoutPercentage,subDailyReportsCount=_props.subDailyReportsCount,showPdfViewer=_props.showPdfViewer;var projectApproved=currentProject&&this.projectApproved();var detailsInfoCards=currentProject&&this.detailsInfoCards()||[];var detailsInfoCardButtons=projectApproved&&this.detailsInfoCardButtons()||[];var detailsInfoExtraHeader=currentProject&&this.detailsInfoExtraHeader()||[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,currentProject&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['PROJECTS',currentProject.name]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_details_DetailsHeader__["a" /* default */],{leftHeader:{title:'PROJECT',value:currentProject.name},rightHeaders:currentProject.general_contractor.logo&&currentProject.general_contractor.logo.image?[[{value:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-preview-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_logo_upload_LogoUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],logos:[{preview:currentProject.general_contractor.logo.image.url,url:currentProject.general_contractor.logo.image.url}],readOnly:true}))}]]:[]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_shared_details_DetailsInfoCard__["a" /* default */],{itemLines:detailsInfoCards,headerButtons:detailsInfoCardButtons,leftHeaderExtraComponents:detailsInfoExtraHeader}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:projectApproved?'Schedule of Values':'Proposal'},{id:2,title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.navBarSelectedItem===2?__WEBPACK_IMPORTED_MODULE_34_images_group_selected_png___default.a:__WEBPACK_IMPORTED_MODULE_33_images_group_png___default.a,alt:'Directory'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'directory-title'},'Directory')),class:'navigation-directory',show:projectApproved},{id:7,title:'Documents',show:projectApproved,total:this.subcontractor||currentProject.advanced_document_view?null:currentProject.documents_count},{id:9,title:'COI',show:projectApproved},{id:3,title:'Meeting Minutes',show:projectApproved&&!this.subcontractor,total:currentProject.meetings_count},{id:4,title:'RFIs',show:projectApproved,total:currentProject.rfis_count},{id:5,title:'Submittals',show:projectApproved,total:currentProject.submittals_count},{id:6,title:'Daily Reports',show:projectApproved,total:this.subcontractor?subDailyReportsCount:currentProject.daily_reports_count},{id:8,title:'Closeout',show:projectApproved,total:closeoutPercentage+'%'}],selectedValue:this.props.navBarSelectedItem,onSelected:this.handleNavigationItemSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'})),this.props.navBarSelectedItem===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_proposal_ProjectProposal__["a" /* default */],null),this.props.navBarSelectedItem===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_components_admin_projects_details_project_directory_ProjectDirectory__["a" /* default */],null),this.props.navBarSelectedItem===3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_components_admin_projects_details_project_meeting_minutes_ProjectMeetingMinutes__["a" /* default */],null),this.props.navBarSelectedItem===4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_components_admin_projects_details_project_rfi_log_ProjectRfiLog__["a" /* default */],null),this.props.navBarSelectedItem===5&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_submittal_log_ProjectSubmittalLog__["a" /* default */],null),this.props.navBarSelectedItem===6&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_components_admin_projects_details_project_daily_report_log_ProjectDailyReportLog__["a" /* default */],null),this.props.navBarSelectedItem===7&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_components_admin_projects_details_project_documentation_ProjectDocumentation__["a" /* default */],null),this.props.navBarSelectedItem===8&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_components_admin_projects_details_project_closeout_ProjectCloseout__["a" /* default */],null),this.props.navBarSelectedItem===9&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_components_admin_projects_details_project_coi_exps_CoiExps__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_components_admin_projects_details_project_open_items_ProjectOpenItemsModal__["a" /* default */],null),showPdfViewer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_46_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:this.state.pdf_url,type:'url'},show:showPdfViewer,onClose:this.handlePdfViewerClose})));}}]);return ProjectDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.loadProjectDetails=function(props){var prevProjectId=_this2.projectId;_this2.projectId=__WEBPACK_IMPORTED_MODULE_3_numeral___default()(props.match.params.projectId).value();props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_actions__["b" /* loadProjectRequest */])(_this2.projectId)).then(function(response){var currentUser=props.currentUser,location=props.location,dispatch=props.dispatch;var state=location&&(location.state||__WEBPACK_IMPORTED_MODULE_39_query_string___default.a.parse(location.search));prevProjectId!==_this2.projectId&&_this2.handleNavigationItemSelect(null);if(state&&Object.keys(state).length>0){if(state.meetingId){_this2.handleNavigationItemSelect(3);dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__["m" /* openMeeting */])(_this2.projectId,state.meetingId));}else if(state.rfiId){_this2.handleNavigationItemSelect(4);dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_rfi_log_store_actions__["p" /* openRfi */])(_this2.projectId,state.rfiId));}else if(state.submittalId){_this2.handleNavigationItemSelect(5);dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_submittal_log_store_actions__["p" /* openSubmittal */])(_this2.projectId,state.submittalId,currentUser));}else if(state.dailyReportId){_this2.handleNavigationItemSelect(6);dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_daily_report_log_store_actions__["I" /* openDraftReport */])(_this2.projectId,state.dailyReportId,state.subDailyReport,true));}else if(state.fieldWorkOrderId){_this2.handleNavigationItemSelect(6);dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_daily_report_log_store_actions__["S" /* setDailyReportTab */])(3));dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_daily_report_log_store_actions__["D" /* loadFieldWorkOrdersRequest */])(_this2.projectId,1));dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_daily_report_log_store_actions__["J" /* openFieldWorkOrder */])(_this2.projectId,state.fieldWorkOrderId));}else if(state.projectOpenItemId){state.projectOpenItemCritical?_this2.onCriticalOpenItemsClick():_this2.onOpenItemsClick();dispatch(Object(__WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_open_items_store_actions__["m" /* loadOpenItem */])(_this2.projectId,state.projectOpenItemId));}else if(state.documentation){_this2.handleNavigationItemSelect(7);}else if(state.closeout){_this2.handleNavigationItemSelect(8);}else{_this2.handleNavigationItemSelect(1);}}else{_this2.handleNavigationItemSelect(1);}});props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_open_items_store_actions__["q" /* openItemsCount */])(_this2.projectId));props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_project_closeout_store_actions__["a" /* closeoutPercentage */])(_this2.projectId));_this2.subcontractor&&props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_daily_report_log_store_actions__["_14" /* subDailyReportsCount */])(_this2.projectId));};this.handleNavigationItemSelect=function(value){Object(__WEBPACK_IMPORTED_MODULE_4_services_utils_scroller_util__["c" /* simpleScrollToTop */])();_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_actions__["c" /* selectNavigationBar */])(value));};this.handleShowLostModal=function(e){var projStatus=__WEBPACK_IMPORTED_MODULE_32_domain_project_status_enum__["a" /* ProjectStatusEnum */].create(_this2.props.currentProject.status);if(__WEBPACK_IMPORTED_MODULE_32_domain_project_status_enum__["a" /* ProjectStatusEnum */].LOST.equals(projStatus)){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_42_components_admin_projects_details_project_proposal_store_actions__["r" /* setShowLostModal */])(true));}else if(__WEBPACK_IMPORTED_MODULE_32_domain_project_status_enum__["a" /* ProjectStatusEnum */].CANCELLED.equals(projStatus)){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_42_components_admin_projects_details_project_proposal_store_actions__["q" /* setShowCancelModal */])(true));}e&&e.stopPropagation();};this.projectApproved=function(){var projStatus=__WEBPACK_IMPORTED_MODULE_32_domain_project_status_enum__["a" /* ProjectStatusEnum */].create(_this2.props.currentProject.status);return!__WEBPACK_IMPORTED_MODULE_32_domain_project_status_enum__["a" /* ProjectStatusEnum */].PENDING.equals(projStatus);};this.detailsInfoCards=function(){var currentProject=_this2.props.currentProject;var detailsInfoCards=[['CLIENT',currentProject.client.company_name,_this2.showActions?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'edit-project-details',onClick:_this2.onEditClick},'Edit Details'):'']];currentProject.client.logo&&currentProject.client.logo.image&&detailsInfoCards.push([__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-preview-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_logo_upload_LogoUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],logos:[{preview:currentProject.client.logo.image.url,url:currentProject.client.logo.image.url}],readOnly:true}))]);detailsInfoCards.push(['ADDRESS',currentProject.building.location.street_address_1,currentProject.building.location.street_address_2,currentProject.building.location.city+', '+currentProject.building.location.state+' '+currentProject.building.location.zip],['INFO',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ','Sq. Footage: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38_components_shared_text_Number__["a" /* default */],{value:currentProject.sq_footage,format:'0,0'}),' ','ft.',' '),'Project #: '+currentProject.number]);if(currentProject.building.property_owner_name||currentProject.building.property_owner_address){detailsInfoCards.push(['PROPERTY OWNER',currentProject.building.property_owner_name,currentProject.building.property_owner_address&&currentProject.building.property_owner_address.street_address_1,currentProject.building.property_owner_address&&currentProject.building.property_owner_address.street_address_2,currentProject.building.property_owner_address&&''+currentProject.building.property_owner_address.city+(', '+currentProject.building.property_owner_address.state)+(', '+currentProject.building.property_owner_address.zip)]);}if(currentProject.vlog&&currentProject.vlog_start_date&&currentProject.vlog_end_date){detailsInfoCards.push([__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-vlog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'VLOG UPDATE',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vlog-dates'},__WEBPACK_IMPORTED_MODULE_45_moment___default()(currentProject.vlog_start_date).format('M/D')+'-',__WEBPACK_IMPORTED_MODULE_45_moment___default()(currentProject.vlog_end_date).format('M/D'),currentProject.walk_thru_url&&currentProject.walk_thru_url_preview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:currentProject.walk_thru_url,target:'_blank'},currentProject.walk_thru_url_preview)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_video_Video__["a" /* default */],{video:currentProject.vlog})))]);}return detailsInfoCards;};this.onCriticalOpenItemsClick=function(e){var _props2=_this2.props,currentProject=_props2.currentProject,dispatch=_props2.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_open_items_store_actions__["A" /* showOpenItemsModal */])(currentProject.id,1,true));e&&e.stopPropagation();};this.onOpenItemsClick=function(e){var _props3=_this2.props,currentProject=_props3.currentProject,dispatch=_props3.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_open_items_store_actions__["A" /* showOpenItemsModal */])(currentProject.id,1,false));e&&e.stopPropagation();};this.detailsInfoCardButtons=function(){var _props4=_this2.props,projectOpenItemsCount=_props4.projectOpenItemsCount,projectOpenItemsCritCount=_props4.projectOpenItemsCritCount;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Critical'+(projectOpenItemsCritCount!==null?'\xA0\xA0('+projectOpenItemsCritCount+')':''),onClick:_this2.onCriticalOpenItemsClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_components_shared_button_Button__["a" /* default */],{className:'button-blue-grey',label:'Open Items'+(projectOpenItemsCount!==null?'\xA0\xA0('+projectOpenItemsCount+')':''),onClick:_this2.onOpenItemsClick})];};this.detailsInfoExtraHeader=function(){var currentProject=_this2.props.currentProject;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-status'},currentProject.termination_reason&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41_react_bootstrap__["q" /* OverlayTrigger */],{placement:'bottom',overlay:_this2.tooltip(currentProject)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41_react_bootstrap__["b" /* Button */],{onClick:_this2.handleShowLostModal,className:'uppercase status-text '+currentProject.status+' btn button'},__WEBPACK_IMPORTED_MODULE_32_domain_project_status_enum__["a" /* ProjectStatusEnum */].create(currentProject.status).label.toUpperCase())),!currentProject.termination_reason&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41_react_bootstrap__["b" /* Button */],{className:'uppercase status-text '+currentProject.status+' btn button'},__WEBPACK_IMPORTED_MODULE_32_domain_project_status_enum__["a" /* ProjectStatusEnum */].create(currentProject.status).label.toUpperCase()),currentProject.bid_due_date&&!_this2.projectApproved()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bid-due-date'},' ','BID DUE DATE:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43_components_shared_text_Date__["a" /* default */],{className:'bid-due-date-date',value:currentProject.bid_due_date,format:'MM/DD/YY'})))];};this.onEditClick=function(){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_37_components_admin_projects_store_actions__["e" /* goToEditProject */])(_this2.props.currentProject.id));};this.tooltip=function(currentProject){var tooltipData=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41_react_bootstrap__["u" /* Tooltip */],{placement:'right',className:'in',id:'tooltip-right'},currentProject.termination_category,' ',currentProject.termination_reason);return tooltipData;};this.displayEmailPdf=function(){var params=new URL(document.location).searchParams;if(params.get('show_pdf_view')==='true'){_this2.setState({pdf_url:params.get('pdf_url')});_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_actions__["e" /* setShowPdfViewer */])(true));}};this.handlePdfViewerClose=function(){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_actions__["e" /* setShowPdfViewer */])(false));};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),navBarSelectedItem:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_store_selectors__["b" /* getNavBarSelectedItem */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_35_selectors_authentication__["d" /* getCurrentUser */])(state),projectOpenItemsCount:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_open_items_store_selectors__["l" /* getProjectOpenItemsCount */])(state),projectOpenItemsCritCount:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_open_items_store_selectors__["m" /* getProjectOpenItemsCritCount */])(state),closeoutPercentage:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_closeout_store_selectors__["i" /* getCloseoutPercentage */])(state),subDailyReportsCount:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_daily_report_log_store_selectors__["L" /* getSubDailyReportsCount */])(state),showPdfViewer:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_store_selectors__["c" /* getShowPdfViewer */])(state)};})(ProjectDetails));

/***/ }),
/* 2506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Video_css__ = __webpack_require__(2508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Video_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Video_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_VideoModal__ = __webpack_require__(981);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Video=function(_Component){_inherits(Video,_Component);function Video(props){_classCallCheck(this,Video);var _this=_possibleConstructorReturn(this,(Video.__proto__||Object.getPrototypeOf(Video)).call(this,props));_this.toggleVideoModal=function(){var showVideoModal=_this.state.showVideoModal;_this.setState({showVideoModal:!showVideoModal});};_this.state={showVideoModal:false};return _this;}_createClass(Video,[{key:'render',value:function render(){var video=this.props.video;var showVideoModal=this.state.showVideoModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-preview',onClick:this.toggleVideoModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:video.video.thumb.url,alt:'Video Preview'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-overlay'},__WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(video.duration*1000).format('m:ss'))),showVideoModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_VideoModal__["a" /* default */],{autoPlay:true,show:showVideoModal,videoSrc:video.video.url,onHide:this.toggleVideoModal}));}}]);return Video;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Video.propTypes={video:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired};/* harmony default export */ __webpack_exports__["a"] = (Video);

/***/ }),
/* 2508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return meetingInfosApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MeetingInfosApi=function(_BaseApi){_inherits(MeetingInfosApi,_BaseApi);function MeetingInfosApi(){_classCallCheck(this,MeetingInfosApi);return _possibleConstructorReturn(this,(MeetingInfosApi.__proto__||Object.getPrototypeOf(MeetingInfosApi)).apply(this,arguments));}_createClass(MeetingInfosApi,[{key:'getMeetingInfo',value:function getMeetingInfo(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/meeting_info').then(function(response){return{ok:true,meetingInfo:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createMeetingInfo',value:function createMeetingInfo(projectId,values){var data=this.meetingInfoParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/projects/'+projectId+'/meeting_info',data).then(function(response){return{ok:true,meetingInfo:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateMeetingInfo',value:function updateMeetingInfo(projectId,values){var data=this.meetingInfoParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/meeting_info',data).then(function(response){return{ok:true,meetingInfo:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'meetingInfoParams',value:function meetingInfoParams(values){return{meeting_info:{day_of_week:values.dayOfWeek,starts_at:values.startsAt,ends_at:values.endsAt,time_zone:values.timeZone,meeting_location:values.meetingLocation,site_walk:values.siteWalk,phone_number:values.phoneNumber,code:values.code,host_pin:values.hostPin,web_link:values.webLink,link_title:values.linkTitle}};}}]);return MeetingInfosApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var meetingInfosApi=new MeetingInfosApi();

/***/ }),
/* 2510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return meetingsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MeetingsApi=function(_BaseApi){_inherits(MeetingsApi,_BaseApi);function MeetingsApi(){_classCallCheck(this,MeetingsApi);return _possibleConstructorReturn(this,(MeetingsApi.__proto__||Object.getPrototypeOf(MeetingsApi)).apply(this,arguments));}_createClass(MeetingsApi,[{key:'getMeetings',value:function getMeetings(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/meetings').then(function(response){return{ok:true,meetings:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getMeeting',value:function getMeeting(projectId,meetingId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/meetings/'+meetingId).then(function(response){return{ok:true,meeting:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'deleteMeeting',value:function deleteMeeting(projectId,meetingId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/projects/'+projectId+'/meetings/'+meetingId).then(function(response){return{ok:true,meetings:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getMeetingPdf',value:function getMeetingPdf(projectId,meetingId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/meetings/'+meetingId+'/print',{responseType:'blob'}).then(function(response){return{ok:true,pdf:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createMeeting',value:function createMeeting(projectId,values){var data=this.meetingParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/projects/'+projectId+'/meetings',data).then(function(response){return{ok:true,meeting:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateMeeting',value:function updateMeeting(projectId,meetingId,values){var data=this.meetingParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/meetings/'+meetingId,data).then(function(response){return{ok:true,meeting:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'meetingParams',value:function meetingParams(values){return{meeting:{status:values.status,meeting_date:values.meetingDate,attendee_ids:values.attendeeIds,meeting_items_attributes:values.meetingItems.map(function(item){return{id:item.id,code:item.code,meeting_category_id:item.meetingCategoryId,new_item:item.newItem,info:item.info,new_info:item.newInfo,resolved:item.resolved,resolved_note:item.resolvedNote,_destroy:item.destroy,contributor_ids:item.contributorIds};})}};}}]);return MeetingsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var meetingsApi=new MeetingsApi();

/***/ }),
/* 2511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return meetingCategoriesApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MeetingCategoriesApi=function(_BaseApi){_inherits(MeetingCategoriesApi,_BaseApi);function MeetingCategoriesApi(){_classCallCheck(this,MeetingCategoriesApi);return _possibleConstructorReturn(this,(MeetingCategoriesApi.__proto__||Object.getPrototypeOf(MeetingCategoriesApi)).apply(this,arguments));}_createClass(MeetingCategoriesApi,[{key:'getMeetingCategories',value:function getMeetingCategories(){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/meeting_categories').then(function(response){return{ok:true,meetingCategories:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return MeetingCategoriesApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var meetingCategoriesApi=new MeetingCategoriesApi();

/***/ }),
/* 2512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rfiQuestionsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RfiQuestionsApi=function(_BaseApi){_inherits(RfiQuestionsApi,_BaseApi);function RfiQuestionsApi(){_classCallCheck(this,RfiQuestionsApi);return _possibleConstructorReturn(this,(RfiQuestionsApi.__proto__||Object.getPrototypeOf(RfiQuestionsApi)).apply(this,arguments));}_createClass(RfiQuestionsApi,[{key:'getNotes',value:function getNotes(questionId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/rfi_questions/'+questionId+'/notes').then(function(response){return{ok:true,notes:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'markNotesRead',value:function markNotesRead(questionId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/rfi_questions/'+questionId+'/notes/mark_all_read').then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createNote',value:function createNote(questionId,content){var headers={headers:{'Content-Type':'multipart/form-data'}};var apiPayload=new FormData();apiPayload.append('note[content]',content.note);var index=0;if(content.images&&content.images.length>0){content.images.filter(function(image){return!image.id;}).forEach(function(image){apiPayload.append('note[images_attributes]['+index+'][image]',image.file,image.file.name);index++;});}index=0;if(content.documents&&content.documents.length>0){content.documents.filter(function(doc){return!doc.id;}).forEach(function(doc){apiPayload.append('note[documents_attributes]['+index+'][document]',doc.file,doc.file.name);index++;});}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/rfi_questions/'+questionId+'/notes',apiPayload,headers).then(function(response){return{ok:true,note:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return RfiQuestionsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var rfiQuestionsApi=new RfiQuestionsApi();

/***/ }),
/* 2513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rfiAddlAssigneesApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RfiAddlAssigneesApi=function(_BaseApi){_inherits(RfiAddlAssigneesApi,_BaseApi);function RfiAddlAssigneesApi(){_classCallCheck(this,RfiAddlAssigneesApi);return _possibleConstructorReturn(this,(RfiAddlAssigneesApi.__proto__||Object.getPrototypeOf(RfiAddlAssigneesApi)).apply(this,arguments));}_createClass(RfiAddlAssigneesApi,[{key:'updaterfiAddlAssignee',value:function updaterfiAddlAssignee(id,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var data=this.rfiAddlAssigneeParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/rfi_addl_assignees/'+id,data,headers).then(function(response){return{ok:true,rfiAddlAssignee:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'rfiAddlAssigneeParams',value:function rfiAddlAssigneeParams(values){var resImgsIndex=0;var resDocsIndex=0;var apiPayload=new FormData();apiPayload.append('rfi_addl_assignee[response]',values.response||'');values.resImages.filter(function(img){return img.file;}).forEach(function(img){var file=img.file;apiPayload.append('rfi_addl_assignee[response_images_attributes]['+resImgsIndex+'][image]',file,file.name);resImgsIndex++;});values.resDocs.filter(function(doc){return doc.file;}).forEach(function(doc){var file=doc.file;apiPayload.append('rfi_addl_assignee[response_documents_attributes]['+resDocsIndex+'][document]',file,file.name);resDocsIndex++;});values.resImagesDelete.filter(function(img){return img.id;}).forEach(function(img){apiPayload.append('rfi_addl_assignee[response_images_attributes]['+resImgsIndex+'][id]',img.id);apiPayload.append('rfi_addl_assignee[response_images_attributes]['+resImgsIndex+'][_destroy]',true);resImgsIndex++;});values.resDocsDelete.filter(function(doc){return doc.id;}).forEach(function(doc){apiPayload.append('rfi_addl_assignee[response_documents_attributes]['+resDocsIndex+'][id]',doc.id);apiPayload.append('rfi_addl_assignee[response_documents_attributes]['+resDocsIndex+'][_destroy]',true);resDocsIndex++;});return apiPayload;}}]);return RfiAddlAssigneesApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var rfiAddlAssigneesApi=new RfiAddlAssigneesApi();

/***/ }),
/* 2514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return submittalAddlAssigneesApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubmittalAddlAssigneesApi=function(_BaseApi){_inherits(SubmittalAddlAssigneesApi,_BaseApi);function SubmittalAddlAssigneesApi(){_classCallCheck(this,SubmittalAddlAssigneesApi);return _possibleConstructorReturn(this,(SubmittalAddlAssigneesApi.__proto__||Object.getPrototypeOf(SubmittalAddlAssigneesApi)).apply(this,arguments));}_createClass(SubmittalAddlAssigneesApi,[{key:'updateSubmittalAddlAssignee',value:function updateSubmittalAddlAssignee(id,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var data=this.submittalAddlAssigneeParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/submittal_addl_assignees/'+id,data,headers).then(function(response){return{ok:true,submittalAddlAssignee:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'submittalAddlAssigneeParams',value:function submittalAddlAssigneeParams(values){var resImgsIndex=0;var resDocsIndex=0;var apiPayload=new FormData();apiPayload.append('submittal_addl_assignee[stamp_action]',values.stampAction);values.resImages.filter(function(img){return img.file;}).forEach(function(img){var file=img.file;apiPayload.append('submittal_addl_assignee[response_images_attributes]['+resImgsIndex+'][image]',file,file.name);resImgsIndex++;});values.resDocs.filter(function(doc){return doc.file;}).forEach(function(doc){var file=doc.file;apiPayload.append('submittal_addl_assignee[response_documents_attributes]['+resDocsIndex+'][document]',file,file.name);resDocsIndex++;});values.resImagesDelete.filter(function(img){return img.id;}).forEach(function(img){apiPayload.append('submittal_addl_assignee[response_images_attributes]['+resImgsIndex+'][id]',img.id);apiPayload.append('submittal_addl_assignee[response_images_attributes]['+resImgsIndex+'][_destroy]',true);resImgsIndex++;});values.resDocsDelete.filter(function(doc){return doc.id;}).forEach(function(doc){apiPayload.append('submittal_addl_assignee[response_documents_attributes]['+resDocsIndex+'][id]',doc.id);apiPayload.append('submittal_addl_assignee[response_documents_attributes]['+resDocsIndex+'][_destroy]',true);resDocsIndex++;});return apiPayload;}}]);return SubmittalAddlAssigneesApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var submittalAddlAssigneesApi=new SubmittalAddlAssigneesApi();

/***/ }),
/* 2515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dailyReportsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DailyReportsApi=function(_BaseApi){_inherits(DailyReportsApi,_BaseApi);function DailyReportsApi(){_classCallCheck(this,DailyReportsApi);return _possibleConstructorReturn(this,(DailyReportsApi.__proto__||Object.getPrototypeOf(DailyReportsApi)).apply(this,arguments));}_createClass(DailyReportsApi,[{key:'getDailyReports',value:function getDailyReports(projectId,currentPage){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/daily_reports?page='+currentPage).then(function(response){return{ok:true,dailyReports:response.data,total:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['per-page']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getDailyReportLogPdf',value:function getDailyReportLogPdf(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/daily_report_log/print',{responseType:'blob'}).then(function(response){return{ok:true,dailyReportLogPdf:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'addDailyReport',value:function addDailyReport(values,reportDate,projectId,generalContactorName){var data={daily_report:{report_date:reportDate,daily_report_entries_attributes:values,gc_staff_on_site:!!generalContactorName}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/projects/'+projectId+'/daily_reports',data).then(function(response){return{ok:true,dailyReport:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateDailyReport',value:function updateDailyReport(values,projectId,dailyReportId){var data={daily_report:{report_date:values.reportDate,gc_staff_on_site:values.gcStaffOnSite,inspections:values.inspections,deliveries:values.deliveries,received_submittal_ids:values.received_submittal_ids,visitors:values.visitors,phone_calls:values.phone_calls,status:values.status,daily_report_entries_attributes:values.dailyReportEntriesAttributes,is_safety_accepted:values.is_safety_accepted,safety:values.safety}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/daily_reports/'+dailyReportId,data).then(function(response){return{ok:true,dailyReport:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'duplicateDailyReport',value:function duplicateDailyReport(values,projectId,dailyReportId){var data={daily_report:{report_date:values.reportDate}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/projects/'+projectId+'/daily_reports/'+dailyReportId+'/duplicate',data).then(function(response){return{ok:true,dailyReport:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'deleteDailyReport',value:function deleteDailyReport(projectId,dailyReportId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/projects/'+projectId+'/daily_reports/'+dailyReportId).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getDailyReportPdf',value:function getDailyReportPdf(projectId,dailyReportId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/daily_reports/'+dailyReportId+'/print',{responseType:'blob'}).then(function(response){return{ok:true,reportPdf:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getDailyReport',value:function getDailyReport(projectId,id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/daily_reports/'+id).then(function(response){return{ok:true,dailyReport:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'addDailyReportMembers',value:function addDailyReportMembers(values,projectId,reportId){var headers={headers:{'Content-Type':'multipart/form-data'}};var data=this.addDailyReportMembersParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/daily_reports/'+reportId,data,headers).then(function(response){return{ok:true,dailyReport:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'addDailyReportMembersParams',value:function addDailyReportMembersParams(values){var apiPayload=new FormData();if(values.gc_staff_members_attributes){values.gc_staff_members_attributes.forEach(function(member,index){if(member.id){apiPayload.append('daily_report[gc_staff_members_attributes]['+index+'][id]',member.id);}if(member._destroy){apiPayload.append('daily_report[gc_staff_members_attributes]['+index+'][_destroy]',member._destroy);}else{apiPayload.append('daily_report[gc_staff_members_attributes]['+index+'][user_id]',member.user_id);apiPayload.append('daily_report[gc_staff_members_attributes]['+index+'][floor]',member.floor);apiPayload.append('daily_report[gc_staff_members_attributes]['+index+'][area]',member.area);apiPayload.append('daily_report[gc_staff_members_attributes]['+index+'][supervisor_task_other]',member.supervisor_task_other);apiPayload.append('daily_report[gc_staff_members_attributes]['+index+'][comments]',member.comments);apiPayload.append('daily_report[gc_staff_members_attributes]['+index+'][hours_worked]',member.hours_worked);apiPayload.append('daily_report[gc_staff_members_attributes]['+index+'][started_at]',member.started_at);apiPayload.append('daily_report[gc_staff_members_attributes]['+index+'][ended_at]',member.ended_at);if(member.supervisor_task_ids&&member.supervisor_task_ids.length>0){member.supervisor_task_ids.forEach(function(id){apiPayload.append('daily_report[gc_staff_members_attributes]['+index+'][supervisor_task_ids][]',id);});}else{apiPayload.append('daily_report[gc_staff_members_attributes]['+index+'][supervisor_task_ids][]',[]);}}});}var gcImagesIndex=0;if(values.gcImages&&values.gcImages.length>0){values.gcImages.forEach(function(image){apiPayload.append('daily_report[images_attributes]['+gcImagesIndex+'][image]',image.file,image.file.name);gcImagesIndex++;});}if(values.gcDeletedImages&&values.gcDeletedImages.length>0){values.gcDeletedImages.forEach(function(image){apiPayload.append('daily_report[images_attributes]['+gcImagesIndex+'][id]',image.id);apiPayload.append('daily_report[images_attributes]['+gcImagesIndex+'][_destroy]',true);gcImagesIndex++;});}if(values.project_open_item_attributes){var _values$project_open_=values.project_open_item_attributes,id=_values$project_open_.id,_destroy=_values$project_open_._destroy,assignee_id=_values$project_open_.assignee_id,recipient_ids=_values$project_open_.recipient_ids,description=_values$project_open_.description,resolve_by=_values$project_open_.resolve_by,critical=_values$project_open_.critical,images_attributes=_values$project_open_.images_attributes,deleted_images_attributes=_values$project_open_.deleted_images_attributes,documents_attributes=_values$project_open_.documents_attributes,deleted_documents_attributes=_values$project_open_.deleted_documents_attributes;if(id){apiPayload.append('daily_report[project_open_item_attributes][id]',id);}if(_destroy){apiPayload.append('daily_report[project_open_item_attributes][_destroy]',_destroy);}else{apiPayload.append('daily_report[project_open_item_attributes][assignee_id]',assignee_id);apiPayload.append('daily_report[project_open_item_attributes][description]',description);apiPayload.append('daily_report[project_open_item_attributes][resolve_by]',resolve_by);apiPayload.append('daily_report[project_open_item_attributes][critical]',critical);if(recipient_ids&&recipient_ids.length>0){recipient_ids.forEach(function(rcptId){apiPayload.append('daily_report[project_open_item_attributes][recipient_ids][]',rcptId);});}else{apiPayload.append('daily_report[project_open_item_attributes][recipient_ids][]',[]);}var index=0;if(images_attributes&&images_attributes.length>0){images_attributes.forEach(function(image){apiPayload.append('daily_report[project_open_item_attributes][images_attributes]['+index+'][image]',image.file,image.file.name);index++;});}if(deleted_images_attributes&&deleted_images_attributes.length>0){deleted_images_attributes.forEach(function(image){apiPayload.append('daily_report[project_open_item_attributes][images_attributes]['+index+'][id]',image.id);apiPayload.append('daily_report[project_open_item_attributes][images_attributes]['+index+'][_destroy]',true);index++;});}index=0;if(documents_attributes&&documents_attributes.length>0){documents_attributes.forEach(function(doc){apiPayload.append('daily_report[project_open_item_attributes][documents_attributes]['+index+'][document]',doc.file,doc.file.name);index++;});}if(deleted_documents_attributes&&deleted_documents_attributes.length>0){deleted_documents_attributes.forEach(function(doc){apiPayload.append('daily_report[project_open_item_attributes][documents_attributes]['+index+'][id]',doc.id);apiPayload.append('daily_report[project_open_item_attributes][documents_attributes]['+index+'][_destroy]',true);index++;});}}}return apiPayload;}}]);return DailyReportsApi;}(__WEBPACK_IMPORTED_MODULE_2__base_api__["a" /* default */]);var dailyReportsApi=new DailyReportsApi();

/***/ }),
/* 2516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subDailyReportsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubDailyReportsApi=function(_BaseApi){_inherits(SubDailyReportsApi,_BaseApi);function SubDailyReportsApi(){_classCallCheck(this,SubDailyReportsApi);return _possibleConstructorReturn(this,(SubDailyReportsApi.__proto__||Object.getPrototypeOf(SubDailyReportsApi)).apply(this,arguments));}_createClass(SubDailyReportsApi,[{key:'getDailyReports',value:function getDailyReports(projectId,currentPage){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/sub_daily_reports?page='+currentPage).then(function(response){return{ok:true,dailyReports:response.data,total:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['per-page']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getDailyReportsCount',value:function getDailyReportsCount(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/sub_daily_reports/count').then(function(response){return{ok:true,total:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(response.headers['total']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getDailyReportLogPdf',value:function getDailyReportLogPdf(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/sub_daily_report_log/print',{responseType:'blob'}).then(function(response){return{ok:true,dailyReportLogPdf:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'addDailyReport',value:function addDailyReport(values,reportDate,projectId){var data={sub_daily_report:{report_date:reportDate,sub_daily_report_entries_attributes:values}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/projects/'+projectId+'/sub_daily_reports',data).then(function(response){return{ok:true,dailyReport:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateDailyReport',value:function updateDailyReport(values,projectId,dailyReportId){var data={sub_daily_report:{report_date:values.reportDate,gc_staff_on_site:values.gcStaffOnSite,inspections:values.inspections,deliveries:values.deliveries,received_submittal_ids:values.received_submittal_ids,visitors:values.visitors,phone_calls:values.phone_calls,status:values.status,sub_daily_report_entries_attributes:values.dailyReportEntriesAttributes}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/sub_daily_reports/'+dailyReportId,data).then(function(response){return{ok:true,dailyReport:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'duplicateDailyReport',value:function duplicateDailyReport(values,projectId,dailyReportId){var data={sub_daily_report:{report_date:values.reportDate}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/projects/'+projectId+'/sub_daily_reports/'+dailyReportId+'/duplicate',data).then(function(response){return{ok:true,dailyReport:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getDailyReport',value:function getDailyReport(projectId,id){var loadingDisabled=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/sub_daily_reports/'+id,{loadingDisabled:loadingDisabled}).then(function(response){return{ok:true,dailyReport:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getDailyReportPdf',value:function getDailyReportPdf(projectId,dailyReportId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/sub_daily_reports/'+dailyReportId+'/print',{responseType:'blob'}).then(function(response){return{ok:true,reportPdf:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'deleteDailyReport',value:function deleteDailyReport(projectId,dailyReportId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/projects/'+projectId+'/sub_daily_reports/'+dailyReportId).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return SubDailyReportsApi;}(__WEBPACK_IMPORTED_MODULE_2__base_api__["a" /* default */]);var subDailyReportsApi=new SubDailyReportsApi();

/***/ }),
/* 2517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dailyReportsEntriesApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DailyReportsEntriesApi=function(_BaseApi){_inherits(DailyReportsEntriesApi,_BaseApi);function DailyReportsEntriesApi(){_classCallCheck(this,DailyReportsEntriesApi);return _possibleConstructorReturn(this,(DailyReportsEntriesApi.__proto__||Object.getPrototypeOf(DailyReportsEntriesApi)).apply(this,arguments));}_createClass(DailyReportsEntriesApi,[{key:'dailyReportEntryParams',value:function dailyReportEntryParams(values){var apiPayload=new FormData();apiPayload.append('daily_report_entry[floor]',values.floor);apiPayload.append('daily_report_entry[area]',values.area);apiPayload.append('daily_report_entry[preset_task_other]',values.preset_task_other);apiPayload.append('daily_report_entry[work_performed]',values.work_performed);if(values.project_open_item_attributes){var _values$project_open_=values.project_open_item_attributes,id=_values$project_open_.id,_destroy=_values$project_open_._destroy,assignee_id=_values$project_open_.assignee_id,recipient_ids=_values$project_open_.recipient_ids,description=_values$project_open_.description,resolve_by=_values$project_open_.resolve_by,critical=_values$project_open_.critical,images_attributes=_values$project_open_.images_attributes,deleted_images_attributes=_values$project_open_.deleted_images_attributes,documents_attributes=_values$project_open_.documents_attributes,deleted_documents_attributes=_values$project_open_.deleted_documents_attributes;if(id){apiPayload.append('daily_report_entry[project_open_item_attributes][id]',id);}if(_destroy){apiPayload.append('daily_report_entry[project_open_item_attributes][_destroy]',_destroy);}else{apiPayload.append('daily_report_entry[project_open_item_attributes][assignee_id]',assignee_id);apiPayload.append('daily_report_entry[project_open_item_attributes][description]',description);apiPayload.append('daily_report_entry[project_open_item_attributes][resolve_by]',resolve_by);apiPayload.append('daily_report_entry[project_open_item_attributes][critical]',critical);if(recipient_ids&&recipient_ids.length>0){recipient_ids.forEach(function(rcptId){apiPayload.append('daily_report_entry[project_open_item_attributes][recipient_ids][]',rcptId);});}else{apiPayload.append('daily_report_entry[project_open_item_attributes][recipient_ids][]',[]);}var index=0;if(images_attributes&&images_attributes.length>0){images_attributes.forEach(function(image){apiPayload.append('daily_report_entry[project_open_item_attributes][images_attributes]['+index+'][image]',image.file,image.file.name);index++;});}if(deleted_images_attributes&&deleted_images_attributes.length>0){deleted_images_attributes.forEach(function(image){apiPayload.append('daily_report_entry[project_open_item_attributes][images_attributes]['+index+'][id]',image.id);apiPayload.append('daily_report_entry[project_open_item_attributes][images_attributes]['+index+'][_destroy]',true);index++;});}index=0;if(documents_attributes&&documents_attributes.length>0){documents_attributes.forEach(function(doc){apiPayload.append('daily_report_entry[project_open_item_attributes][documents_attributes]['+index+'][document]',doc.file,doc.file.name);index++;});}if(deleted_documents_attributes&&deleted_documents_attributes.length>0){deleted_documents_attributes.forEach(function(doc){apiPayload.append('daily_report_entry[project_open_item_attributes][documents_attributes]['+index+'][id]',doc.id);apiPayload.append('daily_report_entry[project_open_item_attributes][documents_attributes]['+index+'][_destroy]',true);index++;});}}}if(values.comments){apiPayload.append('daily_report_entry[comments]',values.comments);}var techIndex=0;if(values.technicians_attributes&&values.technicians_attributes.length>0){values.technicians_attributes.forEach(function(attr){if(attr.id){apiPayload.append('daily_report_entry[technicians_attributes]['+techIndex+'][id]',attr.id);}apiPayload.append('daily_report_entry[technicians_attributes]['+techIndex+'][hours_worked]',attr.hours_worked);apiPayload.append('daily_report_entry[technicians_attributes]['+techIndex+'][started_at]',attr.started_at);apiPayload.append('daily_report_entry[technicians_attributes]['+techIndex+'][ended_at]',attr.ended_at);techIndex++;});}if(values.deletedTechnicians&&values.deletedTechnicians.length>0){values.deletedTechnicians.forEach(function(attr){apiPayload.append('daily_report_entry[technicians_attributes]['+techIndex+'][id]',attr.id);apiPayload.append('daily_report_entry[technicians_attributes]['+techIndex+'][_destroy]',true);techIndex++;});}if(values.preset_task_ids&&values.preset_task_ids.length>0){values.preset_task_ids.forEach(function(id){apiPayload.append('daily_report_entry[preset_task_ids][]',id);});}else{apiPayload.append('daily_report_entry[preset_task_ids][]',[]);}if(values.images_attributes&&values.images_attributes.length>0){values.images_attributes.forEach(function(image,index){apiPayload.append('daily_report_entry[images_attributes]['+index+'][image]',image.file,image.file.name);});}if(values.deleted_images_attributes&&values.deleted_images_attributes.length>0){values.deleted_images_attributes.forEach(function(image,index){apiPayload.append('daily_report_entry[images_attributes]['+index+'][id]',image.id);apiPayload.append('daily_report_entry[images_attributes]['+index+'][_destroy]',true);});}return apiPayload;}},{key:'updateDailyReportEntry',value:function updateDailyReportEntry(values,reportId){var headers={headers:{'Content-Type':'multipart/form-data'}};var data=this.dailyReportEntryParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/daily_report_entries/'+reportId,data,headers).then(function(response){return{ok:true,dailyReport:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'postDailyReportEntry',value:function postDailyReportEntry(entryId){var apiPayload={daily_report_entry:{daily_report_entry_id:entryId}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/daily_report_entries',apiPayload).then(function(response){return{ok:true,newEntry:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'deleteDailyReportEntry',value:function deleteDailyReportEntry(entryId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/daily_report_entries/'+entryId).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return DailyReportsEntriesApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var dailyReportsEntriesApi=new DailyReportsEntriesApi();

/***/ }),
/* 2518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subDailyReportsEntriesApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubDailyReportsEntriesApi=function(_BaseApi){_inherits(SubDailyReportsEntriesApi,_BaseApi);function SubDailyReportsEntriesApi(){_classCallCheck(this,SubDailyReportsEntriesApi);return _possibleConstructorReturn(this,(SubDailyReportsEntriesApi.__proto__||Object.getPrototypeOf(SubDailyReportsEntriesApi)).apply(this,arguments));}_createClass(SubDailyReportsEntriesApi,[{key:'dailyReportEntryParams',value:function dailyReportEntryParams(values){var apiPayload=new FormData();apiPayload.append('sub_daily_report_entry[floor]',values.floor);apiPayload.append('sub_daily_report_entry[area]',values.area);if(values.project_open_item_attributes){var _values$project_open_=values.project_open_item_attributes,id=_values$project_open_.id,_destroy=_values$project_open_._destroy,assignee_id=_values$project_open_.assignee_id,recipient_ids=_values$project_open_.recipient_ids,description=_values$project_open_.description,resolve_by=_values$project_open_.resolve_by,critical=_values$project_open_.critical,images_attributes=_values$project_open_.images_attributes,deleted_images_attributes=_values$project_open_.deleted_images_attributes,documents_attributes=_values$project_open_.documents_attributes,deleted_documents_attributes=_values$project_open_.deleted_documents_attributes;if(id){apiPayload.append('sub_daily_report_entry[project_open_item_attributes][id]',id);}if(_destroy){apiPayload.append('sub_daily_report_entry[project_open_item_attributes][_destroy]',_destroy);}else{apiPayload.append('sub_daily_report_entry[project_open_item_attributes][assignee_id]',assignee_id);apiPayload.append('sub_daily_report_entry[project_open_item_attributes][description]',description);apiPayload.append('sub_daily_report_entry[project_open_item_attributes][resolve_by]',resolve_by);apiPayload.append('sub_daily_report_entry[project_open_item_attributes][critical]',critical);if(recipient_ids&&recipient_ids.length>0){recipient_ids.forEach(function(rcptId){apiPayload.append('sub_daily_report_entry[project_open_item_attributes][recipient_ids][]',rcptId);});}else{apiPayload.append('sub_daily_report_entry[project_open_item_attributes][recipient_ids][]',[]);}var index=0;if(images_attributes&&images_attributes.length>0){images_attributes.forEach(function(image){apiPayload.append('sub_daily_report_entry[project_open_item_attributes][images_attributes]['+index+'][image]',image.file,image.file.name);index++;});}if(deleted_images_attributes&&deleted_images_attributes.length>0){deleted_images_attributes.forEach(function(image){apiPayload.append('sub_daily_report_entry[project_open_item_attributes][images_attributes]['+index+'][id]',image.id);apiPayload.append('sub_daily_report_entry[project_open_item_attributes][images_attributes]['+index+'][_destroy]',true);index++;});}index=0;if(documents_attributes&&documents_attributes.length>0){documents_attributes.forEach(function(doc){apiPayload.append('sub_daily_report_entry[project_open_item_attributes][documents_attributes]['+index+'][document]',doc.file,doc.file.name);index++;});}if(deleted_documents_attributes&&deleted_documents_attributes.length>0){deleted_documents_attributes.forEach(function(doc){apiPayload.append('sub_daily_report_entry[project_open_item_attributes][documents_attributes]['+index+'][id]',doc.id);apiPayload.append('sub_daily_report_entry[project_open_item_attributes][documents_attributes]['+index+'][_destroy]',true);index++;});}}}if(values.field_work_order_attributes){var _values$field_work_or=values.field_work_order_attributes,_id=_values$field_work_or.id,_destroy2=_values$field_work_or._destroy,number=_values$field_work_or.number,preset_task_ids=_values$field_work_or.preset_task_ids,preset_task_other=_values$field_work_or.preset_task_other,work_performed=_values$field_work_or.work_performed,comments=_values$field_work_or.comments,start_date=_values$field_work_or.start_date,completion_date=_values$field_work_or.completion_date,labor=_values$field_work_or.labor,materials=_values$field_work_or.materials;if(_id){apiPayload.append('sub_daily_report_entry[field_work_order_attributes][id]',_id);}if(_destroy2){apiPayload.append('sub_daily_report_entry[field_work_order_attributes][_destroy]',_destroy2);}else{apiPayload.append('sub_daily_report_entry[field_work_order_attributes][number]',number);apiPayload.append('sub_daily_report_entry[field_work_order_attributes][preset_task_other]',preset_task_other);apiPayload.append('sub_daily_report_entry[field_work_order_attributes][work_performed]',work_performed);apiPayload.append('sub_daily_report_entry[field_work_order_attributes][comments]',comments);apiPayload.append('sub_daily_report_entry[field_work_order_attributes][start_date]',start_date);apiPayload.append('sub_daily_report_entry[field_work_order_attributes][completion_date]',completion_date);apiPayload.append('sub_daily_report_entry[field_work_order_attributes][labor]',labor);apiPayload.append('sub_daily_report_entry[field_work_order_attributes][materials]',materials);if(preset_task_ids&&preset_task_ids.length>0){preset_task_ids.forEach(function(taskId){apiPayload.append('sub_daily_report_entry[field_work_order_attributes][preset_task_ids][]',taskId);});}else{apiPayload.append('sub_daily_report_entry[field_work_order_attributes][preset_task_ids][]',[]);}}}var techIndex=0;if(values.technicians_attributes&&values.technicians_attributes.length>0){values.technicians_attributes.forEach(function(attr){if(attr.id){apiPayload.append('sub_daily_report_entry[sub_daily_report_teches_attributes]['+techIndex+'][id]',attr.id);}apiPayload.append('sub_daily_report_entry[sub_daily_report_teches_attributes]['+techIndex+'][hours_worked]',attr.hours_worked);apiPayload.append('sub_daily_report_entry[sub_daily_report_teches_attributes]['+techIndex+'][started_at]',attr.started_at);apiPayload.append('sub_daily_report_entry[sub_daily_report_teches_attributes]['+techIndex+'][ended_at]',attr.ended_at);apiPayload.append('sub_daily_report_entry[sub_daily_report_teches_attributes]['+techIndex+'][preset_task_other]',attr.custom_task);apiPayload.append('sub_daily_report_entry[sub_daily_report_teches_attributes]['+techIndex+'][location]',attr.location);apiPayload.append('sub_daily_report_entry[sub_daily_report_teches_attributes]['+techIndex+'][work_performed]',attr.work_performed);if(attr.preset_task_ids&&attr.preset_task_ids.length>0){attr.preset_task_ids.forEach(function(id){apiPayload.append('sub_daily_report_entry[sub_daily_report_teches_attributes]['+techIndex+'][preset_task_ids][]',id);});}else{apiPayload.append('sub_daily_report_entry[sub_daily_report_teches_attributes]['+techIndex+'][preset_task_ids][]',[]);}if(attr.sub_technician_id){apiPayload.append('sub_daily_report_entry[sub_daily_report_teches_attributes]['+techIndex+'][sub_technician_id]',attr.sub_technician_id);}else{apiPayload.append('sub_daily_report_entry[sub_daily_report_teches_attributes]['+techIndex+'][sub_technician_id]','');}apiPayload.append('sub_daily_report_entry[sub_daily_report_teches_attributes]['+techIndex+'][tech_number]',attr.tech_number);techIndex++;});}if(values.deletedTechnicians&&values.deletedTechnicians.length>0){values.deletedTechnicians.forEach(function(attr){apiPayload.append('sub_daily_report_entry[sub_daily_report_teches_attributes]['+techIndex+'][id]',attr.id);apiPayload.append('sub_daily_report_entry[sub_daily_report_teches_attributes]['+techIndex+'][_destroy]',true);techIndex++;});}var imageIndex=0;if(values.images_attributes&&values.images_attributes.length>0){values.images_attributes.forEach(function(image){apiPayload.append('sub_daily_report_entry[images_attributes]['+imageIndex+'][image]',image.file,image.file.name);imageIndex++;});}if(values.deleted_images_attributes&&values.deleted_images_attributes.length>0){values.deleted_images_attributes.forEach(function(image){apiPayload.append('sub_daily_report_entry[images_attributes]['+imageIndex+'][id]',image.id);apiPayload.append('sub_daily_report_entry[images_attributes]['+imageIndex+'][_destroy]',true);imageIndex++;});}return apiPayload;}},{key:'updateDailyReportEntry',value:function updateDailyReportEntry(values,reportId){var headers={headers:{'Content-Type':'multipart/form-data'}};var data=this.dailyReportEntryParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/sub_daily_report_entries/'+reportId,data,headers).then(function(response){return{ok:true,dailyReport:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getSubDailyReportsEntries',value:function getSubDailyReportsEntries(projectId,reportDate){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/sub_daily_report_entries?submitted=true&by_report_date='+reportDate).then(function(response){return{ok:true,subDailyReportEntries:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'postDailyReportEntry',value:function postDailyReportEntry(entryId){var apiPayload={sub_daily_report_entry:{sub_daily_report_entry_id:entryId}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/sub_daily_report_entries',apiPayload).then(function(response){return{ok:true,newEntry:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'deleteDailyReportEntry',value:function deleteDailyReportEntry(entryId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/sub_daily_report_entries/'+entryId).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return SubDailyReportsEntriesApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var subDailyReportsEntriesApi=new SubDailyReportsEntriesApi();

/***/ }),
/* 2519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closeoutCatsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CloseoutCatsApi=function(_BaseApi){_inherits(CloseoutCatsApi,_BaseApi);function CloseoutCatsApi(){_classCallCheck(this,CloseoutCatsApi);return _possibleConstructorReturn(this,(CloseoutCatsApi.__proto__||Object.getPrototypeOf(CloseoutCatsApi)).apply(this,arguments));}_createClass(CloseoutCatsApi,[{key:'getCloseoutCats',value:function getCloseoutCats(){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/closeout_cats').then(function(response){return{ok:true,closeoutCats:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return CloseoutCatsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var closeoutCatsApi=new CloseoutCatsApi();

/***/ }),
/* 2520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closeoutApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CloseoutApi=function(_BaseApi){_inherits(CloseoutApi,_BaseApi);function CloseoutApi(){_classCallCheck(this,CloseoutApi);return _possibleConstructorReturn(this,(CloseoutApi.__proto__||Object.getPrototypeOf(CloseoutApi)).apply(this,arguments));}_createClass(CloseoutApi,[{key:'getCloseout',value:function getCloseout(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/closeout').then(function(response){return{ok:true,closeout:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateCloseout',value:function updateCloseout(projectId,values){var params={closeout:{warranty_date:values.warrantyDate,due_date:values.dueDate}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/closeout',params).then(function(response){return{ok:true,closeout:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'requestCloseout',value:function requestCloseout(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/closeout/send_request').then(function(response){return{ok:true,closeout:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return CloseoutApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var closeoutApi=new CloseoutApi();

/***/ }),
/* 2521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closeoutContributorsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CloseoutContributorsApi=function(_BaseApi){_inherits(CloseoutContributorsApi,_BaseApi);function CloseoutContributorsApi(){_classCallCheck(this,CloseoutContributorsApi);return _possibleConstructorReturn(this,(CloseoutContributorsApi.__proto__||Object.getPrototypeOf(CloseoutContributorsApi)).apply(this,arguments));}_createClass(CloseoutContributorsApi,[{key:'getCloseoutContributors',value:function getCloseoutContributors(projectId){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/closeout/closeout_contributors?page='+page+'&per_page=10').then(function(response){return{ok:true,closeoutContributors:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateCloseoutContributor',value:function updateCloseoutContributor(projectId,closeoutContrib,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var data=this.closeoutContributorParams(closeoutContrib,values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/closeout/closeout_contributors/'+closeoutContrib.id,data,headers).then(function(response){return{ok:true,closeoutContributor:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'closeoutContributorParams',value:function closeoutContributorParams(closeoutContrib,values){var apiPayload=new FormData();apiPayload.append('closeout_contributor[comments]',values.comments||'');closeoutContrib.closeout_contributor_cats.forEach(function(contribCat,index){var attrs=values[contribCat.id];apiPayload.append('closeout_contributor[closeout_contributor_cats_attributes]['+index+'][id]',contribCat.id);apiPayload.append('closeout_contributor[closeout_contributor_cats_attributes]['+index+'][applies]',attrs.applies||false);apiPayload.append('closeout_contributor[closeout_contributor_cats_attributes]['+index+'][comments]',attrs.comments||'');var docsIndex=0;if(attrs.documents&&attrs.documents.length>0){attrs.documents.filter(function(doc){return!doc.id;}).forEach(function(doc){apiPayload.append('closeout_contributor[closeout_contributor_cats_attributes]['+index+'][documents_attributes]['+docsIndex+'][document]',doc.file,doc.file.name);docsIndex++;});}if(attrs.deletedDocuments&&attrs.deletedDocuments.length>0){attrs.deletedDocuments.filter(function(doc){return doc.id;}).forEach(function(doc){apiPayload.append('closeout_contributor[closeout_contributor_cats_attributes]['+index+'][documents_attributes]['+docsIndex+'][id]',doc.id);apiPayload.append('closeout_contributor[closeout_contributor_cats_attributes]['+index+'][documents_attributes]['+docsIndex+'][_destroy]',true);docsIndex++;});}});return apiPayload;}}]);return CloseoutContributorsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var closeoutContributorsApi=new CloseoutContributorsApi();

/***/ }),
/* 2522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closeoutContributorCatsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CloseoutContributorCatsApi=function(_BaseApi){_inherits(CloseoutContributorCatsApi,_BaseApi);function CloseoutContributorCatsApi(){_classCallCheck(this,CloseoutContributorCatsApi);return _possibleConstructorReturn(this,(CloseoutContributorCatsApi.__proto__||Object.getPrototypeOf(CloseoutContributorCatsApi)).apply(this,arguments));}_createClass(CloseoutContributorCatsApi,[{key:'getCompletedPercentage',value:function getCompletedPercentage(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/closeout/closeout_contributor_cats/completed_percentage').then(function(response){return{ok:true,completedPercentage:response.data.percentage};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return CloseoutContributorCatsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var closeoutContributorCatsApi=new CloseoutContributorCatsApi();

/***/ }),
/* 2523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closeoutManualsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CloseoutManualsApi=function(_BaseApi){_inherits(CloseoutManualsApi,_BaseApi);function CloseoutManualsApi(){_classCallCheck(this,CloseoutManualsApi);return _possibleConstructorReturn(this,(CloseoutManualsApi.__proto__||Object.getPrototypeOf(CloseoutManualsApi)).apply(this,arguments));}_createClass(CloseoutManualsApi,[{key:'getCloseoutManuals',value:function getCloseoutManuals(projectId){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/closeout/closeout_manuals?page='+page).then(function(response){return{ok:true,closeoutManuals:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getCloseoutManual',value:function getCloseoutManual(projectId,id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/closeout/closeout_manuals/'+id,{loadingDisabled:true}).then(function(response){return{ok:true,closeoutManual:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createCloseoutManual',value:function createCloseoutManual(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/projects/'+projectId+'/closeout/closeout_manuals').then(function(response){return{ok:true,closeoutManual:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'deleteCloseoutManual',value:function deleteCloseoutManual(projectId,id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/projects/'+projectId+'/closeout/closeout_manuals/'+id).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return CloseoutManualsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var closeoutManualsApi=new CloseoutManualsApi();

/***/ }),
/* 2524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailsInfoCard_css__ = __webpack_require__(2525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailsInfoCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DetailsInfoCard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome_free_solid_faAngleDown__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome_free_solid_faAngleDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome_free_solid_faAngleDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faAngleUp__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faAngleUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faAngleUp__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsInfoCard=function(_Component){_inherits(DetailsInfoCard,_Component);function DetailsInfoCard(props){_classCallCheck(this,DetailsInfoCard);var _this=_possibleConstructorReturn(this,(DetailsInfoCard.__proto__||Object.getPrototypeOf(DetailsInfoCard)).call(this,props));_this.handleClickDetails=function(event){event.preventDefault();event.stopPropagation();_this.setState({showDetails:!_this.state.showDetails});};_this.state={showDetails:true};return _this;}_createClass(DetailsInfoCard,[{key:'render',value:function render(){var headerButtons=this.props.headerButtons;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-info-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-toggle',onClick:this.handleClickDetails},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'DETAILS'),this.props.leftHeaderExtraComponents!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left-header-extra'},this.props.leftHeaderExtraComponents.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:index},' ',item,' ');}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-toggle-controls'},headerButtons&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-buttons'},headerButtons.map(function(btn,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:index},btn);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'toggle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome__["a" /* default */],{icon:this.state.showDetails?__WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faAngleUp___default.a:__WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome_free_solid_faAngleDown___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Collapse */],{'in':this.state.showDetails,className:'collapse-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-info-items'},this.props.itemLines.map(function(itemLine,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'details-info-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-info-item-content'},itemLine.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'details-info-item-line'},item);})));}))));}}]);return DetailsInfoCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DetailsInfoCard.propTypes={itemLines:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]))).isRequired,headerButtons:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element)};/* harmony default export */ __webpack_exports__["a"] = (DetailsInfoCard);

/***/ }),
/* 2525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectProposal_css__ = __webpack_require__(2527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectProposal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProjectProposal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_print_white_svg__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_print_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_print_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_email_modal_store_selectors__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_store_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_ProjectEmailModal__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProjectCancelledOrLostModal__ = __webpack_require__(2533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_domain_project_status_enum__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_proposal_store_selectors__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_proposal_store_actions__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_proposal_ProjectProposalForm__ = __webpack_require__(2536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_shared_pdf_viewer_PdfViewer__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_shared_modal_MessageModal__ = __webpack_require__(93);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectProposal=function(_Component){_inherits(ProjectProposal,_Component);function ProjectProposal(props){_classCallCheck(this,ProjectProposal);var _this=_possibleConstructorReturn(this,(ProjectProposal.__proto__||Object.getPrototypeOf(ProjectProposal)).call(this,props));_this.handleCreateProposal=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_proposal_store_actions__["v" /* toggleCreateProposal */])());};_this.handleEditProposal=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_proposal_store_actions__["w" /* toggleCreateProposalSuccess */])());};_this.handlePdfViewerClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_proposal_store_actions__["y" /* togglePdfViewer */])());};_this.handleGeneratePdf=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_proposal_store_actions__["h" /* loadProjectProposalPdfRequest */])(_this.props.currentProject.id)).then(function(){return _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_proposal_store_actions__["y" /* togglePdfViewer */])());});};_this.handleCloseApproveSuccessModal=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_proposal_store_actions__["t" /* toggleApproveProposalSuccess */])());};_this.handleToggleReadOnly=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_proposal_store_actions__["p" /* setReadOnly */])(!_this.props.readOnly));};_this.showApprove=function(){var projStatus=__WEBPACK_IMPORTED_MODULE_11_domain_project_status_enum__["a" /* ProjectStatusEnum */].create(_this.props.currentProject.status);return __WEBPACK_IMPORTED_MODULE_11_domain_project_status_enum__["a" /* ProjectStatusEnum */].PENDING.equals(projStatus);};_this.showLost=function(){var projStatus=__WEBPACK_IMPORTED_MODULE_11_domain_project_status_enum__["a" /* ProjectStatusEnum */].create(_this.props.currentProject.status);return __WEBPACK_IMPORTED_MODULE_11_domain_project_status_enum__["a" /* ProjectStatusEnum */].PENDING.equals(projStatus);};_this.showCancel=function(){var projStatus=__WEBPACK_IMPORTED_MODULE_11_domain_project_status_enum__["a" /* ProjectStatusEnum */].create(_this.props.currentProject.status);return __WEBPACK_IMPORTED_MODULE_11_domain_project_status_enum__["a" /* ProjectStatusEnum */].PENDING.equals(projStatus)||__WEBPACK_IMPORTED_MODULE_11_domain_project_status_enum__["a" /* ProjectStatusEnum */].PRECON.equals(projStatus);};_this.showMobilize=function(){var projStatus=__WEBPACK_IMPORTED_MODULE_11_domain_project_status_enum__["a" /* ProjectStatusEnum */].create(_this.props.currentProject.status);return __WEBPACK_IMPORTED_MODULE_11_domain_project_status_enum__["a" /* ProjectStatusEnum */].PRECON.equals(projStatus);};_this.showClose=function(){var projStatus=__WEBPACK_IMPORTED_MODULE_11_domain_project_status_enum__["a" /* ProjectStatusEnum */].create(_this.props.currentProject.status);return __WEBPACK_IMPORTED_MODULE_11_domain_project_status_enum__["a" /* ProjectStatusEnum */].IN_PROGRESS.equals(projStatus);};_this.handleSendEmail=function(emailsData){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_store_actions__["d" /* sendProjectResourceEmails */])(_this.props.projectProposal.id,'ProjectProposal',emailsData));};_this.buildEmailModalTitle=function(){var currentProject=_this.props.currentProject;return'Proposal (Project #'+currentProject.number+': '+currentProject.name+')';};_this.buildEmailModalSubject=function(){var currentProject=_this.props.currentProject;return currentProject.number+', '+currentProject.name+' - Proposal';};_this.buildEmailModalMessage=function(){var currentProject=_this.props.currentProject;var location='';if(currentProject.building&&currentProject.building.location){var buildingLocation=currentProject.building.location;location=' at '+buildingLocation.street_address_1+', '+buildingLocation.city+' '+buildingLocation.state;}return'Please find the attached Proposal for Project '+currentProject.name+location+'. If you have any questions, please reach out via chat or email.';};props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_proposal_store_actions__["f" /* initProjectProposal */])());_this.showActions=__WEBPACK_IMPORTED_MODULE_10_domain_enterprise__["a" /* Enterprise */].showActions(props.currentUser);return _this;}_createClass(ProjectProposal,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;if(this.props.currentProject){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_proposal_store_actions__["g" /* loadCsiCodes */])()).then(function(response){if(response.ok){var csiCodes=response.csiCodes;_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_proposal_store_actions__["i" /* loadProjectProposalRequest */])(_this2.props.currentProject.id)).then(function(response){if(response.ok){if(response.projectProposal===null){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_proposal_store_actions__["v" /* toggleCreateProposal */])());csiCodes.forEach(function(csiCode){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_proposal_store_actions__["k" /* newItem */])(_this2.props.projectProposalItems,csiCode.id));});}else{_this2.handleToggleReadOnly();_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_proposal_store_actions__["b" /* buildProjectProposalForm */])(response.projectProposal));}}});}});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-proposal'},this.props.currentProject&&(this.props.showCreateProposal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'proposal-create'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Create a Proposal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'proposal-create-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'First things first, generate a proposal for your potential client.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Once accepted, you can add the rest of the information to the project.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_button_Button__["a" /* default */],{className:'btn button button-orange',label:'Create Proposal',onClick:this.handleCreateProposal})):this.props.showCreateProposalSuccess&&this.props.projectProposal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'proposal-create-success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.props.currentProject.general_contractor.name+' Bid Proposal - '+__WEBPACK_IMPORTED_MODULE_8_moment___default()(this.props.projectProposal.updated_at).format('MM/DD/YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_button_Button__["a" /* default */],{className:'btn button button-gray',icon:__WEBPACK_IMPORTED_MODULE_3_images_print_white_svg___default.a,label:'Generate PDF',onClick:this.handleGeneratePdf}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_button_Button__["a" /* default */],{className:'btn button button-orange',label:'Back to Proposal',onClick:this.handleEditProposal}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_proposal_ProjectProposalForm__["a" /* default */],{onGeneratePdf:this.handleGeneratePdf,onToggleReadOnly:this.handleToggleReadOnly,readOnly:this.props.readOnly,showApprove:this.showApprove(),showActions:this.showActions,showLost:this.showLost(),showCancel:this.showCancel(),showMobilize:this.showMobilize(),showClose:this.showClose()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:this.props.projectProposalPdf,type:'blob'},show:this.props.showPdfViewer,onClose:this.handlePdfViewerClose}),this.props.showEmailModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_ProjectEmailModal__["a" /* default */],{title:this.buildEmailModalTitle(),handleSendEmail:this.handleSendEmail,projectId:this.props.currentProject.id,initialSubject:this.buildEmailModalSubject(),initialMessage:this.buildEmailModalMessage()}),this.props.showLostOrCancelledModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProjectCancelledOrLostModal__["a" /* default */],{statusSelected:this.props.isCancelledModal?'cancelled':'lost',showLostOrCancelledModal:this.props.showLostOrCancelledModal,projectId:this.props.currentProject.id,terminationDate:this.props.currentProject.termination_date,terminationReason:this.props.currentProject.termination_reason,projectTerminationCategory:this.props.currentProject.termination_category}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_shared_modal_MessageModal__["a" /* default */],{show:this.props.showApproveProposalSuccess,message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Thank you. Your Client has been invited to Spackle to join this Project.'),onHide:this.handleCloseApproveSuccessModal}));}}]);return ProjectProposal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_authentication__["d" /* getCurrentUser */])(state),currentProject:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),projectProposal:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_proposal_store_selectors__["f" /* getProjectProposal */])(state),projectProposalPdf:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_proposal_store_selectors__["j" /* getProjectProposalPdf */])(state),showCreateProposal:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_proposal_store_selectors__["n" /* getShowCreateProposal */])(state),showPdfViewer:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_proposal_store_selectors__["q" /* getShowPdfViewer */])(state),showCreateProposalSuccess:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_proposal_store_selectors__["o" /* getShowCreateProposalSuccess */])(state),showApproveProposalSuccess:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_proposal_store_selectors__["l" /* getShowApproveProposalSuccess */])(state),projectProposalItems:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_proposal_store_selectors__["i" /* getProjectProposalItems */])(state),readOnly:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_proposal_store_selectors__["k" /* getReadOnly */])(state),showEmailModal:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_email_modal_store_selectors__["g" /* getShowEmailModal */])(state),showLostOrCancelledModal:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_proposal_store_selectors__["p" /* getShowLostOrCancelledModal */])(state),isCancelledModal:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_proposal_store_selectors__["c" /* getIsCancelledModal */])(state)};})(ProjectProposal));

/***/ }),
/* 2527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return projectContributorsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectContributorsApi=function(_BaseApi){_inherits(ProjectContributorsApi,_BaseApi);function ProjectContributorsApi(){_classCallCheck(this,ProjectContributorsApi);return _possibleConstructorReturn(this,(ProjectContributorsApi.__proto__||Object.getPrototypeOf(ProjectContributorsApi)).apply(this,arguments));}_createClass(ProjectContributorsApi,[{key:'createProjectContributor',value:function createProjectContributor(projectId,values){var data={project_contributor:{company_type:values.contributorCompanyType,company_type_override:values.contributorCompanyTypeOverride,company_id:values.contributorCompanyId,csi_code_id:values.csiCodeId,user_ids:values.userIds,primary:values.primary,send_notifications:values.sendNotifications}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/projects/'+projectId+'/directory/project_contributors',data).then(function(response){return{ok:true,projectContributor:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateProjectContributor',value:function updateProjectContributor(projectId,id,values){var data={project_contributor:{user_ids:values.userIds,send_notifications:values.sendNotifications}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/directory/project_contributors/'+id,data).then(function(response){return{ok:true,projectContributor:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'destroyProjectContributor',value:function destroyProjectContributor(projectId,id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/projects/'+projectId+'/directory/project_contributors/'+id).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return ProjectContributorsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var projectContributorsApi=new ProjectContributorsApi();

/***/ }),
/* 2529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EmailHistoryModal_css__ = __webpack_require__(2530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EmailHistoryModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EmailHistoryModal_css__);
var EmailHistoryModal=function EmailHistoryModal(props){var title=props.title,history=props.history,onClose=props.onClose,show=props.show;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{className:'project-email-modal',show:show,title:title,onClose:onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'email-history-modal'},history.length<1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'History is empty'),history.map(function(el,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:''+el.from_label+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,el.from_label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body-bold history-label'},'Sent to: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,el.send_to.map(function(mail,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:''+mail+index},mail);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'body-bold message'},__WEBPACK_IMPORTED_MODULE_1_moment___default()(el.created_at).format('LLL'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null));})));};/* harmony default export */ __webpack_exports__["a"] = (EmailHistoryModal);

/***/ }),
/* 2530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_proposal_store_selectors__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_proposal_store_actions__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProjectCancelledOrLostModal_css__ = __webpack_require__(2535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProjectCancelledOrLostModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ProjectCancelledOrLostModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_scroller_util__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectCancelledOrLostModal=function(_Component){_inherits(ProjectCancelledOrLostModal,_Component);function ProjectCancelledOrLostModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProjectCancelledOrLostModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProjectCancelledOrLostModal.__proto__||Object.getPrototypeOf(ProjectCancelledOrLostModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleUpdateProject=function(){var projectId=_this.props.projectId;_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_proposal_store_actions__["z" /* updateProject */])(projectId,{terminationDate:_this.props.date,terminationCategory:_this.props.terminationCategory,terminationReason:_this.props.message,status:_this.props.statusSelected})).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_proposal_store_actions__["q" /* setShowCancelModal */])(false));Object(__WEBPACK_IMPORTED_MODULE_11_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}});},_this.handleClose=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_proposal_store_actions__["q" /* setShowCancelModal */])(false));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_proposal_store_actions__["r" /* setShowLostModal */])(false));},_this.handleMessageChange=function(message){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_proposal_store_actions__["o" /* setMessage */])(message));},_this.handleDateChange=function(date){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_proposal_store_actions__["n" /* setDate */])(date));},_this.handleTerminationCategoryChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_proposal_store_actions__["s" /* setTerminationCategory */])(value.value));},_this.isSendButtonEnabled=function(statusSelected,terminationCategory,date,message){if(date!==null&&date!==''&&message!==null&&message!==''){if(statusSelected==='lost'){if(terminationCategory!==undefined&&terminationCategory!==''){return true;}}else{return true;}}return false;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProjectCancelledOrLostModal,[{key:'componentDidMount',value:function componentDidMount(){var initPayload={date:this.props.terminationDate,message:this.props.terminationReason||this.props.message,terminationCategory:this.props.projectTerminationCategory};this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_proposal_store_actions__["e" /* initProjectLostCancelModal */])(initPayload));}},{key:'render',value:function render(){var _this2=this;var _props=this.props,statusSelected=_props.statusSelected,showLostOrCancelledModal=_props.showLostOrCancelledModal,message=_props.message,date=_props.date,terminationCategory=_props.terminationCategory;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{className:'project-cancelled-lost-modal',show:showLostOrCancelledModal,title:'',onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-cancelled-lost-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'body-bold message'},'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{placeholder:'Date',value:date,isValidDate:__WEBPACK_IMPORTED_MODULE_4_services_utils_date_util__["j" /* sameOrBeforeTodayValidation */],onChange:function onChange(value){return _this2.handleDateChange(value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'body-bold message'},statusSelected==='cancelled'?'Reason for Cancellation':'Reason for Loss'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,statusSelected==='lost'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_dropdown_Dropdown__["a" /* default */],{options:[{value:'Pricing',label:'Pricing'},{value:'Schedule',label:'Schedule'},{value:'Using prefered contractor',label:'Using prefered contractor'},{value:'Other',label:'Other'}],placeholder:'Select Option',onChange:function onChange(value){return _this2.handleTerminationCategoryChange(value);},value:terminationCategory,className:'dropdown-'+statusSelected}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_TextArea__["a" /* default */],{placeholder:'Reason',value:message,onChange:function onChange(value){return _this2.handleMessageChange(value);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:!this.isSendButtonEnabled(statusSelected,terminationCategory,date,message),label:'Submit',onClick:function onClick(){return _this2.handleUpdateProject();}}))));}}]);return ProjectCancelledOrLostModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{showLostOrCancelledModal:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_proposal_store_selectors__["p" /* getShowLostOrCancelledModal */])(state),message:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_proposal_store_selectors__["e" /* getMessage */])(state),date:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_proposal_store_selectors__["b" /* getDate */])(state),terminationCategory:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_proposal_store_selectors__["r" /* getTerminationCategory */])(state)};})(ProjectCancelledOrLostModal));

/***/ }),
/* 2534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return projectProposalsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectProposalsApi=function(_BaseApi){_inherits(ProjectProposalsApi,_BaseApi);function ProjectProposalsApi(){_classCallCheck(this,ProjectProposalsApi);return _possibleConstructorReturn(this,(ProjectProposalsApi.__proto__||Object.getPrototypeOf(ProjectProposalsApi)).apply(this,arguments));}_createClass(ProjectProposalsApi,[{key:'getProjectProposal',value:function getProjectProposal(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/project_proposal').then(function(response){return{ok:true,projectProposal:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getProjectProposalPdf',value:function getProjectProposalPdf(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/project_proposal/print',{responseType:'blob'}).then(function(response){return{ok:true,pdf:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createProjectProposal',value:function createProjectProposal(projectId,values){var data=this.projectProposalParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/projects/'+projectId+'/project_proposal',data).then(function(response){return{ok:true,projectProposal:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateProjectProposal',value:function updateProjectProposal(projectId,values){var data=this.projectProposalParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/project_proposal',data).then(function(response){return{ok:true,projectProposal:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateProjectProposalCostsShown',value:function updateProjectProposalCostsShown(projectId,shown){var data={project_proposal:{costs_shown_to_primary:shown}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/project_proposal',data).then(function(response){return{ok:true,projectProposal:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'approveProjectProposal',value:function approveProjectProposal(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/project_proposal/approve').then(function(response){return{ok:true,projectProposal:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'projectProposalParams',value:function projectProposalParams(values){var params={project_proposal:{costs_shown_to_primary:values.costsShownToPrimary,permits:values.permits,general_conditions:values.generalConditions,insurance:values.insurance,fee:values.fee,contingency:values.contingency,project_proposal_items_attributes:values.projectProposalItems.map(function(item){var subItemParams=item.subItems.map(function(subItem){return{id:subItem.id,division:subItem.division,label:subItem.label,trade_costs:subItem.tradeCosts,award_recommendation_id:subItem.awardRecommendationId,_destroy:!!subItem.delete};});var itemParams={csi_code_id:item.csiCodeId,trade_costs:item.tradeCosts,award_recommendation_id:item.awardRecommendationId,project_proposal_sub_items_attributes:subItemParams};if(item.id){itemParams['id']=item.id;itemParams['_destroy']=!!item.delete;}return itemParams;})}};[['permits','permits_items_attributes'],['generalConditions','general_conditions_items_attributes'],['insurance','insurance_items_attributes'],['fee','fee_items_attributes'],['contingency','contingency_items_attributes']].forEach(function(attr){params['project_proposal'][attr[1]]=values[attr[0]+'Items'].map(function(item){return{id:item.id,summary:item.summary,cost:item.cost,_destroy:!!item.delete};});});return params;}}]);return ProjectProposalsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var projectProposalsApi=new ProjectProposalsApi();

/***/ }),
/* 2535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectProposalForm_css__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectProposalForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProjectProposalForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_print_white_svg__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_print_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_print_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_mail_white_svg__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_mail_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_mail_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_checkbox_CheckBox__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_email_modal_store_actions__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_creation_store_actions__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_store_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_proposal_store_selectors__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_proposal_store_actions__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_proposal_ProjectProposalItem__ = __webpack_require__(2537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_proposal_ProjectProposalAddlItem__ = __webpack_require__(2540);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectProposalForm=function(_Component){_inherits(ProjectProposalForm,_Component);function ProjectProposalForm(props){_classCallCheck(this,ProjectProposalForm);var _this=_possibleConstructorReturn(this,(ProjectProposalForm.__proto__||Object.getPrototypeOf(ProjectProposalForm)).call(this,props));_this.resetFormItems=function(proposal){var _this$props=_this.props,projectProposal=_this$props.projectProposal,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_proposal_store_actions__["m" /* resetProjectProposalItems */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_proposal_store_actions__["b" /* buildProjectProposalForm */])(projectProposal));};_this.handleItemAdd=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_proposal_store_actions__["k" /* newItem */])(_this.props.projectProposalItems));};_this.buildFeeAndInsurance=function(oldTradeCosts,newTradeCosts){var _this$props$projectPr=_this.props.projectProposalForm,insuranceRatio=_this$props$projectPr.insuranceRatio,feeRatio=_this$props$projectPr.feeRatio;var totalCost=_this.totalTradeCosts-oldTradeCosts+newTradeCosts;_this.handleAdditionalItemChange('insurance',totalCost*insuranceRatio);_this.handleAdditionalItemChange('fee',totalCost*feeRatio);};_this.handleRatioChange=function(attr,ratio,value){if(ratio){_this.handleAdditionalItemChange(attr+'Ratio',ratio);_this.handleAdditionalItemChange(attr,_this.totalTradeCosts*ratio);}else{_this.handleAdditionalItemChange(attr+'Ratio',_this.totalTradeCosts?value/_this.totalTradeCosts:1);}};_this.handleItemChange=function(key,attribute,value){if(attribute==='tradeCosts'){var projectProposalItems=_this.props.projectProposalItems;var item=projectProposalItems[key];_this.buildFeeAndInsurance(item.tradeCosts,value);}_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_proposal_store_actions__["E" /* updateProjectProposalItemValue */])(key,attribute,value));};_this.handleSubItemChange=function(itemKey,subItemKey,attribute,value){if(attribute==='tradeCosts'){var projectProposalItems=_this.props.projectProposalItems;var subItem=projectProposalItems[itemKey].subItems[subItemKey];_this.buildFeeAndInsurance(subItem.tradeCosts,value);}_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_proposal_store_actions__["F" /* updateProjectProposalSubItemValue */])(itemKey,subItemKey,attribute,value));};_this.handleAwardRecommendationChange=function(key,id,name){_this.handleItemChange(key,'awardRecommendationId',id);_this.handleItemChange(key,'awardRecommendationName',name);};_this.handleAdditionalItemChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_proposal_store_actions__["D" /* updateProjectProposalFormValue */])(attribute,value));};_this.handleSave=function(){var _this$props2=_this.props,projectProposalForm=_this$props2.projectProposalForm,projectProposalItems=_this$props2.projectProposalItems,projectProposalAddlItems=_this$props2.projectProposalAddlItems;var form=projectProposalForm;form.projectProposalItems=Object.keys(projectProposalItems).map(function(key){var item=projectProposalItems[key];item.subItems=Object.keys(item.subItems||{}).map(function(subItemKey){return item.subItems[subItemKey];});return item;}).filter(function(item){return!!item.csiCodeId;});['permits','generalConditions','insurance','fee','contingency'].forEach(function(attr){form[attr+'Items']=Object.keys(projectProposalAddlItems[attr]).map(function(key){return projectProposalAddlItems[attr][key];});});if(_this.props.projectProposal===null){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_proposal_store_actions__["c" /* createProjectProposal */])(_this.props.currentProject.id,form)).then(function(response){_this.resetFormItems(response.projectProposal);_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_proposal_store_actions__["w" /* toggleCreateProposalSuccess */])());_this.props.onToggleReadOnly();});}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_proposal_store_actions__["A" /* updateProjectProposal */])(_this.props.currentProject.id,form)).then(function(response){_this.resetFormItems(response.projectProposal);_this.props.onToggleReadOnly();});}};_this.handleApprove=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_proposal_store_actions__["a" /* approveProjectProposal */])(_this.props.currentProject.id)).then(function(){return _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_proposal_store_actions__["t" /* toggleApproveProposalSuccess */])());});};_this.handleToggleAwardRecommendation=function(){Object.keys(_this.props.projectProposalItems).forEach(function(key){_this.handleAwardRecommendationChange(key,null,null);});_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_proposal_store_actions__["u" /* toggleAwardRecommendation */])());};_this.handleCancel=function(){_this.resetFormItems(_this.props.projectProposal);_this.props.onToggleReadOnly();};_this.loadSubcontractors=function(input,csiCodeId,page){return _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_proposal_store_actions__["d" /* fetchSubcontractors */])(input,csiCodeId,page)).then(function(response){if(response.ok){var companies=response.contractors;return{ok:true,options:companies.map(function(element){return{value:element.id,label:element.name};}),hasMore:true};}});};_this.selectedCsiCodes=function(){return Object.keys(_this.props.projectProposalItems).filter(function(key){return!_this.props.projectProposalItems[key].delete;}).map(function(key){return _this.props.projectProposalItems[key].csiCodeId;});};_this.csiCodeOptions=function(){var selectedCsiCodes=_this.selectedCsiCodes();return _this.props.csiCodes.filter(function(csiCode){return!selectedCsiCodes.includes(csiCode.id);}).map(function(csiCode){return{value:csiCode.id,label:csiCode.division};});};_this.totalItemCost=function(item){var cost=__WEBPACK_IMPORTED_MODULE_15_numeral___default()(item.tradeCosts).value();item.subItems&&Object.keys(item.subItems).forEach(function(key){var subItem=item.subItems[key];if(!subItem.delete){cost+=__WEBPACK_IMPORTED_MODULE_15_numeral___default()(subItem.tradeCosts).value();}});return cost;};_this.mapItems=function(costsShown){_this.totalTradeCosts=0;var csiCodeOptions=_this.csiCodeOptions();var items=Object.keys(_this.props.projectProposalItems).filter(function(key){return!_this.props.projectProposalItems[key].delete;}).map(function(key){var item=_this.props.projectProposalItems[key];_this.totalTradeCosts+=_this.totalItemCost(item);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_proposal_ProjectProposalItem__["a" /* default */],{key:key,itemKey:key,item:item,itemDelete:_this.props.itemDelete[key],costsShown:costsShown,readOnly:_this.props.readOnly,showAwardRecommendation:_this.props.showAwardRecommendation,onCsiCodeOptions:_this.csiCodeOptions,onTotalItemCost:_this.totalItemCost,onLoadSubcontractors:_this.loadSubcontractors,onChange:_this.handleItemChange,onSubItemChange:_this.handleSubItemChange});});if(!_this.props.readOnly&&csiCodeOptions.length>0){items.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'add-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tomato-row add-row',onClick:_this.handleItemAdd},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-row-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'add-row-plus'},'+ '),'Add Row'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null)));}if(costsShown){items.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'total-costs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tomato-row'},'TOTAL TRADE COSTS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tomato-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_shared_text_Number__["a" /* default */],{value:_this.totalTradeCosts,format:'$ 0,0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tomato-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_shared_text_Number__["a" /* default */],{value:_this.totalTradeCosts/_this.props.currentProject.sq_footage,format:'$ 0,0.[00]'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null)));}return items;};_this.totalAddlItemCost=function(attr){var projectProposalAddlItems=_this.props.projectProposalAddlItems;var form=_this.props.projectProposalForm;var addlItems=projectProposalAddlItems[attr];var cost=__WEBPACK_IMPORTED_MODULE_15_numeral___default()(form[attr]).value();addlItems&&Object.keys(addlItems).forEach(function(key){var item=addlItems[key];if(!item.delete){cost+=__WEBPACK_IMPORTED_MODULE_15_numeral___default()(item.cost).value();}});return cost;};_this.mapAdditionalItems=function(){var _this$props3=_this.props,projectProposalAddlItems=_this$props3.projectProposalAddlItems,readOnly=_this$props3.readOnly;var form=_this.props.projectProposalForm;var total=0;var addlItems=[['permits','Permits (Allowance)'],['generalConditions','General Conditions'],['insurance','Insurance'],['fee','Fee'],['contingency','Contingency']].map(function(attr){var itemRatio=form[attr[0]+'Ratio'];var itemTotalCost=_this.totalAddlItemCost(attr[0]);total+=itemTotalCost;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_proposal_ProjectProposalAddlItem__["a" /* default */],{key:attr[0],itemKey:attr[0],itemValue:form[attr[0]],itemTitle:attr[1],itemTotalCost:itemTotalCost,itemRatio:itemRatio,subItems:projectProposalAddlItems[attr[0]],readOnly:readOnly,onRatioChange:_this.handleRatioChange,onChange:_this.handleAdditionalItemChange});});addlItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'total-addl-costs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tomato-row'},'TOTAL COST')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tomato-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_shared_text_Number__["a" /* default */],{value:total+_this.totalTradeCosts,format:'$ 0,0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tomato-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_shared_text_Number__["a" /* default */],{value:(total+_this.totalTradeCosts)/_this.props.currentProject.sq_footage,format:'$ 0,0.[00]'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null)));return addlItems;};_this.handleCostsToggleChange=function(){var _this$props4=_this.props,currentProject=_this$props4.currentProject,projectProposal=_this$props4.projectProposal,projectProposalForm=_this$props4.projectProposalForm,dispatch=_this$props4.dispatch;var costsShown=!projectProposalForm.costsShownToPrimary;_this.handleAdditionalItemChange('costsShownToPrimary',costsShown);projectProposal&&dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_proposal_store_actions__["C" /* updateProjectProposalCostsShown */])(currentProject.id,costsShown));};_this.renderCostsToggleTooltip=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["u" /* Tooltip */],{id:'tooltip-costs-toggle'},'Show Costs to Primary Users (Clients, Architects, etc.)');};_this.renderCostsToggle=function(){var form=_this.props.projectProposalForm;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["q" /* OverlayTrigger */],{placement:'right',overlay:_this.renderCostsToggleTooltip()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["b" /* Button */],{className:'checkbox-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_checkbox_CheckBox__["a" /* default */],{checked:form.costsShownToPrimary,size:'medium',onChange:_this.handleCostsToggleChange})));};_this.handleShowEmailModal=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_email_modal_store_actions__["j" /* setShowEmailModal */])(true));};_this.handleShowLostModal=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_proposal_store_actions__["r" /* setShowLostModal */])(true));};_this.handleUpdateStatus=function(status){var projectId=_this.props.currentProject.id;_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_creation_store_actions__["r" /* updateProject */])(projectId,{status:status})).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_store_actions__["b" /* loadProjectRequest */])(projectId));Object(__WEBPACK_IMPORTED_MODULE_11_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}});};_this.handleMobilize=function(){_this.handleUpdateStatus('in_progress');};_this.handleClose=function(){_this.handleUpdateStatus('complete');};_this.handleShowCancelModal=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_proposal_store_actions__["q" /* setShowCancelModal */])(true));};_this.totalTradeCosts=0;return _this;}_createClass(ProjectProposalForm,[{key:'render',value:function render(){var projectProposal=this.props.projectProposal;var costsShown=!projectProposal||projectProposal.costs_shown;var headers=['','DIVISION','SUMMARY',costsShown?'TRADE COSTS':'',costsShown?'/SF':'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'AWARD RECOMMENDATION\xA0',!this.props.readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hide-award-reccomendation',onClick:this.handleToggleAwardRecommendation},this.props.showAwardRecommendation?'(-)':'(+)'))];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-proposal-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-proposal-form-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'form-title'},costsShown?'Costs':'Work',' Breakdown'),this.props.showActions&&this.renderCostsToggle()),this.props.csiCodes&&this.props.csiCodes.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["t" /* Table */],{className:'projects-table form-costs-breakdown-table'},headers.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,headers.map(function(_,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:index+1});})),headers.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,headers.map(function(element,index){if(typeof element==='string'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:index},element);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.mapItems(costsShown))),costsShown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'form-title'},'Total Trade Costs'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["t" /* Table */],{className:'projects-table form-costs-breakdown-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,headers.map(function(_,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:index+1});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.mapAdditionalItems()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-proposal-buttons'},!this.props.readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button button-orange',label:'Save Changes',onClick:this.handleSave}),this.props.projectProposal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button button-gray',label:'Cancel',onClick:this.handleCancel})),this.props.projectProposal&&this.props.readOnly&&this.props.showActions&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container-actions'},this.props.showApprove&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button button-white',label:'Approve',onClick:this.handleApprove}),this.props.showCancel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button button-white',label:'Cancelled',onClick:this.handleShowCancelModal}),this.props.showLost&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button button-white',label:'Lost',onClick:this.handleShowLostModal}),this.props.showMobilize&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button button-white',label:'Mobilize',onClick:this.handleMobilize}),this.props.showClose&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button button-white',label:'Project Complete',onClick:this.handleClose})),this.props.projectProposal&&this.props.readOnly&&this.props.showActions&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},!this.props.showApprove&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'btn button button-gray',icon:__WEBPACK_IMPORTED_MODULE_4_images_mail_white_svg___default.a,label:'Email',onClick:this.handleShowEmailModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button button-gray',icon:__WEBPACK_IMPORTED_MODULE_3_images_print_white_svg___default.a,label:'View PDF',onClick:this.props.onGeneratePdf}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button button-orange',label:'Edit',onClick:this.props.onToggleReadOnly}))));}}]);return ProjectProposalForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),projectProposal:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_proposal_store_selectors__["f" /* getProjectProposal */])(state),projectProposalAddlItems:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_proposal_store_selectors__["g" /* getProjectProposalAddlItems */])(state),projectProposalItems:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_proposal_store_selectors__["i" /* getProjectProposalItems */])(state),projectProposalForm:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_proposal_store_selectors__["h" /* getProjectProposalForm */])(state),csiCodes:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_proposal_store_selectors__["a" /* getCsiCodes */])(state),itemDelete:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_proposal_store_selectors__["d" /* getItemDelete */])(state),showAwardRecommendation:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_proposal_store_selectors__["m" /* getShowAwardRecommendation */])(state)};})(ProjectProposalForm));

/***/ }),
/* 2537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectProposalForm_css__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectProposalForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ProjectProposalForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_proposal_store_selectors__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_proposal_store_actions__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_dropdown_SearchableDropDownPaginated__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_settings_png__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_settings_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_images_settings_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_OutsideAlerter__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_proposal_ProjectProposalSubItem__ = __webpack_require__(2538);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectProposalItem=function(_Component){_inherits(ProjectProposalItem,_Component);function ProjectProposalItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProjectProposalItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProjectProposalItem.__proto__||Object.getPrototypeOf(ProjectProposalItem)).call.apply(_ref,[this].concat(args))),_this),_this.handleItemChange=function(key,attribute,value){_this.props.onChange(key,attribute,value);},_this.handleCsiCodeChange=function(key,csiCode,csiCodeId){var csiCodeOptions=_this.csiCodeOptions(csiCode);var newCsiCode=csiCodeOptions.find(function(option){return option.value===csiCodeId;});if(newCsiCode){_this.handleItemChange(key,'csiCodeId',csiCodeId);}else{alert('Division already taken');}},_this.handleAwardRecommendationChange=function(key,id,name){_this.handleItemChange(key,'awardRecommendationId',id);_this.handleItemChange(key,'awardRecommendationName',name);},_this.handleItemDeleteOptionClick=function(key){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_proposal_store_actions__["x" /* toggleItemDelete */])(key));},_this.handleItemDelete=function(key){var confirmed=window.confirm('Are you sure?');confirmed&&_this.handleItemChange(key,'delete',true);},_this.handleAddSubcategory=function(key,item,csiCode){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_proposal_store_actions__["l" /* newSubItem */])(key,item,csiCode));_this.handleItemDeleteOptionClick(key);},_this.selectedCsiCode=function(){var _this$props=_this.props,item=_this$props.item,csiCodes=_this$props.csiCodes;return csiCodes.find(function(csiCode){return csiCode.id===item.csiCodeId;});},_this.csiCodeOptions=function(csiCode){var onCsiCodeOptions=_this.props.onCsiCodeOptions;var csiCodes=onCsiCodeOptions();csiCode&&csiCodes.push({value:csiCode.id,label:csiCode.division});return csiCodes;},_this.renderSettings=function(csiCode){var _this$props2=_this.props,item=_this$props2.item,itemDelete=_this$props2.itemDelete;var key=_this.props.itemKey;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'proposal-item-settings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-icon',onClick:function onClick(){return _this.handleItemDeleteOptionClick(key);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12_images_settings_png___default.a,alt:'settings'})),itemDelete&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_OutsideAlerter__["a" /* default */],{onClickOutside:function onClickOutside(){return _this.handleItemDeleteOptionClick(key);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu '+(csiCode?'settings-menu-2':'')},csiCode&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu-item',onClick:function onClick(){return _this.handleAddSubcategory(key,item,csiCode);}},'Add Subcategory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu-item',onClick:function onClick(){return _this.handleItemDelete(key);}},'Delete'))));},_this.activeSubItemsKeys=function(){var item=_this.props.item;return Object.keys(item.subItems||{}).filter(function(subItemKey){return!item.subItems[subItemKey].delete;});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProjectProposalItem,[{key:'render',value:function render(){var _this2=this;var _props=this.props,item=_props.item,currentProject=_props.currentProject,costsShown=_props.costsShown,onTotalItemCost=_props.onTotalItemCost,onLoadSubcontractors=_props.onLoadSubcontractors,onSubItemChange=_props.onSubItemChange;var key=this.props.itemKey;var csiCode=this.selectedCsiCode();var csiCodeOptions=this.csiCodeOptions(csiCode);var activeSubItemsKeys=this.activeSubItemsKeys();var hasSubItems=activeSubItemsKeys.length>0;var lastSubItemKey=activeSubItemsKeys[activeSubItemsKeys.length-1];var totalItemCost=onTotalItemCost(item);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,hasSubItems&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,!this.props.readOnly&&this.renderSettings(csiCode)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,csiCode.division),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,csiCode.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,costsShown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:totalItemCost,format:'$ 0,0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,costsShown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:totalItemCost/currentProject.sq_footage,format:'$ 0,0.[00]'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:hasSubItems?'project-proposal-sub-item':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,!this.props.readOnly&&!hasSubItems&&this.renderSettings(csiCode)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.props.readOnly||!item.newItem?csiCode.division:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_dropdown_Dropdown__["a" /* default */],{options:csiCodeOptions,placeholder:'00',value:item.csiCodeId,onChange:function onChange(newOption){return _this2.handleCsiCodeChange(key,csiCode,newOption.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,csiCode&&''+csiCode.label+(costsShown&&hasSubItems?' - Original Cost':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,costsShown&&(this.props.readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:item.tradeCosts||'',format:'$ 0,0'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__["a" /* default */],{placeholder:'$0',value:item.tradeCosts?__WEBPACK_IMPORTED_MODULE_9_numeral___default()(item.tradeCosts).format('$ 0,0'):'',onChange:function onChange(value){return _this2.handleItemChange(key,'tradeCosts',__WEBPACK_IMPORTED_MODULE_9_numeral___default()(value).value());}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,costsShown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:item.tradeCosts&&item.tradeCosts/currentProject.sq_footage||'',format:'$ 0,0.[00]'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.props.readOnly?item.awardRecommendationName:item.awardRecommendationName?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'award-recommendation-selected',onClick:function onClick(){_this2.handleAwardRecommendationChange(key,null,null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'remove'},'X'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.awardRecommendationName)):this.props.showAwardRecommendation?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'award-recommendation-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'award-recommendation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-row-plus'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_dropdown_SearchableDropDownPaginated__["a" /* default */],{loadOptions:function loadOptions(input,page){return onLoadSubcontractors(input,csiCode&&csiCode.id,page);},value:item.awardRecommendationId,onChange:function onChange(input){return _this2.handleAwardRecommendationChange(key,input.value,input.label);},placeholder:'Select Subcontractor'}))):'')),activeSubItemsKeys.map(function(subItemKey){var subItem=item.subItems[subItemKey];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_proposal_ProjectProposalSubItem__["a" /* default */],{key:subItem.division,itemKey:key,subItemKey:subItemKey,subItem:subItem,csiCode:csiCode,isLastSubItem:subItemKey===lastSubItemKey,costsShown:costsShown,readOnly:_this2.props.readOnly,showAwardRecommendation:_this2.props.showAwardRecommendation,onLoadSubcontractors:onLoadSubcontractors,onChange:onSubItemChange});}));}}]);return ProjectProposalItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProjectProposalItem.propTypes={itemKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,item:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,itemDelete:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,costsShown:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,showAwardRecommendation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,onCsiCodeOptions:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onTotalItemCost:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onLoadSubcontractors:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onSubItemChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};ProjectProposalItem.defaultProps={itemDelete:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),csiCodes:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_proposal_store_selectors__["a" /* getCsiCodes */])(state)};})(ProjectProposalItem));

/***/ }),
/* 2538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectProposalForm_css__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectProposalForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ProjectProposalForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProjectProposalSubItem_css__ = __webpack_require__(2539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProjectProposalSubItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ProjectProposalSubItem_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_autosize_textarea__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_autosize_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_autosize_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_settings_png__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_settings_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_images_settings_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_OutsideAlerter__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_dropdown_SearchableDropDownPaginated__ = __webpack_require__(142);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectProposalSubItem=function(_Component){_inherits(ProjectProposalSubItem,_Component);function ProjectProposalSubItem(props){_classCallCheck(this,ProjectProposalSubItem);var _this=_possibleConstructorReturn(this,(ProjectProposalSubItem.__proto__||Object.getPrototypeOf(ProjectProposalSubItem)).call(this,props));_this.handleSubItemChange=function(attribute,value){var _this$props=_this.props,itemKey=_this$props.itemKey,subItemKey=_this$props.subItemKey,onChange=_this$props.onChange;onChange(itemKey,subItemKey,attribute,value);};_this.handleAwardRecommendationChange=function(id,name){var _this$props2=_this.props,itemKey=_this$props2.itemKey,subItemKey=_this$props2.subItemKey,onChange=_this$props2.onChange;onChange(itemKey,subItemKey,'awardRecommendationId',id);onChange(itemKey,subItemKey,'awardRecommendationName',name);};_this.handleSubItemDelete=function(){var confirmed=window.confirm('Are you sure?');confirmed&&_this.handleSubItemChange('delete',true);};_this.handleMenuToggle=function(){var subItemMenu=_this.state.subItemMenu;_this.setState({subItemMenu:!subItemMenu});};_this.renderSettings=function(){var subItemMenu=_this.state.subItemMenu;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'proposal-item-settings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-icon',onClick:_this.handleMenuToggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10_images_settings_png___default.a,alt:'settings'})),subItemMenu&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_OutsideAlerter__["a" /* default */],{onClickOutside:_this.handleMenuToggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu-item',onClick:_this.handleSubItemDelete},'Delete'))));};_this.state={subItemMenu:false};return _this;}_createClass(ProjectProposalSubItem,[{key:'render',value:function render(){var _this2=this;var _props=this.props,subItem=_props.subItem,csiCode=_props.csiCode,isLastSubItem=_props.isLastSubItem,currentProject=_props.currentProject,costsShown=_props.costsShown,readOnly=_props.readOnly,showAwardRecommendation=_props.showAwardRecommendation,onLoadSubcontractors=_props.onLoadSubcontractors;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'project-proposal-sub-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,!readOnly&&isLastSubItem&&this.renderSettings()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,subItem.division),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,readOnly?subItem.label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_autosize_textarea___default.a,{rows:1,placeholder:'Add Summary',defaultValue:subItem.label||'',onBlur:function onBlur(e){return _this2.handleSubItemChange('label',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,costsShown&&(readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__["a" /* default */],{value:subItem.tradeCosts||'',format:'$ 0,0'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__["a" /* default */],{placeholder:'$0',value:subItem.tradeCosts?__WEBPACK_IMPORTED_MODULE_8_numeral___default()(subItem.tradeCosts).format('$ 0,0'):'',onChange:function onChange(value){return _this2.handleSubItemChange('tradeCosts',__WEBPACK_IMPORTED_MODULE_8_numeral___default()(value).value());}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,costsShown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__["a" /* default */],{value:subItem.tradeCosts?subItem.tradeCosts/currentProject.sq_footage:'',format:'$ 0,0.[00]'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,readOnly?subItem.awardRecommendationName:subItem.awardRecommendationName?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'award-recommendation-selected',onClick:function onClick(){_this2.handleAwardRecommendationChange(null,null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'remove'},'X'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,subItem.awardRecommendationName)):showAwardRecommendation?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'award-recommendation-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'award-recommendation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-row-plus'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_dropdown_SearchableDropDownPaginated__["a" /* default */],{loadOptions:function loadOptions(input,page){return onLoadSubcontractors(input,csiCode&&csiCode.id,page);},value:subItem.awardRecommendationId,onChange:function onChange(input){return _this2.handleAwardRecommendationChange(input.value,input.label);},placeholder:'Select Subcontractor'}))):''));}}]);return ProjectProposalSubItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProjectProposalSubItem.propTypes={itemKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,subItemKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,subItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,csiCode:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,isLastSubItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,costsShown:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,showAwardRecommendation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,onLoadSubcontractors:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};ProjectProposalSubItem.defaultProps={isLastSubItem:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state)};})(ProjectProposalSubItem));

/***/ }),
/* 2539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectProposalForm_css__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectProposalForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ProjectProposalForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProjectProposalAddlSubItem_css__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProjectProposalAddlSubItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ProjectProposalAddlSubItem_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_proposal_store_actions__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_settings_png__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_settings_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_images_settings_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_OutsideAlerter__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_proposal_ProjectProposalAddlSubItem__ = __webpack_require__(2541);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectProposalAddlItem=function(_Component){_inherits(ProjectProposalAddlItem,_Component);function ProjectProposalAddlItem(props){_classCallCheck(this,ProjectProposalAddlItem);var _this=_possibleConstructorReturn(this,(ProjectProposalAddlItem.__proto__||Object.getPrototypeOf(ProjectProposalAddlItem)).call(this,props));_this.handleAddlItemChange=function(value){var _this$props=_this.props,itemKey=_this$props.itemKey,itemRatio=_this$props.itemRatio,onChange=_this$props.onChange,onRatioChange=_this$props.onRatioChange;onChange(itemKey,value);itemRatio!==null&&onRatioChange&&onRatioChange(itemKey,null,value);};_this.handleRatioChange=function(value){var _this$props2=_this.props,itemKey=_this$props2.itemKey,onRatioChange=_this$props2.onRatioChange;onRatioChange&&onRatioChange(itemKey,value);};_this.handleAddSubcategory=function(){var _this$props3=_this.props,itemKey=_this$props3.itemKey,subItems=_this$props3.subItems,dispatch=_this$props3.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_proposal_store_actions__["j" /* newAddlItem */])(itemKey,subItems));_this.handleMenuToggle();};_this.handleMenuToggle=function(){var addlItemMenu=_this.state.addlItemMenu;_this.setState({addlItemMenu:!addlItemMenu});};_this.renderSettings=function(){var addlItemMenu=_this.state.addlItemMenu;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'proposal-item-settings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-icon',onClick:_this.handleMenuToggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10_images_settings_png___default.a,alt:'settings'})),addlItemMenu&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_OutsideAlerter__["a" /* default */],{onClickOutside:_this.handleMenuToggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu-item',onClick:_this.handleAddSubcategory},'Add Subcategory'))));};_this.activeSubItemsKeys=function(){var subItems=_this.props.subItems;return Object.keys(subItems||{}).filter(function(subItemKey){return!subItems[subItemKey].delete;});};_this.state={addlItemMenu:false};return _this;}_createClass(ProjectProposalAddlItem,[{key:'render',value:function render(){var _this2=this;var _props=this.props,itemKey=_props.itemKey,itemValue=_props.itemValue,itemTitle=_props.itemTitle,itemTotalCost=_props.itemTotalCost,itemRatio=_props.itemRatio,subItems=_props.subItems,currentProject=_props.currentProject,readOnly=_props.readOnly;var activeSubItemsKeys=this.activeSubItemsKeys();var hasSubItems=activeSubItemsKeys.length>0;var lastSubItemKey=activeSubItemsKeys[activeSubItemsKeys.length-1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,hasSubItems&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,!readOnly&&this.renderSettings()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,itemTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__["a" /* default */],{value:itemTotalCost||'',format:'$ 0,0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__["a" /* default */],{value:itemTotalCost?itemTotalCost/currentProject.sq_footage:'',format:'$ 0,0.[00]'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:hasSubItems?'project-proposal-addl-sub-item':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,!readOnly&&!hasSubItems&&this.renderSettings()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,itemTitle,hasSubItems?' - Original Cost':''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__["a" /* default */],{value:itemValue||'',format:'$ 0,0'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__["a" /* default */],{placeholder:'$0',value:itemValue?__WEBPACK_IMPORTED_MODULE_8_numeral___default()(itemValue).format('$ 0,0'):'',onChange:function onChange(value){return _this2.handleAddlItemChange(__WEBPACK_IMPORTED_MODULE_8_numeral___default()(value).value());}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__["a" /* default */],{value:itemValue?itemValue/currentProject.sq_footage:'',format:'$ 0,0.[00]'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,itemRatio!==null&&(readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_Number__["a" /* default */],{value:itemRatio||'',format:'0 %'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-item-ratio'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_input_Input__["a" /* default */],{placeholder:'0',value:itemRatio?__WEBPACK_IMPORTED_MODULE_8_numeral___default()(itemRatio*100).format('0'):'',onChange:function onChange(value){return _this2.handleRatioChange(__WEBPACK_IMPORTED_MODULE_8_numeral___default()(value/100).value());}}),'%')))),activeSubItemsKeys.map(function(subItemKey){var subItem=subItems[subItemKey];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_proposal_ProjectProposalAddlSubItem__["a" /* default */],{key:subItemKey,itemKey:itemKey,subItemKey:subItemKey,subItem:subItem,isLastSubItem:subItemKey===lastSubItemKey,readOnly:readOnly});}));}}]);return ProjectProposalAddlItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProjectProposalAddlItem.propTypes={itemKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,itemValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),itemTotalCost:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),itemTitle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,itemRatio:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,subItems:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,onRatioChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};ProjectProposalAddlItem.defaultProps={itemValue:'',itemTotalCost:'',itemRatio:null,onRatioChange:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state)};})(ProjectProposalAddlItem));

/***/ }),
/* 2541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectProposalForm_css__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectProposalForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ProjectProposalForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProjectProposalAddlSubItem_css__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProjectProposalAddlSubItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ProjectProposalAddlSubItem_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_proposal_store_actions__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_settings_png__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_settings_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_images_settings_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_OutsideAlerter__ = __webpack_require__(207);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectProposalAddlSubItem=function(_Component){_inherits(ProjectProposalAddlSubItem,_Component);function ProjectProposalAddlSubItem(props){_classCallCheck(this,ProjectProposalAddlSubItem);var _this=_possibleConstructorReturn(this,(ProjectProposalAddlSubItem.__proto__||Object.getPrototypeOf(ProjectProposalAddlSubItem)).call(this,props));_this.handleChange=function(attribute,value){var _this$props=_this.props,itemKey=_this$props.itemKey,subItemKey=_this$props.subItemKey,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_proposal_store_actions__["B" /* updateProjectProposalAddlItemValue */])(itemKey,subItemKey,attribute,value));};_this.handleDelete=function(){var confirmed=window.confirm('Are you sure?');confirmed&&_this.handleChange('delete',true);};_this.handleMenuToggle=function(){var addlItemMenu=_this.state.addlItemMenu;_this.setState({addlItemMenu:!addlItemMenu});};_this.renderSettings=function(){var addlItemMenu=_this.state.addlItemMenu;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'proposal-item-settings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-icon',onClick:_this.handleMenuToggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11_images_settings_png___default.a,alt:'settings'})),addlItemMenu&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_OutsideAlerter__["a" /* default */],{onClickOutside:_this.handleMenuToggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu-item',onClick:_this.handleDelete},'Delete'))));};_this.state={addlItemMenu:false};return _this;}_createClass(ProjectProposalAddlSubItem,[{key:'render',value:function render(){var _this2=this;var _props=this.props,subItem=_props.subItem,isLastSubItem=_props.isLastSubItem,currentProject=_props.currentProject,readOnly=_props.readOnly;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'project-proposal-addl-sub-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,!readOnly&&isLastSubItem&&this.renderSettings()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,readOnly?subItem.summary:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea___default.a,{rows:1,placeholder:'Add Summary',defaultValue:subItem.summary||'',onBlur:function onBlur(e){return _this2.handleChange('summary',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:subItem.cost||'',format:'$ 0,0'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{placeholder:'$0',value:subItem.cost?__WEBPACK_IMPORTED_MODULE_9_numeral___default()(subItem.cost).format('$ 0,0'):'',onChange:function onChange(value){return _this2.handleChange('cost',__WEBPACK_IMPORTED_MODULE_9_numeral___default()(value).value());}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Number__["a" /* default */],{value:subItem.cost?subItem.cost/currentProject.sq_footage:'',format:'$ 0,0.[00]'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null));}}]);return ProjectProposalAddlSubItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProjectProposalAddlSubItem.propTypes={itemKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,subItemKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,subItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,isLastSubItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired};ProjectProposalAddlSubItem.defaultProps={isLastSubItem:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state)};})(ProjectProposalAddlSubItem));

/***/ }),
/* 2542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectDirectory_css__ = __webpack_require__(2543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectDirectory_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProjectDirectory_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_print_white_svg__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_print_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_print_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_mail_white_svg__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_mail_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_mail_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_pdf_viewer_PdfViewer__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_modal_MessageModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_email_modal_store_actions__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_email_modal_store_selectors__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_store_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_directory_NewContributorModal__ = __webpack_require__(2544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_directory_SelectUsersModal__ = __webpack_require__(2554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_directory_UserModal__ = __webpack_require__(2557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_shared_checkbox_LabeledBellCheckBox__ = __webpack_require__(2560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_shared_OutsideAlerter__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_images_settings_png__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_images_settings_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_images_settings_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_admin_projects_details_project_email_modal_ProjectEmailModal__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_services_api_users_api__ = __webpack_require__(123);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectDirectory=function(_Component){_inherits(ProjectDirectory,_Component);function ProjectDirectory(props){_classCallCheck(this,ProjectDirectory);var _this=_possibleConstructorReturn(this,(ProjectDirectory.__proto__||Object.getPrototypeOf(ProjectDirectory)).call(this,props));_initialiseProps.call(_this);var currentUser=props.currentUser,currentProject=props.currentProject;_this.showActions=__WEBPACK_IMPORTED_MODULE_23_domain_enterprise__["a" /* Enterprise */].showActions(currentUser);_this.primary=currentProject?__WEBPACK_IMPORTED_MODULE_23_domain_enterprise__["a" /* Enterprise */].primary(currentProject.contributor_type):false;return _this;}_createClass(ProjectDirectory,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.currentProject){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["j" /* loadDirectoryRequest */])(this.props.currentProject.id));}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.directory&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-directory'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-directory-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'contributors-table-title'},'Primary'),(this.showActions||this.primary)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button button-gray',icon:__WEBPACK_IMPORTED_MODULE_4_images_mail_white_svg___default.a,label:'Email',onClick:this.handleShowEmailModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button button-gray',icon:__WEBPACK_IMPORTED_MODULE_3_images_print_white_svg___default.a,label:'View PDF',onClick:this.handleViewPdf}),this.showActions&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button button-orange',label:'Add Contributor',onClick:this.handleAddContributor}))),this.projectContributorsByPrimary(true).length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__["a" /* default */],{rows:[],emptyMessage:'No Contributors Yet'}):this.mapContributors(true),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-directory-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'contributors-table-title'},'Subcontractors, Vendors')),this.projectContributorsByPrimary(false).length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__["a" /* default */],{rows:[],emptyMessage:'No Contributors Yet'}):this.mapContributors(false),this.props.showNewContributorModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_directory_NewContributorModal__["a" /* default */],null),this.props.showEditUserModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_directory_UserModal__["a" /* default */],{show:this.props.showEditUserModal,companyType:this.props.editedUser.accountable_type,handleClose:this.handleCloseEditUserModal,handleSubmit:this.handleEditUserOnSubmit,initialValues:this.getInitialValuesForEditedUser(this.props.editedUser)}),this.props.showSelectUsersForm&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_directory_SelectUsersModal__["a" /* default */],{show:this.props.showSelectUsersForm,users:this.props.serviceProviderUsers,selectedUsers:this.props.currentContributor.users,handleSubmit:this.handleSelectUsers,handleClose:this.handleSelectUsersClose}),this.props.showInviteUserForm&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_directory_UserModal__["a" /* default */],{show:this.props.showInviteUserForm,companyType:this.props.currentContributor.company_type,handleSubmit:this.handleInviteUser,handleClose:this.handleInviteUserClose}),this.props.showDirectoryPdfViewer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:this.props.directoryPdf,type:'blob'},show:this.props.showDirectoryPdfViewer,onClose:this.handlePdfViewerClose}),this.props.showEmailModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_components_admin_projects_details_project_email_modal_ProjectEmailModal__["a" /* default */],{title:this.buildEmailModalTitle(this.props.currentProject),handleSendEmail:function handleSendEmail(emailsData){return _this2.handleSendEmail(emailsData);},projectId:this.props.currentProject.id,initialSubject:this.buildEmailModalSubject(this.props.currentProject),initialMessage:this.buildEmailModalMessage(this.props.currentProject)}),this.renderSendInviteSuccess(),this.renderActivationLinkSuccess()));}}]);return ProjectDirectory;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this3=this;this.projectContributorsByPrimary=function(primary){var contributors=_this3.props.directory.project_contributors.filter(function(contrib){return contrib.primary===primary;});if(primary){return contributors;}else{return contributors.sort(function(pc1,pc2){return pc1.csi_code.division<pc2.csi_code.division?-1:1;});}};this.mapContributors=function(primary){var currentProject=_this3.props.currentProject;return _this3.projectContributorsByPrimary(primary).map(function(contrib){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:contrib.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contributor-header'},_this3.showActions&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contributor-settings',onClick:function onClick(){return _this3.handleContributorSettingsClick(contrib.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_21_images_settings_png___default.a,alt:'settings'}),_this3.props.contributorSettings[contrib.id]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_shared_OutsideAlerter__["a" /* default */],{onClickOutside:function onClickOutside(){return _this3.handleContributorSettingsClick(null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu-item',onClick:function onClick(){return _this3.handleContributorSelectUsersClick(contrib);}},'Select Users'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu-item',onClick:function onClick(){return _this3.handleContributorInviteUserClick(contrib);}},'Invite User'),(contrib.company_type!=='Client'||contrib.company_id!==currentProject.client_id)&&contrib.company_type!=='GeneralContractor'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu-item settings-menu-delete',onClick:function onClick(){return _this3.handleContributorDeleteClick(contrib.id);}},'Delete'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contributor-title-container'+(_this3.showActions?'':' no-settings')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'contributor-title'},primary?contrib.company_type_title+' - '+(contrib.company.name||contrib.company.company_name):contrib.csi_code.division+' '+contrib.csi_code.label+' - '+contrib.company.name)),_this3.showNotifications(contrib)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_shared_checkbox_LabeledBellCheckBox__["a" /* default */],{checked:!!contrib.send_notifications,onChange:function onChange(value){return _this3.handleUpdateProjectContributor(contrib.id,{sendNotifications:value});},label:'Notifications'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table contributors-table',rows:_this3.mapContributorUsers(contrib.users,contrib.id),emptyMessage:'No Users'}));});};this.showNotifications=function(contrib){var currentUser=_this3.props.currentUser;return _this3.showActions||contrib.company_id===currentUser.accountable_id&&contrib.company_type===currentUser.accountable_type;};this.pendingInvite=function(user){return!!user.invitation_sent_at&&!user.invitation_accepted_at;};this.renderMenuForClient=function(user,contribId){var id=user.id,first_name=user.first_name,last_name=user.last_name;var usedId=''+id+contribId;var pendingInvite=_this3.pendingInvite(user);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-setting-wrapper'},_this3.showActions&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-settings',onClick:function onClick(){return _this3.handleUserSettingClick(usedId);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_21_images_settings_png___default.a,alt:'settings'}),_this3.props.userSettings[usedId]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_shared_OutsideAlerter__["a" /* default */],{onClickOutside:function onClickOutside(){return _this3.handleUserSettingClick(usedId);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu-item',onClick:function onClick(){return _this3.toggleUserEditMenu(user);}},'Edit User'),pendingInvite&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu-item',onClick:function onClick(){return _this3.handleSendInvite(user);}},'Resend Invite'),pendingInvite&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu-item',onClick:function onClick(){return _this3.handleGetActivationLink(user);}},'Get Activation Link'))))),first_name+' '+last_name);};this.mapContributorUsers=function(users,contribId){var currentUser=_this3.props.currentUser;return users.map(function(user){return[_this3.renderMenuForClient(user,contribId),user.title,user.email,''+Object(__WEBPACK_IMPORTED_MODULE_9_services_utils_text_util__["c" /* formatPhoneNumber */])(user.phone_number)+(user.phone_ext?' ext '+user.phone_ext:''),__WEBPACK_IMPORTED_MODULE_25_services_api_users_api__["b" /* usersApi */].resendInviteLink(currentUser,user)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'linkable',onClick:function onClick(){return _this3.handleResendInvite(user.id);}},'Resend Invite'):''];});};this.handleResendInvite=function(id){__WEBPACK_IMPORTED_MODULE_25_services_api_users_api__["b" /* usersApi */].resendInvite(id);};this.handleContributorSettingsClick=function(id){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["w" /* toggleContributorSettings */])(id));};this.handleUserSettingClick=function(id){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["x" /* toggleUserSettings */])(id));};this.toggleUserEditMenu=function(user){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["r" /* setShowEditUserModal */])(true,user));};this.handleUpdateProjectContributor=function(id,values){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["y" /* updateProjectContributor */])(_this3.props.currentProject.id,id,values));};this.handleContributorSelectUsersClick=function(contrib){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["k" /* loadServiceProviderUsers */])(contrib.company_type,contrib.company_id)).then(function(response){if(response.ok){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["o" /* setCurrentContributor */])(contrib));_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["v" /* setShowSelectUsersForm */])(true));}});};this.handleContributorInviteUserClick=function(contrib){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["o" /* setCurrentContributor */])(contrib));_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["s" /* setShowInviteUserForm */])(true));};this.handleSelectUsers=function(values){var _props=_this3.props,currentProject=_props.currentProject,currentContributor=_props.currentContributor,dispatch=_props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["y" /* updateProjectContributor */])(currentProject.id,currentContributor.id,values)).then(function(response){if(response.ok){_this3.handleSelectUsersClose();}});};this.handleInviteUser=function(values){var _props2=_this3.props,currentProject=_props2.currentProject,currentContributor=_props2.currentContributor,dispatch=_props2.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["h" /* inviteUser */])(currentContributor.company_type,currentContributor.company_id,values)).then(function(response){if(response.ok){var userIds=currentContributor.users.map(function(usr){return usr.id;}).concat(response.user.id);dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["y" /* updateProjectContributor */])(currentProject.id,currentContributor.id,{userIds:userIds})).then(function(response){if(response.ok){_this3.handleInviteUserClose();}});}});};this.handleSendInvite=function(user){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["n" /* sendInvite */])(user)).then(function(response){if(response.ok){_this3.setState({inviteSentTo:user.email});}});};this.hideSendInviteSuccess=function(){_this3.setState({inviteSentTo:''});};this.renderSendInviteSuccess=function(){var inviteSentTo=!!_this3.state&&_this3.state.inviteSentTo;return!!inviteSentTo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_modal_MessageModal__["a" /* default */],{show:!!inviteSentTo,message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Invitation successfully sent to',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),inviteSentTo),onHide:_this3.hideSendInviteSuccess});};this.handleGetActivationLink=function(user){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["a" /* activationLink */])(user)).then(function(response){if(response.ok){_this3.setState({activationUser:user.first_name+' '+user.last_name,activationLink:response.instructions.accept_invitation_url});}});};this.hideActivationLinkSuccess=function(){_this3.setState({activationUser:'',activationLink:''});};this.renderActivationLinkSuccess=function(){var activationUser=!!_this3.state&&_this3.state.activationUser;var activationLink=!!_this3.state&&_this3.state.activationLink;return!!activationUser&&!!activationLink&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_modal_MessageModal__["a" /* default */],{show:!!activationUser&&!!activationLink,message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activation-link'},'Activation Link for ',activationUser,':',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),activationLink),onHide:_this3.hideActivationLinkSuccess});};this.handleSelectUsersClose=function(){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["v" /* setShowSelectUsersForm */])(false));};this.handleInviteUserClose=function(){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["s" /* setShowInviteUserForm */])(false));};this.handlePdfViewerClose=function(){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["q" /* setShowDirectoryPdfViewer */])(false));};this.handleContributorDeleteClick=function(id){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["d" /* deleteProjectContributor */])(_this3.props.currentProject.id,id));};this.handleAddContributor=function(){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["u" /* setShowNewContributorModal */])(true));};this.handleViewPdf=function(){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["i" /* loadDirectoryPdfRequest */])(_this3.props.currentProject.id)).then(function(response){if(response.ok){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["q" /* setShowDirectoryPdfViewer */])(true));}});};this.handleShowEmailModal=function(){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_email_modal_store_actions__["j" /* setShowEmailModal */])(true));};this.handleSendEmail=function(emailsData){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_store_actions__["d" /* sendProjectResourceEmails */])(_this3.props.directory.id,'Directory',emailsData));};this.buildEmailModalTitle=function(project){return'Directory (Project #'+project.number+': '+project.name+')';};this.buildEmailModalSubject=function(project){return project.number+', '+project.name+' - Directory';};this.buildEmailModalMessage=function(project){var location='';if(project.building&&project.building.location){var buildingLocation=project.building.location;location=' at '+buildingLocation.street_address_1+', '+buildingLocation.city+' '+buildingLocation.state;}return'Please find the attached Directory for Project '+project.name+location+'. If you have any questions, please reach out via chat or email.';};this.handleCloseEditUserModal=function(){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["r" /* setShowEditUserModal */])(false));};this.handleEditUserOnSubmit=function(values){_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_directory_store_actions__["e" /* editUser */])(values));};this.getInitialValuesForEditedUser=function(user){return{id:user.id,type:user.accountable_type,firstName:user.first_name,lastName:user.last_name,email:user.email,phoneNumber:Object(__WEBPACK_IMPORTED_MODULE_9_services_utils_text_util__["c" /* formatPhoneNumber */])(user.phone_number),phoneExt:user.phone_ext,title:user.title,accountableId:user.accountable_id};};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),directory:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__["c" /* getDirectory */])(state),directoryPdf:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__["d" /* getDirectoryPdf */])(state),serviceProviderUsers:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__["g" /* getServiceProviderUsers */])(state),contributorSettings:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__["a" /* getContributorSettings */])(state),userSettings:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__["n" /* getUserSettings */])(state),editedUser:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__["e" /* getEditedUser */])(state),showNewContributorModal:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__["l" /* getShowNewContributorModal */])(state),showEditUserModal:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__["i" /* getShowEditUserModal */])(state),showSelectUsersForm:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__["m" /* getShowSelectUsersForm */])(state),showInviteUserForm:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__["j" /* getShowInviteUserForm */])(state),showDirectoryPdfViewer:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__["h" /* getShowDirectoryPdfViewer */])(state),currentContributor:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__["b" /* getCurrentContributor */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_22_selectors_authentication__["d" /* getCurrentUser */])(state),showEmailModal:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_email_modal_store_selectors__["g" /* getShowEmailModal */])(state)};})(ProjectDirectory));

/***/ }),
/* 2543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_directory_store_selectors__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_directory_store_actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_proposal_store_actions__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_proposal_store_selectors__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_directory_NewContributorForm__ = __webpack_require__(2545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_directory_NewCompanyForm__ = __webpack_require__(2547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_directory_NewContributorModal_css__ = __webpack_require__(2550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_directory_NewContributorModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_directory_NewContributorModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_slidedown__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_slidedown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_slidedown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_slidedown_lib_slidedown_css__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_slidedown_lib_slidedown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_slidedown_lib_slidedown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_domain_service_provider_type_enum__ = __webpack_require__(164);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewContributorModal=function(_Component){_inherits(NewContributorModal,_Component);function NewContributorModal(props){_classCallCheck(this,NewContributorModal);var _this=_possibleConstructorReturn(this,(NewContributorModal.__proto__||Object.getPrototypeOf(NewContributorModal)).call(this,props));_initialiseProps.call(_this);_this.firstCompaniesLoad=true;props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_directory_store_actions__["g" /* initNewContributorModal */])());return _this;}_createClass(NewContributorModal,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_proposal_store_actions__["g" /* loadCsiCodes */])());}},{key:'render',value:function render(){var initialValues={contributorCompanyType:this.props.newContributorType,userIds:[],sendNotifications:true};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.props.currentProject&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{className:'new-contributor-modal '+(this.props.showNewCompanyForm?'new-company':''),show:this.props.show,subTitle:this.formModalSubTitle(),title:this.formModalTitle(),onBack:this.props.showNewCompanyForm?this.handleBack:undefined,onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_slidedown__["SlideDown"],null,this.props.showNewCompanyForm&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_directory_NewCompanyForm__["a" /* default */],{initialValues:initialValues,types:__WEBPACK_IMPORTED_MODULE_15_domain_service_provider_type_enum__["a" /* ServiceProviderOptions */],titles:__WEBPACK_IMPORTED_MODULE_15_domain_service_provider_type_enum__["c" /* ServiceProviderTitles */],newContributorType:this.props.newContributorType,handleNewContributorTypeChange:this.handleNewContributorTypeChange,csiCodes:this.props.csiCodes,onSubmit:this.handleNewCompanyOnSubmit,onClose:this.handleBack})),!this.props.showNewCompanyForm&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_directory_NewContributorForm__["a" /* default */],{initialValues:initialValues,types:__WEBPACK_IMPORTED_MODULE_15_domain_service_provider_type_enum__["a" /* ServiceProviderOptions */],newContributorType:this.props.newContributorType,loadServiceProviders:this.loadServiceProviders,handleNewContributorTypeChange:this.handleNewContributorTypeChange,handleCompanyOptionClick:this.handleCompanyOptionClick,companyUsers:this.props.serviceProviderUsers,csiCodes:this.props.csiCodes,onSubmit:this.handleOnSubmit,onClose:this.handleClose})));}}]);return NewContributorModal;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.handleClose=function(){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_directory_store_actions__["u" /* setShowNewContributorModal */])(false));_this2.handleBack();};this.handleBack=function(){_this2.firstCompaniesLoad=true;_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_directory_store_actions__["t" /* setShowNewCompanyForm */])(false));};this.handleOnSubmit=function(values){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_directory_store_actions__["b" /* createProjectContributor */])(_this2.props.currentProject.id,values)).then(function(response){if(response.ok){_this2.handleClose();}});};this.handleNewCompanyOnSubmit=function(values){var attrs={name:values.name,image:values.logo&&values.logo[0],contact:Object.assign({},values,{phoneExt:values.phoneExt||''})};_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_directory_store_actions__["c" /* createServiceProvider */])(values.contributorCompanyType,attrs)).then(function(response){if(response.ok){var company=response.serviceProvider;_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_directory_store_actions__["k" /* loadServiceProviderUsers */])(values.contributorCompanyType,company.id)).then(function(response){if(response.ok){values.contributorCompanyType=values.contributorCompanyType;values.contributorCompanyId=company.id;values.userIds=response.users.map(function(user){return user.id;});_this2.handleOnSubmit(values);}});}});};this.loadServiceProviders=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(input,page){var options;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(_this2.props.newContributorType){_context.next=2;break;}return _context.abrupt('return');case 2:options=[];if(_this2.firstCompaniesLoad){_this2.firstCompaniesLoad=false;options.push({value:'newCompany',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'new-company-option'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'new-company-option-plus'},'+ '),'New Company',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null))});}return _context.abrupt('return',_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_directory_store_actions__["f" /* fetchServiceProviders */])(_this2.props.newContributorType,input,page)).then(function(response){if(response.ok){return{ok:true,options:options.concat(response.serviceProviders.map(function(element){return{value:element.id,label:element.name};})),hasMore:true};}}));case 5:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x,_x2){return _ref.apply(this,arguments);};}();this.handleNewContributorTypeChange=function(props,value){_this2.firstCompaniesLoad=true;_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_directory_store_actions__["l" /* loadServiceProviderUsersSuccess */])([]));_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_directory_store_actions__["p" /* setNewContributorType */])(value));props.input.onChange(value);};this.handleCompanyOptionClick=function(props,input){if(!input){return;}var value=input.value;if(value==='newCompany'){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_directory_store_actions__["t" /* setShowNewCompanyForm */])(true));}else{props.input.onChange(value);_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_directory_store_actions__["k" /* loadServiceProviderUsers */])(_this2.props.newContributorType,value));}};this.formModalTitle=function(){return _this2.props.showNewCompanyForm?'New Company Details':'Add Contributor';};this.formModalSubTitle=function(){return _this2.props.showNewCompanyForm?[]:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['Projects',_this2.props.currentProject.name,'Add Contributor']});};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),show:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_directory_store_selectors__["l" /* getShowNewContributorModal */])(state),serviceProviderUsers:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_directory_store_selectors__["g" /* getServiceProviderUsers */])(state),showNewCompanyForm:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_directory_store_selectors__["k" /* getShowNewCompanyForm */])(state),newContributorType:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_directory_store_selectors__["f" /* getNewContributorType */])(state),csiCodes:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_proposal_store_selectors__["a" /* getCsiCodes */])(state)};})(NewContributorModal));

/***/ }),
/* 2545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_dropdown_SearchableDropDownPaginated__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_dropdown_arrow_png__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_dropdown_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_dropdown_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_directory_NewContributorForm_css__ = __webpack_require__(2546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_directory_NewContributorForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_directory_NewContributorForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_checkbox_LabeledCheckBox__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_select_MultipleSelectList__ = __webpack_require__(334);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewContributorForm=function(_Component){_inherits(NewContributorForm,_Component);function NewContributorForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewContributorForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewContributorForm.__proto__||Object.getPrototypeOf(NewContributorForm)).call.apply(_ref,[this].concat(args))),_this),_this.renderCompanySearchableDropDown=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_dropdown_SearchableDropDownPaginated__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,arrowRenderer:function arrowRenderer(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3_images_dropdown_arrow_png___default.a,alt:'arrow'});},withCreate:true,loadOptions:_this.props.loadServiceProviders,value:props.input.value,onChange:function onChange(input){return _this.props.handleCompanyOptionClick(props,input);}},props));},_this.renderTypeDropDown=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_dropdown_Dropdown__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(option){return _this.props.handleNewContributorTypeChange(props,option.value);}},props));},_this.renderDropDown=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_dropdown_Dropdown__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(option){return props.input.onChange(option&&option.value);}},props));},_this.renderMultipleSelect=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_select_MultipleSelectList__["a" /* default */],{options:props.options.map(function(user){return{id:user.id,selected:props.input.value.includes(user.id),value:user.first_name+' '+user.last_name+(user.title?' - '+user.title:'')};}),show:5,onSelect:function onSelect(id){return _this.handleUserSelection(props,id);}});},_this.handleUserSelection=function(props,id){if(props.input.value.includes(id)){props.input.onChange(props.input.value.filter(function(item){return item!==id;}));}else{props.input.onChange(props.input.value.concat(id));}},_this.renderCheckBox=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_checkbox_LabeledCheckBox__["a" /* default */],Object.assign({checked:!!props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewContributorForm,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'new-contributor-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.props.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Company Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderTypeDropDown,name:'contributorCompanyType',placeholder:'Select Type',options:this.props.types}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Company Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:7},this.props.newContributorType?this.props.types.map(function(type){if(_this2.props.newContributorType===type.value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{key:type.value,component:_this2.renderCompanySearchableDropDown,name:'contributorCompanyId',placeholder:'Select Company'});}return null;}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderCompanySearchableDropDown,name:'contributorCompanyId',placeholder:'Select Company'}))),this.props.newContributorType!=='Contractor'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Company Type Override'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{clearable:true,component:this.renderDropDown,name:'contributorCompanyTypeOverride',placeholder:'Select Type',disabled:!this.props.newContributorType,options:this.props.types.filter(function(type){return type.value!=='Contractor'&&type.value!==_this2.props.newContributorType;})}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Employees'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderMultipleSelect,name:'userIds',options:this.props.companyUsers}))),this.props.newContributorType==='Contractor'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'CSI Code'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderDropDown,name:'csiCodeId',placeholder:'Select Code',options:this.props.csiCodes.map(function(code){return{value:code.id,label:code.division+' - '+code.label};})}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:3}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderCheckBox,name:'sendNotifications',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'send-notifications-checkbox-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Notifications*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label-subtitle'},'Contacts will receive notifications for changes to the project.'))}))),this.props.invalid&&this.props.submitFailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'The outlined inputs should be added in order to add a Contributor.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:3}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange button-submit',type:'submit',value:'Add',disabled:this.props.invalid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-gray',type:'button',value:'Cancel',onClick:this.props.onClose})))));}}]);return NewContributorForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(values){var errors={};if(!values.contributorCompanyType){errors.contributorCompanyType='Required';}if(!values.contributorCompanyId){errors.contributorCompanyId='Required';}if(!values.userIds||values.userIds.length===0){errors.userIds='Required';}if(values.contributorCompanyType==='Contractor'){if(!values.csiCodeId){errors.csiCodeId='Required';}}return errors;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["f" /* reduxForm */])({form:'NewContributorForm',validate:validate})(NewContributorForm));

/***/ }),
/* 2546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_NewCompanyForm_css__ = __webpack_require__(2548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_NewCompanyForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_NewCompanyForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_checkbox_LabeledCheckBox__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_form_FormImageUpload__ = __webpack_require__(2549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_files_util__ = __webpack_require__(159);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewCompanyForm=function(_Component){_inherits(NewCompanyForm,_Component);function NewCompanyForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewCompanyForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewCompanyForm.__proto__||Object.getPrototypeOf(NewCompanyForm)).call.apply(_ref,[this].concat(args))),_this),_this.renderInput=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_input_Input__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));},_this.renderDropDown=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(option){return props.input.onChange(option.value);}},props));},_this.renderTypeDropDown=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(option){return _this.props.handleNewContributorTypeChange(props,option.value);}},props));},_this.renderCheckBox=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_checkbox_LabeledCheckBox__["a" /* default */],Object.assign({checked:!!props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewCompanyForm,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'new-company-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.props.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Company Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderTypeDropDown,name:'contributorCompanyType',placeholder:'Select Type',options:this.props.types}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Company Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'name',placeholder:'Company Name'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Company Logo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_7_components_shared_form_FormImageUpload__["a" /* default */],name:'logo',extensions:__WEBPACK_IMPORTED_MODULE_8_services_utils_files_util__["a" /* imageExtensions */]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'First Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'firstName',placeholder:'First Name'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Last Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'lastName',placeholder:'Last Name'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'email',placeholder:'Email'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Phone Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'phoneNumber',placeholder:'Phone Number'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'phoneExt',placeholder:'ext'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:4},this.props.newContributorType&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderDropDown,name:'title',placeholder:'Select Title',options:this.props.titles[this.props.newContributorType].map(function(title){return{value:title,label:title};})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderInput,name:'title',placeholder:'Or Type in'}))),this.props.newContributorType==='Contractor'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:3},'CSI Code'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderDropDown,name:'csiCodeId',placeholder:'Select Code',options:this.props.csiCodes.map(function(code){return{value:code.id,label:code.division+' - '+code.label};})}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:3}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:this.renderCheckBox,name:'sendNotifications',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'send-notifications-checkbox-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Notifications*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label-subtitle'},'Contacts will receive notifications for changes to the project.'))}))),this.props.invalid&&this.props.submitFailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'The outlined inputs should be added in order to add a Company.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:3}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange button-submit',type:'submit',value:'Save',disabled:this.props.invalid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-gray',type:'button',value:'Cancel',onClick:this.props.onClose})))));}}]);return NewCompanyForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(values){var errors={};if(!values.contributorCompanyType){errors.contributorCompanyType='Required';}if(!values.name){errors.name='Required';}if(!values.firstName){errors.firstName='Required';}if(!values.lastName){errors.lastName='Required';}if(!values.email){errors.email='Required';}if(!values.phoneNumber){errors.phoneNumber='Required';}if(!values.title){errors.title='Required';}if(values.contributorCompanyType==='Contractor'){if(!values.csiCodeId){errors.csiCodeId='Required';}}return errors;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["f" /* reduxForm */])({form:'NewCompanyForm',validate:validate})(NewCompanyForm));

/***/ }),
/* 2548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_button_SimpleButton__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_plus_icon_png__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_plus_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_plus_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_utils_files_util__ = __webpack_require__(159);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormImageUpload=function(_React$Component){_inherits(FormImageUpload,_React$Component);function FormImageUpload(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FormImageUpload);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FormImageUpload.__proto__||Object.getPrototypeOf(FormImageUpload)).call.apply(_ref,[this].concat(args))),_this),_this.state={images:[],imageIndexToRemove:0,showConfirmation:false},_this.renderButton=function(){var button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_SimpleButton__["a" /* default */],{className:'add-photos-button',img:__WEBPACK_IMPORTED_MODULE_6_images_plus_icon_png___default.a,label:'Add photo',onClick:_this.handleAddPhotoClick});if(_this.props.multiple||_this.state.images.length===0){return button;}return null;},_this.renderImages=function(images){if(images.length>0){return images.map(function(image,index){if(image.preview){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:image.preview,alt:image.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'remove-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5_images_remove_png___default.a,alt:'',onClick:_this.handleRemoveRequest.bind(_this,index)})));}return null;});}return null;},_this.adaptFileEvent=function(delegate){return function(e){var files=e.target.files;var newFiles=[].concat(_toConsumableArray(_this.state.images));for(var i=0;i<files.length;i++){if(Object(__WEBPACK_IMPORTED_MODULE_7_services_utils_files_util__["b" /* validateFile */])(files.item(i).name,_this.props.extensions)){var imagefile=files.item(i);var previewUrl=URL.createObjectURL(imagefile);imagefile.preview=previewUrl;newFiles.push(imagefile);}}_this.setState({images:newFiles});_this.fileUpload.value='';delegate(newFiles);};},_this.handleRemove=function(result){var _this$state=_this.state,imageIndexToRemove=_this$state.imageIndexToRemove,images=_this$state.images;var resultImages=[].concat(_toConsumableArray(images));if(result){resultImages.splice(imageIndexToRemove,1);_this.handleResetField(resultImages);}_this.setState({showConfirmation:false,imageIndexToRemove:0,images:resultImages});},_this.handleResetField=function(newImages){var _this$props=_this.props,name=_this$props.input.name,_this$props$meta=_this$props.meta,dispatch=_this$props$meta.dispatch,form=_this$props$meta.form;dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["c" /* change */])(form,name,newImages));},_this.handleAddPhotoClick=function(){_this.fileUpload.click();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FormImageUpload,[{key:'render',value:function render(){var _this2=this;var _props=this.props,multiple=_props.multiple,_props$input=_props.input,omitValue=_props$input.value,onChange=_props$input.onChange,onBlur=_props$input.onBlur,inputProps=_objectWithoutProperties(_props$input,['value','onChange','onBlur']),omitMeta=_props.meta,props=_objectWithoutProperties(_props,['multiple','input','meta']);var images=this.state.images;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-upload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'preview-container'},this.renderImages(images),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showConfirmation,message:'Are you sure?',onHide:this.handleRemove})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-upload-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.renderButton(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',Object.assign({onChange:this.adaptFileEvent(onChange),ref:function ref(input){_this2.fileUpload=input;},type:'file',style:{display:'none'},multiple:multiple,accept:this.props.extensions.join(', ')},inputProps,props)))));}},{key:'handleRemoveRequest',value:function handleRemoveRequest(index,e){e.preventDefault();this.setState({imageIndexToRemove:index,showConfirmation:true});}}]);return FormImageUpload;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);FormImageUpload.propTypes={multiple:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,extensions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)};FormImageUpload.defaultProps={multiple:false,extensions:[]};/* harmony default export */ __webpack_exports__["a"] = (FormImageUpload);

/***/ }),
/* 2550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1027);
var react_1 = tslib_1.__importDefault(__webpack_require__(0));
var prop_types_1 = tslib_1.__importDefault(__webpack_require__(1));
var chain_function_1 = tslib_1.__importDefault(__webpack_require__(2552));
var react_lifecycles_compat_1 = __webpack_require__(173);
var ChildMapping_1 = __webpack_require__(2553);
var propTypes = {
    component: prop_types_1.default.any,
    childFactory: prop_types_1.default.func,
    children: prop_types_1.default.node,
};
var defaultProps = {
    component: 'span',
    childFactory: function (child) { return child; },
};
var TransitionGroup = (function (_super) {
    tslib_1.__extends(TransitionGroup, _super);
    function TransitionGroup(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.performAppear = function (key, component) {
            _this.currentlyTransitioningKeys[key] = true;
            if (component.componentWillAppear) {
                component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
            }
            else {
                _this._handleDoneAppearing(key, component);
            }
        };
        _this._handleDoneAppearing = function (key, component) {
            if (component && component.componentDidAppear) {
                component.componentDidAppear();
            }
            delete _this.currentlyTransitioningKeys[key];
            var currentChildMapping = ChildMapping_1.getChildMapping(_this.props.children);
            if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
                _this.performLeave(key, component);
            }
        };
        _this.performEnter = function (key, component) {
            _this.currentlyTransitioningKeys[key] = true;
            if (component.componentWillEnter) {
                component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
            }
            else {
                _this._handleDoneEntering(key, component);
            }
        };
        _this._handleDoneEntering = function (key, component) {
            if (component && component.componentDidEnter) {
                component.componentDidEnter();
            }
            delete _this.currentlyTransitioningKeys[key];
            var currentChildMapping = ChildMapping_1.getChildMapping(_this.props.children);
            if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
                _this.performLeave(key, component);
            }
        };
        _this.performLeave = function (key, component) {
            _this.currentlyTransitioningKeys[key] = true;
            if (component && component.componentWillLeave) {
                component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
            }
            else {
                _this._handleDoneLeaving(key, component);
            }
        };
        _this._handleDoneLeaving = function (key, component) {
            if (component && component.componentDidLeave) {
                component.componentDidLeave();
            }
            delete _this.currentlyTransitioningKeys[key];
            var currentChildMapping = ChildMapping_1.getChildMapping(_this.props.children);
            if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
                _this.keysToEnter.push(key);
            }
            else {
                _this.setState(function (state) {
                    var newChildren = Object.assign({}, state.children);
                    delete newChildren[key];
                    return { children: newChildren };
                });
            }
        };
        _this.childRefs = Object.create(null);
        _this.currentlyTransitioningKeys = {};
        _this.keysToEnter = [];
        _this.keysToLeave = [];
        _this.state = {
            children: ChildMapping_1.getChildMapping(props.children),
        };
        return _this;
    }
    TransitionGroup.prototype.componentDidMount = function () {
        var initialChildMapping = this.state.children;
        for (var key in initialChildMapping) {
            if (initialChildMapping[key]) {
                this.performAppear(key, this.childRefs[key]);
            }
        }
    };
    TransitionGroup.getDerivedStateFromProps = function (props, state) {
        var nextChildMapping = ChildMapping_1.getChildMapping(props.children);
        var prevChildMapping = state.children;
        return {
            children: ChildMapping_1.mergeChildMappings(prevChildMapping, nextChildMapping),
        };
    };
    TransitionGroup.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        var nextChildMapping = ChildMapping_1.getChildMapping(this.props.children);
        var prevChildMapping = prevState.children;
        for (var key in nextChildMapping) {
            var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
            if (nextChildMapping[key] && !hasPrev &&
                !this.currentlyTransitioningKeys[key]) {
                this.keysToEnter.push(key);
            }
        }
        for (var key in prevChildMapping) {
            var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
            if (prevChildMapping[key] && !hasNext &&
                !this.currentlyTransitioningKeys[key]) {
                this.keysToLeave.push(key);
            }
        }
        var keysToEnter = this.keysToEnter;
        this.keysToEnter = [];
        keysToEnter.forEach(function (key) { return _this.performEnter(key, _this.childRefs[key]); });
        var keysToLeave = this.keysToLeave;
        this.keysToLeave = [];
        keysToLeave.forEach(function (key) { return _this.performLeave(key, _this.childRefs[key]); });
    };
    TransitionGroup.prototype.render = function () {
        var _this = this;
        var childrenToRender = [];
        var _loop_1 = function (key) {
            var child = this_1.state.children[key];
            if (child) {
                var isCallbackRef = typeof child.ref !== 'string';
                var factoryChild = this_1.props.childFactory(child);
                var ref = function (r) {
                    _this.childRefs[key] = r;
                };
                if (!isCallbackRef) {
                    throw new Error('string refs are not supported on children of TransitionGroup. ' +
                        'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute');
                }
                if (factoryChild === child && isCallbackRef) {
                    ref = chain_function_1.default(child.ref, ref);
                }
                childrenToRender.push(react_1.default.cloneElement(factoryChild, {
                    key: key,
                    ref: ref,
                }));
            }
        };
        var this_1 = this;
        for (var key in this.state.children) {
            _loop_1(key);
        }
        var props = Object.assign({}, this.props);
        delete props.transitionLeave;
        delete props.transitionName;
        delete props.transitionAppear;
        delete props.transitionEnter;
        delete props.childFactory;
        delete props.transitionLeaveTimeout;
        delete props.transitionEnterTimeout;
        delete props.transitionAppearTimeout;
        delete props.component;
        return react_1.default.createElement(this.props.component, props, childrenToRender);
    };
    TransitionGroup.displayName = 'TransitionGroup';
    return TransitionGroup;
}(react_1.default.Component));
TransitionGroup.propTypes = propTypes;
TransitionGroup.defaultProps = defaultProps;
exports.default = react_lifecycles_compat_1.polyfill(TransitionGroup);
//# sourceMappingURL=TransitionGroup.js.map

/***/ }),
/* 2552 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 2553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __webpack_require__(0);
function getChildMapping(children) {
    if (!children) {
        return children;
    }
    var result = {};
    react_1.Children.map(children, function (child) { return child; })
        .forEach(function (child) {
        result[child.key] = child;
    });
    return result;
}
exports.getChildMapping = getChildMapping;
function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        if (next.hasOwnProperty(key)) {
            return next[key];
        }
        return prev[key];
    }
    var nextKeysPending = {};
    var pendingKeys = [];
    for (var prevKey in prev) {
        if (next.hasOwnProperty(prevKey)) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        }
        else {
            pendingKeys.push(prevKey);
        }
    }
    var i;
    var childMapping = {};
    for (var nextKey in next) {
        if (nextKeysPending.hasOwnProperty(nextKey)) {
            for (i = 0; i < nextKeysPending[nextKey].length; i++) {
                var pendingNextKey = nextKeysPending[nextKey][i];
                childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
            }
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    }
    for (i = 0; i < pendingKeys.length; i++) {
        childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    }
    return childMapping;
}
exports.mergeChildMappings = mergeChildMappings;
//# sourceMappingURL=ChildMapping.js.map

/***/ }),
/* 2554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_directory_SelectUsersForm__ = __webpack_require__(2555);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectUsersModal=function(_Component){_inherits(SelectUsersModal,_Component);function SelectUsersModal(){_classCallCheck(this,SelectUsersModal);return _possibleConstructorReturn(this,(SelectUsersModal.__proto__||Object.getPrototypeOf(SelectUsersModal)).apply(this,arguments));}_createClass(SelectUsersModal,[{key:'render',value:function render(){var _props=this.props,show=_props.show,users=_props.users,selectedUsers=_props.selectedUsers,handleSubmit=_props.handleSubmit,handleClose=_props.handleClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{show:show,title:'Select Users',onClose:handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_directory_SelectUsersForm__["a" /* default */],{initialValues:{userIds:selectedUsers.map(function(usr){return usr.id;})},users:users,onSubmit:handleSubmit,onClose:handleClose}));}}]);return SelectUsersModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelectUsersModal.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,users:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,selectedUsers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,handleSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SelectUsersModal);

/***/ }),
/* 2555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_directory_SelectUsersForm_css__ = __webpack_require__(2556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_directory_SelectUsersForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_directory_SelectUsersForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_select_MultipleSelectList__ = __webpack_require__(334);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectUsersForm=function(_Component){_inherits(SelectUsersForm,_Component);function SelectUsersForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SelectUsersForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SelectUsersForm.__proto__||Object.getPrototypeOf(SelectUsersForm)).call.apply(_ref,[this].concat(args))),_this),_this.renderMultipleSelect=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_select_MultipleSelectList__["a" /* default */],{options:_this.props.users.map(function(user){return{id:user.id,selected:props.input.value.includes(user.id),value:user.first_name+' '+user.last_name+(user.title?' - '+user.title:'')};}),show:5,onSelect:function onSelect(id){return _this.handleUserSelection(props,id);}});},_this.handleUserSelection=function(props,id){if(props.input.value.includes(id)){props.input.onChange(props.input.value.filter(function(item){return item!==id;}));}else{props.input.onChange(props.input.value.concat(id));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SelectUsersForm,[{key:'render',value:function render(){var onClose=this.props.onClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select-users-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.props.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* ControlLabel */],sm:3},'Employees'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderMultipleSelect,name:'userIds'}))),this.props.invalid&&this.props.submitFailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'The outlined inputs should be added in order to Select Users.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:3}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange button-submit',type:'submit',value:'Save',disabled:this.props.invalid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-gray',type:'button',value:'Cancel',onClick:onClose})))));}}]);return SelectUsersForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelectUsersForm.propTypes={users:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};function validate(values){var errors={};if(!values.userIds||values.userIds.length===0){errors.userIds='Required';}return errors;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["f" /* reduxForm */])({form:'SelectUsersForm',validate:validate})(SelectUsersForm));

/***/ }),
/* 2556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_directory_UserForm__ = __webpack_require__(2558);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserModal=function(_Component){_inherits(UserModal,_Component);function UserModal(){_classCallCheck(this,UserModal);return _possibleConstructorReturn(this,(UserModal.__proto__||Object.getPrototypeOf(UserModal)).apply(this,arguments));}_createClass(UserModal,[{key:'render',value:function render(){var _props=this.props,show=_props.show,companyType=_props.companyType,handleSubmit=_props.handleSubmit,handleClose=_props.handleClose,initialValues=_props.initialValues;var title=initialValues?'Edit User':'Invite User';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{show:show,title:title,onClose:handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_directory_UserForm__["a" /* default */],{companyType:companyType,onSubmit:handleSubmit,onClose:handleClose,initialValues:initialValues}));}}]);return UserModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UserModal.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,companyType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,handleSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,initialValues:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,firstName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,lastName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,phoneNumber:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,accountableId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number})};/* harmony default export */ __webpack_exports__["a"] = (UserModal);

/***/ }),
/* 2558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_directory_UserForm_css__ = __webpack_require__(2559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_directory_UserForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_directory_UserForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_domain_service_provider_type_enum__ = __webpack_require__(164);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InviteUserForm=function(_Component){_inherits(InviteUserForm,_Component);function InviteUserForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InviteUserForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InviteUserForm.__proto__||Object.getPrototypeOf(InviteUserForm)).call.apply(_ref,[this].concat(args))),_this),_this.renderInput=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_input_Input__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));},_this.onChangeDropDown=function(option,props){var value=option&&option.value?option.value:'';props.input.onChange(value);},_this.renderDropDown=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_dropdown_Dropdown__["a" /* default */],Object.assign({valid:!props.meta.error||!props.meta.submitFailed,value:props.input.value,onChange:function onChange(option){return _this.onChangeDropDown(option,props);}},props));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InviteUserForm,[{key:'render',value:function render(){var _props=this.props,companyType=_props.companyType,onClose=_props.onClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invite-user-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.props.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* ControlLabel */],sm:3},'First Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderInput,name:'firstName',placeholder:'First Name'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* ControlLabel */],sm:3},'Last Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderInput,name:'lastName',placeholder:'Last Name'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* ControlLabel */],sm:3},'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderInput,name:'email',placeholder:'Email'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* ControlLabel */],sm:3},'Phone Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderInput,name:'phoneNumber',placeholder:'Phone Number'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderInput,name:'phoneExt',placeholder:'Ext'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* ControlLabel */],sm:3},'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderDropDown,name:'title',placeholder:'Select Title',options:__WEBPACK_IMPORTED_MODULE_7_domain_service_provider_type_enum__["c" /* ServiceProviderTitles */][companyType].map(function(title){return{value:title,label:title};})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderInput,name:'title',placeholder:'Custom Title'}))),this.props.invalid&&this.props.submitFailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'The outlined inputs should be added in order to Invite a User.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:3}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange button-submit',type:'submit',value:'Save',disabled:this.props.invalid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-gray',type:'button',value:'Cancel',onClick:onClose})))));}}]);return InviteUserForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);InviteUserForm.propTypes={companyType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};function validate(values){var errors={};if(!values.firstName){errors.firstName='Required';}if(!values.lastName){errors.lastName='Required';}if(!values.email){errors.email='Required';}if(!values.phoneNumber){errors.phoneNumber='Required';}if(!values.title){errors.title='Required';}return errors;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["f" /* reduxForm */])({form:'InviteUserForm',validate:validate})(InviteUserForm));

/***/ }),
/* 2559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_bell_active_svg__ = __webpack_require__(2561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_bell_active_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_bell_active_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_bell_inactive_svg__ = __webpack_require__(2562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_bell_inactive_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_bell_inactive_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckBox_css__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckBox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CheckBox_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LabeledBellCheckBox=function(_Component){_inherits(LabeledBellCheckBox,_Component);function LabeledBellCheckBox(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LabeledBellCheckBox);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LabeledBellCheckBox.__proto__||Object.getPrototypeOf(LabeledBellCheckBox)).call.apply(_ref,[this].concat(args))),_this),_this.handleSelectChange=function(event){event.preventDefault();event.stopPropagation();if(!_this.props.readOnly){_this.props.onChange(!_this.props.checked);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LabeledBellCheckBox,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'labeled-bell-checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox-container size-'+this.props.size+(this.props.className!==null?' '+this.props.className:''),onClick:this.handleSelectChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'box-img size-'+this.props.size+(this.props.readOnly?' read-only':'')+(!this.props.checked?' empty':''),src:LabeledBellCheckBox.getImage(this.props.checked,this.props.readOnly),alt:'plus'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox-label'},this.props.label,' ',this.props.checked?'On':'Off'));}}],[{key:'getImage',value:function getImage(checked,readOnly){var image=void 0;if(checked){if(!readOnly){image=__WEBPACK_IMPORTED_MODULE_2__images_bell_active_svg___default.a;}else{image=__WEBPACK_IMPORTED_MODULE_2__images_bell_active_svg___default.a;}}else{image=__WEBPACK_IMPORTED_MODULE_3__images_bell_inactive_svg___default.a;}return image;}}]);return LabeledBellCheckBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);LabeledBellCheckBox.propTypes={checked:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['small','medium']),color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};LabeledBellCheckBox.defaultProps={className:null,readOnly:false,size:'medium',color:null,label:null,onChange:function onChange(){}};/* harmony default export */ __webpack_exports__["a"] = (LabeledBellCheckBox);

/***/ }),
/* 2561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bell-active.b66373c6.svg";

/***/ }),
/* 2562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bell-inactive.69984663.svg";

/***/ }),
/* 2563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectMeetingMinutes_css__ = __webpack_require__(2564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectMeetingMinutes_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProjectMeetingMinutes_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_email_modal_store_actions__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_email_modal_store_selectors__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_store_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_ProjectEmailModal__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_confirmation_ConfirmationPanel__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_check_circle_png__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_check_circle_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_images_check_circle_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_selectors_notifications__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_domain_notification__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_selectors__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_meeting_minutes_MeetingInfo__ = __webpack_require__(2565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_shared_text_BaseStatus__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_admin_projects_details_project_meeting_minutes_MeetingModal__ = __webpack_require__(2568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_domain_meeting_status_enum__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_actions_notifications__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_shared_pdf_viewer_PdfViewer__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectMeetingMinutes=function(_Component){_inherits(ProjectMeetingMinutes,_Component);function ProjectMeetingMinutes(props){_classCallCheck(this,ProjectMeetingMinutes);var _this=_possibleConstructorReturn(this,(ProjectMeetingMinutes.__proto__||Object.getPrototypeOf(ProjectMeetingMinutes)).call(this,props));_this.showActions=function(){var contribType=_this.props.currentProject.contributor_type;return __WEBPACK_IMPORTED_MODULE_23_domain_enterprise__["a" /* Enterprise */].spackle(contribType)||__WEBPACK_IMPORTED_MODULE_23_domain_enterprise__["a" /* Enterprise */].generalContractor(contribType)||__WEBPACK_IMPORTED_MODULE_23_domain_enterprise__["a" /* Enterprise */].primary(contribType);};_this.primary=function(){var contribType=_this.props.currentProject.contributor_type;return __WEBPACK_IMPORTED_MODULE_23_domain_enterprise__["a" /* Enterprise */].primary(contribType);};_this.handleEditMeetingInfo=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["q" /* setMeetingInfoEdit */])(true));};_this.handleViewPdf=function(meetingId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["j" /* loadMeetingPdfRequest */])(_this.props.currentProject.id,meetingId)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["v" /* togglePdfViewer */])());}});};_this.handlePdfViewerClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["v" /* togglePdfViewer */])());};_this.handleSubmitMeetingInfo=function(values){var promise=null;if(_this.props.meetingInfo){promise=_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["y" /* updateMeetingInfo */])(_this.props.currentProject.id,values));}else{promise=_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["d" /* createMeetingInfo */])(_this.props.currentProject.id,values));}promise.then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["q" /* setMeetingInfoEdit */])(false));}});};_this.handleCancelMeetingInfo=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["q" /* setMeetingInfoEdit */])(false));};_this.handleShowEmailModal=function(meeting){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["p" /* setCurrentMeeting */])(meeting));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_email_modal_store_actions__["j" /* setShowEmailModal */])(true));};_this.handleSendEmail=function(emailsData){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_store_actions__["d" /* sendProjectResourceEmails */])(_this.props.currentMeeting.id,'Meeting',emailsData));};_this.buildEmailModalTitle=function(){var _this$props=_this.props,currentProject=_this$props.currentProject,currentMeeting=_this$props.currentMeeting;return'Meeting #'+currentMeeting.number+' (Project #'+currentProject.number+': '+currentProject.name+')';};_this.buildEmailModalSubject=function(){var _this$props2=_this.props,currentProject=_this$props2.currentProject,currentMeeting=_this$props2.currentMeeting;return currentProject.number+', '+currentProject.name+' - Meeting '+currentMeeting.number;};_this.buildEmailModalMessage=function(){var _this$props3=_this.props,currentProject=_this$props3.currentProject,currentMeeting=_this$props3.currentMeeting;var location='';if(currentProject.building&&currentProject.building.location){var buildingLocation=currentProject.building.location;location=' at '+buildingLocation.street_address_1+', '+buildingLocation.city+' '+buildingLocation.state;}return'Please find the attached Meeting #'+currentMeeting.number+' for Project '+currentProject.name+location+'. If you have any questions, please reach out via chat or email.';};_this.handleGenerateLink=function(index){var meetings=_this.props.meetings;return'?meetingId='+meetings[index].id;};_this.isMeetingDeletable=function(meeting){var _this$props4=_this.props,currentProject=_this$props4.currentProject,meetings=_this$props4.meetings;return meeting.id===meetings[meetings.length-1].id&&(meeting.status!=='approved'||__WEBPACK_IMPORTED_MODULE_23_domain_enterprise__["a" /* Enterprise */].spackle(currentProject.contributor_type));};_this.mapMeetings=function(){var unreadById=Object(__WEBPACK_IMPORTED_MODULE_13_domain_notification__["d" /* unreadNotifications */])(_this.props.notifications,'Meeting');return _this.props.meetings.map(function(meeting){var submittedBy=meeting.submitted_by;var meetingStatusEnum=__WEBPACK_IMPORTED_MODULE_24_domain_meeting_status_enum__["a" /* MeetingStatusEnum */].create(meeting.status);var statusLabel=meetingStatusEnum.label;var draftMeeting=__WEBPACK_IMPORTED_MODULE_24_domain_meeting_status_enum__["a" /* MeetingStatusEnum */].DRAFT.equals(meetingStatusEnum);var unread=unreadById&&!!unreadById[meeting.id];return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,unread&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_shared_text_BaseStatus__["a" /* default */],{labels:[{id:'unread',label:''}],status:'unread'}),meeting.number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_shared_text_Date__["a" /* default */],{value:meeting.meeting_date,format:'MM/DD/YYYY'}),meeting.summary||'Meeting Minutes '+meeting.number,submittedBy?submittedBy.first_name+' '+submittedBy.last_name+(submittedBy.title?' - '+submittedBy.title:''):'-',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:draftMeeting?'draft':''},statusLabel.charAt(0).toUpperCase(),statusLabel.slice(1)),meeting.approved_at?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_shared_text_Date__["a" /* default */],{value:meeting.approved_at,format:'MM/DD/YYYY'}):'-',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'action-link',onClick:function onClick(){return _this.handleShowEmailModal(meeting);}},'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'action-link',onClick:function onClick(){return _this.handleViewPdf(meeting.id);}},'PDF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'action-link',onClick:function onClick(){return _this.handleViewDetails(meeting.id);}},'Open'),_this.isMeetingDeletable(meeting)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'action-link',onClick:function onClick(){return _this.handleDeleteMeeting(meeting.id);}},'Delete')];});};_this.handleAddMeeting=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["p" /* setCurrentMeeting */])(null));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["s" /* setMeetingModalShow */])(true));};_this.handleViewDetails=function(meetingId){var _this$props5=_this.props,currentProject=_this$props5.currentProject,dispatch=_this$props5.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["m" /* openMeeting */])(currentProject.id,meetingId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_25_actions_notifications__["o" /* markNotifiableNotificationsAsRead */])(meetingId,'Meeting'));};_this.handleDeleteMeeting=function(meetingId){var confirmed=window.confirm('Are you sure?');confirmed&&_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["e" /* deleteMeetingRequest */])(_this.props.currentProject.id,meetingId)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["l" /* loadMeetingsRequest */])(_this.props.currentProject.id));}});};_this.handleConfirm=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["o" /* setConfirmationMsg */])(''));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["s" /* setMeetingModalShow */])(false));};props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["f" /* initMeetingMinutes */])());return _this;}_createClass(ProjectMeetingMinutes,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.currentProject){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["i" /* loadMeetingInfoRequest */])(this.props.currentProject.id));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_meeting_minutes_store_actions__["l" /* loadMeetingsRequest */])(this.props.currentProject.id));}}},{key:'render',value:function render(){var currentProject=this.props.currentProject;var showActions=currentProject&&this.showActions();var primary=currentProject&&this.primary();var initialMeetingInfoValues={};if(this.props.meetingInfo){initialMeetingInfoValues={dayOfWeek:this.props.meetingInfo.day_of_week,startsAt:this.props.meetingInfo.starts_at,endsAt:this.props.meetingInfo.ends_at,timeZone:this.props.meetingInfo.time_zone,meetingLocation:this.props.meetingInfo.meeting_location,siteWalk:this.props.meetingInfo.site_walk,phoneNumber:Object(__WEBPACK_IMPORTED_MODULE_19_services_utils_text_util__["c" /* formatPhoneNumber */])(this.props.meetingInfo.phone_number),code:this.props.meetingInfo.code,hostPin:this.props.meetingInfo.host_pin,webLink:this.props.meetingInfo.web_link};}return currentProject&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-meeting-minutes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_meeting_minutes_MeetingInfo__["a" /* default */],{meetingInfoEdit:this.props.meetingInfoEdit,initialMeetingInfoValues:initialMeetingInfoValues,meetingInfo:this.props.meetingInfo,showActions:showActions,handleSubmitMeetingInfo:this.handleSubmitMeetingInfo,handleCancelMeetingInfo:this.handleCancelMeetingInfo,handleEditMeetingInfo:this.handleEditMeetingInfo}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'project-meeting-minutes-divider'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'meeting-minutes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'meeting-minutes-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Meeting Minutes'),showActions&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Add Meeting',onClick:this.handleAddMeeting})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table meeting-minutes-table',headers:['#','MEETING DATE','TITLE','SUBMITTED BY','STATUS','PUBLISHED','','ACTIONS','',''],rows:this.mapMeetings(),emptyMessage:'No meetings Added',onGenerateLink:this.handleGenerateLink})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:this.props.meetingPdf,type:'blob'},show:this.props.showPdfViewer,onClose:this.handlePdfViewerClose}),this.props.meetingModalShow&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_admin_projects_details_project_meeting_minutes_MeetingModal__["a" /* default */],{showActions:showActions,primary:primary}),this.props.confirmationMsg&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["o" /* Modal */],{show:!!this.props.confirmationMsg},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_confirmation_ConfirmationPanel__["a" /* default */],{image:__WEBPACK_IMPORTED_MODULE_11_images_check_circle_png___default.a,firstLine:'Thank you!',lines:[this.props.confirmationMsg],buttons:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Continue',onClick:this.handleConfirm})]})),this.props.showEmailModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_ProjectEmailModal__["a" /* default */],{title:this.buildEmailModalTitle(),handleSendEmail:this.handleSendEmail,projectId:this.props.currentProject.id,initialSubject:this.buildEmailModalSubject(),initialMessage:this.buildEmailModalMessage()}));}}]);return ProjectMeetingMinutes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),meetingInfo:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_selectors__["f" /* getMeetingInfo */])(state),meetingInfoEdit:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_selectors__["g" /* getMeetingInfoEdit */])(state),meetings:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_selectors__["l" /* getMeetings */])(state),meetingModalShow:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_selectors__["j" /* getMeetingModalShow */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_22_selectors_authentication__["d" /* getCurrentUser */])(state),showPdfViewer:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_selectors__["o" /* getShowPdfViewer */])(state),meetingPdf:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_selectors__["k" /* getMeetingPdf */])(state),confirmationMsg:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_selectors__["b" /* getConfirmationMsg */])(state),notifications:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_notifications__["b" /* getNotifications */])(state),showEmailModal:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_email_modal_store_selectors__["g" /* getShowEmailModal */])(state),currentMeeting:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_selectors__["c" /* getCurrentMeeting */])(state)};})(ProjectMeetingMinutes));

/***/ }),
/* 2564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_slidedown__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_slidedown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_slidedown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_meeting_minutes_MeetingInfoForm__ = __webpack_require__(2566);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MeetingInfo=function(_Component){_inherits(MeetingInfo,_Component);function MeetingInfo(){_classCallCheck(this,MeetingInfo);return _possibleConstructorReturn(this,(MeetingInfo.__proto__||Object.getPrototypeOf(MeetingInfo)).apply(this,arguments));}_createClass(MeetingInfo,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'meeting-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Meeting Information'),this.props.meetingInfoEdit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_slidedown__["SlideDown"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_meeting_minutes_MeetingInfoForm__["a" /* default */],{initialValues:this.props.initialMeetingInfoValues,onSubmit:this.props.handleSubmitMeetingInfo,onCancel:this.props.handleCancelMeetingInfo})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'meeting-info-read-only'},this.props.showActions&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{className:'button-white',label:'Edit',onClick:this.props.handleEditMeetingInfo}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:2,className:'meeting-info-label'},'Weekly Meeting:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:8},this.props.meetingInfo?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__["a" /* default */],{value:Object(__WEBPACK_IMPORTED_MODULE_6_services_utils_date_util__["f" /* nextDay */])(this.props.meetingInfo.day_of_week),format:'ll'}),'\xA0-\xA0',__WEBPACK_IMPORTED_MODULE_8_moment___default.a.utc(this.props.meetingInfo.starts_at).format('hh:mm A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' To '),__WEBPACK_IMPORTED_MODULE_8_moment___default.a.utc(this.props.meetingInfo.ends_at).format('hh:mm A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,', '),this.props.meetingInfo.time_zone):'Add Month Day, Year – Time')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:2,className:'meeting-info-label'},'Meeting Location:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:8},this.props.meetingInfo&&this.props.meetingInfo.meeting_location?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.meetingInfo.meeting_location):'Add Location')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:2,className:'meeting-info-label'},'Site Walk:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:8},this.props.meetingInfo&&this.props.meetingInfo.site_walk?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.meetingInfo.site_walk):'Add Location')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:2,className:'meeting-info-label'},'Call In Info:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:8},this.props.meetingInfo&&this.props.meetingInfo.phone_number?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_7_services_utils_text_util__["c" /* formatPhoneNumber */])(this.props.meetingInfo.phone_number),this.props.meetingInfo.code&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' / Code: ',this.props.meetingInfo.code),this.props.meetingInfo.host_pin&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ','/ Host PIN: ',this.props.meetingInfo.host_pin)):'Add Phone # / Code / Host Pin')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:2,className:'meeting-info-label'},'Web Link:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:8},this.props.meetingInfo&&this.props.meetingInfo.web_link?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''+this.props.meetingInfo.web_link},this.props.meetingInfo.link_title):'Add Web Link'))));}}]);return MeetingInfo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MeetingInfo.propTypes={meetingInfoEdit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,initialMeetingInfoValues:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),meetingInfo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),showActions:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,handleSubmitMeetingInfo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleCancelMeetingInfo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleEditMeetingInfo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(MeetingInfo));

/***/ }),
/* 2566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_meeting_minutes_MeetingInfoForm_css__ = __webpack_require__(2567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_meeting_minutes_MeetingInfoForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_meeting_minutes_MeetingInfoForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_radio_button_RadioButton__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_form_FormTimePicker__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_form_FormDropDown__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_form_FormInput__ = __webpack_require__(322);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MeetingInfoForm=function(_Component){_inherits(MeetingInfoForm,_Component);function MeetingInfoForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MeetingInfoForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MeetingInfoForm.__proto__||Object.getPrototypeOf(MeetingInfoForm)).call.apply(_ref,[this].concat(args))),_this),_this.renderRadioButton=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_radio_button_RadioButton__["a" /* default */],Object.assign({value:props.input.value,onChange:function onChange(value){return props.input.onChange(value);}},props));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MeetingInfoForm,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'meeting-info-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.props.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Weekly Meeting'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'Day'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:this.renderRadioButton,name:'dayOfWeek',orientation:'horizontal',options:[{value:1,label:'Monday'},{value:2,label:'Tuesday'},{value:3,label:'Wednesday'},{value:4,label:'Thursday'},{value:5,label:'Friday'},{value:6,label:'Saturday'},{value:0,label:'Sunday'}]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_shared_form_FormTimePicker__["a" /* default */],name:'startsAt',placeholder:'From'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'meeting-info-time-to'},'To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_shared_form_FormTimePicker__["a" /* default */],name:'endsAt',placeholder:'To'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'Time Zone'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_shared_form_FormDropDown__["a" /* default */],name:'timeZone',options:[{value:'Pacific Time (US & Canada)',label:'Pacific Time (US & Canada)'},{value:'Central Time (US & Canada)',label:'Central Time (US & Canada)'},{value:'Eastern Time (US & Canada)',label:'Eastern Time (US & Canada)'}],placeholder:'Time Zone'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'Meeting Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_7_components_shared_form_FormInput__["a" /* default */],name:'meetingLocation',placeholder:'Meeting Location'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'Site Walk'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_7_components_shared_form_FormInput__["a" /* default */],name:'siteWalk',placeholder:'Site Walk'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'Call In Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_7_components_shared_form_FormInput__["a" /* default */],name:'phoneNumber',placeholder:'Phone Number'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'Code'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_7_components_shared_form_FormInput__["a" /* default */],name:'code',placeholder:'Code'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'Host Pin'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_7_components_shared_form_FormInput__["a" /* default */],name:'hostPin',placeholder:'Host Pin'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'Web Link'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_7_components_shared_form_FormInput__["a" /* default */],name:'webLink',placeholder:'Web Link'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_7_components_shared_form_FormInput__["a" /* default */],name:'linkTitle',placeholder:'Meeting Title'}))),this.props.invalid&&this.props.submitFailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invalid-message'},'The outlined inputs should be added in order save the Meeting Info.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-gray',type:'button',value:'Cancel',onClick:this.props.onCancel}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'submit',value:'Save',disabled:this.props.invalid})))));}}]);return MeetingInfoForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(values){var errors={};if(!values.dayOfWeek){errors.dayOfWeek='Required';}if(!values.startsAt){errors.startsAt='Required';}if(!values.endsAt){errors.endsAt='Required';}if(!values.timeZone){errors.timeZone='Required';}if(!values.phoneNumber){errors.phoneNumber='Required';}return errors;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["f" /* reduxForm */])({form:'MeetingInfoForm',validate:validate})(MeetingInfoForm));

/***/ }),
/* 2567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MeetingModal_css__ = __webpack_require__(2569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MeetingModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MeetingModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_checkbox_LabeledCheckBox__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_meeting_minutes_MeetingTitle__ = __webpack_require__(2570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_meeting_minutes_MeetingItemsTable__ = __webpack_require__(2571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_meeting_minutes_MeetingActions__ = __webpack_require__(2574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_domain_meeting_status_enum__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_meeting_minutes_store_selectors__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_directory_store_actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_services_utils_date_util__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MeetingModal=function(_Component){_inherits(MeetingModal,_Component);function MeetingModal(props){_classCallCheck(this,MeetingModal);var _this=_possibleConstructorReturn(this,(MeetingModal.__proto__||Object.getPrototypeOf(MeetingModal)).call(this,props));_this.meetingItemKeysByCategory=function(meetingCatId){return Object.keys(_this.props.meetingItems).filter(function(key){return _this.props.meetingItems[key].meetingCategoryId===meetingCatId;});};_this.userLabel=function(user,company){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,user.first_name+' '+user.last_name+' - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'company-name'},company.name||company.company_name));};_this.userLabelStr=function(user,company){return user.first_name+' '+user.last_name+' - '+(company.name||company.company_name);};_this.mapContributors=function(contributors){return contributors.map(function(contrib){return[contrib.id,_this.userLabelStr(contrib,contrib.accountable)];});};_this.prepopulateMeetingItems=function(){var meetingItems={};var key=Object.keys(_this.props.meetingItems).length;_this.props.meetingCategories.filter(function(meetingCat){return _this.meetingItemKeysByCategory(meetingCat.id).length===0;}).forEach(function(meetingCat){key+=1;meetingItems[key]={meetingCategoryId:meetingCat.id,newItem:true,info:'',contributorIds:[],meetingCategory:{orderNumber:meetingCat.order_number}};});_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__["b" /* attachMeetingItems */])(meetingItems));};_this.prepopulateFromLastMeeting=function(lastMeeting){var meetingItems={};var key=0;lastMeeting.meeting_items.filter(function(item){return!item.resolved;}).forEach(function(item){key+=1;meetingItems[key]={code:item.code,meetingCategoryId:item.meeting_category_id,newItem:false,info:''+item.info+(item.new_info?' '+__WEBPACK_IMPORTED_MODULE_17_moment___default()(item.new_info_date).format('M/D')+' '+item.new_info:''),contributorIds:_this.mapContributors(item.contributors),meetingCategory:{orderNumber:item.meeting_category.order_number}};});_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__["b" /* attachMeetingItems */])(meetingItems));};_this.prepopulateFromCurrentMeeting=function(meeting){var meetingItems={};var key=0;meeting.meeting_items.forEach(function(item){key+=1;meetingItems[key]={id:item.id,code:item.code,meetingCategoryId:item.meeting_category_id,newItem:item.new_item,info:item.info,newInfo:item.new_info,newInfoDate:item.new_info_date,resolved:item.resolved,resolvedNote:item.resolved_note,resolvedDate:item.resolved_date,contributorIds:_this.mapContributors(item.contributors),meetingCategory:{orderNumber:item.meeting_category.order_number}};});_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__["b" /* attachMeetingItems */])(meetingItems));};_this.renderAttendeesPopup=function(){var users={};if(!_this.props.directory){return[];}return _this.props.directory.project_contributors.map(function(pc){return pc.users.filter(function(usr){return!users[usr.id];}).map(function(usr){users[usr.id]=true;var usrLabel=_this.userLabel(usr,pc.company);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{key:usr.id,checked:!!_this.props.meetingForm.attendeeIds.find(function(attendee){return attendee[0]===usr.id;}),onChange:function onChange(value){if(value){_this.handleMeetingFormChange('attendeeIds',_this.props.meetingForm.attendeeIds.concat([[usr.id,usrLabel]]));}else{_this.handleMeetingFormChange('attendeeIds',_this.props.meetingForm.attendeeIds.filter(function(attendee){return attendee[0]!==usr.id;}));}},label:usrLabel});});}).reduce(function(acc,val){return acc.concat(val);},[]);};_this.confirmApprovalMsg=function(){return _this.props.primary?'Are you sure you are ready to Publish?':'Are you sure you are ready to Publish without PM Approval?';};_this.handleMeetingFormChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__["x" /* updateMeetingFormValue */])(attribute,value));};_this.handleClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__["s" /* setMeetingModalShow */])(false));};_this.handleRollCall=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__["u" /* setShowAttendeesModal */])(!_this.props.showAttendeesModal));};_this.handleCloseAttendeesModal=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__["u" /* setShowAttendeesModal */])(false));};_this.handleReview=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__["t" /* setReviewMeeting */])(true));};_this.handleBack=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__["t" /* setReviewMeeting */])(false));};_this.handleShowConfirmApproval=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__["n" /* setConfirmApproval */])(true));};_this.handleConfirmApproval=function(confirmApproval){if(confirmApproval){_this.handleSend('approved',true);}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__["n" /* setConfirmApproval */])(false));}};_this.handleSend=function(){var status=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'draft';var send=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var meeting={status:status,meetingDate:_this.props.meetingForm.meetingDate,attendeeIds:_this.props.meetingForm.attendeeIds.map(function(attendee){return attendee[0];}),meetingItems:Object.keys(_this.props.meetingItems).filter(function(key){var item=_this.props.meetingItems[key];return item.code&&item.info&&(!item.destroy||item.id);}).map(function(key){var item=_this.props.meetingItems[key];return{id:item.id,code:item.code,meetingCategoryId:item.meetingCategoryId,newItem:item.newItem,info:item.info,newInfo:item.newInfo,resolved:item.resolved,resolvedNote:item.resolvedNote,destroy:item.destroy,contributorIds:item.contributorIds.map(function(contrib){return contrib[0];}),meetingCategory:{orderNumber:item.meetingCategory.orderNumber}};})};var promise=null;var currentMeeting=_this.props.currentMeeting;if(currentMeeting){promise=_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__["w" /* updateMeeting */])(_this.props.currentProject.id,currentMeeting.id,meeting));}else{promise=_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__["c" /* createMeeting */])(_this.props.currentProject.id,meeting));}promise.then(function(response){if(response.ok){if(send){var msg='';var meetingStatus=__WEBPACK_IMPORTED_MODULE_11_domain_meeting_status_enum__["a" /* MeetingStatusEnum */].create(response.meeting.status);if(__WEBPACK_IMPORTED_MODULE_11_domain_meeting_status_enum__["a" /* MeetingStatusEnum */].PENDING.equals(meetingStatus)){msg='The Meeting Minutes has been sent to the PM for approval.';}else{msg='The Meeting Minutes has been published to the team.';}_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__["o" /* setConfirmationMsg */])(msg));}else{_this.handleClose();}}});};_this.lastMeeting=function(){var _this$props=_this.props,meetings=_this$props.meetings,currentMeeting=_this$props.currentMeeting;return!!currentMeeting&&currentMeeting.id===meetings.slice(-1)[0].id;};props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__["g" /* initMeetingModal */])());if(!props.showActions){_this.handleReview();}return _this;}_createClass(MeetingModal,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;if(!this.props.currentProject){return;}if(!this.props.directory||this.props.directory.project_id!==this.props.currentProject.id){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_directory_store_actions__["j" /* loadDirectoryRequest */])(this.props.currentProject.id));}this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__["h" /* loadMeetingCategoriesRequest */])()).then(function(response){var currentMeeting=_this2.props.currentMeeting;if(currentMeeting){_this2.handleReview();_this2.handleMeetingFormChange('attendeeIds',currentMeeting.attendees.map(function(attendee){return[attendee.id,_this2.userLabel(attendee,attendee.accountable)];}));_this2.handleMeetingFormChange('meetingDate',currentMeeting.meeting_date);_this2.handleMeetingFormChange('number',currentMeeting.number);_this2.prepopulateFromCurrentMeeting(currentMeeting);_this2.prepopulateMeetingItems();}else{var meetingInfo=_this2.props.meetingInfo;var meetingDate=meetingInfo?Object(__WEBPACK_IMPORTED_MODULE_18_services_utils_date_util__["g" /* prevDay */])(meetingInfo.day_of_week):__WEBPACK_IMPORTED_MODULE_17_moment___default()().format('YYYY-MM-DD');var lastMeeting=_this2.props.meetings.slice(-1)[0];_this2.handleMeetingFormChange('meetingDate',meetingDate);if(lastMeeting){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_meeting_minutes_store_actions__["k" /* loadMeetingRequest */])(_this2.props.currentProject.id,lastMeeting.id)).then(function(response){var number=response.meeting.number+1;_this2.handleMeetingFormChange('number',number);_this2.prepopulateFromLastMeeting(response.meeting);_this2.prepopulateMeetingItems();});}else{_this2.handleMeetingFormChange('number',1);_this2.prepopulateMeetingItems();}}});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.currentProject&&this.props.meetingForm.number&&this.props.meetingForm.meetingDate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__["a" /* default */],{className:'meeting-modal',show:this.props.meetingModalShow,onClose:this.handleClose,onBack:this.props.reviewMeeting&&this.props.showActions?this.handleBack:undefined,subTitle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['Projects',this.props.currentProject.name,this.props.currentMeeting?'Meeting Details':'Add Meeting']}),title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_meeting_minutes_MeetingTitle__["a" /* default */],{reviewMeeting:this.props.reviewMeeting,meetingForm:this.props.meetingForm,showAttendeesModal:this.props.showAttendeesModal,handleRollCall:this.handleRollCall,handleCloseAttendeesModal:this.handleCloseAttendeesModal,renderAttendeesPopup:this.renderAttendeesPopup,handleMeetingFormChange:this.handleMeetingFormChange})},this.props.reviewMeeting&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-attendees'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-and-send'},'Review & Send'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-attended'},'Attended'),this.props.meetingForm.attendeeIds.map(function(attendee){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:attendee[0],className:'review-attendee'},attendee[1]);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_meeting_minutes_MeetingItemsTable__["a" /* default */],{meetingNumber:this.props.meetingForm.number,meetingDate:this.props.meetingForm.meetingDate,reviewMeeting:this.props.reviewMeeting,userLabelStr:this.userLabelStr}),this.props.showActions&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_meeting_minutes_MeetingActions__["a" /* default */],{primary:this.props.primary,reviewMeeting:this.props.reviewMeeting,lastMeeting:this.lastMeeting(),meetingStatus:this.props.currentMeeting?this.props.currentMeeting.status:__WEBPACK_IMPORTED_MODULE_11_domain_meeting_status_enum__["b" /* MeetingStatusKeys */].DRAFT,meetingItems:this.props.meetingItems,handleSend:this.handleSend,handleShowConfirmApproval:this.handleShowConfirmApproval,handleBack:this.handleBack,handleReview:this.handleReview,handleClose:this.handleClose}),this.props.confirmApproval&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.props.confirmApproval,message:this.confirmApprovalMsg(),onHide:this.handleConfirmApproval})));}}]);return MeetingModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MeetingModal.propTypes={showActions:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,primary:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),directory:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__["c" /* getDirectory */])(state),meetingModalShow:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_meeting_minutes_store_selectors__["j" /* getMeetingModalShow */])(state),meetingCategories:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_meeting_minutes_store_selectors__["d" /* getMeetingCategories */])(state),meetings:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_meeting_minutes_store_selectors__["l" /* getMeetings */])(state),meetingForm:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_meeting_minutes_store_selectors__["e" /* getMeetingForm */])(state),meetingItems:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_meeting_minutes_store_selectors__["i" /* getMeetingItems */])(state),showAttendeesModal:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_meeting_minutes_store_selectors__["n" /* getShowAttendeesModal */])(state),reviewMeeting:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_meeting_minutes_store_selectors__["m" /* getReviewMeeting */])(state),currentMeeting:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_meeting_minutes_store_selectors__["c" /* getCurrentMeeting */])(state),confirmApproval:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_meeting_minutes_store_selectors__["a" /* getConfirmApproval */])(state),meetingInfo:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_meeting_minutes_store_selectors__["f" /* getMeetingInfo */])(state)};})(MeetingModal));

/***/ }),
/* 2569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_close_png__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_close_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_close_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_OutsideAlerter__ = __webpack_require__(207);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MeetingTitle=function(_Component){_inherits(MeetingTitle,_Component);function MeetingTitle(){_classCallCheck(this,MeetingTitle);return _possibleConstructorReturn(this,(MeetingTitle.__proto__||Object.getPrototypeOf(MeetingTitle)).apply(this,arguments));}_createClass(MeetingTitle,[{key:'render',value:function render(){var _this2=this;var _props=this.props,reviewMeeting=_props.reviewMeeting,meetingForm=_props.meetingForm,showAttendeesModal=_props.showAttendeesModal;return reviewMeeting?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Meeting Minutes '+meetingForm.number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-date'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Date__["a" /* default */],{value:meetingForm.meetingDate,format:'MM/DD/YYYY'}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Meeting Minutes '+meetingForm.number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-white',label:'Roll Call',onClick:this.props.handleRollCall}),showAttendeesModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_OutsideAlerter__["a" /* default */],{onClickOutside:this.props.handleCloseAttendeesModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attendees'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title'},'Attendees '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sub-title'},'(Mark who is present)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'close-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6_images_close_png___default.a,alt:'close',onClick:this.props.handleCloseAttendeesModal}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attendees-selection'},this.props.renderAttendeesPopup()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{placeholder:'Choose Date...',value:meetingForm.meetingDate,onChange:function onChange(value){return _this2.props.handleMeetingFormChange('meetingDate',value);}}));}}]);return MeetingTitle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MeetingTitle.propTypes={reviewMeeting:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,meetingForm:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,showAttendeesModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,handleRollCall:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleCloseAttendeesModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,renderAttendeesPopup:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleMeetingFormChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(MeetingTitle));

/***/ }),
/* 2571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MeetingItemsTable_css__ = __webpack_require__(2572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MeetingItemsTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MeetingItemsTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_autosize_textarea__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_autosize_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_autosize_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_meeting_minutes_MeetingItem__ = __webpack_require__(2573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_meeting_minutes_store_selectors__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_meeting_minutes_store_actions__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_directory_store_actions__ = __webpack_require__(115);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MeetingItemsTable=function(_Component){_inherits(MeetingItemsTable,_Component);function MeetingItemsTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MeetingItemsTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MeetingItemsTable.__proto__||Object.getPrototypeOf(MeetingItemsTable)).call.apply(_ref,[this].concat(args))),_this),_this.handleMeetingItemSettingsClick=function(key){if(_this.props.meetingItemSettings[key]){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_meeting_minutes_store_actions__["r" /* setMeetingItemSettings */])(key,null));}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_meeting_minutes_store_actions__["r" /* setMeetingItemSettings */])(key,'menu'));}},_this.handleMeetingInfoMenuClick=function(e,key,menu){e.stopPropagation();if(menu==='delete'){_this.handleMeetingItemChange(key,'destroy',true);_this.refreshItemCodesAfterDelete(key);}else if(menu==='mark-unresolved'){_this.handleMarkUnresolved(key);}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_meeting_minutes_store_actions__["r" /* setMeetingItemSettings */])(key,menu));}},_this.renderMenuForm=function(key,menu){var item=_this.props.meetingItems[key];var title='';var subTitle='';var value='';if(menu==='new-info'){title='Add New Information';subTitle='What are new updates about this line item?';value=item.newInfoDraft||item.newInfo;}else if(menu==='mark-resolved'){title='Mark as Resolved';subTitle='How was this resolved?';value=item.resolvedNoteDraft||item.resolvedNote;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,subTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_autosize_textarea___default.a,{rows:5,defaultValue:value||'',placeholder:'Enter description here...',onBlur:function onBlur(e){return _this.handleMeetingItemNoteChange(key,menu,e.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{onClick:function onClick(e){_this.handleMeetingInfoMenuClick(e,key,'menu');}},'Go Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Complete',onClick:function onClick(){_this.handleMenuContinue(key,menu);}})));},_this.handleMeetingItemNoteChange=function(key,menu,value){var attr=menu==='new-info'?'newInfoDraft':'resolvedNoteDraft';_this.handleMeetingItemChange(key,attr,value);},_this.handleMenuContinue=function(key,menu){var item=_this.props.meetingItems[key];var meetingDate=_this.props.meetingDate;if(menu==='new-info'){_this.handleMeetingItemChange(key,'newInfo',item.newInfoDraft);_this.handleMeetingItemChange(key,'newInfoDate',meetingDate);}else{_this.handleMeetingItemChange(key,'resolved',true);_this.handleMeetingItemChange(key,'resolvedNote',item.resolvedNoteDraft);_this.handleMeetingItemChange(key,'resolvedDate',meetingDate);}_this.handleMeetingItemSettingsClick(key);},_this.handleMarkUnresolved=function(key){_this.handleMeetingItemChange(key,'resolved',false);_this.handleMeetingItemChange(key,'resolvedNoteDraft','');_this.handleMeetingItemChange(key,'resolvedNote','');_this.handleMeetingItemChange(key,'resolvedDate',null);_this.handleMeetingItemSettingsClick(key);},_this.loadContributors=function(){var users={};return _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_directory_store_actions__["m" /* searchDirectory */])(_this.props.currentProject.id)).then(function(response){if(response.ok){var contributors=response.directory.project_contributors.map(function(pc){return pc.users.filter(function(usr){return!users[usr.id];}).map(function(usr){users[usr.id]=true;return{value:usr.id,label:_this.props.userLabelStr(usr,pc.company)};});}).reduce(function(acc,val){return acc.concat(val);},[]);return{ok:true,options:contributors};}});},_this.extractMeetingNumber=function(key){return parseInt(_this.props.meetingItems[key].code.split('.')[0],10);},_this.extractItemNumber=function(key){return parseInt(_this.props.meetingItems[key].code.split('.')[1],10);},_this.buildItemCode=function(meetingNumber,itemNumber){return meetingNumber+'.'+(itemNumber<10?'0'+itemNumber:itemNumber);},_this.refreshItemCodesAfterDelete=function(key){Object.keys(_this.props.meetingItems).filter(function(itemKey){var item=_this.props.meetingItems[itemKey];return item.code&&!item.destroy&&_this.extractMeetingNumber(itemKey)===_this.extractMeetingNumber(key)&&_this.extractItemNumber(itemKey)>_this.extractItemNumber(key);}).forEach(function(itemKey){var itemCode=_this.buildItemCode(_this.extractMeetingNumber(itemKey),_this.extractItemNumber(itemKey)-1);_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_meeting_minutes_store_actions__["z" /* updateMeetingItemValue */])(itemKey,'code',itemCode));});},_this.nextItemCode=function(meetingCat){var _this$props=_this.props,meetingItems=_this$props.meetingItems,meetingNumber=_this$props.meetingNumber,dispatch=_this$props.dispatch;var newItemNumber=void 0;Object.keys(meetingItems).filter(function(itemKey){var item=meetingItems[itemKey];return item.code&&!item.destroy&&item.meetingCategory.orderNumber>meetingCat.order_number&&_this.extractMeetingNumber(itemKey)===meetingNumber;}).forEach(function(itemKey){if(!newItemNumber){newItemNumber=_this.extractItemNumber(itemKey);}var itemCode=_this.buildItemCode(_this.extractMeetingNumber(itemKey),_this.extractItemNumber(itemKey)+1);dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_meeting_minutes_store_actions__["z" /* updateMeetingItemValue */])(itemKey,'code',itemCode));});if(!newItemNumber){newItemNumber=Object.keys(meetingItems).filter(function(key){return!!meetingItems[key].code&&!!meetingItems[key].newItem&&!meetingItems[key].destroy;}).length+1;}return _this.buildItemCode(meetingNumber,newItemNumber);},_this.setItemCode=function(key){var _this$props2=_this.props,meetingItems=_this$props2.meetingItems,dispatch=_this$props2.dispatch;var item=meetingItems[key];if(!item.code){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_meeting_minutes_store_actions__["z" /* updateMeetingItemValue */])(key,'code',_this.nextItemCode(item.meetingCategory)));}},_this.handleMeetingItemChange=function(key,attribute,value){if(attribute==='info'){_this.setItemCode(key);}_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_meeting_minutes_store_actions__["z" /* updateMeetingItemValue */])(key,attribute,value));},_this.handleAddNewItem=function(meetingCat){var _this$props3=_this.props,meetingItems=_this$props3.meetingItems,dispatch=_this$props3.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_meeting_minutes_store_actions__["a" /* addNewMeetingItem */])(meetingItems,_this.nextItemCode(meetingCat),meetingCat));},_this.mapMeetingItems=function(meetingCat){var itemsWithCode=false;var empty=true;var items=Object.keys(_this.props.meetingItems).filter(function(key){var item=_this.props.meetingItems[key];return item.meetingCategoryId===meetingCat.id&&(!_this.props.reviewMeeting||item.code&&item.info)&&!item.destroy;}).map(function(key){var item=_this.props.meetingItems[key];itemsWithCode=itemsWithCode||item.code;empty=false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_meeting_minutes_MeetingItem__["a" /* default */],{key:key,itemKey:key,item:item,meetingItemSettings:_this.props.meetingItemSettings[key],reviewMeeting:_this.props.reviewMeeting,handleMeetingItemSettingsClick:_this.handleMeetingItemSettingsClick,handleMeetingInfoMenuClick:_this.handleMeetingInfoMenuClick,handleMeetingItemChange:_this.handleMeetingItemChange,renderMenuForm:_this.renderMenuForm,loadContributors:_this.loadContributors});});if(!_this.props.reviewMeeting&&(itemsWithCode||empty)){items.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:meetingCat.id+'-new'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tomato-row add-row',onClick:function onClick(){return _this.handleAddNewItem(meetingCat);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-row-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'add-row-plus'},'+ '),'Add Another Row'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null)));}if(_this.props.reviewMeeting&&!itemsWithCode){items.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:meetingCat.id+'-no-items'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'td-empty-table',colSpan:4},'No Items discussed.')));}return items;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MeetingItemsTable,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'meeting-items'},this.props.meetingCategories.map(function(meetingCat){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:meetingCat.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,meetingCat.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["t" /* Table */],{className:'simple-table meeting-items-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:3}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:4})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,['','ITEM','','CONTRIBUTORS'].map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this2.mapMeetingItems(meetingCat))));}));}}]);return MeetingItemsTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MeetingItemsTable.propTypes={meetingNumber:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,meetingDate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,reviewMeeting:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,userLabelStr:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),meetingCategories:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_meeting_minutes_store_selectors__["d" /* getMeetingCategories */])(state),meetingItems:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_meeting_minutes_store_selectors__["i" /* getMeetingItems */])(state),meetingItemSettings:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_meeting_minutes_store_selectors__["h" /* getMeetingItemSettings */])(state)};})(MeetingItemsTable));

/***/ }),
/* 2572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_settings_png__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_settings_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_settings_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_checkbox_checkbox_square_full_png__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_checkbox_checkbox_square_full_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_shared_checkbox_checkbox_square_full_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_SearchableDropDownPaginated__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_autosize_textarea__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_autosize_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_autosize_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_OutsideAlerter__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MeetingItem=function(_Component){_inherits(MeetingItem,_Component);function MeetingItem(){_classCallCheck(this,MeetingItem);return _possibleConstructorReturn(this,(MeetingItem.__proto__||Object.getPrototypeOf(MeetingItem)).apply(this,arguments));}_createClass(MeetingItem,[{key:'render',value:function render(){var _this2=this;var _props=this.props,itemKey=_props.itemKey,item=_props.item;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.props.reviewMeeting||!item.code?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'meeting-item-settings',onClick:function onClick(){return _this2.props.handleMeetingItemSettingsClick(itemKey);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3_images_settings_png___default.a,alt:'settings'}),this.props.meetingItemSettings==='menu'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_OutsideAlerter__["a" /* default */],{onClickOutside:function onClickOutside(){return _this2.props.handleMeetingItemSettingsClick(null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu'},!item.newItem&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu-item',onClick:function onClick(e){_this2.props.handleMeetingInfoMenuClick(e,itemKey,'new-info');}},'Add New Information'),!!item.resolved?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu-item',onClick:function onClick(e){_this2.props.handleMeetingInfoMenuClick(e,itemKey,'mark-unresolved');}},'Mark as Unresolved'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu-item',onClick:function onClick(e){_this2.props.handleMeetingInfoMenuClick(e,itemKey,'mark-resolved');}},'Mark as Resolved'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu-item settings-menu-item-delete',onClick:function onClick(e){_this2.props.handleMeetingInfoMenuClick(e,itemKey,'delete');}},'Delete'))),this.props.meetingItemSettings==='new-info'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_OutsideAlerter__["a" /* default */],{onClickOutside:function onClickOutside(){return _this2.props.handleMeetingItemSettingsClick(null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu settings-menu-form',onClick:function onClick(e){e.stopPropagation();}},this.props.renderMenuForm(itemKey,'new-info'))),this.props.meetingItemSettings==='mark-resolved'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_OutsideAlerter__["a" /* default */],{onClickOutside:function onClickOutside(){return _this2.props.handleMeetingItemSettingsClick(null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-menu settings-menu-form',onClick:function onClick(e){e.stopPropagation();}},this.props.renderMenuForm(itemKey,'mark-resolved'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:!!item.newItem?'meeting-item-new':''},item.code||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.props.reviewMeeting?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:!!item.newItem?'meeting-item-new':''},item.info):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_autosize_textarea___default.a,{className:!!item.newItem?'meeting-item-new':'',rows:1,placeholder:'Discussion description goes here',defaultValue:item.info,onBlur:function onBlur(e){return _this2.props.handleMeetingItemChange(itemKey,'info',e.target.value);}}),item.newInfo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'meeting-item-new'},' ',__WEBPACK_IMPORTED_MODULE_8_moment___default()(item.newInfoDate).format('M/D'),' ',item.newInfo,'\xA0\xA0'),item.resolved&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'resolved-label'},this.props.reviewMeeting&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4_components_shared_checkbox_checkbox_square_full_png___default.a,alt:'settings'}),' RESOLVED -',' ',__WEBPACK_IMPORTED_MODULE_8_moment___default()(item.resolvedDate).format('M/D'),' ',item.resolvedNote)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.contributorIds.map(function(contrib){var contribId=contrib[0];var contribLabel=contrib[1];return _this2.props.reviewMeeting?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:contribId,className:'contributor-selected'},contribLabel):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:contribId,className:'contributor-selected',onClick:function onClick(){_this2.props.handleMeetingItemChange(itemKey,'contributorIds',item.contributorIds.filter(function(contrib){return contrib[0]!==contribId;}));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'remove'},'X'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,contribLabel));}),!this.props.reviewMeeting&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contributor-add'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-row-plus'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_SearchableDropDownPaginated__["a" /* default */],{loadOptions:this.props.loadContributors,onChange:function onChange(option){if(!item.contributorIds.find(function(contrib){return contrib[0]===option.value;})){_this2.props.handleMeetingItemChange(itemKey,'contributorIds',item.contributorIds.concat([[option.value,option.label]]));}},placeholder:'Add Contributor'}))));}}]);return MeetingItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MeetingItem.propTypes={itemKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,item:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,meetingItemSettings:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,reviewMeeting:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,handleMeetingItemSettingsClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleMeetingInfoMenuClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleMeetingItemChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,renderMenuForm:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,loadContributors:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(MeetingItem));

/***/ }),
/* 2574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_MessageModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_invalid_png__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_invalid_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_invalid_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_domain_meeting_status_enum__ = __webpack_require__(633);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MeetingActions=function(_Component){_inherits(MeetingActions,_Component);function MeetingActions(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MeetingActions);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MeetingActions.__proto__||Object.getPrototypeOf(MeetingActions)).call.apply(_ref,[this].concat(args))),_this),_this.emptyMeetingItems=function(){var meetingItems=_this.props.meetingItems;var emptyItems=Object.keys(meetingItems).filter(function(key){var item=meetingItems[key];return!!item.code&&!item.destroy&&!item.info;});return emptyItems.length>0;},_this.onReview=function(){if(_this.emptyMeetingItems()){_this.setState({invalidReview:true});}else{_this.props.handleReview();}},_this.hideInvalidReviewModal=function(){_this.setState({invalidReview:false});},_this.renderInvalidReviewModal=function(){var invalidReview=!!_this.state&&!!_this.state.invalidReview;return invalidReview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_MessageModal__["a" /* default */],{show:invalidReview,message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Make sure to fill in all items before continuing'),icon:__WEBPACK_IMPORTED_MODULE_5_images_invalid_png___default.a,onHide:_this.hideInvalidReviewModal});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MeetingActions,[{key:'render',value:function render(){var _this2=this;var meetingStatus=__WEBPACK_IMPORTED_MODULE_6_domain_meeting_status_enum__["a" /* MeetingStatusEnum */].create(this.props.meetingStatus);var _props=this.props,primary=_props.primary,reviewMeeting=_props.reviewMeeting,lastMeeting=_props.lastMeeting;return reviewMeeting?!__WEBPACK_IMPORTED_MODULE_6_domain_meeting_status_enum__["a" /* MeetingStatusEnum */].DRAFT.equals(meetingStatus)?lastMeeting?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-white',label:'Save',onClick:function onClick(){return _this2.props.handleSend(meetingStatus.status);}}),!__WEBPACK_IMPORTED_MODULE_6_domain_meeting_status_enum__["a" /* MeetingStatusEnum */].APPROVED.equals(meetingStatus)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-orange approve-and-send',label:'Approve and Publish',onClick:function onClick(){return _this2.props.handleSend('approved',true);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:'Edit',onClick:this.props.handleBack})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:'Close',onClick:this.props.handleClose})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-white',label:'Save as Draft',onClick:function onClick(){return _this2.props.handleSend('draft');}}),!primary&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-orange send-for-approval',label:'Send for Approval',onClick:function onClick(){return _this2.props.handleSend('pending',true);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-orange approve-and-send',label:'Approve and Publish',onClick:this.props.handleShowConfirmApproval}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:'Edit',onClick:this.props.handleBack})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Review',onClick:this.onReview}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:'Cancel',onClick:this.props.handleClose}),this.renderInvalidReviewModal());}}]);return MeetingActions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MeetingActions.propTypes={primary:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,reviewMeeting:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,lastMeeting:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,meetingStatus:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,meetingItems:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,handleSend:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleShowConfirmApproval:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleBack:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleReview:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(MeetingActions));

/***/ }),
/* 2575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectRfiLog_css__ = __webpack_require__(2576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectRfiLog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProjectRfiLog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_print_white_svg__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_print_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_print_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_pdf_viewer_PdfViewer__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_notifications__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_domain_notification__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_actions_notifications__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_rfi_log_store_actions__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_rfi_log_store_selectors__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_rfi_log_RfiLogTable__ = __webpack_require__(2577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_rfi_log_RfiModalContainer__ = __webpack_require__(634);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectRfiLog=function(_Component){_inherits(ProjectRfiLog,_Component);function ProjectRfiLog(props){_classCallCheck(this,ProjectRfiLog);var _this=_possibleConstructorReturn(this,(ProjectRfiLog.__proto__||Object.getPrototypeOf(ProjectRfiLog)).call(this,props));_this.handleRfiTabSelection=function(rfiTab){_this.handlePageChange(1,_this.defaultStatus(rfiTab));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_rfi_log_store_actions__["B" /* setRfiTabSelected */])(rfiTab));};_this.handlePageChange=function(page,status,dueDateFilter){var _this$props=_this.props,currentProject=_this$props.currentProject,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_rfi_log_store_actions__["n" /* loadRfisRequest */])(currentProject.id,page,status,dueDateFilter));};_this.showPreRfi=function(contribType){return __WEBPACK_IMPORTED_MODULE_7_domain_enterprise__["a" /* Enterprise */].spackleOrGc(contribType);};_this.defaultStatus=function(){var rfiTab=arguments.length>0&&arguments[0]!==undefined?arguments[0]:2;var currentProject=_this.props.currentProject;var showPreRfi=!!_this.showPreRfi(currentProject.contributor_type);return showPreRfi&&(rfiTab===1?'pending':'not_pre')||'all';};_this.handleOpenRfiModal=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_rfi_log_store_actions__["x" /* setRfiModalShow */])(true));};_this.handleOpenRfi=function(id){var readOnly=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var _this$props2=_this.props,currentProject=_this$props2.currentProject,dispatch=_this$props2.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_rfi_log_store_actions__["p" /* openRfi */])(currentProject.id,id,readOnly));dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_actions_notifications__["o" /* markNotifiableNotificationsAsRead */])(id,'Rfi'));};_this.handleViewRfiLogPdf=function(){var _this$props3=_this.props,currentProject=_this$props3.currentProject,dispatch=_this$props3.dispatch,rfiTabSelected=_this$props3.rfiTabSelected;dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_rfi_log_store_actions__["l" /* loadRfiLogPdfRequest */])(currentProject.id,_this.defaultStatus(rfiTabSelected))).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_rfi_log_store_actions__["w" /* setRfiLogPdfViewer */])(true));}});};_this.handleRfiLogPdfViewerClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_rfi_log_store_actions__["w" /* setRfiLogPdfViewer */])(false));};props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_rfi_log_store_actions__["j" /* initRfiLog */])());return _this;}_createClass(ProjectRfiLog,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.currentProject){this.handlePageChange(1,this.defaultStatus());}}},{key:'render',value:function render(){var currentUser=this.props.currentUser;var contribType=this.props.currentProject&&this.props.currentProject.contributor_type;var unreadById=Object(__WEBPACK_IMPORTED_MODULE_11_domain_notification__["d" /* unreadNotifications */])(this.props.notifications,'Rfi');var _props=this.props,rfis=_props.rfis,total=_props.total,currentPage=_props.currentPage,currentStatus=_props.currentStatus,pageSize=_props.pageSize,rfiTabSelected=_props.rfiTabSelected,rfiLogPdfViewer=_props.rfiLogPdfViewer,rfiLogPdf=_props.rfiLogPdf,dueDateFilter=_props.dueDateFilter;return this.props.currentProject&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rfi-log'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rfi-log-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'P-RFI LOG',show:this.showPreRfi(contribType),class:rfiTabSelected===1?'sel':''},{id:2,title:'RFI LOG',class:rfiTabSelected===2?'sel':''}],onSelected:this.handleRfiTabSelection}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{className:'button-gray',icon:__WEBPACK_IMPORTED_MODULE_3_images_print_white_svg___default.a,label:'View PDF',onClick:this.handleViewRfiLogPdf}),!__WEBPACK_IMPORTED_MODULE_7_domain_enterprise__["a" /* Enterprise */].primary(contribType)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Add New RFI',onClick:this.handleOpenRfiModal}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_rfi_log_RfiLogTable__["a" /* default */],{rfis:rfis,total:total,currentPage:currentPage,currentStatus:currentStatus,dueDateFilter:dueDateFilter,pageSize:pageSize,currentUser:currentUser,contribType:contribType,unreadById:unreadById,rfiTabSelected:rfiTabSelected,handlePageChange:this.handlePageChange,handleOpenRfi:this.handleOpenRfi}),rfiLogPdfViewer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:rfiLogPdf,type:'blob'},show:rfiLogPdfViewer,onClose:this.handleRfiLogPdfViewerClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_rfi_log_RfiModalContainer__["a" /* default */],null));}}]);return ProjectRfiLog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_authentication__["d" /* getCurrentUser */])(state),currentProject:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),rfis:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_rfi_log_store_selectors__["q" /* getRfis */])(state),rfiTabSelected:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_rfi_log_store_selectors__["p" /* getRfiTabSelected */])(state),currentRfi:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_rfi_log_store_selectors__["b" /* getCurrentRfi */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_rfi_log_store_selectors__["r" /* getTotal */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_rfi_log_store_selectors__["a" /* getCurrentPage */])(state),currentStatus:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_rfi_log_store_selectors__["c" /* getCurrentStatus */])(state),dueDateFilter:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_rfi_log_store_selectors__["d" /* getDueDateFilter */])(state),pageSize:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_rfi_log_store_selectors__["e" /* getPageSize */])(state),notifications:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_notifications__["b" /* getNotifications */])(state),rfiLogPdfViewer:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_rfi_log_store_selectors__["i" /* getRfiLogPdfViewer */])(state),rfiLogPdf:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_rfi_log_store_selectors__["h" /* getRfiLogPdf */])(state)};})(ProjectRfiLog));

/***/ }),
/* 2576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RfiLogTable_css__ = __webpack_require__(2578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RfiLogTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RfiLogTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleHeader__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_text_BaseStatus__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_domain_rfi_status_enum__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_services_utils_text_util__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RfiLogTable=function(_Component){_inherits(RfiLogTable,_Component);function RfiLogTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RfiLogTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RfiLogTable.__proto__||Object.getPrototypeOf(RfiLogTable)).call.apply(_ref,[this].concat(args))),_this),_this.subcontractorExists=function(rfi){var currentUser=_this.props.currentUser;return currentUser.accountable_id===rfi.contractor_id&&__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);},_this.addlAssignees=function(rfi){var currentUser=_this.props.currentUser;return rfi.rfi_questions.map(function(qus){return qus.rfi_addl_assignees;}).flat().filter(function(addlAssignee){return currentUser.id===addlAssignee.assignee_id;});},_this.assigneeExists=function(rfi){var currentUser=_this.props.currentUser;return!!rfi.assignee_ids.find(function(id){return currentUser.id===id;})||_this.addlAssignees(rfi).length>0;},_this.responderExists=function(rfi){var currentUser=_this.props.currentUser;return!!rfi.responder_ids.find(function(id){return currentUser.id===id;})||!!_this.addlAssignees(rfi).find(function(addlAssignee){return!!addlAssignee.response;});},_this.onlyUnique=function(value,index,self){return self.indexOf(value)===index;},_this.uniqAssigneeIds=function(rfi){return rfi.rfi_questions.map(function(qus){return[qus.assignee_id].concat(_toConsumableArray(qus.rfi_addl_assignees.map(function(addlAssignee){return addlAssignee.assignee_id;})));}).flat().filter(function(assigneeId){return!!assigneeId;}).filter(_this.onlyUnique);},_this.questionsForAssigneeId=function(rfi,assigneeId){return rfi.rfi_questions.map(function(question){var addlAssignee=question.rfi_addl_assignees.find(function(addlAssignee){return addlAssignee.assignee_id===assigneeId;});if(question.assignee_id===assigneeId){return question;}else if(addlAssignee){return Object.assign({},question,addlAssignee);}return null;}).filter(function(question){return!!question;});},_this.responsesForQuestions=function(questions){return questions.filter(function(qus){return!!qus.response;}).map(function(qus,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{key:index},qus.number,'. ',qus.response);});},_this.renderAssigneeTooltip=function(label,response){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["u" /* Tooltip */],{id:'tooltip-assignee-toggle'},label,response&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,response));},_this.renderAssigneeCircle=function(label,response,checked,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["q" /* OverlayTrigger */],{key:key,placement:'bottom',overlay:_this.renderAssigneeTooltip(label,response)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["b" /* Button */],{className:'addl-assignee-circle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{role:'img','aria-label':'circle'},checked?'🟢':'⚪')));},_this.handleGenerateLink=function(index){var rfis=_this.props.rfis;return'?rfiId='+rfis[index].id;},_this.mapRfis=function(){var contribType=_this.props.contribType;var spackleOrGc=__WEBPACK_IMPORTED_MODULE_12_domain_enterprise__["a" /* Enterprise */].spackle(contribType)||__WEBPACK_IMPORTED_MODULE_12_domain_enterprise__["a" /* Enterprise */].generalContractor(contribType);return _this.props.rfis.map(function(rfi){var rfiStatusEnum=__WEBPACK_IMPORTED_MODULE_13_domain_rfi_status_enum__["a" /* RfiStatusEnum */].create(rfi.status);var rfiStatusLabel=rfiStatusEnum.label;var draftRfi=__WEBPACK_IMPORTED_MODULE_13_domain_rfi_status_enum__["a" /* RfiStatusEnum */].DRAFT.equals(rfiStatusEnum);var draftOrPendingRfi=draftRfi||__WEBPACK_IMPORTED_MODULE_13_domain_rfi_status_enum__["a" /* RfiStatusEnum */].PENDING.equals(rfiStatusEnum);var resolvedRfi=__WEBPACK_IMPORTED_MODULE_13_domain_rfi_status_enum__["a" /* RfiStatusEnum */].RESOLVED.equals(rfiStatusEnum);var unread=_this.props.unreadById&&!!_this.props.unreadById[rfi.id];var sub=_this.subcontractorExists(rfi);var assigned=_this.assigneeExists(rfi);var responded=_this.responderExists(rfi);var uniqAssigneeIds=_this.uniqAssigneeIds(rfi);return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,unread&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_BaseStatus__["a" /* default */],{labels:[{id:'unread',label:''}],status:'unread'}),Object(__WEBPACK_IMPORTED_MODULE_14_services_utils_text_util__["b" /* formatNumber */])(rfi.number)),rfi.csi_code.division,rfi.title||'-',rfi.received_at?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Date__["a" /* default */],{value:rfi.received_at,format:'MM/DD/YYYY'}):'-',rfi.submitted_at?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Date__["a" /* default */],{value:rfi.submitted_at,format:'MM/DD/YYYY'}):'-',rfi.due_date?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Date__["a" /* default */],{value:rfi.extended_due_date?rfi.extended_due_date:rfi.due_date,format:'MM/DD/YYYY'}):'-',rfi.resolved_at?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Date__["a" /* default */],{value:rfi.resolved_at,format:'MM/DD/YYYY'}):'-',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:draftRfi?'draft':''},uniqAssigneeIds.length===1?uniqAssigneeIds.map(function(assigneeId,index){var questions=_this.questionsForAssigneeId(rfi,assigneeId);var responses=_this.responsesForQuestions(questions);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["q" /* OverlayTrigger */],{key:index,placement:'bottom',overlay:_this.renderAssigneeTooltip(questions[0].assignee_label,responses)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["b" /* Button */],{className:'addl-assignee-circle'},rfiStatusLabel.charAt(0).toUpperCase(),rfiStatusLabel.slice(1)));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,rfiStatusLabel.charAt(0).toUpperCase(),rfiStatusLabel.slice(1)),uniqAssigneeIds.length>1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,uniqAssigneeIds.map(function(assigneeId,index){var questions=_this.questionsForAssigneeId(rfi,assigneeId);var responses=_this.responsesForQuestions(questions);return!questions.find(function(qus){return!qus.response||qus.draft_response;})&&_this.renderAssigneeCircle(questions[0].assignee_label,responses,true,index);}),uniqAssigneeIds.map(function(assigneeId,index){var questions=_this.questionsForAssigneeId(rfi,assigneeId);return!!questions.find(function(qus){return!qus.response||qus.draft_response;})&&_this.renderAssigneeCircle(questions[0].assignee_label,null,false,index);}))),(spackleOrGc||sub&&draftOrPendingRfi||!resolvedRfi&&assigned)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_button_Button__["a" /* default */],{className:'button-blue-grey',label:assigned&&!responded?'Respond':'Edit',onClick:function onClick(){return _this.props.handleOpenRfi(rfi.id,false);}}),(resolvedRfi||!assigned||responded)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_button_Button__["a" /* default */],{className:sub?'button-blue-grey':'button-white',label:'View',onClick:function onClick(){return _this.props.handleOpenRfi(rfi.id,true);}})];});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RfiLogTable,[{key:'render',value:function render(){var _props=this.props,contribType=_props.contribType,currentPage=_props.currentPage,currentStatus=_props.currentStatus,pageSize=_props.pageSize,total=_props.total,rfiTabSelected=_props.rfiTabSelected,handlePageChange=_props.handlePageChange,_props$dueDateFilter=_props.dueDateFilter,dueDateFilter=_props$dueDateFilter===undefined?'all':_props$dueDateFilter;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rfi-log-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table',headers:['#','CSI CODE','TITLE','RECEIVED','SUBMITTED',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleHeader__["a" /* default */],{label:'DUE DATE',filter:{options:[{id:'all',label:'All'},{id:'pending',label:'Pending'},{id:'overdue',label:'Overdue'},{id:'ascending',label:'Ascending'},{id:'descending',label:'Descending'}].filter(function(st){return!!st;}),selected:dueDateFilter},onFilterOptionSelect:function onFilterOptionSelect(filter){handlePageChange(1,currentStatus,filter);}}),'RESOLVED',rfiTabSelected===1?'STATUS':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleHeader__["a" /* default */],{label:'STATUS',filter:{options:[__WEBPACK_IMPORTED_MODULE_12_domain_enterprise__["a" /* Enterprise */].spackleOrGc(contribType)?{id:'not_pre',label:'All'}:{id:'all',label:'All'},(__WEBPACK_IMPORTED_MODULE_12_domain_enterprise__["a" /* Enterprise */].spackleOrGc(contribType)||__WEBPACK_IMPORTED_MODULE_12_domain_enterprise__["a" /* Enterprise */].subcontractor(contribType))&&{id:'draft',label:'Draft'},__WEBPACK_IMPORTED_MODULE_12_domain_enterprise__["a" /* Enterprise */].subcontractor(contribType)&&{id:'pending',label:'Pending'},{id:'assigned',label:'Assigned'},{id:'responded',label:'Responded'},{id:'resolved',label:'Resolved'},{id:'for_record',label:'For Record Only'},(__WEBPACK_IMPORTED_MODULE_12_domain_enterprise__["a" /* Enterprise */].spackleOrGc(contribType)||__WEBPACK_IMPORTED_MODULE_12_domain_enterprise__["a" /* Enterprise */].subcontractor(contribType))&&{id:'void',label:'Void'}].filter(function(st){return!!st;}),selected:currentStatus},onFilterOptionSelect:function onFilterOptionSelect(status){handlePageChange(1,status,dueDateFilter);}}),'',''],rows:this.mapRfis(),emptyMessage:'No RFI\'s added yet.',onGenerateLink:this.handleGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPage,pageSize:pageSize,total:total,onPageChange:function onPageChange(page){handlePageChange(page,currentStatus);}})));}}]);return RfiLogTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RfiLogTable.propTypes={rfis:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})).isRequired,total:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,currentPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,currentStatus:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,pageSize:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,currentUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,contribType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,unreadById:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),rfiTabSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,handlePageChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleOpenRfi:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(RfiLogTable));

/***/ }),
/* 2578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RfiModal_css__ = __webpack_require__(2580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RfiModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RfiModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_rfi_log_store_actions__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_rfi_log_RfiForm__ = __webpack_require__(2581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_rfi_log_RfiQuestions__ = __webpack_require__(2583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_rfi_log_RfiActions__ = __webpack_require__(2599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_rfi_log_RfiDetails__ = __webpack_require__(2601);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RfiModal=function(_Component){_inherits(RfiModal,_Component);function RfiModal(props){_classCallCheck(this,RfiModal);var _this=_possibleConstructorReturn(this,(RfiModal.__proto__||Object.getPrototypeOf(RfiModal)).call(this,props));props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_rfi_log_store_actions__["k" /* initRfiModal */])());return _this;}_createClass(RfiModal,[{key:'render',value:function render(){var readOnly=this.props.readOnly||__WEBPACK_IMPORTED_MODULE_4_domain_enterprise__["a" /* Enterprise */].primary(this.props.contribType);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_modal_FormModal__["a" /* default */],{className:'rfi-modal',show:this.props.show,onClose:this.props.handleClose,subTitle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['Projects',this.props.project.name,'RFI '+this.props.number]})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rfi-body'},readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_rfi_log_RfiDetails__["a" /* default */],{currentRfi:this.props.currentRfi}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_rfi_log_RfiForm__["a" /* default */],{currentUser:this.props.currentUser,contribType:this.props.contribType,project:this.props.project,currentRfi:this.props.currentRfi}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_rfi_log_RfiQuestions__["a" /* default */],{currentUser:this.props.currentUser,contribType:this.props.contribType,project:this.props.project,currentRfi:this.props.currentRfi,readOnly:readOnly,modalReadOnly:this.props.readOnly,gcAcceleration:this.props.gcAcceleration})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_rfi_log_RfiActions__["a" /* default */],{currentUser:this.props.currentUser,contribType:this.props.contribType,project:this.props.project,currentRfi:this.props.currentRfi,readOnly:this.props.readOnly,gcAcceleration:this.props.gcAcceleration,handleClose:this.props.handleClose}));}}]);return RfiModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RfiModal.propTypes={currentUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,contribType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,project:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,number:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]).isRequired,show:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,currentRfi:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,gcAcceleration:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,handleClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(RfiModal));

/***/ }),
/* 2580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RfiForm_css__ = __webpack_require__(2582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RfiForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RfiForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_lock_png__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_lock_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_images_lock_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_dropdown_MultipleDropdown__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_autosize_textarea__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_autosize_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_autosize_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_domain_project__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_domain_rfi_status_enum__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_proposal_store_actions__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_directory_store_actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_rfi_log_store_actions__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_project_proposal_store_selectors__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_admin_projects_details_project_directory_store_selectors__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_rfi_log_store_selectors__ = __webpack_require__(236);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RfiForm=function(_Component){_inherits(RfiForm,_Component);function RfiForm(props){_classCallCheck(this,RfiForm);var _this=_possibleConstructorReturn(this,(RfiForm.__proto__||Object.getPrototypeOf(RfiForm)).call(this,props));_this.nextStatus=function(rfi){var _this$props=_this.props,currentUser=_this$props.currentUser,project=_this$props.project;var assigned=!rfi.rfi_questions.find(function(qus){return!qus.assignee;});var subcontractor=__WEBPACK_IMPORTED_MODULE_14_domain_enterprise__["a" /* Enterprise */].subcontractor(project.contributor_type)||__WEBPACK_IMPORTED_MODULE_13_services_utils_users_util__["g" /* usersUtil */].hasRole(currentUser,__WEBPACK_IMPORTED_MODULE_13_services_utils_users_util__["e" /* ROLES */].GENERAL_CONTRACTOR_SUPERINTENDENT);return assigned&&!subcontractor?__WEBPACK_IMPORTED_MODULE_16_domain_rfi_status_enum__["b" /* RfiStatusKeys */].ASSIGNED:__WEBPACK_IMPORTED_MODULE_16_domain_rfi_status_enum__["b" /* RfiStatusKeys */].PENDING;};_this.initStatus=function(rfi){var stEnum=__WEBPACK_IMPORTED_MODULE_16_domain_rfi_status_enum__["a" /* RfiStatusEnum */].create(rfi.status);return __WEBPACK_IMPORTED_MODULE_16_domain_rfi_status_enum__["a" /* RfiStatusEnum */].DRAFT.equals(stEnum)?_this.nextStatus(rfi):rfi.status;};_this.initFormDetails=function(rfi){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_rfi_log_store_actions__["u" /* setRfiFormValues */])(Object.assign({},rfi,{csiCodeId:rfi.csi_code_id,contractorId:rfi.contractor_id,dueDate:rfi.due_date,extendedDueDate:rfi.extended_due_date,status:_this.initStatus(rfi),relCsiCodes:rfi.rel_csi_codes.map(function(csiCode){return[csiCode.id,csiCode.division+' - '+csiCode.label];}),recipients:rfi.recipients.map(function(rcpt){return[rcpt.id,__WEBPACK_IMPORTED_MODULE_15_domain_project__["a" /* Project */].userLabelStr(rcpt,rcpt.accountable)];})})));};_this.loadDirectory=function(){var _this$props2=_this.props,project=_this$props2.project,directory=_this$props2.directory,dispatch=_this$props2.dispatch;if(!directory||directory.project_id!==project.id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_directory_store_actions__["j" /* loadDirectoryRequest */])(project.id));}};_this.loadProjectProposal=function(){var _this$props3=_this.props,project=_this$props3.project,projectProposal=_this$props3.projectProposal,dispatch=_this$props3.dispatch;if(!projectProposal||projectProposal.project_id!==project.id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_proposal_store_actions__["i" /* loadProjectProposalRequest */])(project.id));}};_this.rfiCsiCodeOptions=function(){return __WEBPACK_IMPORTED_MODULE_15_domain_project__["a" /* Project */].csiCodesOptions(_this.props);};_this.rfiCcCsiCodeOptions=function(){var form=_this.props.form;return __WEBPACK_IMPORTED_MODULE_15_domain_project__["a" /* Project */].csiCodesOptions(_this.props).filter(function(csiCode){return csiCode.value!==form.csiCodeId;}).map(function(csiCode){return{id:csiCode.value,label:csiCode.label};});};_this.recipientOptions=function(){return __WEBPACK_IMPORTED_MODULE_15_domain_project__["a" /* Project */].recipientOptions(_this.props);};_this.rfiSubcontractorOptions=function(csiCodeId){return __WEBPACK_IMPORTED_MODULE_15_domain_project__["a" /* Project */].subcontractorOptions(_this.props,csiCodeId);};_this.rfiStatusOptions=function(){return Object.keys(__WEBPACK_IMPORTED_MODULE_16_domain_rfi_status_enum__["b" /* RfiStatusKeys */]).filter(function(status){return!__WEBPACK_IMPORTED_MODULE_16_domain_rfi_status_enum__["a" /* RfiStatusEnum */].DRAFT.equals(__WEBPACK_IMPORTED_MODULE_16_domain_rfi_status_enum__["a" /* RfiStatusEnum */][status]);}).map(function(status){var statusEnum=__WEBPACK_IMPORTED_MODULE_16_domain_rfi_status_enum__["a" /* RfiStatusEnum */][status];return{value:statusEnum.status,label:''+statusEnum.label.charAt(0).toUpperCase()+statusEnum.label.slice(1)};});};_this.handleFormChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_rfi_log_store_actions__["F" /* updateRfiFormValue */])(attribute,value));};_this.handleCsiCodeChange=function(csiCodeId){_this.handleFormChange('csiCodeId',csiCodeId);_this.handleFormChange('contractorId',null);var subOptions=_this.rfiSubcontractorOptions(csiCodeId);if(subOptions.length===1){_this.handleFormChange('contractorId',subOptions[0].value);}};if(props.currentRfi){_this.initFormDetails(props.currentRfi);}return _this;}_createClass(RfiForm,[{key:'componentDidMount',value:function componentDidMount(){this.loadDirectory();if(!__WEBPACK_IMPORTED_MODULE_14_domain_enterprise__["a" /* Enterprise */].subcontractor(this.props.project.contributor_type)){this.loadProjectProposal();}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,form=_props.form,currentUser=_props.currentUser,contribType=_props.contribType,currentRfi=_props.currentRfi;var subOptions=this.rfiSubcontractorOptions(form.csiCodeId);var statusLabel=form?__WEBPACK_IMPORTED_MODULE_16_domain_rfi_status_enum__["a" /* RfiStatusEnum */].create(form.status).label:null;var subcontractor=__WEBPACK_IMPORTED_MODULE_14_domain_enterprise__["a" /* Enterprise */].subcontractor(contribType)||__WEBPACK_IMPORTED_MODULE_13_services_utils_users_util__["g" /* usersUtil */].hasRole(currentUser,__WEBPACK_IMPORTED_MODULE_13_services_utils_users_util__["e" /* ROLES */].GENERAL_CONTRACTOR_SUPERINTENDENT);var assigned=currentRfi&&!currentRfi.rfi_questions.find(function(qus){return!qus.assignee;});var today=__WEBPACK_IMPORTED_MODULE_6_moment___default()();var dueDateCountdown=form&&form.dueDate?Object(__WEBPACK_IMPORTED_MODULE_11_services_utils_date_util__["b" /* countdown */])(today.format('YYYY-MM-DD'),form.dueDate):null;var extendedDueDateCountdown=form&&form.extendedDueDate?Object(__WEBPACK_IMPORTED_MODULE_11_services_utils_date_util__["b" /* countdown */])(today.format('YYYY-MM-DD'),form.extendedDueDate):null;if(dueDateCountdown){dueDateCountdown+=today>__WEBPACK_IMPORTED_MODULE_6_moment___default()(form.dueDate)?' past due':' left';}if(extendedDueDateCountdown){extendedDueDateCountdown+=today>__WEBPACK_IMPORTED_MODULE_6_moment___default()(form.extendedDueDate)?' past due':' left';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rfi-form'},(!currentRfi||form.csiCodeId)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Form */],{horizontal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},'CSI Code'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_dropdown_Dropdown__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'form-error':form.errors.csiCodeId}),placeholder:'Select Code...',value:form.csiCodeId,onChange:function onChange(option){return _this2.handleCsiCodeChange(option.value);},options:this.rfiCsiCodeOptions()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:3},subcontractor?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'status-locked'},statusLabel.charAt(0).toUpperCase(),statusLabel.slice(1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'locked-icon',src:__WEBPACK_IMPORTED_MODULE_7_images_lock_png___default.a,alt:'locked'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_dropdown_Dropdown__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'form-error':form.errors.status}),placeholder:'Select Status...',value:form.status,onChange:function onChange(option){return _this2.handleFormChange('status',option.value);},options:this.rfiStatusOptions()}))),!subcontractor&&subOptions.length>1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},'Subcontractor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_dropdown_Dropdown__["a" /* default */],{placeholder:'Select Subcontractor...',value:form.contractorId,onChange:function onChange(option){return _this2.handleFormChange('contractorId',option.value);},options:subOptions}))),!subcontractor&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},'CC CSI Code(s)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_dropdown_MultipleDropdown__["a" /* default */],{options:this.rfiCcCsiCodeOptions(),currentValues:form.relCsiCodes,placeholder:'Select CSI Codes to CC',onChange:function onChange(values){return _this2.handleFormChange('relCsiCodes',values);}}))),!subcontractor&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},'CC Recipient(s)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_dropdown_MultipleDropdown__["a" /* default */],{options:this.recipientOptions(),currentValues:form.recipients,placeholder:'Select Contributors to CC',onChange:function onChange(values){return _this2.handleFormChange('recipients',values);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},'Due Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'form-error':form.errors.dueDate})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:__WEBPACK_IMPORTED_MODULE_11_services_utils_date_util__["k" /* todayValidation */],placeholder:'Choose Date...',value:form.dueDate,onChange:function onChange(value){return _this2.handleFormChange('dueDate',value);}}))),dueDateCountdown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:4,className:'countdown'},dueDateCountdown)),assigned&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},'Extended Due Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'form-error':form.errors.extendedDueDate})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:__WEBPACK_IMPORTED_MODULE_11_services_utils_date_util__["k" /* todayValidation */],placeholder:'Choose Date...',value:form.extendedDueDate,onChange:function onChange(value){return _this2.handleFormChange('extendedDueDate',value);}}))),extendedDueDateCountdown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:4,className:'countdown'},extendedDueDateCountdown)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:11},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_autosize_textarea___default.a,{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'form-error':form.errors.title}),rows:1,placeholder:'Enter Text Here...',defaultValue:form.title,onBlur:function onBlur(e){return _this2.handleFormChange('title',e.target.value);}})))));}}]);return RfiForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RfiForm.propTypes={currentUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,contribType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,project:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,currentRfi:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{projectProposal:Object(__WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_project_proposal_store_selectors__["f" /* getProjectProposal */])(state),directory:Object(__WEBPACK_IMPORTED_MODULE_21_components_admin_projects_details_project_directory_store_selectors__["c" /* getDirectory */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_rfi_log_store_selectors__["f" /* getRfiForm */])(state)};})(RfiForm));

/***/ }),
/* 2582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RfiQuestions_css__ = __webpack_require__(2584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RfiQuestions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RfiQuestions_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_domain_rfi_status_enum__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_directory_store_actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_rfi_log_store_selectors__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_rfi_log_RfiQuestion__ = __webpack_require__(2585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_rfi_log_store_actions__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_text_util__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RfiQuestions=function(_Component){_inherits(RfiQuestions,_Component);function RfiQuestions(props){_classCallCheck(this,RfiQuestions);var _this=_possibleConstructorReturn(this,(RfiQuestions.__proto__||Object.getPrototypeOf(RfiQuestions)).call(this,props));_this.initQuestions=function(rfi){var _this$props=_this.props,currentUser=_this$props.currentUser,modalReadOnly=_this$props.modalReadOnly;var questions=rfi.rfi_questions.map(function(qus){var addlAssignee=qus.rfi_addl_assignees.find(function(addlAssignee){return addlAssignee.assignee_id===currentUser.id;});return Object.assign({},qus,{notesReadBy:qus.notes_read_by,assignee:qus.assignee?[qus.assignee.id,_this.userLabelStr(qus.assignee,qus.assignee.accountable)]:[],addlAssignees:qus.rfi_addl_assignees.map(function(addlAssignee){return{id:addlAssignee.id,assigneeId:addlAssignee.assignee_id,assigneeLabel:addlAssignee.assignee_label,dueDate:addlAssignee.due_date,respondedAt:addlAssignee.responded_at,response:addlAssignee.response};}),response:addlAssignee&&!modalReadOnly?addlAssignee.response:qus.response,reqDocsDelete:[],reqImagesDelete:[],resDocsDelete:[],resImagesDelete:[],errors:{}});});_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_rfi_log_store_actions__["c" /* attachRfiQuestions */])(questions));};_this.assigneeChanged=function(questionKey){var questions=_this.props.questions;var allAssigned=!Object.keys(questions).find(function(key){return key!==questionKey&&questions[key].assignee.length===0;});if(allAssigned){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_rfi_log_store_actions__["F" /* updateRfiFormValue */])('status',__WEBPACK_IMPORTED_MODULE_6_domain_rfi_status_enum__["a" /* RfiStatusEnum */].ASSIGNED.status));}};_this.resolvedChanged=function(questionKey){var questions=_this.props.questions;var allResolved=!Object.keys(questions).find(function(key){return key!==questionKey&&!questions[key].resolved;});if(allResolved){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_rfi_log_store_actions__["F" /* updateRfiFormValue */])('status',__WEBPACK_IMPORTED_MODULE_6_domain_rfi_status_enum__["a" /* RfiStatusEnum */].RESOLVED.status));}};_this.userLabelStr=function(user,company){if(company){return user.first_name+' '+user.last_name+' - '+(company.name||company.company_name);}else{return user.first_name+' '+user.last_name+' - Spackle';}};_this.loadContributors=function(){var users={};return _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_directory_store_actions__["m" /* searchDirectory */])(_this.props.project.id)).then(function(response){if(response.ok){var contributors=response.directory.project_contributors.filter(function(pc){return pc.primary&&pc.company_type!=='GeneralContractor';}).map(function(pc){return pc.users.filter(function(usr){return!users[usr.id];}).map(function(usr){users[usr.id]=true;return{value:usr.id,label:_this.userLabelStr(usr,pc.company)};});}).reduce(function(acc,val){return acc.concat(val);},[]);return{ok:true,options:contributors};}});};_this.loadRfiQuestionNotes=function(questionKey,question){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_rfi_log_store_actions__["o" /* markRfiQuestionNotesRead */])(questionKey,question,_this.props.currentUser.id));return _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_rfi_log_store_actions__["m" /* loadRfiQuestionNotes */])(questionKey,question.id));};_this.createRfiQuestionNote=function(questionKey,questionId,content){return _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_rfi_log_store_actions__["e" /* createRfiQuestionNote */])(questionKey,questionId,content));};_this.mapRfiQuestions=function(){var showNotes=_this.showNotes();var questions=Object.keys(_this.props.questions).map(function(key){var question=_this.props.questions[key];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_rfi_log_RfiQuestion__["a" /* default */],{key:key,currentUser:_this.props.currentUser,contribType:_this.props.contribType,dueDate:_this.props.form.extendedDueDate||_this.props.form.dueDate,questionKey:key,question:question,assigneeChanged:_this.assigneeChanged,resolvedChanged:_this.resolvedChanged,loadContributors:_this.loadContributors,loadQuestionNotes:_this.loadRfiQuestionNotes,createQuestionNote:_this.createRfiQuestionNote,handleQuestionChange:_this.handleRfiQuestionChange,handleQuestionDeleteFile:_this.handleRfiQuestionDeleteFile,readOnly:_this.props.readOnly,modalReadOnly:_this.props.modalReadOnly,gcAcceleration:_this.props.gcAcceleration,showNotes:showNotes});});if(!_this.props.readOnly){questions.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'add-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-row-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tomato-row add-row',onClick:_this.handleAddAdditionalRfi},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-row-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'add-row-plus'},'+ '),questions.length===0?'Add RFI':'Add Additional RFI')),questions.length>1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-row',onClick:_this.handleDeleteRfi},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-row-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'add-row-plus'},'- '),'Delete RFI'))))));}return questions;};_this.showNotes=function(){var currentRfi=_this.props.currentRfi;return!!currentRfi&&!__WEBPACK_IMPORTED_MODULE_6_domain_rfi_status_enum__["a" /* RfiStatusEnum */].DRAFT.equals(__WEBPACK_IMPORTED_MODULE_6_domain_rfi_status_enum__["a" /* RfiStatusEnum */].create(currentRfi.status));};_this.handleRfiQuestionChange=function(key,attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_rfi_log_store_actions__["G" /* updateRfiQuestionValue */])(key,attribute,value));};_this.handleRfiQuestionDeleteFile=function(key,attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_rfi_log_store_actions__["f" /* deleteQuestionFile */])(key,attribute,value));};_this.handleAddAdditionalRfi=function(){var key=Object.keys(_this.props.questions).length+1;_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_rfi_log_store_actions__["b" /* addRfiQuestion */])(key,{number:key,action:'',question:'',response:'',resolved:false,assignee:[],addlAssignees:[],rfi_addl_assignees:[],reqDocs:[],reqImages:[],reqDocsDelete:[],reqImagesDelete:[],resDocs:[],resImages:[],resDocsDelete:[],resImagesDelete:[]}));};_this.handleDeleteRfi=function(){var _this$props2=_this.props,questions=_this$props2.questions,dispatch=_this$props2.dispatch;var keys=Object.keys(questions);var key=keys[keys.length-1];dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_rfi_log_store_actions__["i" /* deleteRfiQuestion */])(key));};if(props.currentRfi){_this.initQuestions(props.currentRfi);}else{_this.handleAddAdditionalRfi();}return _this;}_createClass(RfiQuestions,[{key:'render',value:function render(){var _this2=this;var _props=this.props,currentUser=_props.currentUser,currentRfi=_props.currentRfi,questions=_props.questions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rfi-questions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'rfi-title'},currentRfi?'RFI #'+Object(__WEBPACK_IMPORTED_MODULE_11_services_utils_text_util__["b" /* formatNumber */])(currentRfi.number)+' '+(currentRfi.title?' - '+currentRfi.title:''):'Request For Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'rfi-submitted-by'},'Submitted by',currentRfi&&currentRfi.submitted_by?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0',this.userLabelStr(currentRfi.submitted_by,currentRfi.submitted_by.accountable),'\xA0on',' ',__WEBPACK_IMPORTED_MODULE_4_moment___default()(currentRfi.submitted_at||currentRfi.received_at).format('MM/DD/YY')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0',this.userLabelStr(currentUser,currentUser.accountable),'\xA0on ',__WEBPACK_IMPORTED_MODULE_4_moment___default()().format('MM/DD/YY'))),currentRfi&&Object.keys(questions).filter(function(key){var qus=questions[key];return!!qus.response&&!!qus.responded_by&&!!qus.responded_at;}).map(function(key){var qus=questions[key];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{key:key,className:'rfi-responded-by'},qus.number,'. Responded by',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0',_this2.userLabelStr(qus.responded_by,qus.responded_by.accountable),'\xA0on ',__WEBPACK_IMPORTED_MODULE_4_moment___default()(qus.responded_at).format('MM/DD/YY')));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["t" /* Table */],{className:'simple-table rfi-questions-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:2})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.mapRfiQuestions())));}}]);return RfiQuestions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RfiQuestions.propTypes={currentUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,contribType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,project:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,currentRfi:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,modalReadOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,gcAcceleration:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{questions:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_rfi_log_store_selectors__["l" /* getRfiQuestions */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_rfi_log_store_selectors__["f" /* getRfiForm */])(state)};})(RfiQuestions));

/***/ }),
/* 2584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RfiQuestion_css__ = __webpack_require__(2586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RfiQuestion_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RfiQuestion_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_SimpleTruncate__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_autosize_textarea__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_autosize_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_autosize_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_dropdown_SearchableDropDownPaginated__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_checkbox_LabeledCheckBox__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_rfi_log_RfiDocuments__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_rfi_log_RfiResponse__ = __webpack_require__(2593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_rfi_log_RfiQuestionNotes__ = __webpack_require__(2595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_rfi_log_RfiAddlAssignees__ = __webpack_require__(2596);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RfiQuestion=function(_Component){_inherits(RfiQuestion,_Component);function RfiQuestion(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RfiQuestion);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RfiQuestion.__proto__||Object.getPrototypeOf(RfiQuestion)).call.apply(_ref,[this].concat(args))),_this),_this.assigneeExists=function(userId){return _this.props.question.assignee[0]===userId;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RfiQuestion,[{key:'render',value:function render(){var _this2=this;var _props=this.props,contribType=_props.contribType,currentUser=_props.currentUser,dueDate=_props.dueDate,questionKey=_props.questionKey,question=_props.question,loadQuestionNotes=_props.loadQuestionNotes,createQuestionNote=_props.createQuestionNote,handleQuestionChange=_props.handleQuestionChange,handleQuestionDeleteFile=_props.handleQuestionDeleteFile,assigneeChanged=_props.assigneeChanged,resolvedChanged=_props.resolvedChanged,loadContributors=_props.loadContributors,readOnly=_props.readOnly,modalReadOnly=_props.modalReadOnly,gcAcceleration=_props.gcAcceleration;var spackleOrGc=__WEBPACK_IMPORTED_MODULE_12_domain_enterprise__["a" /* Enterprise */].spackleOrGc(contribType)&&!__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasRole(currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["e" /* ROLES */].GENERAL_CONTRACTOR_SUPERINTENDENT);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'rfi-question'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'question-number'},question.number)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:7},(readOnly||spackleOrGc)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["s" /* Row */],{className:'question-assignee'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:1,componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */]},readOnly?'Assigned To':'Assign To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:8},question.assignee.length===0?readOnly?'-':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'contributor-add':true,'question-error':question.errors.assignee})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-row-plus'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_dropdown_SearchableDropDownPaginated__["a" /* default */],{loadOptions:loadContributors,onChange:function onChange(option){if(!_this2.assigneeExists(option.value)){handleQuestionChange(questionKey,'assignee',[option.value,option.label]);assigneeChanged(questionKey);}},placeholder:'Add Contributor'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contributor-selected',onClick:function onClick(){if(!readOnly&&spackleOrGc){handleQuestionChange(questionKey,'assignee',[]);}}},!readOnly&&spackleOrGc&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'remove'},'X'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,question.assignee[1])))),(readOnly||spackleOrGc)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},'Additional Assignees'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_rfi_log_RfiAddlAssignees__["a" /* default */],{contribType:contribType,dueDate:dueDate,question:question,questionKey:questionKey,readOnly:readOnly}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1,className:'action-label'},'Action'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:8},readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'action-value'},question.action):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_dropdown_Dropdown__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'action-value':true,'question-error':question.errors.action}),placeholder:'Select Action...',value:question.action,onChange:function onChange(option){return handleQuestionChange(questionKey,'action',option.value);},options:[{value:'Question',label:'Question'},{value:'Confirm Receipt',label:'Confirm Receipt'},{value:'Approval Request',label:'Approval Request'}]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},'Question'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:8},readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_SimpleTruncate__["a" /* default */],{text:question.question}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_autosize_textarea___default.a,{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'question-error':question.errors.question}),rows:1,placeholder:'Enter Question Here\u2026',defaultValue:question.question,onBlur:function onBlur(e){return handleQuestionChange(questionKey,'question',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_rfi_log_RfiDocuments__["a" /* default */],{questionKey:questionKey,question:question,readOnly:readOnly,fileType:'req',handleQuestionChange:handleQuestionChange,handleQuestionDeleteFile:handleQuestionDeleteFile}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_rfi_log_RfiResponse__["a" /* default */],{questionKey:questionKey,question:question,currentUser:currentUser,contribType:contribType,readOnly:modalReadOnly,gcAcceleration:gcAcceleration,handleResponseChange:handleQuestionChange,handleQuestionDeleteFile:handleQuestionDeleteFile}),(question.responded_at||gcAcceleration)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{checked:!!question.resolved,onChange:function onChange(value){handleQuestionChange(questionKey,'resolved',value);resolvedChanged(questionKey);},label:'Resolved',readOnly:readOnly||__WEBPACK_IMPORTED_MODULE_12_domain_enterprise__["a" /* Enterprise */].subcontractor(contribType)})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:5},question.id&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_rfi_log_RfiQuestionNotes__["a" /* default */],{questionKey:questionKey,question:question,loadQuestionNotes:loadQuestionNotes,createQuestionNote:createQuestionNote})))));}}]);return RfiQuestion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RfiQuestion.propTypes={currentUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,contribType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,dueDate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,questionKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,question:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,assigneeChanged:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,resolvedChanged:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,loadContributors:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,loadQuestionNotes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,createQuestionNote:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleQuestionChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleQuestionDeleteFile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,modalReadOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,gcAcceleration:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(RfiQuestion));

/***/ }),
/* 2586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PdfViewerBluebeam_css__ = __webpack_require__(2589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PdfViewerBluebeam_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PdfViewerBluebeam_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_button_ImageButton__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_iframe__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_close_svg__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_images_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_api_bluebeam_api__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_api_pdftron_api__ = __webpack_require__(2590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_actions_pdfViewerBluebeam__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_actions__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_selectors__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_shared_pdf_viewer_bluebeam_store_actions__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__UsersNotificationModal__ = __webpack_require__(2591);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PdfViewerBluebeam=function(_Component){_inherits(PdfViewerBluebeam,_Component);_createClass(PdfViewerBluebeam,[{key:'loadPdf',value:function loadPdf(){this.props.onResetPdftronMessages();var url=this.getContent(this.props);if(this.viewer){window.WebViewer({path:"https://spackle.s3.amazonaws.com/lib",initialDoc:url,annotationUser:this.props.currentUser.first_name+' '+this.props.currentUser.last_name,config:"https://spackle.s3.amazonaws.com/lib"+'/pdftron_config.js',disableLogs:true},this.viewer);}}},{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('message',this.handleIframeMessages.bind(this));}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('message',this.handleIframeMessages);}}]);function PdfViewerBluebeam(props){_classCallCheck(this,PdfViewerBluebeam);var _this=_possibleConstructorReturn(this,(PdfViewerBluebeam.__proto__||Object.getPrototypeOf(PdfViewerBluebeam)).call(this,props));_initialiseProps.call(_this);_this.viewer=null;_this.setViewerRef=function(element){_this.viewer=element;_this.loadPdf();};_this.docViewer=null;_this.annotManager=null;_this.instance=null;_this.state={showSaveConfirmation:false,closeModal:false,pdfTronChangesDetected:false,openedWithBluebeam:false};return _this;}_createClass(PdfViewerBluebeam,[{key:'render',value:function render(){var props=this.props;var url=props.show&&this.getContent(props);return props.show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["o" /* Modal */],{className:'pdf-viewer-modal',show:props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["o" /* Modal */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body-bold'},'Pdf Viewer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},props.pdfTronSuccess===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pdfTronMessage pdfTronSuccess'},'PDF successfully saved'),props.pdfTronSuccess===false&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pdfTronMessage pdfTronError'},'PDF not saved'),props.pdftronIntegration&&!this.state.openedWithBluebeam&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Save Changes',onClick:this.handleClickSave}),props.bbIntegration&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-white',label:'Invite users to edit',onClick:this.handleInviteUsers}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-white',label:'Open with Bluebeam Studio',onClick:this.handleOpenWithBluebeam}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_ImageButton__["a" /* default */],{alt:'close',src:__WEBPACK_IMPORTED_MODULE_9_images_close_svg___default.a,onClick:this.handleClose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["o" /* Modal */].Body,null,url!==null&&props.pdftronIntegration&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pdf-web-viewer',ref:this.setViewerRef}),url!==null&&!props.pdftronIntegration&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_iframe__["a" /* default */],{url:url,className:'pdf-viewer-iframe',width:'100%',height:'100%',display:'initial',position:'relative',allowFullScreen:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__UsersNotificationModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_modal_ConfirmationModal__["a" /* default */],{show:this.state.showSaveConfirmation,message:'Do you want to save your changes before closing?',onHide:this.handleCloseConfirmation}));}}]);return PdfViewerBluebeam;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PdfViewerBluebeam.propTypes={show:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,content:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({source:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['url','blob'])}),bbIntegration:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,pdftronIntegration:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};PdfViewerBluebeam.defaultProps={show:false,content:null,bbIntegration:false,pdftronIntegration:false,pdfTronSuccess:null};var _initialiseProps=function _initialiseProps(){var _this2=this;this.handleClose=function(){if(_this2.props.pdftronIntegration&&_this2.state.pdfTronChangesDetected&&!_this2.state.openedWithBluebeam){_this2.setState({showSaveConfirmation:true});}else{if(_this2.props.onClose){_this2.props.onClose();}}};this.handleCloseConfirmation=function(response){if(response){_this2.setState({closeModal:true});_this2.handleClickSave();}else if(_this2.props.onClose){_this2.props.onClose();}_this2.setState({showSaveConfirmation:false});};this.handleClickSave=function(){if(_this2.viewer){var iframe=document.getElementsByClassName('pdf-web-viewer')[0].firstElementChild;var message={type:'saveDocument',documentId:_this2.props.documentId};iframe.contentWindow.postMessage(message,'*');}};this.handleIframeMessages=function(event){if(event.data.type==='clickDetected'){_this2.setState({pdfTronChangesDetected:true});}if(event.data.type==='savePdf'&&event.data.documentId===_this2.props.documentId){_this2.props.onResetPdftronMessages();__WEBPACK_IMPORTED_MODULE_12_services_api_pdftron_api__["a" /* pdfTronApi */].savePdf(event.data.data,_this2.props.documentId,_this2.props.fileName).then(function(response){_this2.props.onSavedPdfTronSuccess(response.ok);_this2.setState({pdfTronChangesDetected:false});if(_this2.props.onClose&&_this2.state.closeModal){_this2.props.onClose();}});}};this.handleOpenWithBluebeam=function(){__WEBPACK_IMPORTED_MODULE_11_services_api_bluebeam_api__["a" /* bluebeamApi */].isAuthorized().then(function(response){if(response.ok){if(response.data.error){__WEBPACK_IMPORTED_MODULE_11_services_api_bluebeam_api__["a" /* bluebeamApi */].authorize(_this2.props.documentId).then(function(response){if(response.ok){window.open(response.url,'_blank');}});}else{__WEBPACK_IMPORTED_MODULE_11_services_api_bluebeam_api__["a" /* bluebeamApi */].editInBluebeam(_this2.props.documentId,_this2.props.content.source).then(function(response){window.open(response.url);});}}});_this2.setState({openedWithBluebeam:true});_this2.props.onCreatedBluebeamSession();};this.handleInviteUsers=function(){_this2.props.onHandleInviteUsers(_this2.props.documentId);};this.getContent=function(props){var url=null;if(props.content!==null){if(props.content.type==='url'){url=props.content.source;}else if(props.content.type==='blob'){if(navigator.appVersion.toString().indexOf('.NET')>0){window.navigator.msSaveBlob(props.content.source);return null;}else{//Create a Blob from the PDF Stream
var file=new Blob([props.content.source],{type:'application/pdf'});//Build a URL from the file
url=URL.createObjectURL(file);}}}return url;};};var mapStateToProps=function mapStateToProps(state){return{pdfTronSuccess:Object(__WEBPACK_IMPORTED_MODULE_15__store_selectors__["c" /* getPdfTronSuccess */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_authentication__["d" /* getCurrentUser */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCreatedBluebeamSession:function onCreatedBluebeamSession(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_pdfViewerBluebeam__["c" /* createdBluebeamSession */])());},onHandleInviteUsers:function onHandleInviteUsers(documentId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_shared_pdf_viewer_bluebeam_store_actions__["f" /* setShowModal */])({modal:true,documentId:documentId}));},onResetPdftronMessages:function onResetPdftronMessages(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__store_actions__["b" /* resetPdfTronMessages */])());},onSavedPdfTronSuccess:function onSavedPdfTronSuccess(response){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__store_actions__["c" /* savedPdfTronSuccess */])(response));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(PdfViewerBluebeam));

/***/ }),
/* 2589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pdfTronApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PdfTronApi=function(_BaseApi){_inherits(PdfTronApi,_BaseApi);function PdfTronApi(){_classCallCheck(this,PdfTronApi);return _possibleConstructorReturn(this,(PdfTronApi.__proto__||Object.getPrototypeOf(PdfTronApi)).apply(this,arguments));}_createClass(PdfTronApi,[{key:'savePdf',value:function savePdf(data,documentId,fileName){var formData=new FormData();formData.append('pdf_data',data,fileName);formData.append('document_id',documentId);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/pdftron/save',formData,{'Content-Type':'multipart/form-data'}).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return PdfTronApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var pdfTronApi=new PdfTronApi();

/***/ }),
/* 2591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_selectors__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_directory_store_actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_pdf_viewer_bluebeam_store_selectors__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_pdf_viewer_bluebeam_store_actions__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_dropdown_MultipleDropdown__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_api_bluebeam_api__ = __webpack_require__(635);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UsersNotificationModal=function(_Component){_inherits(UsersNotificationModal,_Component);function UsersNotificationModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UsersNotificationModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UsersNotificationModal.__proto__||Object.getPrototypeOf(UsersNotificationModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_shared_pdf_viewer_bluebeam_store_actions__["f" /* setShowModal */])(false));},_this.handleRecipientsChange=function(recipients){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_shared_pdf_viewer_bluebeam_store_actions__["e" /* setRecipients */])(recipients));},_this.isSendButtonEnabled=function(){return _this.props.recipients.length>0&&_this.props.subject!==''&&_this.props.message!=='';},_this.handleSendEmail=function(recipients){__WEBPACK_IMPORTED_MODULE_10_services_api_bluebeam_api__["a" /* bluebeamApi */].inviteUsers(recipients.recipients,_this.props.currentProject.id,_this.props.documentId).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_shared_pdf_viewer_bluebeam_store_actions__["f" /* setShowModal */])(false));}});},_this.recipientOptions=function(project_contributors){return _this.uniqueEmails(project_contributors.map(function(pc){return pc.users.map(function(user){return{id:user.id,label:user.email};});}).flat(1));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UsersNotificationModal,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props=this.props,currentProject=_props.currentProject,directory=_props.directory,initialSubject=_props.initialSubject,initialMessage=_props.initialMessage,dispatch=_props.dispatch;var initPayload={subject:initialSubject,message:initialMessage};if(!directory||directory.project_id!==currentProject.id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_directory_store_actions__["j" /* loadDirectoryRequest */])(currentProject.id)).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_shared_pdf_viewer_bluebeam_store_actions__["d" /* setEmails */])(_this2.recipientOptions(response.directory.project_contributors)));}});}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_shared_pdf_viewer_bluebeam_store_actions__["d" /* setEmails */])(this.recipientOptions(directory.project_contributors)));}dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_shared_pdf_viewer_bluebeam_store_actions__["a" /* initProjectEmailModal */])(initPayload));}},{key:'uniqueEmails',value:function uniqueEmails(emails){var uniques=[];emails.forEach(function(email){if(!uniques.find(function(unique){return unique.id===email.id;})){uniques.push(email);}});return uniques;}},{key:'render',value:function render(){var _this3=this;var _props2=this.props,showModal=_props2.showModal,recipients=_props2.recipients,emails=_props2.emails;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{className:'project-email-modal',show:showModal||false,title:'Select emails to send invites',onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-email-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'body-bold'},'To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'users-email-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_dropdown_MultipleDropdown__["a" /* default */],{className:'to-emails-dropdown',dropdownClassName:'alternate-dropdown-control',options:emails,currentValues:recipients,placeholder:'Select emails...',onChange:function onChange(values){return _this3.handleRecipientsChange(values);}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:!this.isSendButtonEnabled(),label:'Send',onClick:function onClick(){return _this3.handleSendEmail({recipients:recipients.map(function(recipient){return recipient[1];})});}}))));}}]);return UsersNotificationModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),directory:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_selectors__["c" /* getDirectory */])(state),showModal:Object(__WEBPACK_IMPORTED_MODULE_6_components_shared_pdf_viewer_bluebeam_store_selectors__["e" /* getShowEmailModal */])(state),documentId:Object(__WEBPACK_IMPORTED_MODULE_6_components_shared_pdf_viewer_bluebeam_store_selectors__["a" /* getDocumentId */])(state),emails:Object(__WEBPACK_IMPORTED_MODULE_6_components_shared_pdf_viewer_bluebeam_store_selectors__["b" /* getEmails */])(state),recipients:Object(__WEBPACK_IMPORTED_MODULE_6_components_shared_pdf_viewer_bluebeam_store_selectors__["d" /* getRecipients */])(state)};})(UsersNotificationModal));

/***/ }),
/* 2592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCreatedBluebeamSession; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getCreatedBluebeamSession=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.pdfViewer.createdBluebeamSession;},function(errors){return errors;});

/***/ }),
/* 2593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RfiResponse_css__ = __webpack_require__(2594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RfiResponse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RfiResponse_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_SimpleTruncate__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_rfi_log_RfiDocuments__ = __webpack_require__(1030);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RfiResponse=function(_Component){_inherits(RfiResponse,_Component);function RfiResponse(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RfiResponse);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RfiResponse.__proto__||Object.getPrototypeOf(RfiResponse)).call.apply(_ref,[this].concat(args))),_this),_this.assigneeExists=function(userId){var question=_this.props.question;return question.assignee[0]===userId||!!question.addlAssignees.find(function(addlAssignee){return addlAssignee.assigneeId===userId;});},_this.readOnly=function(){var _this$props=_this.props,question=_this$props.question,currentUser=_this$props.currentUser,contribType=_this$props.contribType,readOnly=_this$props.readOnly,gcAcceleration=_this$props.gcAcceleration;return readOnly||!question.id||__WEBPACK_IMPORTED_MODULE_8_domain_enterprise__["a" /* Enterprise */].primary(contribType)&&!_this.assigneeExists(currentUser.id)||!__WEBPACK_IMPORTED_MODULE_8_domain_enterprise__["a" /* Enterprise */].primary(contribType)&&!gcAcceleration;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RfiResponse,[{key:'render',value:function render(){var _props=this.props,questionKey=_props.questionKey,question=_props.question,currentUser=_props.currentUser,handleResponseChange=_props.handleResponseChange,handleQuestionDeleteFile=_props.handleQuestionDeleteFile;var addlAssignee=question.rfi_addl_assignees.find(function(addlAssignee){return addlAssignee.assignee_id===currentUser.id;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["s" /* Row */],{className:'rfi-response'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},'Response'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:8},this.readOnly()?question.response?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_SimpleTruncate__["a" /* default */],{text:question.response}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'N/A \u2013 no response has been submitted yet.'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea___default.a,{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'question-error':question.errors.response}),rows:1,placeholder:'Add Response\u2026',defaultValue:question.response,onBlur:function onBlur(e){return handleResponseChange(questionKey,'response',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_rfi_log_RfiDocuments__["a" /* default */],{questionKey:questionKey,question:question,questionAddlAssignee:addlAssignee,readOnly:this.readOnly(),fileType:'res',handleQuestionChange:handleResponseChange,handleQuestionDeleteFile:handleQuestionDeleteFile})));}}]);return RfiResponse;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RfiResponse.propTypes={questionKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,question:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,currentUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,contribType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,gcAcceleration:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,handleResponseChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleQuestionDeleteFile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(RfiResponse));

/***/ }),
/* 2594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_chat_Chat__ = __webpack_require__(315);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RfiQuestionNotes=function(_Component){_inherits(RfiQuestionNotes,_Component);function RfiQuestionNotes(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RfiQuestionNotes);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RfiQuestionNotes.__proto__||Object.getPrototypeOf(RfiQuestionNotes)).call.apply(_ref,[this].concat(args))),_this),_this.loadNotes=function(){var _this$props=_this.props,questionKey=_this$props.questionKey,question=_this$props.question,loadQuestionNotes=_this$props.loadQuestionNotes;return loadQuestionNotes(questionKey,question);},_this.buildNote=function(newNote){return{note:newNote.content?newNote.content:'',images:newNote.images?newNote.images:[],documents:newNote.documents?newNote.documents:[]};},_this.handleSubmit=function(newNote){var _this$props2=_this.props,questionKey=_this$props2.questionKey,question=_this$props2.question,createQuestionNote=_this$props2.createQuestionNote;return createQuestionNote(questionKey,question.id,_this.buildNote(newNote));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RfiQuestionNotes,[{key:'render',value:function render(){var question=this.props.question;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_chat_Chat__["a" /* default */],{name:'RFI',notes:question.notes,loadChat:this.loadNotes,handleSubmit:this.handleSubmit});}}]);return RfiQuestionNotes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RfiQuestionNotes.propTypes={questionKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,question:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,loadQuestionNotes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,createQuestionNote:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(RfiQuestionNotes));

/***/ }),
/* 2596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RfiAddlAssignees_css__ = __webpack_require__(2597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RfiAddlAssignees_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RfiAddlAssignees_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_rfi_log_store_actions__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_additional_assignees_AddlAssigneeForm__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RfiAddlAssignees=function(_Component){_inherits(RfiAddlAssignees,_Component);function RfiAddlAssignees(props){_classCallCheck(this,RfiAddlAssignees);var _this=_possibleConstructorReturn(this,(RfiAddlAssignees.__proto__||Object.getPrototypeOf(RfiAddlAssignees)).call(this,props));_this.handleShowAddlAssigneeForm=function(addlAssignee){_this.setState({showAddlAssigneeForm:true,addlAssignee:addlAssignee});};_this.handleCloseAddlAssigneeForm=function(){_this.setState({showAddlAssigneeForm:false});};_this.handleSubmitAddlAssigneeForm=function(addlAssignee){var _this$props=_this.props,questionKey=_this$props.questionKey,dispatch=_this$props.dispatch;var _this$state$addlAssig=_this.state.addlAssignee,id=_this$state$addlAssig.id,index=_this$state$addlAssig.index;if(index!==undefined&&index!==null){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_rfi_log_store_actions__["E" /* updateRfiAddlAssignee */])(questionKey,Object.assign({id:id},addlAssignee),index));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_rfi_log_store_actions__["a" /* addRfiAddlAssignee */])(questionKey,addlAssignee));}_this.setState({showAddlAssigneeForm:false});};_this.handleDeleteAddlAssignee=function(index){var _this$props2=_this.props,questionKey=_this$props2.questionKey,dispatch=_this$props2.dispatch;var confirmed=window.confirm('Are you sure?');confirmed&&dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_rfi_log_store_actions__["h" /* deleteRfiAddlAssignee */])(questionKey,index));};_this.state={showAddlAssigneeForm:false};return _this;}_createClass(RfiAddlAssignees,[{key:'render',value:function render(){var _this2=this;var _props=this.props,contribType=_props.contribType,dueDate=_props.dueDate,question=_props.question,readOnly=_props.readOnly;var _state=this.state,showAddlAssigneeForm=_state.showAddlAssigneeForm,addlAssignee=_state.addlAssignee;var requestReadOnly=readOnly||__WEBPACK_IMPORTED_MODULE_4_domain_enterprise__["a" /* Enterprise */].primary(contribType);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rfi-addl-assignees'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rfi-addl-assignees-container'},question.addlAssignees&&question.addlAssignees.length>0?question.addlAssignees.map(function(addlAssignee,index){return!addlAssignee.destroy&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'addl-assignee-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-block'},addlAssignee.assigneeLabel),addlAssignee.response&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,addlAssignee.response)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-block'},addlAssignee.response?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,addlAssignee.respondedAt&&__WEBPACK_IMPORTED_MODULE_7_moment___default()(addlAssignee.respondedAt).format('M/D/YY')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Due Date',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'addl-assignee-due-date-value'},__WEBPACK_IMPORTED_MODULE_7_moment___default()(addlAssignee.dueDate).format('M/D/YY'))))),!requestReadOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-controls'},!addlAssignee.response&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-control',onClick:function onClick(){return _this2.handleShowAddlAssigneeForm(Object.assign({index:index},addlAssignee));}},'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-control',onClick:function onClick(){return _this2.handleDeleteAddlAssignee(index);}},'Delete')));}):requestReadOnly&&'-'),!requestReadOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-control addl-assignee-add',onClick:this.handleShowAddlAssigneeForm},'+ Add Additional Assignee'),showAddlAssigneeForm&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_additional_assignees_AddlAssigneeForm__["a" /* default */],{showModal:showAddlAssigneeForm,maxDueDate:dueDate,addlAssignees:question.addlAssignees,addlAssignee:addlAssignee,onSubmit:this.handleSubmitAddlAssigneeForm,onClose:this.handleCloseAddlAssigneeForm}));}}]);return RfiAddlAssignees;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RfiAddlAssignees.propTypes={contribType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,dueDate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,questionKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,question:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(RfiAddlAssignees));

/***/ }),
/* 2597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RfiActions_css__ = __webpack_require__(2600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RfiActions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RfiActions_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_print_svg__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_print_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_print_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_mail_svg__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_mail_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_mail_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_rfi_log_store_actions__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_domain_rfi_status_enum__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_rfi_log_store_selectors__ = __webpack_require__(236);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RfiActions=function(_Component){_inherits(RfiActions,_Component);function RfiActions(props){_classCallCheck(this,RfiActions);var _this=_possibleConstructorReturn(this,(RfiActions.__proto__||Object.getPrototypeOf(RfiActions)).call(this,props));_this.pendingResponse=function(){var _this$props=_this.props,currentUser=_this$props.currentUser,currentRfi=_this$props.currentRfi;return!!currentRfi&&!!currentRfi.rfi_questions.find(function(qus){return qus.assignee_id===currentUser.id&&(!qus.response||qus.draft_response);});};_this.assigneeExists=function(){var _this$props2=_this.props,currentUser=_this$props2.currentUser,questions=_this$props2.questions;return!!Object.keys(questions).find(function(key){return questions[key].assignee[0]===currentUser.id;});};_this.addlAssigneeExists=function(){var _this$props3=_this.props,currentUser=_this$props3.currentUser,currentRfi=_this$props3.currentRfi;return!!currentRfi&&!!currentRfi.rfi_questions.map(function(qus){return qus.rfi_addl_assignees;}).flat().find(function(addlAssignee){return addlAssignee.assignee_id===currentUser.id;});};_this.addlAssigneeQuestions=function(questions){var currentUser=_this.props.currentUser;return questions.filter(function(question){return!!question.rfi_addl_assignees.find(function(addlAssignee){return addlAssignee.assignee_id===currentUser.id;});});};_this.assignedQuestions=function(){var _this$props4=_this.props,currentUser=_this$props4.currentUser,currentRfi=_this$props4.currentRfi;return currentRfi?currentRfi.rfi_questions.filter(function(question){return question.assignee_id===currentUser.id||!!question.rfi_addl_assignees.find(function(addlAssignee){return addlAssignee.assignee_id===currentUser.id;});}):[];};_this.validateForm=function(){var draft=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var _this$props5=_this.props,contribType=_this$props5.contribType,form=_this$props5.form,dispatch=_this$props5.dispatch;var errors={};var status=__WEBPACK_IMPORTED_MODULE_11_domain_rfi_status_enum__["a" /* RfiStatusEnum */].create(form.status);if(!__WEBPACK_IMPORTED_MODULE_10_domain_enterprise__["a" /* Enterprise */].primary(contribType)){if(!form.csiCodeId){errors.csiCodeId=true;}if(!draft){if(!form.dueDate&&!__WEBPACK_IMPORTED_MODULE_11_domain_rfi_status_enum__["a" /* RfiStatusEnum */].FOR_RECORD.equals(status)){errors.dueDate=true;}if(!form.status){errors.status=true;}if(!form.title){errors.title=true;}}dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_rfi_log_store_actions__["t" /* setRfiFormErrors */])(errors));}return Object.keys(errors).length===0;};_this.validateQuestions=function(){var draft=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var _this$props6=_this.props,contribType=_this$props6.contribType,gcAcceleration=_this$props6.gcAcceleration,form=_this$props6.form,questions=_this$props6.questions,dispatch=_this$props6.dispatch;var status=__WEBPACK_IMPORTED_MODULE_11_domain_rfi_status_enum__["a" /* RfiStatusEnum */].create(form.status);var assignedQuestions=__WEBPACK_IMPORTED_MODULE_10_domain_enterprise__["a" /* Enterprise */].primary(contribType)&&_this.assignedQuestions();var oneAssignedQuestion=assignedQuestions&&assignedQuestions.length===1;var valid=true;Object.keys(questions).forEach(function(key){var question=questions[key];var assigned=oneAssignedQuestion&&assignedQuestions[0].id===question.id;var errors={};if(!question.action){errors.action=true;}if(!question.question){errors.question=true;}if(!draft&&__WEBPACK_IMPORTED_MODULE_11_domain_rfi_status_enum__["a" /* RfiStatusEnum */].ASSIGNED.equals(status)&&question.assignee.length===0){errors.assignee=true;}if(!draft&&(assigned||gcAcceleration)&&question.id&&!question.response){errors.response=true;}dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_rfi_log_store_actions__["z" /* setRfiQuestionErrors */])(key,errors));valid=valid&&Object.keys(errors).length===0;});return valid;};_this.validate=function(){var draft=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var validForm=_this.validateForm(draft);var validQuestions=_this.validateQuestions(draft);return validForm&&validQuestions;};_this.handleSaveDraft=function(){_this.handleSubmit(true);};_this.handleSubmit=function(){var draft=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;if(!_this.validate(draft)){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_rfi_log_store_actions__["C" /* setSetShowRfiErrorMessage */])(true));return;}var questions=Object.keys(_this.props.questions).map(function(key){return _this.props.questions[key];}).map(function(qus){return Object.assign({},qus,{assigneeId:qus.assignee[0]||'',draftResponse:draft});});var form=_this.props.form;var rfi=Object.assign({},form,{relCsiCodeIds:form.relCsiCodes.map(function(csiCode){return csiCode[0];}),recipientIds:form.recipients.map(function(recpt){return recpt[0];}),draft:draft||'',status:draft?__WEBPACK_IMPORTED_MODULE_11_domain_rfi_status_enum__["b" /* RfiStatusKeys */].DRAFT:form.status,questions:questions,questionsDeleted:_this.props.questionsDeleted});var _this$props7=_this.props,currentUser=_this$props7.currentUser,contribType=_this$props7.contribType,project=_this$props7.project,currentRfi=_this$props7.currentRfi,gcAcceleration=_this$props7.gcAcceleration,handleClose=_this$props7.handleClose,dispatch=_this$props7.dispatch;var promises=[];if(currentRfi){if(__WEBPACK_IMPORTED_MODULE_10_domain_enterprise__["a" /* Enterprise */].primary(contribType)){if(_this.assigneeExists()){rfi.questions=rfi.questions.filter(function(qus){return qus.assignee[0]===currentUser.id;});promises.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_rfi_log_store_actions__["q" /* respondRfi */])(project.id,currentRfi.id,rfi)));}if(_this.addlAssigneeExists()){promises.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_rfi_log_store_actions__["r" /* respondRfiAddlAssignee */])(currentUser.id,_this.addlAssigneeQuestions(questions))));}}else{promises.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_rfi_log_store_actions__["D" /* updateRfi */])(project.id,currentRfi.id,rfi)));if(gcAcceleration){promises.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_rfi_log_store_actions__["q" /* respondRfi */])(project.id,currentRfi.id,rfi)));}}}else{promises.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_rfi_log_store_actions__["d" /* createRfi */])(project.id,rfi)));}Promise.all(promises).then(function(responses){if(!responses.find(function(response){return!response.ok;})){handleClose();}});};_this.handleGcAcceleration=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_rfi_log_store_actions__["v" /* setRfiGcAcceleration */])(true));};_this.handleViewPdf=function(){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_rfi_log_store_actions__["y" /* setRfiPdfViewer */])(true));};_this.handleShowEmailModal=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["j" /* setShowEmailModal */])(true));};_this.handleDiscardDraft=function(){_this.setState({showDeleteConfirmation:true});};_this.handleDeleteConfirmation=function(confirmed){_this.setState({showDeleteConfirmation:false});confirmed&&_this.handleDelete();};_this.handleDelete=function(){var _this$props8=_this.props,project=_this$props8.project,currentRfi=_this$props8.currentRfi,handleClose=_this$props8.handleClose,dispatch=_this$props8.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_rfi_log_store_actions__["g" /* deleteRfi */])(project.id,currentRfi.id)).then(function(response){if(response.ok){handleClose();}});};_this.state={showDeleteConfirmation:false};return _this;}_createClass(RfiActions,[{key:'render',value:function render(){var _this2=this;var _props=this.props,contribType=_props.contribType,currentRfi=_props.currentRfi,readOnly=_props.readOnly,gcAcceleration=_props.gcAcceleration,showErrorMessage=_props.showErrorMessage,handleClose=_props.handleClose;var showDeleteConfirmation=this.state.showDeleteConfirmation;var status=currentRfi&&__WEBPACK_IMPORTED_MODULE_11_domain_rfi_status_enum__["a" /* RfiStatusEnum */].create(currentRfi.status);var primary=__WEBPACK_IMPORTED_MODULE_10_domain_enterprise__["a" /* Enterprise */].primary(contribType);var pendingResponse=this.pendingResponse();var assigneeExists=this.assigneeExists();var addlAssigneeExists=this.addlAssigneeExists();var spackleOrGc=__WEBPACK_IMPORTED_MODULE_10_domain_enterprise__["a" /* Enterprise */].spackle(contribType)||__WEBPACK_IMPORTED_MODULE_10_domain_enterprise__["a" /* Enterprise */].generalContractor(contribType);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rfi-actions'},showErrorMessage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'error-message'},'There are missing fields, please review.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},currentRfi&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-white',icon:__WEBPACK_IMPORTED_MODULE_5_images_mail_svg___default.a,label:'Email',onClick:this.handleShowEmailModal}),currentRfi.pdf_document&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-white',icon:__WEBPACK_IMPORTED_MODULE_4_images_print_svg___default.a,label:'View PDF',onClick:this.handleViewPdf})),!readOnly&&(!currentRfi||__WEBPACK_IMPORTED_MODULE_11_domain_rfi_status_enum__["a" /* RfiStatusEnum */].DRAFT.equals(status)||pendingResponse)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-white button-save-draft',label:'Save Draft and Close',onClick:this.handleSaveDraft}),!readOnly&&!gcAcceleration&&currentRfi&&spackleOrGc&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-white',label:'GC Acceleration',onClick:this.handleGcAcceleration}),!readOnly&&(!primary||assigneeExists||addlAssigneeExists)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Submit',onClick:function onClick(){return _this2.handleSubmit();}}),currentRfi&&(__WEBPACK_IMPORTED_MODULE_11_domain_rfi_status_enum__["a" /* RfiStatusEnum */].DRAFT.equals(status)||__WEBPACK_IMPORTED_MODULE_11_domain_rfi_status_enum__["a" /* RfiStatusEnum */].PENDING.equals(status))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-white button-delete',label:'Discard',onClick:this.handleDiscardDraft}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:readOnly?'Close':'Cancel',onClick:handleClose})),showDeleteConfirmation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_modal_ConfirmationModal__["a" /* default */],{show:showDeleteConfirmation,message:'Are you sure you want to discard this RFI?',onHide:this.handleDeleteConfirmation}));}}]);return RfiActions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RfiActions.propTypes={currentUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,contribType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,project:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,currentRfi:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,gcAcceleration:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,handleClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{form:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_rfi_log_store_selectors__["f" /* getRfiForm */])(state),questions:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_rfi_log_store_selectors__["l" /* getRfiQuestions */])(state),questionsDeleted:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_rfi_log_store_selectors__["m" /* getRfiQuestionsDeleted */])(state),showErrorMessage:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_rfi_log_store_selectors__["o" /* getRfiShowErrorMessage */])(state)};})(RfiActions));

/***/ }),
/* 2600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RfiDetails_css__ = __webpack_require__(2602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RfiDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RfiDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_domain_rfi_status_enum__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_domain_project__ = __webpack_require__(285);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RfiDetails=function(_Component){_inherits(RfiDetails,_Component);function RfiDetails(){_classCallCheck(this,RfiDetails);return _possibleConstructorReturn(this,(RfiDetails.__proto__||Object.getPrototypeOf(RfiDetails)).apply(this,arguments));}_createClass(RfiDetails,[{key:'render',value:function render(){var currentRfi=this.props.currentRfi;var dueDate=currentRfi.due_date?__WEBPACK_IMPORTED_MODULE_4_moment___default()(currentRfi.due_date).format('MM/DD/YY'):'-';var extendedDueDate=currentRfi.extended_due_date?__WEBPACK_IMPORTED_MODULE_4_moment___default()(currentRfi.extended_due_date).format('MM/DD/YY'):null;var resolutionDate=currentRfi.resolved_at&&__WEBPACK_IMPORTED_MODULE_4_moment___default()(currentRfi.resolved_at).format('MM/DD/YY');var today=__WEBPACK_IMPORTED_MODULE_4_moment___default()();var dueDateCountdown=currentRfi.due_date?Object(__WEBPACK_IMPORTED_MODULE_6_services_utils_date_util__["b" /* countdown */])(today.format('YYYY-MM-DD'),currentRfi.due_date):null;var extendedDueDateCountdown=currentRfi.extended_due_date?Object(__WEBPACK_IMPORTED_MODULE_6_services_utils_date_util__["b" /* countdown */])(today.format('YYYY-MM-DD'),currentRfi.extended_due_date):null;if(dueDateCountdown){dueDateCountdown+=today>__WEBPACK_IMPORTED_MODULE_4_moment___default()(currentRfi.due_date)?' past due':' left';}if(extendedDueDateCountdown){extendedDueDateCountdown+=today>__WEBPACK_IMPORTED_MODULE_4_moment___default()(currentRfi.extended_due_date)?' past due':' left';}var statusEnum=__WEBPACK_IMPORTED_MODULE_7_domain_rfi_status_enum__["a" /* RfiStatusEnum */].create(currentRfi.status);var resolved=__WEBPACK_IMPORTED_MODULE_7_domain_rfi_status_enum__["a" /* RfiStatusEnum */].RESOLVED.equals(statusEnum);var statusLabel=statusEnum.label;statusLabel=''+statusLabel.charAt(0).toUpperCase()+statusLabel.slice(1);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rfi-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:2},'CSI Code'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:4},currentRfi.csi_code.division,' - ',currentRfi.csi_code.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:2},'Subcontractor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:4},currentRfi.contractor?currentRfi.contractor.name:'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:2},'Due Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:4},dueDate,!resolved&&dueDateCountdown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,', ',dueDateCountdown)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:2},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:4},statusLabel)),extendedDueDate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:2},'Extended Due Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:4},extendedDueDate,!resolved&&extendedDueDateCountdown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,', ',extendedDueDateCountdown))),!!resolutionDate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:2},'Resolution Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:10},resolutionDate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:2},'CC CSI Code(s)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:10},currentRfi.rel_csi_codes.filter(function(csiCode){return csiCode.id!==currentRfi.csi_code.id;}).length===0?'-':currentRfi.rel_csi_codes.filter(function(csiCode){return csiCode.id!==currentRfi.csi_code.id;}).sort(function(csiCode1,csiCode2){return csiCode1.division<csiCode2.division?-1:1;}).map(function(csiCode){return csiCode.division+' - '+csiCode.label;}).join(', '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:2},'CC Recipient(s)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:10},currentRfi.recipients.length===0?'-':currentRfi.recipients.map(function(rcpt){return __WEBPACK_IMPORTED_MODULE_8_domain_project__["a" /* Project */].userLabelStr(rcpt,rcpt.accountable);}).join(', '))));}}]);return RfiDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RfiDetails.propTypes={currentRfi:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(RfiDetails));

/***/ }),
/* 2602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectSubmittalLog_css__ = __webpack_require__(2604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectSubmittalLog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProjectSubmittalLog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_print_white_svg__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_print_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_print_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_pdf_viewer_PdfViewer__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_notifications__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_domain_notification__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_actions_notifications__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_submittal_log_store_selectors__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_submittal_log_SubmittalLogTable__ = __webpack_require__(2605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_submittal_log_SubmittalLeadTimeLogTable__ = __webpack_require__(2606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_submittal_log_SubmittalModalContainer__ = __webpack_require__(639);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectSubmittalLog=function(_Component){_inherits(ProjectSubmittalLog,_Component);function ProjectSubmittalLog(props){_classCallCheck(this,ProjectSubmittalLog);var _this=_possibleConstructorReturn(this,(ProjectSubmittalLog.__proto__||Object.getPrototypeOf(ProjectSubmittalLog)).call(this,props));_this.handleSubmittalTabSelection=function(submittalTab){_this.handlePageChange(1,_this.defaultStatus(submittalTab));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["B" /* setSubmittalTabSelected */])(submittalTab));};_this.handlePageChange=function(page,status,dueDateFilter){var _this$props=_this.props,currentProject=_this$props.currentProject,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["m" /* loadSubmittalsRequest */])(currentProject.id,page,status,dueDateFilter));};_this.showPreSubmittal=function(contribType){return __WEBPACK_IMPORTED_MODULE_7_domain_enterprise__["a" /* Enterprise */].spackleOrGc(contribType);};_this.defaultStatus=function(){var submittalTab=arguments.length>0&&arguments[0]!==undefined?arguments[0]:2;var currentProject=_this.props.currentProject;var showPreSubmittal=!!_this.showPreSubmittal(currentProject.contributor_type);return submittalTab===3?'cls_approved':showPreSubmittal&&(submittalTab===1?'pre':'not_pre')||'all';};_this.handleAddSubmittal=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["i" /* initSubmittalModal */])());_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["y" /* setSubmittalModalShow */])(true));};_this.handleOpenSubmittal=function(id){var _this$props2=_this.props,currentUser=_this$props2.currentUser,currentProject=_this$props2.currentProject,dispatch=_this$props2.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["p" /* openSubmittal */])(currentProject.id,id,currentUser));dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_actions_notifications__["o" /* markNotifiableNotificationsAsRead */])(id,'Submittal'));};_this.handleViewPdf=function(){var _this$props3=_this.props,currentProject=_this$props3.currentProject,submittalTabSelected=_this$props3.submittalTabSelected,dispatch=_this$props3.dispatch;var promise=submittalTabSelected===3?dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["j" /* loadSubmittalLeadTimeLogPdfRequest */])(currentProject.id)):dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["k" /* loadSubmittalLogPdfRequest */])(currentProject.id,_this.defaultStatus(submittalTabSelected)));promise.then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["x" /* setSubmittalLogPdfViewer */])(true));}});};_this.handleSubmittalLogPdfViewerClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["x" /* setSubmittalLogPdfViewer */])(false));};props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["h" /* initSubmittalLog */])());return _this;}_createClass(ProjectSubmittalLog,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.currentProject){this.handlePageChange(1,this.defaultStatus());}}},{key:'render',value:function render(){var _props=this.props,currentUser=_props.currentUser,currentProject=_props.currentProject,notifications=_props.notifications,submittalTabSelected=_props.submittalTabSelected,submittals=_props.submittals,total=_props.total,currentPage=_props.currentPage,currentStatus=_props.currentStatus,pageSize=_props.pageSize,submittalLogPdfViewer=_props.submittalLogPdfViewer,submittalLogPdf=_props.submittalLogPdf,dueDateFilter=_props.dueDateFilter;var unreadById=Object(__WEBPACK_IMPORTED_MODULE_11_domain_notification__["d" /* unreadNotifications */])(notifications,'Submittal');return currentProject&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submittal-log'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submittal-log-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'P-SUBMITTAL LOG',show:this.showPreSubmittal(currentProject.contributor_type)},{id:2,title:'SUBMITTAL LOG'},{id:3,title:'LEAD TIME LOG'}],selectedValue:submittalTabSelected,onSelected:this.handleSubmittalTabSelection}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{className:'button-gray',icon:__WEBPACK_IMPORTED_MODULE_3_images_print_white_svg___default.a,label:'View PDF',onClick:this.handleViewPdf}),!__WEBPACK_IMPORTED_MODULE_7_domain_enterprise__["a" /* Enterprise */].primary(currentProject.contributor_type)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Add New Submittal',onClick:this.handleAddSubmittal}))),submittalTabSelected===3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_submittal_log_SubmittalLeadTimeLogTable__["a" /* default */],{submittals:submittals,total:total,currentPage:currentPage,currentStatus:currentStatus,pageSize:pageSize,unreadById:unreadById,handlePageChange:this.handlePageChange,handleOpenSubmittal:this.handleOpenSubmittal}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_submittal_log_SubmittalLogTable__["a" /* default */],{submittals:submittals,total:total,currentPage:currentPage,currentStatus:currentStatus,dueDateFilter:dueDateFilter,pageSize:pageSize,currentUser:currentUser,contribType:currentProject.contributor_type,unreadById:unreadById,submittalTabSelected:submittalTabSelected,handlePageChange:this.handlePageChange,handleOpenSubmittal:this.handleOpenSubmittal}),submittalLogPdfViewer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:submittalLogPdf,type:'blob'},show:submittalLogPdfViewer,onClose:this.handleSubmittalLogPdfViewerClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_submittal_log_SubmittalModalContainer__["a" /* default */],null));}}]);return ProjectSubmittalLog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_authentication__["d" /* getCurrentUser */])(state),currentProject:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_submittal_log_store_selectors__["s" /* getTotal */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_submittal_log_store_selectors__["a" /* getCurrentPage */])(state),currentStatus:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_submittal_log_store_selectors__["b" /* getCurrentStatus */])(state),dueDateFilter:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_submittal_log_store_selectors__["d" /* getDueDateFilter */])(state),pageSize:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_submittal_log_store_selectors__["e" /* getPageSize */])(state),submittals:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_submittal_log_store_selectors__["r" /* getSubmittals */])(state),submittalTabSelected:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_submittal_log_store_selectors__["q" /* getSubmittalTabSelected */])(state),notifications:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_notifications__["b" /* getNotifications */])(state),submittalLogPdfViewer:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_submittal_log_store_selectors__["k" /* getSubmittalLogPdfViewer */])(state),submittalLogPdf:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_submittal_log_store_selectors__["j" /* getSubmittalLogPdf */])(state)};})(ProjectSubmittalLog));

/***/ }),
/* 2604 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleHeader__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubmittalLogTable_css__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubmittalLogTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SubmittalLogTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_text_BaseStatus__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_domain_submittal_status_enum__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_domain_submittal__ = __webpack_require__(282);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubmittalLogTable=function(_Component){_inherits(SubmittalLogTable,_Component);function SubmittalLogTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SubmittalLogTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SubmittalLogTable.__proto__||Object.getPrototypeOf(SubmittalLogTable)).call.apply(_ref,[this].concat(args))),_this),_this.subcontractorExists=function(submittal){var currentUser=_this.props.currentUser;return currentUser.accountable_id===submittal.contractor_id&&__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);},_this.assigneeExists=function(submittal){var currentUser=_this.props.currentUser;return __WEBPACK_IMPORTED_MODULE_13_domain_submittal__["a" /* Submittal */].assignee(submittal,currentUser);},_this.addlAssignee=function(submittal){var currentUser=_this.props.currentUser;return __WEBPACK_IMPORTED_MODULE_13_domain_submittal__["a" /* Submittal */].addlAssignee(submittal,currentUser);},_this.responderExists=function(submittal){var currentUser=_this.props.currentUser;var addlAssignee=_this.addlAssignee(submittal);return submittal.responded_by_id===currentUser.id||!!(addlAssignee&&addlAssignee.stamp_action);},_this.dueDate=function(submittal){var addlAssignee=_this.addlAssignee(submittal);return addlAssignee?addlAssignee.due_date:submittal.extended_due_date?submittal.extended_due_date:submittal.due_date;},_this.returnedAt=function(submittal){var addlAssignee=_this.addlAssignee(submittal);return addlAssignee?addlAssignee.returned_at:submittal.returned_at;},_this.renderAssigneeTooltip=function(label,status){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["u" /* Tooltip */],{id:'tooltip-assignee-toggle'},label,status&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,status));},_this.renderAssigneeCircle=function(label,status,checked,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["q" /* OverlayTrigger */],{key:key,placement:'bottom',overlay:_this.renderAssigneeTooltip(label,status)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["b" /* Button */],{className:'addl-assignee-circle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{role:'img','aria-label':'circle'},checked?'🟢':'⚪')));},_this.handleGenerateLink=function(id){return'?submittalId='+id;},_this.mapSubmittals=function(){var _ref2;var _this$props=_this.props,unreadById=_this$props.unreadById,handleOpenSubmittal=_this$props.handleOpenSubmittal;var currentCsiCodeId=null;return(_ref2=[]).concat.apply(_ref2,_toConsumableArray(_this.props.submittals.map(function(submittal,i){var sub=_this.subcontractorExists(submittal);var assigned=_this.assigneeExists(submittal);var responded=_this.responderExists(submittal);var link=_this.handleGenerateLink(submittal.id);var row=[];if(currentCsiCodeId!==submittal.csi_code.id){currentCsiCodeId=submittal.csi_code.id;row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'csi-'+currentCsiCodeId+'_'+i,className:'csi-code-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,submittal.csi_code.division),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'csi-code-label'},submittal.csi_code.label)));}var dueDate=_this.dueDate(submittal);var returnedAt=_this.returnedAt(submittal);var submittalStatusEnum=__WEBPACK_IMPORTED_MODULE_10_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].create(submittal.status);var draftSubmittal=__WEBPACK_IMPORTED_MODULE_10_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].DRAFT.equals(submittalStatusEnum)||__WEBPACK_IMPORTED_MODULE_10_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].DRAFT_PENDING.equals(submittalStatusEnum)||__WEBPACK_IMPORTED_MODULE_10_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].DRAFT_ASSIGNED.equals(submittalStatusEnum);var unread=unreadById&&!!unreadById[submittal.id];row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:submittal.id,className:'selectable link-tab',onClick:function onClick(e){e.preventDefault();handleOpenSubmittal(submittal.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},unread&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_text_BaseStatus__["a" /* default */],{labels:[{id:'unread',label:''}],status:'unread'}),submittal.csi_code.division,'-',submittal.number)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'submittal-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},submittal.title||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},submittal.requested_at?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__["a" /* default */],{value:submittal.requested_at,format:'MM/DD/YYYY'}):'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},submittal.received_at?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__["a" /* default */],{value:submittal.received_at,format:'MM/DD/YYYY'}):'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},submittal.submitted_at?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__["a" /* default */],{value:submittal.submitted_at,format:'MM/DD/YYYY'}):'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},dueDate?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__["a" /* default */],{value:dueDate,format:'MM/DD/YYYY'}):'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},returnedAt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__["a" /* default */],{value:returnedAt,format:'MM/DD/YYYY'}):'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},submittal.distributed_at?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__["a" /* default */],{value:submittal.distributed_at,format:'MM/DD/YYYY'}):'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:draftSubmittal?'submittal-status draft':'submittal-status'},submittal.assignee_label?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["q" /* OverlayTrigger */],{placement:'bottom',overlay:_this.renderAssigneeTooltip(submittal.assignee_label)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["b" /* Button */],{className:'addl-assignee-circle'},Object(__WEBPACK_IMPORTED_MODULE_10_domain_submittal_status_enum__["c" /* submittalStatusLabel */])(submittal))):Object(__WEBPACK_IMPORTED_MODULE_10_domain_submittal_status_enum__["c" /* submittalStatusLabel */])(submittal)),submittal.submittal_addl_assignees.length>0&&submittal.stamp_action&&_this.renderAssigneeCircle(submittal.assignee_label,submittal.stamp_title,true),submittal.submittal_addl_assignees.filter(function(addlAssignee){return!!addlAssignee.stamp_action;}).map(function(addlAssignee,index){return _this.renderAssigneeCircle(addlAssignee.assignee_label,addlAssignee.stamp_title,true,index);}),submittal.submittal_addl_assignees.length>0&&!submittal.stamp_action&&_this.renderAssigneeCircle(submittal.assignee_label,null,false),submittal.submittal_addl_assignees.filter(function(addlAssignee){return!addlAssignee.stamp_action;}).map(function(addlAssignee,index){return _this.renderAssigneeCircle(addlAssignee.assignee_label,null,false,index);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},assigned&&!submittal.closed&&!responded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-blue-grey',label:'Respond'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:sub||assigned&&!submittal.closed?'button-blue-grey':'button-white',label:'View'})))));return row;})));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SubmittalLogTable,[{key:'render',value:function render(){var _props=this.props,submittals=_props.submittals,contribType=_props.contribType,currentPage=_props.currentPage,currentStatus=_props.currentStatus,pageSize=_props.pageSize,total=_props.total,submittalTabSelected=_props.submittalTabSelected,handlePageChange=_props.handlePageChange,_props$dueDateFilter=_props.dueDateFilter,dueDateFilter=_props$dueDateFilter===undefined?'all':_props$dueDateFilter;var headers=['CSI CODE','TITLE','REQUESTED','RECEIVED','SUBMITTED',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleHeader__["a" /* default */],{label:'DUE DATE',filter:{options:[{id:'all',label:'All'},{id:'pending',label:'Pending'},{id:'overdue',label:'Overdue'},{id:'ascending',label:'Ascending'},{id:'descending',label:'Descending'}].filter(function(st){return!!st;}),selected:dueDateFilter},onFilterOptionSelect:function onFilterOptionSelect(filter){handlePageChange(1,currentStatus,filter);}}),'RETURNED','DISTRIBUTED',submittalTabSelected===1?'STATUS':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleHeader__["a" /* default */],{label:'STATUS',filter:{options:[__WEBPACK_IMPORTED_MODULE_12_domain_enterprise__["a" /* Enterprise */].spackleOrGc(contribType)?{id:'not_pre',label:'All'}:{id:'all',label:'All'},(__WEBPACK_IMPORTED_MODULE_12_domain_enterprise__["a" /* Enterprise */].spackleOrGc(contribType)||__WEBPACK_IMPORTED_MODULE_12_domain_enterprise__["a" /* Enterprise */].subcontractor(contribType))&&{id:'draft',label:'Draft'},__WEBPACK_IMPORTED_MODULE_12_domain_enterprise__["a" /* Enterprise */].subcontractor(contribType)&&{id:'pre',label:'Pending'},{id:'assigned_or_draft_assigned',label:'Assigned'},{id:'cls',label:'Closed'}].filter(function(st){return!!st;}),selected:currentStatus},onFilterOptionSelect:function onFilterOptionSelect(status){handlePageChange(1,status,dueDateFilter);}}),''];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submittal-log-table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["t" /* Table */],{className:'simple-table projects-table submittal-log-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,headers.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:index+1});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,headers.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,submittals.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'td-empty-table',colSpan:headers.length},'No Submittals added yet.')):this.mapSubmittals())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPage,pageSize:pageSize,total:total,onPageChange:function onPageChange(page){handlePageChange(page,currentStatus);}})));}}]);return SubmittalLogTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubmittalLogTable.propTypes={submittals:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})).isRequired,total:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,currentPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,currentStatus:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,pageSize:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,currentUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,contribType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,unreadById:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),submittalTabSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,handlePageChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleOpenSubmittal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(SubmittalLogTable));

/***/ }),
/* 2606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubmittalLogTable_css__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubmittalLogTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SubmittalLogTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_text_BaseStatus__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_domain_submittal_status_enum__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_done_svg__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_done_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_images_done_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubmittalLeadTimeLogTable=function(_Component){_inherits(SubmittalLeadTimeLogTable,_Component);function SubmittalLeadTimeLogTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SubmittalLeadTimeLogTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SubmittalLeadTimeLogTable.__proto__||Object.getPrototypeOf(SubmittalLeadTimeLogTable)).call.apply(_ref,[this].concat(args))),_this),_this.checkDeliveryIsDue=function(element){var fieldDeliveryDate=__WEBPACK_IMPORTED_MODULE_11_moment___default()(element.field_delivery);var today=__WEBPACK_IMPORTED_MODULE_11_moment___default()().format('YYYY-MM-DD');return fieldDeliveryDate.isBefore(today)&&!element.delivered_in_id;},_this.handleGenerateLink=function(id){return'?submittalId='+id;},_this.mapSubmittals=function(){var _ref2;var _this$props=_this.props,unreadById=_this$props.unreadById,handleOpenSubmittal=_this$props.handleOpenSubmittal;var currentCsiCodeId=null;return(_ref2=[]).concat.apply(_ref2,_toConsumableArray(_this.props.submittals.map(function(submittal){var link=_this.handleGenerateLink(submittal.id);var row=[];if(currentCsiCodeId!==submittal.csi_code.id){currentCsiCodeId=submittal.csi_code.id;row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'csi-'+currentCsiCodeId,className:'csi-code-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,submittal.csi_code.division),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'csi-code-label'},submittal.csi_code.label)));}var leadTime=submittal.lead_time_weeks;var unread=unreadById&&!!unreadById[submittal.id];var className='selectable link-tab';if(_this.checkDeliveryIsDue(submittal)){className+=' due-date';}row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:submittal.id,className:className,onClick:function onClick(e){e.preventDefault();handleOpenSubmittal(submittal.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},unread&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_BaseStatus__["a" /* default */],{labels:[{id:'unread',label:''}],status:'unread'}),submittal.csi_code.division,'-',submittal.number)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'submittal-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},submittal.title||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},Object(__WEBPACK_IMPORTED_MODULE_9_domain_submittal_status_enum__["c" /* submittalStatusLabel */])(submittal))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},leadTime!==null?leadTime+' '+(leadTime===1?'Week':'Weeks'):'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},submittal.vendor_delivery?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__["a" /* default */],{value:submittal.vendor_delivery,format:'MM/DD/YYYY'}):'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},submittal.field_delivery?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__["a" /* default */],{value:submittal.field_delivery,format:'MM/DD/YYYY'})):'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},submittal.delivered_in_id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'done check',src:__WEBPACK_IMPORTED_MODULE_10_images_done_svg___default.a}):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:submittal.field_delivery?'button-white':'button-blue-grey',label:'View'})))));return row;})));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SubmittalLeadTimeLogTable,[{key:'render',value:function render(){var _props=this.props,submittals=_props.submittals,currentPage=_props.currentPage,currentStatus=_props.currentStatus,pageSize=_props.pageSize,total=_props.total,handlePageChange=_props.handlePageChange;var headers=['CSI CODE','TITLE','STATUS','LEAD TIME','DELIVERY TO VENDOR','FIELD DELIVERY','',''];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submittal-lead-time-log-table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["t" /* Table */],{className:'simple-table projects-table submittal-lead-time-log-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,headers.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:index+1});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,headers.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,submittals.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'td-empty-table',colSpan:headers.length},'No Submittals added yet.')):this.mapSubmittals())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPage,pageSize:pageSize,total:total,onPageChange:function onPageChange(page){handlePageChange(page,currentStatus);}})));}}]);return SubmittalLeadTimeLogTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubmittalLeadTimeLogTable.propTypes={submittals:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})).isRequired,total:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,currentPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,currentStatus:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,pageSize:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,unreadById:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),handlePageChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleOpenSubmittal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(SubmittalLeadTimeLogTable));

/***/ }),
/* 2607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubmittalModal_css__ = __webpack_require__(2608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubmittalModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SubmittalModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_submittal_log_SubmittalForm__ = __webpack_require__(2609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_submittal_log_SubmittalCard__ = __webpack_require__(2610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_submittal_log_SubmittalStamp__ = __webpack_require__(2616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_submittal_log_SubmittalComments__ = __webpack_require__(2617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_submittal_log_SubmittalLeadTimeForm__ = __webpack_require__(2618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_submittal_log_SubmittalActions__ = __webpack_require__(2619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubmittalModal=function(_Component){_inherits(SubmittalModal,_Component);function SubmittalModal(){_classCallCheck(this,SubmittalModal);return _possibleConstructorReturn(this,(SubmittalModal.__proto__||Object.getPrototypeOf(SubmittalModal)).apply(this,arguments));}_createClass(SubmittalModal,[{key:'render',value:function render(){var _props=this.props,currentUser=_props.currentUser,project=_props.project,submittal=_props.submittal,show=_props.show,showLeadTime=_props.showLeadTime,handleClose=_props.handleClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__["a" /* default */],{className:'submittal-modal',show:show,onClose:handleClose,subTitle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['Projects',project.name,submittal?'Submittal '+submittal.csi_code.division+'-'+submittal.number:'Add Submittal']})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submittal-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_submittal_log_SubmittalForm__["a" /* default */],{currentUser:currentUser,project:project}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["d" /* Col */],{sm:submittal?7:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_submittal_log_SubmittalCard__["a" /* default */],{currentUser:currentUser,project:project,submittal:submittal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_submittal_log_SubmittalStamp__["a" /* default */],{currentUser:currentUser,submittal:submittal}),showLeadTime&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_submittal_log_SubmittalLeadTimeForm__["a" /* default */],null)),submittal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["d" /* Col */],{sm:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_submittal_log_SubmittalComments__["a" /* default */],{submittal:submittal}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_submittal_log_SubmittalActions__["a" /* default */],{currentUser:currentUser,project:project,submittal:submittal,showLeadTime:showLeadTime,handleClose:handleClose})));}}]);return SubmittalModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubmittalModal.propTypes={currentUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,project:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,submittal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),show:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,showLeadTime:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,handleClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(SubmittalModal));

/***/ }),
/* 2608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SubmittalForm_css__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SubmittalForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SubmittalForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_lock_png__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_lock_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_lock_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_autosize_textarea__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_autosize_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_autosize_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_domain_project__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_domain_submittal_status_enum__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_proposal_store_actions__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_directory_store_actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_proposal_store_selectors__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_directory_store_selectors__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_submittal_log_store_selectors__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_project_submittal_log_store_actions__ = __webpack_require__(131);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubmittalForm=function(_Component){_inherits(SubmittalForm,_Component);function SubmittalForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SubmittalForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SubmittalForm.__proto__||Object.getPrototypeOf(SubmittalForm)).call.apply(_ref,[this].concat(args))),_this),_this.loadDirectory=function(){var _this$props=_this.props,project=_this$props.project,directory=_this$props.directory,dispatch=_this$props.dispatch;if(!directory||directory.project_id!==project.id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_directory_store_actions__["j" /* loadDirectoryRequest */])(project.id));}},_this.loadProjectProposal=function(){var _this$props2=_this.props,project=_this$props2.project,projectProposal=_this$props2.projectProposal,dispatch=_this$props2.dispatch;if(!projectProposal||projectProposal.project_id!==project.id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_proposal_store_actions__["i" /* loadProjectProposalRequest */])(project.id));}},_this.handleFormChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_project_submittal_log_store_actions__["E" /* updateSubmittalFormValue */])(attribute,value));},_this.handleCsiCodeChange=function(csiCodeId){_this.handleFormChange('csiCodeId',csiCodeId);_this.handleFormChange('contractorId','');var subOptions=_this.submittalSubcontractorOptions(csiCodeId);if(subOptions.length===1){_this.handleFormChange('contractorId',subOptions[0].value);}},_this.submittalCsiCodeOptions=function(){return __WEBPACK_IMPORTED_MODULE_13_domain_project__["a" /* Project */].csiCodesOptions(_this.props);},_this.submittalSubcontractorOptions=function(csiCodeId){return __WEBPACK_IMPORTED_MODULE_13_domain_project__["a" /* Project */].subcontractorOptions(_this.props,csiCodeId);},_this.submittalStatusOptions=function(){return Object.keys(__WEBPACK_IMPORTED_MODULE_14_domain_submittal_status_enum__["b" /* SubmittalStatusKeys */]).filter(function(status){return!__WEBPACK_IMPORTED_MODULE_14_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].DRAFT.equals(__WEBPACK_IMPORTED_MODULE_14_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */][status]);}).map(function(status){var statusEnum=__WEBPACK_IMPORTED_MODULE_14_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */][status];return{value:statusEnum.status,label:''+statusEnum.label.charAt(0).toUpperCase()+statusEnum.label.slice(1)};});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SubmittalForm,[{key:'componentDidMount',value:function componentDidMount(){this.loadDirectory();if(!__WEBPACK_IMPORTED_MODULE_12_domain_enterprise__["a" /* Enterprise */].subcontractor(this.props.project.contributor_type)){this.loadProjectProposal();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_project_submittal_log_store_actions__["b" /* clearSubmittalNotes */])());}},{key:'render',value:function render(){var _this2=this;var _props=this.props,currentUser=_props.currentUser,project=_props.project,form=_props.form;var subOptions=this.submittalSubcontractorOptions(form.csiCodeId);var readOnly=this.props.readOnly||__WEBPACK_IMPORTED_MODULE_12_domain_enterprise__["a" /* Enterprise */].primary(project.contributor_type);var subcontractor=__WEBPACK_IMPORTED_MODULE_12_domain_enterprise__["a" /* Enterprise */].subcontractor(project.contributor_type)||__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["g" /* usersUtil */].hasRole(currentUser,__WEBPACK_IMPORTED_MODULE_11_services_utils_users_util__["e" /* ROLES */].GENERAL_CONTRACTOR_SUPERINTENDENT);var submittedBy=form.submittedBy||currentUser;var labelStyle=readOnly?'compact-control-label':'control-label';var inputValueStyle=readOnly?'read-only':'edit';var stampAction=form.assignee_stamp&&form.assignee_stamp.stamp_actions.find(function(stampAction){return stampAction.action===form.stampAction;});var stampTitle=stampAction&&stampAction.title;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submittal-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'submittal-title'},'Submittal Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Form */],{horizontal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{className:labelStyle,sm:1},'Submitted By'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:5,className:inputValueStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'submitted-by'},submittedBy.first_name,' ',submittedBy.last_name),' - '+(submittedBy.accountable?submittedBy.accountable.name:'Spackle'),currentUser.title?' - '+currentUser.title:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{className:labelStyle,sm:1},'Date Added'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:3,className:inputValueStyle},__WEBPACK_IMPORTED_MODULE_10_moment___default()(form.submitted_at||form.received_at||undefined).format('M/D/YY'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{className:labelStyle,sm:1},'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:5,className:inputValueStyle},readOnly?form.title?form.title:'-':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_autosize_textarea___default.a,{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'form-error':form.errors.title}),rows:1,placeholder:'Enter Text Here...',defaultValue:form.title,onBlur:function onBlur(e){return _this2.handleFormChange('title',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{className:labelStyle,sm:1},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:3,className:inputValueStyle},subcontractor?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'status-locked'},Object(__WEBPACK_IMPORTED_MODULE_14_domain_submittal_status_enum__["c" /* submittalStatusLabel */])(Object.assign({},form,{stamp_title:stampTitle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'locked-icon',src:__WEBPACK_IMPORTED_MODULE_6_images_lock_png___default.a,alt:'locked'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_dropdown_Dropdown__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'form-error':form.errors.status}),placeholder:'Select Status...',value:form.status,onChange:function onChange(option){return _this2.handleFormChange('status',option.value);},options:this.submittalStatusOptions()}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{className:labelStyle,sm:1},'CSI Code'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:5,className:readOnly||form.id?inputValueStyle:''},readOnly?form.csiCodeLabel:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_dropdown_Dropdown__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'dropdown-error':form.errors.csiCodeId}),placeholder:'Select Code...',value:form.csiCodeId,onChange:function onChange(option){return _this2.handleCsiCodeChange(option.value);},options:this.submittalCsiCodeOptions()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{className:labelStyle,sm:1},'Physical Copies'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:3,className:inputValueStyle},readOnly?form.physicalCopies:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__["a" /* default */],{type:'number',value:form.physicalCopies,onChange:function onChange(value){return _this2.handleFormChange('physicalCopies',value);}}))),(readOnly||!subcontractor&&subOptions.length>1)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{className:labelStyle,sm:1},'Subcontractor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:5,className:inputValueStyle},readOnly?form.contractor?form.contractor.name:'-':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_dropdown_Dropdown__["a" /* default */],{placeholder:'Select Subcontractor...',value:form.contractorId,onChange:function onChange(option){return _this2.handleFormChange('contractorId',option.value);},options:subOptions})))));}}]);return SubmittalForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubmittalForm.propTypes={currentUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,project:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{projectProposal:Object(__WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_proposal_store_selectors__["f" /* getProjectProposal */])(state),directory:Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_directory_store_selectors__["c" /* getDirectory */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_submittal_log_store_selectors__["g" /* getSubmittalForm */])(state),readOnly:Object(__WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_submittal_log_store_selectors__["o" /* getSubmittalReadOnly */])(state)};})(SubmittalForm));

/***/ }),
/* 2610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SubmittalCard_css__ = __webpack_require__(2611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SubmittalCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SubmittalCard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_autosize_textarea__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_autosize_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_autosize_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_dropdown_SearchableDropDownPaginated__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_dropdown_MultipleDropdown__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_domain_project__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_domain_submittal__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_domain_submittal_status_enum__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_directory_store_selectors__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_submittal_log_store_selectors__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_directory_store_actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_project_submittal_log_store_actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_admin_projects_details_project_submittal_log_SubmittalDocuments__ = __webpack_require__(2612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_submittal_log_SubmittalAddlAssignees__ = __webpack_require__(2614);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubmittalCard=function(_Component){_inherits(SubmittalCard,_Component);function SubmittalCard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SubmittalCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SubmittalCard.__proto__||Object.getPrototypeOf(SubmittalCard)).call.apply(_ref,[this].concat(args))),_this),_this.loadContributors=function(){var _this$props=_this.props,project=_this$props.project,dispatch=_this$props.dispatch;var users={};return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_directory_store_actions__["m" /* searchDirectory */])(project.id)).then(function(response){if(response.ok){var contributors=response.directory.project_contributors.filter(function(pc){return pc.primary&&pc.company_type!=='GeneralContractor';}).map(function(pc){return pc.users.filter(function(usr){return!users[usr.id];}).map(function(usr){users[usr.id]=true;return{value:usr.id,label:__WEBPACK_IMPORTED_MODULE_14_domain_project__["a" /* Project */].userLabelStr(usr,pc.company)};});}).reduce(function(acc,val){return acc.concat(val);},[]);return{ok:true,options:contributors};}});},_this.recipientOptions=function(){return __WEBPACK_IMPORTED_MODULE_14_domain_project__["a" /* Project */].recipientOptions(_this.props);},_this.handleFormChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_project_submittal_log_store_actions__["E" /* updateSubmittalFormValue */])(attribute,value));},_this.handleFormDeleteFile=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_project_submittal_log_store_actions__["g" /* deleteSubmittalFile */])(attribute,value));},_this.handleMarkSubmittalNotesRead=function(){var _this$props2=_this.props,currentUser=_this$props2.currentUser,form=_this$props2.form,dispatch=_this$props2.dispatch;if(form.id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_project_submittal_log_store_actions__["o" /* markSubmittalNotesRead */])(form.id,form,currentUser.id));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SubmittalCard,[{key:'componentDidMount',value:function componentDidMount(){this.handleMarkSubmittalNotesRead();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,currentUser=_props.currentUser,project=_props.project,submittal=_props.submittal,form=_props.form,readOnly=_props.readOnly,gcAcceleration=_props.gcAcceleration;var spackleOrGc=__WEBPACK_IMPORTED_MODULE_13_domain_enterprise__["a" /* Enterprise */].spackleOrGc(project.contributor_type)&&!__WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__["g" /* usersUtil */].hasRole(currentUser,__WEBPACK_IMPORTED_MODULE_12_services_utils_users_util__["e" /* ROLES */].GENERAL_CONTRACTOR_SUPERINTENDENT);var requestReadOnly=readOnly||__WEBPACK_IMPORTED_MODULE_13_domain_enterprise__["a" /* Enterprise */].primary(project.contributor_type);var assignedToCurrentUser=submittal&&__WEBPACK_IMPORTED_MODULE_15_domain_submittal__["a" /* Submittal */].assignee(submittal,currentUser);var addlAssignee=submittal&&__WEBPACK_IMPORTED_MODULE_15_domain_submittal__["a" /* Submittal */].addlAssignee(submittal,currentUser);var assignee=submittal&&submittal.assignee;var today=__WEBPACK_IMPORTED_MODULE_6_moment___default()();var requestedDateCountdown=form&&form.requestedDate?Object(__WEBPACK_IMPORTED_MODULE_11_services_utils_date_util__["b" /* countdown */])(today.format('YYYY-MM-DD'),form.requestedDate):null;if(requestedDateCountdown){requestedDateCountdown+=' ago';}var dueDateCountdown=form&&form.dueDate?Object(__WEBPACK_IMPORTED_MODULE_11_services_utils_date_util__["b" /* countdown */])(today.format('YYYY-MM-DD'),form.dueDate):null;var extendedDueDateCountdown=form&&form.extendedDueDate?Object(__WEBPACK_IMPORTED_MODULE_11_services_utils_date_util__["b" /* countdown */])(today.format('YYYY-MM-DD'),form.extendedDueDate):null;if(dueDateCountdown){dueDateCountdown+=today>__WEBPACK_IMPORTED_MODULE_6_moment___default()(form.dueDate)?' past due':' left';}if(extendedDueDateCountdown){extendedDueDateCountdown+=today>__WEBPACK_IMPORTED_MODULE_6_moment___default()(form.extendedDueDate)?' past due':' left';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submittal-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Form */],{horizontal:true},(requestReadOnly||spackleOrGc)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},readOnly?'Assigned To':'Assign To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:8},form.assignee.length===0?readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'read-only'},'-'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_dropdown_SearchableDropDownPaginated__["a" /* default */],{loadOptions:this.loadContributors,onChange:function onChange(option){_this2.handleFormChange('assignee',[option.value,option.label]);_this2.handleFormChange('status',__WEBPACK_IMPORTED_MODULE_16_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].ASSIGNED.status);},placeholder:'Add Contributor'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contributor-selected',onClick:function onClick(){if(!readOnly&&spackleOrGc){_this2.handleFormChange('assignee',[]);_this2.handleFormChange('status',__WEBPACK_IMPORTED_MODULE_16_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].PENDING.status);}}},!readOnly&&spackleOrGc&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'remove'},'X'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,form.assignee[1])))),spackleOrGc&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},'Requested Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:requestReadOnly?8:4,className:requestReadOnly?'read-only':''},requestReadOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,form.requestedDate?__WEBPACK_IMPORTED_MODULE_6_moment___default()(form.requestedDate).format('M/D/YY'):'-',!form.closed&&requestedDateCountdown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,', ',requestedDateCountdown)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:__WEBPACK_IMPORTED_MODULE_11_services_utils_date_util__["a" /* beforeTodayValidation */],placeholder:'Choose Date...',value:form.requestedDate,onChange:function onChange(value){return _this2.handleFormChange('requestedDate',value);}})),!requestReadOnly&&!form.closed&&requestedDateCountdown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:4,className:'countdown'},requestedDateCountdown)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},'Due Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:requestReadOnly?8:4,className:requestReadOnly?'read-only':''},requestReadOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,form.dueDate?__WEBPACK_IMPORTED_MODULE_6_moment___default()(form.dueDate).format('M/D/YY'):'-',!form.closed&&dueDateCountdown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,', ',dueDateCountdown)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'form-error':form.errors.dueDate})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:__WEBPACK_IMPORTED_MODULE_11_services_utils_date_util__["k" /* todayValidation */],placeholder:'Choose Date...',value:form.dueDate,onChange:function onChange(value){return _this2.handleFormChange('dueDate',value);}}))),!requestReadOnly&&!form.closed&&dueDateCountdown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:4,className:'countdown'},dueDateCountdown)),assignee&&(!requestReadOnly||form.extendedDueDate)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},'Extended Due Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:requestReadOnly?8:4,className:requestReadOnly?'read-only':''},requestReadOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_moment___default()(form.extendedDueDate).format('M/D/YY'),!form.closed&&extendedDueDateCountdown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,', ',extendedDueDateCountdown)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'form-error':form.errors.extendedDueDate})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:__WEBPACK_IMPORTED_MODULE_11_services_utils_date_util__["k" /* todayValidation */],placeholder:'Choose Date...',value:form.extendedDueDate,onChange:function onChange(value){return _this2.handleFormChange('extendedDueDate',value);}}))),!requestReadOnly&&!form.closed&&extendedDueDateCountdown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:4,className:'countdown'},extendedDueDateCountdown)),(requestReadOnly||spackleOrGc)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},'Additional Assignees'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:form.id?8:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_submittal_log_SubmittalAddlAssignees__["a" /* default */],{project:project}))),spackleOrGc&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},'CC Recipient(s)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:8,className:requestReadOnly?'text-read-only':''},requestReadOnly?form.recipients.length===0?'-':form.recipients.map(function(rcpt){return rcpt[1];}).join(', '):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_dropdown_MultipleDropdown__["a" /* default */],{options:this.recipientOptions(),currentValues:form.recipients,placeholder:'Select Contributors to CC',onChange:function onChange(values){return _this2.handleFormChange('recipients',values);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},'Submittal Request'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:8,className:requestReadOnly?'text-read-only':''},requestReadOnly?form.question?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'read-only-question'},form.question):'-':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_autosize_textarea___default.a,{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'form-error':form.errors.question}),rows:1,placeholder:'Enter Text Here...',defaultValue:form.question,onBlur:function onBlur(e){return _this2.handleFormChange('question',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_admin_projects_details_project_submittal_log_SubmittalDocuments__["a" /* default */],{submittal:submittal,form:form,fileType:'req',handleFormChange:this.handleFormChange,handleFormDeleteFile:this.handleFormDeleteFile,readOnly:requestReadOnly}),(gcAcceleration||readOnly||assignedToCurrentUser)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submittal-response'},(readOnly||!addlAssignee)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["f" /* ControlLabel */],sm:1},'Remarks'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Col */],{sm:8,className:readOnly?'text-read-only':''},readOnly?form.remarks?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'read-only-question'},form.remarks):'-':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_autosize_textarea___default.a,{rows:1,placeholder:'Enter Text Here...',defaultValue:form.remarks,onBlur:function onBlur(e){return _this2.handleFormChange('remarks',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_admin_projects_details_project_submittal_log_SubmittalDocuments__["a" /* default */],{currentUser:currentUser,submittal:submittal,submittalAddlAssignee:addlAssignee,form:form,fileType:'res',handleFormChange:this.handleFormChange,handleFormDeleteFile:this.handleFormDeleteFile,readOnly:readOnly}))));}}]);return SubmittalCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubmittalCard.propTypes={currentUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,project:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,submittal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{directory:Object(__WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_directory_store_selectors__["c" /* getDirectory */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_submittal_log_store_selectors__["g" /* getSubmittalForm */])(state),readOnly:Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_submittal_log_store_selectors__["o" /* getSubmittalReadOnly */])(state),gcAcceleration:Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_submittal_log_store_selectors__["h" /* getSubmittalGcAcceleration */])(state)};})(SubmittalCard));

/***/ }),
/* 2611 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubmittalDocuments_css__ = __webpack_require__(2613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubmittalDocuments_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SubmittalDocuments_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_upload_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_upload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_document_DocumentLinkBluebeam__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubmittalDocuments=function(_Component){_inherits(SubmittalDocuments,_Component);function SubmittalDocuments(props){_classCallCheck(this,SubmittalDocuments);var _this=_possibleConstructorReturn(this,(SubmittalDocuments.__proto__||Object.getPrototypeOf(SubmittalDocuments)).call(this,props));_initialiseProps.call(_this);switch(props.fileType){case'req':_this.imgsAttr='reqImages';_this.docsAttr='reqDocs';_this.imgsDelAttr='reqImagesDelete';_this.docsDelAttr='reqDocsDelete';_this.submittalImgsAttr='request_images';_this.submittalDocsAttr='request_documents';break;case'res':_this.imgsAttr='resImages';_this.docsAttr='resDocs';_this.imgsDelAttr='resImagesDelete';_this.docsDelAttr='resDocsDelete';_this.submittalImgsAttr='response_images';_this.submittalDocsAttr='response_documents';break;default:}if(props.form.id){_this.initFiles(props);}return _this;}_createClass(SubmittalDocuments,[{key:'render',value:function render(){var _this2=this;var _props=this.props,submittal=_props.submittal,submittalAddlAssignee=_props.submittalAddlAssignee,form=_props.form,fileType=_props.fileType,readOnly=_props.readOnly;var filteredAddlAssignees=submittal&&fileType==='res'&&this.filteredAddlAssignees();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["i" /* FormGroup */],{className:'submittal-documents'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{sm:12},(!readOnly||this.filesPresent(this.submittalDocsAttr))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* ControlLabel */],sm:1},'Documents'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{sm:8},filteredAddlAssignees&&filteredAddlAssignees.map(function(addlAssignee){return _this2.mapFiles(addlAssignee[_this2.submittalDocsAttr],'document').map(function(doc,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'doc-viewer doc-viewer-read-only',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_document_DocumentLinkBluebeam__["a" /* default */],{file:doc}),_this2.renderUploaderName(addlAssignee.assignee));});}),submittalAddlAssignee&&form[this.submittalDocsAttr]&&this.mapFiles(form[this.submittalDocsAttr],'document').map(function(doc,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'doc-viewer doc-viewer-read-only',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_document_DocumentLinkBluebeam__["a" /* default */],{file:doc}),_this2.renderUploaderName(submittal.responded_by));}),form[this.docsAttr]&&form[this.docsAttr].map(function(doc,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'doc-viewer'+(readOnly?' doc-viewer-read-only':''),key:index},!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'remove-doc-icon',src:__WEBPACK_IMPORTED_MODULE_6_images_remove_png___default.a,alt:'remove',onClick:function onClick(){return _this2.removeSubmittalDocument(index);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_document_DocumentLinkBluebeam__["a" /* default */],{file:doc}),readOnly&&fileType==='res'&&_this2.renderUploaderName(submittalAddlAssignee?submittalAddlAssignee.assignee:submittal.responded_by));}),!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx',className:'dropzone-container',onDrop:this.dropSubmittalDocuments},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Please drag and drop any file into this area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5_images_upload_svg___default.a,alt:'upload'})))),(!readOnly||this.filesPresent(this.submittalImgsAttr))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* ControlLabel */],sm:1},'Photos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Col */],{sm:8},filteredAddlAssignees&&filteredAddlAssignees.filter(function(addlAssignee){return addlAssignee[_this2.submittalImgsAttr].length>0;}).map(function(addlAssignee,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'img-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],images:_this2.mapFiles(addlAssignee[_this2.submittalImgsAttr],'image'),readOnly:true}),_this2.renderUploaderName(addlAssignee.assignee));}),submittalAddlAssignee&&form[this.submittalImgsAttr]&&form[this.submittalImgsAttr].length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],images:this.mapFiles(form[this.submittalImgsAttr],'image'),readOnly:true}),this.renderUploaderName(submittal.responded_by)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-viewer'+(!form[this.imgsAttr]||form[this.imgsAttr].length===0?' img-viewer-empty':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],images:form[this.imgsAttr],readOnly:readOnly,onRemove:function onRemove(index){return _this2.removeSubmittalImage(index);},onUpload:function onUpload(files){return _this2.setSubmittalImages(files);}}),readOnly&&fileType==='res'&&form[this.imgsAttr]&&form[this.imgsAttr].length>0&&this.renderUploaderName(submittalAddlAssignee?submittalAddlAssignee.assignee:submittal.responded_by))))));}}]);return SubmittalDocuments;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubmittalDocuments.propTypes={submittal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),submittalAddlAssignee:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),form:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,fileType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['req','res']).isRequired,handleFormChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleFormDeleteFile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};SubmittalDocuments.defaultProps={submittal:null,submittalAddlAssignee:null};var _initialiseProps=function _initialiseProps(){var _this3=this;this.filesPresent=function(attr){var _props2=_this3.props,submittal=_props2.submittal,fileType=_props2.fileType;var submittalFilesPresent=submittal&&submittal[attr].length>0;var addlAssigneesFilesPresent=submittal&&fileType==='res'&&submittal.submittal_addl_assignees.find(function(addlAssignee){return addlAssignee[attr].length>0;});return!!(submittalFilesPresent||addlAssigneesFilesPresent);};this.mapFiles=function(files,type){return(files||[]).map(function(file){return{id:file.id,url:file[type].url,preview:file[type].gallery&&file[type].gallery.url};});};this.initFiles=function(props){var submittalAddlAssignee=props.submittalAddlAssignee,form=props.form,fileType=props.fileType;if(submittalAddlAssignee&&fileType==='res'){_this3.props.handleFormChange(_this3.imgsAttr,_this3.mapFiles(submittalAddlAssignee[_this3.submittalImgsAttr],'image'));_this3.props.handleFormChange(_this3.docsAttr,_this3.mapFiles(submittalAddlAssignee[_this3.submittalDocsAttr],'document'));}else{_this3.props.handleFormChange(_this3.imgsAttr,_this3.mapFiles(form[_this3.submittalImgsAttr],'image'));_this3.props.handleFormChange(_this3.docsAttr,_this3.mapFiles(form[_this3.submittalDocsAttr],'document'));}};this.setImages=function(files,imagesRef){var images=imagesRef.slice();files.forEach(function(val){images.push({url:URL.createObjectURL(val),file:val});});return images;};this.setSubmittalImages=function(files){var images=_this3.setImages(files,_this3.props.form[_this3.imgsAttr]);_this3.props.handleFormChange(_this3.imgsAttr,images);};this.removeSubmittalImage=function(index){var img=_this3.props.form[_this3.imgsAttr][index];_this3.props.form[_this3.imgsAttr].splice(index,1);_this3.props.handleFormDeleteFile(_this3.imgsDelAttr,img);_this3.props.handleFormChange(_this3.imgsAttr,_this3.props.form[_this3.imgsAttr]);};this.dropDocuments=function(files,docsRef){var docs=docsRef.slice();files.forEach(function(val){docs.push({file:val,name:val.name});});return docs;};this.dropSubmittalDocuments=function(files){var docs=_this3.dropDocuments(files,_this3.props.form[_this3.docsAttr]);_this3.props.handleFormChange(_this3.docsAttr,docs);};this.removeSubmittalDocument=function(index){var doc=_this3.props.form[_this3.docsAttr][index];_this3.props.form[_this3.docsAttr].splice(index,1);_this3.props.handleFormDeleteFile(_this3.docsDelAttr,doc);_this3.props.handleFormChange(_this3.docsAttr,_this3.props.form[_this3.docsAttr]);};this.filteredAddlAssignees=function(){var _props3=_this3.props,submittal=_props3.submittal,submittalAddlAssignee=_props3.submittalAddlAssignee;return submittal.submittal_addl_assignees.filter(function(addlAssignee){return!submittalAddlAssignee||submittalAddlAssignee.assignee_id!==addlAssignee.assignee_id;});};this.renderUploaderName=function(uploadedBy){return uploadedBy&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,uploadedBy.first_name,' ',uploadedBy.last_name);};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(SubmittalDocuments));

/***/ }),
/* 2613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubmittalAddlAssignees_css__ = __webpack_require__(2615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubmittalAddlAssignees_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SubmittalAddlAssignees_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_submittal_log_store_selectors__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_submittal_log_store_actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_additional_assignees_AddlAssigneeForm__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubmittalAddlAssignees=function(_Component){_inherits(SubmittalAddlAssignees,_Component);function SubmittalAddlAssignees(props){_classCallCheck(this,SubmittalAddlAssignees);var _this=_possibleConstructorReturn(this,(SubmittalAddlAssignees.__proto__||Object.getPrototypeOf(SubmittalAddlAssignees)).call(this,props));_this.handleShowAddlAssigneeForm=function(addlAssignee){_this.setState({showAddlAssigneeForm:true,addlAssignee:addlAssignee});};_this.handleCloseAddlAssigneeForm=function(){_this.setState({showAddlAssigneeForm:false});};_this.handleSubmitAddlAssigneeForm=function(addlAssignee){var dispatch=_this.props.dispatch;var _this$state$addlAssig=_this.state.addlAssignee,id=_this$state$addlAssig.id,index=_this$state$addlAssig.index;if(index!==undefined&&index!==null){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_submittal_log_store_actions__["D" /* updateSubmittalAddlAssignee */])(Object.assign({id:id},addlAssignee),index));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_submittal_log_store_actions__["a" /* addSubmittalAddlAssignee */])(addlAssignee));}_this.setState({showAddlAssigneeForm:false});};_this.handleDeleteAddlAssignee=function(index){var dispatch=_this.props.dispatch;var confirmed=window.confirm('Are you sure?');confirmed&&dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_submittal_log_store_actions__["f" /* deleteSubmittalAddlAssignee */])(index));};_this.state={showAddlAssigneeForm:false};return _this;}_createClass(SubmittalAddlAssignees,[{key:'render',value:function render(){var _this2=this;var _props=this.props,project=_props.project,form=_props.form,readOnly=_props.readOnly;var _state=this.state,showAddlAssigneeForm=_state.showAddlAssigneeForm,addlAssignee=_state.addlAssignee;var requestReadOnly=readOnly||__WEBPACK_IMPORTED_MODULE_4_domain_enterprise__["a" /* Enterprise */].primary(project.contributor_type);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submittal-addl-assignees'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submittal-addl-assignees-container'},form.addlAssignees&&form.addlAssignees.length>0?form.addlAssignees.map(function(addlAssignee,index){return!addlAssignee.destroy&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'addl-assignee-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-block'},addlAssignee.assigneeLabel),addlAssignee.stampAction&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,addlAssignee.stampTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-block'},addlAssignee.stampAction?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,addlAssignee.returnedAt&&__WEBPACK_IMPORTED_MODULE_8_moment___default()(addlAssignee.returnedAt).format('M/D/YY')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Due Date',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'addl-assignee-due-date-value'},__WEBPACK_IMPORTED_MODULE_8_moment___default()(addlAssignee.dueDate).format('M/D/YY'))))),!requestReadOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-controls'},!addlAssignee.stampAction&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-control',onClick:function onClick(){return _this2.handleShowAddlAssigneeForm(Object.assign({index:index},addlAssignee));}},'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-control',onClick:function onClick(){return _this2.handleDeleteAddlAssignee(index);}},'Delete')));}):requestReadOnly&&'-'),!requestReadOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addl-assignee-control addl-assignee-add',onClick:this.handleShowAddlAssigneeForm},'+ Add Additional Assignee'),showAddlAssigneeForm&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_additional_assignees_AddlAssigneeForm__["a" /* default */],{showModal:showAddlAssigneeForm,maxDueDate:form.extendedDueDate||form.dueDate,addlAssignees:form.addlAssignees,addlAssignee:addlAssignee,onSubmit:this.handleSubmitAddlAssigneeForm,onClose:this.handleCloseAddlAssigneeForm}));}}]);return SubmittalAddlAssignees;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubmittalAddlAssignees.propTypes={project:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{form:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_submittal_log_store_selectors__["g" /* getSubmittalForm */])(state),readOnly:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_submittal_log_store_selectors__["o" /* getSubmittalReadOnly */])(state)};})(SubmittalAddlAssignees));

/***/ }),
/* 2615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domain_submittal__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_selectors__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_submittal_log_store_actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_stamp_StampDetails__ = __webpack_require__(971);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubmittalStamp=function(_Component){_inherits(SubmittalStamp,_Component);function SubmittalStamp(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SubmittalStamp);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SubmittalStamp.__proto__||Object.getPrototypeOf(SubmittalStamp)).call.apply(_ref,[this].concat(args))),_this),_this.handleFormChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_submittal_log_store_actions__["E" /* updateSubmittalFormValue */])(attribute,value));},_this.handleStampActionChange=function(value){var submittal=_this.props.submittal;var addlAssignee=submittal&&_this.addlAssignee();_this.handleFormChange('stampAction',value);!addlAssignee&&_this.handleFormChange('status',value);},_this.addlAssignee=function(){var _this$props=_this.props,currentUser=_this$props.currentUser,submittal=_this$props.submittal;return __WEBPACK_IMPORTED_MODULE_3_domain_submittal__["a" /* Submittal */].addlAssignee(submittal,currentUser);},_this.assigneeCompanyName=function(){var submittal=_this.props.submittal;var addlAssignee=_this.addlAssignee();var assignee=addlAssignee?addlAssignee.assignee:submittal.assignee;var company=assignee&&assignee.accountable;return company&&(company.name||company.company_name);},_this.assigneeLogo=function(){var submittal=_this.props.submittal;var addlAssignee=_this.addlAssignee();return addlAssignee?addlAssignee.assignee_logo:submittal.assignee_logo;},_this.assigneeStamp=function(){var submittal=_this.props.submittal;var addlAssignee=_this.addlAssignee();return addlAssignee?addlAssignee.assignee_stamp:submittal.assignee_stamp;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SubmittalStamp,[{key:'componentDidMount',value:function componentDidMount(){var submittal=this.props.submittal;var addlAssignee=submittal&&this.addlAssignee();addlAssignee&&this.handleFormChange('stampAction',addlAssignee.stamp_action);}},{key:'render',value:function render(){var _props=this.props,currentUser=_props.currentUser,submittal=_props.submittal,form=_props.form,readOnly=_props.readOnly,gcAcceleration=_props.gcAcceleration;var assignedToCurrentUser=submittal&&__WEBPACK_IMPORTED_MODULE_3_domain_submittal__["a" /* Submittal */].assignee(submittal,currentUser);var assigneeCompanyName=submittal&&this.assigneeCompanyName();var assigneeLogo=submittal&&this.assigneeLogo();var assigneeStamp=submittal&&this.assigneeStamp();return(gcAcceleration||readOnly||assignedToCurrentUser)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_stamp_StampDetails__["a" /* default */],{companyName:assigneeCompanyName,companyLogo:assigneeLogo,stamp:assigneeStamp,value:form.stampAction,error:form.errors.stampAction,readOnly:readOnly,onChange:this.handleStampActionChange});}}]);return SubmittalStamp;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubmittalStamp.propTypes={currentUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,submittal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{form:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_selectors__["g" /* getSubmittalForm */])(state),readOnly:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_selectors__["o" /* getSubmittalReadOnly */])(state),gcAcceleration:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_selectors__["h" /* getSubmittalGcAcceleration */])(state)};})(SubmittalStamp));

/***/ }),
/* 2617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_chat_Chat__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_selectors__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_submittal_log_store_actions__ = __webpack_require__(131);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubmittalComments=function(_Component){_inherits(SubmittalComments,_Component);function SubmittalComments(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SubmittalComments);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SubmittalComments.__proto__||Object.getPrototypeOf(SubmittalComments)).call.apply(_ref,[this].concat(args))),_this),_this.loadNotes=function(){var _this$props=_this.props,submittal=_this$props.submittal,dispatch=_this$props.dispatch;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_submittal_log_store_actions__["l" /* loadSubmittalNotes */])(submittal.id));},_this.handleSubmit=function(newNote){var _this$props2=_this.props,submittal=_this$props2.submittal,dispatch=_this$props2.dispatch;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_submittal_log_store_actions__["d" /* createSubmittalNote */])(submittal.id,newNote));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SubmittalComments,[{key:'render',value:function render(){var submittalNotes=this.props.submittalNotes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_chat_Chat__["a" /* default */],{name:'Submittal',notes:submittalNotes,loadChat:this.loadNotes,handleFormChange:this.handleFormChange,handleSubmit:this.handleSubmit});}}]);return SubmittalComments;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubmittalComments.propTypes={submittal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{submittalNotes:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_submittal_log_store_selectors__["m" /* getSubmittalNotes */])(state)};})(SubmittalComments));

/***/ }),
/* 2618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubmittalForm_css__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubmittalForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SubmittalForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_checkbox_LabeledCheckBox__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_submittal_log_store_selectors__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_submittal_log_store_actions__ = __webpack_require__(131);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubmittalLeadTimeForm=function(_Component){_inherits(SubmittalLeadTimeForm,_Component);function SubmittalLeadTimeForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SubmittalLeadTimeForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SubmittalLeadTimeForm.__proto__||Object.getPrototypeOf(SubmittalLeadTimeForm)).call.apply(_ref,[this].concat(args))),_this),_this.scrollToLeadTime=function(){_this.leadTimeSection.scrollIntoView();},_this.handleFormChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_submittal_log_store_actions__["E" /* updateSubmittalFormValue */])(attribute,value));},_this.handleFieldDeliveryChange=function(value){var dateTo=__WEBPACK_IMPORTED_MODULE_8_moment___default()(value);var dateFrom=dateTo.subtract(7,'d').format();_this.handleFormChange('fieldDelivery',value);_this.handleFormChange('leadTimeReminder',dateFrom);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SubmittalLeadTimeForm,[{key:'componentDidMount',value:function componentDidMount(){this.scrollToLeadTime();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,form=_props.form,readOnly=_props.readOnly;var labelStyle=readOnly?'compact-control-label':'control-label';var inputValueStyle=readOnly?'read-only':'edit';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submittal-form submittal-lead-time-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'submittal-title'},'Submittal Lead Time - ',form.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Form */],{horizontal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{className:labelStyle+' lead-time-applies-label',sm:3},'Lead Time Applicable'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{readOnly:readOnly,checked:form.leadTimeApplies,onChange:function onChange(value){return _this2.handleFormChange('leadTimeApplies',value);}}))),form.leadTimeApplies&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{className:labelStyle,sm:readOnly?3:2},'Lead Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:readOnly?3:4,className:inputValueStyle},readOnly?form.leadTimeWeeks!==''?form.leadTimeWeeks+' '+(form.leadTimeWeeks===1?'Week':'Weeks'):'-':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{type:'number',placeholder:'# of Weeks',value:form.leadTimeWeeks,onChange:function onChange(value){return _this2.handleFormChange('leadTimeWeeks',value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{className:labelStyle,sm:readOnly?3:2},'Field Delivery'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:readOnly?3:4,className:inputValueStyle},readOnly?form.fieldDelivery?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Date__["a" /* default */],{value:form.fieldDelivery,format:'MM/DD/YYYY'}):'-':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:function isValidDate(date){return(!form.vendorDelivery||date.isSameOrAfter(form.vendorDelivery))&&(!form.leadTimeReminder||date.isSameOrAfter(form.leadTimeReminder));},placeholder:'Choose Date...',value:form.fieldDelivery,onChange:this.handleFieldDeliveryChange}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{className:labelStyle,sm:readOnly?3:2},'Delivery to Vendor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:readOnly?3:4,className:inputValueStyle},readOnly?form.vendorDelivery?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Date__["a" /* default */],{value:form.vendorDelivery,format:'MM/DD/YYYY'}):'-':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:function isValidDate(date){return!form.fieldDelivery||date.isSameOrBefore(form.fieldDelivery);},placeholder:'Choose Date...',value:form.vendorDelivery,onChange:function onChange(value){return _this2.handleFormChange('vendorDelivery',value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{className:labelStyle,sm:readOnly?3:2},'Reminder'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Col */],{sm:readOnly?3:4,className:inputValueStyle},readOnly?form.leadTimeReminder?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Date__["a" /* default */],{value:form.leadTimeReminder,format:'MM/DD/YYYY'}):'-':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{placeholder:'Choose Date...',isValidDate:function isValidDate(date){return!form.fieldDelivery||date.isSameOrBefore(form.fieldDelivery);},value:form.leadTimeReminder,onChange:function onChange(value){return _this2.handleFormChange('leadTimeReminder',value);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(el){_this2.leadTimeSection=el;}}));}}]);return SubmittalLeadTimeForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{form:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_submittal_log_store_selectors__["g" /* getSubmittalForm */])(state),readOnly:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_submittal_log_store_selectors__["i" /* getSubmittalLeadTimeReadOnly */])(state)};})(SubmittalLeadTimeForm));

/***/ }),
/* 2619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubmittalActions_css__ = __webpack_require__(2620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubmittalActions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SubmittalActions_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_print_svg__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_print_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_print_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_mail_svg__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_mail_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_mail_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_domain_submittal__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_submittal_log_store_selectors__ = __webpack_require__(190);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubmittalActions=function(_Component){_inherits(SubmittalActions,_Component);function SubmittalActions(props){_classCallCheck(this,SubmittalActions);var _this=_possibleConstructorReturn(this,(SubmittalActions.__proto__||Object.getPrototypeOf(SubmittalActions)).call(this,props));_this.validateForm=function(){var draft=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var _this$props=_this.props,project=_this$props.project,form=_this$props.form,gcAcceleration=_this$props.gcAcceleration,dispatch=_this$props.dispatch;var primary=__WEBPACK_IMPORTED_MODULE_11_domain_enterprise__["a" /* Enterprise */].primary(project.contributor_type);var errors={};var status=__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].create(form.status);if(!primary){if(!form.csiCodeId){errors.csiCodeId=true;}if(!draft){if(!form.dueDate&&!__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].FOR_RECORD.equals(status)){errors.dueDate=true;}if(!form.status){errors.status=true;}if(!form.title){errors.title=true;}if(!form.question){errors.question=true;}}}if(!draft&&(primary||gcAcceleration)&&!form.stampAction){errors.stampAction=true;}dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["u" /* setSubmittalFormErrors */])(errors));return Object.keys(errors).length===0;};_this.validate=function(){var draft=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;return _this.validateForm(draft);};_this.formStatus=function(){var draft=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var _this$props2=_this.props,submittal=_this$props2.submittal,form=_this$props2.form;var status=submittal&&__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].create(submittal.status);var newStatus=form.status;if(draft){if(!status||__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].DRAFT.equals(status)){newStatus=__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["b" /* SubmittalStatusKeys */].DRAFT;}else if(__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].PENDING.equals(status)||__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].DRAFT_PENDING.equals(status)){newStatus=__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["b" /* SubmittalStatusKeys */].DRAFT_PENDING;}else if(__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].ASSIGNED.equals(status)||__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].DRAFT_ASSIGNED.equals(status)){newStatus=__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["b" /* SubmittalStatusKeys */].DRAFT_ASSIGNED;}}else{if(newStatus==='for_record'){newStatus=__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["b" /* SubmittalStatusKeys */].FOR_RECORD;}else{newStatus=form.stampAction||(form.assignee.length===0?__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["b" /* SubmittalStatusKeys */].PENDING:__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["b" /* SubmittalStatusKeys */].ASSIGNED);}}_this.handleFormChange('status',newStatus);return newStatus;};_this.handleSaveDraft=function(){_this.handleSubmit(true);};_this.handleMarkAsClosed=function(){_this.handleSubmit(false,true);};_this.handleSubmit=function(){var draft=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var closed=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if(!_this.validate(draft)){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["s" /* setSetShowSubmittalErrorMessage */])(true));return;}var _this$props3=_this.props,project=_this$props3.project,form=_this$props3.form,gcAcceleration=_this$props3.gcAcceleration,handleClose=_this$props3.handleClose,dispatch=_this$props3.dispatch;var primary=__WEBPACK_IMPORTED_MODULE_11_domain_enterprise__["a" /* Enterprise */].primary(project.contributor_type);var status=__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].create(_this.formStatus(draft));var submittal=Object.assign({},form,{status:status.status,assigneeId:form.assignee[0]||'',recipientIds:form.recipients.map(function(recpt){return recpt[0];}),requestedAt:form.requestedDate?__WEBPACK_IMPORTED_MODULE_9_moment___default()(form.requestedDate):'',closed:!!form.closed||closed||!!(gcAcceleration&&form.stampAction)||'',remarks:form.remarks||'',stampAction:form.stampAction||''});var promise=void 0;if(form.id){if(primary){var addlAssignee=__WEBPACK_IMPORTED_MODULE_12_domain_submittal__["a" /* Submittal */].addlAssignee(_this.props.submittal,_this.props.currentUser);if(addlAssignee){promise=dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["r" /* respondSubmittalAddlAssignee */])(addlAssignee.id,submittal));}else{promise=dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["q" /* respondSubmittal */])(project.id,form.id,submittal));}}else{promise=dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["C" /* updateSubmittal */])(project.id,form.id,submittal));}}else{var _this$props4=_this.props,currentPage=_this$props4.currentPage,currentStatus=_this$props4.currentStatus;promise=dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["c" /* createSubmittal */])(project.id,submittal,currentPage,currentStatus));}promise.then(function(response){if(response.ok){if(gcAcceleration){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["q" /* respondSubmittal */])(project.id,form.id,submittal)).then(function(response){if(response.ok){handleClose();}});}else{handleClose();}}});};_this.handleFormChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["E" /* updateSubmittalFormValue */])(attribute,value));};_this.setReadOnly=function(readOnly){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["A" /* setSubmittalReadOnly */])(readOnly));};_this.handleExportTransmittal=function(){var _this$props5=_this.props,project=_this$props5.project,form=_this$props5.form,dispatch=_this$props5.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["n" /* loadTransmittalPdf */])(project.id,form.id));};_this.handleEdit=function(){_this.setReadOnly(false);};_this.handleEditLeadTime=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["w" /* setSubmittalLeadTimeReadOnly */])(false));};_this.handleGcAcceleration=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["v" /* setSubmittalGcAcceleration */])(true));};_this.handleViewPdf=function(){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["z" /* setSubmittalPdfViewer */])(true));};_this.handleShowEmailModal=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["j" /* setShowEmailModal */])(true));};_this.handleDiscardDraft=function(){_this.setState({showDeleteConfirmation:true});};_this.handleDeleteConfirmation=function(confirmed){_this.setState({showDeleteConfirmation:false});confirmed&&_this.handleDelete();};_this.handleDelete=function(){var _this$props6=_this.props,project=_this$props6.project,submittal=_this$props6.submittal,handleClose=_this$props6.handleClose,dispatch=_this$props6.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["e" /* deleteSubmittal */])(project.id,submittal.id)).then(function(response){if(response.ok){handleClose();}});};_this.handleSubmitLeadTime=function(){var _this$props7=_this.props,project=_this$props7.project,form=_this$props7.form,handleClose=_this$props7.handleClose,dispatch=_this$props7.dispatch;var submittal={leadTimeApplies:form.leadTimeApplies,leadTimeWeeks:form.leadTimeWeeks,orderDate:form.orderDate,vendorDelivery:form.vendorDelivery,fieldDelivery:form.fieldDelivery,leadTimeReminder:form.leadTimeReminder};dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["F" /* updateSubmittalLeadTime */])(project.id,form.id,submittal)).then(function(response){if(response.ok){handleClose();}});};_this.state={showDeleteConfirmation:false};return _this;}_createClass(SubmittalActions,[{key:'render',value:function render(){var _this2=this;var _props=this.props,currentUser=_props.currentUser,project=_props.project,submittal=_props.submittal,form=_props.form,readOnly=_props.readOnly,leadTimeReadOnly=_props.leadTimeReadOnly,gcAcceleration=_props.gcAcceleration,showLeadTime=_props.showLeadTime,showErrorMessage=_props.showErrorMessage,handleClose=_props.handleClose;var showDeleteConfirmation=this.state.showDeleteConfirmation;var status=__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].create(form.status);var discard=__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].DRAFT.equals(status)||__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].PENDING.equals(status)||__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].DRAFT_PENDING.equals(status);var draftOrPending=__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].DRAFT.equals(status)||__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].PENDING.equals(status);var pendingOrAssigned=__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].PENDING.equals(status)||__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].ASSIGNED.equals(status)||__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].DRAFT_PENDING.equals(status)||__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].DRAFT_ASSIGNED.equals(status);var originalStatus=submittal&&__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].create(submittal.status);var primary=__WEBPACK_IMPORTED_MODULE_11_domain_enterprise__["a" /* Enterprise */].primary(project.contributor_type);var sub=submittal&&submittal.contractor_id===currentUser.accountable_id&&__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);var assignedToMe=submittal&&__WEBPACK_IMPORTED_MODULE_12_domain_submittal__["a" /* Submittal */].assignee(submittal,currentUser);var addlAssignee=submittal&&__WEBPACK_IMPORTED_MODULE_12_domain_submittal__["a" /* Submittal */].addlAssignee(submittal,currentUser);var spackleOrGc=__WEBPACK_IMPORTED_MODULE_11_domain_enterprise__["a" /* Enterprise */].spackle(project.contributor_type)||__WEBPACK_IMPORTED_MODULE_11_domain_enterprise__["a" /* Enterprise */].generalContractor(project.contributor_type);var saveDraft=!originalStatus||__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].DRAFT.equals(originalStatus)||spackleOrGc&&__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].PENDING.equals(originalStatus)||spackleOrGc&&__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].DRAFT_PENDING.equals(originalStatus)||assignedToMe&&__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].ASSIGNED.equals(originalStatus)||assignedToMe&&__WEBPACK_IMPORTED_MODULE_13_domain_submittal_status_enum__["a" /* SubmittalStatusEnum */].DRAFT_ASSIGNED.equals(originalStatus);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submittal-actions'},showErrorMessage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'error-message'},'There are missing fields, please review.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},submittal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-white',icon:__WEBPACK_IMPORTED_MODULE_5_images_mail_svg___default.a,label:'Email',onClick:this.handleShowEmailModal}),submittal.pdf_document&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-white',icon:__WEBPACK_IMPORTED_MODULE_4_images_print_svg___default.a,label:'View PDF',onClick:this.handleViewPdf})),!readOnly&&saveDraft&&!addlAssignee&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-white button-save-draft',label:'Save Draft and Close',onClick:this.handleSaveDraft}),!readOnly&&!gcAcceleration&&submittal&&spackleOrGc&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-white',label:'GC Acceleration',onClick:this.handleGcAcceleration}),!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:form.id?'Submit':'Create Submittal',onClick:function onClick(){return _this2.handleSubmit();}}),readOnly&&!primary&&pendingOrAssigned&&form.physicalCopies>'0'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-white button-save-draft',icon:__WEBPACK_IMPORTED_MODULE_4_images_print_svg___default.a,label:'Export Transmittal',onClick:this.handleExportTransmittal}),readOnly&&spackleOrGc&&!pendingOrAssigned&&form.stampAction&&!form.closed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-white',label:'Mark as Closed',onClick:this.handleMarkAsClosed}),readOnly&&leadTimeReadOnly&&(spackleOrGc||assignedToMe&&!form.closed||sub&&draftOrPending)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Edit',onClick:this.handleEdit}),readOnly&&leadTimeReadOnly&&showLeadTime&&(!sub||!submittal.field_delivery)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Edit Lead Time',onClick:this.handleEditLeadTime}),!leadTimeReadOnly&&showLeadTime&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Submit',onClick:this.handleSubmitLeadTime}),submittal&&discard&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-white button-delete',label:'Discard',onClick:this.handleDiscardDraft}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:readOnly&&leadTimeReadOnly?'Close':'Cancel',onClick:handleClose})),showDeleteConfirmation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_modal_ConfirmationModal__["a" /* default */],{show:showDeleteConfirmation,message:'Are you sure you want to discard this Submittal?',onHide:this.handleDeleteConfirmation}));}}]);return SubmittalActions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubmittalActions.propTypes={currentUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,project:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,submittal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),showLeadTime:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,handleClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentPage:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_submittal_log_store_selectors__["a" /* getCurrentPage */])(state),currentStatus:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_submittal_log_store_selectors__["b" /* getCurrentStatus */])(state),form:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_submittal_log_store_selectors__["g" /* getSubmittalForm */])(state),readOnly:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_submittal_log_store_selectors__["o" /* getSubmittalReadOnly */])(state),leadTimeReadOnly:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_submittal_log_store_selectors__["i" /* getSubmittalLeadTimeReadOnly */])(state),gcAcceleration:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_submittal_log_store_selectors__["h" /* getSubmittalGcAcceleration */])(state),showErrorMessage:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_submittal_log_store_selectors__["p" /* getSubmittalShowErrorMessage */])(state)};})(SubmittalActions));

/***/ }),
/* 2620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProjectDailyReportLog_css__ = __webpack_require__(2622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProjectDailyReportLog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ProjectDailyReportLog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_print_white_svg__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_print_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_print_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_pdf_viewer_PdfViewer__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_checkbox_CheckBox__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_settings_store_selectors__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_daily_report_log_store_selectors__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_settings_store_actions__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_daily_report_log_store_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_daily_report_log_DailyReportLogTable__ = __webpack_require__(2624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_daily_report_log_FieldWorkOrderLogTable__ = __webpack_require__(2626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_daily_report_log_AddDailyReportModal__ = __webpack_require__(2628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_daily_report_log_FieldWorkOrderModal__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_selectors_authentication__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DailyReportTabValue=1;var SubDailyReportTabValue=2;var FieldWorkOrdersTabValue=3;var ProjectDailyReportLog=function(_Component){_inherits(ProjectDailyReportLog,_Component);function ProjectDailyReportLog(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProjectDailyReportLog);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProjectDailyReportLog.__proto__||Object.getPrototypeOf(ProjectDailyReportLog)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenReportModal=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_daily_report_log_store_actions__["_10" /* setShowDailyReportModal */])(true));},_this.handleLogPdfViewerOpen=function(){var _this$props=_this.props,currentProject=_this$props.currentProject,dispatch=_this$props.dispatch,dailyReportsTabSelected=_this$props.dailyReportsTabSelected;dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_daily_report_log_store_actions__["A" /* loadDailyReportLogPdfRequest */])(currentProject.id,dailyReportsTabSelected===SubDailyReportTabValue)).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_daily_report_log_store_actions__["R" /* setDailyReportLogPdfViewer */])(true));}});},_this.handleLogPdfViewerClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_daily_report_log_store_actions__["R" /* setDailyReportLogPdfViewer */])(false));},_this.spackleOrGc=function(){var currentProject=_this.props.currentProject;return currentProject&&(__WEBPACK_IMPORTED_MODULE_20_domain_enterprise__["a" /* Enterprise */].spackle(currentProject.contributor_type)||__WEBPACK_IMPORTED_MODULE_20_domain_enterprise__["a" /* Enterprise */].generalContractor(currentProject.contributor_type));},_this.subcontractor=function(){var currentProject=_this.props.currentProject;return currentProject&&__WEBPACK_IMPORTED_MODULE_20_domain_enterprise__["a" /* Enterprise */].subcontractor(currentProject.contributor_type);},_this.isFieldWorkOrderTab=function(){var dailyReportsTabSelected=_this.props.dailyReportsTabSelected;return dailyReportsTabSelected===FieldWorkOrdersTabValue;},_this.handlePageChange=function(newPage){var _this$props2=_this.props,currentProject=_this$props2.currentProject,dispatch=_this$props2.dispatch,dailyReportsTabSelected=_this$props2.dailyReportsTabSelected;if(_this.isFieldWorkOrderTab()){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_daily_report_log_store_actions__["D" /* loadFieldWorkOrdersRequest */])(currentProject.id,newPage,_this.spackleOrGc()));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_daily_report_log_store_actions__["C" /* loadDailyReportsRequest */])(currentProject.id,newPage,SubDailyReportTabValue===dailyReportsTabSelected));}},_this.handleDailyReportsTabSelection=function(reportTab){var _this$props3=_this.props,dispatch=_this$props3.dispatch,currentProject=_this$props3.currentProject;dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_daily_report_log_store_actions__["S" /* setDailyReportTab */])(reportTab));if(reportTab===FieldWorkOrdersTabValue){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_daily_report_log_store_actions__["D" /* loadFieldWorkOrdersRequest */])(currentProject.id,1,_this.spackleOrGc()));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_daily_report_log_store_actions__["C" /* loadDailyReportsRequest */])(currentProject.id,1,SubDailyReportTabValue===reportTab));}},_this.handleMultipleFloorsChange=function(){var _this$props4=_this.props,currentProject=_this$props4.currentProject,settings=_this$props4.settings,dispatch=_this$props4.dispatch;var values={multipleFloors:!settings.multiple_floors};dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_settings_store_actions__["b" /* updateSettings */])(currentProject.id,values));},_this.renderMultipleFloorsTooltip=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["u" /* Tooltip */],{id:'tooltip-multiple-floors'},'Daily Report requires a floor number for each trade');},_this.renderMultipleFloors=function(){var settings=_this.props.settings;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["q" /* OverlayTrigger */],{placement:'right',overlay:_this.renderMultipleFloorsTooltip()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["b" /* Button */],{className:'checkbox-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_checkbox_CheckBox__["a" /* default */],{checked:settings.multiple_floors,size:'medium',onChange:_this.handleMultipleFloorsChange})));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProjectDailyReportLog,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,dispatch=_props.dispatch,currentProject=_props.currentProject;var isSubcontractor=this.subcontractor();if(currentProject){this.spackleOrGc()&&dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_settings_store_actions__["a" /* loadSettings */])(currentProject.id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_daily_report_log_store_actions__["C" /* loadDailyReportsRequest */])(currentProject.id,1,isSubcontractor));dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_daily_report_log_store_actions__["S" /* setDailyReportTab */])(isSubcontractor?SubDailyReportTabValue:DailyReportTabValue));}}},{key:'buildTabs',value:function buildTabs(){var dailyReportsTabSelected=this.props.dailyReportsTabSelected;var tabs=[{id:SubDailyReportTabValue,title:this.subcontractor()?'Daily Reports':'Sub Daily Reports',class:dailyReportsTabSelected===SubDailyReportTabValue?'sel':''},{id:FieldWorkOrdersTabValue,title:'Field Work Orders',class:this.isFieldWorkOrderTab()?'sel':''}];if(this.spackleOrGc()){tabs=[{id:DailyReportTabValue,title:'Daily Reports',class:dailyReportsTabSelected===DailyReportTabValue?'sel':''}].concat(_toConsumableArray(tabs));}return tabs;}},{key:'render',value:function render(){var _props2=this.props,currentProject=_props2.currentProject,dailyReports=_props2.dailyReports,showAddDailyReportModal=_props2.showAddDailyReportModal,dailyReportLogPdf=_props2.dailyReportLogPdf,dailyReportLogPdfViewer=_props2.dailyReportLogPdfViewer,currentPage=_props2.currentPage,reportsPageSize=_props2.reportsPageSize,reportsTotal=_props2.reportsTotal,dailyReportsTabSelected=_props2.dailyReportsTabSelected,fieldWorkOrders=_props2.fieldWorkOrders,showFieldWorkOrderModal=_props2.showFieldWorkOrderModal,settings=_props2.settings;var isSubcontractor=this.subcontractor();var showActions=isSubcontractor||this.spackleOrGc()&&dailyReportsTabSelected===DailyReportTabValue;return currentProject&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'daily-report-log'},this.spackleOrGc()&&settings&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'daily-report-multiple-floors'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Multiple Floors'),this.renderMultipleFloors()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'daily-report-log-navigation'},isSubcontractor||this.spackleOrGc()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_shared_navigation_NavigationBar__["a" /* default */],{items:this.buildTabs(),onSelected:this.handleDailyReportsTabSelection}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Daily Report Log'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'buttons-container':true,'buttons-container-gc':true})},!this.isFieldWorkOrderTab()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button-gray',icon:__WEBPACK_IMPORTED_MODULE_5_images_print_white_svg___default.a,label:'View PDF',onClick:this.handleLogPdfViewerOpen}),showActions&&!this.isFieldWorkOrderTab()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Add Daily Report',onClick:this.handleOpenReportModal}))),this.isFieldWorkOrderTab()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_daily_report_log_FieldWorkOrderLogTable__["a" /* default */],{fieldWorkOrders:fieldWorkOrders,isSubcontractor:isSubcontractor}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_daily_report_log_DailyReportLogTable__["a" /* default */],{dailyReports:dailyReports,isSubTabSelected:dailyReportsTabSelected===SubDailyReportTabValue,isSubDailyReport:isSubcontractor}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'daily-report-pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPage,pageSize:reportsPageSize,total:reportsTotal,onPageChange:this.handlePageChange})),showAddDailyReportModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_daily_report_log_AddDailyReportModal__["a" /* default */],{projectId:currentProject.id,readOnly:!this.spackleOrGc()&&!this.subcontractor(),show:showAddDailyReportModal}),dailyReportLogPdfViewer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:dailyReportLogPdf,type:'blob'},show:dailyReportLogPdfViewer,onClose:this.handleLogPdfViewerClose}),showFieldWorkOrderModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_daily_report_log_FieldWorkOrderModal__["a" /* default */],null));}}]);return ProjectDailyReportLog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),settings:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_settings_store_selectors__["a" /* getSettings */])(state),dailyReports:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_daily_report_log_store_selectors__["l" /* getDailyReports */])(state),showAddDailyReportModal:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_daily_report_log_store_selectors__["H" /* getShowAddDailyReportModal */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_21_selectors_authentication__["d" /* getCurrentUser */])(state),dailyReportLogPdf:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_daily_report_log_store_selectors__["j" /* getDailyReportLogPdf */])(state),dailyReportLogPdfViewer:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_daily_report_log_store_selectors__["k" /* getDailyReportLogPdfViewer */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_daily_report_log_store_selectors__["h" /* getCurrentPage */])(state),reportsPageSize:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_daily_report_log_store_selectors__["F" /* getReportsPageSize */])(state),reportsTotal:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_daily_report_log_store_selectors__["G" /* getReportsTotal */])(state),dailyReportsTabSelected:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_daily_report_log_store_selectors__["m" /* getDailyReportsTabSelected */])(state),fieldWorkOrders:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_daily_report_log_store_selectors__["t" /* getFieldWorkOrders */])(state),showFieldWorkOrderModal:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_daily_report_log_store_selectors__["J" /* getShowFieldWorkOrderModal */])(state)};})(ProjectDailyReportLog));

/***/ }),
/* 2622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return projectSettingsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectSettingsApi=function(_BaseApi){_inherits(ProjectSettingsApi,_BaseApi);function ProjectSettingsApi(){_classCallCheck(this,ProjectSettingsApi);return _possibleConstructorReturn(this,(ProjectSettingsApi.__proto__||Object.getPrototypeOf(ProjectSettingsApi)).apply(this,arguments));}_createClass(ProjectSettingsApi,[{key:'show',value:function show(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/project_settings').then(function(response){return{ok:true,projectSettings:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'update',value:function update(projectId,values){var data=this.projectSettingsParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/project_settings',data).then(function(response){return{ok:true,projectSettings:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'projectSettingsParams',value:function projectSettingsParams(values){return{project_settings:{multiple_floors:values.multipleFloors}};}}]);return ProjectSettingsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var projectSettingsApi=new ProjectSettingsApi();

/***/ }),
/* 2624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DailyReportLogTable_css__ = __webpack_require__(2625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DailyReportLogTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DailyReportLogTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_daily_report_log_store_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_done_svg__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_done_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_images_done_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_selectors__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_pdf_viewer_PdfViewer__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DailyReportLogTable=function(_Component){_inherits(DailyReportLogTable,_Component);function DailyReportLogTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DailyReportLogTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DailyReportLogTable.__proto__||Object.getPrototypeOf(DailyReportLogTable)).call.apply(_ref,[this].concat(args))),_this),_this.handleGenerateLink=function(index){var _this$props=_this.props,dailyReports=_this$props.dailyReports,isSubTabSelected=_this$props.isSubTabSelected;var query='?dailyReportId='+dailyReports[index].id;if(isSubTabSelected){query+='&subDailyReport=true';}return query;},_this.submittedBy=function(user){var title=user.title?' - '+user.title:'';return user.first_name+' '+user.last_name+title;},_this.viewButton=function(report){var isSubDailyReport=_this.props.isSubDailyReport;if(report.status==='submitted'||report.status==='approved'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_button_Button__["a" /* default */],{className:'button-white',label:'View',onClick:function onClick(e){e.stopPropagation();_this.handleViewPdf(report.id,report.project_id,isSubDailyReport);}});}},_this.handleViewPdf=function(reportId,projectId,isSubDailyReport){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_daily_report_log_store_actions__["B" /* loadDailyReportlPdf */])(projectId,reportId,isSubDailyReport));},_this.handleReportPdfViewerClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_daily_report_log_store_actions__["_8" /* setReportPdfViewer */])(false));},_this.renderPdfViewer=function(){var _this$props2=_this.props,reportPdfViewer=_this$props2.reportPdfViewer,reportPdf=_this$props2.reportPdf;if(reportPdfViewer){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:reportPdf,type:'blob'},show:reportPdfViewer,onClose:_this.handleReportPdfViewerClose});}},_this.status=function(report){if(report.status==='draft'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'draft'},'Draft');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:report.on_schedule&&!report.fwo_present?'on-schedule':'delay'},report.on_schedule&&!report.fwo_present&&'On Schedule',!report.on_schedule&&!report.fwo_present&&'Open Item',report.on_schedule&&report.fwo_present&&'Field Work Order',!report.on_schedule&&report.fwo_present&&'Open Item/Field Work Order',report.status==='approved'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'done-icon',src:__WEBPACK_IMPORTED_MODULE_8_images_done_svg___default.a,alt:'done'}));}},_this.mapDailyReports=function(){var dailyReports=_this.props.dailyReports;return dailyReports.map(function(report){var result=[report.number,report.report_date?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__["a" /* default */],{value:report.report_date,format:'MM/DD/YYYY'}):'-',report.submitted_by?_this.submittedBy(report.submitted_by):'-',(report.submitted_at||report.status==='approved')&&report.total_hours?report.total_hours:'-',_this.status(report),_this.viewButton(report)];if(_this.showContractorColumn()){var resultName=report.contractor?report.contractor.name:'-';result.splice(2,0,resultName);}return result;});},_this.selectedRow=function(id){var _this$props3=_this.props,dailyReports=_this$props3.dailyReports,dispatch=_this$props3.dispatch,isSubDailyReport=_this$props3.isSubDailyReport,isSubTabSelected=_this$props3.isSubTabSelected;var report=dailyReports[id];if(report&&report.id&&report.project_id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_daily_report_log_store_actions__["I" /* openDraftReport */])(report.project_id,report.id,isSubDailyReport||isSubTabSelected));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DailyReportLogTable,[{key:'showContractorColumn',value:function showContractorColumn(){var _props=this.props,isSubTabSelected=_props.isSubTabSelected,isSubDailyReport=_props.isSubDailyReport;return isSubTabSelected&&!isSubDailyReport;}},{key:'render',value:function render(){var headers=['#','DATE','SUBMITTED BY','TOTAL HOURS','STATUS',''];if(this.showContractorColumn()){headers.splice(2,0,'CONTRACTOR');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'simple-table':true,'projects-table':true,'daily-report-log-table':true,'sub-daily-report-log-table':this.showContractorColumn()}),headers:headers,rows:this.mapDailyReports(),emptyMessage:'No Daily Reports',onRowSelected:this.selectedRow,onGenerateLink:this.handleGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_pdf_viewer_PdfViewer__["a" /* default */],{content:{source:this.props.reportPdf,type:'blob'},show:this.props.reportPdfViewer,onClose:this.handleReportPdfViewerClose}));}}]);return DailyReportLogTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DailyReportLogTable.propTypes={dailyReports:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})).isRequired,isSubTabSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isSubDailyReport:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{reportPdfViewer:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_selectors__["E" /* getReportPdfViewer */])(state),reportPdf:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_selectors__["D" /* getReportPdf */])(state)};})(DailyReportLogTable));

/***/ }),
/* 2625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FieldWorkOrderLogTable_css__ = __webpack_require__(2627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FieldWorkOrderLogTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FieldWorkOrderLogTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_store_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FieldWorkOrderLogTable=function(_Component){_inherits(FieldWorkOrderLogTable,_Component);function FieldWorkOrderLogTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FieldWorkOrderLogTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FieldWorkOrderLogTable.__proto__||Object.getPrototypeOf(FieldWorkOrderLogTable)).call.apply(_ref,[this].concat(args))),_this),_this.status={pending:'Pending',sub_approved:'Sub-Approved',gc_approved:'GC-Approved',sub_denied:'Sub-Denied',gc_denied:'GC-Denied'},_this.mapFieldWorkOrders=function(){var _this$props=_this.props,fieldWorkOrders=_this$props.fieldWorkOrders,isSubcontractor=_this$props.isSubcontractor;return fieldWorkOrders.map(function(fieldWO){var result=[fieldWO.number,fieldWO.work_performed||'-',fieldWO.start_date?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__["a" /* default */],{value:fieldWO.start_date,format:'MM/DD/YYYY'}):'TBD',fieldWO.completion_date?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__["a" /* default */],{value:fieldWO.completion_date,format:'MM/DD/YYYY'}):'TBD',fieldWO.delay?'Yes':'No',fieldWO.cost_impact?fieldWO.cost||'Yes':'No',fieldWO.status?_this.status[fieldWO.status]:'-'];if(!isSubcontractor){var csiCode=fieldWO.csi_code?fieldWO.csi_code.division:'';var contractor=fieldWO.contractor?fieldWO.contractor.name:'-';result.splice(1,0,csiCode,contractor);}return result;});},_this.selectedRow=function(id){var _this$props2=_this.props,fieldWorkOrders=_this$props2.fieldWorkOrders,dispatch=_this$props2.dispatch;var fieldWorkOrder=fieldWorkOrders[id];if(fieldWorkOrder&&fieldWorkOrder.id&&fieldWorkOrder.project_id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_store_actions__["J" /* openFieldWorkOrder */])(fieldWorkOrder.project_id,fieldWorkOrder.id));}},_this.handleGenerateLink=function(index){var fieldWorkOrders=_this.props.fieldWorkOrders;return'?fieldWorkOrderId='+fieldWorkOrders[index].id;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FieldWorkOrderLogTable,[{key:'render',value:function render(){var isSubcontractor=this.props.isSubcontractor;var headers=['#','WORK TO BE PERFORMED','START','COMPLETION','DELAY','COST IMPACT','STATUS'];if(!isSubcontractor){headers.splice(1,0,'CSI CODE','CONTRACTOR');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'simple-table':true,'projects-table':true,'field-work-order-log-table':true,'sub-field-work-order-log-table':isSubcontractor}),headers:headers,rows:this.mapFieldWorkOrders(),emptyMessage:'No Field Work Orders',onRowSelected:this.selectedRow,onGenerateLink:this.handleGenerateLink});}}]);return FieldWorkOrderLogTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FieldWorkOrderLogTable.propTypes={fieldWorkOrders:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})).isRequired,isSubcontractor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(FieldWorkOrderLogTable));

/***/ }),
/* 2627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_utils_daily_report_util__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_mail_svg__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_mail_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_images_mail_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_dropdown_MultipleDropdown__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_email_modal_ProjectEmailModal__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_daily_report_log_SingleTradeForm__ = __webpack_require__(2629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_daily_report_log_SingleTradeFormForSub__ = __webpack_require__(2631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_daily_report_log_MemberFormModal__ = __webpack_require__(2633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_daily_report_log_ReviewForm__ = __webpack_require__(2634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_daily_report_log_DuplicateDailyReportModal__ = __webpack_require__(2638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_directory_store_selectors__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_project_settings_store_selectors__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_admin_projects_details_project_email_modal_store_selectors__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_admin_projects_details_project_directory_store_actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_admin_projects_details_project_settings_store_actions__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__AddDailyReportModal_css__ = __webpack_require__(2640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__AddDailyReportModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__AddDailyReportModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_admin_projects_details_project_email_modal_store_actions__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_services_utils_users_util__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubDailyReportTabValue=2;var AddDailyReportModal=function(_Component){_inherits(AddDailyReportModal,_Component);function AddDailyReportModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddDailyReportModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddDailyReportModal.__proto__||Object.getPrototypeOf(AddDailyReportModal)).call.apply(_ref,[this].concat(args))),_this),_this.state={errors:{},reviewErrors:[],errorsMemberForm:[],errorsForStaff:false,errorsOpenItemForm:{},errorsForOpenItem:false,submitFailed:false,showDuplicateModal:false},_this.getGeneralContactorLabel=function(){var currentProject=_this.props.currentProject;return currentProject&&currentProject.general_contractor&&__WEBPACK_IMPORTED_MODULE_6_services_utils_daily_report_util__["a" /* DailyReportUtil */].gcLabel(currentProject.general_contractor);},_this.clearReviewErrors=function(){_this.setState({reviewErrors:[]});},_this.submitFailedTradeFormErrors=function(){if(_this.state.submitFailed){var errors=_this.isSubDailyReport()?_this.getErrorsForSub():_this.getErrors();_this.setState({errors:Object.assign({},errors)});}},_this.submitFailedMembersFormErrors=function(){var submitFailed=_this.state.submitFailed;if(submitFailed){var errorsMemberForm=_this.getErrorsForMembers(submitFailed);var errorsOpenItemForm=_this.getErrorsForOpenItem(submitFailed);_this.setState({errorsMemberForm:[].concat(_toConsumableArray(errorsMemberForm)),errorsOpenItemForm:Object.assign({},errorsOpenItemForm)});}},_this.handleClose=function(event){event&&event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_10" /* setShowDailyReportModal */])(false));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["M" /* setActiveContributor */])(0));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["N" /* setActiveEntriesId */])(null));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["O" /* setContributors */])([]));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["P" /* setCurrentDailyReport */])(null));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_9" /* setReviewFormAction */])(false));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_13" /* setSubmittedReport */])(false));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["i" /* clearFormAction */])());_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["V" /* setEditMode */])(false));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_3" /* setReportDate */])(__WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD')));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_5" /* setReportExtraInputs */])({}));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_6" /* setReportOpenItem */])({}));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_0" /* setGeneralContractorName */])(null));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_1" /* setMemberForm */])(false));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_2" /* setMembers */])([]));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["T" /* setDeletedMembers */])([]));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["Z" /* setGCImagesAction */])([]));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["Y" /* setGCDeletedImagesAction */])([]));},_this.loadDirectory=function(){var _this$props=_this.props,directory=_this$props.directory,projectId=_this$props.projectId,dispatch=_this$props.dispatch;if(projectId){if(!directory||directory.project_id!==projectId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_24_components_admin_projects_details_project_directory_store_actions__["j" /* loadDirectoryRequest */])(projectId));}}},_this.loadSettings=function(){var _this$props2=_this.props,settings=_this$props2.settings,projectId=_this$props2.projectId,dispatch=_this$props2.dispatch;if(projectId){if(!settings||settings.project_id!==projectId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_25_components_admin_projects_details_project_settings_store_actions__["a" /* loadSettings */])(projectId));}}},_this.handleDateChange=function(date){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_3" /* setReportDate */])(date));},_this.handleExtraInputChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_4" /* setReportExtraInput */])(attribute,value));},_this.handleContributorsChange=function(contributors){var errors=Object.assign({},_this.state.errors);if(errors.contributorsField){errors.contributorsField=false;_this.setState({errors:errors});}var generalContactorIndex=contributors.findIndex(function(contrib){return contrib[0]===0;});if(generalContactorIndex>=0){var gcLabel=_this.getGeneralContactorLabel();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_0" /* setGeneralContractorName */])([0,gcLabel]));contributors.splice(generalContactorIndex,1);}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_0" /* setGeneralContractorName */])(null));}_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["O" /* setContributors */])(contributors));},_this.addReport=function(){var editTrades=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var _this$props3=_this.props,contributors=_this$props3.contributors,projectId=_this$props3.projectId,currentDailyReport=_this$props3.currentDailyReport,dispatch=_this$props3.dispatch,editMode=_this$props3.editMode,reportDate=_this$props3.reportDate,generalContactorName=_this$props3.generalContactorName;var errors=_this.getErrors();if(errors&&Object.keys(errors).length>0){_this.setState({errors:Object.assign({},errors)});}else{if(projectId){return currentDailyReport?dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_15" /* updateDailyReport */])(contributors,projectId,currentDailyReport,editTrades===editMode,reportDate,generalContactorName,_this.isSubDailyReport())):dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["a" /* addDailyReport */])(contributors,reportDate,projectId,generalContactorName,_this.isSubDailyReport()));}}},_this.removeErrorsForSub=function(){_this.setState({errors:{}});},_this.removeErrors=function(key,index,value){if(index!==undefined&&_this.state.errors.technicians){var techniciansErrors=[].concat(_toConsumableArray(_this.state.errors.technicians));var currentTech=techniciansErrors[index];if(currentTech){currentTech[key]=value;if(key==='hoursAmount'){currentTech.error=false;}if(key==='workedFrom'&&currentTech.workedTo){currentTech.error=false;}if(key==='workedTo'&&currentTech.workedFrom){currentTech.error=false;}_this.setState({errors:Object.assign({},_this.state.errors,{technicians:techniciansErrors})});}return;}if(_this.state.errors[key]){_this.setState({errors:Object.assign({},_this.state.errors,_defineProperty({},key,false))});return;}},_this.clearErrors=function(index,key){var errors=[].concat(_toConsumableArray(_this.state.errorsMemberForm));if(errors[index]&&errors[index][key]){errors[index][key]=false;if(key==='hoursAmount'){errors[index].workedFrom=false;errors[index].workedTo=false;}if(key==='workedFrom'&&errors[index].workedTo){errors[index].hoursAmount=false;}if(key==='workedTo'&&errors[index].workedFrom){errors[index].hoursAmount=false;}_this.setState({errorsMemberForm:errors});}errors=Object.assign({},_this.state.errorsOpenItemForm);if(errors[key]){if(key==='openItemAssigneeId'){errors.openItemAssigneeId=false;}if(key==='openItemResolveBy'){errors.openItemResolveBy=false;}if(key==='openItemDesc'){errors.openItemDesc=false;}_this.setState({errorsOpenItemForm:errors});}},_this.getErrorsForSaveDraft=function(){var members=_this.props.members;var errors=[];members.forEach(function(member,index){var error={};if(!member.user){error.user=true;}if(Object.keys(error).length>0){errors[index]=error;}});return errors;},_this.getErrorsForMembers=function(){var isSubmitting=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var _this$props4=_this.props,members=_this$props4.members,currentDailyReport=_this$props4.currentDailyReport;var errors=[];if(members.length===0){errors.push({user:true});}members.forEach(function(member,index){var error={};if(!member.user){error.user=true;}if(currentDailyReport.status!=='draft'||isSubmitting){if(!member.supervisorTasks.length&&!member.customTask){error.supervisorTasks=true;}if(!member.hoursAmount&&(!member.workedFrom||!member.workedTo)){error.hoursAmount=true;error.workedFrom=true;error.workedTo=true;}if(member.workedFrom&&!member.workedTo){error.workedTo=true;}if(member.workedTo&&!member.workedFrom){error.workedFrom=true;}}if(Object.keys(error).length>0){errors[index]=error;}});return errors;},_this.getErrorsForOpenItem=function(){var isSubmitting=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var _this$props5=_this.props,reportOpenItem=_this$props5.reportOpenItem,currentDailyReport=_this$props5.currentDailyReport;var errors={};if(reportOpenItem.isDelay&&(currentDailyReport.status!=='draft'||isSubmitting)){if(!reportOpenItem.openItemAssigneeId){errors.openItemAssigneeId=true;}if(!reportOpenItem.openItemResolveBy){errors.openItemResolveBy=true;}if(!reportOpenItem.openItemDesc){errors.openItemDesc=true;}}return errors;},_this.noTradesAndNoGc=function(errors){var _this$props6=_this.props,contributors=_this$props6.contributors,generalContactorName=_this$props6.generalContactorName;if(contributors.length===0&&!generalContactorName){errors.contributorsField=true;}},_this.errorsNoTradesAndNoGc=function(){var errors={};_this.noTradesAndNoGc(errors);if(errors&&Object.keys(errors).length>0){_this.setState({errors:Object.assign({},errors)});return true;}return false;},_this.getErrors=function(){var _this$props7=_this.props,activeContributor=_this$props7.activeContributor,activeEntryId=_this$props7.activeEntryId,contributorsForm=_this$props7.contributorsForm,settings=_this$props7.settings;var errors={};_this.noTradesAndNoGc(errors);if(activeContributor){var formValues=contributorsForm[activeEntryId];var techniciansErrors=[];if(!formValues.floor&&settings&&settings.multiple_floors){errors.floor=true;}if(!formValues.workPerformed){errors.workPerformed=true;}if(formValues.isDelay){if(!formValues.openItemAssigneeId){errors.openItemAssigneeId=true;}if(!formValues.openItemDesc){errors.openItemDesc=true;}if(!formValues.openItemResolveBy){errors.openItemResolveBy=true;}}if(formValues.technicians&&formValues.technicians.length>0){formValues.technicians.forEach(function(technician,index){if(!technician.hoursAmount&&(!technician.workedFrom||!technician.workedTo)){techniciansErrors[index]={error:true,hoursAmount:'',workedFrom:'',workedTo:''};}if(technician.workedFrom&&!technician.workedTo){techniciansErrors[index]={error:true,hoursAmount:'',workedFrom:technician.workedFrom,workedTo:''};}if(technician.workedTo&&!technician.workedFrom){techniciansErrors[index]={error:true,hoursAmount:'',workedFrom:'',workedTo:technician.workedTo};}});if(techniciansErrors.length>0){errors.technicians=techniciansErrors;}}}return errors;},_this.prepareBaseForErrorsTech=function(techniciansErrors,index){if(!techniciansErrors[index]){techniciansErrors[index]={};}},_this.prepareBaseForErrorsTechMoreInfo=function(techniciansErrors,index,infoIndex){if(!techniciansErrors[index]){techniciansErrors[index]={};}if(!techniciansErrors[index].info){techniciansErrors[index].info=[];}if(!techniciansErrors[index].info[infoIndex]){techniciansErrors[index].info[infoIndex]={};}},_this.getErrorsForSub=function(){var _this$props8=_this.props,activeContributor=_this$props8.activeContributor,activeEntryId=_this$props8.activeEntryId,contributorsForm=_this$props8.contributorsForm,settings=_this$props8.settings;var errors={};_this.noTradesAndNoGc(errors);if(activeContributor){var formValues=contributorsForm[activeEntryId];var techniciansErrors=[];if(!formValues.floor&&settings&&settings.multiple_floors){errors.floor=true;}if(formValues.isDelay){if(!formValues.openItemAssigneeId){errors.openItemAssigneeId=true;}if(!formValues.openItemDesc){errors.openItemDesc=true;}if(!formValues.openItemResolveBy){errors.openItemResolveBy=true;}}if(formValues.isFieldWorkOrder){if(!formValues.fwoNumber){errors.fwoNumber=true;}if((!formValues.fwoPresetTasks||!formValues.fwoPresetTasks.length)&&!formValues.fwoCustomTask){errors.fwoPresetTasks=true;}if(!formValues.fwoWorkPerformed){errors.fwoWorkPerformed=true;}if(!formValues.fwoLabor){errors.fwoLabor=true;}}if(formValues.technicians&&formValues.technicians.length>0){formValues.technicians.forEach(function(technician,index){if(!technician.hoursAmount&&(!technician.workedFrom||!technician.workedTo)){_this.prepareBaseForErrorsTech(techniciansErrors,index);techniciansErrors[index].hoursAmount=true;techniciansErrors[index].workedFrom=true;techniciansErrors[index].workedTo=true;}if(technician.workedFrom&&!technician.workedTo){_this.prepareBaseForErrorsTech(techniciansErrors,index);techniciansErrors[index].hoursAmount=false;techniciansErrors[index].workedFrom=false;techniciansErrors[index].workedTo=true;}if(technician.workedTo&&!technician.workedFrom){_this.prepareBaseForErrorsTech(techniciansErrors,index);techniciansErrors[index].hoursAmount=false;techniciansErrors[index].workedFrom=true;techniciansErrors[index].workedTo=false;}if((!technician.presetTasks||!technician.presetTasks.length)&&!technician.customTask){_this.prepareBaseForErrorsTech(techniciansErrors,index);techniciansErrors[index].presetTasks=true;techniciansErrors[index].customTask=true;}if(technician.additionalInfo&&technician.additionalInfo.length){technician.additionalInfo.forEach(function(info,infoIndex){if(!info.hoursAmount&&(!info.workedFrom||!info.workedTo)){_this.prepareBaseForErrorsTechMoreInfo(techniciansErrors,index,infoIndex);techniciansErrors[index].info[infoIndex].hoursAmount=true;techniciansErrors[index].info[infoIndex].workedFrom=true;techniciansErrors[index].info[infoIndex].workedTo=true;}if(info.workedFrom&&!info.workedTo){_this.prepareBaseForErrorsTechMoreInfo(techniciansErrors,index,infoIndex);techniciansErrors[index].info[infoIndex].hoursAmount=false;techniciansErrors[index].info[infoIndex].workedFrom=false;techniciansErrors[index].info[infoIndex].workedTo=true;}if(info.workedTo&&!info.workedFrom){_this.prepareBaseForErrorsTechMoreInfo(techniciansErrors,index,infoIndex);techniciansErrors[index].info[infoIndex].hoursAmount=false;techniciansErrors[index].info[infoIndex].workedFrom=true;techniciansErrors[index].info[infoIndex].workedTo=false;}if(!info.presetTasks.length&&!info.customTask){_this.prepareBaseForErrorsTechMoreInfo(techniciansErrors,index,infoIndex);techniciansErrors[index].info[infoIndex].presetTasks=true;techniciansErrors[index].info[infoIndex].customTask=true;}});}});if(techniciansErrors.length>0){errors.technicians=techniciansErrors;}}}return errors;},_this.getContribFormData=function(){var _this$props9=_this.props,contributorsForm=_this$props9.contributorsForm,activeEntryId=_this$props9.activeEntryId;if(activeEntryId&&contributorsForm[activeEntryId]){return contributorsForm[activeEntryId];}return null;},_this.nextContrib=function(){var _this$props10=_this.props,dispatch=_this$props10.dispatch,activeContributor=_this$props10.activeContributor,contributors=_this$props10.contributors,currentDailyReport=_this$props10.currentDailyReport,activeEntryId=_this$props10.activeEntryId;var isSub=_this.isSubDailyReport();var errors=_this.getErrors();if(!isSub&&errors&&Object.keys(errors).length>0&&currentDailyReport.status!=='draft'){_this.setState({errors:Object.assign({},errors)});}else{if(isSub){_this.submitTradeFormForSub().then(function(response){if(response.ok&&activeContributor<contributors.length){var contribFormData=_this.getContribFormData();var techesValues=[];var indexTech=0;contribFormData.technicians.forEach(function(tech){var additionalInfoRes=[];var resTech=Object.assign({},tech,{id:response.dailyReport.sub_daily_report_teches[indexTech].id});indexTech++;if(tech.additionalInfo&&tech.additionalInfo.length){resTech.additionalInfo.forEach(function(info){var resInfo=Object.assign({},info,{id:response.dailyReport.sub_daily_report_teches[indexTech].id});indexTech++;additionalInfoRes.push(resInfo);});resTech.additionalInfo=additionalInfoRes;}techesValues.push(resTech);});dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["M" /* setActiveContributor */])(+activeContributor+1));var sortedEntries=[].concat(_toConsumableArray(currentDailyReport.sub_daily_report_entries)).sort(function(a,b){return!!a.sub_daily_report_entry_id-!!b.sub_daily_report_entry_id;});var currentIndex=sortedEntries.findIndex(function(value){return value.id===activeEntryId;});dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["h" /* changeAmountOfTechnicians */])(techesValues,currentDailyReport.sub_daily_report_entries[currentIndex].id));if(currentIndex>=0&&currentDailyReport.sub_daily_report_entries[currentIndex+1]){dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["N" /* setActiveEntriesId */])(sortedEntries[currentIndex+1].id));}}});}else{_this.submitTradeForm().then(function(response){if(response.ok&&activeContributor<contributors.length){dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["M" /* setActiveContributor */])(+activeContributor+1));var sortedEntries=[].concat(_toConsumableArray(currentDailyReport.daily_report_entries)).sort(function(a,b){return!!a.daily_report_entry_id-!!b.daily_report_entry_id;});var currentIndex=sortedEntries.findIndex(function(value){return value.id===activeEntryId;});if(currentIndex>=0&&sortedEntries[currentIndex+1]){dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["N" /* setActiveEntriesId */])(sortedEntries[currentIndex+1].id));}}});}}},_this.prevContribOrList=function(){var _this$props11=_this.props,dispatch=_this$props11.dispatch,activeContributor=_this$props11.activeContributor,showReviewForm=_this$props11.showReviewForm,currentDailyReport=_this$props11.currentDailyReport,activeEntryId=_this$props11.activeEntryId,generalContactorName=_this$props11.generalContactorName;var isSub=_this.isSubDailyReport();dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["M" /* setActiveContributor */])(+activeContributor-1));var sortedEntries=void 0;if(isSub){sortedEntries=[].concat(_toConsumableArray(currentDailyReport.sub_daily_report_entries)).sort(function(a,b){return!!a.sub_daily_report_entry_id-!!b.sub_daily_report_entry_id;});}else{sortedEntries=[].concat(_toConsumableArray(currentDailyReport.daily_report_entries)).sort(function(a,b){return!!a.daily_report_entry_id-!!b.daily_report_entry_id;});}var currentIndex=sortedEntries.findIndex(function(value){return value.id===activeEntryId;});if(currentIndex>=0){var index=currentIndex===0?0:currentIndex-1;dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["N" /* setActiveEntriesId */])(sortedEntries[index].id));if(currentIndex===0&&generalContactorName){dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_1" /* setMemberForm */])(true));}}if(showReviewForm){dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_9" /* setReviewFormAction */])(false));}},_this.generateTitle=function(){var _this$props12=_this.props,activeContributor=_this$props12.activeContributor,showReviewForm=_this$props12.showReviewForm,currentProject=_this$props12.currentProject,isSubmitted=_this$props12.isSubmitted,currentDailyReport=_this$props12.currentDailyReport,activeEntryId=_this$props12.activeEntryId,contributors=_this$props12.contributors,memberForm=_this$props12.memberForm,currentUser=_this$props12.currentUser,reportDate=_this$props12.reportDate;if(memberForm){return'Staff On Site';}if(isSubmitted){return currentProject.name;}if(showReviewForm){var editReportDate=__WEBPACK_IMPORTED_MODULE_32_services_utils_users_util__["g" /* usersUtil */].isAdmin(currentUser)||__WEBPACK_IMPORTED_MODULE_32_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_32_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);if(editReportDate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-dateselect-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'report-dateselect-label'},'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:__WEBPACK_IMPORTED_MODULE_5_services_utils_date_util__["j" /* sameOrBeforeTodayValidation */],value:reportDate,placeholder:'Check date...',onChange:_this.updateReportDate}));}else{return'Daily Report '+__WEBPACK_IMPORTED_MODULE_4_moment___default()(currentDailyReport.report_date).format('MM/DD/YYYY');}}if(!activeContributor){return'Add Daily Report';}else{var contrib=void 0;if(currentDailyReport.daily_report_entries){contrib=currentDailyReport.daily_report_entries.find(function(entry){return entry.id===activeEntryId;});}if(currentDailyReport.sub_daily_report_entries){contrib=currentDailyReport.sub_daily_report_entries.find(function(entry){return entry.id===activeEntryId;});}if(contrib&&contrib.project_contributor){return __WEBPACK_IMPORTED_MODULE_6_services_utils_daily_report_util__["a" /* DailyReportUtil */].tradeLabel(contrib.project_contributor);}else{contrib=contributors[activeContributor-1];return''+contrib[1];}}},_this.spackleOrGc=function(){var currentProject=_this.props.currentProject;return __WEBPACK_IMPORTED_MODULE_31_domain_enterprise__["a" /* Enterprise */].spackleOrGc(currentProject.contributor_type);},_this.generalContractor=function(){var currentProject=_this.props.currentProject;return __WEBPACK_IMPORTED_MODULE_31_domain_enterprise__["a" /* Enterprise */].generalContractor(currentProject.contributor_type);},_this.subcontractor=function(){var currentProject=_this.props.currentProject;return __WEBPACK_IMPORTED_MODULE_31_domain_enterprise__["a" /* Enterprise */].subcontractor(currentProject.contributor_type);},_this.submitTradeFormForSub=function(isChildFloor,isDraft){var _this$props13=_this.props,activeContributor=_this$props13.activeContributor,contributors=_this$props13.contributors,contributorsForm=_this$props13.contributorsForm,activeEntryId=_this$props13.activeEntryId,dispatch=_this$props13.dispatch,editMode=_this$props13.editMode,projectId=_this$props13.projectId,currentDailyReport=_this$props13.currentDailyReport;var errors=_this.getErrorsForSub();if(errors&&Object.keys(errors).length&&!isDraft&&(currentDailyReport.status!=='draft'||_this.state.submitFailed)){_this.setState({errors:Object.assign({},errors)});return;}var isThelastContributor=false;if(activeContributor){isThelastContributor=+activeContributor===contributors.length;}if(activeEntryId){var currentTrade=contributorsForm[activeEntryId];var value={};value.floor=currentTrade.floor||'';value.area=currentTrade.area||'';if(currentTrade.isDelay){value.project_open_item_attributes={id:currentTrade.openItemId,assignee_id:currentTrade.openItemAssigneeId||'',recipient_ids:currentTrade.openItemRecipients&&currentTrade.openItemRecipients.map(function(rcpt){return rcpt[0];}),description:currentTrade.openItemDesc||'',resolve_by:currentTrade.openItemResolveBy||'',critical:!!currentTrade.openItemCritical,images_attributes:currentTrade.openItemImages&&currentTrade.openItemImages.filter(function(img){return!!img.file;}),deleted_images_attributes:currentTrade.openItemDeletedImages&&currentTrade.openItemDeletedImages.filter(function(img){return!!img.id;}),documents_attributes:currentTrade.openItemDocuments&&currentTrade.openItemDocuments.filter(function(doc){return!!doc.file;}),deleted_documents_attributes:currentTrade.openItemDeletedDocuments&&currentTrade.openItemDeletedDocuments.filter(function(doc){return!!doc.id;})};}else if(currentTrade.openItemId){value.project_open_item_attributes={id:currentTrade.openItemId,_destroy:true};}if(currentTrade.isFieldWorkOrder){value.field_work_order_attributes={id:currentTrade.fwoId||'',number:currentTrade.fwoNumber||'',preset_task_ids:currentTrade.fwoPresetTasks&&currentTrade.fwoPresetTasks.length>0?currentTrade.fwoPresetTasks.map(function(task){return task[0];}):[],preset_task_other:currentTrade.fwoCustomTask||'',work_performed:currentTrade.fwoWorkPerformed||'',comments:currentTrade.fwoComments||'',start_date:currentTrade.fwoStartDate||'',completion_date:currentTrade.fwoCompletionDate||'',labor:currentTrade.fwoLabor||'',materials:currentTrade.fwoMaterials||''};}else if(currentTrade.fwoId){value.field_work_order_attributes={id:currentTrade.fwoId,_destroy:true};}var resultTechnicians=[];currentTrade.technicians.forEach(function(technician){var newTechnician=Object.assign({},technician);resultTechnicians.push(newTechnician);if(newTechnician.additionalInfo&&newTechnician.additionalInfo.length){newTechnician.additionalInfo.forEach(function(info){var newInfo=Object.assign({},info);if(newTechnician.sub_technician){newInfo.sub_technician=newTechnician.sub_technician;}newInfo.tech=newTechnician.tech;resultTechnicians.push(newInfo);});}});value.technicians_attributes=resultTechnicians.map(function(technician){var techValue={hours_worked:technician.hoursAmount||'',started_at:Object(__WEBPACK_IMPORTED_MODULE_5_services_utils_date_util__["l" /* utcTime */])(technician.workedFrom)||'',ended_at:Object(__WEBPACK_IMPORTED_MODULE_5_services_utils_date_util__["l" /* utcTime */])(technician.workedTo)||'',location:technician.location||'',custom_task:technician.customTask||'',work_performed:technician.workPerformed||'',preset_task_ids:technician.presetTasks&&technician.presetTasks.length>0?technician.presetTasks.map(function(task){return task[0];}):''};if(technician.id){techValue.id=technician.id;}if(technician.sub_technician){techValue.sub_technician_id=technician.sub_technician.value;}techValue.tech_number=technician.tech.value;return techValue;});value.deletedTechnicians=currentTrade.deletedTechnicians;value.images_attributes=currentTrade.images&&currentTrade.images.filter(function(img){return!!img.file;});value.deleted_images_attributes=currentTrade.deletedImages&&currentTrade.deletedImages.filter(function(img){return!!img.id;});_this.removeErrorsForSub();return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["b" /* addDailyReportEntries */])(value,activeEntryId,currentTrade.images,isThelastContributor,editMode,projectId,_this.isSubDailyReport(),isChildFloor,isDraft));}},_this.submitTradeForm=function(){var isChildFloor=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var isDraft=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var _this$props14=_this.props,activeContributor=_this$props14.activeContributor,contributors=_this$props14.contributors,contributorsForm=_this$props14.contributorsForm,activeEntryId=_this$props14.activeEntryId,dispatch=_this$props14.dispatch,editMode=_this$props14.editMode,projectId=_this$props14.projectId,currentDailyReport=_this$props14.currentDailyReport;if(_this.isSubDailyReport()){return _this.submitTradeFormForSub(isChildFloor,isDraft);}var errors=_this.getErrors();if(errors&&Object.keys(errors).length>0&&!isDraft&&(currentDailyReport.status!=='draft'||_this.state.submitFailed)){_this.setState({errors:Object.assign({},errors)});return;}var isThelastContributor=false;if(activeContributor){isThelastContributor=+activeContributor===contributors.length;}if(activeEntryId){var currentTrade=contributorsForm[activeEntryId];var value={};value.preset_task_other=currentTrade.customTask||'';value.work_performed=currentTrade.workPerformed||'';value.comments=currentTrade.comments||'';value.floor=currentTrade.floor||'';value.area=currentTrade.area||'';if(currentTrade.isDelay){value.project_open_item_attributes={id:currentTrade.openItemId,assignee_id:currentTrade.openItemAssigneeId||'',recipient_ids:currentTrade.openItemRecipients&&currentTrade.openItemRecipients.map(function(rcpt){return rcpt[0];}),description:currentTrade.openItemDesc||'',resolve_by:currentTrade.openItemResolveBy||'',critical:!!currentTrade.openItemCritical,images_attributes:currentTrade.openItemImages&&currentTrade.openItemImages.filter(function(img){return!!img.file;}),deleted_images_attributes:currentTrade.openItemDeletedImages&&currentTrade.openItemDeletedImages.filter(function(img){return!!img.id;}),documents_attributes:currentTrade.openItemDocuments&&currentTrade.openItemDocuments.filter(function(doc){return!!doc.file;}),deleted_documents_attributes:currentTrade.openItemDeletedDocuments&&currentTrade.openItemDeletedDocuments.filter(function(doc){return!!doc.id;})};}else if(currentTrade.openItemId){value.project_open_item_attributes={id:currentTrade.openItemId,_destroy:true};}value.deletedTechnicians=currentTrade.deletedTechnicians;value.technicians_attributes=currentTrade.technicians.map(function(technician){var techValue={hours_worked:technician.hoursAmount||'',started_at:Object(__WEBPACK_IMPORTED_MODULE_5_services_utils_date_util__["l" /* utcTime */])(technician.workedFrom)||'',ended_at:Object(__WEBPACK_IMPORTED_MODULE_5_services_utils_date_util__["l" /* utcTime */])(technician.workedTo)||''};if(technician.id){techValue.id=technician.id;}return techValue;});value.preset_task_ids=currentTrade.presetTasks&&currentTrade.presetTasks.length>0?currentTrade.presetTasks.map(function(task){return task[0];}):'';value.images_attributes=currentTrade.images&&currentTrade.images.filter(function(img){return!!img.file;});value.deleted_images_attributes=currentTrade.deletedImages&&currentTrade.deletedImages.filter(function(img){return!!img.id;});return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["b" /* addDailyReportEntries */])(value,activeEntryId,currentTrade.images,isThelastContributor,editMode,projectId,false,isChildFloor,isDraft));}},_this.renderDateInput=function(){var _this$props15=_this.props,activeContributor=_this$props15.activeContributor,showReviewForm=_this$props15.showReviewForm,isSubmitted=_this$props15.isSubmitted,reportDate=_this$props15.reportDate;if(!activeContributor&&!showReviewForm&&!isSubmitted){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-dateselect-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'report-dateselect-label'},'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:__WEBPACK_IMPORTED_MODULE_5_services_utils_date_util__["j" /* sameOrBeforeTodayValidation */],value:reportDate,placeholder:'Check date...',onChange:_this.handleDateChange}));}},_this.renderTradesForm=function(){var errors=_this.state.errors;var _this$props16=_this.props,directory=_this$props16.directory,activeContributor=_this$props16.activeContributor,contributors=_this$props16.contributors,showReviewForm=_this$props16.showReviewForm,isSubmitted=_this$props16.isSubmitted,generalContactorName=_this$props16.generalContactorName,currentUser=_this$props16.currentUser,currentProject=_this$props16.currentProject;var contributorsList=[];if(directory&&directory.project_contributors){contributorsList=directory.project_contributors.filter(function(contrib){if(__WEBPACK_IMPORTED_MODULE_31_domain_enterprise__["a" /* Enterprise */].subcontractor(currentProject.contributor_type)){return!!contrib.csi_code&&contrib.company_id===currentUser.accountable_id;}return!!contrib.csi_code;}).sort(function(contrib1,contrib2){return contrib1.csi_code.division<contrib2.csi_code.division?-1:1;}).map(function(contrib){return{id:contrib.id,label:__WEBPACK_IMPORTED_MODULE_6_services_utils_daily_report_util__["a" /* DailyReportUtil */].tradeLabel(contrib)};});}var values=[].concat(_toConsumableArray(contributors));if(generalContactorName){values.unshift(generalContactorName);}var GeneralContractorName={id:0,label:_this.getGeneralContactorLabel()};if(!__WEBPACK_IMPORTED_MODULE_31_domain_enterprise__["a" /* Enterprise */].subcontractor(currentProject.contributor_type)){contributorsList.unshift(GeneralContractorName);}if(!activeContributor&&!showReviewForm&&!isSubmitted){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-multiselect-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'report-multiselect-label'},'Trades'),directory&&directory.project_contributors&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'report-multiselect':true,'report-error-field':errors.contributorsField})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_dropdown_MultipleDropdown__["a" /* default */],{dropdownClassName:'alternate-dropdown-control',options:contributorsList,currentValues:values,placeholder:'Select trades...',onChange:function onChange(values){return _this.handleContributorsChange(values);}})));}},_this.renderSingleTradeForm=function(){var _this$props17=_this.props,activeContributor=_this$props17.activeContributor,showReviewForm=_this$props17.showReviewForm,isSubmitted=_this$props17.isSubmitted,currentDailyReport=_this$props17.currentDailyReport;var showForm=activeContributor&&!showReviewForm&&!isSubmitted;var subDailyReport=_this.isSubDailyReport();if(showForm){if(!subDailyReport){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_daily_report_log_SingleTradeForm__["a" /* default */],{errors:_this.state.errors,removeErrors:_this.removeErrors,submitFailedErrors:_this.submitFailedTradeFormErrors,currentDailyReport:currentDailyReport});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_daily_report_log_SingleTradeFormForSub__["a" /* default */],{errors:_this.state.errors,submitFailedErrors:_this.submitFailedTradeFormErrors});}}},_this.renderReviewForm=function(){var _this$props18=_this.props,showReviewForm=_this$props18.showReviewForm,isSubmitted=_this$props18.isSubmitted,projectId=_this$props18.projectId,currentDailyReport=_this$props18.currentDailyReport,dispatch=_this$props18.dispatch,readOnly=_this$props18.readOnly,reportExtraInputs=_this$props18.reportExtraInputs;if(showReviewForm&&!isSubmitted&&currentDailyReport){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_daily_report_log_ReviewForm__["a" /* default */],{projectId:projectId,currentDailyReport:currentDailyReport,dispatch:dispatch,readOnly:readOnly,reviewErrors:_this.state.reviewErrors,errorsForStaff:_this.state.errorsForStaff,errorsForOpenItem:_this.state.errorsForOpenItem,clearReviewErrors:_this.clearReviewErrors,reportExtraInputs:reportExtraInputs,handleExtraInputChange:_this.handleExtraInputChange,generalContactorLabel:_this.getGeneralContactorLabel(),clearErrorOnStaff:_this.clearErrorOnStaff,clearErrorOnOpenItem:_this.clearErrorOnOpenItem,isSub:_this.isSubDailyReport()});}},_this.renderCongratsView=function(){var _this$props19=_this.props,isSubmitted=_this$props19.isSubmitted,currentDailyReport=_this$props19.currentDailyReport;if(isSubmitted){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'reports-modal-success-message'},'Daily Report #',currentDailyReport.number,' has been submitted!');}},_this.updateDailyReport=function(attrs){var _this$props20=_this.props,dispatch=_this$props20.dispatch,currentDailyReport=_this$props20.currentDailyReport,projectId=_this$props20.projectId,reportExtraInputs=_this$props20.reportExtraInputs;if(currentDailyReport.id&&projectId){var values=Object.assign({},reportExtraInputs,{status:attrs.status});return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["j" /* dailyReportFinaleUpdate */])(projectId,currentDailyReport.id,values,currentDailyReport.status,_this.isSubDailyReport()));}},_this.isThereErrorsOnOpenItem=function(openItem){return!!openItem&&(!openItem.assignee_id||!openItem.resolve_by||!openItem.description);},_this.isThereErrorsOnFieldWorkOrder=function(fieldWorkOrder){return!!fieldWorkOrder&&(!fieldWorkOrder.number||!fieldWorkOrder.work_performed||!fieldWorkOrder.labor||(!fieldWorkOrder.preset_tasks||!fieldWorkOrder.preset_tasks.length)&&!fieldWorkOrder.preset_task_other);},_this.isThereErrorOnReview=function(){var daily_report_entries=_this.props.currentDailyReport.daily_report_entries;var is_safety_accepted=_this.props.reportExtraInputs.is_safety_accepted;var settings=_this.props.settings;if(daily_report_entries&&daily_report_entries.length>0){var reviewErrors=[];daily_report_entries.forEach(function(report){if(_this.isSubDailyReport()){if(!report.floor&&settings&&settings.multiple_floors||report.sub_daily_report_teches.length===0||report.sub_daily_report_teches.some(function(tech){return!tech.hours_worked||tech.preset_tasks.length===0&&!tech.preset_task_other;})||_this.isThereErrorsOnOpenItem(report.project_open_item)||_this.isThereErrorsOnFieldWorkOrder(report.field_work_order)){reviewErrors.push(report.id);}}else{if(!report.floor&&settings&&settings.multiple_floors||!report.work_performed||report.technicians.length===0||report.technicians.some(function(tech){return!tech.hours_worked;})||_this.isThereErrorsOnOpenItem(report.project_open_item)){reviewErrors.push(report.id);}}});if(!_this.isSubDailyReport()&&!is_safety_accepted){reviewErrors.push(_this.props.currentDailyReport.id);}if(reviewErrors.length>0){_this.setState({reviewErrors:reviewErrors});return reviewErrors;}}else{if(!_this.isSubDailyReport()&&!is_safety_accepted){var _reviewErrors=[];_reviewErrors.push(_this.props.currentDailyReport.id);_this.setState({reviewErrors:_reviewErrors});return _reviewErrors;}}},_this.isThereErrorOnStaff=function(){var isThereErrors=_this.getErrorsForMembers(true).length>0;_this.setState({errorsForStaff:isThereErrors});return isThereErrors;},_this.clearErrorOnStaff=function(){_this.setState({errorsForStaff:false});},_this.setErrorsForOpenItem=function(){var project_open_item=_this.props.currentDailyReport.project_open_item;var isThereErrors=_this.isThereErrorsOnOpenItem(project_open_item);_this.setState({errorsForOpenItem:isThereErrors});return isThereErrors;},_this.clearErrorOnOpenItem=function(){_this.setState({errorsForOpenItem:false});},_this.submitReviewForm=function(event,status){var gc_staff_on_site=_this.props.currentDailyReport.gc_staff_on_site;var reviewErrors=_this.isThereErrorOnReview();var staffErrors=gc_staff_on_site&&_this.isThereErrorOnStaff();var openItemErrors=_this.setErrorsForOpenItem();var statusRes=status||'submitted';if(!reviewErrors&&!staffErrors&&!openItemErrors){_this.updateDailyReport({status:statusRes}).then(function(response){if(response.ok&&!_this.props.isSubmitted){_this.handleClose();}});}else{_this.setState({submitFailed:true});}},_this.updateReportDate=function(newReportDate){var _this$props21=_this.props,contributors=_this$props21.contributors,projectId=_this$props21.projectId,currentDailyReport=_this$props21.currentDailyReport,dispatch=_this$props21.dispatch,editMode=_this$props21.editMode,generalContactorName=_this$props21.generalContactorName;var promise=dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_15" /* updateDailyReport */])(contributors,projectId,currentDailyReport,editMode,newReportDate,generalContactorName,_this.isSubDailyReport()));promise&&promise.then(function(response){if(response.ok){_this.handleClose();}});},_this.onApprove=function(e){_this.submitReviewForm(e,'approved');},_this.handleSaveDraftEntry=function(event){event.persist();var promise=_this.submitTradeForm(false,true);promise&&promise.then(function(response){if(response.ok){_this.handleClose(event);}});},_this.handleSaveDraftReport=function(event){event.persist();var promise=_this.updateDailyReport({status:'draft'});promise&&promise.then(function(response){if(response.ok){_this.handleClose(event);}});},_this.handleSaveDraftReportAndMemberForm=function(event){event.persist();var promise=_this.saveMemberWithDraft();promise&&promise.then(function(response){if(response.ok){_this.handleClose(event);}});},_this.handleAddReportAndClose=function(event){event.persist();var promise=_this.addReport(true);promise&&promise.then(function(response){if(response.ok){_this.handleClose(event);}}).catch(function(error){return console.log(error);});},_this.renderCloseOrDraftButton=function(){var _this$props22=_this.props,showReviewForm=_this$props22.showReviewForm,activeContributor=_this$props22.activeContributor,isSubmitted=_this$props22.isSubmitted,currentDailyReport=_this$props22.currentDailyReport,readOnly=_this$props22.readOnly,editMode=_this$props22.editMode;var showClosed=readOnly||isSubmitted||currentDailyReport&&currentDailyReport.status==='submitted';var handleClick=_this.handleAddReportAndClose;if(showClosed){handleClick=_this.handleClose;}else if(showReviewForm){handleClick=_this.handleSaveDraftReport;}else if(!!activeContributor){handleClick=_this.handleSaveDraftEntry;}if(currentDailyReport&&currentDailyReport.status==='approved'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:'Close',onClick:_this.handleClose});}return!(editMode&&currentDailyReport&&currentDailyReport.status==='submitted')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:showClosed?'Close':'Save Draft',onClick:handleClick});},_this.handleDiscardDraft=function(){_this.setState({showDeleteConfirmation:true});},_this.handleDeleteConfirmation=function(confirmed){_this.setState({showDeleteConfirmation:false});confirmed&&_this.handleDelete();},_this.handleDelete=function(){var _this$props23=_this.props,currentProject=_this$props23.currentProject,currentDailyReport=_this$props23.currentDailyReport,dispatch=_this$props23.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["m" /* deleteReportRequest */])(currentProject.id,currentDailyReport.id,_this.isSubDailyReport())).then(function(response){if(response.ok){_this.handleClose();}});},_this.handleEditTrades=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_9" /* setReviewFormAction */])(false));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["V" /* setEditMode */])(true));},_this.handleShowEmailModal=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_29_components_admin_projects_details_project_email_modal_store_actions__["j" /* setShowEmailModal */])(true));},_this.fromTradesToReview=function(){if(_this.errorsNoTradesAndNoGc()){return;}_this.addReport(true).then(function(response){if(response.ok){var existingContributors=Object.keys(_this.props.contributorsForm);var newContributors=[];if(response.dailyReport.sub_daily_report_entries&&response.dailyReport.sub_daily_report_entries.length){response.dailyReport.sub_daily_report_entries.forEach(function(entry){var entryExist=existingContributors.find(function(contribId){return+contribId===+entry.id;});if(!entryExist){newContributors.push(entry.id);}});}return _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["E" /* loadFullReportsRequest */])(response.dailyReport.project_id,response.dailyReport.id,_this.isSubDailyReport(),newContributors));}return response;}).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_9" /* setReviewFormAction */])(true));}}).catch(function(error){return _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_28_actions_messages__["d" /* showErrorMessage */])(error));});},_this.renderDiscardDraftButton=function(){var _this$props24=_this.props,isSubmitted=_this$props24.isSubmitted,currentDailyReport=_this$props24.currentDailyReport;var showDiscardDraft=!isSubmitted&&!!currentDailyReport&&currentDailyReport.status==='draft';return showDiscardDraft&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-white',label:'Discard Draft',onClick:_this.handleDiscardDraft});},_this.renderEditTradesButton=function(){var _this$props25=_this.props,readOnly=_this$props25.readOnly,showReviewForm=_this$props25.showReviewForm,isSubmitted=_this$props25.isSubmitted,currentDailyReport=_this$props25.currentDailyReport;if(readOnly){return null;}if(showReviewForm&&!isSubmitted&&currentDailyReport.status!=='approved'&&(_this.subcontractor()||_this.spackleOrGc()&&!_this.subTabSelected())){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Trades',onClick:_this.handleEditTrades});}return null;},_this.renderEmailButton=function(){var _this$props26=_this.props,currentDailyReport=_this$props26.currentDailyReport,showReviewForm=_this$props26.showReviewForm;if(currentDailyReport&&(currentDailyReport.status==='submitted'||currentDailyReport.status==='approved')&&showReviewForm&&!_this.isSubDailyReport()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-white',icon:__WEBPACK_IMPORTED_MODULE_7_images_mail_svg___default.a,label:'Email',onClick:_this.handleShowEmailModal});}},_this.renderNextOrConfirmButtons=function(currentEntry){var _this$props27=_this.props,showReviewForm=_this$props27.showReviewForm,activeContributor=_this$props27.activeContributor,contributors=_this$props27.contributors,isSubmitted=_this$props27.isSubmitted,editMode=_this$props27.editMode,readOnly=_this$props27.readOnly,currentDailyReport=_this$props27.currentDailyReport,addFloor=_this$props27.addFloor;if(readOnly){return null;}if(isSubmitted){return null;}if(currentDailyReport&&currentDailyReport.status==='approved'){return null;}if(showReviewForm&&currentDailyReport&&currentDailyReport.status!=='approved'&&(_this.spackleOrGc()&&!_this.subTabSelected()||_this.subcontractor())){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Submit',onClick:_this.submitReviewForm});}if(showReviewForm){return;}var showNextButton=true;var entryId=currentEntry&&(currentEntry.sub_daily_report_entry_id||currentEntry.daily_report_entry_id);if(activeContributor){showNextButton=+activeContributor<contributors.length;}if(showNextButton&&!editMode&&!addFloor){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,activeContributor>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Back',onClick:_this.prevContribOrList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Next',onClick:activeContributor?_this.nextContrib:_this.addReport}));}else{if(addFloor||currentEntry&&entryId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Save floor',onClick:function onClick(){_this.saveFloor(currentEntry);}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Back',onClick:editMode?_this.backTradesAction:_this.prevContribOrList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Review',onClick:activeContributor?function(){return _this.submitTradeForm();}:_this.fromTradesToReview}));}},_this.handleDuplicateModalClose=function(){_this.setState({showDuplicateModal:false});},_this.handleShowDuplicateModal=function(){_this.setState({showDuplicateModal:true});},_this.renderDuplicateButton=function(){var _this$props28=_this.props,currentDailyReport=_this$props28.currentDailyReport,showReviewForm=_this$props28.showReviewForm,isSubmitted=_this$props28.isSubmitted;if(!isSubmitted&&showReviewForm&&currentDailyReport&&currentDailyReport.status!=='draft'&&(_this.isSubDailyReport()&&!_this.generalContractor()||!_this.isSubDailyReport()&&!_this.subcontractor())){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Duplicate',onClick:_this.handleShowDuplicateModal});}},_this.renderApproveButton=function(){var _this$props29=_this.props,currentDailyReport=_this$props29.currentDailyReport,showReviewForm=_this$props29.showReviewForm,isSubmitted=_this$props29.isSubmitted;if(!isSubmitted&&_this.isSubDailyReport()&&_this.spackleOrGc()&&showReviewForm&&currentDailyReport&&currentDailyReport.status!=='approved'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Approve',onClick:_this.onApprove});}},_this.buildEmailModalTitle=function(){var _this$props30=_this.props,currentProject=_this$props30.currentProject,currentDailyReport=_this$props30.currentDailyReport;return'Daily Report #'+currentDailyReport.number+' (Project #'+currentProject.number+': '+currentProject.name+')';},_this.handleSendEmail=function(emailsData){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["L" /* sendDailyReportEmails */])(_this.props.currentDailyReport.id,_this.isSubDailyReport()?'SubDailyReport':'DailyReport',emailsData));},_this.buildEmailModalSubject=function(){var _this$props31=_this.props,currentProject=_this$props31.currentProject,currentDailyReport=_this$props31.currentDailyReport;return currentProject.number+', '+currentProject.name+' - Daily Report #'+currentDailyReport.number;},_this.buildEmailModalMessage=function(){var _this$props32=_this.props,currentProject=_this$props32.currentProject,currentDailyReport=_this$props32.currentDailyReport;return'Please find the attached Daily Report #'+currentDailyReport.number+' for Project '+currentProject.name+'. If you have any questions, please reach out via chat or email.';},_this.saveMemberWithDraft=function(){var _this$props33=_this.props,dispatch=_this$props33.dispatch,projectId=_this$props33.projectId,currentDailyReport=_this$props33.currentDailyReport,members=_this$props33.members,deletedMembers=_this$props33.deletedMembers,reportOpenItem=_this$props33.reportOpenItem,gcImages=_this$props33.gcImages,gcDeletedImages=_this$props33.gcDeletedImages;var errors=_this.getErrorsForSaveDraft();if(errors&&errors.length>0){_this.setState({errorsMemberForm:[].concat(_toConsumableArray(errors))});}else{return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["d" /* addDailyReportMembers */])(projectId,currentDailyReport.id,members,deletedMembers,reportOpenItem,true,false,gcImages,gcDeletedImages));}},_this.saveFloor=function(currentEntry){var dispatch=_this.props.dispatch;var entryId=currentEntry.sub_daily_report_entry_id||currentEntry.daily_report_entry_id;var submitTradeFormPromise=_this.submitTradeForm(entryId);if(submitTradeFormPromise){submitTradeFormPromise.then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["Q" /* setDailyReportAddFloor */])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_9" /* setReviewFormAction */])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["N" /* setActiveEntriesId */])(entryId));}});}},_this.nextMemberAction=function(){var _this$props34=_this.props,dispatch=_this$props34.dispatch,projectId=_this$props34.projectId,currentDailyReport=_this$props34.currentDailyReport,members=_this$props34.members,deletedMembers=_this$props34.deletedMembers,reportOpenItem=_this$props34.reportOpenItem,editMode=_this$props34.editMode,gcImages=_this$props34.gcImages,gcDeletedImages=_this$props34.gcDeletedImages;var errorsMemberForm=_this.getErrorsForMembers(_this.state.submitFailed);var errorsOpenItemForm=_this.getErrorsForOpenItem(_this.state.submitFailed);if(errorsMemberForm&&errorsMemberForm.length>0||errorsOpenItemForm&&Object.keys(errorsOpenItemForm).length>0){_this.setState({errorsMemberForm:[].concat(_toConsumableArray(errorsMemberForm)),errorsOpenItemForm:Object.assign({},errorsOpenItemForm)});}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["d" /* addDailyReportMembers */])(projectId,currentDailyReport.id,members,deletedMembers,reportOpenItem,false,editMode,gcImages,gcDeletedImages));}},_this.backMemberAction=function(){var _this$props35=_this.props,dispatch=_this$props35.dispatch,editMode=_this$props35.editMode;dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_1" /* setMemberForm */])(false));if(editMode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_9" /* setReviewFormAction */])(true));dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["V" /* setEditMode */])(false));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["M" /* setActiveContributor */])(0));}},_this.backTradesAction=function(){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["V" /* setEditMode */])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_9" /* setReviewFormAction */])(true));dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["M" /* setActiveContributor */])(0));},_this.renderMemberButtons=function(){var _this$props36=_this.props,currentDailyReport=_this$props36.currentDailyReport,editMode=_this$props36.editMode,contributors=_this$props36.contributors;var showDraft=currentDailyReport&&currentDailyReport.status==='draft';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,showDraft&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-white',label:'Discard Draft',onClick:_this.handleDiscardDraft}),showDraft&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:'Save Draft',onClick:_this.handleSaveDraftReportAndMemberForm}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Back',onClick:_this.backMemberAction}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:editMode||contributors.length===0?'Review':'Next',onClick:_this.nextMemberAction}));},_this.missingFields=function(){var _this$props37=_this.props,showReviewForm=_this$props37.showReviewForm,activeContributor=_this$props37.activeContributor,memberForm=_this$props37.memberForm;var _this$state=_this.state,reviewErrors=_this$state.reviewErrors,errorsForStaff=_this$state.errorsForStaff,errorsForOpenItem=_this$state.errorsForOpenItem,errors=_this$state.errors,errorsMemberForm=_this$state.errorsMemberForm,errorsOpenItemForm=_this$state.errorsOpenItemForm;return showReviewForm&&!activeContributor&&!memberForm&&(reviewErrors&&reviewErrors.length>0||errorsForStaff||errorsForOpenItem)||!!activeContributor&&errors&&Object.keys(errors).length>0||memberForm&&(errorsMemberForm&&errorsMemberForm.length>0||errorsOpenItemForm&&Object.keys(errorsOpenItemForm).length>0);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddDailyReportModal,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,dispatch=_props.dispatch,currentDailyReport=_props.currentDailyReport;if(currentDailyReport&&currentDailyReport.gc_staff_on_site){dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_components_admin_projects_details_project_daily_report_log_store_actions__["_0" /* setGeneralContractorName */])([0,this.getGeneralContactorLabel()]));}this.loadDirectory();this.loadSettings();}},{key:'isSubDailyReport',value:function isSubDailyReport(){return this.subcontractor()||this.subTabSelected();}},{key:'subTabSelected',value:function subTabSelected(){var dailyReportsTabSelected=this.props.dailyReportsTabSelected;return dailyReportsTabSelected===SubDailyReportTabValue;}},{key:'render',value:function render(){var _props2=this.props,show=_props2.show,memberForm=_props2.memberForm,projectId=_props2.projectId,currentDailyReport=_props2.currentDailyReport,activeEntryId=_props2.activeEntryId;var _state=this.state,showDeleteConfirmation=_state.showDeleteConfirmation,showDuplicateModal=_state.showDuplicateModal,errorsMemberForm=_state.errorsMemberForm,errorsOpenItemForm=_state.errorsOpenItemForm;var currentEntry=void 0;if(currentDailyReport){if(currentDailyReport.daily_report_entries){currentEntry=currentDailyReport.daily_report_entries.find(function(val){return val.id===activeEntryId;});}if(currentDailyReport.sub_daily_report_entries){currentEntry=currentDailyReport.sub_daily_report_entries.find(function(val){return val.id===activeEntryId;});}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_modal_FormModal__["a" /* default */],{id:'daily-report-form-modal',show:show,onClose:this.handleClose,title:this.generateTitle()},memberForm?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_daily_report_log_MemberFormModal__["a" /* default */],{clearErrors:this.clearErrors,projectId:projectId,errors:{errorsMemberForm:errorsMemberForm,errorsOpenItemForm:errorsOpenItemForm},submitFailedErrors:this.submitFailedMembersFormErrors}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderDateInput(),this.renderTradesForm(),this.renderSingleTradeForm(),this.renderReviewForm(),this.renderCongratsView()),this.missingFields()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'error-message'},'There are missing fields, please review.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reports-modal-buttons-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reports-modal-buttons'},memberForm?this.renderMemberButtons():__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderDiscardDraftButton(),this.renderCloseOrDraftButton(),this.renderEmailButton(),this.renderEditTradesButton(),this.renderNextOrConfirmButtons(currentEntry),this.renderDuplicateButton(),this.renderApproveButton()))),showDeleteConfirmation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_modal_ConfirmationModal__["a" /* default */],{show:showDeleteConfirmation,message:'Are you sure you want to discard this Daily Report?',onHide:this.handleDeleteConfirmation}),this.props.showEmailModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_email_modal_ProjectEmailModal__["a" /* default */],{title:this.buildEmailModalTitle(),handleSendEmail:this.handleSendEmail,projectId:this.props.projectId,initialSubject:this.buildEmailModalSubject(),initialMessage:this.buildEmailModalMessage()}),showDuplicateModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_daily_report_log_DuplicateDailyReportModal__["a" /* default */],{showModal:showDuplicateModal,isSubDailyReport:this.isSubDailyReport(),onSubmit:this.handleClose,onClose:this.handleDuplicateModalClose}));}}]);return AddDailyReportModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AddDailyReportModal.propTypes={show:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,projectId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};AddDailyReportModal.defaultProps={show:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{directory:Object(__WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_directory_store_selectors__["c" /* getDirectory */])(state),settings:Object(__WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_project_settings_store_selectors__["a" /* getSettings */])(state),currentUser:Object(__WEBPACK_IMPORTED_MODULE_30_selectors_authentication__["d" /* getCurrentUser */])(state),contributors:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["d" /* getContributors */])(state),contributorsForm:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["e" /* getContributorsForm */])(state),activeContributor:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["a" /* getActiveContributor */])(state),currentDailyReport:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["f" /* getCurrentDailyReport */])(state),showReviewForm:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["K" /* getShowReviewForm */])(state),isSubmitted:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["i" /* getDailyReportIsSubmitted */])(state),currentProject:Object(__WEBPACK_IMPORTED_MODULE_23_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),editMode:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["p" /* getEditMode */])(state),activeEntryId:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["b" /* getActiveEntryId */])(state),showEmailModal:Object(__WEBPACK_IMPORTED_MODULE_21_components_admin_projects_details_project_email_modal_store_selectors__["g" /* getShowEmailModal */])(state),reportDate:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["A" /* getReportDate */])(state),reportExtraInputs:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["B" /* getReportExtraInputs */])(state),generalContactorName:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["w" /* getGeneralContactorName */])(state),memberForm:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["x" /* getMemberForm */])(state),members:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["y" /* getMembers */])(state),deletedMembers:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["n" /* getDeletedMembers */])(state),reportOpenItem:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["C" /* getReportOpenItem */])(state),gcImages:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["v" /* getGCImages */])(state),gcDeletedImages:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["u" /* getGCDeletedImages */])(state),dailyReportsTabSelected:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["m" /* getDailyReportsTabSelected */])(state),addFloor:Object(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_daily_report_log_store_selectors__["c" /* getAddFloor */])(state)};})(AddDailyReportModal));

/***/ }),
/* 2629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_selectors__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_settings_store_selectors__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_store_selectors__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_daily_report_log_ProjectOpenItemForm__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_checkbox_LabeledCheckBox__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_dropdown_MultipleDropdown__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_button_FloorButton__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_shared_time_picker_TimePicker__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_services_utils_files_util__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__SingleTradeForm_css__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__SingleTradeForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__SingleTradeForm_css__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultTechnician={hoursAmount:'',workedFrom:'',workedTo:''};var SingleTradesFormComponent=function(_Component){_inherits(SingleTradesFormComponent,_Component);function SingleTradesFormComponent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SingleTradesFormComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SingleTradesFormComponent.__proto__||Object.getPrototypeOf(SingleTradesFormComponent)).call.apply(_ref,[this].concat(args))),_this),_this.handleDate=function(techId,value,key){var _this$props=_this.props,dispatch=_this$props.dispatch,activeEntryId=_this$props.activeEntryId,removeErrors=_this$props.removeErrors;removeErrors(key,techId,value);if(key==='workedFrom'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["v" /* handleWorkedFrom */])(value,activeEntryId,techId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["w" /* handleWorkedTo */])(value,activeEntryId,techId));}},_this.handleAttributeChange=function(attribute,value){var _this$props2=_this.props,dispatch=_this$props2.dispatch,activeEntryId=_this$props2.activeEntryId,removeErrors=_this$props2.removeErrors;removeErrors(attribute);dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["p" /* handleAttributeChangeAction */])(attribute,value,activeEntryId));},_this.handleHoursAmount=function(techId,value){var _this$props3=_this.props,dispatch=_this$props3.dispatch,activeEntryId=_this$props3.activeEntryId,removeErrors=_this$props3.removeErrors;removeErrors('hoursAmount',techId,value);dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["t" /* handleHoursAmountAction */])(value,activeEntryId,techId));},_this.changeTechnicianAmount=function(action){var _this$props4=_this.props,dispatch=_this$props4.dispatch,activeEntryId=_this$props4.activeEntryId;var contribFormData=_this.getContribFormData();if(contribFormData&&contribFormData.technicians){var newTechnicians=[].concat(_toConsumableArray(contribFormData.technicians));if(action==='add'){newTechnicians.push(defaultTechnician);}else{var deletedTech=newTechnicians.pop(defaultTechnician);if(deletedTech.id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["g" /* addedDeletedTechnicians */])(deletedTech,activeEntryId));}}dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["h" /* changeAmountOfTechnicians */])(newTechnicians,activeEntryId));}},_this.addTechnician=function(){_this.changeTechnicianAmount('add');},_this.removeTechnician=function(){_this.changeTechnicianAmount('remove');},_this.handleAddFloor=function(){var drEntry=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var _this$props5=_this.props,currentDailyReport=_this$props5.currentDailyReport,dispatch=_this$props5.dispatch,activeEntryId=_this$props5.activeEntryId;var presetTasks=[].concat(_toConsumableArray(_this.props.presetTasks));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["Q" /* setDailyReportAddFloor */])(true));if(drEntry){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["N" /* setActiveEntriesId */])(drEntry.id));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["c" /* addDailyReportEntriesFloor */])(activeEntryId,currentDailyReport));}dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["G" /* loadPresetTasksSuccess */])(presetTasks));Object(__WEBPACK_IMPORTED_MODULE_17_services_utils_scroller_util__["a" /* containerScrollToTop */])('daily-report-form-modal');},_this.handleDeleteFloorClick=function(e){var _this$props6=_this.props,dispatch=_this$props6.dispatch,activeEntryId=_this$props6.activeEntryId,currentDailyReport=_this$props6.currentDailyReport,contributorsForm=_this$props6.contributorsForm;var currentEntry=currentDailyReport.daily_report_entries.find(function(val){return val.id===activeEntryId;});var filteredForm=Object.entries(contributorsForm).filter(function(_ref2){var _ref3=_slicedToArray(_ref2,2),key=_ref3[0],value=_ref3[1];return value.id!==activeEntryId;});var newForm={};filteredForm.forEach(function(_ref4){var _ref5=_slicedToArray(_ref4,2),key=_ref5[0],val=_ref5[1];newForm[key]={workPerformed:val.workPerformed,floor:val.floor,area:val.area,comments:val.comments,presetTasks:val.presetTasks,customTask:val.customTask,images:val.images,technicians:val.technicians,deletedImages:val.deletedImages,deletedTechnicians:val.deletedTechnicians};});dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["N" /* setActiveEntriesId */])(currentEntry['daily_report_entry_id']));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["k" /* deleteDailyReportEntry */])(activeEntryId,currentDailyReport));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["_17" /* updateTradeForm */])(newForm));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["Q" /* setDailyReportAddFloor */])(false));},_this.duplicateTechnician=function(){var contribFormData=_this.getContribFormData();if(contribFormData&&contribFormData.technicians){var tech=contribFormData.technicians[contribFormData.technicians.length-1];if(tech){var newTechnicians=[].concat(_toConsumableArray(contribFormData.technicians));for(var i=1;i<contribFormData.techCount;i++){newTechnicians.push(Object.assign({},tech,{id:''}));}_this.handleAttributeChange('duplicateTech',false);_this.handleAttributeChange('technicians',newTechnicians);}}},_this.isTheLastTechnician=function(){var contribFormData=_this.getContribFormData();return contribFormData&&contribFormData.technicians&&contribFormData.technicians.length===1;},_this.setImages=function(attribute,files){var images=[].concat(_toConsumableArray(_this.getImages()));files.forEach(function(val){images.push({url:URL.createObjectURL(val),file:val});});_this.handleAttributeChange(attribute,images);},_this.removeImages=function(attribute,index){var images=[].concat(_toConsumableArray(_this.getImages()));var deletedImages=[].concat(_toConsumableArray(_this.getDeletedImages()));var deletedImage=images.splice(index,1);deletedImages.push(deletedImage[0]);_this.handleAttributeChange(attribute,images);_this.handleAttributeChange('deletedImages',deletedImages);},_this.getImages=function(){var contribFormData=_this.getContribFormData();if(contribFormData&&contribFormData.images&&contribFormData.images.length>0){return contribFormData.images;}return[];},_this.getDeletedImages=function(){var contribFormData=_this.getContribFormData();if(contribFormData&&contribFormData.deletedImages&&contribFormData.deletedImages.length>0){return contribFormData.deletedImages;}return[];},_this.loadPresetTasks=function(){var _this$props7=_this.props,dispatch=_this$props7.dispatch,activeContributor=_this$props7.activeContributor,contributors=_this$props7.contributors,directory=_this$props7.directory;if(contributors.length>0){var contributor=directory.project_contributors.find(function(contrib){return contrib.id===contributors[activeContributor-1][0];});dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["F" /* loadPresetTasksRequest */])(contributor.csi_code.id));}},_this.getContribFormData=function(){var _this$props8=_this.props,contributorsForm=_this$props8.contributorsForm,activeEntryId=_this$props8.activeEntryId;if(activeEntryId&&contributorsForm[activeEntryId]){return contributorsForm[activeEntryId];}return null;},_this.isErrorForHoursAmount=function(index){var errors=_this.props.errors;if(errors.technicians&&errors.technicians[index]&&errors.technicians[index].error){if(errors.technicians[index].workedFrom||errors.technicians[index].workedTo){return false;}return true;}},_this.isErrorForWorkDate=function(index,key){var errors=_this.props.errors;return errors.technicians&&errors.technicians[index]&&errors.technicians[index].error&&!errors.technicians[index][key];},_this.validTechCount=function(){var contribFormData=_this.getContribFormData();return!!contribFormData&&!!contribFormData.techCount&&contribFormData.techCount>0&&contribFormData.techCount<100;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SingleTradesFormComponent,[{key:'componentDidMount',value:function componentDidMount(){var submitFailedErrors=this.props.submitFailedErrors;this.loadPresetTasks();if(submitFailedErrors){submitFailedErrors();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.activeEntryId!==this.props.activeEntryId){this.loadPresetTasks();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var dispatch=this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["Q" /* setDailyReportAddFloor */])(false));}},{key:'render',value:function render(){var _this2=this;var _props=this.props,activeContributor=_props.activeContributor,activeEntryId=_props.activeEntryId,presetTasks=_props.presetTasks,errors=_props.errors,addFloor=_props.addFloor,currentDailyReport=_props.currentDailyReport,settings=_props.settings;var contribFormData=this.getContribFormData();var currentEntry=currentDailyReport.daily_report_entries.find(function(val){return val.id===activeEntryId;});var childFloors=currentDailyReport.daily_report_entries.filter(function(val){return val.daily_report_entry_id===activeEntryId;});var isChildrenFloor=currentEntry&&currentEntry.daily_report_entry_id;var presetTaskList=[];if(presetTasks&&presetTasks.length>0){presetTaskList=presetTasks.map(function(task){return{id:task.id,label:task.label};});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,contribFormData?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-wrapper'},settings&&settings.multiple_floors&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block floor-area-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Floor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'single-trade-form-error-field':errors.floor}),onChange:this.handleAttributeChange.bind(null,'floor'),value:''+(contribFormData.floor||'')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block floor-area-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{onChange:this.handleAttributeChange.bind(null,'area'),value:''+(contribFormData.area||'')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-tech-wrapper'},contribFormData.technicians&&contribFormData.technicians.map(function(technician,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-tech-block',key:''+activeContributor+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Technician ',+index+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{type:'number',className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'single-trade-form-input':true,'single-trade-form-error-field':_this2.isErrorForHoursAmount(index)}),onChange:function onChange(value){return _this2.handleHoursAmount(index,value);},value:technician.hoursAmount,placeholder:'Hours'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'single-trade-form-separate-text'},'or'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_time_picker_TimePicker__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'single-trade-form-error-field':_this2.isErrorForWorkDate(index,'workedFrom')}),placeholder:'Worked from',onChange:function onChange(value){return _this2.handleDate(index,value,'workedFrom');},value:technician.workedFrom}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_time_picker_TimePicker__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'single-trade-form-error-field':_this2.isErrorForWorkDate(index,'workedTo')}),placeholder:'Worked to',onChange:function onChange(value){return _this2.handleDate(index,value,'workedTo');},value:technician.workedTo}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-tech-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-dup-tech-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Duplicate Tech?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{onChange:this.handleAttributeChange.bind(null,'duplicateTech'),checked:contribFormData.duplicateTech})),!contribFormData.duplicateTech?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tech-actions-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'+ Add technician',onClick:this.addTechnician}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__["a" /* default */],{disabled:this.isTheLastTechnician(),className:'button-orange delete-button',label:'- Delete technician',onClick:this.removeTechnician})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tech-actions-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{className:'tech-count',placeholder:'How many?',type:'number',onChange:this.handleAttributeChange.bind(null,'techCount'),value:contribFormData.techCount}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__["a" /* default */],{disabled:!this.validTechCount(),className:'button-orange',label:'+ Duplicate Technician',onClick:this.duplicateTechnician})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-multiselect-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Preset Tasks'),presetTasks&&presetTasks.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-multiselect'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_dropdown_MultipleDropdown__["a" /* default */],{dropdownClassName:'alternate-dropdown-control',options:presetTaskList,currentValues:contribFormData.presetTasks||[],placeholder:'Select tasks...',onChange:function onChange(values){return _this2.handleAttributeChange('presetTasks',values);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block custom-task-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Custom Task'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{onChange:this.handleAttributeChange.bind(null,'customTask'),value:contribFormData.customTask})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Work performed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_TextArea__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'single-trade-form-error-field':errors.workPerformed}),onChange:this.handleAttributeChange.bind(null,'workPerformed'),value:contribFormData.workPerformed||''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Comments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_TextArea__["a" /* default */],{onChange:this.handleAttributeChange.bind(null,'comments'),value:contribFormData.comments||''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:__WEBPACK_IMPORTED_MODULE_16_services_utils_files_util__["a" /* imageExtensions */],multiple:true,onUpload:function onUpload(files){return _this2.setImages('images',files);},onRemove:function onRemove(index){return _this2.removeImages('images',index);},images:this.getImages()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label single-trade-form-label-open-item-q'},'Is there an Open Item to report?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{onChange:this.handleAttributeChange.bind(null,'isDelay'),checked:contribFormData.isDelay})),contribFormData.isDelay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_daily_report_log_ProjectOpenItemForm__["a" /* default */],{form:contribFormData,errors:errors,handleAttributeChange:this.handleAttributeChange}),childFloors&&!!childFloors.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block single-trade-form-floors'},childFloors.map(function(drEntry){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-floor',key:drEntry.id,onClick:function onClick(){return _this2.handleAddFloor(drEntry);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,!!drEntry.floor&&'Floor '+drEntry.floor,!!drEntry.floor&&!!drEntry.area&&' - ',!!drEntry.area&&drEntry.area,!drEntry.floor&&!drEntry.area&&'Draft Floor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'>'));})),settings&&settings.multiple_floors&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block'},addFloor||isChildrenFloor?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_button_FloorButton__["a" /* default */],{isForAdd:false,onClick:this.handleDeleteFloorClick}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_button_FloorButton__["a" /* default */],{isForAdd:true,onClick:this.handleAddFloor}))):null);}}]);return SingleTradesFormComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{directory:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_selectors__["c" /* getDirectory */])(state),settings:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_settings_store_selectors__["a" /* getSettings */])(state),contributorsForm:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_store_selectors__["e" /* getContributorsForm */])(state),presetTasks:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_store_selectors__["z" /* getPresetTasks */])(state),activeContributor:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_store_selectors__["a" /* getActiveContributor */])(state),contributors:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_store_selectors__["d" /* getContributors */])(state),activeEntryId:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_store_selectors__["b" /* getActiveEntryId */])(state),addFloor:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_store_selectors__["c" /* getAddFloor */])(state)};})(SingleTradesFormComponent));

/***/ }),
/* 2630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_selectors__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_settings_store_selectors__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_store_selectors__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_daily_report_log_ProjectOpenItemForm__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_dropdown_SearchableDropDownPaginated__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_checkbox_LabeledCheckBox__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_button_FloorButton__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_time_picker_TimePicker__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_shared_dropdown_MultipleDropdown__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_services_utils_files_util__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_actions_admin_team_contractor_team__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_selectors_admin_team_contractor_team__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_services_api_sub_technicians_api__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_images_dropdown_arrow_png__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_images_dropdown_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_images_dropdown_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_admin_projects_details_project_daily_report_log_FieldWorkOrderForm__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__SingleTradeForm_css__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__SingleTradeForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__SingleTradeForm_css__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultInfo={hoursAmount:'',workedFrom:'',workedTo:'',location:'',customTask:'',workPerformed:'',presetTasks:[]};var defaultTechnician=Object.assign({},defaultInfo,{tech:{value:1,label:'Technician 1',custom:true},additionalInfo:[]});var SingleTradesFormForSubComponent=function(_Component){_inherits(SingleTradesFormForSubComponent,_Component);function SingleTradesFormForSubComponent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SingleTradesFormForSubComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SingleTradesFormForSubComponent.__proto__||Object.getPrototypeOf(SingleTradesFormForSubComponent)).call.apply(_ref,[this].concat(args))),_this),_this.handleDate=function(techId,value,key,infoIndex){var _this$props=_this.props,dispatch=_this$props.dispatch,activeEntryId=_this$props.activeEntryId;if(key==='workedFrom'){if(infoIndex!==undefined){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["s" /* handleDateMoreInfo */])(value,activeEntryId,techId,key,infoIndex));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["v" /* handleWorkedFrom */])(value,activeEntryId,techId));}}else{if(infoIndex!==undefined){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["s" /* handleDateMoreInfo */])(value,activeEntryId,techId,key,infoIndex));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["w" /* handleWorkedTo */])(value,activeEntryId,techId));}}},_this.handleAttributeChange=function(attribute,value){var _this$props2=_this.props,dispatch=_this$props2.dispatch,activeEntryId=_this$props2.activeEntryId;dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["p" /* handleAttributeChangeAction */])(attribute,value,activeEntryId));},_this.handleHoursAmount=function(techId,value,infoIndex){var _this$props3=_this.props,dispatch=_this$props3.dispatch,activeEntryId=_this$props3.activeEntryId;if(infoIndex!==undefined){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["u" /* handleHoursAmountActionMoreAction */])(value,activeEntryId,techId,infoIndex));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["t" /* handleHoursAmountAction */])(value,activeEntryId,techId));}},_this.changeTechnicianAmount=function(action){var _this$props4=_this.props,dispatch=_this$props4.dispatch,activeEntryId=_this$props4.activeEntryId;var contribFormData=_this.getContribFormData();if(contribFormData&&contribFormData.technicians){var newTechnicians=[].concat(_toConsumableArray(contribFormData.technicians));if(action==='add'){var defaultTechnicianValue=Object.assign({},defaultTechnician,{tech:{value:newTechnicians.length+1,label:'Technician '+(newTechnicians.length+1),custom:true}});newTechnicians.push(defaultTechnicianValue);}else{var deletedTech=newTechnicians.pop();if(deletedTech.additionalInfo&&deletedTech.additionalInfo.length){var deletedTechnicians=[].concat(_toConsumableArray(contribFormData.deletedTechnicians),_toConsumableArray(deletedTech.additionalInfo));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["p" /* handleAttributeChangeAction */])('deletedTechnicians',deletedTechnicians,activeEntryId));}if(deletedTech.id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["g" /* addedDeletedTechnicians */])(deletedTech,activeEntryId));}}dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["h" /* changeAmountOfTechnicians */])(newTechnicians,activeEntryId));}},_this.addTechnician=function(){_this.changeTechnicianAmount('add');},_this.removeTechnician=function(){_this.changeTechnicianAmount('remove');},_this.handleAddFloor=function(){var drEntry=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var _this$props5=_this.props,currentDailyReport=_this$props5.currentDailyReport,dispatch=_this$props5.dispatch,activeEntryId=_this$props5.activeEntryId;var presetTasks=[].concat(_toConsumableArray(_this.props.presetTasks));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["Q" /* setDailyReportAddFloor */])(true));if(drEntry){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["N" /* setActiveEntriesId */])(drEntry.id));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["f" /* addSubDailyReportEntriesFloor */])(activeEntryId,currentDailyReport));}dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["G" /* loadPresetTasksSuccess */])(presetTasks));Object(__WEBPACK_IMPORTED_MODULE_24_services_utils_scroller_util__["a" /* containerScrollToTop */])('daily-report-form-modal');},_this.handleDeleteFloorClick=function(){var _this$props6=_this.props,dispatch=_this$props6.dispatch,activeEntryId=_this$props6.activeEntryId,currentDailyReport=_this$props6.currentDailyReport,contributorsForm=_this$props6.contributorsForm;var currentEntry=currentDailyReport.sub_daily_report_entries.find(function(val){return val.id===activeEntryId;});var filteredForm=Object.entries(contributorsForm).filter(function(_ref2){var _ref3=_slicedToArray(_ref2,2),key=_ref3[0],value=_ref3[1];return value.id!==activeEntryId;});var newForm={};filteredForm.forEach(function(_ref4){var _ref5=_slicedToArray(_ref4,2),key=_ref5[0],val=_ref5[1];newForm[key]={workPerformed:val.workPerformed,floor:val.floor,area:val.area,comments:val.comments,presetTasks:val.presetTasks,customTask:val.customTask,images:val.images,technicians:val.technicians,deletedImages:val.deletedImages,deletedTechnicians:val.deletedTechnicians};});dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["N" /* setActiveEntriesId */])(currentEntry['sub_daily_report_entry_id']));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["n" /* deleteSubDailyReportEntry */])(activeEntryId,currentDailyReport));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["_17" /* updateTradeForm */])(newForm));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["Q" /* setDailyReportAddFloor */])(false));},_this.duplicateTechnician=function(){var contribFormData=_this.getContribFormData();if(contribFormData&&contribFormData.technicians){var tech=contribFormData.technicians[contribFormData.technicians.length-1];if(tech){var newTechnicians=[].concat(_toConsumableArray(contribFormData.technicians));for(var i=1;i<contribFormData.techCount;i++){var techNumber=contribFormData.technicians.length+i;newTechnicians.push(Object.assign({},tech,{id:'',sub_technician_id:'',sub_technician:null,tech_number:techNumber,tech:{value:techNumber,label:'Technician '+techNumber,custom:true},additionalInfo:_this.buildAdditionalInfo(tech.additionalInfo)}));}_this.handleAttributeChange('duplicateTech',false);_this.handleAttributeChange('technicians',newTechnicians);}}},_this.isTheLastTechnician=function(){var contribFormData=_this.getContribFormData();return contribFormData&&contribFormData.technicians&&contribFormData.technicians.length===1;},_this.setImages=function(attribute,files){var images=[].concat(_toConsumableArray(_this.getImages()));files.forEach(function(val){images.push({url:URL.createObjectURL(val),file:val});});_this.handleAttributeChange(attribute,images);},_this.removeImages=function(attribute,index){var images=[].concat(_toConsumableArray(_this.getImages()));var deletedImages=[].concat(_toConsumableArray(_this.getDeletedImages()));var deletedImage=images.splice(index,1);deletedImages.push(deletedImage[0]);_this.handleAttributeChange(attribute,images);_this.handleAttributeChange('deletedImages',deletedImages);},_this.getImages=function(){var contribFormData=_this.getContribFormData();if(contribFormData&&contribFormData.images&&contribFormData.images.length>0){return contribFormData.images;}return[];},_this.getDeletedImages=function(){var contribFormData=_this.getContribFormData();if(contribFormData&&contribFormData.deletedImages&&contribFormData.deletedImages.length>0){return contribFormData.deletedImages;}return[];},_this.loadPresetTasks=function(){var _this$props7=_this.props,dispatch=_this$props7.dispatch,activeContributor=_this$props7.activeContributor,contributors=_this$props7.contributors,directory=_this$props7.directory;if(contributors.length>0){var contributor=directory.project_contributors.find(function(contrib){return contrib.id===contributors[activeContributor-1][0];});dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["F" /* loadPresetTasksRequest */])(contributor.csi_code.id));}},_this.getContribFormData=function(){var _this$props8=_this.props,contributorsForm=_this$props8.contributorsForm,activeEntryId=_this$props8.activeEntryId;if(activeEntryId&&contributorsForm[activeEntryId]){return contributorsForm[activeEntryId];}return null;},_this.isErrorValue=function(index,key){var errors=_this.props.errors;return errors.technicians&&errors.technicians[index]&&errors.technicians[index][key];},_this.isErrorValueForMoreInfo=function(index,infoIndex,key){var errors=_this.props.errors;return errors.technicians&&errors.technicians[index]&&errors.technicians[index].info&&errors.technicians[index].info[infoIndex]&&errors.technicians[index].info[infoIndex][key];},_this.validTechCount=function(){var contribFormData=_this.getContribFormData();return!!contribFormData&&!!contribFormData.techCount&&contribFormData.techCount>0&&contribFormData.techCount<100;},_this.handleChooseTechnician=function(option,techId,attribute){var _this$props9=_this.props,dispatch=_this$props9.dispatch,activeEntryId=_this$props9.activeEntryId;if(option){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["q" /* handleAttributeChangeForSub */])(option.custom?null:option,activeEntryId,techId,attribute));}},_this.handleAttributeChangeForSub=function(values,techId,attribute,infoIndex){var _this$props10=_this.props,dispatch=_this$props10.dispatch,activeEntryId=_this$props10.activeEntryId;if(infoIndex!==undefined){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["r" /* handleAttributeChangeForSubMoreAction */])(values,activeEntryId,techId,attribute,infoIndex));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["q" /* handleAttributeChangeForSub */])(values,activeEntryId,techId,attribute));}},_this.addMoreInfo=function(index,infoIndex){var _this$props11=_this.props,dispatch=_this$props11.dispatch,activeEntryId=_this$props11.activeEntryId;var contribFormData=_this.getContribFormData();if(contribFormData&&contribFormData.technicians){var newTechnicians=[].concat(_toConsumableArray(contribFormData.technicians));if(infoIndex!==undefined){var deletedInfo=newTechnicians[index].additionalInfo.splice(infoIndex,1);if(deletedInfo[0]&&deletedInfo[0].id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["g" /* addedDeletedTechnicians */])(deletedInfo[0],activeEntryId));}}else{if(!newTechnicians[index].additionalInfo){newTechnicians[index].additionalInfo=[defaultInfo];}else{newTechnicians[index].additionalInfo=[].concat(_toConsumableArray(newTechnicians[index].additionalInfo),[defaultInfo]);}}dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["h" /* changeAmountOfTechnicians */])(newTechnicians,activeEntryId));}},_this.loadTechnicians=function(input,page,customTech){var options=page===1?[customTech]:[];return __WEBPACK_IMPORTED_MODULE_21_services_api_sub_technicians_api__["a" /* default */].getTechnicians(page,input).then(function(response){if(response.ok){var resp={ok:true,options:[].concat(options,_toConsumableArray(response.technicians.map(function(element){return{value:element.id,label:element.first_name+' '+(element.last_name||'')};}))),hasMore:true};return resp;}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SingleTradesFormForSubComponent,[{key:'buildAdditionalInfo',value:function buildAdditionalInfo(additionalInfo){return additionalInfo&&additionalInfo.length?additionalInfo.map(function(info){return Object.assign({},info,{id:'',sub_technician_id:'',sub_technician:null});}):[];}},{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,currentProject=_props.currentProject,submitFailedErrors=_props.submitFailedErrors,dispatch=_props.dispatch;var isSubcontractor=__WEBPACK_IMPORTED_MODULE_17_domain_enterprise__["a" /* Enterprise */].subcontractor(currentProject.contributor_type);if(isSubcontractor){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19_actions_admin_team_contractor_team__["h" /* loadTechnicianRequest */])(1,__WEBPACK_IMPORTED_MODULE_19_actions_admin_team_contractor_team__["a" /* ContactorTeamTabs */].Technicians.value));}this.loadPresetTasks();if(submitFailedErrors){submitFailedErrors();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.activeEntryId!==this.props.activeEntryId){this.loadPresetTasks();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var dispatch=this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["Q" /* setDailyReportAddFloor */])(false));}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,activeContributor=_props2.activeContributor,errors=_props2.errors,presetTasks=_props2.presetTasks,currentDailyReport=_props2.currentDailyReport,activeEntryId=_props2.activeEntryId,addFloor=_props2.addFloor,settings=_props2.settings;var contribFormData=this.getContribFormData();var presetTaskList=[];if(presetTasks&&presetTasks.length>0){presetTaskList=presetTasks.map(function(task){return{id:task.id,label:task.label};});}var currentEntry=currentDailyReport.sub_daily_report_entries.find(function(val){return val.id===activeEntryId;});var childFloors=currentDailyReport.sub_daily_report_entries.filter(function(val){return val.sub_daily_report_entry_id===activeEntryId;});var isChildrenFloor=currentEntry&&currentEntry.sub_daily_report_entry_id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,contribFormData?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-wrapper'},settings&&settings.multiple_floors&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block floor-area-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Floor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'single-trade-form-error-field':errors.floor}),onChange:this.handleAttributeChange.bind(null,'floor'),value:''+(contribFormData.floor||'')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block floor-area-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{onChange:this.handleAttributeChange.bind(null,'area'),value:contribFormData.area||''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-tech-wrapper'},contribFormData.technicians&&contribFormData.technicians.length&&contribFormData.technicians.map(function(technician,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:''+activeContributor+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-tech-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_dropdown_SearchableDropDownPaginated__["a" /* default */],{className:'single-trade-form-technicians-dropdown',valid:true,arrowRenderer:function arrowRenderer(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{width:'10px',src:__WEBPACK_IMPORTED_MODULE_22_images_dropdown_arrow_png___default.a,alt:'arrow'});},withCreate:true,value:technician.sub_technician||technician.tech,loadOptions:function loadOptions(input,page){return _this2.loadTechnicians(input,page,technician.tech);},onChange:function onChange(value){return _this2.handleChooseTechnician(value,index,'sub_technician');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{type:'number',className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'single-trade-form-input':true,'single-trade-form-error-field':_this2.isErrorValue(index,'hoursAmount')}),onChange:function onChange(value){return _this2.handleHoursAmount(index,value);},value:technician.hoursAmount,placeholder:'Hours'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'single-trade-form-separate-text'},'or'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_time_picker_TimePicker__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'single-trade-form-error-field':_this2.isErrorValue(index,'workedFrom')}),placeholder:'Worked from',onChange:function onChange(value){return _this2.handleDate(index,value,'workedFrom');},value:technician.workedFrom}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_time_picker_TimePicker__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'single-trade-form-error-field':_this2.isErrorValue(index,'workedTo')}),placeholder:'Worked to',onChange:function onChange(value){return _this2.handleDate(index,value,'workedTo');},value:technician.workedTo})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-multiselect-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Preset Tasks'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'report-multiselect':true,'report-multiselect-error':_this2.isErrorValue(index,'presetTasks')})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_dropdown_MultipleDropdown__["a" /* default */],{dropdownClassName:'alternate-dropdown-control',options:presetTaskList,currentValues:technician.presetTasks||[],placeholder:'Select tasks...',onChange:function onChange(values){return _this2.handleAttributeChangeForSub(values,index,'presetTasks');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block custom-task-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Custom Task'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'single-trade-form-error-field':_this2.isErrorValue(index,'customTask')}),onChange:function onChange(value){return _this2.handleAttributeChangeForSub(value,index,'customTask');},value:technician.customTask})),settings&&!settings.multiple_floors&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block custom-task-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{onChange:function onChange(value){return _this2.handleAttributeChangeForSub(value,index,'location');},value:technician.location})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block custom-task-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Work Performed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{onChange:function onChange(value){return _this2.handleAttributeChangeForSub(value,index,'workPerformed');},value:technician.workPerformed})),technician.location&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block custom-task-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'+ Add additional location',onClick:function onClick(){return _this2.addMoreInfo(index);}})),technician.additionalInfo&&technician.additionalInfo.map(function(info,infoIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:''+activeContributor+index+infoIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-tech-block-more-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{type:'number',className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'single-trade-form-input':true,'single-trade-form-error-field':_this2.isErrorValueForMoreInfo(index,infoIndex,'hoursAmount')}),onChange:function onChange(value){return _this2.handleHoursAmount(index,value,infoIndex);},value:info.hoursAmount,placeholder:'Hours'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'single-trade-form-separate-text'},'or'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_time_picker_TimePicker__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'single-trade-form-error-field':_this2.isErrorValueForMoreInfo(index,infoIndex,'workedFrom')}),placeholder:'Worked from',onChange:function onChange(value){return _this2.handleDate(index,value,'workedFrom',infoIndex);},value:info.workedFrom}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_time_picker_TimePicker__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'single-trade-form-error-field':_this2.isErrorValueForMoreInfo(index,infoIndex,'workedTo')}),placeholder:'Worked to',onChange:function onChange(value){return _this2.handleDate(index,value,'workedTo',infoIndex);},value:info.workedTo})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-multiselect-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Preset Tasks'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'report-multiselect':true,'report-multiselect-error':_this2.isErrorValueForMoreInfo(index,infoIndex,'presetTasks')})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_dropdown_MultipleDropdown__["a" /* default */],{dropdownClassName:'alternate-dropdown-control',options:presetTaskList,currentValues:info.presetTasks||[],placeholder:'Select tasks...',onChange:function onChange(values){return _this2.handleAttributeChangeForSub(values,index,'presetTasks',infoIndex);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block custom-task-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Custom Task'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'single-trade-form-error-field':_this2.isErrorValueForMoreInfo(index,infoIndex,'customTask')}),onChange:function onChange(value){return _this2.handleAttributeChangeForSub(value,index,'customTask',infoIndex);},value:info.customTask})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block custom-task-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{onChange:function onChange(value){return _this2.handleAttributeChangeForSub(value,index,'location',infoIndex);},value:info.location})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block custom-task-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Work Performed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{onChange:function onChange(value){return _this2.handleAttributeChangeForSub(value,index,'workPerformed',infoIndex);},value:info.workPerformed})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block custom-task-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{className:'button-orange delete-info-button',label:'- Delete location',onClick:function onClick(){return _this2.addMoreInfo(index,infoIndex);}})));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'divider'}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-tech-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-dup-tech-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Duplicate Tech?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{onChange:this.handleAttributeChange.bind(null,'duplicateTech'),checked:contribFormData.duplicateTech})),!contribFormData.duplicateTech?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tech-actions-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'+ Add technician',onClick:this.addTechnician}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{disabled:this.isTheLastTechnician(),className:'button-orange delete-button',label:'- Delete technician',onClick:this.removeTechnician})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tech-actions-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{className:'tech-count',placeholder:'How many?',type:'number',onChange:this.handleAttributeChange.bind(null,'techCount'),value:contribFormData.techCount}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{disabled:!this.validTechCount(),className:'button-orange',label:'+ Duplicate Technician',onClick:this.duplicateTechnician})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:__WEBPACK_IMPORTED_MODULE_16_services_utils_files_util__["a" /* imageExtensions */],multiple:true,onUpload:function onUpload(files){return _this2.setImages('images',files);},onRemove:function onRemove(index){return _this2.removeImages('images',index);},images:this.getImages()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label single-trade-form-label-open-item-q'},'Is there an Open Item to report?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{onChange:this.handleAttributeChange.bind(null,'isDelay'),checked:contribFormData.isDelay})),contribFormData.isDelay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_daily_report_log_ProjectOpenItemForm__["a" /* default */],{form:contribFormData,errors:errors,handleAttributeChange:this.handleAttributeChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label single-trade-form-label-fwo-q'},'Field Work Order Required?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{onChange:this.handleAttributeChange.bind(null,'isFieldWorkOrder'),checked:contribFormData.isFieldWorkOrder})),contribFormData.isFieldWorkOrder&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_components_admin_projects_details_project_daily_report_log_FieldWorkOrderForm__["a" /* default */],{fieldWorkOrderForm:contribFormData,handleAttributeChange:this.handleAttributeChange,showErrorMessage:false,formErrors:errors,fieldWorkOrder:currentDailyReport.field_work_order,fwoForSubForm:true}),childFloors&&!!childFloors.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block single-trade-form-floors'},childFloors.map(function(drEntry){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-floor',key:drEntry.id,onClick:function onClick(){return _this2.handleAddFloor(drEntry);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,!!drEntry.floor&&'Floor '+drEntry.floor,!!drEntry.floor&&!!drEntry.area&&' - ',!!drEntry.area&&drEntry.area,!drEntry.floor&&!drEntry.area&&'Draft Floor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'>'));})),settings&&settings.multiple_floors&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block'},addFloor||isChildrenFloor?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_FloorButton__["a" /* default */],{isForAdd:false,onClick:this.handleDeleteFloorClick}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_FloorButton__["a" /* default */],{isForAdd:true,onClick:this.handleAddFloor}))):null);}}]);return SingleTradesFormForSubComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{directory:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_directory_store_selectors__["c" /* getDirectory */])(state),settings:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_settings_store_selectors__["a" /* getSettings */])(state),contributorsForm:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_store_selectors__["e" /* getContributorsForm */])(state),presetTasks:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_store_selectors__["z" /* getPresetTasks */])(state),activeContributor:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_store_selectors__["a" /* getActiveContributor */])(state),contributors:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_store_selectors__["d" /* getContributors */])(state),activeEntryId:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_store_selectors__["b" /* getActiveEntryId */])(state),currentProject:Object(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),technicians:Object(__WEBPACK_IMPORTED_MODULE_20_selectors_admin_team_contractor_team__["l" /* getTechnicians */])(state),currentDailyReport:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_store_selectors__["f" /* getCurrentDailyReport */])(state),addFloor:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_store_selectors__["c" /* getAddFloor */])(state)};})(SingleTradesFormForSubComponent));

/***/ }),
/* 2632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_dropdown_MultipleDropdown__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_time_picker_TimePicker__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_button_FloorButton__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_checkbox_LabeledCheckBox__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_daily_report_log_ProjectOpenItemForm__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_daily_report_log_store_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_settings_store_selectors__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_daily_report_log_store_selectors__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_services_utils_files_util__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SingleTradeForm_css__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SingleTradeForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__SingleTradeForm_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialMember={user:'',floor:'',area:'',hoursAmount:'',workedFrom:'',workedTo:'',supervisorTasks:[],customTask:'',comments:''};var MemberFormModal=function(_Component){_inherits(MemberFormModal,_Component);function MemberFormModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MemberFormModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MemberFormModal.__proto__||Object.getPrototypeOf(MemberFormModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleMemberAttribute=function(key,index,values){var _this$props=_this.props,dispatch=_this$props.dispatch,members=_this$props.members,clearErrors=_this$props.clearErrors;var membersList=[].concat(_toConsumableArray(members));var newMember=Object.assign({},membersList[index]);newMember[key]=values;membersList.splice(index,1,newMember);clearErrors(index,key);dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_daily_report_log_store_actions__["_2" /* setMembers */])(membersList));},_this.insertMember=function(member){var _this$props2=_this.props,dispatch=_this$props2.dispatch,members=_this$props2.members;var membersList=[].concat(_toConsumableArray(members));membersList.push(member);dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_daily_report_log_store_actions__["_2" /* setMembers */])(membersList));},_this.addMember=function(){_this.insertMember(initialMember);},_this.addMemberFloor=function(user){_this.insertMember(Object.assign({},initialMember,{user:user,isChildFloor:true}));},_this.removeMember=function(index){var _this$props3=_this.props,dispatch=_this$props3.dispatch,members=_this$props3.members,deletedMembers=_this$props3.deletedMembers;var membersList=[].concat(_toConsumableArray(members));var deletedMember=membersList.splice(index,1)[0];if(deletedMember.id){var newDeletedMembers=[].concat(_toConsumableArray(deletedMembers));newDeletedMembers.push(deletedMember);dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_daily_report_log_store_actions__["T" /* setDeletedMembers */])(newDeletedMembers));}dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_daily_report_log_store_actions__["_2" /* setMembers */])(membersList));},_this.deleteMember=function(){var members=_this.props.members;_this.removeMember(members.length-1);},_this.deletedMemberFloor=function(index){_this.removeMember(index);},_this.handleHoursAmount=function(index,value){var _this$props4=_this.props,dispatch=_this$props4.dispatch,members=_this$props4.members,clearErrors=_this$props4.clearErrors;var membersList=[].concat(_toConsumableArray(members));var newMember=Object.assign({},membersList[index]);newMember.hoursAmount=value;newMember.workedFrom='';newMember.workedTo='';membersList.splice(index,1,newMember);clearErrors(index,'hoursAmount');dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_daily_report_log_store_actions__["_2" /* setMembers */])(membersList));},_this.handleDate=function(key,index,value){var _this$props5=_this.props,dispatch=_this$props5.dispatch,members=_this$props5.members,clearErrors=_this$props5.clearErrors;var membersList=[].concat(_toConsumableArray(members));var newMember=Object.assign({},membersList[index]);newMember[key]=value;newMember.hoursAmount='';membersList.splice(index,1,newMember);clearErrors(index,key);dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_daily_report_log_store_actions__["_2" /* setMembers */])(membersList));},_this.getUsersList=function(index){var _this$props6=_this.props,directory=_this$props6.directory,members=_this$props6.members;var gc=directory.project_contributors.find(function(contrib){return contrib.company_type==='GeneralContractor';});var users=[];gc&&gc.users&&gc.users.forEach(function(user){var selectedUser=members.find(function(member){return member.user&&member.user.value===user.id;});var selectedUserIndex=members.findIndex(function(member){return member.user&&member.user.value===user.id;});if(selectedUser){if(selectedUserIndex===index){users.push({value:user.id,label:user.first_name+' '+user.last_name});}}else{users.push({value:user.id,label:user.first_name+' '+user.last_name});}});return users;},_this.handleOpenItemChange=function(attribute,value){var _this$props7=_this.props,openItem=_this$props7.openItem,clearErrors=_this$props7.clearErrors,dispatch=_this$props7.dispatch;clearErrors(openItem,attribute);dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_daily_report_log_store_actions__["_7" /* setReportOpenItemValue */])(attribute,value));},_this.setImages=function(files){var _this$props8=_this.props,gcImages=_this$props8.gcImages,dispatch=_this$props8.dispatch;var images=[].concat(_toConsumableArray(gcImages));files.forEach(function(val){images.push({url:URL.createObjectURL(val),file:val});});dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_daily_report_log_store_actions__["Z" /* setGCImagesAction */])(images));},_this.removeImages=function(index){var _this$props9=_this.props,gcImages=_this$props9.gcImages,gcDeletedImages=_this$props9.gcDeletedImages,dispatch=_this$props9.dispatch;var images=[].concat(_toConsumableArray(gcImages));var deletedImages=[].concat(_toConsumableArray(gcDeletedImages));var deletedImage=images.splice(index,1);deletedImages.push(deletedImage[0]);dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_daily_report_log_store_actions__["Y" /* setGCDeletedImagesAction */])(deletedImages));dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_daily_report_log_store_actions__["Z" /* setGCImagesAction */])(images));},_this.renderMember=function(member,index){var _this$props10=_this.props,supervisorTasks=_this$props10.supervisorTasks,settings=_this$props10.settings,errors=_this$props10.errors;var errorsMemberForm=errors.errorsMemberForm;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'member-block-wrapper',key:index},!member.isChildFloor&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-multiselect-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Users'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-multiselect'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'single-trade-form-error-field':errorsMemberForm[index]&&errorsMemberForm[index].user}),options:_this.getUsersList(index),value:member.user&&member.user.value||'',placeholder:'Select users...',onChange:function onChange(values){return _this.handleMemberAttribute('user',index,values);}}))),settings&&settings.multiple_floors&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block floor-area-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Floor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{onChange:_this.handleMemberAttribute.bind(null,'floor',index),value:''+(member.floor||'')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block floor-area-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{onChange:_this.handleMemberAttribute.bind(null,'area',index),value:''+(member.area||'')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-tech-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{type:'number',className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'single-trade-form-input':true,'single-trade-form-error-field':errorsMemberForm[index]&&errorsMemberForm[index].hoursAmount}),onChange:function onChange(value){return _this.handleHoursAmount(index,value);},value:member.hoursAmount,placeholder:'Hours'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'single-trade-form-separate-text'},'or'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_time_picker_TimePicker__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'single-trade-form-error-field':errorsMemberForm[index]&&errorsMemberForm[index].workedFrom}),placeholder:'Worked from',onChange:function onChange(value){return _this.handleDate('workedFrom',index,value);},value:member.workedFrom}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_time_picker_TimePicker__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'single-trade-form-error-field':errorsMemberForm[index]&&errorsMemberForm[index].workedTo}),placeholder:'Worked to',onChange:function onChange(value){return _this.handleDate('workedTo',index,value);},value:member.workedTo})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-multiselect-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Preset Tasks'),supervisorTasks&&supervisorTasks.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-multiselect'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_dropdown_MultipleDropdown__["a" /* default */],{dropdownClassName:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'alternate-dropdown-control':true,'single-trade-form-error-field':errorsMemberForm[index]&&errorsMemberForm[index].supervisorTasks}),options:supervisorTasks,currentValues:member.supervisorTasks||[],placeholder:'Select tasks...',onChange:function onChange(values){return _this.handleMemberAttribute('supervisorTasks',index,values);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block custom-task-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Custom Task'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{onChange:_this.handleMemberAttribute.bind(null,'customTask',index),value:member.customTask})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label'},'Comments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_TextArea__["a" /* default */],{onChange:_this.handleMemberAttribute.bind(null,'comments',index),value:member.comments})),settings&&settings.multiple_floors&&member.user&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block'},member.isChildFloor?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_button_FloorButton__["a" /* default */],{isForAdd:false,onClick:function onClick(){return _this.deletedMemberFloor(index);}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_button_FloorButton__["a" /* default */],{isForAdd:true,onClick:function onClick(){return _this.addMemberFloor(member.user);}})));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MemberFormModal,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,dispatch=_props.dispatch,members=_props.members,supervisorTasks=_props.supervisorTasks,submitFailedErrors=_props.submitFailedErrors;if(supervisorTasks.length===0){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_daily_report_log_store_actions__["H" /* loadSupervisorTasksRequest */])());}if(!members.length){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_daily_report_log_store_actions__["_2" /* setMembers */])([initialMember]));}if(submitFailedErrors){submitFailedErrors();}}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,members=_props2.members,openItem=_props2.openItem,gcImages=_props2.gcImages,errors=_props2.errors;var errorsOpenItemForm=errors.errorsOpenItemForm;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,members&&members.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-wrapper'},members.filter(function(member){return!member.isChildFloor;}).map(function(member,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:index},_this2.renderMember(member,members.indexOf(member)),members.filter(function(member2){return member2.isChildFloor&&member2.user.value===member.user.value;}).map(function(member2){return _this2.renderMember(member2,members.indexOf(member2));}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block member-buttons-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'member-add-button',onClick:this.addMember},'+ Add member'),members.length>1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'member-delete-button',onClick:this.deleteMember},'- Delete member')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:__WEBPACK_IMPORTED_MODULE_16_services_utils_files_util__["a" /* imageExtensions */],multiple:true,onUpload:function onUpload(files){return _this2.setImages(files);},onRemove:function onRemove(index){return _this2.removeImages(index);},images:gcImages})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-trade-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'single-trade-form-label single-trade-form-label-open-item-q'},'Is there an Open Item to report?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{onChange:this.handleOpenItemChange.bind(null,'isDelay'),checked:openItem.isDelay})),openItem.isDelay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_daily_report_log_ProjectOpenItemForm__["a" /* default */],{form:openItem,errors:errorsOpenItemForm,handleAttributeChange:this.handleOpenItemChange})));}}]);return MemberFormModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{directory:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__["c" /* getDirectory */])(state),settings:Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_settings_store_selectors__["a" /* getSettings */])(state),generalContactorName:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_daily_report_log_store_selectors__["w" /* getGeneralContactorName */])(state),supervisorTasks:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_daily_report_log_store_selectors__["M" /* getSupervisorTasks */])(state),members:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_daily_report_log_store_selectors__["y" /* getMembers */])(state),deletedMembers:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_daily_report_log_store_selectors__["n" /* getDeletedMembers */])(state),openItem:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_daily_report_log_store_selectors__["C" /* getReportOpenItem */])(state),gcImages:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_daily_report_log_store_selectors__["v" /* getGCImages */])(state),gcDeletedImages:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_daily_report_log_store_selectors__["u" /* getGCDeletedImages */])(state)};})(MemberFormModal));

/***/ }),
/* 2634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_daily_report_log_ReviewFormForStaff__ = __webpack_require__(2635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_daily_report_log_store_selectors__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_ProjectOpenItemReview__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_daily_report_log_FieldWorkOrderReview__ = __webpack_require__(2636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_logo_upload_LogoUpload__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_checkbox_CheckBox__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_autosize_textarea__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_autosize_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_autosize_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_dropdown_SearchableDropDownPaginated__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_images_dropdown_arrow_png__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_images_dropdown_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_images_dropdown_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_images_remove_svg__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_images_remove_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_images_remove_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_daily_report_log_ReviewFormForSub__ = __webpack_require__(2637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_services_api_submittals_api__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ReviewForm_css__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ReviewForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__ReviewForm_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReviewForm=function(_Component){_inherits(ReviewForm,_Component);function ReviewForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ReviewForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ReviewForm.__proto__||Object.getPrototypeOf(ReviewForm)).call.apply(_ref,[this].concat(args))),_this),_this.deliveryExtraInputObject={name:'deliveries',label:'Other Deliveries'},_this.focusDeliveries=false,_this.editEntry=function(report){var _this$props=_this.props,currentDailyReport=_this$props.currentDailyReport,dispatch=_this$props.dispatch;var sortedEntries=currentDailyReport.daily_report_entries.filter(function(value){return!value.daily_report_entry_id&&!value.sub_daily_report_entry_id;});var reportIndex=sortedEntries.findIndex(function(value){return value.id===report.id;});if(report.sub_daily_report_entry_id){reportIndex=sortedEntries.findIndex(function(value){return value.id===report.sub_daily_report_entry_id;});}else if(report.daily_report_entry_id){reportIndex=sortedEntries.findIndex(function(value){return value.id===report.daily_report_entry_id;});}if(reportIndex>=0){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["_9" /* setReviewFormAction */])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["M" /* setActiveContributor */])(reportIndex+1));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["N" /* setActiveEntriesId */])(report.id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["V" /* setEditMode */])(true));_this.props.clearReviewErrors();}},_this.removeDelivery=function(indx){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["l" /* deleteDelivery */])(indx));_this.updateDeliveries();},_this.loadDeliveries=function(input,page){var delValue=_this.props.isSub?'not_delivered_sub':'not_delivered';return __WEBPACK_IMPORTED_MODULE_17_services_api_submittals_api__["a" /* submittalsApi */].getSubmittals(_this.props.projectId,page,delValue,input).then(function(submittals){var resp={ok:true,options:submittals.submittals.map(function(element){var label=element.csi_code.division+'-'+element.number+' '+element.title;if(element.field_delivery){label+=' - '+__WEBPACK_IMPORTED_MODULE_4_moment___default()(element.field_delivery).format('MM/DD/YY');}return{value:element.id,label:label};}),hasMore:true};if(page===1||input!==_this.inputValue){_this.inputValue=input;resp.options.push({label:'Others',value:'others'});}return resp;});},_this.showTechniciansDetails=function(technicians){return technicians&&[].concat(_toConsumableArray(new Set(technicians.map(function(tech){return tech.hours_worked;})))).length>1;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ReviewForm,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,reportExtraInputs=_props.reportExtraInputs,dispatch=_props.dispatch;if(reportExtraInputs['deliveries']){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["e" /* addExtraInput */])(this.deliveryExtraInputObject));}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["K" /* removeDeliveriesExtraInput */])());}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.focusDeliveries){document.getElementById('deliveries').focus();this.focusDeliveries=false;}}},{key:'updateDeliveries',value:function updateDeliveries(){var _props2=this.props,handleExtraInputChange=_props2.handleExtraInputChange,delivery=_props2.delivery;handleExtraInputChange('received_submittal_ids',delivery.map(function(val){return val.value;}));}},{key:'updateIsSafetyAccepted',value:function updateIsSafetyAccepted(value){var handleExtraInputChange=this.props.handleExtraInputChange;handleExtraInputChange('is_safety_accepted',value);}},{key:'render',value:function render(){var _this2=this;var _props$currentDailyRe=this.props.currentDailyReport,daily_report_entries=_props$currentDailyRe.daily_report_entries,sub_daily_report_entries=_props$currentDailyRe.sub_daily_report_entries,gc_staff_members=_props$currentDailyRe.gc_staff_members,gc_staff_on_site=_props$currentDailyRe.gc_staff_on_site,project_open_item=_props$currentDailyRe.project_open_item,images=_props$currentDailyRe.images;var orderedEntriesArr=[];var orderedEntries=[];if(daily_report_entries&&daily_report_entries.length>0){daily_report_entries.sort(function(report1,report2){if(report1.project_contributor&&report2.project_contributor){return Number(report1.project_contributor.csi_code.division)-Number(report2.project_contributor.csi_code.division);}return false;});orderedEntriesArr=daily_report_entries.filter(function(drEntry){return!drEntry.daily_report_entry_id;}).map(function(el){daily_report_entries.filter(function(drEntry){return drEntry.daily_report_entry_id;});return[el].concat(_toConsumableArray(daily_report_entries.filter(function(drEntry){return drEntry.daily_report_entry_id===el.id;})));});}if(sub_daily_report_entries&&sub_daily_report_entries.length>0){sub_daily_report_entries.sort(function(report1,report2){if(report1.project_contributor&&report2.project_contributor){return Number(report1.project_contributor.csi_code.division)-Number(report2.project_contributor.csi_code.division);}return false;});orderedEntriesArr=sub_daily_report_entries.filter(function(drEntry){return!drEntry.sub_daily_report_entry_id;}).map(function(el){sub_daily_report_entries.filter(function(drEntry){return drEntry.sub_daily_report_entry_id;});return[el].concat(_toConsumableArray(sub_daily_report_entries.filter(function(drEntry){return drEntry.sub_daily_report_entry_id===el.id;})));});}orderedEntriesArr.map(function(arr){return orderedEntries.push.apply(orderedEntries,_toConsumableArray(arr));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-wrapper',id:'review-form-wrapper'},gc_staff_on_site&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_daily_report_log_ReviewFormForStaff__["a" /* default */],{members:gc_staff_members,generalContactorLabel:this.props.generalContactorLabel,openItem:project_open_item,readOnly:this.props.readOnly,dispatch:this.props.dispatch,errorsForStaff:this.props.errorsForStaff,errorsForOpenItem:this.props.errorsForOpenItem,clearErrorOnStaff:this.props.clearErrorOnStaff,clearErrorOnOpenItem:this.props.clearErrorOnOpenItem,images:images}),orderedEntries&&orderedEntries.length>0&&orderedEntries[0].project_contributor&&orderedEntries.map(function(report){var isThereAreError=_this2.props.reviewErrors.find(function(error){return error===report.id;});var subTeches=[];var techId=null;var techRes={};if(report.sub_daily_report_teches&&report.sub_daily_report_teches.length){var techListTechNumbers=report.sub_daily_report_teches.filter(function(tech){return!tech.sub_technician_id&&tech.tech_number;}).sort(function(tech1,tech2){return tech1.tech_number-tech2.tech_number;});var techListSubTechIds=report.sub_daily_report_teches.filter(function(tech){return tech.sub_technician_id;}).sort(function(tech1,tech2){return tech1.sub_technician_id-tech2.sub_technician_id;});var resultTechList=[].concat(_toConsumableArray(techListTechNumbers),_toConsumableArray(techListSubTechIds));resultTechList.forEach(function(tech){var newTechId=tech.sub_technician_id||tech.tech_number;if(techId!==newTechId){techRes=tech;techId=newTechId;subTeches.push(techRes);}else{if(techRes.additionalInfo){var isExisting=techRes.additionalInfo.find(function(el){return el.id===tech.id;});if(!isExisting){techRes.additionalInfo.push(tech);}}else{techRes.additionalInfo=[tech];}}});if(subTeches.length){subTeches.sort(function(tech1,tech2){return tech1.tech_number-tech2.tech_number;});}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:report.id,className:'review-form-trade'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-title'},report.project_contributor&&!(report.daily_report_entry_id||report.sub_daily_report_entry_id)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-head-title'},report.project_contributor.csi_code.division,' -',' ',report.project_contributor.csi_code.label),(report.floor||report.area)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-floor-title'},report.floor&&'Floor '+report.floor,report.floor&&report.area&&' - ',report.area||'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()({'review-form-content-wrapper':true,'review-form-content-wrapper-error':!!isThereAreError})},subTeches.length?subTeches.map(function(reportSub,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_daily_report_log_ReviewFormForSub__["a" /* default */],{key:reportSub.id,parentReport:report,report:reportSub,index:index,readOnly:_this2.props.readOnly,editEntry:_this2.editEntry,currentDailyReport:_this2.props.currentDailyReport});}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,report.project_contributor&&report.project_contributor.company.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Total Technicians: ',report.technicians_count||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Total Hours: ',report.hours_worked||0)),!_this2.props.readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Edit',onClick:_this2.editEntry.bind(null,report)})),_this2.showTechniciansDetails(report.technicians)&&report.technicians.map(function(technician,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:technician.id,className:'review-form-block-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Technician ',index+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-content-value'},technician.hours_worked||0,' hours'));})),(report.preset_tasks&&report.preset_tasks.length>0||report.preset_task_other)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title'},'Tasks Performed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-block-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,report.preset_tasks.length>0&&report.preset_tasks.map(function(task){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:task.id},task.label);}),report.preset_task_other&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,report.preset_task_other)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title'},'Work Performed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-text-block'},report.work_performed))),report.comments&&!_this2.props.readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title'},'Comments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-text-block'},report.comments)),report&&report.images&&report.images.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title-photos'},'Photos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-block-images-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_logo_upload_LogoUpload__["a" /* default */],{readOnly:true,logos:report.images.map(function(image){return{preview:image.image.gallery.url,url:image.image.url};})}))),report.project_open_item&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_daily_report_log_ProjectOpenItemReview__["a" /* default */],{openItem:report.project_open_item}),report.field_work_order&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_daily_report_log_FieldWorkOrderReview__["a" /* default */],{fieldWorkOrder:report.field_work_order})));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-extra-input-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Saftey'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()({'review-form-content-wrapper-error':this.props.reviewErrors.includes(this.props.currentDailyReport.id)})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'safety-label'},'This Project has been safety inspected'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_checkbox_CheckBox__["a" /* default */],{className:'safety-checkbox',checked:this.props.reportExtraInputs.is_safety_accepted,readOnly:this.props.currentDailyReport.status==='approved',onChange:function onChange(){return _this2.updateIsSafetyAccepted(!_this2.props.reportExtraInputs.is_safety_accepted);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_autosize_textarea___default.a,{placeholder:'Enter safety here...',rows:3,disabled:this.props.currentDailyReport.status==='approved',defaultValue:this.props.reportExtraInputs.safety||'',onBlur:function onBlur(e){return _this2.props.handleExtraInputChange('safety',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-extra-input-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Deliveries'),!this.props.readOnly&&this.props.currentDailyReport.status!=='approved'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_dropdown_SearchableDropDownPaginated__["a" /* default */],Object.assign({className:'dropdown-deliveries',valid:true,arrowRenderer:function arrowRenderer(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{width:'10px',src:__WEBPACK_IMPORTED_MODULE_14_images_dropdown_arrow_png___default.a,alt:'arrow'});},withCreate:true,loadOptions:function loadOptions(input,page){return _this2.loadDeliveries(input,page);},onChange:function onChange(input){if(input.value==='others'){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["e" /* addExtraInput */])(_this2.deliveryExtraInputObject));_this2.focusDeliveries=true;}else{_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_daily_report_log_store_actions__["U" /* setDelivery */])(input));_this2.updateDeliveries();}}},this.props)),this.props.delivery&&this.props.delivery.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deliveries-list'},this.props.delivery.map(function(val,indx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'deliveries_'+indx,className:'deliveries'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'delivery-row'},!_this2.props.readOnly&&_this2.props.currentDailyReport.status!=='approved'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'button-delete-deliveries',src:__WEBPACK_IMPORTED_MODULE_15_images_remove_svg___default.a,alt:'remove',onClick:function onClick(){return _this2.removeDelivery(indx);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,val.label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null));})):this.props.readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deliveries-list'},'-')),this.props.extraInputs.map(function(attr,index){var name=attr.name,label=attr.label;var value=_this2.props.reportExtraInputs[name];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-extra-input-block',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,label),_this2.props.readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,value?value:'-'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_autosize_textarea___default.a,{rows:3,disabled:_this2.props.currentDailyReport.status==='approved',id:name,key:label,defaultValue:value||'',onBlur:function onBlur(e){return _this2.props.handleExtraInputChange(name,e.target.value);}}));}));}}]);return ReviewForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{delivery:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_daily_report_log_store_selectors__["o" /* getDelivery */])(state),extraInputs:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_daily_report_log_store_selectors__["q" /* getExtraInputs */])(state)};})(ReviewForm));

/***/ }),
/* 2635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_text_Time__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_daily_report_log_ProjectOpenItemReview__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_daily_report_log_store_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_logo_upload_LogoUpload__ = __webpack_require__(102);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReviewFormForStaff=function(_Component){_inherits(ReviewFormForStaff,_Component);function ReviewFormForStaff(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ReviewFormForStaff);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ReviewFormForStaff.__proto__||Object.getPrototypeOf(ReviewFormForStaff)).call.apply(_ref,[this].concat(args))),_this),_this.editMember=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_daily_report_log_store_actions__["_1" /* setMemberForm */])(true));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_daily_report_log_store_actions__["V" /* setEditMode */])(true));_this.props.clearErrorOnStaff();_this.props.clearErrorOnOpenItem();},_this.membersToList=function(){var members=_this.props.members;var membersToList=[];members.forEach(function(member){membersToList.push(Object.assign({},member,{isChildFloor:!!membersToList.find(function(member2){return member2.user_id===member.user_id;})}));});return membersToList;},_this.renderMember=function(member,child){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:member.id},(member.floor||member.area)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-floor-title review-form-floor-title-staff'},member.floor&&'Floor '+member.floor,member.floor&&member.area&&' - ',member.area||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:member.id,className:'review-form-content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,member.user.first_name+' '+member.user.last_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Hours: ',member.hours_worked||0),member.started_at&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Started at: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_text_Time__["a" /* default */],{className:'review-form-date-span',value:member.started_at,format:'LT'})),member.ended_at&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Ended at: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_text_Time__["a" /* default */],{className:'review-form-date-span',value:member.ended_at,format:'LT'}))),!_this.props.readOnly&&!child&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Edit',onClick:_this.editMember}))),(member.supervisor_tasks&&member.supervisor_tasks.length>0||member.supervisor_task_other)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title'},'Tasks Performed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-block-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,member.supervisor_tasks.length>0&&member.supervisor_tasks.map(function(task){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:task.id},task.label);}),member.supervisor_task_other&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,member.supervisor_task_other)))),member.comments&&!_this.props.readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title'},'Comments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-text-block'},member.comments))));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ReviewFormForStaff,[{key:'render',value:function render(){var _this2=this;var _props=this.props,members=_props.members,generalContactorLabel=_props.generalContactorLabel,openItem=_props.openItem,errorsForStaff=_props.errorsForStaff,errorsForOpenItem=_props.errorsForOpenItem,images=_props.images;var membersToList=members&&members.length>0&&this.membersToList();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-head-title'},generalContactorLabel)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()({'review-form-staff-wrapper':true,'review-form-content-wrapper-error':!!errorsForStaff||!!errorsForOpenItem})},members&&members.length>0?membersToList.filter(function(member){return!member.isChildFloor;}).map(function(member,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:index},_this2.renderMember(member),membersToList.filter(function(member2){return member2.isChildFloor&&member2.user_id===member.user_id;}).map(function(member2){return _this2.renderMember(member2,true);}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Staff Member'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Hours: 0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Edit',onClick:this.editMember})))),images&&images.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title-photos'},'Photos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-block-images-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_logo_upload_LogoUpload__["a" /* default */],{readOnly:true,logos:images.map(function(image){return{preview:image.image.gallery.url,url:image.image.url};})}))),openItem&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_daily_report_log_ProjectOpenItemReview__["a" /* default */],{openItem:openItem})));}}]);return ReviewFormForStaff;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ReviewFormForStaff);

/***/ }),
/* 2636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReviewForm_css__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReviewForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ReviewForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FieldWorkOrderReview=function(_Component){_inherits(FieldWorkOrderReview,_Component);function FieldWorkOrderReview(){_classCallCheck(this,FieldWorkOrderReview);return _possibleConstructorReturn(this,(FieldWorkOrderReview.__proto__||Object.getPrototypeOf(FieldWorkOrderReview)).apply(this,arguments));}_createClass(FieldWorkOrderReview,[{key:'render',value:function render(){var fieldWorkOrder=this.props.fieldWorkOrder;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block review-form-field-work-order'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-title-bloc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title-fwo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'FIELD WORK ORDER')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-field-fwo'},!!fieldWorkOrder.number&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'FWO#: ',fieldWorkOrder.number)),(fieldWorkOrder.preset_tasks&&fieldWorkOrder.preset_tasks.length||fieldWorkOrder.preset_task_other)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-block-field-fwo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Tasks to be performed:'),!!fieldWorkOrder.preset_tasks.length&&fieldWorkOrder.preset_tasks.map(function(task){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{key:task.id},'\u2022 ',task.label);}),!!fieldWorkOrder.preset_task_other&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2022 ',fieldWorkOrder.preset_task_other)),!!fieldWorkOrder.work_performed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-block-field-fwo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Work to be performed:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,fieldWorkOrder.work_performed)),!!fieldWorkOrder.comments&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-block-field-fwo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Comments:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,fieldWorkOrder.comments)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-block-field-fwo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Start date:'),!!fieldWorkOrder.start_date?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_3_moment___default()(fieldWorkOrder.start_date).format('MM/DD/YYYY')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TBD')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-block-field-fwo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Completion Date:'),!!fieldWorkOrder.completion_date?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_3_moment___default()(fieldWorkOrder.completion_date).format('MM/DD/YYYY')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TBD')),!!fieldWorkOrder.labor&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-block-field-fwo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Labor:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,fieldWorkOrder.labor)),!!fieldWorkOrder.materials&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-block-field-fwo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Materials:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,fieldWorkOrder.materials))));}}]);return FieldWorkOrderReview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FieldWorkOrderReview.propTypes={fieldWorkOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (FieldWorkOrderReview);

/***/ }),
/* 2637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_button_Button__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReviewFormForSub=function(_Component){_inherits(ReviewFormForSub,_Component);function ReviewFormForSub(){_classCallCheck(this,ReviewFormForSub);return _possibleConstructorReturn(this,(ReviewFormForSub.__proto__||Object.getPrototypeOf(ReviewFormForSub)).apply(this,arguments));}_createClass(ReviewFormForSub,[{key:'render',value:function render(){var _props=this.props,report=_props.report,parentReport=_props.parentReport,index=_props.index,readOnly=_props.readOnly,editEntry=_props.editEntry,currentDailyReport=_props.currentDailyReport;var sub_technician=report.sub_technician,tech_number=report.tech_number,hours_worked=report.hours_worked,preset_tasks=report.preset_tasks,preset_task_other=report.preset_task_other,location=report.location,work_performed=report.work_performed,additionalInfo=report.additionalInfo;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-sub-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,sub_technician?sub_technician.first_name+' '+(sub_technician.last_name||''):'Technician '+tech_number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Total Hours: ',hours_worked||0)),!readOnly&&index===0&&currentDailyReport.status!=='approved'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Edit',onClick:editEntry.bind(null,parentReport)}))),(preset_tasks&&preset_tasks.length>0||preset_task_other)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title'},'Tasks Performed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-block-content review-form-block-content-no-underline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,preset_tasks.length>0&&preset_tasks.map(function(task){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:task.id},task.label);}),preset_task_other&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,preset_task_other)))),location&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title'},'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-text-block'},location)),work_performed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title'},'Work Performed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-text-block'},work_performed)),additionalInfo&&additionalInfo.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title'},'Additional locations')),additionalInfo.map(function(info){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:info.id,className:'review-form-trade-block-additional-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title'},'Total Hours: ',info.hours_worked||0)),(info.preset_tasks&&info.preset_tasks.length>0||info.preset_task_other)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title'},'Tasks Performed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-block-content review-form-block-content-no-underline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,info.preset_tasks.length>0&&info.preset_tasks.map(function(task){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:task.id},task.label);}),info.preset_task_other&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,info.preset_task_other)))),info.location&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title'},'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-text-block'},info.location)),info.work_performed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-trade-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'review-form-block-title'},'Work Performed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-form-text-block'},info.work_performed)));})));}}]);return ReviewFormForSub;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ReviewFormForSub);

/***/ }),
/* 2638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DuplicateDailyReportModal_css__ = __webpack_require__(2639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DuplicateDailyReportModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DuplicateDailyReportModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_simple_loading_gif__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_simple_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_simple_loading_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_selectors__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_actions__ = __webpack_require__(95);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DuplicateDailyReportModal=function(_Component){_inherits(DuplicateDailyReportModal,_Component);function DuplicateDailyReportModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DuplicateDailyReportModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DuplicateDailyReportModal.__proto__||Object.getPrototypeOf(DuplicateDailyReportModal)).call.apply(_ref,[this].concat(args))),_this),_this.state={form:{},dupDailyReportId:null,intervalId:null},_this.fetchDailyReport=function(){var _this$props=_this.props,currentProject=_this$props.currentProject,isSubDailyReport=_this$props.isSubDailyReport,onSubmit=_this$props.onSubmit,dispatch=_this$props.dispatch;var dupDailyReportId=_this.state.dupDailyReportId;if(dupDailyReportId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_actions__["z" /* loadDailyReportInBkg */])(currentProject.id,dupDailyReportId,isSubDailyReport)).then(function(response){if(!response.dailyReport.dup_in_progress){_this.setState({dupDailyReportId:null});onSubmit();Object(__WEBPACK_IMPORTED_MODULE_7_services_utils_scroller_util__["c" /* simpleScrollToTop */])();dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_actions__["I" /* openDraftReport */])(currentProject.id,dupDailyReportId,isSubDailyReport));}});}},_this.formValid=function(){var form=_this.state.form;return!!form.reportDate;},_this.handleFormChange=function(attr,value){var form=_this.state.form;_this.setState({form:Object.assign({},form,_defineProperty({},attr,value))});},_this.handleSubmit=function(e){e.preventDefault();var _this$props2=_this.props,currentProject=_this$props2.currentProject,currentDailyReport=_this$props2.currentDailyReport,isSubDailyReport=_this$props2.isSubDailyReport,dispatch=_this$props2.dispatch;var form=_this.state.form;dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_actions__["o" /* duplicateDailyReport */])(currentProject.id,currentDailyReport.id,form,isSubDailyReport)).then(function(response){if(response.ok){_this.setState({dupDailyReportId:response.dailyReport.id});}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DuplicateDailyReportModal,[{key:'componentDidMount',value:function componentDidMount(){var intervalId=setInterval(this.fetchDailyReport,2000);this.setState({intervalId:intervalId});}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.state.intervalId);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,showModal=_props.showModal,onClose=_props.onClose;var _state=this.state,form=_state.form,dupDailyReportId=_state.dupDailyReportId;return showModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_modal_FormModal__["a" /* default */],{show:showModal,showHeader:!dupDailyReportId,onClose:onClose,title:'Duplicate Daily Report'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'duplicate-daily-report-modal'},!!dupDailyReportId?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'creating-duplicate'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Creating Duplicate'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4_images_simple_loading_gif___default.a,alt:'Creating Duplicate'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'datetime-picker-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{placeholder:'Report Date',onChange:function onChange(value){return _this2.handleFormChange('reportDate',value);},value:form.reportDate})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',disabled:!this.formValid(),className:'btn button button-orange'})))));}}]);return DuplicateDailyReportModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DuplicateDailyReportModal.propTypes={showModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,isSubDailyReport:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),currentDailyReport:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_daily_report_log_store_selectors__["f" /* getCurrentDailyReport */])(state)};})(DuplicateDailyReportModal));

/***/ }),
/* 2639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldWorkOrderActions_css__ = __webpack_require__(2642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldWorkOrderActions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FieldWorkOrderActions_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FieldWorkOrderActions=function(_Component){_inherits(FieldWorkOrderActions,_Component);function FieldWorkOrderActions(){_classCallCheck(this,FieldWorkOrderActions);return _possibleConstructorReturn(this,(FieldWorkOrderActions.__proto__||Object.getPrototypeOf(FieldWorkOrderActions)).apply(this,arguments));}_createClass(FieldWorkOrderActions,[{key:'render',value:function render(){var _props=this.props,handleClose=_props.handleClose,handleCancel=_props.handleCancel,handleSave=_props.handleSave,handleEdit=_props.handleEdit,fieldWorkOrderEdit=_props.fieldWorkOrderEdit,showErrorMessage=_props.showErrorMessage,fieldWorkOrder=_props.fieldWorkOrder;var readOnly=fieldWorkOrder.status==='gc_approved'||fieldWorkOrder.status==='gc_denied';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-order-actions'},showErrorMessage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'error-message'},'There are missing fields, please review.'),fieldWorkOrderEdit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:'Cancel',onClick:handleCancel}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Save',onClick:handleSave})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-gray',label:'Close',onClick:handleClose}),!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Edit',onClick:handleEdit})));}}]);return FieldWorkOrderActions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FieldWorkOrderActions.propTypes={handleClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (FieldWorkOrderActions);

/***/ }),
/* 2642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldWorkOrderDetails_css__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldWorkOrderDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FieldWorkOrderDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_daily_report_log_FieldWorkOrderGCForm__ = __webpack_require__(2644);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FieldWorkOrderDetails=function(_Component){_inherits(FieldWorkOrderDetails,_Component);function FieldWorkOrderDetails(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FieldWorkOrderDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FieldWorkOrderDetails.__proto__||Object.getPrototypeOf(FieldWorkOrderDetails)).call.apply(_ref,[this].concat(args))),_this),_this.status={pending:'Pending',sub_approved:'Sub-Approved',gc_approved:'GC-Approved',sub_denied:'Sub-Denied',gc_denied:'GC-Denied'},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FieldWorkOrderDetails,[{key:'render',value:function render(){var _props=this.props,fieldWorkOrder=_props.fieldWorkOrder,fieldWorkOrderForm=_props.fieldWorkOrderForm,handleAttributeChange=_props.handleAttributeChange,fieldWorkOrderEdit=_props.fieldWorkOrderEdit,showErrorMessage=_props.showErrorMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-order-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-number-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fwo-field-label'},'FWO #'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-block-content'},fieldWorkOrder.number)),(fieldWorkOrder.preset_tasks&&fieldWorkOrder.preset_tasks.length>0||fieldWorkOrder.preset_task_other)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fwo-field-label'},'Tasks to be performed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-block-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,fieldWorkOrder.preset_tasks.length>0&&fieldWorkOrder.preset_tasks.map(function(task){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:task.id},task.label);}),fieldWorkOrder.preset_task_other&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,fieldWorkOrder.preset_task_other)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fwo-field-label'},'Work to be performed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-block-content'},fieldWorkOrder.work_performed)),!!fieldWorkOrder.comments&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fwo-field-label'},'Comments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-block-content'},fieldWorkOrder.comments)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fwo-field-label'},'Start date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-block-content'},!!fieldWorkOrder.start_date?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Date__["a" /* default */],{className:'fwo-date-field',value:fieldWorkOrder.start_date,format:'MM/DD/YYYY'}):'TBD')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fwo-field-label'},'Completion date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-block-content'},!!fieldWorkOrder.completion_date?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Date__["a" /* default */],{className:'fwo-date-field',value:fieldWorkOrder.completion_date,format:'MM/DD/YYYY'}):'TBD')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fwo-field-label'},'Cost Impact'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-block-content'},fieldWorkOrder.cost_impact?'Yes':'No')),fieldWorkOrder.cost&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fwo-field-label'},'Cost'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-block-content'},fieldWorkOrder.cost)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fwo-field-label'},'Delay'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-block-content'},fieldWorkOrder.delay?'Yes':'No')),fieldWorkOrder.delay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fwo-field-label'},'Delay reason'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-block-content'},fieldWorkOrder.delay_reason)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fwo-field-label'},'Labor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-block-content'},fieldWorkOrder.labor)),!!fieldWorkOrder.materials&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fwo-field-label'},'Materials'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-block-content'},fieldWorkOrder.materials)),!fieldWorkOrderEdit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fwo-field-label'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-block-content'},this.status[fieldWorkOrder.status])),(fieldWorkOrder.status==='sub_denied'||fieldWorkOrder.status==='gc_denied')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fwo-field-label'},'Denied reason'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-block-content'},fieldWorkOrder.denied_reason))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_daily_report_log_FieldWorkOrderGCForm__["a" /* default */],{fieldWorkOrderForm:fieldWorkOrderForm,handleAttributeChange:handleAttributeChange,showErrorMessage:showErrorMessage}));}}]);return FieldWorkOrderDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FieldWorkOrderDetails.propTypes={fieldWorkOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),fieldWorkOrderForm:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),handleAttributeChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,fieldWorkOrderEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,showErrorMessage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (FieldWorkOrderDetails);

/***/ }),
/* 2644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_utils_field_work_order_util__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FieldWorkOrderDetails_css__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FieldWorkOrderDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__FieldWorkOrderDetails_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FieldWorkOrderGCForm=function(_Component){_inherits(FieldWorkOrderGCForm,_Component);function FieldWorkOrderGCForm(){_classCallCheck(this,FieldWorkOrderGCForm);return _possibleConstructorReturn(this,(FieldWorkOrderGCForm.__proto__||Object.getPrototypeOf(FieldWorkOrderGCForm)).apply(this,arguments));}_createClass(FieldWorkOrderGCForm,[{key:'missingField',value:function missingField(value){var showErrorMessage=this.props.showErrorMessage;return!value&&showErrorMessage;}},{key:'render',value:function render(){var _props=this.props,fieldWorkOrderForm=_props.fieldWorkOrderForm,handleAttributeChange=_props.handleAttributeChange;var statusList=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_5_services_utils_field_work_order_util__["a" /* fwoStatusList */]));statusList=statusList.filter(function(s){return s.value!=='pending';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-form-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'fwo-field-label'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'field-work-order-dropdown':true,'field-work-order-form-error-field':this.missingField(fieldWorkOrderForm.fwoStatus)})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_dropdown_Dropdown__["a" /* default */],{options:statusList,placeholder:'Select status',value:fieldWorkOrderForm.fwoStatus,onChange:function onChange(value){return handleAttributeChange('fwoStatus',value);}}))),fieldWorkOrderForm.fwoStatus&&fieldWorkOrderForm.fwoStatus.value==='denied'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fwo-form-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'fwo-field-label'},'Denied reason'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_input_TextArea__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'text-area-input':true,'field-work-order-form-error-field':this.missingField(fieldWorkOrderForm.fwoDeniedReason)}),onChange:handleAttributeChange.bind(null,'fwoDeniedReason'),value:fieldWorkOrderForm.fwoDeniedReason||''})));}}]);return FieldWorkOrderGCForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FieldWorkOrderGCForm.propTypes={fieldWorkOrderForm:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),handleAttributeChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,showErrorMessage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (FieldWorkOrderGCForm);

/***/ }),
/* 2645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectDocumentation_css__ = __webpack_require__(2646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectDocumentation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProjectDocumentation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_selectors_notifications__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_documentation_store_selectors__ = __webpack_require__(2647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_notifications__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_documentation_store_actions__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_documentation_DocumentsTable__ = __webpack_require__(2650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_documentation_HyperlinksTable__ = __webpack_require__(2654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_documentation_AdvancedDocumentsTable__ = __webpack_require__(2656);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var per_page=5;var drawingDocuments=[{name:'bidding_documents',param:'biddingDocuments',label:'Bidding'},{name:'plan_check_documents',param:'planCheckDocuments',label:'Plan Check'},{name:'ifc_documents',param:'ifcDocuments',label:'IFC'},{name:'bulletin_arch_documents',param:'bulletinArchDocuments',label:'Bulletin Arch'},{name:'bulletin_structural_documents',param:'bulletinStructuralDocuments',label:'Bulletin Structural'},{name:'bulletin_mep_documents',param:'bulletinMepDocuments',label:'Bulletin MEP'},{name:'sketches_documents',param:'sketchesDocuments',label:'Sketches'},{name:'ffe_documents',param:'ffeDocuments',label:'AVITS / FFE'}];var documents=[{name:'building_documents',param:'buildingDocuments',label:'Building Rules & Regs / COI Requirements'},{name:'drawing_documents',param:'drawingDocuments',label:'Drawings',subCategories:drawingDocuments},{name:'bulletin_documents',param:'bulletinDocuments',label:'Drawing Logs'},{name:'permit_documents',param:'permitDocuments',label:'Permits'},{name:'schedule_documents',param:'scheduleDocuments',label:'Schedule'},{name:'coi_documents',param:'coiDocuments',label:'COIs'},{name:'old_coi_documents',param:'oldCoiDocuments',label:'Old COIs'},{name:'change_estimate_documents',param:'changeEstimateDocuments',label:'Change Estimate Logs'},{name:'cad_documents',param:'cadDocuments',label:'CADs'},{name:'misc_documents',param:'miscDocuments',label:'Misc'}];var ProjectDocumentation=function(_Component){_inherits(ProjectDocumentation,_Component);function ProjectDocumentation(props){_classCallCheck(this,ProjectDocumentation);var _this=_possibleConstructorReturn(this,(ProjectDocumentation.__proto__||Object.getPrototypeOf(ProjectDocumentation)).call(this,props));_this.showDocs=function(docs){var currentProject=_this.props.currentProject;return!!currentProject&&(docs.param!=='changeEstimateDocuments'||!__WEBPACK_IMPORTED_MODULE_5_domain_enterprise__["a" /* Enterprise */].subcontractor(currentProject.contributor_type));};_this.documentsReadOnly=function(){var currentProject=_this.props.currentProject;return!!currentProject&&!__WEBPACK_IMPORTED_MODULE_5_domain_enterprise__["a" /* Enterprise */].spackleOrGc(currentProject.contributor_type);};_this.documentsCategoryReadOnly=function(docs){return(!_this.archOrLandlordOrSub||docs.param!=='cadDocuments')&&(!_this.architect||docs.param!=='bulletinDocuments');};_this.buildCatParams=function(page,category){return{category:category.name,page:page,per_page:per_page};};_this.hyperlinksLoad=function(){var _this$props=_this.props,currentProject=_this$props.currentProject,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_documentation_store_actions__["e" /* loadDocumentationRequest */])(currentProject.id,{category:'hyperlinks'}));};_this.pageChange=function(page,category){var _this$props2=_this.props,currentProject=_this$props2.currentProject,dispatch=_this$props2.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_documentation_store_actions__["e" /* loadDocumentationRequest */])(currentProject.id,_this.buildCatParams(page,category)));};_this.documentsCount=function(){var _this$props3=_this.props,currentProject=_this$props3.currentProject,dispatch=_this$props3.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_documentation_store_actions__["d" /* loadDocumentationCountRequest */])(currentProject.id));};_this.updateHyperlinks=function(hyperlinks){var _this$props4=_this.props,currentProject=_this$props4.currentProject,dispatch=_this$props4.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_documentation_store_actions__["i" /* updateDocumentationRequest */])(currentProject.id,{hyperlinks:hyperlinks},{category:'hyperlinks'}));};_this.parseDocuments=function(files){return files.map(function(val){return{file:val,name:val.name};});};_this.dropDocuments=function(files,category){var _this$props5=_this.props,currentProject=_this$props5.currentProject,dispatch=_this$props5.dispatch;var param=category.param;var values=_defineProperty({},param,_this.parseDocuments(files));dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_documentation_store_actions__["i" /* updateDocumentationRequest */])(currentProject.id,values,_this.buildCatParams(1,category)));};_this.confirmRemoveDocument=function(id,page,category){_this.setState({showRemoveConfirmation:true,id:id,page:page,category:category});};_this.removeDocument=function(confirmed){if(confirmed){var _this$props6=_this.props,currentProject=_this$props6.currentProject,dispatch=_this$props6.dispatch;var _this$state=_this.state,id=_this$state.id,page=_this$state.page,category=_this$state.category;var param=category.param;var values=_defineProperty({},param,[{id:id,destroy:true}]);dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_documentation_store_actions__["i" /* updateDocumentationRequest */])(currentProject.id,values,_this.buildCatParams(page,category)));}_this.setState({showRemoveConfirmation:false});};_this.documentRead=function(doc){var _this$props7=_this.props,notifications=_this$props7.notifications,dispatch=_this$props7.dispatch;notifications.content.filter(function(notification){return!notification.read_at&&notification.notifiable_type==='DocumentNotification'&&notification.notifiable.document_id===doc.id;}).forEach(function(notification){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_actions_notifications__["l" /* markAllAsRead */])(undefined,notification.notifiable.id,notification.notifiable_type));});return null;};_this.unreadNotifications=function(cat,doc){var _this$props8=_this.props,notifications=_this$props8.notifications,documentationCount=_this$props8.documentationCount;return!!notifications.content.find(function(notification){return!notification.read_at&&notification.notifiable_type==='DocumentNotification'&&notification.notifiable.documentable_id===documentationCount.id&&(cat&&notification.notifiable.document_label+'s'===cat.name||doc&&notification.notifiable.document_id===doc.id);});};_this.mapDocuments=function(category){var _this$props9=_this.props,documentation=_this$props9.documentation,documentationCount=_this$props9.documentationCount;var docs={};docs[category.name]=documentation[category.name];docs[category.name+'_count']=documentationCount[category.name+'_count'];(category.subCategories||[]).forEach(function(subCat){docs[subCat.name]=documentation[subCat.name];docs[subCat.name+'_count']=documentationCount[subCat.name+'_count'];docs[subCat.name+'_unread']=_this.unreadNotifications(subCat);(docs[subCat.name]||[]).forEach(function(doc){docs[subCat.name+'_unread_'+doc.id]=_this.unreadNotifications(null,doc);});});return docs;};_this.architect=__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["f" /* TYPES */].ARCHITECT);_this.archOrLandlordOrSub=_this.architect||__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["f" /* TYPES */].LANDLORD)||__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_4_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);_this.state={showRemoveConfirmation:false};return _this;}_createClass(ProjectDocumentation,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var currentProject=this.props.currentProject;if(currentProject){this.documentsCount();this.hyperlinksLoad();documents.filter(function(docs){return _this2.showDocs(docs)&&docs.param!=='coiDocuments';}).forEach(function(docs){return _this2.pageChange(1,docs);});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_documentation_store_actions__["h" /* resetDocumentation */])());}},{key:'render',value:function render(){var _this3=this;var _props=this.props,documentation=_props.documentation,documentationCount=_props.documentationCount,currentProject=_props.currentProject;var showRemoveConfirmation=this.state.showRemoveConfirmation;var readOnly=this.documentsReadOnly();var bucket=''+"360-custom-document";return currentProject&&currentProject.advanced_document_view?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_documentation_AdvancedDocumentsTable__["a" /* default */],{bucket:bucket,region:'us-east-1',prefix:currentProject.advanced_document_view_root_directory,delimiter:'/'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-documentation'},documentation.hyperlinks&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_documentation_HyperlinksTable__["a" /* default */],{hyperlinks:documentation.hyperlinks,readOnly:readOnly,handleUpdate:this.updateHyperlinks,handleLoad:this.hyperlinksLoad}),documentationCount&&documents.filter(function(docs){return _this3.showDocs(docs);}).map(function(docs,index){return docs.param!=='coiDocuments'&&documentation[docs.name]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_documentation_DocumentsTable__["a" /* default */],Object.assign({key:index,category:docs,perPage:per_page,readOnly:readOnly&&_this3.documentsCategoryReadOnly(docs)||docs.param==='oldCoiDocuments',handleDrop:_this3.dropDocuments,handleRemove:_this3.confirmRemoveDocument,handlePageChange:_this3.pageChange,handleDocumentRead:_this3.documentRead},_this3.mapDocuments(docs)));}),showRemoveConfirmation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_modal_ConfirmationModal__["a" /* default */],{show:showRemoveConfirmation,message:'Are you sure you want to delete this document?',onHide:this.removeDocument}));}}]);return ProjectDocumentation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_authentication__["d" /* getCurrentUser */])(state),currentProject:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),documentation:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_documentation_store_selectors__["a" /* getDocumentation */])(state),documentationCount:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_documentation_store_selectors__["b" /* getDocumentationCount */])(state),notifications:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_notifications__["b" /* getNotifications */])(state)};})(ProjectDocumentation));

/***/ }),
/* 2646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDocumentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDocumentationCount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getDocumentation=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.documentation.data.documentation;},function(documentation){return documentation;});var getDocumentationCount=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.projects.scenes.details.scenes.documentation.data.documentationCount;},function(documentationCount){return documentationCount;});

/***/ }),
/* 2648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return projectDocumentationsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectDocumentationsApi=function(_BaseApi){_inherits(ProjectDocumentationsApi,_BaseApi);function ProjectDocumentationsApi(){_classCallCheck(this,ProjectDocumentationsApi);return _possibleConstructorReturn(this,(ProjectDocumentationsApi.__proto__||Object.getPrototypeOf(ProjectDocumentationsApi)).apply(this,arguments));}_createClass(ProjectDocumentationsApi,[{key:'getProjectDocumentation',value:function getProjectDocumentation(projectId,filters){var query='';Object.keys(filters).forEach(function(filter,index){if(index>0){query+='&';}query+=filter+'='+filters[filter];});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/project_documentation?'+query).then(function(response){return{ok:true,projectDocumentation:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getProjectDocumentationCount',value:function getProjectDocumentationCount(projectId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/project_documentation/count').then(function(response){return{ok:true,projectDocumentationCount:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateProjectDocumentation',value:function updateProjectDocumentation(projectId,values,filters){var headers={headers:{'Content-Type':'multipart/form-data'}};var data=this.projectDocumentationParams(values,filters);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/projects/'+projectId+'/project_documentation',data,headers).then(function(response){return{ok:true,projectDocumentation:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'projectDocumentationParams',value:function projectDocumentationParams(values,filters){var apiPayload=new FormData();if(values.hyperlinks){if(values.hyperlinks.length>0){values.hyperlinks.forEach(function(hyperlink){apiPayload.append('project_documentation[hyperlinks][]',hyperlink);});}else{apiPayload.append('project_documentation[hyperlinks][]','');}}[{name:'building_documents_attributes',param:'buildingDocuments'},{name:'bidding_documents_attributes',param:'biddingDocuments'},{name:'plan_check_documents_attributes',param:'planCheckDocuments'},{name:'ifc_documents_attributes',param:'ifcDocuments'},{name:'bulletin_arch_documents_attributes',param:'bulletinArchDocuments'},{name:'bulletin_structural_documents_attributes',param:'bulletinStructuralDocuments'},{name:'bulletin_mep_documents_attributes',param:'bulletinMepDocuments'},{name:'sketches_documents_attributes',param:'sketchesDocuments'},{name:'ffe_documents_attributes',param:'ffeDocuments'},{name:'bulletin_documents_attributes',param:'bulletinDocuments'},{name:'permit_documents_attributes',param:'permitDocuments'},{name:'schedule_documents_attributes',param:'scheduleDocuments'},{name:'change_estimate_documents_attributes',param:'changeEstimateDocuments'},{name:'cad_documents_attributes',param:'cadDocuments'},{name:'misc_documents_attributes',param:'miscDocuments'}].forEach(function(attr){var name=attr.name;var param=attr.param;!!values[param]&&values[param].forEach(function(doc,index){if(doc.id){apiPayload.append('project_documentation['+name+']['+index+'][id]',doc.id);apiPayload.append('project_documentation['+name+']['+index+'][_destroy]',doc.destroy);}else{apiPayload.append('project_documentation['+name+']['+index+'][document]',doc.file,doc.name);}});});Object.keys(filters).forEach(function(filter){apiPayload.append(filter,filters[filter]);});return apiPayload;}}]);return ProjectDocumentationsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var projectDocumentationsApi=new ProjectDocumentationsApi();

/***/ }),
/* 2649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return projectAdvancedDocumentsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectAdvancedDocumentsApi=function(_BaseApi){_inherits(ProjectAdvancedDocumentsApi,_BaseApi);function ProjectAdvancedDocumentsApi(){_classCallCheck(this,ProjectAdvancedDocumentsApi);return _possibleConstructorReturn(this,(ProjectAdvancedDocumentsApi.__proto__||Object.getPrototypeOf(ProjectAdvancedDocumentsApi)).apply(this,arguments));}_createClass(ProjectAdvancedDocumentsApi,[{key:'createAdvancedDocumentsFolder',value:function createAdvancedDocumentsFolder(projectId,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var apiPayload=new FormData();apiPayload.append('advanced_documents[folder_name]',values.folderName);apiPayload.append('advanced_documents[prefix]',values.prefix);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/projects/'+projectId+'/advanced_documents/create_folder',apiPayload,headers).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'renameAdvancedDocumentsFolder',value:function renameAdvancedDocumentsFolder(projectId,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var apiPayload=new FormData();apiPayload.append('advanced_documents[folder_name]',values.folderName);apiPayload.append('advanced_documents[prefix]',values.prefix);apiPayload.append('advanced_documents[old_folder_name]',values.oldFolderName);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/projects/'+projectId+'/advanced_documents/rename_folder',apiPayload,headers).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'uploadAdvancedDocuments',value:function uploadAdvancedDocuments(projectId,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var apiPayload=new FormData();apiPayload.append('advanced_documents[prefix]',values.prefix);values.documents.forEach(function(doc,index){apiPayload.append('advanced_documents[documents]['+index+'][document]',doc.file,doc.name);});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/projects/'+projectId+'/advanced_documents/upload_documents',apiPayload,headers).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'deleteAdvancedDocuments',value:function deleteAdvancedDocuments(projectId,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var apiPayload=new FormData();apiPayload.append('advanced_documents[prefix]',values.prefix);values.documents.forEach(function(doc,index){apiPayload.append('advanced_documents[documents]['+index+'][document]',doc);});values.folders.forEach(function(folder,index){apiPayload.append('advanced_documents[folders]['+index+'][folder]',folder);});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/projects/'+projectId+'/advanced_documents/delete_files_and_folders',apiPayload,headers).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'downloadAdvancedDocumentsFolder',value:function downloadAdvancedDocumentsFolder(values){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://spackle-v1.fly.dev/","REACT_APP_CABLE_WSS_URL":"wss://spackle-v1.fly.dev/cable","REACT_APP_ADVANCED_DOCUMENTS_S3_BUCKET":"360-custom-document","REACT_APP_CLICKUP_FORM_URL":"https://forms.clickup.com/f/86zjg-822/NRB5VVG05QA0QWA5V1","REACT_APP_WEBVIEWER_URL":"https://spackle.s3.amazonaws.com/lib"}).REACT_APP_GATEWAY_API_URL+'/download_folders',{selectedFolders:values.selectedFolders,bucket:values.bucket,message:values.message,subject:values.subject,recipients:values.recipients,rootFolder:values.rootFolder,selectedFiles:values.selectedFiles}).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response};});}},{key:'moveAdvancedDocumentsFolder',value:function moveAdvancedDocumentsFolder(projectId,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var apiPayload=new FormData();apiPayload.append('advanced_documents[selected_object]',values.selectedObject);apiPayload.append('advanced_documents[selected_destination',values.selectedDestination);apiPayload.append('advanced_documents[parent_folder',values.parentFolder);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/projects/'+projectId+'/advanced_documents/move_object',apiPayload,headers).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return ProjectAdvancedDocumentsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var projectAdvancedDocumentsApi=new ProjectAdvancedDocumentsApi();

/***/ }),
/* 2650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DocumentsTable_css__ = __webpack_require__(2651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DocumentsTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DocumentsTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_upload_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_upload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_text_BaseStatus__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_documentation_SelectSubcategoryModal__ = __webpack_require__(2652);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DocumentsTable=function(_Component){_inherits(DocumentsTable,_Component);function DocumentsTable(props){_classCallCheck(this,DocumentsTable);var _this=_possibleConstructorReturn(this,(DocumentsTable.__proto__||Object.getPrototypeOf(DocumentsTable)).call(this,props));_initialiseProps.call(_this);var categories=_this.buildCategories(props.category);_this.state={currentPage:1,selectedCategory:categories[0],categories:categories,showSelectSubcatModal:false};return _this;}_createClass(DocumentsTable,[{key:'render',value:function render(){var _this2=this;var _props=this.props,category=_props.category,perPage=_props.perPage,readOnly=_props.readOnly;var _state=this.state,currentPage=_state.currentPage,selectedCategory=_state.selectedCategory,categories=_state.categories,showSelectSubcatModal=_state.showSelectSubcatModal;var subCatsPresent=category.subCategories&&category.subCategories.length>0;var total=this.props[selectedCategory.name+'_count'];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'documents-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'documents-nav'+(subCatsPresent?' with-subcategories':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_navigation_NavigationBar__["a" /* default */],{items:categories.map(function(cat){return Object.assign({},cat,{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this2.props[cat.name+'_unread']&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_BaseStatus__["a" /* default */],{labels:[{id:'unread',label:''}],status:'unread'}),cat.label),total:_this2.props[cat.name+'_count']});}),selectedValue:selectedCategory.id,onSelected:this.handleNavSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table',headers:['FILENAME','DATE ADDED'],rows:this.mapDocuments(),emptyMessage:'No documents added yet.'}),!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx, .jpg, .jpeg, .gif, .png, .dwg',className:'dropzone-container',onDrop:this.handleDrop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5_images_upload_svg___default.a,alt:'upload'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Please drag and drop any file into this area'))),total>perPage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPage,pageSize:perPage,total:total,onPageChange:function onPageChange(page){return _this2.handlePageChange(page,selectedCategory);}})),showSelectSubcatModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_documentation_SelectSubcategoryModal__["a" /* default */],{showModal:showSelectSubcatModal,options:selectedCategory.subCategories.map(function(subCat){return{value:subCat.param,label:subCat.label};}),onSubmit:this.handleSelectSubcatModalSubmit,onClose:this.handleSelectSubcatModalClose}));}}]);return DocumentsTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DocumentsTable.propTypes={category:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,perPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,handleDrop:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleRemove:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handlePageChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleDocumentRead:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};var _initialiseProps=function _initialiseProps(){var _this3=this;this.buildCategories=function(category){var subCats=(category.subCategories||[]).map(function(subCat,index){return Object.assign({id:index+2},subCat);});return[Object.assign({id:1},category)].concat(_toConsumableArray(subCats));};this.handleNavSelect=function(id){var categories=_this3.state.categories;var selectedCategory=categories.find(function(cat){return cat.id===id;});_this3.setState({selectedCategory:selectedCategory});_this3.handlePageChange(1,selectedCategory);};this.handlePageChange=function(page,category){_this3.props.handlePageChange(page,category);_this3.setState({currentPage:page});};this.handleDrop=function(files){var handleDrop=_this3.props.handleDrop;var selectedCategory=_this3.state.selectedCategory;var subCatsPresent=selectedCategory.subCategories&&selectedCategory.subCategories.length>0;if(subCatsPresent){_this3.setState({showSelectSubcatModal:true,files:files});}else{handleDrop(files,selectedCategory);_this3.setState({currentPage:1});}};this.handleSelectSubcatModalSubmit=function(param){var handleDrop=_this3.props.handleDrop;var _state2=_this3.state,selectedCategory=_state2.selectedCategory,files=_state2.files;handleDrop(files,Object.assign({},selectedCategory,{param:param}));_this3.setState({showSelectSubcatModal:false,currentPage:1});};this.handleSelectSubcatModalClose=function(){_this3.setState({showSelectSubcatModal:false});};this.handleRemove=function(doc){var handleRemove=_this3.props.handleRemove;var _state3=_this3.state,currentPage=_state3.currentPage,selectedCategory=_state3.selectedCategory,categories=_state3.categories;var param=categories.find(function(cat){return cat.name===doc.label+'s';}).param;handleRemove(doc.id,currentPage,Object.assign({},selectedCategory,{param:param}));};this.mapDocuments=function(docs){var _props2=_this3.props,readOnly=_props2.readOnly,handleDocumentRead=_props2.handleDocumentRead;var selectedCategory=_this3.state.selectedCategory;return(_this3.props[selectedCategory.name]||[]).map(function(doc){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'doc-viewer'},_this3.props[selectedCategory.name+'_unread_'+doc.id]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_BaseStatus__["a" /* default */],{labels:[{id:'unread',label:''}],status:'unread'}),!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'remove-doc-icon',src:__WEBPACK_IMPORTED_MODULE_4_images_remove_png___default.a,alt:'remove',onClick:function onClick(){return _this3.handleRemove(doc);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_document_DocumentLink__["a" /* default */],{url:doc.document.url,onClick:function onClick(){return handleDocumentRead(doc);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_text_Date__["a" /* default */],{value:doc.created_at,format:'MM/DD/YYYY'})];});};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(DocumentsTable));

/***/ }),
/* 2651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectSubcategoryModal_css__ = __webpack_require__(2653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectSubcategoryModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SelectSubcategoryModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectSubcategoryModal=function(_Component){_inherits(SelectSubcategoryModal,_Component);function SelectSubcategoryModal(props){_classCallCheck(this,SelectSubcategoryModal);var _this=_possibleConstructorReturn(this,(SelectSubcategoryModal.__proto__||Object.getPrototypeOf(SelectSubcategoryModal)).call(this,props));_this.handleChange=function(option){_this.setState({selectedOption:option});};_this.handleSubmit=function(){_this.props.onSubmit(_this.state.selectedOption.value);};_this.state={selectedOption:null};return _this;}_createClass(SelectSubcategoryModal,[{key:'render',value:function render(){var _props=this.props,showModal=_props.showModal,options=_props.options,onClose=_props.onClose;var selectedOption=this.state.selectedOption;return showModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__["a" /* default */],{show:showModal,onClose:onClose,title:'Select the Subcategory'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-documentation-select-subcategory-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_dropdown_Dropdown__["a" /* default */],{options:options,placeholder:'Subcategories...',value:selectedOption&&selectedOption.value,onChange:this.handleChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_button_Button__["a" /* default */],{disabled:!selectedOption,className:'button-orange',label:'Done',onClick:this.handleSubmit}))));}}]);return SelectSubcategoryModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelectSubcategoryModal.propTypes={showModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,options:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})).isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(SelectSubcategoryModal));

/***/ }),
/* 2653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HyperlinksTable_css__ = __webpack_require__(2655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HyperlinksTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__HyperlinksTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HyperlinksTable=function(_Component){_inherits(HyperlinksTable,_Component);function HyperlinksTable(props){_classCallCheck(this,HyperlinksTable);var _this=_possibleConstructorReturn(this,(HyperlinksTable.__proto__||Object.getPrototypeOf(HyperlinksTable)).call(this,props));_this.onNewHyperlinkChange=function(hyperlink){_this.setState({newHyperlink:hyperlink});};_this.onNewHyperlinkNameChange=function(hyperlinkName){_this.setState({newHyperlinkName:hyperlinkName});};_this.addHyperlink=function(e){e.preventDefault();var pattern=/^((http|https|ftp):\/\/)/;var _this$props=_this.props,hyperlinks=_this$props.hyperlinks,handleUpdate=_this$props.handleUpdate;var _this$state=_this.state,newHyperlink=_this$state.newHyperlink,newHyperlinkName=_this$state.newHyperlinkName;var hyperlinkPayload=[newHyperlink,newHyperlinkName];if(!pattern.test(newHyperlink)){hyperlinkPayload[0]='http://'+newHyperlink;}handleUpdate([].concat(_toConsumableArray(hyperlinks),[hyperlinkPayload]));_this.onNewHyperlinkChange('');_this.onNewHyperlinkNameChange('');};_this.confirmRemoveHyperlink=function(index){_this.setState({showRemoveConfirmation:true,index:index});};_this.removeHyperlink=function(confirmed){if(confirmed){var _this$props2=_this.props,hyperlinks=_this$props2.hyperlinks,handleUpdate=_this$props2.handleUpdate;var index=_this.state.index;hyperlinks.splice(index,1);handleUpdate(hyperlinks);}_this.setState({showRemoveConfirmation:false});};_this.mapHyperlinks=function(){var _this$props3=_this.props,hyperlinks=_this$props3.hyperlinks,readOnly=_this$props3.readOnly;return hyperlinks.map(function(hyperlink,index){hyperlink=hyperlink.split(',');var name=hyperlink.length>1&&hyperlink[1]?hyperlink[1]:hyperlink[0];return hyperlink&&[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hyperlink-viewer'},!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'remove-doc-icon',src:__WEBPACK_IMPORTED_MODULE_5_images_remove_png___default.a,alt:'remove',onClick:function onClick(){return _this.confirmRemoveHyperlink(index);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:hyperlink[0],target:'_blank',onClick:function onClick(event){return event.stopPropagation();}},name))];}).filter(function(row){return row;});};_this.state={newHyperlink:'',newHyperlinkName:'',showRemoveConfirmation:false};return _this;}_createClass(HyperlinksTable,[{key:'render',value:function render(){var _props=this.props,hyperlinks=_props.hyperlinks,readOnly=_props.readOnly,handleLoad=_props.handleLoad;var _state=this.state,newHyperlink=_state.newHyperlink,newHyperlinkName=_state.newHyperlinkName,showRemoveConfirmation=_state.showRemoveConfirmation;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hyperlinks-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hyperlinks-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'Hyperlinks',total:hyperlinks.length}],selectedValue:1,onSelected:handleLoad})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table',rows:this.mapHyperlinks(),emptyMessage:'No hyperlinks added yet.'}),!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'hyperlink-form',onSubmit:this.addHyperlink},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{placeholder:'https://',value:newHyperlink,onChange:this.onNewHyperlinkChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_input_Input__["a" /* default */],{placeholder:'Name to Display',value:newHyperlinkName,onChange:this.onNewHyperlinkNameChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',value:'Add',className:'btn button button-orange',disabled:!newHyperlink||!newHyperlinkName})),showRemoveConfirmation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_ConfirmationModal__["a" /* default */],{show:showRemoveConfirmation,message:'Are you sure you want to delete this hyperlink?',onHide:this.removeHyperlink}));}}]);return HyperlinksTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);HyperlinksTable.propTypes={hyperlinks:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string).isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,handleUpdate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleLoad:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(HyperlinksTable));

/***/ }),
/* 2655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aws_sdk__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aws_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aws_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AdvancedDocumentsTable_css__ = __webpack_require__(2967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AdvancedDocumentsTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AdvancedDocumentsTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_react_fontawesome__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_solid_faFolder__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_solid_faFolder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_solid_faFolder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CreateFolderModal__ = __webpack_require__(2968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UploadFilesModal__ = __webpack_require__(2970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DownloadObjectsModal__ = __webpack_require__(2972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_documentation_store_actions__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__MoveFolderOrFileModal__ = __webpack_require__(2974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_shared_table_SimpleHeader__ = __webpack_require__(202);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_2_aws_sdk___default.a.config.region='us-east-1';var s3=new __WEBPACK_IMPORTED_MODULE_2_aws_sdk___default.a.S3();var AdvancedDocumentsTable=function(_Component){_inherits(AdvancedDocumentsTable,_Component);function AdvancedDocumentsTable(props){_classCallCheck(this,AdvancedDocumentsTable);var _this=_possibleConstructorReturn(this,(AdvancedDocumentsTable.__proto__||Object.getPrototypeOf(AdvancedDocumentsTable)).call(this,props));_this.componentDidMount=function(){_this.renderDocuments();};_this.renderDocuments=function(){_this.fetchFiles();};_this.retrieveFolder=function(event,prefix){event.preventDefault();_this.setState({prefix:prefix},function(){_this.renderDocuments();});};_this.bytesToSize=function(bytes){var sizes=['Bytes','KB','MB','GB','TB'];if(bytes===0)return'0 Bytes';var ii=parseInt(Math.floor(Math.log(bytes)/Math.log(1024)),10);return Math.round(bytes/Math.pow(1024,ii),2)+' '+sizes[ii];};_this.htmlEscape=function(str){return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;').replace(/\//g,'&#x2F;').replace(/`/g,'&#x60;').replace(/=/g,'&#x3D;');};_this.isFolder=function(path){return path.endsWith('/');};_this.isThisDocument=function(key){return key==='index.html';};_this.getPath=function(file){return file.Key?file.Key:file.Prefix;};_this.fullPathToFileName=function(path){return _this.htmlEscape(path.replace(/^.*[\\/]/,''));};_this.fullPathToFolder=function(prefix){var escape=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var parts=prefix.split('/');var rc=parts[parts.length-2]+'/';return escape?_this.htmlEscape(rc):rc;};_this.fileS3Path=function(key){var enckey=key.split('/').map(function(x){return encodeURIComponent(x);}).join('/');if(__WEBPACK_IMPORTED_MODULE_2_aws_sdk___default.a.config.region==='us-east-1'){return document.location.protocol+'//'+_this.props.bucket+'.s3.amazonaws.com/'+enckey;}else{return document.location.protocol+'//'+_this.props.bucket+'.s3-'+__WEBPACK_IMPORTED_MODULE_2_aws_sdk___default.a.config.region+'.amazonaws.com/'+enckey;}};_this.renderObject=function(file){var path=_this.getPath(file);if(file.Prefix){var handleClick=function handleClick(e){return _this.retrieveFolder(e,file.Prefix);};var folderName=_this.fullPathToFolder(path);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#file',onClick:handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__fortawesome_react_fontawesome__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_solid_faFolder___default.a}),' ',folderName,' ');}else{var filePath=_this.fileS3Path(file.Key);var fileName=_this.fullPathToFileName(path);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:filePath,target:'_blank'},fileName,' ');}};_this.getFolderPath=function(){return _this.props.bucket+'/'+_this.state.prefix;};_this.breadCrumbClick=function(e,savePrefix){e.preventDefault();_this.setState({prefix:savePrefix},function(){_this.fetchFiles();});};_this.topLevelBreadCrumbClick=function(e){e.preventDefault();_this.setState({prefix:''},function(){_this.fetchFiles();});};_this.breadcrumbPrefix=function(parts,part){var partIndex=parts.indexOf(part);var prefix='';parts.forEach(function(part,index){// Skip prefix for the bucket if present
if(index<=partIndex&&!_this.props.bucket.includes(part)){prefix=prefix.concat(part+'/');}});return prefix;};_this.displayPart=function(part){var prefix=_this.props.prefix.replace('/','');return prefix===part?'Documents':part;};_this.folderToBreadcrumbs=function(){var parts=[_this.props.bucket];if(_this.state.prefix){parts.push.apply(parts,_this.state.prefix.endsWith('/')?_this.state.prefix.slice(0,-1).split('/'):_this.state.prefix.split('/'));}var buildPrefix=parts.map(function(part,i){if(i!==0){if(i===parts.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,className:'active'},_this.displayPart(part));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'',onClick:function onClick(e){_this.breadCrumbClick(e,_this.breadcrumbPrefix(parts,part));}},_this.displayPart(part)));}}return false;});return buildPrefix;};_this.updateFilesDisplayed=function(scope){return function(err,data){var filesSortDirection=_this.state.filesSortDirection;if(err){scope.stop=true;}else{var files=data.Contents;files=files.concat(data.CommonPrefixes);if(scope.params.Prefix){// filter out folder if prefix
files=files.filter(function(file){return file.Key!==scope.params.Prefix;});}_this.setState({files:files},function(){_this.sortFilesColumns(filesSortDirection);});}};};_this.showRenameFolderModal=function(event,prefix){event.preventDefault();var folderName=_this.fullPathToFolder(prefix).replace('/','');_this.setState({showCreateFolderModal:true,currentFolderName:folderName,renameFolder:true});};_this.renameFolderButton=function(file){if(file.Prefix&&_this.canUserPerformActions()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'',className:'table-action-button',style:{marginRight:'39px'},onClick:function onClick(e){return _this.showRenameFolderModal(e,file.Prefix);}},'Rename');}};_this.moveObjectButton=function(file){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'',className:'table-action-button',onClick:function onClick(e){return _this.showMoveFolderModalClick(e,file);}},'Move');};_this.showMoveFolderModalClick=function(e,file){e.preventDefault();_this.setState({showMoveFolderModal:true,moveObjectSelected:file.Key||file.Prefix});};_this.handleMoveFolderModalClose=function(){_this.setState({showMoveFolderModal:false});};_this.handleMoveFolderModalSubmit=function(){};_this.showDownloadObjectsModalClick=function(prefix){_this.setState({showDownloadObjectsModal:true});};_this.showCreateFolderModalClick=function(){_this.setState({showCreateFolderModal:true,renameFolder:false,currentFolderName:null});};_this.handleCreateFolderModalClose=function(){_this.setState({showCreateFolderModal:false,renameFolder:false,currentFolderName:null});};_this.handleCreateFolderModalSubmit=function(submitValues){var _this$props=_this.props,currentProject=_this$props.currentProject,dispatch=_this$props.dispatch;var renameFolder=_this.state.renameFolder;var values={folderName:submitValues.folderName,prefix:submitValues.prefix};if(!renameFolder){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_documentation_store_actions__["a" /* createAdvancedDocumentsFolderRequest */])(currentProject.id,values)).then(function(response){if(response.ok){_this.setState({showCreateFolderModal:false});_this.renderDocuments();}});}else{values.oldFolderName=submitValues.oldFolderName;values.prefix=submitValues.prefix;dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_documentation_store_actions__["g" /* renameAdvancedDocumentsFolderRequest */])(currentProject.id,values)).then(function(response){if(response.ok){_this.handleCreateFolderModalClose();_this.renderDocuments();}});}};_this.handleUploadFilesModalSubmit=function(documents){var _this$props2=_this.props,currentProject=_this$props2.currentProject,dispatch=_this$props2.dispatch;var values=Object.assign({},_this.state,{documents:documents});dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_documentation_store_actions__["j" /* uploadAdvancedDocumentsRequest */])(currentProject.id,values)).then(function(response){if(response.ok){_this.setState({showUploadFilesModal:false});_this.renderDocuments();}});};_this.fetchFiles=function(){var params={Bucket:_this.props.bucket,Prefix:_this.state.prefix,Delimiter:_this.props.delimiter};var scope={Contents:[],CommonPrefixes:[],params:params,stop:false};scope.cb=_this.updateFilesDisplayed;return s3.makeUnauthenticatedRequest('listObjectsV2',scope.params,_this.updateFilesDisplayed(scope));};_this.createFolderTitle=function(){return _this.state.renameFolder?'Rename Folder':'Create Folder';};_this.showUploadFilesModalClick=function(){_this.setState({showUploadFilesModal:true});};_this.handleUploadFilesModalClose=function(){_this.setState({showUploadFilesModal:false});};_this.showDeleteFilesConfirmationClick=function(){_this.setState({showDeleteFilesConfirmation:true});};_this.showEmailObjectsModalClick=function(){_this.setState({showEmailObjectsModal:true});};_this.handleEmailObjectsModalClose=function(){_this.setState({showEmailObjectsModal:false});};_this.canUserPerformActions=function(){var currentUser=_this.props.currentUser;return __WEBPACK_IMPORTED_MODULE_13_services_utils_users_util__["g" /* usersUtil */].isAdmin(currentUser)||__WEBPACK_IMPORTED_MODULE_13_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_13_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR)||__WEBPACK_IMPORTED_MODULE_13_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_13_services_utils_users_util__["f" /* TYPES */].ARCHITECT);};_this.onChangeActionButtons=function(option){switch(option.value){case'download':if(!_this.areObjectsSelected())return;_this.showDownloadObjectsModalClick();break;case'upload':_this.showUploadFilesModalClick();break;case'delete':if(!_this.areObjectsSelected())return;_this.showDeleteFilesConfirmationClick();break;case'email':if(!_this.areObjectsSelected())return;_this.showEmailObjectsModalClick();break;default:break;}};_this.renderActionButtons=function(){var options=[{value:'upload',label:'Upload'},{value:'download',label:'Download'},{value:'email',label:'Email'},{value:'delete',label:'Delete'}];if(_this.canUserPerformActions()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{href:'',className:'button',onClick:_this.showCreateFolderModalClick},'Create Folder'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_shared_dropdown_Dropdown__["a" /* default */],{options:options,placeholder:'...',value:null,onChange:function onChange(option){return _this.onChangeActionButtons(option);}}));}};_this.renderCheckbox=function(file){var value=file.Key?file.Key:file.Prefix;var classname=file.Key?'file':'folder';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',className:classname,value:value});};_this.allCheckboxes=function(){return document.querySelectorAll("input[class='file'], input[class='folder']");};_this.selectAllCheckboxes=function(){var value=!_this.state.selectAll;var checkboxes=_this.allCheckboxes();checkboxes.forEach(function(checkbox){checkbox.checked=value?'checked':'';});_this.setState({selectAll:value});};_this.unselectAllCheckboxes=function(){var checkboxes=_this.allCheckboxes();checkboxes.forEach(function(checkbox){checkbox.checked='';});_this.setState({selectAll:false});};_this.selectedFiles=function(){var selectedFiles=[];var checkboxes=document.querySelectorAll("input[class='file']");checkboxes.forEach(function(checkbox){if(checkbox.checked)return selectedFiles.push(checkbox.value);});return selectedFiles;};_this.selectedFolders=function(){var selectedFolders=[];var checkboxes=document.querySelectorAll("input[class='folder']");checkboxes.forEach(function(checkbox){if(checkbox.checked)return selectedFolders.push(checkbox.value);});return selectedFolders;};_this.areObjectsSelected=function(){return _this.selectedFolders().length>0||_this.selectedFiles().length>0;};_this.deleteSelectedObjects=function(){var _this$props3=_this.props,currentProject=_this$props3.currentProject,dispatch=_this$props3.dispatch;var selectedFiles=_this.selectedFiles();var selectedFolders=_this.selectedFolders();var values=Object.assign({},_this.state,{documents:selectedFiles,folders:selectedFolders});dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_documentation_store_actions__["b" /* deleteAdvancedDocumentsRequest */])(currentProject.id,values)).then(function(response){if(response.ok){_this.renderDocuments();_this.unselectAllCheckboxes();}});};_this.handleDeleteFilesConfirmation=function(confirmed){_this.setState({showDeleteFilesConfirmation:false});confirmed&&_this.deleteSelectedObjects();};_this.handleDownloadObjectModalClose=function(){_this.setState({showDownloadObjectsModal:false});};_this.handleDownloadObjectsModalSubmit=function(params){var _this$props4=_this.props,bucket=_this$props4.bucket,region=_this$props4.region,dispatch=_this$props4.dispatch;var prefix=_this.state.prefix;var values={bucket:bucket,region:region,recipients:params.recipients,subject:params.subject,message:params.message,selectedFolders:_this.selectedFolders(),rootFolder:prefix,selectedFiles:_this.selectedFiles()};dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_documentation_store_actions__["c" /* downloadAdvancedDocumentsFolderRequest */])(values)).then(function(response){if(response.ok){_this.handleDownloadObjectModalClose();_this.handleEmailObjectsModalClose();_this.renderDocuments();_this.unselectAllCheckboxes();}});};_this.handleMoveFolderModalSubmit=function(params){var _this$props5=_this.props,dispatch=_this$props5.dispatch,currentProject=_this$props5.currentProject;dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_documentation_store_actions__["f" /* moveAdvancedDocumentsFolderRequest */])(currentProject.id,params)).then(function(response){if(response.ok){_this.handleMoveFolderModalClose();_this.renderDocuments();}});};_this.sortTable=function(table,col,reverse){var tb=table.tBodies[0],// use `<tbody>` to ignore `<thead>` and `<tfoot>` rows
tr=Array.prototype.slice.call(tb.rows,0),// put rows into array
i;reverse=-(+reverse||-1);tr=tr.sort(function(a,b){// sort rows
return reverse*// `-1 *` if want opposite order
a.cells[col].textContent.trim()// using `.textContent.trim()` for test
.localeCompare(b.cells[col].textContent.trim());});for(i=0;i<tr.length;++i){tb.appendChild(tr[i]);}// append each row in order
};_this.sortFilesColumns=function(direction){var table=document.getElementById('advanced-documents-table-table');var ascending=direction!=='ascending';_this.setState({filesSortDirection:direction});_this.sortTable(table,1,ascending);};_this.emailObjectsModalMessage=function(){var currentProject=_this.props.currentProject;var _currentProject$build=currentProject.building.location,street_address_1=_currentProject$build.street_address_1,city=_currentProject$build.city,state=_currentProject$build.state;return('Please find the below link to download  documents for '+currentProject.name+', located at '+street_address_1+', '+city+', '+state+'.\n\nIf you have questions, please contact me via the in app chat or email.').trim();};_this.state={files:[],prefix:_this.props.prefix,showCreateFolderModal:false,currentFolderName:null,showUploadFilesModal:false,renameFolder:false,selectAll:false,showDeleteFilesConfirmation:false,showDownloadObjectsModal:false,showMoveFolderModal:false,moveObjectSelected:null,showEmailObjectsModal:false,filesHeaderStatus:null,filesSortDirection:'ascending'};return _this;}_createClass(AdvancedDocumentsTable,[{key:'render',value:function render(){var _this2=this;var _props=this.props,currentProject=_props.currentProject,currentUser=_props.currentUser,bucket=_props.bucket;var _state=this.state,showCreateFolderModal=_state.showCreateFolderModal,currentFolderName=_state.currentFolderName,showUploadFilesModal=_state.showUploadFilesModal,prefix=_state.prefix,showDeleteFilesConfirmation=_state.showDeleteFilesConfirmation,showDownloadObjectsModal=_state.showDownloadObjectsModal,showMoveFolderModal=_state.showMoveFolderModal,moveObjectSelected=_state.moveObjectSelected,showEmailObjectsModal=_state.showEmailObjectsModal,filesSortDirection=_state.filesSortDirection;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'advanced-documents-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-heading clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row title-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group col-md-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'breadcrumb',className:'breadcrumb'},this.folderToBreadcrumbs()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},this.renderActionButtons())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover',id:'advanced-documents-table-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{'data-sort-method':'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onClick:this.selectAllCheckboxes})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{'data-sort-default':true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_shared_table_SimpleHeader__["a" /* default */],{label:'FILES',filter:{options:[{id:'ascending',label:'Ascending'},{id:'descending',label:'Descending'}],selected:''+filesSortDirection},onFilterOptionSelect:this.sortFilesColumns})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{'data-sort-method':'none'},'LAST MODIFIED'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{'data-sort-method':'none'},'SIZE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{'data-sort-method':'none'},'ACTIONS'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.state.files.map(function(file,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this2.renderCheckbox(file)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this2.renderObject(file)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,file.LastModified?__WEBPACK_IMPORTED_MODULE_3_moment___default()(file.LastModified).local().format('YYYY-MM-DD HH:mm:ss'):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,file.Size?_this2.bytesToSize(file.Size):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this2.renameFolderButton(file),_this2.moveObjectButton(file)));})))))))),showCreateFolderModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CreateFolderModal__["a" /* default */],{showModal:showCreateFolderModal,onSubmit:this.handleCreateFolderModalSubmit,onClose:this.handleCreateFolderModalClose,folderName:currentFolderName,prefix:prefix,title:this.createFolderTitle()}),showUploadFilesModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__UploadFilesModal__["a" /* default */],{showModal:showUploadFilesModal,onSubmit:this.handleUploadFilesModalSubmit,onClose:this.handleUploadFilesModalClose,folderName:currentFolderName,prefix:prefix}),showDeleteFilesConfirmation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_modal_ConfirmationModal__["a" /* default */],{show:showDeleteFilesConfirmation,message:'Are you sure you want to delete these items and any sub items?',subMessage:'You cannot undo this action.',onHide:this.handleDeleteFilesConfirmation}),showDownloadObjectsModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__DownloadObjectsModal__["a" /* default */],{showModal:showDownloadObjectsModal,onSubmit:this.handleDownloadObjectsModalSubmit,onClose:this.handleDownloadObjectModalClose,folders:function folders(){return _this2.selectedFolders();},projectId:currentProject.id,currentUser:currentUser,prefix:prefix,title:'Download'}),showEmailObjectsModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__DownloadObjectsModal__["a" /* default */],{showModal:showEmailObjectsModal,onSubmit:this.handleDownloadObjectsModalSubmit,onClose:this.handleEmailObjectsModalClose,folders:function folders(){return _this2.selectedFolders();},projectId:currentProject.id,currentUser:currentUser,prefix:prefix,title:'Email',message:this.emailObjectsModalMessage()}),showMoveFolderModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__MoveFolderOrFileModal__["a" /* default */],{showModal:showMoveFolderModal,onSubmit:this.handleMoveFolderModalSubmit,onClose:this.handleMoveFolderModalClose,bucket:bucket,prefix:prefix,selectedObject:moveObjectSelected}));}}]);return AdvancedDocumentsTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AdvancedDocumentsTable.propTypes={bucket:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,prefix:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,region:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,delimiter:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_14_selectors_authentication__["d" /* getCurrentUser */])(state),currentProject:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state)};})(AdvancedDocumentsTable));

/***/ }),
/* 2657 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(2658);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(97)))

/***/ }),
/* 2658 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(97), __webpack_require__(254)))

/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(74);

function QueryParamSerializer() {
}

QueryParamSerializer.prototype.serialize = function(params, shape, fn) {
  serializeStructure('', params, shape, fn);
};

function ucfirst(shape) {
  if (shape.isQueryName || shape.api.protocol !== 'ec2') {
    return shape.name;
  } else {
    return shape.name[0].toUpperCase() + shape.name.substr(1);
  }
}

function serializeStructure(prefix, struct, rules, fn) {
  util.each(rules.members, function(name, member) {
    var value = struct[name];
    if (value === null || value === undefined) return;

    var memberName = ucfirst(member);
    memberName = prefix ? prefix + '.' + memberName : memberName;
    serializeMember(memberName, value, member, fn);
  });
}

function serializeMap(name, map, rules, fn) {
  var i = 1;
  util.each(map, function (key, value) {
    var prefix = rules.flattened ? '.' : '.entry.';
    var position = prefix + (i++) + '.';
    var keyName = position + (rules.key.name || 'key');
    var valueName = position + (rules.value.name || 'value');
    serializeMember(name + keyName, key, rules.key, fn);
    serializeMember(name + valueName, value, rules.value, fn);
  });
}

function serializeList(name, list, rules, fn) {
  var memberRules = rules.member || {};

  if (list.length === 0) {
    fn.call(this, name, null);
    return;
  }

  util.arrayEach(list, function (v, n) {
    var suffix = '.' + (n + 1);
    if (rules.api.protocol === 'ec2') {
      // Do nothing for EC2
      suffix = suffix + ''; // make linter happy
    } else if (rules.flattened) {
      if (memberRules.name) {
        var parts = name.split('.');
        parts.pop();
        parts.push(ucfirst(memberRules));
        name = parts.join('.');
      }
    } else {
      suffix = '.' + (memberRules.name ? memberRules.name : 'member') + suffix;
    }
    serializeMember(name + suffix, v, memberRules, fn);
  });
}

function serializeMember(name, value, rules, fn) {
  if (value === null || value === undefined) return;
  if (rules.type === 'structure') {
    serializeStructure(name, value, rules, fn);
  } else if (rules.type === 'list') {
    serializeList(name, value, rules, fn);
  } else if (rules.type === 'map') {
    serializeMap(name, value, rules, fn);
  } else {
    fn(name, rules.toWireFormat(value).toString());
  }
}

module.exports = QueryParamSerializer;


/***/ }),
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(74);
var builder = __webpack_require__(2661);

function XmlBuilder() { }

XmlBuilder.prototype.toXML = function(params, shape, rootElement, noEmpty) {
  var xml = builder.create(rootElement);
  applyNamespaces(xml, shape);
  serialize(xml, params, shape);
  return xml.children.length > 0 || noEmpty ? xml.root().toString() : '';
};

function serialize(xml, value, shape) {
  switch (shape.type) {
    case 'structure': return serializeStructure(xml, value, shape);
    case 'map': return serializeMap(xml, value, shape);
    case 'list': return serializeList(xml, value, shape);
    default: return serializeScalar(xml, value, shape);
  }
}

function serializeStructure(xml, params, shape) {
  util.arrayEach(shape.memberNames, function(memberName) {
    var memberShape = shape.members[memberName];
    if (memberShape.location !== 'body') return;

    var value = params[memberName];
    var name = memberShape.name;
    if (value !== undefined && value !== null) {
      if (memberShape.isXmlAttribute) {
        xml.att(name, value);
      } else if (memberShape.flattened) {
        serialize(xml, value, memberShape);
      } else {
        var element = xml.ele(name);
        applyNamespaces(element, memberShape);
        serialize(element, value, memberShape);
      }
    }
  });
}

function serializeMap(xml, map, shape) {
  var xmlKey = shape.key.name || 'key';
  var xmlValue = shape.value.name || 'value';

  util.each(map, function(key, value) {
    var entry = xml.ele(shape.flattened ? shape.name : 'entry');
    serialize(entry.ele(xmlKey), key, shape.key);
    serialize(entry.ele(xmlValue), value, shape.value);
  });
}

function serializeList(xml, list, shape) {
  if (shape.flattened) {
    util.arrayEach(list, function(value) {
      var name = shape.member.name || shape.name;
      var element = xml.ele(name);
      serialize(element, value, shape.member);
    });
  } else {
    util.arrayEach(list, function(value) {
      var name = shape.member.name || 'member';
      var element = xml.ele(name);
      serialize(element, value, shape.member);
    });
  }
}

function serializeScalar(xml, value, shape) {
  xml.txt(shape.toWireFormat(value));
}

function applyNamespaces(xml, shape) {
  var uri, prefix = 'xmlns';
  if (shape.xmlNamespaceUri) {
    uri = shape.xmlNamespaceUri;
    if (shape.xmlNamespacePrefix) prefix += ':' + shape.xmlNamespacePrefix;
  } else if (xml.isRoot && shape.api.xmlNamespaceUri) {
    uri = shape.api.xmlNamespaceUri;
  }

  if (uri) xml.att(prefix, uri);
}

module.exports = XmlBuilder;


/***/ }),
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLBuilder, assign;

  assign = __webpack_require__(838);

  XMLBuilder = __webpack_require__(2662);

  module.exports.create = function(name, xmldec, doctype, options) {
    options = assign({}, xmldec, doctype, options);
    return new XMLBuilder(name, options).root();
  };

}).call(this);


/***/ }),
/* 2662 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLBuilder, XMLDeclaration, XMLDocType, XMLElement, XMLStringifier;

  XMLStringifier = __webpack_require__(2663);

  XMLDeclaration = __webpack_require__(1052);

  XMLDocType = __webpack_require__(1057);

  XMLElement = __webpack_require__(1053);

  module.exports = XMLBuilder = (function() {
    function XMLBuilder(name, options) {
      var root, temp;
      if (name == null) {
        throw new Error("Root element needs a name");
      }
      if (options == null) {
        options = {};
      }
      this.options = options;
      this.stringify = new XMLStringifier(options);
      temp = new XMLElement(this, 'doc');
      root = temp.element(name);
      root.isRoot = true;
      root.documentObject = this;
      this.rootObject = root;
      if (!options.headless) {
        root.declaration(options);
        if ((options.pubID != null) || (options.sysID != null)) {
          root.doctype(options);
        }
      }
    }

    XMLBuilder.prototype.root = function() {
      return this.rootObject;
    };

    XMLBuilder.prototype.end = function(options) {
      return this.toString(options);
    };

    XMLBuilder.prototype.toString = function(options) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      r = '';
      if (this.xmldec != null) {
        r += this.xmldec.toString(options);
      }
      if (this.doctype != null) {
        r += this.doctype.toString(options);
      }
      r += this.rootObject.toString(options);
      if (pretty && r.slice(-newline.length) === newline) {
        r = r.slice(0, -newline.length);
      }
      return r;
    };

    return XMLBuilder;

  })();

}).call(this);


/***/ }),
/* 2663 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLStringifier,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    hasProp = {}.hasOwnProperty;

  module.exports = XMLStringifier = (function() {
    function XMLStringifier(options) {
      this.assertLegalChar = bind(this.assertLegalChar, this);
      var key, ref, value;
      this.allowSurrogateChars = options != null ? options.allowSurrogateChars : void 0;
      this.noDoubleEncoding = options != null ? options.noDoubleEncoding : void 0;
      ref = (options != null ? options.stringify : void 0) || {};
      for (key in ref) {
        if (!hasProp.call(ref, key)) continue;
        value = ref[key];
        this[key] = value;
      }
    }

    XMLStringifier.prototype.eleName = function(val) {
      val = '' + val || '';
      return this.assertLegalChar(val);
    };

    XMLStringifier.prototype.eleText = function(val) {
      val = '' + val || '';
      return this.assertLegalChar(this.elEscape(val));
    };

    XMLStringifier.prototype.cdata = function(val) {
      val = '' + val || '';
      if (val.match(/]]>/)) {
        throw new Error("Invalid CDATA text: " + val);
      }
      return this.assertLegalChar(val);
    };

    XMLStringifier.prototype.comment = function(val) {
      val = '' + val || '';
      if (val.match(/--/)) {
        throw new Error("Comment text cannot contain double-hypen: " + val);
      }
      return this.assertLegalChar(val);
    };

    XMLStringifier.prototype.raw = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.attName = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.attValue = function(val) {
      val = '' + val || '';
      return this.attEscape(val);
    };

    XMLStringifier.prototype.insTarget = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.insValue = function(val) {
      val = '' + val || '';
      if (val.match(/\?>/)) {
        throw new Error("Invalid processing instruction value: " + val);
      }
      return val;
    };

    XMLStringifier.prototype.xmlVersion = function(val) {
      val = '' + val || '';
      if (!val.match(/1\.[0-9]+/)) {
        throw new Error("Invalid version number: " + val);
      }
      return val;
    };

    XMLStringifier.prototype.xmlEncoding = function(val) {
      val = '' + val || '';
      if (!val.match(/^[A-Za-z](?:[A-Za-z0-9._-]|-)*$/)) {
        throw new Error("Invalid encoding: " + val);
      }
      return val;
    };

    XMLStringifier.prototype.xmlStandalone = function(val) {
      if (val) {
        return "yes";
      } else {
        return "no";
      }
    };

    XMLStringifier.prototype.dtdPubID = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdSysID = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdElementValue = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdAttType = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdAttDefault = function(val) {
      if (val != null) {
        return '' + val || '';
      } else {
        return val;
      }
    };

    XMLStringifier.prototype.dtdEntityValue = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdNData = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.convertAttKey = '@';

    XMLStringifier.prototype.convertPIKey = '?';

    XMLStringifier.prototype.convertTextKey = '#text';

    XMLStringifier.prototype.convertCDataKey = '#cdata';

    XMLStringifier.prototype.convertCommentKey = '#comment';

    XMLStringifier.prototype.convertRawKey = '#raw';

    XMLStringifier.prototype.assertLegalChar = function(str) {
      var chars, chr;
      if (this.allowSurrogateChars) {
        chars = /[\u0000-\u0008\u000B-\u000C\u000E-\u001F\uFFFE-\uFFFF]/;
      } else {
        chars = /[\u0000-\u0008\u000B-\u000C\u000E-\u001F\uD800-\uDFFF\uFFFE-\uFFFF]/;
      }
      chr = str.match(chars);
      if (chr) {
        throw new Error("Invalid character (" + chr + ") in string: " + str + " at index " + chr.index);
      }
      return str;
    };

    XMLStringifier.prototype.elEscape = function(str) {
      var ampregex;
      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r/g, '&#xD;');
    };

    XMLStringifier.prototype.attEscape = function(str) {
      var ampregex;
      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
    };

    return XMLStringifier;

  })();

}).call(this);


/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(841),
    keys = __webpack_require__(307);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 2665 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(825),
    getTag = __webpack_require__(830),
    isArguments = __webpack_require__(528),
    isArray = __webpack_require__(113),
    isArrayLike = __webpack_require__(308),
    isBuffer = __webpack_require__(529),
    isPrototype = __webpack_require__(532),
    isTypedArray = __webpack_require__(530);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(2667),
    baseEvery = __webpack_require__(2668),
    baseIteratee = __webpack_require__(826),
    isArray = __webpack_require__(113),
    isIterateeCall = __webpack_require__(842);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),
/* 2667 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(527);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),
/* 2669 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLAttribute, create;

  create = __webpack_require__(116);

  module.exports = XMLAttribute = (function() {
    function XMLAttribute(parent, name, value) {
      this.stringify = parent.stringify;
      if (name == null) {
        throw new Error("Missing attribute name of element " + parent.name);
      }
      if (value == null) {
        throw new Error("Missing attribute value for attribute " + name + " of element " + parent.name);
      }
      this.name = this.stringify.attName(name);
      this.value = this.stringify.attValue(value);
    }

    XMLAttribute.prototype.clone = function() {
      return create(XMLAttribute.prototype, this);
    };

    XMLAttribute.prototype.toString = function(options, level) {
      return ' ' + this.name + '="' + this.value + '"';
    };

    return XMLAttribute;

  })();

}).call(this);


/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLDTDAttList, create;

  create = __webpack_require__(116);

  module.exports = XMLDTDAttList = (function() {
    function XMLDTDAttList(parent, elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      this.stringify = parent.stringify;
      if (elementName == null) {
        throw new Error("Missing DTD element name");
      }
      if (attributeName == null) {
        throw new Error("Missing DTD attribute name");
      }
      if (!attributeType) {
        throw new Error("Missing DTD attribute type");
      }
      if (!defaultValueType) {
        throw new Error("Missing DTD attribute default");
      }
      if (defaultValueType.indexOf('#') !== 0) {
        defaultValueType = '#' + defaultValueType;
      }
      if (!defaultValueType.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) {
        throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT");
      }
      if (defaultValue && !defaultValueType.match(/^(#FIXED|#DEFAULT)$/)) {
        throw new Error("Default value only applies to #FIXED or #DEFAULT");
      }
      this.elementName = this.stringify.eleName(elementName);
      this.attributeName = this.stringify.attName(attributeName);
      this.attributeType = this.stringify.dtdAttType(attributeType);
      this.defaultValue = this.stringify.dtdAttDefault(defaultValue);
      this.defaultValueType = defaultValueType;
    }

    XMLDTDAttList.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<!ATTLIST ' + this.elementName + ' ' + this.attributeName + ' ' + this.attributeType;
      if (this.defaultValueType !== '#DEFAULT') {
        r += ' ' + this.defaultValueType;
      }
      if (this.defaultValue) {
        r += ' "' + this.defaultValue + '"';
      }
      r += '>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLDTDAttList;

  })();

}).call(this);


/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLDTDEntity, create, isObject;

  create = __webpack_require__(116);

  isObject = __webpack_require__(125);

  module.exports = XMLDTDEntity = (function() {
    function XMLDTDEntity(parent, pe, name, value) {
      this.stringify = parent.stringify;
      if (name == null) {
        throw new Error("Missing entity name");
      }
      if (value == null) {
        throw new Error("Missing entity value");
      }
      this.pe = !!pe;
      this.name = this.stringify.eleName(name);
      if (!isObject(value)) {
        this.value = this.stringify.dtdEntityValue(value);
      } else {
        if (!value.pubID && !value.sysID) {
          throw new Error("Public and/or system identifiers are required for an external entity");
        }
        if (value.pubID && !value.sysID) {
          throw new Error("System identifier is required for a public external entity");
        }
        if (value.pubID != null) {
          this.pubID = this.stringify.dtdPubID(value.pubID);
        }
        if (value.sysID != null) {
          this.sysID = this.stringify.dtdSysID(value.sysID);
        }
        if (value.nData != null) {
          this.nData = this.stringify.dtdNData(value.nData);
        }
        if (this.pe && this.nData) {
          throw new Error("Notation declaration is not allowed in a parameter entity");
        }
      }
    }

    XMLDTDEntity.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<!ENTITY';
      if (this.pe) {
        r += ' %';
      }
      r += ' ' + this.name;
      if (this.value) {
        r += ' "' + this.value + '"';
      } else {
        if (this.pubID && this.sysID) {
          r += ' PUBLIC "' + this.pubID + '" "' + this.sysID + '"';
        } else if (this.sysID) {
          r += ' SYSTEM "' + this.sysID + '"';
        }
        if (this.nData) {
          r += ' NDATA ' + this.nData;
        }
      }
      r += '>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLDTDEntity;

  })();

}).call(this);


/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLDTDElement, create;

  create = __webpack_require__(116);

  module.exports = XMLDTDElement = (function() {
    function XMLDTDElement(parent, name, value) {
      this.stringify = parent.stringify;
      if (name == null) {
        throw new Error("Missing DTD element name");
      }
      if (!value) {
        value = '(#PCDATA)';
      }
      if (Array.isArray(value)) {
        value = '(' + value.join(',') + ')';
      }
      this.name = this.stringify.eleName(name);
      this.value = this.stringify.dtdElementValue(value);
    }

    XMLDTDElement.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<!ELEMENT ' + this.name + ' ' + this.value + '>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLDTDElement;

  })();

}).call(this);


/***/ }),
/* 2673 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLDTDNotation, create;

  create = __webpack_require__(116);

  module.exports = XMLDTDNotation = (function() {
    function XMLDTDNotation(parent, name, value) {
      this.stringify = parent.stringify;
      if (name == null) {
        throw new Error("Missing notation name");
      }
      if (!value.pubID && !value.sysID) {
        throw new Error("Public or system identifiers are required for an external entity");
      }
      this.name = this.stringify.eleName(name);
      if (value.pubID != null) {
        this.pubID = this.stringify.dtdPubID(value.pubID);
      }
      if (value.sysID != null) {
        this.sysID = this.stringify.dtdSysID(value.sysID);
      }
    }

    XMLDTDNotation.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<!NOTATION ' + this.name;
      if (this.pubID && this.sysID) {
        r += ' PUBLIC "' + this.pubID + '" "' + this.sysID + '"';
      } else if (this.pubID) {
        r += ' PUBLIC "' + this.pubID + '"';
      } else if (this.sysID) {
        r += ' SYSTEM "' + this.sysID + '"';
      }
      r += '>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLDTDNotation;

  })();

}).call(this);


/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLNode, XMLRaw, create,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  create = __webpack_require__(116);

  XMLNode = __webpack_require__(286);

  module.exports = XMLRaw = (function(superClass) {
    extend(XMLRaw, superClass);

    function XMLRaw(parent, text) {
      XMLRaw.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing raw text");
      }
      this.value = this.stringify.raw(text);
    }

    XMLRaw.prototype.clone = function() {
      return create(XMLRaw.prototype, this);
    };

    XMLRaw.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += this.value;
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLRaw;

  })(XMLNode);

}).call(this);


/***/ }),
/* 2675 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLNode, XMLText, create,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  create = __webpack_require__(116);

  XMLNode = __webpack_require__(286);

  module.exports = XMLText = (function(superClass) {
    extend(XMLText, superClass);

    function XMLText(parent, text) {
      XMLText.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing element text");
      }
      this.value = this.stringify.eleText(text);
    }

    XMLText.prototype.clone = function() {
      return create(XMLText.prototype, this);
    };

    XMLText.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += this.value;
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLText;

  })(XMLNode);

}).call(this);


/***/ }),
/* 2676 */
/***/ (function(module, exports) {

function apiLoader(svc, version) {
  if (!apiLoader.services.hasOwnProperty(svc)) {
    throw new Error('InvalidService: Failed to load api for ' + svc);
  }
  return apiLoader.services[svc][version];
}

/**
 * @api private
 *
 * This member of AWS.apiLoader is private, but changing it will necessitate a
 * change to ../scripts/services-table-generator.ts
 */
apiLoader.services = {};
module.exports = apiLoader;


/***/ }),
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var Api = __webpack_require__(1058);
var regionConfig = __webpack_require__(2678);
var inherit = AWS.util.inherit;
var clientCount = 0;

/**
 * The service class representing an AWS service.
 *
 * @abstract
 *
 * @!attribute apiVersions
 *   @return [Array<String>] the list of API versions supported by this service.
 *   @readonly
 */
AWS.Service = inherit({
  /**
   * Create a new service object with a configuration object
   *
   * @param config [map] a map of configuration options
   */
  constructor: function Service(config) {
    if (!this.loadServiceClass) {
      throw AWS.util.error(new Error(),
        'Service must be constructed with `new\' operator');
    }
    var ServiceClass = this.loadServiceClass(config || {});
    if (ServiceClass) {
      var originalConfig = AWS.util.copy(config);
      var svc = new ServiceClass(config);
      Object.defineProperty(svc, '_originalConfig', {
        get: function() { return originalConfig; },
        enumerable: false,
        configurable: true
      });
      svc._clientId = ++clientCount;
      return svc;
    }
    this.initialize(config);
  },

  /**
   * @api private
   */
  initialize: function initialize(config) {
    var svcConfig = AWS.config[this.serviceIdentifier];

    this.config = new AWS.Config(AWS.config);
    if (svcConfig) this.config.update(svcConfig, true);
    if (config) this.config.update(config, true);

    this.validateService();
    if (!this.config.endpoint) regionConfig(this);

    this.config.endpoint = this.endpointFromTemplate(this.config.endpoint);
    this.setEndpoint(this.config.endpoint);
  },

  /**
   * @api private
   */
  validateService: function validateService() {
  },

  /**
   * @api private
   */
  loadServiceClass: function loadServiceClass(serviceConfig) {
    var config = serviceConfig;
    if (!AWS.util.isEmpty(this.api)) {
      return null;
    } else if (config.apiConfig) {
      return AWS.Service.defineServiceApi(this.constructor, config.apiConfig);
    } else if (!this.constructor.services) {
      return null;
    } else {
      config = new AWS.Config(AWS.config);
      config.update(serviceConfig, true);
      var version = config.apiVersions[this.constructor.serviceIdentifier];
      version = version || config.apiVersion;
      return this.getLatestServiceClass(version);
    }
  },

  /**
   * @api private
   */
  getLatestServiceClass: function getLatestServiceClass(version) {
    version = this.getLatestServiceVersion(version);
    if (this.constructor.services[version] === null) {
      AWS.Service.defineServiceApi(this.constructor, version);
    }

    return this.constructor.services[version];
  },

  /**
   * @api private
   */
  getLatestServiceVersion: function getLatestServiceVersion(version) {
    if (!this.constructor.services || this.constructor.services.length === 0) {
      throw new Error('No services defined on ' +
                      this.constructor.serviceIdentifier);
    }

    if (!version) {
      version = 'latest';
    } else if (AWS.util.isType(version, Date)) {
      version = AWS.util.date.iso8601(version).split('T')[0];
    }

    if (Object.hasOwnProperty(this.constructor.services, version)) {
      return version;
    }

    var keys = Object.keys(this.constructor.services).sort();
    var selectedVersion = null;
    for (var i = keys.length - 1; i >= 0; i--) {
      // versions that end in "*" are not available on disk and can be
      // skipped, so do not choose these as selectedVersions
      if (keys[i][keys[i].length - 1] !== '*') {
        selectedVersion = keys[i];
      }
      if (keys[i].substr(0, 10) <= version) {
        return selectedVersion;
      }
    }

    throw new Error('Could not find ' + this.constructor.serviceIdentifier +
                    ' API to satisfy version constraint `' + version + '\'');
  },

  /**
   * @api private
   */
  api: {},

  /**
   * @api private
   */
  defaultRetryCount: 3,

  /**
   * @api private
   */
  customizeRequests: function customizeRequests(callback) {
    if (!callback) {
      this.customRequestHandler = null;
    } else if (typeof callback === 'function') {
      this.customRequestHandler = callback;
    } else {
      throw new Error('Invalid callback type \'' + typeof callback + '\' provided in customizeRequests');
    }
  },

  /**
   * Calls an operation on a service with the given input parameters.
   *
   * @param operation [String] the name of the operation to call on the service.
   * @param params [map] a map of input options for the operation
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */
  makeRequest: function makeRequest(operation, params, callback) {
    if (typeof params === 'function') {
      callback = params;
      params = null;
    }

    params = params || {};
    if (this.config.params) { // copy only toplevel bound params
      var rules = this.api.operations[operation];
      if (rules) {
        params = AWS.util.copy(params);
        AWS.util.each(this.config.params, function(key, value) {
          if (rules.input.members[key]) {
            if (params[key] === undefined || params[key] === null) {
              params[key] = value;
            }
          }
        });
      }
    }

    var request = new AWS.Request(this, operation, params);
    this.addAllRequestListeners(request);

    if (callback) request.send(callback);
    return request;
  },

  /**
   * Calls an operation on a service with the given input parameters, without
   * any authentication data. This method is useful for "public" API operations.
   *
   * @param operation [String] the name of the operation to call on the service.
   * @param params [map] a map of input options for the operation
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */
  makeUnauthenticatedRequest: function makeUnauthenticatedRequest(operation, params, callback) {
    if (typeof params === 'function') {
      callback = params;
      params = {};
    }

    var request = this.makeRequest(operation, params).toUnauthenticated();
    return callback ? request.send(callback) : request;
  },

  /**
   * Waits for a given state
   *
   * @param state [String] the state on the service to wait for
   * @param params [map] a map of parameters to pass with each request
   * @option params $waiter [map] a map of configuration options for the waiter
   * @option params $waiter.delay [Number] The number of seconds to wait between
   *                                       requests
   * @option params $waiter.maxAttempts [Number] The maximum number of requests
   *                                             to send while waiting
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */
  waitFor: function waitFor(state, params, callback) {
    var waiter = new AWS.ResourceWaiter(this, state);
    return waiter.wait(params, callback);
  },

  /**
   * @api private
   */
  addAllRequestListeners: function addAllRequestListeners(request) {
    var list = [AWS.events, AWS.EventListeners.Core, this.serviceInterface(),
                AWS.EventListeners.CorePost];
    for (var i = 0; i < list.length; i++) {
      if (list[i]) request.addListeners(list[i]);
    }

    // disable parameter validation
    if (!this.config.paramValidation) {
      request.removeListener('validate',
        AWS.EventListeners.Core.VALIDATE_PARAMETERS);
    }

    if (this.config.logger) { // add logging events
      request.addListeners(AWS.EventListeners.Logger);
    }

    this.setupRequestListeners(request);
    // call prototype's customRequestHandler
    if (typeof this.constructor.prototype.customRequestHandler === 'function') {
      this.constructor.prototype.customRequestHandler(request);
    }
    // call instance's customRequestHandler
    if (Object.prototype.hasOwnProperty.call(this, 'customRequestHandler') && typeof this.customRequestHandler === 'function') {
      this.customRequestHandler(request);
    }
  },

  /**
   * Override this method to setup any custom request listeners for each
   * new request to the service.
   *
   * @abstract
   */
  setupRequestListeners: function setupRequestListeners() {
  },

  /**
   * Gets the signer class for a given request
   * @api private
   */
  getSignerClass: function getSignerClass(request) {
    var version;
    // get operation authtype if present
    var operation = null;
    var authtype = '';
    if (request) {
      var operations = request.service.api.operations || {};
      operation = operations[request.operation] || null;
      authtype = operation ? operation.authtype : '';
    }
    if (this.config.signatureVersion) {
      version = this.config.signatureVersion;
    } else if (authtype === 'v4' || authtype === 'v4-unsigned-body') {
      version = 'v4';
    } else {
      version = this.api.signatureVersion;
    }
    return AWS.Signers.RequestSigner.getVersion(version);
  },

  /**
   * @api private
   */
  serviceInterface: function serviceInterface() {
    switch (this.api.protocol) {
      case 'ec2': return AWS.EventListeners.Query;
      case 'query': return AWS.EventListeners.Query;
      case 'json': return AWS.EventListeners.Json;
      case 'rest-json': return AWS.EventListeners.RestJson;
      case 'rest-xml': return AWS.EventListeners.RestXml;
    }
    if (this.api.protocol) {
      throw new Error('Invalid service `protocol\' ' +
        this.api.protocol + ' in API config');
    }
  },

  /**
   * @api private
   */
  successfulResponse: function successfulResponse(resp) {
    return resp.httpResponse.statusCode < 300;
  },

  /**
   * How many times a failed request should be retried before giving up.
   * the defaultRetryCount can be overriden by service classes.
   *
   * @api private
   */
  numRetries: function numRetries() {
    if (this.config.maxRetries !== undefined) {
      return this.config.maxRetries;
    } else {
      return this.defaultRetryCount;
    }
  },

  /**
   * @api private
   */
  retryDelays: function retryDelays(retryCount) {
    return AWS.util.calculateRetryDelay(retryCount, this.config.retryDelayOptions);
  },

  /**
   * @api private
   */
  retryableError: function retryableError(error) {
    if (this.timeoutError(error)) return true;
    if (this.networkingError(error)) return true;
    if (this.expiredCredentialsError(error)) return true;
    if (this.throttledError(error)) return true;
    if (error.statusCode >= 500) return true;
    return false;
  },

  /**
   * @api private
   */
  networkingError: function networkingError(error) {
    return error.code === 'NetworkingError';
  },

  /**
   * @api private
   */
  timeoutError: function timeoutError(error) {
    return error.code === 'TimeoutError';
  },

  /**
   * @api private
   */
  expiredCredentialsError: function expiredCredentialsError(error) {
    // TODO : this only handles *one* of the expired credential codes
    return (error.code === 'ExpiredTokenException');
  },

  /**
   * @api private
   */
  clockSkewError: function clockSkewError(error) {
    switch (error.code) {
      case 'RequestTimeTooSkewed':
      case 'RequestExpired':
      case 'InvalidSignatureException':
      case 'SignatureDoesNotMatch':
      case 'AuthFailure':
      case 'RequestInTheFuture':
        return true;
      default: return false;
    }
  },

  /**
   * @api private
   */
  getSkewCorrectedDate: function getSkewCorrectedDate() {
    return new Date(Date.now() + this.config.systemClockOffset);
  },

  /**
   * @api private
   */
  applyClockOffset: function applyClockOffset(newServerTime) {
    if (newServerTime) {
      this.config.systemClockOffset = newServerTime - Date.now();
    }
  },

  /**
   * @api private
   */
  isClockSkewed: function isClockSkewed(newServerTime) {
    if (newServerTime) {
      return Math.abs(this.getSkewCorrectedDate().getTime() - newServerTime) >= 30000;
    }
  },

  /**
   * @api private
   */
  throttledError: function throttledError(error) {
    // this logic varies between services
    switch (error.code) {
      case 'ProvisionedThroughputExceededException':
      case 'Throttling':
      case 'ThrottlingException':
      case 'RequestLimitExceeded':
      case 'RequestThrottled':
        return true;
      default:
        return false;
    }
  },

  /**
   * @api private
   */
  endpointFromTemplate: function endpointFromTemplate(endpoint) {
    if (typeof endpoint !== 'string') return endpoint;

    var e = endpoint;
    e = e.replace(/\{service\}/g, this.api.endpointPrefix);
    e = e.replace(/\{region\}/g, this.config.region);
    e = e.replace(/\{scheme\}/g, this.config.sslEnabled ? 'https' : 'http');
    return e;
  },

  /**
   * @api private
   */
  setEndpoint: function setEndpoint(endpoint) {
    this.endpoint = new AWS.Endpoint(endpoint, this.config);
  },

  /**
   * @api private
   */
  paginationConfig: function paginationConfig(operation, throwException) {
    var paginator = this.api.operations[operation].paginator;
    if (!paginator) {
      if (throwException) {
        var e = new Error();
        throw AWS.util.error(e, 'No pagination configuration for ' + operation);
      }
      return null;
    }

    return paginator;
  }
});

AWS.util.update(AWS.Service, {

  /**
   * Adds one method for each operation described in the api configuration
   *
   * @api private
   */
  defineMethods: function defineMethods(svc) {
    AWS.util.each(svc.prototype.api.operations, function iterator(method) {
      if (svc.prototype[method]) return;
      var operation = svc.prototype.api.operations[method];
      if (operation.authtype === 'none') {
        svc.prototype[method] = function (params, callback) {
          return this.makeUnauthenticatedRequest(method, params, callback);
        };
      } else {
        svc.prototype[method] = function (params, callback) {
          return this.makeRequest(method, params, callback);
        };
      }
    });
  },

  /**
   * Defines a new Service class using a service identifier and list of versions
   * including an optional set of features (functions) to apply to the class
   * prototype.
   *
   * @param serviceIdentifier [String] the identifier for the service
   * @param versions [Array<String>] a list of versions that work with this
   *   service
   * @param features [Object] an object to attach to the prototype
   * @return [Class<Service>] the service class defined by this function.
   */
  defineService: function defineService(serviceIdentifier, versions, features) {
    AWS.Service._serviceMap[serviceIdentifier] = true;
    if (!Array.isArray(versions)) {
      features = versions;
      versions = [];
    }

    var svc = inherit(AWS.Service, features || {});

    if (typeof serviceIdentifier === 'string') {
      AWS.Service.addVersions(svc, versions);

      var identifier = svc.serviceIdentifier || serviceIdentifier;
      svc.serviceIdentifier = identifier;
    } else { // defineService called with an API
      svc.prototype.api = serviceIdentifier;
      AWS.Service.defineMethods(svc);
    }

    return svc;
  },

  /**
   * @api private
   */
  addVersions: function addVersions(svc, versions) {
    if (!Array.isArray(versions)) versions = [versions];

    svc.services = svc.services || {};
    for (var i = 0; i < versions.length; i++) {
      if (svc.services[versions[i]] === undefined) {
        svc.services[versions[i]] = null;
      }
    }

    svc.apiVersions = Object.keys(svc.services).sort();
  },

  /**
   * @api private
   */
  defineServiceApi: function defineServiceApi(superclass, version, apiConfig) {
    var svc = inherit(superclass, {
      serviceIdentifier: superclass.serviceIdentifier
    });

    function setApi(api) {
      if (api.isApi) {
        svc.prototype.api = api;
      } else {
        svc.prototype.api = new Api(api);
      }
    }

    if (typeof version === 'string') {
      if (apiConfig) {
        setApi(apiConfig);
      } else {
        try {
          setApi(AWS.apiLoader(superclass.serviceIdentifier, version));
        } catch (err) {
          throw AWS.util.error(err, {
            message: 'Could not find API configuration ' +
              superclass.serviceIdentifier + '-' + version
          });
        }
      }
      if (!Object.prototype.hasOwnProperty.call(superclass.services, version)) {
        superclass.apiVersions = superclass.apiVersions.concat(version).sort();
      }
      superclass.services[version] = svc;
    } else {
      setApi(version);
    }

    AWS.Service.defineMethods(svc);
    return svc;
  },

  /**
   * @api private
   */
  hasService: function(identifier) {
    return Object.prototype.hasOwnProperty.call(AWS.Service._serviceMap, identifier);
  },

  /**
   * @api private
   */
  _serviceMap: {}
});

module.exports = AWS.Service;


/***/ }),
/* 2678 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(74);
var regionConfig = __webpack_require__(2679);

function generateRegionPrefix(region) {
  if (!region) return null;

  var parts = region.split('-');
  if (parts.length < 3) return null;
  return parts.slice(0, parts.length - 2).join('-') + '-*';
}

function derivedKeys(service) {
  var region = service.config.region;
  var regionPrefix = generateRegionPrefix(region);
  var endpointPrefix = service.api.endpointPrefix;

  return [
    [region, endpointPrefix],
    [regionPrefix, endpointPrefix],
    [region, '*'],
    [regionPrefix, '*'],
    ['*', endpointPrefix],
    ['*', '*']
  ].map(function(item) {
    return item[0] && item[1] ? item.join('/') : null;
  });
}

function applyConfig(service, config) {
  util.each(config, function(key, value) {
    if (key === 'globalEndpoint') return;
    if (service.config[key] === undefined || service.config[key] === null) {
      service.config[key] = value;
    }
  });
}

function configureEndpoint(service) {
  var keys = derivedKeys(service);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!key) continue;

    if (Object.prototype.hasOwnProperty.call(regionConfig.rules, key)) {
      var config = regionConfig.rules[key];
      if (typeof config === 'string') {
        config = regionConfig.patterns[config];
      }

      // set dualstack endpoint
      if (service.config.useDualstack && util.isDualstackAvailable(service)) {
        config = util.copy(config);
        config.endpoint = '{service}.dualstack.{region}.amazonaws.com';
      }

      // set global endpoint
      service.isGlobalEndpoint = !!config.globalEndpoint;

      // signature version
      if (!config.signatureVersion) config.signatureVersion = 'v4';

      // merge config
      applyConfig(service, config);
      return;
    }
  }
}

module.exports = configureEndpoint;


/***/ }),
/* 2679 */
/***/ (function(module, exports) {

module.exports = {"rules":{"*/*":{"endpoint":"{service}.{region}.amazonaws.com"},"cn-*/*":{"endpoint":"{service}.{region}.amazonaws.com.cn"},"*/budgets":"globalSSL","*/cloudfront":"globalSSL","*/iam":"globalSSL","*/sts":"globalSSL","*/importexport":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2","globalEndpoint":true},"*/route53":{"endpoint":"https://{service}.amazonaws.com","signatureVersion":"v3https","globalEndpoint":true},"*/waf":"globalSSL","us-gov-*/iam":"globalGovCloud","us-gov-*/sts":{"endpoint":"{service}.{region}.amazonaws.com"},"us-gov-west-1/s3":"s3signature","us-west-1/s3":"s3signature","us-west-2/s3":"s3signature","eu-west-1/s3":"s3signature","ap-southeast-1/s3":"s3signature","ap-southeast-2/s3":"s3signature","ap-northeast-1/s3":"s3signature","sa-east-1/s3":"s3signature","us-east-1/s3":{"endpoint":"{service}.amazonaws.com","signatureVersion":"s3"},"us-east-1/sdb":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2"},"*/sdb":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"v2"}},"patterns":{"globalSSL":{"endpoint":"https://{service}.amazonaws.com","globalEndpoint":true},"globalGovCloud":{"endpoint":"{service}.us-gov.amazonaws.com"},"s3signature":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"s3"}}}

/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
__webpack_require__(1062);
__webpack_require__(1063);
var PromisesDependency;

/**
 * The main configuration class used by all service objects to set
 * the region, credentials, and other options for requests.
 *
 * By default, credentials and region settings are left unconfigured.
 * This should be configured by the application before using any
 * AWS service APIs.
 *
 * In order to set global configuration options, properties should
 * be assigned to the global {AWS.config} object.
 *
 * @see AWS.config
 *
 * @!group General Configuration Options
 *
 * @!attribute credentials
 *   @return [AWS.Credentials] the AWS credentials to sign requests with.
 *
 * @!attribute region
 *   @example Set the global region setting to us-west-2
 *     AWS.config.update({region: 'us-west-2'});
 *   @return [AWS.Credentials] The region to send service requests to.
 *   @see http://docs.amazonwebservices.com/general/latest/gr/rande.html
 *     A list of available endpoints for each AWS service
 *
 * @!attribute maxRetries
 *   @return [Integer] the maximum amount of retries to perform for a
 *     service request. By default this value is calculated by the specific
 *     service object that the request is being made to.
 *
 * @!attribute maxRedirects
 *   @return [Integer] the maximum amount of redirects to follow for a
 *     service request. Defaults to 10.
 *
 * @!attribute paramValidation
 *   @return [Boolean|map] whether input parameters should be validated against
 *     the operation description before sending the request. Defaults to true.
 *     Pass a map to enable any of the following specific validation features:
 *
 *     * **min** [Boolean] &mdash; Validates that a value meets the min
 *       constraint. This is enabled by default when paramValidation is set
 *       to `true`.
 *     * **max** [Boolean] &mdash; Validates that a value meets the max
 *       constraint.
 *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
 *       regular expression.
 *     * **enum** [Boolean] &mdash; Validates that a string value matches one
 *       of the allowable enum values.
 *
 * @!attribute computeChecksums
 *   @return [Boolean] whether to compute checksums for payload bodies when
 *     the service accepts it (currently supported in S3 only).
 *
 * @!attribute convertResponseTypes
 *   @return [Boolean] whether types are converted when parsing response data.
 *     Currently only supported for JSON based services. Turning this off may
 *     improve performance on large response payloads. Defaults to `true`.
 *
 * @!attribute correctClockSkew
 *   @return [Boolean] whether to apply a clock skew correction and retry
 *     requests that fail because of an skewed client clock. Defaults to
 *     `false`.
 *
 * @!attribute sslEnabled
 *   @return [Boolean] whether SSL is enabled for requests
 *
 * @!attribute s3ForcePathStyle
 *   @return [Boolean] whether to force path style URLs for S3 objects
 *
 * @!attribute s3BucketEndpoint
 *   @note Setting this configuration option requires an `endpoint` to be
 *     provided explicitly to the service constructor.
 *   @return [Boolean] whether the provided endpoint addresses an individual
 *     bucket (false if it addresses the root API endpoint).
 *
 * @!attribute s3DisableBodySigning
 *   @return [Boolean] whether to disable S3 body signing when using signature version `v4`.
 *     Body signing can only be disabled when using https. Defaults to `true`.
 *
 * @!attribute useAccelerateEndpoint
 *   @note This configuration option is only compatible with S3 while accessing
 *     dns-compatible buckets.
 *   @return [Boolean] Whether to use the Accelerate endpoint with the S3 service.
 *     Defaults to `false`.
 *
 * @!attribute retryDelayOptions
 *   @example Set the base retry delay for all services to 300 ms
 *     AWS.config.update({retryDelayOptions: {base: 300}});
 *     // Delays with maxRetries = 3: 300, 600, 1200
 *   @example Set a custom backoff function to provide delay values on retries
 *     AWS.config.update({retryDelayOptions: {customBackoff: function(retryCount) {
 *       // returns delay in ms
 *     }}});
 *   @return [map] A set of options to configure the retry delay on retryable errors.
 *     Currently supported options are:
 *
 *     * **base** [Integer] &mdash; The base number of milliseconds to use in the
 *       exponential backoff for operation retries. Defaults to 100 ms for all services except
 *       DynamoDB, where it defaults to 50ms.
 *     * **customBackoff ** [function] &mdash; A custom function that accepts a retry count
 *       and returns the amount of time to delay in milliseconds. The `base` option will be
 *       ignored if this option is supplied.
 *
 * @!attribute httpOptions
 *   @return [map] A set of options to pass to the low-level HTTP request.
 *     Currently supported options are:
 *
 *     * **proxy** [String] &mdash; the URL to proxy requests through
 *     * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
 *       HTTP requests with. Used for connection pooling. Defaults to the global
 *       agent (`http.globalAgent`) for non-SSL connections. Note that for
 *       SSL connections, a special Agent object is used in order to enable
 *       peer certificate verification. This feature is only supported in the
 *       Node.js environment.
 *     * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
 *       failing to establish a connection with the server after
 *       `connectTimeout` milliseconds. This timeout has no effect once a socket
 *       connection has been established.
 *     * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
 *       milliseconds of inactivity on the socket. Defaults to two minutes
 *       (120000)
 *     * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
 *       HTTP requests. Used in the browser environment only. Set to false to
 *       send requests synchronously. Defaults to true (async on).
 *     * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
 *       property of an XMLHttpRequest object. Used in the browser environment
 *       only. Defaults to false.
 * @!attribute logger
 *   @return [#write,#log] an object that responds to .write() (like a stream)
 *     or .log() (like the console object) in order to log information about
 *     requests
 *
 * @!attribute systemClockOffset
 *   @return [Number] an offset value in milliseconds to apply to all signing
 *     times. Use this to compensate for clock skew when your system may be
 *     out of sync with the service time. Note that this configuration option
 *     can only be applied to the global `AWS.config` object and cannot be
 *     overridden in service-specific configuration. Defaults to 0 milliseconds.
 *
 * @!attribute signatureVersion
 *   @return [String] the signature version to sign requests with (overriding
 *     the API configuration). Possible values are: 'v2', 'v3', 'v4'.
 *
 * @!attribute signatureCache
 *   @return [Boolean] whether the signature to sign requests with (overriding
 *     the API configuration) is cached. Only applies to the signature version 'v4'.
 *     Defaults to `true`.
 */
AWS.Config = AWS.util.inherit({
  /**
   * @!endgroup
   */

  /**
   * Creates a new configuration object. This is the object that passes
   * option data along to service requests, including credentials, security,
   * region information, and some service specific settings.
   *
   * @example Creating a new configuration object with credentials and region
   *   var config = new AWS.Config({
   *     accessKeyId: 'AKID', secretAccessKey: 'SECRET', region: 'us-west-2'
   *   });
   * @option options accessKeyId [String] your AWS access key ID.
   * @option options secretAccessKey [String] your AWS secret access key.
   * @option options sessionToken [AWS.Credentials] the optional AWS
   *   session token to sign requests with.
   * @option options credentials [AWS.Credentials] the AWS credentials
   *   to sign requests with. You can either specify this object, or
   *   specify the accessKeyId and secretAccessKey options directly.
   * @option options credentialProvider [AWS.CredentialProviderChain] the
   *   provider chain used to resolve credentials if no static `credentials`
   *   property is set.
   * @option options region [String] the region to send service requests to.
   *   See {region} for more information.
   * @option options maxRetries [Integer] the maximum amount of retries to
   *   attempt with a request. See {maxRetries} for more information.
   * @option options maxRedirects [Integer] the maximum amount of redirects to
   *   follow with a request. See {maxRedirects} for more information.
   * @option options sslEnabled [Boolean] whether to enable SSL for
   *   requests.
   * @option options paramValidation [Boolean|map] whether input parameters
   *   should be validated against the operation description before sending
   *   the request. Defaults to true. Pass a map to enable any of the
   *   following specific validation features:
   *
   *   * **min** [Boolean] &mdash; Validates that a value meets the min
   *     constraint. This is enabled by default when paramValidation is set
   *     to `true`.
   *   * **max** [Boolean] &mdash; Validates that a value meets the max
   *     constraint.
   *   * **pattern** [Boolean] &mdash; Validates that a string value matches a
   *     regular expression.
   *   * **enum** [Boolean] &mdash; Validates that a string value matches one
   *     of the allowable enum values.
   * @option options computeChecksums [Boolean] whether to compute checksums
   *   for payload bodies when the service accepts it (currently supported
   *   in S3 only)
   * @option options convertResponseTypes [Boolean] whether types are converted
   *     when parsing response data. Currently only supported for JSON based
   *     services. Turning this off may improve performance on large response
   *     payloads. Defaults to `true`.
   * @option options correctClockSkew [Boolean] whether to apply a clock skew
   *     correction and retry requests that fail because of an skewed client
   *     clock. Defaults to `false`.
   * @option options s3ForcePathStyle [Boolean] whether to force path
   *   style URLs for S3 objects.
   * @option options s3BucketEndpoint [Boolean] whether the provided endpoint
   *   addresses an individual bucket (false if it addresses the root API
   *   endpoint). Note that setting this configuration option requires an
   *   `endpoint` to be provided explicitly to the service constructor.
   * @option options s3DisableBodySigning [Boolean] whether S3 body signing
   *   should be disabled when using signature version `v4`. Body signing
   *   can only be disabled when using https. Defaults to `true`.
   *
   * @option options retryDelayOptions [map] A set of options to configure
   *   the retry delay on retryable errors. Currently supported options are:
   *
   *   * **base** [Integer] &mdash; The base number of milliseconds to use in the
   *     exponential backoff for operation retries. Defaults to 100 ms for all
   *     services except DynamoDB, where it defaults to 50ms.
   *   * **customBackoff ** [function] &mdash; A custom function that accepts a retry count
   *     and returns the amount of time to delay in milliseconds. The `base` option will be
   *     ignored if this option is supplied.
   * @option options httpOptions [map] A set of options to pass to the low-level
   *   HTTP request. Currently supported options are:
   *
   *   * **proxy** [String] &mdash; the URL to proxy requests through
   *   * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
   *     HTTP requests with. Used for connection pooling. Defaults to the global
   *     agent (`http.globalAgent`) for non-SSL connections. Note that for
   *     SSL connections, a special Agent object is used in order to enable
   *     peer certificate verification. This feature is only available in the
   *     Node.js environment.
   *   * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
   *     failing to establish a connection with the server after
   *     `connectTimeout` milliseconds. This timeout has no effect once a socket
   *     connection has been established.
   *   * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
   *     milliseconds of inactivity on the socket. Defaults to two minutes
   *     (120000).
   *   * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
   *     HTTP requests. Used in the browser environment only. Set to false to
   *     send requests synchronously. Defaults to true (async on).
   *   * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
   *     property of an XMLHttpRequest object. Used in the browser environment
   *     only. Defaults to false.
   * @option options apiVersion [String, Date] a String in YYYY-MM-DD format
   *   (or a date) that represents the latest possible API version that can be
   *   used in all services (unless overridden by `apiVersions`). Specify
   *   'latest' to use the latest possible version.
   * @option options apiVersions [map<String, String|Date>] a map of service
   *   identifiers (the lowercase service class name) with the API version to
   *   use when instantiating a service. Specify 'latest' for each individual
   *   that can use the latest available version.
   * @option options logger [#write,#log] an object that responds to .write()
   *   (like a stream) or .log() (like the console object) in order to log
   *   information about requests
   * @option options systemClockOffset [Number] an offset value in milliseconds
   *   to apply to all signing times. Use this to compensate for clock skew
   *   when your system may be out of sync with the service time. Note that
   *   this configuration option can only be applied to the global `AWS.config`
   *   object and cannot be overridden in service-specific configuration.
   *   Defaults to 0 milliseconds.
   * @option options signatureVersion [String] the signature version to sign
   *   requests with (overriding the API configuration). Possible values are:
   *   'v2', 'v3', 'v4'.
   * @option options signatureCache [Boolean] whether the signature to sign
   *   requests with (overriding the API configuration) is cached. Only applies
   *   to the signature version 'v4'. Defaults to `true`.
   * @option options dynamoDbCrc32 [Boolean] whether to validate the CRC32
   *   checksum of HTTP response bodies returned by DynamoDB. Default: `true`.
   */
  constructor: function Config(options) {
    if (options === undefined) options = {};
    options = this.extractCredentials(options);

    AWS.util.each.call(this, this.keys, function (key, value) {
      this.set(key, options[key], value);
    });
  },

  /**
   * @!group Managing Credentials
   */

  /**
   * Loads credentials from the configuration object. This is used internally
   * by the SDK to ensure that refreshable {Credentials} objects are properly
   * refreshed and loaded when sending a request. If you want to ensure that
   * your credentials are loaded prior to a request, you can use this method
   * directly to provide accurate credential data stored in the object.
   *
   * @note If you configure the SDK with static or environment credentials,
   *   the credential data should already be present in {credentials} attribute.
   *   This method is primarily necessary to load credentials from asynchronous
   *   sources, or sources that can refresh credentials periodically.
   * @example Getting your access key
   *   AWS.config.getCredentials(function(err) {
   *     if (err) console.log(err.stack); // credentials not loaded
   *     else console.log("Access Key:", AWS.config.credentials.accessKeyId);
   *   })
   * @callback callback function(err)
   *   Called when the {credentials} have been properly set on the configuration
   *   object.
   *
   *   @param err [Error] if this is set, credentials were not successfully
   *     loaded and this error provides information why.
   * @see credentials
   * @see Credentials
   */
  getCredentials: function getCredentials(callback) {
    var self = this;

    function finish(err) {
      callback(err, err ? null : self.credentials);
    }

    function credError(msg, err) {
      return new AWS.util.error(err || new Error(), {
        code: 'CredentialsError',
        message: msg,
        name: 'CredentialsError'
      });
    }

    function getAsyncCredentials() {
      self.credentials.get(function(err) {
        if (err) {
          var msg = 'Could not load credentials from ' +
            self.credentials.constructor.name;
          err = credError(msg, err);
        }
        finish(err);
      });
    }

    function getStaticCredentials() {
      var err = null;
      if (!self.credentials.accessKeyId || !self.credentials.secretAccessKey) {
        err = credError('Missing credentials');
      }
      finish(err);
    }

    if (self.credentials) {
      if (typeof self.credentials.get === 'function') {
        getAsyncCredentials();
      } else { // static credentials
        getStaticCredentials();
      }
    } else if (self.credentialProvider) {
      self.credentialProvider.resolve(function(err, creds) {
        if (err) {
          err = credError('Could not load credentials from any providers', err);
        }
        self.credentials = creds;
        finish(err);
      });
    } else {
      finish(credError('No credentials to load'));
    }
  },

  /**
   * @!group Loading and Setting Configuration Options
   */

  /**
   * @overload update(options, allowUnknownKeys = false)
   *   Updates the current configuration object with new options.
   *
   *   @example Update maxRetries property of a configuration object
   *     config.update({maxRetries: 10});
   *   @param [Object] options a map of option keys and values.
   *   @param [Boolean] allowUnknownKeys whether unknown keys can be set on
   *     the configuration object. Defaults to `false`.
   *   @see constructor
   */
  update: function update(options, allowUnknownKeys) {
    allowUnknownKeys = allowUnknownKeys || false;
    options = this.extractCredentials(options);
    AWS.util.each.call(this, options, function (key, value) {
      if (allowUnknownKeys || Object.prototype.hasOwnProperty.call(this.keys, key) ||
          AWS.Service.hasService(key)) {
        this.set(key, value);
      }
    });
  },

  /**
   * Loads configuration data from a JSON file into this config object.
   * @note Loading configuration will reset all existing configuration
   *   on the object.
   * @!macro nobrowser
   * @param path [String] the path relative to your process's current
   *    working directory to load configuration from.
   * @return [AWS.Config] the same configuration object
   */
  loadFromPath: function loadFromPath(path) {
    this.clear();

    var options = JSON.parse(AWS.util.readFileSync(path));
    var fileSystemCreds = new AWS.FileSystemCredentials(path);
    var chain = new AWS.CredentialProviderChain();
    chain.providers.unshift(fileSystemCreds);
    chain.resolve(function (err, creds) {
      if (err) throw err;
      else options.credentials = creds;
    });

    this.constructor(options);

    return this;
  },

  /**
   * Clears configuration data on this object
   *
   * @api private
   */
  clear: function clear() {
    /*jshint forin:false */
    AWS.util.each.call(this, this.keys, function (key) {
      delete this[key];
    });

    // reset credential provider
    this.set('credentials', undefined);
    this.set('credentialProvider', undefined);
  },

  /**
   * Sets a property on the configuration object, allowing for a
   * default value
   * @api private
   */
  set: function set(property, value, defaultValue) {
    if (value === undefined) {
      if (defaultValue === undefined) {
        defaultValue = this.keys[property];
      }
      if (typeof defaultValue === 'function') {
        this[property] = defaultValue.call(this);
      } else {
        this[property] = defaultValue;
      }
    } else if (property === 'httpOptions' && this[property]) {
      // deep merge httpOptions
      this[property] = AWS.util.merge(this[property], value);
    } else {
      this[property] = value;
    }
  },

  /**
   * All of the keys with their default values.
   *
   * @constant
   * @api private
   */
  keys: {
    credentials: null,
    credentialProvider: null,
    region: null,
    logger: null,
    apiVersions: {},
    apiVersion: null,
    endpoint: undefined,
    httpOptions: {
      timeout: 120000
    },
    maxRetries: undefined,
    maxRedirects: 10,
    paramValidation: true,
    sslEnabled: true,
    s3ForcePathStyle: false,
    s3BucketEndpoint: false,
    s3DisableBodySigning: true,
    computeChecksums: true,
    convertResponseTypes: true,
    correctClockSkew: false,
    customUserAgent: null,
    dynamoDbCrc32: true,
    systemClockOffset: 0,
    signatureVersion: null,
    signatureCache: true,
    retryDelayOptions: {},
    useAccelerateEndpoint: false
  },

  /**
   * Extracts accessKeyId, secretAccessKey and sessionToken
   * from a configuration hash.
   *
   * @api private
   */
  extractCredentials: function extractCredentials(options) {
    if (options.accessKeyId && options.secretAccessKey) {
      options = AWS.util.copy(options);
      options.credentials = new AWS.Credentials(options);
    }
    return options;
  },

  /**
   * Sets the promise dependency the SDK will use wherever Promises are returned.
   * Passing `null` will force the SDK to use native Promises if they are available.
   * If native Promises are not available, passing `null` will have no effect.
   * @param [Constructor] dep A reference to a Promise constructor
   */
  setPromisesDependency: function setPromisesDependency(dep) {
    PromisesDependency = dep;
    // if null was passed in, we should try to use native promises
    if (dep === null && typeof Promise === 'function') {
      PromisesDependency = Promise;
    }
    var constructors = [AWS.Request, AWS.Credentials, AWS.CredentialProviderChain];
    if (AWS.S3 && AWS.S3.ManagedUpload) constructors.push(AWS.S3.ManagedUpload);
    AWS.util.addPromises(constructors, PromisesDependency);
  },

  /**
   * Gets the promise dependency set by `AWS.config.setPromisesDependency`.
   */
  getPromisesDependency: function getPromisesDependency() {
    return PromisesDependency;
  }
});

/**
 * @return [AWS.Config] The global configuration object singleton instance
 * @readonly
 * @see AWS.Config
 */
AWS.config = new AWS.Config();


/***/ }),
/* 2681 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var SequentialExecutor = __webpack_require__(1065);
/**
 * The namespace used to register global event listeners for request building
 * and sending.
 */
AWS.EventListeners = {
  /**
   * @!attribute VALIDATE_CREDENTIALS
   *   A request listener that validates whether the request is being
   *   sent with credentials.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating credentials
   *     var listener = AWS.EventListeners.Core.VALIDATE_CREDENTIALS;
   *     request.removeListener('validate', listener);
   *   @readonly
   *   @return [Function]
   * @!attribute VALIDATE_REGION
   *   A request listener that validates whether the region is set
   *   for a request.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating region configuration
   *     var listener = AWS.EventListeners.Core.VALIDATE_REGION;
   *     request.removeListener('validate', listener);
   *   @readonly
   *   @return [Function]
   * @!attribute VALIDATE_PARAMETERS
   *   A request listener that validates input parameters in a request.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating parameters
   *     var listener = AWS.EventListeners.Core.VALIDATE_PARAMETERS;
   *     request.removeListener('validate', listener);
   *   @example Disable parameter validation globally
   *     AWS.EventListeners.Core.removeListener('validate',
   *       AWS.EventListeners.Core.VALIDATE_REGION);
   *   @readonly
   *   @return [Function]
   * @!attribute SEND
   *   A request listener that initiates the HTTP connection for a
   *   request being sent. Handles the {AWS.Request~send 'send' Request event}
   *   @example Replacing the HTTP handler
   *     var listener = AWS.EventListeners.Core.SEND;
   *     request.removeListener('send', listener);
   *     request.on('send', function(response) {
   *       customHandler.send(response);
   *     });
   *   @return [Function]
   *   @readonly
   * @!attribute HTTP_DATA
   *   A request listener that reads data from the HTTP connection in order
   *   to build the response data.
   *   Handles the {AWS.Request~httpData 'httpData' Request event}.
   *   Remove this handler if you are overriding the 'httpData' event and
   *   do not want extra data processing and buffering overhead.
   *   @example Disabling default data processing
   *     var listener = AWS.EventListeners.Core.HTTP_DATA;
   *     request.removeListener('httpData', listener);
   *   @return [Function]
   *   @readonly
   */
  Core: {} /* doc hack */
};

/**
 * @api private
 */
function getOperationAuthtype(req) {
  if (!req.service.api.operations) {
    return '';
  }
  var operation = req.service.api.operations[req.operation];
  return operation ? operation.authtype : '';
}

AWS.EventListeners = {
  Core: new SequentialExecutor().addNamedListeners(function(add, addAsync) {
    addAsync('VALIDATE_CREDENTIALS', 'validate',
        function VALIDATE_CREDENTIALS(req, done) {
      if (!req.service.api.signatureVersion) return done(); // none
      req.service.config.getCredentials(function(err) {
        if (err) {
          req.response.error = AWS.util.error(err,
            {code: 'CredentialsError', message: 'Missing credentials in config'});
        }
        done();
      });
    });

    add('VALIDATE_REGION', 'validate', function VALIDATE_REGION(req) {
      if (!req.service.config.region && !req.service.isGlobalEndpoint) {
        req.response.error = AWS.util.error(new Error(),
          {code: 'ConfigError', message: 'Missing region in config'});
      }
    });

    add('BUILD_IDEMPOTENCY_TOKENS', 'validate', function BUILD_IDEMPOTENCY_TOKENS(req) {
      if (!req.service.api.operations) {
        return;
      }
      var operation = req.service.api.operations[req.operation];
      if (!operation) {
        return;
      }
      var idempotentMembers = operation.idempotentMembers;
      if (!idempotentMembers.length) {
        return;
      }
      // creates a copy of params so user's param object isn't mutated
      var params = AWS.util.copy(req.params);
      for (var i = 0, iLen = idempotentMembers.length; i < iLen; i++) {
        if (!params[idempotentMembers[i]]) {
          // add the member
          params[idempotentMembers[i]] = AWS.util.uuid.v4();
        }
      }
      req.params = params;
    });

    add('VALIDATE_PARAMETERS', 'validate', function VALIDATE_PARAMETERS(req) {
      if (!req.service.api.operations) {
        return;
      }
      var rules = req.service.api.operations[req.operation].input;
      var validation = req.service.config.paramValidation;
      new AWS.ParamValidator(validation).validate(rules, req.params);
    });

    addAsync('COMPUTE_SHA256', 'afterBuild', function COMPUTE_SHA256(req, done) {
      req.haltHandlersOnError();
      if (!req.service.api.operations) {
        return;
      }
      var operation = req.service.api.operations[req.operation];
      var authtype = operation ? operation.authtype : '';
      if (!req.service.api.signatureVersion && !authtype) return done(); // none
      if (req.service.getSignerClass(req) === AWS.Signers.V4) {
        var body = req.httpRequest.body || '';
        if (authtype.indexOf('unsigned-body') >= 0) {
          req.httpRequest.headers['X-Amz-Content-Sha256'] = 'UNSIGNED-PAYLOAD';
          return done();
        }
        AWS.util.computeSha256(body, function(err, sha) {
          if (err) {
            done(err);
          }
          else {
            req.httpRequest.headers['X-Amz-Content-Sha256'] = sha;
            done();
          }
        });
      } else {
        done();
      }
    });

    add('SET_CONTENT_LENGTH', 'afterBuild', function SET_CONTENT_LENGTH(req) {
      var authtype = getOperationAuthtype(req);
      if (req.httpRequest.headers['Content-Length'] === undefined
          && authtype.indexOf('unsigned-body') === -1) {
        var length = AWS.util.string.byteLength(req.httpRequest.body);
        req.httpRequest.headers['Content-Length'] = length;
      }
    });

    add('SET_HTTP_HOST', 'afterBuild', function SET_HTTP_HOST(req) {
      req.httpRequest.headers['Host'] = req.httpRequest.endpoint.host;
    });

    add('RESTART', 'restart', function RESTART() {
      var err = this.response.error;
      if (!err || !err.retryable) return;

      this.httpRequest = new AWS.HttpRequest(
        this.service.endpoint,
        this.service.region
      );

      if (this.response.retryCount < this.service.config.maxRetries) {
        this.response.retryCount++;
      } else {
        this.response.error = null;
      }
    });

    addAsync('SIGN', 'sign', function SIGN(req, done) {
      var service = req.service;
      var operations = req.service.api.operations || {};
      var operation = operations[req.operation];
      var authtype = operation ? operation.authtype : '';
      if (!service.api.signatureVersion && !authtype) return done(); // none

      service.config.getCredentials(function (err, credentials) {
        if (err) {
          req.response.error = err;
          return done();
        }

        try {
          var date = service.getSkewCorrectedDate();
          var SignerClass = service.getSignerClass(req);
          var signer = new SignerClass(req.httpRequest,
            service.api.signingName || service.api.endpointPrefix,
            {
              signatureCache: service.config.signatureCache,
              operation: operation
            });
          signer.setServiceClientId(service._clientId);

          // clear old authorization headers
          delete req.httpRequest.headers['Authorization'];
          delete req.httpRequest.headers['Date'];
          delete req.httpRequest.headers['X-Amz-Date'];

          // add new authorization
          signer.addAuthorization(credentials, date);
          req.signedAt = date;
        } catch (e) {
          req.response.error = e;
        }
        done();
      });
    });

    add('VALIDATE_RESPONSE', 'validateResponse', function VALIDATE_RESPONSE(resp) {
      if (this.service.successfulResponse(resp, this)) {
        resp.data = {};
        resp.error = null;
      } else {
        resp.data = null;
        resp.error = AWS.util.error(new Error(),
          {code: 'UnknownError', message: 'An unknown error occurred.'});
      }
    });

    addAsync('SEND', 'send', function SEND(resp, done) {
      resp.httpResponse._abortCallback = done;
      resp.error = null;
      resp.data = null;

      function callback(httpResp) {
        resp.httpResponse.stream = httpResp;
        var stream = resp.request.httpRequest.stream;

        httpResp.on('headers', function onHeaders(statusCode, headers, statusMessage) {
          resp.request.emit(
            'httpHeaders',
            [statusCode, headers, resp, statusMessage]
          );

          if (!resp.httpResponse.streaming) {
            if (AWS.HttpClient.streamsApiVersion === 2) { // streams2 API check
              httpResp.on('readable', function onReadable() {
                var data = httpResp.read();
                if (data !== null) {
                  resp.request.emit('httpData', [data, resp]);
                }
              });
            } else { // legacy streams API
              httpResp.on('data', function onData(data) {
                resp.request.emit('httpData', [data, resp]);
              });
            }
          }
        });

        httpResp.on('end', function onEnd() {
          if (!stream || !stream.didCallback) {
            resp.request.emit('httpDone');
            done();
          }
        });
      }

      function progress(httpResp) {
        httpResp.on('sendProgress', function onSendProgress(value) {
          resp.request.emit('httpUploadProgress', [value, resp]);
        });

        httpResp.on('receiveProgress', function onReceiveProgress(value) {
          resp.request.emit('httpDownloadProgress', [value, resp]);
        });
      }

      function error(err) {
        if (err.code !== 'RequestAbortedError') {
          var errCode = err.code === 'TimeoutError' ? err.code : 'NetworkingError';
          err = AWS.util.error(err, {
            code: errCode,
            region: resp.request.httpRequest.region,
            hostname: resp.request.httpRequest.endpoint.hostname,
            retryable: true
          });
        }
        resp.error = err;
        resp.request.emit('httpError', [resp.error, resp], function() {
          done();
        });
      }

      function executeSend() {
        var http = AWS.HttpClient.getInstance();
        var httpOptions = resp.request.service.config.httpOptions || {};
        try {
          var stream = http.handleRequest(resp.request.httpRequest, httpOptions,
                                          callback, error);
          progress(stream);
        } catch (err) {
          error(err);
        }
      }
      var timeDiff = (resp.request.service.getSkewCorrectedDate() - this.signedAt) / 1000;
      if (timeDiff >= 60 * 10) { // if we signed 10min ago, re-sign
        this.emit('sign', [this], function(err) {
          if (err) done(err);
          else executeSend();
        });
      } else {
        executeSend();
      }
    });

    add('HTTP_HEADERS', 'httpHeaders',
        function HTTP_HEADERS(statusCode, headers, resp, statusMessage) {
      resp.httpResponse.statusCode = statusCode;
      resp.httpResponse.statusMessage = statusMessage;
      resp.httpResponse.headers = headers;
      resp.httpResponse.body = new AWS.util.Buffer('');
      resp.httpResponse.buffers = [];
      resp.httpResponse.numBytes = 0;
      var dateHeader = headers.date || headers.Date;
      var service = resp.request.service;
      if (dateHeader) {
        var serverTime = Date.parse(dateHeader);
        if (service.config.correctClockSkew
            && service.isClockSkewed(serverTime)) {
          service.applyClockOffset(serverTime);
        }
      }
    });

    add('HTTP_DATA', 'httpData', function HTTP_DATA(chunk, resp) {
      if (chunk) {
        if (AWS.util.isNode()) {
          resp.httpResponse.numBytes += chunk.length;

          var total = resp.httpResponse.headers['content-length'];
          var progress = { loaded: resp.httpResponse.numBytes, total: total };
          resp.request.emit('httpDownloadProgress', [progress, resp]);
        }

        resp.httpResponse.buffers.push(new AWS.util.Buffer(chunk));
      }
    });

    add('HTTP_DONE', 'httpDone', function HTTP_DONE(resp) {
      // convert buffers array into single buffer
      if (resp.httpResponse.buffers && resp.httpResponse.buffers.length > 0) {
        var body = AWS.util.buffer.concat(resp.httpResponse.buffers);
        resp.httpResponse.body = body;
      }
      delete resp.httpResponse.numBytes;
      delete resp.httpResponse.buffers;
    });

    add('FINALIZE_ERROR', 'retry', function FINALIZE_ERROR(resp) {
      if (resp.httpResponse.statusCode) {
        resp.error.statusCode = resp.httpResponse.statusCode;
        if (resp.error.retryable === undefined) {
          resp.error.retryable = this.service.retryableError(resp.error, this);
        }
      }
    });

    add('INVALIDATE_CREDENTIALS', 'retry', function INVALIDATE_CREDENTIALS(resp) {
      if (!resp.error) return;
      switch (resp.error.code) {
        case 'RequestExpired': // EC2 only
        case 'ExpiredTokenException':
        case 'ExpiredToken':
          resp.error.retryable = true;
          resp.request.service.config.credentials.expired = true;
      }
    });

    add('EXPIRED_SIGNATURE', 'retry', function EXPIRED_SIGNATURE(resp) {
      var err = resp.error;
      if (!err) return;
      if (typeof err.code === 'string' && typeof err.message === 'string') {
        if (err.code.match(/Signature/) && err.message.match(/expired/)) {
          resp.error.retryable = true;
        }
      }
    });

    add('CLOCK_SKEWED', 'retry', function CLOCK_SKEWED(resp) {
      if (!resp.error) return;
      if (this.service.clockSkewError(resp.error)
          && this.service.config.correctClockSkew) {
        resp.error.retryable = true;
      }
    });

    add('REDIRECT', 'retry', function REDIRECT(resp) {
      if (resp.error && resp.error.statusCode >= 300 &&
          resp.error.statusCode < 400 && resp.httpResponse.headers['location']) {
        this.httpRequest.endpoint =
          new AWS.Endpoint(resp.httpResponse.headers['location']);
        this.httpRequest.headers['Host'] = this.httpRequest.endpoint.host;
        resp.error.redirect = true;
        resp.error.retryable = true;
      }
    });

    add('RETRY_CHECK', 'retry', function RETRY_CHECK(resp) {
      if (resp.error) {
        if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
          resp.error.retryDelay = 0;
        } else if (resp.retryCount < resp.maxRetries) {
          resp.error.retryDelay = this.service.retryDelays(resp.retryCount) || 0;
        }
      }
    });

    addAsync('RESET_RETRY_STATE', 'afterRetry', function RESET_RETRY_STATE(resp, done) {
      var delay, willRetry = false;

      if (resp.error) {
        delay = resp.error.retryDelay || 0;
        if (resp.error.retryable && resp.retryCount < resp.maxRetries) {
          resp.retryCount++;
          willRetry = true;
        } else if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
          resp.redirectCount++;
          willRetry = true;
        }
      }

      if (willRetry) {
        resp.error = null;
        setTimeout(done, delay);
      } else {
        done();
      }
    });
  }),

  CorePost: new SequentialExecutor().addNamedListeners(function(add) {
    add('EXTRACT_REQUEST_ID', 'extractData', AWS.util.extractRequestId);
    add('EXTRACT_REQUEST_ID', 'extractError', AWS.util.extractRequestId);

    add('ENOTFOUND_ERROR', 'httpError', function ENOTFOUND_ERROR(err) {
      if (err.code === 'NetworkingError' && err.errno === 'ENOTFOUND') {
        var message = 'Inaccessible host: `' + err.hostname +
          '\'. This service may not be available in the `' + err.region +
          '\' region.';
        this.response.error = AWS.util.error(new Error(message), {
          code: 'UnknownEndpoint',
          region: err.region,
          hostname: err.hostname,
          retryable: true,
          originalError: err
        });
      }
    });
  }),

  Logger: new SequentialExecutor().addNamedListeners(function(add) {
    add('LOG_REQUEST', 'complete', function LOG_REQUEST(resp) {
      var req = resp.request;
      var logger = req.service.config.logger;
      if (!logger) return;
      function filterSensitiveLog(inputShape, shape) {
        if (!shape) {
          return shape;
        }
        switch (inputShape.type) {
          case 'structure':
            var struct = {};
            AWS.util.each(shape, function(subShapeName, subShape) {
              if (Object.prototype.hasOwnProperty.call(inputShape.members, subShapeName)) {
                struct[subShapeName] = filterSensitiveLog(inputShape.members[subShapeName], subShape);
              } else {
                struct[subShapeName] = subShape;
              }
            })
            return struct
          case 'list':
            var list = [];
            AWS.util.arrayEach(shape, function(subShape, index) {
              list.push(filterSensitiveLog(inputShape.member, subShape));
            })
            return list;
          case 'map':
            var map = {};
            AWS.util.each(shape, function(key, value) {
              map[key] = filterSensitiveLog(inputShape.value, value);
            })
            return map;
          default:
            if (inputShape.isSensitive) {
              return '***SensitiveInformation***'
            } else {
              return shape;
            }
        }
      }

      function buildMessage() {
        var time = resp.request.service.getSkewCorrectedDate().getTime();
        var delta = (time - req.startTime.getTime()) / 1000;
        var ansi = logger.isTTY ? true : false;
        var status = resp.httpResponse.statusCode;
        var censoredParams = req.params;
        if (
          req.service.api.operations &&
              req.service.api.operations[req.operation] &&
              req.service.api.operations[req.operation].input
        ) {
          var inputShape = req.service.api.operations[req.operation].input;
          censoredParams = filterSensitiveLog(inputShape, req.params);
        }
        var params = __webpack_require__(2682).inspect(censoredParams, true, null);
        var message = '';
        if (ansi) message += '\x1B[33m';
        message += '[AWS ' + req.service.serviceIdentifier + ' ' + status;
        message += ' ' + delta.toString() + 's ' + resp.retryCount + ' retries]';
        if (ansi) message += '\x1B[0;1m';
        message += ' ' + AWS.util.string.lowerFirst(req.operation);
        message += '(' + params + ')';
        if (ansi) message += '\x1B[0m';
        return message;
      }

      var line = buildMessage();
      if (typeof logger.log === 'function') {
        logger.log(line);
      } else if (typeof logger.write === 'function') {
        logger.write(line + '\n');
      }
    });
  }),

  Json: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(643);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  Rest: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(439);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  RestJson: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(1050);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  RestXml: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(1051);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  Query: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(1048);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  })
};


/***/ }),
/* 2682 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://spackle-v1.fly.dev/","REACT_APP_CABLE_WSS_URL":"wss://spackle-v1.fly.dev/cable","REACT_APP_ADVANCED_DOCUMENTS_S3_BUCKET":"360-custom-document","REACT_APP_CLICKUP_FORM_URL":"https://forms.clickup.com/f/86zjg-822/NRB5VVG05QA0QWA5V1","REACT_APP_WEBVIEWER_URL":"https://spackle.s3.amazonaws.com/lib"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(2683);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(2684);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(254)))

/***/ }),
/* 2683 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 2684 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var AWS = __webpack_require__(5);
var AcceptorStateMachine = __webpack_require__(2686);
var inherit = AWS.util.inherit;
var domain = AWS.util.domain;
var jmespath = __webpack_require__(646);

/**
 * @api private
 */
var hardErrorStates = {success: 1, error: 1, complete: 1};

function isTerminalState(machine) {
  return Object.prototype.hasOwnProperty.call(hardErrorStates, machine._asm.currentState);
}

var fsm = new AcceptorStateMachine();
fsm.setupStates = function() {
  var transition = function(_, done) {
    var self = this;
    self._haltHandlersOnError = false;

    self.emit(self._asm.currentState, function(err) {
      if (err) {
        if (isTerminalState(self)) {
          if (domain && self.domain instanceof domain.Domain) {
            err.domainEmitter = self;
            err.domain = self.domain;
            err.domainThrown = false;
            self.domain.emit('error', err);
          } else {
            throw err;
          }
        } else {
          self.response.error = err;
          done(err);
        }
      } else {
        done(self.response.error);
      }
    });

  };

  this.addState('validate', 'build', 'error', transition);
  this.addState('build', 'afterBuild', 'restart', transition);
  this.addState('afterBuild', 'sign', 'restart', transition);
  this.addState('sign', 'send', 'retry', transition);
  this.addState('retry', 'afterRetry', 'afterRetry', transition);
  this.addState('afterRetry', 'sign', 'error', transition);
  this.addState('send', 'validateResponse', 'retry', transition);
  this.addState('validateResponse', 'extractData', 'extractError', transition);
  this.addState('extractError', 'extractData', 'retry', transition);
  this.addState('extractData', 'success', 'retry', transition);
  this.addState('restart', 'build', 'error', transition);
  this.addState('success', 'complete', 'complete', transition);
  this.addState('error', 'complete', 'complete', transition);
  this.addState('complete', null, null, transition);
};
fsm.setupStates();

/**
 * ## Asynchronous Requests
 *
 * All requests made through the SDK are asynchronous and use a
 * callback interface. Each service method that kicks off a request
 * returns an `AWS.Request` object that you can use to register
 * callbacks.
 *
 * For example, the following service method returns the request
 * object as "request", which can be used to register callbacks:
 *
 * ```javascript
 * // request is an AWS.Request object
 * var request = ec2.describeInstances();
 *
 * // register callbacks on request to retrieve response data
 * request.on('success', function(response) {
 *   console.log(response.data);
 * });
 * ```
 *
 * When a request is ready to be sent, the {send} method should
 * be called:
 *
 * ```javascript
 * request.send();
 * ```
 *
 * Since registered callbacks may or may not be idempotent, requests should only
 * be sent once. To perform the same operation multiple times, you will need to
 * create multiple request objects, each with its own registered callbacks.
 *
 * ## Removing Default Listeners for Events
 *
 * Request objects are built with default listeners for the various events,
 * depending on the service type. In some cases, you may want to remove
 * some built-in listeners to customize behaviour. Doing this requires
 * access to the built-in listener functions, which are exposed through
 * the {AWS.EventListeners.Core} namespace. For instance, you may
 * want to customize the HTTP handler used when sending a request. In this
 * case, you can remove the built-in listener associated with the 'send'
 * event, the {AWS.EventListeners.Core.SEND} listener and add your own.
 *
 * ## Multiple Callbacks and Chaining
 *
 * You can register multiple callbacks on any request object. The
 * callbacks can be registered for different events, or all for the
 * same event. In addition, you can chain callback registration, for
 * example:
 *
 * ```javascript
 * request.
 *   on('success', function(response) {
 *     console.log("Success!");
 *   }).
 *   on('error', function(response) {
 *     console.log("Error!");
 *   }).
 *   on('complete', function(response) {
 *     console.log("Always!");
 *   }).
 *   send();
 * ```
 *
 * The above example will print either "Success! Always!", or "Error! Always!",
 * depending on whether the request succeeded or not.
 *
 * @!attribute httpRequest
 *   @readonly
 *   @!group HTTP Properties
 *   @return [AWS.HttpRequest] the raw HTTP request object
 *     containing request headers and body information
 *     sent by the service.
 *
 * @!attribute startTime
 *   @readonly
 *   @!group Operation Properties
 *   @return [Date] the time that the request started
 *
 * @!group Request Building Events
 *
 * @!event validate(request)
 *   Triggered when a request is being validated. Listeners
 *   should throw an error if the request should not be sent.
 *   @param request [Request] the request object being sent
 *   @see AWS.EventListeners.Core.VALIDATE_CREDENTIALS
 *   @see AWS.EventListeners.Core.VALIDATE_REGION
 *   @example Ensuring that a certain parameter is set before sending a request
 *     var req = s3.putObject(params);
 *     req.on('validate', function() {
 *       if (!req.params.Body.match(/^Hello\s/)) {
 *         throw new Error('Body must start with "Hello "');
 *       }
 *     });
 *     req.send(function(err, data) { ... });
 *
 * @!event build(request)
 *   Triggered when the request payload is being built. Listeners
 *   should fill the necessary information to send the request
 *   over HTTP.
 *   @param (see AWS.Request~validate)
 *   @example Add a custom HTTP header to a request
 *     var req = s3.putObject(params);
 *     req.on('build', function() {
 *       req.httpRequest.headers['Custom-Header'] = 'value';
 *     });
 *     req.send(function(err, data) { ... });
 *
 * @!event sign(request)
 *   Triggered when the request is being signed. Listeners should
 *   add the correct authentication headers and/or adjust the body,
 *   depending on the authentication mechanism being used.
 *   @param (see AWS.Request~validate)
 *
 * @!group Request Sending Events
 *
 * @!event send(response)
 *   Triggered when the request is ready to be sent. Listeners
 *   should call the underlying transport layer to initiate
 *   the sending of the request.
 *   @param response [Response] the response object
 *   @context [Request] the request object that was sent
 *   @see AWS.EventListeners.Core.SEND
 *
 * @!event retry(response)
 *   Triggered when a request failed and might need to be retried or redirected.
 *   If the response is retryable, the listener should set the
 *   `response.error.retryable` property to `true`, and optionally set
 *   `response.error.retryDelay` to the millisecond delay for the next attempt.
 *   In the case of a redirect, `response.error.redirect` should be set to
 *   `true` with `retryDelay` set to an optional delay on the next request.
 *
 *   If a listener decides that a request should not be retried,
 *   it should set both `retryable` and `redirect` to false.
 *
 *   Note that a retryable error will be retried at most
 *   {AWS.Config.maxRetries} times (based on the service object's config).
 *   Similarly, a request that is redirected will only redirect at most
 *   {AWS.Config.maxRedirects} times.
 *
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @example Adding a custom retry for a 404 response
 *     request.on('retry', function(response) {
 *       // this resource is not yet available, wait 10 seconds to get it again
 *       if (response.httpResponse.statusCode === 404 && response.error) {
 *         response.error.retryable = true;   // retry this error
 *         response.error.retryDelay = 10000; // wait 10 seconds
 *       }
 *     });
 *
 * @!group Data Parsing Events
 *
 * @!event extractError(response)
 *   Triggered on all non-2xx requests so that listeners can extract
 *   error details from the response body. Listeners to this event
 *   should set the `response.error` property.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event extractData(response)
 *   Triggered in successful requests to allow listeners to
 *   de-serialize the response body into `response.data`.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!group Completion Events
 *
 * @!event success(response)
 *   Triggered when the request completed successfully.
 *   `response.data` will contain the response data and
 *   `response.error` will be null.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event error(error, response)
 *   Triggered when an error occurs at any point during the
 *   request. `response.error` will contain details about the error
 *   that occurred. `response.data` will be null.
 *   @param error [Error] the error object containing details about
 *     the error that occurred.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event complete(response)
 *   Triggered whenever a request cycle completes. `response.error`
 *   should be checked, since the request may have failed.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!group HTTP Events
 *
 * @!event httpHeaders(statusCode, headers, response, statusMessage)
 *   Triggered when headers are sent by the remote server
 *   @param statusCode [Integer] the HTTP response code
 *   @param headers [map<String,String>] the response headers
 *   @param (see AWS.Request~send)
 *   @param statusMessage [String] A status message corresponding to the HTTP
 *                                 response code
 *   @context (see AWS.Request~send)
 *
 * @!event httpData(chunk, response)
 *   Triggered when data is sent by the remote server
 *   @param chunk [Buffer] the buffer data containing the next data chunk
 *     from the server
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @see AWS.EventListeners.Core.HTTP_DATA
 *
 * @!event httpUploadProgress(progress, response)
 *   Triggered when the HTTP request has uploaded more data
 *   @param progress [map] An object containing the `loaded` and `total` bytes
 *     of the request.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @note This event will not be emitted in Node.js 0.8.x.
 *
 * @!event httpDownloadProgress(progress, response)
 *   Triggered when the HTTP request has downloaded more data
 *   @param progress [map] An object containing the `loaded` and `total` bytes
 *     of the request.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @note This event will not be emitted in Node.js 0.8.x.
 *
 * @!event httpError(error, response)
 *   Triggered when the HTTP request failed
 *   @param error [Error] the error object that was thrown
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event httpDone(response)
 *   Triggered when the server is finished sending data
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @see AWS.Response
 */
AWS.Request = inherit({

  /**
   * Creates a request for an operation on a given service with
   * a set of input parameters.
   *
   * @param service [AWS.Service] the service to perform the operation on
   * @param operation [String] the operation to perform on the service
   * @param params [Object] parameters to send to the operation.
   *   See the operation's documentation for the format of the
   *   parameters.
   */
  constructor: function Request(service, operation, params) {
    var endpoint = service.endpoint;
    var region = service.config.region;
    var customUserAgent = service.config.customUserAgent;

    // global endpoints sign as us-east-1
    if (service.isGlobalEndpoint) region = 'us-east-1';

    this.domain = domain && domain.active;
    this.service = service;
    this.operation = operation;
    this.params = params || {};
    this.httpRequest = new AWS.HttpRequest(endpoint, region);
    this.httpRequest.appendToUserAgent(customUserAgent);
    this.startTime = service.getSkewCorrectedDate();

    this.response = new AWS.Response(this);
    this._asm = new AcceptorStateMachine(fsm.states, 'validate');
    this._haltHandlersOnError = false;

    AWS.SequentialExecutor.call(this);
    this.emit = this.emitEvent;
  },

  /**
   * @!group Sending a Request
   */

  /**
   * @overload send(callback = null)
   *   Sends the request object.
   *
   *   @callback callback function(err, data)
   *     If a callback is supplied, it is called when a response is returned
   *     from the service.
   *     @context [AWS.Request] the request object being sent.
   *     @param err [Error] the error object returned from the request.
   *       Set to `null` if the request is successful.
   *     @param data [Object] the de-serialized data returned from
   *       the request. Set to `null` if a request error occurs.
   *   @example Sending a request with a callback
   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     request.send(function(err, data) { console.log(err, data); });
   *   @example Sending a request with no callback (using event handlers)
   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     request.on('complete', function(response) { ... }); // register a callback
   *     request.send();
   */
  send: function send(callback) {
    if (callback) {
      // append to user agent
      this.httpRequest.appendToUserAgent('callback');
      this.on('complete', function (resp) {
        callback.call(resp, resp.error, resp.data);
      });
    }
    this.runTo();

    return this.response;
  },

  /**
   * @!method  promise()
   *   Sends the request and returns a 'thenable' promise.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function(data)
   *     Called if the promise is fulfilled.
   *     @param data [Object] the de-serialized data returned from the request.
   *   @callback rejectedCallback function(error)
   *     Called if the promise is rejected.
   *     @param error [Error] the error object returned from the request.
   *   @return [Promise] A promise that represents the state of the request.
   *   @example Sending a request using promises.
   *     var request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     var result = request.promise();
   *     result.then(function(data) { ... }, function(error) { ... });
   */

  /**
   * @api private
   */
  build: function build(callback) {
    return this.runTo('send', callback);
  },

  /**
   * @api private
   */
  runTo: function runTo(state, done) {
    this._asm.runTo(state, done, this);
    return this;
  },

  /**
   * Aborts a request, emitting the error and complete events.
   *
   * @!macro nobrowser
   * @example Aborting a request after sending
   *   var params = {
   *     Bucket: 'bucket', Key: 'key',
   *     Body: new Buffer(1024 * 1024 * 5) // 5MB payload
   *   };
   *   var request = s3.putObject(params);
   *   request.send(function (err, data) {
   *     if (err) console.log("Error:", err.code, err.message);
   *     else console.log(data);
   *   });
   *
   *   // abort request in 1 second
   *   setTimeout(request.abort.bind(request), 1000);
   *
   *   // prints "Error: RequestAbortedError Request aborted by user"
   * @return [AWS.Request] the same request object, for chaining.
   * @since v1.4.0
   */
  abort: function abort() {
    this.removeAllListeners('validateResponse');
    this.removeAllListeners('extractError');
    this.on('validateResponse', function addAbortedError(resp) {
      resp.error = AWS.util.error(new Error('Request aborted by user'), {
         code: 'RequestAbortedError', retryable: false
      });
    });

    if (this.httpRequest.stream && !this.httpRequest.stream.didCallback) { // abort HTTP stream
      this.httpRequest.stream.abort();
      if (this.httpRequest._abortCallback) {
         this.httpRequest._abortCallback();
      } else {
        this.removeAllListeners('send'); // haven't sent yet, so let's not
      }
    }

    return this;
  },

  /**
   * Iterates over each page of results given a pageable request, calling
   * the provided callback with each page of data. After all pages have been
   * retrieved, the callback is called with `null` data.
   *
   * @note This operation can generate multiple requests to a service.
   * @example Iterating over multiple pages of objects in an S3 bucket
   *   var pages = 1;
   *   s3.listObjects().eachPage(function(err, data) {
   *     if (err) return;
   *     console.log("Page", pages++);
   *     console.log(data);
   *   });
   * @example Iterating over multiple pages with an asynchronous callback
   *   s3.listObjects(params).eachPage(function(err, data, done) {
   *     doSomethingAsyncAndOrExpensive(function() {
   *       // The next page of results isn't fetched until done is called
   *       done();
   *     });
   *   });
   * @callback callback function(err, data, [doneCallback])
   *   Called with each page of resulting data from the request. If the
   *   optional `doneCallback` is provided in the function, it must be called
   *   when the callback is complete.
   *
   *   @param err [Error] an error object, if an error occurred.
   *   @param data [Object] a single page of response data. If there is no
   *     more data, this object will be `null`.
   *   @param doneCallback [Function] an optional done callback. If this
   *     argument is defined in the function declaration, it should be called
   *     when the next page is ready to be retrieved. This is useful for
   *     controlling serial pagination across asynchronous operations.
   *   @return [Boolean] if the callback returns `false`, pagination will
   *     stop.
   *
   * @see AWS.Request.eachItem
   * @see AWS.Response.nextPage
   * @since v1.4.0
   */
  eachPage: function eachPage(callback) {
    // Make all callbacks async-ish
    callback = AWS.util.fn.makeAsync(callback, 3);

    function wrappedCallback(response) {
      callback.call(response, response.error, response.data, function (result) {
        if (result === false) return;

        if (response.hasNextPage()) {
          response.nextPage().on('complete', wrappedCallback).send();
        } else {
          callback.call(response, null, null, AWS.util.fn.noop);
        }
      });
    }

    this.on('complete', wrappedCallback).send();
  },

  /**
   * Enumerates over individual items of a request, paging the responses if
   * necessary.
   *
   * @api experimental
   * @since v1.4.0
   */
  eachItem: function eachItem(callback) {
    var self = this;
    function wrappedCallback(err, data) {
      if (err) return callback(err, null);
      if (data === null) return callback(null, null);

      var config = self.service.paginationConfig(self.operation);
      var resultKey = config.resultKey;
      if (Array.isArray(resultKey)) resultKey = resultKey[0];
      var items = jmespath.search(data, resultKey);
      var continueIteration = true;
      AWS.util.arrayEach(items, function(item) {
        continueIteration = callback(null, item);
        if (continueIteration === false) {
          return AWS.util.abort;
        }
      });
      return continueIteration;
    }

    this.eachPage(wrappedCallback);
  },

  /**
   * @return [Boolean] whether the operation can return multiple pages of
   *   response data.
   * @see AWS.Response.eachPage
   * @since v1.4.0
   */
  isPageable: function isPageable() {
    return this.service.paginationConfig(this.operation) ? true : false;
  },

  /**
   * Sends the request and converts the request object into a readable stream
   * that can be read from or piped into a writable stream.
   *
   * @note The data read from a readable stream contains only
   *   the raw HTTP body contents.
   * @example Manually reading from a stream
   *   request.createReadStream().on('data', function(data) {
   *     console.log("Got data:", data.toString());
   *   });
   * @example Piping a request body into a file
   *   var out = fs.createWriteStream('/path/to/outfile.jpg');
   *   s3.service.getObject(params).createReadStream().pipe(out);
   * @return [Stream] the readable stream object that can be piped
   *   or read from (by registering 'data' event listeners).
   * @!macro nobrowser
   */
  createReadStream: function createReadStream() {
    var streams = AWS.util.stream;
    var req = this;
    var stream = null;

    if (AWS.HttpClient.streamsApiVersion === 2) {
      stream = new streams.PassThrough();
      process.nextTick(function() { req.send(); });
    } else {
      stream = new streams.Stream();
      stream.readable = true;

      stream.sent = false;
      stream.on('newListener', function(event) {
        if (!stream.sent && event === 'data') {
          stream.sent = true;
          process.nextTick(function() { req.send(); });
        }
      });
    }

    this.on('error', function(err) {
      stream.emit('error', err);
    });

    this.on('httpHeaders', function streamHeaders(statusCode, headers, resp) {
      if (statusCode < 300) {
        req.removeListener('httpData', AWS.EventListeners.Core.HTTP_DATA);
        req.removeListener('httpError', AWS.EventListeners.Core.HTTP_ERROR);
        req.on('httpError', function streamHttpError(error) {
          resp.error = error;
          resp.error.retryable = false;
        });

        var shouldCheckContentLength = false;
        var expectedLen;
        if (req.httpRequest.method !== 'HEAD') {
          expectedLen = parseInt(headers['content-length'], 10);
        }
        if (expectedLen !== undefined && !isNaN(expectedLen) && expectedLen >= 0) {
          shouldCheckContentLength = true;
          var receivedLen = 0;
        }

        var checkContentLengthAndEmit = function checkContentLengthAndEmit() {
          if (shouldCheckContentLength && receivedLen !== expectedLen) {
            stream.emit('error', AWS.util.error(
              new Error('Stream content length mismatch. Received ' +
                receivedLen + ' of ' + expectedLen + ' bytes.'),
              { code: 'StreamContentLengthMismatch' }
            ));
          } else if (AWS.HttpClient.streamsApiVersion === 2) {
            stream.end();
          } else {
            stream.emit('end');
          }
        };

        var httpStream = resp.httpResponse.createUnbufferedStream();

        if (AWS.HttpClient.streamsApiVersion === 2) {
          if (shouldCheckContentLength) {
            var lengthAccumulator = new streams.PassThrough();
            lengthAccumulator._write = function(chunk) {
              if (chunk && chunk.length) {
                receivedLen += chunk.length;
              }
              return streams.PassThrough.prototype._write.apply(this, arguments);
            };

            lengthAccumulator.on('end', checkContentLengthAndEmit);
            stream.on('error', function(err) {
              shouldCheckContentLength = false;
              httpStream.unpipe(lengthAccumulator);
              lengthAccumulator.emit('end');
              lengthAccumulator.end();
            });
            httpStream.pipe(lengthAccumulator).pipe(stream, { end: false });
          } else {
            httpStream.pipe(stream);
          }
        } else {

          if (shouldCheckContentLength) {
            httpStream.on('data', function(arg) {
              if (arg && arg.length) {
                receivedLen += arg.length;
              }
            });
          }

          httpStream.on('data', function(arg) {
            stream.emit('data', arg);
          });
          httpStream.on('end', checkContentLengthAndEmit);
        }

        httpStream.on('error', function(err) {
          shouldCheckContentLength = false;
          stream.emit('error', err);
        });
      }
    });

    return stream;
  },

  /**
   * @param [Array,Response] args This should be the response object,
   *   or an array of args to send to the event.
   * @api private
   */
  emitEvent: function emit(eventName, args, done) {
    if (typeof args === 'function') { done = args; args = null; }
    if (!done) done = function() { };
    if (!args) args = this.eventParameters(eventName, this.response);

    var origEmit = AWS.SequentialExecutor.prototype.emit;
    origEmit.call(this, eventName, args, function (err) {
      if (err) this.response.error = err;
      done.call(this, err);
    });
  },

  /**
   * @api private
   */
  eventParameters: function eventParameters(eventName) {
    switch (eventName) {
      case 'restart':
      case 'validate':
      case 'sign':
      case 'build':
      case 'afterValidate':
      case 'afterBuild':
        return [this];
      case 'error':
        return [this.response.error, this.response];
      default:
        return [this.response];
    }
  },

  /**
   * @api private
   */
  presign: function presign(expires, callback) {
    if (!callback && typeof expires === 'function') {
      callback = expires;
      expires = null;
    }
    return new AWS.Signers.Presign().sign(this.toGet(), expires, callback);
  },

  /**
   * @api private
   */
  isPresigned: function isPresigned() {
    return Object.prototype.hasOwnProperty.call(this.httpRequest.headers, 'presigned-expires');
  },

  /**
   * @api private
   */
  toUnauthenticated: function toUnauthenticated() {
    this.removeListener('validate', AWS.EventListeners.Core.VALIDATE_CREDENTIALS);
    this.removeListener('sign', AWS.EventListeners.Core.SIGN);
    return this;
  },

  /**
   * @api private
   */
  toGet: function toGet() {
    if (this.service.api.protocol === 'query' ||
        this.service.api.protocol === 'ec2') {
      this.removeListener('build', this.buildAsGet);
      this.addListener('build', this.buildAsGet);
    }
    return this;
  },

  /**
   * @api private
   */
  buildAsGet: function buildAsGet(request) {
    request.httpRequest.method = 'GET';
    request.httpRequest.path = request.service.endpoint.path +
                               '?' + request.httpRequest.body;
    request.httpRequest.body = '';

    // don't need these headers on a GET request
    delete request.httpRequest.headers['Content-Length'];
    delete request.httpRequest.headers['Content-Type'];
  },

  /**
   * @api private
   */
  haltHandlersOnError: function haltHandlersOnError() {
    this._haltHandlersOnError = true;
  }
});

/**
 * @api private
 */
AWS.Request.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
  this.prototype.promise = function promise() {
    var self = this;
    // append to user agent
    this.httpRequest.appendToUserAgent('promise');
    return new PromiseDependency(function(resolve, reject) {
      self.on('complete', function(resp) {
        if (resp.error) {
          reject(resp.error);
        } else {
          // define $response property so that it is not enumberable
          // this prevents circular reference errors when stringifying the JSON object
          resolve(Object.defineProperty(
            resp.data || {},
            '$response',
            {value: resp}
          ));
        }
      });
      self.runTo();
    });
  };
};

/**
 * @api private
 */
AWS.Request.deletePromisesFromClass = function deletePromisesFromClass() {
  delete this.prototype.promise;
};

AWS.util.addPromises(AWS.Request);

AWS.util.mixin(AWS.Request, AWS.SequentialExecutor);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(254)))

/***/ }),
/* 2686 */
/***/ (function(module, exports) {

function AcceptorStateMachine(states, state) {
  this.currentState = state || null;
  this.states = states || {};
}

AcceptorStateMachine.prototype.runTo = function runTo(finalState, done, bindObject, inputError) {
  if (typeof finalState === 'function') {
    inputError = bindObject; bindObject = done;
    done = finalState; finalState = null;
  }

  var self = this;
  var state = self.states[self.currentState];
  state.fn.call(bindObject || self, inputError, function(err) {
    if (err) {
      if (state.fail) self.currentState = state.fail;
      else return done ? done.call(bindObject, err) : null;
    } else {
      if (state.accept) self.currentState = state.accept;
      else return done ? done.call(bindObject) : null;
    }
    if (self.currentState === finalState) {
      return done ? done.call(bindObject, err) : null;
    }

    self.runTo(finalState, done, bindObject, err);
  });
};

AcceptorStateMachine.prototype.addState = function addState(name, acceptState, failState, fn) {
  if (typeof acceptState === 'function') {
    fn = acceptState; acceptState = null; failState = null;
  } else if (typeof failState === 'function') {
    fn = failState; failState = null;
  }

  if (!this.currentState) this.currentState = name;
  this.states[name] = { accept: acceptState, fail: failState, fn: fn };
  return this;
};

module.exports = AcceptorStateMachine;


/***/ }),
/* 2687 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var inherit = AWS.util.inherit;
var jmespath = __webpack_require__(646);

/**
 * This class encapsulates the response information
 * from a service request operation sent through {AWS.Request}.
 * The response object has two main properties for getting information
 * back from a request:
 *
 * ## The `data` property
 *
 * The `response.data` property contains the serialized object data
 * retrieved from the service request. For instance, for an
 * Amazon DynamoDB `listTables` method call, the response data might
 * look like:
 *
 * ```
 * > resp.data
 * { TableNames:
 *    [ 'table1', 'table2', ... ] }
 * ```
 *
 * The `data` property can be null if an error occurs (see below).
 *
 * ## The `error` property
 *
 * In the event of a service error (or transfer error), the
 * `response.error` property will be filled with the given
 * error data in the form:
 *
 * ```
 * { code: 'SHORT_UNIQUE_ERROR_CODE',
 *   message: 'Some human readable error message' }
 * ```
 *
 * In the case of an error, the `data` property will be `null`.
 * Note that if you handle events that can be in a failure state,
 * you should always check whether `response.error` is set
 * before attempting to access the `response.data` property.
 *
 * @!attribute data
 *   @readonly
 *   @!group Data Properties
 *   @note Inside of a {AWS.Request~httpData} event, this
 *     property contains a single raw packet instead of the
 *     full de-serialized service response.
 *   @return [Object] the de-serialized response data
 *     from the service.
 *
 * @!attribute error
 *   An structure containing information about a service
 *   or networking error.
 *   @readonly
 *   @!group Data Properties
 *   @note This attribute is only filled if a service or
 *     networking error occurs.
 *   @return [Error]
 *     * code [String] a unique short code representing the
 *       error that was emitted.
 *     * message [String] a longer human readable error message
 *     * retryable [Boolean] whether the error message is
 *       retryable.
 *     * statusCode [Numeric] in the case of a request that reached the service,
 *       this value contains the response status code.
 *     * time [Date] the date time object when the error occurred.
 *     * hostname [String] set when a networking error occurs to easily
 *       identify the endpoint of the request.
 *     * region [String] set when a networking error occurs to easily
 *       identify the region of the request.
 *
 * @!attribute requestId
 *   @readonly
 *   @!group Data Properties
 *   @return [String] the unique request ID associated with the response.
 *     Log this value when debugging requests for AWS support.
 *
 * @!attribute retryCount
 *   @readonly
 *   @!group Operation Properties
 *   @return [Integer] the number of retries that were
 *     attempted before the request was completed.
 *
 * @!attribute redirectCount
 *   @readonly
 *   @!group Operation Properties
 *   @return [Integer] the number of redirects that were
 *     followed before the request was completed.
 *
 * @!attribute httpResponse
 *   @readonly
 *   @!group HTTP Properties
 *   @return [AWS.HttpResponse] the raw HTTP response object
 *     containing the response headers and body information
 *     from the server.
 *
 * @see AWS.Request
 */
AWS.Response = inherit({

  /**
   * @api private
   */
  constructor: function Response(request) {
    this.request = request;
    this.data = null;
    this.error = null;
    this.retryCount = 0;
    this.redirectCount = 0;
    this.httpResponse = new AWS.HttpResponse();
    if (request) {
      this.maxRetries = request.service.numRetries();
      this.maxRedirects = request.service.config.maxRedirects;
    }
  },

  /**
   * Creates a new request for the next page of response data, calling the
   * callback with the page data if a callback is provided.
   *
   * @callback callback function(err, data)
   *   Called when a page of data is returned from the next request.
   *
   *   @param err [Error] an error object, if an error occurred in the request
   *   @param data [Object] the next page of data, or null, if there are no
   *     more pages left.
   * @return [AWS.Request] the request object for the next page of data
   * @return [null] if no callback is provided and there are no pages left
   *   to retrieve.
   * @since v1.4.0
   */
  nextPage: function nextPage(callback) {
    var config;
    var service = this.request.service;
    var operation = this.request.operation;
    try {
      config = service.paginationConfig(operation, true);
    } catch (e) { this.error = e; }

    if (!this.hasNextPage()) {
      if (callback) callback(this.error, null);
      else if (this.error) throw this.error;
      return null;
    }

    var params = AWS.util.copy(this.request.params);
    if (!this.nextPageTokens) {
      return callback ? callback(null, null) : null;
    } else {
      var inputTokens = config.inputToken;
      if (typeof inputTokens === 'string') inputTokens = [inputTokens];
      for (var i = 0; i < inputTokens.length; i++) {
        params[inputTokens[i]] = this.nextPageTokens[i];
      }
      return service.makeRequest(this.request.operation, params, callback);
    }
  },

  /**
   * @return [Boolean] whether more pages of data can be returned by further
   *   requests
   * @since v1.4.0
   */
  hasNextPage: function hasNextPage() {
    this.cacheNextPageTokens();
    if (this.nextPageTokens) return true;
    if (this.nextPageTokens === undefined) return undefined;
    else return false;
  },

  /**
   * @api private
   */
  cacheNextPageTokens: function cacheNextPageTokens() {
    if (Object.prototype.hasOwnProperty.call(this, 'nextPageTokens')) return this.nextPageTokens;
    this.nextPageTokens = undefined;

    var config = this.request.service.paginationConfig(this.request.operation);
    if (!config) return this.nextPageTokens;

    this.nextPageTokens = null;
    if (config.moreResults) {
      if (!jmespath.search(this.data, config.moreResults)) {
        return this.nextPageTokens;
      }
    }

    var exprs = config.outputToken;
    if (typeof exprs === 'string') exprs = [exprs];
    AWS.util.arrayEach.call(this, exprs, function (expr) {
      var output = jmespath.search(this.data, expr);
      if (output) {
        this.nextPageTokens = this.nextPageTokens || [];
        this.nextPageTokens.push(output);
      }
    });

    return this.nextPageTokens;
  }

});


/***/ }),
/* 2688 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2012-2013 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You
 * may not use this file except in compliance with the License. A copy of
 * the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific
 * language governing permissions and limitations under the License.
 */

var AWS = __webpack_require__(5);
var inherit = AWS.util.inherit;
var jmespath = __webpack_require__(646);

/**
 * @api private
 */
function CHECK_ACCEPTORS(resp) {
  var waiter = resp.request._waiter;
  var acceptors = waiter.config.acceptors;
  var acceptorMatched = false;
  var state = 'retry';

  acceptors.forEach(function(acceptor) {
    if (!acceptorMatched) {
      var matcher = waiter.matchers[acceptor.matcher];
      if (matcher && matcher(resp, acceptor.expected, acceptor.argument)) {
        acceptorMatched = true;
        state = acceptor.state;
      }
    }
  });

  if (!acceptorMatched && resp.error) state = 'failure';

  if (state === 'success') {
    waiter.setSuccess(resp);
  } else {
    waiter.setError(resp, state === 'retry');
  }
}

/**
 * @api private
 */
AWS.ResourceWaiter = inherit({
  /**
   * Waits for a given state on a service object
   * @param service [Service] the service object to wait on
   * @param state [String] the state (defined in waiter configuration) to wait
   *   for.
   * @example Create a waiter for running EC2 instances
   *   var ec2 = new AWS.EC2;
   *   var waiter = new AWS.ResourceWaiter(ec2, 'instanceRunning');
   */
  constructor: function constructor(service, state) {
    this.service = service;
    this.state = state;
    this.loadWaiterConfig(this.state);
  },

  service: null,

  state: null,

  config: null,

  matchers: {
    path: function(resp, expected, argument) {
      try {
        var result = jmespath.search(resp.data, argument);
      } catch (err) {
        return false;
      }

      return jmespath.strictDeepEqual(result,expected);
    },

    pathAll: function(resp, expected, argument) {
      try {
        var results = jmespath.search(resp.data, argument);
      } catch (err) {
        return false;
      }

      if (!Array.isArray(results)) results = [results];
      var numResults = results.length;
      if (!numResults) return false;
      for (var ind = 0 ; ind < numResults; ind++) {
        if (!jmespath.strictDeepEqual(results[ind], expected)) {
          return false;
        }
      }
      return true;
    },

    pathAny: function(resp, expected, argument) {
      try {
        var results = jmespath.search(resp.data, argument);
      } catch (err) {
        return false;
      }

      if (!Array.isArray(results)) results = [results];
      var numResults = results.length;
      for (var ind = 0 ; ind < numResults; ind++) {
        if (jmespath.strictDeepEqual(results[ind], expected)) {
          return true;
        }
      }
      return false;
    },

    status: function(resp, expected) {
      var statusCode = resp.httpResponse.statusCode;
      return (typeof statusCode === 'number') && (statusCode === expected);
    },

    error: function(resp, expected) {
      if (typeof expected === 'string' && resp.error) {
        return expected === resp.error.code;
      }
      // if expected is not string, can be boolean indicating presence of error
      return expected === !!resp.error;
    }
  },

  listeners: new AWS.SequentialExecutor().addNamedListeners(function(add) {
    add('RETRY_CHECK', 'retry', function(resp) {
      var waiter = resp.request._waiter;
      if (resp.error && resp.error.code === 'ResourceNotReady') {
        resp.error.retryDelay = (waiter.config.delay || 0) * 1000;
      }
    });

    add('CHECK_OUTPUT', 'extractData', CHECK_ACCEPTORS);

    add('CHECK_ERROR', 'extractError', CHECK_ACCEPTORS);
  }),

  /**
   * @return [AWS.Request]
   */
  wait: function wait(params, callback) {
    if (typeof params === 'function') {
      callback = params; params = undefined;
    }

    if (params && params.$waiter) {
      params = AWS.util.copy(params);
      if (typeof params.$waiter.delay === 'number') {
        this.config.delay = params.$waiter.delay;
      }
      if (typeof params.$waiter.maxAttempts === 'number') {
        this.config.maxAttempts = params.$waiter.maxAttempts;
      }
      delete params.$waiter;
    }

    var request = this.service.makeRequest(this.config.operation, params);
    request._waiter = this;
    request.response.maxRetries = this.config.maxAttempts;
    request.addListeners(this.listeners);

    if (callback) request.send(callback);
    return request;
  },

  setSuccess: function setSuccess(resp) {
    resp.error = null;
    resp.data = resp.data || {};
    resp.request.removeAllListeners('extractData');
  },

  setError: function setError(resp, retryable) {
    resp.data = null;
    resp.error = AWS.util.error(resp.error || new Error(), {
      code: 'ResourceNotReady',
      message: 'Resource is not in the state ' + this.state,
      retryable: retryable
    });
  },

  /**
   * Loads waiter configuration from API configuration
   *
   * @api private
   */
  loadWaiterConfig: function loadWaiterConfig(state) {
    if (!this.service.api.waiters[state]) {
      throw new AWS.util.error(new Error(), {
        code: 'StateNotFoundError',
        message: 'State ' + state + ' not found.'
      });
    }

    this.config = AWS.util.copy(this.service.api.waiters[state]);
  }
});


/***/ }),
/* 2689 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);

var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.RequestSigner = inherit({
  constructor: function RequestSigner(request) {
    this.request = request;
  },

  setServiceClientId: function setServiceClientId(id) {
    this.serviceClientId = id;
  },

  getServiceClientId: function getServiceClientId() {
    return this.serviceClientId;
  }
});

AWS.Signers.RequestSigner.getVersion = function getVersion(version) {
  switch (version) {
    case 'v2': return AWS.Signers.V2;
    case 'v3': return AWS.Signers.V3;
    case 'v4': return AWS.Signers.V4;
    case 's3': return AWS.Signers.S3;
    case 'v3https': return AWS.Signers.V3Https;
  }
  throw new Error('Unknown signing version ' + version);
};

__webpack_require__(2690);
__webpack_require__(1066);
__webpack_require__(2691);
__webpack_require__(2692);
__webpack_require__(2693);
__webpack_require__(2694);


/***/ }),
/* 2690 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.V2 = inherit(AWS.Signers.RequestSigner, {
  addAuthorization: function addAuthorization(credentials, date) {

    if (!date) date = AWS.util.date.getDate();

    var r = this.request;

    r.params.Timestamp = AWS.util.date.iso8601(date);
    r.params.SignatureVersion = '2';
    r.params.SignatureMethod = 'HmacSHA256';
    r.params.AWSAccessKeyId = credentials.accessKeyId;

    if (credentials.sessionToken) {
      r.params.SecurityToken = credentials.sessionToken;
    }

    delete r.params.Signature; // delete old Signature for re-signing
    r.params.Signature = this.signature(credentials);

    r.body = AWS.util.queryParamsToString(r.params);
    r.headers['Content-Length'] = r.body.length;
  },

  signature: function signature(credentials) {
    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
  },

  stringToSign: function stringToSign() {
    var parts = [];
    parts.push(this.request.method);
    parts.push(this.request.endpoint.host.toLowerCase());
    parts.push(this.request.pathname());
    parts.push(AWS.util.queryParamsToString(this.request.params));
    return parts.join('\n');
  }

});

module.exports = AWS.Signers.V2;


/***/ }),
/* 2691 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var inherit = AWS.util.inherit;

__webpack_require__(1066);

/**
 * @api private
 */
AWS.Signers.V3Https = inherit(AWS.Signers.V3, {
  authorization: function authorization(credentials) {
    return 'AWS3-HTTPS ' +
      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
      'Algorithm=HmacSHA256,' +
      'Signature=' + this.signature(credentials);
  },

  stringToSign: function stringToSign() {
    return this.request.headers['X-Amz-Date'];
  }
});

module.exports = AWS.Signers.V3Https;


/***/ }),
/* 2692 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var v4Credentials = __webpack_require__(1067);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
var expiresHeader = 'presigned-expires';

/**
 * @api private
 */
AWS.Signers.V4 = inherit(AWS.Signers.RequestSigner, {
  constructor: function V4(request, serviceName, options) {
    AWS.Signers.RequestSigner.call(this, request);
    this.serviceName = serviceName;
    options = options || {};
    this.signatureCache = typeof options.signatureCache === 'boolean' ? options.signatureCache : true;
    this.operation = options.operation;
  },

  algorithm: 'AWS4-HMAC-SHA256',

  addAuthorization: function addAuthorization(credentials, date) {
    var datetime = AWS.util.date.iso8601(date).replace(/[:\-]|\.\d{3}/g, '');

    if (this.isPresigned()) {
      this.updateForPresigned(credentials, datetime);
    } else {
      this.addHeaders(credentials, datetime);
    }

    this.request.headers['Authorization'] =
      this.authorization(credentials, datetime);
  },

  addHeaders: function addHeaders(credentials, datetime) {
    this.request.headers['X-Amz-Date'] = datetime;
    if (credentials.sessionToken) {
      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
    }
  },

  updateForPresigned: function updateForPresigned(credentials, datetime) {
    var credString = this.credentialString(datetime);
    var qs = {
      'X-Amz-Date': datetime,
      'X-Amz-Algorithm': this.algorithm,
      'X-Amz-Credential': credentials.accessKeyId + '/' + credString,
      'X-Amz-Expires': this.request.headers[expiresHeader],
      'X-Amz-SignedHeaders': this.signedHeaders()
    };

    if (credentials.sessionToken) {
      qs['X-Amz-Security-Token'] = credentials.sessionToken;
    }

    if (this.request.headers['Content-Type']) {
      qs['Content-Type'] = this.request.headers['Content-Type'];
    }
    if (this.request.headers['Content-MD5']) {
      qs['Content-MD5'] = this.request.headers['Content-MD5'];
    }
    if (this.request.headers['Cache-Control']) {
      qs['Cache-Control'] = this.request.headers['Cache-Control'];
    }

    // need to pull in any other X-Amz-* headers
    AWS.util.each.call(this, this.request.headers, function(key, value) {
      if (key === expiresHeader) return;
      if (this.isSignableHeader(key)) {
        var lowerKey = key.toLowerCase();
        // Metadata should be normalized
        if (lowerKey.indexOf('x-amz-meta-') === 0) {
          qs[lowerKey] = value;
        } else if (lowerKey.indexOf('x-amz-') === 0) {
          qs[key] = value;
        }
      }
    });

    var sep = this.request.path.indexOf('?') >= 0 ? '&' : '?';
    this.request.path += sep + AWS.util.queryParamsToString(qs);
  },

  authorization: function authorization(credentials, datetime) {
    var parts = [];
    var credString = this.credentialString(datetime);
    parts.push(this.algorithm + ' Credential=' +
      credentials.accessKeyId + '/' + credString);
    parts.push('SignedHeaders=' + this.signedHeaders());
    parts.push('Signature=' + this.signature(credentials, datetime));
    return parts.join(', ');
  },

  signature: function signature(credentials, datetime) {
    var signingKey = v4Credentials.getSigningKey(
      credentials,
      datetime.substr(0, 8),
      this.request.region,
      this.serviceName,
      this.signatureCache
    );
    return AWS.util.crypto.hmac(signingKey, this.stringToSign(datetime), 'hex');
  },

  stringToSign: function stringToSign(datetime) {
    var parts = [];
    parts.push('AWS4-HMAC-SHA256');
    parts.push(datetime);
    parts.push(this.credentialString(datetime));
    parts.push(this.hexEncodedHash(this.canonicalString()));
    return parts.join('\n');
  },

  canonicalString: function canonicalString() {
    var parts = [], pathname = this.request.pathname();
    if (this.serviceName !== 's3') pathname = AWS.util.uriEscapePath(pathname);

    parts.push(this.request.method);
    parts.push(pathname);
    parts.push(this.request.search());
    parts.push(this.canonicalHeaders() + '\n');
    parts.push(this.signedHeaders());
    parts.push(this.hexEncodedBodyHash());
    return parts.join('\n');
  },

  canonicalHeaders: function canonicalHeaders() {
    var headers = [];
    AWS.util.each.call(this, this.request.headers, function (key, item) {
      headers.push([key, item]);
    });
    headers.sort(function (a, b) {
      return a[0].toLowerCase() < b[0].toLowerCase() ? -1 : 1;
    });
    var parts = [];
    AWS.util.arrayEach.call(this, headers, function (item) {
      var key = item[0].toLowerCase();
      if (this.isSignableHeader(key)) {
        var value = item[1];
        if (typeof value === 'undefined' || value === null || typeof value.toString !== 'function') {
          throw AWS.util.error(new Error('Header ' + key + ' contains invalid value'), {
            code: 'InvalidHeader'
          });
        }
        parts.push(key + ':' +
          this.canonicalHeaderValues(value.toString()));
      }
    });
    return parts.join('\n');
  },

  canonicalHeaderValues: function canonicalHeaderValues(values) {
    return values.replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
  },

  signedHeaders: function signedHeaders() {
    var keys = [];
    AWS.util.each.call(this, this.request.headers, function (key) {
      key = key.toLowerCase();
      if (this.isSignableHeader(key)) keys.push(key);
    });
    return keys.sort().join(';');
  },

  credentialString: function credentialString(datetime) {
    return v4Credentials.createScope(
      datetime.substr(0, 8),
      this.request.region,
      this.serviceName
    );
  },

  hexEncodedHash: function hash(string) {
    return AWS.util.crypto.sha256(string, 'hex');
  },

  hexEncodedBodyHash: function hexEncodedBodyHash() {
    var request = this.request;
    if (this.isPresigned() && this.serviceName === 's3' && !request.body) {
      return 'UNSIGNED-PAYLOAD';
    } else if (request.headers['X-Amz-Content-Sha256']) {
      return request.headers['X-Amz-Content-Sha256'];
    } else {
      return this.hexEncodedHash(this.request.body || '');
    }
  },

  unsignableHeaders: [
    'authorization',
    'content-type',
    'content-length',
    'user-agent',
    expiresHeader,
    'expect',
    'x-amzn-trace-id'
  ],

  isSignableHeader: function isSignableHeader(key) {
    if (key.toLowerCase().indexOf('x-amz-') === 0) return true;
    return this.unsignableHeaders.indexOf(key) < 0;
  },

  isPresigned: function isPresigned() {
    return this.request.headers[expiresHeader] ? true : false;
  }

});

module.exports = AWS.Signers.V4;


/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.S3 = inherit(AWS.Signers.RequestSigner, {
  /**
   * When building the stringToSign, these sub resource params should be
   * part of the canonical resource string with their NON-decoded values
   */
  subResources: {
    'acl': 1,
    'accelerate': 1,
    'analytics': 1,
    'cors': 1,
    'lifecycle': 1,
    'delete': 1,
    'inventory': 1,
    'location': 1,
    'logging': 1,
    'metrics': 1,
    'notification': 1,
    'partNumber': 1,
    'policy': 1,
    'requestPayment': 1,
    'replication': 1,
    'restore': 1,
    'tagging': 1,
    'torrent': 1,
    'uploadId': 1,
    'uploads': 1,
    'versionId': 1,
    'versioning': 1,
    'versions': 1,
    'website': 1
  },

  // when building the stringToSign, these querystring params should be
  // part of the canonical resource string with their NON-encoded values
  responseHeaders: {
    'response-content-type': 1,
    'response-content-language': 1,
    'response-expires': 1,
    'response-cache-control': 1,
    'response-content-disposition': 1,
    'response-content-encoding': 1
  },

  addAuthorization: function addAuthorization(credentials, date) {
    if (!this.request.headers['presigned-expires']) {
      this.request.headers['X-Amz-Date'] = AWS.util.date.rfc822(date);
    }

    if (credentials.sessionToken) {
      // presigned URLs require this header to be lowercased
      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
    }

    var signature = this.sign(credentials.secretAccessKey, this.stringToSign());
    var auth = 'AWS ' + credentials.accessKeyId + ':' + signature;

    this.request.headers['Authorization'] = auth;
  },

  stringToSign: function stringToSign() {
    var r = this.request;

    var parts = [];
    parts.push(r.method);
    parts.push(r.headers['Content-MD5'] || '');
    parts.push(r.headers['Content-Type'] || '');

    // This is the "Date" header, but we use X-Amz-Date.
    // The S3 signing mechanism requires us to pass an empty
    // string for this Date header regardless.
    parts.push(r.headers['presigned-expires'] || '');

    var headers = this.canonicalizedAmzHeaders();
    if (headers) parts.push(headers);
    parts.push(this.canonicalizedResource());

    return parts.join('\n');

  },

  canonicalizedAmzHeaders: function canonicalizedAmzHeaders() {

    var amzHeaders = [];

    AWS.util.each(this.request.headers, function (name) {
      if (name.match(/^x-amz-/i))
        amzHeaders.push(name);
    });

    amzHeaders.sort(function (a, b) {
      return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
    });

    var parts = [];
    AWS.util.arrayEach.call(this, amzHeaders, function (name) {
      parts.push(name.toLowerCase() + ':' + String(this.request.headers[name]));
    });

    return parts.join('\n');

  },

  canonicalizedResource: function canonicalizedResource() {

    var r = this.request;

    var parts = r.path.split('?');
    var path = parts[0];
    var querystring = parts[1];

    var resource = '';

    if (r.virtualHostedBucket)
      resource += '/' + r.virtualHostedBucket;

    resource += path;

    if (querystring) {

      // collect a list of sub resources and query params that need to be signed
      var resources = [];

      AWS.util.arrayEach.call(this, querystring.split('&'), function (param) {
        var name = param.split('=')[0];
        var value = param.split('=')[1];
        if (this.subResources[name] || this.responseHeaders[name]) {
          var subresource = { name: name };
          if (value !== undefined) {
            if (this.subResources[name]) {
              subresource.value = value;
            } else {
              subresource.value = decodeURIComponent(value);
            }
          }
          resources.push(subresource);
        }
      });

      resources.sort(function (a, b) { return a.name < b.name ? -1 : 1; });

      if (resources.length) {

        querystring = [];
        AWS.util.arrayEach(resources, function (res) {
          if (res.value === undefined) {
            querystring.push(res.name);
          } else {
            querystring.push(res.name + '=' + res.value);
          }
        });

        resource += '?' + querystring.join('&');
      }

    }

    return resource;

  },

  sign: function sign(secret, string) {
    return AWS.util.crypto.hmac(secret, string, 'base64', 'sha1');
  }
});

module.exports = AWS.Signers.S3;


/***/ }),
/* 2694 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
var expiresHeader = 'presigned-expires';

/**
 * @api private
 */
function signedUrlBuilder(request) {
  var expires = request.httpRequest.headers[expiresHeader];
  var signerClass = request.service.getSignerClass(request);

  delete request.httpRequest.headers['User-Agent'];
  delete request.httpRequest.headers['X-Amz-User-Agent'];

  if (signerClass === AWS.Signers.V4) {
    if (expires > 604800) { // one week expiry is invalid
      var message = 'Presigning does not support expiry time greater ' +
                    'than a week with SigV4 signing.';
      throw AWS.util.error(new Error(), {
        code: 'InvalidExpiryTime', message: message, retryable: false
      });
    }
    request.httpRequest.headers[expiresHeader] = expires;
  } else if (signerClass === AWS.Signers.S3) {
    var now = request.service ? request.service.getSkewCorrectedDate() : AWS.util.date.getDate();
    request.httpRequest.headers[expiresHeader] = parseInt(
      AWS.util.date.unixTimestamp(now) + expires, 10).toString();
  } else {
    throw AWS.util.error(new Error(), {
      message: 'Presigning only supports S3 or SigV4 signing.',
      code: 'UnsupportedSigner', retryable: false
    });
  }
}

/**
 * @api private
 */
function signedUrlSigner(request) {
  var endpoint = request.httpRequest.endpoint;
  var parsedUrl = AWS.util.urlParse(request.httpRequest.path);
  var queryParams = {};

  if (parsedUrl.search) {
    queryParams = AWS.util.queryStringParse(parsedUrl.search.substr(1));
  }

  var auth = request.httpRequest.headers['Authorization'].split(' ');
  if (auth[0] === 'AWS') {
    auth = auth[1].split(':');
    queryParams['AWSAccessKeyId'] = auth[0];
    queryParams['Signature'] = auth[1];

    AWS.util.each(request.httpRequest.headers, function (key, value) {
      if (key === expiresHeader) key = 'Expires';
      if (key.indexOf('x-amz-meta-') === 0) {
        // Delete existing, potentially not normalized key
        delete queryParams[key];
        key = key.toLowerCase();
      }
      queryParams[key] = value;
    });
    delete request.httpRequest.headers[expiresHeader];
    delete queryParams['Authorization'];
    delete queryParams['Host'];
  } else if (auth[0] === 'AWS4-HMAC-SHA256') { // SigV4 signing
    auth.shift();
    var rest = auth.join(' ');
    var signature = rest.match(/Signature=(.*?)(?:,|\s|\r?\n|$)/)[1];
    queryParams['X-Amz-Signature'] = signature;
    delete queryParams['Expires'];
  }

  // build URL
  endpoint.pathname = parsedUrl.pathname;
  endpoint.search = AWS.util.queryParamsToString(queryParams);
}

/**
 * @api private
 */
AWS.Signers.Presign = inherit({
  /**
   * @api private
   */
  sign: function sign(request, expireTime, callback) {
    request.httpRequest.headers[expiresHeader] = expireTime || 3600;
    request.on('build', signedUrlBuilder);
    request.on('sign', signedUrlSigner);
    request.removeListener('afterBuild',
      AWS.EventListeners.Core.SET_CONTENT_LENGTH);
    request.removeListener('afterBuild',
      AWS.EventListeners.Core.COMPUTE_SHA256);

    request.emit('beforePresign', [request]);

    if (callback) {
      request.build(function() {
        if (this.response.error) callback(this.response.error);
        else {
          callback(null, AWS.util.urlFormat(request.httpRequest.endpoint));
        }
      });
    } else {
      request.build();
      if (request.response.error) throw request.response.error;
      return AWS.util.urlFormat(request.httpRequest.endpoint);
    }
  }
});

module.exports = AWS.Signers.Presign;


/***/ }),
/* 2695 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);

/**
 * @api private
 */
AWS.ParamValidator = AWS.util.inherit({
  /**
   * Create a new validator object.
   *
   * @param validation [Boolean|map] whether input parameters should be
   *     validated against the operation description before sending the
   *     request. Pass a map to enable any of the following specific
   *     validation features:
   *
   *     * **min** [Boolean] &mdash; Validates that a value meets the min
   *       constraint. This is enabled by default when paramValidation is set
   *       to `true`.
   *     * **max** [Boolean] &mdash; Validates that a value meets the max
   *       constraint.
   *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
   *       regular expression.
   *     * **enum** [Boolean] &mdash; Validates that a string value matches one
   *       of the allowable enum values.
   */
  constructor: function ParamValidator(validation) {
    if (validation === true || validation === undefined) {
      validation = {'min': true};
    }
    this.validation = validation;
  },

  validate: function validate(shape, params, context) {
    this.errors = [];
    this.validateMember(shape, params || {}, context || 'params');

    if (this.errors.length > 1) {
      var msg = this.errors.join('\n* ');
      msg = 'There were ' + this.errors.length +
        ' validation errors:\n* ' + msg;
      throw AWS.util.error(new Error(msg),
        {code: 'MultipleValidationErrors', errors: this.errors});
    } else if (this.errors.length === 1) {
      throw this.errors[0];
    } else {
      return true;
    }
  },

  fail: function fail(code, message) {
    this.errors.push(AWS.util.error(new Error(message), {code: code}));
  },

  validateStructure: function validateStructure(shape, params, context) {
    this.validateType(params, context, ['object'], 'structure');

    var paramName;
    for (var i = 0; shape.required && i < shape.required.length; i++) {
      paramName = shape.required[i];
      var value = params[paramName];
      if (value === undefined || value === null) {
        this.fail('MissingRequiredParameter',
          'Missing required key \'' + paramName + '\' in ' + context);
      }
    }

    // validate hash members
    for (paramName in params) {
      if (!Object.prototype.hasOwnProperty.call(params, paramName)) continue;

      var paramValue = params[paramName],
          memberShape = shape.members[paramName];

      if (memberShape !== undefined) {
        var memberContext = [context, paramName].join('.');
        this.validateMember(memberShape, paramValue, memberContext);
      } else {
        this.fail('UnexpectedParameter',
          'Unexpected key \'' + paramName + '\' found in ' + context);
      }
    }

    return true;
  },

  validateMember: function validateMember(shape, param, context) {
    switch (shape.type) {
      case 'structure':
        return this.validateStructure(shape, param, context);
      case 'list':
        return this.validateList(shape, param, context);
      case 'map':
        return this.validateMap(shape, param, context);
      default:
        return this.validateScalar(shape, param, context);
    }
  },

  validateList: function validateList(shape, params, context) {
    if (this.validateType(params, context, [Array])) {
      this.validateRange(shape, params.length, context, 'list member count');
      // validate array members
      for (var i = 0; i < params.length; i++) {
        this.validateMember(shape.member, params[i], context + '[' + i + ']');
      }
    }
  },

  validateMap: function validateMap(shape, params, context) {
    if (this.validateType(params, context, ['object'], 'map')) {
      // Build up a count of map members to validate range traits.
      var mapCount = 0;
      for (var param in params) {
        if (!Object.prototype.hasOwnProperty.call(params, param)) continue;
        // Validate any map key trait constraints
        this.validateMember(shape.key, param,
                            context + '[key=\'' + param + '\']')
        this.validateMember(shape.value, params[param],
                            context + '[\'' + param + '\']');
        mapCount++;
      }
      this.validateRange(shape, mapCount, context, 'map member count');
    }
  },

  validateScalar: function validateScalar(shape, value, context) {
    switch (shape.type) {
      case null:
      case undefined:
      case 'string':
        return this.validateString(shape, value, context);
      case 'base64':
      case 'binary':
        return this.validatePayload(value, context);
      case 'integer':
      case 'float':
        return this.validateNumber(shape, value, context);
      case 'boolean':
        return this.validateType(value, context, ['boolean']);
      case 'timestamp':
        return this.validateType(value, context, [Date,
          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/, 'number'],
          'Date object, ISO-8601 string, or a UNIX timestamp');
      default:
        return this.fail('UnkownType', 'Unhandled type ' +
                         shape.type + ' for ' + context);
    }
  },

  validateString: function validateString(shape, value, context) {
    var validTypes = ['string'];
    if (shape.isJsonValue) {
      validTypes = validTypes.concat(['number', 'object', 'boolean']);
    }
    if (value !== null && this.validateType(value, context, validTypes)) {
      this.validateEnum(shape, value, context);
      this.validateRange(shape, value.length, context, 'string length');
      this.validatePattern(shape, value, context);
    }
  },

  validatePattern: function validatePattern(shape, value, context) {
    if (this.validation['pattern'] && shape['pattern'] !== undefined) {
      if (!(new RegExp(shape['pattern'])).test(value)) {
        this.fail('PatternMatchError', 'Provided value "' + value + '" '
          + 'does not match regex pattern /' + shape['pattern'] + '/ for '
          + context);
      }
    }
  },

  validateRange: function validateRange(shape, value, context, descriptor) {
    if (this.validation['min']) {
      if (shape['min'] !== undefined && value < shape['min']) {
        this.fail('MinRangeError', 'Expected ' + descriptor + ' >= '
          + shape['min'] + ', but found ' + value + ' for ' + context);
      }
    }
    if (this.validation['max']) {
      if (shape['max'] !== undefined && value > shape['max']) {
        this.fail('MaxRangeError', 'Expected ' + descriptor + ' <= '
          + shape['max'] + ', but found ' + value + ' for ' + context);
      }
    }
  },

  validateEnum: function validateRange(shape, value, context) {
    if (this.validation['enum'] && shape['enum'] !== undefined) {
      // Fail if the string value is not present in the enum list
      if (shape['enum'].indexOf(value) === -1) {
        this.fail('EnumError', 'Found string value of ' + value + ', but '
          + 'expected ' + shape['enum'].join('|') + ' for ' + context);
      }
    }
  },

  validateType: function validateType(value, context, acceptedTypes, type) {
    // We will not log an error for null or undefined, but we will return
    // false so that callers know that the expected type was not strictly met.
    if (value === null || value === undefined) return false;

    var foundInvalidType = false;
    for (var i = 0; i < acceptedTypes.length; i++) {
      if (typeof acceptedTypes[i] === 'string') {
        if (typeof value === acceptedTypes[i]) return true;
      } else if (acceptedTypes[i] instanceof RegExp) {
        if ((value || '').toString().match(acceptedTypes[i])) return true;
      } else {
        if (value instanceof acceptedTypes[i]) return true;
        if (AWS.util.isType(value, acceptedTypes[i])) return true;
        if (!type && !foundInvalidType) acceptedTypes = acceptedTypes.slice();
        acceptedTypes[i] = AWS.util.typeName(acceptedTypes[i]);
      }
      foundInvalidType = true;
    }

    var acceptedType = type;
    if (!acceptedType) {
      acceptedType = acceptedTypes.join(', ').replace(/,([^,]+)$/, ', or$1');
    }

    var vowel = acceptedType.match(/^[aeiou]/i) ? 'n' : '';
    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a' +
              vowel + ' ' + acceptedType);
    return false;
  },

  validateNumber: function validateNumber(shape, value, context) {
    if (value === null || value === undefined) return;
    if (typeof value === 'string') {
      var castedValue = parseFloat(value);
      if (castedValue.toString() === value) value = castedValue;
    }
    if (this.validateType(value, context, ['number'])) {
      this.validateRange(shape, value, context, 'numeric value');
    }
  },

  validatePayload: function validatePayload(value, context) {
    if (value === null || value === undefined) return;
    if (typeof value === 'string') return;
    if (value && typeof value.byteLength === 'number') return; // typed arrays
    if (AWS.util.isNode()) { // special check for buffer/stream in Node.js
      var Stream = AWS.util.stream.Stream;
      if (AWS.util.Buffer.isBuffer(value) || value instanceof Stream) return;
    }

    var types = ['Buffer', 'Stream', 'File', 'Blob', 'ArrayBuffer', 'DataView'];
    if (value) {
      for (var i = 0; i < types.length; i++) {
        if (AWS.util.isType(value, types[i])) return;
        if (AWS.util.typeName(value.constructor) === types[i]) return;
      }
    }

    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a ' +
      'string, Buffer, Stream, Blob, or typed array object');
  }
});


/***/ }),
/* 2696 */
/***/ (function(module, exports) {

module.exports = {"acm":{"name":"ACM","cors":true},"apigateway":{"name":"APIGateway","cors":true},"applicationautoscaling":{"prefix":"application-autoscaling","name":"ApplicationAutoScaling","cors":true},"appstream":{"name":"AppStream"},"autoscaling":{"name":"AutoScaling","cors":true},"batch":{"name":"Batch"},"budgets":{"name":"Budgets"},"clouddirectory":{"name":"CloudDirectory"},"cloudformation":{"name":"CloudFormation","cors":true},"cloudfront":{"name":"CloudFront","versions":["2013-05-12*","2013-11-11*","2014-05-31*","2014-10-21*","2014-11-06*","2015-04-17*","2015-07-27*","2015-09-17*","2016-01-13*","2016-01-28*","2016-08-01*","2016-08-20*","2016-09-07*","2016-09-29*","2016-11-25*"],"cors":true},"cloudhsm":{"name":"CloudHSM","cors":true},"cloudsearch":{"name":"CloudSearch"},"cloudsearchdomain":{"name":"CloudSearchDomain"},"cloudtrail":{"name":"CloudTrail","cors":true},"cloudwatch":{"prefix":"monitoring","name":"CloudWatch","cors":true},"cloudwatchevents":{"prefix":"events","name":"CloudWatchEvents","versions":["2014-02-03*"],"cors":true},"cloudwatchlogs":{"prefix":"logs","name":"CloudWatchLogs","cors":true},"codebuild":{"name":"CodeBuild"},"codecommit":{"name":"CodeCommit","cors":true},"codedeploy":{"name":"CodeDeploy","cors":true},"codepipeline":{"name":"CodePipeline","cors":true},"cognitoidentity":{"prefix":"cognito-identity","name":"CognitoIdentity","cors":true},"cognitoidentityserviceprovider":{"prefix":"cognito-idp","name":"CognitoIdentityServiceProvider","cors":true},"cognitosync":{"prefix":"cognito-sync","name":"CognitoSync","cors":true},"configservice":{"prefix":"config","name":"ConfigService","cors":true},"cur":{"name":"CUR","cors":true},"datapipeline":{"name":"DataPipeline"},"devicefarm":{"name":"DeviceFarm","cors":true},"directconnect":{"name":"DirectConnect","cors":true},"directoryservice":{"prefix":"ds","name":"DirectoryService"},"discovery":{"name":"Discovery"},"dms":{"name":"DMS"},"dynamodb":{"name":"DynamoDB","cors":true},"dynamodbstreams":{"prefix":"streams.dynamodb","name":"DynamoDBStreams","cors":true},"ec2":{"name":"EC2","versions":["2013-06-15*","2013-10-15*","2014-02-01*","2014-05-01*","2014-06-15*","2014-09-01*","2014-10-01*","2015-03-01*","2015-04-15*","2015-10-01*","2016-04-01*","2016-09-15*"],"cors":true},"ecr":{"name":"ECR","cors":true},"ecs":{"name":"ECS","cors":true},"efs":{"prefix":"elasticfilesystem","name":"EFS","cors":true},"elasticache":{"name":"ElastiCache","versions":["2012-11-15*","2014-03-24*","2014-07-15*","2014-09-30*"],"cors":true},"elasticbeanstalk":{"name":"ElasticBeanstalk","cors":true},"elb":{"prefix":"elasticloadbalancing","name":"ELB","cors":true},"elbv2":{"prefix":"elasticloadbalancingv2","name":"ELBv2","cors":true},"emr":{"prefix":"elasticmapreduce","name":"EMR","cors":true},"es":{"name":"ES"},"elastictranscoder":{"name":"ElasticTranscoder","cors":true},"firehose":{"name":"Firehose","cors":true},"gamelift":{"name":"GameLift","cors":true},"glacier":{"name":"Glacier"},"health":{"name":"Health"},"iam":{"name":"IAM"},"importexport":{"name":"ImportExport"},"inspector":{"name":"Inspector","versions":["2015-08-18*"],"cors":true},"iot":{"name":"Iot","cors":true},"iotdata":{"prefix":"iot-data","name":"IotData","cors":true},"kinesis":{"name":"Kinesis","cors":true},"kinesisanalytics":{"name":"KinesisAnalytics"},"kms":{"name":"KMS","cors":true},"lambda":{"name":"Lambda","cors":true},"lexruntime":{"prefix":"runtime.lex","name":"LexRuntime","cors":true},"lightsail":{"name":"Lightsail"},"machinelearning":{"name":"MachineLearning","cors":true},"marketplacecommerceanalytics":{"name":"MarketplaceCommerceAnalytics","cors":true},"marketplacemetering":{"prefix":"meteringmarketplace","name":"MarketplaceMetering"},"mturk":{"prefix":"mturk-requester","name":"MTurk","cors":true},"mobileanalytics":{"name":"MobileAnalytics","cors":true},"opsworks":{"name":"OpsWorks","cors":true},"opsworkscm":{"name":"OpsWorksCM"},"organizations":{"name":"Organizations"},"pinpoint":{"name":"Pinpoint"},"polly":{"name":"Polly","cors":true},"rds":{"name":"RDS","versions":["2014-09-01*"],"cors":true},"redshift":{"name":"Redshift","cors":true},"rekognition":{"name":"Rekognition","cors":true},"resourcegroupstaggingapi":{"name":"ResourceGroupsTaggingAPI"},"route53":{"name":"Route53","cors":true},"route53domains":{"name":"Route53Domains","cors":true},"s3":{"name":"S3","dualstackAvailable":true,"cors":true},"servicecatalog":{"name":"ServiceCatalog","cors":true},"ses":{"prefix":"email","name":"SES","cors":true},"shield":{"name":"Shield"},"simpledb":{"prefix":"sdb","name":"SimpleDB"},"sms":{"name":"SMS"},"snowball":{"name":"Snowball"},"sns":{"name":"SNS","cors":true},"sqs":{"name":"SQS","cors":true},"ssm":{"name":"SSM","cors":true},"storagegateway":{"name":"StorageGateway","cors":true},"stepfunctions":{"prefix":"states","name":"StepFunctions"},"sts":{"name":"STS","cors":true},"support":{"name":"Support"},"swf":{"name":"SWF"},"xray":{"name":"XRay"},"waf":{"name":"WAF","cors":true},"wafregional":{"prefix":"waf-regional","name":"WAFRegional"},"workdocs":{"name":"WorkDocs","cors":true},"workspaces":{"name":"WorkSpaces"},"codestar":{"name":"CodeStar"},"lexmodelbuildingservice":{"prefix":"lex-models","name":"LexModelBuildingService","cors":true},"marketplaceentitlementservice":{"prefix":"entitlement.marketplace","name":"MarketplaceEntitlementService"},"athena":{"name":"Athena"},"greengrass":{"name":"Greengrass"},"dax":{"name":"DAX"},"migrationhub":{"prefix":"AWSMigrationHub","name":"MigrationHub"},"cloudhsmv2":{"name":"CloudHSMV2"},"glue":{"name":"Glue"},"mobile":{"name":"Mobile"},"pricing":{"name":"Pricing"},"costexplorer":{"prefix":"ce","name":"CostExplorer"},"mediaconvert":{"name":"MediaConvert"},"medialive":{"name":"MediaLive"},"mediapackage":{"name":"MediaPackage"},"mediastore":{"name":"MediaStore"},"mediastoredata":{"prefix":"mediastore-data","name":"MediaStoreData"},"appsync":{"name":"AppSync"},"guardduty":{"name":"GuardDuty"},"mq":{"name":"MQ"},"comprehend":{"name":"Comprehend"},"iotjobsdataplane":{"prefix":"iot-jobs-data","name":"IoTJobsDataPlane"},"kinesisvideoarchivedmedia":{"prefix":"kinesis-video-archived-media","name":"KinesisVideoArchivedMedia"},"kinesisvideomedia":{"prefix":"kinesis-video-media","name":"KinesisVideoMedia"},"kinesisvideo":{"name":"KinesisVideo"},"sagemakerruntime":{"prefix":"runtime.sagemaker","name":"SageMakerRuntime"},"sagemaker":{"name":"SageMaker"},"translate":{"name":"Translate"},"resourcegroups":{"prefix":"resource-groups","name":"ResourceGroups"},"alexaforbusiness":{"name":"AlexaForBusiness"},"cloud9":{"name":"Cloud9"},"serverlessapplicationrepository":{"prefix":"serverlessrepo","name":"ServerlessApplicationRepository"},"servicediscovery":{"name":"ServiceDiscovery"},"workmail":{"name":"WorkMail"},"autoscalingplans":{"prefix":"autoscaling-plans","name":"AutoScalingPlans"},"transcribeservice":{"prefix":"transcribe","name":"TranscribeService"}}

/***/ }),
/* 2697 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(2698);
var v4 = __webpack_require__(2699);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 2698 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(1068);
var bytesToUuid = __webpack_require__(1069);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
  _seedBytes[0] | 0x01,
  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 2699 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(1068);
var bytesToUuid = __webpack_require__(1069);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 2700 */
/***/ (function(module, exports, __webpack_require__) {

var Hmac = __webpack_require__(2701);
var Md5 = __webpack_require__(2705);
var Sha1 = __webpack_require__(2706);
var Sha256 = __webpack_require__(2707);

module.exports = exports = {
    createHash: function createHash(alg) {
      alg = alg.toLowerCase();
      if (alg === 'md5') {
        return new Md5();
      } else if (alg === 'sha256') {
        return new Sha256();
      } else if (alg === 'sha1') {
        return new Sha1();
      }

      throw new Error('Hash algorithm ' + alg + ' is not supported in the browser SDK');
    },
    createHmac: function createHmac(alg, key) {
      alg = alg.toLowerCase();
      if (alg === 'md5') {
        return new Hmac(Md5, key);
      } else if (alg === 'sha256') {
        return new Hmac(Sha256, key);
      } else if (alg === 'sha1') {
        return new Hmac(Sha1, key);
      }

      throw new Error('HMAC algorithm ' + alg + ' is not supported in the browser SDK');
    },
    createSign: function() {
      throw new Error('createSign is not implemented in the browser');
    }
  }


/***/ }),
/* 2701 */
/***/ (function(module, exports, __webpack_require__) {

var hashUtils = __webpack_require__(440);

/**
 * @api private
 */
function Hmac(hashCtor, secret) {
    this.hash = new hashCtor();
    this.outer = new hashCtor();

    var inner = bufferFromSecret(hashCtor, secret);
    var outer = new Uint8Array(hashCtor.BLOCK_SIZE);
    outer.set(inner);

    for (var i = 0; i < hashCtor.BLOCK_SIZE; i++) {
        inner[i] ^= 0x36;
        outer[i] ^= 0x5c;
    }

    this.hash.update(inner);
    this.outer.update(outer);

    // Zero out the copied key buffer.
    for (var i = 0; i < inner.byteLength; i++) {
        inner[i] = 0;
    }
}

module.exports = exports = Hmac;

Hmac.prototype.update = function (toHash) {
    if (hashUtils.isEmptyData(toHash) || this.error) {
        return this;
    }

    try {
        this.hash.update(hashUtils.convertToBuffer(toHash));
    } catch (e) {
        this.error = e;
    }

    return this;
};

Hmac.prototype.digest = function (encoding) {
    if (!this.outer.finished) {
        this.outer.update(this.hash.digest());
    }

    return this.outer.digest(encoding);
}

function bufferFromSecret(hashCtor, secret) {
    var input = hashUtils.convertToBuffer(secret);
    if (input.byteLength > hashCtor.BLOCK_SIZE) {
        var bufferHash = new hashCtor;
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(hashCtor.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}


/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 2703 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 2704 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 2705 */
/***/ (function(module, exports, __webpack_require__) {

var hashUtils = __webpack_require__(440);
var Buffer = __webpack_require__(339).Buffer;

var BLOCK_SIZE = 64;

var DIGEST_LENGTH = 16;

var INIT = [
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476,
];

/**
 * @api private
 */
function Md5() {
    this.state = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
    ];
    this.buffer = new DataView(new ArrayBuffer(BLOCK_SIZE));
    this.bufferLength = 0;
    this.bytesHashed = 0;
    this.finished = false;
}

module.exports = exports = Md5;

Md5.BLOCK_SIZE = BLOCK_SIZE;

Md5.prototype.update = function (sourceData) {
    if (hashUtils.isEmptyData(sourceData)) {
        return this;
    } else if (this.finished) {
        throw new Error('Attempted to update an already finished hash.');
    }

    var data = hashUtils.convertToBuffer(sourceData);
    var position = 0;
    var byteLength = data.byteLength;
    this.bytesHashed += byteLength;
    while (byteLength > 0) {
        this.buffer.setUint8(this.bufferLength++, data[position++]);
        byteLength--;
        if (this.bufferLength === BLOCK_SIZE) {
            this.hashBuffer();
            this.bufferLength = 0;
        }
    }

    return this;
};

Md5.prototype.digest = function (encoding) {
    if (!this.finished) {
        var _a = this, buffer = _a.buffer, undecoratedLength = _a.bufferLength, bytesHashed = _a.bytesHashed;
        var bitsHashed = bytesHashed * 8;
        buffer.setUint8(this.bufferLength++, 128);
        // Ensure the final block has enough room for the hashed length
        if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
            for (var i = this.bufferLength; i < BLOCK_SIZE; i++) {
                buffer.setUint8(i, 0);
            }
            this.hashBuffer();
            this.bufferLength = 0;
        }
        for (var i = this.bufferLength; i < BLOCK_SIZE - 8; i++) {
            buffer.setUint8(i, 0);
        }
        buffer.setUint32(BLOCK_SIZE - 8, bitsHashed >>> 0, true);
        buffer.setUint32(BLOCK_SIZE - 4, Math.floor(bitsHashed / 0x100000000), true);
        this.hashBuffer();
        this.finished = true;
    }
    var out = new DataView(new ArrayBuffer(DIGEST_LENGTH));
    for (var i = 0; i < 4; i++) {
        out.setUint32(i * 4, this.state[i], true);
    }
    var buff = new Buffer(out.buffer, out.byteOffset, out.byteLength);
    return encoding ? buff.toString(encoding) : buff;
};

Md5.prototype.hashBuffer = function () {
    var _a = this, buffer = _a.buffer, state = _a.state;
    var a = state[0], b = state[1], c = state[2], d = state[3];
    a = ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
    d = ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
    c = ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
    b = ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
    a = ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
    d = ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
    c = ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
    b = ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
    a = ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
    d = ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
    c = ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
    b = ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
    a = ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
    d = ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
    c = ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
    b = ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
    a = gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
    d = gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
    c = gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
    b = gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
    a = gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
    d = gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
    c = gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
    b = gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
    a = gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
    d = gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
    c = gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
    b = gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
    a = gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
    d = gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
    c = gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
    b = gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
    a = hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
    d = hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
    c = hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
    b = hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
    a = hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
    d = hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
    c = hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
    b = hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
    a = hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
    d = hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
    c = hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
    b = hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
    a = hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
    d = hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
    c = hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
    b = hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
    a = ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
    d = ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
    c = ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
    b = ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
    a = ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
    d = ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
    c = ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
    b = ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
    a = ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
    d = ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
    c = ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
    b = ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
    a = ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
    d = ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
    c = ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
    b = ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
    state[0] = (a + state[0]) & 0xFFFFFFFF;
    state[1] = (b + state[1]) & 0xFFFFFFFF;
    state[2] = (c + state[2]) & 0xFFFFFFFF;
    state[3] = (d + state[3]) & 0xFFFFFFFF;
};

function cmn(q, a, b, x, s, t) {
    a = (((a + q) & 0xFFFFFFFF) + ((x + t) & 0xFFFFFFFF)) & 0xFFFFFFFF;
    return (((a << s) | (a >>> (32 - s))) + b) & 0xFFFFFFFF;
}

function ff(a, b, c, d, x, s, t) {
    return cmn((b & c) | ((~b) & d), a, b, x, s, t);
}

function gg(a, b, c, d, x, s, t) {
    return cmn((b & d) | (c & (~d)), a, b, x, s, t);
}

function hh(a, b, c, d, x, s, t) {
    return cmn(b ^ c ^ d, a, b, x, s, t);
}

function ii(a, b, c, d, x, s, t) {
    return cmn(c ^ (b | (~d)), a, b, x, s, t);
}


/***/ }),
/* 2706 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(339).Buffer;
var hashUtils = __webpack_require__(440);

var BLOCK_SIZE = 64;

var DIGEST_LENGTH = 20;

var KEY = new Uint32Array([
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc | 0,
    0xca62c1d6 | 0
]);

var INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19,
];

var MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

/**
 * @api private
 */
function Sha1() {
    this.h0 = 0x67452301;
    this.h1 = 0xEFCDAB89;
    this.h2 = 0x98BADCFE;
    this.h3 = 0x10325476;
    this.h4 = 0xC3D2E1F0;
    // The first 64 bytes (16 words) is the data chunk
    this.block = new Uint32Array(80);
    this.offset = 0;
    this.shift = 24;
    this.totalLength = 0;
}

module.exports = exports = Sha1;

Sha1.BLOCK_SIZE = BLOCK_SIZE;

Sha1.prototype.update = function (data) {
    if (this.finished) {
        throw new Error('Attempted to update an already finished hash.');
    }

    if (hashUtils.isEmptyData(data)) {
        return this;
    }

    data = hashUtils.convertToBuffer(data);

    var length = data.length;
    this.totalLength += length * 8;
    for (var i = 0; i < length; i++) {
        this.write(data[i]);
    }

    return this;
};

Sha1.prototype.write = function write(byte) {
    this.block[this.offset] |= (byte & 0xff) << this.shift;
    if (this.shift) {
        this.shift -= 8;
    } else {
        this.offset++;
        this.shift = 24;
    }

    if (this.offset === 16) this.processBlock();
};

Sha1.prototype.digest = function (encoding) {
    // Pad
    this.write(0x80);
    if (this.offset > 14 || (this.offset === 14 && this.shift < 24)) {
      this.processBlock();
    }
    this.offset = 14;
    this.shift = 24;

    // 64-bit length big-endian
    this.write(0x00); // numbers this big aren't accurate in javascript anyway
    this.write(0x00); // ..So just hard-code to zero.
    this.write(this.totalLength > 0xffffffffff ? this.totalLength / 0x10000000000 : 0x00);
    this.write(this.totalLength > 0xffffffff ? this.totalLength / 0x100000000 : 0x00);
    for (var s = 24; s >= 0; s -= 8) {
        this.write(this.totalLength >> s);
    }
    // The value in state is little-endian rather than big-endian, so flip
    // each word into a new Uint8Array
    var out = new Buffer(DIGEST_LENGTH);
    var outView = new DataView(out.buffer);
    outView.setUint32(0, this.h0, false);
    outView.setUint32(4, this.h1, false);
    outView.setUint32(8, this.h2, false);
    outView.setUint32(12, this.h3, false);
    outView.setUint32(16, this.h4, false);

    return encoding ? out.toString(encoding) : out;
};

Sha1.prototype.processBlock = function processBlock() {
    // Extend the sixteen 32-bit words into eighty 32-bit words:
    for (var i = 16; i < 80; i++) {
      var w = this.block[i - 3] ^ this.block[i - 8] ^ this.block[i - 14] ^ this.block[i - 16];
      this.block[i] = (w << 1) | (w >>> 31);
    }

    // Initialize hash value for this chunk:
    var a = this.h0;
    var b = this.h1;
    var c = this.h2;
    var d = this.h3;
    var e = this.h4;
    var f, k;

    // Main loop:
    for (i = 0; i < 80; i++) {
      if (i < 20) {
        f = d ^ (b & (c ^ d));
        k = 0x5A827999;
      }
      else if (i < 40) {
        f = b ^ c ^ d;
        k = 0x6ED9EBA1;
      }
      else if (i < 60) {
        f = (b & c) | (d & (b | c));
        k = 0x8F1BBCDC;
      }
      else {
        f = b ^ c ^ d;
        k = 0xCA62C1D6;
      }
      var temp = (a << 5 | a >>> 27) + f + e + k + (this.block[i]|0);
      e = d;
      d = c;
      c = (b << 30 | b >>> 2);
      b = a;
      a = temp;
    }

    // Add this chunk's hash to result so far:
    this.h0 = (this.h0 + a) | 0;
    this.h1 = (this.h1 + b) | 0;
    this.h2 = (this.h2 + c) | 0;
    this.h3 = (this.h3 + d) | 0;
    this.h4 = (this.h4 + e) | 0;

    // The block is now reusable.
    this.offset = 0;
    for (i = 0; i < 16; i++) {
        this.block[i] = 0;
    }
}


/***/ }),
/* 2707 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(339).Buffer;
var hashUtils = __webpack_require__(440);

var BLOCK_SIZE = 64;

var DIGEST_LENGTH = 32;

var KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);

var INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19,
];

var MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

/**
 * @private
 */
function Sha256() {
    this.state = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19,
    ];
    this.temp = new Int32Array(64);
    this.buffer = new Uint8Array(64);
    this.bufferLength = 0;
    this.bytesHashed = 0;
    /**
     * @private
     */
    this.finished = false;
}

module.exports = exports = Sha256;

Sha256.BLOCK_SIZE = BLOCK_SIZE;

Sha256.prototype.update = function (data) {
    if (this.finished) {
        throw new Error('Attempted to update an already finished hash.');
    }

    if (hashUtils.isEmptyData(data)) {
        return this;
    }

    data = hashUtils.convertToBuffer(data);

    var position = 0;
    var byteLength = data.byteLength;
    this.bytesHashed += byteLength;
    if (this.bytesHashed * 8 > MAX_HASHABLE_LENGTH) {
        throw new Error('Cannot hash more than 2^53 - 1 bits');
    }

    while (byteLength > 0) {
        this.buffer[this.bufferLength++] = data[position++];
        byteLength--;
        if (this.bufferLength === BLOCK_SIZE) {
            this.hashBuffer();
            this.bufferLength = 0;
        }
    }

    return this;
};

Sha256.prototype.digest = function (encoding) {
    if (!this.finished) {
        var bitsHashed = this.bytesHashed * 8;
        var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
        var undecoratedLength = this.bufferLength;
        bufferView.setUint8(this.bufferLength++, 0x80);
        // Ensure the final block has enough room for the hashed length
        if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
            for (var i = this.bufferLength; i < BLOCK_SIZE; i++) {
                bufferView.setUint8(i, 0);
            }
            this.hashBuffer();
            this.bufferLength = 0;
        }
        for (var i = this.bufferLength; i < BLOCK_SIZE - 8; i++) {
            bufferView.setUint8(i, 0);
        }
        bufferView.setUint32(BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
        bufferView.setUint32(BLOCK_SIZE - 4, bitsHashed);
        this.hashBuffer();
        this.finished = true;
    }
    // The value in state is little-endian rather than big-endian, so flip
    // each word into a new Uint8Array
    var out = new Buffer(DIGEST_LENGTH);
    for (var i = 0; i < 8; i++) {
        out[i * 4] = (this.state[i] >>> 24) & 0xff;
        out[i * 4 + 1] = (this.state[i] >>> 16) & 0xff;
        out[i * 4 + 2] = (this.state[i] >>> 8) & 0xff;
        out[i * 4 + 3] = (this.state[i] >>> 0) & 0xff;
    }
    return encoding ? out.toString(encoding) : out;
};

Sha256.prototype.hashBuffer = function () {
    var _a = this,
        buffer = _a.buffer,
        state = _a.state;
    var state0 = state[0],
        state1 = state[1],
        state2 = state[2],
        state3 = state[3],
        state4 = state[4],
        state5 = state[5],
        state6 = state[6],
        state7 = state[7];
    for (var i = 0; i < BLOCK_SIZE; i++) {
        if (i < 16) {
            this.temp[i] = (((buffer[i * 4] & 0xff) << 24) |
                ((buffer[(i * 4) + 1] & 0xff) << 16) |
                ((buffer[(i * 4) + 2] & 0xff) << 8) |
                (buffer[(i * 4) + 3] & 0xff));
        }
        else {
            var u = this.temp[i - 2];
            var t1_1 = (u >>> 17 | u << 15) ^
                (u >>> 19 | u << 13) ^
                (u >>> 10);
            u = this.temp[i - 15];
            var t2_1 = (u >>> 7 | u << 25) ^
                (u >>> 18 | u << 14) ^
                (u >>> 3);
            this.temp[i] = (t1_1 + this.temp[i - 7] | 0) +
                (t2_1 + this.temp[i - 16] | 0);
        }
        var t1 = (((((state4 >>> 6 | state4 << 26) ^
            (state4 >>> 11 | state4 << 21) ^
            (state4 >>> 25 | state4 << 7))
            + ((state4 & state5) ^ (~state4 & state6))) | 0)
            + ((state7 + ((KEY[i] + this.temp[i]) | 0)) | 0)) | 0;
        var t2 = (((state0 >>> 2 | state0 << 30) ^
            (state0 >>> 13 | state0 << 19) ^
            (state0 >>> 22 | state0 << 10)) + ((state0 & state1) ^ (state0 & state2) ^ (state1 & state2))) | 0;
        state7 = state6;
        state6 = state5;
        state5 = state4;
        state4 = (state3 + t1) | 0;
        state3 = state2;
        state2 = state1;
        state1 = state0;
        state0 = (t1 + t2) | 0;
    }
    state[0] += state0;
    state[1] += state1;
    state[2] += state2;
    state[3] += state3;
    state[4] += state4;
    state[5] += state5;
    state[6] += state6;
    state[7] += state7;
};


/***/ }),
/* 2708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(2709);
var util = __webpack_require__(2710);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(1070);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 2709 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(368)(module), __webpack_require__(97)))

/***/ }),
/* 2710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 2711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 2713 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var STS = __webpack_require__(340);

/**
 * Represents temporary credentials retrieved from {AWS.STS}. Without any
 * extra parameters, credentials will be fetched from the
 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
 * role instead.
 *
 * To setup temporary credentials, configure a set of master credentials
 * using the standard credentials providers (environment, EC2 instance metadata,
 * or from the filesystem), then set the global credentials to a new
 * temporary credentials object:
 *
 * ```javascript
 * // Note that environment credentials are loaded by default,
 * // the following line is shown for clarity:
 * AWS.config.credentials = new AWS.EnvironmentCredentials('AWS');
 *
 * // Now set temporary credentials seeded from the master credentials
 * AWS.config.credentials = new AWS.TemporaryCredentials();
 *
 * // subsequent requests will now use temporary credentials from AWS STS.
 * new AWS.S3().listBucket(function(err, data) { ... });
 * ```
 *
 * @!attribute masterCredentials
 *   @return [AWS.Credentials] the master (non-temporary) credentials used to
 *     get and refresh temporary credentials from AWS STS.
 * @note (see constructor)
 */
AWS.TemporaryCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * Creates a new temporary credentials object.
   *
   * @note In order to create temporary credentials, you first need to have
   *   "master" credentials configured in {AWS.Config.credentials}. These
   *   master credentials are necessary to retrieve the temporary credentials,
   *   as well as refresh the credentials when they expire.
   * @param params [map] a map of options that are passed to the
   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
   *   If a `RoleArn` parameter is passed in, credentials will be based on the
   *   IAM role.
   * @param masterCredentials [AWS.Credentials] the master (non-temporary) credentials
   *  used to get and refresh temporary credentials from AWS STS.
   * @example Creating a new credentials object for generic temporary credentials
   *   AWS.config.credentials = new AWS.TemporaryCredentials();
   * @example Creating a new credentials object for an IAM role
   *   AWS.config.credentials = new AWS.TemporaryCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials',
   *   });
   * @see AWS.STS.assumeRole
   * @see AWS.STS.getSessionToken
   */
  constructor: function TemporaryCredentials(params, masterCredentials) {
    AWS.Credentials.call(this);
    this.loadMasterCredentials(masterCredentials);
    this.expired = true;

    this.params = params || {};
    if (this.params.RoleArn) {
      this.params.RoleSessionName =
        this.params.RoleSessionName || 'temporary-credentials';
    }
  },

  /**
   * Refreshes credentials using {AWS.STS.assumeRole} or
   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
   * to the credentials {constructor}.
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */
  refresh: function refresh(callback) {
    var self = this;
    self.createClients();
    if (!callback) callback = function(err) { if (err) throw err; };

    self.masterCredentials.get(function() {
      self.service.config.credentials = self.masterCredentials;
      var operation = self.params.RoleArn ?
        self.service.assumeRole : self.service.getSessionToken;
      operation.call(self.service, function (err, data) {
        if (!err) {
          self.service.credentialsFrom(data, self);
        }
        callback(err);
      });
    });
  },

  /**
   * @api private
   */
  loadMasterCredentials: function loadMasterCredentials(masterCredentials) {
    this.masterCredentials = masterCredentials || AWS.config.credentials;
    while (this.masterCredentials.masterCredentials) {
      this.masterCredentials = this.masterCredentials.masterCredentials;
    }

    if (typeof this.masterCredentials.get !== 'function') {
      this.masterCredentials = new AWS.Credentials(this.masterCredentials);
    }
  },

  /**
   * @api private
   */
  createClients: function() {
    this.service = this.service || new STS({params: this.params});
  }

});


/***/ }),
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);

AWS.util.update(AWS.STS.prototype, {
  /**
   * @overload credentialsFrom(data, credentials = null)
   *   Creates a credentials object from STS response data containing
   *   credentials information. Useful for quickly setting AWS credentials.
   *
   *   @note This is a low-level utility function. If you want to load temporary
   *     credentials into your process for subsequent requests to AWS resources,
   *     you should use {AWS.TemporaryCredentials} instead.
   *   @param data [map] data retrieved from a call to {getFederatedToken},
   *     {getSessionToken}, {assumeRole}, or {assumeRoleWithWebIdentity}.
   *   @param credentials [AWS.Credentials] an optional credentials object to
   *     fill instead of creating a new object. Useful when modifying an
   *     existing credentials object from a refresh call.
   *   @return [AWS.TemporaryCredentials] the set of temporary credentials
   *     loaded from a raw STS operation response.
   *   @example Using credentialsFrom to load global AWS credentials
   *     var sts = new AWS.STS();
   *     sts.getSessionToken(function (err, data) {
   *       if (err) console.log("Error getting credentials");
   *       else {
   *         AWS.config.credentials = sts.credentialsFrom(data);
   *       }
   *     });
   *   @see AWS.TemporaryCredentials
   */
  credentialsFrom: function credentialsFrom(data, credentials) {
    if (!data) return null;
    if (!credentials) credentials = new AWS.TemporaryCredentials();
    credentials.expired = false;
    credentials.accessKeyId = data.Credentials.AccessKeyId;
    credentials.secretAccessKey = data.Credentials.SecretAccessKey;
    credentials.sessionToken = data.Credentials.SessionToken;
    credentials.expireTime = data.Credentials.Expiration;
    return credentials;
  },

  assumeRoleWithWebIdentity: function assumeRoleWithWebIdentity(params, callback) {
    return this.makeUnauthenticatedRequest('assumeRoleWithWebIdentity', params, callback);
  },

  assumeRoleWithSAML: function assumeRoleWithSAML(params, callback) {
    return this.makeUnauthenticatedRequest('assumeRoleWithSAML', params, callback);
  }
});


/***/ }),
/* 2715 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-06-15","endpointPrefix":"sts","globalEndpoint":"sts.amazonaws.com","protocol":"query","serviceAbbreviation":"AWS STS","serviceFullName":"AWS Security Token Service","serviceId":"STS","signatureVersion":"v4","uid":"sts-2011-06-15","xmlNamespace":"https://sts.amazonaws.com/doc/2011-06-15/"},"operations":{"AssumeRole":{"input":{"type":"structure","required":["RoleArn","RoleSessionName"],"members":{"RoleArn":{},"RoleSessionName":{},"Policy":{},"DurationSeconds":{"type":"integer"},"ExternalId":{},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"AssumeRoleResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"AssumedRoleUser":{"shape":"Sf"},"PackedPolicySize":{"type":"integer"}}}},"AssumeRoleWithSAML":{"input":{"type":"structure","required":["RoleArn","PrincipalArn","SAMLAssertion"],"members":{"RoleArn":{},"PrincipalArn":{},"SAMLAssertion":{},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithSAMLResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"AssumedRoleUser":{"shape":"Sf"},"PackedPolicySize":{"type":"integer"},"Subject":{},"SubjectType":{},"Issuer":{},"Audience":{},"NameQualifier":{}}}},"AssumeRoleWithWebIdentity":{"input":{"type":"structure","required":["RoleArn","RoleSessionName","WebIdentityToken"],"members":{"RoleArn":{},"RoleSessionName":{},"WebIdentityToken":{},"ProviderId":{},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithWebIdentityResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"SubjectFromWebIdentityToken":{},"AssumedRoleUser":{"shape":"Sf"},"PackedPolicySize":{"type":"integer"},"Provider":{},"Audience":{}}}},"DecodeAuthorizationMessage":{"input":{"type":"structure","required":["EncodedMessage"],"members":{"EncodedMessage":{}}},"output":{"resultWrapper":"DecodeAuthorizationMessageResult","type":"structure","members":{"DecodedMessage":{}}}},"GetCallerIdentity":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"GetCallerIdentityResult","type":"structure","members":{"UserId":{},"Account":{},"Arn":{}}}},"GetFederationToken":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"GetFederationTokenResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"FederatedUser":{"type":"structure","required":["FederatedUserId","Arn"],"members":{"FederatedUserId":{},"Arn":{}}},"PackedPolicySize":{"type":"integer"}}}},"GetSessionToken":{"input":{"type":"structure","members":{"DurationSeconds":{"type":"integer"},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"GetSessionTokenResult","type":"structure","members":{"Credentials":{"shape":"Sa"}}}}},"shapes":{"Sa":{"type":"structure","required":["AccessKeyId","SecretAccessKey","SessionToken","Expiration"],"members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}},"Sf":{"type":"structure","required":["AssumedRoleId","Arn"],"members":{"AssumedRoleId":{},"Arn":{}}}}}

/***/ }),
/* 2716 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 2717 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var STS = __webpack_require__(340);

/**
 * Represents credentials retrieved from STS Web Identity Federation support.
 *
 * By default this provider gets credentials using the
 * {AWS.STS.assumeRoleWithWebIdentity} service operation. This operation
 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
 * application for which credentials will be given. In addition, the
 * `WebIdentityToken` must be set to the token provided by the identity
 * provider. See {constructor} for an example on creating a credentials
 * object with proper `RoleArn` and `WebIdentityToken` values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the WebIdentityToken, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.WebIdentityToken = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
 *     `params.WebIdentityToken` property.
 * @!attribute data
 *   @return [map] the raw data response from the call to
 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
 *     access to other properties from the response.
 */
AWS.WebIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * Creates a new credentials object.
   * @param (see AWS.STS.assumeRoleWithWebIdentity)
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.WebIdentityCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/WebIdentity',
   *     WebIdentityToken: 'ABCDEFGHIJKLMNOP', // token from identity service
   *     RoleSessionName: 'web' // optional name, defaults to web-identity
   *   }, {
   *     // optionally provide configuration to apply to the underlying AWS.STS service client
   *     // if configuration is not provided, then configuration will be pulled from AWS.config
   *
   *     // specify timeout options
   *     httpOptions: {
   *       timeout: 100
   *     }
   *   });
   * @see AWS.STS.assumeRoleWithWebIdentity
   * @see AWS.Config
   */
  constructor: function WebIdentityCredentials(params, clientConfig) {
    AWS.Credentials.call(this);
    this.expired = true;
    this.params = params;
    this.params.RoleSessionName = this.params.RoleSessionName || 'web-identity';
    this.data = null;
    this._clientConfig = AWS.util.copy(clientConfig || {});
  },

  /**
   * Refreshes credentials using {AWS.STS.assumeRoleWithWebIdentity}
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */
  refresh: function refresh(callback) {
    var self = this;
    self.createClients();
    if (!callback) callback = function(err) { if (err) throw err; };

    self.service.assumeRoleWithWebIdentity(function (err, data) {
      self.data = null;
      if (!err) {
        self.data = data;
        self.service.credentialsFrom(data, self);
      }
      callback(err);
    });
  },

  /**
   * @api private
   */
  createClients: function() {
    if (!this.service) {
      var stsConfig = AWS.util.merge({}, this._clientConfig);
      stsConfig.params = this.params;
      this.service = new STS(stsConfig);
    }
  }

});


/***/ }),
/* 2718 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var CognitoIdentity = __webpack_require__(1071);
var STS = __webpack_require__(340);

/**
 * Represents credentials retrieved from STS Web Identity Federation using
 * the Amazon Cognito Identity service.
 *
 * By default this provider gets credentials using the
 * {AWS.CognitoIdentity.getCredentialsForIdentity} service operation, which
 * requires either an `IdentityId` or an `IdentityPoolId` (Amazon Cognito
 * Identity Pool ID), which is used to call {AWS.CognitoIdentity.getId} to
 * obtain an `IdentityId`. If the identity or identity pool is not configured in
 * the Amazon Cognito Console to use IAM roles with the appropriate permissions,
 * then additionally a `RoleArn` is required containing the ARN of the IAM trust
 * policy for the Amazon Cognito role that the user will log into. If a `RoleArn`
 * is provided, then this provider gets credentials using the
 * {AWS.STS.assumeRoleWithWebIdentity} service operation, after first getting an
 * Open ID token from {AWS.CognitoIdentity.getOpenIdToken}.
 *
 * In addition, if this credential provider is used to provide authenticated
 * login, the `Logins` map may be set to the tokens provided by the respective
 * identity providers. See {constructor} for an example on creating a credentials
 * object with proper property values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the WebIdentityToken, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.Logins['graph.facebook.com'] = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.CognitoIdentity.getId},
 *     {AWS.CognitoIdentity.getOpenIdToken}, and
 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
 *     `params.WebIdentityToken` property.
 * @!attribute data
 *   @return [map] the raw data response from the call to
 *     {AWS.CognitoIdentity.getCredentialsForIdentity}, or
 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
 *     access to other properties from the response.
 * @!attribute identityId
 *   @return [String] the Cognito ID returned by the last call to
 *     {AWS.CognitoIdentity.getOpenIdToken}. This ID represents the actual
 *     final resolved identity ID from Amazon Cognito.
 */
AWS.CognitoIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * @api private
   */
  localStorageKey: {
    id: 'aws.cognito.identity-id.',
    providers: 'aws.cognito.identity-providers.'
  },

  /**
   * Creates a new credentials object.
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.CognitoIdentityCredentials({
   *
   *     // either IdentityPoolId or IdentityId is required
   *     // See the IdentityPoolId param for AWS.CognitoIdentity.getID (linked below)
   *     // See the IdentityId param for AWS.CognitoIdentity.getCredentialsForIdentity
   *     // or AWS.CognitoIdentity.getOpenIdToken (linked below)
   *     IdentityPoolId: 'us-east-1:1699ebc0-7900-4099-b910-2df94f52a030',
   *     IdentityId: 'us-east-1:128d0a74-c82f-4553-916d-90053e4a8b0f'
   *
   *     // optional, only necessary when the identity pool is not configured
   *     // to use IAM roles in the Amazon Cognito Console
   *     // See the RoleArn param for AWS.STS.assumeRoleWithWebIdentity (linked below)
   *     RoleArn: 'arn:aws:iam::1234567890:role/MYAPP-CognitoIdentity',
   *
   *     // optional tokens, used for authenticated login
   *     // See the Logins param for AWS.CognitoIdentity.getID (linked below)
   *     Logins: {
   *       'graph.facebook.com': 'FBTOKEN',
   *       'www.amazon.com': 'AMAZONTOKEN',
   *       'accounts.google.com': 'GOOGLETOKEN',
   *       'api.twitter.com': 'TWITTERTOKEN',
   *       'www.digits.com': 'DIGITSTOKEN'
   *     },
   *
   *     // optional name, defaults to web-identity
   *     // See the RoleSessionName param for AWS.STS.assumeRoleWithWebIdentity (linked below)
   *     RoleSessionName: 'web',
   *
   *     // optional, only necessary when application runs in a browser
   *     // and multiple users are signed in at once, used for caching
   *     LoginId: 'example@gmail.com'
   *
   *   }, {
   *      // optionally provide configuration to apply to the underlying service clients
   *      // if configuration is not provided, then configuration will be pulled from AWS.config
   *
   *      // region should match the region your identity pool is located in
   *      region: 'us-east-1',
   *
   *      // specify timeout options
   *      httpOptions: {
   *        timeout: 100
   *      }
   *   });
   * @see AWS.CognitoIdentity.getId
   * @see AWS.CognitoIdentity.getCredentialsForIdentity
   * @see AWS.STS.assumeRoleWithWebIdentity
   * @see AWS.CognitoIdentity.getOpenIdToken
   * @see AWS.Config
   * @note If a region is not provided in the global AWS.config, or
   *   specified in the `clientConfig` to the CognitoIdentityCredentials
   *   constructor, you may encounter a 'Missing credentials in config' error
   *   when calling making a service call.
   */
  constructor: function CognitoIdentityCredentials(params, clientConfig) {
    AWS.Credentials.call(this);
    this.expired = true;
    this.params = params;
    this.data = null;
    this._identityId = null;
    this._clientConfig = AWS.util.copy(clientConfig || {});
    this.loadCachedId();
    var self = this;
    Object.defineProperty(this, 'identityId', {
      get: function() {
        self.loadCachedId();
        return self._identityId || self.params.IdentityId;
      },
      set: function(identityId) {
        self._identityId = identityId;
      }
    });
  },

  /**
   * Refreshes credentials using {AWS.CognitoIdentity.getCredentialsForIdentity},
   * or {AWS.STS.assumeRoleWithWebIdentity}.
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see AWS.Credentials.get
   */
  refresh: function refresh(callback) {
    var self = this;
    self.createClients();
    self.data = null;
    self._identityId = null;
    self.getId(function(err) {
      if (!err) {
        if (!self.params.RoleArn) {
          self.getCredentialsForIdentity(callback);
        } else {
          self.getCredentialsFromSTS(callback);
        }
      } else {
        self.clearIdOnNotAuthorized(err);
        callback(err);
      }
    });
  },

  /**
   * Clears the cached Cognito ID associated with the currently configured
   * identity pool ID. Use this to manually invalidate your cache if
   * the identity pool ID was deleted.
   */
  clearCachedId: function clearCache() {
    this._identityId = null;
    delete this.params.IdentityId;

    var poolId = this.params.IdentityPoolId;
    var loginId = this.params.LoginId || '';
    delete this.storage[this.localStorageKey.id + poolId + loginId];
    delete this.storage[this.localStorageKey.providers + poolId + loginId];
  },

  /**
   * @api private
   */
  clearIdOnNotAuthorized: function clearIdOnNotAuthorized(err) {
    var self = this;
    if (err.code == 'NotAuthorizedException') {
      self.clearCachedId();
    }
  },

  /**
   * Retrieves a Cognito ID, loading from cache if it was already retrieved
   * on this device.
   *
   * @callback callback function(err, identityId)
   *   @param err [Error, null] an error object if the call failed or null if
   *     it succeeded.
   *   @param identityId [String, null] if successful, the callback will return
   *     the Cognito ID.
   * @note If not loaded explicitly, the Cognito ID is loaded and stored in
   *   localStorage in the browser environment of a device.
   * @api private
   */
  getId: function getId(callback) {
    var self = this;
    if (typeof self.params.IdentityId === 'string') {
      return callback(null, self.params.IdentityId);
    }

    self.cognito.getId(function(err, data) {
      if (!err && data.IdentityId) {
        self.params.IdentityId = data.IdentityId;
        callback(null, data.IdentityId);
      } else {
        callback(err);
      }
    });
  },


  /**
   * @api private
   */
  loadCredentials: function loadCredentials(data, credentials) {
    if (!data || !credentials) return;
    credentials.expired = false;
    credentials.accessKeyId = data.Credentials.AccessKeyId;
    credentials.secretAccessKey = data.Credentials.SecretKey;
    credentials.sessionToken = data.Credentials.SessionToken;
    credentials.expireTime = data.Credentials.Expiration;
  },

  /**
   * @api private
   */
  getCredentialsForIdentity: function getCredentialsForIdentity(callback) {
    var self = this;
    self.cognito.getCredentialsForIdentity(function(err, data) {
      if (!err) {
        self.cacheId(data);
        self.data = data;
        self.loadCredentials(self.data, self);
      } else {
        self.clearIdOnNotAuthorized(err);
      }
      callback(err);
    });
  },

  /**
   * @api private
   */
  getCredentialsFromSTS: function getCredentialsFromSTS(callback) {
    var self = this;
    self.cognito.getOpenIdToken(function(err, data) {
      if (!err) {
        self.cacheId(data);
        self.params.WebIdentityToken = data.Token;
        self.webIdentityCredentials.refresh(function(webErr) {
          if (!webErr) {
            self.data = self.webIdentityCredentials.data;
            self.sts.credentialsFrom(self.data, self);
          }
          callback(webErr);
        });
      } else {
        self.clearIdOnNotAuthorized(err);
        callback(err);
      }
    });
  },

  /**
   * @api private
   */
  loadCachedId: function loadCachedId() {
    var self = this;

    // in the browser we source default IdentityId from localStorage
    if (AWS.util.isBrowser() && !self.params.IdentityId) {
      var id = self.getStorage('id');
      if (id && self.params.Logins) {
        var actualProviders = Object.keys(self.params.Logins);
        var cachedProviders =
          (self.getStorage('providers') || '').split(',');

        // only load ID if at least one provider used this ID before
        var intersect = cachedProviders.filter(function(n) {
          return actualProviders.indexOf(n) !== -1;
        });
        if (intersect.length !== 0) {
          self.params.IdentityId = id;
        }
      } else if (id) {
        self.params.IdentityId = id;
      }
    }
  },

  /**
   * @api private
   */
  createClients: function() {
    var clientConfig = this._clientConfig;
    this.webIdentityCredentials = this.webIdentityCredentials ||
      new AWS.WebIdentityCredentials(this.params, clientConfig);
    if (!this.cognito) {
      var cognitoConfig = AWS.util.merge({}, clientConfig);
      cognitoConfig.params = this.params;
      this.cognito = new CognitoIdentity(cognitoConfig);
    }
    this.sts = this.sts || new STS(clientConfig);
  },

  /**
   * @api private
   */
  cacheId: function cacheId(data) {
    this._identityId = data.IdentityId;
    this.params.IdentityId = this._identityId;

    // cache this IdentityId in browser localStorage if possible
    if (AWS.util.isBrowser()) {
      this.setStorage('id', data.IdentityId);

      if (this.params.Logins) {
        this.setStorage('providers', Object.keys(this.params.Logins).join(','));
      }
    }
  },

  /**
   * @api private
   */
  getStorage: function getStorage(key) {
    return this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')];
  },

  /**
   * @api private
   */
  setStorage: function setStorage(key, val) {
    try {
      this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')] = val;
    } catch (_) {}
  },

  /**
   * @api private
   */
  storage: (function() {
    try {
      var storage = AWS.util.isBrowser() && window.localStorage !== null && typeof window.localStorage === 'object' ?
          window.localStorage : {};

      // Test set/remove which would throw an error in Safari's private browsing
      storage['aws.test-storage'] = 'foobar';
      delete storage['aws.test-storage'];

      return storage;
    } catch (_) {
      return {};
    }
  })()
});


/***/ }),
/* 2719 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);

AWS.util.update(AWS.CognitoIdentity.prototype, {
  getOpenIdToken: function getOpenIdToken(params, callback) {
    return this.makeUnauthenticatedRequest('getOpenIdToken', params, callback);
  },

  getId: function getId(params, callback) {
    return this.makeUnauthenticatedRequest('getId', params, callback);
  },

  getCredentialsForIdentity: function getCredentialsForIdentity(params, callback) {
    return this.makeUnauthenticatedRequest('getCredentialsForIdentity', params, callback);
  }
});


/***/ }),
/* 2720 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-identity","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityService","uid":"cognito-identity-2014-06-30"},"operations":{"CreateIdentityPool":{"input":{"type":"structure","required":["IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"}}},"output":{"shape":"Sg"}},"DeleteIdentities":{"input":{"type":"structure","required":["IdentityIdsToDelete"],"members":{"IdentityIdsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"UnprocessedIdentityIds":{"type":"list","member":{"type":"structure","members":{"IdentityId":{},"ErrorCode":{}}}}}}},"DeleteIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}}},"DescribeIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{}}},"output":{"shape":"Sr"}},"DescribeIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"shape":"Sg"}},"GetCredentialsForIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sw"},"CustomRoleArn":{}}},"output":{"type":"structure","members":{"IdentityId":{},"Credentials":{"type":"structure","members":{"AccessKeyId":{},"SecretKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}}}}},"GetId":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"AccountId":{},"IdentityPoolId":{},"Logins":{"shape":"Sw"}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"GetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Roles":{"shape":"S18"},"RoleMappings":{"shape":"S1a"}}}},"GetOpenIdToken":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sw"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"GetOpenIdTokenForDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId","Logins"],"members":{"IdentityPoolId":{},"IdentityId":{},"Logins":{"shape":"Sw"},"TokenDuration":{"type":"long"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"ListIdentities":{"input":{"type":"structure","required":["IdentityPoolId","MaxResults"],"members":{"IdentityPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{},"HideDisabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Identities":{"type":"list","member":{"shape":"Sr"}},"NextToken":{}}}},"ListIdentityPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityPools":{"type":"list","member":{"type":"structure","members":{"IdentityPoolId":{},"IdentityPoolName":{}}}},"NextToken":{}}}},"LookupDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{},"IdentityId":{},"DeveloperUserIdentifier":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityId":{},"DeveloperUserIdentifierList":{"type":"list","member":{}},"NextToken":{}}}},"MergeDeveloperIdentities":{"input":{"type":"structure","required":["SourceUserIdentifier","DestinationUserIdentifier","DeveloperProviderName","IdentityPoolId"],"members":{"SourceUserIdentifier":{},"DestinationUserIdentifier":{},"DeveloperProviderName":{},"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"SetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId","Roles"],"members":{"IdentityPoolId":{},"Roles":{"shape":"S18"},"RoleMappings":{"shape":"S1a"}}}},"UnlinkDeveloperIdentity":{"input":{"type":"structure","required":["IdentityId","IdentityPoolId","DeveloperProviderName","DeveloperUserIdentifier"],"members":{"IdentityId":{},"IdentityPoolId":{},"DeveloperProviderName":{},"DeveloperUserIdentifier":{}}}},"UnlinkIdentity":{"input":{"type":"structure","required":["IdentityId","Logins","LoginsToRemove"],"members":{"IdentityId":{},"Logins":{"shape":"Sw"},"LoginsToRemove":{"shape":"Ss"}}}},"UpdateIdentityPool":{"input":{"shape":"Sg"},"output":{"shape":"Sg"}}},"shapes":{"S4":{"type":"map","key":{},"value":{}},"S8":{"type":"list","member":{}},"Sa":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ClientId":{},"ServerSideTokenCheck":{"type":"boolean"}}}},"Sf":{"type":"list","member":{}},"Sg":{"type":"structure","required":["IdentityPoolId","IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolId":{},"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"}}},"Sr":{"type":"structure","members":{"IdentityId":{},"Logins":{"shape":"Ss"},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"}}},"Ss":{"type":"list","member":{}},"Sw":{"type":"map","key":{},"value":{}},"S18":{"type":"map","key":{},"value":{}},"S1a":{"type":"map","key":{},"value":{"type":"structure","required":["Type"],"members":{"Type":{},"AmbiguousRoleResolution":{},"RulesConfiguration":{"type":"structure","required":["Rules"],"members":{"Rules":{"type":"list","member":{"type":"structure","required":["Claim","MatchType","Value","RoleARN"],"members":{"Claim":{},"MatchType":{},"Value":{},"RoleARN":{}}}}}}}}}}}

/***/ }),
/* 2721 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 2722 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var STS = __webpack_require__(340);

/**
 * Represents credentials retrieved from STS SAML support.
 *
 * By default this provider gets credentials using the
 * {AWS.STS.assumeRoleWithSAML} service operation. This operation
 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
 * application for which credentials will be given, as well as a `PrincipalArn`
 * representing the ARN for the SAML identity provider. In addition, the
 * `SAMLAssertion` must be set to the token provided by the identity
 * provider. See {constructor} for an example on creating a credentials
 * object with proper `RoleArn`, `PrincipalArn`, and `SAMLAssertion` values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the SAMLAssertion, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.SAMLAssertion = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.STS.assumeRoleWithSAML}. To update the token, set the
 *     `params.SAMLAssertion` property.
 */
AWS.SAMLCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * Creates a new credentials object.
   * @param (see AWS.STS.assumeRoleWithSAML)
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.SAMLCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/SAMLRole',
   *     PrincipalArn: 'arn:aws:iam::1234567890:role/SAMLPrincipal',
   *     SAMLAssertion: 'base64-token', // base64-encoded token from IdP
   *   });
   * @see AWS.STS.assumeRoleWithSAML
   */
  constructor: function SAMLCredentials(params) {
    AWS.Credentials.call(this);
    this.expired = true;
    this.params = params;
  },

  /**
   * Refreshes credentials using {AWS.STS.assumeRoleWithSAML}
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */
  refresh: function refresh(callback) {
    var self = this;
    self.createClients();
    if (!callback) callback = function(err) { if (err) throw err; };

    self.service.assumeRoleWithSAML(function (err, data) {
      if (!err) {
        self.service.credentialsFrom(data, self);
      }
      callback(err);
    });
  },

  /**
   * @api private
   */
  createClients: function() {
    this.service = this.service || new STS({params: this.params});
  }

});


/***/ }),
/* 2723 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(74);
var Shape = __webpack_require__(338);

function DomXmlParser() { }

DomXmlParser.prototype.parse = function(xml, shape) {
  if (xml.replace(/^\s+/, '') === '') return {};

  var result, error;
  try {
    if (window.DOMParser) {
      try {
        var parser = new DOMParser();
        result = parser.parseFromString(xml, 'text/xml');
      } catch (syntaxError) {
        throw util.error(new Error('Parse error in document'),
          {
            originalError: syntaxError,
            code: 'XMLParserError',
            retryable: true
          });
      }

      if (result.documentElement === null) {
        throw util.error(new Error('Cannot parse empty document.'),
          {
            code: 'XMLParserError',
            retryable: true
          });
      }

      var isError = result.getElementsByTagName('parsererror')[0];
      if (isError && (isError.parentNode === result ||
          isError.parentNode.nodeName === 'body' ||
          isError.parentNode.parentNode === result ||
          isError.parentNode.parentNode.nodeName === 'body')) {
        var errorElement = isError.getElementsByTagName('div')[0] || isError;
        throw util.error(new Error(errorElement.textContent || 'Parser error in document'),
          {
            code: 'XMLParserError',
            retryable: true
          });
      }
    } else if (window.ActiveXObject) {
      result = new window.ActiveXObject('Microsoft.XMLDOM');
      result.async = false;

      if (!result.loadXML(xml)) {
        throw util.error(new Error('Parse error in document'),
          {
            code: 'XMLParserError',
            retryable: true
          });
      }
    } else {
      throw new Error('Cannot load XML parser');
    }
  } catch (e) {
    error = e;
  }

  if (result && result.documentElement && !error) {
    var data = parseXml(result.documentElement, shape);
    var metadata = result.getElementsByTagName('ResponseMetadata')[0];
    if (metadata) {
      data.ResponseMetadata = parseXml(metadata, {});
    }
    return data;
  } else if (error) {
    throw util.error(error || new Error(), {code: 'XMLParserError', retryable: true});
  } else { // empty xml document
    return {};
  }
};

function parseXml(xml, shape) {
  if (!shape) shape = {};
  switch (shape.type) {
    case 'structure': return parseStructure(xml, shape);
    case 'map': return parseMap(xml, shape);
    case 'list': return parseList(xml, shape);
    case undefined: case null: return parseUnknown(xml);
    default: return parseScalar(xml, shape);
  }
}

function parseStructure(xml, shape) {
  var data = {};
  if (xml === null) return data;

  util.each(shape.members, function(memberName, memberShape) {
    if (memberShape.isXmlAttribute) {
      if (Object.prototype.hasOwnProperty.call(xml.attributes, memberShape.name)) {
        var value = xml.attributes[memberShape.name].value;
        data[memberName] = parseXml({textContent: value}, memberShape);
      }
    } else {
      var xmlChild = memberShape.flattened ? xml :
        xml.getElementsByTagName(memberShape.name)[0];
      if (xmlChild) {
        data[memberName] = parseXml(xmlChild, memberShape);
      } else if (!memberShape.flattened && memberShape.type === 'list') {
        data[memberName] = memberShape.defaultValue;
      }
    }
  });

  return data;
}

function parseMap(xml, shape) {
  var data = {};
  var xmlKey = shape.key.name || 'key';
  var xmlValue = shape.value.name || 'value';
  var tagName = shape.flattened ? shape.name : 'entry';

  var child = xml.firstElementChild;
  while (child) {
    if (child.nodeName === tagName) {
      var key = child.getElementsByTagName(xmlKey)[0].textContent;
      var value = child.getElementsByTagName(xmlValue)[0];
      data[key] = parseXml(value, shape.value);
    }
    child = child.nextElementSibling;
  }
  return data;
}

function parseList(xml, shape) {
  var data = [];
  var tagName = shape.flattened ? shape.name : (shape.member.name || 'member');

  var child = xml.firstElementChild;
  while (child) {
    if (child.nodeName === tagName) {
      data.push(parseXml(child, shape.member));
    }
    child = child.nextElementSibling;
  }
  return data;
}

function parseScalar(xml, shape) {
  if (xml.getAttribute) {
    var encoding = xml.getAttribute('encoding');
    if (encoding === 'base64') {
      shape = new Shape.create({type: encoding});
    }
  }

  var text = xml.textContent;
  if (text === '') text = null;
  if (typeof shape.toType === 'function') {
    return shape.toType(text);
  } else {
    return text;
  }
}

function parseUnknown(xml) {
  if (xml === undefined || xml === null) return '';

  // empty object
  if (!xml.firstElementChild) {
    if (xml.parentNode.parentNode === null) return {};
    if (xml.childNodes.length === 0) return '';
    else return xml.textContent;
  }

  // object, parse as structure
  var shape = {type: 'structure', members: {}};
  var child = xml.firstElementChild;
  while (child) {
    var tag = child.nodeName;
    if (Object.prototype.hasOwnProperty.call(shape.members, tag)) {
      // multiple tags of the same name makes it a list
      shape.members[tag].type = 'list';
    } else {
      shape.members[tag] = {name: tag};
    }
    child = child.nextElementSibling;
  }
  return parseStructure(xml, shape);
}

module.exports = DomXmlParser;


/***/ }),
/* 2724 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var EventEmitter = __webpack_require__(2725).EventEmitter;
__webpack_require__(1064);

/**
 * @api private
 */
AWS.XHRClient = AWS.util.inherit({
  handleRequest: function handleRequest(httpRequest, httpOptions, callback, errCallback) {
    var self = this;
    var endpoint = httpRequest.endpoint;
    var emitter = new EventEmitter();
    var href = endpoint.protocol + '//' + endpoint.hostname;
    if (endpoint.port !== 80 && endpoint.port !== 443) {
      href += ':' + endpoint.port;
    }
    href += httpRequest.path;

    var xhr = new XMLHttpRequest(), headersEmitted = false;
    httpRequest.stream = xhr;

    xhr.addEventListener('readystatechange', function() {
      try {
        if (xhr.status === 0) return; // 0 code is invalid
      } catch (e) { return; }

      if (this.readyState >= this.HEADERS_RECEIVED && !headersEmitted) {
        emitter.statusCode = xhr.status;
        emitter.headers = self.parseHeaders(xhr.getAllResponseHeaders());
        emitter.emit(
          'headers',
          emitter.statusCode,
          emitter.headers,
          xhr.statusText
        );
        headersEmitted = true;
      }
      if (this.readyState === this.DONE) {
        self.finishRequest(xhr, emitter);
      }
    }, false);
    xhr.upload.addEventListener('progress', function (evt) {
      emitter.emit('sendProgress', evt);
    });
    xhr.addEventListener('progress', function (evt) {
      emitter.emit('receiveProgress', evt);
    }, false);
    xhr.addEventListener('timeout', function () {
      errCallback(AWS.util.error(new Error('Timeout'), {code: 'TimeoutError'}));
    }, false);
    xhr.addEventListener('error', function () {
      errCallback(AWS.util.error(new Error('Network Failure'), {
        code: 'NetworkingError'
      }));
    }, false);
    xhr.addEventListener('abort', function () {
      errCallback(AWS.util.error(new Error('Request aborted'), {
        code: 'RequestAbortedError'
      }));
    }, false);

    callback(emitter);
    xhr.open(httpRequest.method, href, httpOptions.xhrAsync !== false);
    AWS.util.each(httpRequest.headers, function (key, value) {
      if (key !== 'Content-Length' && key !== 'User-Agent' && key !== 'Host') {
        xhr.setRequestHeader(key, value);
      }
    });

    if (httpOptions.timeout && httpOptions.xhrAsync !== false) {
      xhr.timeout = httpOptions.timeout;
    }

    if (httpOptions.xhrWithCredentials) {
      xhr.withCredentials = true;
    }
    try { xhr.responseType = 'arraybuffer'; } catch (e) {}

    try {
      if (httpRequest.body) {
        xhr.send(httpRequest.body);
      } else {
        xhr.send();
      }
    } catch (err) {
      if (httpRequest.body && typeof httpRequest.body.buffer === 'object') {
        xhr.send(httpRequest.body.buffer); // send ArrayBuffer directly
      } else {
        throw err;
      }
    }

    return emitter;
  },

  parseHeaders: function parseHeaders(rawHeaders) {
    var headers = {};
    AWS.util.arrayEach(rawHeaders.split(/\r?\n/), function (line) {
      var key = line.split(':', 1)[0];
      var value = line.substring(key.length + 2);
      if (key.length > 0) headers[key.toLowerCase()] = value;
    });
    return headers;
  },

  finishRequest: function finishRequest(xhr, emitter) {
    var buffer;
    if (xhr.responseType === 'arraybuffer' && xhr.response) {
      var ab = xhr.response;
      buffer = new AWS.util.Buffer(ab.byteLength);
      var view = new Uint8Array(ab);
      for (var i = 0; i < buffer.length; ++i) {
        buffer[i] = view[i];
      }
    }

    try {
      if (!buffer && typeof xhr.responseText === 'string') {
        buffer = new AWS.util.Buffer(xhr.responseText);
      }
    } catch (e) {}

    if (buffer) emitter.emit('data', buffer);
    emitter.emit('end');
  }
});

/**
 * @api private
 */
AWS.HttpClient.prototype = AWS.XHRClient.prototype;

/**
 * @api private
 */
AWS.HttpClient.streamsApiVersion = 1;


/***/ }),
/* 2725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),
/* 2726 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
module.exports = {
  ACM: __webpack_require__(2727),
  APIGateway: __webpack_require__(2730),
  ApplicationAutoScaling: __webpack_require__(2734),
  AutoScaling: __webpack_require__(2737),
  CloudFormation: __webpack_require__(2740),
  CloudFront: __webpack_require__(2744),
  CloudHSM: __webpack_require__(2753),
  CloudTrail: __webpack_require__(2756),
  CloudWatch: __webpack_require__(2759),
  CloudWatchEvents: __webpack_require__(2763),
  CloudWatchLogs: __webpack_require__(2766),
  CodeCommit: __webpack_require__(2769),
  CodeDeploy: __webpack_require__(2772),
  CodePipeline: __webpack_require__(2776),
  CognitoIdentity: __webpack_require__(1071),
  CognitoIdentityServiceProvider: __webpack_require__(2779),
  CognitoSync: __webpack_require__(2782),
  ConfigService: __webpack_require__(2784),
  CUR: __webpack_require__(2787),
  DeviceFarm: __webpack_require__(2790),
  DirectConnect: __webpack_require__(2793),
  DynamoDB: __webpack_require__(2796),
  DynamoDBStreams: __webpack_require__(2808),
  EC2: __webpack_require__(2811),
  ECR: __webpack_require__(2816),
  ECS: __webpack_require__(2819),
  EFS: __webpack_require__(2823),
  ElastiCache: __webpack_require__(2826),
  ElasticBeanstalk: __webpack_require__(2830),
  ELB: __webpack_require__(2833),
  ELBv2: __webpack_require__(2837),
  EMR: __webpack_require__(2841),
  ElasticTranscoder: __webpack_require__(2845),
  Firehose: __webpack_require__(2849),
  GameLift: __webpack_require__(2852),
  Inspector: __webpack_require__(2855),
  Iot: __webpack_require__(2858),
  IotData: __webpack_require__(2861),
  Kinesis: __webpack_require__(2864),
  KMS: __webpack_require__(2868),
  Lambda: __webpack_require__(2871),
  LexRuntime: __webpack_require__(2877),
  MachineLearning: __webpack_require__(2880),
  MarketplaceCommerceAnalytics: __webpack_require__(2885),
  MTurk: __webpack_require__(2888),
  MobileAnalytics: __webpack_require__(2891),
  OpsWorks: __webpack_require__(2893),
  Polly: __webpack_require__(2897),
  RDS: __webpack_require__(2902),
  Redshift: __webpack_require__(2917),
  Rekognition: __webpack_require__(2921),
  Route53: __webpack_require__(2924),
  Route53Domains: __webpack_require__(2929),
  S3: __webpack_require__(2932),
  ServiceCatalog: __webpack_require__(2938),
  SES: __webpack_require__(2941),
  SNS: __webpack_require__(2945),
  SQS: __webpack_require__(2948),
  SSM: __webpack_require__(2952),
  StorageGateway: __webpack_require__(2955),
  STS: __webpack_require__(340),
  WAF: __webpack_require__(2958),
  WorkDocs: __webpack_require__(2961),
  LexModelBuildingService: __webpack_require__(2964)
};

/***/ }),
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['acm'] = {};
AWS.ACM = Service.defineService('acm', ['2015-12-08']);
Object.defineProperty(apiLoader.services['acm'], '2015-12-08', {
  get: function get() {
    var model = __webpack_require__(2728);
    model.paginators = __webpack_require__(2729).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ACM;


/***/ }),
/* 2728 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-12-08","endpointPrefix":"acm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"ACM","serviceFullName":"AWS Certificate Manager","signatureVersion":"v4","targetPrefix":"CertificateManager","uid":"acm-2015-12-08"},"operations":{"AddTagsToCertificate":{"input":{"type":"structure","required":["CertificateArn","Tags"],"members":{"CertificateArn":{},"Tags":{"shape":"S3"}}}},"DeleteCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}}},"DescribeCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Certificate":{"type":"structure","members":{"CertificateArn":{},"DomainName":{},"SubjectAlternativeNames":{"shape":"Sc"},"DomainValidationOptions":{"shape":"Sd"},"Serial":{},"Subject":{},"Issuer":{},"CreatedAt":{"type":"timestamp"},"IssuedAt":{"type":"timestamp"},"ImportedAt":{"type":"timestamp"},"Status":{},"RevokedAt":{"type":"timestamp"},"RevocationReason":{},"NotBefore":{"type":"timestamp"},"NotAfter":{"type":"timestamp"},"KeyAlgorithm":{},"SignatureAlgorithm":{},"InUseBy":{"type":"list","member":{}},"FailureReason":{},"Type":{},"RenewalSummary":{"type":"structure","required":["RenewalStatus","DomainValidationOptions"],"members":{"RenewalStatus":{},"DomainValidationOptions":{"shape":"Sd"}}},"KeyUsages":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"ExtendedKeyUsages":{"type":"list","member":{"type":"structure","members":{"Name":{},"OID":{}}}}}}}}},"GetCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Certificate":{},"CertificateChain":{}}}},"ImportCertificate":{"input":{"type":"structure","required":["Certificate","PrivateKey"],"members":{"CertificateArn":{},"Certificate":{"type":"blob"},"PrivateKey":{"type":"blob","sensitive":true},"CertificateChain":{"type":"blob"}}},"output":{"type":"structure","members":{"CertificateArn":{}}}},"ListCertificates":{"input":{"type":"structure","members":{"CertificateStatuses":{"type":"list","member":{}},"Includes":{"type":"structure","members":{"extendedKeyUsage":{"type":"list","member":{}},"keyUsage":{"type":"list","member":{}},"keyTypes":{"type":"list","member":{}}}},"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"CertificateSummaryList":{"type":"list","member":{"type":"structure","members":{"CertificateArn":{},"DomainName":{}}}}}}},"ListTagsForCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S3"}}}},"RemoveTagsFromCertificate":{"input":{"type":"structure","required":["CertificateArn","Tags"],"members":{"CertificateArn":{},"Tags":{"shape":"S3"}}}},"RequestCertificate":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"ValidationMethod":{},"SubjectAlternativeNames":{"shape":"Sc"},"IdempotencyToken":{},"DomainValidationOptions":{"type":"list","member":{"type":"structure","required":["DomainName","ValidationDomain"],"members":{"DomainName":{},"ValidationDomain":{}}}}}},"output":{"type":"structure","members":{"CertificateArn":{}}}},"ResendValidationEmail":{"input":{"type":"structure","required":["CertificateArn","Domain","ValidationDomain"],"members":{"CertificateArn":{},"Domain":{},"ValidationDomain":{}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sc":{"type":"list","member":{}},"Sd":{"type":"list","member":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"ValidationEmails":{"type":"list","member":{}},"ValidationDomain":{},"ValidationStatus":{},"ResourceRecord":{"type":"structure","required":["Name","Type","Value"],"members":{"Name":{},"Type":{},"Value":{}}},"ValidationMethod":{}}}}}}

/***/ }),
/* 2729 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCertificates":{"input_token":"NextToken","limit_key":"MaxItems","output_token":"NextToken","result_key":"CertificateSummaryList"}}}

/***/ }),
/* 2730 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['apigateway'] = {};
AWS.APIGateway = Service.defineService('apigateway', ['2015-07-09']);
__webpack_require__(2731);
Object.defineProperty(apiLoader.services['apigateway'], '2015-07-09', {
  get: function get() {
    var model = __webpack_require__(2732);
    model.paginators = __webpack_require__(2733).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.APIGateway;


/***/ }),
/* 2731 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);

AWS.util.update(AWS.APIGateway.prototype, {
/**
 * Sets the Accept header to application/json.
 *
 * @api private
 */
  setAcceptHeader: function setAcceptHeader(req) {
    var httpRequest = req.httpRequest;
    if (!httpRequest.headers.Accept) {
      httpRequest.headers['Accept'] = 'application/json';
    }
  },

  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    request.addListener('build', this.setAcceptHeader);
    if (request.operation === 'getExport') {
      var params = request.params || {};
      if (params.exportType === 'swagger') {
        request.addListener('extractData', AWS.util.convertPayloadToString);
      }
    }
  }
});



/***/ }),
/* 2732 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-07-09","endpointPrefix":"apigateway","protocol":"rest-json","serviceFullName":"Amazon API Gateway","serviceId":"API Gateway","signatureVersion":"v4","uid":"apigateway-2015-07-09"},"operations":{"CreateApiKey":{"http":{"requestUri":"/apikeys","responseCode":201},"input":{"type":"structure","members":{"name":{},"description":{},"enabled":{"type":"boolean"},"generateDistinctId":{"type":"boolean"},"value":{},"stageKeys":{"type":"list","member":{"type":"structure","members":{"restApiId":{},"stageName":{}}}},"customerId":{}}},"output":{"shape":"S6"}},"CreateAuthorizer":{"http":{"requestUri":"/restapis/{restapi_id}/authorizers","responseCode":201},"input":{"type":"structure","required":["restApiId","name","type"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"name":{},"type":{},"providerARNs":{"shape":"Sb"},"authType":{},"authorizerUri":{},"authorizerCredentials":{},"identitySource":{},"identityValidationExpression":{},"authorizerResultTtlInSeconds":{"type":"integer"}}},"output":{"shape":"Se"}},"CreateBasePathMapping":{"http":{"requestUri":"/domainnames/{domain_name}/basepathmappings","responseCode":201},"input":{"type":"structure","required":["domainName","restApiId"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{},"restApiId":{},"stage":{}}},"output":{"shape":"Sg"}},"CreateDeployment":{"http":{"requestUri":"/restapis/{restapi_id}/deployments","responseCode":201},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{},"stageDescription":{},"description":{},"cacheClusterEnabled":{"type":"boolean"},"cacheClusterSize":{},"variables":{"shape":"Sk"},"canarySettings":{"type":"structure","members":{"percentTraffic":{"type":"double"},"stageVariableOverrides":{"shape":"Sk"},"useStageCache":{"type":"boolean"}}}}},"output":{"shape":"Sn"}},"CreateDocumentationPart":{"http":{"requestUri":"/restapis/{restapi_id}/documentation/parts","responseCode":201},"input":{"type":"structure","required":["restApiId","location","properties"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"location":{"shape":"Ss"},"properties":{}}},"output":{"shape":"Sv"}},"CreateDocumentationVersion":{"http":{"requestUri":"/restapis/{restapi_id}/documentation/versions","responseCode":201},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{},"stageName":{},"description":{}}},"output":{"shape":"Sx"}},"CreateDomainName":{"http":{"requestUri":"/domainnames","responseCode":201},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{},"certificateName":{},"certificateBody":{},"certificatePrivateKey":{},"certificateChain":{},"certificateArn":{},"regionalCertificateName":{},"regionalCertificateArn":{},"endpointConfiguration":{"shape":"Sz"}}},"output":{"shape":"S12"}},"CreateModel":{"http":{"requestUri":"/restapis/{restapi_id}/models","responseCode":201},"input":{"type":"structure","required":["restApiId","name","contentType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"name":{},"description":{},"schema":{},"contentType":{}}},"output":{"shape":"S14"}},"CreateRequestValidator":{"http":{"requestUri":"/restapis/{restapi_id}/requestvalidators","responseCode":201},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"name":{},"validateRequestBody":{"type":"boolean"},"validateRequestParameters":{"type":"boolean"}}},"output":{"shape":"S16"}},"CreateResource":{"http":{"requestUri":"/restapis/{restapi_id}/resources/{parent_id}","responseCode":201},"input":{"type":"structure","required":["restApiId","parentId","pathPart"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"parentId":{"location":"uri","locationName":"parent_id"},"pathPart":{}}},"output":{"shape":"S18"}},"CreateRestApi":{"http":{"requestUri":"/restapis","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"version":{},"cloneFrom":{},"binaryMediaTypes":{"shape":"S8"},"minimumCompressionSize":{"type":"integer"},"apiKeySource":{},"endpointConfiguration":{"shape":"Sz"}}},"output":{"shape":"S1o"}},"CreateStage":{"http":{"requestUri":"/restapis/{restapi_id}/stages","responseCode":201},"input":{"type":"structure","required":["restApiId","stageName","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{},"deploymentId":{},"description":{},"cacheClusterEnabled":{"type":"boolean"},"cacheClusterSize":{},"variables":{"shape":"Sk"},"documentationVersion":{},"canarySettings":{"shape":"S1q"},"tags":{"shape":"Sk"}}},"output":{"shape":"S1r"}},"CreateUsagePlan":{"http":{"requestUri":"/usageplans","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"apiStages":{"shape":"S1y"},"throttle":{"shape":"S20"},"quota":{"shape":"S21"}}},"output":{"shape":"S23"}},"CreateUsagePlanKey":{"http":{"requestUri":"/usageplans/{usageplanId}/keys","responseCode":201},"input":{"type":"structure","required":["usagePlanId","keyId","keyType"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{},"keyType":{}}},"output":{"shape":"S25"}},"CreateVpcLink":{"http":{"requestUri":"/vpclinks","responseCode":202},"input":{"type":"structure","required":["name","targetArns"],"members":{"name":{},"description":{},"targetArns":{"shape":"S8"}}},"output":{"shape":"S27"}},"DeleteApiKey":{"http":{"method":"DELETE","requestUri":"/apikeys/{api_Key}","responseCode":202},"input":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"location":"uri","locationName":"api_Key"}}}},"DeleteAuthorizer":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"}}}},"DeleteBasePathMapping":{"http":{"method":"DELETE","requestUri":"/domainnames/{domain_name}/basepathmappings/{base_path}","responseCode":202},"input":{"type":"structure","required":["domainName","basePath"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{"location":"uri","locationName":"base_path"}}}},"DeleteClientCertificate":{"http":{"method":"DELETE","requestUri":"/clientcertificates/{clientcertificate_id}","responseCode":202},"input":{"type":"structure","required":["clientCertificateId"],"members":{"clientCertificateId":{"location":"uri","locationName":"clientcertificate_id"}}}},"DeleteDeployment":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/deployments/{deployment_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"uri","locationName":"deployment_id"}}}},"DeleteDocumentationPart":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/documentation/parts/{part_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","documentationPartId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationPartId":{"location":"uri","locationName":"part_id"}}}},"DeleteDocumentationVersion":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/documentation/versions/{doc_version}","responseCode":202},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{"location":"uri","locationName":"doc_version"}}}},"DeleteDomainName":{"http":{"method":"DELETE","requestUri":"/domainnames/{domain_name}","responseCode":202},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"}}}},"DeleteGatewayResponse":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}","responseCode":202},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"}}}},"DeleteIntegration":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}}},"DeleteIntegrationResponse":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}}},"DeleteMethod":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}}},"DeleteMethodResponse":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}}},"DeleteModel":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/models/{model_name}","responseCode":202},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"}}}},"DeleteRequestValidator":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","requestValidatorId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"requestValidatorId":{"location":"uri","locationName":"requestvalidator_id"}}}},"DeleteResource":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","resourceId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"}}}},"DeleteRestApi":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}","responseCode":202},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"}}}},"DeleteStage":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/stages/{stage_name}","responseCode":202},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}}},"DeleteUsagePlan":{"http":{"method":"DELETE","requestUri":"/usageplans/{usageplanId}","responseCode":202},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"}}}},"DeleteUsagePlanKey":{"http":{"method":"DELETE","requestUri":"/usageplans/{usageplanId}/keys/{keyId}","responseCode":202},"input":{"type":"structure","required":["usagePlanId","keyId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"uri","locationName":"keyId"}}}},"DeleteVpcLink":{"http":{"method":"DELETE","requestUri":"/vpclinks/{vpclink_id}","responseCode":202},"input":{"type":"structure","required":["vpcLinkId"],"members":{"vpcLinkId":{"location":"uri","locationName":"vpclink_id"}}}},"FlushStageAuthorizersCache":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/cache/authorizers","responseCode":202},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}}},"FlushStageCache":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/cache/data","responseCode":202},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}}},"GenerateClientCertificate":{"http":{"requestUri":"/clientcertificates","responseCode":201},"input":{"type":"structure","members":{"description":{}}},"output":{"shape":"S2y"}},"GetAccount":{"http":{"method":"GET","requestUri":"/account"},"input":{"type":"structure","members":{}},"output":{"shape":"S30"}},"GetApiKey":{"http":{"method":"GET","requestUri":"/apikeys/{api_Key}"},"input":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"location":"uri","locationName":"api_Key"},"includeValue":{"location":"querystring","locationName":"includeValue","type":"boolean"}}},"output":{"shape":"S6"}},"GetApiKeys":{"http":{"method":"GET","requestUri":"/apikeys"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"nameQuery":{"location":"querystring","locationName":"name"},"customerId":{"location":"querystring","locationName":"customerId"},"includeValues":{"location":"querystring","locationName":"includeValues","type":"boolean"}}},"output":{"type":"structure","members":{"warnings":{"shape":"S8"},"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S6"}}}}},"GetAuthorizer":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}"},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"}}},"output":{"shape":"Se"}},"GetAuthorizers":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/authorizers"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Se"}}}}},"GetBasePathMapping":{"http":{"method":"GET","requestUri":"/domainnames/{domain_name}/basepathmappings/{base_path}"},"input":{"type":"structure","required":["domainName","basePath"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{"location":"uri","locationName":"base_path"}}},"output":{"shape":"Sg"}},"GetBasePathMappings":{"http":{"method":"GET","requestUri":"/domainnames/{domain_name}/basepathmappings"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sg"}}}}},"GetClientCertificate":{"http":{"method":"GET","requestUri":"/clientcertificates/{clientcertificate_id}"},"input":{"type":"structure","required":["clientCertificateId"],"members":{"clientCertificateId":{"location":"uri","locationName":"clientcertificate_id"}}},"output":{"shape":"S2y"}},"GetClientCertificates":{"http":{"method":"GET","requestUri":"/clientcertificates"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S2y"}}}}},"GetDeployment":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/deployments/{deployment_id}"},"input":{"type":"structure","required":["restApiId","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"uri","locationName":"deployment_id"},"embed":{"shape":"S8","location":"querystring","locationName":"embed"}}},"output":{"shape":"Sn"}},"GetDeployments":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/deployments"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sn"}}}}},"GetDocumentationPart":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/parts/{part_id}"},"input":{"type":"structure","required":["restApiId","documentationPartId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationPartId":{"location":"uri","locationName":"part_id"}}},"output":{"shape":"Sv"}},"GetDocumentationParts":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/parts"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"type":{"location":"querystring","locationName":"type"},"nameQuery":{"location":"querystring","locationName":"name"},"path":{"location":"querystring","locationName":"path"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"locationStatus":{"location":"querystring","locationName":"locationStatus"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sv"}}}}},"GetDocumentationVersion":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/versions/{doc_version}"},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{"location":"uri","locationName":"doc_version"}}},"output":{"shape":"Sx"}},"GetDocumentationVersions":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/versions"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sx"}}}}},"GetDomainName":{"http":{"method":"GET","requestUri":"/domainnames/{domain_name}"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"}}},"output":{"shape":"S12"}},"GetDomainNames":{"http":{"method":"GET","requestUri":"/domainnames"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S12"}}}}},"GetExport":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/exports/{export_type}","responseCode":200},"input":{"type":"structure","required":["restApiId","stageName","exportType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"},"exportType":{"location":"uri","locationName":"export_type"},"parameters":{"shape":"Sk","location":"querystring"},"accepts":{"location":"header","locationName":"Accept"}}},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"contentDisposition":{"location":"header","locationName":"Content-Disposition"},"body":{"type":"blob"}},"payload":"body"}},"GetGatewayResponse":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}"},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"}}},"output":{"shape":"S42"}},"GetGatewayResponses":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/gatewayresponses"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S42"}}}}},"GetIntegration":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}},"output":{"shape":"S1f"}},"GetIntegrationResponse":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}},"output":{"shape":"S1l"}},"GetMethod":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}},"output":{"shape":"S1a"}},"GetMethodResponse":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}},"output":{"shape":"S1d"}},"GetModel":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/models/{model_name}"},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"},"flatten":{"location":"querystring","locationName":"flatten","type":"boolean"}}},"output":{"shape":"S14"}},"GetModelTemplate":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/models/{model_name}/default_template"},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"}}},"output":{"type":"structure","members":{"value":{}}}},"GetModels":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/models"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S14"}}}}},"GetRequestValidator":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"},"input":{"type":"structure","required":["restApiId","requestValidatorId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"requestValidatorId":{"location":"uri","locationName":"requestvalidator_id"}}},"output":{"shape":"S16"}},"GetRequestValidators":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/requestvalidators"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S16"}}}}},"GetResource":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}"},"input":{"type":"structure","required":["restApiId","resourceId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"embed":{"shape":"S8","location":"querystring","locationName":"embed"}}},"output":{"shape":"S18"}},"GetResources":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"embed":{"shape":"S8","location":"querystring","locationName":"embed"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S18"}}}}},"GetRestApi":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"}}},"output":{"shape":"S1o"}},"GetRestApis":{"http":{"method":"GET","requestUri":"/restapis"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S1o"}}}}},"GetSdk":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/sdks/{sdk_type}","responseCode":200},"input":{"type":"structure","required":["restApiId","stageName","sdkType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"},"sdkType":{"location":"uri","locationName":"sdk_type"},"parameters":{"shape":"Sk","location":"querystring"}}},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"contentDisposition":{"location":"header","locationName":"Content-Disposition"},"body":{"type":"blob"}},"payload":"body"}},"GetSdkType":{"http":{"method":"GET","requestUri":"/sdktypes/{sdktype_id}"},"input":{"type":"structure","required":["id"],"members":{"id":{"location":"uri","locationName":"sdktype_id"}}},"output":{"shape":"S4v"}},"GetSdkTypes":{"http":{"method":"GET","requestUri":"/sdktypes"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S4v"}}}}},"GetStage":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages/{stage_name}"},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}},"output":{"shape":"S1r"}},"GetStages":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"querystring","locationName":"deploymentId"}}},"output":{"type":"structure","members":{"item":{"type":"list","member":{"shape":"S1r"}}}}},"GetTags":{"http":{"method":"GET","requestUri":"/tags/{resource_arn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resource_arn"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sk"}}}},"GetUsage":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}/usage"},"input":{"type":"structure","required":["usagePlanId","startDate","endDate"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"querystring","locationName":"keyId"},"startDate":{"location":"querystring","locationName":"startDate"},"endDate":{"location":"querystring","locationName":"endDate"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"shape":"S58"}},"GetUsagePlan":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}"},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"}}},"output":{"shape":"S23"}},"GetUsagePlanKey":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}/keys/{keyId}","responseCode":200},"input":{"type":"structure","required":["usagePlanId","keyId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"uri","locationName":"keyId"}}},"output":{"shape":"S25"}},"GetUsagePlanKeys":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}/keys"},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"nameQuery":{"location":"querystring","locationName":"name"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S25"}}}}},"GetUsagePlans":{"http":{"method":"GET","requestUri":"/usageplans"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"keyId":{"location":"querystring","locationName":"keyId"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S23"}}}}},"GetVpcLink":{"http":{"method":"GET","requestUri":"/vpclinks/{vpclink_id}"},"input":{"type":"structure","required":["vpcLinkId"],"members":{"vpcLinkId":{"location":"uri","locationName":"vpclink_id"}}},"output":{"shape":"S27"}},"GetVpcLinks":{"http":{"method":"GET","requestUri":"/vpclinks"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S27"}}}}},"ImportApiKeys":{"http":{"requestUri":"/apikeys?mode=import","responseCode":201},"input":{"type":"structure","required":["body","format"],"members":{"body":{"type":"blob"},"format":{"location":"querystring","locationName":"format"},"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"}},"payload":"body"},"output":{"type":"structure","members":{"ids":{"shape":"S8"},"warnings":{"shape":"S8"}}}},"ImportDocumentationParts":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/documentation/parts"},"input":{"type":"structure","required":["restApiId","body"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"mode":{"location":"querystring","locationName":"mode"},"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"},"body":{"type":"blob"}},"payload":"body"},"output":{"type":"structure","members":{"ids":{"shape":"S8"},"warnings":{"shape":"S8"}}}},"ImportRestApi":{"http":{"requestUri":"/restapis?mode=import","responseCode":201},"input":{"type":"structure","required":["body"],"members":{"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"},"parameters":{"shape":"Sk","location":"querystring"},"body":{"type":"blob"}},"payload":"body"},"output":{"shape":"S1o"}},"PutGatewayResponse":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}","responseCode":201},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"},"statusCode":{},"responseParameters":{"shape":"Sk"},"responseTemplates":{"shape":"Sk"}}},"output":{"shape":"S42"}},"PutIntegration":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","type"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"type":{},"integrationHttpMethod":{"locationName":"httpMethod"},"uri":{},"connectionType":{},"connectionId":{},"credentials":{},"requestParameters":{"shape":"Sk"},"requestTemplates":{"shape":"Sk"},"passthroughBehavior":{},"cacheNamespace":{},"cacheKeyParameters":{"shape":"S8"},"contentHandling":{},"timeoutInMillis":{"type":"integer"}}},"output":{"shape":"S1f"}},"PutIntegrationResponse":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"selectionPattern":{},"responseParameters":{"shape":"Sk"},"responseTemplates":{"shape":"Sk"},"contentHandling":{}}},"output":{"shape":"S1l"}},"PutMethod":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","authorizationType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"authorizationType":{},"authorizerId":{},"apiKeyRequired":{"type":"boolean"},"operationName":{},"requestParameters":{"shape":"S1b"},"requestModels":{"shape":"Sk"},"requestValidatorId":{},"authorizationScopes":{"shape":"S8"}}},"output":{"shape":"S1a"}},"PutMethodResponse":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"responseParameters":{"shape":"S1b"},"responseModels":{"shape":"Sk"}}},"output":{"shape":"S1d"}},"PutRestApi":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}"},"input":{"type":"structure","required":["restApiId","body"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"mode":{"location":"querystring","locationName":"mode"},"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"},"parameters":{"shape":"Sk","location":"querystring"},"body":{"type":"blob"}},"payload":"body"},"output":{"shape":"S1o"}},"TagResource":{"http":{"method":"PUT","requestUri":"/tags/{resource_arn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resource_arn"},"tags":{"shape":"Sk"}}}},"TestInvokeAuthorizer":{"http":{"requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}"},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"},"headers":{"shape":"S64"},"pathWithQueryString":{},"body":{},"stageVariables":{"shape":"Sk"},"additionalContext":{"shape":"Sk"}}},"output":{"type":"structure","members":{"clientStatus":{"type":"integer"},"log":{},"latency":{"type":"long"},"principalId":{},"policy":{},"authorization":{"type":"map","key":{},"value":{"shape":"S8"}},"claims":{"shape":"Sk"}}}},"TestInvokeMethod":{"http":{"requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"pathWithQueryString":{},"body":{},"headers":{"shape":"S64"},"clientCertificateId":{},"stageVariables":{"shape":"Sk"}}},"output":{"type":"structure","members":{"status":{"type":"integer"},"body":{},"headers":{"shape":"S64"},"log":{},"latency":{"type":"long"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resource_arn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resource_arn"},"tagKeys":{"shape":"S8","location":"querystring","locationName":"tagKeys"}}}},"UpdateAccount":{"http":{"method":"PATCH","requestUri":"/account"},"input":{"type":"structure","members":{"patchOperations":{"shape":"S6b"}}},"output":{"shape":"S30"}},"UpdateApiKey":{"http":{"method":"PATCH","requestUri":"/apikeys/{api_Key}"},"input":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"location":"uri","locationName":"api_Key"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"S6"}},"UpdateAuthorizer":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}"},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"Se"}},"UpdateBasePathMapping":{"http":{"method":"PATCH","requestUri":"/domainnames/{domain_name}/basepathmappings/{base_path}"},"input":{"type":"structure","required":["domainName","basePath"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{"location":"uri","locationName":"base_path"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"Sg"}},"UpdateClientCertificate":{"http":{"method":"PATCH","requestUri":"/clientcertificates/{clientcertificate_id}"},"input":{"type":"structure","required":["clientCertificateId"],"members":{"clientCertificateId":{"location":"uri","locationName":"clientcertificate_id"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"S2y"}},"UpdateDeployment":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/deployments/{deployment_id}"},"input":{"type":"structure","required":["restApiId","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"uri","locationName":"deployment_id"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"Sn"}},"UpdateDocumentationPart":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/documentation/parts/{part_id}"},"input":{"type":"structure","required":["restApiId","documentationPartId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationPartId":{"location":"uri","locationName":"part_id"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"Sv"}},"UpdateDocumentationVersion":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/documentation/versions/{doc_version}"},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{"location":"uri","locationName":"doc_version"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"Sx"}},"UpdateDomainName":{"http":{"method":"PATCH","requestUri":"/domainnames/{domain_name}"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"S12"}},"UpdateGatewayResponse":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}"},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"S42"}},"UpdateIntegration":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"S1f"}},"UpdateIntegrationResponse":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"S1l"}},"UpdateMethod":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"S1a"}},"UpdateMethodResponse":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"S1d"}},"UpdateModel":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/models/{model_name}"},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"S14"}},"UpdateRequestValidator":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"},"input":{"type":"structure","required":["restApiId","requestValidatorId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"requestValidatorId":{"location":"uri","locationName":"requestvalidator_id"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"S16"}},"UpdateResource":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}"},"input":{"type":"structure","required":["restApiId","resourceId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"S18"}},"UpdateRestApi":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"S1o"}},"UpdateStage":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/stages/{stage_name}"},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"S1r"}},"UpdateUsage":{"http":{"method":"PATCH","requestUri":"/usageplans/{usageplanId}/keys/{keyId}/usage"},"input":{"type":"structure","required":["usagePlanId","keyId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"uri","locationName":"keyId"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"S58"}},"UpdateUsagePlan":{"http":{"method":"PATCH","requestUri":"/usageplans/{usageplanId}"},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"S23"}},"UpdateVpcLink":{"http":{"method":"PATCH","requestUri":"/vpclinks/{vpclink_id}"},"input":{"type":"structure","required":["vpcLinkId"],"members":{"vpcLinkId":{"location":"uri","locationName":"vpclink_id"},"patchOperations":{"shape":"S6b"}}},"output":{"shape":"S27"}}},"shapes":{"S6":{"type":"structure","members":{"id":{},"value":{},"name":{},"customerId":{},"description":{},"enabled":{"type":"boolean"},"createdDate":{"type":"timestamp"},"lastUpdatedDate":{"type":"timestamp"},"stageKeys":{"shape":"S8"}}},"S8":{"type":"list","member":{}},"Sb":{"type":"list","member":{}},"Se":{"type":"structure","members":{"id":{},"name":{},"type":{},"providerARNs":{"shape":"Sb"},"authType":{},"authorizerUri":{},"authorizerCredentials":{},"identitySource":{},"identityValidationExpression":{},"authorizerResultTtlInSeconds":{"type":"integer"}}},"Sg":{"type":"structure","members":{"basePath":{},"restApiId":{},"stage":{}}},"Sk":{"type":"map","key":{},"value":{}},"Sn":{"type":"structure","members":{"id":{},"description":{},"createdDate":{"type":"timestamp"},"apiSummary":{"type":"map","key":{},"value":{"type":"map","key":{},"value":{"type":"structure","members":{"authorizationType":{},"apiKeyRequired":{"type":"boolean"}}}}}}},"Ss":{"type":"structure","required":["type"],"members":{"type":{},"path":{},"method":{},"statusCode":{},"name":{}}},"Sv":{"type":"structure","members":{"id":{},"location":{"shape":"Ss"},"properties":{}}},"Sx":{"type":"structure","members":{"version":{},"createdDate":{"type":"timestamp"},"description":{}}},"Sz":{"type":"structure","members":{"types":{"type":"list","member":{}}}},"S12":{"type":"structure","members":{"domainName":{},"certificateName":{},"certificateArn":{},"certificateUploadDate":{"type":"timestamp"},"regionalDomainName":{},"regionalHostedZoneId":{},"regionalCertificateName":{},"regionalCertificateArn":{},"distributionDomainName":{},"distributionHostedZoneId":{},"endpointConfiguration":{"shape":"Sz"}}},"S14":{"type":"structure","members":{"id":{},"name":{},"description":{},"schema":{},"contentType":{}}},"S16":{"type":"structure","members":{"id":{},"name":{},"validateRequestBody":{"type":"boolean"},"validateRequestParameters":{"type":"boolean"}}},"S18":{"type":"structure","members":{"id":{},"parentId":{},"pathPart":{},"path":{},"resourceMethods":{"type":"map","key":{},"value":{"shape":"S1a"}}}},"S1a":{"type":"structure","members":{"httpMethod":{},"authorizationType":{},"authorizerId":{},"apiKeyRequired":{"type":"boolean"},"requestValidatorId":{},"operationName":{},"requestParameters":{"shape":"S1b"},"requestModels":{"shape":"Sk"},"methodResponses":{"type":"map","key":{},"value":{"shape":"S1d"}},"methodIntegration":{"shape":"S1f"},"authorizationScopes":{"shape":"S8"}}},"S1b":{"type":"map","key":{},"value":{"type":"boolean"}},"S1d":{"type":"structure","members":{"statusCode":{},"responseParameters":{"shape":"S1b"},"responseModels":{"shape":"Sk"}}},"S1f":{"type":"structure","members":{"type":{},"httpMethod":{},"uri":{},"connectionType":{},"connectionId":{},"credentials":{},"requestParameters":{"shape":"Sk"},"requestTemplates":{"shape":"Sk"},"passthroughBehavior":{},"contentHandling":{},"timeoutInMillis":{"type":"integer"},"cacheNamespace":{},"cacheKeyParameters":{"shape":"S8"},"integrationResponses":{"type":"map","key":{},"value":{"shape":"S1l"}}}},"S1l":{"type":"structure","members":{"statusCode":{},"selectionPattern":{},"responseParameters":{"shape":"Sk"},"responseTemplates":{"shape":"Sk"},"contentHandling":{}}},"S1o":{"type":"structure","members":{"id":{},"name":{},"description":{},"createdDate":{"type":"timestamp"},"version":{},"warnings":{"shape":"S8"},"binaryMediaTypes":{"shape":"S8"},"minimumCompressionSize":{"type":"integer"},"apiKeySource":{},"endpointConfiguration":{"shape":"Sz"}}},"S1q":{"type":"structure","members":{"percentTraffic":{"type":"double"},"deploymentId":{},"stageVariableOverrides":{"shape":"Sk"},"useStageCache":{"type":"boolean"}}},"S1r":{"type":"structure","members":{"deploymentId":{},"clientCertificateId":{},"stageName":{},"description":{},"cacheClusterEnabled":{"type":"boolean"},"cacheClusterSize":{},"cacheClusterStatus":{},"methodSettings":{"type":"map","key":{},"value":{"type":"structure","members":{"metricsEnabled":{"type":"boolean"},"loggingLevel":{},"dataTraceEnabled":{"type":"boolean"},"throttlingBurstLimit":{"type":"integer"},"throttlingRateLimit":{"type":"double"},"cachingEnabled":{"type":"boolean"},"cacheTtlInSeconds":{"type":"integer"},"cacheDataEncrypted":{"type":"boolean"},"requireAuthorizationForCacheControl":{"type":"boolean"},"unauthorizedCacheControlHeaderStrategy":{}}}},"variables":{"shape":"Sk"},"documentationVersion":{},"accessLogSettings":{"type":"structure","members":{"format":{},"destinationArn":{}}},"canarySettings":{"shape":"S1q"},"tags":{"shape":"Sk"},"createdDate":{"type":"timestamp"},"lastUpdatedDate":{"type":"timestamp"}}},"S1y":{"type":"list","member":{"type":"structure","members":{"apiId":{},"stage":{}}}},"S20":{"type":"structure","members":{"burstLimit":{"type":"integer"},"rateLimit":{"type":"double"}}},"S21":{"type":"structure","members":{"limit":{"type":"integer"},"offset":{"type":"integer"},"period":{}}},"S23":{"type":"structure","members":{"id":{},"name":{},"description":{},"apiStages":{"shape":"S1y"},"throttle":{"shape":"S20"},"quota":{"shape":"S21"},"productCode":{}}},"S25":{"type":"structure","members":{"id":{},"type":{},"value":{},"name":{}}},"S27":{"type":"structure","members":{"id":{},"name":{},"description":{},"targetArns":{"shape":"S8"},"status":{},"statusMessage":{}}},"S2y":{"type":"structure","members":{"clientCertificateId":{},"description":{},"pemEncodedCertificate":{},"createdDate":{"type":"timestamp"},"expirationDate":{"type":"timestamp"}}},"S30":{"type":"structure","members":{"cloudwatchRoleArn":{},"throttleSettings":{"shape":"S20"},"features":{"shape":"S8"},"apiKeyVersion":{}}},"S42":{"type":"structure","members":{"responseType":{},"statusCode":{},"responseParameters":{"shape":"Sk"},"responseTemplates":{"shape":"Sk"},"defaultResponse":{"type":"boolean"}}},"S4v":{"type":"structure","members":{"id":{},"friendlyName":{},"description":{},"configurationProperties":{"type":"list","member":{"type":"structure","members":{"name":{},"friendlyName":{},"description":{},"required":{"type":"boolean"},"defaultValue":{}}}}}},"S58":{"type":"structure","members":{"usagePlanId":{},"startDate":{},"endDate":{},"position":{},"items":{"locationName":"values","type":"map","key":{},"value":{"type":"list","member":{"type":"list","member":{"type":"long"}}}}}},"S64":{"type":"map","key":{},"value":{}},"S6b":{"type":"list","member":{"type":"structure","members":{"op":{},"path":{},"value":{},"from":{}}}}}}

/***/ }),
/* 2733 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetApiKeys":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetBasePathMappings":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetClientCertificates":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetDeployments":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetDomainNames":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetModels":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetResources":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetRestApis":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetUsage":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetUsagePlanKeys":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetUsagePlans":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetVpcLinks":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"}}}

/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['applicationautoscaling'] = {};
AWS.ApplicationAutoScaling = Service.defineService('applicationautoscaling', ['2016-02-06']);
Object.defineProperty(apiLoader.services['applicationautoscaling'], '2016-02-06', {
  get: function get() {
    var model = __webpack_require__(2735);
    model.paginators = __webpack_require__(2736).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ApplicationAutoScaling;


/***/ }),
/* 2735 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-02-06","endpointPrefix":"autoscaling","jsonVersion":"1.1","protocol":"json","serviceFullName":"Application Auto Scaling","serviceId":"Application Auto Scaling","signatureVersion":"v4","signingName":"application-autoscaling","targetPrefix":"AnyScaleFrontendService","uid":"application-autoscaling-2016-02-06"},"operations":{"DeleteScalingPolicy":{"input":{"type":"structure","required":["PolicyName","ServiceNamespace","ResourceId","ScalableDimension"],"members":{"PolicyName":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{}}},"output":{"type":"structure","members":{}}},"DeleteScheduledAction":{"input":{"type":"structure","required":["ServiceNamespace","ScheduledActionName","ResourceId"],"members":{"ServiceNamespace":{},"ScheduledActionName":{},"ResourceId":{},"ScalableDimension":{}}},"output":{"type":"structure","members":{}}},"DeregisterScalableTarget":{"input":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{}}},"output":{"type":"structure","members":{}}},"DescribeScalableTargets":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"ServiceNamespace":{},"ResourceIds":{"shape":"Sb"},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalableTargets":{"type":"list","member":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension","MinCapacity","MaxCapacity","RoleARN","CreationTime"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"RoleARN":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeScalingActivities":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingActivities":{"type":"list","member":{"type":"structure","required":["ActivityId","ServiceNamespace","ResourceId","ScalableDimension","Description","Cause","StartTime","StatusCode"],"members":{"ActivityId":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"Description":{},"Cause":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"StatusCode":{},"StatusMessage":{},"Details":{}}}},"NextToken":{}}}},"DescribeScalingPolicies":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"PolicyNames":{"shape":"Sb"},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingPolicies":{"type":"list","member":{"type":"structure","required":["PolicyARN","PolicyName","ServiceNamespace","ResourceId","ScalableDimension","PolicyType","CreationTime"],"members":{"PolicyARN":{},"PolicyName":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"PolicyType":{},"StepScalingPolicyConfiguration":{"shape":"Sv"},"TargetTrackingScalingPolicyConfiguration":{"shape":"S14"},"Alarms":{"shape":"S1i"},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeScheduledActions":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"ScheduledActionNames":{"shape":"Sb"},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScheduledActions":{"type":"list","member":{"type":"structure","required":["ScheduledActionName","ScheduledActionARN","ServiceNamespace","Schedule","ResourceId","CreationTime"],"members":{"ScheduledActionName":{},"ScheduledActionARN":{},"ServiceNamespace":{},"Schedule":{},"ResourceId":{},"ScalableDimension":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ScalableTargetAction":{"shape":"S1p"},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"PutScalingPolicy":{"input":{"type":"structure","required":["PolicyName","ServiceNamespace","ResourceId","ScalableDimension"],"members":{"PolicyName":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"PolicyType":{},"StepScalingPolicyConfiguration":{"shape":"Sv"},"TargetTrackingScalingPolicyConfiguration":{"shape":"S14"}}},"output":{"type":"structure","required":["PolicyARN"],"members":{"PolicyARN":{},"Alarms":{"shape":"S1i"}}}},"PutScheduledAction":{"input":{"type":"structure","required":["ServiceNamespace","ScheduledActionName","ResourceId"],"members":{"ServiceNamespace":{},"Schedule":{},"ScheduledActionName":{},"ResourceId":{},"ScalableDimension":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ScalableTargetAction":{"shape":"S1p"}}},"output":{"type":"structure","members":{}}},"RegisterScalableTarget":{"input":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"RoleARN":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sb":{"type":"list","member":{}},"Sv":{"type":"structure","members":{"AdjustmentType":{},"StepAdjustments":{"type":"list","member":{"type":"structure","required":["ScalingAdjustment"],"members":{"MetricIntervalLowerBound":{"type":"double"},"MetricIntervalUpperBound":{"type":"double"},"ScalingAdjustment":{"type":"integer"}}}},"MinAdjustmentMagnitude":{"type":"integer"},"Cooldown":{"type":"integer"},"MetricAggregationType":{}}},"S14":{"type":"structure","required":["TargetValue"],"members":{"TargetValue":{"type":"double"},"PredefinedMetricSpecification":{"type":"structure","required":["PredefinedMetricType"],"members":{"PredefinedMetricType":{},"ResourceLabel":{}}},"CustomizedMetricSpecification":{"type":"structure","required":["MetricName","Namespace","Statistic"],"members":{"MetricName":{},"Namespace":{},"Dimensions":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"Statistic":{},"Unit":{}}},"ScaleOutCooldown":{"type":"integer"},"ScaleInCooldown":{"type":"integer"},"DisableScaleIn":{"type":"boolean"}}},"S1i":{"type":"list","member":{"type":"structure","required":["AlarmName","AlarmARN"],"members":{"AlarmName":{},"AlarmARN":{}}}},"S1p":{"type":"structure","members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"}}}}}

/***/ }),
/* 2736 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeScalableTargets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScalableTargets"},"DescribeScalingActivities":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScalingActivities"},"DescribeScalingPolicies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScalingPolicies"}}}

/***/ }),
/* 2737 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['autoscaling'] = {};
AWS.AutoScaling = Service.defineService('autoscaling', ['2011-01-01']);
Object.defineProperty(apiLoader.services['autoscaling'], '2011-01-01', {
  get: function get() {
    var model = __webpack_require__(2738);
    model.paginators = __webpack_require__(2739).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.AutoScaling;


/***/ }),
/* 2738 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-01-01","endpointPrefix":"autoscaling","protocol":"query","serviceFullName":"Auto Scaling","signatureVersion":"v4","uid":"autoscaling-2011-01-01","xmlNamespace":"http://autoscaling.amazonaws.com/doc/2011-01-01/"},"operations":{"AttachInstances":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{}}}},"AttachLoadBalancerTargetGroups":{"input":{"type":"structure","required":["AutoScalingGroupName","TargetGroupARNs"],"members":{"AutoScalingGroupName":{},"TargetGroupARNs":{"shape":"S6"}}},"output":{"resultWrapper":"AttachLoadBalancerTargetGroupsResult","type":"structure","members":{}}},"AttachLoadBalancers":{"input":{"type":"structure","required":["AutoScalingGroupName","LoadBalancerNames"],"members":{"AutoScalingGroupName":{},"LoadBalancerNames":{"shape":"Sa"}}},"output":{"resultWrapper":"AttachLoadBalancersResult","type":"structure","members":{}}},"CompleteLifecycleAction":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName","LifecycleActionResult"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleActionToken":{},"LifecycleActionResult":{},"InstanceId":{}}},"output":{"resultWrapper":"CompleteLifecycleActionResult","type":"structure","members":{}}},"CreateAutoScalingGroup":{"input":{"type":"structure","required":["AutoScalingGroupName","MinSize","MaxSize"],"members":{"AutoScalingGroupName":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"Sj"},"InstanceId":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"DefaultCooldown":{"type":"integer"},"AvailabilityZones":{"shape":"Sp"},"LoadBalancerNames":{"shape":"Sa"},"TargetGroupARNs":{"shape":"S6"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"PlacementGroup":{},"VPCZoneIdentifier":{},"TerminationPolicies":{"shape":"St"},"NewInstancesProtectedFromScaleIn":{"type":"boolean"},"LifecycleHookSpecificationList":{"type":"list","member":{"type":"structure","required":["LifecycleHookName","LifecycleTransition"],"members":{"LifecycleHookName":{},"LifecycleTransition":{},"NotificationMetadata":{},"HeartbeatTimeout":{"type":"integer"},"DefaultResult":{},"NotificationTargetARN":{},"RoleARN":{}}}},"Tags":{"shape":"S12"},"ServiceLinkedRoleARN":{}}}},"CreateLaunchConfiguration":{"input":{"type":"structure","required":["LaunchConfigurationName"],"members":{"LaunchConfigurationName":{},"ImageId":{},"KeyName":{},"SecurityGroups":{"shape":"S19"},"ClassicLinkVPCId":{},"ClassicLinkVPCSecurityGroups":{"shape":"S1a"},"UserData":{},"InstanceId":{},"InstanceType":{},"KernelId":{},"RamdiskId":{},"BlockDeviceMappings":{"shape":"S1c"},"InstanceMonitoring":{"shape":"S1l"},"SpotPrice":{},"IamInstanceProfile":{},"EbsOptimized":{"type":"boolean"},"AssociatePublicIpAddress":{"type":"boolean"},"PlacementTenancy":{}}}},"CreateOrUpdateTags":{"input":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S12"}}}},"DeleteAutoScalingGroup":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"ForceDelete":{"type":"boolean"}}}},"DeleteLaunchConfiguration":{"input":{"type":"structure","required":["LaunchConfigurationName"],"members":{"LaunchConfigurationName":{}}}},"DeleteLifecycleHook":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{}}},"output":{"resultWrapper":"DeleteLifecycleHookResult","type":"structure","members":{}}},"DeleteNotificationConfiguration":{"input":{"type":"structure","required":["AutoScalingGroupName","TopicARN"],"members":{"AutoScalingGroupName":{},"TopicARN":{}}}},"DeletePolicy":{"input":{"type":"structure","required":["PolicyName"],"members":{"AutoScalingGroupName":{},"PolicyName":{}}}},"DeleteScheduledAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledActionName"],"members":{"AutoScalingGroupName":{},"ScheduledActionName":{}}}},"DeleteTags":{"input":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S12"}}}},"DescribeAccountLimits":{"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"MaxNumberOfAutoScalingGroups":{"type":"integer"},"MaxNumberOfLaunchConfigurations":{"type":"integer"},"NumberOfAutoScalingGroups":{"type":"integer"},"NumberOfLaunchConfigurations":{"type":"integer"}}}},"DescribeAdjustmentTypes":{"output":{"resultWrapper":"DescribeAdjustmentTypesResult","type":"structure","members":{"AdjustmentTypes":{"type":"list","member":{"type":"structure","members":{"AdjustmentType":{}}}}}}},"DescribeAutoScalingGroups":{"input":{"type":"structure","members":{"AutoScalingGroupNames":{"shape":"S2a"},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeAutoScalingGroupsResult","type":"structure","required":["AutoScalingGroups"],"members":{"AutoScalingGroups":{"type":"list","member":{"type":"structure","required":["AutoScalingGroupName","MinSize","MaxSize","DesiredCapacity","DefaultCooldown","AvailabilityZones","HealthCheckType","CreatedTime"],"members":{"AutoScalingGroupName":{},"AutoScalingGroupARN":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"Sj"},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"DefaultCooldown":{"type":"integer"},"AvailabilityZones":{"shape":"Sp"},"LoadBalancerNames":{"shape":"Sa"},"TargetGroupARNs":{"shape":"S6"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"Instances":{"type":"list","member":{"type":"structure","required":["InstanceId","AvailabilityZone","LifecycleState","HealthStatus","ProtectedFromScaleIn"],"members":{"InstanceId":{},"AvailabilityZone":{},"LifecycleState":{},"HealthStatus":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"Sj"},"ProtectedFromScaleIn":{"type":"boolean"}}}},"CreatedTime":{"type":"timestamp"},"SuspendedProcesses":{"type":"list","member":{"type":"structure","members":{"ProcessName":{},"SuspensionReason":{}}}},"PlacementGroup":{},"VPCZoneIdentifier":{},"EnabledMetrics":{"type":"list","member":{"type":"structure","members":{"Metric":{},"Granularity":{}}}},"Status":{},"Tags":{"shape":"S2n"},"TerminationPolicies":{"shape":"St"},"NewInstancesProtectedFromScaleIn":{"type":"boolean"},"ServiceLinkedRoleARN":{}}}},"NextToken":{}}}},"DescribeAutoScalingInstances":{"input":{"type":"structure","members":{"InstanceIds":{"shape":"S2"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeAutoScalingInstancesResult","type":"structure","members":{"AutoScalingInstances":{"type":"list","member":{"type":"structure","required":["InstanceId","AutoScalingGroupName","AvailabilityZone","LifecycleState","HealthStatus","ProtectedFromScaleIn"],"members":{"InstanceId":{},"AutoScalingGroupName":{},"AvailabilityZone":{},"LifecycleState":{},"HealthStatus":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"Sj"},"ProtectedFromScaleIn":{"type":"boolean"}}}},"NextToken":{}}}},"DescribeAutoScalingNotificationTypes":{"output":{"resultWrapper":"DescribeAutoScalingNotificationTypesResult","type":"structure","members":{"AutoScalingNotificationTypes":{"shape":"S2u"}}}},"DescribeLaunchConfigurations":{"input":{"type":"structure","members":{"LaunchConfigurationNames":{"type":"list","member":{}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLaunchConfigurationsResult","type":"structure","required":["LaunchConfigurations"],"members":{"LaunchConfigurations":{"type":"list","member":{"type":"structure","required":["LaunchConfigurationName","ImageId","InstanceType","CreatedTime"],"members":{"LaunchConfigurationName":{},"LaunchConfigurationARN":{},"ImageId":{},"KeyName":{},"SecurityGroups":{"shape":"S19"},"ClassicLinkVPCId":{},"ClassicLinkVPCSecurityGroups":{"shape":"S1a"},"UserData":{},"InstanceType":{},"KernelId":{},"RamdiskId":{},"BlockDeviceMappings":{"shape":"S1c"},"InstanceMonitoring":{"shape":"S1l"},"SpotPrice":{},"IamInstanceProfile":{},"CreatedTime":{"type":"timestamp"},"EbsOptimized":{"type":"boolean"},"AssociatePublicIpAddress":{"type":"boolean"},"PlacementTenancy":{}}}},"NextToken":{}}}},"DescribeLifecycleHookTypes":{"output":{"resultWrapper":"DescribeLifecycleHookTypesResult","type":"structure","members":{"LifecycleHookTypes":{"shape":"S2u"}}}},"DescribeLifecycleHooks":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"LifecycleHookNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeLifecycleHooksResult","type":"structure","members":{"LifecycleHooks":{"type":"list","member":{"type":"structure","members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleTransition":{},"NotificationTargetARN":{},"RoleARN":{},"NotificationMetadata":{},"HeartbeatTimeout":{"type":"integer"},"GlobalTimeout":{"type":"integer"},"DefaultResult":{}}}}}}},"DescribeLoadBalancerTargetGroups":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancerTargetGroupsResult","type":"structure","members":{"LoadBalancerTargetGroups":{"type":"list","member":{"type":"structure","members":{"LoadBalancerTargetGroupARN":{},"State":{}}}},"NextToken":{}}}},"DescribeLoadBalancers":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancersResult","type":"structure","members":{"LoadBalancers":{"type":"list","member":{"type":"structure","members":{"LoadBalancerName":{},"State":{}}}},"NextToken":{}}}},"DescribeMetricCollectionTypes":{"output":{"resultWrapper":"DescribeMetricCollectionTypesResult","type":"structure","members":{"Metrics":{"type":"list","member":{"type":"structure","members":{"Metric":{}}}},"Granularities":{"type":"list","member":{"type":"structure","members":{"Granularity":{}}}}}}},"DescribeNotificationConfigurations":{"input":{"type":"structure","members":{"AutoScalingGroupNames":{"shape":"S2a"},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeNotificationConfigurationsResult","type":"structure","required":["NotificationConfigurations"],"members":{"NotificationConfigurations":{"type":"list","member":{"type":"structure","members":{"AutoScalingGroupName":{},"TopicARN":{},"NotificationType":{}}}},"NextToken":{}}}},"DescribePolicies":{"input":{"type":"structure","members":{"AutoScalingGroupName":{},"PolicyNames":{"type":"list","member":{}},"PolicyTypes":{"type":"list","member":{}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribePoliciesResult","type":"structure","members":{"ScalingPolicies":{"type":"list","member":{"type":"structure","members":{"AutoScalingGroupName":{},"PolicyName":{},"PolicyARN":{},"PolicyType":{},"AdjustmentType":{},"MinAdjustmentStep":{"shape":"S3u"},"MinAdjustmentMagnitude":{"type":"integer"},"ScalingAdjustment":{"type":"integer"},"Cooldown":{"type":"integer"},"StepAdjustments":{"shape":"S3x"},"MetricAggregationType":{},"EstimatedInstanceWarmup":{"type":"integer"},"Alarms":{"shape":"S41"},"TargetTrackingConfiguration":{"shape":"S43"}}}},"NextToken":{}}}},"DescribeScalingActivities":{"input":{"type":"structure","members":{"ActivityIds":{"type":"list","member":{}},"AutoScalingGroupName":{},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeScalingActivitiesResult","type":"structure","required":["Activities"],"members":{"Activities":{"shape":"S4j"},"NextToken":{}}}},"DescribeScalingProcessTypes":{"output":{"resultWrapper":"DescribeScalingProcessTypesResult","type":"structure","members":{"Processes":{"type":"list","member":{"type":"structure","required":["ProcessName"],"members":{"ProcessName":{}}}}}}},"DescribeScheduledActions":{"input":{"type":"structure","members":{"AutoScalingGroupName":{},"ScheduledActionNames":{"type":"list","member":{}},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeScheduledActionsResult","type":"structure","members":{"ScheduledUpdateGroupActions":{"type":"list","member":{"type":"structure","members":{"AutoScalingGroupName":{},"ScheduledActionName":{},"ScheduledActionARN":{},"Time":{"type":"timestamp"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Recurrence":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"}}}},"NextToken":{}}}},"DescribeTags":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"Tags":{"shape":"S2n"},"NextToken":{}}}},"DescribeTerminationPolicyTypes":{"output":{"resultWrapper":"DescribeTerminationPolicyTypesResult","type":"structure","members":{"TerminationPolicyTypes":{"shape":"St"}}}},"DetachInstances":{"input":{"type":"structure","required":["AutoScalingGroupName","ShouldDecrementDesiredCapacity"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{},"ShouldDecrementDesiredCapacity":{"type":"boolean"}}},"output":{"resultWrapper":"DetachInstancesResult","type":"structure","members":{"Activities":{"shape":"S4j"}}}},"DetachLoadBalancerTargetGroups":{"input":{"type":"structure","required":["AutoScalingGroupName","TargetGroupARNs"],"members":{"AutoScalingGroupName":{},"TargetGroupARNs":{"shape":"S6"}}},"output":{"resultWrapper":"DetachLoadBalancerTargetGroupsResult","type":"structure","members":{}}},"DetachLoadBalancers":{"input":{"type":"structure","required":["AutoScalingGroupName","LoadBalancerNames"],"members":{"AutoScalingGroupName":{},"LoadBalancerNames":{"shape":"Sa"}}},"output":{"resultWrapper":"DetachLoadBalancersResult","type":"structure","members":{}}},"DisableMetricsCollection":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"Metrics":{"shape":"S59"}}}},"EnableMetricsCollection":{"input":{"type":"structure","required":["AutoScalingGroupName","Granularity"],"members":{"AutoScalingGroupName":{},"Metrics":{"shape":"S59"},"Granularity":{}}}},"EnterStandby":{"input":{"type":"structure","required":["AutoScalingGroupName","ShouldDecrementDesiredCapacity"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{},"ShouldDecrementDesiredCapacity":{"type":"boolean"}}},"output":{"resultWrapper":"EnterStandbyResult","type":"structure","members":{"Activities":{"shape":"S4j"}}}},"ExecutePolicy":{"input":{"type":"structure","required":["PolicyName"],"members":{"AutoScalingGroupName":{},"PolicyName":{},"HonorCooldown":{"type":"boolean"},"MetricValue":{"type":"double"},"BreachThreshold":{"type":"double"}}}},"ExitStandby":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{}}},"output":{"resultWrapper":"ExitStandbyResult","type":"structure","members":{"Activities":{"shape":"S4j"}}}},"PutLifecycleHook":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleTransition":{},"RoleARN":{},"NotificationTargetARN":{},"NotificationMetadata":{},"HeartbeatTimeout":{"type":"integer"},"DefaultResult":{}}},"output":{"resultWrapper":"PutLifecycleHookResult","type":"structure","members":{}}},"PutNotificationConfiguration":{"input":{"type":"structure","required":["AutoScalingGroupName","TopicARN","NotificationTypes"],"members":{"AutoScalingGroupName":{},"TopicARN":{},"NotificationTypes":{"shape":"S2u"}}}},"PutScalingPolicy":{"input":{"type":"structure","required":["AutoScalingGroupName","PolicyName"],"members":{"AutoScalingGroupName":{},"PolicyName":{},"PolicyType":{},"AdjustmentType":{},"MinAdjustmentStep":{"shape":"S3u"},"MinAdjustmentMagnitude":{"type":"integer"},"ScalingAdjustment":{"type":"integer"},"Cooldown":{"type":"integer"},"MetricAggregationType":{},"StepAdjustments":{"shape":"S3x"},"EstimatedInstanceWarmup":{"type":"integer"},"TargetTrackingConfiguration":{"shape":"S43"}}},"output":{"resultWrapper":"PutScalingPolicyResult","type":"structure","members":{"PolicyARN":{},"Alarms":{"shape":"S41"}}}},"PutScheduledUpdateGroupAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledActionName"],"members":{"AutoScalingGroupName":{},"ScheduledActionName":{},"Time":{"type":"timestamp"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Recurrence":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"}}}},"RecordLifecycleActionHeartbeat":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleActionToken":{},"InstanceId":{}}},"output":{"resultWrapper":"RecordLifecycleActionHeartbeatResult","type":"structure","members":{}}},"ResumeProcesses":{"input":{"shape":"S5p"}},"SetDesiredCapacity":{"input":{"type":"structure","required":["AutoScalingGroupName","DesiredCapacity"],"members":{"AutoScalingGroupName":{},"DesiredCapacity":{"type":"integer"},"HonorCooldown":{"type":"boolean"}}}},"SetInstanceHealth":{"input":{"type":"structure","required":["InstanceId","HealthStatus"],"members":{"InstanceId":{},"HealthStatus":{},"ShouldRespectGracePeriod":{"type":"boolean"}}}},"SetInstanceProtection":{"input":{"type":"structure","required":["InstanceIds","AutoScalingGroupName","ProtectedFromScaleIn"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{},"ProtectedFromScaleIn":{"type":"boolean"}}},"output":{"resultWrapper":"SetInstanceProtectionResult","type":"structure","members":{}}},"SuspendProcesses":{"input":{"shape":"S5p"}},"TerminateInstanceInAutoScalingGroup":{"input":{"type":"structure","required":["InstanceId","ShouldDecrementDesiredCapacity"],"members":{"InstanceId":{},"ShouldDecrementDesiredCapacity":{"type":"boolean"}}},"output":{"resultWrapper":"TerminateInstanceInAutoScalingGroupResult","type":"structure","members":{"Activity":{"shape":"S4k"}}}},"UpdateAutoScalingGroup":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"Sj"},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"DefaultCooldown":{"type":"integer"},"AvailabilityZones":{"shape":"Sp"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"PlacementGroup":{},"VPCZoneIdentifier":{},"TerminationPolicies":{"shape":"St"},"NewInstancesProtectedFromScaleIn":{"type":"boolean"},"ServiceLinkedRoleARN":{}}}}},"shapes":{"S2":{"type":"list","member":{}},"S6":{"type":"list","member":{}},"Sa":{"type":"list","member":{}},"Sj":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"Sp":{"type":"list","member":{}},"St":{"type":"list","member":{}},"S12":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"ResourceId":{},"ResourceType":{},"Key":{},"Value":{},"PropagateAtLaunch":{"type":"boolean"}}}},"S19":{"type":"list","member":{}},"S1a":{"type":"list","member":{}},"S1c":{"type":"list","member":{"type":"structure","required":["DeviceName"],"members":{"VirtualName":{},"DeviceName":{},"Ebs":{"type":"structure","members":{"SnapshotId":{},"VolumeSize":{"type":"integer"},"VolumeType":{},"DeleteOnTermination":{"type":"boolean"},"Iops":{"type":"integer"},"Encrypted":{"type":"boolean"}}},"NoDevice":{"type":"boolean"}}}},"S1l":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"S2a":{"type":"list","member":{}},"S2n":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"ResourceType":{},"Key":{},"Value":{},"PropagateAtLaunch":{"type":"boolean"}}}},"S2u":{"type":"list","member":{}},"S3u":{"type":"integer","deprecated":true},"S3x":{"type":"list","member":{"type":"structure","required":["ScalingAdjustment"],"members":{"MetricIntervalLowerBound":{"type":"double"},"MetricIntervalUpperBound":{"type":"double"},"ScalingAdjustment":{"type":"integer"}}}},"S41":{"type":"list","member":{"type":"structure","members":{"AlarmName":{},"AlarmARN":{}}}},"S43":{"type":"structure","required":["TargetValue"],"members":{"PredefinedMetricSpecification":{"type":"structure","required":["PredefinedMetricType"],"members":{"PredefinedMetricType":{},"ResourceLabel":{}}},"CustomizedMetricSpecification":{"type":"structure","required":["MetricName","Namespace","Statistic"],"members":{"MetricName":{},"Namespace":{},"Dimensions":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"Statistic":{},"Unit":{}}},"TargetValue":{"type":"double"},"DisableScaleIn":{"type":"boolean"}}},"S4j":{"type":"list","member":{"shape":"S4k"}},"S4k":{"type":"structure","required":["ActivityId","AutoScalingGroupName","Cause","StartTime","StatusCode"],"members":{"ActivityId":{},"AutoScalingGroupName":{},"Description":{},"Cause":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"StatusCode":{},"StatusMessage":{},"Progress":{"type":"integer"},"Details":{}}},"S59":{"type":"list","member":{}},"S5p":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"ScalingProcesses":{"type":"list","member":{}}}}}}

/***/ }),
/* 2739 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeAutoScalingGroups":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"AutoScalingGroups"},"DescribeAutoScalingInstances":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"AutoScalingInstances"},"DescribeLaunchConfigurations":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"LaunchConfigurations"},"DescribeNotificationConfigurations":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"NotificationConfigurations"},"DescribePolicies":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"ScalingPolicies"},"DescribeScalingActivities":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Activities"},"DescribeScheduledActions":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"ScheduledUpdateGroupActions"},"DescribeTags":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Tags"}}}

/***/ }),
/* 2740 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudformation'] = {};
AWS.CloudFormation = Service.defineService('cloudformation', ['2010-05-15']);
Object.defineProperty(apiLoader.services['cloudformation'], '2010-05-15', {
  get: function get() {
    var model = __webpack_require__(2741);
    model.paginators = __webpack_require__(2742).pagination;
    model.waiters = __webpack_require__(2743).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudFormation;


/***/ }),
/* 2741 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-05-15","endpointPrefix":"cloudformation","protocol":"query","serviceFullName":"AWS CloudFormation","serviceId":"CloudFormation","signatureVersion":"v4","uid":"cloudformation-2010-05-15","xmlNamespace":"http://cloudformation.amazonaws.com/doc/2010-05-15/"},"operations":{"CancelUpdateStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"ClientRequestToken":{}}}},"ContinueUpdateRollback":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"RoleARN":{},"ResourcesToSkip":{"type":"list","member":{}},"ClientRequestToken":{}}},"output":{"resultWrapper":"ContinueUpdateRollbackResult","type":"structure","members":{}}},"CreateChangeSet":{"input":{"type":"structure","required":["StackName","ChangeSetName"],"members":{"StackName":{},"TemplateBody":{},"TemplateURL":{},"UsePreviousTemplate":{"type":"boolean"},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"ResourceTypes":{"shape":"Sl"},"RoleARN":{},"RollbackConfiguration":{"shape":"Sn"},"NotificationARNs":{"shape":"St"},"Tags":{"shape":"Sv"},"ChangeSetName":{},"ClientToken":{},"Description":{},"ChangeSetType":{}}},"output":{"resultWrapper":"CreateChangeSetResult","type":"structure","members":{"Id":{},"StackId":{}}}},"CreateStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"TemplateBody":{},"TemplateURL":{},"Parameters":{"shape":"Se"},"DisableRollback":{"type":"boolean"},"RollbackConfiguration":{"shape":"Sn"},"TimeoutInMinutes":{"type":"integer"},"NotificationARNs":{"shape":"St"},"Capabilities":{"shape":"Sj"},"ResourceTypes":{"shape":"Sl"},"RoleARN":{},"OnFailure":{},"StackPolicyBody":{},"StackPolicyURL":{},"Tags":{"shape":"Sv"},"ClientRequestToken":{},"EnableTerminationProtection":{"type":"boolean"}}},"output":{"resultWrapper":"CreateStackResult","type":"structure","members":{"StackId":{}}}},"CreateStackInstances":{"input":{"type":"structure","required":["StackSetName","Accounts","Regions"],"members":{"StackSetName":{},"Accounts":{"shape":"S1g"},"Regions":{"shape":"S1i"},"ParameterOverrides":{"shape":"Se"},"OperationPreferences":{"shape":"S1k"},"OperationId":{"idempotencyToken":true}}},"output":{"resultWrapper":"CreateStackInstancesResult","type":"structure","members":{"OperationId":{}}}},"CreateStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"Description":{},"TemplateBody":{},"TemplateURL":{},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"Tags":{"shape":"Sv"},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"resultWrapper":"CreateStackSetResult","type":"structure","members":{"StackSetId":{}}}},"DeleteChangeSet":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{}}},"output":{"resultWrapper":"DeleteChangeSetResult","type":"structure","members":{}}},"DeleteStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"RetainResources":{"type":"list","member":{}},"RoleARN":{},"ClientRequestToken":{}}}},"DeleteStackInstances":{"input":{"type":"structure","required":["StackSetName","Accounts","Regions","RetainStacks"],"members":{"StackSetName":{},"Accounts":{"shape":"S1g"},"Regions":{"shape":"S1i"},"OperationPreferences":{"shape":"S1k"},"RetainStacks":{"type":"boolean"},"OperationId":{"idempotencyToken":true}}},"output":{"resultWrapper":"DeleteStackInstancesResult","type":"structure","members":{"OperationId":{}}}},"DeleteStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{}}},"output":{"resultWrapper":"DeleteStackSetResult","type":"structure","members":{}}},"DescribeAccountLimits":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"AccountLimits":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{"type":"integer"}}}},"NextToken":{}}}},"DescribeChangeSet":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"DescribeChangeSetResult","type":"structure","members":{"ChangeSetName":{},"ChangeSetId":{},"StackId":{},"StackName":{},"Description":{},"Parameters":{"shape":"Se"},"CreationTime":{"type":"timestamp"},"ExecutionStatus":{},"Status":{},"StatusReason":{},"NotificationARNs":{"shape":"St"},"RollbackConfiguration":{"shape":"Sn"},"Capabilities":{"shape":"Sj"},"Tags":{"shape":"Sv"},"Changes":{"type":"list","member":{"type":"structure","members":{"Type":{},"ResourceChange":{"type":"structure","members":{"Action":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Replacement":{},"Scope":{"type":"list","member":{}},"Details":{"type":"list","member":{"type":"structure","members":{"Target":{"type":"structure","members":{"Attribute":{},"Name":{},"RequiresRecreation":{}}},"Evaluation":{},"ChangeSource":{},"CausingEntity":{}}}}}}}}},"NextToken":{}}}},"DescribeStackEvents":{"input":{"type":"structure","members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"DescribeStackEventsResult","type":"structure","members":{"StackEvents":{"type":"list","member":{"type":"structure","required":["StackId","EventId","StackName","Timestamp"],"members":{"StackId":{},"EventId":{},"StackName":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Timestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"ResourceProperties":{},"ClientRequestToken":{}}}},"NextToken":{}}}},"DescribeStackInstance":{"input":{"type":"structure","required":["StackSetName","StackInstanceAccount","StackInstanceRegion"],"members":{"StackSetName":{},"StackInstanceAccount":{},"StackInstanceRegion":{}}},"output":{"resultWrapper":"DescribeStackInstanceResult","type":"structure","members":{"StackInstance":{"type":"structure","members":{"StackSetId":{},"Region":{},"Account":{},"StackId":{},"ParameterOverrides":{"shape":"Se"},"Status":{},"StatusReason":{}}}}}},"DescribeStackResource":{"input":{"type":"structure","required":["StackName","LogicalResourceId"],"members":{"StackName":{},"LogicalResourceId":{}}},"output":{"resultWrapper":"DescribeStackResourceResult","type":"structure","members":{"StackResourceDetail":{"type":"structure","required":["LogicalResourceId","ResourceType","LastUpdatedTimestamp","ResourceStatus"],"members":{"StackName":{},"StackId":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"LastUpdatedTimestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"Description":{},"Metadata":{}}}}}},"DescribeStackResources":{"input":{"type":"structure","members":{"StackName":{},"LogicalResourceId":{},"PhysicalResourceId":{}}},"output":{"resultWrapper":"DescribeStackResourcesResult","type":"structure","members":{"StackResources":{"type":"list","member":{"type":"structure","required":["LogicalResourceId","ResourceType","Timestamp","ResourceStatus"],"members":{"StackName":{},"StackId":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Timestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"Description":{}}}}}}},"DescribeStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{}}},"output":{"resultWrapper":"DescribeStackSetResult","type":"structure","members":{"StackSet":{"type":"structure","members":{"StackSetName":{},"StackSetId":{},"Description":{},"Status":{},"TemplateBody":{},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"Tags":{"shape":"Sv"}}}}}},"DescribeStackSetOperation":{"input":{"type":"structure","required":["StackSetName","OperationId"],"members":{"StackSetName":{},"OperationId":{}}},"output":{"resultWrapper":"DescribeStackSetOperationResult","type":"structure","members":{"StackSetOperation":{"type":"structure","members":{"OperationId":{},"StackSetId":{},"Action":{},"Status":{},"OperationPreferences":{"shape":"S1k"},"RetainStacks":{"type":"boolean"},"CreationTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}}}},"DescribeStacks":{"input":{"type":"structure","members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"DescribeStacksResult","type":"structure","members":{"Stacks":{"type":"list","member":{"type":"structure","required":["StackName","CreationTime","StackStatus"],"members":{"StackId":{},"StackName":{},"ChangeSetId":{},"Description":{},"Parameters":{"shape":"Se"},"CreationTime":{"type":"timestamp"},"DeletionTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"RollbackConfiguration":{"shape":"Sn"},"StackStatus":{},"StackStatusReason":{},"DisableRollback":{"type":"boolean"},"NotificationARNs":{"shape":"St"},"TimeoutInMinutes":{"type":"integer"},"Capabilities":{"shape":"Sj"},"Outputs":{"type":"list","member":{"type":"structure","members":{"OutputKey":{},"OutputValue":{},"Description":{},"ExportName":{}}}},"RoleARN":{},"Tags":{"shape":"Sv"},"EnableTerminationProtection":{"type":"boolean"},"ParentId":{},"RootId":{}}}},"NextToken":{}}}},"EstimateTemplateCost":{"input":{"type":"structure","members":{"TemplateBody":{},"TemplateURL":{},"Parameters":{"shape":"Se"}}},"output":{"resultWrapper":"EstimateTemplateCostResult","type":"structure","members":{"Url":{}}}},"ExecuteChangeSet":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{},"ClientRequestToken":{}}},"output":{"resultWrapper":"ExecuteChangeSetResult","type":"structure","members":{}}},"GetStackPolicy":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{}}},"output":{"resultWrapper":"GetStackPolicyResult","type":"structure","members":{"StackPolicyBody":{}}}},"GetTemplate":{"input":{"type":"structure","members":{"StackName":{},"ChangeSetName":{},"TemplateStage":{}}},"output":{"resultWrapper":"GetTemplateResult","type":"structure","members":{"TemplateBody":{},"StagesAvailable":{"type":"list","member":{}}}}},"GetTemplateSummary":{"input":{"type":"structure","members":{"TemplateBody":{},"TemplateURL":{},"StackName":{},"StackSetName":{}}},"output":{"resultWrapper":"GetTemplateSummaryResult","type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"DefaultValue":{},"ParameterType":{},"NoEcho":{"type":"boolean"},"Description":{},"ParameterConstraints":{"type":"structure","members":{"AllowedValues":{"type":"list","member":{}}}}}}},"Description":{},"Capabilities":{"shape":"Sj"},"CapabilitiesReason":{},"ResourceTypes":{"shape":"Sl"},"Version":{},"Metadata":{},"DeclaredTransforms":{"shape":"S4u"}}}},"ListChangeSets":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"ListChangeSetsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"StackId":{},"StackName":{},"ChangeSetId":{},"ChangeSetName":{},"ExecutionStatus":{},"Status":{},"StatusReason":{},"CreationTime":{"type":"timestamp"},"Description":{}}}},"NextToken":{}}}},"ListExports":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListExportsResult","type":"structure","members":{"Exports":{"type":"list","member":{"type":"structure","members":{"ExportingStackId":{},"Name":{},"Value":{}}}},"NextToken":{}}}},"ListImports":{"input":{"type":"structure","required":["ExportName"],"members":{"ExportName":{},"NextToken":{}}},"output":{"resultWrapper":"ListImportsResult","type":"structure","members":{"Imports":{"type":"list","member":{}},"NextToken":{}}}},"ListStackInstances":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"NextToken":{},"MaxResults":{"type":"integer"},"StackInstanceAccount":{},"StackInstanceRegion":{}}},"output":{"resultWrapper":"ListStackInstancesResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"StackSetId":{},"Region":{},"Account":{},"StackId":{},"Status":{},"StatusReason":{}}}},"NextToken":{}}}},"ListStackResources":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"ListStackResourcesResult","type":"structure","members":{"StackResourceSummaries":{"type":"list","member":{"type":"structure","required":["LogicalResourceId","ResourceType","LastUpdatedTimestamp","ResourceStatus"],"members":{"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"LastUpdatedTimestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{}}}},"NextToken":{}}}},"ListStackSetOperationResults":{"input":{"type":"structure","required":["StackSetName","OperationId"],"members":{"StackSetName":{},"OperationId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListStackSetOperationResultsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"Account":{},"Region":{},"Status":{},"StatusReason":{},"AccountGateResult":{"type":"structure","members":{"Status":{},"StatusReason":{}}}}}},"NextToken":{}}}},"ListStackSetOperations":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListStackSetOperationsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"OperationId":{},"Action":{},"Status":{},"CreationTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListStackSets":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Status":{}}},"output":{"resultWrapper":"ListStackSetsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"StackSetName":{},"StackSetId":{},"Description":{},"Status":{}}}},"NextToken":{}}}},"ListStacks":{"input":{"type":"structure","members":{"NextToken":{},"StackStatusFilter":{"type":"list","member":{}}}},"output":{"resultWrapper":"ListStacksResult","type":"structure","members":{"StackSummaries":{"type":"list","member":{"type":"structure","required":["StackName","CreationTime","StackStatus"],"members":{"StackId":{},"StackName":{},"TemplateDescription":{},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"DeletionTime":{"type":"timestamp"},"StackStatus":{},"StackStatusReason":{},"ParentId":{},"RootId":{}}}},"NextToken":{}}}},"SetStackPolicy":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"StackPolicyBody":{},"StackPolicyURL":{}}}},"SignalResource":{"input":{"type":"structure","required":["StackName","LogicalResourceId","UniqueId","Status"],"members":{"StackName":{},"LogicalResourceId":{},"UniqueId":{},"Status":{}}}},"StopStackSetOperation":{"input":{"type":"structure","required":["StackSetName","OperationId"],"members":{"StackSetName":{},"OperationId":{}}},"output":{"resultWrapper":"StopStackSetOperationResult","type":"structure","members":{}}},"UpdateStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"TemplateBody":{},"TemplateURL":{},"UsePreviousTemplate":{"type":"boolean"},"StackPolicyDuringUpdateBody":{},"StackPolicyDuringUpdateURL":{},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"ResourceTypes":{"shape":"Sl"},"RoleARN":{},"RollbackConfiguration":{"shape":"Sn"},"StackPolicyBody":{},"StackPolicyURL":{},"NotificationARNs":{"shape":"St"},"Tags":{"shape":"Sv"},"ClientRequestToken":{}}},"output":{"resultWrapper":"UpdateStackResult","type":"structure","members":{"StackId":{}}}},"UpdateStackInstances":{"input":{"type":"structure","required":["StackSetName","Accounts","Regions"],"members":{"StackSetName":{},"Accounts":{"shape":"S1g"},"Regions":{"shape":"S1i"},"ParameterOverrides":{"shape":"Se"},"OperationPreferences":{"shape":"S1k"},"OperationId":{"idempotencyToken":true}}},"output":{"resultWrapper":"UpdateStackInstancesResult","type":"structure","members":{"OperationId":{}}}},"UpdateStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"Description":{},"TemplateBody":{},"TemplateURL":{},"UsePreviousTemplate":{"type":"boolean"},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"Tags":{"shape":"Sv"},"OperationPreferences":{"shape":"S1k"},"OperationId":{"idempotencyToken":true}}},"output":{"resultWrapper":"UpdateStackSetResult","type":"structure","members":{"OperationId":{}}}},"UpdateTerminationProtection":{"input":{"type":"structure","required":["EnableTerminationProtection","StackName"],"members":{"EnableTerminationProtection":{"type":"boolean"},"StackName":{}}},"output":{"resultWrapper":"UpdateTerminationProtectionResult","type":"structure","members":{"StackId":{}}}},"ValidateTemplate":{"input":{"type":"structure","members":{"TemplateBody":{},"TemplateURL":{}}},"output":{"resultWrapper":"ValidateTemplateResult","type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"DefaultValue":{},"NoEcho":{"type":"boolean"},"Description":{}}}},"Description":{},"Capabilities":{"shape":"Sj"},"CapabilitiesReason":{},"DeclaredTransforms":{"shape":"S4u"}}}}},"shapes":{"Se":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"ParameterValue":{},"UsePreviousValue":{"type":"boolean"},"ResolvedValue":{}}}},"Sj":{"type":"list","member":{}},"Sl":{"type":"list","member":{}},"Sn":{"type":"structure","members":{"RollbackTriggers":{"type":"list","member":{"type":"structure","required":["Arn","Type"],"members":{"Arn":{},"Type":{}}}},"MonitoringTimeInMinutes":{"type":"integer"}}},"St":{"type":"list","member":{}},"Sv":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S1g":{"type":"list","member":{}},"S1i":{"type":"list","member":{}},"S1k":{"type":"structure","members":{"RegionOrder":{"shape":"S1i"},"FailureToleranceCount":{"type":"integer"},"FailureTolerancePercentage":{"type":"integer"},"MaxConcurrentCount":{"type":"integer"},"MaxConcurrentPercentage":{"type":"integer"}}},"S4u":{"type":"list","member":{}}}}

/***/ }),
/* 2742 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeStackEvents":{"input_token":"NextToken","output_token":"NextToken","result_key":"StackEvents"},"DescribeStackResources":{"result_key":"StackResources"},"DescribeStacks":{"input_token":"NextToken","output_token":"NextToken","result_key":"Stacks"},"ListExports":{"input_token":"NextToken","output_token":"NextToken","result_key":"Exports"},"ListImports":{"input_token":"NextToken","output_token":"NextToken","result_key":"Imports"},"ListStackResources":{"input_token":"NextToken","output_token":"NextToken","result_key":"StackResourceSummaries"},"ListStacks":{"input_token":"NextToken","output_token":"NextToken","result_key":"StackSummaries"}}}

/***/ }),
/* 2743 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"StackExists":{"delay":5,"operation":"DescribeStacks","maxAttempts":20,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"ValidationError","state":"retry"}]},"StackCreateComplete":{"delay":30,"operation":"DescribeStacks","maxAttempts":120,"description":"Wait until stack status is CREATE_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"CREATE_COMPLETE","matcher":"pathAll","state":"success"},{"argument":"Stacks[].StackStatus","expected":"CREATE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"DELETE_COMPLETE","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"DELETE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"StackDeleteComplete":{"delay":30,"operation":"DescribeStacks","maxAttempts":120,"description":"Wait until stack status is DELETE_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"DELETE_COMPLETE","matcher":"pathAll","state":"success"},{"expected":"ValidationError","matcher":"error","state":"success"},{"argument":"Stacks[].StackStatus","expected":"DELETE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"CREATE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_IN_PROGRESS","matcher":"pathAny","state":"failure"}]},"StackUpdateComplete":{"delay":30,"maxAttempts":120,"operation":"DescribeStacks","description":"Wait until stack status is UPDATE_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"UPDATE_COMPLETE","matcher":"pathAll","state":"success"},{"expected":"UPDATE_FAILED","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"expected":"UPDATE_ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"ChangeSetCreateComplete":{"delay":30,"operation":"DescribeChangeSet","maxAttempts":120,"description":"Wait until change set status is CREATE_COMPLETE.","acceptors":[{"argument":"Status","expected":"CREATE_COMPLETE","matcher":"path","state":"success"},{"argument":"Status","expected":"FAILED","matcher":"path","state":"failure"},{"expected":"ValidationError","matcher":"error","state":"failure"}]}}}

/***/ }),
/* 2744 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudfront'] = {};
AWS.CloudFront = Service.defineService('cloudfront', ['2013-05-12*', '2013-11-11*', '2014-05-31*', '2014-10-21*', '2014-11-06*', '2015-04-17*', '2015-07-27*', '2015-09-17*', '2016-01-13*', '2016-01-28*', '2016-08-01*', '2016-08-20*', '2016-09-07*', '2016-09-29*', '2016-11-25', '2016-11-25*', '2017-03-25']);
__webpack_require__(2745);
Object.defineProperty(apiLoader.services['cloudfront'], '2016-11-25', {
  get: function get() {
    var model = __webpack_require__(2747);
    model.paginators = __webpack_require__(2748).pagination;
    model.waiters = __webpack_require__(2749).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['cloudfront'], '2017-03-25', {
  get: function get() {
    var model = __webpack_require__(2750);
    model.paginators = __webpack_require__(2751).pagination;
    model.waiters = __webpack_require__(2752).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudFront;


/***/ }),
/* 2745 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);

// pull in CloudFront signer
__webpack_require__(2746);

AWS.util.update(AWS.CloudFront.prototype, {

  setupRequestListeners: function setupRequestListeners(request) {
    request.addListener('extractData', AWS.util.hoistPayloadMember);
  }

});


/***/ }),
/* 2746 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5),
    url = AWS.util.url,
    crypto = AWS.util.crypto.lib,
    base64Encode = AWS.util.base64.encode,
    inherit = AWS.util.inherit;

var queryEncode = function (string) {
    var replacements = {
        '+': '-',
        '=': '_',
        '/': '~'
    };
    return string.replace(/[\+=\/]/g, function (match) {
        return replacements[match];
    });
};

var signPolicy = function (policy, privateKey) {
    var sign = crypto.createSign('RSA-SHA1');
    sign.write(policy);
    return queryEncode(sign.sign(privateKey, 'base64'))
};

var signWithCannedPolicy = function (url, expires, keyPairId, privateKey) {
    var policy = JSON.stringify({
        Statement: [
            {
                Resource: url,
                Condition: { DateLessThan: { 'AWS:EpochTime': expires } }
            }
        ]
    });

    return {
        Expires: expires,
        'Key-Pair-Id': keyPairId,
        Signature: signPolicy(policy.toString(), privateKey)
    };
};

var signWithCustomPolicy = function (policy, keyPairId, privateKey) {
    policy = policy.replace(/\s/mg, policy);

    return {
        Policy: queryEncode(base64Encode(policy)),
        'Key-Pair-Id': keyPairId,
        Signature: signPolicy(policy, privateKey)
    }
};

var determineScheme = function (url) {
    var parts = url.split('://');
    if (parts.length < 2) {
        throw new Error('Invalid URL.');
    }

    return parts[0].replace('*', '');
};

var getRtmpUrl = function (rtmpUrl) {
    var parsed = url.parse(rtmpUrl);
    return parsed.path.replace(/^\//, '') + (parsed.hash || '');
};

var getResource = function (url) {
    switch (determineScheme(url)) {
        case 'http':
        case 'https':
            return url;
        case 'rtmp':
            return getRtmpUrl(url);
        default:
            throw new Error('Invalid URI scheme. Scheme must be one of'
                + ' http, https, or rtmp');
    }
};

var handleError = function (err, callback) {
    if (!callback || typeof callback !== 'function') {
        throw err;
    }

    callback(err);
};

var handleSuccess = function (result, callback) {
    if (!callback || typeof callback !== 'function') {
        return result;
    }

    callback(null, result);
};

AWS.CloudFront.Signer = inherit({
    /**
     * A signer object can be used to generate signed URLs and cookies for granting
     * access to content on restricted CloudFront distributions.
     *
     * @see http://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/PrivateContent.html
     *
     * @param keyPairId [String]    (Required) The ID of the CloudFront key pair
     *                              being used.
     * @param privateKey [String]   (Required) A private key in RSA format.
     */
    constructor: function Signer(keyPairId, privateKey) {
        if (keyPairId === void 0 || privateKey === void 0) {
            throw new Error('A key pair ID and private key are required');
        }

        this.keyPairId = keyPairId;
        this.privateKey = privateKey;
    },

    /**
     * Create a signed Amazon CloudFront Cookie.
     *
     * @param options [Object]            The options to create a signed cookie.
     * @option options url [String]     The URL to which the signature will grant
     *                                  access. Required unless you pass in a full
     *                                  policy.
     * @option options expires [Number] A Unix UTC timestamp indicating when the
     *                                  signature should expire. Required unless you
     *                                  pass in a full policy.
     * @option options policy [String]  A CloudFront JSON policy. Required unless
     *                                  you pass in a url and an expiry time.
     *
     * @param cb [Function] if a callback is provided, this function will
     *   pass the hash as the second parameter (after the error parameter) to
     *   the callback function.
     *
     * @return [Object] if called synchronously (with no callback), returns the
     *   signed cookie parameters.
     * @return [null] nothing is returned if a callback is provided.
     */
    getSignedCookie: function (options, cb) {
        var signatureHash = 'policy' in options
            ? signWithCustomPolicy(options.policy, this.keyPairId, this.privateKey)
            : signWithCannedPolicy(options.url, options.expires, this.keyPairId, this.privateKey);

        var cookieHash = {};
        for (var key in signatureHash) {
            if (Object.prototype.hasOwnProperty.call(signatureHash, key)) {
                cookieHash['CloudFront-' + key] = signatureHash[key];
            }
        }

        return handleSuccess(cookieHash, cb);
    },

    /**
     * Create a signed Amazon CloudFront URL.
     *
     * Keep in mind that URLs meant for use in media/flash players may have
     * different requirements for URL formats (e.g. some require that the
     * extension be removed, some require the file name to be prefixed
     * - mp4:<path>, some require you to add "/cfx/st" into your URL).
     *
     * @param options [Object]          The options to create a signed URL.
     * @option options url [String]     The URL to which the signature will grant
     *                                  access. Required.
     * @option options expires [Number] A Unix UTC timestamp indicating when the
     *                                  signature should expire. Required unless you
     *                                  pass in a full policy.
     * @option options policy [String]  A CloudFront JSON policy. Required unless
     *                                  you pass in a url and an expiry time.
     *
     * @param cb [Function] if a callback is provided, this function will
     *   pass the URL as the second parameter (after the error parameter) to
     *   the callback function.
     *
     * @return [String] if called synchronously (with no callback), returns the
     *   signed URL.
     * @return [null] nothing is returned if a callback is provided.
     */
    getSignedUrl: function (options, cb) {
        try {
            var resource = getResource(options.url);
        } catch (err) {
            return handleError(err, cb);
        }

        var parsedUrl = url.parse(options.url, true),
            signatureHash = Object.prototype.hasOwnProperty.call(options, 'policy')
                ? signWithCustomPolicy(options.policy, this.keyPairId, this.privateKey)
                : signWithCannedPolicy(resource, options.expires, this.keyPairId, this.privateKey);

        parsedUrl.search = null;
        for (var key in signatureHash) {
            if (Object.prototype.hasOwnProperty.call(signatureHash, key)) {
                parsedUrl.query[key] = signatureHash[key];
            }
        }

        try {
            var signedUrl = determineScheme(options.url) === 'rtmp'
                    ? getRtmpUrl(url.format(parsedUrl))
                    : url.format(parsedUrl);
        } catch (err) {
            return handleError(err, cb);
        }

        return handleSuccess(signedUrl, cb);
    }
});

module.exports = AWS.CloudFront.Signer;


/***/ }),
/* 2747 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-25","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","signatureVersion":"v4","uid":"cloudfront-2016-11-25"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2016-11-25/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2016-11-25/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2016-11-25/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S21"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateInvalidation":{"http":{"requestUri":"/2016-11-25/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S28","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2016-11-25/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2016-11-25/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S2e"},"Tags":{"shape":"S21"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2016-11-25/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2016-11-25/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2016-11-25/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2016-11-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S2e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2016-11-25/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3a"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2016-11-25/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3a"}},"payload":"DistributionList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2016-11-25/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2016-11-25/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S21"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2016-11-25/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S21","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2016-11-25/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2016-11-25/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2016-11-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","members":{"LambdaFunctionARN":{},"EventType":{}}}}}},"S1a":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}}}}},"S1d":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1i":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1m":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1s":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"DistributionConfig":{"shape":"S7"}}},"S1u":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S21":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S28":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2c":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S28"}}},"S2e":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S2f":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S2i":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"StreamingDistributionConfig":{"shape":"S2e"}}},"S3a":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 2748 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","output_token":"DistributionList.NextMarker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","output_token":"InvalidationList.NextMarker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","output_token":"StreamingDistributionList.NextMarker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 2749 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 2750 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-03-25","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","signatureVersion":"v4","uid":"cloudfront-2017-03-25"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2017-03-25/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2017-03-25/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2017-03-25/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S21"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateInvalidation":{"http":{"requestUri":"/2017-03-25/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S28","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2017-03-25/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2017-03-25/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S2e"},"Tags":{"shape":"S21"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2017-03-25/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteServiceLinkedRole":{"http":{"method":"DELETE","requestUri":"/2017-03-25/service-linked-role/{RoleName}","responseCode":204},"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{"location":"uri","locationName":"RoleName"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2017-03-25/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2017-03-25/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-03-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S2e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2017-03-25/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3b"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2017-03-25/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3b"}},"payload":"DistributionList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2017-03-25/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2017-03-25/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S21"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2017-03-25/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S21","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2017-03-25/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2017-03-25/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2017-03-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","members":{"LambdaFunctionARN":{},"EventType":{}}}}}},"S1a":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}}}}},"S1d":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1i":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1m":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1s":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"DistributionConfig":{"shape":"S7"}}},"S1u":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S21":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S28":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2c":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S28"}}},"S2e":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S2f":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S2i":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"StreamingDistributionConfig":{"shape":"S2e"}}},"S3b":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 2751 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 2752 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 2753 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudhsm'] = {};
AWS.CloudHSM = Service.defineService('cloudhsm', ['2014-05-30']);
Object.defineProperty(apiLoader.services['cloudhsm'], '2014-05-30', {
  get: function get() {
    var model = __webpack_require__(2754);
    model.paginators = __webpack_require__(2755).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudHSM;


/***/ }),
/* 2754 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-05-30","endpointPrefix":"cloudhsm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CloudHSM","serviceFullName":"Amazon CloudHSM","serviceId":"CloudHSM","signatureVersion":"v4","targetPrefix":"CloudHsmFrontendService","uid":"cloudhsm-2014-05-30"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceArn","TagList"],"members":{"ResourceArn":{},"TagList":{"shape":"S3"}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"CreateHapg":{"input":{"type":"structure","required":["Label"],"members":{"Label":{}}},"output":{"type":"structure","members":{"HapgArn":{}}}},"CreateHsm":{"input":{"type":"structure","required":["SubnetId","SshKey","IamRoleArn","SubscriptionType"],"members":{"SubnetId":{"locationName":"SubnetId"},"SshKey":{"locationName":"SshKey"},"EniIp":{"locationName":"EniIp"},"IamRoleArn":{"locationName":"IamRoleArn"},"ExternalId":{"locationName":"ExternalId"},"SubscriptionType":{"locationName":"SubscriptionType"},"ClientToken":{"locationName":"ClientToken"},"SyslogIp":{"locationName":"SyslogIp"}},"locationName":"CreateHsmRequest"},"output":{"type":"structure","members":{"HsmArn":{}}}},"CreateLunaClient":{"input":{"type":"structure","required":["Certificate"],"members":{"Label":{},"Certificate":{}}},"output":{"type":"structure","members":{"ClientArn":{}}}},"DeleteHapg":{"input":{"type":"structure","required":["HapgArn"],"members":{"HapgArn":{}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"DeleteHsm":{"input":{"type":"structure","required":["HsmArn"],"members":{"HsmArn":{"locationName":"HsmArn"}},"locationName":"DeleteHsmRequest"},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"DeleteLunaClient":{"input":{"type":"structure","required":["ClientArn"],"members":{"ClientArn":{}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"DescribeHapg":{"input":{"type":"structure","required":["HapgArn"],"members":{"HapgArn":{}}},"output":{"type":"structure","members":{"HapgArn":{},"HapgSerial":{},"HsmsLastActionFailed":{"shape":"Sz"},"HsmsPendingDeletion":{"shape":"Sz"},"HsmsPendingRegistration":{"shape":"Sz"},"Label":{},"LastModifiedTimestamp":{},"PartitionSerialList":{"shape":"S11"},"State":{}}}},"DescribeHsm":{"input":{"type":"structure","members":{"HsmArn":{},"HsmSerialNumber":{}}},"output":{"type":"structure","members":{"HsmArn":{},"Status":{},"StatusDetails":{},"AvailabilityZone":{},"EniId":{},"EniIp":{},"SubscriptionType":{},"SubscriptionStartDate":{},"SubscriptionEndDate":{},"VpcId":{},"SubnetId":{},"IamRoleArn":{},"SerialNumber":{},"VendorName":{},"HsmType":{},"SoftwareVersion":{},"SshPublicKey":{},"SshKeyLastUpdated":{},"ServerCertUri":{},"ServerCertLastUpdated":{},"Partitions":{"type":"list","member":{}}}}},"DescribeLunaClient":{"input":{"type":"structure","members":{"ClientArn":{},"CertificateFingerprint":{}}},"output":{"type":"structure","members":{"ClientArn":{},"Certificate":{},"CertificateFingerprint":{},"LastModifiedTimestamp":{},"Label":{}}}},"GetConfig":{"input":{"type":"structure","required":["ClientArn","ClientVersion","HapgList"],"members":{"ClientArn":{},"ClientVersion":{},"HapgList":{"shape":"S1i"}}},"output":{"type":"structure","members":{"ConfigType":{},"ConfigFile":{},"ConfigCred":{}}}},"ListAvailableZones":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AZList":{"type":"list","member":{}}}}},"ListHapgs":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","required":["HapgList"],"members":{"HapgList":{"shape":"S1i"},"NextToken":{}}}},"ListHsms":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"HsmList":{"shape":"Sz"},"NextToken":{}}}},"ListLunaClients":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","required":["ClientList"],"members":{"ClientList":{"type":"list","member":{}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","required":["TagList"],"members":{"TagList":{"shape":"S3"}}}},"ModifyHapg":{"input":{"type":"structure","required":["HapgArn"],"members":{"HapgArn":{},"Label":{},"PartitionSerialList":{"shape":"S11"}}},"output":{"type":"structure","members":{"HapgArn":{}}}},"ModifyHsm":{"input":{"type":"structure","required":["HsmArn"],"members":{"HsmArn":{"locationName":"HsmArn"},"SubnetId":{"locationName":"SubnetId"},"EniIp":{"locationName":"EniIp"},"IamRoleArn":{"locationName":"IamRoleArn"},"ExternalId":{"locationName":"ExternalId"},"SyslogIp":{"locationName":"SyslogIp"}},"locationName":"ModifyHsmRequest"},"output":{"type":"structure","members":{"HsmArn":{}}}},"ModifyLunaClient":{"input":{"type":"structure","required":["ClientArn","Certificate"],"members":{"ClientArn":{},"Certificate":{}}},"output":{"type":"structure","members":{"ClientArn":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceArn","TagKeyList"],"members":{"ResourceArn":{},"TagKeyList":{"type":"list","member":{}}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sz":{"type":"list","member":{}},"S11":{"type":"list","member":{}},"S1i":{"type":"list","member":{}}}}

/***/ }),
/* 2755 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 2756 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudtrail'] = {};
AWS.CloudTrail = Service.defineService('cloudtrail', ['2013-11-01']);
Object.defineProperty(apiLoader.services['cloudtrail'], '2013-11-01', {
  get: function get() {
    var model = __webpack_require__(2757);
    model.paginators = __webpack_require__(2758).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudTrail;


/***/ }),
/* 2757 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-11-01","endpointPrefix":"cloudtrail","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CloudTrail","serviceFullName":"AWS CloudTrail","signatureVersion":"v4","targetPrefix":"com.amazonaws.cloudtrail.v20131101.CloudTrail_20131101","uid":"cloudtrail-2013-11-01"},"operations":{"AddTags":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"TagsList":{"shape":"S3"}}},"output":{"type":"structure","members":{}},"idempotent":true},"CreateTrail":{"input":{"type":"structure","required":["Name","S3BucketName"],"members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"EnableLogFileValidation":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{}}},"output":{"type":"structure","members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{"deprecated":true},"SnsTopicARN":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"TrailARN":{},"LogFileValidationEnabled":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{}}},"idempotent":true},"DeleteTrail":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DescribeTrails":{"input":{"type":"structure","members":{"trailNameList":{"type":"list","member":{}},"includeShadowTrails":{"type":"boolean"}}},"output":{"type":"structure","members":{"trailList":{"type":"list","member":{"type":"structure","members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{"deprecated":true},"SnsTopicARN":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"HomeRegion":{},"TrailARN":{},"LogFileValidationEnabled":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"HasCustomEventSelectors":{"type":"boolean"}}}}}},"idempotent":true},"GetEventSelectors":{"input":{"type":"structure","required":["TrailName"],"members":{"TrailName":{}}},"output":{"type":"structure","members":{"TrailARN":{},"EventSelectors":{"shape":"Si"}}},"idempotent":true},"GetTrailStatus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"IsLogging":{"type":"boolean"},"LatestDeliveryError":{},"LatestNotificationError":{},"LatestDeliveryTime":{"type":"timestamp"},"LatestNotificationTime":{"type":"timestamp"},"StartLoggingTime":{"type":"timestamp"},"StopLoggingTime":{"type":"timestamp"},"LatestCloudWatchLogsDeliveryError":{},"LatestCloudWatchLogsDeliveryTime":{"type":"timestamp"},"LatestDigestDeliveryTime":{"type":"timestamp"},"LatestDigestDeliveryError":{},"LatestDeliveryAttemptTime":{},"LatestNotificationAttemptTime":{},"LatestNotificationAttemptSucceeded":{},"LatestDeliveryAttemptSucceeded":{},"TimeLoggingStarted":{},"TimeLoggingStopped":{}}},"idempotent":true},"ListPublicKeys":{"input":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"list","member":{"type":"structure","members":{"Value":{"type":"blob"},"ValidityStartTime":{"type":"timestamp"},"ValidityEndTime":{"type":"timestamp"},"Fingerprint":{}}}},"NextToken":{}}},"idempotent":true},"ListTags":{"input":{"type":"structure","required":["ResourceIdList"],"members":{"ResourceIdList":{"type":"list","member":{}},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceTagList":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"TagsList":{"shape":"S3"}}}},"NextToken":{}}},"idempotent":true},"LookupEvents":{"input":{"type":"structure","members":{"LookupAttributes":{"type":"list","member":{"type":"structure","required":["AttributeKey","AttributeValue"],"members":{"AttributeKey":{},"AttributeValue":{}}}},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Events":{"type":"list","member":{"type":"structure","members":{"EventId":{},"EventName":{},"EventTime":{"type":"timestamp"},"EventSource":{},"Username":{},"Resources":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ResourceName":{}}}},"CloudTrailEvent":{}}}},"NextToken":{}}},"idempotent":true},"PutEventSelectors":{"input":{"type":"structure","required":["TrailName","EventSelectors"],"members":{"TrailName":{},"EventSelectors":{"shape":"Si"}}},"output":{"type":"structure","members":{"TrailARN":{},"EventSelectors":{"shape":"Si"}}},"idempotent":true},"RemoveTags":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"TagsList":{"shape":"S3"}}},"output":{"type":"structure","members":{}},"idempotent":true},"StartLogging":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"StopLogging":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateTrail":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"EnableLogFileValidation":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{}}},"output":{"type":"structure","members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{"deprecated":true},"SnsTopicARN":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"TrailARN":{},"LogFileValidationEnabled":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{}}},"idempotent":true}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Si":{"type":"list","member":{"type":"structure","members":{"ReadWriteType":{},"IncludeManagementEvents":{"type":"boolean"},"DataResources":{"type":"list","member":{"type":"structure","members":{"Type":{},"Values":{"type":"list","member":{}}}}}}}}}}

/***/ }),
/* 2758 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeTrails":{"result_key":"trailList"},"LookupEvents":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Events"}}}

/***/ }),
/* 2759 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudwatch'] = {};
AWS.CloudWatch = Service.defineService('cloudwatch', ['2010-08-01']);
Object.defineProperty(apiLoader.services['cloudwatch'], '2010-08-01', {
  get: function get() {
    var model = __webpack_require__(2760);
    model.paginators = __webpack_require__(2761).pagination;
    model.waiters = __webpack_require__(2762).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudWatch;


/***/ }),
/* 2760 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-08-01","endpointPrefix":"monitoring","protocol":"query","serviceAbbreviation":"CloudWatch","serviceFullName":"Amazon CloudWatch","signatureVersion":"v4","uid":"monitoring-2010-08-01","xmlNamespace":"http://monitoring.amazonaws.com/doc/2010-08-01/"},"operations":{"DeleteAlarms":{"input":{"type":"structure","required":["AlarmNames"],"members":{"AlarmNames":{"shape":"S2"}}}},"DeleteDashboards":{"input":{"type":"structure","required":["DashboardNames"],"members":{"DashboardNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DeleteDashboardsResult","type":"structure","members":{}}},"DescribeAlarmHistory":{"input":{"type":"structure","members":{"AlarmName":{},"HistoryItemType":{},"StartDate":{"type":"timestamp"},"EndDate":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeAlarmHistoryResult","type":"structure","members":{"AlarmHistoryItems":{"type":"list","member":{"type":"structure","members":{"AlarmName":{},"Timestamp":{"type":"timestamp"},"HistoryItemType":{},"HistorySummary":{},"HistoryData":{}}}},"NextToken":{}}}},"DescribeAlarms":{"input":{"type":"structure","members":{"AlarmNames":{"shape":"S2"},"AlarmNamePrefix":{},"StateValue":{},"ActionPrefix":{},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeAlarmsResult","type":"structure","members":{"MetricAlarms":{"shape":"Sn"},"NextToken":{}}}},"DescribeAlarmsForMetric":{"input":{"type":"structure","required":["MetricName","Namespace"],"members":{"MetricName":{},"Namespace":{},"Statistic":{},"ExtendedStatistic":{},"Dimensions":{"shape":"S10"},"Period":{"type":"integer"},"Unit":{}}},"output":{"resultWrapper":"DescribeAlarmsForMetricResult","type":"structure","members":{"MetricAlarms":{"shape":"Sn"}}}},"DisableAlarmActions":{"input":{"type":"structure","required":["AlarmNames"],"members":{"AlarmNames":{"shape":"S2"}}}},"EnableAlarmActions":{"input":{"type":"structure","required":["AlarmNames"],"members":{"AlarmNames":{"shape":"S2"}}}},"GetDashboard":{"input":{"type":"structure","required":["DashboardName"],"members":{"DashboardName":{}}},"output":{"resultWrapper":"GetDashboardResult","type":"structure","members":{"DashboardArn":{},"DashboardBody":{},"DashboardName":{}}}},"GetMetricStatistics":{"input":{"type":"structure","required":["Namespace","MetricName","StartTime","EndTime","Period"],"members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S10"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Period":{"type":"integer"},"Statistics":{"type":"list","member":{}},"ExtendedStatistics":{"type":"list","member":{}},"Unit":{}}},"output":{"resultWrapper":"GetMetricStatisticsResult","type":"structure","members":{"Label":{},"Datapoints":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"SampleCount":{"type":"double"},"Average":{"type":"double"},"Sum":{"type":"double"},"Minimum":{"type":"double"},"Maximum":{"type":"double"},"Unit":{},"ExtendedStatistics":{"type":"map","key":{},"value":{"type":"double"}}},"xmlOrder":["Timestamp","SampleCount","Average","Sum","Minimum","Maximum","Unit","ExtendedStatistics"]}}}}},"ListDashboards":{"input":{"type":"structure","members":{"DashboardNamePrefix":{},"NextToken":{}}},"output":{"resultWrapper":"ListDashboardsResult","type":"structure","members":{"DashboardEntries":{"type":"list","member":{"type":"structure","members":{"DashboardName":{},"DashboardArn":{},"LastModified":{"type":"timestamp"},"Size":{"type":"long"}}}},"NextToken":{}}}},"ListMetrics":{"input":{"type":"structure","members":{"Namespace":{},"MetricName":{},"Dimensions":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Value":{}}}},"NextToken":{}}},"output":{"resultWrapper":"ListMetricsResult","type":"structure","members":{"Metrics":{"type":"list","member":{"type":"structure","members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S10"}},"xmlOrder":["Namespace","MetricName","Dimensions"]}},"NextToken":{}},"xmlOrder":["Metrics","NextToken"]}},"PutDashboard":{"input":{"type":"structure","required":["DashboardName","DashboardBody"],"members":{"DashboardName":{},"DashboardBody":{}}},"output":{"resultWrapper":"PutDashboardResult","type":"structure","members":{"DashboardValidationMessages":{"type":"list","member":{"type":"structure","members":{"DataPath":{},"Message":{}}}}}}},"PutMetricAlarm":{"input":{"type":"structure","required":["AlarmName","MetricName","Namespace","Period","EvaluationPeriods","Threshold","ComparisonOperator"],"members":{"AlarmName":{},"AlarmDescription":{},"ActionsEnabled":{"type":"boolean"},"OKActions":{"shape":"Ss"},"AlarmActions":{"shape":"Ss"},"InsufficientDataActions":{"shape":"Ss"},"MetricName":{},"Namespace":{},"Statistic":{},"ExtendedStatistic":{},"Dimensions":{"shape":"S10"},"Period":{"type":"integer"},"Unit":{},"EvaluationPeriods":{"type":"integer"},"DatapointsToAlarm":{"type":"integer"},"Threshold":{"type":"double"},"ComparisonOperator":{},"TreatMissingData":{},"EvaluateLowSampleCountPercentile":{}}}},"PutMetricData":{"input":{"type":"structure","required":["Namespace","MetricData"],"members":{"Namespace":{},"MetricData":{"type":"list","member":{"type":"structure","required":["MetricName"],"members":{"MetricName":{},"Dimensions":{"shape":"S10"},"Timestamp":{"type":"timestamp"},"Value":{"type":"double"},"StatisticValues":{"type":"structure","required":["SampleCount","Sum","Minimum","Maximum"],"members":{"SampleCount":{"type":"double"},"Sum":{"type":"double"},"Minimum":{"type":"double"},"Maximum":{"type":"double"}}},"Unit":{},"StorageResolution":{"type":"integer"}}}}}}},"SetAlarmState":{"input":{"type":"structure","required":["AlarmName","StateValue","StateReason"],"members":{"AlarmName":{},"StateValue":{},"StateReason":{},"StateReasonData":{}}}}},"shapes":{"S2":{"type":"list","member":{}},"Sn":{"type":"list","member":{"type":"structure","members":{"AlarmName":{},"AlarmArn":{},"AlarmDescription":{},"AlarmConfigurationUpdatedTimestamp":{"type":"timestamp"},"ActionsEnabled":{"type":"boolean"},"OKActions":{"shape":"Ss"},"AlarmActions":{"shape":"Ss"},"InsufficientDataActions":{"shape":"Ss"},"StateValue":{},"StateReason":{},"StateReasonData":{},"StateUpdatedTimestamp":{"type":"timestamp"},"MetricName":{},"Namespace":{},"Statistic":{},"ExtendedStatistic":{},"Dimensions":{"shape":"S10"},"Period":{"type":"integer"},"Unit":{},"EvaluationPeriods":{"type":"integer"},"DatapointsToAlarm":{"type":"integer"},"Threshold":{"type":"double"},"ComparisonOperator":{},"TreatMissingData":{},"EvaluateLowSampleCountPercentile":{}},"xmlOrder":["AlarmName","AlarmArn","AlarmDescription","AlarmConfigurationUpdatedTimestamp","ActionsEnabled","OKActions","AlarmActions","InsufficientDataActions","StateValue","StateReason","StateReasonData","StateUpdatedTimestamp","MetricName","Namespace","Statistic","Dimensions","Period","Unit","EvaluationPeriods","Threshold","ComparisonOperator","ExtendedStatistic","TreatMissingData","EvaluateLowSampleCountPercentile","DatapointsToAlarm"]}},"Ss":{"type":"list","member":{}},"S10":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}},"xmlOrder":["Name","Value"]}}}}

/***/ }),
/* 2761 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeAlarmHistory":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"AlarmHistoryItems"},"DescribeAlarms":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"MetricAlarms"},"DescribeAlarmsForMetric":{"result_key":"MetricAlarms"},"ListMetrics":{"input_token":"NextToken","output_token":"NextToken","result_key":"Metrics"}}}

/***/ }),
/* 2762 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"AlarmExists":{"delay":5,"maxAttempts":40,"operation":"DescribeAlarms","acceptors":[{"matcher":"path","expected":true,"argument":"length(MetricAlarms[]) > `0`","state":"success"}]}}}

/***/ }),
/* 2763 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudwatchevents'] = {};
AWS.CloudWatchEvents = Service.defineService('cloudwatchevents', ['2014-02-03*', '2015-10-07']);
Object.defineProperty(apiLoader.services['cloudwatchevents'], '2015-10-07', {
  get: function get() {
    var model = __webpack_require__(2764);
    model.paginators = __webpack_require__(2765).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudWatchEvents;


/***/ }),
/* 2764 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-10-07","endpointPrefix":"events","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon CloudWatch Events","serviceId":"CloudWatch Events","signatureVersion":"v4","targetPrefix":"AWSEvents","uid":"events-2015-10-07"},"operations":{"DeleteRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DescribeEventBus":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"Policy":{}}}},"DescribeRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"EventPattern":{},"ScheduleExpression":{},"State":{},"Description":{},"RoleArn":{}}}},"DisableRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"EnableRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"ListRuleNamesByTarget":{"input":{"type":"structure","required":["TargetArn"],"members":{"TargetArn":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"RuleNames":{"type":"list","member":{}},"NextToken":{}}}},"ListRules":{"input":{"type":"structure","members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Rules":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"EventPattern":{},"State":{},"Description":{},"ScheduleExpression":{},"RoleArn":{}}}},"NextToken":{}}}},"ListTargetsByRule":{"input":{"type":"structure","required":["Rule"],"members":{"Rule":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Targets":{"shape":"Ss"},"NextToken":{}}}},"PutEvents":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","members":{"Time":{"type":"timestamp"},"Source":{},"Resources":{"type":"list","member":{}},"DetailType":{},"Detail":{}}}}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"Entries":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"PutPermission":{"input":{"type":"structure","required":["Action","Principal","StatementId"],"members":{"Action":{},"Principal":{},"StatementId":{}}}},"PutRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"ScheduleExpression":{},"EventPattern":{},"State":{},"Description":{},"RoleArn":{}}},"output":{"type":"structure","members":{"RuleArn":{}}}},"PutTargets":{"input":{"type":"structure","required":["Rule","Targets"],"members":{"Rule":{},"Targets":{"shape":"Ss"}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"FailedEntries":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"RemovePermission":{"input":{"type":"structure","required":["StatementId"],"members":{"StatementId":{}}}},"RemoveTargets":{"input":{"type":"structure","required":["Rule","Ids"],"members":{"Rule":{},"Ids":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"FailedEntries":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"TestEventPattern":{"input":{"type":"structure","required":["EventPattern","Event"],"members":{"EventPattern":{},"Event":{}}},"output":{"type":"structure","members":{"Result":{"type":"boolean"}}}}},"shapes":{"Ss":{"type":"list","member":{"type":"structure","required":["Id","Arn"],"members":{"Id":{},"Arn":{},"RoleArn":{},"Input":{},"InputPath":{},"InputTransformer":{"type":"structure","required":["InputTemplate"],"members":{"InputPathsMap":{"type":"map","key":{},"value":{}},"InputTemplate":{}}},"KinesisParameters":{"type":"structure","required":["PartitionKeyPath"],"members":{"PartitionKeyPath":{}}},"RunCommandParameters":{"type":"structure","required":["RunCommandTargets"],"members":{"RunCommandTargets":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}}}},"EcsParameters":{"type":"structure","required":["TaskDefinitionArn"],"members":{"TaskDefinitionArn":{},"TaskCount":{"type":"integer"}}},"BatchParameters":{"type":"structure","required":["JobDefinition","JobName"],"members":{"JobDefinition":{},"JobName":{},"ArrayProperties":{"type":"structure","members":{"Size":{"type":"integer"}}},"RetryStrategy":{"type":"structure","members":{"Attempts":{"type":"integer"}}}}}}}}}}

/***/ }),
/* 2765 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 2766 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudwatchlogs'] = {};
AWS.CloudWatchLogs = Service.defineService('cloudwatchlogs', ['2014-03-28']);
Object.defineProperty(apiLoader.services['cloudwatchlogs'], '2014-03-28', {
  get: function get() {
    var model = __webpack_require__(2767);
    model.paginators = __webpack_require__(2768).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudWatchLogs;


/***/ }),
/* 2767 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-03-28","endpointPrefix":"logs","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon CloudWatch Logs","signatureVersion":"v4","targetPrefix":"Logs_20140328","uid":"logs-2014-03-28"},"operations":{"AssociateKmsKey":{"input":{"type":"structure","required":["logGroupName","kmsKeyId"],"members":{"logGroupName":{},"kmsKeyId":{}}}},"CancelExportTask":{"input":{"type":"structure","required":["taskId"],"members":{"taskId":{}}}},"CreateExportTask":{"input":{"type":"structure","required":["logGroupName","from","to","destination"],"members":{"taskName":{},"logGroupName":{},"logStreamNamePrefix":{},"from":{"type":"long"},"to":{"type":"long"},"destination":{},"destinationPrefix":{}}},"output":{"type":"structure","members":{"taskId":{}}}},"CreateLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"kmsKeyId":{},"tags":{"shape":"Se"}}}},"CreateLogStream":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{}}}},"DeleteDestination":{"input":{"type":"structure","required":["destinationName"],"members":{"destinationName":{}}}},"DeleteLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"DeleteLogStream":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{}}}},"DeleteMetricFilter":{"input":{"type":"structure","required":["logGroupName","filterName"],"members":{"logGroupName":{},"filterName":{}}}},"DeleteResourcePolicy":{"input":{"type":"structure","members":{"policyName":{}}}},"DeleteRetentionPolicy":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"DeleteSubscriptionFilter":{"input":{"type":"structure","required":["logGroupName","filterName"],"members":{"logGroupName":{},"filterName":{}}}},"DescribeDestinations":{"input":{"type":"structure","members":{"DestinationNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"destinations":{"type":"list","member":{"shape":"Sx"}},"nextToken":{}}}},"DescribeExportTasks":{"input":{"type":"structure","members":{"taskId":{},"statusCode":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"exportTasks":{"type":"list","member":{"type":"structure","members":{"taskId":{},"taskName":{},"logGroupName":{},"from":{"type":"long"},"to":{"type":"long"},"destination":{},"destinationPrefix":{},"status":{"type":"structure","members":{"code":{},"message":{}}},"executionInfo":{"type":"structure","members":{"creationTime":{"type":"long"},"completionTime":{"type":"long"}}}}}},"nextToken":{}}}},"DescribeLogGroups":{"input":{"type":"structure","members":{"logGroupNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"logGroups":{"type":"list","member":{"type":"structure","members":{"logGroupName":{},"creationTime":{"type":"long"},"retentionInDays":{"type":"integer"},"metricFilterCount":{"type":"integer"},"arn":{},"storedBytes":{"type":"long"},"kmsKeyId":{}}}},"nextToken":{}}}},"DescribeLogStreams":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"logStreamNamePrefix":{},"orderBy":{},"descending":{"type":"boolean"},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"logStreams":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"creationTime":{"type":"long"},"firstEventTimestamp":{"type":"long"},"lastEventTimestamp":{"type":"long"},"lastIngestionTime":{"type":"long"},"uploadSequenceToken":{},"arn":{},"storedBytes":{"type":"long"}}}},"nextToken":{}}}},"DescribeMetricFilters":{"input":{"type":"structure","members":{"logGroupName":{},"filterNamePrefix":{},"nextToken":{},"limit":{"type":"integer"},"metricName":{},"metricNamespace":{}}},"output":{"type":"structure","members":{"metricFilters":{"type":"list","member":{"type":"structure","members":{"filterName":{},"filterPattern":{},"metricTransformations":{"shape":"S1v"},"creationTime":{"type":"long"},"logGroupName":{}}}},"nextToken":{}}}},"DescribeResourcePolicies":{"input":{"type":"structure","members":{"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"resourcePolicies":{"type":"list","member":{"shape":"S22"}},"nextToken":{}}}},"DescribeSubscriptionFilters":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"filterNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"subscriptionFilters":{"type":"list","member":{"type":"structure","members":{"filterName":{},"logGroupName":{},"filterPattern":{},"destinationArn":{},"roleArn":{},"distribution":{},"creationTime":{"type":"long"}}}},"nextToken":{}}}},"DisassociateKmsKey":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"FilterLogEvents":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"logStreamNames":{"type":"list","member":{}},"startTime":{"type":"long"},"endTime":{"type":"long"},"filterPattern":{},"nextToken":{},"limit":{"type":"integer"},"interleaved":{"type":"boolean"}}},"output":{"type":"structure","members":{"events":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"timestamp":{"type":"long"},"message":{},"ingestionTime":{"type":"long"},"eventId":{}}}},"searchedLogStreams":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"searchedCompletely":{"type":"boolean"}}}},"nextToken":{}}}},"GetLogEvents":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{},"startTime":{"type":"long"},"endTime":{"type":"long"},"nextToken":{},"limit":{"type":"integer"},"startFromHead":{"type":"boolean"}}},"output":{"type":"structure","members":{"events":{"type":"list","member":{"type":"structure","members":{"timestamp":{"type":"long"},"message":{},"ingestionTime":{"type":"long"}}}},"nextForwardToken":{},"nextBackwardToken":{}}}},"ListTagsLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}},"output":{"type":"structure","members":{"tags":{"shape":"Se"}}}},"PutDestination":{"input":{"type":"structure","required":["destinationName","targetArn","roleArn"],"members":{"destinationName":{},"targetArn":{},"roleArn":{}}},"output":{"type":"structure","members":{"destination":{"shape":"Sx"}}}},"PutDestinationPolicy":{"input":{"type":"structure","required":["destinationName","accessPolicy"],"members":{"destinationName":{},"accessPolicy":{}}}},"PutLogEvents":{"input":{"type":"structure","required":["logGroupName","logStreamName","logEvents"],"members":{"logGroupName":{},"logStreamName":{},"logEvents":{"type":"list","member":{"type":"structure","required":["timestamp","message"],"members":{"timestamp":{"type":"long"},"message":{}}}},"sequenceToken":{}}},"output":{"type":"structure","members":{"nextSequenceToken":{},"rejectedLogEventsInfo":{"type":"structure","members":{"tooNewLogEventStartIndex":{"type":"integer"},"tooOldLogEventEndIndex":{"type":"integer"},"expiredLogEventEndIndex":{"type":"integer"}}}}}},"PutMetricFilter":{"input":{"type":"structure","required":["logGroupName","filterName","filterPattern","metricTransformations"],"members":{"logGroupName":{},"filterName":{},"filterPattern":{},"metricTransformations":{"shape":"S1v"}}}},"PutResourcePolicy":{"input":{"type":"structure","members":{"policyName":{},"policyDocument":{}}},"output":{"type":"structure","members":{"resourcePolicy":{"shape":"S22"}}}},"PutRetentionPolicy":{"input":{"type":"structure","required":["logGroupName","retentionInDays"],"members":{"logGroupName":{},"retentionInDays":{"type":"integer"}}}},"PutSubscriptionFilter":{"input":{"type":"structure","required":["logGroupName","filterName","filterPattern","destinationArn"],"members":{"logGroupName":{},"filterName":{},"filterPattern":{},"destinationArn":{},"roleArn":{},"distribution":{}}}},"TagLogGroup":{"input":{"type":"structure","required":["logGroupName","tags"],"members":{"logGroupName":{},"tags":{"shape":"Se"}}}},"TestMetricFilter":{"input":{"type":"structure","required":["filterPattern","logEventMessages"],"members":{"filterPattern":{},"logEventMessages":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"matches":{"type":"list","member":{"type":"structure","members":{"eventNumber":{"type":"long"},"eventMessage":{},"extractedValues":{"type":"map","key":{},"value":{}}}}}}}},"UntagLogGroup":{"input":{"type":"structure","required":["logGroupName","tags"],"members":{"logGroupName":{},"tags":{"type":"list","member":{}}}}}},"shapes":{"Se":{"type":"map","key":{},"value":{}},"Sx":{"type":"structure","members":{"destinationName":{},"targetArn":{},"roleArn":{},"accessPolicy":{},"arn":{},"creationTime":{"type":"long"}}},"S1v":{"type":"list","member":{"type":"structure","required":["metricName","metricNamespace","metricValue"],"members":{"metricName":{},"metricNamespace":{},"metricValue":{},"defaultValue":{"type":"double"}}}},"S22":{"type":"structure","members":{"policyName":{},"policyDocument":{},"lastUpdatedTime":{"type":"long"}}}}}

/***/ }),
/* 2768 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDestinations":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"destinations"},"DescribeLogGroups":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"logGroups"},"DescribeLogStreams":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"logStreams"},"DescribeMetricFilters":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"metricFilters"},"DescribeSubscriptionFilters":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"subscriptionFilters"},"FilterLogEvents":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":["events","searchedLogStreams"]},"GetLogEvents":{"input_token":"nextToken","limit_key":"limit","output_token":"nextForwardToken","result_key":"events"}}}

/***/ }),
/* 2769 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['codecommit'] = {};
AWS.CodeCommit = Service.defineService('codecommit', ['2015-04-13']);
Object.defineProperty(apiLoader.services['codecommit'], '2015-04-13', {
  get: function get() {
    var model = __webpack_require__(2770);
    model.paginators = __webpack_require__(2771).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CodeCommit;


/***/ }),
/* 2770 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-04-13","endpointPrefix":"codecommit","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodeCommit","serviceFullName":"AWS CodeCommit","serviceId":"CodeCommit","signatureVersion":"v4","targetPrefix":"CodeCommit_20150413","uid":"codecommit-2015-04-13"},"operations":{"BatchGetRepositories":{"input":{"type":"structure","required":["repositoryNames"],"members":{"repositoryNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"shape":"S6"}},"repositoriesNotFound":{"type":"list","member":{}}}}},"CreateBranch":{"input":{"type":"structure","required":["repositoryName","branchName","commitId"],"members":{"repositoryName":{},"branchName":{},"commitId":{}}}},"CreatePullRequest":{"input":{"type":"structure","required":["title","targets"],"members":{"title":{},"description":{},"targets":{"type":"list","member":{"type":"structure","required":["repositoryName","sourceReference"],"members":{"repositoryName":{},"sourceReference":{},"destinationReference":{}}}},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"Sr"}}}},"CreateRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"repositoryDescription":{}}},"output":{"type":"structure","members":{"repositoryMetadata":{"shape":"S6"}}}},"DeleteBranch":{"input":{"type":"structure","required":["repositoryName","branchName"],"members":{"repositoryName":{},"branchName":{}}},"output":{"type":"structure","members":{"deletedBranch":{"shape":"S12"}}}},"DeleteCommentContent":{"input":{"type":"structure","required":["commentId"],"members":{"commentId":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S16"}}}},"DeleteRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"repositoryId":{}}}},"DescribePullRequestEvents":{"input":{"type":"structure","required":["pullRequestId"],"members":{"pullRequestId":{},"pullRequestEventType":{},"actorArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["pullRequestEvents"],"members":{"pullRequestEvents":{"type":"list","member":{"type":"structure","members":{"pullRequestId":{},"eventDate":{"type":"timestamp"},"pullRequestEventType":{},"actorArn":{},"pullRequestStatusChangedEventMetadata":{"type":"structure","members":{"pullRequestStatus":{}}},"pullRequestSourceReferenceUpdatedEventMetadata":{"type":"structure","members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{}}},"pullRequestMergedStateChangedEventMetadata":{"type":"structure","members":{"repositoryName":{},"destinationReference":{},"mergeMetadata":{"shape":"Sw"}}}}}},"nextToken":{}}}},"GetBlob":{"input":{"type":"structure","required":["repositoryName","blobId"],"members":{"repositoryName":{},"blobId":{}}},"output":{"type":"structure","required":["content"],"members":{"content":{"type":"blob"}}}},"GetBranch":{"input":{"type":"structure","members":{"repositoryName":{},"branchName":{}}},"output":{"type":"structure","members":{"branch":{"shape":"S12"}}}},"GetComment":{"input":{"type":"structure","required":["commentId"],"members":{"commentId":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S16"}}}},"GetCommentsForComparedCommit":{"input":{"type":"structure","required":["repositoryName","afterCommitId"],"members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"commentsForComparedCommitData":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S1y"},"comments":{"shape":"S22"}}}},"nextToken":{}}}},"GetCommentsForPullRequest":{"input":{"type":"structure","required":["pullRequestId"],"members":{"pullRequestId":{},"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"commentsForPullRequestData":{"type":"list","member":{"type":"structure","members":{"pullRequestId":{},"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S1y"},"comments":{"shape":"S22"}}}},"nextToken":{}}}},"GetCommit":{"input":{"type":"structure","required":["repositoryName","commitId"],"members":{"repositoryName":{},"commitId":{}}},"output":{"type":"structure","required":["commit"],"members":{"commit":{"type":"structure","members":{"commitId":{},"treeId":{},"parents":{"type":"list","member":{}},"message":{},"author":{"shape":"S2c"},"committer":{"shape":"S2c"},"additionalData":{}}}}}},"GetDifferences":{"input":{"type":"structure","required":["repositoryName","afterCommitSpecifier"],"members":{"repositoryName":{},"beforeCommitSpecifier":{},"afterCommitSpecifier":{},"beforePath":{},"afterPath":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"differences":{"type":"list","member":{"type":"structure","members":{"beforeBlob":{"shape":"S2n"},"afterBlob":{"shape":"S2n"},"changeType":{}}}},"NextToken":{}}}},"GetMergeConflicts":{"input":{"type":"structure","required":["repositoryName","destinationCommitSpecifier","sourceCommitSpecifier","mergeOption"],"members":{"repositoryName":{},"destinationCommitSpecifier":{},"sourceCommitSpecifier":{},"mergeOption":{}}},"output":{"type":"structure","required":["mergeable","destinationCommitId","sourceCommitId"],"members":{"mergeable":{"type":"boolean"},"destinationCommitId":{},"sourceCommitId":{}}}},"GetPullRequest":{"input":{"type":"structure","required":["pullRequestId"],"members":{"pullRequestId":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"Sr"}}}},"GetRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"repositoryMetadata":{"shape":"S6"}}}},"GetRepositoryTriggers":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"configurationId":{},"triggers":{"shape":"S31"}}}},"ListBranches":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"nextToken":{}}},"output":{"type":"structure","members":{"branches":{"shape":"S35"},"nextToken":{}}}},"ListPullRequests":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"authorArn":{},"pullRequestStatus":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["pullRequestIds"],"members":{"pullRequestIds":{"type":"list","member":{}},"nextToken":{}}}},"ListRepositories":{"input":{"type":"structure","members":{"nextToken":{},"sortBy":{},"order":{}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"repositoryId":{}}}},"nextToken":{}}}},"MergePullRequestByFastForward":{"input":{"type":"structure","required":["pullRequestId","repositoryName"],"members":{"pullRequestId":{},"repositoryName":{},"sourceCommitId":{}}},"output":{"type":"structure","members":{"pullRequest":{"shape":"Sr"}}}},"PostCommentForComparedCommit":{"input":{"type":"structure","required":["repositoryName","afterCommitId","content"],"members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"location":{"shape":"S1y"},"content":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S1y"},"comment":{"shape":"S16"}}},"idempotent":true},"PostCommentForPullRequest":{"input":{"type":"structure","required":["pullRequestId","repositoryName","beforeCommitId","afterCommitId","content"],"members":{"pullRequestId":{},"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"location":{"shape":"S1y"},"content":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"repositoryName":{},"pullRequestId":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S1y"},"comment":{"shape":"S16"}}},"idempotent":true},"PostCommentReply":{"input":{"type":"structure","required":["inReplyTo","content"],"members":{"inReplyTo":{},"clientRequestToken":{"idempotencyToken":true},"content":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S16"}}},"idempotent":true},"PutFile":{"input":{"type":"structure","required":["repositoryName","branchName","fileContent","filePath"],"members":{"repositoryName":{},"branchName":{},"fileContent":{"type":"blob"},"filePath":{},"fileMode":{},"parentCommitId":{},"commitMessage":{},"name":{},"email":{}}},"output":{"type":"structure","required":["commitId","blobId","treeId"],"members":{"commitId":{},"blobId":{},"treeId":{}}}},"PutRepositoryTriggers":{"input":{"type":"structure","required":["repositoryName","triggers"],"members":{"repositoryName":{},"triggers":{"shape":"S31"}}},"output":{"type":"structure","members":{"configurationId":{}}}},"TestRepositoryTriggers":{"input":{"type":"structure","required":["repositoryName","triggers"],"members":{"repositoryName":{},"triggers":{"shape":"S31"}}},"output":{"type":"structure","members":{"successfulExecutions":{"type":"list","member":{}},"failedExecutions":{"type":"list","member":{"type":"structure","members":{"trigger":{},"failureMessage":{}}}}}}},"UpdateComment":{"input":{"type":"structure","required":["commentId","content"],"members":{"commentId":{},"content":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S16"}}}},"UpdateDefaultBranch":{"input":{"type":"structure","required":["repositoryName","defaultBranchName"],"members":{"repositoryName":{},"defaultBranchName":{}}}},"UpdatePullRequestDescription":{"input":{"type":"structure","required":["pullRequestId","description"],"members":{"pullRequestId":{},"description":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"Sr"}}}},"UpdatePullRequestStatus":{"input":{"type":"structure","required":["pullRequestId","pullRequestStatus"],"members":{"pullRequestId":{},"pullRequestStatus":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"Sr"}}}},"UpdatePullRequestTitle":{"input":{"type":"structure","required":["pullRequestId","title"],"members":{"pullRequestId":{},"title":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"Sr"}}}},"UpdateRepositoryDescription":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"repositoryDescription":{}}}},"UpdateRepositoryName":{"input":{"type":"structure","required":["oldName","newName"],"members":{"oldName":{},"newName":{}}}}},"shapes":{"S6":{"type":"structure","members":{"accountId":{},"repositoryId":{},"repositoryName":{},"repositoryDescription":{},"defaultBranch":{},"lastModifiedDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"},"cloneUrlHttp":{},"cloneUrlSsh":{},"Arn":{}}},"Sr":{"type":"structure","members":{"pullRequestId":{},"title":{},"description":{},"lastActivityDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"},"pullRequestStatus":{},"authorArn":{},"pullRequestTargets":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"sourceReference":{},"destinationReference":{},"destinationCommit":{},"sourceCommit":{},"mergeMetadata":{"shape":"Sw"}}}},"clientRequestToken":{}}},"Sw":{"type":"structure","members":{"isMerged":{"type":"boolean"},"mergedBy":{}}},"S12":{"type":"structure","members":{"branchName":{},"commitId":{}}},"S16":{"type":"structure","members":{"commentId":{},"content":{},"inReplyTo":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"authorArn":{},"deleted":{"type":"boolean"},"clientRequestToken":{}}},"S1y":{"type":"structure","members":{"filePath":{},"filePosition":{"type":"long"},"relativeFileVersion":{}}},"S22":{"type":"list","member":{"shape":"S16"}},"S2c":{"type":"structure","members":{"name":{},"email":{},"date":{}}},"S2n":{"type":"structure","members":{"blobId":{},"path":{},"mode":{}}},"S31":{"type":"list","member":{"type":"structure","required":["name","destinationArn","events"],"members":{"name":{},"destinationArn":{},"customData":{},"branches":{"shape":"S35"},"events":{"type":"list","member":{}}}}},"S35":{"type":"list","member":{}}}}

/***/ }),
/* 2771 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribePullRequestEvents":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"GetCommentsForComparedCommit":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"GetCommentsForPullRequest":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"GetDifferences":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListBranches":{"input_token":"nextToken","output_token":"nextToken","result_key":"branches"},"ListPullRequests":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"ListRepositories":{"input_token":"nextToken","output_token":"nextToken","result_key":"repositories"}}}

/***/ }),
/* 2772 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['codedeploy'] = {};
AWS.CodeDeploy = Service.defineService('codedeploy', ['2014-10-06']);
Object.defineProperty(apiLoader.services['codedeploy'], '2014-10-06', {
  get: function get() {
    var model = __webpack_require__(2773);
    model.paginators = __webpack_require__(2774).pagination;
    model.waiters = __webpack_require__(2775).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CodeDeploy;


/***/ }),
/* 2773 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-10-06","endpointPrefix":"codedeploy","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodeDeploy","serviceFullName":"AWS CodeDeploy","serviceId":"CodeDeploy","signatureVersion":"v4","targetPrefix":"CodeDeploy_20141006","timestampFormat":"unixTimestamp","uid":"codedeploy-2014-10-06"},"operations":{"AddTagsToOnPremisesInstances":{"input":{"type":"structure","required":["tags","instanceNames"],"members":{"tags":{"shape":"S2"},"instanceNames":{"shape":"S6"}}}},"BatchGetApplicationRevisions":{"input":{"type":"structure","required":["applicationName","revisions"],"members":{"applicationName":{},"revisions":{"shape":"Sa"}}},"output":{"type":"structure","members":{"applicationName":{},"errorMessage":{},"revisions":{"type":"list","member":{"type":"structure","members":{"revisionLocation":{"shape":"Sb"},"genericRevisionInfo":{"shape":"St"}}}}}}},"BatchGetApplications":{"input":{"type":"structure","required":["applicationNames"],"members":{"applicationNames":{"shape":"Sz"}}},"output":{"type":"structure","members":{"applicationsInfo":{"type":"list","member":{"shape":"S12"}}}}},"BatchGetDeploymentGroups":{"input":{"type":"structure","required":["applicationName","deploymentGroupNames"],"members":{"applicationName":{},"deploymentGroupNames":{"shape":"Sv"}}},"output":{"type":"structure","members":{"deploymentGroupsInfo":{"type":"list","member":{"shape":"S1a"}},"errorMessage":{}}}},"BatchGetDeploymentInstances":{"input":{"type":"structure","required":["deploymentId","instanceIds"],"members":{"deploymentId":{},"instanceIds":{"shape":"S2r"}}},"output":{"type":"structure","members":{"instancesSummary":{"type":"list","member":{"shape":"S2v"}},"errorMessage":{}}}},"BatchGetDeployments":{"input":{"type":"structure","required":["deploymentIds"],"members":{"deploymentIds":{"shape":"S38"}}},"output":{"type":"structure","members":{"deploymentsInfo":{"type":"list","member":{"shape":"S3b"}}}}},"BatchGetOnPremisesInstances":{"input":{"type":"structure","required":["instanceNames"],"members":{"instanceNames":{"shape":"S6"}}},"output":{"type":"structure","members":{"instanceInfos":{"type":"list","member":{"shape":"S3q"}}}}},"ContinueDeployment":{"input":{"type":"structure","members":{"deploymentId":{}}}},"CreateApplication":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"computePlatform":{}}},"output":{"type":"structure","members":{"applicationId":{}}}},"CreateDeployment":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"deploymentGroupName":{},"revision":{"shape":"Sb"},"deploymentConfigName":{},"description":{},"ignoreApplicationStopFailures":{"type":"boolean"},"targetInstances":{"shape":"S3i"},"autoRollbackConfiguration":{"shape":"S1y"},"updateOutdatedInstancesOnly":{"type":"boolean"},"fileExistsBehavior":{}}},"output":{"type":"structure","members":{"deploymentId":{}}}},"CreateDeploymentConfig":{"input":{"type":"structure","required":["deploymentConfigName"],"members":{"deploymentConfigName":{},"minimumHealthyHosts":{"shape":"S40"},"trafficRoutingConfig":{"shape":"S43"},"computePlatform":{}}},"output":{"type":"structure","members":{"deploymentConfigId":{}}}},"CreateDeploymentGroup":{"input":{"type":"structure","required":["applicationName","deploymentGroupName","serviceRoleArn"],"members":{"applicationName":{},"deploymentGroupName":{},"deploymentConfigName":{},"ec2TagFilters":{"shape":"S1d"},"onPremisesInstanceTagFilters":{"shape":"S1g"},"autoScalingGroups":{"shape":"S3j"},"serviceRoleArn":{},"triggerConfigurations":{"shape":"S1o"},"alarmConfiguration":{"shape":"S1u"},"autoRollbackConfiguration":{"shape":"S1y"},"deploymentStyle":{"shape":"S21"},"blueGreenDeploymentConfiguration":{"shape":"S24"},"loadBalancerInfo":{"shape":"S2c"},"ec2TagSet":{"shape":"S2m"},"onPremisesTagSet":{"shape":"S2o"}}},"output":{"type":"structure","members":{"deploymentGroupId":{}}}},"DeleteApplication":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{}}}},"DeleteDeploymentConfig":{"input":{"type":"structure","required":["deploymentConfigName"],"members":{"deploymentConfigName":{}}}},"DeleteDeploymentGroup":{"input":{"type":"structure","required":["applicationName","deploymentGroupName"],"members":{"applicationName":{},"deploymentGroupName":{}}},"output":{"type":"structure","members":{"hooksNotCleanedUp":{"shape":"S1j"}}}},"DeleteGitHubAccountToken":{"input":{"type":"structure","members":{"tokenName":{}}},"output":{"type":"structure","members":{"tokenName":{}}}},"DeregisterOnPremisesInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}}},"GetApplication":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{}}},"output":{"type":"structure","members":{"application":{"shape":"S12"}}}},"GetApplicationRevision":{"input":{"type":"structure","required":["applicationName","revision"],"members":{"applicationName":{},"revision":{"shape":"Sb"}}},"output":{"type":"structure","members":{"applicationName":{},"revision":{"shape":"Sb"},"revisionInfo":{"shape":"St"}}}},"GetDeployment":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{}}},"output":{"type":"structure","members":{"deploymentInfo":{"shape":"S3b"}}}},"GetDeploymentConfig":{"input":{"type":"structure","required":["deploymentConfigName"],"members":{"deploymentConfigName":{}}},"output":{"type":"structure","members":{"deploymentConfigInfo":{"type":"structure","members":{"deploymentConfigId":{},"deploymentConfigName":{},"minimumHealthyHosts":{"shape":"S40"},"createTime":{"type":"timestamp"},"computePlatform":{},"trafficRoutingConfig":{"shape":"S43"}}}}}},"GetDeploymentGroup":{"input":{"type":"structure","required":["applicationName","deploymentGroupName"],"members":{"applicationName":{},"deploymentGroupName":{}}},"output":{"type":"structure","members":{"deploymentGroupInfo":{"shape":"S1a"}}}},"GetDeploymentInstance":{"input":{"type":"structure","required":["deploymentId","instanceId"],"members":{"deploymentId":{},"instanceId":{}}},"output":{"type":"structure","members":{"instanceSummary":{"shape":"S2v"}}}},"GetOnPremisesInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"instanceInfo":{"shape":"S3q"}}}},"ListApplicationRevisions":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"sortBy":{},"sortOrder":{},"s3Bucket":{},"s3KeyPrefix":{},"deployed":{},"nextToken":{}}},"output":{"type":"structure","members":{"revisions":{"shape":"Sa"},"nextToken":{}}}},"ListApplications":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"applications":{"shape":"Sz"},"nextToken":{}}}},"ListDeploymentConfigs":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"deploymentConfigsList":{"type":"list","member":{}},"nextToken":{}}}},"ListDeploymentGroups":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"nextToken":{}}},"output":{"type":"structure","members":{"applicationName":{},"deploymentGroups":{"shape":"Sv"},"nextToken":{}}}},"ListDeploymentInstances":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{},"nextToken":{},"instanceStatusFilter":{"type":"list","member":{}},"instanceTypeFilter":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"instancesList":{"shape":"S2r"},"nextToken":{}}}},"ListDeployments":{"input":{"type":"structure","members":{"applicationName":{},"deploymentGroupName":{},"includeOnlyStatuses":{"type":"list","member":{}},"createTimeRange":{"type":"structure","members":{"start":{"type":"timestamp"},"end":{"type":"timestamp"}}},"nextToken":{}}},"output":{"type":"structure","members":{"deployments":{"shape":"S38"},"nextToken":{}}}},"ListGitHubAccountTokenNames":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"tokenNameList":{"type":"list","member":{}},"nextToken":{}}}},"ListOnPremisesInstances":{"input":{"type":"structure","members":{"registrationStatus":{},"tagFilters":{"shape":"S1g"},"nextToken":{}}},"output":{"type":"structure","members":{"instanceNames":{"shape":"S6"},"nextToken":{}}}},"PutLifecycleEventHookExecutionStatus":{"input":{"type":"structure","members":{"deploymentId":{},"lifecycleEventHookExecutionId":{},"status":{}}},"output":{"type":"structure","members":{"lifecycleEventHookExecutionId":{}}}},"RegisterApplicationRevision":{"input":{"type":"structure","required":["applicationName","revision"],"members":{"applicationName":{},"description":{},"revision":{"shape":"Sb"}}}},"RegisterOnPremisesInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{},"iamSessionArn":{},"iamUserArn":{}}}},"RemoveTagsFromOnPremisesInstances":{"input":{"type":"structure","required":["tags","instanceNames"],"members":{"tags":{"shape":"S2"},"instanceNames":{"shape":"S6"}}}},"SkipWaitTimeForInstanceTermination":{"input":{"type":"structure","members":{"deploymentId":{}}}},"StopDeployment":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{},"autoRollbackEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"status":{},"statusMessage":{}}}},"UpdateApplication":{"input":{"type":"structure","members":{"applicationName":{},"newApplicationName":{}}}},"UpdateDeploymentGroup":{"input":{"type":"structure","required":["applicationName","currentDeploymentGroupName"],"members":{"applicationName":{},"currentDeploymentGroupName":{},"newDeploymentGroupName":{},"deploymentConfigName":{},"ec2TagFilters":{"shape":"S1d"},"onPremisesInstanceTagFilters":{"shape":"S1g"},"autoScalingGroups":{"shape":"S3j"},"serviceRoleArn":{},"triggerConfigurations":{"shape":"S1o"},"alarmConfiguration":{"shape":"S1u"},"autoRollbackConfiguration":{"shape":"S1y"},"deploymentStyle":{"shape":"S21"},"blueGreenDeploymentConfiguration":{"shape":"S24"},"loadBalancerInfo":{"shape":"S2c"},"ec2TagSet":{"shape":"S2m"},"onPremisesTagSet":{"shape":"S2o"}}},"output":{"type":"structure","members":{"hooksNotCleanedUp":{"shape":"S1j"}}}}},"shapes":{"S2":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S6":{"type":"list","member":{}},"Sa":{"type":"list","member":{"shape":"Sb"}},"Sb":{"type":"structure","members":{"revisionType":{},"s3Location":{"type":"structure","members":{"bucket":{},"key":{},"bundleType":{},"version":{},"eTag":{}}},"gitHubLocation":{"type":"structure","members":{"repository":{},"commitId":{}}},"string":{"type":"structure","members":{"content":{},"sha256":{}}}}},"St":{"type":"structure","members":{"description":{},"deploymentGroups":{"shape":"Sv"},"firstUsedTime":{"type":"timestamp"},"lastUsedTime":{"type":"timestamp"},"registerTime":{"type":"timestamp"}}},"Sv":{"type":"list","member":{}},"Sz":{"type":"list","member":{}},"S12":{"type":"structure","members":{"applicationId":{},"applicationName":{},"createTime":{"type":"timestamp"},"linkedToGitHub":{"type":"boolean"},"gitHubAccountName":{},"computePlatform":{}}},"S1a":{"type":"structure","members":{"applicationName":{},"deploymentGroupId":{},"deploymentGroupName":{},"deploymentConfigName":{},"ec2TagFilters":{"shape":"S1d"},"onPremisesInstanceTagFilters":{"shape":"S1g"},"autoScalingGroups":{"shape":"S1j"},"serviceRoleArn":{},"targetRevision":{"shape":"Sb"},"triggerConfigurations":{"shape":"S1o"},"alarmConfiguration":{"shape":"S1u"},"autoRollbackConfiguration":{"shape":"S1y"},"deploymentStyle":{"shape":"S21"},"blueGreenDeploymentConfiguration":{"shape":"S24"},"loadBalancerInfo":{"shape":"S2c"},"lastSuccessfulDeployment":{"shape":"S2j"},"lastAttemptedDeployment":{"shape":"S2j"},"ec2TagSet":{"shape":"S2m"},"onPremisesTagSet":{"shape":"S2o"},"computePlatform":{}}},"S1d":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Type":{}}}},"S1g":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Type":{}}}},"S1j":{"type":"list","member":{"type":"structure","members":{"name":{},"hook":{}}}},"S1o":{"type":"list","member":{"type":"structure","members":{"triggerName":{},"triggerTargetArn":{},"triggerEvents":{"type":"list","member":{}}}}},"S1u":{"type":"structure","members":{"enabled":{"type":"boolean"},"ignorePollAlarmFailure":{"type":"boolean"},"alarms":{"type":"list","member":{"type":"structure","members":{"name":{}}}}}},"S1y":{"type":"structure","members":{"enabled":{"type":"boolean"},"events":{"type":"list","member":{}}}},"S21":{"type":"structure","members":{"deploymentType":{},"deploymentOption":{}}},"S24":{"type":"structure","members":{"terminateBlueInstancesOnDeploymentSuccess":{"type":"structure","members":{"action":{},"terminationWaitTimeInMinutes":{"type":"integer"}}},"deploymentReadyOption":{"type":"structure","members":{"actionOnTimeout":{},"waitTimeInMinutes":{"type":"integer"}}},"greenFleetProvisioningOption":{"type":"structure","members":{"action":{}}}}},"S2c":{"type":"structure","members":{"elbInfoList":{"type":"list","member":{"type":"structure","members":{"name":{}}}},"targetGroupInfoList":{"type":"list","member":{"type":"structure","members":{"name":{}}}}}},"S2j":{"type":"structure","members":{"deploymentId":{},"status":{},"endTime":{"type":"timestamp"},"createTime":{"type":"timestamp"}}},"S2m":{"type":"structure","members":{"ec2TagSetList":{"type":"list","member":{"shape":"S1d"}}}},"S2o":{"type":"structure","members":{"onPremisesTagSetList":{"type":"list","member":{"shape":"S1g"}}}},"S2r":{"type":"list","member":{}},"S2v":{"type":"structure","members":{"deploymentId":{},"instanceId":{},"status":{},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"type":"list","member":{"type":"structure","members":{"lifecycleEventName":{},"diagnostics":{"type":"structure","members":{"errorCode":{},"scriptName":{},"message":{},"logTail":{}}},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"status":{}}}},"instanceType":{}}},"S38":{"type":"list","member":{}},"S3b":{"type":"structure","members":{"applicationName":{},"deploymentGroupName":{},"deploymentConfigName":{},"deploymentId":{},"previousRevision":{"shape":"Sb"},"revision":{"shape":"Sb"},"status":{},"errorInformation":{"type":"structure","members":{"code":{},"message":{}}},"createTime":{"type":"timestamp"},"startTime":{"type":"timestamp"},"completeTime":{"type":"timestamp"},"deploymentOverview":{"type":"structure","members":{"Pending":{"type":"long"},"InProgress":{"type":"long"},"Succeeded":{"type":"long"},"Failed":{"type":"long"},"Skipped":{"type":"long"},"Ready":{"type":"long"}}},"description":{},"creator":{},"ignoreApplicationStopFailures":{"type":"boolean"},"autoRollbackConfiguration":{"shape":"S1y"},"updateOutdatedInstancesOnly":{"type":"boolean"},"rollbackInfo":{"type":"structure","members":{"rollbackDeploymentId":{},"rollbackTriggeringDeploymentId":{},"rollbackMessage":{}}},"deploymentStyle":{"shape":"S21"},"targetInstances":{"shape":"S3i"},"instanceTerminationWaitTimeStarted":{"type":"boolean"},"blueGreenDeploymentConfiguration":{"shape":"S24"},"loadBalancerInfo":{"shape":"S2c"},"additionalDeploymentStatusInfo":{"type":"string","deprecated":true},"fileExistsBehavior":{},"deploymentStatusMessages":{"type":"list","member":{}},"computePlatform":{}}},"S3i":{"type":"structure","members":{"tagFilters":{"shape":"S1d"},"autoScalingGroups":{"shape":"S3j"},"ec2TagSet":{"shape":"S2m"}}},"S3j":{"type":"list","member":{}},"S3q":{"type":"structure","members":{"instanceName":{},"iamSessionArn":{},"iamUserArn":{},"instanceArn":{},"registerTime":{"type":"timestamp"},"deregisterTime":{"type":"timestamp"},"tags":{"shape":"S2"}}},"S40":{"type":"structure","members":{"value":{"type":"integer"},"type":{}}},"S43":{"type":"structure","members":{"type":{},"timeBasedCanary":{"type":"structure","members":{"canaryPercentage":{"type":"integer"},"canaryInterval":{"type":"integer"}}},"timeBasedLinear":{"type":"structure","members":{"linearPercentage":{"type":"integer"},"linearInterval":{"type":"integer"}}}}}}}

/***/ }),
/* 2774 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListApplicationRevisions":{"input_token":"nextToken","output_token":"nextToken","result_key":"revisions"},"ListApplications":{"input_token":"nextToken","output_token":"nextToken","result_key":"applications"},"ListDeploymentConfigs":{"input_token":"nextToken","output_token":"nextToken","result_key":"deploymentConfigsList"},"ListDeploymentGroups":{"input_token":"nextToken","output_token":"nextToken","result_key":"deploymentGroups"},"ListDeploymentInstances":{"input_token":"nextToken","output_token":"nextToken","result_key":"instancesList"},"ListDeployments":{"input_token":"nextToken","output_token":"nextToken","result_key":"deployments"}}}

/***/ }),
/* 2775 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DeploymentSuccessful":{"delay":15,"operation":"GetDeployment","maxAttempts":120,"acceptors":[{"expected":"Succeeded","matcher":"path","state":"success","argument":"deploymentInfo.status"},{"expected":"Failed","matcher":"path","state":"failure","argument":"deploymentInfo.status"},{"expected":"Stopped","matcher":"path","state":"failure","argument":"deploymentInfo.status"}]}}}

/***/ }),
/* 2776 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['codepipeline'] = {};
AWS.CodePipeline = Service.defineService('codepipeline', ['2015-07-09']);
Object.defineProperty(apiLoader.services['codepipeline'], '2015-07-09', {
  get: function get() {
    var model = __webpack_require__(2777);
    model.paginators = __webpack_require__(2778).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CodePipeline;


/***/ }),
/* 2777 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-07-09","endpointPrefix":"codepipeline","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodePipeline","serviceFullName":"AWS CodePipeline","signatureVersion":"v4","targetPrefix":"CodePipeline_20150709","uid":"codepipeline-2015-07-09"},"operations":{"AcknowledgeJob":{"input":{"type":"structure","required":["jobId","nonce"],"members":{"jobId":{},"nonce":{}}},"output":{"type":"structure","members":{"status":{}}}},"AcknowledgeThirdPartyJob":{"input":{"type":"structure","required":["jobId","nonce","clientToken"],"members":{"jobId":{},"nonce":{},"clientToken":{}}},"output":{"type":"structure","members":{"status":{}}}},"CreateCustomActionType":{"input":{"type":"structure","required":["category","provider","version","inputArtifactDetails","outputArtifactDetails"],"members":{"category":{},"provider":{},"version":{},"settings":{"shape":"Se"},"configurationProperties":{"shape":"Sh"},"inputArtifactDetails":{"shape":"Sn"},"outputArtifactDetails":{"shape":"Sn"}}},"output":{"type":"structure","required":["actionType"],"members":{"actionType":{"shape":"Sr"}}}},"CreatePipeline":{"input":{"type":"structure","required":["pipeline"],"members":{"pipeline":{"shape":"Sv"}}},"output":{"type":"structure","members":{"pipeline":{"shape":"Sv"}}}},"DeleteCustomActionType":{"input":{"type":"structure","required":["category","provider","version"],"members":{"category":{},"provider":{},"version":{}}}},"DeletePipeline":{"input":{"type":"structure","required":["name"],"members":{"name":{}}}},"DisableStageTransition":{"input":{"type":"structure","required":["pipelineName","stageName","transitionType","reason"],"members":{"pipelineName":{},"stageName":{},"transitionType":{},"reason":{}}}},"EnableStageTransition":{"input":{"type":"structure","required":["pipelineName","stageName","transitionType"],"members":{"pipelineName":{},"stageName":{},"transitionType":{}}}},"GetJobDetails":{"input":{"type":"structure","required":["jobId"],"members":{"jobId":{}}},"output":{"type":"structure","members":{"jobDetails":{"type":"structure","members":{"id":{},"data":{"shape":"S1x"},"accountId":{}}}}}},"GetPipeline":{"input":{"type":"structure","required":["name"],"members":{"name":{},"version":{"type":"integer"}}},"output":{"type":"structure","members":{"pipeline":{"shape":"Sv"},"metadata":{"type":"structure","members":{"pipelineArn":{},"created":{"type":"timestamp"},"updated":{"type":"timestamp"}}}}}},"GetPipelineExecution":{"input":{"type":"structure","required":["pipelineName","pipelineExecutionId"],"members":{"pipelineName":{},"pipelineExecutionId":{}}},"output":{"type":"structure","members":{"pipelineExecution":{"type":"structure","members":{"pipelineName":{},"pipelineVersion":{"type":"integer"},"pipelineExecutionId":{},"status":{},"artifactRevisions":{"type":"list","member":{"type":"structure","members":{"name":{},"revisionId":{},"revisionChangeIdentifier":{},"revisionSummary":{},"created":{"type":"timestamp"},"revisionUrl":{}}}}}}}}},"GetPipelineState":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{"pipelineName":{},"pipelineVersion":{"type":"integer"},"stageStates":{"type":"list","member":{"type":"structure","members":{"stageName":{},"inboundTransitionState":{"type":"structure","members":{"enabled":{"type":"boolean"},"lastChangedBy":{},"lastChangedAt":{"type":"timestamp"},"disabledReason":{}}},"actionStates":{"type":"list","member":{"type":"structure","members":{"actionName":{},"currentRevision":{"shape":"S34"},"latestExecution":{"type":"structure","members":{"status":{},"summary":{},"lastStatusChange":{"type":"timestamp"},"token":{},"lastUpdatedBy":{},"externalExecutionId":{},"externalExecutionUrl":{},"percentComplete":{"type":"integer"},"errorDetails":{"type":"structure","members":{"code":{},"message":{}}}}},"entityUrl":{},"revisionUrl":{}}}},"latestExecution":{"type":"structure","required":["pipelineExecutionId","status"],"members":{"pipelineExecutionId":{},"status":{}}}}}},"created":{"type":"timestamp"},"updated":{"type":"timestamp"}}}},"GetThirdPartyJobDetails":{"input":{"type":"structure","required":["jobId","clientToken"],"members":{"jobId":{},"clientToken":{}}},"output":{"type":"structure","members":{"jobDetails":{"type":"structure","members":{"id":{},"data":{"type":"structure","members":{"actionTypeId":{"shape":"Ss"},"actionConfiguration":{"shape":"S1y"},"pipelineContext":{"shape":"S1z"},"inputArtifacts":{"shape":"S22"},"outputArtifacts":{"shape":"S22"},"artifactCredentials":{"shape":"S2a"},"continuationToken":{},"encryptionKey":{"shape":"S11"}}},"nonce":{}}}}}},"ListActionTypes":{"input":{"type":"structure","members":{"actionOwnerFilter":{},"nextToken":{}}},"output":{"type":"structure","required":["actionTypes"],"members":{"actionTypes":{"type":"list","member":{"shape":"Sr"}},"nextToken":{}}}},"ListPipelineExecutions":{"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"pipelineExecutionSummaries":{"type":"list","member":{"type":"structure","members":{"pipelineExecutionId":{},"status":{},"startTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListPipelines":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"pipelines":{"type":"list","member":{"type":"structure","members":{"name":{},"version":{"type":"integer"},"created":{"type":"timestamp"},"updated":{"type":"timestamp"}}}},"nextToken":{}}}},"PollForJobs":{"input":{"type":"structure","required":["actionTypeId"],"members":{"actionTypeId":{"shape":"Ss"},"maxBatchSize":{"type":"integer"},"queryParam":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"id":{},"data":{"shape":"S1x"},"nonce":{},"accountId":{}}}}}}},"PollForThirdPartyJobs":{"input":{"type":"structure","required":["actionTypeId"],"members":{"actionTypeId":{"shape":"Ss"},"maxBatchSize":{"type":"integer"}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"clientId":{},"jobId":{}}}}}}},"PutActionRevision":{"input":{"type":"structure","required":["pipelineName","stageName","actionName","actionRevision"],"members":{"pipelineName":{},"stageName":{},"actionName":{},"actionRevision":{"shape":"S34"}}},"output":{"type":"structure","members":{"newRevision":{"type":"boolean"},"pipelineExecutionId":{}}}},"PutApprovalResult":{"input":{"type":"structure","required":["pipelineName","stageName","actionName","result","token"],"members":{"pipelineName":{},"stageName":{},"actionName":{},"result":{"type":"structure","required":["summary","status"],"members":{"summary":{},"status":{}}},"token":{}}},"output":{"type":"structure","members":{"approvedAt":{"type":"timestamp"}}}},"PutJobFailureResult":{"input":{"type":"structure","required":["jobId","failureDetails"],"members":{"jobId":{},"failureDetails":{"shape":"S4j"}}}},"PutJobSuccessResult":{"input":{"type":"structure","required":["jobId"],"members":{"jobId":{},"currentRevision":{"shape":"S4m"},"continuationToken":{},"executionDetails":{"shape":"S4o"}}}},"PutThirdPartyJobFailureResult":{"input":{"type":"structure","required":["jobId","clientToken","failureDetails"],"members":{"jobId":{},"clientToken":{},"failureDetails":{"shape":"S4j"}}}},"PutThirdPartyJobSuccessResult":{"input":{"type":"structure","required":["jobId","clientToken"],"members":{"jobId":{},"clientToken":{},"currentRevision":{"shape":"S4m"},"continuationToken":{},"executionDetails":{"shape":"S4o"}}}},"RetryStageExecution":{"input":{"type":"structure","required":["pipelineName","stageName","pipelineExecutionId","retryMode"],"members":{"pipelineName":{},"stageName":{},"pipelineExecutionId":{},"retryMode":{}}},"output":{"type":"structure","members":{"pipelineExecutionId":{}}}},"StartPipelineExecution":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{"pipelineExecutionId":{}}}},"UpdatePipeline":{"input":{"type":"structure","required":["pipeline"],"members":{"pipeline":{"shape":"Sv"}}},"output":{"type":"structure","members":{"pipeline":{"shape":"Sv"}}}}},"shapes":{"Se":{"type":"structure","members":{"thirdPartyConfigurationUrl":{},"entityUrlTemplate":{},"executionUrlTemplate":{},"revisionUrlTemplate":{}}},"Sh":{"type":"list","member":{"type":"structure","required":["name","required","key","secret"],"members":{"name":{},"required":{"type":"boolean"},"key":{"type":"boolean"},"secret":{"type":"boolean"},"queryable":{"type":"boolean"},"description":{},"type":{}}}},"Sn":{"type":"structure","required":["minimumCount","maximumCount"],"members":{"minimumCount":{"type":"integer"},"maximumCount":{"type":"integer"}}},"Sr":{"type":"structure","required":["id","inputArtifactDetails","outputArtifactDetails"],"members":{"id":{"shape":"Ss"},"settings":{"shape":"Se"},"actionConfigurationProperties":{"shape":"Sh"},"inputArtifactDetails":{"shape":"Sn"},"outputArtifactDetails":{"shape":"Sn"}}},"Ss":{"type":"structure","required":["category","owner","provider","version"],"members":{"category":{},"owner":{},"provider":{},"version":{}}},"Sv":{"type":"structure","required":["name","roleArn","artifactStore","stages"],"members":{"name":{},"roleArn":{},"artifactStore":{"type":"structure","required":["type","location"],"members":{"type":{},"location":{},"encryptionKey":{"shape":"S11"}}},"stages":{"type":"list","member":{"type":"structure","required":["name","actions"],"members":{"name":{},"blockers":{"type":"list","member":{"type":"structure","required":["name","type"],"members":{"name":{},"type":{}}}},"actions":{"type":"list","member":{"type":"structure","required":["name","actionTypeId"],"members":{"name":{},"actionTypeId":{"shape":"Ss"},"runOrder":{"type":"integer"},"configuration":{"shape":"S1f"},"outputArtifacts":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{}}}},"inputArtifacts":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{}}}},"roleArn":{}}}}}}},"version":{"type":"integer"}}},"S11":{"type":"structure","required":["id","type"],"members":{"id":{},"type":{}}},"S1f":{"type":"map","key":{},"value":{}},"S1x":{"type":"structure","members":{"actionTypeId":{"shape":"Ss"},"actionConfiguration":{"shape":"S1y"},"pipelineContext":{"shape":"S1z"},"inputArtifacts":{"shape":"S22"},"outputArtifacts":{"shape":"S22"},"artifactCredentials":{"shape":"S2a"},"continuationToken":{},"encryptionKey":{"shape":"S11"}}},"S1y":{"type":"structure","members":{"configuration":{"shape":"S1f"}}},"S1z":{"type":"structure","members":{"pipelineName":{},"stage":{"type":"structure","members":{"name":{}}},"action":{"type":"structure","members":{"name":{}}}}},"S22":{"type":"list","member":{"type":"structure","members":{"name":{},"revision":{},"location":{"type":"structure","members":{"type":{},"s3Location":{"type":"structure","required":["bucketName","objectKey"],"members":{"bucketName":{},"objectKey":{}}}}}}}},"S2a":{"type":"structure","required":["accessKeyId","secretAccessKey","sessionToken"],"members":{"accessKeyId":{},"secretAccessKey":{},"sessionToken":{}},"sensitive":true},"S34":{"type":"structure","required":["revisionId","revisionChangeId","created"],"members":{"revisionId":{},"revisionChangeId":{},"created":{"type":"timestamp"}}},"S4j":{"type":"structure","required":["type","message"],"members":{"type":{},"message":{},"externalExecutionId":{}}},"S4m":{"type":"structure","required":["revision","changeIdentifier"],"members":{"revision":{},"changeIdentifier":{},"created":{"type":"timestamp"},"revisionSummary":{}}},"S4o":{"type":"structure","members":{"summary":{},"externalExecutionId":{},"percentComplete":{"type":"integer"}}}}}

/***/ }),
/* 2778 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 2779 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cognitoidentityserviceprovider'] = {};
AWS.CognitoIdentityServiceProvider = Service.defineService('cognitoidentityserviceprovider', ['2016-04-18']);
Object.defineProperty(apiLoader.services['cognitoidentityserviceprovider'], '2016-04-18', {
  get: function get() {
    var model = __webpack_require__(2780);
    model.paginators = __webpack_require__(2781).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CognitoIdentityServiceProvider;


/***/ }),
/* 2780 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-04-18","endpointPrefix":"cognito-idp","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity Provider","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityProviderService","uid":"cognito-idp-2016-04-18"},"operations":{"AddCustomAttributes":{"input":{"type":"structure","required":["UserPoolId","CustomAttributes"],"members":{"UserPoolId":{},"CustomAttributes":{"type":"list","member":{"shape":"S4"}}}},"output":{"type":"structure","members":{}}},"AdminAddUserToGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminConfirmSignUp":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminCreateUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"ValidationData":{"shape":"Si"},"TemporaryPassword":{"shape":"Sm"},"ForceAliasCreation":{"type":"boolean"},"MessageAction":{},"DesiredDeliveryMediums":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"User":{"shape":"Ss"}}}},"AdminDeleteUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}}},"AdminDeleteUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributeNames"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributeNames":{"shape":"Sz"}}},"output":{"type":"structure","members":{}}},"AdminDisableProviderForUser":{"input":{"type":"structure","required":["UserPoolId","User"],"members":{"UserPoolId":{},"User":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"AdminDisableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminEnableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminForgetDevice":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{}}}},"AdminGetDevice":{"input":{"type":"structure","required":["DeviceKey","UserPoolId","Username"],"members":{"DeviceKey":{},"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1d"}}}},"AdminGetUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Username"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sv"},"PreferredMfaSetting":{},"UserMFASettingList":{"shape":"S1g"}}}},"AdminInitiateAuth":{"input":{"type":"structure","required":["UserPoolId","ClientId","AuthFlow"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"AuthFlow":{},"AuthParameters":{"shape":"S1k"},"ClientMetadata":{"shape":"S1l"},"AnalyticsMetadata":{"shape":"S1m"},"ContextData":{"shape":"S1n"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"AdminLinkProviderForUser":{"input":{"type":"structure","required":["UserPoolId","DestinationUser","SourceUser"],"members":{"UserPoolId":{},"DestinationUser":{"shape":"S12"},"SourceUser":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"AdminListDevices":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S24"},"PaginationToken":{}}}},"AdminListGroupsForUser":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"Username":{"shape":"Sd"},"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S28"},"NextToken":{}}}},"AdminListUserAuthEvents":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AuthEvents":{"type":"list","member":{"type":"structure","members":{"EventId":{},"EventType":{},"CreationDate":{"type":"timestamp"},"EventResponse":{},"EventRisk":{"type":"structure","members":{"RiskDecision":{},"RiskLevel":{}}},"ChallengeResponses":{"type":"list","member":{"type":"structure","members":{"ChallengeName":{},"ChallengeResponse":{}}}},"EventContextData":{"type":"structure","members":{"IpAddress":{},"DeviceName":{},"Timezone":{},"City":{},"Country":{}}},"EventFeedback":{"type":"structure","required":["FeedbackValue","Provider"],"members":{"FeedbackValue":{},"Provider":{},"FeedbackDate":{"type":"timestamp"}}}}}},"NextToken":{}}}},"AdminRemoveUserFromGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminResetUserPassword":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminRespondToAuthChallenge":{"input":{"type":"structure","required":["UserPoolId","ClientId","ChallengeName"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"ChallengeName":{},"ChallengeResponses":{"shape":"S2x"},"Session":{},"AnalyticsMetadata":{"shape":"S1m"},"ContextData":{"shape":"S1n"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"AdminSetUserMFAPreference":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"SMSMfaSettings":{"shape":"S30"},"SoftwareTokenMfaSettings":{"shape":"S31"},"Username":{"shape":"Sd"},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"AdminSetUserSettings":{"input":{"type":"structure","required":["UserPoolId","Username","MFAOptions"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MFAOptions":{"shape":"Sv"}}},"output":{"type":"structure","members":{}}},"AdminUpdateAuthEventFeedback":{"input":{"type":"structure","required":["UserPoolId","Username","EventId","FeedbackValue"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"EventId":{},"FeedbackValue":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateDeviceStatus":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributes"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"AdminUserGlobalSignOut":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AssociateSoftwareToken":{"input":{"type":"structure","members":{"AccessToken":{"shape":"S1v"},"Session":{}}},"output":{"type":"structure","members":{"SecretCode":{"type":"string","sensitive":true},"Session":{}}}},"ChangePassword":{"input":{"type":"structure","required":["PreviousPassword","ProposedPassword","AccessToken"],"members":{"PreviousPassword":{"shape":"Sm"},"ProposedPassword":{"shape":"Sm"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmDevice":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{},"DeviceSecretVerifierConfig":{"type":"structure","members":{"PasswordVerifier":{},"Salt":{}}},"DeviceName":{}}},"output":{"type":"structure","members":{"UserConfirmationNecessary":{"type":"boolean"}}}},"ConfirmForgotPassword":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode","Password"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"Password":{"shape":"Sm"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmSignUp":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"ForceAliasCreation":{"type":"boolean"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"CreateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"CreateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName","ProviderType","ProviderDetails"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S40"},"AttributeMapping":{"shape":"S41"},"IdpIdentifiers":{"shape":"S43"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"CreateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4a"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4f"}}}},"CreateUserImportJob":{"input":{"type":"structure","required":["JobName","UserPoolId","CloudWatchLogsRoleArn"],"members":{"JobName":{},"UserPoolId":{},"CloudWatchLogsRoleArn":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"CreateUserPool":{"input":{"type":"structure","required":["PoolName"],"members":{"PoolName":{},"Policies":{"shape":"S4r"},"LambdaConfig":{"shape":"S4u"},"AutoVerifiedAttributes":{"shape":"S4v"},"AliasAttributes":{"shape":"S4x"},"UsernameAttributes":{"shape":"S4z"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S54"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S59"},"EmailConfiguration":{"shape":"S5a"},"SmsConfiguration":{"shape":"S5c"},"UserPoolTags":{"shape":"S5d"},"AdminCreateUserConfig":{"shape":"S5e"},"Schema":{"shape":"S5h"},"UserPoolAddOns":{"shape":"S5i"}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S5l"}}}},"CreateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientName"],"members":{"UserPoolId":{},"ClientName":{},"GenerateSecret":{"type":"boolean"},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S5s"},"WriteAttributes":{"shape":"S5s"},"ExplicitAuthFlows":{"shape":"S5u"},"SupportedIdentityProviders":{"shape":"S5w"},"CallbackURLs":{"shape":"S5x"},"LogoutURLs":{"shape":"S5z"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S60"},"AllowedOAuthScopes":{"shape":"S62"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S64"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S67"}}}},"CreateUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"DeleteGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}}},"DeleteIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}}},"DeleteResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}}},"DeleteUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"authtype":"none"},"DeleteUserAttributes":{"input":{"type":"structure","required":["UserAttributeNames","AccessToken"],"members":{"UserAttributeNames":{"shape":"Sz"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"DeleteUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}}},"DeleteUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}}},"DeleteUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"DescribeIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"DescribeResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4f"}}}},"DescribeRiskConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}},"output":{"type":"structure","required":["RiskConfiguration"],"members":{"RiskConfiguration":{"shape":"S6r"}}}},"DescribeUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"DescribeUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S5l"}}}},"DescribeUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S67"}}}},"DescribeUserPoolDomain":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"type":"structure","members":{"DomainDescription":{"type":"structure","members":{"UserPoolId":{},"AWSAccountId":{},"Domain":{},"S3Bucket":{},"CloudFrontDistribution":{},"Version":{},"Status":{}}}}}},"ForgetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{}}}},"ForgotPassword":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"UserContextData":{"shape":"S3r"},"Username":{"shape":"Sd"},"AnalyticsMetadata":{"shape":"S1m"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S7p"}}},"authtype":"none"},"GetCSVHeader":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPoolId":{},"CSVHeader":{"type":"list","member":{}}}}},"GetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"DeviceKey":{},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1d"}}}},"GetGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"GetIdentityProviderByIdentifier":{"input":{"type":"structure","required":["UserPoolId","IdpIdentifier"],"members":{"UserPoolId":{},"IdpIdentifier":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"GetSigningCertificate":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"Certificate":{}}}},"GetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S83"}}}},"GetUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","required":["Username","UserAttributes"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"MFAOptions":{"shape":"Sv"},"PreferredMfaSetting":{},"UserMFASettingList":{"shape":"S1g"}}},"authtype":"none"},"GetUserAttributeVerificationCode":{"input":{"type":"structure","required":["AccessToken","AttributeName"],"members":{"AccessToken":{"shape":"S1v"},"AttributeName":{}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S7p"}}},"authtype":"none"},"GetUserPoolMfaConfig":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"SmsMfaConfiguration":{"shape":"S8d"},"SoftwareTokenMfaConfiguration":{"shape":"S8e"},"MfaConfiguration":{}}}},"GlobalSignOut":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"InitiateAuth":{"input":{"type":"structure","required":["AuthFlow","ClientId"],"members":{"AuthFlow":{},"AuthParameters":{"shape":"S1k"},"ClientMetadata":{"shape":"S1l"},"ClientId":{"shape":"S1i"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"ListDevices":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S24"},"PaginationToken":{}}}},"ListGroups":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S28"},"NextToken":{}}}},"ListIdentityProviders":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Providers"],"members":{"Providers":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ProviderType":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListResourceServers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ResourceServers"],"members":{"ResourceServers":{"type":"list","member":{"shape":"S4f"}},"NextToken":{}}}},"ListUserImportJobs":{"input":{"type":"structure","required":["UserPoolId","MaxResults"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"UserImportJobs":{"type":"list","member":{"shape":"S4j"}},"PaginationToken":{}}}},"ListUserPoolClients":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"UserPoolClients":{"type":"list","member":{"type":"structure","members":{"ClientId":{"shape":"S1i"},"UserPoolId":{},"ClientName":{}}}},"NextToken":{}}}},"ListUserPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"UserPools":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"LambdaConfig":{"shape":"S4u"},"Status":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListUsers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"AttributesToGet":{"type":"list","member":{}},"Limit":{"type":"integer"},"PaginationToken":{},"Filter":{}}},"output":{"type":"structure","members":{"Users":{"shape":"S9e"},"PaginationToken":{}}}},"ListUsersInGroup":{"input":{"type":"structure","required":["UserPoolId","GroupName"],"members":{"UserPoolId":{},"GroupName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Users":{"shape":"S9e"},"NextToken":{}}}},"ResendConfirmationCode":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"UserContextData":{"shape":"S3r"},"Username":{"shape":"Sd"},"AnalyticsMetadata":{"shape":"S1m"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S7p"}}},"authtype":"none"},"RespondToAuthChallenge":{"input":{"type":"structure","required":["ClientId","ChallengeName"],"members":{"ClientId":{"shape":"S1i"},"ChallengeName":{},"Session":{},"ChallengeResponses":{"shape":"S2x"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"SetRiskConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"CompromisedCredentialsRiskConfiguration":{"shape":"S6s"},"AccountTakeoverRiskConfiguration":{"shape":"S6x"},"RiskExceptionConfiguration":{"shape":"S76"}}},"output":{"type":"structure","required":["RiskConfiguration"],"members":{"RiskConfiguration":{"shape":"S6r"}}}},"SetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"CSS":{},"ImageFile":{"type":"blob"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S83"}}}},"SetUserMFAPreference":{"input":{"type":"structure","required":["AccessToken"],"members":{"SMSMfaSettings":{"shape":"S30"},"SoftwareTokenMfaSettings":{"shape":"S31"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"SetUserPoolMfaConfig":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"SmsMfaConfiguration":{"shape":"S8d"},"SoftwareTokenMfaConfiguration":{"shape":"S8e"},"MfaConfiguration":{}}},"output":{"type":"structure","members":{"SmsMfaConfiguration":{"shape":"S8d"},"SoftwareTokenMfaConfiguration":{"shape":"S8e"},"MfaConfiguration":{}}}},"SetUserSettings":{"input":{"type":"structure","required":["AccessToken","MFAOptions"],"members":{"AccessToken":{"shape":"S1v"},"MFAOptions":{"shape":"Sv"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"SignUp":{"input":{"type":"structure","required":["ClientId","Username","Password"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"Username":{"shape":"Sd"},"Password":{"shape":"Sm"},"UserAttributes":{"shape":"Si"},"ValidationData":{"shape":"Si"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","required":["UserConfirmed","UserSub"],"members":{"UserConfirmed":{"type":"boolean"},"CodeDeliveryDetails":{"shape":"S7p"},"UserSub":{}}},"authtype":"none"},"StartUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"StopUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"UpdateAuthEventFeedback":{"input":{"type":"structure","required":["UserPoolId","Username","EventId","FeedbackToken","FeedbackValue"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"EventId":{},"FeedbackToken":{"shape":"S1v"},"FeedbackValue":{}}},"output":{"type":"structure","members":{}}},"UpdateDeviceStatus":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"UpdateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"UpdateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderDetails":{"shape":"S40"},"AttributeMapping":{"shape":"S41"},"IdpIdentifiers":{"shape":"S43"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"UpdateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4a"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4f"}}}},"UpdateUserAttributes":{"input":{"type":"structure","required":["UserAttributes","AccessToken"],"members":{"UserAttributes":{"shape":"Si"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{"CodeDeliveryDetailsList":{"type":"list","member":{"shape":"S7p"}}}},"authtype":"none"},"UpdateUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Policies":{"shape":"S4r"},"LambdaConfig":{"shape":"S4u"},"AutoVerifiedAttributes":{"shape":"S4v"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S54"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S59"},"EmailConfiguration":{"shape":"S5a"},"SmsConfiguration":{"shape":"S5c"},"UserPoolTags":{"shape":"S5d"},"AdminCreateUserConfig":{"shape":"S5e"},"UserPoolAddOns":{"shape":"S5i"}}},"output":{"type":"structure","members":{}}},"UpdateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"ClientName":{},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S5s"},"WriteAttributes":{"shape":"S5s"},"ExplicitAuthFlows":{"shape":"S5u"},"SupportedIdentityProviders":{"shape":"S5w"},"CallbackURLs":{"shape":"S5x"},"LogoutURLs":{"shape":"S5z"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S60"},"AllowedOAuthScopes":{"shape":"S62"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S64"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S67"}}}},"VerifySoftwareToken":{"input":{"type":"structure","required":["UserCode"],"members":{"AccessToken":{"shape":"S1v"},"Session":{},"UserCode":{},"FriendlyDeviceName":{}}},"output":{"type":"structure","members":{"Status":{},"Session":{}}}},"VerifyUserAttribute":{"input":{"type":"structure","required":["AccessToken","AttributeName","Code"],"members":{"AccessToken":{"shape":"S1v"},"AttributeName":{},"Code":{}}},"output":{"type":"structure","members":{}},"authtype":"none"}},"shapes":{"S4":{"type":"structure","members":{"Name":{},"AttributeDataType":{},"DeveloperOnlyAttribute":{"type":"boolean"},"Mutable":{"type":"boolean"},"Required":{"type":"boolean"},"NumberAttributeConstraints":{"type":"structure","members":{"MinValue":{},"MaxValue":{}}},"StringAttributeConstraints":{"type":"structure","members":{"MinLength":{},"MaxLength":{}}}}},"Sd":{"type":"string","sensitive":true},"Si":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Value":{"type":"string","sensitive":true}}}},"Sm":{"type":"string","sensitive":true},"Ss":{"type":"structure","members":{"Username":{"shape":"Sd"},"Attributes":{"shape":"Si"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sv"}}},"Sv":{"type":"list","member":{"type":"structure","members":{"DeliveryMedium":{},"AttributeName":{}}}},"Sz":{"type":"list","member":{}},"S12":{"type":"structure","members":{"ProviderName":{},"ProviderAttributeName":{},"ProviderAttributeValue":{}}},"S1d":{"type":"structure","members":{"DeviceKey":{},"DeviceAttributes":{"shape":"Si"},"DeviceCreateDate":{"type":"timestamp"},"DeviceLastModifiedDate":{"type":"timestamp"},"DeviceLastAuthenticatedDate":{"type":"timestamp"}}},"S1g":{"type":"list","member":{}},"S1i":{"type":"string","sensitive":true},"S1k":{"type":"map","key":{},"value":{}},"S1l":{"type":"map","key":{},"value":{}},"S1m":{"type":"structure","members":{"AnalyticsEndpointId":{}}},"S1n":{"type":"structure","required":["IpAddress","ServerName","ServerPath","HttpHeaders"],"members":{"IpAddress":{},"ServerName":{},"ServerPath":{},"HttpHeaders":{"type":"list","member":{"type":"structure","members":{"headerName":{},"headerValue":{}}}},"EncodedData":{}}},"S1t":{"type":"map","key":{},"value":{}},"S1u":{"type":"structure","members":{"AccessToken":{"shape":"S1v"},"ExpiresIn":{"type":"integer"},"TokenType":{},"RefreshToken":{"shape":"S1v"},"IdToken":{"shape":"S1v"},"NewDeviceMetadata":{"type":"structure","members":{"DeviceKey":{},"DeviceGroupKey":{}}}}},"S1v":{"type":"string","sensitive":true},"S24":{"type":"list","member":{"shape":"S1d"}},"S28":{"type":"list","member":{"shape":"S29"}},"S29":{"type":"structure","members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S2x":{"type":"map","key":{},"value":{}},"S30":{"type":"structure","members":{"Enabled":{"type":"boolean"},"PreferredMfa":{"type":"boolean"}}},"S31":{"type":"structure","members":{"Enabled":{"type":"boolean"},"PreferredMfa":{"type":"boolean"}}},"S3p":{"type":"string","sensitive":true},"S3r":{"type":"structure","members":{"EncodedData":{}}},"S40":{"type":"map","key":{},"value":{}},"S41":{"type":"map","key":{},"value":{}},"S43":{"type":"list","member":{}},"S46":{"type":"structure","members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S40"},"AttributeMapping":{"shape":"S41"},"IdpIdentifiers":{"shape":"S43"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S4a":{"type":"list","member":{"type":"structure","required":["ScopeName","ScopeDescription"],"members":{"ScopeName":{},"ScopeDescription":{}}}},"S4f":{"type":"structure","members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4a"}}},"S4j":{"type":"structure","members":{"JobName":{},"JobId":{},"UserPoolId":{},"PreSignedUrl":{},"CreationDate":{"type":"timestamp"},"StartDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"Status":{},"CloudWatchLogsRoleArn":{},"ImportedUsers":{"type":"long"},"SkippedUsers":{"type":"long"},"FailedUsers":{"type":"long"},"CompletionMessage":{}}},"S4r":{"type":"structure","members":{"PasswordPolicy":{"type":"structure","members":{"MinimumLength":{"type":"integer"},"RequireUppercase":{"type":"boolean"},"RequireLowercase":{"type":"boolean"},"RequireNumbers":{"type":"boolean"},"RequireSymbols":{"type":"boolean"}}}}},"S4u":{"type":"structure","members":{"PreSignUp":{},"CustomMessage":{},"PostConfirmation":{},"PreAuthentication":{},"PostAuthentication":{},"DefineAuthChallenge":{},"CreateAuthChallenge":{},"VerifyAuthChallengeResponse":{},"PreTokenGeneration":{},"UserMigration":{}}},"S4v":{"type":"list","member":{}},"S4x":{"type":"list","member":{}},"S4z":{"type":"list","member":{}},"S54":{"type":"structure","members":{"SmsMessage":{},"EmailMessage":{},"EmailSubject":{},"EmailMessageByLink":{},"EmailSubjectByLink":{},"DefaultEmailOption":{}}},"S59":{"type":"structure","members":{"ChallengeRequiredOnNewDevice":{"type":"boolean"},"DeviceOnlyRememberedOnUserPrompt":{"type":"boolean"}}},"S5a":{"type":"structure","members":{"SourceArn":{},"ReplyToEmailAddress":{}}},"S5c":{"type":"structure","required":["SnsCallerArn"],"members":{"SnsCallerArn":{},"ExternalId":{}}},"S5d":{"type":"map","key":{},"value":{}},"S5e":{"type":"structure","members":{"AllowAdminCreateUserOnly":{"type":"boolean"},"UnusedAccountValidityDays":{"type":"integer"},"InviteMessageTemplate":{"type":"structure","members":{"SMSMessage":{},"EmailMessage":{},"EmailSubject":{}}}}},"S5h":{"type":"list","member":{"shape":"S4"}},"S5i":{"type":"structure","required":["AdvancedSecurityMode"],"members":{"AdvancedSecurityMode":{}}},"S5l":{"type":"structure","members":{"Id":{},"Name":{},"Policies":{"shape":"S4r"},"LambdaConfig":{"shape":"S4u"},"Status":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"SchemaAttributes":{"shape":"S5h"},"AutoVerifiedAttributes":{"shape":"S4v"},"AliasAttributes":{"shape":"S4x"},"UsernameAttributes":{"shape":"S4z"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S54"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S59"},"EstimatedNumberOfUsers":{"type":"integer"},"EmailConfiguration":{"shape":"S5a"},"SmsConfiguration":{"shape":"S5c"},"UserPoolTags":{"shape":"S5d"},"SmsConfigurationFailure":{},"EmailConfigurationFailure":{},"Domain":{},"AdminCreateUserConfig":{"shape":"S5e"},"UserPoolAddOns":{"shape":"S5i"}}},"S5s":{"type":"list","member":{}},"S5u":{"type":"list","member":{}},"S5w":{"type":"list","member":{}},"S5x":{"type":"list","member":{}},"S5z":{"type":"list","member":{}},"S60":{"type":"list","member":{}},"S62":{"type":"list","member":{}},"S64":{"type":"structure","required":["ApplicationId","RoleArn","ExternalId"],"members":{"ApplicationId":{},"RoleArn":{},"ExternalId":{},"UserDataShared":{"type":"boolean"}}},"S67":{"type":"structure","members":{"UserPoolId":{},"ClientName":{},"ClientId":{"shape":"S1i"},"ClientSecret":{"type":"string","sensitive":true},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S5s"},"WriteAttributes":{"shape":"S5s"},"ExplicitAuthFlows":{"shape":"S5u"},"SupportedIdentityProviders":{"shape":"S5w"},"CallbackURLs":{"shape":"S5x"},"LogoutURLs":{"shape":"S5z"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S60"},"AllowedOAuthScopes":{"shape":"S62"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S64"}}},"S6r":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"CompromisedCredentialsRiskConfiguration":{"shape":"S6s"},"AccountTakeoverRiskConfiguration":{"shape":"S6x"},"RiskExceptionConfiguration":{"shape":"S76"},"LastModifiedDate":{"type":"timestamp"}}},"S6s":{"type":"structure","required":["Actions"],"members":{"EventFilter":{"type":"list","member":{}},"Actions":{"type":"structure","required":["EventAction"],"members":{"EventAction":{}}}}},"S6x":{"type":"structure","required":["Actions"],"members":{"NotifyConfiguration":{"type":"structure","required":["SourceArn"],"members":{"From":{},"ReplyTo":{},"SourceArn":{},"BlockEmail":{"shape":"S6z"},"NoActionEmail":{"shape":"S6z"},"MfaEmail":{"shape":"S6z"}}},"Actions":{"type":"structure","members":{"LowAction":{"shape":"S73"},"MediumAction":{"shape":"S73"},"HighAction":{"shape":"S73"}}}}},"S6z":{"type":"structure","required":["Subject"],"members":{"Subject":{},"HtmlBody":{},"TextBody":{}}},"S73":{"type":"structure","required":["Notify","EventAction"],"members":{"Notify":{"type":"boolean"},"EventAction":{}}},"S76":{"type":"structure","members":{"BlockedIPRangeList":{"type":"list","member":{}},"SkippedIPRangeList":{"type":"list","member":{}}}},"S7p":{"type":"structure","members":{"Destination":{},"DeliveryMedium":{},"AttributeName":{}}},"S83":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"ImageUrl":{},"CSS":{},"CSSVersion":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S8d":{"type":"structure","members":{"SmsAuthenticationMessage":{},"SmsConfiguration":{"shape":"S5c"}}},"S8e":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"S9e":{"type":"list","member":{"shape":"Ss"}}}}

/***/ }),
/* 2781 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 2782 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cognitosync'] = {};
AWS.CognitoSync = Service.defineService('cognitosync', ['2014-06-30']);
Object.defineProperty(apiLoader.services['cognitosync'], '2014-06-30', {
  get: function get() {
    var model = __webpack_require__(2783);
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CognitoSync;


/***/ }),
/* 2783 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-sync","jsonVersion":"1.1","serviceFullName":"Amazon Cognito Sync","signatureVersion":"v4","protocol":"rest-json","uid":"cognito-sync-2014-06-30"},"operations":{"BulkPublish":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/bulkpublish","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolId":{}}}},"DeleteDataset":{"http":{"method":"DELETE","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"}}},"output":{"type":"structure","members":{"Dataset":{"shape":"S8"}}}},"DescribeDataset":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"}}},"output":{"type":"structure","members":{"Dataset":{"shape":"S8"}}}},"DescribeIdentityPoolUsage":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolUsage":{"shape":"Sg"}}}},"DescribeIdentityUsage":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"}}},"output":{"type":"structure","members":{"IdentityUsage":{"type":"structure","members":{"IdentityId":{},"IdentityPoolId":{},"LastModifiedDate":{"type":"timestamp"},"DatasetCount":{"type":"integer"},"DataStorage":{"type":"long"}}}}}},"GetBulkPublishDetails":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/getBulkPublishDetails","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"BulkPublishStartTime":{"type":"timestamp"},"BulkPublishCompleteTime":{"type":"timestamp"},"BulkPublishStatus":{},"FailureMessage":{}}}},"GetCognitoEvents":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/events","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"Events":{"shape":"Sq"}}}},"GetIdentityPoolConfiguration":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/configuration","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"PushSync":{"shape":"Sv"},"CognitoStreams":{"shape":"Sz"}}}},"ListDatasets":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets","responseCode":200},"input":{"type":"structure","required":["IdentityId","IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Datasets":{"type":"list","member":{"shape":"S8"}},"Count":{"type":"integer"},"NextToken":{}}}},"ListIdentityPoolUsage":{"http":{"method":"GET","requestUri":"/identitypools","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"IdentityPoolUsages":{"type":"list","member":{"shape":"Sg"}},"MaxResults":{"type":"integer"},"Count":{"type":"integer"},"NextToken":{}}}},"ListRecords":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/records","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"LastSyncCount":{"location":"querystring","locationName":"lastSyncCount","type":"long"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"SyncSessionToken":{"location":"querystring","locationName":"syncSessionToken"}}},"output":{"type":"structure","members":{"Records":{"shape":"S1c"},"NextToken":{},"Count":{"type":"integer"},"DatasetSyncCount":{"type":"long"},"LastModifiedBy":{},"MergedDatasetNames":{"type":"list","member":{}},"DatasetExists":{"type":"boolean"},"DatasetDeletedAfterRequestedSyncCount":{"type":"boolean"},"SyncSessionToken":{}}}},"RegisterDevice":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/identity/{IdentityId}/device","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","Platform","Token"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"Platform":{},"Token":{}}},"output":{"type":"structure","members":{"DeviceId":{}}}},"SetCognitoEvents":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/events","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","Events"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"Events":{"shape":"Sq"}}}},"SetIdentityPoolConfiguration":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/configuration","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"PushSync":{"shape":"Sv"},"CognitoStreams":{"shape":"Sz"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"PushSync":{"shape":"Sv"},"CognitoStreams":{"shape":"Sz"}}}},"SubscribeToDataset":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName","DeviceId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"DeviceId":{"location":"uri","locationName":"DeviceId"}}},"output":{"type":"structure","members":{}}},"UnsubscribeFromDataset":{"http":{"method":"DELETE","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName","DeviceId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"DeviceId":{"location":"uri","locationName":"DeviceId"}}},"output":{"type":"structure","members":{}}},"UpdateRecords":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName","SyncSessionToken"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"DeviceId":{},"RecordPatches":{"type":"list","member":{"type":"structure","required":["Op","Key","SyncCount"],"members":{"Op":{},"Key":{},"Value":{},"SyncCount":{"type":"long"},"DeviceLastModifiedDate":{"type":"timestamp"}}}},"SyncSessionToken":{},"ClientContext":{"location":"header","locationName":"x-amz-Client-Context"}}},"output":{"type":"structure","members":{"Records":{"shape":"S1c"}}}}},"shapes":{"S8":{"type":"structure","members":{"IdentityId":{},"DatasetName":{},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"},"LastModifiedBy":{},"DataStorage":{"type":"long"},"NumRecords":{"type":"long"}}},"Sg":{"type":"structure","members":{"IdentityPoolId":{},"SyncSessionsCount":{"type":"long"},"DataStorage":{"type":"long"},"LastModifiedDate":{"type":"timestamp"}}},"Sq":{"type":"map","key":{},"value":{}},"Sv":{"type":"structure","members":{"ApplicationArns":{"type":"list","member":{}},"RoleArn":{}}},"Sz":{"type":"structure","members":{"StreamName":{},"RoleArn":{},"StreamingStatus":{}}},"S1c":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"SyncCount":{"type":"long"},"LastModifiedDate":{"type":"timestamp"},"LastModifiedBy":{},"DeviceLastModifiedDate":{"type":"timestamp"}}}}},"examples":{}}

/***/ }),
/* 2784 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['configservice'] = {};
AWS.ConfigService = Service.defineService('configservice', ['2014-11-12']);
Object.defineProperty(apiLoader.services['configservice'], '2014-11-12', {
  get: function get() {
    var model = __webpack_require__(2785);
    model.paginators = __webpack_require__(2786).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ConfigService;


/***/ }),
/* 2785 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-12","endpointPrefix":"config","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Config Service","serviceFullName":"AWS Config","signatureVersion":"v4","targetPrefix":"StarlingDoveService","uid":"config-2014-11-12"},"operations":{"DeleteConfigRule":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{}}}},"DeleteConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorderName"],"members":{"ConfigurationRecorderName":{}}}},"DeleteDeliveryChannel":{"input":{"type":"structure","required":["DeliveryChannelName"],"members":{"DeliveryChannelName":{}}}},"DeleteEvaluationResults":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{}}},"output":{"type":"structure","members":{}}},"DeliverConfigSnapshot":{"input":{"type":"structure","required":["deliveryChannelName"],"members":{"deliveryChannelName":{}}},"output":{"type":"structure","members":{"configSnapshotId":{}}}},"DescribeComplianceByConfigRule":{"input":{"type":"structure","members":{"ConfigRuleNames":{"shape":"Sd"},"ComplianceTypes":{"shape":"Se"},"NextToken":{}}},"output":{"type":"structure","members":{"ComplianceByConfigRules":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"Compliance":{"shape":"Sj"}}}},"NextToken":{}}}},"DescribeComplianceByResource":{"input":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"ComplianceTypes":{"shape":"Se"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ComplianceByResources":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"Compliance":{"shape":"Sj"}}}},"NextToken":{}}}},"DescribeConfigRuleEvaluationStatus":{"input":{"type":"structure","members":{"ConfigRuleNames":{"shape":"Sd"},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ConfigRulesEvaluationStatus":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"ConfigRuleArn":{},"ConfigRuleId":{},"LastSuccessfulInvocationTime":{"type":"timestamp"},"LastFailedInvocationTime":{"type":"timestamp"},"LastSuccessfulEvaluationTime":{"type":"timestamp"},"LastFailedEvaluationTime":{"type":"timestamp"},"FirstActivatedTime":{"type":"timestamp"},"LastErrorCode":{},"LastErrorMessage":{},"FirstEvaluationStarted":{"type":"boolean"}}}},"NextToken":{}}}},"DescribeConfigRules":{"input":{"type":"structure","members":{"ConfigRuleNames":{"shape":"Sd"},"NextToken":{}}},"output":{"type":"structure","members":{"ConfigRules":{"type":"list","member":{"shape":"S14"}},"NextToken":{}}}},"DescribeConfigurationRecorderStatus":{"input":{"type":"structure","members":{"ConfigurationRecorderNames":{"shape":"S1j"}}},"output":{"type":"structure","members":{"ConfigurationRecordersStatus":{"type":"list","member":{"type":"structure","members":{"name":{},"lastStartTime":{"type":"timestamp"},"lastStopTime":{"type":"timestamp"},"recording":{"type":"boolean"},"lastStatus":{},"lastErrorCode":{},"lastErrorMessage":{},"lastStatusChangeTime":{"type":"timestamp"}}}}}}},"DescribeConfigurationRecorders":{"input":{"type":"structure","members":{"ConfigurationRecorderNames":{"shape":"S1j"}}},"output":{"type":"structure","members":{"ConfigurationRecorders":{"type":"list","member":{"shape":"S1r"}}}}},"DescribeDeliveryChannelStatus":{"input":{"type":"structure","members":{"DeliveryChannelNames":{"shape":"S1y"}}},"output":{"type":"structure","members":{"DeliveryChannelsStatus":{"type":"list","member":{"type":"structure","members":{"name":{},"configSnapshotDeliveryInfo":{"shape":"S22"},"configHistoryDeliveryInfo":{"shape":"S22"},"configStreamDeliveryInfo":{"type":"structure","members":{"lastStatus":{},"lastErrorCode":{},"lastErrorMessage":{},"lastStatusChangeTime":{"type":"timestamp"}}}}}}}}},"DescribeDeliveryChannels":{"input":{"type":"structure","members":{"DeliveryChannelNames":{"shape":"S1y"}}},"output":{"type":"structure","members":{"DeliveryChannels":{"type":"list","member":{"shape":"S28"}}}}},"GetComplianceDetailsByConfigRule":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{},"ComplianceTypes":{"shape":"Se"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EvaluationResults":{"shape":"S2c"},"NextToken":{}}}},"GetComplianceDetailsByResource":{"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{},"ResourceId":{},"ComplianceTypes":{"shape":"Se"},"NextToken":{}}},"output":{"type":"structure","members":{"EvaluationResults":{"shape":"S2c"},"NextToken":{}}}},"GetComplianceSummaryByConfigRule":{"output":{"type":"structure","members":{"ComplianceSummary":{"shape":"S2j"}}}},"GetComplianceSummaryByResourceType":{"input":{"type":"structure","members":{"ResourceTypes":{"shape":"S2l"}}},"output":{"type":"structure","members":{"ComplianceSummariesByResourceType":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ComplianceSummary":{"shape":"S2j"}}}}}}},"GetDiscoveredResourceCounts":{"input":{"type":"structure","members":{"resourceTypes":{"shape":"S2l"},"limit":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"totalDiscoveredResources":{"type":"long"},"resourceCounts":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"count":{"type":"long"}}}},"nextToken":{}}}},"GetResourceConfigHistory":{"input":{"type":"structure","required":["resourceType","resourceId"],"members":{"resourceType":{},"resourceId":{},"laterTime":{"type":"timestamp"},"earlierTime":{"type":"timestamp"},"chronologicalOrder":{},"limit":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"configurationItems":{"type":"list","member":{"type":"structure","members":{"version":{},"accountId":{},"configurationItemCaptureTime":{"type":"timestamp"},"configurationItemStatus":{},"configurationStateId":{},"configurationItemMD5Hash":{},"arn":{},"resourceType":{},"resourceId":{},"resourceName":{},"awsRegion":{},"availabilityZone":{},"resourceCreationTime":{"type":"timestamp"},"tags":{"type":"map","key":{},"value":{}},"relatedEvents":{"type":"list","member":{}},"relationships":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"resourceId":{},"resourceName":{},"relationshipName":{}}}},"configuration":{},"supplementaryConfiguration":{"type":"map","key":{},"value":{}}}}},"nextToken":{}}}},"ListDiscoveredResources":{"input":{"type":"structure","required":["resourceType"],"members":{"resourceType":{},"resourceIds":{"type":"list","member":{}},"resourceName":{},"limit":{"type":"integer"},"includeDeletedResources":{"type":"boolean"},"nextToken":{}}},"output":{"type":"structure","members":{"resourceIdentifiers":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"resourceId":{},"resourceName":{},"resourceDeletionTime":{"type":"timestamp"}}}},"nextToken":{}}}},"PutConfigRule":{"input":{"type":"structure","required":["ConfigRule"],"members":{"ConfigRule":{"shape":"S14"}}}},"PutConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorder"],"members":{"ConfigurationRecorder":{"shape":"S1r"}}}},"PutDeliveryChannel":{"input":{"type":"structure","required":["DeliveryChannel"],"members":{"DeliveryChannel":{"shape":"S28"}}}},"PutEvaluations":{"input":{"type":"structure","required":["ResultToken"],"members":{"Evaluations":{"shape":"S3z"},"ResultToken":{},"TestMode":{"type":"boolean"}}},"output":{"type":"structure","members":{"FailedEvaluations":{"shape":"S3z"}}}},"StartConfigRulesEvaluation":{"input":{"type":"structure","members":{"ConfigRuleNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"StartConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorderName"],"members":{"ConfigurationRecorderName":{}}}},"StopConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorderName"],"members":{"ConfigurationRecorderName":{}}}}},"shapes":{"Sd":{"type":"list","member":{}},"Se":{"type":"list","member":{}},"Sj":{"type":"structure","members":{"ComplianceType":{},"ComplianceContributorCount":{"shape":"Sk"}}},"Sk":{"type":"structure","members":{"CappedCount":{"type":"integer"},"CapExceeded":{"type":"boolean"}}},"S14":{"type":"structure","required":["Source"],"members":{"ConfigRuleName":{},"ConfigRuleArn":{},"ConfigRuleId":{},"Description":{},"Scope":{"type":"structure","members":{"ComplianceResourceTypes":{"type":"list","member":{}},"TagKey":{},"TagValue":{},"ComplianceResourceId":{}}},"Source":{"type":"structure","required":["Owner","SourceIdentifier"],"members":{"Owner":{},"SourceIdentifier":{},"SourceDetails":{"type":"list","member":{"type":"structure","members":{"EventSource":{},"MessageType":{},"MaximumExecutionFrequency":{}}}}}},"InputParameters":{},"MaximumExecutionFrequency":{},"ConfigRuleState":{}}},"S1j":{"type":"list","member":{}},"S1r":{"type":"structure","members":{"name":{},"roleARN":{},"recordingGroup":{"type":"structure","members":{"allSupported":{"type":"boolean"},"includeGlobalResourceTypes":{"type":"boolean"},"resourceTypes":{"type":"list","member":{}}}}}},"S1y":{"type":"list","member":{}},"S22":{"type":"structure","members":{"lastStatus":{},"lastErrorCode":{},"lastErrorMessage":{},"lastAttemptTime":{"type":"timestamp"},"lastSuccessfulTime":{"type":"timestamp"},"nextDeliveryTime":{"type":"timestamp"}}},"S28":{"type":"structure","members":{"name":{},"s3BucketName":{},"s3KeyPrefix":{},"snsTopicARN":{},"configSnapshotDeliveryProperties":{"type":"structure","members":{"deliveryFrequency":{}}}}},"S2c":{"type":"list","member":{"type":"structure","members":{"EvaluationResultIdentifier":{"type":"structure","members":{"EvaluationResultQualifier":{"type":"structure","members":{"ConfigRuleName":{},"ResourceType":{},"ResourceId":{}}},"OrderingTimestamp":{"type":"timestamp"}}},"ComplianceType":{},"ResultRecordedTime":{"type":"timestamp"},"ConfigRuleInvokedTime":{"type":"timestamp"},"Annotation":{},"ResultToken":{}}}},"S2j":{"type":"structure","members":{"CompliantResourceCount":{"shape":"Sk"},"NonCompliantResourceCount":{"shape":"Sk"},"ComplianceSummaryTimestamp":{"type":"timestamp"}}},"S2l":{"type":"list","member":{}},"S3z":{"type":"list","member":{"type":"structure","required":["ComplianceResourceType","ComplianceResourceId","ComplianceType","OrderingTimestamp"],"members":{"ComplianceResourceType":{},"ComplianceResourceId":{},"ComplianceType":{},"Annotation":{},"OrderingTimestamp":{"type":"timestamp"}}}}}}

/***/ }),
/* 2786 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetResourceConfigHistory":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"configurationItems"}}}

/***/ }),
/* 2787 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cur'] = {};
AWS.CUR = Service.defineService('cur', ['2017-01-06']);
Object.defineProperty(apiLoader.services['cur'], '2017-01-06', {
  get: function get() {
    var model = __webpack_require__(2788);
    model.paginators = __webpack_require__(2789).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CUR;


/***/ }),
/* 2788 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-01-06","endpointPrefix":"cur","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Cost and Usage Report Service","signatureVersion":"v4","signingName":"cur","targetPrefix":"AWSOrigamiServiceGatewayService","uid":"cur-2017-01-06"},"operations":{"DeleteReportDefinition":{"input":{"type":"structure","members":{"ReportName":{}}},"output":{"type":"structure","members":{"ResponseMessage":{}}}},"DescribeReportDefinitions":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ReportDefinitions":{"type":"list","member":{"shape":"Sa"}},"NextToken":{}}}},"PutReportDefinition":{"input":{"type":"structure","required":["ReportDefinition"],"members":{"ReportDefinition":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sa":{"type":"structure","required":["ReportName","TimeUnit","Format","Compression","AdditionalSchemaElements","S3Bucket","S3Prefix","S3Region"],"members":{"ReportName":{},"TimeUnit":{},"Format":{},"Compression":{},"AdditionalSchemaElements":{"type":"list","member":{}},"S3Bucket":{},"S3Prefix":{},"S3Region":{},"AdditionalArtifacts":{"type":"list","member":{}}}}}}

/***/ }),
/* 2789 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeReportDefinitions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 2790 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['devicefarm'] = {};
AWS.DeviceFarm = Service.defineService('devicefarm', ['2015-06-23']);
Object.defineProperty(apiLoader.services['devicefarm'], '2015-06-23', {
  get: function get() {
    var model = __webpack_require__(2791);
    model.paginators = __webpack_require__(2792).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.DeviceFarm;


/***/ }),
/* 2791 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-06-23","endpointPrefix":"devicefarm","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Device Farm","signatureVersion":"v4","targetPrefix":"DeviceFarm_20150623","uid":"devicefarm-2015-06-23"},"operations":{"CreateDevicePool":{"input":{"type":"structure","required":["projectArn","name","rules"],"members":{"projectArn":{},"name":{},"description":{},"rules":{"shape":"S5"}}},"output":{"type":"structure","members":{"devicePool":{"shape":"Sb"}}}},"CreateNetworkProfile":{"input":{"type":"structure","required":["projectArn","name"],"members":{"projectArn":{},"name":{},"description":{},"type":{},"uplinkBandwidthBits":{"type":"long"},"downlinkBandwidthBits":{"type":"long"},"uplinkDelayMs":{"type":"long"},"downlinkDelayMs":{"type":"long"},"uplinkJitterMs":{"type":"long"},"downlinkJitterMs":{"type":"long"},"uplinkLossPercent":{"type":"integer"},"downlinkLossPercent":{"type":"integer"}}},"output":{"type":"structure","members":{"networkProfile":{"shape":"Si"}}}},"CreateProject":{"input":{"type":"structure","required":["name"],"members":{"name":{},"defaultJobTimeoutMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"project":{"shape":"Sm"}}}},"CreateRemoteAccessSession":{"input":{"type":"structure","required":["projectArn","deviceArn"],"members":{"projectArn":{},"deviceArn":{},"sshPublicKey":{},"remoteDebugEnabled":{"type":"boolean"},"remoteRecordEnabled":{"type":"boolean"},"remoteRecordAppArn":{},"name":{},"clientId":{},"configuration":{"type":"structure","members":{"billingMethod":{}}},"interactionMode":{}}},"output":{"type":"structure","members":{"remoteAccessSession":{"shape":"Sw"}}}},"CreateUpload":{"input":{"type":"structure","required":["projectArn","name","type"],"members":{"projectArn":{},"name":{},"type":{},"contentType":{}}},"output":{"type":"structure","members":{"upload":{"shape":"S1c"}}}},"DeleteDevicePool":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteNetworkProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteProject":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteRemoteAccessSession":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteRun":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteUpload":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"GetAccountSettings":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"accountSettings":{"type":"structure","members":{"awsAccountNumber":{},"unmeteredDevices":{"shape":"S1w"},"unmeteredRemoteAccessDevices":{"shape":"S1w"},"maxJobTimeoutMinutes":{"type":"integer"},"trialMinutes":{"type":"structure","members":{"total":{"type":"double"},"remaining":{"type":"double"}}},"maxSlots":{"type":"map","key":{},"value":{"type":"integer"}},"defaultJobTimeoutMinutes":{"type":"integer"}}}}}},"GetDevice":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"device":{"shape":"Sz"}}}},"GetDevicePool":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"devicePool":{"shape":"Sb"}}}},"GetDevicePoolCompatibility":{"input":{"type":"structure","required":["devicePoolArn"],"members":{"devicePoolArn":{},"appArn":{},"testType":{},"test":{"shape":"S25"}}},"output":{"type":"structure","members":{"compatibleDevices":{"shape":"S29"},"incompatibleDevices":{"shape":"S29"}}}},"GetJob":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"job":{"shape":"S2f"}}}},"GetNetworkProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"networkProfile":{"shape":"Si"}}}},"GetOfferingStatus":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"current":{"shape":"S2m"},"nextPeriod":{"shape":"S2m"},"nextToken":{}}}},"GetProject":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"project":{"shape":"Sm"}}}},"GetRemoteAccessSession":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"remoteAccessSession":{"shape":"Sw"}}}},"GetRun":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"run":{"shape":"S33"}}}},"GetSuite":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"suite":{"shape":"S3d"}}}},"GetTest":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"test":{"shape":"S3g"}}}},"GetUpload":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"upload":{"shape":"S1c"}}}},"InstallToRemoteAccessSession":{"input":{"type":"structure","required":["remoteAccessSessionArn","appArn"],"members":{"remoteAccessSessionArn":{},"appArn":{}}},"output":{"type":"structure","members":{"appUpload":{"shape":"S1c"}}}},"ListArtifacts":{"input":{"type":"structure","required":["arn","type"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"artifacts":{"type":"list","member":{"type":"structure","members":{"arn":{},"name":{},"type":{},"extension":{},"url":{}}}},"nextToken":{}}}},"ListDevicePools":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"devicePools":{"type":"list","member":{"shape":"Sb"}},"nextToken":{}}}},"ListDevices":{"input":{"type":"structure","members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"devices":{"type":"list","member":{"shape":"Sz"}},"nextToken":{}}}},"ListJobs":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"shape":"S2f"}},"nextToken":{}}}},"ListNetworkProfiles":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"networkProfiles":{"type":"list","member":{"shape":"Si"}},"nextToken":{}}}},"ListOfferingPromotions":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"offeringPromotions":{"type":"list","member":{"type":"structure","members":{"id":{},"description":{}}}},"nextToken":{}}}},"ListOfferingTransactions":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"offeringTransactions":{"type":"list","member":{"shape":"S4b"}},"nextToken":{}}}},"ListOfferings":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"offerings":{"type":"list","member":{"shape":"S2q"}},"nextToken":{}}}},"ListProjects":{"input":{"type":"structure","members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"projects":{"type":"list","member":{"shape":"Sm"}},"nextToken":{}}}},"ListRemoteAccessSessions":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"remoteAccessSessions":{"type":"list","member":{"shape":"Sw"}},"nextToken":{}}}},"ListRuns":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"runs":{"type":"list","member":{"shape":"S33"}},"nextToken":{}}}},"ListSamples":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"samples":{"type":"list","member":{"type":"structure","members":{"arn":{},"type":{},"url":{}}}},"nextToken":{}}}},"ListSuites":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"suites":{"type":"list","member":{"shape":"S3d"}},"nextToken":{}}}},"ListTests":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"tests":{"type":"list","member":{"shape":"S3g"}},"nextToken":{}}}},"ListUniqueProblems":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"uniqueProblems":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"message":{},"problems":{"type":"list","member":{"type":"structure","members":{"run":{"shape":"S57"},"job":{"shape":"S57"},"suite":{"shape":"S57"},"test":{"shape":"S57"},"device":{"shape":"Sz"},"result":{},"message":{}}}}}}}},"nextToken":{}}}},"ListUploads":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"uploads":{"type":"list","member":{"shape":"S1c"}},"nextToken":{}}}},"PurchaseOffering":{"input":{"type":"structure","members":{"offeringId":{},"quantity":{"type":"integer"},"offeringPromotionId":{}}},"output":{"type":"structure","members":{"offeringTransaction":{"shape":"S4b"}}}},"RenewOffering":{"input":{"type":"structure","members":{"offeringId":{},"quantity":{"type":"integer"}}},"output":{"type":"structure","members":{"offeringTransaction":{"shape":"S4b"}}}},"ScheduleRun":{"input":{"type":"structure","required":["projectArn","devicePoolArn","test"],"members":{"projectArn":{},"appArn":{},"devicePoolArn":{},"name":{},"test":{"shape":"S25"},"configuration":{"type":"structure","members":{"extraDataPackageArn":{},"networkProfileArn":{},"locale":{},"location":{"shape":"S36"},"customerArtifactPaths":{"shape":"S37"},"radios":{"shape":"S35"},"auxiliaryApps":{"type":"list","member":{}},"billingMethod":{}}},"executionConfiguration":{"type":"structure","members":{"jobTimeoutMinutes":{"type":"integer"},"accountsCleanup":{"type":"boolean"},"appPackagesCleanup":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"run":{"shape":"S33"}}}},"StopRemoteAccessSession":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"remoteAccessSession":{"shape":"Sw"}}}},"StopRun":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"run":{"shape":"S33"}}}},"UpdateDevicePool":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"description":{},"rules":{"shape":"S5"}}},"output":{"type":"structure","members":{"devicePool":{"shape":"Sb"}}}},"UpdateNetworkProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"description":{},"type":{},"uplinkBandwidthBits":{"type":"long"},"downlinkBandwidthBits":{"type":"long"},"uplinkDelayMs":{"type":"long"},"downlinkDelayMs":{"type":"long"},"uplinkJitterMs":{"type":"long"},"downlinkJitterMs":{"type":"long"},"uplinkLossPercent":{"type":"integer"},"downlinkLossPercent":{"type":"integer"}}},"output":{"type":"structure","members":{"networkProfile":{"shape":"Si"}}}},"UpdateProject":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"defaultJobTimeoutMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"project":{"shape":"Sm"}}}}},"shapes":{"S5":{"type":"list","member":{"type":"structure","members":{"attribute":{},"operator":{},"value":{}}}},"Sb":{"type":"structure","members":{"arn":{},"name":{},"description":{},"type":{},"rules":{"shape":"S5"}}},"Si":{"type":"structure","members":{"arn":{},"name":{},"description":{},"type":{},"uplinkBandwidthBits":{"type":"long"},"downlinkBandwidthBits":{"type":"long"},"uplinkDelayMs":{"type":"long"},"downlinkDelayMs":{"type":"long"},"uplinkJitterMs":{"type":"long"},"downlinkJitterMs":{"type":"long"},"uplinkLossPercent":{"type":"integer"},"downlinkLossPercent":{"type":"integer"}}},"Sm":{"type":"structure","members":{"arn":{},"name":{},"defaultJobTimeoutMinutes":{"type":"integer"},"created":{"type":"timestamp"}}},"Sw":{"type":"structure","members":{"arn":{},"name":{},"created":{"type":"timestamp"},"status":{},"result":{},"message":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"device":{"shape":"Sz"},"remoteDebugEnabled":{"type":"boolean"},"remoteRecordEnabled":{"type":"boolean"},"remoteRecordAppArn":{},"hostAddress":{},"clientId":{},"billingMethod":{},"deviceMinutes":{"shape":"S17"},"endpoint":{},"deviceUdid":{},"interactionMode":{}}},"Sz":{"type":"structure","members":{"arn":{},"name":{},"manufacturer":{},"model":{},"modelId":{},"formFactor":{},"platform":{},"os":{},"cpu":{"type":"structure","members":{"frequency":{},"architecture":{},"clock":{"type":"double"}}},"resolution":{"type":"structure","members":{"width":{"type":"integer"},"height":{"type":"integer"}}},"heapSize":{"type":"long"},"memory":{"type":"long"},"image":{},"carrier":{},"radio":{},"remoteAccessEnabled":{"type":"boolean"},"remoteDebugEnabled":{"type":"boolean"},"fleetType":{},"fleetName":{}}},"S17":{"type":"structure","members":{"total":{"type":"double"},"metered":{"type":"double"},"unmetered":{"type":"double"}}},"S1c":{"type":"structure","members":{"arn":{},"name":{},"created":{"type":"timestamp"},"type":{},"status":{},"url":{},"metadata":{},"contentType":{},"message":{}}},"S1w":{"type":"map","key":{},"value":{"type":"integer"}},"S25":{"type":"structure","required":["type"],"members":{"type":{},"testPackageArn":{},"filter":{},"parameters":{"type":"map","key":{},"value":{}}}},"S29":{"type":"list","member":{"type":"structure","members":{"device":{"shape":"Sz"},"compatible":{"type":"boolean"},"incompatibilityMessages":{"type":"list","member":{"type":"structure","members":{"message":{},"type":{}}}}}}},"S2f":{"type":"structure","members":{"arn":{},"name":{},"type":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S2g"},"message":{},"device":{"shape":"Sz"},"deviceMinutes":{"shape":"S17"}}},"S2g":{"type":"structure","members":{"total":{"type":"integer"},"passed":{"type":"integer"},"failed":{"type":"integer"},"warned":{"type":"integer"},"errored":{"type":"integer"},"stopped":{"type":"integer"},"skipped":{"type":"integer"}}},"S2m":{"type":"map","key":{},"value":{"shape":"S2o"}},"S2o":{"type":"structure","members":{"type":{},"offering":{"shape":"S2q"},"quantity":{"type":"integer"},"effectiveOn":{"type":"timestamp"}}},"S2q":{"type":"structure","members":{"id":{},"description":{},"type":{},"platform":{},"recurringCharges":{"type":"list","member":{"type":"structure","members":{"cost":{"shape":"S2u"},"frequency":{}}}}}},"S2u":{"type":"structure","members":{"amount":{"type":"double"},"currencyCode":{}}},"S33":{"type":"structure","members":{"arn":{},"name":{},"type":{},"platform":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S2g"},"message":{},"totalJobs":{"type":"integer"},"completedJobs":{"type":"integer"},"billingMethod":{},"deviceMinutes":{"shape":"S17"},"networkProfile":{"shape":"Si"},"parsingResultUrl":{},"resultCode":{},"seed":{"type":"integer"},"appUpload":{},"eventCount":{"type":"integer"},"jobTimeoutMinutes":{"type":"integer"},"devicePoolArn":{},"locale":{},"radios":{"shape":"S35"},"location":{"shape":"S36"},"customerArtifactPaths":{"shape":"S37"},"webUrl":{}}},"S35":{"type":"structure","members":{"wifi":{"type":"boolean"},"bluetooth":{"type":"boolean"},"nfc":{"type":"boolean"},"gps":{"type":"boolean"}}},"S36":{"type":"structure","required":["latitude","longitude"],"members":{"latitude":{"type":"double"},"longitude":{"type":"double"}}},"S37":{"type":"structure","members":{"iosPaths":{"type":"list","member":{}},"androidPaths":{"type":"list","member":{}},"deviceHostPaths":{"type":"list","member":{}}}},"S3d":{"type":"structure","members":{"arn":{},"name":{},"type":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S2g"},"message":{},"deviceMinutes":{"shape":"S17"}}},"S3g":{"type":"structure","members":{"arn":{},"name":{},"type":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S2g"},"message":{},"deviceMinutes":{"shape":"S17"}}},"S4b":{"type":"structure","members":{"offeringStatus":{"shape":"S2o"},"transactionId":{},"offeringPromotionId":{},"createdOn":{"type":"timestamp"},"cost":{"shape":"S2u"}}},"S57":{"type":"structure","members":{"arn":{},"name":{}}}}}

/***/ }),
/* 2792 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetOfferingStatus":{"input_token":"nextToken","output_token":"nextToken","result_key":["current","nextPeriod"]},"ListArtifacts":{"input_token":"nextToken","output_token":"nextToken","result_key":"artifacts"},"ListDevicePools":{"input_token":"nextToken","output_token":"nextToken","result_key":"devicePools"},"ListDevices":{"input_token":"nextToken","output_token":"nextToken","result_key":"devices"},"ListJobs":{"input_token":"nextToken","output_token":"nextToken","result_key":"jobs"},"ListOfferingTransactions":{"input_token":"nextToken","output_token":"nextToken","result_key":"offeringTransactions"},"ListOfferings":{"input_token":"nextToken","output_token":"nextToken","result_key":"offerings"},"ListProjects":{"input_token":"nextToken","output_token":"nextToken","result_key":"projects"},"ListRuns":{"input_token":"nextToken","output_token":"nextToken","result_key":"runs"},"ListSamples":{"input_token":"nextToken","output_token":"nextToken","result_key":"samples"},"ListSuites":{"input_token":"nextToken","output_token":"nextToken","result_key":"suites"},"ListTests":{"input_token":"nextToken","output_token":"nextToken","result_key":"tests"},"ListUniqueProblems":{"input_token":"nextToken","output_token":"nextToken","result_key":"uniqueProblems"},"ListUploads":{"input_token":"nextToken","output_token":"nextToken","result_key":"uploads"}}}

/***/ }),
/* 2793 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['directconnect'] = {};
AWS.DirectConnect = Service.defineService('directconnect', ['2012-10-25']);
Object.defineProperty(apiLoader.services['directconnect'], '2012-10-25', {
  get: function get() {
    var model = __webpack_require__(2794);
    model.paginators = __webpack_require__(2795).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.DirectConnect;


/***/ }),
/* 2794 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-10-25","endpointPrefix":"directconnect","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Direct Connect","signatureVersion":"v4","targetPrefix":"OvertureService","uid":"directconnect-2012-10-25"},"operations":{"AllocateConnectionOnInterconnect":{"input":{"type":"structure","required":["bandwidth","connectionName","ownerAccount","interconnectId","vlan"],"members":{"bandwidth":{},"connectionName":{},"ownerAccount":{},"interconnectId":{},"vlan":{"type":"integer"}}},"output":{"shape":"S7"},"deprecated":true},"AllocateHostedConnection":{"input":{"type":"structure","required":["connectionId","ownerAccount","bandwidth","connectionName","vlan"],"members":{"connectionId":{},"ownerAccount":{},"bandwidth":{},"connectionName":{},"vlan":{"type":"integer"}}},"output":{"shape":"S7"}},"AllocatePrivateVirtualInterface":{"input":{"type":"structure","required":["connectionId","ownerAccount","newPrivateVirtualInterfaceAllocation"],"members":{"connectionId":{},"ownerAccount":{},"newPrivateVirtualInterfaceAllocation":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"authKey":{},"amazonAddress":{},"addressFamily":{},"customerAddress":{}}}}},"output":{"shape":"Sp"}},"AllocatePublicVirtualInterface":{"input":{"type":"structure","required":["connectionId","ownerAccount","newPublicVirtualInterfaceAllocation"],"members":{"connectionId":{},"ownerAccount":{},"newPublicVirtualInterfaceAllocation":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"routeFilterPrefixes":{"shape":"Sx"}}}}},"output":{"shape":"Sp"}},"AssociateConnectionWithLag":{"input":{"type":"structure","required":["connectionId","lagId"],"members":{"connectionId":{},"lagId":{}}},"output":{"shape":"S7"}},"AssociateHostedConnection":{"input":{"type":"structure","required":["connectionId","parentConnectionId"],"members":{"connectionId":{},"parentConnectionId":{}}},"output":{"shape":"S7"}},"AssociateVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId","connectionId"],"members":{"virtualInterfaceId":{},"connectionId":{}}},"output":{"shape":"Sp"}},"ConfirmConnection":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{}}},"output":{"type":"structure","members":{"connectionState":{}}}},"ConfirmPrivateVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{},"virtualGatewayId":{},"directConnectGatewayId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"ConfirmPublicVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"CreateBGPPeer":{"input":{"type":"structure","members":{"virtualInterfaceId":{},"newBGPPeer":{"type":"structure","members":{"asn":{"type":"integer"},"authKey":{},"addressFamily":{},"amazonAddress":{},"customerAddress":{}}}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"Sp"}}}},"CreateConnection":{"input":{"type":"structure","required":["location","bandwidth","connectionName"],"members":{"location":{},"bandwidth":{},"connectionName":{},"lagId":{}}},"output":{"shape":"S7"}},"CreateDirectConnectGateway":{"input":{"type":"structure","required":["directConnectGatewayName"],"members":{"directConnectGatewayName":{},"amazonSideAsn":{"type":"long"}}},"output":{"type":"structure","members":{"directConnectGateway":{"shape":"S1m"}}}},"CreateDirectConnectGatewayAssociation":{"input":{"type":"structure","required":["directConnectGatewayId","virtualGatewayId"],"members":{"directConnectGatewayId":{},"virtualGatewayId":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociation":{"shape":"S1r"}}}},"CreateInterconnect":{"input":{"type":"structure","required":["interconnectName","bandwidth","location"],"members":{"interconnectName":{},"bandwidth":{},"location":{},"lagId":{}}},"output":{"shape":"S1w"}},"CreateLag":{"input":{"type":"structure","required":["numberOfConnections","location","connectionsBandwidth","lagName"],"members":{"numberOfConnections":{"type":"integer"},"location":{},"connectionsBandwidth":{},"lagName":{},"connectionId":{}}},"output":{"shape":"S21"}},"CreatePrivateVirtualInterface":{"input":{"type":"structure","required":["connectionId","newPrivateVirtualInterface"],"members":{"connectionId":{},"newPrivateVirtualInterface":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"virtualGatewayId":{},"directConnectGatewayId":{}}}}},"output":{"shape":"Sp"}},"CreatePublicVirtualInterface":{"input":{"type":"structure","required":["connectionId","newPublicVirtualInterface"],"members":{"connectionId":{},"newPublicVirtualInterface":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"routeFilterPrefixes":{"shape":"Sx"}}}}},"output":{"shape":"Sp"}},"DeleteBGPPeer":{"input":{"type":"structure","members":{"virtualInterfaceId":{},"asn":{"type":"integer"},"customerAddress":{}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"Sp"}}}},"DeleteConnection":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{}}},"output":{"shape":"S7"}},"DeleteDirectConnectGateway":{"input":{"type":"structure","required":["directConnectGatewayId"],"members":{"directConnectGatewayId":{}}},"output":{"type":"structure","members":{"directConnectGateway":{"shape":"S1m"}}}},"DeleteDirectConnectGatewayAssociation":{"input":{"type":"structure","required":["directConnectGatewayId","virtualGatewayId"],"members":{"directConnectGatewayId":{},"virtualGatewayId":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociation":{"shape":"S1r"}}}},"DeleteInterconnect":{"input":{"type":"structure","required":["interconnectId"],"members":{"interconnectId":{}}},"output":{"type":"structure","members":{"interconnectState":{}}}},"DeleteLag":{"input":{"type":"structure","required":["lagId"],"members":{"lagId":{}}},"output":{"shape":"S21"}},"DeleteVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"DescribeConnectionLoa":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{},"providerName":{},"loaContentType":{}}},"output":{"type":"structure","members":{"loa":{"shape":"S2p"}}},"deprecated":true},"DescribeConnections":{"input":{"type":"structure","members":{"connectionId":{}}},"output":{"shape":"S2s"}},"DescribeConnectionsOnInterconnect":{"input":{"type":"structure","required":["interconnectId"],"members":{"interconnectId":{}}},"output":{"shape":"S2s"},"deprecated":true},"DescribeDirectConnectGatewayAssociations":{"input":{"type":"structure","members":{"directConnectGatewayId":{},"virtualGatewayId":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociations":{"type":"list","member":{"shape":"S1r"}},"nextToken":{}}}},"DescribeDirectConnectGatewayAttachments":{"input":{"type":"structure","members":{"directConnectGatewayId":{},"virtualInterfaceId":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"directConnectGatewayAttachments":{"type":"list","member":{"type":"structure","members":{"directConnectGatewayId":{},"virtualInterfaceId":{},"virtualInterfaceRegion":{},"virtualInterfaceOwnerAccount":{},"attachmentState":{},"stateChangeError":{}}}},"nextToken":{}}}},"DescribeDirectConnectGateways":{"input":{"type":"structure","members":{"directConnectGatewayId":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"directConnectGateways":{"type":"list","member":{"shape":"S1m"}},"nextToken":{}}}},"DescribeHostedConnections":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{}}},"output":{"shape":"S2s"}},"DescribeInterconnectLoa":{"input":{"type":"structure","required":["interconnectId"],"members":{"interconnectId":{},"providerName":{},"loaContentType":{}}},"output":{"type":"structure","members":{"loa":{"shape":"S2p"}}},"deprecated":true},"DescribeInterconnects":{"input":{"type":"structure","members":{"interconnectId":{}}},"output":{"type":"structure","members":{"interconnects":{"type":"list","member":{"shape":"S1w"}}}}},"DescribeLags":{"input":{"type":"structure","members":{"lagId":{}}},"output":{"type":"structure","members":{"lags":{"type":"list","member":{"shape":"S21"}}}}},"DescribeLoa":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{},"providerName":{},"loaContentType":{}}},"output":{"shape":"S2p"}},"DescribeLocations":{"output":{"type":"structure","members":{"locations":{"type":"list","member":{"type":"structure","members":{"locationCode":{},"locationName":{}}}}}}},"DescribeTags":{"input":{"type":"structure","required":["resourceArns"],"members":{"resourceArns":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"resourceTags":{"type":"list","member":{"type":"structure","members":{"resourceArn":{},"tags":{"shape":"S3s"}}}}}}},"DescribeVirtualGateways":{"output":{"type":"structure","members":{"virtualGateways":{"type":"list","member":{"type":"structure","members":{"virtualGatewayId":{},"virtualGatewayState":{}}}}}}},"DescribeVirtualInterfaces":{"input":{"type":"structure","members":{"connectionId":{},"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaces":{"type":"list","member":{"shape":"Sp"}}}}},"DisassociateConnectionFromLag":{"input":{"type":"structure","required":["connectionId","lagId"],"members":{"connectionId":{},"lagId":{}}},"output":{"shape":"S7"}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S3s"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateLag":{"input":{"type":"structure","required":["lagId"],"members":{"lagId":{},"lagName":{},"minimumLinks":{"type":"integer"}}},"output":{"shape":"S21"}}},"shapes":{"S7":{"type":"structure","members":{"ownerAccount":{},"connectionId":{},"connectionName":{},"connectionState":{},"region":{},"location":{},"bandwidth":{},"vlan":{"type":"integer"},"partnerName":{},"loaIssueTime":{"type":"timestamp"},"lagId":{},"awsDevice":{}}},"Sp":{"type":"structure","members":{"ownerAccount":{},"virtualInterfaceId":{},"location":{},"connectionId":{},"virtualInterfaceType":{},"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"amazonSideAsn":{"type":"long"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"virtualInterfaceState":{},"customerRouterConfig":{},"virtualGatewayId":{},"directConnectGatewayId":{},"routeFilterPrefixes":{"shape":"Sx"},"bgpPeers":{"type":"list","member":{"type":"structure","members":{"asn":{"type":"integer"},"authKey":{},"addressFamily":{},"amazonAddress":{},"customerAddress":{},"bgpPeerState":{},"bgpStatus":{}}}}}},"Sx":{"type":"list","member":{"type":"structure","members":{"cidr":{}}}},"S1m":{"type":"structure","members":{"directConnectGatewayId":{},"directConnectGatewayName":{},"amazonSideAsn":{"type":"long"},"ownerAccount":{},"directConnectGatewayState":{},"stateChangeError":{}}},"S1r":{"type":"structure","members":{"directConnectGatewayId":{},"virtualGatewayId":{},"virtualGatewayRegion":{},"virtualGatewayOwnerAccount":{},"associationState":{},"stateChangeError":{}}},"S1w":{"type":"structure","members":{"interconnectId":{},"interconnectName":{},"interconnectState":{},"region":{},"location":{},"bandwidth":{},"loaIssueTime":{"type":"timestamp"},"lagId":{},"awsDevice":{}}},"S21":{"type":"structure","members":{"connectionsBandwidth":{},"numberOfConnections":{"type":"integer"},"lagId":{},"ownerAccount":{},"lagName":{},"lagState":{},"location":{},"region":{},"minimumLinks":{"type":"integer"},"awsDevice":{},"connections":{"shape":"S23"},"allowsHostedConnections":{"type":"boolean"}}},"S23":{"type":"list","member":{"shape":"S7"}},"S2p":{"type":"structure","members":{"loaContent":{"type":"blob"},"loaContentType":{}}},"S2s":{"type":"structure","members":{"connections":{"shape":"S23"}}},"S3s":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}}}}

/***/ }),
/* 2795 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeConnections":{"result_key":"connections"},"DescribeConnectionsOnInterconnect":{"result_key":"connections"},"DescribeInterconnects":{"result_key":"interconnects"},"DescribeLocations":{"result_key":"locations"},"DescribeVirtualGateways":{"result_key":"virtualGateways"},"DescribeVirtualInterfaces":{"result_key":"virtualInterfaces"}}}

/***/ }),
/* 2796 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['dynamodb'] = {};
AWS.DynamoDB = Service.defineService('dynamodb', ['2011-12-05', '2012-08-10']);
__webpack_require__(2797);
Object.defineProperty(apiLoader.services['dynamodb'], '2011-12-05', {
  get: function get() {
    var model = __webpack_require__(2802);
    model.paginators = __webpack_require__(2803).pagination;
    model.waiters = __webpack_require__(2804).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['dynamodb'], '2012-08-10', {
  get: function get() {
    var model = __webpack_require__(2805);
    model.paginators = __webpack_require__(2806).pagination;
    model.waiters = __webpack_require__(2807).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.DynamoDB;


/***/ }),
/* 2797 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
__webpack_require__(2798);

AWS.util.update(AWS.DynamoDB.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    if (request.service.config.dynamoDbCrc32) {
      request.removeListener('extractData', AWS.EventListeners.Json.EXTRACT_DATA);
      request.addListener('extractData', this.checkCrc32);
      request.addListener('extractData', AWS.EventListeners.Json.EXTRACT_DATA);
    }
  },

  /**
   * @api private
   */
  checkCrc32: function checkCrc32(resp) {
    if (!resp.httpResponse.streaming && !resp.request.service.crc32IsValid(resp)) {
      resp.data = null;
      resp.error = AWS.util.error(new Error(), {
        code: 'CRC32CheckFailed',
        message: 'CRC32 integrity check failed',
        retryable: true
      });
      resp.request.haltHandlersOnError();
      throw (resp.error);
    }
  },

  /**
   * @api private
   */
  crc32IsValid: function crc32IsValid(resp) {
    var crc = resp.httpResponse.headers['x-amz-crc32'];
    if (!crc) return true; // no (valid) CRC32 header
    return parseInt(crc, 10) === AWS.util.crypto.crc32(resp.httpResponse.body);
  },

  /**
   * @api private
   */
  defaultRetryCount: 10,

  /**
   * @api private
   */
  retryDelays: function retryDelays(retryCount) {
    var retryDelayOptions = AWS.util.copy(this.config.retryDelayOptions);

    if (typeof retryDelayOptions.base !== 'number') {
        retryDelayOptions.base = 50; // default for dynamodb
    }
    var delay = AWS.util.calculateRetryDelay(retryCount, retryDelayOptions);
    return delay;
  }
});


/***/ }),
/* 2798 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var Translator = __webpack_require__(2799);
var DynamoDBSet = __webpack_require__(1073);

/**
 * The document client simplifies working with items in Amazon DynamoDB
 * by abstracting away the notion of attribute values. This abstraction
 * annotates native JavaScript types supplied as input parameters, as well
 * as converts annotated response data to native JavaScript types.
 *
 * ## Marshalling Input and Unmarshalling Response Data
 *
 * The document client affords developers the use of native JavaScript types
 * instead of `AttributeValue`s to simplify the JavaScript development
 * experience with Amazon DynamoDB. JavaScript objects passed in as parameters
 * are marshalled into `AttributeValue` shapes required by Amazon DynamoDB.
 * Responses from DynamoDB are unmarshalled into plain JavaScript objects
 * by the `DocumentClient`. The `DocumentClient`, does not accept
 * `AttributeValue`s in favor of native JavaScript types.
 *
 * |                             JavaScript Type                            | DynamoDB AttributeValue |
 * |:----------------------------------------------------------------------:|-------------------------|
 * | String                                                                 | S                       |
 * | Number                                                                 | N                       |
 * | Boolean                                                                | BOOL                    |
 * | null                                                                   | NULL                    |
 * | Array                                                                  | L                       |
 * | Object                                                                 | M                       |
 * | Buffer, File, Blob, ArrayBuffer, DataView, and JavaScript typed arrays | B                       |
 *
 * ## Support for Sets
 *
 * The `DocumentClient` offers a convenient way to create sets from
 * JavaScript Arrays. The type of set is inferred from the first element
 * in the array. DynamoDB supports string, number, and binary sets. To
 * learn more about supported types see the
 * [Amazon DynamoDB Data Model Documentation](http://docs.aws.amazon.com/amazondynamodb/latest/developerguide/DataModel.html)
 * For more information see {AWS.DynamoDB.DocumentClient.createSet}
 *
 */
AWS.DynamoDB.DocumentClient = AWS.util.inherit({

  /**
   * @api private
   */
  operations: {
    batchGetItem: 'batchGet',
    batchWriteItem: 'batchWrite',
    putItem: 'put',
    getItem: 'get',
    deleteItem: 'delete',
    updateItem: 'update',
    scan: 'scan',
    query: 'query'
  },

  /**
   * Creates a DynamoDB document client with a set of configuration options.
   *
   * @option options params [map] An optional map of parameters to bind to every
   *   request sent by this service object.
   * @option options service [AWS.DynamoDB] An optional pre-configured instance
   *  of the AWS.DynamoDB service object to use for requests. The object may
   *  bound parameters used by the document client.
   * @option options convertEmptyValues [Boolean] set to true if you would like
   *  the document client to convert empty values (0-length strings, binary
   *  buffers, and sets) to be converted to NULL types when persisting to
   *  DynamoDB.
   * @see AWS.DynamoDB.constructor
   *
   */
  constructor: function DocumentClient(options) {
    var self = this;
    self.options = options || {};
    self.configure(self.options);
  },

  /**
   * @api private
   */
  configure: function configure(options) {
    var self = this;
    self.service = options.service;
    self.bindServiceObject(options);
    self.attrValue = options.attrValue =
      self.service.api.operations.putItem.input.members.Item.value.shape;
  },

  /**
   * @api private
   */
  bindServiceObject: function bindServiceObject(options) {
    var self = this;
    options = options || {};

    if (!self.service) {
      self.service = new AWS.DynamoDB(options);
    } else {
      var config = AWS.util.copy(self.service.config);
      self.service = new self.service.constructor.__super__(config);
      self.service.config.params =
        AWS.util.merge(self.service.config.params || {}, options.params);
    }
  },

  /**
   * Returns the attributes of one or more items from one or more tables
   * by delegating to `AWS.DynamoDB.batchGetItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.batchGetItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.batchGetItem
   * @example Get items from multiple tables
   *  var params = {
   *    RequestItems: {
   *      'Table-1': {
   *        Keys: [
   *          {
   *             HashKey: 'haskey',
   *             NumberRangeKey: 1
   *          }
   *        ]
   *      },
   *      'Table-2': {
   *        Keys: [
   *          { foo: 'bar' },
   *        ]
   *      }
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.batchGet(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */
  batchGet: function(params, callback) {
    var self = this;
    var request = self.service.batchGetItem(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Puts or deletes multiple items in one or more tables by delegating
   * to `AWS.DynamoDB.batchWriteItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.batchWriteItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.batchWriteItem
   * @example Write to and delete from a table
   *  var params = {
   *    RequestItems: {
   *      'Table-1': [
   *        {
   *          DeleteRequest: {
   *            Key: { HashKey: 'someKey' }
   *          }
   *        },
   *        {
   *          PutRequest: {
   *            Item: {
   *              HashKey: 'anotherKey',
   *              NumAttribute: 1,
   *              BoolAttribute: true,
   *              ListAttribute: [1, 'two', false],
   *              MapAttribute: { foo: 'bar' }
   *            }
   *          }
   *        }
   *      ]
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.batchWrite(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */
  batchWrite: function(params, callback) {
    var self = this;
    var request = self.service.batchWriteItem(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Deletes a single item in a table by primary key by delegating to
   * `AWS.DynamoDB.deleteItem()`
   *
   * Supply the same parameters as {AWS.DynamoDB.deleteItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.deleteItem
   * @example Delete an item from a table
   *  var params = {
   *    TableName : 'Table',
   *    Key: {
   *      HashKey: 'hashkey',
   *      NumberRangeKey: 1
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.delete(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */
  delete: function(params, callback) {
    var self = this;
    var request = self.service.deleteItem(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Returns a set of attributes for the item with the given primary key
   * by delegating to `AWS.DynamoDB.getItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.getItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.getItem
   * @example Get an item from a table
   *  var params = {
   *    TableName : 'Table',
   *    Key: {
   *      HashKey: 'hashkey'
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.get(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */
  get: function(params, callback) {
    var self = this;
    var request = self.service.getItem(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Creates a new item, or replaces an old item with a new item by
   * delegating to `AWS.DynamoDB.putItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.putItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.putItem
   * @example Create a new item in a table
   *  var params = {
   *    TableName : 'Table',
   *    Item: {
   *       HashKey: 'haskey',
   *       NumAttribute: 1,
   *       BoolAttribute: true,
   *       ListAttribute: [1, 'two', false],
   *       MapAttribute: { foo: 'bar'},
   *       NullAttribute: null
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.put(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */
  put: function put(params, callback) {
    var self = this;
    var request = self.service.putItem(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Edits an existing item's attributes, or adds a new item to the table if
   * it does not already exist by delegating to `AWS.DynamoDB.updateItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.updateItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.updateItem
   * @example Update an item with expressions
   *  var params = {
   *    TableName: 'Table',
   *    Key: { HashKey : 'hashkey' },
   *    UpdateExpression: 'set #a = :x + :y',
   *    ConditionExpression: '#a < :MAX',
   *    ExpressionAttributeNames: {'#a' : 'Sum'},
   *    ExpressionAttributeValues: {
   *      ':x' : 20,
   *      ':y' : 45,
   *      ':MAX' : 100,
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.update(params, function(err, data) {
   *     if (err) console.log(err);
   *     else console.log(data);
   *  });
   *
   */
  update: function(params, callback) {
    var self = this;
    var request = self.service.updateItem(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Returns one or more items and item attributes by accessing every item
   * in a table or a secondary index.
   *
   * Supply the same parameters as {AWS.DynamoDB.scan} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.scan
   * @example Scan the table with a filter expression
   *  var params = {
   *    TableName : 'Table',
   *    FilterExpression : 'Year = :this_year',
   *    ExpressionAttributeValues : {':this_year' : 2015}
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.scan(params, function(err, data) {
   *     if (err) console.log(err);
   *     else console.log(data);
   *  });
   *
   */
  scan: function(params, callback) {
    var self = this;
    var request = self.service.scan(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

   /**
    * Directly access items from a table by primary key or a secondary index.
    *
    * Supply the same parameters as {AWS.DynamoDB.query} with
    * `AttributeValue`s substituted by native JavaScript types.
    *
    * @see AWS.DynamoDB.query
    * @example Query an index
    *  var params = {
    *    TableName: 'Table',
    *    IndexName: 'Index',
    *    KeyConditionExpression: 'HashKey = :hkey and RangeKey > :rkey',
    *    ExpressionAttributeValues: {
    *      ':hkey': 'key',
    *      ':rkey': 2015
    *    }
    *  };
    *
    *  var documentClient = new AWS.DynamoDB.DocumentClient();
    *
    *  documentClient.query(params, function(err, data) {
    *     if (err) console.log(err);
    *     else console.log(data);
    *  });
    *
    */
  query: function(params, callback) {
    var self = this;
    var request = self.service.query(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Creates a set of elements inferring the type of set from
   * the type of the first element. Amazon DynamoDB currently supports
   * the number sets, string sets, and binary sets. For more information
   * about DynamoDB data types see the documentation on the
   * [Amazon DynamoDB Data Model](http://docs.aws.amazon.com/amazondynamodb/latest/developerguide/DataModel.html#DataModel.DataTypes).
   *
   * @param list [Array] Collection to represent your DynamoDB Set
   * @param options [map]
   *  * **validate** [Boolean] set to true if you want to validate the type
   *    of each element in the set. Defaults to `false`.
   * @example Creating a number set
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  var params = {
   *    Item: {
   *      hashkey: 'hashkey'
   *      numbers: documentClient.createSet([1, 2, 3]);
   *    }
   *  };
   *
   *  documentClient.put(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */
  createSet: function(list, options) {
    options = options || {};
    return new DynamoDBSet(list, options);
  },

  /**
   * @api private
   */
  getTranslator: function() {
    return new Translator(this.options);
  },

  /**
   * @api private
   */
  setupRequest: function setupRequest(request) {
    var self = this;
    var translator = self.getTranslator();
    var operation = request.operation;
    var inputShape = request.service.api.operations[operation].input;
    request._events.validate.unshift(function(req) {
      req.rawParams = AWS.util.copy(req.params);
      req.params = translator.translateInput(req.rawParams, inputShape);
    });
  },

  /**
   * @api private
   */
  setupResponse: function setupResponse(request) {
    var self = this;
    var translator = self.getTranslator();
    var outputShape = self.service.api.operations[request.operation].output;
    request.on('extractData', function(response) {
      response.data = translator.translateOutput(response.data, outputShape);
    });

    var response = request.response;
    response.nextPage = function(cb) {
      var resp = this;
      var req = resp.request;
      var config;
      var service = req.service;
      var operation = req.operation;
      try {
        config = service.paginationConfig(operation, true);
      } catch (e) { resp.error = e; }

      if (!resp.hasNextPage()) {
        if (cb) cb(resp.error, null);
        else if (resp.error) throw resp.error;
        return null;
      }

      var params = AWS.util.copy(req.rawParams);
      if (!resp.nextPageTokens) {
        return cb ? cb(null, null) : null;
      } else {
        var inputTokens = config.inputToken;
        if (typeof inputTokens === 'string') inputTokens = [inputTokens];
        for (var i = 0; i < inputTokens.length; i++) {
          params[inputTokens[i]] = resp.nextPageTokens[i];
        }
        return self[operation](params, cb);
      }
    };
  }

});

module.exports = AWS.DynamoDB.DocumentClient;


/***/ }),
/* 2799 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(5).util;
var convert = __webpack_require__(2800);

var Translator = function(options) {
  options = options || {};
  this.attrValue = options.attrValue;
  this.convertEmptyValues = Boolean(options.convertEmptyValues);
  this.wrapNumbers = Boolean(options.wrapNumbers);
};

Translator.prototype.translateInput = function(value, shape) {
  this.mode = 'input';
  return this.translate(value, shape);
};

Translator.prototype.translateOutput = function(value, shape) {
  this.mode = 'output';
  return this.translate(value, shape);
};

Translator.prototype.translate = function(value, shape) {
  var self = this;
  if (!shape || value === undefined) return undefined;

  if (shape.shape === self.attrValue) {
    return convert[self.mode](value, {
      convertEmptyValues: self.convertEmptyValues,
      wrapNumbers: self.wrapNumbers,
    });
  }
  switch (shape.type) {
    case 'structure': return self.translateStructure(value, shape);
    case 'map': return self.translateMap(value, shape);
    case 'list': return self.translateList(value, shape);
    default: return self.translateScalar(value, shape);
  }
};

Translator.prototype.translateStructure = function(structure, shape) {
  var self = this;
  if (structure == null) return undefined;

  var struct = {};
  util.each(structure, function(name, value) {
    var memberShape = shape.members[name];
    if (memberShape) {
      var result = self.translate(value, memberShape);
      if (result !== undefined) struct[name] = result;
    }
  });
  return struct;
};

Translator.prototype.translateList = function(list, shape) {
  var self = this;
  if (list == null) return undefined;

  var out = [];
  util.arrayEach(list, function(value) {
    var result = self.translate(value, shape.member);
    if (result === undefined) out.push(null);
    else out.push(result);
  });
  return out;
};

Translator.prototype.translateMap = function(map, shape) {
  var self = this;
  if (map == null) return undefined;

  var out = {};
  util.each(map, function(key, value) {
    var result = self.translate(value, shape.value);
    if (result === undefined) out[key] = null;
    else out[key] = result;
  });
  return out;
};

Translator.prototype.translateScalar = function(value, shape) {
  return shape.toType(value);
};

module.exports = Translator;


/***/ }),
/* 2800 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var util = AWS.util;
var typeOf = __webpack_require__(1072).typeOf;
var DynamoDBSet = __webpack_require__(1073);
var NumberValue = __webpack_require__(2801);

AWS.DynamoDB.Converter = {
  /**
   * Convert a JavaScript value to its equivalent DynamoDB AttributeValue type
   *
   * @param data [any] The data to convert to a DynamoDB AttributeValue
   * @param options [map]
   * @option options convertEmptyValues [Boolean] Whether to automatically
   *                                              convert empty strings, blobs,
   *                                              and sets to `null`
   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
   *                                        NumberValue object instead of
   *                                        converting them to native JavaScript
   *                                        numbers. This allows for the safe
   *                                        round-trip transport of numbers of
   *                                        arbitrary size.
   * @return [map] An object in the Amazon DynamoDB AttributeValue format
   *
   * @see AWS.DynamoDB.Converter.marshall AWS.DynamoDB.Converter.marshall to
   *    convert entire records (rather than individual attributes)
   */
  input: function convertInput(data, options) {
    options = options || {};
    var type = typeOf(data);
    if (type === 'Object') {
      return formatMap(data, options);
    } else if (type === 'Array') {
      return formatList(data, options);
    } else if (type === 'Set') {
      return formatSet(data, options);
    } else if (type === 'String') {
      if (data.length === 0 && options.convertEmptyValues) {
        return convertInput(null);
      }
      return { S: data };
    } else if (type === 'Number' || type === 'NumberValue') {
      return { N: data.toString() };
    } else if (type === 'Binary') {
      if (data.length === 0 && options.convertEmptyValues) {
        return convertInput(null);
      }
      return { B: data };
    } else if (type === 'Boolean') {
      return { BOOL: data };
    } else if (type === 'null') {
      return { NULL: true };
    } else if (type !== 'undefined' && type !== 'Function') {
      // this value has a custom constructor
      return formatMap(data, options);
    }
  },

  /**
   * Convert a JavaScript object into a DynamoDB record.
   *
   * @param data [any] The data to convert to a DynamoDB record
   * @param options [map]
   * @option options convertEmptyValues [Boolean] Whether to automatically
   *                                              convert empty strings, blobs,
   *                                              and sets to `null`
   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
   *                                        NumberValue object instead of
   *                                        converting them to native JavaScript
   *                                        numbers. This allows for the safe
   *                                        round-trip transport of numbers of
   *                                        arbitrary size.
   *
   * @return [map] An object in the DynamoDB record format.
   *
   * @example Convert a JavaScript object into a DynamoDB record
   *  var marshalled = AWS.DynamoDB.Converter.marshall({
   *    string: 'foo',
   *    list: ['fizz', 'buzz', 'pop'],
   *    map: {
   *      nestedMap: {
   *        key: 'value',
   *      }
   *    },
   *    number: 123,
   *    nullValue: null,
   *    boolValue: true,
   *    stringSet: new DynamoDBSet(['foo', 'bar', 'baz'])
   *  });
   */
  marshall: function marshallItem(data, options) {
    return AWS.DynamoDB.Converter.input(data, options).M;
  },

  /**
   * Convert a DynamoDB AttributeValue object to its equivalent JavaScript type.
   *
   * @param data [map] An object in the Amazon DynamoDB AttributeValue format
   * @param options [map]
   * @option options convertEmptyValues [Boolean] Whether to automatically
   *                                              convert empty strings, blobs,
   *                                              and sets to `null`
   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
   *                                        NumberValue object instead of
   *                                        converting them to native JavaScript
   *                                        numbers. This allows for the safe
   *                                        round-trip transport of numbers of
   *                                        arbitrary size.
   *
   * @return [Object|Array|String|Number|Boolean|null]
   *
   * @see AWS.DynamoDB.Converter.unmarshall AWS.DynamoDB.Converter.unmarshall to
   *    convert entire records (rather than individual attributes)
   */
  output: function convertOutput(data, options) {
    options = options || {};
    var list, map, i;
    for (var type in data) {
      var values = data[type];
      if (type === 'M') {
        map = {};
        for (var key in values) {
          map[key] = convertOutput(values[key], options);
        }
        return map;
      } else if (type === 'L') {
        list = [];
        for (i = 0; i < values.length; i++) {
          list.push(convertOutput(values[i], options));
        }
        return list;
      } else if (type === 'SS') {
        list = [];
        for (i = 0; i < values.length; i++) {
          list.push(values[i] + '');
        }
        return new DynamoDBSet(list);
      } else if (type === 'NS') {
        list = [];
        for (i = 0; i < values.length; i++) {
          list.push(convertNumber(values[i], options.wrapNumbers));
        }
        return new DynamoDBSet(list);
      } else if (type === 'BS') {
        list = [];
        for (i = 0; i < values.length; i++) {
          list.push(new util.Buffer(values[i]));
        }
        return new DynamoDBSet(list);
      } else if (type === 'S') {
        return values + '';
      } else if (type === 'N') {
        return convertNumber(values, options.wrapNumbers);
      } else if (type === 'B') {
        return new util.Buffer(values);
      } else if (type === 'BOOL') {
        return (values === 'true' || values === 'TRUE' || values === true);
      } else if (type === 'NULL') {
        return null;
      }
    }
  },

  /**
   * Convert a DynamoDB record into a JavaScript object.
   *
   * @param data [any] The DynamoDB record
   * @param options [map]
   * @option options convertEmptyValues [Boolean] Whether to automatically
   *                                              convert empty strings, blobs,
   *                                              and sets to `null`
   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
   *                                        NumberValue object instead of
   *                                        converting them to native JavaScript
   *                                        numbers. This allows for the safe
   *                                        round-trip transport of numbers of
   *                                        arbitrary size.
   *
   * @return [map] An object whose properties have been converted from
   *    DynamoDB's AttributeValue format into their corresponding native
   *    JavaScript types.
   *
   * @example Convert a record received from a DynamoDB stream
   *  var unmarshalled = AWS.DynamoDB.Converter.unmarshall({
   *    string: {S: 'foo'},
   *    list: {L: [{S: 'fizz'}, {S: 'buzz'}, {S: 'pop'}]},
   *    map: {
   *      M: {
   *        nestedMap: {
   *          M: {
   *            key: {S: 'value'}
   *          }
   *        }
   *      }
   *    },
   *    number: {N: '123'},
   *    nullValue: {NULL: true},
   *    boolValue: {BOOL: true}
   *  });
   */
  unmarshall: function unmarshall(data, options) {
    return AWS.DynamoDB.Converter.output({M: data}, options);
  }
};

/**
 * @api private
 * @param data [Array]
 * @param options [map]
 */
function formatList(data, options) {
  var list = {L: []};
  for (var i = 0; i < data.length; i++) {
    list['L'].push(AWS.DynamoDB.Converter.input(data[i], options));
  }
  return list;
}

/**
 * @api private
 * @param value [String]
 * @param wrapNumbers [Boolean]
 */
function convertNumber(value, wrapNumbers) {
  return wrapNumbers ? new NumberValue(value) : Number(value);
}

/**
 * @api private
 * @param data [map]
 * @param options [map]
 */
function formatMap(data, options) {
  var map = {M: {}};
  for (var key in data) {
    var formatted = AWS.DynamoDB.Converter.input(data[key], options);
    if (formatted !== void 0) {
      map['M'][key] = formatted;
    }
  }
  return map;
}

/**
 * @api private
 */
function formatSet(data, options) {
  options = options || {};
  var values = data.values;
  if (options.convertEmptyValues) {
    values = filterEmptySetValues(data);
    if (values.length === 0) {
      return AWS.DynamoDB.Converter.input(null);
    }
  }

  var map = {};
  switch (data.type) {
    case 'String': map['SS'] = values; break;
    case 'Binary': map['BS'] = values; break;
    case 'Number': map['NS'] = values.map(function (value) {
      return value.toString();
    });
  }
  return map;
}

/**
 * @api private
 */
function filterEmptySetValues(set) {
    var nonEmptyValues = [];
    var potentiallyEmptyTypes = {
        String: true,
        Binary: true,
        Number: false
    };
    if (potentiallyEmptyTypes[set.type]) {
        for (var i = 0; i < set.values.length; i++) {
            if (set.values[i].length === 0) {
                continue;
            }
            nonEmptyValues.push(set.values[i]);
        }

        return nonEmptyValues;
    }

    return set.values;
}

module.exports = AWS.DynamoDB.Converter;


/***/ }),
/* 2801 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(5).util;

/**
 * An object recognizable as a numeric value that stores the underlying number
 * as a string.
 *
 * Intended to be a deserialization target for the DynamoDB Document Client when
 * the `wrapNumbers` flag is set. This allows for numeric values that lose
 * precision when converted to JavaScript's `number` type.
 */
var DynamoDBNumberValue = util.inherit({
  constructor: function NumberValue(value) {
    this.value = value.toString();
  },

  /**
   * Render the underlying value as a number when converting to JSON.
   */
  toJSON: function () {
    return this.toNumber();
  },

  /**
   * Convert the underlying value to a JavaScript number.
   */
  toNumber: function () {
    return Number(this.value);
  },

  /**
   * Return a string representing the unaltered value provided to the
   * constructor.
   */
  toString: function () {
    return this.value;
  }
});

module.exports = DynamoDBNumberValue;

/***/ }),
/* 2802 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-12-05","endpointPrefix":"dynamodb","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"DynamoDB","serviceFullName":"Amazon DynamoDB","serviceId":"DynamoDB","signatureVersion":"v4","targetPrefix":"DynamoDB_20111205","uid":"dynamodb-2011-12-05"},"operations":{"BatchGetItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"S2"}}},"output":{"type":"structure","members":{"Responses":{"type":"map","key":{},"value":{"type":"structure","members":{"Items":{"shape":"Sk"},"ConsumedCapacityUnits":{"type":"double"}}}},"UnprocessedKeys":{"shape":"S2"}}}},"BatchWriteItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"So"}}},"output":{"type":"structure","members":{"Responses":{"type":"map","key":{},"value":{"type":"structure","members":{"ConsumedCapacityUnits":{"type":"double"}}}},"UnprocessedItems":{"shape":"So"}}}},"CreateTable":{"input":{"type":"structure","required":["TableName","KeySchema","ProvisionedThroughput"],"members":{"TableName":{},"KeySchema":{"shape":"Sy"},"ProvisionedThroughput":{"shape":"S12"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S15"}}}},"DeleteItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"Expected":{"shape":"S1b"},"ReturnValues":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"DeleteTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S15"}}}},"DescribeTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"Table":{"shape":"S15"}}}},"GetItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributesToGet":{"shape":"Se"},"ConsistentRead":{"type":"boolean"}}},"output":{"type":"structure","members":{"Item":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"ListTables":{"input":{"type":"structure","members":{"ExclusiveStartTableName":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TableNames":{"type":"list","member":{}},"LastEvaluatedTableName":{}}}},"PutItem":{"input":{"type":"structure","required":["TableName","Item"],"members":{"TableName":{},"Item":{"shape":"Ss"},"Expected":{"shape":"S1b"},"ReturnValues":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"Query":{"input":{"type":"structure","required":["TableName","HashKeyValue"],"members":{"TableName":{},"AttributesToGet":{"shape":"Se"},"Limit":{"type":"integer"},"ConsistentRead":{"type":"boolean"},"Count":{"type":"boolean"},"HashKeyValue":{"shape":"S7"},"RangeKeyCondition":{"shape":"S1u"},"ScanIndexForward":{"type":"boolean"},"ExclusiveStartKey":{"shape":"S6"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sk"},"Count":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacityUnits":{"type":"double"}}}},"Scan":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"AttributesToGet":{"shape":"Se"},"Limit":{"type":"integer"},"Count":{"type":"boolean"},"ScanFilter":{"type":"map","key":{},"value":{"shape":"S1u"}},"ExclusiveStartKey":{"shape":"S6"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sk"},"Count":{"type":"integer"},"ScannedCount":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacityUnits":{"type":"double"}}}},"UpdateItem":{"input":{"type":"structure","required":["TableName","Key","AttributeUpdates"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributeUpdates":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S7"},"Action":{}}}},"Expected":{"shape":"S1b"},"ReturnValues":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"UpdateTable":{"input":{"type":"structure","required":["TableName","ProvisionedThroughput"],"members":{"TableName":{},"ProvisionedThroughput":{"shape":"S12"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S15"}}}}},"shapes":{"S2":{"type":"map","key":{},"value":{"type":"structure","required":["Keys"],"members":{"Keys":{"type":"list","member":{"shape":"S6"}},"AttributesToGet":{"shape":"Se"},"ConsistentRead":{"type":"boolean"}}}},"S6":{"type":"structure","required":["HashKeyElement"],"members":{"HashKeyElement":{"shape":"S7"},"RangeKeyElement":{"shape":"S7"}}},"S7":{"type":"structure","members":{"S":{},"N":{},"B":{"type":"blob"},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{"type":"blob"}}}},"Se":{"type":"list","member":{}},"Sk":{"type":"list","member":{"shape":"Sl"}},"Sl":{"type":"map","key":{},"value":{"shape":"S7"}},"So":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"PutRequest":{"type":"structure","required":["Item"],"members":{"Item":{"shape":"Ss"}}},"DeleteRequest":{"type":"structure","required":["Key"],"members":{"Key":{"shape":"S6"}}}}}}},"Ss":{"type":"map","key":{},"value":{"shape":"S7"}},"Sy":{"type":"structure","required":["HashKeyElement"],"members":{"HashKeyElement":{"shape":"Sz"},"RangeKeyElement":{"shape":"Sz"}}},"Sz":{"type":"structure","required":["AttributeName","AttributeType"],"members":{"AttributeName":{},"AttributeType":{}}},"S12":{"type":"structure","required":["ReadCapacityUnits","WriteCapacityUnits"],"members":{"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"S15":{"type":"structure","members":{"TableName":{},"KeySchema":{"shape":"Sy"},"TableStatus":{},"CreationDateTime":{"type":"timestamp"},"ProvisionedThroughput":{"type":"structure","members":{"LastIncreaseDateTime":{"type":"timestamp"},"LastDecreaseDateTime":{"type":"timestamp"},"NumberOfDecreasesToday":{"type":"long"},"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"TableSizeBytes":{"type":"long"},"ItemCount":{"type":"long"}}},"S1b":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S7"},"Exists":{"type":"boolean"}}}},"S1u":{"type":"structure","required":["ComparisonOperator"],"members":{"AttributeValueList":{"type":"list","member":{"shape":"S7"}},"ComparisonOperator":{}}}}}

/***/ }),
/* 2803 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"BatchGetItem":{"input_token":"RequestItems","output_token":"UnprocessedKeys"},"ListTables":{"input_token":"ExclusiveStartTableName","limit_key":"Limit","output_token":"LastEvaluatedTableName","result_key":"TableNames"},"Query":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"},"Scan":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"}}}

/***/ }),
/* 2804 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"TableExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"success","argument":"Table.TableStatus"},{"expected":"ResourceNotFoundException","matcher":"error","state":"retry"}]},"TableNotExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}

/***/ }),
/* 2805 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-08-10","endpointPrefix":"dynamodb","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"DynamoDB","serviceFullName":"Amazon DynamoDB","serviceId":"DynamoDB","signatureVersion":"v4","targetPrefix":"DynamoDB_20120810","uid":"dynamodb-2012-08-10"},"operations":{"BatchGetItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"S2"},"ReturnConsumedCapacity":{}}},"output":{"type":"structure","members":{"Responses":{"type":"map","key":{},"value":{"shape":"Sr"}},"UnprocessedKeys":{"shape":"S2"},"ConsumedCapacity":{"shape":"St"}}}},"BatchWriteItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"S10"},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{}}},"output":{"type":"structure","members":{"UnprocessedItems":{"shape":"S10"},"ItemCollectionMetrics":{"type":"map","key":{},"value":{"type":"list","member":{"shape":"S1a"}}},"ConsumedCapacity":{"shape":"St"}}}},"CreateBackup":{"input":{"type":"structure","required":["TableName","BackupName"],"members":{"TableName":{},"BackupName":{}}},"output":{"type":"structure","members":{"BackupDetails":{"shape":"S1h"}}}},"CreateGlobalTable":{"input":{"type":"structure","required":["GlobalTableName","ReplicationGroup"],"members":{"GlobalTableName":{},"ReplicationGroup":{"shape":"S1n"}}},"output":{"type":"structure","members":{"GlobalTableDescription":{"shape":"S1r"}}}},"CreateTable":{"input":{"type":"structure","required":["AttributeDefinitions","TableName","KeySchema","ProvisionedThroughput"],"members":{"AttributeDefinitions":{"shape":"S1y"},"TableName":{},"KeySchema":{"shape":"S22"},"LocalSecondaryIndexes":{"type":"list","member":{"type":"structure","required":["IndexName","KeySchema","Projection"],"members":{"IndexName":{},"KeySchema":{"shape":"S22"},"Projection":{"shape":"S27"}}}},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","required":["IndexName","KeySchema","Projection","ProvisionedThroughput"],"members":{"IndexName":{},"KeySchema":{"shape":"S22"},"Projection":{"shape":"S27"},"ProvisionedThroughput":{"shape":"S2d"}}}},"ProvisionedThroughput":{"shape":"S2d"},"StreamSpecification":{"shape":"S2f"},"SSESpecification":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S2l"}}}},"DeleteBackup":{"input":{"type":"structure","required":["BackupArn"],"members":{"BackupArn":{}}},"output":{"type":"structure","members":{"BackupDescription":{"shape":"S36"}}}},"DeleteItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"Expected":{"shape":"S3j"},"ConditionalOperator":{},"ReturnValues":{},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S3r"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Ss"},"ConsumedCapacity":{"shape":"Su"},"ItemCollectionMetrics":{"shape":"S1a"}}}},"DeleteTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S2l"}}}},"DescribeBackup":{"input":{"type":"structure","required":["BackupArn"],"members":{"BackupArn":{}}},"output":{"type":"structure","members":{"BackupDescription":{"shape":"S36"}}}},"DescribeContinuousBackups":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"ContinuousBackupsDescription":{"type":"structure","required":["ContinuousBackupsStatus"],"members":{"ContinuousBackupsStatus":{}}}}}},"DescribeGlobalTable":{"input":{"type":"structure","required":["GlobalTableName"],"members":{"GlobalTableName":{}}},"output":{"type":"structure","members":{"GlobalTableDescription":{"shape":"S1r"}}}},"DescribeLimits":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AccountMaxReadCapacityUnits":{"type":"long"},"AccountMaxWriteCapacityUnits":{"type":"long"},"TableMaxReadCapacityUnits":{"type":"long"},"TableMaxWriteCapacityUnits":{"type":"long"}}}},"DescribeTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"Table":{"shape":"S2l"}}}},"DescribeTimeToLive":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TimeToLiveDescription":{"shape":"S3f"}}}},"GetItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributesToGet":{"shape":"Sj"},"ConsistentRead":{"type":"boolean"},"ReturnConsumedCapacity":{},"ProjectionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"}}},"output":{"type":"structure","members":{"Item":{"shape":"Ss"},"ConsumedCapacity":{"shape":"Su"}}}},"ListBackups":{"input":{"type":"structure","members":{"TableName":{},"Limit":{"type":"integer"},"TimeRangeLowerBound":{"type":"timestamp"},"TimeRangeUpperBound":{"type":"timestamp"},"ExclusiveStartBackupArn":{}}},"output":{"type":"structure","members":{"BackupSummaries":{"type":"list","member":{"type":"structure","members":{"TableName":{},"TableId":{},"TableArn":{},"BackupArn":{},"BackupName":{},"BackupCreationDateTime":{"type":"timestamp"},"BackupStatus":{},"BackupSizeBytes":{"type":"long"}}}},"LastEvaluatedBackupArn":{}}}},"ListGlobalTables":{"input":{"type":"structure","members":{"ExclusiveStartGlobalTableName":{},"Limit":{"type":"integer"},"RegionName":{}}},"output":{"type":"structure","members":{"GlobalTables":{"type":"list","member":{"type":"structure","members":{"GlobalTableName":{},"ReplicationGroup":{"shape":"S1n"}}}},"LastEvaluatedGlobalTableName":{}}}},"ListTables":{"input":{"type":"structure","members":{"ExclusiveStartTableName":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TableNames":{"type":"list","member":{}},"LastEvaluatedTableName":{}}}},"ListTagsOfResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S4w"},"NextToken":{}}}},"PutItem":{"input":{"type":"structure","required":["TableName","Item"],"members":{"TableName":{},"Item":{"shape":"S14"},"Expected":{"shape":"S3j"},"ReturnValues":{},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"ConditionalOperator":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S3r"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Ss"},"ConsumedCapacity":{"shape":"Su"},"ItemCollectionMetrics":{"shape":"S1a"}}}},"Query":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"IndexName":{},"Select":{},"AttributesToGet":{"shape":"Sj"},"Limit":{"type":"integer"},"ConsistentRead":{"type":"boolean"},"KeyConditions":{"type":"map","key":{},"value":{"shape":"S55"}},"QueryFilter":{"shape":"S56"},"ConditionalOperator":{},"ScanIndexForward":{"type":"boolean"},"ExclusiveStartKey":{"shape":"S6"},"ReturnConsumedCapacity":{},"ProjectionExpression":{},"FilterExpression":{},"KeyConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S3r"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sr"},"Count":{"type":"integer"},"ScannedCount":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacity":{"shape":"Su"}}}},"RestoreTableFromBackup":{"input":{"type":"structure","required":["TargetTableName","BackupArn"],"members":{"TargetTableName":{},"BackupArn":{}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S2l"}}}},"Scan":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"IndexName":{},"AttributesToGet":{"shape":"Sj"},"Limit":{"type":"integer"},"Select":{},"ScanFilter":{"shape":"S56"},"ConditionalOperator":{},"ExclusiveStartKey":{"shape":"S6"},"ReturnConsumedCapacity":{},"TotalSegments":{"type":"integer"},"Segment":{"type":"integer"},"ProjectionExpression":{},"FilterExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S3r"},"ConsistentRead":{"type":"boolean"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sr"},"Count":{"type":"integer"},"ScannedCount":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacity":{"shape":"Su"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S4w"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateGlobalTable":{"input":{"type":"structure","required":["GlobalTableName","ReplicaUpdates"],"members":{"GlobalTableName":{},"ReplicaUpdates":{"type":"list","member":{"type":"structure","members":{"Create":{"type":"structure","required":["RegionName"],"members":{"RegionName":{}}},"Delete":{"type":"structure","required":["RegionName"],"members":{"RegionName":{}}}}}}}},"output":{"type":"structure","members":{"GlobalTableDescription":{"shape":"S1r"}}}},"UpdateItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributeUpdates":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S8"},"Action":{}}}},"Expected":{"shape":"S3j"},"ConditionalOperator":{},"ReturnValues":{},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"UpdateExpression":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S3r"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Ss"},"ConsumedCapacity":{"shape":"Su"},"ItemCollectionMetrics":{"shape":"S1a"}}}},"UpdateTable":{"input":{"type":"structure","required":["TableName"],"members":{"AttributeDefinitions":{"shape":"S1y"},"TableName":{},"ProvisionedThroughput":{"shape":"S2d"},"GlobalSecondaryIndexUpdates":{"type":"list","member":{"type":"structure","members":{"Update":{"type":"structure","required":["IndexName","ProvisionedThroughput"],"members":{"IndexName":{},"ProvisionedThroughput":{"shape":"S2d"}}},"Create":{"type":"structure","required":["IndexName","KeySchema","Projection","ProvisionedThroughput"],"members":{"IndexName":{},"KeySchema":{"shape":"S22"},"Projection":{"shape":"S27"},"ProvisionedThroughput":{"shape":"S2d"}}},"Delete":{"type":"structure","required":["IndexName"],"members":{"IndexName":{}}}}}},"StreamSpecification":{"shape":"S2f"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S2l"}}}},"UpdateTimeToLive":{"input":{"type":"structure","required":["TableName","TimeToLiveSpecification"],"members":{"TableName":{},"TimeToLiveSpecification":{"shape":"S63"}}},"output":{"type":"structure","members":{"TimeToLiveSpecification":{"shape":"S63"}}}}},"shapes":{"S2":{"type":"map","key":{},"value":{"type":"structure","required":["Keys"],"members":{"Keys":{"type":"list","member":{"shape":"S6"}},"AttributesToGet":{"shape":"Sj"},"ConsistentRead":{"type":"boolean"},"ProjectionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"}}}},"S6":{"type":"map","key":{},"value":{"shape":"S8"}},"S8":{"type":"structure","members":{"S":{},"N":{},"B":{"type":"blob"},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{"type":"blob"}},"M":{"type":"map","key":{},"value":{"shape":"S8"}},"L":{"type":"list","member":{"shape":"S8"}},"NULL":{"type":"boolean"},"BOOL":{"type":"boolean"}}},"Sj":{"type":"list","member":{}},"Sm":{"type":"map","key":{},"value":{}},"Sr":{"type":"list","member":{"shape":"Ss"}},"Ss":{"type":"map","key":{},"value":{"shape":"S8"}},"St":{"type":"list","member":{"shape":"Su"}},"Su":{"type":"structure","members":{"TableName":{},"CapacityUnits":{"type":"double"},"Table":{"shape":"Sw"},"LocalSecondaryIndexes":{"shape":"Sx"},"GlobalSecondaryIndexes":{"shape":"Sx"}}},"Sw":{"type":"structure","members":{"CapacityUnits":{"type":"double"}}},"Sx":{"type":"map","key":{},"value":{"shape":"Sw"}},"S10":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"PutRequest":{"type":"structure","required":["Item"],"members":{"Item":{"shape":"S14"}}},"DeleteRequest":{"type":"structure","required":["Key"],"members":{"Key":{"shape":"S6"}}}}}}},"S14":{"type":"map","key":{},"value":{"shape":"S8"}},"S1a":{"type":"structure","members":{"ItemCollectionKey":{"type":"map","key":{},"value":{"shape":"S8"}},"SizeEstimateRangeGB":{"type":"list","member":{"type":"double"}}}},"S1h":{"type":"structure","required":["BackupArn","BackupName","BackupStatus","BackupCreationDateTime"],"members":{"BackupArn":{},"BackupName":{},"BackupSizeBytes":{"type":"long"},"BackupStatus":{},"BackupCreationDateTime":{"type":"timestamp"}}},"S1n":{"type":"list","member":{"type":"structure","members":{"RegionName":{}}}},"S1r":{"type":"structure","members":{"ReplicationGroup":{"type":"list","member":{"type":"structure","members":{"RegionName":{}}}},"GlobalTableArn":{},"CreationDateTime":{"type":"timestamp"},"GlobalTableStatus":{},"GlobalTableName":{}}},"S1y":{"type":"list","member":{"type":"structure","required":["AttributeName","AttributeType"],"members":{"AttributeName":{},"AttributeType":{}}}},"S22":{"type":"list","member":{"type":"structure","required":["AttributeName","KeyType"],"members":{"AttributeName":{},"KeyType":{}}}},"S27":{"type":"structure","members":{"ProjectionType":{},"NonKeyAttributes":{"type":"list","member":{}}}},"S2d":{"type":"structure","required":["ReadCapacityUnits","WriteCapacityUnits"],"members":{"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"S2f":{"type":"structure","members":{"StreamEnabled":{"type":"boolean"},"StreamViewType":{}}},"S2l":{"type":"structure","members":{"AttributeDefinitions":{"shape":"S1y"},"TableName":{},"KeySchema":{"shape":"S22"},"TableStatus":{},"CreationDateTime":{"type":"timestamp"},"ProvisionedThroughput":{"shape":"S2n"},"TableSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"TableArn":{},"TableId":{},"LocalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S22"},"Projection":{"shape":"S27"},"IndexSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"IndexArn":{}}}},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S22"},"Projection":{"shape":"S27"},"IndexStatus":{},"Backfilling":{"type":"boolean"},"ProvisionedThroughput":{"shape":"S2n"},"IndexSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"IndexArn":{}}}},"StreamSpecification":{"shape":"S2f"},"LatestStreamLabel":{},"LatestStreamArn":{},"RestoreSummary":{"type":"structure","required":["RestoreDateTime","RestoreInProgress"],"members":{"SourceBackupArn":{},"SourceTableArn":{},"RestoreDateTime":{"type":"timestamp"},"RestoreInProgress":{"type":"boolean"}}},"SSEDescription":{"shape":"S32"}}},"S2n":{"type":"structure","members":{"LastIncreaseDateTime":{"type":"timestamp"},"LastDecreaseDateTime":{"type":"timestamp"},"NumberOfDecreasesToday":{"type":"long"},"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"S32":{"type":"structure","members":{"Status":{}}},"S36":{"type":"structure","members":{"BackupDetails":{"shape":"S1h"},"SourceTableDetails":{"type":"structure","required":["TableName","TableId","KeySchema","TableCreationDateTime","ProvisionedThroughput"],"members":{"TableName":{},"TableId":{},"TableArn":{},"TableSizeBytes":{"type":"long"},"KeySchema":{"shape":"S22"},"TableCreationDateTime":{"type":"timestamp"},"ProvisionedThroughput":{"shape":"S2d"},"ItemCount":{"type":"long"}}},"SourceTableFeatureDetails":{"type":"structure","members":{"LocalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S22"},"Projection":{"shape":"S27"}}}},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S22"},"Projection":{"shape":"S27"},"ProvisionedThroughput":{"shape":"S2d"}}}},"StreamDescription":{"shape":"S2f"},"TimeToLiveDescription":{"shape":"S3f"},"SSEDescription":{"shape":"S32"}}}}},"S3f":{"type":"structure","members":{"TimeToLiveStatus":{},"AttributeName":{}}},"S3j":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S8"},"Exists":{"type":"boolean"},"ComparisonOperator":{},"AttributeValueList":{"shape":"S3n"}}}},"S3n":{"type":"list","member":{"shape":"S8"}},"S3r":{"type":"map","key":{},"value":{"shape":"S8"}},"S4w":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S55":{"type":"structure","required":["ComparisonOperator"],"members":{"AttributeValueList":{"shape":"S3n"},"ComparisonOperator":{}}},"S56":{"type":"map","key":{},"value":{"shape":"S55"}},"S63":{"type":"structure","required":["Enabled","AttributeName"],"members":{"Enabled":{"type":"boolean"},"AttributeName":{}}}}}

/***/ }),
/* 2806 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"BatchGetItem":{"input_token":"RequestItems","output_token":"UnprocessedKeys"},"ListTables":{"input_token":"ExclusiveStartTableName","limit_key":"Limit","output_token":"LastEvaluatedTableName","result_key":"TableNames"},"Query":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"},"Scan":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"}}}

/***/ }),
/* 2807 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"TableExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"success","argument":"Table.TableStatus"},{"expected":"ResourceNotFoundException","matcher":"error","state":"retry"}]},"TableNotExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}

/***/ }),
/* 2808 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['dynamodbstreams'] = {};
AWS.DynamoDBStreams = Service.defineService('dynamodbstreams', ['2012-08-10']);
Object.defineProperty(apiLoader.services['dynamodbstreams'], '2012-08-10', {
  get: function get() {
    var model = __webpack_require__(2809);
    model.paginators = __webpack_require__(2810).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.DynamoDBStreams;


/***/ }),
/* 2809 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-08-10","endpointPrefix":"streams.dynamodb","jsonVersion":"1.0","protocol":"json","serviceFullName":"Amazon DynamoDB Streams","signatureVersion":"v4","signingName":"dynamodb","targetPrefix":"DynamoDBStreams_20120810","uid":"streams-dynamodb-2012-08-10"},"operations":{"DescribeStream":{"input":{"type":"structure","required":["StreamArn"],"members":{"StreamArn":{},"Limit":{"type":"integer"},"ExclusiveStartShardId":{}}},"output":{"type":"structure","members":{"StreamDescription":{"type":"structure","members":{"StreamArn":{},"StreamLabel":{},"StreamStatus":{},"StreamViewType":{},"CreationRequestDateTime":{"type":"timestamp"},"TableName":{},"KeySchema":{"type":"list","member":{"type":"structure","required":["AttributeName","KeyType"],"members":{"AttributeName":{},"KeyType":{}}}},"Shards":{"type":"list","member":{"type":"structure","members":{"ShardId":{},"SequenceNumberRange":{"type":"structure","members":{"StartingSequenceNumber":{},"EndingSequenceNumber":{}}},"ParentShardId":{}}}},"LastEvaluatedShardId":{}}}}}},"GetRecords":{"input":{"type":"structure","required":["ShardIterator"],"members":{"ShardIterator":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Records":{"type":"list","member":{"type":"structure","members":{"eventID":{},"eventName":{},"eventVersion":{},"eventSource":{},"awsRegion":{},"dynamodb":{"type":"structure","members":{"ApproximateCreationDateTime":{"type":"timestamp"},"Keys":{"shape":"Sr"},"NewImage":{"shape":"Sr"},"OldImage":{"shape":"Sr"},"SequenceNumber":{},"SizeBytes":{"type":"long"},"StreamViewType":{}}},"userIdentity":{"type":"structure","members":{"PrincipalId":{},"Type":{}}}}}},"NextShardIterator":{}}}},"GetShardIterator":{"input":{"type":"structure","required":["StreamArn","ShardId","ShardIteratorType"],"members":{"StreamArn":{},"ShardId":{},"ShardIteratorType":{},"SequenceNumber":{}}},"output":{"type":"structure","members":{"ShardIterator":{}}}},"ListStreams":{"input":{"type":"structure","members":{"TableName":{},"Limit":{"type":"integer"},"ExclusiveStartStreamArn":{}}},"output":{"type":"structure","members":{"Streams":{"type":"list","member":{"type":"structure","members":{"StreamArn":{},"TableName":{},"StreamLabel":{}}}},"LastEvaluatedStreamArn":{}}}}},"shapes":{"Sr":{"type":"map","key":{},"value":{"shape":"St"}},"St":{"type":"structure","members":{"S":{},"N":{},"B":{"type":"blob"},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{"type":"blob"}},"M":{"type":"map","key":{},"value":{"shape":"St"}},"L":{"type":"list","member":{"shape":"St"}},"NULL":{"type":"boolean"},"BOOL":{"type":"boolean"}}}}}

/***/ }),
/* 2810 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 2811 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['ec2'] = {};
AWS.EC2 = Service.defineService('ec2', ['2013-06-15*', '2013-10-15*', '2014-02-01*', '2014-05-01*', '2014-06-15*', '2014-09-01*', '2014-10-01*', '2015-03-01*', '2015-04-15*', '2015-10-01*', '2016-04-01*', '2016-09-15*', '2016-11-15']);
__webpack_require__(2812);
Object.defineProperty(apiLoader.services['ec2'], '2016-11-15', {
  get: function get() {
    var model = __webpack_require__(2813);
    model.paginators = __webpack_require__(2814).pagination;
    model.waiters = __webpack_require__(2815).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.EC2;


/***/ }),
/* 2812 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);

AWS.util.update(AWS.EC2.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    request.removeListener('extractError', AWS.EventListeners.Query.EXTRACT_ERROR);
    request.addListener('extractError', this.extractError);

    if (request.operation === 'copySnapshot') {
      request.onAsync('validate', this.buildCopySnapshotPresignedUrl);
    }
  },

  /**
   * @api private
   */
  buildCopySnapshotPresignedUrl: function buildCopySnapshotPresignedUrl(req, done) {
    if (req.params.PresignedUrl || req._subRequest) {
      return done();
    }

    req.params = AWS.util.copy(req.params);
    req.params.DestinationRegion = req.service.config.region;

    var config = AWS.util.copy(req.service.config);
    delete config.endpoint;
    config.region = req.params.SourceRegion;
    var svc = new req.service.constructor(config);
    var newReq = svc[req.operation](req.params);
    newReq._subRequest = true;
    newReq.presign(function(err, url) {
      if (err) done(err);
      else {
        req.params.PresignedUrl = url;
        done();
      }
    });
  },

  /**
   * @api private
   */
  extractError: function extractError(resp) {
    // EC2 nests the error code and message deeper than other AWS Query services.
    var httpResponse = resp.httpResponse;
    var data = new AWS.XML.Parser().parse(httpResponse.body.toString() || '');
    if (data.Errors) {
      resp.error = AWS.util.error(new Error(), {
        code: data.Errors.Error.Code,
        message: data.Errors.Error.Message
      });
    } else {
      resp.error = AWS.util.error(new Error(), {
        code: httpResponse.statusCode,
        message: null
      });
    }
    resp.error.requestId = data.RequestID || null;
  }
});


/***/ }),
/* 2813 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-15","endpointPrefix":"ec2","protocol":"ec2","serviceAbbreviation":"Amazon EC2","serviceFullName":"Amazon Elastic Compute Cloud","serviceId":"EC2","signatureVersion":"v4","uid":"ec2-2016-11-15","xmlNamespace":"http://ec2.amazonaws.com/doc/2016-11-15"},"operations":{"AcceptReservedInstancesExchangeQuote":{"input":{"type":"structure","required":["ReservedInstanceIds"],"members":{"DryRun":{"type":"boolean"},"ReservedInstanceIds":{"shape":"S3","locationName":"ReservedInstanceId"},"TargetConfigurations":{"shape":"S5","locationName":"TargetConfiguration"}}},"output":{"type":"structure","members":{"ExchangeId":{"locationName":"exchangeId"}}}},"AcceptVpcEndpointConnections":{"input":{"type":"structure","required":["ServiceId","VpcEndpointIds"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"VpcEndpointIds":{"shape":"Sa","locationName":"VpcEndpointId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"Sc","locationName":"unsuccessful"}}}},"AcceptVpcPeeringConnection":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"VpcPeeringConnection":{"shape":"Sh","locationName":"vpcPeeringConnection"}}}},"AllocateAddress":{"input":{"type":"structure","members":{"Domain":{},"Address":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"PublicIp":{"locationName":"publicIp"},"AllocationId":{"locationName":"allocationId"},"Domain":{"locationName":"domain"}}}},"AllocateHosts":{"input":{"type":"structure","required":["AvailabilityZone","InstanceType","Quantity"],"members":{"AutoPlacement":{"locationName":"autoPlacement"},"AvailabilityZone":{"locationName":"availabilityZone"},"ClientToken":{"locationName":"clientToken"},"InstanceType":{"locationName":"instanceType"},"Quantity":{"locationName":"quantity","type":"integer"}}},"output":{"type":"structure","members":{"HostIds":{"shape":"Sz","locationName":"hostIdSet"}}}},"AssignIpv6Addresses":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"S11","locationName":"ipv6Addresses"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"AssignedIpv6Addresses":{"shape":"S11","locationName":"assignedIpv6Addresses"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}}},"AssignPrivateIpAddresses":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"AllowReassignment":{"locationName":"allowReassignment","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddresses":{"shape":"S14","locationName":"privateIpAddress"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"}}}},"AssociateAddress":{"input":{"type":"structure","members":{"AllocationId":{},"InstanceId":{},"PublicIp":{},"AllowReassociation":{"locationName":"allowReassociation","type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"}}}},"AssociateDhcpOptions":{"input":{"type":"structure","required":["DhcpOptionsId","VpcId"],"members":{"DhcpOptionsId":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"AssociateIamInstanceProfile":{"input":{"type":"structure","required":["IamInstanceProfile","InstanceId"],"members":{"IamInstanceProfile":{"shape":"S19"},"InstanceId":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociation":{"shape":"S1b","locationName":"iamInstanceProfileAssociation"}}}},"AssociateRouteTable":{"input":{"type":"structure","required":["RouteTableId","SubnetId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"},"SubnetId":{"locationName":"subnetId"}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"}}}},"AssociateSubnetCidrBlock":{"input":{"type":"structure","required":["Ipv6CidrBlock","SubnetId"],"members":{"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"SubnetId":{"locationName":"subnetId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S1i","locationName":"ipv6CidrBlockAssociation"},"SubnetId":{"locationName":"subnetId"}}}},"AssociateVpcCidrBlock":{"input":{"type":"structure","required":["VpcId"],"members":{"AmazonProvidedIpv6CidrBlock":{"locationName":"amazonProvidedIpv6CidrBlock","type":"boolean"},"CidrBlock":{},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S1n","locationName":"ipv6CidrBlockAssociation"},"CidrBlockAssociation":{"shape":"S1q","locationName":"cidrBlockAssociation"},"VpcId":{"locationName":"vpcId"}}}},"AttachClassicLinkVpc":{"input":{"type":"structure","required":["Groups","InstanceId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Groups":{"shape":"S1s","locationName":"SecurityGroupId"},"InstanceId":{"locationName":"instanceId"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"AttachInternetGateway":{"input":{"type":"structure","required":["InternetGatewayId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayId":{"locationName":"internetGatewayId"},"VpcId":{"locationName":"vpcId"}}}},"AttachNetworkInterface":{"input":{"type":"structure","required":["DeviceIndex","InstanceId","NetworkInterfaceId"],"members":{"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"AttachmentId":{"locationName":"attachmentId"}}}},"AttachVolume":{"input":{"type":"structure","required":["Device","InstanceId","VolumeId"],"members":{"Device":{},"InstanceId":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"shape":"S1y"}},"AttachVpnGateway":{"input":{"type":"structure","required":["VpcId","VpnGatewayId"],"members":{"VpcId":{},"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpcAttachment":{"shape":"S22","locationName":"attachment"}}}},"AuthorizeSecurityGroupEgress":{"input":{"type":"structure","required":["GroupId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupId":{"locationName":"groupId"},"IpPermissions":{"shape":"S25","locationName":"ipPermissions"},"CidrIp":{"locationName":"cidrIp"},"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"ToPort":{"locationName":"toPort","type":"integer"},"SourceSecurityGroupName":{"locationName":"sourceSecurityGroupName"},"SourceSecurityGroupOwnerId":{"locationName":"sourceSecurityGroupOwnerId"}}}},"AuthorizeSecurityGroupIngress":{"input":{"type":"structure","members":{"CidrIp":{},"FromPort":{"type":"integer"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S25"},"IpProtocol":{},"SourceSecurityGroupName":{},"SourceSecurityGroupOwnerId":{},"ToPort":{"type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"BundleInstance":{"input":{"type":"structure","required":["InstanceId","Storage"],"members":{"InstanceId":{},"Storage":{"shape":"S2h"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BundleTask":{"shape":"S2l","locationName":"bundleInstanceTask"}}}},"CancelBundleTask":{"input":{"type":"structure","required":["BundleId"],"members":{"BundleId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BundleTask":{"shape":"S2l","locationName":"bundleInstanceTask"}}}},"CancelConversionTask":{"input":{"type":"structure","required":["ConversionTaskId"],"members":{"ConversionTaskId":{"locationName":"conversionTaskId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"ReasonMessage":{"locationName":"reasonMessage"}}}},"CancelExportTask":{"input":{"type":"structure","required":["ExportTaskId"],"members":{"ExportTaskId":{"locationName":"exportTaskId"}}}},"CancelImportTask":{"input":{"type":"structure","members":{"CancelReason":{},"DryRun":{"type":"boolean"},"ImportTaskId":{}}},"output":{"type":"structure","members":{"ImportTaskId":{"locationName":"importTaskId"},"PreviousState":{"locationName":"previousState"},"State":{"locationName":"state"}}}},"CancelReservedInstancesListing":{"input":{"type":"structure","required":["ReservedInstancesListingId"],"members":{"ReservedInstancesListingId":{"locationName":"reservedInstancesListingId"}}},"output":{"type":"structure","members":{"ReservedInstancesListings":{"shape":"S2w","locationName":"reservedInstancesListingsSet"}}}},"CancelSpotFleetRequests":{"input":{"type":"structure","required":["SpotFleetRequestIds","TerminateInstances"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotFleetRequestIds":{"shape":"Sa","locationName":"spotFleetRequestId"},"TerminateInstances":{"locationName":"terminateInstances","type":"boolean"}}},"output":{"type":"structure","members":{"SuccessfulFleetRequests":{"locationName":"successfulFleetRequestSet","type":"list","member":{"locationName":"item","type":"structure","required":["CurrentSpotFleetRequestState","PreviousSpotFleetRequestState","SpotFleetRequestId"],"members":{"CurrentSpotFleetRequestState":{"locationName":"currentSpotFleetRequestState"},"PreviousSpotFleetRequestState":{"locationName":"previousSpotFleetRequestState"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}},"UnsuccessfulFleetRequests":{"locationName":"unsuccessfulFleetRequestSet","type":"list","member":{"locationName":"item","type":"structure","required":["Error","SpotFleetRequestId"],"members":{"Error":{"locationName":"error","type":"structure","required":["Code","Message"],"members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}}}}},"CancelSpotInstanceRequests":{"input":{"type":"structure","required":["SpotInstanceRequestIds"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotInstanceRequestIds":{"shape":"S3h","locationName":"SpotInstanceRequestId"}}},"output":{"type":"structure","members":{"CancelledSpotInstanceRequests":{"locationName":"spotInstanceRequestSet","type":"list","member":{"locationName":"item","type":"structure","members":{"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"State":{"locationName":"state"}}}}}}},"ConfirmProductInstance":{"input":{"type":"structure","required":["InstanceId","ProductCode"],"members":{"InstanceId":{},"ProductCode":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"OwnerId":{"locationName":"ownerId"},"Return":{"locationName":"return","type":"boolean"}}}},"CopyFpgaImage":{"input":{"type":"structure","required":["SourceFpgaImageId","SourceRegion"],"members":{"DryRun":{"type":"boolean"},"SourceFpgaImageId":{},"Description":{},"Name":{},"SourceRegion":{},"ClientToken":{}}},"output":{"type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"}}}},"CopyImage":{"input":{"type":"structure","required":["Name","SourceImageId","SourceRegion"],"members":{"ClientToken":{},"Description":{},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"Name":{},"SourceImageId":{},"SourceRegion":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"CopySnapshot":{"input":{"type":"structure","required":["SourceRegion","SourceSnapshotId"],"members":{"Description":{},"DestinationRegion":{"locationName":"destinationRegion"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"PresignedUrl":{"locationName":"presignedUrl"},"SourceRegion":{},"SourceSnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"}}}},"CreateCustomerGateway":{"input":{"type":"structure","required":["BgpAsn","PublicIp","Type"],"members":{"BgpAsn":{"type":"integer"},"PublicIp":{"locationName":"IpAddress"},"Type":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"CustomerGateway":{"shape":"S3x","locationName":"customerGateway"}}}},"CreateDefaultSubnet":{"input":{"type":"structure","required":["AvailabilityZone"],"members":{"AvailabilityZone":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Subnet":{"shape":"S40","locationName":"subnet"}}}},"CreateDefaultVpc":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Vpc":{"shape":"S45","locationName":"vpc"}}}},"CreateDhcpOptions":{"input":{"type":"structure","required":["DhcpConfigurations"],"members":{"DhcpConfigurations":{"locationName":"dhcpConfiguration","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Values":{"shape":"Sa","locationName":"Value"}}}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"DhcpOptions":{"shape":"S4e","locationName":"dhcpOptions"}}}},"CreateEgressOnlyInternetGateway":{"input":{"type":"structure","required":["VpcId"],"members":{"ClientToken":{},"DryRun":{"type":"boolean"},"VpcId":{}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"EgressOnlyInternetGateway":{"shape":"S4l","locationName":"egressOnlyInternetGateway"}}}},"CreateFlowLogs":{"input":{"type":"structure","required":["DeliverLogsPermissionArn","LogGroupName","ResourceIds","ResourceType","TrafficType"],"members":{"ClientToken":{},"DeliverLogsPermissionArn":{},"LogGroupName":{},"ResourceIds":{"shape":"Sa","locationName":"ResourceId"},"ResourceType":{},"TrafficType":{}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"FlowLogIds":{"shape":"Sa","locationName":"flowLogIdSet"},"Unsuccessful":{"shape":"Sc","locationName":"unsuccessful"}}}},"CreateFpgaImage":{"input":{"type":"structure","required":["InputStorageLocation"],"members":{"DryRun":{"type":"boolean"},"InputStorageLocation":{"shape":"S4u"},"LogsStorageLocation":{"shape":"S4u"},"Description":{},"Name":{},"ClientToken":{}}},"output":{"type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"},"FpgaImageGlobalId":{"locationName":"fpgaImageGlobalId"}}}},"CreateImage":{"input":{"type":"structure","required":["InstanceId","Name"],"members":{"BlockDeviceMappings":{"shape":"S4x","locationName":"blockDeviceMapping"},"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"},"Name":{"locationName":"name"},"NoReboot":{"locationName":"noReboot","type":"boolean"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"CreateInstanceExportTask":{"input":{"type":"structure","required":["InstanceId"],"members":{"Description":{"locationName":"description"},"ExportToS3Task":{"locationName":"exportToS3","type":"structure","members":{"ContainerFormat":{"locationName":"containerFormat"},"DiskImageFormat":{"locationName":"diskImageFormat"},"S3Bucket":{"locationName":"s3Bucket"},"S3Prefix":{"locationName":"s3Prefix"}}},"InstanceId":{"locationName":"instanceId"},"TargetEnvironment":{"locationName":"targetEnvironment"}}},"output":{"type":"structure","members":{"ExportTask":{"shape":"S58","locationName":"exportTask"}}}},"CreateInternetGateway":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InternetGateway":{"shape":"S5e","locationName":"internetGateway"}}}},"CreateKeyPair":{"input":{"type":"structure","required":["KeyName"],"members":{"KeyName":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"KeyFingerprint":{"locationName":"keyFingerprint"},"KeyMaterial":{"locationName":"keyMaterial"},"KeyName":{"locationName":"keyName"}}}},"CreateLaunchTemplate":{"input":{"type":"structure","required":["LaunchTemplateName","LaunchTemplateData"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"LaunchTemplateName":{},"VersionDescription":{},"LaunchTemplateData":{"shape":"S5k"}}},"output":{"type":"structure","members":{"LaunchTemplate":{"shape":"S6d","locationName":"launchTemplate"}}}},"CreateLaunchTemplateVersion":{"input":{"type":"structure","required":["LaunchTemplateData"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"LaunchTemplateId":{},"LaunchTemplateName":{},"SourceVersion":{},"VersionDescription":{},"LaunchTemplateData":{"shape":"S5k"}}},"output":{"type":"structure","members":{"LaunchTemplateVersion":{"shape":"S6g","locationName":"launchTemplateVersion"}}}},"CreateNatGateway":{"input":{"type":"structure","required":["AllocationId","SubnetId"],"members":{"AllocationId":{},"ClientToken":{},"SubnetId":{}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"NatGateway":{"shape":"S71","locationName":"natGateway"}}}},"CreateNetworkAcl":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"NetworkAcl":{"shape":"S78","locationName":"networkAcl"}}}},"CreateNetworkAclEntry":{"input":{"type":"structure","required":["Egress","NetworkAclId","Protocol","RuleAction","RuleNumber"],"members":{"CidrBlock":{"locationName":"cidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Egress":{"locationName":"egress","type":"boolean"},"IcmpTypeCode":{"shape":"S7d","locationName":"Icmp"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"NetworkAclId":{"locationName":"networkAclId"},"PortRange":{"shape":"S7e","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"CreateNetworkInterface":{"input":{"type":"structure","required":["SubnetId"],"members":{"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Groups":{"shape":"S5r","locationName":"SecurityGroupId"},"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"S6o","locationName":"ipv6Addresses"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"shape":"S5u","locationName":"privateIpAddresses"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"SubnetId":{"locationName":"subnetId"}}},"output":{"type":"structure","members":{"NetworkInterface":{"shape":"S7j","locationName":"networkInterface"}}}},"CreateNetworkInterfacePermission":{"input":{"type":"structure","required":["NetworkInterfaceId","Permission"],"members":{"NetworkInterfaceId":{},"AwsAccountId":{},"AwsService":{},"Permission":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"InterfacePermission":{"shape":"S7x","locationName":"interfacePermission"}}}},"CreatePlacementGroup":{"input":{"type":"structure","required":["GroupName","Strategy"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupName":{"locationName":"groupName"},"Strategy":{"locationName":"strategy"}}}},"CreateReservedInstancesListing":{"input":{"type":"structure","required":["ClientToken","InstanceCount","PriceSchedules","ReservedInstancesId"],"members":{"ClientToken":{"locationName":"clientToken"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"PriceSchedules":{"locationName":"priceSchedules","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Price":{"locationName":"price","type":"double"},"Term":{"locationName":"term","type":"long"}}}},"ReservedInstancesId":{"locationName":"reservedInstancesId"}}},"output":{"type":"structure","members":{"ReservedInstancesListings":{"shape":"S2w","locationName":"reservedInstancesListingsSet"}}}},"CreateRoute":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"NatGatewayId":{"locationName":"natGatewayId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"RouteTableId":{"locationName":"routeTableId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"CreateRouteTable":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"RouteTable":{"shape":"S8a","locationName":"routeTable"}}}},"CreateSecurityGroup":{"input":{"type":"structure","required":["Description","GroupName"],"members":{"Description":{"locationName":"GroupDescription"},"GroupName":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"GroupId":{"locationName":"groupId"}}}},"CreateSnapshot":{"input":{"type":"structure","required":["VolumeId"],"members":{"Description":{},"VolumeId":{},"TagSpecifications":{"shape":"S8m","locationName":"TagSpecification"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"shape":"S8o"}},"CreateSpotDatafeedSubscription":{"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"locationName":"bucket"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Prefix":{"locationName":"prefix"}}},"output":{"type":"structure","members":{"SpotDatafeedSubscription":{"shape":"S8s","locationName":"spotDatafeedSubscription"}}}},"CreateSubnet":{"input":{"type":"structure","required":["CidrBlock","VpcId"],"members":{"AvailabilityZone":{},"CidrBlock":{},"Ipv6CidrBlock":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Subnet":{"shape":"S40","locationName":"subnet"}}}},"CreateTags":{"input":{"type":"structure","required":["Resources","Tags"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Resources":{"shape":"S8y","locationName":"ResourceId"},"Tags":{"shape":"Sr","locationName":"Tag"}}}},"CreateVolume":{"input":{"type":"structure","required":["AvailabilityZone"],"members":{"AvailabilityZone":{},"Encrypted":{"locationName":"encrypted","type":"boolean"},"Iops":{"type":"integer"},"KmsKeyId":{},"Size":{"type":"integer"},"SnapshotId":{},"VolumeType":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"TagSpecifications":{"shape":"S8m","locationName":"TagSpecification"}}},"output":{"shape":"S90"}},"CreateVpc":{"input":{"type":"structure","required":["CidrBlock"],"members":{"CidrBlock":{},"AmazonProvidedIpv6CidrBlock":{"locationName":"amazonProvidedIpv6CidrBlock","type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceTenancy":{"locationName":"instanceTenancy"}}},"output":{"type":"structure","members":{"Vpc":{"shape":"S45","locationName":"vpc"}}}},"CreateVpcEndpoint":{"input":{"type":"structure","required":["VpcId","ServiceName"],"members":{"DryRun":{"type":"boolean"},"VpcEndpointType":{},"VpcId":{},"ServiceName":{},"PolicyDocument":{},"RouteTableIds":{"shape":"Sa","locationName":"RouteTableId"},"SubnetIds":{"shape":"Sa","locationName":"SubnetId"},"SecurityGroupIds":{"shape":"Sa","locationName":"SecurityGroupId"},"ClientToken":{},"PrivateDnsEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpcEndpoint":{"shape":"S98","locationName":"vpcEndpoint"},"ClientToken":{"locationName":"clientToken"}}}},"CreateVpcEndpointConnectionNotification":{"input":{"type":"structure","required":["ConnectionNotificationArn","ConnectionEvents"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"VpcEndpointId":{},"ConnectionNotificationArn":{},"ConnectionEvents":{"shape":"Sa"},"ClientToken":{}}},"output":{"type":"structure","members":{"ConnectionNotification":{"shape":"S9g","locationName":"connectionNotification"},"ClientToken":{"locationName":"clientToken"}}}},"CreateVpcEndpointServiceConfiguration":{"input":{"type":"structure","required":["NetworkLoadBalancerArns"],"members":{"DryRun":{"type":"boolean"},"AcceptanceRequired":{"type":"boolean"},"NetworkLoadBalancerArns":{"shape":"Sa","locationName":"NetworkLoadBalancerArn"},"ClientToken":{}}},"output":{"type":"structure","members":{"ServiceConfiguration":{"shape":"S9l","locationName":"serviceConfiguration"},"ClientToken":{"locationName":"clientToken"}}}},"CreateVpcPeeringConnection":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"PeerOwnerId":{"locationName":"peerOwnerId"},"PeerVpcId":{"locationName":"peerVpcId"},"VpcId":{"locationName":"vpcId"},"PeerRegion":{}}},"output":{"type":"structure","members":{"VpcPeeringConnection":{"shape":"Sh","locationName":"vpcPeeringConnection"}}}},"CreateVpnConnection":{"input":{"type":"structure","required":["CustomerGatewayId","Type","VpnGatewayId"],"members":{"CustomerGatewayId":{},"Type":{},"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"Options":{"locationName":"options","type":"structure","members":{"StaticRoutesOnly":{"locationName":"staticRoutesOnly","type":"boolean"},"TunnelOptions":{"type":"list","member":{"locationName":"item","type":"structure","members":{"TunnelInsideCidr":{},"PreSharedKey":{}}}}}}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"S9x","locationName":"vpnConnection"}}}},"CreateVpnConnectionRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","VpnConnectionId"],"members":{"DestinationCidrBlock":{},"VpnConnectionId":{}}}},"CreateVpnGateway":{"input":{"type":"structure","required":["Type"],"members":{"AvailabilityZone":{},"Type":{},"AmazonSideAsn":{"type":"long"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpnGateway":{"shape":"Sa9","locationName":"vpnGateway"}}}},"DeleteCustomerGateway":{"input":{"type":"structure","required":["CustomerGatewayId"],"members":{"CustomerGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteDhcpOptions":{"input":{"type":"structure","required":["DhcpOptionsId"],"members":{"DhcpOptionsId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteEgressOnlyInternetGateway":{"input":{"type":"structure","required":["EgressOnlyInternetGatewayId"],"members":{"DryRun":{"type":"boolean"},"EgressOnlyInternetGatewayId":{}}},"output":{"type":"structure","members":{"ReturnCode":{"locationName":"returnCode","type":"boolean"}}}},"DeleteFlowLogs":{"input":{"type":"structure","required":["FlowLogIds"],"members":{"FlowLogIds":{"shape":"Sa","locationName":"FlowLogId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"Sc","locationName":"unsuccessful"}}}},"DeleteFpgaImage":{"input":{"type":"structure","required":["FpgaImageId"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DeleteInternetGateway":{"input":{"type":"structure","required":["InternetGatewayId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayId":{"locationName":"internetGatewayId"}}}},"DeleteKeyPair":{"input":{"type":"structure","required":["KeyName"],"members":{"KeyName":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteLaunchTemplate":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"LaunchTemplateId":{},"LaunchTemplateName":{}}},"output":{"type":"structure","members":{"LaunchTemplate":{"shape":"S6d","locationName":"launchTemplate"}}}},"DeleteLaunchTemplateVersions":{"input":{"type":"structure","required":["Versions"],"members":{"DryRun":{"type":"boolean"},"LaunchTemplateId":{},"LaunchTemplateName":{},"Versions":{"shape":"Sao","locationName":"LaunchTemplateVersion"}}},"output":{"type":"structure","members":{"SuccessfullyDeletedLaunchTemplateVersions":{"locationName":"successfullyDeletedLaunchTemplateVersionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"VersionNumber":{"locationName":"versionNumber","type":"long"}}}},"UnsuccessfullyDeletedLaunchTemplateVersions":{"locationName":"unsuccessfullyDeletedLaunchTemplateVersionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"VersionNumber":{"locationName":"versionNumber","type":"long"},"ResponseError":{"locationName":"responseError","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}}}}},"DeleteNatGateway":{"input":{"type":"structure","required":["NatGatewayId"],"members":{"NatGatewayId":{}}},"output":{"type":"structure","members":{"NatGatewayId":{"locationName":"natGatewayId"}}}},"DeleteNetworkAcl":{"input":{"type":"structure","required":["NetworkAclId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"}}}},"DeleteNetworkAclEntry":{"input":{"type":"structure","required":["Egress","NetworkAclId","RuleNumber"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Egress":{"locationName":"egress","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"DeleteNetworkInterface":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}}},"DeleteNetworkInterfacePermission":{"input":{"type":"structure","required":["NetworkInterfacePermissionId"],"members":{"NetworkInterfacePermissionId":{},"Force":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DeletePlacementGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupName":{"locationName":"groupName"}}}},"DeleteRoute":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"}}}},"DeleteRouteTable":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"}}}},"DeleteSecurityGroup":{"input":{"type":"structure","members":{"GroupId":{},"GroupName":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSnapshot":{"input":{"type":"structure","required":["SnapshotId"],"members":{"SnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSpotDatafeedSubscription":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSubnet":{"input":{"type":"structure","required":["SubnetId"],"members":{"SubnetId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteTags":{"input":{"type":"structure","required":["Resources"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Resources":{"shape":"S8y","locationName":"resourceId"},"Tags":{"shape":"Sr","locationName":"tag"}}}},"DeleteVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteVpc":{"input":{"type":"structure","required":["VpcId"],"members":{"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteVpcEndpointConnectionNotifications":{"input":{"type":"structure","required":["ConnectionNotificationIds"],"members":{"DryRun":{"type":"boolean"},"ConnectionNotificationIds":{"shape":"Sa","locationName":"ConnectionNotificationId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"Sc","locationName":"unsuccessful"}}}},"DeleteVpcEndpointServiceConfigurations":{"input":{"type":"structure","required":["ServiceIds"],"members":{"DryRun":{"type":"boolean"},"ServiceIds":{"shape":"Sa","locationName":"ServiceId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"Sc","locationName":"unsuccessful"}}}},"DeleteVpcEndpoints":{"input":{"type":"structure","required":["VpcEndpointIds"],"members":{"DryRun":{"type":"boolean"},"VpcEndpointIds":{"shape":"Sa","locationName":"VpcEndpointId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"Sc","locationName":"unsuccessful"}}}},"DeleteVpcPeeringConnection":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DeleteVpnConnection":{"input":{"type":"structure","required":["VpnConnectionId"],"members":{"VpnConnectionId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteVpnConnectionRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","VpnConnectionId"],"members":{"DestinationCidrBlock":{},"VpnConnectionId":{}}}},"DeleteVpnGateway":{"input":{"type":"structure","required":["VpnGatewayId"],"members":{"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeregisterImage":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{"AttributeNames":{"locationName":"attributeName","type":"list","member":{"locationName":"attributeName"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"AccountAttributes":{"locationName":"accountAttributeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AttributeName":{"locationName":"attributeName"},"AttributeValues":{"locationName":"attributeValueSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AttributeValue":{"locationName":"attributeValue"}}}}}}}}}},"DescribeAddresses":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"PublicIps":{"locationName":"PublicIp","type":"list","member":{"locationName":"PublicIp"}},"AllocationIds":{"locationName":"AllocationId","type":"list","member":{"locationName":"AllocationId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Addresses":{"locationName":"addressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"PublicIp":{"locationName":"publicIp"},"AllocationId":{"locationName":"allocationId"},"AssociationId":{"locationName":"associationId"},"Domain":{"locationName":"domain"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"NetworkInterfaceOwnerId":{"locationName":"networkInterfaceOwnerId"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"Tags":{"shape":"Sr","locationName":"tagSet"}}}}}}},"DescribeAggregateIdFormat":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"UseLongIdsAggregated":{"locationName":"useLongIdsAggregated","type":"boolean"},"Statuses":{"shape":"Sc7","locationName":"statusSet"}}}},"DescribeAvailabilityZones":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"ZoneNames":{"locationName":"ZoneName","type":"list","member":{"locationName":"ZoneName"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"AvailabilityZones":{"locationName":"availabilityZoneInfo","type":"list","member":{"locationName":"item","type":"structure","members":{"State":{"locationName":"zoneState"},"Messages":{"locationName":"messageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Message":{"locationName":"message"}}}},"RegionName":{"locationName":"regionName"},"ZoneName":{"locationName":"zoneName"}}}}}}},"DescribeBundleTasks":{"input":{"type":"structure","members":{"BundleIds":{"locationName":"BundleId","type":"list","member":{"locationName":"BundleId"}},"Filters":{"shape":"Sby","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BundleTasks":{"locationName":"bundleInstanceTasksSet","type":"list","member":{"shape":"S2l","locationName":"item"}}}}},"DescribeClassicLinkInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceIds":{"shape":"Scm","locationName":"InstanceId"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Instances":{"locationName":"instancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Groups":{"shape":"S7m","locationName":"groupSet"},"InstanceId":{"locationName":"instanceId"},"Tags":{"shape":"Sr","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeConversionTasks":{"input":{"type":"structure","members":{"ConversionTaskIds":{"locationName":"conversionTaskId","type":"list","member":{"locationName":"item"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"ConversionTasks":{"locationName":"conversionTasks","type":"list","member":{"shape":"Scu","locationName":"item"}}}}},"DescribeCustomerGateways":{"input":{"type":"structure","members":{"CustomerGatewayIds":{"locationName":"CustomerGatewayId","type":"list","member":{"locationName":"CustomerGatewayId"}},"Filters":{"shape":"Sby","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"CustomerGateways":{"locationName":"customerGatewaySet","type":"list","member":{"shape":"S3x","locationName":"item"}}}}},"DescribeDhcpOptions":{"input":{"type":"structure","members":{"DhcpOptionsIds":{"locationName":"DhcpOptionsId","type":"list","member":{"locationName":"DhcpOptionsId"}},"Filters":{"shape":"Sby","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"DhcpOptions":{"locationName":"dhcpOptionsSet","type":"list","member":{"shape":"S4e","locationName":"item"}}}}},"DescribeEgressOnlyInternetGateways":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"EgressOnlyInternetGatewayIds":{"locationName":"EgressOnlyInternetGatewayId","type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EgressOnlyInternetGateways":{"locationName":"egressOnlyInternetGatewaySet","type":"list","member":{"shape":"S4l","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeElasticGpus":{"input":{"type":"structure","members":{"ElasticGpuIds":{"locationName":"ElasticGpuId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"Sby","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ElasticGpuSet":{"locationName":"elasticGpuSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ElasticGpuId":{"locationName":"elasticGpuId"},"AvailabilityZone":{"locationName":"availabilityZone"},"ElasticGpuType":{"locationName":"elasticGpuType"},"ElasticGpuHealth":{"locationName":"elasticGpuHealth","type":"structure","members":{"Status":{"locationName":"status"}}},"ElasticGpuState":{"locationName":"elasticGpuState"},"InstanceId":{"locationName":"instanceId"}}}},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}}},"DescribeExportTasks":{"input":{"type":"structure","members":{"ExportTaskIds":{"locationName":"exportTaskId","type":"list","member":{"locationName":"ExportTaskId"}}}},"output":{"type":"structure","members":{"ExportTasks":{"locationName":"exportTaskSet","type":"list","member":{"shape":"S58","locationName":"item"}}}}},"DescribeFlowLogs":{"input":{"type":"structure","members":{"Filter":{"shape":"Sby"},"FlowLogIds":{"shape":"Sa","locationName":"FlowLogId"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FlowLogs":{"locationName":"flowLogSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CreationTime":{"locationName":"creationTime","type":"timestamp"},"DeliverLogsErrorMessage":{"locationName":"deliverLogsErrorMessage"},"DeliverLogsPermissionArn":{"locationName":"deliverLogsPermissionArn"},"DeliverLogsStatus":{"locationName":"deliverLogsStatus"},"FlowLogId":{"locationName":"flowLogId"},"FlowLogStatus":{"locationName":"flowLogStatus"},"LogGroupName":{"locationName":"logGroupName"},"ResourceId":{"locationName":"resourceId"},"TrafficType":{"locationName":"trafficType"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeFpgaImageAttribute":{"input":{"type":"structure","required":["FpgaImageId","Attribute"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{},"Attribute":{}}},"output":{"type":"structure","members":{"FpgaImageAttribute":{"shape":"Sdy","locationName":"fpgaImageAttribute"}}}},"DescribeFpgaImages":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"FpgaImageIds":{"locationName":"FpgaImageId","type":"list","member":{"locationName":"item"}},"Owners":{"shape":"Se7","locationName":"Owner"},"Filters":{"shape":"Sby","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FpgaImages":{"locationName":"fpgaImageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"},"FpgaImageGlobalId":{"locationName":"fpgaImageGlobalId"},"Name":{"locationName":"name"},"Description":{"locationName":"description"},"ShellVersion":{"locationName":"shellVersion"},"PciId":{"locationName":"pciId","type":"structure","members":{"DeviceId":{},"VendorId":{},"SubsystemId":{},"SubsystemVendorId":{}}},"State":{"locationName":"state","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"CreateTime":{"locationName":"createTime","type":"timestamp"},"UpdateTime":{"locationName":"updateTime","type":"timestamp"},"OwnerId":{"locationName":"ownerId"},"OwnerAlias":{"locationName":"ownerAlias"},"ProductCodes":{"shape":"Se2","locationName":"productCodes"},"Tags":{"shape":"Sr","locationName":"tags"},"Public":{"locationName":"public","type":"boolean"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeHostReservationOfferings":{"input":{"type":"structure","members":{"Filter":{"shape":"Sby"},"MaxDuration":{"type":"integer"},"MaxResults":{"type":"integer"},"MinDuration":{"type":"integer"},"NextToken":{},"OfferingId":{}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"OfferingSet":{"locationName":"offeringSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceFamily":{"locationName":"instanceFamily"},"OfferingId":{"locationName":"offeringId"},"PaymentOption":{"locationName":"paymentOption"},"UpfrontPrice":{"locationName":"upfrontPrice"}}}}}}},"DescribeHostReservations":{"input":{"type":"structure","members":{"Filter":{"shape":"Sby"},"HostReservationIdSet":{"type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"HostReservationSet":{"locationName":"hostReservationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"End":{"locationName":"end","type":"timestamp"},"HostIdSet":{"shape":"Seq","locationName":"hostIdSet"},"HostReservationId":{"locationName":"hostReservationId"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceFamily":{"locationName":"instanceFamily"},"OfferingId":{"locationName":"offeringId"},"PaymentOption":{"locationName":"paymentOption"},"Start":{"locationName":"start","type":"timestamp"},"State":{"locationName":"state"},"UpfrontPrice":{"locationName":"upfrontPrice"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeHosts":{"input":{"type":"structure","members":{"Filter":{"shape":"Sby","locationName":"filter"},"HostIds":{"shape":"Set","locationName":"hostId"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Hosts":{"locationName":"hostSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AutoPlacement":{"locationName":"autoPlacement"},"AvailabilityZone":{"locationName":"availabilityZone"},"AvailableCapacity":{"locationName":"availableCapacity","type":"structure","members":{"AvailableInstanceCapacity":{"locationName":"availableInstanceCapacity","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailableCapacity":{"locationName":"availableCapacity","type":"integer"},"InstanceType":{"locationName":"instanceType"},"TotalCapacity":{"locationName":"totalCapacity","type":"integer"}}}},"AvailableVCpus":{"locationName":"availableVCpus","type":"integer"}}},"ClientToken":{"locationName":"clientToken"},"HostId":{"locationName":"hostId"},"HostProperties":{"locationName":"hostProperties","type":"structure","members":{"Cores":{"locationName":"cores","type":"integer"},"InstanceType":{"locationName":"instanceType"},"Sockets":{"locationName":"sockets","type":"integer"},"TotalVCpus":{"locationName":"totalVCpus","type":"integer"}}},"HostReservationId":{"locationName":"hostReservationId"},"Instances":{"locationName":"instances","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"}}}},"State":{"locationName":"state"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeIamInstanceProfileAssociations":{"input":{"type":"structure","members":{"AssociationIds":{"locationName":"AssociationId","type":"list","member":{"locationName":"AssociationId"}},"Filters":{"shape":"Sby","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociations":{"locationName":"iamInstanceProfileAssociationSet","type":"list","member":{"shape":"S1b","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeIdFormat":{"input":{"type":"structure","members":{"Resource":{}}},"output":{"type":"structure","members":{"Statuses":{"shape":"Sc7","locationName":"statusSet"}}}},"DescribeIdentityIdFormat":{"input":{"type":"structure","required":["PrincipalArn"],"members":{"PrincipalArn":{"locationName":"principalArn"},"Resource":{"locationName":"resource"}}},"output":{"type":"structure","members":{"Statuses":{"shape":"Sc7","locationName":"statusSet"}}}},"DescribeImageAttribute":{"input":{"type":"structure","required":["Attribute","ImageId"],"members":{"Attribute":{},"ImageId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BlockDeviceMappings":{"shape":"Sff","locationName":"blockDeviceMapping"},"ImageId":{"locationName":"imageId"},"LaunchPermissions":{"shape":"Sfg","locationName":"launchPermission"},"ProductCodes":{"shape":"Se2","locationName":"productCodes"},"Description":{"shape":"S4i","locationName":"description"},"KernelId":{"shape":"S4i","locationName":"kernel"},"RamdiskId":{"shape":"S4i","locationName":"ramdisk"},"SriovNetSupport":{"shape":"S4i","locationName":"sriovNetSupport"}}}},"DescribeImages":{"input":{"type":"structure","members":{"ExecutableUsers":{"locationName":"ExecutableBy","type":"list","member":{"locationName":"ExecutableBy"}},"Filters":{"shape":"Sby","locationName":"Filter"},"ImageIds":{"locationName":"ImageId","type":"list","member":{"locationName":"ImageId"}},"Owners":{"shape":"Se7","locationName":"Owner"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Images":{"locationName":"imagesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Architecture":{"locationName":"architecture"},"CreationDate":{"locationName":"creationDate"},"ImageId":{"locationName":"imageId"},"ImageLocation":{"locationName":"imageLocation"},"ImageType":{"locationName":"imageType"},"Public":{"locationName":"isPublic","type":"boolean"},"KernelId":{"locationName":"kernelId"},"OwnerId":{"locationName":"imageOwnerId"},"Platform":{"locationName":"platform"},"ProductCodes":{"shape":"Se2","locationName":"productCodes"},"RamdiskId":{"locationName":"ramdiskId"},"State":{"locationName":"imageState"},"BlockDeviceMappings":{"shape":"Sff","locationName":"blockDeviceMapping"},"Description":{"locationName":"description"},"EnaSupport":{"locationName":"enaSupport","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"ImageOwnerAlias":{"locationName":"imageOwnerAlias"},"Name":{"locationName":"name"},"RootDeviceName":{"locationName":"rootDeviceName"},"RootDeviceType":{"locationName":"rootDeviceType"},"SriovNetSupport":{"locationName":"sriovNetSupport"},"StateReason":{"shape":"Sft","locationName":"stateReason"},"Tags":{"shape":"Sr","locationName":"tagSet"},"VirtualizationType":{"locationName":"virtualizationType"}}}}}}},"DescribeImportImageTasks":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sby"},"ImportTaskIds":{"shape":"Sfw","locationName":"ImportTaskId"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ImportImageTasks":{"locationName":"importImageTaskSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Architecture":{"locationName":"architecture"},"Description":{"locationName":"description"},"Hypervisor":{"locationName":"hypervisor"},"ImageId":{"locationName":"imageId"},"ImportTaskId":{"locationName":"importTaskId"},"LicenseType":{"locationName":"licenseType"},"Platform":{"locationName":"platform"},"Progress":{"locationName":"progress"},"SnapshotDetails":{"shape":"Sg0","locationName":"snapshotDetailSet"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeImportSnapshotTasks":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sby"},"ImportTaskIds":{"shape":"Sfw","locationName":"ImportTaskId"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ImportSnapshotTasks":{"locationName":"importSnapshotTaskSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"ImportTaskId":{"locationName":"importTaskId"},"SnapshotTaskDetail":{"shape":"Sg7","locationName":"snapshotTaskDetail"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceAttribute":{"input":{"type":"structure","required":["Attribute","InstanceId"],"members":{"Attribute":{"locationName":"attribute"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"}}},"output":{"type":"structure","members":{"Groups":{"shape":"S7m","locationName":"groupSet"},"BlockDeviceMappings":{"shape":"Sgb","locationName":"blockDeviceMapping"},"DisableApiTermination":{"shape":"Sge","locationName":"disableApiTermination"},"EnaSupport":{"shape":"Sge","locationName":"enaSupport"},"EbsOptimized":{"shape":"Sge","locationName":"ebsOptimized"},"InstanceId":{"locationName":"instanceId"},"InstanceInitiatedShutdownBehavior":{"shape":"S4i","locationName":"instanceInitiatedShutdownBehavior"},"InstanceType":{"shape":"S4i","locationName":"instanceType"},"KernelId":{"shape":"S4i","locationName":"kernel"},"ProductCodes":{"shape":"Se2","locationName":"productCodes"},"RamdiskId":{"shape":"S4i","locationName":"ramdisk"},"RootDeviceName":{"shape":"S4i","locationName":"rootDeviceName"},"SourceDestCheck":{"shape":"Sge","locationName":"sourceDestCheck"},"SriovNetSupport":{"shape":"S4i","locationName":"sriovNetSupport"},"UserData":{"shape":"S4i","locationName":"userData"}}}},"DescribeInstanceCreditSpecifications":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sby","locationName":"Filter"},"InstanceIds":{"shape":"Scm","locationName":"InstanceId"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceCreditSpecifications":{"locationName":"instanceCreditSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"CpuCredits":{"locationName":"cpuCredits"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceStatus":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"InstanceIds":{"shape":"Scm","locationName":"InstanceId"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"IncludeAllInstances":{"locationName":"includeAllInstances","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceStatuses":{"locationName":"instanceStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Events":{"locationName":"eventsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Code":{"locationName":"code"},"Description":{"locationName":"description"},"NotAfter":{"locationName":"notAfter","type":"timestamp"},"NotBefore":{"locationName":"notBefore","type":"timestamp"}}}},"InstanceId":{"locationName":"instanceId"},"InstanceState":{"shape":"Sgq","locationName":"instanceState"},"InstanceStatus":{"shape":"Sgs","locationName":"instanceStatus"},"SystemStatus":{"shape":"Sgs","locationName":"systemStatus"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"InstanceIds":{"shape":"Scm","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Reservations":{"locationName":"reservationSet","type":"list","member":{"shape":"Sh1","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInternetGateways":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayIds":{"shape":"Sa","locationName":"internetGatewayId"}}},"output":{"type":"structure","members":{"InternetGateways":{"locationName":"internetGatewaySet","type":"list","member":{"shape":"S5e","locationName":"item"}}}}},"DescribeKeyPairs":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"KeyNames":{"locationName":"KeyName","type":"list","member":{"locationName":"KeyName"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"KeyPairs":{"locationName":"keySet","type":"list","member":{"locationName":"item","type":"structure","members":{"KeyFingerprint":{"locationName":"keyFingerprint"},"KeyName":{"locationName":"keyName"}}}}}}},"DescribeLaunchTemplateVersions":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"LaunchTemplateId":{},"LaunchTemplateName":{},"Versions":{"shape":"Sao","locationName":"LaunchTemplateVersion"},"MinVersion":{},"MaxVersion":{},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"Sby","locationName":"Filter"}}},"output":{"type":"structure","members":{"LaunchTemplateVersions":{"locationName":"launchTemplateVersionSet","type":"list","member":{"shape":"S6g","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLaunchTemplates":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"LaunchTemplateIds":{"shape":"Sa","locationName":"LaunchTemplateId"},"LaunchTemplateNames":{"locationName":"LaunchTemplateName","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sby","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"LaunchTemplates":{"locationName":"launchTemplates","type":"list","member":{"shape":"S6d","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeMovingAddresses":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"PublicIps":{"shape":"Sa","locationName":"publicIp"}}},"output":{"type":"structure","members":{"MovingAddressStatuses":{"locationName":"movingAddressStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"MoveStatus":{"locationName":"moveStatus"},"PublicIp":{"locationName":"publicIp"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNatGateways":{"input":{"type":"structure","members":{"Filter":{"shape":"Sby"},"MaxResults":{"type":"integer"},"NatGatewayIds":{"shape":"Sa","locationName":"NatGatewayId"},"NextToken":{}}},"output":{"type":"structure","members":{"NatGateways":{"locationName":"natGatewaySet","type":"list","member":{"shape":"S71","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkAcls":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkAclIds":{"shape":"Sa","locationName":"NetworkAclId"}}},"output":{"type":"structure","members":{"NetworkAcls":{"locationName":"networkAclSet","type":"list","member":{"shape":"S78","locationName":"item"}}}}},"DescribeNetworkInterfaceAttribute":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Attribute":{"locationName":"attribute"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"Attachment":{"shape":"S7l","locationName":"attachment"},"Description":{"shape":"S4i","locationName":"description"},"Groups":{"shape":"S7m","locationName":"groupSet"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"SourceDestCheck":{"shape":"Sge","locationName":"sourceDestCheck"}}}},"DescribeNetworkInterfacePermissions":{"input":{"type":"structure","members":{"NetworkInterfacePermissionIds":{"locationName":"NetworkInterfacePermissionId","type":"list","member":{}},"Filters":{"shape":"Sby","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NetworkInterfacePermissions":{"locationName":"networkInterfacePermissions","type":"list","member":{"shape":"S7x","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkInterfaces":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceIds":{"locationName":"NetworkInterfaceId","type":"list","member":{"locationName":"item"}}}},"output":{"type":"structure","members":{"NetworkInterfaces":{"locationName":"networkInterfaceSet","type":"list","member":{"shape":"S7j","locationName":"item"}}}}},"DescribePlacementGroups":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupNames":{"locationName":"groupName","type":"list","member":{}}}},"output":{"type":"structure","members":{"PlacementGroups":{"locationName":"placementGroupSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GroupName":{"locationName":"groupName"},"State":{"locationName":"state"},"Strategy":{"locationName":"strategy"}}}}}}},"DescribePrefixLists":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sby","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"PrefixListIds":{"shape":"Sa","locationName":"PrefixListId"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"PrefixLists":{"locationName":"prefixListSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Cidrs":{"shape":"Sa","locationName":"cidrSet"},"PrefixListId":{"locationName":"prefixListId"},"PrefixListName":{"locationName":"prefixListName"}}}}}}},"DescribePrincipalIdFormat":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Resources":{"locationName":"Resource","type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Principals":{"locationName":"principalSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Arn":{"locationName":"arn"},"Statuses":{"shape":"Sc7","locationName":"statusSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeRegions":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"RegionNames":{"locationName":"RegionName","type":"list","member":{"locationName":"RegionName"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Regions":{"locationName":"regionInfo","type":"list","member":{"locationName":"item","type":"structure","members":{"Endpoint":{"locationName":"regionEndpoint"},"RegionName":{"locationName":"regionName"}}}}}}},"DescribeReservedInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"OfferingClass":{},"ReservedInstancesIds":{"shape":"Sj3","locationName":"ReservedInstancesId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"OfferingType":{"locationName":"offeringType"}}},"output":{"type":"structure","members":{"ReservedInstances":{"locationName":"reservedInstancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Duration":{"locationName":"duration","type":"long"},"End":{"locationName":"end","type":"timestamp"},"FixedPrice":{"locationName":"fixedPrice","type":"float"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"InstanceType":{"locationName":"instanceType"},"ProductDescription":{"locationName":"productDescription"},"ReservedInstancesId":{"locationName":"reservedInstancesId"},"Start":{"locationName":"start","type":"timestamp"},"State":{"locationName":"state"},"UsagePrice":{"locationName":"usagePrice","type":"float"},"CurrencyCode":{"locationName":"currencyCode"},"InstanceTenancy":{"locationName":"instanceTenancy"},"OfferingClass":{"locationName":"offeringClass"},"OfferingType":{"locationName":"offeringType"},"RecurringCharges":{"shape":"Sjb","locationName":"recurringCharges"},"Scope":{"locationName":"scope"},"Tags":{"shape":"Sr","locationName":"tagSet"}}}}}}},"DescribeReservedInstancesListings":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"ReservedInstancesId":{"locationName":"reservedInstancesId"},"ReservedInstancesListingId":{"locationName":"reservedInstancesListingId"}}},"output":{"type":"structure","members":{"ReservedInstancesListings":{"shape":"S2w","locationName":"reservedInstancesListingsSet"}}}},"DescribeReservedInstancesModifications":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"ReservedInstancesModificationIds":{"locationName":"ReservedInstancesModificationId","type":"list","member":{"locationName":"ReservedInstancesModificationId"}},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ReservedInstancesModifications":{"locationName":"reservedInstancesModificationsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"EffectiveDate":{"locationName":"effectiveDate","type":"timestamp"},"ModificationResults":{"locationName":"modificationResultSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"},"TargetConfiguration":{"shape":"Sjo","locationName":"targetConfiguration"}}}},"ReservedInstancesIds":{"locationName":"reservedInstancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"}}}},"ReservedInstancesModificationId":{"locationName":"reservedInstancesModificationId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"UpdateDate":{"locationName":"updateDate","type":"timestamp"}}}}}}},"DescribeReservedInstancesOfferings":{"input":{"type":"structure","members":{"AvailabilityZone":{},"Filters":{"shape":"Sby","locationName":"Filter"},"IncludeMarketplace":{"type":"boolean"},"InstanceType":{},"MaxDuration":{"type":"long"},"MaxInstanceCount":{"type":"integer"},"MinDuration":{"type":"long"},"OfferingClass":{},"ProductDescription":{},"ReservedInstancesOfferingIds":{"locationName":"ReservedInstancesOfferingId","type":"list","member":{}},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceTenancy":{"locationName":"instanceTenancy"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"OfferingType":{"locationName":"offeringType"}}},"output":{"type":"structure","members":{"ReservedInstancesOfferings":{"locationName":"reservedInstancesOfferingsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Duration":{"locationName":"duration","type":"long"},"FixedPrice":{"locationName":"fixedPrice","type":"float"},"InstanceType":{"locationName":"instanceType"},"ProductDescription":{"locationName":"productDescription"},"ReservedInstancesOfferingId":{"locationName":"reservedInstancesOfferingId"},"UsagePrice":{"locationName":"usagePrice","type":"float"},"CurrencyCode":{"locationName":"currencyCode"},"InstanceTenancy":{"locationName":"instanceTenancy"},"Marketplace":{"locationName":"marketplace","type":"boolean"},"OfferingClass":{"locationName":"offeringClass"},"OfferingType":{"locationName":"offeringType"},"PricingDetails":{"locationName":"pricingDetailsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"Price":{"locationName":"price","type":"double"}}}},"RecurringCharges":{"shape":"Sjb","locationName":"recurringCharges"},"Scope":{"locationName":"scope"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeRouteTables":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableIds":{"shape":"Sa","locationName":"RouteTableId"}}},"output":{"type":"structure","members":{"RouteTables":{"locationName":"routeTableSet","type":"list","member":{"shape":"S8a","locationName":"item"}}}}},"DescribeScheduledInstanceAvailability":{"input":{"type":"structure","required":["FirstSlotStartTimeRange","Recurrence"],"members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sby","locationName":"Filter"},"FirstSlotStartTimeRange":{"type":"structure","required":["EarliestTime","LatestTime"],"members":{"EarliestTime":{"type":"timestamp"},"LatestTime":{"type":"timestamp"}}},"MaxResults":{"type":"integer"},"MaxSlotDurationInHours":{"type":"integer"},"MinSlotDurationInHours":{"type":"integer"},"NextToken":{},"Recurrence":{"type":"structure","members":{"Frequency":{},"Interval":{"type":"integer"},"OccurrenceDays":{"locationName":"OccurrenceDay","type":"list","member":{"locationName":"OccurenceDay","type":"integer"}},"OccurrenceRelativeToEnd":{"type":"boolean"},"OccurrenceUnit":{}}}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ScheduledInstanceAvailabilitySet":{"locationName":"scheduledInstanceAvailabilitySet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"AvailableInstanceCount":{"locationName":"availableInstanceCount","type":"integer"},"FirstSlotStartTime":{"locationName":"firstSlotStartTime","type":"timestamp"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceType":{"locationName":"instanceType"},"MaxTermDurationInDays":{"locationName":"maxTermDurationInDays","type":"integer"},"MinTermDurationInDays":{"locationName":"minTermDurationInDays","type":"integer"},"NetworkPlatform":{"locationName":"networkPlatform"},"Platform":{"locationName":"platform"},"PurchaseToken":{"locationName":"purchaseToken"},"Recurrence":{"shape":"Sk8","locationName":"recurrence"},"SlotDurationInHours":{"locationName":"slotDurationInHours","type":"integer"},"TotalScheduledInstanceHours":{"locationName":"totalScheduledInstanceHours","type":"integer"}}}}}}},"DescribeScheduledInstances":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sby","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"ScheduledInstanceIds":{"locationName":"ScheduledInstanceId","type":"list","member":{"locationName":"ScheduledInstanceId"}},"SlotStartTimeRange":{"type":"structure","members":{"EarliestTime":{"type":"timestamp"},"LatestTime":{"type":"timestamp"}}}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ScheduledInstanceSet":{"locationName":"scheduledInstanceSet","type":"list","member":{"shape":"Skf","locationName":"item"}}}}},"DescribeSecurityGroupReferences":{"input":{"type":"structure","required":["GroupId"],"members":{"DryRun":{"type":"boolean"},"GroupId":{"type":"list","member":{"locationName":"item"}}}},"output":{"type":"structure","members":{"SecurityGroupReferenceSet":{"locationName":"securityGroupReferenceSet","type":"list","member":{"locationName":"item","type":"structure","required":["GroupId","ReferencingVpcId"],"members":{"GroupId":{"locationName":"groupId"},"ReferencingVpcId":{"locationName":"referencingVpcId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}}}}}},"DescribeSecurityGroups":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"GroupIds":{"shape":"S1s","locationName":"GroupId"},"GroupNames":{"shape":"Skm","locationName":"GroupName"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SecurityGroups":{"locationName":"securityGroupInfo","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"groupDescription"},"GroupName":{"locationName":"groupName"},"IpPermissions":{"shape":"S25","locationName":"ipPermissions"},"OwnerId":{"locationName":"ownerId"},"GroupId":{"locationName":"groupId"},"IpPermissionsEgress":{"shape":"S25","locationName":"ipPermissionsEgress"},"Tags":{"shape":"Sr","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeSnapshotAttribute":{"input":{"type":"structure","required":["Attribute","SnapshotId"],"members":{"Attribute":{},"SnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"CreateVolumePermissions":{"shape":"Skt","locationName":"createVolumePermission"},"ProductCodes":{"shape":"Se2","locationName":"productCodes"},"SnapshotId":{"locationName":"snapshotId"}}}},"DescribeSnapshots":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"OwnerIds":{"shape":"Se7","locationName":"Owner"},"RestorableByUserIds":{"locationName":"RestorableBy","type":"list","member":{}},"SnapshotIds":{"locationName":"SnapshotId","type":"list","member":{"locationName":"SnapshotId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Snapshots":{"locationName":"snapshotSet","type":"list","member":{"shape":"S8o","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeSpotDatafeedSubscription":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"SpotDatafeedSubscription":{"shape":"S8s","locationName":"spotDatafeedSubscription"}}}},"DescribeSpotFleetInstances":{"input":{"type":"structure","required":["SpotFleetRequestId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}},"output":{"type":"structure","required":["ActiveInstances","SpotFleetRequestId"],"members":{"ActiveInstances":{"locationName":"activeInstanceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"},"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"InstanceHealth":{"locationName":"instanceHealth"}}}},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}},"DescribeSpotFleetRequestHistory":{"input":{"type":"structure","required":["SpotFleetRequestId","StartTime"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"EventType":{"locationName":"eventType"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"StartTime":{"locationName":"startTime","type":"timestamp"}}},"output":{"type":"structure","required":["HistoryRecords","LastEvaluatedTime","SpotFleetRequestId","StartTime"],"members":{"HistoryRecords":{"locationName":"historyRecordSet","type":"list","member":{"locationName":"item","type":"structure","required":["EventInformation","EventType","Timestamp"],"members":{"EventInformation":{"locationName":"eventInformation","type":"structure","members":{"EventDescription":{"locationName":"eventDescription"},"EventSubType":{"locationName":"eventSubType"},"InstanceId":{"locationName":"instanceId"}}},"EventType":{"locationName":"eventType"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"LastEvaluatedTime":{"locationName":"lastEvaluatedTime","type":"timestamp"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"StartTime":{"locationName":"startTime","type":"timestamp"}}}},"DescribeSpotFleetRequests":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestIds":{"shape":"Sa","locationName":"spotFleetRequestId"}}},"output":{"type":"structure","required":["SpotFleetRequestConfigs"],"members":{"NextToken":{"locationName":"nextToken"},"SpotFleetRequestConfigs":{"locationName":"spotFleetRequestConfigSet","type":"list","member":{"locationName":"item","type":"structure","required":["CreateTime","SpotFleetRequestConfig","SpotFleetRequestId","SpotFleetRequestState"],"members":{"ActivityStatus":{"locationName":"activityStatus"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"SpotFleetRequestConfig":{"shape":"Sli","locationName":"spotFleetRequestConfig"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"SpotFleetRequestState":{"locationName":"spotFleetRequestState"}}}}}}},"DescribeSpotInstanceRequests":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotInstanceRequestIds":{"shape":"S3h","locationName":"SpotInstanceRequestId"}}},"output":{"type":"structure","members":{"SpotInstanceRequests":{"shape":"Sm8","locationName":"spotInstanceRequestSet"}}}},"DescribeSpotPriceHistory":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"AvailabilityZone":{"locationName":"availabilityZone"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EndTime":{"locationName":"endTime","type":"timestamp"},"InstanceTypes":{"locationName":"InstanceType","type":"list","member":{}},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"ProductDescriptions":{"locationName":"ProductDescription","type":"list","member":{}},"StartTime":{"locationName":"startTime","type":"timestamp"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"SpotPriceHistory":{"locationName":"spotPriceHistorySet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"InstanceType":{"locationName":"instanceType"},"ProductDescription":{"locationName":"productDescription"},"SpotPrice":{"locationName":"spotPrice"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}}}}},"DescribeStaleSecurityGroups":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{},"VpcId":{}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"StaleSecurityGroupSet":{"locationName":"staleSecurityGroupSet","type":"list","member":{"locationName":"item","type":"structure","required":["GroupId"],"members":{"Description":{"locationName":"description"},"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"},"StaleIpPermissions":{"shape":"Smo","locationName":"staleIpPermissions"},"StaleIpPermissionsEgress":{"shape":"Smo","locationName":"staleIpPermissionsEgress"},"VpcId":{"locationName":"vpcId"}}}}}}},"DescribeSubnets":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"SubnetIds":{"locationName":"SubnetId","type":"list","member":{"locationName":"SubnetId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Subnets":{"locationName":"subnetSet","type":"list","member":{"shape":"S40","locationName":"item"}}}}},"DescribeTags":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Filters":{"shape":"Sby","locationName":"Filter"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Tags":{"locationName":"tagSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"Value":{"locationName":"value"}}}}}}},"DescribeVolumeAttribute":{"input":{"type":"structure","required":["VolumeId"],"members":{"Attribute":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"AutoEnableIO":{"shape":"Sge","locationName":"autoEnableIO"},"ProductCodes":{"shape":"Se2","locationName":"productCodes"},"VolumeId":{"locationName":"volumeId"}}}},"DescribeVolumeStatus":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"VolumeIds":{"shape":"Sn5","locationName":"VolumeId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"VolumeStatuses":{"locationName":"volumeStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Actions":{"locationName":"actionsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Code":{"locationName":"code"},"Description":{"locationName":"description"},"EventId":{"locationName":"eventId"},"EventType":{"locationName":"eventType"}}}},"AvailabilityZone":{"locationName":"availabilityZone"},"Events":{"locationName":"eventsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"EventId":{"locationName":"eventId"},"EventType":{"locationName":"eventType"},"NotAfter":{"locationName":"notAfter","type":"timestamp"},"NotBefore":{"locationName":"notBefore","type":"timestamp"}}}},"VolumeId":{"locationName":"volumeId"},"VolumeStatus":{"locationName":"volumeStatus","type":"structure","members":{"Details":{"locationName":"details","type":"list","member":{"locationName":"item","type":"structure","members":{"Name":{"locationName":"name"},"Status":{"locationName":"status"}}}},"Status":{"locationName":"status"}}}}}}}}},"DescribeVolumes":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"VolumeIds":{"shape":"Sn5","locationName":"VolumeId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Volumes":{"locationName":"volumeSet","type":"list","member":{"shape":"S90","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVolumesModifications":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"VolumeIds":{"shape":"Sn5","locationName":"VolumeId"},"Filters":{"shape":"Sby","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"VolumesModifications":{"locationName":"volumeModificationSet","type":"list","member":{"shape":"Sno","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcAttribute":{"input":{"type":"structure","required":["Attribute","VpcId"],"members":{"Attribute":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpcId":{"locationName":"vpcId"},"EnableDnsHostnames":{"shape":"Sge","locationName":"enableDnsHostnames"},"EnableDnsSupport":{"shape":"Sge","locationName":"enableDnsSupport"}}}},"DescribeVpcClassicLink":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcIds":{"shape":"Snu","locationName":"VpcId"}}},"output":{"type":"structure","members":{"Vpcs":{"locationName":"vpcSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ClassicLinkEnabled":{"locationName":"classicLinkEnabled","type":"boolean"},"Tags":{"shape":"Sr","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}}}}}},"DescribeVpcClassicLinkDnsSupport":{"input":{"type":"structure","members":{"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"VpcIds":{"shape":"Snu"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Vpcs":{"locationName":"vpcs","type":"list","member":{"locationName":"item","type":"structure","members":{"ClassicLinkDnsSupported":{"locationName":"classicLinkDnsSupported","type":"boolean"},"VpcId":{"locationName":"vpcId"}}}}}}},"DescribeVpcEndpointConnectionNotifications":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ConnectionNotificationId":{},"Filters":{"shape":"Sby","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ConnectionNotificationSet":{"locationName":"connectionNotificationSet","type":"list","member":{"shape":"S9g","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointConnections":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sby","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"VpcEndpointConnections":{"locationName":"vpcEndpointConnectionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ServiceId":{"locationName":"serviceId"},"VpcEndpointId":{"locationName":"vpcEndpointId"},"VpcEndpointOwner":{"locationName":"vpcEndpointOwner"},"VpcEndpointState":{"locationName":"vpcEndpointState"},"CreationTimestamp":{"locationName":"creationTimestamp","type":"timestamp"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointServiceConfigurations":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ServiceIds":{"shape":"Sa","locationName":"ServiceId"},"Filters":{"shape":"Sby","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ServiceConfigurations":{"locationName":"serviceConfigurationSet","type":"list","member":{"shape":"S9l","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointServicePermissions":{"input":{"type":"structure","required":["ServiceId"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"Filters":{"shape":"Sby","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AllowedPrincipals":{"locationName":"allowedPrincipals","type":"list","member":{"locationName":"item","type":"structure","members":{"PrincipalType":{"locationName":"principalType"},"Principal":{"locationName":"principal"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointServices":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ServiceNames":{"shape":"Sa","locationName":"ServiceName"},"Filters":{"shape":"Sby","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ServiceNames":{"shape":"Sa","locationName":"serviceNameSet"},"ServiceDetails":{"locationName":"serviceDetailSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ServiceName":{"locationName":"serviceName"},"ServiceType":{"shape":"S9m","locationName":"serviceType"},"AvailabilityZones":{"shape":"Sa","locationName":"availabilityZoneSet"},"Owner":{"locationName":"owner"},"BaseEndpointDnsNames":{"shape":"Sa","locationName":"baseEndpointDnsNameSet"},"PrivateDnsName":{"locationName":"privateDnsName"},"VpcEndpointPolicySupported":{"locationName":"vpcEndpointPolicySupported","type":"boolean"},"AcceptanceRequired":{"locationName":"acceptanceRequired","type":"boolean"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpoints":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"VpcEndpointIds":{"shape":"Sa","locationName":"VpcEndpointId"},"Filters":{"shape":"Sby","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"VpcEndpoints":{"locationName":"vpcEndpointSet","type":"list","member":{"shape":"S98","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcPeeringConnections":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionIds":{"shape":"Sa","locationName":"VpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"VpcPeeringConnections":{"locationName":"vpcPeeringConnectionSet","type":"list","member":{"shape":"Sh","locationName":"item"}}}}},"DescribeVpcs":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"VpcIds":{"locationName":"VpcId","type":"list","member":{"locationName":"VpcId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Vpcs":{"locationName":"vpcSet","type":"list","member":{"shape":"S45","locationName":"item"}}}}},"DescribeVpnConnections":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"VpnConnectionIds":{"locationName":"VpnConnectionId","type":"list","member":{"locationName":"VpnConnectionId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnections":{"locationName":"vpnConnectionSet","type":"list","member":{"shape":"S9x","locationName":"item"}}}}},"DescribeVpnGateways":{"input":{"type":"structure","members":{"Filters":{"shape":"Sby","locationName":"Filter"},"VpnGatewayIds":{"locationName":"VpnGatewayId","type":"list","member":{"locationName":"VpnGatewayId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpnGateways":{"locationName":"vpnGatewaySet","type":"list","member":{"shape":"Sa9","locationName":"item"}}}}},"DetachClassicLinkVpc":{"input":{"type":"structure","required":["InstanceId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DetachInternetGateway":{"input":{"type":"structure","required":["InternetGatewayId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayId":{"locationName":"internetGatewayId"},"VpcId":{"locationName":"vpcId"}}}},"DetachNetworkInterface":{"input":{"type":"structure","required":["AttachmentId"],"members":{"AttachmentId":{"locationName":"attachmentId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Force":{"locationName":"force","type":"boolean"}}}},"DetachVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"Device":{},"Force":{"type":"boolean"},"InstanceId":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"shape":"S1y"}},"DetachVpnGateway":{"input":{"type":"structure","required":["VpcId","VpnGatewayId"],"members":{"VpcId":{},"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DisableVgwRoutePropagation":{"input":{"type":"structure","required":["GatewayId","RouteTableId"],"members":{"GatewayId":{},"RouteTableId":{}}}},"DisableVpcClassicLink":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DisableVpcClassicLinkDnsSupport":{"input":{"type":"structure","members":{"VpcId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DisassociateAddress":{"input":{"type":"structure","members":{"AssociationId":{},"PublicIp":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DisassociateIamInstanceProfile":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociation":{"shape":"S1b","locationName":"iamInstanceProfileAssociation"}}}},"DisassociateRouteTable":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{"locationName":"associationId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DisassociateSubnetCidrBlock":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{"locationName":"associationId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S1i","locationName":"ipv6CidrBlockAssociation"},"SubnetId":{"locationName":"subnetId"}}}},"DisassociateVpcCidrBlock":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{"locationName":"associationId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S1n","locationName":"ipv6CidrBlockAssociation"},"CidrBlockAssociation":{"shape":"S1q","locationName":"cidrBlockAssociation"},"VpcId":{"locationName":"vpcId"}}}},"EnableVgwRoutePropagation":{"input":{"type":"structure","required":["GatewayId","RouteTableId"],"members":{"GatewayId":{},"RouteTableId":{}}}},"EnableVolumeIO":{"input":{"type":"structure","required":["VolumeId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VolumeId":{"locationName":"volumeId"}}}},"EnableVpcClassicLink":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"EnableVpcClassicLinkDnsSupport":{"input":{"type":"structure","members":{"VpcId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"GetConsoleOutput":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"Output":{"locationName":"output"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"GetConsoleScreenshot":{"input":{"type":"structure","required":["InstanceId"],"members":{"DryRun":{"type":"boolean"},"InstanceId":{},"WakeUp":{"type":"boolean"}}},"output":{"type":"structure","members":{"ImageData":{"locationName":"imageData"},"InstanceId":{"locationName":"instanceId"}}}},"GetHostReservationPurchasePreview":{"input":{"type":"structure","required":["HostIdSet","OfferingId"],"members":{"HostIdSet":{"shape":"Spx"},"OfferingId":{}}},"output":{"type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Purchase":{"shape":"Spz","locationName":"purchase"},"TotalHourlyPrice":{"locationName":"totalHourlyPrice"},"TotalUpfrontPrice":{"locationName":"totalUpfrontPrice"}}}},"GetLaunchTemplateData":{"input":{"type":"structure","required":["InstanceId"],"members":{"DryRun":{"type":"boolean"},"InstanceId":{}}},"output":{"type":"structure","members":{"LaunchTemplateData":{"shape":"S6h","locationName":"launchTemplateData"}}}},"GetPasswordData":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"PasswordData":{"locationName":"passwordData"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"GetReservedInstancesExchangeQuote":{"input":{"type":"structure","required":["ReservedInstanceIds"],"members":{"DryRun":{"type":"boolean"},"ReservedInstanceIds":{"shape":"S3","locationName":"ReservedInstanceId"},"TargetConfigurations":{"shape":"S5","locationName":"TargetConfiguration"}}},"output":{"type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"IsValidExchange":{"locationName":"isValidExchange","type":"boolean"},"OutputReservedInstancesWillExpireAt":{"locationName":"outputReservedInstancesWillExpireAt","type":"timestamp"},"PaymentDue":{"locationName":"paymentDue"},"ReservedInstanceValueRollup":{"shape":"Sq7","locationName":"reservedInstanceValueRollup"},"ReservedInstanceValueSet":{"locationName":"reservedInstanceValueSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservationValue":{"shape":"Sq7","locationName":"reservationValue"},"ReservedInstanceId":{"locationName":"reservedInstanceId"}}}},"TargetConfigurationValueRollup":{"shape":"Sq7","locationName":"targetConfigurationValueRollup"},"TargetConfigurationValueSet":{"locationName":"targetConfigurationValueSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservationValue":{"shape":"Sq7","locationName":"reservationValue"},"TargetConfiguration":{"locationName":"targetConfiguration","type":"structure","members":{"InstanceCount":{"locationName":"instanceCount","type":"integer"},"OfferingId":{"locationName":"offeringId"}}}}}},"ValidationFailureReason":{"locationName":"validationFailureReason"}}}},"ImportImage":{"input":{"type":"structure","members":{"Architecture":{},"ClientData":{"shape":"Sqe"},"ClientToken":{},"Description":{},"DiskContainers":{"locationName":"DiskContainer","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{},"DeviceName":{},"Format":{},"SnapshotId":{},"Url":{},"UserBucket":{"shape":"Sqh"}}}},"DryRun":{"type":"boolean"},"Hypervisor":{},"LicenseType":{},"Platform":{},"RoleName":{}}},"output":{"type":"structure","members":{"Architecture":{"locationName":"architecture"},"Description":{"locationName":"description"},"Hypervisor":{"locationName":"hypervisor"},"ImageId":{"locationName":"imageId"},"ImportTaskId":{"locationName":"importTaskId"},"LicenseType":{"locationName":"licenseType"},"Platform":{"locationName":"platform"},"Progress":{"locationName":"progress"},"SnapshotDetails":{"shape":"Sg0","locationName":"snapshotDetailSet"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"}}}},"ImportInstance":{"input":{"type":"structure","required":["Platform"],"members":{"Description":{"locationName":"description"},"DiskImages":{"locationName":"diskImage","type":"list","member":{"type":"structure","members":{"Description":{},"Image":{"shape":"Sqm"},"Volume":{"shape":"Sqn"}}}},"DryRun":{"locationName":"dryRun","type":"boolean"},"LaunchSpecification":{"locationName":"launchSpecification","type":"structure","members":{"AdditionalInfo":{"locationName":"additionalInfo"},"Architecture":{"locationName":"architecture"},"GroupIds":{"shape":"S5r","locationName":"GroupId"},"GroupNames":{"shape":"S65","locationName":"GroupName"},"InstanceInitiatedShutdownBehavior":{"locationName":"instanceInitiatedShutdownBehavior"},"InstanceType":{"locationName":"instanceType"},"Monitoring":{"locationName":"monitoring","type":"boolean"},"Placement":{"shape":"Sh6","locationName":"placement"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"SubnetId":{"locationName":"subnetId"},"UserData":{"locationName":"userData","type":"structure","members":{"Data":{"locationName":"data"}}}}},"Platform":{"locationName":"platform"}}},"output":{"type":"structure","members":{"ConversionTask":{"shape":"Scu","locationName":"conversionTask"}}}},"ImportKeyPair":{"input":{"type":"structure","required":["KeyName","PublicKeyMaterial"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"KeyName":{"locationName":"keyName"},"PublicKeyMaterial":{"locationName":"publicKeyMaterial","type":"blob"}}},"output":{"type":"structure","members":{"KeyFingerprint":{"locationName":"keyFingerprint"},"KeyName":{"locationName":"keyName"}}}},"ImportSnapshot":{"input":{"type":"structure","members":{"ClientData":{"shape":"Sqe"},"ClientToken":{},"Description":{},"DiskContainer":{"type":"structure","members":{"Description":{},"Format":{},"Url":{},"UserBucket":{"shape":"Sqh"}}},"DryRun":{"type":"boolean"},"RoleName":{}}},"output":{"type":"structure","members":{"Description":{"locationName":"description"},"ImportTaskId":{"locationName":"importTaskId"},"SnapshotTaskDetail":{"shape":"Sg7","locationName":"snapshotTaskDetail"}}}},"ImportVolume":{"input":{"type":"structure","required":["AvailabilityZone","Image","Volume"],"members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Image":{"shape":"Sqm","locationName":"image"},"Volume":{"shape":"Sqn","locationName":"volume"}}},"output":{"type":"structure","members":{"ConversionTask":{"shape":"Scu","locationName":"conversionTask"}}}},"ModifyFpgaImageAttribute":{"input":{"type":"structure","required":["FpgaImageId"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{},"Attribute":{},"OperationType":{},"UserIds":{"shape":"Sr0","locationName":"UserId"},"UserGroups":{"shape":"Sr1","locationName":"UserGroup"},"ProductCodes":{"shape":"Sr2","locationName":"ProductCode"},"LoadPermission":{"type":"structure","members":{"Add":{"shape":"Sr4"},"Remove":{"shape":"Sr4"}}},"Description":{},"Name":{}}},"output":{"type":"structure","members":{"FpgaImageAttribute":{"shape":"Sdy","locationName":"fpgaImageAttribute"}}}},"ModifyHosts":{"input":{"type":"structure","required":["AutoPlacement","HostIds"],"members":{"AutoPlacement":{"locationName":"autoPlacement"},"HostIds":{"shape":"Set","locationName":"hostId"}}},"output":{"type":"structure","members":{"Successful":{"shape":"Sz","locationName":"successful"},"Unsuccessful":{"shape":"Sr9","locationName":"unsuccessful"}}}},"ModifyIdFormat":{"input":{"type":"structure","required":["Resource","UseLongIds"],"members":{"Resource":{},"UseLongIds":{"type":"boolean"}}}},"ModifyIdentityIdFormat":{"input":{"type":"structure","required":["PrincipalArn","Resource","UseLongIds"],"members":{"PrincipalArn":{"locationName":"principalArn"},"Resource":{"locationName":"resource"},"UseLongIds":{"locationName":"useLongIds","type":"boolean"}}}},"ModifyImageAttribute":{"input":{"type":"structure","required":["ImageId"],"members":{"Attribute":{},"Description":{"shape":"S4i"},"ImageId":{},"LaunchPermission":{"type":"structure","members":{"Add":{"shape":"Sfg"},"Remove":{"shape":"Sfg"}}},"OperationType":{},"ProductCodes":{"shape":"Sr2","locationName":"ProductCode"},"UserGroups":{"shape":"Sr1","locationName":"UserGroup"},"UserIds":{"shape":"Sr0","locationName":"UserId"},"Value":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ModifyInstanceAttribute":{"input":{"type":"structure","required":["InstanceId"],"members":{"SourceDestCheck":{"shape":"Sge"},"Attribute":{"locationName":"attribute"},"BlockDeviceMappings":{"locationName":"blockDeviceMapping","type":"list","member":{"locationName":"item","type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"VolumeId":{"locationName":"volumeId"}}},"NoDevice":{"locationName":"noDevice"},"VirtualName":{"locationName":"virtualName"}}}},"DisableApiTermination":{"shape":"Sge","locationName":"disableApiTermination"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EbsOptimized":{"shape":"Sge","locationName":"ebsOptimized"},"EnaSupport":{"shape":"Sge","locationName":"enaSupport"},"Groups":{"shape":"S1s","locationName":"GroupId"},"InstanceId":{"locationName":"instanceId"},"InstanceInitiatedShutdownBehavior":{"shape":"S4i","locationName":"instanceInitiatedShutdownBehavior"},"InstanceType":{"shape":"S4i","locationName":"instanceType"},"Kernel":{"shape":"S4i","locationName":"kernel"},"Ramdisk":{"shape":"S4i","locationName":"ramdisk"},"SriovNetSupport":{"shape":"S4i","locationName":"sriovNetSupport"},"UserData":{"locationName":"userData","type":"structure","members":{"Value":{"locationName":"value","type":"blob"}}},"Value":{"locationName":"value"}}}},"ModifyInstanceCreditSpecification":{"input":{"type":"structure","required":["InstanceCreditSpecifications"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"InstanceCreditSpecifications":{"locationName":"InstanceCreditSpecification","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{},"CpuCredits":{}}}}}},"output":{"type":"structure","members":{"SuccessfulInstanceCreditSpecifications":{"locationName":"successfulInstanceCreditSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"}}}},"UnsuccessfulInstanceCreditSpecifications":{"locationName":"unsuccessfulInstanceCreditSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}}}}},"ModifyInstancePlacement":{"input":{"type":"structure","required":["InstanceId"],"members":{"Affinity":{"locationName":"affinity"},"GroupName":{},"HostId":{"locationName":"hostId"},"InstanceId":{"locationName":"instanceId"},"Tenancy":{"locationName":"tenancy"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyLaunchTemplate":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ClientToken":{},"LaunchTemplateId":{},"LaunchTemplateName":{},"DefaultVersion":{"locationName":"SetDefaultVersion"}}},"output":{"type":"structure","members":{"LaunchTemplate":{"shape":"S6d","locationName":"launchTemplate"}}}},"ModifyNetworkInterfaceAttribute":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Attachment":{"locationName":"attachment","type":"structure","members":{"AttachmentId":{"locationName":"attachmentId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"}}},"Description":{"shape":"S4i","locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Groups":{"shape":"S5r","locationName":"SecurityGroupId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"SourceDestCheck":{"shape":"Sge","locationName":"sourceDestCheck"}}}},"ModifyReservedInstances":{"input":{"type":"structure","required":["ReservedInstancesIds","TargetConfigurations"],"members":{"ReservedInstancesIds":{"shape":"Sj3","locationName":"ReservedInstancesId"},"ClientToken":{"locationName":"clientToken"},"TargetConfigurations":{"locationName":"ReservedInstancesConfigurationSetItemType","type":"list","member":{"shape":"Sjo","locationName":"item"}}}},"output":{"type":"structure","members":{"ReservedInstancesModificationId":{"locationName":"reservedInstancesModificationId"}}}},"ModifySnapshotAttribute":{"input":{"type":"structure","required":["SnapshotId"],"members":{"Attribute":{},"CreateVolumePermission":{"type":"structure","members":{"Add":{"shape":"Skt"},"Remove":{"shape":"Skt"}}},"GroupNames":{"shape":"Skm","locationName":"UserGroup"},"OperationType":{},"SnapshotId":{},"UserIds":{"shape":"Sr0","locationName":"UserId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ModifySpotFleetRequest":{"input":{"type":"structure","required":["SpotFleetRequestId"],"members":{"ExcessCapacityTerminationPolicy":{"locationName":"excessCapacityTerminationPolicy"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"TargetCapacity":{"locationName":"targetCapacity","type":"integer"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifySubnetAttribute":{"input":{"type":"structure","required":["SubnetId"],"members":{"AssignIpv6AddressOnCreation":{"shape":"Sge"},"MapPublicIpOnLaunch":{"shape":"Sge"},"SubnetId":{"locationName":"subnetId"}}}},"ModifyVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"DryRun":{"type":"boolean"},"VolumeId":{},"Size":{"type":"integer"},"VolumeType":{},"Iops":{"type":"integer"}}},"output":{"type":"structure","members":{"VolumeModification":{"shape":"Sno","locationName":"volumeModification"}}}},"ModifyVolumeAttribute":{"input":{"type":"structure","required":["VolumeId"],"members":{"AutoEnableIO":{"shape":"Sge"},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ModifyVpcAttribute":{"input":{"type":"structure","required":["VpcId"],"members":{"EnableDnsHostnames":{"shape":"Sge"},"EnableDnsSupport":{"shape":"Sge"},"VpcId":{"locationName":"vpcId"}}}},"ModifyVpcEndpoint":{"input":{"type":"structure","required":["VpcEndpointId"],"members":{"DryRun":{"type":"boolean"},"VpcEndpointId":{},"ResetPolicy":{"type":"boolean"},"PolicyDocument":{},"AddRouteTableIds":{"shape":"Sa","locationName":"AddRouteTableId"},"RemoveRouteTableIds":{"shape":"Sa","locationName":"RemoveRouteTableId"},"AddSubnetIds":{"shape":"Sa","locationName":"AddSubnetId"},"RemoveSubnetIds":{"shape":"Sa","locationName":"RemoveSubnetId"},"AddSecurityGroupIds":{"shape":"Sa","locationName":"AddSecurityGroupId"},"RemoveSecurityGroupIds":{"shape":"Sa","locationName":"RemoveSecurityGroupId"},"PrivateDnsEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyVpcEndpointConnectionNotification":{"input":{"type":"structure","required":["ConnectionNotificationId"],"members":{"DryRun":{"type":"boolean"},"ConnectionNotificationId":{},"ConnectionNotificationArn":{},"ConnectionEvents":{"shape":"Sa"}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"ModifyVpcEndpointServiceConfiguration":{"input":{"type":"structure","required":["ServiceId"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"AcceptanceRequired":{"type":"boolean"},"AddNetworkLoadBalancerArns":{"shape":"Sa","locationName":"AddNetworkLoadBalancerArn"},"RemoveNetworkLoadBalancerArns":{"shape":"Sa","locationName":"RemoveNetworkLoadBalancerArn"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyVpcEndpointServicePermissions":{"input":{"type":"structure","required":["ServiceId"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"AddAllowedPrincipals":{"shape":"Sa"},"RemoveAllowedPrincipals":{"shape":"Sa"}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"ModifyVpcPeeringConnectionOptions":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"AccepterPeeringConnectionOptions":{"shape":"Ssm"},"DryRun":{"type":"boolean"},"RequesterPeeringConnectionOptions":{"shape":"Ssm"},"VpcPeeringConnectionId":{}}},"output":{"type":"structure","members":{"AccepterPeeringConnectionOptions":{"shape":"Sso","locationName":"accepterPeeringConnectionOptions"},"RequesterPeeringConnectionOptions":{"shape":"Sso","locationName":"requesterPeeringConnectionOptions"}}}},"ModifyVpcTenancy":{"input":{"type":"structure","required":["VpcId","InstanceTenancy"],"members":{"VpcId":{},"InstanceTenancy":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"MonitorInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Scm","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceMonitorings":{"shape":"Ssu","locationName":"instancesSet"}}}},"MoveAddressToVpc":{"input":{"type":"structure","required":["PublicIp"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"PublicIp":{"locationName":"publicIp"}}},"output":{"type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"Status":{"locationName":"status"}}}},"PurchaseHostReservation":{"input":{"type":"structure","required":["HostIdSet","OfferingId"],"members":{"ClientToken":{},"CurrencyCode":{},"HostIdSet":{"shape":"Spx"},"LimitPrice":{},"OfferingId":{}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"CurrencyCode":{"locationName":"currencyCode"},"Purchase":{"shape":"Spz","locationName":"purchase"},"TotalHourlyPrice":{"locationName":"totalHourlyPrice"},"TotalUpfrontPrice":{"locationName":"totalUpfrontPrice"}}}},"PurchaseReservedInstancesOffering":{"input":{"type":"structure","required":["InstanceCount","ReservedInstancesOfferingId"],"members":{"InstanceCount":{"type":"integer"},"ReservedInstancesOfferingId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"LimitPrice":{"locationName":"limitPrice","type":"structure","members":{"Amount":{"locationName":"amount","type":"double"},"CurrencyCode":{"locationName":"currencyCode"}}}}},"output":{"type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"}}}},"PurchaseScheduledInstances":{"input":{"type":"structure","required":["PurchaseRequests"],"members":{"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"PurchaseRequests":{"locationName":"PurchaseRequest","type":"list","member":{"locationName":"PurchaseRequest","type":"structure","required":["InstanceCount","PurchaseToken"],"members":{"InstanceCount":{"type":"integer"},"PurchaseToken":{}}}}}},"output":{"type":"structure","members":{"ScheduledInstanceSet":{"locationName":"scheduledInstanceSet","type":"list","member":{"shape":"Skf","locationName":"item"}}}}},"RebootInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Scm","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"RegisterImage":{"input":{"type":"structure","required":["Name"],"members":{"ImageLocation":{},"Architecture":{"locationName":"architecture"},"BlockDeviceMappings":{"shape":"S4x","locationName":"BlockDeviceMapping"},"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EnaSupport":{"locationName":"enaSupport","type":"boolean"},"KernelId":{"locationName":"kernelId"},"Name":{"locationName":"name"},"BillingProducts":{"locationName":"BillingProduct","type":"list","member":{"locationName":"item"}},"RamdiskId":{"locationName":"ramdiskId"},"RootDeviceName":{"locationName":"rootDeviceName"},"SriovNetSupport":{"locationName":"sriovNetSupport"},"VirtualizationType":{"locationName":"virtualizationType"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"RejectVpcEndpointConnections":{"input":{"type":"structure","required":["ServiceId","VpcEndpointIds"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"VpcEndpointIds":{"shape":"Sa","locationName":"VpcEndpointId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"Sc","locationName":"unsuccessful"}}}},"RejectVpcPeeringConnection":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ReleaseAddress":{"input":{"type":"structure","members":{"AllocationId":{},"PublicIp":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ReleaseHosts":{"input":{"type":"structure","required":["HostIds"],"members":{"HostIds":{"shape":"Set","locationName":"hostId"}}},"output":{"type":"structure","members":{"Successful":{"shape":"Sz","locationName":"successful"},"Unsuccessful":{"shape":"Sr9","locationName":"unsuccessful"}}}},"ReplaceIamInstanceProfileAssociation":{"input":{"type":"structure","required":["IamInstanceProfile","AssociationId"],"members":{"IamInstanceProfile":{"shape":"S19"},"AssociationId":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociation":{"shape":"S1b","locationName":"iamInstanceProfileAssociation"}}}},"ReplaceNetworkAclAssociation":{"input":{"type":"structure","required":["AssociationId","NetworkAclId"],"members":{"AssociationId":{"locationName":"associationId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"}}},"output":{"type":"structure","members":{"NewAssociationId":{"locationName":"newAssociationId"}}}},"ReplaceNetworkAclEntry":{"input":{"type":"structure","required":["Egress","NetworkAclId","Protocol","RuleAction","RuleNumber"],"members":{"CidrBlock":{"locationName":"cidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Egress":{"locationName":"egress","type":"boolean"},"IcmpTypeCode":{"shape":"S7d","locationName":"Icmp"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"NetworkAclId":{"locationName":"networkAclId"},"PortRange":{"shape":"S7e","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"ReplaceRoute":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"NatGatewayId":{"locationName":"natGatewayId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"RouteTableId":{"locationName":"routeTableId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}}},"ReplaceRouteTableAssociation":{"input":{"type":"structure","required":["AssociationId","RouteTableId"],"members":{"AssociationId":{"locationName":"associationId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"}}},"output":{"type":"structure","members":{"NewAssociationId":{"locationName":"newAssociationId"}}}},"ReportInstanceStatus":{"input":{"type":"structure","required":["Instances","ReasonCodes","Status"],"members":{"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EndTime":{"locationName":"endTime","type":"timestamp"},"Instances":{"shape":"Scm","locationName":"instanceId"},"ReasonCodes":{"locationName":"reasonCode","type":"list","member":{"locationName":"item"}},"StartTime":{"locationName":"startTime","type":"timestamp"},"Status":{"locationName":"status"}}}},"RequestSpotFleet":{"input":{"type":"structure","required":["SpotFleetRequestConfig"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotFleetRequestConfig":{"shape":"Sli","locationName":"spotFleetRequestConfig"}}},"output":{"type":"structure","required":["SpotFleetRequestId"],"members":{"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}},"RequestSpotInstances":{"input":{"type":"structure","members":{"AvailabilityZoneGroup":{"locationName":"availabilityZoneGroup"},"BlockDurationMinutes":{"locationName":"blockDurationMinutes","type":"integer"},"ClientToken":{"locationName":"clientToken"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"LaunchGroup":{"locationName":"launchGroup"},"LaunchSpecification":{"type":"structure","members":{"SecurityGroupIds":{"shape":"Sa","locationName":"SecurityGroupId"},"SecurityGroups":{"shape":"Sa","locationName":"SecurityGroup"},"AddressingType":{"locationName":"addressingType"},"BlockDeviceMappings":{"shape":"Sff","locationName":"blockDeviceMapping"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S19","locationName":"iamInstanceProfile"},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"Monitoring":{"shape":"Smb","locationName":"monitoring"},"NetworkInterfaces":{"shape":"Slo","locationName":"NetworkInterface"},"Placement":{"shape":"Slq","locationName":"placement"},"RamdiskId":{"locationName":"ramdiskId"},"SubnetId":{"locationName":"subnetId"},"UserData":{"locationName":"userData"}}},"SpotPrice":{"locationName":"spotPrice"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"InstanceInterruptionBehavior":{}}},"output":{"type":"structure","members":{"SpotInstanceRequests":{"shape":"Sm8","locationName":"spotInstanceRequestSet"}}}},"ResetFpgaImageAttribute":{"input":{"type":"structure","required":["FpgaImageId"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{},"Attribute":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ResetImageAttribute":{"input":{"type":"structure","required":["Attribute","ImageId"],"members":{"Attribute":{},"ImageId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ResetInstanceAttribute":{"input":{"type":"structure","required":["Attribute","InstanceId"],"members":{"Attribute":{"locationName":"attribute"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"}}}},"ResetNetworkInterfaceAttribute":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"SourceDestCheck":{"locationName":"sourceDestCheck"}}}},"ResetSnapshotAttribute":{"input":{"type":"structure","required":["Attribute","SnapshotId"],"members":{"Attribute":{},"SnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"RestoreAddressToClassic":{"input":{"type":"structure","required":["PublicIp"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"PublicIp":{"locationName":"publicIp"}}},"output":{"type":"structure","members":{"PublicIp":{"locationName":"publicIp"},"Status":{"locationName":"status"}}}},"RevokeSecurityGroupEgress":{"input":{"type":"structure","required":["GroupId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupId":{"locationName":"groupId"},"IpPermissions":{"shape":"S25","locationName":"ipPermissions"},"CidrIp":{"locationName":"cidrIp"},"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"ToPort":{"locationName":"toPort","type":"integer"},"SourceSecurityGroupName":{"locationName":"sourceSecurityGroupName"},"SourceSecurityGroupOwnerId":{"locationName":"sourceSecurityGroupOwnerId"}}}},"RevokeSecurityGroupIngress":{"input":{"type":"structure","members":{"CidrIp":{},"FromPort":{"type":"integer"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S25"},"IpProtocol":{},"SourceSecurityGroupName":{},"SourceSecurityGroupOwnerId":{},"ToPort":{"type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"RunInstances":{"input":{"type":"structure","required":["MaxCount","MinCount"],"members":{"BlockDeviceMappings":{"shape":"S4x","locationName":"BlockDeviceMapping"},"ImageId":{},"InstanceType":{},"Ipv6AddressCount":{"type":"integer"},"Ipv6Addresses":{"shape":"S6o","locationName":"Ipv6Address"},"KernelId":{},"KeyName":{},"MaxCount":{"type":"integer"},"MinCount":{"type":"integer"},"Monitoring":{"shape":"Smb"},"Placement":{"shape":"Sh6"},"RamdiskId":{},"SecurityGroupIds":{"shape":"S5r","locationName":"SecurityGroupId"},"SecurityGroups":{"shape":"S65","locationName":"SecurityGroup"},"SubnetId":{},"UserData":{},"AdditionalInfo":{"locationName":"additionalInfo"},"ClientToken":{"locationName":"clientToken"},"DisableApiTermination":{"locationName":"disableApiTermination","type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S19","locationName":"iamInstanceProfile"},"InstanceInitiatedShutdownBehavior":{"locationName":"instanceInitiatedShutdownBehavior"},"NetworkInterfaces":{"shape":"Slo","locationName":"networkInterface"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"ElasticGpuSpecification":{"type":"list","member":{"shape":"S64","locationName":"item"}},"TagSpecifications":{"shape":"S8m","locationName":"TagSpecification"},"LaunchTemplate":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"InstanceMarketOptions":{"type":"structure","members":{"MarketType":{},"SpotOptions":{"type":"structure","members":{"MaxPrice":{},"SpotInstanceType":{},"BlockDurationMinutes":{"type":"integer"},"ValidUntil":{"type":"timestamp"},"InstanceInterruptionBehavior":{}}}}},"CreditSpecification":{"shape":"S6b"}}},"output":{"shape":"Sh1"}},"RunScheduledInstances":{"input":{"type":"structure","required":["LaunchSpecification","ScheduledInstanceId"],"members":{"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"InstanceCount":{"type":"integer"},"LaunchSpecification":{"type":"structure","required":["ImageId"],"members":{"BlockDeviceMappings":{"locationName":"BlockDeviceMapping","type":"list","member":{"locationName":"BlockDeviceMapping","type":"structure","members":{"DeviceName":{},"Ebs":{"type":"structure","members":{"DeleteOnTermination":{"type":"boolean"},"Encrypted":{"type":"boolean"},"Iops":{"type":"integer"},"SnapshotId":{},"VolumeSize":{"type":"integer"},"VolumeType":{}}},"NoDevice":{},"VirtualName":{}}}},"EbsOptimized":{"type":"boolean"},"IamInstanceProfile":{"type":"structure","members":{"Arn":{},"Name":{}}},"ImageId":{},"InstanceType":{},"KernelId":{},"KeyName":{},"Monitoring":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"NetworkInterfaces":{"locationName":"NetworkInterface","type":"list","member":{"locationName":"NetworkInterface","type":"structure","members":{"AssociatePublicIpAddress":{"type":"boolean"},"DeleteOnTermination":{"type":"boolean"},"Description":{},"DeviceIndex":{"type":"integer"},"Groups":{"shape":"Sur","locationName":"Group"},"Ipv6AddressCount":{"type":"integer"},"Ipv6Addresses":{"locationName":"Ipv6Address","type":"list","member":{"locationName":"Ipv6Address","type":"structure","members":{"Ipv6Address":{}}}},"NetworkInterfaceId":{},"PrivateIpAddress":{},"PrivateIpAddressConfigs":{"locationName":"PrivateIpAddressConfig","type":"list","member":{"locationName":"PrivateIpAddressConfigSet","type":"structure","members":{"Primary":{"type":"boolean"},"PrivateIpAddress":{}}}},"SecondaryPrivateIpAddressCount":{"type":"integer"},"SubnetId":{}}}},"Placement":{"type":"structure","members":{"AvailabilityZone":{},"GroupName":{}}},"RamdiskId":{},"SecurityGroupIds":{"shape":"Sur","locationName":"SecurityGroupId"},"SubnetId":{},"UserData":{}}},"ScheduledInstanceId":{}}},"output":{"type":"structure","members":{"InstanceIdSet":{"locationName":"instanceIdSet","type":"list","member":{"locationName":"item"}}}}},"StartInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Scm","locationName":"InstanceId"},"AdditionalInfo":{"locationName":"additionalInfo"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"StartingInstances":{"shape":"Sv2","locationName":"instancesSet"}}}},"StopInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Scm","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Force":{"locationName":"force","type":"boolean"}}},"output":{"type":"structure","members":{"StoppingInstances":{"shape":"Sv2","locationName":"instancesSet"}}}},"TerminateInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Scm","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"TerminatingInstances":{"shape":"Sv2","locationName":"instancesSet"}}}},"UnassignIpv6Addresses":{"input":{"type":"structure","required":["Ipv6Addresses","NetworkInterfaceId"],"members":{"Ipv6Addresses":{"shape":"S11","locationName":"ipv6Addresses"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"UnassignedIpv6Addresses":{"shape":"S11","locationName":"unassignedIpv6Addresses"}}}},"UnassignPrivateIpAddresses":{"input":{"type":"structure","required":["NetworkInterfaceId","PrivateIpAddresses"],"members":{"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddresses":{"shape":"S14","locationName":"privateIpAddress"}}}},"UnmonitorInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Scm","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceMonitorings":{"shape":"Ssu","locationName":"instancesSet"}}}},"UpdateSecurityGroupRuleDescriptionsEgress":{"input":{"type":"structure","required":["IpPermissions"],"members":{"DryRun":{"type":"boolean"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S25"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"UpdateSecurityGroupRuleDescriptionsIngress":{"input":{"type":"structure","required":["IpPermissions"],"members":{"DryRun":{"type":"boolean"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S25"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}}},"shapes":{"S3":{"type":"list","member":{"locationName":"ReservedInstanceId"}},"S5":{"type":"list","member":{"locationName":"TargetConfigurationRequest","type":"structure","required":["OfferingId"],"members":{"InstanceCount":{"type":"integer"},"OfferingId":{}}}},"Sa":{"type":"list","member":{"locationName":"item"}},"Sc":{"type":"list","member":{"shape":"Sd","locationName":"item"}},"Sd":{"type":"structure","required":["Error"],"members":{"Error":{"locationName":"error","type":"structure","required":["Code","Message"],"members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"ResourceId":{"locationName":"resourceId"}}},"Sh":{"type":"structure","members":{"AccepterVpcInfo":{"shape":"Si","locationName":"accepterVpcInfo"},"ExpirationTime":{"locationName":"expirationTime","type":"timestamp"},"RequesterVpcInfo":{"shape":"Si","locationName":"requesterVpcInfo"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Tags":{"shape":"Sr","locationName":"tagSet"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"Si":{"type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"},"Ipv6CidrBlockSet":{"locationName":"ipv6CidrBlockSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"}}}},"CidrBlockSet":{"locationName":"cidrBlockSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"}}}},"OwnerId":{"locationName":"ownerId"},"PeeringOptions":{"locationName":"peeringOptions","type":"structure","members":{"AllowDnsResolutionFromRemoteVpc":{"locationName":"allowDnsResolutionFromRemoteVpc","type":"boolean"},"AllowEgressFromLocalClassicLinkToRemoteVpc":{"locationName":"allowEgressFromLocalClassicLinkToRemoteVpc","type":"boolean"},"AllowEgressFromLocalVpcToRemoteClassicLink":{"locationName":"allowEgressFromLocalVpcToRemoteClassicLink","type":"boolean"}}},"VpcId":{"locationName":"vpcId"},"Region":{"locationName":"region"}}},"Sr":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Value":{"locationName":"value"}}}},"Sz":{"type":"list","member":{"locationName":"item"}},"S11":{"type":"list","member":{"locationName":"item"}},"S14":{"type":"list","member":{"locationName":"PrivateIpAddress"}},"S19":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Name":{"locationName":"name"}}},"S1b":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"InstanceId":{"locationName":"instanceId"},"IamInstanceProfile":{"shape":"S1c","locationName":"iamInstanceProfile"},"State":{"locationName":"state"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}},"S1c":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Id":{"locationName":"id"}}},"S1i":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"Ipv6CidrBlockState":{"locationName":"ipv6CidrBlockState","type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}}}},"S1n":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"Ipv6CidrBlockState":{"shape":"S1o","locationName":"ipv6CidrBlockState"}}},"S1o":{"type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}},"S1q":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"CidrBlock":{"locationName":"cidrBlock"},"CidrBlockState":{"shape":"S1o","locationName":"cidrBlockState"}}},"S1s":{"type":"list","member":{"locationName":"groupId"}},"S1y":{"type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"Device":{"locationName":"device"},"InstanceId":{"locationName":"instanceId"},"State":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"}}},"S22":{"type":"structure","members":{"State":{"locationName":"state"},"VpcId":{"locationName":"vpcId"}}},"S25":{"type":"list","member":{"locationName":"item","type":"structure","members":{"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"IpRanges":{"locationName":"ipRanges","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrIp":{"locationName":"cidrIp"},"Description":{"locationName":"description"}}}},"Ipv6Ranges":{"locationName":"ipv6Ranges","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrIpv6":{"locationName":"cidrIpv6"},"Description":{"locationName":"description"}}}},"PrefixListIds":{"locationName":"prefixListIds","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"PrefixListId":{"locationName":"prefixListId"}}}},"ToPort":{"locationName":"toPort","type":"integer"},"UserIdGroupPairs":{"locationName":"groups","type":"list","member":{"shape":"S2e","locationName":"item"}}}}},"S2e":{"type":"structure","members":{"Description":{"locationName":"description"},"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"},"PeeringStatus":{"locationName":"peeringStatus"},"UserId":{"locationName":"userId"},"VpcId":{"locationName":"vpcId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"S2h":{"type":"structure","members":{"S3":{"type":"structure","members":{"AWSAccessKeyId":{},"Bucket":{"locationName":"bucket"},"Prefix":{"locationName":"prefix"},"UploadPolicy":{"locationName":"uploadPolicy","type":"blob"},"UploadPolicySignature":{"locationName":"uploadPolicySignature"}}}}},"S2l":{"type":"structure","members":{"BundleId":{"locationName":"bundleId"},"BundleTaskError":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"InstanceId":{"locationName":"instanceId"},"Progress":{"locationName":"progress"},"StartTime":{"locationName":"startTime","type":"timestamp"},"State":{"locationName":"state"},"Storage":{"shape":"S2h","locationName":"storage"},"UpdateTime":{"locationName":"updateTime","type":"timestamp"}}},"S2w":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"InstanceCounts":{"locationName":"instanceCounts","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceCount":{"locationName":"instanceCount","type":"integer"},"State":{"locationName":"state"}}}},"PriceSchedules":{"locationName":"priceSchedules","type":"list","member":{"locationName":"item","type":"structure","members":{"Active":{"locationName":"active","type":"boolean"},"CurrencyCode":{"locationName":"currencyCode"},"Price":{"locationName":"price","type":"double"},"Term":{"locationName":"term","type":"long"}}}},"ReservedInstancesId":{"locationName":"reservedInstancesId"},"ReservedInstancesListingId":{"locationName":"reservedInstancesListingId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"Sr","locationName":"tagSet"},"UpdateDate":{"locationName":"updateDate","type":"timestamp"}}}},"S3h":{"type":"list","member":{"locationName":"SpotInstanceRequestId"}},"S3x":{"type":"structure","members":{"BgpAsn":{"locationName":"bgpAsn"},"CustomerGatewayId":{"locationName":"customerGatewayId"},"IpAddress":{"locationName":"ipAddress"},"State":{"locationName":"state"},"Type":{"locationName":"type"},"Tags":{"shape":"Sr","locationName":"tagSet"}}},"S40":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"AvailableIpAddressCount":{"locationName":"availableIpAddressCount","type":"integer"},"CidrBlock":{"locationName":"cidrBlock"},"DefaultForAz":{"locationName":"defaultForAz","type":"boolean"},"MapPublicIpOnLaunch":{"locationName":"mapPublicIpOnLaunch","type":"boolean"},"State":{"locationName":"state"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"AssignIpv6AddressOnCreation":{"locationName":"assignIpv6AddressOnCreation","type":"boolean"},"Ipv6CidrBlockAssociationSet":{"locationName":"ipv6CidrBlockAssociationSet","type":"list","member":{"shape":"S1i","locationName":"item"}},"Tags":{"shape":"Sr","locationName":"tagSet"}}},"S45":{"type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"},"DhcpOptionsId":{"locationName":"dhcpOptionsId"},"State":{"locationName":"state"},"VpcId":{"locationName":"vpcId"},"InstanceTenancy":{"locationName":"instanceTenancy"},"Ipv6CidrBlockAssociationSet":{"locationName":"ipv6CidrBlockAssociationSet","type":"list","member":{"shape":"S1n","locationName":"item"}},"CidrBlockAssociationSet":{"locationName":"cidrBlockAssociationSet","type":"list","member":{"shape":"S1q","locationName":"item"}},"IsDefault":{"locationName":"isDefault","type":"boolean"},"Tags":{"shape":"Sr","locationName":"tagSet"}}},"S4e":{"type":"structure","members":{"DhcpConfigurations":{"locationName":"dhcpConfigurationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Values":{"locationName":"valueSet","type":"list","member":{"shape":"S4i","locationName":"item"}}}}},"DhcpOptionsId":{"locationName":"dhcpOptionsId"},"Tags":{"shape":"Sr","locationName":"tagSet"}}},"S4i":{"type":"structure","members":{"Value":{"locationName":"value"}}},"S4l":{"type":"structure","members":{"Attachments":{"shape":"S4m","locationName":"attachmentSet"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"}}},"S4m":{"type":"list","member":{"locationName":"item","type":"structure","members":{"State":{"locationName":"state"},"VpcId":{"locationName":"vpcId"}}}},"S4u":{"type":"structure","members":{"Bucket":{},"Key":{}}},"S4x":{"type":"list","member":{"shape":"S4y","locationName":"BlockDeviceMapping"}},"S4y":{"type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"VirtualName":{"locationName":"virtualName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"Encrypted":{"locationName":"encrypted","type":"boolean"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Iops":{"locationName":"iops","type":"integer"},"KmsKeyId":{},"SnapshotId":{"locationName":"snapshotId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"VolumeType":{"locationName":"volumeType"}}},"NoDevice":{"locationName":"noDevice"}}},"S58":{"type":"structure","members":{"Description":{"locationName":"description"},"ExportTaskId":{"locationName":"exportTaskId"},"ExportToS3Task":{"locationName":"exportToS3","type":"structure","members":{"ContainerFormat":{"locationName":"containerFormat"},"DiskImageFormat":{"locationName":"diskImageFormat"},"S3Bucket":{"locationName":"s3Bucket"},"S3Key":{"locationName":"s3Key"}}},"InstanceExportDetails":{"locationName":"instanceExport","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"TargetEnvironment":{"locationName":"targetEnvironment"}}},"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}},"S5e":{"type":"structure","members":{"Attachments":{"shape":"S4m","locationName":"attachmentSet"},"InternetGatewayId":{"locationName":"internetGatewayId"},"Tags":{"shape":"Sr","locationName":"tagSet"}}},"S5k":{"type":"structure","members":{"KernelId":{},"EbsOptimized":{"type":"boolean"},"IamInstanceProfile":{"type":"structure","members":{"Arn":{},"Name":{}}},"BlockDeviceMappings":{"locationName":"BlockDeviceMapping","type":"list","member":{"locationName":"BlockDeviceMapping","type":"structure","members":{"DeviceName":{},"VirtualName":{},"Ebs":{"type":"structure","members":{"Encrypted":{"type":"boolean"},"DeleteOnTermination":{"type":"boolean"},"Iops":{"type":"integer"},"KmsKeyId":{},"SnapshotId":{},"VolumeSize":{"type":"integer"},"VolumeType":{}}},"NoDevice":{}}}},"NetworkInterfaces":{"locationName":"NetworkInterface","type":"list","member":{"locationName":"InstanceNetworkInterfaceSpecification","type":"structure","members":{"AssociatePublicIpAddress":{"type":"boolean"},"DeleteOnTermination":{"type":"boolean"},"Description":{},"DeviceIndex":{"type":"integer"},"Groups":{"shape":"S5r","locationName":"SecurityGroupId"},"Ipv6AddressCount":{"type":"integer"},"Ipv6Addresses":{"type":"list","member":{"locationName":"InstanceIpv6Address","type":"structure","members":{"Ipv6Address":{}}}},"NetworkInterfaceId":{},"PrivateIpAddress":{},"PrivateIpAddresses":{"shape":"S5u"},"SecondaryPrivateIpAddressCount":{"type":"integer"},"SubnetId":{}}}},"ImageId":{},"InstanceType":{},"KeyName":{},"Monitoring":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"Placement":{"type":"structure","members":{"AvailabilityZone":{},"Affinity":{},"GroupName":{},"HostId":{},"Tenancy":{},"SpreadDomain":{}}},"RamDiskId":{},"DisableApiTermination":{"type":"boolean"},"InstanceInitiatedShutdownBehavior":{},"UserData":{},"TagSpecifications":{"locationName":"TagSpecification","type":"list","member":{"locationName":"LaunchTemplateTagSpecificationRequest","type":"structure","members":{"ResourceType":{},"Tags":{"shape":"Sr","locationName":"Tag"}}}},"ElasticGpuSpecifications":{"locationName":"ElasticGpuSpecification","type":"list","member":{"shape":"S64","locationName":"ElasticGpuSpecification"}},"SecurityGroupIds":{"shape":"S5r","locationName":"SecurityGroupId"},"SecurityGroups":{"shape":"S65","locationName":"SecurityGroup"},"InstanceMarketOptions":{"type":"structure","members":{"MarketType":{},"SpotOptions":{"type":"structure","members":{"MaxPrice":{},"SpotInstanceType":{},"BlockDurationMinutes":{"type":"integer"},"ValidUntil":{"type":"timestamp"},"InstanceInterruptionBehavior":{}}}}},"CreditSpecification":{"shape":"S6b"}}},"S5r":{"type":"list","member":{"locationName":"SecurityGroupId"}},"S5u":{"type":"list","member":{"locationName":"item","type":"structure","required":["PrivateIpAddress"],"members":{"Primary":{"locationName":"primary","type":"boolean"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"S64":{"type":"structure","required":["Type"],"members":{"Type":{}}},"S65":{"type":"list","member":{"locationName":"SecurityGroup"}},"S6b":{"type":"structure","required":["CpuCredits"],"members":{"CpuCredits":{}}},"S6d":{"type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"CreatedBy":{"locationName":"createdBy"},"DefaultVersionNumber":{"locationName":"defaultVersionNumber","type":"long"},"LatestVersionNumber":{"locationName":"latestVersionNumber","type":"long"},"Tags":{"shape":"Sr","locationName":"tagSet"}}},"S6g":{"type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"VersionNumber":{"locationName":"versionNumber","type":"long"},"VersionDescription":{"locationName":"versionDescription"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"CreatedBy":{"locationName":"createdBy"},"DefaultVersion":{"locationName":"defaultVersion","type":"boolean"},"LaunchTemplateData":{"shape":"S6h","locationName":"launchTemplateData"}}},"S6h":{"type":"structure","members":{"KernelId":{"locationName":"kernelId"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"locationName":"iamInstanceProfile","type":"structure","members":{"Arn":{"locationName":"arn"},"Name":{"locationName":"name"}}},"BlockDeviceMappings":{"locationName":"blockDeviceMappingSet","type":"list","member":{"locationName":"item","type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"VirtualName":{"locationName":"virtualName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"Encrypted":{"locationName":"encrypted","type":"boolean"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Iops":{"locationName":"iops","type":"integer"},"KmsKeyId":{"locationName":"kmsKeyId"},"SnapshotId":{"locationName":"snapshotId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"VolumeType":{"locationName":"volumeType"}}},"NoDevice":{"locationName":"noDevice"}}}},"NetworkInterfaces":{"locationName":"networkInterfaceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AssociatePublicIpAddress":{"locationName":"associatePublicIpAddress","type":"boolean"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Description":{"locationName":"description"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"Groups":{"shape":"S1s","locationName":"groupSet"},"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"S6o","locationName":"ipv6AddressesSet"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"shape":"S5u","locationName":"privateIpAddressesSet"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"SubnetId":{"locationName":"subnetId"}}}},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KeyName":{"locationName":"keyName"},"Monitoring":{"locationName":"monitoring","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"Placement":{"locationName":"placement","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Affinity":{"locationName":"affinity"},"GroupName":{"locationName":"groupName"},"HostId":{"locationName":"hostId"},"Tenancy":{"locationName":"tenancy"},"SpreadDomain":{"locationName":"spreadDomain"}}},"RamDiskId":{"locationName":"ramDiskId"},"DisableApiTermination":{"locationName":"disableApiTermination","type":"boolean"},"InstanceInitiatedShutdownBehavior":{"locationName":"instanceInitiatedShutdownBehavior"},"UserData":{"locationName":"userData"},"TagSpecifications":{"locationName":"tagSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceType":{"locationName":"resourceType"},"Tags":{"shape":"Sr","locationName":"tagSet"}}}},"ElasticGpuSpecifications":{"locationName":"elasticGpuSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Type":{"locationName":"type"}}}},"SecurityGroupIds":{"shape":"Sa","locationName":"securityGroupIdSet"},"SecurityGroups":{"shape":"Sa","locationName":"securityGroupSet"},"InstanceMarketOptions":{"locationName":"instanceMarketOptions","type":"structure","members":{"MarketType":{"locationName":"marketType"},"SpotOptions":{"locationName":"spotOptions","type":"structure","members":{"MaxPrice":{"locationName":"maxPrice"},"SpotInstanceType":{"locationName":"spotInstanceType"},"BlockDurationMinutes":{"locationName":"blockDurationMinutes","type":"integer"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"}}}}},"CreditSpecification":{"locationName":"creditSpecification","type":"structure","members":{"CpuCredits":{"locationName":"cpuCredits"}}}}},"S6o":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Address":{"locationName":"ipv6Address"}}}},"S71":{"type":"structure","members":{"CreateTime":{"locationName":"createTime","type":"timestamp"},"DeleteTime":{"locationName":"deleteTime","type":"timestamp"},"FailureCode":{"locationName":"failureCode"},"FailureMessage":{"locationName":"failureMessage"},"NatGatewayAddresses":{"locationName":"natGatewayAddressSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIp":{"locationName":"privateIp"},"PublicIp":{"locationName":"publicIp"}}}},"NatGatewayId":{"locationName":"natGatewayId"},"ProvisionedBandwidth":{"locationName":"provisionedBandwidth","type":"structure","members":{"ProvisionTime":{"locationName":"provisionTime","type":"timestamp"},"Provisioned":{"locationName":"provisioned"},"RequestTime":{"locationName":"requestTime","type":"timestamp"},"Requested":{"locationName":"requested"},"Status":{"locationName":"status"}}},"State":{"locationName":"state"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"Tags":{"shape":"Sr","locationName":"tagSet"}}},"S78":{"type":"structure","members":{"Associations":{"locationName":"associationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"NetworkAclAssociationId":{"locationName":"networkAclAssociationId"},"NetworkAclId":{"locationName":"networkAclId"},"SubnetId":{"locationName":"subnetId"}}}},"Entries":{"locationName":"entrySet","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"},"Egress":{"locationName":"egress","type":"boolean"},"IcmpTypeCode":{"shape":"S7d","locationName":"icmpTypeCode"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"PortRange":{"shape":"S7e","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"IsDefault":{"locationName":"default","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"},"Tags":{"shape":"Sr","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}},"S7d":{"type":"structure","members":{"Code":{"locationName":"code","type":"integer"},"Type":{"locationName":"type","type":"integer"}}},"S7e":{"type":"structure","members":{"From":{"locationName":"from","type":"integer"},"To":{"locationName":"to","type":"integer"}}},"S7j":{"type":"structure","members":{"Association":{"shape":"S7k","locationName":"association"},"Attachment":{"shape":"S7l","locationName":"attachment"},"AvailabilityZone":{"locationName":"availabilityZone"},"Description":{"locationName":"description"},"Groups":{"shape":"S7m","locationName":"groupSet"},"InterfaceType":{"locationName":"interfaceType"},"Ipv6Addresses":{"locationName":"ipv6AddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Address":{"locationName":"ipv6Address"}}}},"MacAddress":{"locationName":"macAddress"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"OwnerId":{"locationName":"ownerId"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"locationName":"privateIpAddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Association":{"shape":"S7k","locationName":"association"},"Primary":{"locationName":"primary","type":"boolean"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"RequesterId":{"locationName":"requesterId"},"RequesterManaged":{"locationName":"requesterManaged","type":"boolean"},"SourceDestCheck":{"locationName":"sourceDestCheck","type":"boolean"},"Status":{"locationName":"status"},"SubnetId":{"locationName":"subnetId"},"TagSet":{"shape":"Sr","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}},"S7k":{"type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"AssociationId":{"locationName":"associationId"},"IpOwnerId":{"locationName":"ipOwnerId"},"PublicDnsName":{"locationName":"publicDnsName"},"PublicIp":{"locationName":"publicIp"}}},"S7l":{"type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"AttachmentId":{"locationName":"attachmentId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"InstanceId":{"locationName":"instanceId"},"InstanceOwnerId":{"locationName":"instanceOwnerId"},"Status":{"locationName":"status"}}},"S7m":{"type":"list","member":{"locationName":"item","type":"structure","members":{"GroupName":{"locationName":"groupName"},"GroupId":{"locationName":"groupId"}}}},"S7x":{"type":"structure","members":{"NetworkInterfacePermissionId":{"locationName":"networkInterfacePermissionId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"AwsAccountId":{"locationName":"awsAccountId"},"AwsService":{"locationName":"awsService"},"Permission":{"locationName":"permission"},"PermissionState":{"locationName":"permissionState","type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}}}},"S8a":{"type":"structure","members":{"Associations":{"locationName":"associationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Main":{"locationName":"main","type":"boolean"},"RouteTableAssociationId":{"locationName":"routeTableAssociationId"},"RouteTableId":{"locationName":"routeTableId"},"SubnetId":{"locationName":"subnetId"}}}},"PropagatingVgws":{"locationName":"propagatingVgwSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GatewayId":{"locationName":"gatewayId"}}}},"RouteTableId":{"locationName":"routeTableId"},"Routes":{"locationName":"routeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DestinationPrefixListId":{"locationName":"destinationPrefixListId"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"InstanceOwnerId":{"locationName":"instanceOwnerId"},"NatGatewayId":{"locationName":"natGatewayId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"Origin":{"locationName":"origin"},"State":{"locationName":"state"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}}},"Tags":{"shape":"Sr","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}},"S8m":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceType":{"locationName":"resourceType"},"Tags":{"shape":"Sr","locationName":"Tag"}}}},"S8o":{"type":"structure","members":{"DataEncryptionKeyId":{"locationName":"dataEncryptionKeyId"},"Description":{"locationName":"description"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"OwnerId":{"locationName":"ownerId"},"Progress":{"locationName":"progress"},"SnapshotId":{"locationName":"snapshotId"},"StartTime":{"locationName":"startTime","type":"timestamp"},"State":{"locationName":"status"},"StateMessage":{"locationName":"statusMessage"},"VolumeId":{"locationName":"volumeId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"OwnerAlias":{"locationName":"ownerAlias"},"Tags":{"shape":"Sr","locationName":"tagSet"}}},"S8s":{"type":"structure","members":{"Bucket":{"locationName":"bucket"},"Fault":{"shape":"S8t","locationName":"fault"},"OwnerId":{"locationName":"ownerId"},"Prefix":{"locationName":"prefix"},"State":{"locationName":"state"}}},"S8t":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S8y":{"type":"list","member":{}},"S90":{"type":"structure","members":{"Attachments":{"locationName":"attachmentSet","type":"list","member":{"shape":"S1y","locationName":"item"}},"AvailabilityZone":{"locationName":"availabilityZone"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"Size":{"locationName":"size","type":"integer"},"SnapshotId":{"locationName":"snapshotId"},"State":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"},"Iops":{"locationName":"iops","type":"integer"},"Tags":{"shape":"Sr","locationName":"tagSet"},"VolumeType":{"locationName":"volumeType"}}},"S98":{"type":"structure","members":{"VpcEndpointId":{"locationName":"vpcEndpointId"},"VpcEndpointType":{"locationName":"vpcEndpointType"},"VpcId":{"locationName":"vpcId"},"ServiceName":{"locationName":"serviceName"},"State":{"locationName":"state"},"PolicyDocument":{"locationName":"policyDocument"},"RouteTableIds":{"shape":"Sa","locationName":"routeTableIdSet"},"SubnetIds":{"shape":"Sa","locationName":"subnetIdSet"},"Groups":{"locationName":"groupSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"}}}},"PrivateDnsEnabled":{"locationName":"privateDnsEnabled","type":"boolean"},"NetworkInterfaceIds":{"shape":"Sa","locationName":"networkInterfaceIdSet"},"DnsEntries":{"locationName":"dnsEntrySet","type":"list","member":{"locationName":"item","type":"structure","members":{"DnsName":{"locationName":"dnsName"},"HostedZoneId":{"locationName":"hostedZoneId"}}}},"CreationTimestamp":{"locationName":"creationTimestamp","type":"timestamp"}}},"S9g":{"type":"structure","members":{"ConnectionNotificationId":{"locationName":"connectionNotificationId"},"ServiceId":{"locationName":"serviceId"},"VpcEndpointId":{"locationName":"vpcEndpointId"},"ConnectionNotificationType":{"locationName":"connectionNotificationType"},"ConnectionNotificationArn":{"locationName":"connectionNotificationArn"},"ConnectionEvents":{"shape":"Sa","locationName":"connectionEvents"},"ConnectionNotificationState":{"locationName":"connectionNotificationState"}}},"S9l":{"type":"structure","members":{"ServiceType":{"shape":"S9m","locationName":"serviceType"},"ServiceId":{"locationName":"serviceId"},"ServiceName":{"locationName":"serviceName"},"ServiceState":{"locationName":"serviceState"},"AvailabilityZones":{"shape":"Sa","locationName":"availabilityZoneSet"},"AcceptanceRequired":{"locationName":"acceptanceRequired","type":"boolean"},"NetworkLoadBalancerArns":{"shape":"Sa","locationName":"networkLoadBalancerArnSet"},"BaseEndpointDnsNames":{"shape":"Sa","locationName":"baseEndpointDnsNameSet"},"PrivateDnsName":{"locationName":"privateDnsName"}}},"S9m":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ServiceType":{"locationName":"serviceType"}}}},"S9x":{"type":"structure","members":{"CustomerGatewayConfiguration":{"locationName":"customerGatewayConfiguration"},"CustomerGatewayId":{"locationName":"customerGatewayId"},"Category":{"locationName":"category"},"State":{"locationName":"state"},"Type":{"locationName":"type"},"VpnConnectionId":{"locationName":"vpnConnectionId"},"VpnGatewayId":{"locationName":"vpnGatewayId"},"Options":{"locationName":"options","type":"structure","members":{"StaticRoutesOnly":{"locationName":"staticRoutesOnly","type":"boolean"}}},"Routes":{"locationName":"routes","type":"list","member":{"locationName":"item","type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"Source":{"locationName":"source"},"State":{"locationName":"state"}}}},"Tags":{"shape":"Sr","locationName":"tagSet"},"VgwTelemetry":{"locationName":"vgwTelemetry","type":"list","member":{"locationName":"item","type":"structure","members":{"AcceptedRouteCount":{"locationName":"acceptedRouteCount","type":"integer"},"LastStatusChange":{"locationName":"lastStatusChange","type":"timestamp"},"OutsideIpAddress":{"locationName":"outsideIpAddress"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"}}}}}},"Sa9":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"State":{"locationName":"state"},"Type":{"locationName":"type"},"VpcAttachments":{"locationName":"attachments","type":"list","member":{"shape":"S22","locationName":"item"}},"VpnGatewayId":{"locationName":"vpnGatewayId"},"AmazonSideAsn":{"locationName":"amazonSideAsn","type":"long"},"Tags":{"shape":"Sr","locationName":"tagSet"}}},"Sao":{"type":"list","member":{"locationName":"item"}},"Sby":{"type":"list","member":{"locationName":"Filter","type":"structure","members":{"Name":{},"Values":{"shape":"Sa","locationName":"Value"}}}},"Sc7":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Deadline":{"locationName":"deadline","type":"timestamp"},"Resource":{"locationName":"resource"},"UseLongIds":{"locationName":"useLongIds","type":"boolean"}}}},"Scm":{"type":"list","member":{"locationName":"InstanceId"}},"Scu":{"type":"structure","required":["ConversionTaskId","State"],"members":{"ConversionTaskId":{"locationName":"conversionTaskId"},"ExpirationTime":{"locationName":"expirationTime"},"ImportInstance":{"locationName":"importInstance","type":"structure","required":["Volumes"],"members":{"Description":{"locationName":"description"},"InstanceId":{"locationName":"instanceId"},"Platform":{"locationName":"platform"},"Volumes":{"locationName":"volumes","type":"list","member":{"locationName":"item","type":"structure","required":["AvailabilityZone","BytesConverted","Image","Status","Volume"],"members":{"AvailabilityZone":{"locationName":"availabilityZone"},"BytesConverted":{"locationName":"bytesConverted","type":"long"},"Description":{"locationName":"description"},"Image":{"shape":"Scz","locationName":"image"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Volume":{"shape":"Sd0","locationName":"volume"}}}}}},"ImportVolume":{"locationName":"importVolume","type":"structure","required":["AvailabilityZone","BytesConverted","Image","Volume"],"members":{"AvailabilityZone":{"locationName":"availabilityZone"},"BytesConverted":{"locationName":"bytesConverted","type":"long"},"Description":{"locationName":"description"},"Image":{"shape":"Scz","locationName":"image"},"Volume":{"shape":"Sd0","locationName":"volume"}}},"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"Sr","locationName":"tagSet"}}},"Scz":{"type":"structure","required":["Format","ImportManifestUrl","Size"],"members":{"Checksum":{"locationName":"checksum"},"Format":{"locationName":"format"},"ImportManifestUrl":{"locationName":"importManifestUrl"},"Size":{"locationName":"size","type":"long"}}},"Sd0":{"type":"structure","required":["Id"],"members":{"Id":{"locationName":"id"},"Size":{"locationName":"size","type":"long"}}},"Sdy":{"type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"},"Name":{"locationName":"name"},"Description":{"locationName":"description"},"LoadPermissions":{"locationName":"loadPermissions","type":"list","member":{"locationName":"item","type":"structure","members":{"UserId":{"locationName":"userId"},"Group":{"locationName":"group"}}}},"ProductCodes":{"shape":"Se2","locationName":"productCodes"}}},"Se2":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ProductCodeId":{"locationName":"productCode"},"ProductCodeType":{"locationName":"type"}}}},"Se7":{"type":"list","member":{"locationName":"Owner"}},"Seq":{"type":"list","member":{"locationName":"item"}},"Set":{"type":"list","member":{"locationName":"item"}},"Sff":{"type":"list","member":{"shape":"S4y","locationName":"item"}},"Sfg":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Group":{"locationName":"group"},"UserId":{"locationName":"userId"}}}},"Sft":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Sfw":{"type":"list","member":{"locationName":"ImportTaskId"}},"Sg0":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"DeviceName":{"locationName":"deviceName"},"DiskImageSize":{"locationName":"diskImageSize","type":"double"},"Format":{"locationName":"format"},"Progress":{"locationName":"progress"},"SnapshotId":{"locationName":"snapshotId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Url":{"locationName":"url"},"UserBucket":{"shape":"Sg2","locationName":"userBucket"}}}},"Sg2":{"type":"structure","members":{"S3Bucket":{"locationName":"s3Bucket"},"S3Key":{"locationName":"s3Key"}}},"Sg7":{"type":"structure","members":{"Description":{"locationName":"description"},"DiskImageSize":{"locationName":"diskImageSize","type":"double"},"Format":{"locationName":"format"},"Progress":{"locationName":"progress"},"SnapshotId":{"locationName":"snapshotId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Url":{"locationName":"url"},"UserBucket":{"shape":"Sg2","locationName":"userBucket"}}},"Sgb":{"type":"list","member":{"locationName":"item","type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Status":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"}}}}}},"Sge":{"type":"structure","members":{"Value":{"locationName":"value","type":"boolean"}}},"Sgq":{"type":"structure","members":{"Code":{"locationName":"code","type":"integer"},"Name":{"locationName":"name"}}},"Sgs":{"type":"structure","members":{"Details":{"locationName":"details","type":"list","member":{"locationName":"item","type":"structure","members":{"ImpairedSince":{"locationName":"impairedSince","type":"timestamp"},"Name":{"locationName":"name"},"Status":{"locationName":"status"}}}},"Status":{"locationName":"status"}}},"Sh1":{"type":"structure","members":{"Groups":{"shape":"S7m","locationName":"groupSet"},"Instances":{"locationName":"instancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AmiLaunchIndex":{"locationName":"amiLaunchIndex","type":"integer"},"ImageId":{"locationName":"imageId"},"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"LaunchTime":{"locationName":"launchTime","type":"timestamp"},"Monitoring":{"shape":"Sh4","locationName":"monitoring"},"Placement":{"shape":"Sh6","locationName":"placement"},"Platform":{"locationName":"platform"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"ProductCodes":{"shape":"Se2","locationName":"productCodes"},"PublicDnsName":{"locationName":"dnsName"},"PublicIpAddress":{"locationName":"ipAddress"},"RamdiskId":{"locationName":"ramdiskId"},"State":{"shape":"Sgq","locationName":"instanceState"},"StateTransitionReason":{"locationName":"reason"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"Architecture":{"locationName":"architecture"},"BlockDeviceMappings":{"shape":"Sgb","locationName":"blockDeviceMapping"},"ClientToken":{"locationName":"clientToken"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"EnaSupport":{"locationName":"enaSupport","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"IamInstanceProfile":{"shape":"S1c","locationName":"iamInstanceProfile"},"InstanceLifecycle":{"locationName":"instanceLifecycle"},"ElasticGpuAssociations":{"locationName":"elasticGpuAssociationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ElasticGpuId":{"locationName":"elasticGpuId"},"ElasticGpuAssociationId":{"locationName":"elasticGpuAssociationId"},"ElasticGpuAssociationState":{"locationName":"elasticGpuAssociationState"},"ElasticGpuAssociationTime":{"locationName":"elasticGpuAssociationTime"}}}},"NetworkInterfaces":{"locationName":"networkInterfaceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Association":{"shape":"Shc","locationName":"association"},"Attachment":{"locationName":"attachment","type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"AttachmentId":{"locationName":"attachmentId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"Status":{"locationName":"status"}}},"Description":{"locationName":"description"},"Groups":{"shape":"S7m","locationName":"groupSet"},"Ipv6Addresses":{"shape":"S6o","locationName":"ipv6AddressesSet"},"MacAddress":{"locationName":"macAddress"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"OwnerId":{"locationName":"ownerId"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"locationName":"privateIpAddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Association":{"shape":"Shc","locationName":"association"},"Primary":{"locationName":"primary","type":"boolean"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"SourceDestCheck":{"locationName":"sourceDestCheck","type":"boolean"},"Status":{"locationName":"status"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"}}}},"RootDeviceName":{"locationName":"rootDeviceName"},"RootDeviceType":{"locationName":"rootDeviceType"},"SecurityGroups":{"shape":"S7m","locationName":"groupSet"},"SourceDestCheck":{"locationName":"sourceDestCheck","type":"boolean"},"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"SriovNetSupport":{"locationName":"sriovNetSupport"},"StateReason":{"shape":"Sft","locationName":"stateReason"},"Tags":{"shape":"Sr","locationName":"tagSet"},"VirtualizationType":{"locationName":"virtualizationType"}}}},"OwnerId":{"locationName":"ownerId"},"RequesterId":{"locationName":"requesterId"},"ReservationId":{"locationName":"reservationId"}}},"Sh4":{"type":"structure","members":{"State":{"locationName":"state"}}},"Sh6":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Affinity":{"locationName":"affinity"},"GroupName":{"locationName":"groupName"},"HostId":{"locationName":"hostId"},"Tenancy":{"locationName":"tenancy"},"SpreadDomain":{"locationName":"spreadDomain"}}},"Shc":{"type":"structure","members":{"IpOwnerId":{"locationName":"ipOwnerId"},"PublicDnsName":{"locationName":"publicDnsName"},"PublicIp":{"locationName":"publicIp"}}},"Sj3":{"type":"list","member":{"locationName":"ReservedInstancesId"}},"Sjb":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Amount":{"locationName":"amount","type":"double"},"Frequency":{"locationName":"frequency"}}}},"Sjo":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"InstanceType":{"locationName":"instanceType"},"Platform":{"locationName":"platform"},"Scope":{"locationName":"scope"}}},"Sk8":{"type":"structure","members":{"Frequency":{"locationName":"frequency"},"Interval":{"locationName":"interval","type":"integer"},"OccurrenceDaySet":{"locationName":"occurrenceDaySet","type":"list","member":{"locationName":"item","type":"integer"}},"OccurrenceRelativeToEnd":{"locationName":"occurrenceRelativeToEnd","type":"boolean"},"OccurrenceUnit":{"locationName":"occurrenceUnit"}}},"Skf":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"InstanceType":{"locationName":"instanceType"},"NetworkPlatform":{"locationName":"networkPlatform"},"NextSlotStartTime":{"locationName":"nextSlotStartTime","type":"timestamp"},"Platform":{"locationName":"platform"},"PreviousSlotEndTime":{"locationName":"previousSlotEndTime","type":"timestamp"},"Recurrence":{"shape":"Sk8","locationName":"recurrence"},"ScheduledInstanceId":{"locationName":"scheduledInstanceId"},"SlotDurationInHours":{"locationName":"slotDurationInHours","type":"integer"},"TermEndDate":{"locationName":"termEndDate","type":"timestamp"},"TermStartDate":{"locationName":"termStartDate","type":"timestamp"},"TotalScheduledInstanceHours":{"locationName":"totalScheduledInstanceHours","type":"integer"}}},"Skm":{"type":"list","member":{"locationName":"GroupName"}},"Skt":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Group":{"locationName":"group"},"UserId":{"locationName":"userId"}}}},"Sli":{"type":"structure","required":["IamFleetRole","TargetCapacity"],"members":{"AllocationStrategy":{"locationName":"allocationStrategy"},"ClientToken":{"locationName":"clientToken"},"ExcessCapacityTerminationPolicy":{"locationName":"excessCapacityTerminationPolicy"},"FulfilledCapacity":{"locationName":"fulfilledCapacity","type":"double"},"IamFleetRole":{"locationName":"iamFleetRole"},"LaunchSpecifications":{"locationName":"launchSpecifications","type":"list","member":{"locationName":"item","type":"structure","members":{"SecurityGroups":{"shape":"S7m","locationName":"groupSet"},"AddressingType":{"locationName":"addressingType"},"BlockDeviceMappings":{"shape":"Sff","locationName":"blockDeviceMapping"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S19","locationName":"iamInstanceProfile"},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"Monitoring":{"locationName":"monitoring","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"NetworkInterfaces":{"shape":"Slo","locationName":"networkInterfaceSet"},"Placement":{"shape":"Slq","locationName":"placement"},"RamdiskId":{"locationName":"ramdiskId"},"SpotPrice":{"locationName":"spotPrice"},"SubnetId":{"locationName":"subnetId"},"UserData":{"locationName":"userData"},"WeightedCapacity":{"locationName":"weightedCapacity","type":"double"},"TagSpecifications":{"locationName":"tagSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceType":{"locationName":"resourceType"},"Tags":{"shape":"Sr","locationName":"tag"}}}}}}},"LaunchTemplateConfigs":{"locationName":"launchTemplateConfigs","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateSpecification":{"locationName":"launchTemplateSpecification","type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"Version":{"locationName":"version"}}},"Overrides":{"locationName":"overrides","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceType":{"locationName":"instanceType"},"SpotPrice":{"locationName":"spotPrice"},"SubnetId":{"locationName":"subnetId"},"AvailabilityZone":{"locationName":"availabilityZone"},"WeightedCapacity":{"locationName":"weightedCapacity","type":"double"}}}}}}},"SpotPrice":{"locationName":"spotPrice"},"TargetCapacity":{"locationName":"targetCapacity","type":"integer"},"TerminateInstancesWithExpiration":{"locationName":"terminateInstancesWithExpiration","type":"boolean"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"ReplaceUnhealthyInstances":{"locationName":"replaceUnhealthyInstances","type":"boolean"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"},"LoadBalancersConfig":{"locationName":"loadBalancersConfig","type":"structure","members":{"ClassicLoadBalancersConfig":{"locationName":"classicLoadBalancersConfig","type":"structure","required":["ClassicLoadBalancers"],"members":{"ClassicLoadBalancers":{"locationName":"classicLoadBalancers","type":"list","member":{"locationName":"item","type":"structure","required":["Name"],"members":{"Name":{"locationName":"name"}}}}}},"TargetGroupsConfig":{"locationName":"targetGroupsConfig","type":"structure","required":["TargetGroups"],"members":{"TargetGroups":{"locationName":"targetGroups","type":"list","member":{"locationName":"item","type":"structure","required":["Arn"],"members":{"Arn":{"locationName":"arn"}}}}}}}}}},"Slo":{"type":"list","member":{"locationName":"item","type":"structure","members":{"AssociatePublicIpAddress":{"locationName":"associatePublicIpAddress","type":"boolean"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Description":{"locationName":"description"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"Groups":{"shape":"S5r","locationName":"SecurityGroupId"},"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"S6o","locationName":"ipv6AddressesSet","queryName":"Ipv6Addresses"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"shape":"S5u","locationName":"privateIpAddressesSet","queryName":"PrivateIpAddresses"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"SubnetId":{"locationName":"subnetId"}}}},"Slq":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"GroupName":{"locationName":"groupName"},"Tenancy":{"locationName":"tenancy"}}},"Sm8":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ActualBlockHourlyPrice":{"locationName":"actualBlockHourlyPrice"},"AvailabilityZoneGroup":{"locationName":"availabilityZoneGroup"},"BlockDurationMinutes":{"locationName":"blockDurationMinutes","type":"integer"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"Fault":{"shape":"S8t","locationName":"fault"},"InstanceId":{"locationName":"instanceId"},"LaunchGroup":{"locationName":"launchGroup"},"LaunchSpecification":{"locationName":"launchSpecification","type":"structure","members":{"UserData":{"locationName":"userData"},"SecurityGroups":{"shape":"S7m","locationName":"groupSet"},"AddressingType":{"locationName":"addressingType"},"BlockDeviceMappings":{"shape":"Sff","locationName":"blockDeviceMapping"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S19","locationName":"iamInstanceProfile"},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"NetworkInterfaces":{"shape":"Slo","locationName":"networkInterfaceSet"},"Placement":{"shape":"Slq","locationName":"placement"},"RamdiskId":{"locationName":"ramdiskId"},"SubnetId":{"locationName":"subnetId"},"Monitoring":{"shape":"Smb","locationName":"monitoring"}}},"LaunchedAvailabilityZone":{"locationName":"launchedAvailabilityZone"},"ProductDescription":{"locationName":"productDescription"},"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"SpotPrice":{"locationName":"spotPrice"},"State":{"locationName":"state"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"},"UpdateTime":{"locationName":"updateTime","type":"timestamp"}}},"Tags":{"shape":"Sr","locationName":"tagSet"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"}}}},"Smb":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"Smo":{"type":"list","member":{"locationName":"item","type":"structure","members":{"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"IpRanges":{"locationName":"ipRanges","type":"list","member":{"locationName":"item"}},"PrefixListIds":{"locationName":"prefixListIds","type":"list","member":{"locationName":"item"}},"ToPort":{"locationName":"toPort","type":"integer"},"UserIdGroupPairs":{"locationName":"groups","type":"list","member":{"shape":"S2e","locationName":"item"}}}}},"Sn5":{"type":"list","member":{"locationName":"VolumeId"}},"Sno":{"type":"structure","members":{"VolumeId":{"locationName":"volumeId"},"ModificationState":{"locationName":"modificationState"},"StatusMessage":{"locationName":"statusMessage"},"TargetSize":{"locationName":"targetSize","type":"integer"},"TargetIops":{"locationName":"targetIops","type":"integer"},"TargetVolumeType":{"locationName":"targetVolumeType"},"OriginalSize":{"locationName":"originalSize","type":"integer"},"OriginalIops":{"locationName":"originalIops","type":"integer"},"OriginalVolumeType":{"locationName":"originalVolumeType"},"Progress":{"locationName":"progress","type":"long"},"StartTime":{"locationName":"startTime","type":"timestamp"},"EndTime":{"locationName":"endTime","type":"timestamp"}}},"Snu":{"type":"list","member":{"locationName":"VpcId"}},"Spx":{"type":"list","member":{"locationName":"item"}},"Spz":{"type":"list","member":{"locationName":"item","type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"HostIdSet":{"shape":"Seq","locationName":"hostIdSet"},"HostReservationId":{"locationName":"hostReservationId"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceFamily":{"locationName":"instanceFamily"},"PaymentOption":{"locationName":"paymentOption"},"UpfrontPrice":{"locationName":"upfrontPrice"}}}},"Sq7":{"type":"structure","members":{"HourlyPrice":{"locationName":"hourlyPrice"},"RemainingTotalValue":{"locationName":"remainingTotalValue"},"RemainingUpfrontValue":{"locationName":"remainingUpfrontValue"}}},"Sqe":{"type":"structure","members":{"Comment":{},"UploadEnd":{"type":"timestamp"},"UploadSize":{"type":"double"},"UploadStart":{"type":"timestamp"}}},"Sqh":{"type":"structure","members":{"S3Bucket":{},"S3Key":{}}},"Sqm":{"type":"structure","required":["Bytes","Format","ImportManifestUrl"],"members":{"Bytes":{"locationName":"bytes","type":"long"},"Format":{"locationName":"format"},"ImportManifestUrl":{"locationName":"importManifestUrl"}}},"Sqn":{"type":"structure","required":["Size"],"members":{"Size":{"locationName":"size","type":"long"}}},"Sr0":{"type":"list","member":{"locationName":"UserId"}},"Sr1":{"type":"list","member":{"locationName":"UserGroup"}},"Sr2":{"type":"list","member":{"locationName":"ProductCode"}},"Sr4":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Group":{},"UserId":{}}}},"Sr9":{"type":"list","member":{"shape":"Sd","locationName":"item"}},"Ssm":{"type":"structure","members":{"AllowDnsResolutionFromRemoteVpc":{"type":"boolean"},"AllowEgressFromLocalClassicLinkToRemoteVpc":{"type":"boolean"},"AllowEgressFromLocalVpcToRemoteClassicLink":{"type":"boolean"}}},"Sso":{"type":"structure","members":{"AllowDnsResolutionFromRemoteVpc":{"locationName":"allowDnsResolutionFromRemoteVpc","type":"boolean"},"AllowEgressFromLocalClassicLinkToRemoteVpc":{"locationName":"allowEgressFromLocalClassicLinkToRemoteVpc","type":"boolean"},"AllowEgressFromLocalVpcToRemoteClassicLink":{"locationName":"allowEgressFromLocalVpcToRemoteClassicLink","type":"boolean"}}},"Ssu":{"type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"Monitoring":{"shape":"Sh4","locationName":"monitoring"}}}},"Sur":{"type":"list","member":{"locationName":"SecurityGroupId"}},"Sv2":{"type":"list","member":{"locationName":"item","type":"structure","members":{"CurrentState":{"shape":"Sgq","locationName":"currentState"},"InstanceId":{"locationName":"instanceId"},"PreviousState":{"shape":"Sgq","locationName":"previousState"}}}}}}

/***/ }),
/* 2814 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeAccountAttributes":{"result_key":"AccountAttributes"},"DescribeAddresses":{"result_key":"Addresses"},"DescribeAvailabilityZones":{"result_key":"AvailabilityZones"},"DescribeBundleTasks":{"result_key":"BundleTasks"},"DescribeConversionTasks":{"result_key":"ConversionTasks"},"DescribeCustomerGateways":{"result_key":"CustomerGateways"},"DescribeDhcpOptions":{"result_key":"DhcpOptions"},"DescribeExportTasks":{"result_key":"ExportTasks"},"DescribeImages":{"result_key":"Images"},"DescribeInstanceStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceStatuses"},"DescribeInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Reservations"},"DescribeInternetGateways":{"result_key":"InternetGateways"},"DescribeKeyPairs":{"result_key":"KeyPairs"},"DescribeNatGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NatGateways"},"DescribeNetworkAcls":{"result_key":"NetworkAcls"},"DescribeNetworkInterfaces":{"result_key":"NetworkInterfaces"},"DescribePlacementGroups":{"result_key":"PlacementGroups"},"DescribeRegions":{"result_key":"Regions"},"DescribeReservedInstances":{"result_key":"ReservedInstances"},"DescribeReservedInstancesListings":{"result_key":"ReservedInstancesListings"},"DescribeReservedInstancesModifications":{"input_token":"NextToken","output_token":"NextToken","result_key":"ReservedInstancesModifications"},"DescribeReservedInstancesOfferings":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ReservedInstancesOfferings"},"DescribeRouteTables":{"result_key":"RouteTables"},"DescribeSecurityGroups":{"result_key":"SecurityGroups"},"DescribeSnapshots":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Snapshots"},"DescribeSpotFleetRequests":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SpotFleetRequestConfigs"},"DescribeSpotInstanceRequests":{"result_key":"SpotInstanceRequests"},"DescribeSpotPriceHistory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SpotPriceHistory"},"DescribeSubnets":{"result_key":"Subnets"},"DescribeTags":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Tags"},"DescribeVolumeStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VolumeStatuses"},"DescribeVolumes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Volumes"},"DescribeVpcPeeringConnections":{"result_key":"VpcPeeringConnections"},"DescribeVpcs":{"result_key":"Vpcs"},"DescribeVpnConnections":{"result_key":"VpnConnections"},"DescribeVpnGateways":{"result_key":"VpnGateways"}}}

/***/ }),
/* 2815 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"InstanceExists":{"delay":5,"maxAttempts":40,"operation":"DescribeInstances","acceptors":[{"matcher":"path","expected":true,"argument":"length(Reservations[]) > `0`","state":"success"},{"matcher":"error","expected":"InvalidInstanceID.NotFound","state":"retry"}]},"BundleTaskComplete":{"delay":15,"operation":"DescribeBundleTasks","maxAttempts":40,"acceptors":[{"expected":"complete","matcher":"pathAll","state":"success","argument":"BundleTasks[].State"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"BundleTasks[].State"}]},"ConversionTaskCancelled":{"delay":15,"operation":"DescribeConversionTasks","maxAttempts":40,"acceptors":[{"expected":"cancelled","matcher":"pathAll","state":"success","argument":"ConversionTasks[].State"}]},"ConversionTaskCompleted":{"delay":15,"operation":"DescribeConversionTasks","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"ConversionTasks[].State"},{"expected":"cancelled","matcher":"pathAny","state":"failure","argument":"ConversionTasks[].State"},{"expected":"cancelling","matcher":"pathAny","state":"failure","argument":"ConversionTasks[].State"}]},"ConversionTaskDeleted":{"delay":15,"operation":"DescribeConversionTasks","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"ConversionTasks[].State"}]},"CustomerGatewayAvailable":{"delay":15,"operation":"DescribeCustomerGateways","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"CustomerGateways[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"CustomerGateways[].State"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"CustomerGateways[].State"}]},"ExportTaskCancelled":{"delay":15,"operation":"DescribeExportTasks","maxAttempts":40,"acceptors":[{"expected":"cancelled","matcher":"pathAll","state":"success","argument":"ExportTasks[].State"}]},"ExportTaskCompleted":{"delay":15,"operation":"DescribeExportTasks","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"ExportTasks[].State"}]},"ImageExists":{"operation":"DescribeImages","maxAttempts":40,"delay":15,"acceptors":[{"matcher":"path","expected":true,"argument":"length(Images[]) > `0`","state":"success"},{"matcher":"error","expected":"InvalidAMIID.NotFound","state":"retry"}]},"ImageAvailable":{"operation":"DescribeImages","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"Images[].State","expected":"available"},{"state":"failure","matcher":"pathAny","argument":"Images[].State","expected":"failed"}]},"InstanceRunning":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"acceptors":[{"expected":"running","matcher":"pathAll","state":"success","argument":"Reservations[].Instances[].State.Name"},{"expected":"shutting-down","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"matcher":"error","expected":"InvalidInstanceID.NotFound","state":"retry"}]},"InstanceStatusOk":{"operation":"DescribeInstanceStatus","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"InstanceStatuses[].InstanceStatus.Status","expected":"ok"},{"matcher":"error","expected":"InvalidInstanceID.NotFound","state":"retry"}]},"InstanceStopped":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"acceptors":[{"expected":"stopped","matcher":"pathAll","state":"success","argument":"Reservations[].Instances[].State.Name"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"}]},"InstanceTerminated":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"acceptors":[{"expected":"terminated","matcher":"pathAll","state":"success","argument":"Reservations[].Instances[].State.Name"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"}]},"KeyPairExists":{"operation":"DescribeKeyPairs","delay":5,"maxAttempts":6,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(KeyPairs[].KeyName) > `0`"},{"expected":"InvalidKeyPair.NotFound","matcher":"error","state":"retry"}]},"NatGatewayAvailable":{"operation":"DescribeNatGateways","delay":15,"maxAttempts":40,"acceptors":[{"state":"success","matcher":"pathAll","argument":"NatGateways[].State","expected":"available"},{"state":"failure","matcher":"pathAny","argument":"NatGateways[].State","expected":"failed"},{"state":"failure","matcher":"pathAny","argument":"NatGateways[].State","expected":"deleting"},{"state":"failure","matcher":"pathAny","argument":"NatGateways[].State","expected":"deleted"},{"state":"retry","matcher":"error","expected":"NatGatewayNotFound"}]},"NetworkInterfaceAvailable":{"operation":"DescribeNetworkInterfaces","delay":20,"maxAttempts":10,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"NetworkInterfaces[].Status"},{"expected":"InvalidNetworkInterfaceID.NotFound","matcher":"error","state":"failure"}]},"PasswordDataAvailable":{"operation":"GetPasswordData","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"path","argument":"length(PasswordData) > `0`","expected":true}]},"SnapshotCompleted":{"delay":15,"operation":"DescribeSnapshots","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"Snapshots[].State"}]},"SpotInstanceRequestFulfilled":{"operation":"DescribeSpotInstanceRequests","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"SpotInstanceRequests[].Status.Code","expected":"fulfilled"},{"state":"success","matcher":"pathAll","argument":"SpotInstanceRequests[].Status.Code","expected":"request-canceled-and-instance-running"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"schedule-expired"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"canceled-before-fulfillment"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"bad-parameters"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"system-error"},{"state":"retry","matcher":"error","expected":"InvalidSpotInstanceRequestID.NotFound"}]},"SubnetAvailable":{"delay":15,"operation":"DescribeSubnets","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Subnets[].State"}]},"SystemStatusOk":{"operation":"DescribeInstanceStatus","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"InstanceStatuses[].SystemStatus.Status","expected":"ok"}]},"VolumeAvailable":{"delay":15,"operation":"DescribeVolumes","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Volumes[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"Volumes[].State"}]},"VolumeDeleted":{"delay":15,"operation":"DescribeVolumes","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"Volumes[].State"},{"matcher":"error","expected":"InvalidVolume.NotFound","state":"success"}]},"VolumeInUse":{"delay":15,"operation":"DescribeVolumes","maxAttempts":40,"acceptors":[{"expected":"in-use","matcher":"pathAll","state":"success","argument":"Volumes[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"Volumes[].State"}]},"VpcAvailable":{"delay":15,"operation":"DescribeVpcs","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Vpcs[].State"}]},"VpcExists":{"operation":"DescribeVpcs","delay":1,"maxAttempts":5,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"InvalidVpcID.NotFound","state":"retry"}]},"VpnConnectionAvailable":{"delay":15,"operation":"DescribeVpnConnections","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"VpnConnections[].State"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"VpnConnections[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"VpnConnections[].State"}]},"VpnConnectionDeleted":{"delay":15,"operation":"DescribeVpnConnections","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"VpnConnections[].State"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"VpnConnections[].State"}]},"VpcPeeringConnectionExists":{"delay":15,"operation":"DescribeVpcPeeringConnections","maxAttempts":40,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"InvalidVpcPeeringConnectionID.NotFound","state":"retry"}]},"VpcPeeringConnectionDeleted":{"delay":15,"operation":"DescribeVpcPeeringConnections","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"VpcPeeringConnections[].Status.Code"},{"matcher":"error","expected":"InvalidVpcPeeringConnectionID.NotFound","state":"success"}]}}}

/***/ }),
/* 2816 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['ecr'] = {};
AWS.ECR = Service.defineService('ecr', ['2015-09-21']);
Object.defineProperty(apiLoader.services['ecr'], '2015-09-21', {
  get: function get() {
    var model = __webpack_require__(2817);
    model.paginators = __webpack_require__(2818).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ECR;


/***/ }),
/* 2817 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-09-21","endpointPrefix":"ecr","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon ECR","serviceFullName":"Amazon EC2 Container Registry","signatureVersion":"v4","targetPrefix":"AmazonEC2ContainerRegistry_V20150921","uid":"ecr-2015-09-21"},"operations":{"BatchCheckLayerAvailability":{"input":{"type":"structure","required":["repositoryName","layerDigests"],"members":{"registryId":{},"repositoryName":{},"layerDigests":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"layers":{"type":"list","member":{"type":"structure","members":{"layerDigest":{},"layerAvailability":{},"layerSize":{"type":"long"},"mediaType":{}}}},"failures":{"type":"list","member":{"type":"structure","members":{"layerDigest":{},"failureCode":{},"failureReason":{}}}}}}},"BatchDeleteImage":{"input":{"type":"structure","required":["repositoryName","imageIds"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"}}},"output":{"type":"structure","members":{"imageIds":{"shape":"Si"},"failures":{"shape":"Sn"}}}},"BatchGetImage":{"input":{"type":"structure","required":["repositoryName","imageIds"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"},"acceptedMediaTypes":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"images":{"type":"list","member":{"shape":"Sv"}},"failures":{"shape":"Sn"}}}},"CompleteLayerUpload":{"input":{"type":"structure","required":["repositoryName","uploadId","layerDigests"],"members":{"registryId":{},"repositoryName":{},"uploadId":{},"layerDigests":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"uploadId":{},"layerDigest":{}}}},"CreateRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"repository":{"shape":"S13"}}}},"DeleteLifecyclePolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"lastEvaluatedAt":{"type":"timestamp"}}}},"DeleteRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"repository":{"shape":"S13"}}}},"DeleteRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"DescribeImages":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"tagStatus":{}}}}},"output":{"type":"structure","members":{"imageDetails":{"type":"list","member":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageDigest":{},"imageTags":{"shape":"S1p"},"imageSizeInBytes":{"type":"long"},"imagePushedAt":{"type":"timestamp"}}}},"nextToken":{}}}},"DescribeRepositories":{"input":{"type":"structure","members":{"registryId":{},"repositoryNames":{"type":"list","member":{}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"shape":"S13"}},"nextToken":{}}}},"GetAuthorizationToken":{"input":{"type":"structure","members":{"registryIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"authorizationData":{"type":"list","member":{"type":"structure","members":{"authorizationToken":{},"expiresAt":{"type":"timestamp"},"proxyEndpoint":{}}}}}}},"GetDownloadUrlForLayer":{"input":{"type":"structure","required":["repositoryName","layerDigest"],"members":{"registryId":{},"repositoryName":{},"layerDigest":{}}},"output":{"type":"structure","members":{"downloadUrl":{},"layerDigest":{}}}},"GetLifecyclePolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"lastEvaluatedAt":{"type":"timestamp"}}}},"GetLifecyclePolicyPreview":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"tagStatus":{}}}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"status":{},"nextToken":{},"previewResults":{"type":"list","member":{"type":"structure","members":{"imageTags":{"shape":"S1p"},"imageDigest":{},"imagePushedAt":{"type":"timestamp"},"action":{"type":"structure","members":{"type":{}}},"appliedRulePriority":{"type":"integer"}}}},"summary":{"type":"structure","members":{"expiringImageTotalCount":{"type":"integer"}}}}}},"GetRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"InitiateLayerUpload":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"uploadId":{},"partSize":{"type":"long"}}}},"ListImages":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"tagStatus":{}}}}},"output":{"type":"structure","members":{"imageIds":{"shape":"Si"},"nextToken":{}}}},"PutImage":{"input":{"type":"structure","required":["repositoryName","imageManifest"],"members":{"registryId":{},"repositoryName":{},"imageManifest":{},"imageTag":{}}},"output":{"type":"structure","members":{"image":{"shape":"Sv"}}}},"PutLifecyclePolicy":{"input":{"type":"structure","required":["repositoryName","lifecyclePolicyText"],"members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{}}}},"SetRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName","policyText"],"members":{"registryId":{},"repositoryName":{},"policyText":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"StartLifecyclePolicyPreview":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"status":{}}}},"UploadLayerPart":{"input":{"type":"structure","required":["repositoryName","uploadId","partFirstByte","partLastByte","layerPartBlob"],"members":{"registryId":{},"repositoryName":{},"uploadId":{},"partFirstByte":{"type":"long"},"partLastByte":{"type":"long"},"layerPartBlob":{"type":"blob"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"uploadId":{},"lastByteReceived":{"type":"long"}}}}},"shapes":{"Si":{"type":"list","member":{"shape":"Sj"}},"Sj":{"type":"structure","members":{"imageDigest":{},"imageTag":{}}},"Sn":{"type":"list","member":{"type":"structure","members":{"imageId":{"shape":"Sj"},"failureCode":{},"failureReason":{}}}},"Sv":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sj"},"imageManifest":{}}},"S13":{"type":"structure","members":{"repositoryArn":{},"registryId":{},"repositoryName":{},"repositoryUri":{},"createdAt":{"type":"timestamp"}}},"S1p":{"type":"list","member":{}}}}

/***/ }),
/* 2818 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeImages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"imageDetails"},"DescribeRepositories":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"repositories"},"ListImages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"imageIds"}}}

/***/ }),
/* 2819 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['ecs'] = {};
AWS.ECS = Service.defineService('ecs', ['2014-11-13']);
Object.defineProperty(apiLoader.services['ecs'], '2014-11-13', {
  get: function get() {
    var model = __webpack_require__(2820);
    model.paginators = __webpack_require__(2821).pagination;
    model.waiters = __webpack_require__(2822).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ECS;


/***/ }),
/* 2820 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-13","endpointPrefix":"ecs","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon ECS","serviceFullName":"Amazon EC2 Container Service","serviceId":"ECS","signatureVersion":"v4","targetPrefix":"AmazonEC2ContainerServiceV20141113","uid":"ecs-2014-11-13"},"operations":{"CreateCluster":{"input":{"type":"structure","members":{"clusterName":{}}},"output":{"type":"structure","members":{"cluster":{"shape":"S4"}}}},"CreateService":{"input":{"type":"structure","required":["serviceName","taskDefinition","desiredCount"],"members":{"cluster":{},"serviceName":{},"taskDefinition":{},"loadBalancers":{"shape":"S9"},"desiredCount":{"type":"integer"},"clientToken":{},"launchType":{},"platformVersion":{},"role":{},"deploymentConfiguration":{"shape":"Sd"},"placementConstraints":{"shape":"Se"},"placementStrategy":{"shape":"Sh"},"networkConfiguration":{"shape":"Sk"},"healthCheckGracePeriodSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"service":{"shape":"Sp"}}}},"DeleteAttributes":{"input":{"type":"structure","required":["attributes"],"members":{"cluster":{},"attributes":{"shape":"Sw"}}},"output":{"type":"structure","members":{"attributes":{"shape":"Sw"}}}},"DeleteCluster":{"input":{"type":"structure","required":["cluster"],"members":{"cluster":{}}},"output":{"type":"structure","members":{"cluster":{"shape":"S4"}}}},"DeleteService":{"input":{"type":"structure","required":["service"],"members":{"cluster":{},"service":{}}},"output":{"type":"structure","members":{"service":{"shape":"Sp"}}}},"DeregisterContainerInstance":{"input":{"type":"structure","required":["containerInstance"],"members":{"cluster":{},"containerInstance":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"containerInstance":{"shape":"S17"}}}},"DeregisterTaskDefinition":{"input":{"type":"structure","required":["taskDefinition"],"members":{"taskDefinition":{}}},"output":{"type":"structure","members":{"taskDefinition":{"shape":"S1k"}}}},"DescribeClusters":{"input":{"type":"structure","members":{"clusters":{"shape":"Sm"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"clusters":{"type":"list","member":{"shape":"S4"}},"failures":{"shape":"S2r"}}}},"DescribeContainerInstances":{"input":{"type":"structure","required":["containerInstances"],"members":{"cluster":{},"containerInstances":{"shape":"Sm"}}},"output":{"type":"structure","members":{"containerInstances":{"shape":"S2v"},"failures":{"shape":"S2r"}}}},"DescribeServices":{"input":{"type":"structure","required":["services"],"members":{"cluster":{},"services":{"shape":"Sm"}}},"output":{"type":"structure","members":{"services":{"type":"list","member":{"shape":"Sp"}},"failures":{"shape":"S2r"}}}},"DescribeTaskDefinition":{"input":{"type":"structure","required":["taskDefinition"],"members":{"taskDefinition":{}}},"output":{"type":"structure","members":{"taskDefinition":{"shape":"S1k"}}}},"DescribeTasks":{"input":{"type":"structure","required":["tasks"],"members":{"cluster":{},"tasks":{"shape":"Sm"}}},"output":{"type":"structure","members":{"tasks":{"shape":"S33"},"failures":{"shape":"S2r"}}}},"DiscoverPollEndpoint":{"input":{"type":"structure","members":{"containerInstance":{},"cluster":{}}},"output":{"type":"structure","members":{"endpoint":{},"telemetryEndpoint":{}}}},"ListAttributes":{"input":{"type":"structure","required":["targetType"],"members":{"cluster":{},"targetType":{},"attributeName":{},"attributeValue":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"attributes":{"shape":"Sw"},"nextToken":{}}}},"ListClusters":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"clusterArns":{"shape":"Sm"},"nextToken":{}}}},"ListContainerInstances":{"input":{"type":"structure","members":{"cluster":{},"filter":{},"nextToken":{},"maxResults":{"type":"integer"},"status":{}}},"output":{"type":"structure","members":{"containerInstanceArns":{"shape":"Sm"},"nextToken":{}}}},"ListServices":{"input":{"type":"structure","members":{"cluster":{},"nextToken":{},"maxResults":{"type":"integer"},"launchType":{}}},"output":{"type":"structure","members":{"serviceArns":{"shape":"Sm"},"nextToken":{}}}},"ListTaskDefinitionFamilies":{"input":{"type":"structure","members":{"familyPrefix":{},"status":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"families":{"shape":"Sm"},"nextToken":{}}}},"ListTaskDefinitions":{"input":{"type":"structure","members":{"familyPrefix":{},"status":{},"sort":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"taskDefinitionArns":{"shape":"Sm"},"nextToken":{}}}},"ListTasks":{"input":{"type":"structure","members":{"cluster":{},"containerInstance":{},"family":{},"nextToken":{},"maxResults":{"type":"integer"},"startedBy":{},"serviceName":{},"desiredStatus":{},"launchType":{}}},"output":{"type":"structure","members":{"taskArns":{"shape":"Sm"},"nextToken":{}}}},"PutAttributes":{"input":{"type":"structure","required":["attributes"],"members":{"cluster":{},"attributes":{"shape":"Sw"}}},"output":{"type":"structure","members":{"attributes":{"shape":"Sw"}}}},"RegisterContainerInstance":{"input":{"type":"structure","members":{"cluster":{},"instanceIdentityDocument":{},"instanceIdentityDocumentSignature":{},"totalResources":{"shape":"S1a"},"versionInfo":{"shape":"S19"},"containerInstanceArn":{},"attributes":{"shape":"Sw"}}},"output":{"type":"structure","members":{"containerInstance":{"shape":"S17"}}}},"RegisterTaskDefinition":{"input":{"type":"structure","required":["family","containerDefinitions"],"members":{"family":{},"taskRoleArn":{},"executionRoleArn":{},"networkMode":{},"containerDefinitions":{"shape":"S1l"},"volumes":{"shape":"S2c"},"placementConstraints":{"shape":"S2h"},"requiresCompatibilities":{"shape":"S2k"},"cpu":{},"memory":{}}},"output":{"type":"structure","members":{"taskDefinition":{"shape":"S1k"}}}},"RunTask":{"input":{"type":"structure","required":["taskDefinition"],"members":{"cluster":{},"taskDefinition":{},"overrides":{"shape":"S35"},"count":{"type":"integer"},"startedBy":{},"group":{},"placementConstraints":{"shape":"Se"},"placementStrategy":{"shape":"Sh"},"launchType":{},"platformVersion":{},"networkConfiguration":{"shape":"Sk"}}},"output":{"type":"structure","members":{"tasks":{"shape":"S33"},"failures":{"shape":"S2r"}}}},"StartTask":{"input":{"type":"structure","required":["taskDefinition","containerInstances"],"members":{"cluster":{},"taskDefinition":{},"overrides":{"shape":"S35"},"containerInstances":{"shape":"Sm"},"startedBy":{},"group":{},"networkConfiguration":{"shape":"Sk"}}},"output":{"type":"structure","members":{"tasks":{"shape":"S33"},"failures":{"shape":"S2r"}}}},"StopTask":{"input":{"type":"structure","required":["task"],"members":{"cluster":{},"task":{},"reason":{}}},"output":{"type":"structure","members":{"task":{"shape":"S34"}}}},"SubmitContainerStateChange":{"input":{"type":"structure","members":{"cluster":{},"task":{},"containerName":{},"status":{},"exitCode":{"type":"integer"},"reason":{},"networkBindings":{"shape":"S3a"}}},"output":{"type":"structure","members":{"acknowledgment":{}}}},"SubmitTaskStateChange":{"input":{"type":"structure","members":{"cluster":{},"task":{},"status":{},"reason":{},"containers":{"type":"list","member":{"type":"structure","members":{"containerName":{},"exitCode":{"type":"integer"},"networkBindings":{"shape":"S3a"},"reason":{},"status":{}}}},"attachments":{"type":"list","member":{"type":"structure","required":["attachmentArn","status"],"members":{"attachmentArn":{},"status":{}}}},"pullStartedAt":{"type":"timestamp"},"pullStoppedAt":{"type":"timestamp"},"executionStoppedAt":{"type":"timestamp"}}},"output":{"type":"structure","members":{"acknowledgment":{}}}},"UpdateContainerAgent":{"input":{"type":"structure","required":["containerInstance"],"members":{"cluster":{},"containerInstance":{}}},"output":{"type":"structure","members":{"containerInstance":{"shape":"S17"}}}},"UpdateContainerInstancesState":{"input":{"type":"structure","required":["containerInstances","status"],"members":{"cluster":{},"containerInstances":{"shape":"Sm"},"status":{}}},"output":{"type":"structure","members":{"containerInstances":{"shape":"S2v"},"failures":{"shape":"S2r"}}}},"UpdateService":{"input":{"type":"structure","required":["service"],"members":{"cluster":{},"service":{},"desiredCount":{"type":"integer"},"taskDefinition":{},"deploymentConfiguration":{"shape":"Sd"},"networkConfiguration":{"shape":"Sk"},"platformVersion":{},"forceNewDeployment":{"type":"boolean"},"healthCheckGracePeriodSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"service":{"shape":"Sp"}}}}},"shapes":{"S4":{"type":"structure","members":{"clusterArn":{},"clusterName":{},"status":{},"registeredContainerInstancesCount":{"type":"integer"},"runningTasksCount":{"type":"integer"},"pendingTasksCount":{"type":"integer"},"activeServicesCount":{"type":"integer"},"statistics":{"type":"list","member":{"shape":"S7"}}}},"S7":{"type":"structure","members":{"name":{},"value":{}}},"S9":{"type":"list","member":{"type":"structure","members":{"targetGroupArn":{},"loadBalancerName":{},"containerName":{},"containerPort":{"type":"integer"}}}},"Sd":{"type":"structure","members":{"maximumPercent":{"type":"integer"},"minimumHealthyPercent":{"type":"integer"}}},"Se":{"type":"list","member":{"type":"structure","members":{"type":{},"expression":{}}}},"Sh":{"type":"list","member":{"type":"structure","members":{"type":{},"field":{}}}},"Sk":{"type":"structure","members":{"awsvpcConfiguration":{"type":"structure","required":["subnets"],"members":{"subnets":{"shape":"Sm"},"securityGroups":{"shape":"Sm"},"assignPublicIp":{}}}}},"Sm":{"type":"list","member":{}},"Sp":{"type":"structure","members":{"serviceArn":{},"serviceName":{},"clusterArn":{},"loadBalancers":{"shape":"S9"},"status":{},"desiredCount":{"type":"integer"},"runningCount":{"type":"integer"},"pendingCount":{"type":"integer"},"launchType":{},"platformVersion":{},"taskDefinition":{},"deploymentConfiguration":{"shape":"Sd"},"deployments":{"type":"list","member":{"type":"structure","members":{"id":{},"status":{},"taskDefinition":{},"desiredCount":{"type":"integer"},"pendingCount":{"type":"integer"},"runningCount":{"type":"integer"},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"},"launchType":{},"platformVersion":{},"networkConfiguration":{"shape":"Sk"}}}},"roleArn":{},"events":{"type":"list","member":{"type":"structure","members":{"id":{},"createdAt":{"type":"timestamp"},"message":{}}}},"createdAt":{"type":"timestamp"},"placementConstraints":{"shape":"Se"},"placementStrategy":{"shape":"Sh"},"networkConfiguration":{"shape":"Sk"},"healthCheckGracePeriodSeconds":{"type":"integer"}}},"Sw":{"type":"list","member":{"shape":"Sx"}},"Sx":{"type":"structure","required":["name"],"members":{"name":{},"value":{},"targetType":{},"targetId":{}}},"S17":{"type":"structure","members":{"containerInstanceArn":{},"ec2InstanceId":{},"version":{"type":"long"},"versionInfo":{"shape":"S19"},"remainingResources":{"shape":"S1a"},"registeredResources":{"shape":"S1a"},"status":{},"agentConnected":{"type":"boolean"},"runningTasksCount":{"type":"integer"},"pendingTasksCount":{"type":"integer"},"agentUpdateStatus":{},"attributes":{"shape":"Sw"},"registeredAt":{"type":"timestamp"},"attachments":{"shape":"S1f"}}},"S19":{"type":"structure","members":{"agentVersion":{},"agentHash":{},"dockerVersion":{}}},"S1a":{"type":"list","member":{"type":"structure","members":{"name":{},"type":{},"doubleValue":{"type":"double"},"longValue":{"type":"long"},"integerValue":{"type":"integer"},"stringSetValue":{"shape":"Sm"}}}},"S1f":{"type":"list","member":{"type":"structure","members":{"id":{},"type":{},"status":{},"details":{"type":"list","member":{"shape":"S7"}}}}},"S1k":{"type":"structure","members":{"taskDefinitionArn":{},"containerDefinitions":{"shape":"S1l"},"family":{},"taskRoleArn":{},"executionRoleArn":{},"networkMode":{},"revision":{"type":"integer"},"volumes":{"shape":"S2c"},"status":{},"requiresAttributes":{"type":"list","member":{"shape":"Sx"}},"placementConstraints":{"shape":"S2h"},"compatibilities":{"shape":"S2k"},"requiresCompatibilities":{"shape":"S2k"},"cpu":{},"memory":{}}},"S1l":{"type":"list","member":{"type":"structure","members":{"name":{},"image":{},"cpu":{"type":"integer"},"memory":{"type":"integer"},"memoryReservation":{"type":"integer"},"links":{"shape":"Sm"},"portMappings":{"type":"list","member":{"type":"structure","members":{"containerPort":{"type":"integer"},"hostPort":{"type":"integer"},"protocol":{}}}},"essential":{"type":"boolean"},"entryPoint":{"shape":"Sm"},"command":{"shape":"Sm"},"environment":{"shape":"S1q"},"mountPoints":{"type":"list","member":{"type":"structure","members":{"sourceVolume":{},"containerPath":{},"readOnly":{"type":"boolean"}}}},"volumesFrom":{"type":"list","member":{"type":"structure","members":{"sourceContainer":{},"readOnly":{"type":"boolean"}}}},"linuxParameters":{"type":"structure","members":{"capabilities":{"type":"structure","members":{"add":{"shape":"Sm"},"drop":{"shape":"Sm"}}},"devices":{"type":"list","member":{"type":"structure","required":["hostPath"],"members":{"hostPath":{},"containerPath":{},"permissions":{"type":"list","member":{}}}}},"initProcessEnabled":{"type":"boolean"}}},"hostname":{},"user":{},"workingDirectory":{},"disableNetworking":{"type":"boolean"},"privileged":{"type":"boolean"},"readonlyRootFilesystem":{"type":"boolean"},"dnsServers":{"shape":"Sm"},"dnsSearchDomains":{"shape":"Sm"},"extraHosts":{"type":"list","member":{"type":"structure","required":["hostname","ipAddress"],"members":{"hostname":{},"ipAddress":{}}}},"dockerSecurityOptions":{"shape":"Sm"},"dockerLabels":{"type":"map","key":{},"value":{}},"ulimits":{"type":"list","member":{"type":"structure","required":["name","softLimit","hardLimit"],"members":{"name":{},"softLimit":{"type":"integer"},"hardLimit":{"type":"integer"}}}},"logConfiguration":{"type":"structure","required":["logDriver"],"members":{"logDriver":{},"options":{"type":"map","key":{},"value":{}}}},"healthCheck":{"type":"structure","required":["command"],"members":{"command":{"shape":"Sm"},"interval":{"type":"integer"},"timeout":{"type":"integer"},"retries":{"type":"integer"},"startPeriod":{"type":"integer"}}}}}},"S1q":{"type":"list","member":{"shape":"S7"}},"S2c":{"type":"list","member":{"type":"structure","members":{"name":{},"host":{"type":"structure","members":{"sourcePath":{}}}}}},"S2h":{"type":"list","member":{"type":"structure","members":{"type":{},"expression":{}}}},"S2k":{"type":"list","member":{}},"S2r":{"type":"list","member":{"type":"structure","members":{"arn":{},"reason":{}}}},"S2v":{"type":"list","member":{"shape":"S17"}},"S33":{"type":"list","member":{"shape":"S34"}},"S34":{"type":"structure","members":{"taskArn":{},"clusterArn":{},"taskDefinitionArn":{},"containerInstanceArn":{},"overrides":{"shape":"S35"},"lastStatus":{},"desiredStatus":{},"cpu":{},"memory":{},"containers":{"type":"list","member":{"type":"structure","members":{"containerArn":{},"taskArn":{},"name":{},"lastStatus":{},"exitCode":{"type":"integer"},"reason":{},"networkBindings":{"shape":"S3a"},"networkInterfaces":{"type":"list","member":{"type":"structure","members":{"attachmentId":{},"privateIpv4Address":{},"ipv6Address":{}}}},"healthStatus":{}}}},"startedBy":{},"version":{"type":"long"},"stoppedReason":{},"connectivity":{},"connectivityAt":{"type":"timestamp"},"pullStartedAt":{"type":"timestamp"},"pullStoppedAt":{"type":"timestamp"},"executionStoppedAt":{"type":"timestamp"},"createdAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"stoppingAt":{"type":"timestamp"},"stoppedAt":{"type":"timestamp"},"group":{},"launchType":{},"platformVersion":{},"attachments":{"shape":"S1f"},"healthStatus":{}}},"S35":{"type":"structure","members":{"containerOverrides":{"type":"list","member":{"type":"structure","members":{"name":{},"command":{"shape":"Sm"},"environment":{"shape":"S1q"},"cpu":{"type":"integer"},"memory":{"type":"integer"},"memoryReservation":{"type":"integer"}}}},"taskRoleArn":{},"executionRoleArn":{}}},"S3a":{"type":"list","member":{"type":"structure","members":{"bindIP":{},"containerPort":{"type":"integer"},"hostPort":{"type":"integer"},"protocol":{}}}}}}

/***/ }),
/* 2821 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListClusters":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"clusterArns"},"ListContainerInstances":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"containerInstanceArns"},"ListServices":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"serviceArns"},"ListTaskDefinitionFamilies":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"families"},"ListTaskDefinitions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"taskDefinitionArns"},"ListTasks":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"taskArns"}}}

/***/ }),
/* 2822 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"TasksRunning":{"delay":6,"operation":"DescribeTasks","maxAttempts":100,"acceptors":[{"expected":"STOPPED","matcher":"pathAny","state":"failure","argument":"tasks[].lastStatus"},{"expected":"MISSING","matcher":"pathAny","state":"failure","argument":"failures[].reason"},{"expected":"RUNNING","matcher":"pathAll","state":"success","argument":"tasks[].lastStatus"}]},"TasksStopped":{"delay":6,"operation":"DescribeTasks","maxAttempts":100,"acceptors":[{"expected":"STOPPED","matcher":"pathAll","state":"success","argument":"tasks[].lastStatus"}]},"ServicesStable":{"delay":15,"operation":"DescribeServices","maxAttempts":40,"acceptors":[{"expected":"MISSING","matcher":"pathAny","state":"failure","argument":"failures[].reason"},{"expected":"DRAINING","matcher":"pathAny","state":"failure","argument":"services[].status"},{"expected":"INACTIVE","matcher":"pathAny","state":"failure","argument":"services[].status"},{"expected":true,"matcher":"path","state":"success","argument":"length(services[?!(length(deployments) == `1` && runningCount == desiredCount)]) == `0`"}]},"ServicesInactive":{"delay":15,"operation":"DescribeServices","maxAttempts":40,"acceptors":[{"expected":"MISSING","matcher":"pathAny","state":"failure","argument":"failures[].reason"},{"expected":"INACTIVE","matcher":"pathAny","state":"success","argument":"services[].status"}]}}}

/***/ }),
/* 2823 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['efs'] = {};
AWS.EFS = Service.defineService('efs', ['2015-02-01']);
Object.defineProperty(apiLoader.services['efs'], '2015-02-01', {
  get: function get() {
    var model = __webpack_require__(2824);
    model.paginators = __webpack_require__(2825).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.EFS;


/***/ }),
/* 2824 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-02-01","endpointPrefix":"elasticfilesystem","protocol":"rest-json","serviceAbbreviation":"EFS","serviceFullName":"Amazon Elastic File System","signatureVersion":"v4","uid":"elasticfilesystem-2015-02-01"},"operations":{"CreateFileSystem":{"http":{"requestUri":"/2015-02-01/file-systems","responseCode":201},"input":{"type":"structure","required":["CreationToken"],"members":{"CreationToken":{},"PerformanceMode":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{}}},"output":{"shape":"S6"}},"CreateMountTarget":{"http":{"requestUri":"/2015-02-01/mount-targets","responseCode":200},"input":{"type":"structure","required":["FileSystemId","SubnetId"],"members":{"FileSystemId":{},"SubnetId":{},"IpAddress":{},"SecurityGroups":{"shape":"Si"}}},"output":{"shape":"Sk"}},"CreateTags":{"http":{"requestUri":"/2015-02-01/create-tags/{FileSystemId}","responseCode":204},"input":{"type":"structure","required":["FileSystemId","Tags"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"Tags":{"shape":"So"}}}},"DeleteFileSystem":{"http":{"method":"DELETE","requestUri":"/2015-02-01/file-systems/{FileSystemId}","responseCode":204},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}}},"DeleteMountTarget":{"http":{"method":"DELETE","requestUri":"/2015-02-01/mount-targets/{MountTargetId}","responseCode":204},"input":{"type":"structure","required":["MountTargetId"],"members":{"MountTargetId":{"location":"uri","locationName":"MountTargetId"}}}},"DeleteTags":{"http":{"requestUri":"/2015-02-01/delete-tags/{FileSystemId}","responseCode":204},"input":{"type":"structure","required":["FileSystemId","TagKeys"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"TagKeys":{"type":"list","member":{}}}}},"DescribeFileSystems":{"http":{"method":"GET","requestUri":"/2015-02-01/file-systems","responseCode":200},"input":{"type":"structure","members":{"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"Marker":{"location":"querystring","locationName":"Marker"},"CreationToken":{"location":"querystring","locationName":"CreationToken"},"FileSystemId":{"location":"querystring","locationName":"FileSystemId"}}},"output":{"type":"structure","members":{"Marker":{},"FileSystems":{"type":"list","member":{"shape":"S6"}},"NextMarker":{}}}},"DescribeMountTargetSecurityGroups":{"http":{"method":"GET","requestUri":"/2015-02-01/mount-targets/{MountTargetId}/security-groups","responseCode":200},"input":{"type":"structure","required":["MountTargetId"],"members":{"MountTargetId":{"location":"uri","locationName":"MountTargetId"}}},"output":{"type":"structure","required":["SecurityGroups"],"members":{"SecurityGroups":{"shape":"Si"}}}},"DescribeMountTargets":{"http":{"method":"GET","requestUri":"/2015-02-01/mount-targets","responseCode":200},"input":{"type":"structure","members":{"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"Marker":{"location":"querystring","locationName":"Marker"},"FileSystemId":{"location":"querystring","locationName":"FileSystemId"},"MountTargetId":{"location":"querystring","locationName":"MountTargetId"}}},"output":{"type":"structure","members":{"Marker":{},"MountTargets":{"type":"list","member":{"shape":"Sk"}},"NextMarker":{}}}},"DescribeTags":{"http":{"method":"GET","requestUri":"/2015-02-01/tags/{FileSystemId}/","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"Marker":{"location":"querystring","locationName":"Marker"},"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}},"output":{"type":"structure","required":["Tags"],"members":{"Marker":{},"Tags":{"shape":"So"},"NextMarker":{}}}},"ModifyMountTargetSecurityGroups":{"http":{"method":"PUT","requestUri":"/2015-02-01/mount-targets/{MountTargetId}/security-groups","responseCode":204},"input":{"type":"structure","required":["MountTargetId"],"members":{"MountTargetId":{"location":"uri","locationName":"MountTargetId"},"SecurityGroups":{"shape":"Si"}}}}},"shapes":{"S6":{"type":"structure","required":["OwnerId","CreationToken","FileSystemId","CreationTime","LifeCycleState","NumberOfMountTargets","SizeInBytes","PerformanceMode"],"members":{"OwnerId":{},"CreationToken":{},"FileSystemId":{},"CreationTime":{"type":"timestamp"},"LifeCycleState":{},"Name":{},"NumberOfMountTargets":{"type":"integer"},"SizeInBytes":{"type":"structure","required":["Value"],"members":{"Value":{"type":"long"},"Timestamp":{"type":"timestamp"}}},"PerformanceMode":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{}}},"Si":{"type":"list","member":{}},"Sk":{"type":"structure","required":["MountTargetId","FileSystemId","SubnetId","LifeCycleState"],"members":{"OwnerId":{},"MountTargetId":{},"FileSystemId":{},"SubnetId":{},"LifeCycleState":{},"IpAddress":{},"NetworkInterfaceId":{}}},"So":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 2825 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 2826 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['elasticache'] = {};
AWS.ElastiCache = Service.defineService('elasticache', ['2012-11-15*', '2014-03-24*', '2014-07-15*', '2014-09-30*', '2015-02-02']);
Object.defineProperty(apiLoader.services['elasticache'], '2015-02-02', {
  get: function get() {
    var model = __webpack_require__(2827);
    model.paginators = __webpack_require__(2828).pagination;
    model.waiters = __webpack_require__(2829).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ElastiCache;


/***/ }),
/* 2827 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-02-02","endpointPrefix":"elasticache","protocol":"query","serviceFullName":"Amazon ElastiCache","signatureVersion":"v4","uid":"elasticache-2015-02-02","xmlNamespace":"http://elasticache.amazonaws.com/doc/2015-02-02/"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S3"}}},"output":{"shape":"S5","resultWrapper":"AddTagsToResourceResult"}},"AuthorizeCacheSecurityGroupIngress":{"input":{"type":"structure","required":["CacheSecurityGroupName","EC2SecurityGroupName","EC2SecurityGroupOwnerId"],"members":{"CacheSecurityGroupName":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeCacheSecurityGroupIngressResult","type":"structure","members":{"CacheSecurityGroup":{"shape":"S8"}}}},"CopySnapshot":{"input":{"type":"structure","required":["SourceSnapshotName","TargetSnapshotName"],"members":{"SourceSnapshotName":{},"TargetSnapshotName":{},"TargetBucket":{}}},"output":{"resultWrapper":"CopySnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sd"}}}},"CreateCacheCluster":{"input":{"type":"structure","required":["CacheClusterId"],"members":{"CacheClusterId":{},"ReplicationGroupId":{},"AZMode":{},"PreferredAvailabilityZone":{},"PreferredAvailabilityZones":{"shape":"So"},"NumCacheNodes":{"type":"integer"},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"CacheParameterGroupName":{},"CacheSubnetGroupName":{},"CacheSecurityGroupNames":{"shape":"Sp"},"SecurityGroupIds":{"shape":"Sq"},"Tags":{"shape":"S3"},"SnapshotArns":{"shape":"Sr"},"SnapshotName":{},"PreferredMaintenanceWindow":{},"Port":{"type":"integer"},"NotificationTopicArn":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"AuthToken":{}}},"output":{"resultWrapper":"CreateCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"Su"}}}},"CreateCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName","CacheParameterGroupFamily","Description"],"members":{"CacheParameterGroupName":{},"CacheParameterGroupFamily":{},"Description":{}}},"output":{"resultWrapper":"CreateCacheParameterGroupResult","type":"structure","members":{"CacheParameterGroup":{"shape":"S19"}}}},"CreateCacheSecurityGroup":{"input":{"type":"structure","required":["CacheSecurityGroupName","Description"],"members":{"CacheSecurityGroupName":{},"Description":{}}},"output":{"resultWrapper":"CreateCacheSecurityGroupResult","type":"structure","members":{"CacheSecurityGroup":{"shape":"S8"}}}},"CreateCacheSubnetGroup":{"input":{"type":"structure","required":["CacheSubnetGroupName","CacheSubnetGroupDescription","SubnetIds"],"members":{"CacheSubnetGroupName":{},"CacheSubnetGroupDescription":{},"SubnetIds":{"shape":"S1d"}}},"output":{"resultWrapper":"CreateCacheSubnetGroupResult","type":"structure","members":{"CacheSubnetGroup":{"shape":"S1f"}}}},"CreateReplicationGroup":{"input":{"type":"structure","required":["ReplicationGroupId","ReplicationGroupDescription"],"members":{"ReplicationGroupId":{},"ReplicationGroupDescription":{},"PrimaryClusterId":{},"AutomaticFailoverEnabled":{"type":"boolean"},"NumCacheClusters":{"type":"integer"},"PreferredCacheClusterAZs":{"shape":"Sl"},"NumNodeGroups":{"type":"integer"},"ReplicasPerNodeGroup":{"type":"integer"},"NodeGroupConfiguration":{"type":"list","member":{"shape":"Sk","locationName":"NodeGroupConfiguration"}},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"CacheParameterGroupName":{},"CacheSubnetGroupName":{},"CacheSecurityGroupNames":{"shape":"Sp"},"SecurityGroupIds":{"shape":"Sq"},"Tags":{"shape":"S3"},"SnapshotArns":{"shape":"Sr"},"SnapshotName":{},"PreferredMaintenanceWindow":{},"Port":{"type":"integer"},"NotificationTopicArn":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"AuthToken":{},"TransitEncryptionEnabled":{"type":"boolean"},"AtRestEncryptionEnabled":{"type":"boolean"}}},"output":{"resultWrapper":"CreateReplicationGroupResult","type":"structure","members":{"ReplicationGroup":{"shape":"S1m"}}}},"CreateSnapshot":{"input":{"type":"structure","required":["SnapshotName"],"members":{"ReplicationGroupId":{},"CacheClusterId":{},"SnapshotName":{}}},"output":{"resultWrapper":"CreateSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sd"}}}},"DeleteCacheCluster":{"input":{"type":"structure","required":["CacheClusterId"],"members":{"CacheClusterId":{},"FinalSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"Su"}}}},"DeleteCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName"],"members":{"CacheParameterGroupName":{}}}},"DeleteCacheSecurityGroup":{"input":{"type":"structure","required":["CacheSecurityGroupName"],"members":{"CacheSecurityGroupName":{}}}},"DeleteCacheSubnetGroup":{"input":{"type":"structure","required":["CacheSubnetGroupName"],"members":{"CacheSubnetGroupName":{}}}},"DeleteReplicationGroup":{"input":{"type":"structure","required":["ReplicationGroupId"],"members":{"ReplicationGroupId":{},"RetainPrimaryCluster":{"type":"boolean"},"FinalSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteReplicationGroupResult","type":"structure","members":{"ReplicationGroup":{"shape":"S1m"}}}},"DeleteSnapshot":{"input":{"type":"structure","required":["SnapshotName"],"members":{"SnapshotName":{}}},"output":{"resultWrapper":"DeleteSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sd"}}}},"DescribeCacheClusters":{"input":{"type":"structure","members":{"CacheClusterId":{},"MaxRecords":{"type":"integer"},"Marker":{},"ShowCacheNodeInfo":{"type":"boolean"},"ShowCacheClustersNotInReplicationGroups":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeCacheClustersResult","type":"structure","members":{"Marker":{},"CacheClusters":{"type":"list","member":{"shape":"Su","locationName":"CacheCluster"}}}}},"DescribeCacheEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"CacheParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeCacheEngineVersionsResult","type":"structure","members":{"Marker":{},"CacheEngineVersions":{"type":"list","member":{"locationName":"CacheEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"CacheParameterGroupFamily":{},"CacheEngineDescription":{},"CacheEngineVersionDescription":{}}}}}}},"DescribeCacheParameterGroups":{"input":{"type":"structure","members":{"CacheParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheParameterGroupsResult","type":"structure","members":{"Marker":{},"CacheParameterGroups":{"type":"list","member":{"shape":"S19","locationName":"CacheParameterGroup"}}}}},"DescribeCacheParameters":{"input":{"type":"structure","required":["CacheParameterGroupName"],"members":{"CacheParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheParametersResult","type":"structure","members":{"Marker":{},"Parameters":{"shape":"S2k"},"CacheNodeTypeSpecificParameters":{"shape":"S2n"}}}},"DescribeCacheSecurityGroups":{"input":{"type":"structure","members":{"CacheSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheSecurityGroupsResult","type":"structure","members":{"Marker":{},"CacheSecurityGroups":{"type":"list","member":{"shape":"S8","locationName":"CacheSecurityGroup"}}}}},"DescribeCacheSubnetGroups":{"input":{"type":"structure","members":{"CacheSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheSubnetGroupsResult","type":"structure","members":{"Marker":{},"CacheSubnetGroups":{"type":"list","member":{"shape":"S1f","locationName":"CacheSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["CacheParameterGroupFamily"],"members":{"CacheParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"CacheParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2k"},"CacheNodeTypeSpecificParameters":{"shape":"S2n"}},"wrapper":true}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"Date":{"type":"timestamp"}}}}}}},"DescribeReplicationGroups":{"input":{"type":"structure","members":{"ReplicationGroupId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReplicationGroupsResult","type":"structure","members":{"Marker":{},"ReplicationGroups":{"type":"list","member":{"shape":"S1m","locationName":"ReplicationGroup"}}}}},"DescribeReservedCacheNodes":{"input":{"type":"structure","members":{"ReservedCacheNodeId":{},"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedCacheNodesResult","type":"structure","members":{"Marker":{},"ReservedCacheNodes":{"type":"list","member":{"shape":"S3b","locationName":"ReservedCacheNode"}}}}},"DescribeReservedCacheNodesOfferings":{"input":{"type":"structure","members":{"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedCacheNodesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedCacheNodesOfferings":{"type":"list","member":{"locationName":"ReservedCacheNodesOffering","type":"structure","members":{"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"ProductDescription":{},"OfferingType":{},"RecurringCharges":{"shape":"S3c"}},"wrapper":true}}}}},"DescribeSnapshots":{"input":{"type":"structure","members":{"ReplicationGroupId":{},"CacheClusterId":{},"SnapshotName":{},"SnapshotSource":{},"Marker":{},"MaxRecords":{"type":"integer"},"ShowNodeGroupConfig":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeSnapshotsResult","type":"structure","members":{"Marker":{},"Snapshots":{"type":"list","member":{"shape":"Sd","locationName":"Snapshot"}}}}},"ListAllowedNodeTypeModifications":{"input":{"type":"structure","members":{"CacheClusterId":{},"ReplicationGroupId":{}}},"output":{"resultWrapper":"ListAllowedNodeTypeModificationsResult","type":"structure","members":{"ScaleUpModifications":{"type":"list","member":{}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{}}},"output":{"shape":"S5","resultWrapper":"ListTagsForResourceResult"}},"ModifyCacheCluster":{"input":{"type":"structure","required":["CacheClusterId"],"members":{"CacheClusterId":{},"NumCacheNodes":{"type":"integer"},"CacheNodeIdsToRemove":{"shape":"Sy"},"AZMode":{},"NewAvailabilityZones":{"shape":"So"},"CacheSecurityGroupNames":{"shape":"Sp"},"SecurityGroupIds":{"shape":"Sq"},"PreferredMaintenanceWindow":{},"NotificationTopicArn":{},"CacheParameterGroupName":{},"NotificationTopicStatus":{},"ApplyImmediately":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"CacheNodeType":{}}},"output":{"resultWrapper":"ModifyCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"Su"}}}},"ModifyCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName","ParameterNameValues"],"members":{"CacheParameterGroupName":{},"ParameterNameValues":{"shape":"S3s"}}},"output":{"shape":"S3u","resultWrapper":"ModifyCacheParameterGroupResult"}},"ModifyCacheSubnetGroup":{"input":{"type":"structure","required":["CacheSubnetGroupName"],"members":{"CacheSubnetGroupName":{},"CacheSubnetGroupDescription":{},"SubnetIds":{"shape":"S1d"}}},"output":{"resultWrapper":"ModifyCacheSubnetGroupResult","type":"structure","members":{"CacheSubnetGroup":{"shape":"S1f"}}}},"ModifyReplicationGroup":{"input":{"type":"structure","required":["ReplicationGroupId"],"members":{"ReplicationGroupId":{},"ReplicationGroupDescription":{},"PrimaryClusterId":{},"SnapshottingClusterId":{},"AutomaticFailoverEnabled":{"type":"boolean"},"CacheSecurityGroupNames":{"shape":"Sp"},"SecurityGroupIds":{"shape":"Sq"},"PreferredMaintenanceWindow":{},"NotificationTopicArn":{},"CacheParameterGroupName":{},"NotificationTopicStatus":{},"ApplyImmediately":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"CacheNodeType":{},"NodeGroupId":{}}},"output":{"resultWrapper":"ModifyReplicationGroupResult","type":"structure","members":{"ReplicationGroup":{"shape":"S1m"}}}},"ModifyReplicationGroupShardConfiguration":{"input":{"type":"structure","required":["ReplicationGroupId","NodeGroupCount","ApplyImmediately"],"members":{"ReplicationGroupId":{},"NodeGroupCount":{"type":"integer"},"ApplyImmediately":{"type":"boolean"},"ReshardingConfiguration":{"type":"list","member":{"locationName":"ReshardingConfiguration","type":"structure","members":{"PreferredAvailabilityZones":{"shape":"Sl"}}}},"NodeGroupsToRemove":{"type":"list","member":{"locationName":"NodeGroupToRemove"}}}},"output":{"resultWrapper":"ModifyReplicationGroupShardConfigurationResult","type":"structure","members":{"ReplicationGroup":{"shape":"S1m"}}}},"PurchaseReservedCacheNodesOffering":{"input":{"type":"structure","required":["ReservedCacheNodesOfferingId"],"members":{"ReservedCacheNodesOfferingId":{},"ReservedCacheNodeId":{},"CacheNodeCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedCacheNodesOfferingResult","type":"structure","members":{"ReservedCacheNode":{"shape":"S3b"}}}},"RebootCacheCluster":{"input":{"type":"structure","required":["CacheClusterId","CacheNodeIdsToReboot"],"members":{"CacheClusterId":{},"CacheNodeIdsToReboot":{"shape":"Sy"}}},"output":{"resultWrapper":"RebootCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"Su"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}},"output":{"shape":"S5","resultWrapper":"RemoveTagsFromResourceResult"}},"ResetCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName"],"members":{"CacheParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"ParameterNameValues":{"shape":"S3s"}}},"output":{"shape":"S3u","resultWrapper":"ResetCacheParameterGroupResult"}},"RevokeCacheSecurityGroupIngress":{"input":{"type":"structure","required":["CacheSecurityGroupName","EC2SecurityGroupName","EC2SecurityGroupOwnerId"],"members":{"CacheSecurityGroupName":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeCacheSecurityGroupIngressResult","type":"structure","members":{"CacheSecurityGroup":{"shape":"S8"}}}},"TestFailover":{"input":{"type":"structure","required":["ReplicationGroupId","NodeGroupId"],"members":{"ReplicationGroupId":{},"NodeGroupId":{}}},"output":{"resultWrapper":"TestFailoverResult","type":"structure","members":{"ReplicationGroup":{"shape":"S1m"}}}}},"shapes":{"S3":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"S5":{"type":"structure","members":{"TagList":{"shape":"S3"}}},"S8":{"type":"structure","members":{"OwnerId":{},"CacheSecurityGroupName":{},"Description":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}}}},"wrapper":true},"Sd":{"type":"structure","members":{"SnapshotName":{},"ReplicationGroupId":{},"ReplicationGroupDescription":{},"CacheClusterId":{},"SnapshotStatus":{},"SnapshotSource":{},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"NumCacheNodes":{"type":"integer"},"PreferredAvailabilityZone":{},"CacheClusterCreateTime":{"type":"timestamp"},"PreferredMaintenanceWindow":{},"TopicArn":{},"Port":{"type":"integer"},"CacheParameterGroupName":{},"CacheSubnetGroupName":{},"VpcId":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"NumNodeGroups":{"type":"integer"},"AutomaticFailover":{},"NodeSnapshots":{"type":"list","member":{"locationName":"NodeSnapshot","type":"structure","members":{"CacheClusterId":{},"NodeGroupId":{},"CacheNodeId":{},"NodeGroupConfiguration":{"shape":"Sk"},"CacheSize":{},"CacheNodeCreateTime":{"type":"timestamp"},"SnapshotCreateTime":{"type":"timestamp"}},"wrapper":true}}},"wrapper":true},"Sk":{"type":"structure","members":{"Slots":{},"ReplicaCount":{"type":"integer"},"PrimaryAvailabilityZone":{},"ReplicaAvailabilityZones":{"shape":"Sl"}}},"Sl":{"type":"list","member":{"locationName":"AvailabilityZone"}},"So":{"type":"list","member":{"locationName":"PreferredAvailabilityZone"}},"Sp":{"type":"list","member":{"locationName":"CacheSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"SecurityGroupId"}},"Sr":{"type":"list","member":{"locationName":"SnapshotArn"}},"Su":{"type":"structure","members":{"CacheClusterId":{},"ConfigurationEndpoint":{"shape":"Sv"},"ClientDownloadLandingPage":{},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"CacheClusterStatus":{},"NumCacheNodes":{"type":"integer"},"PreferredAvailabilityZone":{},"CacheClusterCreateTime":{"type":"timestamp"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"NumCacheNodes":{"type":"integer"},"CacheNodeIdsToRemove":{"shape":"Sy"},"EngineVersion":{},"CacheNodeType":{}}},"NotificationConfiguration":{"type":"structure","members":{"TopicArn":{},"TopicStatus":{}}},"CacheSecurityGroups":{"type":"list","member":{"locationName":"CacheSecurityGroup","type":"structure","members":{"CacheSecurityGroupName":{},"Status":{}}}},"CacheParameterGroup":{"type":"structure","members":{"CacheParameterGroupName":{},"ParameterApplyStatus":{},"CacheNodeIdsToReboot":{"shape":"Sy"}}},"CacheSubnetGroupName":{},"CacheNodes":{"type":"list","member":{"locationName":"CacheNode","type":"structure","members":{"CacheNodeId":{},"CacheNodeStatus":{},"CacheNodeCreateTime":{"type":"timestamp"},"Endpoint":{"shape":"Sv"},"ParameterGroupStatus":{},"SourceCacheNodeId":{},"CustomerAvailabilityZone":{}}}},"AutoMinorVersionUpgrade":{"type":"boolean"},"SecurityGroups":{"type":"list","member":{"type":"structure","members":{"SecurityGroupId":{},"Status":{}}}},"ReplicationGroupId":{},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"AuthTokenEnabled":{"type":"boolean"},"TransitEncryptionEnabled":{"type":"boolean"},"AtRestEncryptionEnabled":{"type":"boolean"}},"wrapper":true},"Sv":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"Sy":{"type":"list","member":{"locationName":"CacheNodeId"}},"S19":{"type":"structure","members":{"CacheParameterGroupName":{},"CacheParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1d":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1f":{"type":"structure","members":{"CacheSubnetGroupName":{},"CacheSubnetGroupDescription":{},"VpcId":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"type":"structure","members":{"Name":{}},"wrapper":true}}}}},"wrapper":true},"S1m":{"type":"structure","members":{"ReplicationGroupId":{},"Description":{},"Status":{},"PendingModifiedValues":{"type":"structure","members":{"PrimaryClusterId":{},"AutomaticFailoverStatus":{},"Resharding":{"type":"structure","members":{"SlotMigration":{"type":"structure","members":{"ProgressPercentage":{"type":"double"}}}}}}},"MemberClusters":{"type":"list","member":{"locationName":"ClusterId"}},"NodeGroups":{"type":"list","member":{"locationName":"NodeGroup","type":"structure","members":{"NodeGroupId":{},"Status":{},"PrimaryEndpoint":{"shape":"Sv"},"Slots":{},"NodeGroupMembers":{"type":"list","member":{"locationName":"NodeGroupMember","type":"structure","members":{"CacheClusterId":{},"CacheNodeId":{},"ReadEndpoint":{"shape":"Sv"},"PreferredAvailabilityZone":{},"CurrentRole":{}}}}}}},"SnapshottingClusterId":{},"AutomaticFailover":{},"ConfigurationEndpoint":{"shape":"Sv"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"ClusterEnabled":{"type":"boolean"},"CacheNodeType":{},"AuthTokenEnabled":{"type":"boolean"},"TransitEncryptionEnabled":{"type":"boolean"},"AtRestEncryptionEnabled":{"type":"boolean"}},"wrapper":true},"S2k":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ChangeType":{}}}},"S2n":{"type":"list","member":{"locationName":"CacheNodeTypeSpecificParameter","type":"structure","members":{"ParameterName":{},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"CacheNodeTypeSpecificValues":{"type":"list","member":{"locationName":"CacheNodeTypeSpecificValue","type":"structure","members":{"CacheNodeType":{},"Value":{}}}},"ChangeType":{}}}},"S3b":{"type":"structure","members":{"ReservedCacheNodeId":{},"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CacheNodeCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"State":{},"RecurringCharges":{"shape":"S3c"}},"wrapper":true},"S3c":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S3s":{"type":"list","member":{"locationName":"ParameterNameValue","type":"structure","members":{"ParameterName":{},"ParameterValue":{}}}},"S3u":{"type":"structure","members":{"CacheParameterGroupName":{}}}}}

/***/ }),
/* 2828 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeCacheClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheClusters"},"DescribeCacheEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheEngineVersions"},"DescribeCacheParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheParameterGroups"},"DescribeCacheParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeCacheSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheSecurityGroups"},"DescribeCacheSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeReplicationGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReplicationGroups"},"DescribeReservedCacheNodes":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedCacheNodes"},"DescribeReservedCacheNodesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedCacheNodesOfferings"},"DescribeSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Snapshots"}}}

/***/ }),
/* 2829 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"CacheClusterAvailable":{"acceptors":[{"argument":"CacheClusters[].CacheClusterStatus","expected":"available","matcher":"pathAll","state":"success"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"deleted","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"deleting","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"incompatible-network","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"restore-failed","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until ElastiCache cluster is available.","maxAttempts":40,"operation":"DescribeCacheClusters"},"CacheClusterDeleted":{"acceptors":[{"argument":"CacheClusters[].CacheClusterStatus","expected":"deleted","matcher":"pathAll","state":"success"},{"expected":"CacheClusterNotFound","matcher":"error","state":"success"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"available","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"creating","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"incompatible-network","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"modifying","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"restore-failed","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"snapshotting","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until ElastiCache cluster is deleted.","maxAttempts":40,"operation":"DescribeCacheClusters"},"ReplicationGroupAvailable":{"acceptors":[{"argument":"ReplicationGroups[].Status","expected":"available","matcher":"pathAll","state":"success"},{"argument":"ReplicationGroups[].Status","expected":"deleted","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until ElastiCache replication group is available.","maxAttempts":40,"operation":"DescribeReplicationGroups"},"ReplicationGroupDeleted":{"acceptors":[{"argument":"ReplicationGroups[].Status","expected":"deleted","matcher":"pathAll","state":"success"},{"argument":"ReplicationGroups[].Status","expected":"available","matcher":"pathAny","state":"failure"},{"expected":"ReplicationGroupNotFoundFault","matcher":"error","state":"success"}],"delay":15,"description":"Wait until ElastiCache replication group is deleted.","maxAttempts":40,"operation":"DescribeReplicationGroups"}}}

/***/ }),
/* 2830 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['elasticbeanstalk'] = {};
AWS.ElasticBeanstalk = Service.defineService('elasticbeanstalk', ['2010-12-01']);
Object.defineProperty(apiLoader.services['elasticbeanstalk'], '2010-12-01', {
  get: function get() {
    var model = __webpack_require__(2831);
    model.paginators = __webpack_require__(2832).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ElasticBeanstalk;


/***/ }),
/* 2831 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-12-01","endpointPrefix":"elasticbeanstalk","protocol":"query","serviceAbbreviation":"Elastic Beanstalk","serviceFullName":"AWS Elastic Beanstalk","signatureVersion":"v4","uid":"elasticbeanstalk-2010-12-01","xmlNamespace":"http://elasticbeanstalk.amazonaws.com/docs/2010-12-01/"},"operations":{"AbortEnvironmentUpdate":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}}},"ApplyEnvironmentManagedAction":{"input":{"type":"structure","required":["ActionId"],"members":{"EnvironmentName":{},"EnvironmentId":{},"ActionId":{}}},"output":{"resultWrapper":"ApplyEnvironmentManagedActionResult","type":"structure","members":{"ActionId":{},"ActionDescription":{},"ActionType":{},"Status":{}}}},"CheckDNSAvailability":{"input":{"type":"structure","required":["CNAMEPrefix"],"members":{"CNAMEPrefix":{}}},"output":{"resultWrapper":"CheckDNSAvailabilityResult","type":"structure","members":{"Available":{"type":"boolean"},"FullyQualifiedCNAME":{}}}},"ComposeEnvironments":{"input":{"type":"structure","members":{"ApplicationName":{},"GroupName":{},"VersionLabels":{"type":"list","member":{}}}},"output":{"shape":"Si","resultWrapper":"ComposeEnvironmentsResult"}},"CreateApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"Description":{},"ResourceLifecycleConfig":{"shape":"S17"}}},"output":{"shape":"S1d","resultWrapper":"CreateApplicationResult"}},"CreateApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","VersionLabel"],"members":{"ApplicationName":{},"VersionLabel":{},"Description":{},"SourceBuildInformation":{"shape":"S1i"},"SourceBundle":{"shape":"S1m"},"BuildConfiguration":{"type":"structure","required":["CodeBuildServiceRole","Image"],"members":{"ArtifactName":{},"CodeBuildServiceRole":{},"ComputeType":{},"Image":{},"TimeoutInMinutes":{"type":"integer"}}},"AutoCreateApplication":{"type":"boolean"},"Process":{"type":"boolean"}}},"output":{"shape":"S1u","resultWrapper":"CreateApplicationVersionResult"}},"CreateConfigurationTemplate":{"input":{"type":"structure","required":["ApplicationName","TemplateName"],"members":{"ApplicationName":{},"TemplateName":{},"SolutionStackName":{},"PlatformArn":{},"SourceConfiguration":{"type":"structure","members":{"ApplicationName":{},"TemplateName":{}}},"EnvironmentId":{},"Description":{},"OptionSettings":{"shape":"S1z"}}},"output":{"shape":"S25","resultWrapper":"CreateConfigurationTemplateResult"}},"CreateEnvironment":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"EnvironmentName":{},"GroupName":{},"Description":{},"CNAMEPrefix":{},"Tier":{"shape":"S11"},"Tags":{"type":"list","member":{"shape":"S29"}},"VersionLabel":{},"TemplateName":{},"SolutionStackName":{},"PlatformArn":{},"OptionSettings":{"shape":"S1z"},"OptionsToRemove":{"shape":"S2c"}}},"output":{"shape":"Sk","resultWrapper":"CreateEnvironmentResult"}},"CreatePlatformVersion":{"input":{"type":"structure","required":["PlatformName","PlatformVersion","PlatformDefinitionBundle"],"members":{"PlatformName":{},"PlatformVersion":{},"PlatformDefinitionBundle":{"shape":"S1m"},"EnvironmentName":{},"OptionSettings":{"shape":"S1z"}}},"output":{"resultWrapper":"CreatePlatformVersionResult","type":"structure","members":{"PlatformSummary":{"shape":"S2i"},"Builder":{"type":"structure","members":{"ARN":{}}}}}},"CreateStorageLocation":{"output":{"resultWrapper":"CreateStorageLocationResult","type":"structure","members":{"S3Bucket":{}}}},"DeleteApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"TerminateEnvByForce":{"type":"boolean"}}}},"DeleteApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","VersionLabel"],"members":{"ApplicationName":{},"VersionLabel":{},"DeleteSourceBundle":{"type":"boolean"}}}},"DeleteConfigurationTemplate":{"input":{"type":"structure","required":["ApplicationName","TemplateName"],"members":{"ApplicationName":{},"TemplateName":{}}}},"DeleteEnvironmentConfiguration":{"input":{"type":"structure","required":["ApplicationName","EnvironmentName"],"members":{"ApplicationName":{},"EnvironmentName":{}}}},"DeletePlatformVersion":{"input":{"type":"structure","members":{"PlatformArn":{}}},"output":{"resultWrapper":"DeletePlatformVersionResult","type":"structure","members":{"PlatformSummary":{"shape":"S2i"}}}},"DescribeApplicationVersions":{"input":{"type":"structure","members":{"ApplicationName":{},"VersionLabels":{"shape":"S1f"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeApplicationVersionsResult","type":"structure","members":{"ApplicationVersions":{"type":"list","member":{"shape":"S1v"}},"NextToken":{}}}},"DescribeApplications":{"input":{"type":"structure","members":{"ApplicationNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeApplicationsResult","type":"structure","members":{"Applications":{"type":"list","member":{"shape":"S1e"}}}}},"DescribeConfigurationOptions":{"input":{"type":"structure","members":{"ApplicationName":{},"TemplateName":{},"EnvironmentName":{},"SolutionStackName":{},"PlatformArn":{},"Options":{"shape":"S2c"}}},"output":{"resultWrapper":"DescribeConfigurationOptionsResult","type":"structure","members":{"SolutionStackName":{},"PlatformArn":{},"Options":{"type":"list","member":{"type":"structure","members":{"Namespace":{},"Name":{},"DefaultValue":{},"ChangeSeverity":{},"UserDefined":{"type":"boolean"},"ValueType":{},"ValueOptions":{"type":"list","member":{}},"MinValue":{"type":"integer"},"MaxValue":{"type":"integer"},"MaxLength":{"type":"integer"},"Regex":{"type":"structure","members":{"Pattern":{},"Label":{}}}}}}}}},"DescribeConfigurationSettings":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"TemplateName":{},"EnvironmentName":{}}},"output":{"resultWrapper":"DescribeConfigurationSettingsResult","type":"structure","members":{"ConfigurationSettings":{"type":"list","member":{"shape":"S25"}}}}},"DescribeEnvironmentHealth":{"input":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"AttributeNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeEnvironmentHealthResult","type":"structure","members":{"EnvironmentName":{},"HealthStatus":{},"Status":{},"Color":{},"Causes":{"shape":"S3y"},"ApplicationMetrics":{"shape":"S40"},"InstancesHealth":{"type":"structure","members":{"NoData":{"type":"integer"},"Unknown":{"type":"integer"},"Pending":{"type":"integer"},"Ok":{"type":"integer"},"Info":{"type":"integer"},"Warning":{"type":"integer"},"Degraded":{"type":"integer"},"Severe":{"type":"integer"}}},"RefreshedAt":{"type":"timestamp"}}}},"DescribeEnvironmentManagedActionHistory":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{},"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"DescribeEnvironmentManagedActionHistoryResult","type":"structure","members":{"ManagedActionHistoryItems":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"ActionType":{},"ActionDescription":{},"FailureType":{},"Status":{},"FailureDescription":{},"ExecutedTime":{"type":"timestamp"},"FinishedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeEnvironmentManagedActions":{"input":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"Status":{}}},"output":{"resultWrapper":"DescribeEnvironmentManagedActionsResult","type":"structure","members":{"ManagedActions":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"ActionDescription":{},"ActionType":{},"Status":{},"WindowStartTime":{"type":"timestamp"}}}}}}},"DescribeEnvironmentResources":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}},"output":{"resultWrapper":"DescribeEnvironmentResourcesResult","type":"structure","members":{"EnvironmentResources":{"type":"structure","members":{"EnvironmentName":{},"AutoScalingGroups":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Instances":{"type":"list","member":{"type":"structure","members":{"Id":{}}}},"LaunchConfigurations":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"LoadBalancers":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Triggers":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Queues":{"type":"list","member":{"type":"structure","members":{"Name":{},"URL":{}}}}}}}}},"DescribeEnvironments":{"input":{"type":"structure","members":{"ApplicationName":{},"VersionLabel":{},"EnvironmentIds":{"type":"list","member":{}},"EnvironmentNames":{"type":"list","member":{}},"IncludeDeleted":{"type":"boolean"},"IncludedDeletedBackTo":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"shape":"Si","resultWrapper":"DescribeEnvironmentsResult"}},"DescribeEvents":{"input":{"type":"structure","members":{"ApplicationName":{},"VersionLabel":{},"TemplateName":{},"EnvironmentId":{},"EnvironmentName":{},"PlatformArn":{},"RequestId":{},"Severity":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Events":{"type":"list","member":{"type":"structure","members":{"EventDate":{"type":"timestamp"},"Message":{},"ApplicationName":{},"VersionLabel":{},"TemplateName":{},"EnvironmentName":{},"PlatformArn":{},"RequestId":{},"Severity":{}}}},"NextToken":{}}}},"DescribeInstancesHealth":{"input":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"AttributeNames":{"type":"list","member":{}},"NextToken":{}}},"output":{"resultWrapper":"DescribeInstancesHealthResult","type":"structure","members":{"InstanceHealthList":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"HealthStatus":{},"Color":{},"Causes":{"shape":"S3y"},"LaunchedAt":{"type":"timestamp"},"ApplicationMetrics":{"shape":"S40"},"System":{"type":"structure","members":{"CPUUtilization":{"type":"structure","members":{"User":{"type":"double"},"Nice":{"type":"double"},"System":{"type":"double"},"Idle":{"type":"double"},"IOWait":{"type":"double"},"IRQ":{"type":"double"},"SoftIRQ":{"type":"double"}}},"LoadAverage":{"type":"list","member":{"type":"double"}}}},"Deployment":{"type":"structure","members":{"VersionLabel":{},"DeploymentId":{"type":"long"},"Status":{},"DeploymentTime":{"type":"timestamp"}}},"AvailabilityZone":{},"InstanceType":{}}}},"RefreshedAt":{"type":"timestamp"},"NextToken":{}}}},"DescribePlatformVersion":{"input":{"type":"structure","members":{"PlatformArn":{}}},"output":{"resultWrapper":"DescribePlatformVersionResult","type":"structure","members":{"PlatformDescription":{"type":"structure","members":{"PlatformArn":{},"PlatformOwner":{},"PlatformName":{},"PlatformVersion":{},"SolutionStackName":{},"PlatformStatus":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"PlatformCategory":{},"Description":{},"Maintainer":{},"OperatingSystemName":{},"OperatingSystemVersion":{},"ProgrammingLanguages":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"Frameworks":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"CustomAmiList":{"type":"list","member":{"type":"structure","members":{"VirtualizationType":{},"ImageId":{}}}},"SupportedTierList":{"shape":"S2o"},"SupportedAddonList":{"shape":"S2q"}}}}}},"ListAvailableSolutionStacks":{"output":{"resultWrapper":"ListAvailableSolutionStacksResult","type":"structure","members":{"SolutionStacks":{"type":"list","member":{}},"SolutionStackDetails":{"type":"list","member":{"type":"structure","members":{"SolutionStackName":{},"PermittedFileTypes":{"type":"list","member":{}}}}}}}},"ListPlatformVersions":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"Type":{},"Operator":{},"Values":{"type":"list","member":{}}}}},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"ListPlatformVersionsResult","type":"structure","members":{"PlatformSummaryList":{"type":"list","member":{"shape":"S2i"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"ResourceArn":{},"ResourceTags":{"shape":"S6q"}}}},"RebuildEnvironment":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}}},"RequestEnvironmentInfo":{"input":{"type":"structure","required":["InfoType"],"members":{"EnvironmentId":{},"EnvironmentName":{},"InfoType":{}}}},"RestartAppServer":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}}},"RetrieveEnvironmentInfo":{"input":{"type":"structure","required":["InfoType"],"members":{"EnvironmentId":{},"EnvironmentName":{},"InfoType":{}}},"output":{"resultWrapper":"RetrieveEnvironmentInfoResult","type":"structure","members":{"EnvironmentInfo":{"type":"list","member":{"type":"structure","members":{"InfoType":{},"Ec2InstanceId":{},"SampleTimestamp":{"type":"timestamp"},"Message":{}}}}}}},"SwapEnvironmentCNAMEs":{"input":{"type":"structure","members":{"SourceEnvironmentId":{},"SourceEnvironmentName":{},"DestinationEnvironmentId":{},"DestinationEnvironmentName":{}}}},"TerminateEnvironment":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{},"TerminateResources":{"type":"boolean"},"ForceTerminate":{"type":"boolean"}}},"output":{"shape":"Sk","resultWrapper":"TerminateEnvironmentResult"}},"UpdateApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"Description":{}}},"output":{"shape":"S1d","resultWrapper":"UpdateApplicationResult"}},"UpdateApplicationResourceLifecycle":{"input":{"type":"structure","required":["ApplicationName","ResourceLifecycleConfig"],"members":{"ApplicationName":{},"ResourceLifecycleConfig":{"shape":"S17"}}},"output":{"resultWrapper":"UpdateApplicationResourceLifecycleResult","type":"structure","members":{"ApplicationName":{},"ResourceLifecycleConfig":{"shape":"S17"}}}},"UpdateApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","VersionLabel"],"members":{"ApplicationName":{},"VersionLabel":{},"Description":{}}},"output":{"shape":"S1u","resultWrapper":"UpdateApplicationVersionResult"}},"UpdateConfigurationTemplate":{"input":{"type":"structure","required":["ApplicationName","TemplateName"],"members":{"ApplicationName":{},"TemplateName":{},"Description":{},"OptionSettings":{"shape":"S1z"},"OptionsToRemove":{"shape":"S2c"}}},"output":{"shape":"S25","resultWrapper":"UpdateConfigurationTemplateResult"}},"UpdateEnvironment":{"input":{"type":"structure","members":{"ApplicationName":{},"EnvironmentId":{},"EnvironmentName":{},"GroupName":{},"Description":{},"Tier":{"shape":"S11"},"VersionLabel":{},"TemplateName":{},"SolutionStackName":{},"PlatformArn":{},"OptionSettings":{"shape":"S1z"},"OptionsToRemove":{"shape":"S2c"}}},"output":{"shape":"Sk","resultWrapper":"UpdateEnvironmentResult"}},"UpdateTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"TagsToAdd":{"shape":"S6q"},"TagsToRemove":{"type":"list","member":{}}}}},"ValidateConfigurationSettings":{"input":{"type":"structure","required":["ApplicationName","OptionSettings"],"members":{"ApplicationName":{},"TemplateName":{},"EnvironmentName":{},"OptionSettings":{"shape":"S1z"}}},"output":{"resultWrapper":"ValidateConfigurationSettingsResult","type":"structure","members":{"Messages":{"type":"list","member":{"type":"structure","members":{"Message":{},"Severity":{},"Namespace":{},"OptionName":{}}}}}}}},"shapes":{"Si":{"type":"structure","members":{"Environments":{"type":"list","member":{"shape":"Sk"}},"NextToken":{}}},"Sk":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"ApplicationName":{},"VersionLabel":{},"SolutionStackName":{},"PlatformArn":{},"TemplateName":{},"Description":{},"EndpointURL":{},"CNAME":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"Status":{},"AbortableOperationInProgress":{"type":"boolean"},"Health":{},"HealthStatus":{},"Resources":{"type":"structure","members":{"LoadBalancer":{"type":"structure","members":{"LoadBalancerName":{},"Domain":{},"Listeners":{"type":"list","member":{"type":"structure","members":{"Protocol":{},"Port":{"type":"integer"}}}}}}}},"Tier":{"shape":"S11"},"EnvironmentLinks":{"type":"list","member":{"type":"structure","members":{"LinkName":{},"EnvironmentName":{}}}},"EnvironmentArn":{}}},"S11":{"type":"structure","members":{"Name":{},"Type":{},"Version":{}}},"S17":{"type":"structure","members":{"ServiceRole":{},"VersionLifecycleConfig":{"type":"structure","members":{"MaxCountRule":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"MaxCount":{"type":"integer"},"DeleteSourceFromS3":{"type":"boolean"}}},"MaxAgeRule":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"MaxAgeInDays":{"type":"integer"},"DeleteSourceFromS3":{"type":"boolean"}}}}}}},"S1d":{"type":"structure","members":{"Application":{"shape":"S1e"}}},"S1e":{"type":"structure","members":{"ApplicationName":{},"Description":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"Versions":{"shape":"S1f"},"ConfigurationTemplates":{"type":"list","member":{}},"ResourceLifecycleConfig":{"shape":"S17"}}},"S1f":{"type":"list","member":{}},"S1i":{"type":"structure","required":["SourceType","SourceRepository","SourceLocation"],"members":{"SourceType":{},"SourceRepository":{},"SourceLocation":{}}},"S1m":{"type":"structure","members":{"S3Bucket":{},"S3Key":{}}},"S1u":{"type":"structure","members":{"ApplicationVersion":{"shape":"S1v"}}},"S1v":{"type":"structure","members":{"ApplicationName":{},"Description":{},"VersionLabel":{},"SourceBuildInformation":{"shape":"S1i"},"BuildArn":{},"SourceBundle":{"shape":"S1m"},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"Status":{}}},"S1z":{"type":"list","member":{"type":"structure","members":{"ResourceName":{},"Namespace":{},"OptionName":{},"Value":{}}}},"S25":{"type":"structure","members":{"SolutionStackName":{},"PlatformArn":{},"ApplicationName":{},"TemplateName":{},"Description":{},"EnvironmentName":{},"DeploymentStatus":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"OptionSettings":{"shape":"S1z"}}},"S29":{"type":"structure","members":{"Key":{},"Value":{}}},"S2c":{"type":"list","member":{"type":"structure","members":{"ResourceName":{},"Namespace":{},"OptionName":{}}}},"S2i":{"type":"structure","members":{"PlatformArn":{},"PlatformOwner":{},"PlatformStatus":{},"PlatformCategory":{},"OperatingSystemName":{},"OperatingSystemVersion":{},"SupportedTierList":{"shape":"S2o"},"SupportedAddonList":{"shape":"S2q"}}},"S2o":{"type":"list","member":{}},"S2q":{"type":"list","member":{}},"S3y":{"type":"list","member":{}},"S40":{"type":"structure","members":{"Duration":{"type":"integer"},"RequestCount":{"type":"integer"},"StatusCodes":{"type":"structure","members":{"Status2xx":{"type":"integer"},"Status3xx":{"type":"integer"},"Status4xx":{"type":"integer"},"Status5xx":{"type":"integer"}}},"Latency":{"type":"structure","members":{"P999":{"type":"double"},"P99":{"type":"double"},"P95":{"type":"double"},"P90":{"type":"double"},"P85":{"type":"double"},"P75":{"type":"double"},"P50":{"type":"double"},"P10":{"type":"double"}}}}},"S6q":{"type":"list","member":{"shape":"S29"}}}}

/***/ }),
/* 2832 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeApplicationVersions":{"result_key":"ApplicationVersions"},"DescribeApplications":{"result_key":"Applications"},"DescribeConfigurationOptions":{"result_key":"Options"},"DescribeEnvironments":{"result_key":"Environments"},"DescribeEvents":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Events"},"ListAvailableSolutionStacks":{"result_key":"SolutionStacks"}}}

/***/ }),
/* 2833 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['elb'] = {};
AWS.ELB = Service.defineService('elb', ['2012-06-01']);
Object.defineProperty(apiLoader.services['elb'], '2012-06-01', {
  get: function get() {
    var model = __webpack_require__(2834);
    model.paginators = __webpack_require__(2835).pagination;
    model.waiters = __webpack_require__(2836).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ELB;


/***/ }),
/* 2834 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-06-01","endpointPrefix":"elasticloadbalancing","protocol":"query","serviceFullName":"Elastic Load Balancing","signatureVersion":"v4","uid":"elasticloadbalancing-2012-06-01","xmlNamespace":"http://elasticloadbalancing.amazonaws.com/doc/2012-06-01/"},"operations":{"AddTags":{"input":{"type":"structure","required":["LoadBalancerNames","Tags"],"members":{"LoadBalancerNames":{"shape":"S2"},"Tags":{"shape":"S4"}}},"output":{"resultWrapper":"AddTagsResult","type":"structure","members":{}}},"ApplySecurityGroupsToLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","SecurityGroups"],"members":{"LoadBalancerName":{},"SecurityGroups":{"shape":"Sa"}}},"output":{"resultWrapper":"ApplySecurityGroupsToLoadBalancerResult","type":"structure","members":{"SecurityGroups":{"shape":"Sa"}}}},"AttachLoadBalancerToSubnets":{"input":{"type":"structure","required":["LoadBalancerName","Subnets"],"members":{"LoadBalancerName":{},"Subnets":{"shape":"Se"}}},"output":{"resultWrapper":"AttachLoadBalancerToSubnetsResult","type":"structure","members":{"Subnets":{"shape":"Se"}}}},"ConfigureHealthCheck":{"input":{"type":"structure","required":["LoadBalancerName","HealthCheck"],"members":{"LoadBalancerName":{},"HealthCheck":{"shape":"Si"}}},"output":{"resultWrapper":"ConfigureHealthCheckResult","type":"structure","members":{"HealthCheck":{"shape":"Si"}}}},"CreateAppCookieStickinessPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName","CookieName"],"members":{"LoadBalancerName":{},"PolicyName":{},"CookieName":{}}},"output":{"resultWrapper":"CreateAppCookieStickinessPolicyResult","type":"structure","members":{}}},"CreateLBCookieStickinessPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName"],"members":{"LoadBalancerName":{},"PolicyName":{},"CookieExpirationPeriod":{"type":"long"}}},"output":{"resultWrapper":"CreateLBCookieStickinessPolicyResult","type":"structure","members":{}}},"CreateLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","Listeners"],"members":{"LoadBalancerName":{},"Listeners":{"shape":"Sx"},"AvailabilityZones":{"shape":"S13"},"Subnets":{"shape":"Se"},"SecurityGroups":{"shape":"Sa"},"Scheme":{},"Tags":{"shape":"S4"}}},"output":{"resultWrapper":"CreateLoadBalancerResult","type":"structure","members":{"DNSName":{}}}},"CreateLoadBalancerListeners":{"input":{"type":"structure","required":["LoadBalancerName","Listeners"],"members":{"LoadBalancerName":{},"Listeners":{"shape":"Sx"}}},"output":{"resultWrapper":"CreateLoadBalancerListenersResult","type":"structure","members":{}}},"CreateLoadBalancerPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName","PolicyTypeName"],"members":{"LoadBalancerName":{},"PolicyName":{},"PolicyTypeName":{},"PolicyAttributes":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeValue":{}}}}}},"output":{"resultWrapper":"CreateLoadBalancerPolicyResult","type":"structure","members":{}}},"DeleteLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName"],"members":{"LoadBalancerName":{}}},"output":{"resultWrapper":"DeleteLoadBalancerResult","type":"structure","members":{}}},"DeleteLoadBalancerListeners":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerPorts"],"members":{"LoadBalancerName":{},"LoadBalancerPorts":{"type":"list","member":{"type":"integer"}}}},"output":{"resultWrapper":"DeleteLoadBalancerListenersResult","type":"structure","members":{}}},"DeleteLoadBalancerPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName"],"members":{"LoadBalancerName":{},"PolicyName":{}}},"output":{"resultWrapper":"DeleteLoadBalancerPolicyResult","type":"structure","members":{}}},"DeregisterInstancesFromLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","Instances"],"members":{"LoadBalancerName":{},"Instances":{"shape":"S1p"}}},"output":{"resultWrapper":"DeregisterInstancesFromLoadBalancerResult","type":"structure","members":{"Instances":{"shape":"S1p"}}}},"DescribeAccountLimits":{"input":{"type":"structure","members":{"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"Limits":{"type":"list","member":{"type":"structure","members":{"Name":{},"Max":{}}}},"NextMarker":{}}}},"DescribeInstanceHealth":{"input":{"type":"structure","required":["LoadBalancerName"],"members":{"LoadBalancerName":{},"Instances":{"shape":"S1p"}}},"output":{"resultWrapper":"DescribeInstanceHealthResult","type":"structure","members":{"InstanceStates":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"State":{},"ReasonCode":{},"Description":{}}}}}}},"DescribeLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerName"],"members":{"LoadBalancerName":{}}},"output":{"resultWrapper":"DescribeLoadBalancerAttributesResult","type":"structure","members":{"LoadBalancerAttributes":{"shape":"S2a"}}}},"DescribeLoadBalancerPolicies":{"input":{"type":"structure","members":{"LoadBalancerName":{},"PolicyNames":{"shape":"S2s"}}},"output":{"resultWrapper":"DescribeLoadBalancerPoliciesResult","type":"structure","members":{"PolicyDescriptions":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyTypeName":{},"PolicyAttributeDescriptions":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeValue":{}}}}}}}}}},"DescribeLoadBalancerPolicyTypes":{"input":{"type":"structure","members":{"PolicyTypeNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeLoadBalancerPolicyTypesResult","type":"structure","members":{"PolicyTypeDescriptions":{"type":"list","member":{"type":"structure","members":{"PolicyTypeName":{},"Description":{},"PolicyAttributeTypeDescriptions":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeType":{},"Description":{},"DefaultValue":{},"Cardinality":{}}}}}}}}}},"DescribeLoadBalancers":{"input":{"type":"structure","members":{"LoadBalancerNames":{"shape":"S2"},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancersResult","type":"structure","members":{"LoadBalancerDescriptions":{"type":"list","member":{"type":"structure","members":{"LoadBalancerName":{},"DNSName":{},"CanonicalHostedZoneName":{},"CanonicalHostedZoneNameID":{},"ListenerDescriptions":{"type":"list","member":{"type":"structure","members":{"Listener":{"shape":"Sy"},"PolicyNames":{"shape":"S2s"}}}},"Policies":{"type":"structure","members":{"AppCookieStickinessPolicies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"CookieName":{}}}},"LBCookieStickinessPolicies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"CookieExpirationPeriod":{"type":"long"}}}},"OtherPolicies":{"shape":"S2s"}}},"BackendServerDescriptions":{"type":"list","member":{"type":"structure","members":{"InstancePort":{"type":"integer"},"PolicyNames":{"shape":"S2s"}}}},"AvailabilityZones":{"shape":"S13"},"Subnets":{"shape":"Se"},"VPCId":{},"Instances":{"shape":"S1p"},"HealthCheck":{"shape":"Si"},"SourceSecurityGroup":{"type":"structure","members":{"OwnerAlias":{},"GroupName":{}}},"SecurityGroups":{"shape":"Sa"},"CreatedTime":{"type":"timestamp"},"Scheme":{}}}},"NextMarker":{}}}},"DescribeTags":{"input":{"type":"structure","required":["LoadBalancerNames"],"members":{"LoadBalancerNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"TagDescriptions":{"type":"list","member":{"type":"structure","members":{"LoadBalancerName":{},"Tags":{"shape":"S4"}}}}}}},"DetachLoadBalancerFromSubnets":{"input":{"type":"structure","required":["LoadBalancerName","Subnets"],"members":{"LoadBalancerName":{},"Subnets":{"shape":"Se"}}},"output":{"resultWrapper":"DetachLoadBalancerFromSubnetsResult","type":"structure","members":{"Subnets":{"shape":"Se"}}}},"DisableAvailabilityZonesForLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","AvailabilityZones"],"members":{"LoadBalancerName":{},"AvailabilityZones":{"shape":"S13"}}},"output":{"resultWrapper":"DisableAvailabilityZonesForLoadBalancerResult","type":"structure","members":{"AvailabilityZones":{"shape":"S13"}}}},"EnableAvailabilityZonesForLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","AvailabilityZones"],"members":{"LoadBalancerName":{},"AvailabilityZones":{"shape":"S13"}}},"output":{"resultWrapper":"EnableAvailabilityZonesForLoadBalancerResult","type":"structure","members":{"AvailabilityZones":{"shape":"S13"}}}},"ModifyLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerAttributes"],"members":{"LoadBalancerName":{},"LoadBalancerAttributes":{"shape":"S2a"}}},"output":{"resultWrapper":"ModifyLoadBalancerAttributesResult","type":"structure","members":{"LoadBalancerName":{},"LoadBalancerAttributes":{"shape":"S2a"}}}},"RegisterInstancesWithLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","Instances"],"members":{"LoadBalancerName":{},"Instances":{"shape":"S1p"}}},"output":{"resultWrapper":"RegisterInstancesWithLoadBalancerResult","type":"structure","members":{"Instances":{"shape":"S1p"}}}},"RemoveTags":{"input":{"type":"structure","required":["LoadBalancerNames","Tags"],"members":{"LoadBalancerNames":{"shape":"S2"},"Tags":{"type":"list","member":{"type":"structure","members":{"Key":{}}}}}},"output":{"resultWrapper":"RemoveTagsResult","type":"structure","members":{}}},"SetLoadBalancerListenerSSLCertificate":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerPort","SSLCertificateId"],"members":{"LoadBalancerName":{},"LoadBalancerPort":{"type":"integer"},"SSLCertificateId":{}}},"output":{"resultWrapper":"SetLoadBalancerListenerSSLCertificateResult","type":"structure","members":{}}},"SetLoadBalancerPoliciesForBackendServer":{"input":{"type":"structure","required":["LoadBalancerName","InstancePort","PolicyNames"],"members":{"LoadBalancerName":{},"InstancePort":{"type":"integer"},"PolicyNames":{"shape":"S2s"}}},"output":{"resultWrapper":"SetLoadBalancerPoliciesForBackendServerResult","type":"structure","members":{}}},"SetLoadBalancerPoliciesOfListener":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerPort","PolicyNames"],"members":{"LoadBalancerName":{},"LoadBalancerPort":{"type":"integer"},"PolicyNames":{"shape":"S2s"}}},"output":{"resultWrapper":"SetLoadBalancerPoliciesOfListenerResult","type":"structure","members":{}}}},"shapes":{"S2":{"type":"list","member":{}},"S4":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sa":{"type":"list","member":{}},"Se":{"type":"list","member":{}},"Si":{"type":"structure","required":["Target","Interval","Timeout","UnhealthyThreshold","HealthyThreshold"],"members":{"Target":{},"Interval":{"type":"integer"},"Timeout":{"type":"integer"},"UnhealthyThreshold":{"type":"integer"},"HealthyThreshold":{"type":"integer"}}},"Sx":{"type":"list","member":{"shape":"Sy"}},"Sy":{"type":"structure","required":["Protocol","LoadBalancerPort","InstancePort"],"members":{"Protocol":{},"LoadBalancerPort":{"type":"integer"},"InstanceProtocol":{},"InstancePort":{"type":"integer"},"SSLCertificateId":{}}},"S13":{"type":"list","member":{}},"S1p":{"type":"list","member":{"type":"structure","members":{"InstanceId":{}}}},"S2a":{"type":"structure","members":{"CrossZoneLoadBalancing":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"}}},"AccessLog":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"S3BucketName":{},"EmitInterval":{"type":"integer"},"S3BucketPrefix":{}}},"ConnectionDraining":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"Timeout":{"type":"integer"}}},"ConnectionSettings":{"type":"structure","required":["IdleTimeout"],"members":{"IdleTimeout":{"type":"integer"}}},"AdditionalAttributes":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}},"S2s":{"type":"list","member":{}}}}

/***/ }),
/* 2835 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeInstanceHealth":{"result_key":"InstanceStates"},"DescribeLoadBalancerPolicies":{"result_key":"PolicyDescriptions"},"DescribeLoadBalancerPolicyTypes":{"result_key":"PolicyTypeDescriptions"},"DescribeLoadBalancers":{"input_token":"Marker","output_token":"NextMarker","result_key":"LoadBalancerDescriptions"}}}

/***/ }),
/* 2836 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"InstanceDeregistered":{"delay":15,"operation":"DescribeInstanceHealth","maxAttempts":40,"acceptors":[{"expected":"OutOfService","matcher":"pathAll","state":"success","argument":"InstanceStates[].State"},{"matcher":"error","expected":"InvalidInstance","state":"success"}]},"AnyInstanceInService":{"acceptors":[{"argument":"InstanceStates[].State","expected":"InService","matcher":"pathAny","state":"success"}],"delay":15,"maxAttempts":40,"operation":"DescribeInstanceHealth"},"InstanceInService":{"acceptors":[{"argument":"InstanceStates[].State","expected":"InService","matcher":"pathAll","state":"success"},{"matcher":"error","expected":"InvalidInstance","state":"retry"}],"delay":15,"maxAttempts":40,"operation":"DescribeInstanceHealth"}}}

/***/ }),
/* 2837 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['elbv2'] = {};
AWS.ELBv2 = Service.defineService('elbv2', ['2015-12-01']);
Object.defineProperty(apiLoader.services['elbv2'], '2015-12-01', {
  get: function get() {
    var model = __webpack_require__(2838);
    model.paginators = __webpack_require__(2839).pagination;
    model.waiters = __webpack_require__(2840).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ELBv2;


/***/ }),
/* 2838 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-12-01","endpointPrefix":"elasticloadbalancing","protocol":"query","serviceAbbreviation":"Elastic Load Balancing v2","serviceFullName":"Elastic Load Balancing","serviceId":"Elastic Load Balancing v2","signatureVersion":"v4","uid":"elasticloadbalancingv2-2015-12-01","xmlNamespace":"http://elasticloadbalancing.amazonaws.com/doc/2015-12-01/"},"operations":{"AddListenerCertificates":{"input":{"type":"structure","required":["ListenerArn","Certificates"],"members":{"ListenerArn":{},"Certificates":{"shape":"S3"}}},"output":{"resultWrapper":"AddListenerCertificatesResult","type":"structure","members":{"Certificates":{"shape":"S3"}}}},"AddTags":{"input":{"type":"structure","required":["ResourceArns","Tags"],"members":{"ResourceArns":{"shape":"S9"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"AddTagsResult","type":"structure","members":{}}},"CreateListener":{"input":{"type":"structure","required":["LoadBalancerArn","Protocol","Port","DefaultActions"],"members":{"LoadBalancerArn":{},"Protocol":{},"Port":{"type":"integer"},"SslPolicy":{},"Certificates":{"shape":"S3"},"DefaultActions":{"shape":"Sl"}}},"output":{"resultWrapper":"CreateListenerResult","type":"structure","members":{"Listeners":{"shape":"Sq"}}}},"CreateLoadBalancer":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Subnets":{"shape":"Su"},"SubnetMappings":{"shape":"Sw"},"SecurityGroups":{"shape":"Sz"},"Scheme":{},"Tags":{"shape":"Sb"},"Type":{},"IpAddressType":{}}},"output":{"resultWrapper":"CreateLoadBalancerResult","type":"structure","members":{"LoadBalancers":{"shape":"S15"}}}},"CreateRule":{"input":{"type":"structure","required":["ListenerArn","Conditions","Priority","Actions"],"members":{"ListenerArn":{},"Conditions":{"shape":"S1l"},"Priority":{"type":"integer"},"Actions":{"shape":"Sl"}}},"output":{"resultWrapper":"CreateRuleResult","type":"structure","members":{"Rules":{"shape":"S1s"}}}},"CreateTargetGroup":{"input":{"type":"structure","required":["Name","Protocol","Port","VpcId"],"members":{"Name":{},"Protocol":{},"Port":{"type":"integer"},"VpcId":{},"HealthCheckProtocol":{},"HealthCheckPort":{},"HealthCheckPath":{},"HealthCheckIntervalSeconds":{"type":"integer"},"HealthCheckTimeoutSeconds":{"type":"integer"},"HealthyThresholdCount":{"type":"integer"},"UnhealthyThresholdCount":{"type":"integer"},"Matcher":{"shape":"S24"},"TargetType":{}}},"output":{"resultWrapper":"CreateTargetGroupResult","type":"structure","members":{"TargetGroups":{"shape":"S28"}}}},"DeleteListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{}}},"output":{"resultWrapper":"DeleteListenerResult","type":"structure","members":{}}},"DeleteLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerArn"],"members":{"LoadBalancerArn":{}}},"output":{"resultWrapper":"DeleteLoadBalancerResult","type":"structure","members":{}}},"DeleteRule":{"input":{"type":"structure","required":["RuleArn"],"members":{"RuleArn":{}}},"output":{"resultWrapper":"DeleteRuleResult","type":"structure","members":{}}},"DeleteTargetGroup":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{}}},"output":{"resultWrapper":"DeleteTargetGroupResult","type":"structure","members":{}}},"DeregisterTargets":{"input":{"type":"structure","required":["TargetGroupArn","Targets"],"members":{"TargetGroupArn":{},"Targets":{"shape":"S2k"}}},"output":{"resultWrapper":"DeregisterTargetsResult","type":"structure","members":{}}},"DescribeAccountLimits":{"input":{"type":"structure","members":{"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"Limits":{"type":"list","member":{"type":"structure","members":{"Name":{},"Max":{}}}},"NextMarker":{}}}},"DescribeListenerCertificates":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeListenerCertificatesResult","type":"structure","members":{"Certificates":{"shape":"S3"},"NextMarker":{}}}},"DescribeListeners":{"input":{"type":"structure","members":{"LoadBalancerArn":{},"ListenerArns":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeListenersResult","type":"structure","members":{"Listeners":{"shape":"Sq"},"NextMarker":{}}}},"DescribeLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerArn"],"members":{"LoadBalancerArn":{}}},"output":{"resultWrapper":"DescribeLoadBalancerAttributesResult","type":"structure","members":{"Attributes":{"shape":"S33"}}}},"DescribeLoadBalancers":{"input":{"type":"structure","members":{"LoadBalancerArns":{"shape":"S2a"},"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancersResult","type":"structure","members":{"LoadBalancers":{"shape":"S15"},"NextMarker":{}}}},"DescribeRules":{"input":{"type":"structure","members":{"ListenerArn":{},"RuleArns":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeRulesResult","type":"structure","members":{"Rules":{"shape":"S1s"},"NextMarker":{}}}},"DescribeSSLPolicies":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeSSLPoliciesResult","type":"structure","members":{"SslPolicies":{"type":"list","member":{"type":"structure","members":{"SslProtocols":{"type":"list","member":{}},"Ciphers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Priority":{"type":"integer"}}}},"Name":{}}}},"NextMarker":{}}}},"DescribeTags":{"input":{"type":"structure","required":["ResourceArns"],"members":{"ResourceArns":{"shape":"S9"}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"TagDescriptions":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{},"Tags":{"shape":"Sb"}}}}}}},"DescribeTargetGroupAttributes":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{}}},"output":{"resultWrapper":"DescribeTargetGroupAttributesResult","type":"structure","members":{"Attributes":{"shape":"S3u"}}}},"DescribeTargetGroups":{"input":{"type":"structure","members":{"LoadBalancerArn":{},"TargetGroupArns":{"type":"list","member":{}},"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeTargetGroupsResult","type":"structure","members":{"TargetGroups":{"shape":"S28"},"NextMarker":{}}}},"DescribeTargetHealth":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{},"Targets":{"shape":"S2k"}}},"output":{"resultWrapper":"DescribeTargetHealthResult","type":"structure","members":{"TargetHealthDescriptions":{"type":"list","member":{"type":"structure","members":{"Target":{"shape":"S2l"},"HealthCheckPort":{},"TargetHealth":{"type":"structure","members":{"State":{},"Reason":{},"Description":{}}}}}}}}},"ModifyListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{},"Port":{"type":"integer"},"Protocol":{},"SslPolicy":{},"Certificates":{"shape":"S3"},"DefaultActions":{"shape":"Sl"}}},"output":{"resultWrapper":"ModifyListenerResult","type":"structure","members":{"Listeners":{"shape":"Sq"}}}},"ModifyLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerArn","Attributes"],"members":{"LoadBalancerArn":{},"Attributes":{"shape":"S33"}}},"output":{"resultWrapper":"ModifyLoadBalancerAttributesResult","type":"structure","members":{"Attributes":{"shape":"S33"}}}},"ModifyRule":{"input":{"type":"structure","required":["RuleArn"],"members":{"RuleArn":{},"Conditions":{"shape":"S1l"},"Actions":{"shape":"Sl"}}},"output":{"resultWrapper":"ModifyRuleResult","type":"structure","members":{"Rules":{"shape":"S1s"}}}},"ModifyTargetGroup":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{},"HealthCheckProtocol":{},"HealthCheckPort":{},"HealthCheckPath":{},"HealthCheckIntervalSeconds":{"type":"integer"},"HealthCheckTimeoutSeconds":{"type":"integer"},"HealthyThresholdCount":{"type":"integer"},"UnhealthyThresholdCount":{"type":"integer"},"Matcher":{"shape":"S24"}}},"output":{"resultWrapper":"ModifyTargetGroupResult","type":"structure","members":{"TargetGroups":{"shape":"S28"}}}},"ModifyTargetGroupAttributes":{"input":{"type":"structure","required":["TargetGroupArn","Attributes"],"members":{"TargetGroupArn":{},"Attributes":{"shape":"S3u"}}},"output":{"resultWrapper":"ModifyTargetGroupAttributesResult","type":"structure","members":{"Attributes":{"shape":"S3u"}}}},"RegisterTargets":{"input":{"type":"structure","required":["TargetGroupArn","Targets"],"members":{"TargetGroupArn":{},"Targets":{"shape":"S2k"}}},"output":{"resultWrapper":"RegisterTargetsResult","type":"structure","members":{}}},"RemoveListenerCertificates":{"input":{"type":"structure","required":["ListenerArn","Certificates"],"members":{"ListenerArn":{},"Certificates":{"shape":"S3"}}},"output":{"resultWrapper":"RemoveListenerCertificatesResult","type":"structure","members":{}}},"RemoveTags":{"input":{"type":"structure","required":["ResourceArns","TagKeys"],"members":{"ResourceArns":{"shape":"S9"},"TagKeys":{"type":"list","member":{}}}},"output":{"resultWrapper":"RemoveTagsResult","type":"structure","members":{}}},"SetIpAddressType":{"input":{"type":"structure","required":["LoadBalancerArn","IpAddressType"],"members":{"LoadBalancerArn":{},"IpAddressType":{}}},"output":{"resultWrapper":"SetIpAddressTypeResult","type":"structure","members":{"IpAddressType":{}}}},"SetRulePriorities":{"input":{"type":"structure","required":["RulePriorities"],"members":{"RulePriorities":{"type":"list","member":{"type":"structure","members":{"RuleArn":{},"Priority":{"type":"integer"}}}}}},"output":{"resultWrapper":"SetRulePrioritiesResult","type":"structure","members":{"Rules":{"shape":"S1s"}}}},"SetSecurityGroups":{"input":{"type":"structure","required":["LoadBalancerArn","SecurityGroups"],"members":{"LoadBalancerArn":{},"SecurityGroups":{"shape":"Sz"}}},"output":{"resultWrapper":"SetSecurityGroupsResult","type":"structure","members":{"SecurityGroupIds":{"shape":"Sz"}}}},"SetSubnets":{"input":{"type":"structure","required":["LoadBalancerArn","Subnets"],"members":{"LoadBalancerArn":{},"Subnets":{"shape":"Su"},"SubnetMappings":{"shape":"Sw"}}},"output":{"resultWrapper":"SetSubnetsResult","type":"structure","members":{"AvailabilityZones":{"shape":"S1e"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","members":{"CertificateArn":{},"IsDefault":{"type":"boolean"}}}},"S9":{"type":"list","member":{}},"Sb":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sl":{"type":"list","member":{"type":"structure","required":["Type","TargetGroupArn"],"members":{"Type":{},"TargetGroupArn":{}}}},"Sq":{"type":"list","member":{"type":"structure","members":{"ListenerArn":{},"LoadBalancerArn":{},"Port":{"type":"integer"},"Protocol":{},"Certificates":{"shape":"S3"},"SslPolicy":{},"DefaultActions":{"shape":"Sl"}}}},"Su":{"type":"list","member":{}},"Sw":{"type":"list","member":{"type":"structure","members":{"SubnetId":{},"AllocationId":{}}}},"Sz":{"type":"list","member":{}},"S15":{"type":"list","member":{"type":"structure","members":{"LoadBalancerArn":{},"DNSName":{},"CanonicalHostedZoneId":{},"CreatedTime":{"type":"timestamp"},"LoadBalancerName":{},"Scheme":{},"VpcId":{},"State":{"type":"structure","members":{"Code":{},"Reason":{}}},"Type":{},"AvailabilityZones":{"shape":"S1e"},"SecurityGroups":{"shape":"Sz"},"IpAddressType":{}}}},"S1e":{"type":"list","member":{"type":"structure","members":{"ZoneName":{},"SubnetId":{},"LoadBalancerAddresses":{"type":"list","member":{"type":"structure","members":{"IpAddress":{},"AllocationId":{}}}}}}},"S1l":{"type":"list","member":{"type":"structure","members":{"Field":{},"Values":{"type":"list","member":{}}}}},"S1s":{"type":"list","member":{"type":"structure","members":{"RuleArn":{},"Priority":{},"Conditions":{"shape":"S1l"},"Actions":{"shape":"Sl"},"IsDefault":{"type":"boolean"}}}},"S24":{"type":"structure","required":["HttpCode"],"members":{"HttpCode":{}}},"S28":{"type":"list","member":{"type":"structure","members":{"TargetGroupArn":{},"TargetGroupName":{},"Protocol":{},"Port":{"type":"integer"},"VpcId":{},"HealthCheckProtocol":{},"HealthCheckPort":{},"HealthCheckIntervalSeconds":{"type":"integer"},"HealthCheckTimeoutSeconds":{"type":"integer"},"HealthyThresholdCount":{"type":"integer"},"UnhealthyThresholdCount":{"type":"integer"},"HealthCheckPath":{},"Matcher":{"shape":"S24"},"LoadBalancerArns":{"shape":"S2a"},"TargetType":{}}}},"S2a":{"type":"list","member":{}},"S2k":{"type":"list","member":{"shape":"S2l"}},"S2l":{"type":"structure","required":["Id"],"members":{"Id":{},"Port":{"type":"integer"},"AvailabilityZone":{}}},"S33":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S3u":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 2839 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeListeners":{"input_token":"Marker","output_token":"NextMarker","result_key":"Listeners"},"DescribeLoadBalancers":{"input_token":"Marker","output_token":"NextMarker","result_key":"LoadBalancers"},"DescribeTargetGroups":{"input_token":"Marker","output_token":"NextMarker","result_key":"TargetGroups"}}}

/***/ }),
/* 2840 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"LoadBalancerExists":{"delay":15,"operation":"DescribeLoadBalancers","maxAttempts":40,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"LoadBalancerNotFound","state":"retry"}]},"LoadBalancerAvailable":{"delay":15,"operation":"DescribeLoadBalancers","maxAttempts":40,"acceptors":[{"state":"success","matcher":"pathAll","argument":"LoadBalancers[].State.Code","expected":"active"},{"state":"retry","matcher":"pathAny","argument":"LoadBalancers[].State.Code","expected":"provisioning"},{"state":"retry","matcher":"error","expected":"LoadBalancerNotFound"}]},"LoadBalancersDeleted":{"delay":15,"operation":"DescribeLoadBalancers","maxAttempts":40,"acceptors":[{"state":"retry","matcher":"pathAll","argument":"LoadBalancers[].State.Code","expected":"active"},{"matcher":"error","expected":"LoadBalancerNotFound","state":"success"}]},"TargetInService":{"delay":15,"maxAttempts":40,"operation":"DescribeTargetHealth","acceptors":[{"argument":"TargetHealthDescriptions[].TargetHealth.State","expected":"healthy","matcher":"pathAll","state":"success"},{"matcher":"error","expected":"InvalidInstance","state":"retry"}]},"TargetDeregistered":{"delay":15,"maxAttempts":40,"operation":"DescribeTargetHealth","acceptors":[{"matcher":"error","expected":"InvalidTarget","state":"success"},{"argument":"TargetHealthDescriptions[].TargetHealth.State","expected":"unused","matcher":"pathAll","state":"success"}]}}}

/***/ }),
/* 2841 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['emr'] = {};
AWS.EMR = Service.defineService('emr', ['2009-03-31']);
Object.defineProperty(apiLoader.services['emr'], '2009-03-31', {
  get: function get() {
    var model = __webpack_require__(2842);
    model.paginators = __webpack_require__(2843).pagination;
    model.waiters = __webpack_require__(2844).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.EMR;


/***/ }),
/* 2842 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2009-03-31","endpointPrefix":"elasticmapreduce","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon EMR","serviceFullName":"Amazon Elastic MapReduce","signatureVersion":"v4","targetPrefix":"ElasticMapReduce","timestampFormat":"unixTimestamp","uid":"elasticmapreduce-2009-03-31"},"operations":{"AddInstanceFleet":{"input":{"type":"structure","required":["ClusterId","InstanceFleet"],"members":{"ClusterId":{},"InstanceFleet":{"shape":"S3"}}},"output":{"type":"structure","members":{"ClusterId":{},"InstanceFleetId":{}}}},"AddInstanceGroups":{"input":{"type":"structure","required":["InstanceGroups","JobFlowId"],"members":{"InstanceGroups":{"shape":"Sq"},"JobFlowId":{}}},"output":{"type":"structure","members":{"JobFlowId":{},"InstanceGroupIds":{"type":"list","member":{}}}}},"AddJobFlowSteps":{"input":{"type":"structure","required":["JobFlowId","Steps"],"members":{"JobFlowId":{},"Steps":{"shape":"S1b"}}},"output":{"type":"structure","members":{"StepIds":{"shape":"S1k"}}}},"AddTags":{"input":{"type":"structure","required":["ResourceId","Tags"],"members":{"ResourceId":{},"Tags":{"shape":"S1n"}}},"output":{"type":"structure","members":{}}},"CancelSteps":{"input":{"type":"structure","members":{"ClusterId":{},"StepIds":{"shape":"S1k"}}},"output":{"type":"structure","members":{"CancelStepsInfoList":{"type":"list","member":{"type":"structure","members":{"StepId":{},"Status":{},"Reason":{}}}}}}},"CreateSecurityConfiguration":{"input":{"type":"structure","required":["Name","SecurityConfiguration"],"members":{"Name":{},"SecurityConfiguration":{}}},"output":{"type":"structure","required":["Name","CreationDateTime"],"members":{"Name":{},"CreationDateTime":{"type":"timestamp"}}}},"DeleteSecurityConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DescribeCluster":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{"Cluster":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"shape":"S25"},"Ec2InstanceAttributes":{"type":"structure","members":{"Ec2KeyName":{},"Ec2SubnetId":{},"RequestedEc2SubnetIds":{"shape":"S2b"},"Ec2AvailabilityZone":{},"RequestedEc2AvailabilityZones":{"shape":"S2b"},"IamInstanceProfile":{},"EmrManagedMasterSecurityGroup":{},"EmrManagedSlaveSecurityGroup":{},"ServiceAccessSecurityGroup":{},"AdditionalMasterSecurityGroups":{"shape":"S2c"},"AdditionalSlaveSecurityGroups":{"shape":"S2c"}}},"InstanceCollectionType":{},"LogUri":{},"RequestedAmiVersion":{},"RunningAmiVersion":{},"ReleaseLabel":{},"AutoTerminate":{"type":"boolean"},"TerminationProtected":{"type":"boolean"},"VisibleToAllUsers":{"type":"boolean"},"Applications":{"shape":"S2f"},"Tags":{"shape":"S1n"},"ServiceRole":{},"NormalizedInstanceHours":{"type":"integer"},"MasterPublicDnsName":{},"Configurations":{"shape":"Sh"},"SecurityConfiguration":{},"AutoScalingRole":{},"ScaleDownBehavior":{},"CustomAmiId":{},"EbsRootVolumeSize":{"type":"integer"},"RepoUpgradeOnBoot":{},"KerberosAttributes":{"shape":"S2j"}}}}}},"DescribeJobFlows":{"input":{"type":"structure","members":{"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"JobFlowIds":{"shape":"S1i"},"JobFlowStates":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"JobFlows":{"type":"list","member":{"type":"structure","required":["JobFlowId","Name","ExecutionStatusDetail","Instances"],"members":{"JobFlowId":{},"Name":{},"LogUri":{},"AmiVersion":{},"ExecutionStatusDetail":{"type":"structure","required":["State","CreationDateTime"],"members":{"State":{},"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"},"LastStateChangeReason":{}}},"Instances":{"type":"structure","required":["MasterInstanceType","SlaveInstanceType","InstanceCount"],"members":{"MasterInstanceType":{},"MasterPublicDnsName":{},"MasterInstanceId":{},"SlaveInstanceType":{},"InstanceCount":{"type":"integer"},"InstanceGroups":{"type":"list","member":{"type":"structure","required":["Market","InstanceRole","InstanceType","InstanceRequestCount","InstanceRunningCount","State","CreationDateTime"],"members":{"InstanceGroupId":{},"Name":{},"Market":{},"InstanceRole":{},"BidPrice":{},"InstanceType":{},"InstanceRequestCount":{"type":"integer"},"InstanceRunningCount":{"type":"integer"},"State":{},"LastStateChangeReason":{},"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}},"NormalizedInstanceHours":{"type":"integer"},"Ec2KeyName":{},"Ec2SubnetId":{},"Placement":{"shape":"S2v"},"KeepJobFlowAliveWhenNoSteps":{"type":"boolean"},"TerminationProtected":{"type":"boolean"},"HadoopVersion":{}}},"Steps":{"type":"list","member":{"type":"structure","required":["StepConfig","ExecutionStatusDetail"],"members":{"StepConfig":{"shape":"S1c"},"ExecutionStatusDetail":{"type":"structure","required":["State","CreationDateTime"],"members":{"State":{},"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"},"LastStateChangeReason":{}}}}}},"BootstrapActions":{"type":"list","member":{"type":"structure","members":{"BootstrapActionConfig":{"shape":"S32"}}}},"SupportedProducts":{"shape":"S34"},"VisibleToAllUsers":{"type":"boolean"},"JobFlowRole":{},"ServiceRole":{},"AutoScalingRole":{},"ScaleDownBehavior":{}}}}}},"deprecated":true},"DescribeSecurityConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"SecurityConfiguration":{},"CreationDateTime":{"type":"timestamp"}}}},"DescribeStep":{"input":{"type":"structure","required":["ClusterId","StepId"],"members":{"ClusterId":{},"StepId":{}}},"output":{"type":"structure","members":{"Step":{"type":"structure","members":{"Id":{},"Name":{},"Config":{"shape":"S3a"},"ActionOnFailure":{},"Status":{"shape":"S3b"}}}}}},"ListBootstrapActions":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"Marker":{}}},"output":{"type":"structure","members":{"BootstrapActions":{"type":"list","member":{"type":"structure","members":{"Name":{},"ScriptPath":{},"Args":{"shape":"S2c"}}}},"Marker":{}}}},"ListClusters":{"input":{"type":"structure","members":{"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"ClusterStates":{"type":"list","member":{}},"Marker":{}}},"output":{"type":"structure","members":{"Clusters":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"shape":"S25"},"NormalizedInstanceHours":{"type":"integer"}}}},"Marker":{}}}},"ListInstanceFleets":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"Marker":{}}},"output":{"type":"structure","members":{"InstanceFleets":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"InstanceFleetType":{},"TargetOnDemandCapacity":{"type":"integer"},"TargetSpotCapacity":{"type":"integer"},"ProvisionedOnDemandCapacity":{"type":"integer"},"ProvisionedSpotCapacity":{"type":"integer"},"InstanceTypeSpecifications":{"type":"list","member":{"type":"structure","members":{"InstanceType":{},"WeightedCapacity":{"type":"integer"},"BidPrice":{},"BidPriceAsPercentageOfOnDemandPrice":{"type":"double"},"Configurations":{"shape":"Sh"},"EbsBlockDevices":{"shape":"S42"},"EbsOptimized":{"type":"boolean"}}}},"LaunchSpecifications":{"shape":"Sk"}}}},"Marker":{}}}},"ListInstanceGroups":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"Marker":{}}},"output":{"type":"structure","members":{"InstanceGroups":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Market":{},"InstanceGroupType":{},"BidPrice":{},"InstanceType":{},"RequestedInstanceCount":{"type":"integer"},"RunningInstanceCount":{"type":"integer"},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"Configurations":{"shape":"Sh"},"EbsBlockDevices":{"shape":"S42"},"EbsOptimized":{"type":"boolean"},"ShrinkPolicy":{"shape":"S4e"},"AutoScalingPolicy":{"shape":"S4i"}}}},"Marker":{}}}},"ListInstances":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"InstanceGroupId":{},"InstanceGroupTypes":{"type":"list","member":{}},"InstanceFleetId":{},"InstanceFleetType":{},"InstanceStates":{"type":"list","member":{}},"Marker":{}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"Id":{},"Ec2InstanceId":{},"PublicDnsName":{},"PublicIpAddress":{},"PrivateDnsName":{},"PrivateIpAddress":{},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"InstanceGroupId":{},"InstanceFleetId":{},"Market":{},"InstanceType":{},"EbsVolumes":{"type":"list","member":{"type":"structure","members":{"Device":{},"VolumeId":{}}}}}}},"Marker":{}}}},"ListSecurityConfigurations":{"input":{"type":"structure","members":{"Marker":{}}},"output":{"type":"structure","members":{"SecurityConfigurations":{"type":"list","member":{"type":"structure","members":{"Name":{},"CreationDateTime":{"type":"timestamp"}}}},"Marker":{}}}},"ListSteps":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"StepStates":{"type":"list","member":{}},"StepIds":{"shape":"S1i"},"Marker":{}}},"output":{"type":"structure","members":{"Steps":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Config":{"shape":"S3a"},"ActionOnFailure":{},"Status":{"shape":"S3b"}}}},"Marker":{}}}},"ModifyInstanceFleet":{"input":{"type":"structure","required":["ClusterId","InstanceFleet"],"members":{"ClusterId":{},"InstanceFleet":{"type":"structure","required":["InstanceFleetId"],"members":{"InstanceFleetId":{},"TargetOnDemandCapacity":{"type":"integer"},"TargetSpotCapacity":{"type":"integer"}}}}}},"ModifyInstanceGroups":{"input":{"type":"structure","members":{"ClusterId":{},"InstanceGroups":{"type":"list","member":{"type":"structure","required":["InstanceGroupId"],"members":{"InstanceGroupId":{},"InstanceCount":{"type":"integer"},"EC2InstanceIdsToTerminate":{"type":"list","member":{}},"ShrinkPolicy":{"shape":"S4e"}}}}}}},"PutAutoScalingPolicy":{"input":{"type":"structure","required":["ClusterId","InstanceGroupId","AutoScalingPolicy"],"members":{"ClusterId":{},"InstanceGroupId":{},"AutoScalingPolicy":{"shape":"Su"}}},"output":{"type":"structure","members":{"ClusterId":{},"InstanceGroupId":{},"AutoScalingPolicy":{"shape":"S4i"}}}},"RemoveAutoScalingPolicy":{"input":{"type":"structure","required":["ClusterId","InstanceGroupId"],"members":{"ClusterId":{},"InstanceGroupId":{}}},"output":{"type":"structure","members":{}}},"RemoveTags":{"input":{"type":"structure","required":["ResourceId","TagKeys"],"members":{"ResourceId":{},"TagKeys":{"shape":"S2c"}}},"output":{"type":"structure","members":{}}},"RunJobFlow":{"input":{"type":"structure","required":["Name","Instances"],"members":{"Name":{},"LogUri":{},"AdditionalInfo":{},"AmiVersion":{},"ReleaseLabel":{},"Instances":{"type":"structure","members":{"MasterInstanceType":{},"SlaveInstanceType":{},"InstanceCount":{"type":"integer"},"InstanceGroups":{"shape":"Sq"},"InstanceFleets":{"type":"list","member":{"shape":"S3"}},"Ec2KeyName":{},"Placement":{"shape":"S2v"},"KeepJobFlowAliveWhenNoSteps":{"type":"boolean"},"TerminationProtected":{"type":"boolean"},"HadoopVersion":{},"Ec2SubnetId":{},"Ec2SubnetIds":{"shape":"S2b"},"EmrManagedMasterSecurityGroup":{},"EmrManagedSlaveSecurityGroup":{},"ServiceAccessSecurityGroup":{},"AdditionalMasterSecurityGroups":{"shape":"S5o"},"AdditionalSlaveSecurityGroups":{"shape":"S5o"}}},"Steps":{"shape":"S1b"},"BootstrapActions":{"type":"list","member":{"shape":"S32"}},"SupportedProducts":{"shape":"S34"},"NewSupportedProducts":{"type":"list","member":{"type":"structure","members":{"Name":{},"Args":{"shape":"S1i"}}}},"Applications":{"shape":"S2f"},"Configurations":{"shape":"Sh"},"VisibleToAllUsers":{"type":"boolean"},"JobFlowRole":{},"ServiceRole":{},"Tags":{"shape":"S1n"},"SecurityConfiguration":{},"AutoScalingRole":{},"ScaleDownBehavior":{},"CustomAmiId":{},"EbsRootVolumeSize":{"type":"integer"},"RepoUpgradeOnBoot":{},"KerberosAttributes":{"shape":"S2j"}}},"output":{"type":"structure","members":{"JobFlowId":{}}}},"SetTerminationProtection":{"input":{"type":"structure","required":["JobFlowIds","TerminationProtected"],"members":{"JobFlowIds":{"shape":"S1i"},"TerminationProtected":{"type":"boolean"}}}},"SetVisibleToAllUsers":{"input":{"type":"structure","required":["JobFlowIds","VisibleToAllUsers"],"members":{"JobFlowIds":{"shape":"S1i"},"VisibleToAllUsers":{"type":"boolean"}}}},"TerminateJobFlows":{"input":{"type":"structure","required":["JobFlowIds"],"members":{"JobFlowIds":{"shape":"S1i"}}}}},"shapes":{"S3":{"type":"structure","required":["InstanceFleetType"],"members":{"Name":{},"InstanceFleetType":{},"TargetOnDemandCapacity":{"type":"integer"},"TargetSpotCapacity":{"type":"integer"},"InstanceTypeConfigs":{"type":"list","member":{"type":"structure","required":["InstanceType"],"members":{"InstanceType":{},"WeightedCapacity":{"type":"integer"},"BidPrice":{},"BidPriceAsPercentageOfOnDemandPrice":{"type":"double"},"EbsConfiguration":{"shape":"Sa"},"Configurations":{"shape":"Sh"}}}},"LaunchSpecifications":{"shape":"Sk"}}},"Sa":{"type":"structure","members":{"EbsBlockDeviceConfigs":{"type":"list","member":{"type":"structure","required":["VolumeSpecification"],"members":{"VolumeSpecification":{"shape":"Sd"},"VolumesPerInstance":{"type":"integer"}}}},"EbsOptimized":{"type":"boolean"}}},"Sd":{"type":"structure","required":["VolumeType","SizeInGB"],"members":{"VolumeType":{},"Iops":{"type":"integer"},"SizeInGB":{"type":"integer"}}},"Sh":{"type":"list","member":{"type":"structure","members":{"Classification":{},"Configurations":{"shape":"Sh"},"Properties":{"shape":"Sj"}}}},"Sj":{"type":"map","key":{},"value":{}},"Sk":{"type":"structure","required":["SpotSpecification"],"members":{"SpotSpecification":{"type":"structure","required":["TimeoutDurationMinutes","TimeoutAction"],"members":{"TimeoutDurationMinutes":{"type":"integer"},"TimeoutAction":{},"BlockDurationMinutes":{"type":"integer"}}}}},"Sq":{"type":"list","member":{"type":"structure","required":["InstanceRole","InstanceType","InstanceCount"],"members":{"Name":{},"Market":{},"InstanceRole":{},"BidPrice":{},"InstanceType":{},"InstanceCount":{"type":"integer"},"Configurations":{"shape":"Sh"},"EbsConfiguration":{"shape":"Sa"},"AutoScalingPolicy":{"shape":"Su"}}}},"Su":{"type":"structure","required":["Constraints","Rules"],"members":{"Constraints":{"shape":"Sv"},"Rules":{"shape":"Sw"}}},"Sv":{"type":"structure","required":["MinCapacity","MaxCapacity"],"members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"}}},"Sw":{"type":"list","member":{"type":"structure","required":["Name","Action","Trigger"],"members":{"Name":{},"Description":{},"Action":{"type":"structure","required":["SimpleScalingPolicyConfiguration"],"members":{"Market":{},"SimpleScalingPolicyConfiguration":{"type":"structure","required":["ScalingAdjustment"],"members":{"AdjustmentType":{},"ScalingAdjustment":{"type":"integer"},"CoolDown":{"type":"integer"}}}}},"Trigger":{"type":"structure","required":["CloudWatchAlarmDefinition"],"members":{"CloudWatchAlarmDefinition":{"type":"structure","required":["ComparisonOperator","MetricName","Period","Threshold"],"members":{"ComparisonOperator":{},"EvaluationPeriods":{"type":"integer"},"MetricName":{},"Namespace":{},"Period":{"type":"integer"},"Statistic":{},"Threshold":{"type":"double"},"Unit":{},"Dimensions":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}}}}}},"S1b":{"type":"list","member":{"shape":"S1c"}},"S1c":{"type":"structure","required":["Name","HadoopJarStep"],"members":{"Name":{},"ActionOnFailure":{},"HadoopJarStep":{"type":"structure","required":["Jar"],"members":{"Properties":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Jar":{},"MainClass":{},"Args":{"shape":"S1i"}}}}},"S1i":{"type":"list","member":{}},"S1k":{"type":"list","member":{}},"S1n":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S25":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"S2b":{"type":"list","member":{}},"S2c":{"type":"list","member":{}},"S2f":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{},"Args":{"shape":"S2c"},"AdditionalInfo":{"shape":"Sj"}}}},"S2j":{"type":"structure","required":["Realm","KdcAdminPassword"],"members":{"Realm":{},"KdcAdminPassword":{},"CrossRealmTrustPrincipalPassword":{},"ADDomainJoinUser":{},"ADDomainJoinPassword":{}}},"S2v":{"type":"structure","members":{"AvailabilityZone":{},"AvailabilityZones":{"shape":"S2b"}}},"S32":{"type":"structure","required":["Name","ScriptBootstrapAction"],"members":{"Name":{},"ScriptBootstrapAction":{"type":"structure","required":["Path"],"members":{"Path":{},"Args":{"shape":"S1i"}}}}},"S34":{"type":"list","member":{}},"S3a":{"type":"structure","members":{"Jar":{},"Properties":{"shape":"Sj"},"MainClass":{},"Args":{"shape":"S2c"}}},"S3b":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"FailureDetails":{"type":"structure","members":{"Reason":{},"Message":{},"LogFile":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"S42":{"type":"list","member":{"type":"structure","members":{"VolumeSpecification":{"shape":"Sd"},"Device":{}}}},"S4e":{"type":"structure","members":{"DecommissionTimeout":{"type":"integer"},"InstanceResizePolicy":{"type":"structure","members":{"InstancesToTerminate":{"shape":"S4g"},"InstancesToProtect":{"shape":"S4g"},"InstanceTerminationTimeout":{"type":"integer"}}}}},"S4g":{"type":"list","member":{}},"S4i":{"type":"structure","members":{"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}}}},"Constraints":{"shape":"Sv"},"Rules":{"shape":"Sw"}}},"S5o":{"type":"list","member":{}}}}

/***/ }),
/* 2843 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeJobFlows":{"result_key":"JobFlows"},"ListBootstrapActions":{"input_token":"Marker","output_token":"Marker","result_key":"BootstrapActions"},"ListClusters":{"input_token":"Marker","output_token":"Marker","result_key":"Clusters"},"ListInstanceFleets":{"input_token":"Marker","output_token":"Marker","result_key":"InstanceFleets"},"ListInstanceGroups":{"input_token":"Marker","output_token":"Marker","result_key":"InstanceGroups"},"ListInstances":{"input_token":"Marker","output_token":"Marker","result_key":"Instances"},"ListSteps":{"input_token":"Marker","output_token":"Marker","result_key":"Steps"}}}

/***/ }),
/* 2844 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"ClusterRunning":{"delay":30,"operation":"DescribeCluster","maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"Cluster.Status.State","expected":"RUNNING"},{"state":"success","matcher":"path","argument":"Cluster.Status.State","expected":"WAITING"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATING"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED_WITH_ERRORS"}]},"StepComplete":{"delay":30,"operation":"DescribeStep","maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"Step.Status.State","expected":"COMPLETED"},{"state":"failure","matcher":"path","argument":"Step.Status.State","expected":"FAILED"},{"state":"failure","matcher":"path","argument":"Step.Status.State","expected":"CANCELLED"}]},"ClusterTerminated":{"delay":30,"operation":"DescribeCluster","maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED_WITH_ERRORS"}]}}}

/***/ }),
/* 2845 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['elastictranscoder'] = {};
AWS.ElasticTranscoder = Service.defineService('elastictranscoder', ['2012-09-25']);
Object.defineProperty(apiLoader.services['elastictranscoder'], '2012-09-25', {
  get: function get() {
    var model = __webpack_require__(2846);
    model.paginators = __webpack_require__(2847).pagination;
    model.waiters = __webpack_require__(2848).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ElasticTranscoder;


/***/ }),
/* 2846 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"uid":"elastictranscoder-2012-09-25","apiVersion":"2012-09-25","endpointPrefix":"elastictranscoder","protocol":"rest-json","serviceFullName":"Amazon Elastic Transcoder","signatureVersion":"v4"},"operations":{"CancelJob":{"http":{"method":"DELETE","requestUri":"/2012-09-25/jobs/{Id}","responseCode":202},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"CreateJob":{"http":{"requestUri":"/2012-09-25/jobs","responseCode":201},"input":{"type":"structure","required":["PipelineId"],"members":{"PipelineId":{},"Input":{"shape":"S5"},"Inputs":{"shape":"St"},"Output":{"shape":"Su"},"Outputs":{"type":"list","member":{"shape":"Su"}},"OutputKeyPrefix":{},"Playlists":{"type":"list","member":{"type":"structure","members":{"Name":{},"Format":{},"OutputKeys":{"shape":"S1l"},"HlsContentProtection":{"shape":"S1m"},"PlayReadyDrm":{"shape":"S1q"}}}},"UserMetadata":{"shape":"S1v"}}},"output":{"type":"structure","members":{"Job":{"shape":"S1y"}}}},"CreatePipeline":{"http":{"requestUri":"/2012-09-25/pipelines","responseCode":201},"input":{"type":"structure","required":["Name","InputBucket","Role"],"members":{"Name":{},"InputBucket":{},"OutputBucket":{},"Role":{},"AwsKmsKeyArn":{},"Notifications":{"shape":"S2a"},"ContentConfig":{"shape":"S2c"},"ThumbnailConfig":{"shape":"S2c"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"},"Warnings":{"shape":"S2n"}}}},"CreatePreset":{"http":{"requestUri":"/2012-09-25/presets","responseCode":201},"input":{"type":"structure","required":["Name","Container"],"members":{"Name":{},"Description":{},"Container":{},"Video":{"shape":"S2r"},"Audio":{"shape":"S37"},"Thumbnails":{"shape":"S3i"}}},"output":{"type":"structure","members":{"Preset":{"shape":"S3m"},"Warning":{}}}},"DeletePipeline":{"http":{"method":"DELETE","requestUri":"/2012-09-25/pipelines/{Id}","responseCode":202},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeletePreset":{"http":{"method":"DELETE","requestUri":"/2012-09-25/presets/{Id}","responseCode":202},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"ListJobsByPipeline":{"http":{"method":"GET","requestUri":"/2012-09-25/jobsByPipeline/{PipelineId}"},"input":{"type":"structure","required":["PipelineId"],"members":{"PipelineId":{"location":"uri","locationName":"PipelineId"},"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Jobs":{"shape":"S3v"},"NextPageToken":{}}}},"ListJobsByStatus":{"http":{"method":"GET","requestUri":"/2012-09-25/jobsByStatus/{Status}"},"input":{"type":"structure","required":["Status"],"members":{"Status":{"location":"uri","locationName":"Status"},"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Jobs":{"shape":"S3v"},"NextPageToken":{}}}},"ListPipelines":{"http":{"method":"GET","requestUri":"/2012-09-25/pipelines"},"input":{"type":"structure","members":{"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Pipelines":{"type":"list","member":{"shape":"S2l"}},"NextPageToken":{}}}},"ListPresets":{"http":{"method":"GET","requestUri":"/2012-09-25/presets"},"input":{"type":"structure","members":{"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Presets":{"type":"list","member":{"shape":"S3m"}},"NextPageToken":{}}}},"ReadJob":{"http":{"method":"GET","requestUri":"/2012-09-25/jobs/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Job":{"shape":"S1y"}}}},"ReadPipeline":{"http":{"method":"GET","requestUri":"/2012-09-25/pipelines/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"},"Warnings":{"shape":"S2n"}}}},"ReadPreset":{"http":{"method":"GET","requestUri":"/2012-09-25/presets/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Preset":{"shape":"S3m"}}}},"TestRole":{"http":{"requestUri":"/2012-09-25/roleTests","responseCode":200},"input":{"type":"structure","required":["Role","InputBucket","OutputBucket","Topics"],"members":{"Role":{},"InputBucket":{},"OutputBucket":{},"Topics":{"type":"list","member":{}}},"deprecated":true},"output":{"type":"structure","members":{"Success":{},"Messages":{"type":"list","member":{}}},"deprecated":true},"deprecated":true},"UpdatePipeline":{"http":{"method":"PUT","requestUri":"/2012-09-25/pipelines/{Id}","responseCode":200},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"Name":{},"InputBucket":{},"Role":{},"AwsKmsKeyArn":{},"Notifications":{"shape":"S2a"},"ContentConfig":{"shape":"S2c"},"ThumbnailConfig":{"shape":"S2c"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"},"Warnings":{"shape":"S2n"}}}},"UpdatePipelineNotifications":{"http":{"requestUri":"/2012-09-25/pipelines/{Id}/notifications"},"input":{"type":"structure","required":["Id","Notifications"],"members":{"Id":{"location":"uri","locationName":"Id"},"Notifications":{"shape":"S2a"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"}}}},"UpdatePipelineStatus":{"http":{"requestUri":"/2012-09-25/pipelines/{Id}/status"},"input":{"type":"structure","required":["Id","Status"],"members":{"Id":{"location":"uri","locationName":"Id"},"Status":{}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"}}}}},"shapes":{"S5":{"type":"structure","members":{"Key":{},"FrameRate":{},"Resolution":{},"AspectRatio":{},"Interlaced":{},"Container":{},"Encryption":{"shape":"Sc"},"TimeSpan":{"shape":"Sg"},"InputCaptions":{"type":"structure","members":{"MergePolicy":{},"CaptionSources":{"shape":"Sk"}}},"DetectedProperties":{"type":"structure","members":{"Width":{"type":"integer"},"Height":{"type":"integer"},"FrameRate":{},"FileSize":{"type":"long"},"DurationMillis":{"type":"long"}}}}},"Sc":{"type":"structure","members":{"Mode":{},"Key":{},"KeyMd5":{},"InitializationVector":{}}},"Sg":{"type":"structure","members":{"StartTime":{},"Duration":{}}},"Sk":{"type":"list","member":{"type":"structure","members":{"Key":{},"Language":{},"TimeOffset":{},"Label":{},"Encryption":{"shape":"Sc"}}}},"St":{"type":"list","member":{"shape":"S5"}},"Su":{"type":"structure","members":{"Key":{},"ThumbnailPattern":{},"ThumbnailEncryption":{"shape":"Sc"},"Rotate":{},"PresetId":{},"SegmentDuration":{},"Watermarks":{"shape":"Sx"},"AlbumArt":{"shape":"S11"},"Composition":{"shape":"S19","deprecated":true},"Captions":{"shape":"S1b"},"Encryption":{"shape":"Sc"}}},"Sx":{"type":"list","member":{"type":"structure","members":{"PresetWatermarkId":{},"InputKey":{},"Encryption":{"shape":"Sc"}}}},"S11":{"type":"structure","members":{"MergePolicy":{},"Artwork":{"type":"list","member":{"type":"structure","members":{"InputKey":{},"MaxWidth":{},"MaxHeight":{},"SizingPolicy":{},"PaddingPolicy":{},"AlbumArtFormat":{},"Encryption":{"shape":"Sc"}}}}}},"S19":{"type":"list","member":{"type":"structure","members":{"TimeSpan":{"shape":"Sg"}},"deprecated":true},"deprecated":true},"S1b":{"type":"structure","members":{"MergePolicy":{"deprecated":true},"CaptionSources":{"shape":"Sk","deprecated":true},"CaptionFormats":{"type":"list","member":{"type":"structure","members":{"Format":{},"Pattern":{},"Encryption":{"shape":"Sc"}}}}}},"S1l":{"type":"list","member":{}},"S1m":{"type":"structure","members":{"Method":{},"Key":{},"KeyMd5":{},"InitializationVector":{},"LicenseAcquisitionUrl":{},"KeyStoragePolicy":{}}},"S1q":{"type":"structure","members":{"Format":{},"Key":{},"KeyMd5":{},"KeyId":{},"InitializationVector":{},"LicenseAcquisitionUrl":{}}},"S1v":{"type":"map","key":{},"value":{}},"S1y":{"type":"structure","members":{"Id":{},"Arn":{},"PipelineId":{},"Input":{"shape":"S5"},"Inputs":{"shape":"St"},"Output":{"shape":"S1z"},"Outputs":{"type":"list","member":{"shape":"S1z"}},"OutputKeyPrefix":{},"Playlists":{"type":"list","member":{"type":"structure","members":{"Name":{},"Format":{},"OutputKeys":{"shape":"S1l"},"HlsContentProtection":{"shape":"S1m"},"PlayReadyDrm":{"shape":"S1q"},"Status":{},"StatusDetail":{}}}},"Status":{},"UserMetadata":{"shape":"S1v"},"Timing":{"type":"structure","members":{"SubmitTimeMillis":{"type":"long"},"StartTimeMillis":{"type":"long"},"FinishTimeMillis":{"type":"long"}}}}},"S1z":{"type":"structure","members":{"Id":{},"Key":{},"ThumbnailPattern":{},"ThumbnailEncryption":{"shape":"Sc"},"Rotate":{},"PresetId":{},"SegmentDuration":{},"Status":{},"StatusDetail":{},"Duration":{"type":"long"},"Width":{"type":"integer"},"Height":{"type":"integer"},"FrameRate":{},"FileSize":{"type":"long"},"DurationMillis":{"type":"long"},"Watermarks":{"shape":"Sx"},"AlbumArt":{"shape":"S11"},"Composition":{"shape":"S19","deprecated":true},"Captions":{"shape":"S1b"},"Encryption":{"shape":"Sc"},"AppliedColorSpaceConversion":{}}},"S2a":{"type":"structure","members":{"Progressing":{},"Completed":{},"Warning":{},"Error":{}}},"S2c":{"type":"structure","members":{"Bucket":{},"StorageClass":{},"Permissions":{"type":"list","member":{"type":"structure","members":{"GranteeType":{},"Grantee":{},"Access":{"type":"list","member":{}}}}}}},"S2l":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Status":{},"InputBucket":{},"OutputBucket":{},"Role":{},"AwsKmsKeyArn":{},"Notifications":{"shape":"S2a"},"ContentConfig":{"shape":"S2c"},"ThumbnailConfig":{"shape":"S2c"}}},"S2n":{"type":"list","member":{"type":"structure","members":{"Code":{},"Message":{}}}},"S2r":{"type":"structure","members":{"Codec":{},"CodecOptions":{"type":"map","key":{},"value":{}},"KeyframesMaxDist":{},"FixedGOP":{},"BitRate":{},"FrameRate":{},"MaxFrameRate":{},"Resolution":{},"AspectRatio":{},"MaxWidth":{},"MaxHeight":{},"DisplayAspectRatio":{},"SizingPolicy":{},"PaddingPolicy":{},"Watermarks":{"type":"list","member":{"type":"structure","members":{"Id":{},"MaxWidth":{},"MaxHeight":{},"SizingPolicy":{},"HorizontalAlign":{},"HorizontalOffset":{},"VerticalAlign":{},"VerticalOffset":{},"Opacity":{},"Target":{}}}}}},"S37":{"type":"structure","members":{"Codec":{},"SampleRate":{},"BitRate":{},"Channels":{},"AudioPackingMode":{},"CodecOptions":{"type":"structure","members":{"Profile":{},"BitDepth":{},"BitOrder":{},"Signed":{}}}}},"S3i":{"type":"structure","members":{"Format":{},"Interval":{},"Resolution":{},"AspectRatio":{},"MaxWidth":{},"MaxHeight":{},"SizingPolicy":{},"PaddingPolicy":{}}},"S3m":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Description":{},"Container":{},"Audio":{"shape":"S37"},"Video":{"shape":"S2r"},"Thumbnails":{"shape":"S3i"},"Type":{}}},"S3v":{"type":"list","member":{"shape":"S1y"}}}}

/***/ }),
/* 2847 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListJobsByPipeline":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Jobs"},"ListJobsByStatus":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Jobs"},"ListPipelines":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Pipelines"},"ListPresets":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Presets"}}}

/***/ }),
/* 2848 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"JobComplete":{"delay":30,"operation":"ReadJob","maxAttempts":120,"acceptors":[{"expected":"Complete","matcher":"path","state":"success","argument":"Job.Status"},{"expected":"Canceled","matcher":"path","state":"failure","argument":"Job.Status"},{"expected":"Error","matcher":"path","state":"failure","argument":"Job.Status"}]}}}

/***/ }),
/* 2849 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['firehose'] = {};
AWS.Firehose = Service.defineService('firehose', ['2015-08-04']);
Object.defineProperty(apiLoader.services['firehose'], '2015-08-04', {
  get: function get() {
    var model = __webpack_require__(2850);
    model.paginators = __webpack_require__(2851).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Firehose;


/***/ }),
/* 2850 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-08-04","endpointPrefix":"firehose","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Firehose","serviceFullName":"Amazon Kinesis Firehose","serviceId":"Firehose","signatureVersion":"v4","targetPrefix":"Firehose_20150804","uid":"firehose-2015-08-04"},"operations":{"CreateDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"DeliveryStreamType":{},"KinesisStreamSourceConfiguration":{"type":"structure","required":["KinesisStreamARN","RoleARN"],"members":{"KinesisStreamARN":{},"RoleARN":{}}},"S3DestinationConfiguration":{"shape":"S7","deprecated":true},"ExtendedS3DestinationConfiguration":{"type":"structure","required":["RoleARN","BucketARN"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"BufferingHints":{"shape":"Sa"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Se"},"CloudWatchLoggingOptions":{"shape":"Si"},"ProcessingConfiguration":{"shape":"Sn"},"S3BackupMode":{},"S3BackupConfiguration":{"shape":"S7"}}},"RedshiftDestinationConfiguration":{"type":"structure","required":["RoleARN","ClusterJDBCURL","CopyCommand","Username","Password","S3Configuration"],"members":{"RoleARN":{},"ClusterJDBCURL":{},"CopyCommand":{"shape":"Sy"},"Username":{"shape":"S12"},"Password":{"shape":"S13"},"RetryOptions":{"shape":"S14"},"S3Configuration":{"shape":"S7"},"ProcessingConfiguration":{"shape":"Sn"},"S3BackupMode":{},"S3BackupConfiguration":{"shape":"S7"},"CloudWatchLoggingOptions":{"shape":"Si"}}},"ElasticsearchDestinationConfiguration":{"type":"structure","required":["RoleARN","DomainARN","IndexName","TypeName","S3Configuration"],"members":{"RoleARN":{},"DomainARN":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S1c"},"RetryOptions":{"shape":"S1f"},"S3BackupMode":{},"S3Configuration":{"shape":"S7"},"ProcessingConfiguration":{"shape":"Sn"},"CloudWatchLoggingOptions":{"shape":"Si"}}},"SplunkDestinationConfiguration":{"type":"structure","required":["HECEndpoint","HECEndpointType","HECToken","S3Configuration"],"members":{"HECEndpoint":{},"HECEndpointType":{},"HECToken":{},"HECAcknowledgmentTimeoutInSeconds":{"type":"integer"},"RetryOptions":{"shape":"S1n"},"S3BackupMode":{},"S3Configuration":{"shape":"S7"},"ProcessingConfiguration":{"shape":"Sn"},"CloudWatchLoggingOptions":{"shape":"Si"}}}}},"output":{"type":"structure","members":{"DeliveryStreamARN":{}}}},"DeleteDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{}}},"output":{"type":"structure","members":{}}},"DescribeDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"Limit":{"type":"integer"},"ExclusiveStartDestinationId":{}}},"output":{"type":"structure","required":["DeliveryStreamDescription"],"members":{"DeliveryStreamDescription":{"type":"structure","required":["DeliveryStreamName","DeliveryStreamARN","DeliveryStreamStatus","DeliveryStreamType","VersionId","Destinations","HasMoreDestinations"],"members":{"DeliveryStreamName":{},"DeliveryStreamARN":{},"DeliveryStreamStatus":{},"DeliveryStreamType":{},"VersionId":{},"CreateTimestamp":{"type":"timestamp"},"LastUpdateTimestamp":{"type":"timestamp"},"Source":{"type":"structure","members":{"KinesisStreamSourceDescription":{"type":"structure","members":{"KinesisStreamARN":{},"RoleARN":{},"DeliveryStartTimestamp":{"type":"timestamp"}}}}},"Destinations":{"type":"list","member":{"type":"structure","required":["DestinationId"],"members":{"DestinationId":{},"S3DestinationDescription":{"shape":"S27"},"ExtendedS3DestinationDescription":{"type":"structure","required":["RoleARN","BucketARN","BufferingHints","CompressionFormat","EncryptionConfiguration"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"BufferingHints":{"shape":"Sa"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Se"},"CloudWatchLoggingOptions":{"shape":"Si"},"ProcessingConfiguration":{"shape":"Sn"},"S3BackupMode":{},"S3BackupDescription":{"shape":"S27"}}},"RedshiftDestinationDescription":{"type":"structure","required":["RoleARN","ClusterJDBCURL","CopyCommand","Username","S3DestinationDescription"],"members":{"RoleARN":{},"ClusterJDBCURL":{},"CopyCommand":{"shape":"Sy"},"Username":{"shape":"S12"},"RetryOptions":{"shape":"S14"},"S3DestinationDescription":{"shape":"S27"},"ProcessingConfiguration":{"shape":"Sn"},"S3BackupMode":{},"S3BackupDescription":{"shape":"S27"},"CloudWatchLoggingOptions":{"shape":"Si"}}},"ElasticsearchDestinationDescription":{"type":"structure","members":{"RoleARN":{},"DomainARN":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S1c"},"RetryOptions":{"shape":"S1f"},"S3BackupMode":{},"S3DestinationDescription":{"shape":"S27"},"ProcessingConfiguration":{"shape":"Sn"},"CloudWatchLoggingOptions":{"shape":"Si"}}},"SplunkDestinationDescription":{"type":"structure","members":{"HECEndpoint":{},"HECEndpointType":{},"HECToken":{},"HECAcknowledgmentTimeoutInSeconds":{"type":"integer"},"RetryOptions":{"shape":"S1n"},"S3BackupMode":{},"S3DestinationDescription":{"shape":"S27"},"ProcessingConfiguration":{"shape":"Sn"},"CloudWatchLoggingOptions":{"shape":"Si"}}}}}},"HasMoreDestinations":{"type":"boolean"}}}}}},"ListDeliveryStreams":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"DeliveryStreamType":{},"ExclusiveStartDeliveryStreamName":{}}},"output":{"type":"structure","required":["DeliveryStreamNames","HasMoreDeliveryStreams"],"members":{"DeliveryStreamNames":{"type":"list","member":{}},"HasMoreDeliveryStreams":{"type":"boolean"}}}},"PutRecord":{"input":{"type":"structure","required":["DeliveryStreamName","Record"],"members":{"DeliveryStreamName":{},"Record":{"shape":"S2h"}}},"output":{"type":"structure","required":["RecordId"],"members":{"RecordId":{}}}},"PutRecordBatch":{"input":{"type":"structure","required":["DeliveryStreamName","Records"],"members":{"DeliveryStreamName":{},"Records":{"type":"list","member":{"shape":"S2h"}}}},"output":{"type":"structure","required":["FailedPutCount","RequestResponses"],"members":{"FailedPutCount":{"type":"integer"},"RequestResponses":{"type":"list","member":{"type":"structure","members":{"RecordId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"UpdateDestination":{"input":{"type":"structure","required":["DeliveryStreamName","CurrentDeliveryStreamVersionId","DestinationId"],"members":{"DeliveryStreamName":{},"CurrentDeliveryStreamVersionId":{},"DestinationId":{},"S3DestinationUpdate":{"shape":"S2u","deprecated":true},"ExtendedS3DestinationUpdate":{"type":"structure","members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"BufferingHints":{"shape":"Sa"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Se"},"CloudWatchLoggingOptions":{"shape":"Si"},"ProcessingConfiguration":{"shape":"Sn"},"S3BackupMode":{},"S3BackupUpdate":{"shape":"S2u"}}},"RedshiftDestinationUpdate":{"type":"structure","members":{"RoleARN":{},"ClusterJDBCURL":{},"CopyCommand":{"shape":"Sy"},"Username":{"shape":"S12"},"Password":{"shape":"S13"},"RetryOptions":{"shape":"S14"},"S3Update":{"shape":"S2u"},"ProcessingConfiguration":{"shape":"Sn"},"S3BackupMode":{},"S3BackupUpdate":{"shape":"S2u"},"CloudWatchLoggingOptions":{"shape":"Si"}}},"ElasticsearchDestinationUpdate":{"type":"structure","members":{"RoleARN":{},"DomainARN":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S1c"},"RetryOptions":{"shape":"S1f"},"S3Update":{"shape":"S2u"},"ProcessingConfiguration":{"shape":"Sn"},"CloudWatchLoggingOptions":{"shape":"Si"}}},"SplunkDestinationUpdate":{"type":"structure","members":{"HECEndpoint":{},"HECEndpointType":{},"HECToken":{},"HECAcknowledgmentTimeoutInSeconds":{"type":"integer"},"RetryOptions":{"shape":"S1n"},"S3BackupMode":{},"S3Update":{"shape":"S2u"},"ProcessingConfiguration":{"shape":"Sn"},"CloudWatchLoggingOptions":{"shape":"Si"}}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S7":{"type":"structure","required":["RoleARN","BucketARN"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"BufferingHints":{"shape":"Sa"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Se"},"CloudWatchLoggingOptions":{"shape":"Si"}}},"Sa":{"type":"structure","members":{"SizeInMBs":{"type":"integer"},"IntervalInSeconds":{"type":"integer"}}},"Se":{"type":"structure","members":{"NoEncryptionConfig":{},"KMSEncryptionConfig":{"type":"structure","required":["AWSKMSKeyARN"],"members":{"AWSKMSKeyARN":{}}}}},"Si":{"type":"structure","members":{"Enabled":{"type":"boolean"},"LogGroupName":{},"LogStreamName":{}}},"Sn":{"type":"structure","members":{"Enabled":{"type":"boolean"},"Processors":{"type":"list","member":{"type":"structure","required":["Type"],"members":{"Type":{},"Parameters":{"type":"list","member":{"type":"structure","required":["ParameterName","ParameterValue"],"members":{"ParameterName":{},"ParameterValue":{}}}}}}}}},"Sy":{"type":"structure","required":["DataTableName"],"members":{"DataTableName":{},"DataTableColumns":{},"CopyOptions":{}}},"S12":{"type":"string","sensitive":true},"S13":{"type":"string","sensitive":true},"S14":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S1c":{"type":"structure","members":{"IntervalInSeconds":{"type":"integer"},"SizeInMBs":{"type":"integer"}}},"S1f":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S1n":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S27":{"type":"structure","required":["RoleARN","BucketARN","BufferingHints","CompressionFormat","EncryptionConfiguration"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"BufferingHints":{"shape":"Sa"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Se"},"CloudWatchLoggingOptions":{"shape":"Si"}}},"S2h":{"type":"structure","required":["Data"],"members":{"Data":{"type":"blob"}}},"S2u":{"type":"structure","members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"BufferingHints":{"shape":"Sa"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Se"},"CloudWatchLoggingOptions":{"shape":"Si"}}}}}

/***/ }),
/* 2851 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 2852 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['gamelift'] = {};
AWS.GameLift = Service.defineService('gamelift', ['2015-10-01']);
Object.defineProperty(apiLoader.services['gamelift'], '2015-10-01', {
  get: function get() {
    var model = __webpack_require__(2853);
    model.paginators = __webpack_require__(2854).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.GameLift;


/***/ }),
/* 2853 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-10-01","endpointPrefix":"gamelift","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon GameLift","signatureVersion":"v4","targetPrefix":"GameLift","uid":"gamelift-2015-10-01"},"operations":{"AcceptMatch":{"input":{"type":"structure","required":["TicketId","PlayerIds","AcceptanceType"],"members":{"TicketId":{},"PlayerIds":{"shape":"S3"},"AcceptanceType":{}}},"output":{"type":"structure","members":{}}},"CreateAlias":{"input":{"type":"structure","required":["Name","RoutingStrategy"],"members":{"Name":{},"Description":{},"RoutingStrategy":{"shape":"S9"}}},"output":{"type":"structure","members":{"Alias":{"shape":"Se"}}}},"CreateBuild":{"input":{"type":"structure","members":{"Name":{},"Version":{},"StorageLocation":{"shape":"Sj"},"OperatingSystem":{}}},"output":{"type":"structure","members":{"Build":{"shape":"Sn"},"UploadCredentials":{"shape":"Sr"},"StorageLocation":{"shape":"Sj"}}}},"CreateFleet":{"input":{"type":"structure","required":["Name","BuildId","EC2InstanceType"],"members":{"Name":{},"Description":{},"BuildId":{},"ServerLaunchPath":{},"ServerLaunchParameters":{},"LogPaths":{"shape":"S3"},"EC2InstanceType":{},"EC2InboundPermissions":{"shape":"Su"},"NewGameSessionProtectionPolicy":{},"RuntimeConfiguration":{"shape":"S10"},"ResourceCreationLimitPolicy":{"shape":"S16"},"MetricGroups":{"shape":"S18"},"PeerVpcAwsAccountId":{},"PeerVpcId":{},"FleetType":{}}},"output":{"type":"structure","members":{"FleetAttributes":{"shape":"S1c"}}}},"CreateGameSession":{"input":{"type":"structure","required":["MaximumPlayerSessionCount"],"members":{"FleetId":{},"AliasId":{},"MaximumPlayerSessionCount":{"type":"integer"},"Name":{},"GameProperties":{"shape":"S1f"},"CreatorId":{},"GameSessionId":{},"IdempotencyToken":{},"GameSessionData":{}}},"output":{"type":"structure","members":{"GameSession":{"shape":"S1m"}}}},"CreateGameSessionQueue":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"TimeoutInSeconds":{"type":"integer"},"PlayerLatencyPolicies":{"shape":"S1u"},"Destinations":{"shape":"S1w"}}},"output":{"type":"structure","members":{"GameSessionQueue":{"shape":"S1z"}}}},"CreateMatchmakingConfiguration":{"input":{"type":"structure","required":["Name","GameSessionQueueArns","RequestTimeoutSeconds","AcceptanceRequired","RuleSetName"],"members":{"Name":{},"Description":{},"GameSessionQueueArns":{"shape":"S21"},"RequestTimeoutSeconds":{"type":"integer"},"AcceptanceTimeoutSeconds":{"type":"integer"},"AcceptanceRequired":{"type":"boolean"},"RuleSetName":{},"NotificationTarget":{},"AdditionalPlayerCount":{"type":"integer"},"CustomEventData":{},"GameProperties":{"shape":"S1f"},"GameSessionData":{}}},"output":{"type":"structure","members":{"Configuration":{"shape":"S28"}}}},"CreateMatchmakingRuleSet":{"input":{"type":"structure","required":["Name","RuleSetBody"],"members":{"Name":{},"RuleSetBody":{}}},"output":{"type":"structure","required":["RuleSet"],"members":{"RuleSet":{"shape":"S2c"}}}},"CreatePlayerSession":{"input":{"type":"structure","required":["GameSessionId","PlayerId"],"members":{"GameSessionId":{},"PlayerId":{},"PlayerData":{}}},"output":{"type":"structure","members":{"PlayerSession":{"shape":"S2g"}}}},"CreatePlayerSessions":{"input":{"type":"structure","required":["GameSessionId","PlayerIds"],"members":{"GameSessionId":{},"PlayerIds":{"type":"list","member":{}},"PlayerDataMap":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"PlayerSessions":{"shape":"S2n"}}}},"CreateVpcPeeringAuthorization":{"input":{"type":"structure","required":["GameLiftAwsAccountId","PeerVpcId"],"members":{"GameLiftAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{"VpcPeeringAuthorization":{"shape":"S2q"}}}},"CreateVpcPeeringConnection":{"input":{"type":"structure","required":["FleetId","PeerVpcAwsAccountId","PeerVpcId"],"members":{"FleetId":{},"PeerVpcAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{}}},"DeleteAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}}},"DeleteBuild":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{}}}},"DeleteFleet":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{}}}},"DeleteGameSessionQueue":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteMatchmakingConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteScalingPolicy":{"input":{"type":"structure","required":["Name","FleetId"],"members":{"Name":{},"FleetId":{}}}},"DeleteVpcPeeringAuthorization":{"input":{"type":"structure","required":["GameLiftAwsAccountId","PeerVpcId"],"members":{"GameLiftAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{}}},"DeleteVpcPeeringConnection":{"input":{"type":"structure","required":["FleetId","VpcPeeringConnectionId"],"members":{"FleetId":{},"VpcPeeringConnectionId":{}}},"output":{"type":"structure","members":{}}},"DescribeAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}},"output":{"type":"structure","members":{"Alias":{"shape":"Se"}}}},"DescribeBuild":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{}}},"output":{"type":"structure","members":{"Build":{"shape":"Sn"}}}},"DescribeEC2InstanceLimits":{"input":{"type":"structure","members":{"EC2InstanceType":{}}},"output":{"type":"structure","members":{"EC2InstanceLimits":{"type":"list","member":{"type":"structure","members":{"EC2InstanceType":{},"CurrentInstances":{"type":"integer"},"InstanceLimit":{"type":"integer"}}}}}}},"DescribeFleetAttributes":{"input":{"type":"structure","members":{"FleetIds":{"shape":"S3e"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetAttributes":{"type":"list","member":{"shape":"S1c"}},"NextToken":{}}}},"DescribeFleetCapacity":{"input":{"type":"structure","members":{"FleetIds":{"shape":"S3e"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetCapacity":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"InstanceType":{},"InstanceCounts":{"type":"structure","members":{"DESIRED":{"type":"integer"},"MINIMUM":{"type":"integer"},"MAXIMUM":{"type":"integer"},"PENDING":{"type":"integer"},"ACTIVE":{"type":"integer"},"IDLE":{"type":"integer"},"TERMINATING":{"type":"integer"}}}}}},"NextToken":{}}}},"DescribeFleetEvents":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Events":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ResourceId":{},"EventCode":{},"Message":{},"EventTime":{"type":"timestamp"},"PreSignedLogUrl":{}}}},"NextToken":{}}}},"DescribeFleetPortSettings":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{}}},"output":{"type":"structure","members":{"InboundPermissions":{"shape":"Su"}}}},"DescribeFleetUtilization":{"input":{"type":"structure","members":{"FleetIds":{"shape":"S3e"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetUtilization":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"ActiveServerProcessCount":{"type":"integer"},"ActiveGameSessionCount":{"type":"integer"},"CurrentPlayerSessionCount":{"type":"integer"},"MaximumPlayerSessionCount":{"type":"integer"}}}},"NextToken":{}}}},"DescribeGameSessionDetails":{"input":{"type":"structure","members":{"FleetId":{},"GameSessionId":{},"AliasId":{},"StatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessionDetails":{"type":"list","member":{"type":"structure","members":{"GameSession":{"shape":"S1m"},"ProtectionPolicy":{}}}},"NextToken":{}}}},"DescribeGameSessionPlacement":{"input":{"type":"structure","required":["PlacementId"],"members":{"PlacementId":{}}},"output":{"type":"structure","members":{"GameSessionPlacement":{"shape":"S43"}}}},"DescribeGameSessionQueues":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessionQueues":{"type":"list","member":{"shape":"S1z"}},"NextToken":{}}}},"DescribeGameSessions":{"input":{"type":"structure","members":{"FleetId":{},"GameSessionId":{},"AliasId":{},"StatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessions":{"shape":"S4g"},"NextToken":{}}}},"DescribeInstances":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"InstanceId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"InstanceId":{},"IpAddress":{},"OperatingSystem":{},"Type":{},"Status":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMatchmaking":{"input":{"type":"structure","required":["TicketIds"],"members":{"TicketIds":{"shape":"S4o"}}},"output":{"type":"structure","members":{"TicketList":{"type":"list","member":{"shape":"S4r"}}}}},"DescribeMatchmakingConfigurations":{"input":{"type":"structure","members":{"Names":{"shape":"S4o"},"RuleSetName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Configurations":{"type":"list","member":{"shape":"S28"}},"NextToken":{}}}},"DescribeMatchmakingRuleSets":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["RuleSets"],"members":{"RuleSets":{"type":"list","member":{"shape":"S2c"}},"NextToken":{}}}},"DescribePlayerSessions":{"input":{"type":"structure","members":{"GameSessionId":{},"PlayerId":{},"PlayerSessionId":{},"PlayerSessionStatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"PlayerSessions":{"shape":"S2n"},"NextToken":{}}}},"DescribeRuntimeConfiguration":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{}}},"output":{"type":"structure","members":{"RuntimeConfiguration":{"shape":"S10"}}}},"DescribeScalingPolicies":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"StatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingPolicies":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"Name":{},"Status":{},"ScalingAdjustment":{"type":"integer"},"ScalingAdjustmentType":{},"ComparisonOperator":{},"Threshold":{"type":"double"},"EvaluationPeriods":{"type":"integer"},"MetricName":{}}}},"NextToken":{}}}},"DescribeVpcPeeringAuthorizations":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"VpcPeeringAuthorizations":{"type":"list","member":{"shape":"S2q"}}}}},"DescribeVpcPeeringConnections":{"input":{"type":"structure","members":{"FleetId":{}}},"output":{"type":"structure","members":{"VpcPeeringConnections":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"IpV4CidrBlock":{},"VpcPeeringConnectionId":{},"Status":{"type":"structure","members":{"Code":{},"Message":{}}},"PeerVpcId":{},"GameLiftVpcId":{}}}}}}},"GetGameSessionLogUrl":{"input":{"type":"structure","required":["GameSessionId"],"members":{"GameSessionId":{}}},"output":{"type":"structure","members":{"PreSignedUrl":{}}}},"GetInstanceAccess":{"input":{"type":"structure","required":["FleetId","InstanceId"],"members":{"FleetId":{},"InstanceId":{}}},"output":{"type":"structure","members":{"InstanceAccess":{"type":"structure","members":{"FleetId":{},"InstanceId":{},"IpAddress":{},"OperatingSystem":{},"Credentials":{"type":"structure","members":{"UserName":{},"Secret":{}},"sensitive":true}}}}}},"ListAliases":{"input":{"type":"structure","members":{"RoutingStrategyType":{},"Name":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Aliases":{"type":"list","member":{"shape":"Se"}},"NextToken":{}}}},"ListBuilds":{"input":{"type":"structure","members":{"Status":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Builds":{"type":"list","member":{"shape":"Sn"}},"NextToken":{}}}},"ListFleets":{"input":{"type":"structure","members":{"BuildId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetIds":{"shape":"S3e"},"NextToken":{}}}},"PutScalingPolicy":{"input":{"type":"structure","required":["Name","FleetId","ScalingAdjustment","ScalingAdjustmentType","Threshold","ComparisonOperator","EvaluationPeriods","MetricName"],"members":{"Name":{},"FleetId":{},"ScalingAdjustment":{"type":"integer"},"ScalingAdjustmentType":{},"Threshold":{"type":"double"},"ComparisonOperator":{},"EvaluationPeriods":{"type":"integer"},"MetricName":{}}},"output":{"type":"structure","members":{"Name":{}}}},"RequestUploadCredentials":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{}}},"output":{"type":"structure","members":{"UploadCredentials":{"shape":"Sr"},"StorageLocation":{"shape":"Sj"}}}},"ResolveAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}},"output":{"type":"structure","members":{"FleetId":{}}}},"SearchGameSessions":{"input":{"type":"structure","members":{"FleetId":{},"AliasId":{},"FilterExpression":{},"SortExpression":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessions":{"shape":"S4g"},"NextToken":{}}}},"StartGameSessionPlacement":{"input":{"type":"structure","required":["PlacementId","GameSessionQueueName","MaximumPlayerSessionCount"],"members":{"PlacementId":{},"GameSessionQueueName":{},"GameProperties":{"shape":"S1f"},"MaximumPlayerSessionCount":{"type":"integer"},"GameSessionName":{},"PlayerLatencies":{"shape":"S45"},"DesiredPlayerSessions":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerData":{}}}},"GameSessionData":{}}},"output":{"type":"structure","members":{"GameSessionPlacement":{"shape":"S43"}}}},"StartMatchBackfill":{"input":{"type":"structure","required":["ConfigurationName","GameSessionArn","Players"],"members":{"TicketId":{},"ConfigurationName":{},"GameSessionArn":{},"Players":{"shape":"S4u"}}},"output":{"type":"structure","members":{"MatchmakingTicket":{"shape":"S4r"}}}},"StartMatchmaking":{"input":{"type":"structure","required":["ConfigurationName","Players"],"members":{"TicketId":{},"ConfigurationName":{},"Players":{"shape":"S4u"}}},"output":{"type":"structure","members":{"MatchmakingTicket":{"shape":"S4r"}}}},"StopGameSessionPlacement":{"input":{"type":"structure","required":["PlacementId"],"members":{"PlacementId":{}}},"output":{"type":"structure","members":{"GameSessionPlacement":{"shape":"S43"}}}},"StopMatchmaking":{"input":{"type":"structure","required":["TicketId"],"members":{"TicketId":{}}},"output":{"type":"structure","members":{}}},"UpdateAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{},"Name":{},"Description":{},"RoutingStrategy":{"shape":"S9"}}},"output":{"type":"structure","members":{"Alias":{"shape":"Se"}}}},"UpdateBuild":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{},"Name":{},"Version":{}}},"output":{"type":"structure","members":{"Build":{"shape":"Sn"}}}},"UpdateFleetAttributes":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"Name":{},"Description":{},"NewGameSessionProtectionPolicy":{},"ResourceCreationLimitPolicy":{"shape":"S16"},"MetricGroups":{"shape":"S18"}}},"output":{"type":"structure","members":{"FleetId":{}}}},"UpdateFleetCapacity":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"DesiredInstances":{"type":"integer"},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"}}},"output":{"type":"structure","members":{"FleetId":{}}}},"UpdateFleetPortSettings":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"InboundPermissionAuthorizations":{"shape":"Su"},"InboundPermissionRevocations":{"shape":"Su"}}},"output":{"type":"structure","members":{"FleetId":{}}}},"UpdateGameSession":{"input":{"type":"structure","required":["GameSessionId"],"members":{"GameSessionId":{},"MaximumPlayerSessionCount":{"type":"integer"},"Name":{},"PlayerSessionCreationPolicy":{},"ProtectionPolicy":{}}},"output":{"type":"structure","members":{"GameSession":{"shape":"S1m"}}}},"UpdateGameSessionQueue":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"TimeoutInSeconds":{"type":"integer"},"PlayerLatencyPolicies":{"shape":"S1u"},"Destinations":{"shape":"S1w"}}},"output":{"type":"structure","members":{"GameSessionQueue":{"shape":"S1z"}}}},"UpdateMatchmakingConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"GameSessionQueueArns":{"shape":"S21"},"RequestTimeoutSeconds":{"type":"integer"},"AcceptanceTimeoutSeconds":{"type":"integer"},"AcceptanceRequired":{"type":"boolean"},"RuleSetName":{},"NotificationTarget":{},"AdditionalPlayerCount":{"type":"integer"},"CustomEventData":{},"GameProperties":{"shape":"S1f"},"GameSessionData":{}}},"output":{"type":"structure","members":{"Configuration":{"shape":"S28"}}}},"UpdateRuntimeConfiguration":{"input":{"type":"structure","required":["FleetId","RuntimeConfiguration"],"members":{"FleetId":{},"RuntimeConfiguration":{"shape":"S10"}}},"output":{"type":"structure","members":{"RuntimeConfiguration":{"shape":"S10"}}}},"ValidateMatchmakingRuleSet":{"input":{"type":"structure","required":["RuleSetBody"],"members":{"RuleSetBody":{}}},"output":{"type":"structure","members":{"Valid":{"type":"boolean"}}}}},"shapes":{"S3":{"type":"list","member":{}},"S9":{"type":"structure","members":{"Type":{},"FleetId":{},"Message":{}}},"Se":{"type":"structure","members":{"AliasId":{},"Name":{},"AliasArn":{},"Description":{},"RoutingStrategy":{"shape":"S9"},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}},"Sj":{"type":"structure","members":{"Bucket":{},"Key":{},"RoleArn":{}}},"Sn":{"type":"structure","members":{"BuildId":{},"Name":{},"Version":{},"Status":{},"SizeOnDisk":{"type":"long"},"OperatingSystem":{},"CreationTime":{"type":"timestamp"}}},"Sr":{"type":"structure","members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{}},"sensitive":true},"Su":{"type":"list","member":{"type":"structure","required":["FromPort","ToPort","IpRange","Protocol"],"members":{"FromPort":{"type":"integer"},"ToPort":{"type":"integer"},"IpRange":{},"Protocol":{}}}},"S10":{"type":"structure","members":{"ServerProcesses":{"type":"list","member":{"type":"structure","required":["LaunchPath","ConcurrentExecutions"],"members":{"LaunchPath":{},"Parameters":{},"ConcurrentExecutions":{"type":"integer"}}}},"MaxConcurrentGameSessionActivations":{"type":"integer"},"GameSessionActivationTimeoutSeconds":{"type":"integer"}}},"S16":{"type":"structure","members":{"NewGameSessionsPerCreator":{"type":"integer"},"PolicyPeriodInMinutes":{"type":"integer"}}},"S18":{"type":"list","member":{}},"S1c":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"FleetType":{},"InstanceType":{},"Description":{},"Name":{},"CreationTime":{"type":"timestamp"},"TerminationTime":{"type":"timestamp"},"Status":{},"BuildId":{},"ServerLaunchPath":{},"ServerLaunchParameters":{},"LogPaths":{"shape":"S3"},"NewGameSessionProtectionPolicy":{},"OperatingSystem":{},"ResourceCreationLimitPolicy":{"shape":"S16"},"MetricGroups":{"shape":"S18"}}},"S1f":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S1m":{"type":"structure","members":{"GameSessionId":{},"Name":{},"FleetId":{},"CreationTime":{"type":"timestamp"},"TerminationTime":{"type":"timestamp"},"CurrentPlayerSessionCount":{"type":"integer"},"MaximumPlayerSessionCount":{"type":"integer"},"Status":{},"StatusReason":{},"GameProperties":{"shape":"S1f"},"IpAddress":{},"Port":{"type":"integer"},"PlayerSessionCreationPolicy":{},"CreatorId":{},"GameSessionData":{},"MatchmakerData":{}}},"S1u":{"type":"list","member":{"type":"structure","members":{"MaximumIndividualPlayerLatencyMilliseconds":{"type":"integer"},"PolicyDurationSeconds":{"type":"integer"}}}},"S1w":{"type":"list","member":{"type":"structure","members":{"DestinationArn":{}}}},"S1z":{"type":"structure","members":{"Name":{},"GameSessionQueueArn":{},"TimeoutInSeconds":{"type":"integer"},"PlayerLatencyPolicies":{"shape":"S1u"},"Destinations":{"shape":"S1w"}}},"S21":{"type":"list","member":{}},"S28":{"type":"structure","members":{"Name":{},"Description":{},"GameSessionQueueArns":{"shape":"S21"},"RequestTimeoutSeconds":{"type":"integer"},"AcceptanceTimeoutSeconds":{"type":"integer"},"AcceptanceRequired":{"type":"boolean"},"RuleSetName":{},"NotificationTarget":{},"AdditionalPlayerCount":{"type":"integer"},"CustomEventData":{},"CreationTime":{"type":"timestamp"},"GameProperties":{"shape":"S1f"},"GameSessionData":{}}},"S2c":{"type":"structure","required":["RuleSetBody"],"members":{"RuleSetName":{},"RuleSetBody":{},"CreationTime":{"type":"timestamp"}}},"S2g":{"type":"structure","members":{"PlayerSessionId":{},"PlayerId":{},"GameSessionId":{},"FleetId":{},"CreationTime":{"type":"timestamp"},"TerminationTime":{"type":"timestamp"},"Status":{},"IpAddress":{},"Port":{"type":"integer"},"PlayerData":{}}},"S2n":{"type":"list","member":{"shape":"S2g"}},"S2q":{"type":"structure","members":{"GameLiftAwsAccountId":{},"PeerVpcAwsAccountId":{},"PeerVpcId":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"}}},"S3e":{"type":"list","member":{}},"S43":{"type":"structure","members":{"PlacementId":{},"GameSessionQueueName":{},"Status":{},"GameProperties":{"shape":"S1f"},"MaximumPlayerSessionCount":{"type":"integer"},"GameSessionName":{},"GameSessionId":{},"GameSessionArn":{},"GameSessionRegion":{},"PlayerLatencies":{"shape":"S45"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"IpAddress":{},"Port":{"type":"integer"},"PlacedPlayerSessions":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerSessionId":{}}}},"GameSessionData":{},"MatchmakerData":{}}},"S45":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"RegionIdentifier":{},"LatencyInMilliseconds":{"type":"float"}}}},"S4g":{"type":"list","member":{"shape":"S1m"}},"S4o":{"type":"list","member":{}},"S4r":{"type":"structure","members":{"TicketId":{},"ConfigurationName":{},"Status":{},"StatusReason":{},"StatusMessage":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Players":{"shape":"S4u"},"GameSessionConnectionInfo":{"type":"structure","members":{"GameSessionArn":{},"IpAddress":{},"Port":{"type":"integer"},"MatchedPlayerSessions":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerSessionId":{}}}}}},"EstimatedWaitTime":{"type":"integer"}}},"S4u":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerAttributes":{"type":"map","key":{},"value":{"type":"structure","members":{"S":{},"N":{"type":"double"},"SL":{"shape":"S3"},"SDM":{"type":"map","key":{},"value":{"type":"double"}}}}},"Team":{},"LatencyInMs":{"type":"map","key":{},"value":{"type":"integer"}}}}}}}

/***/ }),
/* 2854 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 2855 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['inspector'] = {};
AWS.Inspector = Service.defineService('inspector', ['2015-08-18*', '2016-02-16']);
Object.defineProperty(apiLoader.services['inspector'], '2016-02-16', {
  get: function get() {
    var model = __webpack_require__(2856);
    model.paginators = __webpack_require__(2857).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Inspector;


/***/ }),
/* 2856 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-02-16","endpointPrefix":"inspector","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Inspector","signatureVersion":"v4","targetPrefix":"InspectorService","uid":"inspector-2016-02-16"},"operations":{"AddAttributesToFindings":{"input":{"type":"structure","required":["findingArns","attributes"],"members":{"findingArns":{"shape":"S2"},"attributes":{"shape":"S4"}}},"output":{"type":"structure","required":["failedItems"],"members":{"failedItems":{"shape":"S9"}}}},"CreateAssessmentTarget":{"input":{"type":"structure","required":["assessmentTargetName","resourceGroupArn"],"members":{"assessmentTargetName":{},"resourceGroupArn":{}}},"output":{"type":"structure","required":["assessmentTargetArn"],"members":{"assessmentTargetArn":{}}}},"CreateAssessmentTemplate":{"input":{"type":"structure","required":["assessmentTargetArn","assessmentTemplateName","durationInSeconds","rulesPackageArns"],"members":{"assessmentTargetArn":{},"assessmentTemplateName":{},"durationInSeconds":{"type":"integer"},"rulesPackageArns":{"shape":"Sj"},"userAttributesForFindings":{"shape":"S4"}}},"output":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{}}}},"CreateResourceGroup":{"input":{"type":"structure","required":["resourceGroupTags"],"members":{"resourceGroupTags":{"shape":"Sm"}}},"output":{"type":"structure","required":["resourceGroupArn"],"members":{"resourceGroupArn":{}}}},"DeleteAssessmentRun":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{}}}},"DeleteAssessmentTarget":{"input":{"type":"structure","required":["assessmentTargetArn"],"members":{"assessmentTargetArn":{}}}},"DeleteAssessmentTemplate":{"input":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{}}}},"DescribeAssessmentRuns":{"input":{"type":"structure","required":["assessmentRunArns"],"members":{"assessmentRunArns":{"shape":"Sv"}}},"output":{"type":"structure","required":["assessmentRuns","failedItems"],"members":{"assessmentRuns":{"type":"list","member":{"type":"structure","required":["arn","name","assessmentTemplateArn","state","durationInSeconds","rulesPackageArns","userAttributesForFindings","createdAt","stateChangedAt","dataCollected","stateChanges","notifications","findingCounts"],"members":{"arn":{},"name":{},"assessmentTemplateArn":{},"state":{},"durationInSeconds":{"type":"integer"},"rulesPackageArns":{"type":"list","member":{}},"userAttributesForFindings":{"shape":"S4"},"createdAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"completedAt":{"type":"timestamp"},"stateChangedAt":{"type":"timestamp"},"dataCollected":{"type":"boolean"},"stateChanges":{"type":"list","member":{"type":"structure","required":["stateChangedAt","state"],"members":{"stateChangedAt":{"type":"timestamp"},"state":{}}}},"notifications":{"type":"list","member":{"type":"structure","required":["date","event","error"],"members":{"date":{"type":"timestamp"},"event":{},"message":{},"error":{"type":"boolean"},"snsTopicArn":{},"snsPublishStatusCode":{}}}},"findingCounts":{"type":"map","key":{},"value":{"type":"integer"}}}}},"failedItems":{"shape":"S9"}}}},"DescribeAssessmentTargets":{"input":{"type":"structure","required":["assessmentTargetArns"],"members":{"assessmentTargetArns":{"shape":"Sv"}}},"output":{"type":"structure","required":["assessmentTargets","failedItems"],"members":{"assessmentTargets":{"type":"list","member":{"type":"structure","required":["arn","name","resourceGroupArn","createdAt","updatedAt"],"members":{"arn":{},"name":{},"resourceGroupArn":{},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeAssessmentTemplates":{"input":{"type":"structure","required":["assessmentTemplateArns"],"members":{"assessmentTemplateArns":{"shape":"Sv"}}},"output":{"type":"structure","required":["assessmentTemplates","failedItems"],"members":{"assessmentTemplates":{"type":"list","member":{"type":"structure","required":["arn","name","assessmentTargetArn","durationInSeconds","rulesPackageArns","userAttributesForFindings","assessmentRunCount","createdAt"],"members":{"arn":{},"name":{},"assessmentTargetArn":{},"durationInSeconds":{"type":"integer"},"rulesPackageArns":{"shape":"Sj"},"userAttributesForFindings":{"shape":"S4"},"lastAssessmentRunArn":{},"assessmentRunCount":{"type":"integer"},"createdAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeCrossAccountAccessRole":{"output":{"type":"structure","required":["roleArn","valid","registeredAt"],"members":{"roleArn":{},"valid":{"type":"boolean"},"registeredAt":{"type":"timestamp"}}}},"DescribeFindings":{"input":{"type":"structure","required":["findingArns"],"members":{"findingArns":{"shape":"Sv"},"locale":{}}},"output":{"type":"structure","required":["findings","failedItems"],"members":{"findings":{"type":"list","member":{"type":"structure","required":["arn","attributes","userAttributes","createdAt","updatedAt"],"members":{"arn":{},"schemaVersion":{"type":"integer"},"service":{},"serviceAttributes":{"type":"structure","required":["schemaVersion"],"members":{"schemaVersion":{"type":"integer"},"assessmentRunArn":{},"rulesPackageArn":{}}},"assetType":{},"assetAttributes":{"type":"structure","required":["schemaVersion"],"members":{"schemaVersion":{"type":"integer"},"agentId":{},"autoScalingGroup":{},"amiId":{},"hostname":{},"ipv4Addresses":{"type":"list","member":{}}}},"id":{},"title":{},"description":{},"recommendation":{},"severity":{},"numericSeverity":{"type":"double"},"confidence":{"type":"integer"},"indicatorOfCompromise":{"type":"boolean"},"attributes":{"shape":"S27"},"userAttributes":{"shape":"S4"},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeResourceGroups":{"input":{"type":"structure","required":["resourceGroupArns"],"members":{"resourceGroupArns":{"shape":"Sv"}}},"output":{"type":"structure","required":["resourceGroups","failedItems"],"members":{"resourceGroups":{"type":"list","member":{"type":"structure","required":["arn","tags","createdAt"],"members":{"arn":{},"tags":{"shape":"Sm"},"createdAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeRulesPackages":{"input":{"type":"structure","required":["rulesPackageArns"],"members":{"rulesPackageArns":{"shape":"Sv"},"locale":{}}},"output":{"type":"structure","required":["rulesPackages","failedItems"],"members":{"rulesPackages":{"type":"list","member":{"type":"structure","required":["arn","name","version","provider"],"members":{"arn":{},"name":{},"version":{},"provider":{},"description":{}}}},"failedItems":{"shape":"S9"}}}},"GetAssessmentReport":{"input":{"type":"structure","required":["assessmentRunArn","reportFileFormat","reportType"],"members":{"assessmentRunArn":{},"reportFileFormat":{},"reportType":{}}},"output":{"type":"structure","required":["status"],"members":{"status":{},"url":{}}}},"GetTelemetryMetadata":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{}}},"output":{"type":"structure","required":["telemetryMetadata"],"members":{"telemetryMetadata":{"shape":"S2r"}}}},"ListAssessmentRunAgents":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{},"filter":{"type":"structure","required":["agentHealths","agentHealthCodes"],"members":{"agentHealths":{"type":"list","member":{}},"agentHealthCodes":{"type":"list","member":{}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentRunAgents"],"members":{"assessmentRunAgents":{"type":"list","member":{"type":"structure","required":["agentId","assessmentRunArn","agentHealth","agentHealthCode","telemetryMetadata"],"members":{"agentId":{},"assessmentRunArn":{},"agentHealth":{},"agentHealthCode":{},"agentHealthDetails":{},"autoScalingGroup":{},"telemetryMetadata":{"shape":"S2r"}}}},"nextToken":{}}}},"ListAssessmentRuns":{"input":{"type":"structure","members":{"assessmentTemplateArns":{"shape":"S37"},"filter":{"type":"structure","members":{"namePattern":{},"states":{"type":"list","member":{}},"durationRange":{"shape":"S3b"},"rulesPackageArns":{"shape":"S3c"},"startTimeRange":{"shape":"S3d"},"completionTimeRange":{"shape":"S3d"},"stateChangeTimeRange":{"shape":"S3d"}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentRunArns"],"members":{"assessmentRunArns":{"shape":"S3f"},"nextToken":{}}}},"ListAssessmentTargets":{"input":{"type":"structure","members":{"filter":{"type":"structure","members":{"assessmentTargetNamePattern":{}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentTargetArns"],"members":{"assessmentTargetArns":{"shape":"S3f"},"nextToken":{}}}},"ListAssessmentTemplates":{"input":{"type":"structure","members":{"assessmentTargetArns":{"shape":"S37"},"filter":{"type":"structure","members":{"namePattern":{},"durationRange":{"shape":"S3b"},"rulesPackageArns":{"shape":"S3c"}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentTemplateArns"],"members":{"assessmentTemplateArns":{"shape":"S3f"},"nextToken":{}}}},"ListEventSubscriptions":{"input":{"type":"structure","members":{"resourceArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["subscriptions"],"members":{"subscriptions":{"type":"list","member":{"type":"structure","required":["resourceArn","topicArn","eventSubscriptions"],"members":{"resourceArn":{},"topicArn":{},"eventSubscriptions":{"type":"list","member":{"type":"structure","required":["event","subscribedAt"],"members":{"event":{},"subscribedAt":{"type":"timestamp"}}}}}}},"nextToken":{}}}},"ListFindings":{"input":{"type":"structure","members":{"assessmentRunArns":{"shape":"S37"},"filter":{"type":"structure","members":{"agentIds":{"type":"list","member":{}},"autoScalingGroups":{"type":"list","member":{}},"ruleNames":{"type":"list","member":{}},"severities":{"type":"list","member":{}},"rulesPackageArns":{"shape":"S3c"},"attributes":{"shape":"S27"},"userAttributes":{"shape":"S27"},"creationTimeRange":{"shape":"S3d"}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["findingArns"],"members":{"findingArns":{"shape":"S3f"},"nextToken":{}}}},"ListRulesPackages":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["rulesPackageArns"],"members":{"rulesPackageArns":{"shape":"S3f"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","required":["tags"],"members":{"tags":{"shape":"S45"}}}},"PreviewAgents":{"input":{"type":"structure","required":["previewAgentsArn"],"members":{"previewAgentsArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["agentPreviews"],"members":{"agentPreviews":{"type":"list","member":{"type":"structure","required":["agentId"],"members":{"hostname":{},"agentId":{},"autoScalingGroup":{},"agentHealth":{},"agentVersion":{},"operatingSystem":{},"kernelVersion":{},"ipv4Address":{}}}},"nextToken":{}}}},"RegisterCrossAccountAccessRole":{"input":{"type":"structure","required":["roleArn"],"members":{"roleArn":{}}}},"RemoveAttributesFromFindings":{"input":{"type":"structure","required":["findingArns","attributeKeys"],"members":{"findingArns":{"shape":"S2"},"attributeKeys":{"type":"list","member":{}}}},"output":{"type":"structure","required":["failedItems"],"members":{"failedItems":{"shape":"S9"}}}},"SetTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{},"tags":{"shape":"S45"}}}},"StartAssessmentRun":{"input":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{},"assessmentRunName":{}}},"output":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{}}}},"StopAssessmentRun":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{},"stopAction":{}}}},"SubscribeToEvent":{"input":{"type":"structure","required":["resourceArn","event","topicArn"],"members":{"resourceArn":{},"event":{},"topicArn":{}}}},"UnsubscribeFromEvent":{"input":{"type":"structure","required":["resourceArn","event","topicArn"],"members":{"resourceArn":{},"event":{},"topicArn":{}}}},"UpdateAssessmentTarget":{"input":{"type":"structure","required":["assessmentTargetArn","assessmentTargetName","resourceGroupArn"],"members":{"assessmentTargetArn":{},"assessmentTargetName":{},"resourceGroupArn":{}}}}},"shapes":{"S2":{"type":"list","member":{}},"S4":{"type":"list","member":{"shape":"S5"}},"S5":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}},"S9":{"type":"map","key":{},"value":{"type":"structure","required":["failureCode","retryable"],"members":{"failureCode":{},"retryable":{"type":"boolean"}}}},"Sj":{"type":"list","member":{}},"Sm":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}},"Sv":{"type":"list","member":{}},"S27":{"type":"list","member":{"shape":"S5"}},"S2r":{"type":"list","member":{"type":"structure","required":["messageType","count"],"members":{"messageType":{},"count":{"type":"long"},"dataSize":{"type":"long"}}}},"S37":{"type":"list","member":{}},"S3b":{"type":"structure","members":{"minSeconds":{"type":"integer"},"maxSeconds":{"type":"integer"}}},"S3c":{"type":"list","member":{}},"S3d":{"type":"structure","members":{"beginDate":{"type":"timestamp"},"endDate":{"type":"timestamp"}}},"S3f":{"type":"list","member":{}},"S45":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}}}}

/***/ }),
/* 2857 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListAssessmentRunAgents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentRuns":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentTargets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentTemplates":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListEventSubscriptions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListFindings":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListRulesPackages":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"PreviewAgents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 2858 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['iot'] = {};
AWS.Iot = Service.defineService('iot', ['2015-05-28']);
Object.defineProperty(apiLoader.services['iot'], '2015-05-28', {
  get: function get() {
    var model = __webpack_require__(2859);
    model.paginators = __webpack_require__(2860).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Iot;


/***/ }),
/* 2859 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-05-28","endpointPrefix":"iot","protocol":"rest-json","serviceFullName":"AWS IoT","serviceId":"IoT","signatureVersion":"v4","signingName":"execute-api","uid":"iot-2015-05-28"},"operations":{"AcceptCertificateTransfer":{"http":{"method":"PATCH","requestUri":"/accept-certificate-transfer/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"}}}},"AddThingToThingGroup":{"http":{"method":"PUT","requestUri":"/thing-groups/addThingToThingGroup"},"input":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingName":{},"thingArn":{}}},"output":{"type":"structure","members":{}}},"AssociateTargetsWithJob":{"http":{"requestUri":"/jobs/{jobId}/targets"},"input":{"type":"structure","required":["targets","jobId"],"members":{"targets":{"shape":"Sb"},"jobId":{"location":"uri","locationName":"jobId"},"comment":{}}},"output":{"type":"structure","members":{"jobArn":{},"jobId":{},"description":{}}}},"AttachPolicy":{"http":{"method":"PUT","requestUri":"/target-policies/{policyName}"},"input":{"type":"structure","required":["policyName","target"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"target":{}}}},"AttachPrincipalPolicy":{"http":{"method":"PUT","requestUri":"/principal-policies/{policyName}"},"input":{"type":"structure","required":["policyName","principal"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"principal":{"location":"header","locationName":"x-amzn-iot-principal"}}},"deprecated":true},"AttachThingPrincipal":{"http":{"method":"PUT","requestUri":"/things/{thingName}/principals"},"input":{"type":"structure","required":["thingName","principal"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"principal":{"location":"header","locationName":"x-amzn-principal"}}},"output":{"type":"structure","members":{}}},"CancelCertificateTransfer":{"http":{"method":"PATCH","requestUri":"/cancel-certificate-transfer/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"}}}},"CancelJob":{"http":{"method":"PUT","requestUri":"/jobs/{jobId}/cancel"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"comment":{}}},"output":{"type":"structure","members":{"jobArn":{},"jobId":{},"description":{}}}},"ClearDefaultAuthorizer":{"http":{"method":"DELETE","requestUri":"/default-authorizer"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"CreateAuthorizer":{"http":{"requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName","authorizerFunctionArn","tokenKeyName","tokenSigningPublicKeys"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"},"authorizerFunctionArn":{},"tokenKeyName":{},"tokenSigningPublicKeys":{"shape":"Sy"},"status":{}}},"output":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"CreateCertificateFromCsr":{"http":{"requestUri":"/certificates"},"input":{"type":"structure","required":["certificateSigningRequest"],"members":{"certificateSigningRequest":{},"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"certificatePem":{}}}},"CreateJob":{"http":{"method":"PUT","requestUri":"/jobs/{jobId}"},"input":{"type":"structure","required":["jobId","targets"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"targets":{"shape":"Sb"},"documentSource":{},"document":{},"description":{},"presignedUrlConfig":{"shape":"S1c"},"targetSelection":{},"jobExecutionsRolloutConfig":{"shape":"S1g"},"documentParameters":{"shape":"S1i"}}},"output":{"type":"structure","members":{"jobArn":{},"jobId":{},"description":{}}}},"CreateKeysAndCertificate":{"http":{"requestUri":"/keys-and-certificate"},"input":{"type":"structure","members":{"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"certificatePem":{},"keyPair":{"type":"structure","members":{"PublicKey":{},"PrivateKey":{"type":"string","sensitive":true}}}}}},"CreateOTAUpdate":{"http":{"requestUri":"/otaUpdates/{otaUpdateId}"},"input":{"type":"structure","required":["otaUpdateId","targets","files","roleArn"],"members":{"otaUpdateId":{"location":"uri","locationName":"otaUpdateId"},"description":{},"targets":{"shape":"S1u"},"targetSelection":{},"files":{"shape":"S1w"},"roleArn":{},"additionalParameters":{"shape":"S2g"}}},"output":{"type":"structure","members":{"otaUpdateId":{},"awsIotJobId":{},"otaUpdateArn":{},"awsIotJobArn":{},"otaUpdateStatus":{}}}},"CreatePolicy":{"http":{"requestUri":"/policies/{policyName}"},"input":{"type":"structure","required":["policyName","policyDocument"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyDocument":{}}},"output":{"type":"structure","members":{"policyName":{},"policyArn":{},"policyDocument":{},"policyVersionId":{}}}},"CreatePolicyVersion":{"http":{"requestUri":"/policies/{policyName}/version"},"input":{"type":"structure","required":["policyName","policyDocument"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyDocument":{},"setAsDefault":{"location":"querystring","locationName":"setAsDefault","type":"boolean"}}},"output":{"type":"structure","members":{"policyArn":{},"policyDocument":{},"policyVersionId":{},"isDefaultVersion":{"type":"boolean"}}}},"CreateRoleAlias":{"http":{"requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias","roleArn"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"},"roleArn":{},"credentialDurationSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"roleAlias":{},"roleAliasArn":{}}}},"CreateStream":{"http":{"requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId","files","roleArn"],"members":{"streamId":{"location":"uri","locationName":"streamId"},"description":{},"files":{"shape":"S32"},"roleArn":{}}},"output":{"type":"structure","members":{"streamId":{},"streamArn":{},"description":{},"streamVersion":{"type":"integer"}}}},"CreateThing":{"http":{"requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"thingTypeName":{},"attributePayload":{"shape":"S3d"}}},"output":{"type":"structure","members":{"thingName":{},"thingArn":{},"thingId":{}}}},"CreateThingGroup":{"http":{"requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"parentGroupName":{},"thingGroupProperties":{"shape":"S3l"}}},"output":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingGroupId":{}}}},"CreateThingType":{"http":{"requestUri":"/thing-types/{thingTypeName}"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"},"thingTypeProperties":{"shape":"S3q"}}},"output":{"type":"structure","members":{"thingTypeName":{},"thingTypeArn":{},"thingTypeId":{}}}},"CreateTopicRule":{"http":{"requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName","topicRulePayload"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"},"topicRulePayload":{"shape":"S3y"}},"payload":"topicRulePayload"}},"DeleteAuthorizer":{"http":{"method":"DELETE","requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"}}},"output":{"type":"structure","members":{}}},"DeleteCACertificate":{"http":{"method":"DELETE","requestUri":"/cacertificate/{caCertificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"caCertificateId"}}},"output":{"type":"structure","members":{}}},"DeleteCertificate":{"http":{"method":"DELETE","requestUri":"/certificates/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"forceDelete":{"location":"querystring","locationName":"forceDelete","type":"boolean"}}}},"DeleteOTAUpdate":{"http":{"method":"DELETE","requestUri":"/otaUpdates/{otaUpdateId}"},"input":{"type":"structure","required":["otaUpdateId"],"members":{"otaUpdateId":{"location":"uri","locationName":"otaUpdateId"}}},"output":{"type":"structure","members":{}}},"DeletePolicy":{"http":{"method":"DELETE","requestUri":"/policies/{policyName}"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"}}}},"DeletePolicyVersion":{"http":{"method":"DELETE","requestUri":"/policies/{policyName}/version/{policyVersionId}"},"input":{"type":"structure","required":["policyName","policyVersionId"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyVersionId":{"location":"uri","locationName":"policyVersionId"}}}},"DeleteRegistrationCode":{"http":{"method":"DELETE","requestUri":"/registrationcode"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DeleteRoleAlias":{"http":{"method":"DELETE","requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"}}},"output":{"type":"structure","members":{}}},"DeleteStream":{"http":{"method":"DELETE","requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId"],"members":{"streamId":{"location":"uri","locationName":"streamId"}}},"output":{"type":"structure","members":{}}},"DeleteThing":{"http":{"method":"DELETE","requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteThingGroup":{"http":{"method":"DELETE","requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteThingType":{"http":{"method":"DELETE","requestUri":"/thing-types/{thingTypeName}"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{}}},"DeleteTopicRule":{"http":{"method":"DELETE","requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}}},"DeleteV2LoggingLevel":{"http":{"method":"DELETE","requestUri":"/v2LoggingLevel"},"input":{"type":"structure","required":["targetType","targetName"],"members":{"targetType":{"location":"querystring","locationName":"targetType"},"targetName":{"location":"querystring","locationName":"targetName"}}}},"DeprecateThingType":{"http":{"requestUri":"/thing-types/{thingTypeName}/deprecate"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"},"undoDeprecate":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DescribeAuthorizer":{"http":{"method":"GET","requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"}}},"output":{"type":"structure","members":{"authorizerDescription":{"shape":"S6d"}}}},"DescribeCACertificate":{"http":{"method":"GET","requestUri":"/cacertificate/{caCertificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"caCertificateId"}}},"output":{"type":"structure","members":{"certificateDescription":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"status":{},"certificatePem":{},"ownedBy":{},"creationDate":{"type":"timestamp"},"autoRegistrationStatus":{}}},"registrationConfig":{"shape":"S6l"}}}},"DescribeCertificate":{"http":{"method":"GET","requestUri":"/certificates/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"}}},"output":{"type":"structure","members":{"certificateDescription":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"caCertificateId":{},"status":{},"certificatePem":{},"ownedBy":{},"previousOwnedBy":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"transferData":{"type":"structure","members":{"transferMessage":{},"rejectReason":{},"transferDate":{"type":"timestamp"},"acceptDate":{"type":"timestamp"},"rejectDate":{"type":"timestamp"}}}}}}}},"DescribeDefaultAuthorizer":{"http":{"method":"GET","requestUri":"/default-authorizer"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"authorizerDescription":{"shape":"S6d"}}}},"DescribeEndpoint":{"http":{"method":"GET","requestUri":"/endpoint"},"input":{"type":"structure","members":{"endpointType":{"location":"querystring","locationName":"endpointType"}}},"output":{"type":"structure","members":{"endpointAddress":{}}}},"DescribeEventConfigurations":{"http":{"method":"GET","requestUri":"/event-configurations"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"eventConfigurations":{"shape":"S71"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"DescribeIndex":{"http":{"method":"GET","requestUri":"/indices/{indexName}"},"input":{"type":"structure","required":["indexName"],"members":{"indexName":{"location":"uri","locationName":"indexName"}}},"output":{"type":"structure","members":{"indexName":{},"indexStatus":{},"schema":{}}}},"DescribeJob":{"http":{"method":"GET","requestUri":"/jobs/{jobId}"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","members":{"documentSource":{},"job":{"type":"structure","members":{"jobArn":{},"jobId":{},"targetSelection":{},"status":{},"comment":{},"targets":{"shape":"Sb"},"description":{},"presignedUrlConfig":{"shape":"S1c"},"jobExecutionsRolloutConfig":{"shape":"S1g"},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"completedAt":{"type":"timestamp"},"jobProcessDetails":{"type":"structure","members":{"processingTargets":{"type":"list","member":{}},"numberOfCanceledThings":{"type":"integer"},"numberOfSucceededThings":{"type":"integer"},"numberOfFailedThings":{"type":"integer"},"numberOfRejectedThings":{"type":"integer"},"numberOfQueuedThings":{"type":"integer"},"numberOfInProgressThings":{"type":"integer"},"numberOfRemovedThings":{"type":"integer"}}},"documentParameters":{"shape":"S1i"}}}}}},"DescribeJobExecution":{"http":{"method":"GET","requestUri":"/things/{thingName}/jobs/{jobId}"},"input":{"type":"structure","required":["jobId","thingName"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"thingName":{"location":"uri","locationName":"thingName"},"executionNumber":{"location":"querystring","locationName":"executionNumber","type":"long"}}},"output":{"type":"structure","members":{"execution":{"type":"structure","members":{"jobId":{},"status":{},"statusDetails":{"type":"structure","members":{"detailsMap":{"type":"map","key":{},"value":{}}}},"thingArn":{},"queuedAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"executionNumber":{"type":"long"}}}}}},"DescribeRoleAlias":{"http":{"method":"GET","requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"}}},"output":{"type":"structure","members":{"roleAliasDescription":{"type":"structure","members":{"roleAlias":{},"roleArn":{},"owner":{},"credentialDurationSeconds":{"type":"integer"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}}}},"DescribeStream":{"http":{"method":"GET","requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId"],"members":{"streamId":{"location":"uri","locationName":"streamId"}}},"output":{"type":"structure","members":{"streamInfo":{"type":"structure","members":{"streamId":{},"streamArn":{},"streamVersion":{"type":"integer"},"description":{},"files":{"shape":"S32"},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"roleArn":{}}}}}},"DescribeThing":{"http":{"method":"GET","requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","members":{"defaultClientId":{},"thingName":{},"thingId":{},"thingArn":{},"thingTypeName":{},"attributes":{"shape":"S3e"},"version":{"type":"long"}}}},"DescribeThingGroup":{"http":{"method":"GET","requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"}}},"output":{"type":"structure","members":{"thingGroupName":{},"thingGroupId":{},"thingGroupArn":{},"version":{"type":"long"},"thingGroupProperties":{"shape":"S3l"},"thingGroupMetadata":{"type":"structure","members":{"parentGroupName":{},"rootToParentThingGroups":{"shape":"S8c"},"creationDate":{"type":"timestamp"}}}}}},"DescribeThingRegistrationTask":{"http":{"method":"GET","requestUri":"/thing-registration-tasks/{taskId}"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{"taskId":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"templateBody":{},"inputFileBucket":{},"inputFileKey":{},"roleArn":{},"status":{},"message":{},"successCount":{"type":"integer"},"failureCount":{"type":"integer"},"percentageProgress":{"type":"integer"}}}},"DescribeThingType":{"http":{"method":"GET","requestUri":"/thing-types/{thingTypeName}"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{"thingTypeName":{},"thingTypeId":{},"thingTypeArn":{},"thingTypeProperties":{"shape":"S3q"},"thingTypeMetadata":{"shape":"S8p"}}}},"DetachPolicy":{"http":{"requestUri":"/target-policies/{policyName}"},"input":{"type":"structure","required":["policyName","target"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"target":{}}}},"DetachPrincipalPolicy":{"http":{"method":"DELETE","requestUri":"/principal-policies/{policyName}"},"input":{"type":"structure","required":["policyName","principal"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"principal":{"location":"header","locationName":"x-amzn-iot-principal"}}},"deprecated":true},"DetachThingPrincipal":{"http":{"method":"DELETE","requestUri":"/things/{thingName}/principals"},"input":{"type":"structure","required":["thingName","principal"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"principal":{"location":"header","locationName":"x-amzn-principal"}}},"output":{"type":"structure","members":{}}},"DisableTopicRule":{"http":{"requestUri":"/rules/{ruleName}/disable"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}}},"EnableTopicRule":{"http":{"requestUri":"/rules/{ruleName}/enable"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}}},"GetEffectivePolicies":{"http":{"requestUri":"/effective-policies"},"input":{"type":"structure","members":{"principal":{},"cognitoIdentityPoolId":{},"thingName":{"location":"querystring","locationName":"thingName"}}},"output":{"type":"structure","members":{"effectivePolicies":{"type":"list","member":{"type":"structure","members":{"policyName":{},"policyArn":{},"policyDocument":{}}}}}}},"GetIndexingConfiguration":{"http":{"method":"GET","requestUri":"/indexing/config"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"thingIndexingConfiguration":{"shape":"S95"}}}},"GetJobDocument":{"http":{"method":"GET","requestUri":"/jobs/{jobId}/job-document"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","members":{"document":{}}}},"GetLoggingOptions":{"http":{"method":"GET","requestUri":"/loggingOptions"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"roleArn":{},"logLevel":{}}}},"GetOTAUpdate":{"http":{"method":"GET","requestUri":"/otaUpdates/{otaUpdateId}"},"input":{"type":"structure","required":["otaUpdateId"],"members":{"otaUpdateId":{"location":"uri","locationName":"otaUpdateId"}}},"output":{"type":"structure","members":{"otaUpdateInfo":{"type":"structure","members":{"otaUpdateId":{},"otaUpdateArn":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"description":{},"targets":{"shape":"S1u"},"targetSelection":{},"otaUpdateFiles":{"shape":"S1w"},"otaUpdateStatus":{},"awsIotJobId":{},"awsIotJobArn":{},"errorInfo":{"type":"structure","members":{"code":{},"message":{}}},"additionalParameters":{"shape":"S2g"}}}}}},"GetPolicy":{"http":{"method":"GET","requestUri":"/policies/{policyName}"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"}}},"output":{"type":"structure","members":{"policyName":{},"policyArn":{},"policyDocument":{},"defaultVersionId":{}}}},"GetPolicyVersion":{"http":{"method":"GET","requestUri":"/policies/{policyName}/version/{policyVersionId}"},"input":{"type":"structure","required":["policyName","policyVersionId"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyVersionId":{"location":"uri","locationName":"policyVersionId"}}},"output":{"type":"structure","members":{"policyArn":{},"policyName":{},"policyDocument":{},"policyVersionId":{},"isDefaultVersion":{"type":"boolean"}}}},"GetRegistrationCode":{"http":{"method":"GET","requestUri":"/registrationcode"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"registrationCode":{}}}},"GetTopicRule":{"http":{"method":"GET","requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}},"output":{"type":"structure","members":{"ruleArn":{},"rule":{"type":"structure","members":{"ruleName":{},"sql":{},"description":{},"createdAt":{"type":"timestamp"},"actions":{"shape":"S41"},"ruleDisabled":{"type":"boolean"},"awsIotSqlVersion":{},"errorAction":{"shape":"S42"}}}}}},"GetV2LoggingOptions":{"http":{"method":"GET","requestUri":"/v2LoggingOptions"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"roleArn":{},"defaultLogLevel":{},"disableAllLogs":{"type":"boolean"}}}},"ListAttachedPolicies":{"http":{"requestUri":"/attached-policies/{target}"},"input":{"type":"structure","required":["target"],"members":{"target":{"location":"uri","locationName":"target"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"}}},"output":{"type":"structure","members":{"policies":{"shape":"Sa2"},"nextMarker":{}}}},"ListAuthorizers":{"http":{"method":"GET","requestUri":"/authorizers/"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"},"status":{"location":"querystring","locationName":"status"}}},"output":{"type":"structure","members":{"authorizers":{"type":"list","member":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"nextMarker":{}}}},"ListCACertificates":{"http":{"method":"GET","requestUri":"/cacertificates"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"certificates":{"type":"list","member":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"status":{},"creationDate":{"type":"timestamp"}}}},"nextMarker":{}}}},"ListCertificates":{"http":{"method":"GET","requestUri":"/certificates"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"certificates":{"shape":"Saf"},"nextMarker":{}}}},"ListCertificatesByCA":{"http":{"method":"GET","requestUri":"/certificates-by-ca/{caCertificateId}"},"input":{"type":"structure","required":["caCertificateId"],"members":{"caCertificateId":{"location":"uri","locationName":"caCertificateId"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"certificates":{"shape":"Saf"},"nextMarker":{}}}},"ListIndices":{"http":{"method":"GET","requestUri":"/indices"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"indexNames":{"type":"list","member":{}},"nextToken":{}}}},"ListJobExecutionsForJob":{"http":{"method":"GET","requestUri":"/jobs/{jobId}/things"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"status":{"location":"querystring","locationName":"status"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"executionSummaries":{"type":"list","member":{"type":"structure","members":{"thingArn":{},"jobExecutionSummary":{"shape":"Sat"}}}},"nextToken":{}}}},"ListJobExecutionsForThing":{"http":{"method":"GET","requestUri":"/things/{thingName}/jobs"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"status":{"location":"querystring","locationName":"status"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"executionSummaries":{"type":"list","member":{"type":"structure","members":{"jobId":{},"jobExecutionSummary":{"shape":"Sat"}}}},"nextToken":{}}}},"ListJobs":{"http":{"method":"GET","requestUri":"/jobs"},"input":{"type":"structure","members":{"status":{"location":"querystring","locationName":"status"},"targetSelection":{"location":"querystring","locationName":"targetSelection"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"thingGroupName":{"location":"querystring","locationName":"thingGroupName"},"thingGroupId":{"location":"querystring","locationName":"thingGroupId"}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"jobArn":{},"jobId":{},"thingGroupId":{},"targetSelection":{},"status":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"completedAt":{"type":"timestamp"}}}},"nextToken":{}}}},"ListOTAUpdates":{"http":{"method":"GET","requestUri":"/otaUpdates"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"otaUpdateStatus":{"location":"querystring","locationName":"otaUpdateStatus"}}},"output":{"type":"structure","members":{"otaUpdates":{"type":"list","member":{"type":"structure","members":{"otaUpdateId":{},"otaUpdateArn":{},"creationDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListOutgoingCertificates":{"http":{"method":"GET","requestUri":"/certificates-out-going"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"outgoingCertificates":{"type":"list","member":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"transferredTo":{},"transferDate":{"type":"timestamp"},"transferMessage":{},"creationDate":{"type":"timestamp"}}}},"nextMarker":{}}}},"ListPolicies":{"http":{"method":"GET","requestUri":"/policies"},"input":{"type":"structure","members":{"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"policies":{"shape":"Sa2"},"nextMarker":{}}}},"ListPolicyPrincipals":{"http":{"method":"GET","requestUri":"/policy-principals"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"header","locationName":"x-amzn-iot-policy"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"principals":{"shape":"Sbf"},"nextMarker":{}}},"deprecated":true},"ListPolicyVersions":{"http":{"method":"GET","requestUri":"/policies/{policyName}/version"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"}}},"output":{"type":"structure","members":{"policyVersions":{"type":"list","member":{"type":"structure","members":{"versionId":{},"isDefaultVersion":{"type":"boolean"},"createDate":{"type":"timestamp"}}}}}}},"ListPrincipalPolicies":{"http":{"method":"GET","requestUri":"/principal-policies"},"input":{"type":"structure","required":["principal"],"members":{"principal":{"location":"header","locationName":"x-amzn-iot-principal"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"policies":{"shape":"Sa2"},"nextMarker":{}}},"deprecated":true},"ListPrincipalThings":{"http":{"method":"GET","requestUri":"/principals/things"},"input":{"type":"structure","required":["principal"],"members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"principal":{"location":"header","locationName":"x-amzn-principal"}}},"output":{"type":"structure","members":{"things":{"shape":"Sbq"},"nextToken":{}}}},"ListRoleAliases":{"http":{"method":"GET","requestUri":"/role-aliases"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"roleAliases":{"type":"list","member":{}},"nextMarker":{}}}},"ListStreams":{"http":{"method":"GET","requestUri":"/streams"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"streams":{"type":"list","member":{"type":"structure","members":{"streamId":{},"streamArn":{},"streamVersion":{"type":"integer"},"description":{}}}},"nextToken":{}}}},"ListTargetsForPolicy":{"http":{"requestUri":"/policy-targets/{policyName}"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"}}},"output":{"type":"structure","members":{"targets":{"type":"list","member":{}},"nextMarker":{}}}},"ListThingGroups":{"http":{"method":"GET","requestUri":"/thing-groups"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"parentGroup":{"location":"querystring","locationName":"parentGroup"},"namePrefixFilter":{"location":"querystring","locationName":"namePrefixFilter"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"}}},"output":{"type":"structure","members":{"thingGroups":{"shape":"S8c"},"nextToken":{}}}},"ListThingGroupsForThing":{"http":{"method":"GET","requestUri":"/things/{thingName}/thing-groups"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"thingGroups":{"shape":"S8c"},"nextToken":{}}}},"ListThingPrincipals":{"http":{"method":"GET","requestUri":"/things/{thingName}/principals"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","members":{"principals":{"shape":"Sbf"}}}},"ListThingRegistrationTaskReports":{"http":{"method":"GET","requestUri":"/thing-registration-tasks/{taskId}/reports"},"input":{"type":"structure","required":["taskId","reportType"],"members":{"taskId":{"location":"uri","locationName":"taskId"},"reportType":{"location":"querystring","locationName":"reportType"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"resourceLinks":{"type":"list","member":{}},"reportType":{},"nextToken":{}}}},"ListThingRegistrationTasks":{"http":{"method":"GET","requestUri":"/thing-registration-tasks"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"status":{"location":"querystring","locationName":"status"}}},"output":{"type":"structure","members":{"taskIds":{"type":"list","member":{}},"nextToken":{}}}},"ListThingTypes":{"http":{"method":"GET","requestUri":"/thing-types"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"thingTypeName":{"location":"querystring","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{"thingTypes":{"type":"list","member":{"type":"structure","members":{"thingTypeName":{},"thingTypeArn":{},"thingTypeProperties":{"shape":"S3q"},"thingTypeMetadata":{"shape":"S8p"}}}},"nextToken":{}}}},"ListThings":{"http":{"method":"GET","requestUri":"/things"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"attributeName":{"location":"querystring","locationName":"attributeName"},"attributeValue":{"location":"querystring","locationName":"attributeValue"},"thingTypeName":{"location":"querystring","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{"things":{"type":"list","member":{"type":"structure","members":{"thingName":{},"thingTypeName":{},"thingArn":{},"attributes":{"shape":"S3e"},"version":{"type":"long"}}}},"nextToken":{}}}},"ListThingsInThingGroup":{"http":{"method":"GET","requestUri":"/thing-groups/{thingGroupName}/things"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"things":{"shape":"Sbq"},"nextToken":{}}}},"ListTopicRules":{"http":{"method":"GET","requestUri":"/rules"},"input":{"type":"structure","members":{"topic":{"location":"querystring","locationName":"topic"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"ruleDisabled":{"location":"querystring","locationName":"ruleDisabled","type":"boolean"}}},"output":{"type":"structure","members":{"rules":{"type":"list","member":{"type":"structure","members":{"ruleArn":{},"ruleName":{},"topicPattern":{},"createdAt":{"type":"timestamp"},"ruleDisabled":{"type":"boolean"}}}},"nextToken":{}}}},"ListV2LoggingLevels":{"http":{"method":"GET","requestUri":"/v2LoggingLevel"},"input":{"type":"structure","members":{"targetType":{"location":"querystring","locationName":"targetType"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"logTargetConfigurations":{"type":"list","member":{"type":"structure","members":{"logTarget":{"shape":"Sd1"},"logLevel":{}}}},"nextToken":{}}}},"RegisterCACertificate":{"http":{"requestUri":"/cacertificate"},"input":{"type":"structure","required":["caCertificate","verificationCertificate"],"members":{"caCertificate":{},"verificationCertificate":{},"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"},"allowAutoRegistration":{"location":"querystring","locationName":"allowAutoRegistration","type":"boolean"},"registrationConfig":{"shape":"S6l"}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{}}}},"RegisterCertificate":{"http":{"requestUri":"/certificate/register"},"input":{"type":"structure","required":["certificatePem"],"members":{"certificatePem":{},"caCertificatePem":{},"setAsActive":{"deprecated":true,"location":"querystring","locationName":"setAsActive","type":"boolean"},"status":{}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{}}}},"RegisterThing":{"http":{"requestUri":"/things"},"input":{"type":"structure","required":["templateBody"],"members":{"templateBody":{},"parameters":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"certificatePem":{},"resourceArns":{"type":"map","key":{},"value":{}}}}},"RejectCertificateTransfer":{"http":{"method":"PATCH","requestUri":"/reject-certificate-transfer/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"rejectReason":{}}}},"RemoveThingFromThingGroup":{"http":{"method":"PUT","requestUri":"/thing-groups/removeThingFromThingGroup"},"input":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingName":{},"thingArn":{}}},"output":{"type":"structure","members":{}}},"ReplaceTopicRule":{"http":{"method":"PATCH","requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName","topicRulePayload"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"},"topicRulePayload":{"shape":"S3y"}},"payload":"topicRulePayload"}},"SearchIndex":{"http":{"requestUri":"/indices/search"},"input":{"type":"structure","required":["queryString"],"members":{"indexName":{},"queryString":{},"nextToken":{},"maxResults":{"type":"integer"},"queryVersion":{}}},"output":{"type":"structure","members":{"nextToken":{},"things":{"type":"list","member":{"type":"structure","members":{"thingName":{},"thingId":{},"thingTypeName":{},"thingGroupNames":{"type":"list","member":{}},"attributes":{"shape":"S3e"},"shadow":{}}}}}}},"SetDefaultAuthorizer":{"http":{"requestUri":"/default-authorizer"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{}}},"output":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"SetDefaultPolicyVersion":{"http":{"method":"PATCH","requestUri":"/policies/{policyName}/version/{policyVersionId}"},"input":{"type":"structure","required":["policyName","policyVersionId"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyVersionId":{"location":"uri","locationName":"policyVersionId"}}}},"SetLoggingOptions":{"http":{"requestUri":"/loggingOptions"},"input":{"type":"structure","required":["loggingOptionsPayload"],"members":{"loggingOptionsPayload":{"type":"structure","required":["roleArn"],"members":{"roleArn":{},"logLevel":{}}}},"payload":"loggingOptionsPayload"}},"SetV2LoggingLevel":{"http":{"requestUri":"/v2LoggingLevel"},"input":{"type":"structure","required":["logTarget","logLevel"],"members":{"logTarget":{"shape":"Sd1"},"logLevel":{}}}},"SetV2LoggingOptions":{"http":{"requestUri":"/v2LoggingOptions"},"input":{"type":"structure","members":{"roleArn":{},"defaultLogLevel":{},"disableAllLogs":{"type":"boolean"}}}},"StartThingRegistrationTask":{"http":{"requestUri":"/thing-registration-tasks"},"input":{"type":"structure","required":["templateBody","inputFileBucket","inputFileKey","roleArn"],"members":{"templateBody":{},"inputFileBucket":{},"inputFileKey":{},"roleArn":{}}},"output":{"type":"structure","members":{"taskId":{}}}},"StopThingRegistrationTask":{"http":{"method":"PUT","requestUri":"/thing-registration-tasks/{taskId}/cancel"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{}}},"TestAuthorization":{"http":{"requestUri":"/test-authorization"},"input":{"type":"structure","required":["authInfos"],"members":{"principal":{},"cognitoIdentityPoolId":{},"authInfos":{"type":"list","member":{"shape":"Se4"}},"clientId":{"location":"querystring","locationName":"clientId"},"policyNamesToAdd":{"shape":"Se8"},"policyNamesToSkip":{"shape":"Se8"}}},"output":{"type":"structure","members":{"authResults":{"type":"list","member":{"type":"structure","members":{"authInfo":{"shape":"Se4"},"allowed":{"type":"structure","members":{"policies":{"shape":"Sa2"}}},"denied":{"type":"structure","members":{"implicitDeny":{"type":"structure","members":{"policies":{"shape":"Sa2"}}},"explicitDeny":{"type":"structure","members":{"policies":{"shape":"Sa2"}}}}},"authDecision":{},"missingContextValues":{"type":"list","member":{}}}}}}}},"TestInvokeAuthorizer":{"http":{"requestUri":"/authorizer/{authorizerName}/test"},"input":{"type":"structure","required":["authorizerName","token","tokenSignature"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"},"token":{},"tokenSignature":{}}},"output":{"type":"structure","members":{"isAuthenticated":{"type":"boolean"},"principalId":{},"policyDocuments":{"type":"list","member":{}},"refreshAfterInSeconds":{"type":"integer"},"disconnectAfterInSeconds":{"type":"integer"}}}},"TransferCertificate":{"http":{"method":"PATCH","requestUri":"/transfer-certificate/{certificateId}"},"input":{"type":"structure","required":["certificateId","targetAwsAccount"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"targetAwsAccount":{"location":"querystring","locationName":"targetAwsAccount"},"transferMessage":{}}},"output":{"type":"structure","members":{"transferredCertificateArn":{}}}},"UpdateAuthorizer":{"http":{"method":"PUT","requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"},"authorizerFunctionArn":{},"tokenKeyName":{},"tokenSigningPublicKeys":{"shape":"Sy"},"status":{}}},"output":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"UpdateCACertificate":{"http":{"method":"PUT","requestUri":"/cacertificate/{caCertificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"caCertificateId"},"newStatus":{"location":"querystring","locationName":"newStatus"},"newAutoRegistrationStatus":{"location":"querystring","locationName":"newAutoRegistrationStatus"},"registrationConfig":{"shape":"S6l"},"removeAutoRegistration":{"type":"boolean"}}}},"UpdateCertificate":{"http":{"method":"PUT","requestUri":"/certificates/{certificateId}"},"input":{"type":"structure","required":["certificateId","newStatus"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"newStatus":{"location":"querystring","locationName":"newStatus"}}}},"UpdateEventConfigurations":{"http":{"method":"PATCH","requestUri":"/event-configurations"},"input":{"type":"structure","members":{"eventConfigurations":{"shape":"S71"}}},"output":{"type":"structure","members":{}}},"UpdateIndexingConfiguration":{"http":{"requestUri":"/indexing/config"},"input":{"type":"structure","members":{"thingIndexingConfiguration":{"shape":"S95"}}},"output":{"type":"structure","members":{}}},"UpdateRoleAlias":{"http":{"method":"PUT","requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"},"roleArn":{},"credentialDurationSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"roleAlias":{},"roleAliasArn":{}}}},"UpdateStream":{"http":{"method":"PUT","requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId"],"members":{"streamId":{"location":"uri","locationName":"streamId"},"description":{},"files":{"shape":"S32"},"roleArn":{}}},"output":{"type":"structure","members":{"streamId":{},"streamArn":{},"description":{},"streamVersion":{"type":"integer"}}}},"UpdateThing":{"http":{"method":"PATCH","requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"thingTypeName":{},"attributePayload":{"shape":"S3d"},"expectedVersion":{"type":"long"},"removeThingType":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateThingGroup":{"http":{"method":"PATCH","requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName","thingGroupProperties"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"thingGroupProperties":{"shape":"S3l"},"expectedVersion":{"type":"long"}}},"output":{"type":"structure","members":{"version":{"type":"long"}}}},"UpdateThingGroupsForThing":{"http":{"method":"PUT","requestUri":"/thing-groups/updateThingGroupsForThing"},"input":{"type":"structure","members":{"thingName":{},"thingGroupsToAdd":{"shape":"Sfc"},"thingGroupsToRemove":{"shape":"Sfc"}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sb":{"type":"list","member":{}},"Sy":{"type":"map","key":{},"value":{}},"S1c":{"type":"structure","members":{"roleArn":{},"expiresInSec":{"type":"long"}}},"S1g":{"type":"structure","members":{"maximumPerMinute":{"type":"integer"}}},"S1i":{"type":"map","key":{},"value":{}},"S1u":{"type":"list","member":{}},"S1w":{"type":"list","member":{"type":"structure","members":{"fileName":{},"fileVersion":{},"fileSource":{"shape":"S20"},"codeSigning":{"type":"structure","members":{"awsSignerJobId":{},"customCodeSigning":{"type":"structure","members":{"signature":{"type":"structure","members":{"stream":{"shape":"S20"},"inlineDocument":{"type":"blob"}}},"certificateChain":{"type":"structure","members":{"stream":{"shape":"S20"},"certificateName":{},"inlineDocument":{}}},"hashAlgorithm":{},"signatureAlgorithm":{}}}}},"attributes":{"type":"map","key":{},"value":{}}}}},"S20":{"type":"structure","members":{"streamId":{},"fileId":{"type":"integer"}}},"S2g":{"type":"map","key":{},"value":{}},"S32":{"type":"list","member":{"type":"structure","members":{"fileId":{"type":"integer"},"s3Location":{"type":"structure","required":["bucket","key"],"members":{"bucket":{},"key":{},"version":{}}}}}},"S3d":{"type":"structure","members":{"attributes":{"shape":"S3e"},"merge":{"type":"boolean"}}},"S3e":{"type":"map","key":{},"value":{}},"S3l":{"type":"structure","members":{"thingGroupDescription":{},"attributePayload":{"shape":"S3d"}}},"S3q":{"type":"structure","members":{"thingTypeDescription":{},"searchableAttributes":{"type":"list","member":{}}}},"S3y":{"type":"structure","required":["sql","actions"],"members":{"sql":{},"description":{},"actions":{"shape":"S41"},"ruleDisabled":{"type":"boolean"},"awsIotSqlVersion":{},"errorAction":{"shape":"S42"}}},"S41":{"type":"list","member":{"shape":"S42"}},"S42":{"type":"structure","members":{"dynamoDB":{"type":"structure","required":["tableName","roleArn","hashKeyField","hashKeyValue"],"members":{"tableName":{},"roleArn":{},"operation":{},"hashKeyField":{},"hashKeyValue":{},"hashKeyType":{},"rangeKeyField":{},"rangeKeyValue":{},"rangeKeyType":{},"payloadField":{}}},"dynamoDBv2":{"type":"structure","members":{"roleArn":{},"putItem":{"type":"structure","required":["tableName"],"members":{"tableName":{}}}}},"lambda":{"type":"structure","required":["functionArn"],"members":{"functionArn":{}}},"sns":{"type":"structure","required":["targetArn","roleArn"],"members":{"targetArn":{},"roleArn":{},"messageFormat":{}}},"sqs":{"type":"structure","required":["roleArn","queueUrl"],"members":{"roleArn":{},"queueUrl":{},"useBase64":{"type":"boolean"}}},"kinesis":{"type":"structure","required":["roleArn","streamName"],"members":{"roleArn":{},"streamName":{},"partitionKey":{}}},"republish":{"type":"structure","required":["roleArn","topic"],"members":{"roleArn":{},"topic":{}}},"s3":{"type":"structure","required":["roleArn","bucketName","key"],"members":{"roleArn":{},"bucketName":{},"key":{},"cannedAcl":{}}},"firehose":{"type":"structure","required":["roleArn","deliveryStreamName"],"members":{"roleArn":{},"deliveryStreamName":{},"separator":{}}},"cloudwatchMetric":{"type":"structure","required":["roleArn","metricNamespace","metricName","metricValue","metricUnit"],"members":{"roleArn":{},"metricNamespace":{},"metricName":{},"metricValue":{},"metricUnit":{},"metricTimestamp":{}}},"cloudwatchAlarm":{"type":"structure","required":["roleArn","alarmName","stateReason","stateValue"],"members":{"roleArn":{},"alarmName":{},"stateReason":{},"stateValue":{}}},"elasticsearch":{"type":"structure","required":["roleArn","endpoint","index","type","id"],"members":{"roleArn":{},"endpoint":{},"index":{},"type":{},"id":{}}},"salesforce":{"type":"structure","required":["token","url"],"members":{"token":{},"url":{}}}}},"S6d":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{},"authorizerFunctionArn":{},"tokenKeyName":{},"tokenSigningPublicKeys":{"shape":"Sy"},"status":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}},"S6l":{"type":"structure","members":{"templateBody":{},"roleArn":{}}},"S71":{"type":"map","key":{},"value":{"type":"structure","members":{"Enabled":{"type":"boolean"}}}},"S8c":{"type":"list","member":{"type":"structure","members":{"groupName":{},"groupArn":{}}}},"S8p":{"type":"structure","members":{"deprecated":{"type":"boolean"},"deprecationDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"}}},"S95":{"type":"structure","members":{"thingIndexingMode":{}}},"Sa2":{"type":"list","member":{"type":"structure","members":{"policyName":{},"policyArn":{}}}},"Saf":{"type":"list","member":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"status":{},"creationDate":{"type":"timestamp"}}}},"Sat":{"type":"structure","members":{"status":{},"queuedAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"executionNumber":{"type":"long"}}},"Sbf":{"type":"list","member":{}},"Sbq":{"type":"list","member":{}},"Sd1":{"type":"structure","required":["targetType"],"members":{"targetType":{},"targetName":{}}},"Se4":{"type":"structure","members":{"actionType":{},"resources":{"type":"list","member":{}}}},"Se8":{"type":"list","member":{}},"Sfc":{"type":"list","member":{}}}}

/***/ }),
/* 2860 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 2861 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['iotdata'] = {};
AWS.IotData = Service.defineService('iotdata', ['2015-05-28']);
__webpack_require__(2862);
Object.defineProperty(apiLoader.services['iotdata'], '2015-05-28', {
  get: function get() {
    var model = __webpack_require__(2863);
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.IotData;


/***/ }),
/* 2862 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);

/**
 * @api private
 */
var blobPayloadOutputOps = [
  'deleteThingShadow',
  'getThingShadow',
  'updateThingShadow'
];

/**
 * Constructs a service interface object. Each API operation is exposed as a
 * function on service.
 *
 * ### Sending a Request Using IotData
 *
 * ```javascript
 * var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
 * iotdata.getThingShadow(params, function (err, data) {
 *   if (err) console.log(err, err.stack); // an error occurred
 *   else     console.log(data);           // successful response
 * });
 * ```
 *
 * ### Locking the API Version
 *
 * In order to ensure that the IotData object uses this specific API,
 * you can construct the object by passing the `apiVersion` option to the
 * constructor:
 *
 * ```javascript
 * var iotdata = new AWS.IotData({
 *   endpoint: 'my.host.tld',
 *   apiVersion: '2015-05-28'
 * });
 * ```
 *
 * You can also set the API version globally in `AWS.config.apiVersions` using
 * the **iotdata** service identifier:
 *
 * ```javascript
 * AWS.config.apiVersions = {
 *   iotdata: '2015-05-28',
 *   // other service API versions
 * };
 *
 * var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
 * ```
 *
 * @note You *must* provide an `endpoint` configuration parameter when
 *   constructing this service. See {constructor} for more information.
 *
 * @!method constructor(options = {})
 *   Constructs a service object. This object has one method for each
 *   API operation.
 *
 *   @example Constructing a IotData object
 *     var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
 *   @note You *must* provide an `endpoint` when constructing this service.
 *   @option (see AWS.Config.constructor)
 *
 * @service iotdata
 * @version 2015-05-28
 */
AWS.util.update(AWS.IotData.prototype, {
    /**
     * @api private
     */
    validateService: function validateService() {
        if (!this.config.endpoint || this.config.endpoint.indexOf('{') >= 0) {
            var msg = 'AWS.IotData requires an explicit ' +
                '`endpoint\' configuration option.';
            throw AWS.util.error(new Error(),
                {name: 'InvalidEndpoint', message: msg});
        }
    },

    /**
     * @api private
     */
    setupRequestListeners: function setupRequestListeners(request) {
        request.addListener('validateResponse', this.validateResponseBody);
        if (blobPayloadOutputOps.indexOf(request.operation) > -1) {
            request.addListener('extractData', AWS.util.convertPayloadToString);
        }
    },

    /**
     * @api private
     */
    validateResponseBody: function validateResponseBody(resp) {
        var body = resp.httpResponse.body.toString() || '{}';
        var bodyCheck = body.trim();
        if (!bodyCheck || bodyCheck.charAt(0) !== '{') {
            resp.httpResponse.body = '';
        }
    }

});


/***/ }),
/* 2863 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"uid":"iot-data-2015-05-28","apiVersion":"2015-05-28","endpointPrefix":"data.iot","protocol":"rest-json","serviceFullName":"AWS IoT Data Plane","signatureVersion":"v4","signingName":"iotdata"},"operations":{"DeleteThingShadow":{"http":{"method":"DELETE","requestUri":"/things/{thingName}/shadow"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","required":["payload"],"members":{"payload":{"type":"blob"}},"payload":"payload"}},"GetThingShadow":{"http":{"method":"GET","requestUri":"/things/{thingName}/shadow"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","members":{"payload":{"type":"blob"}},"payload":"payload"}},"Publish":{"http":{"requestUri":"/topics/{topic}"},"input":{"type":"structure","required":["topic"],"members":{"topic":{"location":"uri","locationName":"topic"},"qos":{"location":"querystring","locationName":"qos","type":"integer"},"payload":{"type":"blob"}},"payload":"payload"}},"UpdateThingShadow":{"http":{"requestUri":"/things/{thingName}/shadow"},"input":{"type":"structure","required":["thingName","payload"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"payload":{"type":"blob"}},"payload":"payload"},"output":{"type":"structure","members":{"payload":{"type":"blob"}},"payload":"payload"}}},"shapes":{}}

/***/ }),
/* 2864 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['kinesis'] = {};
AWS.Kinesis = Service.defineService('kinesis', ['2013-12-02']);
Object.defineProperty(apiLoader.services['kinesis'], '2013-12-02', {
  get: function get() {
    var model = __webpack_require__(2865);
    model.paginators = __webpack_require__(2866).pagination;
    model.waiters = __webpack_require__(2867).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Kinesis;


/***/ }),
/* 2865 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-12-02","endpointPrefix":"kinesis","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Kinesis","serviceFullName":"Amazon Kinesis","serviceId":"Kinesis","signatureVersion":"v4","targetPrefix":"Kinesis_20131202","uid":"kinesis-2013-12-02"},"operations":{"AddTagsToStream":{"input":{"type":"structure","required":["StreamName","Tags"],"members":{"StreamName":{},"Tags":{"type":"map","key":{},"value":{}}}}},"CreateStream":{"input":{"type":"structure","required":["StreamName","ShardCount"],"members":{"StreamName":{},"ShardCount":{"type":"integer"}}}},"DecreaseStreamRetentionPeriod":{"input":{"type":"structure","required":["StreamName","RetentionPeriodHours"],"members":{"StreamName":{},"RetentionPeriodHours":{"type":"integer"}}}},"DeleteStream":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{}}}},"DescribeLimits":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["ShardLimit","OpenShardCount"],"members":{"ShardLimit":{"type":"integer"},"OpenShardCount":{"type":"integer"}}}},"DescribeStream":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{},"Limit":{"type":"integer"},"ExclusiveStartShardId":{}}},"output":{"type":"structure","required":["StreamDescription"],"members":{"StreamDescription":{"type":"structure","required":["StreamName","StreamARN","StreamStatus","Shards","HasMoreShards","RetentionPeriodHours","StreamCreationTimestamp","EnhancedMonitoring"],"members":{"StreamName":{},"StreamARN":{},"StreamStatus":{},"Shards":{"shape":"Sl"},"HasMoreShards":{"type":"boolean"},"RetentionPeriodHours":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"},"EnhancedMonitoring":{"shape":"St"},"EncryptionType":{},"KeyId":{}}}}}},"DescribeStreamSummary":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{}}},"output":{"type":"structure","required":["StreamDescriptionSummary"],"members":{"StreamDescriptionSummary":{"type":"structure","required":["StreamName","StreamARN","StreamStatus","RetentionPeriodHours","StreamCreationTimestamp","EnhancedMonitoring","OpenShardCount"],"members":{"StreamName":{},"StreamARN":{},"StreamStatus":{},"RetentionPeriodHours":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"},"EnhancedMonitoring":{"shape":"St"},"EncryptionType":{},"KeyId":{},"OpenShardCount":{"type":"integer"}}}}}},"DisableEnhancedMonitoring":{"input":{"type":"structure","required":["StreamName","ShardLevelMetrics"],"members":{"StreamName":{},"ShardLevelMetrics":{"shape":"Sv"}}},"output":{"shape":"S13"}},"EnableEnhancedMonitoring":{"input":{"type":"structure","required":["StreamName","ShardLevelMetrics"],"members":{"StreamName":{},"ShardLevelMetrics":{"shape":"Sv"}}},"output":{"shape":"S13"}},"GetRecords":{"input":{"type":"structure","required":["ShardIterator"],"members":{"ShardIterator":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","required":["Records"],"members":{"Records":{"type":"list","member":{"type":"structure","required":["SequenceNumber","Data","PartitionKey"],"members":{"SequenceNumber":{},"ApproximateArrivalTimestamp":{"type":"timestamp"},"Data":{"type":"blob"},"PartitionKey":{},"EncryptionType":{}}}},"NextShardIterator":{},"MillisBehindLatest":{"type":"long"}}}},"GetShardIterator":{"input":{"type":"structure","required":["StreamName","ShardId","ShardIteratorType"],"members":{"StreamName":{},"ShardId":{},"ShardIteratorType":{},"StartingSequenceNumber":{},"Timestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{"ShardIterator":{}}}},"IncreaseStreamRetentionPeriod":{"input":{"type":"structure","required":["StreamName","RetentionPeriodHours"],"members":{"StreamName":{},"RetentionPeriodHours":{"type":"integer"}}}},"ListShards":{"input":{"type":"structure","members":{"StreamName":{},"NextToken":{},"ExclusiveStartShardId":{},"MaxResults":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{"Shards":{"shape":"Sl"},"NextToken":{}}}},"ListStreams":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"ExclusiveStartStreamName":{}}},"output":{"type":"structure","required":["StreamNames","HasMoreStreams"],"members":{"StreamNames":{"type":"list","member":{}},"HasMoreStreams":{"type":"boolean"}}}},"ListTagsForStream":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{},"ExclusiveStartTagKey":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","required":["Tags","HasMoreTags"],"members":{"Tags":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"HasMoreTags":{"type":"boolean"}}}},"MergeShards":{"input":{"type":"structure","required":["StreamName","ShardToMerge","AdjacentShardToMerge"],"members":{"StreamName":{},"ShardToMerge":{},"AdjacentShardToMerge":{}}}},"PutRecord":{"input":{"type":"structure","required":["StreamName","Data","PartitionKey"],"members":{"StreamName":{},"Data":{"type":"blob"},"PartitionKey":{},"ExplicitHashKey":{},"SequenceNumberForOrdering":{}}},"output":{"type":"structure","required":["ShardId","SequenceNumber"],"members":{"ShardId":{},"SequenceNumber":{},"EncryptionType":{}}}},"PutRecords":{"input":{"type":"structure","required":["Records","StreamName"],"members":{"Records":{"type":"list","member":{"type":"structure","required":["Data","PartitionKey"],"members":{"Data":{"type":"blob"},"ExplicitHashKey":{},"PartitionKey":{}}}},"StreamName":{}}},"output":{"type":"structure","required":["Records"],"members":{"FailedRecordCount":{"type":"integer"},"Records":{"type":"list","member":{"type":"structure","members":{"SequenceNumber":{},"ShardId":{},"ErrorCode":{},"ErrorMessage":{}}}},"EncryptionType":{}}}},"RemoveTagsFromStream":{"input":{"type":"structure","required":["StreamName","TagKeys"],"members":{"StreamName":{},"TagKeys":{"type":"list","member":{}}}}},"SplitShard":{"input":{"type":"structure","required":["StreamName","ShardToSplit","NewStartingHashKey"],"members":{"StreamName":{},"ShardToSplit":{},"NewStartingHashKey":{}}}},"StartStreamEncryption":{"input":{"type":"structure","required":["StreamName","EncryptionType","KeyId"],"members":{"StreamName":{},"EncryptionType":{},"KeyId":{}}}},"StopStreamEncryption":{"input":{"type":"structure","required":["StreamName","EncryptionType","KeyId"],"members":{"StreamName":{},"EncryptionType":{},"KeyId":{}}}},"UpdateShardCount":{"input":{"type":"structure","required":["StreamName","TargetShardCount","ScalingType"],"members":{"StreamName":{},"TargetShardCount":{"type":"integer"},"ScalingType":{}}},"output":{"type":"structure","members":{"StreamName":{},"CurrentShardCount":{"type":"integer"},"TargetShardCount":{"type":"integer"}}}}},"shapes":{"Sl":{"type":"list","member":{"type":"structure","required":["ShardId","HashKeyRange","SequenceNumberRange"],"members":{"ShardId":{},"ParentShardId":{},"AdjacentParentShardId":{},"HashKeyRange":{"type":"structure","required":["StartingHashKey","EndingHashKey"],"members":{"StartingHashKey":{},"EndingHashKey":{}}},"SequenceNumberRange":{"type":"structure","required":["StartingSequenceNumber"],"members":{"StartingSequenceNumber":{},"EndingSequenceNumber":{}}}}}},"St":{"type":"list","member":{"type":"structure","members":{"ShardLevelMetrics":{"shape":"Sv"}}}},"Sv":{"type":"list","member":{}},"S13":{"type":"structure","members":{"StreamName":{},"CurrentShardLevelMetrics":{"shape":"Sv"},"DesiredShardLevelMetrics":{"shape":"Sv"}}}}}

/***/ }),
/* 2866 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeStream":{"input_token":"ExclusiveStartShardId","limit_key":"Limit","more_results":"StreamDescription.HasMoreShards","output_token":"StreamDescription.Shards[-1].ShardId","result_key":"StreamDescription.Shards"},"ListStreams":{"input_token":"ExclusiveStartStreamName","limit_key":"Limit","more_results":"HasMoreStreams","output_token":"StreamNames[-1]","result_key":"StreamNames"}}}

/***/ }),
/* 2867 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"StreamExists":{"delay":10,"operation":"DescribeStream","maxAttempts":18,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"success","argument":"StreamDescription.StreamStatus"}]},"StreamNotExists":{"delay":10,"operation":"DescribeStream","maxAttempts":18,"acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}

/***/ }),
/* 2868 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['kms'] = {};
AWS.KMS = Service.defineService('kms', ['2014-11-01']);
Object.defineProperty(apiLoader.services['kms'], '2014-11-01', {
  get: function get() {
    var model = __webpack_require__(2869);
    model.paginators = __webpack_require__(2870).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.KMS;


/***/ }),
/* 2869 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-01","endpointPrefix":"kms","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"KMS","serviceFullName":"AWS Key Management Service","serviceId":"KMS","signatureVersion":"v4","targetPrefix":"TrentService","uid":"kms-2014-11-01"},"operations":{"CancelKeyDeletion":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}},"output":{"type":"structure","members":{"KeyId":{}}}},"CreateAlias":{"input":{"type":"structure","required":["AliasName","TargetKeyId"],"members":{"AliasName":{},"TargetKeyId":{}}}},"CreateGrant":{"input":{"type":"structure","required":["KeyId","GranteePrincipal","Operations"],"members":{"KeyId":{},"GranteePrincipal":{},"RetiringPrincipal":{},"Operations":{"shape":"S8"},"Constraints":{"shape":"Sa"},"GrantTokens":{"shape":"Se"},"Name":{}}},"output":{"type":"structure","members":{"GrantToken":{},"GrantId":{}}}},"CreateKey":{"input":{"type":"structure","members":{"Policy":{},"Description":{},"KeyUsage":{},"Origin":{},"BypassPolicyLockoutSafetyCheck":{"type":"boolean"},"Tags":{"shape":"Sp"}}},"output":{"type":"structure","members":{"KeyMetadata":{"shape":"Su"}}}},"Decrypt":{"input":{"type":"structure","required":["CiphertextBlob"],"members":{"CiphertextBlob":{"type":"blob"},"EncryptionContext":{"shape":"Sb"},"GrantTokens":{"shape":"Se"}}},"output":{"type":"structure","members":{"KeyId":{},"Plaintext":{"shape":"S14"}}}},"DeleteAlias":{"input":{"type":"structure","required":["AliasName"],"members":{"AliasName":{}}}},"DeleteImportedKeyMaterial":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"DescribeKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"GrantTokens":{"shape":"Se"}}},"output":{"type":"structure","members":{"KeyMetadata":{"shape":"Su"}}}},"DisableKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"DisableKeyRotation":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"EnableKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"EnableKeyRotation":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"Encrypt":{"input":{"type":"structure","required":["KeyId","Plaintext"],"members":{"KeyId":{},"Plaintext":{"shape":"S14"},"EncryptionContext":{"shape":"Sb"},"GrantTokens":{"shape":"Se"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"KeyId":{}}}},"GenerateDataKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"EncryptionContext":{"shape":"Sb"},"NumberOfBytes":{"type":"integer"},"KeySpec":{},"GrantTokens":{"shape":"Se"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"Plaintext":{"shape":"S14"},"KeyId":{}}}},"GenerateDataKeyWithoutPlaintext":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"EncryptionContext":{"shape":"Sb"},"KeySpec":{},"NumberOfBytes":{"type":"integer"},"GrantTokens":{"shape":"Se"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"KeyId":{}}}},"GenerateRandom":{"input":{"type":"structure","members":{"NumberOfBytes":{"type":"integer"}}},"output":{"type":"structure","members":{"Plaintext":{"shape":"S14"}}}},"GetKeyPolicy":{"input":{"type":"structure","required":["KeyId","PolicyName"],"members":{"KeyId":{},"PolicyName":{}}},"output":{"type":"structure","members":{"Policy":{}}}},"GetKeyRotationStatus":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}},"output":{"type":"structure","members":{"KeyRotationEnabled":{"type":"boolean"}}}},"GetParametersForImport":{"input":{"type":"structure","required":["KeyId","WrappingAlgorithm","WrappingKeySpec"],"members":{"KeyId":{},"WrappingAlgorithm":{},"WrappingKeySpec":{}}},"output":{"type":"structure","members":{"KeyId":{},"ImportToken":{"type":"blob"},"PublicKey":{"shape":"S14"},"ParametersValidTo":{"type":"timestamp"}}}},"ImportKeyMaterial":{"input":{"type":"structure","required":["KeyId","ImportToken","EncryptedKeyMaterial"],"members":{"KeyId":{},"ImportToken":{"type":"blob"},"EncryptedKeyMaterial":{"type":"blob"},"ValidTo":{"type":"timestamp"},"ExpirationModel":{}}},"output":{"type":"structure","members":{}}},"ListAliases":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Aliases":{"type":"list","member":{"type":"structure","members":{"AliasName":{},"AliasArn":{},"TargetKeyId":{}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListGrants":{"input":{"type":"structure","required":["KeyId"],"members":{"Limit":{"type":"integer"},"Marker":{},"KeyId":{}}},"output":{"shape":"S25"}},"ListKeyPolicies":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"PolicyNames":{"type":"list","member":{}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListKeys":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Keys":{"type":"list","member":{"type":"structure","members":{"KeyId":{},"KeyArn":{}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListResourceTags":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sp"},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListRetirableGrants":{"input":{"type":"structure","required":["RetiringPrincipal"],"members":{"Limit":{"type":"integer"},"Marker":{},"RetiringPrincipal":{}}},"output":{"shape":"S25"}},"PutKeyPolicy":{"input":{"type":"structure","required":["KeyId","PolicyName","Policy"],"members":{"KeyId":{},"PolicyName":{},"Policy":{},"BypassPolicyLockoutSafetyCheck":{"type":"boolean"}}}},"ReEncrypt":{"input":{"type":"structure","required":["CiphertextBlob","DestinationKeyId"],"members":{"CiphertextBlob":{"type":"blob"},"SourceEncryptionContext":{"shape":"Sb"},"DestinationKeyId":{},"DestinationEncryptionContext":{"shape":"Sb"},"GrantTokens":{"shape":"Se"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"SourceKeyId":{},"KeyId":{}}}},"RetireGrant":{"input":{"type":"structure","members":{"GrantToken":{},"KeyId":{},"GrantId":{}}}},"RevokeGrant":{"input":{"type":"structure","required":["KeyId","GrantId"],"members":{"KeyId":{},"GrantId":{}}}},"ScheduleKeyDeletion":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"PendingWindowInDays":{"type":"integer"}}},"output":{"type":"structure","members":{"KeyId":{},"DeletionDate":{"type":"timestamp"}}}},"TagResource":{"input":{"type":"structure","required":["KeyId","Tags"],"members":{"KeyId":{},"Tags":{"shape":"Sp"}}}},"UntagResource":{"input":{"type":"structure","required":["KeyId","TagKeys"],"members":{"KeyId":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateAlias":{"input":{"type":"structure","required":["AliasName","TargetKeyId"],"members":{"AliasName":{},"TargetKeyId":{}}}},"UpdateKeyDescription":{"input":{"type":"structure","required":["KeyId","Description"],"members":{"KeyId":{},"Description":{}}}}},"shapes":{"S8":{"type":"list","member":{}},"Sa":{"type":"structure","members":{"EncryptionContextSubset":{"shape":"Sb"},"EncryptionContextEquals":{"shape":"Sb"}}},"Sb":{"type":"map","key":{},"value":{}},"Se":{"type":"list","member":{}},"Sp":{"type":"list","member":{"type":"structure","required":["TagKey","TagValue"],"members":{"TagKey":{},"TagValue":{}}}},"Su":{"type":"structure","required":["KeyId"],"members":{"AWSAccountId":{},"KeyId":{},"Arn":{},"CreationDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"Description":{},"KeyUsage":{},"KeyState":{},"DeletionDate":{"type":"timestamp"},"ValidTo":{"type":"timestamp"},"Origin":{},"ExpirationModel":{},"KeyManager":{}}},"S14":{"type":"blob","sensitive":true},"S25":{"type":"structure","members":{"Grants":{"type":"list","member":{"type":"structure","members":{"KeyId":{},"GrantId":{},"Name":{},"CreationDate":{"type":"timestamp"},"GranteePrincipal":{},"RetiringPrincipal":{},"IssuingAccount":{},"Operations":{"shape":"S8"},"Constraints":{"shape":"Sa"}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}}}

/***/ }),
/* 2870 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListAliases":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Aliases"},"ListGrants":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Grants"},"ListKeyPolicies":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"PolicyNames"},"ListKeys":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Keys"}}}

/***/ }),
/* 2871 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['lambda'] = {};
AWS.Lambda = Service.defineService('lambda', ['2014-11-11', '2015-03-31']);
__webpack_require__(2872);
Object.defineProperty(apiLoader.services['lambda'], '2014-11-11', {
  get: function get() {
    var model = __webpack_require__(2873);
    model.paginators = __webpack_require__(2874).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['lambda'], '2015-03-31', {
  get: function get() {
    var model = __webpack_require__(2875);
    model.paginators = __webpack_require__(2876).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Lambda;


/***/ }),
/* 2872 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);

AWS.util.update(AWS.Lambda.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    if (request.operation === 'invoke') {
      request.addListener('extractData', AWS.util.convertPayloadToString);
    }
  }
});



/***/ }),
/* 2873 */
/***/ (function(module, exports) {

module.exports = {"metadata":{"apiVersion":"2014-11-11","endpointPrefix":"lambda","serviceFullName":"AWS Lambda","signatureVersion":"v4","protocol":"rest-json"},"operations":{"AddEventSource":{"http":{"requestUri":"/2014-11-13/event-source-mappings/"},"input":{"type":"structure","required":["EventSource","FunctionName","Role"],"members":{"EventSource":{},"FunctionName":{},"Role":{},"BatchSize":{"type":"integer"},"Parameters":{"shape":"S6"}}},"output":{"shape":"S7"}},"DeleteFunction":{"http":{"method":"DELETE","requestUri":"/2014-11-13/functions/{FunctionName}","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}}},"GetEventSource":{"http":{"method":"GET","requestUri":"/2014-11-13/event-source-mappings/{UUID}","responseCode":200},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}},"output":{"shape":"S7"}},"GetFunction":{"http":{"method":"GET","requestUri":"/2014-11-13/functions/{FunctionName}","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"type":"structure","members":{"Configuration":{"shape":"Se"},"Code":{"type":"structure","members":{"RepositoryType":{},"Location":{}}}}}},"GetFunctionConfiguration":{"http":{"method":"GET","requestUri":"/2014-11-13/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"shape":"Se"}},"InvokeAsync":{"http":{"requestUri":"/2014-11-13/functions/{FunctionName}/invoke-async/","responseCode":202},"input":{"type":"structure","required":["FunctionName","InvokeArgs"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvokeArgs":{"shape":"Sq"}},"payload":"InvokeArgs"},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"}}}},"ListEventSources":{"http":{"method":"GET","requestUri":"/2014-11-13/event-source-mappings/","responseCode":200},"input":{"type":"structure","members":{"EventSourceArn":{"location":"querystring","locationName":"EventSource"},"FunctionName":{"location":"querystring","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"EventSources":{"type":"list","member":{"shape":"S7"}}}}},"ListFunctions":{"http":{"method":"GET","requestUri":"/2014-11-13/functions/","responseCode":200},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Functions":{"type":"list","member":{"shape":"Se"}}}}},"RemoveEventSource":{"http":{"method":"DELETE","requestUri":"/2014-11-13/event-source-mappings/{UUID}","responseCode":204},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}}},"UpdateFunctionConfiguration":{"http":{"method":"PUT","requestUri":"/2014-11-13/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Role":{"location":"querystring","locationName":"Role"},"Handler":{"location":"querystring","locationName":"Handler"},"Description":{"location":"querystring","locationName":"Description"},"Timeout":{"location":"querystring","locationName":"Timeout","type":"integer"},"MemorySize":{"location":"querystring","locationName":"MemorySize","type":"integer"}}},"output":{"shape":"Se"}},"UploadFunction":{"http":{"method":"PUT","requestUri":"/2014-11-13/functions/{FunctionName}","responseCode":201},"input":{"type":"structure","required":["FunctionName","FunctionZip","Runtime","Role","Handler","Mode"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"FunctionZip":{"shape":"Sq"},"Runtime":{"location":"querystring","locationName":"Runtime"},"Role":{"location":"querystring","locationName":"Role"},"Handler":{"location":"querystring","locationName":"Handler"},"Mode":{"location":"querystring","locationName":"Mode"},"Description":{"location":"querystring","locationName":"Description"},"Timeout":{"location":"querystring","locationName":"Timeout","type":"integer"},"MemorySize":{"location":"querystring","locationName":"MemorySize","type":"integer"}},"payload":"FunctionZip"},"output":{"shape":"Se"}}},"shapes":{"S6":{"type":"map","key":{},"value":{}},"S7":{"type":"structure","members":{"UUID":{},"BatchSize":{"type":"integer"},"EventSource":{},"FunctionName":{},"Parameters":{"shape":"S6"},"Role":{},"LastModified":{"type":"timestamp"},"IsActive":{"type":"boolean"},"Status":{}}},"Se":{"type":"structure","members":{"FunctionName":{},"FunctionARN":{},"ConfigurationId":{},"Runtime":{},"Role":{},"Handler":{},"Mode":{},"CodeSize":{"type":"long"},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"LastModified":{"type":"timestamp"}}},"Sq":{"type":"blob","streaming":true}}}

/***/ }),
/* 2874 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListEventSources":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems","result_key":"EventSources"},"ListFunctions":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems","result_key":"Functions"}}}

/***/ }),
/* 2875 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-03-31","endpointPrefix":"lambda","protocol":"rest-json","serviceFullName":"AWS Lambda","serviceId":"Lambda","signatureVersion":"v4","uid":"lambda-2015-03-31"},"operations":{"AddPermission":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/policy","responseCode":201},"input":{"type":"structure","required":["FunctionName","StatementId","Action","Principal"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"StatementId":{},"Action":{},"Principal":{},"SourceArn":{},"SourceAccount":{},"EventSourceToken":{},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"RevisionId":{}}},"output":{"type":"structure","members":{"Statement":{}}}},"CreateAlias":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/aliases","responseCode":201},"input":{"type":"structure","required":["FunctionName","Name","FunctionVersion"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{},"FunctionVersion":{},"Description":{},"RoutingConfig":{"shape":"Sg"}}},"output":{"shape":"Sk"}},"CreateEventSourceMapping":{"http":{"requestUri":"/2015-03-31/event-source-mappings/","responseCode":202},"input":{"type":"structure","required":["EventSourceArn","FunctionName","StartingPosition"],"members":{"EventSourceArn":{},"FunctionName":{},"Enabled":{"type":"boolean"},"BatchSize":{"type":"integer"},"StartingPosition":{},"StartingPositionTimestamp":{"type":"timestamp"}}},"output":{"shape":"Sr"}},"CreateFunction":{"http":{"requestUri":"/2015-03-31/functions","responseCode":201},"input":{"type":"structure","required":["FunctionName","Runtime","Role","Handler","Code"],"members":{"FunctionName":{},"Runtime":{},"Role":{},"Handler":{},"Code":{"type":"structure","members":{"ZipFile":{"shape":"Sx"},"S3Bucket":{},"S3Key":{},"S3ObjectVersion":{}}},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"Publish":{"type":"boolean"},"VpcConfig":{"shape":"S14"},"DeadLetterConfig":{"shape":"S19"},"Environment":{"shape":"S1b"},"KMSKeyArn":{},"TracingConfig":{"shape":"S1g"},"Tags":{"shape":"S1i"}}},"output":{"shape":"S1l"}},"DeleteAlias":{"http":{"method":"DELETE","requestUri":"/2015-03-31/functions/{FunctionName}/aliases/{Name}","responseCode":204},"input":{"type":"structure","required":["FunctionName","Name"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{"location":"uri","locationName":"Name"}}}},"DeleteEventSourceMapping":{"http":{"method":"DELETE","requestUri":"/2015-03-31/event-source-mappings/{UUID}","responseCode":202},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}},"output":{"shape":"Sr"}},"DeleteFunction":{"http":{"method":"DELETE","requestUri":"/2015-03-31/functions/{FunctionName}","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}}},"DeleteFunctionConcurrency":{"http":{"method":"DELETE","requestUri":"/2017-10-31/functions/{FunctionName}/concurrency","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}}},"GetAccountSettings":{"http":{"method":"GET","requestUri":"/2016-08-19/account-settings/","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AccountLimit":{"type":"structure","members":{"TotalCodeSize":{"type":"long"},"CodeSizeUnzipped":{"type":"long"},"CodeSizeZipped":{"type":"long"},"ConcurrentExecutions":{"type":"integer"},"UnreservedConcurrentExecutions":{"type":"integer"}}},"AccountUsage":{"type":"structure","members":{"TotalCodeSize":{"type":"long"},"FunctionCount":{"type":"long"}}}}}},"GetAlias":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/aliases/{Name}","responseCode":200},"input":{"type":"structure","required":["FunctionName","Name"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{"location":"uri","locationName":"Name"}}},"output":{"shape":"Sk"}},"GetEventSourceMapping":{"http":{"method":"GET","requestUri":"/2015-03-31/event-source-mappings/{UUID}","responseCode":200},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}},"output":{"shape":"Sr"}},"GetFunction":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","members":{"Configuration":{"shape":"S1l"},"Code":{"type":"structure","members":{"RepositoryType":{},"Location":{}}},"Tags":{"shape":"S1i"},"Concurrency":{"shape":"S2b"}}}},"GetFunctionConfiguration":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"shape":"S1l"}},"GetPolicy":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/policy","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","members":{"Policy":{},"RevisionId":{}}}},"Invoke":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/invocations"},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvocationType":{"location":"header","locationName":"X-Amz-Invocation-Type"},"LogType":{"location":"header","locationName":"X-Amz-Log-Type"},"ClientContext":{"location":"header","locationName":"X-Amz-Client-Context"},"Payload":{"shape":"Sx"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}},"payload":"Payload"},"output":{"type":"structure","members":{"StatusCode":{"location":"statusCode","type":"integer"},"FunctionError":{"location":"header","locationName":"X-Amz-Function-Error"},"LogResult":{"location":"header","locationName":"X-Amz-Log-Result"},"Payload":{"shape":"Sx"},"ExecutedVersion":{"location":"header","locationName":"X-Amz-Executed-Version"}},"payload":"Payload"}},"InvokeAsync":{"http":{"requestUri":"/2014-11-13/functions/{FunctionName}/invoke-async/","responseCode":202},"input":{"type":"structure","required":["FunctionName","InvokeArgs"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvokeArgs":{"type":"blob","streaming":true}},"deprecated":true,"payload":"InvokeArgs"},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"}},"deprecated":true},"deprecated":true},"ListAliases":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/aliases","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"FunctionVersion":{"location":"querystring","locationName":"FunctionVersion"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Aliases":{"type":"list","member":{"shape":"Sk"}}}}},"ListEventSourceMappings":{"http":{"method":"GET","requestUri":"/2015-03-31/event-source-mappings/","responseCode":200},"input":{"type":"structure","members":{"EventSourceArn":{"location":"querystring","locationName":"EventSourceArn"},"FunctionName":{"location":"querystring","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"EventSourceMappings":{"type":"list","member":{"shape":"Sr"}}}}},"ListFunctions":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/","responseCode":200},"input":{"type":"structure","members":{"MasterRegion":{"location":"querystring","locationName":"MasterRegion"},"FunctionVersion":{"location":"querystring","locationName":"FunctionVersion"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Functions":{"shape":"S2z"}}}},"ListTags":{"http":{"method":"GET","requestUri":"/2017-03-31/tags/{ARN}"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"uri","locationName":"ARN"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S1i"}}}},"ListVersionsByFunction":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/versions","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Versions":{"shape":"S2z"}}}},"PublishVersion":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/versions","responseCode":201},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"CodeSha256":{},"Description":{},"RevisionId":{}}},"output":{"shape":"S1l"}},"PutFunctionConcurrency":{"http":{"method":"PUT","requestUri":"/2017-10-31/functions/{FunctionName}/concurrency","responseCode":200},"input":{"type":"structure","required":["FunctionName","ReservedConcurrentExecutions"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"ReservedConcurrentExecutions":{"type":"integer"}}},"output":{"shape":"S2b"}},"RemovePermission":{"http":{"method":"DELETE","requestUri":"/2015-03-31/functions/{FunctionName}/policy/{StatementId}","responseCode":204},"input":{"type":"structure","required":["FunctionName","StatementId"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"StatementId":{"location":"uri","locationName":"StatementId"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"RevisionId":{"location":"querystring","locationName":"RevisionId"}}}},"TagResource":{"http":{"requestUri":"/2017-03-31/tags/{ARN}","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"uri","locationName":"ARN"},"Tags":{"shape":"S1i"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/2017-03-31/tags/{ARN}","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"uri","locationName":"ARN"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}}},"UpdateAlias":{"http":{"method":"PUT","requestUri":"/2015-03-31/functions/{FunctionName}/aliases/{Name}","responseCode":200},"input":{"type":"structure","required":["FunctionName","Name"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{"location":"uri","locationName":"Name"},"FunctionVersion":{},"Description":{},"RoutingConfig":{"shape":"Sg"},"RevisionId":{}}},"output":{"shape":"Sk"}},"UpdateEventSourceMapping":{"http":{"method":"PUT","requestUri":"/2015-03-31/event-source-mappings/{UUID}","responseCode":202},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"},"FunctionName":{},"Enabled":{"type":"boolean"},"BatchSize":{"type":"integer"}}},"output":{"shape":"Sr"}},"UpdateFunctionCode":{"http":{"method":"PUT","requestUri":"/2015-03-31/functions/{FunctionName}/code","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"ZipFile":{"shape":"Sx"},"S3Bucket":{},"S3Key":{},"S3ObjectVersion":{},"Publish":{"type":"boolean"},"DryRun":{"type":"boolean"},"RevisionId":{}}},"output":{"shape":"S1l"}},"UpdateFunctionConfiguration":{"http":{"method":"PUT","requestUri":"/2015-03-31/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Role":{},"Handler":{},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"VpcConfig":{"shape":"S14"},"Environment":{"shape":"S1b"},"Runtime":{},"DeadLetterConfig":{"shape":"S19"},"KMSKeyArn":{},"TracingConfig":{"shape":"S1g"},"RevisionId":{}}},"output":{"shape":"S1l"}}},"shapes":{"Sg":{"type":"structure","members":{"AdditionalVersionWeights":{"type":"map","key":{},"value":{"type":"double"}}}},"Sk":{"type":"structure","members":{"AliasArn":{},"Name":{},"FunctionVersion":{},"Description":{},"RoutingConfig":{"shape":"Sg"},"RevisionId":{}}},"Sr":{"type":"structure","members":{"UUID":{},"BatchSize":{"type":"integer"},"EventSourceArn":{},"FunctionArn":{},"LastModified":{"type":"timestamp"},"LastProcessingResult":{},"State":{},"StateTransitionReason":{}}},"Sx":{"type":"blob","sensitive":true},"S14":{"type":"structure","members":{"SubnetIds":{"shape":"S15"},"SecurityGroupIds":{"shape":"S17"}}},"S15":{"type":"list","member":{}},"S17":{"type":"list","member":{}},"S19":{"type":"structure","members":{"TargetArn":{}}},"S1b":{"type":"structure","members":{"Variables":{"shape":"S1c"}}},"S1c":{"type":"map","key":{"type":"string","sensitive":true},"value":{"type":"string","sensitive":true},"sensitive":true},"S1g":{"type":"structure","members":{"Mode":{}}},"S1i":{"type":"map","key":{},"value":{}},"S1l":{"type":"structure","members":{"FunctionName":{},"FunctionArn":{},"Runtime":{},"Role":{},"Handler":{},"CodeSize":{"type":"long"},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"LastModified":{},"CodeSha256":{},"Version":{},"VpcConfig":{"type":"structure","members":{"SubnetIds":{"shape":"S15"},"SecurityGroupIds":{"shape":"S17"},"VpcId":{}}},"DeadLetterConfig":{"shape":"S19"},"Environment":{"type":"structure","members":{"Variables":{"shape":"S1c"},"Error":{"type":"structure","members":{"ErrorCode":{},"Message":{"type":"string","sensitive":true}}}}},"KMSKeyArn":{},"TracingConfig":{"type":"structure","members":{"Mode":{}}},"MasterArn":{},"RevisionId":{}}},"S2b":{"type":"structure","members":{"ReservedConcurrentExecutions":{"type":"integer"}}},"S2z":{"type":"list","member":{"shape":"S1l"}}}}

/***/ }),
/* 2876 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListEventSourceMappings":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"EventSourceMappings"},"ListFunctions":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"Functions"}}}

/***/ }),
/* 2877 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['lexruntime'] = {};
AWS.LexRuntime = Service.defineService('lexruntime', ['2016-11-28']);
Object.defineProperty(apiLoader.services['lexruntime'], '2016-11-28', {
  get: function get() {
    var model = __webpack_require__(2878);
    model.paginators = __webpack_require__(2879).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.LexRuntime;


/***/ }),
/* 2878 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-28","endpointPrefix":"runtime.lex","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Lex Runtime Service","serviceId":"Lex Runtime Service","signatureVersion":"v4","signingName":"lex","uid":"runtime.lex-2016-11-28"},"operations":{"PostContent":{"http":{"requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/content"},"input":{"type":"structure","required":["botName","botAlias","userId","contentType","inputStream"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"sessionAttributes":{"shape":"S5","jsonvalue":true,"location":"header","locationName":"x-amz-lex-session-attributes"},"requestAttributes":{"shape":"S5","jsonvalue":true,"location":"header","locationName":"x-amz-lex-request-attributes"},"contentType":{"location":"header","locationName":"Content-Type"},"accept":{"location":"header","locationName":"Accept"},"inputStream":{"shape":"S8"}},"payload":"inputStream"},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"intentName":{"location":"header","locationName":"x-amz-lex-intent-name"},"slots":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-slots"},"sessionAttributes":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-session-attributes"},"message":{"shape":"Sc","location":"header","locationName":"x-amz-lex-message"},"messageFormat":{"location":"header","locationName":"x-amz-lex-message-format"},"dialogState":{"location":"header","locationName":"x-amz-lex-dialog-state"},"slotToElicit":{"location":"header","locationName":"x-amz-lex-slot-to-elicit"},"inputTranscript":{"location":"header","locationName":"x-amz-lex-input-transcript"},"audioStream":{"shape":"S8"}},"payload":"audioStream"},"authtype":"v4-unsigned-body"},"PostText":{"http":{"requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/text"},"input":{"type":"structure","required":["botName","botAlias","userId","inputText"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"sessionAttributes":{"shape":"Sg"},"requestAttributes":{"shape":"Sg"},"inputText":{"shape":"Sc"}}},"output":{"type":"structure","members":{"intentName":{},"slots":{"shape":"Sg"},"sessionAttributes":{"shape":"Sg"},"message":{"shape":"Sc"},"messageFormat":{},"dialogState":{},"slotToElicit":{},"responseCard":{"type":"structure","members":{"version":{},"contentType":{},"genericAttachments":{"type":"list","member":{"type":"structure","members":{"title":{},"subTitle":{},"attachmentLinkUrl":{},"imageUrl":{},"buttons":{"type":"list","member":{"type":"structure","required":["text","value"],"members":{"text":{},"value":{}}}}}}}}}}}}},"shapes":{"S5":{"type":"string","sensitive":true},"S8":{"type":"blob","streaming":true},"Sc":{"type":"string","sensitive":true},"Sg":{"type":"map","key":{},"value":{},"sensitive":true}}}

/***/ }),
/* 2879 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 2880 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['machinelearning'] = {};
AWS.MachineLearning = Service.defineService('machinelearning', ['2014-12-12']);
__webpack_require__(2881);
Object.defineProperty(apiLoader.services['machinelearning'], '2014-12-12', {
  get: function get() {
    var model = __webpack_require__(2882);
    model.paginators = __webpack_require__(2883).pagination;
    model.waiters = __webpack_require__(2884).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.MachineLearning;


/***/ }),
/* 2881 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);

AWS.util.update(AWS.MachineLearning.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    if (request.operation === 'predict') {
      request.addListener('build', this.buildEndpoint);
    }
  },

  /**
   * Updates request endpoint from PredictEndpoint
   * @api private
   */
  buildEndpoint: function buildEndpoint(request) {
    var url = request.params.PredictEndpoint;
    if (url) {
      request.httpRequest.endpoint = new AWS.Endpoint(url);
    }
  }

});


/***/ }),
/* 2882 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"uid":"machinelearning-2014-12-12","apiVersion":"2014-12-12","endpointPrefix":"machinelearning","jsonVersion":"1.1","serviceFullName":"Amazon Machine Learning","signatureVersion":"v4","targetPrefix":"AmazonML_20141212","protocol":"json"},"operations":{"AddTags":{"input":{"type":"structure","required":["Tags","ResourceId","ResourceType"],"members":{"Tags":{"shape":"S2"},"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceId":{},"ResourceType":{}}}},"CreateBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId","MLModelId","BatchPredictionDataSourceId","OutputUri"],"members":{"BatchPredictionId":{},"BatchPredictionName":{},"MLModelId":{},"BatchPredictionDataSourceId":{},"OutputUri":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{}}}},"CreateDataSourceFromRDS":{"input":{"type":"structure","required":["DataSourceId","RDSData","RoleARN"],"members":{"DataSourceId":{},"DataSourceName":{},"RDSData":{"type":"structure","required":["DatabaseInformation","SelectSqlQuery","DatabaseCredentials","S3StagingLocation","ResourceRole","ServiceRole","SubnetId","SecurityGroupIds"],"members":{"DatabaseInformation":{"shape":"Sf"},"SelectSqlQuery":{},"DatabaseCredentials":{"type":"structure","required":["Username","Password"],"members":{"Username":{},"Password":{}}},"S3StagingLocation":{},"DataRearrangement":{},"DataSchema":{},"DataSchemaUri":{},"ResourceRole":{},"ServiceRole":{},"SubnetId":{},"SecurityGroupIds":{"type":"list","member":{}}}},"RoleARN":{},"ComputeStatistics":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"CreateDataSourceFromRedshift":{"input":{"type":"structure","required":["DataSourceId","DataSpec","RoleARN"],"members":{"DataSourceId":{},"DataSourceName":{},"DataSpec":{"type":"structure","required":["DatabaseInformation","SelectSqlQuery","DatabaseCredentials","S3StagingLocation"],"members":{"DatabaseInformation":{"shape":"Sy"},"SelectSqlQuery":{},"DatabaseCredentials":{"type":"structure","required":["Username","Password"],"members":{"Username":{},"Password":{}}},"S3StagingLocation":{},"DataRearrangement":{},"DataSchema":{},"DataSchemaUri":{}}},"RoleARN":{},"ComputeStatistics":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"CreateDataSourceFromS3":{"input":{"type":"structure","required":["DataSourceId","DataSpec"],"members":{"DataSourceId":{},"DataSourceName":{},"DataSpec":{"type":"structure","required":["DataLocationS3"],"members":{"DataLocationS3":{},"DataRearrangement":{},"DataSchema":{},"DataSchemaLocationS3":{}}},"ComputeStatistics":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"CreateEvaluation":{"input":{"type":"structure","required":["EvaluationId","MLModelId","EvaluationDataSourceId"],"members":{"EvaluationId":{},"EvaluationName":{},"MLModelId":{},"EvaluationDataSourceId":{}}},"output":{"type":"structure","members":{"EvaluationId":{}}}},"CreateMLModel":{"input":{"type":"structure","required":["MLModelId","MLModelType","TrainingDataSourceId"],"members":{"MLModelId":{},"MLModelName":{},"MLModelType":{},"Parameters":{"shape":"S1d"},"TrainingDataSourceId":{},"Recipe":{},"RecipeUri":{}}},"output":{"type":"structure","members":{"MLModelId":{}}}},"CreateRealtimeEndpoint":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{}}},"output":{"type":"structure","members":{"MLModelId":{},"RealtimeEndpointInfo":{"shape":"S1j"}}}},"DeleteBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId"],"members":{"BatchPredictionId":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{}}}},"DeleteDataSource":{"input":{"type":"structure","required":["DataSourceId"],"members":{"DataSourceId":{}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"DeleteEvaluation":{"input":{"type":"structure","required":["EvaluationId"],"members":{"EvaluationId":{}}},"output":{"type":"structure","members":{"EvaluationId":{}}}},"DeleteMLModel":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{}}},"output":{"type":"structure","members":{"MLModelId":{}}}},"DeleteRealtimeEndpoint":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{}}},"output":{"type":"structure","members":{"MLModelId":{},"RealtimeEndpointInfo":{"shape":"S1j"}}}},"DeleteTags":{"input":{"type":"structure","required":["TagKeys","ResourceId","ResourceType"],"members":{"TagKeys":{"type":"list","member":{}},"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceId":{},"ResourceType":{}}}},"DescribeBatchPredictions":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"BatchPredictionId":{},"MLModelId":{},"BatchPredictionDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"OutputUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"TotalRecordCount":{"type":"long"},"InvalidRecordCount":{"type":"long"}}}},"NextToken":{}}}},"DescribeDataSources":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"DataSourceId":{},"DataLocationS3":{},"DataRearrangement":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"DataSizeInBytes":{"type":"long"},"NumberOfFiles":{"type":"long"},"Name":{},"Status":{},"Message":{},"RedshiftMetadata":{"shape":"S2i"},"RDSMetadata":{"shape":"S2j"},"RoleARN":{},"ComputeStatistics":{"type":"boolean"},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeEvaluations":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"EvaluationId":{},"MLModelId":{},"EvaluationDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"PerformanceMetrics":{"shape":"S2q"},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMLModels":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"MLModelId":{},"TrainingDataSourceId":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"SizeInBytes":{"type":"long"},"EndpointInfo":{"shape":"S1j"},"TrainingParameters":{"shape":"S1d"},"InputDataLocationS3":{},"Algorithm":{},"MLModelType":{},"ScoreThreshold":{"type":"float"},"ScoreThresholdLastUpdatedAt":{"type":"timestamp"},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeTags":{"input":{"type":"structure","required":["ResourceId","ResourceType"],"members":{"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceId":{},"ResourceType":{},"Tags":{"shape":"S2"}}}},"GetBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId"],"members":{"BatchPredictionId":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{},"MLModelId":{},"BatchPredictionDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"OutputUri":{},"LogUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"TotalRecordCount":{"type":"long"},"InvalidRecordCount":{"type":"long"}}}},"GetDataSource":{"input":{"type":"structure","required":["DataSourceId"],"members":{"DataSourceId":{},"Verbose":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{},"DataLocationS3":{},"DataRearrangement":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"DataSizeInBytes":{"type":"long"},"NumberOfFiles":{"type":"long"},"Name":{},"Status":{},"LogUri":{},"Message":{},"RedshiftMetadata":{"shape":"S2i"},"RDSMetadata":{"shape":"S2j"},"RoleARN":{},"ComputeStatistics":{"type":"boolean"},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"DataSourceSchema":{}}}},"GetEvaluation":{"input":{"type":"structure","required":["EvaluationId"],"members":{"EvaluationId":{}}},"output":{"type":"structure","members":{"EvaluationId":{},"MLModelId":{},"EvaluationDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"PerformanceMetrics":{"shape":"S2q"},"LogUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"GetMLModel":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{},"Verbose":{"type":"boolean"}}},"output":{"type":"structure","members":{"MLModelId":{},"TrainingDataSourceId":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"SizeInBytes":{"type":"long"},"EndpointInfo":{"shape":"S1j"},"TrainingParameters":{"shape":"S1d"},"InputDataLocationS3":{},"MLModelType":{},"ScoreThreshold":{"type":"float"},"ScoreThresholdLastUpdatedAt":{"type":"timestamp"},"LogUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"Recipe":{},"Schema":{}}}},"Predict":{"input":{"type":"structure","required":["MLModelId","Record","PredictEndpoint"],"members":{"MLModelId":{},"Record":{"type":"map","key":{},"value":{}},"PredictEndpoint":{}}},"output":{"type":"structure","members":{"Prediction":{"type":"structure","members":{"predictedLabel":{},"predictedValue":{"type":"float"},"predictedScores":{"type":"map","key":{},"value":{"type":"float"}},"details":{"type":"map","key":{},"value":{}}}}}}},"UpdateBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId","BatchPredictionName"],"members":{"BatchPredictionId":{},"BatchPredictionName":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{}}}},"UpdateDataSource":{"input":{"type":"structure","required":["DataSourceId","DataSourceName"],"members":{"DataSourceId":{},"DataSourceName":{}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"UpdateEvaluation":{"input":{"type":"structure","required":["EvaluationId","EvaluationName"],"members":{"EvaluationId":{},"EvaluationName":{}}},"output":{"type":"structure","members":{"EvaluationId":{}}}},"UpdateMLModel":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{},"MLModelName":{},"ScoreThreshold":{"type":"float"}}},"output":{"type":"structure","members":{"MLModelId":{}}}}},"shapes":{"S2":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Sf":{"type":"structure","required":["InstanceIdentifier","DatabaseName"],"members":{"InstanceIdentifier":{},"DatabaseName":{}}},"Sy":{"type":"structure","required":["DatabaseName","ClusterIdentifier"],"members":{"DatabaseName":{},"ClusterIdentifier":{}}},"S1d":{"type":"map","key":{},"value":{}},"S1j":{"type":"structure","members":{"PeakRequestsPerSecond":{"type":"integer"},"CreatedAt":{"type":"timestamp"},"EndpointUrl":{},"EndpointStatus":{}}},"S2i":{"type":"structure","members":{"RedshiftDatabase":{"shape":"Sy"},"DatabaseUserName":{},"SelectSqlQuery":{}}},"S2j":{"type":"structure","members":{"Database":{"shape":"Sf"},"DatabaseUserName":{},"SelectSqlQuery":{},"ResourceRole":{},"ServiceRole":{},"DataPipelineId":{}}},"S2q":{"type":"structure","members":{"Properties":{"type":"map","key":{},"value":{}}}}},"examples":{}}

/***/ }),
/* 2883 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeBatchPredictions":{"limit_key":"Limit","output_token":"NextToken","input_token":"NextToken","result_key":"Results"},"DescribeDataSources":{"limit_key":"Limit","output_token":"NextToken","input_token":"NextToken","result_key":"Results"},"DescribeEvaluations":{"limit_key":"Limit","output_token":"NextToken","input_token":"NextToken","result_key":"Results"},"DescribeMLModels":{"limit_key":"Limit","output_token":"NextToken","input_token":"NextToken","result_key":"Results"}}}

/***/ }),
/* 2884 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DataSourceAvailable":{"delay":30,"operation":"DescribeDataSources","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]},"MLModelAvailable":{"delay":30,"operation":"DescribeMLModels","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]},"EvaluationAvailable":{"delay":30,"operation":"DescribeEvaluations","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]},"BatchPredictionAvailable":{"delay":30,"operation":"DescribeBatchPredictions","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]}}}

/***/ }),
/* 2885 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['marketplacecommerceanalytics'] = {};
AWS.MarketplaceCommerceAnalytics = Service.defineService('marketplacecommerceanalytics', ['2015-07-01']);
Object.defineProperty(apiLoader.services['marketplacecommerceanalytics'], '2015-07-01', {
  get: function get() {
    var model = __webpack_require__(2886);
    model.paginators = __webpack_require__(2887).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.MarketplaceCommerceAnalytics;


/***/ }),
/* 2886 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-07-01","endpointPrefix":"marketplacecommerceanalytics","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Marketplace Commerce Analytics","signatureVersion":"v4","signingName":"marketplacecommerceanalytics","targetPrefix":"MarketplaceCommerceAnalytics20150701","uid":"marketplacecommerceanalytics-2015-07-01"},"operations":{"GenerateDataSet":{"input":{"type":"structure","required":["dataSetType","dataSetPublicationDate","roleNameArn","destinationS3BucketName","snsTopicArn"],"members":{"dataSetType":{},"dataSetPublicationDate":{"type":"timestamp"},"roleNameArn":{},"destinationS3BucketName":{},"destinationS3Prefix":{},"snsTopicArn":{},"customerDefinedValues":{"shape":"S8"}}},"output":{"type":"structure","members":{"dataSetRequestId":{}}}},"StartSupportDataExport":{"input":{"type":"structure","required":["dataSetType","fromDate","roleNameArn","destinationS3BucketName","snsTopicArn"],"members":{"dataSetType":{},"fromDate":{"type":"timestamp"},"roleNameArn":{},"destinationS3BucketName":{},"destinationS3Prefix":{},"snsTopicArn":{},"customerDefinedValues":{"shape":"S8"}}},"output":{"type":"structure","members":{"dataSetRequestId":{}}}}},"shapes":{"S8":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 2887 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 2888 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['mturk'] = {};
AWS.MTurk = Service.defineService('mturk', ['2017-01-17']);
Object.defineProperty(apiLoader.services['mturk'], '2017-01-17', {
  get: function get() {
    var model = __webpack_require__(2889);
    model.paginators = __webpack_require__(2890).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.MTurk;


/***/ }),
/* 2889 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-01-17","endpointPrefix":"mturk-requester","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon MTurk","serviceFullName":"Amazon Mechanical Turk","signatureVersion":"v4","targetPrefix":"MTurkRequesterServiceV20170117","uid":"mturk-requester-2017-01-17"},"operations":{"AcceptQualificationRequest":{"input":{"type":"structure","required":["QualificationRequestId"],"members":{"QualificationRequestId":{},"IntegerValue":{"type":"integer"}}},"output":{"type":"structure","members":{}}},"ApproveAssignment":{"input":{"type":"structure","required":["AssignmentId"],"members":{"AssignmentId":{},"RequesterFeedback":{},"OverrideRejection":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"AssociateQualificationWithWorker":{"input":{"type":"structure","required":["QualificationTypeId","WorkerId"],"members":{"QualificationTypeId":{},"WorkerId":{},"IntegerValue":{"type":"integer"},"SendNotification":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"CreateAdditionalAssignmentsForHIT":{"input":{"type":"structure","required":["HITId","NumberOfAdditionalAssignments"],"members":{"HITId":{},"NumberOfAdditionalAssignments":{"type":"integer"},"UniqueRequestToken":{}}},"output":{"type":"structure","members":{}}},"CreateHIT":{"input":{"type":"structure","required":["LifetimeInSeconds","AssignmentDurationInSeconds","Reward","Title","Description"],"members":{"MaxAssignments":{"type":"integer"},"AutoApprovalDelayInSeconds":{"type":"long"},"LifetimeInSeconds":{"type":"long"},"AssignmentDurationInSeconds":{"type":"long"},"Reward":{},"Title":{},"Keywords":{},"Description":{},"Question":{},"RequesterAnnotation":{},"QualificationRequirements":{"shape":"Si"},"UniqueRequestToken":{},"AssignmentReviewPolicy":{"shape":"Sp"},"HITReviewPolicy":{"shape":"Sp"},"HITLayoutId":{},"HITLayoutParameters":{"shape":"Sv"}}},"output":{"type":"structure","members":{"HIT":{"shape":"Sy"}}}},"CreateHITType":{"input":{"type":"structure","required":["AssignmentDurationInSeconds","Reward","Title","Description"],"members":{"AutoApprovalDelayInSeconds":{"type":"long"},"AssignmentDurationInSeconds":{"type":"long"},"Reward":{},"Title":{},"Keywords":{},"Description":{},"QualificationRequirements":{"shape":"Si"}}},"output":{"type":"structure","members":{"HITTypeId":{}}},"idempotent":true},"CreateHITWithHITType":{"input":{"type":"structure","required":["HITTypeId","LifetimeInSeconds"],"members":{"HITTypeId":{},"MaxAssignments":{"type":"integer"},"LifetimeInSeconds":{"type":"long"},"Question":{},"RequesterAnnotation":{},"UniqueRequestToken":{},"AssignmentReviewPolicy":{"shape":"Sp"},"HITReviewPolicy":{"shape":"Sp"},"HITLayoutId":{},"HITLayoutParameters":{"shape":"Sv"}}},"output":{"type":"structure","members":{"HIT":{"shape":"Sy"}}}},"CreateQualificationType":{"input":{"type":"structure","required":["Name","Description","QualificationTypeStatus"],"members":{"Name":{},"Keywords":{},"Description":{},"QualificationTypeStatus":{},"RetryDelayInSeconds":{"type":"long"},"Test":{},"AnswerKey":{},"TestDurationInSeconds":{"type":"long"},"AutoGranted":{"type":"boolean"},"AutoGrantedValue":{"type":"integer"}}},"output":{"type":"structure","members":{"QualificationType":{"shape":"S19"}}}},"CreateWorkerBlock":{"input":{"type":"structure","required":["WorkerId","Reason"],"members":{"WorkerId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"DeleteHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteWorkerBlock":{"input":{"type":"structure","required":["WorkerId"],"members":{"WorkerId":{},"Reason":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DisassociateQualificationFromWorker":{"input":{"type":"structure","required":["WorkerId","QualificationTypeId"],"members":{"WorkerId":{},"QualificationTypeId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"GetAccountBalance":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AvailableBalance":{},"OnHoldBalance":{}}},"idempotent":true},"GetAssignment":{"input":{"type":"structure","required":["AssignmentId"],"members":{"AssignmentId":{}}},"output":{"type":"structure","members":{"Assignment":{"shape":"S1o"},"HIT":{"shape":"Sy"}}},"idempotent":true},"GetFileUploadURL":{"input":{"type":"structure","required":["AssignmentId","QuestionIdentifier"],"members":{"AssignmentId":{},"QuestionIdentifier":{}}},"output":{"type":"structure","members":{"FileUploadURL":{}}},"idempotent":true},"GetHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{}}},"output":{"type":"structure","members":{"HIT":{"shape":"Sy"}}},"idempotent":true},"GetQualificationScore":{"input":{"type":"structure","required":["QualificationTypeId","WorkerId"],"members":{"QualificationTypeId":{},"WorkerId":{}}},"output":{"type":"structure","members":{"Qualification":{"shape":"S1w"}}},"idempotent":true},"GetQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{}}},"output":{"type":"structure","members":{"QualificationType":{"shape":"S19"}}},"idempotent":true},"ListAssignmentsForHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{},"NextToken":{},"MaxResults":{"type":"integer"},"AssignmentStatuses":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"Assignments":{"type":"list","member":{"shape":"S1o"}}}},"idempotent":true},"ListBonusPayments":{"input":{"type":"structure","members":{"HITId":{},"AssignmentId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NumResults":{"type":"integer"},"NextToken":{},"BonusPayments":{"type":"list","member":{"type":"structure","members":{"WorkerId":{},"BonusAmount":{},"AssignmentId":{},"Reason":{},"GrantTime":{"type":"timestamp"}}}}}},"idempotent":true},"ListHITs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"HITs":{"shape":"S2c"}}},"idempotent":true},"ListHITsForQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"HITs":{"shape":"S2c"}}},"idempotent":true},"ListQualificationRequests":{"input":{"type":"structure","members":{"QualificationTypeId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NumResults":{"type":"integer"},"NextToken":{},"QualificationRequests":{"type":"list","member":{"type":"structure","members":{"QualificationRequestId":{},"QualificationTypeId":{},"WorkerId":{},"Test":{},"Answer":{},"SubmitTime":{"type":"timestamp"}}}}}},"idempotent":true},"ListQualificationTypes":{"input":{"type":"structure","required":["MustBeRequestable"],"members":{"Query":{},"MustBeRequestable":{"type":"boolean"},"MustBeOwnedByCaller":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NumResults":{"type":"integer"},"NextToken":{},"QualificationTypes":{"type":"list","member":{"shape":"S19"}}}},"idempotent":true},"ListReviewPolicyResultsForHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{},"PolicyLevels":{"type":"list","member":{}},"RetrieveActions":{"type":"boolean"},"RetrieveResults":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"HITId":{},"AssignmentReviewPolicy":{"shape":"Sp"},"HITReviewPolicy":{"shape":"Sp"},"AssignmentReviewReport":{"shape":"S2q"},"HITReviewReport":{"shape":"S2q"},"NextToken":{}}},"idempotent":true},"ListReviewableHITs":{"input":{"type":"structure","members":{"HITTypeId":{},"Status":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"HITs":{"shape":"S2c"}}},"idempotent":true},"ListWorkerBlocks":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"WorkerBlocks":{"type":"list","member":{"type":"structure","members":{"WorkerId":{},"Reason":{}}}}}},"idempotent":true},"ListWorkersWithQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{},"Status":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"Qualifications":{"type":"list","member":{"shape":"S1w"}}}},"idempotent":true},"NotifyWorkers":{"input":{"type":"structure","required":["Subject","MessageText","WorkerIds"],"members":{"Subject":{},"MessageText":{},"WorkerIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"NotifyWorkersFailureStatuses":{"type":"list","member":{"type":"structure","members":{"NotifyWorkersFailureCode":{},"NotifyWorkersFailureMessage":{},"WorkerId":{}}}}}}},"RejectAssignment":{"input":{"type":"structure","required":["AssignmentId","RequesterFeedback"],"members":{"AssignmentId":{},"RequesterFeedback":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"RejectQualificationRequest":{"input":{"type":"structure","required":["QualificationRequestId"],"members":{"QualificationRequestId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"SendBonus":{"input":{"type":"structure","required":["WorkerId","BonusAmount","AssignmentId","Reason"],"members":{"WorkerId":{},"BonusAmount":{},"AssignmentId":{},"Reason":{},"UniqueRequestToken":{}}},"output":{"type":"structure","members":{}}},"SendTestEventNotification":{"input":{"type":"structure","required":["Notification","TestEventType"],"members":{"Notification":{"shape":"S3j"},"TestEventType":{}}},"output":{"type":"structure","members":{}}},"UpdateExpirationForHIT":{"input":{"type":"structure","required":["HITId","ExpireAt"],"members":{"HITId":{},"ExpireAt":{"type":"timestamp"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateHITReviewStatus":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{},"Revert":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateHITTypeOfHIT":{"input":{"type":"structure","required":["HITId","HITTypeId"],"members":{"HITId":{},"HITTypeId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateNotificationSettings":{"input":{"type":"structure","required":["HITTypeId"],"members":{"HITTypeId":{},"Notification":{"shape":"S3j"},"Active":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{},"Description":{},"QualificationTypeStatus":{},"Test":{},"AnswerKey":{},"TestDurationInSeconds":{"type":"long"},"RetryDelayInSeconds":{"type":"long"},"AutoGranted":{"type":"boolean"},"AutoGrantedValue":{"type":"integer"}}},"output":{"type":"structure","members":{"QualificationType":{"shape":"S19"}}}}},"shapes":{"Si":{"type":"list","member":{"type":"structure","required":["QualificationTypeId","Comparator"],"members":{"QualificationTypeId":{},"Comparator":{},"IntegerValues":{"type":"list","member":{"type":"integer"}},"LocaleValues":{"type":"list","member":{"shape":"Sn"}},"RequiredToPreview":{"type":"boolean"}}}},"Sn":{"type":"structure","required":["Country"],"members":{"Country":{},"Subdivision":{}}},"Sp":{"type":"structure","required":["PolicyName"],"members":{"PolicyName":{},"Parameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"shape":"Ss"},"MapEntries":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"shape":"Ss"}}}}}}}}},"Ss":{"type":"list","member":{}},"Sv":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"Sy":{"type":"structure","members":{"HITId":{},"HITTypeId":{},"HITGroupId":{},"HITLayoutId":{},"CreationTime":{"type":"timestamp"},"Title":{},"Description":{},"Question":{},"Keywords":{},"HITStatus":{},"MaxAssignments":{"type":"integer"},"Reward":{},"AutoApprovalDelayInSeconds":{"type":"long"},"Expiration":{"type":"timestamp"},"AssignmentDurationInSeconds":{"type":"long"},"RequesterAnnotation":{},"QualificationRequirements":{"shape":"Si"},"HITReviewStatus":{},"NumberOfAssignmentsPending":{"type":"integer"},"NumberOfAssignmentsAvailable":{"type":"integer"},"NumberOfAssignmentsCompleted":{"type":"integer"}}},"S19":{"type":"structure","members":{"QualificationTypeId":{},"CreationTime":{"type":"timestamp"},"Name":{},"Description":{},"Keywords":{},"QualificationTypeStatus":{},"Test":{},"TestDurationInSeconds":{"type":"long"},"AnswerKey":{},"RetryDelayInSeconds":{"type":"long"},"IsRequestable":{"type":"boolean"},"AutoGranted":{"type":"boolean"},"AutoGrantedValue":{"type":"integer"}}},"S1o":{"type":"structure","members":{"AssignmentId":{},"WorkerId":{},"HITId":{},"AssignmentStatus":{},"AutoApprovalTime":{"type":"timestamp"},"AcceptTime":{"type":"timestamp"},"SubmitTime":{"type":"timestamp"},"ApprovalTime":{"type":"timestamp"},"RejectionTime":{"type":"timestamp"},"Deadline":{"type":"timestamp"},"Answer":{},"RequesterFeedback":{}}},"S1w":{"type":"structure","members":{"QualificationTypeId":{},"WorkerId":{},"GrantTime":{"type":"timestamp"},"IntegerValue":{"type":"integer"},"LocaleValue":{"shape":"Sn"},"Status":{}}},"S2c":{"type":"list","member":{"shape":"Sy"}},"S2q":{"type":"structure","members":{"ReviewResults":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"SubjectId":{},"SubjectType":{},"QuestionId":{},"Key":{},"Value":{}}}},"ReviewActions":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"ActionName":{},"TargetId":{},"TargetType":{},"Status":{},"CompleteTime":{"type":"timestamp"},"Result":{},"ErrorCode":{}}}}}},"S3j":{"type":"structure","required":["Destination","Transport","Version","EventTypes"],"members":{"Destination":{},"Transport":{},"Version":{},"EventTypes":{"type":"list","member":{}}}}}}

/***/ }),
/* 2890 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListAssignmentsForHIT":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListBonusPayments":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListHITs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListHITsForQualificationType":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListQualificationRequests":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListQualificationTypes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListReviewPolicyResultsForHIT":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListReviewableHITs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWorkerBlocks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWorkersWithQualificationType":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 2891 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['mobileanalytics'] = {};
AWS.MobileAnalytics = Service.defineService('mobileanalytics', ['2014-06-05']);
Object.defineProperty(apiLoader.services['mobileanalytics'], '2014-06-05', {
  get: function get() {
    var model = __webpack_require__(2892);
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.MobileAnalytics;


/***/ }),
/* 2892 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-05","endpointPrefix":"mobileanalytics","serviceFullName":"Amazon Mobile Analytics","signatureVersion":"v4","protocol":"rest-json"},"operations":{"PutEvents":{"http":{"requestUri":"/2014-06-05/events","responseCode":202},"input":{"type":"structure","required":["events","clientContext"],"members":{"events":{"type":"list","member":{"type":"structure","required":["eventType","timestamp"],"members":{"eventType":{},"timestamp":{},"session":{"type":"structure","members":{"id":{},"duration":{"type":"long"},"startTimestamp":{},"stopTimestamp":{}}},"version":{},"attributes":{"type":"map","key":{},"value":{}},"metrics":{"type":"map","key":{},"value":{"type":"double"}}}}},"clientContext":{"location":"header","locationName":"x-amz-Client-Context"},"clientContextEncoding":{"location":"header","locationName":"x-amz-Client-Context-Encoding"}}}}},"shapes":{}}

/***/ }),
/* 2893 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['opsworks'] = {};
AWS.OpsWorks = Service.defineService('opsworks', ['2013-02-18']);
Object.defineProperty(apiLoader.services['opsworks'], '2013-02-18', {
  get: function get() {
    var model = __webpack_require__(2894);
    model.paginators = __webpack_require__(2895).pagination;
    model.waiters = __webpack_require__(2896).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.OpsWorks;


/***/ }),
/* 2894 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-02-18","endpointPrefix":"opsworks","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS OpsWorks","serviceId":"OpsWorks","signatureVersion":"v4","targetPrefix":"OpsWorks_20130218","uid":"opsworks-2013-02-18"},"operations":{"AssignInstance":{"input":{"type":"structure","required":["InstanceId","LayerIds"],"members":{"InstanceId":{},"LayerIds":{"shape":"S3"}}}},"AssignVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{},"InstanceId":{}}}},"AssociateElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{},"InstanceId":{}}}},"AttachElasticLoadBalancer":{"input":{"type":"structure","required":["ElasticLoadBalancerName","LayerId"],"members":{"ElasticLoadBalancerName":{},"LayerId":{}}}},"CloneStack":{"input":{"type":"structure","required":["SourceStackId","ServiceRoleArn"],"members":{"SourceStackId":{},"Name":{},"Region":{},"VpcId":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"UseOpsworksSecurityGroups":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"ClonePermissions":{"type":"boolean"},"CloneAppIds":{"shape":"S3"},"DefaultRootDeviceType":{},"AgentVersion":{}}},"output":{"type":"structure","members":{"StackId":{}}}},"CreateApp":{"input":{"type":"structure","required":["StackId","Name","Type"],"members":{"StackId":{},"Shortname":{},"Name":{},"Description":{},"DataSources":{"shape":"Si"},"Type":{},"AppSource":{"shape":"Sd"},"Domains":{"shape":"S3"},"EnableSsl":{"type":"boolean"},"SslConfiguration":{"shape":"Sl"},"Attributes":{"shape":"Sm"},"Environment":{"shape":"So"}}},"output":{"type":"structure","members":{"AppId":{}}}},"CreateDeployment":{"input":{"type":"structure","required":["StackId","Command"],"members":{"StackId":{},"AppId":{},"InstanceIds":{"shape":"S3"},"LayerIds":{"shape":"S3"},"Command":{"shape":"Ss"},"Comment":{},"CustomJson":{}}},"output":{"type":"structure","members":{"DeploymentId":{}}}},"CreateInstance":{"input":{"type":"structure","required":["StackId","LayerIds","InstanceType"],"members":{"StackId":{},"LayerIds":{"shape":"S3"},"InstanceType":{},"AutoScalingType":{},"Hostname":{},"Os":{},"AmiId":{},"SshKeyName":{},"AvailabilityZone":{},"VirtualizationType":{},"SubnetId":{},"Architecture":{},"RootDeviceType":{},"BlockDeviceMappings":{"shape":"Sz"},"InstallUpdatesOnBoot":{"type":"boolean"},"EbsOptimized":{"type":"boolean"},"AgentVersion":{},"Tenancy":{}}},"output":{"type":"structure","members":{"InstanceId":{}}}},"CreateLayer":{"input":{"type":"structure","required":["StackId","Type","Name","Shortname"],"members":{"StackId":{},"Type":{},"Name":{},"Shortname":{},"Attributes":{"shape":"S17"},"CloudWatchLogsConfiguration":{"shape":"S19"},"CustomInstanceProfileArn":{},"CustomJson":{},"CustomSecurityGroupIds":{"shape":"S3"},"Packages":{"shape":"S3"},"VolumeConfigurations":{"shape":"S1f"},"EnableAutoHealing":{"type":"boolean"},"AutoAssignElasticIps":{"type":"boolean"},"AutoAssignPublicIps":{"type":"boolean"},"CustomRecipes":{"shape":"S1h"},"InstallUpdatesOnBoot":{"type":"boolean"},"UseEbsOptimizedInstances":{"type":"boolean"},"LifecycleEventConfiguration":{"shape":"S1i"}}},"output":{"type":"structure","members":{"LayerId":{}}}},"CreateStack":{"input":{"type":"structure","required":["Name","Region","ServiceRoleArn","DefaultInstanceProfileArn"],"members":{"Name":{},"Region":{},"VpcId":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"UseOpsworksSecurityGroups":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"DefaultRootDeviceType":{},"AgentVersion":{}}},"output":{"type":"structure","members":{"StackId":{}}}},"CreateUserProfile":{"input":{"type":"structure","required":["IamUserArn"],"members":{"IamUserArn":{},"SshUsername":{},"SshPublicKey":{},"AllowSelfManagement":{"type":"boolean"}}},"output":{"type":"structure","members":{"IamUserArn":{}}}},"DeleteApp":{"input":{"type":"structure","required":["AppId"],"members":{"AppId":{}}}},"DeleteInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DeleteElasticIp":{"type":"boolean"},"DeleteVolumes":{"type":"boolean"}}}},"DeleteLayer":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{}}}},"DeleteStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}}},"DeleteUserProfile":{"input":{"type":"structure","required":["IamUserArn"],"members":{"IamUserArn":{}}}},"DeregisterEcsCluster":{"input":{"type":"structure","required":["EcsClusterArn"],"members":{"EcsClusterArn":{}}}},"DeregisterElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{}}}},"DeregisterInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"DeregisterRdsDbInstance":{"input":{"type":"structure","required":["RdsDbInstanceArn"],"members":{"RdsDbInstanceArn":{}}}},"DeregisterVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{}}}},"DescribeAgentVersions":{"input":{"type":"structure","members":{"StackId":{},"ConfigurationManager":{"shape":"Sa"}}},"output":{"type":"structure","members":{"AgentVersions":{"type":"list","member":{"type":"structure","members":{"Version":{},"ConfigurationManager":{"shape":"Sa"}}}}}}},"DescribeApps":{"input":{"type":"structure","members":{"StackId":{},"AppIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Apps":{"type":"list","member":{"type":"structure","members":{"AppId":{},"StackId":{},"Shortname":{},"Name":{},"Description":{},"DataSources":{"shape":"Si"},"Type":{},"AppSource":{"shape":"Sd"},"Domains":{"shape":"S3"},"EnableSsl":{"type":"boolean"},"SslConfiguration":{"shape":"Sl"},"Attributes":{"shape":"Sm"},"CreatedAt":{},"Environment":{"shape":"So"}}}}}}},"DescribeCommands":{"input":{"type":"structure","members":{"DeploymentId":{},"InstanceId":{},"CommandIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Commands":{"type":"list","member":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"DeploymentId":{},"CreatedAt":{},"AcknowledgedAt":{},"CompletedAt":{},"Status":{},"ExitCode":{"type":"integer"},"LogUrl":{},"Type":{}}}}}}},"DescribeDeployments":{"input":{"type":"structure","members":{"StackId":{},"AppId":{},"DeploymentIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Deployments":{"type":"list","member":{"type":"structure","members":{"DeploymentId":{},"StackId":{},"AppId":{},"CreatedAt":{},"CompletedAt":{},"Duration":{"type":"integer"},"IamUserArn":{},"Comment":{},"Command":{"shape":"Ss"},"Status":{},"CustomJson":{},"InstanceIds":{"shape":"S3"}}}}}}},"DescribeEcsClusters":{"input":{"type":"structure","members":{"EcsClusterArns":{"shape":"S3"},"StackId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EcsClusters":{"type":"list","member":{"type":"structure","members":{"EcsClusterArn":{},"EcsClusterName":{},"StackId":{},"RegisteredAt":{}}}},"NextToken":{}}}},"DescribeElasticIps":{"input":{"type":"structure","members":{"InstanceId":{},"StackId":{},"Ips":{"shape":"S3"}}},"output":{"type":"structure","members":{"ElasticIps":{"type":"list","member":{"type":"structure","members":{"Ip":{},"Name":{},"Domain":{},"Region":{},"InstanceId":{}}}}}}},"DescribeElasticLoadBalancers":{"input":{"type":"structure","members":{"StackId":{},"LayerIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"ElasticLoadBalancers":{"type":"list","member":{"type":"structure","members":{"ElasticLoadBalancerName":{},"Region":{},"DnsName":{},"StackId":{},"LayerId":{},"VpcId":{},"AvailabilityZones":{"shape":"S3"},"SubnetIds":{"shape":"S3"},"Ec2InstanceIds":{"shape":"S3"}}}}}}},"DescribeInstances":{"input":{"type":"structure","members":{"StackId":{},"LayerId":{},"InstanceIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"AgentVersion":{},"AmiId":{},"Architecture":{},"Arn":{},"AutoScalingType":{},"AvailabilityZone":{},"BlockDeviceMappings":{"shape":"Sz"},"CreatedAt":{},"EbsOptimized":{"type":"boolean"},"Ec2InstanceId":{},"EcsClusterArn":{},"EcsContainerInstanceArn":{},"ElasticIp":{},"Hostname":{},"InfrastructureClass":{},"InstallUpdatesOnBoot":{"type":"boolean"},"InstanceId":{},"InstanceProfileArn":{},"InstanceType":{},"LastServiceErrorId":{},"LayerIds":{"shape":"S3"},"Os":{},"Platform":{},"PrivateDns":{},"PrivateIp":{},"PublicDns":{},"PublicIp":{},"RegisteredBy":{},"ReportedAgentVersion":{},"ReportedOs":{"type":"structure","members":{"Family":{},"Name":{},"Version":{}}},"RootDeviceType":{},"RootDeviceVolumeId":{},"SecurityGroupIds":{"shape":"S3"},"SshHostDsaKeyFingerprint":{},"SshHostRsaKeyFingerprint":{},"SshKeyName":{},"StackId":{},"Status":{},"SubnetId":{},"Tenancy":{},"VirtualizationType":{}}}}}}},"DescribeLayers":{"input":{"type":"structure","members":{"StackId":{},"LayerIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Layers":{"type":"list","member":{"type":"structure","members":{"Arn":{},"StackId":{},"LayerId":{},"Type":{},"Name":{},"Shortname":{},"Attributes":{"shape":"S17"},"CloudWatchLogsConfiguration":{"shape":"S19"},"CustomInstanceProfileArn":{},"CustomJson":{},"CustomSecurityGroupIds":{"shape":"S3"},"DefaultSecurityGroupNames":{"shape":"S3"},"Packages":{"shape":"S3"},"VolumeConfigurations":{"shape":"S1f"},"EnableAutoHealing":{"type":"boolean"},"AutoAssignElasticIps":{"type":"boolean"},"AutoAssignPublicIps":{"type":"boolean"},"DefaultRecipes":{"shape":"S1h"},"CustomRecipes":{"shape":"S1h"},"CreatedAt":{},"InstallUpdatesOnBoot":{"type":"boolean"},"UseEbsOptimizedInstances":{"type":"boolean"},"LifecycleEventConfiguration":{"shape":"S1i"}}}}}}},"DescribeLoadBasedAutoScaling":{"input":{"type":"structure","required":["LayerIds"],"members":{"LayerIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"LoadBasedAutoScalingConfigurations":{"type":"list","member":{"type":"structure","members":{"LayerId":{},"Enable":{"type":"boolean"},"UpScaling":{"shape":"S36"},"DownScaling":{"shape":"S36"}}}}}}},"DescribeMyUserProfile":{"output":{"type":"structure","members":{"UserProfile":{"type":"structure","members":{"IamUserArn":{},"Name":{},"SshUsername":{},"SshPublicKey":{}}}}}},"DescribeOperatingSystems":{"output":{"type":"structure","members":{"OperatingSystems":{"type":"list","member":{"type":"structure","members":{"Name":{},"Id":{},"Type":{},"ConfigurationManagers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"ReportedName":{},"ReportedVersion":{},"Supported":{"type":"boolean"}}}}}}},"DescribePermissions":{"input":{"type":"structure","members":{"IamUserArn":{},"StackId":{}}},"output":{"type":"structure","members":{"Permissions":{"type":"list","member":{"type":"structure","members":{"StackId":{},"IamUserArn":{},"AllowSsh":{"type":"boolean"},"AllowSudo":{"type":"boolean"},"Level":{}}}}}}},"DescribeRaidArrays":{"input":{"type":"structure","members":{"InstanceId":{},"StackId":{},"RaidArrayIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"RaidArrays":{"type":"list","member":{"type":"structure","members":{"RaidArrayId":{},"InstanceId":{},"Name":{},"RaidLevel":{"type":"integer"},"NumberOfDisks":{"type":"integer"},"Size":{"type":"integer"},"Device":{},"MountPoint":{},"AvailabilityZone":{},"CreatedAt":{},"StackId":{},"VolumeType":{},"Iops":{"type":"integer"}}}}}}},"DescribeRdsDbInstances":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{},"RdsDbInstanceArns":{"shape":"S3"}}},"output":{"type":"structure","members":{"RdsDbInstances":{"type":"list","member":{"type":"structure","members":{"RdsDbInstanceArn":{},"DbInstanceIdentifier":{},"DbUser":{},"DbPassword":{},"Region":{},"Address":{},"Engine":{},"StackId":{},"MissingOnRds":{"type":"boolean"}}}}}}},"DescribeServiceErrors":{"input":{"type":"structure","members":{"StackId":{},"InstanceId":{},"ServiceErrorIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"ServiceErrors":{"type":"list","member":{"type":"structure","members":{"ServiceErrorId":{},"StackId":{},"InstanceId":{},"Type":{},"Message":{},"CreatedAt":{}}}}}}},"DescribeStackProvisioningParameters":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}},"output":{"type":"structure","members":{"AgentInstallerUrl":{},"Parameters":{"type":"map","key":{},"value":{}}}}},"DescribeStackSummary":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}},"output":{"type":"structure","members":{"StackSummary":{"type":"structure","members":{"StackId":{},"Name":{},"Arn":{},"LayersCount":{"type":"integer"},"AppsCount":{"type":"integer"},"InstancesCount":{"type":"structure","members":{"Assigning":{"type":"integer"},"Booting":{"type":"integer"},"ConnectionLost":{"type":"integer"},"Deregistering":{"type":"integer"},"Online":{"type":"integer"},"Pending":{"type":"integer"},"Rebooting":{"type":"integer"},"Registered":{"type":"integer"},"Registering":{"type":"integer"},"Requested":{"type":"integer"},"RunningSetup":{"type":"integer"},"SetupFailed":{"type":"integer"},"ShuttingDown":{"type":"integer"},"StartFailed":{"type":"integer"},"StopFailed":{"type":"integer"},"Stopped":{"type":"integer"},"Stopping":{"type":"integer"},"Terminated":{"type":"integer"},"Terminating":{"type":"integer"},"Unassigning":{"type":"integer"}}}}}}}},"DescribeStacks":{"input":{"type":"structure","members":{"StackIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Stacks":{"type":"list","member":{"type":"structure","members":{"StackId":{},"Name":{},"Arn":{},"Region":{},"VpcId":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"UseOpsworksSecurityGroups":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"CreatedAt":{},"DefaultRootDeviceType":{},"AgentVersion":{}}}}}}},"DescribeTimeBasedAutoScaling":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"TimeBasedAutoScalingConfigurations":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"AutoScalingSchedule":{"shape":"S4b"}}}}}}},"DescribeUserProfiles":{"input":{"type":"structure","members":{"IamUserArns":{"shape":"S3"}}},"output":{"type":"structure","members":{"UserProfiles":{"type":"list","member":{"type":"structure","members":{"IamUserArn":{},"Name":{},"SshUsername":{},"SshPublicKey":{},"AllowSelfManagement":{"type":"boolean"}}}}}}},"DescribeVolumes":{"input":{"type":"structure","members":{"InstanceId":{},"StackId":{},"RaidArrayId":{},"VolumeIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Volumes":{"type":"list","member":{"type":"structure","members":{"VolumeId":{},"Ec2VolumeId":{},"Name":{},"RaidArrayId":{},"InstanceId":{},"Status":{},"Size":{"type":"integer"},"Device":{},"MountPoint":{},"Region":{},"AvailabilityZone":{},"VolumeType":{},"Iops":{"type":"integer"},"Encrypted":{"type":"boolean"}}}}}}},"DetachElasticLoadBalancer":{"input":{"type":"structure","required":["ElasticLoadBalancerName","LayerId"],"members":{"ElasticLoadBalancerName":{},"LayerId":{}}}},"DisassociateElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{}}}},"GetHostnameSuggestion":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{}}},"output":{"type":"structure","members":{"LayerId":{},"Hostname":{}}}},"GrantAccess":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"ValidForInMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"TemporaryCredential":{"type":"structure","members":{"Username":{},"Password":{},"ValidForInMinutes":{"type":"integer"},"InstanceId":{}}}}}},"ListTags":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S50"},"NextToken":{}}}},"RebootInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"RegisterEcsCluster":{"input":{"type":"structure","required":["EcsClusterArn","StackId"],"members":{"EcsClusterArn":{},"StackId":{}}},"output":{"type":"structure","members":{"EcsClusterArn":{}}}},"RegisterElasticIp":{"input":{"type":"structure","required":["ElasticIp","StackId"],"members":{"ElasticIp":{},"StackId":{}}},"output":{"type":"structure","members":{"ElasticIp":{}}}},"RegisterInstance":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{},"Hostname":{},"PublicIp":{},"PrivateIp":{},"RsaPublicKey":{},"RsaPublicKeyFingerprint":{},"InstanceIdentity":{"type":"structure","members":{"Document":{},"Signature":{}}}}},"output":{"type":"structure","members":{"InstanceId":{}}}},"RegisterRdsDbInstance":{"input":{"type":"structure","required":["StackId","RdsDbInstanceArn","DbUser","DbPassword"],"members":{"StackId":{},"RdsDbInstanceArn":{},"DbUser":{},"DbPassword":{}}}},"RegisterVolume":{"input":{"type":"structure","required":["StackId"],"members":{"Ec2VolumeId":{},"StackId":{}}},"output":{"type":"structure","members":{"VolumeId":{}}}},"SetLoadBasedAutoScaling":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{},"Enable":{"type":"boolean"},"UpScaling":{"shape":"S36"},"DownScaling":{"shape":"S36"}}}},"SetPermission":{"input":{"type":"structure","required":["StackId","IamUserArn"],"members":{"StackId":{},"IamUserArn":{},"AllowSsh":{"type":"boolean"},"AllowSudo":{"type":"boolean"},"Level":{}}}},"SetTimeBasedAutoScaling":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"AutoScalingSchedule":{"shape":"S4b"}}}},"StartInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"StartStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}}},"StopInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"Force":{"type":"boolean"}}}},"StopStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S50"}}}},"UnassignInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"UnassignVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateApp":{"input":{"type":"structure","required":["AppId"],"members":{"AppId":{},"Name":{},"Description":{},"DataSources":{"shape":"Si"},"Type":{},"AppSource":{"shape":"Sd"},"Domains":{"shape":"S3"},"EnableSsl":{"type":"boolean"},"SslConfiguration":{"shape":"Sl"},"Attributes":{"shape":"Sm"},"Environment":{"shape":"So"}}}},"UpdateElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{},"Name":{}}}},"UpdateInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"LayerIds":{"shape":"S3"},"InstanceType":{},"AutoScalingType":{},"Hostname":{},"Os":{},"AmiId":{},"SshKeyName":{},"Architecture":{},"InstallUpdatesOnBoot":{"type":"boolean"},"EbsOptimized":{"type":"boolean"},"AgentVersion":{}}}},"UpdateLayer":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{},"Name":{},"Shortname":{},"Attributes":{"shape":"S17"},"CloudWatchLogsConfiguration":{"shape":"S19"},"CustomInstanceProfileArn":{},"CustomJson":{},"CustomSecurityGroupIds":{"shape":"S3"},"Packages":{"shape":"S3"},"VolumeConfigurations":{"shape":"S1f"},"EnableAutoHealing":{"type":"boolean"},"AutoAssignElasticIps":{"type":"boolean"},"AutoAssignPublicIps":{"type":"boolean"},"CustomRecipes":{"shape":"S1h"},"InstallUpdatesOnBoot":{"type":"boolean"},"UseEbsOptimizedInstances":{"type":"boolean"},"LifecycleEventConfiguration":{"shape":"S1i"}}}},"UpdateMyUserProfile":{"input":{"type":"structure","members":{"SshPublicKey":{}}}},"UpdateRdsDbInstance":{"input":{"type":"structure","required":["RdsDbInstanceArn"],"members":{"RdsDbInstanceArn":{},"DbUser":{},"DbPassword":{}}}},"UpdateStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{},"Name":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"DefaultRootDeviceType":{},"UseOpsworksSecurityGroups":{"type":"boolean"},"AgentVersion":{}}}},"UpdateUserProfile":{"input":{"type":"structure","required":["IamUserArn"],"members":{"IamUserArn":{},"SshUsername":{},"SshPublicKey":{},"AllowSelfManagement":{"type":"boolean"}}}},"UpdateVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{},"Name":{},"MountPoint":{}}}}},"shapes":{"S3":{"type":"list","member":{}},"S8":{"type":"map","key":{},"value":{}},"Sa":{"type":"structure","members":{"Name":{},"Version":{}}},"Sb":{"type":"structure","members":{"ManageBerkshelf":{"type":"boolean"},"BerkshelfVersion":{}}},"Sd":{"type":"structure","members":{"Type":{},"Url":{},"Username":{},"Password":{},"SshKey":{},"Revision":{}}},"Si":{"type":"list","member":{"type":"structure","members":{"Type":{},"Arn":{},"DatabaseName":{}}}},"Sl":{"type":"structure","required":["Certificate","PrivateKey"],"members":{"Certificate":{},"PrivateKey":{},"Chain":{}}},"Sm":{"type":"map","key":{},"value":{}},"So":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{},"Secure":{"type":"boolean"}}}},"Ss":{"type":"structure","required":["Name"],"members":{"Name":{},"Args":{"type":"map","key":{},"value":{"shape":"S3"}}}},"Sz":{"type":"list","member":{"type":"structure","members":{"DeviceName":{},"NoDevice":{},"VirtualName":{},"Ebs":{"type":"structure","members":{"SnapshotId":{},"Iops":{"type":"integer"},"VolumeSize":{"type":"integer"},"VolumeType":{},"DeleteOnTermination":{"type":"boolean"}}}}}},"S17":{"type":"map","key":{},"value":{}},"S19":{"type":"structure","members":{"Enabled":{"type":"boolean"},"LogStreams":{"type":"list","member":{"type":"structure","members":{"LogGroupName":{},"DatetimeFormat":{},"TimeZone":{},"File":{},"FileFingerprintLines":{},"MultiLineStartPattern":{},"InitialPosition":{},"Encoding":{},"BufferDuration":{"type":"integer"},"BatchCount":{"type":"integer"},"BatchSize":{"type":"integer"}}}}}},"S1f":{"type":"list","member":{"type":"structure","required":["MountPoint","NumberOfDisks","Size"],"members":{"MountPoint":{},"RaidLevel":{"type":"integer"},"NumberOfDisks":{"type":"integer"},"Size":{"type":"integer"},"VolumeType":{},"Iops":{"type":"integer"},"Encrypted":{"type":"boolean"}}}},"S1h":{"type":"structure","members":{"Setup":{"shape":"S3"},"Configure":{"shape":"S3"},"Deploy":{"shape":"S3"},"Undeploy":{"shape":"S3"},"Shutdown":{"shape":"S3"}}},"S1i":{"type":"structure","members":{"Shutdown":{"type":"structure","members":{"ExecutionTimeout":{"type":"integer"},"DelayUntilElbConnectionsDrained":{"type":"boolean"}}}}},"S36":{"type":"structure","members":{"InstanceCount":{"type":"integer"},"ThresholdsWaitTime":{"type":"integer"},"IgnoreMetricsTime":{"type":"integer"},"CpuThreshold":{"type":"double"},"MemoryThreshold":{"type":"double"},"LoadThreshold":{"type":"double"},"Alarms":{"shape":"S3"}}},"S4b":{"type":"structure","members":{"Monday":{"shape":"S4c"},"Tuesday":{"shape":"S4c"},"Wednesday":{"shape":"S4c"},"Thursday":{"shape":"S4c"},"Friday":{"shape":"S4c"},"Saturday":{"shape":"S4c"},"Sunday":{"shape":"S4c"}}},"S4c":{"type":"map","key":{},"value":{}},"S50":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 2895 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeApps":{"result_key":"Apps"},"DescribeCommands":{"result_key":"Commands"},"DescribeDeployments":{"result_key":"Deployments"},"DescribeEcsClusters":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"EcsClusters"},"DescribeElasticIps":{"result_key":"ElasticIps"},"DescribeElasticLoadBalancers":{"result_key":"ElasticLoadBalancers"},"DescribeInstances":{"result_key":"Instances"},"DescribeLayers":{"result_key":"Layers"},"DescribeLoadBasedAutoScaling":{"result_key":"LoadBasedAutoScalingConfigurations"},"DescribePermissions":{"result_key":"Permissions"},"DescribeRaidArrays":{"result_key":"RaidArrays"},"DescribeServiceErrors":{"result_key":"ServiceErrors"},"DescribeStacks":{"result_key":"Stacks"},"DescribeTimeBasedAutoScaling":{"result_key":"TimeBasedAutoScalingConfigurations"},"DescribeUserProfiles":{"result_key":"UserProfiles"},"DescribeVolumes":{"result_key":"Volumes"}}}

/***/ }),
/* 2896 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"AppExists":{"delay":1,"operation":"DescribeApps","maxAttempts":40,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"matcher":"status","expected":400,"state":"failure"}]},"DeploymentSuccessful":{"delay":15,"operation":"DescribeDeployments","maxAttempts":40,"description":"Wait until a deployment has completed successfully.","acceptors":[{"expected":"successful","matcher":"pathAll","state":"success","argument":"Deployments[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"Deployments[].Status"}]},"InstanceOnline":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is online.","acceptors":[{"expected":"online","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"shutting_down","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"start_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopped","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminating","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stop_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]},"InstanceRegistered":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is registered.","acceptors":[{"expected":"registered","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"shutting_down","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopped","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminating","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stop_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]},"InstanceStopped":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is stopped.","acceptors":[{"expected":"stopped","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"booting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"requested","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"running_setup","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"start_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stop_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]},"InstanceTerminated":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is terminated.","acceptors":[{"expected":"terminated","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"ResourceNotFoundException","matcher":"error","state":"success"},{"expected":"booting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"online","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"requested","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"running_setup","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"start_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]}}}

/***/ }),
/* 2897 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['polly'] = {};
AWS.Polly = Service.defineService('polly', ['2016-06-10']);
__webpack_require__(2898);
Object.defineProperty(apiLoader.services['polly'], '2016-06-10', {
  get: function get() {
    var model = __webpack_require__(2900);
    model.paginators = __webpack_require__(2901).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Polly;


/***/ }),
/* 2898 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2899);

/***/ }),
/* 2899 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var rest = AWS.Protocol.Rest;

/**
 * A presigner object can be used to generate presigned urls for the Polly service.
 */
AWS.Polly.Presigner = AWS.util.inherit({
    /**
     * Creates a presigner object with a set of configuration options.
     *
     * @option options params [map] An optional map of parameters to bind to every
     *   request sent by this service object.
     * @option options service [AWS.Polly] An optional pre-configured instance
     *  of the AWS.Polly service object to use for requests. The object may
     *  bound parameters used by the presigner.
     * @see AWS.Polly.constructor
     */
    constructor: function Signer(options) {
        options = options || {};
        this.options = options;
        this.service = options.service;
        this.bindServiceObject(options);
        this._operations = {};
    },

    /**
     * @api private
     */
    bindServiceObject: function bindServiceObject(options) {
        options = options || {};
        if (!this.service) {
            this.service = new AWS.Polly(options);
        } else {
            var config = AWS.util.copy(this.service.config);
            this.service = new this.service.constructor.__super__(config);
            this.service.config.params = AWS.util.merge(this.service.config.params || {}, options.params);
        }
    },

    /**
     * @api private
     */
    modifyInputMembers: function modifyInputMembers(input) {
        // make copies of the input so we don't overwrite the api
        // need to be careful to copy anything we access/modify
        var modifiedInput = AWS.util.copy(input);
        modifiedInput.members = AWS.util.copy(input.members);
        AWS.util.each(input.members, function(name, member) {
            modifiedInput.members[name] = AWS.util.copy(member);
            // update location and locationName
            if (!member.location || member.location === 'body') {
                modifiedInput.members[name].location = 'querystring';
                modifiedInput.members[name].locationName = name;
            }
        });
        return modifiedInput;
    },

    /**
     * @api private
     */
    convertPostToGet: function convertPostToGet(req) {
        // convert method
        req.httpRequest.method = 'GET';

        var operation = req.service.api.operations[req.operation];
        // get cached operation input first
        var input = this._operations[req.operation];
        if (!input) {
            // modify the original input
            this._operations[req.operation] = input = this.modifyInputMembers(operation.input);
        }

        var uri = rest.generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);

        req.httpRequest.path = uri;
        req.httpRequest.body = '';

        // don't need these headers on a GET request
        delete req.httpRequest.headers['Content-Length'];
        delete req.httpRequest.headers['Content-Type'];
    },

    /**
     * @overload getSynthesizeSpeechUrl(params = {}, [expires = 3600], [callback])
     *   Generate a presigned url for {AWS.Polly.synthesizeSpeech}.
     *   @note You must ensure that you have static or previously resolved
     *     credentials if you call this method synchronously (with no callback),
     *     otherwise it may not properly sign the request. If you cannot guarantee
     *     this (you are using an asynchronous credential provider, i.e., EC2
     *     IAM roles), you should always call this method with an asynchronous
     *     callback.
     *   @param params [map] parameters to pass to the operation. See the {AWS.Polly.synthesizeSpeech}
     *     operation for the expected operation parameters.
     *   @param expires [Integer] (3600) the number of seconds to expire the pre-signed URL operation in.
     *     Defaults to 1 hour.
     *   @return [string] if called synchronously (with no callback), returns the signed URL.
     *   @return [null] nothing is returned if a callback is provided.
     *   @callback callback function (err, url)
     *     If a callback is supplied, it is called when a signed URL has been generated.
     *     @param err [Error] the error object returned from the presigner.
     *     @param url [String] the signed URL.
     *   @see AWS.Polly.synthesizeSpeech
     */
    getSynthesizeSpeechUrl: function getSynthesizeSpeechUrl(params, expires, callback) {
        var self = this;
        var request = this.service.makeRequest('synthesizeSpeech', params);
        // remove existing build listeners
        request.removeAllListeners('build');
        request.on('build', function(req) {
            self.convertPostToGet(req);
        });
        return request.presign(expires, callback);
    }
});


/***/ }),
/* 2900 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-06-10","endpointPrefix":"polly","protocol":"rest-json","serviceFullName":"Amazon Polly","serviceId":"Polly","signatureVersion":"v4","uid":"polly-2016-06-10"},"operations":{"DeleteLexicon":{"http":{"method":"DELETE","requestUri":"/v1/lexicons/{LexiconName}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{"shape":"S2","location":"uri","locationName":"LexiconName"}}},"output":{"type":"structure","members":{}}},"DescribeVoices":{"http":{"method":"GET","requestUri":"/v1/voices","responseCode":200},"input":{"type":"structure","members":{"LanguageCode":{"location":"querystring","locationName":"LanguageCode"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Voices":{"type":"list","member":{"type":"structure","members":{"Gender":{},"Id":{},"LanguageCode":{},"LanguageName":{},"Name":{}}}},"NextToken":{}}}},"GetLexicon":{"http":{"method":"GET","requestUri":"/v1/lexicons/{LexiconName}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{"shape":"S2","location":"uri","locationName":"LexiconName"}}},"output":{"type":"structure","members":{"Lexicon":{"type":"structure","members":{"Content":{},"Name":{"shape":"S2"}}},"LexiconAttributes":{"shape":"Si"}}}},"ListLexicons":{"http":{"method":"GET","requestUri":"/v1/lexicons","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Lexicons":{"type":"list","member":{"type":"structure","members":{"Name":{"shape":"S2"},"Attributes":{"shape":"Si"}}}},"NextToken":{}}}},"PutLexicon":{"http":{"method":"PUT","requestUri":"/v1/lexicons/{LexiconName}","responseCode":200},"input":{"type":"structure","required":["Name","Content"],"members":{"Name":{"shape":"S2","location":"uri","locationName":"LexiconName"},"Content":{}}},"output":{"type":"structure","members":{}}},"SynthesizeSpeech":{"http":{"requestUri":"/v1/speech","responseCode":200},"input":{"type":"structure","required":["OutputFormat","Text","VoiceId"],"members":{"LexiconNames":{"type":"list","member":{"shape":"S2"}},"OutputFormat":{},"SampleRate":{},"SpeechMarkTypes":{"type":"list","member":{}},"Text":{},"TextType":{},"VoiceId":{}}},"output":{"type":"structure","members":{"AudioStream":{"type":"blob","streaming":true},"ContentType":{"location":"header","locationName":"Content-Type"},"RequestCharacters":{"location":"header","locationName":"x-amzn-RequestCharacters","type":"integer"}},"payload":"AudioStream"}}},"shapes":{"S2":{"type":"string","sensitive":true},"Si":{"type":"structure","members":{"Alphabet":{},"LanguageCode":{},"LastModified":{"type":"timestamp"},"LexiconArn":{},"LexemesCount":{"type":"integer"},"Size":{"type":"integer"}}}}}

/***/ }),
/* 2901 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 2902 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['rds'] = {};
AWS.RDS = Service.defineService('rds', ['2013-01-10', '2013-02-12', '2013-09-09', '2014-09-01', '2014-09-01*', '2014-10-31']);
__webpack_require__(2903);
Object.defineProperty(apiLoader.services['rds'], '2013-01-10', {
  get: function get() {
    var model = __webpack_require__(2905);
    model.paginators = __webpack_require__(2906).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['rds'], '2013-02-12', {
  get: function get() {
    var model = __webpack_require__(2907);
    model.paginators = __webpack_require__(2908).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['rds'], '2013-09-09', {
  get: function get() {
    var model = __webpack_require__(2909);
    model.paginators = __webpack_require__(2910).pagination;
    model.waiters = __webpack_require__(2911).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['rds'], '2014-09-01', {
  get: function get() {
    var model = __webpack_require__(2912);
    model.paginators = __webpack_require__(2913).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['rds'], '2014-10-31', {
  get: function get() {
    var model = __webpack_require__(2914);
    model.paginators = __webpack_require__(2915).pagination;
    model.waiters = __webpack_require__(2916).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.RDS;


/***/ }),
/* 2903 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
__webpack_require__(2904);
 /**
  * @api private
  */
 var crossRegionOperations = ['copyDBSnapshot', 'createDBInstanceReadReplica', 'createDBCluster', 'copyDBClusterSnapshot'];

 AWS.util.update(AWS.RDS.prototype, {
   /**
    * @api private
    */
   setupRequestListeners: function setupRequestListeners(request) {
     if (crossRegionOperations.indexOf(request.operation) !== -1 &&
         request.params.SourceRegion) {
       request.params = AWS.util.copy(request.params);
       if (request.params.PreSignedUrl ||
           request.params.SourceRegion === this.config.region) {
         delete request.params.SourceRegion;
       } else {
         var doesParamValidation = !!this.config.paramValidation;
         // remove the validate parameters listener so we can re-add it after we build the URL
         if (doesParamValidation) {
           request.removeListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
         }
         request.onAsync('validate', this.buildCrossRegionPresignedUrl);
         if (doesParamValidation) {
           request.addListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
         }
       }
     }
   },

   /**
    * @api private
    */
   buildCrossRegionPresignedUrl: function buildCrossRegionPresignedUrl(req, done) {
     var config = AWS.util.copy(req.service.config);
     config.region = req.params.SourceRegion;
     delete req.params.SourceRegion;
     delete config.endpoint;
     // relevant params for the operation will already be in req.params
     delete config.params;
     config.signatureVersion = 'v4';
     var destinationRegion = req.service.config.region;

     var svc = new req.service.constructor(config);
     var newReq = svc[req.operation](AWS.util.copy(req.params));
     newReq.on('build', function addDestinationRegionParam(request) {
       var httpRequest = request.httpRequest;
       httpRequest.params.DestinationRegion = destinationRegion;
       httpRequest.body = AWS.util.queryParamsToString(httpRequest.params);
     });
     newReq.presign(function(err, url) {
       if (err) done(err);
       else {
         req.params.PreSignedUrl = url;
         done();
       }
     });
   }
 });

/***/ }),
/* 2904 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);

/**
 * @api private
 */
var service = null;

/**
 * @api private
 */
var api = {
    signatureVersion: 'v4',
    signingName: 'rds-db'
};

/**
 * @api private
 */
var requiredAuthTokenOptions = {
    region: 'string',
    hostname: 'string',
    port: 'number',
    username: 'string'
};

/**
 * A signer object can be used to generate an auth token to a database.
 */
AWS.RDS.Signer = AWS.util.inherit({
    /**
     * Creates a signer object can be used to generate an auth token.
     *
     * @option options credentials [AWS.Credentials] the AWS credentials
     *   to sign requests with. Uses the default credential provider chain
     *   if not specified.
     * @option options hostname [String] the hostname of the database to connect to.
     * @option options port [Number] the port number the database is listening on.
     * @option options region [String] the region the database is located in.
     * @option options username [String] the username to login as.
     * @example Passing in options to constructor
     *   var signer = new AWS.RDS.Signer({
     *     credentials: new AWS.SharedIniFileCredentials({profile: 'default'}),
     *     region: 'us-east-1',
     *     hostname: 'db.us-east-1.rds.amazonaws.com',
     *     port: 8000,
     *     username: 'name'
     *   });
     */
    constructor: function Signer(options) {
        this.options = options || {};
    },

    /**
     * @api private
     * Strips the protocol from a url.
     */
    convertUrlToAuthToken: function convertUrlToAuthToken(url) {
        // we are always using https as the protocol
        var protocol = 'https://';
        if (url.indexOf(protocol) === 0) {
            return url.substring(protocol.length);
        }
    },

    /**
     * @overload getAuthToken(options = {}, [callback])
     *   Generate an auth token to a database.
     *   @note You must ensure that you have static or previously resolved
     *     credentials if you call this method synchronously (with no callback),
     *     otherwise it may not properly sign the request. If you cannot guarantee
     *     this (you are using an asynchronous credential provider, i.e., EC2
     *     IAM roles), you should always call this method with an asynchronous
     *     callback.
     *
     *   @param options [map] The fields to use when generating an auth token.
     *     Any options specified here will be merged on top of any options passed
     *     to AWS.RDS.Signer:
     *
     *     * **credentials** (AWS.Credentials) &mdash; the AWS credentials
     *         to sign requests with. Uses the default credential provider chain
     *         if not specified.
     *     * **hostname** (String) &mdash; the hostname of the database to connect to.
     *     * **port** (Number) &mdash; the port number the database is listening on.
     *     * **region** (String) &mdash; the region the database is located in.
     *     * **username** (String) &mdash; the username to login as.
     *   @return [String] if called synchronously (with no callback), returns the
     *     auth token.
     *   @return [null] nothing is returned if a callback is provided.
     *   @callback callback function (err, token)
     *     If a callback is supplied, it is called when an auth token has been generated.
     *     @param err [Error] the error object returned from the signer.
     *     @param token [String] the auth token.
     *
     *   @example Generating an auth token synchronously
     *     var signer = new AWS.RDS.Signer({
     *       // configure options
     *       region: 'us-east-1',
     *       username: 'default',
     *       hostname: 'db.us-east-1.amazonaws.com',
     *       port: 8000
     *     });
     *     var token = signer.getAuthToken({
     *       // these options are merged with those defined when creating the signer, overriding in the case of a duplicate option
     *       // credentials are not specified here or when creating the signer, so default credential provider will be used
     *       username: 'test' // overriding username
     *     });
     *   @example Generating an auth token asynchronously
     *     var signer = new AWS.RDS.Signer({
     *       // configure options
     *       region: 'us-east-1',
     *       username: 'default',
     *       hostname: 'db.us-east-1.amazonaws.com',
     *       port: 8000
     *     });
     *     signer.getAuthToken({
     *       // these options are merged with those defined when creating the signer, overriding in the case of a duplicate option
     *       // credentials are not specified here or when creating the signer, so default credential provider will be used
     *       username: 'test' // overriding username
     *     }, function(err, token) {
     *       if (err) {
     *         // handle error
     *       } else {
     *         // use token
     *       }
     *     });
     *
     */
    getAuthToken: function getAuthToken(options, callback) {
        if (typeof options === 'function' && callback === undefined) {
            callback = options;
            options = {};
        }
        var self = this;
        var hasCallback = typeof callback === 'function';
        // merge options with existing options
        options = AWS.util.merge(this.options, options);
        // validate options
        var optionsValidation = this.validateAuthTokenOptions(options);
        if (optionsValidation !== true) {
            if (hasCallback) {
                return callback(optionsValidation, null);
            }
            throw optionsValidation;
        }

        // 15 minutes
        var expires = 900;
        // create service to generate a request from
        var serviceOptions = {
            region: options.region,
            endpoint: new AWS.Endpoint(options.hostname + ':' + options.port),
            paramValidation: false,
            signatureVersion: 'v4'
        };
        if (options.credentials) {
            serviceOptions.credentials = options.credentials;
        }
        service = new AWS.Service(serviceOptions);
        // ensure the SDK is using sigv4 signing (config is not enough)
        service.api = api;

        var request = service.makeRequest();
        // add listeners to request to properly build auth token
        this.modifyRequestForAuthToken(request, options);

        if (hasCallback) {
            request.presign(expires, function(err, url) {
                if (url) {
                    url = self.convertUrlToAuthToken(url);
                }
                callback(err, url);
            });
        } else {
            var url = request.presign(expires);
            return this.convertUrlToAuthToken(url);
        }
    },

    /**
     * @api private
     * Modifies a request to allow the presigner to generate an auth token.
     */
    modifyRequestForAuthToken: function modifyRequestForAuthToken(request, options) {
        request.on('build', request.buildAsGet);
        var httpRequest = request.httpRequest;
        httpRequest.body = AWS.util.queryParamsToString({
            Action: 'connect',
            DBUser: options.username
        });
    },

    /**
     * @api private
     * Validates that the options passed in contain all the keys with values of the correct type that
     *   are needed to generate an auth token.
     */
    validateAuthTokenOptions: function validateAuthTokenOptions(options) {
        // iterate over all keys in options
        var message = '';
        options = options || {};
        for (var key in requiredAuthTokenOptions) {
            if (!Object.prototype.hasOwnProperty.call(requiredAuthTokenOptions, key)) {
                continue;
            }
            if (typeof options[key] !== requiredAuthTokenOptions[key]) {
                message += 'option \'' + key + '\' should have been type \'' + requiredAuthTokenOptions[key] + '\', was \'' + typeof options[key] + '\'.\n';
            }
        }
        if (message.length) {
            return AWS.util.error(new Error(), {
                code: 'InvalidParameter',
                message: message
            });
        }
        return true;
    }
});

/***/ }),
/* 2905 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-01-10","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2013-01-10","xmlNamespace":"http://rds.amazonaws.com/doc/2013-01-10/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S1c"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1i"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1o"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S25"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S25","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"St","locationName":"DBInstance"}}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S1c","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2f"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sk","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S11","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2f"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1o","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S14","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S3m","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S3o"}},"wrapper":true}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2f"}}},"output":{"shape":"S3z","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1i"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sp"},"VpcSecurityGroupMemberships":{"shape":"Sq"}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1o"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S3m"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2f"}}},"output":{"shape":"S3z","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"Id":{},"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sv"},"VpcSecurityGroups":{"shape":"Sx"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S11"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMembership":{"type":"structure","members":{"OptionGroupName":{},"Status":{}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"}},"wrapper":true},"Sv":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"Sx":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S11":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S14"},"SubnetStatus":{}}}}},"wrapper":true},"S14":{"type":"structure","members":{"Name":{},"ProvisionedIopsCapable":{"type":"boolean"}},"wrapper":true},"S1c":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1i":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1o":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sv"},"VpcSecurityGroupMemberships":{"shape":"Sx"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"S25":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2f":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S3m":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S3o"}},"wrapper":true},"S3o":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S3z":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 2906 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 2907 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-02-12","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2013-02-12","xmlNamespace":"http://rds.amazonaws.com/doc/2013-02-12/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S1d"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1j"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1p"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S28"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S28","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"St","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S1d","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2n"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sk","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S11","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2n"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"Persistent":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1p","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S14","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S3w","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S3y"}},"wrapper":true}}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2n"}}},"output":{"shape":"S4b","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1j"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sp"},"VpcSecurityGroupMemberships":{"shape":"Sq"},"OptionSettings":{"type":"list","member":{"shape":"S1t","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1p"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S3w"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2n"}}},"output":{"shape":"S4b","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sv"},"VpcSecurityGroups":{"shape":"Sx"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S11"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"}},"wrapper":true},"Sv":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"Sx":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S11":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S14"},"SubnetStatus":{}}}}},"wrapper":true},"S14":{"type":"structure","members":{"Name":{},"ProvisionedIopsCapable":{"type":"boolean"}},"wrapper":true},"S1d":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1j":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1p":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Port":{"type":"integer"},"OptionSettings":{"type":"list","member":{"shape":"S1t","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"Sv"},"VpcSecurityGroupMemberships":{"shape":"Sx"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"S1t":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"S28":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2n":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S3w":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S3y"}},"wrapper":true},"S3y":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4b":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 2908 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBLogFiles":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DescribeDBLogFiles"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"DownloadDBLogFilePortion":{"input_token":"Marker","limit_key":"NumberOfLines","more_results":"AdditionalDataPending","output_token":"Marker","result_key":"LogFileData"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 2909 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-09-09","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2013-09-09","xmlNamespace":"http://rds.amazonaws.com/doc/2013-09-09/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"},"DBSubnetGroupName":{}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S1f"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1l"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1r"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S2d"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S2d","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"St","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S1f","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2s"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sk","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S11","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2s"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S27"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Filters":{"shape":"S27"},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1r","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S14","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S41","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S43"}},"wrapper":true}}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S27"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2s"}}},"output":{"shape":"S4g","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1l"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sp"},"VpcSecurityGroupMemberships":{"shape":"Sq"},"OptionSettings":{"type":"list","member":{"shape":"S1v","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1r"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S41"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2s"}}},"output":{"shape":"S4g","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sv"},"VpcSecurityGroups":{"shape":"Sx"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S11"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}}},"wrapper":true},"Sv":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"Sx":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S11":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S14"},"SubnetStatus":{}}}}},"wrapper":true},"S14":{"type":"structure","members":{"Name":{},"ProvisionedIopsCapable":{"type":"boolean"}},"wrapper":true},"S1f":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1l":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1r":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"Port":{"type":"integer"},"OptionSettings":{"type":"list","member":{"shape":"S1v","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"Sv"},"VpcSecurityGroupMemberships":{"shape":"Sx"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"S1v":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"S27":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S2d":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2s":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S41":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S43"}},"wrapper":true},"S43":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4g":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 2910 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBLogFiles":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DescribeDBLogFiles"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"DownloadDBLogFilePortion":{"input_token":"Marker","limit_key":"NumberOfLines","more_results":"AdditionalDataPending","output_token":"Marker","result_key":"LogFileData"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 2911 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DBInstanceAvailable":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBInstanceDeleted":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]}}}

/***/ }),
/* 2912 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-09-01","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2014-09-01","xmlNamespace":"http://rds.amazonaws.com/doc/2014-09-01/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBParameterGroup":{"input":{"type":"structure","required":["SourceDBParameterGroupIdentifier","TargetDBParameterGroupIdentifier","TargetDBParameterGroupDescription"],"members":{"SourceDBParameterGroupIdentifier":{},"TargetDBParameterGroupIdentifier":{},"TargetDBParameterGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"Sk"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sn"}}}},"CopyOptionGroup":{"input":{"type":"structure","required":["SourceOptionGroupIdentifier","TargetOptionGroupIdentifier","TargetOptionGroupDescription"],"members":{"SourceOptionGroupIdentifier":{},"TargetOptionGroupIdentifier":{},"TargetOptionGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"St"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S13"},"VpcSecurityGroupIds":{"shape":"S14"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"},"DBSubnetGroupName":{},"StorageType":{}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"Sk"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sn"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1u"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S1b"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"St"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sn"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S2h"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S2h","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"S17","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"Sk","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2w"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sn","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S1b","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2w"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S2b"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Filters":{"shape":"S2b"},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"St","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S1e","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"},"StorageType":{},"SupportsIops":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S45","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S47"}},"wrapper":true}}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S2b"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"S13"},"VpcSecurityGroupIds":{"shape":"S14"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2w"}}},"output":{"shape":"S4k","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1u"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S1b"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"S13"},"VpcSecurityGroupMemberships":{"shape":"S14"},"OptionSettings":{"type":"list","member":{"shape":"Sx","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"St"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S45"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2w"}}},"output":{"shape":"S4k","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"Sn":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{},"StorageType":{},"TdeCredentialArn":{}},"wrapper":true},"St":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"Port":{"type":"integer"},"OptionSettings":{"type":"list","member":{"shape":"Sx","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"Sy"},"VpcSecurityGroupMemberships":{"shape":"S10"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"Sx":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"Sy":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"S10":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S13":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"S14":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"S17":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sy"},"VpcSecurityGroups":{"shape":"S10"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S1b"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{},"StorageType":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}},"StorageType":{},"TdeCredentialArn":{}},"wrapper":true},"S1b":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S1e"},"SubnetStatus":{}}}}},"wrapper":true},"S1e":{"type":"structure","members":{"Name":{}},"wrapper":true},"S1u":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S2b":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S2h":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2w":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S45":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S47"}},"wrapper":true},"S47":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4k":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 2913 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 2914 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-10-31","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2014-10-31","xmlNamespace":"http://rds.amazonaws.com/doc/2014-10-31/"},"operations":{"AddRoleToDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","RoleArn"],"members":{"DBClusterIdentifier":{},"RoleArn":{}}}},"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"Sa"}}}},"ApplyPendingMaintenanceAction":{"input":{"type":"structure","required":["ResourceIdentifier","ApplyAction","OptInType"],"members":{"ResourceIdentifier":{},"ApplyAction":{},"OptInType":{}}},"output":{"resultWrapper":"ApplyPendingMaintenanceActionResult","type":"structure","members":{"ResourcePendingMaintenanceActions":{"shape":"Se"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sk"}}}},"CopyDBClusterParameterGroup":{"input":{"type":"structure","required":["SourceDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupDescription"],"members":{"SourceDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupDescription":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CopyDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"Sr"}}}},"CopyDBClusterSnapshot":{"input":{"type":"structure","required":["SourceDBClusterSnapshotIdentifier","TargetDBClusterSnapshotIdentifier"],"members":{"SourceDBClusterSnapshotIdentifier":{},"TargetDBClusterSnapshotIdentifier":{},"KmsKeyId":{},"PreSignedUrl":{},"CopyTags":{"type":"boolean"},"Tags":{"shape":"Sa"},"SourceRegion":{}}},"output":{"resultWrapper":"CopyDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"Sv"}}}},"CopyDBParameterGroup":{"input":{"type":"structure","required":["SourceDBParameterGroupIdentifier","TargetDBParameterGroupIdentifier","TargetDBParameterGroupDescription"],"members":{"SourceDBParameterGroupIdentifier":{},"TargetDBParameterGroupIdentifier":{},"TargetDBParameterGroupDescription":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CopyDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S10"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{},"KmsKeyId":{},"Tags":{"shape":"Sa"},"CopyTags":{"type":"boolean"},"PreSignedUrl":{},"OptionGroupName":{},"SourceRegion":{}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S13"}}}},"CopyOptionGroup":{"input":{"type":"structure","required":["SourceOptionGroupIdentifier","TargetOptionGroupIdentifier","TargetOptionGroupDescription"],"members":{"SourceOptionGroupIdentifier":{},"TargetOptionGroupIdentifier":{},"TargetOptionGroupDescription":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CopyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S17"}}}},"CreateDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"Sw"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"S1h"},"DBSubnetGroupName":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"MasterUsername":{},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"ReplicationSourceIdentifier":{},"Tags":{"shape":"Sa"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"PreSignedUrl":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"SourceRegion":{}}},"output":{"resultWrapper":"CreateDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1j"}}}},"CreateDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"Sr"}}}},"CreateDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","DBClusterIdentifier"],"members":{"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"Sv"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBInstanceClass","Engine"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S1w"},"VpcSecurityGroupIds":{"shape":"S1h"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"Sa"},"DBClusterIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"DomainIAMRoleName":{},"PromotionTier":{"type":"integer"},"Timezone":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"EnableCloudwatchLogsExports":{"shape":"S1x"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1z"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"Sa"},"DBSubnetGroupName":{},"StorageType":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"KmsKeyId":{},"PreSignedUrl":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"EnableCloudwatchLogsExports":{"shape":"S1x"},"SourceRegion":{}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S1z"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S10"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sk"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S13"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S2q"},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S23"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S7"},"SourceIds":{"shape":"S6"},"Enabled":{"type":"boolean"},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S17"}}}},"DeleteDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1j"}}}},"DeleteDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{}}}},"DeleteDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"Sv"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1z"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S13"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"DescribeAccountAttributesResult","type":"structure","members":{"AccountQuotas":{"type":"list","member":{"locationName":"AccountQuota","type":"structure","members":{"AccountQuotaName":{},"Used":{"type":"long"},"Max":{"type":"long"}},"wrapper":true}}}}},"DescribeCertificates":{"input":{"type":"structure","members":{"CertificateIdentifier":{},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCertificatesResult","type":"structure","members":{"Certificates":{"type":"list","member":{"locationName":"Certificate","type":"structure","members":{"CertificateIdentifier":{},"CertificateType":{},"Thumbprint":{},"ValidFrom":{"type":"timestamp"},"ValidTill":{"type":"timestamp"},"CertificateArn":{}},"wrapper":true}},"Marker":{}}}},"DescribeDBClusterParameterGroups":{"input":{"type":"structure","members":{"DBClusterParameterGroupName":{},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParameterGroupsResult","type":"structure","members":{"Marker":{},"DBClusterParameterGroups":{"type":"list","member":{"shape":"Sr","locationName":"DBClusterParameterGroup"}}}}},"DescribeDBClusterParameters":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"Source":{},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParametersResult","type":"structure","members":{"Parameters":{"shape":"S3s"},"Marker":{}}}},"DescribeDBClusterSnapshotAttributes":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotAttributesResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S3x"}}}},"DescribeDBClusterSnapshots":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"DBClusterSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"},"IncludePublic":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotsResult","type":"structure","members":{"Marker":{},"DBClusterSnapshots":{"type":"list","member":{"shape":"Sv","locationName":"DBClusterSnapshot"}}}}},"DescribeDBClusters":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClustersResult","type":"structure","members":{"Marker":{},"DBClusters":{"type":"list","member":{"shape":"S1j","locationName":"DBCluster"}}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"},"ListSupportedTimezones":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S4b"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S4b","locationName":"CharacterSet"}},"ValidUpgradeTarget":{"type":"list","member":{"locationName":"UpgradeTarget","type":"structure","members":{"Engine":{},"EngineVersion":{},"Description":{},"AutoUpgrade":{"type":"boolean"},"IsMajorVersionUpgrade":{"type":"boolean"}}}},"SupportedTimezones":{"type":"list","member":{"locationName":"Timezone","type":"structure","members":{"TimezoneName":{}}}},"ExportableLogTypes":{"shape":"S1x"},"SupportsLogExportsToCloudwatchLogs":{"type":"boolean"},"SupportsReadReplica":{"type":"boolean"}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"S1z","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S10","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S3s"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sk","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshotAttributes":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DescribeDBSnapshotAttributesResult","type":"structure","members":{"DBSnapshotAttributesResult":{"shape":"S4y"}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"},"IncludePublic":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"S13","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S23","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultClusterParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultClusterParametersResult","type":"structure","members":{"EngineDefaults":{"shape":"S59"}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"shape":"S59"}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S3h"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S7"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S5","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S7"},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S7"},"Date":{"type":"timestamp"},"SourceArn":{}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"OptionsConflictsWith":{"type":"list","member":{"locationName":"OptionConflictName"}},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"RequiresAutoMinorEngineVersionUpgrade":{"type":"boolean"},"VpcOnly":{"type":"boolean"},"SupportsOptionVersionDowngrade":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}},"OptionGroupOptionVersions":{"type":"list","member":{"locationName":"OptionVersion","type":"structure","members":{"Version":{},"IsDefault":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Filters":{"shape":"S3h"},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S17","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S26","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"},"SupportsStorageEncryption":{"type":"boolean"},"StorageType":{},"SupportsIops":{"type":"boolean"},"SupportsEnhancedMonitoring":{"type":"boolean"},"SupportsIAMDatabaseAuthentication":{"type":"boolean"},"SupportsPerformanceInsights":{"type":"boolean"},"MinStorageSize":{"type":"integer"},"MaxStorageSize":{"type":"integer"},"MinIopsPerDbInstance":{"type":"integer"},"MaxIopsPerDbInstance":{"type":"integer"},"MinIopsPerGib":{"type":"double"},"MaxIopsPerGib":{"type":"double"}},"wrapper":true}},"Marker":{}}}},"DescribePendingMaintenanceActions":{"input":{"type":"structure","members":{"ResourceIdentifier":{},"Filters":{"shape":"S3h"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribePendingMaintenanceActionsResult","type":"structure","members":{"PendingMaintenanceActions":{"type":"list","member":{"shape":"Se","locationName":"ResourcePendingMaintenanceActions"}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S6d","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S3h"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S6f"}},"wrapper":true}}}}},"DescribeSourceRegions":{"input":{"type":"structure","members":{"RegionName":{},"MaxRecords":{"type":"integer"},"Marker":{},"Filters":{"shape":"S3h"}}},"output":{"resultWrapper":"DescribeSourceRegionsResult","type":"structure","members":{"Marker":{},"SourceRegions":{"type":"list","member":{"locationName":"SourceRegion","type":"structure","members":{"RegionName":{},"Endpoint":{},"Status":{}}}}}}},"DescribeValidDBInstanceModifications":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"DescribeValidDBInstanceModificationsResult","type":"structure","members":{"ValidDBInstanceModificationsMessage":{"type":"structure","members":{"Storage":{"type":"list","member":{"locationName":"ValidStorageOptions","type":"structure","members":{"StorageType":{},"StorageSize":{"shape":"S6u"},"ProvisionedIops":{"shape":"S6u"},"IopsToStorageRatio":{"type":"list","member":{"locationName":"DoubleRange","type":"structure","members":{"From":{"type":"double"},"To":{"type":"double"}}}}}}}},"wrapper":true}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"FailoverDBCluster":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"TargetDBInstanceIdentifier":{}}},"output":{"resultWrapper":"FailoverDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1j"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S3h"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"Sa"}}}},"ModifyDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"NewDBClusterIdentifier":{},"ApplyImmediately":{"type":"boolean"},"BackupRetentionPeriod":{"type":"integer"},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"S1h"},"Port":{"type":"integer"},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1j"}}}},"ModifyDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","Parameters"],"members":{"DBClusterParameterGroupName":{},"Parameters":{"shape":"S3s"}}},"output":{"shape":"S77","resultWrapper":"ModifyDBClusterParameterGroupResult"}},"ModifyDBClusterSnapshotAttribute":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","AttributeName"],"members":{"DBClusterSnapshotIdentifier":{},"AttributeName":{},"ValuesToAdd":{"shape":"S40"},"ValuesToRemove":{"shape":"S40"}}},"output":{"resultWrapper":"ModifyDBClusterSnapshotAttributeResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S3x"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSubnetGroupName":{},"DBSecurityGroups":{"shape":"S1w"},"VpcSecurityGroupIds":{"shape":"S1h"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"CACertificateIdentifier":{},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"DBPortNumber":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"MonitoringRoleArn":{},"DomainIAMRoleName":{},"PromotionTier":{"type":"integer"},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"CloudwatchLogsExportConfiguration":{"type":"structure","members":{"EnableLogTypes":{"shape":"S1x"},"DisableLogTypes":{"shape":"S1x"}}}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1z"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S3s"}}},"output":{"shape":"S7e","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{},"EngineVersion":{},"OptionGroupName":{}}},"output":{"resultWrapper":"ModifyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S13"}}}},"ModifyDBSnapshotAttribute":{"input":{"type":"structure","required":["DBSnapshotIdentifier","AttributeName"],"members":{"DBSnapshotIdentifier":{},"AttributeName":{},"ValuesToAdd":{"shape":"S40"},"ValuesToRemove":{"shape":"S40"}}},"output":{"resultWrapper":"ModifyDBSnapshotAttributeResult","type":"structure","members":{"DBSnapshotAttributesResult":{"shape":"S4y"}}}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S2q"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S23"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S7"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"OptionVersion":{},"DBSecurityGroupMemberships":{"shape":"S1w"},"VpcSecurityGroupMemberships":{"shape":"S1h"},"OptionSettings":{"type":"list","member":{"shape":"S1b","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S17"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S1z"}}}},"PromoteReadReplicaDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"PromoteReadReplicaDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1j"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S6d"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1z"}}}},"RemoveRoleFromDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","RoleArn"],"members":{"DBClusterIdentifier":{},"RoleArn":{}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S3s"}}},"output":{"shape":"S77","resultWrapper":"ResetDBClusterParameterGroupResult"}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S3s"}}},"output":{"shape":"S7e","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBClusterFromS3":{"input":{"type":"structure","required":["DBClusterIdentifier","Engine","MasterUsername","MasterUserPassword","SourceEngine","SourceEngineVersion","S3BucketName","S3IngestionRoleArn"],"members":{"AvailabilityZones":{"shape":"Sw"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"S1h"},"DBSubnetGroupName":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"MasterUsername":{},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"Tags":{"shape":"Sa"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"SourceEngine":{},"SourceEngineVersion":{},"S3BucketName":{},"S3Prefix":{},"S3IngestionRoleArn":{}}},"output":{"resultWrapper":"RestoreDBClusterFromS3Result","type":"structure","members":{"DBCluster":{"shape":"S1j"}}}},"RestoreDBClusterFromSnapshot":{"input":{"type":"structure","required":["DBClusterIdentifier","SnapshotIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"Sw"},"DBClusterIdentifier":{},"SnapshotIdentifier":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"DBSubnetGroupName":{},"DatabaseName":{},"OptionGroupName":{},"VpcSecurityGroupIds":{"shape":"S1h"},"Tags":{"shape":"Sa"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBClusterFromSnapshotResult","type":"structure","members":{"DBCluster":{"shape":"S1j"}}}},"RestoreDBClusterToPointInTime":{"input":{"type":"structure","required":["DBClusterIdentifier","SourceDBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"RestoreType":{},"SourceDBClusterIdentifier":{},"RestoreToTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"Port":{"type":"integer"},"DBSubnetGroupName":{},"OptionGroupName":{},"VpcSecurityGroupIds":{"shape":"S1h"},"Tags":{"shape":"Sa"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBClusterToPointInTimeResult","type":"structure","members":{"DBCluster":{"shape":"S1j"}}}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"Sa"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"DomainIAMRoleName":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnableCloudwatchLogsExports":{"shape":"S1x"}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"S1z"}}}},"RestoreDBInstanceFromS3":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBInstanceClass","Engine","SourceEngine","SourceEngineVersion","S3BucketName","S3IngestionRoleArn"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S1w"},"VpcSecurityGroupIds":{"shape":"S1h"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"Sa"},"StorageType":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"SourceEngine":{},"SourceEngineVersion":{},"S3BucketName":{},"S3Prefix":{},"S3IngestionRoleArn":{},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"EnableCloudwatchLogsExports":{"shape":"S1x"}}},"output":{"resultWrapper":"RestoreDBInstanceFromS3Result","type":"structure","members":{"DBInstance":{"shape":"S1z"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CopyTagsToSnapshot":{"type":"boolean"},"Tags":{"shape":"Sa"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"Domain":{},"DomainIAMRoleName":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnableCloudwatchLogsExports":{"shape":"S1x"}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"S1z"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sk"}}}},"StartDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"StartDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1z"}}}},"StopDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"StopDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1z"}}}}},"shapes":{"S5":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S6"},"EventCategoriesList":{"shape":"S7"},"Enabled":{"type":"boolean"},"EventSubscriptionArn":{}},"wrapper":true},"S6":{"type":"list","member":{"locationName":"SourceId"}},"S7":{"type":"list","member":{"locationName":"EventCategory"}},"Sa":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Se":{"type":"structure","members":{"ResourceIdentifier":{},"PendingMaintenanceActionDetails":{"type":"list","member":{"locationName":"PendingMaintenanceAction","type":"structure","members":{"Action":{},"AutoAppliedAfterDate":{"type":"timestamp"},"ForcedApplyDate":{"type":"timestamp"},"OptInStatus":{},"CurrentApplyDate":{"type":"timestamp"},"Description":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}},"DBSecurityGroupArn":{}},"wrapper":true},"Sr":{"type":"structure","members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"DBClusterParameterGroupArn":{}},"wrapper":true},"Sv":{"type":"structure","members":{"AvailabilityZones":{"shape":"Sw"},"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"VpcId":{},"ClusterCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"PercentProgress":{"type":"integer"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DBClusterSnapshotArn":{},"SourceDBClusterSnapshotArn":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"}},"wrapper":true},"Sw":{"type":"list","member":{"locationName":"AvailabilityZone"}},"S10":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"DBParameterGroupArn":{}},"wrapper":true},"S13":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{},"SourceDBSnapshotIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"DBSnapshotArn":{},"Timezone":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"}},"wrapper":true},"S17":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"Port":{"type":"integer"},"OptionVersion":{},"OptionSettings":{"type":"list","member":{"shape":"S1b","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"S1c"},"VpcSecurityGroupMemberships":{"shape":"S1e"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{},"OptionGroupArn":{}},"wrapper":true},"S1b":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"S1c":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"S1e":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S1h":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"S1j":{"type":"structure","members":{"AllocatedStorage":{"type":"integer"},"AvailabilityZones":{"shape":"Sw"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroup":{},"DBSubnetGroup":{},"Status":{},"PercentProgress":{},"EarliestRestorableTime":{"type":"timestamp"},"Endpoint":{},"ReaderEndpoint":{},"MultiAZ":{"type":"boolean"},"Engine":{},"EngineVersion":{},"LatestRestorableTime":{"type":"timestamp"},"Port":{"type":"integer"},"MasterUsername":{},"DBClusterOptionGroupMemberships":{"type":"list","member":{"locationName":"DBClusterOptionGroup","type":"structure","members":{"DBClusterOptionGroupName":{},"Status":{}}}},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"ReplicationSourceIdentifier":{},"ReadReplicaIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaIdentifier"}},"DBClusterMembers":{"type":"list","member":{"locationName":"DBClusterMember","type":"structure","members":{"DBInstanceIdentifier":{},"IsClusterWriter":{"type":"boolean"},"DBClusterParameterGroupStatus":{},"PromotionTier":{"type":"integer"}},"wrapper":true}},"VpcSecurityGroups":{"shape":"S1e"},"HostedZoneId":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbClusterResourceId":{},"DBClusterArn":{},"AssociatedRoles":{"type":"list","member":{"locationName":"DBClusterRole","type":"structure","members":{"RoleArn":{},"Status":{}}}},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"CloneGroupId":{},"ClusterCreateTime":{"type":"timestamp"}},"wrapper":true},"S1w":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"S1x":{"type":"list","member":{}},"S1z":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"},"HostedZoneId":{}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"S1c"},"VpcSecurityGroups":{"shape":"S1e"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S23"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"LicenseModel":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{},"StorageType":{},"CACertificateIdentifier":{},"DBSubnetGroupName":{},"PendingCloudwatchLogsExports":{"type":"structure","members":{"LogTypesToEnable":{"shape":"S1x"},"LogTypesToDisable":{"shape":"S1x"}}}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"ReadReplicaDBClusterIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBClusterIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}},"StorageType":{},"TdeCredentialArn":{},"DbInstancePort":{"type":"integer"},"DBClusterIdentifier":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbiResourceId":{},"CACertificateIdentifier":{},"DomainMemberships":{"type":"list","member":{"locationName":"DomainMembership","type":"structure","members":{"Domain":{},"Status":{},"FQDN":{},"IAMRoleName":{}}}},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"EnhancedMonitoringResourceArn":{},"MonitoringRoleArn":{},"PromotionTier":{"type":"integer"},"DBInstanceArn":{},"Timezone":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"PerformanceInsightsEnabled":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"EnabledCloudwatchLogsExports":{"shape":"S1x"}},"wrapper":true},"S23":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S26"},"SubnetStatus":{}}}},"DBSubnetGroupArn":{}},"wrapper":true},"S26":{"type":"structure","members":{"Name":{}},"wrapper":true},"S2q":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S3h":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S3s":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S3x":{"type":"structure","members":{"DBClusterSnapshotIdentifier":{},"DBClusterSnapshotAttributes":{"type":"list","member":{"locationName":"DBClusterSnapshotAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"shape":"S40"}}}}},"wrapper":true},"S40":{"type":"list","member":{"locationName":"AttributeValue"}},"S4b":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S4y":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBSnapshotAttributes":{"type":"list","member":{"locationName":"DBSnapshotAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"shape":"S40"}},"wrapper":true}}},"wrapper":true},"S59":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S3s"}},"wrapper":true},"S6d":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S6f"},"ReservedDBInstanceArn":{}},"wrapper":true},"S6f":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S6u":{"type":"list","member":{"locationName":"Range","type":"structure","members":{"From":{"type":"integer"},"To":{"type":"integer"},"Step":{"type":"integer"}}}},"S77":{"type":"structure","members":{"DBClusterParameterGroupName":{}}},"S7e":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 2915 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBLogFiles":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DescribeDBLogFiles"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"DownloadDBLogFilePortion":{"input_token":"Marker","limit_key":"NumberOfLines","more_results":"AdditionalDataPending","output_token":"Marker","result_key":"LogFileData"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 2916 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DBInstanceAvailable":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBInstanceDeleted":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"DBInstanceNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBSnapshotAvailable":{"delay":30,"operation":"DescribeDBSnapshots","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBSnapshots[].Status"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"}]},"DBSnapshotDeleted":{"delay":30,"operation":"DescribeDBSnapshots","maxAttempts":60,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"DBSnapshots[].Status"},{"expected":"DBSnapshotNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"}]}}}

/***/ }),
/* 2917 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['redshift'] = {};
AWS.Redshift = Service.defineService('redshift', ['2012-12-01']);
Object.defineProperty(apiLoader.services['redshift'], '2012-12-01', {
  get: function get() {
    var model = __webpack_require__(2918);
    model.paginators = __webpack_require__(2919).pagination;
    model.waiters = __webpack_require__(2920).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Redshift;


/***/ }),
/* 2918 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-12-01","endpointPrefix":"redshift","protocol":"query","serviceFullName":"Amazon Redshift","signatureVersion":"v4","uid":"redshift-2012-12-01","xmlNamespace":"http://redshift.amazonaws.com/doc/2012-12-01/"},"operations":{"AuthorizeClusterSecurityGroupIngress":{"input":{"type":"structure","required":["ClusterSecurityGroupName"],"members":{"ClusterSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeClusterSecurityGroupIngressResult","type":"structure","members":{"ClusterSecurityGroup":{"shape":"S4"}}}},"AuthorizeSnapshotAccess":{"input":{"type":"structure","required":["SnapshotIdentifier","AccountWithRestoreAccess"],"members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"AccountWithRestoreAccess":{}}},"output":{"resultWrapper":"AuthorizeSnapshotAccessResult","type":"structure","members":{"Snapshot":{"shape":"Sd"}}}},"CopyClusterSnapshot":{"input":{"type":"structure","required":["SourceSnapshotIdentifier","TargetSnapshotIdentifier"],"members":{"SourceSnapshotIdentifier":{},"SourceSnapshotClusterIdentifier":{},"TargetSnapshotIdentifier":{}}},"output":{"resultWrapper":"CopyClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sd"}}}},"CreateCluster":{"input":{"type":"structure","required":["ClusterIdentifier","NodeType","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"ClusterIdentifier":{},"ClusterType":{},"NodeType":{},"MasterUsername":{},"MasterUserPassword":{},"ClusterSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ClusterSubnetGroupName":{},"AvailabilityZone":{},"PreferredMaintenanceWindow":{},"ClusterParameterGroupName":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"Port":{"type":"integer"},"ClusterVersion":{},"AllowVersionUpgrade":{"type":"boolean"},"NumberOfNodes":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"Encrypted":{"type":"boolean"},"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"ElasticIp":{},"Tags":{"shape":"S7"},"KmsKeyId":{},"EnhancedVpcRouting":{"type":"boolean"},"AdditionalInfo":{},"IamRoles":{"shape":"St"}}},"output":{"resultWrapper":"CreateClusterResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}},"CreateClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName","ParameterGroupFamily","Description"],"members":{"ParameterGroupName":{},"ParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S7"}}},"output":{"resultWrapper":"CreateClusterParameterGroupResult","type":"structure","members":{"ClusterParameterGroup":{"shape":"S1g"}}}},"CreateClusterSecurityGroup":{"input":{"type":"structure","required":["ClusterSecurityGroupName","Description"],"members":{"ClusterSecurityGroupName":{},"Description":{},"Tags":{"shape":"S7"}}},"output":{"resultWrapper":"CreateClusterSecurityGroupResult","type":"structure","members":{"ClusterSecurityGroup":{"shape":"S4"}}}},"CreateClusterSnapshot":{"input":{"type":"structure","required":["SnapshotIdentifier","ClusterIdentifier"],"members":{"SnapshotIdentifier":{},"ClusterIdentifier":{},"Tags":{"shape":"S7"}}},"output":{"resultWrapper":"CreateClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sd"}}}},"CreateClusterSubnetGroup":{"input":{"type":"structure","required":["ClusterSubnetGroupName","Description","SubnetIds"],"members":{"ClusterSubnetGroupName":{},"Description":{},"SubnetIds":{"shape":"S1m"},"Tags":{"shape":"S7"}}},"output":{"resultWrapper":"CreateClusterSubnetGroupResult","type":"structure","members":{"ClusterSubnetGroup":{"shape":"S1o"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"SourceIds":{"shape":"S1t"},"EventCategories":{"shape":"S1u"},"Severity":{},"Enabled":{"type":"boolean"},"Tags":{"shape":"S7"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S1w"}}}},"CreateHsmClientCertificate":{"input":{"type":"structure","required":["HsmClientCertificateIdentifier"],"members":{"HsmClientCertificateIdentifier":{},"Tags":{"shape":"S7"}}},"output":{"resultWrapper":"CreateHsmClientCertificateResult","type":"structure","members":{"HsmClientCertificate":{"shape":"S1z"}}}},"CreateHsmConfiguration":{"input":{"type":"structure","required":["HsmConfigurationIdentifier","Description","HsmIpAddress","HsmPartitionName","HsmPartitionPassword","HsmServerPublicCertificate"],"members":{"HsmConfigurationIdentifier":{},"Description":{},"HsmIpAddress":{},"HsmPartitionName":{},"HsmPartitionPassword":{},"HsmServerPublicCertificate":{},"Tags":{"shape":"S7"}}},"output":{"resultWrapper":"CreateHsmConfigurationResult","type":"structure","members":{"HsmConfiguration":{"shape":"S22"}}}},"CreateSnapshotCopyGrant":{"input":{"type":"structure","required":["SnapshotCopyGrantName"],"members":{"SnapshotCopyGrantName":{},"KmsKeyId":{},"Tags":{"shape":"S7"}}},"output":{"resultWrapper":"CreateSnapshotCopyGrantResult","type":"structure","members":{"SnapshotCopyGrant":{"shape":"S25"}}}},"CreateTags":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S7"}}}},"DeleteCluster":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"SkipFinalClusterSnapshot":{"type":"boolean"},"FinalClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteClusterResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}},"DeleteClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{}}}},"DeleteClusterSecurityGroup":{"input":{"type":"structure","required":["ClusterSecurityGroupName"],"members":{"ClusterSecurityGroupName":{}}}},"DeleteClusterSnapshot":{"input":{"type":"structure","required":["SnapshotIdentifier"],"members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{}}},"output":{"resultWrapper":"DeleteClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sd"}}}},"DeleteClusterSubnetGroup":{"input":{"type":"structure","required":["ClusterSubnetGroupName"],"members":{"ClusterSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}}},"DeleteHsmClientCertificate":{"input":{"type":"structure","required":["HsmClientCertificateIdentifier"],"members":{"HsmClientCertificateIdentifier":{}}}},"DeleteHsmConfiguration":{"input":{"type":"structure","required":["HsmConfigurationIdentifier"],"members":{"HsmConfigurationIdentifier":{}}}},"DeleteSnapshotCopyGrant":{"input":{"type":"structure","required":["SnapshotCopyGrantName"],"members":{"SnapshotCopyGrantName":{}}}},"DeleteTags":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"shape":"S2j"}}}},"DescribeClusterParameterGroups":{"input":{"type":"structure","members":{"ParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeClusterParameterGroupsResult","type":"structure","members":{"Marker":{},"ParameterGroups":{"type":"list","member":{"shape":"S1g","locationName":"ClusterParameterGroup"}}}}},"DescribeClusterParameters":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterParametersResult","type":"structure","members":{"Parameters":{"shape":"S2q"},"Marker":{}}}},"DescribeClusterSecurityGroups":{"input":{"type":"structure","members":{"ClusterSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeClusterSecurityGroupsResult","type":"structure","members":{"Marker":{},"ClusterSecurityGroups":{"type":"list","member":{"shape":"S4","locationName":"ClusterSecurityGroup"}}}}},"DescribeClusterSnapshots":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"SnapshotIdentifier":{},"SnapshotType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"Marker":{},"OwnerAccount":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeClusterSnapshotsResult","type":"structure","members":{"Marker":{},"Snapshots":{"type":"list","member":{"shape":"Sd","locationName":"Snapshot"}}}}},"DescribeClusterSubnetGroups":{"input":{"type":"structure","members":{"ClusterSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeClusterSubnetGroupsResult","type":"structure","members":{"Marker":{},"ClusterSubnetGroups":{"type":"list","member":{"shape":"S1o","locationName":"ClusterSubnetGroup"}}}}},"DescribeClusterVersions":{"input":{"type":"structure","members":{"ClusterVersion":{},"ClusterParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterVersionsResult","type":"structure","members":{"Marker":{},"ClusterVersions":{"type":"list","member":{"locationName":"ClusterVersion","type":"structure","members":{"ClusterVersion":{},"ClusterParameterGroupFamily":{},"Description":{}}}}}}},"DescribeClusters":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeClustersResult","type":"structure","members":{"Marker":{},"Clusters":{"type":"list","member":{"shape":"Sv","locationName":"Cluster"}}}}},"DescribeDefaultClusterParameters":{"input":{"type":"structure","required":["ParameterGroupFamily"],"members":{"ParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDefaultClusterParametersResult","type":"structure","members":{"DefaultClusterParameters":{"type":"structure","members":{"ParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2q"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"Events":{"type":"list","member":{"locationName":"EventInfoMap","type":"structure","members":{"EventId":{},"EventCategories":{"shape":"S1u"},"EventDescription":{},"Severity":{}},"wrapper":true}}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S1w","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S1u"},"Severity":{},"Date":{"type":"timestamp"},"EventId":{}}}}}}},"DescribeHsmClientCertificates":{"input":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeHsmClientCertificatesResult","type":"structure","members":{"Marker":{},"HsmClientCertificates":{"type":"list","member":{"shape":"S1z","locationName":"HsmClientCertificate"}}}}},"DescribeHsmConfigurations":{"input":{"type":"structure","members":{"HsmConfigurationIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeHsmConfigurationsResult","type":"structure","members":{"Marker":{},"HsmConfigurations":{"type":"list","member":{"shape":"S22","locationName":"HsmConfiguration"}}}}},"DescribeLoggingStatus":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S3x","resultWrapper":"DescribeLoggingStatusResult"}},"DescribeOrderableClusterOptions":{"input":{"type":"structure","members":{"ClusterVersion":{},"NodeType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableClusterOptionsResult","type":"structure","members":{"OrderableClusterOptions":{"type":"list","member":{"locationName":"OrderableClusterOption","type":"structure","members":{"ClusterVersion":{},"ClusterType":{},"NodeType":{},"AvailabilityZones":{"type":"list","member":{"shape":"S1r","locationName":"AvailabilityZone"}}},"wrapper":true}},"Marker":{}}}},"DescribeReservedNodeOfferings":{"input":{"type":"structure","members":{"ReservedNodeOfferingId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedNodeOfferingsResult","type":"structure","members":{"Marker":{},"ReservedNodeOfferings":{"type":"list","member":{"locationName":"ReservedNodeOffering","type":"structure","members":{"ReservedNodeOfferingId":{},"NodeType":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"OfferingType":{},"RecurringCharges":{"shape":"S47"}},"wrapper":true}}}}},"DescribeReservedNodes":{"input":{"type":"structure","members":{"ReservedNodeId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedNodesResult","type":"structure","members":{"Marker":{},"ReservedNodes":{"type":"list","member":{"shape":"S4c","locationName":"ReservedNode"}}}}},"DescribeResize":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"DescribeResizeResult","type":"structure","members":{"TargetNodeType":{},"TargetNumberOfNodes":{"type":"integer"},"TargetClusterType":{},"Status":{},"ImportTablesCompleted":{"type":"list","member":{}},"ImportTablesInProgress":{"type":"list","member":{}},"ImportTablesNotStarted":{"type":"list","member":{}},"AvgResizeRateInMegaBytesPerSecond":{"type":"double"},"TotalResizeDataInMegaBytes":{"type":"long"},"ProgressInMegaBytes":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"},"EstimatedTimeToCompletionInSeconds":{"type":"long"}}}},"DescribeSnapshotCopyGrants":{"input":{"type":"structure","members":{"SnapshotCopyGrantName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeSnapshotCopyGrantsResult","type":"structure","members":{"Marker":{},"SnapshotCopyGrants":{"type":"list","member":{"shape":"S25","locationName":"SnapshotCopyGrant"}}}}},"DescribeTableRestoreStatus":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"TableRestoreRequestId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeTableRestoreStatusResult","type":"structure","members":{"TableRestoreStatusDetails":{"type":"list","member":{"shape":"S4q","locationName":"TableRestoreStatus"}},"Marker":{}}}},"DescribeTags":{"input":{"type":"structure","members":{"ResourceName":{},"ResourceType":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"TaggedResources":{"type":"list","member":{"locationName":"TaggedResource","type":"structure","members":{"Tag":{"shape":"S8"},"ResourceName":{},"ResourceType":{}}}},"Marker":{}}}},"DisableLogging":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S3x","resultWrapper":"DisableLoggingResult"}},"DisableSnapshotCopy":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"DisableSnapshotCopyResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}},"EnableLogging":{"input":{"type":"structure","required":["ClusterIdentifier","BucketName"],"members":{"ClusterIdentifier":{},"BucketName":{},"S3KeyPrefix":{}}},"output":{"shape":"S3x","resultWrapper":"EnableLoggingResult"}},"EnableSnapshotCopy":{"input":{"type":"structure","required":["ClusterIdentifier","DestinationRegion"],"members":{"ClusterIdentifier":{},"DestinationRegion":{},"RetentionPeriod":{"type":"integer"},"SnapshotCopyGrantName":{}}},"output":{"resultWrapper":"EnableSnapshotCopyResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}},"GetClusterCredentials":{"input":{"type":"structure","required":["DbUser","ClusterIdentifier"],"members":{"DbUser":{},"DbName":{},"ClusterIdentifier":{},"DurationSeconds":{"type":"integer"},"AutoCreate":{"type":"boolean"},"DbGroups":{"type":"list","member":{"locationName":"DbGroup"}}}},"output":{"resultWrapper":"GetClusterCredentialsResult","type":"structure","members":{"DbUser":{},"DbPassword":{"type":"string","sensitive":true},"Expiration":{"type":"timestamp"}}}},"ModifyCluster":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"ClusterType":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"ClusterSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"MasterUserPassword":{},"ClusterParameterGroupName":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"PreferredMaintenanceWindow":{},"ClusterVersion":{},"AllowVersionUpgrade":{"type":"boolean"},"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"NewClusterIdentifier":{},"PubliclyAccessible":{"type":"boolean"},"ElasticIp":{},"EnhancedVpcRouting":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyClusterResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}},"ModifyClusterIamRoles":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"AddIamRoles":{"shape":"St"},"RemoveIamRoles":{"shape":"St"}}},"output":{"resultWrapper":"ModifyClusterIamRolesResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}},"ModifyClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName","Parameters"],"members":{"ParameterGroupName":{},"Parameters":{"shape":"S2q"}}},"output":{"shape":"S5b","resultWrapper":"ModifyClusterParameterGroupResult"}},"ModifyClusterSubnetGroup":{"input":{"type":"structure","required":["ClusterSubnetGroupName","SubnetIds"],"members":{"ClusterSubnetGroupName":{},"Description":{},"SubnetIds":{"shape":"S1m"}}},"output":{"resultWrapper":"ModifyClusterSubnetGroupResult","type":"structure","members":{"ClusterSubnetGroup":{"shape":"S1o"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"SourceIds":{"shape":"S1t"},"EventCategories":{"shape":"S1u"},"Severity":{},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S1w"}}}},"ModifySnapshotCopyRetentionPeriod":{"input":{"type":"structure","required":["ClusterIdentifier","RetentionPeriod"],"members":{"ClusterIdentifier":{},"RetentionPeriod":{"type":"integer"}}},"output":{"resultWrapper":"ModifySnapshotCopyRetentionPeriodResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}},"PurchaseReservedNodeOffering":{"input":{"type":"structure","required":["ReservedNodeOfferingId"],"members":{"ReservedNodeOfferingId":{},"NodeCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedNodeOfferingResult","type":"structure","members":{"ReservedNode":{"shape":"S4c"}}}},"RebootCluster":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"RebootClusterResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}},"ResetClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2q"}}},"output":{"shape":"S5b","resultWrapper":"ResetClusterParameterGroupResult"}},"RestoreFromClusterSnapshot":{"input":{"type":"structure","required":["ClusterIdentifier","SnapshotIdentifier"],"members":{"ClusterIdentifier":{},"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"Port":{"type":"integer"},"AvailabilityZone":{},"AllowVersionUpgrade":{"type":"boolean"},"ClusterSubnetGroupName":{},"PubliclyAccessible":{"type":"boolean"},"OwnerAccount":{},"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"ElasticIp":{},"ClusterParameterGroupName":{},"ClusterSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"PreferredMaintenanceWindow":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"KmsKeyId":{},"NodeType":{},"EnhancedVpcRouting":{"type":"boolean"},"AdditionalInfo":{},"IamRoles":{"shape":"St"}}},"output":{"resultWrapper":"RestoreFromClusterSnapshotResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}},"RestoreTableFromClusterSnapshot":{"input":{"type":"structure","required":["ClusterIdentifier","SnapshotIdentifier","SourceDatabaseName","SourceTableName","NewTableName"],"members":{"ClusterIdentifier":{},"SnapshotIdentifier":{},"SourceDatabaseName":{},"SourceSchemaName":{},"SourceTableName":{},"TargetDatabaseName":{},"TargetSchemaName":{},"NewTableName":{}}},"output":{"resultWrapper":"RestoreTableFromClusterSnapshotResult","type":"structure","members":{"TableRestoreStatus":{"shape":"S4q"}}}},"RevokeClusterSecurityGroupIngress":{"input":{"type":"structure","required":["ClusterSecurityGroupName"],"members":{"ClusterSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeClusterSecurityGroupIngressResult","type":"structure","members":{"ClusterSecurityGroup":{"shape":"S4"}}}},"RevokeSnapshotAccess":{"input":{"type":"structure","required":["SnapshotIdentifier","AccountWithRestoreAccess"],"members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"AccountWithRestoreAccess":{}}},"output":{"resultWrapper":"RevokeSnapshotAccessResult","type":"structure","members":{"Snapshot":{"shape":"Sd"}}}},"RotateEncryptionKey":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"RotateEncryptionKeyResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}}},"shapes":{"S4":{"type":"structure","members":{"ClusterSecurityGroupName":{},"Description":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{},"Tags":{"shape":"S7"}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{},"Tags":{"shape":"S7"}}}},"Tags":{"shape":"S7"}},"wrapper":true},"S7":{"type":"list","member":{"shape":"S8","locationName":"Tag"}},"S8":{"type":"structure","members":{"Key":{},"Value":{}}},"Sd":{"type":"structure","members":{"SnapshotIdentifier":{},"ClusterIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"ClusterCreateTime":{"type":"timestamp"},"MasterUsername":{},"ClusterVersion":{},"SnapshotType":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"DBName":{},"VpcId":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"EncryptedWithHSM":{"type":"boolean"},"AccountsWithRestoreAccess":{"type":"list","member":{"locationName":"AccountWithRestoreAccess","type":"structure","members":{"AccountId":{},"AccountAlias":{}}}},"OwnerAccount":{},"TotalBackupSizeInMegaBytes":{"type":"double"},"ActualIncrementalBackupSizeInMegaBytes":{"type":"double"},"BackupProgressInMegaBytes":{"type":"double"},"CurrentBackupRateInMegaBytesPerSecond":{"type":"double"},"EstimatedSecondsToCompletion":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"},"SourceRegion":{},"Tags":{"shape":"S7"},"RestorableNodeTypes":{"type":"list","member":{"locationName":"NodeType"}},"EnhancedVpcRouting":{"type":"boolean"}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"ClusterSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"list","member":{"locationName":"IamRoleArn"}},"Sv":{"type":"structure","members":{"ClusterIdentifier":{},"NodeType":{},"ClusterStatus":{},"ModifyStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"ClusterCreateTime":{"type":"timestamp"},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ClusterSecurityGroups":{"type":"list","member":{"locationName":"ClusterSecurityGroup","type":"structure","members":{"ClusterSecurityGroupName":{},"Status":{}}}},"VpcSecurityGroups":{"type":"list","member":{"locationName":"VpcSecurityGroup","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"ClusterParameterGroups":{"type":"list","member":{"locationName":"ClusterParameterGroup","type":"structure","members":{"ParameterGroupName":{},"ParameterApplyStatus":{},"ClusterParameterStatusList":{"type":"list","member":{"type":"structure","members":{"ParameterName":{},"ParameterApplyStatus":{},"ParameterApplyErrorDescription":{}}}}}}},"ClusterSubnetGroupName":{},"VpcId":{},"AvailabilityZone":{},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"MasterUserPassword":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"ClusterType":{},"ClusterVersion":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ClusterIdentifier":{},"PubliclyAccessible":{"type":"boolean"},"EnhancedVpcRouting":{"type":"boolean"}}},"ClusterVersion":{},"AllowVersionUpgrade":{"type":"boolean"},"NumberOfNodes":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"Encrypted":{"type":"boolean"},"RestoreStatus":{"type":"structure","members":{"Status":{},"CurrentRestoreRateInMegaBytesPerSecond":{"type":"double"},"SnapshotSizeInMegaBytes":{"type":"long"},"ProgressInMegaBytes":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"},"EstimatedTimeToCompletionInSeconds":{"type":"long"}}},"HsmStatus":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"Status":{}}},"ClusterSnapshotCopyStatus":{"type":"structure","members":{"DestinationRegion":{},"RetentionPeriod":{"type":"long"},"SnapshotCopyGrantName":{}}},"ClusterPublicKey":{},"ClusterNodes":{"type":"list","member":{"type":"structure","members":{"NodeRole":{},"PrivateIPAddress":{},"PublicIPAddress":{}}}},"ElasticIpStatus":{"type":"structure","members":{"ElasticIp":{},"Status":{}}},"ClusterRevisionNumber":{},"Tags":{"shape":"S7"},"KmsKeyId":{},"EnhancedVpcRouting":{"type":"boolean"},"IamRoles":{"type":"list","member":{"locationName":"ClusterIamRole","type":"structure","members":{"IamRoleArn":{},"ApplyStatus":{}}}}},"wrapper":true},"S1g":{"type":"structure","members":{"ParameterGroupName":{},"ParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S7"}},"wrapper":true},"S1m":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1o":{"type":"structure","members":{"ClusterSubnetGroupName":{},"Description":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S1r"},"SubnetStatus":{}}}},"Tags":{"shape":"S7"}},"wrapper":true},"S1r":{"type":"structure","members":{"Name":{}},"wrapper":true},"S1t":{"type":"list","member":{"locationName":"SourceId"}},"S1u":{"type":"list","member":{"locationName":"EventCategory"}},"S1w":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{"type":"timestamp"},"SourceType":{},"SourceIdsList":{"shape":"S1t"},"EventCategoriesList":{"shape":"S1u"},"Severity":{},"Enabled":{"type":"boolean"},"Tags":{"shape":"S7"}},"wrapper":true},"S1z":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"HsmClientCertificatePublicKey":{},"Tags":{"shape":"S7"}},"wrapper":true},"S22":{"type":"structure","members":{"HsmConfigurationIdentifier":{},"Description":{},"HsmIpAddress":{},"HsmPartitionName":{},"Tags":{"shape":"S7"}},"wrapper":true},"S25":{"type":"structure","members":{"SnapshotCopyGrantName":{},"KmsKeyId":{},"Tags":{"shape":"S7"}},"wrapper":true},"S2j":{"type":"list","member":{"locationName":"TagKey"}},"S2l":{"type":"list","member":{"locationName":"TagValue"}},"S2q":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"ApplyType":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{}}}},"S3x":{"type":"structure","members":{"LoggingEnabled":{"type":"boolean"},"BucketName":{},"S3KeyPrefix":{},"LastSuccessfulDeliveryTime":{"type":"timestamp"},"LastFailureTime":{"type":"timestamp"},"LastFailureMessage":{}}},"S47":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4c":{"type":"structure","members":{"ReservedNodeId":{},"ReservedNodeOfferingId":{},"NodeType":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"NodeCount":{"type":"integer"},"State":{},"OfferingType":{},"RecurringCharges":{"shape":"S47"}},"wrapper":true},"S4q":{"type":"structure","members":{"TableRestoreRequestId":{},"Status":{},"Message":{},"RequestTime":{"type":"timestamp"},"ProgressInMegaBytes":{"type":"long"},"TotalDataInMegaBytes":{"type":"long"},"ClusterIdentifier":{},"SnapshotIdentifier":{},"SourceDatabaseName":{},"SourceSchemaName":{},"SourceTableName":{},"TargetDatabaseName":{},"TargetSchemaName":{},"NewTableName":{}},"wrapper":true},"S5b":{"type":"structure","members":{"ParameterGroupName":{},"ParameterGroupStatus":{}}}}}

/***/ }),
/* 2919 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeClusterParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ParameterGroups"},"DescribeClusterParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeClusterSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterSecurityGroups"},"DescribeClusterSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Snapshots"},"DescribeClusterSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterSubnetGroups"},"DescribeClusterVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterVersions"},"DescribeClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Clusters"},"DescribeDefaultClusterParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"DefaultClusterParameters.Marker","result_key":"DefaultClusterParameters.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeHsmClientCertificates":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"HsmClientCertificates"},"DescribeHsmConfigurations":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"HsmConfigurations"},"DescribeOrderableClusterOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableClusterOptions"},"DescribeReservedNodeOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedNodeOfferings"},"DescribeReservedNodes":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedNodes"}}}

/***/ }),
/* 2920 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"ClusterAvailable":{"delay":60,"operation":"DescribeClusters","maxAttempts":30,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Clusters[].ClusterStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"Clusters[].ClusterStatus"},{"expected":"ClusterNotFound","matcher":"error","state":"retry"}]},"ClusterDeleted":{"delay":60,"operation":"DescribeClusters","maxAttempts":30,"acceptors":[{"expected":"ClusterNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"Clusters[].ClusterStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"Clusters[].ClusterStatus"}]},"ClusterRestored":{"operation":"DescribeClusters","maxAttempts":30,"delay":60,"acceptors":[{"state":"success","matcher":"pathAll","argument":"Clusters[].RestoreStatus.Status","expected":"completed"},{"state":"failure","matcher":"pathAny","argument":"Clusters[].ClusterStatus","expected":"deleting"}]},"SnapshotAvailable":{"delay":15,"operation":"DescribeClusterSnapshots","maxAttempts":20,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Snapshots[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"Snapshots[].Status"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"Snapshots[].Status"}]}}}

/***/ }),
/* 2921 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['rekognition'] = {};
AWS.Rekognition = Service.defineService('rekognition', ['2016-06-27']);
Object.defineProperty(apiLoader.services['rekognition'], '2016-06-27', {
  get: function get() {
    var model = __webpack_require__(2922);
    model.paginators = __webpack_require__(2923).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Rekognition;


/***/ }),
/* 2922 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-06-27","endpointPrefix":"rekognition","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Rekognition","serviceId":"Rekognition","signatureVersion":"v4","targetPrefix":"RekognitionService","uid":"rekognition-2016-06-27"},"operations":{"CompareFaces":{"input":{"type":"structure","required":["SourceImage","TargetImage"],"members":{"SourceImage":{"shape":"S2"},"TargetImage":{"shape":"S2"},"SimilarityThreshold":{"type":"float"}}},"output":{"type":"structure","members":{"SourceImageFace":{"type":"structure","members":{"BoundingBox":{"shape":"Sb"},"Confidence":{"type":"float"}}},"FaceMatches":{"type":"list","member":{"type":"structure","members":{"Similarity":{"type":"float"},"Face":{"shape":"Sf"}}}},"UnmatchedFaces":{"type":"list","member":{"shape":"Sf"}},"SourceImageOrientationCorrection":{},"TargetImageOrientationCorrection":{}}}},"CreateCollection":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{}}},"output":{"type":"structure","members":{"StatusCode":{"type":"integer"},"CollectionArn":{},"FaceModelVersion":{}}}},"CreateStreamProcessor":{"input":{"type":"structure","required":["Input","Output","Name","Settings","RoleArn"],"members":{"Input":{"shape":"Su"},"Output":{"shape":"Sx"},"Name":{},"Settings":{"shape":"S11"},"RoleArn":{}}},"output":{"type":"structure","members":{"StreamProcessorArn":{}}}},"DeleteCollection":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{}}},"output":{"type":"structure","members":{"StatusCode":{"type":"integer"}}}},"DeleteFaces":{"input":{"type":"structure","required":["CollectionId","FaceIds"],"members":{"CollectionId":{},"FaceIds":{"shape":"S19"}}},"output":{"type":"structure","members":{"DeletedFaces":{"shape":"S19"}}}},"DeleteStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DescribeStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"StreamProcessorArn":{},"Status":{},"StatusMessage":{},"CreationTimestamp":{"type":"timestamp"},"LastUpdateTimestamp":{"type":"timestamp"},"Input":{"shape":"Su"},"Output":{"shape":"Sx"},"RoleArn":{},"Settings":{"shape":"S11"}}}},"DetectFaces":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"},"Attributes":{"shape":"S1j"}}},"output":{"type":"structure","members":{"FaceDetails":{"type":"list","member":{"shape":"S1n"}},"OrientationCorrection":{}}}},"DetectLabels":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"},"MaxLabels":{"type":"integer"},"MinConfidence":{"type":"float"}}},"output":{"type":"structure","members":{"Labels":{"type":"list","member":{"shape":"S25"}},"OrientationCorrection":{}}}},"DetectModerationLabels":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"},"MinConfidence":{"type":"float"}}},"output":{"type":"structure","members":{"ModerationLabels":{"type":"list","member":{"shape":"S29"}}}}},"DetectText":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"}}},"output":{"type":"structure","members":{"TextDetections":{"type":"list","member":{"type":"structure","members":{"DetectedText":{},"Type":{},"Id":{"type":"integer"},"ParentId":{"type":"integer"},"Confidence":{"type":"float"},"Geometry":{"type":"structure","members":{"BoundingBox":{"shape":"Sb"},"Polygon":{"type":"list","member":{"type":"structure","members":{"X":{"type":"float"},"Y":{"type":"float"}}}}}}}}}}}},"GetCelebrityInfo":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"Urls":{"shape":"S2l"},"Name":{}}}},"GetCelebrityRecognition":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S2v"},"NextToken":{},"Celebrities":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Celebrity":{"type":"structure","members":{"Urls":{"shape":"S2l"},"Name":{},"Id":{},"Confidence":{"type":"float"},"BoundingBox":{"shape":"Sb"},"Face":{"shape":"S1n"}}}}}}}}},"GetContentModeration":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S2v"},"ModerationLabels":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"ModerationLabel":{"shape":"S29"}}}},"NextToken":{}}}},"GetFaceDetection":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S2v"},"NextToken":{},"Faces":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Face":{"shape":"S1n"}}}}}}},"GetFaceSearch":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"NextToken":{},"VideoMetadata":{"shape":"S2v"},"Persons":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Person":{"shape":"S3f"},"FaceMatches":{"shape":"S3h"}}}}}}},"GetLabelDetection":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S2v"},"NextToken":{},"Labels":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Label":{"shape":"S25"}}}}}}},"GetPersonTracking":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S2v"},"NextToken":{},"Persons":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Person":{"shape":"S3f"}}}}}}},"IndexFaces":{"input":{"type":"structure","required":["CollectionId","Image"],"members":{"CollectionId":{},"Image":{"shape":"S2"},"ExternalImageId":{},"DetectionAttributes":{"shape":"S1j"}}},"output":{"type":"structure","members":{"FaceRecords":{"type":"list","member":{"type":"structure","members":{"Face":{"shape":"S3j"},"FaceDetail":{"shape":"S1n"}}}},"OrientationCorrection":{},"FaceModelVersion":{}}}},"ListCollections":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CollectionIds":{"type":"list","member":{}},"NextToken":{},"FaceModelVersions":{"type":"list","member":{}}}}},"ListFaces":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Faces":{"type":"list","member":{"shape":"S3j"}},"NextToken":{},"FaceModelVersion":{}}}},"ListStreamProcessors":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"StreamProcessors":{"type":"list","member":{"type":"structure","members":{"Name":{},"Status":{}}}}}}},"RecognizeCelebrities":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"}}},"output":{"type":"structure","members":{"CelebrityFaces":{"type":"list","member":{"type":"structure","members":{"Urls":{"shape":"S2l"},"Name":{},"Id":{},"Face":{"shape":"Sf"},"MatchConfidence":{"type":"float"}}}},"UnrecognizedFaces":{"type":"list","member":{"shape":"Sf"}},"OrientationCorrection":{}}}},"SearchFaces":{"input":{"type":"structure","required":["CollectionId","FaceId"],"members":{"CollectionId":{},"FaceId":{},"MaxFaces":{"type":"integer"},"FaceMatchThreshold":{"type":"float"}}},"output":{"type":"structure","members":{"SearchedFaceId":{},"FaceMatches":{"shape":"S3h"},"FaceModelVersion":{}}}},"SearchFacesByImage":{"input":{"type":"structure","required":["CollectionId","Image"],"members":{"CollectionId":{},"Image":{"shape":"S2"},"MaxFaces":{"type":"integer"},"FaceMatchThreshold":{"type":"float"}}},"output":{"type":"structure","members":{"SearchedFaceBoundingBox":{"shape":"Sb"},"SearchedFaceConfidence":{"type":"float"},"FaceMatches":{"shape":"S3h"},"FaceModelVersion":{}}}},"StartCelebrityRecognition":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S4n"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S4p"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartContentModeration":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S4n"},"MinConfidence":{"type":"float"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S4p"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartFaceDetection":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S4n"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S4p"},"FaceAttributes":{},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartFaceSearch":{"input":{"type":"structure","required":["Video","CollectionId"],"members":{"Video":{"shape":"S4n"},"ClientRequestToken":{},"FaceMatchThreshold":{"type":"float"},"CollectionId":{},"NotificationChannel":{"shape":"S4p"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartLabelDetection":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S4n"},"ClientRequestToken":{},"MinConfidence":{"type":"float"},"NotificationChannel":{"shape":"S4p"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartPersonTracking":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S4n"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S4p"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"StopStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S2":{"type":"structure","members":{"Bytes":{"type":"blob"},"S3Object":{"shape":"S4"}}},"S4":{"type":"structure","members":{"Bucket":{},"Name":{},"Version":{}}},"Sb":{"type":"structure","members":{"Width":{"type":"float"},"Height":{"type":"float"},"Left":{"type":"float"},"Top":{"type":"float"}}},"Sf":{"type":"structure","members":{"BoundingBox":{"shape":"Sb"},"Confidence":{"type":"float"},"Landmarks":{"shape":"Sg"},"Pose":{"shape":"Sj"},"Quality":{"shape":"Sl"}}},"Sg":{"type":"list","member":{"type":"structure","members":{"Type":{},"X":{"type":"float"},"Y":{"type":"float"}}}},"Sj":{"type":"structure","members":{"Roll":{"type":"float"},"Yaw":{"type":"float"},"Pitch":{"type":"float"}}},"Sl":{"type":"structure","members":{"Brightness":{"type":"float"},"Sharpness":{"type":"float"}}},"Su":{"type":"structure","members":{"KinesisVideoStream":{"type":"structure","members":{"Arn":{}}}}},"Sx":{"type":"structure","members":{"KinesisDataStream":{"type":"structure","members":{"Arn":{}}}}},"S11":{"type":"structure","members":{"FaceSearch":{"type":"structure","members":{"CollectionId":{},"FaceMatchThreshold":{"type":"float"}}}}},"S19":{"type":"list","member":{}},"S1j":{"type":"list","member":{}},"S1n":{"type":"structure","members":{"BoundingBox":{"shape":"Sb"},"AgeRange":{"type":"structure","members":{"Low":{"type":"integer"},"High":{"type":"integer"}}},"Smile":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Eyeglasses":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Sunglasses":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Gender":{"type":"structure","members":{"Value":{},"Confidence":{"type":"float"}}},"Beard":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Mustache":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"EyesOpen":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"MouthOpen":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Emotions":{"type":"list","member":{"type":"structure","members":{"Type":{},"Confidence":{"type":"float"}}}},"Landmarks":{"shape":"Sg"},"Pose":{"shape":"Sj"},"Quality":{"shape":"Sl"},"Confidence":{"type":"float"}}},"S25":{"type":"structure","members":{"Name":{},"Confidence":{"type":"float"}}},"S29":{"type":"structure","members":{"Confidence":{"type":"float"},"Name":{},"ParentName":{}}},"S2l":{"type":"list","member":{}},"S2v":{"type":"structure","members":{"Codec":{},"DurationMillis":{"type":"long"},"Format":{},"FrameRate":{"type":"float"},"FrameHeight":{"type":"long"},"FrameWidth":{"type":"long"}}},"S3f":{"type":"structure","members":{"Index":{"type":"long"},"BoundingBox":{"shape":"Sb"},"Face":{"shape":"S1n"}}},"S3h":{"type":"list","member":{"type":"structure","members":{"Similarity":{"type":"float"},"Face":{"shape":"S3j"}}}},"S3j":{"type":"structure","members":{"FaceId":{},"BoundingBox":{"shape":"Sb"},"ImageId":{},"ExternalImageId":{},"Confidence":{"type":"float"}}},"S4n":{"type":"structure","members":{"S3Object":{"shape":"S4"}}},"S4p":{"type":"structure","required":["SNSTopicArn","RoleArn"],"members":{"SNSTopicArn":{},"RoleArn":{}}}}}

/***/ }),
/* 2923 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetCelebrityRecognition":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetContentModeration":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetFaceDetection":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetFaceSearch":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetLabelDetection":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetPersonTracking":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListCollections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CollectionIds"},"ListFaces":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Faces"},"ListStreamProcessors":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}

/***/ }),
/* 2924 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['route53'] = {};
AWS.Route53 = Service.defineService('route53', ['2013-04-01']);
__webpack_require__(2925);
Object.defineProperty(apiLoader.services['route53'], '2013-04-01', {
  get: function get() {
    var model = __webpack_require__(2926);
    model.paginators = __webpack_require__(2927).pagination;
    model.waiters = __webpack_require__(2928).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Route53;


/***/ }),
/* 2925 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);

AWS.util.update(AWS.Route53.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    request.on('build', this.sanitizeUrl);
  },

  /**
   * @api private
   */
  sanitizeUrl: function sanitizeUrl(request) {
    var path = request.httpRequest.path;
    request.httpRequest.path = path.replace(/\/%2F\w+%2F/, '/');
  },

  /**
   * @return [Boolean] whether the error can be retried
   * @api private
   */
  retryableError: function retryableError(error) {
    if (error.code === 'PriorRequestNotComplete' &&
        error.statusCode === 400) {
      return true;
    } else {
      var _super = AWS.Service.prototype.retryableError;
      return _super.call(this, error);
    }
  }
});


/***/ }),
/* 2926 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-04-01","endpointPrefix":"route53","globalEndpoint":"route53.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"Route 53","serviceFullName":"Amazon Route 53","serviceId":"Route 53","signatureVersion":"v4","uid":"route53-2013-04-01"},"operations":{"AssociateVPCWithHostedZone":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/associatevpc"},"input":{"locationName":"AssociateVPCWithHostedZoneRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"S3"},"Comment":{}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"ChangeResourceRecordSets":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/rrset/"},"input":{"locationName":"ChangeResourceRecordSetsRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","ChangeBatch"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"ChangeBatch":{"type":"structure","required":["Changes"],"members":{"Comment":{},"Changes":{"type":"list","member":{"locationName":"Change","type":"structure","required":["Action","ResourceRecordSet"],"members":{"Action":{},"ResourceRecordSet":{"shape":"Sh"}}}}}}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"ChangeTagsForResource":{"http":{"requestUri":"/2013-04-01/tags/{ResourceType}/{ResourceId}"},"input":{"locationName":"ChangeTagsForResourceRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{"location":"uri","locationName":"ResourceType"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"AddTags":{"shape":"S15"},"RemoveTagKeys":{"type":"list","member":{"locationName":"Key"}}}},"output":{"type":"structure","members":{}}},"CreateHealthCheck":{"http":{"requestUri":"/2013-04-01/healthcheck","responseCode":201},"input":{"locationName":"CreateHealthCheckRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["CallerReference","HealthCheckConfig"],"members":{"CallerReference":{},"HealthCheckConfig":{"shape":"S1d"}}},"output":{"type":"structure","required":["HealthCheck","Location"],"members":{"HealthCheck":{"shape":"S1y"},"Location":{"location":"header","locationName":"Location"}}}},"CreateHostedZone":{"http":{"requestUri":"/2013-04-01/hostedzone","responseCode":201},"input":{"locationName":"CreateHostedZoneRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Name","CallerReference"],"members":{"Name":{},"VPC":{"shape":"S3"},"CallerReference":{},"HostedZoneConfig":{"shape":"S2g"},"DelegationSetId":{}}},"output":{"type":"structure","required":["HostedZone","ChangeInfo","DelegationSet","Location"],"members":{"HostedZone":{"shape":"S2j"},"ChangeInfo":{"shape":"S8"},"DelegationSet":{"shape":"S2l"},"VPC":{"shape":"S3"},"Location":{"location":"header","locationName":"Location"}}}},"CreateQueryLoggingConfig":{"http":{"requestUri":"/2013-04-01/queryloggingconfig","responseCode":201},"input":{"locationName":"CreateQueryLoggingConfigRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","CloudWatchLogsLogGroupArn"],"members":{"HostedZoneId":{},"CloudWatchLogsLogGroupArn":{}}},"output":{"type":"structure","required":["QueryLoggingConfig","Location"],"members":{"QueryLoggingConfig":{"shape":"S2q"},"Location":{"location":"header","locationName":"Location"}}}},"CreateReusableDelegationSet":{"http":{"requestUri":"/2013-04-01/delegationset","responseCode":201},"input":{"locationName":"CreateReusableDelegationSetRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"HostedZoneId":{}}},"output":{"type":"structure","required":["DelegationSet","Location"],"members":{"DelegationSet":{"shape":"S2l"},"Location":{"location":"header","locationName":"Location"}}}},"CreateTrafficPolicy":{"http":{"requestUri":"/2013-04-01/trafficpolicy","responseCode":201},"input":{"locationName":"CreateTrafficPolicyRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Name","Document"],"members":{"Name":{},"Document":{},"Comment":{}}},"output":{"type":"structure","required":["TrafficPolicy","Location"],"members":{"TrafficPolicy":{"shape":"S2z"},"Location":{"location":"header","locationName":"Location"}}}},"CreateTrafficPolicyInstance":{"http":{"requestUri":"/2013-04-01/trafficpolicyinstance","responseCode":201},"input":{"locationName":"CreateTrafficPolicyInstanceRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","Name","TTL","TrafficPolicyId","TrafficPolicyVersion"],"members":{"HostedZoneId":{},"Name":{},"TTL":{"type":"long"},"TrafficPolicyId":{},"TrafficPolicyVersion":{"type":"integer"}}},"output":{"type":"structure","required":["TrafficPolicyInstance","Location"],"members":{"TrafficPolicyInstance":{"shape":"S34"},"Location":{"location":"header","locationName":"Location"}}}},"CreateTrafficPolicyVersion":{"http":{"requestUri":"/2013-04-01/trafficpolicy/{Id}","responseCode":201},"input":{"locationName":"CreateTrafficPolicyVersionRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","Document"],"members":{"Id":{"location":"uri","locationName":"Id"},"Document":{},"Comment":{}}},"output":{"type":"structure","required":["TrafficPolicy","Location"],"members":{"TrafficPolicy":{"shape":"S2z"},"Location":{"location":"header","locationName":"Location"}}}},"CreateVPCAssociationAuthorization":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/authorizevpcassociation"},"input":{"locationName":"CreateVPCAssociationAuthorizationRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"S3"}}},"output":{"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{},"VPC":{"shape":"S3"}}}},"DeleteHealthCheck":{"http":{"method":"DELETE","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","members":{}}},"DeleteHostedZone":{"http":{"method":"DELETE","requestUri":"/2013-04-01/hostedzone/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"DeleteQueryLoggingConfig":{"http":{"method":"DELETE","requestUri":"/2013-04-01/queryloggingconfig/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteReusableDelegationSet":{"http":{"method":"DELETE","requestUri":"/2013-04-01/delegationset/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteTrafficPolicy":{"http":{"method":"DELETE","requestUri":"/2013-04-01/trafficpolicy/{Id}/{Version}"},"input":{"type":"structure","required":["Id","Version"],"members":{"Id":{"location":"uri","locationName":"Id"},"Version":{"location":"uri","locationName":"Version","type":"integer"}}},"output":{"type":"structure","members":{}}},"DeleteTrafficPolicyInstance":{"http":{"method":"DELETE","requestUri":"/2013-04-01/trafficpolicyinstance/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteVPCAssociationAuthorization":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/deauthorizevpcassociation"},"input":{"locationName":"DeleteVPCAssociationAuthorizationRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"DisassociateVPCFromHostedZone":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/disassociatevpc"},"input":{"locationName":"DisassociateVPCFromHostedZoneRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"S3"},"Comment":{}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"GetAccountLimit":{"http":{"method":"GET","requestUri":"/2013-04-01/accountlimit/{Type}"},"input":{"type":"structure","required":["Type"],"members":{"Type":{"location":"uri","locationName":"Type"}}},"output":{"type":"structure","required":["Limit","Count"],"members":{"Limit":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{"type":"long"}}},"Count":{"type":"long"}}}},"GetChange":{"http":{"method":"GET","requestUri":"/2013-04-01/change/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"GetCheckerIpRanges":{"http":{"method":"GET","requestUri":"/2013-04-01/checkeripranges"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["CheckerIpRanges"],"members":{"CheckerIpRanges":{"type":"list","member":{}}}}},"GetGeoLocation":{"http":{"method":"GET","requestUri":"/2013-04-01/geolocation"},"input":{"type":"structure","members":{"ContinentCode":{"location":"querystring","locationName":"continentcode"},"CountryCode":{"location":"querystring","locationName":"countrycode"},"SubdivisionCode":{"location":"querystring","locationName":"subdivisioncode"}}},"output":{"type":"structure","required":["GeoLocationDetails"],"members":{"GeoLocationDetails":{"shape":"S46"}}}},"GetHealthCheck":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","required":["HealthCheck"],"members":{"HealthCheck":{"shape":"S1y"}}}},"GetHealthCheckCount":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheckcount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["HealthCheckCount"],"members":{"HealthCheckCount":{"type":"long"}}}},"GetHealthCheckLastFailureReason":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}/lastfailurereason"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","required":["HealthCheckObservations"],"members":{"HealthCheckObservations":{"shape":"S4h"}}}},"GetHealthCheckStatus":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}/status"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","required":["HealthCheckObservations"],"members":{"HealthCheckObservations":{"shape":"S4h"}}}},"GetHostedZone":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["HostedZone"],"members":{"HostedZone":{"shape":"S2j"},"DelegationSet":{"shape":"S2l"},"VPCs":{"shape":"S4p"}}}},"GetHostedZoneCount":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonecount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["HostedZoneCount"],"members":{"HostedZoneCount":{"type":"long"}}}},"GetHostedZoneLimit":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonelimit/{Id}/{Type}"},"input":{"type":"structure","required":["Type","HostedZoneId"],"members":{"Type":{"location":"uri","locationName":"Type"},"HostedZoneId":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["Limit","Count"],"members":{"Limit":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{"type":"long"}}},"Count":{"type":"long"}}}},"GetQueryLoggingConfig":{"http":{"method":"GET","requestUri":"/2013-04-01/queryloggingconfig/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["QueryLoggingConfig"],"members":{"QueryLoggingConfig":{"shape":"S2q"}}}},"GetReusableDelegationSet":{"http":{"method":"GET","requestUri":"/2013-04-01/delegationset/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["DelegationSet"],"members":{"DelegationSet":{"shape":"S2l"}}}},"GetReusableDelegationSetLimit":{"http":{"method":"GET","requestUri":"/2013-04-01/reusabledelegationsetlimit/{Id}/{Type}"},"input":{"type":"structure","required":["Type","DelegationSetId"],"members":{"Type":{"location":"uri","locationName":"Type"},"DelegationSetId":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["Limit","Count"],"members":{"Limit":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{"type":"long"}}},"Count":{"type":"long"}}}},"GetTrafficPolicy":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicy/{Id}/{Version}"},"input":{"type":"structure","required":["Id","Version"],"members":{"Id":{"location":"uri","locationName":"Id"},"Version":{"location":"uri","locationName":"Version","type":"integer"}}},"output":{"type":"structure","required":["TrafficPolicy"],"members":{"TrafficPolicy":{"shape":"S2z"}}}},"GetTrafficPolicyInstance":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstance/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["TrafficPolicyInstance"],"members":{"TrafficPolicyInstance":{"shape":"S34"}}}},"GetTrafficPolicyInstanceCount":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstancecount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["TrafficPolicyInstanceCount"],"members":{"TrafficPolicyInstanceCount":{"type":"integer"}}}},"ListGeoLocations":{"http":{"method":"GET","requestUri":"/2013-04-01/geolocations"},"input":{"type":"structure","members":{"StartContinentCode":{"location":"querystring","locationName":"startcontinentcode"},"StartCountryCode":{"location":"querystring","locationName":"startcountrycode"},"StartSubdivisionCode":{"location":"querystring","locationName":"startsubdivisioncode"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["GeoLocationDetailsList","IsTruncated","MaxItems"],"members":{"GeoLocationDetailsList":{"type":"list","member":{"shape":"S46","locationName":"GeoLocationDetails"}},"IsTruncated":{"type":"boolean"},"NextContinentCode":{},"NextCountryCode":{},"NextSubdivisionCode":{},"MaxItems":{}}}},"ListHealthChecks":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"marker"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["HealthChecks","Marker","IsTruncated","MaxItems"],"members":{"HealthChecks":{"type":"list","member":{"shape":"S1y","locationName":"HealthCheck"}},"Marker":{},"IsTruncated":{"type":"boolean"},"NextMarker":{},"MaxItems":{}}}},"ListHostedZones":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"marker"},"MaxItems":{"location":"querystring","locationName":"maxitems"},"DelegationSetId":{"location":"querystring","locationName":"delegationsetid"}}},"output":{"type":"structure","required":["HostedZones","Marker","IsTruncated","MaxItems"],"members":{"HostedZones":{"shape":"S5n"},"Marker":{},"IsTruncated":{"type":"boolean"},"NextMarker":{},"MaxItems":{}}}},"ListHostedZonesByName":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonesbyname"},"input":{"type":"structure","members":{"DNSName":{"location":"querystring","locationName":"dnsname"},"HostedZoneId":{"location":"querystring","locationName":"hostedzoneid"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["HostedZones","IsTruncated","MaxItems"],"members":{"HostedZones":{"shape":"S5n"},"DNSName":{},"HostedZoneId":{},"IsTruncated":{"type":"boolean"},"NextDNSName":{},"NextHostedZoneId":{},"MaxItems":{}}}},"ListQueryLoggingConfigs":{"http":{"method":"GET","requestUri":"/2013-04-01/queryloggingconfig"},"input":{"type":"structure","members":{"HostedZoneId":{"location":"querystring","locationName":"hostedzoneid"},"NextToken":{"location":"querystring","locationName":"nexttoken"},"MaxResults":{"location":"querystring","locationName":"maxresults"}}},"output":{"type":"structure","required":["QueryLoggingConfigs"],"members":{"QueryLoggingConfigs":{"type":"list","member":{"shape":"S2q","locationName":"QueryLoggingConfig"}},"NextToken":{}}}},"ListResourceRecordSets":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}/rrset"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"StartRecordName":{"location":"querystring","locationName":"name"},"StartRecordType":{"location":"querystring","locationName":"type"},"StartRecordIdentifier":{"location":"querystring","locationName":"identifier"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["ResourceRecordSets","IsTruncated","MaxItems"],"members":{"ResourceRecordSets":{"type":"list","member":{"shape":"Sh","locationName":"ResourceRecordSet"}},"IsTruncated":{"type":"boolean"},"NextRecordName":{},"NextRecordType":{},"NextRecordIdentifier":{},"MaxItems":{}}}},"ListReusableDelegationSets":{"http":{"method":"GET","requestUri":"/2013-04-01/delegationset"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"marker"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["DelegationSets","Marker","IsTruncated","MaxItems"],"members":{"DelegationSets":{"type":"list","member":{"shape":"S2l","locationName":"DelegationSet"}},"Marker":{},"IsTruncated":{"type":"boolean"},"NextMarker":{},"MaxItems":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2013-04-01/tags/{ResourceType}/{ResourceId}"},"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{"location":"uri","locationName":"ResourceType"},"ResourceId":{"location":"uri","locationName":"ResourceId"}}},"output":{"type":"structure","required":["ResourceTagSet"],"members":{"ResourceTagSet":{"shape":"S63"}}}},"ListTagsForResources":{"http":{"requestUri":"/2013-04-01/tags/{ResourceType}"},"input":{"locationName":"ListTagsForResourcesRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["ResourceType","ResourceIds"],"members":{"ResourceType":{"location":"uri","locationName":"ResourceType"},"ResourceIds":{"type":"list","member":{"locationName":"ResourceId"}}}},"output":{"type":"structure","required":["ResourceTagSets"],"members":{"ResourceTagSets":{"type":"list","member":{"shape":"S63","locationName":"ResourceTagSet"}}}}},"ListTrafficPolicies":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicies"},"input":{"type":"structure","members":{"TrafficPolicyIdMarker":{"location":"querystring","locationName":"trafficpolicyid"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicySummaries","IsTruncated","TrafficPolicyIdMarker","MaxItems"],"members":{"TrafficPolicySummaries":{"type":"list","member":{"locationName":"TrafficPolicySummary","type":"structure","required":["Id","Name","Type","LatestVersion","TrafficPolicyCount"],"members":{"Id":{},"Name":{},"Type":{},"LatestVersion":{"type":"integer"},"TrafficPolicyCount":{"type":"integer"}}}},"IsTruncated":{"type":"boolean"},"TrafficPolicyIdMarker":{},"MaxItems":{}}}},"ListTrafficPolicyInstances":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstances"},"input":{"type":"structure","members":{"HostedZoneIdMarker":{"location":"querystring","locationName":"hostedzoneid"},"TrafficPolicyInstanceNameMarker":{"location":"querystring","locationName":"trafficpolicyinstancename"},"TrafficPolicyInstanceTypeMarker":{"location":"querystring","locationName":"trafficpolicyinstancetype"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicyInstances","IsTruncated","MaxItems"],"members":{"TrafficPolicyInstances":{"shape":"S6e"},"HostedZoneIdMarker":{},"TrafficPolicyInstanceNameMarker":{},"TrafficPolicyInstanceTypeMarker":{},"IsTruncated":{"type":"boolean"},"MaxItems":{}}}},"ListTrafficPolicyInstancesByHostedZone":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstances/hostedzone"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"querystring","locationName":"id"},"TrafficPolicyInstanceNameMarker":{"location":"querystring","locationName":"trafficpolicyinstancename"},"TrafficPolicyInstanceTypeMarker":{"location":"querystring","locationName":"trafficpolicyinstancetype"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicyInstances","IsTruncated","MaxItems"],"members":{"TrafficPolicyInstances":{"shape":"S6e"},"TrafficPolicyInstanceNameMarker":{},"TrafficPolicyInstanceTypeMarker":{},"IsTruncated":{"type":"boolean"},"MaxItems":{}}}},"ListTrafficPolicyInstancesByPolicy":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstances/trafficpolicy"},"input":{"type":"structure","required":["TrafficPolicyId","TrafficPolicyVersion"],"members":{"TrafficPolicyId":{"location":"querystring","locationName":"id"},"TrafficPolicyVersion":{"location":"querystring","locationName":"version","type":"integer"},"HostedZoneIdMarker":{"location":"querystring","locationName":"hostedzoneid"},"TrafficPolicyInstanceNameMarker":{"location":"querystring","locationName":"trafficpolicyinstancename"},"TrafficPolicyInstanceTypeMarker":{"location":"querystring","locationName":"trafficpolicyinstancetype"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicyInstances","IsTruncated","MaxItems"],"members":{"TrafficPolicyInstances":{"shape":"S6e"},"HostedZoneIdMarker":{},"TrafficPolicyInstanceNameMarker":{},"TrafficPolicyInstanceTypeMarker":{},"IsTruncated":{"type":"boolean"},"MaxItems":{}}}},"ListTrafficPolicyVersions":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicies/{Id}/versions"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"TrafficPolicyVersionMarker":{"location":"querystring","locationName":"trafficpolicyversion"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicies","IsTruncated","TrafficPolicyVersionMarker","MaxItems"],"members":{"TrafficPolicies":{"type":"list","member":{"shape":"S2z","locationName":"TrafficPolicy"}},"IsTruncated":{"type":"boolean"},"TrafficPolicyVersionMarker":{},"MaxItems":{}}}},"ListVPCAssociationAuthorizations":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}/authorizevpcassociation"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"NextToken":{"location":"querystring","locationName":"nexttoken"},"MaxResults":{"location":"querystring","locationName":"maxresults"}}},"output":{"type":"structure","required":["HostedZoneId","VPCs"],"members":{"HostedZoneId":{},"NextToken":{},"VPCs":{"shape":"S4p"}}}},"TestDNSAnswer":{"http":{"method":"GET","requestUri":"/2013-04-01/testdnsanswer"},"input":{"type":"structure","required":["HostedZoneId","RecordName","RecordType"],"members":{"HostedZoneId":{"location":"querystring","locationName":"hostedzoneid"},"RecordName":{"location":"querystring","locationName":"recordname"},"RecordType":{"location":"querystring","locationName":"recordtype"},"ResolverIP":{"location":"querystring","locationName":"resolverip"},"EDNS0ClientSubnetIP":{"location":"querystring","locationName":"edns0clientsubnetip"},"EDNS0ClientSubnetMask":{"location":"querystring","locationName":"edns0clientsubnetmask"}}},"output":{"type":"structure","required":["Nameserver","RecordName","RecordType","RecordData","ResponseCode","Protocol"],"members":{"Nameserver":{},"RecordName":{},"RecordType":{},"RecordData":{"type":"list","member":{"locationName":"RecordDataEntry"}},"ResponseCode":{},"Protocol":{}}}},"UpdateHealthCheck":{"http":{"requestUri":"/2013-04-01/healthcheck/{HealthCheckId}"},"input":{"locationName":"UpdateHealthCheckRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"},"HealthCheckVersion":{"type":"long"},"IPAddress":{},"Port":{"type":"integer"},"ResourcePath":{},"FullyQualifiedDomainName":{},"SearchString":{},"FailureThreshold":{"type":"integer"},"Inverted":{"type":"boolean"},"HealthThreshold":{"type":"integer"},"ChildHealthChecks":{"shape":"S1p"},"EnableSNI":{"type":"boolean"},"Regions":{"shape":"S1r"},"AlarmIdentifier":{"shape":"S1t"},"InsufficientDataHealthStatus":{},"ResetElements":{"type":"list","member":{"locationName":"ResettableElementName"}}}},"output":{"type":"structure","required":["HealthCheck"],"members":{"HealthCheck":{"shape":"S1y"}}}},"UpdateHostedZoneComment":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}"},"input":{"locationName":"UpdateHostedZoneCommentRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"Comment":{}}},"output":{"type":"structure","required":["HostedZone"],"members":{"HostedZone":{"shape":"S2j"}}}},"UpdateTrafficPolicyComment":{"http":{"requestUri":"/2013-04-01/trafficpolicy/{Id}/{Version}"},"input":{"locationName":"UpdateTrafficPolicyCommentRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","Version","Comment"],"members":{"Id":{"location":"uri","locationName":"Id"},"Version":{"location":"uri","locationName":"Version","type":"integer"},"Comment":{}}},"output":{"type":"structure","required":["TrafficPolicy"],"members":{"TrafficPolicy":{"shape":"S2z"}}}},"UpdateTrafficPolicyInstance":{"http":{"requestUri":"/2013-04-01/trafficpolicyinstance/{Id}"},"input":{"locationName":"UpdateTrafficPolicyInstanceRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","TTL","TrafficPolicyId","TrafficPolicyVersion"],"members":{"Id":{"location":"uri","locationName":"Id"},"TTL":{"type":"long"},"TrafficPolicyId":{},"TrafficPolicyVersion":{"type":"integer"}}},"output":{"type":"structure","required":["TrafficPolicyInstance"],"members":{"TrafficPolicyInstance":{"shape":"S34"}}}}},"shapes":{"S3":{"type":"structure","members":{"VPCRegion":{},"VPCId":{}}},"S8":{"type":"structure","required":["Id","Status","SubmittedAt"],"members":{"Id":{},"Status":{},"SubmittedAt":{"type":"timestamp"},"Comment":{}}},"Sh":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Type":{},"SetIdentifier":{},"Weight":{"type":"long"},"Region":{},"GeoLocation":{"type":"structure","members":{"ContinentCode":{},"CountryCode":{},"SubdivisionCode":{}}},"Failover":{},"MultiValueAnswer":{"type":"boolean"},"TTL":{"type":"long"},"ResourceRecords":{"type":"list","member":{"locationName":"ResourceRecord","type":"structure","required":["Value"],"members":{"Value":{}}}},"AliasTarget":{"type":"structure","required":["HostedZoneId","DNSName","EvaluateTargetHealth"],"members":{"HostedZoneId":{},"DNSName":{},"EvaluateTargetHealth":{"type":"boolean"}}},"HealthCheckId":{},"TrafficPolicyInstanceId":{}}},"S15":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"S1d":{"type":"structure","required":["Type"],"members":{"IPAddress":{},"Port":{"type":"integer"},"Type":{},"ResourcePath":{},"FullyQualifiedDomainName":{},"SearchString":{},"RequestInterval":{"type":"integer"},"FailureThreshold":{"type":"integer"},"MeasureLatency":{"type":"boolean"},"Inverted":{"type":"boolean"},"HealthThreshold":{"type":"integer"},"ChildHealthChecks":{"shape":"S1p"},"EnableSNI":{"type":"boolean"},"Regions":{"shape":"S1r"},"AlarmIdentifier":{"shape":"S1t"},"InsufficientDataHealthStatus":{}}},"S1p":{"type":"list","member":{"locationName":"ChildHealthCheck"}},"S1r":{"type":"list","member":{"locationName":"Region"}},"S1t":{"type":"structure","required":["Region","Name"],"members":{"Region":{},"Name":{}}},"S1y":{"type":"structure","required":["Id","CallerReference","HealthCheckConfig","HealthCheckVersion"],"members":{"Id":{},"CallerReference":{},"LinkedService":{"shape":"S1z"},"HealthCheckConfig":{"shape":"S1d"},"HealthCheckVersion":{"type":"long"},"CloudWatchAlarmConfiguration":{"type":"structure","required":["EvaluationPeriods","Threshold","ComparisonOperator","Period","MetricName","Namespace","Statistic"],"members":{"EvaluationPeriods":{"type":"integer"},"Threshold":{"type":"double"},"ComparisonOperator":{},"Period":{"type":"integer"},"MetricName":{},"Namespace":{},"Statistic":{},"Dimensions":{"type":"list","member":{"locationName":"Dimension","type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}}}}},"S1z":{"type":"structure","members":{"ServicePrincipal":{},"Description":{}}},"S2g":{"type":"structure","members":{"Comment":{},"PrivateZone":{"type":"boolean"}}},"S2j":{"type":"structure","required":["Id","Name","CallerReference"],"members":{"Id":{},"Name":{},"CallerReference":{},"Config":{"shape":"S2g"},"ResourceRecordSetCount":{"type":"long"},"LinkedService":{"shape":"S1z"}}},"S2l":{"type":"structure","required":["NameServers"],"members":{"Id":{},"CallerReference":{},"NameServers":{"type":"list","member":{"locationName":"NameServer"}}}},"S2q":{"type":"structure","required":["Id","HostedZoneId","CloudWatchLogsLogGroupArn"],"members":{"Id":{},"HostedZoneId":{},"CloudWatchLogsLogGroupArn":{}}},"S2z":{"type":"structure","required":["Id","Version","Name","Type","Document"],"members":{"Id":{},"Version":{"type":"integer"},"Name":{},"Type":{},"Document":{},"Comment":{}}},"S34":{"type":"structure","required":["Id","HostedZoneId","Name","TTL","State","Message","TrafficPolicyId","TrafficPolicyVersion","TrafficPolicyType"],"members":{"Id":{},"HostedZoneId":{},"Name":{},"TTL":{"type":"long"},"State":{},"Message":{},"TrafficPolicyId":{},"TrafficPolicyVersion":{"type":"integer"},"TrafficPolicyType":{}}},"S46":{"type":"structure","members":{"ContinentCode":{},"ContinentName":{},"CountryCode":{},"CountryName":{},"SubdivisionCode":{},"SubdivisionName":{}}},"S4h":{"type":"list","member":{"locationName":"HealthCheckObservation","type":"structure","members":{"Region":{},"IPAddress":{},"StatusReport":{"type":"structure","members":{"Status":{},"CheckedTime":{"type":"timestamp"}}}}}},"S4p":{"type":"list","member":{"shape":"S3","locationName":"VPC"}},"S5n":{"type":"list","member":{"shape":"S2j","locationName":"HostedZone"}},"S63":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"Tags":{"shape":"S15"}}},"S6e":{"type":"list","member":{"shape":"S34","locationName":"TrafficPolicyInstance"}}}}

/***/ }),
/* 2927 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListHealthChecks":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"NextMarker","result_key":"HealthChecks"},"ListHostedZones":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"NextMarker","result_key":"HostedZones"},"ListResourceRecordSets":{"input_token":["StartRecordName","StartRecordType","StartRecordIdentifier"],"limit_key":"MaxItems","more_results":"IsTruncated","output_token":["NextRecordName","NextRecordType","NextRecordIdentifier"],"result_key":"ResourceRecordSets"}}}

/***/ }),
/* 2928 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"ResourceRecordSetsChanged":{"delay":30,"maxAttempts":60,"operation":"GetChange","acceptors":[{"matcher":"path","expected":"INSYNC","argument":"ChangeInfo.Status","state":"success"}]}}}

/***/ }),
/* 2929 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['route53domains'] = {};
AWS.Route53Domains = Service.defineService('route53domains', ['2014-05-15']);
Object.defineProperty(apiLoader.services['route53domains'], '2014-05-15', {
  get: function get() {
    var model = __webpack_require__(2930);
    model.paginators = __webpack_require__(2931).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Route53Domains;


/***/ }),
/* 2930 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-05-15","endpointPrefix":"route53domains","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Route 53 Domains","signatureVersion":"v4","targetPrefix":"Route53Domains_v20140515","uid":"route53domains-2014-05-15"},"operations":{"CheckDomainAvailability":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"IdnLangCode":{}}},"output":{"type":"structure","required":["Availability"],"members":{"Availability":{}}}},"CheckDomainTransferability":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AuthCode":{"shape":"S7"}}},"output":{"type":"structure","required":["Transferability"],"members":{"Transferability":{"type":"structure","members":{"Transferable":{}}}}}},"DeleteTagsForDomain":{"input":{"type":"structure","required":["DomainName","TagsToDelete"],"members":{"DomainName":{},"TagsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"DisableDomainAutoRenew":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{}}},"DisableDomainTransferLock":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"EnableDomainAutoRenew":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{}}},"EnableDomainTransferLock":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"GetContactReachabilityStatus":{"input":{"type":"structure","members":{"domainName":{}}},"output":{"type":"structure","members":{"domainName":{},"status":{}}}},"GetDomainDetail":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["DomainName","Nameservers","AdminContact","RegistrantContact","TechContact"],"members":{"DomainName":{},"Nameservers":{"shape":"St"},"AutoRenew":{"type":"boolean"},"AdminContact":{"shape":"Sz"},"RegistrantContact":{"shape":"Sz"},"TechContact":{"shape":"Sz"},"AdminPrivacy":{"type":"boolean"},"RegistrantPrivacy":{"type":"boolean"},"TechPrivacy":{"type":"boolean"},"RegistrarName":{},"WhoIsServer":{},"RegistrarUrl":{},"AbuseContactEmail":{},"AbuseContactPhone":{},"RegistryDomainId":{},"CreationDate":{"type":"timestamp"},"UpdatedDate":{"type":"timestamp"},"ExpirationDate":{"type":"timestamp"},"Reseller":{},"DnsSec":{},"StatusList":{"type":"list","member":{}}}}},"GetDomainSuggestions":{"input":{"type":"structure","required":["DomainName","SuggestionCount","OnlyAvailable"],"members":{"DomainName":{},"SuggestionCount":{"type":"integer"},"OnlyAvailable":{"type":"boolean"}}},"output":{"type":"structure","members":{"SuggestionsList":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"Availability":{}}}}}}},"GetOperationDetail":{"input":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}},"output":{"type":"structure","members":{"OperationId":{},"Status":{},"Message":{},"DomainName":{},"Type":{},"SubmittedDate":{"type":"timestamp"}}}},"ListDomains":{"input":{"type":"structure","members":{"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","required":["Domains"],"members":{"Domains":{"type":"list","member":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AutoRenew":{"type":"boolean"},"TransferLock":{"type":"boolean"},"Expiry":{"type":"timestamp"}}}},"NextPageMarker":{}}}},"ListOperations":{"input":{"type":"structure","members":{"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","required":["Operations"],"members":{"Operations":{"type":"list","member":{"type":"structure","required":["OperationId","Status","Type","SubmittedDate"],"members":{"OperationId":{},"Status":{},"Type":{},"SubmittedDate":{"type":"timestamp"}}}},"NextPageMarker":{}}}},"ListTagsForDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["TagList"],"members":{"TagList":{"shape":"S29"}}}},"RegisterDomain":{"input":{"type":"structure","required":["DomainName","DurationInYears","AdminContact","RegistrantContact","TechContact"],"members":{"DomainName":{},"IdnLangCode":{},"DurationInYears":{"type":"integer"},"AutoRenew":{"type":"boolean"},"AdminContact":{"shape":"Sz"},"RegistrantContact":{"shape":"Sz"},"TechContact":{"shape":"Sz"},"PrivacyProtectAdminContact":{"type":"boolean"},"PrivacyProtectRegistrantContact":{"type":"boolean"},"PrivacyProtectTechContact":{"type":"boolean"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"RenewDomain":{"input":{"type":"structure","required":["DomainName","CurrentExpiryYear"],"members":{"DomainName":{},"DurationInYears":{"type":"integer"},"CurrentExpiryYear":{"type":"integer"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"ResendContactReachabilityEmail":{"input":{"type":"structure","members":{"domainName":{}}},"output":{"type":"structure","members":{"domainName":{},"emailAddress":{},"isAlreadyVerified":{"type":"boolean"}}}},"RetrieveDomainAuthCode":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["AuthCode"],"members":{"AuthCode":{"shape":"S7"}}}},"TransferDomain":{"input":{"type":"structure","required":["DomainName","DurationInYears","AdminContact","RegistrantContact","TechContact"],"members":{"DomainName":{},"IdnLangCode":{},"DurationInYears":{"type":"integer"},"Nameservers":{"shape":"St"},"AuthCode":{"shape":"S7"},"AutoRenew":{"type":"boolean"},"AdminContact":{"shape":"Sz"},"RegistrantContact":{"shape":"Sz"},"TechContact":{"shape":"Sz"},"PrivacyProtectAdminContact":{"type":"boolean"},"PrivacyProtectRegistrantContact":{"type":"boolean"},"PrivacyProtectTechContact":{"type":"boolean"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"UpdateDomainContact":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AdminContact":{"shape":"Sz"},"RegistrantContact":{"shape":"Sz"},"TechContact":{"shape":"Sz"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"UpdateDomainContactPrivacy":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AdminPrivacy":{"type":"boolean"},"RegistrantPrivacy":{"type":"boolean"},"TechPrivacy":{"type":"boolean"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"UpdateDomainNameservers":{"input":{"type":"structure","required":["DomainName","Nameservers"],"members":{"DomainName":{},"FIAuthKey":{"deprecated":true},"Nameservers":{"shape":"St"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"UpdateTagsForDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"TagsToUpdate":{"shape":"S29"}}},"output":{"type":"structure","members":{}}},"ViewBilling":{"input":{"type":"structure","members":{"Start":{"type":"timestamp"},"End":{"type":"timestamp"},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","members":{"NextPageMarker":{},"BillingRecords":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"Operation":{},"InvoiceId":{},"BillDate":{"type":"timestamp"},"Price":{"type":"double"}}}}}}}},"shapes":{"S7":{"type":"string","sensitive":true},"St":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"GlueIps":{"type":"list","member":{}}}}},"Sz":{"type":"structure","members":{"FirstName":{},"LastName":{},"ContactType":{},"OrganizationName":{},"AddressLine1":{},"AddressLine2":{},"City":{},"State":{},"CountryCode":{},"ZipCode":{},"PhoneNumber":{},"Email":{},"Fax":{},"ExtraParams":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}},"sensitive":true},"S29":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 2931 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListDomains":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextPageMarker","result_key":"Domains"},"ListOperations":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextPageMarker","result_key":"Operations"}}}

/***/ }),
/* 2932 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['s3'] = {};
AWS.S3 = Service.defineService('s3', ['2006-03-01']);
__webpack_require__(2933);
Object.defineProperty(apiLoader.services['s3'], '2006-03-01', {
  get: function get() {
    var model = __webpack_require__(2935);
    model.paginators = __webpack_require__(2936).pagination;
    model.waiters = __webpack_require__(2937).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.S3;


/***/ }),
/* 2933 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var v4Credentials = __webpack_require__(1067);

// Pull in managed upload extension
__webpack_require__(2934);

/**
 * @api private
 */
var operationsWith200StatusCodeError = {
  'completeMultipartUpload': true,
  'copyObject': true,
  'uploadPartCopy': true
};

/**
 * @api private
 */
 var regionRedirectErrorCodes = [
  'AuthorizationHeaderMalformed', // non-head operations on virtual-hosted global bucket endpoints
  'BadRequest', // head operations on virtual-hosted global bucket endpoints
  'PermanentRedirect', // non-head operations on path-style or regional endpoints
  301 // head operations on path-style or regional endpoints
 ];

AWS.util.update(AWS.S3.prototype, {
  /**
   * @api private
   */
  getSignatureVersion: function getSignatureVersion(request) {
    var defaultApiVersion = this.api.signatureVersion;
    var userDefinedVersion = this._originalConfig ? this._originalConfig.signatureVersion : null;
    var regionDefinedVersion = this.config.signatureVersion;
    var isPresigned = request ? request.isPresigned() : false;
    /*
      1) User defined version specified:
        a) always return user defined version
      2) No user defined version specified:
        a) default to lowest version the region supports
        b) If using presigned urls, default to lowest version the region supports
    */
    if (userDefinedVersion) {
      userDefinedVersion = userDefinedVersion === 'v2' ? 's3' : userDefinedVersion;
      return userDefinedVersion;
    }
    if (isPresigned !== true) {
      defaultApiVersion = 'v4';
    } else if (regionDefinedVersion) {
      defaultApiVersion = regionDefinedVersion;
    }
    return defaultApiVersion;
  },

  /**
   * @api private
   */
  getSignerClass: function getSignerClass(request) {
    var signatureVersion = this.getSignatureVersion(request);
    return AWS.Signers.RequestSigner.getVersion(signatureVersion);
  },

  /**
   * @api private
   */
  validateService: function validateService() {
    var msg;
    var messages = [];

    // default to us-east-1 when no region is provided
    if (!this.config.region) this.config.region = 'us-east-1';

    if (!this.config.endpoint && this.config.s3BucketEndpoint) {
      messages.push('An endpoint must be provided when configuring ' +
                    '`s3BucketEndpoint` to true.');
    }
    if (messages.length === 1) {
      msg = messages[0];
    } else if (messages.length > 1) {
      msg = 'Multiple configuration errors:\n' + messages.join('\n');
    }
    if (msg) {
      throw AWS.util.error(new Error(),
        {name: 'InvalidEndpoint', message: msg});
    }
  },

  /**
   * @api private
   */
  shouldDisableBodySigning: function shouldDisableBodySigning(request) {
    var signerClass = this.getSignerClass();
    if (this.config.s3DisableBodySigning === true && signerClass === AWS.Signers.V4
        && request.httpRequest.endpoint.protocol === 'https:') {
      return true;
    }
    return false;
  },

  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    request.addListener('validate', this.validateScheme);
    request.addListener('validate', this.validateBucketEndpoint);
    request.addListener('validate', this.correctBucketRegionFromCache);
    request.addListener('validate', this.validateBucketName);
    request.addListener('build', this.addContentType);
    request.addListener('build', this.populateURI);
    request.addListener('build', this.computeContentMd5);
    request.addListener('build', this.computeSseCustomerKeyMd5);
    request.addListener('afterBuild', this.addExpect100Continue);
    request.removeListener('validate',
      AWS.EventListeners.Core.VALIDATE_REGION);
    request.addListener('extractError', this.extractError);
    request.onAsync('extractError', this.requestBucketRegion);
    request.addListener('extractData', this.extractData);
    request.addListener('extractData', AWS.util.hoistPayloadMember);
    request.addListener('beforePresign', this.prepareSignedUrl);
    if (AWS.util.isBrowser()) {
      request.onAsync('retry', this.reqRegionForNetworkingError);
    }
    if (this.shouldDisableBodySigning(request))  {
      request.removeListener('afterBuild', AWS.EventListeners.Core.COMPUTE_SHA256);
      request.addListener('afterBuild', this.disableBodySigning);
    }
  },

  /**
   * @api private
   */
  validateScheme: function(req) {
    var params = req.params,
        scheme = req.httpRequest.endpoint.protocol,
        sensitive = params.SSECustomerKey || params.CopySourceSSECustomerKey;
    if (sensitive && scheme !== 'https:') {
      var msg = 'Cannot send SSE keys over HTTP. Set \'sslEnabled\'' +
        'to \'true\' in your configuration';
      throw AWS.util.error(new Error(),
        { code: 'ConfigError', message: msg });
    }
  },

  /**
   * @api private
   */
  validateBucketEndpoint: function(req) {
    if (!req.params.Bucket && req.service.config.s3BucketEndpoint) {
      var msg = 'Cannot send requests to root API with `s3BucketEndpoint` set.';
      throw AWS.util.error(new Error(),
        { code: 'ConfigError', message: msg });
    }
  },

  /**
   * @api private
   */
  validateBucketName: function validateBucketName(req) {
    var service = req.service;
    var signatureVersion = service.getSignatureVersion(req);
    // Only validate buckets when using sigv4
    if (signatureVersion !== 'v4') {
      return;
    }
    var bucket = req.params && req.params.Bucket;
    var key = req.params && req.params.Key;
    var slashIndex = bucket && bucket.indexOf('/');
    if (bucket && slashIndex >= 0) {
      if (typeof key === 'string') {
        req.params = AWS.util.copy(req.params);
        // Need to include trailing slash to match sigv2 behavior
        var prefix = bucket.substr(slashIndex + 1) || '';
        req.params.Key = prefix + '/' + key;
        req.params.Bucket = bucket.substr(0, slashIndex);
      } else {
        var msg = 'Bucket names cannot contain forward slashes. Bucket: ' + bucket;
        throw AWS.util.error(new Error(),
          { code: 'InvalidBucket', message: msg });
      }
    }
  },

  /**
   * @api private
   */
  isValidAccelerateOperation: function isValidAccelerateOperation(operation) {
    var invalidOperations = [
      'createBucket',
      'deleteBucket',
      'listBuckets'
    ];
    return invalidOperations.indexOf(operation) === -1;
  },


  /**
   * S3 prefers dns-compatible bucket names to be moved from the uri path
   * to the hostname as a sub-domain.  This is not possible, even for dns-compat
   * buckets when using SSL and the bucket name contains a dot ('.').  The
   * ssl wildcard certificate is only 1-level deep.
   *
   * @api private
   */
  populateURI: function populateURI(req) {
    var httpRequest = req.httpRequest;
    var b = req.params.Bucket;
    var service = req.service;
    var endpoint = httpRequest.endpoint;
    if (b) {
      if (!service.pathStyleBucketName(b)) {
        if (service.config.useAccelerateEndpoint && service.isValidAccelerateOperation(req.operation)) {
          if (service.config.useDualstack) {
            endpoint.hostname = b + '.s3-accelerate.dualstack.amazonaws.com';
          } else {
            endpoint.hostname = b + '.s3-accelerate.amazonaws.com';
          }
        } else if (!service.config.s3BucketEndpoint) {
          endpoint.hostname =
            b + '.' + endpoint.hostname;
        }

        var port = endpoint.port;
        if (port !== 80 && port !== 443) {
          endpoint.host = endpoint.hostname + ':' +
            endpoint.port;
        } else {
          endpoint.host = endpoint.hostname;
        }

        httpRequest.virtualHostedBucket = b; // needed for signing the request
        service.removeVirtualHostedBucketFromPath(req);
      }
    }
  },

  /**
   * Takes the bucket name out of the path if bucket is virtual-hosted
   *
   * @api private
   */
  removeVirtualHostedBucketFromPath: function removeVirtualHostedBucketFromPath(req) {
    var httpRequest = req.httpRequest;
    var bucket = httpRequest.virtualHostedBucket;
    if (bucket && httpRequest.path) {
      httpRequest.path = httpRequest.path.replace(new RegExp('/' + bucket), '');
      if (httpRequest.path[0] !== '/') {
        httpRequest.path = '/' + httpRequest.path;
      }
    }
  },

  /**
   * Adds Expect: 100-continue header if payload is greater-or-equal 1MB
   * @api private
   */
  addExpect100Continue: function addExpect100Continue(req) {
    var len = req.httpRequest.headers['Content-Length'];
    if (AWS.util.isNode() && len >= 1024 * 1024) {
      req.httpRequest.headers['Expect'] = '100-continue';
    }
  },

  /**
   * Adds a default content type if none is supplied.
   *
   * @api private
   */
  addContentType: function addContentType(req) {
    var httpRequest = req.httpRequest;
    if (httpRequest.method === 'GET' || httpRequest.method === 'HEAD') {
      // Content-Type is not set in GET/HEAD requests
      delete httpRequest.headers['Content-Type'];
      return;
    }

    if (!httpRequest.headers['Content-Type']) { // always have a Content-Type
      httpRequest.headers['Content-Type'] = 'application/octet-stream';
    }

    var contentType = httpRequest.headers['Content-Type'];
    if (AWS.util.isBrowser()) {
      if (typeof httpRequest.body === 'string' && !contentType.match(/;\s*charset=/)) {
        var charset = '; charset=UTF-8';
        httpRequest.headers['Content-Type'] += charset;
      } else {
        var replaceFn = function(_, prefix, charsetName) {
          return prefix + charsetName.toUpperCase();
        };

        httpRequest.headers['Content-Type'] =
          contentType.replace(/(;\s*charset=)(.+)$/, replaceFn);
      }
    }
  },

  /**
   * @api private
   */
  computableChecksumOperations: {
    putBucketCors: true,
    putBucketLifecycle: true,
    putBucketLifecycleConfiguration: true,
    putBucketTagging: true,
    deleteObjects: true,
    putBucketReplication: true
  },

  /**
   * Checks whether checksums should be computed for the request.
   * If the request requires checksums to be computed, this will always
   * return true, otherwise it depends on whether {AWS.Config.computeChecksums}
   * is set.
   *
   * @param req [AWS.Request] the request to check against
   * @return [Boolean] whether to compute checksums for a request.
   * @api private
   */
  willComputeChecksums: function willComputeChecksums(req) {
    if (this.computableChecksumOperations[req.operation]) return true;
    if (!this.config.computeChecksums) return false;

    // TODO: compute checksums for Stream objects
    if (!AWS.util.Buffer.isBuffer(req.httpRequest.body) &&
        typeof req.httpRequest.body !== 'string') {
      return false;
    }

    var rules = req.service.api.operations[req.operation].input.members;

    // Sha256 signing disabled, and not a presigned url
    if (req.service.shouldDisableBodySigning(req) && !Object.prototype.hasOwnProperty.call(req.httpRequest.headers, 'presigned-expires')) {
      if (rules.ContentMD5 && !req.params.ContentMD5) {
        return true;
      }
    }

    // V4 signer uses SHA256 signatures so only compute MD5 if it is required
    if (req.service.getSignerClass(req) === AWS.Signers.V4) {
      if (rules.ContentMD5 && !rules.ContentMD5.required) return false;
    }

    if (rules.ContentMD5 && !req.params.ContentMD5) return true;
  },

  /**
   * A listener that computes the Content-MD5 and sets it in the header.
   * @see AWS.S3.willComputeChecksums
   * @api private
   */
  computeContentMd5: function computeContentMd5(req) {
    if (req.service.willComputeChecksums(req)) {
      var md5 = AWS.util.crypto.md5(req.httpRequest.body, 'base64');
      req.httpRequest.headers['Content-MD5'] = md5;
    }
  },

  /**
   * @api private
   */
  computeSseCustomerKeyMd5: function computeSseCustomerKeyMd5(req) {
    var keys = {
      SSECustomerKey: 'x-amz-server-side-encryption-customer-key-MD5',
      CopySourceSSECustomerKey: 'x-amz-copy-source-server-side-encryption-customer-key-MD5'
    };
    AWS.util.each(keys, function(key, header) {
      if (req.params[key]) {
        var value = AWS.util.crypto.md5(req.params[key], 'base64');
        req.httpRequest.headers[header] = value;
      }
    });
  },

  /**
   * Returns true if the bucket name should be left in the URI path for
   * a request to S3.  This function takes into account the current
   * endpoint protocol (e.g. http or https).
   *
   * @api private
   */
  pathStyleBucketName: function pathStyleBucketName(bucketName) {
    // user can force path style requests via the configuration
    if (this.config.s3ForcePathStyle) return true;
    if (this.config.s3BucketEndpoint) return false;

    if (this.dnsCompatibleBucketName(bucketName)) {
      return (this.config.sslEnabled && bucketName.match(/\./)) ? true : false;
    } else {
      return true; // not dns compatible names must always use path style
    }
  },

  /**
   * Returns true if the bucket name is DNS compatible.  Buckets created
   * outside of the classic region MUST be DNS compatible.
   *
   * @api private
   */
  dnsCompatibleBucketName: function dnsCompatibleBucketName(bucketName) {
    var b = bucketName;
    var domain = new RegExp(/^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/);
    var ipAddress = new RegExp(/(\d+\.){3}\d+/);
    var dots = new RegExp(/\.\./);
    return (b.match(domain) && !b.match(ipAddress) && !b.match(dots)) ? true : false;
  },

  /**
   * @return [Boolean] whether response contains an error
   * @api private
   */
  successfulResponse: function successfulResponse(resp) {
    var req = resp.request;
    var httpResponse = resp.httpResponse;
    if (operationsWith200StatusCodeError[req.operation] &&
        httpResponse.body.toString().match('<Error>')) {
      return false;
    } else {
      return httpResponse.statusCode < 300;
    }
  },

  /**
   * @return [Boolean] whether the error can be retried
   * @api private
   */
  retryableError: function retryableError(error, request) {
    if (operationsWith200StatusCodeError[request.operation] &&
        error.statusCode === 200) {
      return true;
    } else if (request._requestRegionForBucket &&
        request.service.bucketRegionCache[request._requestRegionForBucket]) {
      return false;
    } else if (error && error.code === 'RequestTimeout') {
      return true;
    } else if (error &&
        regionRedirectErrorCodes.indexOf(error.code) != -1 &&
        error.region && error.region != request.httpRequest.region) {
      request.httpRequest.region = error.region;
      if (error.statusCode === 301) {
        request.service.updateReqBucketRegion(request);
      }
      return true;
    } else {
      var _super = AWS.Service.prototype.retryableError;
      return _super.call(this, error, request);
    }
  },

  /**
   * Updates httpRequest with region. If region is not provided, then
   * the httpRequest will be updated based on httpRequest.region
   *
   * @api private
   */
  updateReqBucketRegion: function updateReqBucketRegion(request, region) {
    var httpRequest = request.httpRequest;
    if (typeof region === 'string' && region.length) {
      httpRequest.region = region;
    }
    if (!httpRequest.endpoint.host.match(/s3(?!-accelerate).*\.amazonaws\.com$/)) {
      return;
    }
    var service = request.service;
    var s3Config = service.config;
    var s3BucketEndpoint = s3Config.s3BucketEndpoint;
    if (s3BucketEndpoint) {
      delete s3Config.s3BucketEndpoint;
    }
    var newConfig = AWS.util.copy(s3Config);
    delete newConfig.endpoint;
    newConfig.region = httpRequest.region;

    httpRequest.endpoint = (new AWS.S3(newConfig)).endpoint;
    service.populateURI(request);
    s3Config.s3BucketEndpoint = s3BucketEndpoint;
    httpRequest.headers.Host = httpRequest.endpoint.host;

    if (request._asm.currentState === 'validate') {
      request.removeListener('build', service.populateURI);
      request.addListener('build', service.removeVirtualHostedBucketFromPath);
    }
  },

  /**
   * Provides a specialized parser for getBucketLocation -- all other
   * operations are parsed by the super class.
   *
   * @api private
   */
  extractData: function extractData(resp) {
    var req = resp.request;
    if (req.operation === 'getBucketLocation') {
      var match = resp.httpResponse.body.toString().match(/>(.+)<\/Location/);
      delete resp.data['_'];
      if (match) {
        resp.data.LocationConstraint = match[1];
      } else {
        resp.data.LocationConstraint = '';
      }
    }
    var bucket = req.params.Bucket || null;
    if (req.operation === 'deleteBucket' && typeof bucket === 'string' && !resp.error) {
      req.service.clearBucketRegionCache(bucket);
    } else {
      var headers = resp.httpResponse.headers || {};
      var region = headers['x-amz-bucket-region'] || null;
      if (!region && req.operation === 'createBucket' && !resp.error) {
        var createBucketConfiguration = req.params.CreateBucketConfiguration;
        if (!createBucketConfiguration) {
          region = 'us-east-1';
        } else if (createBucketConfiguration.LocationConstraint === 'EU') {
          region = 'eu-west-1';
        } else {
          region = createBucketConfiguration.LocationConstraint;
        }
      }
      if (region) {
          if (bucket && region !== req.service.bucketRegionCache[bucket]) {
            req.service.bucketRegionCache[bucket] = region;
          }
      }
    }
    req.service.extractRequestIds(resp);
  },

  /**
   * Extracts an error object from the http response.
   *
   * @api private
   */
  extractError: function extractError(resp) {
    var codes = {
      304: 'NotModified',
      403: 'Forbidden',
      400: 'BadRequest',
      404: 'NotFound'
    };

    var req = resp.request;
    var code = resp.httpResponse.statusCode;
    var body = resp.httpResponse.body || '';

    var headers = resp.httpResponse.headers || {};
    var region = headers['x-amz-bucket-region'] || null;
    var bucket = req.params.Bucket || null;
    var bucketRegionCache = req.service.bucketRegionCache;
    if (region && bucket && region !== bucketRegionCache[bucket]) {
      bucketRegionCache[bucket] = region;
    }

    var cachedRegion;
    if (codes[code] && body.length === 0) {
      if (bucket && !region) {
        cachedRegion = bucketRegionCache[bucket] || null;
        if (cachedRegion !== req.httpRequest.region) {
          region = cachedRegion;
        }
      }
      resp.error = AWS.util.error(new Error(), {
        code: codes[code],
        message: null,
        region: region
      });
    } else {
      var data = new AWS.XML.Parser().parse(body.toString());

      if (data.Region && !region) {
        region = data.Region;
        if (bucket && region !== bucketRegionCache[bucket]) {
          bucketRegionCache[bucket] = region;
        }
      } else if (bucket && !region && !data.Region) {
        cachedRegion = bucketRegionCache[bucket] || null;
        if (cachedRegion !== req.httpRequest.region) {
          region = cachedRegion;
        }
      }

      resp.error = AWS.util.error(new Error(), {
        code: data.Code || code,
        message: data.Message || null,
        region: region
      });
    }
    req.service.extractRequestIds(resp);
  },

  /**
   * If region was not obtained synchronously, then send async request
   * to get bucket region for errors resulting from wrong region.
   *
   * @api private
   */
  requestBucketRegion: function requestBucketRegion(resp, done) {
    var error = resp.error;
    var req = resp.request;
    var bucket = req.params.Bucket || null;

    if (!error || !bucket || error.region || req.operation === 'listObjects' ||
        (AWS.util.isNode() && req.operation === 'headBucket') ||
        (error.statusCode === 400 && req.operation !== 'headObject') ||
        regionRedirectErrorCodes.indexOf(error.code) === -1) {
      return done();
    }
    var reqOperation = AWS.util.isNode() ? 'headBucket' : 'listObjects';
    var reqParams = {Bucket: bucket};
    if (reqOperation === 'listObjects') reqParams.MaxKeys = 0;
    var regionReq = req.service[reqOperation](reqParams);
    regionReq._requestRegionForBucket = bucket;
    regionReq.send(function() {
      var region = req.service.bucketRegionCache[bucket] || null;
      error.region = region;
      done();
    });
  },

   /**
   * For browser only. If NetworkingError received, will attempt to obtain
   * the bucket region.
   *
   * @api private
   */
   reqRegionForNetworkingError: function reqRegionForNetworkingError(resp, done) {
    if (!AWS.util.isBrowser()) {
      return done();
    }
    var error = resp.error;
    var request = resp.request;
    var bucket = request.params.Bucket;
    if (!error || error.code !== 'NetworkingError' || !bucket ||
        request.httpRequest.region === 'us-east-1') {
      return done();
    }
    var service = request.service;
    var bucketRegionCache = service.bucketRegionCache;
    var cachedRegion = bucketRegionCache[bucket] || null;

    if (cachedRegion && cachedRegion !== request.httpRequest.region) {
      service.updateReqBucketRegion(request, cachedRegion);
      done();
    } else if (!service.dnsCompatibleBucketName(bucket)) {
      service.updateReqBucketRegion(request, 'us-east-1');
      if (bucketRegionCache[bucket] !== 'us-east-1') {
        bucketRegionCache[bucket] = 'us-east-1';
      }
      done();
    } else if (request.httpRequest.virtualHostedBucket) {
      var getRegionReq = service.listObjects({Bucket: bucket, MaxKeys: 0});
      service.updateReqBucketRegion(getRegionReq, 'us-east-1');
      getRegionReq._requestRegionForBucket = bucket;

      getRegionReq.send(function() {
        var region = service.bucketRegionCache[bucket] || null;
        if (region && region !== request.httpRequest.region) {
          service.updateReqBucketRegion(request, region);
        }
        done();
      });
    } else {
      // DNS-compatible path-style
      // (s3ForcePathStyle or bucket name with dot over https)
      // Cannot obtain region information for this case
      done();
    }
   },

  /**
   * Cache for bucket region.
   *
   * @api private
   */
   bucketRegionCache: {},

  /**
   * Clears bucket region cache.
   *
   * @api private
   */
   clearBucketRegionCache: function(buckets) {
    var bucketRegionCache = this.bucketRegionCache;
    if (!buckets) {
      buckets = Object.keys(bucketRegionCache);
    } else if (typeof buckets === 'string') {
      buckets = [buckets];
    }
    for (var i = 0; i < buckets.length; i++) {
      delete bucketRegionCache[buckets[i]];
    }
    return bucketRegionCache;
   },

   /**
    * Corrects request region if bucket's cached region is different
    *
    * @api private
    */
  correctBucketRegionFromCache: function correctBucketRegionFromCache(req) {
    var bucket = req.params.Bucket || null;
    if (bucket) {
      var service = req.service;
      var requestRegion = req.httpRequest.region;
      var cachedRegion = service.bucketRegionCache[bucket];
      if (cachedRegion && cachedRegion !== requestRegion) {
        service.updateReqBucketRegion(req, cachedRegion);
      }
    }
  },

  /**
   * Extracts S3 specific request ids from the http response.
   *
   * @api private
   */
  extractRequestIds: function extractRequestIds(resp) {
    var extendedRequestId = resp.httpResponse.headers ? resp.httpResponse.headers['x-amz-id-2'] : null;
    var cfId = resp.httpResponse.headers ? resp.httpResponse.headers['x-amz-cf-id'] : null;
    resp.extendedRequestId = extendedRequestId;
    resp.cfId = cfId;

    if (resp.error) {
      resp.error.requestId = resp.requestId || null;
      resp.error.extendedRequestId = extendedRequestId;
      resp.error.cfId = cfId;
    }
  },

  /**
   * Get a pre-signed URL for a given operation name.
   *
   * @note You must ensure that you have static or previously resolved
   *   credentials if you call this method synchronously (with no callback),
   *   otherwise it may not properly sign the request. If you cannot guarantee
   *   this (you are using an asynchronous credential provider, i.e., EC2
   *   IAM roles), you should always call this method with an asynchronous
   *   callback.
   * @note Not all operation parameters are supported when using pre-signed
   *   URLs. Certain parameters, such as `SSECustomerKey`, `ACL`, `Expires`,
   *   `ContentLength`, or `Tagging` must be provided as headers when sending a
   *   request. If you are using pre-signed URLs to upload from a browser and
   *   need to use these fields, see {createPresignedPost}.
   * @param operation [String] the name of the operation to call
   * @param params [map] parameters to pass to the operation. See the given
   *   operation for the expected operation parameters. In addition, you can
   *   also pass the "Expires" parameter to inform S3 how long the URL should
   *   work for.
   * @option params Expires [Integer] (900) the number of seconds to expire
   *   the pre-signed URL operation in. Defaults to 15 minutes.
   * @param callback [Function] if a callback is provided, this function will
   *   pass the URL as the second parameter (after the error parameter) to
   *   the callback function.
   * @return [String] if called synchronously (with no callback), returns the
   *   signed URL.
   * @return [null] nothing is returned if a callback is provided.
   * @example Pre-signing a getObject operation (synchronously)
   *   var params = {Bucket: 'bucket', Key: 'key'};
   *   var url = s3.getSignedUrl('getObject', params);
   *   console.log('The URL is', url);
   * @example Pre-signing a putObject (asynchronously)
   *   var params = {Bucket: 'bucket', Key: 'key'};
   *   s3.getSignedUrl('putObject', params, function (err, url) {
   *     console.log('The URL is', url);
   *   });
   * @example Pre-signing a putObject operation with a specific payload
   *   var params = {Bucket: 'bucket', Key: 'key', Body: 'body'};
   *   var url = s3.getSignedUrl('putObject', params);
   *   console.log('The URL is', url);
   * @example Passing in a 1-minute expiry time for a pre-signed URL
   *   var params = {Bucket: 'bucket', Key: 'key', Expires: 60};
   *   var url = s3.getSignedUrl('getObject', params);
   *   console.log('The URL is', url); // expires in 60 seconds
   */
  getSignedUrl: function getSignedUrl(operation, params, callback) {
    params = AWS.util.copy(params || {});
    var expires = params.Expires || 900;
    delete params.Expires; // we can't validate this
    var request = this.makeRequest(operation, params);

    if (callback) {
      AWS.util.defer(function() {
        request.presign(expires, callback);
      });
    } else {
      return request.presign(expires, callback);
    }
  },


  /**
   * Get a pre-signed POST policy to support uploading to S3 directly from an
   * HTML form.
   *
   * @param params [map]
   * @option params Bucket [String]     The bucket to which the post should be
   *                                    uploaded
   * @option params Expires [Integer]   (3600) The number of seconds for which
   *                                    the presigned policy should be valid.
   * @option params Conditions [Array]  An array of conditions that must be met
   *                                    for the presigned policy to allow the
   *                                    upload. This can include required tags,
   *                                    the accepted range for content lengths,
   *                                    etc.
   * @see http://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-HTTPPOSTConstructPolicy.html
   * @option params Fields [map]        Fields to include in the form. All
   *                                    values passed in as fields will be
   *                                    signed as exact match conditions.
   * @param callback [Function]
   *
   * @note All fields passed in when creating presigned post data will be signed
   *   as exact match conditions. Any fields that will be interpolated by S3
   *   must be added to the fields hash after signing, and an appropriate
   *   condition for such fields must be explicitly added to the Conditions
   *   array passed to this function before signing.
   *
   * @example Presiging post data with a known key
   *   var params = {
   *     Bucket: 'bucket',
   *     Fields: {
   *       key: 'key'
   *     }
   *   };
   *   s3.createPresignedPost(params, function(err, data) {
   *     if (err) {
   *       console.error('Presigning post data encountered an error', err);
   *     } else {
   *       console.log('The post data is', data);
   *     }
   *   });
   *
   * @example Presigning post data with an interpolated key
   *   var params = {
   *     Bucket: 'bucket',
   *     Conditions: [
   *       ['starts-with', '$key', 'path/to/uploads/']
   *     ]
   *   };
   *   s3.createPresignedPost(params, function(err, data) {
   *     if (err) {
   *       console.error('Presigning post data encountered an error', err);
   *     } else {
   *       data.Fields.key = 'path/to/uploads/${filename}';
   *       console.log('The post data is', data);
   *     }
   *   });
   *
   * @note You must ensure that you have static or previously resolved
   *   credentials if you call this method synchronously (with no callback),
   *   otherwise it may not properly sign the request. If you cannot guarantee
   *   this (you are using an asynchronous credential provider, i.e., EC2
   *   IAM roles), you should always call this method with an asynchronous
   *   callback.
   *
   * @return [map]  If called synchronously (with no callback), returns a hash
   *                with the url to set as the form action and a hash of fields
   *                to include in the form.
   * @return [null] Nothing is returned if a callback is provided.
   *
   * @callback callback function (err, data)
   *  @param err [Error] the error object returned from the policy signer
   *  @param data [map] The data necessary to construct an HTML form
   *  @param data.url [String] The URL to use as the action of the form
   *  @param data.fields [map] A hash of fields that must be included in the
   *                           form for the upload to succeed. This hash will
   *                           include the signed POST policy, your access key
   *                           ID and security token (if present), etc. These
   *                           may be safely included as input elements of type
   *                           'hidden.'
   */
  createPresignedPost: function createPresignedPost(params, callback) {
    if (typeof params === 'function' && callback === undefined) {
      callback = params;
      params = null;
    }

    params = AWS.util.copy(params || {});
    var boundParams = this.config.params || {};
    var bucket = params.Bucket || boundParams.Bucket,
      self = this,
      config = this.config,
      endpoint = AWS.util.copy(this.endpoint);
    if (!config.s3BucketEndpoint) {
      endpoint.pathname = '/' + bucket;
    }

    function finalizePost() {
      return {
        url: AWS.util.urlFormat(endpoint),
        fields: self.preparePostFields(
          config.credentials,
          config.region,
          bucket,
          params.Fields,
          params.Conditions,
          params.Expires
        )
      };
    }

    if (callback) {
      config.getCredentials(function (err) {
        if (err) {
          callback(err);
        }

        callback(null, finalizePost());
      });
    } else {
      return finalizePost();
    }
  },

  /**
   * @api private
   */
  preparePostFields: function preparePostFields(
    credentials,
    region,
    bucket,
    fields,
    conditions,
    expiresInSeconds
  ) {
    var now = this.getSkewCorrectedDate();
    if (!credentials || !region || !bucket) {
      throw new Error('Unable to create a POST object policy without a bucket,'
        + ' region, and credentials');
    }
    fields = AWS.util.copy(fields || {});
    conditions = (conditions || []).slice(0);
    expiresInSeconds = expiresInSeconds || 3600;

    var signingDate = AWS.util.date.iso8601(now).replace(/[:\-]|\.\d{3}/g, '');
    var shortDate = signingDate.substr(0, 8);
    var scope = v4Credentials.createScope(shortDate, region, 's3');
    var credential = credentials.accessKeyId + '/' + scope;

    fields['bucket'] = bucket;
    fields['X-Amz-Algorithm'] = 'AWS4-HMAC-SHA256';
    fields['X-Amz-Credential'] = credential;
    fields['X-Amz-Date'] = signingDate;
    if (credentials.sessionToken) {
      fields['X-Amz-Security-Token'] = credentials.sessionToken;
    }
    for (var field in fields) {
      if (fields.hasOwnProperty(field)) {
        var condition = {};
        condition[field] = fields[field];
        conditions.push(condition);
      }
    }

    fields.Policy = this.preparePostPolicy(
      new Date(now.valueOf() + expiresInSeconds * 1000),
      conditions
    );
    fields['X-Amz-Signature'] = AWS.util.crypto.hmac(
      v4Credentials.getSigningKey(credentials, shortDate, region, 's3', true),
      fields.Policy,
      'hex'
    );

    return fields;
  },

  /**
   * @api private
   */
  preparePostPolicy: function preparePostPolicy(expiration, conditions) {
    return AWS.util.base64.encode(JSON.stringify({
      expiration: AWS.util.date.iso8601(expiration),
      conditions: conditions
    }));
  },

  /**
   * @api private
   */
  prepareSignedUrl: function prepareSignedUrl(request) {
    request.addListener('validate', request.service.noPresignedContentLength);
    request.removeListener('build', request.service.addContentType);
    if (!request.params.Body) {
      // no Content-MD5/SHA-256 if body is not provided
      request.removeListener('build', request.service.computeContentMd5);
    } else {
      request.addListener('afterBuild', AWS.EventListeners.Core.COMPUTE_SHA256);
    }
  },

  /**
   * @api private
   * @param request
   */
  disableBodySigning: function disableBodySigning(request) {
    var headers = request.httpRequest.headers;
    // Add the header to anything that isn't a presigned url, unless that presigned url had a body defined
    if (!Object.prototype.hasOwnProperty.call(headers, 'presigned-expires')) {
      headers['X-Amz-Content-Sha256'] = 'UNSIGNED-PAYLOAD';
    }
  },

  /**
   * @api private
   */
  noPresignedContentLength: function noPresignedContentLength(request) {
    if (request.params.ContentLength !== undefined) {
      throw AWS.util.error(new Error(), {code: 'UnexpectedParameter',
        message: 'ContentLength is not supported in pre-signed URLs.'});
    }
  },

  createBucket: function createBucket(params, callback) {
    // When creating a bucket *outside* the classic region, the location
    // constraint must be set for the bucket and it must match the endpoint.
    // This chunk of code will set the location constraint param based
    // on the region (when possible), but it will not override a passed-in
    // location constraint.
    if (typeof params === 'function' || !params) {
      callback = callback || params;
      params = {};
    }
    var hostname = this.endpoint.hostname;
    if (hostname !== this.api.globalEndpoint && !params.CreateBucketConfiguration) {
      params.CreateBucketConfiguration = { LocationConstraint: this.config.region };
    }
    return this.makeRequest('createBucket', params, callback);
  },

  /**
   * @see AWS.S3.ManagedUpload
   * @overload upload(params = {}, [options], [callback])
   *   Uploads an arbitrarily sized buffer, blob, or stream, using intelligent
   *   concurrent handling of parts if the payload is large enough. You can
   *   configure the concurrent queue size by setting `options`. Note that this
   *   is the only operation for which the SDK can retry requests with stream
   *   bodies.
   *
   *   @param (see AWS.S3.putObject)
   *   @option (see AWS.S3.ManagedUpload.constructor)
   *   @return [AWS.S3.ManagedUpload] the managed upload object that can call
   *     `send()` or track progress.
   *   @example Uploading a stream object
   *     var params = {Bucket: 'bucket', Key: 'key', Body: stream};
   *     s3.upload(params, function(err, data) {
   *       console.log(err, data);
   *     });
   *   @example Uploading a stream with concurrency of 1 and partSize of 10mb
   *     var params = {Bucket: 'bucket', Key: 'key', Body: stream};
   *     var options = {partSize: 10 * 1024 * 1024, queueSize: 1};
   *     s3.upload(params, options, function(err, data) {
   *       console.log(err, data);
   *     });
   * @callback callback function(err, data)
   *   @param err [Error] an error or null if no error occurred.
   *   @param data [map] The response data from the successful upload:
   *   @param data.Location [String] the URL of the uploaded object
   *   @param data.ETag [String] the ETag of the uploaded object
   *   @param data.Bucket [String]  the bucket to which the object was uploaded
   *   @param data.Key [String] the key to which the object was uploaded
   */
  upload: function upload(params, options, callback) {
    if (typeof options === 'function' && callback === undefined) {
      callback = options;
      options = null;
    }

    options = options || {};
    options = AWS.util.merge(options || {}, {service: this, params: params});

    var uploader = new AWS.S3.ManagedUpload(options);
    if (typeof callback === 'function') uploader.send(callback);
    return uploader;
  }
});


/***/ }),
/* 2934 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);
var byteLength = AWS.util.string.byteLength;
var Buffer = AWS.util.Buffer;

/**
 * The managed uploader allows for easy and efficient uploading of buffers,
 * blobs, or streams, using a configurable amount of concurrency to perform
 * multipart uploads where possible. This abstraction also enables uploading
 * streams of unknown size due to the use of multipart uploads.
 *
 * To construct a managed upload object, see the {constructor} function.
 *
 * ## Tracking upload progress
 *
 * The managed upload object can also track progress by attaching an
 * 'httpUploadProgress' listener to the upload manager. This event is similar
 * to {AWS.Request~httpUploadProgress} but groups all concurrent upload progress
 * into a single event. See {AWS.S3.ManagedUpload~httpUploadProgress} for more
 * information.
 *
 * ## Handling Multipart Cleanup
 *
 * By default, this class will automatically clean up any multipart uploads
 * when an individual part upload fails. This behavior can be disabled in order
 * to manually handle failures by setting the `leavePartsOnError` configuration
 * option to `true` when initializing the upload object.
 *
 * @!event httpUploadProgress(progress)
 *   Triggered when the uploader has uploaded more data.
 *   @note The `total` property may not be set if the stream being uploaded has
 *     not yet finished chunking. In this case the `total` will be undefined
 *     until the total stream size is known.
 *   @note This event will not be emitted in Node.js 0.8.x.
 *   @param progress [map] An object containing the `loaded` and `total` bytes
 *     of the request and the `key` of the S3 object. Note that `total` may be undefined until the payload
 *     size is known.
 *   @context (see AWS.Request~send)
 */
AWS.S3.ManagedUpload = AWS.util.inherit({
  /**
   * Creates a managed upload object with a set of configuration options.
   *
   * @note A "Body" parameter is required to be set prior to calling {send}.
   * @option options params [map] a map of parameters to pass to the upload
   *   requests. The "Body" parameter is required to be specified either on
   *   the service or in the params option.
   * @note ContentMD5 should not be provided when using the managed upload object.
   *   Instead, setting "computeChecksums" to true will enable automatic ContentMD5 generation
   *   by the managed upload object.
   * @option options queueSize [Number] (4) the size of the concurrent queue
   *   manager to upload parts in parallel. Set to 1 for synchronous uploading
   *   of parts. Note that the uploader will buffer at most queueSize * partSize
   *   bytes into memory at any given time.
   * @option options partSize [Number] (5mb) the size in bytes for each
   *   individual part to be uploaded. Adjust the part size to ensure the number
   *   of parts does not exceed {maxTotalParts}. See {minPartSize} for the
   *   minimum allowed part size.
   * @option options leavePartsOnError [Boolean] (false) whether to abort the
   *   multipart upload if an error occurs. Set to true if you want to handle
   *   failures manually.
   * @option options service [AWS.S3] an optional S3 service object to use for
   *   requests. This object might have bound parameters used by the uploader.
   * @option options tags [Array<map>] The tags to apply to the uploaded object.
   *   Each tag should have a `Key` and `Value` keys.
   * @example Creating a default uploader for a stream object
   *   var upload = new AWS.S3.ManagedUpload({
   *     params: {Bucket: 'bucket', Key: 'key', Body: stream}
   *   });
   * @example Creating an uploader with concurrency of 1 and partSize of 10mb
   *   var upload = new AWS.S3.ManagedUpload({
   *     partSize: 10 * 1024 * 1024, queueSize: 1,
   *     params: {Bucket: 'bucket', Key: 'key', Body: stream}
   *   });
   * @example Creating an uploader with tags
   *   var upload = new AWS.S3.ManagedUpload({
   *     params: {Bucket: 'bucket', Key: 'key', Body: stream},
   *     tags: [{Key: 'tag1', Value: 'value1'}, {Key: 'tag2', Value: 'value2'}]
   *   });
   * @see send
   */
  constructor: function ManagedUpload(options) {
    var self = this;
    AWS.SequentialExecutor.call(self);
    self.body = null;
    self.sliceFn = null;
    self.callback = null;
    self.parts = {};
    self.completeInfo = [];
    self.fillQueue = function() {
      self.callback(new Error('Unsupported body payload ' + typeof self.body));
    };

    self.configure(options);
  },

  /**
   * @api private
   */
  configure: function configure(options) {
    options = options || {};
    this.partSize = this.minPartSize;

    if (options.queueSize) this.queueSize = options.queueSize;
    if (options.partSize) this.partSize = options.partSize;
    if (options.leavePartsOnError) this.leavePartsOnError = true;
    if (options.tags) {
      if (!Array.isArray(options.tags)) {
        throw new Error('Tags must be specified as an array; ' +
          typeof options.tags + ' provided.');
      }
      this.tags = options.tags;
    }

    if (this.partSize < this.minPartSize) {
      throw new Error('partSize must be greater than ' +
                      this.minPartSize);
    }

    this.service = options.service;
    this.bindServiceObject(options.params);
    this.validateBody();
    this.adjustTotalBytes();
  },

  /**
   * @api private
   */
  leavePartsOnError: false,

  /**
   * @api private
   */
  queueSize: 4,

  /**
   * @api private
   */
  partSize: null,

  /**
   * @readonly
   * @return [Number] the minimum number of bytes for an individual part
   *   upload.
   */
  minPartSize: 1024 * 1024 * 5,

  /**
   * @readonly
   * @return [Number] the maximum allowed number of parts in a multipart upload.
   */
  maxTotalParts: 10000,

  /**
   * Initiates the managed upload for the payload.
   *
   * @callback callback function(err, data)
   *   @param err [Error] an error or null if no error occurred.
   *   @param data [map] The response data from the successful upload:
   *     * `Location` (String) the URL of the uploaded object
   *     * `ETag` (String) the ETag of the uploaded object
   *     * `Bucket` (String) the bucket to which the object was uploaded
   *     * `Key` (String) the key to which the object was uploaded
   * @example Sending a managed upload object
   *   var params = {Bucket: 'bucket', Key: 'key', Body: stream};
   *   var upload = new AWS.S3.ManagedUpload({params: params});
   *   upload.send(function(err, data) {
   *     console.log(err, data);
   *   });
   */
  send: function(callback) {
    var self = this;
    self.failed = false;
    self.callback = callback || function(err) { if (err) throw err; };

    var runFill = true;
    if (self.sliceFn) {
      self.fillQueue = self.fillBuffer;
    } else if (AWS.util.isNode()) {
      var Stream = AWS.util.stream.Stream;
      if (self.body instanceof Stream) {
        runFill = false;
        self.fillQueue = self.fillStream;
        self.partBuffers = [];
        self.body.
          on('error', function(err) { self.cleanup(err); }).
          on('readable', function() { self.fillQueue(); }).
          on('end', function() {
            self.isDoneChunking = true;
            self.numParts = self.totalPartNumbers;
            self.fillQueue.call(self);

            if (self.isDoneChunking && self.totalPartNumbers >= 1 && self.doneParts === self.numParts) {
              self.finishMultiPart();
            }
          });
      }
    }

    if (runFill) self.fillQueue.call(self);
  },

  /**
   * @!method  promise()
   *   Returns a 'thenable' promise.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function(data)
   *     Called if the promise is fulfilled.
   *     @param data [map] The response data from the successful upload:
   *       `Location` (String) the URL of the uploaded object
   *       `ETag` (String) the ETag of the uploaded object
   *       `Bucket` (String) the bucket to which the object was uploaded
   *       `Key` (String) the key to which the object was uploaded
   *   @callback rejectedCallback function(err)
   *     Called if the promise is rejected.
   *     @param err [Error] an error or null if no error occurred.
   *   @return [Promise] A promise that represents the state of the upload request.
   *   @example Sending an upload request using promises.
   *     var upload = s3.upload({Bucket: 'bucket', Key: 'key', Body: stream});
   *     var promise = upload.promise();
   *     promise.then(function(data) { ... }, function(err) { ... });
   */

  /**
   * Aborts a managed upload, including all concurrent upload requests.
   * @note By default, calling this function will cleanup a multipart upload
   *   if one was created. To leave the multipart upload around after aborting
   *   a request, configure `leavePartsOnError` to `true` in the {constructor}.
   * @note Calling {abort} in the browser environment will not abort any requests
   *   that are already in flight. If a multipart upload was created, any parts
   *   not yet uploaded will not be sent, and the multipart upload will be cleaned up.
   * @example Aborting an upload
   *   var params = {
   *     Bucket: 'bucket', Key: 'key',
   *     Body: new Buffer(1024 * 1024 * 25) // 25MB payload
   *   };
   *   var upload = s3.upload(params);
   *   upload.send(function (err, data) {
   *     if (err) console.log("Error:", err.code, err.message);
   *     else console.log(data);
   *   });
   *
   *   // abort request in 1 second
   *   setTimeout(upload.abort.bind(upload), 1000);
   */
  abort: function() {
    this.cleanup(AWS.util.error(new Error('Request aborted by user'), {
      code: 'RequestAbortedError', retryable: false
    }));
  },

  /**
   * @api private
   */
  validateBody: function validateBody() {
    var self = this;
    self.body = self.service.config.params.Body;
    if (typeof self.body === 'string') {
      self.body = new AWS.util.Buffer(self.body);
    } else if (!self.body) {
      throw new Error('params.Body is required');
    }
    self.sliceFn = AWS.util.arraySliceFn(self.body);
  },

  /**
   * @api private
   */
  bindServiceObject: function bindServiceObject(params) {
    params = params || {};
    var self = this;
    // bind parameters to new service object
    if (!self.service) {
      self.service = new AWS.S3({params: params});
    } else {
      var service = self.service;
      var config = AWS.util.copy(service.config);
      config.signatureVersion = service.getSignatureVersion();
      self.service = new service.constructor.__super__(config);
      self.service.config.params =
        AWS.util.merge(self.service.config.params || {}, params);
    }
  },

  /**
   * @api private
   */
  adjustTotalBytes: function adjustTotalBytes() {
    var self = this;
    try { // try to get totalBytes
      self.totalBytes = byteLength(self.body);
    } catch (e) { }

    // try to adjust partSize if we know payload length
    if (self.totalBytes) {
      var newPartSize = Math.ceil(self.totalBytes / self.maxTotalParts);
      if (newPartSize > self.partSize) self.partSize = newPartSize;
    } else {
      self.totalBytes = undefined;
    }
  },

  /**
   * @api private
   */
  isDoneChunking: false,

  /**
   * @api private
   */
  partPos: 0,

  /**
   * @api private
   */
  totalChunkedBytes: 0,

  /**
   * @api private
   */
  totalUploadedBytes: 0,

  /**
   * @api private
   */
  totalBytes: undefined,

  /**
   * @api private
   */
  numParts: 0,

  /**
   * @api private
   */
  totalPartNumbers: 0,

  /**
   * @api private
   */
  activeParts: 0,

  /**
   * @api private
   */
  doneParts: 0,

  /**
   * @api private
   */
  parts: null,

  /**
   * @api private
   */
  completeInfo: null,

  /**
   * @api private
   */
  failed: false,

  /**
   * @api private
   */
  multipartReq: null,

  /**
   * @api private
   */
  partBuffers: null,

  /**
   * @api private
   */
  partBufferLength: 0,

  /**
   * @api private
   */
  fillBuffer: function fillBuffer() {
    var self = this;
    var bodyLen = byteLength(self.body);

    if (bodyLen === 0) {
      self.isDoneChunking = true;
      self.numParts = 1;
      self.nextChunk(self.body);
      return;
    }

    while (self.activeParts < self.queueSize && self.partPos < bodyLen) {
      var endPos = Math.min(self.partPos + self.partSize, bodyLen);
      var buf = self.sliceFn.call(self.body, self.partPos, endPos);
      self.partPos += self.partSize;

      if (byteLength(buf) < self.partSize || self.partPos === bodyLen) {
        self.isDoneChunking = true;
        self.numParts = self.totalPartNumbers + 1;
      }
      self.nextChunk(buf);
    }
  },

  /**
   * @api private
   */
  fillStream: function fillStream() {
    var self = this;
    if (self.activeParts >= self.queueSize) return;

    var buf = self.body.read(self.partSize - self.partBufferLength) ||
              self.body.read();
    if (buf) {
      self.partBuffers.push(buf);
      self.partBufferLength += buf.length;
      self.totalChunkedBytes += buf.length;
    }

    if (self.partBufferLength >= self.partSize) {
      // if we have single buffer we avoid copyfull concat
      var pbuf = self.partBuffers.length === 1 ?
        self.partBuffers[0] : Buffer.concat(self.partBuffers);
      self.partBuffers = [];
      self.partBufferLength = 0;

      // if we have more than partSize, push the rest back on the queue
      if (pbuf.length > self.partSize) {
        var rest = pbuf.slice(self.partSize);
        self.partBuffers.push(rest);
        self.partBufferLength += rest.length;
        pbuf = pbuf.slice(0, self.partSize);
      }

      self.nextChunk(pbuf);
    }

    if (self.isDoneChunking && !self.isDoneSending) {
      // if we have single buffer we avoid copyfull concat
      pbuf = self.partBuffers.length === 1 ?
          self.partBuffers[0] : Buffer.concat(self.partBuffers);
      self.partBuffers = [];
      self.partBufferLength = 0;
      self.totalBytes = self.totalChunkedBytes;
      self.isDoneSending = true;

      if (self.numParts === 0 || pbuf.length > 0) {
        self.numParts++;
        self.nextChunk(pbuf);
      }
    }

    self.body.read(0);
  },

  /**
   * @api private
   */
  nextChunk: function nextChunk(chunk) {
    var self = this;
    if (self.failed) return null;

    var partNumber = ++self.totalPartNumbers;
    if (self.isDoneChunking && partNumber === 1) {
      var params = {Body: chunk};
      if (this.tags) {
        params.Tagging = this.getTaggingHeader();
      }
      var req = self.service.putObject(params);
      req._managedUpload = self;
      req.on('httpUploadProgress', self.progress).send(self.finishSinglePart);
      return null;
    } else if (self.service.config.params.ContentMD5) {
      var err = AWS.util.error(new Error('The Content-MD5 you specified is invalid for multi-part uploads.'), {
        code: 'InvalidDigest', retryable: false
      });

      self.cleanup(err);
      return null;
    }

    if (self.completeInfo[partNumber] && self.completeInfo[partNumber].ETag !== null) {
      return null; // Already uploaded this part.
    }

    self.activeParts++;
    if (!self.service.config.params.UploadId) {

      if (!self.multipartReq) { // create multipart
        self.multipartReq = self.service.createMultipartUpload();
        self.multipartReq.on('success', function(resp) {
          self.service.config.params.UploadId = resp.data.UploadId;
          self.multipartReq = null;
        });
        self.queueChunks(chunk, partNumber);
        self.multipartReq.on('error', function(err) {
          self.cleanup(err);
        });
        self.multipartReq.send();
      } else {
        self.queueChunks(chunk, partNumber);
      }
    } else { // multipart is created, just send
      self.uploadPart(chunk, partNumber);
    }
  },

  /**
   * @api private
   */
  getTaggingHeader: function getTaggingHeader() {
    var kvPairStrings = [];
    for (var i = 0; i < this.tags.length; i++) {
      kvPairStrings.push(AWS.util.uriEscape(this.tags[i].Key) + '=' +
        AWS.util.uriEscape(this.tags[i].Value));
    }

    return kvPairStrings.join('&');
  },

  /**
   * @api private
   */
  uploadPart: function uploadPart(chunk, partNumber) {
    var self = this;

    var partParams = {
      Body: chunk,
      ContentLength: AWS.util.string.byteLength(chunk),
      PartNumber: partNumber
    };

    var partInfo = {ETag: null, PartNumber: partNumber};
    self.completeInfo[partNumber] = partInfo;

    var req = self.service.uploadPart(partParams);
    self.parts[partNumber] = req;
    req._lastUploadedBytes = 0;
    req._managedUpload = self;
    req.on('httpUploadProgress', self.progress);
    req.send(function(err, data) {
      delete self.parts[partParams.PartNumber];
      self.activeParts--;

      if (!err && (!data || !data.ETag)) {
        var message = 'No access to ETag property on response.';
        if (AWS.util.isBrowser()) {
          message += ' Check CORS configuration to expose ETag header.';
        }

        err = AWS.util.error(new Error(message), {
          code: 'ETagMissing', retryable: false
        });
      }
      if (err) return self.cleanup(err);

      partInfo.ETag = data.ETag;
      self.doneParts++;
      if (self.isDoneChunking && self.doneParts === self.numParts) {
        self.finishMultiPart();
      } else {
        self.fillQueue.call(self);
      }
    });
  },

  /**
   * @api private
   */
  queueChunks: function queueChunks(chunk, partNumber) {
    var self = this;
    self.multipartReq.on('success', function() {
      self.uploadPart(chunk, partNumber);
    });
  },

  /**
   * @api private
   */
  cleanup: function cleanup(err) {
    var self = this;
    if (self.failed) return;

    // clean up stream
    if (typeof self.body.removeAllListeners === 'function' &&
        typeof self.body.resume === 'function') {
      self.body.removeAllListeners('readable');
      self.body.removeAllListeners('end');
      self.body.resume();
    }

    // cleanup multipartReq listeners
    if (self.multipartReq) {
      self.multipartReq.removeAllListeners('success');
      self.multipartReq.removeAllListeners('error');
      self.multipartReq.removeAllListeners('complete');
      delete self.multipartReq;
    }

    if (self.service.config.params.UploadId && !self.leavePartsOnError) {
      self.service.abortMultipartUpload().send();
    } else if (self.leavePartsOnError) {
      self.isDoneChunking = false;
    }

    AWS.util.each(self.parts, function(partNumber, part) {
      part.removeAllListeners('complete');
      part.abort();
    });

    self.activeParts = 0;
    self.partPos = 0;
    self.numParts = 0;
    self.totalPartNumbers = 0;
    self.parts = {};
    self.failed = true;
    self.callback(err);
  },

  /**
   * @api private
   */
  finishMultiPart: function finishMultiPart() {
    var self = this;
    var completeParams = { MultipartUpload: { Parts: self.completeInfo.slice(1) } };
    self.service.completeMultipartUpload(completeParams, function(err, data) {
      if (err) {
        return self.cleanup(err);
      }

      if (data && typeof data.Location === 'string') {
        data.Location = data.Location.replace(/%2F/g, '/');
      }

      if (Array.isArray(self.tags)) {
        self.service.putObjectTagging(
          {Tagging: {TagSet: self.tags}},
          function(e, d) {
            if (e) {
              self.callback(e);
            } else {
              self.callback(e, data);
            }
          }
        );
      } else {
        self.callback(err, data);
      }
    });
  },

  /**
   * @api private
   */
  finishSinglePart: function finishSinglePart(err, data) {
    var upload = this.request._managedUpload;
    var httpReq = this.request.httpRequest;
    var endpoint = httpReq.endpoint;
    if (err) return upload.callback(err);
    data.Location =
      [endpoint.protocol, '//', endpoint.host, httpReq.path].join('');
    data.key = this.request.params.Key; // will stay undocumented
    data.Key = this.request.params.Key;
    data.Bucket = this.request.params.Bucket;
    upload.callback(err, data);
  },

  /**
   * @api private
   */
  progress: function progress(info) {
    var upload = this._managedUpload;
    if (this.operation === 'putObject') {
      info.part = 1;
      info.key = this.params.Key;
    } else {
      upload.totalUploadedBytes += info.loaded - this._lastUploadedBytes;
      this._lastUploadedBytes = info.loaded;
      info = {
        loaded: upload.totalUploadedBytes,
        total: upload.totalBytes,
        part: this.params.PartNumber,
        key: this.params.Key
      };
    }
    upload.emit('httpUploadProgress', [info]);
  }
});

AWS.util.mixin(AWS.S3.ManagedUpload, AWS.SequentialExecutor);

/**
 * @api private
 */
AWS.S3.ManagedUpload.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
  this.prototype.promise = AWS.util.promisifyMethod('send', PromiseDependency);
};

/**
 * @api private
 */
AWS.S3.ManagedUpload.deletePromisesFromClass = function deletePromisesFromClass() {
  delete this.prototype.promise;
};

AWS.util.addPromises(AWS.S3.ManagedUpload);

module.exports = AWS.S3.ManagedUpload;


/***/ }),
/* 2935 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2006-03-01","checksumFormat":"md5","endpointPrefix":"s3","globalEndpoint":"s3.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"Amazon S3","serviceFullName":"Amazon Simple Storage Service","serviceId":"S3","signatureVersion":"s3","timestampFormat":"rfc822","uid":"s3-2006-03-01"},"operations":{"AbortMultipartUpload":{"http":{"method":"DELETE","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"UploadId":{"location":"querystring","locationName":"uploadId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"CompleteMultipartUpload":{"http":{"requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"MultipartUpload":{"locationName":"CompleteMultipartUpload","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"Parts":{"locationName":"Part","type":"list","member":{"type":"structure","members":{"ETag":{},"PartNumber":{"type":"integer"}}},"flattened":true}}},"UploadId":{"location":"querystring","locationName":"uploadId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}},"payload":"MultipartUpload"},"output":{"type":"structure","members":{"Location":{},"Bucket":{},"Key":{},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"ETag":{},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"CopyObject":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","CopySource","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"location":"uri","locationName":"Bucket"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentType":{"location":"header","locationName":"Content-Type"},"CopySource":{"location":"header","locationName":"x-amz-copy-source"},"CopySourceIfMatch":{"location":"header","locationName":"x-amz-copy-source-if-match"},"CopySourceIfModifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-modified-since","type":"timestamp"},"CopySourceIfNoneMatch":{"location":"header","locationName":"x-amz-copy-source-if-none-match"},"CopySourceIfUnmodifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-unmodified-since","type":"timestamp"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"MetadataDirective":{"location":"header","locationName":"x-amz-metadata-directive"},"TaggingDirective":{"location":"header","locationName":"x-amz-tagging-directive"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"CopySourceSSECustomerAlgorithm":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-algorithm"},"CopySourceSSECustomerKey":{"shape":"S1c","location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key"},"CopySourceSSECustomerKeyMD5":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Tagging":{"location":"header","locationName":"x-amz-tagging"}}},"output":{"type":"structure","members":{"CopyObjectResult":{"type":"structure","members":{"ETag":{},"LastModified":{"type":"timestamp"}}},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"CopySourceVersionId":{"location":"header","locationName":"x-amz-copy-source-version-id"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}},"payload":"CopyObjectResult"},"alias":"PutObjectCopy"},"CreateBucket":{"http":{"method":"PUT","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"location":"uri","locationName":"Bucket"},"CreateBucketConfiguration":{"locationName":"CreateBucketConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"LocationConstraint":{}}},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"}},"payload":"CreateBucketConfiguration"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"}}},"alias":"PutBucket"},"CreateMultipartUpload":{"http":{"requestUri":"/{Bucket}/{Key+}?uploads"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"location":"uri","locationName":"Bucket"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Tagging":{"location":"header","locationName":"x-amz-tagging"}}},"output":{"type":"structure","members":{"AbortDate":{"location":"header","locationName":"x-amz-abort-date","type":"timestamp"},"AbortRuleId":{"location":"header","locationName":"x-amz-abort-rule-id"},"Bucket":{"locationName":"Bucket"},"Key":{},"UploadId":{},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"alias":"InitiateMultipartUpload"},"DeleteBucket":{"http":{"method":"DELETE","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketAnalyticsConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}}},"DeleteBucketCors":{"http":{"method":"DELETE","requestUri":"/{Bucket}?cors"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketEncryption":{"http":{"method":"DELETE","requestUri":"/{Bucket}?encryption"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketInventoryConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}}},"DeleteBucketLifecycle":{"http":{"method":"DELETE","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketMetricsConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}}},"DeleteBucketPolicy":{"http":{"method":"DELETE","requestUri":"/{Bucket}?policy"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketReplication":{"http":{"method":"DELETE","requestUri":"/{Bucket}?replication"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketTagging":{"http":{"method":"DELETE","requestUri":"/{Bucket}?tagging"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketWebsite":{"http":{"method":"DELETE","requestUri":"/{Bucket}?website"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteObject":{"http":{"method":"DELETE","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"MFA":{"location":"header","locationName":"x-amz-mfa"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"DeleteObjectTagging":{"http":{"method":"DELETE","requestUri":"/{Bucket}/{Key+}?tagging"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"}}},"output":{"type":"structure","members":{"VersionId":{"location":"header","locationName":"x-amz-version-id"}}}},"DeleteObjects":{"http":{"requestUri":"/{Bucket}?delete"},"input":{"type":"structure","required":["Bucket","Delete"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delete":{"locationName":"Delete","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Objects"],"members":{"Objects":{"locationName":"Object","type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"VersionId":{}}},"flattened":true},"Quiet":{"type":"boolean"}}},"MFA":{"location":"header","locationName":"x-amz-mfa"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}},"payload":"Delete"},"output":{"type":"structure","members":{"Deleted":{"type":"list","member":{"type":"structure","members":{"Key":{},"VersionId":{},"DeleteMarker":{"type":"boolean"},"DeleteMarkerVersionId":{}}},"flattened":true},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"Errors":{"locationName":"Error","type":"list","member":{"type":"structure","members":{"Key":{},"VersionId":{},"Code":{},"Message":{}}},"flattened":true}}},"alias":"DeleteMultipleObjects"},"GetBucketAccelerateConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?accelerate"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Status":{}}}},"GetBucketAcl":{"http":{"method":"GET","requestUri":"/{Bucket}?acl"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Owner":{"shape":"S2v"},"Grants":{"shape":"S2y","locationName":"AccessControlList"}}}},"GetBucketAnalyticsConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}},"output":{"type":"structure","members":{"AnalyticsConfiguration":{"shape":"S37"}},"payload":"AnalyticsConfiguration"}},"GetBucketCors":{"http":{"method":"GET","requestUri":"/{Bucket}?cors"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"CORSRules":{"shape":"S3n","locationName":"CORSRule"}}}},"GetBucketEncryption":{"http":{"method":"GET","requestUri":"/{Bucket}?encryption"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"ServerSideEncryptionConfiguration":{"shape":"S40"}},"payload":"ServerSideEncryptionConfiguration"}},"GetBucketInventoryConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}},"output":{"type":"structure","members":{"InventoryConfiguration":{"shape":"S46"}},"payload":"InventoryConfiguration"}},"GetBucketLifecycle":{"http":{"method":"GET","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Rules":{"shape":"S4m","locationName":"Rule"}}},"deprecated":true},"GetBucketLifecycleConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Rules":{"shape":"S51","locationName":"Rule"}}}},"GetBucketLocation":{"http":{"method":"GET","requestUri":"/{Bucket}?location"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"LocationConstraint":{}}}},"GetBucketLogging":{"http":{"method":"GET","requestUri":"/{Bucket}?logging"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"LoggingEnabled":{"shape":"S5b"}}}},"GetBucketMetricsConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}},"output":{"type":"structure","members":{"MetricsConfiguration":{"shape":"S5j"}},"payload":"MetricsConfiguration"}},"GetBucketNotification":{"http":{"method":"GET","requestUri":"/{Bucket}?notification"},"input":{"shape":"S5m"},"output":{"shape":"S5n"},"deprecated":true},"GetBucketNotificationConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?notification"},"input":{"shape":"S5m"},"output":{"shape":"S5y"}},"GetBucketPolicy":{"http":{"method":"GET","requestUri":"/{Bucket}?policy"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Policy":{}},"payload":"Policy"}},"GetBucketReplication":{"http":{"method":"GET","requestUri":"/{Bucket}?replication"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"ReplicationConfiguration":{"shape":"S6h"}},"payload":"ReplicationConfiguration"}},"GetBucketRequestPayment":{"http":{"method":"GET","requestUri":"/{Bucket}?requestPayment"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Payer":{}}}},"GetBucketTagging":{"http":{"method":"GET","requestUri":"/{Bucket}?tagging"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","required":["TagSet"],"members":{"TagSet":{"shape":"S3d"}}}},"GetBucketVersioning":{"http":{"method":"GET","requestUri":"/{Bucket}?versioning"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Status":{},"MFADelete":{"locationName":"MfaDelete"}}}},"GetBucketWebsite":{"http":{"method":"GET","requestUri":"/{Bucket}?website"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"RedirectAllRequestsTo":{"shape":"S75"},"IndexDocument":{"shape":"S78"},"ErrorDocument":{"shape":"S7a"},"RoutingRules":{"shape":"S7b"}}}},"GetObject":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"IfMatch":{"location":"header","locationName":"If-Match"},"IfModifiedSince":{"location":"header","locationName":"If-Modified-Since","type":"timestamp"},"IfNoneMatch":{"location":"header","locationName":"If-None-Match"},"IfUnmodifiedSince":{"location":"header","locationName":"If-Unmodified-Since","type":"timestamp"},"Key":{"location":"uri","locationName":"Key"},"Range":{"location":"header","locationName":"Range"},"ResponseCacheControl":{"location":"querystring","locationName":"response-cache-control"},"ResponseContentDisposition":{"location":"querystring","locationName":"response-content-disposition"},"ResponseContentEncoding":{"location":"querystring","locationName":"response-content-encoding"},"ResponseContentLanguage":{"location":"querystring","locationName":"response-content-language"},"ResponseContentType":{"location":"querystring","locationName":"response-content-type"},"ResponseExpires":{"location":"querystring","locationName":"response-expires","type":"timestamp"},"VersionId":{"location":"querystring","locationName":"versionId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"}}},"output":{"type":"structure","members":{"Body":{"streaming":true,"type":"blob"},"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"AcceptRanges":{"location":"header","locationName":"accept-ranges"},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"Restore":{"location":"header","locationName":"x-amz-restore"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ETag":{"location":"header","locationName":"ETag"},"MissingMeta":{"location":"header","locationName":"x-amz-missing-meta","type":"integer"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentRange":{"location":"header","locationName":"Content-Range"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"ReplicationStatus":{"location":"header","locationName":"x-amz-replication-status"},"PartsCount":{"location":"header","locationName":"x-amz-mp-parts-count","type":"integer"},"TagCount":{"location":"header","locationName":"x-amz-tagging-count","type":"integer"}},"payload":"Body"}},"GetObjectAcl":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?acl"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"Owner":{"shape":"S2v"},"Grants":{"shape":"S2y","locationName":"AccessControlList"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"GetObjectTagging":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?tagging"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"}}},"output":{"type":"structure","required":["TagSet"],"members":{"VersionId":{"location":"header","locationName":"x-amz-version-id"},"TagSet":{"shape":"S3d"}}}},"GetObjectTorrent":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?torrent"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"Body":{"streaming":true,"type":"blob"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}},"payload":"Body"}},"HeadBucket":{"http":{"method":"HEAD","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"HeadObject":{"http":{"method":"HEAD","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"IfMatch":{"location":"header","locationName":"If-Match"},"IfModifiedSince":{"location":"header","locationName":"If-Modified-Since","type":"timestamp"},"IfNoneMatch":{"location":"header","locationName":"If-None-Match"},"IfUnmodifiedSince":{"location":"header","locationName":"If-Unmodified-Since","type":"timestamp"},"Key":{"location":"uri","locationName":"Key"},"Range":{"location":"header","locationName":"Range"},"VersionId":{"location":"querystring","locationName":"versionId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"}}},"output":{"type":"structure","members":{"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"AcceptRanges":{"location":"header","locationName":"accept-ranges"},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"Restore":{"location":"header","locationName":"x-amz-restore"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ETag":{"location":"header","locationName":"ETag"},"MissingMeta":{"location":"header","locationName":"x-amz-missing-meta","type":"integer"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"ReplicationStatus":{"location":"header","locationName":"x-amz-replication-status"},"PartsCount":{"location":"header","locationName":"x-amz-mp-parts-count","type":"integer"}}}},"ListBucketAnalyticsConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"ContinuationToken":{},"NextContinuationToken":{},"AnalyticsConfigurationList":{"locationName":"AnalyticsConfiguration","type":"list","member":{"shape":"S37"},"flattened":true}}}},"ListBucketInventoryConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"}}},"output":{"type":"structure","members":{"ContinuationToken":{},"InventoryConfigurationList":{"locationName":"InventoryConfiguration","type":"list","member":{"shape":"S46"},"flattened":true},"IsTruncated":{"type":"boolean"},"NextContinuationToken":{}}}},"ListBucketMetricsConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"ContinuationToken":{},"NextContinuationToken":{},"MetricsConfigurationList":{"locationName":"MetricsConfiguration","type":"list","member":{"shape":"S5j"},"flattened":true}}}},"ListBuckets":{"http":{"method":"GET"},"output":{"type":"structure","members":{"Buckets":{"type":"list","member":{"locationName":"Bucket","type":"structure","members":{"Name":{},"CreationDate":{"type":"timestamp"}}}},"Owner":{"shape":"S2v"}}},"alias":"GetService"},"ListMultipartUploads":{"http":{"method":"GET","requestUri":"/{Bucket}?uploads"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"KeyMarker":{"location":"querystring","locationName":"key-marker"},"MaxUploads":{"location":"querystring","locationName":"max-uploads","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"UploadIdMarker":{"location":"querystring","locationName":"upload-id-marker"}}},"output":{"type":"structure","members":{"Bucket":{},"KeyMarker":{},"UploadIdMarker":{},"NextKeyMarker":{},"Prefix":{},"Delimiter":{},"NextUploadIdMarker":{},"MaxUploads":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Uploads":{"locationName":"Upload","type":"list","member":{"type":"structure","members":{"UploadId":{},"Key":{},"Initiated":{"type":"timestamp"},"StorageClass":{},"Owner":{"shape":"S2v"},"Initiator":{"shape":"S97"}}},"flattened":true},"CommonPrefixes":{"shape":"S98"},"EncodingType":{}}}},"ListObjectVersions":{"http":{"method":"GET","requestUri":"/{Bucket}?versions"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"KeyMarker":{"location":"querystring","locationName":"key-marker"},"MaxKeys":{"location":"querystring","locationName":"max-keys","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"VersionIdMarker":{"location":"querystring","locationName":"version-id-marker"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"KeyMarker":{},"VersionIdMarker":{},"NextKeyMarker":{},"NextVersionIdMarker":{},"Versions":{"locationName":"Version","type":"list","member":{"type":"structure","members":{"ETag":{},"Size":{"type":"integer"},"StorageClass":{},"Key":{},"VersionId":{},"IsLatest":{"type":"boolean"},"LastModified":{"type":"timestamp"},"Owner":{"shape":"S2v"}}},"flattened":true},"DeleteMarkers":{"locationName":"DeleteMarker","type":"list","member":{"type":"structure","members":{"Owner":{"shape":"S2v"},"Key":{},"VersionId":{},"IsLatest":{"type":"boolean"},"LastModified":{"type":"timestamp"}}},"flattened":true},"Name":{},"Prefix":{},"Delimiter":{},"MaxKeys":{"type":"integer"},"CommonPrefixes":{"shape":"S98"},"EncodingType":{}}},"alias":"GetBucketObjectVersions"},"ListObjects":{"http":{"method":"GET","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"Marker":{"location":"querystring","locationName":"marker"},"MaxKeys":{"location":"querystring","locationName":"max-keys","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"Marker":{},"NextMarker":{},"Contents":{"shape":"S9q"},"Name":{},"Prefix":{},"Delimiter":{},"MaxKeys":{"type":"integer"},"CommonPrefixes":{"shape":"S98"},"EncodingType":{}}},"alias":"GetBucket"},"ListObjectsV2":{"http":{"method":"GET","requestUri":"/{Bucket}?list-type=2"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"MaxKeys":{"location":"querystring","locationName":"max-keys","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"},"FetchOwner":{"location":"querystring","locationName":"fetch-owner","type":"boolean"},"StartAfter":{"location":"querystring","locationName":"start-after"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"Contents":{"shape":"S9q"},"Name":{},"Prefix":{},"Delimiter":{},"MaxKeys":{"type":"integer"},"CommonPrefixes":{"shape":"S98"},"EncodingType":{},"KeyCount":{"type":"integer"},"ContinuationToken":{},"NextContinuationToken":{},"StartAfter":{}}}},"ListParts":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"MaxParts":{"location":"querystring","locationName":"max-parts","type":"integer"},"PartNumberMarker":{"location":"querystring","locationName":"part-number-marker","type":"integer"},"UploadId":{"location":"querystring","locationName":"uploadId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"AbortDate":{"location":"header","locationName":"x-amz-abort-date","type":"timestamp"},"AbortRuleId":{"location":"header","locationName":"x-amz-abort-rule-id"},"Bucket":{},"Key":{},"UploadId":{},"PartNumberMarker":{"type":"integer"},"NextPartNumberMarker":{"type":"integer"},"MaxParts":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Parts":{"locationName":"Part","type":"list","member":{"type":"structure","members":{"PartNumber":{"type":"integer"},"LastModified":{"type":"timestamp"},"ETag":{},"Size":{"type":"integer"}}},"flattened":true},"Initiator":{"shape":"S97"},"Owner":{"shape":"S2v"},"StorageClass":{},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"PutBucketAccelerateConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?accelerate"},"input":{"type":"structure","required":["Bucket","AccelerateConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"AccelerateConfiguration":{"locationName":"AccelerateConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"Status":{}}}},"payload":"AccelerateConfiguration"}},"PutBucketAcl":{"http":{"method":"PUT","requestUri":"/{Bucket}?acl"},"input":{"type":"structure","required":["Bucket"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"AccessControlPolicy":{"shape":"Sa8","locationName":"AccessControlPolicy","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"}},"payload":"AccessControlPolicy"}},"PutBucketAnalyticsConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket","Id","AnalyticsConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"AnalyticsConfiguration":{"shape":"S37","locationName":"AnalyticsConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"AnalyticsConfiguration"}},"PutBucketCors":{"http":{"method":"PUT","requestUri":"/{Bucket}?cors"},"input":{"type":"structure","required":["Bucket","CORSConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"CORSConfiguration":{"locationName":"CORSConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["CORSRules"],"members":{"CORSRules":{"shape":"S3n","locationName":"CORSRule"}}},"ContentMD5":{"location":"header","locationName":"Content-MD5"}},"payload":"CORSConfiguration"}},"PutBucketEncryption":{"http":{"method":"PUT","requestUri":"/{Bucket}?encryption"},"input":{"type":"structure","required":["Bucket","ServerSideEncryptionConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ServerSideEncryptionConfiguration":{"shape":"S40","locationName":"ServerSideEncryptionConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"ServerSideEncryptionConfiguration"}},"PutBucketInventoryConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket","Id","InventoryConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"InventoryConfiguration":{"shape":"S46","locationName":"InventoryConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"InventoryConfiguration"}},"PutBucketLifecycle":{"http":{"method":"PUT","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"LifecycleConfiguration":{"locationName":"LifecycleConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Rules"],"members":{"Rules":{"shape":"S4m","locationName":"Rule"}}}},"payload":"LifecycleConfiguration"},"deprecated":true},"PutBucketLifecycleConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"LifecycleConfiguration":{"locationName":"LifecycleConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Rules"],"members":{"Rules":{"shape":"S51","locationName":"Rule"}}}},"payload":"LifecycleConfiguration"}},"PutBucketLogging":{"http":{"method":"PUT","requestUri":"/{Bucket}?logging"},"input":{"type":"structure","required":["Bucket","BucketLoggingStatus"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"BucketLoggingStatus":{"locationName":"BucketLoggingStatus","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"LoggingEnabled":{"shape":"S5b"}}},"ContentMD5":{"location":"header","locationName":"Content-MD5"}},"payload":"BucketLoggingStatus"}},"PutBucketMetricsConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket","Id","MetricsConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"MetricsConfiguration":{"shape":"S5j","locationName":"MetricsConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"MetricsConfiguration"}},"PutBucketNotification":{"http":{"method":"PUT","requestUri":"/{Bucket}?notification"},"input":{"type":"structure","required":["Bucket","NotificationConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"NotificationConfiguration":{"shape":"S5n","locationName":"NotificationConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"NotificationConfiguration"},"deprecated":true},"PutBucketNotificationConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?notification"},"input":{"type":"structure","required":["Bucket","NotificationConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"NotificationConfiguration":{"shape":"S5y","locationName":"NotificationConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"NotificationConfiguration"}},"PutBucketPolicy":{"http":{"method":"PUT","requestUri":"/{Bucket}?policy"},"input":{"type":"structure","required":["Bucket","Policy"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ConfirmRemoveSelfBucketAccess":{"location":"header","locationName":"x-amz-confirm-remove-self-bucket-access","type":"boolean"},"Policy":{}},"payload":"Policy"}},"PutBucketReplication":{"http":{"method":"PUT","requestUri":"/{Bucket}?replication"},"input":{"type":"structure","required":["Bucket","ReplicationConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ReplicationConfiguration":{"shape":"S6h","locationName":"ReplicationConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"ReplicationConfiguration"}},"PutBucketRequestPayment":{"http":{"method":"PUT","requestUri":"/{Bucket}?requestPayment"},"input":{"type":"structure","required":["Bucket","RequestPaymentConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"RequestPaymentConfiguration":{"locationName":"RequestPaymentConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Payer"],"members":{"Payer":{}}}},"payload":"RequestPaymentConfiguration"}},"PutBucketTagging":{"http":{"method":"PUT","requestUri":"/{Bucket}?tagging"},"input":{"type":"structure","required":["Bucket","Tagging"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"Tagging":{"shape":"Sau","locationName":"Tagging","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"Tagging"}},"PutBucketVersioning":{"http":{"method":"PUT","requestUri":"/{Bucket}?versioning"},"input":{"type":"structure","required":["Bucket","VersioningConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"MFA":{"location":"header","locationName":"x-amz-mfa"},"VersioningConfiguration":{"locationName":"VersioningConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"MFADelete":{"locationName":"MfaDelete"},"Status":{}}}},"payload":"VersioningConfiguration"}},"PutBucketWebsite":{"http":{"method":"PUT","requestUri":"/{Bucket}?website"},"input":{"type":"structure","required":["Bucket","WebsiteConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"WebsiteConfiguration":{"locationName":"WebsiteConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"ErrorDocument":{"shape":"S7a"},"IndexDocument":{"shape":"S78"},"RedirectAllRequestsTo":{"shape":"S75"},"RoutingRules":{"shape":"S7b"}}}},"payload":"WebsiteConfiguration"}},"PutObject":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Body":{"streaming":true,"type":"blob"},"Bucket":{"location":"uri","locationName":"Bucket"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Tagging":{"location":"header","locationName":"x-amz-tagging"}},"payload":"Body"},"output":{"type":"structure","members":{"Expiration":{"location":"header","locationName":"x-amz-expiration"},"ETag":{"location":"header","locationName":"ETag"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"PutObjectAcl":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?acl"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"AccessControlPolicy":{"shape":"Sa8","locationName":"AccessControlPolicy","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"VersionId":{"location":"querystring","locationName":"versionId"}},"payload":"AccessControlPolicy"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"PutObjectTagging":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?tagging"},"input":{"type":"structure","required":["Bucket","Key","Tagging"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"Tagging":{"shape":"Sau","locationName":"Tagging","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"Tagging"},"output":{"type":"structure","members":{"VersionId":{"location":"header","locationName":"x-amz-version-id"}}}},"RestoreObject":{"http":{"requestUri":"/{Bucket}/{Key+}?restore"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RestoreRequest":{"locationName":"RestoreRequest","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"Days":{"type":"integer"},"GlacierJobParameters":{"type":"structure","required":["Tier"],"members":{"Tier":{}}},"Type":{},"Tier":{},"Description":{},"SelectParameters":{"type":"structure","required":["InputSerialization","ExpressionType","Expression","OutputSerialization"],"members":{"InputSerialization":{"type":"structure","members":{"CSV":{"type":"structure","members":{"FileHeaderInfo":{},"Comments":{},"QuoteEscapeCharacter":{},"RecordDelimiter":{},"FieldDelimiter":{},"QuoteCharacter":{}}}}},"ExpressionType":{},"Expression":{},"OutputSerialization":{"type":"structure","members":{"CSV":{"type":"structure","members":{"QuoteFields":{},"QuoteEscapeCharacter":{},"RecordDelimiter":{},"FieldDelimiter":{},"QuoteCharacter":{}}}}}}},"OutputLocation":{"type":"structure","members":{"S3":{"type":"structure","required":["BucketName","Prefix"],"members":{"BucketName":{},"Prefix":{},"Encryption":{"type":"structure","required":["EncryptionType"],"members":{"EncryptionType":{},"KMSKeyId":{"shape":"Sj"},"KMSContext":{}}},"CannedACL":{},"AccessControlList":{"shape":"S2y"},"Tagging":{"shape":"Sau"},"UserMetadata":{"type":"list","member":{"locationName":"MetadataEntry","type":"structure","members":{"Name":{},"Value":{}}}},"StorageClass":{}}}}}}},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}},"payload":"RestoreRequest"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"RestoreOutputPath":{"location":"header","locationName":"x-amz-restore-output-path"}}},"alias":"PostObjectRestore"},"UploadPart":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","PartNumber","UploadId"],"members":{"Body":{"streaming":true,"type":"blob"},"Bucket":{"location":"uri","locationName":"Bucket"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"Key":{"location":"uri","locationName":"Key"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"},"UploadId":{"location":"querystring","locationName":"uploadId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}},"payload":"Body"},"output":{"type":"structure","members":{"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"ETag":{"location":"header","locationName":"ETag"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"UploadPartCopy":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","CopySource","Key","PartNumber","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"CopySource":{"location":"header","locationName":"x-amz-copy-source"},"CopySourceIfMatch":{"location":"header","locationName":"x-amz-copy-source-if-match"},"CopySourceIfModifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-modified-since","type":"timestamp"},"CopySourceIfNoneMatch":{"location":"header","locationName":"x-amz-copy-source-if-none-match"},"CopySourceIfUnmodifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-unmodified-since","type":"timestamp"},"CopySourceRange":{"location":"header","locationName":"x-amz-copy-source-range"},"Key":{"location":"uri","locationName":"Key"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"},"UploadId":{"location":"querystring","locationName":"uploadId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"CopySourceSSECustomerAlgorithm":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-algorithm"},"CopySourceSSECustomerKey":{"shape":"S1c","location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key"},"CopySourceSSECustomerKeyMD5":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"CopySourceVersionId":{"location":"header","locationName":"x-amz-copy-source-version-id"},"CopyPartResult":{"type":"structure","members":{"ETag":{},"LastModified":{"type":"timestamp"}}},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}},"payload":"CopyPartResult"}}},"shapes":{"Sj":{"type":"string","sensitive":true},"S11":{"type":"map","key":{},"value":{}},"S19":{"type":"blob","sensitive":true},"S1c":{"type":"blob","sensitive":true},"S2v":{"type":"structure","members":{"DisplayName":{},"ID":{}}},"S2y":{"type":"list","member":{"locationName":"Grant","type":"structure","members":{"Grantee":{"shape":"S30"},"Permission":{}}}},"S30":{"type":"structure","required":["Type"],"members":{"DisplayName":{},"EmailAddress":{},"ID":{},"Type":{"locationName":"xsi:type","xmlAttribute":true},"URI":{}},"xmlNamespace":{"prefix":"xsi","uri":"http://www.w3.org/2001/XMLSchema-instance"}},"S37":{"type":"structure","required":["Id","StorageClassAnalysis"],"members":{"Id":{},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S3a"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3d","flattened":true,"locationName":"Tag"}}}}},"StorageClassAnalysis":{"type":"structure","members":{"DataExport":{"type":"structure","required":["OutputSchemaVersion","Destination"],"members":{"OutputSchemaVersion":{},"Destination":{"type":"structure","required":["S3BucketDestination"],"members":{"S3BucketDestination":{"type":"structure","required":["Format","Bucket"],"members":{"Format":{},"BucketAccountId":{},"Bucket":{},"Prefix":{}}}}}}}}}}},"S3a":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"S3d":{"type":"list","member":{"shape":"S3a","locationName":"Tag"}},"S3n":{"type":"list","member":{"type":"structure","required":["AllowedMethods","AllowedOrigins"],"members":{"AllowedHeaders":{"locationName":"AllowedHeader","type":"list","member":{},"flattened":true},"AllowedMethods":{"locationName":"AllowedMethod","type":"list","member":{},"flattened":true},"AllowedOrigins":{"locationName":"AllowedOrigin","type":"list","member":{},"flattened":true},"ExposeHeaders":{"locationName":"ExposeHeader","type":"list","member":{},"flattened":true},"MaxAgeSeconds":{"type":"integer"}}},"flattened":true},"S40":{"type":"structure","required":["Rules"],"members":{"Rules":{"locationName":"Rule","type":"list","member":{"type":"structure","members":{"ApplyServerSideEncryptionByDefault":{"type":"structure","required":["SSEAlgorithm"],"members":{"SSEAlgorithm":{},"KMSMasterKeyID":{"shape":"Sj"}}}}},"flattened":true}}},"S46":{"type":"structure","required":["Destination","IsEnabled","Id","IncludedObjectVersions","Schedule"],"members":{"Destination":{"type":"structure","required":["S3BucketDestination"],"members":{"S3BucketDestination":{"type":"structure","required":["Bucket","Format"],"members":{"AccountId":{},"Bucket":{},"Format":{},"Prefix":{},"Encryption":{"type":"structure","members":{"SSES3":{"locationName":"SSE-S3","type":"structure","members":{}},"SSEKMS":{"locationName":"SSE-KMS","type":"structure","required":["KeyId"],"members":{"KeyId":{"shape":"Sj"}}}}}}}}},"IsEnabled":{"type":"boolean"},"Filter":{"type":"structure","required":["Prefix"],"members":{"Prefix":{}}},"Id":{},"IncludedObjectVersions":{},"OptionalFields":{"type":"list","member":{"locationName":"Field"}},"Schedule":{"type":"structure","required":["Frequency"],"members":{"Frequency":{}}}}},"S4m":{"type":"list","member":{"type":"structure","required":["Prefix","Status"],"members":{"Expiration":{"shape":"S4o"},"ID":{},"Prefix":{},"Status":{},"Transition":{"shape":"S4t"},"NoncurrentVersionTransition":{"shape":"S4v"},"NoncurrentVersionExpiration":{"shape":"S4w"},"AbortIncompleteMultipartUpload":{"shape":"S4x"}}},"flattened":true},"S4o":{"type":"structure","members":{"Date":{"shape":"S4p"},"Days":{"type":"integer"},"ExpiredObjectDeleteMarker":{"type":"boolean"}}},"S4p":{"type":"timestamp","timestampFormat":"iso8601"},"S4t":{"type":"structure","members":{"Date":{"shape":"S4p"},"Days":{"type":"integer"},"StorageClass":{}}},"S4v":{"type":"structure","members":{"NoncurrentDays":{"type":"integer"},"StorageClass":{}}},"S4w":{"type":"structure","members":{"NoncurrentDays":{"type":"integer"}}},"S4x":{"type":"structure","members":{"DaysAfterInitiation":{"type":"integer"}}},"S51":{"type":"list","member":{"type":"structure","required":["Status"],"members":{"Expiration":{"shape":"S4o"},"ID":{},"Prefix":{"deprecated":true},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S3a"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3d","flattened":true,"locationName":"Tag"}}}}},"Status":{},"Transitions":{"locationName":"Transition","type":"list","member":{"shape":"S4t"},"flattened":true},"NoncurrentVersionTransitions":{"locationName":"NoncurrentVersionTransition","type":"list","member":{"shape":"S4v"},"flattened":true},"NoncurrentVersionExpiration":{"shape":"S4w"},"AbortIncompleteMultipartUpload":{"shape":"S4x"}}},"flattened":true},"S5b":{"type":"structure","members":{"TargetBucket":{},"TargetGrants":{"type":"list","member":{"locationName":"Grant","type":"structure","members":{"Grantee":{"shape":"S30"},"Permission":{}}}},"TargetPrefix":{}}},"S5j":{"type":"structure","required":["Id"],"members":{"Id":{},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S3a"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3d","flattened":true,"locationName":"Tag"}}}}}}},"S5m":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"S5n":{"type":"structure","members":{"TopicConfiguration":{"type":"structure","members":{"Id":{},"Events":{"shape":"S5q","locationName":"Event"},"Event":{"deprecated":true},"Topic":{}}},"QueueConfiguration":{"type":"structure","members":{"Id":{},"Event":{"deprecated":true},"Events":{"shape":"S5q","locationName":"Event"},"Queue":{}}},"CloudFunctionConfiguration":{"type":"structure","members":{"Id":{},"Event":{"deprecated":true},"Events":{"shape":"S5q","locationName":"Event"},"CloudFunction":{},"InvocationRole":{}}}}},"S5q":{"type":"list","member":{},"flattened":true},"S5y":{"type":"structure","members":{"TopicConfigurations":{"locationName":"TopicConfiguration","type":"list","member":{"type":"structure","required":["TopicArn","Events"],"members":{"Id":{},"TopicArn":{"locationName":"Topic"},"Events":{"shape":"S5q","locationName":"Event"},"Filter":{"shape":"S61"}}},"flattened":true},"QueueConfigurations":{"locationName":"QueueConfiguration","type":"list","member":{"type":"structure","required":["QueueArn","Events"],"members":{"Id":{},"QueueArn":{"locationName":"Queue"},"Events":{"shape":"S5q","locationName":"Event"},"Filter":{"shape":"S61"}}},"flattened":true},"LambdaFunctionConfigurations":{"locationName":"CloudFunctionConfiguration","type":"list","member":{"type":"structure","required":["LambdaFunctionArn","Events"],"members":{"Id":{},"LambdaFunctionArn":{"locationName":"CloudFunction"},"Events":{"shape":"S5q","locationName":"Event"},"Filter":{"shape":"S61"}}},"flattened":true}}},"S61":{"type":"structure","members":{"Key":{"locationName":"S3Key","type":"structure","members":{"FilterRules":{"locationName":"FilterRule","type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}},"flattened":true}}}}},"S6h":{"type":"structure","required":["Role","Rules"],"members":{"Role":{},"Rules":{"locationName":"Rule","type":"list","member":{"type":"structure","required":["Prefix","Status","Destination"],"members":{"ID":{},"Prefix":{},"Status":{},"SourceSelectionCriteria":{"type":"structure","members":{"SseKmsEncryptedObjects":{"type":"structure","required":["Status"],"members":{"Status":{}}}}},"Destination":{"type":"structure","required":["Bucket"],"members":{"Bucket":{},"Account":{},"StorageClass":{},"AccessControlTranslation":{"type":"structure","required":["Owner"],"members":{"Owner":{}}},"EncryptionConfiguration":{"type":"structure","members":{"ReplicaKmsKeyID":{}}}}}}},"flattened":true}}},"S75":{"type":"structure","required":["HostName"],"members":{"HostName":{},"Protocol":{}}},"S78":{"type":"structure","required":["Suffix"],"members":{"Suffix":{}}},"S7a":{"type":"structure","required":["Key"],"members":{"Key":{}}},"S7b":{"type":"list","member":{"locationName":"RoutingRule","type":"structure","required":["Redirect"],"members":{"Condition":{"type":"structure","members":{"HttpErrorCodeReturnedEquals":{},"KeyPrefixEquals":{}}},"Redirect":{"type":"structure","members":{"HostName":{},"HttpRedirectCode":{},"Protocol":{},"ReplaceKeyPrefixWith":{},"ReplaceKeyWith":{}}}}}},"S97":{"type":"structure","members":{"ID":{},"DisplayName":{}}},"S98":{"type":"list","member":{"type":"structure","members":{"Prefix":{}}},"flattened":true},"S9q":{"type":"list","member":{"type":"structure","members":{"Key":{},"LastModified":{"type":"timestamp"},"ETag":{},"Size":{"type":"integer"},"StorageClass":{},"Owner":{"shape":"S2v"}}},"flattened":true},"Sa8":{"type":"structure","members":{"Grants":{"shape":"S2y","locationName":"AccessControlList"},"Owner":{"shape":"S2v"}}},"Sau":{"type":"structure","required":["TagSet"],"members":{"TagSet":{"shape":"S3d"}}}}}

/***/ }),
/* 2936 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListBuckets":{"result_key":"Buckets"},"ListMultipartUploads":{"input_token":["KeyMarker","UploadIdMarker"],"limit_key":"MaxUploads","more_results":"IsTruncated","output_token":["NextKeyMarker","NextUploadIdMarker"],"result_key":["Uploads","CommonPrefixes"]},"ListObjectVersions":{"input_token":["KeyMarker","VersionIdMarker"],"limit_key":"MaxKeys","more_results":"IsTruncated","output_token":["NextKeyMarker","NextVersionIdMarker"],"result_key":["Versions","DeleteMarkers","CommonPrefixes"]},"ListObjects":{"input_token":"Marker","limit_key":"MaxKeys","more_results":"IsTruncated","output_token":"NextMarker || Contents[-1].Key","result_key":["Contents","CommonPrefixes"]},"ListObjectsV2":{"input_token":"ContinuationToken","limit_key":"MaxKeys","output_token":"NextContinuationToken","result_key":["Contents","CommonPrefixes"]},"ListParts":{"input_token":"PartNumberMarker","limit_key":"MaxParts","more_results":"IsTruncated","output_token":"NextPartNumberMarker","result_key":"Parts"}}}

/***/ }),
/* 2937 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"BucketExists":{"delay":5,"operation":"HeadBucket","maxAttempts":20,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"expected":301,"matcher":"status","state":"success"},{"expected":403,"matcher":"status","state":"success"},{"expected":404,"matcher":"status","state":"retry"}]},"BucketNotExists":{"delay":5,"operation":"HeadBucket","maxAttempts":20,"acceptors":[{"expected":404,"matcher":"status","state":"success"}]},"ObjectExists":{"delay":5,"operation":"HeadObject","maxAttempts":20,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"expected":404,"matcher":"status","state":"retry"}]},"ObjectNotExists":{"delay":5,"operation":"HeadObject","maxAttempts":20,"acceptors":[{"expected":404,"matcher":"status","state":"success"}]}}}

/***/ }),
/* 2938 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['servicecatalog'] = {};
AWS.ServiceCatalog = Service.defineService('servicecatalog', ['2015-12-10']);
Object.defineProperty(apiLoader.services['servicecatalog'], '2015-12-10', {
  get: function get() {
    var model = __webpack_require__(2939);
    model.paginators = __webpack_require__(2940).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ServiceCatalog;


/***/ }),
/* 2939 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-12-10","endpointPrefix":"servicecatalog","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Service Catalog","serviceId":"Service Catalog","signatureVersion":"v4","targetPrefix":"AWS242ServiceCatalogService","uid":"servicecatalog-2015-12-10"},"operations":{"AcceptPortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{}}},"output":{"type":"structure","members":{}}},"AssociatePrincipalWithPortfolio":{"input":{"type":"structure","required":["PortfolioId","PrincipalARN","PrincipalType"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PrincipalARN":{},"PrincipalType":{}}},"output":{"type":"structure","members":{}}},"AssociateProductWithPortfolio":{"input":{"type":"structure","required":["ProductId","PortfolioId"],"members":{"AcceptLanguage":{},"ProductId":{},"PortfolioId":{},"SourcePortfolioId":{}}},"output":{"type":"structure","members":{}}},"AssociateTagOptionWithResource":{"input":{"type":"structure","required":["ResourceId","TagOptionId"],"members":{"ResourceId":{},"TagOptionId":{}}},"output":{"type":"structure","members":{}}},"CopyProduct":{"input":{"type":"structure","required":["SourceProductArn","IdempotencyToken"],"members":{"AcceptLanguage":{},"SourceProductArn":{},"TargetProductId":{},"TargetProductName":{},"SourceProvisioningArtifactIdentifiers":{"type":"list","member":{"type":"map","key":{},"value":{}}},"CopyOptions":{"type":"list","member":{}},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"CopyProductToken":{}}}},"CreateConstraint":{"input":{"type":"structure","required":["PortfolioId","ProductId","Parameters","Type","IdempotencyToken"],"members":{"AcceptLanguage":{},"PortfolioId":{},"ProductId":{},"Parameters":{},"Type":{},"Description":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ConstraintDetail":{"shape":"Sv"},"ConstraintParameters":{},"Status":{}}}},"CreatePortfolio":{"input":{"type":"structure","required":["DisplayName","ProviderName","IdempotencyToken"],"members":{"AcceptLanguage":{},"DisplayName":{},"Description":{},"ProviderName":{},"Tags":{"shape":"S12"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PortfolioDetail":{"shape":"S17"},"Tags":{"shape":"S1a"}}}},"CreatePortfolioShare":{"input":{"type":"structure","required":["PortfolioId","AccountId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"AccountId":{}}},"output":{"type":"structure","members":{}}},"CreateProduct":{"input":{"type":"structure","required":["Name","Owner","ProductType","ProvisioningArtifactParameters","IdempotencyToken"],"members":{"AcceptLanguage":{},"Name":{},"Owner":{},"Description":{},"Distributor":{},"SupportDescription":{},"SupportEmail":{},"SupportUrl":{},"ProductType":{},"Tags":{"shape":"S12"},"ProvisioningArtifactParameters":{"shape":"S1k"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ProductViewDetail":{"shape":"S1s"},"ProvisioningArtifactDetail":{"shape":"S1x"},"Tags":{"shape":"S1a"}}}},"CreateProvisionedProductPlan":{"input":{"type":"structure","required":["PlanName","PlanType","ProductId","ProvisionedProductName","ProvisioningArtifactId","IdempotencyToken"],"members":{"AcceptLanguage":{},"PlanName":{},"PlanType":{},"NotificationArns":{"shape":"S22"},"PathId":{},"ProductId":{},"ProvisionedProductName":{},"ProvisioningArtifactId":{},"ProvisioningParameters":{"shape":"S25"},"IdempotencyToken":{"idempotencyToken":true},"Tags":{"shape":"S1a"}}},"output":{"type":"structure","members":{"PlanName":{},"PlanId":{},"ProvisionProductId":{},"ProvisionedProductName":{},"ProvisioningArtifactId":{}}}},"CreateProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","Parameters","IdempotencyToken"],"members":{"AcceptLanguage":{},"ProductId":{},"Parameters":{"shape":"S1k"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetail":{"shape":"S1x"},"Info":{"shape":"S1n"},"Status":{}}}},"CreateTagOption":{"input":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"output":{"type":"structure","members":{"TagOptionDetail":{"shape":"S2h"}}}},"DeleteConstraint":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{}}},"DeletePortfolio":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{}}},"DeletePortfolioShare":{"input":{"type":"structure","required":["PortfolioId","AccountId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"AccountId":{}}},"output":{"type":"structure","members":{}}},"DeleteProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{}}},"DeleteProvisionedProductPlan":{"input":{"type":"structure","required":["PlanId"],"members":{"AcceptLanguage":{},"PlanId":{},"IgnoreErrors":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{}}},"output":{"type":"structure","members":{}}},"DeleteTagOption":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{}}},"DescribeConstraint":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ConstraintDetail":{"shape":"Sv"},"ConstraintParameters":{},"Status":{}}}},"DescribeCopyProductStatus":{"input":{"type":"structure","required":["CopyProductToken"],"members":{"AcceptLanguage":{},"CopyProductToken":{}}},"output":{"type":"structure","members":{"CopyProductStatus":{},"TargetProductId":{},"StatusDetail":{}}}},"DescribePortfolio":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"PortfolioDetail":{"shape":"S17"},"Tags":{"shape":"S1a"},"TagOptions":{"shape":"S36"}}}},"DescribeProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ProductViewSummary":{"shape":"S1t"},"ProvisioningArtifacts":{"shape":"S39"}}}},"DescribeProductAsAdmin":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ProductViewDetail":{"shape":"S1s"},"ProvisioningArtifactSummaries":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"CreatedTime":{"type":"timestamp"},"ProvisioningArtifactMetadata":{"shape":"S1n"}}}},"Tags":{"shape":"S1a"},"TagOptions":{"shape":"S36"}}}},"DescribeProductView":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ProductViewSummary":{"shape":"S1t"},"ProvisioningArtifacts":{"shape":"S39"}}}},"DescribeProvisionedProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ProvisionedProductDetail":{"shape":"S3k"},"CloudWatchDashboards":{"type":"list","member":{"type":"structure","members":{"Name":{}}}}}}},"DescribeProvisionedProductPlan":{"input":{"type":"structure","required":["PlanId"],"members":{"AcceptLanguage":{},"PlanId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ProvisionedProductPlanDetails":{"type":"structure","members":{"CreatedTime":{"type":"timestamp"},"PathId":{},"ProductId":{},"PlanName":{},"PlanId":{},"ProvisionProductId":{},"ProvisionProductName":{},"PlanType":{},"ProvisioningArtifactId":{},"Status":{},"UpdatedTime":{"type":"timestamp"},"NotificationArns":{"shape":"S22"},"ProvisioningParameters":{"shape":"S25"},"Tags":{"shape":"S1a"},"StatusMessage":{}}},"ResourceChanges":{"type":"list","member":{"type":"structure","members":{"Action":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Replacement":{},"Scope":{"type":"list","member":{}},"Details":{"type":"list","member":{"type":"structure","members":{"Target":{"type":"structure","members":{"Attribute":{},"Name":{},"RequiresRecreation":{}}},"Evaluation":{},"CausingEntity":{}}}}}}},"NextPageToken":{}}}},"DescribeProvisioningArtifact":{"input":{"type":"structure","required":["ProvisioningArtifactId","ProductId"],"members":{"AcceptLanguage":{},"ProvisioningArtifactId":{},"ProductId":{},"Verbose":{"type":"boolean"}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetail":{"shape":"S1x"},"Info":{"shape":"S1n"},"Status":{}}}},"DescribeProvisioningParameters":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{},"PathId":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactParameters":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"DefaultValue":{},"ParameterType":{},"IsNoEcho":{"type":"boolean"},"Description":{},"ParameterConstraints":{"type":"structure","members":{"AllowedValues":{"type":"list","member":{}}}}}}},"ConstraintSummaries":{"shape":"S4w"},"UsageInstructions":{"type":"list","member":{"type":"structure","members":{"Type":{},"Value":{}}}},"TagOptions":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}}}}},"DescribeRecord":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S57"},"RecordOutputs":{"type":"list","member":{"type":"structure","members":{"OutputKey":{},"OutputValue":{},"Description":{}}}},"NextPageToken":{}}}},"DescribeTagOption":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"TagOptionDetail":{"shape":"S2h"}}}},"DisassociatePrincipalFromPortfolio":{"input":{"type":"structure","required":["PortfolioId","PrincipalARN"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PrincipalARN":{}}},"output":{"type":"structure","members":{}}},"DisassociateProductFromPortfolio":{"input":{"type":"structure","required":["ProductId","PortfolioId"],"members":{"AcceptLanguage":{},"ProductId":{},"PortfolioId":{}}},"output":{"type":"structure","members":{}}},"DisassociateTagOptionFromResource":{"input":{"type":"structure","required":["ResourceId","TagOptionId"],"members":{"ResourceId":{},"TagOptionId":{}}},"output":{"type":"structure","members":{}}},"ExecuteProvisionedProductPlan":{"input":{"type":"structure","required":["PlanId","IdempotencyToken"],"members":{"AcceptLanguage":{},"PlanId":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S57"}}}},"ListAcceptedPortfolioShares":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"PortfolioDetails":{"shape":"S5y"},"NextPageToken":{}}}},"ListConstraintsForPortfolio":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"ProductId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ConstraintDetails":{"type":"list","member":{"shape":"Sv"}},"NextPageToken":{}}}},"ListLaunchPaths":{"input":{"type":"structure","required":["ProductId"],"members":{"AcceptLanguage":{},"ProductId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"LaunchPathSummaries":{"type":"list","member":{"type":"structure","members":{"Id":{},"ConstraintSummaries":{"shape":"S4w"},"Tags":{"shape":"S1a"},"Name":{}}}},"NextPageToken":{}}}},"ListPortfolioAccess":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{}}},"output":{"type":"structure","members":{"AccountIds":{"type":"list","member":{}},"NextPageToken":{}}}},"ListPortfolios":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"PortfolioDetails":{"shape":"S5y"},"NextPageToken":{}}}},"ListPortfoliosForProduct":{"input":{"type":"structure","required":["ProductId"],"members":{"AcceptLanguage":{},"ProductId":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"PortfolioDetails":{"shape":"S5y"},"NextPageToken":{}}}},"ListPrincipalsForPortfolio":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"Principals":{"type":"list","member":{"type":"structure","members":{"PrincipalARN":{},"PrincipalType":{}}}},"NextPageToken":{}}}},"ListProvisionedProductPlans":{"input":{"type":"structure","members":{"AcceptLanguage":{},"ProvisionProductId":{},"PageSize":{"type":"integer"},"PageToken":{},"AccessLevelFilter":{"shape":"S6j"}}},"output":{"type":"structure","members":{"ProvisionedProductPlans":{"type":"list","member":{"type":"structure","members":{"PlanName":{},"PlanId":{},"ProvisionProductId":{},"ProvisionProductName":{},"PlanType":{},"ProvisioningArtifactId":{}}}},"NextPageToken":{}}}},"ListProvisioningArtifacts":{"input":{"type":"structure","required":["ProductId"],"members":{"AcceptLanguage":{},"ProductId":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetails":{"type":"list","member":{"shape":"S1x"}},"NextPageToken":{}}}},"ListRecordHistory":{"input":{"type":"structure","members":{"AcceptLanguage":{},"AccessLevelFilter":{"shape":"S6j"},"SearchFilter":{"type":"structure","members":{"Key":{},"Value":{}}},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"RecordDetails":{"type":"list","member":{"shape":"S57"}},"NextPageToken":{}}}},"ListResourcesForTagOption":{"input":{"type":"structure","required":["TagOptionId"],"members":{"TagOptionId":{},"ResourceType":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ResourceDetails":{"type":"list","member":{"type":"structure","members":{"Id":{},"ARN":{},"Name":{},"Description":{},"CreatedTime":{"type":"timestamp"}}}},"PageToken":{}}}},"ListTagOptions":{"input":{"type":"structure","members":{"Filters":{"type":"structure","members":{"Key":{},"Value":{},"Active":{"type":"boolean"}}},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"TagOptionDetails":{"shape":"S36"},"PageToken":{}}}},"ProvisionProduct":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId","ProvisionedProductName","ProvisionToken"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{},"PathId":{},"ProvisionedProductName":{},"ProvisioningParameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Tags":{"shape":"S1a"},"NotificationArns":{"shape":"S22"},"ProvisionToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S57"}}}},"RejectPortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{}}},"output":{"type":"structure","members":{}}},"ScanProvisionedProducts":{"input":{"type":"structure","members":{"AcceptLanguage":{},"AccessLevelFilter":{"shape":"S6j"},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ProvisionedProducts":{"type":"list","member":{"shape":"S3k"}},"NextPageToken":{}}}},"SearchProducts":{"input":{"type":"structure","members":{"AcceptLanguage":{},"Filters":{"shape":"S7l"},"PageSize":{"type":"integer"},"SortBy":{},"SortOrder":{},"PageToken":{}}},"output":{"type":"structure","members":{"ProductViewSummaries":{"type":"list","member":{"shape":"S1t"}},"ProductViewAggregations":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"Value":{},"ApproximateCount":{"type":"integer"}}}}},"NextPageToken":{}}}},"SearchProductsAsAdmin":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PortfolioId":{},"Filters":{"shape":"S7l"},"SortBy":{},"SortOrder":{},"PageToken":{},"PageSize":{"type":"integer"},"ProductSource":{}}},"output":{"type":"structure","members":{"ProductViewDetails":{"type":"list","member":{"shape":"S1s"}},"NextPageToken":{}}}},"SearchProvisionedProducts":{"input":{"type":"structure","members":{"AcceptLanguage":{},"AccessLevelFilter":{"shape":"S6j"},"Filters":{"type":"map","key":{},"value":{"type":"list","member":{}}},"SortBy":{},"SortOrder":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ProvisionedProducts":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"Type":{},"Id":{},"Status":{},"StatusMessage":{},"CreatedTime":{"type":"timestamp"},"IdempotencyToken":{},"LastRecordId":{},"Tags":{"shape":"S1a"},"PhysicalId":{},"ProductId":{},"ProvisioningArtifactId":{},"UserArn":{},"UserArnSession":{}}}},"TotalResultsCount":{"type":"integer"},"NextPageToken":{}}}},"TerminateProvisionedProduct":{"input":{"type":"structure","required":["TerminateToken"],"members":{"ProvisionedProductName":{},"ProvisionedProductId":{},"TerminateToken":{"idempotencyToken":true},"IgnoreErrors":{"type":"boolean"},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S57"}}}},"UpdateConstraint":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"Description":{}}},"output":{"type":"structure","members":{"ConstraintDetail":{"shape":"Sv"},"ConstraintParameters":{},"Status":{}}}},"UpdatePortfolio":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"DisplayName":{},"Description":{},"ProviderName":{},"AddTags":{"shape":"S12"},"RemoveTags":{"shape":"S8m"}}},"output":{"type":"structure","members":{"PortfolioDetail":{"shape":"S17"},"Tags":{"shape":"S1a"}}}},"UpdateProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"Name":{},"Owner":{},"Description":{},"Distributor":{},"SupportDescription":{},"SupportEmail":{},"SupportUrl":{},"AddTags":{"shape":"S12"},"RemoveTags":{"shape":"S8m"}}},"output":{"type":"structure","members":{"ProductViewDetail":{"shape":"S1s"},"Tags":{"shape":"S1a"}}}},"UpdateProvisionedProduct":{"input":{"type":"structure","required":["UpdateToken"],"members":{"AcceptLanguage":{},"ProvisionedProductName":{},"ProvisionedProductId":{},"ProductId":{},"ProvisioningArtifactId":{},"PathId":{},"ProvisioningParameters":{"shape":"S25"},"UpdateToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S57"}}}},"UpdateProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{},"Name":{},"Description":{},"Active":{"type":"boolean"}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetail":{"shape":"S1x"},"Info":{"shape":"S1n"},"Status":{}}}},"UpdateTagOption":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"Value":{},"Active":{"type":"boolean"}}},"output":{"type":"structure","members":{"TagOptionDetail":{"shape":"S2h"}}}}},"shapes":{"Sv":{"type":"structure","members":{"ConstraintId":{},"Type":{},"Description":{},"Owner":{}}},"S12":{"type":"list","member":{"shape":"S13"}},"S13":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"S17":{"type":"structure","members":{"Id":{},"ARN":{},"DisplayName":{},"Description":{},"CreatedTime":{"type":"timestamp"},"ProviderName":{}}},"S1a":{"type":"list","member":{"shape":"S13"}},"S1k":{"type":"structure","required":["Info"],"members":{"Name":{},"Description":{},"Info":{"shape":"S1n"},"Type":{}}},"S1n":{"type":"map","key":{},"value":{}},"S1s":{"type":"structure","members":{"ProductViewSummary":{"shape":"S1t"},"Status":{},"ProductARN":{},"CreatedTime":{"type":"timestamp"}}},"S1t":{"type":"structure","members":{"Id":{},"ProductId":{},"Name":{},"Owner":{},"ShortDescription":{},"Type":{},"Distributor":{},"HasDefaultPath":{"type":"boolean"},"SupportEmail":{},"SupportDescription":{},"SupportUrl":{}}},"S1x":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"Type":{},"CreatedTime":{"type":"timestamp"},"Active":{"type":"boolean"}}},"S22":{"type":"list","member":{}},"S25":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"UsePreviousValue":{"type":"boolean"}}}},"S2h":{"type":"structure","members":{"Key":{},"Value":{},"Active":{"type":"boolean"},"Id":{}}},"S36":{"type":"list","member":{"shape":"S2h"}},"S39":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"CreatedTime":{"type":"timestamp"}}}},"S3k":{"type":"structure","members":{"Name":{},"Arn":{},"Type":{},"Id":{},"Status":{},"StatusMessage":{},"CreatedTime":{"type":"timestamp"},"IdempotencyToken":{},"LastRecordId":{}}},"S4w":{"type":"list","member":{"type":"structure","members":{"Type":{},"Description":{}}}},"S57":{"type":"structure","members":{"RecordId":{},"ProvisionedProductName":{},"Status":{},"CreatedTime":{"type":"timestamp"},"UpdatedTime":{"type":"timestamp"},"ProvisionedProductType":{},"RecordType":{},"ProvisionedProductId":{},"ProductId":{},"ProvisioningArtifactId":{},"PathId":{},"RecordErrors":{"type":"list","member":{"type":"structure","members":{"Code":{},"Description":{}}}},"RecordTags":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}},"S5y":{"type":"list","member":{"shape":"S17"}},"S6j":{"type":"structure","members":{"Key":{},"Value":{}}},"S7l":{"type":"map","key":{},"value":{"type":"list","member":{}}},"S8m":{"type":"list","member":{}}}}

/***/ }),
/* 2940 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListAcceptedPortfolioShares":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListConstraintsForPortfolio":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListLaunchPaths":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPortfolios":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPortfoliosForProduct":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPrincipalsForPortfolio":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListResourcesForTagOption":{"input_token":"PageToken","output_token":"PageToken","limit_key":"PageSize"},"ListTagOptions":{"input_token":"PageToken","output_token":"PageToken","limit_key":"PageSize"},"SearchProducts":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"SearchProductsAsAdmin":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"SearchProvisionedProducts":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"}}}

/***/ }),
/* 2941 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['ses'] = {};
AWS.SES = Service.defineService('ses', ['2010-12-01']);
Object.defineProperty(apiLoader.services['ses'], '2010-12-01', {
  get: function get() {
    var model = __webpack_require__(2942);
    model.paginators = __webpack_require__(2943).pagination;
    model.waiters = __webpack_require__(2944).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.SES;


/***/ }),
/* 2942 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-12-01","endpointPrefix":"email","protocol":"query","serviceAbbreviation":"Amazon SES","serviceFullName":"Amazon Simple Email Service","serviceId":"SES","signatureVersion":"v4","signingName":"ses","uid":"email-2010-12-01","xmlNamespace":"http://ses.amazonaws.com/doc/2010-12-01/"},"operations":{"CloneReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName","OriginalRuleSetName"],"members":{"RuleSetName":{},"OriginalRuleSetName":{}}},"output":{"resultWrapper":"CloneReceiptRuleSetResult","type":"structure","members":{}}},"CreateConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSet"],"members":{"ConfigurationSet":{"shape":"S5"}}},"output":{"resultWrapper":"CreateConfigurationSetResult","type":"structure","members":{}}},"CreateConfigurationSetEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestination"],"members":{"ConfigurationSetName":{},"EventDestination":{"shape":"S9"}}},"output":{"resultWrapper":"CreateConfigurationSetEventDestinationResult","type":"structure","members":{}}},"CreateConfigurationSetTrackingOptions":{"input":{"type":"structure","required":["ConfigurationSetName","TrackingOptions"],"members":{"ConfigurationSetName":{},"TrackingOptions":{"shape":"Sp"}}},"output":{"resultWrapper":"CreateConfigurationSetTrackingOptionsResult","type":"structure","members":{}}},"CreateCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName","FromEmailAddress","TemplateSubject","TemplateContent","SuccessRedirectionURL","FailureRedirectionURL"],"members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"TemplateContent":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"CreateReceiptFilter":{"input":{"type":"structure","required":["Filter"],"members":{"Filter":{"shape":"S10"}}},"output":{"resultWrapper":"CreateReceiptFilterResult","type":"structure","members":{}}},"CreateReceiptRule":{"input":{"type":"structure","required":["RuleSetName","Rule"],"members":{"RuleSetName":{},"After":{},"Rule":{"shape":"S18"}}},"output":{"resultWrapper":"CreateReceiptRuleResult","type":"structure","members":{}}},"CreateReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName"],"members":{"RuleSetName":{}}},"output":{"resultWrapper":"CreateReceiptRuleSetResult","type":"structure","members":{}}},"CreateTemplate":{"input":{"type":"structure","required":["Template"],"members":{"Template":{"shape":"S20"}}},"output":{"resultWrapper":"CreateTemplateResult","type":"structure","members":{}}},"DeleteConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{}}},"output":{"resultWrapper":"DeleteConfigurationSetResult","type":"structure","members":{}}},"DeleteConfigurationSetEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestinationName"],"members":{"ConfigurationSetName":{},"EventDestinationName":{}}},"output":{"resultWrapper":"DeleteConfigurationSetEventDestinationResult","type":"structure","members":{}}},"DeleteConfigurationSetTrackingOptions":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{}}},"output":{"resultWrapper":"DeleteConfigurationSetTrackingOptionsResult","type":"structure","members":{}}},"DeleteCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}}},"DeleteIdentity":{"input":{"type":"structure","required":["Identity"],"members":{"Identity":{}}},"output":{"resultWrapper":"DeleteIdentityResult","type":"structure","members":{}}},"DeleteIdentityPolicy":{"input":{"type":"structure","required":["Identity","PolicyName"],"members":{"Identity":{},"PolicyName":{}}},"output":{"resultWrapper":"DeleteIdentityPolicyResult","type":"structure","members":{}}},"DeleteReceiptFilter":{"input":{"type":"structure","required":["FilterName"],"members":{"FilterName":{}}},"output":{"resultWrapper":"DeleteReceiptFilterResult","type":"structure","members":{}}},"DeleteReceiptRule":{"input":{"type":"structure","required":["RuleSetName","RuleName"],"members":{"RuleSetName":{},"RuleName":{}}},"output":{"resultWrapper":"DeleteReceiptRuleResult","type":"structure","members":{}}},"DeleteReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName"],"members":{"RuleSetName":{}}},"output":{"resultWrapper":"DeleteReceiptRuleSetResult","type":"structure","members":{}}},"DeleteTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}},"output":{"resultWrapper":"DeleteTemplateResult","type":"structure","members":{}}},"DeleteVerifiedEmailAddress":{"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}}},"DescribeActiveReceiptRuleSet":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"DescribeActiveReceiptRuleSetResult","type":"structure","members":{"Metadata":{"shape":"S2t"},"Rules":{"shape":"S2v"}}}},"DescribeConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{},"ConfigurationSetAttributeNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeConfigurationSetResult","type":"structure","members":{"ConfigurationSet":{"shape":"S5"},"EventDestinations":{"type":"list","member":{"shape":"S9"}},"TrackingOptions":{"shape":"Sp"},"ReputationOptions":{"type":"structure","members":{"SendingEnabled":{"type":"boolean"},"ReputationMetricsEnabled":{"type":"boolean"},"LastFreshStart":{"type":"timestamp"}}}}}},"DescribeReceiptRule":{"input":{"type":"structure","required":["RuleSetName","RuleName"],"members":{"RuleSetName":{},"RuleName":{}}},"output":{"resultWrapper":"DescribeReceiptRuleResult","type":"structure","members":{"Rule":{"shape":"S18"}}}},"DescribeReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName"],"members":{"RuleSetName":{}}},"output":{"resultWrapper":"DescribeReceiptRuleSetResult","type":"structure","members":{"Metadata":{"shape":"S2t"},"Rules":{"shape":"S2v"}}}},"GetAccountSendingEnabled":{"output":{"resultWrapper":"GetAccountSendingEnabledResult","type":"structure","members":{"Enabled":{"type":"boolean"}}}},"GetCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}},"output":{"resultWrapper":"GetCustomVerificationEmailTemplateResult","type":"structure","members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"TemplateContent":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"GetIdentityDkimAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3b"}}},"output":{"resultWrapper":"GetIdentityDkimAttributesResult","type":"structure","required":["DkimAttributes"],"members":{"DkimAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["DkimEnabled","DkimVerificationStatus"],"members":{"DkimEnabled":{"type":"boolean"},"DkimVerificationStatus":{},"DkimTokens":{"shape":"S3g"}}}}}}},"GetIdentityMailFromDomainAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3b"}}},"output":{"resultWrapper":"GetIdentityMailFromDomainAttributesResult","type":"structure","required":["MailFromDomainAttributes"],"members":{"MailFromDomainAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["MailFromDomain","MailFromDomainStatus","BehaviorOnMXFailure"],"members":{"MailFromDomain":{},"MailFromDomainStatus":{},"BehaviorOnMXFailure":{}}}}}}},"GetIdentityNotificationAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3b"}}},"output":{"resultWrapper":"GetIdentityNotificationAttributesResult","type":"structure","required":["NotificationAttributes"],"members":{"NotificationAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["BounceTopic","ComplaintTopic","DeliveryTopic","ForwardingEnabled"],"members":{"BounceTopic":{},"ComplaintTopic":{},"DeliveryTopic":{},"ForwardingEnabled":{"type":"boolean"},"HeadersInBounceNotificationsEnabled":{"type":"boolean"},"HeadersInComplaintNotificationsEnabled":{"type":"boolean"},"HeadersInDeliveryNotificationsEnabled":{"type":"boolean"}}}}}}},"GetIdentityPolicies":{"input":{"type":"structure","required":["Identity","PolicyNames"],"members":{"Identity":{},"PolicyNames":{"shape":"S3v"}}},"output":{"resultWrapper":"GetIdentityPoliciesResult","type":"structure","required":["Policies"],"members":{"Policies":{"type":"map","key":{},"value":{}}}}},"GetIdentityVerificationAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3b"}}},"output":{"resultWrapper":"GetIdentityVerificationAttributesResult","type":"structure","required":["VerificationAttributes"],"members":{"VerificationAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["VerificationStatus"],"members":{"VerificationStatus":{},"VerificationToken":{}}}}}}},"GetSendQuota":{"output":{"resultWrapper":"GetSendQuotaResult","type":"structure","members":{"Max24HourSend":{"type":"double"},"MaxSendRate":{"type":"double"},"SentLast24Hours":{"type":"double"}}}},"GetSendStatistics":{"output":{"resultWrapper":"GetSendStatisticsResult","type":"structure","members":{"SendDataPoints":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"DeliveryAttempts":{"type":"long"},"Bounces":{"type":"long"},"Complaints":{"type":"long"},"Rejects":{"type":"long"}}}}}}},"GetTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}},"output":{"resultWrapper":"GetTemplateResult","type":"structure","members":{"Template":{"shape":"S20"}}}},"ListConfigurationSets":{"input":{"type":"structure","members":{"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListConfigurationSetsResult","type":"structure","members":{"ConfigurationSets":{"type":"list","member":{"shape":"S5"}},"NextToken":{}}}},"ListCustomVerificationEmailTemplates":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListCustomVerificationEmailTemplatesResult","type":"structure","members":{"CustomVerificationEmailTemplates":{"type":"list","member":{"type":"structure","members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"NextToken":{}}}},"ListIdentities":{"input":{"type":"structure","members":{"IdentityType":{},"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListIdentitiesResult","type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3b"},"NextToken":{}}}},"ListIdentityPolicies":{"input":{"type":"structure","required":["Identity"],"members":{"Identity":{}}},"output":{"resultWrapper":"ListIdentityPoliciesResult","type":"structure","required":["PolicyNames"],"members":{"PolicyNames":{"shape":"S3v"}}}},"ListReceiptFilters":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"ListReceiptFiltersResult","type":"structure","members":{"Filters":{"type":"list","member":{"shape":"S10"}}}}},"ListReceiptRuleSets":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListReceiptRuleSetsResult","type":"structure","members":{"RuleSets":{"type":"list","member":{"shape":"S2t"}},"NextToken":{}}}},"ListTemplates":{"input":{"type":"structure","members":{"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListTemplatesResult","type":"structure","members":{"TemplatesMetadata":{"type":"list","member":{"type":"structure","members":{"Name":{},"CreatedTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListVerifiedEmailAddresses":{"output":{"resultWrapper":"ListVerifiedEmailAddressesResult","type":"structure","members":{"VerifiedEmailAddresses":{"shape":"S53"}}}},"PutIdentityPolicy":{"input":{"type":"structure","required":["Identity","PolicyName","Policy"],"members":{"Identity":{},"PolicyName":{},"Policy":{}}},"output":{"resultWrapper":"PutIdentityPolicyResult","type":"structure","members":{}}},"ReorderReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName","RuleNames"],"members":{"RuleSetName":{},"RuleNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"ReorderReceiptRuleSetResult","type":"structure","members":{}}},"SendBounce":{"input":{"type":"structure","required":["OriginalMessageId","BounceSender","BouncedRecipientInfoList"],"members":{"OriginalMessageId":{},"BounceSender":{},"Explanation":{},"MessageDsn":{"type":"structure","required":["ReportingMta"],"members":{"ReportingMta":{},"ArrivalDate":{"type":"timestamp"},"ExtensionFields":{"shape":"S5f"}}},"BouncedRecipientInfoList":{"type":"list","member":{"type":"structure","required":["Recipient"],"members":{"Recipient":{},"RecipientArn":{},"BounceType":{},"RecipientDsnFields":{"type":"structure","required":["Action","Status"],"members":{"FinalRecipient":{},"Action":{},"RemoteMta":{},"Status":{},"DiagnosticCode":{},"LastAttemptDate":{"type":"timestamp"},"ExtensionFields":{"shape":"S5f"}}}}}},"BounceSenderArn":{}}},"output":{"resultWrapper":"SendBounceResult","type":"structure","members":{"MessageId":{}}}},"SendBulkTemplatedEmail":{"input":{"type":"structure","required":["Source","Template","Destinations"],"members":{"Source":{},"SourceArn":{},"ReplyToAddresses":{"shape":"S53"},"ReturnPath":{},"ReturnPathArn":{},"ConfigurationSetName":{},"DefaultTags":{"shape":"S5u"},"Template":{},"TemplateArn":{},"DefaultTemplateData":{},"Destinations":{"type":"list","member":{"type":"structure","required":["Destination"],"members":{"Destination":{"shape":"S61"},"ReplacementTags":{"shape":"S5u"},"ReplacementTemplateData":{}}}}}},"output":{"resultWrapper":"SendBulkTemplatedEmailResult","type":"structure","required":["Status"],"members":{"Status":{"type":"list","member":{"type":"structure","members":{"Status":{},"Error":{},"MessageId":{}}}}}}},"SendCustomVerificationEmail":{"input":{"type":"structure","required":["EmailAddress","TemplateName"],"members":{"EmailAddress":{},"TemplateName":{},"ConfigurationSetName":{}}},"output":{"resultWrapper":"SendCustomVerificationEmailResult","type":"structure","members":{"MessageId":{}}}},"SendEmail":{"input":{"type":"structure","required":["Source","Destination","Message"],"members":{"Source":{},"Destination":{"shape":"S61"},"Message":{"type":"structure","required":["Subject","Body"],"members":{"Subject":{"shape":"S6b"},"Body":{"type":"structure","members":{"Text":{"shape":"S6b"},"Html":{"shape":"S6b"}}}}},"ReplyToAddresses":{"shape":"S53"},"ReturnPath":{},"SourceArn":{},"ReturnPathArn":{},"Tags":{"shape":"S5u"},"ConfigurationSetName":{}}},"output":{"resultWrapper":"SendEmailResult","type":"structure","required":["MessageId"],"members":{"MessageId":{}}}},"SendRawEmail":{"input":{"type":"structure","required":["RawMessage"],"members":{"Source":{},"Destinations":{"shape":"S53"},"RawMessage":{"type":"structure","required":["Data"],"members":{"Data":{"type":"blob"}}},"FromArn":{},"SourceArn":{},"ReturnPathArn":{},"Tags":{"shape":"S5u"},"ConfigurationSetName":{}}},"output":{"resultWrapper":"SendRawEmailResult","type":"structure","required":["MessageId"],"members":{"MessageId":{}}}},"SendTemplatedEmail":{"input":{"type":"structure","required":["Source","Destination","Template","TemplateData"],"members":{"Source":{},"Destination":{"shape":"S61"},"ReplyToAddresses":{"shape":"S53"},"ReturnPath":{},"SourceArn":{},"ReturnPathArn":{},"Tags":{"shape":"S5u"},"ConfigurationSetName":{},"Template":{},"TemplateArn":{},"TemplateData":{}}},"output":{"resultWrapper":"SendTemplatedEmailResult","type":"structure","required":["MessageId"],"members":{"MessageId":{}}}},"SetActiveReceiptRuleSet":{"input":{"type":"structure","members":{"RuleSetName":{}}},"output":{"resultWrapper":"SetActiveReceiptRuleSetResult","type":"structure","members":{}}},"SetIdentityDkimEnabled":{"input":{"type":"structure","required":["Identity","DkimEnabled"],"members":{"Identity":{},"DkimEnabled":{"type":"boolean"}}},"output":{"resultWrapper":"SetIdentityDkimEnabledResult","type":"structure","members":{}}},"SetIdentityFeedbackForwardingEnabled":{"input":{"type":"structure","required":["Identity","ForwardingEnabled"],"members":{"Identity":{},"ForwardingEnabled":{"type":"boolean"}}},"output":{"resultWrapper":"SetIdentityFeedbackForwardingEnabledResult","type":"structure","members":{}}},"SetIdentityHeadersInNotificationsEnabled":{"input":{"type":"structure","required":["Identity","NotificationType","Enabled"],"members":{"Identity":{},"NotificationType":{},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"SetIdentityHeadersInNotificationsEnabledResult","type":"structure","members":{}}},"SetIdentityMailFromDomain":{"input":{"type":"structure","required":["Identity"],"members":{"Identity":{},"MailFromDomain":{},"BehaviorOnMXFailure":{}}},"output":{"resultWrapper":"SetIdentityMailFromDomainResult","type":"structure","members":{}}},"SetIdentityNotificationTopic":{"input":{"type":"structure","required":["Identity","NotificationType"],"members":{"Identity":{},"NotificationType":{},"SnsTopic":{}}},"output":{"resultWrapper":"SetIdentityNotificationTopicResult","type":"structure","members":{}}},"SetReceiptRulePosition":{"input":{"type":"structure","required":["RuleSetName","RuleName"],"members":{"RuleSetName":{},"RuleName":{},"After":{}}},"output":{"resultWrapper":"SetReceiptRulePositionResult","type":"structure","members":{}}},"TestRenderTemplate":{"input":{"type":"structure","required":["TemplateName","TemplateData"],"members":{"TemplateName":{},"TemplateData":{}}},"output":{"resultWrapper":"TestRenderTemplateResult","type":"structure","members":{"RenderedTemplate":{}}}},"UpdateAccountSendingEnabled":{"input":{"type":"structure","members":{"Enabled":{"type":"boolean"}}}},"UpdateConfigurationSetEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestination"],"members":{"ConfigurationSetName":{},"EventDestination":{"shape":"S9"}}},"output":{"resultWrapper":"UpdateConfigurationSetEventDestinationResult","type":"structure","members":{}}},"UpdateConfigurationSetReputationMetricsEnabled":{"input":{"type":"structure","required":["ConfigurationSetName","Enabled"],"members":{"ConfigurationSetName":{},"Enabled":{"type":"boolean"}}}},"UpdateConfigurationSetSendingEnabled":{"input":{"type":"structure","required":["ConfigurationSetName","Enabled"],"members":{"ConfigurationSetName":{},"Enabled":{"type":"boolean"}}}},"UpdateConfigurationSetTrackingOptions":{"input":{"type":"structure","required":["ConfigurationSetName","TrackingOptions"],"members":{"ConfigurationSetName":{},"TrackingOptions":{"shape":"Sp"}}},"output":{"resultWrapper":"UpdateConfigurationSetTrackingOptionsResult","type":"structure","members":{}}},"UpdateCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"TemplateContent":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"UpdateReceiptRule":{"input":{"type":"structure","required":["RuleSetName","Rule"],"members":{"RuleSetName":{},"Rule":{"shape":"S18"}}},"output":{"resultWrapper":"UpdateReceiptRuleResult","type":"structure","members":{}}},"UpdateTemplate":{"input":{"type":"structure","required":["Template"],"members":{"Template":{"shape":"S20"}}},"output":{"resultWrapper":"UpdateTemplateResult","type":"structure","members":{}}},"VerifyDomainDkim":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"resultWrapper":"VerifyDomainDkimResult","type":"structure","required":["DkimTokens"],"members":{"DkimTokens":{"shape":"S3g"}}}},"VerifyDomainIdentity":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"resultWrapper":"VerifyDomainIdentityResult","type":"structure","required":["VerificationToken"],"members":{"VerificationToken":{}}}},"VerifyEmailAddress":{"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}}},"VerifyEmailIdentity":{"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}},"output":{"resultWrapper":"VerifyEmailIdentityResult","type":"structure","members":{}}}},"shapes":{"S5":{"type":"structure","required":["Name"],"members":{"Name":{}}},"S9":{"type":"structure","required":["Name","MatchingEventTypes"],"members":{"Name":{},"Enabled":{"type":"boolean"},"MatchingEventTypes":{"type":"list","member":{}},"KinesisFirehoseDestination":{"type":"structure","required":["IAMRoleARN","DeliveryStreamARN"],"members":{"IAMRoleARN":{},"DeliveryStreamARN":{}}},"CloudWatchDestination":{"type":"structure","required":["DimensionConfigurations"],"members":{"DimensionConfigurations":{"type":"list","member":{"type":"structure","required":["DimensionName","DimensionValueSource","DefaultDimensionValue"],"members":{"DimensionName":{},"DimensionValueSource":{},"DefaultDimensionValue":{}}}}}},"SNSDestination":{"type":"structure","required":["TopicARN"],"members":{"TopicARN":{}}}}},"Sp":{"type":"structure","members":{"CustomRedirectDomain":{}}},"S10":{"type":"structure","required":["Name","IpFilter"],"members":{"Name":{},"IpFilter":{"type":"structure","required":["Policy","Cidr"],"members":{"Policy":{},"Cidr":{}}}}},"S18":{"type":"structure","required":["Name"],"members":{"Name":{},"Enabled":{"type":"boolean"},"TlsPolicy":{},"Recipients":{"type":"list","member":{}},"Actions":{"type":"list","member":{"type":"structure","members":{"S3Action":{"type":"structure","required":["BucketName"],"members":{"TopicArn":{},"BucketName":{},"ObjectKeyPrefix":{},"KmsKeyArn":{}}},"BounceAction":{"type":"structure","required":["SmtpReplyCode","Message","Sender"],"members":{"TopicArn":{},"SmtpReplyCode":{},"StatusCode":{},"Message":{},"Sender":{}}},"WorkmailAction":{"type":"structure","required":["OrganizationArn"],"members":{"TopicArn":{},"OrganizationArn":{}}},"LambdaAction":{"type":"structure","required":["FunctionArn"],"members":{"TopicArn":{},"FunctionArn":{},"InvocationType":{}}},"StopAction":{"type":"structure","required":["Scope"],"members":{"Scope":{},"TopicArn":{}}},"AddHeaderAction":{"type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}},"SNSAction":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{},"Encoding":{}}}}}},"ScanEnabled":{"type":"boolean"}}},"S20":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{},"SubjectPart":{},"TextPart":{},"HtmlPart":{}}},"S2t":{"type":"structure","members":{"Name":{},"CreatedTimestamp":{"type":"timestamp"}}},"S2v":{"type":"list","member":{"shape":"S18"}},"S3b":{"type":"list","member":{}},"S3g":{"type":"list","member":{}},"S3v":{"type":"list","member":{}},"S53":{"type":"list","member":{}},"S5f":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S5u":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S61":{"type":"structure","members":{"ToAddresses":{"shape":"S53"},"CcAddresses":{"shape":"S53"},"BccAddresses":{"shape":"S53"}}},"S6b":{"type":"structure","required":["Data"],"members":{"Data":{},"Charset":{}}}}}

/***/ }),
/* 2943 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCustomVerificationEmailTemplates":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListIdentities":{"input_token":"NextToken","limit_key":"MaxItems","output_token":"NextToken","result_key":"Identities"},"ListVerifiedEmailAddresses":{"result_key":"VerifiedEmailAddresses"}}}

/***/ }),
/* 2944 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"IdentityExists":{"delay":3,"operation":"GetIdentityVerificationAttributes","maxAttempts":20,"acceptors":[{"expected":"Success","matcher":"pathAll","state":"success","argument":"VerificationAttributes.*.VerificationStatus"}]}}}

/***/ }),
/* 2945 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['sns'] = {};
AWS.SNS = Service.defineService('sns', ['2010-03-31']);
Object.defineProperty(apiLoader.services['sns'], '2010-03-31', {
  get: function get() {
    var model = __webpack_require__(2946);
    model.paginators = __webpack_require__(2947).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.SNS;


/***/ }),
/* 2946 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"uid":"sns-2010-03-31","apiVersion":"2010-03-31","endpointPrefix":"sns","protocol":"query","serviceAbbreviation":"Amazon SNS","serviceFullName":"Amazon Simple Notification Service","signatureVersion":"v4","xmlNamespace":"http://sns.amazonaws.com/doc/2010-03-31/"},"operations":{"AddPermission":{"input":{"type":"structure","required":["TopicArn","Label","AWSAccountId","ActionName"],"members":{"TopicArn":{},"Label":{},"AWSAccountId":{"type":"list","member":{}},"ActionName":{"type":"list","member":{}}}}},"CheckIfPhoneNumberIsOptedOut":{"input":{"type":"structure","required":["phoneNumber"],"members":{"phoneNumber":{}}},"output":{"resultWrapper":"CheckIfPhoneNumberIsOptedOutResult","type":"structure","members":{"isOptedOut":{"type":"boolean"}}}},"ConfirmSubscription":{"input":{"type":"structure","required":["TopicArn","Token"],"members":{"TopicArn":{},"Token":{},"AuthenticateOnUnsubscribe":{}}},"output":{"resultWrapper":"ConfirmSubscriptionResult","type":"structure","members":{"SubscriptionArn":{}}}},"CreatePlatformApplication":{"input":{"type":"structure","required":["Name","Platform","Attributes"],"members":{"Name":{},"Platform":{},"Attributes":{"shape":"Sj"}}},"output":{"resultWrapper":"CreatePlatformApplicationResult","type":"structure","members":{"PlatformApplicationArn":{}}}},"CreatePlatformEndpoint":{"input":{"type":"structure","required":["PlatformApplicationArn","Token"],"members":{"PlatformApplicationArn":{},"Token":{},"CustomUserData":{},"Attributes":{"shape":"Sj"}}},"output":{"resultWrapper":"CreatePlatformEndpointResult","type":"structure","members":{"EndpointArn":{}}}},"CreateTopic":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"resultWrapper":"CreateTopicResult","type":"structure","members":{"TopicArn":{}}}},"DeleteEndpoint":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}}},"DeletePlatformApplication":{"input":{"type":"structure","required":["PlatformApplicationArn"],"members":{"PlatformApplicationArn":{}}}},"DeleteTopic":{"input":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{}}}},"GetEndpointAttributes":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}},"output":{"resultWrapper":"GetEndpointAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sj"}}}},"GetPlatformApplicationAttributes":{"input":{"type":"structure","required":["PlatformApplicationArn"],"members":{"PlatformApplicationArn":{}}},"output":{"resultWrapper":"GetPlatformApplicationAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sj"}}}},"GetSMSAttributes":{"input":{"type":"structure","members":{"attributes":{"type":"list","member":{}}}},"output":{"resultWrapper":"GetSMSAttributesResult","type":"structure","members":{"attributes":{"shape":"Sj"}}}},"GetSubscriptionAttributes":{"input":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{}}},"output":{"resultWrapper":"GetSubscriptionAttributesResult","type":"structure","members":{"Attributes":{"type":"map","key":{},"value":{}}}}},"GetTopicAttributes":{"input":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{}}},"output":{"resultWrapper":"GetTopicAttributesResult","type":"structure","members":{"Attributes":{"type":"map","key":{},"value":{}}}}},"ListEndpointsByPlatformApplication":{"input":{"type":"structure","required":["PlatformApplicationArn"],"members":{"PlatformApplicationArn":{},"NextToken":{}}},"output":{"resultWrapper":"ListEndpointsByPlatformApplicationResult","type":"structure","members":{"Endpoints":{"type":"list","member":{"type":"structure","members":{"EndpointArn":{},"Attributes":{"shape":"Sj"}}}},"NextToken":{}}}},"ListPhoneNumbersOptedOut":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"resultWrapper":"ListPhoneNumbersOptedOutResult","type":"structure","members":{"phoneNumbers":{"type":"list","member":{}},"nextToken":{}}}},"ListPlatformApplications":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListPlatformApplicationsResult","type":"structure","members":{"PlatformApplications":{"type":"list","member":{"type":"structure","members":{"PlatformApplicationArn":{},"Attributes":{"shape":"Sj"}}}},"NextToken":{}}}},"ListSubscriptions":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListSubscriptionsResult","type":"structure","members":{"Subscriptions":{"shape":"S1n"},"NextToken":{}}}},"ListSubscriptionsByTopic":{"input":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{},"NextToken":{}}},"output":{"resultWrapper":"ListSubscriptionsByTopicResult","type":"structure","members":{"Subscriptions":{"shape":"S1n"},"NextToken":{}}}},"ListTopics":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListTopicsResult","type":"structure","members":{"Topics":{"type":"list","member":{"type":"structure","members":{"TopicArn":{}}}},"NextToken":{}}}},"OptInPhoneNumber":{"input":{"type":"structure","required":["phoneNumber"],"members":{"phoneNumber":{}}},"output":{"resultWrapper":"OptInPhoneNumberResult","type":"structure","members":{}}},"Publish":{"input":{"type":"structure","required":["Message"],"members":{"TopicArn":{},"TargetArn":{},"PhoneNumber":{},"Message":{},"Subject":{},"MessageStructure":{},"MessageAttributes":{"type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value","type":"structure","required":["DataType"],"members":{"DataType":{},"StringValue":{},"BinaryValue":{"type":"blob"}}}}}},"output":{"resultWrapper":"PublishResult","type":"structure","members":{"MessageId":{}}}},"RemovePermission":{"input":{"type":"structure","required":["TopicArn","Label"],"members":{"TopicArn":{},"Label":{}}}},"SetEndpointAttributes":{"input":{"type":"structure","required":["EndpointArn","Attributes"],"members":{"EndpointArn":{},"Attributes":{"shape":"Sj"}}}},"SetPlatformApplicationAttributes":{"input":{"type":"structure","required":["PlatformApplicationArn","Attributes"],"members":{"PlatformApplicationArn":{},"Attributes":{"shape":"Sj"}}}},"SetSMSAttributes":{"input":{"type":"structure","required":["attributes"],"members":{"attributes":{"shape":"Sj"}}},"output":{"resultWrapper":"SetSMSAttributesResult","type":"structure","members":{}}},"SetSubscriptionAttributes":{"input":{"type":"structure","required":["SubscriptionArn","AttributeName"],"members":{"SubscriptionArn":{},"AttributeName":{},"AttributeValue":{}}}},"SetTopicAttributes":{"input":{"type":"structure","required":["TopicArn","AttributeName"],"members":{"TopicArn":{},"AttributeName":{},"AttributeValue":{}}}},"Subscribe":{"input":{"type":"structure","required":["TopicArn","Protocol"],"members":{"TopicArn":{},"Protocol":{},"Endpoint":{}}},"output":{"resultWrapper":"SubscribeResult","type":"structure","members":{"SubscriptionArn":{}}}},"Unsubscribe":{"input":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{}}}}},"shapes":{"Sj":{"type":"map","key":{},"value":{}},"S1n":{"type":"list","member":{"type":"structure","members":{"SubscriptionArn":{},"Owner":{},"Protocol":{},"Endpoint":{},"TopicArn":{}}}}}}

/***/ }),
/* 2947 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListEndpointsByPlatformApplication":{"input_token":"NextToken","output_token":"NextToken","result_key":"Endpoints"},"ListPlatformApplications":{"input_token":"NextToken","output_token":"NextToken","result_key":"PlatformApplications"},"ListSubscriptions":{"input_token":"NextToken","output_token":"NextToken","result_key":"Subscriptions"},"ListSubscriptionsByTopic":{"input_token":"NextToken","output_token":"NextToken","result_key":"Subscriptions"},"ListTopics":{"input_token":"NextToken","output_token":"NextToken","result_key":"Topics"}}}

/***/ }),
/* 2948 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['sqs'] = {};
AWS.SQS = Service.defineService('sqs', ['2012-11-05']);
__webpack_require__(2949);
Object.defineProperty(apiLoader.services['sqs'], '2012-11-05', {
  get: function get() {
    var model = __webpack_require__(2950);
    model.paginators = __webpack_require__(2951).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.SQS;


/***/ }),
/* 2949 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(5);

AWS.util.update(AWS.SQS.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    request.addListener('build', this.buildEndpoint);

    if (request.service.config.computeChecksums) {
      if (request.operation === 'sendMessage') {
        request.addListener('extractData', this.verifySendMessageChecksum);
      } else if (request.operation === 'sendMessageBatch') {
        request.addListener('extractData', this.verifySendMessageBatchChecksum);
      } else if (request.operation === 'receiveMessage') {
        request.addListener('extractData', this.verifyReceiveMessageChecksum);
      }
    }
  },

  /**
   * @api private
   */
  verifySendMessageChecksum: function verifySendMessageChecksum(response) {
    if (!response.data) return;

    var md5 = response.data.MD5OfMessageBody;
    var body = this.params.MessageBody;
    var calculatedMd5 = this.service.calculateChecksum(body);
    if (calculatedMd5 !== md5) {
      var msg = 'Got "' + response.data.MD5OfMessageBody +
        '", expecting "' + calculatedMd5 + '".';
      this.service.throwInvalidChecksumError(response,
        [response.data.MessageId], msg);
    }
  },

  /**
   * @api private
   */
  verifySendMessageBatchChecksum: function verifySendMessageBatchChecksum(response) {
    if (!response.data) return;

    var service = this.service;
    var entries = {};
    var errors = [];
    var messageIds = [];
    AWS.util.arrayEach(response.data.Successful, function (entry) {
      entries[entry.Id] = entry;
    });
    AWS.util.arrayEach(this.params.Entries, function (entry) {
      if (entries[entry.Id]) {
        var md5 = entries[entry.Id].MD5OfMessageBody;
        var body = entry.MessageBody;
        if (!service.isChecksumValid(md5, body)) {
          errors.push(entry.Id);
          messageIds.push(entries[entry.Id].MessageId);
        }
      }
    });

    if (errors.length > 0) {
      service.throwInvalidChecksumError(response, messageIds,
        'Invalid messages: ' + errors.join(', '));
    }
  },

  /**
   * @api private
   */
  verifyReceiveMessageChecksum: function verifyReceiveMessageChecksum(response) {
    if (!response.data) return;

    var service = this.service;
    var messageIds = [];
    AWS.util.arrayEach(response.data.Messages, function(message) {
      var md5 = message.MD5OfBody;
      var body = message.Body;
      if (!service.isChecksumValid(md5, body)) {
        messageIds.push(message.MessageId);
      }
    });

    if (messageIds.length > 0) {
      service.throwInvalidChecksumError(response, messageIds,
        'Invalid messages: ' + messageIds.join(', '));
    }
  },

  /**
   * @api private
   */
  throwInvalidChecksumError: function throwInvalidChecksumError(response, ids, message) {
    response.error = AWS.util.error(new Error(), {
      retryable: true,
      code: 'InvalidChecksum',
      messageIds: ids,
      message: response.request.operation +
               ' returned an invalid MD5 response. ' + message
    });
  },

  /**
   * @api private
   */
  isChecksumValid: function isChecksumValid(checksum, data) {
    return this.calculateChecksum(data) === checksum;
  },

  /**
   * @api private
   */
  calculateChecksum: function calculateChecksum(data) {
    return AWS.util.crypto.md5(data, 'hex');
  },

  /**
   * @api private
   */
  buildEndpoint: function buildEndpoint(request) {
    var url = request.httpRequest.params.QueueUrl;
    if (url) {
      request.httpRequest.endpoint = new AWS.Endpoint(url);

      // signature version 4 requires the region name to be set,
      // sqs queue urls contain the region name
      var matches = request.httpRequest.endpoint.host.match(/^sqs\.(.+?)\./);
      if (matches) request.httpRequest.region = matches[1];
    }
  }
});


/***/ }),
/* 2950 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-11-05","endpointPrefix":"sqs","protocol":"query","serviceAbbreviation":"Amazon SQS","serviceFullName":"Amazon Simple Queue Service","signatureVersion":"v4","uid":"sqs-2012-11-05","xmlNamespace":"http://queue.amazonaws.com/doc/2012-11-05/"},"operations":{"AddPermission":{"input":{"type":"structure","required":["QueueUrl","Label","AWSAccountIds","Actions"],"members":{"QueueUrl":{},"Label":{},"AWSAccountIds":{"type":"list","member":{"locationName":"AWSAccountId"},"flattened":true},"Actions":{"type":"list","member":{"locationName":"ActionName"},"flattened":true}}}},"ChangeMessageVisibility":{"input":{"type":"structure","required":["QueueUrl","ReceiptHandle","VisibilityTimeout"],"members":{"QueueUrl":{},"ReceiptHandle":{},"VisibilityTimeout":{"type":"integer"}}}},"ChangeMessageVisibilityBatch":{"input":{"type":"structure","required":["QueueUrl","Entries"],"members":{"QueueUrl":{},"Entries":{"type":"list","member":{"locationName":"ChangeMessageVisibilityBatchRequestEntry","type":"structure","required":["Id","ReceiptHandle"],"members":{"Id":{},"ReceiptHandle":{},"VisibilityTimeout":{"type":"integer"}}},"flattened":true}}},"output":{"resultWrapper":"ChangeMessageVisibilityBatchResult","type":"structure","required":["Successful","Failed"],"members":{"Successful":{"type":"list","member":{"locationName":"ChangeMessageVisibilityBatchResultEntry","type":"structure","required":["Id"],"members":{"Id":{}}},"flattened":true},"Failed":{"shape":"Sd"}}}},"CreateQueue":{"input":{"type":"structure","required":["QueueName"],"members":{"QueueName":{},"Attributes":{"shape":"Sh","locationName":"Attribute"}}},"output":{"resultWrapper":"CreateQueueResult","type":"structure","members":{"QueueUrl":{}}}},"DeleteMessage":{"input":{"type":"structure","required":["QueueUrl","ReceiptHandle"],"members":{"QueueUrl":{},"ReceiptHandle":{}}}},"DeleteMessageBatch":{"input":{"type":"structure","required":["QueueUrl","Entries"],"members":{"QueueUrl":{},"Entries":{"type":"list","member":{"locationName":"DeleteMessageBatchRequestEntry","type":"structure","required":["Id","ReceiptHandle"],"members":{"Id":{},"ReceiptHandle":{}}},"flattened":true}}},"output":{"resultWrapper":"DeleteMessageBatchResult","type":"structure","required":["Successful","Failed"],"members":{"Successful":{"type":"list","member":{"locationName":"DeleteMessageBatchResultEntry","type":"structure","required":["Id"],"members":{"Id":{}}},"flattened":true},"Failed":{"shape":"Sd"}}}},"DeleteQueue":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}}},"GetQueueAttributes":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{},"AttributeNames":{"shape":"St"}}},"output":{"resultWrapper":"GetQueueAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sh","locationName":"Attribute"}}}},"GetQueueUrl":{"input":{"type":"structure","required":["QueueName"],"members":{"QueueName":{},"QueueOwnerAWSAccountId":{}}},"output":{"resultWrapper":"GetQueueUrlResult","type":"structure","members":{"QueueUrl":{}}}},"ListDeadLetterSourceQueues":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}},"output":{"resultWrapper":"ListDeadLetterSourceQueuesResult","type":"structure","required":["queueUrls"],"members":{"queueUrls":{"shape":"Sz"}}}},"ListQueueTags":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}},"output":{"resultWrapper":"ListQueueTagsResult","type":"structure","members":{"Tags":{"shape":"S12","locationName":"Tag"}}}},"ListQueues":{"input":{"type":"structure","members":{"QueueNamePrefix":{}}},"output":{"resultWrapper":"ListQueuesResult","type":"structure","members":{"QueueUrls":{"shape":"Sz"}}}},"PurgeQueue":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}}},"ReceiveMessage":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{},"AttributeNames":{"shape":"St"},"MessageAttributeNames":{"type":"list","member":{"locationName":"MessageAttributeName"},"flattened":true},"MaxNumberOfMessages":{"type":"integer"},"VisibilityTimeout":{"type":"integer"},"WaitTimeSeconds":{"type":"integer"},"ReceiveRequestAttemptId":{}}},"output":{"resultWrapper":"ReceiveMessageResult","type":"structure","members":{"Messages":{"type":"list","member":{"locationName":"Message","type":"structure","members":{"MessageId":{},"ReceiptHandle":{},"MD5OfBody":{},"Body":{},"Attributes":{"locationName":"Attribute","type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value"},"flattened":true},"MD5OfMessageAttributes":{},"MessageAttributes":{"shape":"S1g","locationName":"MessageAttribute"}}},"flattened":true}}}},"RemovePermission":{"input":{"type":"structure","required":["QueueUrl","Label"],"members":{"QueueUrl":{},"Label":{}}}},"SendMessage":{"input":{"type":"structure","required":["QueueUrl","MessageBody"],"members":{"QueueUrl":{},"MessageBody":{},"DelaySeconds":{"type":"integer"},"MessageAttributes":{"shape":"S1g","locationName":"MessageAttribute"},"MessageDeduplicationId":{},"MessageGroupId":{}}},"output":{"resultWrapper":"SendMessageResult","type":"structure","members":{"MD5OfMessageBody":{},"MD5OfMessageAttributes":{},"MessageId":{},"SequenceNumber":{}}}},"SendMessageBatch":{"input":{"type":"structure","required":["QueueUrl","Entries"],"members":{"QueueUrl":{},"Entries":{"type":"list","member":{"locationName":"SendMessageBatchRequestEntry","type":"structure","required":["Id","MessageBody"],"members":{"Id":{},"MessageBody":{},"DelaySeconds":{"type":"integer"},"MessageAttributes":{"shape":"S1g","locationName":"MessageAttribute"},"MessageDeduplicationId":{},"MessageGroupId":{}}},"flattened":true}}},"output":{"resultWrapper":"SendMessageBatchResult","type":"structure","required":["Successful","Failed"],"members":{"Successful":{"type":"list","member":{"locationName":"SendMessageBatchResultEntry","type":"structure","required":["Id","MessageId","MD5OfMessageBody"],"members":{"Id":{},"MessageId":{},"MD5OfMessageBody":{},"MD5OfMessageAttributes":{},"SequenceNumber":{}}},"flattened":true},"Failed":{"shape":"Sd"}}}},"SetQueueAttributes":{"input":{"type":"structure","required":["QueueUrl","Attributes"],"members":{"QueueUrl":{},"Attributes":{"shape":"Sh","locationName":"Attribute"}}}},"TagQueue":{"input":{"type":"structure","required":["QueueUrl","Tags"],"members":{"QueueUrl":{},"Tags":{"shape":"S12"}}}},"UntagQueue":{"input":{"type":"structure","required":["QueueUrl","TagKeys"],"members":{"QueueUrl":{},"TagKeys":{"type":"list","member":{"locationName":"TagKey"},"flattened":true}}}}},"shapes":{"Sd":{"type":"list","member":{"locationName":"BatchResultErrorEntry","type":"structure","required":["Id","SenderFault","Code"],"members":{"Id":{},"SenderFault":{"type":"boolean"},"Code":{},"Message":{}}},"flattened":true},"Sh":{"type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value"},"flattened":true,"locationName":"Attribute"},"St":{"type":"list","member":{"locationName":"AttributeName"},"flattened":true},"Sz":{"type":"list","member":{"locationName":"QueueUrl"},"flattened":true},"S12":{"type":"map","key":{"locationName":"Key"},"value":{"locationName":"Value"},"flattened":true,"locationName":"Tag"},"S1g":{"type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value","type":"structure","required":["DataType"],"members":{"StringValue":{},"BinaryValue":{"type":"blob"},"StringListValues":{"flattened":true,"locationName":"StringListValue","type":"list","member":{"locationName":"StringListValue"}},"BinaryListValues":{"flattened":true,"locationName":"BinaryListValue","type":"list","member":{"locationName":"BinaryListValue","type":"blob"}},"DataType":{}}},"flattened":true}}}

/***/ }),
/* 2951 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListQueues":{"result_key":"QueueUrls"}}}

/***/ }),
/* 2952 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['ssm'] = {};
AWS.SSM = Service.defineService('ssm', ['2014-11-06']);
Object.defineProperty(apiLoader.services['ssm'], '2014-11-06', {
  get: function get() {
    var model = __webpack_require__(2953);
    model.paginators = __webpack_require__(2954).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.SSM;


/***/ }),
/* 2953 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-06","endpointPrefix":"ssm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon SSM","serviceFullName":"Amazon Simple Systems Manager (SSM)","serviceId":"SSM","signatureVersion":"v4","targetPrefix":"AmazonSSM","uid":"ssm-2014-11-06"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceType","ResourceId","Tags"],"members":{"ResourceType":{},"ResourceId":{},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{}}},"CancelCommand":{"input":{"type":"structure","required":["CommandId"],"members":{"CommandId":{},"InstanceIds":{"shape":"Sb"}}},"output":{"type":"structure","members":{}}},"CreateActivation":{"input":{"type":"structure","required":["IamRole"],"members":{"Description":{},"DefaultInstanceName":{},"IamRole":{},"RegistrationLimit":{"type":"integer"},"ExpirationDate":{"type":"timestamp"}}},"output":{"type":"structure","members":{"ActivationId":{},"ActivationCode":{}}}},"CreateAssociation":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DocumentVersion":{},"InstanceId":{},"Parameters":{"shape":"Sq"},"Targets":{"shape":"Su"},"ScheduleExpression":{},"OutputLocation":{"shape":"S10"},"AssociationName":{}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S17"}}}},"CreateAssociationBatch":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"shape":"S1l"}}}},"output":{"type":"structure","members":{"Successful":{"type":"list","member":{"shape":"S17"}},"Failed":{"type":"list","member":{"type":"structure","members":{"Entry":{"shape":"S1l"},"Message":{},"Fault":{}}}}}}},"CreateDocument":{"input":{"type":"structure","required":["Content","Name"],"members":{"Content":{},"Name":{},"DocumentType":{},"DocumentFormat":{},"TargetType":{}}},"output":{"type":"structure","members":{"DocumentDescription":{"shape":"S1y"}}}},"CreateMaintenanceWindow":{"input":{"type":"structure","required":["Name","Schedule","Duration","Cutoff","AllowUnassociatedTargets"],"members":{"Name":{},"Description":{"shape":"S2h"},"Schedule":{},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"WindowId":{}}}},"CreatePatchBaseline":{"input":{"type":"structure","required":["Name"],"members":{"OperatingSystem":{},"Name":{},"GlobalFilters":{"shape":"S2s"},"ApprovalRules":{"shape":"S2y"},"ApprovedPatches":{"shape":"S34"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S34"},"Description":{},"Sources":{"shape":"S37"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"BaselineId":{}}}},"CreateResourceDataSync":{"input":{"type":"structure","required":["SyncName","S3Destination"],"members":{"SyncName":{},"S3Destination":{"shape":"S3h"}}},"output":{"type":"structure","members":{}}},"DeleteActivation":{"input":{"type":"structure","required":["ActivationId"],"members":{"ActivationId":{}}},"output":{"type":"structure","members":{}}},"DeleteAssociation":{"input":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationId":{}}},"output":{"type":"structure","members":{}}},"DeleteDocument":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteMaintenanceWindow":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{}}},"output":{"type":"structure","members":{"WindowId":{}}}},"DeleteParameter":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteParameters":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S40"}}},"output":{"type":"structure","members":{"DeletedParameters":{"shape":"S40"},"InvalidParameters":{"shape":"S40"}}}},"DeletePatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{}}},"output":{"type":"structure","members":{"BaselineId":{}}}},"DeleteResourceDataSync":{"input":{"type":"structure","required":["SyncName"],"members":{"SyncName":{}}},"output":{"type":"structure","members":{}}},"DeregisterManagedInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}},"output":{"type":"structure","members":{}}},"DeregisterPatchBaselineForPatchGroup":{"input":{"type":"structure","required":["BaselineId","PatchGroup"],"members":{"BaselineId":{},"PatchGroup":{}}},"output":{"type":"structure","members":{"BaselineId":{},"PatchGroup":{}}}},"DeregisterTargetFromMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","WindowTargetId"],"members":{"WindowId":{},"WindowTargetId":{},"Safe":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTargetId":{}}}},"DeregisterTaskFromMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","WindowTaskId"],"members":{"WindowId":{},"WindowTaskId":{}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{}}}},"DescribeActivations":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"FilterKey":{},"FilterValues":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ActivationList":{"type":"list","member":{"type":"structure","members":{"ActivationId":{},"Description":{},"DefaultInstanceName":{},"IamRole":{},"RegistrationLimit":{"type":"integer"},"RegistrationsCount":{"type":"integer"},"ExpirationDate":{"type":"timestamp"},"Expired":{"type":"boolean"},"CreatedDate":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeAssociation":{"input":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationId":{},"AssociationVersion":{}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S17"}}}},"DescribeAutomationExecutions":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AutomationExecutionMetadataList":{"type":"list","member":{"type":"structure","members":{"AutomationExecutionId":{},"DocumentName":{},"DocumentVersion":{},"AutomationExecutionStatus":{},"ExecutionStartTime":{"type":"timestamp"},"ExecutionEndTime":{"type":"timestamp"},"ExecutedBy":{},"LogFile":{},"Outputs":{"shape":"S58"},"Mode":{},"ParentAutomationExecutionId":{},"CurrentStepName":{},"CurrentAction":{},"FailureMessage":{},"TargetParameterName":{},"Targets":{"shape":"Su"},"ResolvedTargets":{"shape":"S5d"},"MaxConcurrency":{},"MaxErrors":{},"Target":{}}}},"NextToken":{}}}},"DescribeAutomationStepExecutions":{"input":{"type":"structure","required":["AutomationExecutionId"],"members":{"AutomationExecutionId":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"NextToken":{},"MaxResults":{"type":"integer"},"ReverseOrder":{"type":"boolean"}}},"output":{"type":"structure","members":{"StepExecutions":{"shape":"S5o"},"NextToken":{}}}},"DescribeAvailablePatches":{"input":{"type":"structure","members":{"Filters":{"shape":"S5w"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Patches":{"type":"list","member":{"shape":"S64"}},"NextToken":{}}}},"DescribeDocument":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DocumentVersion":{}}},"output":{"type":"structure","members":{"Document":{"shape":"S1y"}}}},"DescribeDocumentPermission":{"input":{"type":"structure","required":["Name","PermissionType"],"members":{"Name":{},"PermissionType":{}}},"output":{"type":"structure","members":{"AccountIds":{"shape":"S6l"}}}},"DescribeEffectiveInstanceAssociations":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Associations":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"InstanceId":{},"Content":{},"AssociationVersion":{}}}},"NextToken":{}}}},"DescribeEffectivePatchesForPatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EffectivePatches":{"type":"list","member":{"type":"structure","members":{"Patch":{"shape":"S64"},"PatchStatus":{"type":"structure","members":{"DeploymentStatus":{},"ComplianceLevel":{},"ApprovalDate":{"type":"timestamp"}}}}}},"NextToken":{}}}},"DescribeInstanceAssociationsStatus":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceAssociationStatusInfos":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"Name":{},"DocumentVersion":{},"AssociationVersion":{},"InstanceId":{},"ExecutionDate":{"type":"timestamp"},"Status":{},"DetailedStatus":{},"ExecutionSummary":{},"ErrorCode":{},"OutputUrl":{"type":"structure","members":{"S3OutputUrl":{"type":"structure","members":{"OutputUrl":{}}}}},"AssociationName":{}}}},"NextToken":{}}}},"DescribeInstanceInformation":{"input":{"type":"structure","members":{"InstanceInformationFilterList":{"type":"list","member":{"type":"structure","required":["key","valueSet"],"members":{"key":{},"valueSet":{"shape":"S7b"}}}},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"shape":"S7b"}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceInformationList":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"PingStatus":{},"LastPingDateTime":{"type":"timestamp"},"AgentVersion":{},"IsLatestVersion":{"type":"boolean"},"PlatformType":{},"PlatformName":{},"PlatformVersion":{},"ActivationId":{},"IamRole":{},"RegistrationDate":{"type":"timestamp"},"ResourceType":{},"Name":{},"IPAddress":{},"ComputerName":{},"AssociationStatus":{},"LastAssociationExecutionDate":{"type":"timestamp"},"LastSuccessfulAssociationExecutionDate":{"type":"timestamp"},"AssociationOverview":{"type":"structure","members":{"DetailedStatus":{},"InstanceAssociationStatusAggregatedCount":{"type":"map","key":{},"value":{"type":"integer"}}}}}}},"NextToken":{}}}},"DescribeInstancePatchStates":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Sb"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InstancePatchStates":{"type":"list","member":{"shape":"S7v"}},"NextToken":{}}}},"DescribeInstancePatchStatesForPatchGroup":{"input":{"type":"structure","required":["PatchGroup"],"members":{"PatchGroup":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values","Type"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InstancePatchStates":{"type":"list","member":{"shape":"S7v"}},"NextToken":{}}}},"DescribeInstancePatches":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"Filters":{"shape":"S5w"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Patches":{"type":"list","member":{"type":"structure","required":["Title","KBId","Classification","Severity","State","InstalledTime"],"members":{"Title":{},"KBId":{},"Classification":{},"Severity":{},"State":{},"InstalledTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowExecutionTaskInvocations":{"input":{"type":"structure","required":["WindowExecutionId","TaskId"],"members":{"WindowExecutionId":{},"TaskId":{},"Filters":{"shape":"S8m"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowExecutionTaskInvocationIdentities":{"type":"list","member":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"InvocationId":{},"ExecutionId":{},"TaskType":{},"Parameters":{"shape":"S8y"},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"OwnerInformation":{"shape":"S7x"},"WindowTargetId":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowExecutionTasks":{"input":{"type":"structure","required":["WindowExecutionId"],"members":{"WindowExecutionId":{},"Filters":{"shape":"S8m"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowExecutionTaskIdentities":{"type":"list","member":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TaskArn":{},"TaskType":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowExecutions":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Filters":{"shape":"S8m"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowExecutions":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"WindowExecutionId":{},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowTargets":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Filters":{"shape":"S8m"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Targets":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"WindowTargetId":{},"ResourceType":{},"Targets":{"shape":"Su"},"OwnerInformation":{"shape":"S7x"},"Name":{},"Description":{"shape":"S2h"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowTasks":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Filters":{"shape":"S8m"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tasks":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{},"TaskArn":{},"Type":{},"Targets":{"shape":"Su"},"TaskParameters":{"shape":"S9k"},"Priority":{"type":"integer"},"LoggingInfo":{"shape":"S9q"},"ServiceRoleArn":{},"MaxConcurrency":{},"MaxErrors":{},"Name":{},"Description":{"shape":"S2h"}}}},"NextToken":{}}}},"DescribeMaintenanceWindows":{"input":{"type":"structure","members":{"Filters":{"shape":"S8m"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowIdentities":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"Name":{},"Description":{"shape":"S2h"},"Enabled":{"type":"boolean"},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"}}}},"NextToken":{}}}},"DescribeParameters":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"ParameterFilters":{"shape":"Sa3"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"KeyId":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedUser":{},"Description":{},"AllowedPattern":{},"Version":{"type":"long"}}}},"NextToken":{}}}},"DescribePatchBaselines":{"input":{"type":"structure","members":{"Filters":{"shape":"S5w"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"BaselineIdentities":{"type":"list","member":{"shape":"Sak"}},"NextToken":{}}}},"DescribePatchGroupState":{"input":{"type":"structure","required":["PatchGroup"],"members":{"PatchGroup":{}}},"output":{"type":"structure","members":{"Instances":{"type":"integer"},"InstancesWithInstalledPatches":{"type":"integer"},"InstancesWithInstalledOtherPatches":{"type":"integer"},"InstancesWithMissingPatches":{"type":"integer"},"InstancesWithFailedPatches":{"type":"integer"},"InstancesWithNotApplicablePatches":{"type":"integer"}}}},"DescribePatchGroups":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"Filters":{"shape":"S5w"},"NextToken":{}}},"output":{"type":"structure","members":{"Mappings":{"type":"list","member":{"type":"structure","members":{"PatchGroup":{},"BaselineIdentity":{"shape":"Sak"}}}},"NextToken":{}}}},"GetAutomationExecution":{"input":{"type":"structure","required":["AutomationExecutionId"],"members":{"AutomationExecutionId":{}}},"output":{"type":"structure","members":{"AutomationExecution":{"type":"structure","members":{"AutomationExecutionId":{},"DocumentName":{},"DocumentVersion":{},"ExecutionStartTime":{"type":"timestamp"},"ExecutionEndTime":{"type":"timestamp"},"AutomationExecutionStatus":{},"StepExecutions":{"shape":"S5o"},"StepExecutionsTruncated":{"type":"boolean"},"Parameters":{"shape":"S58"},"Outputs":{"shape":"S58"},"FailureMessage":{},"Mode":{},"ParentAutomationExecutionId":{},"ExecutedBy":{},"CurrentStepName":{},"CurrentAction":{},"TargetParameterName":{},"Targets":{"shape":"Su"},"ResolvedTargets":{"shape":"S5d"},"MaxConcurrency":{},"MaxErrors":{},"Target":{}}}}}},"GetCommandInvocation":{"input":{"type":"structure","required":["CommandId","InstanceId"],"members":{"CommandId":{},"InstanceId":{},"PluginName":{}}},"output":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"Comment":{},"DocumentName":{},"PluginName":{},"ResponseCode":{"type":"integer"},"ExecutionStartDateTime":{},"ExecutionElapsedTime":{},"ExecutionEndDateTime":{},"Status":{},"StatusDetails":{},"StandardOutputContent":{},"StandardOutputUrl":{},"StandardErrorContent":{},"StandardErrorUrl":{}}}},"GetDefaultPatchBaseline":{"input":{"type":"structure","members":{"OperatingSystem":{}}},"output":{"type":"structure","members":{"BaselineId":{},"OperatingSystem":{}}}},"GetDeployablePatchSnapshotForInstance":{"input":{"type":"structure","required":["InstanceId","SnapshotId"],"members":{"InstanceId":{},"SnapshotId":{}}},"output":{"type":"structure","members":{"InstanceId":{},"SnapshotId":{},"SnapshotDownloadUrl":{},"Product":{}}}},"GetDocument":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DocumentVersion":{},"DocumentFormat":{}}},"output":{"type":"structure","members":{"Name":{},"DocumentVersion":{},"Content":{},"DocumentType":{},"DocumentFormat":{}}}},"GetInventory":{"input":{"type":"structure","members":{"Filters":{"shape":"Sbe"},"Aggregators":{"shape":"Sbk"},"ResultAttributes":{"type":"list","member":{"type":"structure","required":["TypeName"],"members":{"TypeName":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Id":{},"Data":{"type":"map","key":{},"value":{"type":"structure","required":["TypeName","SchemaVersion","Content"],"members":{"TypeName":{},"SchemaVersion":{},"CaptureTime":{},"ContentHash":{},"Content":{"shape":"Sc0"}}}}}}},"NextToken":{}}}},"GetInventorySchema":{"input":{"type":"structure","members":{"TypeName":{},"NextToken":{},"MaxResults":{"type":"integer"},"Aggregator":{"type":"boolean"},"SubType":{"type":"boolean"}}},"output":{"type":"structure","members":{"Schemas":{"type":"list","member":{"type":"structure","required":["TypeName","Attributes"],"members":{"TypeName":{},"Version":{},"Attributes":{"type":"list","member":{"type":"structure","required":["Name","DataType"],"members":{"Name":{},"DataType":{}}}},"DisplayName":{}}}},"NextToken":{}}}},"GetMaintenanceWindow":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{}}},"output":{"type":"structure","members":{"WindowId":{},"Name":{},"Description":{"shape":"S2h"},"Schedule":{},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"Enabled":{"type":"boolean"},"CreatedDate":{"type":"timestamp"},"ModifiedDate":{"type":"timestamp"}}}},"GetMaintenanceWindowExecution":{"input":{"type":"structure","required":["WindowExecutionId"],"members":{"WindowExecutionId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{},"TaskIds":{"type":"list","member":{}},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"GetMaintenanceWindowExecutionTask":{"input":{"type":"structure","required":["WindowExecutionId","TaskId"],"members":{"WindowExecutionId":{},"TaskId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"TaskArn":{},"ServiceRole":{},"Type":{},"TaskParameters":{"type":"list","member":{"shape":"S9k"},"sensitive":true},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"GetMaintenanceWindowExecutionTaskInvocation":{"input":{"type":"structure","required":["WindowExecutionId","TaskId","InvocationId"],"members":{"WindowExecutionId":{},"TaskId":{},"InvocationId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"InvocationId":{},"ExecutionId":{},"TaskType":{},"Parameters":{"shape":"S8y"},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"OwnerInformation":{"shape":"S7x"},"WindowTargetId":{}}}},"GetMaintenanceWindowTask":{"input":{"type":"structure","required":["WindowId","WindowTaskId"],"members":{"WindowId":{},"WindowTaskId":{}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{},"Targets":{"shape":"Su"},"TaskArn":{},"ServiceRoleArn":{},"TaskType":{},"TaskParameters":{"shape":"S9k"},"TaskInvocationParameters":{"shape":"Sct"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"S9q"},"Name":{},"Description":{"shape":"S2h"}}}},"GetParameter":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"WithDecryption":{"type":"boolean"}}},"output":{"type":"structure","members":{"Parameter":{"shape":"Sdb"}}}},"GetParameterHistory":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"WithDecryption":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"KeyId":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedUser":{},"Description":{},"Value":{},"AllowedPattern":{},"Version":{"type":"long"}}}},"NextToken":{}}}},"GetParameters":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S40"},"WithDecryption":{"type":"boolean"}}},"output":{"type":"structure","members":{"Parameters":{"shape":"Sdj"},"InvalidParameters":{"shape":"S40"}}}},"GetParametersByPath":{"input":{"type":"structure","required":["Path"],"members":{"Path":{},"Recursive":{"type":"boolean"},"ParameterFilters":{"shape":"Sa3"},"WithDecryption":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Parameters":{"shape":"Sdj"},"NextToken":{}}}},"GetPatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{}}},"output":{"type":"structure","members":{"BaselineId":{},"Name":{},"OperatingSystem":{},"GlobalFilters":{"shape":"S2s"},"ApprovalRules":{"shape":"S2y"},"ApprovedPatches":{"shape":"S34"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S34"},"PatchGroups":{"type":"list","member":{}},"CreatedDate":{"type":"timestamp"},"ModifiedDate":{"type":"timestamp"},"Description":{},"Sources":{"shape":"S37"}}}},"GetPatchBaselineForPatchGroup":{"input":{"type":"structure","required":["PatchGroup"],"members":{"PatchGroup":{},"OperatingSystem":{}}},"output":{"type":"structure","members":{"BaselineId":{},"PatchGroup":{},"OperatingSystem":{}}}},"ListAssociationVersions":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AssociationVersions":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"AssociationVersion":{},"CreatedDate":{"type":"timestamp"},"Name":{},"DocumentVersion":{},"Parameters":{"shape":"Sq"},"Targets":{"shape":"Su"},"ScheduleExpression":{},"OutputLocation":{"shape":"S10"},"AssociationName":{}}}},"NextToken":{}}}},"ListAssociations":{"input":{"type":"structure","members":{"AssociationFilterList":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Associations":{"type":"list","member":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationId":{},"AssociationVersion":{},"DocumentVersion":{},"Targets":{"shape":"Su"},"LastExecutionDate":{"type":"timestamp"},"Overview":{"shape":"S1e"},"ScheduleExpression":{},"AssociationName":{}}}},"NextToken":{}}}},"ListCommandInvocations":{"input":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Se6"},"Details":{"type":"boolean"}}},"output":{"type":"structure","members":{"CommandInvocations":{"type":"list","member":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"InstanceName":{},"Comment":{},"DocumentName":{},"RequestedDateTime":{"type":"timestamp"},"Status":{},"StatusDetails":{},"TraceOutput":{},"StandardOutputUrl":{},"StandardErrorUrl":{},"CommandPlugins":{"type":"list","member":{"type":"structure","members":{"Name":{},"Status":{},"StatusDetails":{},"ResponseCode":{"type":"integer"},"ResponseStartDateTime":{"type":"timestamp"},"ResponseFinishDateTime":{"type":"timestamp"},"Output":{},"StandardOutputUrl":{},"StandardErrorUrl":{},"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{}}}},"ServiceRole":{},"NotificationConfig":{"shape":"Scv"}}}},"NextToken":{}}}},"ListCommands":{"input":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Se6"}}},"output":{"type":"structure","members":{"Commands":{"type":"list","member":{"shape":"Sem"}},"NextToken":{}}}},"ListComplianceItems":{"input":{"type":"structure","members":{"Filters":{"shape":"Ses"},"ResourceIds":{"type":"list","member":{}},"ResourceTypes":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComplianceItems":{"type":"list","member":{"type":"structure","members":{"ComplianceType":{},"ResourceType":{},"ResourceId":{},"Id":{},"Title":{},"Status":{},"Severity":{},"ExecutionSummary":{"shape":"Sfa"},"Details":{"shape":"Sfd"}}}},"NextToken":{}}}},"ListComplianceSummaries":{"input":{"type":"structure","members":{"Filters":{"shape":"Ses"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComplianceSummaryItems":{"type":"list","member":{"type":"structure","members":{"ComplianceType":{},"CompliantSummary":{"shape":"Sfi"},"NonCompliantSummary":{"shape":"Sfl"}}}},"NextToken":{}}}},"ListDocumentVersions":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DocumentVersions":{"type":"list","member":{"type":"structure","members":{"Name":{},"DocumentVersion":{},"CreatedDate":{"type":"timestamp"},"IsDefaultVersion":{"type":"boolean"},"DocumentFormat":{}}}},"NextToken":{}}}},"ListDocuments":{"input":{"type":"structure","members":{"DocumentFilterList":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Filters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DocumentIdentifiers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Owner":{},"PlatformTypes":{"shape":"S2c"},"DocumentVersion":{},"DocumentType":{},"SchemaVersion":{},"DocumentFormat":{},"TargetType":{},"Tags":{"shape":"S4"}}}},"NextToken":{}}}},"ListInventoryEntries":{"input":{"type":"structure","required":["InstanceId","TypeName"],"members":{"InstanceId":{},"TypeName":{},"Filters":{"shape":"Sbe"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TypeName":{},"InstanceId":{},"SchemaVersion":{},"CaptureTime":{},"Entries":{"shape":"Sc0"},"NextToken":{}}}},"ListResourceComplianceSummaries":{"input":{"type":"structure","members":{"Filters":{"shape":"Ses"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceComplianceSummaryItems":{"type":"list","member":{"type":"structure","members":{"ComplianceType":{},"ResourceType":{},"ResourceId":{},"Status":{},"OverallSeverity":{},"ExecutionSummary":{"shape":"Sfa"},"CompliantSummary":{"shape":"Sfi"},"NonCompliantSummary":{"shape":"Sfl"}}}},"NextToken":{}}}},"ListResourceDataSync":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceDataSyncItems":{"type":"list","member":{"type":"structure","members":{"SyncName":{},"S3Destination":{"shape":"S3h"},"LastSyncTime":{"type":"timestamp"},"LastSuccessfulSyncTime":{"type":"timestamp"},"LastStatus":{},"SyncCreatedTime":{"type":"timestamp"},"LastSyncStatusMessage":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{},"ResourceId":{}}},"output":{"type":"structure","members":{"TagList":{"shape":"S4"}}}},"ModifyDocumentPermission":{"input":{"type":"structure","required":["Name","PermissionType"],"members":{"Name":{},"PermissionType":{},"AccountIdsToAdd":{"shape":"S6l"},"AccountIdsToRemove":{"shape":"S6l"}}},"output":{"type":"structure","members":{}}},"PutComplianceItems":{"input":{"type":"structure","required":["ResourceId","ResourceType","ComplianceType","ExecutionSummary","Items"],"members":{"ResourceId":{},"ResourceType":{},"ComplianceType":{},"ExecutionSummary":{"shape":"Sfa"},"Items":{"type":"list","member":{"type":"structure","required":["Severity","Status"],"members":{"Id":{},"Title":{},"Severity":{},"Status":{},"Details":{"shape":"Sfd"}}}},"ItemContentHash":{}}},"output":{"type":"structure","members":{}}},"PutInventory":{"input":{"type":"structure","required":["InstanceId","Items"],"members":{"InstanceId":{},"Items":{"type":"list","member":{"type":"structure","required":["TypeName","SchemaVersion","CaptureTime"],"members":{"TypeName":{},"SchemaVersion":{},"CaptureTime":{},"ContentHash":{},"Content":{"shape":"Sc0"},"Context":{"type":"map","key":{},"value":{}}}}}}},"output":{"type":"structure","members":{}}},"PutParameter":{"input":{"type":"structure","required":["Name","Value","Type"],"members":{"Name":{},"Description":{},"Value":{},"Type":{},"KeyId":{},"Overwrite":{"type":"boolean"},"AllowedPattern":{}}},"output":{"type":"structure","members":{"Version":{"type":"long"}}}},"RegisterDefaultPatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{}}},"output":{"type":"structure","members":{"BaselineId":{}}}},"RegisterPatchBaselineForPatchGroup":{"input":{"type":"structure","required":["BaselineId","PatchGroup"],"members":{"BaselineId":{},"PatchGroup":{}}},"output":{"type":"structure","members":{"BaselineId":{},"PatchGroup":{}}}},"RegisterTargetWithMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","ResourceType","Targets"],"members":{"WindowId":{},"ResourceType":{},"Targets":{"shape":"Su"},"OwnerInformation":{"shape":"S7x"},"Name":{},"Description":{"shape":"S2h"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"WindowTargetId":{}}}},"RegisterTaskWithMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","Targets","TaskArn","ServiceRoleArn","TaskType","MaxConcurrency","MaxErrors"],"members":{"WindowId":{},"Targets":{"shape":"Su"},"TaskArn":{},"ServiceRoleArn":{},"TaskType":{},"TaskParameters":{"shape":"S9k"},"TaskInvocationParameters":{"shape":"Sct"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"S9q"},"Name":{},"Description":{"shape":"S2h"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"WindowTaskId":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceType","ResourceId","TagKeys"],"members":{"ResourceType":{},"ResourceId":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"SendAutomationSignal":{"input":{"type":"structure","required":["AutomationExecutionId","SignalType"],"members":{"AutomationExecutionId":{},"SignalType":{},"Payload":{"shape":"S58"}}},"output":{"type":"structure","members":{}}},"SendCommand":{"input":{"type":"structure","required":["DocumentName"],"members":{"InstanceIds":{"shape":"Sb"},"Targets":{"shape":"Su"},"DocumentName":{},"DocumentHash":{},"DocumentHashType":{},"TimeoutSeconds":{"type":"integer"},"Comment":{},"Parameters":{"shape":"Sq"},"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"MaxConcurrency":{},"MaxErrors":{},"ServiceRoleArn":{},"NotificationConfig":{"shape":"Scv"}}},"output":{"type":"structure","members":{"Command":{"shape":"Sem"}}}},"StartAutomationExecution":{"input":{"type":"structure","required":["DocumentName"],"members":{"DocumentName":{},"DocumentVersion":{},"Parameters":{"shape":"S58"},"ClientToken":{},"Mode":{},"TargetParameterName":{},"Targets":{"shape":"Su"},"MaxConcurrency":{},"MaxErrors":{}}},"output":{"type":"structure","members":{"AutomationExecutionId":{}}}},"StopAutomationExecution":{"input":{"type":"structure","required":["AutomationExecutionId"],"members":{"AutomationExecutionId":{},"Type":{}}},"output":{"type":"structure","members":{}}},"UpdateAssociation":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"Parameters":{"shape":"Sq"},"DocumentVersion":{},"ScheduleExpression":{},"OutputLocation":{"shape":"S10"},"Name":{},"Targets":{"shape":"Su"},"AssociationName":{},"AssociationVersion":{}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S17"}}}},"UpdateAssociationStatus":{"input":{"type":"structure","required":["Name","InstanceId","AssociationStatus"],"members":{"Name":{},"InstanceId":{},"AssociationStatus":{"shape":"S1a"}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S17"}}}},"UpdateDocument":{"input":{"type":"structure","required":["Content","Name"],"members":{"Content":{},"Name":{},"DocumentVersion":{},"DocumentFormat":{},"TargetType":{}}},"output":{"type":"structure","members":{"DocumentDescription":{"shape":"S1y"}}}},"UpdateDocumentDefaultVersion":{"input":{"type":"structure","required":["Name","DocumentVersion"],"members":{"Name":{},"DocumentVersion":{}}},"output":{"type":"structure","members":{"Description":{"type":"structure","members":{"Name":{},"DefaultVersion":{}}}}}},"UpdateMaintenanceWindow":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Name":{},"Description":{"shape":"S2h"},"Schedule":{},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"Enabled":{"type":"boolean"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"Name":{},"Description":{"shape":"S2h"},"Schedule":{},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"Enabled":{"type":"boolean"}}}},"UpdateMaintenanceWindowTarget":{"input":{"type":"structure","required":["WindowId","WindowTargetId"],"members":{"WindowId":{},"WindowTargetId":{},"Targets":{"shape":"Su"},"OwnerInformation":{"shape":"S7x"},"Name":{},"Description":{"shape":"S2h"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTargetId":{},"Targets":{"shape":"Su"},"OwnerInformation":{"shape":"S7x"},"Name":{},"Description":{"shape":"S2h"}}}},"UpdateMaintenanceWindowTask":{"input":{"type":"structure","required":["WindowId","WindowTaskId"],"members":{"WindowId":{},"WindowTaskId":{},"Targets":{"shape":"Su"},"TaskArn":{},"ServiceRoleArn":{},"TaskParameters":{"shape":"S9k"},"TaskInvocationParameters":{"shape":"Sct"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"S9q"},"Name":{},"Description":{"shape":"S2h"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{},"Targets":{"shape":"Su"},"TaskArn":{},"ServiceRoleArn":{},"TaskParameters":{"shape":"S9k"},"TaskInvocationParameters":{"shape":"Sct"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"S9q"},"Name":{},"Description":{"shape":"S2h"}}}},"UpdateManagedInstanceRole":{"input":{"type":"structure","required":["InstanceId","IamRole"],"members":{"InstanceId":{},"IamRole":{}}},"output":{"type":"structure","members":{}}},"UpdatePatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{},"Name":{},"GlobalFilters":{"shape":"S2s"},"ApprovalRules":{"shape":"S2y"},"ApprovedPatches":{"shape":"S34"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S34"},"Description":{},"Sources":{"shape":"S37"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"BaselineId":{},"Name":{},"OperatingSystem":{},"GlobalFilters":{"shape":"S2s"},"ApprovalRules":{"shape":"S2y"},"ApprovedPatches":{"shape":"S34"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S34"},"CreatedDate":{"type":"timestamp"},"ModifiedDate":{"type":"timestamp"},"Description":{},"Sources":{"shape":"S37"}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sb":{"type":"list","member":{}},"Sq":{"type":"map","key":{},"value":{"type":"list","member":{}}},"Su":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"S10":{"type":"structure","members":{"S3Location":{"type":"structure","members":{"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{}}}}},"S17":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationVersion":{},"Date":{"type":"timestamp"},"LastUpdateAssociationDate":{"type":"timestamp"},"Status":{"shape":"S1a"},"Overview":{"shape":"S1e"},"DocumentVersion":{},"Parameters":{"shape":"Sq"},"AssociationId":{},"Targets":{"shape":"Su"},"ScheduleExpression":{},"OutputLocation":{"shape":"S10"},"LastExecutionDate":{"type":"timestamp"},"LastSuccessfulExecutionDate":{"type":"timestamp"},"AssociationName":{}}},"S1a":{"type":"structure","required":["Date","Name","Message"],"members":{"Date":{"type":"timestamp"},"Name":{},"Message":{},"AdditionalInfo":{}}},"S1e":{"type":"structure","members":{"Status":{},"DetailedStatus":{},"AssociationStatusAggregatedCount":{"type":"map","key":{},"value":{"type":"integer"}}}},"S1l":{"type":"structure","required":["Name"],"members":{"Name":{},"InstanceId":{},"Parameters":{"shape":"Sq"},"DocumentVersion":{},"Targets":{"shape":"Su"},"ScheduleExpression":{},"OutputLocation":{"shape":"S10"},"AssociationName":{}}},"S1y":{"type":"structure","members":{"Sha1":{},"Hash":{},"HashType":{},"Name":{},"Owner":{},"CreatedDate":{"type":"timestamp"},"Status":{},"DocumentVersion":{},"Description":{},"Parameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"Description":{},"DefaultValue":{}}}},"PlatformTypes":{"shape":"S2c"},"DocumentType":{},"SchemaVersion":{},"LatestVersion":{},"DefaultVersion":{},"DocumentFormat":{},"TargetType":{},"Tags":{"shape":"S4"}}},"S2c":{"type":"list","member":{}},"S2h":{"type":"string","sensitive":true},"S2s":{"type":"structure","required":["PatchFilters"],"members":{"PatchFilters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}}}},"S2y":{"type":"structure","required":["PatchRules"],"members":{"PatchRules":{"type":"list","member":{"type":"structure","required":["PatchFilterGroup","ApproveAfterDays"],"members":{"PatchFilterGroup":{"shape":"S2s"},"ComplianceLevel":{},"ApproveAfterDays":{"type":"integer"},"EnableNonSecurity":{"type":"boolean"}}}}}},"S34":{"type":"list","member":{}},"S37":{"type":"list","member":{"type":"structure","required":["Name","Products","Configuration"],"members":{"Name":{},"Products":{"type":"list","member":{}},"Configuration":{"type":"string","sensitive":true}}}},"S3h":{"type":"structure","required":["BucketName","SyncFormat","Region"],"members":{"BucketName":{},"Prefix":{},"SyncFormat":{},"Region":{},"AWSKMSKeyARN":{}}},"S40":{"type":"list","member":{}},"S58":{"type":"map","key":{},"value":{"type":"list","member":{}}},"S5d":{"type":"structure","members":{"ParameterValues":{"type":"list","member":{}},"Truncated":{"type":"boolean"}}},"S5o":{"type":"list","member":{"type":"structure","members":{"StepName":{},"Action":{},"TimeoutSeconds":{"type":"long"},"OnFailure":{},"MaxAttempts":{"type":"integer"},"ExecutionStartTime":{"type":"timestamp"},"ExecutionEndTime":{"type":"timestamp"},"StepStatus":{},"ResponseCode":{},"Inputs":{"type":"map","key":{},"value":{}},"Outputs":{"shape":"S58"},"Response":{},"FailureMessage":{},"FailureDetails":{"type":"structure","members":{"FailureStage":{},"FailureType":{},"Details":{"shape":"S58"}}},"StepExecutionId":{},"OverriddenParameters":{"shape":"S58"}}}},"S5w":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"S64":{"type":"structure","members":{"Id":{},"ReleaseDate":{"type":"timestamp"},"Title":{},"Description":{},"ContentUrl":{},"Vendor":{},"ProductFamily":{},"Product":{},"Classification":{},"MsrcSeverity":{},"KbNumber":{},"MsrcNumber":{},"Language":{}}},"S6l":{"type":"list","member":{}},"S7b":{"type":"list","member":{}},"S7v":{"type":"structure","required":["InstanceId","PatchGroup","BaselineId","OperationStartTime","OperationEndTime","Operation"],"members":{"InstanceId":{},"PatchGroup":{},"BaselineId":{},"SnapshotId":{},"OwnerInformation":{"shape":"S7x"},"InstalledCount":{"type":"integer"},"InstalledOtherCount":{"type":"integer"},"MissingCount":{"type":"integer"},"FailedCount":{"type":"integer"},"NotApplicableCount":{"type":"integer"},"OperationStartTime":{"type":"timestamp"},"OperationEndTime":{"type":"timestamp"},"Operation":{}}},"S7x":{"type":"string","sensitive":true},"S8m":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"S8y":{"type":"string","sensitive":true},"S9k":{"type":"map","key":{},"value":{"type":"structure","members":{"Values":{"type":"list","member":{"type":"string","sensitive":true},"sensitive":true}},"sensitive":true},"sensitive":true},"S9q":{"type":"structure","required":["S3BucketName","S3Region"],"members":{"S3BucketName":{},"S3KeyPrefix":{},"S3Region":{}}},"Sa3":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Option":{},"Values":{"type":"list","member":{}}}}},"Sak":{"type":"structure","members":{"BaselineId":{},"BaselineName":{},"OperatingSystem":{},"BaselineDescription":{},"DefaultBaseline":{"type":"boolean"}}},"Sbe":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"Sbk":{"type":"list","member":{"type":"structure","members":{"Expression":{},"Aggregators":{"shape":"Sbk"}}}},"Sc0":{"type":"list","member":{"type":"map","key":{},"value":{}}},"Sct":{"type":"structure","members":{"RunCommand":{"type":"structure","members":{"Comment":{},"DocumentHash":{},"DocumentHashType":{},"NotificationConfig":{"shape":"Scv"},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"Parameters":{"shape":"Sq"},"ServiceRoleArn":{},"TimeoutSeconds":{"type":"integer"}}},"Automation":{"type":"structure","members":{"DocumentVersion":{},"Parameters":{"shape":"S58"}}},"StepFunctions":{"type":"structure","members":{"Input":{"type":"string","sensitive":true},"Name":{}}},"Lambda":{"type":"structure","members":{"ClientContext":{},"Qualifier":{},"Payload":{"type":"blob","sensitive":true}}}}},"Scv":{"type":"structure","members":{"NotificationArn":{},"NotificationEvents":{"type":"list","member":{}},"NotificationType":{}}},"Sdb":{"type":"structure","members":{"Name":{},"Type":{},"Value":{},"Version":{"type":"long"}}},"Sdj":{"type":"list","member":{"shape":"Sdb"}},"Se6":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sem":{"type":"structure","members":{"CommandId":{},"DocumentName":{},"Comment":{},"ExpiresAfter":{"type":"timestamp"},"Parameters":{"shape":"Sq"},"InstanceIds":{"shape":"Sb"},"Targets":{"shape":"Su"},"RequestedDateTime":{"type":"timestamp"},"Status":{},"StatusDetails":{},"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"MaxConcurrency":{},"MaxErrors":{},"TargetCount":{"type":"integer"},"CompletedCount":{"type":"integer"},"ErrorCount":{"type":"integer"},"ServiceRole":{},"NotificationConfig":{"shape":"Scv"}}},"Ses":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"Sfa":{"type":"structure","required":["ExecutionTime"],"members":{"ExecutionTime":{"type":"timestamp"},"ExecutionId":{},"ExecutionType":{}}},"Sfd":{"type":"map","key":{},"value":{}},"Sfi":{"type":"structure","members":{"CompliantCount":{"type":"integer"},"SeveritySummary":{"shape":"Sfk"}}},"Sfk":{"type":"structure","members":{"CriticalCount":{"type":"integer"},"HighCount":{"type":"integer"},"MediumCount":{"type":"integer"},"LowCount":{"type":"integer"},"InformationalCount":{"type":"integer"},"UnspecifiedCount":{"type":"integer"}}},"Sfl":{"type":"structure","members":{"NonCompliantCount":{"type":"integer"},"SeveritySummary":{"shape":"Sfk"}}}}}

/***/ }),
/* 2954 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeActivations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ActivationList"},"DescribeInstanceInformation":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceInformationList"},"DescribeParameters":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetParameterHistory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetParametersByPath":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Associations"},"ListCommandInvocations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CommandInvocations"},"ListCommands":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Commands"},"ListDocuments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DocumentIdentifiers"}}}

/***/ }),
/* 2955 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['storagegateway'] = {};
AWS.StorageGateway = Service.defineService('storagegateway', ['2013-06-30']);
Object.defineProperty(apiLoader.services['storagegateway'], '2013-06-30', {
  get: function get() {
    var model = __webpack_require__(2956);
    model.paginators = __webpack_require__(2957).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.StorageGateway;


/***/ }),
/* 2956 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-06-30","endpointPrefix":"storagegateway","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Storage Gateway","serviceId":"Storage Gateway","signatureVersion":"v4","targetPrefix":"StorageGateway_20130630","uid":"storagegateway-2013-06-30"},"operations":{"ActivateGateway":{"input":{"type":"structure","required":["ActivationKey","GatewayName","GatewayTimezone","GatewayRegion"],"members":{"ActivationKey":{},"GatewayName":{},"GatewayTimezone":{},"GatewayRegion":{},"GatewayType":{},"TapeDriveType":{},"MediumChangerType":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AddCache":{"input":{"type":"structure","required":["GatewayARN","DiskIds"],"members":{"GatewayARN":{},"DiskIds":{"shape":"Sc"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"Sh"}}},"output":{"type":"structure","members":{"ResourceARN":{}}}},"AddUploadBuffer":{"input":{"type":"structure","required":["GatewayARN","DiskIds"],"members":{"GatewayARN":{},"DiskIds":{"shape":"Sc"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AddWorkingStorage":{"input":{"type":"structure","required":["GatewayARN","DiskIds"],"members":{"GatewayARN":{},"DiskIds":{"shape":"Sc"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"CancelArchival":{"input":{"type":"structure","required":["GatewayARN","TapeARN"],"members":{"GatewayARN":{},"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"CancelRetrieval":{"input":{"type":"structure","required":["GatewayARN","TapeARN"],"members":{"GatewayARN":{},"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"CreateCachediSCSIVolume":{"input":{"type":"structure","required":["GatewayARN","VolumeSizeInBytes","TargetName","NetworkInterfaceId","ClientToken"],"members":{"GatewayARN":{},"VolumeSizeInBytes":{"type":"long"},"SnapshotId":{},"TargetName":{},"SourceVolumeARN":{},"NetworkInterfaceId":{},"ClientToken":{}}},"output":{"type":"structure","members":{"VolumeARN":{},"TargetARN":{}}}},"CreateNFSFileShare":{"input":{"type":"structure","required":["ClientToken","GatewayARN","Role","LocationARN"],"members":{"ClientToken":{},"NFSFileShareDefaults":{"shape":"S15"},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ObjectACL":{},"ClientList":{"shape":"S1e"},"Squash":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"CreateSnapshot":{"input":{"type":"structure","required":["VolumeARN","SnapshotDescription"],"members":{"VolumeARN":{},"SnapshotDescription":{}}},"output":{"type":"structure","members":{"VolumeARN":{},"SnapshotId":{}}}},"CreateSnapshotFromVolumeRecoveryPoint":{"input":{"type":"structure","required":["VolumeARN","SnapshotDescription"],"members":{"VolumeARN":{},"SnapshotDescription":{}}},"output":{"type":"structure","members":{"SnapshotId":{},"VolumeARN":{},"VolumeRecoveryPointTime":{}}}},"CreateStorediSCSIVolume":{"input":{"type":"structure","required":["GatewayARN","DiskId","PreserveExistingData","TargetName","NetworkInterfaceId"],"members":{"GatewayARN":{},"DiskId":{},"SnapshotId":{},"PreserveExistingData":{"type":"boolean"},"TargetName":{},"NetworkInterfaceId":{}}},"output":{"type":"structure","members":{"VolumeARN":{},"VolumeSizeInBytes":{"type":"long"},"TargetARN":{}}}},"CreateTapeWithBarcode":{"input":{"type":"structure","required":["GatewayARN","TapeSizeInBytes","TapeBarcode"],"members":{"GatewayARN":{},"TapeSizeInBytes":{"type":"long"},"TapeBarcode":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"CreateTapes":{"input":{"type":"structure","required":["GatewayARN","TapeSizeInBytes","ClientToken","NumTapesToCreate","TapeBarcodePrefix"],"members":{"GatewayARN":{},"TapeSizeInBytes":{"type":"long"},"ClientToken":{},"NumTapesToCreate":{"type":"integer"},"TapeBarcodePrefix":{}}},"output":{"type":"structure","members":{"TapeARNs":{"shape":"S20"}}}},"DeleteBandwidthRateLimit":{"input":{"type":"structure","required":["GatewayARN","BandwidthType"],"members":{"GatewayARN":{},"BandwidthType":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"DeleteChapCredentials":{"input":{"type":"structure","required":["TargetARN","InitiatorName"],"members":{"TargetARN":{},"InitiatorName":{}}},"output":{"type":"structure","members":{"TargetARN":{},"InitiatorName":{}}}},"DeleteFileShare":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"ForceDelete":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"DeleteGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"DeleteSnapshotSchedule":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"DeleteTape":{"input":{"type":"structure","required":["GatewayARN","TapeARN"],"members":{"GatewayARN":{},"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"DeleteTapeArchive":{"input":{"type":"structure","required":["TapeARN"],"members":{"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"DeleteVolume":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"DescribeBandwidthRateLimit":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"AverageUploadRateLimitInBitsPerSec":{"type":"long"},"AverageDownloadRateLimitInBitsPerSec":{"type":"long"}}}},"DescribeCache":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DiskIds":{"shape":"Sc"},"CacheAllocatedInBytes":{"type":"long"},"CacheUsedPercentage":{"type":"double"},"CacheDirtyPercentage":{"type":"double"},"CacheHitPercentage":{"type":"double"},"CacheMissPercentage":{"type":"double"}}}},"DescribeCachediSCSIVolumes":{"input":{"type":"structure","required":["VolumeARNs"],"members":{"VolumeARNs":{"shape":"S2r"}}},"output":{"type":"structure","members":{"CachediSCSIVolumes":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeId":{},"VolumeType":{},"VolumeStatus":{},"VolumeSizeInBytes":{"type":"long"},"VolumeProgress":{"type":"double"},"SourceSnapshotId":{},"VolumeiSCSIAttributes":{"shape":"S2z"},"CreatedDate":{"type":"timestamp"},"VolumeUsedInBytes":{"type":"long"}}}}}}},"DescribeChapCredentials":{"input":{"type":"structure","required":["TargetARN"],"members":{"TargetARN":{}}},"output":{"type":"structure","members":{"ChapCredentials":{"type":"list","member":{"type":"structure","members":{"TargetARN":{},"SecretToAuthenticateInitiator":{},"InitiatorName":{},"SecretToAuthenticateTarget":{}}}}}}},"DescribeGatewayInformation":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"GatewayId":{},"GatewayName":{},"GatewayTimezone":{},"GatewayState":{},"GatewayNetworkInterfaces":{"type":"list","member":{"type":"structure","members":{"Ipv4Address":{},"MacAddress":{},"Ipv6Address":{}}}},"GatewayType":{},"NextUpdateAvailabilityDate":{},"LastSoftwareUpdate":{}}}},"DescribeMaintenanceStartTime":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"HourOfDay":{"type":"integer"},"MinuteOfHour":{"type":"integer"},"DayOfWeek":{"type":"integer"},"Timezone":{}}}},"DescribeNFSFileShares":{"input":{"type":"structure","required":["FileShareARNList"],"members":{"FileShareARNList":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"NFSFileShareInfoList":{"type":"list","member":{"type":"structure","members":{"NFSFileShareDefaults":{"shape":"S15"},"FileShareARN":{},"FileShareId":{},"FileShareStatus":{},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Path":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ObjectACL":{},"ClientList":{"shape":"S1e"},"Squash":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"}}}}}}},"DescribeSnapshotSchedule":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"VolumeARN":{},"StartAt":{"type":"integer"},"RecurrenceInHours":{"type":"integer"},"Description":{},"Timezone":{}}}},"DescribeStorediSCSIVolumes":{"input":{"type":"structure","required":["VolumeARNs"],"members":{"VolumeARNs":{"shape":"S2r"}}},"output":{"type":"structure","members":{"StorediSCSIVolumes":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeId":{},"VolumeType":{},"VolumeStatus":{},"VolumeSizeInBytes":{"type":"long"},"VolumeProgress":{"type":"double"},"VolumeDiskId":{},"SourceSnapshotId":{},"PreservedExistingData":{"type":"boolean"},"VolumeiSCSIAttributes":{"shape":"S2z"},"CreatedDate":{"type":"timestamp"},"VolumeUsedInBytes":{"type":"long"}}}}}}},"DescribeTapeArchives":{"input":{"type":"structure","members":{"TapeARNs":{"shape":"S20"},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TapeArchives":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeBarcode":{},"TapeCreatedDate":{"type":"timestamp"},"TapeSizeInBytes":{"type":"long"},"CompletionTime":{"type":"timestamp"},"RetrievedTo":{},"TapeStatus":{},"TapeUsedInBytes":{"type":"long"}}}},"Marker":{}}}},"DescribeTapeRecoveryPoints":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{},"TapeRecoveryPointInfos":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeRecoveryPointTime":{"type":"timestamp"},"TapeSizeInBytes":{"type":"long"},"TapeStatus":{}}}},"Marker":{}}}},"DescribeTapes":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"TapeARNs":{"shape":"S20"},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Tapes":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeBarcode":{},"TapeCreatedDate":{"type":"timestamp"},"TapeSizeInBytes":{"type":"long"},"TapeStatus":{},"VTLDevice":{},"Progress":{"type":"double"},"TapeUsedInBytes":{"type":"long"}}}},"Marker":{}}}},"DescribeUploadBuffer":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DiskIds":{"shape":"Sc"},"UploadBufferUsedInBytes":{"type":"long"},"UploadBufferAllocatedInBytes":{"type":"long"}}}},"DescribeVTLDevices":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"VTLDeviceARNs":{"type":"list","member":{}},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{},"VTLDevices":{"type":"list","member":{"type":"structure","members":{"VTLDeviceARN":{},"VTLDeviceType":{},"VTLDeviceVendor":{},"VTLDeviceProductIdentifier":{},"DeviceiSCSIAttributes":{"type":"structure","members":{"TargetARN":{},"NetworkInterfaceId":{},"NetworkInterfacePort":{"type":"integer"},"ChapEnabled":{"type":"boolean"}}}}}},"Marker":{}}}},"DescribeWorkingStorage":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DiskIds":{"shape":"Sc"},"WorkingStorageUsedInBytes":{"type":"long"},"WorkingStorageAllocatedInBytes":{"type":"long"}}}},"DisableGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"ListFileShares":{"input":{"type":"structure","members":{"GatewayARN":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"NextMarker":{},"FileShareInfoList":{"type":"list","member":{"type":"structure","members":{"FileShareARN":{},"FileShareId":{},"FileShareStatus":{},"GatewayARN":{}}}}}}},"ListGateways":{"input":{"type":"structure","members":{"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Gateways":{"type":"list","member":{"type":"structure","members":{"GatewayId":{},"GatewayARN":{},"GatewayType":{},"GatewayOperationalState":{},"GatewayName":{}}}},"Marker":{}}}},"ListLocalDisks":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"Disks":{"type":"list","member":{"type":"structure","members":{"DiskId":{},"DiskPath":{},"DiskNode":{},"DiskStatus":{},"DiskSizeInBytes":{"type":"long"},"DiskAllocationType":{},"DiskAllocationResource":{}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceARN":{},"Marker":{},"Tags":{"shape":"Sh"}}}},"ListTapes":{"input":{"type":"structure","members":{"TapeARNs":{"shape":"S20"},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TapeInfos":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeBarcode":{},"TapeSizeInBytes":{"type":"long"},"TapeStatus":{},"GatewayARN":{}}}},"Marker":{}}}},"ListVolumeInitiators":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"Initiators":{"type":"list","member":{}}}}},"ListVolumeRecoveryPoints":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"VolumeRecoveryPointInfos":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeSizeInBytes":{"type":"long"},"VolumeUsageInBytes":{"type":"long"},"VolumeRecoveryPointTime":{}}}}}}},"ListVolumes":{"input":{"type":"structure","members":{"GatewayARN":{},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{},"Marker":{},"VolumeInfos":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeId":{},"GatewayARN":{},"GatewayId":{},"VolumeType":{},"VolumeSizeInBytes":{"type":"long"}}}}}}},"NotifyWhenUploaded":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{}}},"output":{"type":"structure","members":{"FileShareARN":{},"NotificationId":{}}}},"RefreshCache":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ResourceARN":{}}}},"ResetCache":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"RetrieveTapeArchive":{"input":{"type":"structure","required":["TapeARN","GatewayARN"],"members":{"TapeARN":{},"GatewayARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"RetrieveTapeRecoveryPoint":{"input":{"type":"structure","required":["TapeARN","GatewayARN"],"members":{"TapeARN":{},"GatewayARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"SetLocalConsolePassword":{"input":{"type":"structure","required":["GatewayARN","LocalConsolePassword"],"members":{"GatewayARN":{},"LocalConsolePassword":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"ShutdownGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"StartGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateBandwidthRateLimit":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"AverageUploadRateLimitInBitsPerSec":{"type":"long"},"AverageDownloadRateLimitInBitsPerSec":{"type":"long"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateChapCredentials":{"input":{"type":"structure","required":["TargetARN","SecretToAuthenticateInitiator","InitiatorName"],"members":{"TargetARN":{},"SecretToAuthenticateInitiator":{},"InitiatorName":{},"SecretToAuthenticateTarget":{}}},"output":{"type":"structure","members":{"TargetARN":{},"InitiatorName":{}}}},"UpdateGatewayInformation":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"GatewayName":{},"GatewayTimezone":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"GatewayName":{}}}},"UpdateGatewaySoftwareNow":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateMaintenanceStartTime":{"input":{"type":"structure","required":["GatewayARN","HourOfDay","MinuteOfHour","DayOfWeek"],"members":{"GatewayARN":{},"HourOfDay":{"type":"integer"},"MinuteOfHour":{"type":"integer"},"DayOfWeek":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateNFSFileShare":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"NFSFileShareDefaults":{"shape":"S15"},"DefaultStorageClass":{},"ObjectACL":{},"ClientList":{"shape":"S1e"},"Squash":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"UpdateSnapshotSchedule":{"input":{"type":"structure","required":["VolumeARN","StartAt","RecurrenceInHours"],"members":{"VolumeARN":{},"StartAt":{"type":"integer"},"RecurrenceInHours":{"type":"integer"},"Description":{}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"UpdateVTLDeviceType":{"input":{"type":"structure","required":["VTLDeviceARN","DeviceType"],"members":{"VTLDeviceARN":{},"DeviceType":{}}},"output":{"type":"structure","members":{"VTLDeviceARN":{}}}}},"shapes":{"Sc":{"type":"list","member":{}},"Sh":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S15":{"type":"structure","members":{"FileMode":{},"DirectoryMode":{},"GroupId":{"type":"long"},"OwnerId":{"type":"long"}}},"S1e":{"type":"list","member":{}},"S20":{"type":"list","member":{}},"S2r":{"type":"list","member":{}},"S2z":{"type":"structure","members":{"TargetARN":{},"NetworkInterfaceId":{},"NetworkInterfacePort":{"type":"integer"},"LunNumber":{"type":"integer"},"ChapEnabled":{"type":"boolean"}}}}}

/***/ }),
/* 2957 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeCachediSCSIVolumes":{"result_key":"CachediSCSIVolumes"},"DescribeStorediSCSIVolumes":{"result_key":"StorediSCSIVolumes"},"DescribeTapeArchives":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"TapeArchives"},"DescribeTapeRecoveryPoints":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"TapeRecoveryPointInfos"},"DescribeTapes":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Tapes"},"DescribeVTLDevices":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"VTLDevices"},"ListGateways":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Gateways"},"ListLocalDisks":{"result_key":"Disks"},"ListVolumeRecoveryPoints":{"result_key":"VolumeRecoveryPointInfos"},"ListVolumes":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"VolumeInfos"}}}

/***/ }),
/* 2958 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['waf'] = {};
AWS.WAF = Service.defineService('waf', ['2015-08-24']);
Object.defineProperty(apiLoader.services['waf'], '2015-08-24', {
  get: function get() {
    var model = __webpack_require__(2959);
    model.paginators = __webpack_require__(2960).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.WAF;


/***/ }),
/* 2959 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-08-24","endpointPrefix":"waf","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"WAF","serviceFullName":"AWS WAF","serviceId":"WAF","signatureVersion":"v4","targetPrefix":"AWSWAF_20150824","uid":"waf-2015-08-24"},"operations":{"CreateByteMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ByteMatchSet":{"shape":"S5"},"ChangeToken":{}}}},"CreateGeoMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"GeoMatchSet":{"shape":"Sh"},"ChangeToken":{}}}},"CreateIPSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"IPSet":{"shape":"So"},"ChangeToken":{}}}},"CreateRateBasedRule":{"input":{"type":"structure","required":["Name","MetricName","RateKey","RateLimit","ChangeToken"],"members":{"Name":{},"MetricName":{},"RateKey":{},"RateLimit":{"type":"long"},"ChangeToken":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"Sy"},"ChangeToken":{}}}},"CreateRegexMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"RegexMatchSet":{"shape":"S15"},"ChangeToken":{}}}},"CreateRegexPatternSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"RegexPatternSet":{"shape":"S1a"},"ChangeToken":{}}}},"CreateRule":{"input":{"type":"structure","required":["Name","MetricName","ChangeToken"],"members":{"Name":{},"MetricName":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"S1f"},"ChangeToken":{}}}},"CreateRuleGroup":{"input":{"type":"structure","required":["Name","MetricName","ChangeToken"],"members":{"Name":{},"MetricName":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"RuleGroup":{"shape":"S1i"},"ChangeToken":{}}}},"CreateSizeConstraintSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"SizeConstraintSet":{"shape":"S1l"},"ChangeToken":{}}}},"CreateSqlInjectionMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"SqlInjectionMatchSet":{"shape":"S1s"},"ChangeToken":{}}}},"CreateWebACL":{"input":{"type":"structure","required":["Name","MetricName","DefaultAction","ChangeToken"],"members":{"Name":{},"MetricName":{},"DefaultAction":{"shape":"S1w"},"ChangeToken":{}}},"output":{"type":"structure","members":{"WebACL":{"shape":"S1z"},"ChangeToken":{}}}},"CreateXssMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"XssMatchSet":{"shape":"S28"},"ChangeToken":{}}}},"DeleteByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId","ChangeToken"],"members":{"ByteMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId","ChangeToken"],"members":{"GeoMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteIPSet":{"input":{"type":"structure","required":["IPSetId","ChangeToken"],"members":{"IPSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeletePermissionPolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DeleteRateBasedRule":{"input":{"type":"structure","required":["RuleId","ChangeToken"],"members":{"RuleId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId","ChangeToken"],"members":{"RegexMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId","ChangeToken"],"members":{"RegexPatternSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRule":{"input":{"type":"structure","required":["RuleId","ChangeToken"],"members":{"RuleId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRuleGroup":{"input":{"type":"structure","required":["RuleGroupId","ChangeToken"],"members":{"RuleGroupId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId","ChangeToken"],"members":{"SizeConstraintSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId","ChangeToken"],"members":{"SqlInjectionMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteWebACL":{"input":{"type":"structure","required":["WebACLId","ChangeToken"],"members":{"WebACLId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId","ChangeToken"],"members":{"XssMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"GetByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId"],"members":{"ByteMatchSetId":{}}},"output":{"type":"structure","members":{"ByteMatchSet":{"shape":"S5"}}}},"GetChangeToken":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"GetChangeTokenStatus":{"input":{"type":"structure","required":["ChangeToken"],"members":{"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeTokenStatus":{}}}},"GetGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId"],"members":{"GeoMatchSetId":{}}},"output":{"type":"structure","members":{"GeoMatchSet":{"shape":"Sh"}}}},"GetIPSet":{"input":{"type":"structure","required":["IPSetId"],"members":{"IPSetId":{}}},"output":{"type":"structure","members":{"IPSet":{"shape":"So"}}}},"GetPermissionPolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Policy":{}}}},"GetRateBasedRule":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"Sy"}}}},"GetRateBasedRuleManagedKeys":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{},"NextMarker":{}}},"output":{"type":"structure","members":{"ManagedKeys":{"type":"list","member":{}},"NextMarker":{}}}},"GetRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId"],"members":{"RegexMatchSetId":{}}},"output":{"type":"structure","members":{"RegexMatchSet":{"shape":"S15"}}}},"GetRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId"],"members":{"RegexPatternSetId":{}}},"output":{"type":"structure","members":{"RegexPatternSet":{"shape":"S1a"}}}},"GetRule":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"S1f"}}}},"GetRuleGroup":{"input":{"type":"structure","required":["RuleGroupId"],"members":{"RuleGroupId":{}}},"output":{"type":"structure","members":{"RuleGroup":{"shape":"S1i"}}}},"GetSampledRequests":{"input":{"type":"structure","required":["WebAclId","RuleId","TimeWindow","MaxItems"],"members":{"WebAclId":{},"RuleId":{},"TimeWindow":{"shape":"S3w"},"MaxItems":{"type":"long"}}},"output":{"type":"structure","members":{"SampledRequests":{"type":"list","member":{"type":"structure","required":["Request","Weight"],"members":{"Request":{"type":"structure","members":{"ClientIP":{},"Country":{},"URI":{},"Method":{},"HTTPVersion":{},"Headers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}}}}},"Weight":{"type":"long"},"Timestamp":{"type":"timestamp"},"Action":{},"RuleWithinRuleGroup":{}}}},"PopulationSize":{"type":"long"},"TimeWindow":{"shape":"S3w"}}}},"GetSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId"],"members":{"SizeConstraintSetId":{}}},"output":{"type":"structure","members":{"SizeConstraintSet":{"shape":"S1l"}}}},"GetSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId"],"members":{"SqlInjectionMatchSetId":{}}},"output":{"type":"structure","members":{"SqlInjectionMatchSet":{"shape":"S1s"}}}},"GetWebACL":{"input":{"type":"structure","required":["WebACLId"],"members":{"WebACLId":{}}},"output":{"type":"structure","members":{"WebACL":{"shape":"S1z"}}}},"GetXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId"],"members":{"XssMatchSetId":{}}},"output":{"type":"structure","members":{"XssMatchSet":{"shape":"S28"}}}},"ListActivatedRulesInRuleGroup":{"input":{"type":"structure","members":{"RuleGroupId":{},"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"ActivatedRules":{"shape":"S20"}}}},"ListByteMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"ByteMatchSets":{"type":"list","member":{"type":"structure","required":["ByteMatchSetId","Name"],"members":{"ByteMatchSetId":{},"Name":{}}}}}}},"ListGeoMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"GeoMatchSets":{"type":"list","member":{"type":"structure","required":["GeoMatchSetId","Name"],"members":{"GeoMatchSetId":{},"Name":{}}}}}}},"ListIPSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"IPSets":{"type":"list","member":{"type":"structure","required":["IPSetId","Name"],"members":{"IPSetId":{},"Name":{}}}}}}},"ListRateBasedRules":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Rules":{"shape":"S54"}}}},"ListRegexMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RegexMatchSets":{"type":"list","member":{"type":"structure","required":["RegexMatchSetId","Name"],"members":{"RegexMatchSetId":{},"Name":{}}}}}}},"ListRegexPatternSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RegexPatternSets":{"type":"list","member":{"type":"structure","required":["RegexPatternSetId","Name"],"members":{"RegexPatternSetId":{},"Name":{}}}}}}},"ListRuleGroups":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RuleGroups":{"type":"list","member":{"type":"structure","required":["RuleGroupId","Name"],"members":{"RuleGroupId":{},"Name":{}}}}}}},"ListRules":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Rules":{"shape":"S54"}}}},"ListSizeConstraintSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"SizeConstraintSets":{"type":"list","member":{"type":"structure","required":["SizeConstraintSetId","Name"],"members":{"SizeConstraintSetId":{},"Name":{}}}}}}},"ListSqlInjectionMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"SqlInjectionMatchSets":{"type":"list","member":{"type":"structure","required":["SqlInjectionMatchSetId","Name"],"members":{"SqlInjectionMatchSetId":{},"Name":{}}}}}}},"ListSubscribedRuleGroups":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RuleGroups":{"type":"list","member":{"type":"structure","required":["RuleGroupId","Name","MetricName"],"members":{"RuleGroupId":{},"Name":{},"MetricName":{}}}}}}},"ListWebACLs":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"WebACLs":{"type":"list","member":{"type":"structure","required":["WebACLId","Name"],"members":{"WebACLId":{},"Name":{}}}}}}},"ListXssMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"XssMatchSets":{"type":"list","member":{"type":"structure","required":["XssMatchSetId","Name"],"members":{"XssMatchSetId":{},"Name":{}}}}}}},"PutPermissionPolicy":{"input":{"type":"structure","required":["ResourceArn","Policy"],"members":{"ResourceArn":{},"Policy":{}}},"output":{"type":"structure","members":{}}},"UpdateByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId","ChangeToken","Updates"],"members":{"ByteMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ByteMatchTuple"],"members":{"Action":{},"ByteMatchTuple":{"shape":"S8"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId","ChangeToken","Updates"],"members":{"GeoMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","GeoMatchConstraint"],"members":{"Action":{},"GeoMatchConstraint":{"shape":"Sj"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateIPSet":{"input":{"type":"structure","required":["IPSetId","ChangeToken","Updates"],"members":{"IPSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","IPSetDescriptor"],"members":{"Action":{},"IPSetDescriptor":{"shape":"Sq"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRateBasedRule":{"input":{"type":"structure","required":["RuleId","ChangeToken","Updates","RateLimit"],"members":{"RuleId":{},"ChangeToken":{},"Updates":{"shape":"S6k"},"RateLimit":{"type":"long"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId","Updates","ChangeToken"],"members":{"RegexMatchSetId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","RegexMatchTuple"],"members":{"Action":{},"RegexMatchTuple":{"shape":"S17"}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId","Updates","ChangeToken"],"members":{"RegexPatternSetId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","RegexPatternString"],"members":{"Action":{},"RegexPatternString":{}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRule":{"input":{"type":"structure","required":["RuleId","ChangeToken","Updates"],"members":{"RuleId":{},"ChangeToken":{},"Updates":{"shape":"S6k"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRuleGroup":{"input":{"type":"structure","required":["RuleGroupId","Updates","ChangeToken"],"members":{"RuleGroupId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ActivatedRule"],"members":{"Action":{},"ActivatedRule":{"shape":"S21"}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId","ChangeToken","Updates"],"members":{"SizeConstraintSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","SizeConstraint"],"members":{"Action":{},"SizeConstraint":{"shape":"S1n"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId","ChangeToken","Updates"],"members":{"SqlInjectionMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","SqlInjectionMatchTuple"],"members":{"Action":{},"SqlInjectionMatchTuple":{"shape":"S1u"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateWebACL":{"input":{"type":"structure","required":["WebACLId","ChangeToken"],"members":{"WebACLId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ActivatedRule"],"members":{"Action":{},"ActivatedRule":{"shape":"S21"}}}},"DefaultAction":{"shape":"S1w"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId","ChangeToken","Updates"],"members":{"XssMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","XssMatchTuple"],"members":{"Action":{},"XssMatchTuple":{"shape":"S2a"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}}},"shapes":{"S5":{"type":"structure","required":["ByteMatchSetId","ByteMatchTuples"],"members":{"ByteMatchSetId":{},"Name":{},"ByteMatchTuples":{"type":"list","member":{"shape":"S8"}}}},"S8":{"type":"structure","required":["FieldToMatch","TargetString","TextTransformation","PositionalConstraint"],"members":{"FieldToMatch":{"shape":"S9"},"TargetString":{"type":"blob"},"TextTransformation":{},"PositionalConstraint":{}}},"S9":{"type":"structure","required":["Type"],"members":{"Type":{},"Data":{}}},"Sh":{"type":"structure","required":["GeoMatchSetId","GeoMatchConstraints"],"members":{"GeoMatchSetId":{},"Name":{},"GeoMatchConstraints":{"type":"list","member":{"shape":"Sj"}}}},"Sj":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}},"So":{"type":"structure","required":["IPSetId","IPSetDescriptors"],"members":{"IPSetId":{},"Name":{},"IPSetDescriptors":{"type":"list","member":{"shape":"Sq"}}}},"Sq":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}},"Sy":{"type":"structure","required":["RuleId","MatchPredicates","RateKey","RateLimit"],"members":{"RuleId":{},"Name":{},"MetricName":{},"MatchPredicates":{"shape":"Sz"},"RateKey":{},"RateLimit":{"type":"long"}}},"Sz":{"type":"list","member":{"shape":"S10"}},"S10":{"type":"structure","required":["Negated","Type","DataId"],"members":{"Negated":{"type":"boolean"},"Type":{},"DataId":{}}},"S15":{"type":"structure","members":{"RegexMatchSetId":{},"Name":{},"RegexMatchTuples":{"type":"list","member":{"shape":"S17"}}}},"S17":{"type":"structure","required":["FieldToMatch","TextTransformation","RegexPatternSetId"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{},"RegexPatternSetId":{}}},"S1a":{"type":"structure","required":["RegexPatternSetId","RegexPatternStrings"],"members":{"RegexPatternSetId":{},"Name":{},"RegexPatternStrings":{"type":"list","member":{}}}},"S1f":{"type":"structure","required":["RuleId","Predicates"],"members":{"RuleId":{},"Name":{},"MetricName":{},"Predicates":{"shape":"Sz"}}},"S1i":{"type":"structure","required":["RuleGroupId"],"members":{"RuleGroupId":{},"Name":{},"MetricName":{}}},"S1l":{"type":"structure","required":["SizeConstraintSetId","SizeConstraints"],"members":{"SizeConstraintSetId":{},"Name":{},"SizeConstraints":{"type":"list","member":{"shape":"S1n"}}}},"S1n":{"type":"structure","required":["FieldToMatch","TextTransformation","ComparisonOperator","Size"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{},"ComparisonOperator":{},"Size":{"type":"long"}}},"S1s":{"type":"structure","required":["SqlInjectionMatchSetId","SqlInjectionMatchTuples"],"members":{"SqlInjectionMatchSetId":{},"Name":{},"SqlInjectionMatchTuples":{"type":"list","member":{"shape":"S1u"}}}},"S1u":{"type":"structure","required":["FieldToMatch","TextTransformation"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{}}},"S1w":{"type":"structure","required":["Type"],"members":{"Type":{}}},"S1z":{"type":"structure","required":["WebACLId","DefaultAction","Rules"],"members":{"WebACLId":{},"Name":{},"MetricName":{},"DefaultAction":{"shape":"S1w"},"Rules":{"shape":"S20"}}},"S20":{"type":"list","member":{"shape":"S21"}},"S21":{"type":"structure","required":["Priority","RuleId"],"members":{"Priority":{"type":"integer"},"RuleId":{},"Action":{"shape":"S1w"},"OverrideAction":{"type":"structure","required":["Type"],"members":{"Type":{}}},"Type":{}}},"S28":{"type":"structure","required":["XssMatchSetId","XssMatchTuples"],"members":{"XssMatchSetId":{},"Name":{},"XssMatchTuples":{"type":"list","member":{"shape":"S2a"}}}},"S2a":{"type":"structure","required":["FieldToMatch","TextTransformation"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{}}},"S3w":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"S54":{"type":"list","member":{"type":"structure","required":["RuleId","Name"],"members":{"RuleId":{},"Name":{}}}},"S6k":{"type":"list","member":{"type":"structure","required":["Action","Predicate"],"members":{"Action":{},"Predicate":{"shape":"S10"}}}}}}

/***/ }),
/* 2960 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 2961 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['workdocs'] = {};
AWS.WorkDocs = Service.defineService('workdocs', ['2016-05-01']);
Object.defineProperty(apiLoader.services['workdocs'], '2016-05-01', {
  get: function get() {
    var model = __webpack_require__(2962);
    model.paginators = __webpack_require__(2963).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.WorkDocs;


/***/ }),
/* 2962 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-05-01","endpointPrefix":"workdocs","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon WorkDocs","signatureVersion":"v4","uid":"workdocs-2016-05-01"},"operations":{"AbortDocumentVersionUpload":{"http":{"method":"DELETE","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}","responseCode":204},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"}}}},"ActivateUser":{"http":{"requestUri":"/api/v1/users/{UserId}/activation","responseCode":200},"input":{"type":"structure","required":["UserId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}},"AddResourcePermissions":{"http":{"requestUri":"/api/v1/resources/{ResourceId}/permissions","responseCode":201},"input":{"type":"structure","required":["ResourceId","Principals"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"Principals":{"type":"list","member":{"type":"structure","required":["Id","Type","Role"],"members":{"Id":{},"Type":{},"Role":{}}}},"NotificationOptions":{"type":"structure","members":{"SendEmail":{"type":"boolean"},"EmailMessage":{"shape":"St"}}}}},"output":{"type":"structure","members":{"ShareResults":{"type":"list","member":{"type":"structure","members":{"PrincipalId":{},"Role":{},"Status":{},"ShareId":{},"StatusMessage":{"shape":"St"}}}}}}},"CreateComment":{"http":{"requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}/comment","responseCode":201},"input":{"type":"structure","required":["DocumentId","VersionId","Text"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"ParentId":{},"ThreadId":{},"Text":{"shape":"S10"},"Visibility":{},"NotifyCollaborators":{"type":"boolean"}}},"output":{"type":"structure","members":{"Comment":{"shape":"S13"}}}},"CreateCustomMetadata":{"http":{"method":"PUT","requestUri":"/api/v1/resources/{ResourceId}/customMetadata","responseCode":200},"input":{"type":"structure","required":["ResourceId","CustomMetadata"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"VersionId":{"location":"querystring","locationName":"versionid"},"CustomMetadata":{"shape":"S16"}}},"output":{"type":"structure","members":{}}},"CreateFolder":{"http":{"requestUri":"/api/v1/folders","responseCode":201},"input":{"type":"structure","required":["ParentFolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Name":{},"ParentFolderId":{}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S1d"}}}},"CreateLabels":{"http":{"method":"PUT","requestUri":"/api/v1/resources/{ResourceId}/labels","responseCode":200},"input":{"type":"structure","required":["ResourceId","Labels"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"Labels":{"shape":"S1g"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{}}},"CreateNotificationSubscription":{"http":{"requestUri":"/api/v1/organizations/{OrganizationId}/subscriptions","responseCode":200},"input":{"type":"structure","required":["OrganizationId","Endpoint","Protocol","SubscriptionType"],"members":{"OrganizationId":{"location":"uri","locationName":"OrganizationId"},"Endpoint":{},"Protocol":{},"SubscriptionType":{}}},"output":{"type":"structure","members":{"Subscription":{"shape":"S1p"}}}},"CreateUser":{"http":{"requestUri":"/api/v1/users","responseCode":201},"input":{"type":"structure","required":["Username","GivenName","Surname","Password"],"members":{"OrganizationId":{},"Username":{},"EmailAddress":{},"GivenName":{},"Surname":{},"Password":{"type":"string","sensitive":true},"TimeZoneId":{},"StorageRule":{"shape":"Sj"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}},"DeactivateUser":{"http":{"method":"DELETE","requestUri":"/api/v1/users/{UserId}/activation","responseCode":204},"input":{"type":"structure","required":["UserId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}}},"DeleteComment":{"http":{"method":"DELETE","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}/comment/{CommentId}","responseCode":204},"input":{"type":"structure","required":["DocumentId","VersionId","CommentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"CommentId":{"location":"uri","locationName":"CommentId"}}}},"DeleteCustomMetadata":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/customMetadata","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"VersionId":{"location":"querystring","locationName":"versionId"},"Keys":{"location":"querystring","locationName":"keys","type":"list","member":{}},"DeleteAll":{"location":"querystring","locationName":"deleteAll","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteDocument":{"http":{"method":"DELETE","requestUri":"/api/v1/documents/{DocumentId}","responseCode":204},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"}}}},"DeleteFolder":{"http":{"method":"DELETE","requestUri":"/api/v1/folders/{FolderId}","responseCode":204},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"}}}},"DeleteFolderContents":{"http":{"method":"DELETE","requestUri":"/api/v1/folders/{FolderId}/contents","responseCode":204},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"}}}},"DeleteLabels":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/labels","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Labels":{"shape":"S1g","location":"querystring","locationName":"labels"},"DeleteAll":{"location":"querystring","locationName":"deleteAll","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteNotificationSubscription":{"http":{"method":"DELETE","requestUri":"/api/v1/organizations/{OrganizationId}/subscriptions/{SubscriptionId}","responseCode":200},"input":{"type":"structure","required":["SubscriptionId","OrganizationId"],"members":{"SubscriptionId":{"location":"uri","locationName":"SubscriptionId"},"OrganizationId":{"location":"uri","locationName":"OrganizationId"}}}},"DeleteUser":{"http":{"method":"DELETE","requestUri":"/api/v1/users/{UserId}","responseCode":204},"input":{"type":"structure","required":["UserId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"UserId":{"location":"uri","locationName":"UserId"}}}},"DescribeActivities":{"http":{"method":"GET","requestUri":"/api/v1/activities","responseCode":200},"input":{"type":"structure","members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"StartTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"EndTime":{"location":"querystring","locationName":"endTime","type":"timestamp"},"OrganizationId":{"location":"querystring","locationName":"organizationId"},"UserId":{"location":"querystring","locationName":"userId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"UserActivities":{"type":"list","member":{"type":"structure","members":{"Type":{},"TimeStamp":{"type":"timestamp"},"OrganizationId":{},"Initiator":{"shape":"S2c"},"Participants":{"type":"structure","members":{"Users":{"type":"list","member":{"shape":"S2c"}},"Groups":{"shape":"S2f"}}},"ResourceMetadata":{"shape":"S2i"},"OriginalParent":{"shape":"S2i"},"CommentMetadata":{"type":"structure","members":{"CommentId":{},"Contributor":{"shape":"S8"},"CreatedTimestamp":{"type":"timestamp"},"CommentStatus":{},"RecipientId":{}}}}}},"Marker":{}}}},"DescribeComments":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}/comments","responseCode":200},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Comments":{"type":"list","member":{"shape":"S13"}},"Marker":{}}}},"DescribeDocumentVersions":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/versions","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Include":{"location":"querystring","locationName":"include"},"Fields":{"location":"querystring","locationName":"fields"}}},"output":{"type":"structure","members":{"DocumentVersions":{"type":"list","member":{"shape":"S2t"}},"Marker":{}}}},"DescribeFolderContents":{"http":{"method":"GET","requestUri":"/api/v1/folders/{FolderId}/contents","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"Sort":{"location":"querystring","locationName":"sort"},"Order":{"location":"querystring","locationName":"order"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"},"Type":{"location":"querystring","locationName":"type"},"Include":{"location":"querystring","locationName":"include"}}},"output":{"type":"structure","members":{"Folders":{"shape":"S36"},"Documents":{"type":"list","member":{"shape":"S38"}},"Marker":{}}}},"DescribeGroups":{"http":{"method":"GET","requestUri":"/api/v1/groups","responseCode":200},"input":{"type":"structure","required":["SearchQuery"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"SearchQuery":{"shape":"S3a","location":"querystring","locationName":"searchQuery"},"OrganizationId":{"location":"querystring","locationName":"organizationId"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"Groups":{"shape":"S2f"},"Marker":{}}}},"DescribeNotificationSubscriptions":{"http":{"method":"GET","requestUri":"/api/v1/organizations/{OrganizationId}/subscriptions","responseCode":200},"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{"location":"uri","locationName":"OrganizationId"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"Subscriptions":{"type":"list","member":{"shape":"S1p"}},"Marker":{}}}},"DescribeResourcePermissions":{"http":{"method":"GET","requestUri":"/api/v1/resources/{ResourceId}/permissions","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"PrincipalId":{"location":"querystring","locationName":"principalId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Principals":{"type":"list","member":{"type":"structure","members":{"Id":{},"Type":{},"Roles":{"type":"list","member":{"type":"structure","members":{"Role":{},"Type":{}}}}}}},"Marker":{}}}},"DescribeRootFolders":{"http":{"method":"GET","requestUri":"/api/v1/me/root","responseCode":200},"input":{"type":"structure","required":["AuthenticationToken"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Folders":{"shape":"S36"},"Marker":{}}}},"DescribeUsers":{"http":{"method":"GET","requestUri":"/api/v1/users","responseCode":200},"input":{"type":"structure","members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"OrganizationId":{"location":"querystring","locationName":"organizationId"},"UserIds":{"location":"querystring","locationName":"userIds"},"Query":{"shape":"S3a","location":"querystring","locationName":"query"},"Include":{"location":"querystring","locationName":"include"},"Order":{"location":"querystring","locationName":"order"},"Sort":{"location":"querystring","locationName":"sort"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Fields":{"location":"querystring","locationName":"fields"}}},"output":{"type":"structure","members":{"Users":{"type":"list","member":{"shape":"S8"}},"TotalNumberOfUsers":{"deprecated":true,"type":"long"},"Marker":{}}}},"GetCurrentUser":{"http":{"method":"GET","requestUri":"/api/v1/me","responseCode":200},"input":{"type":"structure","required":["AuthenticationToken"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}},"GetDocument":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"IncludeCustomMetadata":{"location":"querystring","locationName":"includeCustomMetadata","type":"boolean"}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S38"},"CustomMetadata":{"shape":"S16"}}}},"GetDocumentPath":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/path","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Fields":{"location":"querystring","locationName":"fields"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Path":{"shape":"S41"}}}},"GetDocumentVersion":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}","responseCode":200},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"Fields":{"location":"querystring","locationName":"fields"},"IncludeCustomMetadata":{"location":"querystring","locationName":"includeCustomMetadata","type":"boolean"}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S2t"},"CustomMetadata":{"shape":"S16"}}}},"GetFolder":{"http":{"method":"GET","requestUri":"/api/v1/folders/{FolderId}","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"IncludeCustomMetadata":{"location":"querystring","locationName":"includeCustomMetadata","type":"boolean"}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S1d"},"CustomMetadata":{"shape":"S16"}}}},"GetFolderPath":{"http":{"method":"GET","requestUri":"/api/v1/folders/{FolderId}/path","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Fields":{"location":"querystring","locationName":"fields"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Path":{"shape":"S41"}}}},"InitiateDocumentVersionUpload":{"http":{"requestUri":"/api/v1/documents","responseCode":201},"input":{"type":"structure","required":["ParentFolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Id":{},"Name":{},"ContentCreatedTimestamp":{"type":"timestamp"},"ContentModifiedTimestamp":{"type":"timestamp"},"ContentType":{},"DocumentSizeInBytes":{"type":"long"},"ParentFolderId":{}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S38"},"UploadMetadata":{"type":"structure","members":{"UploadUrl":{"shape":"S2y"},"SignedHeaders":{"type":"map","key":{},"value":{}}}}}}},"RemoveAllResourcePermissions":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/permissions","responseCode":204},"input":{"type":"structure","required":["ResourceId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"}}}},"RemoveResourcePermission":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/permissions/{PrincipalId}","responseCode":204},"input":{"type":"structure","required":["ResourceId","PrincipalId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"PrincipalId":{"location":"uri","locationName":"PrincipalId"},"PrincipalType":{"location":"querystring","locationName":"type"}}}},"UpdateDocument":{"http":{"method":"PATCH","requestUri":"/api/v1/documents/{DocumentId}","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"Name":{},"ParentFolderId":{},"ResourceState":{}}}},"UpdateDocumentVersion":{"http":{"method":"PATCH","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}","responseCode":200},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"VersionStatus":{}}}},"UpdateFolder":{"http":{"method":"PATCH","requestUri":"/api/v1/folders/{FolderId}","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"Name":{},"ParentFolderId":{},"ResourceState":{}}}},"UpdateUser":{"http":{"method":"PATCH","requestUri":"/api/v1/users/{UserId}","responseCode":200},"input":{"type":"structure","required":["UserId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"UserId":{"location":"uri","locationName":"UserId"},"GivenName":{},"Surname":{},"Type":{},"StorageRule":{"shape":"Sj"},"TimeZoneId":{},"Locale":{},"GrantPoweruserPrivileges":{}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}}},"shapes":{"S2":{"type":"string","sensitive":true},"S8":{"type":"structure","members":{"Id":{},"Username":{},"EmailAddress":{},"GivenName":{},"Surname":{},"OrganizationId":{},"RootFolderId":{},"RecycleBinFolderId":{},"Status":{},"Type":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"TimeZoneId":{},"Locale":{},"Storage":{"type":"structure","members":{"StorageUtilizedInBytes":{"type":"long"},"StorageRule":{"shape":"Sj"}}}}},"Sj":{"type":"structure","members":{"StorageAllocatedInBytes":{"type":"long"},"StorageType":{}}},"St":{"type":"string","sensitive":true},"S10":{"type":"string","sensitive":true},"S13":{"type":"structure","required":["CommentId"],"members":{"CommentId":{},"ParentId":{},"ThreadId":{},"Text":{"shape":"S10"},"Contributor":{"shape":"S8"},"CreatedTimestamp":{"type":"timestamp"},"Status":{},"Visibility":{},"RecipientId":{}}},"S16":{"type":"map","key":{},"value":{}},"S1d":{"type":"structure","members":{"Id":{},"Name":{},"CreatorId":{},"ParentFolderId":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"ResourceState":{},"Signature":{},"Labels":{"shape":"S1g"},"Size":{"type":"long"},"LatestVersionSize":{"type":"long"}}},"S1g":{"type":"list","member":{}},"S1p":{"type":"structure","members":{"SubscriptionId":{},"EndPoint":{},"Protocol":{}}},"S2c":{"type":"structure","members":{"Id":{},"Username":{},"GivenName":{},"Surname":{},"EmailAddress":{}}},"S2f":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{}}}},"S2i":{"type":"structure","members":{"Type":{},"Name":{},"OriginalName":{},"Id":{},"VersionId":{},"Owner":{"shape":"S2c"},"ParentId":{}}},"S2t":{"type":"structure","members":{"Id":{},"Name":{},"ContentType":{},"Size":{"type":"long"},"Signature":{},"Status":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"ContentCreatedTimestamp":{"type":"timestamp"},"ContentModifiedTimestamp":{"type":"timestamp"},"CreatorId":{},"Thumbnail":{"type":"map","key":{},"value":{"shape":"S2y"}},"Source":{"type":"map","key":{},"value":{"shape":"S2y"}}}},"S2y":{"type":"string","sensitive":true},"S36":{"type":"list","member":{"shape":"S1d"}},"S38":{"type":"structure","members":{"Id":{},"CreatorId":{},"ParentFolderId":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"LatestVersionMetadata":{"shape":"S2t"},"ResourceState":{},"Labels":{"shape":"S1g"}}},"S3a":{"type":"string","sensitive":true},"S41":{"type":"structure","members":{"Components":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{}}}}}}}}

/***/ }),
/* 2963 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDocumentVersions":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"DocumentVersions"},"DescribeFolderContents":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":["Folders","Documents"]},"DescribeUsers":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Users"}}}

/***/ }),
/* 2964 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
var AWS = __webpack_require__(5);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['lexmodelbuildingservice'] = {};
AWS.LexModelBuildingService = Service.defineService('lexmodelbuildingservice', ['2017-04-19']);
Object.defineProperty(apiLoader.services['lexmodelbuildingservice'], '2017-04-19', {
  get: function get() {
    var model = __webpack_require__(2965);
    model.paginators = __webpack_require__(2966).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.LexModelBuildingService;


/***/ }),
/* 2965 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-04-19","endpointPrefix":"models.lex","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Lex Model Building Service","serviceId":"Lex Model Building Service","signatureVersion":"v4","signingName":"lex","uid":"lex-models-2017-04-19"},"operations":{"CreateBotVersion":{"http":{"requestUri":"/bots/{name}/versions","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"intents":{"shape":"S6"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"status":{},"failureReason":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"version":{},"locale":{},"childDirected":{"type":"boolean"}}}},"CreateIntentVersion":{"http":{"requestUri":"/intents/{name}/versions","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"Sy"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"Sz"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S10"},"fulfillmentActivity":{"shape":"S13"},"parentIntentSignature":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{}}}},"CreateSlotTypeVersion":{"http":{"requestUri":"/slottypes/{name}/versions","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"enumerationValues":{"shape":"S19"},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"valueSelectionStrategy":{}}}},"DeleteBot":{"http":{"method":"DELETE","requestUri":"/bots/{name}","responseCode":204},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}}},"DeleteBotAlias":{"http":{"method":"DELETE","requestUri":"/bots/{botName}/aliases/{name}","responseCode":204},"input":{"type":"structure","required":["name","botName"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"}}}},"DeleteBotChannelAssociation":{"http":{"method":"DELETE","requestUri":"/bots/{botName}/aliases/{aliasName}/channels/{name}","responseCode":204},"input":{"type":"structure","required":["name","botName","botAlias"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"aliasName"}}}},"DeleteBotVersion":{"http":{"method":"DELETE","requestUri":"/bots/{name}/versions/{version}","responseCode":204},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}}},"DeleteIntent":{"http":{"method":"DELETE","requestUri":"/intents/{name}","responseCode":204},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}}},"DeleteIntentVersion":{"http":{"method":"DELETE","requestUri":"/intents/{name}/versions/{version}","responseCode":204},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}}},"DeleteSlotType":{"http":{"method":"DELETE","requestUri":"/slottypes/{name}","responseCode":204},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}}},"DeleteSlotTypeVersion":{"http":{"method":"DELETE","requestUri":"/slottypes/{name}/version/{version}","responseCode":204},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}}},"DeleteUtterances":{"http":{"method":"DELETE","requestUri":"/bots/{botName}/utterances/{userId}","responseCode":204},"input":{"type":"structure","required":["botName","userId"],"members":{"botName":{"location":"uri","locationName":"botName"},"userId":{"location":"uri","locationName":"userId"}}}},"GetBot":{"http":{"method":"GET","requestUri":"/bots/{name}/versions/{versionoralias}","responseCode":200},"input":{"type":"structure","required":["name","versionOrAlias"],"members":{"name":{"location":"uri","locationName":"name"},"versionOrAlias":{"location":"uri","locationName":"versionoralias"}}},"output":{"type":"structure","members":{"name":{},"description":{},"intents":{"shape":"S6"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"status":{},"failureReason":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"version":{},"locale":{},"childDirected":{"type":"boolean"}}}},"GetBotAlias":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/{name}","responseCode":200},"input":{"type":"structure","required":["name","botName"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"}}},"output":{"type":"structure","members":{"name":{},"description":{},"botVersion":{},"botName":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"checksum":{}}}},"GetBotAliases":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/","responseCode":200},"input":{"type":"structure","required":["botName"],"members":{"botName":{"location":"uri","locationName":"botName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"BotAliases":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"botVersion":{},"botName":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"checksum":{}}}},"nextToken":{}}}},"GetBotChannelAssociation":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/{aliasName}/channels/{name}","responseCode":200},"input":{"type":"structure","required":["name","botName","botAlias"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"aliasName"}}},"output":{"type":"structure","members":{"name":{},"description":{},"botAlias":{},"botName":{},"createdDate":{"type":"timestamp"},"type":{},"botConfiguration":{"shape":"S24"},"status":{},"failureReason":{}}}},"GetBotChannelAssociations":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/{aliasName}/channels/","responseCode":200},"input":{"type":"structure","required":["botName","botAlias"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"aliasName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"botChannelAssociations":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"botAlias":{},"botName":{},"createdDate":{"type":"timestamp"},"type":{},"botConfiguration":{"shape":"S24"},"status":{},"failureReason":{}}}},"nextToken":{}}}},"GetBotVersions":{"http":{"method":"GET","requestUri":"/bots/{name}/versions/","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"bots":{"shape":"S2d"},"nextToken":{}}}},"GetBots":{"http":{"method":"GET","requestUri":"/bots/","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"bots":{"shape":"S2d"},"nextToken":{}}}},"GetBuiltinIntent":{"http":{"method":"GET","requestUri":"/builtins/intents/{signature}","responseCode":200},"input":{"type":"structure","required":["signature"],"members":{"signature":{"location":"uri","locationName":"signature"}}},"output":{"type":"structure","members":{"signature":{},"supportedLocales":{"shape":"S2j"},"slots":{"type":"list","member":{"type":"structure","members":{"name":{}}}}}}},"GetBuiltinIntents":{"http":{"method":"GET","requestUri":"/builtins/intents/","responseCode":200},"input":{"type":"structure","members":{"locale":{"location":"querystring","locationName":"locale"},"signatureContains":{"location":"querystring","locationName":"signatureContains"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"intents":{"type":"list","member":{"type":"structure","members":{"signature":{},"supportedLocales":{"shape":"S2j"}}}},"nextToken":{}}}},"GetBuiltinSlotTypes":{"http":{"method":"GET","requestUri":"/builtins/slottypes/","responseCode":200},"input":{"type":"structure","members":{"locale":{"location":"querystring","locationName":"locale"},"signatureContains":{"location":"querystring","locationName":"signatureContains"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"slotTypes":{"type":"list","member":{"type":"structure","members":{"signature":{},"supportedLocales":{"shape":"S2j"}}}},"nextToken":{}}}},"GetExport":{"http":{"method":"GET","requestUri":"/exports/","responseCode":200},"input":{"type":"structure","required":["name","version","resourceType","exportType"],"members":{"name":{"location":"querystring","locationName":"name"},"version":{"location":"querystring","locationName":"version"},"resourceType":{"location":"querystring","locationName":"resourceType"},"exportType":{"location":"querystring","locationName":"exportType"}}},"output":{"type":"structure","members":{"name":{},"version":{},"resourceType":{},"exportType":{},"exportStatus":{},"failureReason":{},"url":{}}}},"GetImport":{"http":{"method":"GET","requestUri":"/imports/{importId}","responseCode":200},"input":{"type":"structure","required":["importId"],"members":{"importId":{"location":"uri","locationName":"importId"}}},"output":{"type":"structure","members":{"name":{},"resourceType":{},"mergeStrategy":{},"importId":{},"importStatus":{},"failureReason":{"type":"list","member":{}},"createdDate":{"type":"timestamp"}}}},"GetIntent":{"http":{"method":"GET","requestUri":"/intents/{name}/versions/{version}","responseCode":200},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}},"output":{"type":"structure","members":{"name":{},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"Sy"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"Sz"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S10"},"fulfillmentActivity":{"shape":"S13"},"parentIntentSignature":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{}}}},"GetIntentVersions":{"http":{"method":"GET","requestUri":"/intents/{name}/versions/","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"intents":{"shape":"S3a"},"nextToken":{}}}},"GetIntents":{"http":{"method":"GET","requestUri":"/intents/","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"intents":{"shape":"S3a"},"nextToken":{}}}},"GetSlotType":{"http":{"method":"GET","requestUri":"/slottypes/{name}/versions/{version}","responseCode":200},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}},"output":{"type":"structure","members":{"name":{},"description":{},"enumerationValues":{"shape":"S19"},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"valueSelectionStrategy":{}}}},"GetSlotTypeVersions":{"http":{"method":"GET","requestUri":"/slottypes/{name}/versions/","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"slotTypes":{"shape":"S3i"},"nextToken":{}}}},"GetSlotTypes":{"http":{"method":"GET","requestUri":"/slottypes/","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"slotTypes":{"shape":"S3i"},"nextToken":{}}}},"GetUtterancesView":{"http":{"method":"GET","requestUri":"/bots/{botname}/utterances?view=aggregation","responseCode":200},"input":{"type":"structure","required":["botName","botVersions","statusType"],"members":{"botName":{"location":"uri","locationName":"botname"},"botVersions":{"location":"querystring","locationName":"bot_versions","type":"list","member":{}},"statusType":{"location":"querystring","locationName":"status_type"}}},"output":{"type":"structure","members":{"botName":{},"utterances":{"type":"list","member":{"type":"structure","members":{"botVersion":{},"utterances":{"type":"list","member":{"type":"structure","members":{"utteranceString":{},"count":{"type":"integer"},"distinctUsers":{"type":"integer"},"firstUtteredDate":{"type":"timestamp"},"lastUtteredDate":{"type":"timestamp"}}}}}}}}}},"PutBot":{"http":{"method":"PUT","requestUri":"/bots/{name}/versions/$LATEST","responseCode":200},"input":{"type":"structure","required":["name","locale","childDirected"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"intents":{"shape":"S6"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"processBehavior":{},"locale":{},"childDirected":{"type":"boolean"},"createVersion":{"type":"boolean"}}},"output":{"type":"structure","members":{"name":{},"description":{},"intents":{"shape":"S6"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"status":{},"failureReason":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"version":{},"locale":{},"childDirected":{"type":"boolean"},"createVersion":{"type":"boolean"}}}},"PutBotAlias":{"http":{"method":"PUT","requestUri":"/bots/{botName}/aliases/{name}","responseCode":200},"input":{"type":"structure","required":["name","botVersion","botName"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"botVersion":{},"botName":{"location":"uri","locationName":"botName"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"botVersion":{},"botName":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"checksum":{}}}},"PutIntent":{"http":{"method":"PUT","requestUri":"/intents/{name}/versions/$LATEST","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"Sy"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"Sz"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S10"},"fulfillmentActivity":{"shape":"S13"},"parentIntentSignature":{},"checksum":{},"createVersion":{"type":"boolean"}}},"output":{"type":"structure","members":{"name":{},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"Sy"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"Sz"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S10"},"fulfillmentActivity":{"shape":"S13"},"parentIntentSignature":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"createVersion":{"type":"boolean"}}}},"PutSlotType":{"http":{"method":"PUT","requestUri":"/slottypes/{name}/versions/$LATEST","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"enumerationValues":{"shape":"S19"},"checksum":{},"valueSelectionStrategy":{},"createVersion":{"type":"boolean"}}},"output":{"type":"structure","members":{"name":{},"description":{},"enumerationValues":{"shape":"S19"},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"valueSelectionStrategy":{},"createVersion":{"type":"boolean"}}}},"StartImport":{"http":{"requestUri":"/imports/","responseCode":201},"input":{"type":"structure","required":["payload","resourceType","mergeStrategy"],"members":{"payload":{"type":"blob"},"resourceType":{},"mergeStrategy":{}}},"output":{"type":"structure","members":{"name":{},"resourceType":{},"mergeStrategy":{},"importId":{},"importStatus":{},"createdDate":{"type":"timestamp"}}}}},"shapes":{"S6":{"type":"list","member":{"type":"structure","required":["intentName","intentVersion"],"members":{"intentName":{},"intentVersion":{}}}},"Sa":{"type":"structure","required":["messages","maxAttempts"],"members":{"messages":{"shape":"Sb"},"maxAttempts":{"type":"integer"},"responseCard":{}}},"Sb":{"type":"list","member":{"type":"structure","required":["contentType","content"],"members":{"contentType":{},"content":{},"groupNumber":{"type":"integer"}}}},"Si":{"type":"structure","required":["messages"],"members":{"messages":{"shape":"Sb"},"responseCard":{}}},"Sq":{"type":"list","member":{"type":"structure","required":["name","slotConstraint"],"members":{"name":{},"description":{},"slotConstraint":{},"slotType":{},"slotTypeVersion":{},"valueElicitationPrompt":{"shape":"Sa"},"priority":{"type":"integer"},"sampleUtterances":{"type":"list","member":{}},"responseCard":{}}}},"Sy":{"type":"list","member":{}},"Sz":{"type":"structure","required":["prompt","rejectionStatement"],"members":{"prompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"}}},"S10":{"type":"structure","required":["uri","messageVersion"],"members":{"uri":{},"messageVersion":{}}},"S13":{"type":"structure","required":["type"],"members":{"type":{},"codeHook":{"shape":"S10"}}},"S19":{"type":"list","member":{"type":"structure","required":["value"],"members":{"value":{},"synonyms":{"type":"list","member":{}}}}},"S24":{"type":"map","key":{},"value":{},"sensitive":true},"S2d":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"status":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{}}}},"S2j":{"type":"list","member":{}},"S3a":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{}}}},"S3i":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{}}}}}}

/***/ }),
/* 2966 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetBotAliases":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBotChannelAssociations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBotVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBots":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBuiltinIntents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBuiltinSlotTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetIntentVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetIntents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetSlotTypeVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetSlotTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 2967 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CreateFolderModal_css__ = __webpack_require__(2969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CreateFolderModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__CreateFolderModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateFolderModal=function(_Component){_inherits(CreateFolderModal,_Component);function CreateFolderModal(props){_classCallCheck(this,CreateFolderModal);var _this=_possibleConstructorReturn(this,(CreateFolderModal.__proto__||Object.getPrototypeOf(CreateFolderModal)).call(this,props));_this.handleChange=function(folderName){_this.setState({folderName:folderName});};_this.handleSubmit=function(){var values={prefix:_this.props.prefix,oldFolderName:_this.props.folderName,folderName:_this.state.folderName};_this.props.onSubmit(values);};_this.state={folderName:props.folderName||''};return _this;}_createClass(CreateFolderModal,[{key:'render',value:function render(){var _props=this.props,showModal=_props.showModal,onClose=_props.onClose,title=_props.title;var folderName=this.state.folderName;return showModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__["a" /* default */],{show:showModal,onClose:onClose,title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row create-folder-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_input_Input__["a" /* default */],{id:'folderName',placeholder:'Folder Name',theme:'normal',value:folderName,onChange:this.handleChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{disabled:!folderName,className:'button-orange',label:'Done',onClick:this.handleSubmit})))));}}]);return CreateFolderModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CreateFolderModal.propTypes={showModal:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,folderName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,prefix:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,title:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(CreateFolderModal));

/***/ }),
/* 2969 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_upload_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_upload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UploadFilesModal_css__ = __webpack_require__(2971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UploadFilesModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__UploadFilesModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UploadFilesModal=function(_Component){_inherits(UploadFilesModal,_Component);function UploadFilesModal(props){_classCallCheck(this,UploadFilesModal);var _this=_possibleConstructorReturn(this,(UploadFilesModal.__proto__||Object.getPrototypeOf(UploadFilesModal)).call(this,props));_this.getArrayAttribute=function(attr){var form=_this.props.form;if(form&&form[attr]&&form[attr].length>0){return form[attr];}return[];};_this.handleSubmit=function(){_this.props.onSubmit(_this.state.documents);};_this.setDocuments=function(files){var docs=_this.state.documents;files.forEach(function(val){docs.push({file:val,name:val.name});});_this.setState({documents:docs});};_this.removeDocument=function(fileName){var documents=_this.state.documents;var docs=documents.filter(function(document){return document.name!==fileName;});_this.setState({documents:docs});};_this.state={documents:[]};return _this;}_createClass(UploadFilesModal,[{key:'render',value:function render(){var _this2=this;var _props=this.props,showModal=_props.showModal,onClose=_props.onClose;var documents=this.state.documents;return showModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_modal_FormModal__["a" /* default */],{show:showModal,onClose:onClose,title:'Upload Files'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_dropzone__["a" /* default */],{className:'dropzone-container',multiple:true,onDrop:function onDrop(files){return _this2.setDocuments(files);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Drag & Drop or Browse Files'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6_images_upload_svg___default.a,alt:'upload'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'files-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,' ',this.state.documents.map(function(data,index){return!data.removed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,data.file!==null?data.file.name:Object(__WEBPACK_IMPORTED_MODULE_7_services_utils_text_util__["d" /* getLastTokenFromUrl */])(data.document.document.url,'unknown')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8_images_remove_png___default.a,onClick:function onClick(){return _this2.removeDocument(data.file.name);},alt:'remove'})));}),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{disabled:documents.length===0,className:'button-orange',label:'Upload',onClick:this.handleSubmit})));}}]);return UploadFilesModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UploadFilesModal.propTypes={showModal:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(UploadFilesModal));

/***/ }),
/* 2971 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_directory_store_actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_dropdown_MultipleDropdown__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_input_TextArea__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_email_modal_store_selectors__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DownloadObjectModal_css__ = __webpack_require__(2973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DownloadObjectModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__DownloadObjectModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DownloadObjectsModal=function(_Component){_inherits(DownloadObjectsModal,_Component);function DownloadObjectsModal(props){_classCallCheck(this,DownloadObjectsModal);var _this=_possibleConstructorReturn(this,(DownloadObjectsModal.__proto__||Object.getPrototypeOf(DownloadObjectsModal)).call(this,props));_this.handleSubjectChange=function(value){_this.setState({subject:value});};_this.handleMessageChange=function(value){_this.setState({message:value});};_this.handleRecipientsChange=function(values){_this.setState({recipients:values});};_this.isSendButtonEnabled=function(){var _this$state=_this.state,recipients=_this$state.recipients,subject=_this$state.subject,message=_this$state.message;return recipients.length>0&&subject!==''&&message!=='';};_this.recipientOptions=function(){return _this.uniqueEmails(_this.props.directory.project_contributors.map(function(pc){return pc.users.map(function(user){return{id:user.id,label:user.email};});}).flat(1));};_this.initialSubject=function(){var currentProject=_this.props.currentProject;return currentProject.number+' '+currentProject.name+' Documents';};_this.initialMessage=function(){var currentProject=_this.props.currentProject;var _currentProject$build=currentProject.building.location,street_address_1=_currentProject$build.street_address_1,city=_currentProject$build.city,state=_currentProject$build.state;return'Please find the below link to download  documents for '+currentProject.name+', located at '+street_address_1+', '+city+', '+state+'.\n\n';};_this.state={recipients:[[props.currentUser.id,props.currentUser.email]],message:props.message||_this.initialMessage(),subject:props.subject||_this.initialSubject()};return _this;}_createClass(DownloadObjectsModal,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var currentProject=this.props.currentProject;if(currentProject&&currentProject.id){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_directory_store_actions__["j" /* loadDirectoryRequest */])(this.props.currentProject.id)).then(function(response){if(response.ok){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_email_modal_store_actions__["f" /* setEmails */])(_this2.recipientOptions()));}});}}},{key:'uniqueEmails',value:function uniqueEmails(emails){var uniques=[];emails.forEach(function(email){if(!uniques.find(function(unique){return unique.id===email.id;})){uniques.push(email);}});return uniques;}},{key:'render',value:function render(){var _this3=this;var _props=this.props,showModal=_props.showModal,onClose=_props.onClose,emails=_props.emails,title=_props.title;var _state=this.state,recipients=_state.recipients,message=_state.message,subject=_state.subject;return showModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{show:showModal,onClose:onClose,className:'download-objects-modal',title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'download-objects-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'body-bold'},'To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'users-email-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_dropdown_MultipleDropdown__["a" /* default */],{className:'to-emails-dropdown',dropdownClassName:'alternate-dropdown-control',options:emails,currentValues:recipients,placeholder:'Select recipients',onChange:function onChange(values){return _this3.handleRecipientsChange(values);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'with-border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'body-bold'},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subject-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_input_Input__["a" /* default */],{placeholder:'Subject',value:subject,onChange:function onChange(value){return _this3.handleSubjectChange(value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'with-border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'body-bold message'},'Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_input_TextArea__["a" /* default */],{placeholder:'Message',value:message,onChange:function onChange(value){return _this3.handleMessageChange(value);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:!this.isSendButtonEnabled(),label:'Send',onClick:function onClick(){return _this3.props.onSubmit({recipients:recipients.map(function(recipient){return recipient[1];}),subject:subject,message:message});}})));}}]);return DownloadObjectsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DownloadObjectsModal.propTypes={showModal:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,folders:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,projectId:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number.isRequired,currentUser:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object.isRequired,prefix:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,title:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,subject:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,message:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_authentication__["d" /* getCurrentUser */])(state),currentProject:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),emails:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_email_modal_store_selectors__["b" /* getEmails */])(state),recipients:Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_email_modal_store_selectors__["e" /* getRecipients */])(state),directory:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_directory_store_selectors__["c" /* getDirectory */])(state)};})(DownloadObjectsModal));

/***/ }),
/* 2973 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_react_fontawesome__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faFolder__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faFolder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faFolder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MoveFolderOrFileModal_css__ = __webpack_require__(2975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MoveFolderOrFileModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__MoveFolderOrFileModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_aws_sdk__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_aws_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_aws_sdk__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var s3=new __WEBPACK_IMPORTED_MODULE_8_aws_sdk___default.a.S3();var MoveFolderOrFileModal=function(_Component){_inherits(MoveFolderOrFileModal,_Component);function MoveFolderOrFileModal(props){_classCallCheck(this,MoveFolderOrFileModal);var _this=_possibleConstructorReturn(this,(MoveFolderOrFileModal.__proto__||Object.getPrototypeOf(MoveFolderOrFileModal)).call(this,props));_this.componentDidMount=function(){_this.fetchFolders();};_this.fetchFolders=function(){var params={Bucket:_this.props.bucket,Prefix:_this.props.prefix,Delimiter:_this.props.delimiter};var scope={Contents:[],CommonPrefixes:[],params:params};scope.cb=_this.updateFilesDisplayed;return s3.makeUnauthenticatedRequest('listObjectsV2',scope.params,_this.updateFilesDisplayed(scope));};_this.updateFilesDisplayed=function(scope){return function(err,data){var selectedObject=_this.props.selectedObject;if(data){var files=data.Contents;var directoryDepth=_this.props.prefix.split('/').length+1;files=files.concat(data.CommonPrefixes);if(scope.params.Prefix){// filter out folder if prefix
files=files.filter(function(file){return file.Key!==scope.params.Prefix;});files=files.filter(function(file){return file.Key.endsWith('/');});// ensure directories displayed are the correct depth
files=files.filter(function(file){return file.Key.split('/').length===directoryDepth;});files=files.filter(function(file){return file.Key!==selectedObject;});}_this.setState({files:files});}};};_this.folderNameFromPath=function(path){var parts=path.split('/');var name=parts[parts.length-2]+'/';return name;};_this.fileNameFromPath=function(path){return _this.htmlEscape(path.replace(/^.*[\\/]/,''));};_this.objectDisplayName=function(object){return object.endsWith('/')?_this.folderNameFromPath(object):_this.fileNameFromPath(object);};_this.htmlEscape=function(str){return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;').replace(/\//g,'&#x2F;').replace(/`/g,'&#x60;').replace(/=/g,'&#x3D;');};_this.selectFolder=function(file){_this.setState({selectedFolder:file.Key});};_this.folderSelected=function(file){return file.Key===_this.state.selectedFolder?'selected':'';};_this.handleSubmit=function(){var values={selectedObject:_this.props.selectedObject,selectedDestination:_this.state.selectedFolder,parentFolder:_this.props.prefix};_this.props.onSubmit(values);};_this.state={files:[],selectedFolder:null};return _this;}_createClass(MoveFolderOrFileModal,[{key:'render',value:function render(){var _this2=this;var _props=this.props,showModal=_props.showModal,onClose=_props.onClose,selectedObject=_props.selectedObject;var _state=this.state,files=_state.files,selectedFolder=_state.selectedFolder;return showModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_modal_FormModal__["a" /* default */],{show:showModal,onClose:onClose,title:'Move Folder/File'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row move-folder-modal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-heading clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},'Selected:  '+this.objectDisplayName(selectedObject))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,files.map(function(file,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index,className:_this2.folderSelected(file)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{onClick:function onClick(){return _this2.selectFolder(file);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__fortawesome_react_fontawesome__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faFolder___default.a}),_this2.folderNameFromPath(file.Key)));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{disabled:!selectedFolder,className:'button-orange pull-right',label:'Move',onClick:this.handleSubmit}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Cancel',onClick:onClose})))));}}]);return MoveFolderOrFileModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MoveFolderOrFileModal.propTypes={showModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,prefix:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,selectedObject:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(MoveFolderOrFileModal));

/***/ }),
/* 2975 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectOpenItemsModal_css__ = __webpack_require__(2977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectOpenItemsModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProjectOpenItemsModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_open_items_store_selectors__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_open_items_store_actions__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_notifications__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_open_items_ProjectOpenItemsTable__ = __webpack_require__(2978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_ProjectOpenItemFormModal__ = __webpack_require__(2980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_open_items_ProjectOpenItemDetailsModal__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_button_Button__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectOpenItemsModal=function(_Component){_inherits(ProjectOpenItemsModal,_Component);function ProjectOpenItemsModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProjectOpenItemsModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProjectOpenItemsModal.__proto__||Object.getPrototypeOf(ProjectOpenItemsModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenItemsModalClose=function(){var _this$props=_this.props,currentProject=_this$props.currentProject,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_open_items_store_actions__["q" /* openItemsCount */])(currentProject.id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_open_items_store_actions__["g" /* closeOpenItemsModal */])());},_this.handleAddNewOpenItem=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_open_items_store_actions__["z" /* showOpenItemFormModal */])());},_this.handleOpenItemSelected=function(id){var _this$props2=_this.props,currentProject=_this$props2.currentProject,dispatch=_this$props2.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_open_items_store_actions__["m" /* loadOpenItem */])(currentProject.id,id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_notifications__["o" /* markNotifiableNotificationsAsRead */])(id,'ProjectOpenItem'));},_this.modalTitle=function(){var currentProject=_this.props.currentProject;var contribType=currentProject.contributor_type;var canAddOpenItem=__WEBPACK_IMPORTED_MODULE_5_domain_enterprise__["a" /* Enterprise */].spackleOrGc(contribType)||__WEBPACK_IMPORTED_MODULE_5_domain_enterprise__["a" /* Enterprise */].primary(contribType);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this.props.critical?'Critical Open Items':'Open Items',canAddOpenItem&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_button_Button__["a" /* default */],{label:_this.props.critical?'Add New Critical Item':'Add New Open Item',className:'button-orange button-add-open-item',onClick:_this.handleAddNewOpenItem}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProjectOpenItemsModal,[{key:'render',value:function render(){var _props=this.props,currentProject=_props.currentProject,showOpenItemsModal=_props.showOpenItemsModal;return showOpenItemsModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_modal_FormModal__["a" /* default */],{className:'project-open-items-modal',show:showOpenItemsModal,onClose:this.handleOpenItemsModalClose,subTitle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['Projects',currentProject.name]}),title:this.modalTitle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_open_items_ProjectOpenItemsTable__["a" /* default */],{onRowSelected:this.handleOpenItemSelected})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_ProjectOpenItemFormModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_open_items_ProjectOpenItemDetailsModal__["a" /* default */],null));}}]);return ProjectOpenItemsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),showOpenItemsModal:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_open_items_store_selectors__["q" /* getShowOpenItemsModal */])(state),critical:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_open_items_store_selectors__["a" /* getCritical */])(state)};})(ProjectOpenItemsModal));

/***/ }),
/* 2977 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectOpenItemsTable_css__ = __webpack_require__(2979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectOpenItemsTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ProjectOpenItemsTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleHeader__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_selectors__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_open_items_store_actions__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_text_BaseStatus__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_selectors_notifications__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_domain_notification__ = __webpack_require__(279);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectOpenItemsTable=function(_Component){_inherits(ProjectOpenItemsTable,_Component);function ProjectOpenItemsTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProjectOpenItemsTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProjectOpenItemsTable.__proto__||Object.getPrototypeOf(ProjectOpenItemsTable)).call.apply(_ref,[this].concat(args))),_this),_this.handleGenerateLink=function(id){var critical=_this.props.critical;var query='?projectOpenItemId='+id;if(critical){query+='&projectOpenItemCritical='+critical;}return query;},_this.loadOpenItemsPage=function(page,status,dueDateFilter){var _this$props=_this.props,currentProject=_this$props.currentProject,critical=_this$props.critical,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_open_items_store_actions__["o" /* loadOpenItems */])(currentProject.id,page,critical,status,dueDateFilter));},_this.handleStatusChange=function(st){var status=st==='undefined'?undefined:st;_this.loadOpenItemsPage(1,status,_this.props.dueDateFilter);},_this.handleRowSelected=function(id){_this.props.onRowSelected(id);},_this.handlePageChange=function(newPage){_this.loadOpenItemsPage(newPage,_this.props.status,_this.props.dueDateFilter);},_this.mapOpenItems=function(){var _this$props2=_this.props,projectOpenItems=_this$props2.projectOpenItems,notifications=_this$props2.notifications;var unreadById=Object(__WEBPACK_IMPORTED_MODULE_15_domain_notification__["d" /* unreadNotifications */])(notifications,'ProjectOpenItem');return projectOpenItems.map(function(openItem){var unread=unreadById&&!!unreadById[openItem.id];return{id:openItem.id,className:!openItem.draft&&!openItem.resolved&&openItem.resolve_by&&__WEBPACK_IMPORTED_MODULE_8_moment___default()(openItem.resolve_by).isBefore(__WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD'))?'past-due':'',data:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,unread&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_text_BaseStatus__["a" /* default */],{labels:[{id:'unread',label:''}],status:'unread'}),Object(__WEBPACK_IMPORTED_MODULE_9_services_utils_text_util__["b" /* formatNumber */])(openItem.number)),openItem.csi_code&&openItem.csi_code.division||'00',openItem.assignee_label,openItem.description,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__["a" /* default */],{value:openItem.created_at,format:'MM/DD/YY'}),openItem.resolve_by&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__["a" /* default */],{value:openItem.resolve_by,format:'MM/DD/YY'}),openItem.responded_at&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__["a" /* default */],{value:openItem.responded_at,format:'MM/DD/YY'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:openItem.draft||openItem.draft_response&&!openItem.resolved?'draft':''},openItem.draft?'Draft':openItem.resolved?'Resolved':'Pending')]};});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProjectOpenItemsTable,[{key:'render',value:function render(){var _this2=this;var _props=this.props,currentPage=_props.currentPage,pageSize=_props.pageSize,total=_props.total,status=_props.status,_props$dueDateFilter=_props.dueDateFilter,dueDateFilter=_props$dueDateFilter===undefined?'all':_props$dueDateFilter;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-items-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table',headers:['#','CSI CODE','ASSIGNED TO','DESCRIPTION','CREATED',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleHeader__["a" /* default */],{label:'DUE DATE',filter:{options:[{id:'all',label:'All'},{id:'pending',label:'Pending'},{id:'overdue',label:'Overdue'},{id:'ascending',label:'Ascending'},{id:'descending',label:'Descending'}].filter(function(st){return!!st;}),selected:dueDateFilter},onFilterOptionSelect:function onFilterOptionSelect(filter){_this2.loadOpenItemsPage(1,status,filter);}}),'RESPONDED',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleHeader__["a" /* default */],{label:'STATUS',filter:{options:[{id:'undefined',label:'All'},{id:'past_due',label:'Past Due'},{id:'unresolved',label:'Pending'},{id:'resolved',label:'Resolved'}],selected:''+status},onFilterOptionSelect:this.handleStatusChange})],rows:this.mapOpenItems(),onRowSelected:this.handleRowSelected,emptyMessage:'No Open Items added yet.',onGenerateLink:this.handleGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPage,pageSize:pageSize,total:total,onPageChange:this.handlePageChange})));}}]);return ProjectOpenItemsTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProjectOpenItemsTable.propTypes={onRowSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),projectOpenItems:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_selectors__["k" /* getProjectOpenItems */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_selectors__["b" /* getCurrentPage */])(state),pageSize:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_selectors__["i" /* getPageSize */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_selectors__["s" /* getTotal */])(state),critical:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_selectors__["a" /* getCritical */])(state),status:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_selectors__["r" /* getStatus */])(state),dueDateFilter:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_selectors__["d" /* getDueDateFilter */])(state),notifications:Object(__WEBPACK_IMPORTED_MODULE_14_selectors_notifications__["b" /* getNotifications */])(state)};})(ProjectOpenItemsTable));

/***/ }),
/* 2979 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_open_items_store_selectors__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_open_items_store_actions__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_open_items_ProjectOpenItemForm__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProjectOpenItemFormModal_css__ = __webpack_require__(2982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProjectOpenItemFormModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ProjectOpenItemFormModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectOpenItemFormModal=function(_Component){_inherits(ProjectOpenItemFormModal,_Component);function ProjectOpenItemFormModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProjectOpenItemFormModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProjectOpenItemFormModal.__proto__||Object.getPrototypeOf(ProjectOpenItemFormModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenItemFormModalClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_open_items_store_actions__["f" /* closeOpenItemFormModal */])());},_this.handleSave=function(values){var _this$props=_this.props,currentProject=_this$props.currentProject,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_open_items_store_actions__["i" /* createProjectOpenItem */])(currentProject.id,values));},_this.modalTitle=function(){return _this.props.critical?'New Critical Open Item':'New Open Item';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProjectOpenItemFormModal,[{key:'render',value:function render(){var _props=this.props,currentProject=_props.currentProject,showOpenItemFormModal=_props.showOpenItemFormModal;return showOpenItemFormModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_modal_FormModal__["a" /* default */],{className:'project-open-item-form-modal',show:showOpenItemFormModal,onClose:this.handleOpenItemFormModalClose,subTitle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['Projects',currentProject.name]}),title:this.modalTitle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_open_items_ProjectOpenItemForm__["a" /* default */],{onSave:this.handleSave,onCancel:this.handleOpenItemFormModalClose}));}}]);return ProjectOpenItemFormModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),showOpenItemFormModal:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_open_items_store_selectors__["p" /* getShowOpenItemFormModal */])(state),critical:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_open_items_store_selectors__["a" /* getCritical */])(state)};})(ProjectOpenItemFormModal));

/***/ }),
/* 2981 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2982 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectOpenItemDetails_css__ = __webpack_require__(2984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectOpenItemDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ProjectOpenItemDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_slidedown__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_slidedown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_slidedown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_logo_upload_LogoUpload__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_email_modal_store_actions__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_print_svg__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_print_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_images_print_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_mail_svg__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_mail_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_images_mail_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_open_items_store_selectors__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_open_items_store_actions__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_open_items_ProjectOpenItemNotes__ = __webpack_require__(2985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_open_items_ProjectOpenItemRespondForm__ = __webpack_require__(2986);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectOpenItemDetails=function(_Component){_inherits(ProjectOpenItemDetails,_Component);function ProjectOpenItemDetails(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProjectOpenItemDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProjectOpenItemDetails.__proto__||Object.getPrototypeOf(ProjectOpenItemDetails)).call.apply(_ref,[this].concat(args))),_this),_this.handleRespond=function(){var _this$props=_this.props,openItem=_this$props.openItem,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_open_items_store_actions__["u" /* setOpenItemForm */])(Object.assign({},openItem,{documents:openItem.response_documents.map(function(doc){return Object.assign({},doc,{url:doc.document.url});}),images:openItem.response_images.map(function(image){return Object.assign({},image,{url:image.image.gallery.url});})})));dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_open_items_store_actions__["s" /* respondOpenItemDetailsModal */])());},_this.handleRespondCancel=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_open_items_store_actions__["b" /* cancelRespondOpenItemDetailsModal */])());},_this.handleRespondSave=function(values){var _this$props2=_this.props,currentProject=_this$props2.currentProject,openItem=_this$props2.openItem,dispatch=_this$props2.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_open_items_store_actions__["t" /* respondProjectOpenItem */])(currentProject.id,openItem.id,values));},_this.showUnreadNotesIndicator=function(){var _this$props3=_this.props,currentUser=_this$props3.currentUser,openItem=_this$props3.openItem;var notesReadBy=openItem.notes_read_by;return notesReadBy&&notesReadBy.length>0&&!notesReadBy.find(function(readById){return readById===''+currentUser.id;});},_this.handleViewPdf=function(){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_open_items_store_actions__["x" /* setOpenItemPdfViewer */])(true));},_this.handleShowEmailModal=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_email_modal_store_actions__["j" /* setShowEmailModal */])(true));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProjectOpenItemDetails,[{key:'render',value:function render(){var _props=this.props,currentUser=_props.currentUser,currentProject=_props.currentProject,openItem=_props.openItem,respondOpenItemDetailsModal=_props.respondOpenItemDetailsModal,onDelete=_props.onDelete,onEdit=_props.onEdit;var spackleOrGc=__WEBPACK_IMPORTED_MODULE_13_domain_enterprise__["a" /* Enterprise */].spackleOrGc(currentProject.contributor_type);var creator=openItem&&openItem.created_by&&openItem.created_by.id===currentUser.id;var assignee=openItem&&openItem.assignee_id===currentUser.id;var manager=spackleOrGc&&!assignee||creator;return openItem&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["s" /* Row */],{className:'project-open-item-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["d" /* Col */],{sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-details-block'},(openItem.created_by||openItem.assignee_label)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'project-open-item-block-title'},openItem.created_by&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'From: ',openItem.created_by.first_name,' ',openItem.created_by.last_name),openItem.assignee_label&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Assigned To: ',openItem.assignee_label))),openItem.recipients&&openItem.recipients.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'project-open-item-block-title'},'CC Recipient(s):',' ',openItem.recipients.map(function(rcpt){return rcpt.first_name+' '+rcpt.last_name;}).join(', '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'project-open-item-block-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Created: ',__WEBPACK_IMPORTED_MODULE_9_moment___default()(openItem.created_at).format('MM/DD/YY')),openItem.resolve_by&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Due Date: ',__WEBPACK_IMPORTED_MODULE_9_moment___default()(openItem.resolve_by).format('MM/DD/YY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Status: ',openItem.resolved?'Resolved':'Pending'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-details-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-text-block'},openItem.description)),openItem.documents&&openItem.documents.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-details-block'},openItem.documents.map(function(doc,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'doc-viewer',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_document_DocumentLink__["a" /* default */],{url:doc.document.url}));})),openItem.images&&openItem.images.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-details-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-block-images-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_logo_upload_LogoUpload__["a" /* default */],{readOnly:true,logos:openItem.images.map(function(image){return{preview:image.image.gallery.url,url:image.image.url};})}))),(openItem.response||respondOpenItemDetailsModal)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'divider'}),respondOpenItemDetailsModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_slidedown__["SlideDown"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_open_items_ProjectOpenItemRespondForm__["a" /* default */],{onSave:this.handleRespondSave,onCancel:this.handleRespondCancel})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-details-response'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'project-open-item-block-title'},openItem.responded_at&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Responded:',' ',__WEBPACK_IMPORTED_MODULE_9_moment___default()(openItem.responded_at).format('MM/DD/YY')),openItem.draft_response&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Draft Response'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-details-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-text-block'},openItem.response)),openItem.response_documents&&openItem.response_documents.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-details-block'},openItem.response_documents.map(function(doc,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'doc-viewer',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_document_DocumentLink__["a" /* default */],{url:doc.document.url}));})),openItem.response_images&&openItem.response_images.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-details-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-block-images-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_logo_upload_LogoUpload__["a" /* default */],{readOnly:true,logos:openItem.response_images.map(function(image){return{preview:image.image.gallery.url,url:image.image.url};})}))))),!respondOpenItemDetailsModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},manager&&!openItem.responded_at&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{label:'Delete',className:'button-white',onClick:onDelete}),openItem&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-white',icon:__WEBPACK_IMPORTED_MODULE_12_images_mail_svg___default.a,label:'Email',onClick:this.handleShowEmailModal}),openItem.pdf_document&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{className:'button-white',icon:__WEBPACK_IMPORTED_MODULE_11_images_print_svg___default.a,label:'View PDF',onClick:this.handleViewPdf}),spackleOrGc&&!assignee?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{label:'GC Acceleration',className:'button-white',onClick:this.handleRespond}):assignee&&!openItem.resolved&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{label:openItem.responded_at||openItem.draft_response?'Edit Response':'Respond',className:'button-orange',onClick:this.handleRespond}),manager&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{label:openItem.responded_at&&!openItem.draft_response?'Edit or Resolve':'Edit',className:'button-orange',onClick:onEdit}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["d" /* Col */],{sm:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_open_items_ProjectOpenItemNotes__["a" /* default */],null)));}}]);return ProjectOpenItemDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProjectOpenItemDetails.propTypes={onDelete:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onEdit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_14_selectors_authentication__["d" /* getCurrentUser */])(state),currentProject:Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),openItem:Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_open_items_store_selectors__["c" /* getCurrentProjectOpenItem */])(state),respondOpenItemDetailsModal:Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_open_items_store_selectors__["n" /* getRespondOpenItemDetailsModal */])(state)};})(ProjectOpenItemDetails));

/***/ }),
/* 2984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_chat_Chat__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_open_items_store_selectors__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_open_items_store_actions__ = __webpack_require__(132);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectOpenItemNotes=function(_Component){_inherits(ProjectOpenItemNotes,_Component);function ProjectOpenItemNotes(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProjectOpenItemNotes);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProjectOpenItemNotes.__proto__||Object.getPrototypeOf(ProjectOpenItemNotes)).call.apply(_ref,[this].concat(args))),_this),_this.markNotesRead=function(){var _this$props=_this.props,currentUser=_this$props.currentUser,openItem=_this$props.openItem,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_open_items_store_actions__["p" /* markOpenItemNotesRead */])(openItem,currentUser.id));},_this.loadNotes=function(){var _this$props2=_this.props,openItem=_this$props2.openItem,dispatch=_this$props2.dispatch;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_open_items_store_actions__["n" /* loadOpenItemNotes */])(openItem.id));},_this.handleSubmit=function(newNote){var _this$props3=_this.props,openItem=_this$props3.openItem,dispatch=_this$props3.dispatch;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_open_items_store_actions__["h" /* createOpenItemNote */])(openItem.id,newNote));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProjectOpenItemNotes,[{key:'componentDidMount',value:function componentDidMount(){this.markNotesRead();}},{key:'componentWillUnmount',value:function componentWillUnmount(){var dispatch=this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_open_items_store_actions__["c" /* clearItemNotes */])());}},{key:'render',value:function render(){var openItemNotes=this.props.openItemNotes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_chat_Chat__["a" /* default */],{name:'Open Item',notes:openItemNotes,loadChat:this.loadNotes,handleSubmit:this.handleSubmit});}}]);return ProjectOpenItemNotes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_2_selectors_authentication__["d" /* getCurrentUser */])(state),openItem:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_open_items_store_selectors__["c" /* getCurrentProjectOpenItem */])(state),openItemNotes:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_open_items_store_selectors__["j" /* getProjectOpenItemNotes */])(state)};})(ProjectOpenItemNotes));

/***/ }),
/* 2986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProjectOpenItemRespondForm_css__ = __webpack_require__(2987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProjectOpenItemRespondForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ProjectOpenItemRespondForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_autosize_textarea__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_autosize_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_autosize_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_upload_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_upload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_image_upload_ImageUpload__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils_files_util__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_open_items_store_selectors__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_open_items_store_actions__ = __webpack_require__(132);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectOpenItemRespondForm=function(_Component){_inherits(ProjectOpenItemRespondForm,_Component);function ProjectOpenItemRespondForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProjectOpenItemRespondForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProjectOpenItemRespondForm.__proto__||Object.getPrototypeOf(ProjectOpenItemRespondForm)).call.apply(_ref,[this].concat(args))),_this),_this.handleAttributeChange=function(attr,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_open_items_store_actions__["v" /* setOpenItemFormAttr */])(attr,value));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_open_items_store_actions__["d" /* clearOpenItemFormErrorAttr */])(attr));},_this.handleSaveDraft=function(){var _this$props=_this.props,form=_this$props.form,onSave=_this$props.onSave;var values=Object.assign({},form,{draftResponse:true});onSave(values);},_this.handleSave=function(){var _this$props2=_this.props,form=_this$props2.form,onSave=_this$props2.onSave,dispatch=_this$props2.dispatch;var errors={};if(!form.response){errors.response=true;}if(Object.keys(errors).length>0){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_open_items_store_actions__["w" /* setOpenItemFormErrors */])(errors));}else{var values=Object.assign({},form,{draftResponse:false});onSave(values);}},_this.getArrayAttribute=function(attr){var form=_this.props.form;if(form&&form[attr]&&form[attr].length>0){return form[attr];}return[];},_this.setImages=function(files){var images=[].concat(_toConsumableArray(_this.getArrayAttribute('images')));files.forEach(function(val){images.push({url:URL.createObjectURL(val),file:val});});_this.handleAttributeChange('images',images);},_this.removeImage=function(index){var images=[].concat(_toConsumableArray(_this.getArrayAttribute('images')));var deletedImages=[].concat(_toConsumableArray(_this.getArrayAttribute('deletedImages')));var deletedImage=images.splice(index,1);deletedImages.push(deletedImage[0]);_this.handleAttributeChange('images',images);_this.handleAttributeChange('deletedImages',deletedImages);},_this.setDocuments=function(files){var docs=[].concat(_toConsumableArray(_this.getArrayAttribute('documents')));files.forEach(function(val){docs.push({file:val,name:val.name});});_this.handleAttributeChange('documents',docs);},_this.removeDocument=function(index){var docs=[].concat(_toConsumableArray(_this.getArrayAttribute('documents')));var deletedDocs=[].concat(_toConsumableArray(_this.getArrayAttribute('deletedDocuments')));var deletedDoc=docs.splice(index,1);deletedDocs.push(deletedDoc[0]);_this.handleAttributeChange('documents',docs);_this.handleAttributeChange('deletedDocuments',deletedDocs);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProjectOpenItemRespondForm,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_open_items_store_actions__["r" /* resetOpenItemForm */])());}},{key:'render',value:function render(){var _this2=this;var _props=this.props,form=_props.form,errors=_props.errors,onCancel=_props.onCancel;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-respond-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-respond-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'project-open-item-respond-form-label'},'Response'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_autosize_textarea___default.a,{rows:2,className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'text-area':true,'input-area':true,'form-control':true,'project-open-item-respond-form-error-field':errors.response}),placeholder:'Enter Text Here...',onBlur:function onBlur(e){return _this2.handleAttributeChange('response',e.target.value);},defaultValue:form.response})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-respond-form-block project-open-item-respond-form-block-docs'},form.documents&&form.documents.map(function(doc,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'doc-viewer',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'remove-doc-icon',src:__WEBPACK_IMPORTED_MODULE_7_images_remove_png___default.a,alt:'remove',onClick:function onClick(){return _this2.removeDocument(index);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_document_DocumentLink__["a" /* default */],{file:doc,url:doc.url}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_dropzone__["a" /* default */],{accept:'application/pdf, .doc, .docx, .xls, .xlsx',className:'dropzone-container',onDrop:function onDrop(files){return _this2.setDocuments(files);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Please drag and drop any file into this area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6_images_upload_svg___default.a,alt:'upload'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-item-respond-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_image_upload_ImageUpload__["a" /* default */],{extensions:__WEBPACK_IMPORTED_MODULE_11_services_utils_files_util__["a" /* imageExtensions */],multiple:true,onUpload:function onUpload(files){return _this2.setImages(files);},onRemove:function onRemove(index){return _this2.removeImage(index);},images:form.images})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__["a" /* default */],{label:'Save Draft',className:'button-white',onClick:this.handleSaveDraft}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__["a" /* default */],{label:!form.responded_at||form.draft_response?'Submit':'Save',className:'button-orange',onClick:this.handleSave}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_button_Button__["a" /* default */],{label:'Cancel',className:'button-gray',onClick:onCancel})));}}]);return ProjectOpenItemRespondForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProjectOpenItemRespondForm.propTypes={onSave:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{form:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_open_items_store_selectors__["f" /* getOpenItemForm */])(state),errors:Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_open_items_store_selectors__["g" /* getOpenItemFormErrors */])(state)};})(ProjectOpenItemRespondForm));

/***/ }),
/* 2987 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectCloseout_css__ = __webpack_require__(2989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectCloseout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProjectCloseout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_closeout_store_selectors__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_closeout_store_actions__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_closeout_CloseoutTable__ = __webpack_require__(2990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_closeout_CloseoutForm__ = __webpack_require__(2992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_closeout_CloseoutContribForms__ = __webpack_require__(2996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_closeout_CloseoutManualLog__ = __webpack_require__(2999);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectCloseout=function(_Component){_inherits(ProjectCloseout,_Component);function ProjectCloseout(props){_classCallCheck(this,ProjectCloseout);var _this=_possibleConstructorReturn(this,(ProjectCloseout.__proto__||Object.getPrototypeOf(ProjectCloseout)).call(this,props));_this.handleTabSelection=function(tab){_this.setState({tab:tab});_this.loadTabData(tab);};_this.state={tab:1};return _this;}_createClass(ProjectCloseout,[{key:'loadTabData',value:function loadTabData(tab){var _props=this.props,currentProject=_props.currentProject,dispatch=_props.dispatch;if(currentProject){switch(tab){case 1:dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_closeout_store_actions__["d" /* loadCloseoutCatsRequest */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_closeout_store_actions__["h" /* loadCloseoutRequest */])(currentProject.id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_closeout_store_actions__["e" /* loadCloseoutContribsRequest */])(currentProject.id));break;case 2:dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_closeout_store_actions__["g" /* loadCloseoutManualsRequest */])(currentProject.id));break;default:}}}},{key:'componentDidMount',value:function componentDidMount(){this.loadTabData(this.state.tab);}},{key:'render',value:function render(){var closeout=this.props.closeout;var tab=this.state.tab;return closeout&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-closeout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-closeout-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'CLOSEOUT'},{id:2,title:'CLOSEOUT MANUAL'}],selectedValue:tab,onSelected:this.handleTabSelection})),tab===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_closeout_CloseoutForm__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_closeout_CloseoutTable__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_closeout_CloseoutContribForms__["a" /* default */],null)),tab===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_closeout_CloseoutManualLog__["a" /* default */],null));}}]);return ProjectCloseout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),closeout:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_closeout_store_selectors__["a" /* getCloseout */])(state)};})(ProjectCloseout));

/***/ }),
/* 2989 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CloseoutTable_css__ = __webpack_require__(2991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CloseoutTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CloseoutTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_done_svg__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_done_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_done_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_closeout_store_selectors__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_closeout_store_actions__ = __webpack_require__(233);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CloseoutTable=function(_Component){_inherits(CloseoutTable,_Component);function CloseoutTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CloseoutTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CloseoutTable.__proto__||Object.getPrototypeOf(CloseoutTable)).call.apply(_ref,[this].concat(args))),_this),_this.closeoutContribComments=function(closeoutContrib){var misc=closeoutContrib.closeout_contributor_cats.find(function(contribCat){return contribCat.closeout_cat.value==='misc';});var miscComments=misc&&misc.applies&&misc.comments;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,closeoutContrib.comments,miscComments&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,closeoutContrib.comments&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,misc.closeout_cat.label.toUpperCase(),':'),' ',miscComments));},_this.mapCloseoutContribs=function(){var _this$props=_this.props,closeoutContribs=_this$props.closeoutContribs,closeoutCats=_this$props.closeoutCats;return closeoutContribs.map(function(closeoutContrib){return{id:closeoutContrib.id,data:[closeoutContrib.csi_code_division+' '+(closeoutContrib.csi_code_label.length>15?closeoutContrib.csi_code_label.substring(0,15)+'...':closeoutContrib.csi_code_label),closeoutContrib.company_name.length>15?closeoutContrib.company_name.substring(0,15)+'...':closeoutContrib.company_name].concat(closeoutCats.filter(function(closeoutCat){return closeoutCat.value!=='misc';}).map(function(closeoutCat){var closeoutContribCat=closeoutContrib.closeout_contributor_cats.find(function(contribCat){return contribCat.closeout_cat_id===closeoutCat.id;});return closeoutContribCat&&closeoutContribCat.applies?closeoutContribCat.documents.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'checked',src:__WEBPACK_IMPORTED_MODULE_3_images_done_svg___default.a}):'':'N/A';})).concat(_this.closeoutContribComments(closeoutContrib))};});},_this.handlePageChange=function(newPage){var _this$props2=_this.props,currentProject=_this$props2.currentProject,dispatch=_this$props2.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_closeout_store_actions__["e" /* loadCloseoutContribsRequest */])(currentProject.id,newPage));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CloseoutTable,[{key:'render',value:function render(){var _props=this.props,closeoutCats=_props.closeoutCats,currentPage=_props.currentPage,pageSize=_props.pageSize,total=_props.total;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'closeout-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table',headers:['CSI CODE','SUBCONTRACTOR'].concat(closeoutCats.filter(function(closeoutCat){return closeoutCat.value!=='misc';}).map(function(cat){return cat.label.toUpperCase();})).concat('NOTES / COMMENTS'),rows:this.mapCloseoutContribs(),emptyMessage:'No Items'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPage,pageSize:pageSize,total:total,onPageChange:this.handlePageChange})));}}]);return CloseoutTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),closeoutCats:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_closeout_store_selectors__["b" /* getCloseoutCats */])(state),closeoutContribs:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_closeout_store_selectors__["c" /* getCloseoutContribs */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_closeout_store_selectors__["j" /* getCurrentPage */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_closeout_store_selectors__["l" /* getTotal */])(state),pageSize:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_closeout_store_selectors__["k" /* getPageSize */])(state)};})(CloseoutTable));

/***/ }),
/* 2991 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CloseoutForm_css__ = __webpack_require__(2993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CloseoutForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CloseoutForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_modal_MessageModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_closeout_store_selectors__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_closeout_store_actions__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_closeout_PropertyOwnerModal__ = __webpack_require__(2994);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CloseoutForm=function(_Component){_inherits(CloseoutForm,_Component);function CloseoutForm(props){_classCallCheck(this,CloseoutForm);var _this=_possibleConstructorReturn(this,(CloseoutForm.__proto__||Object.getPrototypeOf(CloseoutForm)).call(this,props));_this.initializeForm=function(closeout){if(closeout){return{warrantyDate:closeout.warranty_date,dueDate:closeout.due_date,requestedAt:closeout.requested_at};}};_this.handleAttributeChange=function(attr,value){_this.setState({form:Object.assign({},_this.state.form,_defineProperty({},attr,value))},_this.handleSave);};_this.handleSave=function(){var _this$props=_this.props,currentProject=_this$props.currentProject,dispatch=_this$props.dispatch;var form=_this.state.form;dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_closeout_store_actions__["k" /* updateCloseout */])(currentProject.id,form));};_this.handleRequestConfirmation=function(){_this.setState({showRequestConfirmation:true});};_this.sendRequest=function(){var _this$props2=_this.props,currentProject=_this$props2.currentProject,dispatch=_this$props2.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_closeout_store_actions__["i" /* requestCloseout */])(currentProject.id)).then(function(response){if(response.ok){_this.setState({showRequestConfirmationSuccess:true});}});};_this.handleRequest=function(confirmed){if(confirmed){if(_this.props.currentProject.building.property_owner_name){_this.sendRequest();}else{_this.setState({showPropOwnerModal:true});}}_this.setState({showRequestConfirmation:false});};_this.handleDismissRequestSuccess=function(){_this.setState({showRequestConfirmationSuccess:false});};_this.handlePropOwnerSubmit=function(){_this.sendRequest();_this.setState({showPropOwnerModal:false});};_this.handlePropOwnerClose=function(){_this.setState({showPropOwnerModal:false});};_this.state={form:_this.initializeForm(props.closeout),showRequestConfirmation:false,showRequestConfirmationSuccess:false,showPropOwnerModal:false};return _this;}_createClass(CloseoutForm,[{key:'UNSAFE_componentWillReceiveProps',value:function UNSAFE_componentWillReceiveProps(newProps){var closeout=this.props.closeout;var newCloseout=newProps.closeout;if(closeout!==newCloseout){this.setState({form:this.initializeForm(newCloseout)});}}},{key:'render',value:function render(){var _this2=this;var currentProject=this.props.currentProject;var _state=this.state,form=_state.form,showRequestConfirmation=_state.showRequestConfirmation,showRequestConfirmationSuccess=_state.showRequestConfirmationSuccess,showPropOwnerModal=_state.showPropOwnerModal;var readOnly=currentProject&&!__WEBPACK_IMPORTED_MODULE_9_domain_enterprise__["a" /* Enterprise */].spackleOrGc(currentProject.contributor_type);return form&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'closeout-form'},form.requestedAt&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'closeout-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'closeout-form-label'},'Requested On'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Date__["a" /* default */],{value:form.requestedAt,format:'MM/DD/YY'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'closeout-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'closeout-form-label'},'Warranty Date'),readOnly?form.warrantyDate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Date__["a" /* default */],{value:form.warrantyDate,format:'MM/DD/YY'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{placeholder:'Warranty Date',onChange:function onChange(value){return _this2.handleAttributeChange('warrantyDate',value);},value:form.warrantyDate})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'closeout-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'closeout-form-label'},'Closeout Due Date'),readOnly?form.dueDate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Date__["a" /* default */],{value:form.dueDate,format:'MM/DD/YY'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:__WEBPACK_IMPORTED_MODULE_8_services_utils_date_util__["k" /* todayValidation */],placeholder:'Due Date',onChange:function onChange(value){return _this2.handleAttributeChange('dueDate',value);},value:form.dueDate})),!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'closeout-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:form.requestedAt?'Request Again':'Request Closeout',disabled:!form.warrantyDate||!form.dueDate,onClick:this.handleRequestConfirmation}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),showRequestConfirmation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_modal_ConfirmationModal__["a" /* default */],{show:showRequestConfirmation,message:'Are you sure you want to send the Closeout Request email notification?',onHide:this.handleRequest}),showRequestConfirmationSuccess&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_modal_MessageModal__["a" /* default */],{show:showRequestConfirmationSuccess,message:'An email has been sent to subcontractors requesting them to start uploading their Closeout documents.',onHide:this.handleDismissRequestSuccess}),showPropOwnerModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_closeout_PropertyOwnerModal__["a" /* default */],{show:showPropOwnerModal,onSubmit:this.handlePropOwnerSubmit,onClose:this.handlePropOwnerClose}));}}]);return CloseoutForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),closeout:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_closeout_store_selectors__["a" /* getCloseout */])(state)};})(CloseoutForm));

/***/ }),
/* 2993 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropertyOwnerModal_css__ = __webpack_require__(2995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropertyOwnerModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PropertyOwnerModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_closeout_store_actions__ = __webpack_require__(233);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PropertyOwnerModal=function(_Component){_inherits(PropertyOwnerModal,_Component);function PropertyOwnerModal(props){_classCallCheck(this,PropertyOwnerModal);var _this=_possibleConstructorReturn(this,(PropertyOwnerModal.__proto__||Object.getPrototypeOf(PropertyOwnerModal)).call(this,props));_this.initForm=function(building){return{name:building.property_owner_name||'',locationId:building.property_owner_address&&building.property_owner_address.id,streetAddress1:building.property_owner_address&&building.property_owner_address.street_address_1||'',streetAddress2:building.property_owner_address&&building.property_owner_address.street_address_2||'',city:building.property_owner_address&&building.property_owner_address.city||'',state:building.property_owner_address&&building.property_owner_address.state||'',zip:building.property_owner_address&&building.property_owner_address.zip||''};};_this.mapBuildingData=function(){var form=_this.state.form;var currentProject=_this.props.currentProject;var building=currentProject.building;return{propOwnerName:form.name,propOwnerAddress:{id:form.locationId,streetAddress:form.streetAddress1,unitNumber:form.streetAddress2,city:form.city,state:form.state,zipCode:form.zip},location:{id:building.location.id,streetAddress:building.location.street_address_1,unitNumber:building.location.street_address_2||'',city:building.location.city,state:building.location.state,zipCode:building.location.zip}};};_this.handleSubmit=function(event){event.preventDefault();var _this$props=_this.props,currentProject=_this$props.currentProject,onSubmit=_this$props.onSubmit,dispatch=_this$props.dispatch;var values=_this.mapBuildingData();dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_closeout_store_actions__["j" /* updateBuilding */])(currentProject.building.id,values)).then(function(response){if(response.ok){onSubmit();}});};_this.handleFormChange=function(attribute,value){var form=_this.state.form;_this.setState({form:Object.assign({},form,_defineProperty({},attribute,value))});};_this.formValid=function(){var form=_this.state.form;return!!form.name&&!!form.streetAddress1&&!!form.city&&!!form.state&&!!form.zip;};_this.state={form:_this.initForm(props.currentProject.building)};return _this;}_createClass(PropertyOwnerModal,[{key:'render',value:function render(){var form=this.state.form;var _props=this.props,show=_props.show,onClose=_props.onClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'property-owner-form-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_modal_FormModal__["a" /* default */],{className:'property-owner-modal',show:show,title:'Please provide the Property Owner information.',onClose:onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["g" /* Form */],{horizontal:true,onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'Property Owner Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{id:'name',placeholder:'Property Owner Name',value:form.name,theme:'normal',onChange:this.handleFormChange.bind(this,'name')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'Address Line 1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{id:'street-address-1',placeholder:'Street Address',value:form.streetAddress1,theme:'normal',onChange:this.handleFormChange.bind(this,'streetAddress1')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'Address Line 2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{id:'street-address-2',placeholder:'Unit number / Floor',value:form.streetAddress2,theme:'normal',onChange:this.handleFormChange.bind(this,'streetAddress2')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'City'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{id:'city',placeholder:'City',theme:'normal',value:form.city,onChange:this.handleFormChange.bind(this,'city')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* ControlLabel */],sm:4},'State / Zip'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{id:'state',placeholder:'State',value:form.state,theme:'normal',onChange:this.handleFormChange.bind(this,'state')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_input_Input__["a" /* default */],{id:'zip',placeholder:'Zip',value:form.zip,theme:'normal',onChange:this.handleFormChange.bind(this,'zip')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* FormGroup */],{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-continue '+(this.formValid()?'button-orange':'button-disabled'),type:'submit',value:'Add',disabled:!this.formValid()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-gray',value:'Cancel',onClick:onClose,readOnly:true}))))));}}]);return PropertyOwnerModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PropertyOwnerModal.propTypes={show:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state)};})(PropertyOwnerModal));

/***/ }),
/* 2995 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_closeout_store_selectors__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_closeout_CloseoutContribForm__ = __webpack_require__(2997);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CloseoutContribForms=function(_Component){_inherits(CloseoutContribForms,_Component);function CloseoutContribForms(){_classCallCheck(this,CloseoutContribForms);return _possibleConstructorReturn(this,(CloseoutContribForms.__proto__||Object.getPrototypeOf(CloseoutContribForms)).apply(this,arguments));}_createClass(CloseoutContribForms,[{key:'render',value:function render(){var closeoutContribs=this.props.closeoutContribs;return closeoutContribs.map(function(closeoutContrib){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:closeoutContrib.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_details_project_closeout_CloseoutContribForm__["a" /* default */],{closeoutContrib:closeoutContrib}));});}}]);return CloseoutContribForms;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{closeoutContribs:Object(__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_details_project_closeout_store_selectors__["c" /* getCloseoutContribs */])(state)};})(CloseoutContribForms));

/***/ }),
/* 2997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CloseoutContribForm_css__ = __webpack_require__(2998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CloseoutContribForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CloseoutContribForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_react_fontawesome__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_solid_faAngleDown__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_solid_faAngleDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_solid_faAngleDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_free_solid_faAngleUp__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_free_solid_faAngleUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_free_solid_faAngleUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_upload_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_images_upload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_autosize_textarea__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_autosize_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_autosize_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_checkbox_LabeledCheckBox__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_shared_modal_ConfirmationModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_shared_modal_MessageModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_images_invalid_png__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_images_invalid_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_images_invalid_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_project_closeout_store_actions__ = __webpack_require__(233);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CloseoutContribForm=function(_Component){_inherits(CloseoutContribForm,_Component);function CloseoutContribForm(props){_classCallCheck(this,CloseoutContribForm);var _this=_possibleConstructorReturn(this,(CloseoutContribForm.__proto__||Object.getPrototypeOf(CloseoutContribForm)).call(this,props));_initialiseProps.call(_this);var currentProject=props.currentProject;_this.state={contribForm:_this.initializeContribForm(props.closeoutContrib),showForm:currentProject&&__WEBPACK_IMPORTED_MODULE_18_domain_enterprise__["a" /* Enterprise */].subcontractor(currentProject.contributor_type),showRemoveConfirmation:false,showInvalidDocsMsg:false};return _this;}_createClass(CloseoutContribForm,[{key:'UNSAFE_componentWillReceiveProps',value:function UNSAFE_componentWillReceiveProps(newProps){var closeoutContrib=this.props.closeoutContrib;var newCloseoutContrib=newProps.closeoutContrib;if(closeoutContrib!==newCloseoutContrib){this.setState({contribForm:this.initializeContribForm(newCloseoutContrib)});}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,currentProject=_props.currentProject,closeoutContrib=_props.closeoutContrib;var _state=this.state,contribForm=_state.contribForm,showForm=_state.showForm,showRemoveConfirmation=_state.showRemoveConfirmation,showInvalidDocsMsg=_state.showInvalidDocsMsg;var subcontractor=currentProject&&__WEBPACK_IMPORTED_MODULE_18_domain_enterprise__["a" /* Enterprise */].subcontractor(currentProject.contributor_type);var readOnly=currentProject&&__WEBPACK_IMPORTED_MODULE_18_domain_enterprise__["a" /* Enterprise */].primary(currentProject.contributor_type);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'closeout-contrib-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'closeout-contrib-form-header',onClick:this.showForm},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'closeout-contrib-form-toggle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__fortawesome_react_fontawesome__["a" /* default */],{icon:showForm?__WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_free_solid_faAngleUp___default.a:__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_solid_faAngleDown___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,closeoutContrib.csi_code_division,' ',closeoutContrib.csi_code_label,!subcontractor&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ','- ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,closeoutContrib.company_name)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Collapse */],{'in':showForm,className:'collapse-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'closeout-contrib-form-container'},showForm&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'closeout-contrib-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'closeout-contrib-form-label'},'Notes / Comments'),readOnly?contribForm.comments:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_autosize_textarea___default.a,{rows:2,className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'text-area':true,'input-area':true,'form-control':true}),placeholder:'Enter Text Here...',onBlur:function onBlur(e){return _this2.handleContribFormChange('comments',e.target.value,_this2.handleSave);},defaultValue:contribForm.comments})),closeoutContrib.closeout_contributor_cats.sort(function(contribCat1,contribCat2){return contribCat1.id<contribCat2.id?-1:1;}).map(function(contribCat){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:contribCat.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,contribCat.closeout_cat.label)),readOnly?!contribForm[contribCat.id].applies&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'closeout-contrib-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'closeout-contrib-form-label'},'Not Applicable')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'closeout-contrib-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'closeout-contrib-form-label'},'Not Applicable'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{onChange:function onChange(value){return _this2.handleContribFormCatChange(contribCat.id,'applies',!value,_this2.handleSave);},checked:!contribForm[contribCat.id].applies})),contribForm[contribCat.id].applies&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,contribCat.closeout_cat.value==='misc'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'closeout-contrib-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'closeout-contrib-form-label'},'Notes / Comments'),readOnly?contribForm[contribCat.id].comments:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_autosize_textarea___default.a,{rows:2,className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'text-area':true,'input-area':true,'form-control':true}),placeholder:'Enter Text Here...',onBlur:function onBlur(e){return _this2.handleContribFormCatChange(contribCat.id,'comments',e.target.value,_this2.handleSave);},defaultValue:contribForm[contribCat.id].comments})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'closeout-contrib-form-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'closeout-contrib-form-label'},'Documents'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'closeout-contrib-form-block-docs'},contribForm[contribCat.id]&&contribForm[contribCat.id].documents&&contribForm[contribCat.id].documents.map(function(doc,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'doc-viewer',key:index},!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'remove-doc-icon',src:__WEBPACK_IMPORTED_MODULE_9_images_remove_png___default.a,alt:'remove',onClick:function onClick(){return _this2.confirmRemoveDocument(contribCat.id,index);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_document_DocumentLink__["a" /* default */],{file:doc,url:doc.url}));}),!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_dropzone__["a" /* default */],{accept:'application/pdf',className:'dropzone-container',onDropAccepted:function onDropAccepted(files){return _this2.setDocuments(contribCat.id,files);},onDropRejected:_this2.handleShowInvalidDocsMsg},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10_images_upload_svg___default.a,alt:'upload'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Please drag and drop any PDF file into this area')))))));}),showRemoveConfirmation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_modal_ConfirmationModal__["a" /* default */],{show:showRemoveConfirmation,message:'Are you sure you want to delete this document?',onHide:this.removeDocument}),showInvalidDocsMsg&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_shared_modal_MessageModal__["a" /* default */],{show:showInvalidDocsMsg,icon:__WEBPACK_IMPORTED_MODULE_17_images_invalid_png___default.a,message:'File format not supported. Please try uploading again as PDF.',onHide:this.handleDismissInvalidDocsMsg})))));}}]);return CloseoutContribForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CloseoutContribForm.propTypes={closeoutContrib:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired};var _initialiseProps=function _initialiseProps(){var _this3=this;this.initializeContribForm=function(closeoutContrib){var contribForm={comments:closeoutContrib.comments};closeoutContrib.closeout_contributor_cats.forEach(function(contribCat){contribForm[contribCat.id]={};contribForm[contribCat.id].documents=contribCat.documents.map(function(doc){return Object.assign({},doc,{url:doc.document.url});});contribForm[contribCat.id].applies=contribCat.applies;contribForm[contribCat.id].comments=contribCat.comments;});return contribForm;};this.handleContribFormChange=function(attr,value,callback){_this3.setState({contribForm:Object.assign({},_this3.state.contribForm,_defineProperty({},attr,value))},callback);};this.handleContribFormCatChange=function(categoryId,attr,value,callback){_this3.setState({contribForm:Object.assign({},_this3.state.contribForm,_defineProperty({},categoryId,Object.assign({},_this3.state.contribForm[categoryId],_defineProperty({},attr,value))))},callback);};this.getArrayAttribute=function(categoryId,attr){var contribForm=_this3.state.contribForm;var contribFormCat=contribForm[categoryId];if(contribFormCat&&contribFormCat[attr]&&contribFormCat[attr].length>0){return contribFormCat[attr];}return[];};this.setDocuments=function(categoryId,files){var docs=[].concat(_toConsumableArray(_this3.getArrayAttribute(categoryId,'documents')));files.forEach(function(val){docs.push({file:val,name:val.name});});_this3.handleContribFormCatChange(categoryId,'documents',docs,_this3.handleSave);};this.removeDocument=function(confirmed){if(confirmed){var _state2=_this3.state,categoryId=_state2.categoryId,index=_state2.index;var docs=[].concat(_toConsumableArray(_this3.getArrayAttribute(categoryId,'documents')));var deletedDocs=[].concat(_toConsumableArray(_this3.getArrayAttribute(categoryId,'deletedDocuments')));var deletedDoc=docs.splice(index,1);deletedDocs.push(deletedDoc[0]);_this3.handleContribFormCatChange(categoryId,'documents',docs,function(){return _this3.handleContribFormCatChange(categoryId,'deletedDocuments',deletedDocs,_this3.handleSave);});}_this3.setState({showRemoveConfirmation:false});};this.confirmRemoveDocument=function(categoryId,index){_this3.setState({showRemoveConfirmation:true,categoryId:categoryId,index:index});};this.handleSave=function(){var _props2=_this3.props,currentProject=_props2.currentProject,closeoutContrib=_props2.closeoutContrib,dispatch=_props2.dispatch;var contribForm=_this3.state.contribForm;dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_project_closeout_store_actions__["l" /* updateCloseoutContrib */])(currentProject.id,closeoutContrib,contribForm)).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_project_closeout_store_actions__["a" /* closeoutPercentage */])(currentProject.id));}});};this.showForm=function(){_this3.setState({showForm:!_this3.state.showForm});};this.handleShowInvalidDocsMsg=function(){_this3.setState({showInvalidDocsMsg:true});};this.handleDismissInvalidDocsMsg=function(){_this3.setState({showInvalidDocsMsg:false});};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state)};})(CloseoutContribForm));

/***/ }),
/* 2998 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CloseoutManualLog_css__ = __webpack_require__(3000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CloseoutManualLog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CloseoutManualLog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_simple_loading_gif__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_simple_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_simple_loading_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_closeout_store_selectors__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_closeout_store_actions__ = __webpack_require__(233);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CloseoutManualLog=function(_Component){_inherits(CloseoutManualLog,_Component);function CloseoutManualLog(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CloseoutManualLog);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CloseoutManualLog.__proto__||Object.getPrototypeOf(CloseoutManualLog)).call.apply(_ref,[this].concat(args))),_this),_this.fetchCloseoutManual=function(){var _this$props=_this.props,currentProject=_this$props.currentProject,closeoutManual=_this$props.closeoutManual,dispatch=_this$props.dispatch;if(closeoutManual&&!closeoutManual.document){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_closeout_store_actions__["f" /* loadCloseoutManual */])(currentProject.id,closeoutManual.id));}},_this.mapCloseoutManuals=function(){var closeoutManuals=_this.props.closeoutManuals;var readOnly=_this.readOnly();return closeoutManuals.map(function(closeoutManual){return{id:closeoutManual.id,data:[closeoutManual.number,closeoutManual.document?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__["a" /* default */],{value:closeoutManual.document.created_at,format:'MM/DD/YYYY'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'processing',src:__WEBPACK_IMPORTED_MODULE_3_images_simple_loading_gif___default.a,alt:'processing'}),closeoutManual.document?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_document_DocumentLink__["a" /* default */],{url:closeoutManual.document.document.url}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'processing',src:__WEBPACK_IMPORTED_MODULE_3_images_simple_loading_gif___default.a,alt:'processing'}),!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{className:'button-white closeout-manual-delete',label:'Delete',disabled:!closeoutManual.document,onClick:function onClick(){return _this.handleDeleteManual(closeoutManual.id);}})]};});},_this.handlePageChange=function(newPage){var _this$props2=_this.props,currentProject=_this$props2.currentProject,dispatch=_this$props2.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_closeout_store_actions__["g" /* loadCloseoutManualsRequest */])(currentProject.id,newPage));},_this.handleCreateManual=function(){var _this$props3=_this.props,currentProject=_this$props3.currentProject,dispatch=_this$props3.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_closeout_store_actions__["b" /* createCloseoutManual */])(currentProject.id));},_this.handleDeleteManual=function(id){var _this$props4=_this.props,currentProject=_this$props4.currentProject,dispatch=_this$props4.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_closeout_store_actions__["c" /* deleteCloseoutManual */])(currentProject.id,id));},_this.readOnly=function(){var currentProject=_this.props.currentProject;return currentProject&&!__WEBPACK_IMPORTED_MODULE_9_domain_enterprise__["a" /* Enterprise */].spackleOrGc(currentProject.contributor_type);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CloseoutManualLog,[{key:'componentDidMount',value:function componentDidMount(){var intervalId=setInterval(this.fetchCloseoutManual,5000);this.setState({intervalId:intervalId});}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.state.intervalId);}},{key:'render',value:function render(){var _props=this.props,closeoutPercentage=_props.closeoutPercentage,closeoutManual=_props.closeoutManual,currentPage=_props.currentPage,pageSize=_props.pageSize,total=_props.total;var readOnly=this.readOnly();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'closeout-manual-log'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'closeout-manual-create'},!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_button_Button__["a" /* default */],{className:'button-orange',label:'Create Manual',disabled:closeoutPercentage<100||closeoutManual&&!closeoutManual.document,onClick:this.handleCreateManual})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table',headers:['#','CREATED','LINK',''],rows:this.mapCloseoutManuals(),emptyMessage:'No Items'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPage,pageSize:pageSize,total:total,onPageChange:this.handlePageChange})));}}]);return CloseoutManualLog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),closeoutPercentage:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_closeout_store_selectors__["i" /* getCloseoutPercentage */])(state),closeoutManual:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_closeout_store_selectors__["d" /* getCloseoutManual */])(state),closeoutManuals:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_closeout_store_selectors__["e" /* getCloseoutManuals */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_closeout_store_selectors__["f" /* getCloseoutManualsCurrentPage */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_closeout_store_selectors__["h" /* getCloseoutManualsTotal */])(state),pageSize:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_closeout_store_selectors__["g" /* getCloseoutManualsPageSize */])(state)};})(CloseoutManualLog));

/***/ }),
/* 3000 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CoiExps_css__ = __webpack_require__(3002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CoiExps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CoiExps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_coi_exps_store_selectors__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_coi_exps_store_actions__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_coi_exps_CoiExp__ = __webpack_require__(3006);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CoiExps=function(_Component){_inherits(CoiExps,_Component);function CoiExps(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CoiExps);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CoiExps.__proto__||Object.getPrototypeOf(CoiExps)).call.apply(_ref,[this].concat(args))),_this),_this.handleNavSelect=function(){_this.handlePageChange(1);},_this.handlePageChange=function(page){var _this$props=_this.props,currentProject=_this$props.currentProject,dispatch=_this$props.dispatch;if(currentProject){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_coi_exps_store_actions__["e" /* loadCoiExpsRequest */])(currentProject.id,page));}},_this.loadLiabilities=function(){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_project_coi_exps_store_actions__["f" /* loadLiabilitiesRequest */])());},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CoiExps,[{key:'componentDidMount',value:function componentDidMount(){this.handlePageChange(1);this.loadLiabilities();}},{key:'render',value:function render(){var _props=this.props,currentProject=_props.currentProject,coiExps=_props.coiExps,coiExpsTotal=_props.coiExpsTotal,coiExpsCurrentPage=_props.coiExpsCurrentPage,coiExpsPageSize=_props.coiExpsPageSize,liabilities=_props.liabilities;var readOnly=currentProject&&__WEBPACK_IMPORTED_MODULE_3_domain_enterprise__["a" /* Enterprise */].primary(currentProject.contributor_type);return coiExps&&liabilities&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-documentation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'coi-exps'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'coi-exps-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'COIs'}],selectedValue:1,onSelected:this.handleNavSelect})),coiExps.map(function(coiExp,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:coiExp.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_coi_exps_CoiExp__["a" /* default */],{coiExp:coiExp,readOnly:readOnly,index:index}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:coiExpsCurrentPage,pageSize:coiExpsPageSize,total:coiExpsTotal,onPageChange:this.handlePageChange}))));}}]);return CoiExps;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),coiExps:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_coi_exps_store_selectors__["b" /* getCoiExps */])(state),coiExpsTotal:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_coi_exps_store_selectors__["e" /* getCoiExpsTotal */])(state),coiExpsCurrentPage:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_coi_exps_store_selectors__["c" /* getCoiExpsCurrentPage */])(state),coiExpsPageSize:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_coi_exps_store_selectors__["d" /* getCoiExpsPageSize */])(state),liabilities:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_details_project_coi_exps_store_selectors__["f" /* getLiabilities */])(state)};})(CoiExps));

/***/ }),
/* 3002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return coiExpsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CoiExpsApi=function(_BaseApi){_inherits(CoiExpsApi,_BaseApi);function CoiExpsApi(){_classCallCheck(this,CoiExpsApi);return _possibleConstructorReturn(this,(CoiExpsApi.__proto__||Object.getPrototypeOf(CoiExpsApi)).apply(this,arguments));}_createClass(CoiExpsApi,[{key:'getCoiExps',value:function getCoiExps(projectId){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/coi_exps?page='+page+'&per_page=8').then(function(response){return{ok:true,coiExps:response.data,coiExpsTotal:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),coiExpsPageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'getCoiExp',value:function getCoiExp(projectId,coiExpId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/projects/'+projectId+'/coi_exps/'+coiExpId).then(function(response){return{ok:true,coiExp:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return CoiExpsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var coiExpsApi=new CoiExpsApi();

/***/ }),
/* 3004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return coiExpDocsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CoiExpDocsApi=function(_BaseApi){_inherits(CoiExpDocsApi,_BaseApi);function CoiExpDocsApi(){_classCallCheck(this,CoiExpDocsApi);return _possibleConstructorReturn(this,(CoiExpDocsApi.__proto__||Object.getPrototypeOf(CoiExpDocsApi)).apply(this,arguments));}_createClass(CoiExpDocsApi,[{key:'getCoiExpDocs',value:function getCoiExpDocs(coiExpId){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var query='page='+page+'&per_page=5';return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/coi_exps/'+coiExpId+'/coi_exp_docs?'+query).then(function(response){return{ok:true,coiExpDocs:response.data,coiExpDocsTotal:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),coiExpDocsPageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'createCoiExpDoc',value:function createCoiExpDoc(coiExpId,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var data=this.coiExpDocParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/coi_exps/'+coiExpId+'/coi_exp_docs',data,headers).then(function(response){return{ok:true,coiExpDoc:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'updateCoiExpDoc',value:function updateCoiExpDoc(coiExpId,values){var headers={headers:{'Content-Type':'multipart/form-data'}};var data=this.coiExpDocParams(values);return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.baseUrl+'/coi_exps/'+coiExpId+'/coi_exp_docs/'+values.id,data,headers).then(function(response){return{ok:true,coiExpDoc:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'destroyCoiExpDoc',value:function destroyCoiExpDoc(coiExpId,coiExpDocId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(this.baseUrl+'/coi_exps/'+coiExpId+'/coi_exp_docs/'+coiExpDocId).then(function(response){return{ok:true};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'coiExpDocParams',value:function coiExpDocParams(values){var apiPayload=new FormData();apiPayload.append('coi_exp_doc[subcategory]',values.subcategory);if(!values.id){apiPayload.append('coi_exp_doc[document_attributes][document]',values.coiExpDocFile,values.coiExpDocFile.name);}values.coiExpDocLiabilities.forEach(function(coiExpDocLiability,index){if(coiExpDocLiability.id){apiPayload.append('coi_exp_doc[coi_exp_doc_liabilities_attributes]['+index+'][id]',coiExpDocLiability.id);apiPayload.append('coi_exp_doc[coi_exp_doc_liabilities_attributes]['+index+'][_destroy]',coiExpDocLiability.destroy);}if(!coiExpDocLiability.destroy){apiPayload.append('coi_exp_doc[coi_exp_doc_liabilities_attributes]['+index+'][liability_id]',coiExpDocLiability.liabilityId);apiPayload.append('coi_exp_doc[coi_exp_doc_liabilities_attributes]['+index+'][exp_date]',coiExpDocLiability.expDate);}});return apiPayload;}}]);return CoiExpDocsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var coiExpDocsApi=new CoiExpDocsApi();

/***/ }),
/* 3005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return liabilitiesApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LiabilitiesApi=function(_BaseApi){_inherits(LiabilitiesApi,_BaseApi);function LiabilitiesApi(){_classCallCheck(this,LiabilitiesApi);return _possibleConstructorReturn(this,(LiabilitiesApi.__proto__||Object.getPrototypeOf(LiabilitiesApi)).apply(this,arguments));}_createClass(LiabilitiesApi,[{key:'getLiabilities',value:function getLiabilities(){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/liabilities').then(function(response){return{ok:true,liabilities:response.data};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return LiabilitiesApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var liabilitiesApi=new LiabilitiesApi();

/***/ }),
/* 3006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faAngleDown__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faAngleDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faAngleDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_solid_faAngleUp__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_solid_faAngleUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_solid_faAngleUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CoiExp_css__ = __webpack_require__(3007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CoiExp_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__CoiExp_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_coi_exps_store_selectors__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_coi_exps_store_actions__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_coi_exps_CoiExpDocs__ = __webpack_require__(3008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CoiExp=function(_Component){_inherits(CoiExp,_Component);function CoiExp(props){_classCallCheck(this,CoiExp);var _this=_possibleConstructorReturn(this,(CoiExp.__proto__||Object.getPrototypeOf(CoiExp)).call(this,props));_this.expiresSoon=function(coiExpLiability){return coiExpLiability&&__WEBPACK_IMPORTED_MODULE_14_moment___default()().diff(coiExpLiability.exp_date,'days')>-2;};_this.expired=function(coiExpLiability){return coiExpLiability&&__WEBPACK_IMPORTED_MODULE_14_moment___default()().diff(coiExpLiability.exp_date,'days')>=0;};_this.mapCoiExpLiabilities=function(){var _this$props=_this.props,coiExp=_this$props.coiExp,liabilities=_this$props.liabilities;var coiExpLiabilities=coiExp.coi_exp_liabilities;return[liabilities.map(function(liability){var coiExpLiability=coiExpLiabilities.find(function(expLiability){return expLiability.liability_id===liability.id;});return coiExpLiability&&coiExpLiability.exp_date?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_text_Date__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_9_classnames___default()({'expires-soon':_this.expiresSoon(coiExpLiability),expired:_this.expired(coiExpLiability)}),value:coiExpLiability.exp_date,format:'MM/DD/YYYY'}):'N/A';})];};_this.handleCoiExpDocsPageChange=function(page){var _this$props2=_this.props,coiExp=_this$props2.coiExp,dispatch=_this$props2.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_coi_exps_store_actions__["c" /* loadCoiExpDocsRequest */])(coiExp.id,page));};_this.showForm=function(){if(!_this.state.showForm){_this.handleCoiExpDocsPageChange(1,'client_landlord');}_this.setState({showForm:!_this.state.showForm});};_this.formattedCsiCode=function(){var coiExp=_this.props.coiExp;return coiExp.csi_code_division+' '+coiExp.csi_code_label;};_this.state={showForm:false,readOnly:true,index:0};return _this;}_createClass(CoiExp,[{key:'render',value:function render(){var _props=this.props,liabilities=_props.liabilities,coiExp=_props.coiExp,coiExpDocs=_props.coiExpDocs,readOnly=_props.readOnly,index=_props.index;var showForm=this.state.showForm;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'coi-exp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'coi-exp-header',onClick:this.showForm},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'coi-exp-header-col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'coi-exp-toggle-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'coi-exp-toggle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome__["a" /* default */],{icon:showForm?__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_solid_faAngleUp___default.a:__WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_solid_faAngleDown___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,this.formattedCsiCode(),' - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,coiExp.company_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navigation-item selected'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'coi-exp-total'},coiExp.coi_exp_docs_count))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'coi-exp-header-col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_9_classnames___default()({'projects-table':true,'coi-exp-table':true,first:index===0}),headers:liabilities.map(function(liability){return liability.short_label;}),rows:this.mapCoiExpLiabilities(),emptyMessage:'No Exp. Dates'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Collapse */],{'in':showForm,className:'collapse-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'coi-exp-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_coi_exps_CoiExpDocs__["a" /* default */],{coiExpId:coiExp.id,coiExpDocs:coiExpDocs&&coiExpDocs[coiExp.id],readOnly:readOnly,onPageChange:this.handleCoiExpDocsPageChange}))));}}]);return CoiExp;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CoiExp.propTypes={coiExp:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,index:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{liabilities:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_coi_exps_store_selectors__["f" /* getLiabilities */])(state),coiExpDocs:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_coi_exps_store_selectors__["a" /* getCoiExpDocs */])(state)};})(CoiExp));

/***/ }),
/* 3007 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CoiExpDocs_css__ = __webpack_require__(3009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CoiExpDocs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CoiExpDocs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_remove_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_upload_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_upload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_coi_exps_store_selectors__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_coi_exps_store_actions__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dropzone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_document_DocumentLink__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_coi_exps_CoiExpDocModal__ = __webpack_require__(3010);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CoiExpDocs=function(_Component){_inherits(CoiExpDocs,_Component);function CoiExpDocs(props){_classCallCheck(this,CoiExpDocs);var _this=_possibleConstructorReturn(this,(CoiExpDocs.__proto__||Object.getPrototypeOf(CoiExpDocs)).call(this,props));_this.handlePageChange=function(page){var onPageChange=_this.props.onPageChange;onPageChange(page);};_this.expiresSoon=function(coiExpDocLiability){return coiExpDocLiability&&__WEBPACK_IMPORTED_MODULE_15_moment___default()().diff(coiExpDocLiability.exp_date,'days')>-2;};_this.expired=function(coiExpDocLiability){return coiExpDocLiability&&__WEBPACK_IMPORTED_MODULE_15_moment___default()().diff(coiExpDocLiability.exp_date,'days')>=0;};_this.mapCoiExpDocs=function(){var _this$props=_this.props,coiExpDocs=_this$props.coiExpDocs,liabilities=_this$props.liabilities,readOnly=_this$props.readOnly;var coiExpDocsList=coiExpDocs.coiExpDocs;return coiExpDocsList.map(function(coiExpDoc){return{id:coiExpDoc.id,data:[!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'doc-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'remove-doc-icon',src:__WEBPACK_IMPORTED_MODULE_5_images_remove_png___default.a,alt:'remove',onClick:function onClick(event){return _this.handleRemoveCoiExpDoc(event,coiExpDoc);}}),coiExpDoc.subcategory==='client_landlord'?'Client/Landlord':'General Contractor'),coiExpDoc.document&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_document_DocumentLink__["a" /* default */],{url:coiExpDoc.document.document.url})].concat(_toConsumableArray(liabilities.map(function(liability){var docLiability=coiExpDoc.coi_exp_doc_liabilities.find(function(coiExpDocLiability){return coiExpDocLiability.liability_id===liability.id;});return docLiability?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_text_Date__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({'expires-soon':_this.expiresSoon(docLiability),expired:_this.expired(docLiability)}),value:docLiability.exp_date,format:'MM/DD/YYYY'}):'N/A';}))).filter(function(col){return!!col;})};});};_this.handleDrop=function(files){_this.setState({showCoiExpDocModal:true,coiExpDocFile:files[0],coiExpDoc:null});};_this.handleCloseCoiExpDocModal=function(){_this.setState({showCoiExpDocModal:false,coiExpDocFile:null,coiExpDoc:null});};_this.handleRowSelected=function(id){var coiExpDocs=_this.props.coiExpDocs.coiExpDocs;var coiExpDoc=coiExpDocs.find(function(coiExpDoc){return coiExpDoc.id===id;});_this.setState({showCoiExpDocModal:true,coiExpDocFile:null,coiExpDoc:coiExpDoc});};_this.handleSubmitCoiExpDoc=function(_ref){var subcategory=_ref.subcategory,coiExpDocLiabilities=_ref.coiExpDocLiabilities;var _this$props2=_this.props,currentProject=_this$props2.currentProject,coiExpId=_this$props2.coiExpId,dispatch=_this$props2.dispatch;var _this$state=_this.state,coiExpDocFile=_this$state.coiExpDocFile,coiExpDoc=_this$state.coiExpDoc;var values={coiExpDocFile:coiExpDocFile,subcategory:subcategory,coiExpDocLiabilities:coiExpDocLiabilities};var promise=null;if(coiExpDocFile&&!coiExpDoc){promise=dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_coi_exps_store_actions__["a" /* createCoiExpDoc */])(coiExpId,values));}else if(coiExpDoc&&!coiExpDocFile){promise=dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_coi_exps_store_actions__["g" /* updateCoiExpDoc */])(coiExpId,Object.assign({id:coiExpDoc.id},values)));}promise&&promise.then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_coi_exps_store_actions__["d" /* loadCoiExpRequest */])(currentProject.id,coiExpId));_this.handleCloseCoiExpDocModal();}});};_this.handleRemoveCoiExpDoc=function(event,coiExpDoc){event.stopPropagation();var confirmed=window.confirm('Are you sure?');if(confirmed){var _this$props3=_this.props,currentProject=_this$props3.currentProject,coiExpId=_this$props3.coiExpId,dispatch=_this$props3.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_coi_exps_store_actions__["b" /* destroyCoiExpDoc */])(coiExpId,coiExpDoc)).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_coi_exps_store_actions__["d" /* loadCoiExpRequest */])(currentProject.id,coiExpId));}});}};_this.state={showCoiExpDocModal:false,coiExpDocFile:null,currentCoiExpDoc:null};return _this;}_createClass(CoiExpDocs,[{key:'render',value:function render(){var _props=this.props,coiExpDocs=_props.coiExpDocs,liabilities=_props.liabilities,readOnly=_props.readOnly;var coiExpDocsTotal=coiExpDocs.coiExpDocsTotal,coiExpDocsCurrentPage=coiExpDocs.coiExpDocsCurrentPage,coiExpDocsPageSize=coiExpDocs.coiExpDocsPageSize;var _state=this.state,showCoiExpDocModal=_state.showCoiExpDocModal,coiExpDoc=_state.coiExpDoc;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'coi-exp-docs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_table_SimpleTable__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({'projects-table':true,'coi-exp-docs-table':true,'read-only':readOnly}),headers:[!readOnly&&'CERT HOLDER','FILENAME'].concat(_toConsumableArray(liabilities.map(function(liability){return liability.short_label;}))).filter(function(header){return!!header;}),rows:this.mapCoiExpDocs(),emptyMessage:'No Documents',onRowSelected:this.handleRowSelected}),!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_dropzone__["a" /* default */],{accept:'application/pdf',className:'dropzone-container',multiple:false,onDrop:this.handleDrop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6_images_upload_svg___default.a,alt:'upload'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Please drag and drop any file into this area'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:coiExpDocsCurrentPage,pageSize:coiExpDocsPageSize,total:coiExpDocsTotal,onPageChange:this.handlePageChange})),showCoiExpDocModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_coi_exps_CoiExpDocModal__["a" /* default */],{initialValues:coiExpDoc,showModal:showCoiExpDocModal,onSubmit:this.handleSubmitCoiExpDoc,onClose:this.handleCloseCoiExpDocModal}));}}]);return CoiExpDocs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CoiExpDocs.propTypes={coiExpId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,coiExpDocs:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onPageChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};CoiExpDocs.defaultProps={coiExpDocs:{coiExpDocs:[],coiExpDocsTotal:0,coiExpDocsCurrentPage:1,coiExpDocsPageSize:5,readOnly:true}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentProject:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),liabilities:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_coi_exps_store_selectors__["f" /* getLiabilities */])(state)};})(CoiExpDocs));

/***/ }),
/* 3009 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_coi_exps_CoiExpDocForm__ = __webpack_require__(3011);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CoiExpDocModal=function(_Component){_inherits(CoiExpDocModal,_Component);function CoiExpDocModal(){_classCallCheck(this,CoiExpDocModal);return _possibleConstructorReturn(this,(CoiExpDocModal.__proto__||Object.getPrototypeOf(CoiExpDocModal)).apply(this,arguments));}_createClass(CoiExpDocModal,[{key:'render',value:function render(){var _props=this.props,initialValues=_props.initialValues,showModal=_props.showModal,onSubmit=_props.onSubmit,onClose=_props.onClose;return showModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_modal_FormModal__["a" /* default */],{show:showModal,onClose:onClose,title:'COI Document Liabilities'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_coi_exps_CoiExpDocForm__["a" /* default */],{initialValues:initialValues,onSubmit:onSubmit}));}}]);return CoiExpDocModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CoiExpDocModal.propTypes={initialValues:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),showModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(CoiExpDocModal));

/***/ }),
/* 3011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CoiExpDocForm_css__ = __webpack_require__(3012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CoiExpDocForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CoiExpDocForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_coi_exps_store_selectors__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_utils_date_util__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_checkbox_LabeledCheckBox__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CoiExpDocForm=function(_Component){_inherits(CoiExpDocForm,_Component);function CoiExpDocForm(props){_classCallCheck(this,CoiExpDocForm);var _this=_possibleConstructorReturn(this,(CoiExpDocForm.__proto__||Object.getPrototypeOf(CoiExpDocForm)).call(this,props));_initialiseProps.call(_this);var initialValues=props.initialValues,liabilities=props.liabilities;var coiExpDocLiabilities=initialValues&&initialValues.coi_exp_doc_liabilities||[];_this.state={subcategory:'',coiExpDocLiabilities:liabilities.map(function(liability){var docLiability=coiExpDocLiabilities.find(function(coiExpDocLiability){return coiExpDocLiability.liability_id===liability.id;});return{id:docLiability&&docLiability.id,liabilityId:liability.id,expDate:docLiability&&docLiability.exp_date,destroy:!docLiability};})};return _this;}_createClass(CoiExpDocForm,[{key:'render',value:function render(){var subcategory=this.state.subcategory;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'coi-exp-doc-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'coi-exp-doc-subcategory'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_dropdown_Dropdown__["a" /* default */],{options:this.subcategories(),placeholder:'Cert Holder...',value:subcategory,onChange:this.handleSubcategoryChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table',headers:[],rows:this.mapLiabilities(),emptyMessage:'No Liabilities'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_button_Button__["a" /* default */],{disabled:!this.formValid(),className:'button-orange',label:'Done',onClick:this.handleSubmit})));}}]);return CoiExpDocForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CoiExpDocForm.propTypes={initialValues:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),onSubmit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};CoiExpDocForm.defaultProps={initialValues:null};var _initialiseProps=function _initialiseProps(){var _this2=this;this.subcategories=function(){return[{value:'client_landlord',label:'Client/Landlord'},{value:'general_contractor',label:'General Contractor'}];};this.formValid=function(){var _state=_this2.state,subcategory=_state.subcategory,coiExpDocLiabilities=_state.coiExpDocLiabilities;return!!subcategory&&!!coiExpDocLiabilities.find(function(coiExpDocLiability){return!coiExpDocLiability.destroy;})&&!coiExpDocLiabilities.find(function(coiExpDocLiability){return!coiExpDocLiability.destroy&&!coiExpDocLiability.expDate;});};this.mapLiabilities=function(){var coiExpDocLiabilities=_this2.state.coiExpDocLiabilities;var liabilities=_this2.props.liabilities;return liabilities.map(function(liability){var docLiability=coiExpDocLiabilities.find(function(coiExpDocLiability){return coiExpDocLiability.liabilityId===liability.id;});return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_checkbox_LabeledCheckBox__["a" /* default */],{onChange:function onChange(value){return _this2.handleChange(docLiability,'destroy',!value);},checked:!docLiability.destroy,label:liability.label}),!docLiability.destroy&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{isValidDate:__WEBPACK_IMPORTED_MODULE_5_services_utils_date_util__["k" /* todayValidation */],placeholder:'Expiration date',onChange:function onChange(value){return _this2.handleChange(docLiability,'expDate',value);},value:docLiability.expDate})];});};this.handleSubcategoryChange=function(option){_this2.setState({subcategory:option.value});};this.handleChange=function(docLiability,attr,value){var coiExpDocLiabilities=_this2.state.coiExpDocLiabilities;_this2.setState({coiExpDocLiabilities:coiExpDocLiabilities.map(function(coiExpDocLiability){if(coiExpDocLiability.liabilityId===docLiability.liabilityId){return Object.assign({},docLiability,_defineProperty({},attr,value));}else{return coiExpDocLiability;}})});};this.handleSubmit=function(){var _state2=_this2.state,subcategory=_state2.subcategory,coiExpDocLiabilities=_state2.coiExpDocLiabilities;var onSubmit=_this2.props.onSubmit;onSubmit({subcategory:subcategory,coiExpDocLiabilities:coiExpDocLiabilities});};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{liabilities:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_details_project_coi_exps_store_selectors__["f" /* getLiabilities */])(state)};})(CoiExpDocForm));

/***/ }),
/* 3012 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3013 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAmCAYAAABDClKtAAAAAXNSR0IArs4c6QAAAmVJREFUWAlj7J+73pPh3/9Z//8zyDAMMGBkZHjCwMSYxjRYHAQKD3DAAAOIaTCEEHIEgdzDhCwwWNijjiI2JkZDajSkiA0BYtWxEKsQpM5QW5nBwliDgYOdjWhtnz5/Y9h75ALDgycvidZDUkK3MdMmyUEgV/DxcjEY6ioT7SCQQpIcxcLCTJLhMMUszCRZQ5qjYJaQSjMxMTGws7MSrY00L+Aw9vefPwzvP3xm+PfvP1YVUuLCDBkx3ljlsAmSlNCxGfDi1TuG9TuOM/z4+YtBWJCXIczHjoGDAzMjMDExYtOOVYzikDp5/ibYQSDT377/zHDl5gMMi0A58OjpqxjiuAQodhQ7G2paYUPjgyz+9uMnw92Hz3G5AUOcYkdZm2oxSEsIM7ACc6a6sgyDtpo8hiUSooIMcSEuGOK4BMhOU9++/2TYeeAsw49fvxiMdFQYBPl5GO49esGwaM0eBk1VWQYLI00UO/8DW2/EArIddfL8DXgpvW3faRT7jp+9waAkJ8kgJiIAFn/x+j3D1r2nUNTg45Adfc9evMVnLsNTJHlmYDnFy82JVz2yJNmOYiJQSjMjyYsK8zOE+doh24uXTXb0WQLTzNEz1xh+/vyNYQE/sL5TU5JGEadLmlKQFWcAYWIAKCrX7zhGjFKwGrKjj2gbgAr////H8Pv3H6K1kOSoHz9+EW0wssI/f/4hcwmySXIUOA39wkxD+Gz5+Okrw9nLt/EpwZAjKaFfun6fAYRpDUgKKVo7Bmb+qKNgIUGIHg0pQiEEkx8NKVhIEKKZwOOMhFTRUR7kHibQwOdgcRhsIBYASmuiy8qeiaoAAAAASUVORK5CYII="

/***/ }),
/* 3014 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAmCAYAAABDClKtAAAAAXNSR0IArs4c6QAAAmZJREFUWAntWD2IE0EU/mayu0k0iZUE/xD8Q85CwROxUEQ4NIWolb+FCB4Kor1whZXCYSfKpRCFA7WwsNROEAWx0CKFhcXhidoYY3K59W53x53VXW6ym2RmIppiF5ad9+Z77318b2YWhjQqoxUPpArG1uJ/P4TMUrBxUq/s+jgUhEJBfhMbAoVCQvzrd4wutYdlnJKS7USqVKqUrAKyOEMWyHHWkRPInRkHLRSlw7yvn9G+dQPOm5fSMUoLPX/ukhIhzoKWVyF79KQ0oSBGBU2srAo8whLTjMYyAyWlZBImYgwDpFBKnEpy/hVSzLbhzs6AuW5SDRgj21F6+CxxLsmptNCTEjjva5ibuALWbICu34jC5BRocUUMSjKZmK+bY2Cl7Ad3A0K8gDfzAQtPn8Rq8R04f+92zN/NMTApsrwg5CbLRJtPeo06Fl89F3C9jIFJ5c9eRGbbDiCXh7n/IKyxw7F6xpYRlKYexfzdHNpryvv+De2b18BaP5A9dgp09To4r1+geeE4rAMV5E6fF2oyxgS7l6FNiq+l8JRuX78q1LCnqzB274WxaWvg55uhEyMEdBja7XNrbztSiaZbexc5iGmBrCxHdr+BNin0O6WXzGc2bEZxstqPSzSv3T7+Y7b9bc7mmlGycEDLa2DuGwvN4Ms8T7B7GdqkzJ17wF+Zx/Fb2Zq4LAMNMPrtky7hA10HmG9LRyiR8vxfic7DFheUwpRI2ffv+GuopVTA/fIJPx9PK8WQ+qFR+VNNKbU+WEkp/TJqkSkpWb1SpVKlZBWQxVH413my4H+C49eL/OJzaIj9uYj9BcWLm1VlWNSgAAAAAElFTkSuQmCC"

/***/ }),
/* 3015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewProject_css__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewProject_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NewProject_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_projects_creation_store_selectors__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_creation_store_actions__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_creation_ClientSelection__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_creation_BuildingSelection__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_store_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_selectors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_store_actions__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditProject=function(_Component){_inherits(EditProject,_Component);function EditProject(props){_classCallCheck(this,EditProject);var _this=_possibleConstructorReturn(this,(EditProject.__proto__||Object.getPrototypeOf(EditProject)).call(this,props));_this.handleCancelEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_store_actions__["f" /* goToProjectDetails */])(_this.props.currentProject.id));};_this.handleUpdateProject=function(){var projectId=_this.props.currentProject.id;_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_creation_store_actions__["r" /* updateProject */])(projectId,_this.props.projectForm)).then(function(response){if(response.ok){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_store_actions__["f" /* goToProjectDetails */])(projectId));}});};_this.renderCurrentStage=function(){var stage=void 0;switch(_this.props.currentStage){case'client-selection':stage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_creation_ClientSelection__["a" /* default */],null);break;case'building-selection':stage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_creation_BuildingSelection__["a" /* default */],{submitButtonLabel:'Update Project',submitFunction:_this.handleUpdateProject});break;default:stage=null;}return stage;};props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_creation_store_actions__["f" /* editProject */])());return _this;}_createClass(EditProject,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var projectId=__WEBPACK_IMPORTED_MODULE_8_numeral___default()(this.props.match.params.projectId).value();var currentProject=this.props.currentProject;if(currentProject&&currentProject.id===projectId){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_creation_store_actions__["o" /* setProjectFormValues */])(currentProject));}else{this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_store_actions__["b" /* loadProjectRequest */])(projectId)).then(function(response){if(response.project){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_creation_store_actions__["o" /* setProjectFormValues */])(response.project));}});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'new-project'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'Edit Project'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_button_Button__["a" /* default */],{className:'button-gray cancel-button',label:'Cancel',onClick:this.handleCancelEdit}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},this.renderCurrentStage()));}}]);return EditProject;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentStage:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_creation_store_selectors__["d" /* getCurrentStage */])(state),currentProject:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_selectors__["a" /* getCurrentProject */])(state),projectForm:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_creation_store_selectors__["g" /* getProjectForm */])(state)};})(EditProject));

/***/ }),
/* 3016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_general_contractors_GeneralContractors__ = __webpack_require__(3017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_NewGeneralContractor__ = __webpack_require__(3020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_general_contractors_GeneralContractorOnboarding__ = __webpack_require__(3021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_general_contractors_GeneralContractorDetails__ = __webpack_require__(3044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_general_contractors_EditGeneralContractor__ = __webpack_require__(3046);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Parent container for all general contractors components/routes. Also catch render errors and redirects to /
 */var GeneralContractorsContainer=function(_Component){_inherits(GeneralContractorsContainer,_Component);function GeneralContractorsContainer(props){_classCallCheck(this,GeneralContractorsContainer);var _this=_possibleConstructorReturn(this,(GeneralContractorsContainer.__proto__||Object.getPrototypeOf(GeneralContractorsContainer)).call(this,props));_this.state={hasError:false};return _this;}_createClass(GeneralContractorsContainer,[{key:'componentDidCatch',value:function componentDidCatch(error,info){this.setState({hasError:true});this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actions_messages__["d" /* showErrorMessage */])('Something went wrong with the request, please try again later.'));}},{key:'render',value:function render(){if(this.state.hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Redirect */],{to:'/'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url,component:__WEBPACK_IMPORTED_MODULE_3_components_admin_general_contractors_GeneralContractors__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/new',component:__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_NewGeneralContractor__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/onboarding',component:__WEBPACK_IMPORTED_MODULE_5_components_admin_general_contractors_GeneralContractorOnboarding__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/:id',component:__WEBPACK_IMPORTED_MODULE_6_components_admin_general_contractors_GeneralContractorDetails__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url+'/:id/edit',component:__WEBPACK_IMPORTED_MODULE_7_components_admin_general_contractors_EditGeneralContractor__["a" /* default */]})));}}}]);return GeneralContractorsContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GeneralContractorsContainer);

/***/ }),
/* 3017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GeneralContractor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_general_contractors_GeneralContractors_css__ = __webpack_require__(3018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_general_contractors_GeneralContractors_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_admin_general_contractors_GeneralContractors_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_navigation_SearchBar__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_general_contractors_store_selectors__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_general_contractors_store_actions__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_general_contractors_GeneralContractorsTable__ = __webpack_require__(3019);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GeneralContractor=function(_Component){_inherits(GeneralContractor,_Component);function GeneralContractor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GeneralContractor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GeneralContractor.__proto__||Object.getPrototypeOf(GeneralContractor)).call.apply(_ref,[this].concat(args))),_this),_this.tabSelection=1,_this.handleNavSelect=function(id){_this.tabSelection=id;_this.loadGeneralContractors(id,1);},_this.handlePageChange=function(newPage){_this.loadGeneralContractors(_this.tabSelection,newPage);},_this.handleAddGeneralContractors=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_general_contractors_store_actions__["a" /* addGeneralContractor */])());},_this.handleRowGeneralContractors=function(index){var generalContractorId=_this.props.generalContractors.data[index].id;_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_general_contractors_store_actions__["o" /* showGeneralContractorDetails */])(generalContractorId));},_this.handleGenerateLink=function(index){var data=_this.props.generalContractors.data;return'general-contractors/'+data[index].id;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GeneralContractor,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_general_contractors_store_actions__["f" /* loadGeneralContractorsRequest */])(1));}},{key:'componentDidUpdate',value:function componentDidUpdate(){Object(__WEBPACK_IMPORTED_MODULE_8_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}},{key:'loadGeneralContractors',value:function loadGeneralContractors(tabSelection,newPage){switch(tabSelection){case 1:this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_general_contractors_store_actions__["f" /* loadGeneralContractorsRequest */])(newPage));break;case 2:this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_general_contractors_store_actions__["f" /* loadGeneralContractorsRequest */])(newPage,'active'));break;case 3:this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_components_admin_general_contractors_store_actions__["f" /* loadGeneralContractorsRequest */])(newPage,'inactive'));break;default:}}},{key:'render',value:function render(){var generalContractors=this.props.generalContractors;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'general-contractors'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},'General Contractors'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_navigation_SearchBar__["a" /* default */],{addButton:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-orange',type:'button',value:'Add GC',onClick:this.handleAddGeneralContractors})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,show:true,title:'All'},{id:2,show:generalContractors.totalActive>0,title:'Active',total:generalContractors.totalActive},{id:3,show:generalContractors.totalInactive>0,title:'Pending invites',total:generalContractors.totalInactive}],onSelected:this.handleNavSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_admin_general_contractors_GeneralContractorsTable__["a" /* default */],{generalContractors:this.props.generalContractors.data,onRowSelected:this.handleRowGeneralContractors,onGenerateLink:this.handleGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.currentPage,pageSize:generalContractors.pageSize,total:generalContractors.total,onPageChange:this.handlePageChange}))));}}]);return GeneralContractor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentPage:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_general_contractors_store_selectors__["c" /* getCurrentPage */])(state),generalContractors:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_general_contractors_store_selectors__["e" /* getGeneralContractors */])(state)};})(GeneralContractor));

/***/ }),
/* 3018 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GeneralContractorsTable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function GeneralContractorsTable(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_components_shared_table_SimpleTable__["a" /* default */],{className:'general-contractor-table',headers:['GENERAL CONTRACTOR','POC','EMAIL'].filter(function(header){return header;}),rows:mapGeneralContractors(props.generalContractors),emptyMessage:'No General Contractors',onRowSelected:props.onRowSelected,onGenerateLink:props.onGenerateLink});}function mapGeneralContractors(generalContractorsData){return generalContractorsData.map(function(generalContractor){var contact=generalContractor.contact;return[generalContractor.name,contact?contact.first_name+' '+contact.last_name:'',contact?contact.email:''].filter(function(attr){return attr;});});}

/***/ }),
/* 3020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_store_actions__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_general_contractors_GeneralContractorForm__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewGeneralContractor=function(_Component){_inherits(NewGeneralContractor,_Component);function NewGeneralContractor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewGeneralContractor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewGeneralContractor.__proto__||Object.getPrototypeOf(NewGeneralContractor)).call.apply(_ref,[this].concat(args))),_this),_this.handleOnSubmit=function(values){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_store_actions__["b" /* createGeneralContractor */])(values));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewGeneralContractor,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_admin_general_contractors_GeneralContractorForm__["a" /* default */],{onSubmit:this.handleOnSubmit}));}}]);return NewGeneralContractor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(state){return{};})(NewGeneralContractor));

/***/ }),
/* 3021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_general_contractors_GeneralContractorOnboarding_css__ = __webpack_require__(3022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_general_contractors_GeneralContractorOnboarding_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_admin_general_contractors_GeneralContractorOnboarding_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_general_contractors_store_selectors__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_actions__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_general_contractors_LicenceNumberInput__ = __webpack_require__(3023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_general_contractors_CompanyLogoUpload__ = __webpack_require__(3043);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GeneralContractorOnboarding=function(_Component){_inherits(GeneralContractorOnboarding,_Component);function GeneralContractorOnboarding(props){_classCallCheck(this,GeneralContractorOnboarding);var _this=_possibleConstructorReturn(this,(GeneralContractorOnboarding.__proto__||Object.getPrototypeOf(GeneralContractorOnboarding)).call(this,props));_this.renderCurrentStage=function(){var stage=void 0;switch(_this.props.currentStage){case'licence-input':stage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_admin_general_contractors_LicenceNumberInput__["a" /* default */],null);break;case'logo-upload':stage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_general_contractors_CompanyLogoUpload__["a" /* default */],null);break;default:stage=null;}return stage;};props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_actions__["g" /* newOnboarding */])());return _this;}_createClass(GeneralContractorOnboarding,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'general-contractor-onboarding'},this.renderCurrentStage());}}]);return GeneralContractorOnboarding;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentStage:Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_general_contractors_store_selectors__["d" /* getCurrentStage */])(state)};})(GeneralContractorOnboarding));

/***/ }),
/* 3022 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_input_Input__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_selectors__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_general_contractors_store_actions__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_general_contractors_OnboardingStatus__ = __webpack_require__(1077);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LicenceNumberInput=function(_Component){_inherits(LicenceNumberInput,_Component);function LicenceNumberInput(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LicenceNumberInput);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LicenceNumberInput.__proto__||Object.getPrototypeOf(LicenceNumberInput)).call.apply(_ref,[this].concat(args))),_this),_this.handleLicenceNumberChange=function(value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_general_contractors_store_actions__["k" /* setLicenceNumberValue */])(value));},_this.handleContinue=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_general_contractors_store_actions__["h" /* nextStage */])());},_this.canContinue=function(){return!!_this.props.licenceNumber;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LicenceNumberInput,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'license-number-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_general_contractors_OnboardingStatus__["a" /* default */],{activeStep:0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'onboarding-title'},'Contractor Licence'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'add-message'},'Users will be emailed an invite to finish creating their account.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_input_Input__["a" /* default */],{placeholder:'Add Contractor License',value:this.props.licenceNumber,onChange:function onChange(value){return _this2.handleLicenceNumberChange(value);},className:'onboarding-input'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-continue '+(this.canContinue()?'button-orange':'button-disabled'),type:'button',value:'Continue',onClick:this.handleContinue,disabled:!this.canContinue()}))));}}]);return LicenceNumberInput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{licenceNumber:Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_selectors__["f" /* getLicenceNumber */])(state)};})(LicenceNumberInput));

/***/ }),
/* 3024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Stepper = __webpack_require__(3025);

var _Stepper2 = _interopRequireDefault(_Stepper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Stepper2.default;

/***/ }),
/* 3025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1078);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _Step = __webpack_require__(3042);

var _Step2 = _interopRequireDefault(_Step);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  root: {
    width: '100%',
    minHeight: 0,
    padding: 0
  },
  stepper: {
    display: 'table',
    width: '100%',
    margin: '0 auto'
  }
};

function Stepper(_ref) {
  var activeStep = _ref.activeStep,
      steps = _ref.steps,
      disabledSteps = _ref.disabledSteps,
      activeColor = _ref.activeColor,
      completeColor = _ref.completeColor,
      defaultColor = _ref.defaultColor,
      circleFontColor = _ref.circleFontColor,
      activeTitleColor = _ref.activeTitleColor,
      completeTitleColor = _ref.completeTitleColor,
      defaultTitleColor = _ref.defaultTitleColor,
      size = _ref.size,
      circleFontSize = _ref.circleFontSize,
      titleFontSize = _ref.titleFontSize,
      circleTop = _ref.circleTop,
      titleTop = _ref.titleTop,
      completeOpacity = _ref.completeOpacity,
      activeOpacity = _ref.activeOpacity,
      defaultOpacity = _ref.defaultOpacity,
      completeTitleOpacity = _ref.completeTitleOpacity,
      activeTitleOpacity = _ref.activeTitleOpacity,
      defaultTitleOpacity = _ref.defaultTitleOpacity,
      barStyle = _ref.barStyle,
      defaultBorderColor = _ref.defaultBorderColor,
      completeBorderColor = _ref.completeBorderColor,
      activeBorderColor = _ref.activeBorderColor,
      defaultBorderStyle = _ref.defaultBorderStyle,
      completeBorderStyle = _ref.completeBorderStyle,
      activeBorderStyle = _ref.activeBorderStyle,
      defaultBarColor = _ref.defaultBarColor,
      completeBarColor = _ref.completeBarColor,
      lineMarginOffset = _ref.lineMarginOffset,
      defaultBorderWidth = _ref.defaultBorderWidth;

  return _react2.default.createElement(
    'div',
    { style: styles.root },
    _react2.default.createElement(
      'div',
      { style: styles.stepper },
      steps.map(function (step, index) {
        return _react2.default.createElement(_Step2.default, {
          key: index,
          width: 100 / steps.length,
          title: step.title,
          icon: step.icon,
          href: step.href,
          onClick: step.onClick,
          active: !(disabledSteps || []).includes(index) && index === activeStep,
          completed: !(disabledSteps || []).includes(index) && index < activeStep,
          first: index === 0,
          isLast: index === steps.length - 1,
          index: index,
          activeColor: activeColor,
          completeColor: completeColor,
          defaultColor: defaultColor,
          circleFontColor: circleFontColor,
          activeTitleColor: activeTitleColor,
          completeTitleColor: completeTitleColor,
          defaultTitleColor: defaultTitleColor,
          size: size,
          circleFontSize: circleFontSize,
          titleFontSize: titleFontSize,
          circleTop: circleTop,
          titleTop: titleTop,
          defaultOpacity: defaultOpacity,
          completeOpacity: completeOpacity,
          activeOpacity: activeOpacity,
          defaultTitleOpacity: defaultTitleOpacity,
          completeTitleOpacity: completeTitleOpacity,
          activeTitleOpacity: activeTitleOpacity,
          barStyle: barStyle,
          defaultBorderColor: defaultBorderColor,
          completeBorderColor: completeBorderColor,
          activeBorderColor: activeBorderColor,
          defaultBorderStyle: defaultBorderStyle,
          defaultBorderWidth: defaultBorderWidth,
          completeBorderStyle: completeBorderStyle,
          activeBorderStyle: activeBorderStyle,
          defaultBarColor: defaultBarColor,
          completeBarColor: completeBarColor,
          lineMarginOffset: lineMarginOffset
        });
      })
    )
  );
}

Stepper.defaultProps = {
  activeStep: 0
};

Stepper.propTypes = {
  activeStep: _propTypes.PropTypes.number,
  steps: _propTypes.PropTypes.array,
  activeColor: _propTypes.PropTypes.string,
  completeColor: _propTypes.PropTypes.string,
  defaultColor: _propTypes.PropTypes.string,
  activeTitleColor: _propTypes.PropTypes.string,
  completeTitleColor: _propTypes.PropTypes.string,
  defaultTitleColor: _propTypes.PropTypes.string,
  circleFontColor: _propTypes.PropTypes.string,
  size: _propTypes.PropTypes.number,
  circleFontSize: _propTypes.PropTypes.number,
  titleFontSize: _propTypes.PropTypes.number,
  circleTop: _propTypes.PropTypes.number,
  titleTop: _propTypes.PropTypes.number,
  defaultOpacity: _propTypes.PropTypes.string,
  completeOpacity: _propTypes.PropTypes.string,
  activeOpacity: _propTypes.PropTypes.string,
  defaultTitleOpacity: _propTypes.PropTypes.string,
  completeTitleOpacity: _propTypes.PropTypes.string,
  activeTitleOpacity: _propTypes.PropTypes.string,
  barStyle: _propTypes.PropTypes.string,
  defaultBarColor: _propTypes.PropTypes.string,
  completeBarColor: _propTypes.PropTypes.string,
  defaultBorderColor: _propTypes.PropTypes.string,
  completeBorderColor: _propTypes.PropTypes.string,
  activeBorderColor: _propTypes.PropTypes.string,
  defaultBorderStyle: _propTypes.PropTypes.string,
  completeBorderStyle: _propTypes.PropTypes.string,
  activeBorderStyle: _propTypes.PropTypes.string,
  lineMarginOffset: _propTypes.PropTypes.number,
  defaultBorderWidth: _propTypes.PropTypes.number
};

exports.default = Stepper;

/***/ }),
/* 3026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(134);

var ReactBaseClasses = __webpack_require__(1079);
var ReactChildren = __webpack_require__(3029);
var ReactDOMFactories = __webpack_require__(3034);
var ReactElement = __webpack_require__(287);
var ReactPropTypes = __webpack_require__(3035);
var ReactVersion = __webpack_require__(3039);

var createReactClass = __webpack_require__(3040);
var onlyChild = __webpack_require__(3041);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 3027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 3028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 3029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(3030);
var ReactElement = __webpack_require__(287);

var emptyFunction = __webpack_require__(1081);
var traverseAllChildren = __webpack_require__(3031);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 3030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(442);

var invariant = __webpack_require__(443);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 3031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(442);

var ReactCurrentOwner = __webpack_require__(1083);
var REACT_ELEMENT_TYPE = __webpack_require__(1084);

var getIteratorFn = __webpack_require__(3032);
var invariant = __webpack_require__(443);
var KeyEscapeUtils = __webpack_require__(3033);
var warning = __webpack_require__(649);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 3032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 3033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 3034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(287);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 3035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(287),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(3036);

module.exports = factory(isValidElement);

/***/ }),
/* 3036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(3037);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 3037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(295);
var assign = __webpack_require__(134);

var ReactPropTypesSecret = __webpack_require__(669);
var checkPropTypes = __webpack_require__(3038);

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 3038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (false) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 3039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.7.0';


/***/ }),
/* 3040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(1079),
    Component = _require.Component;

var _require2 = __webpack_require__(287),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(1080);
var factory = __webpack_require__(881);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 3041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(442);

var ReactElement = __webpack_require__(287);

var invariant = __webpack_require__(443);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 3042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1078);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Step = function (_Component) {
  _inherits(Step, _Component);

  function Step() {
    _classCallCheck(this, Step);

    var _this = _possibleConstructorReturn(this, (Step.__proto__ || Object.getPrototypeOf(Step)).call(this));

    _this.getStyles = _this.getStyles.bind(_this);
    return _this;
  }

  _createClass(Step, [{
    key: 'getStyles',
    value: function getStyles() {
      var _props = this.props,
          activeColor = _props.activeColor,
          completeColor = _props.completeColor,
          defaultColor = _props.defaultColor,
          circleFontColor = _props.circleFontColor,
          activeTitleColor = _props.activeTitleColor,
          completeTitleColor = _props.completeTitleColor,
          defaultTitleColor = _props.defaultTitleColor,
          size = _props.size,
          circleFontSize = _props.circleFontSize,
          titleFontSize = _props.titleFontSize,
          circleTop = _props.circleTop,
          titleTop = _props.titleTop,
          width = _props.width,
          completeOpacity = _props.completeOpacity,
          activeOpacity = _props.activeOpacity,
          defaultOpacity = _props.defaultOpacity,
          completeTitleOpacity = _props.completeTitleOpacity,
          activeTitleOpacity = _props.activeTitleOpacity,
          defaultTitleOpacity = _props.defaultTitleOpacity,
          barStyle = _props.barStyle,
          defaultBarColor = _props.defaultBarColor,
          completeBarColor = _props.completeBarColor,
          defaultBorderColor = _props.defaultBorderColor,
          completeBorderColor = _props.completeBorderColor,
          activeBorderColor = _props.activeBorderColor,
          defaultBorderStyle = _props.defaultBorderStyle,
          completeBorderStyle = _props.completeBorderStyle,
          activeBorderStyle = _props.activeBorderStyle,
          lineMarginOffset = _props.lineMarginOffset,
          defaultBorderWidth = _props.defaultBorderWidth;


      return {
        step: {
          width: width + '%',
          display: 'table-cell',
          position: 'relative',
          paddingTop: circleTop
        },
        circle: {
          width: size,
          height: size,
          margin: '0 auto',
          backgroundColor: defaultColor,
          borderRadius: '50%',
          textAlign: 'center',
          padding: 1,
          fontSize: circleFontSize,
          color: circleFontColor,
          display: 'block',
          opacity: defaultOpacity,
          borderWidth: defaultBorderColor ? defaultBorderWidth : 0,
          borderColor: defaultBorderColor,
          borderStyle: defaultBorderStyle
        },
        activeCircle: {
          backgroundColor: activeColor,
          opacity: activeOpacity,
          borderWidth: activeBorderColor ? defaultBorderWidth : 0,
          borderColor: activeBorderColor,
          borderStyle: activeBorderStyle
        },
        completedCircle: {
          backgroundColor: completeColor,
          opacity: completeOpacity,
          borderWidth: completeBorderColor ? defaultBorderWidth : 0,
          borderColor: completeBorderColor,
          borderStyle: completeBorderStyle
        },
        index: {
          lineHeight: size + circleFontSize / 4 + 'px',
          color: circleFontColor
        },
        title: {
          marginTop: titleTop,
          fontSize: titleFontSize,
          fontWeight: '300',
          textAlign: 'center',
          display: 'block',
          color: defaultTitleColor,
          opacity: defaultTitleOpacity
        },
        activeTitle: {
          color: activeTitleColor,
          opacity: activeTitleOpacity
        },
        completedTitle: {
          color: completeTitleColor,
          opacity: completeTitleOpacity
        },
        leftBar: {
          position: 'absolute',
          top: circleTop + size / 2,
          height: 1,
          borderTopStyle: barStyle,
          borderTopWidth: 1,
          borderTopColor: defaultBarColor,
          left: 0,
          right: '50%',
          marginRight: size / 2 + lineMarginOffset,
          opacity: defaultOpacity
        },
        rightBar: {
          position: 'absolute',
          top: circleTop + size / 2,
          height: 1,
          borderTopStyle: barStyle,
          borderTopWidth: 1,
          borderTopColor: defaultBarColor,
          right: 0,
          left: '50%',
          marginLeft: size / 2 + lineMarginOffset,
          opacity: defaultOpacity
        },
        completedBar: {
          borderTopStyle: barStyle,
          borderTopWidth: 1,
          borderTopColor: completeBarColor,
          opacity: completeOpacity
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          title = _props2.title,
          icon = _props2.icon,
          index = _props2.index,
          active = _props2.active,
          completed = _props2.completed,
          first = _props2.first,
          isLast = _props2.isLast,
          href = _props2.href,
          onClick = _props2.onClick;


      var styles = this.getStyles();
      var circleStyle = Object.assign(styles.circle, completed ? styles.completedCircle : {}, active ? styles.activeCircle : {});
      var titleStyle = Object.assign(styles.title, completed ? styles.completedTitle : {}, active ? styles.activeTitle : {});
      var leftStyle = Object.assign(styles.leftBar, active || completed ? styles.completedBar : {});
      var rightStyle = Object.assign(styles.rightBar, completed ? styles.completedBar : {});

      var stepContent = icon ? _react2.default.createElement('img', { src: icon, alt: index + 1 }) : index + 1;

      return _react2.default.createElement(
        'div',
        { style: styles.step },
        _react2.default.createElement(
          'div',
          { style: circleStyle },
          active || completed ? _react2.default.createElement(
            'a',
            { href: href, onClick: onClick, style: styles.index },
            stepContent
          ) : _react2.default.createElement(
            'span',
            { style: styles.index },
            stepContent
          )
        ),
        active || completed ? _react2.default.createElement(
          'a',
          { href: href, onClick: onClick, style: titleStyle },
          title
        ) : _react2.default.createElement(
          'div',
          { style: titleStyle },
          title
        ),
        !first && _react2.default.createElement('div', { style: leftStyle }),
        !isLast && _react2.default.createElement('div', { style: rightStyle })
      );
    }
  }]);

  return Step;
}(_react.Component);

exports.default = Step;


Step.defaultProps = {
  activeColor: '#5096FF',
  completeColor: '#5096FF',
  defaultColor: '#E0E0E0',
  activeTitleColor: '#000',
  completeTitleColor: '#000',
  defaultTitleColor: '#757575',
  circleFontColor: '#FFF',
  size: 32,
  circleFontSize: 16,
  titleFontSize: 16,
  circleTop: 24,
  titleTop: 8,
  defaultBarColor: '#E0E0E0',
  barStyle: 'solid',
  borderStyle: 'solid',
  lineMarginOffset: 4,
  defaultBorderWidth: 3
};

Step.propTypes = {
  width: _propTypes.PropTypes.number.isRequired,
  activeColor: _propTypes.PropTypes.string,
  completeColor: _propTypes.PropTypes.string,
  defaultColor: _propTypes.PropTypes.string,
  activeTitleColor: _propTypes.PropTypes.string,
  completeTitleColor: _propTypes.PropTypes.string,
  defaultTitleColor: _propTypes.PropTypes.string,
  circleFontColor: _propTypes.PropTypes.string,
  size: _propTypes.PropTypes.number,
  circleFontSize: _propTypes.PropTypes.number,
  titleFontSize: _propTypes.PropTypes.number,
  circleTop: _propTypes.PropTypes.number,
  titleTop: _propTypes.PropTypes.number,
  title: _propTypes.PropTypes.string,
  index: _propTypes.PropTypes.number,
  active: _propTypes.PropTypes.bool,
  completed: _propTypes.PropTypes.bool,
  first: _propTypes.PropTypes.bool,
  isLast: _propTypes.PropTypes.bool,
  completeOpacity: _propTypes.PropTypes.string,
  activeOpacity: _propTypes.PropTypes.string,
  defaultOpacity: _propTypes.PropTypes.string,
  completeTitleOpacity: _propTypes.PropTypes.string,
  activeTitleOpacity: _propTypes.PropTypes.string,
  defaultTitleOpacity: _propTypes.PropTypes.string,
  barStyle: _propTypes.PropTypes.string,
  defaultBarColor: _propTypes.PropTypes.string,
  completeBarColor: _propTypes.PropTypes.string,
  defaultBorderColor: _propTypes.PropTypes.string,
  completeBorderColor: _propTypes.PropTypes.string,
  activeBorderColor: _propTypes.PropTypes.string,
  defaultBorderStyle: _propTypes.PropTypes.string,
  completeBorderStyle: _propTypes.PropTypes.string,
  activeBorderStyle: _propTypes.PropTypes.string,
  lineMarginOffset: _propTypes.PropTypes.number,
  defaultBorderWidth: _propTypes.PropTypes.number
};

/***/ }),
/* 3043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_general_contractors_store_selectors__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_general_contractors_store_actions__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_OnboardingStatus__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_logo_upload_LogoUpload__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_admin_sidebar_sidebar__ = __webpack_require__(498);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CompanyLogoUpload=function(_Component){_inherits(CompanyLogoUpload,_Component);function CompanyLogoUpload(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CompanyLogoUpload);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CompanyLogoUpload.__proto__||Object.getPrototypeOf(CompanyLogoUpload)).call.apply(_ref,[this].concat(args))),_this),_this.canContinue=function(){return!!_this.props.companyLogo.image;},_this.handleCompanyLogoChange=function(files){var file=files[0];var logo={url:URL.createObjectURL(file),file:file};_this.logos=[logo];_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_general_contractors_store_actions__["i" /* setCompanyLogo */])(logo));},_this.handleCompanyLogoRemove=function(){_this.logos=[];var logo={url:'',file:''};_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_general_contractors_store_actions__["i" /* setCompanyLogo */])(logo));},_this.handleContinue=function(){var onboardingData={generalContractor:_this.props.currentGeneralContractor,licenceNumber:_this.props.licenceNumber,companyLogo:_this.props.companyLogo,confirmed:true};_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_general_contractors_store_actions__["q" /* submitOnboarding */])(onboardingData));_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions_admin_sidebar_sidebar__["b" /* setHideSideBar */])(false));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CompanyLogoUpload,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'company-logo-upload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_OnboardingStatus__["a" /* default */],{activeStep:2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'onboarding-title'},'Company Logo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'add-message'},'Your company logo will be added to any proposals you deliver'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_logo_upload_LogoUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],logos:this.logos,onRemove:function onRemove(){return _this2.handleCompanyLogoRemove({});},onUpload:function onUpload(files){return _this2.handleCompanyLogoChange(files);},useDropzone:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'btn button button-continue '+(this.canContinue()?'button-orange':'button-disabled'),type:'button',value:'Finished',onClick:this.handleContinue,disabled:!this.canContinue()})));}}]);return CompanyLogoUpload;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{companyLogo:Object(__WEBPACK_IMPORTED_MODULE_2_components_admin_general_contractors_store_selectors__["a" /* getCompanyLogo */])(state),licenceNumber:Object(__WEBPACK_IMPORTED_MODULE_2_components_admin_general_contractors_store_selectors__["f" /* getLicenceNumber */])(state),currentGeneralContractor:Object(__WEBPACK_IMPORTED_MODULE_2_components_admin_general_contractors_store_selectors__["b" /* getCurrentGeneralContractor */])(state)};})(CompanyLogoUpload));

/***/ }),
/* 3044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GeneralContractorDetails_css__ = __webpack_require__(3045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GeneralContractorDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__GeneralContractorDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_projects_store_actions__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_actions_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_route_title_RouteTitle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_details_DetailsHeader__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_contractors_ContractorStatus__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_details_DetailsInfo__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfoItem__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_general_contractors_store_selectors__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_navigation_SearchBar__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_shared_logo_upload_LogoUpload__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_shared_modal_ContactsModal__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_shared_text_SimpleText__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_shared_project_status_ProjectStatus__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_domain_project_status_enum__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_services_utils_scroller_util__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GeneralContractorDetails=function(_Component){_inherits(GeneralContractorDetails,_Component);function GeneralContractorDetails(props){_classCallCheck(this,GeneralContractorDetails);var _this=_possibleConstructorReturn(this,(GeneralContractorDetails.__proto__||Object.getPrototypeOf(GeneralContractorDetails)).call(this,props));_this.tabSelection=1;_this.handleEdit=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_actions_js__["c" /* goToEditGeneralContractor */])(_this.generalContractorId));};_this.handleRowSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_store_actions__["f" /* goToProjectDetails */])(_this.props.projects.content[index].id));};_this.handleNavSelect=function(id){_this.tabSelection=id;_this.loadProjects(id,1);};_this.handlePageChange=function(newPage){_this.loadProjects(_this.tabSelection,newPage);};_this.handleViewAll=function(event){event.preventDefault();_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_actions_js__["n" /* showContactsRequest */])(_this.props.generalContractor.id,_this.props.users));};_this.handleContactsModalClose=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_actions_js__["m" /* showContactsModal */])(false));};_this.mapUsers=function(users){return users.map(function(user){return{email:user.email,lastSignIn:user.current_sign_in_at,name:user.first_name+' '+user.last_name,phoneNumber:user.phone_number,primaryContact:user.account_creator,title:_this.mapTitle(user.roles)};});};_this.mapProjects=function(projects){return projects.map(function(project){return[project.number,project.name,project.client.company_name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_shared_text_SimpleText__["a" /* default */],{lines:[project.building.location.street_address_1,project.building.location.city]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_shared_project_status_ProjectStatus__["a" /* default */],{status:__WEBPACK_IMPORTED_MODULE_21_domain_project_status_enum__["a" /* ProjectStatusEnum */].create(project.status)})].filter(function(attr){return attr;});});};_this.generalContractorId=__WEBPACK_IMPORTED_MODULE_17_numeral___default()(_this.props.match.params.id).value();return _this;}_createClass(GeneralContractorDetails,[{key:'componentDidUpdate',value:function componentDidUpdate(){Object(__WEBPACK_IMPORTED_MODULE_23_services_utils_scroller_util__["c" /* simpleScrollToTop */])();}},{key:'componentDidMount',value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_actions_js__["j" /* setGeneralContractorUsers */])([]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_actions_js__["e" /* loadGeneralContractorRequest */])(this.generalContractorId));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_actions_js__["d" /* loadGeneralContractorProjectsRequest */])(this.generalContractorId,1));}},{key:'loadProjects',value:function loadProjects(tabSelection,newPage){switch(tabSelection){case 1:this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_actions_js__["d" /* loadGeneralContractorProjectsRequest */])(this.generalContractorId,newPage));break;case 2:this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_actions_js__["d" /* loadGeneralContractorProjectsRequest */])(this.generalContractorId,newPage,'pending'));break;case 3:this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_actions_js__["d" /* loadGeneralContractorProjectsRequest */])(this.generalContractorId,newPage,'in_progress'));break;case 4:this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_actions_js__["d" /* loadGeneralContractorProjectsRequest */])(this.generalContractorId,newPage,'complete'));break;default:}}},{key:'mapTitle',value:function mapTitle(roles){var titles=roles.filter(function(role){return role.resource_type===__WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR;}).map(function(role){return __WEBPACK_IMPORTED_MODULE_10_services_utils_users_util__["d" /* GENERAL_CONTRACTOR_ROLES */][role.name];});if(titles.length>1){return titles.join(' / ');}else if(titles.length===1){return titles[0];}else{return'N/A';}}},{key:'render',value:function render(){var detailsInfoItems=[];if(this.props.generalContractor){if(this.props.generalContractor.location){detailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[this.props.generalContractor.location.street_address_1,this.props.generalContractor.location.city+', '+this.props.generalContractor.location.state+' '+this.props.generalContractor.location.zip],title:'ADDRESS'}));}detailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'general-contractor-name'},this.props.generalContractor.contact.first_name+' '+this.props.generalContractor.contact.last_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'general-contractor-email',href:'mailto:'+this.props.generalContractor.contact.email},this.props.generalContractor.contact.email),Object(__WEBPACK_IMPORTED_MODULE_15_services_utils_text_util__["c" /* formatPhoneNumber */])(this.props.generalContractor.contact.phone_number)],title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'PRIMARY CONTACT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'view-all',onClick:this.handleViewAll},'View All'))}));detailsInfoItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_details_DetailsInfoItem__["a" /* default */],{lines:[this.props.generalContractor.license_number],title:'LICENSE NUMBER'}));}return this.props.generalContractor&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_route_title_RouteTitle__["a" /* default */],{titles:['COMPANY',this.props.generalContractor.name.toUpperCase()]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_details_DetailsHeader__["a" /* default */],{leftHeader:{title:'COMPANY',value:this.props.generalContractor.name},leftHeaderExtraComponents:this.props.generalContractor.logo&&this.props.generalContractor.logo.image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-preview-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_shared_logo_upload_LogoUpload__["a" /* default */],{extensions:['.jpg','.jpeg','.gif','.png'],logos:[{preview:this.props.generalContractor.logo.image.url,url:this.props.generalContractor.logo.image.url}],readOnly:true})),rightHeaders:[[{title:'STATUS',value:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_contractors_ContractorStatus__["a" /* default */],{status:this.props.generalContractor.status})}]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-info-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_details_DetailsInfo__["a" /* default */],{itemsContainerSize:12,itemsLines:[detailsInfoItems]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edit-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn button button-gray',value:'Edit',onClick:this.handleEdit}))),this.props.projects&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_navigation_SearchBar__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'All'},{id:2,show:this.props.projects.totalPending>0,title:'Pending',total:this.props.projects.totalPending},{id:3,show:this.props.projects.totalInProgress>0,title:'In Progress',total:this.props.projects.totalInProgress},{id:4,show:this.props.projects.totalComplete>0,title:'Complete',total:this.props.projects.totalComplete}],onSelected:this.handleNavSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table',headers:['PROJECT #','NAME','CLIENT NAME','LOCATION','STATUS'].filter(function(header){return header;}),rows:this.mapProjects(this.props.projects.content),emptyMessage:'No Projects',onRowSelected:this.handleRowSelection}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:this.props.currentPage,pageSize:this.props.projects.pageSize,total:this.props.projects.total,onPageChange:this.handlePageChange}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_shared_modal_ContactsModal__["a" /* default */],{show:this.props.showContactsModal,users:this.mapUsers(this.props.users),onClose:this.handleContactsModalClose}));}}]);return GeneralContractorDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{generalContractor:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_general_contractors_store_selectors__["b" /* getCurrentGeneralContractor */])(state),projects:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_general_contractors_store_selectors__["g" /* getProjects */])(state),users:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_general_contractors_store_selectors__["j" /* getUsers */])(state),showContactsModal:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_general_contractors_store_selectors__["i" /* getShowContactsModal */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_general_contractors_store_selectors__["h" /* getProjectsCurrentPage */])(state)};})(GeneralContractorDetails));

/***/ }),
/* 3045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_GeneralContractorForm__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_actions__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_general_contractors_store_selectors__ = __webpack_require__(165);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditGeneralContractor=function(_Component){_inherits(EditGeneralContractor,_Component);function EditGeneralContractor(props){_classCallCheck(this,EditGeneralContractor);var _this=_possibleConstructorReturn(this,(EditGeneralContractor.__proto__||Object.getPrototypeOf(EditGeneralContractor)).call(this,props));_this.handleOnSubmit=function(values){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_actions__["r" /* updateGeneralContractorTeam */])(values,false));};_this.generalContractorId=__WEBPACK_IMPORTED_MODULE_3_numeral___default()(props.match.params.id).value();return _this;}_createClass(EditGeneralContractor,[{key:'UNSAFE_componentWillMount',value:function UNSAFE_componentWillMount(){var generalContractor=this.props.generalContractor;if(generalContractor===null||generalContractor.id!==this.generalContractorId){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_general_contractors_store_actions__["e" /* loadGeneralContractorRequest */])(this.generalContractorId));}}},{key:'render',value:function render(){var generalContractor=this.props.generalContractor;if(generalContractor){this.initialValues={id:generalContractor.id,name:generalContractor.name,licenceNumber:generalContractor.license_number,firstName:generalContractor.contact.first_name,lastName:generalContractor.contact.last_name,email:generalContractor.contact.email,phoneNumber:generalContractor.contact.phone_number,companyLogo:generalContractor.logo};if(generalContractor.location){this.initialValues['streetAddress']=generalContractor.location.street_address_1;this.initialValues['unitNumber']=generalContractor.location.street_address_2;this.initialValues['city']=generalContractor.location.city;this.initialValues['state']=generalContractor.location.state;this.initialValues['zipCode']=generalContractor.location.zip;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,generalContractor&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_GeneralContractorForm__["a" /* default */],{initialValues:this.initialValues,onSubmit:this.handleOnSubmit}));}}]);return EditGeneralContractor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{generalContractor:Object(__WEBPACK_IMPORTED_MODULE_5_components_admin_general_contractors_store_selectors__["b" /* getCurrentGeneralContractor */])(state)};})(EditGeneralContractor));

/***/ }),
/* 3047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_dashboard_Dashboard__ = __webpack_require__(3048);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Parent container for all dashboard components/routes. Also catch render errors and redirects to /
 */var DashboardContainer=function(_Component){_inherits(DashboardContainer,_Component);function DashboardContainer(props){_classCallCheck(this,DashboardContainer);var _this=_possibleConstructorReturn(this,(DashboardContainer.__proto__||Object.getPrototypeOf(DashboardContainer)).call(this,props));_this.state={hasError:false};return _this;}_createClass(DashboardContainer,[{key:'componentDidCatch',value:function componentDidCatch(error,info){this.setState({hasError:true});this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actions_messages__["d" /* showErrorMessage */])('Something went wrong with the request, please try again later.'));}},{key:'render',value:function render(){if(this.state.hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Redirect */],{to:'/'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:this.props.match.url,component:__WEBPACK_IMPORTED_MODULE_3_components_admin_dashboard_Dashboard__["a" /* default */]})));}}}]);return DashboardContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DashboardContainer);

/***/ }),
/* 3048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_css__ = __webpack_require__(3049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Dashboard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_dashboard_DashboardNav__ = __webpack_require__(3050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_dashboard_DashboardRecentActivity__ = __webpack_require__(3076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_chats_ChatActivity__ = __webpack_require__(3088);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Dashboard=function(_Component){_inherits(Dashboard,_Component);function Dashboard(){_classCallCheck(this,Dashboard);return _possibleConstructorReturn(this,(Dashboard.__proto__||Object.getPrototypeOf(Dashboard)).apply(this,arguments));}_createClass(Dashboard,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dashboard'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dashboard-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_admin_dashboard_DashboardNav__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dashboard-activity'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dashboard-recent-activity'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_dashboard_DashboardRecentActivity__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dashboard-chat-activity'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_admin_chats_ChatActivity__["a" /* default */],null)))));}}]);return Dashboard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(Dashboard));

/***/ }),
/* 3049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DashboardNav_css__ = __webpack_require__(3051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DashboardNav_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DashboardNav_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils_scroller_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_domain_dashboard__ = __webpack_require__(3052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_rfis_store_selectors__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_submittals_store_selectors__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_store_selectors__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_project_open_items_store_selectors__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_field_work_orders_store_selectors__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_selectors_admin_quotes_quotes__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_rfis_store_actions__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_submittals_store_actions__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_store_actions__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_project_open_items_store_actions__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_field_work_orders_store_actions__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_actions_admin_quotes_quotes__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_shared_modal_FormModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_admin_dashboard_DashboardProjects__ = __webpack_require__(3053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_admin_rfis_Rfis__ = __webpack_require__(3055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_admin_submittals_Submittals__ = __webpack_require__(3059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_admin_projects_MissingDailyReports__ = __webpack_require__(3063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_admin_projects_BidsDue__ = __webpack_require__(3065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_admin_project_open_items_ProjectOpenItems__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_admin_project_open_items_ProjectOpenItemsCritical__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_admin_project_open_items_ProjectOpenItemsTabs__ = __webpack_require__(3068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_admin_field_work_orders_FieldWorkOrders__ = __webpack_require__(3070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_components_admin_quotes_BidsDue__ = __webpack_require__(3074);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DashboardNav=function(_Component){_inherits(DashboardNav,_Component);function DashboardNav(props){_classCallCheck(this,DashboardNav);var _this=_possibleConstructorReturn(this,(DashboardNav.__proto__||Object.getPrototypeOf(DashboardNav)).call(this,props));_this.renderTitle=function(){return _this.showMyProjects?'My Projects':'Projects';};_this.buildNavItems=function(){var _this$props=_this.props,rfisCount=_this$props.rfisCount,submittalsCount=_this$props.submittalsCount,missingDrsCount=_this$props.missingDrsCount,projectOpenItemsCount=_this$props.projectOpenItemsCount,projectOpenItemsCritCount=_this$props.projectOpenItemsCritCount,fieldWorkOrdersCount=_this$props.fieldWorkOrdersCount;return[{count:rfisCount,title:'OVERDUE RFIS'},{count:submittalsCount,title:'OVERDUE SUBMITTALS'},_this.spackleOrGc?{count:missingDrsCount,title:'MISSING DAILY REPORTS'}:_this.subcontractor?{count:projectOpenItemsCount+projectOpenItemsCritCount,title:'OVERDUE/CRITICAL OPEN ITEMS'}:{count:projectOpenItemsCount,title:'OVERDUE OPEN ITEMS'},_this.subcontractor?{count:fieldWorkOrdersCount,title:'PENDING FWO TICKETS'}:{count:projectOpenItemsCritCount,title:'CRITICAL OPEN ITEMS'}].map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'count'},item.count),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},item.title));});};_this.buildContentItems=function(){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_admin_dashboard_DashboardProjects__["a" /* default */],{perPage:_this.perPage,showNav:!_this.showMyProjects,showSw:_this.spackle||_this.client||_this.subcontractor}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_admin_rfis_Rfis__["a" /* default */],{filters:_this.filters}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_components_admin_submittals_Submittals__["a" /* default */],{filters:_this.filters}),_this.spackleOrGc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_components_admin_projects_MissingDailyReports__["a" /* default */],{filters:_this.filtersDrs}):_this.subcontractor?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_components_admin_project_open_items_ProjectOpenItemsTabs__["a" /* default */],{filters:_this.filters,filtersCritical:_this.filtersCritical}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_admin_project_open_items_ProjectOpenItems__["a" /* default */],{filters:_this.filters}),_this.subcontractor?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_components_admin_field_work_orders_FieldWorkOrders__["a" /* default */],{filters:_this.filtersFwos}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_components_admin_project_open_items_ProjectOpenItemsCritical__["a" /* default */],{filters:_this.filtersCritical})];};_this.handleNavClick=function(nav){var currentNav=_this.state.currentNav;currentNav===nav?_this.setState({currentNav:0}):_this.setState({currentNav:nav});};_this.toggleBidsDue=function(){_this.setState({showBidsDue:!_this.state.showBidsDue});};_this.bidsDueButtonLabel=function(){var _this$props2=_this.props,bidsDueCount=_this$props2.bidsDueCount,quotesCount=_this$props2.quotesCount;var label='\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0';if(_this.spackle||_this.subcontractor){label='RFPs Due'+label+'('+quotesCount+')';}else{label='Bids Due'+label+'('+bidsDueCount+')';}return label;};var dashboard=new __WEBPACK_IMPORTED_MODULE_5_domain_dashboard__["a" /* Dashboard */](props.currentUser);_this.perPage=dashboard.perPage;_this.spackleOrGc=dashboard.spackleOrGc;_this.spackle=dashboard.spackle;_this.client=dashboard.client;_this.subcontractor=dashboard.subcontractor;_this.showMyProjects=dashboard.showMyProjects;_this.filters=dashboard.filters;_this.filtersDrs=dashboard.filtersDrs;_this.filtersBidsDue=dashboard.filtersBidsDue;_this.filtersQuotesBidsDue=dashboard.filtersQuotesBidsDue;_this.filtersCritical=dashboard.filtersCritical;_this.filtersFwos=dashboard.filtersFwos;_this.state={currentNav:0,showBidsDue:false};return _this;}_createClass(DashboardNav,[{key:'componentDidMount',value:function componentDidMount(){var dispatch=this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_rfis_store_actions__["a" /* rfisCount */])(this.filters));dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_submittals_store_actions__["a" /* submittalsCount */])(this.filters));dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_project_open_items_store_actions__["b" /* projectOpenItemsCriticalCount */])(this.filtersCritical));if(this.spackle||this.subcontractor){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_actions_admin_quotes_quotes__["c" /* quotesCount */])(this.filtersQuotesBidsDue));}else if(this.spackleOrGc){dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_store_actions__["b" /* bidsDueCount */])(this.filtersBidsDue));}if(this.spackleOrGc){dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_store_actions__["j" /* missingDrsCount */])(this.filtersDrs));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_project_open_items_store_actions__["a" /* projectOpenItemsCount */])(this.filters));}if(this.subcontractor){dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_components_admin_field_work_orders_store_actions__["a" /* fieldWorkOrdersCount */])(this.filtersFwos));}}},{key:'componentDidUpdate',value:function componentDidUpdate(){Object(__WEBPACK_IMPORTED_MODULE_4_services_utils_scroller_util__["c" /* simpleScrollToTop */])();this.navContentDiv.scrollTop=0;}},{key:'render',value:function render(){var _this2=this;var navItems=this.buildNavItems();var contentItems=this.buildContentItems();var _state=this.state,currentNav=_state.currentNav,showBidsDue=_state.showBidsDue;var title=this.renderTitle();var bidsDueButtonLabel=this.bidsDueButtonLabel();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dashboard-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dashboard-nav-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-title'},title),(this.spackleOrGc||this.subcontractor)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_shared_button_Button__["a" /* default */],{className:'button-orange button-bids-due',label:bidsDueButtonLabel,onClick:this.toggleBidsDue})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dashboard-nav-items'},navItems.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'dashboard-nav-item':true,selected:currentNav===index+1}),onClick:function onClick(){return _this2.handleNavClick(index+1);}},item);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dashboard-nav-indicator indicator-'+currentNav}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dashboard-nav-content',ref:function ref(_ref){return _this2.navContentDiv=_ref;}},currentNav!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'back-to-projects',onClick:function onClick(){return _this2.handleNavClick(0);}},'Back to All ',title),contentItems.find(function(item,index){return currentNav===index;})),showBidsDue&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_shared_modal_FormModal__["a" /* default */],{show:showBidsDue,title:this.spackle||this.subcontractor?'RFPs Due':'Bids Due',onClose:this.toggleBidsDue},this.spackle||this.subcontractor?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_components_admin_quotes_BidsDue__["a" /* default */],{filters:this.filtersQuotesBidsDue}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_components_admin_projects_BidsDue__["a" /* default */],{filters:this.filtersBidsDue})));}}]);return DashboardNav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_authentication__["d" /* getCurrentUser */])(state),rfisCount:Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_rfis_store_selectors__["e" /* getRfisCount */])(state),submittalsCount:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_submittals_store_selectors__["e" /* getSubmittalsCount */])(state),missingDrsCount:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_store_selectors__["g" /* getMissingDrsCount */])(state),bidsDueCount:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_store_selectors__["b" /* getBidsDueCount */])(state),projectOpenItemsCount:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_project_open_items_store_selectors__["e" /* getProjectOpenItemsCount */])(state),projectOpenItemsCritCount:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_project_open_items_store_selectors__["f" /* getProjectOpenItemsCritCount */])(state),fieldWorkOrdersCount:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_field_work_orders_store_selectors__["c" /* getFieldWorkOrdersCount */])(state),quotesCount:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_admin_quotes_quotes__["c" /* getQuotesCount */])(state)};})(DashboardNav));

/***/ }),
/* 3051 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dashboard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var PER_PAGE=5;var Dashboard=function(){function Dashboard(currentUser){_classCallCheck(this,Dashboard);this._perPage=PER_PAGE;this._spackleOrGc=__WEBPACK_IMPORTED_MODULE_1_domain_enterprise__["a" /* Enterprise */].showActions(currentUser);this._spackle=__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].isAdmin(currentUser);this._client=__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["f" /* TYPES */].CLIENT);this._subcontractor=__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_0_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);this._primary=!this.spackleOrGc&&!this.subcontractor;this._showMyProjects=__WEBPACK_IMPORTED_MODULE_1_domain_enterprise__["a" /* Enterprise */].showMyProjects(currentUser);this._filtersGeneral=this.buildFiltersGeneral();this._filters=this.buildFilters();this._filtersDrs=this.buildFiltersDrs();this._filtersBidsDue=this.buildFiltersBidsDue();this._filtersQuotesBidsDue=this.buildFiltersQuotesBidsDue();this._filtersCritical=this.buildFiltersCritical();this._filtersFwos=this.buildFiltersFwos();}_createClass(Dashboard,[{key:'buildFiltersGeneral',value:function buildFiltersGeneral(){var filters={per_page:this.perPage};if(this.showMyProjects){filters.my_projects=true;}if(this.primary){filters.assigned_to_me=true;}return filters;}},{key:'buildFilters',value:function buildFilters(){return Object.assign({},this.filtersGeneral,{past_due:__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD')});}},{key:'buildFiltersDrs',value:function buildFiltersDrs(){return Object.assign({},this.filtersGeneral,{missing_drs:__WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(3,'days').format('YYYY-MM-DD')});}},{key:'buildFiltersBidsDue',value:function buildFiltersBidsDue(){return{per_page:this.perPage,bids_due:__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD')};}},{key:'buildFiltersQuotesBidsDue',value:function buildFiltersQuotesBidsDue(){return{per_page:this.perPage,agg:true,waiting:true};}},{key:'buildFiltersCritical',value:function buildFiltersCritical(){return Object.assign({},this.filtersGeneral,{unresolved:true,critical:true});}},{key:'buildFiltersFwos',value:function buildFiltersFwos(){return Object.assign({},this.filtersGeneral,{pending:true});}},{key:'perPage',get:function get(){return this._perPage;}},{key:'spackleOrGc',get:function get(){return this._spackleOrGc;}},{key:'spackle',get:function get(){return this._spackle;}},{key:'client',get:function get(){return this._client;}},{key:'subcontractor',get:function get(){return this._subcontractor;}},{key:'primary',get:function get(){return this._primary;}},{key:'showMyProjects',get:function get(){return this._showMyProjects;}},{key:'filtersGeneral',get:function get(){return this._filtersGeneral;}},{key:'filters',get:function get(){return this._filters;}},{key:'filtersDrs',get:function get(){return this._filtersDrs;}},{key:'filtersBidsDue',get:function get(){return this._filtersBidsDue;}},{key:'filtersQuotesBidsDue',get:function get(){return this._filtersQuotesBidsDue;}},{key:'filtersCritical',get:function get(){return this._filtersCritical;}},{key:'filtersFwos',get:function get(){return this._filtersFwos;}}]);return Dashboard;}();

/***/ }),
/* 3053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DashboardProjects_css__ = __webpack_require__(3054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DashboardProjects_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DashboardProjects_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_Projects__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_WorkOrders__ = __webpack_require__(769);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DashboardProjects=function(_Component){_inherits(DashboardProjects,_Component);function DashboardProjects(props){_classCallCheck(this,DashboardProjects);var _this=_possibleConstructorReturn(this,(DashboardProjects.__proto__||Object.getPrototypeOf(DashboardProjects)).call(this,props));_this.handleTabSelection=function(tab){_this.setState({tab:tab});};_this.state={tab:1};return _this;}_createClass(DashboardProjects,[{key:'render',value:function render(){var _props=this.props,perPage=_props.perPage,showNav=_props.showNav,showSw=_props.showSw;var tab=this.state.tab;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dashboard-projects'},showSw&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dashboard-projects-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'Projects'},{id:2,title:'Work Orders'}],selectedValue:tab,onSelected:this.handleTabSelection})),tab===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_Projects__["a" /* default */],{perPage:perPage,showTitle:false,showControls:false,showNav:showNav}),tab===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_work_orders_WorkOrders__["a" /* default */],{perPage:perPage,showTitle:false,showControls:false}));}}]);return DashboardProjects;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DashboardProjects.propTypes={perPage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,showNav:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,showSw:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};DashboardProjects.defaultProps={perPage:5,showNav:false,showSw:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(DashboardProjects));

/***/ }),
/* 3054 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Rfis_css__ = __webpack_require__(3056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Rfis_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Rfis_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_rfis_store_actions__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_rfis_RfisTable__ = __webpack_require__(3057);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Rfis=function(_Component){_inherits(Rfis,_Component);function Rfis(props){_classCallCheck(this,Rfis);var _this=_possibleConstructorReturn(this,(Rfis.__proto__||Object.getPrototypeOf(Rfis)).call(this,props));_this.handlePageChange=function(page,status){var _this$props=_this.props,filters=_this$props.filters,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_rfis_store_actions__["b" /* rfisRequest */])(page,status,Object.assign({},filters,_defineProperty({},status,true))));};_this.defaultStatus=function(){var rfisTab=arguments.length>0&&arguments[0]!==undefined?arguments[0]:2;return _this.spackleOrGc&&(rfisTab===1?'pending':'not_pre')||'all';};_this.handleRfisTabSelection=function(rfisTab){_this.handlePageChange(1,_this.defaultStatus(rfisTab));_this.setState({rfisTab:rfisTab});};_this.spackleOrGc=__WEBPACK_IMPORTED_MODULE_5_domain_enterprise__["a" /* Enterprise */].showActions(props.currentUser);_this.state={rfisTab:2};return _this;}_createClass(Rfis,[{key:'componentDidMount',value:function componentDidMount(){this.handlePageChange(1,this.defaultStatus());}},{key:'render',value:function render(){var rfisTab=this.state.rfisTab;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rfis'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rfis-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'P-RFI LOG',show:this.spackleOrGc},{id:2,title:'RFI LOG'}],selectedValue:rfisTab,onSelected:this.handleRfisTabSelection})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_admin_rfis_RfisTable__["a" /* default */],{onPageChange:this.handlePageChange}));}}]);return Rfis;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Rfis.propTypes={filters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape()};Rfis.defaultProps={filters:{}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_authentication__["d" /* getCurrentUser */])(state)};})(Rfis));

/***/ }),
/* 3056 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RfisTable_css__ = __webpack_require__(3058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RfisTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RfisTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_rfi_log_RfiModalContainer__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_utils_text_util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_rfis_store_selectors__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_store_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_rfi_log_store_actions__ = __webpack_require__(169);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RfisTable=function(_Component){_inherits(RfisTable,_Component);function RfisTable(props){_classCallCheck(this,RfisTable);var _this=_possibleConstructorReturn(this,(RfisTable.__proto__||Object.getPrototypeOf(RfisTable)).call(this,props));_this.open=function(id){var rfi=_this.props.rfis.find(function(rfi){return rfi.id===id;});var _this$props=_this.props,currentUser=_this$props.currentUser,dispatch=_this$props.dispatch;_this.setState({showModal:true});dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_store_actions__["b" /* loadProjectRequest */])(rfi.project_id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_rfi_log_store_actions__["p" /* openRfi */])(rfi.project_id,rfi.id,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["g" /* usersUtil */].hasType(currentUser,__WEBPACK_IMPORTED_MODULE_8_services_utils_users_util__["f" /* TYPES */].CONTRACTOR)));};_this.close=function(){var _this$props2=_this.props,currentPage=_this$props2.currentPage,currentStatus=_this$props2.currentStatus,onPageChange=_this$props2.onPageChange;_this.setState({showModal:false});onPageChange(currentPage,currentStatus);};_this.handleGenerateLink=function(id){var rfis=_this.props.rfis;var rfi=rfis.find(function(rfi){return rfi.id===id;});return'projects/'+rfi.project_id+'?rfiId='+id;};_this.mapRfis=function(){return _this.props.rfis.map(function(rfi){return{id:rfi.id,data:[rfi.project_number,rfi.project_name,Object(__WEBPACK_IMPORTED_MODULE_9_services_utils_text_util__["b" /* formatNumber */])(rfi.number),rfi.csi_code.division,rfi.title||'-',rfi.due_date?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__["a" /* default */],{className:'due-date',value:rfi.extended_due_date?rfi.extended_due_date:rfi.due_date,format:'MM/DD/YYYY'}):'-']};});};_this.state={showModal:false};return _this;}_createClass(RfisTable,[{key:'render',value:function render(){var _props=this.props,currentStatus=_props.currentStatus,total=_props.total,currentPage=_props.currentPage,pageSize=_props.pageSize,_onPageChange=_props.onPageChange;var showModal=this.state.showModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rfis-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table',headers:['PROJECT #','NAME','#','CSI CODE','TITLE','DUE'],rows:this.mapRfis(),emptyMessage:'No RFI\'s added yet.',onRowSelected:this.open,onGenerateLink:this.handleGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPage,pageSize:pageSize,total:total,onPageChange:function onPageChange(page){return _onPageChange(page,currentStatus);}})),showModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_rfi_log_RfiModalContainer__["a" /* default */],{onClose:this.close}));}}]);return RfisTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RfisTable.propTypes={onPageChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_authentication__["d" /* getCurrentUser */])(state),rfis:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_rfis_store_selectors__["d" /* getRfis */])(state),currentStatus:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_rfis_store_selectors__["b" /* getCurrentStatus */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_rfis_store_selectors__["f" /* getTotal */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_rfis_store_selectors__["a" /* getCurrentPage */])(state),pageSize:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_rfis_store_selectors__["c" /* getPageSize */])(state)};})(RfisTable));

/***/ }),
/* 3058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Submittals_css__ = __webpack_require__(3060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Submittals_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Submittals_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_domain_enterprise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_submittals_store_actions__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_submittals_SubmittalsTable__ = __webpack_require__(3061);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Submittals=function(_Component){_inherits(Submittals,_Component);function Submittals(props){_classCallCheck(this,Submittals);var _this=_possibleConstructorReturn(this,(Submittals.__proto__||Object.getPrototypeOf(Submittals)).call(this,props));_this.handlePageChange=function(page,status){var _this$props=_this.props,filters=_this$props.filters,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_components_admin_submittals_store_actions__["b" /* submittalsRequest */])(page,status,Object.assign({},filters,_defineProperty({},status,true))));};_this.defaultStatus=function(){var submittalsTab=arguments.length>0&&arguments[0]!==undefined?arguments[0]:2;return _this.spackleOrGc&&(submittalsTab===1?'pre':'not_pre')||'all';};_this.handleSubmittalsTabSelection=function(submittalsTab){_this.handlePageChange(1,_this.defaultStatus(submittalsTab));_this.setState({submittalsTab:submittalsTab});};_this.spackleOrGc=__WEBPACK_IMPORTED_MODULE_5_domain_enterprise__["a" /* Enterprise */].showActions(props.currentUser);_this.state={submittalsTab:2};return _this;}_createClass(Submittals,[{key:'componentDidMount',value:function componentDidMount(){this.handlePageChange(1,this.defaultStatus());}},{key:'render',value:function render(){var submittalsTab=this.state.submittalsTab;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submittals'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submittals-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'P-SUBMITTAL LOG',show:this.spackleOrGc},{id:2,title:'SUBMITTAL LOG'}],selectedValue:submittalsTab,onSelected:this.handleSubmittalsTabSelection})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_admin_submittals_SubmittalsTable__["a" /* default */],{onPageChange:this.handlePageChange}));}}]);return Submittals;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Submittals.propTypes={filters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape()};Submittals.defaultProps={filters:{}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_authentication__["d" /* getCurrentUser */])(state)};})(Submittals));

/***/ }),
/* 3060 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubmittalsTable_css__ = __webpack_require__(3062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubmittalsTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SubmittalsTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_submittal_log_SubmittalModalContainer__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_domain_submittal__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_submittals_store_selectors__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_store_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_submittal_log_store_actions__ = __webpack_require__(131);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubmittalsTable=function(_Component){_inherits(SubmittalsTable,_Component);function SubmittalsTable(props){_classCallCheck(this,SubmittalsTable);var _this=_possibleConstructorReturn(this,(SubmittalsTable.__proto__||Object.getPrototypeOf(SubmittalsTable)).call(this,props));_this.open=function(submittal){var _this$props=_this.props,currentUser=_this$props.currentUser,dispatch=_this$props.dispatch;_this.setState({showModal:true});dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_store_actions__["b" /* loadProjectRequest */])(submittal.project_id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_submittal_log_store_actions__["p" /* openSubmittal */])(submittal.project_id,submittal.id,currentUser));};_this.close=function(){var _this$props2=_this.props,currentPage=_this$props2.currentPage,currentStatus=_this$props2.currentStatus,onPageChange=_this$props2.onPageChange;_this.setState({showModal:false});onPageChange(currentPage,currentStatus);};_this.addlAssignee=function(submittal){var currentUser=_this.props.currentUser;return __WEBPACK_IMPORTED_MODULE_8_domain_submittal__["a" /* Submittal */].addlAssignee(submittal,currentUser);};_this.dueDate=function(submittal){var addlAssignee=_this.addlAssignee(submittal);return addlAssignee?addlAssignee.due_date:submittal.extended_due_date?submittal.extended_due_date:submittal.due_date;};_this.handleGenerateLink=function(id){var submittals=_this.props.submittals;var submittal=submittals.find(function(submittal){return submittal.id===id;});return'projects/'+submittal.project_id+'?submittalId='+id;};_this.mapSubmittals=function(){var _ref;var currentStatus=_this.props.currentStatus;var currentCsiCodeId=null;return(_ref=[]).concat.apply(_ref,_toConsumableArray(_this.props.submittals.map(function(submittal){var dueDate=_this.dueDate(submittal);var link=_this.handleGenerateLink(submittal.id);var row=[];if(currentCsiCodeId!==submittal.csi_code.id){currentCsiCodeId=submittal.csi_code.id;row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'csi-'+currentCsiCodeId,className:'csi-code-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,submittal.csi_code.division),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,submittal.csi_code.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null)));}row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:submittal.id,className:'selectable link-tab',onClick:function onClick(e){e.preventDefault();_this.open(submittal,currentStatus);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},submittal.project_number)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},submittal.project_name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},submittal.csi_code.division,'-',submittal.number)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},submittal.title||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'due-date'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link},dueDate?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__["a" /* default */],{value:dueDate,format:'MM/DD/YYYY'}):'-'))));return row;})));};_this.state={showModal:false};return _this;}_createClass(SubmittalsTable,[{key:'render',value:function render(){var _props=this.props,submittals=_props.submittals,currentStatus=_props.currentStatus,total=_props.total,currentPage=_props.currentPage,pageSize=_props.pageSize,_onPageChange=_props.onPageChange;var showModal=this.state.showModal;var headers=['PROJECT #','NAME','CSI CODE','TITLE','DUE'];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submittals-table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["t" /* Table */],{className:'simple-table projects-table submittals-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,headers.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{key:index+1});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,headers.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,submittals.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'td-empty-table',colSpan:headers.length},'No Submittals added yet.')):this.mapSubmittals())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPage,pageSize:pageSize,total:total,onPageChange:function onPageChange(page){return _onPageChange(page,currentStatus);}})),showModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_submittal_log_SubmittalModalContainer__["a" /* default */],{onClose:this.close}));}}]);return SubmittalsTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubmittalsTable.propTypes={onPageChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_authentication__["d" /* getCurrentUser */])(state),submittals:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_submittals_store_selectors__["d" /* getSubmittals */])(state),currentStatus:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_submittals_store_selectors__["b" /* getCurrentStatus */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_submittals_store_selectors__["f" /* getTotal */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_submittals_store_selectors__["a" /* getCurrentPage */])(state),pageSize:Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_submittals_store_selectors__["c" /* getPageSize */])(state)};})(SubmittalsTable));

/***/ }),
/* 3062 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MissingDailyReports_css__ = __webpack_require__(3064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MissingDailyReports_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MissingDailyReports_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_modal_MessageModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_store_selectors__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_store_actions__ = __webpack_require__(162);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MissingDailyReports=function(_Component){_inherits(MissingDailyReports,_Component);function MissingDailyReports(props){_classCallCheck(this,MissingDailyReports);var _this=_possibleConstructorReturn(this,(MissingDailyReports.__proto__||Object.getPrototypeOf(MissingDailyReports)).call(this,props));_this.handlePageChange=function(page){var _this$props=_this.props,filters=_this$props.filters,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_store_actions__["h" /* loadMissingDrsRequest */])(Object.assign({},filters,{page:page})));};_this.handleOpen=function(id){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_store_actions__["f" /* goToProjectDetails */])(id));};_this.handleSendReminder=function(project,event){var dispatch=_this.props.dispatch;event.stopPropagation();dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_store_actions__["d" /* dailyReportsReminder */])(project.id)).then(function(response){if(response.ok){_this.setState({reminderSent:true});}});};_this.handleHideReminderSent=function(){_this.setState({reminderSent:false});};_this.mapProjects=function(){var projects=_this.props.projects;return projects.content.map(function(project){return{id:project.id,data:[project.number,project.name,project.last_dr_date&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_text_Date__["a" /* default */],{className:'last-dr-date',value:project.last_dr_date,format:'MM/DD/YYYY'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_button_Button__["a" /* default */],{className:'button-blue-grey',label:'Send Reminder',onClick:function onClick(e){return _this.handleSendReminder(project,e);}}))]};});};_this.handleGenerateLink=function(id){return'projects/'+id;};_this.state={reminderSent:false};return _this;}_createClass(MissingDailyReports,[{key:'componentDidMount',value:function componentDidMount(){this.handlePageChange(1);}},{key:'render',value:function render(){var _props=this.props,projects=_props.projects,currentPage=_props.currentPage;var reminderSent=this.state.reminderSent;return projects&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'missing-daily-reports'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table',headers:['PROJECT #','NAME','LAST SUBMISSION',''],rows:this.mapProjects(),emptyMessage:'No Projects',onRowSelected:this.handleOpen,onGenerateLink:this.handleGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPage,pageSize:projects.pageSize,total:projects.total,onPageChange:this.handlePageChange})),reminderSent&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_modal_MessageModal__["a" /* default */],{show:reminderSent,message:'Superintendent has been reminded to add the Daily Reports',onHide:this.handleHideReminderSent}));}}]);return MissingDailyReports;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MissingDailyReports.propTypes={filters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape()};MissingDailyReports.defaultProps={filters:{}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentPage:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_store_selectors__["h" /* getMissingDrsCurrentPage */])(state),projects:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_store_selectors__["f" /* getMissingDrs */])(state)};})(MissingDailyReports));

/***/ }),
/* 3064 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BidsDue_css__ = __webpack_require__(3066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BidsDue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BidsDue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_domain_project_status_enum__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_project_status_ProjectStatus__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_store_selectors__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_store_actions__ = __webpack_require__(162);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BidsDue=function(_Component){_inherits(BidsDue,_Component);function BidsDue(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BidsDue);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BidsDue.__proto__||Object.getPrototypeOf(BidsDue)).call.apply(_ref,[this].concat(args))),_this),_this.handlePageChange=function(page){var _this$props=_this.props,filters=_this$props.filters,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_store_actions__["g" /* loadBidsDueRequest */])(Object.assign({},filters,{page:page})));},_this.handleOpen=function(id){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_store_actions__["f" /* goToProjectDetails */])(id));},_this.handleGenerateLink=function(id){return'projects/'+id;},_this.mapProjects=function(){var projects=_this.props.projects;return projects.content.map(function(project){return{id:project.id,data:[project.number,project.name,project.bid_due_date&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__["a" /* default */],{className:'bid-due-date',value:project.bid_due_date,format:'MM/DD/YYYY'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_project_status_ProjectStatus__["a" /* default */],{status:__WEBPACK_IMPORTED_MODULE_4_domain_project_status_enum__["a" /* ProjectStatusEnum */].create(project.status)})]};});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BidsDue,[{key:'componentDidMount',value:function componentDidMount(){this.handlePageChange(1);}},{key:'render',value:function render(){var _props=this.props,projects=_props.projects,currentPage=_props.currentPage;return projects&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bids-due'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table',headers:['PROJECT #','NAME','BID DUE DATE','STATUS'],rows:this.mapProjects(),emptyMessage:'No Projects',onRowSelected:this.handleOpen,onGenerateLink:this.handleGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPage,pageSize:projects.pageSize,total:projects.total,onPageChange:this.handlePageChange})));}}]);return BidsDue;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BidsDue.propTypes={filters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape()};BidsDue.defaultProps={filters:{}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentPage:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_store_selectors__["c" /* getBidsDueCurrentPage */])(state),projects:Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_store_selectors__["a" /* getBidsDue */])(state)};})(BidsDue));

/***/ }),
/* 3066 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3067 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectOpenItemsTabs_css__ = __webpack_require__(3069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectOpenItemsTabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ProjectOpenItemsTabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_NavigationBar__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_project_open_items_ProjectOpenItems__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_project_open_items_ProjectOpenItemsCritical__ = __webpack_require__(1098);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectOpenItemsTabs=function(_Component){_inherits(ProjectOpenItemsTabs,_Component);function ProjectOpenItemsTabs(props){_classCallCheck(this,ProjectOpenItemsTabs);var _this=_possibleConstructorReturn(this,(ProjectOpenItemsTabs.__proto__||Object.getPrototypeOf(ProjectOpenItemsTabs)).call(this,props));_this.handleTabSelection=function(tab){_this.setState({tab:tab});};_this.state={tab:1};return _this;}_createClass(ProjectOpenItemsTabs,[{key:'render',value:function render(){var _props=this.props,filters=_props.filters,filtersCritical=_props.filtersCritical;var tab=this.state.tab;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-items-tabs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-open-items-tabs-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_navigation_NavigationBar__["a" /* default */],{items:[{id:1,title:'OVERDUE'},{id:2,title:'CRITICAL'}],selectedValue:tab,onSelected:this.handleTabSelection})),tab===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_admin_project_open_items_ProjectOpenItems__["a" /* default */],{filters:filters}),tab===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_project_open_items_ProjectOpenItemsCritical__["a" /* default */],{filters:filtersCritical}));}}]);return ProjectOpenItemsTabs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProjectOpenItemsTabs.propTypes={filters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape(),filtersCritical:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape()};ProjectOpenItemsTabs.defaultProps={filters:{},filtersCritical:{}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{};})(ProjectOpenItemsTabs));

/***/ }),
/* 3069 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FieldWorkOrders_css__ = __webpack_require__(3071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FieldWorkOrders_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FieldWorkOrders_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_field_work_orders_store_actions__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_field_work_orders_FieldWorkOrdersTable__ = __webpack_require__(3072);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FieldWorkOrders=function(_Component){_inherits(FieldWorkOrders,_Component);function FieldWorkOrders(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FieldWorkOrders);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FieldWorkOrders.__proto__||Object.getPrototypeOf(FieldWorkOrders)).call.apply(_ref,[this].concat(args))),_this),_this.handlePageChange=function(page,status){var _this$props=_this.props,filters=_this$props.filters,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_components_admin_field_work_orders_store_actions__["b" /* fieldWorkOrdersRequest */])(page,filters));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FieldWorkOrders,[{key:'componentDidMount',value:function componentDidMount(){this.handlePageChange(1);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-orders'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_admin_field_work_orders_FieldWorkOrdersTable__["a" /* default */],{onPageChange:this.handlePageChange}));}}]);return FieldWorkOrders;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FieldWorkOrders.propTypes={filters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape()};FieldWorkOrders.defaultProps={filters:{}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{};})(FieldWorkOrders));

/***/ }),
/* 3071 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FieldWorkOrdersTable_css__ = __webpack_require__(3073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FieldWorkOrdersTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FieldWorkOrdersTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_daily_report_log_FieldWorkOrderModal__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_field_work_orders_store_selectors__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_actions__ = __webpack_require__(95);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FieldWorkOrdersTable=function(_Component){_inherits(FieldWorkOrdersTable,_Component);function FieldWorkOrdersTable(props){_classCallCheck(this,FieldWorkOrdersTable);var _this=_possibleConstructorReturn(this,(FieldWorkOrdersTable.__proto__||Object.getPrototypeOf(FieldWorkOrdersTable)).call(this,props));_this.handleGenerateLink=function(id){var fieldWorkOrders=_this.props.fieldWorkOrders;var fwo=fieldWorkOrders.find(function(fwo){return fwo.id===id;});return'projects/'+fwo.project_id+'?fieldWorkOrderId='+id;};_this.open=function(id){var fieldWorkOrder=_this.props.fieldWorkOrders.find(function(fieldWorkOrder){return fieldWorkOrder.id===id;});var dispatch=_this.props.dispatch;_this.setState({showModal:true});dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_store_actions__["b" /* loadProjectRequest */])(fieldWorkOrder.project_id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_daily_report_log_store_actions__["J" /* openFieldWorkOrder */])(fieldWorkOrder.project_id,fieldWorkOrder.id));};_this.close=function(){var _this$props=_this.props,currentPage=_this$props.currentPage,onPageChange=_this$props.onPageChange;_this.setState({showModal:false});onPageChange(currentPage);};_this.mapFieldWorkOrders=function(){return _this.props.fieldWorkOrders.map(function(fieldWorkOrder){return{id:fieldWorkOrder.id,data:[fieldWorkOrder.project_number,fieldWorkOrder.project_name,fieldWorkOrder.number,fieldWorkOrder.csi_code.division,fieldWorkOrder.work_performed||'-',fieldWorkOrder.start_date?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__["a" /* default */],{className:'date-field',value:fieldWorkOrder.start_date,format:'MM/DD/YYYY'}):'TBD',fieldWorkOrder.completion_date?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__["a" /* default */],{className:'date-field',value:fieldWorkOrder.completion_date,format:'MM/DD/YYYY'}):'TBD']};});};_this.state={showModal:false};return _this;}_createClass(FieldWorkOrdersTable,[{key:'render',value:function render(){var _props=this.props,total=_props.total,currentPage=_props.currentPage,pageSize=_props.pageSize,onPageChange=_props.onPageChange;var showModal=this.state.showModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-work-orders-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table',headers:['PROJECT #','NAME','#','CSI CODE','WORK TO BE PERFORMED','START','COMPLETION'],rows:this.mapFieldWorkOrders(),emptyMessage:'No FWO\'s added yet.',onRowSelected:this.open,onGenerateLink:this.handleGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPage,pageSize:pageSize,total:total,onPageChange:onPageChange})),showModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_daily_report_log_FieldWorkOrderModal__["a" /* default */],{onClose:this.close}));}}]);return FieldWorkOrdersTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FieldWorkOrdersTable.propTypes={onPageChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{fieldWorkOrders:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_field_work_orders_store_selectors__["b" /* getFieldWorkOrders */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_field_work_orders_store_selectors__["e" /* getTotal */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_field_work_orders_store_selectors__["a" /* getCurrentPage */])(state),pageSize:Object(__WEBPACK_IMPORTED_MODULE_8_components_admin_field_work_orders_store_selectors__["d" /* getPageSize */])(state)};})(FieldWorkOrdersTable));

/***/ }),
/* 3073 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BidsDue_css__ = __webpack_require__(3075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BidsDue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BidsDue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_table_cell_addons_QuoteStatus__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_selectors_admin_quotes_quotes__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_actions_admin_quotes_quotes__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_details__ = __webpack_require__(34);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BidsDue=function(_Component){_inherits(BidsDue,_Component);function BidsDue(props){_classCallCheck(this,BidsDue);var _this=_possibleConstructorReturn(this,(BidsDue.__proto__||Object.getPrototypeOf(BidsDue)).call(this,props));_this.handlePageChange=function(page){var _this$props=_this.props,filters=_this$props.filters,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_actions_admin_quotes_quotes__["b" /* loadQuotesRequest */])(page,filters.waiting,filters.denied,filters.agg,filters.per_page));};_this.handleOpen=function(id){var _this$props2=_this.props,quotes=_this$props2.quotes,dispatch=_this$props2.dispatch;var quote=quotes.content.find(function(quote){return quote.id===id;});dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_admin_work_orders_details_details__["A" /* goToTask */])(quote.work_order.id,quote.task.id));};_this.handleGenerateLink=function(id){var quotes=_this.props.quotes;var quote=quotes.content.find(function(quote){return quote.id===id;});return'work-orders/'+quote.work_order.id+'/task/'+quote.task.id;};_this.mapquotes=function(){var quotes=_this.props.quotes;return quotes.content.map(function(quote){return{id:quote.id,data:[quote.work_order.number+'-'+quote.task.number,quote.work_order.name,quote.work_order.client.company_name,_this.spackle?quote.contractor_name:undefined,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__["a" /* default */],{className:'bid-due-date',value:quote.task.bid_due_date,format:'MM/DD/YYYY'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_table_cell_addons_QuoteStatus__["a" /* default */],{status:quote.status})].filter(function(field){return field!==undefined;})};});};_this.spackle=__WEBPACK_IMPORTED_MODULE_9_services_utils_users_util__["g" /* usersUtil */].isAdmin(props.currentUser)||__WEBPACK_IMPORTED_MODULE_9_services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_9_services_utils_users_util__["f" /* TYPES */].GENERAL_CONTRACTOR);return _this;}_createClass(BidsDue,[{key:'componentDidMount',value:function componentDidMount(){this.handlePageChange(1);}},{key:'render',value:function render(){var _props=this.props,quotes=_props.quotes,currentPage=_props.currentPage;return quotes&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bids-due'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_table_SimpleTable__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'projects-table':true,spackle:this.spackle}),headers:['WO #','NAME','CLIENT',this.spackle&&'CONTRACTOR','BID DUE DATE','STATUS'].filter(function(header){return header;}),rows:this.mapquotes(),emptyMessage:'No quotes',onRowSelected:this.handleOpen,onGenerateLink:this.handleGenerateLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPage,pageSize:quotes.pageSize,total:quotes.total,onPageChange:this.handlePageChange})));}}]);return BidsDue;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BidsDue.propTypes={filters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape()};BidsDue.defaultProps={filters:{}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_authentication__["d" /* getCurrentUser */])(state),currentPage:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_admin_quotes_quotes__["a" /* getCurrentPage */])(state),quotes:Object(__WEBPACK_IMPORTED_MODULE_11_selectors_admin_quotes_quotes__["b" /* getQuotes */])(state)};})(BidsDue));

/***/ }),
/* 3075 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_utils_users_util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_recent_activity_AllRecentActivity__ = __webpack_require__(3077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_recent_activity_SpeRecentActivity__ = __webpack_require__(3086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_recent_activity_SwRecentActivity__ = __webpack_require__(3087);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DashboardRecentActiviy=function(_Component){_inherits(DashboardRecentActiviy,_Component);function DashboardRecentActiviy(props){_classCallCheck(this,DashboardRecentActiviy);var _this=_possibleConstructorReturn(this,(DashboardRecentActiviy.__proto__||Object.getPrototypeOf(DashboardRecentActiviy)).call(this,props));_this.client=__WEBPACK_IMPORTED_MODULE_2_services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_2_services_utils_users_util__["f" /* TYPES */].CLIENT);_this.subcontractor=__WEBPACK_IMPORTED_MODULE_2_services_utils_users_util__["g" /* usersUtil */].hasType(props.currentUser,__WEBPACK_IMPORTED_MODULE_2_services_utils_users_util__["f" /* TYPES */].CONTRACTOR);return _this;}_createClass(DashboardRecentActiviy,[{key:'render',value:function render(){return this.client||this.subcontractor?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_admin_recent_activity_SpeRecentActivity__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_recent_activity_SwRecentActivity__["a" /* default */],null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_recent_activity_AllRecentActivity__["a" /* default */],null);}}]);return DashboardRecentActiviy;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_authentication__["d" /* getCurrentUser */])(state)};})(DashboardRecentActiviy));

/***/ }),
/* 3077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_recent_activity_store_selectors__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_recent_activity_store_actions__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_recent_activity_RecentActivity__ = __webpack_require__(652);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AllRecentActivity=function(_Component){_inherits(AllRecentActivity,_Component);function AllRecentActivity(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AllRecentActivity);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AllRecentActivity.__proto__||Object.getPrototypeOf(AllRecentActivity)).call.apply(_ref,[this].concat(args))),_this),_this.handlePageChange=function(page){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_recent_activity_store_actions__["b" /* recentActivityRequest */])(page)).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_recent_activity_store_actions__["a" /* allRecentActivitySuccess */])(response.notifications));}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AllRecentActivity,[{key:'render',value:function render(){var recentActivity=this.props.recentActivity;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_recent_activity_RecentActivity__["a" /* default */],{title:'Recent Activity',recentActivity:recentActivity,onPageChange:this.handlePageChange});}}]);return AllRecentActivity;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{recentActivity:Object(__WEBPACK_IMPORTED_MODULE_2_components_admin_recent_activity_store_selectors__["a" /* getAllRecentActivity */])(state)};})(AllRecentActivity));

/***/ }),
/* 3078 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NotificationViewer_css__ = __webpack_require__(3080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NotificationViewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__NotificationViewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bell_svg__ = __webpack_require__(3081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bell_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__bell_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_awesome_popover__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_awesome_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_awesome_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotificationViewer=function(_Component){_inherits(NotificationViewer,_Component);function NotificationViewer(props){_classCallCheck(this,NotificationViewer);var _this=_possibleConstructorReturn(this,(NotificationViewer.__proto__||Object.getPrototypeOf(NotificationViewer)).call(this,props));_this.scrollToTop=function(){if(_this.recentActContentEl){_this.recentActContentEl.scrollTop=0;}};_this.handleMessageOpen=function(id,event){event&&event.preventDefault();if(_this.props.onMessageOpen){_this.props.onMessageOpen(id);// Update state after calling "on" function
_this.setState({open:false});}};_this.handleMessageRead=function(id,event){event.preventDefault();if(_this.props.onMessageRead){_this.props.onMessageRead(id);}};_this.handleMessageUnread=function(id,event){event.preventDefault();if(_this.props.onMessageUnread){_this.props.onMessageUnread(id);}};_this.handleMarkAllAsRead=function(event){event.preventDefault();if(_this.props.onMarkAllAsRead){_this.props.onMarkAllAsRead();}};_this.handleOnClose=function(){_this.setState({open:false});};_this.handleOnOpen=function(){_this.setState({open:true});};_this.handleNewer=function(event){event.preventDefault();if(_this.props.onShowNewer){_this.props.onShowNewer();}};_this.handleOlder=function(event){event.preventDefault();if(_this.props.onShowOlder){_this.props.onShowOlder();}};_this.handlePageChange=function(newPage){var onPageChange=_this.props.onPageChange;_this.scrollToTop();onPageChange&&onPageChange(newPage);};_this.state={showRead:false,open:false};return _this;}_createClass(NotificationViewer,[{key:'render',value:function render(){var _this2=this;var _props=this.props,recentActivity=_props.recentActivity,currentPage=_props.currentPage,pageSize=_props.pageSize,total=_props.total;return recentActivity?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recent-activity-content',ref:function ref(el){return _this2.recentActContentEl=el;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table',headers:['',''],rows:this.renderRecentActivityMessages(),emptyMessage:'No Activity',onRowSelected:this.handleMessageOpen}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:currentPage,pageSize:pageSize,total:total,onPageChange:this.handlePageChange}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification-viewer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_awesome_popover___default.a,{placement:'bottom-end',open:this.state.open,onClose:this.handleOnClose,onOpen:this.handleOnOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'nv-bell-image',src:__WEBPACK_IMPORTED_MODULE_2__bell_svg___default.a,alt:'bell'}),this.renderNotificationsContainer()),this.props.totalUnread>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nv-unread-indicator '+(this.props.totalUnread>99?'medium':'small')},this.props.totalUnread));}},{key:'renderNotificationsContainer',value:function renderNotificationsContainer(){var maxPages=Math.ceil(this.props.total/this.props.pageSize);if(this.props.total===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nv-no-notifications'},'No Notifications');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nv-notification-container'},(this.props.total>this.props.pageSize||this.props.showLoader||this.props.totalUnread>0)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nv-messages-buttons-container'},this.props.total>this.props.pageSize&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nv-messages-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:this.props.currentPage===1,onClick:this.handleNewer},'<'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,(this.props.currentPage-1)*this.props.pageSize+1+'-'+Math.min(this.props.currentPage*this.props.pageSize,this.props.total)+' of '+this.props.total),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:this.props.currentPage===maxPages,onClick:this.handleOlder},'>')),this.props.showLoader&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nv-loader-container'},'Loading...'),this.props.totalUnread>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nv-messages-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.handleMarkAllAsRead},'Mark all as read'))),this.renderMessages(this.props.messages));}}},{key:'renderMessages',value:function renderMessages(messages){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nv-messages'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,messages.map(function(element){if(element.user!==null&&element.user!==undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:element.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:element.unread?'unread':'read'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'user'},element.user),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element.message),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'target'},element.target),element.content&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element.content))),_this3.renderMessagePopover(element.unread,element.id,element.webAvailable));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:element.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:element.unread?'unread':'read'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'target'},element.target),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element.message,'.'),element.content&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element.content))),_this3.renderMessagePopover(element.unread,element.id,element.webAvailable));}})));}},{key:'renderMessagePopover',value:function renderMessagePopover(unread,id){var webAvailable=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nv-message-popover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nv-message-popover-buttons'},webAvailable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:this.handleMessageOpen.bind(this,id)},'Open'),unread?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:this.handleMessageRead.bind(this,id)},'Mark as read'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:this.handleMessageUnread.bind(this,id)},'Mark as unread')));}},{key:'renderRecentActivityMessages',value:function renderRecentActivityMessages(){var messages=this.props.messages;return messages.map(function(element){if(element.user!==null&&element.user!==undefined){return{id:element.id,data:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recent-activity-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:element.unread?'unread':'read'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'user'},element.user),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element.message),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'target'},element.target),element.content&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element.content))))]};}else{return{id:element.id,data:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recent-activity-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:element.unread?'unread':'read'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'target'},element.target),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element.message,'.'),element.content&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element.content))))]};}});}}]);return NotificationViewer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NotificationViewer.propTypes={recentActivity:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,currentPage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,pageSize:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,messages:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,message:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,target:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,unread:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,user:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,content:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string})),showLoader:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,total:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,totalUnread:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,onMarkAllAsRead:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onMessageOpen:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onMessageRead:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onMessageUnread:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onShowNewer:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onShowOlder:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onPageChange:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};NotificationViewer.defaultProps={recentActivity:false,currentPage:1,pageSize:25,messages:[],showLoader:false,total:0,totalUnread:0};/* harmony default export */ __webpack_exports__["a"] = (NotificationViewer);

/***/ }),
/* 3080 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3081 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bell.2b3b933b.svg";

/***/ }),
/* 3082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(3083);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 3083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(134),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 3084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actioncable__ = __webpack_require__(3085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actioncable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_actioncable__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var NotificationsSocket=function(){function NotificationsSocket(uid,token,client,onUpdate){_classCallCheck(this,NotificationsSocket);var url="wss://spackle-v1.fly.dev/cable"+'?uid='+uid+'&token='+token+'&client='+client;this.cable=__WEBPACK_IMPORTED_MODULE_0_actioncable___default.a.createConsumer(url);this.onUpdate=onUpdate;}_createClass(NotificationsSocket,[{key:'subscribe',value:function subscribe(channel){return this.cable.subscriptions.create(channel,{received:this.onUpdate});}},{key:'disconnect',value:function disconnect(){if(this.cable){this.cable.disconnect();}}}]);return NotificationsSocket;}();/* harmony default export */ __webpack_exports__["a"] = (NotificationsSocket);

/***/ }),
/* 3085 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function() {
  var context = this;

  (function() {
    (function() {
      var slice = [].slice;

      this.ActionCable = {
        INTERNAL: {
          "message_types": {
            "welcome": "welcome",
            "ping": "ping",
            "confirmation": "confirm_subscription",
            "rejection": "reject_subscription"
          },
          "default_mount_path": "/cable",
          "protocols": ["actioncable-v1-json", "actioncable-unsupported"]
        },
        WebSocket: window.WebSocket,
        logger: window.console,
        createConsumer: function(url) {
          var ref;
          if (url == null) {
            url = (ref = this.getConfig("url")) != null ? ref : this.INTERNAL.default_mount_path;
          }
          return new ActionCable.Consumer(this.createWebSocketURL(url));
        },
        getConfig: function(name) {
          var element;
          element = document.head.querySelector("meta[name='action-cable-" + name + "']");
          return element != null ? element.getAttribute("content") : void 0;
        },
        createWebSocketURL: function(url) {
          var a;
          if (url && !/^wss?:/i.test(url)) {
            a = document.createElement("a");
            a.href = url;
            a.href = a.href;
            a.protocol = a.protocol.replace("http", "ws");
            return a.href;
          } else {
            return url;
          }
        },
        startDebugging: function() {
          return this.debugging = true;
        },
        stopDebugging: function() {
          return this.debugging = null;
        },
        log: function() {
          var messages, ref;
          messages = 1 <= arguments.length ? slice.call(arguments, 0) : [];
          if (this.debugging) {
            messages.push(Date.now());
            return (ref = this.logger).log.apply(ref, ["[ActionCable]"].concat(slice.call(messages)));
          }
        }
      };

    }).call(this);
  }).call(context);

  var ActionCable = context.ActionCable;

  (function() {
    (function() {
      var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

      ActionCable.ConnectionMonitor = (function() {
        var clamp, now, secondsSince;

        ConnectionMonitor.pollInterval = {
          min: 3,
          max: 30
        };

        ConnectionMonitor.staleThreshold = 6;

        function ConnectionMonitor(connection) {
          this.connection = connection;
          this.visibilityDidChange = bind(this.visibilityDidChange, this);
          this.reconnectAttempts = 0;
        }

        ConnectionMonitor.prototype.start = function() {
          if (!this.isRunning()) {
            this.startedAt = now();
            delete this.stoppedAt;
            this.startPolling();
            document.addEventListener("visibilitychange", this.visibilityDidChange);
            return ActionCable.log("ConnectionMonitor started. pollInterval = " + (this.getPollInterval()) + " ms");
          }
        };

        ConnectionMonitor.prototype.stop = function() {
          if (this.isRunning()) {
            this.stoppedAt = now();
            this.stopPolling();
            document.removeEventListener("visibilitychange", this.visibilityDidChange);
            return ActionCable.log("ConnectionMonitor stopped");
          }
        };

        ConnectionMonitor.prototype.isRunning = function() {
          return (this.startedAt != null) && (this.stoppedAt == null);
        };

        ConnectionMonitor.prototype.recordPing = function() {
          return this.pingedAt = now();
        };

        ConnectionMonitor.prototype.recordConnect = function() {
          this.reconnectAttempts = 0;
          this.recordPing();
          delete this.disconnectedAt;
          return ActionCable.log("ConnectionMonitor recorded connect");
        };

        ConnectionMonitor.prototype.recordDisconnect = function() {
          this.disconnectedAt = now();
          return ActionCable.log("ConnectionMonitor recorded disconnect");
        };

        ConnectionMonitor.prototype.startPolling = function() {
          this.stopPolling();
          return this.poll();
        };

        ConnectionMonitor.prototype.stopPolling = function() {
          return clearTimeout(this.pollTimeout);
        };

        ConnectionMonitor.prototype.poll = function() {
          return this.pollTimeout = setTimeout((function(_this) {
            return function() {
              _this.reconnectIfStale();
              return _this.poll();
            };
          })(this), this.getPollInterval());
        };

        ConnectionMonitor.prototype.getPollInterval = function() {
          var interval, max, min, ref;
          ref = this.constructor.pollInterval, min = ref.min, max = ref.max;
          interval = 5 * Math.log(this.reconnectAttempts + 1);
          return Math.round(clamp(interval, min, max) * 1000);
        };

        ConnectionMonitor.prototype.reconnectIfStale = function() {
          if (this.connectionIsStale()) {
            ActionCable.log("ConnectionMonitor detected stale connection. reconnectAttempts = " + this.reconnectAttempts + ", pollInterval = " + (this.getPollInterval()) + " ms, time disconnected = " + (secondsSince(this.disconnectedAt)) + " s, stale threshold = " + this.constructor.staleThreshold + " s");
            this.reconnectAttempts++;
            if (this.disconnectedRecently()) {
              return ActionCable.log("ConnectionMonitor skipping reopening recent disconnect");
            } else {
              ActionCable.log("ConnectionMonitor reopening");
              return this.connection.reopen();
            }
          }
        };

        ConnectionMonitor.prototype.connectionIsStale = function() {
          var ref;
          return secondsSince((ref = this.pingedAt) != null ? ref : this.startedAt) > this.constructor.staleThreshold;
        };

        ConnectionMonitor.prototype.disconnectedRecently = function() {
          return this.disconnectedAt && secondsSince(this.disconnectedAt) < this.constructor.staleThreshold;
        };

        ConnectionMonitor.prototype.visibilityDidChange = function() {
          if (document.visibilityState === "visible") {
            return setTimeout((function(_this) {
              return function() {
                if (_this.connectionIsStale() || !_this.connection.isOpen()) {
                  ActionCable.log("ConnectionMonitor reopening stale connection on visibilitychange. visbilityState = " + document.visibilityState);
                  return _this.connection.reopen();
                }
              };
            })(this), 200);
          }
        };

        now = function() {
          return new Date().getTime();
        };

        secondsSince = function(time) {
          return (now() - time) / 1000;
        };

        clamp = function(number, min, max) {
          return Math.max(min, Math.min(max, number));
        };

        return ConnectionMonitor;

      })();

    }).call(this);
    (function() {
      var i, message_types, protocols, ref, supportedProtocols, unsupportedProtocol,
        slice = [].slice,
        bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
        indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

      ref = ActionCable.INTERNAL, message_types = ref.message_types, protocols = ref.protocols;

      supportedProtocols = 2 <= protocols.length ? slice.call(protocols, 0, i = protocols.length - 1) : (i = 0, []), unsupportedProtocol = protocols[i++];

      ActionCable.Connection = (function() {
        Connection.reopenDelay = 500;

        function Connection(consumer) {
          this.consumer = consumer;
          this.open = bind(this.open, this);
          this.subscriptions = this.consumer.subscriptions;
          this.monitor = new ActionCable.ConnectionMonitor(this);
          this.disconnected = true;
        }

        Connection.prototype.send = function(data) {
          if (this.isOpen()) {
            this.webSocket.send(JSON.stringify(data));
            return true;
          } else {
            return false;
          }
        };

        Connection.prototype.open = function() {
          if (this.isActive()) {
            ActionCable.log("Attempted to open WebSocket, but existing socket is " + (this.getState()));
            return false;
          } else {
            ActionCable.log("Opening WebSocket, current state is " + (this.getState()) + ", subprotocols: " + protocols);
            if (this.webSocket != null) {
              this.uninstallEventHandlers();
            }
            this.webSocket = new ActionCable.WebSocket(this.consumer.url, protocols);
            this.installEventHandlers();
            this.monitor.start();
            return true;
          }
        };

        Connection.prototype.close = function(arg) {
          var allowReconnect, ref1;
          allowReconnect = (arg != null ? arg : {
            allowReconnect: true
          }).allowReconnect;
          if (!allowReconnect) {
            this.monitor.stop();
          }
          if (this.isActive()) {
            return (ref1 = this.webSocket) != null ? ref1.close() : void 0;
          }
        };

        Connection.prototype.reopen = function() {
          var error;
          ActionCable.log("Reopening WebSocket, current state is " + (this.getState()));
          if (this.isActive()) {
            try {
              return this.close();
            } catch (error1) {
              error = error1;
              return ActionCable.log("Failed to reopen WebSocket", error);
            } finally {
              ActionCable.log("Reopening WebSocket in " + this.constructor.reopenDelay + "ms");
              setTimeout(this.open, this.constructor.reopenDelay);
            }
          } else {
            return this.open();
          }
        };

        Connection.prototype.getProtocol = function() {
          var ref1;
          return (ref1 = this.webSocket) != null ? ref1.protocol : void 0;
        };

        Connection.prototype.isOpen = function() {
          return this.isState("open");
        };

        Connection.prototype.isActive = function() {
          return this.isState("open", "connecting");
        };

        Connection.prototype.isProtocolSupported = function() {
          var ref1;
          return ref1 = this.getProtocol(), indexOf.call(supportedProtocols, ref1) >= 0;
        };

        Connection.prototype.isState = function() {
          var ref1, states;
          states = 1 <= arguments.length ? slice.call(arguments, 0) : [];
          return ref1 = this.getState(), indexOf.call(states, ref1) >= 0;
        };

        Connection.prototype.getState = function() {
          var ref1, state, value;
          for (state in WebSocket) {
            value = WebSocket[state];
            if (value === ((ref1 = this.webSocket) != null ? ref1.readyState : void 0)) {
              return state.toLowerCase();
            }
          }
          return null;
        };

        Connection.prototype.installEventHandlers = function() {
          var eventName, handler;
          for (eventName in this.events) {
            handler = this.events[eventName].bind(this);
            this.webSocket["on" + eventName] = handler;
          }
        };

        Connection.prototype.uninstallEventHandlers = function() {
          var eventName;
          for (eventName in this.events) {
            this.webSocket["on" + eventName] = function() {};
          }
        };

        Connection.prototype.events = {
          message: function(event) {
            var identifier, message, ref1, type;
            if (!this.isProtocolSupported()) {
              return;
            }
            ref1 = JSON.parse(event.data), identifier = ref1.identifier, message = ref1.message, type = ref1.type;
            switch (type) {
              case message_types.welcome:
                this.monitor.recordConnect();
                return this.subscriptions.reload();
              case message_types.ping:
                return this.monitor.recordPing();
              case message_types.confirmation:
                return this.subscriptions.notify(identifier, "connected");
              case message_types.rejection:
                return this.subscriptions.reject(identifier);
              default:
                return this.subscriptions.notify(identifier, "received", message);
            }
          },
          open: function() {
            ActionCable.log("WebSocket onopen event, using '" + (this.getProtocol()) + "' subprotocol");
            this.disconnected = false;
            if (!this.isProtocolSupported()) {
              ActionCable.log("Protocol is unsupported. Stopping monitor and disconnecting.");
              return this.close({
                allowReconnect: false
              });
            }
          },
          close: function(event) {
            ActionCable.log("WebSocket onclose event");
            if (this.disconnected) {
              return;
            }
            this.disconnected = true;
            this.monitor.recordDisconnect();
            return this.subscriptions.notifyAll("disconnected", {
              willAttemptReconnect: this.monitor.isRunning()
            });
          },
          error: function() {
            return ActionCable.log("WebSocket onerror event");
          }
        };

        return Connection;

      })();

    }).call(this);
    (function() {
      var slice = [].slice;

      ActionCable.Subscriptions = (function() {
        function Subscriptions(consumer) {
          this.consumer = consumer;
          this.subscriptions = [];
        }

        Subscriptions.prototype.create = function(channelName, mixin) {
          var channel, params, subscription;
          channel = channelName;
          params = typeof channel === "object" ? channel : {
            channel: channel
          };
          subscription = new ActionCable.Subscription(this.consumer, params, mixin);
          return this.add(subscription);
        };

        Subscriptions.prototype.add = function(subscription) {
          this.subscriptions.push(subscription);
          this.consumer.ensureActiveConnection();
          this.notify(subscription, "initialized");
          this.sendCommand(subscription, "subscribe");
          return subscription;
        };

        Subscriptions.prototype.remove = function(subscription) {
          this.forget(subscription);
          if (!this.findAll(subscription.identifier).length) {
            this.sendCommand(subscription, "unsubscribe");
          }
          return subscription;
        };

        Subscriptions.prototype.reject = function(identifier) {
          var i, len, ref, results, subscription;
          ref = this.findAll(identifier);
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            subscription = ref[i];
            this.forget(subscription);
            this.notify(subscription, "rejected");
            results.push(subscription);
          }
          return results;
        };

        Subscriptions.prototype.forget = function(subscription) {
          var s;
          this.subscriptions = (function() {
            var i, len, ref, results;
            ref = this.subscriptions;
            results = [];
            for (i = 0, len = ref.length; i < len; i++) {
              s = ref[i];
              if (s !== subscription) {
                results.push(s);
              }
            }
            return results;
          }).call(this);
          return subscription;
        };

        Subscriptions.prototype.findAll = function(identifier) {
          var i, len, ref, results, s;
          ref = this.subscriptions;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            s = ref[i];
            if (s.identifier === identifier) {
              results.push(s);
            }
          }
          return results;
        };

        Subscriptions.prototype.reload = function() {
          var i, len, ref, results, subscription;
          ref = this.subscriptions;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            subscription = ref[i];
            results.push(this.sendCommand(subscription, "subscribe"));
          }
          return results;
        };

        Subscriptions.prototype.notifyAll = function() {
          var args, callbackName, i, len, ref, results, subscription;
          callbackName = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
          ref = this.subscriptions;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            subscription = ref[i];
            results.push(this.notify.apply(this, [subscription, callbackName].concat(slice.call(args))));
          }
          return results;
        };

        Subscriptions.prototype.notify = function() {
          var args, callbackName, i, len, results, subscription, subscriptions;
          subscription = arguments[0], callbackName = arguments[1], args = 3 <= arguments.length ? slice.call(arguments, 2) : [];
          if (typeof subscription === "string") {
            subscriptions = this.findAll(subscription);
          } else {
            subscriptions = [subscription];
          }
          results = [];
          for (i = 0, len = subscriptions.length; i < len; i++) {
            subscription = subscriptions[i];
            results.push(typeof subscription[callbackName] === "function" ? subscription[callbackName].apply(subscription, args) : void 0);
          }
          return results;
        };

        Subscriptions.prototype.sendCommand = function(subscription, command) {
          var identifier;
          identifier = subscription.identifier;
          return this.consumer.send({
            command: command,
            identifier: identifier
          });
        };

        return Subscriptions;

      })();

    }).call(this);
    (function() {
      ActionCable.Subscription = (function() {
        var extend;

        function Subscription(consumer, params, mixin) {
          this.consumer = consumer;
          if (params == null) {
            params = {};
          }
          this.identifier = JSON.stringify(params);
          extend(this, mixin);
        }

        Subscription.prototype.perform = function(action, data) {
          if (data == null) {
            data = {};
          }
          data.action = action;
          return this.send(data);
        };

        Subscription.prototype.send = function(data) {
          return this.consumer.send({
            command: "message",
            identifier: this.identifier,
            data: JSON.stringify(data)
          });
        };

        Subscription.prototype.unsubscribe = function() {
          return this.consumer.subscriptions.remove(this);
        };

        extend = function(object, properties) {
          var key, value;
          if (properties != null) {
            for (key in properties) {
              value = properties[key];
              object[key] = value;
            }
          }
          return object;
        };

        return Subscription;

      })();

    }).call(this);
    (function() {
      ActionCable.Consumer = (function() {
        function Consumer(url) {
          this.url = url;
          this.subscriptions = new ActionCable.Subscriptions(this);
          this.connection = new ActionCable.Connection(this);
        }

        Consumer.prototype.send = function(data) {
          return this.connection.send(data);
        };

        Consumer.prototype.connect = function() {
          return this.connection.open();
        };

        Consumer.prototype.disconnect = function() {
          return this.connection.close({
            allowReconnect: false
          });
        };

        Consumer.prototype.ensureActiveConnection = function() {
          if (!this.connection.isActive()) {
            return this.connection.open();
          }
        };

        return Consumer;

      })();

    }).call(this);
  }).call(this);

  if (typeof module === "object" && module.exports) {
    module.exports = ActionCable;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (ActionCable),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}).call(this);


/***/ }),
/* 3086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_recent_activity_store_selectors__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_recent_activity_store_actions__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_recent_activity_RecentActivity__ = __webpack_require__(652);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SpeRecentActivity=function(_Component){_inherits(SpeRecentActivity,_Component);function SpeRecentActivity(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SpeRecentActivity);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SpeRecentActivity.__proto__||Object.getPrototypeOf(SpeRecentActivity)).call.apply(_ref,[this].concat(args))),_this),_this.handlePageChange=function(page){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_recent_activity_store_actions__["b" /* recentActivityRequest */])(page,{spe:true})).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_recent_activity_store_actions__["c" /* speRecentActivitySuccess */])(response.notifications));}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SpeRecentActivity,[{key:'render',value:function render(){var recentActivity=this.props.recentActivity;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_recent_activity_RecentActivity__["a" /* default */],{title:'Enterprise Activity',recentActivity:recentActivity,onPageChange:this.handlePageChange});}}]);return SpeRecentActivity;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{recentActivity:Object(__WEBPACK_IMPORTED_MODULE_2_components_admin_recent_activity_store_selectors__["b" /* getSpeRecentActivity */])(state)};})(SpeRecentActivity));

/***/ }),
/* 3087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_recent_activity_store_selectors__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_recent_activity_store_actions__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_recent_activity_RecentActivity__ = __webpack_require__(652);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SwRecentActivity=function(_Component){_inherits(SwRecentActivity,_Component);function SwRecentActivity(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SwRecentActivity);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SwRecentActivity.__proto__||Object.getPrototypeOf(SwRecentActivity)).call.apply(_ref,[this].concat(args))),_this),_this.handlePageChange=function(page){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_recent_activity_store_actions__["b" /* recentActivityRequest */])(page,{service_work:true})).then(function(response){if(response.ok){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_admin_recent_activity_store_actions__["d" /* swRecentActivitySuccess */])(response.notifications));}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SwRecentActivity,[{key:'render',value:function render(){var recentActivity=this.props.recentActivity;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_recent_activity_RecentActivity__["a" /* default */],{title:'Service Work Activity',recentActivity:recentActivity,onPageChange:this.handlePageChange});}}]);return SwRecentActivity;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{recentActivity:Object(__WEBPACK_IMPORTED_MODULE_2_components_admin_recent_activity_store_selectors__["c" /* getSwRecentActivity */])(state)};})(SwRecentActivity));

/***/ }),
/* 3088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ChatActivity_css__ = __webpack_require__(3089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ChatActivity_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ChatActivity_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_pagination_SimplePagination__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_rfi_log_RfiModalContainer__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_submittal_log_SubmittalModalContainer__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_open_items_ProjectOpenItemDetailsModal__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_chats_store_selectors__ = __webpack_require__(3090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_store_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_rfi_log_store_actions__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_open_items_store_actions__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_chats_store_actions__ = __webpack_require__(3091);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChatActivity=function(_Component){_inherits(ChatActivity,_Component);function ChatActivity(props){_classCallCheck(this,ChatActivity);var _this=_possibleConstructorReturn(this,(ChatActivity.__proto__||Object.getPrototypeOf(ChatActivity)).call(this,props));_this.scrollToTop=function(){if(_this.chatActContentEl){_this.chatActContentEl.scrollTop=0;}};_this.loadChatActivity=function(page){var _this$props=_this.props,filters=_this$props.filters,dispatch=_this$props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_components_admin_chats_store_actions__["a" /* chatActivityRequest */])(Object.assign({},filters,{page:page}))).then(function(response){return response.ok&&_this.scrollToTop();});};_this.closeModal=function(){_this.setState({showModal:null});};_this.openModal=function(chat){var _this$props2=_this.props,currentUser=_this$props2.currentUser,dispatch=_this$props2.dispatch;var subject=chat.notifiable;_this.setState({showModal:chat.notifiable_type});dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_store_actions__["b" /* loadProjectRequest */])(subject.project_id));switch(chat.notifiable_type){case'Rfi':return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_rfi_log_store_actions__["p" /* openRfi */])(subject.project_id,subject.id));case'Submittal':return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_submittal_log_store_actions__["p" /* openSubmittal */])(subject.project_id,subject.id,currentUser));case'ProjectOpenItem':dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_open_items_store_actions__["y" /* setOpenItemsCritical */])(subject.critical));return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_open_items_store_actions__["m" /* loadOpenItem */])(subject.project_id,subject.id));default:return null;}};_this.open=function(id){var _this$props3=_this.props,chatActivity=_this$props3.chatActivity,dispatch=_this$props3.dispatch;var chat=chatActivity.activity.find(function(chat){return chat.id===id;});var subject=chat.notifiable;switch(chat.notifiable_type){case'Rfi':case'Submittal':case'ProjectOpenItem':return _this.openModal(chat);case'WorkOrder':return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])('/admin/work-orders/'+subject.id));case'Task':return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])('/admin/work-orders/'+subject.work_order_id+'/task/'+subject.id));default:return null;}};_this.handleGenerateLink=function(id){var chatActivity=_this.props.chatActivity;var chat=chatActivity.activity.find(function(chat){return chat.id===id;});var subject=chat.notifiable;switch(chat.notifiable_type){case'Rfi':return'projects/'+subject.project_id+'?rfiId='+subject.id;case'Submittal':return'projects/'+subject.project_id+'?submittalId='+subject.id;case'ProjectOpenItem':return'projects/'+subject.project_id+'?projectOpenItemId='+subject.id;case'WorkOrder':return'work-orders/'+subject.id;case'Task':return'work-orders/'+subject.work_order_id+'/task/'+subject.id;default:return null;}};_this.subText=function(title){var maxLength=arguments.length>1&&arguments[1]!==undefined?arguments[1]:30;return title.length>maxLength?title.substring(0,maxLength)+'...':title;};_this.buildUserName=function(chat){var user=chat.user;return _this.subText(user.first_name+' '+(user.last_name?user.last_name[0]+'.':''));};_this.buildSubject=function(chat){var subject=chat.notifiable;switch(chat.notifiable_type){case'Rfi':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,_this.subText('RFI #'+subject.number+' - '+subject.project_name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,_this.subText(subject.title))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.subText(chat.content)));case'Submittal':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,_this.subText('Submittal #'+subject.division+'-'+subject.number+' - '+subject.project_name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,_this.subText(subject.title))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.subText(chat.content)));case'ProjectOpenItem':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,_this.subText('Open Item #'+subject.number+' - '+subject.project_name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,_this.subText(subject.description))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.subText(chat.content)));case'WorkOrder':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,_this.subText('WO #'+subject.number+' '+(subject.name?'- '+subject.name:'')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.subText(chat.content)));case'Task':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,_this.subText('WO #'+subject.wo_number+' Task '+subject.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.subText(chat.content)));default:return'';}};_this.mapActivity=function(){var chatActivity=_this.props.chatActivity;return chatActivity.activity.map(function(chat){return{id:chat.id,data:[_this.buildUserName(chat),_this.buildSubject(chat)]};});};_this.state={showModal:null};return _this;}_createClass(ChatActivity,[{key:'componentDidMount',value:function componentDidMount(){this.loadChatActivity(1);}},{key:'render',value:function render(){var _this2=this;var chatActivity=this.props.chatActivity;var showModal=this.state.showModal;return chatActivity&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat-activity'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat-activity-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Chat'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat-activity-total'},chatActivity.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat-activity-content',ref:function ref(el){return _this2.chatActContentEl=el;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_table_SimpleTable__["a" /* default */],{className:'projects-table',headers:['USER','SUBJECT'],rows:this.mapActivity(),emptyMessage:'No Activity.',onRowSelected:this.open,onGenerateLink:this.handleGenerateLink})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_pagination_SimplePagination__["a" /* default */],{currentPage:chatActivity.currentPage,pageSize:chatActivity.pageSize,total:chatActivity.total,onPageChange:this.loadChatActivity})),showModal==='Rfi'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_rfi_log_RfiModalContainer__["a" /* default */],{onClose:this.closeModal}),showModal==='Submittal'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_submittal_log_SubmittalModalContainer__["a" /* default */],{onClose:this.closeModal}),showModal==='ProjectOpenItem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_open_items_ProjectOpenItemDetailsModal__["a" /* default */],{onClose:this.closeModal}));}}]);return ChatActivity;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ChatActivity.propTypes={filters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape()};ChatActivity.defaultProps={filters:{per_page:5}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_authentication__["d" /* getCurrentUser */])(state),chatActivity:Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_chats_store_selectors__["a" /* getChatActivity */])(state)};})(ChatActivity));

/***/ }),
/* 3089 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getChatActivity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getChatActivity=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.chats.data.chatActivity;},function(chatActivity){return chatActivity;});

/***/ }),
/* 3091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export chatActivityRequestSuccess */
/* harmony export (immutable) */ __webpack_exports__["a"] = chatActivityRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_messages__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_chats_api__ = __webpack_require__(3092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_chats_store_action_types__ = __webpack_require__(1102);
function chatActivityRequestSuccess(chatActivity){return{type:__WEBPACK_IMPORTED_MODULE_2_components_admin_chats_store_action_types__["a" /* CHAT_ACTIVITY_LOAD */],payload:chatActivity};}function chatActivityRequest(filters){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_api_chats_api__["a" /* chatsApi */].getChatActivity(filters).then(function(response){if(response.ok){dispatch(chatActivityRequestSuccess(Object.assign({},response,{currentPage:filters.page})));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions_messages__["d" /* showErrorMessage */])(response.errors));}return response;});};}

/***/ }),
/* 3092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return chatsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChatsApi=function(_BaseApi){_inherits(ChatsApi,_BaseApi);function ChatsApi(){_classCallCheck(this,ChatsApi);return _possibleConstructorReturn(this,(ChatsApi.__proto__||Object.getPrototypeOf(ChatsApi)).apply(this,arguments));}_createClass(ChatsApi,[{key:'getChatActivity',value:function getChatActivity(filters){var query='';Object.keys(filters).forEach(function(filter,index){if(index>0){query+='&';}query+=filter+'='+filters[filter];});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/notes/activity?'+query).then(function(response){return{ok:true,activity:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return ChatsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var chatsApi=new ChatsApi();

/***/ }),
/* 3093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecoverPassword_css__ = __webpack_require__(3094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecoverPassword_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RecoverPassword_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_errors_SimpleErrorList__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api_auth_api__ = __webpack_require__(365);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var confirmUrl=window.location.origin+'/reset-password';var RecoverPassword=function(_Component){_inherits(RecoverPassword,_Component);function RecoverPassword(){_classCallCheck(this,RecoverPassword);var _this=_possibleConstructorReturn(this,(RecoverPassword.__proto__||Object.getPrototypeOf(RecoverPassword)).call(this));_this.handleEmailChange=function(event){_this.setState({email:event.target.value});};_this.handleSubmit=function(event){event.preventDefault();__WEBPACK_IMPORTED_MODULE_5__services_api_auth_api__["a" /* authApi */].recoverPassword(_this.state.email,confirmUrl).then(function(response){if(response.ok){_this.setState({confirmationMessage:response.message,showMessage:true});}else{_this.setState({errors:response.errors});}});};_this.state={confirmationMessage:'',email:'',errors:[],showMessage:false};return _this;}_createClass(RecoverPassword,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'client recover-password'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["k" /* Grid */],null,!this.state.showMessage?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:6,mdOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Recover your password')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:6,mdOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormControl */],{className:'input',value:this.state.password,placeholder:'Enter your email',type:'email',onChange:this.handleEmailChange}))),this.state.errors.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_errors_SimpleErrorList__["a" /* default */],{errors:this.state.errors})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',className:'btn-select btn-orange',value:'Next'})))))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:6,mdOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.confirmationMessage)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:6,mdOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{to:'/login'},'Go to Login')))))));}}]);return RecoverPassword;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RecoverPassword);

/***/ }),
/* 3094 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_auth_api__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_errors_SimpleErrorList__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ResetPassword_css__ = __webpack_require__(3096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ResetPassword_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ResetPassword_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResetPassword=function(_Component){_inherits(ResetPassword,_Component);function ResetPassword(props){_classCallCheck(this,ResetPassword);var _this=_possibleConstructorReturn(this,(ResetPassword.__proto__||Object.getPrototypeOf(ResetPassword)).call(this,props));_this.handlePasswordChange=function(event){_this.setState({password:event.target.value});};_this.handlePasswordConfirmationChange=function(event){_this.setState({passwordConfirmation:event.target.value});};_this.handleSubmit=function(event){event.preventDefault();__WEBPACK_IMPORTED_MODULE_2__services_api_auth_api__["a" /* authApi */].resetPassword(_this.state.password,_this.state.passwordConfirmation,_this.clientId,_this.token,_this.uid).then(function(response){if(response.ok){_this.props.history.push('/login');}else{_this.setState({errors:response.errors.full_messages});}});};_this.showWarning=function(){return _this.clientId===''||_this.token===''||_this.uid===''||_this.uid===undefined;};_this.state={password:'',passwordConfirmation:'',errors:[]};var params=__WEBPACK_IMPORTED_MODULE_3_query_string___default.a.parse(_this.props.location.search);_this.clientId=params['client_id'];_this.token=params['token'];_this.uid=params['uid'];return _this;}_createClass(ResetPassword,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'client reset-password'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["k" /* Grid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:6,mdOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Reset your password')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["s" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:6,mdOffset:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormControl */],{type:'password',className:'input',value:this.state.password,placeholder:'Password',onChange:this.handlePasswordChange,required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormControl */],{type:'password',className:'input',value:this.state.passwordConfirmation,placeholder:'Password confirmation',onChange:this.handlePasswordConfirmationChange,required:true}))),this.state.errors.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_errors_SimpleErrorList__["a" /* default */],{errors:this.state.errors})),this.showWarning()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:12,className:'warning-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Alert */],{bsStyle:'warning'},'Some parameters are missing, please go',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{to:'/recover-password'},'here')),' ','to properly recover your password.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',className:'btn-select btn-orange',value:'Reset'})))))))));}}]);return ResetPassword;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* withRouter */])(ResetPassword));

/***/ }),
/* 3096 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header_css__ = __webpack_require__(3098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Header_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logo_png__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserHeader__ = __webpack_require__(3099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_authentication__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NotificationsContainer__ = __webpack_require__(1100);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header=function(_Component){_inherits(Header,_Component);function Header(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Header);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Header.__proto__||Object.getPrototypeOf(Header)).call.apply(_ref,[this].concat(args))),_this),_this.handleAccountClick=function(acc){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_authentication__["l" /* switchAccount */])(acc));},_this.handleAddAccount=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_authentication__["i" /* clearCurrentUser */])());},_this.handleLogout=function(){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_authentication__["k" /* logoutRequest */])());},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Header,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__logo_png___default.a,className:'logo',alt:'Spackle Logo'}),this.props.isLoggedIn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-right-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__NotificationsContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__UserHeader__["a" /* default */],{currentUser:this.props.currentUser,accounts:this.props.accounts||[],onAccountClick:this.handleAccountClick,onAddAccount:this.handleAddAccount,onLogout:this.handleLogout})));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_4__selectors_authentication__["d" /* getCurrentUser */])(state),accounts:Object(__WEBPACK_IMPORTED_MODULE_4__selectors_authentication__["b" /* getAccounts */])(state),isLoggedIn:Object(__WEBPACK_IMPORTED_MODULE_4__selectors_authentication__["f" /* isLoggedIn */])(state)};})(Header));

/***/ }),
/* 3098 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserHeader_css__ = __webpack_require__(3100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__UserHeader_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_user_png__ = __webpack_require__(3101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_user_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_user_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_dropdown_arrow_png__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_dropdown_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_dropdown_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_header_Account__ = __webpack_require__(3102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_awesome_popover__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_awesome_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_awesome_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_domain_service_provider_type_enum__ = __webpack_require__(164);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserHeader=function(_Component){_inherits(UserHeader,_Component);function UserHeader(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserHeader);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserHeader.__proto__||Object.getPrototypeOf(UserHeader)).call.apply(_ref,[this].concat(args))),_this),_this.handleAccountClick=function(event,acc){event.preventDefault();_this.props.onAccountClick(acc);},_this.handleAddAccount=function(event){event.preventDefault();_this.props.onAddAccount();},_this.handleLogout=function(event){event.preventDefault();_this.props.onLogout();},_this.handleCustomerSupport=function(event){var currentUser=_this.props.currentUser;event.preventDefault();var url=''+"https://forms.clickup.com/f/86zjg-822/NRB5VVG05QA0QWA5V1"+('?Name='+encodeURIComponent(currentUser.first_name+' '+currentUser.last_name))+('&Email='+encodeURIComponent(currentUser.email))+('&'+encodeURIComponent('Phone Number')+'='+encodeURIComponent(currentUser.phone_number))+('&'+encodeURIComponent('User Id')+'='+encodeURIComponent(currentUser.uid))+('&Role='+encodeURIComponent(__WEBPACK_IMPORTED_MODULE_7_domain_service_provider_type_enum__["d" /* ServiceProviderTypes */][currentUser.accountable_type]||'Spackle'));window.open(url,'_blank');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserHeader,[{key:'render',value:function render(){var _this2=this;var _props=this.props,currentUser=_props.currentUser,accounts=_props.accounts;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__images_user_png___default.a,alt:'user'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Hello'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,currentUser.first_name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-options'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_awesome_popover___default.a,{arrow:false,placement:'bottom-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__images_dropdown_arrow_png___default.a,alt:'options'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'options-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,accounts.map(function(acc){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:acc.user.id,className:currentUser.id===acc.user.id?'selected':'',onClick:function onClick(e){return _this2.handleAccountClick(e,acc);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_header_Account__["a" /* default */],{account:acc.user}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{onClick:this.handleAddAccount},'Add Account'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{onClick:this.handleCustomerSupport},'Customer Support'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{onClick:this.handleLogout},'Logout'))))));}}]);return UserHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UserHeader.propTypes={currentUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,accounts:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})).isRequired,onAccountClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onAddAccount:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onLogout:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (UserHeader);

/***/ }),
/* 3100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3101 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA8CAYAAAAt3km7AAAAAXNSR0IArs4c6QAABKlJREFUaAXtWj1oFEEUntk7PYsYTCMmks6/QrCwEMSoh21AEzXx1NhZ2Ahip2CXdEGwtTPqedHkDKTVqAFB0EoENWUwEZvImcJI7sb3bdywuX2ztzO7i0e4bW73zbzvvW/e7MzbeSdFCpdSyik+LR9drakzUsnDSoguKVQXTCkhF6QQC0qqD1lHPi+c73srpawl7QbZSO6amZnZNr/48zqRuKmE2hkFWQr5g8iOdnfuuJfP539H0YnSJzFiY6XyWVVTd4VS3VEMB/pIOS8deWNosG8i0GYhcCx0NqjQtJNjxclhVa09syYFRBoQYLhYhLnBiMVDLACX1JPJIr04gxa29SpSlIYu9Bfo3aPX0+7K2Kmtae05cGiYSF2Lg6HRPfjx0+ct5YnSS017Q7F1xNx3CtMv5KIRf0EGSiqTeZMT7d/QdUVUdstq9TiFYpAifipEXciMc872nbMi5q5+35e+6t4pAp3LZOXViwP9r8Mcfzw+eaK6qu4Tyb1sP1pQund17LNZLa0WDyzpWlJSzjrtuSONSIEI+qAvRXaWJUYLimuLbQwXGhPD5ot9ioNFpJztW09f6u1d4to5GfpCB7pcu7snkk2uLUxmrICMQrf5YvqZkPIcgw50vWf/L2zBpl8W5d6YGNIkDhgLRZTpx+lCBl1gcO06m1xfT2ZMDLmfp+z/palU8j/b3OswdDbDbBgTQ0LLAWJJ5+QmMh2GzmYYtjExL0uvB/X2qXq5ybMOQ2czDNuYWBhY3LZcrkKzMXhR6khBM7uMieF7ijOBjIKTm8gqK/w0F1IsmuCgrzExGlKWGNIkU+P1/XUYOpv1+v5nY2L48vUDePc0V2Jn+CEY7z07UX+NieFzngNHQovcj2uLIoOuLinOZMRUFAx/H/Zl9Xeov0dK9bBYXuSyDwKbQ+5nmn08mp7uqFVW3lHEAskwjg4uF/o6afM2OhcxjhgM4IyinjCe4Vjt158pOMq1czKXFOlwpNYw5agpKegZE4MSDl4EfVLgvv6iiPZg9KNMS/RxI0U69TjuMz5bYMviMp6Kno1N+aG5Tg6HOErd8p6T/KXpNzJU6L9ti2kdMRgkUnKsSQ9zrN4xbxRpVNW/06QRTxb3141UzBMq+BArYn4SzXZgmhgxkNyUR9z+6GET/99FCb8/rfvWCLRGoDUCrRGItI/plm+lRFuaQyilWLatWYcSs9lw0yQK7Kg1ay2x2ClS6gzDa9aBJNjN2JOoKadNrEHNekPEUvsMSZskU7PeUINOsaacNrVAzXo9Yjaf+gMD+eU0PR4fn2mzrVm7xJKqKadJEtg4/Ilas3YXj6RqymkTM6lZO9h8k6wpp00uas1aUniPra4qtmqfzcqTccqvaZLEtCS/X3E2yO8eR1ffpUOVWDVlzmCSskY1a0dX36VVJXZNOUkiHJbOR3By6Mw8tZoy50ySsrCaNRYOlpiuHpykY3GxdD6CE62K/KdH2ptvXFLQ1/kIToEkOAmDzYDRItYMUTDxoRUxk9Fqhr603MvAn0M4WTM4y/nA+QqZQ6cjDwIKnCzQqUkEnK8ky+Yy+++sVL+g5H/FdZWEkDWJ2w3d0Pn/F1JFa2e9avPcAAAAAElFTkSuQmCC"

/***/ }),
/* 3102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Account_css__ = __webpack_require__(3103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Account_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Account_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_spackle_icon_png__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_spackle_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_spackle_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_domain_service_provider_type_enum__ = __webpack_require__(164);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Account=function(_Component){_inherits(Account,_Component);function Account(){_classCallCheck(this,Account);return _possibleConstructorReturn(this,(Account.__proto__||Object.getPrototypeOf(Account)).apply(this,arguments));}_createClass(Account,[{key:'render',value:function render(){var account=this.props.account;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'account'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'account-icon-container'},!account.accountable_id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon with-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3_images_spackle_icon_png___default.a,alt:'user-icon'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon no-icon'},(account.first_name||'').charAt(0),(account.last_name||'').charAt(0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'account-content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'account-name'},account.first_name,' ',account.last_name,' -',' ',__WEBPACK_IMPORTED_MODULE_4_domain_service_provider_type_enum__["d" /* ServiceProviderTypes */][account.accountable_type]||'Spackle'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'account-contact'},account.email)));}}]);return Account;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Account.propTypes={account:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Account);

/***/ }),
/* 3103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loader_css__ = __webpack_require__(3105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Loader_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loader_svg__ = __webpack_require__(3106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loader_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loader_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Loader=function(_Component){_inherits(Loader,_Component);function Loader(){_classCallCheck(this,Loader);return _possibleConstructorReturn(this,(Loader.__proto__||Object.getPrototypeOf(Loader)).apply(this,arguments));}_createClass(Loader,[{key:'render',value:function render(){if(this.props.show){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__loader_svg___default.a,alt:'loader'}));}else{return null;}}}]);return Loader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Loader.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{show:state.loader.loading};},null)(Loader));

/***/ }),
/* 3105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loader.120eb0c8.svg";

/***/ }),
/* 3107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors_messages__ = __webpack_require__(3108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Messages_css__ = __webpack_require__(3109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Messages_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Messages_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_close_png__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_close_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_close_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_invalid_png__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_invalid_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_invalid_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_messages__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Messages=function(_Component){_inherits(Messages,_Component);function Messages(props){_classCallCheck(this,Messages);var _this=_possibleConstructorReturn(this,(Messages.__proto__||Object.getPrototypeOf(Messages)).call(this,props));_this.handleErrorClose=function(event,id){event.preventDefault();// Clear timeout for current error and update local timeout id object
clearTimeout(_this.timeoutIds[id]);delete _this.timeoutIds[id];_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_messages__["c" /* closeErrorMessage */])(id));};_this.timeoutIds={};// { errorId: number, timeoutId: number }
_this.defaultDuration=5000;return _this;}_createClass(Messages,[{key:'render',value:function render(){var _this2=this;return this.props.errors.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'messages'},this.props.errors.map(function(element){return _this2.renderErrorMessage(element);})):null;}},{key:'renderErrorMessage',value:function renderErrorMessage(error){var _this3=this;if(this.timeoutIds[error.id]===undefined){this.timeoutIds[error.id]=setTimeout(function(){// Update local timeout id object
delete _this3.timeoutIds[error.id];_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_messages__["c" /* closeErrorMessage */])(error.id));},this.defaultDuration);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:error.id,className:'error-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__images_invalid_png___default.a,alt:'invalid'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,error.message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__images_close_png___default.a,alt:'close',onClick:function onClick(event){return _this3.handleErrorClose(event,error.id);}})));}}]);return Messages;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{errors:Object(__WEBPACK_IMPORTED_MODULE_2__selectors_messages__["a" /* getMessagesErrors */])(state)};})(Messages));

/***/ }),
/* 3108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMessagesErrors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getMessagesErrors=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.messages.errors;},function(errors){return errors;});

/***/ }),
/* 3109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export register */
/* harmony export (immutable) */ __webpack_exports__["a"] = unregister;
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 3111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 3112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loader__ = __webpack_require__(3113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__authentication__ = __webpack_require__(3114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__admin_work_orders_work_orders__ = __webpack_require__(3115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messages__ = __webpack_require__(3167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__client_user_invitations_data__ = __webpack_require__(3168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__admin_contractors_contractors__ = __webpack_require__(3169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__admin_buildings_buildings__ = __webpack_require__(3172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__admin_clients_clients__ = __webpack_require__(3175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__admin_quotes_quotes__ = __webpack_require__(3178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__admin_tasks_tasks__ = __webpack_require__(3181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__admin_invoices_invoices__ = __webpack_require__(3184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__admin_deposits_deposits__ = __webpack_require__(3187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__admin_sidebar_sidebar__ = __webpack_require__(3190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__admin_team_team__ = __webpack_require__(3197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__admin_users_users__ = __webpack_require__(3204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_tutorials_store_reducers__ = __webpack_require__(3207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__notifications__ = __webpack_require__(3209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_admin_contractors_invoices_store_reducers__ = __webpack_require__(3212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__admin_reports_reports__ = __webpack_require__(3215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_reducers_client_set_password_ui__ = __webpack_require__(3230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_admin_purchase_orders_store_reducers__ = __webpack_require__(3231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_admin_surveys_store_reducers__ = __webpack_require__(3234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_admin_projects_store_reducers__ = __webpack_require__(3237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_shared_pagination_table_store_reducers__ = __webpack_require__(3265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_admin_general_contractors_store_reducers__ = __webpack_require__(3266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_admin_service_providers_store_reducers__ = __webpack_require__(3269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pdfViewerBluebeam__ = __webpack_require__(3271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_admin_rfis_store_reducers__ = __webpack_require__(3272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_components_admin_submittals_store_reducers__ = __webpack_require__(3274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_admin_project_open_items_store_reducers__ = __webpack_require__(3276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_components_admin_chats_store_reducers__ = __webpack_require__(3278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_components_admin_field_work_orders_store_reducers__ = __webpack_require__(3280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_components_admin_recent_activity_store_reducers__ = __webpack_require__(3282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_components_admin_featured_items_store_reducers__ = __webpack_require__(3284);
function getReducers(){return{auth:__WEBPACK_IMPORTED_MODULE_1__authentication__["a" /* default */],loader:__WEBPACK_IMPORTED_MODULE_0__loader__["a" /* default */],messages:__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */],sidebar:__WEBPACK_IMPORTED_MODULE_13__admin_sidebar_sidebar__["a" /* default */],userInvitations:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_5__client_user_invitations_data__["a" /* default */]),workOrders:__WEBPACK_IMPORTED_MODULE_2__admin_work_orders_work_orders__["a" /* default */],contractors:__WEBPACK_IMPORTED_MODULE_6__admin_contractors_contractors__["a" /* default */],buildings:__WEBPACK_IMPORTED_MODULE_7__admin_buildings_buildings__["a" /* default */],clients:__WEBPACK_IMPORTED_MODULE_8__admin_clients_clients__["a" /* default */],quotes:__WEBPACK_IMPORTED_MODULE_9__admin_quotes_quotes__["a" /* default */],tasks:__WEBPACK_IMPORTED_MODULE_10__admin_tasks_tasks__["a" /* default */],invoices:__WEBPACK_IMPORTED_MODULE_11__admin_invoices_invoices__["a" /* default */],deposits:__WEBPACK_IMPORTED_MODULE_12__admin_deposits_deposits__["a" /* default */],team:__WEBPACK_IMPORTED_MODULE_14__admin_team_team__["a" /* default */],users:__WEBPACK_IMPORTED_MODULE_15__admin_users_users__["a" /* default */],tutorials:__WEBPACK_IMPORTED_MODULE_16_components_admin_tutorials_store_reducers__["a" /* default */],notifications:__WEBPACK_IMPORTED_MODULE_17__notifications__["a" /* default */],contractorsInvoices:__WEBPACK_IMPORTED_MODULE_18_components_admin_contractors_invoices_store_reducers__["a" /* default */],reports:__WEBPACK_IMPORTED_MODULE_19__admin_reports_reports__["a" /* default */],purchaseOrders:__WEBPACK_IMPORTED_MODULE_22_components_admin_purchase_orders_store_reducers__["a" /* default */],setPassword:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_util__["a" /* createSceneReducer */])(null,__WEBPACK_IMPORTED_MODULE_20_reducers_client_set_password_ui__["a" /* default */]),form:__WEBPACK_IMPORTED_MODULE_21_redux_form__["e" /* reducer */],surveys:__WEBPACK_IMPORTED_MODULE_23_components_admin_surveys_store_reducers__["a" /* default */],projects:__WEBPACK_IMPORTED_MODULE_24_components_admin_projects_store_reducers__["a" /* default */],paginationTable:__WEBPACK_IMPORTED_MODULE_25_components_shared_pagination_table_store_reducers__["a" /* default */],generalContractors:__WEBPACK_IMPORTED_MODULE_26_components_admin_general_contractors_store_reducers__["a" /* default */],serviceProviders:__WEBPACK_IMPORTED_MODULE_27_components_admin_service_providers_store_reducers__["a" /* default */],pdfViewer:__WEBPACK_IMPORTED_MODULE_28__pdfViewerBluebeam__["a" /* default */],rfis:__WEBPACK_IMPORTED_MODULE_29_components_admin_rfis_store_reducers__["a" /* default */],submittals:__WEBPACK_IMPORTED_MODULE_30_components_admin_submittals_store_reducers__["a" /* default */],projectOpenItems:__WEBPACK_IMPORTED_MODULE_31_components_admin_project_open_items_store_reducers__["a" /* default */],chats:__WEBPACK_IMPORTED_MODULE_32_components_admin_chats_store_reducers__["a" /* default */],fieldWorkOrders:__WEBPACK_IMPORTED_MODULE_33_components_admin_field_work_orders_store_reducers__["a" /* default */],recentActivity:__WEBPACK_IMPORTED_MODULE_34_components_admin_recent_activity_store_reducers__["a" /* default */],featuredItems:__WEBPACK_IMPORTED_MODULE_35_components_admin_featured_items_store_reducers__["a" /* default */]};}

/***/ }),
/* 3113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loaderReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_loader__ = __webpack_require__(1103);
var initialState={loading:false,loaders:0};function loaderReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_loader__["b" /* LOADER_START */]:return Object.assign({},state,{loaders:state.loaders+1,loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_loader__["a" /* LOADER_END */]:var loaders=state.loaders-1;if(loaders<0){// For the situation when a loaderStart is not executed on purpose
loaders=0;}var loading=state.loading;if(loaders===0){loading=false;}return Object.assign({},state,{loaders:loaders,loading:loading});default:return state;}}

/***/ }),
/* 3114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = authenticationReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_authentication__ = __webpack_require__(174);
var initialState={accessToken:'',client:'',errors:[],loggedIn:false,user:null,accounts:[]};function authenticationReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_authentication__["d" /* AUTHENTICATION_SUCCESS */]:return Object.assign({},state,{accessToken:action.payload.accessToken,client:action.payload.client,errors:[],loggedIn:true,user:action.payload.user,enterpriseRedirect:action.payload.enterpriseRedirect});case __WEBPACK_IMPORTED_MODULE_0__actions_authentication__["b" /* AUTHENTICATION_FAILURE */]:return Object.assign({},state,{errors:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_authentication__["c" /* AUTHENTICATION_LOGOUT */]:return Object.assign({},state,{accessToken:'',client:'',loggedIn:false,user:null});case __WEBPACK_IMPORTED_MODULE_0__actions_authentication__["a" /* AUTHENTICATION_ACCOUNTS_SET */]:return Object.assign({},state,{accounts:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_authentication__["e" /* CANCEL_ENTERPRISE_REDIRECT */]:return Object.assign({},state,{enterpriseRedirect:false});default:return state;}}

/***/ }),
/* 3115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__details_create_quote_ui__ = __webpack_require__(3116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__details_deny_quote_ui__ = __webpack_require__(3117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__details_proposal_ui__ = __webpack_require__(3118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__details_proposal_data__ = __webpack_require__(3119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__details_decline_proposal_ui__ = __webpack_require__(3120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__details_details_data__ = __webpack_require__(3121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__details_details_ui__ = __webpack_require__(3122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__details_quotes_request_data__ = __webpack_require__(3123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__details_quotes_request_ui__ = __webpack_require__(3124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__details_proposal_approval_data__ = __webpack_require__(3125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__details_proposal_approval_ui__ = __webpack_require__(3126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__creation_buildings_data__ = __webpack_require__(3127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__creation_sub_contractors_union_trades_ui__ = __webpack_require__(3128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__creation_tasks_ui__ = __webpack_require__(3129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__creation_buildings_ui__ = __webpack_require__(3130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__creation_tasks_data__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__creation_work_order_summary_ui__ = __webpack_require__(3131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__creation_working_hours_data__ = __webpack_require__(3132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__creation_working_hours_ui__ = __webpack_require__(3133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__creation_sub_contractors_union_trades_data__ = __webpack_require__(3134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__work_orders_data__ = __webpack_require__(3135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__work_orders_ui__ = __webpack_require__(3136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__details_create_quote_data__ = __webpack_require__(3137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__creation_creation_ui__ = __webpack_require__(3138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__details_members_data__ = __webpack_require__(3139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__details_members_ui__ = __webpack_require__(3140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__details_open_items_data__ = __webpack_require__(3141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__details_open_items_ui__ = __webpack_require__(3142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__creation_clients_data__ = __webpack_require__(3143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__creation_clients_ui__ = __webpack_require__(3144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__details_qualifications_data__ = __webpack_require__(3145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__details_qualifications_ui__ = __webpack_require__(3146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_reducers_admin_work_orders_details_new_task_data__ = __webpack_require__(3147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_reducers_admin_work_orders_details_new_task_ui__ = __webpack_require__(3148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_reducers_admin_work_orders_details_budget_ui__ = __webpack_require__(3149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_reducers_admin_work_orders_details_purchase_order_ui__ = __webpack_require__(3150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_reducers_admin_work_orders_details_budget_data__ = __webpack_require__(3151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_components_admin_work_orders_details_time_store_reducers_data__ = __webpack_require__(3152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_components_admin_work_orders_details_time_store_reducers_ui__ = __webpack_require__(3153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_components_admin_work_orders_details_vendor_invoices_store_reducers_data__ = __webpack_require__(3154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_components_admin_work_orders_details_vendor_invoices_store_reducers_ui__ = __webpack_require__(3155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_components_admin_work_orders_details_transfer_store_reducers_ui__ = __webpack_require__(3156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_components_admin_work_orders_details_receipts_store_reducers_data__ = __webpack_require__(3157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_components_admin_work_orders_details_receipts_store_reducers_ui__ = __webpack_require__(3158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_components_admin_work_orders_details_anticipated_cost_report_store_reducers_data__ = __webpack_require__(3159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_components_admin_work_orders_details_anticipated_cost_report_store_reducers_ui__ = __webpack_require__(3160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_components_admin_work_orders_details_change_order_tasks_store_reducers_data__ = __webpack_require__(3161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_components_admin_work_orders_details_change_order_tasks_store_reducers_ui__ = __webpack_require__(3162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_components_admin_work_orders_details_change_order_quotes_store_reducers_data__ = __webpack_require__(3163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_components_admin_work_orders_details_change_order_quotes_store_reducers_ui__ = __webpack_require__(3164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_components_admin_work_orders_details_change_orders_store_reducers_data__ = __webpack_require__(3165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_components_admin_work_orders_details_change_orders_store_reducers_ui__ = __webpack_require__(3166);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_22__work_orders_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_23__work_orders_ui__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({creation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(null,__WEBPACK_IMPORTED_MODULE_25__creation_creation_ui__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({buildings:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_13__creation_buildings_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_16__creation_buildings_ui__["a" /* default */]),clients:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_30__creation_clients_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_31__creation_clients_ui__["a" /* default */]),subContractorsUnionTrades:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_21__creation_sub_contractors_union_trades_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_14__creation_sub_contractors_union_trades_ui__["a" /* default */]),summary:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(null,__WEBPACK_IMPORTED_MODULE_18__creation_work_order_summary_ui__["a" /* default */]),tasks:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_17__creation_tasks_data__["b" /* default */],__WEBPACK_IMPORTED_MODULE_15__creation_tasks_ui__["a" /* default */]),workingHours:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_19__creation_working_hours_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_20__creation_working_hours_ui__["a" /* default */])})),details:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_7__details_details_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_8__details_details_ui__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({budget:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_38_reducers_admin_work_orders_details_budget_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_36_reducers_admin_work_orders_details_budget_ui__["a" /* default */]),createQuote:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_24__details_create_quote_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__details_create_quote_ui__["a" /* default */]),denyQuote:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(null,__WEBPACK_IMPORTED_MODULE_3__details_deny_quote_ui__["a" /* default */]),members:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_26__details_members_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_27__details_members_ui__["a" /* default */]),newTask:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_34_reducers_admin_work_orders_details_new_task_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_35_reducers_admin_work_orders_details_new_task_ui__["a" /* default */]),openItems:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_28__details_open_items_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_29__details_open_items_ui__["a" /* default */]),proposal:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_5__details_proposal_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_4__details_proposal_ui__["a" /* default */]),proposalApproval:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_11__details_proposal_approval_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_12__details_proposal_approval_ui__["a" /* default */]),declineProposal:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(null,__WEBPACK_IMPORTED_MODULE_6__details_decline_proposal_ui__["a" /* default */]),purchaseOrder:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(null,__WEBPACK_IMPORTED_MODULE_37_reducers_admin_work_orders_details_purchase_order_ui__["a" /* default */]),qualifications:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_32__details_qualifications_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_33__details_qualifications_ui__["a" /* default */]),quotesRequest:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_9__details_quotes_request_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_10__details_quotes_request_ui__["a" /* default */]),receipts:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_44_components_admin_work_orders_details_receipts_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_45_components_admin_work_orders_details_receipts_store_reducers_ui__["a" /* default */]),time:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_39_components_admin_work_orders_details_time_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_40_components_admin_work_orders_details_time_store_reducers_ui__["a" /* default */]),transfer:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(null,__WEBPACK_IMPORTED_MODULE_43_components_admin_work_orders_details_transfer_store_reducers_ui__["a" /* default */]),vendorInvoices:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_41_components_admin_work_orders_details_vendor_invoices_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_42_components_admin_work_orders_details_vendor_invoices_store_reducers_ui__["a" /* default */]),anticipatedCostReport:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_46_components_admin_work_orders_details_anticipated_cost_report_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_47_components_admin_work_orders_details_anticipated_cost_report_store_reducers_ui__["a" /* default */]),changeOrderTasks:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_48_components_admin_work_orders_details_change_order_tasks_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_49_components_admin_work_orders_details_change_order_tasks_store_reducers_ui__["a" /* default */]),changeOrderQuotes:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_50_components_admin_work_orders_details_change_order_quotes_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_51_components_admin_work_orders_details_change_order_quotes_store_reducers_ui__["a" /* default */]),changeOrders:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_52_components_admin_work_orders_details_change_orders_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_53_components_admin_work_orders_details_change_orders_store_reducers_ui__["a" /* default */])}))})));

/***/ }),
/* 3116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createQuoteUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={createQuotesForm:null,// to keep track of redux-form state after continue
createQuotesModalState:'edit',// 'edit', 'review', 'confirmation'
state:'edit',// 'edit', 'review', 'confirmation'
show:false,showCreateQuotesModal:false,validationMessage:null,showCounter:null};function createQuoteUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_45" /* WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_SHOW */]:return Object.assign({},state,{show:true,state:'edit',validationMessage:null,showCounter:null});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_140" /* WORK_ORDERS_DETAILS_REVIEW_QUOTE_MODAL_SHOW */]:return Object.assign({},state,{show:true,state:'review',validationMessage:null,showCounter:action.payload.status==='received'&&action.payload.counter_status==='negotiating'});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_40" /* WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_CLOSE */]:return Object.assign({},state,{show:false});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_41" /* WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_EDIT */]:return Object.assign({},state,{state:'edit',validationMessage:null,showCounter:null});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_47" /* WORK_ORDERS_DETAILS_CREATE_QUOTE_VALIDATION_MESSAGE_SET */]:return Object.assign({},state,{validationMessage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_43" /* WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_VALID */]:return Object.assign({},state,{state:'review',validationMessage:null});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_46" /* WORK_ORDERS_DETAILS_CREATE_QUOTE_STATE_SET */]:return Object.assign({},state,{state:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_37" /* WORK_ORDERS_DETAILS_CREATE_QUOTES_FORM_SET */]:return Object.assign({},state,{createQuotesForm:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_38" /* WORK_ORDERS_DETAILS_CREATE_QUOTES_MODAL_SHOW_SET */]:return Object.assign({},state,{createQuotesForm:null,createQuotesModalState:'edit',showCreateQuotesModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_39" /* WORK_ORDERS_DETAILS_CREATE_QUOTES_STATE_SET */]:return Object.assign({},state,{createQuotesModalState:action.payload});default:return state;}}

/***/ }),
/* 3117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = denyQuoteUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={reason:'',show:false,sure:null};function denyQuoteUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_50" /* WORK_ORDERS_DETAILS_DENY_QUOTE_MODAL_CLOSE */]:return Object.assign({},state,{show:false});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_51" /* WORK_ORDERS_DETAILS_DENY_QUOTE_MODAL_SHOW */]:return Object.assign({},state,{reason:'',show:true,sure:null});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_53" /* WORK_ORDERS_DETAILS_DENY_QUOTE_REASON_CHANGE */]:return Object.assign({},state,{reason:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_52" /* WORK_ORDERS_DETAILS_DENY_QUOTE_QUESTION_ANSWERED */]:return Object.assign({},state,{sure:action.payload});default:return state;}}

/***/ }),
/* 3118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = proposalUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={currentView:'form',// oneOf: [form, review, thank-you]
emails:[],message:'',pdf:null,show:false,showEmailModal:false,showPdfViewer:false,subject:'',depositSelected:false};function proposalUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_81" /* WORK_ORDERS_DETAILS_PROPOSAL_BACK */]:return Object.assign({},state,{currentView:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_83" /* WORK_ORDERS_DETAILS_PROPOSAL_CREATE_SUCCESS */]:return Object.assign({},state,{currentView:'thank-you'});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_86" /* WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_ADD */]:if(state.emails.find(function(email){return email===action.payload;})===undefined){return Object.assign({},state,{emails:state.emails.concat([action.payload])});}else{return state;}case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_87" /* WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_CLEAR */]:return Object.assign({},state,{emails:[]});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_88" /* WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_MODAL_SHOW_SET */]:return Object.assign({},state,{showEmailModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_89" /* WORK_ORDERS_DETAILS_PROPOSAL_EMAIL_REMOVE */]:return Object.assign({},state,{emails:state.emails.filter(function(email){return email!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_91" /* WORK_ORDERS_DETAILS_PROPOSAL_MESSAGE_SET */]:return Object.assign({},state,{message:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_92" /* WORK_ORDERS_DETAILS_PROPOSAL_MODAL_CLOSE */]:return Object.assign({},state,{show:false});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_94" /* WORK_ORDERS_DETAILS_PROPOSAL_MODAL_SHOW */]:return Object.assign({},state,{currentView:'form',show:true,depositSelected:action.payload.deposit!==undefined&&action.payload.deposit!==null});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_93" /* WORK_ORDERS_DETAILS_PROPOSAL_MODAL_EDIT */]:return Object.assign({},state,{currentView:'edit',show:true});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_95" /* WORK_ORDERS_DETAILS_PROPOSAL_NEXT */]:return Object.assign({},state,{currentView:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_96" /* WORK_ORDERS_DETAILS_PROPOSAL_PDF_VIEWER_CLOSE */]:return Object.assign({},state,{showPdfViewer:false});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_97" /* WORK_ORDERS_DETAILS_PROPOSAL_PRINT_SUCCESS */]:return Object.assign({},state,{pdf:action.payload,showPdfViewer:true});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_101" /* WORK_ORDERS_DETAILS_PROPOSAL_SUBJECT_SET */]:return Object.assign({},state,{subject:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_85" /* WORK_ORDERS_DETAILS_PROPOSAL_DEPOSIT_SELECTED_CHANGE */]:return Object.assign({},state,{depositSelected:action.payload});default:return state;}}

/***/ }),
/* 3119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = proposalDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={completionDate:null,valuesByQuoteId:{},startDate:null,depositCost:null,users:[]};function proposalDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_82" /* WORK_ORDERS_DETAILS_PROPOSAL_COMPLETION_DATE_UPDATE */]:return Object.assign({},state,{completionDate:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_90" /* WORK_ORDERS_DETAILS_PROPOSAL_MARKUP_UPDATE */]:return Object.assign({},state,{valuesByQuoteId:Object.assign({},state.valuesByQuoteId,_defineProperty({},action.payload.quoteId,Object.assign({},state.valuesByQuoteId[action.payload.quoteId],_defineProperty({},action.payload.key,action.payload.value))))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_94" /* WORK_ORDERS_DETAILS_PROPOSAL_MODAL_SHOW */]:return Object.assign({},state,{completionDate:action.payload.completionDate,valuesByQuoteId:action.payload.valuesByQuoteId,startDate:action.payload.startDate,depositCost:action.payload.deposit!==undefined&&action.payload.deposit!==null?action.payload.deposit.cost:null});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_93" /* WORK_ORDERS_DETAILS_PROPOSAL_MODAL_EDIT */]:return Object.assign({},state,{selectedProposal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_98" /* WORK_ORDERS_DETAILS_PROPOSAL_QUOTE_UPDATE */]:return Object.assign({},state,{selectedProposal:Object.assign({},state.selectedProposal,{proposal_quotes:state.selectedProposal.proposal_quotes.map(function(pq){if(pq.id===action.payload.proposalQuoteId){return Object.assign({},pq,_defineProperty({},action.payload.key,action.payload.value));}else{return pq;}})})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_100" /* WORK_ORDERS_DETAILS_PROPOSAL_START_DATE_UPDATE */]:return Object.assign({},state,{startDate:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_106" /* WORK_ORDERS_DETAILS_PROPOSAL_USERS_LOAD_SUCCESS */]:return Object.assign({},state,{users:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_84" /* WORK_ORDERS_DETAILS_PROPOSAL_DEPOSIT_COST_CHANGE */]:return Object.assign({},state,{depositCost:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_78" /* WORK_ORDERS_DETAILS_PROPOSAL_ADD_BREAKDOWNITEM */]:return Object.assign({},state,{valuesByQuoteId:Object.assign({},state.valuesByQuoteId,_defineProperty({},action.payload.quoteId,Object.assign({},state.valuesByQuoteId[action.payload.quoteId],{breakdownItems:[].concat(_toConsumableArray(state.valuesByQuoteId[action.payload.quoteId].breakdownItems),[action.payload.breakdownItem])})))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_99" /* WORK_ORDERS_DETAILS_PROPOSAL_REMOVE_BREAKDOWNITEM */]:return Object.assign({},state,{valuesByQuoteId:Object.assign({},state.valuesByQuoteId,_defineProperty({},action.payload.quoteId,Object.assign({},state.valuesByQuoteId[action.payload.quoteId],{breakdownItems:state.valuesByQuoteId[action.payload.quoteId].breakdownItems.filter(function(item,index){return index!==action.payload.biIndex;})})))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_105" /* WORK_ORDERS_DETAILS_PROPOSAL_UPDATE_BREAKDOWNITEM */]:return Object.assign({},state,{valuesByQuoteId:Object.assign({},state.valuesByQuoteId,_defineProperty({},action.payload.quoteId,Object.assign({},state.valuesByQuoteId[action.payload.quoteId],{breakdownItems:state.valuesByQuoteId[action.payload.quoteId].breakdownItems.map(function(item,index){if(index===action.payload.biIndex){return Object.assign({},item,_defineProperty({},action.payload.key,action.payload.value));}else{return item;}})})))});default:return state;}}

/***/ }),
/* 3120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = declineProposalUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={show:false};function declineProposalUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_48" /* WORK_ORDERS_DETAILS_DECLINE_PROPOSAL_MODAL_CLOSE */]:return Object.assign({},state,{show:false});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_49" /* WORK_ORDERS_DETAILS_DECLINE_PROPOSAL_MODAL_SHOW */]:return Object.assign({},state,{show:true});default:return state;}}

/***/ }),
/* 3121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = detailsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_utils_text_util__ = __webpack_require__(29);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={budget:null,contractorInvoice:null,contractorLienRelease:null,contractorLienReleases:[],currentTask:null,currentWorkOrder:null,members:[],openItemsByTaskId:null,// object with taskId as key
proposals:[],quotes:[],quotesSelectedByTaskId:{},// { taskId, selectedQuoteId: null OR id}
selectedQuoteId:null,taskNotes:[],workOrderNotes:[],workOrderAuthorizations:[]};function detailsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_25" /* WORK_ORDERS_DETAILS_BUDGET_SET */]:return Object.assign({},state,{budget:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_57" /* WORK_ORDERS_DETAILS_MEMBERS_ADD */]:return Object.assign({},state,{members:state.members.concat([action.payload])});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_59" /* WORK_ORDERS_DETAILS_MEMBERS_REMOVE */]:return Object.assign({},state,{members:state.members.filter(function(member){return member.id!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_58" /* WORK_ORDERS_DETAILS_MEMBERS_LOAD_SUCCESS */]:return Object.assign({},state,{members:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_67" /* WORK_ORDERS_DETAILS_NOTE_ADD_SUCCESS */]:return Object.assign({},state,{workOrderNotes:state.workOrderNotes.concat([action.payload])});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_66" /* WORK_ORDERS_DETAILS_NOTES_LOAD_SUCCESS */]:return Object.assign({},state,{workOrderNotes:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_68" /* WORK_ORDERS_DETAILS_OPEN_ITEMS_ADD */]:var newOpenItemsByTaskId=Object.assign({},state.openItemsByTaskId);if(newOpenItemsByTaskId[action.payload.taskId]===undefined){newOpenItemsByTaskId[action.payload.taskId]=[action.payload.item];}else{newOpenItemsByTaskId[action.payload.taskId]=newOpenItemsByTaskId[action.payload.taskId].concat([action.payload.item]);}return Object.assign({},state,{openItemsByTaskId:newOpenItemsByTaskId});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_70" /* WORK_ORDERS_DETAILS_OPEN_ITEMS_UPDATE */]:return Object.assign({},state,{openItemsByTaskId:Object.assign({},state.openItemsByTaskId,_defineProperty({},action.payload.taskId,state.openItemsByTaskId[action.payload.taskId].map(function(openItem){if(openItem.id===action.payload.item.id){return action.payload.item;}else{return openItem;}})))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_69" /* WORK_ORDERS_DETAILS_OPEN_ITEMS_LOAD_SUCCESS */]:return Object.assign({},state,{openItemsByTaskId:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_31" /* WORK_ORDERS_DETAILS_CHANGE_ORDER_ADD */]:return Object.assign({},state,{quotesSelectedByTaskId:{}});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_60" /* WORK_ORDERS_DETAILS_MOVED_TO_ACR */]:return Object.assign({},state,{quotesSelectedByTaskId:{}});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_77" /* WORK_ORDERS_DETAILS_PROPOSAL_ADD */]:return Object.assign({},state,{proposals:state.proposals.concat([action.payload]),quotesSelectedByTaskId:{}});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_76" /* WORK_ORDERS_DETAILS_PROPOSALS_LOAD_SUCCESS */]:return Object.assign({},state,{proposals:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_148" /* WORK_ORDERS_DETAILS_TASK_LOAD_SUCCESS */]:return Object.assign({},state,{currentTask:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_150" /* WORK_ORDERS_DETAILS_TASK_NOTE_ADD_SUCCESS */]:return Object.assign({},state,{taskNotes:state.taskNotes.concat([action.payload])});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_149" /* WORK_ORDERS_DETAILS_TASK_NOTES_LOAD_SUCCESS */]:return Object.assign({},state,{taskNotes:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_139" /* WORK_ORDERS_DETAILS_QUOTE_DETAIL_MODAL_CLOSE */]:return Object.assign({},state,{selectedQuoteId:null});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_123" /* WORK_ORDERS_DETAILS_QUOTES_LOAD_SUCCESS */]:return Object.assign({},state,{quotes:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_138" /* WORK_ORDERS_DETAILS_QUOTES_UPDATE_SUCCESS */]:return Object.assign({},state,{quotes:state.quotes.map(function(quote){if(quote.id===action.payload.id){quote['estimate']=action.payload['estimate'];quote['counter']=action.payload['counter'];quote['counter_status']=action.payload['counter_status'];quote['value']=action.payload['value'];quote['contractor_name']=action.payload['contractor_name'];}return quote;})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_122" /* WORK_ORDERS_DETAILS_QUOTES_DELETE_SUCCESS */]:return Object.assign({},state,{quotes:state.quotes.filter(function(quote){return quote.id!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_124" /* WORK_ORDERS_DETAILS_QUOTES_REMOVE */]:return Object.assign({},state,{quotes:state.quotes.filter(function(quote){return quote.task.id!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_134" /* WORK_ORDERS_DETAILS_QUOTES_SELECT */]:return Object.assign({},state,{selectedQuoteId:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_136" /* WORK_ORDERS_DETAILS_QUOTES_TABLE_RADIO_SELECT */]:return Object.assign({},state,{quotesSelectedByTaskId:Object.assign({},state.quotesSelectedByTaskId,_defineProperty({},action.payload.taskId,action.payload.quoteId))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_135" /* WORK_ORDERS_DETAILS_QUOTES_TABLE_FILTER_CHANGE */]:return Object.assign({},state,{quotesSelectedByTaskId:{}});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_121" /* WORK_ORDERS_DETAILS_QUOTES_ADD */]:return Object.assign({},state,{quotes:[].concat(_toConsumableArray(state.quotes),[action.payload])});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_137" /* WORK_ORDERS_DETAILS_QUOTES_UPDATE */]:return Object.assign({},state,{// quotes: action.payload
quotes:state.quotes.map(function(quote){// action.payload is a list of quotes
var foundQuote=action.payload.find(function(payloadQuote){return payloadQuote.id===quote.id;});// If quote exists, update with the value that come in the payload
if(foundQuote!==undefined){return foundQuote;}else{return quote;}})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_145" /* WORK_ORDERS_DETAILS_TASK_CHANGE_VALUE */]:var newTask=Object.assign({},state.currentTask);if(action.payload.attribute==='images'){newTask['images']=newTask['images'].concat(action.payload.value);}else{newTask[action.payload.attribute]=action.payload.value;}// If trades are updated, removeUser value for subTrade
if(action.payload.attribute==='trade'){newTask['tradeLabel']=action.payload.label;newTask['subTrade']=0;}if(action.payload.attribute==='trade'&&newTask['tradeLabel']!==''){newTask['name']=Object(__WEBPACK_IMPORTED_MODULE_1_services_utils_text_util__["a" /* buildTaskName */])(newTask['tradeLabel']);}return Object.assign({},state,{currentTask:newTask});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_144" /* WORK_ORDERS_DETAILS_TASK_CANCEL */]:return Object.assign({},state,{currentTask:null});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_147" /* WORK_ORDERS_DETAILS_TASK_IMAGE_REMOVE_SUCCESS */]:return Object.assign({},state,{currentTask:Object.assign({},state.currentTask,{images:state.currentTask.images.filter(function(element,index){return index!==action.payload;})})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_153" /* WORK_ORDERS_DETAILS_TASK_UPDATE */]:return Object.assign({},state,{currentTask:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_143" /* WORK_ORDERS_DETAILS_STATE_INIT */]:return Object.assign({},state,{currentTask:null,quotesSelectedByTaskId:{},receipts:[]});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_61" /* WORK_ORDERS_DETAILS_NAV_BAR_SELECTION */]:return Object.assign({},state,{currentTask:null});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_104" /* WORK_ORDERS_DETAILS_PROPOSAL_UPDATE */]:return Object.assign({},state,{proposals:state.proposals.map(function(proposal){if(proposal.id===action.payload.id){return action.payload;}else{return proposal;}})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_141" /* WORK_ORDERS_DETAILS_SET_CURRENT_WORK_ORDER */]:return Object.assign({},state,{currentWorkOrder:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_33" /* WORK_ORDERS_DETAILS_CONTRACTOR_INVOICE_SET */]:return Object.assign({},state,{contractorInvoice:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_36" /* WORK_ORDERS_DETAILS_CONTRACTOR_LIEN_RELEASE_SET */]:return Object.assign({},state,{contractorLienRelease:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_34" /* WORK_ORDERS_DETAILS_CONTRACTOR_LIEN_RELEASES_SET */]:return Object.assign({},state,{contractorLienReleases:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_35" /* WORK_ORDERS_DETAILS_CONTRACTOR_LIEN_RELEASE_REMOVE */]:return Object.assign({},state,{contractorLienReleases:state.contractorLienReleases.filter(function(lienRelease){return lienRelease.id!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_155" /* WORK_ORDERS_DETAILS_WOAS_SET */]:return Object.assign({},state,{workOrderAuthorizations:action.payload});default:return state;}}

/***/ }),
/* 3122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = detailsUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={editTask:false,navigationBarSelectedItem:1,preExistingConditions:null,// boolean
preExistingConditionsDescription:'',quotesTableSelectedFilter:'all',selectedOpenItemId:null,showClientStreamModal:false,workOrderJobNumberEdit:false,workOrderJobNumberSaving:false,workOrderJobNumberValue:'',workOrderNameEdit:false,workOrderNameSaving:false,workOrderNameValue:'',workOrderNoteEdit:false,workOrderNoteSaving:false,workOrderNoteValue:'',workOrderNoteReminderValue:null,selectAllChecked:false,selectedTasks:{},showWoaSigningModal:false,woaSigningUrl:null};function detailsUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_32" /* WORK_ORDERS_DETAILS_CLIENT_STREAM_MODAL_SHOW */]:return Object.assign({},state,{showClientStreamModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_72" /* WORK_ORDERS_DETAILS_OPEN_ITEM_SELECTED */]:return Object.assign({},state,{selectedOpenItemId:action.payload!==null?action.payload.id:null});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_73" /* WORK_ORDERS_DETAILS_PRE_EXISTING_CONDITIONS_CHANGE */]:return Object.assign({},state,{preExistingConditions:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_74" /* WORK_ORDERS_DETAILS_PRE_EXISTING_CONDITIONS_DESCRIPTION_CHANGE */]:return Object.assign({},state,{preExistingConditionsDescription:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_75" /* WORK_ORDERS_DETAILS_PRE_EXISTING_CONDITIONS_RESET */]:return Object.assign({},state,{preExistingConditions:null,preExistingConditionsDescription:''});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_146" /* WORK_ORDERS_DETAILS_TASK_EDIT */]:return Object.assign({},state,{editTask:true});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_144" /* WORK_ORDERS_DETAILS_TASK_CANCEL */]:return Object.assign({},state,{editTask:false});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_179" /* WORK_ORDERS_TASK_UPDATE_SUCCESS */]:return Object.assign({},state,{editTask:false});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_143" /* WORK_ORDERS_DETAILS_STATE_INIT */]:return Object.assign({},state,{editTask:false,navigationBarSelectedItem:1,quotesTableSelectedFilter:'all'});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_61" /* WORK_ORDERS_DETAILS_NAV_BAR_SELECTION */]:return Object.assign({},state,{editTask:false,navigationBarSelectedItem:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_135" /* WORK_ORDERS_DETAILS_QUOTES_TABLE_FILTER_CHANGE */]:return Object.assign({},state,{quotesTableSelectedFilter:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_157" /* WORK_ORDERS_DETAILS_WORK_ORDER_JOB_NUMBER_CHANGE */]:return Object.assign({},state,{workOrderJobNumberValue:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_158" /* WORK_ORDERS_DETAILS_WORK_ORDER_JOB_NUMBER_EDIT */]:return Object.assign({},state,{workOrderJobNumberEdit:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_159" /* WORK_ORDERS_DETAILS_WORK_ORDER_JOB_NUMBER_SAVING */]:return Object.assign({},state,{workOrderJobNumberSaving:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_160" /* WORK_ORDERS_DETAILS_WORK_ORDER_NAME_CHANGE */]:return Object.assign({},state,{workOrderNameValue:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_161" /* WORK_ORDERS_DETAILS_WORK_ORDER_NAME_EDIT */]:return Object.assign({},state,{workOrderNameEdit:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_162" /* WORK_ORDERS_DETAILS_WORK_ORDER_NAME_SAVING */]:return Object.assign({},state,{workOrderNameSaving:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_163" /* WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_CHANGE */]:return Object.assign({},state,{workOrderNoteValue:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_165" /* WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_REMINDER_CHANGE */]:return Object.assign({},state,{workOrderNoteReminderValue:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_164" /* WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_EDIT */]:return Object.assign({},state,{workOrderNoteEdit:action.payload,workOrderNoteReminderValue:null});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_166" /* WORK_ORDERS_DETAILS_WORK_ORDER_NOTE_SAVING */]:return Object.assign({},state,{workOrderNoteSaving:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_185" /* WORK_ORDERS_WO_SELECT_SUCCESS */]:if(action.payload!==null){return Object.assign({},state,{workOrderJobNumberEdit:false,workOrderNameEdit:false,workOrderNoteEdit:false,workOrderJobNumberValue:action.payload.work_order_job!==null&&action.payload.work_order_job!==undefined?action.payload.work_order_job.number:'',workOrderNameValue:action.payload.name!==null?action.payload.name:'',workOrderNoteValue:action.payload.note!==null?action.payload.note:''});}else{return state;}case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_152" /* WORK_ORDERS_DETAILS_TASK_SELECT_SET */]:return Object.assign({},state,{selectAllChecked:action.payload.allChecked,selectedTasks:action.payload.selectedTasks});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_151" /* WORK_ORDERS_DETAILS_TASK_SELECT_CLEAR */]:return Object.assign({},state,{selectAllChecked:initialState.selectAllChecked,selectedTasks:initialState.selectedTasks});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_156" /* WORK_ORDERS_DETAILS_WOA_SIGNING_URL_SET */]:return Object.assign({},state,{woaSigningUrl:action.payload,showWoaSigningModal:true});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_142" /* WORK_ORDERS_DETAILS_SHOW_WOA_SIGNING_MODAL_SET */]:return Object.assign({},state,{showWoaSigningModal:false});default:return state;}}

/***/ }),
/* 3123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quotesRequestDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={bidDueDate:null,selectedContractor:null,// object { value: NUMBER, label: STRING }
selectedContractors:[]// array of object { value: NUMBER, label: STRING }
};function quotesRequestDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_125" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_BID_DUE_DATE_SET */]:return Object.assign({},state,{bidDueDate:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_128" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_SET */]:return Object.assign({},state,{selectedContractor:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_126" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_ADD */]:return Object.assign({},state,{selectedContractor:null,selectedContractors:state.selectedContractors.filter(function(element){return element.value!==action.payload.value;})// Filter existing contractor (if exists)
.concat([action.payload])});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_127" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_REMOVE */]:return Object.assign({},state,{selectedContractors:state.selectedContractors.filter(function(element,index){return index!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_130" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_MODAL_SHOW */]:return Object.assign({},state,{bidDueDate:null,selectedContractor:null,selectedContractors:action.payload});default:return state;}}

/***/ }),
/* 3124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quotesRequestUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={currentView:'form',// possible values: 'form', 'preview' and 'message'
showQuotesRequestModal:false};function quotesRequestUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_130" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_MODAL_SHOW */]:return Object.assign({},state,{currentView:'form',showQuotesRequestModal:true});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_132" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_PREVIEW_SHOW */]:return Object.assign({},state,{currentView:'preview'});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_131" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_PREVIEW_GO_BACK */]:return Object.assign({},state,{currentView:'form'});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_133" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_SUBMIT_SUCCESS */]:return Object.assign({},state,{currentView:'message'});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_129" /* WORK_ORDERS_DETAILS_QUOTES_REQUEST_MODAL_CLOSE */]:return Object.assign({},state,{showQuotesRequestModal:false});default:return state;}}

/***/ }),
/* 3125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = proposalApprovalDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={selectedProposalId:null,selectedProposalNumber:null};function proposalApprovalDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_79" /* WORK_ORDERS_DETAILS_PROPOSAL_APPROVAL_MODAL_CLOSE */]:return Object.assign({},state,{selectedProposalId:null,selectedProposalNumber:null});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_80" /* WORK_ORDERS_DETAILS_PROPOSAL_APPROVAL_SELECT */]:return Object.assign({},state,{selectedProposalId:action.payload.id,selectedProposalNumber:action.payload.number});default:return state;}}

/***/ }),
/* 3126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = proposalApprovalUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={showSuccessMessage:false};function proposalApprovalUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_103" /* WORK_ORDERS_DETAILS_PROPOSAL_SUCCESS_MODAL_OPEN */]:return Object.assign({},state,{showSuccessMessage:true});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_102" /* WORK_ORDERS_DETAILS_PROPOSAL_SUCCESS_MODAL_CLOSE */]:return Object.assign({},state,{showSuccessMessage:false});default:return state;}}

/***/ }),
/* 3127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildingsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={selectedBuildingId:0,newBuildingForm:createNewBuildingForm()};function createNewBuildingForm(){return{name:'',streetAddress:'',unitNumber:'',city:'',state:'',zipCode:''};}function buildingsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["n" /* WORK_ORDERS_CREATION_SELECT_BUILDING */]:return Object.assign({},state,{selectedBuildingId:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["l" /* WORK_ORDERS_CREATION_NEW_BUILDING_REQUEST */]:return Object.assign({},state,{selectedBuildingId:0,newBuildingForm:createNewBuildingForm()});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["j" /* WORK_ORDERS_CREATION_NEW_BUILDING_CHANGE_VALUE */]:var newForm=Object.assign({},state.newBuildingForm);newForm[action.payload.attribute]=action.payload.value;return Object.assign({},state,{newBuildingForm:newForm});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["m" /* WORK_ORDERS_CREATION_NEW_BUILDING_SUCCESS */]:return Object.assign({},state,{newBuildingForm:Object.assign({},state.newBuildingForm,{name:action.payload.name!==null?action.payload.name:'',streetAddress:action.payload.location.street_address_1,city:action.payload.location.city,state:action.payload.location.state,zipCode:action.payload.location.zip}),selectedBuildingId:action.payload.id});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["e" /* WORK_ORDERS_CREATION_BUILDING_LOCATION_UPDATE_SUCCESS */]:return Object.assign({},state,{newBuildingForm:Object.assign({},state.newBuildingForm,{streetAddress:action.payload.location.street_address_1,city:action.payload.location.city,state:action.payload.location.state,zipCode:action.payload.location.zip})});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_182" /* WORK_ORDERS_WO_ADD */]:return Object.assign({},state,{selectedBuildingId:0});default:return state;}}

/***/ }),
/* 3128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subContractorsUnionTradesUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={dontKnowUnions:false,noUnions:false,subContractorAnswer:null,showNewContractor:false,validationError:'',unionTradesValidationError:''};function subContractorsUnionTradesUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["z" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_STATE_INIT */]:return Object.assign({},state,{dontKnowUnions:action.payload.dontKnowUnions,noUnions:false,subContractorAnswer:action.payload.dontKnowSubContractor});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["o" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_ADD */]:return Object.assign({},state,{showNewContractor:true,validationError:''});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["r" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_CANCEL */]:return Object.assign({},state,{showNewContractor:false,validationError:''});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["u" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_VALID */]:return Object.assign({},state,{validationError:''});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["s" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_INVALID */]:return Object.assign({},state,{validationError:action.payload.validationMessage});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["t" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_SUCCESS */]:return Object.assign({},state,{showNewContractor:false});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["w" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_QUESTION_ANSWERED */]:return Object.assign({},state,{subContractorAnswer:action.payload.value,validationError:''});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["A" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_VALID_CONFIRMATION */]:return Object.assign({},state,{validationError:''});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["q" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_INVALID_CONFIRMATION */]:return Object.assign({},state,{validationError:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["R" /* WORK_ORDERS_CREATION_UNION_TRADES_VALID_CONFIRMATION */]:return Object.assign({},state,{unionTradesValidationError:''});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["P" /* WORK_ORDERS_CREATION_UNION_TRADES_INVALID_CONFIRMATION */]:return Object.assign({},state,{unionTradesValidationError:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["Q" /* WORK_ORDERS_CREATION_UNION_TRADES_SELECT */]:return Object.assign({},state,{dontKnowUnions:action.payload.dontKnowUnions,noUnions:action.payload.noUnions,unionTradesValidationError:''});default:return state;}}

/***/ }),
/* 3129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tasksUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={showCancel:false};function tasksUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_182" /* WORK_ORDERS_WO_ADD */]:return Object.assign({},state,{showCancel:false});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["I" /* WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_SHOW */]:return Object.assign({},state,{showCancel:true});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["G" /* WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_HIDE */]:return Object.assign({},state,{showCancel:false});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["H" /* WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_NEW */]:case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["J" /* WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_SUCCESS */]:return Object.assign({},state,{showCancel:false});default:return state;}}

/***/ }),
/* 3130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildingsUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={readOnly:true};function buildingsUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["l" /* WORK_ORDERS_CREATION_NEW_BUILDING_REQUEST */]:return Object.assign({},state,{readOnly:true});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["k" /* WORK_ORDERS_CREATION_NEW_BUILDING_EDIT */]:return Object.assign({},state,{readOnly:false});default:return state;}}

/***/ }),
/* 3131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = workOrderSummaryUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={showSubmitRequestConfirmation:false,showWorkOrderCreatedConfirmation:false};function workOrderSummaryUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["B" /* WORK_ORDERS_CREATION_SUMMARY_CONFIRMATION_SUCCESS */]:return Object.assign({},state,{showWorkOrderCreatedConfirmation:true});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["C" /* WORK_ORDERS_CREATION_SUMMARY_CONFIRMATION_WITHOUT_PICS_SUCCESS */]:return Object.assign({},state,{showSubmitRequestConfirmation:true});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["D" /* WORK_ORDERS_CREATION_SUMMARY_START */]:return Object.assign({},state,{showSubmitRequestConfirmation:false,showWorkOrderCreatedConfirmation:false});default:return state;}}

/***/ }),
/* 3132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = workingHoursDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={otherWorkingHour:'',workingHours:[{id:'monday-friday-day',value:'Monday-Friday 5AM-5PM',selected:false},{id:'monday-friday-night',value:'Monday-Friday 5PM-5AM',selected:false},{id:'saturday',value:'Saturday',selected:false},{id:'sunday',value:'Sunday',selected:false},{id:'other',value:'Other',selected:false}]};function workingHoursDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["V" /* WORK_ORDERS_CREATION_WORKING_HOURS_SELECT */]:return Object.assign({},state,{workingHours:state.workingHours.map(function(element){if(element.id===action.payload){return Object.assign({},element,{selected:!element.selected});}else{return element;}})});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["U" /* WORK_ORDERS_CREATION_WORKING_HOURS_OTHER_CHANGE */]:return Object.assign({},state,{otherWorkingHour:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_182" /* WORK_ORDERS_WO_ADD */]:return Object.assign({},state,{otherWorkingHour:'',workingHours:state.workingHours.map(function(element){return Object.assign({},element,{selected:false});})});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["S" /* WORK_ORDERS_CREATION_WORKING_HOURS_CURRENT_SET */]:var otherWorkingHour='';var newWorkingHours=state.workingHours.slice();// Current working hours
action.payload.forEach(function(element){var index=newWorkingHours.findIndex(function(wh){return wh.value===element;});if(index>-1){newWorkingHours[index]=Object.assign({},newWorkingHours[index],{selected:true});}else{// Text not found on list, should be "other"
otherWorkingHour=element;}});return Object.assign({},state,{otherWorkingHour:otherWorkingHour,workingHours:newWorkingHours});default:return state;}}

/***/ }),
/* 3133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = workingHoursUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={validationError:''};function workingHoursUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["W" /* WORK_ORDERS_CREATION_WORKING_HOURS_VALID */]:return Object.assign({},state,{validationError:''});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["T" /* WORK_ORDERS_CREATION_WORKING_HOURS_INVALID */]:return Object.assign({},state,{validationError:action.payload});default:return state;}}

/***/ }),
/* 3134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subContractorsUnionTradesDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={newSubContractor:null,selectedSubContractorsId:[],selectedUnionTradesId:[]};function createEmptyForm(){return{subContractorName:{value:'',valid:true},phoneNumber:{value:'',valid:true},streetAddress:{value:'',valid:true},unitNumberFloor:{value:'',valid:true},city:{value:'',valid:true},state:{value:'',valid:true},zipCode:{value:'',valid:true},contactFirstName:{value:'',valid:true},contactLastName:{value:'',valid:true},email:{value:'',valid:true}};}function subContractorsUnionTradesDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var newSubContractor=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["p" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_CURRENT_SET */]:return Object.assign({},state,{selectedSubContractorsId:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["y" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_SELECT */]:return Object.assign({},state,{selectedSubContractorsId:state.selectedSubContractorsId.concat([action.payload])});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["o" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_ADD */]:return Object.assign({},state,{newSubContractor:createEmptyForm()});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["r" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_CANCEL */]:return Object.assign({},state,{newSubContractor:null});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["v" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_VALUE_CHANGE */]:newSubContractor=Object.assign({},state.newSubContractor);newSubContractor[action.payload.attribute]={value:action.payload.value,valid:true};return Object.assign({},state,{newSubContractor:newSubContractor});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["s" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_INVALID */]:newSubContractor=Object.assign({},state.newSubContractor);action.payload.fields.forEach(function(field){newSubContractor[field]=Object.assign({},state.newSubContractor[field],{valid:false});});return Object.assign({},state,{newSubContractor:newSubContractor});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["t" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_NEW_SUCCESS */]:return Object.assign({},state,{selectedSubContractorsId:state.selectedSubContractorsId.concat(action.payload.id)});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_182" /* WORK_ORDERS_WO_ADD */]:return Object.assign({},state,{newSubContractor:null,selectedSubContractorsId:[]});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["x" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_REMOVE */]:return Object.assign({},state,{selectedSubContractorsId:state.selectedSubContractorsId.filter(function(element){return element!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["w" /* WORK_ORDERS_CREATION_SUB_CONTRACTORS_QUESTION_ANSWERED */]:return Object.assign({},state,{selectedSubContractorsId:action.payload.clearSelected?[]:state.selectedSubContractorsId});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["Q" /* WORK_ORDERS_CREATION_UNION_TRADES_SELECT */]:return Object.assign({},state,{selectedUnionTradesId:action.payload.newSelectedUnionTradesId});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["O" /* WORK_ORDERS_CREATION_UNION_TRADES_CURRENT_SET */]:return Object.assign({},state,{selectedUnionTradesId:action.payload});default:return state;}}

/***/ }),
/* 3135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = workOrdersDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={buildings:[],orders:null,contractors:[],currentWorkOrder:null,tasks:[],trades:[],subTradesByTradeId:{},summary:null,unionTrades:[]};function workOrdersDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var newTasks=void 0;var index=void 0;var newBuildings=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_170" /* WORK_ORDERS_LOAD_SUCCESS */]:return Object.assign({},state,{orders:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_185" /* WORK_ORDERS_WO_SELECT_SUCCESS */]:return Object.assign({},state,{currentWorkOrder:action.payload,summary:null,tasks:[]});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_184" /* WORK_ORDERS_WO_LOAD_TASKS_SUCCESS */]:return Object.assign({},state,{tasks:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["i" /* WORK_ORDERS_CREATION_LOAD_BUILDINGS_SUCCESS */]:return Object.assign({},state,{buildings:action.payload,errors:[]});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_181" /* WORK_ORDERS_WORK_ORDER_CREATION_SUCCESS */]:return Object.assign({},state,{currentWorkOrder:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_171" /* WORK_ORDERS_LOAD_TRADES_SUCCESS */]:return Object.assign({},state,{trades:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_169" /* WORK_ORDERS_LOAD_SUB_TRADES_SUCCESS */]:var newSubTrades=Object.assign({},state.subTradesByTradeId);newSubTrades[action.payload.tradeId]=action.payload.subTrades;return Object.assign({},state,{subTradesByTradeId:newSubTrades});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["N" /* WORK_ORDERS_CREATION_TASKS_TASK_SAVE_SUCCESS */]:newTasks=state.tasks.slice();newTasks.push(action.payload);return Object.assign({},state,{tasks:newTasks});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["J" /* WORK_ORDERS_CREATION_TASKS_TASK_CANCEL_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_177" /* WORK_ORDERS_TASK_REMOVE */]:return Object.assign({},state,{tasks:state.tasks.filter(function(element){return element.id!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_168" /* WORK_ORDERS_LOAD_CONTRACTORS_SUCCESS */]:return Object.assign({},state,{contractors:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["b" /* WORK_ORDERS_CONTRACTOR_NEW_SUCCESS */]:return Object.assign({},state,{contractors:state.contractors.concat([action.payload])});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_0" /* WORK_ORDERS_CURRENT_WO_ATTRIBUTE_UPDATE */]:return Object.assign({},state,{currentWorkOrder:Object.assign({},state.currentWorkOrder,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_183" /* WORK_ORDERS_WO_ATTRIBUTE_UPDATE */]:return Object.assign({},state,{currentWorkOrder:Object.assign({},state.currentWorkOrder,_defineProperty({},action.payload.attribute,action.payload.workOrder[action.payload.attribute]))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_186" /* WORK_ORDERS_WO_UPDATE */]:return Object.assign({},state,{currentWorkOrder:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_180" /* WORK_ORDERS_UNION_TRADES_LOAD_SUCCESS */]:return Object.assign({},state,{unionTrades:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_174" /* WORK_ORDERS_SUMMARY_LOAD_SUCCESS */]:return Object.assign({},state,{summary:action.payload,tasks:action.payload.tasks// The complete tasks info can be obtained from the WO summary
});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_175" /* WORK_ORDERS_SUMMARY_TASK_REMOVE */]:return Object.assign({},state,{summary:Object.assign({},state.summary,{tasks:state.summary.tasks.filter(function(element){return element.id!==action.payload;})})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_182" /* WORK_ORDERS_WO_ADD */]:return Object.assign({},state,{currentWorkOrder:null,tasks:[],summary:null});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_176" /* WORK_ORDERS_TASK_CHECKLIST_UPDATE */]:return Object.assign({},state,{tasks:state.tasks.map(function(task){if(task.id===action.payload.taskId){return Object.assign({},task,{task_checklist:action.payload.taskChecklist});}else{return task;}})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_178" /* WORK_ORDERS_TASK_UPDATE */]:return Object.assign({},state,{tasks:state.tasks.map(function(task){if(task.id===action.payload.id){return action.payload;}else{return task;}})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_54" /* WORK_ORDERS_DETAILS_DOCUMENTS_UPLOAD_SUCCESS */]:return Object.assign({},state,{currentWorkOrder:Object.assign({},state.currentWorkOrder,{documents:state.currentWorkOrder.documents.concat(action.payload)})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_154" /* WORK_ORDERS_DETAILS_UNREAD_NOTES_SET */]:return Object.assign({},state,{currentWorkOrder:Object.assign({},state.currentWorkOrder,{unread_notes:action.payload})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_55" /* WORK_ORDERS_DETAILS_DOCUMENT_REMOVE_SUCCESS */]:return Object.assign({},state,{currentWorkOrder:Object.assign({},state.currentWorkOrder,{documents:state.currentWorkOrder.documents.filter(function(element){return element.id!==action.payload;})})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["m" /* WORK_ORDERS_CREATION_NEW_BUILDING_SUCCESS */]:return Object.assign({},state,{buildings:state.buildings.concat([action.payload])});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["e" /* WORK_ORDERS_CREATION_BUILDING_LOCATION_UPDATE_SUCCESS */]:newBuildings=state.buildings.slice();index=newBuildings.findIndex(function(element){return element.id===action.payload.selectedBuildingId;});newBuildings[index]=Object.assign({},newBuildings[index],{location:action.payload.location});newBuildings[index].location.latitude=action.payload.latitude;newBuildings[index].location.longitude=action.payload.longitude;return Object.assign({},state,{buildings:newBuildings});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["d" /* WORK_ORDERS_CREATION_BUILDING_DOCUMENTS_UPLOAD_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["c" /* WORK_ORDERS_CREATION_BUILDING_DOCUMENTS_REMOVE_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["f" /* WORK_ORDERS_CREATION_BUILDING_UPDATE_SUCCESS */]:newBuildings=state.buildings.slice();index=newBuildings.findIndex(function(element){return element.id===action.payload.id;});newBuildings[index]=action.payload;return Object.assign({},state,{buildings:newBuildings});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_1" /* WORK_ORDERS_CURRENT_WO_COMPLETE */]:return Object.assign({},state,{currentWorkOrder:Object.assign({},state.currentWorkOrder,{status:action.payload})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["a" /* WORK_ORDERS_ADD_BUILDING_TO_BEGINNING */]:return Object.assign({},state,{buildings:[action.payload].concat(_toConsumableArray(state.buildings))});default:return state;}}

/***/ }),
/* 3136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = workOrdersUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={currentPage:1,searchText:'',showNoWorkOrdersOverlay:false,currentInvoicesTab:1};function workOrdersUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_170" /* WORK_ORDERS_LOAD_SUCCESS */]:return Object.assign({},state,{showNoWorkOrdersOverlay:action.payload.total===0// show overlay if no WO created yet
});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_173" /* WORK_ORDERS_SEARCH_TEXT_CHANGE */]:return Object.assign({},state,{searchText:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_172" /* WORK_ORDERS_PAGE_CHANGE */]:return Object.assign({},state,{currentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_167" /* WORK_ORDERS_INVOICES_TAB_CHANGE */]:return Object.assign({},state,{currentInvoicesTab:action.payload});default:return state;}}

/***/ }),
/* 3137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createQuoteDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={form:{}};function createQuoteDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var newForm=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_45" /* WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_SHOW */]:return Object.assign({},state,{form:{startDate:{value:'',valid:true},duration:{value:null,valid:true},cost:{value:'',valid:true},materialLeadDays:{value:'',valid:true},description:{value:''}}});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_140" /* WORK_ORDERS_DETAILS_REVIEW_QUOTE_MODAL_SHOW */]:return Object.assign({},state,{form:{startDate:{value:action.payload.start_date,valid:true},duration:{value:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(action.payload.days_of_duration).value(),valid:true},cost:{value:action.payload.status==='received'&&action.payload.counter_status==='negotiating'?action.payload.counter:action.payload.estimate,valid:true},materialLeadDays:{value:action.payload.material_lead_days!==null?__WEBPACK_IMPORTED_MODULE_1_numeral___default()(action.payload.material_lead_days).value():'',valid:true},description:{value:action.payload.description!==null?action.payload.description:''}}});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_44" /* WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_VALUE_UPDATE */]:return Object.assign({},state,{form:Object.assign({},state.form,_defineProperty({},action.payload.attribute,{value:action.payload.value,valid:true}))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_42" /* WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_INVALID */]:newForm=Object.assign({},state.form);action.payload.forEach(function(attribute){return newForm[attribute].valid=false;});return Object.assign({},state,{form:newForm});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_43" /* WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_VALID */]:newForm=Object.assign({},state.form);Object.keys(newForm).forEach(function(key){return newForm[key].valid=true;});return Object.assign({},state,{form:newForm});default:return state;}}

/***/ }),
/* 3138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = creationUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={newWOProcessStarted:false,showWOCancellationConfirmationModal:false};function creationUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["X" /* WORK_ORDERS_CREATION_WO_CANCELLATION_MODAL_CLOSE */]:return Object.assign({},state,{showWOCancellationConfirmationModal:false});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["Y" /* WORK_ORDERS_CREATION_WO_CANCELLATION_MODAL_SHOW */]:return Object.assign({},state,{showWOCancellationConfirmationModal:true});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["Z" /* WORK_ORDERS_CREATION_WO_NEW_PROCESS_STARTED */]:return Object.assign({},state,{newWOProcessStarted:action.payload});default:return state;}}

/***/ }),
/* 3139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = membersDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={users:[]};function membersDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_6" /* WORK_ORDERS_DETAILS_ADD_MEMBER_USERS_LOAD_SUCCESS */]:return Object.assign({},state,{users:action.payload});default:return state;}}

/***/ }),
/* 3140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = membersUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={form:{note:'',userId:null},invalidFields:[],showAddMemberModal:false,validationMessage:''};function membersUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_2" /* WORK_ORDERS_DETAILS_ADD_MEMBER_FORM_INVALID */]:return Object.assign({},state,{invalidFields:action.payload.invalidFields,validationMessage:action.payload.message});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_3" /* WORK_ORDERS_DETAILS_ADD_MEMBER_FORM_VALID */]:return Object.assign({},state,{invalidFields:[],validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_4" /* WORK_ORDERS_DETAILS_ADD_MEMBER_FORM_VALUE_UPDATE */]:return Object.assign({},state,{form:Object.assign({},state.form,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_5" /* WORK_ORDERS_DETAILS_ADD_MEMBER_MODAL_SHOW */]:return Object.assign({},initialState,{showAddMemberModal:action.payload});default:return state;}}

/***/ }),
/* 3141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = openItemsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={members:[]};function openItemsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_10" /* WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_MEMBERS_LOAD_SUCCESS */]:return Object.assign({},state,{members:action.payload});default:return state;}}

/***/ }),
/* 3142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = openItemsUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={editOpenItem:false,form:{critical:false,description:'',dueDate:'',memberId:null},editForm:{userId:null,description:'',dueDate:null,resolved:false,resolvedNote:''},invalidFields:[],showAddOpenItemModal:false,validationMessage:''};function openItemsUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_7" /* WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_INVALID */]:return Object.assign({},state,{invalidFields:action.payload.invalidFields,validationMessage:action.payload.message});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_8" /* WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_VALID */]:return Object.assign({},state,{invalidFields:[],validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_9" /* WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_VALUE_UPDATE */]:return Object.assign({},state,{form:Object.assign({},state.form,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_56" /* WORK_ORDERS_DETAILS_EDIT_OPEN_ITEM_FORM_VALUE_UPDATE */]:return Object.assign({},state,{editForm:Object.assign({},state.editForm,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_11" /* WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_MODAL_SHOW */]:return Object.assign({},initialState,{showAddOpenItemModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_71" /* WORK_ORDERS_DETAILS_OPEN_ITEM_EDIT_SET */]:return Object.assign({},state,{editOpenItem:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_72" /* WORK_ORDERS_DETAILS_OPEN_ITEM_SELECTED */]:return Object.assign({},initialState,{editOpenItem:false,resolved:action.payload!==null?action.payload.resolved:state.resolved});default:return state;}}

/***/ }),
/* 3143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clientsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={clients:[]};function clientsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["h" /* WORK_ORDERS_CREATION_CLIENTS_LOAD_SUCCESS */]:return Object.assign({},state,{clients:action.payload});default:return state;}}

/***/ }),
/* 3144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clientsUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={selectedClientId:null};function clientsUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_182" /* WORK_ORDERS_WO_ADD */]:return Object.assign({},state,{selectedClientId:null});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["g" /* WORK_ORDERS_CREATION_CLIENTS_CLIENT_SET */]:return Object.assign({},state,{selectedClientId:action.payload});default:return state;}}

/***/ }),
/* 3145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = qualificationsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={qualifications:[],trades:[]};function qualificationsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_113" /* WORK_ORDERS_DETAILS_QUALIFICATIONS_ADD_SUCCESS */]:return Object.assign({},state,{qualifications:state.qualifications.concat([action.payload])});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_114" /* WORK_ORDERS_DETAILS_QUALIFICATIONS_LOAD_SUCCESS */]:return Object.assign({},state,{qualifications:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_120" /* WORK_ORDERS_DETAILS_QUALIFICATIONS_TRADES_LOAD_SUCCESS */]:return Object.assign({},state,{trades:action.payload});default:return state;}}

/***/ }),
/* 3146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = qualificationsUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__ = __webpack_require__(22);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={selectedQualificationsById:{},//   { id: { id: number, option: null } }
showNewQualificationModal:false};function qualificationsUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_115" /* WORK_ORDERS_DETAILS_QUALIFICATIONS_MODAL_SHOW */]:return Object.assign({},state,{showNewQualificationModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_116" /* WORK_ORDERS_DETAILS_QUALIFICATIONS_OPTION_SELECTED */]:return Object.assign({},state,{selectedQualificationsById:Object.assign({},state.selectedQualificationsById,_defineProperty({},action.payload.qualificationId,{id:action.payload.qualificationId,option:action.payload.option}))});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_117" /* WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED */]:var newSelectedQualificationsById=Object.assign({},state.selectedQualificationsById);if(state.selectedQualificationsById[action.payload]!==undefined){delete newSelectedQualificationsById[action.payload];}else{newSelectedQualificationsById[action.payload]={id:action.payload,option:null};}return Object.assign({},state,{selectedQualificationsById:newSelectedQualificationsById});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_118" /* WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED_BY_ID_SET */]:return Object.assign({},state,{selectedQualificationsById:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_work_orders_action_types__["_119" /* WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED_CLEAR */]:return Object.assign({},state,{selectedQualificationsById:{}});default:return state;}}

/***/ }),
/* 3147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newTaskDataReducer;
var initialState={};function newTaskDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){default:return state;}}

/***/ }),
/* 3148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newTaskUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={form:{completionDate:null,description:'',floorNumber:'',images:[],name:'',number:0,room:'',subTrade:0,trade:0},showModal:false};function newTaskUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_62" /* WORK_ORDERS_DETAILS_NEW_TASK_ATTRIBUTE_CHANGE */]:return Object.assign({},state,{form:Object.assign({},state.form,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_63" /* WORK_ORDERS_DETAILS_NEW_TASK_FORM_CLEAR */]:return Object.assign({},state,{form:initialState.form});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_64" /* WORK_ORDERS_DETAILS_NEW_TASK_IMAGE_REMOVE */]:return Object.assign({},state,{form:Object.assign({},state.form,{images:state.form.images.filter(function(image,index){return index!==action.payload;})})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_65" /* WORK_ORDERS_DETAILS_NEW_TASK_MODAL_SHOW */]:return Object.assign({},state,{showModal:action.payload});default:return state;}}

/***/ }),
/* 3149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = budgetUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={approvedTasksId:[],currentView:'form',// oneOf: [form, review, thank-you]
emails:[],message:'',pdf:null,show:false,showApprovalConfirmation:false,showApproveReviewModal:false,showEmailModal:false,showPdfViewer:false,subject:'',valuesByTaskId:{}// { cost, fee, markup, insurance }
};function budgetUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_13" /* WORK_ORDERS_DETAILS_BUDGET_CURRENT_VIEW_SET */]:return Object.assign({},state,{currentView:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_14" /* WORK_ORDERS_DETAILS_BUDGET_EMAIL_ADD */]:if(state.emails.find(function(email){return email===action.payload;})===undefined){return Object.assign({},state,{emails:state.emails.concat([action.payload])});}else{return state;}case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_15" /* WORK_ORDERS_DETAILS_BUDGET_EMAIL_CLEAR */]:return Object.assign({},state,{emails:[]});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_16" /* WORK_ORDERS_DETAILS_BUDGET_EMAIL_MODAL_SHOW_SET */]:return Object.assign({},state,{showEmailModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_17" /* WORK_ORDERS_DETAILS_BUDGET_EMAIL_REMOVE */]:return Object.assign({},state,{emails:state.emails.filter(function(email){return email!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_18" /* WORK_ORDERS_DETAILS_BUDGET_MESSAGE_SET */]:return Object.assign({},state,{message:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_19" /* WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_APPROVAL_CONFIRMATION_SET */]:return Object.assign({},state,{showApprovalConfirmation:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_20" /* WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_APPROVE_REVIEW_SET */]:return Object.assign({},state,{showApproveReviewModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_21" /* WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_SET */]:return Object.assign({},state,{show:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_12" /* WORK_ORDERS_DETAILS_BUDGET_BACK */]:case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_22" /* WORK_ORDERS_DETAILS_BUDGET_NEXT */]:return Object.assign({},state,{currentView:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_23" /* WORK_ORDERS_DETAILS_BUDGET_PDF_VIEWER_CLOSE */]:return Object.assign({},state,{showPdfViewer:false});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_24" /* WORK_ORDERS_DETAILS_BUDGET_PRINT_SUCCESS */]:return Object.assign({},state,{pdf:action.payload,showPdfViewer:true});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_26" /* WORK_ORDERS_DETAILS_BUDGET_SUBJECT_SET */]:return Object.assign({},state,{subject:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_27" /* WORK_ORDERS_DETAILS_BUDGET_TASK_CHECK */]:if(state.approvedTasksId.find(function(id){return id===action.payload.id;})!==undefined){if(!action.payload.value){return Object.assign({},state,{approvedTasksId:state.approvedTasksId.filter(function(id){return id!==action.payload.id;})});}else{// Already selected, don't do anything
return state;}}else{if(action.payload.value){return Object.assign({},state,{approvedTasksId:state.approvedTasksId.concat([action.payload.id])});}else{// Already unselected, don't do anything
return state;}}case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_30" /* WORK_ORDERS_DETAILS_BUDGET_VALUE_UPDATE */]:return Object.assign({},state,{valuesByTaskId:Object.assign({},state.valuesByTaskId,_defineProperty({},action.payload.taskId,Object.assign({},state.valuesByTaskId[action.payload.taskId],_defineProperty({},action.payload.valueKey,action.payload.value))))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_29" /* WORK_ORDERS_DETAILS_BUDGET_VALUES_INIT */]:return Object.assign({},state,{valuesByTaskId:action.payload});default:return state;}}

/***/ }),
/* 3150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = purchaseOrderUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={documentFile:null,documentUrl:null,edit:false,number:''};function getPurchaseOrderInfo(workOrder){return{document:workOrder.purchase_order_doc!==null&&workOrder.purchase_order_doc!==undefined?workOrder.purchase_order_doc.document.url:null,number:workOrder.purchase_order!==null&&workOrder.purchase_order!==undefined?workOrder.purchase_order:''};}function purchaseOrderUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_112" /* WORK_ORDERS_DETAILS_PURCHASE_ORDER_UPDATE */]:case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_107" /* WORK_ORDERS_DETAILS_PURCHASE_ORDER_CANCEL */]:var result=getPurchaseOrderInfo(action.payload);return Object.assign({},state,{edit:false,documentFile:null,documentUrl:result.document,number:result.number});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_108" /* WORK_ORDERS_DETAILS_PURCHASE_ORDER_DOCUMENT_FILE_SET */]:return Object.assign({},state,{documentFile:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_109" /* WORK_ORDERS_DETAILS_PURCHASE_ORDER_DOCUMENT_REMOVE */]:return Object.assign({},state,{documentFile:null,documentUrl:null});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_110" /* WORK_ORDERS_DETAILS_PURCHASE_ORDER_EDIT_SET */]:return Object.assign({},state,{edit:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_111" /* WORK_ORDERS_DETAILS_PURCHASE_ORDER_NUMBER_SET */]:return Object.assign({},state,{number:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_185" /* WORK_ORDERS_WO_SELECT_SUCCESS */]:if(action.payload!==null){var _result=getPurchaseOrderInfo(action.payload);// Take into account that this action is used to set the current WO to null
return Object.assign({},state,{documentFile:null,documentUrl:_result.document,number:_result.number});}else{return state;}default:return state;}}

/***/ }),
/* 3151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = budgetDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={users:[]};function budgetDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_work_orders_action_types__["_28" /* WORK_ORDERS_DETAILS_BUDGET_USERS_LOAD_SUCCESS */]:return Object.assign({},state,{users:action.payload});default:return state;}}

/***/ }),
/* 3152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = timeDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_time_store_action_types__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={time:[]};function timeDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_time_store_action_types__["a" /* TIME_ADD_ENTRY_SUCCESS */]:return Object.assign({},state,{time:state.time.concat([action.payload])});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_time_store_action_types__["d" /* TIME_RATE_CONFIRM_SUCCESS */]:return{time:state.time.map(function(timeEntry){if(timeEntry.id===action.payload.id){return action.payload;}return timeEntry;})};case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_time_store_action_types__["f" /* TIME_REMOVE */]:return Object.assign({},state,{time:state.time.filter(function(time){return time.id!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_time_store_action_types__["g" /* TIME_SET */]:return Object.assign({},state,{time:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_time_store_action_types__["i" /* TIME_UPDATE */]:return Object.assign({},state,{time:state.time.map(function(time){if(time.id===action.payload.id){return action.payload;}return time;})});case __WEBPACK_IMPORTED_MODULE_1_actions_admin_work_orders_action_types__["_143" /* WORK_ORDERS_DETAILS_STATE_INIT */]:return Object.assign({},state,{time:initialState.time});default:return state;}}

/***/ }),
/* 3153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = timeUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_time_store_action_types__ = __webpack_require__(502);
var initialState={rate:null,showAddModal:false,timeToEdit:null,timeIdRateToEdit:null};function timeUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_time_store_action_types__["b" /* TIME_ADD_MODAL_SHOW */]:return Object.assign({},state,{showAddModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_time_store_action_types__["c" /* TIME_ID_RATE_TO_EDIT */]:return Object.assign({},state,{rate:action.payload.rate!==null?action.payload.rate.toString():'0',timeIdRateToEdit:action.payload.timeId});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_time_store_action_types__["d" /* TIME_RATE_CONFIRM_SUCCESS */]:return Object.assign({},state,{rate:initialState.rate,timeIdRateToEdit:initialState.timeIdRateToEdit});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_time_store_action_types__["e" /* TIME_RATE_SET */]:return Object.assign({},state,{rate:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_time_store_action_types__["h" /* TIME_TO_EDIT */]:return Object.assign({},state,{timeToEdit:action.payload});default:return state;}}

/***/ }),
/* 3154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = vendorInvoicesDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_vendor_invoices_store_action_types__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={invoices:[]};function vendorInvoicesDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_vendor_invoices_store_action_types__["b" /* VENDOR_INVOICES_INVOICE_ADD */]:return Object.assign({},state,{invoices:state.invoices.concat([action.payload])});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_vendor_invoices_store_action_types__["c" /* VENDOR_INVOICES_INVOICE_REMOVE */]:return Object.assign({},state,{invoices:state.invoices.filter(function(invoice){return invoice.id!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_vendor_invoices_store_action_types__["d" /* VENDOR_INVOICES_SET */]:return Object.assign({},state,{invoices:action.payload});case __WEBPACK_IMPORTED_MODULE_1_actions_admin_work_orders_action_types__["_143" /* WORK_ORDERS_DETAILS_STATE_INIT */]:return Object.assign({},state,{invoices:initialState.invoices});default:return state;}}

/***/ }),
/* 3155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = vendorInvoicesUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_vendor_invoices_store_action_types__ = __webpack_require__(504);
var initialState={showAddInvoiceModal:false};function vendorInvoicesUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_vendor_invoices_store_action_types__["a" /* VENDOR_INVOICES_ADD_INVOICE_MODAL_SHOW */]:return Object.assign({},state,{showAddInvoiceModal:action.payload});default:return state;}}

/***/ }),
/* 3156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transferWorkOrderUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_transfer_store_action_types__ = __webpack_require__(957);
var initialState={selectedClient:null,showModal:false,showMessageModal:false};function transferWorkOrderUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_transfer_store_action_types__["a" /* TRANSFER_WORK_ORDER_CLIENT_SELECT */]:return Object.assign({},state,{selectedClient:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_transfer_store_action_types__["b" /* TRANSFER_WORK_ORDER_MESSAGE_MODAL_SHOW */]:return Object.assign({},state,{showMessageModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_transfer_store_action_types__["c" /* TRANSFER_WORK_ORDER_MODAL_SHOW */]:return Object.assign({},state,{selectedClient:action.payload?null:state.selectedClient,showModal:action.payload});default:return state;}}

/***/ }),
/* 3157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = receiptsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_receipts_store_action_types__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_admin_work_orders_action_types__ = __webpack_require__(22);
var initialState={receipts:[]};function receiptsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_receipts_store_action_types__["a" /* RECEIPTS_ADD */]:return Object.assign({},state,{receipts:state.receipts.concat([action.payload])});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_receipts_store_action_types__["b" /* RECEIPTS_REMOVE */]:return Object.assign({},state,{receipts:state.receipts.filter(function(receipt){return receipt.id!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_receipts_store_action_types__["c" /* RECEIPTS_SET */]:return Object.assign({},state,{receipts:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_receipts_store_action_types__["f" /* RECEIPTS_UPDATE */]:return Object.assign({},state,{receipts:state.receipts.map(function(receipt){if(receipt.id===action.payload.id){return action.payload;}return receipt;})});case __WEBPACK_IMPORTED_MODULE_1_actions_admin_work_orders_action_types__["_143" /* WORK_ORDERS_DETAILS_STATE_INIT */]:return Object.assign({},state,{receipts:initialState.receipts});default:return state;}}

/***/ }),
/* 3158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = receiptsUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_receipts_store_action_types__ = __webpack_require__(506);
var initialState={receiptToEdit:null,showAddMaterialsModal:false};function receiptsUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_receipts_store_action_types__["d" /* RECEIPTS_SHOW_ADD_MODAL_SET */]:return Object.assign({},state,{showAddMaterialsModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_receipts_store_action_types__["e" /* RECEIPTS_TO_EDIT_SET */]:return Object.assign({},state,{receiptToEdit:action.payload});default:return state;}}

/***/ }),
/* 3159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = anticipatedCostReportDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_anticipated_cost_report_store_action_types__ = __webpack_require__(588);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={miscCosts:{},proposal:{additionalCost:'',additionalCostDesc:''}};function anticipatedCostReportDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_anticipated_cost_report_store_action_types__["e" /* ACR_MISC_COST_SET */]:return Object.assign({},state,{miscCosts:Object.assign({},state.miscCosts,_defineProperty({},action.payload.quoteId,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_anticipated_cost_report_store_action_types__["c" /* ACR_ADDITIONAL_COST_SET */]:return Object.assign({},state,{proposal:Object.assign({},state.proposal,_defineProperty({},action.payload.attr,action.payload.value))});default:return state;}}

/***/ }),
/* 3160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = anticipatedCostReportUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_anticipated_cost_report_store_action_types__ = __webpack_require__(588);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={edit:{},saving:{},additionalCostEdit:false,additionalCostSaving:false};function anticipatedCostReportUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_anticipated_cost_report_store_action_types__["d" /* ACR_EDIT_SET */]:return Object.assign({},state,{edit:Object.assign({},state.edit,_defineProperty({},action.payload,!state.edit[action.payload]))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_anticipated_cost_report_store_action_types__["f" /* ACR_SAVING_SET */]:return Object.assign({},state,{saving:Object.assign({},state.saving,_defineProperty({},action.payload,!state.saving[action.payload]))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_anticipated_cost_report_store_action_types__["a" /* ACR_ADDITIONAL_COST_EDIT_SET */]:return Object.assign({},state,{additionalCostEdit:!state.additionalCostEdit});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_anticipated_cost_report_store_action_types__["b" /* ACR_ADDITIONAL_COST_SAVING_SET */]:return Object.assign({},state,{additionalCostSaving:!state.additionalCostSaving});default:return state;}}

/***/ }),
/* 3161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = changeOrderTasksDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_tasks_store_action_types__ = __webpack_require__(575);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={changeOrderTasks:[]};function changeOrderTasksDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_tasks_store_action_types__["b" /* CHANGE_ORDER_TASKS_LOAD_SUCCESS */]:return Object.assign({},state,{changeOrderTasks:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_tasks_store_action_types__["a" /* CHANGE_ORDER_TASKS_ADD */]:return Object.assign({},state,{changeOrderTasks:[].concat(_toConsumableArray(state.changeOrderTasks),[action.payload])});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_tasks_store_action_types__["d" /* CHANGE_ORDER_TASKS_UPDATE */]:return Object.assign({},state,{changeOrderTasks:state.changeOrderTasks.map(function(changeOrder){if(action.payload.id===changeOrder.id){return action.payload;}else{return changeOrder;}})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_tasks_store_action_types__["e" /* CHANGE_ORDER_TASK_DELETE */]:return Object.assign({},state,{changeOrderTasks:state.changeOrderTasks.filter(function(changeOrder){return action.payload!==changeOrder.id;})});default:return state;}}

/***/ }),
/* 3162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = changeOrderTasksUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_tasks_store_action_types__ = __webpack_require__(575);
var initialState={showChangeOrderTaskModal:false};function changeOrderTasksUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_tasks_store_action_types__["c" /* CHANGE_ORDER_TASKS_SHOW_MODAL_SET */]:return Object.assign({},state,{showChangeOrderTaskModal:!state.showChangeOrderTaskModal});default:return state;}}

/***/ }),
/* 3163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = changeOrderQuotesDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_quotes_store_action_types__ = __webpack_require__(576);
var initialState={selectedChangeOrderTaskId:null};function changeOrderQuotesDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_quotes_store_action_types__["c" /* CHANGE_ORDER_QUOTES_SELECT */]:return Object.assign({},state,{selectedChangeOrderTaskId:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_quotes_store_action_types__["d" /* CHANGE_ORDER_QUOTE_DETAILS_MODAL_CLOSE */]:return Object.assign({},state,{selectedChangeOrderTaskId:null});default:return state;}}

/***/ }),
/* 3164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = changeOrderQuotesUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_quotes_store_action_types__ = __webpack_require__(576);
var initialState={showChangeOrderQuoteModal:false,showChangeOrderRequestConfirmation:false};function changeOrderQuotesUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_quotes_store_action_types__["b" /* CHANGE_ORDER_QUOTES_REQUEST_MODAL_SET */]:return Object.assign({},state,{showChangeOrderQuoteModal:!state.showChangeOrderQuoteModal});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_order_quotes_store_action_types__["a" /* CHANGE_ORDER_QUOTES_REQUEST_CONFIRMATION_SET */]:return Object.assign({},state,{showChangeOrderRequestConfirmation:!state.showChangeOrderRequestConfirmation});default:return state;}}

/***/ }),
/* 3165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = changeOrdersDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__ = __webpack_require__(580);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={changeOrders:[],startDate:null,completionDate:null,valuesByQuoteId:{},selectedChangeOrderId:null,selectedChangeOrderNumber:null,users:[]};function changeOrdersDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["b" /* CHANGE_ORDERS_LOAD_SUCCESS */]:return Object.assign({},state,{changeOrders:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["a" /* CHANGE_ORDERS_ADD */]:return Object.assign({},state,{changeOrders:[].concat(_toConsumableArray(state.changeOrders),[action.payload])});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["c" /* CHANGE_ORDERS_UPDATE */]:return Object.assign({},state,{changeOrders:state.changeOrders.map(function(co){if(co.id===action.payload.id){return action.payload;}else{return co;}})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["s" /* CHANGE_ORDER_START_DATE_UPDATE */]:return Object.assign({},state,{startDate:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["g" /* CHANGE_ORDER_COMPLETION_DATE_UPDATE */]:return Object.assign({},state,{completionDate:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["x" /* CHANGE_ORDER_VALUES_UPDATE */]:return Object.assign({},state,{valuesByQuoteId:Object.assign({},state.valuesByQuoteId,_defineProperty({},action.payload.quoteId,Object.assign({},state.valuesByQuoteId[action.payload.quoteId],_defineProperty({},action.payload.key,action.payload.value))))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["d" /* CHANGE_ORDER_APPROVAL_MODAL_CLOSE */]:return Object.assign({},state,{selectedChangeOrderId:null,selectedChangeOrderNumber:null});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["e" /* CHANGE_ORDER_APPROVAL_SELECT */]:return Object.assign({},state,{selectedChangeOrderId:action.payload.id,selectedChangeOrderNumber:action.payload.number});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["w" /* CHANGE_ORDER_USERS_LOAD_SUCCESS */]:return Object.assign({},state,{users:action.payload});default:return state;}}

/***/ }),
/* 3166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = changeOrdersUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__ = __webpack_require__(580);
var initialState={showChangeOrderModal:false,currentView:'form',// oneOf: [form, review, thank-you]
showSuccessMessage:false,pdf:null,showPdfViewer:false,emails:[],subject:'',message:'',showEmailModal:false};function changeOrdersUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["n" /* CHANGE_ORDER_MODAL_CLOSE */]:return Object.assign({},state,{showChangeOrderModal:false});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["o" /* CHANGE_ORDER_MODAL_SHOW */]:return Object.assign({},state,{currentView:'form',showChangeOrderModal:true});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["f" /* CHANGE_ORDER_BACK */]:return Object.assign({},state,{currentView:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["h" /* CHANGE_ORDER_CREATE_SUCCESS */]:return Object.assign({},state,{currentView:'thank-you'});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["p" /* CHANGE_ORDER_NEXT */]:return Object.assign({},state,{currentView:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["v" /* CHANGE_ORDER_SUCCESS_MODAL_OPEN */]:return Object.assign({},state,{showSuccessMessage:true});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["u" /* CHANGE_ORDER_SUCCESS_MODAL_CLOSE */]:return Object.assign({},state,{showSuccessMessage:false});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["r" /* CHANGE_ORDER_PRINT_SUCCESS */]:return Object.assign({},state,{pdf:action.payload,showPdfViewer:true});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["q" /* CHANGE_ORDER_PDF_VIEWER_CLOSE */]:return Object.assign({},state,{showPdfViewer:false});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["k" /* CHANGE_ORDER_EMAIL_MODAL_SHOW_SET */]:return Object.assign({},state,{showEmailModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["i" /* CHANGE_ORDER_EMAIL_ADD */]:if(state.emails.find(function(email){return email===action.payload;})===undefined){return Object.assign({},state,{emails:state.emails.concat([action.payload])});}else{return state;}case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["j" /* CHANGE_ORDER_EMAIL_CLEAR */]:return Object.assign({},state,{emails:[]});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["l" /* CHANGE_ORDER_EMAIL_REMOVE */]:return Object.assign({},state,{emails:state.emails.filter(function(email){return email!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["t" /* CHANGE_ORDER_SUBJECT_SET */]:return Object.assign({},state,{subject:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_work_orders_details_change_orders_store_action_types__["m" /* CHANGE_ORDER_MESSAGE_SET */]:return Object.assign({},state,{message:action.payload});default:return state;}}

/***/ }),
/* 3167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = messagesReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_messages__ = __webpack_require__(14);
var messageId=1;var initialState={errors:[]// array of { id, message }
};function messagesReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_messages__["a" /* MESSAGES_ERROR_CLOSE */]:return Object.assign({},state,{errors:state.errors.filter(function(element){return element.id!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0__actions_messages__["b" /* MESSAGES_ERROR_SHOW */]:return Object.assign({},state,{errors:state.errors.concat(action.payload.map(function(message){return{id:messageId++,message:message};}))});default:return state;}}

/***/ }),
/* 3168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = userInvitationsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_client_user_invitations__ = __webpack_require__(762);
var initialState={permissions:[],users:[]};function userInvitationsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_client_user_invitations__["a" /* USER_INVITATIONS_REQUEST_PERMISSIONS_SUCCESS */]:return Object.assign({},state,{permissions:action.payload,users:[]});case __WEBPACK_IMPORTED_MODULE_0__actions_client_user_invitations__["b" /* USER_INVITATIONS_REQUEST_SUCCESS */]:return Object.assign({},state,{users:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_client_user_invitations__["c" /* USER_REMOVE_REQUEST_SUCCESS */]:return Object.assign({},state,{// errors: [],
users:state.users.filter(function(element){return element.id!==action.payload;})});default:return state;}}

/***/ }),
/* 3169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contractors_data__ = __webpack_require__(3170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contractors_ui__ = __webpack_require__(3171);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1__contractors_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__contractors_ui__["a" /* default */]));

/***/ }),
/* 3170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contractorsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__ = __webpack_require__(590);
var initialState={contractors:[],contractorInvoices:[],currentContractor:null,serviceAreas:[],trades:[],unions:[],users:[],workOrders:null,projects:null,roles:[]};function contractorsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["c" /* CONTRACTORS_CONTRACTOR_LOAD_SUCCESS */]:return Object.assign({},state,{currentContractor:action.payload,users:initialState.users});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["g" /* CONTRACTORS_CONTRACTOR_WORK_ORDERS_LOAD_SUCCESS */]:return Object.assign({},state,{workOrders:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["k" /* CONTRACTORS_INVOICES_SET */]:return Object.assign({},state,{contractorInvoices:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["d" /* CONTRACTORS_CONTRACTOR_PROJECTS_LOAD_SUCCESS */]:return Object.assign({},state,{projects:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["l" /* CONTRACTORS_LOAD_SUCCESS */]:return Object.assign({},state,{contractors:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["s" /* CONTRACTORS_NEW_PARAMETERS_LOAD_SUCCESS */]:return Object.assign({},state,{serviceAreas:action.payload.serviceAreas!==undefined?action.payload.serviceAreas:state.serviceAreas,trades:action.payload.trades!==undefined?action.payload.trades:state.trades,unions:action.payload.unions!==undefined?action.payload.unions:state.unions});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["y" /* CONTRACTORS_USERS_SET */]:return Object.assign({},state,{users:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["e" /* CONTRACTORS_CONTRACTOR_ROLES_LOAD_SUCCESS */]:return Object.assign({},state,{roles:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["f" /* CONTRACTORS_CONTRACTOR_USER_ADD */]:return Object.assign({},state,{users:state.users.concat([action.payload])});default:return state;}}

/***/ }),
/* 3171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contractorsUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__ = __webpack_require__(590);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={currentPage:1,invalidFields:[],form:{companyName:'',licenseNumber:'',firstName:'',lastName:'',email:'',phoneNumber:'',streetAddress:'',unitNumber:'',city:'',state:'',zipCode:'',confirmed:false,roleId:''// for contractor user invite
},selectedServiceAreasId:[],selectedTradesId:[],selectedUnionsId:[],w9Document:{id:'',url:'',document:''},showContacts:false,validationMessage:'',msaSigningUrl:null,showMsaSigningModal:false,contractorsCurrentPage:1,contractorsTotal:0,contractorsPageSize:25,showInviteContractorUserModal:false};function contractorsUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["h" /* CONTRACTORS_CONTRACTOR_WORK_ORDERS_PAGE_CHANGE */]:return Object.assign({},state,{currentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["i" /* CONTRACTORS_EDIT_FORM_LOAD_FROM_CURRENT */]:var w9Document=action.payload.w9_document||{document:{}};return Object.assign({},state,{invalidFields:[],form:{companyName:action.payload.name,licenseNumber:action.payload.license_number||'',firstName:action.payload.contact.first_name,lastName:action.payload.contact.last_name,email:action.payload.contact.email,phoneNumber:action.payload.contact.phone_number,streetAddress:action.payload.location?action.payload.location.street_address_1:'',unitNumber:action.payload.location?action.payload.location.street_address_2:'',city:action.payload.location?action.payload.location.city:'',state:action.payload.location?action.payload.location.state:'',zipCode:action.payload.location?action.payload.location.zip:'',confirmed:action.payload.confirmed},selectedServiceAreasId:action.payload.service_areas.map(function(serviceArea){return serviceArea.id;}),selectedTradesId:action.payload.trades.map(function(trade){return trade.id;}),selectedUnionsId:action.payload.unions.map(function(union){return union.id;}),w9Document:{id:w9Document.id||'',url:w9Document.document.url||'',document:''},validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["o" /* CONTRACTORS_NEW_CLEAR_DATA */]:return initialState;case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["p" /* CONTRACTORS_NEW_FORM_INVALID */]:return Object.assign({},state,{invalidFields:action.payload.invalidFields,validationMessage:action.payload.message});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["q" /* CONTRACTORS_NEW_FORM_VALID */]:return Object.assign({},state,{invalidFields:[],validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["r" /* CONTRACTORS_NEW_FORM_VALUE_CHANGE */]:return Object.assign({},state,{form:Object.assign({},state.form,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["t" /* CONTRACTORS_NEW_SERVICE_AREA_SELECT */]:var newSelectedServiceAreasId=void 0;if(state.selectedServiceAreasId.find(function(element){return element===action.payload;})!==undefined){newSelectedServiceAreasId=state.selectedServiceAreasId.filter(function(element){return element!==action.payload;});}else{newSelectedServiceAreasId=state.selectedServiceAreasId.concat(action.payload);}return Object.assign({},state,{selectedServiceAreasId:newSelectedServiceAreasId});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["u" /* CONTRACTORS_NEW_TRADE_SELECT */]:var newSelectedTradesId=void 0;if(state.selectedTradesId.find(function(element){return element===action.payload;})!==undefined){newSelectedTradesId=state.selectedTradesId.filter(function(element){return element!==action.payload;});}else{newSelectedTradesId=state.selectedTradesId.concat(action.payload);}return Object.assign({},state,{selectedTradesId:newSelectedTradesId});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["v" /* CONTRACTORS_NEW_UNIONS_SELECT */]:return Object.assign({},state,{selectedUnionsId:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["w" /* CONTRACTORS_NEW_W9_DOCUMENT_SET */]:return Object.assign({},state,{w9Document:{id:state.w9Document.id,url:'',document:action.payload}});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["a" /* CONTRACTORS_CONTACTS_MODAL_SHOW */]:return Object.assign({},state,{showContacts:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["n" /* CONTRACTORS_MSA_SIGNING_URL_CHANGE */]:return Object.assign({},state,{msaSigningUrl:action.payload,showMsaSigningModal:true});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["m" /* CONTRACTORS_MSA_SIGNING_MODAL_HIDE */]:return Object.assign({},state,{showMsaSigningModal:false});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["x" /* CONTRACTORS_SET_PAGINATION_DATA */]:return Object.assign({},state,{contractorsCurrentPage:action.payload.page,contractorsTotal:action.payload.total,contractorsPageSize:action.payload.pageSize});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["b" /* CONTRACTORS_CONTRACTOR_INVITE_USER_SHOW */]:return Object.assign({},state,{showInviteContractorUserModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_contractors_action_types__["j" /* CONTRACTORS_INVITE_FORM_CLEAR */]:return Object.assign({},state,{form:initialState.form,invalidFields:[],validationMessage:''});default:return state;}}

/***/ }),
/* 3172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buildings_data__ = __webpack_require__(3173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buildings_ui__ = __webpack_require__(3174);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1__buildings_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__buildings_ui__["a" /* default */]));

/***/ }),
/* 3173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildingsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__ = __webpack_require__(595);
var initialState={buildings:[],clients:[],currentBuilding:null,// we need another attribute because the buildings list doesn't contain all the info required
unions:[],workOrders:null,projects:null};function buildingsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["a" /* BUILDINGS_BUILDING_CLIENTS_LOAD_SUCCESS */]:return Object.assign({},state,{clients:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["b" /* BUILDINGS_BUILDING_LOAD_SUCCESS */]:return Object.assign({},state,{currentBuilding:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["d" /* BUILDINGS_BUILDING_WORK_ORDERS_LOAD_SUCCESS */]:return Object.assign({},state,{workOrders:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["c" /* BUILDINGS_BUILDING_PROJECTS_LOAD_SUCCESS */]:return Object.assign({},state,{projects:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["g" /* BUILDINGS_LOAD_SUCCESS */]:return Object.assign({},state,{buildings:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["t" /* BUILDINGS_NEW_UNIONS_LOAD_SUCCESS */]:return Object.assign({},state,{unions:action.payload});default:return state;}}

/***/ }),
/* 3174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildingsUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__ = __webpack_require__(595);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={currentPage:1,engineerAdded:false,files:[],// array { removed: boolean, file: file uploaded, document: document from backend }
form:{buildingName:'',streetAddress:'',unitNumber:'',city:'',state:'',zipCode:'',managerFirstName:'',managerLastName:'',managerEmail:'',managerPhoneNumber:'',engineerFirstName:'',engineerLastName:'',engineerEmail:'',engineerPhoneNumber:''},invalidFields:[],parkingOnSite:null,// boolean
selectedClientsId:[],selectedContractors:[],// array { value, label }
selectedUnionsId:[],validationMessage:'',buildingsCurrentPage:1,buildingsTotal:0,buildingsPageSize:25};function buildingsUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["e" /* BUILDINGS_BUILDING_WORK_ORDERS_PAGE_CHANGE */]:return Object.assign({},state,{currentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["f" /* BUILDINGS_EDIT_FORM_LOAD_FROM_CURRENT */]:return Object.assign({},state,{engineerAdded:action.payload.engineer!==null,files:action.payload.documents.map(function(document){return{removed:false,file:null,document:document};}),form:{buildingName:action.payload.name,locationId:action.payload.location.id,streetAddress:action.payload.location.street_address_1,unitNumber:action.payload.location.street_address_2!==null?action.payload.location.street_address_2:'',city:action.payload.location.city,state:action.payload.location.state,zipCode:action.payload.location.zip,propOwnerName:action.payload.property_owner_name||'',propOwnerAddressId:action.payload.property_owner_address&&action.payload.property_owner_address.id,propOwnerStreetAddress:action.payload.property_owner_address&&action.payload.property_owner_address.street_address_1||'',propOwnerUnitNumber:action.payload.property_owner_address&&action.payload.property_owner_address.street_address_2||'',propOwnerCity:action.payload.property_owner_address&&action.payload.property_owner_address.city||'',propOwnerState:action.payload.property_owner_address&&action.payload.property_owner_address.state||'',propOwnerZipCode:action.payload.property_owner_address&&action.payload.property_owner_address.zip||'',managerFirstName:action.payload.property_manager!==null?action.payload.property_manager.first_name:'',managerLastName:action.payload.property_manager!==null?action.payload.property_manager.last_name:'',managerEmail:action.payload.property_manager!==null?action.payload.property_manager.email:'',managerPhoneNumber:action.payload.property_manager!==null&&action.payload.property_manager.phone_number?action.payload.property_manager.phone_number:'',engineerFirstName:action.payload.engineer!==null?action.payload.engineer.first_name:'',engineerLastName:action.payload.engineer!==null?action.payload.engineer.last_name:'',engineerEmail:action.payload.engineer!==null?action.payload.engineer.email:'',engineerPhoneNumber:action.payload.engineer!==null&&action.payload.engineer.phone_number?action.payload.engineer.phone_number:''},invalidFields:[],parkingOnSite:action.payload.parking_on_site!==null?action.payload.parking_on_site:null,selectedClientsId:action.payload.clients!==undefined?action.payload.clients.map(function(client){return client.id;}):[],selectedContractors:action.payload.propietary_sub_contractors.map(function(contractor){return{value:contractor.id,label:contractor.name};}),selectedUnionsId:action.payload.unions.map(function(union){return union.id;}),validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["i" /* BUILDINGS_NEW_CLIENT_REMOVE */]:return Object.assign({},state,{selectedClientsId:state.selectedClientsId.filter(function(id){return id!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["j" /* BUILDINGS_NEW_CLIENT_SELECT */]:return Object.assign({},state,{selectedClientsId:state.selectedClientsId.concat([action.payload])});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["k" /* BUILDINGS_NEW_CONTRACTOR_REMOVE */]:return Object.assign({},state,{selectedContractors:state.selectedContractors.filter(function(element){return element.value!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["l" /* BUILDINGS_NEW_CONTRACTOR_SELECT */]:return Object.assign({},state,{selectedContractors:state.selectedContractors.concat([action.payload])});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["h" /* BUILDINGS_NEW_CLEAR_DATA */]:return initialState;case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["m" /* BUILDINGS_NEW_ENGINEER_ADD */]:return Object.assign({},state,{engineerAdded:true});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["n" /* BUILDINGS_NEW_FILES_ADD */]:return Object.assign({},state,{files:state.files.concat(action.payload.map(function(file){return{removed:false,file:file,data:null};}))});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["o" /* BUILDINGS_NEW_FILE_REMOVE */]:return Object.assign({},state,{files:state.files.map(function(element,index){if(index===action.payload){return Object.assign({},element,{removed:true});}else{return element;}})});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["p" /* BUILDINGS_NEW_FORM_INVALID */]:return Object.assign({},state,{invalidFields:action.payload.invalidFields,validationMessage:action.payload.message});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["q" /* BUILDINGS_NEW_FORM_VALID */]:return Object.assign({},state,{invalidFields:[],validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["r" /* BUILDINGS_NEW_FORM_VALUE_CHANGE */]:return Object.assign({},state,{form:Object.assign({},state.form,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["u" /* BUILDINGS_NEW_UNIONS_SELECT */]:return Object.assign({},state,{selectedUnionsId:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["s" /* BUILDINGS_NEW_PARKING_ON_SITE_SELECT */]:return Object.assign({},state,{parkingOnSite:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_buildings_action_types__["v" /* BUILDINGS_SET_PAGINATION_DATA */]:return Object.assign({},state,{buildingsCurrentPage:action.payload.page,buildingsTotal:action.payload.total,buildingsPageSize:action.payload.pageSize});default:return state;}}

/***/ }),
/* 3175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clients_data__ = __webpack_require__(3176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clients_ui__ = __webpack_require__(3177);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1__clients_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__clients_ui__["a" /* default */]));

/***/ }),
/* 3176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clientsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_utils_sort_util__ = __webpack_require__(273);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={buildings:[],clients:[],currentClient:null,invoices:null,purchaseOrders:null,roles:[],surveys:null,users:[],workOrders:null,projects:null};function clientsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["b" /* CLIENTS_CLIENT_BUILDINGS_LOAD_SUCCESS */]:return Object.assign({},state,{buildings:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["e" /* CLIENTS_CLIENT_INVOICES_LOAD_SUCCESS */]:return Object.assign({},state,{invoices:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["f" /* CLIENTS_CLIENT_LOAD_SUCCESS */]:return Object.assign({},state,{buildings:initialState.buildings,currentClient:action.payload,users:initialState.users});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["m" /* CLIENTS_CLIENT_PURCHASE_ORDERS_SUCCESS */]:return Object.assign({},state,{purchaseOrders:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["n" /* CLIENTS_CLIENT_ROLES_LOAD_SUCCESS */]:return Object.assign({},state,{roles:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["o" /* CLIENTS_CLIENT_SET */]:return Object.assign({},state,{currentClient:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["p" /* CLIENTS_CLIENT_SURVEYS_LOAD_SUCCESS */]:return Object.assign({},state,{surveys:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["q" /* CLIENTS_CLIENT_USERS_ADD */]:return Object.assign({},state,{users:state.users.concat(action.payload)});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["r" /* CLIENTS_CLIENT_WORK_ORDERS_LOAD_SUCCESS */]:return Object.assign({},state,{workOrders:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["u" /* CLIENTS_INVITE_CLIENT_ADD */]:{var clients=state.clients.find(function(client){return client.id===action.payload.id;})?state.clients:state.clients.concat([action.payload]);return Object.assign({},state,{clients:Object(__WEBPACK_IMPORTED_MODULE_1_services_utils_sort_util__["a" /* sortByAttribute */])(clients,'company_name')});}case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["z" /* CLIENTS_LOAD_SUCCESS */]:return Object.assign({},state,{clients:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["B" /* CLIENTS_USERS_SET */]:return Object.assign({},state,{users:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["a" /* CLIENTS_ADD_TO_BEGINNING */]:{var _clients=state.clients.find(function(client){return client.id===action.payload.id;})?state.clients:[action.payload].concat(_toConsumableArray(state.clients));return Object.assign({},state,{clients:_clients});}case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["l" /* CLIENTS_CLIENT_PROJECTS_LOAD_SUCCESS */]:return Object.assign({},state,{projects:action.payload});default:return state;}}

/***/ }),
/* 3177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clientsUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__ = __webpack_require__(596);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var formInitialState={buildingsId:[],// for client user invite
companyName:'',firstName:'',lastName:'',email:'',phoneNumber:'',globalPurchaseOrderRequired:null,purchaseOrderRequired:null,rolesId:[],// for client user invite
streetAddress1:'',streetAddress2:'',city:'',state:'',zip:''};var initialState={currentFilter:'all',currentPage:1,form:formInitialState,invalidFields:[],noteEditor:{edit:false,reminder:null,saving:false,text:''},showContacts:false,showInviteClientModal:false,showInviteClientUserModal:false,// modal to invite a user within a client
validationMessage:'',clientsCurrentPage:1,clientsTotal:0,clientsPageSize:25};function clientsUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["c" /* CLIENTS_CLIENT_FILTER_CHANGE */]:return Object.assign({},state,{currentFilter:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["d" /* CLIENTS_CLIENT_INVITE_USER_SHOW */]:return Object.assign({},state,{showInviteClientUserModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["f" /* CLIENTS_CLIENT_LOAD_SUCCESS */]:return Object.assign({},state,{noteEditor:Object.assign({},state.noteEditor,{edit:false,reminder:action.payload.note_reminder_date,text:action.payload.note!==null?action.payload.note:''})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["g" /* CLIENTS_CLIENT_NOTE_EDITOR_EDIT_SET */]:return Object.assign({},state,{noteEditor:Object.assign({},state.noteEditor,{edit:action.payload})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["h" /* CLIENTS_CLIENT_NOTE_EDITOR_REMINDER_CHANGE */]:return Object.assign({},state,{noteEditor:Object.assign({},state.noteEditor,{reminder:action.payload})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["i" /* CLIENTS_CLIENT_NOTE_EDITOR_SAVING_SET */]:return Object.assign({},state,{noteEditor:Object.assign({},state.noteEditor,{saving:action.payload})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["j" /* CLIENTS_CLIENT_NOTE_EDITOR_TEXT_CHANGE */]:return Object.assign({},state,{noteEditor:Object.assign({},state.noteEditor,{text:action.payload})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["k" /* CLIENTS_CLIENT_PAGE_CHANGE */]:return Object.assign({},state,{currentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["t" /* CLIENTS_INVITE_ATTRIBUTE_CHANGE */]:return Object.assign({},state,{form:Object.assign({},state.form,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["v" /* CLIENTS_INVITE_FORM_CLEAR */]:return Object.assign({},state,{form:formInitialState,invalidFields:[],validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["w" /* CLIENTS_INVITE_FORM_INVALID */]:return Object.assign({},state,{invalidFields:action.payload.invalidFields,validationMessage:action.payload.message});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["x" /* CLIENTS_INVITE_FORM_VALID */]:return Object.assign({},state,{invalidFields:[],validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["y" /* CLIENTS_INVITE_USER_MODAL_SHOW */]:return Object.assign({},state,{showInviteClientModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["s" /* CLIENTS_CONTACTS_MODAL_SHOW */]:return Object.assign({},state,{showContacts:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_clients_action_types__["A" /* CLIENTS_SET_PAGINATION_DATA */]:return Object.assign({},state,{clientsCurrentPage:action.payload.page,clientsTotal:action.payload.total,clientsPageSize:action.payload.pageSize});default:return state;}}

/***/ }),
/* 3178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__quotes_data__ = __webpack_require__(3179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quotes_ui__ = __webpack_require__(3180);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1__quotes_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__quotes_ui__["a" /* default */]));

/***/ }),
/* 3179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quotesDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_quotes_action_types__ = __webpack_require__(601);
var initialState={quotes:null,quotesCount:0};function quotesDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_quotes_action_types__["b" /* QUOTES_LOAD_SUCCESS */]:return Object.assign({},state,{quotes:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_quotes_action_types__["a" /* QUOTES_COUNT_SUCCESS */]:return Object.assign({},state,{quotesCount:action.payload});default:return state;}}

/***/ }),
/* 3180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quotesUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_quotes_action_types__ = __webpack_require__(601);
var initialState={currentPage:1,selectedQuoteIndex:null,taskImages:[]};function quotesUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_quotes_action_types__["c" /* QUOTES_MODAL_CLOSE */]:return Object.assign({},state,{selectedQuoteIndex:null,taskImages:[]});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_quotes_action_types__["d" /* QUOTES_PAGE_CHANGE */]:return Object.assign({},state,{currentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_quotes_action_types__["e" /* QUOTES_SELECTION_SUCCESS */]:return Object.assign({},state,{selectedQuoteIndex:action.payload.quoteIndex,taskImages:action.payload.images});default:return state;}}

/***/ }),
/* 3181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tasks_data__ = __webpack_require__(3182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tasks_ui__ = __webpack_require__(3183);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1__tasks_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__tasks_ui__["a" /* default */]));

/***/ }),
/* 3182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tasksDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_tasks_action_types__ = __webpack_require__(603);
var initialState={tasks:null,trades:[]};function tasksDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_tasks_action_types__["b" /* TASKS_LOAD_SUCCESS */]:return Object.assign({},state,{tasks:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_tasks_action_types__["e" /* TASKS_TRADES_SUCCESS */]:return Object.assign({},state,{trades:action.payload});default:return state;}}

/***/ }),
/* 3183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tasksUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_tasks_action_types__ = __webpack_require__(603);
var initialState={currentPage:1,selectedContractorId:null,selectedTradeId:null};function tasksUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_tasks_action_types__["a" /* TASKS_CONTRACTOR_SELECT */]:return Object.assign({},state,{selectedContractorId:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_tasks_action_types__["c" /* TASKS_PAGE_CHANGE */]:return Object.assign({},state,{currentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_tasks_action_types__["d" /* TASKS_TRADES_SELECT */]:return Object.assign({},state,{selectedTradeId:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_tasks_action_types__["e" /* TASKS_TRADES_SUCCESS */]:return Object.assign({},state,{selectedTradeId:null});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_tasks_action_types__["f" /* TASKS_UI_INITIALIZE */]:return initialState;default:return state;}}

/***/ }),
/* 3184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__invoices_data__ = __webpack_require__(3185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__invoices_ui__ = __webpack_require__(3186);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1__invoices_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__invoices_ui__["a" /* default */]));

/***/ }),
/* 3185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = invoicesDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__ = __webpack_require__(586);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={currentInvoice:null,invoices:null,usersByClientId:{}};function invoicesDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["q" /* INVOICES_INVOICE_LOAD_SUCCESS */]:return Object.assign({},state,{currentInvoice:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["v" /* INVOICES_LOAD_SUCCESS */]:return Object.assign({},state,{invoices:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["a" /* INVOICES_INVOICE_ATTRIBUTE_UPDATE */]:return Object.assign({},state,{currentInvoice:Object.assign({},state.currentInvoice,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["p" /* INVOICES_INVOICE_ITEM_LINE_CHANGE */]:return Object.assign({},state,{currentInvoice:Object.assign({},state.currentInvoice,{line_items:state.currentInvoice.line_items.map(function(lineItem){if(lineItem.id===action.payload.lineItemId){return Object.assign({},lineItem,{cost:action.payload.value});}else{return lineItem;}})})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["z" /* INVOICES_USERS_LOAD_SUCCESS */]:return Object.assign({},state,{usersByClientId:Object.assign({},state.usersByClientId,_defineProperty({},action.payload.clientId,action.payload.users))});default:return state;}}

/***/ }),
/* 3186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = invoicesUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={currentPage:1,customEmail:'',customEmailValid:true,edit:false,form:{additionalCostsByLineItemId:{},adjustmentDesc:'',adjustment:'',adjustmentSign:1,amountsByLineItemId:{},// [lineItemId]: value
dueDate:'',emails:[],// [ { id: number, email: string } ]
miscCosts:[]// [ { id: number, description: string, cost: string } ]
},invalidFields:[],pdf:null,showEmailModal:false,showPdfViewer:false,showSave:false,validationMessage:'',usersIdSelected:[],tabSelection:1,selectedStatus:'all'};function invoicesUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["b" /* INVOICES_INVOICE_CUSTOM_EMAIL_CHANGE */]:return Object.assign({},state,{customEmail:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["c" /* INVOICES_INVOICE_CUSTOM_EMAIL_VALIDATION_SET */]:return Object.assign({},state,{customEmailValid:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["e" /* INVOICES_INVOICE_EDIT_SET */]:return Object.assign({},state,{customEmail:'',customEmailValid:true,edit:action.payload,usersIdSelected:[]});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["h" /* INVOICES_INVOICE_EMAIL_MODAL_SHOW_SET */]:return Object.assign({},state,{showEmailModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["f" /* INVOICES_INVOICE_EMAILS_REMOVE */]:var newEmails=void 0;if(action.payload.id===0){newEmails=state.form.emails.filter(function(email,index){return index!==action.payload.index;});}else{newEmails=state.form.emails.filter(function(email){return email.id!==action.payload.id;});}return Object.assign({},state,{form:Object.assign({},state.form,{emails:newEmails})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["i" /* INVOICES_INVOICE_FORM_ATTRIBUTE_CHANGE */]:return Object.assign({},state,{form:Object.assign({},state.form,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["k" /* INVOICES_INVOICE_FORM_ITEM_LINE_CHANGE */]:return Object.assign({},state,{form:Object.assign({},state.form,{amountsByLineItemId:Object.assign({},state.form.amountsByLineItemId,_defineProperty({},action.payload.itemId,action.payload.value))})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["j" /* INVOICES_INVOICE_FORM_INVALID */]:return Object.assign({},state,{invalidFields:action.payload.invalidLineItemId,validationMessage:action.payload.validationMessage});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["o" /* INVOICES_INVOICE_FORM_VALID */]:return Object.assign({},state,{invalidFields:[],validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["d" /* INVOICES_INVOICE_EDIT_CANCEL */]:case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["q" /* INVOICES_INVOICE_LOAD_SUCCESS */]:return Object.assign({},state,{edit:false,form:{additionalCostsByLineItemId:action.payload.line_items.reduce(function(accumulator,currentValue){accumulator[currentValue.id]=currentValue.additional_cost;return accumulator;},{}),adjustmentDesc:action.payload.adjustment_desc||'',adjustment:action.payload.adjustment,adjustmentSign:__WEBPACK_IMPORTED_MODULE_1_numeral___default()(action.payload.adjustment).value()>=0?1:-1,amountsByLineItemId:action.payload.line_items.reduce(function(accumulator,currentValue){accumulator[currentValue.id]=currentValue.cost;return accumulator;},{}),dueDate:action.payload.due_date,emails:action.payload.send_to.map(function(value){return{id:0,email:value};}),purchaseOrder:action.payload.purchase_order!==null?action.payload.purchase_order:'',miscCosts:action.payload.misc_items.map(function(miscItem){return{id:miscItem.id,cost:miscItem.cost,description:miscItem.description};})},invalidFields:[],validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["r" /* INVOICES_INVOICE_PDF_VIEWER_CLOSE */]:return Object.assign({},state,{showPdfViewer:false});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["s" /* INVOICES_INVOICE_PRINT_SUCCESS */]:return Object.assign({},state,{pdf:action.payload,showPdfViewer:true});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["l" /* INVOICES_INVOICE_FORM_MISC_COST_ADD */]:return Object.assign({},state,{form:Object.assign({},state.form,{miscCosts:state.form.miscCosts.concat([{id:action.payload.id,description:action.payload.description,cost:action.payload.cost}])})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["m" /* INVOICES_INVOICE_FORM_MISC_COST_CLEAR */]:return Object.assign({},state,{form:Object.assign({},state.form,{miscCosts:[]})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["n" /* INVOICES_INVOICE_FORM_MISC_COST_REMOVE */]:return Object.assign({},state,{form:Object.assign({},state.form,{miscCosts:state.form.miscCosts.filter(function(item,index){return index!==action.payload;})})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["t" /* INVOICES_INVOICE_SAVE_SHOW */]:return Object.assign({},state,{showSave:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["u" /* INVOICES_INVOICE_USER_SELECT */]:return Object.assign({},state,{usersIdSelected:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["g" /* INVOICES_INVOICE_EMAILS_USERS_ADD */]:return Object.assign({},state,{form:Object.assign({},state.form,{emails:state.form.emails.concat(action.payload)}),usersIdSelected:[]});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["w" /* INVOICES_PAGE_CHANGE */]:return Object.assign({},state,{currentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["y" /* INVOICES_TAB_SELECTION_CHANGE */]:return Object.assign({},state,{tabSelection:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_invoices_action_types__["x" /* INVOICES_SELECTED_STATUS_SET */]:return Object.assign({},state,{selectedStatus:action.payload});default:return state;}}

/***/ }),
/* 3187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deposits_data__ = __webpack_require__(3188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__deposits_ui__ = __webpack_require__(3189);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1__deposits_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__deposits_ui__["a" /* default */]));

/***/ }),
/* 3188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = depositsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_deposits_action_types__ = __webpack_require__(604);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={deposits:null,currentDeposit:null,usersByClientId:{}};function depositsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_deposits_action_types__["f" /* DEPOSITS_LOAD_SUCCESS */]:return Object.assign({},state,{deposits:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_deposits_action_types__["c" /* DEPOSITS_DEPOSIT_LOAD_SUCCESS */]:return Object.assign({},state,{currentDeposit:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_deposits_action_types__["a" /* DEPOSITS_DEPOSIT_ATTRIBUTE_UPDATE */]:return Object.assign({},state,{currentDeposit:Object.assign({},state.currentDeposit,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_deposits_action_types__["h" /* DEPOSITS_USERS_LOAD_SUCCESS */]:return Object.assign({},state,{usersByClientId:Object.assign({},state.usersByClientId,_defineProperty({},action.payload.clientId,action.payload.users))});default:return state;}}

/***/ }),
/* 3189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = depositsUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_deposits_action_types__ = __webpack_require__(604);
var initialState={currentPage:1,pdf:null,showPdfViewer:false,showEmailModal:false};function depositsUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_deposits_action_types__["g" /* DEPOSITS_PAGE_CHANGE */]:return Object.assign({},state,{currentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_deposits_action_types__["d" /* DEPOSITS_DEPOSIT_PDF_VIEWER_CLOSE */]:return Object.assign({},state,{showPdfViewer:false});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_deposits_action_types__["e" /* DEPOSITS_DEPOSIT_PRINT_SUCCESS */]:return Object.assign({},state,{pdf:action.payload,showPdfViewer:true});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_deposits_action_types__["b" /* DEPOSITS_DEPOSIT_EMAIL_MODAL_SHOW_SET */]:return Object.assign({},state,{showEmailModal:action.payload});default:return state;}}

/***/ }),
/* 3190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sidebarReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_sidebar_action_types__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_route_parser__ = __webpack_require__(3191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_route_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_route_parser__);
var initialState={activeRoute:null,hideSideBar:false};function sidebarReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_sidebar_action_types__["b" /* SIDEBAR_SELECT_ROUTE */]:return Object.assign({},state,{activeRoute:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_sidebar_action_types__["a" /* HIDE_SIDE_BAR_CHANGE */]:return Object.assign({},state,{hideSideBar:action.payload});case __WEBPACK_IMPORTED_MODULE_1_react_router_redux__["b" /* LOCATION_CHANGE */]:var route=new __WEBPACK_IMPORTED_MODULE_2_route_parser___default.a('/admin/:route(/*rest)');var result=route.match(action.payload.pathname);if(result){return Object.assign({},state,{activeRoute:result.route});}else{return state;}case __WEBPACK_IMPORTED_MODULE_0__actions_admin_sidebar_action_types__["c" /* TOGGLE_NEW_SERVICE_WORK */]:var currentState=!!state.showNewServiceWorkModal;return Object.assign({},state,{showNewServiceWorkModal:!currentState});default:return state;}}

/***/ }),
/* 3191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @module Passage
 */


var Route = __webpack_require__(3192);


module.exports = Route;

/***/ }),
/* 3192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Parser = __webpack_require__(3193),
    RegexpVisitor = __webpack_require__(3195),
    ReverseVisitor = __webpack_require__(3196);

Route.prototype = Object.create(null)

/**
 * Match a path against this route, returning the matched parameters if
 * it matches, false if not.
 * @example
 * var route = new Route('/this/is/my/route')
 * route.match('/this/is/my/route') // -> {}
 * @example
 * var route = new Route('/:one/:two')
 * route.match('/foo/bar/') // -> {one: 'foo', two: 'bar'}
 * @param  {string} path the path to match this route against
 * @return {(Object.<string,string>|false)} A map of the matched route
 * parameters, or false if matching failed
 */
Route.prototype.match = function(path) {
  var re = RegexpVisitor.visit(this.ast),
      matched = re.match(path);

  return matched ? matched : false;

};

/**
 * Reverse a route specification to a path, returning false if it can't be
 * fulfilled
 * @example
 * var route = new Route('/:one/:two')
 * route.reverse({one: 'foo', two: 'bar'}) -> '/foo/bar'
 * @param  {Object} params The parameters to fill in
 * @return {(String|false)} The filled in path
 */
Route.prototype.reverse = function(params) {
  return ReverseVisitor.visit(this.ast, params);
};

/**
 * Represents a route
 * @example
 * var route = Route('/:foo/:bar');
 * @example
 * var route = Route('/:foo/:bar');
 * @param {string} spec -  the string specification of the route.
 *     use :param for single portion captures, *param for splat style captures,
 *     and () for optional route branches
 * @constructor
 */
function Route(spec) {
  var route;
  if (this) {
    // constructor called with new
    route = this;
  } else {
    // constructor called as a function
    route = Object.create(Route.prototype);
  }
  if( typeof spec === 'undefined' ) {
    throw new Error('A route spec is required');
  }
  route.spec = spec;
  route.ast = Parser.parse(spec);
  return route;
}

module.exports = Route;

/***/ }),
/* 3193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @module route/parser
 */


/** Wrap the compiled parser with the context to create node objects */
var parser = __webpack_require__(3194).parser;
parser.yy = __webpack_require__(1104);
module.exports = parser;


/***/ }),
/* 3194 */
/***/ (function(module, exports, __webpack_require__) {

/* parser generated by jison 0.4.17 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var parser = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,9],$V1=[1,10],$V2=[1,11],$V3=[1,12],$V4=[5,11,12,13,14,15];
var parser = {trace: function trace() { },
yy: {},
symbols_: {"error":2,"root":3,"expressions":4,"EOF":5,"expression":6,"optional":7,"literal":8,"splat":9,"param":10,"(":11,")":12,"LITERAL":13,"SPLAT":14,"PARAM":15,"$accept":0,"$end":1},
terminals_: {2:"error",5:"EOF",11:"(",12:")",13:"LITERAL",14:"SPLAT",15:"PARAM"},
productions_: [0,[3,2],[3,1],[4,2],[4,1],[6,1],[6,1],[6,1],[6,1],[7,3],[8,1],[9,1],[10,1]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1:
return new yy.Root({},[$$[$0-1]])
break;
case 2:
return new yy.Root({},[new yy.Literal({value: ''})])
break;
case 3:
this.$ = new yy.Concat({},[$$[$0-1],$$[$0]]);
break;
case 4: case 5:
this.$ = $$[$0];
break;
case 6:
this.$ = new yy.Literal({value: $$[$0]});
break;
case 7:
this.$ = new yy.Splat({name: $$[$0]});
break;
case 8:
this.$ = new yy.Param({name: $$[$0]});
break;
case 9:
this.$ = new yy.Optional({},[$$[$0-1]]);
break;
case 10:
this.$ = yytext;
break;
case 11: case 12:
this.$ = yytext.slice(1);
break;
}
},
table: [{3:1,4:2,5:[1,3],6:4,7:5,8:6,9:7,10:8,11:$V0,13:$V1,14:$V2,15:$V3},{1:[3]},{5:[1,13],6:14,7:5,8:6,9:7,10:8,11:$V0,13:$V1,14:$V2,15:$V3},{1:[2,2]},o($V4,[2,4]),o($V4,[2,5]),o($V4,[2,6]),o($V4,[2,7]),o($V4,[2,8]),{4:15,6:4,7:5,8:6,9:7,10:8,11:$V0,13:$V1,14:$V2,15:$V3},o($V4,[2,10]),o($V4,[2,11]),o($V4,[2,12]),{1:[2,1]},o($V4,[2,3]),{6:14,7:5,8:6,9:7,10:8,11:$V0,12:[1,16],13:$V1,14:$V2,15:$V3},o($V4,[2,9])],
defaultActions: {3:[2,2],13:[2,1]},
parseError: function parseError(str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        function _parseError (msg, hash) {
            this.message = msg;
            this.hash = hash;
        }
        _parseError.prototype = Error;

        throw new _parseError(str, hash);
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    _token_stack:
        var lex = function () {
            var token;
            token = lexer.lex() || EOF;
            if (typeof token !== 'number') {
                token = self.symbols_[token] || token;
            }
            return token;
        };
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
                    if (typeof action === 'undefined' || !action.length || !action[0]) {
                var errStr = '';
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push('\'' + this.terminals_[p] + '\'');
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                } else {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected
                });
            }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};
/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function (match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex() {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin(condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState() {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules() {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState(n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState(condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:return "(";
break;
case 1:return ")";
break;
case 2:return "SPLAT";
break;
case 3:return "PARAM";
break;
case 4:return "LITERAL";
break;
case 5:return "LITERAL";
break;
case 6:return "EOF";
break;
}
},
rules: [/^(?:\()/,/^(?:\))/,/^(?:\*+\w+)/,/^(?::+\w+)/,/^(?:[\w%\-~\n]+)/,/^(?:.)/,/^(?:$)/],
conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (true) {
exports.parser = parser;
exports.Parser = parser.Parser;
exports.parse = function () { return parser.parse.apply(parser, arguments); };
}

/***/ }),
/* 3195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createVisitor  = __webpack_require__(1105),
    escapeRegExp = /[\-{}\[\]+?.,\\\^$|#\s]/g;

/**
 * @class
 * @private
 */
function Matcher(options) {
  this.captures = options.captures;
  this.re = options.re;
}

/**
 * Try matching a path against the generated regular expression
 * @param  {String} path The path to try to match
 * @return {Object|false}      matched parameters or false
 */
Matcher.prototype.match = function (path) {
  var match = this.re.exec(path),
      matchParams = {};

  if( !match ) {
    return;
  }

  this.captures.forEach( function(capture, i) {
    if( typeof match[i+1] === 'undefined' ) {
      matchParams[capture] = undefined;
    }
    else {
      matchParams[capture] = decodeURIComponent(match[i+1]);
    }
  });

  return matchParams;
};

/**
 * Visitor for the AST to create a regular expression matcher
 * @class RegexpVisitor
 * @borrows Visitor-visit
 */
var RegexpVisitor = createVisitor({
  'Concat': function(node) {
    return node.children
      .reduce(
        function(memo, child) {
          var childResult = this.visit(child);
          return {
            re: memo.re + childResult.re,
            captures: memo.captures.concat(childResult.captures)
          };
        }.bind(this),
        {re: '', captures: []}
      );
  },
  'Literal': function(node) {
    return {
      re: node.props.value.replace(escapeRegExp, '\\$&'),
      captures: []
    };
  },

  'Splat': function(node) {
    return {
      re: '([^?]*?)',
      captures: [node.props.name]
    };
  },

  'Param': function(node) {
    return {
      re: '([^\\/\\?]+)',
      captures: [node.props.name]
    };
  },

  'Optional': function(node) {
    var child = this.visit(node.children[0]);
    return {
      re: '(?:' + child.re + ')?',
      captures: child.captures
    };
  },

  'Root': function(node) {
    var childResult = this.visit(node.children[0]);
    return new Matcher({
      re: new RegExp('^' + childResult.re + '(?=\\?|$)' ),
      captures: childResult.captures
    });
  }
});

module.exports = RegexpVisitor;

/***/ }),
/* 3196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createVisitor  = __webpack_require__(1105);

/**
 * Visitor for the AST to construct a path with filled in parameters
 * @class ReverseVisitor
 * @borrows Visitor-visit
 */
var ReverseVisitor = createVisitor({
  'Concat': function(node, context) {
    var childResults =  node.children
      .map( function(child) {
        return this.visit(child,context);
      }.bind(this));

    if( childResults.some(function(c) { return c === false; }) ) {
      return false;
    }
    else {
      return childResults.join('');
    }
  },

  'Literal': function(node) {
    return decodeURI(node.props.value);
  },

  'Splat': function(node, context) {
    if( context[node.props.name] ) {
      return context[node.props.name];
    }
    else {
      return false;
    }
  },

  'Param': function(node, context) {
    if( context[node.props.name] ) {
      return context[node.props.name];
    }
    else {
      return false;
    }
  },

  'Optional': function(node, context) {
    var childResult = this.visit(node.children[0], context);
    if( childResult ) {
      return childResult;
    }
    else {
      return '';
    }
  },

  'Root': function(node, context) {
    context = context || {};
    var childResult = this.visit(node.children[0], context);
    if( !childResult ) {
      return false;
    }
    return encodeURI(childResult);
  }
});

module.exports = ReverseVisitor;

/***/ }),
/* 3197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contractor_team_data__ = __webpack_require__(3198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contractor_team_ui__ = __webpack_require__(3199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__client_team_data__ = __webpack_require__(3200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__client_team_ui__ = __webpack_require__(3201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reducers_admin_team_general_contractor_team_data__ = __webpack_require__(3202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reducers_admin_team_general_contractor_team_ui__ = __webpack_require__(3203);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__reducers_util__["a" /* createSceneReducer */])(undefined,undefined,Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({client:Object(__WEBPACK_IMPORTED_MODULE_0__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_4__client_team_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_5__client_team_ui__["a" /* default */]),contractor:Object(__WEBPACK_IMPORTED_MODULE_0__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_2__contractor_team_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_3__contractor_team_ui__["a" /* default */]),generalContractor:Object(__WEBPACK_IMPORTED_MODULE_0__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_6_reducers_admin_team_general_contractor_team_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_7_reducers_admin_team_general_contractor_team_ui__["a" /* default */])})));

/***/ }),
/* 3198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (immutable) */ __webpack_exports__["a"] = contractorTeamDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_utils_sort_util__ = __webpack_require__(273);
var initialState={roles:[],users:[],technicians:[]};function contractorTeamDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["B" /* CONTRACTOR_TEAM_ROLES_LOAD_SUCCESS */]:return Object.assign({},state,{roles:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["G" /* CONTRACTOR_TEAM_USERS_ADD */]:return Object.assign({},state,{users:Object(__WEBPACK_IMPORTED_MODULE_1_services_utils_sort_util__["a" /* sortByAttribute */])(state.users.concat([action.payload]),'first_name')});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["C" /* CONTRACTOR_TEAM_TECHNICIANS_ADD */]:return Object.assign({},state,{technicians:Object(__WEBPACK_IMPORTED_MODULE_1_services_utils_sort_util__["a" /* sortByAttribute */])(state.technicians.concat([action.payload]),'first_name')});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["H" /* CONTRACTOR_TEAM_USERS_EDIT */]:return Object.assign({},state,{users:state.users.map(function(user){if(user.id===action.payload.id){return action.payload;}else{return user;}})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["D" /* CONTRACTOR_TEAM_TECHNICIANS_EDIT */]:return Object.assign({},state,{technicians:state.technicians.map(function(user){if(user.id===action.payload.id){return action.payload;}else{return user;}})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["I" /* CONTRACTOR_TEAM_USERS_LOAD_SUCCESS */]:return Object.assign({},state,{users:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["E" /* CONTRACTOR_TEAM_TECHNICIANS_LOAD_SUCCESS */]:return Object.assign({},state,{technicians:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["J" /* CONTRACTOR_TEAM_USERS_REMOVE */]:return Object.assign({},state,{users:state.users.filter(function(user){return user.id!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["F" /* CONTRACTOR_TEAM_TECHNICIANS_REMOVE */]:return Object.assign({},state,{technicians:state.technicians.filter(function(technician){return technician.id!==action.payload;})});default:return state;}}

/***/ }),
/* 3199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (immutable) */ __webpack_exports__["a"] = contractorTeamUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_modal_InviteUserModal__ = __webpack_require__(86);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={currentUserId:0,currentTechnicianId:0,form:{firstName:'',lastName:'',email:'',phoneNumber:'',rolesId:null},invalidFields:[],showInviteUserModal:false,showInviteTechnicianModal:false,userModalState:__WEBPACK_IMPORTED_MODULE_1_components_shared_modal_InviteUserModal__["a" /* UserModalState */].NEW,// one of UserModalState
technicianModalState:__WEBPACK_IMPORTED_MODULE_1_components_shared_modal_InviteUserModal__["a" /* UserModalState */].NEW,validationMessage:'',currentPageTechnicians:1,perPageTechnicians:1,totalTechnicians:1,activeTab:1};function contractorTeamUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["v" /* CONTRACTOR_TEAM_INVITE_USER_FORM_INVALID */]:return Object.assign({},state,{invalidFields:action.payload.invalidFields,validationMessage:action.payload.message});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["w" /* CONTRACTOR_TEAM_INVITE_USER_FORM_LOAD */]:return Object.assign({},state,{form:action.payload,invalidFields:[],validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["x" /* CONTRACTOR_TEAM_INVITE_USER_FORM_VALID */]:return Object.assign({},state,{invalidFields:[],validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["y" /* CONTRACTOR_TEAM_INVITE_USER_FORM_VALUE_UPDATE */]:return Object.assign({},state,{form:Object.assign({},state.form,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["z" /* CONTRACTOR_TEAM_INVITE_USER_ID_SET */]:return Object.assign({},state,{currentUserId:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["t" /* CONTRACTOR_TEAM_INVITE_TECHNICIAN_ID_SET */]:return Object.assign({},state,{currentTechnicianId:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["A" /* CONTRACTOR_TEAM_INVITE_USER_MODAL_SHOW */]:var newState=Object.assign({},state,{showInviteUserModal:action.payload.open});if(action.payload.state!==undefined){newState['userModalState']=action.payload.state;}return newState;case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["u" /* CONTRACTOR_TEAM_INVITE_TECHNICIAN_MODAL_SHOW */]:var newStateTechnician=Object.assign({},state,{showInviteTechnicianModal:action.payload.open});if(action.payload.state!==undefined){newStateTechnician['technicianModalState']=action.payload.state;}return newStateTechnician;case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["p" /* CONTACTOR_TEAM_CURRENT_PAGE_TECHNICIANS */]:return Object.assign({},state,{currentPageTechnicians:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["q" /* CONTACTOR_TEAM_PER_PAGE_TECHNICIANS */]:return Object.assign({},state,{perPageTechnicians:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["s" /* CONTACTOR_TEAM_TOTAL_TECHNICIANS */]:return Object.assign({},state,{totalTechnicians:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["r" /* CONTACTOR_TEAM_SET_ACTIVE_TAB */]:return Object.assign({},state,{activeTab:action.payload});default:return state;}}

/***/ }),
/* 3200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clientTeamDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_utils_sort_util__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_authentication__ = __webpack_require__(174);
var initialState={buildings:[],client:null,roles:[],users:[]};function clientTeamDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_2_actions_authentication__["d" /* AUTHENTICATION_SUCCESS */]:// Remove info after login
return initialState;case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["a" /* CLIENT_TEAM_BUILDINGS_LOAD_SUCCESS */]:return Object.assign({},state,{buildings:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["e" /* CLIENT_TEAM_CLIENT_LOAD_SUCCESS */]:return Object.assign({},state,{client:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["k" /* CLIENT_TEAM_ROLES_LOAD_SUCCESS */]:return Object.assign({},state,{roles:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["l" /* CLIENT_TEAM_USERS_ADD */]:return Object.assign({},state,{users:Object(__WEBPACK_IMPORTED_MODULE_1_services_utils_sort_util__["a" /* sortByAttribute */])(state.users.concat([action.payload]),'first_name')});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["m" /* CLIENT_TEAM_USERS_EDIT */]:return Object.assign({},state,{users:state.users.map(function(user){if(user.id===action.payload.id){return action.payload;}else{return user;}})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["n" /* CLIENT_TEAM_USERS_LOAD_SUCCESS */]:return Object.assign({},state,{users:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["o" /* CLIENT_TEAM_USERS_REMOVE */]:return Object.assign({},state,{users:state.users.filter(function(user){return user.id!==action.payload;})});default:return state;}}

/***/ }),
/* 3201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clientTeamUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_modal_InviteUserModal__ = __webpack_require__(86);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={currentUserId:0,clientForm:{companyName:'',firstName:'',lastName:'',email:'',phoneNumber:'',globalPurchaseOrderRequired:false,purchaseOrderRequired:false,streetAddress:'',unitNumber:'',city:'',state:'',zipCode:''},invalidFields:[],showInviteUserModal:false,userForm:{buildingsId:[],firstName:'',lastName:'',email:'',phoneNumber:'',rolesId:[],title:''},userModalState:__WEBPACK_IMPORTED_MODULE_1_components_shared_modal_InviteUserModal__["a" /* UserModalState */].NEW,// one of UserModalState
validationMessage:''};function clientTeamUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["f" /* CLIENT_TEAM_EDIT_FORM_LOAD_FROM_CURRENT */]:return Object.assign({},state,{invalidFields:[],clientForm:{companyName:action.payload.company_name,firstName:action.payload.contact.first_name,lastName:action.payload.contact.last_name,email:action.payload.contact.email,phoneNumber:action.payload.contact.phone_number!==null?action.payload.contact.phone_number:'',globalPurchaseOrderRequired:action.payload.global_po_required,purchaseOrderRequired:action.payload.po_required,streetAddress:action.payload.location?action.payload.location.street_address_1:'',unitNumber:action.payload.location?action.payload.location.street_address_2:'',city:action.payload.location?action.payload.location.city:'',state:action.payload.location?action.payload.location.state:'',zipCode:action.payload.location?action.payload.location.zip:''},validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["b" /* CLIENT_TEAM_CLIENT_FORM_INVALID */]:return Object.assign({},state,{invalidFields:action.payload.invalidFields,validationMessage:action.payload.message});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["c" /* CLIENT_TEAM_CLIENT_FORM_VALID */]:return Object.assign({},state,{invalidFields:[],validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["d" /* CLIENT_TEAM_CLIENT_FORM_VALUE_UPDATE */]:return Object.assign({},state,{clientForm:Object.assign({},state.clientForm,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["g" /* CLIENT_TEAM_INVITE_USER_FORM_LOAD */]:return Object.assign({},state,{userForm:action.payload,invalidFields:[],validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["h" /* CLIENT_TEAM_INVITE_USER_FORM_VALUE_UPDATE */]:return Object.assign({},state,{userForm:Object.assign({},state.userForm,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["i" /* CLIENT_TEAM_INVITE_USER_ID_SET */]:return Object.assign({},state,{currentUserId:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["j" /* CLIENT_TEAM_INVITE_USER_MODAL_SHOW */]:var newState=Object.assign({},state,{invalidFields:[],showInviteUserModal:action.payload.open,validationMessage:''});if(action.payload.state!==undefined){newState['userModalState']=action.payload.state;}return newState;default:return state;}}

/***/ }),
/* 3202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (immutable) */ __webpack_exports__["a"] = generalContractorTeamDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_utils_sort_util__ = __webpack_require__(273);
var initialState={roles:[],users:[]};function generalContractorTeamDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["Q" /* GENERAL_CONTRACTOR_TEAM_ROLES_LOAD_SUCCESS */]:return Object.assign({},state,{roles:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["R" /* GENERAL_CONTRACTOR_TEAM_USERS_ADD */]:return Object.assign({},state,{users:Object(__WEBPACK_IMPORTED_MODULE_1_services_utils_sort_util__["a" /* sortByAttribute */])(state.users.concat([action.payload]),'first_name')});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["S" /* GENERAL_CONTRACTOR_TEAM_USERS_EDIT */]:return Object.assign({},state,{users:state.users.map(function(user){if(user.id===action.payload.id){return action.payload;}else{return user;}})});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["T" /* GENERAL_CONTRACTOR_TEAM_USERS_LOAD_SUCCESS */]:return Object.assign({},state,{users:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["U" /* GENERAL_CONTRACTOR_TEAM_USERS_REMOVE */]:return Object.assign({},state,{users:state.users.filter(function(user){return user.id!==action.payload;})});default:return state;}}

/***/ }),
/* 3203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (immutable) */ __webpack_exports__["a"] = generalContractorTeamUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_modal_InviteUserModal__ = __webpack_require__(86);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={currentUserId:0,form:{firstName:'',lastName:'',email:'',phoneNumber:'',rolesId:null},invalidFields:[],showInviteUserModal:false,userModalState:__WEBPACK_IMPORTED_MODULE_1_components_shared_modal_InviteUserModal__["a" /* UserModalState */].NEW,// one of UserModalState
validationMessage:''};function generalContractorTeamUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["K" /* GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_INVALID */]:return Object.assign({},state,{invalidFields:action.payload.invalidFields,validationMessage:action.payload.message});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["L" /* GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_LOAD */]:return Object.assign({},state,{form:action.payload,invalidFields:[],validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["M" /* GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_VALID */]:return Object.assign({},state,{invalidFields:[],validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["N" /* GENERAL_CONTRACTOR_TEAM_INVITE_USER_FORM_VALUE_UPDATE */]:return Object.assign({},state,{form:Object.assign({},state.form,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["O" /* GENERAL_CONTRACTOR_TEAM_INVITE_USER_ID_SET */]:return Object.assign({},state,{currentUserId:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_team_action_types__["P" /* GENERAL_CONTRACTOR_TEAM_INVITE_USER_MODAL_SHOW */]:var newState=Object.assign({},state,{showInviteUserModal:action.payload.open});if(action.payload.state!==undefined){newState['userModalState']=action.payload.state;}return newState;default:return state;}}

/***/ }),
/* 3204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__users_data__ = __webpack_require__(3205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_ui__ = __webpack_require__(3206);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1__users_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__users_ui__["a" /* default */]));

/***/ }),
/* 3205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = usersDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_users_action_types__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utils_sort_util__ = __webpack_require__(273);
var initialState={roles:[],users:[]};function usersDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_users_action_types__["h" /* USERS_LOAD_SUCCESS */]:return Object.assign({},state,{users:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_users_action_types__["g" /* USERS_INVITE_USER_ROLES_LOAD_SUCCESS */]:return Object.assign({},state,{roles:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_users_action_types__["i" /* USERS_USER_ADD */]:return Object.assign({},state,{users:Object(__WEBPACK_IMPORTED_MODULE_1__services_utils_sort_util__["a" /* sortByAttribute */])(state.users.concat([action.payload]),'first_name')});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_users_action_types__["j" /* USERS_USER_EDIT */]:return Object.assign({},state,{users:state.users.map(function(user){if(user.id===action.payload.id){return action.payload;}else{return user;}})});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_users_action_types__["k" /* USERS_USER_REMOVE */]:return Object.assign({},state,{users:state.users.filter(function(user){return user.id!==action.payload;})});default:return state;}}

/***/ }),
/* 3206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = usersUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_admin_users_action_types__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_modal_InviteUserModal__ = __webpack_require__(86);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={currentUserId:0,form:{firstName:'',lastName:'',email:'',phoneNumber:'',rolesId:null,title:''},invalidFields:[],showInviteUserModal:false,userModalState:__WEBPACK_IMPORTED_MODULE_1__components_shared_modal_InviteUserModal__["a" /* UserModalState */].NEW,validationMessage:''};function usersUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_admin_users_action_types__["a" /* USERS_INVITE_USER_FORM_INVALID */]:return Object.assign({},state,{invalidFields:action.payload.invalidFields,validationMessage:action.payload.message});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_users_action_types__["b" /* USERS_INVITE_USER_FORM_LOAD */]:return Object.assign({},state,{form:action.payload,invalidFields:[],validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_users_action_types__["c" /* USERS_INVITE_USER_FORM_VALID */]:return Object.assign({},state,{invalidFields:[],validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_users_action_types__["d" /* USERS_INVITE_USER_FORM_VALUE_UPDATE */]:return Object.assign({},state,{form:Object.assign({},state.form,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_users_action_types__["e" /* USERS_INVITE_USER_ID_SET */]:return Object.assign({},state,{currentUserId:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_admin_users_action_types__["f" /* USERS_INVITE_USER_MODAL_SHOW */]:var newState=Object.assign({},state,{showInviteUserModal:action.payload.open});if(action.payload.state!==undefined){newState['userModalState']=action.payload.state;}return newState;default:return state;}}

/***/ }),
/* 3207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_data__ = __webpack_require__(3208);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1__reducers_data__["a" /* default */]));

/***/ }),
/* 3208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tutorialsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types__ = __webpack_require__(1010);
var initialState={tutorials:[]};function tutorialsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__action_types__["a" /* TUTORIALS_LOAD_SUCCESS */]:return Object.assign({},state,{tutorials:action.payload});default:return state;}}

/***/ }),
/* 3209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notifications_data__ = __webpack_require__(3210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications_ui__ = __webpack_require__(3211);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1__notifications_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__notifications_ui__["a" /* default */]));

/***/ }),
/* 3210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = notificationsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_notifications__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var initialState={notifications:null// { content: array, total: number, totalUnread: number, pageSize: number }
};function notificationsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_notifications__["a" /* NOTIFICATIONS_ADD */]:var newContent=state.notifications.content.slice();newContent.unshift(action.payload);return Object.assign({},state,{notifications:Object.assign({},state.notifications,{content:newContent})});case __WEBPACK_IMPORTED_MODULE_0__actions_notifications__["e" /* NOTIFICATIONS_SET */]:return Object.assign({},state,{notifications:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_notifications__["g" /* NOTIFICATIONS_TOTAL_UPDATE */]:return Object.assign({},state,{notifications:Object.assign({},state.notifications,{total:action.payload})});case __WEBPACK_IMPORTED_MODULE_0__actions_notifications__["b" /* NOTIFICATIONS_CHAT_UPDATE */]:var newNotificationsContent=state.notifications.content.map(function(notification){if(notification.notifiable_type==='Note'&&notification.notifiable.noteable_id===action.payload.id&&notification.notifiable.noteable_type===action.payload.type){return Object.assign({},notification,{read_at:__WEBPACK_IMPORTED_MODULE_1_moment___default()()});}else{return notification;}});return Object.assign({},state,{notifications:Object.assign({},state.notifications,{content:newNotificationsContent,totalUnread:newNotificationsContent.filter(function(notification){return!notification.read_at;}).length})});case __WEBPACK_IMPORTED_MODULE_0__actions_notifications__["i" /* NOTIFICATIONS_UPDATE */]:return Object.assign({},state,{notifications:Object.assign({},state.notifications,{content:state.notifications.content.map(function(notification){var found=action.payload.find(function(temp){return temp.id===notification.id;});if(found!==undefined){return found;}else{return notification;}})})});case __WEBPACK_IMPORTED_MODULE_0__actions_notifications__["h" /* NOTIFICATIONS_UNREAD_TOTAL_UPDATE */]:return Object.assign({},state,{notifications:Object.assign({},state.notifications,{totalUnread:action.payload})});case __WEBPACK_IMPORTED_MODULE_0__actions_notifications__["d" /* NOTIFICATIONS_NOTIFICATION_UPDATE */]:return Object.assign({},state,{notifications:Object.assign({},state.notifications,{content:state.notifications.content.map(function(notification){if(notification.id===action.payload.id){return action.payload;}else{return notification;}})})});default:return state;}}

/***/ }),
/* 3211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = notificationsUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_notifications__ = __webpack_require__(178);
var initialState={currentPage:1,showLoader:false};function notificationsUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_notifications__["c" /* NOTIFICATIONS_CURRENT_PAGE_SET */]:return Object.assign({},state,{currentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_notifications__["f" /* NOTIFICATIONS_SHOW_LOADER_SET */]:return Object.assign({},state,{showLoader:action.payload});default:return state;}}

/***/ }),
/* 3212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_contractors_invoices_store_reducers_data__ = __webpack_require__(3213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_store_reducers_ui__ = __webpack_require__(3214);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1_components_admin_contractors_invoices_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2_components_admin_contractors_invoices_store_reducers_ui__["a" /* default */]));

/***/ }),
/* 3213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contractorsInvoicesDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_contractors_invoices_store_action_types__ = __webpack_require__(616);
var initialState={invoices:[],vendorInvoices:[]};function contractorsInvoicesDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_contractors_invoices_store_action_types__["a" /* CONTRACTORS_INVOICES_INVOICE_REMOVE */]:return Object.assign({},state,{invoices:state.invoices.filter(function(invoice){return invoice.id!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_contractors_invoices_store_action_types__["c" /* CONTRACTORS_INVOICES_LOAD_SUCCESS */]:return Object.assign({},state,{invoices:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_contractors_invoices_store_action_types__["b" /* CONTRACTORS_INVOICES_INVOICE_UPDATE */]:return Object.assign({},state,{invoices:state.invoices.map(function(invoice){if(invoice.id===action.payload.id){return action.payload;}else{return invoice;}})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_contractors_invoices_store_action_types__["i" /* CONTRACTORS_INVOICES_VENDOR_INVOICES_INVOICE_UPDATE */]:return Object.assign({},state,{vendorInvoices:state.vendorInvoices.map(function(invoice){if(invoice.id===action.payload.id){return action.payload;}else{return invoice;}})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_contractors_invoices_store_action_types__["l" /* CONTRACTORS_INVOICES_VENDOR_INVOICES_SET */]:return Object.assign({},state,{vendorInvoices:action.payload});default:return state;}}

/***/ }),
/* 3214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contractorsInvoicesUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_contractors_invoices_store_action_types__ = __webpack_require__(616);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={paginationInfo:null,// { currentPage: number, pageSize: number, total: number }
searchText:'',vendorInvoicesPaginationInfo:null,// { currentPage: number, pageSize: number, total: number }
searchFilters:{}};function contractorsInvoicesUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_contractors_invoices_store_action_types__["d" /* CONTRACTORS_INVOICES_PAGE_CHANGE */]:return Object.assign({},state,{paginationInfo:Object.assign({},state.paginationInfo,{currentPage:action.payload})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_contractors_invoices_store_action_types__["e" /* CONTRACTORS_INVOICES_PAGINATION_INIT */]:return Object.assign({},state,{paginationInfo:{currentPage:1,pageSize:action.payload.pageSize,total:action.payload.total}});case __WEBPACK_IMPORTED_MODULE_0_components_admin_contractors_invoices_store_action_types__["h" /* CONTRACTORS_INVOICES_SEARCH_TEXT_CHANGE */]:return Object.assign({},state,{searchText:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_contractors_invoices_store_action_types__["j" /* CONTRACTORS_INVOICES_VENDOR_INVOICES_PAGE_CHANGE */]:return Object.assign({},state,{vendorInvoicesPaginationInfo:Object.assign({},state.vendorInvoicesPaginationInfo,{currentPage:action.payload.page,pageSize:action.payload.pageSize,total:action.payload.total})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_contractors_invoices_store_action_types__["k" /* CONTRACTORS_INVOICES_VENDOR_INVOICES_PAGINATION_INIT */]:return Object.assign({},state,{vendorInvoicesPaginationInfo:{currentPage:1,pageSize:action.payload.pageSize,total:action.payload.total}});case __WEBPACK_IMPORTED_MODULE_0_components_admin_contractors_invoices_store_action_types__["f" /* CONTRACTORS_INVOICES_SEARCH_FILTERS_INIT */]:return Object.assign({},state,{searchFilters:{}});case __WEBPACK_IMPORTED_MODULE_0_components_admin_contractors_invoices_store_action_types__["g" /* CONTRACTORS_INVOICES_SEARCH_FILTER_VALUE_CHANGE */]:return Object.assign({},state,{searchFilters:Object.assign({},state.searchFilters,_defineProperty({},action.payload.attribute,action.payload.value))});default:return state;}}

/***/ }),
/* 3215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reports_data__ = __webpack_require__(3216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reports_ui__ = __webpack_require__(3217);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1__reports_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__reports_ui__["a" /* default */]));

/***/ }),
/* 3216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reportsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_reports_action_types__ = __webpack_require__(653);
var initialState={results:null};function reportsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_reports_action_types__["e" /* REPORT_RESULTS_LOAD_SUCCESS */]:return Object.assign({},state,{results:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_reports_action_types__["a" /* REPORTS_RESET */]:return initialState;default:return state;}}

/***/ }),
/* 3217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reportsUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_admin_reports_action_types__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_reports_OutstandingPricingReport__ = __webpack_require__(3218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_reports_OpenPricingReport__ = __webpack_require__(3223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_reports_WorkOrderVarianceReport__ = __webpack_require__(3224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_reports_ReceiptsReport__ = __webpack_require__(3225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_reports_ContractorWoVarianceReport__ = __webpack_require__(3226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_reports_MissingContractorInvoicesReport__ = __webpack_require__(3227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_reports_OpenItemsReport__ = __webpack_require__(3228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_reports_ProjectOpenItemsReport__ = __webpack_require__(3229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={reports:[{name:'Outstanding AGG Pricing',description:'WO Status: Pending, Task Status: AGG, Quote Status: Waiting - By Bid Due Date',route:'outstanding-pricing-report',component:__WEBPACK_IMPORTED_MODULE_1_components_admin_reports_OutstandingPricingReport__["a" /* default */],admin:true},{name:'Open RFP Pricing',description:'WO Status: Pending, Task Status: RFP - By Target Completion Date',route:'open-pricing-report',component:__WEBPACK_IMPORTED_MODULE_2_components_admin_reports_OpenPricingReport__["a" /* default */],admin:true},{name:'Work Order Variance',description:'WO Status: Complete - By Invoice Creation Date',route:'work-order-variance-report',component:__WEBPACK_IMPORTED_MODULE_3_components_admin_reports_WorkOrderVarianceReport__["a" /* default */],admin:true},{name:'Materials',description:'WO Materials - By Materials Uploaded Date',route:'receipts-report',component:__WEBPACK_IMPORTED_MODULE_4_components_admin_reports_ReceiptsReport__["a" /* default */],contractor:true},{name:'Contractor Work Order Variance',description:'WO Status: Complete - By Completion Date',route:'contractor-wo-variance-report',component:__WEBPACK_IMPORTED_MODULE_5_components_admin_reports_ContractorWoVarianceReport__["a" /* default */],contractor:true},{name:'Open Items Report',description:'Open Items: By Due Date and Status',route:'open-items-report',component:__WEBPACK_IMPORTED_MODULE_7_components_admin_reports_OpenItemsReport__["a" /* default */],admin:true},{name:'Missing Contractor Invoices Report',description:'WO Status: Complete or Closed - By Completion Date',route:'missing-contractor-invoices-report',component:__WEBPACK_IMPORTED_MODULE_6_components_admin_reports_MissingContractorInvoicesReport__["a" /* default */],admin:true},{name:'Open Items Report',description:'Open Items: By Due Date and Status',route:'project-open-items-report',component:__WEBPACK_IMPORTED_MODULE_8_components_admin_reports_ProjectOpenItemsReport__["a" /* default */],generalContractor:true}],startDate:__WEBPACK_IMPORTED_MODULE_9_moment___default()().format('YYYY-MM-DD'),endDate:__WEBPACK_IMPORTED_MODULE_9_moment___default()().add(1,'month').format('YYYY-MM-DD'),extraFilterValues:{},searching:false,selectAllChecked:false,selectedWorkOrders:{}};function reportsUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_admin_reports_action_types__["d" /* REPORT_PAGE_CHANGE */]:return Object.assign({},state,{currentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_reports_action_types__["g" /* REPORT_START_DATE_CHANGE */]:return Object.assign({},state,{startDate:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_reports_action_types__["b" /* REPORT_END_DATE_CHANGE */]:return Object.assign({},state,{endDate:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_reports_action_types__["c" /* REPORT_EXTRA_FILTER_VALUE_CHANGE */]:return Object.assign({},state,{extraFilterValues:Object.assign({},state.extraFilterValues,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_reports_action_types__["f" /* REPORT_SEARCHING_CHANGE */]:return Object.assign({},state,{searching:action.payload});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_reports_action_types__["h" /* REPORT_WORK_ORDER_SELECT_CLEAR */]:return Object.assign({},state,{selectAllChecked:initialState.selectAllChecked,selectedWorkOrders:initialState.selectedWorkOrders});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_reports_action_types__["i" /* REPORT_WORK_ORDER_SELECT_SET */]:return Object.assign({},state,{selectAllChecked:action.payload.allChecked,selectedWorkOrders:Object.assign({},state.selectedWorkOrders,action.payload.selectedWorkOrders)});case __WEBPACK_IMPORTED_MODULE_0_actions_admin_reports_action_types__["a" /* REPORTS_RESET */]:return initialState;default:return state;}}

/***/ }),
/* 3218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reports_css__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reports_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Reports_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_tasks_tasks__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_reports_BaseReport__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OutstandingPricingReport=function(_Component){_inherits(OutstandingPricingReport,_Component);function OutstandingPricingReport(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OutstandingPricingReport);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OutstandingPricingReport.__proto__||Object.getPrototypeOf(OutstandingPricingReport)).call.apply(_ref,[this].concat(args))),_this),_this.handleRowSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_tasks_tasks__["c" /* openTaskDetails */])(_this.props.reportResults.data[index].task));},_this.createTableRowsData=function(){if(_this.props.reportResults!==null){var woNumber=null;return _this.props.reportResults.data.map(function(result,index){var first=result.work_order.number!==woNumber;var rowData={id:index,selectable:true,data:[first?result.work_order.number:'',first?result.work_order.name:'',first?result.work_order.client.company_name:'',first?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__["a" /* default */],{value:result.work_order.created_at,format:'LL'}):'',result.task.number,result.task.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__["a" /* default */],{value:result.task.completion_date,format:'LL'}),result.contractor.name]};if(!first){rowData['className']='no-top-border';}woNumber=result.work_order.number;return{rowData:rowData,first:first,workOrderId:result.work_order.id};});}else{return[];}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OutstandingPricingReport,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_admin_reports_BaseReport__["a" /* default */],{reportName:'outstanding_pricing_report',tableHeader:['','WO #','NAME','CLIENT NAME','CREATED AT','TASK #','TASK NAME','COMPLETION DATE','CONTRACTOR'],tableRowsData:this.createTableRowsData(),title:'Outstanding AGG Pricing',onRowSelection:this.handleRowSelection});}}]);return OutstandingPricingReport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{reportResults:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__["d" /* getReportResults */])(state)};})(OutstandingPricingReport));

/***/ }),
/* 3219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reportsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportsApi=function(_BaseApi){_inherits(ReportsApi,_BaseApi);function ReportsApi(){_classCallCheck(this,ReportsApi);return _possibleConstructorReturn(this,(ReportsApi.__proto__||Object.getPrototypeOf(ReportsApi)).apply(this,arguments));}_createClass(ReportsApi,[{key:'getReport',value:function getReport(report,page,startDate,endDate,extraFilterValues){var queryString='page='+(page!==undefined?page:1)+'&start_date='+startDate+'&end_date='+endDate;Object.keys(extraFilterValues).forEach(function(attr){if(extraFilterValues[attr].constructor===[].constructor){extraFilterValues[attr].forEach(function(value){return queryString+='&'+attr+'[]='+value;});}else{queryString+='&'+attr+'='+extraFilterValues[attr];}});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.baseUrl+'/reports/'+report+'?'+queryString).then(function(response){return{ok:true,results:{data:response.data,total:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['total']).value(),pageSize:__WEBPACK_IMPORTED_MODULE_2_numeral___default()(response.headers['per-page']).value()}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}},{key:'exportReport',value:function exportReport(report,ids,startDate,endDate,extraFilterValues){var apiPayload={work_order_ids:ids,start_date:startDate,end_date:endDate};Object.keys(extraFilterValues).forEach(function(attr){return apiPayload[attr]=extraFilterValues[attr];});return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.baseUrl+'/reports/'+report+'/print',apiPayload,{responseType:'blob'}).then(function(response){return{ok:true,content:{data:response.data,type:response.headers['content-type']}};}).catch(function(error){return{ok:false,errors:error.response.data.errors};});}}]);return ReportsApi;}(__WEBPACK_IMPORTED_MODULE_1__base_api__["a" /* default */]);var reportsApi=new ReportsApi();

/***/ }),
/* 3220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ReportFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_button_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_datetime_picker_DatetimePicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReportFilter_css__ = __webpack_require__(3221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReportFilter_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ReportFilter_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_checkbox_CheckBox__ = __webpack_require__(64);
function ReportFilter(props){var handleStartDateChange=function handleStartDateChange(value){if(props.onStartDateChange){props.onStartDateChange(value);}};var handleEndDateChange=function handleEndDateChange(value){if(props.onEndDateChange){props.onEndDateChange(value);}};var handleExport=function handleExport(){if(props.onExport){props.onExport();}};var handleSearchClick=function handleSearchClick(){if(props.onSearchClick){props.onSearchClick();}};var handleSelectAllCheck=function handleSelectAllCheck(){if(props.onSelectAllCheck){props.onSelectAllCheck();}};var buttonLabel=void 0;if(props.searching){buttonLabel='Searching...';}else{buttonLabel='Search';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-filter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_checkbox_CheckBox__["a" /* default */],{checked:props.selectAllChecked,className:'check-select-all',readOnly:props.selectAllDisabled,onChange:handleSelectAllCheck}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{placeholder:'Start Date',value:props.startDate,onChange:function onChange(value){return handleStartDateChange(value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_datetime_picker_DatetimePicker__["a" /* default */],{placeholder:'End Date',value:props.endDate,onChange:function onChange(value){return handleEndDateChange(value);}}),props.extraFilters.map(function(filter,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extra-filter',key:i},filter);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_button_Button__["a" /* default */],{className:'button-orange',disabled:props.searching,label:buttonLabel,onClick:handleSearchClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_button_Button__["a" /* default */],{className:'button-orange export-button',disabled:props.exportButtonDisabled,label:'Export to Excel',onClick:handleExport}));}ReportFilter.propTypes={exportButtonDisabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,selectAllChecked:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,selectAllDisabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onStartDateChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onEndDateChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onExport:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSearchClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSelectAllCheck:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,extraFilters:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};ReportFilter.defaultProps={exportButtonDisabled:true,selectAllChecked:false,selectAllDisabled:false,extraFilters:[]};

/***/ }),
/* 3221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3222 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)b();else{b(),a.FileSaver={exports:{}}.exports}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c)},d.onerror=function(){console.error("could not download file")},d.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof global&&global.global===global?global:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null},k.readAsDataURL(b)}else{var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m)},4E4)}});f.saveAs=g.saveAs=g,"undefined"!=typeof module&&(module.exports=g)});

//# sourceMappingURL=FileSaver.min.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(97)))

/***/ }),
/* 3223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reports_css__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reports_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Reports_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_tasks_tasks__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_reports_BaseReport__ = __webpack_require__(208);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OpenPricingReport=function(_Component){_inherits(OpenPricingReport,_Component);function OpenPricingReport(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OpenPricingReport);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OpenPricingReport.__proto__||Object.getPrototypeOf(OpenPricingReport)).call.apply(_ref,[this].concat(args))),_this),_this.handleRowSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_tasks_tasks__["c" /* openTaskDetails */])(_this.props.reportResults.data[index]));},_this.createTableRowsData=function(){if(_this.props.reportResults!==null){var woNumber=null;return _this.props.reportResults.data.map(function(result,index){var first=result.work_order.number!==woNumber;var rowData={id:index,selectable:true,data:[first?result.work_order.number:'',first?result.work_order.name:'',first?result.work_order.client.company_name:'',first?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__["a" /* default */],{value:result.work_order.created_at,format:'LL'}):'',result.number,result.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__["a" /* default */],{value:result.completion_date,format:'LL'})]};if(!first){rowData['className']='no-top-border';}woNumber=result.work_order.number;return{rowData:rowData,first:first,workOrderId:result.work_order.id};});}else{return[];}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OpenPricingReport,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_reports_BaseReport__["a" /* default */],{reportName:'open_pricing_report',tableHeader:['','WO #','NAME','CLIENT NAME','CREATED AT','TASK #','TASK NAME','COMPLETION DATE'],tableRowsData:this.createTableRowsData(),title:'Open RFP Pricing',onRowSelection:this.handleRowSelection});}}]);return OpenPricingReport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{reportResults:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__["d" /* getReportResults */])(state)};})(OpenPricingReport));

/***/ }),
/* 3224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Reports_css__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Reports_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Reports_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_reports_BaseReport__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_admin_reports_reports__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_numeral__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WorkOrderVarianceReport=function(_Component){_inherits(WorkOrderVarianceReport,_Component);function WorkOrderVarianceReport(){var _ref;var _temp,_this,_ret;_classCallCheck(this,WorkOrderVarianceReport);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WorkOrderVarianceReport.__proto__||Object.getPrototypeOf(WorkOrderVarianceReport)).call.apply(_ref,[this].concat(args))),_this),_this.handleRowSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_work_orders__["h" /* goToWorkOrder */])(_this.props.reportResults.data[index].id));},_this.createTableRowsData=function(){if(_this.props.reportResults!==null){return _this.props.reportResults.data.map(function(result,index){var woAmount=__WEBPACK_IMPORTED_MODULE_7_numeral___default()(result.wo_amount).value();var additionalCost=__WEBPACK_IMPORTED_MODULE_7_numeral___default()(result.total_value).value()+__WEBPACK_IMPORTED_MODULE_7_numeral___default()(result.total_markup).value()+__WEBPACK_IMPORTED_MODULE_7_numeral___default()(result.total_fee).value()+__WEBPACK_IMPORTED_MODULE_7_numeral___default()(result.total_insurance).value();var contractorCoCost=__WEBPACK_IMPORTED_MODULE_7_numeral___default()(result.contractor_change_orders_cost).value();var revenue=additionalCost-contractorCoCost;var variance=woAmount===0?0:Math.round(revenue*100/woAmount);var rowData={id:index,selectable:true,data:[result.number,result.name,result.client.company_name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Number__["a" /* default */],{value:woAmount,format:'$0,0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Number__["a" /* default */],{value:woAmount-revenue,format:'$0,0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Number__["a" /* default */],{value:revenue,format:'$0,0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Number__["a" /* default */],{value:result.total_value,format:'$0,0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Number__["a" /* default */],{value:result.total_markup,format:'$0,0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Number__["a" /* default */],{value:result.total_fee,format:'$0,0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Number__["a" /* default */],{value:result.total_insurance,format:'$0,0'}),variance+'%']};return{first:true,rowData:rowData,workOrderId:result.id};});}else{return[];}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WorkOrderVarianceReport,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_reports_BaseReport__["a" /* default */],{reportName:'work_order_variance_report',tableHeader:['','WO #','NAME','CLIENT NAME','WO AMOUNT','ACTUAL COST','REVENUE','VALUE','MARKUP','FEE','INSURANCE','VARIANCE'],tableRowsData:this.createTableRowsData(),title:'Work Order Variance',onRowSelection:this.handleRowSelection});}}]);return WorkOrderVarianceReport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(function(state){return{reportResults:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_reports_reports__["d" /* getReportResults */])(state)};})(WorkOrderVarianceReport));

/***/ }),
/* 3225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reports_css__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reports_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Reports_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_admin_reports_reports__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_reports_BaseReport__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReceiptsReport=function(_Component){_inherits(ReceiptsReport,_Component);function ReceiptsReport(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ReceiptsReport);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ReceiptsReport.__proto__||Object.getPrototypeOf(ReceiptsReport)).call.apply(_ref,[this].concat(args))),_this),_this.handleRowSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_work_orders_work_orders__["h" /* goToWorkOrder */])(_this.props.reportResults.data[index].work_order.id));},_this.createTableRowsData=function(){if(_this.props.reportResults!==null){var woNumber=null;return _this.props.reportResults.data.map(function(result,index){var first=result.work_order.number!==woNumber;var rowData={id:index,selectable:true,data:[first?result.work_order.number:'',first?result.work_order_job!==null?result.work_order_job:'N/A':'',first?result.work_order.name:'',first?result.work_order.client.company_name:'',result.task.number,result.task.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_text_Date__["a" /* default */],{value:result.created_at,format:'LL'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_text_Number__["a" /* default */],{value:result.cost,format:'$0,0.[00]'}),result.description]};if(!first){rowData['className']='no-top-border';}woNumber=result.work_order.number;return{rowData:rowData,first:first,workOrderId:result.work_order.id};});}else{return[];}},_this.handleExtraFilterValueChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_admin_reports_reports__["b" /* changeExtraFilterValue */])(attribute,value));},_this.extraFilters=function(){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__["a" /* default */],{type:'number',placeholder:'Min. Cost',value:_this.props.extraFilterValues['min_cost'],onChange:function onChange(value){return _this.handleExtraFilterValueChange('min_cost',value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_input_Input__["a" /* default */],{type:'number',placeholder:'Max. Cost',value:_this.props.extraFilterValues['max_cost'],onChange:function onChange(value){return _this.handleExtraFilterValueChange('max_cost',value);}})];},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ReceiptsReport,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_admin_reports_BaseReport__["a" /* default */],{reportName:'receipts_report',tableHeader:['','WO #','JOB #','NAME','CLIENT NAME','TASK #','TASK NAME','UPLOADED DATE','AMOUNT','DESCRIPTION'],tableRowsData:this.createTableRowsData(),title:'Materials',onRowSelection:this.handleRowSelection,extraFilters:this.extraFilters()});}}]);return ReceiptsReport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{reportResults:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__["d" /* getReportResults */])(state),extraFilterValues:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__["c" /* getExtraFilterValues */])(state)};})(ReceiptsReport));

/***/ }),
/* 3226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Reports_css__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Reports_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Reports_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_text_Number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_reports_BaseReport__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectors_admin_reports_reports__ = __webpack_require__(107);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractorWoVarianceReport=function(_Component){_inherits(ContractorWoVarianceReport,_Component);function ContractorWoVarianceReport(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ContractorWoVarianceReport);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ContractorWoVarianceReport.__proto__||Object.getPrototypeOf(ContractorWoVarianceReport)).call.apply(_ref,[this].concat(args))),_this),_this.handleRowSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_work_orders__["h" /* goToWorkOrder */])(_this.props.reportResults.data[index].id));},_this.createTableRowsData=function(){if(_this.props.reportResults!==null){return _this.props.reportResults.data.map(function(result,index){var revenue=result.quotes_cost-result.actual_cost;var rowData={id:index,selectable:true,data:[result.number,result.work_order_job!==null?result.work_order_job:'N/A',result.name,result.client.company_name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Number__["a" /* default */],{value:result.quotes_cost,format:'$0,0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Number__["a" /* default */],{value:result.actual_cost,format:'$0,0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Number__["a" /* default */],{value:revenue,format:'$0,0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_text_Number__["a" /* default */],{value:revenue*100/result.quotes_cost,format:'0,0'}),'%')]};return{first:true,rowData:rowData,workOrderId:result.id};});}else{return[];}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ContractorWoVarianceReport,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_reports_BaseReport__["a" /* default */],{reportName:'contractor_wo_variance_report',tableHeader:['','WO #','JOB #','NAME','CLIENT NAME','QUOTE','ACTUAL COST','REVENUE','VARIANCE'],tableRowsData:this.createTableRowsData(),title:'Work Order Variance',onRowSelection:this.handleRowSelection});}}]);return ContractorWoVarianceReport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(function(state){return{reportResults:Object(__WEBPACK_IMPORTED_MODULE_6_selectors_admin_reports_reports__["d" /* getReportResults */])(state)};})(ContractorWoVarianceReport));

/***/ }),
/* 3227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Reports_css__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Reports_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Reports_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_work_orders__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_reports_BaseReport__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_admin_reports_reports__ = __webpack_require__(107);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MissingContractorInvoicesReport=function(_Component){_inherits(MissingContractorInvoicesReport,_Component);function MissingContractorInvoicesReport(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MissingContractorInvoicesReport);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MissingContractorInvoicesReport.__proto__||Object.getPrototypeOf(MissingContractorInvoicesReport)).call.apply(_ref,[this].concat(args))),_this),_this.handleRowSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actions_admin_work_orders_work_orders__["h" /* goToWorkOrder */])(_this.props.reportResults.data[index].id));},_this.createTableRowsData=function(){if(_this.props.reportResults!==null){return _this.props.reportResults.data.map(function(result,index){var contractorsWithoutInvoice=result.contractors_without_invoice;var contractorsWithoutInvoiceField=void 0;if(contractorsWithoutInvoice.length>0){contractorsWithoutInvoiceField=contractorsWithoutInvoice.map(function(con){return con.name;}).join(' - ');}else{contractorsWithoutInvoiceField='All invoices uploaded';}var rowData={id:index,selectable:true,data:[result.number,result.name,result.client.company_name,contractorsWithoutInvoiceField]};return{first:true,rowData:rowData,workOrderId:result.id};});}else{return[];}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MissingContractorInvoicesReport,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_admin_reports_BaseReport__["a" /* default */],{reportName:'missing_contractor_invoices_report',tableHeader:['','WO #','NAME','CLIENT NAME','MISSING CONTRACTOR INVOICES'],tableRowsData:this.createTableRowsData(),title:'Missing Contractor Invoices Report',onRowSelection:this.handleRowSelection});}}]);return MissingContractorInvoicesReport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(state){return{reportResults:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_admin_reports_reports__["d" /* getReportResults */])(state)};})(MissingContractorInvoicesReport));

/***/ }),
/* 3228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reports_css__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reports_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Reports_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_admin_tasks_tasks__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_reports_BaseReport__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_admin_reports_reports__ = __webpack_require__(444);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OpenItemsReport=function(_Component){_inherits(OpenItemsReport,_Component);function OpenItemsReport(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OpenItemsReport);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OpenItemsReport.__proto__||Object.getPrototypeOf(OpenItemsReport)).call.apply(_ref,[this].concat(args))),_this),_this.handleRowSelection=function(index){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_admin_tasks_tasks__["c" /* openTaskDetails */])(_this.props.reportResults.data[index].task));},_this.createTableRowsData=function(){if(_this.props.reportResults!==null){var woNumber=null;return _this.props.reportResults.data.map(function(result,index){var first=result.work_order.number!==woNumber;var rowData={id:index,selectable:true,data:[first?result.work_order.number:'',first?result.work_order.name:'',first?result.client.company_name:'',result.task.number+'-'+result.letter,result.task.name,result.user.first_name+' '+result.user.last_name,result.description,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_text_Date__["a" /* default */],{value:result.due_date,format:'LL'}),result.resolved?'Complete':'Incomplete',result.resolved_note]};if(!first){rowData['className']='no-top-border';}woNumber=result.work_order.number;return{rowData:rowData,first:first,workOrderId:result.work_order.id};});}else{return[];}},_this.handleExtraFilterValueChange=function(attribute,value){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_reports_reports__["b" /* changeExtraFilterValue */])(attribute,value));},_this.extraFilters=function(){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_dropdown_Dropdown__["a" /* default */],{options:[{value:0,label:'Incomplete'},{value:1,label:'Complete'}],clearable:true,placeholder:'All',value:_this.props.extraFilterValues['resolved'],onChange:function onChange(newOption){return _this.handleExtraFilterValueChange('resolved',newOption?newOption.value:'');}})];},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OpenItemsReport,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_admin_reports_BaseReport__["a" /* default */],{reportName:'open_items_report',tableHeader:['','WO #','NAME','CLIENT NAME','TASK #','TASK NAME','ASSIGNED TO','DESCRIPTION','DUE DATE','STATUS','NOTE'],tableRowsData:this.createTableRowsData(),title:'Open Items',onRowSelection:this.handleRowSelection,extraFilters:this.extraFilters()});}}]);return OpenItemsReport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{reportResults:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__["d" /* getReportResults */])(state),extraFilterValues:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_admin_reports_reports__["c" /* getExtraFilterValues */])(state)};})(OpenItemsReport));

/***/ }),
/* 3229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reports_css__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reports_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Reports_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectors_admin_reports_reports__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_reports_BaseReport__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_dropdown_Dropdown__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_open_items_ProjectOpenItemDetailsModal__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_admin_reports_reports__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_store_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_actions__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_input_Input__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectOpenItemsReport=function(_Component){_inherits(ProjectOpenItemsReport,_Component);function ProjectOpenItemsReport(props){_classCallCheck(this,ProjectOpenItemsReport);var _this=_possibleConstructorReturn(this,(ProjectOpenItemsReport.__proto__||Object.getPrototypeOf(ProjectOpenItemsReport)).call(this,props));_this.open=function(projectOpenItem){var dispatch=_this.props.dispatch;_this.setState({showModal:true});dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_store_actions__["b" /* loadProjectRequest */])(projectOpenItem.project_id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_actions__["y" /* setOpenItemsCritical */])(projectOpenItem.critical));dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_open_items_store_actions__["m" /* loadOpenItem */])(projectOpenItem.project_id,projectOpenItem.id));};_this.close=function(){_this.setState({showModal:false});};_this.handleRowSelection=function(index){var reportResults=_this.props.reportResults;var openItem=reportResults.data[index];_this.open(openItem);};_this.renderDescription=function(desc){return''+desc.substring(0,50)+(desc.length>50?'...':'');};_this.createTableRowsData=function(){if(_this.props.reportResults!==null){var projNumber=null;return _this.props.reportResults.data.map(function(result,index){var first=result.project_number!==projNumber;var rowData={id:index,selectable:true,data:[first?result.project_number:'',first?result.project_name:'',result.number,result.csi_code&&result.csi_code.division||'00',result.assignor_label,result.assignee_label,result.description&&_this.renderDescription(result.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__["a" /* default */],{value:result.created_at,format:'MM/DD/YY'}),result.resolve_by&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__["a" /* default */],{value:result.resolve_by,format:'MM/DD/YY'}),result.responded_at&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_text_Date__["a" /* default */],{value:result.responded_at,format:'MM/DD/YY'}),result.draft?'Draft':result.resolved?'Resolved':result.critical?'Critical':'Pending']};if(!first){rowData['className']='no-top-border';}projNumber=result.project_number;return{rowData:rowData,first:first,workOrderId:result.project_id};});}else{return[];}};_this.handleExtraFilterValueChange=function(attribute,value){var dispatch=_this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_reports_reports__["b" /* changeExtraFilterValue */])(attribute,value));if(value==='past_due'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_reports_reports__["b" /* changeExtraFilterValue */])('scope_args',[__WEBPACK_IMPORTED_MODULE_9_moment___default()().format()]));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_admin_reports_reports__["b" /* changeExtraFilterValue */])('scope_args',[]));}};_this.extraFilters=function(){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_input_Input__["a" /* default */],{placeholder:'Assignor',value:_this.props.extraFilterValues['assignor'],onChange:function onChange(value){return _this.handleExtraFilterValueChange('assignor',value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_input_Input__["a" /* default */],{placeholder:'Assignee',value:_this.props.extraFilterValues['assignee'],onChange:function onChange(value){return _this.handleExtraFilterValueChange('assignee',value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_dropdown_Dropdown__["a" /* default */],{options:[{value:'past_due',label:'Past Due'},{value:'unresolved',label:'Pending'},{value:'resolved',label:'Resolved'}],clearable:true,placeholder:'All',value:_this.props.extraFilterValues['scope'],onChange:function onChange(newOption){return _this.handleExtraFilterValueChange('scope',newOption?newOption.value:'');}})];};_this.state={showModal:false};return _this;}_createClass(ProjectOpenItemsReport,[{key:'render',value:function render(){var showModal=this.state.showModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_admin_reports_BaseReport__["a" /* default */],{reportName:'project_open_items_report',tableHeader:['','PROJECT #','NAME','#','CSI CODE','ASSIGNOR','ASSIGNEE','DESCRIPTION','CREATED','DUE DATE','RESPONDED','STATUS'],tableRowsData:this.createTableRowsData(),title:'Open Items',onRowSelection:this.handleRowSelection,extraFilters:this.extraFilters()}),showModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_project_open_items_ProjectOpenItemDetailsModal__["a" /* default */],{onClose:this.close}));}}]);return ProjectOpenItemsReport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{reportResults:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_reports_reports__["d" /* getReportResults */])(state),extraFilterValues:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_admin_reports_reports__["c" /* getExtraFilterValues */])(state)};})(ProjectOpenItemsReport));

/***/ }),
/* 3230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setPasswordUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_client_set_password__ = __webpack_require__(763);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={errors:[],password:'',passwordConfirmation:''};function setPasswordUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_client_set_password__["a" /* SET_PASSWORD_PASSWORD_UPDATE */]:return Object.assign({},state,_defineProperty({},action.payload.attribute,action.payload.value));default:return state;}}

/***/ }),
/* 3231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_purchase_orders_store_reducers_data__ = __webpack_require__(3232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_purchase_orders_store_reducers_ui__ = __webpack_require__(3233);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1_components_admin_purchase_orders_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2_components_admin_purchase_orders_store_reducers_ui__["a" /* default */]));

/***/ }),
/* 3232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = purchaseOrdersDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_purchase_orders_store_action_types__ = __webpack_require__(618);
var initialState={purchaseOrders:null};function purchaseOrdersDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_purchase_orders_store_action_types__["b" /* PURCHASE_ORDERS_SET */]:return Object.assign({},state,{purchaseOrders:action.payload});default:return state;}}

/***/ }),
/* 3233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = purchaseOrdersUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_purchase_orders_store_action_types__ = __webpack_require__(618);
var initialState={createForm:{number:''},currentPage:1,showCreateModal:false};function purchaseOrdersUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_purchase_orders_store_action_types__["a" /* PURCHASE_ORDERS_CURRENT_PAGE_SET */]:return Object.assign({},state,{currentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_purchase_orders_store_action_types__["c" /* PURCHASE_ORDERS_SHOW_MODAL_SET */]:return Object.assign({},state,{showCreateModal:action.payload});default:return state;}}

/***/ }),
/* 3234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_surveys_store_reducers_data__ = __webpack_require__(3235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_surveys_store_reducers_ui__ = __webpack_require__(3236);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1_components_admin_surveys_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2_components_admin_surveys_store_reducers_ui__["a" /* default */]));

/***/ }),
/* 3235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = surveysDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_surveys_store_action_types__ = __webpack_require__(598);
var initialState={currentSurvey:null,surveys:[]};function surveysDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_surveys_store_action_types__["c" /* SURVEYS_SET */]:return Object.assign({},state,{surveys:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_surveys_store_action_types__["g" /* SURVEYS_SURVEY_SET */]:return Object.assign({},state,{currentSurvey:action.payload});default:return state;}}

/***/ }),
/* 3236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = surveysUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_surveys_store_action_types__ = __webpack_require__(598);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={surveyForm:null,paginationInfo:null,// { currentPage: number, pageSize: number, total: number }
pendingTotal:0,showValidationMessage:false};function surveysUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_surveys_store_action_types__["a" /* SURVEYS_PAGINATION_INFO_SET */]:return Object.assign({},state,{paginationInfo:{currentPage:action.payload.page,pageSize:action.payload.pageSize,total:action.payload.total}});case __WEBPACK_IMPORTED_MODULE_0_components_admin_surveys_store_action_types__["b" /* SURVEYS_PAGINATION_PAGE_CHANGE */]:return Object.assign({},state,{paginationInfo:Object.assign({},state.paginationInfo,{currentPage:action.payload})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_surveys_store_action_types__["d" /* SURVEYS_SURVEY_FORM_ATTRIBUTE_CHANGE */]:return Object.assign({},state,{surveyForm:Object.assign({},state.surveyForm,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_surveys_store_action_types__["e" /* SURVEYS_SURVEY_FORM_SET */]:return Object.assign({},state,{showValidationMessage:false,surveyForm:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_surveys_store_action_types__["f" /* SURVEYS_SURVEY_FORM_VALIDATION_MESSAGE_SET */]:return Object.assign({},state,{showValidationMessage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_surveys_store_action_types__["h" /* SURVEYS_TOTAL_PENDING_SET */]:return Object.assign({},state,{pendingTotal:action.payload});default:return state;}}

/***/ }),
/* 3237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_projects_store_reducers_data__ = __webpack_require__(3238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_admin_projects_store_reducers_ui__ = __webpack_require__(3239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_admin_projects_creation_store_reducers_data__ = __webpack_require__(3240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_admin_projects_creation_store_reducers_ui__ = __webpack_require__(3241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_store_reducers_data__ = __webpack_require__(3242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_store_reducers_ui__ = __webpack_require__(3243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_proposal_store_reducers_data__ = __webpack_require__(3244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_proposal_store_reducers_ui__ = __webpack_require__(3245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_directory_store_reducers_data__ = __webpack_require__(3246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_directory_store_reducers_ui__ = __webpack_require__(3247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_meeting_minutes_store_reducers_data__ = __webpack_require__(3248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_meeting_minutes_store_reducers_ui__ = __webpack_require__(3249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_rfi_log_store_reducers_data__ = __webpack_require__(3250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_rfi_log_store_reducers_ui__ = __webpack_require__(3251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_submittal_log_store_reducers_data__ = __webpack_require__(3252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_submittal_log_store_reducers_ui__ = __webpack_require__(3253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_email_modal_store_reducers_ui__ = __webpack_require__(3254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_email_modal_store_reducers_data__ = __webpack_require__(3255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_project_daily_report_log_store_reducers_data__ = __webpack_require__(3256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_admin_projects_details_project_daily_report_log_store_reducers_ui__ = __webpack_require__(3257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_documentation_store_reducers_data__ = __webpack_require__(3258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_admin_projects_details_project_open_items_store_reducers_data__ = __webpack_require__(3259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_admin_projects_details_project_open_items_store_reducers_ui__ = __webpack_require__(3260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_admin_projects_details_project_closeout_store_reducers_data__ = __webpack_require__(3261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_shared_pdf_viewer_bluebeam_store_reducers_ui__ = __webpack_require__(3262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_admin_projects_details_project_settings_store_reducers_data__ = __webpack_require__(3263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_admin_projects_details_project_coi_exps_store_reducers_data__ = __webpack_require__(3264);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_2_components_admin_projects_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_3_components_admin_projects_store_reducers_ui__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({creation:Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_4_components_admin_projects_creation_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_5_components_admin_projects_creation_store_reducers_ui__["a" /* default */]),details:Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_6_components_admin_projects_details_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_7_components_admin_projects_details_store_reducers_ui__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({proposal:Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_8_components_admin_projects_details_project_proposal_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_9_components_admin_projects_details_project_proposal_store_reducers_ui__["a" /* default */]),directory:Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_10_components_admin_projects_details_project_directory_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_11_components_admin_projects_details_project_directory_store_reducers_ui__["a" /* default */]),meetingMinutes:Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_12_components_admin_projects_details_project_meeting_minutes_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_13_components_admin_projects_details_project_meeting_minutes_store_reducers_ui__["a" /* default */]),rfiLog:Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_14_components_admin_projects_details_project_rfi_log_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_15_components_admin_projects_details_project_rfi_log_store_reducers_ui__["a" /* default */]),submittalLog:Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_16_components_admin_projects_details_project_submittal_log_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_17_components_admin_projects_details_project_submittal_log_store_reducers_ui__["a" /* default */]),emailModal:Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_19_components_admin_projects_details_project_email_modal_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_18_components_admin_projects_details_project_email_modal_store_reducers_ui__["a" /* default */]),dailyReportLog:Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_20_components_admin_projects_details_project_daily_report_log_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_21_components_admin_projects_details_project_daily_report_log_store_reducers_ui__["a" /* default */]),documentation:Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_22_components_admin_projects_details_project_documentation_store_reducers_data__["a" /* default */]),openItems:Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_23_components_admin_projects_details_project_open_items_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_24_components_admin_projects_details_project_open_items_store_reducers_ui__["a" /* default */]),closeout:Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_25_components_admin_projects_details_project_closeout_store_reducers_data__["a" /* default */]),pdfViewer:Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_26_components_shared_pdf_viewer_bluebeam_store_reducers_ui__["a" /* default */]),settings:Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_27_components_admin_projects_details_project_settings_store_reducers_data__["a" /* default */]),coiExps:Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_28_components_admin_projects_details_project_coi_exps_store_reducers_data__["a" /* default */])}))})));

/***/ }),
/* 3238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_store_action_types__ = __webpack_require__(594);
var initialState={projects:null,missingDrs:null,bidsDue:null,missingDrsCount:0,bidsDueCount:0};function projectsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_store_action_types__["d" /* PROJECTS_LOAD_SUCCESS */]:return Object.assign({},state,{projects:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_store_action_types__["f" /* PROJECTS_MISSING_DRS_LOAD_SUCCESS */]:return Object.assign({},state,{missingDrs:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_store_action_types__["b" /* PROJECTS_BIDS_DUE_LOAD_SUCCESS */]:return Object.assign({},state,{bidsDue:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_store_action_types__["e" /* PROJECTS_MISSING_DRS_COUNT */]:return Object.assign({},state,{missingDrsCount:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_store_action_types__["a" /* PROJECTS_BIDS_DUE_COUNT */]:return Object.assign({},state,{bidsDueCount:action.payload});default:return state;}}

/***/ }),
/* 3239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectsUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_store_action_types__ = __webpack_require__(594);
var initialState={currentPage:1,missingDrsCurrentPage:1,bidsDueCurrentPage:1,currentNav:1};function projectsUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_store_action_types__["i" /* PROJECTS_PAGE_CHANGE */]:return Object.assign({},state,{currentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_store_action_types__["g" /* PROJECTS_MISSING_DRS_PAGE_CHANGE */]:return Object.assign({},state,{missingDrsCurrentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_store_action_types__["c" /* PROJECTS_BIDS_DUE_PAGE_CHANGE */]:return Object.assign({},state,{bidsDueCurrentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_store_action_types__["h" /* PROJECTS_NAV_CHANGE */]:return Object.assign({},state,{currentNav:action.payload});default:return state;}}

/***/ }),
/* 3240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newProjectDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__ = __webpack_require__(619);
var initialState={generalContractors:null,newProjectId:null};function newProjectDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["h" /* NEW_PROJECT_GC_SET */]:return Object.assign({},state,{generalContractors:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["i" /* NEW_PROJECT_ID_SET */]:return Object.assign({},state,{newProjectId:action.payload});default:return state;}}

/***/ }),
/* 3241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newProjectUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__ = __webpack_require__(619);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var stages=['gc-selection','client-selection','building-selection','success'];var initialState={currentPage:1,currentStage:'gc-selection',projectForm:{generalContractorId:null,clientId:null,buildingId:null,number:'',name:'',sqFootage:'',bidDueDate:'',advancedDocumentView:false},clientForm:{companyName:'',firstName:'',lastName:'',email:'',phoneNumber:''},buildingForm:{name:'',streetAddress1:'',streetAddress2:'',city:'',state:'',zip:''},showNewClientModal:false,showNewBuildingModal:false};function newProjectUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["c" /* NEW_PROJECT */]:return initialState;case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["a" /* EDIT_PROJECT */]:return Object.assign({},initialState,{currentStage:'client-selection'});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["f" /* NEW_PROJECT_CURRENT_PAGE_SET */]:return Object.assign({},state,{currentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["n" /* NEXT_STAGE */]:return Object.assign({},state,{currentStage:stages[stages.indexOf(state.currentStage)+1]});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["g" /* NEW_PROJECT_FORM_VALUE_CHANGE */]:return Object.assign({},state,{projectForm:Object.assign({},state.projectForm,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["b" /* EDIT_PROJECT_FORM_SET_VALUES */]:return Object.assign({},state,{projectForm:Object.assign({},state.projectForm,{clientId:action.payload.client.id,buildingId:action.payload.building.id,number:action.payload.number,name:action.payload.name,sqFootage:action.payload.sq_footage,bidDueDate:action.payload.bid_due_date,advancedDocumentView:action.payload.advanced_document_view})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["e" /* NEW_PROJECT_CLIENT_FORM_VALUE_CHANGE */]:return Object.assign({},state,{clientForm:Object.assign({},state.clientForm,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["d" /* NEW_PROJECT_BUILDING_FORM_VALUE_CHANGE */]:return Object.assign({},state,{buildingForm:Object.assign({},state.buildingForm,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["m" /* NEW_PROJECT_NEW_CLIENT_MODAL_SHOW */]:return Object.assign({},state,{showNewClientModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["l" /* NEW_PROJECT_NEW_CLIENT_FORM_CLEAN */]:return Object.assign({},state,{clientForm:initialState.clientForm});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["k" /* NEW_PROJECT_NEW_BUILDING_MODAL_SHOW */]:return Object.assign({},state,{showNewBuildingModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_creation_store_action_types__["j" /* NEW_PROJECT_NEW_BUILDING_FORM_CLEAN */]:return Object.assign({},state,{buildingForm:initialState.buildingForm});default:return state;}}

/***/ }),
/* 3242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectDetailsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_store_action_types__ = __webpack_require__(620);
var initialState={currentProject:null};function projectDetailsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_store_action_types__["b" /* PROJECT_DETAILS_INIT */]:return initialState;case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_store_action_types__["a" /* PROJECT_DETAILS_CURRENT_PROJECT_SET */]:return Object.assign({},state,{currentProject:action.payload});default:return state;}}

/***/ }),
/* 3243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectDetailsUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_store_action_types__ = __webpack_require__(620);
var initialState={navBarSelectedItem:null};function projectDetailsUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_store_action_types__["b" /* PROJECT_DETAILS_INIT */]:return initialState;case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_store_action_types__["c" /* PROJECT_DETAILS_NAV_BAR_SELECTION */]:return Object.assign({},state,{navBarSelectedItem:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_store_action_types__["d" /* SHOW_PDF_VIEWER_SET */]:return Object.assign({},state,{showPdfViewer:action.payload});default:return state;}}

/***/ }),
/* 3244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectProposalDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__ = __webpack_require__(631);
var initialState={projectProposal:null,projectProposalPdf:null,csiCodes:[]};function projectProposalDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["o" /* PROJECT_PROPOSAL_SET */]:return Object.assign({},state,{projectProposal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["m" /* PROJECT_PROPOSAL_PDF_SET */]:return Object.assign({},state,{projectProposalPdf:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["b" /* CSI_CODES_SET */]:return Object.assign({},state,{csiCodes:action.payload});default:return state;}}

/***/ }),
/* 3245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (immutable) */ __webpack_exports__["a"] = projectProposalUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__ = __webpack_require__(631);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={showCreateProposal:false,showCreateProposalSuccess:false,showPdfViewer:false,showApproveProposalSuccess:false,projectProposalAddlItems:{permits:{},generalConditions:{},insurance:{},fee:{},contingency:{}},projectProposalItems:{},projectProposalForm:{insuranceRatio:0.01,feeRatio:0.03},itemDelete:{},cancelledLostModal:{message:''},readOnly:false,showAwardRecommendation:true,showCancelModal:false,showLostModal:false,showLostOrCancelledModal:false,isCancelledModal:false,isLostModal:false};function projectProposalUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var item=null;var subItem=null;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["d" /* INIT_PROJECT_PROPOSAL */]:return initialState;case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["x" /* TOGGLE_CREATE_PROPOSAL */]:return Object.assign({},state,{showCreateProposal:!state.showCreateProposal});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["y" /* TOGGLE_CREATE_PROPOSAL_SUCCESS */]:return Object.assign({},state,{showCreateProposalSuccess:!state.showCreateProposalSuccess});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["z" /* TOGGLE_PDF_VIEWER_SUCCESS */]:return Object.assign({},state,{showPdfViewer:!state.showPdfViewer});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["w" /* TOGGLE_APPROVE_PROPOSAL_SUCCESS */]:return Object.assign({},state,{showApproveProposalSuccess:!state.showApproveProposalSuccess});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["i" /* PROJECT_PROPOSAL_ITEMS_SET */]:return Object.assign({},state,{projectProposalItems:action.payload.items,projectProposalAddlItems:action.payload.addlItems});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["e" /* PROJECT_PROPOSAL_ADDL_ITEM_ADD */]:return Object.assign({},state,{projectProposalAddlItems:Object.assign({},state.projectProposalAddlItems,_defineProperty({},action.payload.type,Object.assign({},state.projectProposalAddlItems[action.payload.type],_defineProperty({},action.payload.key,action.payload.item))))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["f" /* PROJECT_PROPOSAL_ADDL_ITEM_VALUE_UPDATE */]:item=state.projectProposalAddlItems[action.payload.type][action.payload.key];return Object.assign({},state,{projectProposalAddlItems:Object.assign({},state.projectProposalAddlItems,_defineProperty({},action.payload.type,Object.assign({},state.projectProposalAddlItems[action.payload.type],_defineProperty({},action.payload.key,Object.assign({},item,_defineProperty({},action.payload.attribute,action.payload.value))))))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["j" /* PROJECT_PROPOSAL_ITEM_ADD */]:return Object.assign({},state,{projectProposalItems:Object.assign({},state.projectProposalItems,_defineProperty({},action.payload.key,action.payload.item))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["l" /* PROJECT_PROPOSAL_ITEM_VALUE_UPDATE */]:item=state.projectProposalItems[action.payload.key];return Object.assign({},state,{projectProposalItems:Object.assign({},state.projectProposalItems,_defineProperty({},action.payload.key,Object.assign({},item,_defineProperty({},action.payload.attribute,action.payload.value))))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["p" /* PROJECT_PROPOSAL_SUB_ITEM_ADD */]:item=state.projectProposalItems[action.payload.itemKey];return Object.assign({},state,{projectProposalItems:Object.assign({},state.projectProposalItems,_defineProperty({},action.payload.itemKey,Object.assign({},item,{subItems:Object.assign({},item.subItems,_defineProperty({},action.payload.key,action.payload.subItem))})))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["q" /* PROJECT_PROPOSAL_SUB_ITEM_VALUE_UPDATE */]:item=state.projectProposalItems[action.payload.itemKey];subItem=item.subItems[action.payload.key];return Object.assign({},state,{projectProposalItems:Object.assign({},state.projectProposalItems,_defineProperty({},action.payload.itemKey,Object.assign({},item,{subItems:Object.assign({},item.subItems,_defineProperty({},action.payload.key,Object.assign({},subItem,_defineProperty({},action.payload.attribute,action.payload.value))))})))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["g" /* PROJECT_PROPOSAL_FORM_VALUE_UPDATE */]:return Object.assign({},state,{projectProposalForm:Object.assign({},state.projectProposalForm,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["k" /* PROJECT_PROPOSAL_ITEM_DELETE_TOGGLE */]:return Object.assign({},state,{itemDelete:_defineProperty({},action.payload,!state.itemDelete[action.payload])});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["h" /* PROJECT_PROPOSAL_ITEMS_RESET */]:return Object.assign({},state,initialState);case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["n" /* PROJECT_PROPOSAL_READ_ONLY_SET */]:return Object.assign({},state,{readOnly:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["a" /* AWARD_RECOMMENDATION_TOGGLE */]:return Object.assign({},state,{showAwardRecommendation:!state.showAwardRecommendation});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["t" /* SET_SHOW_CANCEL_MODAL */]:return Object.assign({},state,{isCancelledModal:action.payload,showLostOrCancelledModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["u" /* SET_SHOW_LOST_MODAL */]:return Object.assign({},state,{isLostModal:action.payload,showLostOrCancelledModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["r" /* SET_DATE_MODAL */]:return Object.assign({},state,{cancelledLostModal:Object.assign({},state.cancelledLostModal,{date:action.payload})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["s" /* SET_MESSAGE */]:return Object.assign({},state,{cancelledLostModal:Object.assign({},state.cancelledLostModal,{message:action.payload})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["v" /* SET_TERMINATION_CATEGORY */]:return Object.assign({},state,{cancelledLostModal:Object.assign({},state.cancelledLostModal,{terminationCategory:action.payload})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_proposal_store_action_types__["c" /* INIT_PROJECT_LOST_CANCEL_MODAL */]:return Object.assign({},state,{cancelledLostModal:{date:action.payload.date,message:action.payload.message,terminationCategory:action.payload.terminationCategory}});default:return state;}}

/***/ }),
/* 3246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectDirectoryDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__ = __webpack_require__(630);
var initialState={directory:null,directoryPdf:null,serviceProviderUsers:[]};function projectDirectoryDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__["d" /* DIRECTORY_SET */]:return Object.assign({},state,{directory:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__["c" /* DIRECTORY_PDF_SET */]:return Object.assign({},state,{directoryPdf:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__["e" /* NEW_CONTRIBUTOR_MODAL_INIT */]:return Object.assign({},state,{serviceProviderUsers:initialState.serviceProviderUsers});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__["j" /* SERVICE_PROVIDER_USERS_SET */]:return Object.assign({},state,{serviceProviderUsers:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__["i" /* PROJECT_CONTRIBUTORS_UPDATE_WITH_EDIT_USER */]:return Object.assign({},state,{directory:Object.assign({},state.directory,{project_contributors:state.directory.project_contributors.map(function(contrib){return Object.assign({},contrib,{users:contrib.users.map(function(user){if(user.id===action.payload.id){return action.payload;}else{return user;}})});})})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__["h" /* PROJECT_CONTRIBUTORS_UPDATE */]:return Object.assign({},state,{directory:Object.assign({},state.directory,{project_contributors:state.directory.project_contributors.map(function(contrib){if(contrib.id===action.payload.id){return action.payload;}else{return contrib;}})})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__["g" /* PROJECT_CONTRIBUTORS_DELETE */]:return Object.assign({},state,{directory:Object.assign({},state.directory,{project_contributors:state.directory.project_contributors.filter(function(contrib){return contrib.id!==action.payload;})})});default:return state;}}

/***/ }),
/* 3247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectDirectoryUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__ = __webpack_require__(630);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={showNewContributorModal:false,showEditUserModal:false,showNewCompanyForm:false,showSelectUsersForm:false,showInviteUserForm:false,showDirectoryPdfViewer:false,newContributorType:null,contributorSettings:{},userSettings:{},editedUser:{},currentContributor:{}};function projectDirectoryUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__["o" /* SHOW_NEW_CONTRIBUTOR_MODAL_SET */]:return Object.assign({},state,{showNewContributorModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__["l" /* SHOW_EDIT_USER_MODAL_SET */]:return Object.assign({},state,{showEditUserModal:action.payload.showEditUserModal,editedUser:action.payload.user});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__["e" /* NEW_CONTRIBUTOR_MODAL_INIT */]:return Object.assign({},state,{newContributorType:initialState.newContributorType});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__["n" /* SHOW_NEW_COMPANY_FORM_SET */]:return Object.assign({},state,{showNewCompanyForm:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__["p" /* SHOW_SELECT_USERS_FORM_SET */]:return Object.assign({},state,{showSelectUsersForm:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__["m" /* SHOW_INVITE_USER_FORM_SET */]:return Object.assign({},state,{showInviteUserForm:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__["k" /* SHOW_DIRECTORY_PDF_VIEWER_SET */]:return Object.assign({},state,{showDirectoryPdfViewer:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__["b" /* CURRENT_CONTRIBUTOR_SET */]:return Object.assign({},state,{currentContributor:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__["f" /* NEW_CONTRIBUTOR_TYPE_SET */]:return Object.assign({},state,{newContributorType:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__["a" /* CONTRIBUTOR_SETTINGS_TOGGLE */]:return Object.assign({},state,{contributorSettings:_defineProperty({},action.payload,!state.contributorSettings[action.payload])});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_directory_store_action_types__["q" /* USER_SETTINGS_TOGGLE */]:return Object.assign({},state,{userSettings:_defineProperty({},action.payload,!state.userSettings[action.payload])});default:return state;}}

/***/ }),
/* 3248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectMeetingMinutesDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__ = __webpack_require__(623);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={meetingInfo:null,meetings:[],meetingCategories:[],currentMeeting:null,meetingPdf:null};function projectMeetingMinutesDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["k" /* MEETING_INFO_SET */]:return Object.assign({},state,{meetingInfo:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["f" /* MEETINGS_SET */]:return Object.assign({},state,{meetings:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["s" /* MEETING_PDF_SET */]:return Object.assign({},state,{meetingPdf:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["h" /* MEETING_CATEGORIES_SET */]:return Object.assign({},state,{meetingCategories:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["e" /* MEETINGS_ADD */]:return Object.assign({},state,{meetings:[].concat(_toConsumableArray(state.meetings),[action.payload])});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["d" /* CURRENT_MEETING_SET */]:return Object.assign({},state,{currentMeeting:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["g" /* MEETINGS_UPDATE */]:return Object.assign({},state,{meetings:state.meetings.map(function(meeting){if(meeting.id===action.payload.id){return action.payload;}else{return meeting;}})});default:return state;}}

/***/ }),
/* 3249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectMeetingMinutesUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__ = __webpack_require__(623);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={meetingInfoEdit:false,meetingModalShow:false,meetingForm:{attendeeIds:[]},meetingItems:{},showAttendeesModal:false,reviewMeeting:false,meetingItemSettings:{},showPdfViewer:false,confirmationMsg:'',confirmApproval:false};function projectMeetingMinutesUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["p" /* MEETING_MINUTES_INIT */]:return initialState;case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["j" /* MEETING_INFO_EDIT_SET */]:return Object.assign({},state,{meetingInfoEdit:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["r" /* MEETING_MODAL_SHOW_SET */]:return Object.assign({},state,{meetingModalShow:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["q" /* MEETING_MODAL_INIT */]:return Object.assign({},state,{meetingForm:initialState.meetingForm,meetingItems:initialState.meetingItems,showAttendeesModal:initialState.showAttendeesModal,reviewMeeting:initialState.reviewMeeting,meetingItemSettings:initialState.meetingItemSettings,confirmApproval:initialState.confirmApproval});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["i" /* MEETING_FORM_VALUE_UPDATE */]:return Object.assign({},state,{meetingForm:Object.assign({},state.meetingForm,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["o" /* MEETING_ITEM_VALUE_UPDATE */]:var item=state.meetingItems[action.payload.key];return Object.assign({},state,{meetingItems:Object.assign({},state.meetingItems,_defineProperty({},action.payload.key,Object.assign({},item,_defineProperty({},action.payload.attribute,action.payload.value))))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["m" /* MEETING_ITEM_ADD */]:return Object.assign({},state,{meetingItems:Object.assign({},state.meetingItems,_defineProperty({},action.payload.key,action.payload.item))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["l" /* MEETING_ITEMS_ATTACH */]:return Object.assign({},state,{meetingItems:Object.assign({},state.meetingItems,action.payload)});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["a" /* ATTENDEES_MODAL_SHOW_SET */]:return Object.assign({},state,{showAttendeesModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["u" /* REVIEW_MEETING_SET */]:return Object.assign({},state,{reviewMeeting:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["n" /* MEETING_ITEM_SETTINGS_SET */]:return Object.assign({},state,{meetingItemSettings:_defineProperty({},action.payload.key,action.payload.menu)});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["v" /* TOGGLE_PDF_VIEWER_SUCCESS */]:return Object.assign({},state,{showPdfViewer:!state.showPdfViewer});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["b" /* CONFIRMATION_MSG_SET */]:return Object.assign({},state,{confirmationMsg:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_meeting_minutes_store_action_types__["c" /* CONFIRM_APPROVAL_SET */]:return Object.assign({},state,{confirmApproval:action.payload});default:return state;}}

/***/ }),
/* 3250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectRfiLogDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__ = __webpack_require__(625);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={rfis:[],total:0,currentPage:1,currentStatus:'not_pre',pageSize:25,currentRfi:null,rfiLogPdf:null,dueDateFilter:'all'};function projectRfiLogDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["d" /* RFIS_SET */]:return Object.assign({},state,action.payload);case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["b" /* RFIS_ADD */]:return Object.assign({},state,{rfis:[action.payload].concat(_toConsumableArray(state.rfis))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["e" /* RFIS_UPDATE */]:return Object.assign({},state,{rfis:state.rfis.map(function(rfi){if(rfi.id===action.payload.id){return action.payload;}else{return rfi;}})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["c" /* RFIS_DELETE */]:return Object.assign({},state,{rfis:state.rfis.filter(function(rfi){return rfi.id!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["a" /* CURRENT_RFI_SET */]:return Object.assign({},state,{currentRfi:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["o" /* RFI_LOG_PDF_SET */]:return Object.assign({},state,{rfiLogPdf:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["i" /* RFI_ADDL_ASSIGNEE_RESPOND_SUCCESS */]:return Object.assign({},state,{rfis:state.rfis.map(function(rfi){return Object.assign({},rfi,{rfi_questions:rfi.rfi_questions.map(function(qus){return Object.assign({},qus,{rfi_addl_assignees:qus.rfi_addl_assignees.map(function(addlAssignee){if(addlAssignee.id===action.payload.id){return action.payload;}else{return addlAssignee;}})});})});})});default:return state;}}

/***/ }),
/* 3251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectRfiLogUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domain_rfi_status_enum__ = __webpack_require__(284);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={rfiTabSelected:2,rfiModalShow:false,rfiForm:{title:'',status:__WEBPACK_IMPORTED_MODULE_1_domain_rfi_status_enum__["b" /* RfiStatusKeys */].PENDING,relCsiCodes:[],recipients:[],errors:{}},rfiQuestions:{},rfiQuestionsDeleted:[],rfiReadOnly:false,rfiGcAcceleration:false,rfiLogPdfViewer:false,rfiPdfViewer:false,rfiShowErrorMessage:false};var question=null;var questions={};var addlAssignees=null;function projectRfiLogUiReducer(){var _Object$assign2,_Object$assign4;var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["n" /* RFI_LOG_INIT */]:return initialState;case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["C" /* RFI_TAB_SELECTED_SET */]:return Object.assign({},state,{rfiTabSelected:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["r" /* RFI_MODAL_SHOW_SET */]:return Object.assign({},state,{rfiModalShow:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["q" /* RFI_MODAL_INIT */]:return Object.assign({},state,{rfiForm:initialState.rfiForm,rfiQuestions:initialState.rfiQuestions,rfiQuestionsDeleted:initialState.rfiQuestionsDeleted,rfiGcAcceleration:initialState.rfiGcAcceleration,rfiShowErrorMessage:initialState.rfiShowErrorMessage});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["l" /* RFI_FORM_VALUE_UPDATE */]:return Object.assign({},state,{rfiShowErrorMessage:false,rfiForm:Object.assign({},state.rfiForm,(_Object$assign2={},_defineProperty(_Object$assign2,action.payload.attribute,action.payload.value),_defineProperty(_Object$assign2,'errors',Object.assign({},state.rfiForm.errors,_defineProperty({},action.payload.attribute,false))),_Object$assign2))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["k" /* RFI_FORM_VALUES_SET */]:return Object.assign({},state,{rfiForm:Object.assign({},state.rfiForm,action.payload)});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["j" /* RFI_FORM_ERRORS_SET */]:return Object.assign({},state,{rfiForm:Object.assign({},state.rfiForm,{errors:action.payload})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["z" /* RFI_QUESTION_VALUE_UPDATE */]:question=state.rfiQuestions[action.payload.key];return Object.assign({},state,{rfiShowErrorMessage:false,rfiQuestions:Object.assign({},state.rfiQuestions,_defineProperty({},action.payload.key,Object.assign({},question,(_Object$assign4={},_defineProperty(_Object$assign4,action.payload.attribute,action.payload.value),_defineProperty(_Object$assign4,'errors',Object.assign({},question.errors,_defineProperty({},action.payload.attribute,false))),_Object$assign4))))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["w" /* RFI_QUESTION_ERRORS_SET */]:question=state.rfiQuestions[action.payload.key];return Object.assign({},state,{rfiQuestions:Object.assign({},state.rfiQuestions,_defineProperty({},action.payload.key,Object.assign({},question,{errors:action.payload.errors})))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["u" /* RFI_QUESTION_ADD */]:return Object.assign({},state,{rfiQuestions:Object.assign({},state.rfiQuestions,_defineProperty({},action.payload.key,Object.assign({},action.payload.item,{errors:{}})))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["t" /* RFI_QUESTIONS_ATTACH */]:return Object.assign({},state,{rfiQuestions:Object.assign({},state.rfiQuestions,action.payload)});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["v" /* RFI_QUESTION_DELETE */]:question=state.rfiQuestions[action.payload];questions=Object.assign({},state.rfiQuestions);delete questions[action.payload];return Object.assign({},state,{rfiQuestions:questions,rfiQuestionsDeleted:[].concat(_toConsumableArray(state.rfiQuestionsDeleted),[question])});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["A" /* RFI_READ_ONLY_SET */]:return Object.assign({},state,{rfiReadOnly:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["x" /* RFI_QUESTION_FILE_DELETE */]:question=state.rfiQuestions[action.payload.key];return Object.assign({},state,{rfiQuestions:Object.assign({},state.rfiQuestions,_defineProperty({},action.payload.key,Object.assign({},question,_defineProperty({},action.payload.attribute,[].concat(_toConsumableArray(question[action.payload.attribute]),[action.payload.value])))))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["y" /* RFI_QUESTION_NOTE_ADD */]:question=state.rfiQuestions[action.payload.key];return Object.assign({},state,{rfiQuestions:Object.assign({},state.rfiQuestions,_defineProperty({},action.payload.key,Object.assign({},question,{notes:[].concat(_toConsumableArray(question.notes),[action.payload.note])})))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["m" /* RFI_GC_ACCELERATION_SET */]:return Object.assign({},state,{rfiGcAcceleration:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["p" /* RFI_LOG_PDF_VIEWER_SET */]:return Object.assign({},state,{rfiLogPdfViewer:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["s" /* RFI_PDF_VIEWER_SET */]:return Object.assign({},state,{rfiPdfViewer:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["B" /* RFI_SHOW_ERROR_MESSAGE_SET */]:return Object.assign({},state,{rfiShowErrorMessage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["f" /* RFI_ADDL_ASSIGNEES_ADD */]:question=state.rfiQuestions[action.payload.key];return Object.assign({},state,{rfiQuestions:Object.assign({},state.rfiQuestions,_defineProperty({},action.payload.key,Object.assign({},question,{addlAssignees:[].concat(_toConsumableArray(question.addlAssignees),[action.payload.addlAssignee])})))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["h" /* RFI_ADDL_ASSIGNEES_UPDATE */]:question=state.rfiQuestions[action.payload.key];addlAssignees=[].concat(_toConsumableArray(question.addlAssignees));addlAssignees[action.payload.index]=Object.assign({},addlAssignees[action.payload.index],action.payload.addlAssignee);return Object.assign({},state,{rfiQuestions:Object.assign({},state.rfiQuestions,_defineProperty({},action.payload.key,Object.assign({},question,{addlAssignees:addlAssignees})))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_rfi_log_store_action_types__["g" /* RFI_ADDL_ASSIGNEES_DELETE */]:question=state.rfiQuestions[action.payload.key];addlAssignees=[].concat(_toConsumableArray(question.addlAssignees));addlAssignees[action.payload.index]=Object.assign({},addlAssignees[action.payload.index],{destroy:true});return Object.assign({},state,{rfiQuestions:Object.assign({},state.rfiQuestions,_defineProperty({},action.payload.key,Object.assign({},question,{addlAssignees:addlAssignees})))});default:return state;}}

/***/ }),
/* 3252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectSubmittalLogDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__ = __webpack_require__(627);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={submittals:[],submittalNotes:[],total:0,currentPage:1,currentStatus:'not_pre',pageSize:25,transmittalPdf:null,currentSubmittal:null,submittalLogPdf:null,dueDateFilter:'all'};function projectSubmittalLogDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["d" /* SUBMITTALS_SET */]:return Object.assign({},state,action.payload);case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["r" /* SUBMITTAL_MODAL_INIT */]:return Object.assign({},state,{submittalNotes:initialState.submittalNotes,transmittalPdf:initialState.transmittalPdf,currentSubmittal:initialState.currentSubmittal});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["A" /* TRANSMITTAL_PDF_SET */]:return Object.assign({},state,{transmittalPdf:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["a" /* CURRENT_SUBMITTAL_SET */]:return Object.assign({},state,{currentSubmittal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["z" /* SUBMITTAL_UPDATE */]:return Object.assign({},state,{submittals:state.submittals.map(function(submittal){if(submittal.id===action.payload.id){return action.payload;}else{return submittal;}})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["u" /* SUBMITTAL_NOTES_SET */]:return Object.assign({},state,{submittalNotes:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["t" /* SUBMITTAL_NOTES_ADD */]:return Object.assign({},state,{submittalNotes:[].concat(_toConsumableArray(state.submittalNotes),[action.payload])});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["p" /* SUBMITTAL_LOG_PDF_SET */]:return Object.assign({},state,{submittalLogPdf:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["h" /* SUBMITTAL_ADDL_ASSIGNEE_RESPONSE */]:return Object.assign({},state,{submittals:state.submittals.map(function(submittal){if(submittal.id===action.payload.submittal_id){return Object.assign({},submittal,{submittal_addl_assignees:submittal.submittal_addl_assignees.map(function(addlAssignee){if(addlAssignee.id===action.payload.id){return action.payload;}else{return addlAssignee;}})});}else{return submittal;}})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["c" /* SUBMITTALS_DELETE */]:return Object.assign({},state,{submittals:state.submittals.filter(function(submittal){return submittal.id!==action.payload;})});default:return state;}}

/***/ }),
/* 3253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectSubmittalLogUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domain_submittal_status_enum__ = __webpack_require__(237);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={submittalTabSelected:2,submittalModalShow:false,submittalReadOnly:false,submittalLeadTimeReadOnly:false,submittalGcAcceleration:false,showTransmittalPdf:false,submittalLogPdfViewer:false,submittalPdfViewer:false,submittalShowErrorMessage:false,submittalForm:{title:'',status:__WEBPACK_IMPORTED_MODULE_1_domain_submittal_status_enum__["b" /* SubmittalStatusKeys */].PENDING,physicalCopies:'0',question:'',assignee:[],recipients:[],reqDocs:[],reqImages:[],reqDocsDelete:[],reqImagesDelete:[],addlAssignees:[],errors:{}}};function projectSubmittalLogUiReducer(){var _Object$assign2;var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var addlAssignees=null;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["o" /* SUBMITTAL_LOG_INIT */]:return initialState;case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["y" /* SUBMITTAL_TAB_SELECTED_SET */]:return Object.assign({},state,{submittalTabSelected:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["s" /* SUBMITTAL_MODAL_SHOW_SET */]:return Object.assign({},state,{submittalModalShow:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["r" /* SUBMITTAL_MODAL_INIT */]:return Object.assign({},state,{submittalForm:initialState.submittalForm,submittalReadOnly:initialState.submittalReadOnly,submittalLeadTimeReadOnly:initialState.submittalLeadTimeReadOnly,submittalGcAcceleration:initialState.submittalGcAcceleration,submittalShowErrorMessage:initialState.submittalShowErrorMessage});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["l" /* SUBMITTAL_FORM_VALUE_UPDATE */]:return Object.assign({},state,{submittalShowErrorMessage:false,submittalForm:Object.assign({},state.submittalForm,(_Object$assign2={},_defineProperty(_Object$assign2,action.payload.attribute,action.payload.value),_defineProperty(_Object$assign2,'errors',Object.assign({},state.submittalForm.errors,_defineProperty({},action.payload.attribute,false))),_Object$assign2))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["i" /* SUBMITTAL_FILE_DELETE */]:return Object.assign({},state,{submittalForm:Object.assign({},state.submittalForm,_defineProperty({},action.payload.attribute,[].concat(_toConsumableArray(state.submittalForm[action.payload.attribute]),[action.payload.value])))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["w" /* SUBMITTAL_READ_ONLY_SET */]:return Object.assign({},state,{submittalReadOnly:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["n" /* SUBMITTAL_LEAD_TIME_READ_ONLY_SET */]:return Object.assign({},state,{submittalLeadTimeReadOnly:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["b" /* SHOW_TRANSMITTAL_PDF_SET */]:return Object.assign({},state,{showTransmittalPdf:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["k" /* SUBMITTAL_FORM_SET */]:return Object.assign({},state,{submittalForm:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["j" /* SUBMITTAL_FORM_ERRORS_SET */]:return Object.assign({},state,{submittalForm:Object.assign({},state.submittalForm,{errors:action.payload})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["m" /* SUBMITTAL_GC_ACCELERATION_SET */]:return Object.assign({},state,{submittalGcAcceleration:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["q" /* SUBMITTAL_LOG_PDF_VIEWER_SET */]:return Object.assign({},state,{submittalLogPdfViewer:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["v" /* SUBMITTAL_PDF_VIEWER_SET */]:return Object.assign({},state,{submittalPdfViewer:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["x" /* SUBMITTAL_SHOW_ERROR_MESSAGE_SET */]:return Object.assign({},state,{submittalShowErrorMessage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["e" /* SUBMITTAL_ADDL_ASSIGNEES_ADD */]:return Object.assign({},state,{submittalForm:Object.assign({},state.submittalForm,{addlAssignees:[].concat(_toConsumableArray(state.submittalForm.addlAssignees),[action.payload])})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["g" /* SUBMITTAL_ADDL_ASSIGNEES_UPDATE */]:addlAssignees=[].concat(_toConsumableArray(state.submittalForm.addlAssignees));addlAssignees[action.payload.index]=Object.assign({},addlAssignees[action.payload.index],action.payload.addlAssignee);return Object.assign({},state,{submittalForm:Object.assign({},state.submittalForm,{addlAssignees:addlAssignees})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_submittal_log_store_action_types__["f" /* SUBMITTAL_ADDL_ASSIGNEES_DELETE */]:addlAssignees=[].concat(_toConsumableArray(state.submittalForm.addlAssignees));addlAssignees[action.payload]=Object.assign({},addlAssignees[action.payload],{destroy:true});return Object.assign({},state,{submittalForm:Object.assign({},state.submittalForm,{addlAssignees:addlAssignees})});default:return state;}}

/***/ }),
/* 3254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (immutable) */ __webpack_exports__["a"] = projectEmailModalUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__ = __webpack_require__(622);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={showEmailModal:false,showCustomEmailError:false,showNewCustomEmail:false,emails:[],subject:'',message:'',recipients:[],customEmail:''};function projectEmailModalUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["c" /* INIT_PROJECT_EMAIL_MODAL */]:return Object.assign({},state,{recipients:[],showCustomEmailError:false,showNewCustomEmail:false,subject:action.payload.subject,message:action.payload.message,customEmail:''});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["j" /* SET_SHOW_EMAIL_MODAL */]:return Object.assign({},state,{showEmailModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["i" /* SET_SHOW_CUSTOM_EMAIL_ERROR */]:return Object.assign({},state,{showCustomEmailError:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["k" /* SET_SHOW_NEW_CUSTOM_EMAIL */]:return Object.assign({},state,{showNewCustomEmail:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["e" /* SET_EMAILS */]:return Object.assign({},state,{emails:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["a" /* ADD_EMAIL */]:return Object.assign({},state,{emails:[action.payload].concat(_toConsumableArray(state.emails))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["b" /* ADD_RECIPIENT */]:return Object.assign({},state,{recipients:[action.payload].concat(_toConsumableArray(state.recipients))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["l" /* SET_SUBJECT */]:return Object.assign({},state,{subject:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["g" /* SET_MESSAGE */]:return Object.assign({},state,{message:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["h" /* SET_RECIPIENTS */]:return Object.assign({},state,{recipients:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["d" /* SET_CUSTOM_EMAIL */]:return Object.assign({},state,{customEmail:action.payload});default:return state;}}

/***/ }),
/* 3255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (immutable) */ __webpack_exports__["a"] = projectEmailModalDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__ = __webpack_require__(622);
var initialState={history:[]};function projectEmailModalDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_email_modal_store_action_types__["f" /* SET_EMAIL_HISTORY */]:return Object.assign({},state,{history:action.payload});default:return state;}}

/***/ }),
/* 3256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectDailyReportLogDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__ = __webpack_require__(628);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={dailyReports:[],fieldWorkOrders:[],currentDailyReport:null,currentDailyReportIds:null,currentFieldWorkOrder:null,contributors:[],presetTasks:{},contributorsForm:{},dailyReportLogPdf:null,activeEntryId:null,reportLogPdf:null,subDailyReportsCount:null,reportDate:__WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD'),reportExtraInputs:{},reportOpenItem:{},generalContactor:null,members:[],deletedMembers:[],supervisorTasks:[],gcImages:[],gcDeletedImages:[],fieldWorkOrderForm:{}};function projectDailyReportLogDataReducer(){var _Object$assign5,_Object$assign11;var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["f" /* DAILY_REPORTS_SET */]:return Object.assign({},state,{dailyReports:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["k" /* FIELD_WORK_ORDERS_SET */]:return Object.assign({},state,{fieldWorkOrders:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["n" /* FIELD_WORK_ORDER_SET */]:return Object.assign({},state,{currentFieldWorkOrder:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["R" /* SET_REPORTS_IDS */]:return Object.assign({},state,{currentDailyReportIds:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["A" /* SET_ACTIVE_ENTRIES_ID */]:return Object.assign({},state,{activeEntryId:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["g" /* DAILY_REPORTS_UPDATE */]:return Object.assign({},state,{dailyReports:state.dailyReports.map(function(report){if(report.id===action.payload.id){return action.payload;}return report;})});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["B" /* SET_CONTRIBUTORS */]:return Object.assign({},state,{contributors:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["C" /* SET_CURRENT_DAILY_REPORT */]:return Object.assign({},state,{currentDailyReport:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["x" /* LOAD_PRESET_TASKS */]:return Object.assign({},state,{presetTasks:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["b" /* ADD_DAILY_REPORT_SUCCESS */]:return Object.assign({},state,{currentDailyReport:action.payload,dailyReports:[action.payload].concat(_toConsumableArray(state.dailyReports.filter(function(report){return report.id!==action.payload.id;}))),currentDailyReportIds:action.payload.daily_report_entries.sort(function(report1,report2){return report1.id-report2.id;}).map(function(report){return report.id;})});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["w" /* INITIALIZE_TRADE_FORM */]:return Object.assign({},state,{contributorsForm:Object.assign({},state.contributorsForm,action.payload)});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["_10" /* UPDATE_TRADE_FORM */]:return Object.assign({},state,{contributorsForm:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["d" /* CHANGE_AMOUNT_OF_TECHNICIANS */]:return Object.assign({},state,{contributorsForm:Object.assign({},state.contributorsForm,_defineProperty({},action.payload.contribId,Object.assign({},state.contributorsForm[action.payload.contribId],{technicians:action.payload.technicians})))});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["a" /* ADDED_DELETED_TECHNICIANS */]:return Object.assign({},state,{contributorsForm:Object.assign({},state.contributorsForm,_defineProperty({},action.payload.contribId,Object.assign({},state.contributorsForm[action.payload.contribId],{deletedTechnicians:[].concat(_toConsumableArray(state.contributorsForm[action.payload.contribId].deletedTechnicians),[action.payload.technician])})))});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["u" /* HANDLE_WORKED_FORM */]:var newTechnicians=[].concat(_toConsumableArray(state.contributorsForm[action.payload.contribId].technicians));newTechnicians[action.payload.techId]=Object.assign({},state.contributorsForm[action.payload.contribId].technicians[action.payload.techId],{workedFrom:action.payload.value,hoursAmount:''});return Object.assign({},state,{contributorsForm:Object.assign({},state.contributorsForm,_defineProperty({},action.payload.contribId,Object.assign({},state.contributorsForm[action.payload.contribId],{technicians:newTechnicians})))});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["v" /* HANDLE_WORKED_TO */]:var newTechniciansValues=[].concat(_toConsumableArray(state.contributorsForm[action.payload.contribId].technicians));newTechniciansValues[action.payload.techId]=Object.assign({},state.contributorsForm[action.payload.contribId].technicians[action.payload.techId],{workedTo:action.payload.value,hoursAmount:''});return Object.assign({},state,{contributorsForm:Object.assign({},state.contributorsForm,_defineProperty({},action.payload.contribId,Object.assign({},state.contributorsForm[action.payload.contribId],{technicians:newTechniciansValues})))});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["p" /* HANDLE_ATTRIBUTE_CHANGE_FOR_SUB */]:var newTechniciansValuesForSub=[].concat(_toConsumableArray(state.contributorsForm[action.payload.contribId].technicians));var additionalInfo=newTechniciansValuesForSub[action.payload.techId].additionalInfo;if(action.payload.attribute==='sub_technician'&&additionalInfo){additionalInfo=additionalInfo.map(function(info){return Object.assign({},info,{sub_technician_id:'',sub_technician:action.payload.value});});}newTechniciansValuesForSub[action.payload.techId]=Object.assign({},state.contributorsForm[action.payload.contribId].technicians[action.payload.techId],(_Object$assign5={},_defineProperty(_Object$assign5,action.payload.attribute,action.payload.value),_defineProperty(_Object$assign5,'additionalInfo',additionalInfo),_Object$assign5));return Object.assign({},state,{contributorsForm:Object.assign({},state.contributorsForm,_defineProperty({},action.payload.contribId,Object.assign({},state.contributorsForm[action.payload.contribId],{technicians:newTechniciansValuesForSub})))});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["q" /* HANDLE_ATTRIBUTE_CHANGE_FOR_SUB_MORE_ACTION */]:var techniciansValuesForMoreInfoAttribute=[].concat(_toConsumableArray(state.contributorsForm[action.payload.contribId].technicians));var additionalInfoValuesAttribute=[].concat(_toConsumableArray(state.contributorsForm[action.payload.contribId].technicians[action.payload.techId].additionalInfo));additionalInfoValuesAttribute[action.payload.infoIndex]=Object.assign({},additionalInfoValuesAttribute[action.payload.infoIndex],_defineProperty({},action.payload.attribute,action.payload.value));techniciansValuesForMoreInfoAttribute[action.payload.techId]=Object.assign({},state.contributorsForm[action.payload.contribId].technicians[action.payload.techId],{additionalInfo:additionalInfoValuesAttribute});return Object.assign({},state,{contributorsForm:Object.assign({},state.contributorsForm,_defineProperty({},action.payload.contribId,Object.assign({},state.contributorsForm[action.payload.contribId],{technicians:techniciansValuesForMoreInfoAttribute})))});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["s" /* HANDLE_HOURS_AMOUNT */]:var techniciansValues=[].concat(_toConsumableArray(state.contributorsForm[action.payload.contribId].technicians));techniciansValues[action.payload.techId]=Object.assign({},state.contributorsForm[action.payload.contribId].technicians[action.payload.techId],{workedTo:'',workedFrom:'',hoursAmount:action.payload.value});return Object.assign({},state,{contributorsForm:Object.assign({},state.contributorsForm,_defineProperty({},action.payload.contribId,Object.assign({},state.contributorsForm[action.payload.contribId],{technicians:techniciansValues})))});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["t" /* HANDLE_HOURS_AMOUNT_MORE_INFO */]:var techniciansValuesForMoreInfoHours=[].concat(_toConsumableArray(state.contributorsForm[action.payload.contribId].technicians));var additionalInfoValues=[].concat(_toConsumableArray(state.contributorsForm[action.payload.contribId].technicians[action.payload.techId].additionalInfo));additionalInfoValues[action.payload.infoIndex]=Object.assign({},additionalInfoValues[action.payload.infoIndex],{workedTo:'',workedFrom:'',hoursAmount:action.payload.value});techniciansValuesForMoreInfoHours[action.payload.techId]=Object.assign({},state.contributorsForm[action.payload.contribId].technicians[action.payload.techId],{additionalInfo:additionalInfoValues});return Object.assign({},state,{contributorsForm:Object.assign({},state.contributorsForm,_defineProperty({},action.payload.contribId,Object.assign({},state.contributorsForm[action.payload.contribId],{technicians:techniciansValuesForMoreInfoHours})))});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["r" /* HANDLE_DATE_MORE_INFO */]:var techniciansValuesForMoreInfoWorkedFrom=[].concat(_toConsumableArray(state.contributorsForm[action.payload.contribId].technicians));var additionalInfoValuesWorkedFrom=[].concat(_toConsumableArray(state.contributorsForm[action.payload.contribId].technicians[action.payload.techId].additionalInfo));additionalInfoValuesWorkedFrom[action.payload.infoIndex]=Object.assign({},additionalInfoValuesWorkedFrom[action.payload.infoIndex],(_Object$assign11={},_defineProperty(_Object$assign11,action.payload.key,action.payload.value),_defineProperty(_Object$assign11,'hoursAmount',''),_Object$assign11));techniciansValuesForMoreInfoWorkedFrom[action.payload.techId]=Object.assign({},state.contributorsForm[action.payload.contribId].technicians[action.payload.techId],{additionalInfo:additionalInfoValuesWorkedFrom});return Object.assign({},state,{contributorsForm:Object.assign({},state.contributorsForm,_defineProperty({},action.payload.contribId,Object.assign({},state.contributorsForm[action.payload.contribId],{technicians:techniciansValuesForMoreInfoWorkedFrom})))});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["o" /* HANDLE_ATTRIBUTE_CHANGE */]:return Object.assign({},state,{contributorsForm:Object.assign({},state.contributorsForm,_defineProperty({},action.payload.contribId,Object.assign({},state.contributorsForm[action.payload.contribId],_defineProperty({},action.payload.attribute,action.payload.value))))});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["e" /* CLEAR_FORM */]:return Object.assign({},state,{contributorsForm:{}});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["F" /* SET_DAILY_REPORT_LOG_PDF */]:return Object.assign({},state,{dailyReportLogPdf:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["h" /* DELETE_DAILY_REPORT */]:return Object.assign({},state,{dailyReports:state.dailyReports.filter(function(report){return report.id!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["Z" /* SET_REPORT_PDF */]:return Object.assign({},state,{reportLogPdf:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["U" /* SET_REPORT_DATE */]:return Object.assign({},state,{reportDate:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["W" /* SET_REPORT_EXTRA_INPUTS */]:return Object.assign({},state,{reportExtraInputs:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["V" /* SET_REPORT_EXTRA_INPUT */]:return Object.assign({},state,{reportExtraInputs:Object.assign({},state.reportExtraInputs,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["X" /* SET_REPORT_OPEN_ITEM */]:return Object.assign({},state,{reportOpenItem:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["Y" /* SET_REPORT_OPEN_ITEM_VALUE */]:return Object.assign({},state,{reportOpenItem:Object.assign({},state.reportOpenItem,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["O" /* SET_GENERAL_CONTACTOR_NAME */]:return Object.assign({},state,{generalContactor:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["_5" /* SET_SUPERVISOR_TASKS */]:return Object.assign({},state,{supervisorTasks:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["P" /* SET_MEMBERS */]:return Object.assign({},state,{members:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["I" /* SET_DELETED_MEMBERS */]:return Object.assign({},state,{deletedMembers:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["N" /* SET_GCX_IMAGES */]:return Object.assign({},state,{gcImages:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["M" /* SET_GCX_DELETED_IMAGES */]:return Object.assign({},state,{gcDeletedImages:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["_8" /* SUB_DAILY_REPORTS_COUNT_SUCCESS */]:return Object.assign({},state,{subDailyReportsCount:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["_7" /* SUB_DAILY_REPORTS_COUNT_INIT */]:return Object.assign({},state,{subDailyReportsCount:initialState.subDailyReportsCount});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["m" /* FIELD_WORK_ORDER_FORM_INIT */]:return Object.assign({},state,{fieldWorkOrderForm:action.payload});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["l" /* FIELD_WORK_ORDER_FORM_ATTRIBUTE_SET */]:return Object.assign({},state,{fieldWorkOrderForm:Object.assign({},state.fieldWorkOrderForm,_defineProperty({},action.payload.attribute,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["_9" /* UPDATE_FIELD_WORK_ORDER_SUCCESS */]:return Object.assign({},state,{currentFieldWorkOrder:action.payload,fieldWorkOrders:state.fieldWorkOrders.map(function(fwo){if(fwo.id===action.payload.id){return action.payload;}else{return fwo;}})});case __WEBPACK_IMPORTED_MODULE_1_components_admin_projects_details_project_daily_report_log_store_action_types__["j" /* DUPLICATE_DAILY_REPORT_SUCCESS */]:return Object.assign({},state,{dailyReports:[action.payload].concat(_toConsumableArray(state.dailyReports.filter(function(report){return report.id!==action.payload.id;})))});default:return state;}}

/***/ }),
/* 3257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectDailyReportLogUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={showAddDailyReportModal:false,showFieldWorkOrderModal:false,showReviewForm:false,isSubmitted:false,activeContributor:0,dailyReportLogPdfViewer:false,editMode:false,reportPdfViewer:false,memberForm:false,currentPage:1,reportsPageSize:1,reportsTotal:0,fieldWorkOrdersPageSize:1,fieldWorkOrdersTotal:0,delivery:[],extraInputs:[{name:'inspections',label:'Inspections'},{name:'visitors',label:'Meetings/Visitors'},{name:'phone_calls',label:'Job Scheduling/Phone Calls'}],dailyReportsTabSelected:1,fieldWorkOrderEdit:false,showFieldWorkOrderError:false,addFloor:false,isSafetyAccepted:false};function addExtraInput(action,state){var extraInputs=state.extraInputs;if(!extraInputs.find(function(option){return option.name===action.payload.name;})){extraInputs.unshift(action.payload);}return[].concat(_toConsumableArray(extraInputs));}function deliveryOptions(action,state){var delivery=void 0;if(action.payload instanceof Array){delivery=action.payload.map(function(element){var label=element.division+'-'+element.number+' '+element.title;if(element.field_delivery){label+=' - '+__WEBPACK_IMPORTED_MODULE_1_moment___default()(element.field_delivery).format('MM/DD/YY');}return{value:element.id,label:label};});}else{delivery=state.delivery;if(!delivery.find(function(option){return option.value===action.payload.value;})){delivery.push(action.payload);}}return[].concat(_toConsumableArray(delivery));}function deleteDelivery(action,state){var delivery=state.delivery;delivery.splice(action.payload,1);return[].concat(_toConsumableArray(delivery));}function projectDailyReportLogUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["_6" /* SHOW_ADD_DAILY_REPORT_SET */]:return Object.assign({},state,{showAddDailyReportModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["_3" /* SET_SHOW_FIELD_WORK_ORDER */]:return Object.assign({},state,{showFieldWorkOrderModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["z" /* SET_ACTIVE_CONTRIBUTOR */]:return Object.assign({},state,{activeContributor:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["_2" /* SET_REVIEW_FORM */]:return Object.assign({},state,{showReviewForm:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["_1" /* SET_REPORT_SUBMITTED */]:return Object.assign({},state,{isSubmitted:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["G" /* SET_DAILY_REPORT_LOG_PDF_VIEWER */]:return Object.assign({},state,{dailyReportLogPdfViewer:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["K" /* SET_EDIT_MODE */]:return Object.assign({},state,{editMode:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["_0" /* SET_REPORT_PDF_VIEWER */]:return Object.assign({},state,{reportPdfViewer:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["Q" /* SET_MEMBER_FORM */]:return Object.assign({},state,{memberForm:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["D" /* SET_CURRENT_PAGE */]:return Object.assign({},state,{currentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["T" /* SET_REPORTS_TOTAL */]:return Object.assign({},state,{reportsTotal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["S" /* SET_REPORTS_PAGE_SIZE */]:return Object.assign({},state,{reportsPageSize:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["J" /* SET_DELIVERY */]:return Object.assign({},state,{delivery:deliveryOptions(action,state)});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["c" /* ADD_EXTRA_INPUT */]:return Object.assign({},state,{extraInputs:addExtraInput(action,state)});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["i" /* DELETE_DELIVERY */]:return Object.assign({},state,{delivery:deleteDelivery(action,state)});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["y" /* REMOVE_DELIVERIES_EXTRA_INPUT */]:{return Object.assign({},state,{extraInputs:state.extraInputs.filter(function(element){return element.name!=='deliveries';})});}case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["H" /* SET_DAILY_REPORT_TAB */]:return Object.assign({},state,{dailyReportsTabSelected:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["L" /* SET_FIELD_WORK_ORDER_EDIT */]:return Object.assign({},state,{fieldWorkOrderEdit:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["_4" /* SET_SHOW_FIELD_WORK_ORDER_ERROR */]:return Object.assign({},state,{showFieldWorkOrderError:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_daily_report_log_store_action_types__["E" /* SET_DAILY_REPORT_ADD_FLOOR */]:return Object.assign({},state,{addFloor:action.payload});default:return state;}}

/***/ }),
/* 3258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectDocumentationDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_documentation_store_action_types__ = __webpack_require__(1046);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={documentation:{},documentationCount:null};function projectDocumentationDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_documentation_store_action_types__["d" /* DOCUMENTATION_SET */]:return Object.assign({},state,{documentation:Object.assign({},state.documentation,_defineProperty({},action.payload.category,action.payload.documentation))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_documentation_store_action_types__["b" /* DOCUMENTATION_COUNT_SET */]:return Object.assign({},state,{documentationCount:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_documentation_store_action_types__["c" /* DOCUMENTATION_RESET */]:return initialState;case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_documentation_store_action_types__["a" /* DIRECTORY_SET */]:return Object.assign({},state,{directory:action.payload});default:return state;}}

/***/ }),
/* 3259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectOpenItemsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__ = __webpack_require__(629);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={projectOpenItems:[],currentPage:1,total:0,pageSize:25,currentProjectOpenItem:null,projectOpenItemsCount:null,projectOpenItemsCritCount:null,projectOpenItemNotes:[],dueDateFilter:'all'};function projectOpenItemsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["d" /* OPEN_ITEMS_LOAD_SUCCESS */]:return Object.assign({},state,action.payload);case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["e" /* OPEN_ITEMS_MODAL_CLOSE */]:return Object.assign({},initialState,{projectOpenItemsCount:state.projectOpenItemsCount,projectOpenItemsCritCount:state.projectOpenItemsCritCount});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["g" /* OPEN_ITEM_CREATE_SUCCESS */]:return Object.assign({},state,{projectOpenItems:[action.payload].concat(_toConsumableArray(state.projectOpenItems))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["v" /* OPEN_ITEM_LOAD_SUCCESS */]:return Object.assign({},state,{currentProjectOpenItem:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["A" /* OPEN_ITEM_UPDATE_SUCCESS */]:return Object.assign({},state,{projectOpenItems:state.projectOpenItems.map(function(openItem){return openItem.id===action.payload.id?action.payload:openItem;})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["h" /* OPEN_ITEM_DELETE_SUCCESS */]:return Object.assign({},state,{projectOpenItems:state.projectOpenItems.filter(function(openItem){return openItem.id!==action.payload;})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["b" /* OPEN_ITEMS_COUNT_SUCCESS */]:return Object.assign({},state,{projectOpenItemsCount:action.payload.total,projectOpenItemsCritCount:action.payload.totalCritical});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["a" /* OPEN_ITEMS_COUNT_INIT */]:return Object.assign({},state,{projectOpenItemsCount:initialState.projectOpenItemsCount,projectOpenItemsCritCount:initialState.projectOpenItemsCritCount});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["c" /* OPEN_ITEMS_CRITICAL_SET */]:return Object.assign({},state,{critical:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["w" /* OPEN_ITEM_NOTES_LOAD_SUCCESS */]:return Object.assign({},state,{projectOpenItemNotes:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["y" /* OPEN_ITEM_NOTE_CREATE_SUCCESS */]:return Object.assign({},state,{projectOpenItemNotes:[].concat(_toConsumableArray(state.projectOpenItemNotes),[action.payload])});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["x" /* OPEN_ITEM_NOTE_CLEAR */]:return Object.assign({},state,{projectOpenItemNotes:[]});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["B" /* OPEN_ITEM_UPDATE_VALUE */]:return Object.assign({},state,{currentProjectOpenItem:Object.assign({},state.currentProjectOpenItem,_defineProperty({},action.payload.attr,action.payload.value))});default:return state;}}

/***/ }),
/* 3260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectOpenItemsUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__ = __webpack_require__(629);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={showOpenItemsModal:false,showOpenItemFormModal:false,showOpenItemDetailsModal:false,editOpenItemDetailsModal:false,respondOpenItemDetailsModal:false,notesOpenItemDetailsModal:false,openItemForm:{},openItemFormErrors:{}};function projectOpenItemsUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["f" /* OPEN_ITEMS_MODAL_SHOW */]:return Object.assign({},state,{showOpenItemsModal:true});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["e" /* OPEN_ITEMS_MODAL_CLOSE */]:return Object.assign({},state,{showOpenItemsModal:false});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["s" /* OPEN_ITEM_FORM_MODAL_SHOW */]:return Object.assign({},state,{showOpenItemFormModal:true});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["r" /* OPEN_ITEM_FORM_MODAL_CLOSE */]:return Object.assign({},state,{showOpenItemFormModal:false});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["n" /* OPEN_ITEM_DETAILS_MODAL_SHOW */]:return Object.assign({},state,{showOpenItemDetailsModal:true});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["i" /* OPEN_ITEM_DETAILS_MODAL_CLOSE */]:return Object.assign({},state,{showOpenItemDetailsModal:false,editOpenItemDetailsModal:false,respondOpenItemDetailsModal:false,notesOpenItemDetailsModal:false});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["j" /* OPEN_ITEM_DETAILS_MODAL_EDIT */]:return Object.assign({},state,{editOpenItemDetailsModal:true});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["k" /* OPEN_ITEM_DETAILS_MODAL_EDIT_CANCEL */]:return Object.assign({},state,{editOpenItemDetailsModal:false});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["l" /* OPEN_ITEM_DETAILS_MODAL_RESPOND */]:return Object.assign({},state,{respondOpenItemDetailsModal:true});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["m" /* OPEN_ITEM_DETAILS_MODAL_RESPOND_CANCEL */]:return Object.assign({},state,{respondOpenItemDetailsModal:false});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["o" /* OPEN_ITEM_FORM_ATTR_SET */]:return Object.assign({},state,{openItemForm:Object.assign({},state.openItemForm,_defineProperty({},action.payload.attr,action.payload.value))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["q" /* OPEN_ITEM_FORM_ERRORS_SET */]:return Object.assign({},state,{openItemFormErrors:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["p" /* OPEN_ITEM_FORM_ERRORS_ATTR_CLEAR */]:return Object.assign({},state,{openItemFormErrors:Object.assign({},state.openItemFormErrors,_defineProperty({},action.payload,false))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["u" /* OPEN_ITEM_FORM_SET */]:return Object.assign({},state,{openItemForm:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["t" /* OPEN_ITEM_FORM_RESET */]:return Object.assign({},state,{openItemForm:initialState.openItemForm,openItemFormErrors:initialState.openItemFormErrors});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_open_items_store_action_types__["z" /* OPEN_ITEM_PDF_VIEWER_SET */]:return Object.assign({},state,{openItemPdfViewer:action.payload});default:return state;}}

/***/ }),
/* 3261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectCloseoutDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_closeout_store_action_types__ = __webpack_require__(1024);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={closeoutCats:[],closeout:null,closeoutContribs:[],currentPage:1,total:0,pageSize:25,closeoutPercentage:0,closeoutManuals:[],closeoutManualsCurrentPage:1,closeoutManualsTotal:0,closeoutManualsPageSize:25,closeoutManual:null};function projectCloseoutDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_closeout_store_action_types__["a" /* CLOSEOUT_CATS_SET */]:return Object.assign({},state,{closeoutCats:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_closeout_store_action_types__["i" /* CLOSEOUT_SET */]:return Object.assign({},state,{closeout:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_closeout_store_action_types__["b" /* CLOSEOUT_CONTRIBS_SET */]:return Object.assign({},state,action.payload);case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_closeout_store_action_types__["c" /* CLOSEOUT_CONTRIB_SET */]:return Object.assign({},state,{closeoutContribs:state.closeoutContribs.map(function(closeoutContrib){return closeoutContrib.id===action.payload.id?action.payload:closeoutContrib;})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_closeout_store_action_types__["h" /* CLOSEOUT_PERCENTAGE_SET */]:return Object.assign({},state,{closeoutPercentage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_closeout_store_action_types__["d" /* CLOSEOUT_MANUALS_SET */]:return Object.assign({},state,action.payload);case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_closeout_store_action_types__["f" /* CLOSEOUT_MANUAL_SET */]:return Object.assign({},state,{closeoutManual:action.payload,closeoutManuals:[action.payload].concat(_toConsumableArray(state.closeoutManuals))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_closeout_store_action_types__["g" /* CLOSEOUT_MANUAL_UPDATE */]:return Object.assign({},state,{closeoutManual:action.payload,closeoutManuals:state.closeoutManuals.map(function(clsManual){return clsManual.id===action.payload.id?action.payload:clsManual;})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_closeout_store_action_types__["e" /* CLOSEOUT_MANUAL_DELETE */]:return Object.assign({},state,{closeoutManuals:state.closeoutManuals.filter(function(clsManual){return clsManual.id!==action.payload;})});default:return state;}}

/***/ }),
/* 3262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (immutable) */ __webpack_exports__["a"] = usersNotificationModalUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_shared_pdf_viewer_bluebeam_store_action_types__ = __webpack_require__(1032);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={showModal:false,showCustomEmailError:false,showNewCustomEmail:false,emails:[],subject:'',message:'',recipients:[],customEmail:'',pdfTronSuccess:null};function usersNotificationModalUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_shared_pdf_viewer_bluebeam_store_action_types__["c" /* INIT_PROJECT_EMAIL_MODAL */]:return Object.assign({},state,{recipients:[]});case __WEBPACK_IMPORTED_MODULE_0_components_shared_pdf_viewer_bluebeam_store_action_types__["h" /* SET_SHOW_MODAL */]:return Object.assign({},state,{showModal:action.payload.modal,documentId:action.payload.documentId});case __WEBPACK_IMPORTED_MODULE_0_components_shared_pdf_viewer_bluebeam_store_action_types__["f" /* SET_EMAILS */]:return Object.assign({},state,{emails:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_shared_pdf_viewer_bluebeam_store_action_types__["a" /* ADD_EMAIL */]:return Object.assign({},state,{emails:[action.payload].concat(_toConsumableArray(state.emails))});case __WEBPACK_IMPORTED_MODULE_0_components_shared_pdf_viewer_bluebeam_store_action_types__["b" /* ADD_RECIPIENT */]:return Object.assign({},state,{recipients:[action.payload].concat(_toConsumableArray(state.recipients))});case __WEBPACK_IMPORTED_MODULE_0_components_shared_pdf_viewer_bluebeam_store_action_types__["g" /* SET_RECIPIENTS */]:return Object.assign({},state,{recipients:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_shared_pdf_viewer_bluebeam_store_action_types__["e" /* SAVED_PDFTRON_SUCCESS */]:return Object.assign({},state,{pdfTronSuccess:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_shared_pdf_viewer_bluebeam_store_action_types__["d" /* RESET_PDFTRON_MESSAGES */]:return Object.assign({},state,{pdfTronSuccess:null});default:return state;}}

/***/ }),
/* 3263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectSettingsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_settings_store_action_types__ = __webpack_require__(1038);
var initialState={settings:null};function projectSettingsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_settings_store_action_types__["a" /* SETTINGS_SET */]:return Object.assign({},state,{settings:action.payload});default:return state;}}

/***/ }),
/* 3264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectCoiExpsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_coi_exps_store_action_types__ = __webpack_require__(1076);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={coiExps:null,coiExpsCurrentPage:1,coiExpsTotal:0,coiExpsPageSize:5,coiExpDocs:{},liabilities:null};function projectCoiExpsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var _ref=action.payload||{},coiExpId=_ref.coiExpId,coiExpDoc=_ref.coiExpDoc;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_coi_exps_store_action_types__["a" /* COI_EXPS_SET */]:return Object.assign({},state,action.payload);case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_coi_exps_store_action_types__["f" /* COI_EXP_SET */]:return Object.assign({},state,{coiExps:state.coiExps.map(function(coiExp){if(coiExp.id===action.payload.id){return action.payload;}else{return coiExp;}})});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_coi_exps_store_action_types__["d" /* COI_EXP_DOCS_SET */]:return Object.assign({},state,{coiExpDocs:Object.assign({},state.coiExpDocs,_defineProperty({},coiExpId,action.payload))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_coi_exps_store_action_types__["g" /* LIABILITIES_SET */]:return Object.assign({},state,{liabilities:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_coi_exps_store_action_types__["b" /* COI_EXP_DOCS_ADD */]:return Object.assign({},state,{coiExps:state.coiExps.map(function(coiExp){if(coiExp.id===coiExpId&&coiExpDoc.subcategory==='client_landlord'){return Object.assign({},coiExp,{coi_exp_docs_count:coiExp.coi_exp_docs_count+1});}else{return coiExp;}}),coiExpDocs:Object.assign({},state.coiExpDocs,_defineProperty({},coiExpId,Object.assign({},state.coiExpDocs[coiExpId],{coiExpDocs:[coiExpDoc].concat(_toConsumableArray(state.coiExpDocs[coiExpId].coiExpDocs))})))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_coi_exps_store_action_types__["e" /* COI_EXP_DOCS_UPDATE */]:return Object.assign({},state,{coiExpDocs:Object.assign({},state.coiExpDocs,_defineProperty({},coiExpId,Object.assign({},state.coiExpDocs[coiExpId],{coiExpDocs:state.coiExpDocs[coiExpId].coiExpDocs.map(function(doc){if(doc.id===coiExpDoc.id){return coiExpDoc;}else{return doc;}})})))});case __WEBPACK_IMPORTED_MODULE_0_components_admin_projects_details_project_coi_exps_store_action_types__["c" /* COI_EXP_DOCS_DESTROY */]:return Object.assign({},state,{coiExps:state.coiExps.map(function(coiExp){if(coiExp.id===coiExpId&&coiExpDoc.subcategory==='client_landlord'){return Object.assign({},coiExp,{coi_exp_docs_count:coiExp.coi_exp_docs_count-1});}else{return coiExp;}}),coiExpDocs:Object.assign({},state.coiExpDocs,_defineProperty({},coiExpId,Object.assign({},state.coiExpDocs[coiExpId],{coiExpDocs:state.coiExpDocs[coiExpId].coiExpDocs.filter(function(doc){return doc.id!==coiExpDoc.id;})})))});default:return state;}}

/***/ }),
/* 3265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = paginationTableReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_shared_pagination_table_store_action_types__ = __webpack_require__(960);
var initialState={// For now, only one PaginationTable is supported at the same time
currentPage:1,pageSize:25,total:0};function paginationTableReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_shared_pagination_table_store_action_types__["a" /* PAGINATION_TABLE_CURRENT_PAGE_SET */]:return Object.assign({},state,{currentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_shared_pagination_table_store_action_types__["b" /* PAGINATION_TABLE_INIT */]:return initialState;case __WEBPACK_IMPORTED_MODULE_0_components_shared_pagination_table_store_action_types__["c" /* PAGINATION_TABLE_PAGE_SIZE_SET */]:return Object.assign({},state,{pageSize:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_shared_pagination_table_store_action_types__["d" /* PAGINATION_TABLE_TOTAL_SET */]:return Object.assign({},state,{total:action.payload});default:return state;}}

/***/ }),
/* 3266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_store_reducers_data__ = __webpack_require__(3267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_admin_general_contractors_store_reducers_ui__ = __webpack_require__(3268);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1_components_admin_general_contractors_store_reducers_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2_components_admin_general_contractors_store_reducers_ui__["a" /* default */]));

/***/ }),
/* 3267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generalContractorsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_general_contractors_store_action_types__ = __webpack_require__(606);
var initialState={generalContractors:{data:[],total:0},currentGeneralContractor:null,projects:null,users:[]};function generalContractorsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_general_contractors_store_action_types__["f" /* GENERAL_CONTRACTOR_LOAD_SUCCESS */]:return Object.assign({},state,{currentGeneralContractor:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_general_contractors_store_action_types__["c" /* GENERAL_CONTRACTORS_LOAD_SUCCESS */]:return Object.assign({},state,{generalContractors:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_general_contractors_store_action_types__["h" /* GENERAL_CONTRACTOR_PROJECTS_LOAD_SUCCESS */]:return Object.assign({},state,{projects:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_general_contractors_store_action_types__["e" /* GENERAL_CONTRACTORS_USERS_SET */]:return Object.assign({},state,{users:action.payload});default:return state;}}

/***/ }),
/* 3268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generalContractorsUiReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_general_contractors_store_action_types__ = __webpack_require__(606);
var stages=['licence-input','logo-upload'];var initialState={currentPage:1,currentStage:'licence-input',licenceNumber:'',companyLogo:{url:'',image:''},hideSideBar:false,projectsCurrentPage:1,showContacts:false};function generalContractorsUiReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_general_contractors_store_action_types__["d" /* GENERAL_CONTRACTORS_PAGE_CHANGE */]:return Object.assign({},state,{currentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_general_contractors_store_action_types__["k" /* NEW_ONBOARDING */]:return initialState;case __WEBPACK_IMPORTED_MODULE_0_components_admin_general_contractors_store_action_types__["l" /* NEXT_STAGE */]:return Object.assign({},state,{currentStage:stages[stages.indexOf(state.currentStage)+1]});case __WEBPACK_IMPORTED_MODULE_0_components_admin_general_contractors_store_action_types__["g" /* GENERAL_CONTRACTOR_ONBOARDING_STAGE_CHANGE */]:return Object.assign({},state,{currentStage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_general_contractors_store_action_types__["j" /* LICENCE_NUMBER_VALUE_CHANGE */]:return Object.assign({},state,{licenceNumber:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_general_contractors_store_action_types__["a" /* COMPANY_LOGO_FILE_SET */]:return Object.assign({},state,{companyLogo:{url:action.payload.url,image:action.payload.file}});case __WEBPACK_IMPORTED_MODULE_0_components_admin_general_contractors_store_action_types__["i" /* GENERAL_CONTRACTOR_PROJECTS_PAGE_CHANGE */]:return Object.assign({},state,{projectsCurrentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_general_contractors_store_action_types__["b" /* GENERAL_CONTRACTORS_CONTACTS_MODAL_SHOW */]:return Object.assign({},state,{showContacts:action.payload});default:return state;}}

/***/ }),
/* 3269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_service_providers_store_reducers_ui__ = __webpack_require__(3270);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(null,__WEBPACK_IMPORTED_MODULE_1_components_admin_service_providers_store_reducers_ui__["a" /* default */]));

/***/ }),
/* 3270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = serviceProvidersUIReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_service_providers_store_action_types__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_modal_InviteUserModal__ = __webpack_require__(86);
var initialState={currentPage:1,serviceProviderDropdown:'Architect',serviceProviders:[],total:1,pageSize:10,nameToSearch:'',companyData:{name:'',status:'',contact:{}},currentUserId:0,clientForm:{companyName:'',firstName:'',lastName:'',email:'',phoneNumber:'',globalPurchaseOrderRequired:false,purchaseOrderRequired:false,streetAddress:'',unitNumber:'',city:'',state:'',zipCode:''},invalidFields:[],showInviteUserModal:false,userForm:{buildingsId:[],firstName:'',lastName:'',email:'',phoneNumber:'',rolesId:[],title:''},userModalState:__WEBPACK_IMPORTED_MODULE_1_components_shared_modal_InviteUserModal__["a" /* UserModalState */].NEW,// one of UserModalState
validationMessage:'',currentUserCompany:null};function serviceProvidersUIReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_service_providers_store_action_types__["g" /* SET_CURRENT_PAGE */]:return Object.assign({},state,{currentPage:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_service_providers_store_action_types__["l" /* SET_SERVICE_PROVIDER_DROPDOWN */]:return Object.assign({},initialState,{serviceProviderDropdown:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_service_providers_store_action_types__["k" /* SET_SERVICE_PROVIDER_DATA */]:return Object.assign({},state,{serviceProviders:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_service_providers_store_action_types__["i" /* SET_NAME_TO_SEARCH */]:return Object.assign({},state,{nameToSearch:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_service_providers_store_action_types__["n" /* SET_TOTAL */]:return Object.assign({},state,{total:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_service_providers_store_action_types__["j" /* SET_PAGE_SIZE */]:return Object.assign({},state,{pageSize:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_service_providers_store_action_types__["m" /* SET_SERVICE_PROVIDER_USER_DATA */]:return Object.assign({},state,{userList:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_service_providers_store_action_types__["f" /* SET_COMPANY_DATA */]:return Object.assign({},state,{companyData:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_service_providers_store_action_types__["h" /* SET_CURRENT_USER_COMPANY */]:return Object.assign({},state,{currentUserCompany:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_service_providers_store_action_types__["c" /* SERVICE_PROVIDERS_INVITE_USER_ID_SET */]:return Object.assign({},state,{currentUserId:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_service_providers_store_action_types__["b" /* SERVICE_PROVIDERS_INVITE_USER_FORM_LOAD */]:return Object.assign({},state,{userForm:action.payload,invalidFields:[],validationMessage:''});case __WEBPACK_IMPORTED_MODULE_0_components_admin_service_providers_store_action_types__["d" /* SERVICE_PROVIDERS_INVITE_USER_MODAL_SHOW */]:var newState=Object.assign({},state,{invalidFields:[],showInviteUserModal:action.payload,validationMessage:''});return newState;case __WEBPACK_IMPORTED_MODULE_0_components_admin_service_providers_store_action_types__["e" /* SERVICE_PROVIDERS_SHOW_CONFIRMATION_MODAL */]:return Object.assign({},state,{showConfirmationDeleteModal:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_service_providers_store_action_types__["a" /* SERVICE_PROVIDERS_CLEAR_FILTERS */]:return initialState;default:return state;}}

/***/ }),
/* 3271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pdfViewerBluebeamReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_pdfViewerBluebeam__ = __webpack_require__(636);
var initialState={createdBluebeamSession:false};function pdfViewerBluebeamReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_pdfViewerBluebeam__["a" /* CREATED_BB_SESSION */]:return Object.assign({},state,{createdBluebeamSession:true});case __WEBPACK_IMPORTED_MODULE_0__actions_pdfViewerBluebeam__["b" /* CREATED_BB_SNAPSHOT */]:return Object.assign({},state,{createdBluebeamSession:false});default:return state;}}

/***/ }),
/* 3272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_rfis_store_reducers_data__ = __webpack_require__(3273);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1_components_admin_rfis_store_reducers_data__["a" /* default */]));

/***/ }),
/* 3273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rfisDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_rfis_store_action_types__ = __webpack_require__(1090);
var initialState={rfisCount:0,rfis:[],currentStatus:'not_pre',total:0,currentPage:1,pageSize:25};function rfisDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_rfis_store_action_types__["a" /* RFIS_COUNT */]:return Object.assign({},state,{rfisCount:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_rfis_store_action_types__["b" /* RFIS_LOAD */]:return Object.assign({},state,action.payload);default:return state;}}

/***/ }),
/* 3274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_submittals_store_reducers_data__ = __webpack_require__(3275);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1_components_admin_submittals_store_reducers_data__["a" /* default */]));

/***/ }),
/* 3275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = submittalsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_submittals_store_action_types__ = __webpack_require__(1092);
var initialState={submittalsCount:0,submittals:[],currentStatus:'not_pre',total:0,currentPage:1,pageSize:25};function submittalsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_submittals_store_action_types__["a" /* SUBMITTALS_COUNT */]:return Object.assign({},state,{submittalsCount:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_submittals_store_action_types__["b" /* SUBMITTALS_LOAD */]:return Object.assign({},state,action.payload);default:return state;}}

/***/ }),
/* 3276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_project_open_items_store_reducers_data__ = __webpack_require__(3277);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1_components_admin_project_open_items_store_reducers_data__["a" /* default */]));

/***/ }),
/* 3277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectOpenItemsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_project_open_items_store_action_types__ = __webpack_require__(1093);
var initialState={projectOpenItemsCount:0,projectOpenItemsCritCount:0,projectOpenItems:[],currentStatus:'not_pre',total:0,currentPage:1,pageSize:25};function projectOpenItemsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_project_open_items_store_action_types__["a" /* PROJECT_OPEN_ITEMS_COUNT */]:return Object.assign({},state,{projectOpenItemsCount:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_project_open_items_store_action_types__["b" /* PROJECT_OPEN_ITEMS_CRITICAL_COUNT */]:return Object.assign({},state,{projectOpenItemsCritCount:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_project_open_items_store_action_types__["c" /* PROJECT_OPEN_ITEMS_LOAD */]:return Object.assign({},state,action.payload);default:return state;}}

/***/ }),
/* 3278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_chats_store_reducers_data__ = __webpack_require__(3279);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1_components_admin_chats_store_reducers_data__["a" /* default */]));

/***/ }),
/* 3279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chatsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_chats_store_action_types__ = __webpack_require__(1102);
var initialState={chatActivity:null};function chatsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_chats_store_action_types__["a" /* CHAT_ACTIVITY_LOAD */]:return Object.assign({},state,{chatActivity:action.payload});default:return state;}}

/***/ }),
/* 3280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_field_work_orders_store_reducers_data__ = __webpack_require__(3281);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1_components_admin_field_work_orders_store_reducers_data__["a" /* default */]));

/***/ }),
/* 3281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fieldWorkOrdersDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_field_work_orders_store_action_types__ = __webpack_require__(1095);
var initialState={fieldWorkOrdersCount:0,fieldWorkOrders:[],total:0,currentPage:1,pageSize:25};function fieldWorkOrdersDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_field_work_orders_store_action_types__["a" /* FIELD_WORK_ORDERS_COUNT */]:return Object.assign({},state,{fieldWorkOrdersCount:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_field_work_orders_store_action_types__["b" /* FIELD_WORK_ORDERS_LOAD */]:return Object.assign({},state,action.payload);default:return state;}}

/***/ }),
/* 3282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_recent_activity_store_reducers_data__ = __webpack_require__(3283);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1_components_admin_recent_activity_store_reducers_data__["a" /* default */]));

/***/ }),
/* 3283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = recentActivityDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_recent_activity_store_action_types__ = __webpack_require__(1099);
var initialState={allRecentActivity:null,speRecentActivity:null,swRecentActivity:null};function recentActivityDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_recent_activity_store_action_types__["a" /* ALL_RECENT_ACTIVITY_LOAD */]:return Object.assign({},state,{allRecentActivity:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_recent_activity_store_action_types__["b" /* SPE_RECENT_ACTIVITY_LOAD */]:return Object.assign({},state,{speRecentActivity:action.payload});case __WEBPACK_IMPORTED_MODULE_0_components_admin_recent_activity_store_action_types__["c" /* SW_RECENT_ACTIVITY_LOAD */]:return Object.assign({},state,{swRecentActivity:action.payload});default:return state;}}

/***/ }),
/* 3284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_admin_featured_items_store_reducers_data__ = __webpack_require__(3285);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reducers_reducers_util__["a" /* createSceneReducer */])(__WEBPACK_IMPORTED_MODULE_1_components_admin_featured_items_store_reducers_data__["a" /* default */]));

/***/ }),
/* 3285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = featuredItemsDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_admin_featured_items_store_action_types__ = __webpack_require__(3286);
var initialState={featuredItems:[]};function featuredItemsDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_components_admin_featured_items_store_action_types__["a" /* FEATURED_ITEMS_LOAD */]:return Object.assign({},state,{featuredItems:action.payload});default:return state;}}

/***/ }),
/* 3286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FEATURED_ITEMS_LOAD; });
var FEATURED_ITEMS_LOAD='FEATURED_ITEMS_LOAD';

/***/ }),
/* 3287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(3288)('createBrowserHistory');
module.exports = __webpack_require__(3289).createBrowserHistory;


/***/ }),
/* 3288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var printWarning = function() {};

if (false) {
  printWarning = function(format, subs) {
    var index = 0;
    var message =
      'Warning: ' +
      (subs.length > 0
        ? format.replace(/%s/g, function() {
            return subs[index++];
          })
        : format);

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging history ---
      // This error was thrown as a convenience so that you can use the
      // stack trace to find the callsite that triggered this warning.
      throw new Error(message);
    } catch (e) {}
  };
}

module.exports = function(member) {
  printWarning(
    'Please use `require("history").%s` instead of `require("history/%s")`. ' +
      'Support for the latter will be removed in the next major release.',
    [member, member]
  );
};


/***/ }),
/* 3289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(3290);
} else {
  module.exports = require('./cjs/history.js');
}


/***/ }),
/* 3290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(670)),valueEqual=_interopDefault(__webpack_require__(671));__webpack_require__(292);var invariant=_interopDefault(__webpack_require__(672));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ }),
/* 3291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configureApi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios_index__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_loader__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors_authentication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_authentication__ = __webpack_require__(174);
function configureApi(dispatch,getState){__WEBPACK_IMPORTED_MODULE_0_axios_index___default.a.interceptors.request.use(function(config){// Custom config to prevent loader to be shown for a asynch request
if(!config.hasOwnProperty('loadingDisabled')||!config.loadingDisabled){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_loader__["d" /* loaderStart */])());}var newConfig=config;var state=getState();if(Object(__WEBPACK_IMPORTED_MODULE_2__selectors_authentication__["f" /* isLoggedIn */])(state)){newConfig=Object.assign({},config);newConfig.headers=Object.assign({},config.headers,{'access-token':Object(__WEBPACK_IMPORTED_MODULE_2__selectors_authentication__["a" /* getAccessToken */])(state),client:Object(__WEBPACK_IMPORTED_MODULE_2__selectors_authentication__["c" /* getClient */])(state),'token-type':'bearer',uid:Object(__WEBPACK_IMPORTED_MODULE_2__selectors_authentication__["d" /* getCurrentUser */])(state).uid});}return newConfig;});__WEBPACK_IMPORTED_MODULE_0_axios_index___default.a.interceptors.response.use(function(response){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_loader__["c" /* loaderEnd */])());return response;},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_loader__["c" /* loaderEnd */])());var newError=error;if(error.response.status===401){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_authentication__["k" /* logoutRequest */])());// Don't remember route otherwise if the user tries to login again, the same error will happen
}else{if(!error.response.data.hasOwnProperty('errors')){newError=Object.assign({},error,{response:{data:{errors:['An unexpector error occurred.']}}});}}return Promise.reject(newError);});}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.233bff77.js